webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAqCAYAAAA0yJLWAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAC20lEQVRYw+3YP0wTURwH8O97d71S21qooLWCEENCIOqgi8hCooOJDiaNk9HJRRcTNxOji8bJaExM1MFRo4kkotHgKFSJokgECsQYqlATMYUKtNd39+45QEsw19LC9Wgiv/H9Xt/7vH9310eEEAJlFrJZITcMxKdnoKaZJZ3MJGaxxe9DcNvWgupT80b+WAZaGCRH3+chRCd/rh7FmGYZKBNCCAwMjhQEowW0ZzvMVlShMNtRhcDWBbUSzBaUYRQHswUly3LOnBnMFpTP64bH41kZNhFbGIQdKEoJ6muDmE7Mgml6zno/f8VRXxu0BwUATkVGoKaqsEHYhSomNlAbqP8CJesjYWiRt4BYehc4UyocKNFXsuQAazkEXt2QG5V8chXQl39llvrhJcUnMHf8Ss48/RdkS2hq3nRZ7qmyRJluH6muBe4ztwFCAMMAnxqH2nkT/McwNp28BrnpAABApJPQR8JIPbsB17HzkHbtW96QzjB/7xxEOrl2FPFUAYQg+egyCJGgHAzBFbqIuVunQHw10Ed7wT69BPVWo+LIWfDYGNiH56DRL3A0t0HauQdq110IdR6CpayZqexAI+HFqZPgOnEpW27EY9mcY3c7qL8W7F0H+OQoaGUANNAIrb/L2uXLhNIaApEdcOw/Cj4+sLS82xuhtIZA/TsgNewF6+1YNaBolKO5DYJz6JEw0t0Ps+XUH1zIpWaRenod2nC3faj5BxdMy7WhN1Bf3bEUsiLKiI2B9Tw2B73vBP/9PWeD+rePAF/b335zVGIK6uv7pj9gfS/yNsijg+DRwTWhyvLhSUGI7Z0KIuXNy87209AjPcsKVaYBJbrgE5Qi0XQYSp46xOx6sX/oK3TOSzZTbpcTXneFaa4uGDDf6DV+L3S9NChCCCjNv2XMX8iUQkjrdz9bVqcvc+ZMUU5FKaYtyyLTr+nyVfq8EBCLN8T2LKNTUVDl2wwgx+lb7/gL9CUwBeNYITwAAAAASUVORK5CYII="

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAqCAYAAAA0yJLWAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAC20lEQVRYw+3YP0wTURwH8O97d71S21qooLWCEENCIOqgi8hCooOJDiaNk9HJRRcTNxOji8bJaExM1MFRo4kkotHgKFSJokgECsQYqlATMYUKtNd39+45QEsw19LC9Wgiv/H9Xt/7vH9310eEEAJlFrJZITcMxKdnoKaZJZ3MJGaxxe9DcNvWgupT80b+WAZaGCRH3+chRCd/rh7FmGYZKBNCCAwMjhQEowW0ZzvMVlShMNtRhcDWBbUSzBaUYRQHswUly3LOnBnMFpTP64bH41kZNhFbGIQdKEoJ6muDmE7Mgml6zno/f8VRXxu0BwUATkVGoKaqsEHYhSomNlAbqP8CJesjYWiRt4BYehc4UyocKNFXsuQAazkEXt2QG5V8chXQl39llvrhJcUnMHf8Ss48/RdkS2hq3nRZ7qmyRJluH6muBe4ztwFCAMMAnxqH2nkT/McwNp28BrnpAABApJPQR8JIPbsB17HzkHbtW96QzjB/7xxEOrl2FPFUAYQg+egyCJGgHAzBFbqIuVunQHw10Ed7wT69BPVWo+LIWfDYGNiH56DRL3A0t0HauQdq110IdR6CpayZqexAI+HFqZPgOnEpW27EY9mcY3c7qL8W7F0H+OQoaGUANNAIrb/L2uXLhNIaApEdcOw/Cj4+sLS82xuhtIZA/TsgNewF6+1YNaBolKO5DYJz6JEw0t0Ps+XUH1zIpWaRenod2nC3faj5BxdMy7WhN1Bf3bEUsiLKiI2B9Tw2B73vBP/9PWeD+rePAF/b335zVGIK6uv7pj9gfS/yNsijg+DRwTWhyvLhSUGI7Z0KIuXNy87209AjPcsKVaYBJbrgE5Qi0XQYSp46xOx6sX/oK3TOSzZTbpcTXneFaa4uGDDf6DV+L3S9NChCCCjNv2XMX8iUQkjrdz9bVqcvc+ZMUU5FKaYtyyLTr+nyVfq8EBCLN8T2LKNTUVDl2wwgx+lb7/gL9CUwBeNYITwAAAAASUVORK5CYII="

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj06.00fb9a8.png";

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _interopRequireDefault = __webpack_require__(4);
var _typeof2 = _interopRequireDefault(__webpack_require__(73));
/*
    PDFObject v2.0.201604172
    https://github.com/pipwerks/PDFObject
    Copyright (c) 2008-2016 Philip Hutchison
    MIT-style license: http://pipwerks.mit-license.org/
    UMD module pattern from https://github.com/umdjs/umd/blob/master/templates/returnExports.js
*/
(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === "undefined" ? "undefined" : (0, _typeof2.default)(module)) === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.PDFObject = factory();
  }
})(void 0, function () {
  "use strict";

  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  var pdfobjectversion = "2.0.201604172",
    supportsPDFs,
    createAXO,
    isIE,
    supportsPdfMimeType = typeof navigator.mimeTypes["application/pdf"] !== "undefined",
    supportsPdfActiveX,
    buildFragmentString,
    log,
    embedError,
    _embed,
    getTargetElement,
    generatePDFJSiframe,
    isIOS = function () {
      return /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase());
    }(),
    generateEmbedElement;
  createAXO = function createAXO(type) {
    var ax;
    try {
      ax = new ActiveXObject(type);
    } catch (e) {
      ax = null;
    }
    return ax;
  };
  isIE = function isIE() {
    return !!(window.ActiveXObject || "ActiveXObject" in window);
  };
  supportsPdfActiveX = function supportsPdfActiveX() {
    return !!(createAXO("AcroPDF.PDF") || createAXO("PDF.PdfCtrl"));
  };
  supportsPDFs = supportsPdfMimeType || isIE() && supportsPdfActiveX();
  buildFragmentString = function buildFragmentString(pdfParams) {
    var string = "",
      prop;
    if (pdfParams) {
      for (prop in pdfParams) {
        if (pdfParams.hasOwnProperty(prop)) {
          string += encodeURIComponent(prop) + "=" + encodeURIComponent(pdfParams[prop]) + "&";
        }
      }
      if (string) {
        string = "#" + string;
        string = string.slice(0, string.length - 1);
      }
    }
    return string;
  };
  log = function log(msg) {
    if (typeof console !== "undefined" && console.log) {
      console.log("[PDFObject] " + msg);
    }
  };
  embedError = function embedError(msg) {
    log(msg);
    return false;
  };
  getTargetElement = function getTargetElement(targetSelector) {
    var targetNode = document.body;
    if (typeof targetSelector === "string") {
      targetNode = document.querySelector(targetSelector);
    } else if (typeof jQuery !== "undefined" && targetSelector instanceof jQuery && targetSelector.length) {
      targetNode = targetSelector.get(0);
    } else if (typeof targetSelector.nodeType !== "undefined" && targetSelector.nodeType === 1) {
      targetNode = targetSelector;
    }
    return targetNode;
  };
  generatePDFJSiframe = function generatePDFJSiframe(targetNode, url, pdfOpenFragment, PDFJS_URL, id) {
    var fullURL = PDFJS_URL + "?file=" + encodeURIComponent(url) + pdfOpenFragment;
    var scrollfix = isIOS ? "-webkit-overflow-scrolling: touch; overflow-y: scroll; " : "overflow: hidden; ";
    var iframe = "<div style='" + scrollfix + "position: absolute; top: 0; right: 0; bottom: 0; left: 0;'><iframe  " + id + " src='" + fullURL + "' style='border: none; width: 100%; height: 100%;' frameborder='0'></iframe></div>";
    targetNode.className += " pdfobject-container";
    targetNode.style.position = "relative";
    targetNode.style.overflow = "auto";
    targetNode.innerHTML = iframe;
    return targetNode.getElementsByTagName("iframe")[0];
  };
  generateEmbedElement = function generateEmbedElement(targetNode, targetSelector, url, pdfOpenFragment, width, height, id) {
    var style = "";
    if (targetSelector && targetSelector !== document.body) {
      style = "width: " + width + "; height: " + height + ";";
    } else {
      style = "position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%;";
    }
    targetNode.className += " pdfobject-container";
    targetNode.innerHTML = "<embed " + id + " class='pdfobject' src='" + url + pdfOpenFragment + "' type='application/pdf' style='overflow: auto; " + style + "'/>";
    return targetNode.getElementsByTagName("embed")[0];
  };
  _embed = function embed(url, targetSelector, options) {
    if (typeof url !== "string") {
      return embedError("URL is not valid");
    }
    targetSelector = typeof targetSelector !== "undefined" ? targetSelector : false;
    options = typeof options !== "undefined" ? options : {};
    var id = options.id && typeof options.id === "string" ? "id='" + options.id + "'" : "",
      page = options.page ? options.page : false,
      pdfOpenParams = options.pdfOpenParams ? options.pdfOpenParams : {},
      fallbackLink = typeof options.fallbackLink !== "undefined" ? options.fallbackLink : true,
      width = options.width ? options.width : "100%",
      height = options.height ? options.height : "100%",
      forcePDFJS = typeof options.forcePDFJS === "boolean" ? options.forcePDFJS : false,
      PDFJS_URL = options.PDFJS_URL ? options.PDFJS_URL : false,
      targetNode = getTargetElement(targetSelector),
      fallbackHTML = "",
      pdfOpenFragment = "",
      fallbackHTML_default = "<p>This browser does not support inline PDFs. Please download the PDF to view it: <a href='[url]'>Download PDF</a></p>";
    if (!targetNode) {
      return embedError("Target element cannot be determined");
    }
    if (page) {
      pdfOpenParams.page = page;
    }
    pdfOpenFragment = buildFragmentString(pdfOpenParams);
    if (forcePDFJS && PDFJS_URL) {
      return generatePDFJSiframe(targetNode, url, pdfOpenFragment, PDFJS_URL, id);
    } else if (supportsPDFs) {
      return generateEmbedElement(targetNode, targetSelector, url, pdfOpenFragment, width, height, id);
    } else {
      if (PDFJS_URL) {
        return generatePDFJSiframe(targetNode, url, pdfOpenFragment, PDFJS_URL, id);
      } else if (fallbackLink) {
        fallbackHTML = typeof fallbackLink === "string" ? fallbackLink : fallbackHTML_default;
        targetNode.innerHTML = fallbackHTML.replace(/\[url\]/g, url);
      }
      return embedError("This browser does not support embedded PDFs");
    }
  };
  return {
    embed: function embed(a, b, c) {
      return _embed(a, b, c);
    },
    pdfobjectversion: function () {
      return pdfobjectversion;
    }(),
    supportsPDFs: function () {
      return supportsPDFs;
    }()
  };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy04.3e8d26d.png";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy06.aebfd36.png";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy07.e5b7e4f.png";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-03.e8c11cd.png";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-05.f6866d9.png";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-06.76eb7dd.png";

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-9.c907b3f.png";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdsj1-1.15b4766.png";

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jd.0ffc17a.png";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy01.61c7597.png";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy11.db79788.png";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj13.e787bfa.png";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx06.094a76f.png";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-11.af30693.png";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-15.7f3febf.png";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-16.374d068.png";

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAPCAYAAAC2u9IeAAAAPElEQVRYhe3QsQ3AIADAMOD/n4EDqqx0sC+IMvc1+LReB/yZOcGcYE4wJ5gTzAnmBHOCOcGcYE4wJ5gTDo5bBBrCU9McAAAAAElFTkSuQmCC"

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAWCAYAAAAW5GZjAAAAPUlEQVQokWN8+PjZfwYiAeN/ICBWMROxCkcV008xC7pAcf10DEW9jZnYTYZJYOX/xwGK6qZhiI0mJPooBgBZ5zwW7mL2kgAAAABJRU5ErkJggg=="

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/monitorPhoto.b2ef887.png";

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepPlayer_vue__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepPlayer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepPlayer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepPlayer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e465850_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepPlayer_vue__ = __webpack_require__(1291);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1285)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e465850"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepPlayer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e465850_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepPlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/simulate/StepPlayer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e465850", Component.options)
  } else {
    hotAPI.reload("data-v-7e465850", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnbg2.37f064b.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnstatus1.bc621ca.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xgdh1.60dbf97.png";

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_wuxiao.59b28a6.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_dafen.e474765.png";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAPCAYAAACyTgIjAAAAPElEQVRYhe3QsQ3AIADAMOD/n4G1UnY62BdEmfsafKzXAX9kSjAlmBJMCaYEU4IpwZRgSjAlmBJMCaaEA6idBBpxcDUVAAAAAElFTkSuQmCC"

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d27aeac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__ = __webpack_require__(1107);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d27aeac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/pagination.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d27aeac", Component.options)
  } else {
    hotAPI.reload("data-v-0d27aeac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login.d22b6c7.png";

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAPCAIAAADS7v5KAAADl0lEQVRIDd1WT2jTYBT/NufWbaAXD23YwYMXD2K2loCICEOQUCsVYQgOPJQSCnoRQS+h1p4ExYtSSg0eFC+iBkvpQfCqhMYGvExQUAxp0Hmwsk7Zn/rely9pEkMnnsY+xr7ve+99773f+9eM9Pt9slPWGAB5+2H9bn11ubs5BNS+PaMXM5NzB1B+265R8GxLJCADUEFs28JwHMNID8+JByAsZjfLjYSc4wkxFKmieXLsIBSqyMMFkjWSl8V46EyZoX+oiwyeOlxQUFRNV1IQBE3z25vJlqjyEeiZ06UfrlzEfuFE7ND+XVfurwDvRXGvX8LvpJ9O4elJF0xYzFDKnbQDDV9FhsKnznUVY8Ki5+Pie4XkaNy26IGFYxNnj068WVoLPHcvcTGfKjcM0c2ASw/udrvFZWRbkYq+aGqSSqUgf0niueuPghOCPKnVmDq7baXSIr34w2PoJJlzRAJg5g/v/tjZ+PyVTYKTc+OL87H35vrtZz2mMLzFRZkpCnO8u9FQCVcifK5adUT/CjAvE0VSkiWujoGvEkVRdE2zWO3IsqPKaLQ4hgUJXAKLFtDrFpemJ0ICYMD18TFy7cGKubx55OBY4VTsy7eNG497vyMSAy7RMnZaI6JUhCSasJt1yEeWWYvcQBN2CU+adeAbSkXTQGk1bdtYWEUrg+WKekwT84lpTFiEm6XK7I7lwgqBufO8d/38dGlx+uGrX5cyk9+7/eKjlZ+rkT9EkJOqCBh05qCvVKhLlGE3a61UVmgxmegNNdEnqqkRCWA5GTQatXZalkvNsmLwSV01qQUb+g3VmGqRFSpcJM2xHsjMu08bt572ri5MXT4z1e1tApLlbiQSVDd0QVHhJDNIKi8mGi20H0ye5PQP5jXu5FgolLJWUdUqjIUpwErCQjYUXRB8Bgc1i0RatygaAAP310vr9+qr547Hbj7pQbGh7P8tsMDGseEo8BygtulIpwyjSfIFodZJ8/E4XxUH74Drzj0+lyMsJUBtK5I6mCUz2SxnkgTqCoMB0sv2Gvwh89+W3VTakZKDYo5kMyIviuD0MIkwbzZXFf1jx1BUi8pEgAm/HX7XKkUcr7qq24Q4AwYfwDwmXH74Uz830ANk0A8zWXdUuW3iozgKYAYQQqcNgoHvrvCvu9+OewYx98h2UOP1vVDxit3hAsQBtlDHYM8yHdg1vFeCIQNYZh4pMACQ6nUhcLBDCX4B7JgPzT9crcqj8plbKQAAAABJRU5ErkJggg=="

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginrnd.3392ff4.png";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/index.83e88dd.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh.ebed13f.png";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qhwc.97aa663.png";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/paixu01.0b17d4a.png";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/paixu02.cb79305.png";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/paixu03.93a7353.png";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/paixu04.a095aae.png";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/paixu05.58ccd10.png";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf01.f715e4b.png";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf02.feb9cfd.png";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf03.ffb3b73.png";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf04.23a0340.png";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf05.936283c.png";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf06.df48a1f.png";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf07.660c871.png";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf08_bg.484fe50.png";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf08.0fd89e0.png";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zdhf09.4708a03.png";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy02.fbebe87.png";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy03.bcdb990.png";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy05.4d74675.png";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy08.f8a0715.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy09.ad10451.png";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy10.8134df5.png";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy12.7362658.png";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy13.07c5c7b.png";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy14.ca8c0a9.png";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy15.625f183.png";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zj01.a0116b7.png";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zj02.feba9c4.png";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zj03.8999d26.png";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zj04.7e790ba.png";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zj05.adc4400.png";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zj06.7821370.png";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zj07.799a9e8.png";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj01.7c4c7a8.png";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj02.78a2799.png";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj03.6254dd7.png";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj04.ab9dd11.png";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj05.3bb436f.png";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj07.f66b6a7.png";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj08.6f2bd9f.png";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj09.5de166b.png";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj10.338799d.png";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj11.02a49ff.png";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj12.9b104bc.png";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj14.00d0cfd.png";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj15.e19e30f.png";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cj16.14804c3.png";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx01.ef13303.png";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx02.1c89e71.png";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx03.c0145a1.png";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx04.5726535.png";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx05.412bb98.png";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx07.5d01a00.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx08.f92d1ea.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx09.73a8eca.png";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx10.324a5c1.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx11.ad75dc4.png";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cjx12.2a2b937.png";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc01.4338f8c.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc02.d094f60.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc03.94cd1e5.png";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc04.13e6123.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc05.1e7024f.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc06.09a52f2.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tc07.e58eac6.png";

/***/ }),
/* 177 */,
/* 178 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAABoElEQVQ4T7WVzVHCUBDHdx8zojfoADuADvACvGScMRUgHUAFYAViBWAFwXGSgBfoADqQDsxRcci6LwEn5IOAQg455O3+9uv/NghnevBMXMgEO5ZzD5hrIlCBAArssCDyXqQuh/uSSgWb5rRwlV8NGHaXBFABGlq9kgZPBdv2uI2Aj4EjzoDWz4TCFQDNbTB27jO8kxI4OaZjT975pASIQylrrbDV2J6YCs5gl8HFg8GW9VYWSHPl4BFWdL22CDurNl3mVx9p536NSdGcV6cKOTENuuBdSymXUTuuiJMG4JehafVR9DwT/Pl1UTSMG/ff4I0aupxJe1NSLJtNpr5aOLMR99nIzJgHM2doOU1GKYOKDXGnFbY9UZM2j4H+2pLXCl+aCDis3R38ktVhCLF2gfyhlqLBCaijaY3+9vtBYI+8B12XPeVkWU5PoOieBLy9voF+v7lVVD0JOFABdZDIBRSDpBn8qRUnAGeqQt3A2OD8CvapIrwDjpGcWka09gx5K2eJqlAfgz2R6/JiP/SSLHnxP0UXf+Yf5JjMw7ZnA/8A9DrJFyv6VYAAAAAASUVORK5CYII="

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-3.6eeee42.png";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-4.a8f2dff.png";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-5.c67d12a.png";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-6.8a024e8.png";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-7.50e92b5.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-8.7c29f59.png";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-9.f284644.png";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-10.1c63d2b.png";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-11.7011118.png";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-12.0f9aa62.png";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg1-13.04220d7.png";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-1.67dba17.png";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-2.243caec.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-3.9a2fb65.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-4.2a4e08c.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-5.c3709db.png";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-6.af22de3.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-7.ab8315d.png";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-8.bbece87.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-9.db4ce14.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fgbg2-10.25dab85.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-01.60ebc33.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-02.d2b0b1c.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-03.f152ab1.png";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-04.8cf738e.png";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-05.24bb259.png";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-06.275a8ac.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-07.b72ae13.png";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-08.2fecee2.png";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-09.12923dc.png";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-10.f90dd71.png";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-11.1f3c7c7.png";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-12.29f1aef.png";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-13.18bfcb0.png";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-14.d91b257.png";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-17.3d0cc16.png";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-18.950da14.png";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-01.165b805.png";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-02.b25ce8c.png";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-03.1de62c1.png";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-04.1c8ae40.png";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-05.db6e826.png";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-06.419f9d3.png";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-07.36d83e2.png";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-08.6c54fba.png";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-09.596aefa.png";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-10.37fd40d.png";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-01.5f024b8.png";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-02.4bd2e1f.png";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-03.6051548.png";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-04.45da2bb.png";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-05.ac7636b.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-06.cc8f323.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-07.0d68e96.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-001.6bc9abe.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-02.e3d1877.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-04.49090cc.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-07.dbde90d.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-08.aa7be23.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.f2fa283.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.dd36cba.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.d1cf3b5.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.d50854f.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.ccc5830.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.0803cfc.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.e29aa0b.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.575edf1.png";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.38bf7f7.png";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.580905d.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.1.6da9a5b.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.2.3f38c92.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.cc657ca.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.f7bc3cb.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.0bd8328.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-1.f25070c.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-2.c3fd5dd.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-3.9985ea1.png";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-4.ac4167a.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-5.04630d3.png";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-6.dec5420.png";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-7.2a4afeb.png";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-11.9857943.png";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-12.999af08.png";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-2.dfc1e41.png";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-1.0848186.png";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-2.aa62433.png";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-3.b765182.png";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-1.f25070c.png";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-2.011102f.png";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-3.2e1d4df.png";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-4.2778ddd.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-5.b804bc7.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-2.8105979.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-3.f37ec36.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-4.985e7a5.png";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-5.739bd8f.png";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-6.76587b0.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-7.be8e3eb.png";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.915a085.png";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.afe7f31.png";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.617df45.png";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.788e588.png";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.42e2167.png";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.a7f15df.png";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.de583aa.png";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.5a300a5.png";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.ec929b3.png";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.6fa4d8d.png";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.aeeeb8a.png";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.36f68a5.png";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13.141fe04.png";

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoomImg_vue__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoomImg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoomImg_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoomImg_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoomImg_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4f9910_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoomImg_vue__ = __webpack_require__(1116);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1114)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d4f9910"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoomImg_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4f9910_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoomImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/zoomImg.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6d4f9910", Component.options)
  } else {
    hotAPI.reload("data-v-6d4f9910", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JST_TARGETS = exports.JST_SECOND_ORDER_ROW = exports.JST_SECOND_GOODS_ROWS = exports.JST_PRODUCT_LIST = exports.JST_PRODUCT_LIBRARY_GOODS = exports.JST_ORDER_QUERY_ROWS = exports.JST_FIXTURE_DATA = exports.JST_ERROR_PRODUCT_LIBRARY = exports.JST_ERROR_PRODUCT = exports.JST_CREATE_ORDER = exports.JST_CREATE_GOODS = exports.JST_AFTERSALE_RETURN_ROWS = exports.JST_AFTERSALE_RETURN_GOODS_BY_ID = exports.JST_AFTERSALE_FAST_ROWS = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _jstErpFixtures = _interopRequireDefault(__webpack_require__(1304));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var JST_TARGETS = exports.JST_TARGETS = _jstErpFixtures.default.targets;
var productsById = _jstErpFixtures.default.products.reduce(function (result, product) {
  result[product.id] = product;
  return result;
}, {});
var ordersById = _jstErpFixtures.default.orders.reduce(function (result, order) {
  result[order.id] = order;
  return result;
}, {});
var orderItemsByOrderId = _jstErpFixtures.default.orderItems.reduce(function (result, item) {
  if (!result[item.orderId]) result[item.orderId] = [];
  result[item.orderId].push(item);
  return result;
}, {});
var aftersaleItemsByAftersaleId = _jstErpFixtures.default.aftersaleItems.reduce(function (result, item) {
  if (!result[item.aftersaleId]) result[item.aftersaleId] = [];
  result[item.aftersaleId].push(item);
  return result;
}, {});
function money(value) {
  return Number(value || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
function compactMoney(value) {
  var amount = Number(value || 0);
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
}
function lineDate(value) {
  return String(value || '').replace(' ', '\n');
}
function findOrder(role) {
  return _jstErpFixtures.default.orders.find(function (order) {
    return order.role === role;
  });
}
function getOrderProducts(orderId) {
  return (orderItemsByOrderId[orderId] || []).map(function (item) {
    return {
      item: item,
      product: productsById[item.productId]
    };
  });
}
var JST_PRODUCT_LIST = exports.JST_PRODUCT_LIST = _jstErpFixtures.default.products.map(function (product, index) {
  return {
    id: String(index + 1),
    goodsName: product.goodsName,
    goodsShortName: product.goodsShortName,
    quantity: 0,
    price: product.price,
    goodsCode: product.goodsCode,
    styleCode: product.styleCode,
    spec: product.spec
  };
});
var serviceOrder = findOrder('service');
var JST_SECOND_ORDER_ROW = exports.JST_SECOND_ORDER_ROW = {
  id: 'order-1',
  orderNo: serviceOrder.internalOrderNo,
  orderTime: serviceOrder.orderTime,
  buyerNickname: serviceOrder.buyerAccount,
  receiver: serviceOrder.receiver + ' ' + serviceOrder.phone + '\n' + serviceOrder.address,
  shop: serviceOrder.store,
  status: serviceOrder.status,
  orderCode: serviceOrder.onlineOrderNo,
  payAmount: money(serviceOrder.amount),
  orderType: serviceOrder.orderType,
  expressInfo: serviceOrder.expressCompany + '\n' + serviceOrder.expressNo,
  buyerMessage: serviceOrder.buyerMessage,
  buyerRemark: serviceOrder.sellerRemark
};
var JST_SECOND_GOODS_ROWS = exports.JST_SECOND_GOODS_ROWS = getOrderProducts(serviceOrder.id).map(function (_ref, index) {
  var item = _ref.item,
    product = _ref.product;
  return {
    id: 'goods-' + (index + 1),
    image: '',
    goodsCode: product.goodsCode,
    comboGoodsCode: '',
    styleCode: product.styleCode,
    goodsName: product.goodsName,
    goodsShortName: product.goodsShortName,
    spec: product.spec,
    type: '退',
    orderGoodsStatus: '',
    price: compactMoney(item.unitPrice),
    qty: item.quantity,
    amount: compactMoney(item.amount),
    appliedReturnQty: item.appliedReturnQty,
    actualReturnQty: item.actualReturnQty,
    goodsAmount: compactMoney(item.amount),
    orderQty: item.quantity
  };
});
function toSecondLibraryProduct(product, index) {
  return {
    id: 'error-product-' + product.styleCode.toLowerCase() + '-' + index,
    image: '',
    goodsCode: product.goodsCode,
    comboGoodsCode: '',
    styleCode: product.styleCode,
    goodsName: product.goodsName,
    goodsShortName: product.goodsShortName,
    spec: product.spec,
    type: '退',
    orderGoodsStatus: '',
    price: compactMoney(product.price),
    qty: 1,
    amount: '0',
    appliedReturnQty: 0,
    actualReturnQty: 0,
    goodsAmount: '0',
    orderQty: 1,
    issueType: '错发已发'
  };
}
var JST_ERROR_PRODUCT_LIBRARY = exports.JST_ERROR_PRODUCT_LIBRARY = ['product-ksn054', 'product-ucp001', 'product-ksj0417', 'product-ksj0450'].map(function (id, index) {
  return toSecondLibraryProduct(productsById[id], index + 1);
});
var JST_ERROR_PRODUCT = exports.JST_ERROR_PRODUCT = _objectSpread(_objectSpread({}, JST_ERROR_PRODUCT_LIBRARY[0]), {}, {
  id: 'error-product-ksn054'
});
var createOrder = findOrder('create');
var JST_CREATE_ORDER = exports.JST_CREATE_ORDER = {
  id: 'practice-order-1',
  internalOrderNo: createOrder.internalOrderNo,
  orderDate: createOrder.orderTime,
  buyerAccount: createOrder.buyerAccount,
  shop: createOrder.store,
  status: createOrder.status,
  onlineOrderNo: createOrder.onlineOrderNo,
  receivableAmount: money(createOrder.amount),
  paidAmount: money(createOrder.amount),
  freight: money(createOrder.freight),
  orderType: createOrder.orderType,
  receiver: createOrder.receiver,
  buyerMessage: createOrder.buyerMessage,
  phone: createOrder.phone,
  address: createOrder.address,
  expressCompany: createOrder.expressCompany,
  expressNo: createOrder.expressNo,
  orderRemark: createOrder.sellerRemark
};
var JST_CREATE_GOODS = exports.JST_CREATE_GOODS = getOrderProducts(createOrder.id).map(function (_ref2, index) {
  var item = _ref2.item,
    product = _ref2.product;
  return {
    id: 'practice-goods-' + (index + 1),
    thumbnail: '',
    goodsCode: product.goodsCode,
    styleCode: product.styleCode,
    type: '补',
    goodsName: product.goodsName,
    spec: product.spec,
    orderGoodsStatus: '等待线上退款',
    goodsTag: createOrder.tags,
    unitPrice: compactMoney(item.unitPrice),
    goodsAmount: compactMoney(item.amount),
    orderQty: item.quantity,
    currentQty: '0',
    defectiveQty: '',
    currentAmount: '0',
    appliedReturnQty: item.appliedReturnQty,
    actualReturnQty: item.actualReturnQty,
    remark: '',
    availableStock: product.stock
  };
});
var JST_PRODUCT_LIBRARY_GOODS = exports.JST_PRODUCT_LIBRARY_GOODS = ['product-acb001', 'product-acb002', 'product-acb003', 'product-acb004', 'product-acb005', 'product-acb006'].map(function (productId) {
  return productsById[productId];
}).map(function (product) {
  return {
    id: 'library-' + product.styleCode.toLowerCase(),
    styleCode: product.styleCode,
    goodsCode: product.goodsCode,
    goodsName: product.goodsName,
    spec: product.spec,
    unitPrice: compactMoney(product.price),
    stock: product.stock
  };
});
var JST_ORDER_QUERY_ROWS = exports.JST_ORDER_QUERY_ROWS = _jstErpFixtures.default.orders.filter(function (order) {
  return order.role === 'query-list';
}).map(function (order, index) {
  return {
    id: 'order-query-' + order.internalOrderNo,
    seq: String(index + 1),
    internalOrderNo: order.internalOrderNo,
    tags: order.tags,
    goods: '',
    onlineOrderNo: order.onlineOrderNo,
    externalOrderNo: order.externalOrderNo,
    orderTime: lineDate(order.orderTime),
    paymentTime: lineDate(order.paymentTime),
    auditTime: lineDate(order.auditTime),
    buyer: '● ' + order.buyerAccount + '\n' + order.store,
    payable: compactMoney(order.amount) + '\n' + compactMoney(order.freight),
    profit: '',
    paidAmount: compactMoney(order.amount),
    additional: compactMoney(order.amount) + '\n' + compactMoney(order.amount),
    status: order.status,
    suggestion: order.status.indexOf('缺货') > -1 ? '1、补库存\n2、更换有库存的仓库发货\n3、更换有库存的商品发货' : '',
    selected: index === 0
  };
});
function aftersaleGoodsInfo(aftersale) {
  var rows = (aftersaleItemsByAftersaleId[aftersale.id] || []).map(function (item) {
    var product = productsById[item.productId];
    return product.goodsShortName + '　退 ×' + item.applyQty;
  });
  return rows.concat('商品明细　合计：' + rows.length).join('\n');
}
function toFastAftersale(aftersale) {
  var order = ordersById[aftersale.orderId];
  var delivered = order.expressCompany ? order.expressCompany + '\n' + order.expressNo : '';
  return {
    id: aftersale.id === 'aftersale-target' ? 'aftersale-fast-target' : 'aftersale-fast-' + aftersale.aftersaleNo,
    aftersaleNo: aftersale.aftersaleNo,
    internalOrderNo: order.internalOrderNo,
    aftersaleStatus: aftersale.aftersaleStatus,
    solution: aftersale.solution,
    onlineStatus: aftersale.onlineStatus,
    onlineType: aftersale.onlineType,
    aftersaleCategory: aftersale.aftersaleCategory,
    goodsInfo: aftersaleGoodsInfo(aftersale),
    returnExpressNo: aftersale.returnExpressNo,
    returnInternationalNo: aftersale.returnInternationalNo,
    cargoStatus: aftersale.cargoStatus,
    interceptStatus: '',
    interceptReason: '',
    interceptTime: '',
    receivingWarehouse: aftersale.warehouse,
    warehouse: aftersale.warehouse,
    onlineOrderNo: order.onlineOrderNo,
    onlineAftersaleNo: aftersale.onlineAftersaleNo,
    issueType: aftersale.issueType,
    tags: aftersale.tags,
    issueRecord: aftersale.issueRecord,
    supplierMemo: '',
    supplierAftersaleStatus: aftersale.supplierRefundStatus,
    workOrder: '',
    buyer: '● ' + order.buyerAccount,
    receiver: order.receiver + ' ' + order.phone + '\n' + order.address,
    store: order.store,
    exceptionStatus: '',
    supplierRefundStatus: aftersale.supplierRefundStatus,
    applyTime: lineDate(aftersale.applyTime),
    confirmTime: lineDate(aftersale.confirmTime),
    originalOrderStatus: order.status,
    orderStatusSnapshot: order.status,
    deliveryExpressNo: delivered,
    deliveryInternationalNo: '',
    originalTags: order.tags,
    originalWarehouse: '淘金云仓库',
    originalRemark: order.sellerRemark,
    originalOfflineRemark: '',
    originalSalesman: '',
    originalPurchaseAmount: '',
    originalOrderAmount: money(order.amount) + '\n(含运费' + money(order.freight) + ')',
    onlineApplyAmount: money(aftersale.applyAmount),
    refundedAmount: money(aftersale.refundedAmount) + '\n查看明细',
    actualReceivedAmount: '0.00',
    applyReturnQty: String(aftersale.applyQty),
    actualReturnQty: String(aftersale.actualReturnQty),
    creator: '系统下载',
    modifier: '',
    platformDetail: '查看平台售后单详情',
    arbitrationStatus: '',
    actions: '编辑\n查看日志'
  };
}
var JST_AFTERSALE_FAST_ROWS = exports.JST_AFTERSALE_FAST_ROWS = _jstErpFixtures.default.aftersales.map(toFastAftersale);
function returnRowId(aftersale) {
  return aftersale.id === 'aftersale-target' ? 'aftersale-return-target' : 'aftersale-return-' + aftersale.aftersaleNo;
}
var JST_AFTERSALE_RETURN_ROWS = exports.JST_AFTERSALE_RETURN_ROWS = _jstErpFixtures.default.aftersales.map(function (aftersale) {
  var order = ordersById[aftersale.orderId];
  return {
    id: returnRowId(aftersale),
    aftersaleNo: aftersale.aftersaleNo,
    businessType: aftersale.businessType,
    internalOrderNo: order.internalOrderNo,
    applyTime: aftersale.applyTime,
    onlineType: aftersale.onlineType,
    aftersaleCategory: aftersale.aftersaleCategory,
    status: aftersale.aftersaleStatus,
    onlineStatus: aftersale.onlineStatus,
    cargoStatus: aftersale.cargoStatus,
    buyerAccount: order.buyerAccount,
    externalTradeNo: order.externalOrderNo,
    receivingWarehouse: aftersale.warehouse,
    warehouse: aftersale.warehouse,
    returnLogistics: aftersale.returnExpressNo,
    returnInternationalNo: aftersale.returnInternationalNo,
    onlineOrderNo: order.onlineOrderNo
  };
});
var JST_AFTERSALE_RETURN_GOODS_BY_ID = exports.JST_AFTERSALE_RETURN_GOODS_BY_ID = _jstErpFixtures.default.aftersales.reduce(function (result, aftersale) {
  result[returnRowId(aftersale)] = (aftersaleItemsByAftersaleId[aftersale.id] || []).map(function (item, index) {
    var product = productsById[item.productId];
    return {
      id: 'aftersale-return-goods-' + aftersale.aftersaleNo + '-' + (index + 1),
      thumbnail: '',
      goodsCode: product.goodsCode,
      comboGoodsCode: '',
      styleCode: product.styleCode,
      goodsName: product.goodsName,
      spec: product.spec,
      goodsTag: aftersale.tags,
      onlineDetailAmount: compactMoney(item.amount),
      unitPrice: compactMoney(item.unitPrice),
      applyQty: item.applyQty,
      actualReturnQty: item.actualReturnQty
    };
  });
  return result;
}, {});
var JST_FIXTURE_DATA = exports.JST_FIXTURE_DATA = _jstErpFixtures.default;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.br = br;
exports.joinTips = joinTips;
exports.p = p;
exports.red = red;
var RED_STYLE = 'color:red;font-weight:bold;';
var PARAGRAPH_STYLE = 'margin:0 0 8px;';
var LAST_PARAGRAPH_STYLE = 'margin:0;';
function red(text) {
  return '<span style="' + RED_STYLE + '">' + text + '</span>';
}
function p(text) {
  var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return '<p style="' + (last ? LAST_PARAGRAPH_STYLE : PARAGRAPH_STYLE) + '">' + text + '</p>';
}
function br() {
  return '<br/>';
}
function joinTips(parts) {
  return (parts || []).filter(Boolean).join('');
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1-0.png": 1305,
	"./1-1.png": 1306,
	"./1-2.png": 1307,
	"./1-3.png": 1308,
	"./1-4.png": 1309,
	"./1-5.png": 1310,
	"./2-0-aftersale-fast.png": 1311,
	"./2-0-order.png": 1312,
	"./2-1-search.png": 1313,
	"./2-2-普通仅退款.png": 1314,
	"./2-3-普通换货.png": 1315,
	"./2-4-普通补发.png": 1316,
	"./2-5-普通维修.png": 1317,
	"./2-6-普通拒收退货.png": 1318,
	"./2-7-错发退货退款.png": 1319,
	"./2-8-错发仅退款.png": 1320,
	"./2-9-错发换货.png": 1321,
	"./3-1-create-aftersale-empty.png": 1322,
	"./3-2-create-aftersale-return.png": 1323,
	"./3-3-create-aftersale-refund.png": 1324,
	"./3-4-create-aftersale-resend.png": 1325,
	"./3-5-aftersale-detail.png": 1326,
	"./3-6-create-noinfo-aftersale.png": 1327,
	"./3-7-select-noinfo-goods.png": 1328,
	"./3-aftersale-issue-registration.png": 1329,
	"./3-leak-resend-selected.png": 1330,
	"./3-leak-resend.png": 1331,
	"./3-noinfo-aftersale.png": 1332,
	"./3-noinfo-product-library.png": 1333,
	"./3-normal-return.png": 1334,
	"./3-product-library-search-result.png": 1335,
	"./3-product-library.png": 1336,
	"./3-select-exchange-order-goods.png": 1337,
	"./3-select-return-order-goods.png": 1338,
	"./3-wrong-exchange.png": 1339,
	"./4-1-order-query-result.png": 1340,
	"./4-2-aftersale-query.png": 1341,
	"./4-3-aftersale-query-result.png": 1342,
	"./jst_login.png": 1343,
	"./order-default-necklace.png": 1344,
	"./ppt/2-10-普通退货退款建单.png": 1345,
	"./ppt/2-11-普通补发建单.png": 1346,
	"./ppt/2-12-普通补发填写.png": 1347,
	"./ppt/2-13-普通维修建单.png": 1348,
	"./ppt/2-14-错发退货退款建单.png": 1349,
	"./ppt/2-15-错发退货退款问题类型.png": 1350,
	"./ppt/2-16-错发退货退款问题选择.png": 1351,
	"./ppt/2-17-错发退货退款商品库.png": 1352,
	"./ppt/2-18-漏发补发问题类型.png": 1353,
	"./ppt/2-18-错发退货退款添加商品.png": 1354,
	"./ppt/2-19-错发退货退款完成.png": 1355,
	"./ppt/2-20-错发换货建单.png": 1356,
	"./ppt/2-21-漏发补发建单.png": 1357,
	"./ppt/2-22-已创建手工售后单.png": 1358,
	"./ppt/2-22-漏发仅退款建单.png": 1359,
	"./ppt/2-34-错发换货选择订单商品.png": 1360
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bz1.a62eebc.png";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bz2.86109ce.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bz3.fe33b96.png";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ck1.e39a73c.png";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ck2.f44be53.png";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn1.d99012c.png";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn10.7984c2e.png";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn2.eb7cffc.png";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn3.31b64c9.png";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn4.e39a73c.png";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn5.1255abe.png";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn6.1736675.png";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn7.06818b2.png";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cygn8.053e15e.png";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fkzt1.1334c9b.png";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fkzt2.6167911.png";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fkzt3.4117682.png";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fkzt4.cac18c9.png";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hddd1.69e27a8.png";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hddd2.8d559b2.png";

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy1.d969aaa.png";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy10.47d06cf.png";

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy11.bca3b9a.png";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy12.054457e.png";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy13.1ffab89.png";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy14.84e94da.png";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy15.d50fea5.png";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy16.4b3a9a4.png";

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy17.64de9b6.png";

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy18.aa784f9.png";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy19.f602503.png";

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy2.0b1b6ef.png";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy20.b5339e2.png";

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy21.bca7f90.png";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy3.c474ba3.png";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy4.41456a3.png";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy5.ec427c3.png";

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy6.ee7dab7.png";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy7.d9364e7.png";

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy8.41f09cc.png";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy9.ab07ae1.png";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login1.8efd570.png";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login2.db6560c.png";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login3.2f2a3ce.png";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginindex1.0da93d3.png";

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginindex2.503fa38.png";

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginindex3.bc621ca.png";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginrnd1.d4b3557.png";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginrnd2.76d9dfa.png";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginrnd3.eb9e7c9.png";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnbg1.8f90d91.png";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnset1.dddb8ec.png";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnset2.cd14da3.png";

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnset3.ca53535.png";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnset4.136e979.png";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnset5.42d9ab6.png";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnset6.07b3956.png";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnsort1.2613f2c.png";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnsort2.c3d7070.png";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnsort3.1bc9bda.png";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnstatus2.c32dee8.png";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnstatus3.ac70c57.png";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnstatus4.00db58b.png";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnstatus5.a6ef506.png";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnstatus6.5f5f4e5.png";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnstatus7.85a878b.png";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn1.1334c9b.png";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn10.6648685.png";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn2.916b362.png";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn3.c47226b.png";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn4.bffddae.png";

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn5.e96a8a2.png";

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn6.aaaeb3c.png";

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn7.75dba93.png";

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn8.1f08874.png";

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shcygn9.6e9e4ce.png";

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn1.021a03e.png";

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn2.3e41f1e.png";

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn3.fb40a4d.png";

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn4.a0493bb.png";

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn5.32df029.png";

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn6.ba5f9c0.png";

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn7.ab7be0b.png";

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn8.fb50410.png";

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tjsp1.b58916b.png";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tjsp2.494fe2a.png";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tjsp3.3a5ea53.png";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tjsp4.8dfa5a8.png";

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tjsp5.3bde5f1.png";

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xgdh2.6768029.png";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xgyf1.842dcf5.png";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xgyf2.18ff5a1.png";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yfalert1.8c1d5ff.png";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yfalert2.1ee9cfb.png";

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAA8CAYAAAB8SnrYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAACrUlEQVRYw+2WPUxTURiGn3sba0j5G6xG07SESQEVF0ggDkwwiAkTyIIm7mIkOrmKUaMMkDho1EGJDho3iD84KJOJmIC6WCxBEygTfzE15XXouXjSH2mRzfslN+l5v/f93tNzz/nOdfhLSIoCvUAbUAeEgV/APJAA3gCPHceZpZSQFJX0SFJS0rCkToMFJVVIOmiwYUlLhhsttvhJSYuSLksqL4JfbrhJSae2Ip+T9FXSkZL+ckZ7WFJc0vlChG5Jc5IiWXidpJuSPkv6aZ5PBqvL4kZMje58a56U1GxhQbPGaRWOtKTbksosXbOpFbUNHkoazCr+QsXHK0lBS39V0qg3iJmdUGURRkoo7sWwpa8yNWOOpEvAIcdxTptkPfARCHiCH99S3LuWZOrdGgCNrSHOXAxzoGZz0gBp4KjjODPeJIE5l8whem4Rz9rFv8+m6O9KMDm+wvrqBuurG0yOr9DflWA+nrINAkbrxRjQ5gINwHsr0WGr7l9Psracztl1a8tpHtxIZsO2dgpocIE9wIKVqLUV3rLkiw9vc3K2dgEIu2awm+2EcpBUNuACS8B+C4vbhMbWUMH6x47n5BLW731A0gVmyLwHL8ZsRd9AmFBlIKd4qDJA30A4G35pzw2YdoHXQKeVuEtmywEQqQ0y9CxGS3sFZSGXspBLS3sFt57GiNTmbNM71rgDmEBSjTna/3rQRiy9d9BqPGB0h1vF4GarMIDX7JqyTLbT7Jpymp1J9Ch/u66XNCTpi6SUpFVJ0wZryOJ67bon77bTzlw4F7YielfmoKTqIgpXS7pilqW32NlEzYtfMu/hhMF2mSdqMO/SH1WBS9/Zyog/ny31wF6TWiRzQCeAJ47jxNmJkKRSNW6pAt/AN/ANfAPfwDfwDXwD38A38A18g//X4Dd5di/Lnb/FTwAAAABJRU5ErkJggg=="

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAA8CAYAAAB8SnrYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAACsklEQVRYw+2YO0xTYRiGn3OqNaTcBqvRNC1hUkDFBRKIAxMMYsIEsqCJuxiJTq5i1CgDJA4adVCig8YN4gUHZTIRE1AXiyVoAmXiYrRJeR36H/zTi7TI5vmSk/S83/t+75//8v0nhRJCkkrhA7ilCnwD38A38A18A9/AN/ANfAPfwDfwDf5fgx1/S0qKAr1AG1AH/JK0AswDCeA18MhxnNmSXCVFJT2UlJQ0LKnTYEFJFZIOGGxY0pLhRostfkLSoqRLksqL4JcbblLSyc3IZyV9kXS41LmWdEhSXNK5QoRuSXOSIll4naQbkj5J+mmejwary+JGTI3ufHOelNRsYUEzx2kVjrSkW5LKLF2zqRW1DR5IGswq/lzFx0tJQUt/RdKo9xIzO6HKIoyUUNyLYUtfZWrGHEkXgYOO45wyyXrgAxDwBN+/prh7NcnU2zUAGltDnL4QZn/NxqAB0sARx3FmvEECcy6ZQ/TMIp6xi3+bTdHflWByfIUfq+v8WF1ncnyF/q4E8/GUbRAwWi/GgDYXaADeWYkOW3XvWpK15XTOrltbTnP/ejIbtrVTQIML7AYWrEStrfCmJV+8f5OTs7ULQNhrdrvYSuT+e5TKBlxgCdhnYXGb0NgaKlj/6LGcXML6vRdIusAMmXXwYsxW9A2ECVUGcoqHKgP0DYSz4Rf22IBpF3gFdFqJO2S2HACR2iBDT2O0tFdQFnIpC7m0tFdw80mMSG3ONr1tvXcAE0iqMUf7Xw/aiKX3DlqNB4xuc6sY3GgVBvCaXVOWyVaaXVNOszOJHuVv1/WShiR9lpSStCpp2mANWVyvXffk3Xbangvn/GZE78oclFRdROFqSZfNtPQWO5qoWfglsw7HDbbTPFGDeZf+qApc+s5mRvz5bKkH9pjUIpkDOgE8dhwnXqjGb6IVM6fXi5W+AAAAAElFTkSuQmCC"

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_kong.73efc11.png";

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDialog_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d24141b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examDialog_vue__ = __webpack_require__(1547);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1545)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d24141b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d24141b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/examDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d24141b6", Component.options)
  } else {
    hotAPI.reload("data-v-d24141b6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABgElEQVQ4T62U71nCMBDGk2OBVhwAJxAXaOIGdQOYQJlAmAA2oBugE5h2AR1BP/uHDiA572pT09CKPg98gTZvfnfvmwtSHOkjuzhbraOdEFpaO5ZSKhKVAvF5B5CfGnPXtWcP9Kq1HiCuSTzqaba0Uk5DYAv0niRz6uCaANEhx4i4GBbF3OkaUN3JwyGAv06dXbnOKhBnQhUYMuZnFgysVSjljb9RIq4+Ae7JuitYnuR5zJoK9KZ1Coibpk3aEBfFbJskSwdjiABYWCEm9HvptLQ+GxqzqkB1Nrd+dZcBw6r3PxDWNRkSIIvzfPptTakNCpGG+TQwsl530oLU+ieyd1GBPpRizzoEsR222Nf1HsjPws/J2RHWRnzUfTou1ht2mEljU6k1xTBxBevhzPzjf6TFEQt2Ul4CjQJZa2XCMABY0fe2BpU0wGexMeVxB9K12ZVBeADhrDXPofCPl3ZGVyPz9/72N5LSNTmnyeVrE1FexgK8UHYZZ7I3Kn2t//f9FzjC5xOKN2jLAAAAAElFTkSuQmCC"

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAVCAYAAAAdHVOZAAACtElEQVRYhe1XTWsaURQ9KW3+wfiNi0I3BrFSFLpSCkGClITSEugqIjXFiq666BAQQaaLrhQrSYvoKlBaSiWUUrKJKyFBBgnJvtTUtP6DdNHeN6N2WscwM7ZRypyFM++9e/Xe+8479zn3udP9ARMSLk07gFmCWQwFZqIY3Y8lxGrHE3zDMV4IDXQnjGPOqGY8e/4K8/NXkHlwZ8IQGCiZ5BEC5Xvwq65tA+t5BMQNFPf7065FpG8colg/HfFwL2eQi3C6o7is26OPT52vRl2HYIzgFck0k2369CG9DhS32v1ZGpfzcpF8eVTXZL9NeOCPhFCNsAXGjB5u8yHY26+RHa2PJhguxt+APbKKu609OHiZEXKSYXrfA4L3KXHPqBMly7e8EPgeMaaApmKpmdwdGCHWWiQbKo6OeKZaDIBDNG5Bls67LQ5sdm8ht8axXMaAGLAFYoqcZIIYkxjM/8aM8MUek8nRw3uhgDcdecTn5GeMNOFm0Afsb0vvQ5BGCNFvxIS2fJxUNGPADPdy2FBEmgSUiaVWjbh21WVAVBU7y4a0uzFxQTomYq2EL0spRK3n2I+MjUETM1jX0Iqzs++abUcFlO2sLKDj7HdsKSRsPZw4OJzWNsAr2DPUDJd+vWDQVAy1nU49KUrP0tO0zp/8Bft1L9x1K1bKCzgQjqS5AImpjZJ228Oq9ieVBkQ6Hk5/Cv5+d7lQZvwbkGZUDhHMUlKUzAEslAyHHRJTp4OayZKKAFpDWHHQXaPO2q18/1DvJqQ7dC9J+PRFNMViUCfhU3/MeZCIN5CtePHQqurURxtFwQJBrZtMENGUW6uio9C9giUmftiFM5pXTUokjXhnz6Ba5mS9UTCBQcmMsfeUc2D4Ol54+VYSy8ePVo24zyQMF+N/xEz8a50VmMVQwCyGAmYxFPgJ87ELsnT7VUoAAAAASUVORK5CYII="

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAABcCAYAAAClWXHyAAAEaklEQVR4nO2cX2hTVxzHv449bA+DKQUnOJxkNDChJfhgRWn6Ml986aCgTyWGKTQ+FUYDFjYoCEakPjUPfShhD9LRjvZhbhBfTKm0e2km6LYOAmM4tdR/sIf5dj33Jl1rcrPk3tJ7k2++HwhNzj2Hc5LP+f1+J03TfZYBgpZ3wl6A2FskmBwJJkeCyZFgciSYnI4R/Os/TzHz10rYywicjhGc3/wNE3/8FPYyAqdjBHcqEkyOBJMjweRIMDkSTI4EkyPB5EgwORJMjgSTI8HkSDA574a9AC88+vcV/n79yt/YyrifX/7pe/4T+z/xPTYs9rXTn81evH8LdzZ/D23+H0+k8NkHH4U2vx/aSrAdwY9ev/Q1du5xEd8/+QWzxy/4nr9v/1HfY8OirVL04fc/dG5+WK2k5naUtBt0yCJHgsmRYHIkmBwJJkeCyZFgciSYHAkmR4LJkWByJJgcCSanrT5N2g1Dh2I4/J6/T6Lambb6PFh4RymaHAkmR4LJkWByJJgcCSZHgsmRYHIkmBwJJkeCyZFgciSYHAkmR4LJkWByJJgcCSZHgsmRYHIkmBwJJkeCyZFgclpP8MZtXOpNY37Dy6AXmL8cx6XFFz7niyNTbNTxITL11lXMInrzofe5A6D1BB88i5HEKsZveXjBNlaQXz6HkcEDvuabzo+hlPCwqf53U9gboZkNEwzhfnXF3vmJ7zwMOIfZ+ynEnIj9AuPLzY1K5gpIx+wXPoUZr2tMfGXG36gaZ6/jPEpmDfnPFzB9ZBbRu3Gsj8LM8S0i+QyGDnqdaI+wwmRtyuqefNBk5wfWtZ4pa825/9yaS/Vb19aamGLSpZ89b+oHa7PhPNXtY9bcU7dJvDyPYGmpFF28GUf08m08cx6VU92e1LZYHMnlJdx1racFzCTiJku4tJsf+YlyKnfW2lu52Vkol9p+3EIpOtwIdihHY3dPnYi0o8NcezvidhnBhs2FMeviwnOXtbhFqWmfNP17yuvsdo1w72sLghC/H7xVR/twNV/Aer2aFUth3dTdrYNNxKmn5Ut2pDVTU5MDtW1dg8OI9GYwf3K7Xj5bzGD80+HatZhDXOloPyLm7hlTXwdW0rhiTuzTfg51AROi4AMYmipgaCsVN+qeyBrRhbeakjtk18NOpXnXK8eQzh1B9EwWEbOBPl5M49SdftybOlbVz2zEiSVEvh5GCUtOS9dgBiNOiq4/b/LLRk8oGFrgG/7mhTbi0jtaHCkDjeXtGjs75LJOzcTpMSP3LLpqOj1ByUR12kR1ZufQ0YJzaq6lnJlKe7Vmj7TUIStw7LRvH5BO9yG+fB2nerOoPRuZDThaHdXtQwtEsH/81mA7Q5zPoRy1Jnv8F7XFSjSjQfpv4v27UjTsQ42pe9+sul/MucmzD2TbhyJvNXj7Fx32ONf0unWgq4yLJlCu/dURvKNfLa2VovVPWMjp7BrcAUgwORJMjgSTI8HkSDA5EkyOBJMjweRIMDkSTI4EkyPB5EgwOW8AA+i86QCMBloAAAAASUVORK5CYII="

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2-7.605b694.png";

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2-8.993deff.png";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2-9.ba0eddc.png";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-4.bc969bf.png";

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAQCAYAAABEO2JQAAAAoElEQVRYhe2X4Q6AIAiEo/X+r1z5w81ucMy5ZhjfPyQ2vThKOW+2RGWfvYEvk+IQUhzCMXsDo4jII8YR2ua18crqQ4tTDqaJUdcw78W49itblUNjpzBCizP6F8K6phDaVohmE8yzdaxdRhxNGLSRZStrRi0hDuuYHutV8ZYZyJ6VvFpGaHGsT7EV9woZ3lbe22/njDeT8BnJW7lNaFu9zQUfLmUdLmjkXgAAAABJRU5ErkJggg=="

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zt1-5.a48af55.png";

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAAASElEQVQ4jWP8DwQMNABMtDCUpgaz4JO0dQlmePX6DYqYmKgIw+E9awkazDgaxjCAEsbYwpQQwBXmo2EMB6PpmPYGj6bjIWwwAKR7LBjhH+bqAAAAAElFTkSuQmCC"

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAS0lEQVQ4jWN88fr9fwYaACZaGDpqMApgIaQgKCyR4c3bdyhiIsJCDOtWzcerj3E0VcAARhhjC1NCAFuYj4YxHIymY9obPJqOh7DBAFYMKvVsQH/DAAAAAElFTkSuQmCC"

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jz1-2.55ad14b.png";

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAYAAABCIB6VAAABe0lEQVQ4jWN88fr9fwYaACZaGEq0we/efWB4++49VrngiCSs4iyEDP3//z9Dfkk1mF48byoDIyMjivzr12+x6iPo4ouXrsLZly5fg7ODwhIZ7Jz9wWwQDeIjA0ZCkdfc1sugoa4KdvHNW3cYaquKUeRBhh7au5E0F3/6+Jnh+IkzDB6ujkDsxHDs+BmwGDIQERbCqhevwTt272OwsjRj4OXjZeDj52WwsjIFiyGDdavmk2YwyOubtu5k8PVxh4v5ebszbNyyCyxHCOA0+NKV62BaT0cTLqanqwWRQ4pEkg3evGUn2IXIyQvE9vNxY9i0ZQd5Bn/+9BkYUafAEYYOPNwcsUYiOsCaQXbuOcDw5es3Bp+gGJwaQZEYFuJPvMHgSAMGw+QJ7Qz60DBFBxeBYdzVO5UhNNgPIyfCAEZQXL56g+Hf/38okYYOQHJMTPgjEcPgzcCIQY80dACS8/fxwBuJGAZfu3EHa6ShA1BuvHb9Fm7Lh2dBP6gMBgD2CJYw8XTrwgAAAABJRU5ErkJggg=="

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAVCAYAAACkCdXRAAABIElEQVQ4jWP8DwQMVAJM1DIIBFjQBVy8IxkeP3mGoZCDnZ1BR1udISstnsHa0gSrYYzo3lTXt8drOxMTE8OE7gYGdxcs6v6jATU9OzBGB9++f/8/YcpcsJyVo///P3/+YKghOsw4OTgY8rISGZQU5RjevH3PcOvOfUxXE2sYDDAyMkJoLHIYEYAL/Pj5k2HG7MUMd+89ZBAVEWZQVVUi3jB8EZGeEsPAzITpKbLS2dQZCxgePHyMKUFsbILAm7fv/qdml4Hl80rqyI9NEBAWEmRoa6wAs4+dOEu5N6GRCUy8mPFJkmGg9FVR2w5mW5gZYciTFZsCAnwMBdnJhF0mKyOF0xA+Xh4GDzcHhlWLpzMoKshhyGNkdEoAVcuzEWIYAM1tur4+qlY6AAAAAElFTkSuQmCC"

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAABM0lEQVQ4jWN88fr9fwYqAyZqG0gzQ1mwCUbEpDM8e/4CQ5ydjY1BXV2FIT4mnMHUxACnoVhdis1AEPj56xfDpcvXGEorGxkOHD5Gmkth4NDejSj8Hz9/MixdtpZh4ZKVDBMmzmSwtTJnYGZmJs6luAAHOztDUkIkg5ycNMO79x8Y7j14hFUdWRHFyMgIoXHI4/U+OgCF6eIlqxgePnzCICwkyKCoKE+6oXbO/jjlYqJDGZiZsHuU7HS6YOEKhsdPnmKVIyn2QeD9hw8M7V2TGE6cPMswe95Shqa6Mgw1JLtUUECAoaI0D8w+c+4iVjVkxj5UMxP2+Ccp9kEAlD7buyaC2UYGeqQbii/2+fh5GVITo4g3VEpSAmf+5+XhZjA2NmBIS45hkJGWwqqGcWQX0jQxFABcCFcoNeSGoAAAAABJRU5ErkJggg=="

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAAfElEQVRIie2VMQ6AMAwDnVCY+P/T+AADf6CiAbfQhQmRMZZsRR2u6VLLsh6m2OGlgglyZTIoaHGAWrXWOXHbAfk+/iu5s0Cl3+Uh6y9XJ+JLAQ5wgAMc4G/g9sV7FFPjPJWRWH5eaEJ7mTJoDwla31XwrNs1ZBcwZRjBvU9NYB7hQLIBGgAAAABJRU5ErkJggg=="

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAATCAYAAACk9eypAAAAO0lEQVQokWP8DwQMJAAmUhSPaiAWsKALFNdPx1DU25iJ2wZkSWx8hv84QFHdNKzijKNJY8A1/P37jwEAkcM/XI7L+F0AAAAASUVORK5CYII="

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAN0lEQVQokWN88fr9fwYiAROxCkcVowMWZE7X5OUYCspyI7GbjCyBjY/hDJgCdIUgwDga3eQqBgCj3g+Xj7xnEAAAAABJRU5ErkJggg=="

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAAAhCAYAAAD+vMi+AAADVUlEQVR4nO2awY7SUBSG/zE+RZF5AN1ohJLIOwwDbkgMKxInLBo3YtCEFYkhsjJdEBezmpiwcWbwHSAZBhNXPoBMceFD6Dm3hd4WSqDgAOP5NrS39/aWOf/9z7llDka/fv+B8F9zb9sPIGwfEYEgIhBEBAJEBAJEBAJEBAJEBAJEBIpB+xj2cNtPsT3uxxn0vvUJ377/WGnM08cP8a56stIY56uFWncEpKo4S/dRGxdRcCzY9NlsFJGY9hzhov4BqNjIG4vaomEhlEJtZuUSmesVBMLPWcku2Xl3iCUCFsCXzx9XGvP8xavlOg5bKLV76jCRs3F2mvTa++qDA3M27qBWbqFwWoXJjeMergwShh7seW0L4PtaqTkXUjSffs5ztwErIML9JpYI/im8mii4LIbaOKIPB/fUO9ZEUyJhAEkUGjbMYQ/OcOS1YdquXEEbM2UYdAJfFD3YdI9B6BFq5U6oJQtrIso9Y20RTFY4O4N+HJeL+jHOp8HvodTVr4bOWQw51zGaR+wYXgqgfufXWRKKv1oHbQuONtQfMwunoXO9wfDSD7tAN4mmZ/mcQq7SLBYWSj/2d942a4tAD/g6wZ+Qb1wizwfKCYp+oEIBmDJshW+Bmy6tUgryIrt2ulZIYEHMSsQFdpGyP6eZXjDJnrBzTqDjB4qtnFfiSK3mhLLoDh6wvSMcUOpLxWCiSwUdIvI8VnQCHa34U04Q98vtEDvnBPp2LRgosnr04ZAj2PUOEpSzVX4fz0sHbk5HO1oIsZ3gDrJRJ9gEqvrng5nCMImEQQ5QZ1e4XGrbZ5IjOHUq6mj1BpgUnx688m28iXSGAJIOZtlU8BejVeipoicAFsQIhdyicUmqMTjY5BCeoKJfDM1xBmX989okHdwqbtB4+0W2ruzecs8pNQyMZ6ptpiaYuctP3IwPkTE0p5ncm4pPK027CRSRuW7hJhdOHz23KNW2hLoT+FvLLDKb/OK3yO6JQNvDmxXadx/pL2vclW2X3T88XweJYV5NMLO/pxVsIegEShApTgc836Hamag3h21/jHICI/yGMsx+bxEP4vyjaZzXxqknj/D29ctVpxJugVgiEO4W8iuiICIQRAQCRAQCRAQCRAQCRAQCRAQCRAQCRAQC8Re+7XsoJ1pa4wAAAABJRU5ErkJggg=="

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAAAYCAYAAACGLcGvAAAC3klEQVRYhe1YS5KiQBRM8HMDeit7DgHjHXRLhFvvoLZ36K0RbNs7GHAIeo3b9gSjopOvkKFE50850xNkREcUXY8HlZUvX6H1af75jBaNwP7bL/A/oSWzQbRkNoiWzAbRktkguiaTu0EPM+RIvC5C507ALsfkJUem/8/pYDW1EC2OSEy+nAEYJNOC7wHJK09e3hnRywHRTpsW0sbF0B/1Mfeu754v+vfTahsgm7VycgzXJ0iRzRdd+JewZL3Hc1rkDncHTGLzJ0BzZDo2F3bCkgT6PwiVhQ/XMhJCOsjqxN/N38HMO5HYikhInlQmLYRTEptS3esDXI7D9Cdy/iGMkel6tGMuJoOQKYujQupBVNkVeI+fnpCN+9jcswVuzvOl/P2gg228LyzCsTBgrmVaxkklHKsxVbkJbERKweZgiEwbYWABcXldlrkoyEYshGhlXsBS90SvR8bliPQpeu5mZFNlpY9acJ/OyMr8uzO2DtXn5aq0b/DOWOZ2OcyaW+QNjHRzl6oZ7EqPuuOXglrzcQNpUlx0LU58cROcMVnsNaJIzFUsFUvViT9uNN+sniVkU71NLO47MKLMARcXpVSnKu/eTSf39eYipL4CM1EyiRfy5mqsgyqml+rxsllbPYSWIn6pmpLkl+uvZS3EywbQnw36phEykzjnokT0osr9pWRJ7KirOjw4P4kr//JHPST0uO3UZukeMIyrXEKOdOPr8rWpNFspLas9u7i/aEjzt1LNhZJjww3oYYd2n0QKiVshmN650tQnHffXO22hNAXx31F9KVTjezlvvsQFDyCz6OTBm0YYS3CJoqn8Hk6IU2lCl0vp5LsO/bJ/+ZNjkva8J8bylGD6I8DoF1B53nPj/U2XVeWoujQ0b6tQHeTFKm4zi5WE4w5JKppY3R6u3kGdEswei9STPvKPw+UXkBydvgXZxEd9AX1oMv81tL8aNYiWzAbRktkgWjIbREtmg/gCPXE86hcD3dEAAAAASUVORK5CYII="

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAOElEQVQokWN88fr9fwYiAROxCkcVU6SYBZnTNXk5hoKy3EjsJiNLYONjOAOmAF0hCDCOpo3BpxgA0KsPnYNGk2QAAAAASUVORK5CYII="

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-10.eabc2c7.png";

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdsjtb1-1.7644e35.png";

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-5.3f3dfa1.png";

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-1.7b0596c.png";

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAQCAYAAADu+KTsAAAEdElEQVQ4jX1VS0xcVRj+zp0HHYbL8LKmddPRhEVjiyO0cc9DLCyM0caYSB/Wki7MtLG0KEttRTRViE2pIRYHFsYmuLCMLTPtukmhpD4WxmeixSAMDAzDvJh7/M9rptXEA3PvOeee///+x/f/h60tpDgcBodvARbk4A5NXWqPcw4wBiZe4iNNuMPFhP4cuclIkNPbKTjyzcRh8U+yTOjUsuIbpKzSaQndcpPF4Q93YNvftLBILR2SuLiJqnAnfItKjnNLA4tBoN+fRmDoMlx6Rz3VjBGyO96NQPx3SEhlkwQWP7c5XfpAG5xcV14SEG/HxtEo6t57E8XhC8hz5bWR885HUAzNYouC4L7VheroHdptQebAbviiEW3IM6j7hl473kHy9OsoaiPdMnhcwZon4zH4T70ELx4e/vA4/HpeeG0F6T1xeOdAXregdnofsv3XsbL3EgKEmWs7jkzrh+T5AfjZJ1jbE5P7XERLh4it3k9xz4QN/+wDKC1HkJ/9Ac7ADDa3m2AKM2Xc4Z2ogbcpgexiJyrZZay37qLUMfVtsg6epi/APnv5P8bLsfNdJPuOo+hocJlL3EDVySHwgZvIbKd8CzJR7vm9MOrHgPTwCHKCQJpMjOaeyVr454zWQ0gd5rC/7ULi1dYSlif+HEXrItaemkHgCpA60yvDLh7uoqOoKMghGUlg1Qgj2R6kxW+ojI4jd2wdecZUYrjmCBmWfSWJbNNJ1F9vxPrZE2CRWuBuBPV3KQVdu7Ft+nNtwn7UTSuvodWIymLLf6SkuopJG1XCi+YprHT+hMC5s5TL/xnNXyKFg7Dnyls54sHGk3FUnZpG4aMLyJHBnviz8PNL5MwuVT2mZsVr+c8090744Q1NgY0NojhwC5uPClW/onLwGHBErLlsAc7iRdSc+xGZj4n1lqUC8R2lJdpIeexExQe9wOE+WOM/Ix/6Cvb0nX9Z3IMUyWZlwXAqNRr5Q2kUWAxVsHQFE3Eie+Fb2I+MbigO/wW+K/1A1zxywhRHlaehLkcQhRBQff4gReUqNtpjSHRwuGIdsPkoVslzxpiSEcIQde5ikjzQerhU5CDfs4FEDwEO2qhfMKGewnL747JHGAGmF+74KNDxKTLzIVihJ+AbqkGlkUMzGkTOsQ+bAzeQblCtVHrOWbkvKfapWmQUepdWkOt+H+5rL6BhjqLxdoxSwaQR0uyFt2DvuIrVWC9scX7saRS757HUH4RnhjzHKBJtQZTZqpGW7qe5O96Kmq9vA48NIdnfCN8bz6NCfj6K1AiVmLFLNH3MwA6/CHf3PQplkMLahtq/zmApdA2PUEmmRobl+YpIAPaDvcOMneex0ncCWyLGywQOSR4delYuJ91bdFPX4KZUoO4AedGI+i8ZyOVdIQnq8FIblueKIqVGuRC3ygRQKq0yqNKt+7y5TphME3cZagrOMN3/tHIuNLKHLxOw0sIio4W/loGVeSdLHF6EoV7JJqYS5egcc2MQV+2WS/KXPVK3lnDNgiGG4xgMVorsP26H6bHw/QdvAAAAAElFTkSuQmCC"

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom01.14db6e4.png";

/***/ }),
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qtcj01.96762fe.png";

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qtcj02.c32a10f.png";

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qtcj03.9165d50.png";

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qtcj04.e4d7eab.png";

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qtcj05.258087b.png";

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qtcj06.cd4537c.png";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qtcj07.6cefa9e.png";

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qtcj08.790d104.png";

/***/ }),
/* 469 */,
/* 470 */,
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {};
  }
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'list': '',
      "children": [],
      "childrens": [],
      "cateId": '',
      "add": '',
      "info": '',
      "nums": 0,
      "roomType": '',
      'success': true,
      'message': '',
      'pageNum': 1,
      'pageSize': 12,
      'pages': 1,
      'categoryId': '',
      'categoryList': [],
      'courseList': [],
      'List': [],
      'courseName': '',
      'isActive': ''
    };
  },
  mounted: function mounted() {
    this.Category();
    this.courselist(1);
    this.StudyInfo();
  },
  methods: {
    queryListByType: function queryListByType(categoryId, key) {
      var _this = this;
      this.add = categoryId;
      $("#type").find("li").eq(key).addClass("active");
      $("#type").find("li").eq(key).siblings().removeClass('active');
      $("#genre").find("li").removeClass('active');
      $("#genre").find("li").eq(0).addClass("active");
      this.categoryId = categoryId;
      this.pageNum = 1;
      var data = {
        'categoryId': this.categoryId,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryCourseList', data).then(function (response) {
        _this.children = [];
        var result = response.data;
        if (result.success) {
          _this.categoryList = result.data.list != null ? result.data.list : [];
          _this.pageNum = result.data.pageNum == 0 ? 1 : result.data.pageNum;
          _this.pages = result.data.pages == 0 ? 1 : result.data.pages;
          for (var i = 0; i < _this.list.length; i++) {
            if (_this.list[i].categoryId == _this.categoryId && _this.list[i].children !== null) {
              for (var n = 0; n < _this.list[i].children.length; n++) {
                _this.children.push(_this.list[i].children[n]);
              }
            } else if (_this.list[i].children !== null && _this.categoryId == 0) {
              for (var n = 0; n < _this.list[i].children.length; n++) {
                _this.children.push(_this.list[i].children[n]);
              }
            }
          }
          _this.childrens = _this.children;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //父级接口判断
    queryListByCategory: function queryListByCategory(categoryId, key) {
      var _this2 = this;
      this.pageNum = 1;
      if (categoryId == '') {
        this.categoryId = this.add;
      } else {
        this.categoryId = categoryId;
      }
      $("#genre").find("li").eq(key).addClass("active");
      $("#genre").find("li").eq(key).siblings().removeClass('active');
      var data = {
        'categoryId': this.categoryId,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryCourseList', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.categoryList = result.data.list != null ? result.data.list : [];
          _this2.children = _this2.childrens;
          _this2.pages = result.data.pages;
          _this2.pageNum = result.data.pageNum == 0 ? 1 : result.data.pageNum;
          _this2.pages = result.data.pages == 0 ? 1 : result.data.pages;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //子级接口判断
    Category: function Category() {
      var _this3 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryCategory').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.list = result.data;
          for (var i = 0; i < _this3.list.length; i++) {
            if (_this3.list[i].children !== null) {
              for (var n = 0; n < _this3.list[i].children.length; n++) {
                _this3.children.push(_this3.list[i].children[n]);
                _this3.childrens = _this3.children;
              }
            }
          }
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //标题课件接口
    courselist: function courselist(num) {
      var _this4 = this;
      //课程列表
      var data = {
        "categoryId": this.categoryId,
        'pageNum': num,
        "pageSize": this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryCourseList', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.pages = result.data.pages;
          _this4.pageNum = result.data.pageNum;
          _this4.categoryList = result.data.list != null ? result.data.list : [];
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //课件接口
    StudyInfo: function StudyInfo() {
      var _this5 = this;
      var param = {
        size: 20
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryUserStudyInfo', param).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.info = result.data;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //排行榜接口
    //设置图片
    style: function style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      };
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1dbe7d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__ = __webpack_require__(1089);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1087)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1dbe7d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/video.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b1dbe7d8", Component.options)
  } else {
    hotAPI.reload("data-v-b1dbe7d8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var getMousePosition = function getMousePosition(e) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  if (type === 'x') {
    return e.pageX;
  }
  return e.pageY;
};
var pad = function pad(val) {
  val = Math.floor(val);
  if (val < 10) {
    return '0' + val;
  }
  return val + '';
};
var timeParse = function timeParse(sec) {
  var min = 0;
  min = Math.floor(sec / 60);
  sec = sec - min * 60;
  return pad(min) + ':' + pad(sec);
};
var _default2 = exports.default = {
  props: {
    sources: [{
      src: ""
    }, {
      src: ""
    }],
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: true,
          volume: 0.9,
          poster: ''
        };
      }
    },
    poster: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      playvideo: "",
      $video: null,
      video: {
        $videoSlider: null,
        len: 0,
        current: 0,
        loaded: 0,
        moving: false,
        displayTime: '00:00',
        pos: {
          start: 0,
          width: 0,
          innerWidth: 0,
          current: 0
        }
      },
      volume: {
        $volBox: null,
        muted: false,
        percent: 60,
        moving: false,
        pos: {
          start: 0,
          width: 0,
          innerWidth: 0,
          current: 0
        }
      },
      player: {
        $player: null,
        pos: null
      },
      tmp: {
        contrlHideTimer: null
      },
      state: {
        contrlShow: true,
        vol: 0.5,
        currentTime: 0,
        fullScreen: false,
        playing: false
      }
    };
  },
  ready: function ready() {
    this.init();
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('mousemove', this.mouseMoveAction);
    document.body.removeEventListener('mouseup', this.mouseUpAction);
  },
  methods: {
    init: function init() {
      var _this = this;
      this.$video = this.$el.getElementsByTagName('video')[0];
      this.initCore();
      if (this.options.autoplay) {
        this.$video.addEventListener('loadedmetadata', function (e) {
          _this.play();
        });
      }
      document.body.addEventListener('mousemove', this.mouseMoveAction, false);
      document.body.addEventListener('mouseup', this.mouseUpAction, false);
    },
    initCore: function initCore() {
      this.initVol();
      this.initVideo();
      this.initPlayer();
      var vol = this.options.volume || 0.9;
      this.setVol(vol);
    },
    initPlayer: function initPlayer() {
      var $player = this.$el.getElementsByClassName('__cov-video-container')[0];
      this.player.pos = $player.getBoundingClientRect();
      this.player.$player = $player;
    },
    initVol: function initVol() {
      var $volBox = this.$el.getElementsByClassName('__cov-contrl-vol-slider')[0];
      var $volInner = $volBox.getElementsByClassName('__cov-contrl-vol-inner')[0];
      this.volume.$volBox = $volBox;
      this.volume.pos.innerWidth = $volInner.getBoundingClientRect().width;
      this.volume.pos.start = $volBox.getBoundingClientRect().left;
      this.volume.pos.width = $volBox.getBoundingClientRect().width - this.volume.pos.innerWidth;
    },
    initVideo: function initVideo() {
      var $videoSlider = this.$el.getElementsByClassName('__cov-contrl-video-slider')[0];
      var $videoInner = $videoSlider.getElementsByClassName('__cov-contrl-video-inner')[0];
      this.$videoSlider = $videoSlider;
      this.video.pos.start = $videoSlider.getBoundingClientRect().left;
      this.video.pos.innerWidth = $videoInner.getBoundingClientRect().width;
      this.video.pos.width = $videoSlider.getBoundingClientRect().width - this.video.pos.innerWidth;
      this.getTime();
    },
    mouseEnterVideo: function mouseEnterVideo() {
      if (this.tmp.contrlHideTimer) {
        clearTimeout(this.tmp.contrlHideTimer);
        this.tmp.contrlHideTimer = null;
      }
      this.state.contrlShow = true;
    },
    mouseLeaveVideo: function mouseLeaveVideo(e) {
      var _this2 = this;
      if (this.tmp.contrlHideTimer) {
        clearTimeout(this.tmp.contrlHideTimer);
      }
      this.tmp.contrlHideTimer = setTimeout(function () {
        _this2.state.contrlShow = false;
        _this2.tmp.contrlHideTimer = null;
      }, 2000);
    },
    toggleContrlShow: function toggleContrlShow() {
      this.state.contrlShow = !this.state.contrlShow;
    },
    getTime: function getTime() {
      var _this3 = this;
      this.$video.addEventListener('durationchange', function (e) {
        //                console.log(e)
      });
      this.$video.addEventListener('progress', function (e) {
        _this3.video.loaded = (-1 + _this3.$video.buffered / _this3.$video.duration) * 100;
      });
      this.video.len = this.$video.duration;
    },
    setVideoByTime: function setVideoByTime(percent) {
      this.$video.currentTime = Math.floor(percent * this.video.len);
    },
    play: function play() {
      this.state.playing = !this.state.playing;
      if (this.$video) {
        if (this.state.playing) {
          this.$video.play();
          this.mouseLeaveVideo();
          this.$video.addEventListener('timeupdate', this.timeline);
          // this.$video.addEventListener('ended', (e) => {
          //   this.state.playing = false
          //   this.video.pos.current = 0
          //   this.$video.currentTime = 0
          //   var data={
          //     "courseId":this.poster.courseId,
          //     "materialId":this.poster.materialId
          //   }
          //   this.$http.post(API_ROOT.system+'/course/study/completeStudyMaterial',data).then(response=>{
          //     var result=response.data
          //     if(result.success){
          //     }
          //   })
          // })
        } else {
          this.$video.pause();
        }
      }
    },
    timeline: function timeline() {
      var percent = this.$video.currentTime / this.$video.duration;
      this.video.pos.current = (this.video.pos.width * percent).toFixed(3);
      this.video.displayTime = timeParse(this.$video.duration - this.$video.currentTime);
    },
    volMove: function volMove(e) {
      this.initVol();
      this.volume.moving = true;
    },
    videoMove: function videoMove(e) {
      this.initVideo();
      this.video.moving = true;
    },
    slideClick: function slideClick(e) {
      this.videoSlideMove(e);
    },
    volSlideClick: function volSlideClick(e) {
      this.volSlideMove(e);
    },
    volMuted: function volMuted() {
      this.$video.muted = !this.$video.muted;
      this.volume.muted = this.$video.muted;
    },
    setVol: function setVol(val) {
      if (this.$video) {
        this.volume.pos.current = val * this.volume.pos.width;
        this.volume.percent = val * 100;
        this.$video.volume = val;
      }
    },
    fullScreen: function fullScreen() {
      if (!this.state.fullScreen) {
        this.state.fullScreen = true;
        this.$video.webkitRequestFullScreen();
      } else {
        this.state.fullScreen = false;
        document.webkitCancelFullScreen();
      }
      setTimeout(this.initVideo, 200);
    },
    mouseMoveAction: function mouseMoveAction(e) {
      if (this.volume.moving) {
        this.volSlideMove(e);
      }
      if (this.video.moving) {
        this.videoSlideMove(e);
      }
      this.contrlHider(e);
    },
    contrlHider: function contrlHider(e) {
      var x = getMousePosition(e, 'x');
      var y = getMousePosition(e, 'y');
      if (!this.player.pos) return;
      if (x > this.player.pos.left && x < this.player.pos.left + this.player.pos.width) {
        if (y > this.player.pos.top + this.player.pos.height * 0.6 && y < this.player.pos.top + this.player.pos.height) {
          return this.mouseEnterVideo();
        }
      }
      return this.mouseLeaveVideo();
    },
    volSlideMove: function volSlideMove(e) {
      var x = getMousePosition(e) - this.volume.pos.start;
      if (x > 0 && x < this.volume.pos.width) {
        this.setVol(x / this.volume.pos.width);
      }
    },
    videoSlideMove: function videoSlideMove(e) {
      var x = getMousePosition(e) - this.video.pos.start;
      if (x > 0 && x < this.video.pos.width) {
        this.video.pos.current = x;
        this.setVideoByTime(x / this.video.pos.width);
      }
    },
    mouseUpAction: function mouseUpAction(e) {
      this.volume.moving = false;
      this.video.moving = false;
    }
  }
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueEsign = _interopRequireDefault(__webpack_require__(1093));
var _iTaojinAppUtil = __webpack_require__(1100);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    vueEsign: _vueEsign.default
  },
  data: function data() {
    return {
      step: 0,
      form: {
        realName: '',
        idcardNo: '',
        phone: '',
        address: '',
        appletUserId: null
      },
      countdown: 0,
      loading: false,
      dialogObj: {
        visible: false
      },
      dealUrl: null,
      type: null
    };
  },
  mounted: function mounted() {
    try {
      window.getToken = this.getToken;
      this.initToken();
    } catch (e) {}
    this.type = this.getUrlParam('type');
    this.getCustomerInfo();
  },
  methods: {
    initToken: function initToken() {
      var result = _iTaojinAppUtil.iTaojinAppUtil.callNativeFun('getNativeToken');
      if (result.data != null) {
        document.cookie = 'login_token=' + result.data + ';';
      }
    },
    //ios调用传入token
    getToken: function getToken(token) {
      document.cookie = 'login_token=' + token + ';';
    },
    getUrlParam: function getUrlParam(name) {
      var reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)");
      var r = (window.location.search || window.location.hash).match(reg);
      if (r != null) return r[2];
      return null;
    },
    getCustomerInfo: function getCustomerInfo() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/gzhArticalSign/queryByTjkId?type=' + this.type).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.form = result.data || {};
          _this.dealUrl = result.data.dealUrl;
          _this.step = _this.dealUrl ? 2 : 0;
        } else {
          _this.$alert(result.message || result.msg);
        }
      }, function (err) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    nextStep: function nextStep() {
      var _this2 = this;
      if (!this.form.idcardNo) {
        this.$alert('无实名认证信息！');
        return;
      }
      this.$refs.formRef.validate(function (valid) {
        if (!valid) {
          return;
        }
        _this2.step += 1;
        _this2.countdown = 10;
        _this2.interval && clearInterval(_this2.interval);
        _this2.interval = setInterval(function () {
          _this2.countdown -= 1;
          if (_this2.countdown <= 0) {
            clearInterval(_this2.interval);
          }
        }, 1000);
      });
    },
    handleReset: function handleReset() {
      this.$refs.esign.reset();
    },
    signContract: function signContract() {
      var _this$$refs$esign;
      (_this$$refs$esign = this.$refs.esign) === null || _this$$refs$esign === void 0 || _this$$refs$esign.reset();
      this.dialogObj.visible = true;
      this.loading = false;
    },
    submitFun: function submitFun() {
      var _this3 = this;
      this.loading = true;
      this.$refs.esign.generate({
        format: "png",
        quality: 0.8
      }).then(function (res) {
        var blob = _this3.dataURLtoBlob(res);
        var file = _this3.blobToFile(blob, '签名.png');
        _this3.customUpload(file).then(function (imgUrl) {
          var data = {
            signUrl: imgUrl,
            address: _this3.form.address,
            appletUserId: _this3.form.appletUserId,
            realName: _this3.form.realName,
            idcardNo: _this3.form.idcardNo,
            phone: _this3.form.phone,
            type: _this3.type
          };
          _this3.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/gzhArticalSign/addSign', data).then(function (response) {
            var result = response.data;
            _this3.loading = false;
            if (result.success) {
              _this3.dialogObj.visible = false;
              _this3.$message.success('签约成功');
              _this3.getCustomerInfo();
            } else {
              _this3.$alert(result.message || result.msg);
            }
          }, function (err) {
            _this3.loading = false;
            _this3.$alert('网络繁忙，请稍后重试！');
          });
        }, function () {
          _this3.loading = false;
        });
      }).catch(function (err) {
        _this3.loading = false;
        _this3.$alert("生成图片失败：" + err.message);
      });
    },
    dataURLtoBlob: function dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    blobToFile: function blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    getQiniuConfig: function getQiniuConfig(file) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var fileName = file.name;
        var data = {
          ext: fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length)
        };
        _this4.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.method + '/qiniu/token', data).then(function (res) {
          var res = res.data;
          if (res.success) {
            resolve(res.data);
          } else {
            _this4.$alert('上传图片失败!', '警告');
            reject();
          }
        }, function (err) {
          _this4.$alert('上传图片失败!', '警告');
          reject();
        });
      });
    },
    customUpload: function customUpload(file) {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        _this5.getQiniuConfig(file).then(function (config) {
          var formdata = new FormData();
          formdata.append('file', file);
          formdata.append('token', config.token);
          formdata.append('key', config.key);
          _this5.$http.post('//upload-z0.qiniup.com', formdata, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (res) {
            resolve(config.domain + '/' + res.data.key);
          }, function (err) {
            _this5.$alert('上传图片失败!', '警告');
            reject();
          });
        }, function (err) {
          reject();
        });
      });
    }
  }
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(460));
//
//
//
//
//
var _default = exports.default = {
  props: {
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 300
    },
    lineWidth: {
      type: Number,
      default: 4
    },
    lineColor: {
      type: String,
      default: '#000000'
    },
    bgColor: {
      type: String,
      default: ''
    },
    isCrop: {
      type: Boolean,
      default: false
    },
    isClearBgColor: {
      type: Boolean,
      default: true
    },
    format: {
      type: String,
      default: 'image/png'
    },
    quality: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      hasDrew: false,
      resultImg: '',
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      isDrawing: false,
      sratio: 1
    };
  },
  computed: {
    ratio: function ratio() {
      return this.height / this.width;
    },
    stageInfo: function stageInfo() {
      return this.$refs.canvas.getBoundingClientRect();
    },
    myBg: function myBg() {
      return this.bgColor ? this.bgColor : 'rgba(255, 255, 255, 0)';
    }
  },
  watch: {
    'myBg': function myBg(newVal) {
      this.$refs.canvas.style.background = newVal;
    }
  },
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  mounted: function mounted() {
    var _this = this;
    var canvas = this.$refs.canvas;
    canvas.height = this.height;
    canvas.width = this.width;
    canvas.style.background = this.myBg;
    this.$_resizeHandler();
    // 在画板以外松开鼠标后冻结画笔
    document.onmouseup = function () {
      _this.isDrawing = false;
    };
  },
  methods: {
    $_resizeHandler: function $_resizeHandler() {
      var canvas = this.$refs.canvas;
      canvas.style.width = this.width + "px";
      var realw = parseFloat(window.getComputedStyle(canvas).width);
      canvas.style.height = this.ratio * realw + "px";
      this.canvasTxt = canvas.getContext('2d');
      this.canvasTxt.scale(1 * this.sratio, 1 * this.sratio);
      this.sratio = realw / this.width;
      this.canvasTxt.scale(1 / this.sratio, 1 / this.sratio);
    },
    // pc
    mouseDown: function mouseDown(e) {
      e = e || event;
      e.preventDefault();
      this.isDrawing = true;
      this.hasDrew = true;
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawStart(obj);
    },
    mouseMove: function mouseMove(e) {
      e = e || event;
      e.preventDefault();
      if (this.isDrawing) {
        var obj = {
          x: e.offsetX,
          y: e.offsetY
        };
        this.drawMove(obj);
      }
    },
    mouseUp: function mouseUp(e) {
      e = e || event;
      e.preventDefault();
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawEnd(obj);
      this.isDrawing = false;
    },
    // mobile
    touchStart: function touchStart(e) {
      e = e || event;
      e.preventDefault();
      this.hasDrew = true;
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawStart(obj);
      }
    },
    touchMove: function touchMove(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawMove(obj);
      }
    },
    touchEnd: function touchEnd(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawEnd(obj);
      }
    },
    // 绘制
    drawStart: function drawStart(obj) {
      this.startX = obj.x;
      this.startY = obj.y;
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
    },
    drawMove: function drawMove(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.strokeStyle = this.lineColor;
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.startY = obj.y;
      this.startX = obj.x;
      this.points.push(obj);
    },
    drawEnd: function drawEnd(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
      this.points.push({
        x: -1,
        y: -1
      });
    },
    // 操作
    generate: function generate(options) {
      var _this2 = this;
      var imgFormat = options && options.format ? options.format : this.format;
      var imgQuality = options && options.quality ? options.quality : this.quality;
      var pm = new Promise(function (resolve, reject) {
        if (!_this2.hasDrew) {
          reject("Warning: Not Signned!");
          return;
        }
        var resImgData = _this2.canvasTxt.getImageData(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.globalCompositeOperation = "destination-over";
        _this2.canvasTxt.fillStyle = _this2.myBg;
        _this2.canvasTxt.fillRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.resultImg = _this2.$refs.canvas.toDataURL(imgFormat, imgQuality);
        var resultImg = _this2.resultImg;
        _this2.canvasTxt.clearRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.putImageData(resImgData, 0, 0);
        _this2.canvasTxt.globalCompositeOperation = "source-over";
        if (_this2.isCrop) {
          var _this2$canvasTxt;
          var crop_area = _this2.getCropArea(resImgData.data);
          var crop_canvas = document.createElement('canvas');
          var crop_ctx = crop_canvas.getContext('2d');
          crop_canvas.width = crop_area[2] - crop_area[0];
          crop_canvas.height = crop_area[3] - crop_area[1];
          var crop_imgData = (_this2$canvasTxt = _this2.canvasTxt).getImageData.apply(_this2$canvasTxt, (0, _toConsumableArray2.default)(crop_area));
          crop_ctx.globalCompositeOperation = "destination-over";
          crop_ctx.putImageData(crop_imgData, 0, 0);
          crop_ctx.fillStyle = _this2.myBg;
          crop_ctx.fillRect(0, 0, crop_canvas.width, crop_canvas.height);
          resultImg = crop_canvas.toDataURL(imgFormat, imgQuality);
          crop_canvas = null;
        }
        resolve(resultImg);
      });
      return pm;
    },
    reset: function reset() {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      if (this.isClearBgColor) {
        this.$emit('update:bgColor', '');
        this.$refs.canvas.style.background = 'rgba(255, 255, 255, 0)';
      }
      this.points = [];
      this.hasDrew = false;
      this.resultImg = '';
    },
    getCropArea: function getCropArea(imgData) {
      var topX = this.$refs.canvas.width;
      var btmX = 0;
      var topY = this.$refs.canvas.height;
      var btnY = 0;
      for (var i = 0; i < this.$refs.canvas.width; i++) {
        for (var j = 0; j < this.$refs.canvas.height; j++) {
          var pos = (i + this.$refs.canvas.width * j) * 4;
          if (imgData[pos] > 0 || imgData[pos + 1] > 0 || imgData[pos + 2] || imgData[pos + 3] > 0) {
            btnY = Math.max(j, btnY);
            btmX = Math.max(i, btmX);
            topY = Math.min(j, topY);
            topX = Math.min(i, topX);
          }
        }
      }
      topX++;
      btmX++;
      topY++;
      btnY++;
      var data = [topX, topY, btmX, btnY];
      return data;
    }
  }
};

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _play = _interopRequireDefault(__webpack_require__(537));
var _pdf = _interopRequireDefault(__webpack_require__(538));
var _word = _interopRequireDefault(__webpack_require__(1105));
var _PPT = _interopRequireDefault(__webpack_require__(1106));
var _pagination = _interopRequireDefault(__webpack_require__(104));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      "id": this.$route.params.id,
      //courseId
      "categoryId": '',
      "materialId": '',
      "materialList": '',
      //课件列表
      "completeMaterialList": '',
      //课件列表
      "info": '',
      "keys": 0,
      "nextStudyMaterial": '',
      //下一个学习的课件
      'success': true,
      'courseDetail': {},
      "img": [{
        src: _play.default
      }, {
        src: _pdf.default
      }]
    };
  },
  mounted: function mounted() {
    this.MaterialList();
    this.CourseDetail();
    this.StudyInfo();
  },
  methods: {
    //学习课程记录
    GetArgsFromHref: function GetArgsFromHref(sArgName) {
      var sHref = window.location.href;
      var args = sHref.split("?");
      var retval = "";
      if (args[0] == sHref) {
        return retval;
      }
      var str = args[1];
      args = str.split("&");
      for (var i = 0; i < args.length; i++) {
        str = args[i];
        var arg = str.split("=");
        if (arg.length <= 1) continue;
        if (arg[0] == sArgName) retval = arg[1];
      }
      return retval;
    },
    //获取url参数
    StudyInfo: function StudyInfo() {
      var _this = this;
      var data = {
        "courseId": this.id,
        size: 20
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryUserStudyInfo', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.info = result.data;
          _this.keys = _this.info.length;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //排行榜接口
    studyCourse: function studyCourse(numb, courseId, courseName) {
      var isCompletCourse = true;
      for (var i = 0; i < this.materialList.length; i++) {
        if (!this.materialList[i].isDone) {
          isCompletCourse = false;
          break;
        }
      }
      // if(isCompletCourse){
      //   this.$http.post(API_ROOT.system+'/course/study/completeStudyCourse',{ "courseId":this.id}).then(response=>{
      //     var result=response.data
      //     if(result.success){
      //     }else{
      //       alert(result.msg)
      //     }
      //   },response=>{
      //     alert("网络繁忙，请稍后重试！")
      //   })
      // }
      this.$router.push({
        path: '/course?materialId=' + numb + "&&courseId=" + courseId + "&&courseName=" + courseName
      });
      // var data={
      //   "courseId":this.id
      // }
      // this.$http.post(API_ROOT.system+"/course/study/startStudyCourse",data).then(response=>{
      //   var result= response.data
      //   if(result.success){
      //   }else{
      //     alert(result.msg)
      //   }
      // },response=>{
      //   alert("网络繁忙，请稍后重试！")
      // })
    },
    startStudyCourse: function startStudyCourse() {
      for (var i = 0; i < this.materialList.length; i++) {
        if (this.materialList[i].materialId == this.nextStudyMaterial) {
          this.studyCourse(this.nextStudyMaterial, this.courseDetail.courseId, this.courseDetail.courseName);
          break;
        }
      }
    },
    //开始课程学习

    queryUserMaterial: function queryUserMaterial(materialListParam) {
      var _this2 = this;
      var data = {
        "courseId": this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryUserMaterial', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          var completeMaterialMap = {};
          for (var i = 0; i < result.data.length; i++) {
            if (result.data[i].isDone == "yes") {
              completeMaterialMap[result.data[i].materialId] = result.data[i];
            }
          }
          _this2.completeMaterialList = result.data;
          for (var n = 0; n < materialListParam.length; n++) {
            if (completeMaterialMap[materialListParam[n].materialId]) {
              materialListParam[n].isDone = 'yes';
            }
            if (_this2.nextStudyMaterial == '' && !completeMaterialMap[materialListParam[n].materialId]) {
              _this2.nextStudyMaterial = materialListParam[n].materialId;
            }
          }
          if (_this2.nextStudyMaterial == '') {
            _this2.nextStudyMaterial = materialListParam[0].materialId;
          }
          _this2.materialList = materialListParam;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert("网络繁忙，请稍后重试！");
      });
    },
    //学习课程课件记录信息

    CourseDetail: function CourseDetail() {
      var _this3 = this;
      var data = {
        "courseId": this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryCourseDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.courseDetail = result.data;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //课程详细信息
    MaterialList: function MaterialList() {
      var _this4 = this;
      var data = {
        "courseId": this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryMaterialList', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          for (var i = 0; i < result.data.length; i++) {
            if (result.data[i].resourceType == 'mp4') {
              result.data[i].resTypeUrl = _this4.img[0].src;
            } else if (result.data[i].resourceType == 'pdf') {
              result.data[i].resTypeUrl = _this4.img[1].src;
            }
          }
          if (result.data && result.data.length > 0) {
            _this4.queryUserMaterial(result.data);
          }
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert("网络异常，请稍后重试！");
      });
    },
    //课件信息列表
    formatSeconds: function formatSeconds(value) {
      var result = '';
      var days = parseInt(value / (60 * 60 * 24));
      var hours = parseInt(value % (60 * 60 * 24) / (60 * 60));
      if (hours > 0) {
        hours = hours < 9 ? '0' + hours : hours;
        result += hours + ':';
      }
      var minutes = parseInt(value % (60 * 60) / 60);
      if (minutes > 0) {
        minutes = minutes < 9 ? '0' + minutes : minutes;
        result += minutes + ':';
      }
      var seconds = value % 60;
      if (seconds > 0) {
        seconds = seconds < 9 ? '0' + seconds : seconds;
        result += seconds;
      }
      return result;
    },
    //设置封面图片
    style: function style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      };
    }
  }
};

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAt0lEQVQ4jd3RPWoCQQCA0bcasLDQzhPYCUIqKysRb+ABBH/IgQIWKXKElIJgYZMqla29NhbaihZZYQmbXTeZIuRrZoaBN8xMNNu913EQqFIo6P+A+5DgHA20sAwBLuJxgx5GOP0GPH9Zv6CN9U/BtLboYoJjCBAuPt93EAq8VQkFlvCEt7TNh4JYE6/oZJ32XeXEPMIUH1lYHtiPx0es8IxqFkb2lccYopaHJMv7lELYPWDh/j54BWLCFiZWfEFCAAAAAElFTkSuQmCC"

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAABBUlEQVQ4ja3UvyuFcRTH8dfVU2zuQAbbzWDSlUx3UBZkMpht6tLdlYkyGKRkYpHJYDGZZBGb1J38AcokGZCE4fv40ePhPvL91LdT3855d87n1CmdVCoLGBdH+wn6MRIJeNEWCfShosBjPMYCruMQG7GATSziLhZwAHtpbKmkQM40BnFZBFikw1504TkW8AgTmMfLf4Gv2MQKJjGDW9z/VNDKw7U0zgkjX6EHU7hBFaso/QZ8wjZ20I0lDPmcZhbXOEADp6i9F2dHfhAORQfK2MVwJm9L8HQs7bj6FZDt8AydwiKWhe3mqZ6+b8oCR9GOPsGrPyvPw1rOX2FFP18JzoUFxFDzDZAnKYTUQeL1AAAAAElFTkSuQmCC"

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'pagination',
  data: function data() {
    return {};
  },
  props: ['pages', 'pageNum'],
  computed: {
    prePage: function prePage() {
      return this.pageNum !== 1 && this.pages;
    },
    nextPage: function nextPage() {
      return this.pageNum < this.pages && this.pages;
    },
    showPageBtn: function showPageBtn() {
      var arr = [];
      if (this.pages <= 5) {
        for (var i = 1; i <= this.pages; i++) {
          arr.push(i);
        }
        return arr;
      }
      if (this.pageNum <= 2) return [1, 2, 3, 0, this.pages];
      if (this.pageNum >= this.pages - 1) return [1, 0, this.pages - 2, this.pages - 1, this.pages];
      if (this.pageNum === 3) return [1, 2, 3, 4, 0, this.pages];
      if (this.pageNum === this.pages - 2) return [1, 0, this.pages - 3, this.pages - 2, this.pages - 1, this.pages];
      return [1, 0, this.pageNum - 1, this.pageNum, this.pageNum + 1, 0, this.pages];
    }
  },
  methods: {
    goPrePage: function goPrePage() {
      this.$emit('getData', this.pageNum - 1);
    },
    pageOffset: function pageOffset(i) {
      this.$emit('getData', i);
    },
    goNextPage: function goNextPage() {
      this.$emit('getData', this.pageNum + 1);
    }
  }
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _video = _interopRequireDefault(__webpack_require__(530));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
var _play = _interopRequireDefault(__webpack_require__(537));
var _pdf = _interopRequireDefault(__webpack_require__(538));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      "materialId": '',
      "courseId": '',
      "courseName": '',
      "List": '',
      "test": '',
      "poster": '',
      "id": this.$route.params.id,
      "ids": this.$route.params.ids,
      "img": [{
        src: _play.default
      }, {
        src: _pdf.default
      }]
    };
  },
  mounted: function mounted() {
    this.MaterialDetail();
    this.MaterialList();
    this.$nextTick(function () {
      this.MaterialList();
    });
  },
  components: {
    component1: _video.default
  },
  methods: {
    GetArgsFromHref: function GetArgsFromHref(sArgName) {
      var sHref = window.location.href;
      var args = sHref.split("?");
      var retval = "";
      if (args[0] == sHref) /*参数为空*/
        {
          return retval;
          /*无需做任何处理*/
        }
      var str = args[1];
      args = str.split("&");
      for (var i = 0; i < args.length; i++) {
        str = args[i];
        var arg = str.split("=");
        if (arg.length <= 1) continue;
        if (arg[0] == sArgName) retval = arg[1];
      }
      return retval;
    },
    //获取参数
    MaterialDetail: function MaterialDetail(materialId) {
      var _this = this;
      var courseName = decodeURI(this.GetArgsFromHref("courseName"));
      this.courseName = decodeURI(courseName);
      this.materialId = materialId;
      var data = {
        "materialId": materialId ? this.materialId : this.GetArgsFromHref("materialId")
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryMaterialDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.test = result.data;
          _this.poster = _this.test.resourceUrl;
          $("#component").hide();
          $("#pdf_viewer").hide();
          if (_this.test.resourceType == 'mp4') {
            $("#component").show();
            $("#pdf_viewer").hide();
          } else {
            $("#component").hide();
            $("#pdf_viewer").show();
            var options = {
              pdfOpenParams: {
                navpanes: 0,
                toolbar: 0,
                statusbar: 0,
                view: "FitV",
                pagemode: "thumbs",
                page: 1
              },
              forcePDFJS: true,
              PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
            };
            if (_pdfobject.default.supportsPDFs) {
              _pdfobject.default.embed(_this.poster, "#pdf_viewer", options);
            } else {
              location.href = "/resume/canvas";
            }
          }
          var datas = {
            "materialId": materialId ? _this.materialId : _this.GetArgsFromHref("materialId"),
            "courseId": _this.GetArgsFromHref("courseId")
          };
          _this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/completeStudyMaterial', datas).then(function (response) {
            var result = response.data;
            if (result.success) {
              // this.queryUserMaterial()
            } else {
              alert(result.msg);
            }
          }, function (response) {
            alert("网络繁忙，请稍后重试！");
          });
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert("网络异常，稍后重试！");
      });
    },
    //课件详细信息
    // queryUserMaterial:function(){
    //   var data ={
    //     "courseId":this.GetArgsFromHref("courseId")
    //     };
    //   this.$http.post(API_ROOT.system+'/course/study/queryUserMaterial',data).then(response=>{
    //     var result= response.data
    //     if(result.success){
    //       if(result.data.length == this.List.length){
    //         this.$http.post(API_ROOT.system+'/course/study/completeStudyCourse',data).then(response=>{
    //           var result=response.data
    //           if(result.success){
    //           }else{
    //             alert(result.msg)
    //           }
    //         },response=>{
    //           alert("网络繁忙，请稍后重试！")
    //         })
    //       }
    //     }else{
    //       alert(result.msg)
    //     }
    //   },response=>{
    //     alert("网络繁忙，请稍后重试！")
    //   })
    // },//课程记录信息
    MaterialList: function MaterialList() {
      var _this2 = this;
      this.courseId = this.GetArgsFromHref("courseId");
      var data = {
        "courseId": this.GetArgsFromHref("courseId")
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/course/study/queryMaterialList', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          for (var i = 0; i < result.data.length; i++) {
            if (result.data[i].resourceType == 'mp4') {
              $(".resType").eq(i).attr('src', _this2.img[0].src);
            } else if (result.data[i].resourceType == 'pdf') {
              $(".resType").eq(i).attr('src', _this2.img[1].src);
            }
          }
          _this2.List = result.data;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert("网络异常，请稍后重试！");
      });
    },
    //课件信息列表
    formatSeconds: function formatSeconds(value) {
      var result = '';
      var days = parseInt(value / (60 * 60 * 24));
      var hours = parseInt(value % (60 * 60 * 24) / (60 * 60));
      if (hours > 0) {
        hours = hours < 9 ? '0' + hours : hours;
        result += hours + ':';
      }
      var minutes = parseInt(value % (60 * 60) / 60);
      if (minutes > 0) {
        minutes = minutes < 9 ? '0' + minutes : minutes;
        result += minutes + ':';
      }
      var seconds = value % 60;
      if (seconds > 0) {
        seconds = seconds < 9 ? '0' + seconds : seconds;
        result += seconds;
      }
      return result;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'examList',
  data: function data() {
    return {
      'success': true,
      'message': '',
      'pageNum': 1,
      'pageSize': 12,
      'pages': 1,
      'examTypeList': [{
        value: 'Formal',
        label: '正式考试'
      }, {
        value: 'Practice',
        label: '模拟练习'
      }],
      'examType': '',
      'categoryId': '',
      'categorylist': [],
      'examlist': []
    };
  },
  mounted: function mounted() {
    this.getCategory();
    this.getList(1);
  },
  methods: {
    //查询考试分类
    getCategory: function getCategory() {
      var _this = this;
      var data = {
        'parentId': -1
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/exam/category/queryByParentId', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          _this.categorylist = result.data;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    queryListByType: function queryListByType(examType, key) {
      var _this2 = this;
      $('#type').find('li').eq(key).addClass('active');
      $('#type').find('li').eq(key).siblings().removeClass('active');
      this.examType = examType;
      this.pageNum = 1;
      var data = {
        'examType': this.examType,
        'parentCategoryId': this.categoryId,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/search', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.success = result.success;
          _this2.message = result.msg;
          _this2.pageNum = result.data.pageNum == 0 ? 1 : result.data.pageNum;
          _this2.pages = result.data.pages == 0 ? 1 : result.data.pages;
          _this2.examlist = result.data.list != null ? result.data.list : [];
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    queryListByCategory: function queryListByCategory(categoryId, key) {
      var _this3 = this;
      $('#category').find('li').eq(key).addClass('active');
      $('#category').find('li').eq(key).siblings().removeClass('active');
      this.categoryId = categoryId;
      this.pageNum = 1;
      var data = {
        'examType': this.examType,
        'parentCategoryId': this.categoryId,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/search', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.success = result.success;
          _this3.message = result.msg;
          _this3.pageNum = result.data.pageNum == 0 ? 1 : result.data.pageNum;
          _this3.pages = result.data.pages == 0 ? 1 : result.data.pages;
          _this3.examlist = result.data.list != null ? result.data.list : [];
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    getList: function getList(num) {
      var _this4 = this;
      var data = {
        'examType': this.examType,
        'parentCategoryId': this.categoryId,
        'pageNum': num,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/search', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.success = result.success;
          _this4.message = result.msg;
          _this4.pageNum = result.data.pageNum;
          _this4.pages = result.data.pages;
          _this4.examlist = result.data.list != null ? result.data.list : [];
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //设置图片
    style: function style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      };
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zoomImg = _interopRequireDefault(__webpack_require__(300));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      //examConfigId
      'data': {},
      'paperQuestion': [],
      'examRecordId': '',
      'endTime': '',
      'time': '',
      'showImg': false,
      'imgSrc': '',
      'num': [],
      'savelist': [],
      'list': [] //保存时的结果集转换的一维数组，用作答题卡
    };
  },
  components: {
    'zoom-img': _zoomImg.default
  },
  mounted: function mounted() {
    this.getExam();
  },
  watch: {
    paperQuestion: function paperQuestion() {
      for (var i = 0; i < this.paperQuestion.length; i++) {
        var xti = [];
        var numlength = parseInt(this.num.length);
        for (var j = 0; j < this.paperQuestion[i].questionDetailList.length; j++) {
          this.num.push(j);
          if (this.paperQuestion[i].questionDetailList[j].questionType == 'SingleChoice' || this.paperQuestion[i].questionDetailList[j].questionType == 'TrueOrFalse' || this.paperQuestion[i].questionDetailList[j].questionType == 'ShortAnswer') {
            var temp = {
              'num': numlength + j + 1,
              'examRecordId': this.paperQuestion[i].questionDetailList[j].examRecordId,
              'sequence': this.paperQuestion[i].questionDetailList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionDetailList[j].tjkAnswer != null ? this.paperQuestion[i].questionDetailList[j].tjkAnswer : ''
            };
          } else {
            var temp = {
              'num': numlength + j + 1,
              'examRecordId': this.paperQuestion[i].examRecordId,
              'sequence': this.paperQuestion[i].questionDetailList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionDetailList[j].tjkAnswer != null ? this.paperQuestion[i].questionDetailList[j].tjkAnswer : []
            };
          }
          xti.push(temp);
        }
        this.savelist.push(xti);
      }
      this.list = [].concat.apply([], this.savelist);
    }
  },
  methods: {
    replaceNToBr: function replaceNToBr(str) {
      var reg = new RegExp("\n", "g");
      return str.replace(reg, "<br/>");
    },
    getExam: function getExam() {
      var _this = this;
      var data = {
        'examConfigId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/startExam', data).then(function (response) {
        var result = response.data;
        _this.success = result.success;
        _this.message = result.msg;
        if (result.success) {
          _this.data = result.data;
          _this.paperQuestion = result.data.paperQuestion;
          _this.examRecordId = result.data.examRecordId;
          if (_this.endTime == '') _this.endTime = result.data.examRemainingTime;
          _this.countdown(_this.endTime);
        } else {
          alert(result.msg);
          window.location.href = '/tjkStudy/examlist';
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    countdown: function countdown(endTime) {
      var self = this;
      var timer = setInterval(function () {
        endTime--;
        if (endTime >= 0) {
          var sec = parseInt(endTime);
          var min = 0;
          var hour = 0;
          if (sec > 60) {
            min = parseInt(sec / 60);
            sec = parseInt(sec % 60);
            if (min > 60) {
              hour = parseInt(min / 60);
              min = parseInt(min % 60);
            }
          }
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (hour > 0) {
            self.time = "".concat(hour, ":").concat(min, ":").concat(sec);
          } else {
            self.time = "".concat(min, ":").concat(sec);
          }
          if (endTime == 300) {
            self.open();
          }
        } else {
          clearInterval(timer);
          self.time = '时间到';
          self.submitExamNoconfirm();
        }
      }, 1000);
    },
    //考试时间提示框
    open: function open() {
      var h = this.$createElement;
      this.$notify({
        title: '',
        message: h('i', {
          style: 'color: red'
        }, '离自动交卷还有5分钟，请注意答题时间'),
        duration: 5000
      });
    },
    //提交考试前保存——自动提交
    submitExamNoconfirm: function submitExamNoconfirm() {
      var _this2 = this;
      var arry = JSON.parse(JSON.stringify(this.list));
      for (var i = 0; i < arry.length; i++) {
        if (typeof arry[i].tjkAnswerString != 'string') {
          for (var j = 0; j < arry[i].tjkAnswerString.length; j++) {
            var reg = /^[A-Za-z]+$/;
            if (arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = '';
            if (reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase();
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString);
        }
      }
      var data = {
        'tjkAnswerDetailList': arry
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitTjkAnswer', data).then(function (response) {
        var result = response.data;
        _this2.success = result.success;
        _this2.message = result.msg;
        if (result.success) {
          _this2.submitExamFun();
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //提交考试前保存——手动提交
    submitExam: function submitExam() {
      var _this3 = this;
      var arry = JSON.parse(JSON.stringify(this.list));
      for (var i = 0; i < arry.length; i++) {
        if (typeof arry[i].tjkAnswerString != 'string') {
          for (var j = 0; j < arry[i].tjkAnswerString.length; j++) {
            var reg = /^[A-Za-z]+$/;
            if (arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = '';
            if (reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase();
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString);
        }
      }
      var data = {
        'tjkAnswerDetailList': arry
      };
      if (confirm("您确定要提交考试吗？")) {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitTjkAnswer', data).then(function (response) {
          var result = response.data;
          _this3.success = result.success;
          _this3.message = result.msg;
          if (result.success) {
            _this3.submitExamFun();
          } else {
            alert(result.msg);
          }
        }, function (response) {
          alert('网络繁忙，请稍后重试！');
        });
      }
    },
    //提交考试
    submitExamFun: function submitExamFun() {
      var _this4 = this;
      var data = {
        'examRecordId': this.examRecordId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitNormalExam', data).then(function (response) {
        var result = response.data;
        _this4.success = result.success;
        _this4.message = result.msg;
        if (result.success) {
          _this4.$message({
            message: '已提交',
            type: 'success',
            center: true,
            duration: 1000
          });
          window.location.href = '/tjkStudy/examResult/' + _this4.examRecordId;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //保存考试
    saveExam: function saveExam() {
      var _this5 = this;
      var arry = JSON.parse(JSON.stringify(this.list));
      for (var i = 0; i < arry.length; i++) {
        if (typeof arry[i].tjkAnswerString != 'string') {
          for (var j = 0; j < arry[i].tjkAnswerString.length; j++) {
            var reg = /^[A-Za-z]+$/;
            if (arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = '';
            if (reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase();
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString);
        }
      }
      var data = {
        'tjkAnswerDetailList': arry
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitTjkAnswer', data).then(function (response) {
        var result = response.data;
        _this5.success = result.success;
        _this5.message = result.msg;
        if (result.success) {
          _this5.$message({
            message: '已保存',
            type: 'success',
            center: true,
            duration: 1000
          });
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //获取大题分类序号
    getNum: function getNum(key) {
      var arry = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];
      for (var i = 0; i < arry.length; i++) {
        if (i == key) {
          return arry[i];
          break;
        }
      }
    },
    //判断是否显示已答题样式
    getClass: function getClass(string) {
      if (typeof string == 'boolean') {
        return true;
      } else if (string instanceof Array) {
        for (var i = 0; i < string.length; i++) {
          if (string[i] != '') {
            return true;
            break;
          }
        }
      } else if (string != '') {
        return true;
      } else {
        return false;
      }
    },
    clickImg: function clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg: function viewImg() {
      this.showImg = false;
    }
  }
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['imgSrc'],
  methods: {
    bigImg: function bigImg() {
      // 发送事件
      this.$emit('clickit');
      console.log(1);
    }
  }
};

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _zoomImg = _interopRequireDefault(__webpack_require__(300));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      //examConfigId
      'trainId': this.$route.params.trainId,
      'data': {},
      'paperQuestion': [],
      'examRecordId': '',
      'endTime': '',
      'time': '',
      'showImg': false,
      'imgSrc': '',
      'num': [],
      'savelist': [],
      'list': [] //保存时的结果集转换的一维数组，用作答题卡
    };
  },
  components: {
    'zoom-img': _zoomImg.default
  },
  created: function created() {
    // this.firstStep();
  },
  mounted: function mounted() {
    this.queryTrainJoinedTjk();
    // this.getExam()
  },
  watch: {
    paperQuestion: function paperQuestion() {
      for (var i = 0; i < this.paperQuestion.length; i++) {
        var xti = [];
        var numlength = parseInt(this.num.length);
        for (var j = 0; j < this.paperQuestion[i].questionDetailList.length; j++) {
          this.num.push(j);
          if (this.paperQuestion[i].questionDetailList[j].questionType == 'SingleChoice' || this.paperQuestion[i].questionDetailList[j].questionType == 'TrueOrFalse' || this.paperQuestion[i].questionDetailList[j].questionType == 'ShortAnswer') {
            var temp = {
              'num': numlength + j + 1,
              'examRecordId': this.paperQuestion[i].questionDetailList[j].examRecordId,
              'sequence': this.paperQuestion[i].questionDetailList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionDetailList[j].tjkAnswer != null ? this.paperQuestion[i].questionDetailList[j].tjkAnswer : ''
            };
          } else {
            var temp = {
              'num': numlength + j + 1,
              'examRecordId': this.paperQuestion[i].examRecordId,
              'sequence': this.paperQuestion[i].questionDetailList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionDetailList[j].tjkAnswer != null ? this.paperQuestion[i].questionDetailList[j].tjkAnswer : []
            };
          }
          xti.push(temp);
        }
        this.savelist.push(xti);
      }
      this.list = [].concat.apply([], this.savelist);
    }
  },
  methods: {
    firstStep: function firstStep() {
      var data = {
        examConfigId: this.$route.params.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/startExam', data);
    },
    searchExamOnce: function searchExamOnce() {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var data, response;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                pageNum: 1,
                pageSize: 10,
                examConfigId: _this.$route.params.id
              };
              _context.next = 1;
              return _this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/examRecord/searchExamOnce', data);
            case 1:
              response = _context.sent;
              if (response.data.success) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(response.data.success && response.data.data === true)) {
                _context.next = 3;
                break;
              }
              alert('您已经提交了考试');
              window.location.href = '/tjkStudy/examDetailTemp/' + _this.$route.params.id;
              return _context.abrupt("return");
            case 3:
              _this.getExam();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryTrainJoinedTjk: function queryTrainJoinedTjk() {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var data, response, list;
        return _regenerator.default.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                pageNum: 1,
                pageSize: 10,
                simpleQuery: 'Yes',
                transTokenToTjkId: 'Yes',
                trainId: _this2.$route.params.trainId
              };
              _context2.next = 1;
              return _this2.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/taojinCollege/queryTrainJoinedTjk', data);
            case 1:
              response = _context2.sent;
              if (response.data.success) {
                _context2.next = 2;
                break;
              }
              _this2.$message.error(response.data.msg);
              return _context2.abrupt("return");
            case 2:
              list = response.data.data.list;
              if (!(list && list.length === 0)) {
                _context2.next = 3;
                break;
              }
              _this2.$message.error('你尚未报名考试或培训未开始，无法查看考试内容');
              return _context2.abrupt("return");
            case 3:
              _this2.searchExamOnce();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    replaceNToBr: function replaceNToBr(str) {
      var reg = new RegExp("\n", "g");
      return str.replace(reg, "<br/>");
    },
    getExam: function getExam() {
      var _this3 = this;
      var data = {
        'examConfigId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/startExam', data).then(function (response) {
        var result = response.data;
        _this3.success = result.success;
        _this3.message = result.msg;
        if (result.success) {
          _this3.data = result.data;
          _this3.paperQuestion = result.data.paperQuestion;
          _this3.examRecordId = result.data.examRecordId;
          if (_this3.endTime == '') _this3.endTime = result.data.examRemainingTime;
          _this3.countdown(_this3.endTime);
        } else {
          alert(result.msg);
          window.location.href = '/tjkStudy/examlist';
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    countdown: function countdown(endTime) {
      var self = this;
      var timer = setInterval(function () {
        endTime--;
        if (endTime >= 0) {
          var sec = parseInt(endTime);
          var min = 0;
          var hour = 0;
          if (sec > 60) {
            min = parseInt(sec / 60);
            sec = parseInt(sec % 60);
            if (min > 60) {
              hour = parseInt(min / 60);
              min = parseInt(min % 60);
            }
          }
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (hour > 0) {
            self.time = "".concat(hour, ":").concat(min, ":").concat(sec);
          } else {
            self.time = "".concat(min, ":").concat(sec);
          }
          if (endTime == 300) {
            self.open();
          }
        } else {
          clearInterval(timer);
          self.time = '时间到';
          self.submitExamNoconfirm();
        }
      }, 1000);
    },
    //考试时间提示框
    open: function open() {
      var h = this.$createElement;
      this.$notify({
        title: '',
        message: h('i', {
          style: 'color: red'
        }, '离自动交卷还有5分钟，请注意答题时间'),
        duration: 5000
      });
    },
    //提交考试前保存——自动提交
    submitExamNoconfirm: function submitExamNoconfirm() {
      var _this4 = this;
      var arry = JSON.parse(JSON.stringify(this.list));
      for (var i = 0; i < arry.length; i++) {
        if (typeof arry[i].tjkAnswerString != 'string') {
          for (var j = 0; j < arry[i].tjkAnswerString.length; j++) {
            var reg = /^[A-Za-z]+$/;
            if (arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = '';
            if (reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase();
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString);
        }
      }
      var data = {
        'tjkAnswerDetailList': arry
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitTjkAnswer', data).then(function (response) {
        var result = response.data;
        _this4.success = result.success;
        _this4.message = result.msg;
        if (result.success) {
          _this4.submitExamFun();
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    insertOrUpdateEvaluate: function insertOrUpdateEvaluate() {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var data, response;
        return _regenerator.default.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              data = {
                examId: _this5.$route.params.id,
                score: null
              };
              _context3.next = 1;
              return _this5.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/taojinCollege/insertOrUpdateEvaluate', data);
            case 1:
              response = _context3.sent;
              if (response.data.success) {
                _context3.next = 2;
                break;
              }
              _this5.$message.error(response.data.msg);
              return _context3.abrupt("return");
            case 2:
              console.log('传递给后台的', response);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    //提交考试前保存——手动提交
    submitExam: function submitExam() {
      var _this6 = this;
      this.insertOrUpdateEvaluate();
      var arry = JSON.parse(JSON.stringify(this.list));
      for (var i = 0; i < arry.length; i++) {
        if (typeof arry[i].tjkAnswerString != 'string') {
          for (var j = 0; j < arry[i].tjkAnswerString.length; j++) {
            var reg = /^[A-Za-z]+$/;
            if (arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = '';
            if (reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase();
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString);
        }
      }
      var data = {
        'tjkAnswerDetailList': arry
      };
      if (confirm("您确定要提交考试吗？")) {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitTjkAnswer', data).then(function (response) {
          var result = response.data;
          _this6.success = result.success;
          _this6.message = result.msg;
          if (result.success) {
            _this6.submitExamFun();
          } else {
            alert(result.msg);
          }
        }, function (response) {
          alert('网络繁忙，请稍后重试！');
        });
      }
    },
    //提交考试
    submitExamFun: function submitExamFun() {
      var _this7 = this;
      var data = {
        'examRecordId': this.examRecordId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitNormalExam', data).then(function (response) {
        var result = response.data;
        _this7.success = result.success;
        _this7.message = result.msg;
        if (result.success) {
          _this7.$message({
            message: '已提交',
            type: 'success',
            center: true,
            duration: 1000
          });
          window.location.href = '/tjkStudy/examResult/' + _this7.examRecordId;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //保存考试
    saveExam: function saveExam() {
      var _this8 = this;
      var arry = JSON.parse(JSON.stringify(this.list));
      for (var i = 0; i < arry.length; i++) {
        if (typeof arry[i].tjkAnswerString != 'string') {
          for (var j = 0; j < arry[i].tjkAnswerString.length; j++) {
            var reg = /^[A-Za-z]+$/;
            if (arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = '';
            if (reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase();
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString);
        }
      }
      var data = {
        'tjkAnswerDetailList': arry
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitTjkAnswer', data).then(function (response) {
        var result = response.data;
        _this8.success = result.success;
        _this8.message = result.msg;
        if (result.success) {
          _this8.$message({
            message: '已保存',
            type: 'success',
            center: true,
            duration: 1000
          });
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //获取大题分类序号
    getNum: function getNum(key) {
      var arry = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];
      for (var i = 0; i < arry.length; i++) {
        if (i == key) {
          return arry[i];
          break;
        }
      }
    },
    //判断是否显示已答题样式
    getClass: function getClass(string) {
      if (typeof string == 'boolean') {
        return true;
      } else if (string instanceof Array) {
        for (var i = 0; i < string.length; i++) {
          if (string[i] != '') {
            return true;
            break;
          }
        }
      } else if (string != '') {
        return true;
      } else {
        return false;
      }
    },
    clickImg: function clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg: function viewImg() {
      this.showImg = false;
    }
  }
};

/***/ }),
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      //examConfigId
      'data': {},
      'examRecordId': '',
      'endTime': '',
      //初始化考试剩余时间
      'time': '',
      //考试剩余时间-时分秒
      'secTime': '',
      //考试剩余时间-秒
      'isShowBtn': false,
      'paper': '',
      'paperlist': []
    }, "examRecordId", ''), 'totalTime', 0), 'errorNum', 0), 'paperWords', 0), "OnInline", 'fales');
  },
  mounted: function mounted() {
    this.getExam();
  },
  computed: {
    //输入总字数
    totalNum: function totalNum() {
      var num = 0;
      for (var i = 0; i < this.paperlist.length; i++) {
        num = num + this.paperlist[i].input.length;
      }
      if (num < this.paperWords) {
        this.isShowBtn = false;
      } else {
        this.isShowBtn = true;
      }
      return num;
    },
    //正确率
    ratio: function ratio() {
      var temp = (this.totalNum - this.errorNum) / this.totalNum * 100,
        temp = isNaN(temp) ? 0 : temp.toFixed(2);
      return temp;
    },
    //打字速度
    lastspeed: function lastspeed() {
      var value = Math.round(this.totalNum / (this.totalTime - this.secTime) * 60),
        value = isNaN(value) ? 0 : value;
      return value;
    }
  },
  watch: {
    paperlist: {
      handler: function handler(val, oldVal) {
        this.errorNum = 0;
        for (var m = 0; m < this.paperlist.length; m++) {
          var contentArray = this.paperlist[m].content.split(''),
            inputArray = this.paperlist[m].input.split(''),
            str = '',
            index = 0,
            length = 0;

          //如果输入的文字长度小于等于测试长度
          if (inputArray.length <= contentArray.length) {
            for (var i = 0; i < inputArray.length; i++) {
              if (inputArray[i] != contentArray[i]) {
                str = str + '<span class="c-red">' + contentArray[i] + '</span>';
              } else {
                str = str + '<span class="c-green">' + contentArray[i] + '</span>';
              }
            }

            //计算打字错误总字数
            var regValue = /(<span class="c-red"\s?[^\>]*>.*?<\/span>)/gi;
            var errorArray = str.split(regValue);
            for (var n = 0; n < errorArray.length; n++) {
              if (errorArray[n].indexOf('c-red') > 0) {
                this.errorNum = this.errorNum + 1;
              }
            }
            index = inputArray.length;
            length = contentArray.length - inputArray.length;
            this.paperlist[m].lastcontent = str + this.paperlist[m].content.substr(index, length);
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getExam: function getExam() {
      var _this = this;
      var data = {
        'examConfigId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/startExam', data).then(function (response) {
        var result = response.data;
        _this.success = result.success;
        _this.message = result.msg;
        if (result.success) {
          _this.data = result.data;
          _this.paper = result.data.paperQuestion[0].questionDetailList[0].question.questionContent.questionStemString;
          _this.totalTime = result.data.examRemainingTime;
          _this.paperWords = result.data.paperQuestion[0].questionDetailList[0].question.wordNumber;
          _this.examRecordId = result.data.examRecordId;
          _this.paperInit();
          if (_this.endTime == '') _this.endTime = result.data.examRemainingTime;
          _this.countdown(_this.endTime);
        } else {
          alert(result.msg);
          window.location.href = '/tjkStudy/examlist';
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //拆分文章
    paperInit: function paperInit() {
      var width = $('.left').width(),
        content = this.paper.trim(),
        size = width * 0.9 / 15,
        size = Math.floor(size),
        row = Math.floor((content.length - 1) / size) + 1;
      for (var i = 0; i < row; i++) {
        var rsult = content.substr(i * size, size),
          temp = {
            'lastcontent': rsult,
            'content': rsult,
            'maxlength': rsult.length,
            'input': ''
          };
        this.paperlist.push(temp);
      }
    },
    //倒计时
    countdown: function countdown(endTime) {
      var self = this;
      var timer = setInterval(function () {
        endTime--;
        self.secTime = endTime;
        if (endTime >= 0) {
          var sec = parseInt(endTime);
          var min = 0;
          var hour = 0;
          if (sec > 60) {
            min = parseInt(sec / 60);
            sec = parseInt(sec % 60);
            if (min > 60) {
              hour = parseInt(min / 60);
              min = parseInt(min % 60);
            }
          }
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (hour > 0) {
            self.time = "".concat(hour, ":").concat(min, ":").concat(sec);
          } else {
            self.time = "".concat(min, ":").concat(sec);
          }
          if (endTime == 300) {
            self.open();
          }
        } else {
          clearInterval(timer);
          self.time = '时间到';
          self.isShowBtn = true;
          self.submitExamNoconfirm();
        }
      }, 1000);
    },
    computeFun: function computeFun(key, e) {
      //输入框超过考试内容自动换行
      var max = this.paperlist[key].maxlength;
      if (this.paperlist[key].input.length == 0) {
        return false;
      }
      if (this.paperlist[key].input.length >= max) {
        this.paperlist[key].input = this.paperlist[key].input.slice(0, max);
        this.paperlist[key + 1].input = this.paperlist[key + 1].input + this.paperlist[key].input.slice(max);
        $(e.currentTarget).next().next().focus();
      }
    },
    //考试时间提示框
    open: function open() {
      var h = this.$createElement;
      this.$notify({
        title: '',
        message: h('i', {
          style: 'color: red'
        }, '离自动交卷还有5分钟，请注意答题时间'),
        duration: 5000
      });
    },
    //提交考试前保存——自动提交
    submitExamNoconfirm: function submitExamNoconfirm() {
      var _this2 = this;
      var arry = [],
        list = {
          'speed': this.lastspeed,
          'accuracy': this.ratio,
          'tjkWordNumber': this.totalNum,
          'spentTime': this.totalTime - this.secTime
        };
      arry[0] = {
        'examRecordId': this.examRecordId,
        'sequence': 1,
        'tjkAnswerString': JSON.stringify(list)
      };
      var data = {
        'tjkAnswerDetailList': arry
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitTjkAnswer', data).then(function (response) {
        var result = response.data;
        _this2.success = result.success;
        _this2.message = result.msg;
        if (result.success) {
          _this2.submitExamFun();
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //提交考试前保存——手动提交
    submitExam: function submitExam() {
      var _this3 = this;
      var arry = [],
        list = {
          'speed': this.lastspeed,
          'accuracy': this.ratio,
          'tjkWordNumber': this.totalNum,
          'spentTime': this.totalTime - this.secTime
        };
      arry[0] = {
        'examRecordId': this.examRecordId,
        'sequence': 1,
        'tjkAnswerString': JSON.stringify(list)
      };
      var data = {
        'tjkAnswerDetailList': arry
      };
      if (confirm("您确定要提交考试吗？")) {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitTjkAnswer', data).then(function (response) {
          var result = response.data;
          _this3.success = result.success;
          _this3.message = result.msg;
          if (result.success) {
            _this3.submitExamFun();
          } else {
            alert(result.msg);
          }
        }, function (response) {
          alert('网络繁忙，请稍后重试！');
        });
      }
    },
    //提交考试
    submitExamFun: function submitExamFun() {
      var _this4 = this;
      var data = {
        'examRecordId': this.examRecordId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/submitNormalExam', data).then(function (response) {
        var result = response.data;
        _this4.success = result.success;
        _this4.message = result.msg;
        if (result.success) {
          _this4.$message({
            message: '已提交',
            type: 'success',
            center: true,
            duration: 1000
          });
          if (_this4.OnInline == 'true') {
            window.location.href = '/tjkStudy/typingResult/' + _this4.examRecordId + '&OnInline=' + _this4.OnInline;
          } else {
            window.location.href = '/tjkStudy/typingResult/' + _this4.examRecordId;
          }
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      'data': {
        examConfigId: '',
        examConfig: {
          name: '',
          iconUrl: '',
          passScore: '',
          description: '',
          examType: '',
          regStartTime: '',
          regEndTime: '',
          startTime: '',
          endTime: '',
          duration: ''
        },
        examPaper: {
          totalScore: ''
        },
        examState: '',
        examStastics: {
          registerNum: ''
        },
        examTypeName: ''
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var data = {
        'examConfigId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/examDetail', data).then(function (response) {
        var result = response.data;
        _this.success = result.success;
        _this.message = result.msg;
        if (result.success) {
          _this.data = result.data;
          if (result.data.examConfig.examType == 'Formal') {
            _this.data.examTypeName = '考试';
          } else if (result.data.examConfig.examType == 'Practice') {
            _this.data.examTypeName = '练习';
          }
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    toRegister: function toRegister(examConfigId) {
      var _this2 = this;
      var data = {
        'examConfigId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/examRecord/registerExam', data).then(function (response) {
        var result = response.data;
        _this2.success = result.success;
        _this2.message = result.msg;
        if (result.success) {
          _this2.$message({
            message: '已报名',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this2.getList();
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //设置封面图片
    style: function style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      };
    },
    //编码超链接地址
    getCourseUrl: function getCourseUrl(id) {
      var a = '/tjkStudy/courseDetail/' + id,
        b = 'learn',
        c = '培训课程',
        aa = encodeURIComponent(encodeURIComponent(a)),
        bb = encodeURIComponent(encodeURIComponent(b)),
        cc = encodeURIComponent(encodeURIComponent(c));
      return '/customer/action/proxy/redirect?dest=' + aa + '&pageName=' + bb + '&pageTitle=' + cc;
    },
    //编码超链接地址
    getExamUrl: function getExamUrl(id) {
      var a = '/tjkStudy/examDetail/' + id,
        b = 'tjkStudyExam',
        c = '考试中心',
        aa = encodeURIComponent(encodeURIComponent(a)),
        bb = encodeURIComponent(encodeURIComponent(b)),
        cc = encodeURIComponent(encodeURIComponent(c));
      return '/customer/action/proxy/redirect?dest=' + aa + '&pageName=' + bb + '&pageTitle=' + cc;
    }
  }
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      'data': {
        examConfigId: '',
        examConfig: {
          name: '',
          iconUrl: '',
          passScore: '',
          description: '',
          examType: '',
          regStartTime: '',
          regEndTime: '',
          startTime: '',
          endTime: '',
          duration: ''
        },
        examPaper: {
          totalScore: ''
        },
        examState: '',
        examStastics: {
          registerNum: ''
        },
        examTypeName: ''
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var data = {
        'examConfigId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/examDetail', data).then(function (response) {
        var result = response.data;
        _this.success = result.success;
        _this.message = result.msg;
        if (result.success) {
          _this.data = result.data;
          if (result.data.examConfig.examType == 'Formal') {
            _this.data.examTypeName = '考试';
          } else if (result.data.examConfig.examType == 'Practice') {
            _this.data.examTypeName = '练习';
          }
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    toRegister: function toRegister(examConfigId) {
      var _this2 = this;
      var data = {
        'examConfigId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/examRecord/registerExam', data).then(function (response) {
        var result = response.data;
        _this2.success = result.success;
        _this2.message = result.msg;
        if (result.success) {
          _this2.$message({
            message: '已报名',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this2.getList();
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    //设置封面图片
    style: function style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      };
    },
    //编码超链接地址
    getCourseUrl: function getCourseUrl(id) {
      var a = '/tjkStudy/courseDetail/' + id,
        b = 'learn',
        c = '培训课程',
        aa = encodeURIComponent(encodeURIComponent(a)),
        bb = encodeURIComponent(encodeURIComponent(b)),
        cc = encodeURIComponent(encodeURIComponent(c));
      return '/customer/action/proxy/redirect?dest=' + aa + '&pageName=' + bb + '&pageTitle=' + cc;
    },
    //编码超链接地址
    getExamUrl: function getExamUrl(id) {
      var a = '/tjkStudy/examDetail/' + id,
        b = 'tjkStudyExam',
        c = '考试中心',
        aa = encodeURIComponent(encodeURIComponent(a)),
        bb = encodeURIComponent(encodeURIComponent(b)),
        cc = encodeURIComponent(encodeURIComponent(c));
      return '/customer/action/proxy/redirect?dest=' + aa + '&pageName=' + bb + '&pageTitle=' + cc;
    }
  }
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      experience: {
        list: [],
        defaultCheckedArr: []
      },
      intent_schedule_hour: {
        list: [],
        defaultCheckedArr: []
      },
      intent_serve_hour: {
        list: [],
        value: null
      },
      props: {
        label: function label(data, node) {
          return data;
        }
      }
    };
  },
  components: {},
  created: function created() {
    this.queryLabelsByTjkId();
  },
  methods: {
    queryLabelsByTjkId: function queryLabelsByTjkId() {
      var _this2 = this;
      var self = this;
      var param = '?functionNames=experience_label,intent_schedule_hour_label,intent_serve_hour_label';
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjk + '/operationTagItem/queryTagsByTopFunctionName' + param, {}).then(function (res) {
        var result = res.data;
        if (result.success) {
          self.experience.list = result.data.data.experience;
          self.intent_schedule_hour.list = result.data.data.intent_schedule_hour;
          self.intent_serve_hour.list = result.data.data.intent_serve_hour;
          // //把勾选过的，弄出来
          var checkArr = result.data.mapDefaultChecked;
          self.experience.defaultCheckedArr = checkArr.labelExpAndIndustryList;
          self.intent_schedule_hour.defaultCheckedArr = !!checkArr.intent_schedule_hour ? checkArr.intent_schedule_hour : [];
          self.intent_serve_hour.value = !!checkArr.intent_serve_hour && checkArr.intent_serve_hour.length > 0 ? checkArr.intent_serve_hour[0] : null;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      });
    },
    //返回课程
    saveLabel: function saveLabel() {
      var _this3 = this;
      var self = this;
      // var checkedNodes = this.$refs.tree.getCheckedNodes();
      var checkedKeys = this.$refs.tree.getCheckedKeys();
      if (checkedKeys && checkedKeys.length >= 14) {
        this.$message({
          message: '请按照实际情况选择，不要选择过多（通常10个以下）',
          type: 'warning',
          center: true,
          duration: 3000
        });
        return;
      }
      //组装店铺和行业
      var data = {
        // experience_industry : checkedNodes,
        experience_industry_tagIds: checkedKeys,
        intent_schedule_hour: this.intent_schedule_hour.defaultCheckedArr,
        intent_serve_hour: this.intent_serve_hour.value
      };
      var checked_no_exp = null;
      var checked_has_exp = null;
      var checkNodes = this.$refs.tree.getCheckedNodes();
      for (var i = 0; i < checkNodes.length; i++) {
        if (checkNodes[i].operationTagName == '无在线经验') {
          checked_no_exp = true;
        } else {
          checked_has_exp = true;
        }
      }
      if (checked_no_exp == true && checked_has_exp == true) {
        this.$message({
          message: '不能同时选择【无在线经验】和其他店铺经验',
          type: 'warning',
          center: true,
          duration: 2500
        });
        return;
      }
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjk + '/expTjk/saveLabelTjk', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this3.$message({
            message: '保存成功',
            type: 'success',
            center: true,
            duration: 1500
          });

          //--------------------保存课程学习记录--------------------
          if (!!self.$route.query.tabIndex) {
            _this3.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/courseRecord/tool/addCourseRecord?courseId=' + _this3.$route.query.courseId, {}).then(function (res) {
              _this3.isreturn();
            }, function (res) {
              _this3.$alert("AJAX请求接口异常（/courseRecord/tool/addCourseRecord）！");
            });
          }
          //--------------------保存课程学习记录完毕--------------------
        } else {
          _this3.$message({
            message: '操作失败：' + result.msg,
            type: 'warning',
            center: true,
            duration: 2500
          });
        }
      }, function (res) {
        _this3.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      });
    },
    checkChildrenChecked: function checkChildrenChecked(data, node) {
      var _this = this;
      // 获取当前节点是否被选中
      var isChecked = this.$refs.tree.getNode(data).checked;
      if (isChecked) {
        // 判断是否有上级节点，如果有那么遍历设置上级节点选中
        data.parentId && _this.setParentChecked(data.parentId, true);
        // 判断该节点是否有下级节点，如果有那么遍历设置下级节点为选中
        data.children && _this.setChildreChecked(data.children, true);
      } else {
        // 判断是否有上级节点，如果有那么遍历设置上级节点选中
        data.parentId && _this.setParentChecked(data.parentId, false);
        // 如果节点取消选中，则取消该节点下的子节点选中
        data.children && _this.setChildreChecked(data.children, false);
      }
    },
    setParentChecked: function (_setParentChecked) {
      function setParentChecked(_x, _x2) {
        return _setParentChecked.apply(this, arguments);
      }
      setParentChecked.toString = function () {
        return _setParentChecked.toString();
      };
      return setParentChecked;
    }(function (parentId, isChecked) {
      var _this = this;
      // 获取该id的父级node
      var parentNode = _this.$refs.tree.getNode(parentId);
      // 如果该id的父级node存在父级id则继续遍历
      if (isChecked) {
        _this.$refs.tree.setChecked(parentId, true);
        if (parentNode && parentNode.data && parentNode.data.parentId) {
          _this.setParentChecked(parentNode.data.parentId, true);
        }
      } else {
        //查所选节点的父级node,根据是否还有已勾选的子节点，从而设置状态（递归搞）
        var existChecked = false;
        if (parentNode == null) {
          return;
        }
        for (var i = 0; i < parentNode.childNodes.length; i++) {
          if (parentNode.childNodes[i].checked == true) {
            existChecked = true;
            break;
          }
        }

        //如果是勾选(取消)，则根据父节点的子节点是否勾选，来遍历的对父节点(勾选,取消)
        _this.$refs.tree.setChecked(parentId, existChecked);
        if (parentNode && parentNode.data && parentNode.data.parentId) {
          setParentChecked(parentNode.data.parentId, existChecked);
        }
      }
    }),
    setChildreChecked: function setChildreChecked(node, isChecked) {
      var _this = this;
      node.forEach(function (item) {
        item.children && _this.setChildreChecked(item.children, isChecked);
        _this.$refs.tree.setChecked(item.operationTagId, isChecked);
      });
    },
    isreturn: function isreturn() {
      var tabIndex = this.$route.query.tabIndex;
      // tabIndex设置
      //设置不刷到默认位置，直接跳到fbt培训那里
      localStorage.setItem('tabIndex', tabIndex);
      this.$router.push({
        path: '/train/index'
      });
    }
  }
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      'data': {},
      'paperQuestion': [],
      'num': [],
      'savelist': [],
      'list': [] //保存时的结果集转换的一维数组，用作答题卡
    };
  },
  mounted: function mounted() {
    this.getExam();
  },
  watch: {
    paperQuestion: function paperQuestion() {
      for (var i = 0; i < this.paperQuestion.length; i++) {
        var xti = [];
        var numlength = parseInt(this.num.length);
        for (var j = 0; j < this.paperQuestion[i].questionDetailList.length; j++) {
          this.num.push(j);
          var temp = {
            'num': numlength + j + 1,
            'answerState': this.paperQuestion[i].questionDetailList[j].answerState
          };
          xti.push(temp);
        }
        this.savelist.push(xti);
      }
      this.list = [].concat.apply([], this.savelist);
    }
  },
  methods: {
    getExam: function getExam() {
      var _this = this;
      var data = {
        'examRecordId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/getTjkExamDetail', data).then(function (response) {
        var result = response.data;
        _this.success = result.success;
        _this.message = result.msg;
        if (result.success) {
          _this.data = result.data;
          _this.paperQuestion = result.data.allTjkAnswerDetailList;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    getTime: function getTime(second) {
      var sec = parseInt(second);
      var min = 0;
      var hour = 0;
      if (sec >= 60) {
        min = parseInt(sec / 60);
        sec = parseInt(sec % 60);
        if (min >= 60) {
          hour = parseInt(min / 60);
          min = parseInt(min % 60);
        }
      }
      hour = hour < 10 ? "0" + hour : hour;
      min = min < 10 ? "0" + min : min;
      sec = sec < 10 ? "0" + sec : sec;
      if (hour > 0) {
        return "".concat(hour, "\u5C0F\u65F6").concat(min, "\u5206\u949F").concat(sec, "\u79D2");
      } else {
        return "".concat(min, "\u5206\u949F").concat(sec, "\u79D2");
      }
    }
  }
};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      'data': {},
      'tjkAnswer': {},
      'num': [],
      'savelist': [],
      'list': [],
      //保存时的结果集转换的一维数组，用作答题卡
      OnInline: 'false' //小助手跳转
    };
  },
  mounted: function mounted() {
    this.getExam();
  },
  methods: {
    getExam: function getExam() {
      var _this = this;
      var data = {
        'examRecordId': this.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjkExam/getTjkExamDetail', data).then(function (response) {
        var result = response.data;
        _this.success = result.success;
        _this.message = result.msg;
        if (result.success) {
          _this.data = result.data;
          _this.tjkAnswer = result.data.allTjkAnswerDetailList[0].questionDetailList[0].tjkAnswer;
          console.log(_this.tjkAnswer.speed, '原');
          if (_this.data.isPassed == 'passed') {
            window.parent['goBack'](_this.tjkAnswer.speed);
          }
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    getTime: function getTime(second) {
      var sec = parseInt(second);
      var min = 0;
      var hour = 0;
      if (sec >= 60) {
        min = parseInt(sec / 60);
        sec = parseInt(sec % 60);
        if (min >= 60) {
          hour = parseInt(min / 60);
          min = parseInt(min % 60);
        }
      }
      hour = hour < 10 ? "0" + hour : hour;
      min = min < 10 ? "0" + min : min;
      sec = sec < 10 ? "0" + sec : sec;
      if (hour > 0) {
        return "".concat(hour, "\u5C0F\u65F6").concat(min, "\u5206\u949F").concat(sec, "\u79D2");
      } else {
        return "".concat(min, "\u5206\u949F").concat(sec, "\u79D2");
      }
    }
  }
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'liveId': this.$route.query.ll,
      'livePlanId': this.$route.query.pp,
      'url': '' //直播地址
    };
  },
  mounted: function mounted() {
    this.getUrl();
  },
  methods: {
    getUrl: function getUrl() {
      var _this = this;
      var data = {
        'liveId': this.liveId,
        'livePlanId': this.livePlanId,
        'liveRoleType': 'Student'
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/liveRecord/getLiveAccessRoomUrl', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          if (result.data != '') {
            _this.url = result.data;
            _this.updateLifecycle();
            setInterval(function () {
              _this.updateLifecycle();
            }, 30000);
          } else {
            _this.$alert('你没有权限访问该页面', {
              confirmButtonText: '确定',
              callback: function callback(action) {
                window.location.href = '/';
              }
            });
          }
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    updateLifecycle: function updateLifecycle() {
      var _this2 = this;
      var data = {
        'liveId': this.liveId,
        'livePlanId': this.livePlanId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/liveTjkStudyRecord/updateLifecycle', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.success = result.success;
          _this2.message = result.msg;
        } else {
          alert(result.msg);
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    }
  }
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(1143);
var _highcharts = _interopRequireDefault(__webpack_require__(1144));
__webpack_require__(1145);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'token': this.$route.query.tjkapptoken,
      'list': [],
      //图表数据
      'cardStatistics': {},
      //列表数据
      'xlist': [],
      'ylist': [],
      'time': ''
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      document.cookie = 'login_token=' + this.token + ';';
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/tjkMajorStatistics/queryMyStatistics').then(function (response) {
        var result = response.data;
        _this.success = result.success;
        _this.message = result.msg;
        if (result.success) {
          _this.list = result.data.recentTjkMajorStatistics;
          _this.cardStatistics = result.data.tjkCourseStatistics;
          _this.time = (result.data.totalLearningDuration / 3600).toFixed(2);
          for (var i = 0; i < _this.list.length; i++) {
            var dataDate = new Date(_this.list[i].collectDate);
            _this.xlist.push(dataDate.getMonth() + 1 + '/' + dataDate.getDate());
            _this.ylist.push(parseInt((_this.list[i].totalLearningDurationPerDay / 60).toFixed(0)));
          }
          _this.initCharts();
          document.cookie = 'login_token=' + _this.token + ';expires=' + new Date(0).toGMTString();
        } else {
          alert(result.msg);
          document.cookie = 'login_token=' + _this.token + ';expires=' + new Date(0).toGMTString();
        }
      }, function (response) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    initCharts: function initCharts() {
      var chart = _highcharts.default.chart('container', {
        chart: {
          type: 'areaspline',
          height: 300
        },
        title: {
          text: '学习总时长:' + this.time + '小时',
          style: {
            color: '#2A2A2A',
            fontSize: '18px'
          }
        },
        tooltip: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false // 禁用版权信息
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        plotOptions: {
          areaspline: {
            dataLabels: {
              enabled: true,
              format: '{y} 分钟',
              style: {
                color: '#2A2A2A',
                textOutline: "none"
              }
            },
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [[0, '#B4D0FF'], [1, '#fff']]
            },
            marker: {
              symbol: 'circle',
              fillColor: '#ffffff',
              lineColor: '#77A9FD',
              lineWidth: 2,
              radius: 5
            },
            lineWidth: 2,
            states: {
              hover: {
                lineWidth: 1
              }
            },
            threshold: null
          }
        },
        xAxis: {
          categories: this.xlist,
          lineWidth: 0,
          tickLength: 0
        },
        yAxis: {
          visible: false
        },
        series: [{
          name: '学习时长',
          data: this.ylist
        }]
      });
    }
  }
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _img_index_remind = _interopRequireDefault(__webpack_require__(1150));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      methodData: [],
      menuList: [],
      searchData: {
        pageSize: 100,
        pageNum: 1,
        manualCategoryId: '',
        isSystemRule: ''
      },
      img: _img_index_remind.default
    };
  },
  mounted: function mounted() {
    this.getMenuList();
    this.getMethodData();
  },
  methods: {
    getMenuList: function getMenuList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.method + '/manualRule/queryCategory').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.menuList = result.data;
        } else {
          alert(result.msg);
        }
      }, function (err) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    getMethodData: function getMethodData(id) {
      var _this2 = this;
      this.searchData.manualCategoryId = id;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.method + '/manualRule/queryRule', this.searchData).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.methodData = result.data.list;
        } else {
          alert(result.msg);
        }
      }, function (err) {
        alert('网络繁忙，请稍后重试！');
      });
    },
    getMethodDataByCategory: function getMethodDataByCategory(row) {
      var _this3 = this;
      this.menuList.map(function (item) {
        _this3.$set(item, 'checked', false);
        // item.checked = false;
      });
      this.$set(row, 'checked', true);
      this.getMethodData(row.manualCategoryId);
    }
  }
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      dialogVisibleResult: false,
      pageNum: 1,
      pageSize: 10,
      pages: 1,
      blacklistId: '',
      platform: '',
      compositeState: '',
      list: [],
      fileList: [],
      //已上传凭证列表
      token: null,
      uploaderDomain: null,
      modal: {
        punishId: '',
        appealExtend: [],
        appealExplain: ''
      },
      result: {},
      rules: {
        appealExplain: [{
          required: true,
          message: '请输入申诉原因',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '长度在 1 到 500 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList(1);
  },
  methods: {
    getList: function getList(num) {
      var _this = this;
      var data = {
        'pageNum': num,
        'pageSize': this.pageSize,
        'blacklistId': this.blacklistId,
        'platform': this.platform,
        'compositeState': this.compositeState
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.method + '/blacklist/queryPersonalBlacklist', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.pages = result.data.pages;
          _this.pageNum = result.data.pageNum;
          _this.list = result.data.list;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //弹出层显示
    showModal: function showModal(blacklistId) {
      this.dialogVisible = true;
      this.modal.punishId = blacklistId;
    },
    //弹出层关闭
    handleClose: function handleClose() {
      this.$refs['modal'].resetFields();
      this.dialogVisible = false;
      this.modal.appealExtend = [];
      this.fileList = [];
    },
    //申诉提交
    addModalFun: function addModalFun() {
      var self = this;
      this.$refs.modal.validate(function (valid) {
        if (valid) {
          if (self.modal.appealExtend.length == 0) {
            self.$alert('请上传图片');
            return;
          }
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.method + '/appeal/instituteAppeal', self.modal).then(function (response) {
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '已提交',
                type: 'success',
                center: true,
                duration: 1000
              });
              self.handleClose();
              self.getList(self.pageNum);
            } else {
              self.$alert(result.message);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        } else {
          return false;
        }
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      var _this2 = this;
      this.modal.appealExtend = [];
      this.fileList = [];
      fileList.map(function (item) {
        if (item.response) {
          _this2.modal.appealExtend.push(_this2.uploaderDomain + '/' + item.response.key);
          _this2.fileList.push({
            'url': _this2.uploaderDomain + '/' + item.response.key
          });
        } else {
          _this2.modal.appealExtend.push(item.url);
          _this2.fileList.push({
            'url': item.url
          });
        }
      });
    },
    //获取文件后缀名
    getSuffix: function getSuffix(file) {
      var lastPlace = file.lastIndexOf("."),
        fileLength = file.length;
      return file.substring(lastPlace + 1, fileLength);
    },
    //获取上传七牛token
    getToken: function getToken(file) {
      var _this3 = this;
      return this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.method + '/qiniu/token', {
        ext: this.getSuffix(file.name)
      }).then(function (res) {
        var res = res.data;
        if (res.success) {
          _this3.token = {
            key: res.data.key,
            token: res.data.token
          };
          _this3.uploaderDomain = res.data.domain;
        } else {
          _this3.$alert('上传图片失败!', '警告');
        }
      }, function (err) {
        _this3.$alert('上传图片失败!', '警告');
      });
    },
    //上传七牛成功执行回调函数
    uploadSuccess: function uploadSuccess(response, file, fileList) {
      var uploadUrl = this.uploaderDomain + '/' + response.key;
      this.modal.appealExtend.push(uploadUrl);
    },
    //弹出层关闭-查看详情
    handleCloseResult: function handleCloseResult() {
      this.result = {};
      this.dialogVisibleResult = false;
    },
    //弹出层显示-查看详情
    showResultModal: function showResultModal(punishId) {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.method + '/appeal/getTjkAppealRecord', {
        'punishId': punishId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.result = result.data;
          _this4.dialogVisibleResult = true;
        } else {
          _this4.$alert(result.msg);
        }
      }, function (response) {
        _this4.$alert('网络繁忙，请稍后重试！');
      });
    },
    jumpToInfo: function jumpToInfo(row) {
      // 详情跳转
      window.parent.location.href = '/customer/action/qualityControl/customerWeigui?id=' + row.thirdPlatformId + '&customScore=' + row.customScore;
    }
  }
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _provinces = _interopRequireDefault(__webpack_require__(1157));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      uid: '',
      voList: '',
      form: {
        answerList: []
      },
      province: '',
      city: '',
      provinceList: [],
      citysList: [],
      imgurl: [],
      //上传图片数据
      fileList: [],
      //已上传列表
      token: null,
      uploaderDomain: null,
      index: '',
      //查找省份和城市的questionId
      imgindex: '',
      //查找上传图片的questionId
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  watch: {
    voList: function voList() {
      for (var i = 0; i < this.voList.length; i++) {
        if (this.voList[i].questionType == 'MULTIPLE_CHOICE') {
          this.form.answerList[this.voList[i].questionId] = [];
        }
        if (this.voList[i].questionType == 'BLANK_CHOICE') {
          this.index = this.voList[i].questionId;
        }
        if (this.voList[i].questionType == 'IMAGE') {
          this.imgindex = this.voList[i].questionId;
        }
      }
    },
    province: function province() {
      if (!this.province) {
        this.city = '';
        this.citysList = [];
      }
    }
  },
  mounted: function mounted() {
    this.provinceList = _provinces.default.provinces;
    this.queryList();
  },
  methods: {
    //根据省份查询地市
    queryCitysFun: function queryCitysFun() {
      var _this = this;
      this.provinceList.map(function (item) {
        if (item.provinceName == _this.province) {
          _this.citysList = item.citys;
        }
      });
    },
    queryList: function queryList() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.provider + '/intentRegister/queryQuestion', {
        'surveyId': 1
      }).then(function (respones) {
        var result = respones.data;
        if (result.success) {
          if (result.data) {
            _this2.uid = result.data.surveyInfo.uid;
            _this2.voList = result.data.voList;
          }
        } else {
          _this2.$alert(result.msg);
        }
      }, function (respones) {
        _this2.$alert("网络繁忙，请稍后重试！");
      });
    },
    submitInfo: function submitInfo() {
      var _this3 = this;
      var self = this,
        answerList = [];
      if (this.form.answerList.length < this.voList.length) {
        this.$alert('你还有必填项未填');
        return false;
      }
      this.form.answerList.forEach(function (v, i) {
        if ($.isArray(v)) {
          answerList.push({
            'questionId': i,
            'answer': JSON.stringify(v)
          });
        } else {
          answerList.push({
            'questionId': i,
            'answer': v
          });
        }
      });
      if (!this.city) {
        this.$alert('请选择所在城市');
        return false;
      }
      if (this.imgurl.length == 0) {
        this.$alert('请上传图片');
        return false;
      }
      answerList.push({
        'questionId': this.index,
        'answer': this.province + '-' + this.city
      });
      answerList.push({
        'questionId': this.imgindex,
        'answer': JSON.stringify(this.imgurl)
      });
      var data = {
        'surveyId': 1,
        'uid': this.uid,
        'answerList': answerList
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.provider + '/intentRegister/submit', data).then(function (respones) {
        var result = respones.data;
        if (result.success) {
          self.$message({
            message: '登记成功',
            type: 'success',
            center: true,
            duration: 1000
          });
        } else {
          _this3.$alert(result.msg);
        }
      }, function (respones) {
        _this3.$alert("网络繁忙，请稍后重试！");
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      var _this4 = this;
      this.imgurl = [];
      this.fileList = [];
      fileList.map(function (item) {
        if (item.response) {
          _this4.imgurl.push(_this4.uploaderDomain + '/' + item.response.key);
          _this4.fileList.push({
            'url': _this4.uploaderDomain + '/' + item.response.key
          });
        } else {
          _this4.imgurl.push(item.url);
          _this4.fileList.push({
            'url': item.url
          });
        }
      });
    },
    //获取文件后缀名
    getSuffix: function getSuffix(file) {
      var lastPlace = file.lastIndexOf("."),
        fileLength = file.length;
      return file.substring(lastPlace + 1, fileLength);
    },
    //获取上传七牛token
    getToken: function getToken(file) {
      var _this5 = this;
      return this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.method + '/qiniu/token', {
        ext: this.getSuffix(file.name)
      }).then(function (res) {
        var res = res.data;
        if (res.success) {
          _this5.token = {
            key: res.data.key,
            token: res.data.token
          };
          _this5.uploaderDomain = res.data.domain;
        } else {
          _this5.$alert('上传图片失败!', '警告');
        }
      }, function (err) {
        _this5.$alert('上传图片失败!', '警告');
      });
    },
    //上传七牛成功执行回调函数
    uploadSuccess: function uploadSuccess(response, file, fileList) {
      var uploadUrl = this.uploaderDomain + '/' + response.key;
      this.imgurl.push(uploadUrl);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName,
      //考核群名称
      'tjkId': '',
      //搜索的淘金客id
      tjkNumbers: '',
      //批量淘金号
      'type': '',
      'multipleSelection': [],
      'check': {
        'callOutPhone': '',
        'avgDuration': '',
        'codeName': ''
      },
      'release': {
        'shopGroupId': '',
        'failedState': 'Kicked',
        'abandonState': 'Kicked',
        'passedMsg': '恭喜你通过了本次考核。',
        'stayMsg': '考核成绩已发布。',
        'kickMsg': '考核成绩已发布，很遗憾你没有通过本次考核。（已释放，可以去领取新的任务!)'
      },
      'list': [],
      'examiningList': [],
      //正在考核列表
      'basicGroupList': [],
      //基础培训群列表
      'shopGroupList': [],
      //流转群列表
      'shopId': '',
      //店铺id
      'tableHeight': window.innerHeight - 270,
      'onlineTableHeight': window.innerHeight - 220
    };
  },
  mounted: function mounted() {
    this.getBasicGroup();
    this.getList();
  },
  methods: {
    myAlert: function myAlert(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {}
      });
    },
    //查询基础培训群
    getBasicGroup: function getBasicGroup() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.teamTalk + '/retrial/group/queryAll').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          _this.basicGroupList = result.data;
        } else {
          _this.myAlert(result.msg);
        }
      }, function (response) {
        _this.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //查询流转群
    getShopGroup: function getShopGroup() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.teamTalk + '/shopGroup/queryAllGroupsByShopId', {
        'shopId': this.shopId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.shopGroupList = result.data;
        } else {
          _this2.myAlert(result.msg);
        }
      }, function (response) {
        _this2.myAlert('网络繁忙，请稍后重试！');
      });
    },
    getList: function getList(opetype) {
      var _this3 = this;
      //opetype:标记当前查询是按 单查 还是 批量查【tjk|tjkNumbers】
      var tjkId = opetype == 'tjk' ? this.tjkId : null;
      var tjkNumbers = opetype == 'tjkNumbers' ? this.tjkNumbers : null;
      var data = {
        'groupId': this.groupId,
        'tjkId': tjkId,
        'tjkNumbers': tjkNumbers
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/examine/query', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.success = result.success;
          _this3.message = result.msg;
          _this3.type = result.data.type;
          _this3.shopId = result.data.shopId;
          _this3.list = result.data.tjkList;
          _this3.examiningList = result.data.examiningList;
        } else {
          _this3.myAlert(result.msg);
        }
      }, function (response) {
        _this3.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //语音打分保存
    saveVoice: function saveVoice() {
      var self = this,
        ids = [],
        isOkVoice = true,
        //表单是否校验通过
        reg = /^[1-9]\d*|0$/;
      self.list.map(function (item) {
        if (!!item.score && !reg.test(item.score)) {
          self.myAlert('分数只能是非负整数');
          isOkVoice = false;
          return false;
        }
        if (!!item.remark && item.remark.length > 200) {
          self.myAlert('备注不能超过200字');
          isOkVoice = false;
          return false;
        }
      });
      self.list.map(function (item) {
        if (!!item.passState) {
          ids.push({
            'examineId': !!item.examineId ? item.examineId : '',
            'groupId': self.groupId,
            'taskId': item.taskId,
            'tjkId': item.tjkId,
            'passState': item.passState,
            'remark': !!item.remark ? item.remark : '',
            'score': !!item.score ? item.score : 0
          });
        }
      });
      if (isOkVoice) {
        self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/json/batchScore', ids).then(function (response) {
          var result = response.data;
          if (result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            });
            self.type = result.data.type;
            self.list = result.data.tjkList;
          } else {
            self.myAlert(result.msg);
            self.getList();
          }
        }, function (response) {
          self.myAlert('网络繁忙，请稍后重试！');
        });
      }
    },
    //在线打分保存
    saveOnline: function saveOnline() {
      var self = this,
        ids = [],
        isOk = true,
        //表单是否校验通过
        reg = /^[1-9]\d*|0$/;
      self.list.map(function (item) {
        if (!!item.score && !reg.test(item.score)) {
          self.myAlert('分数只能是非负整数');
          isOk = false;
          return false;
        }
        if (!!item.remark && item.remark.length > 200) {
          self.myAlert('备注不能超过200字');
          isOk = false;
          return false;
        }
      });
      self.list.map(function (item) {
        if (!!item.passState) {
          ids.push({
            'examineId': !!item.examineId ? item.examineId : '',
            'groupId': self.groupId,
            'tjkId': item.tjkId,
            'taskId': item.taskId,
            'passState': item.passState,
            'remark': !!item.remark ? item.remark : '',
            'score': !!item.score ? item.score : 0
          });
        }
      });
      if (isOk) {
        self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/online/examine/json/score', ids).then(function (response) {
          var result = response.data;
          if (result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            });
            self.type = result.data.type;
            self.list = result.data.tjkList;
          } else {
            self.myAlert(result.msg);
            self.getList();
          }
        }, function (response) {
          self.myAlert('网络繁忙，请稍后重试！');
        });
      }
    },
    //群考核
    checkGroup: function checkGroup() {
      var _this4 = this;
      var self = this;
      self.check.callOutPhone = '';
      self.check.avgDuration = '';
      self.check.codeName = '';

      //发起考核前查询是否存在未结束的考核
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/existStartedExamine', {
        'groupId': self.groupId,
        'recordType': 'PreExamine'
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          if (result.data) {
            self.myAlert('存在未结束的考核，考核结束后才能再次发起群考核！');
          } else {
            //不存在即发起考核
            var ids = [];
            self.multipleSelection.map(function (item) {
              ids.push(item.tjkId);
            });
            if (ids.length == 0) {
              self.myAlert('请先选择淘金客');
              return false;
            }
            _this4.$refs.check.open({
              title: '群考核',
              width: 800,
              callBack: function callBack(arg) {
                if (arg.type === 'cancel') {
                  arg.close();
                  return;
                }
                if (self.check.callOutPhone == '') {
                  self.myAlert('外呼电话不能为空');
                  return false;
                }
                if (self.check.avgDuration == '') {
                  self.myAlert('平均外呼时长不能为空');
                  return false;
                }
                if (self.check.codeName == '') {
                  self.myAlert('考核代号不能为空');
                  return false;
                }
                var reg = /^[0-9]*[1-9][0-9]*$/;
                if (!reg.test(self.check.callOutPhone) || !reg.test(self.check.avgDuration)) {
                  self.myAlert('只能填写正整数');
                  return false;
                }
                if (arg.pending()) return;
                arg.pending(true);
                var data = {
                  'groupId': self.groupId,
                  'callOutPhone': self.check.callOutPhone,
                  'avgDuration': self.check.avgDuration,
                  'codeName': self.check.codeName,
                  'tjkIds': ids
                };
                self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/start', data, {
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                  }
                }).then(function (response) {
                  arg.pending(false);
                  var result = response.data;
                  if (result.success) {
                    self.$message({
                      message: '已添加',
                      type: 'success',
                      center: true,
                      duration: 1000
                    });
                    arg.close();
                    window.location.href = '/tjkStudy/voiceExam?id=' + result.data + '&groupId=' + self.groupId + '&groupName=' + self.groupName;
                  } else {
                    self.myAlert(result.msg);
                  }
                }, function (response) {
                  self.myAlert('网络繁忙，请稍后重试！');
                });
              }
            });
          }
        } else {
          self.myAlert(result.msg);
        }
      }, function (response) {
        self.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //发布成绩
    releaseGroup: function releaseGroup() {
      var self = this;
      self.getShopGroup();
      self.release.failedState = 'Kicked';
      self.release.abandonState = 'Kicked';
      self.release.shopGroupId = '';
      self.release.passedMsg = '恭喜你通过了本次考核。';
      self.release.stayMsg = '考核成绩已发布。';
      self.release.kickMsg = '考核成绩已发布，很遗憾你没有通过本次考核。（已释放，可以去领取新的任务!)';
      //筛选状态有值的淘金客
      var ids = [];
      if (self.multipleSelection.length > 0) {
        self.multipleSelection.map(function (item) {
          ids.push(item.examineId);
        });
      }
      this.$refs.release.open({
        title: '学员处理',
        width: 800,
        callBack: function callBack(arg) {
          if (arg.type === 'cancel') {
            arg.close();
            return;
          }
          if (self.release.waitJobMsg == '' || self.release.stayMsg == '' || self.release.kickMsg == '' || self.release.retrialMsg == '') {
            self.myAlert('发送消息不能为空');
            return false;
          }
          if (arg.pending()) return;
          arg.pending(true);
          var data = {
            'groupId': self.groupId,
            'passed.state': 'Enroll',
            'failed.state': self.release.failedState,
            'abandon.state': self.release.abandonState,
            'shopGroupId': self.release.shopGroupId,
            'stayMsg': self.release.stayMsg,
            'kickMsg': self.release.kickMsg,
            'passedMsg': self.release.passedMsg,
            'examineIds': ids
          };
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/publish', data, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          }).then(function (response) {
            arg.pending(false);
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '已发布',
                type: 'success',
                center: true,
                duration: 1000
              });
              arg.close();
              self.type = result.data.type;
              self.list = result.data.tjkList;
            } else {
              self.myAlert(result.msg);
              self.getList();
            }
          }, function (response) {
            self.myAlert('网络繁忙，请稍后重试！');
          });
        }
      });
    },
    //全选/全不选 标记是否通过
    toggleSelection: function toggleSelection(passState) {
      var _this5 = this;
      var ids = [];
      this.multipleSelection.map(function (item) {
        ids.push(item.examineId);
      });
      if (ids.length == 0) {
        this.myAlert('请先选择淘金客');
        return false;
      }
      var data = {
        'groupId': this.groupId,
        'examineIds': ids,
        'passState': passState
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/examine/mark', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this5.type = result.data.type;
          _this5.list = result.data.tjkList;
        } else {
          _this5.myAlert(result.msg);
          _this5.getList();
        }
      }, function (response) {
        _this5.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //淘金客自动搜索
    updateTjkId: function updateTjkId(val) {
      this.tjkId = val;
    }
  }
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName,
      'multipleSelection': [],
      'list': [],
      'check': {
        'callOutPhone': '',
        'avgDuration': '',
        'codeName': ''
      },
      'examiningList': [] //正在考核列表
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    myAlert: function myAlert(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {}
      });
    },
    getList: function getList() {
      var _this = this;
      var data = {
        'groupId': this.groupId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/examine/queryReady', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          _this.list = result.data.tjkList;
          _this.examiningList = result.data.examiningList;
        } else {
          _this.myAlert(result.msg);
        }
      }, function (response) {
        _this.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //全选/全不选 移除待岗学员
    toggleSelection: function toggleSelection() {
      var _this2 = this;
      var ids = [];
      this.multipleSelection.map(function (item) {
        ids.push(item.examineId);
      });
      if (ids.length == 0) {
        this.myAlert('请先选择淘金客');
        return false;
      }
      var data = {
        'examineIds': ids
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/examine/removeReady', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this2.getList();
        } else {
          _this2.myAlert(result.msg);
        }
      }, function (response) {
        _this2.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //群考核
    checkGroup: function checkGroup() {
      var _this3 = this;
      var self = this;
      self.check.callOutPhone = '';
      self.check.avgDuration = '';
      self.check.codeName = '';

      //发起考核前查询是否存在未结束的考核
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/existStartedExamine', {
        'groupId': self.groupId,
        'recordType': 'WaitJob'
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          if (result.data) {
            self.myAlert('存在未结束的考核，考核结束后才能再次发起群考核！');
          } else {
            //不存在即发起考核
            var ids = [];
            self.list.map(function (item) {
              ids.push(item.tjkId);
            });
            _this3.$refs.check.open({
              title: '群考核',
              width: 800,
              callBack: function callBack(arg) {
                if (arg.type === 'cancel') {
                  arg.close();
                  return;
                }
                if (self.check.callOutPhone == '') {
                  self.myAlert('外呼电话不能为空');
                  return false;
                }
                if (self.check.avgDuration == '') {
                  self.myAlert('平均外呼时长不能为空');
                  return false;
                }
                if (self.check.codeName == '') {
                  self.myAlert('考核代号不能为空');
                  return false;
                }
                var reg = /^[0-9]*[1-9][0-9]*$/;
                if (!reg.test(self.check.callOutPhone) || !reg.test(self.check.avgDuration)) {
                  self.myAlert('只能填写正整数');
                  return false;
                }
                if (arg.pending()) return;
                arg.pending(true);
                var data = {
                  'groupId': self.groupId,
                  'callOutPhone': self.check.callOutPhone,
                  'avgDuration': self.check.avgDuration,
                  'codeName': self.check.codeName,
                  'tjkIds': ids
                };
                self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/waitJob/examine/start', data, {
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                  }
                }).then(function (response) {
                  arg.pending(false);
                  var result = response.data;
                  if (result.success) {
                    self.$message({
                      message: '已添加',
                      type: 'success',
                      center: true,
                      duration: 1000
                    });
                    arg.close();
                    window.location.href = '/tjkStudy/waitWorkExam?id=' + result.data + '&groupId=' + self.groupId + '&groupName=' + self.groupName;
                  } else {
                    self.myAlert(result.msg);
                  }
                }, function (response) {
                  self.myAlert('网络繁忙，请稍后重试！');
                });
              }
            });
          }
        } else {
          self.myAlert(result.msg);
        }
      }, function (response) {
        self.myAlert('网络繁忙，请稍后重试！');
      });
    }
  }
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName,
      'tjkId': '',
      //当前考核人员的tjkId
      'userList': {},
      //当前和下一个考核人员信息
      'list': [],
      //考核名单列表
      'score': '',
      'remark': '',
      'waitNum': '',
      //剩余考核人数
      'callOutPhone': '',
      //当前外呼电话号码
      'codeName': '',
      //当前考核代号
      'examineRecordId': this.$route.query.id,
      //当前考核记录id
      'examineId': '',
      //群考核记录id
      'taskId': '',
      //任务id
      'change': {
        callOutPhone: ''
      },
      //修改外呼电话 
      'interval': null,
      //轮询状态
      'status': false //是否考核完成 无考核人员和结束考核后为true
    };
  },
  mounted: function mounted() {
    this.initUser();
    this.intervalFun();
    this.getList();
  },
  methods: {
    myAlert: function myAlert(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {}
      });
    },
    //轮询代码
    intervalFun: function intervalFun() {
      var _this = this;
      var self = this;
      self.interval = setInterval(function () {
        console.log('this is heartbeat...');
        _this.initUser();
      }, 5000);
    },
    //查询当前和下一个考核人员信息
    initUser: function initUser() {
      var _this2 = this;
      var data = {
        'examineRecordId': this.examineRecordId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/userState', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.success = result.success;
          _this2.message = result.msg;
          _this2.userList = result.data;
          _this2.tjkId = !!result.data.current ? result.data.current.tjkId : '';
          _this2.waitNum = result.data.waitNum;
          _this2.callOutPhone = result.data.callOutPhone;
          _this2.codeName = result.data.codeName;
          _this2.examineId = !!result.data.current && !!result.data.current.evaluation ? result.data.current.evaluation.examineId : '';
          _this2.taskId = !!result.data.current && !!result.data.current.evaluation ? result.data.current.evaluation.taskId : '';
          if (!result.data.current && !result.data.next) {
            _this2.status = true;
            _this2.endExam();
            clearInterval(_this2.interval);
          }
        } else {
          _this2.myAlert(result.msg);
        }
      }, function (response) {
        _this2.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //查询考核名单列表
    getList: function getList() {
      var _this3 = this;
      var data = {
        'examineRecordId': this.examineRecordId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/manageView', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.success = result.success;
          _this3.message = result.msg;
          _this3.list = result.data;
        } else {
          _this3.myAlert(result.msg);
        }
      }, function (response) {
        _this3.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //时间格式化
    formatTime: function formatTime(time) {
      if (!!time) {
        var h = parseInt(time / (60 * 60));
        var m = parseInt(time % (60 * 60) / 60);
        var s = parseInt(time % (60 * 60) % 60);
        return (h >= 10 ? h : '0' + h) + ':' + (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s);
      } else {
        return '';
      }
    },
    //语音考核打分并标记是否通过
    saveScore: function saveScore(passState) {
      var reg = /^[1-9]\d*|0$/;
      if (!!this.score && !reg.test(this.score)) {
        this.myAlert('分数只能是非负整数');
        return false;
      }
      if (!!this.remark && this.remark.length > 200) {
        this.myAlert('备注不能超过200字');
        return false;
      }
      this.saveScoreFun(passState);
    },
    //保存打分
    saveScoreFun: function saveScoreFun(passState) {
      var _this4 = this;
      var data = {
        'groupId': this.groupId,
        'examineId': this.examineId,
        'taskId': this.taskId,
        'tjkId': this.tjkId,
        'passState': passState,
        'score': !!this.score ? this.score : 0,
        'remark': !!this.remark ? this.remark : ''
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/score', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this4.score = '';
          _this4.remark = '';
          _this4.initUser();
          _this4.getList();
        } else {
          _this4.myAlert(result.msg);
        }
      }, function (response) {
        _this4.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //考核结束
    endExam: function endExam() {
      var _this5 = this;
      var data = {
        'groupId': this.groupId,
        'recordType': 'PreExamine'
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/end', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.status = true;
          clearInterval(self.interval);
          window.location.href = '/tjkStudy/groupTrain?groupId=' + _this5.groupId;
        } else {
          _this5.myAlert(result.msg);
        }
      }, function (response) {
        _this5.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //修改外呼电话
    changePhone: function changePhone() {
      var _this6 = this;
      var self = this;
      self.change.callOutPhone = '';
      this.$confirm('修改学员拨打电话，下一位学员生效。是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.$refs.change.open({
          title: '修改外呼电话',
          width: 600,
          callBack: function callBack(arg) {
            if (arg.type === 'cancel') {
              arg.close();
              return;
            }
            if (self.change.callOutPhone == '') {
              self.myAlert('外呼电话不能为空');
              return false;
            }
            var reg = /^[0-9]*[1-9][0-9]*$/;
            if (!reg.test(self.change.callOutPhone)) {
              self.myAlert('只能填写正整数');
              return false;
            }
            if (arg.pending()) return;
            arg.pending(true);
            var data = {
              'examineRecordId': self.examineRecordId,
              'callOutPhone': self.change.callOutPhone
            };
            self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/updateCallOutPhone', data).then(function (response) {
              arg.pending(false);
              var result = response.data;
              if (result.success) {
                self.$message({
                  message: '已修改',
                  type: 'success',
                  center: true,
                  duration: 1000
                });
                arg.close();
              } else {
                self.myAlert(result.msg);
              }
            }, function (response) {
              self.myAlert('网络繁忙，请稍后重试！');
            });
          }
        });
      }).catch(function () {});
    }
  }
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'people': '',
      //等待人数
      'time': '',
      //等待时间
      'eventName': '',
      //事件名称
      'eventData': '',
      //事件数据
      'phone': '',
      //外呼电话号码
      'tjkId': '',
      //当前淘金客ID
      'list': [],
      //待考核名单列表
      'interval': null,
      //轮询状态
      'refresh': '',
      //列表是否刷新
      //当前拨打电话等待时间定时器
      'callInterval': null,
      //当前拨打电话等待时间(秒)
      'currCallTimeForSecond': 0,
      //当前通话电话时间定时器
      'callingInterval': null,
      //当前通话电话时间(秒)
      'currCallingTimeForSecond': 0,
      'socketUrl': {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.wsUrl,
      //容联ws
      'hawkeyeSocketUrl': {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.hawkeyeUrl,
      //小助手
      //保存ws链接
      'connection': null,
      //ws是否连接
      'isopen': false,
      //是否通过小助手打电话
      'isHawkeyeCall': true,
      //WS重连次数
      'tryTime': 0,
      //小助手是否已提示升级
      'isAlert': false,
      //根据answer来判断是否接听端正忙
      'isAnswer': false,
      //等待接通电话标识
      'isWait': false,
      'merchantId': 387
    };
  },
  mounted: function mounted() {
    this.init();
    this.intervalFun();
    this.getList();
  },
  watch: {
    refresh: function refresh() {
      if (this.refresh == 'Yes') {
        this.getList();
      }
    }
  },
  computed: {
    // 通话时间00:00:00
    currCallingTimeForStr: function currCallingTimeForStr() {
      var h = parseInt(this.currCallingTimeForSecond / (60 * 60));
      var m = parseInt(this.currCallingTimeForSecond % (60 * 60) / 60);
      var s = parseInt(this.currCallingTimeForSecond % (60 * 60) % 60);
      return (h >= 10 ? h : '0' + h) + ':' + (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s);
    }
  },
  methods: {
    hawkeyeAlert: function hawkeyeAlert(msg) {
      var _this = this;
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          window.location.href = "/tjkStudy/tjkExam?groupId=" + _this.groupId;
        }
      });
    },
    myAlert: function myAlert(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {}
      });
    },
    //轮询代码
    intervalFun: function intervalFun() {
      var self = this;
      self.interval = setInterval(function () {
        console.log('this is interval...');
        self.init();
      }, 5000);
    },
    //轮询查询事件接口
    init: function init() {
      var _this2 = this;
      var data = {
        'groupId': this.groupId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/eventMsg', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.success = result.success;
          _this2.message = result.msg;
          _this2.eventName = result.data.eventName;
          _this2.eventData = result.data.eventData;
          if (_this2.eventName == 'StartCall') {
            _this2.phone = result.data.eventData.callPhone;
          }
          _this2.refresh = result.data.eventData.refresh;
        } else {
          _this2.myAlert(result.msg);
        }
      }, function (response) {
        _this2.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //查询考核名单列表
    getList: function getList() {
      var _this3 = this;
      var data = {
        'groupId': this.groupId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/tjkView', data).then(function (response) {
        var result = response.data;
        _this3.successList = result.success;
        _this3.message = result.msg;
        if (result.success) {
          _this3.list = result.data.list;
          _this3.people = result.data.number;
          _this3.time = result.data.duration;
          for (var i = 0; i < result.data.list.length; i++) {
            if (result.data.list[i].myself == 'Yes') {
              _this3.tjkId = result.data.list[i].tjkId;
            }
          }
        }
      }, function (response) {
        _this3.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //当前淘金客高亮
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      if (row.myself == 'Yes') {
        return 'myself-row';
      }
      return '';
    },
    //确认考核
    confirmExam: function confirmExam() {
      this.changeStatus('Confirmed');
    },
    //更新淘金客状态--确认考核
    changeStatus: function changeStatus(status) {
      var _this4 = this;
      var data = {
        'groupId': this.groupId,
        'userState': status
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/updateUserState', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.init();
        } else {
          _this4.myAlert(result.msg);
        }
      }, function (response) {
        _this4.myAlert('网络繁忙，请稍后重试！');
      });
    },
    // 链接WS和小助手
    callClick: function callClick() {
      if (this.isopen && this.isHawkeyeCall) {
        this.callPhone();
      } else {
        this.initWS();
      }
    },
    // 初始化websocket链接
    initWS: function initWS() {
      var self = this,
        data = {
          'agent': self.tjkId,
          'code': 0
        };
      if (!window.WebSocket) {
        self.myAlert("您的浏览器版本过低，无法完成工作，请更换至谷歌或者IE10！");
        return false;
      }
      console.log("WebSocket is supported by your Browser!");
      self.hawkeyeConnectionFunc('connect');
      if (!self.isopen) {
        self.connectionFunc(data);
      }
    },
    // 创建websocket链接
    connectionFunc: function connectionFunc(data) {
      var self = this;
      self.connection = new WebSocket(self.socketUrl);
      self.connection.onopen = function () {
        console.log("Webpage web socket is connected");
        self.isopen = true;
        self.connection.send(JSON.stringify(data));
      };
      self.connection.onmessage = function (result) {
        // console.log("Message is received...: " + result.data)
        var data = eval('(' + result.data + ')'),
          status = data.code == "200",
          msg = data.msg,
          rst = data.rst;

        // 成功拨打返回，显示弹层 SIP应答
        if (msg == "calling") {
          self.afterCalling();
        }
        // 接听电话
        if (msg == "answer") {
          self.isAnswer = true;
          self.afterAnswer();
        }
        //挂断电话-未接听
        if (msg == 'sipOutCallEnd' && !self.isAnswer) {
          self.busyFun();
        }
        //挂断电话--已接听
        if (msg == 'sipOutCallEnd' && self.isAnswer) {
          self.isAnswer = false;
          self.hangedUp();
        }
        if (msg == "makecall_error") {
          self.myAlert("拨打失败: " + rst.msg);
        }
        // 预警
        if (msg == "warning") {
          self.myAlert('温馨提示：' + rst.reason);
        }
      };
      self.connection.onclose = function () {
        console.log('Connection is closed...');
        self.isopen = false;
        // 重试5次，每次之间间隔5秒
        if (self.tryTime < 5) {
          setTimeout(function () {
            self.connection = null;
            self.tryTime++;
            self.connectionFunc({
              'agent': self.tjkId,
              'code': 0
            });
            console.log("第" + self.tryTime + "次重连");
          }, 5000);
        } else {
          self.alert("webSocket重连失败");
        }
      };
      self.connection.onerror = function () {
        self.isopen = false;
        console.log('Connection is error.');
      };
    },
    hawkeyeConnectionFunc: function hawkeyeConnectionFunc(data) {
      var self = this;
      self.hawkeyeConnection = new WebSocket(self.hawkeyeSocketUrl);
      self.hawkeyeConnection.onopen = function () {
        self.isHawkeyeCall = true;
        console.log("Hawkeye web socket is connected");
        self.hawkeyeConnection.send(data);
      };
      self.hawkeyeConnection.onmessage = function (result) {
        console.log("Hawkeye message is received...: " + result.data);
        if (result.data == 0) {
          self.myAlert("小助手已离线，请重启小助手后刷新当前页面！");
          return;
        }
        if (result.data == 'Success') {
          //拨号
          self.callPhone();
        }
        if (result.data == 'GetSipAccountFailure') {
          self.hawkeyeAlert("获取SIP账号失败，请稍候再重新外呼！");
          return;
        }
        if (result.data == 'NoMic') {
          self.hawkeyeAlert("请先插入麦克风和耳机！");
          return;
        }
        if (result.data == 'InitSipFailure') {
          self.hawkeyeAlert("初始化SIP电话发生异常，请稍候再重新外呼！");
          return;
        }
      };
      self.hawkeyeConnection.onclose = function () {
        console.log("Hawkeye connection is closed...");
        self.isHawkeyeCall = false;
        if (!self.isAlert) {
          self.isAlert = true;
          self.myAlert('请检查是否是新版小助手且开启！');
        }
      };
      self.hawkeyeConnection.onerror = function () {
        console.log("Hawkeye connection is error.");
        self.isHawkeyeCall = false;
        if (!self.isAlert) {
          self.isAlert = true;
          self.myAlert('请检查是否是新版小助手且开启！');
        }
      };
    },
    // 开始拨打电话
    callPhone: function callPhone() {
      var _this5 = this;
      if (this.isHawkeyeCall) {
        this.hawkeyeConnection.send('call|' + this.phone + ',' + 0 + ',' + 0);
        this.isWait = true;
        this.callInterval = setInterval(function () {
          _this5.currCallTimeForSecond++;
        }, 1000);
        console.log('拨号中...');
      } else {
        this.myAlert('请检查是否是新版小助手且开启！');
      }
    },
    //对方忙的情况下主动挂断电话
    endCall: function endCall() {
      this.hawkeyeConnectionFunc('hangup');
      console.log('主动挂断电话..');
      this.currCallTimeForSecond = 0;
      clearInterval(this.callInterval);
      this.isWait = false;
    },
    // busy状态的回调-淘金客状态变成重新开始外呼
    busyFun: function busyFun() {
      this.currCallTimeForSecond = 0;
      clearInterval(this.callInterval);
    },
    // SIP点击了应答-等待接通
    afterCalling: function afterCalling() {},
    //电话接通
    afterAnswer: function afterAnswer() {
      var self = this;
      self.isWait = false;
      self.currCallTimeForSecond = 0;
      clearInterval(self.callInterval);
      // 当前接通电话时间为0
      self.currCallingTimeForSecond = 0;
      // 开始通话计时并且显示通话界面
      self.callingInterval = setInterval(function () {
        self.currCallingTimeForSecond++;
      }, 1000);
      //淘金客状态变为通话中
      self.changeStatus('Call');
      console.log('电话接通...');
    },
    // 挂断
    hangedUp: function hangedUp() {
      var self = this;
      // 清空通话定时器和时间
      self.currCallingTimeForSecond = 0;
      clearInterval(self.callingInterval);
      //淘金客状态变为通话结束
      self.changeStatus('Callend');
      self.hawkeyeConnectionFunc('hangup');
      console.log('小助手hangup..');
      console.log('挂断..');
    }
  }
};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName,
      'tjkId': '',
      //当前考核人员的tjkId
      'userList': {},
      //当前和下一个考核人员信息
      'list': [],
      //考核名单列表
      'waitNum': '',
      //剩余考核人数
      'callOutPhone': '',
      //当前外呼电话号码
      'codeName': '',
      //当前考核代号
      'examineRecordId': this.$route.query.id,
      //当前考核记录id
      'examineId': '',
      //群考核记录id
      'change': {
        callOutPhone: ''
      },
      //修改外呼电话 
      'interval': null,
      //轮询状态
      'status': false //是否考核完成 无考核人员和结束考核后为true
    };
  },
  mounted: function mounted() {
    this.initUser();
    this.intervalFun();
    this.getList();
  },
  methods: {
    myAlert: function myAlert(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {}
      });
    },
    //轮询代码
    intervalFun: function intervalFun() {
      var _this = this;
      var self = this;
      self.interval = setInterval(function () {
        console.log('this is heartbeat...');
        _this.initUser();
      }, 5000);
    },
    //查询当前和下一个考核人员信息
    initUser: function initUser() {
      var _this2 = this;
      var data = {
        'examineRecordId': this.examineRecordId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/userState', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.success = result.success;
          _this2.message = result.msg;
          _this2.userList = result.data;
          _this2.tjkId = !!result.data.current ? result.data.current.tjkId : '';
          _this2.waitNum = result.data.waitNum;
          _this2.callOutPhone = result.data.callOutPhone;
          _this2.codeName = result.data.codeName;
          _this2.examineId = !!result.data.current && !!result.data.current.evaluation ? result.data.current.evaluation.examineId : '';
          if (!result.data.current && !result.data.next) {
            _this2.status = true;
            _this2.endExam();
            clearInterval(_this2.interval);
          }
        } else {
          _this2.myAlert(result.msg);
        }
      }, function (response) {
        _this2.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //查询考核名单列表
    getList: function getList() {
      var _this3 = this;
      var data = {
        'examineRecordId': this.examineRecordId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/manageView', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.success = result.success;
          _this3.message = result.msg;
          _this3.list = result.data;
        } else {
          _this3.myAlert(result.msg);
        }
      }, function (response) {
        _this3.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //时间格式化
    formatTime: function formatTime(time) {
      if (!!time) {
        var h = parseInt(time / (60 * 60));
        var m = parseInt(time % (60 * 60) / 60);
        var s = parseInt(time % (60 * 60) % 60);
        return (h >= 10 ? h : '0' + h) + ':' + (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s);
      } else {
        return '';
      }
    },
    //语音考核打分并标记是否通过
    saveScore: function saveScore(passState) {
      var reg = /^[1-9]\d*|0$/;
      if (!!this.score && !reg.test(this.score)) {
        this.myAlert('分数只能是非负整数');
        return false;
      }
      if (!!this.remark && this.remark.length > 200) {
        this.myAlert('备注不能超过200字');
        return false;
      }
      this.saveScoreFun(passState);
    },
    //保存打分
    saveScoreFun: function saveScoreFun(passState) {
      var _this4 = this;
      var data = {
        'groupId': this.groupId,
        'tjkId': this.tjkId,
        'examineId': this.examineId,
        'passState': passState
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/waitJob/examine/score', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this4.initUser();
          _this4.getList();
        } else {
          _this4.myAlert(result.msg);
        }
      }, function (response) {
        _this4.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //考核结束
    endExam: function endExam() {
      var _this5 = this;
      var data = {
        'groupId': this.groupId,
        'recordType': 'WaitJob'
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/end', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.status = true;
          clearInterval(self.interval);
          window.location.href = '/tjkStudy/waitWork?groupId=' + _this5.groupId + '&groupName=' + _this5.groupName;
        } else {
          _this5.myAlert(result.msg);
        }
      }, function (response) {
        _this5.myAlert('网络繁忙，请稍后重试！');
      });
    },
    //修改外呼电话
    changePhone: function changePhone() {
      var _this6 = this;
      var self = this;
      self.change.callOutPhone = '';
      this.$confirm('修改学员拨打电话，下一位学员生效。是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.$refs.change.open({
          title: '修改外呼电话',
          width: 600,
          callBack: function callBack(arg) {
            if (arg.type === 'cancel') {
              arg.close();
              return;
            }
            if (self.change.callOutPhone == '') {
              self.myAlert('外呼电话不能为空');
              return false;
            }
            var reg = /^[0-9]*[1-9][0-9]*$/;
            if (!reg.test(self.change.callOutPhone)) {
              self.myAlert('只能填写正整数');
              return false;
            }
            if (arg.pending()) return;
            arg.pending(true);
            var data = {
              'examineRecordId': self.examineRecordId,
              'callOutPhone': self.change.callOutPhone
            };
            self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/examine/updateCallOutPhone', data).then(function (response) {
              arg.pending(false);
              var result = response.data;
              if (result.success) {
                self.$message({
                  message: '已修改',
                  type: 'success',
                  center: true,
                  duration: 1000
                });
                arg.close();
              } else {
                self.myAlert(result.msg);
              }
            }, function (response) {
              self.myAlert('网络繁忙，请稍后重试！');
            });
          }
        });
      }).catch(function () {});
    }
  }
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'retrialGroupId': this.$route.query.groupId,
      'tjkId': '',
      //搜索的淘金客id
      'multipleSelection': [],
      'release': {
        'publishMsg': '恭喜你通过基础复训，赶快去领取任务吧。'
      },
      'groupName': '',
      //考核群名称
      'list': [],
      'onlineTableHeight': window.innerHeight - 220
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var data = {
        'retrialGroupId': this.retrialGroupId,
        'tjkId': this.tjkId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/retrialRecord/queryList', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          _this.groupName = result.data.groupName;
          _this.list = result.data;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //保存打分
    saveScore: function saveScore() {
      var self = this,
        ids = [],
        isOk = true; //表单是否校验通过

      self.list.map(function (item) {
        if (!!item.passRemark && item.passRemark.length > 200) {
          self.$alert('备注不能超过200字');
          isOk = false;
          return false;
        }
      });
      self.list.map(function (item) {
        if (!!item.retrialState) {
          ids.push({
            'retrialRecordId': item.retrialRecordId,
            'retrialState': item.retrialState,
            'passRemark': !!item.passRemark ? item.passRemark : ''
          });
        }
      });
      if (isOk) {
        self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/retrialRecord/updateRetrialRecords', {
          'retrialRecordList': ids
        }).then(function (response) {
          var result = response.data;
          if (result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            });
            self.getList();
          } else {
            self.$alert(result.msg);
            self.getList();
          }
        }, function (response) {
          self.$alert('网络繁忙，请稍后重试！');
        });
      }
    },
    //发布成绩
    releaseGroup: function releaseGroup() {
      var self = this;
      self.release.publishMsg = '恭喜你通过基础复训，赶快去领取任务吧。';
      //筛选状态有值的淘金客
      var ids = [];
      if (self.multipleSelection.length > 0) {
        self.multipleSelection.map(function (item) {
          ids.push(item.retrialRecordId);
        });
      }
      this.$refs.release.open({
        title: '发布成绩',
        width: 600,
        callBack: function callBack(arg) {
          if (arg.type === 'cancel') {
            arg.close();
            return;
          }
          if (self.release.publishMsg == '') {
            self.$alert('发送消息不能为空');
            return false;
          }
          if (arg.pending()) return;
          arg.pending(true);
          var data = {
            'retrialGroupId': self.retrialGroupId,
            'publishMsg': self.release.publishMsg,
            'retrialRecordIds': ids
          };
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/retrialRecord/publishRetrialRecord', data).then(function (response) {
            arg.pending(false);
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '已发布',
                type: 'success',
                center: true,
                duration: 1000
              });
              arg.close();
              self.getList();
            } else {
              self.$alert(result.msg);
              self.getList();
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        }
      });
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //淘金客自动搜索
    updateTjkId: function updateTjkId(val) {
      this.tjkId = val;
    }
  }
};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'success': true,
      'message': '',
      'pageNum': 1,
      'pageSize': 10,
      'pages': 1,
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.name,
      'activeName': 'first',
      //当前tab
      'tjkId': '',
      //搜索的淘金客id
      'queryGroupId': '',
      //所属群id
      'teacherId': '',
      //培训老师id
      'multipleSelection': [],
      'badgeName': '',
      //联动课程通过后获得徽章名称
      'totalList': [],
      //总学习学员名单列表
      'tabList': [],
      //联动课程tab查询
      'courseId': '',
      //当前联动课程id
      'linkageList': [],
      //联动课程列表
      'teacherList': [] //基础培训老师列表
    };
  },
  watch: {
    courseId: function courseId() {
      for (var i = 0; i < this.tabList.length; i++) {
        if (this.courseId == this.tabList[i].courseId) {
          this.badgeName = this.tabList[i].badgeName;
        }
      }
    }
  },
  mounted: function mounted() {
    this.getLinkageTab();
    this.getTeacherList();
    this.getList(1);
  },
  methods: {
    //查询培训老师列表
    getTeacherList: function getTeacherList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.teamTalk + '/basic/teacher/query').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          _this.teacherList = result.data;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //tab切换
    handleClick: function handleClick(tab) {
      if (tab.name == 'first') {
        this.getList(1);
      } else {
        this.courseId = tab.name;
        this.getLinkageList(1);
      }
    },
    //总学习学员名单查询
    getList: function getList(num) {
      var _this2 = this;
      var data = {
        'groupId': this.groupId,
        'tjkId': this.tjkId,
        'queryGroupId': this.queryGroupId,
        'teacherId': this.teacherId,
        'pageNum': num,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryTjkList', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.success = result.success;
          _this2.message = result.msg;
          _this2.pageNum = result.data.pageNum;
          _this2.pages = result.data.pages;
          _this2.totalList = result.data.list;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('网络繁忙，请稍后重试！');
      });
    },
    //查询联动课程tab
    getLinkageTab: function getLinkageTab() {
      var _this3 = this;
      var data = {
        'groupId': this.groupId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryLinkage', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.success = result.success;
          _this3.message = result.msg;
          _this3.tabList = result.data;
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('网络繁忙，请稍后重试！');
      });
    },
    //查询联动课程列表
    getLinkageList: function getLinkageList(num) {
      var _this4 = this;
      var data = {
        'courseId': this.courseId,
        'tjkId': this.tjkId,
        'pageNum': num,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/courseExamine/queryByCourseId', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.success = result.success;
          _this4.message = result.msg;
          _this4.pageNum = result.data.pageNum;
          _this4.pages = result.data.pages;
          _this4.linkageList = result.data.list;
        } else {
          _this4.$alert(result.msg);
        }
      }, function (response) {
        _this4.$alert('网络繁忙，请稍后重试！');
      });
    },
    //学员通过课程-单个操作
    passSingle: function passSingle(evaluationId) {
      var evaluationIds = [];
      evaluationIds.push(evaluationId);
      var data = {
        'courseId': this.courseId,
        'evaluationIds': evaluationIds
      };
      this.passFunction(data);
    },
    //学员通过课程
    passEvaluations: function passEvaluations() {
      var ids = [];
      this.multipleSelection.map(function (item) {
        ids.push(item.evaluationId);
      });
      if (ids.length == 0) {
        this.$alert('请先选择淘金客');
        return false;
      }
      var data = {
        'courseId': this.courseId,
        'evaluationIds': ids
      };
      this.passFunction(data);
    },
    //通过操作-功能方法
    passFunction: function passFunction(data) {
      var _this5 = this;
      var self = this;
      this.$confirm('标记学员通过课程将颁发"' + this.badgeName + '徽章"给客服，确认名单无误？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/courseExamine/passEvaluations', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            });
            self.getLinkageList(_this5.pageNum);
          } else {
            self.$alert(result.msg);
          }
        }, function (response) {
          self.$alert('网络繁忙，请稍后重试！');
        });
      }).catch(function () {});
    },
    //number转换为string
    getString: function getString(name) {
      return JSON.stringify(name);
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //淘金客自动搜索
    updateTjkId: function updateTjkId(val) {
      this.tjkId = val;
    }
  }
};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      pageNum: 1,
      pageSize: 24,
      pages: 1,
      groupId: this.$route.query.groupId,
      //gg80233497726
      groupName: this.$route.query.groupName,
      list: [],
      add: {
        title: '',
        description: '',
        expireTime: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请输入面试主题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 10,
          message: '长度在 1 到 10 个字符',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: '请输入面试邀请简述',
          trigger: 'blur'
        }, {
          min: 1,
          max: 200,
          message: '长度在 1 到 200 个字符',
          trigger: 'blur'
        }],
        expireTime: [{
          required: true,
          message: '请选择截止日期',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList(1);
  },
  methods: {
    getList: function getList(num) {
      var _this = this;
      var data = {
        'groupId': this.groupId,
        'pageNum': num,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/interview/query', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.pageNum = result.data.pageNum;
          _this.pages = result.data.pages;
          _this.list = result.data.list;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //弹出层关闭-新增
    handleClose: function handleClose() {
      this.$refs['add'].resetFields();
      this.dialogVisible = false;
    },
    //新建面试邀请
    addNew: function addNew() {
      var self = this;
      this.$refs.add.validate(function (valid) {
        if (valid) {
          self.add.groupId = self.groupId;
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/interview/add', self.add).then(function (response) {
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '已添加',
                type: 'success',
                center: true,
                duration: 1000
              });
              self.handleClose();
              self.getList(1);
            } else {
              self.$alert(result.msg);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        } else {
          return false;
        }
      });
    },
    //时间
    changeHandlerStart: function changeHandlerStart(val) {
      this.add.expireTime = val;
    }
  }
};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      dialogVisibleTjk: false,
      groupId: this.$route.params.groupId,
      groupName: this.$route.params.groupName,
      interviewInviteId: this.$route.params.id,
      pageNum: 1,
      pageSize: 10,
      pages: 1,
      tjkId: '',
      tjkList: [],
      modal: {
        applyId: '',
        remark: ''
      },
      nick: '',
      //昵称
      age: '',
      //年龄
      wechatId: '',
      //绑定微信
      registerTime: '',
      //注册日期
      providerTag: '',
      //客服标签
      providerName: '',
      //所属团队
      advantage: '',
      //我的优势
      channel: '',
      //注册来源
      expectedWork: [],
      //期望工作类型
      acceptShortProject: '',
      //特殊任务要求
      haveChildren: '',
      //是否有小孩
      lowestSalary: '',
      //最低接受薪酬
      workHours: '',
      //每天可工作时长
      experience: '',
      //平台外客服经验
      experienceWork: [],
      //平台外经验工作类型
      industryed: [],
      //擅长行业
      language: [],
      //擅长语种
      education: '',
      //学历
      rules: {
        remark: [{
          min: 1,
          max: 100,
          message: '长度在 1 到 100 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getTjkList(1);
  },
  methods: {
    //查询面试申请人信息
    getTjkList: function getTjkList(num) {
      var _this = this;
      var data = {
        'interviewInviteId': this.interviewInviteId,
        'tjkId': this.tjkId,
        'pageNum': num,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/interview/applyRecord', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.pageNum = result.data.pageNum;
          _this.pages = result.data.pages;
          _this.tjkList = result.data.list;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //弹出层关闭-新增
    handleClose: function handleClose() {
      this.$refs['modal'].resetFields();
      this.dialogVisible = false;
    },
    addRemark: function addRemark(applyId, remark) {
      this.modal.applyId = applyId;
      this.modal.remark = remark;
      this.dialogVisible = true;
    },
    addRemarkFun: function addRemarkFun() {
      var _this2 = this;
      var self = this;
      this.$refs.modal.validate(function (valid) {
        if (valid) {
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/interview/remark', self.modal).then(function (response) {
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '操作成功',
                type: 'success',
                center: true,
                duration: 1000
              });
              self.handleClose();
              self.getTjkList(_this2.pageNum);
            } else {
              self.$alert(result.msg);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        } else {
          return false;
        }
      });
    },
    //通过/不通过
    updateState: function updateState(applyId, passState) {
      var _this3 = this;
      var data = {
        'applyId': applyId,
        'passState': passState
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/interview/evaluation', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.$message({
            message: '已修改',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this3.getTjkList(_this3.pageNum);
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('网络繁忙，请稍后重试！');
      });
    },
    //查询淘金客个人信息
    queryTjkFun: function queryTjkFun(tjkId) {
      this.queryTjk(tjkId);
      this.queryTjkTypes(tjkId);
      this.dialogVisibleTjk = true;
    },
    //查询个人信息
    queryTjk: function queryTjk(tjkId) {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjk + '/manageInfo/getTjkDatabase', {
        'tjkId': tjkId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.nick = result.data.tjkUserExt.nick;
          _this4.age = result.data.tjkUserExt.age;
          _this4.wechatId = result.data.tjkUserExt.wechatId;
          _this4.registerTime = result.data.tjkUserExt.registerTime;
          _this4.providerTag = result.data.providerTag;
          _this4.providerName = result.data.providerName;
        } else {
          _this4.$alert(result.msg);
        }
      }, function (response) {
        _this4.$alert('网络繁忙，请稍后重试！');
      });
    },
    //查询个人信息
    queryTjkTypes: function queryTjkTypes(tjkId) {
      var _this5 = this;
      this.expectedWork = [];
      this.experienceWork = [];
      this.industryed = [];
      this.language = [];
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/personalInfo/getManagePersonTypes', {
        'tjkId': tjkId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          for (var i = 0; i < result.data.length; i++) {
            if (result.data[i].typeName == '我的优势') {
              _this5.advantage = result.data[i].typeValue;
            }
            if (result.data[i].typeName == '从何知晓淘金渠道') {
              for (var j = 0; j < result.data[i].childrenList.length; j++) {
                if (result.data[i].childrenList[j].checked == 'Yes') {
                  _this5.channel = result.data[i].childrenList[j].typeName;
                }
              }
            }
            if (result.data[i].typeName == '是否有小孩') {
              _this5.haveChildrenList = result.data[i].childrenList;
              for (var j = 0; j < result.data[i].childrenList.length; j++) {
                if (result.data[i].childrenList[j].checked == 'Yes') {
                  _this5.haveChildren = result.data[i].childrenList[j].typeName;
                }
              }
            }
            if (result.data[i].typeName == '期望工作类型') {
              for (var j = 0; j < result.data[i].childrenList.length; j++) {
                if (result.data[i].childrenList[j].checked == 'Yes') {
                  _this5.expectedWork.push(result.data[i].childrenList[j].typeName);
                }
              }
            }
            if (result.data[i].typeName == '是否接收短期项目') {
              for (var j = 0; j < result.data[i].childrenList.length; j++) {
                if (result.data[i].childrenList[j].checked == 'Yes') {
                  _this5.acceptShortProject = result.data[i].childrenList[j].typeName;
                }
              }
            }
            if (result.data[i].typeName == '最低可接收薪酬') {
              for (var j = 0; j < result.data[i].childrenList.length; j++) {
                if (result.data[i].childrenList[j].checked == 'Yes') {
                  _this5.lowestSalary = result.data[i].childrenList[j].typeName;
                }
              }
            }
            if (result.data[i].typeName == '每天可用于平台的工作时长') {
              for (var j = 0; j < result.data[i].childrenList.length; j++) {
                if (result.data[i].childrenList[j].checked == 'Yes') {
                  _this5.workHours = result.data[i].childrenList[j].typeName;
                }
              }
            }
            if (result.data[i].typeName == '平台外经验') {
              if (result.data[i].childrenList[0].typeName == '平台外客服经验') {
                for (var j = 0; j < result.data[i].childrenList[0].childrenList.length; j++) {
                  if (result.data[i].childrenList[0].childrenList[j].checked == 'Yes') {
                    _this5.experience = result.data[i].childrenList[0].childrenList[j].typeName;
                  }
                }
              }
              if (result.data[i].childrenList[1].typeName == '平台外经验工作类型') {
                for (var j = 0; j < result.data[i].childrenList[1].childrenList.length; j++) {
                  if (result.data[i].childrenList[1].childrenList[j].checked == 'Yes') {
                    _this5.experienceWork.push(result.data[i].childrenList[1].childrenList[j].typeName);
                  }
                }
              }
              if (result.data[i].childrenList[2].typeName == '行业') {
                for (var j = 0; j < result.data[i].childrenList[2].childrenList.length; j++) {
                  if (result.data[i].childrenList[2].childrenList[j].checked == 'Yes') {
                    _this5.industryed.push(result.data[i].childrenList[2].childrenList[j].typeName);
                  }
                }
              }
            }
            if (result.data[i].typeName == '擅长语种') {
              for (var j = 0; j < result.data[i].childrenList.length; j++) {
                if (result.data[i].childrenList[j].checked == 'Yes') {
                  _this5.language.push(result.data[i].childrenList[j].typeName);
                }
              }
            }
            if (result.data[i].typeName == '学历') {
              for (var j = 0; j < result.data[i].childrenList.length; j++) {
                if (result.data[i].childrenList[j].checked == 'Yes') {
                  _this5.education = result.data[i].childrenList[j].typeName;
                }
              }
            }
          }
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('网络繁忙，请稍后重试！');
      });
    }
  }
};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      'dialogVisible': false,
      'success': true,
      'message': '',
      'pageNum': 1,
      'pageSize': 10,
      'pages': 1,
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName,
      'tjkId': '',
      'queryStartTime': '',
      'queryEndTime': '',
      'name': '',
      'list': [],
      'modal': {
        name: '',
        time: ''
      },
      'rules': {
        name: [{
          required: true,
          message: '请输入签到主题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 5,
          message: '长度在 1 到 5 个字符',
          trigger: 'blur'
        }],
        time: [{
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList(1);
  },
  methods: {
    getList: function getList(num) {
      var _this = this;
      var data = {
        'groupId': this.groupId,
        'tjkId': this.tjkId,
        'queryStartTime': this.queryStartTime,
        'queryEndTime': this.queryEndTime,
        'name': this.name,
        'pageNum': num,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/checkin/queryRecord', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          _this.pageNum = result.data.pageNum;
          _this.pages = result.data.pages;
          _this.list = result.data.list;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //弹出层关闭-发起签到
    handleClose: function handleClose() {
      this.$refs['modal'].resetFields();
      this.dialogVisible = false;
    },
    //发起签到
    addCheckIn: function addCheckIn() {
      var self = this;
      this.$refs.modal.validate(function (valid) {
        if (valid) {
          self.modal.groupId = self.groupId;
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/checkin/add', self.modal).then(function (response) {
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '已添加',
                type: 'success',
                center: true,
                duration: 1000
              });
              self.handleClose();
              self.getList(1);
            } else {
              self.$alert(result.msg);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        } else {
          return false;
        }
      });
    },
    //导出
    getExcel: function getExcel() {
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = arr != null ? unescape(arr[2]) : null;
      if (this.queryStartTime == null || this.queryEndTime == null) {
        this.queryStartTime = '';
        this.queryEndTime = '';
      }
      var url = {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/checkin/export/checkRecord?tjk_login_token=' + login_token + '&groupId=' + this.groupId + '&tjkId=' + this.tjkId + '&name=' + this.name + '&queryStartTime=' + this.queryStartTime + '&queryEndTime=' + this.queryEndTime;
      window.open(url);
    },
    //淘金客自动搜索
    updateTjkId: function updateTjkId(val) {
      this.tjkId = val;
    },
    //开始时间
    changeHandlerStart: function changeHandlerStart(val) {
      this.queryStartTime = val;
    },
    //结束时间
    changeHandlerEnd: function changeHandlerEnd(val) {
      this.queryEndTime = val;
    }
  }
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      success: true,
      message: '',
      groupId: this.$route.query.groupId,
      tjkId: '',
      //搜索的淘金客id
      providerId: '',
      //搜索的合作公司id
      passState: '',
      //通过状态
      checkInTimes: '',
      //签到次数
      checkInStartTime: '',
      checkInEndTime: '',
      multipleSelection: [],
      groupName: this.$route.query.groupName,
      //考核群名称
      list: [],
      examiningList: [],
      check: {
        callPhone: '',
        averageDuration: ''
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var data = {
        'groupId': this.groupId,
        'tjkId': this.tjkId,
        'providerId': this.providerId,
        'passState': this.passState,
        'checkInTimes': this.checkInTimes,
        'checkInStartTime': this.checkInStartTime,
        'checkInEndTime': this.checkInEndTime
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorEvaluation/queryOperatorEvaluations', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          _this.list = result.data.evaluationRecords;
          _this.examiningList = result.data.examiningList;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //群考核
    checkGroup: function checkGroup() {
      var self = this;
      self.check.callOutPhone = '';
      self.check.averageDuration = '';
      var ids = [];
      self.multipleSelection.map(function (item) {
        ids.push(item.recordId);
      });
      if (ids.length == 0) {
        self.$alert('请先选择淘金客');
        return false;
      }
      this.$refs.check.open({
        title: '群考核',
        width: 800,
        callBack: function callBack(arg) {
          if (arg.type === 'cancel') {
            arg.close();
            return;
          }
          if (self.check.callPhone == '') {
            self.$alert('外呼电话不能为空');
            return false;
          }
          if (self.check.averageDuration == '') {
            self.$alert('平均外呼时长不能为空');
            return false;
          }
          var reg = /^[0-9]*[1-9][0-9]*$/;
          if (!reg.test(self.check.callPhone) || !reg.test(self.check.averageDuration)) {
            self.$alert('只能填写正整数');
            return false;
          }
          if (arg.pending()) return;
          arg.pending(true);
          var data = {
            'groupId': self.groupId,
            'callPhone': self.check.callPhone,
            'averageDuration': self.check.averageDuration,
            'recordIds': ids
          };
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorExam/startOperatorExam', data, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
          }).then(function (response) {
            arg.pending(false);
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '已添加',
                type: 'success',
                center: true,
                duration: 1000
              });
              arg.close();
              window.location.href = '/tjkStudy/enterExam?id=' + result.data.currentExamRecord.operatorExamId + '&groupId=' + self.groupId + '&groupName=' + self.groupName;
            } else {
              self.$alert(result.msg);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        }
      });
    },
    //保存打分
    saveScore: function saveScore() {
      var self = this,
        ids = [],
        isOk = true,
        //表单是否校验通过
        reg = /^[1-9]\d*|0$/;
      self.list.map(function (item) {
        if (!!item.score && !reg.test(item.score)) {
          self.$alert('分数只能是非负整数');
          isOk = false;
          return false;
        }
        if (!!item.remark && item.remark.length > 200) {
          self.$alert('备注不能超过200字');
          isOk = false;
          return false;
        }
      });
      self.list.map(function (item) {
        if (!!item.passState) {
          ids.push({
            'recordId': item.recordId,
            'passState': item.passState,
            'score': !!item.score ? item.score : 0,
            'remark': !!item.remark ? item.remark : ''
          });
        }
      });
      var data = {
        'groupId': self.groupId,
        'records': ids
      };
      if (isOk) {
        self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorEvaluation/batchScore', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            });
            self.list = result.data.evaluationRecords;
            self.examiningList = result.data.examiningList;
          } else {
            self.$alert(result.msg);
            self.getList();
          }
        }, function (response) {
          self.$alert('网络繁忙，请稍后重试！');
        });
      }
    },
    //发布成绩
    releaseGroup: function releaseGroup() {
      var self = this;
      //筛选状态有值的淘金客
      var ids = [];
      if (self.multipleSelection.length > 0) {
        self.multipleSelection.map(function (item) {
          ids.push({
            'recordId': item.recordId,
            'tjkId': item.tjkId,
            'providerId': item.providerId,
            'passState': item.passState,
            'score': item.score,
            'remark': item.remark
          });
        });
      }
      var data = {
        'groupId': self.groupId,
        'records': ids
      };
      self.$confirm('确定发布成绩？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorEvaluation/publishOperatorEvaluations', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            self.$message({
              message: '已发布',
              type: 'success',
              center: true,
              duration: 1000
            });
            self.list = result.data.evaluationRecords;
            self.examiningList = result.data.examiningList;
          } else {
            self.$alert(result.msg);
            self.getList();
          }
        }, function (response) {
          self.$alert('网络繁忙，请稍后重试！');
        });
      }).catch(function () {});
    },
    //结束培训
    endOperatorExam: function endOperatorExam() {
      var self = this,
        data = {
          'groupId': this.groupId
        };
      self.$confirm('结束后将会解散群，确定结束培训？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorEvaluation/endOperatorEvaluation', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            window.close();
          } else {
            self.$alert(result.msg);
          }
        }, function (response) {
          self.$alert('网络繁忙，请稍后重试！');
        });
      }).catch(function () {});
    },
    //导出
    getExcel: function getExcel() {
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = arr != null ? unescape(arr[2]) : null;
      var url = {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorEvaluation/exportOperatorExamEvaluations?tjk_login_token=' + login_token + '&groupId=' + this.groupId + '&tjkId=' + this.tjkId + '&providerId=' + this.providerId;
      window.open(url);
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //淘金客自动搜索
    updateTjkId: function updateTjkId(val) {
      this.tjkId = val;
    },
    //合作公司自动搜索
    updateProviderId: function updateProviderId(val) {
      this.providerId = val;
    },
    //开始时间
    changeHandlerStart: function changeHandlerStart(val) {
      this.checkInStartTime = val;
    },
    //结束时间
    changeHandlerEnd: function changeHandlerEnd(val) {
      this.checkInEndTime = val;
    }
  }
};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      success: true,
      message: '',
      groupId: this.$route.query.groupId,
      groupName: this.$route.query.groupName,
      operatorExamId: this.$route.query.id ? this.$route.query.id : '',
      //从列表页tab点击传入
      list: this.$route.query.list ? this.$route.query.list : [],
      //考核记录列表
      currentExamRecord: this.$route.query.current ? this.$route.query.current : '',
      //当前考核人
      callPhone: this.$route.query.phone ? this.$route.query.phone : '',
      //当前考核人
      recordId: '',
      examRecordId: '',
      passState: '',
      score: '',
      remark: '',
      realName: '',
      loginName: '',
      tjkNumber: ''
    };
  },
  mounted: function mounted() {
    this.initUser();
  },
  methods: {
    //查询当前考核人员信息
    initUser: function initUser() {
      var _this = this;
      var data = {
        'operatorExamId': this.operatorExamId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorExam/enterOperatorExam', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.success = result.success;
          _this.message = result.msg;
          _this.list = result.data.operatorExamRecords;
          if (result.data.currentExamRecord) {
            _this.currentExamRecord = result.data.currentExamRecord;
            _this.passState = result.data.currentExamRecord.passState;
            _this.score = result.data.currentExamRecord.score;
            _this.remark = result.data.currentExamRecord.remark;
            _this.realName = result.data.currentExamRecord.realName;
            _this.loginName = result.data.currentExamRecord.loginName;
            _this.tjkNumber = result.data.currentExamRecord.tjkNumber;
            _this.recordId = result.data.currentExamRecord.recordId;
            _this.examRecordId = result.data.currentExamRecord.examRecordId;
          } else {
            _this.currentExamRecord = null;
            _this.passState = '';
            _this.score = '';
            _this.remark = '';
            _this.realName = '';
            _this.loginName = '';
            _this.tjkNumber = '';
            _this.recordId = '';
            _this.examRecordId = '';
          }
          _this.callPhone = result.data.callPhone;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //语音考核打分并标记是否通过
    saveScore: function saveScore() {
      var _this2 = this;
      var reg = /^[1-9]\d*|0$/;
      if (!!this.score && !reg.test(this.score)) {
        this.$alert('分数只能是非负整数');
        return false;
      }
      if (!!this.remark && this.remark.length > 200) {
        this.$alert('备注不能超过200字');
        return false;
      }
      var data = {
        'groupId': this.groupId,
        'operatorExamId': this.operatorExamId,
        'examRecordId': this.examRecordId,
        'recordId': this.recordId,
        'passState': this.passState,
        'score': !!this.score ? this.score : 0,
        'remark': !!this.remark ? this.remark : ''
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorExam/saveOperatorExamRecord', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this2.initUser();
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('网络繁忙，请稍后重试！');
      });
    },
    //考核结束
    endExam: function endExam() {
      var _this3 = this;
      var data = {
        'operatorExamId': this.operatorExamId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorExam/endOperatorExam', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          window.location.href = '/tjkStudy/operatorExamine?groupId=' + _this3.groupId + '&groupName=' + _this3.groupName;
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('网络繁忙，请稍后重试！');
      });
    }
  }
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      success: true,
      message: '',
      groupId: this.$route.query.groupId,
      interval: null,
      //轮询状态
      callPhone: '',
      //外呼电话号码
      tjkExamRecord: null,
      //当前考核人员
      list: [],
      //待考核名单列表
      isCurrent: '',
      //是否进行考核
      passState: '',
      //是否通过
      score: '',
      //得分
      expectExamineTime: '',
      //预估考核时间
      isFinish: '',
      //是否完成考核
      currentlist: []
    };
  },
  mounted: function mounted() {
    this.intervalFun();
    this.getList();
  },
  methods: {
    //轮询代码
    intervalFun: function intervalFun() {
      var self = this;
      self.interval = setInterval(function () {
        console.log('this is interval...');
        self.getList();
      }, 30000);
    },
    //查询考核名单列表
    getList: function getList() {
      var _this = this;
      var data = {
        'groupId': this.groupId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/operatorExam/getTjkOperatorExamView', data).then(function (response) {
        var result = response.data;
        _this.success = result.success;
        _this.message = result.msg;
        if (result.success) {
          _this.list = result.data.operatorExamRecords;
          _this.tjkExamRecord = result.data.tjkExamRecord;
          if (_this.tjkExamRecord) {
            _this.passState = result.data.tjkExamRecord.passState;
            _this.score = result.data.tjkExamRecord.score;
            _this.isCurrent = result.data.tjkExamRecord.isCurrent;
            _this.expectExamineTime = result.data.tjkExamRecord.expectExamineTime;
            var arr = [];
            arr.splice(0, 1, result.data.tjkExamRecord);
            _this.currentlist = arr;
          } else {
            _this.passState = '';
            _this.score = '';
            _this.isCurrent = '';
            _this.expectExamineTime = '';
            _this.currentlist = [];
          }
          _this.callPhone = result.data.callPhone;
          for (var i = 0; i < result.data.operatorExamRecords.length; i++) {
            if (result.data.operatorExamRecords[i].isCurrent == 'Yes') {
              _this.isFinish = result.data.operatorExamRecords[i].isFinish;
            }
          }
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //当前淘金客高亮
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      if (row.isCurrent == 'Yes') {
        return 'myself-row';
      }
      return '';
    }
  }
};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
var _pddStudyScenarios = __webpack_require__(575);
var _StepPlayer = _interopRequireDefault(__webpack_require__(74));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TAB_KEYS = ['first', 'second', 'third', 'four', 'five', 'six', 'seven'];
var PDF_VIEWER_IDS = {
  first: 'pdf_viewer',
  second: 'pdf_viewer2',
  third: 'pdf_viewer3',
  four: 'pdf_viewer4',
  five: 'pdf_viewer5',
  six: 'pdf_viewer6',
  seven: 'pdf_viewer7'
};
var PDF_URLS = {
  first: '//res.study.itaojin.cn/1.%E7%99%BB%E5%BD%95%E6%8B%BC%E5%A4%9A%E5%A4%9A%E5%95%86%E5%AE%B6%E7%89%88.pdf',
  second: '//res.study.itaojin.cn/2.%E5%9F%BA%E7%A1%80%E8%AE%BE%E7%BD%AE.pdf',
  third: '//res.study.itaojin.cn/3.%E8%AE%A2%E5%8D%95%E7%AE%A1%E7%90%86%E5%B8%B8%E7%94%A8%E5%8A%9F%E8%83%BD.pdf',
  four: '//res.study.itaojin.cn/4.%E4%BC%9A%E8%AF%9D%E7%AA%97%E5%8F%A3%E5%B8%B8%E7%94%A8%E5%8A%9F%E8%83%BD.pdf',
  five: '//res.study.itaojin.cn/5.%E6%8F%92%E4%BB%B6%E5%B8%B8%E7%94%A8%E5%8A%9F%E8%83%BD%E5%AD%A6%E4%B9%A0.pdf',
  six: '//res.study.itaojin.cn/6.%E6%B7%BB%E5%8A%A0%E5%BF%AB%E6%8D%B7%E5%9B%9E%E5%A4%8D.pdf',
  seven: '//res.study.itaojin.cn/7.%E9%80%80%E5%87%BA%E8%B4%A6%E5%8F%B7.pdf'
};
var _default = exports.default = {
  components: {
    StepPlayer: _StepPlayer.default
  },
  data: function data() {
    var rightTip = {};
    var isOpenPpt = {};
    TAB_KEYS.forEach(function (k) {
      rightTip[k] = '';
      isOpenPpt[k] = false;
    });
    return {
      OnInline: 'false',
      tabIndex: 1,
      tabCurrent: 'first',
      isShowBtn: [],
      scenarioConfig: (0, _pddStudyScenarios.getScenarioConfig)(),
      rightTip: rightTip,
      isOpenPpt: isOpenPpt,
      currentStepId: TAB_KEYS.reduce(function (m, k) {
        m[k] = '';
        return m;
      }, {}),
      showLoginPassword: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this.tabCurrent).show();
      _this.$set(_this.isShowBtn, _this.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
    // 页面初始化时重置各关卡的内容显示与 StepPlayer 状态
    this.initAll();
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    resetFocus: function resetFocus() {},
    onFinish: function onFinish(tabKey) {
      this.addRecord('END');
      var self = this;
      setTimeout(function () {
        $('#studytip-' + tabKey).show();
      }, 2000);
    },
    onStepChange: function onStepChange(tabKey, stepId, step, resolvedTip) {
      this.$set(this.currentStepId, tabKey, stepId);
      if (tabKey === 'first' && stepId !== 'login') {
        this.showLoginPassword = false;
      }
      this.$set(this.rightTip, tabKey, resolvedTip || '');
    },
    onGuardFailed: function onGuardFailed(tabKey, res) {
      this.$alert(res && res.msg ? res.msg : '校验未通过');
    },
    onRequestFile: function onRequestFile() {
      this.$refs.fileInputSix && this.$refs.fileInputSix.click();
    },
    onSixFileChange: function onSixFileChange(evt) {
      var _this2 = this;
      var file = evt.target.files && evt.target.files[0];
      if (!file || file.name && file.name.indexOf('快捷短语') < 0) {
        this.$alert('请选择你下载的“快捷短语.csv”模板文件');
        return;
      }
      var player = this.$refs.playerSix;
      if (player) player.go('six_5');
      setTimeout(function () {
        if (_this2.$refs.fileInputSix) _this2.$refs.fileInputSix.value = '';
      }, 300);
    },
    downloadKjdyFile: function downloadKjdyFile() {
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      fetch(path).then(function (r) {
        return r.blob();
      }).then(function (blob) {
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = '快捷短语.csv';
        a.click();
        a.remove();
      });
    },
    /******************/
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('first').play();
      $('#startvideo').hide();
    },
    //初始化所有tab内容
    initAll: function initAll() {
      var _this3 = this;
      $('#startvideo').hide();
      this.isShowBtn = [];
      TAB_KEYS.forEach(function (k) {
        _this3.isOpenPpt[k] = false;
        _this3.rightTip[k] = '';
        var id = PDF_VIEWER_IDS[k];
        if (id && $('#' + id).length) $('#' + id).height('0');
      });
      var playerRefs = ['playerFirst', 'playerSecond', 'playerThird', 'playerFour', 'playerFive', 'playerSix', 'playerSeven'];
      playerRefs.forEach(function (ref, i) {
        var player = _this3.$refs[ref];
        if (player && _this3.scenarioConfig[TAB_KEYS[i]]) {
          player.reset(_this3.scenarioConfig[TAB_KEYS[i]].initialStepId);
        }
      });
      $('.content').each(function () {
        $(this).css('display', 'none');
      }); //todo none
      $('.stoptip').each(function () {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function () {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show(); //todo show
    },
    //tab切换
    handleClick: function handleClick(tab, event) {
      var _this4 = this;
      this.tabIndex = parseInt(tab.index) + 1;
      //内容初始化
      this.initAll();
      this.resetFocus();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this4.tabCurrent).show();
        _this4.$set(_this4.isShowBtn, _this4.tabCurrent, true);
      }, false);
    },
    //展开/收起ppt（tabKey: first|second|third|four|five|six|seven|eight, bol: false 表示收起）
    viewPpt: function viewPpt(tabKey, bol) {
      if (this.isOpenPpt[tabKey] === true || bol === false) {
        this.$set(this.isOpenPpt, tabKey, false);
        var id = PDF_VIEWER_IDS[tabKey];
        if (id && $('#' + id).length) $('#' + id).height('0');
      } else {
        this.$set(this.isOpenPpt, tabKey, true);
        var _id = PDF_VIEWER_IDS[tabKey];
        var url = PDF_URLS[tabKey];
        if (_id && url && _pdfobject.default.supportsPDFs) {
          $('#' + _id).height('700px');
          _pdfobject.default.embed(url, '#' + _id, {
            pdfOpenParams: {
              navpanes: 0,
              toolbar: 0,
              statusbar: 0,
              view: 'FitV',
              pagemode: 'thumbs',
              page: 1
            },
            forcePDFJS: true,
            PDFJS_URL: '//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html'
          });
        }
      }
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //开始实操练习
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.$set(this.isShowBtn, this.tabCurrent, false);
      $('#content-' + this.tabCurrent).css('display', 'flex');
      var ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1);
      var player = this.$refs[ref];
      var cfg = this.scenarioConfig[this.tabCurrent];
      if (player && cfg) {
        player.reset(cfg.initialStepId);
      }
      this.addRecord('START');
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initAll();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    restartStudy: function restartStudy() {
      var cfg = this.scenarioConfig[this.tabCurrent];
      if (!cfg) return;
      var ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1);
      var player = this.$refs[ref];
      if (player) player.reset(cfg.initialStepId);
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type) {
      var _this5 = this;
      var data = {
        exerciseType: 'PDD',
        stepSeq: this.tabIndex,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this5.tabIndex == 7 && type == 'END') {
            window.parent['goBack']();
          }
        } else {
          _this5.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this5.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScenarioConfig = getScenarioConfig;
/**
 * 拼多多
 * 每关: { steps, initialStepId, initialForm }
 * 步骤: id, image, tip, hotspots[], fields[], isEnd, afterEnter?: { delay, go }, onEnter?
 */
function r(path) {
  return __webpack_require__(1210)("./" + path);
}
function getScenarioConfig() {
  return {
    first: {
      initialStepId: 'desktop',
      initialForm: {
        name: '',
        password: '',
        rnd: ''
      },
      steps: [{
        id: 'desktop',
        image: function image(_ref) {
          var ui = _ref.ui;
          return ui.qnHover ? r('pddbg2.png') : r('pddbg1.png');
        },
        tip: '请双击<span style="color: red;font-weight:bold;">左侧练习场</span>中的拼多多图标进行登录',
        hotspots: [{
          id: 'qnIcon',
          x: 0.29,
          y: 0.26,
          w: 0.04,
          h: 0.08,
          on: 'dblclick',
          hoverSet: {
            qnHover: true
          },
          hoverUnset: {
            qnHover: false
          },
          next: 'login1'
        }]
      }, {
        id: 'login1',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('login1.png');
        },
        canvasScale: 0.7,
        tip: '点击<span style="color: red;font-weight:bold;">账号登录</span>',
        hotspots: [{
          id: 'aclg',
          x: 0.64,
          y: 0.15,
          w: 0.09,
          h: 0.06,
          next: 'login2'
        }]
      }, {
        id: 'login2',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image(_ref2) {
          var ui = _ref2.ui;
          if (ui.saveChecked) return r('login3.png');
          return r('login2.png');
        },
        canvasScale: 0.7,
        tip: '1.复制粘贴账号和密码<br>2.取消自动登录勾选',
        fields: [{
          id: 'name',
          model: 'name',
          type: 'text',
          bgColor: '#fff',
          placeholder: '账号名/手机号',
          x: 0.505,
          y: 0.38,
          w: 0.24,
          h: 0.065
        }, {
          id: 'pwd',
          model: 'password',
          type: 'password',
          bgColor: '#fff',
          placeholder: '登录密码',
          autocomplete: 'new-password',
          x: 0.505,
          y: 0.475,
          w: 0.24,
          h: 0.065
        }],
        hotspots: [{
          id: 'save',
          x: 0.69,
          y: 0.66,
          w: 0.02,
          h: 0.03,
          set: {
            saveChecked: true
          }
        }, {
          id: 'loginBtn',
          x: 0.50,
          y: 0.57,
          w: 0.25,
          h: 0.06,
          guard: function guard(_ref3) {
            var form = _ref3.form,
              ui = _ref3.ui;
            if (!ui.saveChecked) return {
              ok: false,
              msg: '不要勾选自动登录'
            };
            if (!form.name) return {
              ok: false,
              msg: '请输入账号'
            };
            if (form.name !== '淘金云客服:小淘') return {
              ok: false,
              msg: '用户名或密码错误，请注意大小写或特殊符号'
            };
            if (!form.password) return {
              ok: false,
              msg: '请输入密码'
            };
            if (form.password !== 'Tj1234') return {
              ok: false,
              msg: '用户名或密码错误，请注意大小写或特殊符号'
            };
            return {
              ok: true
            };
          },
          next: 'rnd'
        }]
      }, {
        id: 'rnd',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        canvasScale: 0.4,
        image: function image(_ref4) {
          var ui = _ref4.ui;
          if (ui.rndShown) return r('rnd2.png');
          return r('rnd1.png');
        },
        tip: function tip(_ref5) {
          var ui = _ref5.ui;
          return ui.rndShown ? '短信验证码：<br><span style="color: red;font-weight:bold;">660220</span>' : '<span style="color: red;font-weight:bold;">获取短信验证码</span>';
        },
        fields: [{
          id: 'rnd',
          model: 'rnd',
          type: 'text',
          bgColor: '#FFFFFF',
          placeholder: '输入短信验证码',
          x: 0.185,
          y: 0.61,
          w: 0.32,
          h: 0.05
        }],
        hotspots: [{
          id: 'sendRnd',
          x: 0.63,
          y: 0.58,
          w: 0.20,
          h: 0.10,
          set: {
            rndShown: true
          }
        }, {
          id: 'loginRndBtn',
          x: 0.50,
          y: 0.85,
          w: 0.15,
          h: 0.08,
          guard: function guard(_ref6) {
            var form = _ref6.form;
            if (!form.rnd) return {
              ok: false,
              msg: '请输入短信验证码'
            };
            if (form.rnd !== '660220') return {
              ok: false,
              msg: '短信验证码错误'
            };
            return {
              ok: true
            };
          },
          next: 'done'
        }]
      }, {
        id: 'done',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('loginindex.png');
        },
        canvasScale: 0.95,
        isEnd: true
      }]
    },
    second: {
      initialStepId: 'offline',
      initialForm: {},
      steps: [{
        id: 'offline',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('loginindex.png');
        },
        canvasScale: 0.95,
        tip: '切换接待状态为<span style="color: red;font-weight:bold;">在线</span>',
        extraImages: function extraImages(_ref7) {
          var ui = _ref7.ui;
          var list = [];
          if (ui.offlineClick) {
            list.push({
              id: 'status',
              src: r('staus.png'),
              x: 0.13,
              y: 0.1,
              w: 0.06,
              h: 0.1
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref8) {
          var ui = _ref8.ui;
          var list = [];
          if (!ui.offlineClick) {
            list.push({
              id: 'offline',
              x: 0.13,
              y: 0.1,
              w: 0.04,
              h: 0.03,
              set: {
                offlineClick: true
              }
            });
          }
          if (ui.offlineClick) {
            list.push({
              id: 'online',
              x: 0.13,
              y: 0.1,
              w: 0.04,
              h: 0.03,
              next: 'online'
            });
          }
          return list;
        }
      }, {
        id: 'online',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image(_ref9) {
          var ui = _ref9.ui;
          return ui.qtHover ? r('statusonline1.png') : r('statusonline.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">退出登录</span>(鼠标移动到顶部店铺名称后面，点击鼠标<span style="color: red;font-weight:bold;">左键</span>)',
        extraImages: function extraImages(_ref0) {
          var ui = _ref0.ui;
          var list = [];
          if (ui.showQt) {
            list.push({
              id: 'qtalert',
              src: r('qtalert.png'),
              x: 0.17,
              y: 0.05,
              w: 0.07,
              h: 0.154
            });
          }
          return list;
        },
        canvasScale: 0.95,
        hotspots: function hotspots(_ref1) {
          var ui = _ref1.ui;
          var list = [];
          if (!ui.showQt) {
            list.push({
              id: 'qtBtn',
              x: 0.18,
              y: 0.0,
              w: 0.04,
              h: 0.05,
              hoverSet: {
                qtHover: true
              },
              hoverUnset: {
                qtHover: false
              },
              set: {
                showQt: true
              }
            });
          }
          if (ui.showQt) {
            list.push({
              id: 'qtBtn2',
              x: 0.17,
              y: 0.14,
              w: 0.07,
              h: 0.05,
              next: 'add'
            });
          }
          return list;
        }
      }, {
        id: 'add',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: r('statusonline.png'),
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">加号</span>添加账号',
        hotspots: [{
          id: 'qtBtn',
          x: 0.22,
          y: 0.0,
          w: 0.04,
          h: 0.05,
          next: 'end'
        }]
      }, {
        id: 'end',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: r('statusonline1.png'),
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">加号</span>添加账号',
        extraImages: [{
          id: 'qtalert',
          src: r('login1.png'),
          x: 0.22,
          y: 0.05,
          w: 0.60,
          h: 0.87,
          shadow: false
        }],
        isEnd: true
      }]
    },
    third: {
      initialStepId: 'order1',
      initialForm: {
        orderid: ''
      },
      steps: [{
        id: 'order1',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('statusonline.png');
        },
        canvasScale: 0.95,
        tip: '切换到<span style="color: red;font-weight:bold;">订单管理</span>页面',
        extraImages: function extraImages(_ref10) {
          var ui = _ref10.ui;
          var list = [];
          if (ui.orderHover) {
            list.push({
              id: 'orderHover',
              src: r('order_hover.png'),
              x: 0.023,
              y: 0.13,
              w: 0.03,
              h: 0.03,
              shadow: false
            });
          }
          return list;
        },
        hotspots: [{
          id: 'order',
          x: 0.05,
          y: 0.11,
          w: 0.04,
          h: 0.06,
          hoverSet: {
            orderHover: true
          },
          hoverUnset: {
            orderHover: false
          },
          next: 'order2'
        }]
      }, {
        id: 'order2',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order1.png');
        },
        canvasScale: 0.95,
        tip: '搜索订单号为<span style="color: red;font-weight:bold;">8888-88888888888</span>的订单',
        extraImages: [],
        fields: [{
          id: 'orderid',
          model: 'orderid',
          type: 'text',
          bgColor: '#fff',
          placeholder: '订单号/快递单号',
          x: 0.68,
          y: 0.24,
          w: 0.15,
          h: 0.02
        }],
        hotspots: [{
          id: 'search',
          x: 0.85,
          y: 0.23,
          w: 0.03,
          h: 0.04,
          guard: function guard(_ref11) {
            var form = _ref11.form;
            if (form.orderid !== '8888-88888888888') return {
              ok: false,
              msg: '请查询指定订单'
            };
            return {
              ok: true
            };
          },
          next: 'order3'
        }]
      }, {
        id: 'order3',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order2.png');
        },
        canvasScale: 0.95,
        tip: '向下单客户<span style="color: red;font-weight:bold;">发起聊天</span>',
        extraImages: [],
        hotspots: [{
          id: 'chat',
          x: 0.73,
          y: 0.43,
          w: 0.06,
          h: 0.04,
          next: 'order4'
        }]
      }, {
        id: 'order4',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '向下单客户<span style="color: red;font-weight:bold;">发起聊天</span>',
        extraImages: [],
        isEnd: true
      }]
    },
    four: {
      initialStepId: 'four_step1',
      initialForm: {},
      steps: [{
        id: 'four_step1',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">帮助链接</span>按钮',
        extraImages: function extraImages(_ref12) {
          var ui = _ref12.ui;
          var list = [];
          if (ui.linkHover) {
            list.push({
              id: 'linkHover',
              src: r('link_hover.png'),
              x: 0.36,
              y: 0.73,
              w: 0.04,
              h: 0.03,
              shadow: false
            });
          }
          if (ui.linkClick) {
            list.push({
              id: 'link',
              src: r('link.png'),
              x: 0.355,
              y: 0.44,
              w: 0.30,
              h: 0.24
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref13) {
          var ui = _ref13.ui;
          var list = [];
          list.push({
            id: 'bq',
            x: 0.36,
            y: 0.69,
            w: 0.02,
            h: 0.04,
            hoverSet: {
              linkHover: true
            },
            hoverUnset: {
              linkHover: false
            },
            set: {
              linkClick: true
            }
          });
          if (ui.linkClick) {
            list.push({
              id: 'sendlink',
              x: 0,
              y: 0,
              w: 1,
              h: 1,
              next: 'four_step7'
            });
          }
          return list;
        }
      }, {
        id: 'four_step7',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">推送优惠券</span>按钮',
        extraImages: function extraImages(_ref14) {
          var ui = _ref14.ui;
          var list = [];
          if (ui.couponHover) {
            list.push({
              id: 'couponHover',
              src: r('coupon_hover.png'),
              x: 0.43,
              y: 0.73,
              w: 0.05,
              h: 0.03,
              shadow: false
            });
          }
          if (ui.couponlick) {
            list.push({
              id: 'coupon',
              src: r('coupon.png'),
              x: 0.36,
              y: 0.53,
              w: 0.28,
              h: 0.14
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref15) {
          var ui = _ref15.ui;
          var list = [];
          list.push({
            id: 'couponbtn',
            x: 0.43,
            y: 0.69,
            w: 0.02,
            h: 0.04,
            hoverSet: {
              couponHover: true
            },
            hoverUnset: {
              couponHover: false
            },
            set: {
              couponlick: true
            }
          });
          if (ui.couponlick) {
            list.push({
              id: 'couponbtn2',
              x: 0,
              y: 0,
              w: 1,
              h: 1,
              next: 'four_step9'
            });
          }
          return list;
        }
      }, {
        id: 'four_step8',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">举报恶意售后</span>按钮',
        extraImages: function extraImages(_ref16) {
          var ui = _ref16.ui;
          var list = [];
          if (ui.eyshlick) {
            list.push({
              id: 'jbeysh',
              src: r('jbeysh.png'),
              x: 0.24,
              y: 0.1,
              w: 0.44,
              h: 0.77
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref17) {
          var ui = _ref17.ui;
          var list = [];
          if (!ui.eyshlick) {
            list.push({
              id: 'eyshbtn',
              x: 0.45,
              y: 0.69,
              w: 0.02,
              h: 0.04,
              set: {
                eyshlick: true
              }
            });
          }
          if (ui.eyshlick) {
            list.push({
              id: 'eyshbtn2',
              x: 0.24,
              y: 0.1,
              w: 0.44,
              h: 0.77,
              next: 'four_step9'
            });
          }
          return list;
        }
      }, {
        id: 'four_step9',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">代客户申请售后</span>按钮',
        extraImages: function extraImages(_ref18) {
          var ui = _ref18.ui;
          var list = [];
          if (ui.dkhsqshHover) {
            list.push({
              id: 'dkhsqshHover',
              src: r('dkhsqsh_hover.png'),
              x: 0.47,
              y: 0.73,
              w: 0.075,
              h: 0.03,
              shadow: false
            });
          }
          if (ui.dkhsqshclick) {
            list.push({
              id: 'dkhsqsh',
              src: r('dkhsqsh.png'),
              x: 0.27,
              y: 0.11,
              w: 0.42,
              h: 0.69
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref19) {
          var ui = _ref19.ui;
          var list = [];
          list.push({
            id: 'dkhsqshbtn',
            x: 0.47,
            y: 0.69,
            w: 0.02,
            h: 0.04,
            hoverSet: {
              dkhsqshHover: true
            },
            hoverUnset: {
              dkhsqshHover: false
            },
            set: {
              dkhsqshclick: true
            }
          });
          if (ui.dkhsqshclick) {
            list.push({
              id: 'dkhsqshbtn2',
              x: 0,
              y: 0,
              w: 1,
              h: 1,
              next: 'four_step11'
            });
          }
          return list;
        }
      }, {
        id: 'four_step10',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">发送文件</span>按钮',
        hotspots: [{
          id: 'fswjbtn',
          x: 0.49,
          y: 0.69,
          w: 0.02,
          h: 0.04,
          next: 'four_step11'
        }]
      }, {
        id: 'four_step11',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">小额打款</span>按钮',
        extraImages: function extraImages(_ref20) {
          var ui = _ref20.ui;
          var list = [];
          if (ui.ltjlclick2) {
            list.push({
              id: 'xedk',
              src: r('xedk.png'),
              x: 0.28,
              y: 0.14,
              w: 0.435,
              h: 0.74
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref21) {
          var ui = _ref21.ui;
          var list = [];
          list.push({
            id: 'ltjlbtn2',
            x: 0.56,
            y: 0.69,
            w: 0.04,
            h: 0.04,
            set: {
              ltjlclick2: true
            }
          });
          if (ui.ltjlclick2) {
            list.push({
              id: 'ltjlbtn3',
              x: 0,
              y: 0,
              w: 1,
              h: 1,
              next: 'four_step13'
            });
          }
          return list;
        }
      }, {
        id: 'four_step12',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">小额收款</span>按钮',
        extraImages: function extraImages(_ref22) {
          var ui = _ref22.ui;
          var list = [];
          if (ui.xeskclick) {
            list.push({
              id: 'xesk',
              src: r('xesk.png'),
              x: 0.32,
              y: 0.33,
              w: 0.33,
              h: 0.29
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref23) {
          var ui = _ref23.ui;
          var list = [];
          if (!ui.xeskclick) {
            list.push({
              id: 'xeskbtn',
              x: 0.60,
              y: 0.69,
              w: 0.04,
              h: 0.04,
              set: {
                xeskclick: true
              }
            });
          }
          if (ui.xeskclick) {
            list.push({
              id: 'xeskbtn2',
              x: 0.31,
              y: 0.33,
              w: 0.33,
              h: 0.29,
              next: 'four_step13'
            });
          }
          return list;
        }
      }, {
        id: 'four_step13',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击查看<span style="color: red;font-weight:bold;">更多功能</span>',
        extraImages: function extraImages(_ref24) {
          var ui = _ref24.ui;
          var list = [];
          if (ui.moreHover) {
            list.push({
              id: 'moreHover',
              src: r('more_feature.png'),
              x: 0.65,
              y: 0.73,
              w: 0.04,
              h: 0.03,
              shadow: false
            });
          }
          if (ui.other1click) {
            list.push({
              id: 'other',
              src: r('other.png'),
              x: 0.58,
              y: 0.72,
              w: 0.10,
              h: 0.20,
              shadow: false
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref25) {
          var ui = _ref25.ui;
          var list = [];
          list.push({
            id: 'otherbtn',
            x: 0.64,
            y: 0.69,
            w: 0.03,
            h: 0.04,
            hoverSet: {
              moreHover: true
            },
            hoverUnset: {
              moreHover: false
            },
            set: {
              other1click: true
            }
          });
          if (ui.other1click) {
            list.push({
              id: 'otherbtn2',
              x: 0,
              y: 0,
              w: 1,
              h: 1,
              next: 'four_step14'
            });
          }
          return list;
        }
      }, {
        id: 'four_step14',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '点击数据面板的<span style="color: red;font-weight:bold;">展开</span>按钮，查看数据；',
        extraImages: function extraImages(_ref26) {
          var ui = _ref26.ui;
          var list = [];
          if (ui.sjmbclick) {
            list.push({
              id: 'sjmb',
              src: r('sjmb.png'),
              x: 0.31,
              y: 0.06,
              w: 0.36,
              h: 0.46
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref27) {
          var ui = _ref27.ui;
          var list = [];
          list.push({
            id: 'sjmbbtn',
            x: 0.63,
            y: 0.08,
            w: 0.03,
            h: 0.04,
            set: {
              sjmbclick: true
            }
          });
          if (ui.sjmbclick) {
            list.push({
              id: 'sjmbbtn2',
              x: 0,
              y: 0,
              w: 1,
              h: 1,
              next: 'four_step18'
            });
          }
          return list;
        }
      }, {
        id: 'four_step17',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '<span style="color: red;font-weight:bold;">举报恶意客户</span>',
        extraImages: function extraImages(_ref28) {
          var ui = _ref28.ui;
          var list = [];
          if (ui.jb1click && !ui.jb2click) {
            list.push({
              id: 'jbalert',
              src: r('jbalert.png'),
              x: 0.58,
              y: 0.19,
              w: 0.08,
              h: 0.12
            });
          }
          if (ui.jb2click) {
            list.push({
              id: 'jbeykh',
              src: r('jbeykh.png'),
              x: 0.28,
              y: 0.14,
              w: 0.425,
              h: 0.58
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref29) {
          var ui = _ref29.ui;
          var list = [];
          if (!ui.jb1click && !ui.jb2click) {
            list.push({
              id: 'jb1btn',
              x: 0.59,
              y: 0.15,
              w: 0.02,
              h: 0.04,
              set: {
                jb1click: true
              }
            });
          }
          if (ui.jb1click) {
            list.push({
              id: 'jb2btn',
              x: 0.58,
              y: 0.19,
              w: 0.04,
              h: 0.04,
              set: {
                jb2click: true
              }
            });
          }
          if (ui.jb2click) {
            list.push({
              id: 'ltjlbtn3',
              x: 0.28,
              y: 0.14,
              w: 0.425,
              h: 0.58,
              next: 'four_step18'
            });
          }
          return list;
        }
      }, {
        id: 'four_step18',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('order3.png');
        },
        canvasScale: 0.95,
        tip: '<span style="color: red;font-weight:bold;">转移会话</span>给<span style="color: red;font-weight:bold;">淘金云客服01</span>，原因选择<span style="color: red;font-weight:bold;">退款/退货问题</br>',
        extraImages: function extraImages(_ref30) {
          var ui = _ref30.ui;
          var list = [];
          if (ui.zy1click && !ui.zy2click) {
            list.push({
              id: 'zyhh1',
              src: r('zyhh1.png'),
              x: 0.22,
              y: 0.19,
              w: 0.52,
              h: 0.62
            });
          }
          if (ui.zy2click && ui.zy1click) {
            list.push({
              id: 'zyhh1',
              src: r('zyhh2.png'),
              x: 0.22,
              y: 0.19,
              w: 0.52,
              h: 0.62
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref31) {
          var ui = _ref31.ui;
          var list = [];
          if (!ui.zy1click && !ui.zy2click) {
            list.push({
              id: 'jb1btn',
              x: 0.62,
              y: 0.15,
              w: 0.02,
              h: 0.04,
              set: {
                zy1click: true
              }
            });
          }
          if (ui.zy1click && !ui.zy2click) {
            list.push({
              id: 'jb2btn',
              x: 0.54,
              y: 0.39,
              w: 0.04,
              h: 0.04,
              set: {
                zy2click: true
              }
            });
          }
          if (ui.zy2click && ui.zy1click) {
            list.push({
              id: 'ltjlbtn3',
              x: 0.49,
              y: 0.55,
              w: 0.145,
              h: 0.05,
              next: 'four_step19'
            });
          }
          return list;
        }
      }, {
        id: 'four_step19',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('undealuser.png');
        },
        canvasScale: 0.95,
        tip: '将此客户标为<span style="color: red;font-weight:bold;">黄色星星</span>，添加到收藏会话',
        extraImages: function extraImages(_ref32) {
          var ui = _ref32.ui;
          var list = [];
          if (ui.starclick) {
            list.push({
              id: 'tag',
              src: r('tag.png'),
              x: 0.58,
              y: 0.19,
              w: 0.09,
              h: 0.05,
              shadow: false
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref33) {
          var ui = _ref33.ui;
          var list = [];
          if (!ui.starclick) {
            list.push({
              id: 'starbtn',
              x: 0.65,
              y: 0.15,
              w: 0.02,
              h: 0.04,
              hoverSet: {
                starclick: true
              }
            });
          }
          if (ui.starclick) {
            list.push({
              id: 'xeskbtn2',
              x: 0.605,
              y: 0.19,
              w: 0.02,
              h: 0.05,
              next: 'four_step20'
            });
          }
          return list;
        }
      }, {
        id: 'four_step20',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('dealuser.png');
        },
        canvasScale: 0.95,
        tip: '在<span style="color: red;font-weight:bold;">全部会话</span>中查看收藏的会话',
        extraImages: [{
          id: 'tagsuccess',
          src: r('tagsuccess.png'),
          x: 0.40,
          y: 0.43,
          w: 0.12,
          h: 0.05
        }],
        hotspots: [],
        afterEnter: {
          delay: 2500,
          go: 'four_step21'
        }
      }, {
        id: 'four_step21',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('dealuser.png');
        },
        canvasScale: 0.95,
        tip: '在<span style="color: red;font-weight:bold;">全部会话</span>中查看收藏的会话',
        hotspots: [{
          id: 'allchat',
          x: 0.17,
          y: 0.2,
          w: 0.06,
          h: 0.05,
          next: 'four_step22'
        }]
      }, {
        id: 'four_step22',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('allchat.png');
        },
        canvasScale: 0.95,
        tip: '取消<span style="color: red;font-weight:bold;">标星</span>',
        hotspots: [{
          id: 'unstarbtn',
          x: 0.65,
          y: 0.15,
          w: 0.02,
          h: 0.04,
          next: 'four_step23'
        }]
      }, {
        id: 'four_step23',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('untagsuccessbg.png');
        },
        canvasScale: 0.95,
        tip: '取消<span style="color: red;font-weight:bold;">标星</span>',
        extraImages: [{
          id: 'untagsuccess',
          src: r('untagsuccess.png'),
          x: 0.40,
          y: 0.43,
          w: 0.15,
          h: 0.05
        }],
        isEnd: true
      }]
    },
    five: {
      initialStepId: 'five_1',
      initialForm: {
        remark: ''
      },
      steps: [{
        id: 'five_1',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('untagsuccessbg.png');
        },
        canvasScale: 0.95,
        tip: '【假设商家要求给<span style="color: red;font-weight:bold;">发顺丰</span>的客户标记<span style="color: red;font-weight:bold;">红色</span>】<span style="color: red;font-weight:bold;">请添加订单备注，并标记对应的颜色。</span><br>备注内容为：发顺丰',
        extraImages: function extraImages(_ref34) {
          var ui = _ref34.ui;
          var list = [];
          if (ui.remarkClick && !ui.redClick) {
            list.push({
              id: 'orderremark',
              src: r('orderremark1.png'),
              x: 0.68,
              y: 0.26,
              w: 0.26,
              h: 0.50
            });
          }
          if (ui.redClick) {
            list.push({
              id: 'orderremark',
              src: r('orderremark2.png'),
              x: 0.68,
              y: 0.26,
              w: 0.26,
              h: 0.50
            });
          }
          return list;
        },
        fields: function fields(_ref35) {
          var ui = _ref35.ui;
          var list = [];
          if (ui.redClick) {
            list.push({
              id: 'remark',
              model: 'remark',
              type: 'text',
              bgColor: '#fff',
              placeholder: '请填写订单备注信息',
              x: 0.695,
              y: 0.42,
              w: 0.17,
              h: 0.05
            });
          } else if (ui.remarkClick) {
            list.push({
              id: 'remark',
              model: 'remark',
              type: 'text',
              bgColor: '#fff',
              placeholder: '请填写订单备注信息',
              x: 0.695,
              y: 0.39,
              w: 0.17,
              h: 0.05
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref36) {
          var ui = _ref36.ui;
          var list = [];
          if (!ui.remarkClick && !ui.redClick) {
            list.push({
              id: 'orderremarkbtn',
              x: 0.89,
              y: 0.55,
              w: 0.04,
              h: 0.04,
              set: {
                remarkClick: true
              }
            });
          }
          if (ui.remarkClick && !ui.redClick) {
            list.push({
              id: 'redbtn',
              x: 0.69,
              y: 0.33,
              w: 0.03,
              h: 0.04,
              set: {
                redClick: true
              }
            });
          }
          if (ui.redClick || ui.remarkClick) {
            list.push({
              id: 'redbtn',
              x: 0.84,
              y: 0.71,
              w: 0.05,
              h: 0.04,
              guard: function guard(_ref37) {
                var form = _ref37.form,
                  ui = _ref37.ui;
                if (form.remark !== '发顺丰') return {
                  ok: false,
                  msg: '请备注发顺丰'
                };
                if (!ui.redClick) {
                  return {
                    ok: false,
                    msg: '请标记红色'
                  };
                }
                return {
                  ok: true
                };
              },
              next: 'five_2'
            });
          }
          return list;
        }
      }, {
        id: 'five_2',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('markend.png');
        },
        canvasScale: 0.95,
        tip: '点击<span style="color: red;font-weight:bold;">商品推荐</span>',
        hotspots: [{
          id: 'tjsptab',
          x: 0.75,
          y: 0.16,
          w: 0.054,
          h: 0.045,
          next: 'five_3'
        }]
      }, {
        id: 'five_3',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        canvasScale: 0.95,
        extraImages: function extraImages(_ref38) {
          var ui = _ref38.ui;
          var list = [];
          if (ui.tjstep == 'step_zuji') {
            list.push({
              id: 'llzj',
              src: r('llzj.png'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.85,
              shadow: false
            });
          } else if (ui.tjstep == 'step_rexiao') {
            list.push({
              id: 'rexiao',
              src: r('rexiao.png'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.85,
              shadow: false
            });
          } else if (ui.tjstep == 'step_caitaxihuan') {
            list.push({
              id: 'caitaxihuan',
              src: r('caitaxihuan.png'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.85,
              shadow: false
            });
          }
          return list;
        },
        tip: function tip(_ref39) {
          var ui = _ref39.ui;
          if (ui.tjstep == 'step_zuji') {
            return '查看<span style="color: red;font-weight:bold;">热销商品</span>';
          } else if (ui.tjstep == 'step_rexiao') {
            return '查看<span style="color: red;font-weight:bold;">猜TA喜欢</span>';
          } else if (ui.tjstep == 'step_caitaxihuan') {
            return '把<span style="color: red;font-weight:bold;">销量最高的</span>商品发送给客户';
          }
          return '查看<span style="color: red;font-weight:bold;">浏览足迹</span>';
        },
        hotspots: function hotspots(_ref40) {
          var ui = _ref40.ui;
          var list = [{
            id: 'step_zuji',
            x: 0.74,
            y: 0.27,
            w: 0.06,
            h: 0.04,
            set: {
              tjstep: 'step_zuji'
            }
          }, {
            id: 'step_rexiao',
            x: 0.80,
            y: 0.27,
            w: 0.04,
            h: 0.04,
            set: {
              tjstep: 'step_rexiao'
            }
          }, {
            id: 'step_caitaxihuan',
            x: 0.84,
            y: 0.27,
            w: 0.05,
            h: 0.04,
            set: {
              tjstep: 'step_caitaxihuan'
            }
          }];
          if (ui.tjstep == 'step_caitaxihuan') {
            list.push({
              id: 'sendgoods',
              x: 0.68,
              y: 0.50,
              w: 0.05,
              h: 0.04,
              next: 'five_4'
            });
          }
          return list;
        }
      }, {
        id: 'five_4',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        canvasScale: 0.95,
        extraImages: [{
          id: 'caitaxihuan',
          src: r('caitaxihuan.png'),
          x: 0.671,
          y: 0.14,
          w: 0.274,
          h: 0.85,
          shadow: false
        }, {
          id: 'goodmsg',
          src: r('goodmsg.png'),
          x: 0.38,
          y: 0.38,
          w: 0.27,
          h: 0.29,
          shadow: false
        }],
        tip: '',
        isEnd: true
      }]
    },
    six: {
      initialStepId: 'six_1',
      initialForm: {
        groupName: '',
        kjbm: '',
        kjdy: '',
        srnr: ''
      },
      steps: [{
        id: 'six_1',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        canvasScale: 0.95,
        tip: function tip(_ref41) {
          var ui = _ref41.ui;
          if (!ui.six_stp) {
            return '点击<span style="color: red;font-weight:bold;">快捷回复</span>';
          } else if (ui.six_stp == 'show_kjhf1') {
            return '<span style="color: red;font-weight:bold;">添加</span>一条快捷回复';
          } else if (ui.six_stp == 'add_kjhf' || ui.six_stp == 'add_group') {
            return '新增分组名称为<br><span style="color: red;font-weight:bold;">常用接待语</span>';
          } else if (ui.six_stp == 'add_group_success' || ui.six_stp == 'select_group' || ui.six_stp == 'selected_group') {
            return '选择刚才新建的分组<br>新建快捷编码为<span style="color: red;font-weight:bold;">欢迎</span><br>话术内容为<span style="color: red;font-weight:bold;">欢迎光临小店，很高兴为您服务~</span>的快捷回复';
          }
          return '';
        },
        extraImages: function extraImages(_ref42) {
          var ui = _ref42.ui;
          var list = [];
          if (ui.six_stp == 'show_kjhf1') {
            list.push({
              id: 'kjhf',
              src: r('kjhf1.jpeg'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
          }
          if (ui.six_stp == 'add_kjhf') {
            list.push({
              id: 'kjhf',
              src: r('kjhf_add.jpeg'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
          }
          if (ui.six_stp == 'add_group') {
            list.push({
              id: 'kjhf',
              src: r('kjhf_add_group.jpeg'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
          }
          if (ui.six_stp == 'add_group_success') {
            list.push({
              id: 'kjhf',
              src: r('kjhf_add_group_success.jpeg'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
          }
          if (ui.six_stp == 'select_group') {
            list.push({
              id: 'kjhf',
              src: r('kjhf_add_select_group.jpeg'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
          }
          if (ui.six_stp == 'selected_group') {
            list.push({
              id: 'kjhf',
              src: r('kjhf_add_new.jpeg'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
          }
          return list;
        },
        fields: function fields(_ref43) {
          var ui = _ref43.ui;
          var list = [];
          if (ui.six_stp == 'add_group') {
            list.push({
              id: 'groupName',
              model: 'groupName',
              type: 'text',
              bgColor: '#fff',
              placeholder: '请输入分组名称',
              x: 0.70,
              y: 0.52,
              w: 0.215,
              h: 0.032
            });
          }
          if (ui.six_stp == 'selected_group' || ui.six_stp == 'add_group_success') {
            list.push({
              id: 'kjbm',
              model: 'kjbm',
              type: 'text',
              bgColor: '#fff',
              placeholder: '支持大小写字母、数字和汉字',
              x: 0.70,
              y: 0.54,
              w: 0.215,
              h: 0.032
            });
            list.push({
              id: 'kjdy',
              model: 'kjdy',
              type: 'text',
              bgColor: '#fff',
              placeholder: '请输入话术内容',
              x: 0.70,
              y: 0.62,
              w: 0.215,
              h: 0.032
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref44) {
          var ui = _ref44.ui;
          var list = [];
          if (!ui.six_stp) {
            list.push({
              id: 'kjhfbtn',
              x: 0.82,
              y: 0.16,
              w: 0.05,
              h: 0.04,
              set: {
                six_stp: 'show_kjhf1'
              }
            });
          }
          if (ui.six_stp == 'show_kjhf1') {
            list.push({
              id: 'addbtn',
              x: 0.72,
              y: 0.95,
              w: 0.05,
              h: 0.04,
              set: {
                six_stp: 'add_kjhf'
              }
            });
          }
          if (ui.six_stp == 'add_kjhf') {
            list.push({
              id: 'addgroup',
              x: 0.87,
              y: 0.42,
              w: 0.05,
              h: 0.04,
              set: {
                six_stp: 'add_group'
              }
            });
          }
          if (ui.six_stp == 'add_group') {
            list.push({
              id: 'confirmaddgroup',
              x: 0.83,
              y: 0.57,
              w: 0.05,
              h: 0.04,
              guard: function guard(_ref45) {
                var form = _ref45.form;
                console.log('ssss' + form.groupName);
                if (form.groupName !== '常用接待语') return {
                  ok: false,
                  msg: '请输入正确的分组名称'
                };
                return {
                  ok: true
                };
              },
              set: {
                six_stp: 'add_group_success'
              }
            });
          }
          if (ui.six_stp == 'add_group_success') {
            list.push({
              id: 'selectgroup',
              x: 0.70,
              y: 0.45,
              w: 0.22,
              h: 0.04,
              set: {
                six_stp: 'select_group'
              }
            });
          }
          if (ui.six_stp == 'select_group') {
            list.push({
              id: 'selectgroup1',
              x: 0.70,
              y: 0.57,
              w: 0.22,
              h: 0.04,
              set: {
                six_stp: 'selected_group'
              }
            });
          }
          if (ui.six_stp == 'selected_group') {
            list.push({
              id: 'confirmadd',
              x: 0.84,
              y: 0.73,
              w: 0.04,
              h: 0.04,
              guard: function guard(_ref46) {
                var form = _ref46.form;
                console.log('ssss' + form.groupName);
                if (form.kjbm !== '欢迎') return {
                  ok: false,
                  msg: '请输入正确的快捷编码'
                };
                if (form.kjdy !== '欢迎光临小店，很高兴为您服务~') return {
                  ok: false,
                  msg: '请输入正确的分组名称'
                };
                return {
                  ok: true
                };
              },
              next: 'six_1a'
            });
          }
          return list;
        }
      }, {
        id: 'six_1a',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        extraImages: function extraImages(_ref47) {
          var ui = _ref47.ui;
          var list = [];
          list.push({
            id: 'add_kjdy_success',
            src: r('add_kjdy_success.png'),
            x: 0.671,
            y: 0.14,
            w: 0.274,
            h: 0.86,
            shadow: false
          });
          return list;
        },
        canvasScale: 0.95,
        tip: '选择刚才新建的分组<br>新建快捷编码为<span style="color: red;font-weight:bold;">欢迎</span><br>话术内容为<span style="color: red;font-weight:bold;">欢迎光临小店，很高兴为您服务~</span>的快捷回复',
        afterEnter: {
          delay: 2500,
          go: 'six_2'
        }
      }, {
        id: 'six_2',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        canvasScale: 0.95,
        tip: '采用输入<span style="color: red;font-weight:bold;">/</span>+<span style="color: red;font-weight:bold;">快捷编码</span>的方式，给客户发送欢迎语',
        fields: function fields() {
          var list = [];
          list.push({
            id: 'srnr',
            model: 'srnr',
            type: 'text',
            bgColor: '#fff',
            placeholder: '请输入内容',
            x: 0.32,
            y: 0.79,
            w: 0.295,
            h: 0.032,
            onInput: function onInput(_ref48) {
              var value = _ref48.value,
                setUi = _ref48.setUi;
              if (String(value || '').trim() === '/欢迎') {
                setUi({
                  six_stp: 'show_tip'
                });
              } else {
                setUi({
                  six_stp: ''
                });
              }
            },
            onEnter: function onEnter(_ref49) {
              var form = _ref49.form,
                go = _ref49.go,
                setForm = _ref49.setForm,
                set = _ref49.set;
              if (String(form.srnr || '').trim() === '欢迎光临小店，很高兴为您服务~') {
                go('six_3'); // 或者你想跳的 stepId
              } else if (String(form.srnr || '').trim() === '/欢迎') {
                setForm({
                  srnr: '欢迎光临小店，很高兴为您服务~'
                });
                set({
                  six_stp: 'click_tip_done'
                });
              }
            }
          });
          return list;
        },
        extraImages: function extraImages(_ref50) {
          var ui = _ref50.ui;
          var list = [];
          list.push({
            id: 'kjdy_raw',
            src: r('kjdy_raw.png'),
            x: 0.671,
            y: 0.14,
            w: 0.274,
            h: 0.86,
            shadow: false
          });
          if (ui.six_stp == 'show_tip') {
            list.push({
              id: 'kjhf_alert',
              src: ui.tipHover ? r('kjdy_alert_hover.png') : r('kjdy_alert.png'),
              x: 0.35,
              y: 0.825,
              w: 0.38,
              h: 0.0415,
              shadow: false
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref51) {
          var ui = _ref51.ui,
            form = _ref51.form;
          var list = [];
          if (ui.six_stp == 'show_tip') {
            list.push({
              id: 'select_kjdy',
              x: 0.35,
              y: 0.825,
              w: 0.38,
              h: 0.0415,
              hoverSet: {
                tipHover: true
              },
              hoverUnset: {
                tipHover: false
              },
              setForm: {
                srnr: '欢迎光临小店，很高兴为您服务~'
              },
              set: {
                six_stp: 'click_tip_done'
              },
              focusFieldId: 'srnr'
            });
          }
          if (ui.six_stp == 'click_tip_done') {
            list.push({
              id: 'send_kjdy',
              x: 0.61,
              y: 0.945,
              w: 0.06,
              h: 0.0415,
              next: 'six_3'
            });
          }
          return list;
        }
      }, {
        id: 'six_3',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        extraImages: function extraImages(_ref52) {
          var ui = _ref52.ui;
          var list = [];
          list.push({
            id: 'kjdy_raw',
            src: r('kjdy_raw.png'),
            x: 0.671,
            y: 0.14,
            w: 0.274,
            h: 0.86,
            shadow: false
          });
          list.push({
            id: 'send_kjdy',
            src: r('send_kjdy.png'),
            x: 0.35,
            y: 0.26,
            w: 0.31,
            h: 0.33,
            shadow: false
          });
          return list;
        },
        canvasScale: 0.95,
        tip: '输入<span style="color: red;font-weight:bold;">/</span>+<span style="color: red;font-weight:bold;">快捷编码</span>发送快捷回复给客户',
        afterEnter: {
          delay: 2500,
          go: 'six_4'
        }
      }, {
        id: 'six_4',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        extraImages: function extraImages(_ref53) {
          var ui = _ref53.ui;
          var list = [];
          if (!ui.six_dr_stp) {
            list.push({
              id: 'kjdy_raw',
              src: r('kjdy_raw.png'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
          }
          if (ui.six_dr_stp == 'six_drdc') {
            list.push({
              id: 'kjdy_raw',
              src: r('kjdy_drdc.jpeg'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
          }
          if (ui.six_dr_stp == 'six_drdc_dr') {
            list.push({
              id: 'kjdy_raw',
              src: r('kjdy_raw.png'),
              x: 0.671,
              y: 0.14,
              w: 0.274,
              h: 0.86,
              shadow: false
            });
            list.push({
              id: 'dr_alert1',
              src: r('dr_alert1.png'),
              x: 0.29,
              y: 0.26,
              w: 0.41,
              h: 0.39,
              shadow: true
            });
          }
          return list;
        },
        canvasScale: 0.95,
        tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
        hotspots: function hotspots(_ref54) {
          var ui = _ref54.ui;
          var list = [];
          if (!ui.six_dr_stp) {
            list.push({
              id: 'drdc',
              x: 0.82,
              y: 0.96,
              w: 0.11,
              h: 0.04,
              set: {
                six_dr_stp: 'six_drdc'
              }
            });
          }
          if (ui.six_dr_stp == 'six_drdc') {
            list.push({
              id: 'drbtn',
              x: 0.82,
              y: 0.81,
              w: 0.11,
              h: 0.04,
              set: {
                six_dr_stp: 'six_drdc_dr'
              }
            });
            list.push({
              id: 'xzbtn',
              x: 0.82,
              y: 0.90,
              w: 0.11,
              h: 0.04,
              emit: 'download-file'
            });
          }
          if (ui.six_dr_stp == 'six_drdc_dr') {
            list.push({
              id: 'six_drdc_dr',
              x: 0.40,
              y: 0.42,
              w: 0.11,
              h: 0.04,
              emit: 'request-file'
            });
          }
          return list;
        }
      }, {
        id: 'six_5',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        canvasScale: 0.95,
        tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
        extraImages: function extraImages(_ref55) {
          var ui = _ref55.ui;
          var list = [];
          list.push({
            id: 'six_5a',
            src: r('kjdy_raw.png'),
            x: 0.671,
            y: 0.14,
            w: 0.274,
            h: 0.86,
            shadow: false
          });
          if (!ui.six_dr_alert) {
            list.push({
              id: 'six_5b',
              src: r('dr_alert1a.png'),
              x: 0.29,
              y: 0.26,
              w: 0.41,
              h: 0.39,
              shadow: true
            });
          } else if (ui.six_dr_alert == 'six_drdc_dr_confirm') {
            list.push({
              id: 'six_5c',
              src: r('dr_alert2.png'),
              x: 0.29,
              y: 0.26,
              w: 0.41,
              h: 0.39,
              shadow: true
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref56) {
          var ui = _ref56.ui;
          var list = [];
          if (!ui.six_dr_alert) {
            list.push({
              id: 'six_5d',
              x: 0.52,
              y: 0.57,
              w: 0.09,
              h: 0.04,
              set: {
                six_dr_alert: 'six_drdc_dr_confirm'
              }
            });
          } else if (ui.six_dr_alert == 'six_drdc_dr_confirm') {
            list.push({
              id: 'six_5f',
              x: 0.66,
              y: 0.28,
              w: 0.03,
              h: 0.04,
              next: 'six_done'
            });
            list.push({
              id: 'six_5e',
              x: 0.61,
              y: 0.57,
              w: 0.06,
              h: 0.04,
              next: 'six_done'
            });
          }
          return list;
        }
      }, {
        id: 'six_done',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('tjsp2.png');
        },
        canvasScale: 0.95,
        extraImages: [{
          id: 'six_done_a',
          src: r('kjdy_dr_done.jpeg'),
          x: 0.671,
          y: 0.14,
          w: 0.274,
          h: 0.86,
          shadow: false
        }],
        isEnd: true
      }]
    },
    seven: {
      initialStepId: 'seven_1',
      initialForm: {},
      steps: [{
        id: 'seven_1',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('statusonline.png');
        },
        canvasScale: 0.95,
        tip: '切换接待状态为<span style="color: red;font-weight:bold;">离线</span>',
        extraImages: function extraImages(_ref57) {
          var ui = _ref57.ui;
          var list = [];
          if (ui.offlineClick) {
            list.push({
              id: 'seven_1a',
              src: r('staus.png'),
              x: 0.13,
              y: 0.1,
              w: 0.06,
              h: 0.1
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref58) {
          var ui = _ref58.ui;
          var list = [];
          if (!ui.offlineClick) {
            list.push({
              id: 'seven_1b',
              x: 0.13,
              y: 0.1,
              w: 0.04,
              h: 0.03,
              set: {
                offlineClick: true
              }
            });
          }
          if (ui.offlineClick) {
            list.push({
              id: 'seven_1c',
              x: 0.13,
              y: 0.17,
              w: 0.06,
              h: 0.03,
              next: 'seven_2'
            });
          }
          return list;
        }
      }, {
        id: 'seven_2',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        image: function image() {
          return r('loginindex.png');
        },
        canvasScale: 0.95,
        tip: '关闭接待窗口',
        hotspots: [{
          id: 'seven_1d',
          x: 0.93,
          y: 0.01,
          w: 0.02,
          h: 0.03,
          next: 'seven_3'
        }]
      }, {
        id: 'seven_3',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        tip: '点击右下角任务栏，退出拼多多接待工具',
        extraImages: function extraImages(_ref59) {
          var ui = _ref59.ui;
          var list = [];
          list.push({
            id: 'seven_3a',
            src: r('status_bar_left.png'),
            x: 0.0,
            y: 0.957,
            w: 0.84,
            h: 0.04
          });
          list.push({
            id: 'seven_3b',
            src: r('status_bar_right.png'),
            x: 0.84,
            y: 0.957,
            w: 0.16,
            h: 0.04
          });
          if (ui.seven_3_step == 'menus_normal' || ui.seven_3_step == 'menus_right_click') {
            list.push({
              id: 'seven_3d',
              src: ui.pddHover ? r('status_menu2.png') : r('status_menu1.png'),
              x: 0.74,
              y: 0.81,
              w: 0.11,
              h: 0.15
            });
          }
          if (ui.seven_3_step == 'menus_right_click') {
            list.push({
              id: 'seven_3f',
              src: r('quitpdd.png'),
              x: 0.73,
              y: 0.71,
              w: 0.07,
              h: 0.20
            });
          }
          return list;
        },
        hotspots: function hotspots(_ref60) {
          var ui = _ref60.ui;
          var list = [];
          if (!ui.seven_3_step) {
            list.push({
              id: 'seven_3c',
              x: 0.835,
              y: 0.96,
              w: 0.02,
              h: 0.03,
              set: {
                seven_3_step: 'menus_normal'
              }
            });
          } else if (ui.seven_3_step == 'menus_normal') {
            list.push({
              id: 'seven_3e',
              x: 0.80,
              y: 0.92,
              w: 0.02,
              h: 0.03,
              on: 'contextmenu',
              hoverUnset: {
                pddHover: false
              },
              hoverSet: {
                pddHover: true
              },
              set: {
                seven_3_step: 'menus_right_click'
              }
            });
          } else if (ui.seven_3_step == 'menus_right_click') {
            list.push({
              id: 'seven_3g',
              x: 0.73,
              y: 0.71,
              w: 0.07,
              h: 0.20,
              next: 'seven_done'
            });
          }
          return list;
        }
      }, {
        id: 'seven_done',
        stageBg: function stageBg() {
          return r('pddbg1.png');
        },
        isEnd: true
      }]
    }
  };
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(__webpack_require__(73));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _SceneTable = _interopRequireDefault(__webpack_require__(1287));
var _methods;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'StepPlayer',
  components: {
    SceneTable: _SceneTable.default
  },
  props: {
    steps: {
      type: Array,
      required: true
    },
    initialStepId: {
      type: String,
      required: true
    },
    showTip: {
      type: Boolean,
      default: true
    },
    initialForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    initialUi: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      currentStepId: this.initialStepId,
      hoveredHotspotId: '',
      ui: _objectSpread({}, this.initialUi),
      form: _objectSpread({}, this.initialForm),
      _afterEnterTimer: null
    };
  },
  computed: {
    stepMap: function stepMap() {
      var map = Object.create(null);
      (this.steps || []).forEach(function (s) {
        if (s && s.id) map[s.id] = s;
      });
      return map;
    },
    currentStep: function currentStep() {
      return this.stepMap[this.currentStepId] || {
        id: this.currentStepId
      };
    },
    resolvedHotspots: function resolvedHotspots() {
      var hs = this.currentStep && this.currentStep.hotspots;
      var raw = typeof hs === 'function' ? hs({
        ui: this.ui,
        form: this.form
      }) : hs;
      return Array.isArray(raw) ? raw : [];
    },
    resolvedFields: function resolvedFields() {
      var fs = this.currentStep && this.currentStep.fields;
      var raw = typeof fs === 'function' ? fs({
        ui: this.ui,
        form: this.form
      }) : fs;
      return Array.isArray(raw) ? raw : [];
    },
    resolvedLabels: function resolvedLabels() {
      var ls = this.currentStep && this.currentStep.labels;
      var raw = typeof ls === 'function' ? ls({
        ui: this.ui,
        form: this.form
      }) : ls;
      return Array.isArray(raw) ? raw : [];
    },
    resolvedExtraImages: function resolvedExtraImages() {
      var _this = this;
      var imgs = this.currentStep && this.currentStep.extraImages;
      var raw = typeof imgs === 'function' ? imgs({
        ui: this.ui,
        form: this.form
      }) : imgs;
      var list = Array.isArray(raw) ? raw : [];
      return list.filter(function (i) {
        return i && i.id && i.src;
      }).map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          src: _this.normalizeSrc(typeof i.src === 'function' ? i.src({
            ui: _this.ui,
            form: _this.form
          }) : i.src)
        });
      });
    },
    resolvedTables: function resolvedTables() {
      var _this2 = this;
      var ts = this.currentStep && this.currentStep.tables;
      var raw = typeof ts === 'function' ? ts({
        ui: this.ui,
        form: this.form
      }) : ts;
      if (!Array.isArray(raw)) return [];
      return raw.map(function (table) {
        var selectedKeys = _this2.ui[table.id + 'SelectedKeys'];
        return Array.isArray(selectedKeys) ? _objectSpread(_objectSpread({}, table), {}, {
          selectedKeys: selectedKeys
        }) : table;
      });
    },
    resolvedOverlayImage: function resolvedOverlayImage() {
      var img = this.currentStep && this.currentStep.overlayImage;
      var raw = typeof img === 'function' ? img({
        ui: this.ui,
        form: this.form
      }) : img;
      return this.normalizeSrc(raw);
    },
    resolvedImage: function resolvedImage() {
      var img = this.currentStep.image;
      var raw = typeof img === 'function' ? img({
        ui: this.ui,
        form: this.form
      }) : img;
      return this.normalizeSrc(raw);
    },
    resolvedTip: function resolvedTip() {
      var tip = this.currentStep.tip;
      if (typeof tip === 'function') return tip({
        ui: this.ui,
        form: this.form
      });
      return tip || '';
    },
    stageStyle: function stageStyle() {
      var bg = this.currentStep && this.currentStep.stageBg;
      var raw = typeof bg === 'function' ? bg({
        ui: this.ui,
        form: this.form
      }) : bg;
      var src = this.normalizeSrc(raw);
      var ratioRaw = this.currentStep && this.currentStep.aspectRatio;
      var ratio = typeof ratioRaw === 'number' && ratioRaw > 0 ? ratioRaw : 1.766;
      var style = {
        '--stage-ratio': ratio
      };
      if (!src) return style;
      return _objectSpread(_objectSpread({}, style), {}, {
        backgroundImage: "url(".concat(src, ")"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      });
    },
    canvasStyle: function canvasStyle() {
      var scaleRaw = this.currentStep && this.currentStep.canvasScale;
      var scale = typeof scaleRaw === 'number' && scaleRaw > 0 && scaleRaw <= 1 ? scaleRaw : 1;
      var pad = (1 - scale) / 2;
      return {
        left: pad * 100 + '%',
        top: pad * 100 + '%',
        width: scale * 100 + '%',
        height: scale * 100 + '%'
      };
    },
    overlayStyle: function overlayStyle() {
      var scaleRaw = this.currentStep && this.currentStep.overlayScale;
      var raw = typeof scaleRaw === 'function' ? scaleRaw({
        ui: this.ui,
        form: this.form
      }) : scaleRaw;
      var scale = typeof raw === 'number' && raw > 0 && raw <= 1 ? raw : 1;
      return {
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: scale * 100 + '%',
        height: scale * 100 + '%'
      };
    }
  },
  watch: {
    initialStepId: {
      immediate: false,
      handler: function handler(next) {
        this.reset(next);
      }
    },
    initialForm: {
      deep: true,
      handler: function handler(next) {
        this.form = _objectSpread({}, next || {});
      }
    },
    initialUi: {
      deep: true,
      handler: function handler(next) {
        this.ui = _objectSpread({}, next || {});
      }
    },
    currentStepId: function currentStepId(next) {
      var _this3 = this;
      if (this._afterEnterTimer) {
        clearTimeout(this._afterEnterTimer);
        this._afterEnterTimer = null;
      }
      this.$emit('step-change', next, this.currentStep, this.resolvedTip);
      if (this.currentStep && this.currentStep.onEnter) {
        this.currentStep.onEnter({
          go: this.go,
          ui: this.ui,
          form: this.form,
          emit: this.$emit.bind(this)
        });
      }
      if (this.currentStep && this.currentStep.afterEnter) {
        var _this$currentStep$aft = this.currentStep.afterEnter,
          delay = _this$currentStep$aft.delay,
          goTo = _this$currentStep$aft.go,
          set = _this$currentStep$aft.set,
          setForm = _this$currentStep$aft.setForm,
          finish = _this$currentStep$aft.finish;
        if (set) this.applySet(set);
        if (setForm) this.applyFormSet(setForm);
        if (delay != null && (goTo || finish)) {
          this._afterEnterTimer = setTimeout(function () {
            _this3._afterEnterTimer = null;
            if (finish) {
              _this3.$emit('finish', {
                stepId: _this3.currentStepId
              });
              return;
            }
            _this3.go(goTo);
          }, delay);
        }
      }
      // 步骤切换后，为标记了 autoFocus 的输入框自动聚焦
      this.$nextTick(function () {
        _this3.focusAutoField();
      });
    }
  },
  mounted: function mounted() {
    // 初始渲染时也需要把当前步骤提示发给父组件（否则 initialStepId 不变化时不会触发 watcher）
    this.$emit('step-change', this.currentStepId, this.currentStep, this.resolvedTip);
  },
  beforeDestroy: function beforeDestroy() {
    if (this._afterEnterTimer) clearTimeout(this._afterEnterTimer);
  },
  methods: (_methods = {
    extraImageStyle: function extraImageStyle(img) {
      if (!img) return {};
      if (img.noShadow === true || img.shadow === false) return {
        boxShadow: 'none'
      };
      return {};
    },
    labelStyle: function labelStyle(label) {
      var selectable = !!(label && label.selectable);
      var style = {
        color: label && label.color || '#333',
        fontSize: (label && label.fontSize) != null ? typeof label.fontSize === 'number' ? label.fontSize + 'px' : label.fontSize : '14px',
        fontWeight: label && label.fontWeight || 'normal',
        lineHeight: label && label.lineHeight || '1.2',
        display: 'flex',
        alignItems: label && label.alignItems || 'center',
        justifyContent: label && label.justifyContent || 'center',
        backgroundColor: label && label.bgColor || 'transparent',
        pointerEvents: selectable ? 'auto' : 'none',
        userSelect: selectable ? 'text' : 'none',
        cursor: selectable ? 'text' : 'default'
      };
      return style;
    },
    fieldStyle: function fieldStyle(field) {
      var style = {};
      if (!field) return style;
      if (field.bgColor) style.backgroundColor = field.bgColor;
      if (field.borderColor) style.border = "1px solid ".concat(field.borderColor);
      return style;
    },
    fieldInputStyle: function fieldInputStyle(field) {
      var style = {};
      if (!field) return style;
      if (field.fontSize) style.fontSize = typeof field.fontSize === 'number' ? field.fontSize + 'px' : field.fontSize;
      // autoFocus 类型的“功能输入框”，默认隐藏光标；如需显示可显式设置 hideCaret: false
      if (field.autoFocus && field.hideCaret !== false) {
        style.caretColor = 'transparent';
      }
      return style;
    },
    fieldLabelStyle: function fieldLabelStyle(field) {
      var style = {};
      if (!field) return style;
      if (field.color) style.color = field.color;
      if (field.fontSize) style.fontSize = typeof field.fontSize === 'number' ? field.fontSize + 'px' : field.fontSize;
      if (field.fontWeight) style.fontWeight = field.fontWeight;
      if (field.textAlign) style.textAlign = field.textAlign;
      return style;
    },
    focusAutoField: function focusAutoField() {
      var fields = this.resolvedFields;
      if (!Array.isArray(fields) || !fields.length) return;
      var target = fields.find(function (f) {
        return f && f.autoFocus;
      });
      if (!target || !target.id) return;
      var root = this.$el;
      var el = root.querySelector(".field-input[data-field-id=\"".concat(target.id, "\"]"));
      if (el && typeof el.focus === 'function') {
        el.focus();
      }
    },
    focusFieldById: function focusFieldById(fieldId) {
      var _this4 = this;
      if (!fieldId) return;
      this.$nextTick(function () {
        var root = _this4.$el;
        var el = root && root.querySelector ? root.querySelector(".field-input[data-field-id=\"".concat(fieldId, "\"]")) : null;
        if (el && typeof el.focus === 'function') {
          el.focus();
        }
      });
    }
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "fieldStyle", function fieldStyle(field) {
    var style = {};
    if (!field) return style;
    if (field.bgColor) style.background = field.bgColor;
    if (field.borderColor) style.border = "1px solid ".concat(field.borderColor);
    return style;
  }), "normalizeSrc", function normalizeSrc(val) {
    // 兼容 webpack/vite 的 require/import 返回形式
    if (!val) return val;
    if (typeof val === 'string') return val;
    if ((0, _typeof2.default)(val) === 'object' && typeof val.default === 'string') return val.default;
    return val;
  }), "reset", function reset() {
    var stepId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.initialStepId;
    if (this._afterEnterTimer) {
      clearTimeout(this._afterEnterTimer);
      this._afterEnterTimer = null;
    }
    this.currentStepId = stepId;
    this.hoveredHotspotId = '';
    this.ui = _objectSpread({}, this.initialUi);
    this.form = _objectSpread({}, this.initialForm);
    // reset 到同一步骤时，watcher 不会触发；这里补发一次
    this.$emit('step-change', this.currentStepId, this.currentStep, this.resolvedTip);
  }), "rectStyle", function rectStyle(rect) {
    var x = (rect.x || 0) * 100;
    var y = (rect.y || 0) * 100;
    var w = (rect.w || 0) * 100;
    var h = (rect.h || 0) * 100;
    return {
      left: x + '%',
      top: y + '%',
      width: w + '%',
      height: h + '%',
      cursor: rect.cursor || 'pointer'
    };
  }), "hotspotStyle", function hotspotStyle(hotspot) {
    if (!hotspot) return {};
    var style = _objectSpread({}, hotspot.style || {});
    var highlight = hotspot.highlight;
    var isHovered = this.hoveredHotspotId === hotspot.id;
    if (!isHovered) return style;
    if (highlight === 'primary') {
      style.background = style.background || 'rgba(64, 158, 255, .18)';
      style.border = style.border || '2px solid #409eff';
      style.boxShadow = style.boxShadow || '0 0 10px rgba(64, 158, 255, .7)';
    } else if (highlight === 'warning') {
      style.background = style.background || 'rgba(230, 162, 60, .18)';
      style.border = style.border || '2px solid #e6a23c';
      style.boxShadow = style.boxShadow || '0 0 10px rgba(230, 162, 60, .7)';
    } else if (highlight === 'danger') {
      style.background = style.background || 'rgba(245, 108, 108, .18)';
      style.border = style.border || '2px solid #f56c6c';
      style.boxShadow = style.boxShadow || '0 0 10px rgba(245, 108, 108, .7)';
    } else if (highlight === 'success') {
      style.background = style.background || 'rgba(103, 194, 58, .18)';
      style.border = style.border || '2px solid #67c23a';
      style.boxShadow = style.boxShadow || '0 0 10px rgba(103, 194, 58, .7)';
    }
    if (hotspot.hoverStyle) Object.assign(style, hotspot.hoverStyle);
    return style;
  }), "applySet", function applySet(setter) {
    var _this5 = this;
    if (!setter) return;
    Object.keys(setter).forEach(function (k) {
      _this5.$set(_this5.ui, k, setter[k]);
    });
  }), "applyFormSet", function applyFormSet(setter) {
    var _this6 = this;
    if (!setter) return;
    Object.keys(setter).forEach(function (k) {
      _this6.$set(_this6.form, k, setter[k]);
    });
  }), "onTableSelectionChange", function onTableSelectionChange(table, event) {
    if (!table || !event) return;
    var rowKey = table.rowKey || 'id';
    var selectedKey = event.row && event.row[rowKey];
    var isRadio = table.selectionType === 'radio';
    var currentKeys = Array.isArray(this.ui[table.id + 'SelectedKeys']) ? this.ui[table.id + 'SelectedKeys'].slice() : Array.isArray(table.selectedKeys) ? table.selectedKeys.slice() : [];
    var currentRows = Array.isArray(this.ui[table.id + 'SelectedRows']) ? this.ui[table.id + 'SelectedRows'].slice() : [];
    var existsIndex = currentKeys.indexOf(selectedKey);
    if (event.checked && isRadio) {
      // 单选：只选中当前行
      currentKeys = [selectedKey];
      currentRows = [_objectSpread({}, event.row)];
    } else if (event.checked) {
      if (existsIndex < 0) {
        currentKeys.push(selectedKey);
        currentRows.push(_objectSpread({}, event.row));
      }
    } else if (existsIndex > -1) {
      currentKeys.splice(existsIndex, 1);
      currentRows.splice(existsIndex, 1);
    }
    this.$set(this.ui, table.id + 'SelectedKeys', currentKeys);
    this.$set(this.ui, table.id + 'SelectedRows', currentRows);
    if (typeof table.onSelectionChange === 'function') {
      table.onSelectionChange({
        row: event.row,
        checked: event.checked,
        selectedKeys: currentKeys,
        selectedRows: currentRows,
        form: this.form,
        ui: this.ui,
        setForm: this.applyFormSet,
        setUi: this.applySet,
        go: this.go
      });
    }
    this.$emit('step-change', this.currentStepId, this.currentStep, this.resolvedTip);
  }), "onTableCellChange", function onTableCellChange(table, event) {
    if (!table || !event || !event.row) return;
    var rowKey = table.rowKey || 'id';
    var currentRows = Array.isArray(this.ui[table.id + 'SelectedRows']) ? this.ui[table.id + 'SelectedRows'].slice() : [];
    var targetKey = event.row[rowKey];
    var index = currentRows.findIndex(function (row) {
      return row && row[rowKey] === targetKey;
    });
    if (index > -1) {
      var nextRow = _objectSpread(_objectSpread({}, currentRows[index]), {}, (0, _defineProperty2.default)({}, event.key, event.value));
      currentRows.splice(index, 1, nextRow);
      this.$set(this.ui, table.id + 'SelectedRows', currentRows);
    }
    if (typeof table.onCellChange === 'function') {
      table.onCellChange({
        row: event.row,
        key: event.key,
        value: event.value,
        selectedRows: currentRows,
        form: this.form,
        ui: this.ui,
        setForm: this.applyFormSet,
        setUi: this.applySet,
        go: this.go
      });
    }
    this.$emit('step-change', this.currentStepId, this.currentStep, this.resolvedTip);
  }), "onTablePageChange", function onTablePageChange(table, page) {
    if (!table) return;
    this.$set(this.ui, table.id + 'Page', page);
    this.$emit('step-change', this.currentStepId, this.currentStep, this.resolvedTip);
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "onEnter", function onEnter(hotspot) {
    this.hoveredHotspotId = hotspot && hotspot.id ? hotspot.id : '';
    if (hotspot && hotspot.hoverSet) this.applySet(hotspot.hoverSet);
    if (hotspot && hotspot.on === 'mouseenter') {
      this.guardOrNext(hotspot);
    }
  }), "onLeave", function onLeave(hotspot) {
    if (this.hoveredHotspotId === (hotspot && hotspot.id)) this.hoveredHotspotId = '';
    if (hotspot && hotspot.hoverUnset) this.applySet(hotspot.hoverUnset);
  }), "guardOrNext", function guardOrNext(hotspot) {
    var guard = hotspot && hotspot.guard;
    if (typeof guard === 'function') {
      var res = guard({
        ui: this.ui,
        form: this.form
      });
      if (res && res.ok === false) {
        this.$emit('guard-failed', res);
        return;
      }
    }
    if (hotspot && hotspot.set) this.applySet(hotspot.set);
    if (hotspot && hotspot.setForm) this.applyFormSet(hotspot.setForm);
    if (hotspot && typeof hotspot.action === 'function') {
      var result = hotspot.action({
        ui: this.ui,
        form: this.form
      }) || {};
      if (result.set) this.applySet(result.set);
      if (result.setForm) this.applyFormSet(result.setForm);
      if (result.next) hotspot = _objectSpread(_objectSpread({}, hotspot), {}, {
        next: result.next
      });
    }
    if (hotspot && hotspot.focusFieldId) this.focusFieldById(hotspot.focusFieldId);
    // 一些热点（如“获取验证码”）只修改 ui，不切换步骤，
    // 这里补发一次 step-change，让父组件同步更新右侧提示。
    if (hotspot && (hotspot.set || hotspot.setForm) && !hotspot.next) {
      this.$emit('step-change', this.currentStepId, this.currentStep, this.resolvedTip);
    }
    if (hotspot && hotspot.next) this.go(hotspot.next);
    if (hotspot && hotspot.emit) this.$emit(hotspot.emit, {
      stepId: this.currentStepId,
      hotspotId: hotspot.id
    });
  }), "onClick", function onClick(hotspot) {
    if (!hotspot) return;
    if (hotspot.on && hotspot.on !== 'click') return;
    this.guardOrNext(hotspot);
  }), "onContextMenu", function onContextMenu(hotspot) {
    if (!hotspot) return;
    if (hotspot.on && hotspot.on !== 'contextmenu' && hotspot.on !== 'rightclick') return;
    this.guardOrNext(hotspot);
  }), "onDblClick", function onDblClick(hotspot) {
    if (!hotspot) return;
    if (hotspot.on !== 'dblclick') return;
    this.guardOrNext(hotspot);
  }), "onFieldInput", function onFieldInput(field, evt) {
    var val = evt && evt.target ? evt.target.value : '';
    this.$set(this.form, field.model, val);
    if (typeof field.onInput === 'function') {
      field.onInput({
        value: val,
        ui: this.ui,
        form: this.form,
        go: this.go,
        setUi: this.applySet,
        setForm: this.applyFormSet,
        nextTick: this.$nextTick.bind(this)
      });
    }
  }), "onEnterSubmit", function onEnterSubmit(field) {
    if (!field || !field.onEnter) return;
    var result = field.onEnter({
      ui: this.ui,
      form: this.form,
      go: this.go,
      setUi: this.applySet,
      set: this.applySet,
      setForm: this.applyFormSet
    });
    if (result && result.ok === false) this.$emit('guard-failed', result);
  }), "go", function go(stepId) {
    if (!this.stepMap[stepId]) {
      this.$emit('unknown-step', stepId);
      return;
    }
    this.currentStepId = stepId;
    if (this.currentStep && this.currentStep.emitOnEnter) {
      this.$emit(this.currentStep.emitOnEnter, {
        stepId: stepId
      });
    }
    if (this.currentStep && this.currentStep.isEnd) {
      this.$emit('finish', {
        stepId: stepId
      });
    }
  }))
};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SceneTable',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      page: 1
    };
  },
  computed: {
    columns: function columns() {
      return Array.isArray(this.config.columns) ? this.config.columns : [];
    },
    rows: function rows() {
      return Array.isArray(this.config.rows) ? this.config.rows : [];
    },
    rowKey: function rowKey() {
      return this.config.rowKey || 'id';
    },
    selectable: function selectable() {
      return this.config.selectable === true;
    },
    selectionType: function selectionType() {
      return this.config.selectionType === 'radio' ? 'radio' : 'checkbox';
    },
    selectionInputType: function selectionInputType() {
      return this.selectionType;
    },
    tableName: function tableName() {
      return 'scene-table-' + (this.config.id || this._uid);
    },
    selectedKeys: function selectedKeys() {
      return Array.isArray(this.config.selectedKeys) ? this.config.selectedKeys : [];
    },
    selectionDisabled: function selectionDisabled() {
      return this.config.selectionDisabled === true;
    },
    pageSize: function pageSize() {
      return Number(this.config.pageSize) > 0 ? Number(this.config.pageSize) : 0;
    },
    total: function total() {
      return Number(this.config.total) > 0 ? Number(this.config.total) : this.rows.length;
    },
    totalPages: function totalPages() {
      if (!this.pageSize) return 1;
      return Math.max(1, Math.ceil(this.rows.length / this.pageSize));
    },
    showPagination: function showPagination() {
      return !!this.pageSize;
    },
    tableStyle: function tableStyle() {
      var contentWidth = this.columns.reduce(function (total, column) {
        var width = Number(column.width);
        return total + (Number.isFinite(width) ? width : 120);
      }, this.selectable ? 40 : 0);
      var style = {
        minWidth: Math.max(contentWidth, 100) + 'px'
      };
      var fontSize = Number(this.config.fontSize);
      if (Number.isFinite(fontSize) && fontSize > 0) style.fontSize = fontSize + 'px';
      return style;
    },
    pagedRows: function pagedRows() {
      if (!this.pageSize) return this.rows;
      var start = (this.page - 1) * this.pageSize;
      return this.rows.slice(start, start + this.pageSize);
    }
  },
  watch: {
    config: {
      deep: true,
      handler: function handler() {
        if (this.page > this.totalPages) this.page = this.totalPages;
      }
    }
  },
  methods: {
    columnStyle: function columnStyle(column) {
      var style = {};
      if (column.width) style.width = typeof column.width === 'number' ? column.width + 'px' : column.width;
      if (column.align) style.textAlign = column.align;
      if (column.whiteSpace) style.whiteSpace = column.whiteSpace;
      return style;
    },
    cellStyle: function cellStyle(row, column) {
      var style = {};
      var rowHeight = Number(this.config.rowHeight);
      if (Number.isFinite(rowHeight) && rowHeight > 0) style.height = rowHeight + 'px';
      var columnStyle = typeof column.cellStyle === 'function' ? column.cellStyle(row) : column.cellStyle;
      return _objectSpread(_objectSpread({}, style), columnStyle || {});
    },
    isCellInputDisabled: function isCellInputDisabled(row, column) {
      if (typeof column.inputDisabled === 'function') return column.inputDisabled(row) === true;
      return column.inputDisabled === true;
    },
    formatCell: function formatCell(row, column) {
      if (typeof column.formatter === 'function') return column.formatter(row);
      return row[column.key];
    },
    badgeClass: function badgeClass(row, column) {
      var value = String(this.formatCell(row, column) || '');
      if (value === '换') return 'badge-exchange';
      if (value === '退') return 'badge-return';
      if (value === '补') return 'badge-resend';
      return '';
    },
    isSelected: function isSelected(row) {
      var key = row[this.rowKey];
      return this.selectedKeys.indexOf(key) > -1;
    },
    toggleRow: function toggleRow(row, event) {
      if (this.selectionDisabled) return;
      var checked = !!(event && event.target && event.target.checked);
      this.$emit('selection-change', {
        row: row,
        checked: checked,
        page: this.page
      });
    },
    changeCell: function changeCell(row, column, event) {
      var value = event && event.target ? event.target.value : '';
      this.$emit('cell-change', {
        row: row,
        key: column.key,
        value: value,
        page: this.page
      });
    },
    changePage: function changePage(nextPage) {
      var page = Math.max(1, Math.min(this.totalPages, nextPage));
      this.page = page;
      this.$emit('page-change', page);
    }
  }
};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pddStudyScenarios = __webpack_require__(575);
var _StepPlayer = _interopRequireDefault(__webpack_require__(74));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TAB_KEYS = ['first', 'second', 'third', 'four', 'five', 'six', 'seven'];
var _default = exports.default = {
  components: {
    StepPlayer: _StepPlayer.default
  },
  data: function data() {
    var rightTip = {};
    TAB_KEYS.forEach(function (k) {
      rightTip[k] = '';
    });
    return {
      tabIndex: 1,
      tabCurrent: 'first',
      scenarioConfig: (0, _pddStudyScenarios.getScenarioConfig)(),
      rightTip: rightTip,
      currentStepId: TAB_KEYS.reduce(function (m, k) {
        m[k] = '';
        return m;
      }, {}),
      showLoginPassword: false
    };
  },
  mounted: function mounted() {
    this.initAll();
  },
  methods: {
    goBack: function goBack() {
      if (window.parent && typeof window.parent['goBack'] === 'function') {
        window.parent['goBack']();
        return;
      }
      this.$router && this.$router.back && this.$router.back();
    },
    initAll: function initAll() {
      var _this = this;
      TAB_KEYS.forEach(function (k) {
        _this.rightTip[k] = '';
      });
      var playerRefs = ['playerFirst', 'playerSecond', 'playerThird', 'playerFour', 'playerFive', 'playerSix', 'playerSeven'];
      playerRefs.forEach(function (ref, i) {
        var player = _this.$refs[ref];
        var tabKey = TAB_KEYS[i];
        if (player && _this.scenarioConfig[tabKey]) {
          player.reset(_this.scenarioConfig[tabKey].initialStepId);
        }
      });
      $('.content').each(function () {
        $(this).hide();
      });
      $('.stoptip').each(function () {
        $(this).hide();
      });
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $('#tab-' + this.tabCurrent + '-content').show();
      if (this.tabCurrent === 'first') {
        $('#stoptip-' + this.tabCurrent).show();
      } else {
        $('#content-' + this.tabCurrent).css('display', 'flex');
      }
    },
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).css('display', 'flex');
      var ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1);
      var player = this.$refs[ref];
      var cfg = this.scenarioConfig[this.tabCurrent];
      if (player && cfg) {
        player.reset(cfg.initialStepId);
      }
      this.addRecord('START', this.tabIndex);
    },
    onFinish: function onFinish(tabKey) {
      this.addRecord('END', this.tabIndex);
      setTimeout(function () {
        $('#studytip-' + tabKey).show();
      }, 2000);
    },
    onStepChange: function onStepChange(tabKey, stepId, step, resolvedTip) {
      this.$set(this.currentStepId, tabKey, stepId);
      if (tabKey === 'first' && stepId !== 'login2') {
        this.showLoginPassword = false;
      }
      this.$set(this.rightTip, tabKey, resolvedTip || '');
    },
    onGuardFailed: function onGuardFailed(tabKey, res) {
      this.$alert(res && res.msg ? res.msg : '校验未通过');
    },
    onRequestFile: function onRequestFile() {
      this.$refs.fileInputSix && this.$refs.fileInputSix.click();
    },
    onSixFileChange: function onSixFileChange(evt) {
      var _this2 = this;
      var file = evt.target.files && evt.target.files[0];
      if (!file || file.name && file.name.indexOf('快捷短语') < 0) {
        this.$alert('请选择你下载的“快捷短语.csv”模板文件');
        return;
      }
      var player = this.$refs.playerSix;
      if (player) player.go('six_5');
      setTimeout(function () {
        if (_this2.$refs.fileInputSix) _this2.$refs.fileInputSix.value = '';
      }, 300);
    },
    downloadKjdyFile: function downloadKjdyFile() {
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      fetch(path).then(function (r) {
        return r.blob();
      }).then(function (blob) {
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = '快捷短语.csv';
        a.click();
        a.remove();
      });
    },
    restartStudy: function restartStudy() {
      var cfg = this.scenarioConfig[this.tabCurrent];
      if (!cfg) return;
      var ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1);
      var player = this.$refs[ref];
      if (player) player.reset(cfg.initialStepId);
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START', this.tabIndex);
    },
    studyNext: function studyNext(next, index, tabCurrent) {
      if (index !== this.tabIndex + 1) return;
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabIndex = index;
      this.tabCurrent = tabCurrent;
      this.initAll();
      this.addRecord('START', this.tabIndex);
    },
    addRecord: function addRecord(type, stepSeq) {
      var _this3 = this;
      var data = {
        exerciseType: 'PDD_EXAM',
        stepSeq: stepSeq,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          return;
        }
        _this3.$message({
          message: result && result.msg || '操作失败',
          type: 'error',
          center: true,
          duration: 1000
        });
      }, function () {
        _this3.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
var _JstErpLoginScene = _interopRequireDefault(__webpack_require__(580));
var _JstErpSecondScene = _interopRequireDefault(__webpack_require__(582));
var _JstErpCreateAftersaleScene = _interopRequireDefault(__webpack_require__(587));
var _JstErpOrderQueryScene = _interopRequireDefault(__webpack_require__(589));
var _JstErpPlaceholderScene = _interopRequireDefault(__webpack_require__(1378));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_VIDEO_URL = 'http://taojinyun.file.itaojin.cn/qianniusource/202412/';
var BASE_PDF_URL = '//res.study.itaojin.cn/2024-12/661361ebec2f434fb859625f84480ea0.pdf';
var CHAPTERS = [{
  key: 'first',
  title: '1、登记无条件信息',
  videoUrl: BASE_VIDEO_URL + 'step1.mp4',
  pptTitle: '聚水潭ERP练习-登记无条件信息.ppt',
  pdfViewerId: 'jst_pdf_viewer_1',
  implemented: true
}, {
  key: 'second',
  title: '2、手工创建售后单',
  videoUrl: BASE_VIDEO_URL + 'step2.mp4',
  pptTitle: '聚水潭ERP练习-手工创建售后单.ppt',
  pdfViewerId: 'jst_pdf_viewer_2',
  implemented: true
}, {
  key: 'third',
  title: '3、创建售后',
  videoUrl: BASE_VIDEO_URL + 'step3.mp4',
  pptTitle: '聚水潭ERP练习-创建售后.ppt',
  pdfViewerId: 'jst_pdf_viewer_3',
  implemented: true
}, {
  key: 'four',
  title: '4、订单查询',
  videoUrl: BASE_VIDEO_URL + 'step4.mp4',
  pptTitle: '聚水潭ERP练习-订单查询.ppt',
  pdfViewerId: 'jst_pdf_viewer_4',
  implemented: true
}];
var _default = exports.default = {
  name: 'JuShuiTanErpStudy',
  components: {
    JstErpLoginScene: _JstErpLoginScene.default,
    JstErpSecondScene: _JstErpSecondScene.default,
    JstErpCreateAftersaleScene: _JstErpCreateAftersaleScene.default,
    JstErpOrderQueryScene: _JstErpOrderQueryScene.default,
    JstErpPlaceholderScene: _JstErpPlaceholderScene.default
  },
  data: function data() {
    var isOpenPpt = {};
    CHAPTERS.forEach(function (chapter) {
      isOpenPpt[chapter.key] = false;
    });
    return {
      chapters: CHAPTERS,
      tabCurrent: 'first',
      isOpenPpt: isOpenPpt,
      rightTip: '',
      rightTipStep: '',
      finishTimer: null,
      showLoginPassword: false,
      state: {
        videoGateVisible: true,
        videoCompleted: false,
        practiceVisible: false,
        practiceCompleted: false
      }
    };
  },
  computed: {
    currentChapter: function currentChapter() {
      var _this = this;
      return this.chapters.find(function (chapter) {
        return chapter.key === _this.tabCurrent;
      }) || this.chapters[0];
    },
    isLastChapter: function isLastChapter() {
      return this.tabCurrent === this.chapters[this.chapters.length - 1].key;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearFinishTimer();
  },
  methods: {
    getCurrentVideo: function getCurrentVideo() {
      var videoRef = this.$refs['video-' + this.tabCurrent];
      return Array.isArray(videoRef) ? videoRef[0] : videoRef;
    },
    getCurrentScene: function getCurrentScene() {
      var sceneRef = this.$refs['scene-' + this.tabCurrent];
      return Array.isArray(sceneRef) ? sceneRef[0] : sceneRef;
    },
    startVideo: function startVideo() {
      var video = this.getCurrentVideo();
      if (video) video.play();
    },
    onVideoPlay: function onVideoPlay() {
      this.state.videoGateVisible = false;
    },
    onVideoEnded: function onVideoEnded() {
      this.state.videoCompleted = true;
    },
    restartVideo: function restartVideo() {
      var video = this.getCurrentVideo();
      if (!video) return;
      video.currentTime = 0;
      video.play();
      this.state.videoCompleted = false;
    },
    startStudy: function startStudy() {
      var _this2 = this;
      this.clearFinishTimer();
      var video = this.getCurrentVideo();
      if (video) video.pause();
      this.state.videoCompleted = false;
      this.state.practiceVisible = true;
      this.state.practiceCompleted = false;
      this.showLoginPassword = false;
      this.addRecord('START');
      this.$nextTick(function () {
        var scene = _this2.getCurrentScene();
        if (scene && scene.reset) scene.reset();
      });
    },
    onStepChange: function onStepChange(stepId, step, tip) {
      this.rightTipStep = stepId;
      this.rightTip = tip || '';
      if (stepId !== 'login') this.showLoginPassword = false;
    },
    onGuardFailed: function onGuardFailed(res) {
      this.$alert(res && res.msg ? res.msg : '校验未通过');
    },
    onFinish: function onFinish() {
      var _this3 = this;
      this.addRecord('END', this.isLastChapter ? this.finishCourse : null);
      this.clearFinishTimer();
      this.finishTimer = setTimeout(function () {
        _this3.finishTimer = null;
        _this3.state.practiceCompleted = true;
      }, 2000);
    },
    restartStudy: function restartStudy() {
      this.clearFinishTimer();
      this.state.practiceCompleted = false;
      this.showLoginPassword = false;
      this.addRecord('START');
      var scene = this.getCurrentScene();
      if (scene && scene.reset) scene.reset();
    },
    studyNext: function studyNext() {
      var _this4 = this;
      var currentIndex = this.chapters.findIndex(function (chapter) {
        return chapter.key === _this4.tabCurrent;
      });
      var nextChapter = this.chapters[currentIndex + 1];
      if (!nextChapter) return;
      this.tabCurrent = nextChapter.key;
      this.resetChapterState(nextChapter.key);
    },
    finishCourse: function finishCourse() {
      if (window.parent && typeof window.parent.goBack === 'function') {
        window.parent.goBack();
      }
    },
    handleTabClick: function handleTabClick() {
      this.resetChapterState(this.tabCurrent);
    },
    resetChapterState: function resetChapterState(tabKey) {
      var _this5 = this;
      this.clearFinishTimer();
      var currentVideo = this.getCurrentVideo();
      if (currentVideo) {
        currentVideo.pause();
        currentVideo.currentTime = 0;
      }
      this.state.videoGateVisible = tabKey === 'first';
      this.state.videoCompleted = false;
      this.state.practiceVisible = false;
      this.state.practiceCompleted = false;
      this.rightTip = '';
      this.rightTipStep = '';
      this.showLoginPassword = false;
      Object.keys(this.isOpenPpt).forEach(function (key) {
        _this5.isOpenPpt[key] = false;
      });
    },
    clearFinishTimer: function clearFinishTimer() {
      if (!this.finishTimer) return;
      clearTimeout(this.finishTimer);
      this.finishTimer = null;
    },
    addRecord: function addRecord(exerciseAction, onSuccess) {
      var _this6 = this;
      var stepSeq = this.chapters.findIndex(function (chapter) {
        return chapter.key === _this6.tabCurrent;
      }) + 1;
      var data = {
        exerciseType: 'WORKORDER_JUSHUITAN',
        stepSeq: stepSeq,
        exerciseAction: exerciseAction
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          if (exerciseAction === 'END' && _this6.isLastChapter) {
            _this6.submitKnowledgeRecord(onSuccess);
          } else if (onSuccess) {
            onSuccess();
          }
        } else {
          _this6.$message({
            message: result && result.msg || '记录练习进度失败',
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function () {
        _this6.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    submitKnowledgeRecord: function submitKnowledgeRecord(onSuccess) {
      var _this7 = this;
      var knowledgeId = this.$route.query.knowledgeId;
      var courseId = this.$route.query.courseId;
      if (!knowledgeId || !courseId) {
        if (onSuccess) onSuccess();
        return;
      }
      var param = {
        assitant: 'assitantNotNull_force_passRecord',
        knowledgeId: knowledgeId,
        courseId: courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/course/submitKnowledgeXlk', param).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          if (onSuccess) onSuccess();
        } else {
          _this7.$message({
            message: result && result.msg || '记录知识点完成状态失败',
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function () {
        _this7.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    viewPpt: function viewPpt(tabKey, collapse) {
      var chapter = this.chapters.find(function (item) {
        return item.key === tabKey;
      });
      if (!chapter) return;
      if (this.isOpenPpt[tabKey] || collapse === false) {
        this.$set(this.isOpenPpt, tabKey, false);
        var viewer = document.getElementById(chapter.pdfViewerId);
        if (viewer) viewer.style.height = '0';
        return;
      }
      this.$set(this.isOpenPpt, tabKey, true);
      this.$nextTick(function () {
        var viewer = document.getElementById(chapter.pdfViewerId);
        if (!viewer || !_pdfobject.default.supportsPDFs) return;
        viewer.style.height = '700px';
        _pdfobject.default.embed(BASE_PDF_URL, '#' + chapter.pdfViewerId, {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: 'FitV',
            pagemode: 'thumbs',
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: '//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html'
        });
      });
    }
  }
};

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpLoginScene_vue__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpLoginScene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpLoginScene_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpLoginScene_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpLoginScene_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31178041_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpLoginScene_vue__ = __webpack_require__(1361);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1300)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31178041"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpLoginScene_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31178041_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpLoginScene_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/jushuitan/JstErpLoginScene.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31178041", Component.options)
  } else {
    hotAPI.reload("data-v-31178041", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StepPlayer = _interopRequireDefault(__webpack_require__(74));
var _jstErpScenarios = __webpack_require__(1302);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JstErpLoginScene',
  components: {
    StepPlayer: _StepPlayer.default
  },
  data: function data() {
    return {
      scenario: (0, _jstErpScenarios.getJstErpScenario)()
    };
  },
  methods: {
    onStepChange: function onStepChange(stepId, step, resolvedTip) {
      this.$emit('step-change', stepId, step, resolvedTip);
    },
    onGuardFailed: function onGuardFailed(res) {
      this.$emit('guard-failed', res);
    },
    onFinish: function onFinish(payload) {
      this.$emit('finish', payload);
    },
    reset: function reset() {
      var player = this.$refs.player;
      if (player) player.reset(this.scenario.initialStepId);
    }
  }
};

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpSecondScene_vue__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpSecondScene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpSecondScene_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpSecondScene_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpSecondScene_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634d6f4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpSecondScene_vue__ = __webpack_require__(1365);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1362)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-634d6f4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpSecondScene_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634d6f4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpSecondScene_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/jushuitan/JstErpSecondScene.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-634d6f4a", Component.options)
  } else {
    hotAPI.reload("data-v-634d6f4a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StepPlayer = _interopRequireDefault(__webpack_require__(74));
var _jstErpSecondScenarios = __webpack_require__(1364);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JstErpSecondScene',
  components: {
    StepPlayer: _StepPlayer.default
  },
  data: function data() {
    return {
      scenario: (0, _jstErpSecondScenarios.getJstErpSecondScenario)()
    };
  },
  methods: {
    onStepChange: function onStepChange(stepId, step, resolvedTip) {
      this.$emit('step-change', stepId, step, resolvedTip);
    },
    onGuardFailed: function onGuardFailed(res) {
      this.$emit('guard-failed', res);
    },
    onFinish: function onFinish(payload) {
      this.$emit('finish', payload);
    },
    reset: function reset() {
      var player = this.$refs.player;
      if (player) player.reset(this.scenario.initialStepId);
    }
  }
};

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = [{"code":"110000","name":"北京市","province":"11"},{"code":"120000","name":"天津市","province":"12"},{"code":"130000","name":"河北省","province":"13"},{"code":"140000","name":"山西省","province":"14"},{"code":"150000","name":"内蒙古自治区","province":"15"},{"code":"210000","name":"辽宁省","province":"21"},{"code":"220000","name":"吉林省","province":"22"},{"code":"230000","name":"黑龙江省","province":"23"},{"code":"310000","name":"上海市","province":"31"},{"code":"320000","name":"江苏省","province":"32"},{"code":"330000","name":"浙江省","province":"33"},{"code":"340000","name":"安徽省","province":"34"},{"code":"350000","name":"福建省","province":"35"},{"code":"360000","name":"江西省","province":"36"},{"code":"370000","name":"山东省","province":"37"},{"code":"410000","name":"河南省","province":"41"},{"code":"420000","name":"湖北省","province":"42"},{"code":"430000","name":"湖南省","province":"43"},{"code":"440000","name":"广东省","province":"44"},{"code":"450000","name":"广西壮族自治区","province":"45"},{"code":"460000","name":"海南省","province":"46"},{"code":"500000","name":"重庆市","province":"50"},{"code":"510000","name":"四川省","province":"51"},{"code":"520000","name":"贵州省","province":"52"},{"code":"530000","name":"云南省","province":"53"},{"code":"540000","name":"西藏自治区","province":"54"},{"code":"610000","name":"陕西省","province":"61"},{"code":"620000","name":"甘肃省","province":"62"},{"code":"630000","name":"青海省","province":"63"},{"code":"640000","name":"宁夏回族自治区","province":"64"},{"code":"650000","name":"新疆维吾尔自治区","province":"65"},{"code":"710000","name":"台湾省","province":"71"},{"code":"810000","name":"香港特别行政区","province":"81"},{"code":"820000","name":"澳门特别行政区","province":"82"}]

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = [{"code":"130100","name":"石家庄市","province":"13","city":"01"},{"code":"130200","name":"唐山市","province":"13","city":"02"},{"code":"130300","name":"秦皇岛市","province":"13","city":"03"},{"code":"130400","name":"邯郸市","province":"13","city":"04"},{"code":"130500","name":"邢台市","province":"13","city":"05"},{"code":"130600","name":"保定市","province":"13","city":"06"},{"code":"130700","name":"张家口市","province":"13","city":"07"},{"code":"130800","name":"承德市","province":"13","city":"08"},{"code":"130900","name":"沧州市","province":"13","city":"09"},{"code":"131000","name":"廊坊市","province":"13","city":"10"},{"code":"131100","name":"衡水市","province":"13","city":"11"},{"code":"140100","name":"太原市","province":"14","city":"01"},{"code":"140200","name":"大同市","province":"14","city":"02"},{"code":"140300","name":"阳泉市","province":"14","city":"03"},{"code":"140400","name":"长治市","province":"14","city":"04"},{"code":"140500","name":"晋城市","province":"14","city":"05"},{"code":"140600","name":"朔州市","province":"14","city":"06"},{"code":"140700","name":"晋中市","province":"14","city":"07"},{"code":"140800","name":"运城市","province":"14","city":"08"},{"code":"140900","name":"忻州市","province":"14","city":"09"},{"code":"141000","name":"临汾市","province":"14","city":"10"},{"code":"141100","name":"吕梁市","province":"14","city":"11"},{"code":"150100","name":"呼和浩特市","province":"15","city":"01"},{"code":"150200","name":"包头市","province":"15","city":"02"},{"code":"150300","name":"乌海市","province":"15","city":"03"},{"code":"150400","name":"赤峰市","province":"15","city":"04"},{"code":"150500","name":"通辽市","province":"15","city":"05"},{"code":"150600","name":"鄂尔多斯市","province":"15","city":"06"},{"code":"150700","name":"呼伦贝尔市","province":"15","city":"07"},{"code":"150800","name":"巴彦淖尔市","province":"15","city":"08"},{"code":"150900","name":"乌兰察布市","province":"15","city":"09"},{"code":"152200","name":"兴安盟","province":"15","city":"22"},{"code":"152500","name":"锡林郭勒盟","province":"15","city":"25"},{"code":"152900","name":"阿拉善盟","province":"15","city":"29"},{"code":"210100","name":"沈阳市","province":"21","city":"01"},{"code":"210200","name":"大连市","province":"21","city":"02"},{"code":"210300","name":"鞍山市","province":"21","city":"03"},{"code":"210400","name":"抚顺市","province":"21","city":"04"},{"code":"210500","name":"本溪市","province":"21","city":"05"},{"code":"210600","name":"丹东市","province":"21","city":"06"},{"code":"210700","name":"锦州市","province":"21","city":"07"},{"code":"210800","name":"营口市","province":"21","city":"08"},{"code":"210900","name":"阜新市","province":"21","city":"09"},{"code":"211000","name":"辽阳市","province":"21","city":"10"},{"code":"211100","name":"盘锦市","province":"21","city":"11"},{"code":"211200","name":"铁岭市","province":"21","city":"12"},{"code":"211300","name":"朝阳市","province":"21","city":"13"},{"code":"211400","name":"葫芦岛市","province":"21","city":"14"},{"code":"220100","name":"长春市","province":"22","city":"01"},{"code":"220200","name":"吉林市","province":"22","city":"02"},{"code":"220300","name":"四平市","province":"22","city":"03"},{"code":"220400","name":"辽源市","province":"22","city":"04"},{"code":"220500","name":"通化市","province":"22","city":"05"},{"code":"220600","name":"白山市","province":"22","city":"06"},{"code":"220700","name":"松原市","province":"22","city":"07"},{"code":"220800","name":"白城市","province":"22","city":"08"},{"code":"222400","name":"延边朝鲜族自治州","province":"22","city":"24"},{"code":"230100","name":"哈尔滨市","province":"23","city":"01"},{"code":"230200","name":"齐齐哈尔市","province":"23","city":"02"},{"code":"230300","name":"鸡西市","province":"23","city":"03"},{"code":"230400","name":"鹤岗市","province":"23","city":"04"},{"code":"230500","name":"双鸭山市","province":"23","city":"05"},{"code":"230600","name":"大庆市","province":"23","city":"06"},{"code":"230700","name":"伊春市","province":"23","city":"07"},{"code":"230800","name":"佳木斯市","province":"23","city":"08"},{"code":"230900","name":"七台河市","province":"23","city":"09"},{"code":"231000","name":"牡丹江市","province":"23","city":"10"},{"code":"231100","name":"黑河市","province":"23","city":"11"},{"code":"231200","name":"绥化市","province":"23","city":"12"},{"code":"232700","name":"大兴安岭地区","province":"23","city":"27"},{"code":"320100","name":"南京市","province":"32","city":"01"},{"code":"320200","name":"无锡市","province":"32","city":"02"},{"code":"320300","name":"徐州市","province":"32","city":"03"},{"code":"320400","name":"常州市","province":"32","city":"04"},{"code":"320500","name":"苏州市","province":"32","city":"05"},{"code":"320600","name":"南通市","province":"32","city":"06"},{"code":"320700","name":"连云港市","province":"32","city":"07"},{"code":"320800","name":"淮安市","province":"32","city":"08"},{"code":"320900","name":"盐城市","province":"32","city":"09"},{"code":"321000","name":"扬州市","province":"32","city":"10"},{"code":"321100","name":"镇江市","province":"32","city":"11"},{"code":"321200","name":"泰州市","province":"32","city":"12"},{"code":"321300","name":"宿迁市","province":"32","city":"13"},{"code":"330100","name":"杭州市","province":"33","city":"01"},{"code":"330200","name":"宁波市","province":"33","city":"02"},{"code":"330300","name":"温州市","province":"33","city":"03"},{"code":"330400","name":"嘉兴市","province":"33","city":"04"},{"code":"330500","name":"湖州市","province":"33","city":"05"},{"code":"330600","name":"绍兴市","province":"33","city":"06"},{"code":"330700","name":"金华市","province":"33","city":"07"},{"code":"330800","name":"衢州市","province":"33","city":"08"},{"code":"330900","name":"舟山市","province":"33","city":"09"},{"code":"331000","name":"台州市","province":"33","city":"10"},{"code":"331100","name":"丽水市","province":"33","city":"11"},{"code":"340100","name":"合肥市","province":"34","city":"01"},{"code":"340200","name":"芜湖市","province":"34","city":"02"},{"code":"340300","name":"蚌埠市","province":"34","city":"03"},{"code":"340400","name":"淮南市","province":"34","city":"04"},{"code":"340500","name":"马鞍山市","province":"34","city":"05"},{"code":"340600","name":"淮北市","province":"34","city":"06"},{"code":"340700","name":"铜陵市","province":"34","city":"07"},{"code":"340800","name":"安庆市","province":"34","city":"08"},{"code":"341000","name":"黄山市","province":"34","city":"10"},{"code":"341100","name":"滁州市","province":"34","city":"11"},{"code":"341200","name":"阜阳市","province":"34","city":"12"},{"code":"341300","name":"宿州市","province":"34","city":"13"},{"code":"341500","name":"六安市","province":"34","city":"15"},{"code":"341600","name":"亳州市","province":"34","city":"16"},{"code":"341700","name":"池州市","province":"34","city":"17"},{"code":"341800","name":"宣城市","province":"34","city":"18"},{"code":"350100","name":"福州市","province":"35","city":"01"},{"code":"350200","name":"厦门市","province":"35","city":"02"},{"code":"350300","name":"莆田市","province":"35","city":"03"},{"code":"350400","name":"三明市","province":"35","city":"04"},{"code":"350500","name":"泉州市","province":"35","city":"05"},{"code":"350600","name":"漳州市","province":"35","city":"06"},{"code":"350700","name":"南平市","province":"35","city":"07"},{"code":"350800","name":"龙岩市","province":"35","city":"08"},{"code":"350900","name":"宁德市","province":"35","city":"09"},{"code":"360100","name":"南昌市","province":"36","city":"01"},{"code":"360200","name":"景德镇市","province":"36","city":"02"},{"code":"360300","name":"萍乡市","province":"36","city":"03"},{"code":"360400","name":"九江市","province":"36","city":"04"},{"code":"360500","name":"新余市","province":"36","city":"05"},{"code":"360600","name":"鹰潭市","province":"36","city":"06"},{"code":"360700","name":"赣州市","province":"36","city":"07"},{"code":"360800","name":"吉安市","province":"36","city":"08"},{"code":"360900","name":"宜春市","province":"36","city":"09"},{"code":"361000","name":"抚州市","province":"36","city":"10"},{"code":"361100","name":"上饶市","province":"36","city":"11"},{"code":"370100","name":"济南市","province":"37","city":"01"},{"code":"370200","name":"青岛市","province":"37","city":"02"},{"code":"370300","name":"淄博市","province":"37","city":"03"},{"code":"370400","name":"枣庄市","province":"37","city":"04"},{"code":"370500","name":"东营市","province":"37","city":"05"},{"code":"370600","name":"烟台市","province":"37","city":"06"},{"code":"370700","name":"潍坊市","province":"37","city":"07"},{"code":"370800","name":"济宁市","province":"37","city":"08"},{"code":"370900","name":"泰安市","province":"37","city":"09"},{"code":"371000","name":"威海市","province":"37","city":"10"},{"code":"371100","name":"日照市","province":"37","city":"11"},{"code":"371300","name":"临沂市","province":"37","city":"13"},{"code":"371400","name":"德州市","province":"37","city":"14"},{"code":"371500","name":"聊城市","province":"37","city":"15"},{"code":"371600","name":"滨州市","province":"37","city":"16"},{"code":"371700","name":"菏泽市","province":"37","city":"17"},{"code":"410100","name":"郑州市","province":"41","city":"01"},{"code":"410200","name":"开封市","province":"41","city":"02"},{"code":"410300","name":"洛阳市","province":"41","city":"03"},{"code":"410400","name":"平顶山市","province":"41","city":"04"},{"code":"410500","name":"安阳市","province":"41","city":"05"},{"code":"410600","name":"鹤壁市","province":"41","city":"06"},{"code":"410700","name":"新乡市","province":"41","city":"07"},{"code":"410800","name":"焦作市","province":"41","city":"08"},{"code":"410900","name":"濮阳市","province":"41","city":"09"},{"code":"411000","name":"许昌市","province":"41","city":"10"},{"code":"411100","name":"漯河市","province":"41","city":"11"},{"code":"411200","name":"三门峡市","province":"41","city":"12"},{"code":"411300","name":"南阳市","province":"41","city":"13"},{"code":"411400","name":"商丘市","province":"41","city":"14"},{"code":"411500","name":"信阳市","province":"41","city":"15"},{"code":"411600","name":"周口市","province":"41","city":"16"},{"code":"411700","name":"驻马店市","province":"41","city":"17"},{"code":"420100","name":"武汉市","province":"42","city":"01"},{"code":"420200","name":"黄石市","province":"42","city":"02"},{"code":"420300","name":"十堰市","province":"42","city":"03"},{"code":"420500","name":"宜昌市","province":"42","city":"05"},{"code":"420600","name":"襄阳市","province":"42","city":"06"},{"code":"420700","name":"鄂州市","province":"42","city":"07"},{"code":"420800","name":"荆门市","province":"42","city":"08"},{"code":"420900","name":"孝感市","province":"42","city":"09"},{"code":"421000","name":"荆州市","province":"42","city":"10"},{"code":"421100","name":"黄冈市","province":"42","city":"11"},{"code":"421200","name":"咸宁市","province":"42","city":"12"},{"code":"421300","name":"随州市","province":"42","city":"13"},{"code":"422800","name":"恩施土家族苗族自治州","province":"42","city":"28"},{"code":"430100","name":"长沙市","province":"43","city":"01"},{"code":"430200","name":"株洲市","province":"43","city":"02"},{"code":"430300","name":"湘潭市","province":"43","city":"03"},{"code":"430400","name":"衡阳市","province":"43","city":"04"},{"code":"430500","name":"邵阳市","province":"43","city":"05"},{"code":"430600","name":"岳阳市","province":"43","city":"06"},{"code":"430700","name":"常德市","province":"43","city":"07"},{"code":"430800","name":"张家界市","province":"43","city":"08"},{"code":"430900","name":"益阳市","province":"43","city":"09"},{"code":"431000","name":"郴州市","province":"43","city":"10"},{"code":"431100","name":"永州市","province":"43","city":"11"},{"code":"431200","name":"怀化市","province":"43","city":"12"},{"code":"431300","name":"娄底市","province":"43","city":"13"},{"code":"433100","name":"湘西土家族苗族自治州","province":"43","city":"31"},{"code":"440100","name":"广州市","province":"44","city":"01"},{"code":"440200","name":"韶关市","province":"44","city":"02"},{"code":"440300","name":"深圳市","province":"44","city":"03"},{"code":"440400","name":"珠海市","province":"44","city":"04"},{"code":"440500","name":"汕头市","province":"44","city":"05"},{"code":"440600","name":"佛山市","province":"44","city":"06"},{"code":"440700","name":"江门市","province":"44","city":"07"},{"code":"440800","name":"湛江市","province":"44","city":"08"},{"code":"440900","name":"茂名市","province":"44","city":"09"},{"code":"441200","name":"肇庆市","province":"44","city":"12"},{"code":"441300","name":"惠州市","province":"44","city":"13"},{"code":"441400","name":"梅州市","province":"44","city":"14"},{"code":"441500","name":"汕尾市","province":"44","city":"15"},{"code":"441600","name":"河源市","province":"44","city":"16"},{"code":"441700","name":"阳江市","province":"44","city":"17"},{"code":"441800","name":"清远市","province":"44","city":"18"},{"code":"441900","name":"东莞市","province":"44","city":"19"},{"code":"442000","name":"中山市","province":"44","city":"20"},{"code":"445100","name":"潮州市","province":"44","city":"51"},{"code":"445200","name":"揭阳市","province":"44","city":"52"},{"code":"445300","name":"云浮市","province":"44","city":"53"},{"code":"450100","name":"南宁市","province":"45","city":"01"},{"code":"450200","name":"柳州市","province":"45","city":"02"},{"code":"450300","name":"桂林市","province":"45","city":"03"},{"code":"450400","name":"梧州市","province":"45","city":"04"},{"code":"450500","name":"北海市","province":"45","city":"05"},{"code":"450600","name":"防城港市","province":"45","city":"06"},{"code":"450700","name":"钦州市","province":"45","city":"07"},{"code":"450800","name":"贵港市","province":"45","city":"08"},{"code":"450900","name":"玉林市","province":"45","city":"09"},{"code":"451000","name":"百色市","province":"45","city":"10"},{"code":"451100","name":"贺州市","province":"45","city":"11"},{"code":"451200","name":"河池市","province":"45","city":"12"},{"code":"451300","name":"来宾市","province":"45","city":"13"},{"code":"451400","name":"崇左市","province":"45","city":"14"},{"code":"460100","name":"海口市","province":"46","city":"01"},{"code":"460200","name":"三亚市","province":"46","city":"02"},{"code":"460300","name":"三沙市","province":"46","city":"03"},{"code":"460400","name":"儋州市","province":"46","city":"04"},{"code":"510100","name":"成都市","province":"51","city":"01"},{"code":"510300","name":"自贡市","province":"51","city":"03"},{"code":"510400","name":"攀枝花市","province":"51","city":"04"},{"code":"510500","name":"泸州市","province":"51","city":"05"},{"code":"510600","name":"德阳市","province":"51","city":"06"},{"code":"510700","name":"绵阳市","province":"51","city":"07"},{"code":"510800","name":"广元市","province":"51","city":"08"},{"code":"510900","name":"遂宁市","province":"51","city":"09"},{"code":"511000","name":"内江市","province":"51","city":"10"},{"code":"511100","name":"乐山市","province":"51","city":"11"},{"code":"511300","name":"南充市","province":"51","city":"13"},{"code":"511400","name":"眉山市","province":"51","city":"14"},{"code":"511500","name":"宜宾市","province":"51","city":"15"},{"code":"511600","name":"广安市","province":"51","city":"16"},{"code":"511700","name":"达州市","province":"51","city":"17"},{"code":"511800","name":"雅安市","province":"51","city":"18"},{"code":"511900","name":"巴中市","province":"51","city":"19"},{"code":"512000","name":"资阳市","province":"51","city":"20"},{"code":"513200","name":"阿坝藏族羌族自治州","province":"51","city":"32"},{"code":"513300","name":"甘孜藏族自治州","province":"51","city":"33"},{"code":"513400","name":"凉山彝族自治州","province":"51","city":"34"},{"code":"520100","name":"贵阳市","province":"52","city":"01"},{"code":"520200","name":"六盘水市","province":"52","city":"02"},{"code":"520300","name":"遵义市","province":"52","city":"03"},{"code":"520400","name":"安顺市","province":"52","city":"04"},{"code":"520500","name":"毕节市","province":"52","city":"05"},{"code":"520600","name":"铜仁市","province":"52","city":"06"},{"code":"522300","name":"黔西南布依族苗族自治州","province":"52","city":"23"},{"code":"522600","name":"黔东南苗族侗族自治州","province":"52","city":"26"},{"code":"522700","name":"黔南布依族苗族自治州","province":"52","city":"27"},{"code":"530100","name":"昆明市","province":"53","city":"01"},{"code":"530300","name":"曲靖市","province":"53","city":"03"},{"code":"530400","name":"玉溪市","province":"53","city":"04"},{"code":"530500","name":"保山市","province":"53","city":"05"},{"code":"530600","name":"昭通市","province":"53","city":"06"},{"code":"530700","name":"丽江市","province":"53","city":"07"},{"code":"530800","name":"普洱市","province":"53","city":"08"},{"code":"530900","name":"临沧市","province":"53","city":"09"},{"code":"532300","name":"楚雄彝族自治州","province":"53","city":"23"},{"code":"532500","name":"红河哈尼族彝族自治州","province":"53","city":"25"},{"code":"532600","name":"文山壮族苗族自治州","province":"53","city":"26"},{"code":"532800","name":"西双版纳傣族自治州","province":"53","city":"28"},{"code":"532900","name":"大理白族自治州","province":"53","city":"29"},{"code":"533100","name":"德宏傣族景颇族自治州","province":"53","city":"31"},{"code":"533300","name":"怒江傈僳族自治州","province":"53","city":"33"},{"code":"533400","name":"迪庆藏族自治州","province":"53","city":"34"},{"code":"540100","name":"拉萨市","province":"54","city":"01"},{"code":"540200","name":"日喀则市","province":"54","city":"02"},{"code":"540300","name":"昌都市","province":"54","city":"03"},{"code":"540400","name":"林芝市","province":"54","city":"04"},{"code":"540500","name":"山南市","province":"54","city":"05"},{"code":"540600","name":"那曲市","province":"54","city":"06"},{"code":"542500","name":"阿里地区","province":"54","city":"25"},{"code":"610100","name":"西安市","province":"61","city":"01"},{"code":"610200","name":"铜川市","province":"61","city":"02"},{"code":"610300","name":"宝鸡市","province":"61","city":"03"},{"code":"610400","name":"咸阳市","province":"61","city":"04"},{"code":"610500","name":"渭南市","province":"61","city":"05"},{"code":"610600","name":"延安市","province":"61","city":"06"},{"code":"610700","name":"汉中市","province":"61","city":"07"},{"code":"610800","name":"榆林市","province":"61","city":"08"},{"code":"610900","name":"安康市","province":"61","city":"09"},{"code":"611000","name":"商洛市","province":"61","city":"10"},{"code":"620100","name":"兰州市","province":"62","city":"01"},{"code":"620200","name":"嘉峪关市","province":"62","city":"02"},{"code":"620300","name":"金昌市","province":"62","city":"03"},{"code":"620400","name":"白银市","province":"62","city":"04"},{"code":"620500","name":"天水市","province":"62","city":"05"},{"code":"620600","name":"武威市","province":"62","city":"06"},{"code":"620700","name":"张掖市","province":"62","city":"07"},{"code":"620800","name":"平凉市","province":"62","city":"08"},{"code":"620900","name":"酒泉市","province":"62","city":"09"},{"code":"621000","name":"庆阳市","province":"62","city":"10"},{"code":"621100","name":"定西市","province":"62","city":"11"},{"code":"621200","name":"陇南市","province":"62","city":"12"},{"code":"622900","name":"临夏回族自治州","province":"62","city":"29"},{"code":"623000","name":"甘南藏族自治州","province":"62","city":"30"},{"code":"630100","name":"西宁市","province":"63","city":"01"},{"code":"630200","name":"海东市","province":"63","city":"02"},{"code":"632200","name":"海北藏族自治州","province":"63","city":"22"},{"code":"632300","name":"黄南藏族自治州","province":"63","city":"23"},{"code":"632500","name":"海南藏族自治州","province":"63","city":"25"},{"code":"632600","name":"果洛藏族自治州","province":"63","city":"26"},{"code":"632700","name":"玉树藏族自治州","province":"63","city":"27"},{"code":"632800","name":"海西蒙古族藏族自治州","province":"63","city":"28"},{"code":"640100","name":"银川市","province":"64","city":"01"},{"code":"640200","name":"石嘴山市","province":"64","city":"02"},{"code":"640300","name":"吴忠市","province":"64","city":"03"},{"code":"640400","name":"固原市","province":"64","city":"04"},{"code":"640500","name":"中卫市","province":"64","city":"05"},{"code":"650100","name":"乌鲁木齐市","province":"65","city":"01"},{"code":"650200","name":"克拉玛依市","province":"65","city":"02"},{"code":"650400","name":"吐鲁番市","province":"65","city":"04"},{"code":"650500","name":"哈密市","province":"65","city":"05"},{"code":"652300","name":"昌吉回族自治州","province":"65","city":"23"},{"code":"652700","name":"博尔塔拉蒙古自治州","province":"65","city":"27"},{"code":"652800","name":"巴音郭楞蒙古自治州","province":"65","city":"28"},{"code":"652900","name":"阿克苏地区","province":"65","city":"29"},{"code":"653000","name":"克孜勒苏柯尔克孜自治州","province":"65","city":"30"},{"code":"653100","name":"喀什地区","province":"65","city":"31"},{"code":"653200","name":"和田地区","province":"65","city":"32"},{"code":"654000","name":"伊犁哈萨克自治州","province":"65","city":"40"},{"code":"654200","name":"塔城地区","province":"65","city":"42"},{"code":"654300","name":"阿勒泰地区","province":"65","city":"43"},{"code":"429000","name":"湖北省-自治区直辖县级行政区划","province":"42","city":"90"},{"code":"469000","name":"海南省-自治区直辖县级行政区划","province":"46","city":"90"},{"code":"659000","name":"新疆维吾尔自治区-自治区直辖县级行政区划","province":"65","city":"90"},{"code":"419000","name":"河南省-省直辖县级行政区划","province":"41","city":"90"}]

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = [{"code":"110101","name":"东城区","province":"11","city":"01","area":"01"},{"code":"110102","name":"西城区","province":"11","city":"01","area":"02"},{"code":"110105","name":"朝阳区","province":"11","city":"01","area":"05"},{"code":"110106","name":"丰台区","province":"11","city":"01","area":"06"},{"code":"110107","name":"石景山区","province":"11","city":"01","area":"07"},{"code":"110108","name":"海淀区","province":"11","city":"01","area":"08"},{"code":"110109","name":"门头沟区","province":"11","city":"01","area":"09"},{"code":"110111","name":"房山区","province":"11","city":"01","area":"11"},{"code":"110112","name":"通州区","province":"11","city":"01","area":"12"},{"code":"110113","name":"顺义区","province":"11","city":"01","area":"13"},{"code":"110114","name":"昌平区","province":"11","city":"01","area":"14"},{"code":"110115","name":"大兴区","province":"11","city":"01","area":"15"},{"code":"110116","name":"怀柔区","province":"11","city":"01","area":"16"},{"code":"110117","name":"平谷区","province":"11","city":"01","area":"17"},{"code":"110118","name":"密云区","province":"11","city":"01","area":"18"},{"code":"110119","name":"延庆区","province":"11","city":"01","area":"19"},{"code":"120101","name":"和平区","province":"12","city":"01","area":"01"},{"code":"120102","name":"河东区","province":"12","city":"01","area":"02"},{"code":"120103","name":"河西区","province":"12","city":"01","area":"03"},{"code":"120104","name":"南开区","province":"12","city":"01","area":"04"},{"code":"120105","name":"河北区","province":"12","city":"01","area":"05"},{"code":"120106","name":"红桥区","province":"12","city":"01","area":"06"},{"code":"120110","name":"东丽区","province":"12","city":"01","area":"10"},{"code":"120111","name":"西青区","province":"12","city":"01","area":"11"},{"code":"120112","name":"津南区","province":"12","city":"01","area":"12"},{"code":"120113","name":"北辰区","province":"12","city":"01","area":"13"},{"code":"120114","name":"武清区","province":"12","city":"01","area":"14"},{"code":"120115","name":"宝坻区","province":"12","city":"01","area":"15"},{"code":"120116","name":"滨海新区","province":"12","city":"01","area":"16"},{"code":"120117","name":"宁河区","province":"12","city":"01","area":"17"},{"code":"120118","name":"静海区","province":"12","city":"01","area":"18"},{"code":"120119","name":"蓟州区","province":"12","city":"01","area":"19"},{"code":"130102","name":"长安区","province":"13","city":"01","area":"02"},{"code":"130104","name":"桥西区","province":"13","city":"01","area":"04"},{"code":"130105","name":"新华区","province":"13","city":"01","area":"05"},{"code":"130107","name":"井陉矿区","province":"13","city":"01","area":"07"},{"code":"130108","name":"裕华区","province":"13","city":"01","area":"08"},{"code":"130109","name":"藁城区","province":"13","city":"01","area":"09"},{"code":"130110","name":"鹿泉区","province":"13","city":"01","area":"10"},{"code":"130111","name":"栾城区","province":"13","city":"01","area":"11"},{"code":"130121","name":"井陉县","province":"13","city":"01","area":"21"},{"code":"130123","name":"正定县","province":"13","city":"01","area":"23"},{"code":"130125","name":"行唐县","province":"13","city":"01","area":"25"},{"code":"130126","name":"灵寿县","province":"13","city":"01","area":"26"},{"code":"130127","name":"高邑县","province":"13","city":"01","area":"27"},{"code":"130128","name":"深泽县","province":"13","city":"01","area":"28"},{"code":"130129","name":"赞皇县","province":"13","city":"01","area":"29"},{"code":"130130","name":"无极县","province":"13","city":"01","area":"30"},{"code":"130131","name":"平山县","province":"13","city":"01","area":"31"},{"code":"130132","name":"元氏县","province":"13","city":"01","area":"32"},{"code":"130133","name":"赵县","province":"13","city":"01","area":"33"},{"code":"130181","name":"辛集市","province":"13","city":"01","area":"81"},{"code":"130183","name":"晋州市","province":"13","city":"01","area":"83"},{"code":"130184","name":"新乐市","province":"13","city":"01","area":"84"},{"code":"130202","name":"路南区","province":"13","city":"02","area":"02"},{"code":"130203","name":"路北区","province":"13","city":"02","area":"03"},{"code":"130204","name":"古冶区","province":"13","city":"02","area":"04"},{"code":"130205","name":"开平区","province":"13","city":"02","area":"05"},{"code":"130207","name":"丰南区","province":"13","city":"02","area":"07"},{"code":"130208","name":"丰润区","province":"13","city":"02","area":"08"},{"code":"130209","name":"曹妃甸区","province":"13","city":"02","area":"09"},{"code":"130224","name":"滦南县","province":"13","city":"02","area":"24"},{"code":"130225","name":"乐亭县","province":"13","city":"02","area":"25"},{"code":"130227","name":"迁西县","province":"13","city":"02","area":"27"},{"code":"130229","name":"玉田县","province":"13","city":"02","area":"29"},{"code":"130281","name":"遵化市","province":"13","city":"02","area":"81"},{"code":"130283","name":"迁安市","province":"13","city":"02","area":"83"},{"code":"130284","name":"滦州市","province":"13","city":"02","area":"84"},{"code":"130302","name":"海港区","province":"13","city":"03","area":"02"},{"code":"130303","name":"山海关区","province":"13","city":"03","area":"03"},{"code":"130304","name":"北戴河区","province":"13","city":"03","area":"04"},{"code":"130306","name":"抚宁区","province":"13","city":"03","area":"06"},{"code":"130321","name":"青龙满族自治县","province":"13","city":"03","area":"21"},{"code":"130322","name":"昌黎县","province":"13","city":"03","area":"22"},{"code":"130324","name":"卢龙县","province":"13","city":"03","area":"24"},{"code":"130402","name":"邯山区","province":"13","city":"04","area":"02"},{"code":"130403","name":"丛台区","province":"13","city":"04","area":"03"},{"code":"130404","name":"复兴区","province":"13","city":"04","area":"04"},{"code":"130406","name":"峰峰矿区","province":"13","city":"04","area":"06"},{"code":"130407","name":"肥乡区","province":"13","city":"04","area":"07"},{"code":"130408","name":"永年区","province":"13","city":"04","area":"08"},{"code":"130423","name":"临漳县","province":"13","city":"04","area":"23"},{"code":"130424","name":"成安县","province":"13","city":"04","area":"24"},{"code":"130425","name":"大名县","province":"13","city":"04","area":"25"},{"code":"130426","name":"涉县","province":"13","city":"04","area":"26"},{"code":"130427","name":"磁县","province":"13","city":"04","area":"27"},{"code":"130430","name":"邱县","province":"13","city":"04","area":"30"},{"code":"130431","name":"鸡泽县","province":"13","city":"04","area":"31"},{"code":"130432","name":"广平县","province":"13","city":"04","area":"32"},{"code":"130433","name":"馆陶县","province":"13","city":"04","area":"33"},{"code":"130434","name":"魏县","province":"13","city":"04","area":"34"},{"code":"130435","name":"曲周县","province":"13","city":"04","area":"35"},{"code":"130481","name":"武安市","province":"13","city":"04","area":"81"},{"code":"130502","name":"襄都区","province":"13","city":"05","area":"02"},{"code":"130503","name":"信都区","province":"13","city":"05","area":"03"},{"code":"130505","name":"任泽区","province":"13","city":"05","area":"05"},{"code":"130506","name":"南和区","province":"13","city":"05","area":"06"},{"code":"130522","name":"临城县","province":"13","city":"05","area":"22"},{"code":"130523","name":"内丘县","province":"13","city":"05","area":"23"},{"code":"130524","name":"柏乡县","province":"13","city":"05","area":"24"},{"code":"130525","name":"隆尧县","province":"13","city":"05","area":"25"},{"code":"130528","name":"宁晋县","province":"13","city":"05","area":"28"},{"code":"130529","name":"巨鹿县","province":"13","city":"05","area":"29"},{"code":"130530","name":"新河县","province":"13","city":"05","area":"30"},{"code":"130531","name":"广宗县","province":"13","city":"05","area":"31"},{"code":"130532","name":"平乡县","province":"13","city":"05","area":"32"},{"code":"130533","name":"威县","province":"13","city":"05","area":"33"},{"code":"130534","name":"清河县","province":"13","city":"05","area":"34"},{"code":"130535","name":"临西县","province":"13","city":"05","area":"35"},{"code":"130581","name":"南宫市","province":"13","city":"05","area":"81"},{"code":"130582","name":"沙河市","province":"13","city":"05","area":"82"},{"code":"130602","name":"竞秀区","province":"13","city":"06","area":"02"},{"code":"130606","name":"莲池区","province":"13","city":"06","area":"06"},{"code":"130607","name":"满城区","province":"13","city":"06","area":"07"},{"code":"130608","name":"清苑区","province":"13","city":"06","area":"08"},{"code":"130609","name":"徐水区","province":"13","city":"06","area":"09"},{"code":"130623","name":"涞水县","province":"13","city":"06","area":"23"},{"code":"130624","name":"阜平县","province":"13","city":"06","area":"24"},{"code":"130626","name":"定兴县","province":"13","city":"06","area":"26"},{"code":"130627","name":"唐县","province":"13","city":"06","area":"27"},{"code":"130628","name":"高阳县","province":"13","city":"06","area":"28"},{"code":"130629","name":"容城县","province":"13","city":"06","area":"29"},{"code":"130630","name":"涞源县","province":"13","city":"06","area":"30"},{"code":"130631","name":"望都县","province":"13","city":"06","area":"31"},{"code":"130632","name":"安新县","province":"13","city":"06","area":"32"},{"code":"130633","name":"易县","province":"13","city":"06","area":"33"},{"code":"130634","name":"曲阳县","province":"13","city":"06","area":"34"},{"code":"130635","name":"蠡县","province":"13","city":"06","area":"35"},{"code":"130636","name":"顺平县","province":"13","city":"06","area":"36"},{"code":"130637","name":"博野县","province":"13","city":"06","area":"37"},{"code":"130638","name":"雄县","province":"13","city":"06","area":"38"},{"code":"130681","name":"涿州市","province":"13","city":"06","area":"81"},{"code":"130682","name":"定州市","province":"13","city":"06","area":"82"},{"code":"130683","name":"安国市","province":"13","city":"06","area":"83"},{"code":"130684","name":"高碑店市","province":"13","city":"06","area":"84"},{"code":"130702","name":"桥东区","province":"13","city":"07","area":"02"},{"code":"130703","name":"桥西区","province":"13","city":"07","area":"03"},{"code":"130705","name":"宣化区","province":"13","city":"07","area":"05"},{"code":"130706","name":"下花园区","province":"13","city":"07","area":"06"},{"code":"130708","name":"万全区","province":"13","city":"07","area":"08"},{"code":"130709","name":"崇礼区","province":"13","city":"07","area":"09"},{"code":"130722","name":"张北县","province":"13","city":"07","area":"22"},{"code":"130723","name":"康保县","province":"13","city":"07","area":"23"},{"code":"130724","name":"沽源县","province":"13","city":"07","area":"24"},{"code":"130725","name":"尚义县","province":"13","city":"07","area":"25"},{"code":"130726","name":"蔚县","province":"13","city":"07","area":"26"},{"code":"130727","name":"阳原县","province":"13","city":"07","area":"27"},{"code":"130728","name":"怀安县","province":"13","city":"07","area":"28"},{"code":"130730","name":"怀来县","province":"13","city":"07","area":"30"},{"code":"130731","name":"涿鹿县","province":"13","city":"07","area":"31"},{"code":"130732","name":"赤城县","province":"13","city":"07","area":"32"},{"code":"130802","name":"双桥区","province":"13","city":"08","area":"02"},{"code":"130803","name":"双滦区","province":"13","city":"08","area":"03"},{"code":"130804","name":"鹰手营子矿区","province":"13","city":"08","area":"04"},{"code":"130821","name":"承德县","province":"13","city":"08","area":"21"},{"code":"130822","name":"兴隆县","province":"13","city":"08","area":"22"},{"code":"130824","name":"滦平县","province":"13","city":"08","area":"24"},{"code":"130825","name":"隆化县","province":"13","city":"08","area":"25"},{"code":"130826","name":"丰宁满族自治县","province":"13","city":"08","area":"26"},{"code":"130827","name":"宽城满族自治县","province":"13","city":"08","area":"27"},{"code":"130828","name":"围场满族蒙古族自治县","province":"13","city":"08","area":"28"},{"code":"130881","name":"平泉市","province":"13","city":"08","area":"81"},{"code":"130902","name":"新华区","province":"13","city":"09","area":"02"},{"code":"130903","name":"运河区","province":"13","city":"09","area":"03"},{"code":"130921","name":"沧县","province":"13","city":"09","area":"21"},{"code":"130922","name":"青县","province":"13","city":"09","area":"22"},{"code":"130923","name":"东光县","province":"13","city":"09","area":"23"},{"code":"130924","name":"海兴县","province":"13","city":"09","area":"24"},{"code":"130925","name":"盐山县","province":"13","city":"09","area":"25"},{"code":"130926","name":"肃宁县","province":"13","city":"09","area":"26"},{"code":"130927","name":"南皮县","province":"13","city":"09","area":"27"},{"code":"130928","name":"吴桥县","province":"13","city":"09","area":"28"},{"code":"130929","name":"献县","province":"13","city":"09","area":"29"},{"code":"130930","name":"孟村回族自治县","province":"13","city":"09","area":"30"},{"code":"130981","name":"泊头市","province":"13","city":"09","area":"81"},{"code":"130982","name":"任丘市","province":"13","city":"09","area":"82"},{"code":"130983","name":"黄骅市","province":"13","city":"09","area":"83"},{"code":"130984","name":"河间市","province":"13","city":"09","area":"84"},{"code":"131002","name":"安次区","province":"13","city":"10","area":"02"},{"code":"131003","name":"广阳区","province":"13","city":"10","area":"03"},{"code":"131022","name":"固安县","province":"13","city":"10","area":"22"},{"code":"131023","name":"永清县","province":"13","city":"10","area":"23"},{"code":"131024","name":"香河县","province":"13","city":"10","area":"24"},{"code":"131025","name":"大城县","province":"13","city":"10","area":"25"},{"code":"131026","name":"文安县","province":"13","city":"10","area":"26"},{"code":"131028","name":"大厂回族自治县","province":"13","city":"10","area":"28"},{"code":"131081","name":"霸州市","province":"13","city":"10","area":"81"},{"code":"131082","name":"三河市","province":"13","city":"10","area":"82"},{"code":"131102","name":"桃城区","province":"13","city":"11","area":"02"},{"code":"131103","name":"冀州区","province":"13","city":"11","area":"03"},{"code":"131121","name":"枣强县","province":"13","city":"11","area":"21"},{"code":"131122","name":"武邑县","province":"13","city":"11","area":"22"},{"code":"131123","name":"武强县","province":"13","city":"11","area":"23"},{"code":"131124","name":"饶阳县","province":"13","city":"11","area":"24"},{"code":"131125","name":"安平县","province":"13","city":"11","area":"25"},{"code":"131126","name":"故城县","province":"13","city":"11","area":"26"},{"code":"131127","name":"景县","province":"13","city":"11","area":"27"},{"code":"131128","name":"阜城县","province":"13","city":"11","area":"28"},{"code":"131182","name":"深州市","province":"13","city":"11","area":"82"},{"code":"140105","name":"小店区","province":"14","city":"01","area":"05"},{"code":"140106","name":"迎泽区","province":"14","city":"01","area":"06"},{"code":"140107","name":"杏花岭区","province":"14","city":"01","area":"07"},{"code":"140108","name":"尖草坪区","province":"14","city":"01","area":"08"},{"code":"140109","name":"万柏林区","province":"14","city":"01","area":"09"},{"code":"140110","name":"晋源区","province":"14","city":"01","area":"10"},{"code":"140121","name":"清徐县","province":"14","city":"01","area":"21"},{"code":"140122","name":"阳曲县","province":"14","city":"01","area":"22"},{"code":"140123","name":"娄烦县","province":"14","city":"01","area":"23"},{"code":"140181","name":"古交市","province":"14","city":"01","area":"81"},{"code":"140212","name":"新荣区","province":"14","city":"02","area":"12"},{"code":"140213","name":"平城区","province":"14","city":"02","area":"13"},{"code":"140214","name":"云冈区","province":"14","city":"02","area":"14"},{"code":"140215","name":"云州区","province":"14","city":"02","area":"15"},{"code":"140221","name":"阳高县","province":"14","city":"02","area":"21"},{"code":"140222","name":"天镇县","province":"14","city":"02","area":"22"},{"code":"140223","name":"广灵县","province":"14","city":"02","area":"23"},{"code":"140224","name":"灵丘县","province":"14","city":"02","area":"24"},{"code":"140225","name":"浑源县","province":"14","city":"02","area":"25"},{"code":"140226","name":"左云县","province":"14","city":"02","area":"26"},{"code":"140302","name":"城区","province":"14","city":"03","area":"02"},{"code":"140303","name":"矿区","province":"14","city":"03","area":"03"},{"code":"140311","name":"郊区","province":"14","city":"03","area":"11"},{"code":"140321","name":"平定县","province":"14","city":"03","area":"21"},{"code":"140322","name":"盂县","province":"14","city":"03","area":"22"},{"code":"140403","name":"潞州区","province":"14","city":"04","area":"03"},{"code":"140404","name":"上党区","province":"14","city":"04","area":"04"},{"code":"140405","name":"屯留区","province":"14","city":"04","area":"05"},{"code":"140406","name":"潞城区","province":"14","city":"04","area":"06"},{"code":"140423","name":"襄垣县","province":"14","city":"04","area":"23"},{"code":"140425","name":"平顺县","province":"14","city":"04","area":"25"},{"code":"140426","name":"黎城县","province":"14","city":"04","area":"26"},{"code":"140427","name":"壶关县","province":"14","city":"04","area":"27"},{"code":"140428","name":"长子县","province":"14","city":"04","area":"28"},{"code":"140429","name":"武乡县","province":"14","city":"04","area":"29"},{"code":"140430","name":"沁县","province":"14","city":"04","area":"30"},{"code":"140431","name":"沁源县","province":"14","city":"04","area":"31"},{"code":"140502","name":"城区","province":"14","city":"05","area":"02"},{"code":"140521","name":"沁水县","province":"14","city":"05","area":"21"},{"code":"140522","name":"阳城县","province":"14","city":"05","area":"22"},{"code":"140524","name":"陵川县","province":"14","city":"05","area":"24"},{"code":"140525","name":"泽州县","province":"14","city":"05","area":"25"},{"code":"140581","name":"高平市","province":"14","city":"05","area":"81"},{"code":"140602","name":"朔城区","province":"14","city":"06","area":"02"},{"code":"140603","name":"平鲁区","province":"14","city":"06","area":"03"},{"code":"140621","name":"山阴县","province":"14","city":"06","area":"21"},{"code":"140622","name":"应县","province":"14","city":"06","area":"22"},{"code":"140623","name":"右玉县","province":"14","city":"06","area":"23"},{"code":"140681","name":"怀仁市","province":"14","city":"06","area":"81"},{"code":"140702","name":"榆次区","province":"14","city":"07","area":"02"},{"code":"140703","name":"太谷区","province":"14","city":"07","area":"03"},{"code":"140721","name":"榆社县","province":"14","city":"07","area":"21"},{"code":"140722","name":"左权县","province":"14","city":"07","area":"22"},{"code":"140723","name":"和顺县","province":"14","city":"07","area":"23"},{"code":"140724","name":"昔阳县","province":"14","city":"07","area":"24"},{"code":"140725","name":"寿阳县","province":"14","city":"07","area":"25"},{"code":"140727","name":"祁县","province":"14","city":"07","area":"27"},{"code":"140728","name":"平遥县","province":"14","city":"07","area":"28"},{"code":"140729","name":"灵石县","province":"14","city":"07","area":"29"},{"code":"140781","name":"介休市","province":"14","city":"07","area":"81"},{"code":"140802","name":"盐湖区","province":"14","city":"08","area":"02"},{"code":"140821","name":"临猗县","province":"14","city":"08","area":"21"},{"code":"140822","name":"万荣县","province":"14","city":"08","area":"22"},{"code":"140823","name":"闻喜县","province":"14","city":"08","area":"23"},{"code":"140824","name":"稷山县","province":"14","city":"08","area":"24"},{"code":"140825","name":"新绛县","province":"14","city":"08","area":"25"},{"code":"140826","name":"绛县","province":"14","city":"08","area":"26"},{"code":"140827","name":"垣曲县","province":"14","city":"08","area":"27"},{"code":"140828","name":"夏县","province":"14","city":"08","area":"28"},{"code":"140829","name":"平陆县","province":"14","city":"08","area":"29"},{"code":"140830","name":"芮城县","province":"14","city":"08","area":"30"},{"code":"140881","name":"永济市","province":"14","city":"08","area":"81"},{"code":"140882","name":"河津市","province":"14","city":"08","area":"82"},{"code":"140902","name":"忻府区","province":"14","city":"09","area":"02"},{"code":"140921","name":"定襄县","province":"14","city":"09","area":"21"},{"code":"140922","name":"五台县","province":"14","city":"09","area":"22"},{"code":"140923","name":"代县","province":"14","city":"09","area":"23"},{"code":"140924","name":"繁峙县","province":"14","city":"09","area":"24"},{"code":"140925","name":"宁武县","province":"14","city":"09","area":"25"},{"code":"140926","name":"静乐县","province":"14","city":"09","area":"26"},{"code":"140927","name":"神池县","province":"14","city":"09","area":"27"},{"code":"140928","name":"五寨县","province":"14","city":"09","area":"28"},{"code":"140929","name":"岢岚县","province":"14","city":"09","area":"29"},{"code":"140930","name":"河曲县","province":"14","city":"09","area":"30"},{"code":"140931","name":"保德县","province":"14","city":"09","area":"31"},{"code":"140932","name":"偏关县","province":"14","city":"09","area":"32"},{"code":"140981","name":"原平市","province":"14","city":"09","area":"81"},{"code":"141002","name":"尧都区","province":"14","city":"10","area":"02"},{"code":"141021","name":"曲沃县","province":"14","city":"10","area":"21"},{"code":"141022","name":"翼城县","province":"14","city":"10","area":"22"},{"code":"141023","name":"襄汾县","province":"14","city":"10","area":"23"},{"code":"141024","name":"洪洞县","province":"14","city":"10","area":"24"},{"code":"141025","name":"古县","province":"14","city":"10","area":"25"},{"code":"141026","name":"安泽县","province":"14","city":"10","area":"26"},{"code":"141027","name":"浮山县","province":"14","city":"10","area":"27"},{"code":"141028","name":"吉县","province":"14","city":"10","area":"28"},{"code":"141029","name":"乡宁县","province":"14","city":"10","area":"29"},{"code":"141030","name":"大宁县","province":"14","city":"10","area":"30"},{"code":"141031","name":"隰县","province":"14","city":"10","area":"31"},{"code":"141032","name":"永和县","province":"14","city":"10","area":"32"},{"code":"141033","name":"蒲县","province":"14","city":"10","area":"33"},{"code":"141034","name":"汾西县","province":"14","city":"10","area":"34"},{"code":"141081","name":"侯马市","province":"14","city":"10","area":"81"},{"code":"141082","name":"霍州市","province":"14","city":"10","area":"82"},{"code":"141102","name":"离石区","province":"14","city":"11","area":"02"},{"code":"141121","name":"文水县","province":"14","city":"11","area":"21"},{"code":"141122","name":"交城县","province":"14","city":"11","area":"22"},{"code":"141123","name":"兴县","province":"14","city":"11","area":"23"},{"code":"141124","name":"临县","province":"14","city":"11","area":"24"},{"code":"141125","name":"柳林县","province":"14","city":"11","area":"25"},{"code":"141126","name":"石楼县","province":"14","city":"11","area":"26"},{"code":"141127","name":"岚县","province":"14","city":"11","area":"27"},{"code":"141128","name":"方山县","province":"14","city":"11","area":"28"},{"code":"141129","name":"中阳县","province":"14","city":"11","area":"29"},{"code":"141130","name":"交口县","province":"14","city":"11","area":"30"},{"code":"141181","name":"孝义市","province":"14","city":"11","area":"81"},{"code":"141182","name":"汾阳市","province":"14","city":"11","area":"82"},{"code":"150102","name":"新城区","province":"15","city":"01","area":"02"},{"code":"150103","name":"回民区","province":"15","city":"01","area":"03"},{"code":"150104","name":"玉泉区","province":"15","city":"01","area":"04"},{"code":"150105","name":"赛罕区","province":"15","city":"01","area":"05"},{"code":"150121","name":"土默特左旗","province":"15","city":"01","area":"21"},{"code":"150122","name":"托克托县","province":"15","city":"01","area":"22"},{"code":"150123","name":"和林格尔县","province":"15","city":"01","area":"23"},{"code":"150124","name":"清水河县","province":"15","city":"01","area":"24"},{"code":"150125","name":"武川县","province":"15","city":"01","area":"25"},{"code":"150202","name":"东河区","province":"15","city":"02","area":"02"},{"code":"150203","name":"昆都仑区","province":"15","city":"02","area":"03"},{"code":"150204","name":"青山区","province":"15","city":"02","area":"04"},{"code":"150205","name":"石拐区","province":"15","city":"02","area":"05"},{"code":"150206","name":"白云鄂博矿区","province":"15","city":"02","area":"06"},{"code":"150207","name":"九原区","province":"15","city":"02","area":"07"},{"code":"150221","name":"土默特右旗","province":"15","city":"02","area":"21"},{"code":"150222","name":"固阳县","province":"15","city":"02","area":"22"},{"code":"150223","name":"达尔罕茂明安联合旗","province":"15","city":"02","area":"23"},{"code":"150302","name":"海勃湾区","province":"15","city":"03","area":"02"},{"code":"150303","name":"海南区","province":"15","city":"03","area":"03"},{"code":"150304","name":"乌达区","province":"15","city":"03","area":"04"},{"code":"150402","name":"红山区","province":"15","city":"04","area":"02"},{"code":"150403","name":"元宝山区","province":"15","city":"04","area":"03"},{"code":"150404","name":"松山区","province":"15","city":"04","area":"04"},{"code":"150421","name":"阿鲁科尔沁旗","province":"15","city":"04","area":"21"},{"code":"150422","name":"巴林左旗","province":"15","city":"04","area":"22"},{"code":"150423","name":"巴林右旗","province":"15","city":"04","area":"23"},{"code":"150424","name":"林西县","province":"15","city":"04","area":"24"},{"code":"150425","name":"克什克腾旗","province":"15","city":"04","area":"25"},{"code":"150426","name":"翁牛特旗","province":"15","city":"04","area":"26"},{"code":"150428","name":"喀喇沁旗","province":"15","city":"04","area":"28"},{"code":"150429","name":"宁城县","province":"15","city":"04","area":"29"},{"code":"150430","name":"敖汉旗","province":"15","city":"04","area":"30"},{"code":"150502","name":"科尔沁区","province":"15","city":"05","area":"02"},{"code":"150521","name":"科尔沁左翼中旗","province":"15","city":"05","area":"21"},{"code":"150522","name":"科尔沁左翼后旗","province":"15","city":"05","area":"22"},{"code":"150523","name":"开鲁县","province":"15","city":"05","area":"23"},{"code":"150524","name":"库伦旗","province":"15","city":"05","area":"24"},{"code":"150525","name":"奈曼旗","province":"15","city":"05","area":"25"},{"code":"150526","name":"扎鲁特旗","province":"15","city":"05","area":"26"},{"code":"150581","name":"霍林郭勒市","province":"15","city":"05","area":"81"},{"code":"150602","name":"东胜区","province":"15","city":"06","area":"02"},{"code":"150603","name":"康巴什区","province":"15","city":"06","area":"03"},{"code":"150621","name":"达拉特旗","province":"15","city":"06","area":"21"},{"code":"150622","name":"准格尔旗","province":"15","city":"06","area":"22"},{"code":"150623","name":"鄂托克前旗","province":"15","city":"06","area":"23"},{"code":"150624","name":"鄂托克旗","province":"15","city":"06","area":"24"},{"code":"150625","name":"杭锦旗","province":"15","city":"06","area":"25"},{"code":"150626","name":"乌审旗","province":"15","city":"06","area":"26"},{"code":"150627","name":"伊金霍洛旗","province":"15","city":"06","area":"27"},{"code":"150702","name":"海拉尔区","province":"15","city":"07","area":"02"},{"code":"150703","name":"扎赉诺尔区","province":"15","city":"07","area":"03"},{"code":"150721","name":"阿荣旗","province":"15","city":"07","area":"21"},{"code":"150722","name":"莫力达瓦达斡尔族自治旗","province":"15","city":"07","area":"22"},{"code":"150723","name":"鄂伦春自治旗","province":"15","city":"07","area":"23"},{"code":"150724","name":"鄂温克族自治旗","province":"15","city":"07","area":"24"},{"code":"150725","name":"陈巴尔虎旗","province":"15","city":"07","area":"25"},{"code":"150726","name":"新巴尔虎左旗","province":"15","city":"07","area":"26"},{"code":"150727","name":"新巴尔虎右旗","province":"15","city":"07","area":"27"},{"code":"150781","name":"满洲里市","province":"15","city":"07","area":"81"},{"code":"150782","name":"牙克石市","province":"15","city":"07","area":"82"},{"code":"150783","name":"扎兰屯市","province":"15","city":"07","area":"83"},{"code":"150784","name":"额尔古纳市","province":"15","city":"07","area":"84"},{"code":"150785","name":"根河市","province":"15","city":"07","area":"85"},{"code":"150802","name":"临河区","province":"15","city":"08","area":"02"},{"code":"150821","name":"五原县","province":"15","city":"08","area":"21"},{"code":"150822","name":"磴口县","province":"15","city":"08","area":"22"},{"code":"150823","name":"乌拉特前旗","province":"15","city":"08","area":"23"},{"code":"150824","name":"乌拉特中旗","province":"15","city":"08","area":"24"},{"code":"150825","name":"乌拉特后旗","province":"15","city":"08","area":"25"},{"code":"150826","name":"杭锦后旗","province":"15","city":"08","area":"26"},{"code":"150902","name":"集宁区","province":"15","city":"09","area":"02"},{"code":"150921","name":"卓资县","province":"15","city":"09","area":"21"},{"code":"150922","name":"化德县","province":"15","city":"09","area":"22"},{"code":"150923","name":"商都县","province":"15","city":"09","area":"23"},{"code":"150924","name":"兴和县","province":"15","city":"09","area":"24"},{"code":"150925","name":"凉城县","province":"15","city":"09","area":"25"},{"code":"150926","name":"察哈尔右翼前旗","province":"15","city":"09","area":"26"},{"code":"150927","name":"察哈尔右翼中旗","province":"15","city":"09","area":"27"},{"code":"150928","name":"察哈尔右翼后旗","province":"15","city":"09","area":"28"},{"code":"150929","name":"四子王旗","province":"15","city":"09","area":"29"},{"code":"150981","name":"丰镇市","province":"15","city":"09","area":"81"},{"code":"152201","name":"乌兰浩特市","province":"15","city":"22","area":"01"},{"code":"152202","name":"阿尔山市","province":"15","city":"22","area":"02"},{"code":"152221","name":"科尔沁右翼前旗","province":"15","city":"22","area":"21"},{"code":"152222","name":"科尔沁右翼中旗","province":"15","city":"22","area":"22"},{"code":"152223","name":"扎赉特旗","province":"15","city":"22","area":"23"},{"code":"152224","name":"突泉县","province":"15","city":"22","area":"24"},{"code":"152501","name":"二连浩特市","province":"15","city":"25","area":"01"},{"code":"152502","name":"锡林浩特市","province":"15","city":"25","area":"02"},{"code":"152522","name":"阿巴嘎旗","province":"15","city":"25","area":"22"},{"code":"152523","name":"苏尼特左旗","province":"15","city":"25","area":"23"},{"code":"152524","name":"苏尼特右旗","province":"15","city":"25","area":"24"},{"code":"152525","name":"东乌珠穆沁旗","province":"15","city":"25","area":"25"},{"code":"152526","name":"西乌珠穆沁旗","province":"15","city":"25","area":"26"},{"code":"152527","name":"太仆寺旗","province":"15","city":"25","area":"27"},{"code":"152528","name":"镶黄旗","province":"15","city":"25","area":"28"},{"code":"152529","name":"正镶白旗","province":"15","city":"25","area":"29"},{"code":"152530","name":"正蓝旗","province":"15","city":"25","area":"30"},{"code":"152531","name":"多伦县","province":"15","city":"25","area":"31"},{"code":"152921","name":"阿拉善左旗","province":"15","city":"29","area":"21"},{"code":"152922","name":"阿拉善右旗","province":"15","city":"29","area":"22"},{"code":"152923","name":"额济纳旗","province":"15","city":"29","area":"23"},{"code":"210102","name":"和平区","province":"21","city":"01","area":"02"},{"code":"210103","name":"沈河区","province":"21","city":"01","area":"03"},{"code":"210104","name":"大东区","province":"21","city":"01","area":"04"},{"code":"210105","name":"皇姑区","province":"21","city":"01","area":"05"},{"code":"210106","name":"铁西区","province":"21","city":"01","area":"06"},{"code":"210111","name":"苏家屯区","province":"21","city":"01","area":"11"},{"code":"210112","name":"浑南区","province":"21","city":"01","area":"12"},{"code":"210113","name":"沈北新区","province":"21","city":"01","area":"13"},{"code":"210114","name":"于洪区","province":"21","city":"01","area":"14"},{"code":"210115","name":"辽中区","province":"21","city":"01","area":"15"},{"code":"210123","name":"康平县","province":"21","city":"01","area":"23"},{"code":"210124","name":"法库县","province":"21","city":"01","area":"24"},{"code":"210181","name":"新民市","province":"21","city":"01","area":"81"},{"code":"210202","name":"中山区","province":"21","city":"02","area":"02"},{"code":"210203","name":"西岗区","province":"21","city":"02","area":"03"},{"code":"210204","name":"沙河口区","province":"21","city":"02","area":"04"},{"code":"210211","name":"甘井子区","province":"21","city":"02","area":"11"},{"code":"210212","name":"旅顺口区","province":"21","city":"02","area":"12"},{"code":"210213","name":"金州区","province":"21","city":"02","area":"13"},{"code":"210214","name":"普兰店区","province":"21","city":"02","area":"14"},{"code":"210224","name":"长海县","province":"21","city":"02","area":"24"},{"code":"210281","name":"瓦房店市","province":"21","city":"02","area":"81"},{"code":"210283","name":"庄河市","province":"21","city":"02","area":"83"},{"code":"210302","name":"铁东区","province":"21","city":"03","area":"02"},{"code":"210303","name":"铁西区","province":"21","city":"03","area":"03"},{"code":"210304","name":"立山区","province":"21","city":"03","area":"04"},{"code":"210311","name":"千山区","province":"21","city":"03","area":"11"},{"code":"210321","name":"台安县","province":"21","city":"03","area":"21"},{"code":"210323","name":"岫岩满族自治县","province":"21","city":"03","area":"23"},{"code":"210381","name":"海城市","province":"21","city":"03","area":"81"},{"code":"210402","name":"新抚区","province":"21","city":"04","area":"02"},{"code":"210403","name":"东洲区","province":"21","city":"04","area":"03"},{"code":"210404","name":"望花区","province":"21","city":"04","area":"04"},{"code":"210411","name":"顺城区","province":"21","city":"04","area":"11"},{"code":"210421","name":"抚顺县","province":"21","city":"04","area":"21"},{"code":"210422","name":"新宾满族自治县","province":"21","city":"04","area":"22"},{"code":"210423","name":"清原满族自治县","province":"21","city":"04","area":"23"},{"code":"210502","name":"平山区","province":"21","city":"05","area":"02"},{"code":"210503","name":"溪湖区","province":"21","city":"05","area":"03"},{"code":"210504","name":"明山区","province":"21","city":"05","area":"04"},{"code":"210505","name":"南芬区","province":"21","city":"05","area":"05"},{"code":"210521","name":"本溪满族自治县","province":"21","city":"05","area":"21"},{"code":"210522","name":"桓仁满族自治县","province":"21","city":"05","area":"22"},{"code":"210602","name":"元宝区","province":"21","city":"06","area":"02"},{"code":"210603","name":"振兴区","province":"21","city":"06","area":"03"},{"code":"210604","name":"振安区","province":"21","city":"06","area":"04"},{"code":"210624","name":"宽甸满族自治县","province":"21","city":"06","area":"24"},{"code":"210681","name":"东港市","province":"21","city":"06","area":"81"},{"code":"210682","name":"凤城市","province":"21","city":"06","area":"82"},{"code":"210702","name":"古塔区","province":"21","city":"07","area":"02"},{"code":"210703","name":"凌河区","province":"21","city":"07","area":"03"},{"code":"210711","name":"太和区","province":"21","city":"07","area":"11"},{"code":"210726","name":"黑山县","province":"21","city":"07","area":"26"},{"code":"210727","name":"义县","province":"21","city":"07","area":"27"},{"code":"210781","name":"凌海市","province":"21","city":"07","area":"81"},{"code":"210782","name":"北镇市","province":"21","city":"07","area":"82"},{"code":"210802","name":"站前区","province":"21","city":"08","area":"02"},{"code":"210803","name":"西市区","province":"21","city":"08","area":"03"},{"code":"210804","name":"鲅鱼圈区","province":"21","city":"08","area":"04"},{"code":"210811","name":"老边区","province":"21","city":"08","area":"11"},{"code":"210881","name":"盖州市","province":"21","city":"08","area":"81"},{"code":"210882","name":"大石桥市","province":"21","city":"08","area":"82"},{"code":"210902","name":"海州区","province":"21","city":"09","area":"02"},{"code":"210903","name":"新邱区","province":"21","city":"09","area":"03"},{"code":"210904","name":"太平区","province":"21","city":"09","area":"04"},{"code":"210905","name":"清河门区","province":"21","city":"09","area":"05"},{"code":"210911","name":"细河区","province":"21","city":"09","area":"11"},{"code":"210921","name":"阜新蒙古族自治县","province":"21","city":"09","area":"21"},{"code":"210922","name":"彰武县","province":"21","city":"09","area":"22"},{"code":"211002","name":"白塔区","province":"21","city":"10","area":"02"},{"code":"211003","name":"文圣区","province":"21","city":"10","area":"03"},{"code":"211004","name":"宏伟区","province":"21","city":"10","area":"04"},{"code":"211005","name":"弓长岭区","province":"21","city":"10","area":"05"},{"code":"211011","name":"太子河区","province":"21","city":"10","area":"11"},{"code":"211021","name":"辽阳县","province":"21","city":"10","area":"21"},{"code":"211081","name":"灯塔市","province":"21","city":"10","area":"81"},{"code":"211102","name":"双台子区","province":"21","city":"11","area":"02"},{"code":"211103","name":"兴隆台区","province":"21","city":"11","area":"03"},{"code":"211104","name":"大洼区","province":"21","city":"11","area":"04"},{"code":"211122","name":"盘山县","province":"21","city":"11","area":"22"},{"code":"211202","name":"银州区","province":"21","city":"12","area":"02"},{"code":"211204","name":"清河区","province":"21","city":"12","area":"04"},{"code":"211221","name":"铁岭县","province":"21","city":"12","area":"21"},{"code":"211223","name":"西丰县","province":"21","city":"12","area":"23"},{"code":"211224","name":"昌图县","province":"21","city":"12","area":"24"},{"code":"211281","name":"调兵山市","province":"21","city":"12","area":"81"},{"code":"211282","name":"开原市","province":"21","city":"12","area":"82"},{"code":"211302","name":"双塔区","province":"21","city":"13","area":"02"},{"code":"211303","name":"龙城区","province":"21","city":"13","area":"03"},{"code":"211321","name":"朝阳县","province":"21","city":"13","area":"21"},{"code":"211322","name":"建平县","province":"21","city":"13","area":"22"},{"code":"211324","name":"喀喇沁左翼蒙古族自治县","province":"21","city":"13","area":"24"},{"code":"211381","name":"北票市","province":"21","city":"13","area":"81"},{"code":"211382","name":"凌源市","province":"21","city":"13","area":"82"},{"code":"211402","name":"连山区","province":"21","city":"14","area":"02"},{"code":"211403","name":"龙港区","province":"21","city":"14","area":"03"},{"code":"211404","name":"南票区","province":"21","city":"14","area":"04"},{"code":"211421","name":"绥中县","province":"21","city":"14","area":"21"},{"code":"211422","name":"建昌县","province":"21","city":"14","area":"22"},{"code":"211481","name":"兴城市","province":"21","city":"14","area":"81"},{"code":"220102","name":"南关区","province":"22","city":"01","area":"02"},{"code":"220103","name":"宽城区","province":"22","city":"01","area":"03"},{"code":"220104","name":"朝阳区","province":"22","city":"01","area":"04"},{"code":"220105","name":"二道区","province":"22","city":"01","area":"05"},{"code":"220106","name":"绿园区","province":"22","city":"01","area":"06"},{"code":"220112","name":"双阳区","province":"22","city":"01","area":"12"},{"code":"220113","name":"九台区","province":"22","city":"01","area":"13"},{"code":"220122","name":"农安县","province":"22","city":"01","area":"22"},{"code":"220182","name":"榆树市","province":"22","city":"01","area":"82"},{"code":"220183","name":"德惠市","province":"22","city":"01","area":"83"},{"code":"220184","name":"公主岭市","province":"22","city":"01","area":"84"},{"code":"220202","name":"昌邑区","province":"22","city":"02","area":"02"},{"code":"220203","name":"龙潭区","province":"22","city":"02","area":"03"},{"code":"220204","name":"船营区","province":"22","city":"02","area":"04"},{"code":"220211","name":"丰满区","province":"22","city":"02","area":"11"},{"code":"220221","name":"永吉县","province":"22","city":"02","area":"21"},{"code":"220281","name":"蛟河市","province":"22","city":"02","area":"81"},{"code":"220282","name":"桦甸市","province":"22","city":"02","area":"82"},{"code":"220283","name":"舒兰市","province":"22","city":"02","area":"83"},{"code":"220284","name":"磐石市","province":"22","city":"02","area":"84"},{"code":"220302","name":"铁西区","province":"22","city":"03","area":"02"},{"code":"220303","name":"铁东区","province":"22","city":"03","area":"03"},{"code":"220322","name":"梨树县","province":"22","city":"03","area":"22"},{"code":"220323","name":"伊通满族自治县","province":"22","city":"03","area":"23"},{"code":"220382","name":"双辽市","province":"22","city":"03","area":"82"},{"code":"220402","name":"龙山区","province":"22","city":"04","area":"02"},{"code":"220403","name":"西安区","province":"22","city":"04","area":"03"},{"code":"220421","name":"东丰县","province":"22","city":"04","area":"21"},{"code":"220422","name":"东辽县","province":"22","city":"04","area":"22"},{"code":"220502","name":"东昌区","province":"22","city":"05","area":"02"},{"code":"220503","name":"二道江区","province":"22","city":"05","area":"03"},{"code":"220521","name":"通化县","province":"22","city":"05","area":"21"},{"code":"220523","name":"辉南县","province":"22","city":"05","area":"23"},{"code":"220524","name":"柳河县","province":"22","city":"05","area":"24"},{"code":"220581","name":"梅河口市","province":"22","city":"05","area":"81"},{"code":"220582","name":"集安市","province":"22","city":"05","area":"82"},{"code":"220602","name":"浑江区","province":"22","city":"06","area":"02"},{"code":"220605","name":"江源区","province":"22","city":"06","area":"05"},{"code":"220621","name":"抚松县","province":"22","city":"06","area":"21"},{"code":"220622","name":"靖宇县","province":"22","city":"06","area":"22"},{"code":"220623","name":"长白朝鲜族自治县","province":"22","city":"06","area":"23"},{"code":"220681","name":"临江市","province":"22","city":"06","area":"81"},{"code":"220702","name":"宁江区","province":"22","city":"07","area":"02"},{"code":"220721","name":"前郭尔罗斯蒙古族自治县","province":"22","city":"07","area":"21"},{"code":"220722","name":"长岭县","province":"22","city":"07","area":"22"},{"code":"220723","name":"乾安县","province":"22","city":"07","area":"23"},{"code":"220781","name":"扶余市","province":"22","city":"07","area":"81"},{"code":"220802","name":"洮北区","province":"22","city":"08","area":"02"},{"code":"220821","name":"镇赉县","province":"22","city":"08","area":"21"},{"code":"220822","name":"通榆县","province":"22","city":"08","area":"22"},{"code":"220881","name":"洮南市","province":"22","city":"08","area":"81"},{"code":"220882","name":"大安市","province":"22","city":"08","area":"82"},{"code":"222401","name":"延吉市","province":"22","city":"24","area":"01"},{"code":"222402","name":"图们市","province":"22","city":"24","area":"02"},{"code":"222403","name":"敦化市","province":"22","city":"24","area":"03"},{"code":"222404","name":"珲春市","province":"22","city":"24","area":"04"},{"code":"222405","name":"龙井市","province":"22","city":"24","area":"05"},{"code":"222406","name":"和龙市","province":"22","city":"24","area":"06"},{"code":"222424","name":"汪清县","province":"22","city":"24","area":"24"},{"code":"222426","name":"安图县","province":"22","city":"24","area":"26"},{"code":"230102","name":"道里区","province":"23","city":"01","area":"02"},{"code":"230103","name":"南岗区","province":"23","city":"01","area":"03"},{"code":"230104","name":"道外区","province":"23","city":"01","area":"04"},{"code":"230108","name":"平房区","province":"23","city":"01","area":"08"},{"code":"230109","name":"松北区","province":"23","city":"01","area":"09"},{"code":"230110","name":"香坊区","province":"23","city":"01","area":"10"},{"code":"230111","name":"呼兰区","province":"23","city":"01","area":"11"},{"code":"230112","name":"阿城区","province":"23","city":"01","area":"12"},{"code":"230113","name":"双城区","province":"23","city":"01","area":"13"},{"code":"230123","name":"依兰县","province":"23","city":"01","area":"23"},{"code":"230124","name":"方正县","province":"23","city":"01","area":"24"},{"code":"230125","name":"宾县","province":"23","city":"01","area":"25"},{"code":"230126","name":"巴彦县","province":"23","city":"01","area":"26"},{"code":"230127","name":"木兰县","province":"23","city":"01","area":"27"},{"code":"230128","name":"通河县","province":"23","city":"01","area":"28"},{"code":"230129","name":"延寿县","province":"23","city":"01","area":"29"},{"code":"230183","name":"尚志市","province":"23","city":"01","area":"83"},{"code":"230184","name":"五常市","province":"23","city":"01","area":"84"},{"code":"230202","name":"龙沙区","province":"23","city":"02","area":"02"},{"code":"230203","name":"建华区","province":"23","city":"02","area":"03"},{"code":"230204","name":"铁锋区","province":"23","city":"02","area":"04"},{"code":"230205","name":"昂昂溪区","province":"23","city":"02","area":"05"},{"code":"230206","name":"富拉尔基区","province":"23","city":"02","area":"06"},{"code":"230207","name":"碾子山区","province":"23","city":"02","area":"07"},{"code":"230208","name":"梅里斯达斡尔族区","province":"23","city":"02","area":"08"},{"code":"230221","name":"龙江县","province":"23","city":"02","area":"21"},{"code":"230223","name":"依安县","province":"23","city":"02","area":"23"},{"code":"230224","name":"泰来县","province":"23","city":"02","area":"24"},{"code":"230225","name":"甘南县","province":"23","city":"02","area":"25"},{"code":"230227","name":"富裕县","province":"23","city":"02","area":"27"},{"code":"230229","name":"克山县","province":"23","city":"02","area":"29"},{"code":"230230","name":"克东县","province":"23","city":"02","area":"30"},{"code":"230231","name":"拜泉县","province":"23","city":"02","area":"31"},{"code":"230281","name":"讷河市","province":"23","city":"02","area":"81"},{"code":"230302","name":"鸡冠区","province":"23","city":"03","area":"02"},{"code":"230303","name":"恒山区","province":"23","city":"03","area":"03"},{"code":"230304","name":"滴道区","province":"23","city":"03","area":"04"},{"code":"230305","name":"梨树区","province":"23","city":"03","area":"05"},{"code":"230306","name":"城子河区","province":"23","city":"03","area":"06"},{"code":"230307","name":"麻山区","province":"23","city":"03","area":"07"},{"code":"230321","name":"鸡东县","province":"23","city":"03","area":"21"},{"code":"230381","name":"虎林市","province":"23","city":"03","area":"81"},{"code":"230382","name":"密山市","province":"23","city":"03","area":"82"},{"code":"230402","name":"向阳区","province":"23","city":"04","area":"02"},{"code":"230403","name":"工农区","province":"23","city":"04","area":"03"},{"code":"230404","name":"南山区","province":"23","city":"04","area":"04"},{"code":"230405","name":"兴安区","province":"23","city":"04","area":"05"},{"code":"230406","name":"东山区","province":"23","city":"04","area":"06"},{"code":"230407","name":"兴山区","province":"23","city":"04","area":"07"},{"code":"230421","name":"萝北县","province":"23","city":"04","area":"21"},{"code":"230422","name":"绥滨县","province":"23","city":"04","area":"22"},{"code":"230502","name":"尖山区","province":"23","city":"05","area":"02"},{"code":"230503","name":"岭东区","province":"23","city":"05","area":"03"},{"code":"230505","name":"四方台区","province":"23","city":"05","area":"05"},{"code":"230506","name":"宝山区","province":"23","city":"05","area":"06"},{"code":"230521","name":"集贤县","province":"23","city":"05","area":"21"},{"code":"230522","name":"友谊县","province":"23","city":"05","area":"22"},{"code":"230523","name":"宝清县","province":"23","city":"05","area":"23"},{"code":"230524","name":"饶河县","province":"23","city":"05","area":"24"},{"code":"230602","name":"萨尔图区","province":"23","city":"06","area":"02"},{"code":"230603","name":"龙凤区","province":"23","city":"06","area":"03"},{"code":"230604","name":"让胡路区","province":"23","city":"06","area":"04"},{"code":"230605","name":"红岗区","province":"23","city":"06","area":"05"},{"code":"230606","name":"大同区","province":"23","city":"06","area":"06"},{"code":"230621","name":"肇州县","province":"23","city":"06","area":"21"},{"code":"230622","name":"肇源县","province":"23","city":"06","area":"22"},{"code":"230623","name":"林甸县","province":"23","city":"06","area":"23"},{"code":"230624","name":"杜尔伯特蒙古族自治县","province":"23","city":"06","area":"24"},{"code":"230717","name":"伊美区","province":"23","city":"07","area":"17"},{"code":"230718","name":"乌翠区","province":"23","city":"07","area":"18"},{"code":"230719","name":"友好区","province":"23","city":"07","area":"19"},{"code":"230722","name":"嘉荫县","province":"23","city":"07","area":"22"},{"code":"230723","name":"汤旺县","province":"23","city":"07","area":"23"},{"code":"230724","name":"丰林县","province":"23","city":"07","area":"24"},{"code":"230725","name":"大箐山县","province":"23","city":"07","area":"25"},{"code":"230726","name":"南岔县","province":"23","city":"07","area":"26"},{"code":"230751","name":"金林区","province":"23","city":"07","area":"51"},{"code":"230781","name":"铁力市","province":"23","city":"07","area":"81"},{"code":"230803","name":"向阳区","province":"23","city":"08","area":"03"},{"code":"230804","name":"前进区","province":"23","city":"08","area":"04"},{"code":"230805","name":"东风区","province":"23","city":"08","area":"05"},{"code":"230811","name":"郊区","province":"23","city":"08","area":"11"},{"code":"230822","name":"桦南县","province":"23","city":"08","area":"22"},{"code":"230826","name":"桦川县","province":"23","city":"08","area":"26"},{"code":"230828","name":"汤原县","province":"23","city":"08","area":"28"},{"code":"230881","name":"同江市","province":"23","city":"08","area":"81"},{"code":"230882","name":"富锦市","province":"23","city":"08","area":"82"},{"code":"230883","name":"抚远市","province":"23","city":"08","area":"83"},{"code":"230902","name":"新兴区","province":"23","city":"09","area":"02"},{"code":"230903","name":"桃山区","province":"23","city":"09","area":"03"},{"code":"230904","name":"茄子河区","province":"23","city":"09","area":"04"},{"code":"230921","name":"勃利县","province":"23","city":"09","area":"21"},{"code":"231002","name":"东安区","province":"23","city":"10","area":"02"},{"code":"231003","name":"阳明区","province":"23","city":"10","area":"03"},{"code":"231004","name":"爱民区","province":"23","city":"10","area":"04"},{"code":"231005","name":"西安区","province":"23","city":"10","area":"05"},{"code":"231025","name":"林口县","province":"23","city":"10","area":"25"},{"code":"231081","name":"绥芬河市","province":"23","city":"10","area":"81"},{"code":"231083","name":"海林市","province":"23","city":"10","area":"83"},{"code":"231084","name":"宁安市","province":"23","city":"10","area":"84"},{"code":"231085","name":"穆棱市","province":"23","city":"10","area":"85"},{"code":"231086","name":"东宁市","province":"23","city":"10","area":"86"},{"code":"231102","name":"爱辉区","province":"23","city":"11","area":"02"},{"code":"231123","name":"逊克县","province":"23","city":"11","area":"23"},{"code":"231124","name":"孙吴县","province":"23","city":"11","area":"24"},{"code":"231181","name":"北安市","province":"23","city":"11","area":"81"},{"code":"231182","name":"五大连池市","province":"23","city":"11","area":"82"},{"code":"231183","name":"嫩江市","province":"23","city":"11","area":"83"},{"code":"231202","name":"北林区","province":"23","city":"12","area":"02"},{"code":"231221","name":"望奎县","province":"23","city":"12","area":"21"},{"code":"231222","name":"兰西县","province":"23","city":"12","area":"22"},{"code":"231223","name":"青冈县","province":"23","city":"12","area":"23"},{"code":"231224","name":"庆安县","province":"23","city":"12","area":"24"},{"code":"231225","name":"明水县","province":"23","city":"12","area":"25"},{"code":"231226","name":"绥棱县","province":"23","city":"12","area":"26"},{"code":"231281","name":"安达市","province":"23","city":"12","area":"81"},{"code":"231282","name":"肇东市","province":"23","city":"12","area":"82"},{"code":"231283","name":"海伦市","province":"23","city":"12","area":"83"},{"code":"232701","name":"漠河市","province":"23","city":"27","area":"01"},{"code":"232721","name":"呼玛县","province":"23","city":"27","area":"21"},{"code":"232722","name":"塔河县","province":"23","city":"27","area":"22"},{"code":"310101","name":"黄浦区","province":"31","city":"01","area":"01"},{"code":"310104","name":"徐汇区","province":"31","city":"01","area":"04"},{"code":"310105","name":"长宁区","province":"31","city":"01","area":"05"},{"code":"310106","name":"静安区","province":"31","city":"01","area":"06"},{"code":"310107","name":"普陀区","province":"31","city":"01","area":"07"},{"code":"310109","name":"虹口区","province":"31","city":"01","area":"09"},{"code":"310110","name":"杨浦区","province":"31","city":"01","area":"10"},{"code":"310112","name":"闵行区","province":"31","city":"01","area":"12"},{"code":"310113","name":"宝山区","province":"31","city":"01","area":"13"},{"code":"310114","name":"嘉定区","province":"31","city":"01","area":"14"},{"code":"310115","name":"浦东新区","province":"31","city":"01","area":"15"},{"code":"310116","name":"金山区","province":"31","city":"01","area":"16"},{"code":"310117","name":"松江区","province":"31","city":"01","area":"17"},{"code":"310118","name":"青浦区","province":"31","city":"01","area":"18"},{"code":"310120","name":"奉贤区","province":"31","city":"01","area":"20"},{"code":"310151","name":"崇明区","province":"31","city":"01","area":"51"},{"code":"320102","name":"玄武区","province":"32","city":"01","area":"02"},{"code":"320104","name":"秦淮区","province":"32","city":"01","area":"04"},{"code":"320105","name":"建邺区","province":"32","city":"01","area":"05"},{"code":"320106","name":"鼓楼区","province":"32","city":"01","area":"06"},{"code":"320111","name":"浦口区","province":"32","city":"01","area":"11"},{"code":"320113","name":"栖霞区","province":"32","city":"01","area":"13"},{"code":"320114","name":"雨花台区","province":"32","city":"01","area":"14"},{"code":"320115","name":"江宁区","province":"32","city":"01","area":"15"},{"code":"320116","name":"六合区","province":"32","city":"01","area":"16"},{"code":"320117","name":"溧水区","province":"32","city":"01","area":"17"},{"code":"320118","name":"高淳区","province":"32","city":"01","area":"18"},{"code":"320205","name":"锡山区","province":"32","city":"02","area":"05"},{"code":"320206","name":"惠山区","province":"32","city":"02","area":"06"},{"code":"320211","name":"滨湖区","province":"32","city":"02","area":"11"},{"code":"320213","name":"梁溪区","province":"32","city":"02","area":"13"},{"code":"320214","name":"新吴区","province":"32","city":"02","area":"14"},{"code":"320281","name":"江阴市","province":"32","city":"02","area":"81"},{"code":"320282","name":"宜兴市","province":"32","city":"02","area":"82"},{"code":"320302","name":"鼓楼区","province":"32","city":"03","area":"02"},{"code":"320303","name":"云龙区","province":"32","city":"03","area":"03"},{"code":"320305","name":"贾汪区","province":"32","city":"03","area":"05"},{"code":"320311","name":"泉山区","province":"32","city":"03","area":"11"},{"code":"320312","name":"铜山区","province":"32","city":"03","area":"12"},{"code":"320321","name":"丰县","province":"32","city":"03","area":"21"},{"code":"320322","name":"沛县","province":"32","city":"03","area":"22"},{"code":"320324","name":"睢宁县","province":"32","city":"03","area":"24"},{"code":"320381","name":"新沂市","province":"32","city":"03","area":"81"},{"code":"320382","name":"邳州市","province":"32","city":"03","area":"82"},{"code":"320402","name":"天宁区","province":"32","city":"04","area":"02"},{"code":"320404","name":"钟楼区","province":"32","city":"04","area":"04"},{"code":"320411","name":"新北区","province":"32","city":"04","area":"11"},{"code":"320412","name":"武进区","province":"32","city":"04","area":"12"},{"code":"320413","name":"金坛区","province":"32","city":"04","area":"13"},{"code":"320481","name":"溧阳市","province":"32","city":"04","area":"81"},{"code":"320505","name":"虎丘区","province":"32","city":"05","area":"05"},{"code":"320506","name":"吴中区","province":"32","city":"05","area":"06"},{"code":"320507","name":"相城区","province":"32","city":"05","area":"07"},{"code":"320508","name":"姑苏区","province":"32","city":"05","area":"08"},{"code":"320509","name":"吴江区","province":"32","city":"05","area":"09"},{"code":"320581","name":"常熟市","province":"32","city":"05","area":"81"},{"code":"320582","name":"张家港市","province":"32","city":"05","area":"82"},{"code":"320583","name":"昆山市","province":"32","city":"05","area":"83"},{"code":"320585","name":"太仓市","province":"32","city":"05","area":"85"},{"code":"320612","name":"通州区","province":"32","city":"06","area":"12"},{"code":"320613","name":"崇川区","province":"32","city":"06","area":"13"},{"code":"320614","name":"海门区","province":"32","city":"06","area":"14"},{"code":"320623","name":"如东县","province":"32","city":"06","area":"23"},{"code":"320681","name":"启东市","province":"32","city":"06","area":"81"},{"code":"320682","name":"如皋市","province":"32","city":"06","area":"82"},{"code":"320685","name":"海安市","province":"32","city":"06","area":"85"},{"code":"320703","name":"连云区","province":"32","city":"07","area":"03"},{"code":"320706","name":"海州区","province":"32","city":"07","area":"06"},{"code":"320707","name":"赣榆区","province":"32","city":"07","area":"07"},{"code":"320722","name":"东海县","province":"32","city":"07","area":"22"},{"code":"320723","name":"灌云县","province":"32","city":"07","area":"23"},{"code":"320724","name":"灌南县","province":"32","city":"07","area":"24"},{"code":"320803","name":"淮安区","province":"32","city":"08","area":"03"},{"code":"320804","name":"淮阴区","province":"32","city":"08","area":"04"},{"code":"320812","name":"清江浦区","province":"32","city":"08","area":"12"},{"code":"320813","name":"洪泽区","province":"32","city":"08","area":"13"},{"code":"320826","name":"涟水县","province":"32","city":"08","area":"26"},{"code":"320830","name":"盱眙县","province":"32","city":"08","area":"30"},{"code":"320831","name":"金湖县","province":"32","city":"08","area":"31"},{"code":"320902","name":"亭湖区","province":"32","city":"09","area":"02"},{"code":"320903","name":"盐都区","province":"32","city":"09","area":"03"},{"code":"320904","name":"大丰区","province":"32","city":"09","area":"04"},{"code":"320921","name":"响水县","province":"32","city":"09","area":"21"},{"code":"320922","name":"滨海县","province":"32","city":"09","area":"22"},{"code":"320923","name":"阜宁县","province":"32","city":"09","area":"23"},{"code":"320924","name":"射阳县","province":"32","city":"09","area":"24"},{"code":"320925","name":"建湖县","province":"32","city":"09","area":"25"},{"code":"320981","name":"东台市","province":"32","city":"09","area":"81"},{"code":"321002","name":"广陵区","province":"32","city":"10","area":"02"},{"code":"321003","name":"邗江区","province":"32","city":"10","area":"03"},{"code":"321012","name":"江都区","province":"32","city":"10","area":"12"},{"code":"321023","name":"宝应县","province":"32","city":"10","area":"23"},{"code":"321081","name":"仪征市","province":"32","city":"10","area":"81"},{"code":"321084","name":"高邮市","province":"32","city":"10","area":"84"},{"code":"321102","name":"京口区","province":"32","city":"11","area":"02"},{"code":"321111","name":"润州区","province":"32","city":"11","area":"11"},{"code":"321112","name":"丹徒区","province":"32","city":"11","area":"12"},{"code":"321181","name":"丹阳市","province":"32","city":"11","area":"81"},{"code":"321182","name":"扬中市","province":"32","city":"11","area":"82"},{"code":"321183","name":"句容市","province":"32","city":"11","area":"83"},{"code":"321202","name":"海陵区","province":"32","city":"12","area":"02"},{"code":"321203","name":"高港区","province":"32","city":"12","area":"03"},{"code":"321204","name":"姜堰区","province":"32","city":"12","area":"04"},{"code":"321281","name":"兴化市","province":"32","city":"12","area":"81"},{"code":"321282","name":"靖江市","province":"32","city":"12","area":"82"},{"code":"321283","name":"泰兴市","province":"32","city":"12","area":"83"},{"code":"321302","name":"宿城区","province":"32","city":"13","area":"02"},{"code":"321311","name":"宿豫区","province":"32","city":"13","area":"11"},{"code":"321322","name":"沭阳县","province":"32","city":"13","area":"22"},{"code":"321323","name":"泗阳县","province":"32","city":"13","area":"23"},{"code":"321324","name":"泗洪县","province":"32","city":"13","area":"24"},{"code":"330102","name":"上城区","province":"33","city":"01","area":"02"},{"code":"330103","name":"下城区","province":"33","city":"01","area":"03"},{"code":"330104","name":"江干区","province":"33","city":"01","area":"04"},{"code":"330105","name":"拱墅区","province":"33","city":"01","area":"05"},{"code":"330106","name":"西湖区","province":"33","city":"01","area":"06"},{"code":"330108","name":"滨江区","province":"33","city":"01","area":"08"},{"code":"330109","name":"萧山区","province":"33","city":"01","area":"09"},{"code":"330110","name":"余杭区","province":"33","city":"01","area":"10"},{"code":"330111","name":"富阳区","province":"33","city":"01","area":"11"},{"code":"330112","name":"临安区","province":"33","city":"01","area":"12"},{"code":"330122","name":"桐庐县","province":"33","city":"01","area":"22"},{"code":"330127","name":"淳安县","province":"33","city":"01","area":"27"},{"code":"330182","name":"建德市","province":"33","city":"01","area":"82"},{"code":"330203","name":"海曙区","province":"33","city":"02","area":"03"},{"code":"330205","name":"江北区","province":"33","city":"02","area":"05"},{"code":"330206","name":"北仑区","province":"33","city":"02","area":"06"},{"code":"330211","name":"镇海区","province":"33","city":"02","area":"11"},{"code":"330212","name":"鄞州区","province":"33","city":"02","area":"12"},{"code":"330213","name":"奉化区","province":"33","city":"02","area":"13"},{"code":"330225","name":"象山县","province":"33","city":"02","area":"25"},{"code":"330226","name":"宁海县","province":"33","city":"02","area":"26"},{"code":"330281","name":"余姚市","province":"33","city":"02","area":"81"},{"code":"330282","name":"慈溪市","province":"33","city":"02","area":"82"},{"code":"330302","name":"鹿城区","province":"33","city":"03","area":"02"},{"code":"330303","name":"龙湾区","province":"33","city":"03","area":"03"},{"code":"330304","name":"瓯海区","province":"33","city":"03","area":"04"},{"code":"330305","name":"洞头区","province":"33","city":"03","area":"05"},{"code":"330324","name":"永嘉县","province":"33","city":"03","area":"24"},{"code":"330326","name":"平阳县","province":"33","city":"03","area":"26"},{"code":"330327","name":"苍南县","province":"33","city":"03","area":"27"},{"code":"330328","name":"文成县","province":"33","city":"03","area":"28"},{"code":"330329","name":"泰顺县","province":"33","city":"03","area":"29"},{"code":"330381","name":"瑞安市","province":"33","city":"03","area":"81"},{"code":"330382","name":"乐清市","province":"33","city":"03","area":"82"},{"code":"330383","name":"龙港市","province":"33","city":"03","area":"83"},{"code":"330402","name":"南湖区","province":"33","city":"04","area":"02"},{"code":"330411","name":"秀洲区","province":"33","city":"04","area":"11"},{"code":"330421","name":"嘉善县","province":"33","city":"04","area":"21"},{"code":"330424","name":"海盐县","province":"33","city":"04","area":"24"},{"code":"330481","name":"海宁市","province":"33","city":"04","area":"81"},{"code":"330482","name":"平湖市","province":"33","city":"04","area":"82"},{"code":"330483","name":"桐乡市","province":"33","city":"04","area":"83"},{"code":"330502","name":"吴兴区","province":"33","city":"05","area":"02"},{"code":"330503","name":"南浔区","province":"33","city":"05","area":"03"},{"code":"330521","name":"德清县","province":"33","city":"05","area":"21"},{"code":"330522","name":"长兴县","province":"33","city":"05","area":"22"},{"code":"330523","name":"安吉县","province":"33","city":"05","area":"23"},{"code":"330602","name":"越城区","province":"33","city":"06","area":"02"},{"code":"330603","name":"柯桥区","province":"33","city":"06","area":"03"},{"code":"330604","name":"上虞区","province":"33","city":"06","area":"04"},{"code":"330624","name":"新昌县","province":"33","city":"06","area":"24"},{"code":"330681","name":"诸暨市","province":"33","city":"06","area":"81"},{"code":"330683","name":"嵊州市","province":"33","city":"06","area":"83"},{"code":"330702","name":"婺城区","province":"33","city":"07","area":"02"},{"code":"330703","name":"金东区","province":"33","city":"07","area":"03"},{"code":"330723","name":"武义县","province":"33","city":"07","area":"23"},{"code":"330726","name":"浦江县","province":"33","city":"07","area":"26"},{"code":"330727","name":"磐安县","province":"33","city":"07","area":"27"},{"code":"330781","name":"兰溪市","province":"33","city":"07","area":"81"},{"code":"330782","name":"义乌市","province":"33","city":"07","area":"82"},{"code":"330783","name":"东阳市","province":"33","city":"07","area":"83"},{"code":"330784","name":"永康市","province":"33","city":"07","area":"84"},{"code":"330802","name":"柯城区","province":"33","city":"08","area":"02"},{"code":"330803","name":"衢江区","province":"33","city":"08","area":"03"},{"code":"330822","name":"常山县","province":"33","city":"08","area":"22"},{"code":"330824","name":"开化县","province":"33","city":"08","area":"24"},{"code":"330825","name":"龙游县","province":"33","city":"08","area":"25"},{"code":"330881","name":"江山市","province":"33","city":"08","area":"81"},{"code":"330902","name":"定海区","province":"33","city":"09","area":"02"},{"code":"330903","name":"普陀区","province":"33","city":"09","area":"03"},{"code":"330921","name":"岱山县","province":"33","city":"09","area":"21"},{"code":"330922","name":"嵊泗县","province":"33","city":"09","area":"22"},{"code":"331002","name":"椒江区","province":"33","city":"10","area":"02"},{"code":"331003","name":"黄岩区","province":"33","city":"10","area":"03"},{"code":"331004","name":"路桥区","province":"33","city":"10","area":"04"},{"code":"331022","name":"三门县","province":"33","city":"10","area":"22"},{"code":"331023","name":"天台县","province":"33","city":"10","area":"23"},{"code":"331024","name":"仙居县","province":"33","city":"10","area":"24"},{"code":"331081","name":"温岭市","province":"33","city":"10","area":"81"},{"code":"331082","name":"临海市","province":"33","city":"10","area":"82"},{"code":"331083","name":"玉环市","province":"33","city":"10","area":"83"},{"code":"331102","name":"莲都区","province":"33","city":"11","area":"02"},{"code":"331121","name":"青田县","province":"33","city":"11","area":"21"},{"code":"331122","name":"缙云县","province":"33","city":"11","area":"22"},{"code":"331123","name":"遂昌县","province":"33","city":"11","area":"23"},{"code":"331124","name":"松阳县","province":"33","city":"11","area":"24"},{"code":"331125","name":"云和县","province":"33","city":"11","area":"25"},{"code":"331126","name":"庆元县","province":"33","city":"11","area":"26"},{"code":"331127","name":"景宁畲族自治县","province":"33","city":"11","area":"27"},{"code":"331181","name":"龙泉市","province":"33","city":"11","area":"81"},{"code":"340102","name":"瑶海区","province":"34","city":"01","area":"02"},{"code":"340103","name":"庐阳区","province":"34","city":"01","area":"03"},{"code":"340104","name":"蜀山区","province":"34","city":"01","area":"04"},{"code":"340111","name":"包河区","province":"34","city":"01","area":"11"},{"code":"340121","name":"长丰县","province":"34","city":"01","area":"21"},{"code":"340122","name":"肥东县","province":"34","city":"01","area":"22"},{"code":"340123","name":"肥西县","province":"34","city":"01","area":"23"},{"code":"340124","name":"庐江县","province":"34","city":"01","area":"24"},{"code":"340181","name":"巢湖市","province":"34","city":"01","area":"81"},{"code":"340202","name":"镜湖区","province":"34","city":"02","area":"02"},{"code":"340207","name":"鸠江区","province":"34","city":"02","area":"07"},{"code":"340209","name":"弋江区","province":"34","city":"02","area":"09"},{"code":"340210","name":"湾沚区","province":"34","city":"02","area":"10"},{"code":"340212","name":"繁昌区","province":"34","city":"02","area":"12"},{"code":"340223","name":"南陵县","province":"34","city":"02","area":"23"},{"code":"340281","name":"无为市","province":"34","city":"02","area":"81"},{"code":"340302","name":"龙子湖区","province":"34","city":"03","area":"02"},{"code":"340303","name":"蚌山区","province":"34","city":"03","area":"03"},{"code":"340304","name":"禹会区","province":"34","city":"03","area":"04"},{"code":"340311","name":"淮上区","province":"34","city":"03","area":"11"},{"code":"340321","name":"怀远县","province":"34","city":"03","area":"21"},{"code":"340322","name":"五河县","province":"34","city":"03","area":"22"},{"code":"340323","name":"固镇县","province":"34","city":"03","area":"23"},{"code":"340402","name":"大通区","province":"34","city":"04","area":"02"},{"code":"340403","name":"田家庵区","province":"34","city":"04","area":"03"},{"code":"340404","name":"谢家集区","province":"34","city":"04","area":"04"},{"code":"340405","name":"八公山区","province":"34","city":"04","area":"05"},{"code":"340406","name":"潘集区","province":"34","city":"04","area":"06"},{"code":"340421","name":"凤台县","province":"34","city":"04","area":"21"},{"code":"340422","name":"寿县","province":"34","city":"04","area":"22"},{"code":"340503","name":"花山区","province":"34","city":"05","area":"03"},{"code":"340504","name":"雨山区","province":"34","city":"05","area":"04"},{"code":"340506","name":"博望区","province":"34","city":"05","area":"06"},{"code":"340521","name":"当涂县","province":"34","city":"05","area":"21"},{"code":"340522","name":"含山县","province":"34","city":"05","area":"22"},{"code":"340523","name":"和县","province":"34","city":"05","area":"23"},{"code":"340602","name":"杜集区","province":"34","city":"06","area":"02"},{"code":"340603","name":"相山区","province":"34","city":"06","area":"03"},{"code":"340604","name":"烈山区","province":"34","city":"06","area":"04"},{"code":"340621","name":"濉溪县","province":"34","city":"06","area":"21"},{"code":"340705","name":"铜官区","province":"34","city":"07","area":"05"},{"code":"340706","name":"义安区","province":"34","city":"07","area":"06"},{"code":"340711","name":"郊区","province":"34","city":"07","area":"11"},{"code":"340722","name":"枞阳县","province":"34","city":"07","area":"22"},{"code":"340802","name":"迎江区","province":"34","city":"08","area":"02"},{"code":"340803","name":"大观区","province":"34","city":"08","area":"03"},{"code":"340811","name":"宜秀区","province":"34","city":"08","area":"11"},{"code":"340822","name":"怀宁县","province":"34","city":"08","area":"22"},{"code":"340825","name":"太湖县","province":"34","city":"08","area":"25"},{"code":"340826","name":"宿松县","province":"34","city":"08","area":"26"},{"code":"340827","name":"望江县","province":"34","city":"08","area":"27"},{"code":"340828","name":"岳西县","province":"34","city":"08","area":"28"},{"code":"340881","name":"桐城市","province":"34","city":"08","area":"81"},{"code":"340882","name":"潜山市","province":"34","city":"08","area":"82"},{"code":"341002","name":"屯溪区","province":"34","city":"10","area":"02"},{"code":"341003","name":"黄山区","province":"34","city":"10","area":"03"},{"code":"341004","name":"徽州区","province":"34","city":"10","area":"04"},{"code":"341021","name":"歙县","province":"34","city":"10","area":"21"},{"code":"341022","name":"休宁县","province":"34","city":"10","area":"22"},{"code":"341023","name":"黟县","province":"34","city":"10","area":"23"},{"code":"341024","name":"祁门县","province":"34","city":"10","area":"24"},{"code":"341102","name":"琅琊区","province":"34","city":"11","area":"02"},{"code":"341103","name":"南谯区","province":"34","city":"11","area":"03"},{"code":"341122","name":"来安县","province":"34","city":"11","area":"22"},{"code":"341124","name":"全椒县","province":"34","city":"11","area":"24"},{"code":"341125","name":"定远县","province":"34","city":"11","area":"25"},{"code":"341126","name":"凤阳县","province":"34","city":"11","area":"26"},{"code":"341181","name":"天长市","province":"34","city":"11","area":"81"},{"code":"341182","name":"明光市","province":"34","city":"11","area":"82"},{"code":"341202","name":"颍州区","province":"34","city":"12","area":"02"},{"code":"341203","name":"颍东区","province":"34","city":"12","area":"03"},{"code":"341204","name":"颍泉区","province":"34","city":"12","area":"04"},{"code":"341221","name":"临泉县","province":"34","city":"12","area":"21"},{"code":"341222","name":"太和县","province":"34","city":"12","area":"22"},{"code":"341225","name":"阜南县","province":"34","city":"12","area":"25"},{"code":"341226","name":"颍上县","province":"34","city":"12","area":"26"},{"code":"341282","name":"界首市","province":"34","city":"12","area":"82"},{"code":"341302","name":"埇桥区","province":"34","city":"13","area":"02"},{"code":"341321","name":"砀山县","province":"34","city":"13","area":"21"},{"code":"341322","name":"萧县","province":"34","city":"13","area":"22"},{"code":"341323","name":"灵璧县","province":"34","city":"13","area":"23"},{"code":"341324","name":"泗县","province":"34","city":"13","area":"24"},{"code":"341502","name":"金安区","province":"34","city":"15","area":"02"},{"code":"341503","name":"裕安区","province":"34","city":"15","area":"03"},{"code":"341504","name":"叶集区","province":"34","city":"15","area":"04"},{"code":"341522","name":"霍邱县","province":"34","city":"15","area":"22"},{"code":"341523","name":"舒城县","province":"34","city":"15","area":"23"},{"code":"341524","name":"金寨县","province":"34","city":"15","area":"24"},{"code":"341525","name":"霍山县","province":"34","city":"15","area":"25"},{"code":"341602","name":"谯城区","province":"34","city":"16","area":"02"},{"code":"341621","name":"涡阳县","province":"34","city":"16","area":"21"},{"code":"341622","name":"蒙城县","province":"34","city":"16","area":"22"},{"code":"341623","name":"利辛县","province":"34","city":"16","area":"23"},{"code":"341702","name":"贵池区","province":"34","city":"17","area":"02"},{"code":"341721","name":"东至县","province":"34","city":"17","area":"21"},{"code":"341722","name":"石台县","province":"34","city":"17","area":"22"},{"code":"341723","name":"青阳县","province":"34","city":"17","area":"23"},{"code":"341802","name":"宣州区","province":"34","city":"18","area":"02"},{"code":"341821","name":"郎溪县","province":"34","city":"18","area":"21"},{"code":"341823","name":"泾县","province":"34","city":"18","area":"23"},{"code":"341824","name":"绩溪县","province":"34","city":"18","area":"24"},{"code":"341825","name":"旌德县","province":"34","city":"18","area":"25"},{"code":"341881","name":"宁国市","province":"34","city":"18","area":"81"},{"code":"341882","name":"广德市","province":"34","city":"18","area":"82"},{"code":"350102","name":"鼓楼区","province":"35","city":"01","area":"02"},{"code":"350103","name":"台江区","province":"35","city":"01","area":"03"},{"code":"350104","name":"仓山区","province":"35","city":"01","area":"04"},{"code":"350105","name":"马尾区","province":"35","city":"01","area":"05"},{"code":"350111","name":"晋安区","province":"35","city":"01","area":"11"},{"code":"350112","name":"长乐区","province":"35","city":"01","area":"12"},{"code":"350121","name":"闽侯县","province":"35","city":"01","area":"21"},{"code":"350122","name":"连江县","province":"35","city":"01","area":"22"},{"code":"350123","name":"罗源县","province":"35","city":"01","area":"23"},{"code":"350124","name":"闽清县","province":"35","city":"01","area":"24"},{"code":"350125","name":"永泰县","province":"35","city":"01","area":"25"},{"code":"350128","name":"平潭县","province":"35","city":"01","area":"28"},{"code":"350181","name":"福清市","province":"35","city":"01","area":"81"},{"code":"350203","name":"思明区","province":"35","city":"02","area":"03"},{"code":"350205","name":"海沧区","province":"35","city":"02","area":"05"},{"code":"350206","name":"湖里区","province":"35","city":"02","area":"06"},{"code":"350211","name":"集美区","province":"35","city":"02","area":"11"},{"code":"350212","name":"同安区","province":"35","city":"02","area":"12"},{"code":"350213","name":"翔安区","province":"35","city":"02","area":"13"},{"code":"350302","name":"城厢区","province":"35","city":"03","area":"02"},{"code":"350303","name":"涵江区","province":"35","city":"03","area":"03"},{"code":"350304","name":"荔城区","province":"35","city":"03","area":"04"},{"code":"350305","name":"秀屿区","province":"35","city":"03","area":"05"},{"code":"350322","name":"仙游县","province":"35","city":"03","area":"22"},{"code":"350402","name":"梅列区","province":"35","city":"04","area":"02"},{"code":"350403","name":"三元区","province":"35","city":"04","area":"03"},{"code":"350421","name":"明溪县","province":"35","city":"04","area":"21"},{"code":"350423","name":"清流县","province":"35","city":"04","area":"23"},{"code":"350424","name":"宁化县","province":"35","city":"04","area":"24"},{"code":"350425","name":"大田县","province":"35","city":"04","area":"25"},{"code":"350426","name":"尤溪县","province":"35","city":"04","area":"26"},{"code":"350427","name":"沙县","province":"35","city":"04","area":"27"},{"code":"350428","name":"将乐县","province":"35","city":"04","area":"28"},{"code":"350429","name":"泰宁县","province":"35","city":"04","area":"29"},{"code":"350430","name":"建宁县","province":"35","city":"04","area":"30"},{"code":"350481","name":"永安市","province":"35","city":"04","area":"81"},{"code":"350502","name":"鲤城区","province":"35","city":"05","area":"02"},{"code":"350503","name":"丰泽区","province":"35","city":"05","area":"03"},{"code":"350504","name":"洛江区","province":"35","city":"05","area":"04"},{"code":"350505","name":"泉港区","province":"35","city":"05","area":"05"},{"code":"350521","name":"惠安县","province":"35","city":"05","area":"21"},{"code":"350524","name":"安溪县","province":"35","city":"05","area":"24"},{"code":"350525","name":"永春县","province":"35","city":"05","area":"25"},{"code":"350526","name":"德化县","province":"35","city":"05","area":"26"},{"code":"350527","name":"金门县","province":"35","city":"05","area":"27"},{"code":"350581","name":"石狮市","province":"35","city":"05","area":"81"},{"code":"350582","name":"晋江市","province":"35","city":"05","area":"82"},{"code":"350583","name":"南安市","province":"35","city":"05","area":"83"},{"code":"350602","name":"芗城区","province":"35","city":"06","area":"02"},{"code":"350603","name":"龙文区","province":"35","city":"06","area":"03"},{"code":"350622","name":"云霄县","province":"35","city":"06","area":"22"},{"code":"350623","name":"漳浦县","province":"35","city":"06","area":"23"},{"code":"350624","name":"诏安县","province":"35","city":"06","area":"24"},{"code":"350625","name":"长泰县","province":"35","city":"06","area":"25"},{"code":"350626","name":"东山县","province":"35","city":"06","area":"26"},{"code":"350627","name":"南靖县","province":"35","city":"06","area":"27"},{"code":"350628","name":"平和县","province":"35","city":"06","area":"28"},{"code":"350629","name":"华安县","province":"35","city":"06","area":"29"},{"code":"350681","name":"龙海市","province":"35","city":"06","area":"81"},{"code":"350702","name":"延平区","province":"35","city":"07","area":"02"},{"code":"350703","name":"建阳区","province":"35","city":"07","area":"03"},{"code":"350721","name":"顺昌县","province":"35","city":"07","area":"21"},{"code":"350722","name":"浦城县","province":"35","city":"07","area":"22"},{"code":"350723","name":"光泽县","province":"35","city":"07","area":"23"},{"code":"350724","name":"松溪县","province":"35","city":"07","area":"24"},{"code":"350725","name":"政和县","province":"35","city":"07","area":"25"},{"code":"350781","name":"邵武市","province":"35","city":"07","area":"81"},{"code":"350782","name":"武夷山市","province":"35","city":"07","area":"82"},{"code":"350783","name":"建瓯市","province":"35","city":"07","area":"83"},{"code":"350802","name":"新罗区","province":"35","city":"08","area":"02"},{"code":"350803","name":"永定区","province":"35","city":"08","area":"03"},{"code":"350821","name":"长汀县","province":"35","city":"08","area":"21"},{"code":"350823","name":"上杭县","province":"35","city":"08","area":"23"},{"code":"350824","name":"武平县","province":"35","city":"08","area":"24"},{"code":"350825","name":"连城县","province":"35","city":"08","area":"25"},{"code":"350881","name":"漳平市","province":"35","city":"08","area":"81"},{"code":"350902","name":"蕉城区","province":"35","city":"09","area":"02"},{"code":"350921","name":"霞浦县","province":"35","city":"09","area":"21"},{"code":"350922","name":"古田县","province":"35","city":"09","area":"22"},{"code":"350923","name":"屏南县","province":"35","city":"09","area":"23"},{"code":"350924","name":"寿宁县","province":"35","city":"09","area":"24"},{"code":"350925","name":"周宁县","province":"35","city":"09","area":"25"},{"code":"350926","name":"柘荣县","province":"35","city":"09","area":"26"},{"code":"350981","name":"福安市","province":"35","city":"09","area":"81"},{"code":"350982","name":"福鼎市","province":"35","city":"09","area":"82"},{"code":"360102","name":"东湖区","province":"36","city":"01","area":"02"},{"code":"360103","name":"西湖区","province":"36","city":"01","area":"03"},{"code":"360104","name":"青云谱区","province":"36","city":"01","area":"04"},{"code":"360111","name":"青山湖区","province":"36","city":"01","area":"11"},{"code":"360112","name":"新建区","province":"36","city":"01","area":"12"},{"code":"360113","name":"红谷滩区","province":"36","city":"01","area":"13"},{"code":"360121","name":"南昌县","province":"36","city":"01","area":"21"},{"code":"360123","name":"安义县","province":"36","city":"01","area":"23"},{"code":"360124","name":"进贤县","province":"36","city":"01","area":"24"},{"code":"360202","name":"昌江区","province":"36","city":"02","area":"02"},{"code":"360203","name":"珠山区","province":"36","city":"02","area":"03"},{"code":"360222","name":"浮梁县","province":"36","city":"02","area":"22"},{"code":"360281","name":"乐平市","province":"36","city":"02","area":"81"},{"code":"360302","name":"安源区","province":"36","city":"03","area":"02"},{"code":"360313","name":"湘东区","province":"36","city":"03","area":"13"},{"code":"360321","name":"莲花县","province":"36","city":"03","area":"21"},{"code":"360322","name":"上栗县","province":"36","city":"03","area":"22"},{"code":"360323","name":"芦溪县","province":"36","city":"03","area":"23"},{"code":"360402","name":"濂溪区","province":"36","city":"04","area":"02"},{"code":"360403","name":"浔阳区","province":"36","city":"04","area":"03"},{"code":"360404","name":"柴桑区","province":"36","city":"04","area":"04"},{"code":"360423","name":"武宁县","province":"36","city":"04","area":"23"},{"code":"360424","name":"修水县","province":"36","city":"04","area":"24"},{"code":"360425","name":"永修县","province":"36","city":"04","area":"25"},{"code":"360426","name":"德安县","province":"36","city":"04","area":"26"},{"code":"360428","name":"都昌县","province":"36","city":"04","area":"28"},{"code":"360429","name":"湖口县","province":"36","city":"04","area":"29"},{"code":"360430","name":"彭泽县","province":"36","city":"04","area":"30"},{"code":"360481","name":"瑞昌市","province":"36","city":"04","area":"81"},{"code":"360482","name":"共青城市","province":"36","city":"04","area":"82"},{"code":"360483","name":"庐山市","province":"36","city":"04","area":"83"},{"code":"360502","name":"渝水区","province":"36","city":"05","area":"02"},{"code":"360521","name":"分宜县","province":"36","city":"05","area":"21"},{"code":"360602","name":"月湖区","province":"36","city":"06","area":"02"},{"code":"360603","name":"余江区","province":"36","city":"06","area":"03"},{"code":"360681","name":"贵溪市","province":"36","city":"06","area":"81"},{"code":"360702","name":"章贡区","province":"36","city":"07","area":"02"},{"code":"360703","name":"南康区","province":"36","city":"07","area":"03"},{"code":"360704","name":"赣县区","province":"36","city":"07","area":"04"},{"code":"360722","name":"信丰县","province":"36","city":"07","area":"22"},{"code":"360723","name":"大余县","province":"36","city":"07","area":"23"},{"code":"360724","name":"上犹县","province":"36","city":"07","area":"24"},{"code":"360725","name":"崇义县","province":"36","city":"07","area":"25"},{"code":"360726","name":"安远县","province":"36","city":"07","area":"26"},{"code":"360728","name":"定南县","province":"36","city":"07","area":"28"},{"code":"360729","name":"全南县","province":"36","city":"07","area":"29"},{"code":"360730","name":"宁都县","province":"36","city":"07","area":"30"},{"code":"360731","name":"于都县","province":"36","city":"07","area":"31"},{"code":"360732","name":"兴国县","province":"36","city":"07","area":"32"},{"code":"360733","name":"会昌县","province":"36","city":"07","area":"33"},{"code":"360734","name":"寻乌县","province":"36","city":"07","area":"34"},{"code":"360735","name":"石城县","province":"36","city":"07","area":"35"},{"code":"360781","name":"瑞金市","province":"36","city":"07","area":"81"},{"code":"360783","name":"龙南市","province":"36","city":"07","area":"83"},{"code":"360802","name":"吉州区","province":"36","city":"08","area":"02"},{"code":"360803","name":"青原区","province":"36","city":"08","area":"03"},{"code":"360821","name":"吉安县","province":"36","city":"08","area":"21"},{"code":"360822","name":"吉水县","province":"36","city":"08","area":"22"},{"code":"360823","name":"峡江县","province":"36","city":"08","area":"23"},{"code":"360824","name":"新干县","province":"36","city":"08","area":"24"},{"code":"360825","name":"永丰县","province":"36","city":"08","area":"25"},{"code":"360826","name":"泰和县","province":"36","city":"08","area":"26"},{"code":"360827","name":"遂川县","province":"36","city":"08","area":"27"},{"code":"360828","name":"万安县","province":"36","city":"08","area":"28"},{"code":"360829","name":"安福县","province":"36","city":"08","area":"29"},{"code":"360830","name":"永新县","province":"36","city":"08","area":"30"},{"code":"360881","name":"井冈山市","province":"36","city":"08","area":"81"},{"code":"360902","name":"袁州区","province":"36","city":"09","area":"02"},{"code":"360921","name":"奉新县","province":"36","city":"09","area":"21"},{"code":"360922","name":"万载县","province":"36","city":"09","area":"22"},{"code":"360923","name":"上高县","province":"36","city":"09","area":"23"},{"code":"360924","name":"宜丰县","province":"36","city":"09","area":"24"},{"code":"360925","name":"靖安县","province":"36","city":"09","area":"25"},{"code":"360926","name":"铜鼓县","province":"36","city":"09","area":"26"},{"code":"360981","name":"丰城市","province":"36","city":"09","area":"81"},{"code":"360982","name":"樟树市","province":"36","city":"09","area":"82"},{"code":"360983","name":"高安市","province":"36","city":"09","area":"83"},{"code":"361002","name":"临川区","province":"36","city":"10","area":"02"},{"code":"361003","name":"东乡区","province":"36","city":"10","area":"03"},{"code":"361021","name":"南城县","province":"36","city":"10","area":"21"},{"code":"361022","name":"黎川县","province":"36","city":"10","area":"22"},{"code":"361023","name":"南丰县","province":"36","city":"10","area":"23"},{"code":"361024","name":"崇仁县","province":"36","city":"10","area":"24"},{"code":"361025","name":"乐安县","province":"36","city":"10","area":"25"},{"code":"361026","name":"宜黄县","province":"36","city":"10","area":"26"},{"code":"361027","name":"金溪县","province":"36","city":"10","area":"27"},{"code":"361028","name":"资溪县","province":"36","city":"10","area":"28"},{"code":"361030","name":"广昌县","province":"36","city":"10","area":"30"},{"code":"361102","name":"信州区","province":"36","city":"11","area":"02"},{"code":"361103","name":"广丰区","province":"36","city":"11","area":"03"},{"code":"361104","name":"广信区","province":"36","city":"11","area":"04"},{"code":"361123","name":"玉山县","province":"36","city":"11","area":"23"},{"code":"361124","name":"铅山县","province":"36","city":"11","area":"24"},{"code":"361125","name":"横峰县","province":"36","city":"11","area":"25"},{"code":"361126","name":"弋阳县","province":"36","city":"11","area":"26"},{"code":"361127","name":"余干县","province":"36","city":"11","area":"27"},{"code":"361128","name":"鄱阳县","province":"36","city":"11","area":"28"},{"code":"361129","name":"万年县","province":"36","city":"11","area":"29"},{"code":"361130","name":"婺源县","province":"36","city":"11","area":"30"},{"code":"361181","name":"德兴市","province":"36","city":"11","area":"81"},{"code":"370102","name":"历下区","province":"37","city":"01","area":"02"},{"code":"370103","name":"市中区","province":"37","city":"01","area":"03"},{"code":"370104","name":"槐荫区","province":"37","city":"01","area":"04"},{"code":"370105","name":"天桥区","province":"37","city":"01","area":"05"},{"code":"370112","name":"历城区","province":"37","city":"01","area":"12"},{"code":"370113","name":"长清区","province":"37","city":"01","area":"13"},{"code":"370114","name":"章丘区","province":"37","city":"01","area":"14"},{"code":"370115","name":"济阳区","province":"37","city":"01","area":"15"},{"code":"370116","name":"莱芜区","province":"37","city":"01","area":"16"},{"code":"370117","name":"钢城区","province":"37","city":"01","area":"17"},{"code":"370124","name":"平阴县","province":"37","city":"01","area":"24"},{"code":"370126","name":"商河县","province":"37","city":"01","area":"26"},{"code":"370202","name":"市南区","province":"37","city":"02","area":"02"},{"code":"370203","name":"市北区","province":"37","city":"02","area":"03"},{"code":"370211","name":"黄岛区","province":"37","city":"02","area":"11"},{"code":"370212","name":"崂山区","province":"37","city":"02","area":"12"},{"code":"370213","name":"李沧区","province":"37","city":"02","area":"13"},{"code":"370214","name":"城阳区","province":"37","city":"02","area":"14"},{"code":"370215","name":"即墨区","province":"37","city":"02","area":"15"},{"code":"370281","name":"胶州市","province":"37","city":"02","area":"81"},{"code":"370283","name":"平度市","province":"37","city":"02","area":"83"},{"code":"370285","name":"莱西市","province":"37","city":"02","area":"85"},{"code":"370302","name":"淄川区","province":"37","city":"03","area":"02"},{"code":"370303","name":"张店区","province":"37","city":"03","area":"03"},{"code":"370304","name":"博山区","province":"37","city":"03","area":"04"},{"code":"370305","name":"临淄区","province":"37","city":"03","area":"05"},{"code":"370306","name":"周村区","province":"37","city":"03","area":"06"},{"code":"370321","name":"桓台县","province":"37","city":"03","area":"21"},{"code":"370322","name":"高青县","province":"37","city":"03","area":"22"},{"code":"370323","name":"沂源县","province":"37","city":"03","area":"23"},{"code":"370402","name":"市中区","province":"37","city":"04","area":"02"},{"code":"370403","name":"薛城区","province":"37","city":"04","area":"03"},{"code":"370404","name":"峄城区","province":"37","city":"04","area":"04"},{"code":"370405","name":"台儿庄区","province":"37","city":"04","area":"05"},{"code":"370406","name":"山亭区","province":"37","city":"04","area":"06"},{"code":"370481","name":"滕州市","province":"37","city":"04","area":"81"},{"code":"370502","name":"东营区","province":"37","city":"05","area":"02"},{"code":"370503","name":"河口区","province":"37","city":"05","area":"03"},{"code":"370505","name":"垦利区","province":"37","city":"05","area":"05"},{"code":"370522","name":"利津县","province":"37","city":"05","area":"22"},{"code":"370523","name":"广饶县","province":"37","city":"05","area":"23"},{"code":"370602","name":"芝罘区","province":"37","city":"06","area":"02"},{"code":"370611","name":"福山区","province":"37","city":"06","area":"11"},{"code":"370612","name":"牟平区","province":"37","city":"06","area":"12"},{"code":"370613","name":"莱山区","province":"37","city":"06","area":"13"},{"code":"370614","name":"蓬莱区","province":"37","city":"06","area":"14"},{"code":"370681","name":"龙口市","province":"37","city":"06","area":"81"},{"code":"370682","name":"莱阳市","province":"37","city":"06","area":"82"},{"code":"370683","name":"莱州市","province":"37","city":"06","area":"83"},{"code":"370685","name":"招远市","province":"37","city":"06","area":"85"},{"code":"370686","name":"栖霞市","province":"37","city":"06","area":"86"},{"code":"370687","name":"海阳市","province":"37","city":"06","area":"87"},{"code":"370702","name":"潍城区","province":"37","city":"07","area":"02"},{"code":"370703","name":"寒亭区","province":"37","city":"07","area":"03"},{"code":"370704","name":"坊子区","province":"37","city":"07","area":"04"},{"code":"370705","name":"奎文区","province":"37","city":"07","area":"05"},{"code":"370724","name":"临朐县","province":"37","city":"07","area":"24"},{"code":"370725","name":"昌乐县","province":"37","city":"07","area":"25"},{"code":"370781","name":"青州市","province":"37","city":"07","area":"81"},{"code":"370782","name":"诸城市","province":"37","city":"07","area":"82"},{"code":"370783","name":"寿光市","province":"37","city":"07","area":"83"},{"code":"370784","name":"安丘市","province":"37","city":"07","area":"84"},{"code":"370785","name":"高密市","province":"37","city":"07","area":"85"},{"code":"370786","name":"昌邑市","province":"37","city":"07","area":"86"},{"code":"370811","name":"任城区","province":"37","city":"08","area":"11"},{"code":"370812","name":"兖州区","province":"37","city":"08","area":"12"},{"code":"370826","name":"微山县","province":"37","city":"08","area":"26"},{"code":"370827","name":"鱼台县","province":"37","city":"08","area":"27"},{"code":"370828","name":"金乡县","province":"37","city":"08","area":"28"},{"code":"370829","name":"嘉祥县","province":"37","city":"08","area":"29"},{"code":"370830","name":"汶上县","province":"37","city":"08","area":"30"},{"code":"370831","name":"泗水县","province":"37","city":"08","area":"31"},{"code":"370832","name":"梁山县","province":"37","city":"08","area":"32"},{"code":"370881","name":"曲阜市","province":"37","city":"08","area":"81"},{"code":"370883","name":"邹城市","province":"37","city":"08","area":"83"},{"code":"370902","name":"泰山区","province":"37","city":"09","area":"02"},{"code":"370911","name":"岱岳区","province":"37","city":"09","area":"11"},{"code":"370921","name":"宁阳县","province":"37","city":"09","area":"21"},{"code":"370923","name":"东平县","province":"37","city":"09","area":"23"},{"code":"370982","name":"新泰市","province":"37","city":"09","area":"82"},{"code":"370983","name":"肥城市","province":"37","city":"09","area":"83"},{"code":"371002","name":"环翠区","province":"37","city":"10","area":"02"},{"code":"371003","name":"文登区","province":"37","city":"10","area":"03"},{"code":"371082","name":"荣成市","province":"37","city":"10","area":"82"},{"code":"371083","name":"乳山市","province":"37","city":"10","area":"83"},{"code":"371102","name":"东港区","province":"37","city":"11","area":"02"},{"code":"371103","name":"岚山区","province":"37","city":"11","area":"03"},{"code":"371121","name":"五莲县","province":"37","city":"11","area":"21"},{"code":"371122","name":"莒县","province":"37","city":"11","area":"22"},{"code":"371302","name":"兰山区","province":"37","city":"13","area":"02"},{"code":"371311","name":"罗庄区","province":"37","city":"13","area":"11"},{"code":"371312","name":"河东区","province":"37","city":"13","area":"12"},{"code":"371321","name":"沂南县","province":"37","city":"13","area":"21"},{"code":"371322","name":"郯城县","province":"37","city":"13","area":"22"},{"code":"371323","name":"沂水县","province":"37","city":"13","area":"23"},{"code":"371324","name":"兰陵县","province":"37","city":"13","area":"24"},{"code":"371325","name":"费县","province":"37","city":"13","area":"25"},{"code":"371326","name":"平邑县","province":"37","city":"13","area":"26"},{"code":"371327","name":"莒南县","province":"37","city":"13","area":"27"},{"code":"371328","name":"蒙阴县","province":"37","city":"13","area":"28"},{"code":"371329","name":"临沭县","province":"37","city":"13","area":"29"},{"code":"371402","name":"德城区","province":"37","city":"14","area":"02"},{"code":"371403","name":"陵城区","province":"37","city":"14","area":"03"},{"code":"371422","name":"宁津县","province":"37","city":"14","area":"22"},{"code":"371423","name":"庆云县","province":"37","city":"14","area":"23"},{"code":"371424","name":"临邑县","province":"37","city":"14","area":"24"},{"code":"371425","name":"齐河县","province":"37","city":"14","area":"25"},{"code":"371426","name":"平原县","province":"37","city":"14","area":"26"},{"code":"371427","name":"夏津县","province":"37","city":"14","area":"27"},{"code":"371428","name":"武城县","province":"37","city":"14","area":"28"},{"code":"371481","name":"乐陵市","province":"37","city":"14","area":"81"},{"code":"371482","name":"禹城市","province":"37","city":"14","area":"82"},{"code":"371502","name":"东昌府区","province":"37","city":"15","area":"02"},{"code":"371503","name":"茌平区","province":"37","city":"15","area":"03"},{"code":"371521","name":"阳谷县","province":"37","city":"15","area":"21"},{"code":"371522","name":"莘县","province":"37","city":"15","area":"22"},{"code":"371524","name":"东阿县","province":"37","city":"15","area":"24"},{"code":"371525","name":"冠县","province":"37","city":"15","area":"25"},{"code":"371526","name":"高唐县","province":"37","city":"15","area":"26"},{"code":"371581","name":"临清市","province":"37","city":"15","area":"81"},{"code":"371602","name":"滨城区","province":"37","city":"16","area":"02"},{"code":"371603","name":"沾化区","province":"37","city":"16","area":"03"},{"code":"371621","name":"惠民县","province":"37","city":"16","area":"21"},{"code":"371622","name":"阳信县","province":"37","city":"16","area":"22"},{"code":"371623","name":"无棣县","province":"37","city":"16","area":"23"},{"code":"371625","name":"博兴县","province":"37","city":"16","area":"25"},{"code":"371681","name":"邹平市","province":"37","city":"16","area":"81"},{"code":"371702","name":"牡丹区","province":"37","city":"17","area":"02"},{"code":"371703","name":"定陶区","province":"37","city":"17","area":"03"},{"code":"371721","name":"曹县","province":"37","city":"17","area":"21"},{"code":"371722","name":"单县","province":"37","city":"17","area":"22"},{"code":"371723","name":"成武县","province":"37","city":"17","area":"23"},{"code":"371724","name":"巨野县","province":"37","city":"17","area":"24"},{"code":"371725","name":"郓城县","province":"37","city":"17","area":"25"},{"code":"371726","name":"鄄城县","province":"37","city":"17","area":"26"},{"code":"371728","name":"东明县","province":"37","city":"17","area":"28"},{"code":"410102","name":"中原区","province":"41","city":"01","area":"02"},{"code":"410103","name":"二七区","province":"41","city":"01","area":"03"},{"code":"410104","name":"管城回族区","province":"41","city":"01","area":"04"},{"code":"410105","name":"金水区","province":"41","city":"01","area":"05"},{"code":"410106","name":"上街区","province":"41","city":"01","area":"06"},{"code":"410108","name":"惠济区","province":"41","city":"01","area":"08"},{"code":"410122","name":"中牟县","province":"41","city":"01","area":"22"},{"code":"410181","name":"巩义市","province":"41","city":"01","area":"81"},{"code":"410182","name":"荥阳市","province":"41","city":"01","area":"82"},{"code":"410183","name":"新密市","province":"41","city":"01","area":"83"},{"code":"410184","name":"新郑市","province":"41","city":"01","area":"84"},{"code":"410185","name":"登封市","province":"41","city":"01","area":"85"},{"code":"410202","name":"龙亭区","province":"41","city":"02","area":"02"},{"code":"410203","name":"顺河回族区","province":"41","city":"02","area":"03"},{"code":"410204","name":"鼓楼区","province":"41","city":"02","area":"04"},{"code":"410205","name":"禹王台区","province":"41","city":"02","area":"05"},{"code":"410212","name":"祥符区","province":"41","city":"02","area":"12"},{"code":"410221","name":"杞县","province":"41","city":"02","area":"21"},{"code":"410222","name":"通许县","province":"41","city":"02","area":"22"},{"code":"410223","name":"尉氏县","province":"41","city":"02","area":"23"},{"code":"410225","name":"兰考县","province":"41","city":"02","area":"25"},{"code":"410302","name":"老城区","province":"41","city":"03","area":"02"},{"code":"410303","name":"西工区","province":"41","city":"03","area":"03"},{"code":"410304","name":"瀍河回族区","province":"41","city":"03","area":"04"},{"code":"410305","name":"涧西区","province":"41","city":"03","area":"05"},{"code":"410306","name":"吉利区","province":"41","city":"03","area":"06"},{"code":"410311","name":"洛龙区","province":"41","city":"03","area":"11"},{"code":"410322","name":"孟津县","province":"41","city":"03","area":"22"},{"code":"410323","name":"新安县","province":"41","city":"03","area":"23"},{"code":"410324","name":"栾川县","province":"41","city":"03","area":"24"},{"code":"410325","name":"嵩县","province":"41","city":"03","area":"25"},{"code":"410326","name":"汝阳县","province":"41","city":"03","area":"26"},{"code":"410327","name":"宜阳县","province":"41","city":"03","area":"27"},{"code":"410328","name":"洛宁县","province":"41","city":"03","area":"28"},{"code":"410329","name":"伊川县","province":"41","city":"03","area":"29"},{"code":"410381","name":"偃师市","province":"41","city":"03","area":"81"},{"code":"410402","name":"新华区","province":"41","city":"04","area":"02"},{"code":"410403","name":"卫东区","province":"41","city":"04","area":"03"},{"code":"410404","name":"石龙区","province":"41","city":"04","area":"04"},{"code":"410411","name":"湛河区","province":"41","city":"04","area":"11"},{"code":"410421","name":"宝丰县","province":"41","city":"04","area":"21"},{"code":"410422","name":"叶县","province":"41","city":"04","area":"22"},{"code":"410423","name":"鲁山县","province":"41","city":"04","area":"23"},{"code":"410425","name":"郏县","province":"41","city":"04","area":"25"},{"code":"410481","name":"舞钢市","province":"41","city":"04","area":"81"},{"code":"410482","name":"汝州市","province":"41","city":"04","area":"82"},{"code":"410502","name":"文峰区","province":"41","city":"05","area":"02"},{"code":"410503","name":"北关区","province":"41","city":"05","area":"03"},{"code":"410505","name":"殷都区","province":"41","city":"05","area":"05"},{"code":"410506","name":"龙安区","province":"41","city":"05","area":"06"},{"code":"410522","name":"安阳县","province":"41","city":"05","area":"22"},{"code":"410523","name":"汤阴县","province":"41","city":"05","area":"23"},{"code":"410526","name":"滑县","province":"41","city":"05","area":"26"},{"code":"410527","name":"内黄县","province":"41","city":"05","area":"27"},{"code":"410581","name":"林州市","province":"41","city":"05","area":"81"},{"code":"410602","name":"鹤山区","province":"41","city":"06","area":"02"},{"code":"410603","name":"山城区","province":"41","city":"06","area":"03"},{"code":"410611","name":"淇滨区","province":"41","city":"06","area":"11"},{"code":"410621","name":"浚县","province":"41","city":"06","area":"21"},{"code":"410622","name":"淇县","province":"41","city":"06","area":"22"},{"code":"410702","name":"红旗区","province":"41","city":"07","area":"02"},{"code":"410703","name":"卫滨区","province":"41","city":"07","area":"03"},{"code":"410704","name":"凤泉区","province":"41","city":"07","area":"04"},{"code":"410711","name":"牧野区","province":"41","city":"07","area":"11"},{"code":"410721","name":"新乡县","province":"41","city":"07","area":"21"},{"code":"410724","name":"获嘉县","province":"41","city":"07","area":"24"},{"code":"410725","name":"原阳县","province":"41","city":"07","area":"25"},{"code":"410726","name":"延津县","province":"41","city":"07","area":"26"},{"code":"410727","name":"封丘县","province":"41","city":"07","area":"27"},{"code":"410781","name":"卫辉市","province":"41","city":"07","area":"81"},{"code":"410782","name":"辉县市","province":"41","city":"07","area":"82"},{"code":"410783","name":"长垣市","province":"41","city":"07","area":"83"},{"code":"410802","name":"解放区","province":"41","city":"08","area":"02"},{"code":"410803","name":"中站区","province":"41","city":"08","area":"03"},{"code":"410804","name":"马村区","province":"41","city":"08","area":"04"},{"code":"410811","name":"山阳区","province":"41","city":"08","area":"11"},{"code":"410821","name":"修武县","province":"41","city":"08","area":"21"},{"code":"410822","name":"博爱县","province":"41","city":"08","area":"22"},{"code":"410823","name":"武陟县","province":"41","city":"08","area":"23"},{"code":"410825","name":"温县","province":"41","city":"08","area":"25"},{"code":"410882","name":"沁阳市","province":"41","city":"08","area":"82"},{"code":"410883","name":"孟州市","province":"41","city":"08","area":"83"},{"code":"410902","name":"华龙区","province":"41","city":"09","area":"02"},{"code":"410922","name":"清丰县","province":"41","city":"09","area":"22"},{"code":"410923","name":"南乐县","province":"41","city":"09","area":"23"},{"code":"410926","name":"范县","province":"41","city":"09","area":"26"},{"code":"410927","name":"台前县","province":"41","city":"09","area":"27"},{"code":"410928","name":"濮阳县","province":"41","city":"09","area":"28"},{"code":"411002","name":"魏都区","province":"41","city":"10","area":"02"},{"code":"411003","name":"建安区","province":"41","city":"10","area":"03"},{"code":"411024","name":"鄢陵县","province":"41","city":"10","area":"24"},{"code":"411025","name":"襄城县","province":"41","city":"10","area":"25"},{"code":"411081","name":"禹州市","province":"41","city":"10","area":"81"},{"code":"411082","name":"长葛市","province":"41","city":"10","area":"82"},{"code":"411102","name":"源汇区","province":"41","city":"11","area":"02"},{"code":"411103","name":"郾城区","province":"41","city":"11","area":"03"},{"code":"411104","name":"召陵区","province":"41","city":"11","area":"04"},{"code":"411121","name":"舞阳县","province":"41","city":"11","area":"21"},{"code":"411122","name":"临颍县","province":"41","city":"11","area":"22"},{"code":"411202","name":"湖滨区","province":"41","city":"12","area":"02"},{"code":"411203","name":"陕州区","province":"41","city":"12","area":"03"},{"code":"411221","name":"渑池县","province":"41","city":"12","area":"21"},{"code":"411224","name":"卢氏县","province":"41","city":"12","area":"24"},{"code":"411281","name":"义马市","province":"41","city":"12","area":"81"},{"code":"411282","name":"灵宝市","province":"41","city":"12","area":"82"},{"code":"411302","name":"宛城区","province":"41","city":"13","area":"02"},{"code":"411303","name":"卧龙区","province":"41","city":"13","area":"03"},{"code":"411321","name":"南召县","province":"41","city":"13","area":"21"},{"code":"411322","name":"方城县","province":"41","city":"13","area":"22"},{"code":"411323","name":"西峡县","province":"41","city":"13","area":"23"},{"code":"411324","name":"镇平县","province":"41","city":"13","area":"24"},{"code":"411325","name":"内乡县","province":"41","city":"13","area":"25"},{"code":"411326","name":"淅川县","province":"41","city":"13","area":"26"},{"code":"411327","name":"社旗县","province":"41","city":"13","area":"27"},{"code":"411328","name":"唐河县","province":"41","city":"13","area":"28"},{"code":"411329","name":"新野县","province":"41","city":"13","area":"29"},{"code":"411330","name":"桐柏县","province":"41","city":"13","area":"30"},{"code":"411381","name":"邓州市","province":"41","city":"13","area":"81"},{"code":"411402","name":"梁园区","province":"41","city":"14","area":"02"},{"code":"411403","name":"睢阳区","province":"41","city":"14","area":"03"},{"code":"411421","name":"民权县","province":"41","city":"14","area":"21"},{"code":"411422","name":"睢县","province":"41","city":"14","area":"22"},{"code":"411423","name":"宁陵县","province":"41","city":"14","area":"23"},{"code":"411424","name":"柘城县","province":"41","city":"14","area":"24"},{"code":"411425","name":"虞城县","province":"41","city":"14","area":"25"},{"code":"411426","name":"夏邑县","province":"41","city":"14","area":"26"},{"code":"411481","name":"永城市","province":"41","city":"14","area":"81"},{"code":"411502","name":"浉河区","province":"41","city":"15","area":"02"},{"code":"411503","name":"平桥区","province":"41","city":"15","area":"03"},{"code":"411521","name":"罗山县","province":"41","city":"15","area":"21"},{"code":"411522","name":"光山县","province":"41","city":"15","area":"22"},{"code":"411523","name":"新县","province":"41","city":"15","area":"23"},{"code":"411524","name":"商城县","province":"41","city":"15","area":"24"},{"code":"411525","name":"固始县","province":"41","city":"15","area":"25"},{"code":"411526","name":"潢川县","province":"41","city":"15","area":"26"},{"code":"411527","name":"淮滨县","province":"41","city":"15","area":"27"},{"code":"411528","name":"息县","province":"41","city":"15","area":"28"},{"code":"411602","name":"川汇区","province":"41","city":"16","area":"02"},{"code":"411603","name":"淮阳区","province":"41","city":"16","area":"03"},{"code":"411621","name":"扶沟县","province":"41","city":"16","area":"21"},{"code":"411622","name":"西华县","province":"41","city":"16","area":"22"},{"code":"411623","name":"商水县","province":"41","city":"16","area":"23"},{"code":"411624","name":"沈丘县","province":"41","city":"16","area":"24"},{"code":"411625","name":"郸城县","province":"41","city":"16","area":"25"},{"code":"411627","name":"太康县","province":"41","city":"16","area":"27"},{"code":"411628","name":"鹿邑县","province":"41","city":"16","area":"28"},{"code":"411681","name":"项城市","province":"41","city":"16","area":"81"},{"code":"411702","name":"驿城区","province":"41","city":"17","area":"02"},{"code":"411721","name":"西平县","province":"41","city":"17","area":"21"},{"code":"411722","name":"上蔡县","province":"41","city":"17","area":"22"},{"code":"411723","name":"平舆县","province":"41","city":"17","area":"23"},{"code":"411724","name":"正阳县","province":"41","city":"17","area":"24"},{"code":"411725","name":"确山县","province":"41","city":"17","area":"25"},{"code":"411726","name":"泌阳县","province":"41","city":"17","area":"26"},{"code":"411727","name":"汝南县","province":"41","city":"17","area":"27"},{"code":"411728","name":"遂平县","province":"41","city":"17","area":"28"},{"code":"411729","name":"新蔡县","province":"41","city":"17","area":"29"},{"code":"419001","name":"济源市","province":"41","city":"90","area":"01"},{"code":"420102","name":"江岸区","province":"42","city":"01","area":"02"},{"code":"420103","name":"江汉区","province":"42","city":"01","area":"03"},{"code":"420104","name":"硚口区","province":"42","city":"01","area":"04"},{"code":"420105","name":"汉阳区","province":"42","city":"01","area":"05"},{"code":"420106","name":"武昌区","province":"42","city":"01","area":"06"},{"code":"420107","name":"青山区","province":"42","city":"01","area":"07"},{"code":"420111","name":"洪山区","province":"42","city":"01","area":"11"},{"code":"420112","name":"东西湖区","province":"42","city":"01","area":"12"},{"code":"420113","name":"汉南区","province":"42","city":"01","area":"13"},{"code":"420114","name":"蔡甸区","province":"42","city":"01","area":"14"},{"code":"420115","name":"江夏区","province":"42","city":"01","area":"15"},{"code":"420116","name":"黄陂区","province":"42","city":"01","area":"16"},{"code":"420117","name":"新洲区","province":"42","city":"01","area":"17"},{"code":"420202","name":"黄石港区","province":"42","city":"02","area":"02"},{"code":"420203","name":"西塞山区","province":"42","city":"02","area":"03"},{"code":"420204","name":"下陆区","province":"42","city":"02","area":"04"},{"code":"420205","name":"铁山区","province":"42","city":"02","area":"05"},{"code":"420222","name":"阳新县","province":"42","city":"02","area":"22"},{"code":"420281","name":"大冶市","province":"42","city":"02","area":"81"},{"code":"420302","name":"茅箭区","province":"42","city":"03","area":"02"},{"code":"420303","name":"张湾区","province":"42","city":"03","area":"03"},{"code":"420304","name":"郧阳区","province":"42","city":"03","area":"04"},{"code":"420322","name":"郧西县","province":"42","city":"03","area":"22"},{"code":"420323","name":"竹山县","province":"42","city":"03","area":"23"},{"code":"420324","name":"竹溪县","province":"42","city":"03","area":"24"},{"code":"420325","name":"房县","province":"42","city":"03","area":"25"},{"code":"420381","name":"丹江口市","province":"42","city":"03","area":"81"},{"code":"420502","name":"西陵区","province":"42","city":"05","area":"02"},{"code":"420503","name":"伍家岗区","province":"42","city":"05","area":"03"},{"code":"420504","name":"点军区","province":"42","city":"05","area":"04"},{"code":"420505","name":"猇亭区","province":"42","city":"05","area":"05"},{"code":"420506","name":"夷陵区","province":"42","city":"05","area":"06"},{"code":"420525","name":"远安县","province":"42","city":"05","area":"25"},{"code":"420526","name":"兴山县","province":"42","city":"05","area":"26"},{"code":"420527","name":"秭归县","province":"42","city":"05","area":"27"},{"code":"420528","name":"长阳土家族自治县","province":"42","city":"05","area":"28"},{"code":"420529","name":"五峰土家族自治县","province":"42","city":"05","area":"29"},{"code":"420581","name":"宜都市","province":"42","city":"05","area":"81"},{"code":"420582","name":"当阳市","province":"42","city":"05","area":"82"},{"code":"420583","name":"枝江市","province":"42","city":"05","area":"83"},{"code":"420602","name":"襄城区","province":"42","city":"06","area":"02"},{"code":"420606","name":"樊城区","province":"42","city":"06","area":"06"},{"code":"420607","name":"襄州区","province":"42","city":"06","area":"07"},{"code":"420624","name":"南漳县","province":"42","city":"06","area":"24"},{"code":"420625","name":"谷城县","province":"42","city":"06","area":"25"},{"code":"420626","name":"保康县","province":"42","city":"06","area":"26"},{"code":"420682","name":"老河口市","province":"42","city":"06","area":"82"},{"code":"420683","name":"枣阳市","province":"42","city":"06","area":"83"},{"code":"420684","name":"宜城市","province":"42","city":"06","area":"84"},{"code":"420702","name":"梁子湖区","province":"42","city":"07","area":"02"},{"code":"420703","name":"华容区","province":"42","city":"07","area":"03"},{"code":"420704","name":"鄂城区","province":"42","city":"07","area":"04"},{"code":"420802","name":"东宝区","province":"42","city":"08","area":"02"},{"code":"420804","name":"掇刀区","province":"42","city":"08","area":"04"},{"code":"420822","name":"沙洋县","province":"42","city":"08","area":"22"},{"code":"420881","name":"钟祥市","province":"42","city":"08","area":"81"},{"code":"420882","name":"京山市","province":"42","city":"08","area":"82"},{"code":"420902","name":"孝南区","province":"42","city":"09","area":"02"},{"code":"420921","name":"孝昌县","province":"42","city":"09","area":"21"},{"code":"420922","name":"大悟县","province":"42","city":"09","area":"22"},{"code":"420923","name":"云梦县","province":"42","city":"09","area":"23"},{"code":"420981","name":"应城市","province":"42","city":"09","area":"81"},{"code":"420982","name":"安陆市","province":"42","city":"09","area":"82"},{"code":"420984","name":"汉川市","province":"42","city":"09","area":"84"},{"code":"421002","name":"沙市区","province":"42","city":"10","area":"02"},{"code":"421003","name":"荆州区","province":"42","city":"10","area":"03"},{"code":"421022","name":"公安县","province":"42","city":"10","area":"22"},{"code":"421024","name":"江陵县","province":"42","city":"10","area":"24"},{"code":"421081","name":"石首市","province":"42","city":"10","area":"81"},{"code":"421083","name":"洪湖市","province":"42","city":"10","area":"83"},{"code":"421087","name":"松滋市","province":"42","city":"10","area":"87"},{"code":"421088","name":"监利市","province":"42","city":"10","area":"88"},{"code":"421102","name":"黄州区","province":"42","city":"11","area":"02"},{"code":"421121","name":"团风县","province":"42","city":"11","area":"21"},{"code":"421122","name":"红安县","province":"42","city":"11","area":"22"},{"code":"421123","name":"罗田县","province":"42","city":"11","area":"23"},{"code":"421124","name":"英山县","province":"42","city":"11","area":"24"},{"code":"421125","name":"浠水县","province":"42","city":"11","area":"25"},{"code":"421126","name":"蕲春县","province":"42","city":"11","area":"26"},{"code":"421127","name":"黄梅县","province":"42","city":"11","area":"27"},{"code":"421181","name":"麻城市","province":"42","city":"11","area":"81"},{"code":"421182","name":"武穴市","province":"42","city":"11","area":"82"},{"code":"421202","name":"咸安区","province":"42","city":"12","area":"02"},{"code":"421221","name":"嘉鱼县","province":"42","city":"12","area":"21"},{"code":"421222","name":"通城县","province":"42","city":"12","area":"22"},{"code":"421223","name":"崇阳县","province":"42","city":"12","area":"23"},{"code":"421224","name":"通山县","province":"42","city":"12","area":"24"},{"code":"421281","name":"赤壁市","province":"42","city":"12","area":"81"},{"code":"421303","name":"曾都区","province":"42","city":"13","area":"03"},{"code":"421321","name":"随县","province":"42","city":"13","area":"21"},{"code":"421381","name":"广水市","province":"42","city":"13","area":"81"},{"code":"422801","name":"恩施市","province":"42","city":"28","area":"01"},{"code":"422802","name":"利川市","province":"42","city":"28","area":"02"},{"code":"422822","name":"建始县","province":"42","city":"28","area":"22"},{"code":"422823","name":"巴东县","province":"42","city":"28","area":"23"},{"code":"422825","name":"宣恩县","province":"42","city":"28","area":"25"},{"code":"422826","name":"咸丰县","province":"42","city":"28","area":"26"},{"code":"422827","name":"来凤县","province":"42","city":"28","area":"27"},{"code":"422828","name":"鹤峰县","province":"42","city":"28","area":"28"},{"code":"429004","name":"仙桃市","province":"42","city":"90","area":"04"},{"code":"429005","name":"潜江市","province":"42","city":"90","area":"05"},{"code":"429006","name":"天门市","province":"42","city":"90","area":"06"},{"code":"429021","name":"神农架林区","province":"42","city":"90","area":"21"},{"code":"430102","name":"芙蓉区","province":"43","city":"01","area":"02"},{"code":"430103","name":"天心区","province":"43","city":"01","area":"03"},{"code":"430104","name":"岳麓区","province":"43","city":"01","area":"04"},{"code":"430105","name":"开福区","province":"43","city":"01","area":"05"},{"code":"430111","name":"雨花区","province":"43","city":"01","area":"11"},{"code":"430112","name":"望城区","province":"43","city":"01","area":"12"},{"code":"430121","name":"长沙县","province":"43","city":"01","area":"21"},{"code":"430181","name":"浏阳市","province":"43","city":"01","area":"81"},{"code":"430182","name":"宁乡市","province":"43","city":"01","area":"82"},{"code":"430202","name":"荷塘区","province":"43","city":"02","area":"02"},{"code":"430203","name":"芦淞区","province":"43","city":"02","area":"03"},{"code":"430204","name":"石峰区","province":"43","city":"02","area":"04"},{"code":"430211","name":"天元区","province":"43","city":"02","area":"11"},{"code":"430212","name":"渌口区","province":"43","city":"02","area":"12"},{"code":"430223","name":"攸县","province":"43","city":"02","area":"23"},{"code":"430224","name":"茶陵县","province":"43","city":"02","area":"24"},{"code":"430225","name":"炎陵县","province":"43","city":"02","area":"25"},{"code":"430281","name":"醴陵市","province":"43","city":"02","area":"81"},{"code":"430302","name":"雨湖区","province":"43","city":"03","area":"02"},{"code":"430304","name":"岳塘区","province":"43","city":"03","area":"04"},{"code":"430321","name":"湘潭县","province":"43","city":"03","area":"21"},{"code":"430381","name":"湘乡市","province":"43","city":"03","area":"81"},{"code":"430382","name":"韶山市","province":"43","city":"03","area":"82"},{"code":"430405","name":"珠晖区","province":"43","city":"04","area":"05"},{"code":"430406","name":"雁峰区","province":"43","city":"04","area":"06"},{"code":"430407","name":"石鼓区","province":"43","city":"04","area":"07"},{"code":"430408","name":"蒸湘区","province":"43","city":"04","area":"08"},{"code":"430412","name":"南岳区","province":"43","city":"04","area":"12"},{"code":"430421","name":"衡阳县","province":"43","city":"04","area":"21"},{"code":"430422","name":"衡南县","province":"43","city":"04","area":"22"},{"code":"430423","name":"衡山县","province":"43","city":"04","area":"23"},{"code":"430424","name":"衡东县","province":"43","city":"04","area":"24"},{"code":"430426","name":"祁东县","province":"43","city":"04","area":"26"},{"code":"430481","name":"耒阳市","province":"43","city":"04","area":"81"},{"code":"430482","name":"常宁市","province":"43","city":"04","area":"82"},{"code":"430502","name":"双清区","province":"43","city":"05","area":"02"},{"code":"430503","name":"大祥区","province":"43","city":"05","area":"03"},{"code":"430511","name":"北塔区","province":"43","city":"05","area":"11"},{"code":"430522","name":"新邵县","province":"43","city":"05","area":"22"},{"code":"430523","name":"邵阳县","province":"43","city":"05","area":"23"},{"code":"430524","name":"隆回县","province":"43","city":"05","area":"24"},{"code":"430525","name":"洞口县","province":"43","city":"05","area":"25"},{"code":"430527","name":"绥宁县","province":"43","city":"05","area":"27"},{"code":"430528","name":"新宁县","province":"43","city":"05","area":"28"},{"code":"430529","name":"城步苗族自治县","province":"43","city":"05","area":"29"},{"code":"430581","name":"武冈市","province":"43","city":"05","area":"81"},{"code":"430582","name":"邵东市","province":"43","city":"05","area":"82"},{"code":"430602","name":"岳阳楼区","province":"43","city":"06","area":"02"},{"code":"430603","name":"云溪区","province":"43","city":"06","area":"03"},{"code":"430611","name":"君山区","province":"43","city":"06","area":"11"},{"code":"430621","name":"岳阳县","province":"43","city":"06","area":"21"},{"code":"430623","name":"华容县","province":"43","city":"06","area":"23"},{"code":"430624","name":"湘阴县","province":"43","city":"06","area":"24"},{"code":"430626","name":"平江县","province":"43","city":"06","area":"26"},{"code":"430681","name":"汨罗市","province":"43","city":"06","area":"81"},{"code":"430682","name":"临湘市","province":"43","city":"06","area":"82"},{"code":"430702","name":"武陵区","province":"43","city":"07","area":"02"},{"code":"430703","name":"鼎城区","province":"43","city":"07","area":"03"},{"code":"430721","name":"安乡县","province":"43","city":"07","area":"21"},{"code":"430722","name":"汉寿县","province":"43","city":"07","area":"22"},{"code":"430723","name":"澧县","province":"43","city":"07","area":"23"},{"code":"430724","name":"临澧县","province":"43","city":"07","area":"24"},{"code":"430725","name":"桃源县","province":"43","city":"07","area":"25"},{"code":"430726","name":"石门县","province":"43","city":"07","area":"26"},{"code":"430781","name":"津市市","province":"43","city":"07","area":"81"},{"code":"430802","name":"永定区","province":"43","city":"08","area":"02"},{"code":"430811","name":"武陵源区","province":"43","city":"08","area":"11"},{"code":"430821","name":"慈利县","province":"43","city":"08","area":"21"},{"code":"430822","name":"桑植县","province":"43","city":"08","area":"22"},{"code":"430902","name":"资阳区","province":"43","city":"09","area":"02"},{"code":"430903","name":"赫山区","province":"43","city":"09","area":"03"},{"code":"430921","name":"南县","province":"43","city":"09","area":"21"},{"code":"430922","name":"桃江县","province":"43","city":"09","area":"22"},{"code":"430923","name":"安化县","province":"43","city":"09","area":"23"},{"code":"430981","name":"沅江市","province":"43","city":"09","area":"81"},{"code":"431002","name":"北湖区","province":"43","city":"10","area":"02"},{"code":"431003","name":"苏仙区","province":"43","city":"10","area":"03"},{"code":"431021","name":"桂阳县","province":"43","city":"10","area":"21"},{"code":"431022","name":"宜章县","province":"43","city":"10","area":"22"},{"code":"431023","name":"永兴县","province":"43","city":"10","area":"23"},{"code":"431024","name":"嘉禾县","province":"43","city":"10","area":"24"},{"code":"431025","name":"临武县","province":"43","city":"10","area":"25"},{"code":"431026","name":"汝城县","province":"43","city":"10","area":"26"},{"code":"431027","name":"桂东县","province":"43","city":"10","area":"27"},{"code":"431028","name":"安仁县","province":"43","city":"10","area":"28"},{"code":"431081","name":"资兴市","province":"43","city":"10","area":"81"},{"code":"431102","name":"零陵区","province":"43","city":"11","area":"02"},{"code":"431103","name":"冷水滩区","province":"43","city":"11","area":"03"},{"code":"431121","name":"祁阳县","province":"43","city":"11","area":"21"},{"code":"431122","name":"东安县","province":"43","city":"11","area":"22"},{"code":"431123","name":"双牌县","province":"43","city":"11","area":"23"},{"code":"431124","name":"道县","province":"43","city":"11","area":"24"},{"code":"431125","name":"江永县","province":"43","city":"11","area":"25"},{"code":"431126","name":"宁远县","province":"43","city":"11","area":"26"},{"code":"431127","name":"蓝山县","province":"43","city":"11","area":"27"},{"code":"431128","name":"新田县","province":"43","city":"11","area":"28"},{"code":"431129","name":"江华瑶族自治县","province":"43","city":"11","area":"29"},{"code":"431202","name":"鹤城区","province":"43","city":"12","area":"02"},{"code":"431221","name":"中方县","province":"43","city":"12","area":"21"},{"code":"431222","name":"沅陵县","province":"43","city":"12","area":"22"},{"code":"431223","name":"辰溪县","province":"43","city":"12","area":"23"},{"code":"431224","name":"溆浦县","province":"43","city":"12","area":"24"},{"code":"431225","name":"会同县","province":"43","city":"12","area":"25"},{"code":"431226","name":"麻阳苗族自治县","province":"43","city":"12","area":"26"},{"code":"431227","name":"新晃侗族自治县","province":"43","city":"12","area":"27"},{"code":"431228","name":"芷江侗族自治县","province":"43","city":"12","area":"28"},{"code":"431229","name":"靖州苗族侗族自治县","province":"43","city":"12","area":"29"},{"code":"431230","name":"通道侗族自治县","province":"43","city":"12","area":"30"},{"code":"431281","name":"洪江市","province":"43","city":"12","area":"81"},{"code":"431302","name":"娄星区","province":"43","city":"13","area":"02"},{"code":"431321","name":"双峰县","province":"43","city":"13","area":"21"},{"code":"431322","name":"新化县","province":"43","city":"13","area":"22"},{"code":"431381","name":"冷水江市","province":"43","city":"13","area":"81"},{"code":"431382","name":"涟源市","province":"43","city":"13","area":"82"},{"code":"433101","name":"吉首市","province":"43","city":"31","area":"01"},{"code":"433122","name":"泸溪县","province":"43","city":"31","area":"22"},{"code":"433123","name":"凤凰县","province":"43","city":"31","area":"23"},{"code":"433124","name":"花垣县","province":"43","city":"31","area":"24"},{"code":"433125","name":"保靖县","province":"43","city":"31","area":"25"},{"code":"433126","name":"古丈县","province":"43","city":"31","area":"26"},{"code":"433127","name":"永顺县","province":"43","city":"31","area":"27"},{"code":"433130","name":"龙山县","province":"43","city":"31","area":"30"},{"code":"440103","name":"荔湾区","province":"44","city":"01","area":"03"},{"code":"440104","name":"越秀区","province":"44","city":"01","area":"04"},{"code":"440105","name":"海珠区","province":"44","city":"01","area":"05"},{"code":"440106","name":"天河区","province":"44","city":"01","area":"06"},{"code":"440111","name":"白云区","province":"44","city":"01","area":"11"},{"code":"440112","name":"黄埔区","province":"44","city":"01","area":"12"},{"code":"440113","name":"番禺区","province":"44","city":"01","area":"13"},{"code":"440114","name":"花都区","province":"44","city":"01","area":"14"},{"code":"440115","name":"南沙区","province":"44","city":"01","area":"15"},{"code":"440117","name":"从化区","province":"44","city":"01","area":"17"},{"code":"440118","name":"增城区","province":"44","city":"01","area":"18"},{"code":"440203","name":"武江区","province":"44","city":"02","area":"03"},{"code":"440204","name":"浈江区","province":"44","city":"02","area":"04"},{"code":"440205","name":"曲江区","province":"44","city":"02","area":"05"},{"code":"440222","name":"始兴县","province":"44","city":"02","area":"22"},{"code":"440224","name":"仁化县","province":"44","city":"02","area":"24"},{"code":"440229","name":"翁源县","province":"44","city":"02","area":"29"},{"code":"440232","name":"乳源瑶族自治县","province":"44","city":"02","area":"32"},{"code":"440233","name":"新丰县","province":"44","city":"02","area":"33"},{"code":"440281","name":"乐昌市","province":"44","city":"02","area":"81"},{"code":"440282","name":"南雄市","province":"44","city":"02","area":"82"},{"code":"440303","name":"罗湖区","province":"44","city":"03","area":"03"},{"code":"440304","name":"福田区","province":"44","city":"03","area":"04"},{"code":"440305","name":"南山区","province":"44","city":"03","area":"05"},{"code":"440306","name":"宝安区","province":"44","city":"03","area":"06"},{"code":"440307","name":"龙岗区","province":"44","city":"03","area":"07"},{"code":"440308","name":"盐田区","province":"44","city":"03","area":"08"},{"code":"440309","name":"龙华区","province":"44","city":"03","area":"09"},{"code":"440310","name":"坪山区","province":"44","city":"03","area":"10"},{"code":"440311","name":"光明区","province":"44","city":"03","area":"11"},{"code":"440402","name":"香洲区","province":"44","city":"04","area":"02"},{"code":"440403","name":"斗门区","province":"44","city":"04","area":"03"},{"code":"440404","name":"金湾区","province":"44","city":"04","area":"04"},{"code":"440507","name":"龙湖区","province":"44","city":"05","area":"07"},{"code":"440511","name":"金平区","province":"44","city":"05","area":"11"},{"code":"440512","name":"濠江区","province":"44","city":"05","area":"12"},{"code":"440513","name":"潮阳区","province":"44","city":"05","area":"13"},{"code":"440514","name":"潮南区","province":"44","city":"05","area":"14"},{"code":"440515","name":"澄海区","province":"44","city":"05","area":"15"},{"code":"440523","name":"南澳县","province":"44","city":"05","area":"23"},{"code":"440604","name":"禅城区","province":"44","city":"06","area":"04"},{"code":"440605","name":"南海区","province":"44","city":"06","area":"05"},{"code":"440606","name":"顺德区","province":"44","city":"06","area":"06"},{"code":"440607","name":"三水区","province":"44","city":"06","area":"07"},{"code":"440608","name":"高明区","province":"44","city":"06","area":"08"},{"code":"440703","name":"蓬江区","province":"44","city":"07","area":"03"},{"code":"440704","name":"江海区","province":"44","city":"07","area":"04"},{"code":"440705","name":"新会区","province":"44","city":"07","area":"05"},{"code":"440781","name":"台山市","province":"44","city":"07","area":"81"},{"code":"440783","name":"开平市","province":"44","city":"07","area":"83"},{"code":"440784","name":"鹤山市","province":"44","city":"07","area":"84"},{"code":"440785","name":"恩平市","province":"44","city":"07","area":"85"},{"code":"440802","name":"赤坎区","province":"44","city":"08","area":"02"},{"code":"440803","name":"霞山区","province":"44","city":"08","area":"03"},{"code":"440804","name":"坡头区","province":"44","city":"08","area":"04"},{"code":"440811","name":"麻章区","province":"44","city":"08","area":"11"},{"code":"440823","name":"遂溪县","province":"44","city":"08","area":"23"},{"code":"440825","name":"徐闻县","province":"44","city":"08","area":"25"},{"code":"440881","name":"廉江市","province":"44","city":"08","area":"81"},{"code":"440882","name":"雷州市","province":"44","city":"08","area":"82"},{"code":"440883","name":"吴川市","province":"44","city":"08","area":"83"},{"code":"440902","name":"茂南区","province":"44","city":"09","area":"02"},{"code":"440904","name":"电白区","province":"44","city":"09","area":"04"},{"code":"440981","name":"高州市","province":"44","city":"09","area":"81"},{"code":"440982","name":"化州市","province":"44","city":"09","area":"82"},{"code":"440983","name":"信宜市","province":"44","city":"09","area":"83"},{"code":"441202","name":"端州区","province":"44","city":"12","area":"02"},{"code":"441203","name":"鼎湖区","province":"44","city":"12","area":"03"},{"code":"441204","name":"高要区","province":"44","city":"12","area":"04"},{"code":"441223","name":"广宁县","province":"44","city":"12","area":"23"},{"code":"441224","name":"怀集县","province":"44","city":"12","area":"24"},{"code":"441225","name":"封开县","province":"44","city":"12","area":"25"},{"code":"441226","name":"德庆县","province":"44","city":"12","area":"26"},{"code":"441284","name":"四会市","province":"44","city":"12","area":"84"},{"code":"441302","name":"惠城区","province":"44","city":"13","area":"02"},{"code":"441303","name":"惠阳区","province":"44","city":"13","area":"03"},{"code":"441322","name":"博罗县","province":"44","city":"13","area":"22"},{"code":"441323","name":"惠东县","province":"44","city":"13","area":"23"},{"code":"441324","name":"龙门县","province":"44","city":"13","area":"24"},{"code":"441402","name":"梅江区","province":"44","city":"14","area":"02"},{"code":"441403","name":"梅县区","province":"44","city":"14","area":"03"},{"code":"441422","name":"大埔县","province":"44","city":"14","area":"22"},{"code":"441423","name":"丰顺县","province":"44","city":"14","area":"23"},{"code":"441424","name":"五华县","province":"44","city":"14","area":"24"},{"code":"441426","name":"平远县","province":"44","city":"14","area":"26"},{"code":"441427","name":"蕉岭县","province":"44","city":"14","area":"27"},{"code":"441481","name":"兴宁市","province":"44","city":"14","area":"81"},{"code":"441502","name":"城区","province":"44","city":"15","area":"02"},{"code":"441521","name":"海丰县","province":"44","city":"15","area":"21"},{"code":"441523","name":"陆河县","province":"44","city":"15","area":"23"},{"code":"441581","name":"陆丰市","province":"44","city":"15","area":"81"},{"code":"441602","name":"源城区","province":"44","city":"16","area":"02"},{"code":"441621","name":"紫金县","province":"44","city":"16","area":"21"},{"code":"441622","name":"龙川县","province":"44","city":"16","area":"22"},{"code":"441623","name":"连平县","province":"44","city":"16","area":"23"},{"code":"441624","name":"和平县","province":"44","city":"16","area":"24"},{"code":"441625","name":"东源县","province":"44","city":"16","area":"25"},{"code":"441702","name":"江城区","province":"44","city":"17","area":"02"},{"code":"441704","name":"阳东区","province":"44","city":"17","area":"04"},{"code":"441721","name":"阳西县","province":"44","city":"17","area":"21"},{"code":"441781","name":"阳春市","province":"44","city":"17","area":"81"},{"code":"441802","name":"清城区","province":"44","city":"18","area":"02"},{"code":"441803","name":"清新区","province":"44","city":"18","area":"03"},{"code":"441821","name":"佛冈县","province":"44","city":"18","area":"21"},{"code":"441823","name":"阳山县","province":"44","city":"18","area":"23"},{"code":"441825","name":"连山壮族瑶族自治县","province":"44","city":"18","area":"25"},{"code":"441826","name":"连南瑶族自治县","province":"44","city":"18","area":"26"},{"code":"441881","name":"英德市","province":"44","city":"18","area":"81"},{"code":"441882","name":"连州市","province":"44","city":"18","area":"82"},{"code":"445102","name":"湘桥区","province":"44","city":"51","area":"02"},{"code":"445103","name":"潮安区","province":"44","city":"51","area":"03"},{"code":"445122","name":"饶平县","province":"44","city":"51","area":"22"},{"code":"445202","name":"榕城区","province":"44","city":"52","area":"02"},{"code":"445203","name":"揭东区","province":"44","city":"52","area":"03"},{"code":"445222","name":"揭西县","province":"44","city":"52","area":"22"},{"code":"445224","name":"惠来县","province":"44","city":"52","area":"24"},{"code":"445281","name":"普宁市","province":"44","city":"52","area":"81"},{"code":"445302","name":"云城区","province":"44","city":"53","area":"02"},{"code":"445303","name":"云安区","province":"44","city":"53","area":"03"},{"code":"445321","name":"新兴县","province":"44","city":"53","area":"21"},{"code":"445322","name":"郁南县","province":"44","city":"53","area":"22"},{"code":"445381","name":"罗定市","province":"44","city":"53","area":"81"},{"code":"450102","name":"兴宁区","province":"45","city":"01","area":"02"},{"code":"450103","name":"青秀区","province":"45","city":"01","area":"03"},{"code":"450105","name":"江南区","province":"45","city":"01","area":"05"},{"code":"450107","name":"西乡塘区","province":"45","city":"01","area":"07"},{"code":"450108","name":"良庆区","province":"45","city":"01","area":"08"},{"code":"450109","name":"邕宁区","province":"45","city":"01","area":"09"},{"code":"450110","name":"武鸣区","province":"45","city":"01","area":"10"},{"code":"450123","name":"隆安县","province":"45","city":"01","area":"23"},{"code":"450124","name":"马山县","province":"45","city":"01","area":"24"},{"code":"450125","name":"上林县","province":"45","city":"01","area":"25"},{"code":"450126","name":"宾阳县","province":"45","city":"01","area":"26"},{"code":"450127","name":"横县","province":"45","city":"01","area":"27"},{"code":"450202","name":"城中区","province":"45","city":"02","area":"02"},{"code":"450203","name":"鱼峰区","province":"45","city":"02","area":"03"},{"code":"450204","name":"柳南区","province":"45","city":"02","area":"04"},{"code":"450205","name":"柳北区","province":"45","city":"02","area":"05"},{"code":"450206","name":"柳江区","province":"45","city":"02","area":"06"},{"code":"450222","name":"柳城县","province":"45","city":"02","area":"22"},{"code":"450223","name":"鹿寨县","province":"45","city":"02","area":"23"},{"code":"450224","name":"融安县","province":"45","city":"02","area":"24"},{"code":"450225","name":"融水苗族自治县","province":"45","city":"02","area":"25"},{"code":"450226","name":"三江侗族自治县","province":"45","city":"02","area":"26"},{"code":"450302","name":"秀峰区","province":"45","city":"03","area":"02"},{"code":"450303","name":"叠彩区","province":"45","city":"03","area":"03"},{"code":"450304","name":"象山区","province":"45","city":"03","area":"04"},{"code":"450305","name":"七星区","province":"45","city":"03","area":"05"},{"code":"450311","name":"雁山区","province":"45","city":"03","area":"11"},{"code":"450312","name":"临桂区","province":"45","city":"03","area":"12"},{"code":"450321","name":"阳朔县","province":"45","city":"03","area":"21"},{"code":"450323","name":"灵川县","province":"45","city":"03","area":"23"},{"code":"450324","name":"全州县","province":"45","city":"03","area":"24"},{"code":"450325","name":"兴安县","province":"45","city":"03","area":"25"},{"code":"450326","name":"永福县","province":"45","city":"03","area":"26"},{"code":"450327","name":"灌阳县","province":"45","city":"03","area":"27"},{"code":"450328","name":"龙胜各族自治县","province":"45","city":"03","area":"28"},{"code":"450329","name":"资源县","province":"45","city":"03","area":"29"},{"code":"450330","name":"平乐县","province":"45","city":"03","area":"30"},{"code":"450332","name":"恭城瑶族自治县","province":"45","city":"03","area":"32"},{"code":"450381","name":"荔浦市","province":"45","city":"03","area":"81"},{"code":"450403","name":"万秀区","province":"45","city":"04","area":"03"},{"code":"450405","name":"长洲区","province":"45","city":"04","area":"05"},{"code":"450406","name":"龙圩区","province":"45","city":"04","area":"06"},{"code":"450421","name":"苍梧县","province":"45","city":"04","area":"21"},{"code":"450422","name":"藤县","province":"45","city":"04","area":"22"},{"code":"450423","name":"蒙山县","province":"45","city":"04","area":"23"},{"code":"450481","name":"岑溪市","province":"45","city":"04","area":"81"},{"code":"450502","name":"海城区","province":"45","city":"05","area":"02"},{"code":"450503","name":"银海区","province":"45","city":"05","area":"03"},{"code":"450512","name":"铁山港区","province":"45","city":"05","area":"12"},{"code":"450521","name":"合浦县","province":"45","city":"05","area":"21"},{"code":"450602","name":"港口区","province":"45","city":"06","area":"02"},{"code":"450603","name":"防城区","province":"45","city":"06","area":"03"},{"code":"450621","name":"上思县","province":"45","city":"06","area":"21"},{"code":"450681","name":"东兴市","province":"45","city":"06","area":"81"},{"code":"450702","name":"钦南区","province":"45","city":"07","area":"02"},{"code":"450703","name":"钦北区","province":"45","city":"07","area":"03"},{"code":"450721","name":"灵山县","province":"45","city":"07","area":"21"},{"code":"450722","name":"浦北县","province":"45","city":"07","area":"22"},{"code":"450802","name":"港北区","province":"45","city":"08","area":"02"},{"code":"450803","name":"港南区","province":"45","city":"08","area":"03"},{"code":"450804","name":"覃塘区","province":"45","city":"08","area":"04"},{"code":"450821","name":"平南县","province":"45","city":"08","area":"21"},{"code":"450881","name":"桂平市","province":"45","city":"08","area":"81"},{"code":"450902","name":"玉州区","province":"45","city":"09","area":"02"},{"code":"450903","name":"福绵区","province":"45","city":"09","area":"03"},{"code":"450921","name":"容县","province":"45","city":"09","area":"21"},{"code":"450922","name":"陆川县","province":"45","city":"09","area":"22"},{"code":"450923","name":"博白县","province":"45","city":"09","area":"23"},{"code":"450924","name":"兴业县","province":"45","city":"09","area":"24"},{"code":"450981","name":"北流市","province":"45","city":"09","area":"81"},{"code":"451002","name":"右江区","province":"45","city":"10","area":"02"},{"code":"451003","name":"田阳区","province":"45","city":"10","area":"03"},{"code":"451022","name":"田东县","province":"45","city":"10","area":"22"},{"code":"451024","name":"德保县","province":"45","city":"10","area":"24"},{"code":"451026","name":"那坡县","province":"45","city":"10","area":"26"},{"code":"451027","name":"凌云县","province":"45","city":"10","area":"27"},{"code":"451028","name":"乐业县","province":"45","city":"10","area":"28"},{"code":"451029","name":"田林县","province":"45","city":"10","area":"29"},{"code":"451030","name":"西林县","province":"45","city":"10","area":"30"},{"code":"451031","name":"隆林各族自治县","province":"45","city":"10","area":"31"},{"code":"451081","name":"靖西市","province":"45","city":"10","area":"81"},{"code":"451082","name":"平果市","province":"45","city":"10","area":"82"},{"code":"451102","name":"八步区","province":"45","city":"11","area":"02"},{"code":"451103","name":"平桂区","province":"45","city":"11","area":"03"},{"code":"451121","name":"昭平县","province":"45","city":"11","area":"21"},{"code":"451122","name":"钟山县","province":"45","city":"11","area":"22"},{"code":"451123","name":"富川瑶族自治县","province":"45","city":"11","area":"23"},{"code":"451202","name":"金城江区","province":"45","city":"12","area":"02"},{"code":"451203","name":"宜州区","province":"45","city":"12","area":"03"},{"code":"451221","name":"南丹县","province":"45","city":"12","area":"21"},{"code":"451222","name":"天峨县","province":"45","city":"12","area":"22"},{"code":"451223","name":"凤山县","province":"45","city":"12","area":"23"},{"code":"451224","name":"东兰县","province":"45","city":"12","area":"24"},{"code":"451225","name":"罗城仫佬族自治县","province":"45","city":"12","area":"25"},{"code":"451226","name":"环江毛南族自治县","province":"45","city":"12","area":"26"},{"code":"451227","name":"巴马瑶族自治县","province":"45","city":"12","area":"27"},{"code":"451228","name":"都安瑶族自治县","province":"45","city":"12","area":"28"},{"code":"451229","name":"大化瑶族自治县","province":"45","city":"12","area":"29"},{"code":"451302","name":"兴宾区","province":"45","city":"13","area":"02"},{"code":"451321","name":"忻城县","province":"45","city":"13","area":"21"},{"code":"451322","name":"象州县","province":"45","city":"13","area":"22"},{"code":"451323","name":"武宣县","province":"45","city":"13","area":"23"},{"code":"451324","name":"金秀瑶族自治县","province":"45","city":"13","area":"24"},{"code":"451381","name":"合山市","province":"45","city":"13","area":"81"},{"code":"451402","name":"江州区","province":"45","city":"14","area":"02"},{"code":"451421","name":"扶绥县","province":"45","city":"14","area":"21"},{"code":"451422","name":"宁明县","province":"45","city":"14","area":"22"},{"code":"451423","name":"龙州县","province":"45","city":"14","area":"23"},{"code":"451424","name":"大新县","province":"45","city":"14","area":"24"},{"code":"451425","name":"天等县","province":"45","city":"14","area":"25"},{"code":"451481","name":"凭祥市","province":"45","city":"14","area":"81"},{"code":"460105","name":"秀英区","province":"46","city":"01","area":"05"},{"code":"460106","name":"龙华区","province":"46","city":"01","area":"06"},{"code":"460107","name":"琼山区","province":"46","city":"01","area":"07"},{"code":"460108","name":"美兰区","province":"46","city":"01","area":"08"},{"code":"460202","name":"海棠区","province":"46","city":"02","area":"02"},{"code":"460203","name":"吉阳区","province":"46","city":"02","area":"03"},{"code":"460204","name":"天涯区","province":"46","city":"02","area":"04"},{"code":"460205","name":"崖州区","province":"46","city":"02","area":"05"},{"code":"469001","name":"五指山市","province":"46","city":"90","area":"01"},{"code":"469002","name":"琼海市","province":"46","city":"90","area":"02"},{"code":"469005","name":"文昌市","province":"46","city":"90","area":"05"},{"code":"469006","name":"万宁市","province":"46","city":"90","area":"06"},{"code":"469007","name":"东方市","province":"46","city":"90","area":"07"},{"code":"469021","name":"定安县","province":"46","city":"90","area":"21"},{"code":"469022","name":"屯昌县","province":"46","city":"90","area":"22"},{"code":"469023","name":"澄迈县","province":"46","city":"90","area":"23"},{"code":"469024","name":"临高县","province":"46","city":"90","area":"24"},{"code":"469025","name":"白沙黎族自治县","province":"46","city":"90","area":"25"},{"code":"469026","name":"昌江黎族自治县","province":"46","city":"90","area":"26"},{"code":"469027","name":"乐东黎族自治县","province":"46","city":"90","area":"27"},{"code":"469028","name":"陵水黎族自治县","province":"46","city":"90","area":"28"},{"code":"469029","name":"保亭黎族苗族自治县","province":"46","city":"90","area":"29"},{"code":"469030","name":"琼中黎族苗族自治县","province":"46","city":"90","area":"30"},{"code":"500101","name":"万州区","province":"50","city":"01","area":"01"},{"code":"500102","name":"涪陵区","province":"50","city":"01","area":"02"},{"code":"500103","name":"渝中区","province":"50","city":"01","area":"03"},{"code":"500104","name":"大渡口区","province":"50","city":"01","area":"04"},{"code":"500105","name":"江北区","province":"50","city":"01","area":"05"},{"code":"500106","name":"沙坪坝区","province":"50","city":"01","area":"06"},{"code":"500107","name":"九龙坡区","province":"50","city":"01","area":"07"},{"code":"500108","name":"南岸区","province":"50","city":"01","area":"08"},{"code":"500109","name":"北碚区","province":"50","city":"01","area":"09"},{"code":"500110","name":"綦江区","province":"50","city":"01","area":"10"},{"code":"500111","name":"大足区","province":"50","city":"01","area":"11"},{"code":"500112","name":"渝北区","province":"50","city":"01","area":"12"},{"code":"500113","name":"巴南区","province":"50","city":"01","area":"13"},{"code":"500114","name":"黔江区","province":"50","city":"01","area":"14"},{"code":"500115","name":"长寿区","province":"50","city":"01","area":"15"},{"code":"500116","name":"江津区","province":"50","city":"01","area":"16"},{"code":"500117","name":"合川区","province":"50","city":"01","area":"17"},{"code":"500118","name":"永川区","province":"50","city":"01","area":"18"},{"code":"500119","name":"南川区","province":"50","city":"01","area":"19"},{"code":"500120","name":"璧山区","province":"50","city":"01","area":"20"},{"code":"500151","name":"铜梁区","province":"50","city":"01","area":"51"},{"code":"500152","name":"潼南区","province":"50","city":"01","area":"52"},{"code":"500153","name":"荣昌区","province":"50","city":"01","area":"53"},{"code":"500154","name":"开州区","province":"50","city":"01","area":"54"},{"code":"500155","name":"梁平区","province":"50","city":"01","area":"55"},{"code":"500156","name":"武隆区","province":"50","city":"01","area":"56"},{"code":"500229","name":"城口县","province":"50","city":"02","area":"29"},{"code":"500230","name":"丰都县","province":"50","city":"02","area":"30"},{"code":"500231","name":"垫江县","province":"50","city":"02","area":"31"},{"code":"500233","name":"忠县","province":"50","city":"02","area":"33"},{"code":"500235","name":"云阳县","province":"50","city":"02","area":"35"},{"code":"500236","name":"奉节县","province":"50","city":"02","area":"36"},{"code":"500237","name":"巫山县","province":"50","city":"02","area":"37"},{"code":"500238","name":"巫溪县","province":"50","city":"02","area":"38"},{"code":"500240","name":"石柱土家族自治县","province":"50","city":"02","area":"40"},{"code":"500241","name":"秀山土家族苗族自治县","province":"50","city":"02","area":"41"},{"code":"500242","name":"酉阳土家族苗族自治县","province":"50","city":"02","area":"42"},{"code":"500243","name":"彭水苗族土家族自治县","province":"50","city":"02","area":"43"},{"code":"510104","name":"锦江区","province":"51","city":"01","area":"04"},{"code":"510105","name":"青羊区","province":"51","city":"01","area":"05"},{"code":"510106","name":"金牛区","province":"51","city":"01","area":"06"},{"code":"510107","name":"武侯区","province":"51","city":"01","area":"07"},{"code":"510108","name":"成华区","province":"51","city":"01","area":"08"},{"code":"510112","name":"龙泉驿区","province":"51","city":"01","area":"12"},{"code":"510113","name":"青白江区","province":"51","city":"01","area":"13"},{"code":"510114","name":"新都区","province":"51","city":"01","area":"14"},{"code":"510115","name":"温江区","province":"51","city":"01","area":"15"},{"code":"510116","name":"双流区","province":"51","city":"01","area":"16"},{"code":"510117","name":"郫都区","province":"51","city":"01","area":"17"},{"code":"510118","name":"新津区","province":"51","city":"01","area":"18"},{"code":"510121","name":"金堂县","province":"51","city":"01","area":"21"},{"code":"510129","name":"大邑县","province":"51","city":"01","area":"29"},{"code":"510131","name":"蒲江县","province":"51","city":"01","area":"31"},{"code":"510181","name":"都江堰市","province":"51","city":"01","area":"81"},{"code":"510182","name":"彭州市","province":"51","city":"01","area":"82"},{"code":"510183","name":"邛崃市","province":"51","city":"01","area":"83"},{"code":"510184","name":"崇州市","province":"51","city":"01","area":"84"},{"code":"510185","name":"简阳市","province":"51","city":"01","area":"85"},{"code":"510302","name":"自流井区","province":"51","city":"03","area":"02"},{"code":"510303","name":"贡井区","province":"51","city":"03","area":"03"},{"code":"510304","name":"大安区","province":"51","city":"03","area":"04"},{"code":"510311","name":"沿滩区","province":"51","city":"03","area":"11"},{"code":"510321","name":"荣县","province":"51","city":"03","area":"21"},{"code":"510322","name":"富顺县","province":"51","city":"03","area":"22"},{"code":"510402","name":"东区","province":"51","city":"04","area":"02"},{"code":"510403","name":"西区","province":"51","city":"04","area":"03"},{"code":"510411","name":"仁和区","province":"51","city":"04","area":"11"},{"code":"510421","name":"米易县","province":"51","city":"04","area":"21"},{"code":"510422","name":"盐边县","province":"51","city":"04","area":"22"},{"code":"510502","name":"江阳区","province":"51","city":"05","area":"02"},{"code":"510503","name":"纳溪区","province":"51","city":"05","area":"03"},{"code":"510504","name":"龙马潭区","province":"51","city":"05","area":"04"},{"code":"510521","name":"泸县","province":"51","city":"05","area":"21"},{"code":"510522","name":"合江县","province":"51","city":"05","area":"22"},{"code":"510524","name":"叙永县","province":"51","city":"05","area":"24"},{"code":"510525","name":"古蔺县","province":"51","city":"05","area":"25"},{"code":"510603","name":"旌阳区","province":"51","city":"06","area":"03"},{"code":"510604","name":"罗江区","province":"51","city":"06","area":"04"},{"code":"510623","name":"中江县","province":"51","city":"06","area":"23"},{"code":"510681","name":"广汉市","province":"51","city":"06","area":"81"},{"code":"510682","name":"什邡市","province":"51","city":"06","area":"82"},{"code":"510683","name":"绵竹市","province":"51","city":"06","area":"83"},{"code":"510703","name":"涪城区","province":"51","city":"07","area":"03"},{"code":"510704","name":"游仙区","province":"51","city":"07","area":"04"},{"code":"510705","name":"安州区","province":"51","city":"07","area":"05"},{"code":"510722","name":"三台县","province":"51","city":"07","area":"22"},{"code":"510723","name":"盐亭县","province":"51","city":"07","area":"23"},{"code":"510725","name":"梓潼县","province":"51","city":"07","area":"25"},{"code":"510726","name":"北川羌族自治县","province":"51","city":"07","area":"26"},{"code":"510727","name":"平武县","province":"51","city":"07","area":"27"},{"code":"510781","name":"江油市","province":"51","city":"07","area":"81"},{"code":"510802","name":"利州区","province":"51","city":"08","area":"02"},{"code":"510811","name":"昭化区","province":"51","city":"08","area":"11"},{"code":"510812","name":"朝天区","province":"51","city":"08","area":"12"},{"code":"510821","name":"旺苍县","province":"51","city":"08","area":"21"},{"code":"510822","name":"青川县","province":"51","city":"08","area":"22"},{"code":"510823","name":"剑阁县","province":"51","city":"08","area":"23"},{"code":"510824","name":"苍溪县","province":"51","city":"08","area":"24"},{"code":"510903","name":"船山区","province":"51","city":"09","area":"03"},{"code":"510904","name":"安居区","province":"51","city":"09","area":"04"},{"code":"510921","name":"蓬溪县","province":"51","city":"09","area":"21"},{"code":"510923","name":"大英县","province":"51","city":"09","area":"23"},{"code":"510981","name":"射洪市","province":"51","city":"09","area":"81"},{"code":"511002","name":"市中区","province":"51","city":"10","area":"02"},{"code":"511011","name":"东兴区","province":"51","city":"10","area":"11"},{"code":"511024","name":"威远县","province":"51","city":"10","area":"24"},{"code":"511025","name":"资中县","province":"51","city":"10","area":"25"},{"code":"511083","name":"隆昌市","province":"51","city":"10","area":"83"},{"code":"511102","name":"市中区","province":"51","city":"11","area":"02"},{"code":"511111","name":"沙湾区","province":"51","city":"11","area":"11"},{"code":"511112","name":"五通桥区","province":"51","city":"11","area":"12"},{"code":"511113","name":"金口河区","province":"51","city":"11","area":"13"},{"code":"511123","name":"犍为县","province":"51","city":"11","area":"23"},{"code":"511124","name":"井研县","province":"51","city":"11","area":"24"},{"code":"511126","name":"夹江县","province":"51","city":"11","area":"26"},{"code":"511129","name":"沐川县","province":"51","city":"11","area":"29"},{"code":"511132","name":"峨边彝族自治县","province":"51","city":"11","area":"32"},{"code":"511133","name":"马边彝族自治县","province":"51","city":"11","area":"33"},{"code":"511181","name":"峨眉山市","province":"51","city":"11","area":"81"},{"code":"511302","name":"顺庆区","province":"51","city":"13","area":"02"},{"code":"511303","name":"高坪区","province":"51","city":"13","area":"03"},{"code":"511304","name":"嘉陵区","province":"51","city":"13","area":"04"},{"code":"511321","name":"南部县","province":"51","city":"13","area":"21"},{"code":"511322","name":"营山县","province":"51","city":"13","area":"22"},{"code":"511323","name":"蓬安县","province":"51","city":"13","area":"23"},{"code":"511324","name":"仪陇县","province":"51","city":"13","area":"24"},{"code":"511325","name":"西充县","province":"51","city":"13","area":"25"},{"code":"511381","name":"阆中市","province":"51","city":"13","area":"81"},{"code":"511402","name":"东坡区","province":"51","city":"14","area":"02"},{"code":"511403","name":"彭山区","province":"51","city":"14","area":"03"},{"code":"511421","name":"仁寿县","province":"51","city":"14","area":"21"},{"code":"511423","name":"洪雅县","province":"51","city":"14","area":"23"},{"code":"511424","name":"丹棱县","province":"51","city":"14","area":"24"},{"code":"511425","name":"青神县","province":"51","city":"14","area":"25"},{"code":"511502","name":"翠屏区","province":"51","city":"15","area":"02"},{"code":"511503","name":"南溪区","province":"51","city":"15","area":"03"},{"code":"511504","name":"叙州区","province":"51","city":"15","area":"04"},{"code":"511523","name":"江安县","province":"51","city":"15","area":"23"},{"code":"511524","name":"长宁县","province":"51","city":"15","area":"24"},{"code":"511525","name":"高县","province":"51","city":"15","area":"25"},{"code":"511526","name":"珙县","province":"51","city":"15","area":"26"},{"code":"511527","name":"筠连县","province":"51","city":"15","area":"27"},{"code":"511528","name":"兴文县","province":"51","city":"15","area":"28"},{"code":"511529","name":"屏山县","province":"51","city":"15","area":"29"},{"code":"511602","name":"广安区","province":"51","city":"16","area":"02"},{"code":"511603","name":"前锋区","province":"51","city":"16","area":"03"},{"code":"511621","name":"岳池县","province":"51","city":"16","area":"21"},{"code":"511622","name":"武胜县","province":"51","city":"16","area":"22"},{"code":"511623","name":"邻水县","province":"51","city":"16","area":"23"},{"code":"511681","name":"华蓥市","province":"51","city":"16","area":"81"},{"code":"511702","name":"通川区","province":"51","city":"17","area":"02"},{"code":"511703","name":"达川区","province":"51","city":"17","area":"03"},{"code":"511722","name":"宣汉县","province":"51","city":"17","area":"22"},{"code":"511723","name":"开江县","province":"51","city":"17","area":"23"},{"code":"511724","name":"大竹县","province":"51","city":"17","area":"24"},{"code":"511725","name":"渠县","province":"51","city":"17","area":"25"},{"code":"511781","name":"万源市","province":"51","city":"17","area":"81"},{"code":"511802","name":"雨城区","province":"51","city":"18","area":"02"},{"code":"511803","name":"名山区","province":"51","city":"18","area":"03"},{"code":"511822","name":"荥经县","province":"51","city":"18","area":"22"},{"code":"511823","name":"汉源县","province":"51","city":"18","area":"23"},{"code":"511824","name":"石棉县","province":"51","city":"18","area":"24"},{"code":"511825","name":"天全县","province":"51","city":"18","area":"25"},{"code":"511826","name":"芦山县","province":"51","city":"18","area":"26"},{"code":"511827","name":"宝兴县","province":"51","city":"18","area":"27"},{"code":"511902","name":"巴州区","province":"51","city":"19","area":"02"},{"code":"511903","name":"恩阳区","province":"51","city":"19","area":"03"},{"code":"511921","name":"通江县","province":"51","city":"19","area":"21"},{"code":"511922","name":"南江县","province":"51","city":"19","area":"22"},{"code":"511923","name":"平昌县","province":"51","city":"19","area":"23"},{"code":"512002","name":"雁江区","province":"51","city":"20","area":"02"},{"code":"512021","name":"安岳县","province":"51","city":"20","area":"21"},{"code":"512022","name":"乐至县","province":"51","city":"20","area":"22"},{"code":"513201","name":"马尔康市","province":"51","city":"32","area":"01"},{"code":"513221","name":"汶川县","province":"51","city":"32","area":"21"},{"code":"513222","name":"理县","province":"51","city":"32","area":"22"},{"code":"513223","name":"茂县","province":"51","city":"32","area":"23"},{"code":"513224","name":"松潘县","province":"51","city":"32","area":"24"},{"code":"513225","name":"九寨沟县","province":"51","city":"32","area":"25"},{"code":"513226","name":"金川县","province":"51","city":"32","area":"26"},{"code":"513227","name":"小金县","province":"51","city":"32","area":"27"},{"code":"513228","name":"黑水县","province":"51","city":"32","area":"28"},{"code":"513230","name":"壤塘县","province":"51","city":"32","area":"30"},{"code":"513231","name":"阿坝县","province":"51","city":"32","area":"31"},{"code":"513232","name":"若尔盖县","province":"51","city":"32","area":"32"},{"code":"513233","name":"红原县","province":"51","city":"32","area":"33"},{"code":"513301","name":"康定市","province":"51","city":"33","area":"01"},{"code":"513322","name":"泸定县","province":"51","city":"33","area":"22"},{"code":"513323","name":"丹巴县","province":"51","city":"33","area":"23"},{"code":"513324","name":"九龙县","province":"51","city":"33","area":"24"},{"code":"513325","name":"雅江县","province":"51","city":"33","area":"25"},{"code":"513326","name":"道孚县","province":"51","city":"33","area":"26"},{"code":"513327","name":"炉霍县","province":"51","city":"33","area":"27"},{"code":"513328","name":"甘孜县","province":"51","city":"33","area":"28"},{"code":"513329","name":"新龙县","province":"51","city":"33","area":"29"},{"code":"513330","name":"德格县","province":"51","city":"33","area":"30"},{"code":"513331","name":"白玉县","province":"51","city":"33","area":"31"},{"code":"513332","name":"石渠县","province":"51","city":"33","area":"32"},{"code":"513333","name":"色达县","province":"51","city":"33","area":"33"},{"code":"513334","name":"理塘县","province":"51","city":"33","area":"34"},{"code":"513335","name":"巴塘县","province":"51","city":"33","area":"35"},{"code":"513336","name":"乡城县","province":"51","city":"33","area":"36"},{"code":"513337","name":"稻城县","province":"51","city":"33","area":"37"},{"code":"513338","name":"得荣县","province":"51","city":"33","area":"38"},{"code":"513401","name":"西昌市","province":"51","city":"34","area":"01"},{"code":"513422","name":"木里藏族自治县","province":"51","city":"34","area":"22"},{"code":"513423","name":"盐源县","province":"51","city":"34","area":"23"},{"code":"513424","name":"德昌县","province":"51","city":"34","area":"24"},{"code":"513425","name":"会理县","province":"51","city":"34","area":"25"},{"code":"513426","name":"会东县","province":"51","city":"34","area":"26"},{"code":"513427","name":"宁南县","province":"51","city":"34","area":"27"},{"code":"513428","name":"普格县","province":"51","city":"34","area":"28"},{"code":"513429","name":"布拖县","province":"51","city":"34","area":"29"},{"code":"513430","name":"金阳县","province":"51","city":"34","area":"30"},{"code":"513431","name":"昭觉县","province":"51","city":"34","area":"31"},{"code":"513432","name":"喜德县","province":"51","city":"34","area":"32"},{"code":"513433","name":"冕宁县","province":"51","city":"34","area":"33"},{"code":"513434","name":"越西县","province":"51","city":"34","area":"34"},{"code":"513435","name":"甘洛县","province":"51","city":"34","area":"35"},{"code":"513436","name":"美姑县","province":"51","city":"34","area":"36"},{"code":"513437","name":"雷波县","province":"51","city":"34","area":"37"},{"code":"520102","name":"南明区","province":"52","city":"01","area":"02"},{"code":"520103","name":"云岩区","province":"52","city":"01","area":"03"},{"code":"520111","name":"花溪区","province":"52","city":"01","area":"11"},{"code":"520112","name":"乌当区","province":"52","city":"01","area":"12"},{"code":"520113","name":"白云区","province":"52","city":"01","area":"13"},{"code":"520115","name":"观山湖区","province":"52","city":"01","area":"15"},{"code":"520121","name":"开阳县","province":"52","city":"01","area":"21"},{"code":"520122","name":"息烽县","province":"52","city":"01","area":"22"},{"code":"520123","name":"修文县","province":"52","city":"01","area":"23"},{"code":"520181","name":"清镇市","province":"52","city":"01","area":"81"},{"code":"520201","name":"钟山区","province":"52","city":"02","area":"01"},{"code":"520203","name":"六枝特区","province":"52","city":"02","area":"03"},{"code":"520204","name":"水城区","province":"52","city":"02","area":"04"},{"code":"520281","name":"盘州市","province":"52","city":"02","area":"81"},{"code":"520302","name":"红花岗区","province":"52","city":"03","area":"02"},{"code":"520303","name":"汇川区","province":"52","city":"03","area":"03"},{"code":"520304","name":"播州区","province":"52","city":"03","area":"04"},{"code":"520322","name":"桐梓县","province":"52","city":"03","area":"22"},{"code":"520323","name":"绥阳县","province":"52","city":"03","area":"23"},{"code":"520324","name":"正安县","province":"52","city":"03","area":"24"},{"code":"520325","name":"道真仡佬族苗族自治县","province":"52","city":"03","area":"25"},{"code":"520326","name":"务川仡佬族苗族自治县","province":"52","city":"03","area":"26"},{"code":"520327","name":"凤冈县","province":"52","city":"03","area":"27"},{"code":"520328","name":"湄潭县","province":"52","city":"03","area":"28"},{"code":"520329","name":"余庆县","province":"52","city":"03","area":"29"},{"code":"520330","name":"习水县","province":"52","city":"03","area":"30"},{"code":"520381","name":"赤水市","province":"52","city":"03","area":"81"},{"code":"520382","name":"仁怀市","province":"52","city":"03","area":"82"},{"code":"520402","name":"西秀区","province":"52","city":"04","area":"02"},{"code":"520403","name":"平坝区","province":"52","city":"04","area":"03"},{"code":"520422","name":"普定县","province":"52","city":"04","area":"22"},{"code":"520423","name":"镇宁布依族苗族自治县","province":"52","city":"04","area":"23"},{"code":"520424","name":"关岭布依族苗族自治县","province":"52","city":"04","area":"24"},{"code":"520425","name":"紫云苗族布依族自治县","province":"52","city":"04","area":"25"},{"code":"520502","name":"七星关区","province":"52","city":"05","area":"02"},{"code":"520521","name":"大方县","province":"52","city":"05","area":"21"},{"code":"520522","name":"黔西县","province":"52","city":"05","area":"22"},{"code":"520523","name":"金沙县","province":"52","city":"05","area":"23"},{"code":"520524","name":"织金县","province":"52","city":"05","area":"24"},{"code":"520525","name":"纳雍县","province":"52","city":"05","area":"25"},{"code":"520526","name":"威宁彝族回族苗族自治县","province":"52","city":"05","area":"26"},{"code":"520527","name":"赫章县","province":"52","city":"05","area":"27"},{"code":"520602","name":"碧江区","province":"52","city":"06","area":"02"},{"code":"520603","name":"万山区","province":"52","city":"06","area":"03"},{"code":"520621","name":"江口县","province":"52","city":"06","area":"21"},{"code":"520622","name":"玉屏侗族自治县","province":"52","city":"06","area":"22"},{"code":"520623","name":"石阡县","province":"52","city":"06","area":"23"},{"code":"520624","name":"思南县","province":"52","city":"06","area":"24"},{"code":"520625","name":"印江土家族苗族自治县","province":"52","city":"06","area":"25"},{"code":"520626","name":"德江县","province":"52","city":"06","area":"26"},{"code":"520627","name":"沿河土家族自治县","province":"52","city":"06","area":"27"},{"code":"520628","name":"松桃苗族自治县","province":"52","city":"06","area":"28"},{"code":"522301","name":"兴义市","province":"52","city":"23","area":"01"},{"code":"522302","name":"兴仁市","province":"52","city":"23","area":"02"},{"code":"522323","name":"普安县","province":"52","city":"23","area":"23"},{"code":"522324","name":"晴隆县","province":"52","city":"23","area":"24"},{"code":"522325","name":"贞丰县","province":"52","city":"23","area":"25"},{"code":"522326","name":"望谟县","province":"52","city":"23","area":"26"},{"code":"522327","name":"册亨县","province":"52","city":"23","area":"27"},{"code":"522328","name":"安龙县","province":"52","city":"23","area":"28"},{"code":"522601","name":"凯里市","province":"52","city":"26","area":"01"},{"code":"522622","name":"黄平县","province":"52","city":"26","area":"22"},{"code":"522623","name":"施秉县","province":"52","city":"26","area":"23"},{"code":"522624","name":"三穗县","province":"52","city":"26","area":"24"},{"code":"522625","name":"镇远县","province":"52","city":"26","area":"25"},{"code":"522626","name":"岑巩县","province":"52","city":"26","area":"26"},{"code":"522627","name":"天柱县","province":"52","city":"26","area":"27"},{"code":"522628","name":"锦屏县","province":"52","city":"26","area":"28"},{"code":"522629","name":"剑河县","province":"52","city":"26","area":"29"},{"code":"522630","name":"台江县","province":"52","city":"26","area":"30"},{"code":"522631","name":"黎平县","province":"52","city":"26","area":"31"},{"code":"522632","name":"榕江县","province":"52","city":"26","area":"32"},{"code":"522633","name":"从江县","province":"52","city":"26","area":"33"},{"code":"522634","name":"雷山县","province":"52","city":"26","area":"34"},{"code":"522635","name":"麻江县","province":"52","city":"26","area":"35"},{"code":"522636","name":"丹寨县","province":"52","city":"26","area":"36"},{"code":"522701","name":"都匀市","province":"52","city":"27","area":"01"},{"code":"522702","name":"福泉市","province":"52","city":"27","area":"02"},{"code":"522722","name":"荔波县","province":"52","city":"27","area":"22"},{"code":"522723","name":"贵定县","province":"52","city":"27","area":"23"},{"code":"522725","name":"瓮安县","province":"52","city":"27","area":"25"},{"code":"522726","name":"独山县","province":"52","city":"27","area":"26"},{"code":"522727","name":"平塘县","province":"52","city":"27","area":"27"},{"code":"522728","name":"罗甸县","province":"52","city":"27","area":"28"},{"code":"522729","name":"长顺县","province":"52","city":"27","area":"29"},{"code":"522730","name":"龙里县","province":"52","city":"27","area":"30"},{"code":"522731","name":"惠水县","province":"52","city":"27","area":"31"},{"code":"522732","name":"三都水族自治县","province":"52","city":"27","area":"32"},{"code":"530102","name":"五华区","province":"53","city":"01","area":"02"},{"code":"530103","name":"盘龙区","province":"53","city":"01","area":"03"},{"code":"530111","name":"官渡区","province":"53","city":"01","area":"11"},{"code":"530112","name":"西山区","province":"53","city":"01","area":"12"},{"code":"530113","name":"东川区","province":"53","city":"01","area":"13"},{"code":"530114","name":"呈贡区","province":"53","city":"01","area":"14"},{"code":"530115","name":"晋宁区","province":"53","city":"01","area":"15"},{"code":"530124","name":"富民县","province":"53","city":"01","area":"24"},{"code":"530125","name":"宜良县","province":"53","city":"01","area":"25"},{"code":"530126","name":"石林彝族自治县","province":"53","city":"01","area":"26"},{"code":"530127","name":"嵩明县","province":"53","city":"01","area":"27"},{"code":"530128","name":"禄劝彝族苗族自治县","province":"53","city":"01","area":"28"},{"code":"530129","name":"寻甸回族彝族自治县","province":"53","city":"01","area":"29"},{"code":"530181","name":"安宁市","province":"53","city":"01","area":"81"},{"code":"530302","name":"麒麟区","province":"53","city":"03","area":"02"},{"code":"530303","name":"沾益区","province":"53","city":"03","area":"03"},{"code":"530304","name":"马龙区","province":"53","city":"03","area":"04"},{"code":"530322","name":"陆良县","province":"53","city":"03","area":"22"},{"code":"530323","name":"师宗县","province":"53","city":"03","area":"23"},{"code":"530324","name":"罗平县","province":"53","city":"03","area":"24"},{"code":"530325","name":"富源县","province":"53","city":"03","area":"25"},{"code":"530326","name":"会泽县","province":"53","city":"03","area":"26"},{"code":"530381","name":"宣威市","province":"53","city":"03","area":"81"},{"code":"530402","name":"红塔区","province":"53","city":"04","area":"02"},{"code":"530403","name":"江川区","province":"53","city":"04","area":"03"},{"code":"530423","name":"通海县","province":"53","city":"04","area":"23"},{"code":"530424","name":"华宁县","province":"53","city":"04","area":"24"},{"code":"530425","name":"易门县","province":"53","city":"04","area":"25"},{"code":"530426","name":"峨山彝族自治县","province":"53","city":"04","area":"26"},{"code":"530427","name":"新平彝族傣族自治县","province":"53","city":"04","area":"27"},{"code":"530428","name":"元江哈尼族彝族傣族自治县","province":"53","city":"04","area":"28"},{"code":"530481","name":"澄江市","province":"53","city":"04","area":"81"},{"code":"530502","name":"隆阳区","province":"53","city":"05","area":"02"},{"code":"530521","name":"施甸县","province":"53","city":"05","area":"21"},{"code":"530523","name":"龙陵县","province":"53","city":"05","area":"23"},{"code":"530524","name":"昌宁县","province":"53","city":"05","area":"24"},{"code":"530581","name":"腾冲市","province":"53","city":"05","area":"81"},{"code":"530602","name":"昭阳区","province":"53","city":"06","area":"02"},{"code":"530621","name":"鲁甸县","province":"53","city":"06","area":"21"},{"code":"530622","name":"巧家县","province":"53","city":"06","area":"22"},{"code":"530623","name":"盐津县","province":"53","city":"06","area":"23"},{"code":"530624","name":"大关县","province":"53","city":"06","area":"24"},{"code":"530625","name":"永善县","province":"53","city":"06","area":"25"},{"code":"530626","name":"绥江县","province":"53","city":"06","area":"26"},{"code":"530627","name":"镇雄县","province":"53","city":"06","area":"27"},{"code":"530628","name":"彝良县","province":"53","city":"06","area":"28"},{"code":"530629","name":"威信县","province":"53","city":"06","area":"29"},{"code":"530681","name":"水富市","province":"53","city":"06","area":"81"},{"code":"530702","name":"古城区","province":"53","city":"07","area":"02"},{"code":"530721","name":"玉龙纳西族自治县","province":"53","city":"07","area":"21"},{"code":"530722","name":"永胜县","province":"53","city":"07","area":"22"},{"code":"530723","name":"华坪县","province":"53","city":"07","area":"23"},{"code":"530724","name":"宁蒗彝族自治县","province":"53","city":"07","area":"24"},{"code":"530802","name":"思茅区","province":"53","city":"08","area":"02"},{"code":"530821","name":"宁洱哈尼族彝族自治县","province":"53","city":"08","area":"21"},{"code":"530822","name":"墨江哈尼族自治县","province":"53","city":"08","area":"22"},{"code":"530823","name":"景东彝族自治县","province":"53","city":"08","area":"23"},{"code":"530824","name":"景谷傣族彝族自治县","province":"53","city":"08","area":"24"},{"code":"530825","name":"镇沅彝族哈尼族拉祜族自治县","province":"53","city":"08","area":"25"},{"code":"530826","name":"江城哈尼族彝族自治县","province":"53","city":"08","area":"26"},{"code":"530827","name":"孟连傣族拉祜族佤族自治县","province":"53","city":"08","area":"27"},{"code":"530828","name":"澜沧拉祜族自治县","province":"53","city":"08","area":"28"},{"code":"530829","name":"西盟佤族自治县","province":"53","city":"08","area":"29"},{"code":"530902","name":"临翔区","province":"53","city":"09","area":"02"},{"code":"530921","name":"凤庆县","province":"53","city":"09","area":"21"},{"code":"530922","name":"云县","province":"53","city":"09","area":"22"},{"code":"530923","name":"永德县","province":"53","city":"09","area":"23"},{"code":"530924","name":"镇康县","province":"53","city":"09","area":"24"},{"code":"530925","name":"双江拉祜族佤族布朗族傣族自治县","province":"53","city":"09","area":"25"},{"code":"530926","name":"耿马傣族佤族自治县","province":"53","city":"09","area":"26"},{"code":"530927","name":"沧源佤族自治县","province":"53","city":"09","area":"27"},{"code":"532301","name":"楚雄市","province":"53","city":"23","area":"01"},{"code":"532322","name":"双柏县","province":"53","city":"23","area":"22"},{"code":"532323","name":"牟定县","province":"53","city":"23","area":"23"},{"code":"532324","name":"南华县","province":"53","city":"23","area":"24"},{"code":"532325","name":"姚安县","province":"53","city":"23","area":"25"},{"code":"532326","name":"大姚县","province":"53","city":"23","area":"26"},{"code":"532327","name":"永仁县","province":"53","city":"23","area":"27"},{"code":"532328","name":"元谋县","province":"53","city":"23","area":"28"},{"code":"532329","name":"武定县","province":"53","city":"23","area":"29"},{"code":"532331","name":"禄丰县","province":"53","city":"23","area":"31"},{"code":"532501","name":"个旧市","province":"53","city":"25","area":"01"},{"code":"532502","name":"开远市","province":"53","city":"25","area":"02"},{"code":"532503","name":"蒙自市","province":"53","city":"25","area":"03"},{"code":"532504","name":"弥勒市","province":"53","city":"25","area":"04"},{"code":"532523","name":"屏边苗族自治县","province":"53","city":"25","area":"23"},{"code":"532524","name":"建水县","province":"53","city":"25","area":"24"},{"code":"532525","name":"石屏县","province":"53","city":"25","area":"25"},{"code":"532527","name":"泸西县","province":"53","city":"25","area":"27"},{"code":"532528","name":"元阳县","province":"53","city":"25","area":"28"},{"code":"532529","name":"红河县","province":"53","city":"25","area":"29"},{"code":"532530","name":"金平苗族瑶族傣族自治县","province":"53","city":"25","area":"30"},{"code":"532531","name":"绿春县","province":"53","city":"25","area":"31"},{"code":"532532","name":"河口瑶族自治县","province":"53","city":"25","area":"32"},{"code":"532601","name":"文山市","province":"53","city":"26","area":"01"},{"code":"532622","name":"砚山县","province":"53","city":"26","area":"22"},{"code":"532623","name":"西畴县","province":"53","city":"26","area":"23"},{"code":"532624","name":"麻栗坡县","province":"53","city":"26","area":"24"},{"code":"532625","name":"马关县","province":"53","city":"26","area":"25"},{"code":"532626","name":"丘北县","province":"53","city":"26","area":"26"},{"code":"532627","name":"广南县","province":"53","city":"26","area":"27"},{"code":"532628","name":"富宁县","province":"53","city":"26","area":"28"},{"code":"532801","name":"景洪市","province":"53","city":"28","area":"01"},{"code":"532822","name":"勐海县","province":"53","city":"28","area":"22"},{"code":"532823","name":"勐腊县","province":"53","city":"28","area":"23"},{"code":"532901","name":"大理市","province":"53","city":"29","area":"01"},{"code":"532922","name":"漾濞彝族自治县","province":"53","city":"29","area":"22"},{"code":"532923","name":"祥云县","province":"53","city":"29","area":"23"},{"code":"532924","name":"宾川县","province":"53","city":"29","area":"24"},{"code":"532925","name":"弥渡县","province":"53","city":"29","area":"25"},{"code":"532926","name":"南涧彝族自治县","province":"53","city":"29","area":"26"},{"code":"532927","name":"巍山彝族回族自治县","province":"53","city":"29","area":"27"},{"code":"532928","name":"永平县","province":"53","city":"29","area":"28"},{"code":"532929","name":"云龙县","province":"53","city":"29","area":"29"},{"code":"532930","name":"洱源县","province":"53","city":"29","area":"30"},{"code":"532931","name":"剑川县","province":"53","city":"29","area":"31"},{"code":"532932","name":"鹤庆县","province":"53","city":"29","area":"32"},{"code":"533102","name":"瑞丽市","province":"53","city":"31","area":"02"},{"code":"533103","name":"芒市","province":"53","city":"31","area":"03"},{"code":"533122","name":"梁河县","province":"53","city":"31","area":"22"},{"code":"533123","name":"盈江县","province":"53","city":"31","area":"23"},{"code":"533124","name":"陇川县","province":"53","city":"31","area":"24"},{"code":"533301","name":"泸水市","province":"53","city":"33","area":"01"},{"code":"533323","name":"福贡县","province":"53","city":"33","area":"23"},{"code":"533324","name":"贡山独龙族怒族自治县","province":"53","city":"33","area":"24"},{"code":"533325","name":"兰坪白族普米族自治县","province":"53","city":"33","area":"25"},{"code":"533401","name":"香格里拉市","province":"53","city":"34","area":"01"},{"code":"533422","name":"德钦县","province":"53","city":"34","area":"22"},{"code":"533423","name":"维西傈僳族自治县","province":"53","city":"34","area":"23"},{"code":"540102","name":"城关区","province":"54","city":"01","area":"02"},{"code":"540103","name":"堆龙德庆区","province":"54","city":"01","area":"03"},{"code":"540104","name":"达孜区","province":"54","city":"01","area":"04"},{"code":"540121","name":"林周县","province":"54","city":"01","area":"21"},{"code":"540122","name":"当雄县","province":"54","city":"01","area":"22"},{"code":"540123","name":"尼木县","province":"54","city":"01","area":"23"},{"code":"540124","name":"曲水县","province":"54","city":"01","area":"24"},{"code":"540127","name":"墨竹工卡县","province":"54","city":"01","area":"27"},{"code":"540202","name":"桑珠孜区","province":"54","city":"02","area":"02"},{"code":"540221","name":"南木林县","province":"54","city":"02","area":"21"},{"code":"540222","name":"江孜县","province":"54","city":"02","area":"22"},{"code":"540223","name":"定日县","province":"54","city":"02","area":"23"},{"code":"540224","name":"萨迦县","province":"54","city":"02","area":"24"},{"code":"540225","name":"拉孜县","province":"54","city":"02","area":"25"},{"code":"540226","name":"昂仁县","province":"54","city":"02","area":"26"},{"code":"540227","name":"谢通门县","province":"54","city":"02","area":"27"},{"code":"540228","name":"白朗县","province":"54","city":"02","area":"28"},{"code":"540229","name":"仁布县","province":"54","city":"02","area":"29"},{"code":"540230","name":"康马县","province":"54","city":"02","area":"30"},{"code":"540231","name":"定结县","province":"54","city":"02","area":"31"},{"code":"540232","name":"仲巴县","province":"54","city":"02","area":"32"},{"code":"540233","name":"亚东县","province":"54","city":"02","area":"33"},{"code":"540234","name":"吉隆县","province":"54","city":"02","area":"34"},{"code":"540235","name":"聂拉木县","province":"54","city":"02","area":"35"},{"code":"540236","name":"萨嘎县","province":"54","city":"02","area":"36"},{"code":"540237","name":"岗巴县","province":"54","city":"02","area":"37"},{"code":"540302","name":"卡若区","province":"54","city":"03","area":"02"},{"code":"540321","name":"江达县","province":"54","city":"03","area":"21"},{"code":"540322","name":"贡觉县","province":"54","city":"03","area":"22"},{"code":"540323","name":"类乌齐县","province":"54","city":"03","area":"23"},{"code":"540324","name":"丁青县","province":"54","city":"03","area":"24"},{"code":"540325","name":"察雅县","province":"54","city":"03","area":"25"},{"code":"540326","name":"八宿县","province":"54","city":"03","area":"26"},{"code":"540327","name":"左贡县","province":"54","city":"03","area":"27"},{"code":"540328","name":"芒康县","province":"54","city":"03","area":"28"},{"code":"540329","name":"洛隆县","province":"54","city":"03","area":"29"},{"code":"540330","name":"边坝县","province":"54","city":"03","area":"30"},{"code":"540402","name":"巴宜区","province":"54","city":"04","area":"02"},{"code":"540421","name":"工布江达县","province":"54","city":"04","area":"21"},{"code":"540422","name":"米林县","province":"54","city":"04","area":"22"},{"code":"540423","name":"墨脱县","province":"54","city":"04","area":"23"},{"code":"540424","name":"波密县","province":"54","city":"04","area":"24"},{"code":"540425","name":"察隅县","province":"54","city":"04","area":"25"},{"code":"540426","name":"朗县","province":"54","city":"04","area":"26"},{"code":"540502","name":"乃东区","province":"54","city":"05","area":"02"},{"code":"540521","name":"扎囊县","province":"54","city":"05","area":"21"},{"code":"540522","name":"贡嘎县","province":"54","city":"05","area":"22"},{"code":"540523","name":"桑日县","province":"54","city":"05","area":"23"},{"code":"540524","name":"琼结县","province":"54","city":"05","area":"24"},{"code":"540525","name":"曲松县","province":"54","city":"05","area":"25"},{"code":"540526","name":"措美县","province":"54","city":"05","area":"26"},{"code":"540527","name":"洛扎县","province":"54","city":"05","area":"27"},{"code":"540528","name":"加查县","province":"54","city":"05","area":"28"},{"code":"540529","name":"隆子县","province":"54","city":"05","area":"29"},{"code":"540530","name":"错那县","province":"54","city":"05","area":"30"},{"code":"540531","name":"浪卡子县","province":"54","city":"05","area":"31"},{"code":"540602","name":"色尼区","province":"54","city":"06","area":"02"},{"code":"540621","name":"嘉黎县","province":"54","city":"06","area":"21"},{"code":"540622","name":"比如县","province":"54","city":"06","area":"22"},{"code":"540623","name":"聂荣县","province":"54","city":"06","area":"23"},{"code":"540624","name":"安多县","province":"54","city":"06","area":"24"},{"code":"540625","name":"申扎县","province":"54","city":"06","area":"25"},{"code":"540626","name":"索县","province":"54","city":"06","area":"26"},{"code":"540627","name":"班戈县","province":"54","city":"06","area":"27"},{"code":"540628","name":"巴青县","province":"54","city":"06","area":"28"},{"code":"540629","name":"尼玛县","province":"54","city":"06","area":"29"},{"code":"540630","name":"双湖县","province":"54","city":"06","area":"30"},{"code":"542521","name":"普兰县","province":"54","city":"25","area":"21"},{"code":"542522","name":"札达县","province":"54","city":"25","area":"22"},{"code":"542523","name":"噶尔县","province":"54","city":"25","area":"23"},{"code":"542524","name":"日土县","province":"54","city":"25","area":"24"},{"code":"542525","name":"革吉县","province":"54","city":"25","area":"25"},{"code":"542526","name":"改则县","province":"54","city":"25","area":"26"},{"code":"542527","name":"措勤县","province":"54","city":"25","area":"27"},{"code":"610102","name":"新城区","province":"61","city":"01","area":"02"},{"code":"610103","name":"碑林区","province":"61","city":"01","area":"03"},{"code":"610104","name":"莲湖区","province":"61","city":"01","area":"04"},{"code":"610111","name":"灞桥区","province":"61","city":"01","area":"11"},{"code":"610112","name":"未央区","province":"61","city":"01","area":"12"},{"code":"610113","name":"雁塔区","province":"61","city":"01","area":"13"},{"code":"610114","name":"阎良区","province":"61","city":"01","area":"14"},{"code":"610115","name":"临潼区","province":"61","city":"01","area":"15"},{"code":"610116","name":"长安区","province":"61","city":"01","area":"16"},{"code":"610117","name":"高陵区","province":"61","city":"01","area":"17"},{"code":"610118","name":"鄠邑区","province":"61","city":"01","area":"18"},{"code":"610122","name":"蓝田县","province":"61","city":"01","area":"22"},{"code":"610124","name":"周至县","province":"61","city":"01","area":"24"},{"code":"610202","name":"王益区","province":"61","city":"02","area":"02"},{"code":"610203","name":"印台区","province":"61","city":"02","area":"03"},{"code":"610204","name":"耀州区","province":"61","city":"02","area":"04"},{"code":"610222","name":"宜君县","province":"61","city":"02","area":"22"},{"code":"610302","name":"渭滨区","province":"61","city":"03","area":"02"},{"code":"610303","name":"金台区","province":"61","city":"03","area":"03"},{"code":"610304","name":"陈仓区","province":"61","city":"03","area":"04"},{"code":"610322","name":"凤翔县","province":"61","city":"03","area":"22"},{"code":"610323","name":"岐山县","province":"61","city":"03","area":"23"},{"code":"610324","name":"扶风县","province":"61","city":"03","area":"24"},{"code":"610326","name":"眉县","province":"61","city":"03","area":"26"},{"code":"610327","name":"陇县","province":"61","city":"03","area":"27"},{"code":"610328","name":"千阳县","province":"61","city":"03","area":"28"},{"code":"610329","name":"麟游县","province":"61","city":"03","area":"29"},{"code":"610330","name":"凤县","province":"61","city":"03","area":"30"},{"code":"610331","name":"太白县","province":"61","city":"03","area":"31"},{"code":"610402","name":"秦都区","province":"61","city":"04","area":"02"},{"code":"610403","name":"杨陵区","province":"61","city":"04","area":"03"},{"code":"610404","name":"渭城区","province":"61","city":"04","area":"04"},{"code":"610422","name":"三原县","province":"61","city":"04","area":"22"},{"code":"610423","name":"泾阳县","province":"61","city":"04","area":"23"},{"code":"610424","name":"乾县","province":"61","city":"04","area":"24"},{"code":"610425","name":"礼泉县","province":"61","city":"04","area":"25"},{"code":"610426","name":"永寿县","province":"61","city":"04","area":"26"},{"code":"610428","name":"长武县","province":"61","city":"04","area":"28"},{"code":"610429","name":"旬邑县","province":"61","city":"04","area":"29"},{"code":"610430","name":"淳化县","province":"61","city":"04","area":"30"},{"code":"610431","name":"武功县","province":"61","city":"04","area":"31"},{"code":"610481","name":"兴平市","province":"61","city":"04","area":"81"},{"code":"610482","name":"彬州市","province":"61","city":"04","area":"82"},{"code":"610502","name":"临渭区","province":"61","city":"05","area":"02"},{"code":"610503","name":"华州区","province":"61","city":"05","area":"03"},{"code":"610522","name":"潼关县","province":"61","city":"05","area":"22"},{"code":"610523","name":"大荔县","province":"61","city":"05","area":"23"},{"code":"610524","name":"合阳县","province":"61","city":"05","area":"24"},{"code":"610525","name":"澄城县","province":"61","city":"05","area":"25"},{"code":"610526","name":"蒲城县","province":"61","city":"05","area":"26"},{"code":"610527","name":"白水县","province":"61","city":"05","area":"27"},{"code":"610528","name":"富平县","province":"61","city":"05","area":"28"},{"code":"610581","name":"韩城市","province":"61","city":"05","area":"81"},{"code":"610582","name":"华阴市","province":"61","city":"05","area":"82"},{"code":"610602","name":"宝塔区","province":"61","city":"06","area":"02"},{"code":"610603","name":"安塞区","province":"61","city":"06","area":"03"},{"code":"610621","name":"延长县","province":"61","city":"06","area":"21"},{"code":"610622","name":"延川县","province":"61","city":"06","area":"22"},{"code":"610625","name":"志丹县","province":"61","city":"06","area":"25"},{"code":"610626","name":"吴起县","province":"61","city":"06","area":"26"},{"code":"610627","name":"甘泉县","province":"61","city":"06","area":"27"},{"code":"610628","name":"富县","province":"61","city":"06","area":"28"},{"code":"610629","name":"洛川县","province":"61","city":"06","area":"29"},{"code":"610630","name":"宜川县","province":"61","city":"06","area":"30"},{"code":"610631","name":"黄龙县","province":"61","city":"06","area":"31"},{"code":"610632","name":"黄陵县","province":"61","city":"06","area":"32"},{"code":"610681","name":"子长市","province":"61","city":"06","area":"81"},{"code":"610702","name":"汉台区","province":"61","city":"07","area":"02"},{"code":"610703","name":"南郑区","province":"61","city":"07","area":"03"},{"code":"610722","name":"城固县","province":"61","city":"07","area":"22"},{"code":"610723","name":"洋县","province":"61","city":"07","area":"23"},{"code":"610724","name":"西乡县","province":"61","city":"07","area":"24"},{"code":"610725","name":"勉县","province":"61","city":"07","area":"25"},{"code":"610726","name":"宁强县","province":"61","city":"07","area":"26"},{"code":"610727","name":"略阳县","province":"61","city":"07","area":"27"},{"code":"610728","name":"镇巴县","province":"61","city":"07","area":"28"},{"code":"610729","name":"留坝县","province":"61","city":"07","area":"29"},{"code":"610730","name":"佛坪县","province":"61","city":"07","area":"30"},{"code":"610802","name":"榆阳区","province":"61","city":"08","area":"02"},{"code":"610803","name":"横山区","province":"61","city":"08","area":"03"},{"code":"610822","name":"府谷县","province":"61","city":"08","area":"22"},{"code":"610824","name":"靖边县","province":"61","city":"08","area":"24"},{"code":"610825","name":"定边县","province":"61","city":"08","area":"25"},{"code":"610826","name":"绥德县","province":"61","city":"08","area":"26"},{"code":"610827","name":"米脂县","province":"61","city":"08","area":"27"},{"code":"610828","name":"佳县","province":"61","city":"08","area":"28"},{"code":"610829","name":"吴堡县","province":"61","city":"08","area":"29"},{"code":"610830","name":"清涧县","province":"61","city":"08","area":"30"},{"code":"610831","name":"子洲县","province":"61","city":"08","area":"31"},{"code":"610881","name":"神木市","province":"61","city":"08","area":"81"},{"code":"610902","name":"汉滨区","province":"61","city":"09","area":"02"},{"code":"610921","name":"汉阴县","province":"61","city":"09","area":"21"},{"code":"610922","name":"石泉县","province":"61","city":"09","area":"22"},{"code":"610923","name":"宁陕县","province":"61","city":"09","area":"23"},{"code":"610924","name":"紫阳县","province":"61","city":"09","area":"24"},{"code":"610925","name":"岚皋县","province":"61","city":"09","area":"25"},{"code":"610926","name":"平利县","province":"61","city":"09","area":"26"},{"code":"610927","name":"镇坪县","province":"61","city":"09","area":"27"},{"code":"610928","name":"旬阳县","province":"61","city":"09","area":"28"},{"code":"610929","name":"白河县","province":"61","city":"09","area":"29"},{"code":"611002","name":"商州区","province":"61","city":"10","area":"02"},{"code":"611021","name":"洛南县","province":"61","city":"10","area":"21"},{"code":"611022","name":"丹凤县","province":"61","city":"10","area":"22"},{"code":"611023","name":"商南县","province":"61","city":"10","area":"23"},{"code":"611024","name":"山阳县","province":"61","city":"10","area":"24"},{"code":"611025","name":"镇安县","province":"61","city":"10","area":"25"},{"code":"611026","name":"柞水县","province":"61","city":"10","area":"26"},{"code":"620102","name":"城关区","province":"62","city":"01","area":"02"},{"code":"620103","name":"七里河区","province":"62","city":"01","area":"03"},{"code":"620104","name":"西固区","province":"62","city":"01","area":"04"},{"code":"620105","name":"安宁区","province":"62","city":"01","area":"05"},{"code":"620111","name":"红古区","province":"62","city":"01","area":"11"},{"code":"620121","name":"永登县","province":"62","city":"01","area":"21"},{"code":"620122","name":"皋兰县","province":"62","city":"01","area":"22"},{"code":"620123","name":"榆中县","province":"62","city":"01","area":"23"},{"code":"620302","name":"金川区","province":"62","city":"03","area":"02"},{"code":"620321","name":"永昌县","province":"62","city":"03","area":"21"},{"code":"620402","name":"白银区","province":"62","city":"04","area":"02"},{"code":"620403","name":"平川区","province":"62","city":"04","area":"03"},{"code":"620421","name":"靖远县","province":"62","city":"04","area":"21"},{"code":"620422","name":"会宁县","province":"62","city":"04","area":"22"},{"code":"620423","name":"景泰县","province":"62","city":"04","area":"23"},{"code":"620502","name":"秦州区","province":"62","city":"05","area":"02"},{"code":"620503","name":"麦积区","province":"62","city":"05","area":"03"},{"code":"620521","name":"清水县","province":"62","city":"05","area":"21"},{"code":"620522","name":"秦安县","province":"62","city":"05","area":"22"},{"code":"620523","name":"甘谷县","province":"62","city":"05","area":"23"},{"code":"620524","name":"武山县","province":"62","city":"05","area":"24"},{"code":"620525","name":"张家川回族自治县","province":"62","city":"05","area":"25"},{"code":"620602","name":"凉州区","province":"62","city":"06","area":"02"},{"code":"620621","name":"民勤县","province":"62","city":"06","area":"21"},{"code":"620622","name":"古浪县","province":"62","city":"06","area":"22"},{"code":"620623","name":"天祝藏族自治县","province":"62","city":"06","area":"23"},{"code":"620702","name":"甘州区","province":"62","city":"07","area":"02"},{"code":"620721","name":"肃南裕固族自治县","province":"62","city":"07","area":"21"},{"code":"620722","name":"民乐县","province":"62","city":"07","area":"22"},{"code":"620723","name":"临泽县","province":"62","city":"07","area":"23"},{"code":"620724","name":"高台县","province":"62","city":"07","area":"24"},{"code":"620725","name":"山丹县","province":"62","city":"07","area":"25"},{"code":"620802","name":"崆峒区","province":"62","city":"08","area":"02"},{"code":"620821","name":"泾川县","province":"62","city":"08","area":"21"},{"code":"620822","name":"灵台县","province":"62","city":"08","area":"22"},{"code":"620823","name":"崇信县","province":"62","city":"08","area":"23"},{"code":"620825","name":"庄浪县","province":"62","city":"08","area":"25"},{"code":"620826","name":"静宁县","province":"62","city":"08","area":"26"},{"code":"620881","name":"华亭市","province":"62","city":"08","area":"81"},{"code":"620902","name":"肃州区","province":"62","city":"09","area":"02"},{"code":"620921","name":"金塔县","province":"62","city":"09","area":"21"},{"code":"620922","name":"瓜州县","province":"62","city":"09","area":"22"},{"code":"620923","name":"肃北蒙古族自治县","province":"62","city":"09","area":"23"},{"code":"620924","name":"阿克塞哈萨克族自治县","province":"62","city":"09","area":"24"},{"code":"620981","name":"玉门市","province":"62","city":"09","area":"81"},{"code":"620982","name":"敦煌市","province":"62","city":"09","area":"82"},{"code":"621002","name":"西峰区","province":"62","city":"10","area":"02"},{"code":"621021","name":"庆城县","province":"62","city":"10","area":"21"},{"code":"621022","name":"环县","province":"62","city":"10","area":"22"},{"code":"621023","name":"华池县","province":"62","city":"10","area":"23"},{"code":"621024","name":"合水县","province":"62","city":"10","area":"24"},{"code":"621025","name":"正宁县","province":"62","city":"10","area":"25"},{"code":"621026","name":"宁县","province":"62","city":"10","area":"26"},{"code":"621027","name":"镇原县","province":"62","city":"10","area":"27"},{"code":"621102","name":"安定区","province":"62","city":"11","area":"02"},{"code":"621121","name":"通渭县","province":"62","city":"11","area":"21"},{"code":"621122","name":"陇西县","province":"62","city":"11","area":"22"},{"code":"621123","name":"渭源县","province":"62","city":"11","area":"23"},{"code":"621124","name":"临洮县","province":"62","city":"11","area":"24"},{"code":"621125","name":"漳县","province":"62","city":"11","area":"25"},{"code":"621126","name":"岷县","province":"62","city":"11","area":"26"},{"code":"621202","name":"武都区","province":"62","city":"12","area":"02"},{"code":"621221","name":"成县","province":"62","city":"12","area":"21"},{"code":"621222","name":"文县","province":"62","city":"12","area":"22"},{"code":"621223","name":"宕昌县","province":"62","city":"12","area":"23"},{"code":"621224","name":"康县","province":"62","city":"12","area":"24"},{"code":"621225","name":"西和县","province":"62","city":"12","area":"25"},{"code":"621226","name":"礼县","province":"62","city":"12","area":"26"},{"code":"621227","name":"徽县","province":"62","city":"12","area":"27"},{"code":"621228","name":"两当县","province":"62","city":"12","area":"28"},{"code":"622901","name":"临夏市","province":"62","city":"29","area":"01"},{"code":"622921","name":"临夏县","province":"62","city":"29","area":"21"},{"code":"622922","name":"康乐县","province":"62","city":"29","area":"22"},{"code":"622923","name":"永靖县","province":"62","city":"29","area":"23"},{"code":"622924","name":"广河县","province":"62","city":"29","area":"24"},{"code":"622925","name":"和政县","province":"62","city":"29","area":"25"},{"code":"622926","name":"东乡族自治县","province":"62","city":"29","area":"26"},{"code":"622927","name":"积石山保安族东乡族撒拉族自治县","province":"62","city":"29","area":"27"},{"code":"623001","name":"合作市","province":"62","city":"30","area":"01"},{"code":"623021","name":"临潭县","province":"62","city":"30","area":"21"},{"code":"623022","name":"卓尼县","province":"62","city":"30","area":"22"},{"code":"623023","name":"舟曲县","province":"62","city":"30","area":"23"},{"code":"623024","name":"迭部县","province":"62","city":"30","area":"24"},{"code":"623025","name":"玛曲县","province":"62","city":"30","area":"25"},{"code":"623026","name":"碌曲县","province":"62","city":"30","area":"26"},{"code":"623027","name":"夏河县","province":"62","city":"30","area":"27"},{"code":"630102","name":"城东区","province":"63","city":"01","area":"02"},{"code":"630103","name":"城中区","province":"63","city":"01","area":"03"},{"code":"630104","name":"城西区","province":"63","city":"01","area":"04"},{"code":"630105","name":"城北区","province":"63","city":"01","area":"05"},{"code":"630106","name":"湟中区","province":"63","city":"01","area":"06"},{"code":"630121","name":"大通回族土族自治县","province":"63","city":"01","area":"21"},{"code":"630123","name":"湟源县","province":"63","city":"01","area":"23"},{"code":"630202","name":"乐都区","province":"63","city":"02","area":"02"},{"code":"630203","name":"平安区","province":"63","city":"02","area":"03"},{"code":"630222","name":"民和回族土族自治县","province":"63","city":"02","area":"22"},{"code":"630223","name":"互助土族自治县","province":"63","city":"02","area":"23"},{"code":"630224","name":"化隆回族自治县","province":"63","city":"02","area":"24"},{"code":"630225","name":"循化撒拉族自治县","province":"63","city":"02","area":"25"},{"code":"632221","name":"门源回族自治县","province":"63","city":"22","area":"21"},{"code":"632222","name":"祁连县","province":"63","city":"22","area":"22"},{"code":"632223","name":"海晏县","province":"63","city":"22","area":"23"},{"code":"632224","name":"刚察县","province":"63","city":"22","area":"24"},{"code":"632301","name":"同仁市","province":"63","city":"23","area":"01"},{"code":"632322","name":"尖扎县","province":"63","city":"23","area":"22"},{"code":"632323","name":"泽库县","province":"63","city":"23","area":"23"},{"code":"632324","name":"河南蒙古族自治县","province":"63","city":"23","area":"24"},{"code":"632521","name":"共和县","province":"63","city":"25","area":"21"},{"code":"632522","name":"同德县","province":"63","city":"25","area":"22"},{"code":"632523","name":"贵德县","province":"63","city":"25","area":"23"},{"code":"632524","name":"兴海县","province":"63","city":"25","area":"24"},{"code":"632525","name":"贵南县","province":"63","city":"25","area":"25"},{"code":"632621","name":"玛沁县","province":"63","city":"26","area":"21"},{"code":"632622","name":"班玛县","province":"63","city":"26","area":"22"},{"code":"632623","name":"甘德县","province":"63","city":"26","area":"23"},{"code":"632624","name":"达日县","province":"63","city":"26","area":"24"},{"code":"632625","name":"久治县","province":"63","city":"26","area":"25"},{"code":"632626","name":"玛多县","province":"63","city":"26","area":"26"},{"code":"632701","name":"玉树市","province":"63","city":"27","area":"01"},{"code":"632722","name":"杂多县","province":"63","city":"27","area":"22"},{"code":"632723","name":"称多县","province":"63","city":"27","area":"23"},{"code":"632724","name":"治多县","province":"63","city":"27","area":"24"},{"code":"632725","name":"囊谦县","province":"63","city":"27","area":"25"},{"code":"632726","name":"曲麻莱县","province":"63","city":"27","area":"26"},{"code":"632801","name":"格尔木市","province":"63","city":"28","area":"01"},{"code":"632802","name":"德令哈市","province":"63","city":"28","area":"02"},{"code":"632803","name":"茫崖市","province":"63","city":"28","area":"03"},{"code":"632821","name":"乌兰县","province":"63","city":"28","area":"21"},{"code":"632822","name":"都兰县","province":"63","city":"28","area":"22"},{"code":"632823","name":"天峻县","province":"63","city":"28","area":"23"},{"code":"640104","name":"兴庆区","province":"64","city":"01","area":"04"},{"code":"640105","name":"西夏区","province":"64","city":"01","area":"05"},{"code":"640106","name":"金凤区","province":"64","city":"01","area":"06"},{"code":"640121","name":"永宁县","province":"64","city":"01","area":"21"},{"code":"640122","name":"贺兰县","province":"64","city":"01","area":"22"},{"code":"640181","name":"灵武市","province":"64","city":"01","area":"81"},{"code":"640202","name":"大武口区","province":"64","city":"02","area":"02"},{"code":"640205","name":"惠农区","province":"64","city":"02","area":"05"},{"code":"640221","name":"平罗县","province":"64","city":"02","area":"21"},{"code":"640302","name":"利通区","province":"64","city":"03","area":"02"},{"code":"640303","name":"红寺堡区","province":"64","city":"03","area":"03"},{"code":"640323","name":"盐池县","province":"64","city":"03","area":"23"},{"code":"640324","name":"同心县","province":"64","city":"03","area":"24"},{"code":"640381","name":"青铜峡市","province":"64","city":"03","area":"81"},{"code":"640402","name":"原州区","province":"64","city":"04","area":"02"},{"code":"640422","name":"西吉县","province":"64","city":"04","area":"22"},{"code":"640423","name":"隆德县","province":"64","city":"04","area":"23"},{"code":"640424","name":"泾源县","province":"64","city":"04","area":"24"},{"code":"640425","name":"彭阳县","province":"64","city":"04","area":"25"},{"code":"640502","name":"沙坡头区","province":"64","city":"05","area":"02"},{"code":"640521","name":"中宁县","province":"64","city":"05","area":"21"},{"code":"640522","name":"海原县","province":"64","city":"05","area":"22"},{"code":"650102","name":"天山区","province":"65","city":"01","area":"02"},{"code":"650103","name":"沙依巴克区","province":"65","city":"01","area":"03"},{"code":"650104","name":"新市区","province":"65","city":"01","area":"04"},{"code":"650105","name":"水磨沟区","province":"65","city":"01","area":"05"},{"code":"650106","name":"头屯河区","province":"65","city":"01","area":"06"},{"code":"650107","name":"达坂城区","province":"65","city":"01","area":"07"},{"code":"650109","name":"米东区","province":"65","city":"01","area":"09"},{"code":"650121","name":"乌鲁木齐县","province":"65","city":"01","area":"21"},{"code":"650202","name":"独山子区","province":"65","city":"02","area":"02"},{"code":"650203","name":"克拉玛依区","province":"65","city":"02","area":"03"},{"code":"650204","name":"白碱滩区","province":"65","city":"02","area":"04"},{"code":"650205","name":"乌尔禾区","province":"65","city":"02","area":"05"},{"code":"650402","name":"高昌区","province":"65","city":"04","area":"02"},{"code":"650421","name":"鄯善县","province":"65","city":"04","area":"21"},{"code":"650422","name":"托克逊县","province":"65","city":"04","area":"22"},{"code":"650502","name":"伊州区","province":"65","city":"05","area":"02"},{"code":"650521","name":"巴里坤哈萨克自治县","province":"65","city":"05","area":"21"},{"code":"650522","name":"伊吾县","province":"65","city":"05","area":"22"},{"code":"652301","name":"昌吉市","province":"65","city":"23","area":"01"},{"code":"652302","name":"阜康市","province":"65","city":"23","area":"02"},{"code":"652323","name":"呼图壁县","province":"65","city":"23","area":"23"},{"code":"652324","name":"玛纳斯县","province":"65","city":"23","area":"24"},{"code":"652325","name":"奇台县","province":"65","city":"23","area":"25"},{"code":"652327","name":"吉木萨尔县","province":"65","city":"23","area":"27"},{"code":"652328","name":"木垒哈萨克自治县","province":"65","city":"23","area":"28"},{"code":"652701","name":"博乐市","province":"65","city":"27","area":"01"},{"code":"652702","name":"阿拉山口市","province":"65","city":"27","area":"02"},{"code":"652722","name":"精河县","province":"65","city":"27","area":"22"},{"code":"652723","name":"温泉县","province":"65","city":"27","area":"23"},{"code":"652801","name":"库尔勒市","province":"65","city":"28","area":"01"},{"code":"652822","name":"轮台县","province":"65","city":"28","area":"22"},{"code":"652823","name":"尉犁县","province":"65","city":"28","area":"23"},{"code":"652824","name":"若羌县","province":"65","city":"28","area":"24"},{"code":"652825","name":"且末县","province":"65","city":"28","area":"25"},{"code":"652826","name":"焉耆回族自治县","province":"65","city":"28","area":"26"},{"code":"652827","name":"和静县","province":"65","city":"28","area":"27"},{"code":"652828","name":"和硕县","province":"65","city":"28","area":"28"},{"code":"652829","name":"博湖县","province":"65","city":"28","area":"29"},{"code":"652901","name":"阿克苏市","province":"65","city":"29","area":"01"},{"code":"652902","name":"库车市","province":"65","city":"29","area":"02"},{"code":"652922","name":"温宿县","province":"65","city":"29","area":"22"},{"code":"652924","name":"沙雅县","province":"65","city":"29","area":"24"},{"code":"652925","name":"新和县","province":"65","city":"29","area":"25"},{"code":"652926","name":"拜城县","province":"65","city":"29","area":"26"},{"code":"652927","name":"乌什县","province":"65","city":"29","area":"27"},{"code":"652928","name":"阿瓦提县","province":"65","city":"29","area":"28"},{"code":"652929","name":"柯坪县","province":"65","city":"29","area":"29"},{"code":"653001","name":"阿图什市","province":"65","city":"30","area":"01"},{"code":"653022","name":"阿克陶县","province":"65","city":"30","area":"22"},{"code":"653023","name":"阿合奇县","province":"65","city":"30","area":"23"},{"code":"653024","name":"乌恰县","province":"65","city":"30","area":"24"},{"code":"653101","name":"喀什市","province":"65","city":"31","area":"01"},{"code":"653121","name":"疏附县","province":"65","city":"31","area":"21"},{"code":"653122","name":"疏勒县","province":"65","city":"31","area":"22"},{"code":"653123","name":"英吉沙县","province":"65","city":"31","area":"23"},{"code":"653124","name":"泽普县","province":"65","city":"31","area":"24"},{"code":"653125","name":"莎车县","province":"65","city":"31","area":"25"},{"code":"653126","name":"叶城县","province":"65","city":"31","area":"26"},{"code":"653127","name":"麦盖提县","province":"65","city":"31","area":"27"},{"code":"653128","name":"岳普湖县","province":"65","city":"31","area":"28"},{"code":"653129","name":"伽师县","province":"65","city":"31","area":"29"},{"code":"653130","name":"巴楚县","province":"65","city":"31","area":"30"},{"code":"653131","name":"塔什库尔干塔吉克自治县","province":"65","city":"31","area":"31"},{"code":"653201","name":"和田市","province":"65","city":"32","area":"01"},{"code":"653221","name":"和田县","province":"65","city":"32","area":"21"},{"code":"653222","name":"墨玉县","province":"65","city":"32","area":"22"},{"code":"653223","name":"皮山县","province":"65","city":"32","area":"23"},{"code":"653224","name":"洛浦县","province":"65","city":"32","area":"24"},{"code":"653225","name":"策勒县","province":"65","city":"32","area":"25"},{"code":"653226","name":"于田县","province":"65","city":"32","area":"26"},{"code":"653227","name":"民丰县","province":"65","city":"32","area":"27"},{"code":"654002","name":"伊宁市","province":"65","city":"40","area":"02"},{"code":"654003","name":"奎屯市","province":"65","city":"40","area":"03"},{"code":"654004","name":"霍尔果斯市","province":"65","city":"40","area":"04"},{"code":"654021","name":"伊宁县","province":"65","city":"40","area":"21"},{"code":"654022","name":"察布查尔锡伯自治县","province":"65","city":"40","area":"22"},{"code":"654023","name":"霍城县","province":"65","city":"40","area":"23"},{"code":"654024","name":"巩留县","province":"65","city":"40","area":"24"},{"code":"654025","name":"新源县","province":"65","city":"40","area":"25"},{"code":"654026","name":"昭苏县","province":"65","city":"40","area":"26"},{"code":"654027","name":"特克斯县","province":"65","city":"40","area":"27"},{"code":"654028","name":"尼勒克县","province":"65","city":"40","area":"28"},{"code":"654201","name":"塔城市","province":"65","city":"42","area":"01"},{"code":"654202","name":"乌苏市","province":"65","city":"42","area":"02"},{"code":"654221","name":"额敏县","province":"65","city":"42","area":"21"},{"code":"654223","name":"沙湾县","province":"65","city":"42","area":"23"},{"code":"654224","name":"托里县","province":"65","city":"42","area":"24"},{"code":"654225","name":"裕民县","province":"65","city":"42","area":"25"},{"code":"654226","name":"和布克赛尔蒙古自治县","province":"65","city":"42","area":"26"},{"code":"654301","name":"阿勒泰市","province":"65","city":"43","area":"01"},{"code":"654321","name":"布尔津县","province":"65","city":"43","area":"21"},{"code":"654322","name":"富蕴县","province":"65","city":"43","area":"22"},{"code":"654323","name":"福海县","province":"65","city":"43","area":"23"},{"code":"654324","name":"哈巴河县","province":"65","city":"43","area":"24"},{"code":"654325","name":"青河县","province":"65","city":"43","area":"25"},{"code":"654326","name":"吉木乃县","province":"65","city":"43","area":"26"},{"code":"659001","name":"石河子市","province":"65","city":"90","area":"01"},{"code":"659002","name":"阿拉尔市","province":"65","city":"90","area":"02"},{"code":"659003","name":"图木舒克市","province":"65","city":"90","area":"03"},{"code":"659004","name":"五家渠市","province":"65","city":"90","area":"04"},{"code":"659005","name":"北屯市","province":"65","city":"90","area":"05"},{"code":"659006","name":"铁门关市","province":"65","city":"90","area":"06"},{"code":"659007","name":"双河市","province":"65","city":"90","area":"07"},{"code":"659008","name":"可克达拉市","province":"65","city":"90","area":"08"},{"code":"659009","name":"昆玉市","province":"65","city":"90","area":"09"},{"code":"659010","name":"胡杨河市","province":"65","city":"90","area":"10"},{"code":"659011","name":"新星市","province":"65","city":"90","area":"11"},{"code":"460321","name":"西沙群岛","province":"46","city":"03","area":"21"},{"code":"460322","name":"南沙群岛","province":"46","city":"03","area":"22"},{"code":"460323","name":"中沙群岛的岛礁及其海域","province":"46","city":"03","area":"23"},{"code":"130101","name":"市辖区","province":"13","city":"01","area":"01"},{"code":"130171","name":"石家庄高新技术产业开发区","province":"13","city":"01","area":"71"},{"code":"130172","name":"石家庄循环化工园区","province":"13","city":"01","area":"72"},{"code":"130201","name":"市辖区","province":"13","city":"02","area":"01"},{"code":"130271","name":"河北唐山芦台经济开发区","province":"13","city":"02","area":"71"},{"code":"130272","name":"唐山市汉沽管理区","province":"13","city":"02","area":"72"},{"code":"130273","name":"唐山高新技术产业开发区","province":"13","city":"02","area":"73"},{"code":"130274","name":"河北唐山海港经济开发区","province":"13","city":"02","area":"74"},{"code":"130301","name":"市辖区","province":"13","city":"03","area":"01"},{"code":"130371","name":"秦皇岛市经济技术开发区","province":"13","city":"03","area":"71"},{"code":"130372","name":"北戴河新区","province":"13","city":"03","area":"72"},{"code":"130401","name":"市辖区","province":"13","city":"04","area":"01"},{"code":"130471","name":"邯郸经济技术开发区","province":"13","city":"04","area":"71"},{"code":"130473","name":"邯郸冀南新区","province":"13","city":"04","area":"73"},{"code":"130501","name":"市辖区","province":"13","city":"05","area":"01"},{"code":"130571","name":"河北邢台经济开发区","province":"13","city":"05","area":"71"},{"code":"130601","name":"市辖区","province":"13","city":"06","area":"01"},{"code":"130671","name":"保定高新技术产业开发区","province":"13","city":"06","area":"71"},{"code":"130672","name":"保定白沟新城","province":"13","city":"06","area":"72"},{"code":"130701","name":"市辖区","province":"13","city":"07","area":"01"},{"code":"130771","name":"张家口经济开发区","province":"13","city":"07","area":"71"},{"code":"130772","name":"张家口市察北管理区","province":"13","city":"07","area":"72"},{"code":"130773","name":"张家口市塞北管理区","province":"13","city":"07","area":"73"},{"code":"130801","name":"市辖区","province":"13","city":"08","area":"01"},{"code":"130871","name":"承德高新技术产业开发区","province":"13","city":"08","area":"71"},{"code":"130901","name":"市辖区","province":"13","city":"09","area":"01"},{"code":"130971","name":"河北沧州经济开发区","province":"13","city":"09","area":"71"},{"code":"130972","name":"沧州高新技术产业开发区","province":"13","city":"09","area":"72"},{"code":"130973","name":"沧州渤海新区","province":"13","city":"09","area":"73"},{"code":"131001","name":"市辖区","province":"13","city":"10","area":"01"},{"code":"131071","name":"廊坊经济技术开发区","province":"13","city":"10","area":"71"},{"code":"131101","name":"市辖区","province":"13","city":"11","area":"01"},{"code":"131171","name":"河北衡水高新技术产业开发区","province":"13","city":"11","area":"71"},{"code":"131172","name":"衡水滨湖新区","province":"13","city":"11","area":"72"},{"code":"140101","name":"市辖区","province":"14","city":"01","area":"01"},{"code":"140171","name":"山西转型综合改革示范区","province":"14","city":"01","area":"71"},{"code":"140201","name":"市辖区","province":"14","city":"02","area":"01"},{"code":"140271","name":"山西大同经济开发区","province":"14","city":"02","area":"71"},{"code":"140301","name":"市辖区","province":"14","city":"03","area":"01"},{"code":"140401","name":"市辖区","province":"14","city":"04","area":"01"},{"code":"140471","name":"山西长治高新技术产业园区","province":"14","city":"04","area":"71"},{"code":"140501","name":"市辖区","province":"14","city":"05","area":"01"},{"code":"140601","name":"市辖区","province":"14","city":"06","area":"01"},{"code":"140671","name":"山西朔州经济开发区","province":"14","city":"06","area":"71"},{"code":"140701","name":"市辖区","province":"14","city":"07","area":"01"},{"code":"140801","name":"市辖区","province":"14","city":"08","area":"01"},{"code":"140901","name":"市辖区","province":"14","city":"09","area":"01"},{"code":"140971","name":"五台山风景名胜区","province":"14","city":"09","area":"71"},{"code":"141001","name":"市辖区","province":"14","city":"10","area":"01"},{"code":"141101","name":"市辖区","province":"14","city":"11","area":"01"},{"code":"150101","name":"市辖区","province":"15","city":"01","area":"01"},{"code":"150172","name":"呼和浩特经济技术开发区","province":"15","city":"01","area":"72"},{"code":"150201","name":"市辖区","province":"15","city":"02","area":"01"},{"code":"150271","name":"包头稀土高新技术产业开发区","province":"15","city":"02","area":"71"},{"code":"150301","name":"市辖区","province":"15","city":"03","area":"01"},{"code":"150401","name":"市辖区","province":"15","city":"04","area":"01"},{"code":"150501","name":"市辖区","province":"15","city":"05","area":"01"},{"code":"150571","name":"通辽经济技术开发区","province":"15","city":"05","area":"71"},{"code":"150601","name":"市辖区","province":"15","city":"06","area":"01"},{"code":"150701","name":"市辖区","province":"15","city":"07","area":"01"},{"code":"150801","name":"市辖区","province":"15","city":"08","area":"01"},{"code":"150901","name":"市辖区","province":"15","city":"09","area":"01"},{"code":"152571","name":"乌拉盖管委会","province":"15","city":"25","area":"71"},{"code":"152971","name":"内蒙古阿拉善高新技术产业开发区","province":"15","city":"29","area":"71"},{"code":"210101","name":"市辖区","province":"21","city":"01","area":"01"},{"code":"210201","name":"市辖区","province":"21","city":"02","area":"01"},{"code":"210301","name":"市辖区","province":"21","city":"03","area":"01"},{"code":"210401","name":"市辖区","province":"21","city":"04","area":"01"},{"code":"210501","name":"市辖区","province":"21","city":"05","area":"01"},{"code":"210601","name":"市辖区","province":"21","city":"06","area":"01"},{"code":"210701","name":"市辖区","province":"21","city":"07","area":"01"},{"code":"210801","name":"市辖区","province":"21","city":"08","area":"01"},{"code":"210901","name":"市辖区","province":"21","city":"09","area":"01"},{"code":"211001","name":"市辖区","province":"21","city":"10","area":"01"},{"code":"211101","name":"市辖区","province":"21","city":"11","area":"01"},{"code":"211201","name":"市辖区","province":"21","city":"12","area":"01"},{"code":"211301","name":"市辖区","province":"21","city":"13","area":"01"},{"code":"211401","name":"市辖区","province":"21","city":"14","area":"01"},{"code":"220101","name":"市辖区","province":"22","city":"01","area":"01"},{"code":"220171","name":"长春经济技术开发区","province":"22","city":"01","area":"71"},{"code":"220172","name":"长春净月高新技术产业开发区","province":"22","city":"01","area":"72"},{"code":"220173","name":"长春高新技术产业开发区","province":"22","city":"01","area":"73"},{"code":"220174","name":"长春汽车经济技术开发区","province":"22","city":"01","area":"74"},{"code":"220201","name":"市辖区","province":"22","city":"02","area":"01"},{"code":"220271","name":"吉林经济开发区","province":"22","city":"02","area":"71"},{"code":"220272","name":"吉林高新技术产业开发区","province":"22","city":"02","area":"72"},{"code":"220273","name":"吉林中国新加坡食品区","province":"22","city":"02","area":"73"},{"code":"220301","name":"市辖区","province":"22","city":"03","area":"01"},{"code":"220401","name":"市辖区","province":"22","city":"04","area":"01"},{"code":"220501","name":"市辖区","province":"22","city":"05","area":"01"},{"code":"220601","name":"市辖区","province":"22","city":"06","area":"01"},{"code":"220701","name":"市辖区","province":"22","city":"07","area":"01"},{"code":"220771","name":"吉林松原经济开发区","province":"22","city":"07","area":"71"},{"code":"220801","name":"市辖区","province":"22","city":"08","area":"01"},{"code":"220871","name":"吉林白城经济开发区","province":"22","city":"08","area":"71"},{"code":"230101","name":"市辖区","province":"23","city":"01","area":"01"},{"code":"230201","name":"市辖区","province":"23","city":"02","area":"01"},{"code":"230301","name":"市辖区","province":"23","city":"03","area":"01"},{"code":"230401","name":"市辖区","province":"23","city":"04","area":"01"},{"code":"230501","name":"市辖区","province":"23","city":"05","area":"01"},{"code":"230601","name":"市辖区","province":"23","city":"06","area":"01"},{"code":"230671","name":"大庆高新技术产业开发区","province":"23","city":"06","area":"71"},{"code":"230701","name":"市辖区","province":"23","city":"07","area":"01"},{"code":"230801","name":"市辖区","province":"23","city":"08","area":"01"},{"code":"230901","name":"市辖区","province":"23","city":"09","area":"01"},{"code":"231001","name":"市辖区","province":"23","city":"10","area":"01"},{"code":"231071","name":"牡丹江经济技术开发区","province":"23","city":"10","area":"71"},{"code":"231101","name":"市辖区","province":"23","city":"11","area":"01"},{"code":"231201","name":"市辖区","province":"23","city":"12","area":"01"},{"code":"232761","name":"加格达奇区","province":"23","city":"27","area":"61"},{"code":"232762","name":"松岭区","province":"23","city":"27","area":"62"},{"code":"232763","name":"新林区","province":"23","city":"27","area":"63"},{"code":"232764","name":"呼中区","province":"23","city":"27","area":"64"},{"code":"320101","name":"市辖区","province":"32","city":"01","area":"01"},{"code":"320201","name":"市辖区","province":"32","city":"02","area":"01"},{"code":"320301","name":"市辖区","province":"32","city":"03","area":"01"},{"code":"320371","name":"徐州经济技术开发区","province":"32","city":"03","area":"71"},{"code":"320401","name":"市辖区","province":"32","city":"04","area":"01"},{"code":"320501","name":"市辖区","province":"32","city":"05","area":"01"},{"code":"320571","name":"苏州工业园区","province":"32","city":"05","area":"71"},{"code":"320601","name":"市辖区","province":"32","city":"06","area":"01"},{"code":"320671","name":"南通经济技术开发区","province":"32","city":"06","area":"71"},{"code":"320701","name":"市辖区","province":"32","city":"07","area":"01"},{"code":"320771","name":"连云港经济技术开发区","province":"32","city":"07","area":"71"},{"code":"320772","name":"连云港高新技术产业开发区","province":"32","city":"07","area":"72"},{"code":"320801","name":"市辖区","province":"32","city":"08","area":"01"},{"code":"320871","name":"淮安经济技术开发区","province":"32","city":"08","area":"71"},{"code":"320901","name":"市辖区","province":"32","city":"09","area":"01"},{"code":"320971","name":"盐城经济技术开发区","province":"32","city":"09","area":"71"},{"code":"321001","name":"市辖区","province":"32","city":"10","area":"01"},{"code":"321071","name":"扬州经济技术开发区","province":"32","city":"10","area":"71"},{"code":"321101","name":"市辖区","province":"32","city":"11","area":"01"},{"code":"321171","name":"镇江新区","province":"32","city":"11","area":"71"},{"code":"321201","name":"市辖区","province":"32","city":"12","area":"01"},{"code":"321271","name":"泰州医药高新技术产业开发区","province":"32","city":"12","area":"71"},{"code":"321301","name":"市辖区","province":"32","city":"13","area":"01"},{"code":"321371","name":"宿迁经济技术开发区","province":"32","city":"13","area":"71"},{"code":"330101","name":"市辖区","province":"33","city":"01","area":"01"},{"code":"330113","name":"临平区","province":"33","city":"01","area":"13"},{"code":"330114","name":"钱塘区","province":"33","city":"01","area":"14"},{"code":"330201","name":"市辖区","province":"33","city":"02","area":"01"},{"code":"330301","name":"市辖区","province":"33","city":"03","area":"01"},{"code":"330371","name":"温州经济技术开发区","province":"33","city":"03","area":"71"},{"code":"330401","name":"市辖区","province":"33","city":"04","area":"01"},{"code":"330501","name":"市辖区","province":"33","city":"05","area":"01"},{"code":"330601","name":"市辖区","province":"33","city":"06","area":"01"},{"code":"330701","name":"市辖区","province":"33","city":"07","area":"01"},{"code":"330801","name":"市辖区","province":"33","city":"08","area":"01"},{"code":"330901","name":"市辖区","province":"33","city":"09","area":"01"},{"code":"331001","name":"市辖区","province":"33","city":"10","area":"01"},{"code":"331101","name":"市辖区","province":"33","city":"11","area":"01"},{"code":"340101","name":"市辖区","province":"34","city":"01","area":"01"},{"code":"340171","name":"合肥高新技术产业开发区","province":"34","city":"01","area":"71"},{"code":"340172","name":"合肥经济技术开发区","province":"34","city":"01","area":"72"},{"code":"340173","name":"合肥新站高新技术产业开发区","province":"34","city":"01","area":"73"},{"code":"340201","name":"市辖区","province":"34","city":"02","area":"01"},{"code":"340271","name":"芜湖经济技术开发区","province":"34","city":"02","area":"71"},{"code":"340272","name":"安徽芜湖三山经济开发区","province":"34","city":"02","area":"72"},{"code":"340301","name":"市辖区","province":"34","city":"03","area":"01"},{"code":"340371","name":"蚌埠市高新技术开发区","province":"34","city":"03","area":"71"},{"code":"340372","name":"蚌埠市经济开发区","province":"34","city":"03","area":"72"},{"code":"340401","name":"市辖区","province":"34","city":"04","area":"01"},{"code":"340501","name":"市辖区","province":"34","city":"05","area":"01"},{"code":"340601","name":"市辖区","province":"34","city":"06","area":"01"},{"code":"340701","name":"市辖区","province":"34","city":"07","area":"01"},{"code":"340801","name":"市辖区","province":"34","city":"08","area":"01"},{"code":"340871","name":"安徽安庆经济开发区","province":"34","city":"08","area":"71"},{"code":"341001","name":"市辖区","province":"34","city":"10","area":"01"},{"code":"341101","name":"市辖区","province":"34","city":"11","area":"01"},{"code":"341171","name":"中新苏滁高新技术产业开发区","province":"34","city":"11","area":"71"},{"code":"341172","name":"滁州经济技术开发区","province":"34","city":"11","area":"72"},{"code":"341201","name":"市辖区","province":"34","city":"12","area":"01"},{"code":"341271","name":"阜阳合肥现代产业园区","province":"34","city":"12","area":"71"},{"code":"341272","name":"阜阳经济技术开发区","province":"34","city":"12","area":"72"},{"code":"341301","name":"市辖区","province":"34","city":"13","area":"01"},{"code":"341371","name":"宿州马鞍山现代产业园区","province":"34","city":"13","area":"71"},{"code":"341372","name":"宿州经济技术开发区","province":"34","city":"13","area":"72"},{"code":"341501","name":"市辖区","province":"34","city":"15","area":"01"},{"code":"341601","name":"市辖区","province":"34","city":"16","area":"01"},{"code":"341701","name":"市辖区","province":"34","city":"17","area":"01"},{"code":"341801","name":"市辖区","province":"34","city":"18","area":"01"},{"code":"341871","name":"宣城市经济开发区","province":"34","city":"18","area":"71"},{"code":"350101","name":"市辖区","province":"35","city":"01","area":"01"},{"code":"350201","name":"市辖区","province":"35","city":"02","area":"01"},{"code":"350301","name":"市辖区","province":"35","city":"03","area":"01"},{"code":"350401","name":"市辖区","province":"35","city":"04","area":"01"},{"code":"350404","name":"三元区","province":"35","city":"04","area":"04"},{"code":"350405","name":"沙县区","province":"35","city":"04","area":"05"},{"code":"350501","name":"市辖区","province":"35","city":"05","area":"01"},{"code":"350601","name":"市辖区","province":"35","city":"06","area":"01"},{"code":"350604","name":"龙海区","province":"35","city":"06","area":"04"},{"code":"350605","name":"长泰区","province":"35","city":"06","area":"05"},{"code":"350701","name":"市辖区","province":"35","city":"07","area":"01"},{"code":"350801","name":"市辖区","province":"35","city":"08","area":"01"},{"code":"350901","name":"市辖区","province":"35","city":"09","area":"01"},{"code":"360101","name":"市辖区","province":"36","city":"01","area":"01"},{"code":"360201","name":"市辖区","province":"36","city":"02","area":"01"},{"code":"360301","name":"市辖区","province":"36","city":"03","area":"01"},{"code":"360401","name":"市辖区","province":"36","city":"04","area":"01"},{"code":"360501","name":"市辖区","province":"36","city":"05","area":"01"},{"code":"360601","name":"市辖区","province":"36","city":"06","area":"01"},{"code":"360701","name":"市辖区","province":"36","city":"07","area":"01"},{"code":"360801","name":"市辖区","province":"36","city":"08","area":"01"},{"code":"360901","name":"市辖区","province":"36","city":"09","area":"01"},{"code":"361001","name":"市辖区","province":"36","city":"10","area":"01"},{"code":"361101","name":"市辖区","province":"36","city":"11","area":"01"},{"code":"370101","name":"市辖区","province":"37","city":"01","area":"01"},{"code":"370171","name":"济南高新技术产业开发区","province":"37","city":"01","area":"71"},{"code":"370201","name":"市辖区","province":"37","city":"02","area":"01"},{"code":"370271","name":"青岛高新技术产业开发区","province":"37","city":"02","area":"71"},{"code":"370301","name":"市辖区","province":"37","city":"03","area":"01"},{"code":"370401","name":"市辖区","province":"37","city":"04","area":"01"},{"code":"370501","name":"市辖区","province":"37","city":"05","area":"01"},{"code":"370571","name":"东营经济技术开发区","province":"37","city":"05","area":"71"},{"code":"370572","name":"东营港经济开发区","province":"37","city":"05","area":"72"},{"code":"370601","name":"市辖区","province":"37","city":"06","area":"01"},{"code":"370671","name":"烟台高新技术产业开发区","province":"37","city":"06","area":"71"},{"code":"370672","name":"烟台经济技术开发区","province":"37","city":"06","area":"72"},{"code":"370701","name":"市辖区","province":"37","city":"07","area":"01"},{"code":"370772","name":"潍坊滨海经济技术开发区","province":"37","city":"07","area":"72"},{"code":"370801","name":"市辖区","province":"37","city":"08","area":"01"},{"code":"370871","name":"济宁高新技术产业开发区","province":"37","city":"08","area":"71"},{"code":"370901","name":"市辖区","province":"37","city":"09","area":"01"},{"code":"371001","name":"市辖区","province":"37","city":"10","area":"01"},{"code":"371071","name":"威海火炬高技术产业开发区","province":"37","city":"10","area":"71"},{"code":"371072","name":"威海经济技术开发区","province":"37","city":"10","area":"72"},{"code":"371073","name":"威海临港经济技术开发区","province":"37","city":"10","area":"73"},{"code":"371101","name":"市辖区","province":"37","city":"11","area":"01"},{"code":"371171","name":"日照经济技术开发区","province":"37","city":"11","area":"71"},{"code":"371301","name":"市辖区","province":"37","city":"13","area":"01"},{"code":"371371","name":"临沂高新技术产业开发区","province":"37","city":"13","area":"71"},{"code":"371401","name":"市辖区","province":"37","city":"14","area":"01"},{"code":"371471","name":"德州经济技术开发区","province":"37","city":"14","area":"71"},{"code":"371472","name":"德州运河经济开发区","province":"37","city":"14","area":"72"},{"code":"371501","name":"市辖区","province":"37","city":"15","area":"01"},{"code":"371601","name":"市辖区","province":"37","city":"16","area":"01"},{"code":"371701","name":"市辖区","province":"37","city":"17","area":"01"},{"code":"371771","name":"菏泽经济技术开发区","province":"37","city":"17","area":"71"},{"code":"371772","name":"菏泽高新技术开发区","province":"37","city":"17","area":"72"},{"code":"410101","name":"市辖区","province":"41","city":"01","area":"01"},{"code":"410171","name":"郑州经济技术开发区","province":"41","city":"01","area":"71"},{"code":"410172","name":"郑州高新技术产业开发区","province":"41","city":"01","area":"72"},{"code":"410173","name":"郑州航空港经济综合实验区","province":"41","city":"01","area":"73"},{"code":"410201","name":"市辖区","province":"41","city":"02","area":"01"},{"code":"410301","name":"市辖区","province":"41","city":"03","area":"01"},{"code":"410307","name":"偃师区","province":"41","city":"03","area":"07"},{"code":"410308","name":"孟津区","province":"41","city":"03","area":"08"},{"code":"410371","name":"洛阳高新技术产业开发区","province":"41","city":"03","area":"71"},{"code":"410401","name":"市辖区","province":"41","city":"04","area":"01"},{"code":"410471","name":"平顶山高新技术产业开发区","province":"41","city":"04","area":"71"},{"code":"410472","name":"平顶山市城乡一体化示范区","province":"41","city":"04","area":"72"},{"code":"410501","name":"市辖区","province":"41","city":"05","area":"01"},{"code":"410571","name":"安阳高新技术产业开发区","province":"41","city":"05","area":"71"},{"code":"410601","name":"市辖区","province":"41","city":"06","area":"01"},{"code":"410671","name":"鹤壁经济技术开发区","province":"41","city":"06","area":"71"},{"code":"410701","name":"市辖区","province":"41","city":"07","area":"01"},{"code":"410771","name":"新乡高新技术产业开发区","province":"41","city":"07","area":"71"},{"code":"410772","name":"新乡经济技术开发区","province":"41","city":"07","area":"72"},{"code":"410773","name":"新乡市平原城乡一体化示范区","province":"41","city":"07","area":"73"},{"code":"410801","name":"市辖区","province":"41","city":"08","area":"01"},{"code":"410871","name":"焦作城乡一体化示范区","province":"41","city":"08","area":"71"},{"code":"410901","name":"市辖区","province":"41","city":"09","area":"01"},{"code":"410971","name":"河南濮阳工业园区","province":"41","city":"09","area":"71"},{"code":"410972","name":"濮阳经济技术开发区","province":"41","city":"09","area":"72"},{"code":"411001","name":"市辖区","province":"41","city":"10","area":"01"},{"code":"411071","name":"许昌经济技术开发区","province":"41","city":"10","area":"71"},{"code":"411101","name":"市辖区","province":"41","city":"11","area":"01"},{"code":"411171","name":"漯河经济技术开发区","province":"41","city":"11","area":"71"},{"code":"411201","name":"市辖区","province":"41","city":"12","area":"01"},{"code":"411271","name":"河南三门峡经济开发区","province":"41","city":"12","area":"71"},{"code":"411301","name":"市辖区","province":"41","city":"13","area":"01"},{"code":"411371","name":"南阳高新技术产业开发区","province":"41","city":"13","area":"71"},{"code":"411372","name":"南阳市城乡一体化示范区","province":"41","city":"13","area":"72"},{"code":"411401","name":"市辖区","province":"41","city":"14","area":"01"},{"code":"411471","name":"豫东综合物流产业聚集区","province":"41","city":"14","area":"71"},{"code":"411472","name":"河南商丘经济开发区","province":"41","city":"14","area":"72"},{"code":"411501","name":"市辖区","province":"41","city":"15","area":"01"},{"code":"411571","name":"信阳高新技术产业开发区","province":"41","city":"15","area":"71"},{"code":"411601","name":"市辖区","province":"41","city":"16","area":"01"},{"code":"411671","name":"河南周口经济开发区","province":"41","city":"16","area":"71"},{"code":"411701","name":"市辖区","province":"41","city":"17","area":"01"},{"code":"411771","name":"河南驻马店经济开发区","province":"41","city":"17","area":"71"},{"code":"420101","name":"市辖区","province":"42","city":"01","area":"01"},{"code":"420201","name":"市辖区","province":"42","city":"02","area":"01"},{"code":"420301","name":"市辖区","province":"42","city":"03","area":"01"},{"code":"420501","name":"市辖区","province":"42","city":"05","area":"01"},{"code":"420601","name":"市辖区","province":"42","city":"06","area":"01"},{"code":"420701","name":"市辖区","province":"42","city":"07","area":"01"},{"code":"420801","name":"市辖区","province":"42","city":"08","area":"01"},{"code":"420901","name":"市辖区","province":"42","city":"09","area":"01"},{"code":"421001","name":"市辖区","province":"42","city":"10","area":"01"},{"code":"421071","name":"荆州经济技术开发区","province":"42","city":"10","area":"71"},{"code":"421101","name":"市辖区","province":"42","city":"11","area":"01"},{"code":"421171","name":"龙感湖管理区","province":"42","city":"11","area":"71"},{"code":"421201","name":"市辖区","province":"42","city":"12","area":"01"},{"code":"421301","name":"市辖区","province":"42","city":"13","area":"01"},{"code":"430101","name":"市辖区","province":"43","city":"01","area":"01"},{"code":"430201","name":"市辖区","province":"43","city":"02","area":"01"},{"code":"430271","name":"云龙示范区","province":"43","city":"02","area":"71"},{"code":"430301","name":"市辖区","province":"43","city":"03","area":"01"},{"code":"430371","name":"湖南湘潭高新技术产业园区","province":"43","city":"03","area":"71"},{"code":"430372","name":"湘潭昭山示范区","province":"43","city":"03","area":"72"},{"code":"430373","name":"湘潭九华示范区","province":"43","city":"03","area":"73"},{"code":"430401","name":"市辖区","province":"43","city":"04","area":"01"},{"code":"430471","name":"衡阳综合保税区","province":"43","city":"04","area":"71"},{"code":"430472","name":"湖南衡阳高新技术产业园区","province":"43","city":"04","area":"72"},{"code":"430473","name":"湖南衡阳松木经济开发区","province":"43","city":"04","area":"73"},{"code":"430501","name":"市辖区","province":"43","city":"05","area":"01"},{"code":"430601","name":"市辖区","province":"43","city":"06","area":"01"},{"code":"430671","name":"岳阳市屈原管理区","province":"43","city":"06","area":"71"},{"code":"430701","name":"市辖区","province":"43","city":"07","area":"01"},{"code":"430771","name":"常德市西洞庭管理区","province":"43","city":"07","area":"71"},{"code":"430801","name":"市辖区","province":"43","city":"08","area":"01"},{"code":"430901","name":"市辖区","province":"43","city":"09","area":"01"},{"code":"430971","name":"益阳市大通湖管理区","province":"43","city":"09","area":"71"},{"code":"430972","name":"湖南益阳高新技术产业园区","province":"43","city":"09","area":"72"},{"code":"431001","name":"市辖区","province":"43","city":"10","area":"01"},{"code":"431101","name":"市辖区","province":"43","city":"11","area":"01"},{"code":"431171","name":"永州经济技术开发区","province":"43","city":"11","area":"71"},{"code":"431173","name":"永州市回龙圩管理区","province":"43","city":"11","area":"73"},{"code":"431181","name":"祁阳市","province":"43","city":"11","area":"81"},{"code":"431201","name":"市辖区","province":"43","city":"12","area":"01"},{"code":"431271","name":"怀化市洪江管理区","province":"43","city":"12","area":"71"},{"code":"431301","name":"市辖区","province":"43","city":"13","area":"01"},{"code":"440101","name":"市辖区","province":"44","city":"01","area":"01"},{"code":"440201","name":"市辖区","province":"44","city":"02","area":"01"},{"code":"440301","name":"市辖区","province":"44","city":"03","area":"01"},{"code":"440401","name":"市辖区","province":"44","city":"04","area":"01"},{"code":"440501","name":"市辖区","province":"44","city":"05","area":"01"},{"code":"440601","name":"市辖区","province":"44","city":"06","area":"01"},{"code":"440701","name":"市辖区","province":"44","city":"07","area":"01"},{"code":"440801","name":"市辖区","province":"44","city":"08","area":"01"},{"code":"440901","name":"市辖区","province":"44","city":"09","area":"01"},{"code":"441201","name":"市辖区","province":"44","city":"12","area":"01"},{"code":"441301","name":"市辖区","province":"44","city":"13","area":"01"},{"code":"441401","name":"市辖区","province":"44","city":"14","area":"01"},{"code":"441501","name":"市辖区","province":"44","city":"15","area":"01"},{"code":"441601","name":"市辖区","province":"44","city":"16","area":"01"},{"code":"441701","name":"市辖区","province":"44","city":"17","area":"01"},{"code":"441801","name":"市辖区","province":"44","city":"18","area":"01"},{"code":"445101","name":"市辖区","province":"44","city":"51","area":"01"},{"code":"445201","name":"市辖区","province":"44","city":"52","area":"01"},{"code":"445301","name":"市辖区","province":"44","city":"53","area":"01"},{"code":"450101","name":"市辖区","province":"45","city":"01","area":"01"},{"code":"450181","name":"横州市","province":"45","city":"01","area":"81"},{"code":"450201","name":"市辖区","province":"45","city":"02","area":"01"},{"code":"450301","name":"市辖区","province":"45","city":"03","area":"01"},{"code":"450401","name":"市辖区","province":"45","city":"04","area":"01"},{"code":"450501","name":"市辖区","province":"45","city":"05","area":"01"},{"code":"450601","name":"市辖区","province":"45","city":"06","area":"01"},{"code":"450701","name":"市辖区","province":"45","city":"07","area":"01"},{"code":"450801","name":"市辖区","province":"45","city":"08","area":"01"},{"code":"450901","name":"市辖区","province":"45","city":"09","area":"01"},{"code":"451001","name":"市辖区","province":"45","city":"10","area":"01"},{"code":"451101","name":"市辖区","province":"45","city":"11","area":"01"},{"code":"451201","name":"市辖区","province":"45","city":"12","area":"01"},{"code":"451301","name":"市辖区","province":"45","city":"13","area":"01"},{"code":"451401","name":"市辖区","province":"45","city":"14","area":"01"},{"code":"460101","name":"市辖区","province":"46","city":"01","area":"01"},{"code":"460201","name":"市辖区","province":"46","city":"02","area":"01"},{"code":"510101","name":"市辖区","province":"51","city":"01","area":"01"},{"code":"510301","name":"市辖区","province":"51","city":"03","area":"01"},{"code":"510401","name":"市辖区","province":"51","city":"04","area":"01"},{"code":"510501","name":"市辖区","province":"51","city":"05","area":"01"},{"code":"510601","name":"市辖区","province":"51","city":"06","area":"01"},{"code":"510701","name":"市辖区","province":"51","city":"07","area":"01"},{"code":"510801","name":"市辖区","province":"51","city":"08","area":"01"},{"code":"510901","name":"市辖区","province":"51","city":"09","area":"01"},{"code":"511001","name":"市辖区","province":"51","city":"10","area":"01"},{"code":"511071","name":"内江经济开发区","province":"51","city":"10","area":"71"},{"code":"511101","name":"市辖区","province":"51","city":"11","area":"01"},{"code":"511301","name":"市辖区","province":"51","city":"13","area":"01"},{"code":"511401","name":"市辖区","province":"51","city":"14","area":"01"},{"code":"511501","name":"市辖区","province":"51","city":"15","area":"01"},{"code":"511601","name":"市辖区","province":"51","city":"16","area":"01"},{"code":"511701","name":"市辖区","province":"51","city":"17","area":"01"},{"code":"511771","name":"达州经济开发区","province":"51","city":"17","area":"71"},{"code":"511801","name":"市辖区","province":"51","city":"18","area":"01"},{"code":"511901","name":"市辖区","province":"51","city":"19","area":"01"},{"code":"511971","name":"巴中经济开发区","province":"51","city":"19","area":"71"},{"code":"512001","name":"市辖区","province":"51","city":"20","area":"01"},{"code":"513402","name":"会理市","province":"51","city":"34","area":"02"},{"code":"520101","name":"市辖区","province":"52","city":"01","area":"01"},{"code":"520301","name":"市辖区","province":"52","city":"03","area":"01"},{"code":"520401","name":"市辖区","province":"52","city":"04","area":"01"},{"code":"520501","name":"市辖区","province":"52","city":"05","area":"01"},{"code":"520581","name":"黔西市","province":"52","city":"05","area":"81"},{"code":"520601","name":"市辖区","province":"52","city":"06","area":"01"},{"code":"530101","name":"市辖区","province":"53","city":"01","area":"01"},{"code":"530301","name":"市辖区","province":"53","city":"03","area":"01"},{"code":"530401","name":"市辖区","province":"53","city":"04","area":"01"},{"code":"530501","name":"市辖区","province":"53","city":"05","area":"01"},{"code":"530601","name":"市辖区","province":"53","city":"06","area":"01"},{"code":"530701","name":"市辖区","province":"53","city":"07","area":"01"},{"code":"530801","name":"市辖区","province":"53","city":"08","area":"01"},{"code":"530901","name":"市辖区","province":"53","city":"09","area":"01"},{"code":"532302","name":"禄丰市","province":"53","city":"23","area":"02"},{"code":"540101","name":"市辖区","province":"54","city":"01","area":"01"},{"code":"540171","name":"格尔木藏青工业园区","province":"54","city":"01","area":"71"},{"code":"540172","name":"拉萨经济技术开发区","province":"54","city":"01","area":"72"},{"code":"540173","name":"西藏文化旅游创意园区","province":"54","city":"01","area":"73"},{"code":"540174","name":"达孜工业园区","province":"54","city":"01","area":"74"},{"code":"540501","name":"市辖区","province":"54","city":"05","area":"01"},{"code":"610101","name":"市辖区","province":"61","city":"01","area":"01"},{"code":"610201","name":"市辖区","province":"61","city":"02","area":"01"},{"code":"610301","name":"市辖区","province":"61","city":"03","area":"01"},{"code":"610305","name":"凤翔区","province":"61","city":"03","area":"05"},{"code":"610401","name":"市辖区","province":"61","city":"04","area":"01"},{"code":"610501","name":"市辖区","province":"61","city":"05","area":"01"},{"code":"610601","name":"市辖区","province":"61","city":"06","area":"01"},{"code":"610701","name":"市辖区","province":"61","city":"07","area":"01"},{"code":"610801","name":"市辖区","province":"61","city":"08","area":"01"},{"code":"610901","name":"市辖区","province":"61","city":"09","area":"01"},{"code":"610981","name":"旬阳市","province":"61","city":"09","area":"81"},{"code":"611001","name":"市辖区","province":"61","city":"10","area":"01"},{"code":"620101","name":"市辖区","province":"62","city":"01","area":"01"},{"code":"620171","name":"兰州新区","province":"62","city":"01","area":"71"},{"code":"620201","name":"市辖区","province":"62","city":"02","area":"01"},{"code":"620301","name":"市辖区","province":"62","city":"03","area":"01"},{"code":"620401","name":"市辖区","province":"62","city":"04","area":"01"},{"code":"620501","name":"市辖区","province":"62","city":"05","area":"01"},{"code":"620601","name":"市辖区","province":"62","city":"06","area":"01"},{"code":"620701","name":"市辖区","province":"62","city":"07","area":"01"},{"code":"620801","name":"市辖区","province":"62","city":"08","area":"01"},{"code":"620901","name":"市辖区","province":"62","city":"09","area":"01"},{"code":"621001","name":"市辖区","province":"62","city":"10","area":"01"},{"code":"621101","name":"市辖区","province":"62","city":"11","area":"01"},{"code":"621201","name":"市辖区","province":"62","city":"12","area":"01"},{"code":"630101","name":"市辖区","province":"63","city":"01","area":"01"},{"code":"632857","name":"大柴旦行政委员会","province":"63","city":"28","area":"57"},{"code":"640101","name":"市辖区","province":"64","city":"01","area":"01"},{"code":"640201","name":"市辖区","province":"64","city":"02","area":"01"},{"code":"640301","name":"市辖区","province":"64","city":"03","area":"01"},{"code":"640401","name":"市辖区","province":"64","city":"04","area":"01"},{"code":"640501","name":"市辖区","province":"64","city":"05","area":"01"},{"code":"650101","name":"市辖区","province":"65","city":"01","area":"01"},{"code":"650201","name":"市辖区","province":"65","city":"02","area":"01"},{"code":"652871","name":"库尔勒经济技术开发区","province":"65","city":"28","area":"71"},{"code":"654203","name":"沙湾市","province":"65","city":"42","area":"03"}]

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpCreateAftersaleScene_vue__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpCreateAftersaleScene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpCreateAftersaleScene_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpCreateAftersaleScene_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpCreateAftersaleScene_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06264f63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpCreateAftersaleScene_vue__ = __webpack_require__(1373);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1366)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06264f63"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpCreateAftersaleScene_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06264f63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpCreateAftersaleScene_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/jushuitan/JstErpCreateAftersaleScene.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06264f63", Component.options)
  } else {
    hotAPI.reload("data-v-06264f63", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StepPlayer = _interopRequireDefault(__webpack_require__(74));
var _jstErpCreateAftersaleScenarios = __webpack_require__(1368);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JstErpCreateAftersaleScene',
  components: {
    StepPlayer: _StepPlayer.default
  },
  data: function data() {
    return {
      scenario: (0, _jstErpCreateAftersaleScenarios.getJstErpCreateAftersaleScenario)()
    };
  },
  methods: {
    onStepChange: function onStepChange(stepId, step, resolvedTip) {
      this.$emit('step-change', stepId, step, resolvedTip);
    },
    onGuardFailed: function onGuardFailed(res) {
      this.$emit('guard-failed', res);
    },
    onFinish: function onFinish(payload) {
      this.$emit('finish', payload);
    },
    reset: function reset() {
      var player = this.$refs.player;
      if (player) player.reset(this.scenario.initialStepId);
    }
  }
};

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpOrderQueryScene_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpOrderQueryScene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpOrderQueryScene_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpOrderQueryScene_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpOrderQueryScene_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ff6ff64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpOrderQueryScene_vue__ = __webpack_require__(1377);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1374)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ff6ff64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpOrderQueryScene_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ff6ff64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpOrderQueryScene_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/jushuitan/JstErpOrderQueryScene.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ff6ff64", Component.options)
  } else {
    hotAPI.reload("data-v-4ff6ff64", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StepPlayer = _interopRequireDefault(__webpack_require__(74));
var _jstErpOrderQueryScenarios = __webpack_require__(1376);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JstErpOrderQueryScene',
  components: {
    StepPlayer: _StepPlayer.default
  },
  data: function data() {
    return {
      scenario: (0, _jstErpOrderQueryScenarios.getJstErpOrderQueryScenario)()
    };
  },
  methods: {
    onStepChange: function onStepChange(stepId, step, resolvedTip) {
      this.$emit('step-change', stepId, step, resolvedTip);
    },
    onGuardFailed: function onGuardFailed(res) {
      this.$emit('guard-failed', res);
    },
    onFinish: function onFinish(payload) {
      this.$emit('finish', payload);
    },
    reset: function reset() {
      var player = this.$refs.player;
      if (player) player.reset(this.scenario.initialStepId);
    }
  }
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JstErpPlaceholderScene'
};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _JstErpLoginScene = _interopRequireDefault(__webpack_require__(580));
var _JstErpSecondScene = _interopRequireDefault(__webpack_require__(582));
var _JstErpCreateAftersaleScene = _interopRequireDefault(__webpack_require__(587));
var _JstErpOrderQueryScene = _interopRequireDefault(__webpack_require__(589));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var CHAPTERS = [{
  key: 'first',
  title: '1、登记无条件信息'
}, {
  key: 'second',
  title: '2、手工创建售后单'
}, {
  key: 'third',
  title: '3、创建售后'
}, {
  key: 'four',
  title: '4、订单查询'
}];
var _default = exports.default = {
  name: 'JuShuiTanErpExam',
  components: {
    JstErpLoginScene: _JstErpLoginScene.default,
    JstErpSecondScene: _JstErpSecondScene.default,
    JstErpCreateAftersaleScene: _JstErpCreateAftersaleScene.default,
    JstErpOrderQueryScene: _JstErpOrderQueryScene.default
  },
  data: function data() {
    return {
      chapters: CHAPTERS,
      tabCurrent: 'first',
      rightTip: '',
      rightTipStep: '',
      finishTimer: null,
      state: {
        practiceVisible: false,
        practiceCompleted: false
      }
    };
  },
  computed: {
    isLastChapter: function isLastChapter() {
      return this.tabCurrent === this.chapters[this.chapters.length - 1].key;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearFinishTimer();
  },
  methods: {
    getCurrentScene: function getCurrentScene() {
      var scene = this.$refs['scene-' + this.tabCurrent];
      return Array.isArray(scene) ? scene[0] : scene;
    },
    startStudy: function startStudy() {
      var _this = this;
      this.clearFinishTimer();
      this.state.practiceVisible = true;
      this.state.practiceCompleted = false;
      this.rightTip = '';
      this.rightTipStep = '';
      this.addRecord('START');
      this.$nextTick(function () {
        var scene = _this.getCurrentScene();
        if (scene && scene.reset) scene.reset();
      });
    },
    restartStudy: function restartStudy() {
      var _this2 = this;
      this.clearFinishTimer();
      this.state.practiceCompleted = false;
      this.rightTip = '';
      this.rightTipStep = '';
      this.addRecord('START');
      this.$nextTick(function () {
        var scene = _this2.getCurrentScene();
        if (scene && scene.reset) scene.reset();
      });
    },
    studyNext: function studyNext() {
      var _this3 = this;
      var currentIndex = this.chapters.findIndex(function (chapter) {
        return chapter.key === _this3.tabCurrent;
      });
      var nextChapter = this.chapters[currentIndex + 1];
      if (!nextChapter) return;
      this.clearFinishTimer();
      this.tabCurrent = nextChapter.key;
      this.state.practiceCompleted = false;
      this.rightTip = '';
      this.rightTipStep = '';
      this.addRecord('START');
      this.$nextTick(function () {
        var scene = _this3.getCurrentScene();
        if (scene && scene.reset) scene.reset();
      });
    },
    onStepChange: function onStepChange(stepId, step, tip) {
      this.rightTipStep = stepId;
      this.rightTip = tip || '';
    },
    onGuardFailed: function onGuardFailed(res) {
      this.$alert(res && res.msg ? res.msg : '校验未通过');
    },
    onFinish: function onFinish() {
      var _this4 = this;
      this.addRecord('END', this.isLastChapter ? this.finishExam : null);
      this.clearFinishTimer();
      this.finishTimer = setTimeout(function () {
        _this4.finishTimer = null;
        _this4.state.practiceCompleted = true;
      }, 2000);
    },
    clearFinishTimer: function clearFinishTimer() {
      if (!this.finishTimer) return;
      clearTimeout(this.finishTimer);
      this.finishTimer = null;
    },
    finishExam: function finishExam() {
      this.addCourseRecord();
      if (window.parent && typeof window.parent.goBack === 'function') {
        window.parent.goBack();
      }
    },
    addCourseRecord: function addCourseRecord() {
      var courseId = this.$route.query.courseId;
      if (!courseId) return;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/courseRecord/tool/addCourseRecord?courseId=' + encodeURIComponent(courseId), null).then(function () {});
    },
    addRecord: function addRecord(exerciseAction, onSuccess) {
      var _this5 = this;
      var stepSeq = this.chapters.findIndex(function (chapter) {
        return chapter.key === _this5.tabCurrent;
      }) + 1;
      var data = {
        exerciseType: 'WORKORDER_JUSHUITAN_EXAM',
        stepSeq: stepSeq,
        exerciseAction: exerciseAction
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          if (onSuccess) onSuccess();
        } else {
          _this5.$message({
            message: result && result.msg || '记录练习进度失败',
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function () {
        _this5.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
var _newQianNiuScenarios = __webpack_require__(1390);
var _StepPlayer = _interopRequireDefault(__webpack_require__(74));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TAB_KEYS = ['first', 'second', 'third', 'four', 'five', 'six', 'seven', 'eight'];
var PDF_VIEWER_IDS = {
  first: 'pdf_viewer',
  second: 'pdf_viewer2',
  third: 'pdf_viewer3',
  four: 'pdf_viewer4',
  five: 'pdf_viewer5',
  six: 'pdf_viewer6',
  seven: 'pdf_viewer7',
  eight: 'pdf_viewer8'
};
var PDF_URLS = {
  first: '//res.study.itaojin.cn/2024-12/661361ebec2f434fb859625f84480ea0.pdf',
  second: '//res.study.itaojin.cn/2024-12/e203c6b30e9049818094cee869c17026.pdf',
  third: '//res.study.itaojin.cn/2024-12/6fa4070d7418446690ce19576261afe5.pdf',
  four: '//res.study.itaojin.cn/2024-12/8a2815e9246840c2be40e87ac705da18.pdf',
  five: '//res.study.itaojin.cn/2024-12/52d4b0fc262c4b058ddee379d625552f.pdf',
  six: '//res.study.itaojin.cn/2024-12/5490dc4ddc6c4e73897aaa3332e5a3d1.pdf',
  seven: '//res.study.itaojin.cn/2024-12/4183c223f03d4892a6768486996d5455.pdf',
  eight: '//res.study.itaojin.cn/2024-12/d138c13a5f304a0198294afb2495384b.pdf'
};
var _default = exports.default = {
  components: {
    StepPlayer: _StepPlayer.default
  },
  data: function data() {
    var rightTip = {};
    var isOpenPpt = {};
    TAB_KEYS.forEach(function (k) {
      rightTip[k] = '';
      isOpenPpt[k] = false;
    });
    return {
      OnInline: 'false',
      tabIndex: 1,
      tabCurrent: 'first',
      isShowBtn: [],
      scenarioConfig: (0, _newQianNiuScenarios.getScenarioConfig)(),
      rightTip: rightTip,
      isOpenPpt: isOpenPpt,
      currentStepId: TAB_KEYS.reduce(function (m, k) {
        m[k] = '';
        return m;
      }, {}),
      showLoginPassword: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this.tabCurrent).show();
      _this.$set(_this.isShowBtn, _this.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
    // 页面初始化时重置各关卡的内容显示与 StepPlayer 状态
    this.initAll();
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    resetFocus: function resetFocus() {},
    onFinish: function onFinish(tabKey) {
      this.addRecord('END');
      var self = this;
      setTimeout(function () {
        $('#studytip-' + tabKey).show();
      }, 2000);
    },
    onStepChange: function onStepChange(tabKey, stepId, step, resolvedTip) {
      this.$set(this.currentStepId, tabKey, stepId);
      if (tabKey === 'first' && stepId !== 'login') {
        this.showLoginPassword = false;
      }
      this.$set(this.rightTip, tabKey, resolvedTip || '');
    },
    onGuardFailed: function onGuardFailed(tabKey, res) {
      this.$alert(res && res.msg ? res.msg : '校验未通过');
    },
    onRequestFile: function onRequestFile() {
      this.$refs.fileInputThird && this.$refs.fileInputThird.click();
    },
    onThirdFileChange: function onThirdFileChange(evt) {
      var _this2 = this;
      var file = evt.target.files && evt.target.files[0];
      if (!file || file.name && file.name.indexOf('快捷短语') < 0) {
        this.$alert('请选择你下载的“快捷短语.csv”模板文件');
        return;
      }
      var player = this.$refs.playerThird;
      if (player) player.go('s3_11');
      setTimeout(function () {
        if (_this2.$refs.fileInputThird) _this2.$refs.fileInputThird.value = '';
      }, 300);
    },
    downloadKjdyFile: function downloadKjdyFile() {
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      fetch(path).then(function (r) {
        return r.blob();
      }).then(function (blob) {
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = '快捷短语.csv';
        a.click();
        a.remove();
      });
    },
    /******************/
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('first').play();
      $('#startvideo').hide();
    },
    //初始化所有tab内容
    initAll: function initAll() {
      var _this3 = this;
      $('#startvideo').hide();
      this.isShowBtn = [];
      TAB_KEYS.forEach(function (k) {
        _this3.isOpenPpt[k] = false;
        _this3.rightTip[k] = '';
        var id = PDF_VIEWER_IDS[k];
        if (id && $('#' + id).length) $('#' + id).height('0');
      });
      var playerRefs = ['playerFirst', 'playerSecond', 'playerThird', 'playerFour', 'playerFive', 'playerSix', 'playerSeven', 'playerEight'];
      playerRefs.forEach(function (ref, i) {
        var player = _this3.$refs[ref];
        if (player && _this3.scenarioConfig[TAB_KEYS[i]]) {
          player.reset(_this3.scenarioConfig[TAB_KEYS[i]].initialStepId);
        }
      });
      $('.content').each(function () {
        $(this).css('display', 'none');
      }); //todo none
      $('.stoptip').each(function () {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function () {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show(); //todo show
    },
    //tab切换
    handleClick: function handleClick(tab, event) {
      var _this4 = this;
      this.tabIndex = parseInt(tab.index) + 1;
      //内容初始化
      this.initAll();
      this.resetFocus();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this4.tabCurrent).show();
        _this4.$set(_this4.isShowBtn, _this4.tabCurrent, true);
      }, false);
    },
    //展开/收起ppt（tabKey: first|second|third|four|five|six|seven|eight, bol: false 表示收起）
    viewPpt: function viewPpt(tabKey, bol) {
      if (this.isOpenPpt[tabKey] === true || bol === false) {
        this.$set(this.isOpenPpt, tabKey, false);
        var id = PDF_VIEWER_IDS[tabKey];
        if (id && $('#' + id).length) $('#' + id).height('0');
      } else {
        this.$set(this.isOpenPpt, tabKey, true);
        var _id = PDF_VIEWER_IDS[tabKey];
        var url = PDF_URLS[tabKey];
        if (_id && url && _pdfobject.default.supportsPDFs) {
          $('#' + _id).height('700px');
          _pdfobject.default.embed(url, '#' + _id, {
            pdfOpenParams: {
              navpanes: 0,
              toolbar: 0,
              statusbar: 0,
              view: 'FitV',
              pagemode: 'thumbs',
              page: 1
            },
            forcePDFJS: true,
            PDFJS_URL: '//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html'
          });
        }
      }
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //开始实操练习
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.$set(this.isShowBtn, this.tabCurrent, false);
      $('#content-' + this.tabCurrent).css('display', 'flex');
      var ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1);
      var player = this.$refs[ref];
      var cfg = this.scenarioConfig[this.tabCurrent];
      if (player && cfg) {
        player.reset(cfg.initialStepId);
      }
      this.addRecord('START');
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initAll();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    restartStudy: function restartStudy() {
      var cfg = this.scenarioConfig[this.tabCurrent];
      if (!cfg) return;
      var ref = 'player' + this.tabCurrent.charAt(0).toUpperCase() + this.tabCurrent.slice(1);
      var player = this.$refs[ref];
      if (player) player.reset(cfg.initialStepId);
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type) {
      var _this5 = this;
      var data = {
        exerciseType: 'QIAN_NIU',
        stepSeq: this.tabIndex,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this5.tabIndex == 8 && type == 'END') {
            window.parent['goBack']();
          }
        } else {
          _this5.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this5.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //第1步
      isShowQnIcon: true,
      //是否显示千牛图标
      isShowQnIcon2: false,
      //显示点击千牛图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      mouseFocusSaveAP: false,
      //鼠标焦点
      isSaveAP: false,
      //是否保存账号密码
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      mouseFocusRnd: false,
      //鼠标焦点
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      mouseFocusJD: false,
      //鼠标焦点
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      gqstep: 1,
      //挂起步骤
      wgqstep: 1,
      mouseFocusZX: false,
      //鼠标焦点
      mouseFocusGQ: false,
      mouseFocusDdsc: false,
      mouseFocusSet: false,
      mouseFocusSetInfo: false,
      mouseFocusSetInfoDetail: false,
      secondStep: 1,
      secondStepStep: 1,
      //第3步---------
      kjdyStep: 1,
      kjdySearch: '',
      mouseFocusKJDY: false,
      mouseFocusFZ: false,
      mouseFocusFZI: false,
      kjdybm: '',
      kjdynr: '',
      kjdyfz: '',
      kjdyfs: '',
      //第4步---------
      cygnStep: 1,
      mouseFocus: false,
      zjyy: '',
      //第5步---------
      zncjsstep: 1,
      //第6步---------
      zncjxstep: 15,
      showYfstep: false,
      yfamount: '0',
      bznr: '',
      phone: '18418966473-4839',
      //第7步---------
      shcygnStep: 1,
      //第8步---------
      tcqnStep: 1
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    var step = this.$route.query.step;
    if (step == 8) {
      this.studyNext('#tab-eight', step, 'eight');
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.isSaveAP = false; //是否保存账号密码
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.gqstep = 1; //挂起步骤
      this.wgqstep = 1; //未挂起步骤
      this.secondStep = 1;
      this.secondStepStep = 1;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.kjdyStep = 1;
      this.kjdySearch = '';
      this.mouseFocusKJDY = false;
      this.mouseFocusFZ = false;
      this.mouseFocusFZI = false;
      this.kjdybm = '';
      this.kjdynr = '';
      this.kjdyfz = '';
      this.kjdyfs = '';
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.cygnStep = 1;
      this.zjyy = '';
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.zncjsstep = 1;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.zncjxstep = 1;
      this.showYfstep = false;
      this.yfamount = '0';
      this.bznr = '';
      this.phone = '18418966473-4839';
    },
    //初始化第7步状态值
    initSeven: function initSeven() {
      this.shcygnStep = 1;
    },
    //初始化第8步状态值
    initEight: function initEight() {
      this.tcqnStep = 1;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
      this.resetFocus();
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    resetFocus: function resetFocus() {
      this.mouseFocus = false;
      this.mouseFocusZX = false;
      this.mouseFocusGQ = false;
      this.mouseFocusDdsc = false;
      this.mouseFocusSet = false;
      this.mouseFocusSetInfo = false;
      this.mouseFocusSetInfoDetail = false;
      this.mouseFocusKJDY = false;
      this.mouseFocusFZ = false;
      this.mouseFocusFZI = false;
      this.mouseFocusSaveAP = false;
      this.mouseFocusRnd = false;
      this.mouseFocusJD = false;
    },
    //第1步-单击千牛图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击千牛图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '淘金云客服:小淘') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != 'Tj1234') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowLoginImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.notify('<p>请输入短信验证码</p>');
        return;
      } else if (this.rnd != '660220') {
        this.notify('<p>短信验证码错误</p>');
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showGqImgClick: function showGqImgClick() {
      this.secondStepStep = 5;
      this.addRecord('END', 2);
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    finishThird: function finishThird() {
      this.kjdyStep = 17;
      this.addRecord('END', 3);
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
    },
    kjdyfsChange: function kjdyfsChange(e) {
      if (e == '/欢迎') {
        this.kjdyStep = 15;
      }
    },
    enterSelect: function enterSelect() {
      var _this = this;
      this.kjdyStep = 16;
      var self = this;
      this.$nextTick(function () {
        _this.$refs.sixInput.focus();
      });
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$alert('请选择你下载的“快捷短语.csv”模板文件');
        return false;
      }
      var fileInput = this.$refs.fileInput;
      setTimeout(function () {
        fileInput.value = "";
        self.kjdyStep = 11;
      }, 500);
    },
    kjdyConfirm: function kjdyConfirm() {
      if (this.kjdynr != '亲，欢迎光临，请问有什么可以帮您的？') {
        this.$alert('请输入正确的快捷短语内容！');
        return;
      }
      if (this.kjdybm != '欢迎') {
        this.$alert('请输入正确的编码');
        return;
      }
      this.kjdyStep = 9;
    },
    kjdySearchChange: function kjdySearchChange() {
      if (this.kjdySearch == '淘金云客服:小淘') {
        var self = this;
        setTimeout(function () {
          self.kjdyStep = 2;
        }, 500);
      }
    },
    kjdyfzConfirm: function kjdyfzConfirm() {
      if (this.kjdyfz == '开头语') {
        this.kjdyStep = 8;
        return;
      }
      this.$alert('分组名称应为: 开头语');
    },
    //********第四步的内容**********/
    fourStepBystep: function fourStepBystep() {
      this.cygnStep = 3;
      var self = this;
      setTimeout(function () {
        self.cygnStep = 4;
      }, 2500);
    },
    sendZfyy: function sendZfyy() {
      if (this.zjyy == '少件') {
        this.cygnStep = 7;
        var self = this;
        this.addRecord('END', 4);
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
        return;
      }
      this.$alert('请输入正确的转交原因');
    },
    //********第5步的内容**********/
    tjspEnd: function tjspEnd() {
      this.zncjsstep = 3;
      var self = this;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /********第6步的内*********/sixStepByStep: function sixStepByStep() {
      this.zncjxstep = 4;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 5;
      }, 2500);
    },
    sixStepByStep2: function sixStepByStep2() {
      this.zncjxstep = 6;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 7;
      }, 2500);
    },
    sixStepByStep3: function sixStepByStep3() {
      if (this.yfamount == 8) {
        this.showYfstep = false;
        this.yfamount = '';
        this.zncjxstep = 8;
        return;
      }
      this.$alert('请输入正确的邮费');
    },
    sixStepByStep4: function sixStepByStep4() {
      if (this.bznr == '发顺丰') {
        this.bznr = '';
        this.zncjxstep = 11;
        var self = this;
        setTimeout(function () {
          self.zncjxstep = 12;
        }, 2500);
        return;
      }
      this.$alert('请输入正确的备注');
    },
    sixStepByStep5: function sixStepByStep5() {
      this.zncjxstep = 13;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 14;
      }, 2500);
    },
    sixStepByStep6: function sixStepByStep6() {
      if (this.phone == '13656565656') {
        this.zncjxstep = 16;
        var self = this;
        this.addRecord('END', 6);
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
        return;
      }
      this.$alert('请输入正确的电话号码！');
    },
    /********第7 8步的内*********/sevenStepEnd: function sevenStepEnd() {
      this.shcygnStep = 6;
      var self = this;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    eightStepEnd: function eightStepEnd() {
      this.tcqnStep = 7;
      var self = this;
      this.addRecord('END', 8);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this2 = this;
      var data = {
        exerciseType: 'QIAN_NIU_EXAM',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 8 && type == 'END') {
            window.parent['goBack']();
            // /courseRecord/tool/addCourseRecord
            try {
              _this2.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/courseRecord/tool/addCourseRecord?courseId=10467', null).then(function (response) {});
            } catch (e) {}
          }
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this2.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //第1步
      isShowQnIcon: true,
      //是否显示千牛图标
      isShowQnIcon2: false,
      //显示点击千牛图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      showGqImg: false,
      //显示切换挂起图片
      isShowWgq: false,
      //显示未挂起图片
      //第3步
      jdnr: '',
      //接待回复内容
      time: this.formatDate(new Date()),
      time1: '',
      //时间1
      time2: '',
      //时间2
      time3: '',
      //时间3
      time4: '',
      //时间4
      time5: '',
      //时间5
      time6: '',
      //时间6
      time7: '',
      //时间7
      replyhtml: "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time + "</span></p><p><span>在吗？</span></p>",
      //回复内容回显1
      isShowOne: true,
      //显示回复1
      isShowTwo: false,
      //显示回复2
      isShowThree: false,
      //显示回复3
      isShowFour: false,
      //显示回复4
      //第4步
      zdhf: '',
      //自动回复输入框
      isShowZdhficon: true,
      isShowZdhf01: false,
      isShowZdhf02: false,
      isShowZdhf03: false,
      isShowZdhf04: false,
      isShowZdhf05: false,
      isShowZdhf06: false,
      isShowZdhf07: false,
      isShowZdhf08: false,
      isShowZdhf09: false,
      isShowZdhf10: false,
      //第5步
      isShowCjxxicon: true,
      isShowCjxx01: false,
      isShowCjxx02: false,
      isShowCjxx03: false,
      isShowCjxx04: false,
      isShowCjxx05: false,
      isShowCjxx06: false,
      isShowCjxx07: false,
      isShowCjxx08: false,
      isShowCjxx09: false,
      isShowCjxx10: false,
      isShowCjxx11: false,
      isShowCjxx12: false,
      isShowCjxx13: false,
      isShowCjxx14: false,
      isShowCjxx15: false,
      isShowCjxx16: false,
      isShowCjxx17: false,
      isShowCjxx18: false,
      isShowCjxx19: false,
      isShowCjxx20: false,
      isShowCjxxTip: true,
      isShowCjxxTip01: false,
      isShowCjxxTip02: false,
      isShowCjxxTip03: false,
      isShowCjxxTip04: false,
      isShowCjxxTip05: false,
      //第6步
      kjdy: '',
      //快捷编码输入框
      downCount: 0,
      //是否点击下载csv
      isShowKjdyicon: true,
      isShowKjdy01: false,
      isShowKjdy02: false,
      isShowKjdy03: false,
      isShowKjdy04: false,
      isShowKjdy05: false,
      isShowKjdy06: false,
      isShowKjdy07: false,
      isShowKjdy08: false,
      isShowKjdy09: false,
      isShowKjdy10: false,
      isShowKjdy11: false,
      isShowKjdy12: false,
      isShowKjdyTip01: true,
      isShowKjdyTip02: false,
      isShowKjdyTip03: false,
      isShowKjdyTip04: false,
      //第7步
      isShowZtsbicon: true,
      isShowZtsb01: false,
      isShowZtsb02: false,
      isShowZtsb03: false,
      isShowZtsb04: false,
      isShowZtsb05: false,
      isShowZtsb06: false,
      isShowZtsbTip01: true,
      isShowZtsbTip02: false,
      isShowZtsbTip03: false,
      //第8步
      isShowZjgnicon: true,
      isShowZjgn01: false,
      isShowZjgn02: false,
      isShowZjgn03: false,
      isShowZjgn04: false,
      isShowZjgn05: false,
      //第9步
      isShowTjgnicon: true,
      isShowTjgn01: false,
      isShowTjgn02: false,
      isShowTjgn03: false,
      isShowTjgn04: false,
      isShowTjgn05: false,
      isShowTjgn06: false,
      //第10步
      isShowDdcjicon: false,
      isShowDdcj01: false,
      isShowDdcj02: false,
      isShowDdcj03: false,
      isShowDdcj04: false,
      isShowDdcj05: false,
      isShowDdcj06: false,
      isShowDdcj07: true,
      isShowDdcj08: false,
      isShowDdcj09: false,
      isShowDdcj10: false,
      isShowDdcjTip01: true,
      isShowDdcjTip02: false,
      isShowDdcjTip03: false,
      ddcjbz: '',
      ddcjdz: '',
      ddcjyf: '',
      //第11步
      isShowXjrwicon: true,
      isShowXjrw01: false,
      isShowXjrw02: false,
      isShowXjrw03: false,
      isShowXjrw04: false,
      isShowXjrw05: false,
      isShowXjrw06: false,
      xjrwmt: this.getLastDaysFromToday(-1) + ' 09:00',
      xjrwsj: '',
      xjrwtxt: '',
      //第12步
      isShowTcqnicon: true,
      isShowTcqn01: false,
      isShowTcqn02: false,
      isShowTcqn03: false,
      isShowTcqn04: false,
      isShowTcqn05: false,
      isShowTcqn06: false,
      isShowTcqn07: false,
      isShowTcqn08: false,
      isShowTcqn09: false,
      isShowTcqn10: false,
      isShowTcqnTip01: true,
      isShowTcqnTip02: false
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    var step = this.$route.query.step;
    if (step == 12) {
      this.studyNext('#tab-twelve', step, 'twelve');
    }
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.showGqImg = false;
      this.isShowWgq = false;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.jdnr = '';
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time + "</span></p><p><span>在吗？</span></p>";
      $('.replyone').html(this.replyhtml);
      this.time1 = '';
      this.time2 = '';
      this.time3 = '';
      this.time4 = '';
      this.time5 = '';
      this.time6 = '';
      this.time7 = '';
      this.isShowOne = true;
      this.isShowTwo = false;
      this.isShowThree = false;
      this.isShowFour = false;
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.zdhf = '';
      this.isShowZdhficon = true;
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = false;
      this.isShowZdhf09 = false;
      this.isShowZdhf10 = false;
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.isShowCjxxicon = true;
      this.isShowCjxx01 = false;
      this.isShowCjxx02 = false;
      this.isShowCjxx03 = false;
      this.isShowCjxx04 = false;
      this.isShowCjxx05 = false;
      this.isShowCjxx06 = false;
      this.isShowCjxx07 = false;
      this.isShowCjxx08 = false;
      this.isShowCjxx09 = false;
      this.isShowCjxx10 = false;
      this.isShowCjxx11 = false;
      this.isShowCjxx12 = false;
      this.isShowCjxx13 = false;
      this.isShowCjxx14 = false;
      this.isShowCjxx15 = false;
      this.isShowCjxx16 = false;
      this.isShowCjxx17 = false;
      this.isShowCjxx18 = false;
      this.isShowCjxx19 = false;
      this.isShowCjxx20 = false;
      this.isShowCjxxTip = true;
      this.isShowCjxxTip01 = false;
      this.isShowCjxxTip02 = false;
      this.isShowCjxxTip03 = false;
      this.isShowCjxxTip04 = false;
      this.isShowCjxxTip05 = false;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.kjdy = '';
      this.downCount = 0;
      this.isShowKjdyicon = true;
      this.isShowKjdy01 = false;
      this.isShowKjdy02 = false;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = false;
      this.isShowKjdy08 = false;
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = false;
      this.isShowKjdy12 = false;
      this.isShowKjdyTip01 = true;
      this.isShowKjdyTip02 = false;
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = false;
    },
    //初始化第7步状态值
    initSeven: function initSeven() {
      this.isShowZtsbicon = true;
      this.isShowZtsb01 = false;
      this.isShowZtsb02 = false;
      this.isShowZtsb03 = false;
      this.isShowZtsb04 = false;
      this.isShowZtsb05 = false;
      this.isShowZtsb06 = false;
      this.isShowZtsbTip01 = true;
      this.isShowZtsbTip02 = false;
      this.isShowZtsbTip03 = false;
    },
    //初始化第8步状态值
    initEight: function initEight() {
      this.isShowZjgnicon = true;
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
    },
    //初始化第9步状态值
    initNine: function initNine() {
      this.isShowTjgnicon = true;
      this.isShowTjgn01 = false;
      this.isShowTjgn02 = false;
      this.isShowTjgn03 = false;
      this.isShowTjgn04 = false;
      this.isShowTjgn05 = false;
      this.isShowTjgn06 = false;
    },
    //初始化第10步状态值
    initTen: function initTen() {
      this.isShowDdcjicon = false;
      this.isShowDdcj01 = false;
      this.isShowDdcj02 = false;
      this.isShowDdcj03 = false;
      this.isShowDdcj04 = false;
      this.isShowDdcj05 = false;
      this.isShowDdcj06 = false;
      this.isShowDdcj07 = true;
      this.isShowDdcj08 = false;
      this.isShowDdcj09 = false;
      this.isShowDdcj10 = false;
      this.isShowDdcjTip01 = true;
      this.isShowDdcjTip02 = false;
      this.isShowDdcjTip03 = false;
      this.ddcjbz = '';
      this.ddcjdz = '';
      this.ddcjyf = '';
    },
    //初始化第11步状态值
    initEleven: function initEleven() {
      this.isShowXjrwicon = true;
      this.isShowXjrw01 = false;
      this.isShowXjrw02 = false;
      this.isShowXjrw03 = false;
      this.isShowXjrw04 = false;
      this.isShowXjrw05 = false;
      this.isShowXjrw06 = false;
      this.xjrwmt = this.getLastDaysFromToday(-1) + ' 09:00';
      this.xjrwsj = '';
      this.xjrwtxt = '';
    },
    //初始化第12步状态值
    initTwelve: function initTwelve() {
      this.isShowTcqnicon = true;
      this.isShowTcqn01 = false;
      this.isShowTcqn02 = false;
      this.isShowTcqn03 = false;
      this.isShowTcqn04 = false;
      this.isShowTcqn05 = false;
      this.isShowTcqn06 = false;
      this.isShowTcqn07 = false;
      this.isShowTcqn08 = false;
      this.isShowTcqn09 = false;
      this.isShowTcqn10 = false;
      this.isShowTcqnTip01 = true;
      this.isShowTcqnTip02 = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
      //第9步
      this.initNine();
      //第10步
      this.initTen();
      //第11步
      this.initEleven();
      //第12步
      this.initTwelve();
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    //第1步-单击千牛图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击千牛图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '淘金客服:001') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != 'TJ2019') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowLoginImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.notify('<p>请输入短信验证码</p>');
        return;
      } else if (this.rnd != '660220') {
        this.notify('<p>短信验证码错误</p>');
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg: function showWgqImg() {
      var self = this;
      this.showGqImg = false;
      this.isShowWgq = true;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第3步-接待顾客
    //监听回车1
    listenOne: function listenOne(event) {
      if (event.keyCode === 13) {
        this.showJieDaiImgOne();
        event.preventDefault();
        return false;
      }
    },
    //监听回车2
    listenTwo: function listenTwo(event) {
      if (event.keyCode === 13) {
        this.showJieDaiImgTwo();
        event.preventDefault();
        return false;
      }
    },
    //监听回车3
    listenThree: function listenThree() {
      if (event.keyCode === 13) {
        this.showJieDaiImgThree();
        event.preventDefault();
        return false;
      }
    },
    //监听回车4
    listenFour: function listenFour() {
      if (event.keyCode === 13) {
        this.showJieDaiImgFour();
        event.preventDefault();
        return false;
      }
    },
    //接待顾客-显示回复1
    showJieDaiImgOne: function showJieDaiImgOne() {
      var self = this;
      if (this.jdnr.indexOf('您好') < 0 || this.jdnr.indexOf('欢迎光临') < 0 || this.jdnr.indexOf('请问有什么可以帮到您') < 0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>');
        return;
      }
      this.time1 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function () {
        self.time2 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p>";
        $('.replyone').html(self.replyhtml);
        self.isShowOne = false;
        self.isShowTwo = true;
      }, 2000);
      this.jdnr = '';
    },
    //接待顾客-显示回复2
    showJieDaiImgTwo: function showJieDaiImgTwo() {
      var self = this;
      if (this.jdnr.indexOf('亲亲') < 0 || this.jdnr.indexOf('正常情况下大概3天左右能到哦') < 0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>');
        return;
      }
      this.time3 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function () {
        self.time4 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time4 + "</span></p><p><span>好的</span></p>";
        $('.replyone').html(self.replyhtml);
        self.isShowTwo = false;
        self.isShowThree = true;
      }, 2000);
      this.jdnr = '';
    },
    //接待顾客-显示回复3
    showJieDaiImgThree: function showJieDaiImgThree() {
      var self = this;
      if (this.jdnr.indexOf('请问还有什么可以帮到您') < 0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>');
        return;
      }
      this.time5 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      setTimeout(function () {
        self.time6 = self.formatDate(new Date());
        self.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time6 + "</span></p><p><span>没有了</span></p>";
        $('.replyone').html(self.replyhtml);
        self.isShowThree = false;
        self.isShowFour = true;
      }, 2000);
      this.jdnr = '';
    },
    //接待顾客-显示回复4
    showJieDaiImgFour: function showJieDaiImgFour() {
      var self = this;
      if (this.jdnr.indexOf('好的') < 0 || this.jdnr.indexOf('感谢亲亲的支持') < 0 || this.jdnr.indexOf('祝您生活愉快') < 0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>');
        return;
      }
      this.time7 = this.formatDate(new Date());
      this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time6 + "</span></p><p><span>没有了</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time7 + "</span></p><p><span>好的，感谢亲亲的支持，祝您生活愉快</span><span class='read'>已读</span></p>";
      $('.replyone').html(this.replyhtml);
      this.jdnr = '';
      this.addRecord('END', 3);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第4步-自动回复
    showZdhf01: function showZdhf01() {
      this.isShowZdhficon = false;
      this.isShowZdhf01 = true;
      var $zdhficon = $('.zdhficon').closest('.con-left'),
        height = $('.zdhficon').closest('.con-left')[0].scrollHeight;
      setTimeout(function () {
        $zdhficon.scrollTop(height);
      }, 100);
    },
    showZdhf02: function showZdhf02() {
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = true;
    },
    showZdhf03: function showZdhf03() {
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = true;
    },
    showZdhf04: function showZdhf04() {
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = true;
    },
    showZdhf05: function showZdhf05() {
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = true;
    },
    showZdhf06: function showZdhf06() {
      if (this.zdhf.indexOf('您好') < 0 || this.zdhf.indexOf('欢迎光临') < 0 || this.zdhf.indexOf('请问有什么可以帮到您') < 0) {
        this.notify('<p>请按照右边提示输入正确的回复内容</p>');
        return;
      }
      this.isShowZdhf05 = false;
      this.zdhf = '';
      this.isShowZdhf06 = true;
    },
    showZdhf07: function showZdhf07() {
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = true;
    },
    showZdhf08: function showZdhf08() {
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = true;
    },
    showZdhf09: function showZdhf09() {
      this.isShowZdhf08 = false;
      this.isShowZdhf09 = true;
    },
    showZdhf10: function showZdhf10() {
      var self = this;
      this.isShowZdhf09 = false;
      this.isShowZdhf10 = true;
      this.addRecord('END', 4);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第5步-插件学习
    showCjxx01: function showCjxx01() {
      this.isShowCjxxicon = false;
      this.isShowCjxx01 = true;
    },
    showCjxx02: function showCjxx02() {
      this.isShowCjxx01 = false;
      this.isShowCjxx02 = true;
    },
    showCjxx03: function showCjxx03() {
      this.isShowCjxx02 = false;
      this.isShowCjxx03 = true;
      this.isShowCjxxTip = false;
      this.isShowCjxxTip01 = true;
    },
    showCjxx04: function showCjxx04() {
      this.isShowCjxx03 = false;
      this.isShowCjxx04 = true;
    },
    showCjxx05: function showCjxx05() {
      this.isShowCjxx04 = false;
      this.isShowCjxx05 = true;
    },
    showCjxx06: function showCjxx06() {
      this.isShowCjxx05 = false;
      this.isShowCjxx06 = true;
      this.isShowCjxxTip01 = false;
      this.isShowCjxxTip02 = true;
    },
    showCjxx07: function showCjxx07() {
      this.isShowCjxx06 = false;
      this.isShowCjxx07 = true;
    },
    showCjxx08: function showCjxx08() {
      this.isShowCjxx07 = false;
      this.isShowCjxx08 = true;
    },
    showCjxx09: function showCjxx09() {
      this.isShowCjxx08 = false;
      this.isShowCjxx09 = true;
    },
    showCjxx10: function showCjxx10() {
      this.isShowCjxx09 = false;
      this.isShowCjxx10 = true;
      this.isShowCjxxTip02 = false;
      this.isShowCjxxTip03 = true;
    },
    showCjxx11: function showCjxx11() {
      this.isShowCjxx10 = false;
      this.isShowCjxx11 = true;
    },
    showCjxx12: function showCjxx12() {
      this.isShowCjxx11 = false;
      this.isShowCjxx12 = true;
    },
    showCjxx13: function showCjxx13() {
      this.isShowCjxx12 = false;
      this.isShowCjxx13 = true;
    },
    showCjxx14: function showCjxx14() {
      this.isShowCjxx13 = false;
      this.isShowCjxx14 = true;
      this.isShowCjxxTip03 = false;
      this.isShowCjxxTip04 = true;
    },
    showCjxx15: function showCjxx15() {
      this.isShowCjxx14 = false;
      this.isShowCjxx15 = true;
    },
    showCjxx16: function showCjxx16() {
      this.isShowCjxx15 = false;
      this.isShowCjxx16 = true;
    },
    showCjxx17: function showCjxx17() {
      this.isShowCjxx16 = false;
      this.isShowCjxx17 = true;
    },
    showCjxx18: function showCjxx18() {
      this.isShowCjxx17 = false;
      this.isShowCjxx18 = true;
      this.isShowCjxxTip04 = false;
      this.isShowCjxxTip05 = true;
    },
    showCjxx19: function showCjxx19() {
      this.isShowCjxx18 = false;
      this.isShowCjxx19 = true;
    },
    showCjxx20: function showCjxx20() {
      this.isShowCjxx19 = false;
      this.isShowCjxx20 = true;
      var self = this;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第6步-快捷短语
    showKjdy01: function showKjdy01() {
      this.isShowKjdyicon = false;
      this.isShowKjdy01 = true;
    },
    showKjdy02: function showKjdy02() {
      this.isShowKjdy01 = false;
      this.isShowKjdy02 = true;
    },
    showKjdy03: function showKjdy03() {
      this.isShowKjdy02 = false;
      this.isShowKjdy03 = true;
    },
    showKjdy04: function showKjdy04() {
      var self = this;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = true;
      this.notify('<p>快捷短语鼠标点击练习完成，下一步快捷短语编码练习</p>');
      setTimeout(function () {
        self.isShowKjdyTip01 = false;
        self.isShowKjdyTip02 = true;
        self.isShowKjdy04 = false;
        self.isShowKjdy05 = true;
      }, 2000);
    },
    showKjdy05: function showKjdy05() {
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = true;
    },
    showKjdy06: function showKjdy06() {
      var self = this;
      this.isShowKjdy07 = false;
      this.isShowKjdy08 = true;
      this.notify('<p>快捷短语编码练习完成，下一步快捷模板导入练习</p>');
      setTimeout(function () {
        self.isShowKjdyTip02 = false;
        self.isShowKjdyTip03 = true;
        self.isShowKjdy08 = false;
        self.isShowKjdy09 = true;
      }, 2000);
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // window.open('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv')
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = true;
    },
    showKjdy07: function showKjdy07() {
      if (this.downCount == 0) {
        this.$alert('请先下载快捷短语模板');
        return false;
      }
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = true;
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$alert('请选择你下载的“快捷短语.csv”模板文件');
        return false;
      }
      setTimeout(function () {
        self.isShowKjdy10 = false;
        self.isShowKjdy11 = true;
      }, 500);
    },
    showKjdy08: function showKjdy08() {
      var self = this;
      this.isShowKjdy11 = false;
      this.isShowKjdy12 = true;
      this.addRecord('END', 6);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第7步-状态识别
    showZtsb01: function showZtsb01() {
      this.isShowZtsbicon = false;
      this.isShowZtsb01 = true;
    },
    showZtsb02: function showZtsb02() {
      this.isShowZtsb01 = false;
      this.isShowZtsb02 = true;
      this.isShowZtsbTip01 = false;
      this.isShowZtsbTip02 = true;
    },
    showZtsb03: function showZtsb03() {
      this.isShowZtsb02 = false;
      this.isShowZtsb03 = true;
    },
    showZtsb04: function showZtsb04() {
      this.isShowZtsb03 = false;
      this.isShowZtsb04 = true;
      this.isShowZtsbTip02 = false;
      this.isShowZtsbTip03 = true;
    },
    showZtsb05: function showZtsb05() {
      this.isShowZtsb04 = false;
      this.isShowZtsb05 = true;
    },
    showZtsb06: function showZtsb06() {
      this.isShowZtsb05 = false;
      this.isShowZtsb06 = true;
      var self = this;
      this.isShowKjdy11 = false;
      this.isShowKjdy12 = true;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第8步-转接功能
    showZjgn01: function showZjgn01() {
      this.isShowZjgnicon = false;
      this.isShowZjgn01 = true;
    },
    showZjgn02: function showZjgn02() {
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = true;
      this.isShowZjgnTip01 = false;
      this.isShowZjgnTip02 = true;
    },
    showZjgn03: function showZjgn03() {
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = true;
    },
    showZjgn04: function showZjgn04() {
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = true;
    },
    showZjgn05: function showZjgn05() {
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = true;
      var self = this;
      this.addRecord('END', 8);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第9步-商品插件（推荐功能）
    showTjgn01: function showTjgn01() {
      this.isShowTjgnicon = false;
      this.isShowTjgn01 = true;
    },
    showTjgn02: function showTjgn02() {
      this.isShowTjgn01 = false;
      this.isShowTjgn02 = true;
    },
    showTjgn03: function showTjgn03() {
      this.isShowTjgn02 = false;
      this.isShowTjgn03 = true;
    },
    showTjgn04: function showTjgn04() {
      this.isShowTjgn03 = false;
      this.isShowTjgn04 = true;
    },
    showTjgn05: function showTjgn05() {
      this.isShowTjgn04 = false;
      this.isShowTjgn05 = true;
    },
    showTjgn06: function showTjgn06() {
      this.isShowTjgn05 = false;
      this.isShowTjgn06 = true;
      var self = this;
      this.addRecord('END', 9);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第10步-订单插件
    showDdcj01: function showDdcj01() {
      this.isShowDdcjicon = false;
      this.isShowDdcj01 = true;
    },
    showDdcj02: function showDdcj02() {
      if (this.ddcjbz == '') {
        this.notify('<p>你还没有填写订单备注</p>');
        return;
      }
      if (this.ddcjbz != '顾客要求发顺丰') {
        this.notify('<p>请按照右边提示填写正确的订单备注</p>');
        return;
      }
      this.isShowDdcj01 = false;
      this.isShowDdcj02 = true;
      this.isShowDdcjTip02 = false;
      this.isShowDdcjTip03 = true;
    },
    showDdcj03: function showDdcj03() {
      this.isShowDdcj02 = false;
      this.isShowDdcj03 = true;
    },
    showDdcj04: function showDdcj04() {
      this.isShowDdcj03 = false;
      this.isShowDdcj04 = true;
    },
    showDdcj05: function showDdcj05() {
      if (this.ddcjdz == '') {
        this.notify('<p>你还没有填写地址</p>');
        return;
      }
      if (this.ddcjdz == "双流区 大林镇" || this.ddcjdz == "双流区大林镇") {} else {
        console.log(this.ddcjdz == '双流区 大林镇');
        this.notify('<p>请按照右边提示填写正确的地址</p>');
        return;
      }
      this.isShowDdcj04 = false;
      this.isShowDdcj05 = true;
    },
    showDdcj06: function showDdcj06() {
      this.isShowDdcj05 = false;
      this.isShowDdcj06 = true;
    },
    showDdcj08: function showDdcj08() {
      this.isShowDdcj10 = false;
      this.isShowDdcj08 = true;
    },
    showDdcj09: function showDdcj09() {
      this.isShowDdcj08 = false;
      this.isShowDdcj09 = true;
    },
    showDdcj10: function showDdcj10() {
      if (this.ddcjyf == '') {
        this.notify('<p>你还没有填写邮费</p>');
        return;
      }
      if (this.ddcjyf != '10') {
        this.notify('<p>请按照右边提示填写正确的邮费</p>');
        return;
      }
      this.isShowDdcj09 = false;
      this.isShowDdcjicon = true;
      this.isShowDdcjTip01 = false;
      this.isShowDdcjTip02 = true;
    },
    showDdcj07: function showDdcj07() {
      this.isShowDdcj06 = false;
      this.isShowDdcj10 = true;
      var self = this;
      this.addRecord('END', 10);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第11步-新建任务
    showXjrw01: function showXjrw01() {
      this.isShowXjrwicon = false;
      this.isShowXjrw01 = true;
    },
    showXjrw02: function showXjrw02() {
      this.isShowXjrw01 = false;
      this.isShowXjrw02 = true;
    },
    showXjrw03: function showXjrw03() {
      if (this.xjrwtxt.indexOf('此顾客有购买意向') < 0 || this.xjrwtxt.indexOf('请继续跟进') < 0) {
        this.notify('<p>请按照右边提示填写正确的任务内容</p>');
        return;
      }
      this.isShowXjrw02 = false;
      this.isShowXjrw03 = true;
    },
    showXjrw04: function showXjrw04() {
      this.isShowXjrw03 = false;
      this.isShowXjrw04 = true;
    },
    showXjrw05: function showXjrw05() {
      this.isShowXjrw04 = false;
      this.isShowXjrw05 = true;
    },
    showXjrw06: function showXjrw06() {
      if (this.xjrwsj != this.xjrwmt) {
        this.notify('<p>请按照右边提示设置正确的时间</p>');
        return;
      }
      this.isShowXjrw05 = false;
      this.isShowXjrw06 = true;
      var self = this;
      this.addRecord('END', 11);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第12步-退出千牛
    showTcqn01: function showTcqn01() {
      this.isShowTcqnicon = false;
      this.isShowTcqn01 = true;
    },
    showTcqn02: function showTcqn02() {
      this.isShowTcqn01 = false;
      this.isShowTcqn02 = true;
      this.isShowTcqnTip01 = false;
      this.isShowTcqnTip02 = true;
    },
    showTcqn03: function showTcqn03() {
      this.isShowTcqn02 = false;
      this.isShowTcqn03 = true;
    },
    showTcqn04: function showTcqn04() {
      this.isShowTcqn03 = false;
      this.isShowTcqn04 = true;
    },
    showTcqn05: function showTcqn05() {
      this.isShowTcqn04 = false;
      this.isShowTcqn05 = true;
      setTimeout(function () {
        var $left = $('.tcqn05icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight);
      }, 100);
    },
    showTcqn06: function showTcqn06() {
      this.isShowTcqn05 = false;
      this.isShowTcqn06 = true;
    },
    showTcqn07: function showTcqn07() {
      this.isShowTcqn06 = false;
      this.isShowTcqn07 = true;
    },
    showTcqn08: function showTcqn08() {
      this.isShowTcqn07 = false;
      this.isShowTcqn08 = true;
    },
    showTcqn09: function showTcqn09() {
      this.isShowTcqn08 = false;
      this.isShowTcqn09 = true;
    },
    showTcqn10: function showTcqn10() {
      this.isShowTcqn09 = false;
      this.isShowTcqn10 = true;
      var self = this;
      this.addRecord('END', 12);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this = this;
      var data = {
        exerciseType: 'QIAN_NIU_EXAM_11618',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 12 && type == 'END') {
            window.parent['goBack']();
          }
        } else {
          _this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      tabCurrent: 'first',
      badgesList: [],
      isHaveBadge: true,
      //是否有在线上岗徽章,去掉门槛，默认为true
      tjkName: '',
      tjkNumber: '',
      //第1步
      isShowQnIcon: true,
      //是否显示千牛图标
      isShowQnIcon2: false,
      //显示点击千牛图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      //第2步
      showGqImg: false,
      //显示切换挂起图片
      isShowWgq: false,
      //显示未挂起图片
      //第3步
      isShowKjdy01: true,
      isShowKjdy02: false,
      isShowKjdy03: false,
      isShowKjdy04: false,
      isShowKjdyTip01: true,
      isShowKjdyTip02: false,
      //第4步
      kjdy: '',
      isShowKjdy05: true,
      isShowKjdy06: false,
      isShowKjdy07: false,
      isShowKjdy08: false,
      isShowKjdy09: false,
      isShowKjdyTip03: true,
      isShowKjdyTip04: false,
      //第5步
      zjcz: '',
      isShowZjgnicon: true,
      isShowZjgn01: false,
      isShowZjgn02: false,
      isShowZjgn03: false,
      isShowZjgn04: false,
      isShowZjgn05: false,
      isShowZjgnTip01: true,
      isShowZjgnTip02: false,
      //第6步
      isShowDdcjicon: true,
      isShowDdcj01: false,
      isShowDdcj02: false,
      ddcjbz: '',
      //第7步
      end: '',
      isShowEnd01: true,
      isShowEnd02: false,
      isShowEnd03: false,
      isShowEnd04: false
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    this.getMyBadges();
  },
  watch: {},
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //查询当前用户徽章
    getMyBadges: function getMyBadges() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/user/getByToken').then(function (response) {
        var result = response.data;
        if (result.success) {
          if (result.data) {
            _this.tjkName = result.data.realName;
            _this.tjkNumber = result.data.tjkNumber;
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('Ajax请求接口抛异常！');
      });
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.showGqImg = false;
      this.isShowWgq = false;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowKjdy01 = true;
      this.isShowKjdy02 = false;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = false;
      this.isShowKjdyTip01 = true;
      this.isShowKjdyTip02 = false;
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.isShowKjdy05 = true;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = false;
      this.isShowKjdy08 = false;
      this.isShowKjdyTip03 = true;
      this.isShowKjdyTip04 = false;
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.isShowZjgnicon = true;
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.isShowDdcjicon = true;
      this.isShowDdcj01 = false;
      this.isShowDdcj02 = false;
      this.ddcjbz = '';
    },
    //初始化第7步状态值
    initSeven: function initSeven() {
      this.end = '';
      this.isShowEnd01 = true;
      this.isShowEnd02 = false;
      this.isShowEnd03 = false;
      this.isShowEnd04 = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
    },
    //第1步-单击千牛图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击千牛图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != 'taojin:111') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != '123456') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowLoginImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      var self = this;
      if (this.rnd == '') {
        this.notify('<p>请输入短信验证码</p>');
        return;
      } else if (this.rnd != '789654') {
        this.notify('<p>短信验证码错误</p>');
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 1500);
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg: function showWgqImg() {
      var self = this;
      this.showGqImg = false;
      this.isShowWgq = true;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 1500);
    },
    //第3步-快捷短语
    showKjdy01: function showKjdy01() {
      this.isShowKjdy01 = false;
      this.isShowKjdy02 = true;
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      setTimeout(function () {
        self.isShowKjdy02 = false;
        self.isShowKjdy03 = true;
      }, 500);
    },
    showKjdy02: function showKjdy02() {
      var self = this;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = true;
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    //导出
    showKjdy03: function showKjdy03() {
      var self = this;
      window.open('http://taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 1500);
    },
    //快捷短语
    showKjdy04: function showKjdy04() {
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = true;
    },
    //手动回复
    showKjdy05: function showKjdy05() {
      var self = this;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = true;
      this.notify('<p>快捷短语回复练习完成，下一步手打文字回复</p>');
      setTimeout(function () {
        self.isShowKjdyTip03 = false;
        self.isShowKjdyTip04 = true;
        self.isShowKjdy07 = false;
        self.isShowKjdy08 = true;
      }, 1500);
    },
    showKjdy06: function showKjdy06() {
      var self = this;
      if (this.kjdy.indexOf('您好') < 0 || this.kjdy.indexOf('请问您的收货地址是哪里？') < 0) {
        this.notify('<p>请输入正确的回复内容</p>');
        return false;
      }
      this.isShowKjdy08 = false;
      this.isShowKjdy09 = true;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 1500);
    },
    //第5步-转接功能
    showZjgn01: function showZjgn01() {
      if (this.zjcz.indexOf('抱歉给您带来了不好的体验') < 0 || this.zjcz.indexOf('这边给您转接售后客服') < 0) {
        this.notify('<p>请输入正确的回复内容</p>');
        return false;
      }
      this.isShowZjgnicon = false;
      this.isShowZjgn01 = true;
      this.isShowZjgnTip01 = false;
      this.isShowZjgnTip02 = true;
    },
    showZjgn02: function showZjgn02() {
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = true;
    },
    showZjgn03: function showZjgn03() {
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = true;
    },
    showZjgn04: function showZjgn04() {
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = true;
    },
    showZjgn05: function showZjgn05() {
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = true;
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 1500);
    },
    //第6步-备注
    showDdcj01: function showDdcj01() {
      this.isShowDdcjicon = false;
      this.isShowDdcj01 = true;
    },
    showDdcj02: function showDdcj02() {
      if (this.ddcjbz != '发粉色') {
        this.notify('<p>请填写正确的订单备注</p>');
        return;
      }
      this.isShowDdcj01 = false;
      this.isShowDdcj02 = true;
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 1500);
    },
    //第7步-结束
    showEnd01: function showEnd01() {
      this.isShowEnd01 = false;
      this.isShowEnd02 = true;
    },
    showEnd02: function showEnd02() {
      this.isShowEnd02 = false;
      this.isShowEnd03 = true;
    },
    showEnd03: function showEnd03() {
      this.isShowEnd03 = false;
      this.isShowEnd04 = true;
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 1500);
    },
    again: function again() {
      window.location.reload();
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qnbg.cd4c258.jpg";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      OnInline: 'false',
      //小助手跳转
      tabIndex: 0,
      //序号
      tabCurrent: 'zero',
      //当前标签页
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      isOpenPpt7: false,
      //是否展开ppt
      isOpenPpt8: false,
      //是否展开ppt
      isOpenPpt9: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示图标
      isShowQnIcon2: false,
      //显示点击图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowMimaImg: false,
      //显示记住密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      showGqImg: false,
      //显示切换挂起图片
      isShowWgq: false,
      //显示未挂起图片
      //第3步
      isShowOne: true,
      //显示排序1
      isShowTwo: false,
      //显示排序2
      isShowThree: false,
      //显示排序3
      isShowFour: false,
      //显示排序4
      isShowFive: false,
      //显示排序5
      isShowSix: false,
      //显示数据
      //第4步
      zdhf: '',
      //自动回复输入框
      isShowZdhficon: true,
      isShowZdhf01: false,
      isShowZdhf02: false,
      isShowZdhf03: false,
      isShowZdhf04: false,
      isShowZdhf05: false,
      isShowZdhf06: false,
      isShowZdhf07: false,
      isShowZdhf08: false,
      //第5步
      kjdy: '',
      //快捷编码输入框-16
      kjdytwo: '',
      //快捷编码输入框-发货
      xjkjdy: '',
      //新建快捷短语
      fenzu: '',
      //分组名称
      kjbm: '',
      //快捷编码
      downCount: 0,
      //是否点击下载csv
      isShowKjdy01: true,
      isShowKjdy02: false,
      isShowKjdy03: false,
      isShowKjdy04: false,
      isShowKjdy05: false,
      isShowKjdy06: false,
      isShowKjdy07: false,
      isShowKjdy08: false,
      isShowKjdy09: false,
      isShowKjdy10: false,
      isShowKjdy11: false,
      isShowKjdy12: false,
      isShowKjdy13: false,
      isShowKjdy14: false,
      isShowKjdy15: false,
      isShowKjdy16: false,
      isShowKjdy17: false,
      isShowKjdy18: false,
      isShowKjdy19: false,
      isShowKjdy20: false,
      isShowKjdy21: false,
      isShowKjdy22: false,
      isShowKjdy23: false,
      isShowKjdyTip01: true,
      isShowKjdyTip02: false,
      isShowKjdyTip03: false,
      isShowKjdyTip04: false,
      isShowKjdyTip05: false,
      isShowKjdyTip06: false,
      //第6步
      isShowZjgn01: true,
      isShowZjgn02: false,
      isShowZjgn03: false,
      isShowZjgn04: false,
      isShowZjgn05: false,
      isShowZjgn06: false,
      isShowZjgn07: false,
      //第7步上
      isShowCjgn01: true,
      isShowCjgn02: false,
      isShowCjgn03: false,
      isShowCjgn04: false,
      isShowCjgn05: false,
      isShowCjgn06: false,
      isShowCjgn07: false,
      isShowCjgn08: false,
      isShowCjgn09: false,
      isShowCjgn10: false,
      isShowCjgn11: false,
      isShowCjgn12: false,
      isShowCjgn13: false,
      isShowCjgn14: false,
      isShowCjgn15: false,
      isShowCjgn16: false,
      isShowCjgn17: false,
      isShowCjgn18: false,
      isShowCjgn19: false,
      isShowCjgn20: false,
      isShowCjgnTip01: true,
      isShowCjgnTip02: false,
      isShowCjgnTip03: false,
      isShowCjgnTip04: false,
      isShowCjgnTip05: false,
      isShowCjgnTip06: false,
      isShowCjgnTip07: false,
      //第7步下
      yunfei: '',
      dizhi: '',
      beizhu: '',
      isShowCjgnx01: true,
      isShowCjgnx02: false,
      isShowCjgnx03: false,
      isShowCjgnx04: false,
      isShowCjgnx05: false,
      isShowCjgnx06: false,
      isShowCjgnx07: false,
      isShowCjgnx08: false,
      isShowCjgnx09: false,
      isShowCjgnx10: false,
      isShowCjgnx11: false,
      isShowCjgnx12: false,
      isShowCjgnx13: false,
      isShowCjgnxTip01: true,
      isShowCjgnxTip02: false,
      isShowCjgnxTip03: false,
      isShowCjgnxTip04: false,
      isShowCjgnxTip05: false,
      isShowCjgnxTip06: false,
      //第8步
      isShowTcjm01: true,
      isShowTcjm02: false,
      isShowTcjm03: false,
      isShowTcjm04: false,
      isShowTcjm05: false,
      isShowTcjm06: false,
      isShowTcjm07: false,
      isShowTcjm08: false,
      isShowTcjm09: false,
      isShowTcjm10: false,
      isShowTcjmTip01: true,
      isShowTcjmTip02: false,
      isShowTcjmTip03: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this.tabCurrent).show();
      _this.$set(_this.isShowBtn, _this.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/16') {
        this.isShowKjdy08 = false;
        this.isShowKjdy09 = true;
      }
    },
    kjdytwo: function kjdytwo() {
      if (this.kjdytwo == '/发货') {
        this.isShowKjdy12 = false;
        this.isShowKjdy13 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('zero').play();
      $('#startvideo').hide();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowMimaImg = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.showGqImg = false;
      this.isShowWgq = false;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowOne = true;
      this.isShowTwo = false;
      this.isShowThree = false;
      this.isShowFour = false;
      this.isShowFive = false;
      this.isShowSix = false;
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.zdhf = '';
      this.isShowZdhficon = true;
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = false;
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.kjdy = '';
      this.kjdytwo = '';
      this.xjkjdy = '';
      this.fenzu = '';
      this.downCount = 0;
      this.isShowKjdy01 = true;
      this.isShowKjdy02 = false;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = false;
      this.isShowKjdy08 = false;
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = false;
      this.isShowKjdy12 = false;
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = false;
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = false;
      this.isShowKjdyTip01 = true;
      this.isShowKjdyTip02 = false;
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = false;
      this.isShowKjdyTip05 = false;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.isShowZjgn01 = true;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = false;
    },
    //初始化第7步上状态值
    initSeven: function initSeven() {
      this.isShowCjgn01 = true;
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = false;
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = false;
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = false;
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = false;
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = false;
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = false;
      this.isShowCjgnTip01 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = false;
      this.isShowCjgnTip04 = false;
      this.isShowCjgnTip05 = false;
      this.isShowCjgnTip06 = false;
      this.isShowCjgnTip07 = false;
    },
    //初始化第7步下状态值
    initEight: function initEight() {
      this.yunfei = '';
      this.dizhi = '';
      this.beizhu = '';
      this.isShowCjgnx01 = true;
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = false;
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = false;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = false;
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = false;
      this.isShowCjgnxTip01 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = false;
      this.isShowCjgnxTip04 = false;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = false;
    },
    //初始化第8步状态值
    initNine: function initNine() {
      this.isShowTjgnicon = true;
      this.isShowTjgn01 = false;
      this.isShowTjgn02 = false;
      this.isShowTjgn03 = false;
      this.isShowTjgn04 = false;
      this.isShowTjgn05 = false;
      this.isShowTjgn06 = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      $('#startvideo').hide();
      this.isShowBtn = [];
      this.isOpenPpt = false;
      this.isOpenPpt2 = false;
      this.isOpenPpt3 = false;
      this.isOpenPpt4 = false;
      this.isOpenPpt5 = false;
      this.isOpenPpt6 = false;
      this.isOpenPpt7 = false;
      this.isOpenPpt8 = false;
      this.isOpenPpt9 = false;
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      $('#pdf_viewer7').height('0');
      $('#pdf_viewer8').height('0');
      $('#pdf_viewer9').height('0');
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步上
      this.initSeven();
      //第7步下
      this.initEight();
      //第9步
      this.initNine();
      $('.content').each(function (i) {
        $(this).hide();
      });
      $('.stoptip').each(function (i) {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function (i) {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show();
    },
    //tab切换
    handleClick: function handleClick(tab, event) {
      var _this2 = this;
      this.tabIndex = parseInt(tab.index) + 1;
      //内容初始化
      this.initAll();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this2.tabCurrent).show();
        _this2.$set(_this2.isShowBtn, _this2.tabCurrent, true);
      }, false);
    },
    //展开/收起ppt
    viewPpt: function viewPpt(bol) {
      if (this.isOpenPpt == true || !bol) {
        this.isOpenPpt = false;
        $('#pdf_viewer').height('0');
      } else {
        this.isOpenPpt = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2022-11/47a9abea7f634f6ea4687fc57e21fd9b.pdf?version=0512', "#pdf_viewer", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt2: function viewPpt2(bol) {
      if (this.isOpenPpt2 == true || !bol) {
        this.isOpenPpt2 = false;
        $('#pdf_viewer2').height('0');
      } else {
        this.isOpenPpt2 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer2').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-002.pdf?version=0512', "#pdf_viewer2", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt3: function viewPpt3(bol) {
      if (this.isOpenPpt3 == true || !bol) {
        this.isOpenPpt3 = false;
        $('#pdf_viewer3').height('0');
      } else {
        this.isOpenPpt3 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer3').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-003.pdf?version=0512', "#pdf_viewer3", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt4: function viewPpt4(bol) {
      if (this.isOpenPpt4 == true || !bol) {
        this.isOpenPpt4 = false;
        $('#pdf_viewer4').height('0');
      } else {
        this.isOpenPpt4 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer4').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-004.pdf?version=0512', "#pdf_viewer4", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt5: function viewPpt5(bol) {
      if (this.isOpenPpt5 == true || !bol) {
        this.isOpenPpt5 = false;
        $('#pdf_viewer5').height('0');
      } else {
        this.isOpenPpt5 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer5').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-005.pdf?version=0512', "#pdf_viewer5", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt6: function viewPpt6(bol) {
      if (this.isOpenPpt6 == true || !bol) {
        this.isOpenPpt6 = false;
        $('#pdf_viewer6').height('0');
      } else {
        this.isOpenPpt6 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer6').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-006.pdf?version=0512', "#pdf_viewer6", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt7: function viewPpt7(bol) {
      if (this.isOpenPpt7 == true || !bol) {
        this.isOpenPpt7 = false;
        $('#pdf_viewer7').height('0');
      } else {
        this.isOpenPpt7 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer7').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-007-01.pdf?version=0512', "#pdf_viewer7", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt8: function viewPpt8(bol) {
      if (this.isOpenPpt8 == true || !bol) {
        this.isOpenPpt8 = false;
        $('#pdf_viewer8').height('0');
      } else {
        this.isOpenPpt8 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer8').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-007-02.pdf?version=0512', "#pdf_viewer8", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt9: function viewPpt9(bol) {
      if (this.isOpenPpt9 == true || !bol) {
        this.isOpenPpt9 = false;
        $('#pdf_viewer9').height('0');
      } else {
        this.isOpenPpt9 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer9').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-008.pdf?version=0512', "#pdf_viewer9", options);
        }
      }
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //最后一节-重看视频
    restartVideoLast: function restartVideoLast() {
      this.initTwelve();
      document.getElementById(this.tabCurrent).play();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
    },
    //开始实操练习
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.isShowBtn[this.tabCurrent] = false;
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START');
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initFirst();
      this.initSecond();
      this.initThird();
      this.initFour();
      this.initFive();
      this.initSix();
      this.initSeven();
      this.initEight();
      this.initNine();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.$notify({
          message: '请输入账号',
          duration: 2000
        });
        return;
      } else if (this.name != '淘金客服:002') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (this.password == '') {
        this.$notify({
          message: '请输入密码',
          duration: 2000
        });
        return;
      } else if (this.password != 'TJ2022') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (!this.isShowMimaImg) {
        this.$notify({
          message: '请勾选记住密码',
          duration: 2000
        });
        return;
      }
      this.isShowLoginImg = false;
      this.isShowMimaImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.$notify({
          message: '请输入短信验证码',
          duration: 2000
        });
        return;
      } else if (this.rnd != '6022') {
        this.$notify({
          message: '短信验证码错误',
          duration: 2000
        });
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练-登录
    restartStudyFirst: function restartStudyFirst() {
      this.initFirst();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg: function showWgqImg() {
      var self = this;
      this.showGqImg = false;
      this.isShowWgq = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练-切换状态
    restartStudySecond: function restartStudySecond() {
      this.initSecond();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第3步-排序
    showPaixuImgOne: function showPaixuImgOne() {
      this.isShowOne = false;
      this.isShowTwo = true;
    },
    showPaixuImgTwo: function showPaixuImgTwo() {
      this.isShowTwo = false;
      this.isShowThree = true;
    },
    showPaixuImgThree: function showPaixuImgThree() {
      this.isShowThree = false;
      this.isShowFour = true;
    },
    showPaixuImgFour: function showPaixuImgFour() {
      this.isShowFour = false;
      this.isShowFive = true;
    },
    showPaixuImgFive: function showPaixuImgFive() {
      var self = this;
      this.isShowFive = false;
      this.isShowSix = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第三步
    restartStudyThird: function restartStudyThird() {
      this.initThird();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第4步-自动回复
    showZdhf01: function showZdhf01() {
      this.isShowZdhficon = false;
      this.isShowZdhf01 = true;
    },
    showZdhf02: function showZdhf02() {
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = true;
    },
    showZdhf03: function showZdhf03() {
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = true;
    },
    showZdhf04: function showZdhf04() {
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = true;
    },
    showZdhf05: function showZdhf05() {
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = true;
    },
    showZdhf06: function showZdhf06() {
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = true;
    },
    showZdhf07: function showZdhf07() {
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = true;
    },
    showZdhf08: function showZdhf08() {
      var self = this;
      if (this.zdhf != '您好！欢迎光临，请问有什么可以帮到您？') {
        this.$notify({
          message: '请输入正确的回复内容',
          duration: 2000
        });
        return;
      }
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第4步-自动回复
    restartStudyFour: function restartStudyFour() {
      this.initFour();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第5步-快捷短语
    showKjdy01: function showKjdy01() {
      if (this.downCount == 0) {
        this.$notify({
          message: '请先下载快捷短语模板',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy01 = false;
      this.isShowKjdy02 = true;
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // window.open('//res.study.itaojin.cn/jingmai/快捷短语.csv');
      var path = '//res.study.itaojin.cn/jingmai/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$notify({
          message: '请选择你下载的“快捷短语.csv”模板文件',
          duration: 2000
        });
        return false;
      }
      self.isShowKjdy02 = false;
      self.isShowKjdy03 = true;
      self.$notify({
        message: '快捷短语导入练习完成，下一步快捷短语调出练习',
        duration: 2000
      });
      setTimeout(function () {
        self.isShowKjdy03 = false;
        self.isShowKjdy04 = true;
        self.isShowKjdyTip02 = false;
        self.isShowKjdyTip03 = true;
      }, 2000);
    },
    showKjdy02: function showKjdy02() {
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = true;
    },
    showKjdy03: function showKjdy03() {
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = true;
    },
    showKjdy04: function showKjdy04() {
      var self = this;
      self.isShowKjdy06 = false;
      self.isShowKjdy07 = true;
      setTimeout(function () {
        self.isShowKjdy07 = false;
        self.isShowKjdy08 = true;
        self.isShowKjdyTip03 = false;
        self.isShowKjdyTip04 = true;
      }, 2000);
    },
    showKjdy05: function showKjdy05() {
      this.kjdy = '';
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = true;
    },
    showKjdy06: function showKjdy06() {
      var self = this;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = true;
      setTimeout(function () {
        self.isShowKjdy11 = false;
        self.isShowKjdy12 = true;
        self.isShowKjdyTip04 = false;
        self.isShowKjdyTip05 = true;
      }, 2000);
    },
    showKjdy07: function showKjdy07() {
      this.kjdytwo = '';
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = true;
    },
    showKjdy08: function showKjdy08() {
      var self = this;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = true;
      setTimeout(function () {
        self.isShowKjdy15 = false;
        self.isShowKjdy16 = true;
        self.isShowKjdyTip05 = false;
        self.isShowKjdyTip06 = true;
      }, 2000);
    },
    showKjdy09: function showKjdy09() {
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = true;
    },
    showKjdy10: function showKjdy10() {
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = true;
    },
    showKjdy11: function showKjdy11() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = true;
    },
    showKjdy12: function showKjdy12() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.fenzu != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语分组名称',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = true;
    },
    showKjdy13: function showKjdy13() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = true;
    },
    showKjdy14: function showKjdy14() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = true;
    },
    showKjdy15: function showKjdy15() {
      var self = this;
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.kjbm != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语编码',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第5步-快捷短语
    restartStudyFive: function restartStudyFive() {
      this.initFive();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第6步-转接
    showZjgn01: function showZjgn01() {
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = true;
    },
    showZjgn02: function showZjgn02() {
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = true;
    },
    showZjgn03: function showZjgn03() {
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = true;
    },
    showZjgn04: function showZjgn04() {
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = true;
    },
    showZjgn05: function showZjgn05() {
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = true;
    },
    showZjgn06: function showZjgn06() {
      var self = this;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第6步-转接
    restartStudySix: function restartStudySix() {
      this.initSix();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第7步-插件功能上
    showCjgn01: function showCjgn01() {
      this.isShowCjgn01 = false;
      this.isShowCjgn02 = true;
    },
    showCjgn02: function showCjgn02() {
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = true;
    },
    showCjgn03: function showCjgn03() {
      var self = this;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = true;
      setTimeout(function () {
        self.isShowCjgn04 = false;
        self.isShowCjgn05 = true;
        self.isShowCjgnTip01 = false;
        self.isShowCjgnTip02 = true;
      }, 2000);
    },
    showCjgn04: function showCjgn04() {
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = true;
    },
    showCjgn05: function showCjgn05() {
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = true;
    },
    showCjgn06: function showCjgn06() {
      var self = this;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = true;
      setTimeout(function () {
        self.isShowCjgn08 = false;
        self.isShowCjgn09 = true;
        self.isShowCjgnTip03 = false;
        self.isShowCjgnTip04 = true;
      }, 2000);
    },
    showCjgn07: function showCjgn07() {
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = true;
    },
    showCjgn08: function showCjgn08() {
      var self = this;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = true;
      setTimeout(function () {
        self.isShowCjgn11 = false;
        self.isShowCjgn12 = true;
        self.isShowCjgnTip04 = false;
        self.isShowCjgnTip05 = true;
      }, 2000);
    },
    showCjgn09: function showCjgn09() {
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = true;
    },
    showCjgn10: function showCjgn10() {
      var self = this;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = true;
      setTimeout(function () {
        self.isShowCjgn14 = false;
        self.isShowCjgn15 = true;
        self.isShowCjgnTip05 = false;
        self.isShowCjgnTip06 = true;
      }, 2000);
    },
    showCjgn11: function showCjgn11() {
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = true;
    },
    showCjgn12: function showCjgn12() {
      var self = this;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = true;
      setTimeout(function () {
        self.isShowCjgn17 = false;
        self.isShowCjgn18 = true;
        self.isShowCjgnTip06 = false;
        self.isShowCjgnTip07 = true;
      }, 2000);
    },
    showCjgn13: function showCjgn13() {
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = true;
    },
    showCjgn14: function showCjgn14() {
      var self = this;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第7步-插件功能上
    restartStudySeven: function restartStudySeven() {
      this.initSeven();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第7步-插件功能（下）
    showCjgnx01: function showCjgnx01() {
      this.isShowCjgnx01 = false;
      this.isShowCjgnx02 = true;
    },
    showCjgnx02: function showCjgnx02() {
      var self = this;
      if (this.yunfei != 15) {
        this.$notify({
          message: '请输入正确的运费',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = true;
      setTimeout(function () {
        self.isShowCjgnx03 = false;
        self.isShowCjgnx04 = true;
        self.isShowCjgnxTip01 = false;
        self.isShowCjgnxTip02 = true;
      }, 2000);
    },
    showCjgnx03: function showCjgnx03() {
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = true;
    },
    showCjgnx04: function showCjgnx04() {
      if (this.dizhi != '淘金云客服') {
        this.$notify({
          message: '请输入正确的详细地址',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = true;
    },
    showCjgnx05: function showCjgnx05() {
      var self = this;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = true;
      setTimeout(function () {
        self.isShowCjgnx07 = false;
        self.isShowCjgnx08 = true;
        self.isShowCjgnxTip03 = false;
        self.isShowCjgnxTip04 = true;
      }, 2000);
    },
    showCjgnx06: function showCjgnx06() {
      var self = this;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = true;
      setTimeout(function () {
        self.isShowCjgnx09 = false;
        self.isShowCjgnx10 = true;
        self.isShowCjgnxTip04 = false;
        self.isShowCjgnxTip05 = true;
      }, 2000);
    },
    showCjgnx07: function showCjgnx07() {
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = true;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = true;
    },
    showCjgnx08: function showCjgnx08() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = true;
    },
    showCjgnx09: function showCjgnx09() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = true;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第7步-插件功能下
    restartStudyEight: function restartStudyEight() {
      this.initEight();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第8步-退出京麦
    showTcjm01: function showTcjm01() {
      this.isShowTcjm01 = false;
      this.isShowTcjm02 = true;
    },
    showTcjm02: function showTcjm02() {
      this.isShowTcjm02 = false;
      this.isShowTcjm03 = true;
      this.isShowTcjmTip01 = false;
      this.isShowTcjmTip02 = true;
    },
    showTcjm03: function showTcjm03() {
      this.isShowTcjm03 = false;
      this.isShowTcjm04 = true;
      this.isShowTcjmTip02 = false;
      this.isShowTcjmTip03 = true;
      setTimeout(function () {
        var $left = $('.tcjm04icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight);
      }, 100);
    },
    showTcjm04: function showTcjm04() {
      this.isShowTcjm04 = false;
      this.isShowTcjm05 = true;
    },
    showTcjm05: function showTcjm05() {
      this.isShowTcjm06 = true;
    },
    showTcjm06: function showTcjm06() {
      this.isShowTcjm05 = false;
      this.isShowTcjm06 = false;
      this.isShowTcjm07 = true;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type) {
      var _this3 = this;
      var data = {
        exerciseType: 'JING_MAI',
        stepSeq: this.tabIndex,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this3.tabIndex == 10 && type == 'END') {
            window.parent['goBack']();
          }
        } else {}
      }, function (res) {});
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      tabCurrent: 'first',
      OnInline: 'false',
      //小助手跳转
      //第1步
      isShowQnIcon: true,
      //是否显示图标
      isShowQnIcon2: false,
      //显示点击图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowMimaImg: false,
      //显示记住密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      showGqImg: false,
      //显示切换挂起图片
      isShowWgq: false,
      //显示未挂起图片
      //第3步
      isShowOne: true,
      //显示排序1
      isShowTwo: false,
      //显示排序2
      isShowThree: false,
      //显示排序3
      isShowFour: false,
      //显示排序4
      isShowFive: false,
      //显示排序5
      isShowSix: false,
      //显示数据
      //第4步
      zdhf: '',
      //自动回复输入框
      isShowZdhficon: true,
      isShowZdhf01: false,
      isShowZdhf02: false,
      isShowZdhf03: false,
      isShowZdhf04: false,
      isShowZdhf05: false,
      isShowZdhf06: false,
      isShowZdhf07: false,
      isShowZdhf08: false,
      //第5步
      kjdy: '',
      //快捷编码输入框-16
      kjdytwo: '',
      //快捷编码输入框-发货
      xjkjdy: '',
      //新建快捷短语
      fenzu: '',
      //分组名称
      kjbm: '',
      //快捷编码
      downCount: 0,
      //是否点击下载csv
      isShowKjdy01: true,
      isShowKjdy02: false,
      isShowKjdy03: false,
      isShowKjdy04: false,
      isShowKjdy05: false,
      isShowKjdy06: false,
      isShowKjdy07: false,
      isShowKjdy08: false,
      isShowKjdy09: false,
      isShowKjdy10: false,
      isShowKjdy11: false,
      isShowKjdy12: false,
      isShowKjdy13: false,
      isShowKjdy14: false,
      isShowKjdy15: false,
      isShowKjdy16: false,
      isShowKjdy17: false,
      isShowKjdy18: false,
      isShowKjdy19: false,
      isShowKjdy20: false,
      isShowKjdy21: false,
      isShowKjdy22: false,
      isShowKjdy23: false,
      isShowKjdyTip01: true,
      isShowKjdyTip02: false,
      isShowKjdyTip03: false,
      isShowKjdyTip04: false,
      isShowKjdyTip05: false,
      isShowKjdyTip06: false,
      //第6步
      isShowZjgn01: true,
      isShowZjgn02: false,
      isShowZjgn03: false,
      isShowZjgn04: false,
      isShowZjgn05: false,
      isShowZjgn06: false,
      isShowZjgn07: false,
      //第7步上
      isShowCjgn01: true,
      isShowCjgn02: false,
      isShowCjgn03: false,
      isShowCjgn04: false,
      isShowCjgn05: false,
      isShowCjgn06: false,
      isShowCjgn07: false,
      isShowCjgn08: false,
      isShowCjgn09: false,
      isShowCjgn10: false,
      isShowCjgn11: false,
      isShowCjgn12: false,
      isShowCjgn13: false,
      isShowCjgn14: false,
      isShowCjgn15: false,
      isShowCjgn16: false,
      isShowCjgn17: false,
      isShowCjgn18: false,
      isShowCjgn19: false,
      isShowCjgn20: false,
      isShowCjgnTip01: true,
      isShowCjgnTip02: false,
      isShowCjgnTip03: false,
      isShowCjgnTip04: false,
      isShowCjgnTip05: false,
      isShowCjgnTip06: false,
      isShowCjgnTip07: false,
      //第7步下
      yunfei: '',
      dizhi: '',
      beizhu: '',
      isShowCjgnx01: true,
      isShowCjgnx02: false,
      isShowCjgnx03: false,
      isShowCjgnx04: false,
      isShowCjgnx05: false,
      isShowCjgnx06: false,
      isShowCjgnx07: false,
      isShowCjgnx08: false,
      isShowCjgnx09: false,
      isShowCjgnx10: false,
      isShowCjgnx11: false,
      isShowCjgnx12: false,
      isShowCjgnx13: false,
      isShowCjgnxTip01: true,
      isShowCjgnxTip02: false,
      isShowCjgnxTip03: false,
      isShowCjgnxTip04: false,
      isShowCjgnxTip05: false,
      isShowCjgnxTip06: false,
      //第8步
      isShowTcjm01: true,
      isShowTcjm02: false,
      isShowTcjm03: false,
      isShowTcjm04: false,
      isShowTcjm05: false,
      isShowTcjm06: false,
      isShowTcjm07: false,
      isShowTcjm08: false,
      isShowTcjm09: false,
      isShowTcjm10: false,
      isShowTcjmTip01: true,
      isShowTcjmTip02: false,
      isShowTcjmTip03: false
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/16') {
        this.isShowKjdy08 = false;
        this.isShowKjdy09 = true;
      }
    },
    kjdytwo: function kjdytwo() {
      if (this.kjdytwo == '/发货') {
        this.isShowKjdy12 = false;
        this.isShowKjdy13 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('first').play();
      $('#startvideo').hide();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowMimaImg = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.showGqImg = false;
      this.isShowWgq = false;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowOne = true;
      this.isShowTwo = false;
      this.isShowThree = false;
      this.isShowFour = false;
      this.isShowFive = false;
      this.isShowSix = false;
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.zdhf = '';
      this.isShowZdhficon = true;
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = false;
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.kjdy = '';
      this.kjdytwo = '';
      this.xjkjdy = '';
      this.fenzu = '';
      this.downCount = 0;
      this.isShowKjdy01 = true;
      this.isShowKjdy02 = false;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = false;
      this.isShowKjdy08 = false;
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = false;
      this.isShowKjdy12 = false;
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = false;
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = false;
      this.isShowKjdyTip01 = true;
      this.isShowKjdyTip02 = false;
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = false;
      this.isShowKjdyTip05 = false;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.isShowZjgn01 = true;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = false;
    },
    //初始化第7步上状态值
    initSeven: function initSeven() {
      this.isShowCjgn01 = true;
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = false;
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = false;
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = false;
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = false;
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = false;
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = false;
      this.isShowCjgnTip01 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = false;
      this.isShowCjgnTip04 = false;
      this.isShowCjgnTip05 = false;
      this.isShowCjgnTip06 = false;
      this.isShowCjgnTip07 = false;
    },
    //初始化第7步下状态值
    initEight: function initEight() {
      this.yunfei = '';
      this.dizhi = '';
      this.beizhu = '';
      this.isShowCjgnx01 = true;
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = false;
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = false;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = false;
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = false;
      this.isShowCjgnxTip01 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = false;
      this.isShowCjgnxTip04 = false;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = false;
    },
    //初始化第8步状态值
    initNine: function initNine() {
      this.isShowTjgnicon = true;
      this.isShowTjgn01 = false;
      this.isShowTjgn02 = false;
      this.isShowTjgn03 = false;
      this.isShowTjgn04 = false;
      this.isShowTjgn05 = false;
      this.isShowTjgn06 = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步上
      this.initSeven();
      //第7步下
      this.initEight();
      //第9步
      this.initNine();
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.$notify({
          message: '请输入账号',
          duration: 2000
        });
        return;
      } else if (this.name != '淘金客服:002') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (this.password == '') {
        this.$notify({
          message: '请输入密码',
          duration: 2000
        });
        return;
      } else if (this.password != 'TJ2022') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (!this.isShowMimaImg) {
        this.$notify({
          message: '请勾选记住密码',
          duration: 2000
        });
        return;
      }
      this.isShowLoginImg = false;
      this.isShowMimaImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.$notify({
          message: '请输入短信验证码',
          duration: 2000
        });
        return;
      } else if (this.rnd != '6022') {
        this.$notify({
          message: '短信验证码错误',
          duration: 2000
        });
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg: function showWgqImg() {
      var self = this;
      this.showGqImg = false;
      this.isShowWgq = true;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第3步-排序
    showPaixuImgOne: function showPaixuImgOne() {
      this.isShowOne = false;
      this.isShowTwo = true;
    },
    showPaixuImgTwo: function showPaixuImgTwo() {
      this.isShowTwo = false;
      this.isShowThree = true;
    },
    showPaixuImgThree: function showPaixuImgThree() {
      this.isShowThree = false;
      this.isShowFour = true;
    },
    showPaixuImgFour: function showPaixuImgFour() {
      this.isShowFour = false;
      this.isShowFive = true;
    },
    showPaixuImgFive: function showPaixuImgFive() {
      var self = this;
      this.isShowFive = false;
      this.isShowSix = true;
      this.addRecord('END', 3);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第4步-自动回复
    showZdhf01: function showZdhf01() {
      this.isShowZdhficon = false;
      this.isShowZdhf01 = true;
    },
    showZdhf02: function showZdhf02() {
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = true;
    },
    showZdhf03: function showZdhf03() {
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = true;
    },
    showZdhf04: function showZdhf04() {
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = true;
    },
    showZdhf05: function showZdhf05() {
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = true;
    },
    showZdhf06: function showZdhf06() {
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = true;
    },
    showZdhf07: function showZdhf07() {
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = true;
    },
    showZdhf08: function showZdhf08() {
      var self = this;
      if (this.zdhf != '您好！欢迎光临，请问有什么可以帮到您？') {
        this.$notify({
          message: '请输入正确的回复内容',
          duration: 2000
        });
        return;
      }
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = true;
      this.addRecord('END', 4);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第5步-快捷短语
    showKjdy01: function showKjdy01() {
      if (this.downCount == 0) {
        this.$notify({
          message: '请先下载快捷短语模板',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy01 = false;
      this.isShowKjdy02 = true;
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // window.open('//res.study.itaojin.cn/jingmai/快捷短语.csv');
      var path = '//res.study.itaojin.cn/jingmai/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$notify({
          message: '请选择你下载的“快捷短语.csv”模板文件',
          duration: 2000
        });
        return false;
      }
      self.isShowKjdy02 = false;
      self.isShowKjdy03 = true;
      self.$notify({
        message: '快捷短语导入练习完成，下一步快捷短语调出练习',
        duration: 2000
      });
      setTimeout(function () {
        self.isShowKjdy03 = false;
        self.isShowKjdy04 = true;
        self.isShowKjdyTip02 = false;
        self.isShowKjdyTip03 = true;
      }, 2000);
    },
    showKjdy02: function showKjdy02() {
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = true;
    },
    showKjdy03: function showKjdy03() {
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = true;
    },
    showKjdy04: function showKjdy04() {
      var self = this;
      self.isShowKjdy06 = false;
      self.isShowKjdy07 = true;
      setTimeout(function () {
        self.isShowKjdy07 = false;
        self.isShowKjdy08 = true;
        self.isShowKjdyTip03 = false;
        self.isShowKjdyTip04 = true;
      }, 2000);
    },
    showKjdy05: function showKjdy05() {
      this.kjdy = '';
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = true;
    },
    showKjdy06: function showKjdy06() {
      var self = this;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = true;
      setTimeout(function () {
        self.isShowKjdy11 = false;
        self.isShowKjdy12 = true;
        self.isShowKjdyTip04 = false;
        self.isShowKjdyTip05 = true;
      }, 2000);
    },
    showKjdy07: function showKjdy07() {
      this.kjdytwo = '';
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = true;
    },
    showKjdy08: function showKjdy08() {
      var self = this;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = true;
      setTimeout(function () {
        self.isShowKjdy15 = false;
        self.isShowKjdy16 = true;
        self.isShowKjdyTip05 = false;
        self.isShowKjdyTip06 = true;
      }, 2000);
    },
    showKjdy09: function showKjdy09() {
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = true;
    },
    showKjdy10: function showKjdy10() {
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = true;
    },
    showKjdy11: function showKjdy11() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = true;
    },
    showKjdy12: function showKjdy12() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.fenzu != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语分组名称',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = true;
    },
    showKjdy13: function showKjdy13() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = true;
    },
    showKjdy14: function showKjdy14() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = true;
    },
    showKjdy15: function showKjdy15() {
      var self = this;
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.kjbm != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语编码',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = true;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第6步-转接
    showZjgn01: function showZjgn01() {
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = true;
    },
    showZjgn02: function showZjgn02() {
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = true;
    },
    showZjgn03: function showZjgn03() {
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = true;
    },
    showZjgn04: function showZjgn04() {
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = true;
    },
    showZjgn05: function showZjgn05() {
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = true;
    },
    showZjgn06: function showZjgn06() {
      var self = this;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = true;
      this.addRecord('END', 6);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第7步-插件功能上
    showCjgn01: function showCjgn01() {
      this.isShowCjgn01 = false;
      this.isShowCjgn02 = true;
    },
    showCjgn02: function showCjgn02() {
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = true;
    },
    showCjgn03: function showCjgn03() {
      var self = this;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = true;
      setTimeout(function () {
        self.isShowCjgn04 = false;
        self.isShowCjgn05 = true;
        self.isShowCjgnTip01 = false;
        self.isShowCjgnTip02 = true;
      }, 2000);
    },
    showCjgn04: function showCjgn04() {
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = true;
    },
    showCjgn05: function showCjgn05() {
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = true;
    },
    showCjgn06: function showCjgn06() {
      var self = this;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = true;
      setTimeout(function () {
        self.isShowCjgn08 = false;
        self.isShowCjgn09 = true;
        self.isShowCjgnTip03 = false;
        self.isShowCjgnTip04 = true;
      }, 2000);
    },
    showCjgn07: function showCjgn07() {
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = true;
    },
    showCjgn08: function showCjgn08() {
      var self = this;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = true;
      setTimeout(function () {
        self.isShowCjgn11 = false;
        self.isShowCjgn12 = true;
        self.isShowCjgnTip04 = false;
        self.isShowCjgnTip05 = true;
      }, 2000);
    },
    showCjgn09: function showCjgn09() {
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = true;
    },
    showCjgn10: function showCjgn10() {
      var self = this;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = true;
      setTimeout(function () {
        self.isShowCjgn14 = false;
        self.isShowCjgn15 = true;
        self.isShowCjgnTip05 = false;
        self.isShowCjgnTip06 = true;
      }, 2000);
    },
    showCjgn11: function showCjgn11() {
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = true;
    },
    showCjgn12: function showCjgn12() {
      var self = this;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = true;
      setTimeout(function () {
        self.isShowCjgn17 = false;
        self.isShowCjgn18 = true;
        self.isShowCjgnTip06 = false;
        self.isShowCjgnTip07 = true;
      }, 2000);
    },
    showCjgn13: function showCjgn13() {
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = true;
    },
    showCjgn14: function showCjgn14() {
      var self = this;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = true;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第7步-插件功能（下）
    showCjgnx01: function showCjgnx01() {
      this.isShowCjgnx01 = false;
      this.isShowCjgnx02 = true;
    },
    showCjgnx02: function showCjgnx02() {
      var self = this;
      if (this.yunfei != 15) {
        this.$notify({
          message: '请输入正确的运费',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = true;
      setTimeout(function () {
        self.isShowCjgnx03 = false;
        self.isShowCjgnx04 = true;
        self.isShowCjgnxTip01 = false;
        self.isShowCjgnxTip02 = true;
      }, 2000);
    },
    showCjgnx03: function showCjgnx03() {
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = true;
    },
    showCjgnx04: function showCjgnx04() {
      if (this.dizhi != '淘金云客服') {
        this.$notify({
          message: '请输入正确的详细地址',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = true;
    },
    showCjgnx05: function showCjgnx05() {
      var self = this;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = true;
      setTimeout(function () {
        self.isShowCjgnx07 = false;
        self.isShowCjgnx08 = true;
        self.isShowCjgnxTip03 = false;
        self.isShowCjgnxTip04 = true;
      }, 2000);
    },
    showCjgnx06: function showCjgnx06() {
      var self = this;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = true;
      setTimeout(function () {
        self.isShowCjgnx09 = false;
        self.isShowCjgnx10 = true;
        self.isShowCjgnxTip04 = false;
        self.isShowCjgnxTip05 = true;
      }, 2000);
    },
    showCjgnx07: function showCjgnx07() {
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = true;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = true;
    },
    showCjgnx08: function showCjgnx08() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = true;
    },
    showCjgnx09: function showCjgnx09() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = true;
      var self = this;
      this.addRecord('END', 8);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第8步-退出京麦
    showTcjm01: function showTcjm01() {
      this.isShowTcjm01 = false;
      this.isShowTcjm02 = true;
    },
    showTcjm02: function showTcjm02() {
      this.isShowTcjm02 = false;
      this.isShowTcjm03 = true;
      this.isShowTcjmTip01 = false;
      this.isShowTcjmTip02 = true;
    },
    showTcjm03: function showTcjm03() {
      this.isShowTcjm03 = false;
      this.isShowTcjm04 = true;
      this.isShowTcjmTip02 = false;
      this.isShowTcjmTip03 = true;
      setTimeout(function () {
        var $left = $('.tcjm04icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight);
      }, 100);
    },
    showTcjm04: function showTcjm04() {
      this.isShowTcjm04 = false;
      this.isShowTcjm05 = true;
    },
    showTcjm05: function showTcjm05() {
      this.isShowTcjm06 = true;
    },
    showTcjm06: function showTcjm06() {
      this.isShowTcjm05 = false;
      this.isShowTcjm06 = false;
      this.isShowTcjm07 = true;
      var self = this;
      this.addRecord('END', 9);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this = this;
      var data = {
        exerciseType: 'JING_MAI_EXAM',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 9 && type == 'END') {
            window.parent['goBack']();
            try {
              _this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/courseRecord/tool/addCourseRecord?courseId=10466', null).then(function (response) {});
            } catch (e) {}
          }
        } else {
          _this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      tabCurrent: 'first',
      OnInline: 'false',
      //小助手跳转
      //第1步
      isShowQnIcon: true,
      //是否显示图标
      isShowQnIcon2: false,
      //显示点击图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowMimaImg: false,
      //显示记住密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      showGqImg: false,
      //显示切换挂起图片
      isShowWgq: false,
      //显示未挂起图片
      //第3步
      isShowOne: true,
      //显示排序1
      isShowTwo: false,
      //显示排序2
      isShowThree: false,
      //显示排序3
      isShowFour: false,
      //显示排序4
      isShowFive: false,
      //显示排序5
      isShowSix: false,
      //显示数据
      //第4步
      zdhf: '',
      //自动回复输入框
      isShowZdhficon: true,
      isShowZdhf01: false,
      isShowZdhf02: false,
      isShowZdhf03: false,
      isShowZdhf04: false,
      isShowZdhf05: false,
      isShowZdhf06: false,
      isShowZdhf07: false,
      isShowZdhf08: false,
      //第5步
      kjdy: '',
      //快捷编码输入框-16
      kjdytwo: '',
      //快捷编码输入框-发货
      xjkjdy: '',
      //新建快捷短语
      fenzu: '',
      //分组名称
      kjbm: '',
      //快捷编码
      downCount: 0,
      //是否点击下载csv
      isShowKjdy01: true,
      isShowKjdy02: false,
      isShowKjdy03: false,
      isShowKjdy04: false,
      isShowKjdy05: false,
      isShowKjdy06: false,
      isShowKjdy07: false,
      isShowKjdy08: false,
      isShowKjdy09: false,
      isShowKjdy10: false,
      isShowKjdy11: false,
      isShowKjdy12: false,
      isShowKjdy13: false,
      isShowKjdy14: false,
      isShowKjdy15: false,
      isShowKjdy16: false,
      isShowKjdy17: false,
      isShowKjdy18: false,
      isShowKjdy19: false,
      isShowKjdy20: false,
      isShowKjdy21: false,
      isShowKjdy22: false,
      isShowKjdy23: false,
      isShowKjdyTip01: true,
      isShowKjdyTip02: false,
      isShowKjdyTip03: false,
      isShowKjdyTip04: false,
      isShowKjdyTip05: false,
      isShowKjdyTip06: false,
      //第6步
      isShowZjgn01: true,
      isShowZjgn02: false,
      isShowZjgn03: false,
      isShowZjgn04: false,
      isShowZjgn05: false,
      isShowZjgn06: false,
      isShowZjgn07: false,
      //第7步上
      isShowCjgn01: true,
      isShowCjgn02: false,
      isShowCjgn03: false,
      isShowCjgn04: false,
      isShowCjgn05: false,
      isShowCjgn06: false,
      isShowCjgn07: false,
      isShowCjgn08: false,
      isShowCjgn09: false,
      isShowCjgn10: false,
      isShowCjgn11: false,
      isShowCjgn12: false,
      isShowCjgn13: false,
      isShowCjgn14: false,
      isShowCjgn15: false,
      isShowCjgn16: false,
      isShowCjgn17: false,
      isShowCjgn18: false,
      isShowCjgn19: false,
      isShowCjgn20: false,
      isShowCjgnTip01: true,
      isShowCjgnTip02: false,
      isShowCjgnTip03: false,
      isShowCjgnTip04: false,
      isShowCjgnTip05: false,
      isShowCjgnTip06: false,
      isShowCjgnTip07: false,
      //第7步下
      yunfei: '',
      dizhi: '',
      beizhu: '',
      isShowCjgnx01: true,
      isShowCjgnx02: false,
      isShowCjgnx03: false,
      isShowCjgnx04: false,
      isShowCjgnx05: false,
      isShowCjgnx06: false,
      isShowCjgnx07: false,
      isShowCjgnx08: false,
      isShowCjgnx09: false,
      isShowCjgnx10: false,
      isShowCjgnx11: false,
      isShowCjgnx12: false,
      isShowCjgnx13: false,
      isShowCjgnxTip01: true,
      isShowCjgnxTip02: false,
      isShowCjgnxTip03: false,
      isShowCjgnxTip04: false,
      isShowCjgnxTip05: false,
      isShowCjgnxTip06: false,
      //第8步
      isShowTcjm01: true,
      isShowTcjm02: false,
      isShowTcjm03: false,
      isShowTcjm04: false,
      isShowTcjm05: false,
      isShowTcjm06: false,
      isShowTcjm07: false,
      isShowTcjm08: false,
      isShowTcjm09: false,
      isShowTcjm10: false,
      isShowTcjmTip01: true,
      isShowTcjmTip02: false,
      isShowTcjmTip03: false
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/16') {
        this.isShowKjdy08 = false;
        this.isShowKjdy09 = true;
      }
    },
    kjdytwo: function kjdytwo() {
      if (this.kjdytwo == '/发货') {
        this.isShowKjdy12 = false;
        this.isShowKjdy13 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('first').play();
      $('#startvideo').hide();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowMimaImg = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.showGqImg = false;
      this.isShowWgq = false;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowOne = true;
      this.isShowTwo = false;
      this.isShowThree = false;
      this.isShowFour = false;
      this.isShowFive = false;
      this.isShowSix = false;
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.zdhf = '';
      this.isShowZdhficon = true;
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = false;
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.kjdy = '';
      this.kjdytwo = '';
      this.xjkjdy = '';
      this.fenzu = '';
      this.downCount = 0;
      this.isShowKjdy01 = true;
      this.isShowKjdy02 = false;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = false;
      this.isShowKjdy08 = false;
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = false;
      this.isShowKjdy12 = false;
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = false;
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = false;
      this.isShowKjdyTip01 = true;
      this.isShowKjdyTip02 = false;
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = false;
      this.isShowKjdyTip05 = false;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.isShowZjgn01 = true;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = false;
    },
    //初始化第7步上状态值
    initSeven: function initSeven() {
      this.isShowCjgn01 = true;
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = false;
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = false;
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = false;
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = false;
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = false;
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = false;
      this.isShowCjgnTip01 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = false;
      this.isShowCjgnTip04 = false;
      this.isShowCjgnTip05 = false;
      this.isShowCjgnTip06 = false;
      this.isShowCjgnTip07 = false;
    },
    //初始化第7步下状态值
    initEight: function initEight() {
      this.yunfei = '';
      this.dizhi = '';
      this.beizhu = '';
      this.isShowCjgnx01 = true;
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = false;
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = false;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = false;
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = false;
      this.isShowCjgnxTip01 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = false;
      this.isShowCjgnxTip04 = false;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = false;
    },
    //初始化第8步状态值
    initNine: function initNine() {
      this.isShowTjgnicon = true;
      this.isShowTjgn01 = false;
      this.isShowTjgn02 = false;
      this.isShowTjgn03 = false;
      this.isShowTjgn04 = false;
      this.isShowTjgn05 = false;
      this.isShowTjgn06 = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步上
      this.initSeven();
      //第7步下
      this.initEight();
      //第9步
      this.initNine();
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.$notify({
          message: '请输入账号',
          duration: 2000
        });
        return;
      } else if (this.name != '淘金客服:002') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (this.password == '') {
        this.$notify({
          message: '请输入密码',
          duration: 2000
        });
        return;
      } else if (this.password != 'TJ2022') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (!this.isShowMimaImg) {
        this.$notify({
          message: '请勾选记住密码',
          duration: 2000
        });
        return;
      }
      this.isShowLoginImg = false;
      this.isShowMimaImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.$notify({
          message: '请输入短信验证码',
          duration: 2000
        });
        return;
      } else if (this.rnd != '6022') {
        this.$notify({
          message: '短信验证码错误',
          duration: 2000
        });
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg: function showWgqImg() {
      var self = this;
      this.showGqImg = false;
      this.isShowWgq = true;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第3步-排序
    showPaixuImgOne: function showPaixuImgOne() {
      this.isShowOne = false;
      this.isShowTwo = true;
    },
    showPaixuImgTwo: function showPaixuImgTwo() {
      this.isShowTwo = false;
      this.isShowThree = true;
    },
    showPaixuImgThree: function showPaixuImgThree() {
      this.isShowThree = false;
      this.isShowFour = true;
    },
    showPaixuImgFour: function showPaixuImgFour() {
      this.isShowFour = false;
      this.isShowFive = true;
    },
    showPaixuImgFive: function showPaixuImgFive() {
      var self = this;
      this.isShowFive = false;
      this.isShowSix = true;
      this.addRecord('END', 3);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第4步-自动回复
    showZdhf01: function showZdhf01() {
      this.isShowZdhficon = false;
      this.isShowZdhf01 = true;
    },
    showZdhf02: function showZdhf02() {
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = true;
    },
    showZdhf03: function showZdhf03() {
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = true;
    },
    showZdhf04: function showZdhf04() {
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = true;
    },
    showZdhf05: function showZdhf05() {
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = true;
    },
    showZdhf06: function showZdhf06() {
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = true;
    },
    showZdhf07: function showZdhf07() {
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = true;
    },
    showZdhf08: function showZdhf08() {
      var self = this;
      if (this.zdhf != '您好！欢迎光临，请问有什么可以帮到您？') {
        this.$notify({
          message: '请输入正确的回复内容',
          duration: 2000
        });
        return;
      }
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = true;
      this.addRecord('END', 4);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第5步-快捷短语
    showKjdy01: function showKjdy01() {
      if (this.downCount == 0) {
        this.$notify({
          message: '请先下载快捷短语模板',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy01 = false;
      this.isShowKjdy02 = true;
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // window.open('//res.study.itaojin.cn/jingmai/快捷短语.csv');
      var path = '//res.study.itaojin.cn/jingmai/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$notify({
          message: '请选择你下载的“快捷短语.csv”模板文件',
          duration: 2000
        });
        return false;
      }
      self.isShowKjdy02 = false;
      self.isShowKjdy03 = true;
      self.$notify({
        message: '快捷短语导入练习完成，下一步快捷短语调出练习',
        duration: 2000
      });
      setTimeout(function () {
        self.isShowKjdy03 = false;
        self.isShowKjdy04 = true;
        self.isShowKjdyTip02 = false;
        self.isShowKjdyTip03 = true;
      }, 2000);
    },
    showKjdy02: function showKjdy02() {
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = true;
    },
    showKjdy03: function showKjdy03() {
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = true;
    },
    showKjdy04: function showKjdy04() {
      var self = this;
      self.isShowKjdy06 = false;
      self.isShowKjdy07 = true;
      setTimeout(function () {
        self.isShowKjdy07 = false;
        self.isShowKjdy08 = true;
        self.isShowKjdyTip03 = false;
        self.isShowKjdyTip04 = true;
      }, 2000);
    },
    showKjdy05: function showKjdy05() {
      this.kjdy = '';
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = true;
    },
    showKjdy06: function showKjdy06() {
      var self = this;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = true;
      setTimeout(function () {
        self.isShowKjdy11 = false;
        self.isShowKjdy12 = true;
        self.isShowKjdyTip04 = false;
        self.isShowKjdyTip05 = true;
      }, 2000);
    },
    showKjdy07: function showKjdy07() {
      this.kjdytwo = '';
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = true;
    },
    showKjdy08: function showKjdy08() {
      var self = this;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = true;
      setTimeout(function () {
        self.isShowKjdy15 = false;
        self.isShowKjdy16 = true;
        self.isShowKjdyTip05 = false;
        self.isShowKjdyTip06 = true;
      }, 2000);
    },
    showKjdy09: function showKjdy09() {
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = true;
    },
    showKjdy10: function showKjdy10() {
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = true;
    },
    showKjdy11: function showKjdy11() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = true;
    },
    showKjdy12: function showKjdy12() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.fenzu != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语分组名称',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = true;
    },
    showKjdy13: function showKjdy13() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = true;
    },
    showKjdy14: function showKjdy14() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = true;
    },
    showKjdy15: function showKjdy15() {
      var self = this;
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.kjbm != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语编码',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = true;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第6步-转接
    showZjgn01: function showZjgn01() {
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = true;
    },
    showZjgn02: function showZjgn02() {
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = true;
    },
    showZjgn03: function showZjgn03() {
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = true;
    },
    showZjgn04: function showZjgn04() {
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = true;
    },
    showZjgn05: function showZjgn05() {
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = true;
    },
    showZjgn06: function showZjgn06() {
      var self = this;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = true;
      this.addRecord('END', 6);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第7步-插件功能上
    showCjgn01: function showCjgn01() {
      this.isShowCjgn01 = false;
      this.isShowCjgn02 = true;
    },
    showCjgn02: function showCjgn02() {
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = true;
    },
    showCjgn03: function showCjgn03() {
      var self = this;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = true;
      setTimeout(function () {
        self.isShowCjgn04 = false;
        self.isShowCjgn05 = true;
        self.isShowCjgnTip01 = false;
        self.isShowCjgnTip02 = true;
      }, 2000);
    },
    showCjgn04: function showCjgn04() {
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = true;
    },
    showCjgn05: function showCjgn05() {
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = true;
    },
    showCjgn06: function showCjgn06() {
      var self = this;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = true;
      setTimeout(function () {
        self.isShowCjgn08 = false;
        self.isShowCjgn09 = true;
        self.isShowCjgnTip03 = false;
        self.isShowCjgnTip04 = true;
      }, 2000);
    },
    showCjgn07: function showCjgn07() {
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = true;
    },
    showCjgn08: function showCjgn08() {
      var self = this;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = true;
      setTimeout(function () {
        self.isShowCjgn11 = false;
        self.isShowCjgn12 = true;
        self.isShowCjgnTip04 = false;
        self.isShowCjgnTip05 = true;
      }, 2000);
    },
    showCjgn09: function showCjgn09() {
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = true;
    },
    showCjgn10: function showCjgn10() {
      var self = this;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = true;
      setTimeout(function () {
        self.isShowCjgn14 = false;
        self.isShowCjgn15 = true;
        self.isShowCjgnTip05 = false;
        self.isShowCjgnTip06 = true;
      }, 2000);
    },
    showCjgn11: function showCjgn11() {
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = true;
    },
    showCjgn12: function showCjgn12() {
      var self = this;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = true;
      setTimeout(function () {
        self.isShowCjgn17 = false;
        self.isShowCjgn18 = true;
        self.isShowCjgnTip06 = false;
        self.isShowCjgnTip07 = true;
      }, 2000);
    },
    showCjgn13: function showCjgn13() {
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = true;
    },
    showCjgn14: function showCjgn14() {
      var self = this;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = true;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第7步-插件功能（下）
    showCjgnx01: function showCjgnx01() {
      this.isShowCjgnx01 = false;
      this.isShowCjgnx02 = true;
    },
    showCjgnx02: function showCjgnx02() {
      var self = this;
      if (this.yunfei != 15) {
        this.$notify({
          message: '请输入正确的运费',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = true;
      setTimeout(function () {
        self.isShowCjgnx03 = false;
        self.isShowCjgnx04 = true;
        self.isShowCjgnxTip01 = false;
        self.isShowCjgnxTip02 = true;
      }, 2000);
    },
    showCjgnx03: function showCjgnx03() {
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = true;
    },
    showCjgnx04: function showCjgnx04() {
      if (this.dizhi != '淘金云客服') {
        this.$notify({
          message: '请输入正确的详细地址',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = true;
    },
    showCjgnx05: function showCjgnx05() {
      var self = this;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = true;
      setTimeout(function () {
        self.isShowCjgnx07 = false;
        self.isShowCjgnx08 = true;
        self.isShowCjgnxTip03 = false;
        self.isShowCjgnxTip04 = true;
      }, 2000);
    },
    showCjgnx06: function showCjgnx06() {
      var self = this;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = true;
      setTimeout(function () {
        self.isShowCjgnx09 = false;
        self.isShowCjgnx10 = true;
        self.isShowCjgnxTip04 = false;
        self.isShowCjgnxTip05 = true;
      }, 2000);
    },
    showCjgnx07: function showCjgnx07() {
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = true;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = true;
    },
    showCjgnx08: function showCjgnx08() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = true;
    },
    showCjgnx09: function showCjgnx09() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = true;
      var self = this;
      this.addRecord('END', 8);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第8步-退出京麦
    showTcjm01: function showTcjm01() {
      this.isShowTcjm01 = false;
      this.isShowTcjm02 = true;
    },
    showTcjm02: function showTcjm02() {
      this.isShowTcjm02 = false;
      this.isShowTcjm03 = true;
      this.isShowTcjmTip01 = false;
      this.isShowTcjmTip02 = true;
    },
    showTcjm03: function showTcjm03() {
      this.isShowTcjm03 = false;
      this.isShowTcjm04 = true;
      this.isShowTcjmTip02 = false;
      this.isShowTcjmTip03 = true;
      setTimeout(function () {
        var $left = $('.tcjm04icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight);
      }, 100);
    },
    showTcjm04: function showTcjm04() {
      this.isShowTcjm04 = false;
      this.isShowTcjm05 = true;
    },
    showTcjm05: function showTcjm05() {
      this.isShowTcjm06 = true;
    },
    showTcjm06: function showTcjm06() {
      this.isShowTcjm05 = false;
      this.isShowTcjm06 = false;
      this.isShowTcjm07 = true;
      var self = this;
      this.addRecord('END', 9);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this = this;
      var data = {
        exerciseType: 'JING_MAI_EXAM_11618',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 9 && type == 'END') {
            window.parent['goBack']();
          }
        } else {
          _this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      scheduleId: '',
      disabled: false,
      isShowMore: true,
      isShowMoreTwo: true,
      isShowList: false,
      //默认显示列表
      isShowPjia: false,
      //显示评价
      isShowPjiaSucc: false,
      //显示评价成功提示
      isShowCheckSucc: false,
      //签到成功提示
      isShowLogin: false,
      //显示登录
      isShowRecruit: false,
      //显示报名
      isShowTemplate: false,
      //显示问卷调查
      isShowCheck: false,
      //显示立即签到弹框
      interval: null,
      //轮询状态
      time: 0,
      //签到剩余时间
      djs: '',
      //倒计时
      checkCourseId: '',
      //当前签到课程id
      description: '',
      //课程说明
      list: [],
      courseId: '',
      //评价时课程id
      advice: '',
      //建议
      courseScore: 0,
      //课程评分
      utility: 0,
      //实用性
      popularity: 0,
      //通俗性
      reasonability: 0,
      //合理性
      teacherScore: 0,
      //老师评分
      interaction: 0,
      //互动性
      discipline: 0,
      //纪律性
      affinity: 0,
      //亲和力
      form: {
        loginName: '',
        loginPwd: '',
        deviceType: 'PC'
      },
      questionList: [],
      //问卷调查题目
      wjform: {
        answerList: []
      },
      rules: {
        loginName: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        loginPwd: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var idarry = this.$route.query.schedule.split('y');
    this.scheduleId = idarry[1];
  },
  watch: {
    utility: function utility() {
      if (this.utility == 0) {
        this.utility = this.courseScore;
      }
      this.courseScore = (this.utility + this.popularity + this.reasonability) / 3;
    },
    popularity: function popularity() {
      if (this.popularity == 0) {
        this.popularity = this.courseScore;
      }
      this.courseScore = (this.utility + this.popularity + this.reasonability) / 3;
    },
    reasonability: function reasonability() {
      if (this.reasonability == 0) {
        this.reasonability = this.courseScore;
      }
      this.courseScore = (this.utility + this.popularity + this.reasonability) / 3;
    },
    interaction: function interaction() {
      if (this.interaction == 0) {
        this.interaction = this.teacherScore;
      }
      this.teacherScore = (this.interaction + this.discipline + this.affinity) / 3;
    },
    discipline: function discipline() {
      if (this.discipline == 0) {
        this.discipline = this.teacherScore;
      }
      this.teacherScore = (this.interaction + this.discipline + this.affinity) / 3;
    },
    affinity: function affinity() {
      if (this.affinity == 0) {
        this.affinity = this.teacherScore;
      }
      this.teacherScore = (this.interaction + this.discipline + this.affinity) / 3;
    },
    isShowList: function isShowList() {
      if (this.isShowList) {
        this.isHasCheck();
        this.intervalFun();
      }
    },
    time: function time() {
      if (this.time == 0) {
        this.isShowCheck = false;
      } else {
        if (this.time > 0) {
          this.isShowCheck = true;
        }
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    //倒计时
    countdown: function countdown(time) {
      var self = this;
      var timer = setInterval(function () {
        time--;
        if (time > 0) {
          var h = parseInt(time / (60 * 60));
          var m = parseInt(time % (60 * 60) / 60);
          var s = parseInt(time % (60 * 60) % 60);
          var format = '';
          format = (h >= 10 ? h : '0' + h) + ':' + (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s);
          self.djs = format;
        } else {
          clearInterval(timer);
          self.djs = "00:00:00";
          self.isShowCheck = false;
        }
      }, 1000);
    },
    //轮询
    intervalFun: function intervalFun() {
      var self = this;
      self.interval = setInterval(function () {
        self.isHasCheck();
      }, 5000);
    },
    //点击展开
    showMore: function showMore() {
      this.isShowMore = true;
    },
    //点击收起
    closeMore: function closeMore() {
      this.isShowMore = false;
    },
    //点击展开
    showMoreTwo: function showMoreTwo() {
      this.isShowMoreTwo = true;
    },
    //点击收起
    closeMoreTwo: function closeMoreTwo() {
      this.isShowMoreTwo = false;
    },
    //查询列表
    getList: function getList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/queryTjkMerchantScheduleCourse', {
        'scheduleId': this.scheduleId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          //培训老师跳转至管理页面
          if (result.data.isTeacher == 'Yes') {
            window.location.href = '/tjkStudy/traincheck/list';
          } else {
            if (result.data.isLogin == 'No') {
              _this.isShowLogin = true;
              _this.isShowList = false;
            } else {
              _this.description = result.data.description;
              for (var i = 0; i < result.data.courses.length; i++) {
                if (result.data.courses[i].isExpire == 'No') {
                  result.data.courses[i].isExpireFirst = 'Yes';
                  break;
                }
              }
              _this.list = result.data.courses;
              if (result.data.templateId != '' && result.data.templateId != null && result.data.isSubmitQuestion == 'No') {
                _this.isShowTemplate = true;
                _this.isShowList = false;
                _this.questionList = result.data.paramList;
              } else {
                if (result.data.isRecruit == 'No') {
                  _this.isShowRecruit = true;
                  _this.isShowList = false;
                } else {
                  _this.isShowList = true;
                  _this.isShowRecruit = false;
                }
              }
            }
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //签到
    checkIn: function checkIn() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/tjkSignCourse', {
        'courseId': this.checkCourseId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.isShowCheck = false;
          _this2.isShowCheckSucc = true;
          _this2.getList();
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('网络繁忙，请稍后重试！');
      });
    },
    //显示评价
    showPjia: function showPjia(courseId) {
      this.isShowList = false;
      this.isShowPjia = true;
      this.courseId = courseId;
    },
    //返回签到
    gotoList: function gotoList() {
      this.isShowList = true;
      this.isShowPjia = false;
      this.isShowMore = true;
      this.isShowMoreTwo = true;
      this.courseScore = 0;
      this.utility = 0;
      this.popularity = 0;
      this.reasonability = 0;
      this.teacherScore = 0;
      this.interaction = 0;
      this.discipline = 0;
      this.affinity = 0;
      this.advice = '';
    },
    //提交评价
    submitPjia: function submitPjia() {
      var _this3 = this;
      if (this.courseScore == 0 || this.teacherScore == 0) {
        this.$alert('请选择分数');
        return;
      }
      var data = {
        'scheduleId': this.scheduleId,
        'courseId': this.courseId,
        'courseScore': parseFloat(this.courseScore).toFixed(2),
        'teacherScore': parseFloat(this.teacherScore).toFixed(2),
        'advice': this.advice,
        'courseEvaluateVO.utility': this.utility,
        'courseEvaluateVO.popularity': this.popularity,
        'courseEvaluateVO.reasonability': this.reasonability,
        'teacherEvaluateVO.interaction': this.interaction,
        'teacherEvaluateVO.discipline': this.discipline,
        'teacherEvaluateVO.affinity': this.affinity
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/tjkEvaluateCourse', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.isShowPjia = false;
          _this3.isShowPjiaSucc = true;
          _this3.courseScore = 0;
          _this3.utility = 0;
          _this3.popularity = 0;
          _this3.reasonability = 0;
          _this3.teacherScore = 0;
          _this3.interaction = 0;
          _this3.discipline = 0;
          _this3.affinity = 0;
          _this3.advice = '';
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('网络繁忙，请稍后重试！');
      });
    },
    //评价成功后返回
    closePjiaSucc: function closePjiaSucc() {
      this.isShowPjiaSucc = false;
      this.isShowList = true;
    },
    //登录
    login: function login() {
      var self = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/tjkLogin/login', self.form).then(function (response) {
            var result = response.data;
            if (result.success) {
              window.location.reload();
            } else {
              self.$alert(result.msg);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        } else {
          return false;
        }
      });
    },
    //报名
    recruitFun: function recruitFun() {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/createScheduleTjkRel', {
        'scheduleId': this.scheduleId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.isShowRecruit = false;
          _this4.isShowList = true;
        } else {
          _this4.$alert(result.msg);
        }
      }, function (response) {
        _this4.$alert('网络繁忙，请稍后重试！');
      });
    },
    //提交问卷
    submitInfo: function submitInfo() {
      var _this5 = this;
      var self = this,
        answerList = [];
      this.wjform.answerList.forEach(function (v, i) {
        answerList.push({
          'paramId': i,
          'value': v
        });
      });
      if (answerList.length < this.questionList.length) {
        this.$alert('你还有必填项未填');
        return false;
      }
      for (var i = 0; i < this.questionList.length; i++) {
        for (var j = 0; j < answerList.length; j++) {
          if (this.questionList[i].paramId == answerList[j].paramId) {
            answerList[j].paramName = this.questionList[i].paramName;
            answerList[j].paramType = this.questionList[i].paramType;
            answerList[j].templateId = this.questionList[i].templateId;
          }
        }
      }
      var data = {
        'scheduleId': this.scheduleId,
        'paramFullList': answerList
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/tjkSubmitDynamicTable', data).then(function (respones) {
        var result = respones.data;
        if (result.success) {
          _this5.$message({
            message: '提交成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          window.location.reload();
        } else {
          _this5.$alert(result.msg);
        }
      }, function (respones) {
        _this5.$alert("网络繁忙，请稍后重试！");
      });
    },
    //查询是否有签到课程
    isHasCheck: function isHasCheck() {
      var _this6 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/getSignExpireMinute', {
        'scheduleId': this.scheduleId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this6.time = result.data.seconds;
          _this6.checkCourseId = result.data.courseId;
          _this6.countdown(_this6.time);
        } else {
          _this6.$alert(result.msg);
        }
      }, function (response) {
        _this6.$alert('网络繁忙，请稍后重试！');
      });
    }
  }
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      pages: 1,
      merchantId: '',
      courseStartTime: '',
      courseEndTime: '',
      list: [],
      dialogVisible: false,
      add: {
        scheduleId: null,
        courses: []
      },
      dialogVisibleCourse: false,
      date: '',
      addcourse: {
        startTime: '',
        endTime: '',
        content: ''
      },
      dialogVisibleCheck: false,
      dialogVisibleSign: false,
      sign: {
        scheduleId: '',
        expireMinute: ''
      },
      signRules: {
        expireMinute: [{
          required: true,
          message: '过期时间不能为空'
        }, {
          type: 'number',
          message: '过期时间必须为数字'
        }]
      },
      check: {
        scheduleId: '',
        total: 0,
        pageNum: 1,
        pageSize: 10,
        courseId: '',
        isNotSign: null
      },
      checkCourseList: [],
      //签到明细-课程列表
      checkList: [] //签到明细列表
    };
  },
  mounted: function mounted() {
    document.title = '培训助手';
    this.getList(1);
  },
  methods: {
    getStartTime: function getStartTime(date) {
      this.courseStartTime = date;
    },
    getEndTime: function getEndTime(date) {
      this.courseEndTime = date;
    },
    getList: function getList(num) {
      var _this = this;
      var data = {
        'merchantId': this.merchantId,
        'courseStartTime': this.courseStartTime,
        'courseEndTime': this.courseEndTime,
        'pageNum': num,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/queryMerchantSchedule', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.total = result.data.total;
          _this.pageNum = result.data.pageNum;
          _this.pages = result.data.pages;
          _this.list = result.data.list;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //弹出层关闭-新增培训计划
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.add.courses = [];
    },
    //编辑
    editRow: function editRow(obj) {
      this.add.scheduleId = obj.scheduleId;
      this.dialogVisible = true;
      this.add.courses = !!obj.courses ? obj.courses : [];
    },
    //编辑
    showSign: function showSign(obj) {
      this.sign.scheduleId = obj.scheduleId;
      this.dialogVisibleSign = true;
    },
    //编辑提交
    editSubmitCourse: function editSubmitCourse() {
      var _this2 = this;
      if (this.add.courses.length == 0) {
        this.$alert('请先新增课程');
        return;
      }
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/tjkTeacherUpdateSchedule', this.add).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.$message({
            message: '编辑成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this2.handleClose();
          _this2.getList();
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('网络繁忙，请稍后重试！');
      });
    },
    getDateTime: function getDateTime(date) {
      this.date = date;
    },
    //弹出层关闭-新增课程
    handleCloseCourse: function handleCloseCourse() {
      this.dialogVisibleCourse = false;
    },
    //新增课程-弹出层
    addCourse: function addCourse() {
      this.dialogVisibleCourse = true;
      this.date = '';
      this.addcourse.startTime = '';
      this.addcourse.endTime = '';
      this.addcourse.content = '';
    },
    //新增课程-确定
    addCourseFun: function addCourseFun() {
      if (this.date == '' || this.date == null) {
        this.$alert('请选择日期');
        return;
      }
      if (this.addcourse.startTime == '' || this.addcourse.startTime == null) {
        this.$alert('请选择开始时间');
        return;
      }
      if (this.addcourse.endTime == '' || this.addcourse.endTime == null) {
        this.$alert('请选择结束时间');
        return;
      }
      var start = new Date(this.date + ' ' + this.addcourse.startTime + ':00').valueOf();
      var end = new Date(this.date + ' ' + this.addcourse.endTime + ':00').valueOf();
      if (end < start) {
        this.$alert("结束时间不能小于开始时间");
        return;
      }
      if (this.addcourse.content == '' || this.addcourse.content == null) {
        this.$alert('请填写课程内容');
        return;
      }
      this.addcourse.startTime = this.date + ' ' + this.addcourse.startTime + ':00';
      this.addcourse.endTime = this.date + ' ' + this.addcourse.endTime + ':00';
      this.add.courses.push(JSON.parse(JSON.stringify(this.addcourse)));
      this.dialogVisibleCourse = false;
    },
    //删除课程
    deleteCourse: function deleteCourse(key) {
      this.add.courses.splice(key, 1);
    },
    //签到明细-弹出层显示
    showCheckList: function showCheckList(obj) {
      this.dialogVisibleCheck = true;
      this.check.scheduleId = obj.scheduleId;
      this.checkCourseList = obj.courses;
      this.getCheckList();
    },
    gotoNameList: function gotoNameList(obj) {
      var scheduleId = obj.scheduleId;
      window.location.href = "/tjkStudy/traincheck/namelist?scheduleId=" + scheduleId;
    },
    //签到明细-弹出层关闭
    handleCloseCheck: function handleCloseCheck() {
      this.dialogVisibleCheck = false;
      this.check.total = 0;
      this.check.pageNum = 1;
      this.check.pageSize = 10;
      this.check.courseId = '';
      this.check.isNotSign = null;
      this.checkCourseList = [];
      this.checkList = [];
    },
    //签到明细
    getCheckList: function getCheckList() {
      var _this3 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/querySignRecordByScheduleId', this.check).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.check.total = result.data.total;
          _this3.checkList = result.data.list;
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('网络繁忙，请稍后重试！');
      });
    },
    //发起签到弹出层-关闭
    handleCloseSign: function handleCloseSign() {
      this.sign.scheduleId = '';
      this.sign.expireMinute = '';
      this.dialogVisibleSign = false;
    },
    //发起签到-确认
    signFun: function signFun() {
      var self = this;
      this.$refs.sign.validate(function (valid) {
        if (valid) {
          //tjk也需要签到，为不受登录token困扰，末尾传jumpToken=true
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/merchantSchedule/tjkSetSignExpireTime?jumpToken=true', self.sign).then(function (response) {
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '操作成功',
                type: 'success',
                center: true,
                duration: 1000
              });
              self.handleCloseSign();
            } else {
              self.$alert(result.msg);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        } else {
          return false;
        }
      });
    }
  }
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(__webpack_require__(469));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      searchData: {
        scheduleId: this.$route.query.scheduleId,
        tjkId: '',
        tjkJoin: '',
        platformAppraise: '',
        merchantAppraise: '',
        enrollState: '',
        //录取状态
        //以下几个参数是录取时候用，shopId是Excel方式下的选择店铺
        shopId: '',
        shopName: '',
        enroll: '',
        msg: ''
      },
      way: '',
      //tjk来源，Excel,Shop,WorkOrder
      tableData: [],
      headList: [],
      columnData: [],
      finalTableData: [],
      dialogEnrollVisible: false,
      shopOptions: [],
      tjkOpeData: {
        appraiseId: '',
        tjkJoin: '',
        //临时tjkJoin参数，用于当行的参培情况保存设置的临时变量
        scheduleId: this.$route.query.scheduleId,
        //删除时候使用
        tjkId: '' //删除时候使用
      },
      passStatus: {
        'pass': '通过',
        'nopass': '未通过',
        'reject': '拒绝'
      },
      tjkJoin: {
        'noJoin': '未参培',
        'abandonNoSay': '中途退出（无报备）',
        'abandonAndSay': '中途退出（有报备）',
        'joinComplete': '完整参培'
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    //列表页淘金客自动搜索
    updateTjkId: function updateTjkId(val) {
      this.searchData.tjkId = val;
    },
    getList: function getList() {
      var _this = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/queryTjkUser', this.searchData).then(function (response) {
        var result = response.data;
        if (result.success) {
          self.headList = result.data.headerInfos;
          self.tableData = result.data.dataList;
          self.way = result.data.way;
          self.finalTableData = [];
          //生成表格内容数据finalTableData
          for (var i = 0; i < self.tableData.length; i++) {
            var curLineData = self.tableData[i];
            var tempTableData = [];

            //j为head总列数
            for (var j = 0; j < self.headList.length; j++) {
              var head = self.headList[j];
              //非动态
              if (self.headList[j].dynamicForm == false) {
                var value = curLineData[head.fieldName];
                var dataCell = _this.setObjectForFinalTable(head, value);
                tempTableData.push(dataCell);
              }

              //动态
              if (self.headList[j].dynamicForm == true) {
                if (head.children.length > 0) {
                  for (var ch = 0; ch < head.children.length; ch++) {
                    var headChild = head.children[ch];
                    if (curLineData.fieldValueList) {
                      for (var f = 0; f < curLineData.fieldValueList.length; f++) {
                        if (headChild.id == curLineData.fieldValueList[f].fieldId) {
                          var dataCell = _this.setObjectForFinalTable(headChild, curLineData.fieldValueList[f].value);
                          tempTableData.push(dataCell);
                          break;
                        }
                      }
                    }
                  }
                } else {
                  var headChild = head;
                  if (curLineData.fieldValueList) {
                    for (var f = 0; f < curLineData.fieldValueList.length; f++) {
                      if (headChild.id == curLineData.fieldValueList[f].fieldId) {
                        var dataCell = _this.setObjectForFinalTable(headChild, curLineData.fieldValueList[f].value);
                        tempTableData.push(dataCell);
                        break;
                      }
                    }
                  }
                }
              }
            }
            self.finalTableData.push(tempTableData);
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //设置一个cell值给finalTable,[head.type, value, head.fieldOptions, head.id]->[input、select输入框， 值， select组件时的下拉可选项， 动态表单cell的fieldId]
    setObjectForFinalTable: function setObjectForFinalTable(head, value) {
      var dataCell = new Object();
      dataCell.type = head.type;
      dataCell.value = value;
      dataCell.fieldOptions = head.fieldOptions;
      dataCell.fieldId = head.id;
      return dataCell;
    },
    //导出查询结果
    getExcel: function getExcel() {
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = arr != null ? unescape(arr[2]) : null;
      var url = {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/exportNamelistApprise?tjk_login_token=' + login_token + '&scheduleId=' + this.searchData.scheduleId + '&tjkId=' + this.searchData.tjkId + '&tjkJoin=' + this.searchData.tjkJoin + '&platformAppraise=' + this.searchData.platformAppraise + '&merchantAppraise=' + this.searchData.merchantAppraise + '&enrollState=' + this.searchData.enrollState;
      window.open(url);
    },
    //导入文件-平台考核
    importExcel: function importExcel(event) {
      var _this2 = this;
      var self = this;
      var file = event.target.files[0];
      if (!file) {
        return;
      }
      this.$refs.referenceUpload.value = null;
      event.preventDefault();
      var formData = new FormData();
      formData.append('name', file.name);
      formData.append('file', file);
      formData.append('scheduleId', this.searchData.scheduleId);
      formData.append('templateId', 51);
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)')),
        token = arr != null ? unescape(arr[2]) : null;
      formData.append('login_token', token);
      var config = {
        headers: {
          'Content-Type': 'multipart/form-data;'
        }
      };
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = arr != null ? unescape(arr[2]) : null;
      var ajax = _axios.default.create({});
      ajax.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/appraise/uploadAppraiseExcel?tjk_login_token=" + login_token, formData, config).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.getList();
          self.$message({
            message: '导入成功',
            type: 'success'
          });
        } else {
          self.$alert(result.msg);
        }
      }, function (response) {
        self.$alert("网络繁忙，请稍后重试！");
      });
    },
    //导入文件-商家考核
    importMerchantExcel: function importMerchantExcel(event) {
      var _this3 = this;
      var self = this;
      var file = event.target.files[0];
      if (!file) {
        return;
      }
      this.$refs.referenceUploadMerchant.value = null;
      event.preventDefault();
      var formData = new FormData();
      formData.append('name', file.name);
      formData.append('file', file);
      formData.append('scheduleId', this.searchData.scheduleId);
      formData.append('templateId', 52);
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)')),
        token = arr != null ? unescape(arr[2]) : null;
      formData.append('login_token', token);
      var config = {
        headers: {
          'Content-Type': 'multipart/form-data;'
        }
      };
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = arr != null ? unescape(arr[2]) : null;
      var ajax = _axios.default.create({});
      ajax.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/appraise/uploadAppraiseExcel?tjk_login_token=" + login_token, formData, config).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.getList();
          self.$message({
            message: '导入成功',
            type: 'success'
          });
        } else {
          self.$alert(result.msg);
        }
      }, function (response) {
        self.$alert("网络繁忙，请稍后重试！");
      });
    },
    //下载
    doDownload: function doDownload(command) {
      var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)'));
      var login_token = arr != null ? unescape(arr[2]) : null;
      var cond = '&scheduleId=' + this.searchData.scheduleId + '&tjkId=' + this.searchData.tjkId + '&tjkJoin=' + this.searchData.tjkJoin + '&platformAppraise=' + this.searchData.platformAppraise + '&merchantAppraise=' + this.searchData.merchantAppraise + '&enrollState=' + this.searchData.enrollState;
      if (command == 51) {
        var url = {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/exportPlatformApprise?tjk_login_token=' + login_token + '&templateId=51' + cond;
        window.open(url);
      }
      if (command == 52) {
        var url = {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/exportMerchantApprise?tjk_login_token=' + login_token + '&templateId=52' + cond;
        window.open(url);
      }
    },
    queryShopIdByName: function queryShopIdByName(query) {
      var _this4 = this;
      this.searchData.shopName = query;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/queryShop', this.searchData).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.shopOptions = result.data;
        } else {
          _this4.$alert(result.msg);
        }
      }, function (response) {
        _this4.$alert('网络繁忙，请稍后重试！');
      });
    },
    //录取
    enroll: function enroll(type) {
      if (enrollState == 'Yes' || enrollState == 'No') {
        if (enrollState != type) {
          this.$alert("录取条件下不能进行释放操作，释放条件下不能进行录取操作");
          return;
        }
      }
      this.searchData.enroll = type;
      this.dialogEnrollVisible = true;
    },
    doEnroll: function doEnroll() {
      var _this5 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/enrollTjk', this.searchData).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.getList();
          _this5.$alert("操作成功");
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('网络繁忙，请稍后重试！');
      });
      this.dialogEnrollVisible = false;
    },
    saveTjkJoin: function saveTjkJoin(data, finaldata) {
      var _this6 = this;
      var self = this;
      var appraiseId = data.appraiseId;
      var tjkId = data.tjkId;
      this.tjkOpeData.appraiseId = appraiseId;
      this.tjkOpeData.tjkId = tjkId;
      this.tjkOpeData.tjkJoin = finaldata[1].value;
      this.tjkOpeData.merchantAppraise = finaldata[2].value;
      this.tjkOpeData.platformAppraise = finaldata[3].value;
      var fieldValueList = [];
      for (var i = 5; i < finaldata.length; i++) {
        fieldValueList.push(finaldata[i]);
      }
      this.tjkOpeData.fieldValueList = fieldValueList;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/updateTjkJoinByAppraiseId', this.tjkOpeData).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this6.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this6.getList();
        } else {
          _this6.$alert(result.msg);
        }
      }, function (response) {
        self.$alert('网络繁忙，请稍后重试！');
      });
    },
    delTjk: function delTjk(data) {
      var _this7 = this;
      this.tjkOpeData.tjkId = data.tjkId;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/delTjkByScheduleIdAndTjkId', this.tjkOpeData).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this7.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this7.getList();
        } else {
          _this7.$alert(result.msg);
        }
      }, function (response) {
        _this7.$alert('网络繁忙，请稍后重试！');
      });
    },
    //参培生成
    getTjkJoin: function getTjkJoin() {
      var _this8 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/appraise/generateTjkJoin', {
        'scheduleId': this.searchData.scheduleId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this8.getList();
          _this8.$alert("参培生成成功");
        } else {
          _this8.$alert(result.msg);
        }
      }, function (response) {
        _this8.$alert('网络繁忙，请稍后重试！');
      });
    }
  }
};

/***/ }),
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      referral: '',
      addForm: {
        tjkId: '',
        groupId: ''
      },
      searchForm: {
        tjkId: '',
        groupId: '',
        pageNum: 1,
        pageSize: 10
      },
      pages: 1,
      list: [],
      groupList: [],
      rules: {
        tjkId: [{
          required: true,
          message: '请选择客服',
          trigger: 'blur'
        }],
        groupId: [{
          required: true,
          message: '请选择小组名称',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    var login_token = this.$route.query.token;
    document.cookie = 'login_token=' + login_token;
    this.getLeader();
  },
  methods: {
    //列表页淘金客自动搜索
    updateTjkId: function updateTjkId(val) {
      this.searchForm.tjkId = val;
    },
    updateAddTjkId: function updateAddTjkId(val) {
      this.addForm.tjkId = val;
    },
    getLeader: function getLeader() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/group/queryLeaderGroup').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.groupList = result.data;
          _this.addForm.groupId = result.data[0].id;
          _this.searchForm.groupId = result.data[0].id;
          _this.getList(1);
        } else {
          _this.$alert('获取 groupId 失败：' + result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    addMember: function addMember() {
      var _this2 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this2.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/group/member/add', _this2.addForm).then(function (response) {
            var result = response.data;
            if (result.success) {
              _this2.$alert('添加成功');
              _this2.getList(1);
            } else {
              _this2.$alert(result.msg);
            }
          }, function (response) {
            _this2.$alert('网络繁忙，请稍后重试！');
          });
        } else {
          return;
        }
      });
    },
    getList: function getList(num) {
      var _this3 = this;
      this.searchForm.pageNum = num;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/group/member/query', this.searchForm).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.pages = result.data.pages;
          _this3.searchForm.pageNum = result.data.pageNum;
          _this3.list = result.data.list;
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('网络繁忙，请稍后重试！');
      });
    },
    deleteRow: function deleteRow(row) {
      var _this4 = this;
      var self = this;
      var data = {
        groupId: this.searchForm.groupId,
        memberId: row.memberId
      };
      this.$confirm('确定删除此数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/group/member/delete', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            _this4.$alert('删除成功');
            _this4.getList(self.searchForm.pageNum);
          } else {
            _this4.$alert(result.msg);
          }
        }, function (response) {
          _this4.$alert('网络繁忙，请稍后重试！');
        });
      });
    }
  },
  filters: {
    tagFilter: function tagFilter(val) {
      switch (val) {
        case 'CloudService':
          return 'http://taojinyun.file.itaojin.cn/tjkTypeIconYun.png';
          break;
        case 'ProviderService':
          return 'http://taojinyun.file.itaojin.cn/tjkTypeIconTuan.png';
          break;
        case 'SaleService':
          return 'http://taojinyun.file.itaojin.cn/tjkTypeIconXiao.png';
          break;
        case 'FreeService':
          return 'http://taojinyun.file.itaojin.cn/tjkTypeIconZi.png';
          break;
        case 'MerchantService':
          return 'http://taojinyun.file.itaojin.cn/tjkTypeIconShang.png';
          break;
      }
    }
  }
};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isDisable: false,
      toptab: '',
      //语音or在线
      stepactive: 1,
      //当前进度
      clickFlag: 1,
      //进度条是否可点击
      leadId: '',
      videoindex: [],
      //视频是否全部看完
      tabCurrent: 'first',
      //当前标签页
      status: '',
      //考核状态
      retry: '',
      //是否可重新测试
      result: '',
      //未通过原因
      miaoone: 480,
      //倒计时480s
      timerone: null,
      miaotwo: 180,
      //倒计时180s
      timertwo: null,
      isShowStepOne: false,
      isShowStepTwo: false,
      isShowStepThird: false,
      isShowStepFour: false
    };
  },
  created: function created() {
    // window.location.href="/tjkStudy/train/index";
    this.getCurrentStep();
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#stoptip-' + _this.tabCurrent).show();
    }, false);
    document.getElementById('web').addEventListener('ended', function () {
      //该视频播放是否已结束
      _this.saveTjkTrainInfoOnline();
    }, false);
  },
  methods: {
    //在线客服-视频观看记录
    saveTjkTrainInfoOnline: function saveTjkTrainInfoOnline() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/assitantTrain/saveWebLoginAndAssitantDown', {
        'tDisplayVideo': 'Yes'
      }).then(function (res) {
        var result = res.data;
        if (result.success) {}
      }, function (res) {
        _this2.$alert("网络繁忙，请稍后重试！");
      });
    },
    //tab切换
    handleClick: function handleClick(event) {
      var _this3 = this;
      document.getElementById(this.tabCurrent).play();
      //初始化其他视频
      $('.js-video video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this3.tabCurrent).show();
      }, false);
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //下一关
    studyNext: function studyNext(next) {
      $('#stoptip-' + this.tabCurrent).hide();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    //进入测试须知
    studyNextLast: function studyNextLast() {
      this.stepactive++;
      this.clickFlag++;
      this.saveStep(2);
      if (this.stepactive === 2) {
        this.countdownOne(480);
      }
    },
    //进度条切换
    showStep: function showStep(val) {
      this.clickFlag = val;
    },
    //查询当前进度
    getCurrentStep: function getCurrentStep() {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/badge/queryTjkTrainInfo').then(function (res) {
        var result = res.data;
        if (result.success) {
          _this4.stepactive = result.data.step ? parseInt(result.data.step) : 1;
          _this4.clickFlag = result.data.step ? parseInt(result.data.step) : 1;
          _this4.leadId = result.data.leadId ? result.data.leadId : '';
          _this4.status = result.data.status;
          _this4.retry = result.data.retry;
          _this4.result = result.data.result;
          _this4.toptab = result.data.intent;
          if (_this4.clickFlag == 1) {
            _this4.addRecord('START', 1);
          }
          //测试须知倒计时
          if (_this4.stepactive === 2 && _this4.clickFlag === 2) {
            _this4.countdownOne(480);
          }
          //开始测试提示层
          if (_this4.stepactive === 3 && _this4.clickFlag === 3 && (_this4.status == 'AlreadyTheoryBadge' || _this4.status == 'NoTheoryBadge' || _this4.status == 'Failed' && _this4.retry == 'true')) {
            _this4.isShowStepOne = true;
          }
        }
      }, function (res) {
        _this4.$alert("网络繁忙，请稍后重试！");
      });
    },
    //保存当前进度
    saveStep: function saveStep(step) {
      var _this5 = this;
      var data = {
        'step': step,
        'leadId': this.leadId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/train/view/saveTrainLead', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this5.leadId = result.data;
        }
      }, function (res) {
        _this5.$alert("网络繁忙，请稍后重试！");
      });
    },
    //我已知晓
    goNext: function goNext() {
      if (this.stepactive === 2) {
        this.isShowStepOne = true;
      }
      this.stepactive = 3;
      this.clickFlag = 3;
      this.saveStep(3);
      this.addRecord('START', 2);
    },
    showStepTwo: function showStepTwo() {
      this.isShowStepOne = false;
      this.isShowStepTwo = true;
    },
    showStepThird: function showStepThird() {
      this.isShowStepTwo = false;
      this.isShowStepThird = true;
    },
    showStepFour: function showStepFour() {
      this.isShowStepThird = false;
      this.isShowStepFour = true;
    },
    closeStep: function closeStep() {
      this.isShowStepFour = false;
      this.countdownTwo(180);
    },
    //开始测试
    startExam: function startExam() {
      if (this.status == 'NoTheoryBadge') {
        this.$alert('您还不符合测试条件，请前往淘金云客服APP，点击"培训"，完成"语音客服培训"后，才能测试。');
        return;
      }
      this.applyTask();
      this.addRecord('START', 3);
    },
    //重新测试
    replyBegin: function replyBegin() {
      this.applyTask();
      this.addRecord('START', 4);
    },
    applyTask: function applyTask() {
      var _this6 = this;
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.isDisable = true;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/badge/applyTaskApp').then(function (res) {
        var result = res.data;
        if (result.success) {
          _this6.status = result.data.status;
          _this6.callHawkeye();
        } else {
          _this6.$alert(result.msg);
        }
        loading.close();
        _this6.isDisable = false;
      }, function (res) {
        loading.close();
        _this6.isDisable = false;
        _this6.$alert("网络繁忙，请稍后重试！");
      });
    },
    //调用小助手引导功能
    callHawkeye: function callHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    //倒计时480秒
    countdownOne: function countdownOne(endTime) {
      var self = this;
      self.timerone = setInterval(function () {
        endTime--;
        if (endTime >= 1) {
          var sec = parseInt(endTime);
          self.miaoone = sec;
        } else {
          clearInterval(self.timerone);
          self.miaoone = 0;
        }
      }, 1000);
    },
    //倒计时180秒
    countdownTwo: function countdownTwo(endTime) {
      var self = this;
      self.timertwo = setInterval(function () {
        endTime--;
        if (endTime >= 1) {
          var sec = parseInt(endTime);
          self.miaotwo = sec;
        } else {
          clearInterval(self.timertwo);
          self.miaotwo = 0;
        }
      }, 1000);
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this7 = this;
      var data = {
        exerciseType: 'ASSITANT',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {} else {
          _this7.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this7.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {
    var login_token = this.$route.query._token;
    window.location.href = 'http://t.itaojin.cn/customer/action/login/verifyLogin?url=http://t.itaojin.cn/tjkStudy/hawkeye/voiceExam&token=' + login_token;
  },
  methods: {}
};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      list: [],
      trainId: '',
      trainState: '',
      content: '',
      modal: {
        trainTitle: '',
        teacherName: '',
        trainContent: '',
        guideContent: ''
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    //小助手有个弹窗“培训通知----再考虑一下----报名”是跳这个界面，直接在界面改，跳到目标地址
    window.location.href = "/tjkStudy/train/index?type=SkillUpgrade&show=yes";
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/preWorkTrain/customer/queryTrainList').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.content = result.data.content;
          _this.trainState = result.data.trainState;
          _this.list = result.data.trainList;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    getDetail: function getDetail(trainId) {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/preWorkTrain/customer/getTrainDetail', {
        'trainId': trainId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.modal = result.data;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('网络繁忙，请稍后重试！');
      });
    },
    showDetail: function showDetail(trainId) {
      this.trainId = trainId;
      this.getDetail(trainId);
      this.checkTrainState(trainId);
      this.dialogVisible = true;
    },
    //弹出层关闭
    handleClose: function handleClose() {
      this.$refs['modal'].resetFields();
      this.dialogVisible = false;
    },
    //检测是否存在其他报名信息
    checkTrainState: function checkTrainState(trainId) {
      var _this3 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/preWorkTrain/customer/checkTrainState', {
        'trainId': trainId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.existApplyRecord = result.data.existApplyRecord;
          if (result.data.existApplyRecord) {
            _this3.oldTrainId = result.data.oldTrainId;
            _this3.oldTrainTitle = result.data.oldTrainTitle;
          } else {
            _this3.oldTrainId = '';
            _this3.oldTrainTitle = '';
          }
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('网络繁忙，请稍后重试！');
      });
    },
    applyTrain: function applyTrain() {
      var _this4 = this;
      var self = this;
      if (this.existApplyRecord) {
        this.$confirm('你已报名培训场次:' + this.oldTrainTitle + '，是否确认并切换？', '提示', {
          confirmButtonText: '确认并加群',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var data = {
            'trainId': _this4.trainId,
            'oldTrainId': _this4.oldTrainId
          };
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/preWorkTrain/customer/applyTrain', data).then(function (response) {
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '操作成功',
                type: 'success',
                center: true,
                duration: 1000
              });
              window.location.href = result.data.groupLink;
            } else {
              self.$alert(result.msg);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        }).catch(function () {});
      } else {
        this.$confirm('是否确认报名？', '提示', {
          confirmButtonText: '确认并加群',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var data = {
            'trainId': _this4.trainId
          };
          self.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/preWorkTrain/customer/applyTrain', data).then(function (response) {
            var result = response.data;
            if (result.success) {
              self.$message({
                message: '操作成功',
                type: 'success',
                center: true,
                duration: 1000
              });
              window.location.href = result.data.groupLink;
            } else {
              self.$alert(result.msg);
            }
          }, function (response) {
            self.$alert('网络繁忙，请稍后重试！');
          });
        }).catch(function () {});
      }
    }
  }
};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      month: this.getCurrentDate().monthStartDate,
      salaryList: [],
      totalAmount: '',
      //报酬总额
      basicSalaryAmount: '',
      //任务报酬
      serviceAwardAmount: '',
      //奖励
      servicePunishAmount: '',
      //扣罚
      paySuccessAmount: '',
      //实发
      tax: '' //扣税
    };
  },
  mounted: function mounted() {
    this.getSearch();
  },
  methods: {
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    getCurrentDate: function getCurrentDate() {
      var now = new Date(); //当前日期
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      var nowDay = now.getDate(); //当前日
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年
      nowYear += nowYear < 2000 ? 1900 : 0;
      var lastMonthDate = new Date(); //上月日期 
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastYear = lastMonthDate.getYear();
      var lastMonth = lastMonthDate.getMonth();
      return {
        monthStartDate: this.getMonthStartDate(nowYear, nowMonth)
      };
    },
    //获得本月的开端日期
    getMonthStartDate: function getMonthStartDate(nowYear, nowMonth) {
      var monthStartDate = new Date(nowYear, nowMonth, 1);
      return this.dateFormatString(monthStartDate, 'yyyy-MM-dd hh:mm:ss');
    },
    getSearch: function getSearch() {
      this.getMoney();
      this.getList();
    },
    getMoney: function getMoney() {
      var _this = this;
      var data = {
        month: this.month,
        accumulated: false
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkInfo + '/wallet/getHistorySalaryTotalAmountDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.totalAmount = result.data.totalAmount;
          _this.basicSalaryAmount = result.data.basicSalaryAmount;
          _this.serviceAwardAmount = result.data.serviceAwardAmount;
          _this.servicePunishAmount = result.data.servicePunishAmount;
          _this.paySuccessAmount = result.data.paySuccessAmount;
          _this.tax = result.data.tax;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert("网络繁忙，请稍后重试！");
      });
    },
    getList: function getList() {
      var _this2 = this;
      var data = {
        month: this.month,
        salaryType: 'ALL'
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkInfo + '/wallet/querySalaryRecordDetailList', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.salaryList = result.data;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert("网络繁忙，请稍后重试！");
      });
    }
  }
};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(__webpack_require__(469));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      userList: [],
      tjkName: '',
      add: {
        tjkId: ''
      },
      isShowFirst: true,
      isShowSecond: false,
      isShowThird: false,
      isPending: false,
      current: {},
      to: {},
      rules: {
        tjkId: [{
          required: true,
          message: '请选择用户',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    querySearch: function querySearch(queryString) {
      var _this = this;
      if (queryString !== '' && queryString.length >= 2) {
        var data = {
          'tjkParam': queryString
        };
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/tjk/queryForAllType', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            _this.userList = result.data.map(_this.userWithLabel);
          } else {
            _this.$alert(result.msg);
          }
        }, function (response) {
          _this.$alert('网络繁忙，请稍后重试！');
        });
      }
    },
    userWithLabel: function userWithLabel(user) {
      if (!user) {
        return user;
      }
      user.label = (user.realName ? user.realName : "空") + '(' + user.tjkNumber + ')';
      return user;
    },
    // 选中
    onChange: function onChange(item) {
      this.add.tjkId = item;
      this.userList = [];
    },
    onClear: function onClear() {
      this.add.tjkId = '';
      this.tjkName = '';
      this.userList = [];
    },
    callClick: function callClick() {
      this.isShowFirst = false;
      this.isShowSecond = true;
    },
    gotoReady: function gotoReady() {
      var _this2 = this;
      this.isPending = true;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voice/exercise/ready', {
        'tjkId': this.add.tjkId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.current = result.data.from;
          _this2.to = result.data.to;
          _this2.isShowSecond = false;
          _this2.isShowThird = true;
          _this2.getHawkeye();
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error',
            customClass: 'message',
            showClose: true,
            duration: 3000
          });
        }
        _this2.isPending = false;
      });
    },
    //调用小助手
    getHawkeye: function getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    }
  }
};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      tjkId: '',
      activeName: 'first',
      list: [],
      step: 'first',
      input: '',
      priList: [{
        title: '对练目的',
        tips: [{
          value: '1、熟悉小助手外呼操作步骤;'
        }, {
          value: '2、与搭档进行话术对练。'
        }]
      }, {
        title: '必备条件',
        tips: [{
          value: '1、有对练搭档（一般老师会分组，若未分组，请自行在群内找搭档）；'
        }, {
          value: '2、你的对练搭档也进入了语音对练。'
        }]
      }, {
        title: '操作手册',
        tips: [{
          value: '1、请先查看语音对练操作手册，然后再进行练习。'
        }]
      }],
      dialogVisible: false,
      partner: {},
      kaoheList: []
    };
  },
  created: function created() {
    this.getCustomerUser();
  },
  mounted: function mounted() {
    this.getList();
    this.getKaoheList();
  },
  methods: {
    style: function style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      };
    },
    handleClick: function handleClick() {},
    getList: function getList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceScene/list').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.list = result.data;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    /*toDetail(id) {
    	this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/accompanyReady', {'id': id}).then(response=>{
    		var result = response.data;
    		if(result.success) {
    			this.toSign(id);
    		}else {
    			this.$alert(result.msg);
    		}
    	},response => {
    		this.$alert('AJAX访问接口异常！');
    	})
    },*/
    toSign: function toSign(id) {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=' + id).then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    getKaoheList: function getKaoheList() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceScene/listExamScene').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.kaoheList = result.data;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('AJAX访问接口异常！');
      });
    },
    toKaoheDetail: function toKaoheDetail(id) {
      var _this3 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/examReady', {
        'id': id
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.toSign(id);
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('AJAX访问接口异常！');
      });
    },
    stopKaohePrict: function stopKaohePrict() {
      var _this4 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voiceExerciseCustomer/endExamExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this4.getKaoheList();
        }
      });
    },
    //查询淘金客信息
    getCustomerUser: function getCustomerUser() {
      var _this5 = this;
      this.$http.get('/customer/action/currentUser/customerUser').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.tjkId = result.data.id;
          _this5.isHasPri();
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('AJAX访问接口异常！');
      });
    },
    showKnow: function showKnow() {
      this.step = 'second';
    },
    isHasPri: function isHasPri() {
      var _this6 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/existExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success && result.data.data) {
          _this6.step = 'handing';
        } else {
          _this6.step = 'first';
        }
      });
    },
    goToPrict: function goToPrict() {
      var _this7 = this;
      var patrn = /^(-)?\d+(\.\d+)?$/;
      if (!patrn.exec(this.input)) {
        this.$message({
          message: '请输入正确的淘金号',
          type: 'error'
        });
        return;
      }
      if (this.input && this.input.length < 9) {
        this.$message({
          message: '淘金号长度至少为9位',
          type: 'error'
        });
        return;
      }

      //查询是否存在当前淘金号
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + "/tjk/queryTjkList?tjkParam=".concat(this.input, "&returnAllData=1")).then(function (result) {
        if (result.data.data.length) {
          _this7.partner = result.data.data[0];
          _this7.dialogVisible = true;
        } else {
          _this7.$message({
            message: '未找到对应的对练伙伴，请重新输入淘金号',
            type: 'error'
          });
        }
      });
      // 打开打卡，然后展示正在练习
    },
    stopPrict: function stopPrict() {
      var _this8 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/endExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this8.step = 'first';
        }
      });
    },
    /*stopTeacherPrict() {
      this.$http.get(API_ROOT.college + `/voiceExerciseCustomer/endExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
        if(result.data.success) {
          this.getList();
        }
      });
    },*/
    newPrict: function newPrict() {
      this.step = 'second';
    },
    //清空排版数据
    clearSchedule: function clearSchedule() {
      this.$http.get('http://127.0.0.1:26688/api/SignIn/clearScheduleCache').then(function (res) {});
      this.sureGoToPri();
    },
    sureGoToPri: function sureGoToPri() {
      var _this9 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/ready?tjkId=".concat(this.partner.id, "&assitantTjkId=").concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this9.getHawkeye();
          _this9.input = '';
          _this9.step = 'handing';
          _this9.dialogVisible = false;
        } else {
          _this9.$message({
            message: result.data.msg,
            type: 'error'
          });
        }
      });
    },
    //调用小助手
    getHawkeye: function getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (res) {
        done();
      }).catch(function (res) {});
    }
  }
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      videoUrl: '',
      //录音文件
      gradeState: '',
      //评分状态
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      gradeScore: '',
      //得分
      gradeList: '',
      //点评内容
      evaluateList: [],
      //练习建议
      preId: '',
      //上一条记录
      nextId: '',
      //下一条记录
      keyData: 0 //更新页面
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.queryGrade(this.id);
  },
  methods: {
    //查询评分字段
    queryGrade: function queryGrade(id) {
      var _this = this;
      var data = {
        'id': id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.videoUrl = result.data.videoUrl;
          _this.gradeState = result.data.gradeState;
          _this.effectStatus = result.data.effectStatus;
          _this.effectReason = result.data.effectReason;
          _this.gradeScore = result.data.gradeScore;
          _this.gradeList = result.data.gradeList;
          _this.evaluateList = result.data.evaluateList;
          _this.preId = result.data.preId;
          _this.nextId = result.data.nextId;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    }
  }
};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {
    var login_token = this.$route.query.token;
    window.location.href = window.location.origin + '/customer/action/login/verifyLogin?url=' + window.location.origin + '/tjkStudy/voiceSceneIndex&token=' + login_token;
  },
  methods: {}
};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: '',
      count: 0,
      callId: '',
      videoUrl: '',
      //录音文件
      gradeState: null,
      //评分状态
      gradeScore: '',
      //得分
      gradeList: '',
      //点评内容
      gradeList2: '',
      //点评内容
      evaluateList: [],
      //练习建议
      teacherGradeList: [],
      //老师打分
      afterArry: [],
      //表格数据
      spanArr: [],
      pos: 0,
      keyData: 0,
      //更新页面
      selfassessment: false,
      //判断是否自评（表单显现）
      gradeScore1: '',
      //表单练习得分
      complete: 'no',
      //是否点击提交自评
      existAdvise: false //是否显示 系统建议
    };
  },
  watch: {},
  created: function created() {
    window.getCallId = this.getCallId;
  },
  mounted: function mounted() {
    this.queryExerciseCount();
    this.queryCallNoSelfValuate();
  },
  methods: {
    // 合并表头
    rowClass: function rowClass(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (rowIndex === 0 && columnIndex === 0) {
        this.$nextTick(function () {
          if (document.getElementsByClassName(column.id).length !== 0) {
            document.getElementsByClassName(column.id)[0].setAttribute('rowSpan', 2);
            return false;
          }
        });
      }
      if (rowIndex === 1 && (columnIndex === 0 || columnIndex === 1)) {
        return {
          display: 'none'
        };
      }
    },
    //提交查询
    uploadqueryGrade: function uploadqueryGrade(id) {
      var _this = this;
      var self = this;
      var data = {
        'id': id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.gradeScore1 = result.data.gradeScore;
          _this.gradeList2 = [];
          var teacherGradeMap = new Map();
          if (result.data.teacherGradeList != null) {
            result.data.teacherGradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                obj.childList.map(function (o) {
                  if (o.checked) {
                    checkedId = o.id;
                  }
                });
                var tempObj = {
                  'score': obj.gradeScore,
                  'childList': obj.childList,
                  'checkedId': checkedId
                };
                teacherGradeMap.set(obj.id, tempObj);
              });
            });
          } else if (result.data.gradeList != null) {
            result.data.gradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                var tempObj = {
                  'childList': obj.childList,
                  'checkedId': checkedId
                };
                teacherGradeMap.set(obj.id, tempObj);
              });
            });
          }
          if (result.data.gradeList != null) {
            result.data.gradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                var description = '';
                obj.childList.map(function (o) {
                  if (o.checked) {
                    checkedId = o.id;
                    checkedName = o.name;
                    description = o.description;
                  }
                });
                var teacherGradeObj = teacherGradeMap.get(obj.id);
                var tempObj = {
                  'parentname': item.name,
                  'name': obj.name,
                  'score': obj.gradeScore,
                  'gradeScore': obj.score,
                  'childList': obj.childList,
                  'checkedId': checkedId,
                  'checkedName': checkedName,
                  'description': description,
                  'teacherGrade': teacherGradeObj ? teacherGradeObj : {}
                };
                self.gradeList2.push(tempObj);
                //判断是否有建议，无建议，则不显示“系统建议”那一列
                if (_this.existAdvise == false && description /* != null && description.trim() != ''*/) {
                  _this.existAdvise = true;
                }
              });
            });
          }
          _this.getSpanArr(_this.gradeList2);
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    //接收callId
    getCallId: function getCallId(id) {
      console.log('传进来的callId------' + id);
      this.callId = id;
      this.queryGrade();
    },
    //查询对练次数
    queryExerciseCount: function queryExerciseCount() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/queryPartnerExerciseCount').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.count = result.data;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('AJAX访问接口异常！');
      });
    },
    //查询是否存在未自评数据
    queryCallNoSelfValuate: function queryCallNoSelfValuate() {
      var _this3 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/queryCallNoSelfValuate?type=Each').then(function (response) {
        var result = response.data;
        if (result.success) {
          if (result.data != null) {
            _this3.id = result.data.id;
            _this3.videoUrl = result.data.videoUrl;
            _this3.gradeState = result.data.gradeState;
            _this3.gradeScore = result.data.gradeScore;
            _this3.evaluateList = result.data.evaluateList;
            _this3.gradeList = result.data.gradeList;
            _this3.teacherGradeList = result.data.teacherGradeList;
            console.log(_this3.gradeList, 5555);
            if (_this3.gradeList != null) {
              _this3.gradeList.map(function (item) {
                item.childList.map(function (obj) {
                  obj.isClickSecond = false;
                });
              });
            }
            _this3.afterArry = [];
            //if(result.data.teacherGradeList != null) {
            for (var i = 0; i < _this3.gradeList.length; i++) {
              for (var c = 0; c < _this3.gradeList[i].childList.length; c++) {
                for (var ic = 0; ic < _this3.gradeList[i].childList[c].childList.length; ic++) {
                  var selfDp = '',
                    teacherDp = '';
                  if (_this3.gradeList[i].childList[c].childList[ic].checked) {
                    selfDp = _this3.gradeList[i].childList[c].childList[ic].name;
                    //for(let j=0;j<this.teacherGradeList[i].childList[c].childList.length;j++) {
                    //if(this.teacherGradeList[i].childList[c].childList[j].checked) {
                    //teacherDp = this.gradeList[i].childList[c].childList[j].name;
                    //break;
                    //}
                    //}
                    var tempObj = {
                      'parentname': _this3.gradeList[i].name,
                      'name': _this3.gradeList[i].childList[c].name,
                      'score': _this3.gradeList[i].childList[c].gradeScore,
                      'selfDp': selfDp,
                      'teacherDp': teacherDp,
                      'description': _this3.gradeList[i].childList[c].childList[ic].description,
                      'teacherScore': null //this.teacherGradeList[i].childList[c].gradeScore
                    };
                    _this3.afterArry.push(tempObj);
                    console.log(_this3.gradeList[i].childList[c], 85474);
                    break;
                  }
                }
              }
            }
            _this3.getSpanArr(_this3.afterArry);
            //}
          }
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('AJAX访问接口异常！');
      });
    },
    //查询评分结果
    queryGrade: function queryGrade() {
      var _this4 = this;
      var self = this;
      var data = {
        'callId': this.callId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/queryPartnerGrade', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.id = result.data.id;
          _this4.videoUrl = result.data.videoUrl;
          _this4.gradeState = result.data.gradeState;
          _this4.gradeScore = result.data.gradeScore;
          _this4.evaluateList = result.data.evaluateList;
          _this4.gradeList = result.data.gradeList;
          _this4.teacherGradeList = result.data.teacherGradeList;
          if (_this4.gradeList != null) {
            _this4.gradeList.map(function (item) {
              item.childList.map(function (obj) {
                obj.isClickSecond = false;
              });
            });
          }
          _this4.afterArry = [];
          //if(result.data.teacherGradeList != null) {
          for (var i = 0; i < _this4.gradeList.length; i++) {
            for (var c = 0; c < _this4.gradeList[i].childList.length; c++) {
              for (var ic = 0; ic < _this4.gradeList[i].childList[c].childList.length; ic++) {
                var selfDp = '',
                  teacherDp = '';
                if (_this4.gradeList[i].childList[c].childList[ic].checked) {
                  selfDp = _this4.gradeList[i].childList[c].childList[ic].name;
                  //for(let j=0;j<this.teacherGradeList[i].childList[c].childList.length;j++) {
                  //if(this.teacherGradeList[i].childList[c].childList[j].checked) {
                  //teacherDp = this.gradeList[i].childList[c].childList[j].name;
                  //break;
                  //}
                  //}
                  var tempObj = {
                    'parentname': _this4.gradeList[i].name,
                    'name': _this4.gradeList[i].childList[c].name,
                    'score': _this4.gradeList[i].childList[c].gradeScore,
                    'selfDp': selfDp,
                    'teacherDp': teacherDp,
                    'description': _this4.gradeList[i].childList[c].childList[ic].description,
                    'teacherScore': null //this.teacherGradeList[i].childList[c].gradeScore
                  };
                  _this4.afterArry.push(tempObj);
                  break;
                }
              }
            }
          }
          _this4.getSpanArr(_this4.afterArry);
          //}
        } else {
          _this4.$alert(result.msg);
        }
      }, function (response) {
        _this4.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    },
    //提交评分
    saveScore: function saveScore() {
      var _this5 = this;
      var choiceRuleIds = [];
      for (var i = 0; i < this.gradeList.length; i++) {
        for (var j = 0; j < this.gradeList[i].childList.length; j++) {
          if (!this.gradeList[i].childList[j].checked) {
            this.$alert('练习点评为必选');
            return false;
            break;
          } else {
            choiceRuleIds.push(this.gradeList[i].childList[j].checked);
          }
        }
      }
      var data = {
        'id': this.id,
        'callId': this.callId,
        'choiceRuleIds': choiceRuleIds
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/savePartnerGrade', data).then(function (response) {
        var result = response.data;
        console.log(result, 9999);
        if (result.success) {
          _this5.$alert('保存成功');
          _this5.queryGrade();
          _this5.selfassessment = true;
          _this5.uploadqueryGrade(result.data);
          _this5.complete = 'yes';
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('AJAX访问接口异常！');
      });
    },
    getSpanArr: function getSpanArr(data) {
      this.spanArr = [];
      this.pos = 0;
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          if (data[i].parentname === data[i - 1].parentname) {
            // 如果name相等就累加，并且push 0 （这里的判断视自己的判定依据改变,name就是要对比的字段）
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            // 不相等push 1
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    objectSpanMethod: function objectSpanMethod(_ref2) {
      var row = _ref2.row,
        column = _ref2.column,
        rowIndex = _ref2.rowIndex,
        columnIndex = _ref2.columnIndex;
      // 用于设置要合并的列 0 表示第一列
      if (columnIndex === 0) {
        var cRow = this.spanArr[rowIndex];
        var cCol = cRow > 0 ? 1 : 0;
        return {
          rowspan: cRow,
          // 合并的行数
          colspan: cCol // 合并的列数，为0表示不显示
        };
      }
    },
    addClass: function addClass(_ref3) {
      var row = _ref3.row,
        column = _ref3.column,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      if (columnIndex == 2 || columnIndex == 3) {
        return 'self';
      }
      if (columnIndex == 4 || columnIndex == 5) {
        return 'teacher';
      }
    }
  }
};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      callId: '',
      orderId: '',
      startDate: '',
      endDate: '',
      shopId: '',
      accounts: '',
      dialogVisible: false,
      isDaka: false,
      //是否打卡
      isHasData: null,
      //是否打分完成
      videoUrl: '',
      //录音文件
      gradeState: '',
      //评分状态
      passedStatus: null,
      //考核是否通过
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      gradeScore: '',
      //得分
      gradeList: '',
      //点评内容
      evaluateList: [],
      //练习建议
      isCurrent: false,
      //是否显示考核次数
      keyData: 0,
      //更新页面
      timer: null //定时获取评分状态
    };
  },
  watch: {
    gradeState: function gradeState() {
      var self = this;
      if (this.gradeState == 1) {
        this.timer = setInterval(function () {
          self.queryGrade('one');
        }, 5000);
      } else if (this.gradeState == 2) {
        clearInterval(this.timer);
      }
    }
  },
  created: function created() {
    window.getCallId = this.getCallId;
  },
  mounted: function mounted() {
    //this.queryGrade();
  },
  methods: {
    //接收callId
    getCallId: function getCallId(id) {
      console.log('传进来的callId------' + id);
      this.callId = id;
      this.queryGrade();
    },
    //查询评分结果
    queryGrade: function queryGrade(type) {
      var _this = this;
      var self = this;
      var data = {
        'callId': this.callId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/queryExamGrade', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          if (result.data == null) {
            _this.isHasData = false;
          } else {
            _this.isHasData = true;
            _this.videoUrl = result.data.videoUrl;
            _this.passedStatus = result.data.passedStatus;
            _this.gradeState = result.data.gradeState;
            _this.effectStatus = result.data.effectStatus;
            if (type == 'one') {
              _this.isCurrent = true;
            } else {
              _this.isCurrent = false;
            }
            _this.effectReason = result.data.effectReason;
            _this.gradeScore = result.data.gradeScore;
            _this.gradeList = result.data.gradeList;
            _this.evaluateList = result.data.evaluateList;
            if (_this.gradeList != null) {
              _this.gradeList.map(function (item) {
                item.childList.map(function (obj) {
                  obj.isClickSecond = false;
                });
              });
            }
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    },
    endHawkeye: function endHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/stop').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    //结束练习
    endScene: function endScene() {
      var _this2 = this;
      this.$confirm('是否确定结束考核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/endExamExercise').then(function (response) {
          var result = response.data;
          if (result.success) {
            _this2.endHawkeye();
            window.open('about:blank', '_top').close();
          } else {
            _this2.$alert(result.msg);
          }
        }, function (response) {
          _this2.$alert('AJAX访问接口异常！');
        });
      }).catch(function () {});
    }
  }
};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: '',
      callId: '',
      imageUrl: '',
      //场景封面
      name: '',
      //场景名称
      gradeList: [],
      showBtn: null,
      //是否显示继续考核/结束考核
      passedStatus: null,
      //考核是否通过
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      evaluateList: [],
      //练习建议
      gradeScore: '',
      //保存打分后接口返回分数
      list: [],
      count: 0,
      total: 0,
      pages: 0,
      pageNum: 1,
      pageSize: 20,
      loading: false,
      totalScore: 0 //评分总分
    };
  },
  computed: {
    noMore: {
      get: function get() {
        return this.count >= this.pages - 1;
      },
      set: function set() {}
    },
    disabled: {
      get: function get() {
        return this.loading || this.noMore;
      },
      set: function set() {}
    }
  },
  created: function created() {
    window.getCallId = this.getCallId;
  },
  mounted: function mounted() {
    /*this.queryList();
    this.queryScene();
    this.queryGrade();*/
  },
  methods: {
    //接收callId
    getCallId: function getCallId(id) {
      console.log('传进来的callId-----' + id);
      this.callId = id;
      this.queryList(true);
      this.queryScene();
      this.queryGrade();
    },
    //查询场景名称
    queryScene: function queryScene() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/queryExamCustomerScene', {
        'callId': this.callId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.imageUrl = result.data != null ? result.data.imageUrl : '';
          _this.name = result.data != null ? result.data.name : '';
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    load: function load() {
      var _this2 = this;
      this.loading = true;
      setTimeout(function () {
        _this2.count += 1;
        _this2.queryList(false);
      }, 100);
    },
    //查询练习记录
    queryList: function queryList(init) {
      var _this3 = this;
      if (init) {
        this.pageNum = 1;
        this.list = [];
      }
      var data = {
        'callId': this.callId,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryRecord', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.total = result.data.total;
          _this3.pages = result.data.pages;
          if (result.data.list != null) {
            for (var i = 0, len = result.data.list.length; i < len; i++) {
              _this3.list.push(result.data.list[i]);
            }
            _this3.pageNum++;
          }
        } else {
          _this3.$alert(result.msg);
        }
        _this3.loading = false;
      }, function (response) {
        _this3.loading = false;
        _this3.$alert('AJAX访问接口异常！');
      });
    },
    //查询评分字段
    queryGrade: function queryGrade() {
      var _this4 = this;
      var data = {
        'callId': this.callId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/queryExamGradeField', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.id = result.data.id;
          _this4.showBtn = result.data.showBtn;
          _this4.passedStatus = result.data.passedStatus;
          _this4.effectStatus = result.data.effectStatus;
          _this4.effectReason = result.data.effectReason;
          _this4.gradeScore = result.data.gradeScore;
          _this4.evaluateList = [];
          if (result.data.evaluateList) {
            result.data.evaluateList.map(function (item) {
              _this4.evaluateList.push({
                'evaluate': item
              });
            });
          } else {
            _this4.evaluateList.push({
              'evaluate': ''
            });
          }
          _this4.gradeList = result.data.gradeList;
          _this4.gradeList.map(function (item) {
            item.childList.map(function (obj) {
              for (var i = 0; i < obj.childList.length; i++) {
                if (obj.childList[i].checked) {
                  _this4.$set(obj, 'checked', obj.childList[i].id);
                  break;
                } else {
                  _this4.$set(obj, 'checked', '');
                }
              }
            });
          });
        } else {
          _this4.$alert(result.msg);
        }
      }, function (response) {
        _this4.$alert('AJAX访问接口异常！');
      });
    },
    addEvaluate: function addEvaluate() {
      this.evaluateList.push({
        'evaluate': ''
      });
    },
    delEvaluate: function delEvaluate(key) {
      this.evaluateList.splice(key, 1);
    },
    //计算总分
    computeTotalScore: function computeTotalScore() {
      this.totalScore = 0;
      for (var i = 0; i < this.gradeList.length; i++) {
        for (var j = 0; j < this.gradeList[i].childList.length; j++) {
          if (this.gradeList[i].childList[j].checked != null) {
            for (var c = 0; c < this.gradeList[i].childList[j].childList.length; c++) {
              if (this.gradeList[i].childList[j].checked == this.gradeList[i].childList[j].childList[c].id) {
                this.$set(this, 'totalScore', this.totalScore + this.gradeList[i].childList[j].childList[c].score);
                break;
              }
            }
          }
        }
      }
    },
    //提交评分
    saveScore: function saveScore() {
      var _this5 = this;
      if (this.effectStatus != 0 && this.effectStatus != 1) {
        this.$alert('请选择考核状态');
        return false;
      }
      if (this.effectStatus == 0 && this.effectReason == '') {
        this.$alert('请填写无效原因');
        return false;
      }
      var choiceRuleIds = [],
        evaluateList = [];
      if (this.effectStatus == 1) {
        for (var i = 0; i < this.gradeList.length; i++) {
          for (var j = 0; j < this.gradeList[i].childList.length; j++) {
            if (!this.gradeList[i].childList[j].checked) {
              this.$alert('考核点评为必选');
              return false;
              break;
            } else {
              choiceRuleIds.push(this.gradeList[i].childList[j].checked);
            }
          }
        }
        for (var _i = 0; _i < this.evaluateList.length; _i++) {
          if (!this.evaluateList[_i].evaluate) {
            this.$alert('请填写考核建议');
            return false;
            break;
          } else {
            evaluateList.push(this.evaluateList[_i].evaluate);
          }
        }
      }
      var data = {
        'id': this.id,
        'callId': this.callId,
        'effectStatus': this.effectStatus,
        'effectReason': this.effectReason,
        'choiceRuleIds': choiceRuleIds,
        'evaluateList': evaluateList
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/saveExamGrade', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.$message({
            message: '操作成功',
            type: 'success'
          });
          _this5.queryList(true);
          _this5.queryGrade();
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('AJAX访问接口异常！');
      });
    },
    //继续考核/结束考核
    updateExamStatus: function updateExamStatus(status) {
      var _this6 = this;
      var text = status == 0 ? '是否确定结束考核？' : '是否确定继续考核？';
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          'callId': _this6.callId,
          'status': status
        };
        _this6.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/updateExamStatus', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            _this6.$message({
              message: '操作成功',
              type: 'success'
            });
            _this6.queryGrade();
          } else {
            _this6.$alert(result.msg);
          }
        }, function (response) {
          _this6.$alert('AJAX访问接口异常！');
        });
      }).catch(function () {});
    }
  }
};

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      videoUrl: '',
      //录音文件
      gradeState: '',
      //评分状态
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      gradeScore: '',
      //得分
      gradeList: '',
      //点评内容
      evaluateList: [],
      //练习建议
      preId: '',
      //上一条记录
      nextId: '',
      //下一条记录
      keyData: 0 //更新页面
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.queryGrade(this.id);
  },
  methods: {
    queryGrade: function queryGrade(id) {
      var _this = this;
      var data = {
        'id': id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.videoUrl = result.data.videoUrl;
          _this.gradeState = result.data.gradeState;
          _this.effectStatus = result.data.effectStatus;
          _this.effectReason = result.data.effectReason;
          _this.gradeScore = result.data.gradeScore;
          _this.gradeList = result.data.gradeList;
          _this.evaluateList = result.data.evaluateList;
          _this.preId = result.data.preId;
          _this.nextId = result.data.nextId;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    }
  }
};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      tjkId: '',
      activeName: 'zero',
      list: [],
      step: 'first',
      input: '',
      priList: [{
        title: '对练目的',
        tips: [{
          value: '1、熟悉小助手外呼操作步骤;'
        }, {
          value: '2、与搭档进行话术对练。'
        }]
      }, {
        title: '必备条件',
        tips: [{
          value: '1、有对练搭档（一般老师会分组，若未分组，请自行在群内找搭档）；'
        }, {
          value: '2、你的对练搭档也进入了语音对练。'
        }]
      }, {
        title: '操作手册',
        tips: [{
          value: '1、请先查看语音对练操作手册，然后再进行练习。'
        }]
      }],
      dialogVisible: false,
      partner: {},
      kaoheList: []
    };
  },
  created: function created() {
    this.getCustomerUser();
  },
  mounted: function mounted() {
    this.getList();
    this.getKaoheList();
  },
  methods: {
    style: function style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      };
    },
    handleClick: function handleClick() {},
    getList: function getList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceScene/list').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.list = result.data;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    /*toDetail(id) {
    	this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/accompanyReady', {'id': id}).then(response=>{
    		var result = response.data;
    		if(result.success) {
    			this.toSign(id);
    		}else {
    			this.$alert(result.msg);
    		}
    	},response => {
    		this.$alert('AJAX访问接口异常！');
    	})
    },*/
    toSign: function toSign(id) {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=' + id).then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    getKaoheList: function getKaoheList() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceScene/listExamScene').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.kaoheList = result.data;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('AJAX访问接口异常！');
      });
    },
    toKaoheDetail: function toKaoheDetail(id) {
      var _this3 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/examReady', {
        'id': id
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.toSign(id);
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('AJAX访问接口异常！');
      });
    },
    stopKaohePrict: function stopKaohePrict() {
      var _this4 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voiceExerciseCustomer/endExamExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this4.getKaoheList();
        }
      });
    },
    //查询淘金客信息
    getCustomerUser: function getCustomerUser() {
      var _this5 = this;
      this.$http.get('/customer/action/currentUser/customerUser').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.tjkId = result.data.id;
          _this5.isHasPri();
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('AJAX访问接口异常！');
      });
    },
    showKnow: function showKnow() {
      this.step = 'second';
    },
    isHasPri: function isHasPri() {
      var _this6 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/existExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success && result.data.data) {
          _this6.step = 'handing';
        } else {
          _this6.step = 'first';
        }
      });
    },
    goToPrict: function goToPrict() {
      var _this7 = this;
      var patrn = /^(-)?\d+(\.\d+)?$/;
      if (!patrn.exec(this.input)) {
        this.$message({
          message: '请输入正确的淘金号',
          type: 'error'
        });
        return;
      }
      if (this.input && this.input.length < 9) {
        this.$message({
          message: '淘金号长度至少为9位',
          type: 'error'
        });
        return;
      }

      //查询是否存在当前淘金号
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + "/tjk/queryTjkList?tjkParam=".concat(this.input, "&returnAllData=1")).then(function (result) {
        if (result.data.data.length) {
          _this7.partner = result.data.data[0];
          _this7.dialogVisible = true;
        } else {
          _this7.$message({
            message: '未找到对应的对练伙伴，请重新输入淘金号',
            type: 'error'
          });
        }
      });
      // 打开打卡，然后展示正在练习
    },
    stopPrict: function stopPrict() {
      var _this8 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/endExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this8.step = 'first';
        }
      });
    },
    /*stopTeacherPrict() {
      this.$http.get(API_ROOT.college + `/voiceExerciseCustomer/endExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
        if(result.data.success) {
          this.getList();
        }
      });
    },*/
    newPrict: function newPrict() {
      this.step = 'second';
    },
    //清空排版数据
    clearSchedule: function clearSchedule() {
      this.$http.get('http://127.0.0.1:26688/api/SignIn/clearScheduleCache').then(function (res) {});
      this.sureGoToPri();
    },
    sureGoToPri: function sureGoToPri() {
      var _this9 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/ready?tjkId=".concat(this.partner.id, "&assitantTjkId=").concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this9.getHawkeye();
          _this9.input = '';
          _this9.step = 'handing';
          _this9.dialogVisible = false;
        } else {
          _this9.$message({
            message: result.data.msg,
            type: 'error'
          });
        }
      });
    },
    //调用小助手
    getHawkeye: function getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (res) {
        done();
      }).catch(function (res) {});
    }
  }
};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      videoUrl: '',
      //录音文件
      gradeState: '',
      //评分状态
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      gradeScore: '',
      //得分
      gradeList: '',
      //点评内容
      evaluateList: [],
      //练习建议
      preId: '',
      //上一条记录
      nextId: '',
      //下一条记录
      keyData: 0 //更新页面
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.queryGrade(this.id);
  },
  methods: {
    //查询评分字段
    queryGrade: function queryGrade(id) {
      var _this = this;
      var data = {
        'id': id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.videoUrl = result.data.videoUrl;
          _this.gradeState = result.data.gradeState;
          _this.effectStatus = result.data.effectStatus;
          _this.effectReason = result.data.effectReason;
          _this.gradeScore = result.data.gradeScore;
          _this.gradeList = result.data.gradeList;
          _this.evaluateList = result.data.evaluateList;
          _this.preId = result.data.preId;
          _this.nextId = result.data.nextId;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    }
  }
};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {
    var login_token = this.$route.query.token;
    // window.location.href = window.location.origin + '/customer/action/login/verifyLogin?url=' + window.location.origin + '/tjkStudy/newVoiceSceneIndex&token='+login_token
    window.location.href = window.location.origin + '/customer/action/login/verifyLogin?url=' + window.location.origin + '/tjkStudy/train/index&token=' + login_token;
  },
  methods: {}
};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: '',
      count: 0,
      callId: '',
      videoUrl: '',
      //录音文件
      gradeState: null,
      //评分状态
      gradeScore: '',
      //得分
      gradeList: '',
      //点评内容
      evaluateList: [],
      //练习建议
      teacherGradeList: [],
      //老师打分
      afterArry: [],
      //表格数据
      spanArr: [],
      pos: 0,
      keyData: 0,
      //更新页面
      isShowRecord: false,
      //是否达标听优秀录音
      tabId: null,
      //技能提升tab
      sceneMajorId: null,
      //场景id
      gradeScore1: '',
      //表单练习得分
      gradeList2: '',
      //点评内容
      complete: 'no',
      //是否点击提交自评
      selfassessment: false,
      //判断是否自评（表单显现）
      existAdvise: false,
      //是否显示 系统建议
      Clickrecord: false,
      //判断是否点击通话查看历史评分
      isexistAdvise: false,
      //判断是否有建议（旧数据）
      courseId: null,
      knowledgeSeq: null,
      CourseLevel: null,
      sceneId: null,
      trainId: null,
      tjkId: null,
      knowledgeId: null,
      centerDialogVisible: false //提示弹窗
    };
  },
  watch: {},
  created: function created() {
    window.getCallId = this.getCallId;
  },
  mounted: function mounted() {
    this.queryExerciseCount();
    this.queryCallNoSelfValuate();
  },
  methods: {
    //点击结束练习
    stopPrict: function stopPrict() {
      var _this = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/endExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this.step = 'second';
        }
      });
    },
    //更改某一列样式
    // addsClass({row,column,rowIndex,columnIndex}){ 
    //    if(columnIndex==3){  //此判断为第四列
    //       return 'addBorderStyle_3'
    //     }
    // 	 if(columnIndex==4){  //此判断为第五列
    //       return 'addBorderStyle_4'
    //     }
    // },
    rowsClass: function rowsClass(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (rowIndex === 0 && columnIndex === 0) {
        this.$nextTick(function () {
          if (document.getElementsByClassName(column.id).length !== 0) {
            document.getElementsByClassName(column.id)[0].setAttribute('rowSpan', 2);
            return false;
          }
        });
      }
      if (rowIndex === 1 && (columnIndex === 0 || columnIndex === 1)) {
        return {
          display: 'none'
        };
      }
      if (columnIndex == 3 && rowIndex == 0) {
        return 'background-color:#f9dbd0 !important ';
      } else if (columnIndex == 3 && rowIndex == 1) {
        return 'background-color:#cbd5fa !important';
      }
      if (columnIndex == 2) {
        return 'background-color:#cbd5fa !important';
      }
    },
    //提交查询
    uploadqueryGrade: function uploadqueryGrade(id) {
      var _this2 = this;
      var self = this;
      var data = {
        'id': id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.gradeScore1 = result.data.gradeScore;
          _this2.gradeList2 = [];
          var teacherGradeMap = new Map();
          if (result.data.teacherGradeList != null) {
            result.data.teacherGradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                obj.childList.map(function (o) {
                  if (o.checked) {
                    checkedId = o.id;
                  }
                });
                var tempObj = {
                  'score': obj.gradeScore,
                  'childList': obj.childList,
                  'checkedId': checkedId
                };
                teacherGradeMap.set(obj.id, tempObj);
              });
            });
          } else if (result.data.gradeList != null) {
            result.data.gradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                var tempObj = {
                  'childList': obj.childList,
                  'checkedId': checkedId
                };
                teacherGradeMap.set(obj.id, tempObj);
              });
            });
          }
          if (result.data.gradeList != null) {
            result.data.gradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                var description = '';
                obj.childList.map(function (o) {
                  if (o.checked) {
                    checkedId = o.id;
                    checkedName = o.name;
                    description = o.description;
                  }
                });
                var teacherGradeObj = teacherGradeMap.get(obj.id);
                var tempObj = {
                  'parentname': item.name,
                  'name': obj.name,
                  'score': obj.gradeScore,
                  'gradeScore': obj.score,
                  'childList': obj.childList,
                  'checkedId': checkedId,
                  'checkedName': checkedName,
                  'description': description,
                  'teacherGrade': teacherGradeObj ? teacherGradeObj : {}
                };
                self.gradeList2.push(tempObj);
                //判断是否有建议，无建议，则不显示“系统建议”那一列
                if (_this2.existAdvise == false && description /* != null && description.trim() != ''*/) {
                  _this2.existAdvise = true;
                }
              });
            });
          }
          _this2.getSpanArr(_this2.gradeList2);
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('AJAX访问接口异常！');
      });
    },
    //接收callId
    getCallId: function getCallId(id) {
      console.log('传进来的callId------' + id);
      this.callId = id;
      this.queryGrade();
    },
    //查询对练次数
    queryExerciseCount: function queryExerciseCount() {
      var _this3 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/queryPartnerExerciseCount').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.count = result.data;
        } else {
          _this3.$alert(result.msg);
        }
      }, function (response) {
        _this3.$alert('AJAX访问接口异常！');
      });
    },
    //查询是否存在未自评数据
    queryCallNoSelfValuate: function queryCallNoSelfValuate() {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/queryCallNoSelfValuate?type=Each').then(function (response) {
        var result = response.data;
        if (result.success) {
          if (result.data != null) {
            _this4.id = result.data.id;
            _this4.videoUrl = result.data.videoUrl;
            _this4.gradeState = result.data.gradeState;
            _this4.gradeScore = result.data.gradeScore;
            _this4.evaluateList = result.data.evaluateList;
            _this4.gradeList = result.data.gradeList;
            _this4.teacherGradeList = result.data.teacherGradeList;
            if (_this4.gradeList != null) {
              _this4.gradeList.map(function (item) {
                item.childList.map(function (obj) {
                  obj.isClickSecond = false;
                });
              });
            }
            _this4.afterArry = [];
            //if(result.data.teacherGradeList != null) {
            for (var i = 0; i < _this4.gradeList.length; i++) {
              for (var c = 0; c < _this4.gradeList[i].childList.length; c++) {
                for (var ic = 0; ic < _this4.gradeList[i].childList[c].childList.length; ic++) {
                  var selfDp = '',
                    teacherDp = '';
                  if (_this4.gradeList[i].childList[c].childList[ic].checked) {
                    selfDp = _this4.gradeList[i].childList[c].childList[ic].name;
                    //for(let j=0;j<this.teacherGradeList[i].childList[c].childList.length;j++) {
                    //if(this.teacherGradeList[i].childList[c].childList[j].checked) {
                    //teacherDp = this.gradeList[i].childList[c].childList[j].name;
                    //break;
                    //}
                    //}
                    var tempObj = {
                      'parentname': _this4.gradeList[i].name,
                      'name': _this4.gradeList[i].childList[c].name,
                      'score': _this4.gradeList[i].childList[c].gradeScore,
                      'selfDp': selfDp,
                      'teacherDp': teacherDp,
                      'description': _this4.gradeList[i].childList[c].childList[ic].description,
                      'teacherScore': null //this.teacherGradeList[i].childList[c].gradeScore
                    };
                    _this4.afterArry.push(tempObj);
                    break;
                  }
                }
              }
            }
            _this4.getSpanArr(_this4.afterArry);
            //}
          }
        } else {
          _this4.$alert(result.msg);
        }
      }, function (response) {
        _this4.$alert('AJAX访问接口异常！');
      });
    },
    //查询评分结果
    queryGrade: function queryGrade() {
      var _this5 = this;
      var self = this;
      var data = {
        'callId': this.callId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/queryPartnerGrade', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.Clickrecord = true;
          _this5.id = result.data.id;
          _this5.videoUrl = result.data.videoUrl;
          _this5.gradeState = result.data.gradeState;
          _this5.gradeScore = result.data.gradeScore;
          _this5.evaluateList = result.data.evaluateList;
          _this5.gradeList = result.data.gradeList;
          _this5.teacherGradeList = result.data.teacherGradeList;
          if (_this5.gradeList != null) {
            _this5.gradeList.map(function (item) {
              item.childList.map(function (obj) {
                obj.isClickSecond = false;
              });
            });
          }
          _this5.afterArry = [];
          //if(result.data.teacherGradeList != null) {
          var tempObj = {};
          for (var i = 0; i < _this5.gradeList.length; i++) {
            for (var c = 0; c < _this5.gradeList[i].childList.length; c++) {
              for (var ic = 0; ic < _this5.gradeList[i].childList[c].childList.length; ic++) {
                var selfDp = '',
                  teacherDp = '';
                if (_this5.gradeList[i].childList[c].childList[ic].checked) {
                  selfDp = _this5.gradeList[i].childList[c].childList[ic].name;
                  //for(let j=0;j<this.teacherGradeList[i].childList[c].childList.length;j++) {
                  //if(this.teacherGradeList[i].childList[c].childList[j].checked) {
                  //teacherDp = this.gradeList[i].childList[c].childList[j].name;
                  //break;
                  //}
                  //}
                  tempObj = {
                    'parentname': _this5.gradeList[i].name,
                    'name': _this5.gradeList[i].childList[c].name,
                    'score': _this5.gradeList[i].childList[c].gradeScore,
                    'gradeScore': _this5.gradeList[i].childList[c].score,
                    'selfDp': selfDp,
                    'teacherDp': teacherDp,
                    'description': _this5.gradeList[i].childList[c].childList[ic].description,
                    'teacherScore': null //this.teacherGradeList[i].childList[c].gradeScore
                  };
                  _this5.afterArry.push(tempObj);
                  break;
                }
              }
            }
          }
          _this5.getSpanArr(_this5.afterArry);
          console.log(tempObj, '《==================obj');
          if (_this5.isexistAdvise == false && tempObj && tempObj.description && tempObj.description.length() != 0 /* != null && description.trim() != ''*/) {
            _this5.isexistAdvise = true;
          }
          //}
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    },
    //提交评分
    saveScore: function saveScore() {
      var _this6 = this;
      var choiceRuleIds = [];
      for (var i = 0; i < this.gradeList.length; i++) {
        for (var j = 0; j < this.gradeList[i].childList.length; j++) {
          if (!this.gradeList[i].childList[j].checked) {
            this.centerDialogVisible = true;
            // this.$alert('练习点评为必选');
            return false;
            break;
          } else {
            choiceRuleIds.push(this.gradeList[i].childList[j].checked);
          }
        }
      }
      var data = {
        'id': this.id,
        'callId': this.callId,
        'choiceRuleIds': choiceRuleIds
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/savePartnerGrade', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this6.$alert('你已完成本次自评');
          // 以前是保存成功
          _this6.queryGrade();
          //查询是否达标听优秀录音
          _this6.showGoodVoicePopWin();
          _this6.selfassessment = true;
          _this6.uploadqueryGrade(result.data);
          _this6.complete = 'yes';
        } else {
          _this6.$alert(result.msg);
        }
      }, function (response) {
        _this6.$alert('AJAX访问接口异常！');
      });
    },
    showGoodVoicePopWin: function showGoodVoicePopWin() {
      var _this7 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/goodRecord/showGoodVoicePopWin').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this7.isShowRecord = result.data.jumpGoodVoice ? true : false;
          _this7.knowledgeId = result.data.knowledgeId;
          _this7.courseId = result.data.courseId;
          _this7.knowledgeSeq = result.data.knowledgeSeq;
          _this7.CourseLevel = result.data.CourseLevel;
          _this7.sceneId = result.data.sceneId;
          _this7.trainId = result.data.trainId;
          _this7.tjkId = result.data.tjkId;
        } else {
          _this7.$alert(result.msg);
        }
      }, function (response) {
        _this7.$alert('AJAX访问接口异常！');
      });
    },
    //听录音
    goRecord: function goRecord() {
      this.$router.push({
        path: '/vedioDetail',
        query: {
          courseId: this.courseId,
          knowledgeSeq: this.knowledgeSeq,
          CourseLevel: this.CourseLevel,
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId,
          knowledgeId: this.knowledgeId,
          isReture: 'yes'
        }
      });
    },
    getSpanArr: function getSpanArr(data) {
      this.spanArr = [];
      this.pos = 0;
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          if (data[i].parentname === data[i - 1].parentname) {
            // 如果name相等就累加，并且push 0 （这里的判断视自己的判定依据改变,name就是要对比的字段）
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            // 不相等push 1
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    objectSpanMethod: function objectSpanMethod(_ref2) {
      var row = _ref2.row,
        column = _ref2.column,
        rowIndex = _ref2.rowIndex,
        columnIndex = _ref2.columnIndex;
      // 用于设置要合并的列 0 表示第一列
      if (columnIndex === 0) {
        var cRow = this.spanArr[rowIndex];
        var cCol = cRow > 0 ? 1 : 0;
        return {
          rowspan: cRow,
          // 合并的行数
          colspan: cCol // 合并的列数，为0表示不显示
        };
      }
    },
    addsClass: function addsClass(_ref3) {
      var row = _ref3.row,
        column = _ref3.column,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      //   if(columnIndex == 2 || columnIndex == 3) {
      //     return 'self';
      //   }
      //   if(columnIndex == 4 || columnIndex == 5) {
      //     return 'teacher';
      //   }
      // 修改样式
      if (columnIndex == 3) {
        //此判断为第四列
        return 'addBorderStyle_3';
      }
      if (columnIndex == 4) {
        //此判断为第五列
        return 'addBorderStyle_4';
      }
    }
  }
};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      callId: '',
      orderId: '',
      startDate: '',
      endDate: '',
      shopId: '',
      accounts: '',
      dialogVisible: false,
      isDaka: false,
      //是否打卡
      isHasData: null,
      //是否打分完成
      videoUrl: '',
      //录音文件
      gradeState: '',
      //评分状态
      passedStatus: null,
      //考核是否通过
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      gradeScore: '',
      //得分
      gradeList: '',
      //点评内容
      evaluateList: [],
      //练习建议
      isCurrent: false,
      //是否显示考核次数
      keyData: 0,
      //更新页面
      timer: null //定时获取评分状态
    };
  },
  watch: {
    gradeState: function gradeState() {
      var self = this;
      if (this.gradeState == 1) {
        this.timer = setInterval(function () {
          self.queryGrade('one');
        }, 5000);
      } else if (this.gradeState == 2) {
        clearInterval(this.timer);
      }
    }
  },
  created: function created() {
    window.getCallId = this.getCallId;
  },
  mounted: function mounted() {
    //this.queryGrade();
  },
  methods: {
    //接收callId
    getCallId: function getCallId(id) {
      console.log('传进来的callId------' + id);
      this.callId = id;
      this.queryGrade();
    },
    //查询评分结果
    queryGrade: function queryGrade(type) {
      var _this = this;
      var self = this;
      var data = {
        'callId': this.callId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/queryExamGrade', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          if (result.data == null) {
            _this.isHasData = false;
          } else {
            _this.isHasData = true;
            _this.videoUrl = result.data.videoUrl;
            _this.passedStatus = result.data.passedStatus;
            _this.gradeState = result.data.gradeState;
            _this.effectStatus = result.data.effectStatus;
            if (type == 'one') {
              _this.isCurrent = true;
            } else {
              _this.isCurrent = false;
            }
            _this.effectReason = result.data.effectReason;
            _this.gradeScore = result.data.gradeScore;
            _this.gradeList = result.data.gradeList;
            _this.evaluateList = result.data.evaluateList;
            if (_this.gradeList != null) {
              _this.gradeList.map(function (item) {
                item.childList.map(function (obj) {
                  obj.isClickSecond = false;
                });
              });
            }
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    },
    endHawkeye: function endHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/stop').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    //结束练习
    endScene: function endScene() {
      var _this2 = this;
      this.$confirm('是否确定结束考核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/endExamExercise').then(function (response) {
          var result = response.data;
          if (result.success) {
            _this2.endHawkeye();
            window.open('about:blank', '_top').close();
          } else {
            _this2.$alert(result.msg);
          }
        }, function (response) {
          _this2.$alert('AJAX访问接口异常！');
        });
      }).catch(function () {});
    }
  }
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: '',
      callId: '',
      imageUrl: '',
      //场景封面
      name: '',
      //场景名称
      gradeList: [],
      showBtn: null,
      //是否显示继续考核/结束考核
      passedStatus: null,
      //考核是否通过
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      evaluateList: [],
      //练习建议
      gradeScore: '',
      //保存打分后接口返回分数
      list: [],
      count: 0,
      total: 0,
      pages: 0,
      pageNum: 1,
      pageSize: 20,
      loading: false,
      totalScore: 0,
      //评分总分
      check: '',
      //抽查内容
      scriptTitle: null,
      //话术标题
      scriptObj: {
        intro: null,
        script: null
      }
    };
  },
  computed: {
    noMore: {
      get: function get() {
        return this.count >= this.pages - 1;
      },
      set: function set() {}
    },
    disabled: {
      get: function get() {
        return this.loading || this.noMore;
      },
      set: function set() {}
    }
  },
  created: function created() {
    window.getCallId = this.getCallId;
  },
  methods: {
    //接收callId
    getCallId: function getCallId(id) {
      console.log('传进来的callId-----' + id);
      this.callId = id;
      // this.queryTjkScriptByCallId();//淘金大学没使用了,弃用
      this.queryList(true);
      this.queryScene();
      this.queryGrade();
    },
    //查询场景名称
    queryScene: function queryScene() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/queryExamCustomerScene', {
        'callId': this.callId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.imageUrl = result.data != null ? result.data.imageUrl : '';
          _this.name = result.data != null ? result.data.name : '';
        } else {
          _this.$alert('查询场景错误：' + result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    load: function load() {
      var _this2 = this;
      this.loading = true;
      setTimeout(function () {
        _this2.count += 1;
        _this2.queryList(false);
      }, 100);
    },
    //查询练习记录
    queryList: function queryList(init) {
      var _this3 = this;
      if (init) {
        this.pageNum = 1;
        this.list = [];
      }
      var data = {
        'callId': this.callId,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryRecord', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this3.total = result.data.total;
          _this3.pages = result.data.pages;
          if (result.data.list != null) {
            for (var i = 0, len = result.data.list.length; i < len; i++) {
              _this3.list.push(result.data.list[i]);
            }
            _this3.pageNum++;
          }
        } else {
          _this3.$alert('查询练习记录错误：' + result.msg);
        }
        _this3.loading = false;
      }, function (response) {
        _this3.loading = false;
        _this3.$alert('AJAX访问接口异常！');
      });
    },
    //查询评分字段
    queryGrade: function queryGrade() {
      var _this4 = this;
      var data = {
        'callId': this.callId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/queryExamGradeField', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.id = result.data.id;
          _this4.showBtn = result.data.showBtn;
          _this4.passedStatus = result.data.passedStatus;
          _this4.effectStatus = result.data.effectStatus;
          _this4.effectReason = result.data.effectReason;
          _this4.gradeScore = result.data.gradeScore;
          _this4.evaluateList = [];
          if (result.data.evaluateList) {
            result.data.evaluateList.map(function (item) {
              _this4.evaluateList.push({
                'evaluate': item
              });
            });
          } else {
            _this4.evaluateList.push({
              'evaluate': ''
            });
          }
          _this4.gradeList = result.data.gradeList;
          _this4.gradeList.map(function (item) {
            item.childList.map(function (obj) {
              for (var i = 0; i < obj.childList.length; i++) {
                if (obj.childList[i].checked) {
                  _this4.$set(obj, 'checked', obj.childList[i].id);
                  break;
                } else {
                  _this4.$set(obj, 'checked', '');
                }
              }
            });
          });
        } else {
          _this4.$alert('查询评分错误：' + result.msg);
        }
      }, function (response) {
        _this4.$alert('AJAX访问接口异常！');
      });
    },
    /*queryTjkScriptByCallId() {
    this.$http.post(API_ROOT.college + '/tjCollegeTrain/queryTjkScriptByCallId', {"callId": this.callId}).then(response=>{
    var result = response.data;
    if(result.success) {
                this.scriptTitle = result.data == null ? null : result.data.title;
                this.scriptObj = result.data == null ? {} : result.data;
                console.log('===queryTjkScriptByCallId.callId='+this.callId+'_____'+this.scriptObj)
            }else{
    this.$alert("对练脚本 error:"+result.msg);
    }
    },response => {
    this.$alert('AJAX访问接口异常！');
    })
    },*/
    addEvaluate: function addEvaluate() {
      this.evaluateList.push({
        'evaluate': ''
      });
    },
    delEvaluate: function delEvaluate(key) {
      this.evaluateList.splice(key, 1);
    },
    //计算总分
    computeTotalScore: function computeTotalScore() {
      this.totalScore = 0;
      for (var i = 0; i < this.gradeList.length; i++) {
        for (var j = 0; j < this.gradeList[i].childList.length; j++) {
          if (this.gradeList[i].childList[j].checked != null) {
            for (var c = 0; c < this.gradeList[i].childList[j].childList.length; c++) {
              if (this.gradeList[i].childList[j].checked == this.gradeList[i].childList[j].childList[c].id) {
                this.$set(this, 'totalScore', this.totalScore + this.gradeList[i].childList[j].childList[c].score);
                break;
              }
            }
          }
        }
      }
    },
    //提交评分
    saveScore: function saveScore() {
      var _this5 = this;
      if (this.effectStatus != 0 && this.effectStatus != 1) {
        this.$alert('请选择考核状态');
        return false;
      }
      if (this.effectStatus == 0 && this.effectReason == '') {
        this.$alert('请填写无效原因');
        return false;
      }
      var choiceRuleIds = [],
        evaluateList = [];
      if (this.effectStatus == 1) {
        for (var i = 0; i < this.gradeList.length; i++) {
          for (var j = 0; j < this.gradeList[i].childList.length; j++) {
            if (!this.gradeList[i].childList[j].checked) {
              this.$alert('考核点评为必选');
              return false;
              break;
            } else {
              choiceRuleIds.push(this.gradeList[i].childList[j].checked);
            }
          }
        }
        for (var _i = 0; _i < this.evaluateList.length; _i++) {
          if (!this.evaluateList[_i].evaluate) {
            this.$alert('请填写考核建议');
            return false;
            break;
          } else {
            evaluateList.push(this.evaluateList[_i].evaluate);
          }
        }
      }
      var data = {
        'id': this.id,
        'callId': this.callId,
        'effectStatus': this.effectStatus,
        'effectReason': this.effectReason,
        'choiceRuleIds': choiceRuleIds,
        'evaluateList': evaluateList
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/saveExamGrade', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.$message({
            message: '操作成功',
            type: 'success'
          });
          _this5.queryList(true);
          _this5.queryGrade();
        } else {
          _this5.$alert('提交评分错误：' + result.msg);
        }
      }, function (response) {
        _this5.$alert('AJAX访问接口异常！');
      });
    },
    //继续考核/结束考核
    updateExamStatus: function updateExamStatus(status) {
      var _this6 = this;
      var text = status == 0 ? '是否确定结束考核？' : '是否确定继续考核？';
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          'callId': _this6.callId,
          'status': status
        };
        _this6.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/updateExamStatus', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            _this6.$message({
              message: '操作成功',
              type: 'success'
            });
            _this6.queryGrade();
          } else {
            _this6.$alert('错误：' + result.msg);
          }
        }, function (response) {
          _this6.$alert('AJAX访问接口异常！');
        });
      }).catch(function () {});
    }
  }
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      videoUrl: '',
      //录音文件
      gradeState: '',
      //评分状态
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      gradeScore: '',
      //得分
      gradeList: '',
      //点评内容
      evaluateList: [],
      //练习建议
      preId: '',
      //上一条记录
      nextId: '',
      //下一条记录
      keyData: 0 //更新页面
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.queryGrade(this.id);
  },
  methods: {
    queryGrade: function queryGrade(id) {
      var _this = this;
      var data = {
        'id': id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.videoUrl = result.data.videoUrl;
          _this.gradeState = result.data.gradeState;
          _this.effectStatus = result.data.effectStatus;
          _this.effectReason = result.data.effectReason;
          _this.gradeScore = result.data.gradeScore;
          _this.gradeList = result.data.gradeList;
          _this.evaluateList = result.data.evaluateList;
          _this.preId = result.data.preId;
          _this.nextId = result.data.nextId;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    }
  }
};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {
    var login_token = this.$route.query.token;
    var assitantParam = this.$route.query.assitantParam;
    //有些客服，（比如辽宁的局部地区），访问 t.itaojin.cn/train/index时，某缓存js（https://t-cdn.itaojin.cn/tjkStudy/static/js/9.dc86dfbdcc303ae07f9a.js）， 用http访问不到，用https能行，所以下面访问的时候强行指定为https，否则白屏
    var url = window.location.origin.indexOf('itaojin.cn') > -1 ? 'https://t.itaojin.cn' : 'https://t.itaojintest.cn';
    if (assitantParam == 'SkillUpgrade') {
      var url = window.location.origin + '/customer/action/login/verifyLogin?url=' + url + '/tjkStudy/train/index?type=SkillUpgrade&show=yes&token=' + login_token;
      window.location.href = url;
    } else {
      window.location.href = window.location.origin + '/customer/action/login/verifyLogin?url=' + url + '/tjkStudy/train/index&token=' + login_token;
    }
  },
  methods: {}
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _voice = _interopRequireDefault(__webpack_require__(632));
var _examDialog = _interopRequireDefault(__webpack_require__(402));
var _trainList = _interopRequireDefault(__webpack_require__(1548));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _ref;
    return _ref = {
      tjkInfo: {},
      toptab: '语音技能提升',
      //语音or在线
      tabIndex: 0,
      showAskingDoor: false,
      //是否展示咨询入口
      tabOneList: [],
      //一级table
      tabType: null,
      //二级tab菜单名称
      tabTwoList: [],
      //二级tab菜单
      tabMajorId: this.$route.query.tabMajorId,
      //tab的id
      courseList: [],
      trainList: [],
      examCourseId: null,
      //测试考试课程id
      trainState: null,
      //技能提升是否获得徽章
      badgeUrl: "",
      //获得徽章图片地址
      content: "",
      //获得徽章文字描述
      description: "",
      //场景文字描述
      isAllComplete: 0,
      registration: 0
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "trainList", []), "decide", 0), "isPost", false), "newPeopleBadgeId", false), "isaxx", 0), "dialogVisible", false), "needFinish", null), "systemPopup", false), "iskey", null), "istype", ''), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "axx", false), "issystem", false), "prosystemPopup", false), "dimensional", false), "dimensionalimg", ''), "majorId", 100037), "categoryId", 1071), "cseList", []), "assitantType", ''), "sceneId", null), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "addGroupDialog", {
      show: false,
      //是否报名弹窗（qq弹窗之前）
      majorType: null,
      //是否是淘金大学类型【VOICE/TjCollege】
      tip: '确认参加培训并加入培训群'
    }), "trainId", null), "OnlinetrainId", null), "tjkId", null), "prosper", false), "AppGuide", false), "Onetabtindex", 0), "Onlinelist", []), "OnlinesignIn", false), "trainTitle", ''), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "VoicePassState", ''), "curriculum", {}), "theoryRemainDialog", {
      show: false,
      courseIdOfsceneId: null,
      passState: null,
      total: null,
      remain: null
    }), "imUrl", {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.imUrl), "imToken", {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.imToken);
  },
  components: {
    voice: _voice.default,
    examDialog: _examDialog.default,
    trainList: _trainList.default
  },
  watch: {},
  created: function created() {
    // if (!window.myTaojinWebBrower && !this.$route.query.ht) {
    //   alert('请在小助手中打开此页面！')
    //   return
    // }
    // this.getCustomerUser();//查当前客服

    if (this.$route.query.type == 'SkillUpgrade') {
      this.isspecial();
      this.Lv3Courses();
    } else if (localStorage.getItem('tabIndex') || localStorage.getItem('majorId')) {
      var i = localStorage.getItem('tabIndex');
      i = Number(i);
      this.tabIndex = i;
      var n = localStorage.getItem('Onetabtindex');
      n = Number(n);
      this.Onetabtindex = n;
      this.majorId = localStorage.getItem('majorId');
      this.categoryId = localStorage.getItem('categoryId');
      this.LevelOneTab(i);
      if (this.$route.query.condition == 'false') {
        this.assitantType = 'VoiceUpgradeSkill';
        // this.$router.push({query: {}});
      }
    } else {
      this.LevelOneTab();
    }
    this.parent = this.$route.query.parent;
    this.getCustomerUser();
  },
  methods: {
    alertTrainNoStartOnline: function alertTrainNoStartOnline(trainTime) {
      this.$message({
        message: '该培训 ' + trainTime + ' 开始',
        type: 'warning',
        center: true,
        duration: 3500
      });
    },
    //(普通课程)点击学习点击重新学习
    goStudy: function goStudy(c) {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var courseId, courseType, assitantType;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              courseId = c.courseId;
              courseType = c.courseType;
              assitantType = c.assitantType;
              _this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
                courseId: courseId
              }).then(function (res) {
                var result = res.data;
                if (result.success) {
                  if (result.data.knowledgeRecordFullList.length != 1 && courseType != "Exam") {
                    var url = c.assitantJsonObj ? c.assitantJsonObj.url : null;
                    _this.$router.push({
                      path: '/train/Secondarylist',
                      query: {
                        courseId: courseId,
                        tjkId: _this.tjkId,
                        CourseLevel: 3,
                        sceneId: _this.sceneId,
                        trainId: _this.trainId,
                        urlLink: url
                      }
                    });
                  } else if (courseType == "Exam") {
                    _this.beginExam(c);
                    _this.examCourseId = courseId;
                  } else {
                    _this.$router.push({
                      path: "/vedioDetail",
                      query: {
                        courseId: courseId,
                        knowledgeSeq: result.data.knowledgeRecordFullList[0].knowledgeSeq,
                        CourseLevel: 3,
                        sceneId: _this.sceneId,
                        trainId: _this.trainId,
                        tjkId: _this.tjkId,
                        knowledgeId: result.data.knowledgeRecordFullList[0].knowledgeId
                      }
                    });
                  }
                } else {
                  _this.$alert(result.msg);
                }
              }, function (res) {
                _this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //切换一级tab
    oneClick: function oneClick(index, id, type) {
      this.Onetabtindex = index;
      this.majorId = id;
      this.assitantType = '';
      localStorage.removeItem('tabIndex');
      localStorage.removeItem('categoryId');
      localStorage.setItem('Onetabtindex', index);
      localStorage.setItem('CurrentMajorScope', type);
      this.tabIndex = 0;
      this.SecondaryTab(0);
    },
    //  一级导航tab
    LevelOneTab: function LevelOneTab(i) {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majorAll/showTabMajor").then(function (res) {
        var result = res.data;
        if (result.success) {
          _this2.tabOneList = result.data;
          if (localStorage.getItem('defaultShow')) {
            _this2.majorId = localStorage.getItem('majorId') ? localStorage.getItem('majorId') : _this2.tabOneList[0].id;
            _this2.SecondaryTab(i);
            //添加i修改两次锁定弹窗
          } else {
            _this2.tabOneList.forEach(function (item, index) {
              if (item.defaultShow == true) {
                localStorage.setItem('defaultShow', 1);
                _this2.majorId = item.id;
                _this2.Onetabtindex = index;
                _this2.SecondaryTab(index);
                //添加i修改两次锁定弹窗
                localStorage.setItem('tabIndex', 0);
                localStorage.setItem('Onetabtindex', index);
              }
            });
          }
        } else {
          _this2.$alert(result.msg);
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    //二级获得目录tab
    SecondaryTab: function SecondaryTab(i) {
      var _this3 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/courseCategory/queryListXlk", {
        majorId: this.majorId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          self.tabTwoList = result.data;
          self.categoryId = _this3.tabTwoList[0].categoryId;
          self.showAskingDoor = result.showAskingDoor;
          var needSetDefaultTab2Tmp = true;
          if (localStorage.getItem('needSetDefaultTab2') == 'false') {
            localStorage.removeItem('needSetDefaultTab2');
            needSetDefaultTab2Tmp = false;
          }
          var tabIndex = result.tabIndex;
          var categoryId = result.categoryId;
          if (needSetDefaultTab2Tmp == false && self.tabTwoList && self.$route.query.tabIndex) {
            var routeTabIndex = Number(self.$route.query.tabIndex);
            routeTabIndex = routeTabIndex > self.tabTwoList.length ? 0 : routeTabIndex;
            tabIndex = routeTabIndex;
            categoryId = self.tabTwoList[routeTabIndex].categoryId;
          }
          self.changeSecondaryTab(tabIndex, categoryId);
          var tabname = _this3.tabTwoList[0].categoryName;
          localStorage.setItem('majorId', _this3.majorId);
          if (localStorage.getItem('categoryId')) {
            self.categoryId = localStorage.getItem('categoryId');
          }
          if (localStorage.getItem('CurrentMajorScope') == 'PreworkOnlineExerciseDirect') {
            self.assitantType = 'PreworkOnlineExerciseDirect';
            localStorage.setItem('assitantType', 'PreworkOnlineExerciseDirect');
          }
        } else {
          self.$alert(result.msg);
          self.tabTwoList = [];
          self.courseList = [];
        }
      }, function (res) {
        _this3.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    //特殊弹窗点击报名（刚打开小助手弹报名窗）
    isspecial: function isspecial() {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majorAll/showTabMajor").then(function (res) {
        var result = res.data;
        if (result.success) {
          _this4.tabOneList = result.data;
          _this4.majorId = _this4.tabOneList[0].id;
          localStorage.setItem('majorId', _this4.majorId);
          _this4.specialtwotab();
        } else {
          _this4.$alert(result.msg);
        }
      }, function (res) {
        _this4.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    //特殊弹窗，小助手弹窗查询二级tab
    specialtwotab: function specialtwotab() {
      var _this5 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/courseCategory/queryListXlk", {
        majorId: this.majorId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this5.tabTwoList = result.data;
          _this5.tabIndex = 0;
          localStorage.setItem('tabIndex', 0);
          _this5.categoryId = _this5.tabTwoList[0].categoryId;
          localStorage.setItem('categoryId', _this5.categoryId);
          localStorage.setItem('tabname', _this5.tabTwoList[0].categoryName);
        } else {
          _this5.$alert(result.msg);
        }
      }, function (res) {
        _this5.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    /**
     * 点击二级tab
     * needSetDefaultTab2 是否需要默认的定位高亮，若是点击的一级tab，需要定位到合适的二级tab，这情况当做是需要定位
     * */
    changeSecondaryTab: function changeSecondaryTab(tabTwoIndex, categoryId) {
      var tabTwoObj = this.tabTwoList[tabTwoIndex];
      if (this.tabTwoList.length != 1) {
        this.courseList = [];
        this.assitantType = tabTwoObj.assitantType;
        this.tabIndex = tabTwoIndex;
        this.categoryId = categoryId;
        localStorage.setItem('categoryId', categoryId);
        localStorage.setItem('tabIndex', tabTwoIndex);
        var self = this;
        if (this.assitantType == 'VoiceUpgradeSkill') {
          this.getTrainList();
        } else if (this.assitantType == 'OnlineUpgradeSkill') {
          this.OnlinePromote();
        } else if (this.assitantType == 'TjCollegeYingxiao') {
          this.getTjCollegeTrainList('yingxiao');
        } else if (this.assitantType == 'FbtOperate') {} else {
          this.Lv3Courses();
        }
      } else if (this.tabTwoList.length == 1) {
        //路径下直接课程列表，如：【在线实操直通车】、【办公软件学习】
        this.Lv3Courses();
      }
    },
    /**
     * 三级课程
     * @param needSetDefaultTab2 手动tab切换，区别于默认自定位tab2，因为Lv3Courses里会根据末尾课程的结果 和 needSetDefaultTab2 联合决定是否强行定位到默认tab
     * */
    Lv3Courses: function Lv3Courses() {
      var _this6 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majors/queryCourseViewNewXlkCategoryId", {
        categoryId: this.categoryId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this6.courseList = result.data.courseViewList;
          _this6.curriculum = result.data;
          if (result.msg != null) {
            _this6.$alert(result.msg);
          }

          //如果tab末尾课程已通关，则自动定位到下一个 二级tab高亮(如 技能提升)
          // if(this.courseList && this.courseList.length>0 && needSetDefaultTab2 == true){
          //     var showNextTabTwo = self.courseList[self.courseList.length-1].passState == 'Passed';
          //     if(showNextTabTwo && self.tabIndex < self.tabTwoList.length-1){
          //         self.categoryId = self.tabTwoList[self.tabIndex+1].categoryId;
          //         self.tabIndex++;
          //         self.changeSecondaryTab(self.tabIndex, self.categoryId, self.tabTwoList[self.tabIndex], true);//这里可能要屏蔽
          //     }
          // }
        } else {
          if (result.msg != '课程记录列表不能为空') {
            _this6.$alert(result.msg); //因为需要查看课程列表所以屏蔽
            _this6.courseList = [];
            _this6.Onlinelist = [];
            _this6.cseList = [];
          }
        }
      }, function (res) {
        _this6.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    getCustomerUser: function getCustomerUser() {
      var _this7 = this;
      this.$http.get('/customer/action/currentUser/customerUser').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this7.tjkInfo = result.data;
        } else {
          _this7.$alert(result.msg);
        }
      }, function (response) {
        _this7.$alert('AJAX访问接口异常！');
      });
    },
    //在线技能提升
    OnlinePromote: function OnlinePromote() {
      var _this8 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/queryTrainListOnline").then(function (res) {
        var result = res.data;
        if (result.success) {
          _this8.Onlinelist = result.data.trainList;
          //若存在已完成，则则跳下一个
          // if(needSetDefaultTab2){
          //     for (var i of result.data.trainList) {
          //         if(i.trainFlag == 'exercise' && i.passState == 'passed' && self.tabIndex < self.tabTwoList.length-1){
          //             self.categoryId = self.tabTwoList[self.tabIndex+1].categoryId;
          //             self.tabIndex++;
          //             self.changeSecondaryTab(self.tabIndex, self.categoryId, self.tabTwoList[self.tabIndex], true);//这里可能要屏蔽
          //             break;
          //         }
          //     }
          // }
        } else {
          if (result.msg != '课程记录列表不能为空') {
            _this8.$alert(result.msg); //因为需要查看课程列表所以屏蔽
          }
        }
      }, function (res) {
        _this8.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    // 进入考试,
    beginExam: function beginExam(c) {
      var trainFlag = null;
      if (c.assitantType == 'fbtExamCourse') {
        trainFlag = 'fbtTrain';
      }
      if (localStorage.getItem('CurrentMajorScope') == 'PreworkOnlineExerciseDirect') {
        trainFlag = 'PreworkOnlineExerciseDirect'; //只要不是theory,就不会提示说，接下来学习下一阶段
        this.assitantType = 'PreworkOnlineExerciseDirect';
      }
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + c.courseId + '&trainFlag=' + trainFlag + '&assitantType=' + this.assitantType + '&tabIndex=' + this.tabIndex;
    },
    //报名页面进入场景页面
    // 点击签到
    signIn: function signIn(id, trainId) {
      var _this9 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkOnlineTrain/sign", {
        trainId: trainId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this9.sceneId = id;
          _this9.trainId = trainId;
          _this9.$router.push({
            path: '/train/SpecialCourses',
            query: {
              sceneId: _this9.sceneId,
              trainId: _this9.trainId,
              tjkId: _this9.tjkId
            }
          });
        } else {
          _this9.$alert(result.msg);
        }
      }, function (res) {
        _this9.$alert("AJAX请求接口异常（/preWorkOnlineTrain/sign）！");
      });
    },
    // 直播模式签到：签到成功后不跳转，给出反馈并原地切换为已签到
    liveSignIn: function liveSignIn(item) {
      var _this0 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkOnlineTrain/sign", {
        trainId: item.trainId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this0.$message({
            message: '签到成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this0.$set(item, 'sign', 'Yes');
        } else {
          _this0.$alert(result.msg);
        }
      }, function (res) {
        _this0.$alert("AJAX请求接口异常（/preWorkOnlineTrain/sign）！");
      });
    },
    // 重新学习
    regoscene: function regoscene(id, trainId) {
      this.sceneId = id;
      this.trainId = trainId;
      this.$router.push({
        path: '/train/SpecialCourses',
        query: {
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId,
          assitantType: this.assitantType
        }
      });
    },
    //点击报名
    goscene: function goscene(item) {
      this.addGroupDialog.show = true;
      this.addGroupDialog.tip = item.majorType == 'VOICE' ? '确认参加培训并加入培训群' : '确认参加培训并加入企业微信群', this.addGroupDialog.majorType = item.majorType;
      this.sceneId = item.sceneId;
      this.trainId = item.trainId;
      this.VoicePassState = item.passState;
      this.sign = item.sign;
      this.teamtalkGroupId = item.teamtalkGroupId;
      this.dimensionalimg = item.qqImg;
      debugger;
    },
    //在线————点击报名
    togoscene: function togoscene(item) {
      this.addGroupDialog.show = true;
      this.OnlinesignIn = true;
      this.OnlinetrainId = item.trainId;
      this.trainId = item.trainId;
      this.trainTitle = item.trainTitle;
      this.jumpGroupLink = item.groupLink;
      this.teamtalkGroupId = item.teamtalkGroupId;
    },
    //--在线点击测试
    gotest: function gotest(row) {
      if (row.trainFlag == 'theory' || row.trainFlag == 'exercise') {
        this.$router.push({
          path: '/train/SpecialCourses',
          query: {
            "sceneId": row.sceneId,
            assitantType: this.assitantType,
            trainFlag: row.trainFlag
          }
        });
      }
    },
    goThoryExamPage: function goThoryExamPage() {
      if (this.theoryRemainDialog.remain <= 0) {
        if (this.theoryRemainDialog.passState == 'passed') {
          this.$message({
            message: '今日次数已用完，请明日再来',
            type: 'warning',
            center: true,
            duration: 2500
          });
        } else {
          this.$message({
            message: '考核次数已用完，请报名下一场',
            type: 'warning',
            center: true,
            duration: 2500
          });
        }
        return;
      }
      window.location.href = '/tjkStudy/train/examDetail?trainFlag=theory&courseId=' + this.theoryRemainDialog.courseIdOfsceneId + '&assitantType=' + this.assitantType;
    },
    //--在线理论和实操点击签到
    GoOnlineSignIn: function GoOnlineSignIn(item) {
      var _this1 = this;
      if (item.trainFlag == 'exercise') {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkOnlineTrain/sign?", {
          trainId: item.trainId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            _this1.$message({
              message: '签到成功',
              type: 'success',
              center: true,
              duration: 1000
            });
            _this1.OnlinePromote();
          } else {
            _this1.$alert(result.msg);
          }
        }, function (res) {
          _this1.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        });
      } else if (item.trainFlag == 'theory') {
        this.$router.push({
          path: '/train/Sessions',
          query: {
            trainId: item.trainId,
            trainTitle: item.trainTitle,
            trainContent: item.trainContent
          }
        });
      }
    },
    //进入培训群qq群进入场景页面
    isenlist: function isenlist() {
      var _this10 = this;
      var self = this;
      if (this.OnlinesignIn) {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkOnlineTrain/applyTrain", {
          trainId: this.trainId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            _this10.dimensional = true;
            _this10.addGroupDialog.show = false;
            _this10.OnlinePromote();
          } else {
            _this10.$alert(result.msg);
          }
        }, function (res) {
          _this10.$alert("AJAX请求接口异常（/preWorkOnlineTrain/applyTrain）！");
        });
      } else if (this.addGroupDialog.majorType == 'VOICE') {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/applyTrainIntegrate", {
          trainId: this.trainId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            //加群二维码图片
            _this10.dimensional = true;
            _this10.addGroupDialog.show = false;
            _this10.dimensionalimg = result.data.qqImg; //这里再设置一次，是为了避免出现图片没加载出来的情况
            debugger;
            var mode = result.data.mode; //self-自学，live-直播
            //如果是自学模式,就直接刷新,跳小助手, 若是直播live模式,还要弹出q群二维码
            if (mode == 'self') {
              _this10.qqsceneId();
            }
          } else {
            _this10.$alert(result.msg);
          }
        }, function (res) {
          _this10.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
        });
      } else {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/applyTrain", {
          trainId: this.trainId,
          channel: 'assitant'
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            _this10.addGroupDialog.show = false;
            _this10.getTjCollegeTrainList('yingxiao');
          } else {
            _this10.$alert(result.msg);
          }
        }, function (res) {
          _this10.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
        });
      }
    },
    qqsceneId: function qqsceneId() {
      //判断是否是小助手，如是小助手，则跳 “消息”模块，判断有没有填写teamtalk群号，填了就跳
      this.dimensional = false;
      //刷新先
      if (this.OnlinesignIn) {
        this.OnlinePromote();
      } else {
        this.getTrainList();
      }
      if (this.teamtalkGroupId) {
        this.$http.get("http://127.0.0.1:26688/api/TjHawkeye/switchMenu?menu=\u6D88\u606F&id=".concat(this.teamtalkGroupId)).then(function (res) {});
      }
    },
    sign_upo: function sign_upo() {
      localStorage.setItem('trainState', 'no');
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=no';
    },
    sign_up: function sign_up() {
      localStorage.setItem('trainState', 'no');
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=yes';
    },
    // 去报名
    Gosignup: function Gosignup() {
      if (this.registration == null || 0) {
        window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=yes';
      }
    },
    handleClick: function handleClick(tab, event) {
      var _this11 = this;
      this.tabOneList.forEach(function (item, index) {
        if (tab.name == item.name) {
          _this11.majorId = item.id;
        }
      });
    },
    //在线客服-视频观看记录
    saveTjkTrainInfoOnline: function saveTjkTrainInfoOnline() {
      var _this12 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/assitantTrain/saveWebLoginAndAssitantDown", {
        tDisplayVideo: "Yes"
      }).then(function (res) {
        var result = res.data;
        if (result.success) {} else {
          _this12.$alert(result.msg);
        }
      }, function (res) {
        _this12.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    getTabIndex: function getTabIndex() {
      for (var i = 0; i < this.tabTwoList.length; i++) {
        if (this.tabTwoList[i].type == this.tabType) {
          return i;
          break;
        }
      }
    },
    changeTab: function changeTab(key, type, id) {
      if (key == 2 && this.issystem == false) {
        if (this.axx == false) {
          if (this.iskey == 0) {
            this.tabType = 'SystemOperation';
            this.tabIndex = 0;
            this.dialogVisible = true;
          } else if (this.iskey == 1) {
            this.tabType = 'TaojinCulture';
            this.tabIndex = 1;
            this.dialogVisible = true;
          }
        } else {
          if (this.iskey == 1) {
            this.tabType = 'SystemOperation';
            this.tabIndex = 0;
            this.dialogVisible = true;
          }
        }
      } else if (this.issystem == false) {
        if (type != "SystemOperation") {
          window.location.href = "/tjkStudy/train/index?type=TaojinCulture&tabMajorId=" + id + '&show=yes';
        } else {
          this.axx = true;
          this.$set(this, "tabIndex", key);
          this.$set(this, "tabType", type);
        }
      } else if (this.issystem == true) {
        this.$set(this, "tabIndex", key);
        this.$set(this, "tabType", type);
        if (type != "SystemOperation") {
          window.location.href = "/tjkStudy/train/index?type=" + type + "&tabMajorId=" + id + '&show=yes';
        }
      }
    },
    //获取技能提升列表
    getTrainList: function getTrainList() {
      var _this13 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/queryTrainListVoice", {}).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this13.cseList = result.data.trainList;
          _this13.newPeopleBadgeId = result.data.newPeopleBadgeId;
          _this13.needFinish = result.data.needFinish;
          _this13.tjkId = result.data.tjkId;
          var _iterator = _createForOfIteratorHelper(self.trainList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var i = _step.value;
              if (i.passState == 'signTimeOut' || i.passState == 'examUnPassed' && i.passState != 'signTimeOut' || i.passState == 'noExam') {
                _this13.registration = 0;
              } else if (i.passState == 'passed') {
                _this13.registration = 1;
                break;
              } else if (i.passState != 'noJoin' && i.sign != 'Yes' && i.passState != 'signTimeOut' && i.passState != 'examUnPassed' && i.passState != 'noExam' || i.sign == 'Yes' && i.passState != 'signTimeOut' && i.passState != 'unPassed' && i.passState != 'examUnPassed' && i.passState != 'noExam' && i.passState != 'signTimeOut') {
                _this13.registration = 1;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          localStorage.setItem('registration', _this13.registration);
          _this13.trainState = result.data.trainState;
          if (localStorage.getItem('trainState') == 'no') {
            _this13.trainState = null;
            localStorage.setItem('trainState', '');
          }
          _this13.content = result.data.content;

          // //若存在已完成，则则跳下一个
          // for (var i of self.cseList) {
          //     if(needSetDefaultTab2 && i.passState == 'passed' && self.tabIndex < self.tabTwoList.length-1){
          //         self.categoryId = self.tabTwoList[self.tabIndex+1].categoryId;
          //         self.tabIndex++;
          //         self.changeSecondaryTab(self.tabIndex, self.categoryId, self.tabTwoList[self.tabIndex], true);//这里可能要屏蔽
          //         break;
          //     }
          // }
        } else {
          _this13.$alert(result.msg);
        }
      }, function (res) {
        _this13.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！");
      });
    },
    //获取淘金大学技能提升列表，type代表类型，如 营销
    getTjCollegeTrainList: function getTjCollegeTrainList(type) {
      var _this14 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/queryTjCollegeWeb", {}).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this14.cseList = result.data.trainList;
          _this14.newPeopleBadgeId = result.data.newPeopleBadgeId;
          _this14.needFinish = result.data.needFinish;
          _this14.tjkId = result.data.tjkId;
          var _iterator2 = _createForOfIteratorHelper(_this14.trainList),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var i = _step2.value;
              if (i.passState == 'signTimeOut' || i.passState == 'examUnPassed' && i.passState != 'signTimeOut' || i.passState == 'noExam') {
                _this14.registration = 0;
              } else if (i.passState == 'passed') {
                _this14.registration = 1;
                break;
              } else if (i.passState != 'noJoin' && i.sign != 'Yes' && i.passState != 'signTimeOut' && i.passState != 'examUnPassed' && i.passState != 'noExam' || i.sign == 'Yes' && i.passState != 'signTimeOut' && i.passState != 'unPassed' && i.passState != 'examUnPassed' && i.passState != 'noExam' && i.passState != 'signTimeOut') {
                _this14.registration = 1;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          localStorage.setItem('registration', _this14.registration);
          _this14.trainState = result.data.trainState;
          if (localStorage.getItem('trainState') == 'no') {
            _this14.trainState = null;
            localStorage.setItem('trainState', '');
          }
          _this14.content = result.data.content;
        } else {
          _this14.$alert(result.msg);
        }
      }, function (res) {
        _this14.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！");
      });
    },
    //调用小助手
    getHawkeye: function getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
      }, function (response) {});
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this15 = this;
      var data = {
        exerciseType: 'ASSITANT',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {} else {
          _this15.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this15.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    applyTask: function applyTask() {
      var _this16 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/badge/applyTaskApp').then(function (res) {
        var result = res.data;
        if (result.success) {
          _this16.callHawkeye();
        } else {
          _this16.$alert(result.msg);
        }
      }, function (res) {
        loading.close();
        _this16.isDisable = false;
        _this16.$alert("网络繁忙，请稍后重试！");
      });
    },
    goCompleteExperience: function goCompleteExperience(c) {
      //跳转到 经验选择
      this.$router.push({
        path: '/train/fbtExperienceChoose',
        query: {
          tabIndex: this.tabIndex,
          courseId: c.courseId
        }
      });
    },
    /*async */toStudy: function toStudy(c) {
      var _this17 = this;
      var self = this;
      if (c.assitantType == 'urlLink') {
        var url = c.assitantJsonObj ? c.assitantJsonObj.url : null;
        this.$router.push({
          path: '/train/Secondarylist',
          query: {
            courseId: c.courseId,
            tjkId: this.tjkId,
            CourseLevel: 3,
            urlLink: url
          }
        });
      } else if (c.assitantType == 'AssitantSpecialRobotExam') {
        if (c.status == 'NoTheoryBadge') {
          this.$alert('您还不符合测试条件，请前往淘金云客服APP，点击"培训"，完成"语音客服培训"后，才能测试。');
          return;
        }
        this.applyTask();
        this.addRecord('START', 3);
      } else if (c.assitantType == 'WordInputExam') {
        this.$router.push({
          path: '/train/OnInline',
          query: {
            page: 'dazi',
            courseId: c.courseId,
            type: c.assitantType,
            knowledgeSeq: 1,
            theoryBadge: this.curriculum.theoryBadge //理论实操完成情况
          }
        });
      } else {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
          courseId: c.courseId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            if (c.assitantType == 'fbt' || result.data.knowledgeRecordFullList.length != 1 && c.courseType != "Exam") {
              //记录类型，传到对练系统，记录结果存到college里
              var collegeType = null;
              if (c.assitantType == 'allSaleExam' || c.assitantType == 'fbt') {
                collegeType = c.assitantType;
              }
              _this17.$router.push({
                path: '/train/Secondarylist',
                query: {
                  courseId: c.courseId,
                  collegeType: collegeType
                }
              });
            } else if (c.courseType == "Exam") {
              // var trainFlag = '电商平台制度考核' == c.courseName ? null : 'theory';
              _this17.beginExam(c);
              _this17.examCourseId = c.courseId;
            } else {
              var knowledgeId = result.data.knowledgeRecordFullList[0].knowledgeId;
              _this17.$router.push({
                path: "/vedioDetail",
                query: {
                  courseId: c.courseId,
                  knowledgeSeq: result.data.knowledgeRecordFullList[0].knowledgeSeq,
                  knowledgeId: knowledgeId
                }
              });
            }
          } else {
            _this17.$alert(result.msg);
          }
        }, function (res) {
          _this17.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        });
      }
    },
    //调用小助手引导功能
    callHawkeye: function callHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
      }, function (response) {});
    },
    //技能提升-报名
    joinTrain: function joinTrain(trainId, groupLink) {
      var _this18 = this;
      var self = this;
      this.$confirm('是否确认报名？', '提示', {
        confirmButtonText: '确认并加群',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this18.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/applyTrainIntegrate", {
          trainId: trainId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            self.getTrainList();
            //加群二维码图片
            _this18.dimensional = true;
            _this18.jumpGroupLink = result.data.groupLink;
          } else {
            _this18.$alert(result.msg);
          }
        }, function (res) {
          _this18.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
        });
      }).catch(function () {});
    },
    //场景列表切换到场次列表
    toTrainList: function toTrainList() {
      window.location.href = "/tjkStudy/train/index?type=" + this.tabType + "&tabMajorId=" + this.tabMajorId + "&show=yes";
    }
  }
};

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voice_vue__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voice_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voice_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voice_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe166578_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voice_vue__ = __webpack_require__(1544);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1542)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe166578"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voice_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe166578_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/voice.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fe166578", Component.options)
  } else {
    hotAPI.reload("data-v-fe166578", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isDisable: false,
      toptab: '',
      //语音or在线
      stepactive: 1,
      //当前进度
      clickFlag: 1,
      //进度条是否可点击
      leadId: '',
      videoindex: [],
      //视频是否全部看完
      tabCurrent: 'first',
      //当前标签页
      status: '',
      //考核状态
      retry: '',
      //是否可重新测试
      result: '',
      //未通过原因
      miaoone: 480,
      //倒计时480s
      timerone: null,
      miaotwo: 180,
      //倒计时180s
      timertwo: null,
      isShowStepOne: false,
      isShowStepTwo: false,
      isShowStepThird: false,
      isShowStepFour: false,
      isSmallpop: '',
      isokisSmallpop: 0,
      Finished: '',
      //任务指南是否完成
      type: '',
      //跳转任务指南参数type
      tabMajorId: '',
      //任务指南参数id
      tabList: [],
      //跳任务指南（参数）
      isAllComplete: 0,
      registration: 0 //判断是否报名
    };
  },
  created: function created() {
    this.isokisSmallpop = 0;
    this.getCurrentStep();
    this.getTabList();
    if (localStorage.getItem('Finished')) {
      this.Finished = localStorage.getItem('Finished');
    }
    console.log(this.Finished);
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#stoptip-' + _this.tabCurrent).show();
    }, false);
  },
  methods: {
    sign_up: function sign_up() {
      // console.log(this.tabMajorId,951)
      localStorage.setItem('trainState', 'no');
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=yes';
    },
    // 去报名
    Gosignup: function Gosignup() {
      if (this.registration == null || 0) {
        window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=yes';
      }
    },
    //获取技能提升列表
    getTrainList: function getTrainList() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/queryTrainListWeb", {
        majorId: this.tabMajorId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this2.trainList = result.data.trainList;
          _this2.newPeopleBadgeId = result.data.newPeopleBadgeId;
          _this2.needFinish = result.data.needFinish;
          var _iterator = _createForOfIteratorHelper(_this2.trainList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;)
            //  this.trainList.forEach((item) => 
            {
              var i = _step.value;
              if (i.passState == 'signTimeOut' || i.passState == 'examUnPassed' && i.passState != 'signTimeOut' || i.passState == 'noExam') {
                _this2.registration = 0;
              } else if (i.passState == 'passed') {
                _this2.registration = 1;
                break;
              } else if (i.passState != 'noJoin' && i.sign != 'Yes' && i.passState != 'signTimeOut' && i.passState != 'examUnPassed' && i.passState != 'noExam' || i.sign == 'Yes' && i.passState != 'signTimeOut' && i.passState != 'unPassed' && i.passState != 'examUnPassed' && i.passState != 'noExam' && i.passState != 'signTimeOut') {
                _this2.registration = 1;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          ;
          localStorage.setItem('registration', _this2.registration);
          _this2.content = result.data.content;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！");
      });
    },
    //获取淘金文化列表
    getCourseList: function getCourseList() {
      var _this3 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryCourseViewNewXlk', {
        majorId: this.tabMajorId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this3.courseList = result.data.data.courseViewList;

          //判断是否全部不完成

          _this3.courseList.forEach(function (item) {
            if (item.passState == 'Passed') {
              _this3.isAllComplete++;
            }
          });
          if (_this3.isAllComplete == _this3.courseList.length) {
            _this3.Finished = 'yes';
            console.log(_this3.courseList, 2546);
          }
        } else {
          _this3.$alert(result.msg);
        }
      }, function (res) {
        _this3.$alert("AJAX请求接口异常（/majors/queryCourseViewNewXlk）！");
      });
    },
    //点击重新学习
    relearn: function relearn() {
      this.clickFlag = 1;
    },
    // 查询跳转条件
    getTabList: function getTabList() {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majorAll/showTab").then(function (res) {
        var result = res.data;
        if (result.success) {
          _this4.tabList = result.data;
          _this4.type = _this4.tabList[1].type;
          _this4.tabMajorId = _this4.tabList[1].id;
          _this4.getCourseList();
          console.log(_this4.tabMajorId);
        }
      });
    },
    //点击去成跳任务指南
    goguide: function goguide() {
      window.location.href = "/tjkStudy/train/index?type=" + this.type + '&tabMajorId=' + this.tabMajorId;
    },
    //点击刷新审核结果
    Smallpop: function Smallpop() {
      this.$alert(this.isSmallpop, '', {
        confirmButtonText: '确定'
        // callback: action => {
        //   this.$message({
        //     type: 'info',
        //     message: `action: ${ action }`
        //   });
        // }
      });
    },
    //tab切换
    handleClick: function handleClick(event) {
      var _this5 = this;
      document.getElementById(this.tabCurrent).play();
      //初始化其他视频
      $('.js-video video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this5.tabCurrent).show();
      }, false);
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //下一关
    studyNext: function studyNext(next) {
      $('#stoptip-' + this.tabCurrent).hide();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    //进入测试须知
    studyNextLast: function studyNextLast() {
      this.stepactive++;
      this.clickFlag++;
      this.saveStep(2);
      if (this.stepactive === 2) {
        this.countdownOne(480);
      }
    },
    //进度条切换
    showStep: function showStep(val) {
      this.clickFlag = val;
    },
    //查询当前进度
    getCurrentStep: function getCurrentStep() {
      var _this6 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/badge/queryTjkTrainInfo').then(function (res) {
        var result = res.data;
        if (result.success) {
          _this6.stepactive = result.data.step ? parseInt(result.data.step) : 1;
          _this6.clickFlag = result.data.step ? parseInt(result.data.step) : 1;
          _this6.leadId = result.data.leadId ? result.data.leadId : '';
          _this6.status = result.data.status;
          _this6.retry = result.data.retry;
          _this6.result = result.data.result;
          _this6.toptab = result.data.intent;
          _this6.isSmallpop = result.msg;
          console.log(_this6.isSmallpop, 111);
          if (_this6.status == 'Passed') {}
          if (_this6.isSmallpop !== '' && _this6.isokisSmallpop == 0) {
            _this6.isokisSmallpop = 1;
          } else {
            _this6.Smallpop();
          }
          if (_this6.clickFlag == 1) {
            _this6.addRecord('START', 1);
            console.log(1);
          }
          //测试须知倒计时
          if (_this6.stepactive === 2 && _this6.clickFlag === 2) {
            _this6.countdownOne(480);
            console.log(2);
          }
          //开始测试提示层
          if (_this6.stepactive === 3 && _this6.clickFlag === 3 && (_this6.status == 'AlreadyTheoryBadge' || _this6.status == 'NoTheoryBadge' || _this6.status == 'Failed' && _this6.retry == 'true')) {
            _this6.isShowStepOne = true;
            console.log(3);
          }
        } else {
          _this6.$alert(result.msg);
          console.log(4);
        }
      }, function (res) {
        console.log(5);
        _this6.$alert("AJAX请求接口异常（/badge/queryTjkTrainInfo）！");
      });
    },
    //保存当前进度
    saveStep: function saveStep(step) {
      var _this7 = this;
      var data = {
        'step': step,
        'leadId': this.leadId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/train/view/saveTrainLead', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this7.leadId = result.data;
        } else {
          _this7.$alert(result.msg);
        }
      }, function (res) {
        _this7.$alert("AJAX请求接口异常（/train/view/saveTrainLead）！");
      });
    },
    //我已知晓
    goNext: function goNext() {
      if (this.stepactive === 2) {
        this.isShowStepOne = true;
      }
      this.stepactive = 3;
      this.clickFlag = 3;
      this.saveStep(3);
      this.addRecord('START', 2);
      // this.closeStep();
    },
    showStepTwo: function showStepTwo() {
      this.isShowStepOne = false;
      this.isShowStepTwo = true;
    },
    showStepThird: function showStepThird() {
      this.isShowStepTwo = false;
      this.isShowStepThird = true;
    },
    showStepFour: function showStepFour() {
      this.isShowStepThird = false;
      this.isShowStepFour = true;
    },
    closeStep: function closeStep() {
      this.isShowStepFour = false;
      this.countdownTwo(180);
    },
    //开始测试
    startExam: function startExam() {
      if (this.status == 'NoTheoryBadge') {
        this.$alert('您还不符合测试条件，请前往淘金云客服APP，点击"培训"，完成"语音客服培训"后，才能测试。');
        return;
      }
      this.applyTask();
      this.addRecord('START', 3);
    },
    //重新测试
    replyBegin: function replyBegin() {
      this.applyTask();
      this.addRecord('START', 4);
    },
    applyTask: function applyTask() {
      var _this8 = this;
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.isDisable = true;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/badge/applyTaskApp').then(function (res) {
        var result = res.data;
        if (result.success) {
          _this8.status = result.data.status;
          _this8.callHawkeye();
        } else {
          _this8.$alert(result.msg);
        }
        loading.close();
        _this8.isDisable = false;
      }, function (res) {
        loading.close();
        _this8.isDisable = false;
        _this8.$alert("AJAX请求接口异常（/badge/applyTaskApp）！");
      });
    },
    //调用小助手引导功能
    callHawkeye: function callHawkeye() {
      var _this9 = this;
      this.$http.get('http://127.0.0.1:26789/api/npg/start').then(function (response) {
        var result = response.data;
        if (result.success) {} else {
          _this9.$alert(result.msg);
        }
      }, function (response) {});
    },
    //倒计时480秒
    countdownOne: function countdownOne(endTime) {
      var self = this;
      self.timerone = setInterval(function () {
        endTime--;
        if (endTime >= 1) {
          var sec = parseInt(endTime);
          self.miaoone = sec;
        } else {
          clearInterval(self.timerone);
          self.miaoone = 0;
        }
      }, 1000);
    },
    //倒计时180秒
    countdownTwo: function countdownTwo(endTime) {
      var self = this;
      self.timertwo = setInterval(function () {
        endTime--;
        if (endTime >= 1) {
          var sec = parseInt(endTime);
          self.miaotwo = sec;
        } else {
          clearInterval(self.timertwo);
          self.miaotwo = 0;
        }
      }, 1000);
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this0 = this;
      var data = {
        exerciseType: 'ASSITANT',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {} else {
          _this0.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this0.$message({
          message: "AJAX请求接口异常（/simulationExercise/addRecord）！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      examVisible: false,
      exam: {
        examDescription: null,
        //测试须知
        examDuration: null,
        //测试时间
        questionNum: null,
        //测试题目
        remainingExamTimes: null,
        //测试机会
        passScore: null //通关分数
      }
    };
  },
  props: ['courseId', 'visible', 'tabMajorId', 'majorId', 'type', 'isListPage', 'parent', 'id'],
  watch: {
    visible: function visible() {
      this.examVisible = this.visible;
      this.getExamDetail(this.courseId);
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    //获取考试弹出层信息
    getExamDetail: function getExamDetail(courseId) {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/examining/getExamDetail', {
        'courseId': courseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this.exam.examDescription = result.data.examDescription;
          _this.exam.examDuration = result.data.examDuration;
          _this.exam.questionNum = result.data.questionNum;
          _this.exam.remainingExamTimes = result.data.remainingExamTimes;
          _this.exam.passScore = result.data.passScore;
        } else {
          _this.$alert(result.msg);
        }
      }, function (res) {
        _this.$alert("AJAX请求接口异常（/examining/getExamDetail）！");
      });
    },
    returnCourseList: function returnCourseList() {
      this.$emit('callback', false);
      if (!this.isListPage) {
        window.location.href = '/tjkStudy/train/childCourseList?id=' + this.id + '&type=' + this.type + '&majorId=' + this.majorId + '&tabMajorId=' + this.tabMajorId;
      }
    },
    //开始考试
    beginExam: function beginExam() {
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + this.courseId + '&majorId=' + this.majorId + '&tabMajorId=' + this.tabMajorId + '&type=' + this.type + '&score=' + this.exam.passScore + '&parent=' + this.parent + '&id=' + this.id;
    }
  }
};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TrainList',
  props: ['categoryId'],
  data: function data() {
    return {
      cardList: []
    };
  },
  mounted: function mounted() {
    this.getCardList();
  },
  watch: {
    categoryId: function categoryId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getCardList();
      }
    }
  },
  methods: {
    getCardList: function getCardList() {
      var _this = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majors/queryFbtOperateMajors", {
        categoryId: this.categoryId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          self.cardList = result.data;
        }
      }, function (res) {
        _this.$alert("请求接口异常");
      });
    },
    handleCardClick: function handleCardClick(item) {
      // 这里可以添加路由跳转或其他逻辑
      this.$router.push({
        name: 'fbtCourseList',
        query: {
          categoryId: item.categoryId,
          tjkId: item.tjkId
        }
      });
    }
  }
};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
var _examDialog = _interopRequireDefault(__webpack_require__(402));
__webpack_require__(1556);
var _vueVideoPlayer = __webpack_require__(1557);
var _knowledgeDialog = _interopRequireDefault(__webpack_require__(1571));
var _answerResultDialog = _interopRequireDefault(__webpack_require__(1575));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    examDialog: _examDialog.default,
    videoPlayer: _vueVideoPlayer.videoPlayer,
    knowledgeDialog: _knowledgeDialog.default,
    answerResultDialog: _answerResultDialog.default
  },
  data: function data() {
    return {
      largerVisible: false,
      //查看上传图片之，大图
      largerUrl: null,
      //查看上传图片之，大图
      fbtType: this.$route.query.fbtType,
      id: this.$route.query.id,
      //技能提升-场景id
      courseId: this.$route.query.courseId,
      //课程id
      type: this.$route.query.type,
      //上级tab类型
      tabMajorId: this.$route.query.tabMajorId,
      //上级tab的id
      majorId: this.$route.query.majorId,
      //
      tjkId: this.$route.query.tjkId,
      //
      lastCourseId: null,
      //上一课程id
      nextCourseId: null,
      //下一课程id
      readTimeSeconds: null,
      //pdf最少阅读时间
      nextExamCourse: false,
      //下一课是否测试课程
      knowledge: {},
      curMajor: {
        majorScope: null
      },
      unlock: false,
      //下一课是否可点击
      height: 0,
      //pdf高度
      examVisible: false,
      //测试考试弹出层
      parent: this.$route.query.parent,
      //父级菜单
      timer: null,
      timerTimeValue: null,
      //界面倒计时数字显示
      knowledgeSeq: this.$route.query.knowledgeSeq,
      //知识点提交需要的参数
      currency: false,
      //知识点通用弹窗控制
      nextobject: {},
      //储存知识点接口数据
      nextknowledge: {},
      //下一个知识点
      nextcourseId: null,
      //下一个知识点或课程courseId
      tabIndex: null,
      //记录二级tab的位置
      CourseLevel: this.$route.query.CourseLevel,
      //知识点跳课程层级
      guidePopMsg: '',
      //弹窗提示
      knowledgestate: null,
      //弹窗文字类型
      knowledgename: '',
      //当前知识点或课程名称
      nextknowledgename: '',
      //下一个知识点或课程名称
      Coursestate: '',
      //接下跳转的课程状态
      nowCoursestate: '',
      //当前的课程状态
      nowCoursestatetext: '',
      //当前的课程状态的弹窗文字
      categoryName: '',
      //当前tab名字
      tabstate: null,
      //根据tab位置判断最后一个知识点的弹窗文字状态
      nextcategoryName: '',
      //下一个tab名字
      knowledgeId: this.$route.query.knowledgeId,
      //知识点id
      dazhiJump: false,
      //打字认证跳系统实操
      isReture: this.$route.query.isReture,
      //是否是服务台跳回
      timeUpdateInterval: null,
      playPositions: [],
      enableDrag: false,
      knowledgeDialogObj: {
        visible: false,
        knowledgeId: '',
        playSecondsAt: '',
        courseId: ''
      },
      answerResultDialogObj: {
        visible: false,
        isRight: false
      },
      playerOptions: {
        autoplay: false,
        controls: true,
        sources: []
      }
    };
  },
  created: function created() {
    var _this = this;
    this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/videoDragTjk/enableDrag').then(function (res) {
      _this.enableDrag = res.data.data;
    });
  },
  mounted: function mounted() {
    this.height = document.body.clientHeight - 150;
    this.getCourseDetail();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeUpdateInterval);
  },
  methods: {
    handleChildEventMethod: function handleChildEventMethod(data) {
      this.largerVisible = true;
      this.largerUrl = data;
    },
    goonOrNot: function goonOrNot(isRight) {
      var player = this.$refs.videoPlayer.player;
      if (isRight) {
        player.play();
      } else {
        var currentTime = Math.floor(player.currentTime()) + 1; // 取整当前播放时间
        var idx = this.playPositions.indexOf(currentTime);
        if (idx != -1) {
          if (idx == 0) {
            this.seekVideo(0);
          } else {
            this.seekVideo(this.playPositions[idx - 1]);
          }
          player.play();
        }
      }
    },
    knowledgeResult: function knowledgeResult(isRight) {
      this.answerResultDialogObj = {
        visible: +new Date(),
        isRight: isRight
      };
    },
    onPlayerPlay: function onPlayerPlay() {
      var _this2 = this;
      if (this.enableDrag) {
        document.querySelector(".vjs-progress-control").style.pointerEvents = "auto";
      }
      var player = this.$refs.videoPlayer.player;
      this.timeUpdateInterval = setInterval(function () {
        var currentTime = Math.floor(player.currentTime()) + 1; // 取整当前播放时间
        if (_this2.playPositions && _this2.playPositions.length > 0) {
          var idx = _this2.playPositions.indexOf(currentTime);
          if (idx != -1) {
            player.pause();
            _this2.knowledgeDialogObj = {
              visible: +new Date(),
              knowledgeId: _this2.knowledge.knowledgeId,
              courseId: _this2.knowledge.courseId,
              playSecondsAt: currentTime
            };
          }
        }
      }, 1000);
    },
    onPlayerEnded: function onPlayerEnded() {
      this.submitKnowledge();
    },
    onPause: function onPause() {
      clearInterval(this.timeUpdateInterval);
    },
    seekVideo: function seekVideo(time) {
      this.$refs.videoPlayer.player.currentTime(time);
    },
    goindex: function goindex() {
      if (this.fbtType) {
        this.$router.back();
        return;
      }
      this.$router.push({
        path: '/train/index'
      });
    },
    // 返回按钮
    isreturn: function isreturn() {
      var _this3 = this;
      if (this.curMajor.majorScope == 'FbtOperate') {
        this.$router.back();
        return;
      }
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.courseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this3.isReture == 'yes') {
            _this3.$router.go(-1);
          } else {
            if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
              _this3.$router.push({
                path: '/train/Secondarylist',
                query: {
                  courseId: _this3.courseId,
                  CourseLevel: _this3.$route.query.CourseLevel,
                  sceneId: _this3.$route.query.sceneId,
                  trainId: _this3.$route.query.trainId,
                  tjkId: _this3.$route.query.tjkId,
                  assitantTjkId: _this3.$route.query.tjkId
                }
              });
            } else if (_this3.CourseLevel == 3) {
              _this3.$router.push({
                path: '/train/SpecialCourses',
                query: {
                  sceneId: _this3.$route.query.sceneId,
                  trainId: _this3.$route.query.trainId,
                  tjkId: _this3.$route.query.tjkId,
                  assitantTjkId: _this3.$route.query.tjkId
                }
              });
            } else {
              _this3.tabIndex = localStorage.getItem('tabIndex');
              _this3.$router.push({
                path: '/train/index',
                query: {
                  tabIndex: _this3.tabIndex,
                  condition: true //判断是否是基础知识点跳课程
                }
              });
            }
          }
        } else {
          _this3.$alert(result.msg);
        }
      }, function (res) {
        _this3.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    initPdf: function initPdf(url) {
      var options = {
        pdfOpenParams: {
          navpanes: 0,
          toolbar: 0,
          statusbar: 0,
          view: "FitV",
          pagemode: "thumbs",
          page: 1
        },
        forcePDFJS: true,
        PDFJS_URL: ( false ? '' : '/tjkStudy') + '/static/pdfjs-2.6.347/web/viewer.html'
      };
      if (_pdfobject.default.supportsPDFs) {
        $('#pdf_viewer').height(this.height);
        _pdfobject.default.embed(url, "#pdf_viewer", options);
      }
    },
    getCourseDetail: function getCourseDetail() {
      var _this4 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/course/getGuideDialog', {
        'courseId': this.courseId,
        'knowledgeId': this.knowledgeId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this4.knowledge = result.data.current;
          _this4.curMajor = result.data.curMajor;
          if (_this4.knowledge.knowledgeType == 'Video') {
            _this4.playPositions = result.data.playPositions; //知识点跳知识点
            _this4.playerOptions.sources = [{
              type: "video/mp4",
              src: _this4.knowledge.videoUrl
            }];
          }
          if (result.data.playSecondsAt) {
            setTimeout(function () {
              _this4.$refs.videoPlayer.player.currentTime(result.data.playSecondsAt);
            }, 500);
          }
          _this4.nextobject = result.data;
          if (_this4.nextobject.next) {
            _this4.knowledgeId = _this4.nextobject.next.knowledgeId;
          }
          if (_this4.nextobject.next && !_this4.nextobject.nextCourse && !_this4.nextobject.nextCourse) {
            self.knowledgestate = 1; //知识点跳知识点
            self.knowledgeId = self.nextobject.next.knowledgeId;
            self.knowledgename = self.nextobject.current.title;
            self.nextknowledgename = self.nextobject.next.title;
            console.log('===' + JSON.stringify(_this4.nextobject));
          } else if (!_this4.nextobject.nextCategory && _this4.nextobject.nextCourse) {
            self.knowledgestate = 2; //知识点跳课程
            self.knowledgename = self.nextobject.currentCourse.courseName;
            self.nextknowledgename = self.nextobject.nextCourse.courseName;
            if (_this4.nextobject.currentCourse.courseType == 'Exam') {
              _this4.nowCoursestate = 'Exam';
              _this4.nowCoursestatetext = '测试';
            } else if (_this4.nextobject.currentCourse.courseType == 'Integrate' && _this4.nextobject.currentCourse.assitantType) {
              if (_this4.nextobject.currentCourse.assitantType == 'CallOutAbilityCheck') {
                _this4.nowCoursestate = 'Exam';
                _this4.nowCoursestatetext = '测试';
              } else {
                _this4.nowCoursestate = 'Practice';
                _this4.nowCoursestatetext = '练习';
              }
            } else if (_this4.nextobject.currentCourse.courseType == 'Integrate' && !_this4.nextobject.currentCourse.assitantType) {
              _this4.nowCoursestate = 'Study';
              _this4.nowCoursestatetext = '学习';
            }
            if (_this4.nextobject.nextCourse.courseType == 'Exam' || _this4.nextobject.nextCourse.assitantType == 'AssitantSpecialRobotExam') {
              _this4.Coursestate = 'Exam';
            } else if (_this4.nextobject.nextCourse.courseType == 'Integrate' && _this4.nextobject.nextCourse.assitantType) {
              _this4.Coursestate = 'Practice';
            } else if (_this4.nextobject.nextCourse.courseType == 'Integrate' && !_this4.nextobject.nextCourse.assitantType) {
              _this4.Coursestate = 'Study';
            }
          } else if (_this4.nextobject.nextCategory) {
            _this4.knowledgestate = 2;
            _this4.categoryName = _this4.nextobject.currentCategory.categoryName;
            var ismajorId = localStorage.getItem('majorId');
          } else if (!_this4.nextobject.next && !_this4.nextobject.nextCourse && !_this4.nextobject.nextCategory) {
            _this4.knowledgestate = 2;
            _this4.categoryName = _this4.nextobject.currentCategory.categoryName;
          }
          _this4.$nextTick(function () {
            if (this.knowledge.knowledgeType == 'Pdf') {
              this.initPdf(this.knowledge.pdfUrl);
              if (!this.unlock) {
                this.countdown(this.knowledge.readTimeSeconds);
              }
            } else if (this.knowledge.knowledgeType == 'Video') {}
          });
        } else {
          _this4.$alert(result.msg);
        }
      }, function (res) {
        _this4.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      });
    },
    //pdf倒计时
    countdown: function countdown(endTime) {
      var self = this;
      self.timerTimeValue = '学习倒计时：' + self.formatCountdown(endTime);
      self.timer = setInterval(function () {
        endTime--;
        self.timerTimeValue = '学习倒计时：' + self.formatCountdown(endTime);
        if (endTime <= 0) {
          self.unlock = true;
          self.submitKnowledge();
          clearInterval(self.timer);
          self.timerTimeValue = '';
        }
      }, 1000);
    },
    //将剩余秒数格式化为 分:秒
    formatCountdown: function formatCountdown(totalSeconds) {
      if (!totalSeconds || totalSeconds < 0 || isNaN(totalSeconds)) {
        totalSeconds = 0;
      }
      totalSeconds = Math.floor(totalSeconds);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };
      return pad(minutes) + ':' + pad(seconds);
    },
    //视频/pdf学习完成后提交
    submitKnowledge: function submitKnowledge() {
      var _this5 = this;
      var data = {
        'courseId': this.courseId,
        'knowledgeSeq': this.knowledge.knowledgeSeq,
        'knowledgeId': this.knowledge.knowledgeId,
        'assitant': true
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/course/submitKnowledgeXlk', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this5.currency = true;
          var ismajorId = localStorage.getItem('majorId');
          _this5.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/courseCategory/queryListXlk", {
            majorId: ismajorId
          }).then(function (res) {
            var result = res.data;
            if (result.success) {
              var relist = result.data;
              if (_this5.nextobject.nextCategory) {
                if (_this5.nextobject.nextCategory == null) {
                  _this5.tabstate = 1;
                } else {
                  _this5.tabstate = 2;
                  _this5.nextobject.nextCategory.assitantType;
                  relist.forEach(function (item, index) {
                    if (item.assitantType == _this5.nextobject.nextCategory.assitantType) {
                      if (_this5.nextobject.nextCategory.assitantType == 'OnlineUpgradeSkill') {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        if (_this5.nextobject.theoryBadge == false) {
                          _this5.nextcategoryName = '理论培训';
                        } else {
                          _this5.nextcategoryName = '实操培训';
                        }
                      } else if (_this5.nextobject.nextCategory.assitantType == 'VoiceUpgradeSkill') {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        _this5.nextcategoryName = '语音技能提升';
                      } else if (_this5.nextobject.nextCategory.assitantType == 'SysOperate') {
                        _this5.dazhiJump = true;
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        localStorage.setItem('categoryId', item.categoryId);
                      } else {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        localStorage.setItem('categoryId', item.categoryId);
                        _this5.nextcategoryName == item.categoryName;
                        _this5.categoryName = _this5.nextobject.currentCategory.categoryName;
                      }
                    }
                  });
                }
              } else if (!_this5.nextobject.next && !_this5.nextobject.nextCourse && !_this5.nextobject.nextCategory) {
                _this5.knowledgestate = 2;
                _this5.categoryName = _this5.nextobject.currentCategory.categoryName;
                _this5.tabstate = 1;
              }
            } else {
              _this5.$alert(result.msg);
            }
          }, function (res) {
            _this5.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
          });
        } else {
          _this5.$alert(result.msg);
        }
      }, function (res) {
        _this5.$alert("AJAX请求接口异常（/course/submitKnowledge）！");
      });
    },
    lastStudy: function lastStudy() {
      clearInterval(this.timer);
      window.location.href = '/tjkStudy/vedioDetail?courseId=' + this.lastCourseId + '&id=' + this.id + '&type=' + this.type + '&tabMajorId=' + this.tabMajorId + '&majorId=' + this.majorId + '&parent=' + this.parent;
    },
    nextStudy: function nextStudy() {
      clearInterval(this.timer);
      if (this.unlock) {
        window.location.href = '/tjkStudy/vedioDetail?courseId=' + this.nextCourseId + '&id=' + this.id + '&type=' + this.type + '&tabMajorId=' + this.tabMajorId + '&majorId=' + this.majorId + '&parent=' + this.parent;
      }
    },
    endStudy: function endStudy() {
      clearInterval(this.timer);
      if (this.parent == 'jineng') {
        this.$router.push({
          path: '/train/childCourseList',
          query: {
            id: this.id,
            type: this.type,
            tabMajorId: this.tabMajorId,
            majorId: this.majorId
          }
        });
      } else {
        this.$router.push({
          path: '/train/index',
          query: {
            type: this.type,
            tabMajorId: this.tabMajorId
          }
        });
      }
    },
    showExamDialog: function showExamDialog() {
      if (!this.unlock) {
        return false;
      }
      this.examVisible = true;
    },
    closeDialog: function closeDialog(val) {
      this.examVisible = val;
    },
    //点击前往下一个课程或知识点
    determine: function determine() {
      var self = this;
      if (!!this.nextobject.nextCourse && this.nextobject.nextCourse.courseType == 'Exam') {
        this.nextcourseId = this.nextobject.nextCourse.courseId; //进这儿了
        if ('fbtExamCourse' == this.nextobject.nextCourse.assitantType) {
          window.location.href = '/tjkStudy/train/examDetail?trainFlag=fbtTrain&assitantType=fbtTrain&courseId=' + this.nextcourseId;
        } else {
          this.beginExam();
        }
      }
      //若是淘系培训的，则跳到
      var nextC = this.nextobject.nextCourse;
      var assitantType = nextC ? nextC.assitantType : null;
      if (assitantType === "qianniuplugin") {
        this.$router.replace({
          name: 'fbtQianniu',
          query: {
            courseId: nextC.courseId
          }
        });
        return;
      } else if (assitantType === "qianniupluginexam") {
        this.$router.replace({
          name: 'fbtQianniuExam',
          query: {
            courseId: nextC.courseId
          }
        });
        return;
      } else if (assitantType === "jingmaiplugin") {
        this.$router.replace({
          name: 'fbtJingmai',
          query: {
            courseId: nextC.courseId
          }
        });
        return;
      } else if (assitantType === "jingmaipluginexam") {
        this.$router.replace({
          name: 'fbtJingmaiExam',
          query: {
            courseId: nextC.courseId
          }
        });
        return;
      } else if (assitantType === "feigeplugin") {
        this.$router.replace({
          name: 'fbtDoudian',
          query: {
            courseId: nextC.courseId
          }
        });
        return;
      } else if (assitantType === "feigepluginexam") {
        this.$router.replace({
          name: 'fbtDoudianExam',
          query: {
            courseId: nextC.courseId
          }
        });
        return;
      }
      if (this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
        var assitantType = this.nextobject.next.assitantType;
        if (assitantType == 'qianniu' || assitantType == 'qianniuexam' || assitantType == 'workorderjushuitan' || assitantType == 'workorderjushuitanexam' || assitantType == 'jingmai' || assitantType == 'jingmaiexam' || assitantType == 'primary' || assitantType == 'middle' || assitantType == 'wpsexcel' || assitantType == 'wpsexcelexam' || assitantType == 'sougouinput' || assitantType == 'sougouinputexam' || assitantType == 'feige' || assitantType == 'feigeexam') {
          this.$router.push({
            path: '/train/OnInline',
            query: {
              type: this.nextobject.next.assitantType,
              courseId: this.nextobject.next.courseId,
              knowledgeSeq: this.nextobject.next.knowledgeSeq,
              knowledgeId: this.nextobject.next.knowledgeId
            }
          });
        } else if (assitantType == 'fbt') {
          this.$router.replace({
            path: '/train/FBT/jingmaiChat',
            query: {
              sceneId: this.nextobject.next.courseId
            }
          });
        } else {
          this.nextcourseId = this.nextobject.next.courseId;
          //若下一知识点是下载【没有页面，会白屏的】，跳到知识点列表页面
          if (this.nextobject.next.assitantType == 'downLink') {
            window.location.href = "/tjkStudy/train/Secondarylist?courseId=" + self.courseId + '&CourseLevel=' + self.CourseLevel + '&sceneId=' + self.$route.query.sceneId;
          } else {
            window.location.href = "/tjkStudy/vedioDetail?courseId=" + this.nextcourseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&CourseLevel=' + this.CourseLevel + '&sceneId=' + this.$route.query.sceneId + '&assitantTjkId=' + this.$route.query.tjkId + '&tjkId=' + this.$route.query.tjkId + '&trainId=' + this.$route.query.trainId + '&knowledgeId=' + this.knowledgeId;
          }
        }
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse && this.nextobject.next) {
        this.nextcourseId = this.nextobject.nextCourse.courseId;
        this.toStudy();
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse) {
        this.nextcourseId = this.nextobject.nextCourse.courseId; //进这儿了
        this.gotoStudy();
      } else if (this.nextobject.nextCategory) {
        this.$router.push({
          path: '/train/index'
        });
      } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCourse) {
        this.$router.push({
          path: '/train/index'
        });
      }
    },
    // 进入考试
    beginExam: function beginExam(courseId) {
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + this.nextcourseId;
    },
    toStudy: function toStudy() {
      var _this6 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.nextcourseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
            _this6.$router.push({
              path: '/train/Secondarylist',
              query: {
                courseId: _this6.nextcourseId
              }
            });
          } else if (_this6.CourseLevel == 3) {
            _this6.$router.push({
              path: '/train/SpecialCourses',
              query: {
                sceneId: _this6.$route.query.sceneId,
                trainId: _this6.$route.query.trainId,
                tjkId: _this6.$route.query.tjkId,
                assitantTjkId: _this6.$route.query.tjkId
              }
            });
          } else if (result.data.knowledgeRecordFullList.length == 1) {
            window.location.href = '/tjkStudy/vedioDetail?courseId=' + _this6.nextcourseId + '&knowledgeSeq=' + _this6.nextobject.next.knowledgeSeq + '&CourseLevel=' + _this6.CourseLevel + '&sceneId=' + _this6.$route.query.sceneId + '&assitantTjkId=' + _this6.$route.query.tjkId + '&tjkId=' + _this6.$route.query.tjkId + '&trainId=' + _this6.$route.query.trainId + '&knowledgeId=' + _this6.knowledgeId;
          }
        } else {
          _this6.$alert(result.msg);
        }
      }, function (res) {
        _this6.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    gotoStudy: function gotoStudy() {
      var _this7 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.nextcourseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
            _this7.$router.push({
              path: '/train/Secondarylist',
              query: {
                courseId: _this7.nextcourseId
              }
            });
          } else if (_this7.CourseLevel == 3) {
            _this7.$router.push({
              path: '/train/SpecialCourses',
              query: {
                sceneId: _this7.$route.query.sceneId,
                trainId: _this7.$route.query.trainId,
                tjkId: _this7.$route.query.tjkId,
                assitantTjkId: _this7.$route.query.tjkId
              }
            });
          } else {
            _this7.tabIndex = localStorage.getItem('tabIndex');
            _this7.$router.push({
              path: '/train/index',
              query: {
                tabIndex: _this7.tabIndex,
                condition: true //判断是否是基础知识点跳课程
              }
            });
          }
        } else {
          _this7.$alert(result.msg);
        }
      }, function (res) {
        _this7.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// SingleChoice MultipleChoice TrueOrFalse
var _default = exports.default = {
  name: 'knowledgeDialog',
  props: ['show', 'knowledgeId', 'playSecondsAt', 'courseId'],
  watch: {
    show: function show(val) {
      if (val) {
        this.init();
      } else {
        this.visible = false;
      }
    }
  },
  data: function data() {
    return {
      randomKnowledgeId: null,
      visible: false,
      knowledge: {},
      question: null,
      choices: [],
      rightAnswer: null,
      btnDisabled: true,
      remainingTime: 60,
      interval: null
    };
  },
  methods: {
    picturePreview: function picturePreview(imgUrl) {
      // 查看大图
      this.$emit('handleChildEvent', imgUrl);
    },
    startCountdown: function startCountdown() {
      var _this = this;
      this.interval = setInterval(function () {
        _this.remainingTime -= 1;
        if (_this.remainingTime <= 0) {
          clearInterval(_this.interval);
          _this.$emit('result', false);
          _this.visible = false;
        }
      }, 1000);
    },
    submit: function submit() {
      clearInterval(this.interval);
      var answer;
      if (this.question.questionType == 'TrueOrFalse' || this.question.questionType == 'SingleChoice') {
        this.choices.forEach(function (item) {
          if (item.checked) {
            answer = item.value;
          }
        });
      } else if (this.question.questionType == 'MultipleChoice') {
        answer = this.choices.filter(function (item) {
          return item.checked;
        }).map(function (item) {
          return item.value;
        }).join(',');
      }
      if (answer == this.rightAnswer) {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/submitKnowledgeXlk", {
          knowledgeId: this.randomKnowledgeId,
          courseId: this.courseId,
          assitant: 'Yes'
        }).then(function (res) {});
        this.$emit('result', true);
      } else {
        this.$emit('result', false);
      }
      this.visible = false;
    },
    type: function type() {
      if (this.question.questionType == 'TrueOrFalse') {
        return '【判断题】';
      } else if (this.question.questionType == 'SingleChoice') {
        return '【单选题】';
      } else if (this.question.questionType == 'MultipleChoice') {
        return '【多选题】';
      }
    },
    updateChecked: function updateChecked(index) {
      var _this2 = this;
      if (this.question.questionType == 'TrueOrFalse' || this.question.questionType == 'SingleChoice') {
        this.choices.map(function (item) {
          item.checked = false;
        });
      }
      this.choices[index].checked = !this.choices[index].checked;
      this.btnDisabled = true;
      this.choices.forEach(function (item) {
        if (item.checked) {
          _this2.btnDisabled = false;
        }
      });
    },
    init: function init() {
      var _this3 = this;
      this.remainingTime = 60;
      this.visible = true;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getQuesKnowledgeXlk", {
        knowledgeId: this.knowledgeId,
        playSecondsAt: this.playSecondsAt
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this3.knowledge = result.data;
          _this3.randomKnowledgeId = _this3.knowledge.knowledgeId;
          _this3.question = result.data.question;
          if (_this3.question.questionType == 'TrueOrFalse') {
            _this3.choices = [{
              value: true,
              content: '正确',
              checked: false
            }, {
              value: false,
              content: '错误',
              checked: false
            }];
            _this3.rightAnswer = _this3.question.questionContent.rightAnswer;
          } else if (_this3.question.questionType == 'SingleChoice' || _this3.question.questionType == 'MultipleChoice') {
            _this3.choices = Object.keys(_this3.question.questionContent.choices).map(function (key) {
              return {
                value: key,
                content: key + '：' + _this3.question.questionContent.choices[key],
                checked: false
              };
            });
            if (_this3.question.questionType == 'SingleChoice') {
              _this3.rightAnswer = _this3.question.questionContent.rightAnswer;
            } else if (_this3.question.questionType == 'MultipleChoice') {
              _this3.rightAnswer = _this3.question.questionContent.rightAnswer.join(',');
            }
          }
          _this3.startCountdown();
        } else {
          _this3.$alert(result.msg);
        }
      });
    }
  }
};

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAFF0lEQVRoQ9WbTV7iMBTAE8qAGxFugDeQEwzsxI1wAvUGw25kFsJicHY6J9A5gbgRdzonGG4w3ADEjTLSzHuhYFvSJk0/qNn4+0mavH/fR15eUkoSao3OuPjyQoqZDCkyZpRxWsbmE/gzuv9RGiUkBqFxTGTB7VEje0gYqQIaAhYlcyH8hFDaJyb7PTgv9OOQLTJghHx9NaqUkkNGSEMBUIWnD2Pd3vcK1yqdVfqEBuag/7JnYJ/HEUGK5ab0cvB9u6UC5ddHG5ib7cxowABnMAH3yQTaBDTeCqNxLeD9r+MqzWQvwDf3EoAUTEGHYFFdHT8PDFw/ffoCgQW1KgtCsb8LRlj3vrfTCTKRMjCa8GxmXIBJoa+mpzHyCJquqQqkBMwD08y4gkEx+qaw0SEz35oq67kUGPy1TDPGQ4KBSfeFTpg5r8igfYGttfUG0pOqrhQJPzca9Aq72svSQXt6lTqflb1BiU97atiKxrD0fMDGWGtwvnMpklwIXD+dNsCMMUhtfOnRft2MNEXrtBi4/fxnc0mFNqL7wQn4c8n9zzXgD23KLjqIPyfuNNQBbK23oN3EcuPI1Okx0JqWHcD77acOJTxtTG0Dga9Nc/6LUqNIMvQz5NRf/IR1p58rYEu7f1McqCZQTDhxB6L99vQYIDDAejVHQrICtiLzTUpVK4RdylpvT1FRZU/ZbcvUO3B7irBpzJV9YRESlPUgyQb7ELGb2JcDp9icpbAcWKZhqJXlc/Pdfqc04cApNWc12MX+XJoRLpeoBfC35wtZtEvYtzHQ4Hbv0W/eIMUIjO53vcLJAlhuEknygtnNa3e90lABVqpZ2xh8TU4b8Ag0W5PtaTWzQQcwmPimm1rVQhOWw0HgKlGrooHr2AabGmzYTBBcpUIP2uM9RgzMnwM2KJVS8siY+QTp6BE8XA44gNWdDvO5txouGX7Ph4XFsdFdqEJqti4HVBXy+XnTLqSeQGqwkVVeIOOiOmswmoYoigaDlsNGXRrGtRh9GE4ReFVSsdHhoLdd8eqsBC2wEPd4UcPy8aEKQq20cqxIi92ElQT7877QirBx1MF50NIA5m9Kdq4jgsZsJ5ebt/wCVJxFfwhau8vEAzUcpGCnlA3ZoTcNixYImRYcX0Or6xXt1KFpZif/6a27Kc1a7saL9GE3D0rQaKYbhkVmvieOYnuoBO0VFOP0WcecVtyxFwCCRGq3/FrQC9gsLImxH6yv6lqrEk8E2Uwg6IRPJZ0lHlSXVoq5bqdK0AnDwir6flPAXaYNY9ZLfF9oa7OCBcNygGQnTFdxmXah5cgK8ULoDcA6tIuMsR61oClliMlv1DGaPYr9LpfAxZbVyuVPa4dpEflyGBOM7FnRLR+P41JJJT8ykWIdaATarbgTHiFw8C1jrIJrDS46Kl3zYfvIKaxVq4P73MsUang5MtSr03re5Akv25X5AieY+qlrz7envGzkC4xjp/igTSuflwLzhITfxsuCecee5GtqWq2u7Ru0RDOn0qcVamR2FiUN2x+IMP3U1KbtMYjGskqKe5LAwJaJY2kX71WUw0utNYL2zXgt4NWypXgYrYUkfggOyVk3nzevZUczXnOGAk4QHDTKfm7lzEtd0KWskQA7wAk9jOi6MV55gENxdgsHdn3ZmbGqFUUK7EhN4YKq9Q1TVdHXFx9qETLEb5W2cvN+WG2KXkJswO7JFmdFpIyf4TFKipQx+CTPHMKneZNcjozigBMB/wfZ0+vp2PyfIgAAAABJRU5ErkJggg=="

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  name: 'answerResultDialog',
  props: ['show', 'isRight'],
  watch: {
    show: function show(val) {
      if (val) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  methods: {
    submit: function submit() {
      this.$emit('goonOrNot', this.isRight);
      this.visible = false;
    }
  }
};

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      //技能提升-场景id
      courseId: this.$route.query.courseId,
      //课程id
      type: this.$route.query.type,
      //上级tab类型
      tabMajorId: this.$route.query.tabMajorId,
      //上级tab的id
      majorId: this.$route.query.majorId,
      //
      lastCourseId: null,
      //上一课程id
      nextCourseId: null,
      //下一课程id
      readTimeSeconds: null,
      //pdf最少阅读时间
      nextExamCourse: false,
      //下一课是否测试课程
      urlLink: this.$route.query.urlLink,
      isReture: this.$route.query.isReture //是否是服务台跳回
    };
  },
  components: {},
  created: function created() {
    this.urlLink = this.$route.query.urlLink;
  },
  mounted: function mounted() {
    this.urlLink = this.$route.query.urlLink;
  },
  methods: {
    // 返回按钮
    isreturn: function isreturn() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.courseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this.isReture == 'yes') {
            _this.$router.go(-1);
          } else {
            if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
              _this.$router.push({
                path: '/train/Secondarylist',
                query: {
                  courseId: _this.courseId,
                  CourseLevel: _this.$route.query.CourseLevel,
                  sceneId: _this.$route.query.sceneId,
                  trainId: _this.$route.query.trainId,
                  tjkId: _this.$route.query.tjkId,
                  assitantTjkId: _this.$route.query.tjkId
                }
              });
            } else if (_this.CourseLevel == 3) {
              _this.$router.push({
                path: '/train/SpecialCourses',
                query: {
                  sceneId: _this.$route.query.sceneId,
                  trainId: _this.$route.query.trainId,
                  tjkId: _this.$route.query.tjkId,
                  assitantTjkId: _this.$route.query.tjkId
                }
              });
            } else {
              _this.tabIndex = localStorage.getItem('tabIndex');
              _this.$router.push({
                path: '/train/index',
                query: {
                  tabIndex: _this.tabIndex,
                  condition: true //判断是否是基础知识点跳课程
                }
              });
            }
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (res) {
        _this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    }
  }
};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zoomImg = _interopRequireDefault(__webpack_require__(300));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      courseId: this.$route.query.courseId,
      //课程id
      majorId: this.$route.query.majorId,
      //技能提升-场景-课程id
      assitantType: this.$route.query.assitantType,
      //场景id
      passScore: null,
      //通关分数
      paperQuestion: [],
      examRecordId: '',
      endTime: '',
      time: '',
      showImg: false,
      imgSrc: '',
      num: [],
      savelist: [],
      list: [],
      //保存时的结果集转换的一维数组，用作答题卡
      completeDialogVisible: false,
      //考完试点提交弹窗（及格）
      showExamError: false,
      //显示 错题集开关
      score: null,
      //考试分数
      state: '',
      //考试是否通过（状态）
      times: null,
      //剩余考试次数
      Coursename: '',
      //当前课程名称
      nextobject: {},
      //储存当前课程接口返回
      nextCoursename: '',
      //下一个课程名称
      Coursestate: '',
      //下一个课程的类型（英文）
      Coursestatename: '',
      //下一个课程的类型（中文）
      categoryName: '',
      //当前tab名字
      nextcategoryName: '',
      //下一个tab名字
      tabstate: null,
      //tab状态
      fbtBadge: null,
      //fbtBadge是否获得，bool
      nextcourseId: null,
      //查询下一个知识点id
      timer: null,
      tabIndex: null,
      //当前所在tab位置
      huizhang: '',
      //徽章名字
      Graduation: this.$route.query.Graduation,
      //是不是结业考试
      theory: this.$route.query.theory,
      //在线理论跳考试
      knowledgestate: null,
      //弹窗文字类型：：【'jumpToKnowledge'-知识点跳知识点 | 'jumpToCourse'-知识点跳课程】
      knowledgename: '',
      //当前知识点或课程名称
      dazhiJump: false,
      //打字认证跳系统实操
      randomNumbers: [],
      trainFlag: this.$route.query.trainFlag,
      //判断是不是理论跳转考试
      sceneId: this.$route.query.sceneId,
      trainId: this.$route.query.trainId,
      tjkId: this.$route.query.tjkId
    };
  },
  components: {
    'zoom-img': _zoomImg.default
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    if (this.assitantType == 'OnlineUpgradeSkill') {
      if (!window.myTaojinWebBrower && !this.$route.query.ht) {
        alert('请在小助手中参加考试！');
        window.location.href = '/tjkStudy/train/index';
        return;
      }
      this.$http.post('http://local.itaojin.cn:26688/api/TjHawkeye/checkRemoteSoftware').then(function (response) {
        var result = response.data;
        if (!!result.data) {
          alert("\u57F9\u8BAD\u8FC7\u7A0B\u4E2D,\u4E0D\u80FD\u5F00\u542F".concat(result.data, "\u8F6F\u4EF6,\u8BF7\u5173\u95ED\u4E4B\u540E\u518D\u7EE7\u7EED\u8FDB\u884C\u8003\u8BD5\u3002"));
          window.location.href = '/tjkStudy/train/index';
        } else {
          _this.getExam();
        }
      }, function (res) {
        _this.getExam();
      });
    } else {
      this.getExam();
    }
  },
  watch: {
    paperQuestion: function paperQuestion() {
      for (var i = 0; i < this.paperQuestion.length; i++) {
        var xti = [];
        var numlength = parseInt(this.num.length);
        for (var j = 0; j < this.paperQuestion[i].questionRecordFullList.length; j++) {
          this.num.push(j);
          if (this.paperQuestion[i].questionRecordFullList[j].answerRecord.questionType == 'SingleChoice' || this.paperQuestion[i].questionRecordFullList[j].answerRecord.questionType == 'TrueOrFalse' || this.paperQuestion[i].questionRecordFullList[j].answerRecord.questionType == 'ShortAnswer') {
            var temp = {
              'num': numlength + j + 1,
              'examRecordId': this.paperQuestion[i].questionRecordFullList[j].examRecordId,
              'questionRecordId': this.paperQuestion[i].questionRecordFullList[j].questionRecordId,
              'sequence': this.paperQuestion[i].questionRecordFullList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionRecordFullList[j].tjkAnswer != null ? this.paperQuestion[i].questionRecordFullList[j].tjkAnswer : ''
            };
          } else {
            var temp = {
              'num': numlength + j + 1,
              'examRecordId': this.paperQuestion[i].examRecordId,
              'questionRecordId': this.paperQuestion[i].questionRecordFullList[j].questionRecordId,
              'sequence': this.paperQuestion[i].questionRecordFullList[j].sequence,
              'tjkAnswerString': this.paperQuestion[i].questionRecordFullList[j].tjkAnswer != null ? this.paperQuestion[i].questionRecordFullList[j].tjkAnswer : []
            };
          }
          xti.push(temp);
        }
        this.savelist.push(xti);
      }
      this.list = [].concat.apply([], this.savelist);
    }
  },
  methods: {
    //点击我知道了
    isreturn: function isreturn() {
      this.completeDialogVisible = false, this.$router.back();
    },
    //报名或参加下一个tab
    goindex: function goindex() {
      this.$router.replace({
        path: '/train/index'
      });
    },
    //报名或参加下一个tab
    goUpdateExp: function goUpdateExp() {
      this.$router.replace({
        path: '/train/fbtExperienceChoose?tabIndex=' + this.$route.query.tabIndex
      });
    },
    //点击继续（学习，练习，测试）
    determine: function determine() {
      if (this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
        this.nextcourseId = this.nextobject.next.courseId;
        window.location.href = "/tjkStudy/vedioDetail?courseId=" + this.nextcourseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&CourseLevel=' + this.CourseLevel + '&sceneId=' + this.$route.query.sceneId + '&assitantTjkId=' + this.$route.query.tjkId + '&tjkId=' + this.$route.query.tjkId + '&trainId=' + this.$route.query.trainId + '&knowledgeId=' + this.knowledgeId;
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse && this.nextobject.next) {
        this.nextcourseId = this.nextobject.nextCourse.courseId;
        this.toStudy();
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse) {
        this.nextcourseId = this.nextobject.nextCourse.courseId;
        this.gotoStudy();
      } else if (this.nextobject.nextCategory) {
        this.$router.replace({
          path: '/train/index'
        });
      } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCourse) {
        this.$router.replace({
          path: '/train/index'
        });
      }
    },
    gotoStudy: function gotoStudy() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.nextcourseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
            _this2.$router.replace({
              path: '/train/Secondarylist',
              query: {
                courseId: _this2.nextcourseId
              }
            });
          } else if (_this2.CourseLevel == 3) {
            _this2.$router.replace({
              path: '/train/SpecialCourses',
              query: {
                sceneId: _this2.$route.query.sceneId,
                trainId: _this2.$route.query.trainId,
                tjkId: _this2.$route.query.tjkId,
                assitantTjkId: _this2.$route.query.tjkId
              }
            });
          } else {
            _this2.tabIndex = localStorage.getItem('tabIndex');
            _this2.$router.replace({
              path: '/train/index',
              query: {
                tabIndex: _this2.tabIndex,
                condition: true //判断是否是基础知识点跳课程
              }
            });
          }
        } else {
          if (result.msg != null && result.msg != '') {
            _this2.$alert(result.msg);
          }
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    toStudy: function toStudy() {
      var _this3 = this;
      console.log(this.CourseLevel, '状态');
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.nextcourseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
            _this3.$router.replace({
              path: '/train/Secondarylist',
              query: {
                courseId: _this3.nextcourseId
              }
            });
          } else if (_this3.CourseLevel == 3) {
            _this3.$router.replace({
              path: '/train/SpecialCourses',
              query: {
                sceneId: _this3.$route.query.sceneId,
                trainId: _this3.$route.query.trainId,
                tjkId: _this3.$route.query.tjkId,
                assitantTjkId: _this3.$route.query.tjkId
              }
            });
          } else if (result.data.knowledgeRecordFullList.length == 1) {
            window.location.href = '/tjkStudy/vedioDetail?courseId=' + _this3.nextcourseId + '&knowledgeSeq=' + _this3.nextobject.next.knowledgeSeq + '&CourseLevel=' + _this3.CourseLevel + '&sceneId=' + _this3.$route.query.sceneId + '&assitantTjkId=' + _this3.$route.query.tjkId + '&tjkId=' + _this3.$route.query.tjkId + '&trainId=' + _this3.$route.query.trainId + '&knowledgeId=' + _this3.knowledgeId;
          }
        } else {
          if (result.msg != null && result.msg != '') {
            _this3.$alert(result.msg);
          }
        }
      }, function (res) {
        _this3.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    //考试页面查看下一个课程
    seecurriculum: function seecurriculum() {
      var _this4 = this;
      var data = {
        'courseId': this.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/course/getGuideDialog', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.knowledge = result.data.current;
          _this4.fbtBadge = result.data.fbtBadge;
          _this4.nextobject = result.data;
          if (_this4.nextobject.next) {
            _this4.knowledgeId = _this4.nextobject.next.knowledgeId;
          }
          if (_this4.nextobject.next && !_this4.nextobject.nextCourse && !_this4.nextobject.nextCategory) {
            _this4.knowledgestate = 'jumpToKnowledge'; //知识点跳知识点
            _this4.knowledgeId = _this4.nextobject.next.knowledgeId;
            _this4.knowledgename = _this4.nextobject.current.title;
          } else if (!_this4.nextobject.nextCategory && _this4.nextobject.nextCourse) {
            _this4.knowledgestate = 'jumpToCourse'; //知识点跳课程
            _this4.knowledgename = _this4.nextobject.currentCourse.courseName;
            if (_this4.nextobject.nextCourse.courseType == 'Exam' || _this4.nextobject.nextCourse.assitantType == 'AssitantSpecialRobotExam') {
              _this4.Coursestate = 'Exam';
            } else if (_this4.nextobject.nextCourse.courseType == 'Integrate' && _this4.nextobject.nextCourse.assitantType) {
              _this4.Coursestate = 'Practice';
            } else if (_this4.nextobject.nextCourse.courseType == 'Integrate' && !_this4.nextobject.nextCourse.assitantType) {
              _this4.Coursestate = 'Study';
            }
          } else if (_this4.nextobject.nextCategory) {
            _this4.knowledgestate = 'jumpToCourse';
            _this4.categoryName = _this4.nextobject.currentCategory.categoryName;
          } else if (!_this4.nextobject.next && !_this4.nextobject.nextCourse && !_this4.nextobject.nextCategory) {
            _this4.knowledgestate = 'jumpToCourse';
          }
          var ismajorId = localStorage.getItem('majorId');
          _this4.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/courseCategory/queryListXlk", {
            majorId: ismajorId
          }).then(function (res) {
            var result = res.data;
            if (result.success) {
              var relist = result.data;
              if (!_this4.nextobject.next && !_this4.nextobject.nextCourse && !_this4.nextobject.nextCategory) {
                _this4.knowledgestate = 'jumpToCourse';
                _this4.categoryName = _this4.nextobject.currentCategory.categoryName;
                _this4.tabstate = 'noNextTab';
              } else if (_this4.nextobject.nextCategory) {
                if (_this4.nextobject.nextCategory == null) {} else {
                  _this4.tabstate = 'hasNextTab';
                  _this4.nextobject.nextCategory.assitantType;
                  relist.forEach(function (item, index) {
                    if (item.assitantType == _this4.nextobject.nextCategory.assitantType) {
                      if (_this4.nextobject.nextCategory.assitantType == 'OnlineUpgradeSkill') {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        if (_this4.nextobject.theoryBadge == false) {
                          _this4.nextcategoryName = '理论培训';
                        } else {
                          _this4.nextcategoryName = '实操培训';
                        }
                      } else if (_this4.nextobject.nextCategory.assitantType == 'VoiceUpgradeSkill') {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        _this4.nextcategoryName = '语音技能提升';
                      } else if (_this4.nextobject.nextCategory.assitantType == 'SysOperate') {
                        _this4.dazhiJump = true;
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        localStorage.setItem('categoryId', item.categoryId);
                      } else {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        localStorage.setItem('categoryId', item.categoryId);
                        _this4.categoryName = _this4.nextobject.currentCategory.categoryName;
                        _this4.nextcategoryName == item.categoryName;
                      }
                    }
                  });
                }
              }
            } else {
              if (result.msg != null && result.msg != '') {
                _this4.$alert(result.msg);
              }
            }
          }, function (res) {
            _this4.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
          });
        } else {
          if (result.msg != null && result.msg != '') {
            _this4.$alert(result.msg);
          }
        }
      }, function (response) {
        _this4.$alert('AJAX请求接口异常（/examining/startExam）！');
      });
    },
    replaceNToBr: function replaceNToBr(str) {
      var reg = new RegExp("\n", "g");
      return str.replace(reg, "<br/>");
    },
    getExam: function getExam() {
      var _this5 = this;
      var data = {
        'courseId': this.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/examining/startExam', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this5.paperQuestion = result.data.groupRecordList;
          _this5.examRecordId = result.data.examRecordId;
          _this5.passScore = result.data.passScore;
          if (_this5.endTime == '') _this5.endTime = result.data.examRemainingTime;
          _this5.countdown(_this5.endTime);
          _this5.randomNumbers = _this5.getRandomIntegers(_this5.endTime, 3);
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('AJAX请求接口异常（/examining/startExam）！');
      });
    },
    countdown: function countdown(endTime) {
      var self = this;
      self.timer = setInterval(function () {
        endTime--;
        if (endTime >= 0) {
          var sec = parseInt(endTime);
          var min = 0;
          var hour = 0;
          if (sec > 60) {
            min = parseInt(sec / 60);
            sec = parseInt(sec % 60);
            if (min > 60) {
              hour = parseInt(min / 60);
              min = parseInt(min % 60);
            }
          }
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (hour > 0) {
            self.time = "".concat(hour, ":").concat(min, ":").concat(sec);
          } else {
            self.time = "".concat(min, ":").concat(sec);
          }
          if (endTime == 300) {
            self.open();
          }
        } else {
          clearInterval(self.timer);
          self.time = '时间到';
          self.saveExam();
        }
      }, 1000);
    },
    getRandomIntegers: function getRandomIntegers(n, count) {
      var randomNumbers = new Set();
      while (randomNumbers.size < count) {
        var randomNumber = Math.floor(Math.random() * (n - 1)) + 1;
        randomNumbers.add(randomNumber);
      }
      return Array.from(randomNumbers);
    },
    //考试时间提示框
    open: function open() {
      var h = this.$createElement;
      this.$notify({
        title: '',
        message: h('i', {
          style: 'color: red'
        }, '离自动交卷还有5分钟，请注意答题时间'),
        duration: 5000
      });
    },
    //保存考试
    saveExam: function saveExam(type) {
      var _this6 = this;
      var arry = JSON.parse(JSON.stringify(this.list));
      for (var i = 0; i < arry.length; i++) {
        if (typeof arry[i].tjkAnswerString != 'string') {
          for (var j = 0; j < arry[i].tjkAnswerString.length; j++) {
            var reg = /^[A-Za-z]+$/;
            if (arry[i].tjkAnswerString[j] == null) arry[i].tjkAnswerString[j] = '';
            if (reg.test(arry[i].tjkAnswerString[j])) arry[i].tjkAnswerString[j] = arry[i].tjkAnswerString[j].toUpperCase();
          }
          arry[i].tjkAnswerString = JSON.stringify(arry[i].tjkAnswerString);
        }
      }
      var data = {
        'courseId': this.courseId,
        'examRecordId': this.examRecordId,
        'tjkAnswerString': arry,
        'badgeGetRemark': this.assitantType == 'PreworkOnlineExerciseDirect' ? '老客服路径获得' : null
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/examining/submitCourseExam', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this6.score = result.data.score;
          _this6.times = result.data.remainingExamTimes;
          _this6.state = result.data.examPassState;
          _this6.showExamError = result.data.showExamError;
          if (result.data.badge) {
            _this6.huizhang = result.data.badge.name;
          }
          if (_this6.theory == 'theory') {
            _this6.completeDialogVisible = true;
          } else {
            if (_this6.state == 'passed') {
              _this6.seecurriculum();
            }
            _this6.completeDialogVisible = true;
          }
        } else {
          if (result.msg != null && result.msg != '') {
            _this6.$alert(result.msg);
          }
        }
      }, function (response) {
        _this6.$alert('AJAX请求接口异常（/examining/submitCourseExam）！');
      });
    },
    //点击继续测试
    again: function again() {
      this.completeDialogVisible = false;
      if (this.trainFlag == 'theory' && this.times == 0) {
        this.$message({
          message: '已无剩余测试次数',
          type: 'warning',
          center: true,
          duration: 3000
        });
        this.tabIndex = localStorage.getItem('tabIndex');
        this.$router.replace({
          path: '/train/index',
          query: {
            tabIndex: this.tabIndex
          }
        });
        return;
      }
      if (this.trainFlag == 'tjcollege' && this.times == 0) {
        if (this.times == 0) {
          this.$message({
            message: '已无剩余测试次数',
            type: 'warning',
            center: true,
            duration: 3000
          });
        }
        this.$router.replace({
          path: '/train/SpecialCourses',
          query: {
            sceneId: this.sceneId,
            trainId: this.trainId,
            tjkId: this.tjkId
          }
        });
        return;
      }
      window.location.reload(); //不方便改为route.push或者window.href,或router.replace
    },
    //点击重新学习
    relearn: function relearn() {
      if (this.trainFlag == 'theory') {
        this.tabIndex = localStorage.getItem('tabIndex');
        this.$router.replace({
          path: '/train/index',
          query: {
            tabIndex: this.tabIndex
          }
        });
      } else if (this.trainFlag == 'VoiceGraduateExam') {
        this.$router.replace({
          path: '/train/SpecialCourses',
          query: {
            sceneId: this.sceneId,
            trainId: this.trainId,
            tjkId: this.tjkId
          }
        });
      } else if (this.trainFlag == 'fbtTrain') {
        this.$router.replace({
          path: '/train/index'
        });
      } else if (this.trainFlag == 'tjcollege') {
        this.$router.replace({
          path: '/train/SpecialCourses',
          query: {
            sceneId: this.sceneId,
            trainId: this.trainId,
            tjkId: this.tjkId
          }
        });
      } else {
        this.$router.back();
      }
    },
    goCuotiji: function goCuotiji() {
      this.$router.replace({
        path: '/train/basicExamDetail/' + this.examRecordId,
        query: {
          courseId: this.courseId,
          trainFlag: this.trainFlag,
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId
        }
      });
    },
    //退出考试
    exitExam: function exitExam() {
      var _this7 = this;
      var self = this;
      this.$confirm('确定退出测试？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        //在线理论考核，点返回，直接返回到培训页，其他的返回上个路由页，包括营销培训
        if (_this7.trainFlag == 'theory') {
          _this7.tabIndex = localStorage.getItem('tabIndex');
          _this7.$router.replace({
            path: '/train/index',
            query: {
              tabIndex: _this7.tabIndex
            }
          });
        }
        if (_this7.trainFlag == 'exercise') {
          if (_this7.sceneId) {
            _this7.$router.replace({
              path: '/train/SpecialCourses',
              query: {
                sceneId: _this7.sceneId,
                assitantType: 'OnlineUpgradeSkill',
                trainFlag: 'exercise'
              }
            });
          } else {
            //----------------这一段临时代码 开始,发版当天(2024-10-18)，可能有客服页面停留在本页面，url拿不到sceneId,所以，改天就不会运行到这里了，日期>2024-10-18就可以删除------------------
            _this7.$router.back();
            //----------------这一段临时代码 结束------------------
          }
        } else if (_this7.trainFlag == 'VoiceGraduateExam') {
          _this7.$router.replace({
            path: '/train/SpecialCourses',
            query: {
              sceneId: _this7.sceneId,
              trainId: _this7.trainId,
              tjkId: _this7.tjkId
            }
          });
        } else if (_this7.trainFlag == 'fbtTrain') {
          localStorage.setItem('tabIndex', _this7.$route.query.tabIndex);
          _this7.$router.replace({
            path: '/train/index'
          });
        } else if (_this7.trainFlag == 'tjcollege') {
          _this7.$router.replace({
            path: '/train/SpecialCourses',
            query: {
              sceneId: _this7.sceneId,
              trainId: _this7.trainId,
              tjkId: _this7.tjkId
            }
          });
        } else {
          _this7.$router.back();
        }
      });
    },
    //获取大题分类序号
    getNum: function getNum(key) {
      var arry = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];
      for (var i = 0; i < arry.length; i++) {
        if (i == key) {
          return arry[i];
          break;
        }
      }
    },
    //判断是否显示已答题样式
    getClass: function getClass(string) {
      if (typeof string == 'boolean') {
        return true;
      } else if (string instanceof Array) {
        for (var i = 0; i < string.length; i++) {
          if (string[i] != '') {
            return true;
            break;
          }
        }
      } else if (string != '') {
        return true;
      } else {
        return false;
      }
    },
    clickImg: function clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg: function viewImg() {
      this.showImg = false;
    }
  }
};

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      examPassState: this.$route.query.state,
      //测试结果
      score: this.$route.query.score,
      //分数
      remainingExamTimes: this.$route.query.times,
      //剩余测试次数
      type: this.$route.query.type,
      //上级tab类型
      majorId: this.$route.query.majorId,
      //技能提升-场景-课程id
      tabMajorId: this.$route.query.tabMajorId,
      //tab的id
      courseId: this.$route.query.courseId,
      //课程id
      passScore: this.$route.query.passScore,
      //通关分数
      parent: this.$route.query.parent,
      //父级
      id: this.$route.query.id,
      //技能提升-场景id
      show: this.$route.query.show,
      //技能提升-场次和场景列表切换标识
      registration: 0,
      //判断是否报名
      voiceBadge: null,
      //语音上岗徽章
      newPeopleBadge: null,
      //语音新人徽章
      isPost: false,
      //判断是否有上岗徽章
      isexamination: true,
      //判断是否是考试页面
      isidNum: 1 //判断几次进页面
    };
  },
  created: function created() {
    this.registration = localStorage.getItem("registration");
    console.log(this.registration, 63);
    this.parent = this.$route.query.parent;
    console.log(this.parent, '我在');
    console.log(this.$route.query.state, '穿过看来');
    console.log(this.$route.query.score, '分数');
    this.getTrainList();
  },
  beforeMount: function beforeMount() {
    if (localStorage.getItem('badgeUrl') == 'false') {
      this.badgeUrl = false;
    }
  },
  mounted: function mounted() {},
  methods: {
    //语音上岗徽章点击跳转到场景
    returnscene: function returnscene() {
      localStorage.setItem('trainState', 'no');
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=no';
    },
    // 查看是否报名
    getTrainList: function getTrainList() {
      var _this = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/queryBadgeByCourseId", {
        "courseId": this.courseId,
        "businessMajorId": isNaN(self.id) == false ? self.id : null //结业考试会传，任务指南考试不传
      }).then(function (res) {
        var result = res.data;
        console.log(result.data != null, 999);
        if (result.data != null) {
          _this.isexamination = true;
          if (result.data.newPeopleBadge) {
            self.newPeopleBadge = result.data.newPeopleBadge;
            // console.log(this.newPeopleBadge,8858)
          }
          if (result.data.voiceBadge) {
            self.voiceBadge = result.data.voiceBadge;
          }
        } else {
          _this.isexamination = false;
        }
      }, function (res) {
        _this.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！");
      });
    },
    // 去报名
    Gosignup: function Gosignup() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/applyTrainPreCondition", null).then(function (res) {
        var result = res.data;
        if (result.data == null) {
          if (_this2.examPassState == 'passed' && _this2.registration == 0) {
            localStorage.setItem('trainState', 'no');
            window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + _this2.tabMajorId + '&show=yes';
          } else {
            window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + _this2.tabMajorId + '&show=yes';
          }
        } else {
          _this2.$alert(result.data);
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainPreCondition）！");
      });
    },
    //重新学习
    returnCourseList: function returnCourseList() {
      this.id = localStorage.getItem('id');
      this.majorId = localStorage.getItem('majorId');
      window.location.href = '/tjkStudy/train/childCourseList?id=' + this.id + '&type=' + this.type + '&majorId=' + this.majorId + '&tabMajorId=' + this.tabMajorId + '&show=' + this.show;
    },
    beginExam: function beginExam() {
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + this.courseId + '&tabMajorId=' + this.tabMajorId + '&type=' + this.type + '&score=' + this.passScore + '&parent=' + this.parent;
    }
  }
};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zoomImg = _interopRequireDefault(__webpack_require__(300));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      examRecordId: this.$route.params.id,
      //examRecordId
      groupRecordList: [],
      //试题信息
      examRecord: {},
      //淘金客答题记录信息
      exam: {},
      //考试课程信息

      courseId: this.$route.query.courseId,
      //课程id
      type: this.$route.query.type,
      //上级tab类型
      majorId: this.$route.query.majorId,
      //技能提升-场景-课程id
      passScore: null,
      //通关分数
      show: this.$route.query.show,
      //技能提升-场次和场景列表切换标识
      endTime: '',
      time: '',
      showImg: false,
      imgSrc: '',
      num: [],
      savelist: [],
      list: [],
      //保存时的结果集转换的一维数组，用作答题卡
      showExamError: false,
      //显示 错题集开关
      score: null,
      //考试分数
      state: '',
      //考试是否通过（状态）
      times: null,
      //剩余考试次数
      Coursename: '',
      //当前课程名称
      nextobject: {},
      //储存当前课程接口返回
      nextCoursename: '',
      //下一个课程名称
      Coursestate: '',
      //下一个课程的类型（英文）
      Coursestatename: '',
      //下一个课程的类型（中文）
      categoryName: '',
      //当前tab名字
      nextcategoryName: '',
      //下一个tab名字
      tabstate: null,
      //tab状态
      nextcourseId: null,
      //查询下一个知识点id
      tabIndex: null,
      //当前所在tab位置
      huizhang: '',
      //徽章名字
      theory: this.$route.query.theory,
      //在线理论跳考试
      knowledgestate: null,
      //弹窗文字类型
      knowledgename: '',
      //当前知识点或课程名称
      dazhiJump: false,
      //打字认证跳系统实操
      trainFlag: this.$route.query.trainFlag,
      //判断是不是理论跳转考试
      sceneId: this.$route.query.sceneId,
      trainId: this.$route.query.trainId,
      tjkId: this.$route.query.tjkId
    };
  },
  components: {
    'zoom-img': _zoomImg.default
  },
  created: function created() {
    this.examRecordId = this.$route.params.id;
  },
  mounted: function mounted() {
    this.getPaper(this.examRecordId);
  },
  methods: {
    //试卷内容查询
    getPaper: function getPaper(examRecordId) {
      var _this = this;
      var self = this;
      var data = {
        'examRecordId': examRecordId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/examRecord/getTjkExamDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          self.groupRecordList = result.data.groupRecordList;
          self.examRecord = result.data.examRecord;
          self.exam = result.data.exam;
          //groupRecordList标记好题号
          var num = 1;
          for (var i = 0; i < self.groupRecordList.length; i++) {
            var questionRecordFullList = self.groupRecordList[i];
            for (var j = 0; j < questionRecordFullList.questionRecordFullList.length; j++) {
              questionRecordFullList.questionRecordFullList[j].num = num;
              num++;
            }
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    //报名或参加下一个tab
    goindex: function goindex() {
      this.$router.push({
        path: '/train/index'
      });
    },
    //点击继续（学习，练习，测试）
    determine: function determine() {
      if (this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
        this.nextcourseId = this.nextobject.next.courseId;
        window.location.href = "/tjkStudy/vedioDetail?courseId=" + this.nextcourseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&CourseLevel=' + this.CourseLevel + '&sceneId=' + this.$route.query.sceneId + '&assitantTjkId=' + this.$route.query.tjkId + '&tjkId=' + this.$route.query.tjkId + '&trainId=' + this.$route.query.trainId + '&knowledgeId=' + this.knowledgeId;
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse && this.nextobject.next) {
        this.nextcourseId = this.nextobject.nextCourse.courseId;
        this.toStudy();
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse) {
        this.nextcourseId = this.nextobject.nextCourse.courseId;
        this.gotoStudy();
      } else if (this.nextobject.nextCategory) {
        this.$router.push({
          path: '/train/index'
        });
      } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCourse) {
        this.$router.push({
          path: '/train/index'
        });
      }
    },
    gotoStudy: function gotoStudy() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.nextcourseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
            _this2.$router.push({
              path: '/train/Secondarylist',
              query: {
                courseId: _this2.nextcourseId
              }
            });
          } else if (_this2.CourseLevel == 3) {
            _this2.$router.push({
              path: '/train/SpecialCourses',
              query: {
                sceneId: _this2.$route.query.sceneId,
                trainId: _this2.$route.query.trainId,
                tjkId: _this2.$route.query.tjkId,
                assitantTjkId: _this2.$route.query.tjkId
              }
            });
          } else {
            _this2.tabIndex = localStorage.getItem('tabIndex');
            _this2.$router.push({
              path: '/train/index',
              query: {
                tabIndex: _this2.tabIndex,
                condition: true //判断是否是基础知识点跳课程
              }
            });
          }
        } else {
          if (result.msg != null && result.msg != '') {
            _this2.$alert(result.msg);
          }
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    toStudy: function toStudy() {
      var _this3 = this;
      console.log(this.CourseLevel, '状态');
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.nextcourseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
            _this3.$router.push({
              path: '/train/Secondarylist',
              query: {
                courseId: _this3.nextcourseId
              }
            });
          } else if (_this3.CourseLevel == 3) {
            _this3.$router.push({
              path: '/train/SpecialCourses',
              query: {
                sceneId: _this3.$route.query.sceneId,
                trainId: _this3.$route.query.trainId,
                tjkId: _this3.$route.query.tjkId,
                assitantTjkId: _this3.$route.query.tjkId
              }
            });
          } else if (result.data.knowledgeRecordFullList.length == 1) {
            window.location.href = '/tjkStudy/vedioDetail?courseId=' + _this3.nextcourseId + '&knowledgeSeq=' + _this3.nextobject.next.knowledgeSeq + '&CourseLevel=' + _this3.CourseLevel + '&sceneId=' + _this3.$route.query.sceneId + '&assitantTjkId=' + _this3.$route.query.tjkId + '&tjkId=' + _this3.$route.query.tjkId + '&trainId=' + _this3.$route.query.trainId + '&knowledgeId=' + _this3.knowledgeId;
          }
        } else {
          if (result.msg != null && result.msg != '') {
            _this3.$alert(result.msg);
          }
        }
      }, function (res) {
        _this3.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    //考试页面查看下一个课程
    seecurriculum: function seecurriculum() {
      var _this4 = this;
      var data = {
        'courseId': this.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/course/getGuideDialog', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this4.knowledge = result.data.current;
          _this4.nextobject = result.data;
          if (_this4.nextobject.next) {
            _this4.knowledgeId = _this4.nextobject.next.knowledgeId;
          }
          if (_this4.nextobject.next && !_this4.nextobject.nextCourse && !_this4.nextobject.nextCategory) {
            _this4.knowledgestate = 1; //知识点跳知识点
            _this4.knowledgeId = _this4.nextobject.next.knowledgeId;
            _this4.knowledgename = _this4.nextobject.current.title;
          } else if (!_this4.nextobject.nextCategory && _this4.nextobject.nextCourse) {
            _this4.knowledgestate = 2; //知识点跳课程
            _this4.knowledgename = _this4.nextobject.currentCourse.courseName;
            if (_this4.nextobject.nextCourse.courseType == 'Exam' || _this4.nextobject.nextCourse.assitantType == 'AssitantSpecialRobotExam') {
              _this4.Coursestate = 'Exam';
            } else if (_this4.nextobject.nextCourse.courseType == 'Integrate' && _this4.nextobject.nextCourse.assitantType) {
              _this4.Coursestate = 'Practice';
            } else if (_this4.nextobject.nextCourse.courseType == 'Integrate' && !_this4.nextobject.nextCourse.assitantType) {
              _this4.Coursestate = 'Study';
            }
          } else if (_this4.nextobject.nextCategory) {
            _this4.knowledgestate = 2;
            _this4.categoryName = _this4.nextobject.currentCategory.categoryName;
          } else if (!_this4.nextobject.next && !_this4.nextobject.nextCourse && !_this4.nextobject.nextCategory) {
            _this4.knowledgestate = 2;
          }
          var ismajorId = localStorage.getItem('majorId');
          _this4.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/courseCategory/queryListXlk", {
            majorId: ismajorId
          }).then(function (res) {
            var result = res.data;
            if (result.success) {
              var relist = result.data;
              if (!_this4.nextobject.next && !_this4.nextobject.nextCourse && !_this4.nextobject.nextCategory) {
                _this4.knowledgestate = 2;
                _this4.categoryName = _this4.nextobject.currentCategory.categoryName;
                _this4.tabstate = 1;
              } else if (_this4.nextobject.nextCategory) {
                if (_this4.nextobject.nextCategory == null) {} else {
                  _this4.tabstate = 2;
                  _this4.nextobject.nextCategory.assitantType;
                  relist.forEach(function (item, index) {
                    if (item.assitantType == _this4.nextobject.nextCategory.assitantType) {
                      if (_this4.nextobject.nextCategory.assitantType == 'OnlineUpgradeSkill') {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        if (_this4.nextobject.theoryBadge == false) {
                          _this4.nextcategoryName = '理论培训';
                        } else {
                          _this4.nextcategoryName = '实操培训';
                        }
                      } else if (_this4.nextobject.nextCategory.assitantType == 'VoiceUpgradeSkill') {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        _this4.nextcategoryName = '语音技能提升';
                      } else if (_this4.nextobject.nextCategory.assitantType == 'SysOperate') {
                        _this4.dazhiJump = true;
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        localStorage.setItem('categoryId', item.categoryId);
                      } else {
                        localStorage.setItem('tabIndex', index);
                        localStorage.setItem('majorId', item.majorId);
                        localStorage.setItem('categoryId', item.categoryId);
                        _this4.categoryName = _this4.nextobject.currentCategory.categoryName;
                        _this4.nextcategoryName == item.categoryName;
                      }
                    }
                  });
                }
              }
            } else {
              if (result.msg != null && result.msg != '') {
                _this4.$alert(result.msg);
              }
            }
          }, function (res) {
            _this4.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
          });
        } else {
          if (result.msg != null && result.msg != '') {
            _this4.$alert(result.msg);
          }
        }
      }, function (response) {
        _this4.$alert('AJAX请求接口异常（/examining/startExam）！');
      });
    },
    replaceNToBr: function replaceNToBr(str) {
      var reg = new RegExp("\n", "g");
      return str.replace(reg, "<br/>");
    },
    //考试时间提示框
    open: function open() {
      var h = this.$createElement;
      this.$notify({
        title: '',
        message: h('i', {
          style: 'color: red'
        }, '离自动交卷还有5分钟，请注意答题时间'),
        duration: 5000
      });
    },
    //点击继续测试
    exitExam: function exitExam() {
      if (this.trainFlag == 'theory' && this.times == 0) {
        this.$message({
          message: '已无剩余测试次数',
          type: 'warning',
          center: true,
          duration: 3000
        });
        this.tabIndex = localStorage.getItem('tabIndex');
        this.$router.push({
          path: '/train/index',
          query: {
            tabIndex: this.tabIndex
          }
        });
        return;
      }
      if (this.trainFlag == 'tjcollege' && this.times == 0) {
        if (this.times == 0) {
          this.$message({
            message: '已无剩余测试次数',
            type: 'warning',
            center: true,
            duration: 3000
          });
        }
        this.$router.push({
          path: '/train/SpecialCourses',
          query: {
            sceneId: this.sceneId,
            trainId: this.trainId,
            tjkId: this.tjkId
          }
        });
        return;
      }
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + this.courseId + '&sceneId=' + this.sceneId + '&trainId=' + this.trainId + '&tjkId=' + this.tjkId + '&trainFlag=' + this.trainFlag;
    },
    //重新学习
    relearn: function relearn() {
      var self = this;
      //在线理论考核，点返回，直接返回到培训页，其他的返回上个路由页，包括营销培训
      if (this.trainFlag == 'theory') {
        this.tabIndex = localStorage.getItem('tabIndex');
        this.$router.push({
          path: '/train/index',
          query: {
            tabIndex: this.tabIndex
          }
        });
      } else if (this.trainFlag == 'VoiceGraduateExam') {
        this.$router.push({
          path: '/train/SpecialCourses',
          query: {
            sceneId: this.sceneId,
            trainId: this.trainId,
            tjkId: this.tjkId
          }
        });
      } else if (this.trainFlag == 'fbtTrain') {
        this.$router.push({
          path: '/train/index'
        });
      } else if (this.trainFlag == 'tjcollege') {
        this.$router.push({
          path: '/train/SpecialCourses',
          query: {
            sceneId: this.sceneId,
            trainId: this.trainId,
            tjkId: this.tjkId
          }
        });
      } else {
        this.$router.back();
      }
    },
    //获取大题分类序号
    getNum: function getNum(key) {
      var arry = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];
      for (var i = 0; i < arry.length; i++) {
        if (i == key) {
          return arry[i];
          break;
        }
      }
    },
    //判断是否显示已答题样式
    getClass: function getClass(string) {
      if (typeof string == 'boolean') {
        return true;
      } else if (string instanceof Array) {
        for (var i = 0; i < string.length; i++) {
          if (string[i] != '') {
            return true;
            break;
          }
        }
      } else if (string != '') {
        return true;
      } else {
        return false;
      }
    },
    clickImg: function clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg: function viewImg() {
      this.showImg = false;
    }
  }
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      //场景id
      type: this.$route.query.type,
      //上级tab类型
      tabMajorId: this.$route.query.tabMajorId,
      //tab的id
      tjkId: null,
      trainId: null,
      showEachDialog: false,
      //对练弹窗
      recordState: '',
      //外呼能力考核
      notification: false,
      //点击继续练习弹窗
      exercisePopup: false,
      //点击点击考核弹窗
      ismajorId: '',
      //保存结束考核状态
      istype: '',
      //保存结束考核状态
      exercisePopupNum: 0,
      //对练是否结束状态（点击考核）

      step: 'second',
      input: '',
      dialogVisible: false,
      partner: {},
      clickStatus: {
        recordId: null,
        clickStatus: "Yes",
        showContinue: null //用于首次 点击练习后，点停止，在不刷新界面的情况下改变按钮显隐
      }
    };
  },
  mounted: function mounted() {
    if (location.href.indexOf("#reloaded") == -1) {
      location.href = location.href + "#reloaded";
      location.reload();
    }

    //页面加载就判断是否有 “结束对练” 可以点
    this.isHasPri();
    localStorage.setItem('id', this.$route.query.id);
    localStorage.setItem('tabMajorId', this.$route.query.tabMajorId);
  },
  methods: {
    //点击考核弹窗确定
    exerciseClickconfirm: function exerciseClickconfirm() {
      // console.log(this.istype,this.id,this.ismajorId,'数据')
      this.stopPrict();
      if (this.istype == 'BusinessKnowledgeStudy' || this.istype == 'VoiceGraduate') {
        //业务知识学习，结业课
        this.$router.push({
          path: '/train/childCourseList',
          query: {
            id: this.id,
            type: this.istype,
            tabMajorId: this.tabMajorId,
            majorId: this.ismajorId
          }
        });
      } else if (this.istype == 'PartnerCallOutExercise') {
        //对练
        this.$router.push({
          path: '/train/partnerIndex',
          query: {
            id: this.id,
            type: this.istype,
            tabMajorId: this.tabMajorId
          }
        });
      } else if (this.istype == 'MankindDemoStudy') {
        //真人示范学习
        this.$router.push({
          path: '/train/recordDetail',
          query: {
            id: this.id,
            type: this.istype,
            tabMajorId: this.tabMajorId,
            majorId: this.ismajorId
          }
        });
      } else if (this.istype == 'CallOutAbilityCheck') {
        //考核
        this.toKaoheDetail(this.ismajorId);
        //  this.$router.go(0)
      } else {}
      this.exercisePopup = false;
    },
    // 继续练习弹窗点击确定
    Clickconfirm: function Clickconfirm() {
      this.notification = false;
      this.showEachDialog = true;
      this.stopKaohePrict();
    },
    //刷新
    Refresh: function Refresh() {
      if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        location.reload();
      }
    },
    //返回场景
    toSceneList: function toSceneList() {
      this.$router.push({
        path: '/train/index',
        query: {
          type: this.type,
          tabMajorId: this.tabMajorId
        }
      });
    },
    goDuilian: function goDuilian(recordId, type) {
      if (recordId) {
        this.clickStatus.recordId = recordId;
        this.showEachDialog = true;
      }
      var available = this.checkOperationAvailable(type);
      if (available == 'needEndKaohe') {
        // this.$message({
        //     message: '需要先结束考核',
        //     type: 'error'
        // });
        // return;
        this.notification = true;
      } else {
        this.showEachDialog = true;
      }
    },
    stopKaohePrict: function stopKaohePrict() {
      var self = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voiceExerciseCustomer/endExamExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          self.queryMajorAll();
        }
      });
    },
    toKaoheDetail: function toKaoheDetail(id) {
      var _this = this;
      // console.log(id,'有没有')
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/examReady', {
        'id': id
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.toSign(id);
        } else {
          console.log(result.msg);

          // this.$alert("你考核未合格，请重新报名参加培训");
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    toSign: function toSign(id) {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=' + id).then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    //============
    //查询淘金客信息
    getCustomerUser: function getCustomerUser() {
      var _this2 = this;
      this.$http.get('/customer/action/currentUser/customerUser').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.tjkId = result.data.id;
          _this2.isHasPri();
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('AJAX访问接口异常！');
      });
    },
    showKnow: function showKnow() {
      this.step = 'second';
    },
    isHasPri: function isHasPri() {
      var _this3 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/existExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success && result.data.data) {
          _this3.step = 'handing';
        } else {
          _this3.step = 'second';
          //展示开始对练还是继续对练
        }
      });
    },
    goToPrict: function goToPrict() {
      var _this4 = this;
      var patrn = /^(-)?\d+(\.\d+)?$/;
      if (!patrn.exec(this.input)) {
        this.$message({
          message: '请输入正确的淘金号',
          type: 'error'
        });
        return;
      }
      if (this.input && this.input.length < 9) {
        this.$message({
          message: '淘金号长度至少为9位',
          type: 'error'
        });
        return;
      }

      //查询是否存在当前淘金号
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + "/tjk/queryTjkList?tjkParam=".concat(this.input, "&returnAllData=1")).then(function (result) {
        if (result.data.data.length) {
          _this4.partner = result.data.data[0];
          _this4.dialogVisible = true;
        } else {
          _this4.$message({
            message: '未找到对应的对练伙伴，请重新输入淘金号',
            type: 'error'
          });
        }
      });
      // 打开打卡，然后展示正在练习
    },
    updateSlickStatus: function updateSlickStatus() {
      var _this5 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majorAll/majorAllTjkUpdate', this.clickStatus).then(function (response) {
        var result = response.data;
        if (result.success) {
          self.queryMajorAll();
        } else {
          _this5.$alert(result.msg);
        }
      }, function (response) {
        _this5.$alert('majorAllTjkUpdate AJAX访问接口异常！');
      });
    },
    stopPrict: function stopPrict() {
      var _this6 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/endExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this6.step = 'second';
        }
      });
      this.clickStatus.showContinue = 'Yes';
    },
    newPrict: function newPrict() {
      this.step = 'second';
    },
    //清空排版数据
    clearSchedule: function clearSchedule() {
      this.$http.get('http://127.0.0.1:26688/api/SignIn/clearScheduleCache').then(function (res) {});
      this.sureGoToPri();
      this.updateSlickStatus();
    },
    checkOperationAvailable: function checkOperationAvailable(ope) {
      //如果点击的是考核，看当前是否是 “结束对练”按钮能点
      if (ope == 'CallOutAbilityCheck') {
        if (this.step == 'handing') {
          return 'needEndDuilian';
        }
      }
    },
    sureGoToPri: function sureGoToPri() {
      var _this7 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/ready?tjkId=".concat(this.partner.id, "&assitantTjkId=").concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this7.getHawkeye();
          _this7.input = '';
          _this7.step = 'handing';
          _this7.dialogVisible = false;
          _this7.showEachDialog = false;
        } else {
          if (result.data.msg && result.data.msg.indexOf('不能有多个语音订单排班') > -1) {
            _this7.$message({
              message: '请先结束对练 或者结束考核',
              type: 'error'
            });
          } else {
            _this7.$message({
              message: result.data.msg,
              type: 'error'
            });
          }
        }
      });
    },
    //调用小助手
    getHawkeye: function getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (res) {
        done();
      }).catch(function (res) {});
    }
  }
};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _examDialog = _interopRequireDefault(__webpack_require__(402));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      //场景id
      type: this.$route.query.type,
      //上级tab类型
      tabMajorId: this.$route.query.tabMajorId,
      //tab的id
      majorId: this.$route.query.majorId,
      //课程majorId
      courseList: [],
      examVisible: false,
      //测试考试弹出层
      examCourseId: null //测试考试课程id
    };
  },
  components: {
    examDialog: _examDialog.default
  },
  mounted: function mounted() {
    this.getCourseList();
    localStorage.setItem('majorId', this.$route.query.majorId);
  },
  methods: {
    //获取课程列表
    getCourseList: function getCourseList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryCourseViewNewXlk', {
        'majorId': this.majorId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this.courseList = result.data.data.courseViewList;
        } else {
          _this.$alert(result.msg);
        }
      }, function (res) {
        _this.$alert("AJAX请求接口异常（/majors/queryCourseViewNewXlk）！");
      });
    },
    //返回课程
    toCourseList: function toCourseList() {
      this.$router.push({
        path: '/train/courseList',
        query: {
          id: this.id,
          type: this.type,
          tabMajorId: this.tabMajorId
        }
      });
    },
    toStudy: function toStudy(courseId, unlock, courseType) {
      if (!unlock) {
        return false;
      }
      if (courseType == 'Exam') {
        this.examVisible = true;
        this.examCourseId = courseId;
      } else {
        this.$router.push({
          path: '/vedioDetail',
          query: {
            id: this.id,
            courseId: courseId,
            type: this.type,
            majorId: this.majorId,
            tabMajorId: this.tabMajorId,
            parent: 'jineng'
          }
        });
      }
    },
    closeDialog: function closeDialog(val) {
      this.examVisible = val;
    }
  }
};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      //场景id
      type: this.$route.query.type,
      //上级tab类型
      tabMajorId: this.$route.query.tabMajorId,
      //tab的id
      tjkId: '',
      step: 'first',
      input: '',
      priList: [{
        title: '对练目的',
        tips: [{
          value: '1、熟悉小助手外呼操作步骤;'
        }, {
          value: '2、与搭档进行话术对练。'
        }]
      }, {
        title: '必备条件',
        tips: [{
          value: '1、有对练搭档（一般老师会分组，若未分组，请自行在群内找搭档）；'
        }, {
          value: '2、你的对练搭档也进入了语音对练。'
        }]
      }, {
        title: '操作手册',
        tips: [{
          value: '1、请先查看语音对练操作手册，然后再进行练习。'
        }]
      }],
      dialogVisible: false,
      partner: {}
    };
  },
  created: function created() {
    this.getCustomerUser();
  },
  mounted: function mounted() {},
  methods: {
    style: function style(iconUrl) {
      return {
        backgroundImage: 'url(' + iconUrl + ')'
      };
    },
    //查询淘金客信息
    getCustomerUser: function getCustomerUser() {
      var _this = this;
      this.$http.get('/customer/action/currentUser/customerUser').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.tjkId = result.data.id;
          _this.isHasPri();
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    showKnow: function showKnow() {
      this.step = 'second';
    },
    isHasPri: function isHasPri() {
      var _this2 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/existExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success && result.data.data) {
          _this2.step = 'handing';
        } else {
          _this2.step = 'first';
        }
      });
    },
    goToPrict: function goToPrict() {
      var _this3 = this;
      var patrn = /^(-)?\d+(\.\d+)?$/;
      if (!patrn.exec(this.input)) {
        this.$message({
          message: '请输入正确的淘金号',
          type: 'error'
        });
        return;
      }
      if (this.input && this.input.length < 9) {
        this.$message({
          message: '淘金号长度至少为9位',
          type: 'error'
        });
        return;
      }

      //查询是否存在当前淘金号
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + "/tjk/queryTjkList?tjkParam=".concat(this.input, "&returnAllData=1")).then(function (result) {
        if (result.data.data.length) {
          _this3.partner = result.data.data[0];
          _this3.dialogVisible = true;
        } else {
          _this3.$message({
            message: '未找到对应的对练伙伴，请重新输入淘金号',
            type: 'error'
          });
        }
      });
      // 打开打卡，然后展示正在练习
    },
    stopPrict: function stopPrict() {
      var _this4 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/endExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this4.step = 'first';
        }
      });
    },
    newPrict: function newPrict() {
      this.step = 'second';
    },
    //清空排版数据
    clearSchedule: function clearSchedule() {
      this.$http.get('http://127.0.0.1:26688/api/SignIn/clearScheduleCache').then(function (res) {});
      this.sureGoToPri();
    },
    sureGoToPri: function sureGoToPri() {
      var _this5 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/ready?tjkId=".concat(this.partner.id, "&assitantTjkId=").concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this5.getHawkeye();
          _this5.input = '';
          _this5.step = 'handing';
          _this5.dialogVisible = false;
        } else {
          _this5.$message({
            message: result.data.msg,
            type: 'error'
          });
        }
      });
    },
    //调用小助手
    getHawkeye: function getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (res) {
        done();
      }).catch(function (res) {});
    } //返回场景
  }
};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      //技能提升-场景id
      type: this.$route.query.type,
      //上级tab类型
      tabMajorId: this.$route.query.tabMajorId,
      //上级tab的id
      majorId: this.$route.query.majorId,
      //businessMajorId
      lastRecordId: null,
      //上一课程id
      nextRecordId: null,
      //下一课程id
      record: {},
      recordId: this.$route.query.recordId //录音id
    };
  },
  components: {},
  created: function created() {},
  mounted: function mounted() {
    this.getRecordDetail();
  },
  methods: {
    getRecordDetail: function getRecordDetail() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/goodRecord/queryRecomendRecord', {
        'businessMajorId': this.majorId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this.lastRecordId = result.data.lastRecordId;
          _this.nextRecordId = result.data.nextRecordId;
          _this.record = result.data.record;
          _this.recordId = result.data.record.recordId;
          _this.$nextTick(function () {
            var _this2 = this;
            this.$refs.video.addEventListener('ended', function () {
              //该视频播放是否已结束
              _this2.submitKnowledge();
            }, false);
          });
        } else {
          _this.$alert(result.msg);
        }
      }, function (res) {
        _this.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      });
    },
    //录音完成后提交
    submitKnowledge: function submitKnowledge() {
      var _this3 = this;
      var data = {
        'recordId': this.recordId,
        'businessMajorId': this.$route.query.id
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/goodRecord/listenGoodRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {} else {
          _this3.$alert(result.msg);
        }
      }, function (res) {
        _this3.$alert("AJAX请求接口异常（/goodRecord/listenGoodRecord）！");
      });
    },
    lastStudy: function lastStudy() {
      window.location.href = '/tjkStudy/vedioDetail?recordId=' + this.lastRecordId + '&type=' + this.type + '&tabMajorId=' + this.tabMajorId;
    },
    nextStudy: function nextStudy() {
      if (this.unlock) {
        window.location.href = '/tjkStudy/vedioDetail?recordId=' + this.nextRecordId + '&type=' + this.type + '&tabMajorId=' + this.tabMajorId;
      }
    },
    //返回课程
    toCourseList: function toCourseList() {
      this.$router.go(-1);
    }
  }
};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pagination = _interopRequireDefault(__webpack_require__(104));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    pagination: _pagination.default
  },
  data: function data() {
    return {
      businessMajorId: this.$route.query.businessMajorId,
      //场景id
      searchData: {
        pageNum: 1,
        pageSize: 10,
        pages: 0,
        tjkId: this.$route.query.tjkId,
        trainId: this.$route.query.trainId,
        toTjkId: null,
        minScore: '',
        maxScore: '',
        effectStatus: this.$route.query.effectStatus,
        callInterVal: this.$route.query.callInterVal,
        qcEffectStatus: this.$route.query.qcEffectStatus,
        goodStatus: null,
        qcStatus: null,
        callInterval: this.$route.query.callInterVal
      },
      queryDate: [this.getCurrentDate().monthStartDate, this.getCurrentDate().monthEndDate],
      //培训时间
      queryBeginTime: this.$route.query.beginTime,
      queryEndTime: this.$route.query.endTime,
      majorList: [],
      list: null
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    updateTjkId: function updateTjkId(val) {
      this.searchData.tjkId = val.id;
    },
    updateToTjkId: function updateToTjkId(val) {
      this.searchData.toTjkId = val.id;
    },
    //点分页组件的数字/下一页，会回传pageNum过来，平时直接点查新，参数是event对象，所以需要isNAN判断
    getList: function getList(pageNum) {
      var _this = this;
      if (pageNum && isNaN(pageNum) == false) {
        this.searchData.pageNum = pageNum;
      }
      var self = this;
      if (this.queryBeginTime && this.queryEndTime) {
        this.queryDate = [];
        this.queryDate[0] = this.queryBeginTime;
        this.queryDate[1] = this.queryEndTime;
      }
      if (this.queryDate && this.queryDate.length == 2) {
        this.searchData.beginTime = this.queryDate[0];
        this.searchData.endTime = this.queryDate[1];
      } else {
        this.searchData.beginTime = null;
        this.searchData.endTime = null;
      }
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryExerciseRecordAll', this.searchData).then(function (response) {
        var result = response.data;
        if (result.success) {
          self.searchData.pages = result.data.pages;
          self.list = result.data.list;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert("网络繁忙，请稍后重试！");
      });
    },
    exportList: function exportList() {
      window.open({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/export/excel/exportVoiceEachExerciseRecordAll?' + this.urlEncode(this.searchData));
    }
  }
};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pagination = _interopRequireDefault(__webpack_require__(104));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    pagination: _pagination.default
  },
  data: function data() {
    return {
      businessMajorId: this.$route.query.businessMajorId,
      //场景id
      searchData: {
        pageNum: 1,
        pageSize: 10,
        pages: 0,
        tjkId: null,
        //receivePhoneIsKf=false
        trainId: this.$route.query.trainId,
        kf: this.$route.query.tjkId,
        //receivePhoneIsKf=true
        minScore: '',
        maxScore: '',
        effectStatus: this.$route.query.effectStatus,
        callInterVal: this.$route.query.callInterVal,
        qcEffectStatus: this.$route.query.qcEffectStatus,
        goodStatus: null,
        qcStatus: null,
        callInterval: this.$route.query.callInterVal
      },
      searchDataKh: {
        pageNum: 1,
        pageSize: 10,
        pages: 0,
        kh: this.$route.query.tjkId,
        //receivePhoneIsKf=true
        toTjkId: null,
        //receivePhoneIsKf=false
        trainId: this.$route.query.trainId,
        effectStatus: this.$route.query.effectStatus,
        callInterVal: this.$route.query.callInterVal,
        qcEffectStatus: this.$route.query.qcEffectStatus,
        callInterval: this.$route.query.callInterVal
      },
      queryDate: [this.getCurrentDate().monthStartDate, this.getCurrentDate().monthEndDate],
      //培训时间
      queryBeginTime: this.$route.query.beginTime,
      queryEndTime: this.$route.query.endTime,
      majorList: [],
      list: null,
      listActKh: null,
      tjkId: this.$route.query.tjkId,
      activeName: 'actAsKf'
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    toSceneList: function toSceneList() {
      this.$router.back();
    },
    handleClick: function handleClick(tab, event) {
      this.getList();
    },
    updateTjkId: function updateTjkId(val) {
      this.searchData.tjkId = val.id;
    },
    updateToTjkId: function updateToTjkId(val) {
      this.searchData.toTjkId = val.id;
    },
    //点分页组件的数字/下一页，会回传pageNum过来，平时直接点查新，参数是event对象，所以需要isNAN判断
    getList: function getList(pageNum) {
      var _this = this;
      var param = null;
      if (this.activeName == 'actAsKh') {
        param = this.searchDataKh;
      } else {
        param = this.searchData;
      }
      param.trainId = this.searchData.trainId;
      if (pageNum && isNaN(pageNum) == false) {
        param.pageNum = pageNum;
      }
      param.courseId = this.$route.query.courseId;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryExerciseRecordAll', param).then(function (response) {
        var result = response.data;
        if (result.success) {
          self.searchData.pages = result.data.pages;
          if (self.activeName == 'actAsKh') {
            self.listActKh = result.data.list;
          } else {
            self.list = result.data.list;
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert("网络繁忙，请稍后重试！");
      });
    },
    exportList: function exportList() {
      window.open({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/export/excel/exportVoiceEachExerciseRecordAll?' + this.urlEncode(this.searchData));
    },
    gobackScene: function gobackScene() {
      this.$router.go(-1);
      // this.$router.push({path: '/train/courseList', query: {id: this.businessMajorId, type: 'SkillUpgrade', show:'no'}});
    }
  }
};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: this.$route.query.id,
      kf: this.$route.query.kf,
      callId: '',
      videoUrl: '',
      //录音文件
      gradeState: '',
      //评分状态
      effectStatus: null,
      //是否有效
      effectReason: '',
      //无效原因
      gradeScore: '',
      //得分
      gradeList: [],
      //点评内容
      evaluateList: [],
      //练习建议
      preId: '',
      //上一条记录
      nextId: '',
      //下一条记录
      keyData: 0,
      //更新页面
      spanArr: [],
      pos: 0,
      existAdvise: false,
      //是否显示 系统建议
      Totalscore: 0
    };
  },
  created: function created() {
    console.log(this.preId == '', '28');
  },
  mounted: function mounted() {
    this.queryGrade();
  },
  methods: {
    extractTotalscore: function extractTotalscore() {},
    //更改某一列样式
    addClass: function addClass(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex == 3) {
        //此判断为第四列
        return 'addBorderStyle_3';
      }
      if (columnIndex == 4) {
        //此判断为第五列
        return 'addBorderStyle_4';
      }
    },
    // 合并表头
    rowClass: function rowClass(_ref2) {
      var row = _ref2.row,
        column = _ref2.column,
        rowIndex = _ref2.rowIndex,
        columnIndex = _ref2.columnIndex;
      if (rowIndex === 0 && columnIndex === 0) {
        this.$nextTick(function () {
          if (document.getElementsByClassName(column.id).length !== 0) {
            document.getElementsByClassName(column.id)[0].setAttribute('rowSpan', 2);
            return false;
          }
        });
      }
      if (rowIndex === 1 && (columnIndex === 0 || columnIndex === 1)) {
        return {
          display: 'none'
        };
      }
      if (columnIndex == 3 && rowIndex == 0) {
        return 'background-color:#f9dbd0 !important ';
      } else if (columnIndex == 3 && rowIndex == 1) {
        return 'background-color:#cbd5fa !important';
      }
      if (columnIndex == 2) {
        return 'background-color:#cbd5fa !important';
      }
    },
    getSpanArr: function getSpanArr(data) {
      this.spanArr = [];
      this.pos = 0;
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          if (data[i].parentname === data[i - 1].parentname) {
            // 如果name相等就累加，并且push 0 （这里的判断视自己的判定依据改变,name就是要对比的字段）
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            // 不相等push 1
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    objectSpanMethod: function objectSpanMethod(_ref3) {
      var row = _ref3.row,
        column = _ref3.column,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      // 用于设置要合并的列 0 表示第一列
      if (columnIndex === 0) {
        var cRow = this.spanArr[rowIndex];
        var cCol = cRow > 0 ? 1 : 0;
        return {
          rowspan: cRow,
          // 合并的行数
          colspan: cCol // 合并的列数，为0表示不显示
        };
      }
    },
    //查询评分字段
    queryGrade: function queryGrade() {
      var _this = this;
      var self = this;
      var data = {
        'id': this.id,
        'kf': this.kf
      };
      var regex1 = /(?<=\()(.+?)(?=\))/g;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryDetail', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.callId = result.data.callId;
          _this.videoUrl = result.data.videoUrl;
          _this.gradeState = result.data.gradeState;
          _this.effectStatus = result.data.effectStatus;
          _this.effectReason = result.data.effectReason;
          _this.gradeScore = result.data.gradeScore;
          _this.preId = result.data.preId;
          _this.nextId = result.data.nextId;
          _this.evaluateList = [];
          if (result.data.evaluateList) {
            result.data.evaluateList.map(function (item) {
              _this.evaluateList.push({
                'evaluate': item
              });
            });
          } else {
            _this.evaluateList.push({
              'evaluate': ''
            });
          }
          _this.gradeList = [];
          var teacherGradeMap = new Map();
          if (result.data.teacherGradeList != null) {
            result.data.teacherGradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                obj.childList.map(function (o) {
                  if (o.checked) {
                    checkedId = o.id;
                  }
                });
                var tempObj = {
                  'score': obj.gradeScore,
                  'childList': obj.childList,
                  'checkedId': checkedId
                };
                teacherGradeMap.set(obj.id, tempObj);
              });
            });
          } else if (result.data.gradeList != null) {
            result.data.gradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                var tempObj = {
                  'childList': obj.childList,
                  'checkedId': checkedId
                };
                teacherGradeMap.set(obj.id, tempObj);
              });
            });
          }
          if (result.data.gradeList != null) {
            result.data.gradeList.map(function (item) {
              item.childList.map(function (obj) {
                var checkedId = '';
                var checkedName = '';
                var description = '';
                obj.childList.map(function (o) {
                  if (o.checked) {
                    checkedId = o.id;
                    checkedName = o.name;
                    description = o.description;
                  }
                });
                var teacherGradeObj = teacherGradeMap.get(obj.id);
                var tempObj = {
                  'parentname': item.name,
                  'name': obj.name,
                  'score': obj.gradeScore,
                  //总分
                  'gradeScore': obj.score,
                  //得分
                  'childList': obj.childList,
                  'checkedId': checkedId,
                  'checkedName': checkedName,
                  'description': description,
                  'teacherGrade': teacherGradeObj ? teacherGradeObj : {},
                  'Totalscore': obj.name.match(regex1)
                };
                console.log(obj.name.match(regex1), 666);
                self.gradeList.push(tempObj);

                //判断是否有建议，无建议，则不显示“系统建议”那一列
                if (_this.existAdvise == false && description /* != null && description.trim() != ''*/) {
                  _this.existAdvise = true;
                }
              });
            });
          }
          _this.getSpanArr(_this.gradeList);
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    toPre: function toPre(id) {
      window.location.href = '/tjkStudy/train/eachRecordDetail?id=' + id + '&kf=' + this.kf;
    },
    toNext: function toNext(id) {
      window.location.href = '/tjkStudy/train/eachRecordDetail?id=' + id + '&kf=' + this.kf;
    },
    addEvaluate: function addEvaluate() {
      this.evaluateList.push({
        'evaluate': ''
      });
    },
    delEvaluate: function delEvaluate(key) {
      this.evaluateList.splice(key, 1);
    },
    //提交评分
    saveScore: function saveScore() {
      var _this2 = this;
      var choiceRuleIds = [],
        evaluateList = [];
      for (var i = 0; i < this.gradeList.length; i++) {
        if (!this.gradeList[i].teacherGrade.checkedId) {
          this.$alert('练习点评为必选');
          return false;
          break;
        } else {
          choiceRuleIds.push(this.gradeList[i].teacherGrade.checkedId);
        }
      }
      for (var _i = 0; _i < this.evaluateList.length; _i++) {
        if (!this.evaluateList[_i].evaluate) {
          this.$alert('请填写练习建议');
          return false;
          break;
        } else {
          evaluateList.push(this.evaluateList[_i].evaluate);
        }
      }
      var data = {
        'id': this.id,
        'callId': this.callId,
        'choiceRuleIds': choiceRuleIds,
        'evaluateList': evaluateList
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseTeacher/savePartnerGrade', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.$alert('保存成功');
          _this2.queryGrade();
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert('AJAX访问接口异常！');
      });
    },
    //点击二级菜单
    clickSecond: function clickSecond(index, key) {
      this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
      this.keyData += 1;
    }
  }
};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pagination = _interopRequireDefault(__webpack_require__(104));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    pagination: _pagination.default
  },
  data: function data() {
    return {
      businessMajorId: this.$route.query.businessMajorId,
      //场景id
      searchData: {
        courseId: this.$route.query.courseId,
        pageNum: 1,
        pageSize: 10,
        pages: 0,
        tjkId: this.$route.query.tjkId,
        trainId: this.$route.query.trainId,
        teacherTjkId: this.$route.query.teacherTjkId,
        sceneId: '',
        effectStatus: this.$route.query.effectStatus,
        callInterVal: this.$route.query.callInterVal,
        qcEffectStatus: this.$route.query.qcEffectStatus,
        goodStatus: null,
        qcStatus: null,
        callInterval: this.$route.query.callInterVal
      },
      queryDate: null,
      majorList: [],
      list: []
    };
  },
  mounted: function mounted() {
    // this.querySceneList();
    this.getList();
  },
  methods: {
    //查询场景
    querySceneList: function querySceneList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceScene/listExamSceneActive').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.majorList = result.data;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    updateTjkId: function updateTjkId(val) {
      this.searchData.tjkId = val.id;
    },
    updateTeacherTjkId: function updateTeacherTjkId(val) {
      this.searchData.teacherTjkId = val.id;
    },
    //点分页组件的数字/下一页，会回传pageNum过来，平时直接点查新，参数是event对象，所以需要isNAN判断
    getList: function getList(pageNum) {
      var _this2 = this;
      if (this.queryDate) {
        this.searchData.beginTime = this.queryDate[0];
        this.searchData.endTime = this.queryDate[1];
      }
      if (pageNum && isNaN(pageNum) == false) {
        this.searchData.pageNum = pageNum;
      }
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseRecord/queryTjkExamRecordAll', this.searchData).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.searchData.pageSize = result.data.pageSize;
          _this2.searchData.pages = result.data.pages;
          _this2.list = result.data.list;
        } else {
          _this2.$alert(result.msg);
        }
      }, function (response) {
        _this2.$alert("网络繁忙，请稍后重试！");
      });
    },
    exportList: function exportList() {
      window.open({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/export/excel/exportVoiceExamRecordList?' + this.urlEncode(this.searchData));
    },
    gobackScene: function gobackScene() {
      // this.$router.push({path: '/train/courseList', query: {id: this.businessMajorId, type: 'SkillUpgrade', show:'no'}});
      this.$router.go(-1);
    }
  }
};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "examRecordList",
  data: function data() {
    return {
      tjkInfo: {},
      tabIndex: 0,
      collegeType: this.$route.query.collegeType,
      //记录类型，传到对练系统，记录结果存到college里
      fbtType: null,
      categoryId: null,
      courseList: [],
      //四级列表
      courseId: this.$route.query.courseId,
      urlLink: this.$route.query.urlLink,
      CourseLevel: null,
      //任务指南跳过来的,
      imUrl: {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.imUrl,
      imToken: {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.imToken
    };
  },
  // ... 其他代码
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.loadData();
    });
  },
  methods: {
    loadData: function loadData() {
      if (this.urlLink) {
        return;
      } else {
        if (this.$route.query.CourseLevel) {
          this.CourseLevel = this.$route.query.CourseLevel;
        }
        this.Lv3Courses();
      }
      this.getCustomerUser();
    },
    getCustomerUser: function getCustomerUser() {
      var _this = this;
      this.$http.get('/customer/action/currentUser/customerUser').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.tjkInfo = result.data;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    goDownLoadLink: function goDownLoadLink(knowledge) {
      var _this2 = this;
      //urllink以 “//” 开头
      var urlLink = knowledge.downLink;
      urlLink = urlLink.replace('http:', '');
      urlLink = urlLink.replace('https:', '');
      window.location.href = urlLink;
      var data = {
        'courseId': this.courseId,
        'knowledgeSeq': knowledge.knowledgeSeq,
        //以后取消，后端不用【knowledgeSeq】参数了
        'knowledgeId': knowledge.knowledgeId,
        'assitant': true
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/course/submitKnowledgeXlk', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this2.Lv3Courses();
        } else {
          _this2.$alert(result.msg);
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/course/submitKnowledge）！");
      });
    },
    //--在线进入实操--点击练习记录
    Gorecord: function Gorecord(type, id) {
      if (type === 'fbtoperate') {
        type = 'fbt';
      }
      this.$router.push({
        path: "/train/OperationRecord",
        query: {
          type: type,
          id: id
        }
      });
    },
    //--在线进入实操--点击练习，测试
    GoPracticalOperation: function GoPracticalOperation(know, id, courseId, key, name) {
      if (this.fbtType == 'jingmai') {
        this.$router.push({
          path: '/train/FBT/jingmaiChat',
          query: {
            sceneId: know.courseId
          }
        });
      } else if (this.fbtType == 'feige') {
        this.$router.push({
          path: '/train/FBT/doudianChat',
          query: {
            sceneId: know.courseId
          }
        });
      } else {
        var targetType = know.assitantType;
        var targetId = id;
        if (targetType === 'fbtoperate') {
          targetType = 'primary';
          targetId = courseId;
        }
        this.$router.push({
          path: '/train/OnInline',
          query: {
            page: 'shichao',
            type: targetType,
            knowledgeId: know.knowledgeId,
            courseId: courseId,
            id: targetId,
            knowledgeSeq: key + 1,
            key: key + 1,
            courseName: name,
            CourseLevel: 3,
            sceneId: this.sceneId,
            collegeType: this.collegeType,
            showanswer: know.showanswer,
            assitantType: know.assitantType
          }
        });
      }
    },
    // 返回按钮
    isreturn: function isreturn() {
      if (this.fbtType) {
        this.$router.back();
        return;
      }
      if (this.$route.query.CourseLevel == 3) {
        this.$router.push({
          path: '/train/SpecialCourses',
          query: {
            sceneId: this.$route.query.sceneId,
            trainId: this.$route.query.trainId,
            tjkId: this.$route.query.tjkId,
            assitantTjkId: this.$route.query.tjkId
          }
        });
      } else if (this.$route.query.Level == 4) {
        this.$router.back();
      } else {
        localStorage.setItem('needSetDefaultTab2', 'false'); //返回上级，要求不重新定位
        this.tabIndex = localStorage.getItem('tabIndex');
        this.$router.push({
          path: '/train/index',
          query: {
            tabIndex: this.tabIndex,
            condition: true //判断是否是基础知识点跳课程
          }
        });
      }
    },
    //前往知识点
    goKnowledge: function goKnowledge(c, key) {
      if (c.knowledge.assitantType && c.knowledge.knowledgeType == 'Special') {
        this.$router.push({
          path: '/train/OnInline',
          query: {
            page: 'qiannui',
            type: c.knowledge.assitantType,
            courseId: this.courseId,
            knowledgeSeq: key + 1,
            showanswer: c.showanswer,
            knowledgeId: c.knowledgeId
          }
        });
      } else {
        if (this.fbtType == 'jingmai' || this.fbtType == 'feige' || this.fbtType == 'qianniu') {
          this.$router.replace({
            path: "/vedioDetail",
            query: {
              fbtType: this.fbtType,
              courseId: this.courseId,
              knowledgeSeq: c.knowledge.knowledgeSeq,
              CourseLevel: this.CourseLevel,
              sceneId: this.$route.query.sceneId,
              trainId: this.$route.query.trainId,
              tjkId: this.$route.query.tjkId,
              knowledgeId: c.knowledgeId
            }
          });
          return;
        }
        this.$router.push({
          path: "/vedioDetail",
          query: {
            courseId: this.courseId,
            knowledgeSeq: c.knowledge.knowledgeSeq,
            CourseLevel: this.CourseLevel,
            sceneId: this.$route.query.sceneId,
            trainId: this.$route.query.trainId,
            tjkId: this.$route.query.tjkId,
            knowledgeId: c.knowledgeId
          }
        });
      }
    },
    //三级课程
    Lv3Courses: function Lv3Courses() {
      var _this3 = this;
      var assitantType = localStorage.getItem('assitantType');
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.courseId,
        'assitantType': assitantType
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this3.fbtType = result.data.fbtType;
          _this3.categoryId = result.data.categoryId;
          _this3.courseList = result.data.knowledgeRecordFullList;
        } else {
          _this3.$alert(result.msg);
        }
      }, function (res) {
        _this3.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      });
    }
  }
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _voice = _interopRequireDefault(__webpack_require__(632));
var _examDialog = _interopRequireDefault(__webpack_require__(402));
var _vue = __webpack_require__(22);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Knowledge',
  data: function data() {
    var _ref;
    return _ref = {
      toptab: '语音技能提升',
      //语音or在线
      tabIndex: 0,
      tabType: null,
      //二级tab菜单名称
      tabList: [],
      //二级tab菜单
      tabMajorId: this.$route.query.tabMajorId,
      //tab的id
      courseList: [],
      trainList: [],
      examCourseId: null,
      //测试考试课程id
      sceneList: [],
      //场景列表
      trainState: null,
      //技能提升是否获得徽章
      badgeUrl: "",
      //获得徽章图片地址
      content: "",
      //获得徽章文字描述
      description: "",
      //场景文字描述
      isAllComplete: 0,
      registration: 0
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "trainList", []), "decide", 0), "isPost", false), "newPeopleBadgeId", false), "isaxx", 0), "dialogVisible", false), "needFinish", null), "systemPopup", false), "iskey", null), "istype", ''), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "axx", false), "issystem", false), "prosystemPopup", false), "dimensional", false), "dimensionalimg", ''), "loneTab", []), "majorId", 100071), "categoryId", 1071), "cseList", []), "assitantType", ''), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "enlist", false), "sceneId", null), "trainId", null), "tjkId", null);
  },
  components: {
    voice: _voice.default,
    examDialog: _examDialog.default
  },
  watch: {},
  created: function created() {
    if (this.$route.query.tabIndex) {
      var i = this.$route.query.tabIndex;
      i = Number(i);
      this.tabIndex = this.$route.query.tabIndex;
      this.categoryId = localStorage.getItem('categoryId');
      this.LevelOneTab();
      this.SecondaryTab();
      this.getTrainList();
      if (this.$route.query.condition == 'false') {
        // console.log('提升')
        this.assitantType = 'VoiceUpgradeSkill';
        this.$router.push({
          query: {}
        });
      }
      // console.log(typeof(i),963369)

      this.Lv3Courses();

      // this.getTabList();
      // this.getTrainList()
    } else {
      this.LevelOneTab();
      this.Lv3Courses();
      // this.getTabList();
      // this.getTrainList()
    }

    // this.getCourseList()
    //  this.registration=localStorage.getItem("registration")

    // this.$route.query.trainState
    this.parent = this.$route.query.parent;
  },
  mounted: function mounted() {},
  beforeMount: function beforeMount() {},
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    //  一级导航tab
    LevelOneTab: function LevelOneTab() {
      var _this = this;
      {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majorAll/showTabMajor").then(function (res) {
          var result = res.data;
          if (result.success) {
            _this.loneTab = result.data;
            _this.majorId = _this.loneTab[0].id;
            _this.SecondaryTab();
          } else {
            _this.$alert(result.msg);
          }
        }, function (res) {
          _this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        });
      }
    },
    //二级获得目录tab
    SecondaryTab: function SecondaryTab() {
      var _this2 = this;
      {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/courseCategory/queryListXlk", {
          majorId: this.majorId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            _this2.tabList = result.data;
            console.log(_this2.tabList, 555569);
            var tabname = _this2.tabList[0].categoryName;
            localStorage.setItem('majorId', _this2.majorId);
          } else {
            _this2.$alert(result.msg);
          }
        }, function (res) {
          _this2.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        });
      }
    },
    //点击二级tab
    changeSecondaryTab: function changeSecondaryTab(key, id, t) {
      this.assitantType = t.assitantType;
      if (this.assitantType == 'VoiceUpgradeSkill') {
        this.getTrainList();
        this.tabIndex = key;
        localStorage.setItem('tabname', t.categoryName);
        localStorage.setItem('categoryId', id);
        localStorage.setItem('tabIndex', key);
        this.categoryId = id;
      } else {
        this.tabIndex = key;
        localStorage.setItem('categoryId', id);
        localStorage.setItem('tabIndex', key);
        this.categoryId = id;
        this.Lv3Courses();
      }

      //  console.log(this.categoryId,'categoryId的id')
    },
    //三级课程
    Lv3Courses: function Lv3Courses() {
      var _this3 = this;
      {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majors/queryCourseViewNewXlkCategoryId", {
          categoryId: this.categoryId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            _this3.courseList = result.data.courseViewList;
            var ass = document.getElementsByClassName('step-list');
            var app = document.getElementsByClassName('add');
            // ass.removeChild('app')
            //  this.DynamicLine()
          } else {
            _this3.$alert(result.msg);
          }
        }, function (res) {
          _this3.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        });
      }
    },
    // 进入考试
    beginExam: function beginExam(courseId) {
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + courseId + '&type=' + this.type + '&parent=' + this.parent + '&id=' + this.id;
    },
    //报名页面进入场景页面
    // 点击签到
    signIn: function signIn(trainId) {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkOnlineTrain/sign", {
        trainId: trainId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this4.getTrainList();
        } else {
          _this4.$alert(result.msg);
        }
      }, function (res) {
        _this4.$alert("AJAX请求接口异常（/preWorkOnlineTrain/sign）！");
      });
    },
    // 重新学习
    regoscene: function regoscene(id, trainId) {
      this.sceneId = id;
      this.trainId = trainId;
      this.$router.push({
        path: '/train/SpecialCourses',
        query: {
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId
        }
      });
    },
    //点击报名
    goscene: function goscene(id, trainId) {
      this.enlist = true;
      this.sceneId = id;
      this.trainId = trainId;

      //  this.$router.push({path:'/train/Scene',query:{
      //  sceneId:id
      //  }})
    },
    //已扫码加入qq群进入场景页面
    isenlist: function isenlist() {
      var _this5 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/applyTrainIntegrate", {
        trainId: this.trainId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          // localStorage.setItem('registration',1)
          // self.getTrainList();
          //加群二维码图片
          _this5.dimensional = true;
          // console.log(groupLink,'图片')
          _this5.dimensionalimg = result.data.groupLink;
          _this5.enlist = false, _this5.dimensional = true;
        } else {
          _this5.$alert(result.msg);
        }
      }, function (res) {
        _this5.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
      });
    },
    qqsceneId: function qqsceneId() {
      this.dimensional = false;
      this.$router.push({
        path: '/train/SpecialCourses',
        query: {
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId
        }
      });
    },
    sign_upo: function sign_upo() {
      localStorage.setItem('trainState', 'no');
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=no';
    },
    sign_up: function sign_up() {
      // console.log(this.tabMajorId,951)
      localStorage.setItem('trainState', 'no');
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=yes';
    },
    //重新学习
    returnCourseList: function returnCourseList() {
      this.badgeUrl = false;
    },
    // 去报名
    Gosignup: function Gosignup() {
      if (this.registration == null || 0) {
        window.location.href = '/tjkStudy/train/index?type=SkillUpgrade' + '&tabMajorId=' + this.tabMajorId + '&show=yes';
      }
    },
    handleClick: function handleClick(tab, event) {
      var _this6 = this;
      this.loneTab.forEach(function (item, index) {
        if (tab.name == item.name) {
          _this6.majorId = item.id;
        }
      });
    },
    //在线客服-视频观看记录
    saveTjkTrainInfoOnline: function saveTjkTrainInfoOnline() {
      var _this7 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/assitantTrain/saveWebLoginAndAssitantDown", {
        tDisplayVideo: "Yes"
      }).then(function (res) {
        var result = res.data;
        if (result.success) {} else {
          _this7.$alert(result.msg);
        }
      }, function (res) {
        _this7.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    getTabIndex: function getTabIndex() {
      for (var i = 0; i < this.tabList.length; i++) {
        if (this.tabList[i].type == this.tabType) {
          return i;
          break;
        }
      }
    },
    changeTab: function changeTab(key, type, id) {
      if (key == 2 && this.issystem == false) {
        if (this.axx == false) {
          if (this.iskey == 0) {
            this.tabType = 'SystemOperation';
            this.tabIndex = 0;
            this.dialogVisible = true;
          } else if (this.iskey == 1) {
            this.tabType = 'TaojinCulture';
            this.tabIndex = 1;
            this.dialogVisible = true;
          }
        } else {
          if (this.iskey == 1) {
            this.tabType = 'SystemOperation';
            this.tabIndex = 0;
            this.dialogVisible = true;
          }
        }
      } else if (this.issystem == false) {
        if (type != "SystemOperation") {
          window.location.href = "/tjkStudy/train/index?type=TaojinCulture" + "&tabMajorId=" + id + '&show=yes';
        } else {
          this.axx = true;
          this.$set(this, "tabIndex", key);
          this.$set(this, "tabType", type);
          //  localStorage.setItem('type',type)
        }
      } else if (this.issystem == true) {
        this.$set(this, "tabIndex", key);
        this.$set(this, "tabType", type);
        if (type != "SystemOperation") {
          window.location.href = "/tjkStudy/train/index?type=" + type + "&tabMajorId=" + id + '&show=yes';
        }
      }
    },
    //获取技能提升列表
    getTrainList: function getTrainList() {
      var _this8 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/queryTrainListWeb", {}).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this8.cseList = result.data.trainList;
          _this8.newPeopleBadgeId = result.data.newPeopleBadgeId;
          _this8.needFinish = result.data.needFinish;
          _this8.tjkId = result.data.tjkId;
          var _iterator = _createForOfIteratorHelper(_this8.trainList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;)
            //  this.trainList.forEach((item) => 
            {
              var i = _step.value;
              if (i.passState == 'signTimeOut' || i.passState == 'examUnPassed' && i.passState != 'signTimeOut' || i.passState == 'noExam') {
                _this8.registration = 0;
              } else if (i.passState == 'passed') {
                _this8.registration = 1;
                break;
              } else if (i.passState != 'noJoin' && i.sign != 'Yes' && i.passState != 'signTimeOut' && i.passState != 'examUnPassed' && i.passState != 'noExam' || i.sign == 'Yes' && i.passState != 'signTimeOut' && i.passState != 'unPassed' && i.passState != 'examUnPassed' && i.passState != 'noExam' && i.passState != 'signTimeOut') {
                _this8.registration = 1;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          ;
          localStorage.setItem('registration', _this8.registration);
          if (_this8.tabType == 'SkillUpgrade') {}
          _this8.trainState = result.data.trainState;
          if (localStorage.getItem('trainState') == 'no') {
            _this8.trainState = null;
            localStorage.setItem('trainState', '');
          }
          _this8.badgeUrl = result.data.badge ? result.data.badge.iconUrl : "";
          if (localStorage.getItem('badgeUrl') == 'false') {
            _this8.badgeUrl = false;
            setTimeout(function () {
              localStorage.setItem('badgeUrl', 'no');
            }, 1000);
          }
          _this8.content = result.data.content;
        } else {
          _this8.$alert(result.msg);
        }
      }, function (res) {
        _this8.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！");
      });
    },
    //调用小助手
    getHawkeye: function getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this9 = this;
      var data = {
        exerciseType: 'ASSITANT',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {} else {
          _this9.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this9.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    applyTask: function applyTask() {
      var _this0 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/badge/applyTaskApp').then(function (res) {
        var result = res.data;
        if (result.success) {
          _this0.status = result.data.status;
          _this0.callHawkeye();
        } else {
          _this0.$alert(result.msg);
        }
      }, function (res) {
        loading.close();
        _this0.isDisable = false;
        _this0.$alert("网络繁忙，请稍后重试！");
      });
    },
    toStudy: function toStudy(courseId, unlock, courseType, c, status) {
      var _this1 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(c.assitantType == 'AssitantSpecialRobotExam')) {
                _context.next = 2;
                break;
              }
              if (!(status == 'NoTheoryBadge')) {
                _context.next = 1;
                break;
              }
              _this1.$alert('您还不符合测试条件，请前往淘金云客服APP，点击"培训"，完成"语音客服培训"后，才能测试。');
              return _context.abrupt("return");
            case 1:
              _this1.applyTask();
              _this1.addRecord('START', 3);
              _context.next = 3;
              break;
            case 2:
              _this1.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
                courseId: courseId
              }).then(function (res) {
                var result = res.data;
                if (result.success) {
                  if (result.data.knowledgeRecordFullList.length != 1 && courseType != "Exam") {
                    _this1.$router.push({
                      path: '/train/Secondarylist',
                      query: {
                        courseId: courseId
                      }
                    });
                  } else if (courseType == "Exam") {
                    _this1.beginExam(courseId);
                    _this1.examCourseId = courseId;
                  } else {
                    _this1.$router.push({
                      path: "/vedioDetail",
                      query: {
                        courseId: courseId,
                        knowledgeSeq: result.data.knowledgeRecordFullList[0].knowledgeSeq
                      }
                    });
                  }
                } else {
                  _this1.$alert(result.msg);
                }
              }, function (res) {
                _this1.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //调用小助手引导功能
    callHawkeye: function callHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
        if (result.success) {}
      }, function (response) {});
    },
    //技能提升-报名
    joinTrain: function joinTrain(trainId, groupLink) {
      var _this10 = this;
      var self = this;
      this.$confirm('是否确认报名？', '提示', {
        confirmButtonText: '确认并加群',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this10.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/applyTrainIntegrate", {
          trainId: trainId
        }).then(function (res) {
          var result = res.data;
          // console.log(result,'加群')
          if (result.success) {
            // localStorage.setItem('registration',1)
            self.getTrainList();
            //加群二维码图片
            _this10.dimensional = true;
            // console.log(groupLink,'图片')
            _this10.dimensionalimg = groupLink;
          } else {
            _this10.$alert(result.msg);
          }
        }, function (res) {
          _this10.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainIntegrate）！");
        });
      }).catch(function () {});
    }
  }, "signIn", function signIn(trainId) {
    var _this11 = this;
    this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkOnlineTrain/sign", {
      trainId: trainId
    }).then(function (res) {
      var result = res.data;
      if (result.success) {
        window.location.href = "/tjkStudy/train/index?type=" + _this11.tabType + "&tabMajorId=" + _this11.tabMajorId + "&show=no";
      } else {
        _this11.$alert(result.msg);
      }
    }, function (res) {
      _this11.$alert("AJAX请求接口异常（/preWorkOnlineTrain/sign）！");
    });
  }), "toSceneList", function toSceneList(val) {
    var _this12 = this;
    if (val == "go") {
      window.location.href = "/tjkStudy/train/index?type=" + this.tabType + "&tabMajorId=" + this.tabMajorId + "&show=no";
    } else {
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voiceScene/queryWithStatus").then(function (res) {
        var result = res.data;
        if (result.success) {
          _this12.sceneList = result.data.list;
          _this12.description = result.data.tip;
          //判断场景完成状态

          _this12.sceneList.forEach(function (item) {
            if (item.status == "Finish") {
              _this12.decide++;
            }
          });
        } else {
          _this12.$alert(result.msg);
        }
      }, function (res) {
        _this12.$alert("AJAX请求接口异常（/voiceScene/queryWithStatus）！");
      });
    }
  }), "toCourseList", function toCourseList(id) {
    this.$router.push({
      path: "/train/courseList",
      query: {
        id: id,
        type: this.tabType,
        tabMajorId: this.tabMajorId
      }
    });
  }), "toTrainList", function toTrainList() {
    window.location.href = "/tjkStudy/train/index?type=" + this.tabType + "&tabMajorId=" + this.tabMajorId + "&show=yes";
  })
};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Scene',
  data: function data() {
    return {
      sceneList: [],
      //场景列表
      sceneId: this.$route.query.sceneId,
      //场景与课程id
      tjkId: this.$route.query.tjkId,
      //淘金客id
      trainId: this.$route.query.trainId,
      //场次id
      tabIndex: null //二级tab的index
    };
  },
  created: function created() {
    this.Scene();
  },
  methods: {
    // 返回按钮
    isreturn: function isreturn() {
      this.tabIndex = localStorage.getItem('tabIndex');
      this.$router.push({
        path: '/train/index',
        query: {
          tabIndex: this.tabIndex,
          condition: false //判断是否是基础知识点跳课程
        }
      });
    },
    //前往知识点
    goKnowledge: function goKnowledge(c) {
      console.log(c, 'dsad');
      this.$router.push({
        path: "/vedioDetail",
        query: {
          courseId: this.courseId,
          knowledgeSeq: c.knowledge.knowledgeSeq
        }
      });
    },
    //前往技能提升课程
    gocurriculum: function gocurriculum() {
      this.$router.push({
        path: '/train/SpecialCourses',
        query: {
          sceneId: this.sceneId,
          courseId: this.courseId,
          trainId: this.trainId,
          tjkId: this.tjkId
        }
      });
    },
    //三级课程
    Scene: function Scene() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voiceScene/queryWithStatus", {
        sceneId: this.sceneId
      }).then(function (res) {
        var result = res.data;
        console.log(result, '话');
        if (result.success) {
          _this.sceneList = result.data.list;
          _this.description = result.data.tip;
          //判断场景完成状态

          _this.sceneList.forEach(function (item) {
            if (item.status == "Finish") {
              _this.decide++;
            }
          });
        } else {
          _this.$alert(result.msg);
        }
      }, function (res) {
        _this.$alert("AJAX请求接口异常（/voiceScene/queryWithStatus）！");
      });
    }
  }
};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "SpecialCourses",
  data: function data() {
    return {
      hasExerciseStatus: false,
      //是否存在[考核课程排班中]
      enterGroup: {
        popwin: null,
        //
        popwinCourseId: null,
        teamGroupId: null,
        popTips: ''
      },
      courseList: [],
      //四级列表
      examCheckBtnTip: null,
      //请于%s-%s在考核群排队参加考核
      sceneId: this.$route.query.sceneId,
      //场景与课程id
      tjkId: this.$route.query.tjkId,
      //淘金客id
      trainId: this.$route.query.trainId,
      //场景id
      assitantType: this.$route.query.assitantType,
      //场景id
      scriptRelId: this.$route.query.scriptRelId,
      //淘金大学营销，随机话术脚本id
      step: 'second',
      curLinkCourseId: null,
      //当前排班,最近点过的 按钮(对外课程/对内课程)
      notification: false,
      //点击继续练习弹窗
      input: '',
      dialogVisible: false,
      //确定与对练对象对练弹窗
      istype: '',
      //保存（判断是否是特殊课程的属性）
      clickStatus: {
        recordId: null,
        clickStatus: "Yes",
        showContinue: null //用于首次 点击练习后，点停止，在不刷新界面的情况下改变按钮显隐
      },
      showEachDialog: false,
      //对练弹窗
      partner: {},
      exercisePopup: false,
      //点击点击考核弹窗
      tabIndex: null,
      //二级tab的index
      kaoheid: null,
      //考核id
      currentDuilianCourseId: null,
      //对练courseId
      theoryRemainDialog: {
        show: false,
        courseIdOfsceneId: null,
        passState: null,
        total: null,
        remain: null
      }
    };
  },
  created: function created() {
    if (localStorage.getItem('showEachDialog')) {
      if (localStorage.getItem('showEachDialog') != 0) {
        this.showEachDialog = true;
        localStorage.setItem('showEachDialog', 0);
      }
    }
    this.Lv3Courses();
    this.diaclick();

    //若是从淘金大学随机脚本页面点确定跳过来的，则本业生成一次排班
    if (localStorage.getItem('do_toKaoheDetail') == 'true') {
      localStorage.removeItem('do_toKaoheDetail');
      var businessMajorId = this.$route.query.businessMajorId;
      if (!businessMajorId) {
        this.$message({
          message: '淘金大学无关联的考核场景',
          type: 'warning',
          center: true,
          duration: 2500
        });
        return;
      }
      this.toKaoheDetail(businessMajorId);
    }
  },
  mounted: function mounted() {
    // this.isHasPri();
  },
  methods: {
    //语音岗前的
    alertTrainNoStart: function alertTrainNoStart() {
      this.$message({
        message: this.examCheckBtnTip,
        type: 'warning',
        center: true,
        duration: 4000
      });
    },
    diaclick: function diaclick() {
      var divheight = document.getElementsByClassName('step-list');
    },
    // 返回按钮
    isreturn: function isreturn() {
      localStorage.setItem('needSetDefaultTab2', 'false'); //返回上级，要求不重新定位
      this.tabIndex = localStorage.getItem('tabIndex');
      this.$router.push({
        path: '/train/index',
        query: {
          tabIndex: this.tabIndex,
          condition: false //判断是否是基础知识点跳课程
        }
      });
    },
    //前往知识点
    goKnowledge: function goKnowledge(c) {
      this.$router.push({
        path: "/vedioDetail",
        query: {
          courseId: this.courseId,
          knowledgeSeq: c.knowledge.knowledgeSeq
        }
      });
    },
    //三级课程
    Lv3Courses: function Lv3Courses() {
      var _this = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majors/queryCourseViewNewXlk", {
        majorId: this.sceneId,
        trainId: this.$route.query.trainId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this.courseList = result.data.data.courseViewList;
          self.examCheckBtnTip = result.data.examCheckBtnTip;
          _this.enterGroup = {
            popwin: result.data.data.popwin,
            popwinCourseId: result.data.data.popwinCourseId,
            teamGroupId: result.data.data.teamGroupId,
            popTips: result.data.data.popwin == 'duilian' ? '接下来进群寻找搭档进行对练' : '接下来进群排队考核'
          };
          for (var i = 0; i < _this.courseList.length; i++) {
            if (_this.courseList[i].exerciseStatus == 1) {
              _this.hasExerciseStatus = true;
              break;
            }
          }
          if (result.data.data.majorScope == 'Voice') {
            _this.isHasPri();
          }
        } else {
          if (result.msg.indexOf('培训已失效，请重新报名下一场培训') > -1) {
            _this.$alert(result.msg, '提示', {
              showClose: false,
              confirmButtonText: '确定',
              callback: function callback(action) {
                _this.isreturn();
              }
            });
          }
        }
      }, function (res) {
        _this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    enterGroupAct: function enterGroupAct() {
      var _this2 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/joinVoiceTeamGroup", {
        trainId: this.trainId,
        courseId: this.enterGroup.popwinCourseId,
        groupId: this.enterGroup.teamGroupId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          var teamGroupId = self.enterGroup.teamGroupId;
          self.enterGroup.popwin = null;
          self.enterGroup.popwinCourseId = null;
          self.enterGroup.teamGroupId = null;
          self.enterGroup.popTips = '';
          _this2.$http.get("http://127.0.0.1:26688/api/TjHawkeye/switchMenu?menu=\u6D88\u606F&id=".concat(teamGroupId)).then(function (res) {});
        } else {
          _this2.$alert(result.msg);
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/preWorkTrain/customer/joinVoiceTeamGroup）！");
      });
    },
    // 练习记录
    practise: function practise(courseId) {
      this.$router.push({
        path: '/train/eachExerciseRecordAll',
        query: {
          trainId: this.trainId,
          tjkId: this.tjkId,
          businessMajorId: this.sceneId,
          courseId: courseId
        }
      });
    },
    goThoryExamPage: function goThoryExamPage() {
      if (this.theoryRemainDialog.remain <= 0) {
        if (this.theoryRemainDialog.passState == 'passed') {
          this.$message({
            message: '今日次数已用完，请明日再来',
            type: 'warning',
            center: true,
            duration: 2500
          });
        } else {
          this.$message({
            message: '考核次数已用完，请报名下一场',
            type: 'warning',
            center: true,
            duration: 2500
          });
        }
        return;
      }
      //sceneId=100085&trainId=118&tjkId=8715266
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + this.theoryRemainDialog.courseIdOfsceneId + '&trainFlag=tjcollege&sceneId=' + this.sceneId + '&trainId=' + this.trainId + '&tjkId=' + this.tjkId + '&assitantType=' + this.assitantType;
    },
    // 进入考试
    beginExam: function beginExam(course) {
      var _this3 = this;
      //判断是否是 淘金大学营销 考试课程,是就判断一下剩余次数，显示
      var yingxiaoExamCourseId = window.location.href.indexOf('itaojin.cn') > -1 ? 10267 : 10383;
      if (yingxiaoExamCourseId == course.courseId) {
        this.theoryRemainDialog.passState = course.passState;
        this.theoryRemainDialog.courseIdOfsceneId = yingxiaoExamCourseId;
        //如果是 重新测试
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/queryTheoryRemainTimes", {
          trainId: this.trainId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            _this3.theoryRemainDialog.total = result.data.total;
            _this3.theoryRemainDialog.remain = result.data.remain;
            _this3.theoryRemainDialog.show = true;
          } else {
            _this3.$alert(result.msg);
          }
        }, function (res) {
          _this3.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTheoryRemainTimes）！");
        });
      } else {
        var trainFlag = this.$route.query.trainFlag;
        var Graduation = this.assitantType == 'VoiceGraduateExam';
        if (course.assitantType == 'VoiceGraduateExam') {
          window.location.href = '/tjkStudy/train/examDetail?courseId=' + course.courseId + '&trainFlag=VoiceGraduateExam&sceneId=' + this.sceneId + '&trainId=' + this.trainId + '&tjkId=' + this.tjkId + '&Graduation=' + Graduation + '&assitantType=' + this.assitantType;
        } else if (trainFlag == 'exercise') {
          //ps: 'theory'不从这儿过，直接从 /train/index进 /train/examDetail
          window.location.href = '/tjkStudy/train/examDetail?trainFlag=exercise&assitantType=OnlineUpgradeSkill&courseId=' + course.courseId + '&sceneId=' + this.sceneId;
        } else {
          window.location.href = '/tjkStudy/train/examDetail?courseId=' + course.courseId + '&trainFlag=' + trainFlag + '&Graduation=' + Graduation + '&assitantType=' + this.assitantType;
        }
      }
    },
    //测试记录
    testRecord: function testRecord(courseId) {
      this.$router.push({
        path: '/train/examRecordList',
        query: {
          trainId: this.trainId,
          tjkId: this.tjkId,
          businessMajorId: this.sceneId,
          courseId: courseId
        }
      });
    },
    //(普通课程)点击学习点击重新学习
    goStudy: function goStudy(c) {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var courseId, courseType, assitantType;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              courseId = c.courseId;
              courseType = c.courseType;
              assitantType = c.assitantType;
              _this4.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
                courseId: courseId
              }).then(function (res) {
                var result = res.data;
                if (result.success) {
                  if (result.data.knowledgeRecordFullList.length != 1 && courseType != "Exam") {
                    var url = c.assitantJsonObj ? c.assitantJsonObj.url : null;
                    _this4.$router.push({
                      path: '/train/Secondarylist',
                      query: {
                        courseId: courseId,
                        tjkId: _this4.tjkId,
                        CourseLevel: 3,
                        sceneId: _this4.sceneId,
                        trainId: _this4.trainId,
                        urlLink: url
                      }
                    });
                  } else if (courseType == "Exam") {
                    _this4.beginExam(c);
                    _this4.examCourseId = courseId;
                  } else {
                    _this4.$router.push({
                      path: "/vedioDetail",
                      query: {
                        courseId: courseId,
                        knowledgeSeq: result.data.knowledgeRecordFullList[0].knowledgeSeq,
                        CourseLevel: 3,
                        sceneId: _this4.sceneId,
                        trainId: _this4.trainId,
                        tjkId: _this4.tjkId,
                        knowledgeId: result.data.knowledgeRecordFullList[0].knowledgeId
                      }
                    });
                  }
                } else {
                  _this4.$alert(result.msg);
                }
              }, function (res) {
                _this4.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    isHasPri: function isHasPri() {
      var _this5 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/existExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success && result.data.data) {
          _this5.step = 'handing';
          //如果curLinkCourseId为空,则指定:已解锁 + 末尾对练课程(courseList倒着着)
          _this5.curLinkCourseId = result.data.msg;
          if (_this5.curLinkCourseId == null || _this5.curLinkCourseId == 'null') {
            for (var i = _this5.courseList.length - 1; i >= 0; i--) {
              var c = _this5.courseList[i];
              if (c.unlock == true && c.assitantType == 'PartnerCallOutExercise') {
                _this5.curLinkCourseId = c.courseId;
                break;
              }
            }
          }
        } else {
          _this5.step = 'second';
          //展示开始对练还是继续对练
        }
      });
    },
    //点击点击练习
    goDuilian: function goDuilian(type, courseId) {
      this.currentDuilianCourseId = courseId;
      var available = this.checkOperationAvailable(type);
      if (available == 'needEndKaohe') {
        this.notification = true;
      } else {
        this.showEachDialog = true;
      }
    },
    //点击结束练习
    stopPrict: function stopPrict() {
      var _this6 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/endExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this6.step = 'second';
        }
      });
    },
    goLink: function goLink(c) {
      window.location.href = c.assitantJsonObj.url;
    },
    checkOperationAvailable: function checkOperationAvailable(ope) {
      //如果点击的是考核，看当前是否是 “结束对练”按钮能点
      if (ope == 'CallOutAbilityCheck') {
        if (this.step == 'handing') {
          return 'needEndDuilian';
        }
      }
      //如果点击的是对练，看当前是否是 “结束考核”按钮能点
      if (ope == 'PartnerCallOutExercise') {
        var needStr = null;
        this.courseList.forEach(function (a) {
          if (a.assitantType == 'CallOutAbilityCheck' && a.exerciseStatus == 1) {
            needStr = 'needEndKaohe';
          }
        });
        return needStr;
      }
    },
    // 继续练习弹窗点击确定
    Clickconfirm: function Clickconfirm() {
      localStorage.setItem('showEachDialog', 1);
      this.notification = false;
      this.stopKaohePrict();
    },
    goToPrict: function goToPrict() {
      var _this7 = this;
      var patrn = /^(-)?\d+(\.\d+)?$/;
      if (!patrn.exec(this.input)) {
        this.$message({
          message: '请输入正确的淘金号',
          type: 'error'
        });
        return;
      }
      if (this.input && this.input.length < 9) {
        this.$message({
          message: '淘金号长度至少为9位',
          type: 'error'
        });
        return;
      }

      //查询是否存在当前淘金号
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + "/tjk/queryTjkList?tjkParam=".concat(this.input, "&returnAllData=1")).then(function (result) {
        if (result.data.data.length) {
          _this7.partner = result.data.data[0];
          _this7.dialogVisible = true;
        } else {
          _this7.$message({
            message: '未找到对应的对练伙伴，请重新输入淘金号',
            type: 'error'
          });
        }
      });
      // 打开打卡，然后展示正在练习
    },
    //调用小助手
    getHawkeye: function getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(function (response) {
        var result = response.data;
      }, function (response) {});
    },
    ureGoToPri: function ureGoToPri() {
      var _this8 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/ready?tjkId=".concat(this.partner.id, "&assitantTjkId=").concat(this.tjkId, "&returnAllData=1&courseId=").concat(this.currentDuilianCourseId)).then(function (result) {
        if (result.data.success) {
          _this8.getHawkeye();
          _this8.input = '';
          _this8.step = 'handing';
          _this8.dialogVisible = false;
          _this8.showEachDialog = false;
        } else {
          if (result.data.msg && result.data.msg.indexOf('不能有多个语音订单排班') > -1) {
            _this8.$message({
              message: '请先结束对练 或者结束考核',
              type: 'error'
            });
          } else {
            _this8.$message({
              message: result.data.msg,
              type: 'error'
            });
          }
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (res) {
        done();
      }).catch(function (res) {});
    },
    //清空排版数据
    clearSchedule: function clearSchedule() {
      this.$http.get('http://127.0.0.1:26688/api/SignIn/clearScheduleCache').then(function (res) {});
      this.sureGoToPri();
    },
    stopKaohePrict: function stopKaohePrict() {
      var _this9 = this;
      var self = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voiceExerciseCustomer/endExamExercise?assitantTjkId=".concat(this.tjkId, "&returnAllData=1")).then(function (result) {
        if (result.data.success) {
          _this9.$router.go(0);
        }
      });
    },
    showRandomScript: function showRandomScript(c) {
      this.$router.push({
        path: "/train/CallOutRandomScript",
        query: {
          courseId: c.courseId,
          assitantType: c.assitantType,
          businessMajorId: c.businessMajorId,
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId
        }
      });
    },
    //--在线进入实操--点击练习，测试
    GoPracticalOperation: function GoPracticalOperation(type, id, courseId, key, name) {
      this.$router.push({
        path: '/train/OnInline',
        query: {
          page: 'shichao',
          type: type,
          courseId: courseId,
          id: id,
          knowledgeSeq: key + 1,
          key: key + 1,
          courseName: name,
          CourseLevel: 3,
          sceneId: this.sceneId
        }
      });
    },
    //--在线进入实操--点击练习记录
    Gorecord: function Gorecord(type, id) {
      this.$router.push({
        path: "/train/OperationRecord",
        query: {
          type: type,
          id: id
        }
      });
    },
    toChildCourse: function toChildCourse(courseId, assitantType, businessMajorId) {
      var available = this.checkOperationAvailable(assitantType);
      if (available == 'needEndDuilian') {
        this.istype = assitantType;
        this.exercisePopup = true;
        this.kaoheid = businessMajorId;
      } else {
        if (assitantType == 'PartnerCallOutExercise') {
          //对练
          this.$router.push({
            path: '/train/partnerIndex',
            query: {
              id: this.sceneId,
              type: null,
              tabMajorId: null,
              show: null
            }
          });
        } else if (assitantType == 'CallOutAbilityCheck') {
          //考核
          this.toKaoheDetail(businessMajorId, courseId);
        }
      }
    },
    toKaoheDetail: function toKaoheDetail(majorId, courseId) {
      var _this0 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/voiceExerciseCustomer/examReady', {
        'id': majorId,
        'trainId': this.trainId,
        'courseId': courseId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this0.Lv3Courses();
          _this0.toSign(majorId);
        } else {
          _this0.$alert(result.msg);
          // this.$alert("你考核未合格，请重新报名参加培训");
        }
      }, function (response) {
        _this0.$alert('AJAX访问接口异常！');
      });
    },
    toSign: function toSign(id) {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=1').then(function (response) {}, function (response) {});
    },
    //点击考核弹窗确定
    exerciseClickconfirm: function exerciseClickconfirm() {
      this.stopPrict();
      if (this.istype == 'PartnerCallOutExercise') {
        //对练
        this.$router.push({
          path: '/train/partnerIndex',
          query: {
            id: this.sceneId,
            type: this.istype,
            tabMajorId: this.tabMajorId
          }
        });
      } else if (this.istype == 'CallOutAbilityCheck') {
        //考核
        this.toKaoheDetail(this.kaoheid);
      }
      this.exercisePopup = false;
    },
    sureGoToPri: function sureGoToPri() {
      var _this1 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/voice/exercise/ready?tjkId=".concat(this.partner.id, "&assitantTjkId=").concat(this.tjkId, "&returnAllData=1&courseId=").concat(this.currentDuilianCourseId)).then(function (result) {
        if (result.data.success) {
          _this1.$router.go(0);
          _this1.getHawkeye();
          _this1.input = '';
          _this1.step = 'handing';
          _this1.dialogVisible = false;
          _this1.showEachDialog = false;
        } else {
          if (result.data.msg && result.data.msg.indexOf('不能有多个语音订单排班') > -1) {
            _this1.$message({
              message: '请先结束对练 或者结束考核',
              type: 'error'
            });
          } else {
            _this1.$message({
              message: result.data.msg,
              type: 'error'
            });
          }
        }
      });
    }
  }
};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "CallOutRandomScript",
  data: function data() {
    return {
      courseId: this.$route.query.courseId,
      assitantType: this.$route.query.assitantType,
      businessMajorId: this.$route.query.businessMajorId,
      sceneId: this.$route.query.sceneId,
      trainId: this.$route.query.trainId,
      tjkId: this.$route.query.tjkId,
      seconds: 1 * 60,
      //1min，给客服的准备时间
      time: null,
      randomScript: {
        //随机考核话术
        show: false,
        relId: null,
        asking: null,
        courseId: null,
        intro: null,
        script: null,
        title: null
      }
    };
  },
  created: function created() {
    this.showRandomScript();
    this.startTime();
  },
  mounted: function mounted() {},
  methods: {
    // 返回按钮
    isreturn: function isreturn() {
      this.$router.go(-1);
    },
    // 返回按钮
    goKaohe: function goKaohe() {
      if (this.randomScript == null) {
        this.$message({
          message: '未配置随机脚本',
          type: 'warning',
          center: true,
          duration: 2500
        });
        return;
      }
      localStorage.setItem('do_toKaoheDetail', 'true');
      this.$router.push({
        path: "/train/SpecialCourses",
        query: {
          courseId: this.courseId,
          assitantType: this.assitantType,
          businessMajorId: this.businessMajorId,
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId,
          scriptRelId: this.randomScript.relId
        }
      });
    },
    showRandomScript: function showRandomScript() {
      var _this = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/courseTjcollege/randomScript', {
        "trainId": this.trainId
      }).then(function (response) {
        var result = response.data;
        if (result.success) {
          self.randomScript = result.data;
          if (self.randomScript == null) {
            _this.$message({
              message: '随机脚本为空，刷新一下缓存或联系管理员',
              type: 'warning',
              center: true,
              duration: 2500
            });
          }
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    startTime: function startTime() {
      var self = this;
      //若是我(prd,test)或者海建（prd,test）则设定3秒
      if (self.tjkId == 558306 || self.tjkId == 8715266 || self.tjkId == 1434675 || self.tjkId == 8716027) {
        self.seconds = 3;
      }
      var timer = setInterval(function () {
        self.seconds--;
        if (self.seconds >= 0) {
          var sec = parseInt(self.seconds);
          var min = 0;
          var hour = 0;
          if (sec > 60) {
            min = parseInt(sec / 60);
            sec = parseInt(sec % 60);
            if (min > 60) {
              hour = parseInt(min / 60);
              min = parseInt(min % 60);
            }
          }
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (hour > 0) {
            self.time = "".concat(hour, ":").concat(min, ":").concat(sec);
          } else {
            self.time = "".concat(min, ":").concat(sec);
          }
        } else {
          clearInterval(timer);
          self.time = '时间到';
        }
      }, 1000);
    }
  }
};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "Sessions",
  data: function data() {
    return {
      trainId: this.$route.query.trainId,
      trainTitle: this.$route.query.trainTitle,
      //上个场景页面的title
      SessionsList: [],
      //场景列表
      trainContent: this.$route.query.trainContent //场景文本框内容
    };
  },
  created: function created() {
    this.signUp();
    console.log(this.$route.query);
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)({
    // 返回按钮
    isreturn: function isreturn() {
      this.$router.go(-1);
    },
    signUp: function signUp() {
      var _this = this;
      {
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/signList", {
          trainId: this.trainId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            _this.SessionsList = result.data.signList;
            console.log(_this.SessionsList, 77777);
          } else {
            _this.$alert(result.msg); //因为需要查看课程列表所以屏蔽
          }
        }, function (res) {
          _this.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        });
      }
    }
  }, "signUp", function signUp() {
    var _this2 = this;
    this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkTrain/customer/signList", {
      trainId: this.trainId
    }).then(function (res) {
      var result = res.data;
      if (result.success) {
        _this2.SessionsList = result.data.signList;
        console.log(_this2.SessionsList, 77777);
      } else {
        _this2.$alert(result.msg); //因为需要查看课程列表所以屏蔽
      }
    }, function (res) {
      _this2.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
    });
  }), "GoSignin", function GoSignin(seqId) {
    var _this3 = this;
    var self = this;
    this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/preWorkOnlineTrain/sign?", {
      seqId: seqId
    }).then(function (res) {
      var result = res.data;
      if (result.success) {
        _this3.signUp();
        // this.SessionsList=result.data.signList
        // console.log(this.SessionsList,77777)
      } else {
        _this3.$alert(result.msg);
      }
    }, function (res) {
      _this3.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
    });
  })
};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OnInline',
  data: function data() {
    var _ref;
    return _ref = {
      tjkInfo: {},
      collegeType: this.$route.query.collegeType,
      page: this.$route.query.page,
      //判断是在线那个页面跳过来的
      type: this.$route.query.type,
      id: this.$route.query.id,
      assitantType: this.$route.query.assitantType,
      courseId: this.$route.query.courseId,
      knowledgeSeq: this.$route.query.knowledgeSeq,
      // courseName:this.$route.query.courseName,//实操页面每一个实操课程名字
      QiannuiiframeURL: '',
      //跳转千牛页面的地址
      nextobject: {},
      //当前知识点数据（相邻知识点数据）
      knowledgename: '',
      //当前知识点名字
      nextknowledgename: '',
      //下一个知识点名字
      nowCoursestate: '',
      //当前的课程状态
      nowCoursestatetext: '',
      //当前的课程状态的弹窗文字
      Coursestate: ''
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "nowCoursestate", ''), "nowCoursestatetext", ''), "categoryName", ''), "tabstate", null), "nextcategoryName", ''), "currency", false), "knowledgestate", null), "tjkAnswer", false), "speedfraction", ''), "Jump", null), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "theoryBadge", this.$route.query.theoryBadge), "majorId", null), "knowledgeId", this.$route.query.knowledgeId), "CourseLevel", this.$route.query.CourseLevel), "dazhiJump", false), "Operation", false), "sceneId", this.$route.query.sceneId), "imUrl", {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.imUrl), "imToken", {"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.imToken);
  },
  created: function created() {
    if (localStorage.getItem('majorId')) {
      this.majorId = localStorage.getItem('majorId');
    }
    console.log(this.$route.query, '跳转');
    this.getCourseDetail();
    this.iframeURLsrc();
    this.getCustomerUser();
  },
  methods: {
    goindex: function goindex() {
      this.$router.push({
        path: '/train/index'
      });
    },
    getCustomerUser: function getCustomerUser() {
      var _this = this;
      this.$http.get('/customer/action/currentUser/customerUser').then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.tjkInfo = result.data;
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('AJAX访问接口异常！');
      });
    },
    //查看当前知识点（相邻知识点）
    getCourseDetail: function getCourseDetail() {
      var _this2 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/course/getGuideDialog', {
        'courseId': this.courseId,
        'knowledgeId': this.knowledgeId
      }).then(function (res) {
        var result = res.data;
        console.log(result, '知识点');
        if (result.success) {
          // this.guidePopMsg=result.data.current.knowledge.guidePopMsg
          _this2.knowledge = result.data.current;
          _this2.nextobject = result.data;
          if (_this2.nextobject.next) {
            _this2.knowledgeId = _this2.nextobject.next.knowledgeId;
          }
          if (_this2.nextobject.next && !_this2.nextobject.nextCourse && !_this2.nextobject.nextCourse) {
            _this2.knowledgestate = 1; //知识点跳知识点
            _this2.knowledgeId = _this2.nextobject.next.knowledgeId;
            _this2.knowledgename = _this2.nextobject.current.title;
            _this2.nextknowledgename = _this2.nextobject.next.title;
            if (_this2.nextobject.next.assitantType == 'jingmaiexam' || _this2.nextobject.next.assitantType == 'qianniuexam' || _this2.nextobject.next.assitantType == 'workorderjushuitanexam') {
              _this2.Operation = true;
            }
          } else if (!_this2.nextobject.nextCategory && _this2.nextobject.nextCourse) {
            _this2.knowledgestate = 2; //知识点跳课程
            _this2.knowledgename = _this2.nextobject.currentCourse.courseName;
            _this2.nextknowledgename = _this2.nextobject.nextCourse.courseName;
            if (_this2.nextobject.currentCourse.courseType == 'Exam') {
              _this2.nowCoursestate = 'Exam';
              _this2.nowCoursestatetext = '测试';
            } else if (_this2.nextobject.currentCourse.courseType == 'Integrate' && _this2.nextobject.currentCourse.assitantType) {
              if (_this2.nextobject.currentCourse.assitantType == 'CallOutAbilityCheck') {
                _this2.nowCoursestate = 'Exam';
                _this2.nowCoursestatetext = '测试';
              } else {
                _this2.nowCoursestate = 'Practice';
                _this2.nowCoursestatetext = '练习';
              }
            } else if (_this2.nextobject.currentCourse.courseType == 'Integrate' && !_this2.nextobject.currentCourse.assitantType) {
              _this2.nowCoursestate = 'Study';
              _this2.nowCoursestatetext = '学习';
            }
            if (_this2.nextobject.nextCourse.courseType == 'Exam' || _this2.nextobject.nextCourse.assitantType == 'AssitantSpecialRobotExam') {
              _this2.Coursestate = 'Exam';
            } else if (_this2.nextobject.nextCourse.courseType == 'Integrate' && _this2.nextobject.nextCourse.assitantType) {
              _this2.Coursestate = 'Practice';
            } else if (_this2.nextobject.nextCourse.courseType == 'Integrate' && !_this2.nextobject.nextCourse.assitantType) {
              _this2.Coursestate = 'Study';
            }
          } else if (_this2.nextobject.nextCategory) {
            _this2.knowledgestate = 2;
            _this2.categoryName = _this2.nextobject.currentCategory.categoryName;
            var ismajorId = localStorage.getItem('majorId');
            _this2.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/courseCategory/queryListXlk", {
              majorId: ismajorId
            }).then(function (res) {
              var result = res.data;
              if (result.success) {
                var relist = result.data;
                if (_this2.nextobject.nextCategory) {
                  if (_this2.nextobject.nextCategory == null) {
                    _this2.tabstate = 1;
                  } else {
                    _this2.tabstate = 2;
                    _this2.nextobject.nextCategory.assitantType;
                    relist.forEach(function (item, index) {
                      if (item.assitantType == _this2.nextobject.nextCategory.assitantType) {
                        if (_this2.nextobject.nextCategory.assitantType == 'OnlineUpgradeSkill') {
                          _this2.nextcategoryName = _this2.nextobject.theoryBadge == false ? '理论培训' : '实操培训';
                        } else if (_this2.nextobject.assitantType == 'VoiceUpgradeSkill') {
                          _this2.nextcategoryName = '语音技能提升';
                        } else if (_this2.nextobject.nextCategory.assitantType == 'SysOperate') {
                          _this2.dazhiJump = true;
                        } else {
                          _this2.nextcategoryName == item.categoryName;
                        }
                      }
                    });
                  }
                }
              } else {
                _this2.$alert(result.msg);
              }
            }, function (res) {
              _this2.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
            });
          } else if (!_this2.nextobject.next && !_this2.nextobject.nextCourse && !_this2.nextobject.nextCategory) {
            _this2.knowledgestate = 2;
            _this2.categoryName = _this2.nextobject.currentCategory.categoryName;
            _this2.tabstate = 1;
          }
        } else {
          _this2.$alert(result.msg);
        }
      }, function (res) {
        _this2.$alert("AJAX请求接口异常（/course/getKnowledgeListXlk）！");
      });
    },
    // 返回按钮
    isreturn: function isreturn() {
      var prevRoutePath = sessionStorage.getItem('prevRoutePath');
      if (prevRoutePath === '/train/Secondarylist') {
        window.history.back();
      } else if (this.page == 'dazi') {
        this.$router.push({
          path: '/train/index'
        });
      } else {
        this.$router.push({
          path: '/train/Secondarylist',
          query: {
            courseId: this.courseId,
            collegeType: this.$route.query.collegeType
          }
        });
      }
    },
    iframeURLsrc: function iframeURLsrc() {
      var showanswerParam = this.$route.query.showanswer && this.$route.query.showanswer === 'false' ? '&showanswer=false' : '';
      if (this.type == 'qianniu') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/newqianniu?type=-1&id=-100&OnInline=true';
      } else if (this.type == 'workorderjushuitan') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/jushuitanerpStudy?OnInline=true' + (this.courseId ? '&courseId=' + encodeURIComponent(this.courseId) : '') + (this.knowledgeId ? '&knowledgeId=' + encodeURIComponent(this.knowledgeId) : '');
      } else if (this.type == 'qianniuexam') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/newqianniuexam?type=-1&id=-99&OnInline=true';
      } else if (this.type == 'workorderjushuitanexam') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/jushuitanerpexam?OnInline=true' + (this.courseId ? '&courseId=' + encodeURIComponent(this.courseId) : '');
      } else if (this.type == 'jingmai') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/jmStudy?type=-1&id=-98&OnInline=true';
      } else if (this.type == 'jingmaiexam') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/jmExam?type=-1&id=-97&OnInline=true';
      } else if (this.type == 'wpsexcel') {
        this.QiannuiiframeURL = '/tjkStudy/newexcel?OnInline=true';
      } else if (this.type == 'wpsexcelexam') {
        this.QiannuiiframeURL = '/tjkStudy/excelstudy?OnInline=true';
      } else if (this.type == 'sougouinput') {
        this.QiannuiiframeURL = '/tjkStudy/typewriting?OnInline=true';
      } else if (this.type == 'sougouinputexam') {
        this.QiannuiiframeURL = '/tjkStudy/typewritingstudy?OnInline=true';
      } else if (this.type == 'feige') {
        this.QiannuiiframeURL = '/tjkStudy/feiGeTrain?OnInline=true';
      } else if (this.type == 'feigeexam') {
        this.QiannuiiframeURL = '/tjkStudy/feiGeTrainExam?OnInline=true';
      } else if (this.type == 'primary') {
        this.QiannuiiframeURL = '/cloudtraining/customer/scene/?type=0&abilityType=1&id=' + this.id + showanswerParam + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=2' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '');
      } else if (this.type == 'middle') {
        this.QiannuiiframeURL = '/cloudtraining/customer/scene/?type=0&abilityType=2&id=' + this.id + showanswerParam + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=4' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '');
      } else if (this.type == 'high') {
        var param = this.collegeType == 'allSaleExam' ? 'collegeType=high&' : ''; //记录类型，传到对练系统，记录结果存到college里
        this.QiannuiiframeURL = '/cloudtraining/customer/scene/?' + param + 'type=0&abilityType=2&id=' + this.id + showanswerParam + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=5' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '');
      } else if (this.type == 'aftersaleprimary') {
        this.QiannuiiframeURL = '/cloudtraining/customer/scene/?type=0&abilityType=1&id=' + this.id + showanswerParam + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=2' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '');
      } else if (this.type == 'aftersalemiddle') {
        this.QiannuiiframeURL = '/cloudtraining/customer/scene/?type=0&abilityType=1&id=' + this.id + showanswerParam + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=4' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '');
      } else if (this.type == 'aftersalehigh') {
        var param = this.collegeType == 'allSaleExam' ? 'collegeType=aftersalehigh&' : '';
        this.QiannuiiframeURL = '/cloudtraining/customer/scene/?' + param + 'type=0&abilityType=1&id=' + this.id + showanswerParam + '&readurl=http://t.itaojin.cn/pages/article.html?id=103&psure=5' + (this.assitantType ? '&assitantType=' + encodeURIComponent(this.assitantType) : '') + (this.courseId ? '&courseId=' + this.courseId : '');
      } else if (this.page == 'dazi') {
        this.QiannuiiframeURL = '/tjkStudy/examTyping/10063?OnInline=true';
      } else if (this.type == 'qianniuexam_11618') {
        //双11 618
        this.QiannuiiframeURL = '/tjkStudy/simulate/newqianniuexam_11618?type=-1&id=-99&OnInline=true';
      } else if (this.type == 'jingmaiexam_11618') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/jmExam_11618?type=-1&id=-97&OnInline=true';
      } else if (this.type == 'feigeexam_11618') {
        this.QiannuiiframeURL = '/tjkStudy/feiGeTrainExam_11618?OnInline=true';
      } else if (this.type == 'pdd') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/pddStudy?OnInline=true';
      } else if (this.type == 'pddexam') {
        this.QiannuiiframeURL = '/tjkStudy/simulate/pddExam?OnInline=true';
      }
    },
    //点击前往下一个课程或知识点
    determine: function determine() {
      var _this3 = this;
      if (this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory) {
        var assitantType = this.nextobject.next.assitantType;
        if (assitantType != null && (assitantType.indexOf('qianniu') > -1 || assitantType.indexOf('jingmai') > -1 || assitantType.indexOf('feige') > -1 || assitantType.indexOf('wpsexcel') > -1 || assitantType.indexOf('sougouinput') > -1 || assitantType.indexOf('pdd') > -1 || assitantType.indexOf('workorderjushuitan') > -1)) {
          window.location.href = "/tjkStudy/train/OnInline?type=" + assitantType + '&courseId=' + this.nextobject.next.courseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&knowledgeId=' + this.nextobject.next.knowledgeId;
        } else {
          this.nextcourseId = this.nextobject.next.courseId;
          window.location.href = "/tjkStudy/vedioDetail?courseId=" + this.nextcourseId + '&knowledgeSeq=' + this.nextobject.next.knowledgeSeq + '&CourseLevel=' + this.CourseLevel + '&sceneId=' + this.$route.query.sceneId + '&assitantTjkId=' + this.$route.query.tjkId + '&tjkId=' + this.$route.query.tjkId + '&trainId=' + this.$route.query.trainId + '&knowledgeId=' + this.knowledgeId;
        }
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse && this.nextobject.next) {
        this.nextcourseId = this.nextobject.nextCourse.courseId;
        this.toStudy();
      } else if (!this.nextobject.nextCategory && this.nextobject.nextCourse) {
        this.nextcourseId = this.nextobject.nextCourse.courseId;
        this.gotoStudy();
      } else if (this.nextobject.nextCategory) {
        var ismajorId = localStorage.getItem('majorId');
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/courseCategory/queryListXlk", {
          majorId: ismajorId
        }).then(function (res) {
          var result = res.data;
          if (result.success) {
            var relist = result.data;
            if (_this3.nextobject.nextCategory) {
              if (_this3.nextobject.nextCategory == null) {
                _this3.tabstate = 1;
              } else {
                _this3.tabstate = 2;
                relist.forEach(function (item, index) {
                  if (item.assitantType == _this3.nextobject.nextCategory.assitantType) {
                    if (_this3.nextobject.nextCategory.assitantType == 'OnlineUpgradeSkill') {
                      localStorage.setItem('tabIndex', index);
                      localStorage.setItem('majorId', item.majorId);
                    } else if (_this3.nextobject.assitantType == 'VoiceUpgradeSkill') {
                      localStorage.setItem('tabIndex', index);
                      localStorage.setItem('majorId', item.majorId);
                    } else {
                      localStorage.setItem('tabIndex', index);
                      localStorage.setItem('majorId', item.majorId);
                      localStorage.setItem('categoryId', item.categoryId);
                    }
                  }
                });
              }
            }
            _this3.$router.push({
              path: '/train/index'
            });
          } else {
            _this3.$alert(result.msg);
          }
        }, function (res) {
          _this3.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
        });
      }
    },
    test: function test(i) {
      console.log(i, '穿过来了');
      if (i) {
        this.speedfraction = i;
        this.tjkAnswer = true;
      }
      console.log(i, '分数');
      this.currency = true;
    },
    gotoStudy: function gotoStudy() {
      var _this4 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.nextcourseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
            _this4.$router.push({
              path: '/train/Secondarylist',
              query: {
                courseId: _this4.nextcourseId
              }
            });
          } else if (_this4.CourseLevel == 3) {
            _this4.$router.back();
          } else {
            _this4.tabIndex = localStorage.getItem('tabIndex');
            _this4.$router.push({
              path: '/train/index',
              query: {
                tabIndex: _this4.tabIndex,
                condition: true //判断是否是基础知识点跳课程
              }
            });
          }
        } else {
          _this4.$alert(result.msg);
        }
      }, function (res) {
        _this4.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    },
    toStudy: function toStudy() {
      var _this5 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
        courseId: this.nextcourseId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && result.data.knowledgeRecordFullList.length != 0) {
            _this5.$router.push({
              path: '/train/Secondarylist',
              query: {
                courseId: _this5.nextcourseId
              }
            });
          } else if (_this5.CourseLevel == 3) {
            _this5.$router.back();
          } else if (result.data.knowledgeRecordFullList.length == 1) {
            window.location.href = '/tjkStudy/vedioDetail?courseId=' + _this5.nextcourseId + '&knowledgeSeq=' + _this5.nextobject.next.knowledgeSeq + '&CourseLevel=' + _this5.CourseLevel + '&sceneId=' + _this5.$route.query.sceneId + '&assitantTjkId=' + _this5.$route.query.tjkId + '&tjkId=' + _this5.$route.query.tjkId + '&trainId=' + _this5.$route.query.trainId + '&knowledgeId=' + _this5.knowledgeId;
          }
        } else {
          _this5.$alert(result.msg);
        }
      }, function (res) {
        _this5.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    window["goBack"] = function (i) {
      self.test(i);
    };
  }
};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OperationRecord',
  data: function data() {
    return {
      type: this.$route.query.type,
      id: this.$route.query.id,
      QiannuiiframeURL: '' //内嵌地址
    };
  },
  created: function created() {
    this.Gorecord();
  },
  methods: {
    isreturn: function isreturn() {
      this.$router.go(-1);
    },
    Gorecord: function Gorecord() {
      if (this.type == 'primary' || this.type == 'middle' || this.type == 'high' || this.type == 'aftersaleprimary' || this.type == 'aftersalemiddle' || this.type == 'aftersalehigh' || this.type == 'fbt') {
        this.QiannuiiframeURL = '/cloudtraining/customer/sceneRecords?pageName=clouding&pageTitle=模拟练习&id=' + this.id;
      }
    }
  }
};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
var _methods; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      data: {
        positionX: 0,
        positionY: 0
      },
      OnInline: 'false',
      //小助手跳转
      tabIndex: 1,
      //序号
      tabCurrent: 'zero',
      //当前标签页
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      isOpenPpt7: false,
      //是否展开ppt
      isOpenPpt8: false,
      //是否展开ppt
      isOpenPpt9: false,
      //是否展开ppt
      isOpenPpt10: false,
      //是否展开ppt
      isOpenPpt11: false,
      //是否展开ppt
      isOpenPpt12: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示wps图标
      isShowQnIcon2: false,
      //点击wps图标
      isShowQnIcon3: false,
      //移入新建
      isShowQnIcon4: false,
      //点击新建后
      isShowQnIcon5: false,
      //鼠标移入新建表格
      isShowQnIcon6: false,
      //点击新建表格
      isShowQnIcon7: false,
      //移入空白文档
      isShowQnIcon8: false,
      //点击空白文档
      isShowQnIcon9: false,
      //点击空白文档延时两秒
      isShowQnIcon10: false,
      //点击B列
      isShowQnIcon11: false,
      //点击B列延时两秒
      isShowQnIcon12: false,
      //点击第6行
      isShowQnIcon13: false,
      //点击第6行延时两秒
      isShowQnIcon14: false,
      //点击第6行第三个单元格

      isShowLoginImg: false,
      //是否显示电竞图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      isShownr1_1: true,
      //是否显示J第2步第一张图片
      isShownr1_2: false,
      //点击J2单元框
      nr_input: '',
      //J2输入框
      isShownr1_3: false,
      //敲下回车键后
      isShownr1_3_1: false,
      //敲下回车键后延时两秒
      isShownr1_4: false,
      //点击A3
      nr_input2: '',
      //A3输入框
      isShownr1_5: false,
      //按下ctrl+；
      isShownr1_6: false,
      //按下enter
      isShownr1_6_1: false,
      //按下enter延时两秒
      isShownr1_7: false,
      //点击A（下托前）
      isShownr1_8: false,
      //按下ctrl+c
      isShownr1_9: false,
      //按下ctrl+c延时两秒
      isShownr1_10: false,
      //按下ctrl+V
      isShownr1_11: false,
      //按下ctrl+V延时两秒
      isShownr1_12: false,
      //点击c列
      isShownr1_13: false,
      //c列鼠标点击右键
      isShownr1_14: false,
      //键鼠标移入插入列
      isShownr1_15: false,
      //点击右键鼠标移入插入列
      isShownr1_16: false,
      //点击右键鼠标移入插入列延长两秒
      isShownr1_17: false,
      //点击第六6行
      isShownr1_17_1: false,
      //点击右键
      isShownr1_17_2: false,
      //点击右键移入
      isShownr1_17_3: false,
      //右键点击
      isShownr1_18: false,
      //右键点击以后的页面
      isShownr1_19: false,
      //过渡求和页面
      isShowqh1_1: false,
      //点击I3
      isShowqh1_2: false,
      //点击F3
      isShowqh1_3: false,
      //点击G3
      isShowqh1_4: false,
      //点击H3
      qh1_input: '',
      //求和输入框
      qh1_input1: '',
      //求和输入框
      isShowqh1_5: false,
      //按下enter
      // 平均
      isShowpj1_1: false,
      //延时两秒（显示求和页面）
      isShowpj1_2: false,
      //点击J3
      isShowpj1_3: false,
      //点击I3
      isShowpj1_4: false,
      //按下enter
      pj_input1: '293',
      //I3输入框
      pj1_input: '',
      //I3输入框
      // 总分
      isShowzf1_1: false,
      //k3平均页面显示
      isShowzf1_2: false,
      //点击K3单元格
      isShowzf1_3: false,
      //点击I3单元格
      isShowzf1_4: false,
      //点击I3单元格
      isShowzf1_5: false,
      //按下enter

      zf1_input: '',
      //E3输入框

      //修改第一张
      isShowxg1_1: false,
      //延时两秒（显示新建页面）
      isShowxg1_2: false,
      //点击下方的Sheet1
      xg_input1: 'Sheet1',
      //Sheet1修改输入框
      isShowxg1_3: false,
      //按下enter
      //新建
      isShowxj1_1: false,
      //按下enter延时两秒显示新建页面
      isShowxj1_2: false,
      //移入+号
      isShowxj1_3: false,
      //点击+号
      //占比
      isShowzb1_1: false,
      //占比页面显示
      isShowzb1_2: false,
      //点击C3
      isShowzb1_3: false,
      //点击B3
      isShowzb1_4: false,
      //点击A3
      zb_input1: '',
      //A3输入框
      isShowzb1_5: false,
      //按下enter
      //修改第二张
      isShowxg2_1: false,
      //延时两秒显示第二张修改页面
      isShowxg2_2: false,
      //点击下面的Sheet2
      xg_input2: 'Sheet2',
      //下面Sheet2输入框
      isShowxg2_3: false,
      //按下enter

      // 第三步
      isShowzt1_1: true,
      //是否显示第三步第一张图片
      isShowzt1_2: false,
      //鼠标移入字体样式
      isShowzt1_3: false,
      //鼠标点击字体样式
      isShowzt1_4: false,
      //鼠标移入微软雅黑
      isShowzt1_5: false,
      //鼠标点击微软雅黑
      // 居中
      isShowjz1_1: false,
      //延时两秒显示居中页面
      isShowjz1_2: false,
      //鼠标移入居中
      isShowjz1_3: false,
      //鼠标点击居中
      // 框线
      isShowkx1_1: false,
      //延迟两秒显示框线页面
      isShowkx1_2: false,
      //鼠标移入框线
      isShowkx1_3: false,
      //鼠标点击框线
      isShowkx1_4: false,
      //鼠标移入所有框线
      isShowkx1_5: false,
      //鼠标点击所有框线
      // 调A列
      // isShowta1_1:false,//延迟两秒调整A页面显示
      isShowta1_2: false,
      //移到A列
      isShowta1_3: false,
      //点击A列
      // 加粗合并第一行
      isShowjchb1_1: false,
      //延迟两秒显示加粗合并第一行页面
      isShowjchb1_2: false,
      //鼠标移入大号字体
      isShowjchb1_3: false,
      //鼠标点击大号字体（第一次）
      isShowjchb1_4: false,
      //鼠标点击大号字体（第二次）
      isShowjchb1_5: false,
      //鼠标移入字体加粗
      isShowjchb1_6: false,
      //鼠标点击字体加粗
      isShowjchb1_7: false,
      //鼠标移入居中合并
      isShowjchb1_8: false,
      //鼠标点击居中合并
      isShowjchb1_9: false,
      //鼠标移入设置颜色
      isShowjchb1_10: false,
      //鼠标移入颜色
      isShowjchb1_11: false,
      //鼠标点击颜色
      isShowjchb1_12: false,
      //
      //颜色换行第二行
      isShowyshh1_1: false,
      //延时两秒第二行颜色换行页面显示
      isShowyshh1_2: false,
      //鼠标移入更换字体颜色
      isShowyshh1_3: false,
      //鼠标点击更换字体颜色
      isShowyshh1_4: false,
      //鼠标移入自动换行
      isShowyshh1_5: false,
      //鼠标点击自动换行
      // 冻结
      isShowdj1_1: false,
      //延时两秒冻结页面显示
      isShowdj1_2: false,
      //鼠标移入冻结窗格
      isShowdj1_3: false,
      //鼠标点击冻结窗格
      isShowdj1_4: false,
      //鼠标移入冻结第二行
      isShowdj1_5: false,
      //鼠标点击冻结第二行
      // isShownr1_16:false,//插入列后延迟两秒
      // 保留小数
      isShowxs1_1: false,
      //延迟两秒保留小数页面显示
      isShowxs1_2: false,
      //鼠标移入常规
      isShowxs1_3: false,
      //点击常规下标
      isShowxs1_4: false,
      //鼠标移入其他数字格式
      isShowxs1_5: false,
      //鼠标点击其他数字格式
      isShowxs1_6: false,
      //鼠标点击数值
      isShowxs1_7: false,
      //鼠标移入输入框
      isShowxs1_8: false,
      //鼠标点击减号输入框
      isShowxs1_9: false,
      //鼠标移动到确定
      isShowxs1_10: false,
      //鼠标点击确定
      //占比保留两位小数
      isShowzbbl1_1: false,
      //延时两秒显示占比保留两位小数页面
      isShowzbbl1_2: false,
      //鼠标移入常规
      isShowzbbl1_3: false,
      //点击常规下标
      isShowzbbl1_4: false,
      //鼠标移动到%
      isShowzbbl1_5: false,
      //鼠标点击%
      // 第四步
      // 保存文件
      isShowbc1_1: true,
      //是否显示第四步第一张图片
      bc_input1: '66.67%',
      //保存第一张图的输入框（用于监听ctrl+s）
      isShowbc1_2: false,
      //监听ctrl+s
      isShowbc1_3: false,
      //鼠标移入我的桌面
      isShowbc1_4: false,
      //鼠标点击我的桌面
      isShowbc1_5: false,
      //鼠标点击办公软件培训
      isShowbc1_6: false,
      //鼠标点击文件名
      isShowbc1_7: false,
      //再点击一次
      isShowbc1_8: false,
      //显示输入框
      bc_input2: '',
      isShowbc1_9: false,
      //点击确定
      //另存为
      isShowlc1_1: false,
      //延时两秒显示另存页面
      isShowlc1_2: false,
      //点击右键
      isShowlc1_3: false,
      //鼠标移入另存为
      isShowlc1_4: false,
      //鼠标点击另存为
      isShowlc1_5: false,
      //鼠标移入我的桌面
      isShowlc1_6: false,
      //鼠标点击我的桌面
      isShowlc1_7: false,
      //鼠标点击保存
      // 第五步
      // 发送文件
      isShowfs1_1: true,
      //是否显示第五步第一张图片
      isShowfs1_2: false,
      //鼠标移入关闭
      isShowfs1_3: false,
      //鼠标点击关闭
      isShowfs1_4: false,
      //键盘点击表格
      isShowfs1_5: false,
      //键盘按下ctrl+c
      isShowfs1_6: false,
      //键盘按下ctrl+v
      isShowfs1_7: false,
      //点击发送
      // 第六步
      // Word基础功能
      isShowwdzt1_1: true,
      //是否显示第六步第一张图片
      isShowwdzt1_2: false,
      //ctrl+A
      isShowwdzt1_3: false,
      //鼠标移入字体下拉
      isShowwdzt1_4: false,
      //鼠标点击字体下拉
      isShowwdzt1_5: false,
      //鼠标移入楷体
      isShowwdzt1_6: false,
      //鼠标点击楷体
      isShowwdzt1_7: false,
      //鼠标移入字体大小
      isShowwdzt1_8: false,
      //鼠标点击字体大小
      isShowwdzt1_9: false,
      //鼠标移入小四
      isShowwdzt1_10: false,
      //鼠标点击小四
      // 行距
      isShowwdhj1_1: false,
      //延迟两秒显示行距页面
      isShowwdhj1_2: false,
      //鼠标移入行距
      isShowwdhj1_3: false,
      //鼠标点击行距
      isShowwdhj1_4: false,
      //鼠标移入1.5
      isShowwdhj1_5: false,
      //鼠标点击1.5
      // 首行缩进
      isShowwdsj1_1: false,
      //延时两秒显示首行缩进页面
      isShowwdsj1_1_1: false,
      //点击鼠标右键
      isShowwdsj1_2: false,
      //鼠标移入段落
      isShowwdsj1_3: false,
      //鼠标点击段落
      isShowwdsj1_4: false,
      //鼠标点击特殊格式
      isShowwdsj1_5: false,
      //鼠标移动到首行缩进
      isShowwdsj1_6: false,
      //鼠标点击首行缩进
      isShowwdsj1_7: false,
      //鼠标点击确定
      //加粗居中
      isShowwdjc1_1: false,
      //延时两秒显示加粗居中页面
      isShowwdjc1_2: false,
      //鼠标移到加粗
      isShowwdjc1_3: false,
      //鼠标点击加粗
      isShowwdjc1_4: false,
      //鼠标移到居中
      isShowwdjc1_5: false,
      //鼠标点击居中
      //颜色设置为红色
      isShowwdys1_1: false,
      //延时两秒显示设置颜色页面
      isShowwdys1_2: false,
      //鼠标移到颜色
      isShowwdys1_3: false,
      //鼠标点击颜色
      isShowwdys1_4: false,
      //鼠标移到红色
      isShowwdys1_5: false,
      //鼠标点击红色
      // 自然段颜色页面显示(凸显页面)
      isShowwdtx1_1: false,
      //延迟两秒自然段颜色页面显示(凸显页面)显示
      isShowwdtx1_2: false,
      //鼠标移到段落颜色
      isShowwdtx1_3: false,
      //鼠标点击段落颜色
      isShowwdtx1_4: false //鼠标点击空白
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this2.tabCurrent).show();
      _this2.$set(_this2.isShowBtn, _this2.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
    var _this = this;
    document.onkeydown = function (event) {
      var key = window.event.keyCode;
      console.log(key, 88877);
      if (key === 83 && event.ctrlKey) {
        event.returnValue = false; // 阻止直接保存网页
        if (_this.isShowbc1_1 == true) {
          _this.showLoginbc1_1();
        }

        // 监听ctrl+S组合键
      }
      if (key === 67 && event.ctrlKey) {
        if (_this.isShowfs1_4 == true) {
          _this.Loginfs1_4();
        }
        if (_this.isShownr1_7 == true) {
          _this.showLoginnr1_7();
        }

        // 监听ctrl+C组合键
      }
      if (key === 86 && event.ctrlKey) {
        if (_this.isShowfs1_5 == true) {
          _this.Loginfs1_5();
        }
        if (_this.isShownr1_9 == true) {
          _this.listenTwo_3();
        }

        // 监听ctrl+V组合键
      }
      if (key === 13) {
        if (_this.isShowqh1_1 == true) {
          _this.showLoginnr1_20_1();
        }
        if (_this.isShowpj1_2 == true) {
          _this.Loginpj1_2_1();
        }
        if (_this.isShowzb1_2 == true) {
          _this.Loginzb1_2_1();
        }
        if (_this.isShowqh1_4 == true) {
          _this.showLoginqh1_4();
        }
        if (_this.isShowpj1_3 == true) {
          _this.showLoginpj1_1();
        }
        if (_this.isShowzf1_2 == true) {
          _this.Loginzf1_2_1();
        }
        if (_this.isShowzf1_4 == true) {
          _this.showLoginzf1_1();
        }
        if (_this.isShowzb1_4 == true) {
          _this.showLoginzb1_1();
        }
        if (_this.isShowfs1_6 == true) {
          _this.Loginfs1_6();
        }

        // 监听回车
      }
      if (key === 65 && event.ctrlKey) {
        if (_this.isShowwdzt1_1 == true) {
          event.returnValue = false; // 阻止
          _this.Loginwdzt1_1();
        }

        // 监听ctrl+A
      }
    };

    // var step = this.$route.query.step;
    // if(step == 12){
    //     this.studyNext('#tab-twelve')
    // }
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: (_methods = {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('zero').play();
      $('#startvideo').hide();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.isShowQnIcon = true, this.isShowQnIcon2 = false, this.isShowQnIcon3 = false, this.isShowQnIcon4 = false, this.isShowQnIcon5 = false, this.isShowQnIcon6 = false, this.isShowQnIcon7 = false, this.isShowQnIcon8 = false, this.isShowQnIcon9 = false, this.isShowQnIcon10 = false, this.isShowQnIcon11 = false, this.isShowQnIcon12 = false, this.isShowQnIcon13 = false, this.isShowQnIcon14 = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.isShownr1_1 = true,
      //是否显示J第2步第一张图片
      this.isShownr1_2 = false,
      //点击J2单元框
      this.nr_input = '',
      //J2输入框
      this.isShownr1_3 = false,
      //敲下回车键后
      this.isShownr1_3_1 = false,
      //敲下回车键后延时两秒
      this.isShownr1_4 = false,
      //点击A3
      this.nr_input2 = '',
      //A3输入框
      this.isShownr1_5 = false,
      //按下ctrl+；
      this.isShownr1_6 = false,
      //按下enter
      this.isShownr1_6_1 = false,
      //按下enter延时两秒
      this.isShownr1_7 = false,
      //点击A（下托前）
      this.isShownr1_8 = false,
      //按下ctrl+c
      this.isShownr1_9 = false,
      //按下ctrl+c延时两秒
      this.isShownr1_10 = false,
      //按下ctrl+V
      this.isShownr1_11 = false,
      //按下ctrl+V延时两秒
      this.isShownr1_12 = false,
      //点击c列
      this.isShownr1_13 = false,
      //c列鼠标点击右键
      this.isShownr1_14 = false,
      //键鼠标移入插入列
      this.isShownr1_15 = false,
      //点击右键鼠标移入插入列
      this.isShownr1_16 = false,
      //点击右键鼠标移入插入列延长两秒
      this.isShownr1_17 = false,
      //点击第六6行
      this.isShownr1_17_1 = false,
      //点击右键
      this.isShownr1_17_2 = false,
      //点击右键移入
      this.isShownr1_17_3 = false,
      //右键点击
      this.isShownr1_18 = false,
      //右键点击以后的页面
      this.isShownr1_19 = false,
      //过渡求和页面
      this.qh1_input = '',
      //求和输入框
      this.qh1_input1 = '',
      //求和输入框
      this.isShowqh1_1 = false,
      //点击I3
      this.isShowqh1_2 = false,
      //点击F3
      this.isShowqh1_3 = false,
      //点击G3
      this.isShowqh1_4 = false,
      //点击H3
      // this.qh_input1='',
      this.isShowqh1_5 = false,
      //按下enter
      // 平均
      this.isShowpj1_1 = false,
      //延时两秒（显示求和页面）
      this.isShowpj1_2 = false,
      //点击J3
      this.isShowpj1_3 = false,
      //点击I3
      this.isShowpj1_4 = false,
      //按下enter
      this.pj1_input = '',
      //I3输入框
      // 总分
      this.isShowzf1_1 = false,
      //k3平均页面显示
      this.isShowzf1_2 = false,
      //点击K3单元格
      this.isShowzf1_3 = false,
      //点击I3单元格
      this.isShowzf1_4 = false,
      //点击I3单元格
      this.isShowzf1_5 = false,
      //按下enter
      this.zf1_input = '',
      //E3输入框
      //修改第一张
      this.isShowxg1_1 = false,
      //延时两秒（显示新建页面）
      this.isShowxg1_2 = false,
      //点击下方的Sheet1
      this.xg_input1 = 'Sheet1',
      //Sheet1修改输入框
      this.isShowxg1_3 = false,
      //按下enter
      //新建
      this.isShowxj1_1 = false,
      //按下enter延时两秒显示新建页面
      this.isShowxj1_2 = false,
      //移入+号
      this.isShowxj1_3 = false,
      //点击+号
      //占比
      this.isShowzb1_1 = false,
      //占比页面显示
      this.isShowzb1_2 = false,
      //点击C3
      this.isShowzb1_3 = false,
      //点击B3
      this.isShowzb1_4 = false,
      //点击A3
      this.zb_input1 = '',
      //A3输入框
      this.isShowzb1_5 = false,
      //按下enter
      //修改第二张
      this.isShowxg2_1 = false,
      //延时两秒显示第二张修改页面
      this.isShowxg2_2 = false,
      //点击下面的Sheet2
      this.xg_input2 = 'Sheet2',
      //下面Sheet2输入框
      this.isShowxg2_3 = false; //按下enter
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowzt1_1 = true,
      //是否显示第三步第一张图片
      this.isShowzt1_2 = false,
      //鼠标移入字体样式
      this.isShowzt1_3 = false,
      //鼠标点击字体样式
      this.isShowzt1_4 = false,
      //鼠标移入微软雅黑
      this.isShowzt1_5 = false,
      //鼠标点击微软雅黑
      // 居中
      this.isShowjz1_1 = false,
      //延时两秒显示居中页面
      this.isShowjz1_2 = false,
      //鼠标移入居中
      this.isShowjz1_3 = false,
      //鼠标点击居中
      // 框线
      this.isShowkx1_1 = false,
      //延迟两秒显示框线页面
      this.isShowkx1_2 = false,
      //鼠标移入框线
      this.isShowkx1_3 = false,
      //鼠标点击框线
      this.isShowkx1_4 = false,
      //鼠标移入所有框线
      this.isShowkx1_5 = false,
      //鼠标点击所有框线
      // 调A列
      // this.isShowta1_1=false,//延迟两秒调整A页面显示
      this.isShowta1_2 = false,
      //移到A列
      this.isShowta1_3 = false,
      //点击A列
      // 加粗合并第一行
      this.isShowjchb1_1 = false,
      //延迟两秒显示加粗合并第一行页面
      this.isShowjchb1_2 = false,
      //鼠标移入大号字体
      this.isShowjchb1_3 = false,
      //鼠标点击大号字体（第一次）
      this.isShowjchb1_4 = false,
      //鼠标点击大号字体（第二次）
      this.isShowjchb1_5 = false,
      //鼠标移入字体加粗
      this.isShowjchb1_6 = false,
      //鼠标点击字体加粗
      this.isShowjchb1_7 = false,
      //鼠标移入居中合并
      this.isShowjchb1_8 = false,
      //鼠标点击居中合并
      this.isShowjchb1_9 = false,
      //鼠标移入设置颜色
      this.isShowjchb1_10 = false,
      //鼠标移入颜色
      this.isShowjchb1_11 = false,
      //鼠标点击颜色
      this.isShowjchb1_12 = false,
      //
      //颜色换行第二行
      this.isShowyshh1_1 = false,
      //延时两秒第二行颜色换行页面显示
      this.isShowyshh1_2 = false,
      //鼠标移入更换字体颜色
      this.isShowyshh1_3 = false,
      //鼠标点击更换字体颜色
      this.isShowyshh1_4 = false,
      //鼠标移入自动换行
      this.isShowyshh1_5 = false,
      //鼠标点击自动换行
      // 冻结
      this.isShowdj1_1 = false,
      //延时两秒冻结页面显示
      this.isShowdj1_2 = false,
      //鼠标移入冻结窗格
      this.isShowdj1_3 = false,
      //鼠标点击冻结窗格
      this.isShowdj1_4 = false,
      //鼠标移入冻结第二行
      this.isShowdj1_5 = false,
      //鼠标点击冻结第二行
      // isShownr1_16:false,//插入列后延迟两秒
      // 保留小数
      this.isShowxs1_1 = false,
      //延迟两秒保留小数页面显示
      this.isShowxs1_2 = false,
      //鼠标移入常规
      this.isShowxs1_3 = false,
      //点击常规下标
      this.isShowxs1_4 = false,
      //鼠标移入其他数字格式
      this.isShowxs1_5 = false,
      //鼠标点击其他数字格式
      this.isShowxs1_6 = false,
      //鼠标点击数值
      this.isShowxs1_7 = false,
      //鼠标移入输入框
      this.isShowxs1_8 = false,
      //鼠标点击减号输入框
      this.isShowxs1_9 = false,
      //鼠标移动到确定
      this.isShowxs1_10 = false,
      //鼠标点击确定
      //占比保留两位小数
      this.isShowzbbl1_1 = false,
      //延时两秒显示占比保留两位小数页面
      this.isShowzbbl1_2 = false,
      //鼠标移入常规
      this.isShowzbbl1_3 = false,
      //点击常规下标
      this.isShowzbbl1_4 = false,
      //鼠标移动到%
      this.isShowzbbl1_5 = false; //鼠标点击%
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.isShowbc1_1 = true,
      //是否显示第四步第一张图片
      this.bc_input1 = '66.67%',
      //保存第一张图的输入框（用于监听ctrl+s）
      this.isShowbc1_2 = false,
      //监听ctrl+s
      this.isShowbc1_3 = false,
      //鼠标移入我的桌面
      this.isShowbc1_4 = false,
      //鼠标点击我的桌面
      this.isShowbc1_5 = false,
      //鼠标点击办公软件培训
      this.isShowbc1_6 = false,
      //鼠标点击文件名
      this.isShowbc1_7 = false,
      //再点击一次
      this.isShowbc1_8 = false,
      //显示输入框
      this.bc_input2 = '', this.isShowbc1_9 = false,
      //点击确定
      //另存为
      this.isShowlc1_1 = false,
      //延时两秒显示另存页面
      this.isShowlc1_2 = false,
      //点击右键
      this.isShowlc1_3 = false,
      //鼠标移入另存为
      this.isShowlc1_4 = false,
      //鼠标点击另存为
      this.isShowlc1_5 = false,
      //鼠标移入我的桌面
      this.isShowlc1_6 = false,
      //鼠标点击我的桌面
      this.isShowlc1_7 = false; //鼠标点击保存
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.isShowfs1_1 = true,
      //是否显示第五步第一张图片
      this.isShowfs1_2 = false,
      //鼠标移入关闭
      this.isShowfs1_3 = false,
      //鼠标点击关闭
      this.isShowfs1_4 = false,
      //鼠标点击表格
      this.isShowfs1_5 = false,
      //键盘按下ctrl+c
      this.isShowfs1_6 = false; //键盘按下ctrl+v
    },
    //初始化第6步状态值
    initSix: function initSix() {
      // Word基础功能
      this.isShowwdzt1_1 = true,
      //是否显示第六步第一张图片
      this.isShowwdzt1_2 = false,
      //ctrl+A
      this.isShowwdzt1_3 = false,
      //鼠标移入字体下拉
      this.isShowwdzt1_4 = false,
      //鼠标点击字体下拉
      this.isShowwdzt1_5 = false,
      //鼠标移入楷体
      this.isShowwdzt1_6 = false,
      //鼠标点击楷体
      this.isShowwdzt1_7 = false,
      //鼠标移入字体大小
      this.isShowwdzt1_8 = false,
      //鼠标点击字体大小
      this.isShowwdzt1_9 = false,
      //鼠标移入小四
      this.isShowwdzt1_10 = false,
      //鼠标点击小四
      // 行距
      this.isShowwdhj1_1 = false,
      //延迟两秒显示行距页面
      this.isShowwdhj1_2 = false,
      //鼠标移入行距
      this.isShowwdhj1_3 = false,
      //鼠标点击行距
      this.isShowwdhj1_4 = false,
      //鼠标移入1.5
      this.isShowwdhj1_5 = false,
      //鼠标点击1.5
      // 首行缩进
      this.isShowwdsj1_1 = false,
      //延时两秒显示首行缩进页面
      this.isShowwdsj1_1_1 = false,
      //点击鼠标右键
      this.isShowwdsj1_2 == false,
      //鼠标移入段落
      this.isShowwdsj1_3 = false,
      //鼠标点击段落
      this.isShowwdsj1_4 = false,
      //鼠标点击特殊格式
      this.isShowwdsj1_5 = false,
      //鼠标移动到首行缩进
      this.isShowwdsj1_6 = false,
      //鼠标点击首行缩进
      this.isShowwdsj1_7 = false,
      //鼠标点击确定
      //加粗居中
      this.isShowwdjc1_1 = false,
      //延时两秒显示加粗居中页面
      this.isShowwdjc1_2 = false,
      //鼠标移到加粗
      this.isShowwdjc1_3 = false,
      //鼠标点击加粗
      this.isShowwdjc1_4 = false,
      //鼠标移到居中
      this.isShowwdjc1_5 = false,
      //鼠标点击居中
      //颜色设置为红色
      this.isShowwdys1_1 = false,
      //延时两秒显示设置颜色页面
      this.isShowwdys1_2 = false,
      //鼠标移到颜色
      this.isShowwdys1_3 = false,
      //鼠标点击颜色
      this.isShowwdys1_4 = false,
      //鼠标移到红色
      this.isShowwdys1_5 = false,
      //鼠标点击红色
      // 自然段颜色页面显示(凸显页面)
      this.isShowwdtx1_1 = false,
      //延迟两秒自然段颜色页面显示(凸显页面)显示
      this.isShowwdtx1_2 = false,
      //鼠标移到段落颜色
      this.isShowwdtx1_3 = false,
      //鼠标点击段落颜色
      this.isShowwdtx1_4 = false; //鼠标点击空白
    },
    //初始化第7步状态值
    initSeven: function initSeven() {
      this.isShowZtsbicon = true;
      this.isShowZtsb01 = false;
      this.isShowZtsb02 = false;
      this.isShowZtsb03 = false;
      this.isShowZtsb04 = false;
      this.isShowZtsb05 = false;
      this.isShowZtsb06 = false;
      this.isShowZtsbTip01 = true;
      this.isShowZtsbTip02 = false;
      this.isShowZtsbTip03 = false;
    },
    //初始化第8步状态值
    initEight: function initEight() {
      this.isShowZjgnicon = true;
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
    },
    //初始化第9步状态值
    initNine: function initNine() {
      this.isShowTjgnicon = true;
      this.isShowTjgn01 = false;
      this.isShowTjgn02 = false;
      this.isShowTjgn03 = false;
      this.isShowTjgn04 = false;
      this.isShowTjgn05 = false;
      this.isShowTjgn06 = false;
    },
    //初始化第10步状态值
    initTen: function initTen() {
      this.isShowDdcjicon = false;
      this.isShowDdcj01 = false;
      this.isShowDdcj02 = false;
      this.isShowDdcj03 = false;
      this.isShowDdcj04 = false;
      this.isShowDdcj05 = false;
      this.isShowDdcj06 = false;
      this.isShowDdcj07 = true;
      this.isShowDdcj08 = false;
      this.isShowDdcj09 = false;
      this.isShowDdcj10 = false;
      this.isShowDdcjTip01 = true;
      this.isShowDdcjTip02 = false;
      this.isShowDdcjTip03 = false;
      this.ddcjbz = '';
      this.ddcjdz = '';
      this.ddcjyf = '';
    },
    //初始化第11步状态值
    initEleven: function initEleven() {
      this.isShowXjrwicon = true;
      this.isShowXjrw01 = false;
      this.isShowXjrw02 = false;
      this.isShowXjrw03 = false;
      this.isShowXjrw04 = false;
      this.isShowXjrw05 = false;
      this.isShowXjrw06 = false;
      this.xjrwmt = this.getLastDaysFromToday(-1) + ' 09:00';
      this.xjrwsj = '';
      this.xjrwtxt = '';
    },
    //初始化第12步状态值
    initTwelve: function initTwelve() {
      this.isShowTcqnicon = true;
      this.isShowTcqn01 = false;
      this.isShowTcqn02 = false;
      this.isShowTcqn03 = false;
      this.isShowTcqn04 = false;
      this.isShowTcqn05 = false;
      this.isShowTcqn06 = false;
      this.isShowTcqn07 = false;
      this.isShowTcqn08 = false;
      this.isShowTcqn09 = false;
      this.isShowTcqn10 = false;
      this.isShowTcqnTip01 = true;
      this.isShowTcqnTip02 = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      $('#startvideo').hide();
      this.isShowBtn = [];
      this.isOpenPpt = false;
      this.isOpenPpt2 = false;
      this.isOpenPpt3 = false;
      this.isOpenPpt4 = false;
      this.isOpenPpt5 = false;
      this.isOpenPpt6 = false;
      this.isOpenPpt7 = false;
      this.isOpenPpt8 = false;
      this.isOpenPpt9 = false;
      this.isOpenPpt10 = false;
      this.isOpenPpt11 = false;
      this.isOpenPpt12 = false;
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      $('#pdf_viewer7').height('0');
      $('#pdf_viewer8').height('0');
      $('#pdf_viewer9').height('0');
      $('#pdf_viewer10').height('0');
      $('#pdf_viewer11').height('0');
      $('#pdf_viewer12').height('0');
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
      //第9步
      this.initNine();
      //第10步
      this.initTen();
      //第11步
      this.initEleven();
      //第12步
      this.initTwelve();
      $('.content').each(function (i) {
        $(this).hide();
      });
      $('.stoptip').each(function (i) {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function (i) {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show();
    },
    //tab切换
    handleClick: function handleClick(tab, event) {
      var _this3 = this;
      console.log(tab, 111111);
      this.tabIndex = parseInt(tab.index) + 1;
      //内容初始化
      this.initAll();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this3.tabCurrent).show();
        _this3.$set(_this3.isShowBtn, _this3.tabCurrent, true);
      }, false);
    },
    //展开/收起ppt
    viewPpt: function viewPpt(bol) {
      if (this.isOpenPpt == true || !bol) {
        this.isOpenPpt = false;
        $('#pdf_viewer').height('0');
      } else {
        this.isOpenPpt = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/30186a3c66eb47d2baff3a4a20b898c6.pdf', "#pdf_viewer", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt2: function viewPpt2(bol) {
      if (this.isOpenPpt2 == true || !bol) {
        this.isOpenPpt2 = false;
        $('#pdf_viewer2').height('0');
      } else {
        this.isOpenPpt2 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer2').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/1ec7bb26500c4642915ce394e0868ef2.pdf', "#pdf_viewer2", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt3: function viewPpt3(bol) {
      if (this.isOpenPpt3 == true || !bol) {
        this.isOpenPpt3 = false;
        $('#pdf_viewer3').height('0');
      } else {
        this.isOpenPpt3 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer3').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/f7ebc1dcca274d7988724f21a45dd216.pdf', "#pdf_viewer3", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt4: function viewPpt4(bol) {
      if (this.isOpenPpt4 == true || !bol) {
        this.isOpenPpt4 = false;
        $('#pdf_viewer4').height('0');
      } else {
        this.isOpenPpt4 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer4').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/8fb3a6ee5a50492daf527cf4af5df717.pdf', "#pdf_viewer4", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt5: function viewPpt5(bol) {
      if (this.isOpenPpt5 == true || !bol) {
        this.isOpenPpt5 = false;
        $('#pdf_viewer5').height('0');
      } else {
        this.isOpenPpt5 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer5').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/30df4c094d9a4aba83db818ef47d208f.pdf', "#pdf_viewer5", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt6: function viewPpt6(bol) {
      if (this.isOpenPpt6 == true || !bol) {
        this.isOpenPpt6 = false;
        $('#pdf_viewer6').height('0');
      } else {
        this.isOpenPpt6 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer6').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/74edd4969b8e47c1920cf97981e227b0.pdf', "#pdf_viewer6", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt7: function viewPpt7(bol) {
      if (this.isOpenPpt7 == true || !bol) {
        this.isOpenPpt7 = false;
        $('#pdf_viewer7').height('0');
      } else {
        this.isOpenPpt7 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer7').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step7.pdf?version=1221', "#pdf_viewer7", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt8: function viewPpt8(bol) {
      if (this.isOpenPpt8 == true || !bol) {
        this.isOpenPpt8 = false;
        $('#pdf_viewer8').height('0');
      } else {
        this.isOpenPpt8 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer8').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step8.pdf?version=1221', "#pdf_viewer8", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt9: function viewPpt9(bol) {
      if (this.isOpenPpt9 == true || !bol) {
        this.isOpenPpt9 = false;
        $('#pdf_viewer9').height('0');
      } else {
        this.isOpenPpt9 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer9').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step9.pdf?version=1221', "#pdf_viewer9", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt10: function viewPpt10(bol) {
      if (this.isOpenPpt10 == true || !bol) {
        this.isOpenPpt10 = false;
        $('#pdf_viewer10').height('0');
      } else {
        this.isOpenPpt10 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer10').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step10.pdf?version=1221', "#pdf_viewer10", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt11: function viewPpt11(bol) {
      if (this.isOpenPpt11 == true || !bol) {
        this.isOpenPpt11 = false;
        $('#pdf_viewer11').height('0');
      } else {
        this.isOpenPpt11 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer11').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step11.pdf?version=1221', "#pdf_viewer11", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt12: function viewPpt12(bol) {
      if (this.isOpenPpt12 == true || !bol) {
        this.isOpenPpt12 = false;
        $('#pdf_viewer12').height('0');
      } else {
        this.isOpenPpt12 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer12').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step12.pdf?version=1221', "#pdf_viewer12", options);
        }
      }
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //最后一节-重看视频
    restartVideoLast: function restartVideoLast() {
      this.initTwelve();
      document.getElementById(this.tabCurrent).play();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
    },
    //开始实操练习
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.isShowBtn[this.tabCurrent] = false;
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START');
      // this.getFocusbc_1()
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initFirst();
      this.initSecond();
      this.initThird();
      this.initFour();
      this.initFive();
      this.initSix();
      this.initSeven();
      this.initEight();
      this.initNine();
      this.initTen();
      this.initEleven();
      this.initTwelve();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    //第1步-单击wps图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //点击wps新建
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowQnIcon3 = true;
      // this.isShowLoginImg = true
    },
    //点击新建
    showLoginImg3: function showLoginImg3() {
      this.isShowQnIcon3 = false;
      this.isShowQnIcon4 = true;
    },
    //移动到新建表格
    showLoginImg4: function showLoginImg4() {
      this.isShowQnIcon4 = false;
      this.isShowQnIcon5 = true;
    },
    //点击新建表格
    showLoginImg5: function showLoginImg5() {
      this.isShowQnIcon5 = false, this.isShowQnIcon6 = true;
    },
    //移到空白文档
    showLoginImg6: function showLoginImg6() {
      this.isShowQnIcon6 = false, this.isShowQnIcon7 = true;
    },
    //点击空白文档
    showLoginImg7: function showLoginImg7() {
      var _this4 = this;
      this.isShowQnIcon7 = false, this.isShowQnIcon8 = true;
      setTimeout(function () {
        _this4.isShowQnIcon8 = false, _this4.isShowQnIcon9 = true;
      }, 2000);
    },
    //点击b列
    showLoginImg8: function showLoginImg8() {
      var _this5 = this;
      this.isShowQnIcon9 = false, this.isShowQnIcon10 = true;
      setTimeout(function () {
        _this5.isShowQnIcon10 = false, _this5.isShowQnIcon11 = true;
      }, 2000);
    },
    // 点击第六行
    showLoginImg9: function showLoginImg9() {
      var _this6 = this;
      var self = this;
      this.isShowQnIcon11 = false, this.isShowQnIcon12 = true;
      setTimeout(function () {
        _this6.isShowQnIcon12 = false, _this6.isShowQnIcon13 = true;
      }, 2000);
    },
    // 点击第六行第三个
    showLoginImg10: function showLoginImg10() {
      var self = this;
      this.isShowQnIcon13 = false;
      this.isShowQnIcon14 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第1步-Excel界面介绍
    restartStudyFirst: function restartStudyFirst() {
      this.initFirst();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    // //登录
    // loginIn() {
    //   if(this.name == '') {
    //     this.notify('<p>请输入账号</p>')
    //     return
    //   }else if(this.name != '淘金客服:001') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   if(this.password == '') {
    //     this.notify('<p>请输入密码</p>')
    //     return
    //   }else if(this.password != 'TJ2019') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   this.isShowLoginImg = false
    //   this.isShowRnd = true
    // },
    // //验证码登录
    // loginInRnd() {
    // 	if(this.rnd == '') {
    //     this.notify('<p>请输入短信验证码</p>')
    //     return
    //   }else if(this.rnd != '660220') {
    //     this.notify('<p>短信验证码错误</p>')
    //     return
    //   }
    //   this.isShowRnd = false
    //   this.isShowLoginIndex = true
    // },
    // //进入接待中心
    // enterJd() {
    // 	var self = this
    // 	this.isShowLoginIndex = false
    // 	this.isShowLoginIndexTwo = true
    // 	this.addRecord('END')
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    // //重练-登录
    // restartStudyFirst() {
    // 	this.initFirst()
    // 	$('#studytip-'+this.tabCurrent).hide();
    // 	this.addRecord('START')
    // },
    //第2步-
    showLoginnr1_1: function showLoginnr1_1() {
      this.isShownr1_1 = false;
      this.isShownr1_2 = true;
      this.getFocus();
    },
    //input自动获取焦点1
    getFocus: function getFocus() {
      this.$nextTick(function () {
        var _this7 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this7.$refs.strname.focus();
        }, 100);
      });
    },
    //监听回车1
    listenOne: function listenOne(event) {
      if (event.keyCode === 13) {
        this.verification_nr1();
        event.preventDefault();
        return false;
      }
    },
    verification_nr1: function verification_nr1() {
      var _this8 = this;
      if (this.nr_input == '总分较8月上升（下降）') {
        this.isShownr1_2 = false;
        this.isShownr1_3 = true;
        console.log(22222);
        setTimeout(function () {
          _this8.isShownr1_3_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击A3
    showLoginnr1_3: function showLoginnr1_3() {
      this.isShownr1_3 = false;
      this.isShownr1_4 = true;
      this.getFocus2();
    },
    //input自动获取焦点2
    getFocus2: function getFocus2() {
      this.$nextTick(function () {
        var _this9 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this9.$refs.strname2.focus();
        }, 100);
      });
    },
    //监听回车2
    listenTwo: function listenTwo(event) {
      console.log(event, 7777);
      console.log(event.key, 555);
      if (event.key == ';' && event.ctrlKey) {
        this.isShownr1_4 = false;
        this.isShownr1_5 = true;
        this.nr_input2 = this.getNowDate();
        console.log(this.nr_input2, 11111);
        event.preventDefault();
        return false;
      }
    },
    //监听回车3
    listenTwo_1: function listenTwo_1(event) {
      var _this0 = this;
      if (event.keyCode === 13) {
        if (this.nr_input2 == '2022/9/29') {
          this.isShownr1_5 = false;
          this.isShownr1_6 = true;
          setTimeout(function () {
            _this0.isShownr1_6_1 = true;
          }, 2000);
        } else {
          this.notify('<p>请按照右边提示填写正确的内容</p>');
        }
      }

      // if(  ) {
      // 	    this.isShownr1_4=false
      // 	    this.isShownr1_5=true
      // 	    this.nr_input2=this.getNowDate()
      // 		console.log(this.nr_input2,77777)
      // 	    event.preventDefault()
      // 	    return false
      // 	    }
    },
    // 获得当前时间（并格式化）
    getNowDate: function getNowDate() {
      var timeOne = new Date();
      var year = timeOne.getFullYear();
      var month = timeOne.getMonth() + 1;
      var day = timeOne.getDate();
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      var NOW_MONTHS_AGO = "".concat(year, "/").concat(month, "/").concat(day);
      return NOW_MONTHS_AGO;
    },
    // 点击A单元格（下拖前）
    showLoginnr1_6: function showLoginnr1_6() {
      this.isShownr1_6 = false;
      this.isShownr1_6_1 = false;
      this.isShownr1_7 = true;
      // this.getFocus3()
    },
    //input自动获取焦点3
    getFocus3: function getFocus3() {
      this.$nextTick(function () {
        var _this1 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this1.$refs.strname3.focus();
        }, 100);
      });
    },
    //监听ctrl+C
    listenTwo_2: function listenTwo_2(event) {
      console.log(event, 7777);
      if (event.keyCode == 67 && event.ctrlKey) {
        this.showLoginnr1_7();
        event.preventDefault();
        return false;
      }
    },
    // 按下 ctrl C
    showLoginnr1_7: function showLoginnr1_7() {
      var _this10 = this;
      this.isShownr1_7 = false;
      this.isShownr1_8 = true;
      setTimeout(function () {
        _this10.isShownr1_8 = false;
        _this10.isShownr1_9 = true;
        // this.getFocus4()
      }, 1000);
    },
    //监听Ctrl+v 4
    // listenTwo_3(event){
    // console.log(event,77778888)
    // if( event.keyCode== 86) {
    // 	    this.isShownr1_9=false
    // 	    this.isShownr1_10=true
    //         setTimeout(()=>{
    // 			this.isShownr1_10=false
    // 			this.isShownr1_11=true
    // 		},2000)
    //         event.preventDefault()
    // 	    return false
    // 	    }
    // },
    //监听Ctrl+v 4
    listenTwo_3: function listenTwo_3() {
      var _this11 = this;
      this.isShownr1_9 = false;
      this.isShownr1_10 = true;
      setTimeout(function () {
        _this11.isShownr1_10 = false;
        _this11.isShownr1_11 = true;
      }, 2000);
    },
    //input自动获取焦点4
    getFocus4: function getFocus4() {
      this.$nextTick(function () {
        var _this12 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this12.$refs.strname4.focus();
        }, 100);
      });
    },
    //点击C列
    showLoginnr1_11: function showLoginnr1_11() {
      this.isShownr1_11 = false;
      this.isShownr1_12 = true;
    },
    //点击鼠标右键
    rightClick: function rightClick($event) {
      this.isShownr1_12 = false;
      this.isShownr1_13 = true;
    },
    //右键后鼠标移入插入列
    showLoginnr1_13: function showLoginnr1_13() {
      this.isShownr1_13 = false;
      this.isShownr1_14 = true;
    },
    //点击鼠标移入的插入列
    showLoginnr1_14: function showLoginnr1_14() {
      var _this13 = this;
      this.isShownr1_14 = false;
      this.isShownr1_15 = true;
      setTimeout(function () {
        _this13.isShownr1_15 = false;
        _this13.isShownr1_16 = true;
      }, 2000);
    },
    //点击第6列
    showLoginnr1_15: function showLoginnr1_15() {
      this.isShownr1_16 = false;
      this.isShownr1_17 = true;
    },
    //点击右键
    showLoginnr1_16: function showLoginnr1_16() {
      // this.isShownr1_17=false
      // this.isShownr1_17_1=true
      this.isShownr1_17_1 = true;
    },
    //鼠标移入
    showLoginnr1_17: function showLoginnr1_17() {
      this.isShownr1_17_1 = false;
      this.isShownr1_17_2 = true;
    },
    //点击插入行
    showLoginnr1_17_1: function showLoginnr1_17_1() {
      var _this14 = this;
      this.isShownr1_17 = false;
      this.isShownr1_17_2 = false;
      this.isShownr1_18 = true;
      //过渡求和
      setTimeout(function () {
        _this14.isShownr1_18 = false;
        _this14.isShownr1_19 = true;
      }, 2000);
    },
    // 求和
    //点击I3
    showLoginnr1_19: function showLoginnr1_19() {
      this.isShownr1_19 = false;
      this.isShowqh1_1 = true;
      this.getFocusqh_1();
    },
    //点击F3
    showLoginnr1_20: function showLoginnr1_20() {
      if (this.qh1_input == '=') {
        this.qh1_input1 = '=F3';
        this.isShowqh1_1 = false;
        this.isShowqh1_2 = true;
        this.getFocusqh_2();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //直接复制=F3+G3+H3
    showLoginnr1_20_1: function showLoginnr1_20_1() {
      var _this15 = this;
      if (this.qh1_input == '=F3+G3+H3') {
        this.isShowqh1_1 = false;
        this.isShowqh1_5 = true;
        //平均值页面
        setTimeout(function () {
          _this15.isShowqh1_5 = false;
          _this15.isShowpj1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击G3
    showLoginqh1_2: function showLoginqh1_2() {
      if (this.qh1_input1 == '=F3+') {
        this.qh1_input = '=F3+G3';
        this.isShowqh1_2 = false;
        this.isShowqh1_3 = true;
        this.getFocusqh_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击H3
    showLoginqh1_3: function showLoginqh1_3() {
      if (this.qh1_input == '=F3+G3+') {
        this.isShowqh1_3 = false;
        this.isShowqh1_4 = true;
        // this.getFocusqh_1()
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //输入框焦点聚焦
    getFocusqh_1: function getFocusqh_1() {
      this.$nextTick(function () {
        var _this16 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this16.$refs.strname_1qh.focus();
        }, 100);
      });
    },
    //输入框焦点聚焦
    getFocusqh_2: function getFocusqh_2() {
      this.$nextTick(function () {
        var _this17 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this17.$refs.strname_2qh.focus();
        }, 100);
      });
    },
    //敲下enter
    showLoginqh1_4: function showLoginqh1_4(event) {
      var _this18 = this;
      this.isShowqh1_4 = false;
      this.isShowqh1_5 = true;
      //平均值页面
      setTimeout(function () {
        _this18.isShowqh1_5 = false;
        _this18.isShowpj1_1 = true;
      }, 2000);
    },
    //点击J3
    Loginpj1_1: function Loginpj1_1() {
      this.isShowpj1_1 = false;
      this.isShowpj1_2 = true;
      this.getFocuspj_1();
    },
    //输入框焦点聚焦
    getFocuspj_1: function getFocuspj_1() {
      this.$nextTick(function () {
        var _this19 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this19.$refs.strname_pj1.focus();
        }, 100);
      });
    },
    //点击I3
    Loginpj1_2: function Loginpj1_2() {
      if (this.pj1_input == '=') {
        this.pj1_input = '=I3';
        this.isShowpj1_2 = false;
        this.isShowpj1_3 = true;
        this.getFocuspj_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }

      // this.getFocuspj_1()
    },
    //直接复制=I3/3
    Loginpj1_2_1: function Loginpj1_2_1() {
      var _this20 = this;
      if (this.pj1_input == '=I3/3') {
        this.isShowpj1_2 = false;
        this.isShowpj1_4 = true;
        setTimeout(function () {
          _this20.isShowpj1_4 = false;
          _this20.isShowzf1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //按下enter
    showLoginpj1_1: function showLoginpj1_1() {
      var _this21 = this;
      if (this.pj1_input == '=I3/3') {
        this.isShowpj1_3 = false;
        this.isShowpj1_4 = true;
        // 总分页面显示
        setTimeout(function () {
          _this21.isShowpj1_4 = false;
          _this21.isShowzf1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击K3单元格
    Loginzf1_1: function Loginzf1_1() {
      this.isShowzf1_1 = false;
      this.isShowzf1_2 = true;
      this.getFocuszf_1();
    },
    //点击I3单元格
    Loginzf1_2: function Loginzf1_2() {
      if (this.zf1_input == '=') {
        this.zf1_input = '=I3';
        this.isShowzf1_2 = false;
        this.isShowzf1_3 = true;
        this.getFocuszf_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //直接复制=I3-E3
    Loginzf1_2_1: function Loginzf1_2_1() {
      var _this22 = this;
      if (this.zf1_input == '=I3-E3') {
        this.isShowzf1_2 = false;
        this.isShowzf1_5 = true;
        setTimeout(function () {
          _this22.isShowzf1_5 = false;
          _this22.isShowxg1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //输入框焦点聚焦
    getFocuszf_1: function getFocuszf_1() {
      this.$nextTick(function () {
        var _this23 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this23.$refs.strname_zf1.focus();
        }, 100);
      });
    },
    //点击E3单元格
    Loginzf1_3: function Loginzf1_3() {
      if (this.zf1_input == '=I3-') {
        this.zf1_input = 'I3-E3';
        this.isShowzf1_3 = false;
        this.isShowzf1_4 = true;
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }

      // this.getFocuszf_1()
    },
    //按下enter
    showLoginzf1_1: function showLoginzf1_1() {
      var _this24 = this;
      this.isShowzf1_4 = false;
      this.isShowzf1_5 = true;
      // 显示修改页面
      setTimeout(function () {
        _this24.isShowzf1_5 = false;
        _this24.isShowxg1_1 = true;
      }, 2000);
    },
    //输入框焦点聚焦
    getFocusxg_1: function getFocusxg_1() {
      this.$nextTick(function () {
        var _this25 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this25.$refs.strname_xg1.focus();
        }, 100);
      });
    },
    // 点击下方的名字，进行修改
    Loginxg1_3: function Loginxg1_3() {
      this.isShowxg1_1 = false;
      this.isShowxg1_2 = true;
    },
    //修改完点击enter
    showLoginxg1_1: function showLoginxg1_1() {
      var _this26 = this;
      if (this.xg_input1 == '成绩汇总') {
        this.isShowxg1_2 = false;
        this.isShowxg1_3 = true;
        // 显示新建页面
        setTimeout(function () {
          _this26.isShowxg1_3 = false;
          _this26.isShowxj1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    // 移入+号
    Loginxj1_1: function Loginxj1_1() {
      this.isShowxj1_1 = false;
      this.isShowxj1_2 = true;
    },
    // 点击+号
    Loginxj1_2: function Loginxj1_2() {
      var _this27 = this;
      this.isShowxj1_2 = false;
      this.isShowxj1_3 = true;
      // 显示占比页面
      setTimeout(function () {
        _this27.isShowxj1_3 = false;
        _this27.isShowzb1_1 = true;
      }, 2000);
    },
    //点击C3
    Loginzb1_1: function Loginzb1_1() {
      this.isShowzb1_1 = false;
      this.isShowzb1_2 = true;
      this.getFocuszb_1();
    },
    // 点击B3
    Loginzb1_2: function Loginzb1_2() {
      if (this.zb_input1 == '=') {
        this.zb_input1 = '=B3';
        this.isShowzb1_2 = false;
        this.isShowzb1_3 = true;
        this.getFocuszb_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    // 直接复制=B3/A3
    Loginzb1_2_1: function Loginzb1_2_1() {
      var _this28 = this;
      if (this.zb_input1 == '=B3/A3') {
        this.isShowzb1_2 = false;
        this.isShowzb1_5 = true;
        setTimeout(function () {
          _this28.isShowzb1_5 = false;
          _this28.isShowxg2_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //输入框焦点聚焦
    getFocuszb_1: function getFocuszb_1() {
      this.$nextTick(function () {
        var _this29 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this29.$refs.strname_zb1.focus();
        }, 100);
      });
    },
    //点击A3
    Loginzb1_3: function Loginzb1_3() {
      if (this.zb_input1 == '=B3/') {
        this.isShowzb1_3 = false;
        this.isShowzb1_4 = true;
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }

      // this.getFocuszb_1()
    },
    //按下enter
    showLoginzb1_1: function showLoginzb1_1() {
      var _this30 = this;
      this.isShowzb1_4 = false;
      this.isShowzb1_5 = true;
      //第二张修改页面
      setTimeout(function () {
        _this30.isShowzb1_5 = false;
        _this30.isShowxg2_1 = true;
      }, 2000);
    },
    //输入框焦点聚焦
    getFocusxg_2: function getFocusxg_2() {
      this.$nextTick(function () {
        var _this31 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this31.$refs.strname_xg2.focus();
        }, 100);
      });
    },
    //点击下面的sheet2
    Loginxg2_1: function Loginxg2_1() {
      this.isShowxg2_1 = false;
      this.isShowxg2_2 = true;
      this.getFocusxg_2();
    },
    //按下enter
    showLoginxg2_1: function showLoginxg2_1() {
      if (this.xg_input2 == '数据统计') {
        var self = this;
        this.isShowxg2_2 = false;
        this.isShowxg2_3 = true;
        this.addRecord('END');
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //重练-Excel内容编辑
    restartStudySecond: function restartStudySecond() {
      this.initSecond();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    // 第3步-Excel内容布局
    //鼠标移入字体样式
    Loginzt1_1: function Loginzt1_1() {
      this.isShowzt1_1 = false;
      this.isShowzt1_2 = true;
    },
    //鼠标点击字体样式
    Loginzt1_2: function Loginzt1_2() {
      this.isShowzt1_2 = false;
      this.isShowzt1_3 = true;
    },
    //鼠标移入微软雅黑
    Loginzt1_3: function Loginzt1_3() {
      this.isShowzt1_3 = false;
      this.isShowzt1_4 = true;
      // this.isShowzt1_3=true
    },
    //鼠标点击微软雅黑
    Loginzt1_4: function Loginzt1_4() {
      var _this32 = this;
      this.isShowzt1_4 = false;
      this.isShowzt1_5 = true;
      // 显示居中页面
      setTimeout(function () {
        _this32.isShowzt1_5 = false;
        _this32.isShowjz1_1 = true;
      }, 2000);
    },
    //鼠标移入居中
    Loginjz1_1: function Loginjz1_1() {
      this.isShowjz1_1 = false;
      this.isShowjz1_2 = true;
    },
    //鼠标点击居中
    Loginjz1_2: function Loginjz1_2() {
      var _this33 = this;
      this.isShowjz1_2 = false;
      this.isShowjz1_3 = true;
      // 显示框线页面
      setTimeout(function () {
        _this33.isShowjz1_3 = false;
        _this33.isShowkx1_1 = true;
      }, 2000);
    },
    // 鼠标移入框线
    Loginkx1_1: function Loginkx1_1() {
      this.isShowkx1_1 = false;
      this.isShowkx1_2 = true;
    },
    //鼠标点击框线
    Loginkx1_2: function Loginkx1_2() {
      this.isShowkx1_2 = false;
      this.isShowkx1_3 = true;
    },
    //鼠标移入所有框线
    Loginkx1_3: function Loginkx1_3() {
      this.isShowkx1_3 = false;
      this.isShowkx1_4 = true;
    },
    //鼠标点击所有框线
    Loginkx1_4: function Loginkx1_4() {
      var _this34 = this;
      this.isShowkx1_4 = false;
      this.isShowkx1_5 = true;
      // 调整A页面显示
      setTimeout(function () {
        _this34.isShowkx1_5 = false;
        _this34.isShowta1_2 = true;
      }, 2000);
    },
    // //点击A列
    // Loginta1_1(){
    // 	this.isShowta1_1=false
    // 	this.isShowta1_2=true
    // },
    //鼠标移入ab列间
    Loginta1_2: function Loginta1_2(v) {
      var _this35 = this;
      console.log('11111111111111111111111111', v);
      this.isShowta1_2 = false;
      this.isShowta1_3 = true;
      // 显示加粗合并第一行页面
      setTimeout(function () {
        _this35.isShowta1_3 = false;
        _this35.isShowjchb1_1 = true;
      }, 2000);
    },
    //鼠标移入字体加粗
    Loginjchb1_1: function Loginjchb1_1() {
      this.isShowjchb1_1 = false;
      this.isShowjchb1_2 = true;
    },
    //鼠标点击字体加粗（第一次）
    Loginjchb1_2: function Loginjchb1_2() {
      this.isShowjchb1_2 = false;
      this.isShowjchb1_3 = true;
    },
    //鼠标点击字体加粗（第二次）
    Loginjchb1_3: function Loginjchb1_3() {
      this.isShowjchb1_3 = false;
      this.isShowjchb1_4 = true;
    },
    //鼠标移入加粗
    Loginjchb1_4: function Loginjchb1_4() {
      this.isShowjchb1_4 = false;
      this.isShowjchb1_5 = true;
    },
    //鼠标点击加粗
    Loginjchb1_5: function Loginjchb1_5() {
      this.isShowjchb1_5 = false;
      this.isShowjchb1_6 = true;
    },
    //鼠标移入合并居中
    Loginjchb1_6: function Loginjchb1_6() {
      this.isShowjchb1_6 = false;
      this.isShowjchb1_7 = true;
    },
    //鼠标点击合并居中
    Loginjchb1_7: function Loginjchb1_7() {
      this.isShowjchb1_7 = false;
      this.isShowjchb1_8 = true;
    },
    //鼠标移入设置颜色
    Loginjchb1_8: function Loginjchb1_8() {
      this.isShowjchb1_8 = false;
      this.isShowjchb1_9 = true;
    },
    //鼠标点击设置颜色
    Loginjchb1_9: function Loginjchb1_9() {
      this.isShowjchb1_9 = false;
      this.isShowjchb1_10 = true;
    },
    //鼠标移到颜色
    Loginjchb1_10: function Loginjchb1_10() {
      this.isShowjchb1_10 = false;
      this.isShowjchb1_11 = true;
    },
    //鼠标点击颜色
    Loginjchb1_11: function Loginjchb1_11() {
      var _this36 = this;
      this.isShowjchb1_11 = false;
      this.isShowjchb1_12 = true;
      //第二行颜色换行页面显示
      setTimeout(function () {
        _this36.isShowjchb1_12 = false;
        _this36.isShowyshh1_1 = true;
      }, 2000);
    },
    //鼠标移入字体颜色的A
    Loginyshh1_1: function Loginyshh1_1() {
      this.isShowyshh1_1 = false;
      this.isShowyshh1_2 = true;
    },
    //鼠标点击字体颜色的A
    Loginyshh1_2: function Loginyshh1_2() {
      this.isShowyshh1_2 = false;
      this.isShowyshh1_3 = true;
    },
    //鼠标移到自动换行
    Loginyshh1_3: function Loginyshh1_3() {
      this.isShowyshh1_3 = false;
      this.isShowyshh1_4 = true;
    },
    //鼠标点击自动换行
    Loginyshh1_4: function Loginyshh1_4() {
      var _this37 = this;
      this.isShowyshh1_4 = false;
      this.isShowyshh1_5 = true;
      // 显示冻结页面
      setTimeout(function () {
        _this37.isShowyshh1_5 = false;
        _this37.isShowdj1_1 = true;
      }, 2000);
    },
    //鼠标移入冻结窗格
    Logindj1_1: function Logindj1_1() {
      this.isShowdj1_1 = false;
      this.isShowdj1_2 = true;
    },
    //鼠标点击冻结窗格
    Logindj1_2: function Logindj1_2() {
      this.isShowdj1_2 = false;
      this.isShowdj1_3 = true;
    },
    //鼠标移入冻结至第二行
    Logindj1_3: function Logindj1_3() {
      this.isShowdj1_3 = false;
      this.isShowdj1_4 = true;
    },
    //鼠标点击冻结至第二行
    Logindj1_4: function Logindj1_4() {
      var _this38 = this;
      this.isShowdj1_4 = false;
      this.isShowdj1_5 = true;
      // 保留小数页面显示
      setTimeout(function () {
        _this38.isShowdj1_5 = false;
        _this38.isShowxs1_1 = true;
      }, 2000);
    },
    //鼠标移入常规
    Loginxs1_1: function Loginxs1_1() {
      this.isShowxs1_1 = false;
      this.isShowxs1_2 = true;
    },
    //鼠标点击常规下箭头
    Loginxs1_2: function Loginxs1_2() {
      this.isShowxs1_2 = false;
      this.isShowxs1_3 = true;
    },
    //鼠标移入其他数字格式
    Loginxs1_3: function Loginxs1_3() {
      this.isShowxs1_3 = false;
      this.isShowxs1_4 = true;
    },
    //鼠标点击其他数字格式
    Loginxs1_4: function Loginxs1_4() {
      this.isShowxs1_4 = false;
      this.isShowxs1_5 = true;
    },
    // 点击数值
    Loginxs1_5: function Loginxs1_5() {
      this.isShowxs1_5 = false;
      this.isShowxs1_6 = true;
    },
    // 鼠标移入输入框
    Loginxs1_6: function Loginxs1_6() {
      this.isShowxs1_6 = false;
      this.isShowxs1_7 = true;
    },
    // 鼠标点击减号输入框
    Loginxs1_7: function Loginxs1_7() {
      this.isShowxs1_7 = false;
      this.isShowxs1_8 = true;
    },
    // 鼠标移动到确定
    Loginxs1_8: function Loginxs1_8() {
      this.isShowxs1_8 = false;
      this.isShowxs1_9 = true;
    },
    // 鼠标点击确定
    Loginxs1_9: function Loginxs1_9() {
      var _this39 = this;
      this.isShowxs1_9 = false;
      this.isShowxs1_10 = true;
      // 占比保留页面显示
      setTimeout(function () {
        _this39.isShowxs1_10 = false;
        _this39.isShowzbbl1_1 = true;
      }, 2000);
    },
    //鼠标移入常规
    Loginzbbl1_1: function Loginzbbl1_1() {
      this.isShowzbbl1_1 = false;
      this.isShowzbbl1_2 = true;
    },
    //鼠标点击常规
    Loginzbbl1_2: function Loginzbbl1_2() {
      this.isShowzbbl1_2 = false;
      this.isShowzbbl1_3 = true;
    },
    //鼠标移动到%
    Loginzbbl1_3: function Loginzbbl1_3() {
      this.isShowzbbl1_3 = false;
      this.isShowzbbl1_4 = true;
    },
    //鼠标移动到%
    Loginzbbl1_4: function Loginzbbl1_4() {
      this.isShowzbbl1_3 = false;
      this.isShowzbbl1_4 = true;
    }
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginzbbl1_4", function Loginzbbl1_4() {
    var self = this;
    this.isShowzbbl1_4 = false;
    this.isShowzbbl1_5 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyThird", function restartStudyThird() {
    this.initThird();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "getFocusbc_1", function getFocusbc_1() {
    this.$nextTick(function () {
      var _this40 = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this40.$refs.strname_bc1.focus();
      }, 100);
    });
  }), "showLoginbc1_1", function showLoginbc1_1(event) {
    this.isShowbc1_1 = false;
    this.isShowbc1_2 = true;
  }), "Loginbc1_1", function Loginbc1_1() {
    this.isShowbc1_2 = false;
    this.isShowbc1_3 = true;
  }), "Loginbc1_2", function Loginbc1_2() {
    this.isShowbc1_3 = false;
    this.isShowbc1_4 = true;
  }), "Loginbc1_3", function Loginbc1_3() {
    this.isShowbc1_4 = false;
    this.isShowbc1_5 = true;
  }), "Loginbc1_4", function Loginbc1_4() {
    this.isShowbc1_5 = false;
    this.isShowbc1_6 = true;
  }), "Loginbc1_5", function Loginbc1_5() {
    this.isShowbc1_6 = false;
    this.isShowbc1_7 = true;
  }), "getFocusbc_2", function getFocusbc_2() {
    this.$nextTick(function () {
      var _this41 = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this41.$refs.strname_bc2.focus();
      }, 100);
    });
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginbc1_6", function Loginbc1_6() {
    this.isShowbc1_7 = false;
    this.isShowbc1_8 = true;
    this.getFocusbc_2();
  }), "Loginbc1_7", function Loginbc1_7() {
    var _this42 = this;
    if (this.bc_input2 == '月考成绩统计') {
      this.isShowbc1_8 = false;
      this.isShowbc1_9 = true;
      //显示另存页面
      setTimeout(function () {
        _this42.isShowbc1_9 = false;
        _this42.isShowlc1_1 = true;
      }, 2000);
    } else {
      this.notify('<p>请填写月考成绩统计</p>');
    }
  }), "Loginlc1_1", function Loginlc1_1() {
    console.log(8899);
    this.isShowlc1_1 = false;
    this.isShowlc1_2 = true;
  }), "Loginlc1_2", function Loginlc1_2() {
    this.isShowlc1_2 = false;
    this.isShowlc1_3 = true;
  }), "Loginlc1_3", function Loginlc1_3() {
    this.isShowlc1_3 = false;
    this.isShowlc1_4 = true;
  }), "Loginlc1_4", function Loginlc1_4() {
    this.isShowlc1_4 = false;
    this.isShowlc1_5 = true;
  }), "Loginlc1_5", function Loginlc1_5() {
    this.isShowlc1_5 = false;
    this.isShowlc1_6 = true;
  }), "Loginlc1_6", function Loginlc1_6() {
    var self = this;
    this.isShowlc1_6 = false;
    this.isShowlc1_7 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyFour", function restartStudyFour() {
    this.initFour();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "Loginfs1_1", function Loginfs1_1() {
    this.isShowfs1_1 = false;
    this.isShowfs1_2 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginfs1_1", function Loginfs1_1() {
    this.isShowfs1_1 = false;
    this.isShowfs1_2 = true;
  }), "Loginfs1_2", function Loginfs1_2() {
    this.isShowfs1_2 = false;
    this.isShowfs1_3 = true;
  }), "Loginfs1_3", function Loginfs1_3() {
    this.isShowfs1_3 = false;
    this.isShowfs1_4 = true;
  }), "Loginfs1_4", function Loginfs1_4() {
    this.isShowfs1_4 = false;
    this.isShowfs1_5 = true;
  }), "Loginfs1_5", function Loginfs1_5() {
    this.isShowfs1_5 = false;
    this.isShowfs1_6 = true;
  }), "Loginfs1_6", function Loginfs1_6() {
    var self = this;
    this.isShowfs1_6 = false;
    this.isShowfs1_7 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "Loginwdzt1_1", function Loginwdzt1_1() {
    this.isShowwdzt1_1 = false;
    this.isShowwdzt1_2 = true;
  }), "Loginwdzt1_2", function Loginwdzt1_2() {
    this.isShowwdzt1_2 = false;
    this.isShowwdzt1_3 = true;
  }), "Loginwdzt1_3", function Loginwdzt1_3() {
    this.isShowwdzt1_3 = false;
    this.isShowwdzt1_4 = true;
  }), "Loginwdzt1_4", function Loginwdzt1_4() {
    this.isShowwdzt1_4 = false;
    this.isShowwdzt1_5 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginwdzt1_5", function Loginwdzt1_5() {
    this.isShowwdzt1_5 = false;
    this.isShowwdzt1_6 = true;
  }), "Loginwdzt1_6", function Loginwdzt1_6() {
    this.isShowwdzt1_6 = false;
    this.isShowwdzt1_7 = true;
  }), "Loginwdzt1_7", function Loginwdzt1_7() {
    this.isShowwdzt1_7 = false;
    this.isShowwdzt1_8 = true;
  }), "Loginwdzt1_8", function Loginwdzt1_8() {
    this.isShowwdzt1_8 = false;
    this.isShowwdzt1_9 = true;
  }), "Loginwdzt1_9", function Loginwdzt1_9() {
    this.isShowwdzt1_9 = false;
    this.isShowwdzt1_10 = true;
  }), "Loginwdzt1_9", function Loginwdzt1_9() {
    var _this43 = this;
    this.isShowwdzt1_9 = false;
    this.isShowwdzt1_10 = true;
    // 显示行距页面
    setTimeout(function () {
      _this43.isShowwdzt1_10 = false;
      _this43.isShowwdhj1_1 = true;
    }, 2000);
  }), "Loginwdhj1_1", function Loginwdhj1_1() {
    this.isShowwdhj1_1 = false;
    this.isShowwdhj1_2 = true;
  }), "Loginwdhj1_2", function Loginwdhj1_2() {
    this.isShowwdhj1_2 = false;
    this.isShowwdhj1_3 = true;
  }), "Loginwdhj1_3", function Loginwdhj1_3() {
    this.isShowwdhj1_3 = false;
    this.isShowwdhj1_4 = true;
  }), "Loginwdhj1_4", function Loginwdhj1_4() {
    var _this44 = this;
    this.isShowwdhj1_4 = false;
    this.isShowwdhj1_5 = true;
    // 显示首行缩进页面
    setTimeout(function () {
      _this44.isShowwdhj1_5 = false;
      _this44.isShowwdsj1_1 = true;
    }, 2000);
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "rightClick_sj", function rightClick_sj() {
    this.isShowwdsj1_1_1 = true;
  }), "Loginwdsj1_1", function Loginwdsj1_1() {
    this.isShowwdsj1_1 = false;
    this.isShowwdsj1_2 = true;
  }), "Loginwdsj1_2", function Loginwdsj1_2() {
    this.isShowwdsj1_2 = false;
    this.isShowwdsj1_3 = true;
  }), "Loginwdsj1_3", function Loginwdsj1_3() {
    this.isShowwdsj1_3 = false;
    this.isShowwdsj1_4 = true;
  }), "Loginwdsj1_4", function Loginwdsj1_4() {
    this.isShowwdsj1_4 = false;
    this.isShowwdsj1_5 = true;
  }), "Loginwdsj1_5", function Loginwdsj1_5() {
    this.isShowwdsj1_5 = false;
    this.isShowwdsj1_6 = true;
  }), "Loginwdsj1_6", function Loginwdsj1_6() {
    var _this45 = this;
    this.isShowwdsj1_6 = false;
    this.isShowwdsj1_7 = true;
    // 显示加粗居中页面
    setTimeout(function () {
      _this45.isShowwdsj1_7 = false;
      _this45.isShowwdjc1_1 = true;
    }, 2000);
  }), "Loginwdjc1_1", function Loginwdjc1_1() {
    this.isShowwdjc1_1 = false;
    this.isShowwdjc1_2 = true;
  }), "Loginwdjc1_2", function Loginwdjc1_2() {
    this.isShowwdjc1_2 = false;
    this.isShowwdjc1_3 = true;
  }), "Loginwdjc1_3", function Loginwdjc1_3() {
    this.isShowwdjc1_3 = false;
    this.isShowwdjc1_4 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginwdjc1_4", function Loginwdjc1_4() {
    var _this46 = this;
    this.isShowwdjc1_4 = false;
    this.isShowwdjc1_5 = true;
    // 设置颜色页面显示
    setTimeout(function () {
      _this46.isShowwdjc1_5 = false;
      _this46.isShowwdys1_1 = true;
    }, 2000);
  }), "Loginwdys1_1", function Loginwdys1_1() {
    this.isShowwdys1_1 = false;
    this.isShowwdys1_2 = true;
  }), "Loginwdys1_2", function Loginwdys1_2() {
    this.isShowwdys1_2 = false;
    this.isShowwdys1_3 = true;
  }), "Loginwdys1_3", function Loginwdys1_3() {
    this.isShowwdys1_3 = false;
    this.isShowwdys1_4 = true;
  }), "Loginwdys1_4", function Loginwdys1_4() {
    var _this47 = this;
    this.isShowwdys1_4 = false;
    this.isShowwdys1_5 = true;
    // 自然段颜色页面显示
    setTimeout(function () {
      _this47.isShowwdys1_5 = false;
      _this47.isShowwdtx1_1 = true;
    }, 2000);
  }), "Loginwdtx1_1", function Loginwdtx1_1() {
    this.isShowwdtx1_1 = false;
    this.isShowwdtx1_2 = true;
  }), "Loginwdtx1_2", function Loginwdtx1_2() {
    this.isShowwdtx1_2 = false;
    this.isShowwdtx1_4 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
    // this.isShowwdtx1_3=true
  }), "Loginwdtx1_3", function Loginwdtx1_3() {
    // 	let self = this
    // 	this.isShowwdtx1_3=false
    // 	this.isShowwdtx1_4=true
    // 	this.addRecord('END')
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
  }), "restartStudySix", function restartStudySix() {
    this.initSix();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "listenThree", function listenThree() {
    if (event.keyCode === 13) {
      this.showJieDaiImgThree();
      event.preventDefault();
      return false;
    }
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "listenFour", function listenFour() {
    if (event.keyCode === 13) {
      this.showJieDaiImgFour();
      event.preventDefault();
      return false;
    }
  }), "showJieDaiImgOne", function showJieDaiImgOne() {
    var self = this;
    if (this.jdnr.indexOf('您好') < 0 || this.jdnr.indexOf('欢迎光临') < 0 || this.jdnr.indexOf('请问有什么可以帮到您') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.time1 = this.formatDate(new Date());
    this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p>";
    $('.replyone').html(this.replyhtml);
    setTimeout(function () {
      self.time2 = self.formatDate(new Date());
      self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p>";
      $('.replyone').html(self.replyhtml);
      setTimeout(function () {
        self.isShowOne = false;
        self.isShowTwo = true;
      }, 500);
    }, 2000);
    this.jdnr = '';
  }), "showJieDaiImgTwo", function showJieDaiImgTwo() {
    var self = this;
    if (this.jdnr.indexOf('亲亲') < 0 || this.jdnr.indexOf('正常情况下大概3天左右能到哦') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.time3 = this.formatDate(new Date());
    this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p>";
    $('.replyone').html(this.replyhtml);
    setTimeout(function () {
      self.time4 = self.formatDate(new Date());
      self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time4 + "</span></p><p><span>好的</span></p>";
      $('.replyone').html(self.replyhtml);
      setTimeout(function () {
        self.isShowTwo = false;
        self.isShowThree = true;
      }, 500);
    }, 2000);
    this.jdnr = '';
  }), "showJieDaiImgThree", function showJieDaiImgThree() {
    var self = this;
    if (this.jdnr.indexOf('请问还有什么可以帮到您') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.time5 = this.formatDate(new Date());
    this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p>";
    $('.replyone').html(this.replyhtml);
    setTimeout(function () {
      self.time6 = self.formatDate(new Date());
      self.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time6 + "</span></p><p><span>没有了</span></p>";
      $('.replyone').html(self.replyhtml);
      setTimeout(function () {
        self.isShowThree = false;
        self.isShowFour = true;
      }, 500);
    }, 2000);
    this.jdnr = '';
  }), "showJieDaiImgFour", function showJieDaiImgFour() {
    var self = this;
    if (this.jdnr.indexOf('好的') < 0 || this.jdnr.indexOf('感谢亲亲的支持') < 0 || this.jdnr.indexOf('祝您生活愉快') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.time7 = this.formatDate(new Date());
    this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time6 + "</span></p><p><span>没有了</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time7 + "</span></p><p><span>好的，感谢亲亲的支持，祝您生活愉快</span><span class='read'>已读</span></p>";
    $('.replyone').html(this.replyhtml);
    this.jdnr = '';
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyThird", function restartStudyThird() {
    this.initThird();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showZdhf01", function showZdhf01() {
    this.isShowZdhficon = false;
    this.isShowZdhf01 = true;
    var $zdhficon = $('.zdhficon').closest('.con-left'),
      height = $('.zdhficon').closest('.con-left')[0].scrollHeight;
    setTimeout(function () {
      $zdhficon.scrollTop(height);
    }, 100);
  }), "showZdhf02", function showZdhf02() {
    this.isShowZdhf01 = false;
    this.isShowZdhf02 = true;
  }), "showZdhf03", function showZdhf03() {
    this.isShowZdhf02 = false;
    this.isShowZdhf03 = true;
  }), "showZdhf04", function showZdhf04() {
    this.isShowZdhf03 = false;
    this.isShowZdhf04 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showZdhf05", function showZdhf05() {
    this.isShowZdhf04 = false;
    this.isShowZdhf05 = true;
  }), "showZdhf06", function showZdhf06() {
    if (this.zdhf.indexOf('您好') < 0 || this.zdhf.indexOf('欢迎光临') < 0 || this.zdhf.indexOf('请问有什么可以帮到您') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.isShowZdhf05 = false;
    this.zdhf = '';
    this.isShowZdhf06 = true;
  }), "showZdhf07", function showZdhf07() {
    this.isShowZdhf06 = false;
    this.isShowZdhf07 = true;
  }), "showZdhf08", function showZdhf08() {
    this.isShowZdhf07 = false;
    this.isShowZdhf08 = true;
  }), "showZdhf09", function showZdhf09() {
    this.isShowZdhf08 = false;
    this.isShowZdhf09 = true;
  }), "showZdhf10", function showZdhf10() {
    var self = this;
    this.isShowZdhf09 = false;
    this.isShowZdhf10 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyFour", function restartStudyFour() {
    this.initFour();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "restartStudyFive", function restartStudyFive() {
    this.initFive();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showKjdy01", function showKjdy01() {
    this.isShowKjdyicon = false;
    this.isShowKjdy01 = true;
  }), "showKjdy02", function showKjdy02() {
    this.isShowKjdy01 = false;
    this.isShowKjdy02 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showKjdy03", function showKjdy03() {
    this.isShowKjdy02 = false;
    this.isShowKjdy03 = true;
  }), "showKjdy04", function showKjdy04() {
    var self = this;
    this.isShowKjdy03 = false;
    this.isShowKjdy04 = true;
    this.notify('<p>快捷短语鼠标点击练习完成，下一步快捷短语编码练习</p>');
    setTimeout(function () {
      self.isShowKjdyTip01 = false;
      self.isShowKjdyTip02 = true;
      self.isShowKjdy04 = false;
      self.isShowKjdy05 = true;
    }, 2000);
  }), "showKjdy05", function showKjdy05() {
    this.isShowKjdy05 = false;
    this.isShowKjdy06 = false;
    this.isShowKjdy07 = true;
  }), "showKjdy06", function showKjdy06() {
    var self = this;
    this.isShowKjdy07 = false;
    this.isShowKjdy08 = true;
    this.notify('<p>快捷短语编码练习完成，下一步快捷模板导入练习</p>');
    setTimeout(function () {
      self.isShowKjdyTip02 = false;
      self.isShowKjdyTip03 = true;
      self.isShowKjdy08 = false;
      self.isShowKjdy09 = true;
    }, 2000);
  }), "downloadKjdyFile", function downloadKjdyFile() {
    this.downCount = 1;
    // indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
    var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
    var downloadRes = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var response, blob, objectUrl, a;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return fetch(path);
            case 1:
              response = _context.sent;
              _context.next = 2;
              return response.blob();
            case 2:
              blob = _context.sent;
              objectUrl = window.URL.createObjectURL(blob);
              a = document.createElement('a');
              a.href = objectUrl;
              a.download = '快捷短语.csv';
              a.click();
              a.remove();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function downloadRes() {
        return _ref2.apply(this, arguments);
      };
    }();
    downloadRes();
    this.isShowKjdyTip03 = false;
    this.isShowKjdyTip04 = true;
  }), "showKjdy07", function showKjdy07() {
    if (this.downCount == 0) {
      this.$alert('请先下载快捷短语模板');
      return false;
    }
    this.isShowKjdy09 = false;
    this.isShowKjdy10 = true;
  }), "tirggerFile", function tirggerFile($event) {
    var self = this;
    var file = $event.target.files;
    if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
      this.$alert('请选择你下载的“快捷短语.csv”模板文件');
      return false;
    }
    setTimeout(function () {
      self.isShowKjdy10 = false;
      self.isShowKjdy11 = true;
    }, 500);
  }), "showKjdy08", function showKjdy08() {
    var self = this;
    this.isShowKjdy11 = false;
    this.isShowKjdy12 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudySix", function restartStudySix() {
    this.initSix();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showZtsb01", function showZtsb01() {
    this.isShowZtsbicon = false;
    this.isShowZtsb01 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showZtsb02", function showZtsb02() {
    this.isShowZtsb01 = false;
    this.isShowZtsb02 = true;
    this.isShowZtsbTip01 = false;
    this.isShowZtsbTip02 = true;
  }), "showZtsb03", function showZtsb03() {
    this.isShowZtsb02 = false;
    this.isShowZtsb03 = true;
  }), "showZtsb04", function showZtsb04() {
    this.isShowZtsb03 = false;
    this.isShowZtsb04 = true;
    this.isShowZtsbTip02 = false;
    this.isShowZtsbTip03 = true;
  }), "showZtsb05", function showZtsb05() {
    this.isShowZtsb04 = false;
    this.isShowZtsb05 = true;
  }), "showZtsb06", function showZtsb06() {
    this.isShowZtsb05 = false;
    this.isShowZtsb06 = true;
    var self = this;
    this.isShowKjdy11 = false;
    this.isShowKjdy12 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudySeven", function restartStudySeven() {
    this.initSeven();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showZjgn01", function showZjgn01() {
    this.isShowZjgnicon = false;
    this.isShowZjgn01 = true;
  }), "showZjgn02", function showZjgn02() {
    this.isShowZjgn01 = false;
    this.isShowZjgn02 = true;
    this.isShowZjgnTip01 = false;
    this.isShowZjgnTip02 = true;
  }), "showZjgn03", function showZjgn03() {
    this.isShowZjgn02 = false;
    this.isShowZjgn03 = true;
  }), "showZjgn04", function showZjgn04() {
    this.isShowZjgn03 = false;
    this.isShowZjgn04 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showZjgn05", function showZjgn05() {
    this.isShowZjgn04 = false;
    this.isShowZjgn05 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyEight", function restartStudyEight() {
    this.initEight();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showTjgn01", function showTjgn01() {
    this.isShowTjgnicon = false;
    this.isShowTjgn01 = true;
  }), "showTjgn02", function showTjgn02() {
    this.isShowTjgn01 = false;
    this.isShowTjgn02 = true;
  }), "showTjgn03", function showTjgn03() {
    this.isShowTjgn02 = false;
    this.isShowTjgn03 = true;
  }), "showTjgn04", function showTjgn04() {
    this.isShowTjgn03 = false;
    this.isShowTjgn04 = true;
  }), "showTjgn05", function showTjgn05() {
    this.isShowTjgn04 = false;
    this.isShowTjgn05 = true;
  }), "showTjgn06", function showTjgn06() {
    this.isShowTjgn05 = false;
    this.isShowTjgn06 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyNine", function restartStudyNine() {
    this.initNine();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showDdcj01", function showDdcj01() {
    this.isShowDdcjicon = false;
    this.isShowDdcj01 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showDdcj02", function showDdcj02() {
    if (this.ddcjbz == '') {
      this.notify('<p>你还没有填写订单备注</p>');
      return;
    }
    if (this.ddcjbz != '顾客要求发顺丰') {
      this.notify('<p>请按照右边提示填写正确的订单备注</p>');
      return;
    }
    this.isShowDdcj01 = false;
    this.isShowDdcj02 = true;
    this.isShowDdcjTip02 = false;
    this.isShowDdcjTip03 = true;
  }), "showDdcj03", function showDdcj03() {
    this.isShowDdcj02 = false;
    this.isShowDdcj03 = true;
  }), "showDdcj04", function showDdcj04() {
    this.isShowDdcj03 = false;
    this.isShowDdcj04 = true;
  }), "showDdcj05", function showDdcj05() {
    if (this.ddcjdz == '') {
      this.notify('<p>你还没有填写地址</p>');
      return;
    }
    console.log(this.ddcjdz);

    //   if(this.ddcjdz != '双流区大林镇') {
    //     this.notify('<p>请按照右边提示填写正确的地址</p>')
    //     return;
    //   }
    if (this.ddcjdz == "双流区 大林镇" || this.ddcjdz == "双流区大林镇") {} else {
      console.log(this.ddcjdz == '双流区 大林镇');
      this.notify('<p>请按照右边提示填写正确的地址</p>');
      return;
    }
    this.isShowDdcj04 = false;
    this.isShowDdcj05 = true;
  }), "showDdcj06", function showDdcj06() {
    this.isShowDdcj05 = false;
    this.isShowDdcj06 = true;
  }), "showDdcj08", function showDdcj08() {
    this.isShowDdcj10 = false;
    this.isShowDdcj08 = true;
  }), "showDdcj09", function showDdcj09() {
    this.isShowDdcj08 = false;
    this.isShowDdcj09 = true;
  }), "showDdcj10", function showDdcj10() {
    if (this.ddcjyf == '') {
      this.notify('<p>你还没有填写邮费</p>');
      return;
    }
    if (this.ddcjyf != '10') {
      this.notify('<p>请按照右边提示填写正确的邮费</p>');
      return;
    }
    this.isShowDdcj09 = false;
    this.isShowDdcjicon = true;
    this.isShowDdcjTip01 = false;
    this.isShowDdcjTip02 = true;
  }), "showDdcj07", function showDdcj07() {
    this.isShowDdcj06 = false;
    this.isShowDdcj10 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyTen", function restartStudyTen() {
    this.initTen();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showXjrw01", function showXjrw01() {
    this.isShowXjrwicon = false;
    this.isShowXjrw01 = true;
  }), "showXjrw02", function showXjrw02() {
    this.isShowXjrw01 = false;
    this.isShowXjrw02 = true;
  }), "showXjrw03", function showXjrw03() {
    if (this.xjrwtxt.indexOf('此顾客有购买意向') < 0 || this.xjrwtxt.indexOf('请继续跟进') < 0) {
      this.notify('<p>请按照右边提示填写正确的任务内容</p>');
      return;
    }
    this.isShowXjrw02 = false;
    this.isShowXjrw03 = true;
  }), "showXjrw04", function showXjrw04() {
    this.isShowXjrw03 = false;
    this.isShowXjrw04 = true;
  }), "showXjrw05", function showXjrw05() {
    this.isShowXjrw04 = false;
    this.isShowXjrw05 = true;
  }), "showXjrw06", function showXjrw06() {
    if (this.xjrwsj != this.xjrwmt) {
      this.notify('<p>请按照右边提示设置正确的时间</p>');
      return;
    }
    this.isShowXjrw05 = false;
    this.isShowXjrw06 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyEleven", function restartStudyEleven() {
    this.initEleven();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showTcqn01", function showTcqn01() {
    this.isShowTcqnicon = false;
    this.isShowTcqn01 = true;
  }), "showTcqn02", function showTcqn02() {
    this.isShowTcqn01 = false;
    this.isShowTcqn02 = true;
    this.isShowTcqnTip01 = false;
    this.isShowTcqnTip02 = true;
  }), "showTcqn03", function showTcqn03() {
    this.isShowTcqn02 = false;
    this.isShowTcqn03 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showTcqn04", function showTcqn04() {
    this.isShowTcqn03 = false;
    this.isShowTcqn04 = true;
  }), "showTcqn05", function showTcqn05() {
    this.isShowTcqn04 = false;
    this.isShowTcqn05 = true;
    setTimeout(function () {
      var $left = $('.tcqn05icon').closest('.con-left');
      $left.scrollTop($left[0].scrollHeight);
    }, 100);
  }), "showTcqn06", function showTcqn06() {
    this.isShowTcqn05 = false;
    this.isShowTcqn06 = true;
  }), "showTcqn07", function showTcqn07() {
    this.isShowTcqn06 = false;
    this.isShowTcqn07 = true;
  }), "showTcqn08", function showTcqn08() {
    this.isShowTcqn07 = false;
    this.isShowTcqn08 = true;
  }), "showTcqn09", function showTcqn09() {
    this.isShowTcqn08 = false;
    this.isShowTcqn09 = true;
  }), "showTcqn10", function showTcqn10() {
    this.isShowTcqn09 = false;
    this.isShowTcqn10 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "dateFormatString", function dateFormatString(date, format) {
    // 时间格式化
    var date = new Date(date),
      o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds()
      };
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return format;
  }), "getLastDaysFromToday", function getLastDaysFromToday(n) {
    var lastDays = new Date().setDate(new Date().getDate() - n);
    var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
    return lastDaysStr;
  }), "addRecord", function addRecord(type) {
    var _this48 = this;
    var data = {
      exerciseType: 'WPS_EXCEL',
      stepSeq: this.tabIndex,
      exerciseAction: type
    };
    this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
      var result = res.data;
      if (result.success) {
        if (_this48.tabIndex == 7 && type == 'END') {
          window.parent['goBack']();
        }
      } else {
        _this48.$message({
          message: result.msg,
          type: 'error',
          center: true,
          duration: 1000
        });
      }
    }, function (res) {
      _this48.$message({
        message: "网络繁忙，请稍后重试！",
        type: 'error',
        center: true,
        duration: 1000
      });
    });
  }), (0, _defineProperty2.default)(_methods, "inputnr1focus", function inputnr1focus() {
    this.inputnr1 = '';
  }))
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps1.2b40a6c.png";

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABVCAYAAACy2jEbAAAWH0lEQVR4nO1dCWAURdb+eiZ3AoEQIJwhkHAZEOWIEBAVRQLIsSJeu4IshwIacBV3kV2RVfFigQX1J6yILLqCsB5riICoiwgigoQAQhIWEiCBJBy5r5nu/1VV90zPlUlgMonIg0d3V3dVd72v3lVdPUjSe+UK6kCKYnu5BLku1Z00aKjT/TxN9nd37J/Rzfmaye3zq/2vWQrXyWt0HYhGQnUCor7NxK+ZrmtEIyGfulwsSZLXtYLdsya6VrT0ukY0EroORCMhMk11ywPsLYU7y6A3Lc7MiCTVPQ+xbcezY8nBFCo1n3drGl2YVq2edvYXpxHXgk9w1odfHBDXKl0HopFQncLXq6Xnf16LqbnJaF10Eb6yiXSULKRiFltZ9RWyIhyPTRn7R+F/C6uMOBLWFU8Pegp72sQ6vc99l3dhWUkSWkk58Cm/TPVkYeuZQabblR4qRdHhQiDfDF+jEb4GYskII+0baWug40KDDw5GxGBjr7uQNOyJepeNJL1XelVG153N1pwbA2F+6rvwPXDR1gFqAtK2taRLAYG4e9o72Neul015QuE+fOr/Gnyz/icAYPeX1BsRuCWppcjdfg4BRh/4kcAZ+9K+DwOAgGBbicokiYwFcY65AovveBxvjXj6ivrvro7k7Um/aaf/Dd/Ui+ACkVQ2EBt1W63MoO3Dui8pNvvNK8uwbsM8+DCNUilArsJGaRl8T2UB1WZSNrrWRMy2TCnKzDizjbTEYIDRIJEGCDYwmRvpERhgRlUqdJ5t2/r6Y9yuNfUuH68BEV5yUYxQo52w9Wy0F7psLTcotvvE3S9k44FDKZZ7rMpZjpCKC0BlNRe8xDBig88swChJLyMADASExIEwSAwEiQa+yj7aPmzu37yypN7l49ZHXG24qNUv9g9GC8NFUag3Qcx06O9hsDsWrdjG47rdYFOFxfz9xm8/kEtAmGXRDq8qzJNSreDMV2SSyOwYVSC4NhiFdhi4BqgsabZSUIm/v8v+XckUjH6qSKvvViPYhTVxbWln0z5AMx9H86ONeq2MDWVtNPJhrT8Pm2vPhjTHezeN5e3/9ew7BMplKFVV3Bcws6TIjCXuoMuzKsiMGaxmSRU+N0uS0ALOds9XRuYuNeqWWvezNtSgecScm+eioo2/rfkx2m25AFQADCpzQMxia5Bt6q8cMhmVRj/e/gx5K6RzBfwyBoKkmiaJAVItI+er8+SUVU0g6XMQjJpJgtAI5h98JBuwT1VX4tV7X6l3+XgtfD0dHIGjzaJxs99P5EjVEaFZADZCaH/45LX4MmqgQ10W6i75YjFm//C+pd4l32D8X/8H+OGsnM0IN5HZq6ji53izBtWC0Wg/YuiEXisPObTLHH3q26PQs+Ck7nkUi+kzkVk73DIauc3aueyXpzJ9ryZ0f75pNkzh/lbTo6gjnpskM+LP/Oi0XjXF9C/c/iSKKGTVIqmkWx5EoX8IP/900SYg7yLPQRRZ5Bu8edpWV0t4qNsbTtsNL7uEqEtZVpOnN0vE2eVlePuev9SPMOzIq0CktI/H2aYtVLsvW3yCwk2Pgin7PiDL43wS8EJgKNb0ncDrlZHD/XvcJF4+9sK3aGfMJSdQaY2UNEDILJ02tkZak65O23zsp38hECbVDNpFclSWEdgcO7sNq7FPnvKhXnPWGq2N+Q2UQHKmUG0/dVhSfUKHolxMObzBZd1lcVNQSSCsv/le5Ia05GWL8pJgLCjkJkKRVTXg+CowmQ2YHvOC07b8zNWYduB9536KfEV+eQU+j59c5/5dKXl9rmlR/9m4HBzEoxNFkjkgCttnf2g76/t3XdbNbtoGH944BksGTuXHAwoPo1tVNsWXlcIxc2tH7bDwlf6e8wnDjhbOI577jyWjbXm+LmeBTf7yP9kXb9/1h/oQgVNyCwQfaTVwbTVGu14m3tkhDoqPGIGKatA5IMSxZ45g+Onv1KkJSfhyHc8evhDpzSP5/uvZK+BbUqRqgWJJ2tmW8mr8OWquy37NPvCeNSTWfJZqnkqrq7G7++3UBukqldfMsGF7ciYTAw+hBfPBSNwgs6+zbl+EChawKcIsCTMlizlA4md2LnNZt8QvkG87l55B/8ojQFE5yVBz0sI8seMLCMW6tmOdtjEw9wAGnD/omMew8JX2M0vMeGX84nrouWtqECDOBrdGZusoq2kChGawcUyC6Je+B12KTtXYxpKTyxFQXEJyEwAwWVp9hIIVHSa5rPvkgXdtoiO9VpgopD0a0R15Ia2vqG+uNMMdNdj7iD8Oew7VZuEXLGGsCkkARTIvfv2Sy7pNTKW4s3gvUFpOMpdV2ctqEqeg0BCIl7s85rRuu5LzGJ++xSp8O7OUVVSBFWMWeqyf7ky7Rg0GxJbI21AQyiIfq7OWhcumbFfB0NTtCKyucFr3pcwVCCktFO8uGKmaoKjJ2D9bj3d538fS1sHfWG0jfDHjKkLWzKAI7Ok8xPMddkMN+oZuXf+HxZwQH9XqKIEwLU0qirFwl6Od9pHNeCCfRjSFlzxYYD6BASAr3DcUKUFIjHWehAWYKzH1yPui16o/0PuJvOIqbI6f6tE+1jaYaVAgnoufhxL/QFUP1D8ECjNSRhLU2N3vO9SZd3INZcQXoZhYTCMA4FqkCD+ztdWt3MCxaZE2pXk2dR/M+BQRlQXWCUUbHwGcMAXhH7fW/9s4Z9SgQDCBfR8TzyMeWdZphizACL9UgClpH9jUmZbzISTKonm0xetAgEF1SxRfPNrnVX7dQxn/xsw025xk9uF/WH2DzbsPqltRhW+73skg9Urf7ckCxNVmzLUl+/tMG7UUFQY296iZJjHpwQTs6yth1lbrPNGk05+iU3EOmTOzAED8w00TM0t7Q/uizBjIRfnUwbfwyLEP4Eutsfvceu4H3FxwWPUNcAxZLxvw2ljPh6zOcqlG4aztZytzyDnmtI1UNYL5XW2ky9zxNss5hX65P/Fr555aA6WiUkRZqi+ROGhmSq59MHnAEn7dPVnb0OvyMbQvP4fJR9fzsicOJ1mdMgPDsq+gmvzOkYhYXAgK96IkbKnegagpy9ZAefaul0FxDM+6RV6miECIDkKNMl7ZmIjh+d+i96WjlGqo7z8VNQlk5ox2U5v1QE6AiP2fTl3Be8beM9y/fy06lpzFmJNfWLXBJmSVceqCCctHO5+T8hZ5VSNcmbzkqDtR1qyZ0AqNzeQnKKJi72kiMg/j+SPLAf72TRZOWpulJcRKK42YGSd8w+DzezE4f68lEoo5ewiLv50PP0O1kzeC4Enl8YD22Bc5yFticEqNZoHZP+MetbzeZABooJhNCsKDZQy8uI+EblZNkepS1dA1IzASaaQRjOalLbcRdMumwH1nttjlDLCAknfJhM2DpzdgzwV5FYia3mb9cfCfUekXANkkgOCgmMS2aVQgN0mSolimz3kmTcIsKZUw75a/8jZiyS+MOLtdF5LKCAyW4OOrm87QXrmqIWt6aROsHTjLK/2vieodCGcRgqvo7GDPWwQAbPGfCggbwQFhdK0s5rklCAct5phkZPlF4Ks2IhN+8ORHZMpkCwiWtVH6xQc6QIpLTdh1w4j6FkGtyOumqabQePLYJJgkg9AKE/g2oIOfxTGLOSn1BRBtKwplLO47z1L/o07jHf2AxSnDNnQlgDPzffDq6Ffrvc/OSJvW18jHlWC08qt9Oa61sy36CJoYZZGs8ajIGqbqjw99uIX7B0NJMfo8eh+CIowkN93rU/4OBFyoWaY2+KDbBGjfeBwM64mt7W7H3blfw2YtJ187JcOy9JK2VdUK0tr1QVFgc4cUzhMLAqwzsIplMYL9Gi5JdxuvreJgIPTt27fW12/ftg1h/fzo2U0WmVqyXtKaiosyVvV3nBd6LTYRd5/boVuRwXZUIC0LxyRk5cpYOtkxgfPm9xeKZAXDa0Ao6spuk8mEE2cLMffNnSgpr3a4bsffxlNG7cs1xOBvFqu+VOGJXeEbTle1wNK+sx1G89etB2Nvi5sQd/kn3dIYRacgQguP+3VCatt+Dl8ENRR5zUfIupHWpV0o/jZrCIIDjDwr1jMj7ZWqWDap+ga20EARyVxloYKPYu93ea83YudYs2cHfwGcz5OxYWjDR0p68h4QsuxQplAkpMiyLauAyWbdDKlRW5PKzphxuqgpnh+6yOW9Pm4/GsdCO1vrq6Gq5rAzKsLwfv9pnu/kVZDXgFBkq0ZknrmExOVforiswlYjGDCWcFe2nRtSl19WlQJbu4yEWXL96CzIXdr9Saf1i4plfN3znvrvcB3Je0DoIp+/b/5RBUF2wqpGkHbsD+utmxsS7x1O5LXAH8Yst7brgtd2fNihPlvZkVoQhpdGL3EIHxuavO4jSsqrcOB4Lhe0TBrA+NmH4jjLik4j6PyIwZ/hvcgHUOAfirzSYGytuAWjp+1ApcHP7f2qDL4YEf+JqB8QijPlIfi4Mg6/m/ENnXNf39vkY/mOwBV5aNhoPqK4rMoSQTGa/8ggjIjrrM646jVCwQW/MDzad7VDW7V9W3LBP9x9fbV/Wr5T1/ypztGuXd6mfWfudR/RpkUIIsKCuE9g0dOIuC4WLbh7QJSNafo1kdfWvmo+gtV5bvIQrhUhAb5OV8GJ8LV2QGiL0q6EGxN5MXwVI519Qtu/R3u8Pe8etA0PgY+PD2eWxPn5+fGtuL7+NaIxgGFZumpYX/Nv+nkq5d8S/l8xz6TNNZlFlCSr+YMsK+o5UVZWreAxnwlu73+1wpTMtr7B0m6tfcTVPYCkJrFeA8L1g9R8/loHwgAvO+vrVDO5nfS7ln9BjC9Kk9xrpTfIAoTD75nWOp6+MqWytGsXHdkDr0VR2vX23yd7Qog8inL4Yaba1ZXcJFru5Kf1vtGbpl+yxtWFvPrrNA1K5UVA6WWgrJD4srXc3tkGNwOCQolpG9jUa4/nGSB45wqtx6wjlnK106xjlusvC6Ew0psmdk2w/jpd/cBQVUChjgJyJeQgVaisTTqvFFzAssR4JLYGUt5ZjZF7m2PZoglIjKDjz75HzJiuSH5hM+bkRwLsi4FfIhDThsdglXkvDO+etgh94G1x+O6Gi4hfeBh7WkaKsrsG4rtupYifeRwTV8xGou5b8pQ1qzFqr9hX0AVbVt2BBN25kWkk1BYdSUiRUFSwpTICIT8Lil8TZCyIQ7SltctYvugjzM2m68IjOUCDhsQh8cx/YHhc3GTQb8chMWsjpEnfAj0nIGOMR6RhQ7UNdjzjI6iTSd+fAsIqMDArFSBWss5iYo8mQJv2mOgjyhjHhgQj86tN2P3zQaA6G8t//ztII56ANHMbYqaMw1KfQ1B+NnMQ8DqVJxDfuwLpI++EwzIwDYQ2raDMa4nkpxbA8NvXYZi+GtL8Yxj1l2lIjjoEZAuObdYMmZmHSTOyOMe2aknHdI72cXQTYh5egzlnPCKROpMHNIJMS9kl4EgZMqdEY2LAEuzOYhoxCF3b7UXK1jh0DSVg0pjJ6IieLXOR/Kf1wDFSBVMVcJ4JgkZswUq8vuszPNO3HHMyDIg5kYRJa+hccCg3E3Oe/9Jq8jQqY+ZGwZYFUUhZOAZzfgyFxEY/aaR07HPEvOQL5bl7MO3WlUhioJU9AxRSm8e+V+sTF9IAOb4LuJAtAOHaU2hlzYTqTSajUp3J9YBP8VzUdHQPkk+2Q9c2p8UIHNADCds24cVjmUgY0p06T+of0BGjOqbj6PYsa71LbLSmCa6k49KTwPb9yOgyHQvuOCTqsXM08m38ECN23LUFEk59gBffomsKsqEwgRPx7fovkIJW6Nn0MKa/+ilWDQOip/8LSt56bNlwEquG0/HM/0Ap2YTp/Z5Fxv7nMZ21yQDJZgAPgLJ4OOeMeJN4hqwSm/L0vtmiv6xOedEVi88A9dNatnxRz1q5e4YYgUGl2EgCThh+J3+w6cOGImXzG9i9MRmZMT0xKP8UENUB0ds+R5KzJ+nzJzwzLAvJmw+QYSV/QKYq4c1LJKRPMJ1GnPaLcBLlFexn3vhsbXkh/6ARcgnXDok9R2RvSD1u5VsE5yM9MwpdI08haWxzzNgKZK6ZCqnnfIycNRQzvmbH0yC1mmp9JubsCzpjy8cTEbNhMaTxCyBNW42YT85SeSC2rL4B6VMegdR3DHEikmMnkPlLFUDoA4W6A+EBUiOT3dt3IzM6BoOUgegZk4n0w3Ru90YkYxQmDgKmj0tA5vEDuorRSPyOUqm8k1C2jUDy7xdgTskQoDvxDysh3foI4tdFY9W+TyE/29vxvmzUV7ElgVXimIeexOEd1QiMfBROIP2gGlG5mtBlAiwqpp0SoYFxNyAhcyUmLfyCa5klGruxAwUPrZG4Zh2U/Z8RL0ci3Sqmw5V9CqwnDwGhdj6vEBmduyF20EQSfTI2pjK7uhtHM6LRNXYQB0eMeC2SyMTyeBrZnfpA6vcE5lyK5BERt9NsS/5h94qZkPovRcqAiUiOPmQ78oLIJu9KQ0r0bCyYBDWEvawKj7a3j0Zi9AkcTVXtuKvelqmaxZwGq8e/wSA+fUjlNMF5dC5zOeKZNoY0J02KIu0biphl+9TnKnRxA/fkISCacuFJ4WfxyTdDMW5BVyB5I3areUHS52Rmxi1AVwbO0WaqoMNgM4/AnTK10ZFG/pCZyHjxblHO7XIO7ZxEemq21Uny+5IpapGPF9dkkxk7gKWdCrlZVI7thOLTERkL45AyZwaSWJuMWWgSECHuz9hXPWYg+bIlH+p/Y5P0CYGbKMDlNBDLHm0LbNohynXh2/S3XnaM5q6APJdZs86QViR9tx+rnktAyhePi84z2nsEKW/ORcLWLRjZUft50Ci6O0miOV1j7AWpA5V36C1sP43KScW3QUkZbWk+Zf5QyglIeD2sv7fBkjyFwNuz8XVIO4YiY9M3SLTUyKfQ+BHMSaV2O4ocBuyn+QJa04BRL/EVx+y+CGcDI1jNgTZg5NBeyPgv+ag32YWpmDH+I8phDmHk6HeR8TmZ01Xqc732BAUgvQWw9lFdHUgyrK/5d19rPenH7HU2yxVoRGaJXwvjDlNrh6kujW6bMqbKbKWLNmIJJKm82GJ++Pl81RSxfdbRyBvF9cwUsnuynIDdN1+NxLgW0nWluiw7XAWCHQfZhaFs2o7V1yhfF9Fp9bTwVDM/WobPNFIDIEjV9DqGsJp8PagRTS0PLmkjQ82mLWWa7dfKmJlhz8Gdq4vRxIQarJ6zdLyZzT35klZWpo9atHqBobZAOJDBZqJVaWF9Pv5Mmt0PCrUFxsPk2Uk/PiqgE1So7Tn7sjL1Zxy0+SB+XgW0jEJWHq1YQbCMvCDdqNPA0IRmN9eksBGqtV3qTICGmgXrpYTOrWlyRrWbmq5lHCDbtuWpb7xrP31+df8P3tW+D9FetTb69xG/FqpHIHSZ93VyS9c1opFQg7+hc1iNUkcX0Rhe/HuCrmtEI6HrQDQSug5EI6Er8hGuYv0rWfrC1i05q2u/fqm25OnlN1e6FLMmsm1DtN/wztpJx67ltUyu+tbgQOjpWgbAHTUaH+EAgvYz042I6nOgNLhGWPIAJzjYnL/G6f8BfZBpFlq+CKEAAAAASUVORK5CYII="

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2.d3f7ead.png";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwpx2-2.d5d805f.png";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2-3.5977d26.png";

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2-4.d635d8d.png";

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2-5.d6e4fa5.png";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2-6.53885af.png";

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAUCAYAAAAz30VQAAAAyElEQVRYhWP8+v3nf4YRApgG2gH0BKOeHa6Abp7dUyTHIC6Bigv30Mt2CKBvzEbNZ3j54hEELwljWBbjwzDjHv2sH7hk7OLJEMVwieHmiPAsGOgxqCvRzzYW+lmFCvYUJTIsAyXrYevZZYkM4stgHD2GxmPOdLV+4AqoF4UMN63kGDxn3Keb9QOYZ50Zchv0GM5t3M1ArzJqtFFBF3BvFkN2wyUGI39XBnqVUQNYQAGz8JJHDP0u9LOecbSLN0zBqGeHKxhRngUAaDE64B8zBqgAAAAASUVORK5CYII="

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAMCAYAAACJOyb4AAAA80lEQVQ4jWO8dPX2fwYaARbilX5kWPdqI8P8PzCdBgwzxPQYpCk3HGowqwPDZjE5op3DRIyip58PQQwWJN5gIg3/yHDy+3sGZw7SDAYBIoLlI8OjP4IMcgyXGAqfXWC4AxV1FoxjKOCk1PA/HxgeMrxn2PtZnmGGVBwkAr8fZvB9v5lBjtWXIQiPCUSFOQODIEOiEFLK4NRjSGR5z3D4+0e8uog0HB3wM8iwElZF2HAWeQZboCsf/UYW/MjwBMiXZ+Gn0HCgK805BRn2vj/McAoqAk6afxQZrAhEKCOx2f/p580MGZ/fQ3mKDLVStgxmBPQAADQrR0n8hmJmAAAAAElFTkSuQmCC"

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkwps2-10.81649f0.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-1.9fb1ccf.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-2.19ac745.png";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-3.667fa4d.png";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-5.e1883ba.png";

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAAAQCAYAAABui5P/AAAA80lEQVRYhe1YWw7CMAxbEffgpJyMwwH7qFRlSeM8prbT/DWWxs5M0wXK94/tRgiP0QVcAUuaWEoZmk+xnIm7AZETKJrP4YkKt+CKqGt6MSkf4Ufr8xhkqY/jV03kvjl6r/3ciyHrpXtofdadZq2PWx9uZ0q6X2efOZIWh55+Ritz/KqJGaJn8keRoW/eiWcf7FIc1Y3uQqQ+CujFYi3Em+/hp+0VOU44fYQfNnFGAysyWrKnr/FD7TzawNH6GlQTpRGggm5vdMRB4wg0Pi1X09f4XcM2RWskMmxb4taxxjNzhp9v9n9xZvyZd9B4fd5Tm7gCfjTF8YWVhBNBAAAAAElFTkSuQmCC"

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-6.843fdf6.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-7.21ef4fb.png";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-8.3c8c716.png";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-9.626539d.png";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-10.a377209.png";

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAATCAYAAADLRLCEAAABeklEQVRYhe2XO0vDUBxHf6kNvihqrSC4hEqtSlFxsTi4FBU3J/0GguAHcBbcnAWLiyC6SQdRJ6cKovGBLYo6aG2l2pJWNNqEWGNiEAOta/4ZcuAOuRlyONwHYd5LsgqHH1zUAnbCiWHCiWHCTS1goEI1n1wMA4bAgnRlqOVPyHcHWJ2fRmcwhC59BHowtbCFRM76c51sZahlBZmzXUSXVlDon8P+zQQ4/UWRR4wHWFnSHuotdWJortYvvKWOsbkcxTk3g8XZIbRYL1EBzTZRRTzd87i88mB03B4hdGhiaFtAfBTx2tyHgJ/EoCo0MRQFUiGPLMnH/4cmhqsG7gZtSM8QiiQGVaGJUetBWyCo3R4niMfTKJFIVEITw92I9tAIIsM+XGysYfvo4S/IRxqJ6zRyL4rlWkRXq44MIZXE3voO+GwGrLcDdfq0xMAbHsNkZBBcE2upEWEMg5KQQvL0ELf535lWdIcH0Ov3GXEshDyGnXD+Wk04MUx8A2GHd4G1+KZ+AAAAAElFTkSuQmCC"

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-11.110c390.png";

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-12.3dab4df.png";

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-13.d035e87.png";

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-14.330d44a.png";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-15.95672ec.png";

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAPCAYAAAAYjcSfAAAA6ElEQVQ4jcWUMQ6CQBBFP8Y7SGW5ewto6AjcgkI7Ck7BJpQkcgs4gceYtbOSAxhjpUPEEGPjoOBPpthJdt/+mdl1zpfrDTNrMTdwJNTC+Gus3D78AiQ8YSkHBshViXYfClGDHElPyQTwKEVbjQd2EpTXomks4vg7oBB6AJGCRgHPHXqaNFNCyfLAWOQGqE5HtF1wmeskgBFOknB6FbJdym57RSkybVFz2SeEvl9CKfmuz6E6RMyu6MWUheW11jKywKlCFCnu4QZ1nyGzRU4h50VM2Tt9gPitmqfdkIeqRCxjyqG/0F8+/Dt3PU/6U6OhLwAAAABJRU5ErkJggg=="

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-16.d174581.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-17.c25b939.png";

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-18.497e97e.png";

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nr1-19.10f399d.png";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-1.bb7d73a.png";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-2.3d86c3f.png";

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAQCAYAAAC1MDndAAAAjUlEQVRYhe2X0QqAMAhFM/r/X658KOTiuAOJhXqeGhVsB70yOW+2Zsi+egN/pwURWhDhWL2BrxGR9xnj1r6z2O9SC1IB9rC4VtiMKtViKmNUNSNSV9AMKAwrqpQgr3q8XCqTQdhS3pqRWpASvSiUCmlkJrDTC7ISvDFP/69wWX0keUdlU6yEoAjpWyzKBR0+PBsrlOYeAAAAAElFTkSuQmCC"

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-3.a2801bf.png";

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAARCAYAAABgpdrLAAAAhElEQVRYhe2X0QqAIAxFW/T/v1z5MJDa3YxCm9zzJNw9uIMylf1kITfW0Rv4KxQDoBgAxQBSixGRMPdqvHx7tbNBREK0RgduvW7NU56Y0oT3yrg2Wta1zCgvpBTTA4oBUAyAYgAUA5hSzNMpZI7zjL9r6x1jtaF1qEUvTymmB1NepS84AJ42PyJIpqTEAAAAAElFTkSuQmCC"

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-4.2456f38.png";

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAPCAYAAACyTgIjAAAAh0lEQVRYhe2XUQ6AIAxDnfH+V1b3MTObOYPGYDreFwgkrKEFZd2ZBifm3hv4I0OUgKX3Br5CRI52lBB+HOdQiqIF+yLv+vithH20WDwZGSVEaYXSPkiUH+UyBYu+so8JgWOUoijZmxSD1kQrFbSt0IriLRFdwela5n8fE6b18UYtylNo7fOGDdJ3RRcPmMFQAAAAAElFTkSuQmCC"

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-5.34486c1.png";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-6.33b5dad.png";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pj1-1.8a83334.png";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pj1-2.5aa8a10.png";

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pj1-3.4e27235.png";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pj1-4.c2db4ab.png";

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zf1-1.0e2f21c.png";

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zf1-2.c8051ff.png";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zf1-3.73de95f.png";

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAQCAYAAABEO2JQAAAAnElEQVRYhe2X4QqAIAyEW/T+r1zth7DGzSGCdbTvn52IHrtpct5sBWR/ewNfpszpUOZ0ON7ewAwi8hj79mn1qLW2OUinNUcPhcxo37w+Ol/5Taz04LaSvBleV2jNWfECoTXHg2Lh9VFoe44FGeNjgmKTQW9Or2Jmo0cdqyxKs9CaE13N0Ti7ndB61LHKeog1AFVYpkv9lcfQxmoFFx1+XCF49aH9AAAAAElFTkSuQmCC"

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zf1-4.88dfdf1.png";

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zf1-5.4b31752.png";

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xg1-1.d6e06bd.png";

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAARCAYAAABgpdrLAAABzUlEQVRYhe2XP46CQBTGPzfbYa0tMdHGeABLEmMhB+AQWngCCk5gsR7CA7CFMaH0AKwNmxBbtF3q3TczgLD80cjobsGvgcwbZ+Z9M+9zaH0TaMjx8tcL+K80wpTwWGFCB9OdCXXvwHvoRPJ5lTIKEyCTfAfL8QJLKYMX4/lvmPoQ8yjpyAHz3Qa2omE71jC4c/z6wuREeQ6f4QlsAy5Egkgav74wXychStfAcTTkTZ6/wfvvfsEGqnvgr4PeAttenFQ2oVtitmtiHrCWE1Z7Eys+d9xHQ993agskz2MCB6tQvA56Ru54LyJRGF6y8PwusxIRSVfFihhiPbFSotajvjBdLRJB7J66M/OLJ8FmYwvHiQGdN5ypFOgRfIjE2Y5TUsfIE3iZVMT0kYV1lwWZl1nJSZWJBPMVi+u7F0HYUQdo8e2oizLEjItHT0rIjvp54Vm8sDJLi0ntHspjWW95DPWFoYXPYWBNu6iPkHgJ3/X21V9zsr4iYOVWFnsGUv6u2Qmx3WxbX2HJHAr7xzCj1MmobfIO1Y9bmVdQyVXFkhHS5iu3nOp7TLuTuytcPOAalGjpXaMqBi7cvXeUW2g1H5HFNN9KJTTClNAIU8IPRqfLuollVBEAAAAASUVORK5CYII="

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xg1-2.add9923.png";

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xg1-3.531f4dd.png";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xj1-1.6224233.png";

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAASCAYAAABIB77kAAAAY0lEQVQ4jWP8+v3nfwY6AiZ6WkaShWHxRfS18PWb9/S1kFpg1EKqA0b0fAhKjaQkEGEhfobVi/oZGBkZybMQF3D0TmTYv3U+0Q7BBYZ/HI5aCAeiIoJUsZDoVEotMHiDlFoAAFZIHNg6urzzAAAAAElFTkSuQmCC"

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xj1-2.79adf47.png";

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAAY0lEQVQ4jWN89Oz1fwYqAiZqGjbMDEzPq6eugW/ffaCugcSCEWggI3pOAcUmsREAAoKCfAyzJjUxMDIyYjcQFwiJyWdYs2QiQXWDPwyHkYHCQgJEqSM6lokFwygMiQUs1DYRAA/YHEmVqsJzAAAAAElFTkSuQmCC"

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xj1-3.1add3cd.png";

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zb1-1.1e64098.png";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zb1-2.d55b6b6.png";

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAQCAYAAABAzrJtAAAAbklEQVRYhe3WQQrAIAxE0ab0/leuZiHEMCK4iTDzdu1KPmhif/fI5K0+wI0UBVAU4Ks+QBUzm77j00oZxYPk+RL/6foAlFF2WwhllCxfJ/oo6H2hjoKCONooqyCOMspqJA+Ue4rLy1tEGUUj+UADtIciJHgoDWUAAAAASUVORK5CYII="

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zb1-3.b336402.png";

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAQCAYAAABAzrJtAAAAfElEQVRYhe2XSwqAMAxEG/F03sareqFqxEoYQ91pYeZBFt2FR361elDEzbJuxSTlyfR3AiMiKQnUUszsDIRWisvwceqBYiilNCEN3DXz1wmNRKyQKIZWClZLfFO2j9M7z2il9JCUBEop2RqO0A5aFKPtc5ENW/8lU7bPGzvvWS8zdttuuQAAAABJRU5ErkJggg=="

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zb1-4.dad0c5c.png";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zb1-5.861d4bd.png";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xg2-1.242b7b8.png";

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAUCAYAAADbX/B7AAAB+klEQVRYhe2YMW7CQBBFP1E6qE1rWYIGcQBKJEQBB/AhoOAELjgBBRyCAzhFhETJAYwbI1m0QIvrZNa7NnZYI/BCkmJfA55Z7c78mR0LKl8ENDne/jqA/4gWRYIWRYIWRYIWRcLrRInW6K8cmJs1gpcd8hrelXdgyecSNzDpjDFR3riYIJyjH4KfUxXGwxKm56drhu0pFvVy+6t1ypUgv8MuOv6w+BhlBGG43hyzqNz+ap1yPnJB6jb27VZsCsIlPn6uy1SxaY3xaRnCQcmslnDF0z0+13MwOjDLEbONg1l8dj4GvuaI3Zkekk56gOfMlMM6rUrTsi8tHeNjnKliEK5FovmkuW8uEr7lk9HCQghywUCjViIXqIpS7woBeNXMlXMdOIk16Eyx79kYxoYTtT99HLY8aVbhHvk7XTQhrsYN32VWsNk1TbsjIe2kNLbHURy0PLCGdxGDBQVQ4EmVqi0M4uDok5JxxbogOvEv7GplhSR7gGIfO1NOprsyV6kMaqJQ0CPY1LpTqiDS2RFX+87Wzc8RDrtiRT45rFOZIEb+jVQS5Vcy6wzXy9saVZaIL12f0LS6GNJQdmlWmGFipdnArtktX7pDZtAaWzHThE2sKPtaVpspNSO+61nuD4SSFLPiMR9i0Yp8z6Ci/0+5Rv/2kaBFkaBFkfANDXDoAKTNeMMAAAAASUVORK5CYII="

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xg2-2.ffcc66d.png";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xg2-3.d026046.png";

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zt1-1.9d22164.png";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zt1-2.045b11e.png";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zt1-3.62ed669.png";

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARYAAAAbCAYAAAC5pKAlAAAFmklEQVR4nO2cX0sbaRTGny77NTZmSlSCUD+AS6OCf6CIxJuKEBAiJL1QkAUrKr1YooiwFOzFKqQohEquEkQETcEkoB/ACwkacaL7QbLnvJOJ74yZaLZpXcr5gU3m/TsRzuNzzrzpiyoBQRCENvLLc9+AIAg/HyIsgiC0HREWQRDajgiLIAhtR4RFEIS2I8IiCELbEWERBKHtPElY8ishLBZrF5U9TPSuIq8PKK6ie3IPZsPZd/g8GcLE7p2r/QyLvdq6LWLuzqg98/y6cvbfFhEE4bvw66MjSDTi1zFsBWYwYX5Apt/uYGEoYOR8GX6TJCXQD6PR/MopDkvDmE37XOsWkB1bw2XIe9/uudyD5p75FDLTwMlRGeF3SQyEfsfCZISEi9vdezReoyl8T4m+1uYIguDgEWEh8ZgzsbBP4lE48RxVuaYgH3IGIzuK0Y/l+nW81w7wYWydR3DzN12Xcug+aLCgCu5lXJJoWRuQSxo3MUvXA7W1NxDDkRIlH6LrMRyOp5Cftvqd8H7OdnVvR4M4Sk85xFC1Xzf5dQiC8CSaCAs7kiVczceA8RAOg524KEXQ/dHqtYRiGCM07pjEIXsQQtaeGqSgTydxOc1pUATld0Wsa86EAzgeIPFIu52BtSdqIsUpWBw0bsY5ZlsJVhmjvduO2bZ4Wa7G55ij1t103odCEy2/9y9DEIQW8K6xVG4BDlDDJMHgVIaE4ryo/awhzOM4pVGugNr2Y+jh97YT4DSInEWsQ6/LsDAACzMsHs76i7m7gyyJUkwF/x1uyD04nRCPX1ICFt607yOFhaB+XXyYEqEP63S/mJvB54r+GW1RicBfgSAIbcLbsfinsK4cR045gIcpBgdrn3IV7FwUtyYugkb9L38+SY5iNEUic1qfxeJxNf8B637XcjUnEt5M1tKTf1AudaKzQxuihGoY4WArdZOcloZBua8N9YYcz7jV5Ogfa2FpQRAa0rzGUkxhg4J7Yd1X++u+jQu9P0hBzoE+ZuKmAlcRl1OkTrzZd7oHYzqJjGubLoPH+EiotEdE5JiuaKURP7+vtZHYZdKW2G3MaakXo12H7ZQnpNVpNLxqLIIgtIcmwkIBzAVWdFqXHNTnUw1HcqBuU+b08rqMnsBvVqNKkcqaQ7CdAQnVfhJR//387NczEgJXvYXdj8tt8Pue+TW8gSYeaFzHse9LLyA7eVijUaj6kAiOIHwLnsJi7v6JjQC5kZJ9OsUqgOouwQ5uwzBIHFYB3aGEvJ/q1FGPoum1VEA+0efsq8+3hGOjZD/doeujp304dkeX040+mzgWQfieeBZvK9cGthL9D9qtIqlVMK0T6kf4IIdscBCDfq8V2X2E0N2rFWsLJ7gYi9FaORx7HJRjgTskget50scRBOH/gKdjGUiwWzjDsaPVVUxVbiKFl+kIOlloAh11B6AeFTvOqLjOk5CL+aNWrI0OmeieW1WH7ZyOhscYmN038OnAea43+0iNZeSre383HqkQI+mQIHwTj5+8tdGLqeqJDQd3RD0x+otcRZxEp+dgCYtDVno0kCBnk7DnWqnQPZRWcSF4bA0ZVReJkGuJID5paAFtjekikRjAHj65bufRGktI218QhB/Kk7+EaKUt/ZajUCJjBXfGSGGUXMVWOonM5jCJjeusiBs+Zs+1GsfReR+i6TWES9vkIqzzLvkVjwNtraD2qt2P6ztOpvs7Rk2/7yQIQktUm3Jaff8qWk2a/Jqonnj2a02FRLXr7ZfqjT7M/FIN83z1+rr6vuC13201+fa193x9zCvvn/DO7f245dP6MifL+rXVb43V+t17C4LQMo8Iy3PDwlUTDJcgeIuTxc1OlOa5xJBFT29jwXIJCYuLLjaCILTOC/7nuV2TIAg/F/IfPQmC0HZEWARBaDsiLIIgtJ1/AXaWllNvUcDiAAAAAElFTkSuQmCC"

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zt1-4.ef97fbe.png";

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQoAAAAUCAYAAAB1YHOWAAAFfklEQVR4nO2c30ojSRTGv1n2LTIJJhBfwSVqdAmE3HkhGBwhKAwSvQsIIRlEFpmIsJA7EwZhxGHWVfBi7oIQjI4J4ysYiNJRWNiLfYTdc6q6k+5O0kmGhZldz+9Gu7q6qlo43/lT1b7448+//oYgCIIHP3zrBQiC8P0jQiEIwlBGFor6/gIKDfOifY7XsSLq9g6NIqLpc7T7Pv2Ek/QCXp8+udpvUYjZxh2T9mlGzVnnn/u3XzeIIAhD+XGkXiQCufsU9iYyZOxbOIxYN9jQG5irZhBoG0AwAn+/59tfUG3OY63sc43bQCWex3Wk30N63uh2rad5cv0Ah0ng5rKFRKqI6chP2Ehv0tq43T1H/zE84TVlp8Z7RhD+x4wgFCQG2wY2jkgMGjcDexkPZLSzTuNij7/yrtW5zsVq5m/z2KsuwTim62YN0Ys+AypjzeCaREgPRlHMqoE1up42xy4hhY9KZHxYfpNCdfUM9aS+74Tnc7artV3O4GN50SFuqv1h4GsKwrNkiFBwxFBAaz0FrC6gGg7hrrmJ6Dt9Vxv+POao3xUZe+ViARXr0TAZcbmI6ySnHZu4T31C3hY5sEHmgiQGZbfn1nPCFB1OeXKgfq+cfT4oAWphJXbseNoSIx11+BzPqHF3nevQi+mKUMD7DyIIzxJvoWg/Amxw/jNE2SuX3d5apx4qhbC8tmV0lqfmtIM8/46f6xpWRMCGDopSWAy0kFR/1obdPv0dlbAVKTzBuAelF9zv0ZyT+xeUICU6Rt9fjJxMIV/N03ozODkqYqbzjpZILFH6NP4fUBCeA95C4V9EXkUENeWhe0N6Nr4p5fU5slC0DdyFAx3PXP+NPD6JgB9fOk+xGLTWt5DvKWjoSCGxWzTTgUfcN0MIOnIDFp55JMK1MV6zZkt7oKKjkvqFIpJV3eS4Hx9jaEF4BgyvUTTOUCJj3XjjM73vMe7s98NktGy4cQMGeWRnUZNTkhBiR84Coz9ZxKFrmpCf+/hIeD51GymiaZHkzPFglrcn8Tosa/EqbdtSHcZ23Yk2IrY6h41BNQpBEHoZIhRkkFxwREhfspFWF/v2ZMP7wELx0MLkxEvdqFKSls2DW56bhIfC/2WbhVY+35Jhu+oVHJ24ogH+fXI9jxhGSz3cBVUnvTUOhaqviIAIgoWnULRPf0UpSNFC0zBbdEHQ7sUtY/X7A2TsRcAeQUQG71p0J+GtU/rZbKCenXLe6zyvhaDUtHYv6PpytBfk6OU62e/dJKIQhFHxPHBlPASwl+2tDrI4XFcPsBG2NUYiSFzUUAnPYGag5XF0sIBorHv4qt24wV08RWPVcDXg4BULVpUEa3KEFxIE4d/HM6KYzrI3v8WVo9VVXFTe/gyB8hKCLBzBlx0PrbY2HWckXOcZKMr4xSxeLs8aiG4X1eEtZ8TBfQJYOwrg/YVhv4PKkBrF3Gf3/G4GpB6MpB+C0GG0k5kW9uKi2pFgY91UOyI75PVzJCKTFwUUZnU6Mp2lyCNrPatTjy6UxnBhNJ43T3ouUVSxiVw6YDNQ3SdERj+Nc7x3LWdojSJim18QhK9mrI/CdJoQ0R5fiYY2Vj5nsUJef69cxOHuPIlHBideZxL4WDXXOhxHpX1YLueRaB6Tl9ffkdT3BxyQGgc1l7ke1zcqbfc3Ip7fqwjC82WMiILPOJAYVE3D7uyAcIHTULsYSkC4AEmpRPTtOWb6he5srNs1WzRgh89lHCCYtiIL6uOxIq/Uw/oeRO3akCDpHZZFrMUpHdmPKIHyJ7ec34jQ2vcoXVlJQ9IOQbDx4vv/xzW2nZZOBDLKSUxrazTgrIuoj8TQbWPhegvs2ISBayvvJ/p8YCYIz5T/gFAIgvCtkX9cIwjCUP4BX7OEEUJpAXkAAAAASUVORK5CYII="

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jz1-1.993e091.png";

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAASCAYAAABIB77kAAAAz0lEQVQ4jWP8DwQMdARMIMLFO5LB1iUYLACiCbHt3UIY1PXtwfpIBiAfqunZ/ScH2DgHkawH7EMJcVGcDgL5Bhc4vGctyR4EW3hw1xqcCv79wx3F+ByD10JyfYHPMXgtJNcX5AQpCyGNhByDLTqK66djiPU2ZoJplCDFlg1AjsGVPXA5BmY4Vj6h5G3nGkxWlgGBorppGGIMhDRR2zHDP5UyEdJI7YzPQG5cgAA5ZTDYh6ysrODSH1/2wMaWlZEi2YOMIFtJDxfyARM9LQMBABQKBcxy+W5gAAAAAElFTkSuQmCC"

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kx1-1.bbb3a34.png";

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAWCAYAAAA4oUfxAAAA9UlEQVRIiWO8++jZfwYqA25OTqLUMVHbYlLAyLWcBZmTmJLP8PvXL4Yli6YzxMRlgsXwsWMTshjevHnHICEhzjB/zkSSLWdETnCePhEM27esINkQkINAjoEBshKciIgQToUgX+ICyBaTAlAsX7xgGk6F///hzpH4HEa05eT6Dp/DiLacXN+RG+woqZ1c34Echi3KuiYvxxAry42Es7EGOyj1wrIUjA3LZuji+ByGbBE2PkpWQ88yxPgOG0DPaqAQQLcYBFB8Tkmw4wPYLMawfESldroEO1GWk+s7UOVCseUsLKzgygVflsPGBtVq5ADG0WbUQAAAuPuON6+jArgAAAAASUVORK5CYII="

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kx1-2.9d7162f.png";

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALMAAAAYCAYAAACxz8zeAAAEz0lEQVR4nO2abWsaWRTH/132Uyw01aKGIDQfIEuMhSRCV4p501QoGCKYvEghFFJJwrIstkggBDYvsoLBgDSbVwmLG8gD+ADxA/RFCKniqIH9Gu45M6OOOurEuqmV+wMz47nXc++E/7n33KOPKgQEgiHgh289AYGgXwgxC4YGIWbB0PBjtw7Tv7xG+e7fezseefwTLv/5q6dJCQS90FXMLOTbzxndttFxR8c2geAhGcA0I4sgBUKwOUYyH+QAmTsot36E2nTtzX7nDyFpfOm+NrNq/zL25/3YL9Y9SAd+eRy+tp2L4JvRdWV+GFg4b7B1w/dWrP2dwaJJayPcH2kX2ND9dOryArZp/bZ22FfjOPaNtO9QvMKpZQHHptYmsy+KW1+rnUXuyi/gNjShWtRnsHzU2Gi+mw7sWrqML7g3AyJmZgZ/klidDTYWdpSE3dhTFs1OrtGYcOBEz617FWv5nVpQnIxH4HHPAJa7xmBR8fyRQdhBIgxKWDnyymNFzFGyVXtc0c4RqY1VC4riId6dPcfZUV20ckDQM9gTaaRIzNVnc4biKMz/jv2p1mcTfAWVLtieTfa9rZVSJfpqUv6M8lqsRCW28bXzJ5Mbk5X3aQNDSJ8qnlefKgW+T4cqnlhJ46NpHGpXfF5V3m9cyWPU5xaqJA3OoxBblMfRnSONYSPfgv4xkCtzatOPgmzLYeulA1vabmMBWv28MPM95b5LCbRdlZVVVrmX0klc3+TgmgfOljvPhNOWkwS9anPKUJqgjDd6OdW0ezBlFPJWWP2NtuQZ8CI8Aqd5Bkt7hwg41HkzT8yw50uUw0/UbYKvwpCYO1Um/t+qRTXN4NwzjqdHmjSEtvW5txdtc1/OS89r77KIkLDsFAjbyxLe7dEx0NWUriQ4aFTxhki8fjromUZ0hJamNGO9Hjycy5PQczdmzJo03TJx8kdpB9tMU/C8jSFZ9NbTCtMT2G7SKNKtEHN/MCTmhynNXWBp/EK9JxH7O/XNIvhSwotVK7Z23mB0R7+XZ1q5SgcxYHkBtr0S4NjAMT5gTqof5OSdwK/NX9n/un4OTnOz0gH11qQxUWB9GTMjoDHx6m53xVWhTmDWvY7ddBmLtcB7DOuYhEKRcmitL0HPDHCacde62qmkNmMkqCiep/04NbAyF2mFDFBsRfaMzYTFf6J7IOWyYRpPeU68M1BArXCfllU2i3NKf67RHGhxpHxVn+2fT9AbgyFm+dRvxrb61hmKwsn5qXsKYZ3ucjtduWZ8bWBldvq8YIE10liVUNKManWiWnrLyikFarm3ssIqO0iz2DWrbCatEwyKr/MM2dhXsYQvdJk18O8RGGMgxMyHM7h+1eSOlCNTXrsW7l47NpYz6/Ezwp+9usFSr3uzIDOqILV1b1WovDoHgW06kLLIzymLgUlJMTiXblzVORCApcssBcYEUJJw7dY7TAp6ZSDEXMybsRLSCJIOT6ckbr0vLDo74q0/Qts7Q4ILte/adkWnQ+Jvlghyy5QXO7Q+lS9z5FxZ/QaR4WDiIDT7A9gNHkJyeJUDpI7rut14sAruQbfa3cPUmYcDrisbqR1z3Vlb5xb0h0f8p5PYxa/mBN8LXcUsEHwvDOCv5gSC3hBiFgwNQsyCoUGIWTA0/Ac2izZ/0nFFyQAAAABJRU5ErkJggg=="

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kx1-3.7b0239a.png";

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALEAAAAaCAYAAAD48r3oAAAE0ElEQVR4nO2bXWsaWRjH/136IcqakSrEr5BFmzcECXuTCy+MlkiF0ia5ky1ILCGUJS6BBe9iGgJZDG1ewAvvgiDNm0P9CgnEMKNLYS/2I+w+Z2acGXUcX9KNznJ+IOo5Z86cCf/nmf9zxjz59tff/4DDcTA/jHoBHM5D4SLmOB4uYo7j4SLmOB4uYo7jeWrXGV1+i8af3wae1PXjMxwdfhx6URzOINiKmAn4sly07JsJLtr2cTiPxZjZiSoyFAAZsa1ZzCqB8fqk0XkI9Vm2t8+7UoBsmsvytV3VxjdwtJLEkWzMIJ8klfOw965r4YwE20z8ODDBrCF3yz57sfpHEVHB3EaE0pT1k5ZHV67O4Z227uuG780O9iOu7gPkryh7lrAvdHYJkSwuIxaHkLhf3i/hMjWltWjX4Emb2mi924s4eN7j/JyBGAMRM+bwG4k00NLGBJ0lQbeOVMSyd9faWFrEmdW0obdYrX3Ug+EsmMdCaA54Xm8NEo2FX4tI+0l8WxISu2HlXIdCltqaI77SnSKvn0sPBrmAD19e4NOuIVYlEOgafCURFRJx89oCqR1IK7/jyN95bZzhGBMRn2M9eK59ZuJ913WkOROyrHYxXTSJzIqfESWRvd4CNkmYArMf8gSiu5TxlTmSkGImQYmnqMWT1EcWhDLr7D3ZjI3mXG4kqA5It52h8jkPb7wIsyZl8RqYf4eEZw0XIgWovkYXonE3Zj5XETVlaM7wjImIjUysiEppu0Pu1SJy5mGTccp2YVUsJMb1ErpmYTWrqp+ZoG5u7/ByBfgUt18JsydnJXrpayqSHVDPN3Plb7tbMBqQal54Yq1t11+A4HsXAsIc1vMFLPvDhsgFN3y1Onn0KfBk/HB6ithup+G/3YVo2gnmLU/h3jXZDZZZN867elslQ+vfqjgkQfkoADbjEj7kKUTm22xJiQWLJtoUiTZGBZzgshCYSHYiYwQN8+ok8NqtG7PmwZTNcyB7wdoEPxY2jnEth41sL0zAeysqwcpF/HB6ivhxttja7ETMbizd5l9JCL7xIre3hpk961EL0+q7fHIMxJfgzdcBfxL7YHbCsCUddkKZP2PtsWltHio8L1t8QwF3k24sm5pYNvfN72gCncJsKIMDsYGoHnAT8ExKkGgdAa7iBzOmdqLemd00KtvHJKQsXpDPLPeRiSXKiMtkKw7z/a2Eif7MstBk238i3GxN7E5AgZRgYzqyahUXZHNu0B5gp6hEmnN2vz7O4IxexEoV78am9jWQyiLA/GfI31FA6f3sMHrd9JGJA5EwmLBaad1lUO1Ec7ehWThWFesA3VurGVW9Y7SL3JRVRdEiCNS59AJProMZmdn+/kKcHoxcxM0q3khK5IHJt66+7733258ntuInpMthyyAx9q2ZEIuaEM371ppATTseTNwXLKoE1Uowr9yaxVkAAOtXVQqIKbpoCTchqyKRMwwjF7F070YiZRIiFUVlErXVgwZblFt8nm7jDBJaqvvQrhmcir9fPHnU4uR7/eY51YcwihfWnvgxWBAptVssjoOtAmR/WC0MLaY22vsPUk5/PLH796Rexdswff9XOp/YWcOf2H1/bEXMf8XGcQK2IuZwnMCY/YqNwxkcLmKO4+Ei5jgeLmKO4/kX4qEnISZ36tMAAAAASUVORK5CYII="

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kx1-4.4d8348b.png";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ta1-1.4569873.png";

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAGjCAYAAAAGgcTbAAAAYElEQVRIie3PQQqAIBCFYaeLdNJO1rlCInUSLCtHWgTt/ll9jO+hyuJXdXkGd8yFlLQghFiwnaibENvNLZPasM2Yem117jJ182YZ5+n5HdE8/aMXfGsBAAAAAAAAAPgDO8U1S177v6pOAAAAAElFTkSuQmCC"

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ta1-3.310497f.png";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-1.18e2d7a.png";

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAABcklEQVQ4jWP8DwQMNAJMhBS8efOO4fWbt1jl7N1C8OplwScJ8lRcagGY3rZ+EQMjIyOK/IuXr/Eajtflp89ehLPPnLsEZ9u6BDOo69uD2SAaxMcGGPGFeUllM4OutgbY5Veu3WToaa9FkQcZfPPiQdyu+48DvH//8b+xlef/Dx8+gtlGlp5gGhnYOAfh0g4GOINlw+YdDI721gz8/HwMAgJ8DI4OVmAxZHB4z1rcrsbl8n///v338I/5DwxzuNipMxf+u/vFgOWIBVhdfvb8ZTBtbKgLFzMx0gPTyBFLCGA1fOWazQzhwb4oSQ/EDg/xBcptItpwjGABRSAoItEjDwTevf+ANWJxAYxMtHHLLobPX74ymNv74nQQKGITYsNIczkosrwC4lAiEh2A5IiNWJQwP3fhCsO///9QIhIdgOSYmBiJilgUw0GRhR6R6AAkFxHiR1zEInsD5F1iIuvjx0//XbwjCKrDW7ZQCgiW54PWcAB+WAzP1oO62wAAAABJRU5ErkJggg=="

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-2.ff6def8.png";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-3.304baba.png";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-4.d45bdf1.png";

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-5.23d0db7.png";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-6.a57f3f1.png";

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAuCAYAAACWPmGbAAADMElEQVRoge2YX0hTURzHv4Yv+Va9SYpCOURw9BQx2FDKBFu1XjQrKDbIXgQTUtwwghkSRNBDJSwMRPOpFUMQic2B/4r+4EOIGG5m9FT0Zm873XO3u93dP7vXuzOzu/uBsZ17z/me8z3n/M6fVRAOlAkH/nUD9pJKFiKnOy5j+/sPFlJZao5W4+3MS6aaIAxoaHbu6TujlNU0tsyalbIyW0EDt1iRE6fasbPzh0V7slRVHcTn5Vmmmky2Hmp0fTXOQiqLze5iqkcpq2lsmS2WlfefcPb8Vd3529zdWH73sRRNyYfFyUR82uGMkpNON/+tF84oX2Zp5YOiJiuYrMZ0MREWKEfrRfz89duQzpHDh7AUey3TZAaLHhOPAh2d/TqyJbkI0EafOddNUqmUrvJt7it5RpU0WVDyW89+0rS2HrPC5LhYW1PN/HhHNVnDZOv5XyiraWyZNSuWWbNimTUrltnECx93IhpBrFDJ+AhsXVNISB7HAi4MSq6haT1X4U9gUbUqWl6qaQjpzWBz3EsaOifJ5nww/V3oGkHzNAdJNJOM+p3EM74ly0Y1B+YL6CQmice/oPpas7xORMfFb3jedQ0PcBOz092oz/Ro+6N6PFv1o0U8or1zujrS8ziOUZegs1E4s/s+1oMO7sciBu1DCGuqt+W3Sw+8ZX6EnKRBoXf5kebeKfVs1O8loYTogcoIKY2MrGyWBTIgmVHy8lsk1JmbUQK3h5/IPmIqaYz1RICmxuP4EhmCLSLvEPou3OtCONv7u4cvL30YcXEzSVRP3wReXTckz/Pw3i30332alxZT2RKMcwaMV6AXYUoLxAI+bPpC8NZJc24XVY9gWGqUkolZrTgR4iMT12s6a25Mx3+SNzYMDKqXTY9qLUofswpxohUf6ed6YlbIp6aTjsncKm48ZrUwfqhILmAGrWit08q4jQ1d+QQcGM3sBurUwju9y1GF+G+ZtTG028dUsnFTRpxMTuHShSg63oQ0GkW3nXGEj93AKJ+aQ49dedtq6tPdZsPkzDbm9td8aJxO5JIio/LFRU7yK3DH5+B11OKM7sP9Rlq/S6z/oMyKZdaslJXZv7zMu+my9iouAAAAAElFTkSuQmCC"

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-7.48d48a8.png";

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAwCAYAAABKfMccAAADuklEQVRoge2bW0hTcRzHfy4f8q2HIDMQhVJEal0eBYcGJVSIvSh2ZwMvD8ZUVNy8NkPyUvTgBRZmpthDDVlBCU0X+piXIiQMNxPKsIvag5GX0/5nO9vfnevmOWdF/w8ctnPO7//b73z/v9/v/9/QqKVvK9Tm1hYQADREiACaSAfwN0HEwCBiYEQr5TjvYgF8+rwoq8+4/bEw+LBbVp84iomBhHj1cojzXvrJ7LDvKQkpEwwiBgYRA4OIgRG1uPSDUsLx6bO5sLb2S1afMTG74cXTR7L6xFFsNUFC8K0K4UJWExUhYmCoJsbE5Bu4cKVYsn3+5UJ4PTGtYERsVBFjcuot1DW2QLmxSPKYcmMx1N9oVVUQxRooToOlFVZWV+F6mTnksY1N7TD0uFeBqNioIkZNdSk9y411FXDs6GFJY1BZoWyqNZUqHF0AVcrkxHEt1NeUQ0t7B1CUtG1N250uegwaqxaqZAYCPdTAg07J9v29HQpGww1ZWjGIGBiKlcmBuFjZt8/Ip5Io9kXtX4SUCQYRA4OIgeFvoPv27olkHBHny9dlkhk4RAwMIgYGEQNDshiu+wZI1jbBiJCRswmS8wbAFXR5xKyDKieXP53wYR4XjCfY545BO1B0CDHXo6eScvupuVGL91XIGNkcsVAO36nDlE7l9Mxz+qwcFfDj6qdyTGOCMQmODxGkgX87zr20foR7eZfgFhTA88F8SPTNSNbtROiaNkEGY4YyomRYkvg5d53QrGP8zAobn7sJ7y1pnjfjUKWtBpuo91Pb4woBtLTyZwY9w+lUEsfs0Jniucc1Mw6TnrK6sAs8M8w1s6yxfsaoyqCMZI+fp6y5gYxkKK3tYB1cIA04v7WiGi+0A6SmHIJ39mpItrNt0D1biQ5s/tkLHXp88EW7zpOJ2OcY++DJ1bDc07Q1FEFZXee2cz44xciwOD0PGH4AUmFKhmHEbIA5gxX0CcGWCzv6HEYQISEQAj1DrE6Z+vT1lRmJkaV4+4+bfvBagCr+sd6siJcQS3BMoSPcMzjqVKw+vdel9AzGjs+PtycEVqHwe4ZUkAbybrrcY/AMMiEzQcxwAWYl2TGkQbNvNeMnHvSD4WUFg/DPfjPdkKXl+4MyT0rip+4BOJ/tgDNDVpGg0bLaA7aD16CZPhuGQi33spxqFHEkM8JipAT2F9tBfaIvcIoJwW5+bNwfACoMabQfvjpH+5AycVeyIrLp+n8gv2cE4RdjfWMzknFElN/rG/Rr9C6NBtB/Fnxf/hnhkCLPHxuS+A6bqxC3AAAAAElFTkSuQmCC"

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-8.aa0640a.png";

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAYAAADNAiUZAAABUElEQVRIiWP8DwQMdAZM9LaQKEtPnbnA4BuSCKapBv7jASdPn/9vYe/3f86C5WAaxKcGwGkpzEKYReh8qluKywJqWcwIthkIbF2CGV69foM1CsRERRgO71kLj+P8knqGiT2NDGYmBpTHKbE+odTHcEtJNQiUuIwsPcmylAXm4+aOiQwpiZFEBRkoiOfMX87w5etXrPLF9dMxxHobMzGDF+bT3fsO/X/67AVODJKHhYianh1O3xTVTYNjdIA1TnFZjGwhCOCzFGYxNoCRZXBZjG4hCNg4B+G1FBcAZ5nbt28zbNq0ieHLly8kpXweHh4GPz8/BlVVVZL0gRMSyEJJyXNAAzYBDSLO4i9feID6/IAYmHCKi0mylAliwBcGJ6d9RFsIAiC1ID2khg7cUlAw7dvnBHY9sQCkFqQHpJdUMCBxCi976QkGZ8th1NJRS4kBAEPjtvWavCjrAAAAAElFTkSuQmCC"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-9.b33a6a9.png";

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAYCAYAAACfpi8JAAABuUlEQVRIiWP8/uPn/7cfPjH8/PWbgZqAm5OToBpmJiYGXh5OBnY2VgYmWjiCWPD33z+Gz1++g9lMA+UIZMeAHTKgrkACJDnk8uVrDJk5ZWB6wBwCsry1YwKDs5MtmKa2Y4hyCMwR1RUFDCFBvmCa2o4h6BBkR+jqaoHFQDS1HcN499Gz/+iCMXGZDG/fvceqQVhIkGHJouk4HQkDxJQjMCAuIoDdIYQsIUYdqQ7BGjXEOgIEQPIhwb4MDU09RFuMDbBgE5w2cwHYcEKOAAGQo9es3czw7fs3rPJdk5djiJXlRmKIYQ2RrPQEsOHHT5xmePX6DU4MkoeFHC6Abik2R+B0CCxXTJw8m+Hu3ftYNYLEQfLERB/MclyOwOkQQo7B5ghQbiLGMbgARq55+uQRw/HDhxi+44hzXICTk4vB0taOQVpGDswnNddgJFaQI2RkLjD4+W1i4OH5QpRBX77wMGza5AfUy8AQEhlDtAOQAUbUgELCyWkf0Y4AAZBakB5SQxGvQ0BBvG+fE9iXxAKQWpAekF5ywaBJIziLeEoBVYr4gQBMoBb0QAJQSx7sECEBPoaBcgysOwECAE/E8225W5OKAAAAAElFTkSuQmCC"

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-10.79a4851.png";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-11.91c2cb5.png";

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jchb1-12.71d437d.png";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yshh1-2.9378d18.png";

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAABR0lEQVQ4jWP8DwQMVARM1DSMaAPzSuoZ8orriDKQhZCCR4+fMZw6fZ7hPxCC2HKyUnjVMxIKw75Jsxl+/PzJAFLGxcnBUJibit8F//GAP3/+/Ld2Cvx/6869/7du3wOzQWL4AN4wPHj4BIOMtASDqrIig6qKIoO0lDjDwSMn8ToQr4Gr121hCA3ygfNBbJAYWV5+8fL1fxNrr/9fv36Di4HYILGXr16T7uV1G7czeLg5MHBxccLFQGx3Vweg3A6cDsQay//+/WNw9YliePL0OVZNsjJSDLs2L2VgYsLiHmzOPnbizH+f4IT/QIMx5EBi3kHx/4+fPEu8l1ev2wqOAEZGRkwvAcXC8EQOwYRNKkB14datDAySkiBnEIdBakF6kAFKABgYgJxLGgbpQQKoBm7Z8v+/hATxhoHUgvQgARqH4aiBg8JAACaumRIzrLg6AAAAAElFTkSuQmCC"

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yshh1-3.8f4fe36.png";

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAACTklEQVQ4ja1US08TURT+7jzoE3GjsfJIxDTFEDAEiJpoaAxs2LkyujHq2qUuWPMPdOsCExcm/gEN0bpgY4Iaalr6oiIW2gJi6ZSpnelc773FWjrR0saTnM2Zc777ne+cMyS7vUfxn4xSCqlVkkQIulQFstwytZb/r48qA1qNp/Bwbh5vQ0twOBydAxLGzDBMxGJJhN4tYeVzFLqui3hHgJIkIbOZRSqdxu2bN2AaBsIMlLPumOHXjW8C9O6dW0xDBSvhSGcMJYmgsF9AJBLDhSE/+vt9CAQGkc1vs0c2oShye4CESMjldhGLJ3E9eA2apmPs4iiMSgXR1ThkqQ1A3pHB9Eqk0vB6PRgfGxGMhwLn0XfWh7X0Ooqlklgney2BTWHOTtOKWFwMiQE8e/5SPKCqKjJbOWQyWUxdvSKkqLB4s9kA+bbzQXxZ38DlS+P48DEsWLMwXC4nCsUCUmtp+P2D9XhjbR2Qx3kTpQMdr16/wfT0FOYePUC5/IeF26Xi6cILvF/+hJHRYfT6zsCiFhqbJ79vmZ+Wq9sDk0EvR5M4N9AHX48XVpPguyUdCcY+MNCLkx43DgoaTLNaZ1gH7Ol2w5lMAE8eg50EUGVJh4lHjN+0LNf83n1UJifxQysLMO7ggFvMrapF6ewsDx3fJyYo3dmh+b19KnDy32l9bShXcWaG/xHsrP5mwSCfVI1Zs4ZOZxdOsC5ILs9aNVuDsVvH6VPQiIKS/tOuocjh+vAraHGvh9WAZcGqVhtC9OgeMh3ZMCxbbTt2vN9wG/YLB/Qj2c+uTg4AAAAASUVORK5CYII="

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yshh1-3-1.5344850.png";

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAuCAYAAABjwOorAAADsklEQVRoge1Y/0tTURQ/Rn9CVkSZA52EoD/0g0TkUMwJYjILtGIwmDD7IWMEKi7si1NEEMF+MGEyYVj+UIoMIYbMjbQsKvAHEXG4qdE3g+oveJ373Nu7773t7W3vLdvaB97evffdc+4593y7dwUMAnIQRw5bgEwhr1i24aga4rrG67D36XOsf7zwGLxafJESD0P9Nfj6bT/WP3P6FCwuPFMj1gEYFdBXVKshzyjPnHXFnFVMVYzFw6W6q/B9/4eiuenEpFKoUuzkiULJmFpBibJaoIAEmiac/jHkrCvmrMXyWVEp5FxR7Hrk1BH0PddaBBaaK5ZKzNBHKa3xV1zxMMJYlWLElZLhzdsPYLxyU1OeSqDKFZO5ElHK3vUQxkYeacZTKTSPMRp3e/rh56/fYLbeifudXFEyBjVXg2RXjNer75mq6iZm9d1HzXgqRUaTx4Wq8zA6fB/6+kcyuUxcqDp5iG/Q5FCcal0S1z2tbtD5I1W2Ia9YtiGvWLYhr1i24f9TLDzVDi1Tu2kxTUgbHBCN78JkWztMRuS4rUBP5QAssW8DlEke8k0KwemeCNQwukWNmKFsVEhQbvfArKUoKpQZhjeoj+ds8HLmhpyUQgQ9SI/rNRtgmB0oha55F1iL+SlL93oBxoJQg+2atSAMKeVNn4i33VamOyBzZA44GZN7J/H38DRjwtO5XvSY3KuMq5Uacyzj5GWmm33zvPV0H+F3VMuvJwOJYmKhpEImX4jw4ebRbXpj/A4n449RoJKt08x2Ah5+h5VxhVNTTHLRNKHZhwyJXAdjJMy3yzp9kimE3pbMTZC2w4u0XiH9XOUE/tbDkzUH1FhcMAsH4fG4pA9uuzCevAn4NQ3CpvOicEy806m6Yjwa4kLcmNhinNVpOt4iaLkKypKsa9OWFa4r5z0Si811GmBOZrPL7Waqtwv+UC3YLCRjBcBIdhrHtkOlUNpOU32JJRou+YSnZBYhiDyFluYJWEcLpoP0XZHte2DrsgOs2LTZ3TARxMx1dhkWoBZGivlpel0VWGeCYI3S89mX2kQvlxlxc9t08KDED43zg6BvDmijmHJguh8HMM6QlGzAmMGhphUwAsZJgwd00VmRECqgE1LqMH42LdEOidXxMHTdwjQv2FBSNtAT0pQufVeMoGU2fLBe6WOtvOkk7tgLHaSWOYsULc5uSIjUPgdEsN0S5mqkBlCbPHjsYK3iksAOVbdI8PP97gDdliYEvs7FSSZsn+MrXwLy/3lkG3JWsT9Hk5R/4cnlUAAAAABJRU5ErkJggg=="

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yshh1-3-2.c7ccbdf.jpg";

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/yshh1-7.667269e.png";

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dj1-1.72693ad.png";

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dj1-2.76fe6f6.png";

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAwCAYAAAClvqwiAAAFQklEQVRoge2ZbUxbVRjH/xX8OhNwidqVDHQkmmjmjI5AxySNBJMlTSTyahkkCIVETSOCKyEbWehkktS3jYpkXYq8KmqzJUNMIzJopiZq4gcNaCEt6BJ1xH0Vguece9re23vbAvZm1+T+EgL3nHufc57/eZ7nnHsx3PxjYxs6uOtOT0Ar6EJwdCE42WoYrXmhFb/9fjOjNh+4/z5MfPh+Rm2KUUUIKsJHY8OKfc/XNe+5T0301ODoQnB0ITi6EByDGifLUos10yYZ8wG/KnYpquwalFTVfy8OqSVuFD01OP8bIe7NzVHVvmqp8V94rqoJf/51izn/yZSXtUV/q4UmIuLv27fZTxQl5xPvyTSqRcRujsTvvPcBWf1c2FtOwmAwyPq3t7cxMvoxNjY20ON8NZPTjHFHdo1Efvp5GVnZISz9EkK7vQmHHsyP9S0t/4oLHi9uERE2/9lUa7raqBFjPg+2trZw9doXeO31Mzj65BOs3XX+bXzz7XdoOlmLE88+g6ysLNXmoAkhKNRJ64kKFBc9hfaXO1nb9z/8iGGPW/Udg6KJYkmhEfHZlRm82ObAkcOPsbbHDz+KZruDtdN+NdFERNTaWpF9dzYrmG++cYbViGufB+DsfIXVjQuDlzD96RVsbW6xNFIDVYSgX5NS7Rr0uLx/fy6mJy6x60ceLkRuTg7aWhtlu0bhQwV4a+AsLvKCqRaqvHTtluj54J59+2JtVCzxO4nSPZlEEzWCOid2kJ4sxb+V7sk0mogILaCJiNACuhAcXQiOLgRHF4KjC8HRheDIhIhMOtA8uZ7QOI1miwPjkWRmvobL4saigi1XMN0U1jFut8rHTLRvn0ZE8kyq+ewe2buGqboDFvsAxotrsNLowoyob6nRikHRdWHLRQxXG4nDEwi1dMC5kxGDbpT2zMnbl9tROiRtqjjrh7NYycYUBpdDgGQ+T+NcwIGSncxBAeWTJY2AsQMY7joKYbWDOJ50EHE/Xal2Mskkox1qwGhDGL2RKi6gA/WrNZhn40ByTf8eMXUg3ye1V9jSgIIhH1mguOOJdjInhAg6SC86YhMfMbklqxRvoyIMAN1u1JoS++Q264dCgjCeIiwQ8VYahNWP9ZU7447RhekDTnsqgZhNugA8YsX3ijj/7risrfOl2r0IQQebQP5lwTm5Y6LJoABt5D5zkDuiAA3149etODWbfEQJ3MGYOODpWHwDzY0+LJGoqCifw8xs8rQQi5FMBEoSIWhxWoOtG+hlAyoTrxHTCFdX7jg/F/ut+OqYXzGKGImp2U8q7koebCQiwv1UyETH+YKkiIxUIlCUP8xE1oCyIphMRgwHKuPNsogQKj7LYZK3rGBdzoNXUTz5qkUmB5SLHrERv2cCOFZDhFhj1yVdTlTMunDKMic1T9MsSY1IJwJFUYhIMIz8Yi6AZHUEFvsdCNfRVTSi1uOHZBhyv1e2MlSwKckYIR8J9/wanCt3wXtQiCwaKd6DVUSsG4j+aycMM2xE+BGf+GmFiLCvpXU2FQoHqnUsrObBbOIO9C3AUidVuqTOjECfaF9n5wwr+6qU/twgUNDgZmKVdPnRtNrOno0KIhmLpJwpiY1MIo8IskcHyKrQVaahGygjO0biTEyVOF1G0iR4AOghuUnDMuAXJkxFGXKhVFYQySqKL5l4QgrRIjrfJaReqd2M0e50055TTA1busdSIBNi8XqYRICRTbT3SzPZsoyiqk13BuE+UzXJW1pQiQCyg9QOUmNmKB7rMz1W0cEthPpGwUZyMp8a+qc6jv7SxdGF4OhCcP4F4fZXHl3KGUkAAAAASUVORK5CYII="

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dj1-3.eef9622.png";

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dj1-4.01aec69.png";

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dj1-5.35045b0.png";

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-1.ca410f1.png";

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-2.3193f5e.png";

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-3.564c4b8.png";

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-4.d0491bd.png";

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-5.b14d98f.png";

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAbCAYAAAD28DaZAAABsklEQVRIie1VMXLCMBBc5S04RSYvEC8wNKnc0okSGneUeYBcki5tKprYLwgvYFwg/qLoZAOyLQWYeJJMxjsj5nz23e2tToJpA/wR3P02ARcDmRAGMiH0RuaQjTEvXE+B+TjD4ZYkug0ltZCKDC250Ll1cS3IyIWGNTpB1bf03qQMLm/sGV0yp+JVAWlsbsk5pDwN8M6LXAsutfqy/AUyVNDXlchN8ra/LqZOhKmBgCpXEPMqY/uSwnTWLHhOSMSqLaxsOGS4lu2qpNwVZDwDfEA2Ztjcp3iAQL4qMcsKvJeP5qmEsp/sseMPiOzgPhubO/FbLCMGxpwVLY33MjpkivkMeNVYx7UjTpGUe0zXa6QJsKfjoUogmWJEJhKsEjcDh1EGterVUhK8XcgHv2ABuevTlAs0BrmvmfEoQ9JGWG4duY/3hVFJ7iaY7CTSuB35fWU6ZOKUAs2s2EQKplOI1cJuCW1KeXHze5wZjBb40E/YsKNCwMumIMnM8wSGJVTyhih4u/Y4MzQPJmFzXuzNejzKjq9xz8juPXTj3DD6uYb0T+B//mv3gYFMCAOZEAYyIXwCweMDb3nxdREAAAAASUVORK5CYII="

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-6.a923bb5.png";

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAcCAYAAAAwTqwDAAADjUlEQVRYheWYXUhTYRjH/9vOmptrq7mYSHrRkBxqdyNmotBFBEG0AkExuogK7aKLwC4GQYghsRCkz+tA6iKICrwppJBGkGE3iUoGS1B0TJ37/rI9L22czZ19T2f+4d3OeT/g+Z3nfZ/nOUe0FRP2gcS7bcBOad+AcvQTDocxPj6OQCCw2/YkSSQSFbQufhrb2tpQV1fHrhloKBSCzWaD2WxGJBIpkZnFiSDjD14szm/j0fzJyUk0NDQkg5KUSiWMRmMJTS1e0WgUs7OzWFlZydm75E29Xo/FxcWkfk5gfkWIQJeWlqBWq6HVatl9JkkkEtjtdqyuriI1mVQ0KIk8SaA1NTVJoFVVVfD7/UlzOY7D2toau04F3RNRl+IGBUx+a21tZWeR30exRijGZADdij2VCFtILbpLdQV5lLzDb83NzZibm2OwtF35Y0ISBnVMYfRGOzhFNZTcMfQ+/Ig/4XKgZFccQiaTwWQyYX19HdXV1ez8dnZ2QqFQZIUVOKNO2L7OQ9ZkhT9wCrLl17h45ilG9bW4Z26BooxQQiIAn8/H0mCq3G53Yg4pXYQWANXAdK471v7d1raivW4LS8sueGO3Ow2aOD6xYJQtzwtFZi6X3eieeIV3yyqcNdRDXYChxYi84/F42HbNll4oOJHX5XL5tjEuY9j1O/Dry0vcf/ABLdfv4kp7PaTF2Z23yHiHw8G2Z7YXLXooNI9ybqoEQbfcdnx++wSPx+w4cc2Km5eMOFwCw/MVpQ2DwcBKOdq2FHj4Z5C87PV6WR/lUaqkaE2quPTPKIyfb17g0XsPzj8bw+WjZePISWR4MBhk3h0eHmb/1AhcKpWir6+PjZPHqY9STqq4tEfbN49vUxP49EMC7fM7+O4KIBT0ounCbfSePo5DO7x/CYA8R16jymdkZITBU7oZGBhIjBOkYHoh9lBqr0SHk+aruKX7HRuMLT5yEJGgH2q5FOLC3pwKFsERBDWqfIaGhqDT6WCxWGC1Wpk3nU4nmxcvLtKJS2v3AQ2aOrph6SgrQ94ikI2NDfT390Oj0aCnp4d5OJc3m4ov6uPiVz0UWbu6uuByubbNIeVRMFSWZmZmsLCwkHVePOdSlE6FrWhQOpNkdLp0kUkqlQrT09NJsBUNShVOuionF1FE5gcmBhp3+eDgYGksrABtbm6isbExcS+Kf8DO9j63F8X/qJYA/d+1Jz6llEJ/ActVxRNoPHtgAAAAAElFTkSuQmCC"

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-7.590a537.png";

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAATklEQVQYlWN8/fn3fwYSABMpikGA5T+S+WJ8rBgKXn36jWrDX6AGGH7+EVUSxEeWB2EmkA3I+NkHiCYQjS4HwoxPPpDmaZaff0hRzsAAAM4BOcTuJZCWAAAAAElFTkSuQmCC"

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-8.b4e9bff.png";

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAXCAYAAABdy4LVAAAB3klEQVRYhe2XMY6CQBSGfzd7j8HCE3AAooXVVpRUhCPYUREqOhsrG0JFSWVlIeEAHMBsIXOS3TcwuqCzups4upvMZyh8eUyGn/f+N4w45x8wDHh59gb+IkYUBUYUBUYUBUYUBQ8XpQwZwvInmQ1S96e592WkayQ3qQsnrk//vYwjQQjm54O8Nj5tb4DrxKhxCxtRVSCw7rzhHq+6FraCAjwQb3uNcZFgKh56PQfnSZdQkkDbeSfIETtCVQSwrqxbhi4OujYt0VYpLSREuJshCQ4I3S0FcuSKUrCjCoXOV/9LtIoi/OPYLV5WYbJaAEsqfYiqGaOgMhFttsCSfotBu11Dt4ja2ke0hxBEeMZ8y7BtgzVihyGWKUwKRl0j2+1sjeZLvEeiafqQl6xIEO88LkySg1cRbC8jf+GoInt4J1XOMyZOH02iWAjIXOcX8a5SmJgyuQ/G2FnLNNhtgMm4F5J5p8tNKUsvjzunHHbYgKYLv1Ip5RpxXeO9P15k3um6MZ3ugXZRcr8z2/2GSuBtduWBSoT+ntorA+geN210b+1b9BmtpDucyfPKYGIcKOZDdI+XWeTLDkC5bQpVhJhcTDoyyy8WBddovnrPKf8U80GowIiiwIiiwIiiwIii4BP2bcSQ5rcj/wAAAABJRU5ErkJggg=="

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-9.e9fb1cb.png";

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAXCAYAAACyCenrAAAEdklEQVRYhe2Ya2wUZRSGn29uu7SlUFq0ayi2AcUQxZpIKEQkBkUUIRIsVZuwAX60ESKohIgQESUEmhDBKDc1QAUDiHIJYr3UkIrWNjRQ0SoCDS13aum2u9vtdGd2/HZLINYf/mFQk32TLzM/vjlz5p33nPPOiKthy4lYDkn0QPm3E/ivIUlILyQJ6YVbS4hsVYquYujiH28sVLnPq6KJxGW3DC4SIlA1Da+3Z3l0BSNVo3lXCWt2VHDJ1khL0ZD8XNuuSQJ69qama7Q37OSdebP48opGRtqNOLoq3Es5noYbU0YoGk7b7+xbWcT8rU146WToMytY+0IBW5cU88E3l0nP6Itmh3liTQNvPT0I5fQG/BOXUh9XkXxm24wQDkfR0/uRojpSJRZdIR/T397MguJRZAkL2wXpaDc/pJR4zIL0PKas+JrckfupPh7lyUX5HNhUR37JAU5tz8OoeZOCHXcwsyAdQ9iYdhSRv4T922fhs2wcIRBxMcScRMlofdL4deNCjvQLyL1uZe6SQnoiyxIwT1H17VecVEeQ01bHFxs+5EjLac536ES7bXTDg2IGGPpqNZ+UDKEzYqMoN0pCiJ5zx3GuHW2EkSZLzYNbleMWz8ieSMupY+wpm8u2OnjA/xITxkwl+7ZcJo5XWbs5wOwZT+GtKmG5fPDGbX6KVtaiqBrCsaTKbLq6InQ7HtJTjQQpdqSd7OfeY/1rfoYPFERdqBl3FKKoqG0n2bu0kMWN97Ow+GHsthpaL6VSs7ecxlgKwQ6b/v36IkJnGTi3ij0LRpKm23QH/yBo3M4grYm9+w5yNDyBVbOHEL4W2jJjROSK3dyMr8MVhShKlNZAp1xDmTreIhi08UjO7Ugq+dMWUTpGZ8vuDoqmPYqndiEbDdkqrBjh0EUOr55N3eQKluVLRQSv0HS0kv05TVItJpaRzbB778bX35voLW7AFUJilkLmsHyeXTqDXR+XE8mSY9cMExJRmiu3UH0oxpnzNpd/q5AS/QVjZnz+yzlypYodn4d4ZA7omo4ndI76T3dy+tgAiEbozHyMl9+Yhy8rBSF7kBuUuNRDZAOUkyDardJ+roEffvaQ7dRy3DuKF1d/R+noWp5fZrJk3hQyDhVSdEZeIC7zY9kmfhrkJePdPVSXjkLLG820stdZ7s+5HteUAyzQZWO7lLdrhCTgKHRcvEBr37H42gdz1z2p3Dl8AGZLO8FwC9+Xr6S+8jDK48s5sW8+uwOFrNvwEPWLy3h/9Wd0NF+guauGWKMPUyoCuxszdzz+yWMZnGFgu1A2rirEyMxl0ivr8I8rJrPhOGdjHgZL9YfaRlA4KYBXlox+30xmjctBOzGc6WvnUOCDB9ev4vBHqzio55CnW7Re7ejxJJZJV8RMGDK3/Kp7PiQeXJoFXVp2RzopW3p06V+JyvOYdLIphiAmX4ehxtuDhSVtvhq1EiURt6qePiryU+ZvfUJ6OELSr7ihjkT85A+ivyL5+d8LSUJ6IUlILyQJ6QVNKCDc/efyv8KfDVnQojnv9BoAAAAASUVORK5CYII="

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xs1-10.4d6dc66.png";

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zbbl1-1.67c37d9.png";

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zbbl1-2.b150727.png";

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zbbl1-3.ff4979a.png";

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zbbl1-4.8d437d8.png";

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zbbl1-5.0197f74.png";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-1.b834aa4.png";

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-2.55ae7d6.png";

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAAAcCAYAAABGWNzNAAADQElEQVRoge2ZQW7aQBSG/1Q9hwM3aDdNpRhhp7twgyBEwqpsq3ZBlZTSqGFRtdusSooQvUGWxVS4i+x6gmJyEfc9Y8zYxggwCaR9n5R4PJ4Z25p//vfG7LgEhP+aR5t+AGHziAgEEYEgIhAgIhAgIhAgIojRb+po2Jt+ivvlcdoBXr39hF83v5fqs7/3BF8u3izVx/lewkl3COjnsHI9nNxWUB6V0KDj1WUFmaDlEO3qO6DWQVmbV5cMC6EfqTNqNvKDJQTCz1kzF2y8YdyUPDs4urs+g1PXONz3/o67f0L1wfnoq3t8eOpak2t8ftELjzOrLgHrYt99P1js8bxxX351hws231ZSO8Gdwqvpmo72Ga38hDYaOcG1X6Z2ZtPyimaB/2dxfNlB3rbg2C2/blrvuYLSJ8AOOwG7QF3nkoVG4SzmEieFVqTGRP36HMaCr7lp1iqCvRdF73jzoxsqr0q7quNbMPkWzNBQkXMWA90yU+zg6iiLIARQu/bAJKF0gpDRb5YwUrpO+8ThMNRWKzQ//Ny2KDxlceVbPoeQnzkWCwult+orb4S1ikCd8DSTP6F8aaPMBc8JKtOJikxAALWL4nRplRY7Ss4Qx+mWIgILY9QSLrCLFJR2uTk32WK22glUphPFVs4rcQiHbDfjWXQLGbZ3RCeU2lIyuNulhA4TS4+zlBOoKMmf5wQrv91m2WonULdr4Ykiq0cPDjlCo0oCoJjtxffbWeFgHNPRTBbCyk7wj3BnTrAOePIMLsQSwyx2NXKAqkOuYC+07TPIEUZVSupo9YaYJJ8+vPIb+JDoDCEkHMRZ1+TPR8nQ9YovABbEEOXivH5ZyjFYAOQQvqCSPwzNcAbP+mfVSTi4V8aTxtsvsnXP7mnV2lzuoa8deHWxnCA2ikNhJIO8pjjNZGxKPus52k2gAmNwBqcYDR/WOClVtoSqE0y3liby63rpe2C7RaDs4Y0a7buPbGXvPV7ZjYIO078OEsOsnCC2v6cVXEfYCVgQls7hgO+X8XYmfN1sTvt4TqBFv1BGeXhbxB3+YpRmgFU+G+vPn+Lzx9dpbiuskdQiEB4+8iuiICIQRAQCRAQCRAQCRAQCRAQC8Rd7b0MVYyUXBQAAAABJRU5ErkJggg=="

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-3.f240fd0.png";

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-4.4feb25d.png";

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-5.326d057.png";

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-6.a94107d.png";

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAAAWCAYAAACi7pBsAAABN0lEQVRoge2YwQ7CIAyGndlb6UGv+ryevfhecxyaYG2hLWydrl+yMKG07C8w5jDNHIJVOXoPYI+E6A6E6A6E6A40i369nz/Kml2tbg+McCMR4Pl4NQXLY4AvHLc1Ri3eJpgYLrcT10TapHvqouy4OssYJPTy04suolNCSnyVhM+T1srWRDfv6Zqlm9rzvR+u/LfW5y9jEj2Jw4mCRQXAnipxnWU8VBIlfUoTYKkX/Vg3+aYkDtVGJUl66pGOx7JKsJ3Vj5ZVzun4YaAOyh4PBzE0gnMrUuPHQnfRqWWbwEfE2p5uiUsltwQkPO9j8aPFtL2UkL5Uc7va9iO1xTZYzHx8ko+1xWY8d6zRntNrfUq2WzvSLc3IZZ2rt2SemjGlGffvDEl570HsjfiX0YEQ3YEQ3YEQ3YE33YLANTcO2ggAAAAASUVORK5CYII="

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-7.9d56071.png";

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAAAWCAYAAADQIfLaAAABO0lEQVRoge2ZAQ7CMAhFndlhvKIn8IreZloTDBKgLawdKi9Zuk0KlV+6TpftySk5lPPRA0hShBCkCAFY4WS53s1Ottvl1R/aml3tXlTKWEew4ouWIN6E4Rjgi8bdUxQuXjQ+RLDMUmrDCUmrhKscKZa3UiShI7HbMwEnq7T4oGA7SA4+xz7/AZcIPaWOk1xaOPB1r89fwSyCtkzQJAO4AmhL71nGw4na0kebEDOqca2b8GjJal3budnvGY+liqid1Y+Hae8J3JrPVcIeMXoEkCp25tZ5iAhcmRfoTqX2TLDE5cTWgAmA+1j8eDAvRxqtD2m6tdWWq1ZbakOTi8fHJVnyM5IhIkjQbWztC0qfadte7dzjZyRvEaTSk16+euES/g0vUjNY8v+E48lfUQOQIgQgRQhAihCAFCEADz1kCFQurulnAAAAAElFTkSuQmCC"

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bc1-8.9f1e4e3.png";

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lc1-1.8a2ca2e.png";

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOsAAAAeCAYAAADNVel/AAACvElEQVR4nO3awWvTUBwH8O/Ef0Ntx7ayy/oHDIz1IAMpo14mgjCpYD0oiNCVdSepMrwI9aBCRgtjYyeH9FI81AbmH7DDGF1H0/YfiXkx3dKk6WrVvj74fk5p3stLevgmv/eSGcsGIpp612RfABGNhmElUgTDSqQIhpVIEQwrkSIYViJFMKxEimBYiRRxXcpZjbeIvfw+tEuqaGBb8+1s7+PBqokXx3kkhhxrlp9i5fwJGoVl+1cXOw93MXsw/BiiaScnrELynRumIBG2L+72jy0NmUp/eyYeEvTFZ6gePEJ0XUdD3BC2YJ/jxr+7ZiKJ5IV1RImCYQdObP1ELl7C/Dcd6cgIB2p5NJwnc/d/Xh7RxMgLa2UTsUp4c6ro22HUcZi8i2xOQ+x00BH38FmUx2ElduBpPI/sqMEnmgaWDPWCtZA/Cm1uldLWRt27p2Ppa2lLN0PGWrrt6+9h7lmppYJV8+2u5UPGI5pSclaDRYnqzlfFnDRn9DeLOad3ccksv8H70yhmI/39xNw29imK6vGAxahen3oNJ8k7vsWlLlrnf/kfiCZs8mXwoDK1ouEw0NEta9v7eP2haf+OomWHM+NsezWxEneXo3oLTBdtXdSqTaSeLzs3hY9zu/i6ftNtC4afaKrJfbAfWRsDSlSndF3bs1pWr1wd3C9YLgfbF9xxLn475XfIeYmmmNSPIsxyCWevHg99/5kojLkI5DyRgez25ZPWeaUjyu92B2eLUYwzLJEsksIqPlTQnA8XLstSj46Jk7lbnnL2D4lSe7WG+yGrvc48dtyxiSSZ+Jz190cO4rWJgUakt1e8Q930zFtFe/6KMXr9fI3OnBj2fFfve2L7P65IFfXxbwZEEsyIWlj2RRDR1fghP5EiGFYiRTCsRIpgWIkUwbASKYJhJVIEw0qkCIaVSBEMK5EifgEvd9vZ4sN0DAAAAABJRU5ErkJggg=="

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lc1-2.45f653f.png";

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOsAAAAYCAYAAAAbDApiAAACt0lEQVR4nO3bvWtaURgG8Celf0ZTtSlkd3NQCoEKgkOWCK0hhQyFdNDJoWBiK3RwaocIHSwJsYV0yRAQhBbEO7i5hkCsmvontHRsz3u9fl0/EBvv9cDzm4znXr13eHzfc+7J2q/ff/6CiFbePbcvgIjmw7ASaYJhJdIEw0qkCYaVSBP3Hf9GIwd/6vvMQ6K5Mt4EbW/efsXzWAsvaymEZpzbLh5gu7mLejqg/urg9MUX+E5mn0OkA+fDKiIZK0zjJGyfrNfVbBjJ0uh4MjAl6Jv7uDjZgSeeR11+ELJQ37F+d9dM5DJ3wjqnULqsAievajgKnOHReR57D+c4MZhC3azMnaVeH5GT3AlrKQN/afpwNGd7wzBwGXmCxGEY/utJZ2zhvbTH01rssWq8gcS8wSdaESvdBnepeWehhcTblArXDvaGh6xwRnPWnFQqqgpt35R5bjV7gOYd3QqRU5xfDZZAWUGVOemRMTosc87hxaV28R0+XHvhs1VBCbW/4MVFbcJiVO+YagVXkaBtcamDZuN/b4LIec5W1kltaimMy7EDrbZWVcbXx5IsL5oqnMlje8oa2A4Uui97C0z9sQ4q3xqI7gfMH4WPvgI+xx9YY+PhJ1p1zoZ1pE2VRSMDW/ZHMdK6HsIMXfW0gqfnGTyOGfDJKm98cJjZLnvy06uqVGSoAKtxT7AMj1Ti7K65YPVDzXt9y7lDoqVxbVNEu3iGm1fPZj7/DKUXXAQyKzLUPHdQac1HOtJ+3/7EzaZ3qAIT6cGFsMpGhbC5cWHQlg5pt3C1sb54mKTVjklFnhx0cx676GcTucjRNri7yUEem5RR7wdJ2uHM0LxVxlMTzx98Ru8426A5J4aa7+Ztq7+jmyuiuTwrK2lnjf98TqQHbuQn0gTDSqQJhpVIEwwrkSYYViJNMKxEmvgHDbbkBYlwyD4AAAAASUVORK5CYII="

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lc1-3.c950174.png";

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAAfCAYAAAA/QknEAAADS0lEQVRoge2ZQW7aQBSGX6qew4EbtJumUoyw0124QRCCsCrbql1QJaU0alhU7ZZVoAi5N8iymAh3kV1PUAwXcd8bjD22MTUGCpPMJxEP45mxPb//N2/IgYOARFie7PoGJOshBRQcKaDgSAEFRwooOFJAwZECCo4UUHAepYDDlgpNa9d3sRmeJmn05v0X+HX/e6WBj4+ewbfrdyv1sX+U4NwYA6hXYOYGcD6tQnlSgiYeu+0qZLyWY+jVPgDU+1BWltXFQyIOQ3Va3YL8aAVx6T7resLGW8JJwIuTsyTN0vUZXTja6TH7VIw/gXrv++TGqZxeOOb8HH2/HgTHWVQXg3l97HwcJbs9Nu7rG2ecsPn/JpEDtwq9xbd4tC7RcTFtFHTgrVvGdnrLZEW9QH+zUGn3IW+ZYFsdt86vZ27k+nhYQQeS+xoqlUxoFi4j7jwvdEI1OjRur0BL+JjbYmUBj14V2fH+pxEop6VXU+G7J5wJemCo0HcSEi+ZKfahe5YFL2xiu95IR5H7Xpgdtkow4br6faJQ6O7xFYobsqcdDOlZ6LphksLuXY6EJpEHaR95o6wsIC/WOsLNKbctKFOBObDqT3Jo8jywXRjbQHcU+9waGcU2SqGXI4hWjzlB7i1w7XJLLrIDdu5AHn+SKfyRA8ZgY6jKsLDWgQyFRAiLgW0xcTk0MPmAeRiMspIDebhEhTkw9dNth507kE/pg5OM4REGYKMTmzUUD9cotp5NF4XQ2RoGrXgRUztwz1nLgZuAJl6jQiSJycKhgs6r2ehGK9HWQEMnTmqYgKBrAswTJRdyXBM+xToywEMLoZsSbjlcJqhWXfFIzDGUi8v6ZXFNJfHQme7LEL9pX+BIFi4X1T2gELptZhNOKTqGQhYi0S0WlQcwVE5YXWQNjIxiY+jNQF7hHD4fGxOlRg6zVqiCNroEuxgOueYsgeK2DbwD/e2HDvlNPfQa7F5Abo+m1XFfdWZxe6uZo5oFFXT3PKCQi9bAyP4NndOAoANJTFOlEErXy7AMmM7rLb8Pc6AS/uUnzP5sIw5oN/+vRml+SlNfPoevn9+mvjFJMhIJKNlfHuV/Ix4SUkDBkQIKjhRQcKSAgiMFFBwpoOBIAQXnL2xv/1Dv6xZ5AAAAAElFTkSuQmCC"

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lc1-4.c6d320d.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lc1-5.77eeb77.png";

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAAhklEQVQokWP8DwQMZAImGOP3n78EFaOrYYIJzl66i+Hxszc4NYLkQGpQDPgPBY+evv4/dcE2MI0OcMkxEFKEz1AGdAFkxfg0ggAjttAG+W/z7tNgtq+rKYOslAj+0CYLUOJs6gQY2VH16/cfvM5DNgCkFgbgoQ1KOawszHjDB10N1qgiFgAALli84sA8MukAAAAASUVORK5CYII="

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fs1-1.e8ae3f7.png";

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAABhElEQVQ4jbWUsU7DQAyGfZeqO6wwQ4PgBahIBbwCSIDEBCxFTDwCK0wIFsTCQAd4BhBF8AIgijrDCnvV5LCvzeWc3AUh2n9KzudPts+2UCgYseSogaRKmVF9foB6egDVeQX1/aXPxMQkiHAeRL0BYmra6Sec6ff7kNxcQ/J4j2RPdYQAubQMcn0LQ+OxFaEIjE9PQHU7ZUlkgJkQgoNDBi7UlCI0wGrVTxva6G5y22ImBqUa6pSHTpWjY4yk5oiupm0pOGnfaV83FB/F1LDXg/jyHIK9fQambzojG90ZOCpQz20PFF+Z/XffIb44M2ADxDOysbtvL+abPVvaNj4wyQXM+46l+RmUGjsvO2W7FIV7li+H4qT4gJRyvsbs7tyCB4qjR5Oihe0S7DQLNTTg3WbWx+gj6lHGyU9U0rrSfZeCTdvkZdlkYxXkxrY7Un2As0yjp+UDWjYxG4Jc22Qm/0LB0dMRly2UaGUA/HWhWNKrDyeFGputPnwUsRj9cfX9U2Np/h+QkcykS2vk0gAAAABJRU5ErkJggg=="

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fs1-2.488be13.png";

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fs1-3.4d44d24.png";

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fs1-4.655cb9f.png";

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fs1-5.81a5973.png";

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAXCAYAAAC1Szf+AAACZ0lEQVRYhe2Xz0tVQRTHj9LKNrqQFlL6IqxFhD1yFWobaROG+QeUaNt8+7dQF7XWZWSk+0oKNxJIKa0Si3ARIVqkUEhIoWv1w+lw5953r8080OL5PnB5c2fGmfPjO2euNWeGdnflmFD7rw04SqrOVipVZyuVIGcnBvWB/k6R10Vtj/aJfLgfn0ufjUP72fg7TBd03lER5Oy5UyIP57Td0iiy8kPbw89E7j4W+TqmTlkf4zgE71ZF3nyK3vn9ua3zXAimBYW1WNMeCwyBLSdIQc7W16nR0NQgsrEVjdHfXIjGYXBCpOGkqgBj73SI5Fu0zW/3xbgTOHclJ3Ltj0qe3hMZea7r8lw6rf1tRV0rlBrfjwoMHrnlt+jaZmRwGmSmrVjaT7Y/ftNss9/Q9fR5YMeJgPpywnfik3l9DKR2kEOM5/al/mrZ3yDmP3ip7eV1VQVZT0od3n4WuR2YXe/MumBAlowmFyLjmIfcAclmsfRFnXw0EM+kq6bmQunfcQTS+rPwzqzLzbxmjGLlnlE2n3lfOj+ZWWQ8PhtXihU2F1MTkmVtgtI7Vo7FSvA9y8aLa+oAmTCQLQFwnU9i1ZUzjQRpk72/wV5kkKLmMz+LoMxiLHI06dh1A0Q962ya7Ld2SmVHlnvyUcbYg4DhVLIfOMvAOEELIchZuwrcd4Oom6GGnWu7PtJwzyjG37isayDfq61RMG0dW58xu+d98S5QyJSPgq4LWjUhLUtUUIv41IJmwg1KGnZVEaxkkcoitDhBWdX4MKEm8KX2/Vf6+OZvkY7zIi+W0q+kg/jvnD1Mqv/1VCpVZyuVPYuY50YGeOGPAAAAAElFTkSuQmCC"

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fs1-6.2a4f1a8.png";

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-1.fc892e8.png";

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-2.5d4bb8b.png";

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-3.c27dd75.png";

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-4.735cdc0.png";

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARQAAAAaCAYAAAB2DaO9AAADcklEQVR4nO2cvW7iQBSFT1b7HvwM1HmEkAKHgooncEkkohUFNaKmQEiW1l38BFQrYaCI8xwwC36S3TtDlDgEIjtrKXhzPgnFjD0jp+DTudcDF38EEEJIDnz77BsghPw/UCiEkNygUAghuUGhEEJyI6NQtlifGtcfu4H1MoC33H5sMiHkrMgolBjepQvvjTwq0P6x8bes5br2IHoWU10Bof94QlSEkCKRUSglEUAJNZEAdAQvIQZzrqa2CAcufixPr6C1pBFZo54cVOXX7wkhhSR7D0VVoOzfktjhAYvl0CaOjQzOBwE2zSGmzqnJEea6gV63klivvF/PILIJWf4QUli+Z5+yxcIPoLvuPqmoEX45pmzZ4WbsPiUN01Op2HImyVrmoRugZY5FHlrH2KxkLUk0bR1YSSkjrCNzCSHnTyqhrP0h+st4fyylzVRkYqQQymsjpU8oY0YipoVihGIbrRhhmpSCCKP/U5wxhr0WIhMbTXyRj2rgbjxCjxIhpNCkKnnqXUkhswCTZCmjzdOZ2AqmJami1azA67hoy6vvxwc9kS28wRa9WQN6FcE0cetOAy0pmUKRSUtdoyZJhY1ZQorNRfrv8kT40XmQVBFLqVJCb1yRdOJKqghEIhFaIpxTCSO0pY5JNbLGAJiOG7CS6QSoza4xt2OQcztZ12WDlpCCkropGw4C1O2HvYHJbCSp4go10ytZbaFuXUkYQ7QvzROeg6aqlvNPJRL0bt/MhSmjRlhL8mk9X9gQIUXod5hUCCkqqYRieiibrkkgcWIDWwVYjbCoSkrpStkicpjcinhW8evJUg4dJg7TY1lUA0wdEdJyJ4knsKWSVzXiuZfjITe7EVJAUjRl5YMtsuidOBdK0gh9iFCGuAHsPpWT2Cc7ZaDp2vJoraV8MusrFxMpg6x4HCmDbAM4RqgrkoQy/0+EkE8ihVASCUNKFp3YhKbUPpn01NNjYpSkBIrtnGOsf8f7TW1PkqgrI5EdvBUSKUYk4hyfTwg5bz6wD+UFs48kNPtHmmXU8AjPj1B33HdmlKCqB7LQ5vtB5X+5DULImZBNKOoKvebLW1PmqGSPZHWP+aEwEpjHz9PDQecad3inTCKEFIYMj41TYL+nw3KFkK9KvkIhhHxp+ANLhJDcoFAIIblBoRBCcoNCIYTkBoVCCMmNvxA0Miv3vzhwAAAAAElFTkSuQmCC"

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-5.33f8b03.png";

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQYAAAAUCAYAAABvXJMYAAADVUlEQVR4nO2cwU7iUBSGfyfzGtLb17CJhfgSrArENUvZyRTc4ZI1obKxb1Fqgq/BbbuZZBbzCDP/bRErFplIMjTmfEmlnN571cX5e/5zC2c/f/3+A0EQhBLfTv0HCIJQP0QYBEF4xwFhSLHeF9ef+4XrOMQ8Tj83WRCE/8IBYcgQXPUx17vxBvSiKv6eNcd1xqutwNgWsFw87xEcQRDqwAFhOIdS5uCpXmFeSvDiWopo3MePeP8KWrM64Bp2OWjtvBcEoVYc7jFYDSjzyuRGssIynuQVgGZwOQ6h3RuM3H2TOT5x0PUaryEjNC/nFI1IbIUg1I7vh4ekLP0pAF4bijYA1gAPQyBaZGgO25s7v+k5NGCrtzPXnAdvipY5pwjoJIOOuRYrjM51mFcOSlF4KuYKgnA6KoVhvZjAj7PinJZhRFEwyR3x0KwaIsaMGGj+NMJgGooBBhip0iI6hP/AAmGIfCwoCjDCklBElIPe7QC98nhBEGpDpZWwPVYFsyn8skVgogcUC01RaPEu37psILju887fh8/qQb1ZIcX8LkV35rA6WME0K23XQctYEYuvPNRTKA1IQagpH1iJFYWAImBlCO4mwG2D1mGKnhWic3WPJoXjYdaunBktnqFmA1YZFIJtlGKxQC4WyzHQ8s7xYxyiu7UjgiDUhb3Nx4hJq27brAQc+CbJ1QXPaQOeUqgO408TCoTZkdhpHmpe31gP6KxoWsLYk3tob1DEcxx01Qr+tVQOglA3KoXB9Bi0x+pA0TokL9EGEN/TCrTR9WgHmOR+hwKy6UVsoc3YrQBMD2JpTTFyKSzGjiRhbkECrtXEI88n8tCTINSICivBBGXS9yqHmx0KigMtQdO7YVID9qYiqCRJoTWvX7bzRuNamx4F16cg+EOnEBB3CpWLS4ZIN1iZHPcPCYJwPBXCULrjm0QuPYyklENBMLsJm+1JnOcVQF5NVLBOCithq+K9rYwYZAiAUlVBMXCr5wuCcBr+4TmGVzSFYqlD3uXNQ0rPCBYr2G51A7KA46ydpDfblfigyhAE4eR8LAzqAt3SlmWL9kGVewjxI5a7iV/CbHuOdoOuQ5siwiAIdebsqC9qyT8HITZAEL4ax30fg4iCIHxJ5ItaBEF4x1/+hSgKMjdKJgAAAABJRU5ErkJggg=="

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-6.bfd9cb6.png";

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-7.ad57ef3.png";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-8.99e86c3.png";

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAVCAYAAADSM2daAAABbUlEQVRIie2XTWqDQBiG35TeI4iVLHMEXYmBrHoCs1MwhC5cS9YuSmig7jInyEqodWWOkKVY8SjtZ5s2Rq2WaCwBH1Bkxp9nxm9ecfBO4Mq4+W+Bc+ilu6KX7orbyl7fwsjh4G5VCIXOBOt7FU9x3SMkrPZLKOc7Fmg406nQDiFtK5nDfJsekyA/g/vZzjDn2xHNcpXlUZCOHBVTJ8m1pqUgYuF3ZFVDTjrA+nkIQ+Nyp3Ew7Bli04JXepsEb/EQdxcohTJOpCOHIdbV8kXDqzDkAAszKPbFOxoMh46cM9Ixw4Mv4bEwy0cUmxYZJcppmVDpmBtAFg8JI2HCbzAdixiNl7+8mZakPScgqbJoyyLB0Dk6lyE6tLyYKjyZwc0MVrG/EiXcW61G3Tc/Oa3Y7E8XCBpDqKVHCV5pPyHBS4hVUf1xqYVqnMqgGsryZg8pUCKdihxTQtCrSqbua5dGJWtmWMKg/wnoiF66Kz4Ac5VwF11AKYgAAAAASUVORK5CYII="

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdzt1-9.6fba3cb.png";

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAUCAYAAAA+wTUXAAABZUlEQVRYhe2X222DMBiFT1AW6EOkTBC8Qh6iTGCXFSJEJ+CSEULJBEWoK1CYIOoDKxgmiJSHjNAaEolcCKkINEjwSUhgAzrHPv4Ng+1u/4OOIT1bwDPoTXeFYtPBAuOZjbiwk2M9e8F4dO9YIGxS+QNUnGkF7m4PUQThMgL9Oz3/BCVLbLL2CDqpV2iddDvesTPF3OEX3Ycoa8E/q2qYo2kf63cRU+Myk6LNXSJRb61PjjghkFsc5SIy07FjIzEt0KI7iAWd+dBU/7qPf4nBIJg0q7F2JHAbb4GCj6tZzqGeKFKiop/HXERfWwHsFXJ2rYBNVpi3vHKnSKHjg7rWUfgtFOgmQejk21igThGyCJuTwaLeoaJnlbxB0Y8ypF70J4GyEWFrpGc8m0UmDLbZWBnDao+JNT4qWONniL282ssb58R0aiRfi7IZlUQ+/Tgpi3C61dk1SayfQf9r2RF6012hk6Z/Aa3FcJy/JMWjAAAAAElFTkSuQmCC"

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAASCAYAAAAzI3woAAAA4UlEQVRIiWP8DwQMgwgwEaPo+MmzDNZOAWCa1oCRUAiBHFFY1sjw/sNHBkEBfob+rnoGS3NjsJytSzDDq9dvsOoTExVhOLxnLeku+k8AuPlG/z9x6tx/NT27/ydPn//v6hP5/9+/f4S0kQ0IOggGQA6iByAqDdETsFCimRZpiCIHkWNhcf10DLHexkw4m+5Rhmw5Nv6AJeqiumlYxQmWQzCgrm/PcPPiQRSxYZGGCIFBl+0JOsjNN4rh1JkLYDawxGZw94uhqYOGXl0GAsdOnPlv6eAPpmkNiM5l9AKDLlEDAOImg8rxR3jJAAAAAElFTkSuQmCC"

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdhj1-1.0fc645c.png";

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAATCAYAAABobNZCAAAA7UlEQVRIiWN88fr9f4YBAOIiAgxMA2ExDMAtP3vuIkNASDyYphdgBAU7yMKG5h6Gj58+MfDz8TE01JYwGBvpgxUEhSUyvHn7DqtmEWEhhnWr5pNlMSjYwZZHx2cxlBRmMuQX1zBM6mtl6OqdwrB04XQGRkZGsn1FtOUwATtnf4ZDezfSzEJ0ywc0wbEQUkCrOCfKcnIM75q8HEOsLDcSQ4wmwY5uETaLaWY5soW4LAYBmsY5PouJspySBEUIDHzZHhWXwXDh4hWwwLnzlxhAJR49wMCX7SAOyAFNrX0MddVFcItpCTDKdnqCAS/bAUGMcik67cs5AAAAAElFTkSuQmCC"

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdhj1-2.0c5f562.png";

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJUAAAAaCAYAAAC+RB5CAAABMUlEQVRoge3avUrDUByG8bfijdQQHHsJdtIKmXoFcWtB6JRZvAY7dOwVdMqQbvESHCUegleiQYn40UqQPz0n8vwg2xne4eEklA5eGgIMHfkegP+HqGCOqGCOqGCOqGCOqGCOqGAuoKhKLUZnSlb13hPVKtVpc+bjycrDzUNnx74HSLWW01R3bqzJ+e8nnasVz9fKZ8PDTMOfBHBTDXW9udfjw60uO5yOTggqdAFE1VWtJycVWfv6u1HhexJ26lFU7Y32/uTzZy2ma1W+Z+GHHkX1VTxLNXGlts73EnzX26gQrrCjcmslo1TLt9uoVvXpViqy5psqGusi8jUO+wTwk0J32+YjPWnDiq6Ub1LFXhdhlwF/0oO1sF9/6CWigjmigjmigjmigjmigjmigjmigrlXXaRC5si4R+wAAAAASUVORK5CYII="

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdhj1-3.a04d7ea.png";

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAAAWCAYAAAArWsVAAAABLElEQVRoge3asUoDQRAG4D/ic8S95zjQHHmAa2OTJaROayuena11CEmV1geQC8I9R8atBAsfQXMaFCKGQ4fMnvwfXDHswE3xs7cL13l6fnkF0R8dWQ9A/wODRCoYJFLBIJEKBolUGAepwmU/h1+EHzvWiwlONz2fT1EdcD5q6tjmtQGz8QQzSZGd7e8UCUj8LebD7mFGo18x2pG6GE3v8HB/gV6DbnfCEMXOaEdqKkAegbLIUb7XKa424cuMp6LvIg/Sx8412lb1ecmPl3DTARLTuWhXq25tyXCATCqsxHoS2tWqIFG84guSLOH79Y2uLgLW8rVUFjcoXYqeM5mM9oj8jASsrnN42RbuHHOej6LU4W8kpCG+Txu1EoNEKhgkUsEgkQoGiVQwSKTiDXZKQEVhgLPAAAAAAElFTkSuQmCC"

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdhj1-4.7a5e0bf.png";

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASsAAAAhCAYAAACBSI1mAAAFaElEQVR4nO3cX0hbVxwH8K9j68MobGPtHsY0pkRd6rp0MPriRpqx2uyPEx2MIggOC1bYArItiNo+dG4LQpHpgw0oygIiGyhtkaUpzAWWl1JoAxNRw2Ldy7aHtXTuqcp2zs29uTfx2ph4W730+4HgPSf3z/Hlx+/88kvK/hNARLTHPbHbCyAi2g4GKyKyBQYrIrIFBisisgUGKyKyhSeLOXn68o+4lZwv7UllZWhqOInXPK+Udj0RPdaKClZORznu318v6UFl4nXwwPMlXUtEVMY+KyKyA/vVrOJfocbjRU1fQgwS6JbHxtepSaS3uHSuz4vmidWcufTEafVeRLSXFbUN3C0yyJy5oo3qcTEZh085Tqjj3sxYBrKRra7TtKJmMH+uBzXG8xq+xmJ/nTpYxdipVgy4MnMyuPkHl3Mvd3cgOtUCp/bMlD4mImvYpsBe2xXBdFtF7uTKbSyJPye3uMbXHxcBRh/LQDLsiuACzsOf+lgPPuqxmfTEeQxABB/j+25jMMoEM/8pKHO+/giCYvzZxBub10tEJbNNgX1+MDcjahqKIyQ2fPNuJyq1SYcTtXnXGTMdGbx8MvsKyMzImE1px1UIXhpFe/aGCYRFFtU0NPqALKkC7aEOzDaGEY63IOQV4856DAQimGtTMz4i2rGigpXMirabGd37Zw1ra//ijz//wvr6hjL33LPPFL9C1ebMSmY0MdT6I3ogqXSgeqEHfk84u5WTASoqsyeZ+XSm4Q+kUesGqjtFsPPqd9MyLD1QCfGfMSOzKMN5puRzjWNvK4LuVlyNi2BV6Foi2hbLa1YbGxsYHhnH+HffY//+p3Hn7j1lTvry3Bf46MP3LXnOXJ9aR8oJYHUIJWXGpZ2jZVWjWDw+iebGdDZzku91IxOwtO3hYn/utm3uWgwQzyhYe1K2o1V4z6FNVOCQCxi4lhD3N99eElFxLA9W3WdDuDwbU45fPeJGZOxb5VM6+ffY60dLvm/uNlBs17rqgcG8wrhKy8KyWZUnrRThp5MtOefNBLyYyV6Tf5dV/JYS8/7yAitLoFtsAedFJjddqc/6Toj1jdwWG9U6FtqJLGBZgf2opxbNH7yD6zduWrKwfGYF9kOpmJIR6fOZYveyUz/P2SayqjZxsCIzKxFU1HlZ8zIW35UWBo/6KZ+yhcwEqWqnSZF8IZzZahrWtmhWTF9IY0WuoZh/lIhMWVZgl+9JI0PfoP3M5/j7zt2dr64A3+kODDfqhezs1tCsTlTZomRWWjuDMavSGdogsLrp3Sw3WxOIHjXLC+yHX67CpR/G8EnX2R0tzExO35SS/bTgQpcsnk8i6ApjQKlP5deIZONoDzCkF9TN2yAyNa18S2kRtLwltiAYP6kkoh15KB3sLxw8gDfrjllyLy1AyZrV1RNi65ZUX2rfk7PtHIIQgepKFYIhk2xH/USvo+hP5TJF8vnU7yWtO50Wgc/lUNejdtpnO+ULjYko357vYJdF8ovIfFoXygs4WiBTakadEdQ0ejGQs0UTQSAQU+pTxiCW37Olq899dslF8lX8FF02FOfLUeU2vl9oTET5LC+wPxJKY2csE6SS2hatVxz3Zr87KLeJUde4aZ/UtreB3uNoCvSozZ6ZqWzB/kFWfsHsQj0+ndKeUYH2qTjasycUGhNRvqJ+deFm8lcspcy/JlztcubUs2Sv1fUbtyxrXdgtSrNo9K2iCupa3xa/bkNknYfWwe45chj79j2lHDe8+zbKX3qx+NXtAUpNLNoKf59jy+8PGmUbUfsZqIisxN+zIiJbsN/vWRHRY4nBiohsgcGKiGyBwYqIbIHBiohsgcGKiGyBwYqIbIHBiohs4X9nCxzwqtP4ggAAAABJRU5ErkJggg=="

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAATCAIAAABaw9UlAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAbSSURBVGhD7Zh7UFRVGMDvue99seuC8lBA5CWIkboKRFpaiQ/QxLWspKLRJrPRyggKI0zzVUQaCTgpKampoeCAWoba2jTlqJipFRrEFKUYwr7v+3aIW4O6NNOMTdDc3+6c3XPuubt/3N9833c+0PJLB0UgKiq3FlT5VFG5pfQqFvq3AKBsU1Hxie9UKMmS3e6UJQnxZZAkSX4GPUWRsqysqKjcgA+xAABuj+eDnR/Z7Q4YnJTVHrAsZ83MiI+NFkRRWboJgOEkKnMiQhAYdBM6yvGCcg0BOIZ234tiOCIJkiro/w7fEQu6hWEYHJX5jciiCMOWpMyuh9Do9BrC3nSq9jt5cqKx4USjE0Fo05BUSySOklqaQHjv+UstscPjaBxpafwGBMSEmgiBYx0eFvqo05KMlyU1OhIHiIyIvNft5SmtTuK8nOD7H1X6IL2KRRAELKWU+Q3ICM/zUC1l2gNo1ckdKzcebTMA/7FPzUt1HC+pdWQkEQU7r9R//Pr3FYVrD16mRFdDY8tYy1gNgfxw7iQYFD9Ey3VGTN73ymyWaS187YMFi+fbtq2tPetABDY6bdG6hSnvvrQ4/OFlk0JpRnWrn+A7Fbrc7s3vb+/svC4VwoodhjG4wnLcnNkZI+KGC8Jf2U2B1ptqls+u11rvDhP9osabz+04bJ6xagr24LMHyjc/T3nY48dsieNTG45UH6472Bk+jfp2jxhvnZWamJwUi6Lcx8sW2Eatfms6mj1/xeKy0nFmdM289EsTCt9KbZ2Wf6F67wvSNbeaNvsF2HNL83BMmfwFiRMjR8anJFlSki1dY5JlQmpycpIlLHSw0WgIDhwUHTlMo6Hlm6p3nKAufrGfj0m/Kz44wCwerDmWev/D0cEa+5Hq/JozCTERcuuJjTUXwOXGT5uuTp5qnZUxdWDzntLmsMzkMLrt9LK99uV5M2l3x6FPPh8xYbw/TgX7X6k+xmdnp7vryxojraOMnKCa1R/w3W4AKBgY4B8UNCgoUHkzLJeTV2idO//T+uOr1234rb0Dxi5ld09gWSZyZ2yf7Ku12bYU7b5qPruneOnLG1tD49a+mqdrPlhyoHPOrLjwSU/bPlx/csfyyrINBU1j6vInGSiiseGUJyQ8HONFqA7A9QajQefdXXEq4Y5Yr0Cn3Rddd+Ar9Oa0rdIn6e1U6N6xa5/T4YJlliCIsbFRg4ODs7IXBYcEvVdaVL5p2/ri191ut3JDD2idcf/qrNbkVdljtHqTueSFh3QZq60jxOLcnIQXqzKjeJeT8bZ9+VJO6TkX+tjCJeF6Xm4+WlD5dXTmwjduu1j20zh4J+9qz3/6ifNCqF52JM4tyJkewckEdbZiymZtVdkczMmoMavv4yPqwARHU5rpU+6zZmbMnpX+gHUGTIWpKZaidcsxFHi8XkHg4UvZfT0oDrQ6PXm1ofDlvIdW7n708Se/rLft37bBc2/OIzEcI0o/nag60j7uzaUTIyx3B8pt1651eGhqRMIjO/PTnS6m0+ns6r1KgouMfmNLeXXVrrz0oSzLw5QLzxGUUU8C3Gz2w1F4vDSY9BRM5cYBJprwHXdV/kN8PxJYo0dFDo2Pi4kbHhMfFztkcDBMhTMz0m5LiON7UQqC4uRvp+vK931l+xFZVbJp74q5HZwrim+oPYPHDDSLtEYjt23d/U34MJ3TyQCc8jMaTSbTAD+NwDGdCBIaHtnYdAmQOCJLHpej0+6w2x1upqumwglw4fz5oaNHGZzHh4ZlNHPg6Mqs25fUBgZ0TIlK2XrarrrV1/DxPGAqhGFpa+WuktLNG8sq3nn3vZraQyRJsAzHcTB4dDWxZMRHOpIEzn/09CemjUxLu9fA/lqc98zb9R1JWbmbVmYNurR3/II3D+3a0hY20RJCcbwgSRL8qS4kWRIlkRcGJI62XD5x+GcMo/2W5C4epgVK5xRgOnClqlaYMzXECxIqtxcE4siYR3NLnhrrcA1YU1l0T6RObXH1NXz3sURRvPhDE8tyUDJogMlojIqMEARhxaqizPvTq2sOFBbk8jyn7L4eSmsAnIsRAYxQOKzkoUQySpAEjSGMAEhMcLlZlNLqCZnh/2jcA5wmJaeDAaTe0VAxr7x92/pF/iSAobFbXlKjqyt+/rOAGaWP3dnu5ggC60rEKIYDmRclHMclUe3d9zl8iwWBDwxa1f0dugVVgzOPh6EoEgqn1WpgrOm+eguBsvzc0uofFEL26ICgGHa5pckQEqHFYJBTFlX6OL2K5ROoGvSpe1SWbjUYhkGJlcmfQLdgvlSt6kf8s5q326d/zyrIzVZBYMBUrepfqIcplX8BBPkdP0EU+5pGndUAAAAASUVORK5CYII="

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdsjtb1-3.3893a89.png";

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAAAXCAYAAACChfjKAAACLklEQVRoge2ZPXLiMBiG3+zsPSQKxgfwATxuqFJRuvK4oXKTjsqjio6GisZD5ZKKiiIeDqADeFxYPsmuBJsJ/sPKko03Rk8FWAjPg/he6eOpLMtfMHw5P4a+gUfFiB8II34gjPiB+Nk7Il2C+In2hHZ0wj6gd9zSY/DU3NUIxHMHzNqhXLmtbxLxHE4edl5XpEsCP4tw2gegn3jDY6FRakT8AgYp7IZUHdzVSc7C8BKLu+YZKzXxKbaMwwv7V6k9nfSMoAhCD5xt5ayGOlXx6RGJHWHRs9iLnOvN7i4Q2QmOxnyDSrimRxmisrbTP8/PtZx1SXZAWPuV94ClmFgAk+ZX7n2l63+GENJ5TWZo6+tX4gWKTEp7fi8hNNijDGrvEDHmTo6wXEFHpTvzgE0hZ3dHG7JKbpv8LumKRrhaE3rzQ9ItA/dmUmOKJZlDKzt5jkJj2HemLvmWdMXHDlBytW8SG1FfCDwob7L7pCsa4rNCdAyVK9yRRT1a49b5SOUCWdbS1J6ibw80FnSkK67EX4KQ521FQZUVH4m30zqVXm81hQoOazLa+v63VFb8OQgzFYRXqJaBlJ7JnUrzpMpR/56qW02B1wPX2PM/HtVejTuD5/vYpgGU48t20sJO/nyaVd3FIrLh+ATVTo4nx9PLQ/GKA/cQ7um/uftvTKNXc5Z9eP6UHovq12ympmnWRiNcabA+91icekB+kLcm2dpIb6WlO2n4CswfIQNhxA/Eb1j5xoHxC0mFAAAAAElFTkSuQmCC"

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdsjtb1-4.aec47c9.png";

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAAAXCAYAAABgWeOzAAACk0lEQVRoge1YO3ajMBS9zJmlmKmyArECO81UbqcTJTTpsoNpoIQu7VSpxArsFeSkCN6L8sTHgJEE8diYJNxzdGzZ6Onp6r6P7UgCFlwVP27twHfAQvIEuA7JhxieF+NwFeOfD2aSjUQdEHsO/My4EPGfENjeY0WzzHfgOKbho21GPevFmqvJ/OJ5/Z7Kn66d45q2/6fzKSEtEBxUFLkUx09yGTFIFuX2NVwYv7cslGCRLC0LyaH2to96mzxi/T079jTzCdEhuXB2xOF6ozrg2QQXl8ekurvSBieSy7n5+Ybk/lzOl2QTFPk29RZQhziesiFtrP1yqVJwEzlahQ7tr14HhdGOzutDQ3KpinEq1jv7IXJOUkNzmaJUs4gkG4ggvdn5KNlY+Mh/dQHmkUdguoVUYNzwDiJZU+30LEWvGt4bHmp7LMJTsKrMbJCyLe7XAXbFnjno8rt+0R5NYfWgq5mzQJ/3/1ByXqluSGGaCBC8lV7qkC+UZ/Cno0rRz+FfUsmq5XOpdWNafdtB6t+ke4Ru2db5zy+IIm72R3CDobK9LJS9SYF9CNcxzM096MVhJDndDIQ5EbpvPZ/9DXFHRDxtP+5E9pwqFisSEyTJDsEviz+KMC1WCHati6D0k0vDnFLNVLiYkteJxLl+q7VDhx6n5Aoqqugi+GOA1XkuXRQz+u8ig18pVfurz4bDG16O78u0paJqQrFa8dP0hQpPU1A2GFDUKKg86iLcc1AxRFJ/fJIye/5Q6BerqYNRpSASW/xzPSDfUTcS9LdZJ5A3Iv3yLZwGnVZO5VP+G8156zyawMaBKV3kr0QwERsUrd4jXt2BWnKDwueoFmOy3b4pZpSTvy4WkifAQvIEWEieAAvJE+AduJz3Q8yyYZ8AAAAASUVORK5CYII="

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdsjtb1-5.868600a.png";

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAAAWCAYAAABJ2StvAAADJElEQVRoge1Yz0sbQRT+LP0vctAt7dJriUfB1TYtNBQvQhBSQiBeSqE9SIUEDbVEsHiw4EmFUAxIwIuUCirYLHis9CqxdOMhf0f73uyuzf6YzUZWN635QPDNzpt5+81737zNUNNo/8YAN447cQdwWzEgPiZcD/GtLWSmt3BxLYv/H5ATLyXPwOfpBBYaMkd6PlcG0o8xTJZeTEBVZH/z0Ds8eW6maniXbMyL+f57cjzOdS59OuN32zHjrvTJSAGv1ARSyjk2jRWMi0F+yTHsp09Q1/zd9OIYKuo2mnlF2OPLbTSXQ0RCxMw23+Nomf2OsaC8RN01pZ5POMYy1TY+aAq09BlSxWPaZzLERv0BB/EX1Smklr67ptQwq9ScQ6djUJc67Jlt8dKcsbPYvgIBdKDrZyitrqBFa6SQRQajKH3bQ25EMp8S4KdlDefXUCJ7ocEH0ePWMWEoTDvJB/IOa5RxinwSl/LhM4t0JuYtsCojzrv+lrJHpHGmH+CJVWEiEc7fhDtIe/+nB1DztS6Tsx1VHA98iDezqXIaxt3/BXoizCUrjxZPrAPm8U+4X32B/XwZP/xcZwKqiw9i/QGOdgvirvHYMUOq8aZ+Bnjy5Ttx7h2nF0wtPaQDmZRIlwtJ0nWD9uL15oCPVlXpRToMfqYVkDMKuJSX1864hLzt8H9B0tR/kBLvvsj8kXWaTB6XOWWiqIL8Hl2yLhfOPBpzV4q+8QXPSZrs7BRkJtlwVaAdFx8KZa95eZvV8S8huowXNrWRydHeoxBEU2XsJFDhi3WGLtrFLCpfJfEI2fBbyCuTKaXsmHFpB8nUDSCyjNc3ylCJnILB+t5bEPphzUsEkVsJiocy3gsFud02cpb/rdB4LnnRifh8/3SDkIsuc8JlfEdsJHns0w8k+6GPfqthnTa/aH2/XoPQ+vX34CzJU7slTsyI9nK9Emxd5taUyLKHG13isaTG7JyAEredE1MAdTZ10QW5oK2gqUUQbkSIvp30gaettLsegQ5dDoBMaloUgt1G5ox7ZtWECSrmyzXUl+sA0aOPNP52YUB8TBgQHxMGxMeEPxqKfkLxCYoSAAAAAElFTkSuQmCC"

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdsjtb1-6.9534360.png";

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAcCAYAAADhqahzAAACFklEQVRoge2XP3KCQBTGPzO5x9JkcgAOwGiRioqSirFJZWNHxVB5AKs0DhUllZVFGA7AARwL2ZMkj3+KSYw6ifsw2R/DDAO+Bb/9eHw7kFK+QXN17rgf4L+ghVaEFloRWmhFaKEVoYVWRD+FLhZwhINFcWmZA+GnV3mkn8ImdCWKEAe7UymbwrdC5LSFVue6s0BxYkxjZMOMvWacfjFgX7CkPsT8AVkyhlE62VrCzhKMjeZ6dW6DiZxhuC+CLzzEF93IRXQwhlrume67I13FMO0Mxs7JQE5ODj/8zhO1rG4kMavUMhF0J+Q7msnihNnRpTNXeOo4rWwp1mYCWarZdTs1joVjYTNphb4teB2druj1p63j1uczyqrJCPOLb2cGGZKzXoHfh1Focug8Lv89OXaE19Kt7SX6oIlOA7bEvpG4tBvjBHJ8ZMyeup4v3qUvOGpKNwK1NMjIrSeiPJYZAvPTINR6Lo+BHLAJna7WCAL3Z4MUW6xNGyPj8HTsiSPRkQ+21jGcJRjSx+5juthu8pOto6V4XVJKsT+NvU8m/YF/ZZiHJKTVtJEUlPYqoU62Dops07KI6qc30Dv4hd4JSYljO6cM4uLppBvrzE1BmuoiPIbWWStHTvhXhju+SAxNjo7sJbzK8vXqjr6A8BDVWbutPifyuYc1KumR0H8b/tbxT9BCK0ILrQgttCK00IrQQitCC62Id2SJ6ia8AhEEAAAAAElFTkSuQmCC"

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdsj1-4.689d3f4.png";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdjc1-1.dc6f5c0.png";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdjc1-2.a5a271e.png";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdjc1-3.c8eef45.png";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdjc1-4.729c84a.png";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdjc1-5.9d59400.png";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdys1-1.6564e57.png";

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAYAAACeXl35AAABbUlEQVRIiWP8DwQMdARM9LSMoIV5JfUMecV1VLWQBZfEo8fPGE6dPs/wHwhBbDlZKapYyIgrDvsmzWb48fMnA0iai5ODoTA3lSoWggzEAH/+/Plv7RT4/9ade/9v3b4HZoPEqAGwxuHBwycYZKQlGFSVFRlUVRQZpKXEGQ4eOUkVD2K1cPW6LQyhQT5wPogNEqMKQPfyi5ev/5tYe/3/+vUbXAzEBom9fPWa4iDFSKXrNm5n8HBzYODi4oSLgdjurg5AuR0MGSkxeD1QXD8dQ6y3MRPORkml//79Y3D1iWJ48vQ5VsNkZaQYdm1eysDEhL+8QLYU2TIwQPbusRNn/vsEJ/wHWowRFCAx76D4/8dPniUq6IrqpmEVR3Hq6nVbwQmEkZERw9UgsTASEg+Gz2DmIAcpPQDYh1u3MjBISoJ8QRwGqQXpIQuAfGhgAPIlaRikhxwAtnDLlv//JSSItwykFqSHHDAwcTisLQQAPo4/pYYpa1kAAAAASUVORK5CYII="

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdys1-2.5674efd.png";

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAdCAYAAADGgB7AAAACOUlEQVRYhWP8DwQMgxAwDbQDcAEWGOPHz18MH798Y/j/9z8DIxMjVS35+v07Xnl2NlYGIQE+Bk52NrgYPMTefvhEE0cRA37++s3wDmg/MmBClhwIRyHbjwwGbRojy2G1jV0MdQ2d1HYLCmAhrAQVPH32guHChcsM/xn/g9nSUhK0cBfpIbZ1+24GN1cHBjdnB4ZtQDatAEkO+/v3L8P2HXsZfLxcGXy93Bi2AdkgsQF32ImTZxkkJcUYFBXkGBQV5RgkJEQZTpw6N/AO27JtFzC03OB8EBskRgtAtMNev3nHcOnyNQZHexu4mJODLcOlS1cZ3rx9R3WHEZ0rt+/cy+Bgb83AyckBFwOx7e2sgXL7GGKjQvDqnzpnA4ZYdkoATvWMsNbFvcfPGbg5ObEq+vfvH0NkbAbD8xcvscpLSUowLFs0nYGJCXsEwOpKZMdhc5SSrCScTVSInQeWW6DQObhnAwMjI2q1BfJXQmoew4WLVxiMDPXwmgNyDMhx+EIKBohKY1u27Wbw8XbDcBQIgMR8ScgExDgKbC6uqAQ1Rfh4OHFGDy4AivZPX76jVMqEmj0wgByVOG0FOWr7diZguQUKFeIwSC1ID0gvpQCnw0AhVVPDwPDiBfGGgdSC9JAayiQ5DBQlLS0MwNKdeMNAakF6QHopBThzJSideHpyMjx/Tl4ao5nDQIn39bvfuKRpDgZ/CxZUPPz/N3BdTJD9yADuMFD3iZGZcUAcB+u+IQPG0Z44iWDQOgwAFh7QDxFZeVIAAAAASUVORK5CYII="

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdys1-3.1b31d0a.png";

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAOklEQVQokWP8DwQMFAAWEPH46QuyNMtKS0AMAHNkJEnS/PjJczDNRJbVSGDUgFEDBocB8LwAS9ukAgDSQQzO6AO7WgAAAABJRU5ErkJggg=="

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdys1-4.33b7ef5.png";

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAAHElEQVQYlWP8z8AARESAR1MYmIhSCAWjislWDABDtgOGOWLqSwAAAABJRU5ErkJggg=="

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdys1-5.1787c5f.png";

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdtx1-1.51a833b.png";

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAATCAYAAACDW21BAAABY0lEQVRIiWP8DwQMdARMpCg+deYCg29IIpgmG/wnEpw8ff6/hb3f/zkLloNpEJ8cQJSFMMtglqDzqWohLsPJtRSvhYQMBQWvT3ACdSwkZBnVfRiXUvBf39wNq4GUxCELrtT7+MkzhpryPIa84jqGSb1NDGYmBvCskV9SzzCxpxEuhg6K66djiPU2ZuLOFiCXaxg4/D987NT/4yfP/je38wWLkeKzorppcIwMMCyEGTplxnywRUeOnf6/cs1mcPCSGozoloEAI9hWJGBq68NgZW7MEBrkzXD46GmGRcvWMEhJijPISEsy5GQkMJga65NdyIAA2MLbt28zbNq0ieHLly8kaebh4WHw8/NjUFVVJVoPONGALJOUPAfUvAloCHGWfvnCA9TnB8TARFJcTLSFTBDNXxicnPYRbRkIgNSC9JAaKkwQzTwM+/Y5gV1NLACpBekB6SUF0D0OMVIprQFJFTA1AACMOZinTOSI8wAAAABJRU5ErkJggg=="

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdtx1-2.a8e26d4.png";

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAUCAYAAABxnDbHAAABhUlEQVRIiWN88fr9fwYqg6/fv+OVZ6K2hcQAki29cPEKQ0JKHpimi6Ugi+oauxjc3RzBNLkWE20pzMKm+jKGyLBAME2uxURZimyhgb4OWAxEk2sxQUuxWQgDIH5kRCDDhMmzqGcpPgth8stXrGcoyE2jnqULFq9k+PHzB1kOwgdY8Ek+e/aCIT8nlaG2oZOhuaEcbjgxFk6dswFDLDslAEzj9CnI4Fev3zCIioowNNaVgi0GiRHrQ5gF2PiM2IpBmMFBgV4Ma9dtZairLmZ48fIVw+Rpcxg42DkIWohcDIJ8jO4ArJZ6BUQzmBjqM/h4uzCcOnWBYc36zQziYqIMkpLiDIlxEQz6eto4LUS3FBuAW/ro4QOGA/t2M3z79g2vBnTAxcXF4ODkyiAnr0C0pfCEBLJQWvoCg5/fJgYeni9EWfjlCw/Dpk1+QL0MDHGJqUQ7FJ6QQD50ctpHtIUgAFIL0kNq6MAtBQXTvn1OYNcTC0BqQXpAekkBAxKnWFMvpWBQthwAQQXdJT9b2KoAAAAASUVORK5CYII="

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdtx1-3.3a1c316.png";

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wdtx1-4.9349161.png";

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _methods;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _ref;
    return _ref = {
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //第1步
      isShowQnIcon: true,
      //是否显示千牛图标
      isShowQnIcon2: false,
      //显示点击千牛图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowQnIcon", true), "isShowQnIcon2", false), "isShowQnIcon3", false), "isShowQnIcon4", false), "isShowQnIcon5", false), "isShowQnIcon6", false), "isShowQnIcon7", false), "isShowQnIcon8", false), "isShowQnIcon9", false), "isShowQnIcon10", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowQnIcon11", false), "isShowQnIcon12", false), "isShowQnIcon13", false), "isShowQnIcon14", false), "isShownr1_1", true), "isShownr1_2", false), "nr_input", ''), "isShownr1_3", false), "isShownr1_3_1", false), "isShownr1_4", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "nr_input2", ''), "isShownr1_5", false), "isShownr1_6", false), "isShownr1_6_1", false), "isShownr1_7", false), "isShownr1_8", false), "isShownr1_9", false), "isShownr1_10", false), "isShownr1_11", false), "isShownr1_12", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShownr1_13", false), "isShownr1_14", false), "isShownr1_15", false), "isShownr1_16", false), "isShownr1_17", false), "isShownr1_17_1", false), "isShownr1_17_2", false), "isShownr1_17_3", false), "isShownr1_18", false), "isShownr1_19", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowqh1_1", false), "isShowqh1_2", false), "isShowqh1_3", false), "isShowqh1_4", false), "qh1_input", ''), "qh1_input1", ''), "isShowqh1_5", false), "isShowpj1_1", false), "isShowpj1_2", false), "isShowpj1_3", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowpj1_4", false), "pj_input1", '293'), "pj1_input", ''), "isShowzf1_1", false), "isShowzf1_2", false), "isShowzf1_3", false), "isShowzf1_4", false), "isShowzf1_5", false), "zf1_input", ''), "isShowxg1_1", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowxg1_2", false), "xg_input1", 'Sheet1'), "isShowxg1_3", false), "isShowxj1_1", false), "isShowxj1_2", false), "isShowxj1_3", false), "isShowzb1_1", false), "isShowzb1_2", false), "isShowzb1_3", false), "isShowzb1_4", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "zb_input1", ''), "isShowzb1_5", false), "isShowxg2_1", false), "isShowxg2_2", false), "xg_input2", 'Sheet2'), "isShowxg2_3", false), "isShowzt1_1", true), "isShowzt1_2", false), "isShowzt1_3", false), "isShowzt1_4", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowzt1_5", false), "isShowjz1_1", false), "isShowjz1_2", false), "isShowjz1_3", false), "isShowkx1_1", false), "isShowkx1_2", false), "isShowkx1_3", false), "isShowkx1_4", false), "isShowkx1_5", false), "isShowta1_2", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowta1_3", false), "isShowjchb1_1", false), "isShowjchb1_2", false), "isShowjchb1_3", false), "isShowjchb1_4", false), "isShowjchb1_5", false), "isShowjchb1_6", false), "isShowjchb1_7", false), "isShowjchb1_8", false), "isShowjchb1_9", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowjchb1_10", false), "isShowjchb1_11", false), "isShowjchb1_12", false), "isShowyshh1_1", false), "isShowyshh1_2", false), "isShowyshh1_3", false), "isShowyshh1_4", false), "isShowyshh1_5", false), "isShowdj1_1", false), "isShowdj1_2", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowdj1_3", false), "isShowdj1_4", false), "isShowdj1_5", false), "isShowxs1_1", false), "isShowxs1_2", false), "isShowxs1_3", false), "isShowxs1_4", false), "isShowxs1_5", false), "isShowxs1_6", false), "isShowxs1_7", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowxs1_8", false), "isShowxs1_9", false), "isShowxs1_10", false), "isShowzbbl1_1", false), "isShowzbbl1_2", false), "isShowzbbl1_3", false), "isShowzbbl1_4", false), "isShowzbbl1_5", false), "isShowbc1_1", true), "bc_input1", '66.67%'), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowbc1_2", false), "isShowbc1_3", false), "isShowbc1_4", false), "isShowbc1_5", false), "isShowbc1_6", false), "isShowbc1_7", false), "isShowbc1_8", false), "bc_input2", ''), "isShowbc1_9", false), "isShowlc1_1", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowlc1_2", false), "isShowlc1_3", false), "isShowlc1_4", false), "isShowlc1_5", false), "isShowlc1_6", false), "isShowlc1_7", false), "isShowfs1_1", true), "isShowfs1_2", false), "isShowfs1_3", false), "isShowfs1_4", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowfs1_5", false), "isShowfs1_6", false), "isShowfs1_7", false), "isShowwdzt1_1", true), "isShowwdzt1_2", false), "isShowwdzt1_3", false), "isShowwdzt1_4", false), "isShowwdzt1_5", false), "isShowwdzt1_6", false), "isShowwdzt1_7", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowwdzt1_8", false), "isShowwdzt1_9", false), "isShowwdzt1_10", false), "isShowwdhj1_1", false), "isShowwdhj1_2", false), "isShowwdhj1_3", false), "isShowwdhj1_4", false), "isShowwdhj1_5", false), "isShowwdsj1_1", false), "isShowwdsj1_1_1", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowwdsj1_2", false), "isShowwdsj1_3", false), "isShowwdsj1_4", false), "isShowwdsj1_5", false), "isShowwdsj1_6", false), "isShowwdsj1_7", false), "isShowwdjc1_1", false), "isShowwdjc1_2", false), "isShowwdjc1_3", false), "isShowwdjc1_4", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowwdjc1_5", false), "isShowwdys1_1", false), "isShowwdys1_2", false), "isShowwdys1_3", false), "isShowwdys1_4", false), "isShowwdys1_5", false), "isShowwdtx1_1", false), "isShowwdtx1_2", false), "isShowwdtx1_3", false), "isShowwdtx1_4", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowZtsbicon", true), "isShowZtsb01", false), "isShowZtsb02", false), "isShowZtsb03", false), "isShowZtsb04", false), "isShowZtsb05", false), "isShowZtsb06", false), "isShowZtsbTip01", true), "isShowZtsbTip02", false), "isShowZtsbTip03", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowZjgnicon", true), "isShowZjgn01", false), "isShowZjgn02", false), "isShowZjgn03", false), "isShowZjgn04", false), "isShowZjgn05", false), "isShowTjgnicon", true), "isShowTjgn01", false), "isShowTjgn02", false), "isShowTjgn03", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowTjgn04", false), "isShowTjgn05", false), "isShowTjgn06", false), "isShowDdcjicon", false), "isShowDdcj01", false), "isShowDdcj02", false), "isShowDdcj03", false), "isShowDdcj04", false), "isShowDdcj05", false), "isShowDdcj06", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowDdcj07", true), "isShowDdcj08", false), "isShowDdcj09", false), "isShowDdcj10", false), "isShowDdcjTip01", true), "isShowDdcjTip02", false), "isShowDdcjTip03", false), "ddcjbz", ''), "ddcjdz", ''), "ddcjyf", ''), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowXjrwicon", true), "isShowXjrw01", false), "isShowXjrw02", false), "isShowXjrw03", false), "isShowXjrw04", false), "isShowXjrw05", false), "isShowXjrw06", false), "xjrwmt", this.getLastDaysFromToday(-1) + ' 09:00'), "xjrwsj", ''), "xjrwtxt", ''), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowTcqnicon", true), "isShowTcqn01", false), "isShowTcqn02", false), "isShowTcqn03", false), "isShowTcqn04", false), "isShowTcqn05", false), "isShowTcqn06", false), "isShowTcqn07", false), "isShowTcqn08", false), "isShowTcqn09", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "isShowTcqn10", false), "isShowTcqnTip01", true), "isShowTcqnTip02", false);
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    var step = this.$route.query.step;
    if (step == 12) {
      this.studyNext('#tab-twelve', step, 'twelve');
    }
    var _this = this;
    document.onkeydown = function (event) {
      var key = window.event.keyCode;
      console.log(key, 88877);
      if (key === 83 && event.ctrlKey) {
        event.returnValue = false; // 阻止直接保存网页
        if (_this.isShowbc1_1 == true) {
          _this.showLoginbc1_1();
        }

        // 监听ctrl+S组合键      
      }
      if (key === 67 && event.ctrlKey) {
        if (_this.isShowfs1_4 == true) {
          _this.Loginfs1_4();
        }
        if (_this.isShownr1_7 == true) {
          _this.showLoginnr1_7();
        }

        // 监听ctrl+C组合键      
      }
      if (key === 86 && event.ctrlKey) {
        if (_this.isShowfs1_5 == true) {
          _this.Loginfs1_5();
        }
        if (_this.isShownr1_9 == true) {
          _this.listenTwo_3();
        }

        // 监听ctrl+V组合键      
      }
      if (key === 13) {
        if (_this.isShowqh1_1 == true) {
          _this.showLoginnr1_20_1();
        }
        if (_this.isShowpj1_2 == true) {
          _this.Loginpj1_2_1();
        }
        if (_this.isShowzf1_2 == true) {
          _this.Loginzf1_2_1();
        }
        if (_this.isShowzb1_2 == true) {
          _this.Loginzb1_2_1();
        }
        if (_this.isShowqh1_4 == true) {
          _this.showLoginqh1_4();
        }
        if (_this.isShowpj1_3 == true) {
          _this.showLoginpj1_1();
        }
        if (_this.isShowzf1_4 == true) {
          _this.showLoginzf1_1();
        }
        if (_this.isShowzb1_4 == true) {
          _this.showLoginzb1_1();
        }
        if (_this.isShowfs1_6 == true) {
          _this.Loginfs1_6();
        }

        // 监听回车     
      }
      if (key === 65 && event.ctrlKey) {
        if (_this.isShowwdzt1_1 == true) {
          event.returnValue = false; // 阻止
          _this.Loginwdzt1_1();
        }

        // 监听ctrl+A     
      }
    };
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref2) {
        var value = _ref2.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: (_methods = {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.isShowQnIcon = true, this.isShowQnIcon2 = false, this.isShowQnIcon3 = false, this.isShowQnIcon4 = false, this.isShowQnIcon5 = false, this.isShowQnIcon6 = false, this.isShowQnIcon7 = false, this.isShowQnIcon8 = false, this.isShowQnIcon9 = false, this.isShowQnIcon10 = false, this.isShowQnIcon11 = false, this.isShowQnIcon12 = false, this.isShowQnIcon13 = false, this.isShowQnIcon14 = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.isShownr1_1 = true,
      //是否显示J第2步第一张图片
      this.isShownr1_2 = false,
      //点击J2单元框
      this.nr_input = '',
      //J2输入框
      this.isShownr1_3 = false,
      //敲下回车键后
      this.isShownr1_3_1 = false,
      //敲下回车键后延时两秒
      this.isShownr1_4 = false,
      //点击A3
      this.nr_input2 = '',
      //A3输入框
      this.isShownr1_5 = false,
      //按下ctrl+；
      this.isShownr1_6 = false,
      //按下enter
      this.isShownr1_6_1 = false,
      //按下enter延时两秒
      this.isShownr1_7 = false,
      //点击A（下托前）
      this.isShownr1_8 = false,
      //按下ctrl+c
      this.isShownr1_9 = false,
      //按下ctrl+c延时两秒
      this.isShownr1_10 = false,
      //按下ctrl+V
      this.isShownr1_11 = false,
      //按下ctrl+V延时两秒
      this.isShownr1_12 = false,
      //点击c列
      this.isShownr1_13 = false,
      //c列鼠标点击右键
      this.isShownr1_14 = false,
      //键鼠标移入插入列
      this.isShownr1_15 = false,
      //点击右键鼠标移入插入列
      this.isShownr1_16 = false,
      //点击右键鼠标移入插入列延长两秒
      this.isShownr1_17 = false,
      //点击第六6行
      this.isShownr1_17_1 = false,
      //点击右键
      this.isShownr1_17_2 = false,
      //点击右键移入
      this.isShownr1_17_3 = false,
      //右键点击
      this.isShownr1_18 = false,
      //右键点击以后的页面
      this.isShownr1_19 = false,
      //过渡求和页面
      this.qh1_input = '',
      //求和输入框
      this.qh1_input1 = '',
      //求和输入框
      this.isShowqh1_1 = false,
      //点击I3
      this.isShowqh1_2 = false,
      //点击F3
      this.isShowqh1_3 = false,
      //点击G3
      this.isShowqh1_4 = false,
      //点击H3
      // this.qh_input1='',
      this.isShowqh1_5 = false,
      //按下enter
      // 平均
      this.isShowpj1_1 = false,
      //延时两秒（显示求和页面）
      this.isShowpj1_2 = false,
      //点击J3
      this.isShowpj1_3 = false,
      //点击I3
      this.isShowpj1_4 = false,
      //按下enter
      this.pj1_input = '',
      //I3输入框
      // 总分
      this.isShowzf1_1 = false,
      //k3平均页面显示
      this.isShowzf1_2 = false,
      //点击K3单元格
      this.isShowzf1_3 = false,
      //点击I3单元格
      this.isShowzf1_4 = false,
      //点击I3单元格
      this.isShowzf1_5 = false,
      //按下enter
      this.zf1_input = '',
      //E3输入框
      //修改第一张
      this.isShowxg1_1 = false,
      //延时两秒（显示新建页面）
      this.isShowxg1_2 = false,
      //点击下方的Sheet1
      this.xg_input1 = 'Sheet1',
      //Sheet1修改输入框
      this.isShowxg1_3 = false,
      //按下enter
      //新建
      this.isShowxj1_1 = false,
      //按下enter延时两秒显示新建页面
      this.isShowxj1_2 = false,
      //移入+号
      this.isShowxj1_3 = false,
      //点击+号
      //占比
      this.isShowzb1_1 = false,
      //占比页面显示
      this.isShowzb1_2 = false,
      //点击C3
      this.isShowzb1_3 = false,
      //点击B3
      this.isShowzb1_4 = false,
      //点击A3
      this.zb_input1 = '',
      //A3输入框
      this.isShowzb1_5 = false,
      //按下enter
      //修改第二张
      this.isShowxg2_1 = false,
      //延时两秒显示第二张修改页面
      this.isShowxg2_2 = false,
      //点击下面的Sheet2
      this.xg_input2 = 'Sheet2',
      //下面Sheet2输入框
      this.isShowxg2_3 = false; //按下enter
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowzt1_1 = true,
      //是否显示第三步第一张图片
      this.isShowzt1_2 = false,
      //鼠标移入字体样式
      this.isShowzt1_3 = false,
      //鼠标点击字体样式
      this.isShowzt1_4 = false,
      //鼠标移入微软雅黑
      this.isShowzt1_5 = false,
      //鼠标点击微软雅黑
      // 居中
      this.isShowjz1_1 = false,
      //延时两秒显示居中页面
      this.isShowjz1_2 = false,
      //鼠标移入居中
      this.isShowjz1_3 = false,
      //鼠标点击居中
      // 框线
      this.isShowkx1_1 = false,
      //延迟两秒显示框线页面
      this.isShowkx1_2 = false,
      //鼠标移入框线
      this.isShowkx1_3 = false,
      //鼠标点击框线
      this.isShowkx1_4 = false,
      //鼠标移入所有框线
      this.isShowkx1_5 = false,
      //鼠标点击所有框线
      // 调A列
      // this.isShowta1_1=false,//延迟两秒调整A页面显示
      this.isShowta1_2 = false,
      //移到A列
      this.isShowta1_3 = false,
      //点击A列
      // 加粗合并第一行
      this.isShowjchb1_1 = false,
      //延迟两秒显示加粗合并第一行页面
      this.isShowjchb1_2 = false,
      //鼠标移入大号字体
      this.isShowjchb1_3 = false,
      //鼠标点击大号字体（第一次）
      this.isShowjchb1_4 = false,
      //鼠标点击大号字体（第二次）
      this.isShowjchb1_5 = false,
      //鼠标移入字体加粗
      this.isShowjchb1_6 = false,
      //鼠标点击字体加粗
      this.isShowjchb1_7 = false,
      //鼠标移入居中合并
      this.isShowjchb1_8 = false,
      //鼠标点击居中合并
      this.isShowjchb1_9 = false,
      //鼠标移入设置颜色
      this.isShowjchb1_10 = false,
      //鼠标移入颜色
      this.isShowjchb1_11 = false,
      //鼠标点击颜色
      this.isShowjchb1_12 = false,
      //
      //颜色换行第二行
      this.isShowyshh1_1 = false,
      //延时两秒第二行颜色换行页面显示
      this.isShowyshh1_2 = false,
      //鼠标移入更换字体颜色
      this.isShowyshh1_3 = false,
      //鼠标点击更换字体颜色
      this.isShowyshh1_4 = false,
      //鼠标移入自动换行
      this.isShowyshh1_5 = false,
      //鼠标点击自动换行
      // 冻结
      this.isShowdj1_1 = false,
      //延时两秒冻结页面显示
      this.isShowdj1_2 = false,
      //鼠标移入冻结窗格
      this.isShowdj1_3 = false,
      //鼠标点击冻结窗格
      this.isShowdj1_4 = false,
      //鼠标移入冻结第二行
      this.isShowdj1_5 = false,
      //鼠标点击冻结第二行
      // isShownr1_16:false,//插入列后延迟两秒
      // 保留小数
      this.isShowxs1_1 = false,
      //延迟两秒保留小数页面显示
      this.isShowxs1_2 = false,
      //鼠标移入常规
      this.isShowxs1_3 = false,
      //点击常规下标
      this.isShowxs1_4 = false,
      //鼠标移入其他数字格式
      this.isShowxs1_5 = false,
      //鼠标点击其他数字格式
      this.isShowxs1_6 = false,
      //鼠标点击数值
      this.isShowxs1_7 = false,
      //鼠标移入输入框
      this.isShowxs1_8 = false,
      //鼠标点击减号输入框
      this.isShowxs1_9 = false,
      //鼠标移动到确定
      this.isShowxs1_10 = false,
      //鼠标点击确定
      //占比保留两位小数
      this.isShowzbbl1_1 = false,
      //延时两秒显示占比保留两位小数页面
      this.isShowzbbl1_2 = false,
      //鼠标移入常规
      this.isShowzbbl1_3 = false,
      //点击常规下标
      this.isShowzbbl1_4 = false,
      //鼠标移动到%
      this.isShowzbbl1_5 = false; //鼠标点击%
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.isShowbc1_1 = true,
      //是否显示第四步第一张图片
      this.bc_input1 = '66.67%',
      //保存第一张图的输入框（用于监听ctrl+s）
      this.isShowbc1_2 = false,
      //监听ctrl+s
      this.isShowbc1_3 = false,
      //鼠标移入我的桌面
      this.isShowbc1_4 = false,
      //鼠标点击我的桌面
      this.isShowbc1_5 = false,
      //鼠标点击办公软件培训
      this.isShowbc1_6 = false,
      //鼠标点击文件名
      this.isShowbc1_7 = false,
      //再点击一次
      this.isShowbc1_8 = false,
      //显示输入框
      this.bc_input2 = '', this.isShowbc1_9 = false,
      //点击确定
      //另存为
      this.isShowlc1_1 = false,
      //延时两秒显示另存页面
      this.isShowlc1_2 = false,
      //点击右键
      this.isShowlc1_3 = false,
      //鼠标移入另存为
      this.isShowlc1_4 = false,
      //鼠标点击另存为
      this.isShowlc1_5 = false,
      //鼠标移入我的桌面
      this.isShowlc1_6 = false,
      //鼠标点击我的桌面
      this.isShowlc1_7 = false; //鼠标点击保存
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.isShowfs1_1 = true,
      //是否显示第五步第一张图片
      this.isShowfs1_2 = false,
      //鼠标移入关闭
      this.isShowfs1_3 = false,
      //鼠标点击关闭
      this.isShowfs1_4 = false,
      //鼠标点击表格
      this.isShowfs1_5 = false,
      //键盘按下ctrl+c
      this.isShowfs1_6 = false; //键盘按下ctrl+v
    },
    //初始化第6步状态值
    initSix: function initSix() {
      // Word基础功能
      this.isShowwdzt1_1 = true,
      //是否显示第六步第一张图片
      this.isShowwdzt1_2 = false,
      //ctrl+A
      this.isShowwdzt1_3 = false,
      //鼠标移入字体下拉
      this.isShowwdzt1_4 = false,
      //鼠标点击字体下拉
      this.isShowwdzt1_5 = false,
      //鼠标移入楷体
      this.isShowwdzt1_6 = false,
      //鼠标点击楷体
      this.isShowwdzt1_7 = false,
      //鼠标移入字体大小
      this.isShowwdzt1_8 = false,
      //鼠标点击字体大小
      this.isShowwdzt1_9 = false,
      //鼠标移入小四
      this.isShowwdzt1_10 = false,
      //鼠标点击小四
      // 行距
      this.isShowwdhj1_1 = false,
      //延迟两秒显示行距页面
      this.isShowwdhj1_2 = false,
      //鼠标移入行距
      this.isShowwdhj1_3 = false,
      //鼠标点击行距
      this.isShowwdhj1_4 = false,
      //鼠标移入1.5
      this.isShowwdhj1_5 = false,
      //鼠标点击1.5
      // 首行缩进
      this.isShowwdsj1_1 = false,
      //延时两秒显示首行缩进页面
      this.isShowwdsj1_1_1 = false,
      //点击鼠标右键
      this.isShowwdsj1_2 == false,
      //鼠标移入段落
      this.isShowwdsj1_3 = false,
      //鼠标点击段落
      this.isShowwdsj1_4 = false,
      //鼠标点击特殊格式
      this.isShowwdsj1_5 = false,
      //鼠标移动到首行缩进
      this.isShowwdsj1_6 = false,
      //鼠标点击首行缩进
      this.isShowwdsj1_7 = false,
      //鼠标点击确定
      //加粗居中
      this.isShowwdjc1_1 = false,
      //延时两秒显示加粗居中页面
      this.isShowwdjc1_2 = false,
      //鼠标移到加粗
      this.isShowwdjc1_3 = false,
      //鼠标点击加粗
      this.isShowwdjc1_4 = false,
      //鼠标移到居中
      this.isShowwdjc1_5 = false,
      //鼠标点击居中
      //颜色设置为红色
      this.isShowwdys1_1 = false,
      //延时两秒显示设置颜色页面
      this.isShowwdys1_2 = false,
      //鼠标移到颜色
      this.isShowwdys1_3 = false,
      //鼠标点击颜色
      this.isShowwdys1_4 = false,
      //鼠标移到红色
      this.isShowwdys1_5 = false,
      //鼠标点击红色
      // 自然段颜色页面显示(凸显页面)
      this.isShowwdtx1_1 = false,
      //延迟两秒自然段颜色页面显示(凸显页面)显示
      this.isShowwdtx1_2 = false,
      //鼠标移到段落颜色
      this.isShowwdtx1_3 = false,
      //鼠标点击段落颜色
      this.isShowwdtx1_4 = false; //鼠标点击空白
    },
    //初始化第7步状态值
    initSeven: function initSeven() {
      this.isShowZtsbicon = true;
      this.isShowZtsb01 = false;
      this.isShowZtsb02 = false;
      this.isShowZtsb03 = false;
      this.isShowZtsb04 = false;
      this.isShowZtsb05 = false;
      this.isShowZtsb06 = false;
      this.isShowZtsbTip01 = true;
      this.isShowZtsbTip02 = false;
      this.isShowZtsbTip03 = false;
    },
    //初始化第8步状态值
    initEight: function initEight() {
      this.isShowZjgnicon = true;
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
    },
    //初始化第9步状态值
    initNine: function initNine() {
      this.isShowTjgnicon = true;
      this.isShowTjgn01 = false;
      this.isShowTjgn02 = false;
      this.isShowTjgn03 = false;
      this.isShowTjgn04 = false;
      this.isShowTjgn05 = false;
      this.isShowTjgn06 = false;
    },
    //初始化第10步状态值
    initTen: function initTen() {
      this.isShowDdcjicon = false;
      this.isShowDdcj01 = false;
      this.isShowDdcj02 = false;
      this.isShowDdcj03 = false;
      this.isShowDdcj04 = false;
      this.isShowDdcj05 = false;
      this.isShowDdcj06 = false;
      this.isShowDdcj07 = true;
      this.isShowDdcj08 = false;
      this.isShowDdcj09 = false;
      this.isShowDdcj10 = false;
      this.isShowDdcjTip01 = true;
      this.isShowDdcjTip02 = false;
      this.isShowDdcjTip03 = false;
      this.ddcjbz = '';
      this.ddcjdz = '';
      this.ddcjyf = '';
    },
    //初始化第11步状态值
    initEleven: function initEleven() {
      this.isShowXjrwicon = true;
      this.isShowXjrw01 = false;
      this.isShowXjrw02 = false;
      this.isShowXjrw03 = false;
      this.isShowXjrw04 = false;
      this.isShowXjrw05 = false;
      this.isShowXjrw06 = false;
      this.xjrwmt = this.getLastDaysFromToday(-1) + ' 09:00';
      this.xjrwsj = '';
      this.xjrwtxt = '';
    },
    //初始化第12步状态值
    initTwelve: function initTwelve() {
      this.isShowTcqnicon = true;
      this.isShowTcqn01 = false;
      this.isShowTcqn02 = false;
      this.isShowTcqn03 = false;
      this.isShowTcqn04 = false;
      this.isShowTcqn05 = false;
      this.isShowTcqn06 = false;
      this.isShowTcqn07 = false;
      this.isShowTcqn08 = false;
      this.isShowTcqn09 = false;
      this.isShowTcqn10 = false;
      this.isShowTcqnTip01 = true;
      this.isShowTcqnTip02 = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
      //第9步
      this.initNine();
      //第10步
      this.initTen();
      //第11步
      this.initEleven();
      //第12步
      this.initTwelve();
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    //第1步-单击千牛图标
    // showLoginImg() {
    // 	this.isShowQnIcon = false
    // 	this.isShowQnIcon2 = true
    // },
    // //双击千牛图标
    // showLoginImg2() {
    // 	this.isShowQnIcon2 = false
    // 	this.isShowLoginImg = true
    // },
    // //登录
    // loginIn() {
    //   if(this.name == '') {
    //     this.notify('<p>请输入账号</p>')
    //     return
    //   }else if(this.name != '淘金客服:001') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   if(this.password == '') {
    //     this.notify('<p>请输入密码</p>')
    //     return
    //   }else if(this.password != 'TJ2019') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   this.isShowLoginImg = false
    //   this.isShowRnd = true
    // },
    // //验证码登录
    // loginInRnd() {
    // 	if(this.rnd == '') {
    //     this.notify('<p>请输入短信验证码</p>')
    //     return
    //   }else if(this.rnd != '660220') {
    //     this.notify('<p>短信验证码错误</p>')
    //     return
    //   }
    //   this.isShowRnd = false
    //   this.isShowLoginIndex = true
    // },
    //第1步-单击wps图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //点击wps新建
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowQnIcon3 = true;
      // this.isShowLoginImg = true
    },
    //点击新建
    showLoginImg3: function showLoginImg3() {
      this.isShowQnIcon3 = false;
      this.isShowQnIcon4 = true;
    },
    //移动到新建表格
    showLoginImg4: function showLoginImg4() {
      this.isShowQnIcon4 = false;
      this.isShowQnIcon5 = true;
    },
    //点击新建表格
    showLoginImg5: function showLoginImg5() {
      this.isShowQnIcon5 = false, this.isShowQnIcon6 = true;
    },
    //移到空白文档
    showLoginImg6: function showLoginImg6() {
      this.isShowQnIcon6 = false, this.isShowQnIcon7 = true;
    },
    //点击空白文档
    showLoginImg7: function showLoginImg7() {
      var _this2 = this;
      this.isShowQnIcon7 = false, this.isShowQnIcon8 = true;
      setTimeout(function () {
        _this2.isShowQnIcon8 = false, _this2.isShowQnIcon9 = true;
      }, 2000);
    },
    //点击b列
    showLoginImg8: function showLoginImg8() {
      var _this3 = this;
      this.isShowQnIcon9 = false, this.isShowQnIcon10 = true;
      setTimeout(function () {
        _this3.isShowQnIcon10 = false, _this3.isShowQnIcon11 = true;
      }, 2000);
    },
    // 点击第六行
    showLoginImg9: function showLoginImg9() {
      var _this4 = this;
      var self = this;
      this.isShowQnIcon11 = false, this.isShowQnIcon12 = true;
      setTimeout(function () {
        _this4.isShowQnIcon12 = false, _this4.isShowQnIcon13 = true;
      }, 2000);
    },
    // 点击第六行第三个
    showLoginImg10: function showLoginImg10() {
      var self = this;
      this.isShowQnIcon13 = false;
      this.isShowQnIcon14 = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // //进入接待中心
    // enterJd() {
    // 	var self = this
    // 	this.isShowLoginIndex = false
    // 	this.isShowLoginIndexTwo = true
    // 	this.addRecord('END', 1)
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    //第2步-切换状态-显示未挂起图片
    //第2步-
    showLoginnr1_1: function showLoginnr1_1() {
      this.isShownr1_1 = false;
      this.isShownr1_2 = true;
      this.getFocus();
    },
    //input自动获取焦点1
    getFocus: function getFocus() {
      this.$nextTick(function () {
        var _this5 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this5.$refs.strname.focus();
        }, 100);
      });
    },
    //监听回车1
    listenOne: function listenOne(event) {
      console.log(111);
      if (event.keyCode === 13) {
        this.verification_nr1();
        event.preventDefault();
        return false;
      }
    },
    verification_nr1: function verification_nr1() {
      var _this6 = this;
      if (this.nr_input == '总分较8月上升（下降）') {
        this.isShownr1_2 = false;
        this.isShownr1_3 = true;
        console.log(22222);
        setTimeout(function () {
          _this6.isShownr1_3_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击A3
    showLoginnr1_3: function showLoginnr1_3() {
      this.isShownr1_3 = false;
      this.isShownr1_4 = true;
      this.getFocus2();
    },
    //input自动获取焦点2
    getFocus2: function getFocus2() {
      this.$nextTick(function () {
        var _this7 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this7.$refs.strname2.focus();
        }, 100);
      });
    },
    //监听回车2
    listenTwo: function listenTwo(event) {
      console.log(event, 7777);
      console.log(event.key, 555);
      if (event.key == ';' && event.ctrlKey) {
        this.isShownr1_4 = false;
        this.isShownr1_5 = true;
        this.nr_input2 = this.getNowDate();
        console.log(this.nr_input2, 11111);
        event.preventDefault();
        return false;
      }
    },
    //监听回车3
    listenTwo_1: function listenTwo_1(event) {
      var _this8 = this;
      if (event.keyCode === 13) {
        if (this.nr_input2 == '2022/9/29') {
          this.isShownr1_5 = false;
          this.isShownr1_6 = true;
          setTimeout(function () {
            _this8.isShownr1_6_1 = true;
          }, 2000);
        } else {
          this.notify('<p>请按照右边提示填写正确的内容</p>');
        }
      }

      // if(  ) {
      // 	    this.isShownr1_4=false
      // 	    this.isShownr1_5=true
      // 	    this.nr_input2=this.getNowDate()
      // 		console.log(this.nr_input2,77777)
      // 	    event.preventDefault()
      // 	    return false
      // 	    }
    },
    // 获得当前时间（并格式化）
    getNowDate: function getNowDate() {
      var timeOne = new Date();
      var year = timeOne.getFullYear();
      var month = timeOne.getMonth() + 1;
      var day = timeOne.getDate();
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      var NOW_MONTHS_AGO = "".concat(year, "/").concat(month, "/").concat(day);
      return NOW_MONTHS_AGO;
    },
    // 点击A单元格（下拖前）
    showLoginnr1_6: function showLoginnr1_6() {
      this.isShownr1_6 = false;
      this.isShownr1_6_1 = false;
      this.isShownr1_7 = true;
      // this.getFocus3()
    },
    //input自动获取焦点3
    getFocus3: function getFocus3() {
      this.$nextTick(function () {
        var _this9 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this9.$refs.strname3.focus();
        }, 100);
      });
    },
    //监听ctrl+C
    listenTwo_2: function listenTwo_2(event) {
      console.log(event, 7777);
      if (event.keyCode == 67 && event.ctrlKey) {
        this.showLoginnr1_7();
        event.preventDefault();
        return false;
      }
    },
    // 按下 ctrl C
    showLoginnr1_7: function showLoginnr1_7() {
      var _this0 = this;
      this.isShownr1_7 = false;
      this.isShownr1_8 = true;
      setTimeout(function () {
        _this0.isShownr1_8 = false;
        _this0.isShownr1_9 = true;
        // this.getFocus4()
      }, 1000);
    },
    //监听Ctrl+v 4
    // listenTwo_3(event){
    // console.log(event,77778888)
    // if( event.keyCode== 86) {
    // 	    this.isShownr1_9=false
    // 	    this.isShownr1_10=true
    //         setTimeout(()=>{
    // 			this.isShownr1_10=false
    // 			this.isShownr1_11=true
    // 		},2000)
    //         event.preventDefault()
    // 	    return false
    // 	    }
    // },
    //监听Ctrl+v 4
    listenTwo_3: function listenTwo_3() {
      var _this1 = this;
      this.isShownr1_9 = false;
      this.isShownr1_10 = true;
      setTimeout(function () {
        _this1.isShownr1_10 = false;
        _this1.isShownr1_11 = true;
      }, 2000);
    },
    //input自动获取焦点4
    getFocus4: function getFocus4() {
      this.$nextTick(function () {
        var _this10 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this10.$refs.strname4.focus();
        }, 100);
      });
    },
    //点击C列
    showLoginnr1_11: function showLoginnr1_11() {
      this.isShownr1_11 = false;
      this.isShownr1_12 = true;
    },
    //点击鼠标右键
    rightClick: function rightClick($event) {
      this.isShownr1_12 = false;
      this.isShownr1_13 = true;
    },
    //右键后鼠标移入插入列
    showLoginnr1_13: function showLoginnr1_13() {
      this.isShownr1_13 = false;
      this.isShownr1_14 = true;
    },
    //点击鼠标移入的插入列
    showLoginnr1_14: function showLoginnr1_14() {
      var _this11 = this;
      this.isShownr1_14 = false;
      this.isShownr1_15 = true;
      setTimeout(function () {
        _this11.isShownr1_15 = false;
        _this11.isShownr1_16 = true;
      }, 2000);
    },
    //点击第6列
    showLoginnr1_15: function showLoginnr1_15() {
      this.isShownr1_16 = false;
      this.isShownr1_17 = true;
    },
    //点击右键
    showLoginnr1_16: function showLoginnr1_16() {
      // this.isShownr1_17=false
      // this.isShownr1_17_1=true
      this.isShownr1_17_1 = true;
    },
    //鼠标移入
    showLoginnr1_17: function showLoginnr1_17() {
      this.isShownr1_17_1 = false;
      this.isShownr1_17_2 = true;
    },
    //点击插入行
    showLoginnr1_17_1: function showLoginnr1_17_1() {
      var _this12 = this;
      this.isShownr1_17 = false;
      this.isShownr1_17_2 = false;
      this.isShownr1_18 = true;
      //过渡求和
      setTimeout(function () {
        _this12.isShownr1_18 = false;
        _this12.isShownr1_19 = true;
      }, 2000);
    },
    // 求和
    //点击I3
    showLoginnr1_19: function showLoginnr1_19() {
      this.isShownr1_19 = false;
      this.isShowqh1_1 = true;
      this.getFocusqh_1();
    },
    //点击F3
    showLoginnr1_20: function showLoginnr1_20() {
      if (this.qh1_input == '=') {
        this.qh1_input1 = '=F3';
        this.isShowqh1_1 = false;
        this.isShowqh1_2 = true;
        this.getFocusqh_2();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //直接复制=F3+G3+H3
    showLoginnr1_20_1: function showLoginnr1_20_1() {
      var _this13 = this;
      if (this.qh1_input == '=F3+G3+H3') {
        this.isShowqh1_1 = false;
        this.isShowqh1_5 = true;
        //平均值页面
        setTimeout(function () {
          _this13.isShowqh1_5 = false;
          _this13.isShowpj1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击G3
    showLoginqh1_2: function showLoginqh1_2() {
      if (this.qh1_input1 == '=F3+') {
        this.qh1_input = '=F3+G3';
        this.isShowqh1_2 = false;
        this.isShowqh1_3 = true;
        this.getFocusqh_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击H3
    showLoginqh1_3: function showLoginqh1_3() {
      if (this.qh1_input == '=F3+G3+') {
        this.isShowqh1_3 = false;
        this.isShowqh1_4 = true;
        // this.getFocusqh_1()
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //输入框焦点聚焦
    getFocusqh_1: function getFocusqh_1() {
      this.$nextTick(function () {
        var _this14 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this14.$refs.strname_1qh.focus();
        }, 100);
      });
    },
    //输入框焦点聚焦
    getFocusqh_2: function getFocusqh_2() {
      this.$nextTick(function () {
        var _this15 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this15.$refs.strname_2qh.focus();
        }, 100);
      });
    },
    //敲下enter
    showLoginqh1_4: function showLoginqh1_4(event) {
      var _this16 = this;
      this.isShowqh1_4 = false;
      this.isShowqh1_5 = true;
      //平均值页面
      setTimeout(function () {
        _this16.isShowqh1_5 = false;
        _this16.isShowpj1_1 = true;
      }, 2000);
    },
    //点击J3
    Loginpj1_1: function Loginpj1_1() {
      this.isShowpj1_1 = false;
      this.isShowpj1_2 = true;
      this.getFocuspj_1();
    },
    //输入框焦点聚焦
    getFocuspj_1: function getFocuspj_1() {
      this.$nextTick(function () {
        var _this17 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this17.$refs.strname_pj1.focus();
        }, 100);
      });
    },
    //点击I3
    Loginpj1_2: function Loginpj1_2() {
      if (this.pj1_input == '=') {
        this.pj1_input = '=I3';
        this.isShowpj1_2 = false;
        this.isShowpj1_3 = true;
        this.getFocuspj_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }

      // this.getFocuspj_1()
    },
    //直接复制=I3/3
    Loginpj1_2_1: function Loginpj1_2_1() {
      var _this18 = this;
      if (this.pj1_input == '=I3/3') {
        this.isShowpj1_2 = false;
        this.isShowpj1_4 = true;
        setTimeout(function () {
          _this18.isShowpj1_4 = false;
          _this18.isShowzf1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //按下enter
    showLoginpj1_1: function showLoginpj1_1() {
      var _this19 = this;
      if (this.pj1_input == '=I3/3') {
        this.isShowpj1_3 = false;
        this.isShowpj1_4 = true;
        // 总分页面显示
        setTimeout(function () {
          _this19.isShowpj1_4 = false;
          _this19.isShowzf1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击K3单元格
    Loginzf1_1: function Loginzf1_1() {
      this.isShowzf1_1 = false;
      this.isShowzf1_2 = true;
      this.getFocuszf_1();
    },
    //点击I3单元格
    Loginzf1_2: function Loginzf1_2() {
      if (this.zf1_input == '=') {
        this.zf1_input = '=I3';
        this.isShowzf1_2 = false;
        this.isShowzf1_3 = true;
        this.getFocuszf_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //直接复制=I3-E3
    Loginzf1_2_1: function Loginzf1_2_1() {
      var _this20 = this;
      if (this.zf1_input == '=I3-E3') {
        this.isShowzf1_2 = false;
        this.isShowzf1_5 = true;
        setTimeout(function () {
          _this20.isShowzf1_5 = false;
          _this20.isShowxg1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //输入框焦点聚焦
    getFocuszf_1: function getFocuszf_1() {
      this.$nextTick(function () {
        var _this21 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this21.$refs.strname_zf1.focus();
        }, 100);
      });
    },
    //点击E3单元格
    Loginzf1_3: function Loginzf1_3() {
      if (this.zf1_input == '=I3-') {
        this.zf1_input = 'I3-E3';
        this.isShowzf1_3 = false;
        this.isShowzf1_4 = true;
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }

      // this.getFocuszf_1()
    },
    //按下enter
    showLoginzf1_1: function showLoginzf1_1() {
      var _this22 = this;
      this.isShowzf1_4 = false;
      this.isShowzf1_5 = true;
      // 显示修改页面
      setTimeout(function () {
        _this22.isShowzf1_5 = false;
        _this22.isShowxg1_1 = true;
      }, 2000);
    },
    //输入框焦点聚焦
    getFocusxg_1: function getFocusxg_1() {
      this.$nextTick(function () {
        var _this23 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this23.$refs.strname_xg1.focus();
        }, 100);
      });
    },
    // 点击下方的名字，进行修改
    Loginxg1_3: function Loginxg1_3() {
      this.isShowxg1_1 = false;
      this.isShowxg1_2 = true;
    },
    //修改完点击enter
    showLoginxg1_1: function showLoginxg1_1() {
      var _this24 = this;
      if (this.xg_input1 == '成绩汇总') {
        this.isShowxg1_2 = false;
        this.isShowxg1_3 = true;
        // 显示新建页面
        setTimeout(function () {
          _this24.isShowxg1_3 = false;
          _this24.isShowxj1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    // 移入+号
    Loginxj1_1: function Loginxj1_1() {
      this.isShowxj1_1 = false;
      this.isShowxj1_2 = true;
    },
    // 点击+号
    Loginxj1_2: function Loginxj1_2() {
      var _this25 = this;
      this.isShowxj1_2 = false;
      this.isShowxj1_3 = true;
      // 显示占比页面
      setTimeout(function () {
        _this25.isShowxj1_3 = false;
        _this25.isShowzb1_1 = true;
      }, 2000);
    },
    //点击C3
    Loginzb1_1: function Loginzb1_1() {
      this.isShowzb1_1 = false;
      this.isShowzb1_2 = true;
      this.getFocuszb_1();
    },
    // 点击B3
    Loginzb1_2: function Loginzb1_2() {
      if (this.zb_input1 == '=') {
        this.zb_input1 = '=B3';
        this.isShowzb1_2 = false;
        this.isShowzb1_3 = true;
        this.getFocuszb_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    // 直接复制=B3/A3
    Loginzb1_2_1: function Loginzb1_2_1() {
      var _this26 = this;
      if (this.zb_input1 == '=B3/A3') {
        this.isShowzb1_2 = false;
        this.isShowzb1_5 = true;
        setTimeout(function () {
          _this26.isShowzb1_5 = false;
          _this26.isShowxg2_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //输入框焦点聚焦
    getFocuszb_1: function getFocuszb_1() {
      this.$nextTick(function () {
        var _this27 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this27.$refs.strname_zb1.focus();
        }, 100);
      });
    },
    //点击A3
    Loginzb1_3: function Loginzb1_3() {
      if (this.zb_input1 == '=B3/') {
        this.isShowzb1_3 = false;
        this.isShowzb1_4 = true;
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }

      // this.getFocuszb_1()
    },
    //按下enter
    showLoginzb1_1: function showLoginzb1_1() {
      var _this28 = this;
      this.isShowzb1_4 = false;
      this.isShowzb1_5 = true;
      //第二张修改页面
      setTimeout(function () {
        _this28.isShowzb1_5 = false;
        _this28.isShowxg2_1 = true;
      }, 2000);
    },
    //输入框焦点聚焦
    getFocusxg_2: function getFocusxg_2() {
      this.$nextTick(function () {
        var _this29 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this29.$refs.strname_xg2.focus();
        }, 100);
      });
    },
    //点击下面的sheet2
    Loginxg2_1: function Loginxg2_1() {
      this.isShowxg2_1 = false;
      this.isShowxg2_2 = true;
      this.getFocusxg_2();
    },
    //按下enter
    showLoginxg2_1: function showLoginxg2_1() {
      if (this.xg_input2 == '数据统计') {
        var self = this;
        this.isShowxg2_2 = false;
        this.isShowxg2_3 = true;
        this.addRecord('END', 2);
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    showWgqImg: function showWgqImg() {
      var self = this;
      this.showGqImg = false;
      this.isShowWgq = true;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第3步-接待顾客
    // 第3步-Excel内容布局 
    //鼠标移入字体样式
    Loginzt1_1: function Loginzt1_1() {
      this.isShowzt1_1 = false;
      this.isShowzt1_2 = true;
    },
    //鼠标点击字体样式
    Loginzt1_2: function Loginzt1_2() {
      this.isShowzt1_2 = false;
      this.isShowzt1_3 = true;
    },
    //鼠标移入微软雅黑
    Loginzt1_3: function Loginzt1_3() {
      this.isShowzt1_3 = false;
      this.isShowzt1_4 = true;
      // this.isShowzt1_3=true
    },
    //鼠标点击微软雅黑
    Loginzt1_4: function Loginzt1_4() {
      var _this30 = this;
      this.isShowzt1_4 = false;
      this.isShowzt1_5 = true;
      // 显示居中页面
      setTimeout(function () {
        _this30.isShowzt1_5 = false;
        _this30.isShowjz1_1 = true;
      }, 2000);
    },
    //鼠标移入居中
    Loginjz1_1: function Loginjz1_1() {
      this.isShowjz1_1 = false;
      this.isShowjz1_2 = true;
    },
    //鼠标点击居中
    Loginjz1_2: function Loginjz1_2() {
      var _this31 = this;
      this.isShowjz1_2 = false;
      this.isShowjz1_3 = true;
      // 显示框线页面
      setTimeout(function () {
        _this31.isShowjz1_3 = false;
        _this31.isShowkx1_1 = true;
      }, 2000);
    },
    // 鼠标移入框线
    Loginkx1_1: function Loginkx1_1() {
      this.isShowkx1_1 = false;
      this.isShowkx1_2 = true;
    },
    //鼠标点击框线
    Loginkx1_2: function Loginkx1_2() {
      this.isShowkx1_2 = false;
      this.isShowkx1_3 = true;
    },
    //鼠标移入所有框线
    Loginkx1_3: function Loginkx1_3() {
      this.isShowkx1_3 = false;
      this.isShowkx1_4 = true;
    },
    //鼠标点击所有框线
    Loginkx1_4: function Loginkx1_4() {
      var _this32 = this;
      this.isShowkx1_4 = false;
      this.isShowkx1_5 = true;
      // 调整A页面显示
      setTimeout(function () {
        _this32.isShowkx1_5 = false;
        _this32.isShowta1_2 = true;
      }, 2000);
    },
    //点击A列
    // Loginta1_1(){
    // 	this.isShowta1_1=false
    // 	this.isShowta1_2=true
    // },
    //鼠标移入ab列间
    Loginta1_2: function Loginta1_2() {
      var _this33 = this;
      this.isShowta1_2 = false;
      this.isShowta1_3 = true;
      // 显示加粗合并第一行页面
      setTimeout(function () {
        _this33.isShowta1_3 = false;
        _this33.isShowjchb1_1 = true;
      }, 2000);
    },
    //鼠标移入字体加粗
    Loginjchb1_1: function Loginjchb1_1() {
      this.isShowjchb1_1 = false;
      this.isShowjchb1_2 = true;
    },
    //鼠标点击字体加粗（第一次）
    Loginjchb1_2: function Loginjchb1_2() {
      this.isShowjchb1_2 = false;
      this.isShowjchb1_3 = true;
    },
    //鼠标点击字体加粗（第二次）
    Loginjchb1_3: function Loginjchb1_3() {
      this.isShowjchb1_3 = false;
      this.isShowjchb1_4 = true;
    },
    //鼠标移入加粗
    Loginjchb1_4: function Loginjchb1_4() {
      this.isShowjchb1_4 = false;
      this.isShowjchb1_5 = true;
    },
    //鼠标点击加粗
    Loginjchb1_5: function Loginjchb1_5() {
      this.isShowjchb1_5 = false;
      this.isShowjchb1_6 = true;
    },
    //鼠标移入合并居中
    Loginjchb1_6: function Loginjchb1_6() {
      this.isShowjchb1_6 = false;
      this.isShowjchb1_7 = true;
    },
    //鼠标点击合并居中
    Loginjchb1_7: function Loginjchb1_7() {
      this.isShowjchb1_7 = false;
      this.isShowjchb1_8 = true;
    },
    //鼠标移入设置颜色
    Loginjchb1_8: function Loginjchb1_8() {
      this.isShowjchb1_8 = false;
      this.isShowjchb1_9 = true;
    },
    //鼠标点击设置颜色
    Loginjchb1_9: function Loginjchb1_9() {
      this.isShowjchb1_9 = false;
      this.isShowjchb1_10 = true;
    },
    //鼠标移到颜色
    Loginjchb1_10: function Loginjchb1_10() {
      this.isShowjchb1_10 = false;
      this.isShowjchb1_11 = true;
    },
    //鼠标点击颜色
    Loginjchb1_11: function Loginjchb1_11() {
      var _this34 = this;
      this.isShowjchb1_11 = false;
      this.isShowjchb1_12 = true;
      //第二行颜色换行页面显示
      setTimeout(function () {
        _this34.isShowjchb1_12 = false;
        _this34.isShowyshh1_1 = true;
      }, 2000);
    },
    //鼠标移入字体颜色的A
    Loginyshh1_1: function Loginyshh1_1() {
      this.isShowyshh1_1 = false;
      this.isShowyshh1_2 = true;
    },
    //鼠标点击字体颜色的A
    Loginyshh1_2: function Loginyshh1_2() {
      this.isShowyshh1_2 = false;
      this.isShowyshh1_3 = true;
    },
    //鼠标移到自动换行
    Loginyshh1_3: function Loginyshh1_3() {
      this.isShowyshh1_3 = false;
      this.isShowyshh1_4 = true;
    },
    //鼠标点击自动换行
    Loginyshh1_4: function Loginyshh1_4() {
      var _this35 = this;
      this.isShowyshh1_4 = false;
      this.isShowyshh1_5 = true;
      // 显示冻结页面
      setTimeout(function () {
        _this35.isShowyshh1_5 = false;
        _this35.isShowdj1_1 = true;
      }, 2000);
    },
    //鼠标移入冻结窗格
    Logindj1_1: function Logindj1_1() {
      this.isShowdj1_1 = false;
      this.isShowdj1_2 = true;
    },
    //鼠标点击冻结窗格
    Logindj1_2: function Logindj1_2() {
      this.isShowdj1_2 = false;
      this.isShowdj1_3 = true;
    },
    //鼠标移入冻结至第二行
    Logindj1_3: function Logindj1_3() {
      this.isShowdj1_3 = false;
      this.isShowdj1_4 = true;
    },
    //鼠标点击冻结至第二行
    Logindj1_4: function Logindj1_4() {
      var _this36 = this;
      this.isShowdj1_4 = false;
      this.isShowdj1_5 = true;
      // 保留小数页面显示
      setTimeout(function () {
        _this36.isShowdj1_5 = false;
        _this36.isShowxs1_1 = true;
      }, 2000);
    },
    //鼠标移入常规
    Loginxs1_1: function Loginxs1_1() {
      this.isShowxs1_1 = false;
      this.isShowxs1_2 = true;
    },
    //鼠标点击常规下箭头
    Loginxs1_2: function Loginxs1_2() {
      this.isShowxs1_2 = false;
      this.isShowxs1_3 = true;
    },
    //鼠标移入其他数字格式
    Loginxs1_3: function Loginxs1_3() {
      this.isShowxs1_3 = false;
      this.isShowxs1_4 = true;
    },
    //鼠标点击其他数字格式
    Loginxs1_4: function Loginxs1_4() {
      this.isShowxs1_4 = false;
      this.isShowxs1_5 = true;
    },
    // 点击数值
    Loginxs1_5: function Loginxs1_5() {
      this.isShowxs1_5 = false;
      this.isShowxs1_6 = true;
    },
    // 鼠标移入输入框
    Loginxs1_6: function Loginxs1_6() {
      this.isShowxs1_6 = false;
      this.isShowxs1_7 = true;
    },
    // 鼠标点击减号输入框
    Loginxs1_7: function Loginxs1_7() {
      this.isShowxs1_7 = false;
      this.isShowxs1_8 = true;
    },
    // 鼠标移动到确定
    Loginxs1_8: function Loginxs1_8() {
      this.isShowxs1_8 = false;
      this.isShowxs1_9 = true;
    },
    // 鼠标点击确定
    Loginxs1_9: function Loginxs1_9() {
      var _this37 = this;
      this.isShowxs1_9 = false;
      this.isShowxs1_10 = true;
      // 占比保留页面显示
      setTimeout(function () {
        _this37.isShowxs1_10 = false;
        _this37.isShowzbbl1_1 = true;
      }, 2000);
    },
    //鼠标移入常规
    Loginzbbl1_1: function Loginzbbl1_1() {
      this.isShowzbbl1_1 = false;
      this.isShowzbbl1_2 = true;
    },
    //鼠标点击常规
    Loginzbbl1_2: function Loginzbbl1_2() {
      this.isShowzbbl1_2 = false;
      this.isShowzbbl1_3 = true;
    },
    //鼠标移动到%
    Loginzbbl1_3: function Loginzbbl1_3() {
      this.isShowzbbl1_3 = false;
      this.isShowzbbl1_4 = true;
    },
    //鼠标移动到%
    Loginzbbl1_4: function Loginzbbl1_4() {
      this.isShowzbbl1_3 = false;
      this.isShowzbbl1_4 = true;
    }
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginzbbl1_4", function Loginzbbl1_4() {
    var self = this;
    this.isShowzbbl1_4 = false;
    this.isShowzbbl1_5 = true;
    this.addRecord('END', 3);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "showJieDaiImgOne", function showJieDaiImgOne() {
    // 	let self = this
    // 	if(this.jdnr.indexOf('您好')<0 || this.jdnr.indexOf('欢迎光临')<0 || this.jdnr.indexOf('请问有什么可以帮到您')<0) {
    //     this.notify('<p>请按照右边提示输入正确的回复内容</p>')
    //     return
    //   }
    //   this.time1 = this.formatDate(new Date());
    //   this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p>";
    //   $('.replyone').html(this.replyhtml);
    //   setTimeout(function() {
    //   	self.time2 = self.formatDate(new Date());
    //     self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p>";
    //     $('.replyone').html(self.replyhtml);
    //     self.isShowOne = false;
    // 		self.isShowTwo = true;
    //   }, 2000);
    this.jdnr = '';
  }), "showJieDaiImgTwo", function showJieDaiImgTwo() {
    // 	let self = this
    // 	if(this.jdnr.indexOf('亲亲')<0 || this.jdnr.indexOf('正常情况下大概3天左右能到哦')<0) {
    //     this.notify('<p>请按照右边提示输入正确的回复内容</p>')
    //     return
    //   }
    //   this.time3 = this.formatDate(new Date());
    //   this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p>";
    //   $('.replyone').html(this.replyhtml);
    //   setTimeout(function() {
    //   	self.time4 = self.formatDate(new Date());
    //     self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time+"</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time4+"</span></p><p><span>好的</span></p>";
    //     $('.replyone').html(self.replyhtml);
    //     self.isShowTwo = false;
    // 		self.isShowThree = true;
    //   }, 2000);
    // 	this.jdnr = ''
  }), "showJieDaiImgThree", function showJieDaiImgThree() {
    // 	let self = this
    // 	if(this.jdnr.indexOf('请问还有什么可以帮到您')<0) {
    //     this.notify('<p>请按照右边提示输入正确的回复内容</p>')
    //     return
    //   }
    //   this.time5 = this.formatDate(new Date());
    //   this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p>";
    //   $('.replyone').html(this.replyhtml);
    //   setTimeout(function() {
    //   	self.time6 = self.formatDate(new Date());
    //     self.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+self.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+self.time6+"</span></p><p><span>没有了</span></p>";
    //     $('.replyone').html(self.replyhtml);
    //     self.isShowThree = false;
    // 		self.isShowFour = true;
    //   }, 2000);
    // 	this.jdnr = ''
  }), "showJieDaiImgFour", function showJieDaiImgFour() {
    // 	let self = this
    // 	if(this.jdnr.indexOf('好的')<0 || this.jdnr.indexOf('感谢亲亲的支持')<0 || this.jdnr.indexOf('祝您生活愉快')<0) {
    //     this.notify('<p>请按照右边提示输入正确的回复内容</p>')
    //     return
    //   }
    //   this.time7 = this.formatDate(new Date());
    //   this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time1+"</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time2+"</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time3+"</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time4+"</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time5+"</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>"+this.time6+"</span></p><p><span>没有了</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>"+this.time7+"</span></p><p><span>好的，感谢亲亲的支持，祝您生活愉快</span><span class='read'>已读</span></p>";
    //   $('.replyone').html(this.replyhtml);
    // 	this.jdnr = ''
    // 	this.addRecord('END', 3)
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
  }), "getFocusbc_1", function getFocusbc_1() {
    this.$nextTick(function () {
      var _this38 = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this38.$refs.strname_bc1.focus();
      }, 100);
    });
  }), "showLoginbc1_1", function showLoginbc1_1(event) {
    this.isShowbc1_1 = false;
    this.isShowbc1_2 = true;
  }), "Loginbc1_1", function Loginbc1_1() {
    this.isShowbc1_2 = false;
    this.isShowbc1_3 = true;
  }), "Loginbc1_2", function Loginbc1_2() {
    this.isShowbc1_3 = false;
    this.isShowbc1_4 = true;
  }), "Loginbc1_3", function Loginbc1_3() {
    this.isShowbc1_4 = false;
    this.isShowbc1_5 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginbc1_4", function Loginbc1_4() {
    this.isShowbc1_5 = false;
    this.isShowbc1_6 = true;
  }), "Loginbc1_5", function Loginbc1_5() {
    this.isShowbc1_6 = false;
    this.isShowbc1_7 = true;
  }), "getFocusbc_2", function getFocusbc_2() {
    this.$nextTick(function () {
      var _this39 = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this39.$refs.strname_bc2.focus();
      }, 100);
    });
  }), "Loginbc1_6", function Loginbc1_6() {
    this.isShowbc1_7 = false;
    this.isShowbc1_8 = true;
    this.getFocusbc_2();
  }), "Loginbc1_7", function Loginbc1_7() {
    var _this40 = this;
    if (this.bc_input2 == '月考成绩统计') {
      this.isShowbc1_8 = false;
      this.isShowbc1_9 = true;
      //显示另存页面
      setTimeout(function () {
        _this40.isShowbc1_9 = false;
        _this40.isShowlc1_1 = true;
      }, 2000);
    } else {
      this.notify('<p>请填写月考成绩统计</p>');
    }
  }), "Loginlc1_1", function Loginlc1_1() {
    console.log(8899);
    this.isShowlc1_1 = false;
    this.isShowlc1_2 = true;
  }), "Loginlc1_2", function Loginlc1_2() {
    this.isShowlc1_2 = false;
    this.isShowlc1_3 = true;
  }), "Loginlc1_3", function Loginlc1_3() {
    this.isShowlc1_3 = false;
    this.isShowlc1_4 = true;
  }), "Loginlc1_4", function Loginlc1_4() {
    this.isShowlc1_4 = false;
    this.isShowlc1_5 = true;
  }), "Loginlc1_5", function Loginlc1_5() {
    this.isShowlc1_5 = false;
    this.isShowlc1_6 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginlc1_6", function Loginlc1_6() {
    var self = this;
    this.isShowlc1_6 = false;
    this.isShowlc1_7 = true;
    this.addRecord('END', 4);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "Loginfs1_1", function Loginfs1_1() {
    this.isShowfs1_1 = false;
    this.isShowfs1_2 = true;
  }), "Loginfs1_1", function Loginfs1_1() {
    this.isShowfs1_1 = false;
    this.isShowfs1_2 = true;
  }), "Loginfs1_2", function Loginfs1_2() {
    this.isShowfs1_2 = false;
    this.isShowfs1_3 = true;
  }), "Loginfs1_3", function Loginfs1_3() {
    this.isShowfs1_3 = false;
    this.isShowfs1_4 = true;
  }), "Loginfs1_4", function Loginfs1_4() {
    this.isShowfs1_4 = false;
    this.isShowfs1_5 = true;
  }), "Loginfs1_5", function Loginfs1_5() {
    this.isShowfs1_5 = false;
    this.isShowfs1_6 = true;
  }), "Loginfs1_6", function Loginfs1_6() {
    var self = this;
    this.isShowfs1_6 = false;
    this.isShowfs1_7 = true;
    this.addRecord('END', 5);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "Loginwdzt1_1", function Loginwdzt1_1() {
    this.isShowwdzt1_1 = false;
    this.isShowwdzt1_2 = true;
  }), "Loginwdzt1_2", function Loginwdzt1_2() {
    this.isShowwdzt1_2 = false;
    this.isShowwdzt1_3 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginwdzt1_3", function Loginwdzt1_3() {
    this.isShowwdzt1_3 = false;
    this.isShowwdzt1_4 = true;
  }), "Loginwdzt1_4", function Loginwdzt1_4() {
    this.isShowwdzt1_4 = false;
    this.isShowwdzt1_5 = true;
  }), "Loginwdzt1_5", function Loginwdzt1_5() {
    this.isShowwdzt1_5 = false;
    this.isShowwdzt1_6 = true;
  }), "Loginwdzt1_6", function Loginwdzt1_6() {
    this.isShowwdzt1_6 = false;
    this.isShowwdzt1_7 = true;
  }), "Loginwdzt1_7", function Loginwdzt1_7() {
    this.isShowwdzt1_7 = false;
    this.isShowwdzt1_8 = true;
  }), "Loginwdzt1_8", function Loginwdzt1_8() {
    this.isShowwdzt1_8 = false;
    this.isShowwdzt1_9 = true;
  }), "Loginwdzt1_9", function Loginwdzt1_9() {
    this.isShowwdzt1_9 = false;
    this.isShowwdzt1_10 = true;
  }), "Loginwdzt1_9", function Loginwdzt1_9() {
    var _this41 = this;
    this.isShowwdzt1_9 = false;
    this.isShowwdzt1_10 = true;
    // 显示行距页面
    setTimeout(function () {
      _this41.isShowwdzt1_10 = false;
      _this41.isShowwdhj1_1 = true;
    }, 2000);
  }), "Loginwdhj1_1", function Loginwdhj1_1() {
    this.isShowwdhj1_1 = false;
    this.isShowwdhj1_2 = true;
  }), "Loginwdhj1_2", function Loginwdhj1_2() {
    this.isShowwdhj1_2 = false;
    this.isShowwdhj1_3 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginwdhj1_3", function Loginwdhj1_3() {
    this.isShowwdhj1_3 = false;
    this.isShowwdhj1_4 = true;
  }), "Loginwdhj1_4", function Loginwdhj1_4() {
    var _this42 = this;
    this.isShowwdhj1_4 = false;
    this.isShowwdhj1_5 = true;
    // 显示首行缩进页面
    setTimeout(function () {
      _this42.isShowwdhj1_5 = false;
      _this42.isShowwdsj1_1 = true;
    }, 2000);
  }), "rightClick_sj", function rightClick_sj() {
    this.isShowwdsj1_1_1 = true;
  }), "Loginwdsj1_1", function Loginwdsj1_1() {
    this.isShowwdsj1_1 = false;
    this.isShowwdsj1_2 = true;
  }), "Loginwdsj1_2", function Loginwdsj1_2() {
    this.isShowwdsj1_2 = false;
    this.isShowwdsj1_3 = true;
  }), "Loginwdsj1_3", function Loginwdsj1_3() {
    this.isShowwdsj1_3 = false;
    this.isShowwdsj1_4 = true;
  }), "Loginwdsj1_4", function Loginwdsj1_4() {
    this.isShowwdsj1_4 = false;
    this.isShowwdsj1_5 = true;
  }), "Loginwdsj1_5", function Loginwdsj1_5() {
    this.isShowwdsj1_5 = false;
    this.isShowwdsj1_6 = true;
  }), "Loginwdsj1_6", function Loginwdsj1_6() {
    var _this43 = this;
    this.isShowwdsj1_6 = false;
    this.isShowwdsj1_7 = true;
    // 显示加粗居中页面
    setTimeout(function () {
      _this43.isShowwdsj1_7 = false;
      _this43.isShowwdjc1_1 = true;
    }, 2000);
  }), "Loginwdjc1_1", function Loginwdjc1_1() {
    this.isShowwdjc1_1 = false;
    this.isShowwdjc1_2 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginwdjc1_2", function Loginwdjc1_2() {
    this.isShowwdjc1_2 = false;
    this.isShowwdjc1_3 = true;
  }), "Loginwdjc1_3", function Loginwdjc1_3() {
    this.isShowwdjc1_3 = false;
    this.isShowwdjc1_4 = true;
  }), "Loginwdjc1_4", function Loginwdjc1_4() {
    var _this44 = this;
    this.isShowwdjc1_4 = false;
    this.isShowwdjc1_5 = true;
    // 设置颜色页面显示
    setTimeout(function () {
      _this44.isShowwdjc1_5 = false;
      _this44.isShowwdys1_1 = true;
    }, 2000);
  }), "Loginwdys1_1", function Loginwdys1_1() {
    this.isShowwdys1_1 = false;
    this.isShowwdys1_2 = true;
  }), "Loginwdys1_2", function Loginwdys1_2() {
    this.isShowwdys1_2 = false;
    this.isShowwdys1_3 = true;
  }), "Loginwdys1_3", function Loginwdys1_3() {
    this.isShowwdys1_3 = false;
    this.isShowwdys1_4 = true;
  }), "Loginwdys1_4", function Loginwdys1_4() {
    var _this45 = this;
    this.isShowwdys1_4 = false;
    this.isShowwdys1_5 = true;
    // 自然段颜色页面显示
    setTimeout(function () {
      _this45.isShowwdys1_5 = false;
      _this45.isShowwdtx1_1 = true;
    }, 2000);
  }), "Loginwdtx1_1", function Loginwdtx1_1() {
    this.isShowwdtx1_1 = false;
    this.isShowwdtx1_2 = true;
  }), "Loginwdtx1_2", function Loginwdtx1_2() {
    this.isShowwdtx1_2 = false;
    this.isShowwdtx1_4 = true;
    var self = this;
    this.addRecord('END', 6);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "showKjdy08", function showKjdy08() {
    var self = this;
    this.isShowKjdy11 = false;
    this.isShowKjdy12 = true;
    this.addRecord('END', 6);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showZtsb01", function showZtsb01() {
    this.isShowZtsbicon = false;
    this.isShowZtsb01 = true;
  }), "showZtsb02", function showZtsb02() {
    this.isShowZtsb01 = false;
    this.isShowZtsb02 = true;
    this.isShowZtsbTip01 = false;
    this.isShowZtsbTip02 = true;
  }), "showZtsb03", function showZtsb03() {
    this.isShowZtsb02 = false;
    this.isShowZtsb03 = true;
  }), "showZtsb04", function showZtsb04() {
    this.isShowZtsb03 = false;
    this.isShowZtsb04 = true;
    this.isShowZtsbTip02 = false;
    this.isShowZtsbTip03 = true;
  }), "showZtsb05", function showZtsb05() {
    this.isShowZtsb04 = false;
    this.isShowZtsb05 = true;
  }), "showZtsb06", function showZtsb06() {
    this.isShowZtsb05 = false;
    this.isShowZtsb06 = true;
    var self = this;
    this.isShowKjdy11 = false;
    this.isShowKjdy12 = true;
    this.addRecord('END', 7);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "showZjgn01", function showZjgn01() {
    this.isShowZjgnicon = false;
    this.isShowZjgn01 = true;
  }), "showZjgn02", function showZjgn02() {
    this.isShowZjgn01 = false;
    this.isShowZjgn02 = true;
    this.isShowZjgnTip01 = false;
    this.isShowZjgnTip02 = true;
  }), "showZjgn03", function showZjgn03() {
    this.isShowZjgn02 = false;
    this.isShowZjgn03 = true;
  }), "showZjgn04", function showZjgn04() {
    this.isShowZjgn03 = false;
    this.isShowZjgn04 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showZjgn05", function showZjgn05() {
    this.isShowZjgn04 = false;
    this.isShowZjgn05 = true;
    var self = this;
    this.addRecord('END', 8);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "showTjgn01", function showTjgn01() {
    this.isShowTjgnicon = false;
    this.isShowTjgn01 = true;
  }), "showTjgn02", function showTjgn02() {
    this.isShowTjgn01 = false;
    this.isShowTjgn02 = true;
  }), "showTjgn03", function showTjgn03() {
    this.isShowTjgn02 = false;
    this.isShowTjgn03 = true;
  }), "showTjgn04", function showTjgn04() {
    this.isShowTjgn03 = false;
    this.isShowTjgn04 = true;
  }), "showTjgn05", function showTjgn05() {
    this.isShowTjgn04 = false;
    this.isShowTjgn05 = true;
  }), "showTjgn06", function showTjgn06() {
    this.isShowTjgn05 = false;
    this.isShowTjgn06 = true;
    var self = this;
    this.addRecord('END', 9);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "showDdcj01", function showDdcj01() {
    this.isShowDdcjicon = false;
    this.isShowDdcj01 = true;
  }), "showDdcj02", function showDdcj02() {
    if (this.ddcjbz == '') {
      this.notify('<p>你还没有填写订单备注</p>');
      return;
    }
    if (this.ddcjbz != '顾客要求发顺丰') {
      this.notify('<p>请按照右边提示填写正确的订单备注</p>');
      return;
    }
    this.isShowDdcj01 = false;
    this.isShowDdcj02 = true;
    this.isShowDdcjTip02 = false;
    this.isShowDdcjTip03 = true;
  }), "showDdcj03", function showDdcj03() {
    this.isShowDdcj02 = false;
    this.isShowDdcj03 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showDdcj04", function showDdcj04() {
    this.isShowDdcj03 = false;
    this.isShowDdcj04 = true;
  }), "showDdcj05", function showDdcj05() {
    if (this.ddcjdz == '') {
      this.notify('<p>你还没有填写地址</p>');
      return;
    }
    if (this.ddcjdz == "双流区 大林镇" || this.ddcjdz == "双流区大林镇") {} else {
      console.log(this.ddcjdz == '双流区 大林镇');
      this.notify('<p>请按照右边提示填写正确的地址</p>');
      return;
    }
    this.isShowDdcj04 = false;
    this.isShowDdcj05 = true;
  }), "showDdcj06", function showDdcj06() {
    this.isShowDdcj05 = false;
    this.isShowDdcj06 = true;
  }), "showDdcj08", function showDdcj08() {
    this.isShowDdcj10 = false;
    this.isShowDdcj08 = true;
  }), "showDdcj09", function showDdcj09() {
    this.isShowDdcj08 = false;
    this.isShowDdcj09 = true;
  }), "showDdcj10", function showDdcj10() {
    if (this.ddcjyf == '') {
      this.notify('<p>你还没有填写邮费</p>');
      return;
    }
    if (this.ddcjyf != '10') {
      this.notify('<p>请按照右边提示填写正确的邮费</p>');
      return;
    }
    this.isShowDdcj09 = false;
    this.isShowDdcjicon = true;
    this.isShowDdcjTip01 = false;
    this.isShowDdcjTip02 = true;
  }), "showDdcj07", function showDdcj07() {
    this.isShowDdcj06 = false;
    this.isShowDdcj10 = true;
    var self = this;
    this.addRecord('END', 10);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "showXjrw01", function showXjrw01() {
    this.isShowXjrwicon = false;
    this.isShowXjrw01 = true;
  }), "showXjrw02", function showXjrw02() {
    this.isShowXjrw01 = false;
    this.isShowXjrw02 = true;
  }), "showXjrw03", function showXjrw03() {
    if (this.xjrwtxt.indexOf('此顾客有购买意向') < 0 || this.xjrwtxt.indexOf('请继续跟进') < 0) {
      this.notify('<p>请按照右边提示填写正确的任务内容</p>');
      return;
    }
    this.isShowXjrw02 = false;
    this.isShowXjrw03 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showXjrw04", function showXjrw04() {
    this.isShowXjrw03 = false;
    this.isShowXjrw04 = true;
  }), "showXjrw05", function showXjrw05() {
    this.isShowXjrw04 = false;
    this.isShowXjrw05 = true;
  }), "showXjrw06", function showXjrw06() {
    if (this.xjrwsj != this.xjrwmt) {
      this.notify('<p>请按照右边提示设置正确的时间</p>');
      return;
    }
    this.isShowXjrw05 = false;
    this.isShowXjrw06 = true;
    var self = this;
    this.addRecord('END', 11);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "showTcqn01", function showTcqn01() {
    this.isShowTcqnicon = false;
    this.isShowTcqn01 = true;
  }), "showTcqn02", function showTcqn02() {
    this.isShowTcqn01 = false;
    this.isShowTcqn02 = true;
    this.isShowTcqnTip01 = false;
    this.isShowTcqnTip02 = true;
  }), "showTcqn03", function showTcqn03() {
    this.isShowTcqn02 = false;
    this.isShowTcqn03 = true;
  }), "showTcqn04", function showTcqn04() {
    this.isShowTcqn03 = false;
    this.isShowTcqn04 = true;
  }), "showTcqn05", function showTcqn05() {
    this.isShowTcqn04 = false;
    this.isShowTcqn05 = true;
    setTimeout(function () {
      var $left = $('.tcqn05icon').closest('.con-left');
      $left.scrollTop($left[0].scrollHeight);
    }, 100);
  }), "showTcqn06", function showTcqn06() {
    this.isShowTcqn05 = false;
    this.isShowTcqn06 = true;
  }), "showTcqn07", function showTcqn07() {
    this.isShowTcqn06 = false;
    this.isShowTcqn07 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showTcqn08", function showTcqn08() {
    this.isShowTcqn07 = false;
    this.isShowTcqn08 = true;
  }), "showTcqn09", function showTcqn09() {
    this.isShowTcqn08 = false;
    this.isShowTcqn09 = true;
  }), "showTcqn10", function showTcqn10() {
    this.isShowTcqn09 = false;
    this.isShowTcqn10 = true;
    var self = this;
    this.addRecord('END', 12);
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "dateFormatString", function dateFormatString(date, format) {
    // 时间格式化
    var date = new Date(date),
      o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds()
      };
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return format;
  }), "getLastDaysFromToday", function getLastDaysFromToday(n) {
    var lastDays = new Date().setDate(new Date().getDate() - n);
    var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
    return lastDaysStr;
  }), "addRecord", function addRecord(type, index) {
    var _this46 = this;
    var data = {
      exerciseType: 'WPS_EXCEL_EXAM',
      stepSeq: index,
      exerciseAction: type
    };
    this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
      var result = res.data;
      if (result.success) {
        if (index == 6 && type == 'END') {
          window.parent['goBack']();
        }
      } else {
        _this46.$message({
          message: result.msg,
          type: 'error',
          center: true,
          duration: 1000
        });
      }
    }, function (res) {
      _this46.$message({
        message: "网络繁忙，请稍后重试！",
        type: 'error',
        center: true,
        duration: 1000
      });
    });
  }))
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
var _methods; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      data: {
        positionX: 0,
        positionY: 0
      },
      OnInline: 'false',
      //小助手跳转
      tabIndex: 1,
      //序号
      tabCurrent: 'first',
      //当前标签页
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      isOpenPpt7: false,
      //是否展开ppt
      isOpenPpt8: false,
      //是否展开ppt
      isOpenPpt9: false,
      //是否展开ppt
      isOpenPpt10: false,
      //是否展开ppt
      isOpenPpt11: false,
      //是否展开ppt
      isOpenPpt12: false,
      //是否展开ppt
      //第1步
      isShowqh1_1: true,
      //显示切换输入法页面
      isShowqh1_2: false,
      //鼠标移入切换输入法
      isShowqh1_3: false,
      //鼠标点击切换输入法
      isShowqh1_4: false,
      //鼠标移入搜狗输入法
      isShowqh1_5: false,
      //鼠标点击搜狗输入法
      // 设置截屏
      isShowjp1_1: false,
      //延时两秒设置截屏页面显示
      isShowjp1_2: false,
      //鼠标移入输入法设置
      isShowjp1_3: false,
      //鼠标点击输入法设置
      isShowjp1_4: false,
      //鼠标移入截屏设置
      isShowjp1_5: false,
      //点击鼠标右键
      isShowjp1_6: false,
      //鼠标点击发送到桌面
      //设置截屏快捷键
      isShowkj1_1: false,
      //延时两秒显示设置截屏快捷键页面
      isShowkj1_2: false,
      //鼠标移入输入法图标
      isShowkj1_3: false,
      //鼠标点击输入法（菜单）图标
      isShowkj1_4: false,
      //鼠标点击更多设置
      isShowkj1_5: false,
      //鼠标移入按钮
      isShowkj1_6: false,
      //鼠标点击按钮,鼠标滚轮滑动
      // isShowkj1_7:false,//监听滚轮滚动
      isShowkj1_8: false,
      //鼠标移入系统功能快捷键设置
      isShowkj1_9: false,
      //鼠标点击系统功能快捷键设置
      isShowkj1_10: false,
      //监听滚轮滚动
      isShowkj1_11: false,
      //鼠标移入截屏
      isShowkj1_12: false,
      //鼠标点击截屏

      //第2步

      // 搜狗输入法的快捷短语
      isShowdy1_1: true,
      //显示快捷短语的第一张图片
      isShowdy1_2: false,
      //鼠标移入高级
      isShowdy1_3: false,
      //鼠标点击高级
      isShowdy1_4: false,
      //鼠标移入自定义短语
      isShowdy1_5: false,
      //鼠标点击自定义短语
      isShowdy1_6: false,
      //鼠标移入添加新短语
      isShowdy1_7: false,
      //鼠标点击添加新短语
      isShowdy1_7_input: '',
      //缩写输入框
      isShowdy1_7_textarea: '',
      //内容输入框
      isShowdy1_7_select: 1,
      //候选位置值
      isShowdy1_7_selectopint: [{
        value: 1,
        label: 1
      }, {
        value: 2,
        label: 2
      }, {
        value: 3,
        label: 3
      }, {
        value: 4,
        label: 4
      }, {
        value: 5,
        label: 5
      }, {
        value: 6,
        label: 6
      }, {
        value: 7,
        label: 7
      }, {
        value: 8,
        label: 8
      }, {
        value: 9,
        label: 9
      }],
      //候选位置下拉框值
      isShowdy1_8: false,
      //鼠标点击确定并添加
      isShowdy1_9: false,
      //鼠标点确定

      // 显示调用界面
      isShowdy1_10: false,
      //鼠标点击高级
      isb: 0,
      //记录b按下次数
      isShowdy1_11: false,
      //键盘连续输入bb
      isShowdy1_12: false,
      //键盘移入2
      isShowdy1_13: false,
      //键盘点击2
      isShowdy1_14: false,
      //鼠标点击发送

      // 平均
      isShowpj1_1: false,
      //延时两秒（显示求和页面）
      isShowpj1_2: false,
      //点击J3
      isShowpj1_3: false,
      //点击I3
      isShowpj1_4: false,
      //按下enter
      pj_input1: '293',
      //I3输入框
      pj1_input: '',
      //I3输入框
      // 总分
      isShowzf1_1: false,
      //k3平均页面显示
      isShowzf1_2: false,
      //点击K3单元格
      isShowzf1_3: false,
      //点击I3单元格
      isShowzf1_4: false,
      //点击I3单元格
      isShowzf1_5: false,
      //按下enter

      zf1_input: '',
      //E3输入框

      //修改第一张
      isShowxg1_1: false,
      //延时两秒（显示新建页面）
      isShowxg1_2: false,
      //点击下方的Sheet1
      xg_input1: 'Sheet1',
      //Sheet1修改输入框
      isShowxg1_3: false,
      //按下enter
      //新建
      isShowxj1_1: false,
      //按下enter延时两秒显示新建页面
      isShowxj1_2: false,
      //移入+号
      isShowxj1_3: false,
      //点击+号
      //占比
      isShowzb1_1: false,
      //占比页面显示
      isShowzb1_2: false,
      //点击C3
      isShowzb1_3: false,
      //点击B3
      isShowzb1_4: false,
      //点击A3
      zb_input1: '',
      //A3输入框
      isShowzb1_5: false,
      //按下enter
      //修改第二张
      isShowxg2_1: false,
      //延时两秒显示第二张修改页面
      isShowxg2_2: false,
      //点击下面的Sheet2
      xg_input2: 'Sheet2',
      //下面Sheet2输入框
      isShowxg2_3: false,
      //按下enter

      // 第三步
      isShowzt1_1: true,
      //是否显示第三步第一张图片
      isShowzt1_2: false,
      //鼠标移入字体样式
      isShowzt1_3: false,
      //鼠标点击字体样式
      isShowzt1_4: false,
      //鼠标移入微软雅黑
      isShowzt1_5: false,
      //鼠标点击微软雅黑
      // 居中
      isShowjz1_1: false,
      //延时两秒显示居中页面
      isShowjz1_2: false,
      //鼠标移入居中
      isShowjz1_3: false,
      //鼠标点击居中
      // 框线
      isShowkx1_1: false,
      //延迟两秒显示框线页面
      isShowkx1_2: false,
      //鼠标移入框线
      isShowkx1_3: false,
      //鼠标点击框线
      isShowkx1_4: false,
      //鼠标移入所有框线
      isShowkx1_5: false,
      //鼠标点击所有框线
      // 调A列
      // isShowta1_1:false,//延迟两秒调整A页面显示
      isShowta1_2: false,
      //移到A列
      isShowta1_3: false,
      //点击A列
      // 加粗合并第一行
      isShowjchb1_1: false,
      //延迟两秒显示加粗合并第一行页面
      isShowjchb1_2: false,
      //鼠标移入大号字体
      isShowjchb1_3: false,
      //鼠标点击大号字体（第一次）
      isShowjchb1_4: false,
      //鼠标点击大号字体（第二次）
      isShowjchb1_5: false,
      //鼠标移入字体加粗
      isShowjchb1_6: false,
      //鼠标点击字体加粗
      isShowjchb1_7: false,
      //鼠标移入居中合并
      isShowjchb1_8: false,
      //鼠标点击居中合并
      isShowjchb1_9: false,
      //鼠标移入设置颜色
      isShowjchb1_10: false,
      //鼠标移入颜色
      isShowjchb1_11: false,
      //鼠标点击颜色
      isShowjchb1_12: false,
      //
      //颜色换行第二行
      isShowyshh1_1: false,
      //延时两秒第二行颜色换行页面显示
      isShowyshh1_2: false,
      //鼠标移入更换字体颜色
      isShowyshh1_3: false,
      //鼠标点击更换字体颜色
      isShowyshh1_4: false,
      //鼠标移入自动换行
      isShowyshh1_5: false,
      //鼠标点击自动换行
      // 冻结
      isShowdj1_1: false,
      //延时两秒冻结页面显示
      isShowdj1_2: false,
      //鼠标移入冻结窗格
      isShowdj1_3: false,
      //鼠标点击冻结窗格
      isShowdj1_4: false,
      //鼠标移入冻结第二行
      isShowdj1_5: false,
      //鼠标点击冻结第二行
      // isShownr1_16:false,//插入列后延迟两秒
      // 保留小数
      isShowxs1_1: false,
      //延迟两秒保留小数页面显示
      isShowxs1_2: false,
      //鼠标移入常规
      isShowxs1_3: false,
      //点击常规下标
      isShowxs1_4: false,
      //鼠标移入其他数字格式
      isShowxs1_5: false,
      //鼠标点击其他数字格式
      isShowxs1_6: false,
      //鼠标点击数值
      isShowxs1_7: false,
      //鼠标移入输入框
      isShowxs1_8: false,
      //鼠标点击减号输入框
      isShowxs1_9: false,
      //鼠标移动到确定
      isShowxs1_10: false,
      //鼠标点击确定
      //占比保留两位小数
      isShowzbbl1_1: false,
      //延时两秒显示占比保留两位小数页面
      isShowzbbl1_2: false,
      //鼠标移入常规
      isShowzbbl1_3: false,
      //点击常规下标
      isShowzbbl1_4: false,
      //鼠标移动到%
      isShowzbbl1_5: false,
      //鼠标点击%
      // 第四步
      // 保存文件
      isShowbc1_1: true,
      //是否显示第四步第一张图片
      bc_input1: '66.67%',
      //保存第一张图的输入框（用于监听ctrl+s）
      isShowbc1_2: false,
      //监听ctrl+s
      isShowbc1_3: false,
      //鼠标移入我的桌面
      isShowbc1_4: false,
      //鼠标点击我的桌面
      isShowbc1_5: false,
      //鼠标点击办公软件培训
      isShowbc1_6: false,
      //鼠标点击文件名
      isShowbc1_7: false,
      //再点击一次
      isShowbc1_8: false,
      //显示输入框
      bc_input2: '',
      isShowbc1_9: false,
      //点击确定
      //另存为
      isShowlc1_1: false,
      //延时两秒显示另存页面
      isShowlc1_2: false,
      //点击右键
      isShowlc1_3: false,
      //鼠标移入另存为
      isShowlc1_4: false,
      //鼠标点击另存为
      isShowlc1_5: false,
      //鼠标移入我的桌面
      isShowlc1_6: false,
      //鼠标点击我的桌面
      isShowlc1_7: false,
      //鼠标点击保存
      // 第五步
      // 发送文件
      isShowfs1_1: true,
      //是否显示第五步第一张图片
      isShowfs1_2: false,
      //鼠标移入关闭
      isShowfs1_3: false,
      //鼠标点击关闭
      isShowfs1_4: false,
      //键盘点击表格
      isShowfs1_5: false,
      //键盘按下ctrl+c
      isShowfs1_6: false,
      //键盘按下ctrl+v
      isShowfs1_7: false,
      //点击发送
      // 第六步
      // Word基础功能
      isShowwdzt1_1: true,
      //是否显示第六步第一张图片
      isShowwdzt1_2: false,
      //ctrl+A
      isShowwdzt1_3: false,
      //鼠标移入字体下拉
      isShowwdzt1_4: false,
      //鼠标点击字体下拉
      isShowwdzt1_5: false,
      //鼠标移入楷体
      isShowwdzt1_6: false,
      //鼠标点击楷体
      isShowwdzt1_7: false,
      //鼠标移入字体大小
      isShowwdzt1_8: false,
      //鼠标点击字体大小
      isShowwdzt1_9: false,
      //鼠标移入小四
      isShowwdzt1_10: false,
      //鼠标点击小四
      // 行距
      isShowwdhj1_1: false,
      //延迟两秒显示行距页面
      isShowwdhj1_2: false,
      //鼠标移入行距
      isShowwdhj1_3: false,
      //鼠标点击行距
      isShowwdhj1_4: false,
      //鼠标移入1.5
      isShowwdhj1_5: false,
      //鼠标点击1.5
      // 首行缩进
      isShowwdsj1_1: false,
      //延时两秒显示首行缩进页面
      isShowwdsj1_1_1: false,
      //点击鼠标右键
      isShowwdsj1_2: false,
      //鼠标移入段落
      isShowwdsj1_3: false,
      //鼠标点击段落
      isShowwdsj1_4: false,
      //鼠标点击特殊格式
      isShowwdsj1_5: false,
      //鼠标移动到首行缩进
      isShowwdsj1_6: false,
      //鼠标点击首行缩进
      isShowwdsj1_7: false,
      //鼠标点击确定
      //加粗居中
      isShowwdjc1_1: false,
      //延时两秒显示加粗居中页面
      isShowwdjc1_2: false,
      //鼠标移到加粗
      isShowwdjc1_3: false,
      //鼠标点击加粗
      isShowwdjc1_4: false,
      //鼠标移到居中
      isShowwdjc1_5: false,
      //鼠标点击居中
      //颜色设置为红色
      isShowwdys1_1: false,
      //延时两秒显示设置颜色页面
      isShowwdys1_2: false,
      //鼠标移到颜色
      isShowwdys1_3: false,
      //鼠标点击颜色
      isShowwdys1_4: false,
      //鼠标移到红色
      isShowwdys1_5: false,
      //鼠标点击红色
      // 自然段颜色页面显示(凸显页面)
      isShowwdtx1_1: false,
      //延迟两秒自然段颜色页面显示(凸显页面)显示
      isShowwdtx1_2: false,
      //鼠标移到段落颜色
      isShowwdtx1_3: false,
      //鼠标点击段落颜色
      isShowwdtx1_4: false //鼠标点击空白
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this2.tabCurrent).show();
      _this2.$set(_this2.isShowBtn, _this2.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
    var _this = this;
    document.onkeydown = function (event) {
      var key = window.event.keyCode;
      console.log(key, 88877);
      if (key === 83 && event.ctrlKey) {
        event.returnValue = false; // 阻止直接保存网页
        if (_this.isShowbc1_1 == true) {
          _this.showLoginbc1_1();
        }

        // 监听ctrl+S组合键      
      }
      if (key === 67 && event.ctrlKey) {
        if (_this.isShowfs1_4 == true) {
          _this.Loginfs1_4();
        }
        if (_this.isShownr1_7 == true) {
          _this.showLoginnr1_7();
        }

        // 监听ctrl+C组合键      
      }
      if (key === 86 && event.ctrlKey) {
        if (_this.isShowfs1_5 == true) {
          _this.Loginfs1_5();
        }
        if (_this.isShownr1_9 == true) {
          _this.listenTwo_3();
        }

        // 监听ctrl+V组合键      
      }
      if (key === 13) {
        if (_this.isShowqh1_4 == true) {
          _this.showLoginqh1_4();
        }
        if (_this.isShowpj1_3 == true) {
          _this.showLoginpj1_1();
        }
        if (_this.isShowzf1_4 == true) {
          _this.showLoginzf1_1();
        }
        if (_this.isShowzb1_4 == true) {
          _this.showLoginzb1_1();
        }
        if (_this.isShowfs1_6 == true) {
          _this.Loginfs1_6();
        }
        if (_this.isShowdy1_13 == true) {
          _this.showLogindy1_12_1();
        }

        // 监听回车     
      }
      if (key === 65 && event.ctrlKey) {
        if (_this.isShowwdzt1_1 == true) {
          event.returnValue = false; // 阻止
          _this.Loginwdzt1_1();
        }

        // 监听ctrl+A     
      }
      if (key === 66) {
        _this.isb++;
        console.log(_this.isb, 888);
        if (_this.isShowdy1_10 == true) {
          if (_this.isb == 2) {
            _this.showLogindy1_9();
          }
        } else {
          _this.isb = 0;
        }
        // 监听连续按下两次b    
      } else {
        _this.isb = 0;
      }
      if (key === 50 || key === 98) {
        if (_this.isShowdy1_11 == true) {
          _this.showLogindy1_10_1();
        }
      }
    };

    // var step = this.$route.query.step;
    // if(step == 12){
    //     this.studyNext('#tab-twelve')
    // }
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: (_methods = {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('zero').play();
      $('#startvideo').hide();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.isShowqh1_1 = true,
      //显示切换输入法页面
      this.isShowqh1_2 = false,
      //鼠标移入切换输入法
      this.isShowqh1_3 = false,
      //鼠标点击切换输入法
      this.isShowqh1_4 = false,
      //鼠标移入搜狗输入法
      this.isShowqh1_5 = false,
      //鼠标点击搜狗输入法
      // 设置截屏
      this.isShowjp1_1 = false,
      //延时两秒设置截屏页面显示
      this.isShowjp1_2 = false,
      //鼠标移入输入法设置
      this.isShowjp1_3 = false,
      //鼠标点击输入法设置
      this.isShowjp1_4 = false,
      //鼠标移入截屏设置
      this.isShowjp1_5 = false,
      //点击鼠标右键
      this.isShowjp1_6 = false,
      //鼠标点击发送到桌面
      //设置截屏快捷键
      this.isShowkj1_1 = false,
      //延时两秒显示设置截屏快捷键页面
      this.isShowkj1_2 = false,
      //鼠标移入输入法图标
      this.isShowkj1_3 = false,
      //鼠标点击输入法（菜单）图标
      this.isShowkj1_4 = false,
      //鼠标点击更多设置
      this.isShowkj1_5 = false,
      //鼠标移入按钮
      this.isShowkj1_6 = false,
      //鼠标点击按钮,鼠标滚轮滑动
      // isShowkj1_7:false,//监听滚轮滚动
      this.isShowkj1_8 = false,
      //鼠标移入系统功能快捷键设置
      this.isShowkj1_9 = false,
      //鼠标点击系统功能快捷键设置
      this.isShowkj1_10 = false,
      //监听滚轮滚动
      this.isShowkj1_11 = false,
      //鼠标移入截屏
      this.isShowkj1_12 = false; //鼠标点击截屏
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      // 搜狗输入法的快捷短语
      this.isShowdy1_1 = true,
      //显示快捷短语的第一张图片
      this.isShowdy1_2 = false,
      //鼠标移入高级
      this.isShowdy1_3 = false,
      //鼠标点击高级
      this.isShowdy1_4 = false,
      //鼠标移入自定义短语
      this.isShowdy1_5 = false,
      //鼠标点击自定义短语
      this.isShowdy1_6 = false,
      //鼠标移入添加新短语
      this.isShowdy1_7 = false,
      //鼠标点击添加新短语
      this.isShowdy1_7_input = '',
      //缩写输入框
      this.isShowdy1_7_textarea = '',
      //内容输入框
      this.isShowdy1_7_select = 1,
      //候选位置值
      this.isShowdy1_7_selectopint = [{
        value: 1,
        label: 1
      }, {
        value: 2,
        label: 2
      }, {
        value: 3,
        label: 3
      }, {
        value: 4,
        label: 4
      }, {
        value: 5,
        label: 5
      }, {
        value: 6,
        label: 6
      }, {
        value: 7,
        label: 7
      }, {
        value: 8,
        label: 8
      }, {
        value: 9,
        label: 9
      }],
      //候选位置下拉框值
      this.isShowdy1_8 = false,
      //鼠标点击确定并添加
      this.isShowdy1_9 = false,
      //鼠标点确定

      // 显示调用界面
      this.isShowdy1_10 = false,
      //鼠标点击高级
      this.isb = 0,
      //记录b按下次数
      this.isShowdy1_11 = false,
      //键盘连续输入bb
      this.isShowdy1_12 = false,
      //键盘移入2
      this.isShowdy1_13 = false,
      //键盘点击2
      this.isShowdy1_14 = false; //鼠标点击发送
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowzt1_1 = true,
      //是否显示第三步第一张图片
      this.isShowzt1_2 = false,
      //鼠标移入字体样式
      this.isShowzt1_3 = false,
      //鼠标点击字体样式
      this.isShowzt1_4 = false,
      //鼠标移入微软雅黑
      this.isShowzt1_5 = false,
      //鼠标点击微软雅黑
      // 居中
      this.isShowjz1_1 = false,
      //延时两秒显示居中页面
      this.isShowjz1_2 = false,
      //鼠标移入居中
      this.isShowjz1_3 = false,
      //鼠标点击居中
      // 框线
      this.isShowkx1_1 = false,
      //延迟两秒显示框线页面
      this.isShowkx1_2 = false,
      //鼠标移入框线
      this.isShowkx1_3 = false,
      //鼠标点击框线
      this.isShowkx1_4 = false,
      //鼠标移入所有框线
      this.isShowkx1_5 = false,
      //鼠标点击所有框线
      // 调A列
      // this.isShowta1_1=false,//延迟两秒调整A页面显示
      this.isShowta1_2 = false,
      //移到A列
      this.isShowta1_3 = false,
      //点击A列
      // 加粗合并第一行
      this.isShowjchb1_1 = false,
      //延迟两秒显示加粗合并第一行页面
      this.isShowjchb1_2 = false,
      //鼠标移入大号字体
      this.isShowjchb1_3 = false,
      //鼠标点击大号字体（第一次）
      this.isShowjchb1_4 = false,
      //鼠标点击大号字体（第二次）
      this.isShowjchb1_5 = false,
      //鼠标移入字体加粗
      this.isShowjchb1_6 = false,
      //鼠标点击字体加粗
      this.isShowjchb1_7 = false,
      //鼠标移入居中合并
      this.isShowjchb1_8 = false,
      //鼠标点击居中合并
      this.isShowjchb1_9 = false,
      //鼠标移入设置颜色
      this.isShowjchb1_10 = false,
      //鼠标移入颜色
      this.isShowjchb1_11 = false,
      //鼠标点击颜色
      this.isShowjchb1_12 = false,
      //
      //颜色换行第二行
      this.isShowyshh1_1 = false,
      //延时两秒第二行颜色换行页面显示
      this.isShowyshh1_2 = false,
      //鼠标移入更换字体颜色
      this.isShowyshh1_3 = false,
      //鼠标点击更换字体颜色
      this.isShowyshh1_4 = false,
      //鼠标移入自动换行
      this.isShowyshh1_5 = false,
      //鼠标点击自动换行
      // 冻结
      this.isShowdj1_1 = false,
      //延时两秒冻结页面显示
      this.isShowdj1_2 = false,
      //鼠标移入冻结窗格
      this.isShowdj1_3 = false,
      //鼠标点击冻结窗格
      this.isShowdj1_4 = false,
      //鼠标移入冻结第二行
      this.isShowdj1_5 = false,
      //鼠标点击冻结第二行
      // isShownr1_16:false,//插入列后延迟两秒
      // 保留小数
      this.isShowxs1_1 = false,
      //延迟两秒保留小数页面显示
      this.isShowxs1_2 = false,
      //鼠标移入常规
      this.isShowxs1_3 = false,
      //点击常规下标
      this.isShowxs1_4 = false,
      //鼠标移入其他数字格式
      this.isShowxs1_5 = false,
      //鼠标点击其他数字格式
      this.isShowxs1_6 = false,
      //鼠标点击数值
      this.isShowxs1_7 = false,
      //鼠标移入输入框
      this.isShowxs1_8 = false,
      //鼠标点击减号输入框
      this.isShowxs1_9 = false,
      //鼠标移动到确定
      this.isShowxs1_10 = false,
      //鼠标点击确定
      //占比保留两位小数
      this.isShowzbbl1_1 = false,
      //延时两秒显示占比保留两位小数页面
      this.isShowzbbl1_2 = false,
      //鼠标移入常规
      this.isShowzbbl1_3 = false,
      //点击常规下标
      this.isShowzbbl1_4 = false,
      //鼠标移动到%
      this.isShowzbbl1_5 = false; //鼠标点击%
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.isShowbc1_1 = true,
      //是否显示第四步第一张图片
      this.bc_input1 = '66.67%',
      //保存第一张图的输入框（用于监听ctrl+s）
      this.isShowbc1_2 = false,
      //监听ctrl+s
      this.isShowbc1_3 = false,
      //鼠标移入我的桌面
      this.isShowbc1_4 = false,
      //鼠标点击我的桌面
      this.isShowbc1_5 = false,
      //鼠标点击办公软件培训
      this.isShowbc1_6 = false,
      //鼠标点击文件名
      this.isShowbc1_7 = false,
      //再点击一次
      this.isShowbc1_8 = false,
      //显示输入框
      this.bc_input2 = '', this.isShowbc1_9 = false,
      //点击确定
      //另存为
      this.isShowlc1_1 = false,
      //延时两秒显示另存页面
      this.isShowlc1_2 = false,
      //点击右键
      this.isShowlc1_3 = false,
      //鼠标移入另存为
      this.isShowlc1_4 = false,
      //鼠标点击另存为
      this.isShowlc1_5 = false,
      //鼠标移入我的桌面
      this.isShowlc1_6 = false,
      //鼠标点击我的桌面
      this.isShowlc1_7 = false; //鼠标点击保存
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.isShowfs1_1 = true,
      //是否显示第五步第一张图片
      this.isShowfs1_2 = false,
      //鼠标移入关闭
      this.isShowfs1_3 = false,
      //鼠标点击关闭
      this.isShowfs1_4 = false,
      //鼠标点击表格
      this.isShowfs1_5 = false,
      //键盘按下ctrl+c
      this.isShowfs1_6 = false; //键盘按下ctrl+v
    },
    //初始化第6步状态值
    initSix: function initSix() {
      // Word基础功能
      this.isShowwdzt1_1 = true,
      //是否显示第六步第一张图片
      this.isShowwdzt1_2 = false,
      //ctrl+A
      this.isShowwdzt1_3 = false,
      //鼠标移入字体下拉
      this.isShowwdzt1_4 = false,
      //鼠标点击字体下拉
      this.isShowwdzt1_5 = false,
      //鼠标移入楷体
      this.isShowwdzt1_6 = false,
      //鼠标点击楷体
      this.isShowwdzt1_7 = false,
      //鼠标移入字体大小
      this.isShowwdzt1_8 = false,
      //鼠标点击字体大小
      this.isShowwdzt1_9 = false,
      //鼠标移入小四
      this.isShowwdzt1_10 = false,
      //鼠标点击小四
      // 行距
      this.isShowwdhj1_1 = false,
      //延迟两秒显示行距页面
      this.isShowwdhj1_2 = false,
      //鼠标移入行距
      this.isShowwdhj1_3 = false,
      //鼠标点击行距
      this.isShowwdhj1_4 = false,
      //鼠标移入1.5
      this.isShowwdhj1_5 = false,
      //鼠标点击1.5
      // 首行缩进
      this.isShowwdsj1_1 = false,
      //延时两秒显示首行缩进页面
      this.isShowwdsj1_1_1 = false,
      //点击鼠标右键
      this.isShowwdsj1_2 == false,
      //鼠标移入段落
      this.isShowwdsj1_3 = false,
      //鼠标点击段落
      this.isShowwdsj1_4 = false,
      //鼠标点击特殊格式
      this.isShowwdsj1_5 = false,
      //鼠标移动到首行缩进
      this.isShowwdsj1_6 = false,
      //鼠标点击首行缩进
      this.isShowwdsj1_7 = false,
      //鼠标点击确定
      //加粗居中
      this.isShowwdjc1_1 = false,
      //延时两秒显示加粗居中页面
      this.isShowwdjc1_2 = false,
      //鼠标移到加粗
      this.isShowwdjc1_3 = false,
      //鼠标点击加粗
      this.isShowwdjc1_4 = false,
      //鼠标移到居中
      this.isShowwdjc1_5 = false,
      //鼠标点击居中
      //颜色设置为红色
      this.isShowwdys1_1 = false,
      //延时两秒显示设置颜色页面
      this.isShowwdys1_2 = false,
      //鼠标移到颜色
      this.isShowwdys1_3 = false,
      //鼠标点击颜色
      this.isShowwdys1_4 = false,
      //鼠标移到红色
      this.isShowwdys1_5 = false,
      //鼠标点击红色
      // 自然段颜色页面显示(凸显页面)
      this.isShowwdtx1_1 = false,
      //延迟两秒自然段颜色页面显示(凸显页面)显示
      this.isShowwdtx1_2 = false,
      //鼠标移到段落颜色
      this.isShowwdtx1_3 = false,
      //鼠标点击段落颜色
      this.isShowwdtx1_4 = false; //鼠标点击空白
    },
    //初始化第7步状态值
    initSeven: function initSeven() {
      this.isShowZtsbicon = true;
      this.isShowZtsb01 = false;
      this.isShowZtsb02 = false;
      this.isShowZtsb03 = false;
      this.isShowZtsb04 = false;
      this.isShowZtsb05 = false;
      this.isShowZtsb06 = false;
      this.isShowZtsbTip01 = true;
      this.isShowZtsbTip02 = false;
      this.isShowZtsbTip03 = false;
    },
    //初始化第8步状态值
    initEight: function initEight() {
      this.isShowZjgnicon = true;
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
    },
    //初始化第9步状态值
    initNine: function initNine() {
      this.isShowTjgnicon = true;
      this.isShowTjgn01 = false;
      this.isShowTjgn02 = false;
      this.isShowTjgn03 = false;
      this.isShowTjgn04 = false;
      this.isShowTjgn05 = false;
      this.isShowTjgn06 = false;
    },
    //初始化第10步状态值
    initTen: function initTen() {
      this.isShowDdcjicon = false;
      this.isShowDdcj01 = false;
      this.isShowDdcj02 = false;
      this.isShowDdcj03 = false;
      this.isShowDdcj04 = false;
      this.isShowDdcj05 = false;
      this.isShowDdcj06 = false;
      this.isShowDdcj07 = true;
      this.isShowDdcj08 = false;
      this.isShowDdcj09 = false;
      this.isShowDdcj10 = false;
      this.isShowDdcjTip01 = true;
      this.isShowDdcjTip02 = false;
      this.isShowDdcjTip03 = false;
      this.ddcjbz = '';
      this.ddcjdz = '';
      this.ddcjyf = '';
    },
    //初始化第11步状态值
    initEleven: function initEleven() {
      this.isShowXjrwicon = true;
      this.isShowXjrw01 = false;
      this.isShowXjrw02 = false;
      this.isShowXjrw03 = false;
      this.isShowXjrw04 = false;
      this.isShowXjrw05 = false;
      this.isShowXjrw06 = false;
      this.xjrwmt = this.getLastDaysFromToday(-1) + ' 09:00';
      this.xjrwsj = '';
      this.xjrwtxt = '';
    },
    //初始化第12步状态值
    initTwelve: function initTwelve() {
      this.isShowTcqnicon = true;
      this.isShowTcqn01 = false;
      this.isShowTcqn02 = false;
      this.isShowTcqn03 = false;
      this.isShowTcqn04 = false;
      this.isShowTcqn05 = false;
      this.isShowTcqn06 = false;
      this.isShowTcqn07 = false;
      this.isShowTcqn08 = false;
      this.isShowTcqn09 = false;
      this.isShowTcqn10 = false;
      this.isShowTcqnTip01 = true;
      this.isShowTcqnTip02 = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      $('#startvideo').hide();
      this.isShowBtn = [];
      this.isOpenPpt = false;
      this.isOpenPpt2 = false;
      this.isOpenPpt3 = false;
      this.isOpenPpt4 = false;
      this.isOpenPpt5 = false;
      this.isOpenPpt6 = false;
      this.isOpenPpt7 = false;
      this.isOpenPpt8 = false;
      this.isOpenPpt9 = false;
      this.isOpenPpt10 = false;
      this.isOpenPpt11 = false;
      this.isOpenPpt12 = false;
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      $('#pdf_viewer7').height('0');
      $('#pdf_viewer8').height('0');
      $('#pdf_viewer9').height('0');
      $('#pdf_viewer10').height('0');
      $('#pdf_viewer11').height('0');
      $('#pdf_viewer12').height('0');
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
      //第9步
      this.initNine();
      //第10步
      this.initTen();
      //第11步
      this.initEleven();
      //第12步
      this.initTwelve();
      $('.content').each(function (i) {
        $(this).hide();
      });
      $('.stoptip').each(function (i) {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function (i) {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show();
    },
    //tab切换
    handleClick: function handleClick(tab, event) {
      var _this3 = this;
      console.log(tab, 111111);
      this.tabIndex = parseInt(tab.index) + 1;
      //内容初始化
      this.initAll();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this3.tabCurrent).show();
        _this3.$set(_this3.isShowBtn, _this3.tabCurrent, true);
      }, false);
    },
    //展开/收起ppt
    viewPpt: function viewPpt(bol) {
      if (this.isOpenPpt == true || !bol) {
        this.isOpenPpt = false;
        $('#pdf_viewer').height('0');
      } else {
        this.isOpenPpt = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/53a1088d94174ab3b03cd609e3fd39f2.pdf', "#pdf_viewer", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt2: function viewPpt2(bol) {
      if (this.isOpenPpt2 == true || !bol) {
        this.isOpenPpt2 = false;
        $('#pdf_viewer2').height('0');
      } else {
        this.isOpenPpt2 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer2').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/4c9cc43c2d234113a68c3b9f329c8ce9.pdf', "#pdf_viewer2", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt3: function viewPpt3(bol) {
      if (this.isOpenPpt3 == true || !bol) {
        this.isOpenPpt3 = false;
        $('#pdf_viewer3').height('0');
      } else {
        this.isOpenPpt3 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer3').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step3.pdf?version=1221', "#pdf_viewer3", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt4: function viewPpt4(bol) {
      if (this.isOpenPpt4 == true || !bol) {
        this.isOpenPpt4 = false;
        $('#pdf_viewer4').height('0');
      } else {
        this.isOpenPpt4 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer4').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step4.pdf?version=1221', "#pdf_viewer4", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt5: function viewPpt5(bol) {
      if (this.isOpenPpt5 == true || !bol) {
        this.isOpenPpt5 = false;
        $('#pdf_viewer5').height('0');
      } else {
        this.isOpenPpt5 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer5').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step5.pdf?version=1221', "#pdf_viewer5", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt6: function viewPpt6(bol) {
      if (this.isOpenPpt6 == true || !bol) {
        this.isOpenPpt6 = false;
        $('#pdf_viewer6').height('0');
      } else {
        this.isOpenPpt6 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer6').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step6.pdf?version=1221', "#pdf_viewer6", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt7: function viewPpt7(bol) {
      if (this.isOpenPpt7 == true || !bol) {
        this.isOpenPpt7 = false;
        $('#pdf_viewer7').height('0');
      } else {
        this.isOpenPpt7 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer7').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step7.pdf?version=1221', "#pdf_viewer7", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt8: function viewPpt8(bol) {
      if (this.isOpenPpt8 == true || !bol) {
        this.isOpenPpt8 = false;
        $('#pdf_viewer8').height('0');
      } else {
        this.isOpenPpt8 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer8').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step8.pdf?version=1221', "#pdf_viewer8", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt9: function viewPpt9(bol) {
      if (this.isOpenPpt9 == true || !bol) {
        this.isOpenPpt9 = false;
        $('#pdf_viewer9').height('0');
      } else {
        this.isOpenPpt9 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer9').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step9.pdf?version=1221', "#pdf_viewer9", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt10: function viewPpt10(bol) {
      if (this.isOpenPpt10 == true || !bol) {
        this.isOpenPpt10 = false;
        $('#pdf_viewer10').height('0');
      } else {
        this.isOpenPpt10 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer10').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step10.pdf?version=1221', "#pdf_viewer10", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt11: function viewPpt11(bol) {
      if (this.isOpenPpt11 == true || !bol) {
        this.isOpenPpt11 = false;
        $('#pdf_viewer11').height('0');
      } else {
        this.isOpenPpt11 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer11').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step11.pdf?version=1221', "#pdf_viewer11", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt12: function viewPpt12(bol) {
      if (this.isOpenPpt12 == true || !bol) {
        this.isOpenPpt12 = false;
        $('#pdf_viewer12').height('0');
      } else {
        this.isOpenPpt12 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer12').height('700px');
          _pdfobject.default.embed('//taojinyun.file.itaojin.cn/qianniusource/step12.pdf?version=1221', "#pdf_viewer12", options);
        }
      }
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //最后一节-重看视频
    restartVideoLast: function restartVideoLast() {
      this.initTwelve();
      document.getElementById(this.tabCurrent).play();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
    },
    //开始实操练习
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.isShowBtn[this.tabCurrent] = false;
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START');
      // this.getFocusbc_1()
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initFirst();
      this.initSecond();
      this.initThird();
      this.initFour();
      this.initFive();
      this.initSix();
      this.initSeven();
      this.initEight();
      this.initNine();
      this.initTen();
      this.initEleven();
      this.initTwelve();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    //第1步-鼠标移入输入法
    showLoginqh1_1: function showLoginqh1_1() {
      this.isShowqh1_1 = false;
      this.isShowqh1_2 = true;
    },
    //鼠标点击输入法
    showLoginqh1_2: function showLoginqh1_2() {
      this.isShowqh1_2 = false;
      this.isShowqh1_3 = true;
    },
    //鼠标移入搜狗输入法
    showLoginqh1_3: function showLoginqh1_3() {
      this.isShowqh1_3 = false;
      this.isShowqh1_4 = true;
    },
    //鼠标点击搜狗输入法
    showLoginqh1_4: function showLoginqh1_4() {
      var _this4 = this;
      this.isShowqh1_4 = false;
      this.isShowqh1_5 = true;
      // 设置截屏页面显示
      setTimeout(function () {
        _this4.isShowqh1_5 = false;
        _this4.isShowjp1_1 = true;
      }, 2000);
    },
    //鼠标移入输入法设置
    showLoginjp1_1: function showLoginjp1_1() {
      this.isShowjp1_1 = false;
      this.isShowjp1_2 = true;
    },
    //鼠标点击输入法设置
    showLoginjp1_2: function showLoginjp1_2() {
      this.isShowjp1_2 = false;
      this.isShowjp1_3 = true;
    },
    //鼠标移入截屏设置
    showLoginjp1_3: function showLoginjp1_3() {
      this.isShowjp1_3 = false;
      this.isShowjp1_4 = true;
    },
    //点击鼠标右键
    showLoginjp1_4: function showLoginjp1_4() {
      this.isShowjp1_4 = false;
      this.isShowjp1_5 = true;
    },
    //鼠标点击发送到桌面
    showLoginjp1_5: function showLoginjp1_5() {
      var _this5 = this;
      this.isShowjp1_5 = false;
      this.isShowjp1_6 = true;
      // 设置截屏快捷键页面显示
      setTimeout(function () {
        _this5.isShowjp1_6 = false;
        _this5.isShowkj1_1 = true;
      }, 2000);
    },
    //鼠标移入输入法
    showLoginkj1_1: function showLoginkj1_1() {
      this.isShowkj1_1 = false;
      this.isShowkj1_2 = true;
    },
    //鼠标点击输入法菜单
    showLoginkj1_2: function showLoginkj1_2() {
      this.isShowkj1_2 = false;
      this.isShowkj1_3 = true;
    },
    //鼠标点击更多设置
    showLoginkj1_3: function showLoginkj1_3() {
      this.isShowkj1_3 = false;
      this.isShowkj1_4 = true;
    },
    //鼠标移入按键
    showLoginkj1_4: function showLoginkj1_4() {
      this.isShowkj1_4 = false;
      this.isShowkj1_5 = true;
    },
    //鼠标点击按键
    showLoginkj1_5: function showLoginkj1_5() {
      this.isShowkj1_5 = false;
      this.isShowkj1_6 = true;
    },
    // //滚轮滑动
    // gunlun(e){
    // 	console.log(e)
    // 	if(e.deltaY>0){
    // 		this.isShowkj1_6=false
    // 		this.isShowkj1_7=true
    // 	}
    // },
    //鼠标移入系统功能快捷键设置
    showLoginkj1_6: function showLoginkj1_6() {
      this.isShowkj1_6 = false;
      this.isShowkj1_8 = true;
    },
    //鼠标点击系统功能快捷键设置
    showLoginkj1_7: function showLoginkj1_7() {
      this.isShowkj1_8 = false;
      this.isShowkj1_9 = true;
    },
    // //滚轮滑动
    // showLoginkj1_8(e){
    // 	if(e.deltaY>0){
    // 		this.isShowkj1_9=false
    // 		this.isShowkj1_10=true
    // 	}
    // },
    //鼠标移入截屏
    showLoginkj1_9: function showLoginkj1_9() {
      this.isShowkj1_9 = false;
      this.isShowkj1_11 = true;
    },
    //鼠标点击截屏单选框
    showLoginkj1_10: function showLoginkj1_10() {
      this.isShowkj1_11 = false;
      this.isShowkj1_12 = true;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 搜狗输入法的快捷短语
    // 搜狗输入法的快捷短语的第一张图显示// 鼠标移入高级
    showLogindy1_1: function showLogindy1_1() {
      this.isShowdy1_1 = false;
      this.isShowdy1_2 = true;
    },
    // 鼠标点击高级
    showLogindy1_2: function showLogindy1_2() {
      this.isShowdy1_2 = false;
      this.isShowdy1_3 = true;
    },
    //鼠标移入自定义短语设置
    showLogindy1_3: function showLogindy1_3() {
      this.isShowdy1_3 = false;
      this.isShowdy1_4 = true;
    },
    //鼠标点击自定义短语设置
    showLogindy1_4: function showLogindy1_4() {
      this.isShowdy1_4 = false;
      this.isShowdy1_5 = true;
    },
    //鼠标移入添加新短语
    showLogindy1_5: function showLogindy1_5() {
      this.isShowdy1_5 = false;
      this.isShowdy1_6 = true;
    },
    //鼠标点击添加新短语
    showLogindy1_6: function showLogindy1_6() {
      this.isShowdy1_6 = false;
      this.isShowdy1_7 = true;
    },
    //鼠标点击确定并继续添加
    showLogindy1_7: function showLogindy1_7() {
      if (this.isShowdy1_7_input != 'bb') {
        this.notify('<p>请将“缩写”按照要求编辑</p>');
      } else {
        if (this.isShowdy1_7_textarea != '报备：去上厕所，离开3分钟') {
          this.notify('<p>请将“内容”按照要求编辑</p>');
        } else {
          this.isShowdy1_7 = false;
          this.isShowdy1_7_input = '';
          this.isShowdy1_7_textarea = '';
          this.isShowdy1_8 = true;
        }
      }
    },
    //鼠标点击确定
    showLogindy1_8: function showLogindy1_8() {
      var _this6 = this;
      if (this.isShowdy1_7_input != 'bb') {
        this.notify('<p>请将“缩写”按照要求编辑</p>');
      } else {
        if (this.isShowdy1_7_textarea != '报备：去上厕所，离开5分钟') {
          this.notify('<p>请将“内容”按照要求编辑</p>');
        } else {
          if (this.isShowdy1_7_select != 2) {
            this.notify('<p>请将“候选位置”按照要求编辑</p>');
          } else {
            this.isShowdy1_8 = false;
            this.isShowdy1_9 = true;
            //   延时两秒显示调用页面
            setTimeout(function () {
              _this6.isShowdy1_9 = false;
              _this6.isShowdy1_10 = true;
            }, 2000);
          }
        }
      }
    },
    //连续点击两次b
    showLogindy1_9: function showLogindy1_9() {
      this.isShowdy1_10 = false;
      this.isShowdy1_11 = true;
    },
    //鼠标移到2
    showLogindy1_10: function showLogindy1_10() {
      this.isShowdy1_11 = false;
      this.isShowdy1_12 = true;
    },
    //键盘按下2
    showLogindy1_10_1: function showLogindy1_10_1() {
      this.isShowdy1_11 = false;
      this.isShowdy1_13 = true;
    },
    //鼠标点击2
    showLogindy1_11: function showLogindy1_11() {
      this.isShowdy1_12 = false;
      this.isShowdy1_13 = true;
    },
    //鼠标点击发送
    showLogindy1_12: function showLogindy1_12() {
      this.isShowdy1_13 = false;
      this.isShowdy1_14 = true;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //按下键盘enter
    showLogindy1_12_1: function showLogindy1_12_1() {
      this.isShowdy1_13 = false;
      this.isShowdy1_14 = true;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 点击第六行第三个
    showLoginImg10: function showLoginImg10() {
      var self = this;
      this.isShowQnIcon13 = false;
      this.isShowQnIcon14 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第1步-Excel界面介绍
    restartStudyFirst: function restartStudyFirst() {
      this.initFirst();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    // //登录
    // loginIn() {
    //   if(this.name == '') {
    //     this.notify('<p>请输入账号</p>')
    //     return
    //   }else if(this.name != '淘金客服:001') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   if(this.password == '') {
    //     this.notify('<p>请输入密码</p>')
    //     return
    //   }else if(this.password != 'TJ2019') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   this.isShowLoginImg = false
    //   this.isShowRnd = true
    // },
    // //验证码登录
    // loginInRnd() {
    // 	if(this.rnd == '') {
    //     this.notify('<p>请输入短信验证码</p>')
    //     return
    //   }else if(this.rnd != '660220') {
    //     this.notify('<p>短信验证码错误</p>')
    //     return
    //   }
    //   this.isShowRnd = false
    //   this.isShowLoginIndex = true
    // },
    // //进入接待中心
    // enterJd() {
    // 	var self = this
    // 	this.isShowLoginIndex = false
    // 	this.isShowLoginIndexTwo = true
    // 	this.addRecord('END')
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    // //重练-登录
    // restartStudyFirst() {
    // 	this.initFirst()
    // 	$('#studytip-'+this.tabCurrent).hide();
    // 	this.addRecord('START')
    // },
    //第2步-
    showLoginnr1_1: function showLoginnr1_1() {
      this.isShownr1_1 = false;
      this.isShownr1_2 = true;
      this.getFocus();
    },
    //input自动获取焦点1
    getFocus: function getFocus() {
      this.$nextTick(function () {
        var _this7 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this7.$refs.strname.focus();
        }, 100);
      });
    },
    //监听回车1
    listenOne: function listenOne(event) {
      if (event.keyCode === 13) {
        this.verification_nr1();
        event.preventDefault();
        return false;
      }
    },
    verification_nr1: function verification_nr1() {
      var _this8 = this;
      if (this.nr_input == '总分较8月上升（下降）') {
        this.isShownr1_2 = false;
        this.isShownr1_3 = true;
        console.log(22222);
        setTimeout(function () {
          _this8.isShownr1_3_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //点击A3
    showLoginnr1_3: function showLoginnr1_3() {
      this.isShownr1_3 = false;
      this.isShownr1_4 = true;
      this.getFocus2();
    },
    //input自动获取焦点2
    getFocus2: function getFocus2() {
      this.$nextTick(function () {
        var _this9 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this9.$refs.strname2.focus();
        }, 100);
      });
    },
    //监听回车2
    listenTwo: function listenTwo(event) {
      console.log(event, 7777);
      console.log(event.key, 555);
      if (event.key == ';' && event.ctrlKey) {
        this.isShownr1_4 = false;
        this.isShownr1_5 = true;
        this.nr_input2 = this.getNowDate();
        console.log(this.nr_input2, 11111);
        event.preventDefault();
        return false;
      }
    },
    //监听回车3
    listenTwo_1: function listenTwo_1(event) {
      var _this0 = this;
      if (event.keyCode === 13) {
        if (this.nr_input2 == '2022/9/29') {
          this.isShownr1_5 = false;
          this.isShownr1_6 = true;
          setTimeout(function () {
            _this0.isShownr1_6_1 = true;
          }, 2000);
        } else {
          this.notify('<p>请按照右边提示填写正确的内容</p>');
        }
      }

      // if(  ) {
      // 	    this.isShownr1_4=false
      // 	    this.isShownr1_5=true
      // 	    this.nr_input2=this.getNowDate()
      // 		console.log(this.nr_input2,77777)
      // 	    event.preventDefault()
      // 	    return false
      // 	    }
    },
    // 获得当前时间（并格式化）
    getNowDate: function getNowDate() {
      var timeOne = new Date();
      var year = timeOne.getFullYear();
      var month = timeOne.getMonth() + 1;
      var day = timeOne.getDate();
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      var NOW_MONTHS_AGO = "".concat(year, "/").concat(month, "/").concat(day);
      return NOW_MONTHS_AGO;
    },
    // 点击A单元格（下拖前）
    showLoginnr1_6: function showLoginnr1_6() {
      this.isShownr1_6 = false;
      this.isShownr1_6_1 = false;
      this.isShownr1_7 = true;
      // this.getFocus3()
    },
    //input自动获取焦点3
    getFocus3: function getFocus3() {
      this.$nextTick(function () {
        var _this1 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this1.$refs.strname3.focus();
        }, 100);
      });
    },
    //监听ctrl+C
    listenTwo_2: function listenTwo_2(event) {
      console.log(event, 7777);
      if (event.keyCode == 67 && event.ctrlKey) {
        this.showLoginnr1_7();
        event.preventDefault();
        return false;
      }
    },
    // 按下 ctrl C
    showLoginnr1_7: function showLoginnr1_7() {
      var _this10 = this;
      this.isShownr1_7 = false;
      this.isShownr1_8 = true;
      setTimeout(function () {
        _this10.isShownr1_8 = false;
        _this10.isShownr1_9 = true;
        // this.getFocus4()
      }, 1000);
    },
    //监听Ctrl+v 4
    // listenTwo_3(event){
    // console.log(event,77778888)
    // if( event.keyCode== 86) {
    // 	    this.isShownr1_9=false
    // 	    this.isShownr1_10=true
    //         setTimeout(()=>{
    // 			this.isShownr1_10=false
    // 			this.isShownr1_11=true
    // 		},2000)
    //         event.preventDefault()
    // 	    return false
    // 	    }
    // },
    //监听Ctrl+v 4
    listenTwo_3: function listenTwo_3() {
      var _this11 = this;
      this.isShownr1_9 = false;
      this.isShownr1_10 = true;
      setTimeout(function () {
        _this11.isShownr1_10 = false;
        _this11.isShownr1_11 = true;
      }, 2000);
    },
    //input自动获取焦点4
    getFocus4: function getFocus4() {
      this.$nextTick(function () {
        var _this12 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this12.$refs.strname4.focus();
        }, 100);
      });
    },
    //点击C列
    showLoginnr1_11: function showLoginnr1_11() {
      this.isShownr1_11 = false;
      this.isShownr1_12 = true;
    },
    //点击鼠标右键
    rightClick: function rightClick($event) {
      this.isShownr1_12 = false;
      this.isShownr1_13 = true;
    },
    //右键后鼠标移入插入列
    showLoginnr1_13: function showLoginnr1_13() {
      this.isShownr1_13 = false;
      this.isShownr1_14 = true;
    },
    //点击鼠标移入的插入列
    showLoginnr1_14: function showLoginnr1_14() {
      var _this13 = this;
      this.isShownr1_14 = false;
      this.isShownr1_15 = true;
      setTimeout(function () {
        _this13.isShownr1_15 = false;
        _this13.isShownr1_16 = true;
      }, 2000);
    },
    //点击第6列
    showLoginnr1_15: function showLoginnr1_15() {
      this.isShownr1_16 = false;
      this.isShownr1_17 = true;
    },
    //点击右键
    showLoginnr1_16: function showLoginnr1_16() {
      // this.isShownr1_17=false
      // this.isShownr1_17_1=true
      this.isShownr1_17_1 = true;
    },
    //鼠标移入
    showLoginnr1_17: function showLoginnr1_17() {
      this.isShownr1_17_1 = false;
      this.isShownr1_17_2 = true;
    },
    //点击插入行
    showLoginnr1_17_1: function showLoginnr1_17_1() {
      var _this14 = this;
      this.isShownr1_17 = false;
      this.isShownr1_17_2 = false;
      this.isShownr1_18 = true;
      //过渡求和
      setTimeout(function () {
        _this14.isShownr1_18 = false;
        _this14.isShownr1_19 = true;
      }, 2000);
    },
    // 求和
    //点击I3
    showLoginnr1_19: function showLoginnr1_19() {
      this.isShownr1_19 = false;
      this.isShowqh1_1 = true;
      this.getFocusqh_1();
    },
    //点击F3
    showLoginnr1_20: function showLoginnr1_20() {
      if (this.qh1_input == '=') {
        this.qh1_input1 = '=F3';
        this.isShowqh1_1 = false;
        this.isShowqh1_2 = true;
        this.getFocusqh_2();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    // 点击下方的名字，进行修改
    Loginxg1_3: function Loginxg1_3() {
      this.isShowxg1_1 = false;
      this.isShowxg1_2 = true;
    },
    //修改完点击enter
    showLoginxg1_1: function showLoginxg1_1() {
      var _this15 = this;
      if (this.xg_input1 == '成绩汇总') {
        this.isShowxg1_2 = false;
        this.isShowxg1_3 = true;
        // 显示新建页面
        setTimeout(function () {
          _this15.isShowxg1_3 = false;
          _this15.isShowxj1_1 = true;
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    // 移入+号
    Loginxj1_1: function Loginxj1_1() {
      this.isShowxj1_1 = false;
      this.isShowxj1_2 = true;
    },
    // 点击+号
    Loginxj1_2: function Loginxj1_2() {
      var _this16 = this;
      this.isShowxj1_2 = false;
      this.isShowxj1_3 = true;
      // 显示占比页面
      setTimeout(function () {
        _this16.isShowxj1_3 = false;
        _this16.isShowzb1_1 = true;
      }, 2000);
    },
    //点击C3
    Loginzb1_1: function Loginzb1_1() {
      this.isShowzb1_1 = false;
      this.isShowzb1_2 = true;
      this.getFocuszb_1();
    },
    // 点击B3
    Loginzb1_2: function Loginzb1_2() {
      if (this.zb_input1 == '=') {
        this.zb_input1 = '=B3';
        this.isShowzb1_2 = false;
        this.isShowzb1_3 = true;
        this.getFocuszb_1();
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //输入框焦点聚焦
    getFocuszb_1: function getFocuszb_1() {
      this.$nextTick(function () {
        var _this17 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this17.$refs.strname_zb1.focus();
        }, 100);
      });
    },
    //点击A3
    Loginzb1_3: function Loginzb1_3() {
      if (this.zb_input1 == '=B3/') {
        this.isShowzb1_3 = false;
        this.isShowzb1_4 = true;
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }

      // this.getFocuszb_1()
    },
    //按下enter
    showLoginzb1_1: function showLoginzb1_1() {
      var _this18 = this;
      this.isShowzb1_4 = false;
      this.isShowzb1_5 = true;
      //第二张修改页面
      setTimeout(function () {
        _this18.isShowzb1_5 = false;
        _this18.isShowxg2_1 = true;
      }, 2000);
    },
    //输入框焦点聚焦
    getFocusxg_2: function getFocusxg_2() {
      this.$nextTick(function () {
        var _this19 = this;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(function () {
          _this19.$refs.strname_xg2.focus();
        }, 100);
      });
    },
    //点击下面的sheet2
    Loginxg2_1: function Loginxg2_1() {
      this.isShowxg2_1 = false;
      this.isShowxg2_2 = true;
      this.getFocusxg_2();
    },
    //按下enter
    showLoginxg2_1: function showLoginxg2_1() {
      if (this.xg_input2 == '数据统计') {
        var self = this;
        this.isShowxg2_2 = false;
        this.isShowxg2_3 = true;
        this.addRecord('END');
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
      } else {
        this.notify('<p>请按照右边提示填写正确的内容</p>');
      }
    },
    //重练-Excel内容编辑
    restartStudySecond: function restartStudySecond() {
      this.initSecond();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    // 第3步-Excel内容布局 
    //鼠标移入字体样式
    Loginzt1_1: function Loginzt1_1() {
      this.isShowzt1_1 = false;
      this.isShowzt1_2 = true;
    },
    //鼠标点击字体样式
    Loginzt1_2: function Loginzt1_2() {
      this.isShowzt1_2 = false;
      this.isShowzt1_3 = true;
    },
    //鼠标移入微软雅黑
    Loginzt1_3: function Loginzt1_3() {
      this.isShowzt1_3 = false;
      this.isShowzt1_4 = true;
      // this.isShowzt1_3=true
    },
    //鼠标点击微软雅黑
    Loginzt1_4: function Loginzt1_4() {
      var _this20 = this;
      this.isShowzt1_4 = false;
      this.isShowzt1_5 = true;
      // 显示居中页面
      setTimeout(function () {
        _this20.isShowzt1_5 = false;
        _this20.isShowjz1_1 = true;
      }, 2000);
    },
    //鼠标移入居中
    Loginjz1_1: function Loginjz1_1() {
      this.isShowjz1_1 = false;
      this.isShowjz1_2 = true;
    },
    //鼠标点击居中
    Loginjz1_2: function Loginjz1_2() {
      var _this21 = this;
      this.isShowjz1_2 = false;
      this.isShowjz1_3 = true;
      // 显示框线页面
      setTimeout(function () {
        _this21.isShowjz1_3 = false;
        _this21.isShowkx1_1 = true;
      }, 2000);
    },
    // 鼠标移入框线
    Loginkx1_1: function Loginkx1_1() {
      this.isShowkx1_1 = false;
      this.isShowkx1_2 = true;
    },
    //鼠标点击框线
    Loginkx1_2: function Loginkx1_2() {
      this.isShowkx1_2 = false;
      this.isShowkx1_3 = true;
    },
    //鼠标移入所有框线
    Loginkx1_3: function Loginkx1_3() {
      this.isShowkx1_3 = false;
      this.isShowkx1_4 = true;
    },
    //鼠标点击所有框线
    Loginkx1_4: function Loginkx1_4() {
      var _this22 = this;
      this.isShowkx1_4 = false;
      this.isShowkx1_5 = true;
      // 调整A页面显示
      setTimeout(function () {
        _this22.isShowkx1_5 = false;
        _this22.isShowta1_2 = true;
      }, 2000);
    },
    // //点击A列
    // Loginta1_1(){
    // 	this.isShowta1_1=false
    // 	this.isShowta1_2=true
    // },
    //鼠标移入ab列间
    Loginta1_2: function Loginta1_2() {
      var _this23 = this;
      this.isShowta1_2 = false;
      this.isShowta1_3 = true;
      // 显示加粗合并第一行页面
      setTimeout(function () {
        _this23.isShowta1_3 = false;
        _this23.isShowjchb1_1 = true;
      }, 2000);
    },
    //鼠标移入字体加粗
    Loginjchb1_1: function Loginjchb1_1() {
      this.isShowjchb1_1 = false;
      this.isShowjchb1_2 = true;
    },
    //鼠标点击字体加粗（第一次）
    Loginjchb1_2: function Loginjchb1_2() {
      this.isShowjchb1_2 = false;
      this.isShowjchb1_3 = true;
    },
    //鼠标点击字体加粗（第二次）
    Loginjchb1_3: function Loginjchb1_3() {
      this.isShowjchb1_3 = false;
      this.isShowjchb1_4 = true;
    },
    //鼠标移入加粗
    Loginjchb1_4: function Loginjchb1_4() {
      this.isShowjchb1_4 = false;
      this.isShowjchb1_5 = true;
    },
    //鼠标点击加粗
    Loginjchb1_5: function Loginjchb1_5() {
      this.isShowjchb1_5 = false;
      this.isShowjchb1_6 = true;
    },
    //鼠标移入合并居中
    Loginjchb1_6: function Loginjchb1_6() {
      this.isShowjchb1_6 = false;
      this.isShowjchb1_7 = true;
    },
    //鼠标点击合并居中
    Loginjchb1_7: function Loginjchb1_7() {
      this.isShowjchb1_7 = false;
      this.isShowjchb1_8 = true;
    },
    //鼠标移入设置颜色
    Loginjchb1_8: function Loginjchb1_8() {
      this.isShowjchb1_8 = false;
      this.isShowjchb1_9 = true;
    },
    //鼠标点击设置颜色
    Loginjchb1_9: function Loginjchb1_9() {
      this.isShowjchb1_9 = false;
      this.isShowjchb1_10 = true;
    },
    //鼠标移到颜色
    Loginjchb1_10: function Loginjchb1_10() {
      this.isShowjchb1_10 = false;
      this.isShowjchb1_11 = true;
    },
    //鼠标点击颜色
    Loginjchb1_11: function Loginjchb1_11() {
      var _this24 = this;
      this.isShowjchb1_11 = false;
      this.isShowjchb1_12 = true;
      //第二行颜色换行页面显示
      setTimeout(function () {
        _this24.isShowjchb1_12 = false;
        _this24.isShowyshh1_1 = true;
      }, 2000);
    },
    //鼠标移入字体颜色的A
    Loginyshh1_1: function Loginyshh1_1() {
      this.isShowyshh1_1 = false;
      this.isShowyshh1_2 = true;
    },
    //鼠标点击字体颜色的A
    Loginyshh1_2: function Loginyshh1_2() {
      this.isShowyshh1_2 = false;
      this.isShowyshh1_3 = true;
    },
    //鼠标移到自动换行
    Loginyshh1_3: function Loginyshh1_3() {
      this.isShowyshh1_3 = false;
      this.isShowyshh1_4 = true;
    },
    //鼠标点击自动换行
    Loginyshh1_4: function Loginyshh1_4() {
      var _this25 = this;
      this.isShowyshh1_4 = false;
      this.isShowyshh1_5 = true;
      // 显示冻结页面
      setTimeout(function () {
        _this25.isShowyshh1_5 = false;
        _this25.isShowdj1_1 = true;
      }, 2000);
    },
    //鼠标移入冻结窗格
    Logindj1_1: function Logindj1_1() {
      this.isShowdj1_1 = false;
      this.isShowdj1_2 = true;
    },
    //鼠标点击冻结窗格
    Logindj1_2: function Logindj1_2() {
      this.isShowdj1_2 = false;
      this.isShowdj1_3 = true;
    },
    //鼠标移入冻结至第二行
    Logindj1_3: function Logindj1_3() {
      this.isShowdj1_3 = false;
      this.isShowdj1_4 = true;
    },
    //鼠标点击冻结至第二行
    Logindj1_4: function Logindj1_4() {
      var _this26 = this;
      this.isShowdj1_4 = false;
      this.isShowdj1_5 = true;
      // 保留小数页面显示
      setTimeout(function () {
        _this26.isShowdj1_5 = false;
        _this26.isShowxs1_1 = true;
      }, 2000);
    },
    //鼠标移入常规
    Loginxs1_1: function Loginxs1_1() {
      this.isShowxs1_1 = false;
      this.isShowxs1_2 = true;
    },
    //鼠标点击常规下箭头
    Loginxs1_2: function Loginxs1_2() {
      this.isShowxs1_2 = false;
      this.isShowxs1_3 = true;
    },
    //鼠标移入其他数字格式
    Loginxs1_3: function Loginxs1_3() {
      this.isShowxs1_3 = false;
      this.isShowxs1_4 = true;
    },
    //鼠标点击其他数字格式
    Loginxs1_4: function Loginxs1_4() {
      this.isShowxs1_4 = false;
      this.isShowxs1_5 = true;
    },
    // 点击数值
    Loginxs1_5: function Loginxs1_5() {
      this.isShowxs1_5 = false;
      this.isShowxs1_6 = true;
    },
    // 鼠标移入输入框
    Loginxs1_6: function Loginxs1_6() {
      this.isShowxs1_6 = false;
      this.isShowxs1_7 = true;
    },
    // 鼠标点击减号输入框
    Loginxs1_7: function Loginxs1_7() {
      this.isShowxs1_7 = false;
      this.isShowxs1_8 = true;
    },
    // 鼠标移动到确定
    Loginxs1_8: function Loginxs1_8() {
      this.isShowxs1_8 = false;
      this.isShowxs1_9 = true;
    },
    // 鼠标点击确定
    Loginxs1_9: function Loginxs1_9() {
      var _this27 = this;
      this.isShowxs1_9 = false;
      this.isShowxs1_10 = true;
      // 占比保留页面显示
      setTimeout(function () {
        _this27.isShowxs1_10 = false;
        _this27.isShowzbbl1_1 = true;
      }, 2000);
    },
    //鼠标移入常规
    Loginzbbl1_1: function Loginzbbl1_1() {
      this.isShowzbbl1_1 = false;
      this.isShowzbbl1_2 = true;
    },
    //鼠标点击常规
    Loginzbbl1_2: function Loginzbbl1_2() {
      this.isShowzbbl1_2 = false;
      this.isShowzbbl1_3 = true;
    },
    //鼠标移动到%
    Loginzbbl1_3: function Loginzbbl1_3() {
      this.isShowzbbl1_3 = false;
      this.isShowzbbl1_4 = true;
    },
    //鼠标移动到%
    Loginzbbl1_4: function Loginzbbl1_4() {
      this.isShowzbbl1_3 = false;
      this.isShowzbbl1_4 = true;
    }
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginzbbl1_4", function Loginzbbl1_4() {
    var self = this;
    this.isShowzbbl1_4 = false;
    this.isShowzbbl1_5 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyThird", function restartStudyThird() {
    this.initThird();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "getFocusbc_1", function getFocusbc_1() {
    this.$nextTick(function () {
      var _this28 = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this28.$refs.strname_bc1.focus();
      }, 100);
    });
  }), "showLoginbc1_1", function showLoginbc1_1(event) {
    this.isShowbc1_1 = false;
    this.isShowbc1_2 = true;
  }), "Loginbc1_1", function Loginbc1_1() {
    this.isShowbc1_2 = false;
    this.isShowbc1_3 = true;
  }), "Loginbc1_2", function Loginbc1_2() {
    this.isShowbc1_3 = false;
    this.isShowbc1_4 = true;
  }), "Loginbc1_3", function Loginbc1_3() {
    this.isShowbc1_4 = false;
    this.isShowbc1_5 = true;
  }), "Loginbc1_4", function Loginbc1_4() {
    this.isShowbc1_5 = false;
    this.isShowbc1_6 = true;
  }), "Loginbc1_5", function Loginbc1_5() {
    this.isShowbc1_6 = false;
    this.isShowbc1_7 = true;
  }), "getFocusbc_2", function getFocusbc_2() {
    this.$nextTick(function () {
      var _this29 = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this29.$refs.strname_bc2.focus();
      }, 100);
    });
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginbc1_6", function Loginbc1_6() {
    this.isShowbc1_7 = false;
    this.isShowbc1_8 = true;
    this.getFocusbc_2();
  }), "Loginbc1_7", function Loginbc1_7() {
    var _this30 = this;
    if (this.bc_input2 == '月考成绩统计') {
      this.isShowbc1_8 = false;
      this.isShowbc1_9 = true;
      //显示另存页面
      setTimeout(function () {
        _this30.isShowbc1_9 = false;
        _this30.isShowlc1_1 = true;
      }, 2000);
    } else {
      this.notify('<p>请填写月考成绩统计</p>');
    }
  }), "Loginlc1_1", function Loginlc1_1() {
    console.log(8899);
    this.isShowlc1_1 = false;
    this.isShowlc1_2 = true;
  }), "Loginlc1_2", function Loginlc1_2() {
    this.isShowlc1_2 = false;
    this.isShowlc1_3 = true;
  }), "Loginlc1_3", function Loginlc1_3() {
    this.isShowlc1_3 = false;
    this.isShowlc1_4 = true;
  }), "Loginlc1_4", function Loginlc1_4() {
    this.isShowlc1_4 = false;
    this.isShowlc1_5 = true;
  }), "Loginlc1_5", function Loginlc1_5() {
    this.isShowlc1_5 = false;
    this.isShowlc1_6 = true;
  }), "Loginlc1_6", function Loginlc1_6() {
    var self = this;
    this.isShowlc1_6 = false;
    this.isShowlc1_7 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyFour", function restartStudyFour() {
    this.initFour();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "Loginfs1_1", function Loginfs1_1() {
    this.isShowfs1_1 = false;
    this.isShowfs1_2 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginfs1_1", function Loginfs1_1() {
    this.isShowfs1_1 = false;
    this.isShowfs1_2 = true;
  }), "Loginfs1_2", function Loginfs1_2() {
    this.isShowfs1_2 = false;
    this.isShowfs1_3 = true;
  }), "Loginfs1_3", function Loginfs1_3() {
    this.isShowfs1_3 = false;
    this.isShowfs1_4 = true;
  }), "Loginfs1_4", function Loginfs1_4() {
    this.isShowfs1_4 = false;
    this.isShowfs1_5 = true;
  }), "Loginfs1_5", function Loginfs1_5() {
    this.isShowfs1_5 = false;
    this.isShowfs1_6 = true;
  }), "Loginfs1_6", function Loginfs1_6() {
    var self = this;
    this.isShowfs1_6 = false;
    this.isShowfs1_7 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "Loginwdzt1_1", function Loginwdzt1_1() {
    this.isShowwdzt1_1 = false;
    this.isShowwdzt1_2 = true;
  }), "Loginwdzt1_2", function Loginwdzt1_2() {
    this.isShowwdzt1_2 = false;
    this.isShowwdzt1_3 = true;
  }), "Loginwdzt1_3", function Loginwdzt1_3() {
    this.isShowwdzt1_3 = false;
    this.isShowwdzt1_4 = true;
  }), "Loginwdzt1_4", function Loginwdzt1_4() {
    this.isShowwdzt1_4 = false;
    this.isShowwdzt1_5 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginwdzt1_5", function Loginwdzt1_5() {
    this.isShowwdzt1_5 = false;
    this.isShowwdzt1_6 = true;
  }), "Loginwdzt1_6", function Loginwdzt1_6() {
    this.isShowwdzt1_6 = false;
    this.isShowwdzt1_7 = true;
  }), "Loginwdzt1_7", function Loginwdzt1_7() {
    this.isShowwdzt1_7 = false;
    this.isShowwdzt1_8 = true;
  }), "Loginwdzt1_8", function Loginwdzt1_8() {
    this.isShowwdzt1_8 = false;
    this.isShowwdzt1_9 = true;
  }), "Loginwdzt1_9", function Loginwdzt1_9() {
    this.isShowwdzt1_9 = false;
    this.isShowwdzt1_10 = true;
  }), "Loginwdzt1_9", function Loginwdzt1_9() {
    var _this31 = this;
    this.isShowwdzt1_9 = false;
    this.isShowwdzt1_10 = true;
    // 显示行距页面
    setTimeout(function () {
      _this31.isShowwdzt1_10 = false;
      _this31.isShowwdhj1_1 = true;
    }, 2000);
  }), "Loginwdhj1_1", function Loginwdhj1_1() {
    this.isShowwdhj1_1 = false;
    this.isShowwdhj1_2 = true;
  }), "Loginwdhj1_2", function Loginwdhj1_2() {
    this.isShowwdhj1_2 = false;
    this.isShowwdhj1_3 = true;
  }), "Loginwdhj1_3", function Loginwdhj1_3() {
    this.isShowwdhj1_3 = false;
    this.isShowwdhj1_4 = true;
  }), "Loginwdhj1_4", function Loginwdhj1_4() {
    var _this32 = this;
    this.isShowwdhj1_4 = false;
    this.isShowwdhj1_5 = true;
    // 显示首行缩进页面
    setTimeout(function () {
      _this32.isShowwdhj1_5 = false;
      _this32.isShowwdsj1_1 = true;
    }, 2000);
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "rightClick_sj", function rightClick_sj() {
    this.isShowwdsj1_1_1 = true;
  }), "Loginwdsj1_1", function Loginwdsj1_1() {
    this.isShowwdsj1_1 = false;
    this.isShowwdsj1_2 = true;
  }), "Loginwdsj1_2", function Loginwdsj1_2() {
    this.isShowwdsj1_2 = false;
    this.isShowwdsj1_3 = true;
  }), "Loginwdsj1_3", function Loginwdsj1_3() {
    this.isShowwdsj1_3 = false;
    this.isShowwdsj1_4 = true;
  }), "Loginwdsj1_4", function Loginwdsj1_4() {
    this.isShowwdsj1_4 = false;
    this.isShowwdsj1_5 = true;
  }), "Loginwdsj1_5", function Loginwdsj1_5() {
    this.isShowwdsj1_5 = false;
    this.isShowwdsj1_6 = true;
  }), "Loginwdsj1_6", function Loginwdsj1_6() {
    var _this33 = this;
    this.isShowwdsj1_6 = false;
    this.isShowwdsj1_7 = true;
    // 显示加粗居中页面
    setTimeout(function () {
      _this33.isShowwdsj1_7 = false;
      _this33.isShowwdjc1_1 = true;
    }, 2000);
  }), "Loginwdjc1_1", function Loginwdjc1_1() {
    this.isShowwdjc1_1 = false;
    this.isShowwdjc1_2 = true;
  }), "Loginwdjc1_2", function Loginwdjc1_2() {
    this.isShowwdjc1_2 = false;
    this.isShowwdjc1_3 = true;
  }), "Loginwdjc1_3", function Loginwdjc1_3() {
    this.isShowwdjc1_3 = false;
    this.isShowwdjc1_4 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "Loginwdjc1_4", function Loginwdjc1_4() {
    var _this34 = this;
    this.isShowwdjc1_4 = false;
    this.isShowwdjc1_5 = true;
    // 设置颜色页面显示
    setTimeout(function () {
      _this34.isShowwdjc1_5 = false;
      _this34.isShowwdys1_1 = true;
    }, 2000);
  }), "Loginwdys1_1", function Loginwdys1_1() {
    this.isShowwdys1_1 = false;
    this.isShowwdys1_2 = true;
  }), "Loginwdys1_2", function Loginwdys1_2() {
    this.isShowwdys1_2 = false;
    this.isShowwdys1_3 = true;
  }), "Loginwdys1_3", function Loginwdys1_3() {
    this.isShowwdys1_3 = false;
    this.isShowwdys1_4 = true;
  }), "Loginwdys1_4", function Loginwdys1_4() {
    var _this35 = this;
    this.isShowwdys1_4 = false;
    this.isShowwdys1_5 = true;
    // 自然段颜色页面显示
    setTimeout(function () {
      _this35.isShowwdys1_5 = false;
      _this35.isShowwdtx1_1 = true;
    }, 2000);
  }), "Loginwdtx1_1", function Loginwdtx1_1() {
    this.isShowwdtx1_1 = false;
    this.isShowwdtx1_2 = true;
  }), "Loginwdtx1_2", function Loginwdtx1_2() {
    this.isShowwdtx1_2 = false;
    this.isShowwdtx1_3 = true;
  }), "Loginwdtx1_3", function Loginwdtx1_3() {
    var self = this;
    this.isShowwdtx1_3 = false;
    this.isShowwdtx1_4 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudySix", function restartStudySix() {
    this.initSix();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "listenThree", function listenThree() {
    if (event.keyCode === 13) {
      this.showJieDaiImgThree();
      event.preventDefault();
      return false;
    }
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "listenFour", function listenFour() {
    if (event.keyCode === 13) {
      this.showJieDaiImgFour();
      event.preventDefault();
      return false;
    }
  }), "showJieDaiImgOne", function showJieDaiImgOne() {
    var self = this;
    if (this.jdnr.indexOf('您好') < 0 || this.jdnr.indexOf('欢迎光临') < 0 || this.jdnr.indexOf('请问有什么可以帮到您') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.time1 = this.formatDate(new Date());
    this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p>";
    $('.replyone').html(this.replyhtml);
    setTimeout(function () {
      self.time2 = self.formatDate(new Date());
      self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p>";
      $('.replyone').html(self.replyhtml);
      setTimeout(function () {
        self.isShowOne = false;
        self.isShowTwo = true;
      }, 500);
    }, 2000);
    this.jdnr = '';
  }), "showJieDaiImgTwo", function showJieDaiImgTwo() {
    var self = this;
    if (this.jdnr.indexOf('亲亲') < 0 || this.jdnr.indexOf('正常情况下大概3天左右能到哦') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.time3 = this.formatDate(new Date());
    this.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p>";
    $('.replyone').html(this.replyhtml);
    setTimeout(function () {
      self.time4 = self.formatDate(new Date());
      self.replyhtml = "<p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time + "</span></p><p><span>在吗？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time4 + "</span></p><p><span>好的</span></p>";
      $('.replyone').html(self.replyhtml);
      setTimeout(function () {
        self.isShowTwo = false;
        self.isShowThree = true;
      }, 500);
    }, 2000);
    this.jdnr = '';
  }), "showJieDaiImgThree", function showJieDaiImgThree() {
    var self = this;
    if (this.jdnr.indexOf('请问还有什么可以帮到您') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.time5 = this.formatDate(new Date());
    this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p>";
    $('.replyone').html(this.replyhtml);
    setTimeout(function () {
      self.time6 = self.formatDate(new Date());
      self.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + self.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + self.time6 + "</span></p><p><span>没有了</span></p>";
      $('.replyone').html(self.replyhtml);
      setTimeout(function () {
        self.isShowThree = false;
        self.isShowFour = true;
      }, 500);
    }, 2000);
    this.jdnr = '';
  }), "showJieDaiImgFour", function showJieDaiImgFour() {
    var self = this;
    if (this.jdnr.indexOf('好的') < 0 || this.jdnr.indexOf('感谢亲亲的支持') < 0 || this.jdnr.indexOf('祝您生活愉快') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.time7 = this.formatDate(new Date());
    this.replyhtml = "<p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time1 + "</span></p><p><span>您好！欢迎光临，请问有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time2 + "</span></p><p><span>我今天下单的话，寄成都什么时候能收到呢？</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time3 + "</span></p><p><span>亲亲，正常情况下大概3天左右能到哦！</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time4 + "</span></p><p><span>好的</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time5 + "</span></p><p><span>请问还有什么可以帮到您？</span><span class='read'>已读</span></p><p class='session'><span class='user'>fanchaocdmc</span><span class='time'>" + this.time6 + "</span></p><p><span>没有了</span></p><p class='session'><span class='tjk'>淘金客服:001</span><span class='time'>" + this.time7 + "</span></p><p><span>好的，感谢亲亲的支持，祝您生活愉快</span><span class='read'>已读</span></p>";
    $('.replyone').html(this.replyhtml);
    this.jdnr = '';
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyThird", function restartStudyThird() {
    this.initThird();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showZdhf01", function showZdhf01() {
    this.isShowZdhficon = false;
    this.isShowZdhf01 = true;
    var $zdhficon = $('.zdhficon').closest('.con-left'),
      height = $('.zdhficon').closest('.con-left')[0].scrollHeight;
    setTimeout(function () {
      $zdhficon.scrollTop(height);
    }, 100);
  }), "showZdhf02", function showZdhf02() {
    this.isShowZdhf01 = false;
    this.isShowZdhf02 = true;
  }), "showZdhf03", function showZdhf03() {
    this.isShowZdhf02 = false;
    this.isShowZdhf03 = true;
  }), "showZdhf04", function showZdhf04() {
    this.isShowZdhf03 = false;
    this.isShowZdhf04 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showZdhf05", function showZdhf05() {
    this.isShowZdhf04 = false;
    this.isShowZdhf05 = true;
  }), "showZdhf06", function showZdhf06() {
    if (this.zdhf.indexOf('您好') < 0 || this.zdhf.indexOf('欢迎光临') < 0 || this.zdhf.indexOf('请问有什么可以帮到您') < 0) {
      this.notify('<p>请按照右边提示输入正确的回复内容</p>');
      return;
    }
    this.isShowZdhf05 = false;
    this.zdhf = '';
    this.isShowZdhf06 = true;
  }), "showZdhf07", function showZdhf07() {
    this.isShowZdhf06 = false;
    this.isShowZdhf07 = true;
  }), "showZdhf08", function showZdhf08() {
    this.isShowZdhf07 = false;
    this.isShowZdhf08 = true;
  }), "showZdhf09", function showZdhf09() {
    this.isShowZdhf08 = false;
    this.isShowZdhf09 = true;
  }), "showZdhf10", function showZdhf10() {
    var self = this;
    this.isShowZdhf09 = false;
    this.isShowZdhf10 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyFour", function restartStudyFour() {
    this.initFour();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "restartStudyFive", function restartStudyFive() {
    this.initFive();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showKjdy01", function showKjdy01() {
    this.isShowKjdyicon = false;
    this.isShowKjdy01 = true;
  }), "showKjdy02", function showKjdy02() {
    this.isShowKjdy01 = false;
    this.isShowKjdy02 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showKjdy03", function showKjdy03() {
    this.isShowKjdy02 = false;
    this.isShowKjdy03 = true;
  }), "showKjdy04", function showKjdy04() {
    var self = this;
    this.isShowKjdy03 = false;
    this.isShowKjdy04 = true;
    this.notify('<p>快捷短语鼠标点击练习完成，下一步快捷短语编码练习</p>');
    setTimeout(function () {
      self.isShowKjdyTip01 = false;
      self.isShowKjdyTip02 = true;
      self.isShowKjdy04 = false;
      self.isShowKjdy05 = true;
    }, 2000);
  }), "showKjdy05", function showKjdy05() {
    this.isShowKjdy05 = false;
    this.isShowKjdy06 = false;
    this.isShowKjdy07 = true;
  }), "showKjdy06", function showKjdy06() {
    var self = this;
    this.isShowKjdy07 = false;
    this.isShowKjdy08 = true;
    this.notify('<p>快捷短语编码练习完成，下一步快捷模板导入练习</p>');
    setTimeout(function () {
      self.isShowKjdyTip02 = false;
      self.isShowKjdyTip03 = true;
      self.isShowKjdy08 = false;
      self.isShowKjdy09 = true;
    }, 2000);
  }), "downloadKjdyFile", function downloadKjdyFile() {
    this.downCount = 1;
    // indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
    var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
    var downloadRes = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var response, blob, objectUrl, a;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return fetch(path);
            case 1:
              response = _context.sent;
              _context.next = 2;
              return response.blob();
            case 2:
              blob = _context.sent;
              objectUrl = window.URL.createObjectURL(blob);
              a = document.createElement('a');
              a.href = objectUrl;
              a.download = '快捷短语.csv';
              a.click();
              a.remove();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function downloadRes() {
        return _ref2.apply(this, arguments);
      };
    }();
    downloadRes();
    this.isShowKjdyTip03 = false;
    this.isShowKjdyTip04 = true;
  }), "showKjdy07", function showKjdy07() {
    if (this.downCount == 0) {
      this.$alert('请先下载快捷短语模板');
      return false;
    }
    this.isShowKjdy09 = false;
    this.isShowKjdy10 = true;
  }), "tirggerFile", function tirggerFile($event) {
    var self = this;
    var file = $event.target.files;
    if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
      this.$alert('请选择你下载的“快捷短语.csv”模板文件');
      return false;
    }
    setTimeout(function () {
      self.isShowKjdy10 = false;
      self.isShowKjdy11 = true;
    }, 500);
  }), "showKjdy08", function showKjdy08() {
    var self = this;
    this.isShowKjdy11 = false;
    this.isShowKjdy12 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudySix", function restartStudySix() {
    this.initSix();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showZtsb01", function showZtsb01() {
    this.isShowZtsbicon = false;
    this.isShowZtsb01 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showZtsb02", function showZtsb02() {
    this.isShowZtsb01 = false;
    this.isShowZtsb02 = true;
    this.isShowZtsbTip01 = false;
    this.isShowZtsbTip02 = true;
  }), "showZtsb03", function showZtsb03() {
    this.isShowZtsb02 = false;
    this.isShowZtsb03 = true;
  }), "showZtsb04", function showZtsb04() {
    this.isShowZtsb03 = false;
    this.isShowZtsb04 = true;
    this.isShowZtsbTip02 = false;
    this.isShowZtsbTip03 = true;
  }), "showZtsb05", function showZtsb05() {
    this.isShowZtsb04 = false;
    this.isShowZtsb05 = true;
  }), "showZtsb06", function showZtsb06() {
    this.isShowZtsb05 = false;
    this.isShowZtsb06 = true;
    var self = this;
    this.isShowKjdy11 = false;
    this.isShowKjdy12 = true;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudySeven", function restartStudySeven() {
    this.initSeven();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showZjgn01", function showZjgn01() {
    this.isShowZjgnicon = false;
    this.isShowZjgn01 = true;
  }), "showZjgn02", function showZjgn02() {
    this.isShowZjgn01 = false;
    this.isShowZjgn02 = true;
    this.isShowZjgnTip01 = false;
    this.isShowZjgnTip02 = true;
  }), "showZjgn03", function showZjgn03() {
    this.isShowZjgn02 = false;
    this.isShowZjgn03 = true;
  }), "showZjgn04", function showZjgn04() {
    this.isShowZjgn03 = false;
    this.isShowZjgn04 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showZjgn05", function showZjgn05() {
    this.isShowZjgn04 = false;
    this.isShowZjgn05 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyEight", function restartStudyEight() {
    this.initEight();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showTjgn01", function showTjgn01() {
    this.isShowTjgnicon = false;
    this.isShowTjgn01 = true;
  }), "showTjgn02", function showTjgn02() {
    this.isShowTjgn01 = false;
    this.isShowTjgn02 = true;
  }), "showTjgn03", function showTjgn03() {
    this.isShowTjgn02 = false;
    this.isShowTjgn03 = true;
  }), "showTjgn04", function showTjgn04() {
    this.isShowTjgn03 = false;
    this.isShowTjgn04 = true;
  }), "showTjgn05", function showTjgn05() {
    this.isShowTjgn04 = false;
    this.isShowTjgn05 = true;
  }), "showTjgn06", function showTjgn06() {
    this.isShowTjgn05 = false;
    this.isShowTjgn06 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyNine", function restartStudyNine() {
    this.initNine();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showDdcj01", function showDdcj01() {
    this.isShowDdcjicon = false;
    this.isShowDdcj01 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showDdcj02", function showDdcj02() {
    if (this.ddcjbz == '') {
      this.notify('<p>你还没有填写订单备注</p>');
      return;
    }
    if (this.ddcjbz != '顾客要求发顺丰') {
      this.notify('<p>请按照右边提示填写正确的订单备注</p>');
      return;
    }
    this.isShowDdcj01 = false;
    this.isShowDdcj02 = true;
    this.isShowDdcjTip02 = false;
    this.isShowDdcjTip03 = true;
  }), "showDdcj03", function showDdcj03() {
    this.isShowDdcj02 = false;
    this.isShowDdcj03 = true;
  }), "showDdcj04", function showDdcj04() {
    this.isShowDdcj03 = false;
    this.isShowDdcj04 = true;
  }), "showDdcj05", function showDdcj05() {
    if (this.ddcjdz == '') {
      this.notify('<p>你还没有填写地址</p>');
      return;
    }
    console.log(this.ddcjdz);

    //   if(this.ddcjdz != '双流区大林镇') {
    //     this.notify('<p>请按照右边提示填写正确的地址</p>')
    //     return;
    //   }
    if (this.ddcjdz == "双流区 大林镇" || this.ddcjdz == "双流区大林镇") {} else {
      console.log(this.ddcjdz == '双流区 大林镇');
      this.notify('<p>请按照右边提示填写正确的地址</p>');
      return;
    }
    this.isShowDdcj04 = false;
    this.isShowDdcj05 = true;
  }), "showDdcj06", function showDdcj06() {
    this.isShowDdcj05 = false;
    this.isShowDdcj06 = true;
  }), "showDdcj08", function showDdcj08() {
    this.isShowDdcj10 = false;
    this.isShowDdcj08 = true;
  }), "showDdcj09", function showDdcj09() {
    this.isShowDdcj08 = false;
    this.isShowDdcj09 = true;
  }), "showDdcj10", function showDdcj10() {
    if (this.ddcjyf == '') {
      this.notify('<p>你还没有填写邮费</p>');
      return;
    }
    if (this.ddcjyf != '10') {
      this.notify('<p>请按照右边提示填写正确的邮费</p>');
      return;
    }
    this.isShowDdcj09 = false;
    this.isShowDdcjicon = true;
    this.isShowDdcjTip01 = false;
    this.isShowDdcjTip02 = true;
  }), "showDdcj07", function showDdcj07() {
    this.isShowDdcj06 = false;
    this.isShowDdcj10 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyTen", function restartStudyTen() {
    this.initTen();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showXjrw01", function showXjrw01() {
    this.isShowXjrwicon = false;
    this.isShowXjrw01 = true;
  }), "showXjrw02", function showXjrw02() {
    this.isShowXjrw01 = false;
    this.isShowXjrw02 = true;
  }), "showXjrw03", function showXjrw03() {
    if (this.xjrwtxt.indexOf('此顾客有购买意向') < 0 || this.xjrwtxt.indexOf('请继续跟进') < 0) {
      this.notify('<p>请按照右边提示填写正确的任务内容</p>');
      return;
    }
    this.isShowXjrw02 = false;
    this.isShowXjrw03 = true;
  }), "showXjrw04", function showXjrw04() {
    this.isShowXjrw03 = false;
    this.isShowXjrw04 = true;
  }), "showXjrw05", function showXjrw05() {
    this.isShowXjrw04 = false;
    this.isShowXjrw05 = true;
  }), "showXjrw06", function showXjrw06() {
    if (this.xjrwsj != this.xjrwmt) {
      this.notify('<p>请按照右边提示设置正确的时间</p>');
      return;
    }
    this.isShowXjrw05 = false;
    this.isShowXjrw06 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "restartStudyEleven", function restartStudyEleven() {
    this.initEleven();
    $('#studytip-' + this.tabCurrent).hide();
    this.addRecord('START');
  }), "showTcqn01", function showTcqn01() {
    this.isShowTcqnicon = false;
    this.isShowTcqn01 = true;
  }), "showTcqn02", function showTcqn02() {
    this.isShowTcqn01 = false;
    this.isShowTcqn02 = true;
    this.isShowTcqnTip01 = false;
    this.isShowTcqnTip02 = true;
  }), "showTcqn03", function showTcqn03() {
    this.isShowTcqn02 = false;
    this.isShowTcqn03 = true;
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "showTcqn04", function showTcqn04() {
    this.isShowTcqn03 = false;
    this.isShowTcqn04 = true;
  }), "showTcqn05", function showTcqn05() {
    this.isShowTcqn04 = false;
    this.isShowTcqn05 = true;
    setTimeout(function () {
      var $left = $('.tcqn05icon').closest('.con-left');
      $left.scrollTop($left[0].scrollHeight);
    }, 100);
  }), "showTcqn06", function showTcqn06() {
    this.isShowTcqn05 = false;
    this.isShowTcqn06 = true;
  }), "showTcqn07", function showTcqn07() {
    this.isShowTcqn06 = false;
    this.isShowTcqn07 = true;
  }), "showTcqn08", function showTcqn08() {
    this.isShowTcqn07 = false;
    this.isShowTcqn08 = true;
  }), "showTcqn09", function showTcqn09() {
    this.isShowTcqn08 = false;
    this.isShowTcqn09 = true;
  }), "showTcqn10", function showTcqn10() {
    this.isShowTcqn09 = false;
    this.isShowTcqn10 = true;
    var self = this;
    this.addRecord('END');
    setTimeout(function () {
      $('#studytip-' + self.tabCurrent).show();
    }, 2000);
  }), "dateFormatString", function dateFormatString(date, format) {
    // 时间格式化
    var date = new Date(date),
      o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds()
      };
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return format;
  }), "getLastDaysFromToday", function getLastDaysFromToday(n) {
    var lastDays = new Date().setDate(new Date().getDate() - n);
    var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
    return lastDaysStr;
  }), "addRecord", function addRecord(type) {
    var _this36 = this;
    var data = {
      exerciseType: 'SOUGOU_INPUT',
      stepSeq: this.tabIndex,
      exerciseAction: type
    };
    this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
      var result = res.data;
      if (result.success) {
        if (_this36.tabIndex == 2 && type == 'END') {
          window.parent['goBack']();
        }
      } else {
        _this36.$message({
          message: result.msg,
          type: 'error',
          center: true,
          duration: 1000
        });
      }
    }, function (res) {
      _this36.$message({
        message: "网络繁忙，请稍后重试！",
        type: 'error',
        center: true,
        duration: 1000
      });
    });
  }), (0, _defineProperty2.default)(_methods, "inputnr1focus", function inputnr1focus() {
    this.inputnr1 = '';
  }))
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-1.e20f637.png";

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABvElEQVQ4jZVUy23CQBBdLxzDRwogJbGETQ75XECiAOykAUqgBG4coRTogA6gA2ggMUeURIIkZ7zxm2GMzSchT1pmf/OYebMe6/reN1prZYxRlmWpMAxTFmebzUYl78AKZD+Ln8+3F9rEJYAd9NYBY+fMd4SI54XKrcrKxtf7qzoHi8VCFYtFGkCu5FL0Ov0PDM/z4nm73Vbdbje1HgwG8RruxAGNLi4dkwRnx5jNZrQOgsD0+31TrVbNarWKz3Mlx9w8PBllPz6bfNmlTVzchkdjMpmk1vtnAIIAhwKbEB2LCA6tVuvoGUfkEpHGWRimNfoPIA+JLQvBeDwm6ziOmk6nfxIhELylLFeNmVCt+XxOc1TG9/3EP1sHc3lbZKERlJcK7evQ6/VMs9k8qRH0vbrzWCNBo9E4CH25XCrbtn9NLZPJyIPchb1er1W9XieLNEejET3C00RbsSGU5DwcDuOoQALNotKrTqdzkkhr9tX4siU9VApOqBYIEYlUURA92oPUAAtif38EUQc476PdR75ci4bLbQSjUKkpJjdkOVsOG/NdL0rFQ2vqR8KarF6ygUlzY0KLmhxs8hz4AfoQbU7wdDkCAAAAAElFTkSuQmCC"

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-2.fc29e83.png";

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA1klEQVQokZVSyw2EIBDFbUAKIMEONKEAS7AES/DI0VJswQ60A0uAozdLmN1HFgLu4rovmcBk5jGfR0EvsBuw1jLOuTMHitC2bbh3XUfDMAS/ruvET4jxO9u2Od8YQ+M4kpSSjuNIiQggyduyLIl/jl1WRELc+mkqetxZzDcE4jzP7qyqiq3r+pvpt1mWpWtnmqbsfN7CjNjgeQ6tNSmlrmdsmuajk33fmRDiulUAGkFknF5DtJ2r6DwkQGAQIQPmjaXIEpGMT4BqsL7vk18CIB6jeL/2N54QTYHpS1axTwAAAABJRU5ErkJggg=="

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-3.06aeb31.png";

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qh1-4.badee6d.png";

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAoUlEQVQokWP8DwQMZACW7de/MqStfMXw5ONvsIAMPyvDrHAxBk9NbgZ8cowy9ff+wyRgAKTgcYMig2zDfQZcckzoEiAAE4PR//vVwBhZjIkc/4H9CLIam63IgLHwFopTwTaCPAvjEAKwwAEbRrXogAFQYCA7EdlGUHQwYdOEC4DUgdSDANboIKQZrJEkXUiACVuIwsTwyWFEB3KQ45MjOzoAn/NhcRq7lkIAAAAASUVORK5CYII="

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jp1-1.5ea453c.png";

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAACTElEQVQ4jXVUsW4TQRCd2VtbsuMCbBAVFfQ00CAkqJCAiiY1DaIgCgW/AV0kRIUQBSUV5gNoqGhSEkSRKkWIC4LF3d4Mb3b3znexM/be7OzsvZ15O3MclgdKJGSimHGc2MORWUxFnHP02FqRB+d13+71QbNDI0IWbgFc1mpP7I3gCpvTHtOc3/IKp2oy3Y99Gn7+QPxnkSKdXKDw8AnV126Q+7lPfv4OvpP05mRK+uAZ0fWb6SCAOrFTGYAAHXSAYnyYF/P3JFL0gaLvN/GXt0QBgQQcjOGFXeRI8XMdoEYcANTSy0D/Xn5EFAUNX21HQBHOfIKzSj026xpIV+yFdo4MnBStrdKwDDBzSjSU6slFKjqpNBJ0BTZ6vb0C2pqShHRJ8V9iYwVHCbjFo6cR8KzUnUhaoPGUqnvPSWsmqWFXiO3wdJGTTOXGZmCDq9NLXnCu8VJbaTANNFeVJtvKxFl5gHsfkGagVFnjg+90ef6GPIjtytHOJ7qy97jP43hG5Z0d0qsoDc5pVngKRlBHlzYARc5kbYnc32Maft3DBaBwLQuk6cucod3KYANQcvPGdbc8zp1otQpKamsJattzo4i4850h1Zh1pQuYCFI00HIyW9tbgRurszBe98lolvrUwkqXVlAJ2Arj1/1dKrdmPaCju7vxoJPb0KNZD2h56wXo4ZSVVcK300ojgbYAXSDjAhrXHEtiWCd7gOHUNBs3xJI+Tp4oN1P8anDD8kpp0mlw/Do162SRnNN9npsL6F4Yp15rTuz5HK1OOiP/AbNlAgitjmrfAAAAAElFTkSuQmCC"

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jp1-2.3b724ee.png";

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jp1-3.853dd3d.png";

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jp1-4.5e99001.png";

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAAAiCAYAAAAjzOVkAAADXElEQVRoge2YP09yMRTGD+8sEyzoQiDRzcSBTyBsYJyUOOiig5MJasJCQpxhhYCTDhoTMCY4+hl0ZjBxUgc2HEmufU7eNqXeC17o+5qY/pLKpT399/T03CMRT0AOK/z56QX8JpyYFnFiWsSJaREnpkWcmBZxYlrEiWmRXynm3t4e3d/f//d5ZxKzXq9zAU9PT3R8fMzP2EA6naa3tzdlizpsTgL77e1t+vj4UHX65vEZiUR8iy7QNMEKhYJvf/QLGt8s+rq/hTcDpVLJe3x85Oder+fVajXV9vr66mUyGdUO0L67u6u+o4/8jja9v5+NPvbBwYE3HA65DTZ+TGozwTq3trZ4zHkJLaa+IQAhpi0ctmdnZ9719TV+BwgschzYYw7Mhc3i8My5dcHwOWlcfWyMkUqlptrDBrZhCH3N39/f6fb2lqLRKF+Fk5MT3yuFks1m+TovLCxQpVKhYrGIw+MiBCEhDIkFq7p8Ps9ztFot2tjYoEQiQWtra7S4uDg1BopDVeOYBW066+vrPL84KBIHpezEAZEQndckxAwrTfiYic0NBgOeHJNCECzMbxN3d3e0ubnJwsoYOw3E20ajMXZAOLCjoyM+yCBgExT70BbExcWFsru8vAwrxxhzvc2vrq7o/PxceakZ7OGRDw8PfNoAgsp29EFfeJ0e8OGNz8/PyqPQF8+dTmfiWsJ4pg7m1D1zHmYWE9e33++TiIV8XeSC4K3iBURLS0tf+uCtr19zEfjH+sJL8LaPx+NfQkgulxvLEkxm9UybzCwm4trKygrt7+9Ts9lUqU65XObUB+EgCAiWTCZpNBrR6ekpi4c6oIcR3TNRFzQmYq3piaanynhs8uPXHBu/ubmhnZ0dvpaHh4csDha0urqq8k4TmUNCwJeXF+p2uxwG8Iy6aXEVc7XbbQ4fEr+8EZ7o56l+eaPNaz5TaqTnkTLViMVi3vLyMn/qOaaeinw395Mg7aK/qYo5rl8uiTrxpvaq1SoXPJs2/zI1Ci0mFox8EQv1mxQ5oGyDrUzwUSDIpA3AXhcQ4+jJtD62nBd9pL0UTv9HQG/Hs5kn+wEbkdaFFjOCP/P5tkPyK3/o+CmcmBZxYlrEiWkRJ6ZFnJgWcWJaxIlpESemRZyYFnFiWsSJaZFPLs2Vl68cW6AAAAAASUVORK5CYII="

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jp1-5.450da4d.png";

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-2.32d1868.png";

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-3.464fb57.png";

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAwCAYAAABJy8k0AAASPElEQVRogc1aCXgV5bl+Z87M2UJCQkKAQEjYguwJi4gKIqveUkVrqUsvYkV9LC2odeOpXvXWetVWTdVqARWty1Xv5aLeel0qIoohIWACshMoS0JWyHJy9pn57vf/MycEqNbbOz71zzM5Z+b8883/7e/3/aNYlklwYSigrm8g5eR32KcGf3pMC6onyZfjwLH9iNXXwV84DMguAJGGOHmhqYCaupO6USGHNCw3lgvNFSpyOKskZ9nOQsFyVYwEdJ2va8x03W6gphJoPIBwUx2MgwPgLRgL75AJ8GcPAxkKDCJ4hABUDZbDp6J8xWP/zqG4q3HFYZz5FR+8aA/F+HIYaKtnhqtg7a+E2VwDXWMb8OuIRA2YaX1APYUAiuEfNQUI9OZbvYgmCD6vByqTFgeJZyiuLNc9xiUxwbjlqEZQFRpO1AFVHwK1e4Dmg2zzrSwNvk6CCZaOovN3D8DWH/LnwswfA39BCfyDioG0XKZnsKvokjqRxZp3R/WuMc4Gzb7p2CUlWOWdrOHNMPeVwdNaAyPUDM0nHsVMm4bNsOWxBWWarFL+VAIIWUEYgX7w9x3OzI+CMpIFoAaR5Fs8Hq8tXBeGa4ybzLZmsdqojQPXTpg7y6E27IESbeAVRxwTJVvTFmuafA7jYhWmLSyFQ44aYGJevhhEJK03YvkjoBdNQlrBaPZ9DbqiurFc94JbkvnRPKyNui8Ree9ZBD2sogRrXTVt5uCxJ5I4Ue1oJbQsfpThwRECGc6cJIKRKCI7GnGkNYZRhRPtAEffsahupf7HGxFs3Qv0ymLqms2g5RUmwUOXh8U+HWcTtyxiDXIYUy2bYcURipzMLsEWlOMhtEXaJPVE0pIk3RiuMd7lL2LxQrmUivCm7dOcmoR5N+t9ESwchzSRv4N+oLUWxo5yaMeP8NxoN4KKTdVKsmEYko4qrdwdH3cxjztDLli1/dVQ7HV6hKa9aFczkDl+LvSRF/A19mUvH30aoQ0YAnzwmh35BYKxTIcG7LAgkzmHT5f8WwzXGD+pB49NVgQxMm1BcMDqjKnwDOZANbgEZiBHzjKFcag5QAafnH0ha78JCHO6Uz22CcnDI11D0LWtyp3s654I5VBsTctUlYrgfNnSEOJIrWXnA1l56CDbi8VBKs81OMJn9WPTz3QivYj6mu0q5AhSitY9+OYy47AXKhYNW0uphSv8XUBQOSWFwRUZwmwhCXcQyTqVAUjpOiwHFLkJW91nPJWrU9oSFsAAJZ2jc7ThEMOzFvRS7SCuK8Lzeeh80lzLsS0CO4I52iX70y3Q0n24xvhJzzMlzISp2GYrtGcmkabGYdTtRWxXORA7zjbAGB4MWsCpqvMoULmeU2GIp2uysLGJ2kIkcg1Vdw33o7odxm1AkiowFTstZXsSqKtch/TjLcgoGsnq5jmhJkS3boC35Qg84h7p+IrjD5adHlUbJVCq4nNhuMy4IgMZEoqTwsjG4ZIRZioZR3+lA+bezxHd+bEUhs5CCXgcw5O4nZz5Dh5ga4mbIr+LaOBxbaWuMW4vSZElZTy3CHoyzIpKQBbWccbwUvtJySy7OwJ2uHeivpMNZFCzHHNXWQZ+tKVnI5OLFYH4vIKES5DV/SLFYp+t3wOrugzW0T3QuCqTeF0wI1OcZTNqOUBHDicgijkihzPTIc79SuFI6MMnwDdumqzcxO2KSx0Y98tSRZikMO8wsPsLmNvKoDQcBEVCzJdYuUhZlpP2PLZpax5ZsIj20wlvBoye/ZEzfDw8JedwTc65HT4bBYpsoHzHGO8iKJm2JMxUBENRRmOb2Z+PcuHSeIjNvh3S1sVTDSfy+3yIJZKI5hRAG1SM9JFTgIHDGdlZnBxMTnlO3c7xgFwKbq4zLuMSq8aUxE3oZtzuuLSzAGq28bEdiUO74RVwls06wgYQz8iGZ8BgZIw+Dxgygef7EXUyos4867L1ZGPY7yzjJ0G2YhcVErY6Jafw9YYaYOdm0OEatHd2QOvTD/6ho6GNYIaD+XZG0J0UKNtN6Na/TdH+/w8XGT+9hEi1lu2GlLAAjSO6JjotKgui7jDQwYEwbwCQ2ZvRqgKDY72u2Q0Jlc8UGfxUx4pIMu4WhnOZcWd53UF1t3a7KqyA/ZafyeW51/mBzznXqx4b8MjYIAPdScTmVoOx+/gWNK58jR/a2FvMlDjFEv1zLl9k3U3dNiW+/eF+cAO+knGFTiLOlBa/DRz+Tca3gNW/fqTgdpcZw61w9X8b30JZ+jVDObOd8I/Rd1dj61TbPNNSla+4fnrwoW6Hc6fc9VG6Lp/OtI3Y7R+7+/ipAe1McZ26Fjpt7t/u16hETrHQ7eZTz+wrskvcfVGCCS4juzcAyUk/KUNK+bTqbCaoMq/bvyuSTUlEUJf3Uuo+h2nLOglPxTXxLPmLkyJPsq92Y5m6eOh29xmMKyRCq51lv0Y+IrXYe1hqF3HOu2LHl3Oyh4sLE045eYpiTI7YDhMCfaUMzKFhIM6LE01EXeKb1Bbx1w9CXHRhVS3V1uxmZKaUtikFY/dtPLymrn1GxXQoKIwnrCiXzEnOpSxNLgMt1qKlmnIfWujBI2AnU4gzAfJp8DEjTl9A1hYCdsaTMf7wI6V8JztJRi0hHUFL1uewmy6qKFCTiPBzBRFBRncQWsKIw0wkpHUkZYkq1iXmcPXnmJDlszFAqjonZwNdEfNFnSCtU5UASLZCumGJLlRJFCaxT/VNh2jta5LxCFOPMoMZUHQdMcNZiWVv6YrWmXigJ7VzxAJQxMlf6Y3LFgNbhyqrNtah9rcBi2hc+eWC2AJYk8Ta8IuHMxhKsnIMtk6FDyFuj+msQXatLaQ6/7j9tqXIzcnBmJGjUVg4DIOHjcOIUZNQNHQMhg4pwbCiKRhYWIyVz70CK85mzw8zWTPQAjhU24hZsxbiYE0t/EzRz8S9mk1Z8PllxRZ8tPZtrtR0KfEP3nobk8dPRGFREQaNmoz+w6Zjw4Zq1rCo02Movf9XmMzYfQQXLSVjilE4tAgDhw3FiJLxKDxrAn8/G3fd96jDtKjzLS5kNGbSK60VWhqfBxBQdSk/iVI0+xDFoKGodmwg5qSjvYGO1f2FmptaqK0tRl/uPEzL736Qdm0/QOEw0eF6otoGk8KhBFEsRpTgg8fKl16m7PxR5M8aQgP696eCgX2pR8EEyhg5l55Y/ZqcQ8kwvfLIg/TUI/fI0988uZru+OUDtG9/OYeNJM2ZuojWrvmcTEqKybT8xmW0a8MXFG0M0Q/n/4h27DlA2/bso+LJU+loC9H68qO08Ka7bNKxdkpGW+mpF1bRO59+Rofq6umm639CS2++lhYuupoeW/UihZhsVXklrXr2OTp6PEZRvi9miMqfJRUOh3DLsltRtmk7Mnv1QTSWYD+L463/eB1KoDdawgoW/Xg+Hr73ZmnOyY5OzPreLMz6/hXYs3uH7evRFhn573tqDf78WQWWLboKsdbD8GcVYNqci7GpqgwtJ5pQtXs/ppwzFsOGDpJq6NsrQ5bnqlQLm7vXj4XXL5ZvVLTHIph/yeUyEcSiCcy+cBY6oyYumjdDvEfAVuTHls2bEIlE8P2p5+OjDZWYMPE8XH7JdKTn9MaDT63G62++icVXL8CXu3diy/ZdmDG9RFqlQFC0Y0cFLVt6E328bj3F4iZtrd5O9977L1S99QsKsXIff/4jum35I0TxDmqsPUjF48ZT+ecbqWLjOvp96eNS+gfZLOZe8kN64DfP2pqOdbBKQnQialILGwqZJi2YP5/u/NVj8ucT4WPys/ShP9CoIRNp3Lhi2rZtO88jam+K0LFDzdR+Ik6Pl66gFStfoeNMpPZomBqbiRpYba187/76Dlqx+mXasmuHpPXJxp300uq1ZIY75Pn6rdvo30pLqbVuNxtpiO56/AWqrgvL30RXDxnBHjhy6DCuu24Remb1Rke4kzUewxuvvQ6k9QXTx+IrL2IpJZGb1wdbq7fKVkOypQ6VG9ZjYJ9c5I2agmdeeBVjC3tIzcGXjoO79mDh8oewe/8+rHnsHryxdi0a2+Oo5UO3PGhNtuO6n9+En956E3R22opPNmLi2Emob25BVu9cRDm6+zhw6mxKpY/+ljXsQytrN8lp5o7ld+PyeT9AQ2MYAwfky+BlJaOcnZIc7yy5USFKXdHHC3PWyfT1gGZaiIc6IYK56O7BjMYxqmg4lt5yJ6acfyE++HAjPv14HRb/ZCEGjBiEFa9+gnDdDrndmwy34mhbIzrrW7D02uuQmZ2GrV9sxm0Pv4BzZ87Dxndewll5PZmsH9n5Z2Hj239E6dMrocSOYW/ZnzB9wR2wOPX5rOPQghk41m7hezMuwOrfPoDJ087HlupK3Lx4CRYuW4ohHNji7e2cc7lS9/tw5HgnHv3dk7jmqpm4eNosbNpSA68nHT3TM2ScT/fFWTdtONHWAj/n+YqKbejbtwBZ+YVSMEHDgNoZlt/FzhwyAj5Uba7A6tfXIJDRH62tSdk0eOs/34AVSMfRExFcd8UcKb11H/wJt95zH2ZMnob3P3yffXYvpsyYB8OXiaL8XFy/eDG2V5ajZMIUvPbqa7yoHASVOEKmjgvOnYclN9fg7InnYs7cs+UCbvjl4xjcPw8ZebmcIe23JxqP1WLBVVcijS3Ry+lJ4+Svc6poTfhgMh64/scX8J0hGYfS0rPtbShE4WecUVVdheo9VWhui2He/EW47NJpHMqbZZbp04d5a+uUiE4zOSX0ysrE+LGjMfuKa7Ds5z/Duk11iLY1Yd7cEnnDR59vR3UFaz0UwUWXXYaZc2ejZscunHfhOTDTC/HG/5RhwpAMJONhVO2txzMrX8Wc6efjrKE5oEgY/oAHf64+gM7gu7hw+lTs216N8o/bsPtoE9KDAVx59ZV27zEShZ7mR3p6EM+vXImBBYWyJ88QCV6/jvoThBdefJVTqiFZ9QeCON52AhHWZJBTaycL7pxzZ+LqhT/oyvdWgrUs2t6MkPYfa0FRyWQJajSPyK+ZefjXp1bh6muuwRUVu1BeuRdLFi/EvItL5M2zzhsrDxsFhPES+/K6dR9j6/5a/KU+hGEjJ+GPzz7IWWA16toIL//7Oxicq0kX8gS9qK89gk/eX49lS5ajF5vloYP7cPtdy2F4fHj4yVUYlGmT1nN62I/gvzt/cRt83gCjTEOAVI4BGkd0lYGcH7ctEYylM2Q+jGSkCZFoBEGmG45baO0IIxQ15D6GT8BaAQljAhjF2dfjSDjtaQ1tDajafxihWBI333gD/rDqFfTL7YmtW8rw32sy0K9vNjjQo5ODRk8BcoYOx7Tpl2Lq3AV477MytDacwOzJY/DGm/+FJ37/Igb36y2RmNwfYBeKh1pw9oRJuGz2peioqcHS0iexqXIzHrp3Oaq2bMYDdy9D+Be3ID+vN4IMOsKtnYizlp5fsQpZmb3YZxMw1AQ8PhXtbSE88/QKvP3uevgW5GD40IE4MLQXDh44iJziYgTSeyK/YCB0XYM/VXoYjJED2Wipb0T/vCwUFvSRl5Uj28rorl8/gepd+3DepPF4+uln4Qv65I+Lrl2I6qqtyOQFdCQNDB8zDvffuRxLr78RDR1tiHE+nHkuR/MnS+V8BnVsmRbS/KpTFpqIRToRCPbE7k/LsXjJz3D7I7/GZf809xT4+c/X/AjhRBTjR43FpnWfseqDaGLNGWzSokWd4BgRZa37NS/69c5Da9jC7DkX4eH7b0Vl+ad499NNWHTDT1GYlS7pydY2nE2rRAgqR/XSZ55D8bSLMXVyMddOCYHVE2S/jWSPJPuUyriZGG9quu9MkPxXRmeklUGICl3jNOFj3G7aRYjCh5f/VIPhie8kRu+MtaOHNwiDgZLKAVP1fbPnnD7EqyQqF1Rvvvc+AoEeuGT6BTDDUahpAURYYCaHMQFdKzaX4XhTM2bNnI1gwC9FowhImYhzTrYU9gcdfr+9CNOIsRZMWXOLMKjpXll5CDxuxqJcrFjMluiOKgj6/fKNBzFPvtTA80wlydO5uuPKQGcaYpGxeAw+JqCp4hmpV7s4PovczFWezt7sTbLAeLGmorHGk7JKN5g5gwsRUbFpXHiYlgqv18vPFTbFpW+qTrNsXctNV4nJRQ3DgU9J2b3Z9Vyu5MTrxd2aCbK0E5e6Xp4+bZy5SU2pl/TEL84D7RBFdlVMp3ZpRHs5tdkgr/+dbzNZshXNpWxCvlDCwdDb1cvrqkRFpcaVoWg76HrKsgn/C1zHoLmw7zwSAAAAAElFTkSuQmCC"

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-4.e5d1a0a.png";

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAQCAYAAACYwhZnAAAEAklEQVRIiX2V709bVRjHP7fhbxggmZi9nzERLKAuIXGarYxhsmKaqIDZxgtbDQ4Y6vAFVNcynINiIoNoMTGd9M1g1MTFxARwqVkXHL43q6OO+XJGx5v1+Jx77r297YxP2txzznPOeb7n+/yy9h78rbAstJTLCuyhfAmYoYyV0uuWM9dLZm5/bbHM3DI6hVlXj6ByyLlNlbHcc47dQGWXt9tRKheCUfnUBCwPmNmvPFX5kZwoY//Bu8Ze0Mb917gPClC1d5vp3gTZP2p3yno4wXLJ3SeseADkW/iao6PX2ak95khpJUls5f5/K+V8nYegCmKFCUP70wyP/EJoaIkns/20aRZ8Z/L5Agfax2mS1++sJhnMCFqa6Is0spQpOHd+QuiKfJq7mE8cFq1jR351Pl6qAcrrL/Qu8GMN8IlwwRt3jqQYaf2VjXX4jUlCGTF8cYy11uvEZqDj+GHC3W8IE1Mk6SPVuk101lgyb9CPEVb3Hvxjh0l+LsrEus/aoRY61+/RPDNG+AkXtWWCSv75VIyN4CyRUpKE9Rap7n22XsdKfi7GT20nYXrxsUfY0nyM+aSwoQwU6+FfD5Ub5YrbEhPf0fzZ+/TuxwSfNn4zTWgKPsoOELSDS3nEaYMTG+7tLZwbhnj+GdaiBz1OdUwkGSD13G2il2As6bjDsVtnxs6NbpgW0kQLR0j1yOu4T3a5QOfoHG2u03yZGXx7jlxQQGYbmZ96mbvCEJsFujab6I80kM7ccjbHxV2GBb/YSaaZUGWTTz9/HjMuOXSa3IldYu+siq//R148xbhaYHKzstQ5PMuZZ7f5NLLFC5k+gpZmIkFC9cuj6p3X+2qKB8L2cZTN9lMwJe6Y+UDiQBkWRr6EIZk3mhxXpe+JDd3j9W/7aHPr1c0lw0TiIDfGluDdI/w+s8vz7VvEr5RqkIvLMm+KW/GA1LnUtsXmaA9IRvi251OTpO8IrWWXfwF16RpEPrRjw7jGn9v1dHTA4HuLNkvDPa+Qe1XS9qqPCccHbr3RYlLUi/pqzBpYLrpLdjRK6E7FBbmeBl/Jrsjd1R+wegbovxGnGKwnezZGuuhqP6ZL1wldPy6e5URDpQ5V6kTA8gWcv1j9SdEB0Bk5RjGzQGhD2JGLwk0+ForXiO8/yfzVr5jUhqfjHIiMk5vaZ5jQ2SFp7EH3vUFiYk/pplJaOc/pb8R/T3Vz+UIDmfBlJ8dbGF8W/7tV1GZAyvhrixQj50gdr2dHAm9w5yhrwS26pmFcxwsmfSc3eFwkQ744/5JJU8syIOxuo5lwmo6yVFUamkVnzeu0jtLpnsrfnLzmJhXFyTxXWd1ZTXQGvBrh48eq6XW1TdSTgG+1NkRq5lUhVKP7F+mUyA2ccLgOAAAAAElFTkSuQmCC"

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-5.6b2cffc.png";

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-6.977c7df.png";

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-7.8fe261e.png";

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-8.4204d7a.png";

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-9.ecc5cc6.png";

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjtb1-8-1.ade9bcb.png";

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-10.e2c4df9.png";

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAQUlEQVQ4jWP8//vXfwYKAQuI6Ju9lizNRanBYJqJUlfAXYJuMiGA7nKquGTUkFFDiAEoKZbcPEQVlzBSoyigiksA6NsP421YzFEAAAAASUVORK5CYII="

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kj1-11.fca0dc1.png";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-1.eaeada6.png";

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAPCAYAAACFgM0XAAADh0lEQVQ4jXVVS09TQRT+puE/iMVH9AdYDKgs1MhGYkBwISK6qMFEjFhNRDGoqAF8ECxGEwiwwbrQEkwU6yNqjEYIghQRlm60YBE2PpAWNLHHM3fu3E6xTDK9Z86ZOY/vfDMV83N/CNYgEAlQIqGWQsgfJeIvnEHaxiIlUtassI+4AOlHuyBSAknRDif3OL8wnCwaRKO4tqcKvgczpjLtXoQDKKp5jmhaR06gFLVIIjCN7uqLCETS+15yrC5GR9N2ZGEc/r2PsarlDErdYyx34tUS+9uv8n6dkExAz9jPBYrN/qbYy3bKvzTE8gLN/ZynOOvj8jsr5wJ9DNTRwdsRts9b9tiPuKWrCHxmed6ecXrZWEH1L+IU+67mx1t1lN84SHMsz31TM0P1UKdjfPs6UNS3dOFry41OhG+hcrIQj45mAsNdKPJPweuvACbZtkmfmMHAW8B7bB2sNtidyFBEETaBkgZsqcRjX7ZFylR6CHzpvYwmIod0g0NhoD+Mon5p34BzwbPIS3xFD68+T0nuLAMNP0VgZSFCbuH4kedtDhBIM9RhrctiKGk2GwnoPQkNgZXhDO7dn0bprmylkwnUNiAA5gj3nHqv4HAwavCggHkjGAENu+WMyVPakZ48aQdXe9fLKHPw0/UWgQNBGaCEielRWyIPERwpwImSWoRKBKISPXg4uG6BU5iwc1kB7/VaZrKASxh9Nu+4hCbxAc1l79U5CS8H33ayDSdz9L4xTESy4C13I9DzDGW5XDGNIcgJbvVnOmGTCTgoaJjH0LwnPRr5HKg6x1DkehFiJFRgqz9MzFE+68a5kh3wDtQjGC7A5sFOvN58iHmQLDjDOaBRSBkbUdftRZ4mAU2jh6GO6DgpY9y6+69ZWrPvAvZPDAMcLE9kIu94MXwnqtgmCepR4eyQGf8/aqbiHRrK3v2PwKL1UOtRNPYz3P42hLi54usz+O7wukXxIDo8gk+WNIXJKb6ZbpFMwJKESIXfyYMRCB7gKgwbGWZbt8nHgX1KKZiQPTd6gfLzzCOWayQ5mVctbdgd7cJORuIN224WZ+oEkHwDUtDw4FR3trqaJJzHarD1CBr0A8UQVztvCGxCPuH7XonQrhlcK+tAhIM9alqm6lt+gLmyHv7yeuycZC5UeSDiv34rz8L4J7Qrc5n/XkLX7bJzJvl6sN5l3BDBeZIJlLVOgmsgbcv/AIiE1UMj9YTzAAAAAElFTkSuQmCC"

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-2.3f640ae.png";

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAASCAYAAACjMAXnAAAEg0lEQVRIiZVV329URRT+ZnbbpVu30GLLj7cKTwI1SEJ8d7uNaU3EaHyBBpVEeaAFaUX00VBRULpEBU2IEHls5EHR0N3/wJRC2/BEqS+2m3b7c9vtbs3OeOacuXdR4cHZ3Ht3Zs6cM+c73zlHLeeKFhYwxsLQT9H38aGVoTftWZ5AuUUrsu7LDw0FVgOWoDUrgv5xa8aLkoQiaZpETcULqAiUNYFF9+J1/jnLGl6pEnk27HRpyH2M2LB+n+2QIRar6mOdJKO0phV6qUgEzhF+WLlyFyWxYcR7N6MhO1V10nhPnIy4J3Ym+tB04XtESaW1OpQxgfPBBfiymvWrpZkSIfAQm87vxaZp/L+x4xxW+t7HXyqLxAcXYT66g2JzBs+cfgu1T5T/FIt978GB7XxUi9PrVkJi5ILjJ9A0+irmjyQZSs1RtAGQiGaTqMd3WGpvlWgRHDrbgQSuYjnZ6qUMam8+i5q2PFb3yUok+wq25E4jfzjJ8WddHBcmlGVk+DtyCFtHnu5wpVMxtO4cJk6S0n4sHN4NO9aDrdcfoHTmCpAjwTYBG3iE2nsWRXKIV4hfYpwJYJlkJvDvwC0sdKdgKxWhQDgUef4yeQ4hALGp5v4N4O4NNN11i0exeimLDfMQdTSrmfuDCNpKl/oG8R39yG/3ylzcCWm1MF1ydKY4iDIZGhHHbFMhvAQl5Y37XGOEHOSWM2MS9cOTKLanOHwKU4h/+SJdYABLxAmb6UDjb7+L6p3nsNh/HBUXzvk/162LrVXDSPQeQuzpaP9rvI3CV4Mo20eIX9yP+Ixf3nkeS/0pxC6QcSJw+dgiCnskQyLZFBpwBYvtz8EVgqh4oiFV4SUUz2ZRbCFBLYXABhC7nCG4VI3j0x3U9/4sKEyk2XD5nRUhF6OXgZ4+iPXO51H361UU95KnNoP4bZI7uwvCVBfzIFfDukA5qIdJ+WtPTJfysTXyRAqJdbHbdxlzl9JctUJ6jN8mBPeg0N6D4iihMn4c5XtvInZgCPltkHMWXBOkuESCOwRK3kUhfRkbVonXehJ1X7QJFzwvVFhdM0iceoNDVukaQ3HmByLtEMpqN3HwMzQObKG9o1gZ9Gxnhw2i1qMeJjLvuSS6Rhy49l/PfTnli5Jc7GYCDSMHKVyrmCOv1Ny3aPyF5h+nWGV07Jb36wGiswqllsA5TZ4b+qurRaQaAvJ88Gts+AyQSiQNpAqwQrl7DbPdQRgnEb/+IdB1H2vbplD/+QuIU+yLnxSwlutB88BmxLpGMZ/cxaejbNj+I5lppLCa7pBG4pqAkgId+zGORFB8qBYsax3mIV9obBDx7T9hNjWJhp7XUUOXyJ9p5XKK5jTmBjuROLkfLTNDmD2SgprNlawyQQGtYq85nn7uO5o0BilKvKd8vJRvpr5K+t5F/KDGa4PaoDy5VJhBWnOR94ZtcFIFzbR6xh1yjFbSmSx5bekc92Ymn+w5Jltpiai4/8G9ucnpsBXrCMXcVHnm7yWGw7iGByW9TBB/ygDRZXjPPMYEUehnOuj/nuS+Zbv53yUJH8zijVwMAAAAAElFTkSuQmCC"

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-3.f6046e3.png";

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dytb1-4.3fdbf06.png";

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-4.8548533.png";

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-5.a7cff03.png";

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAAVCAYAAADCUymGAAADg0lEQVRYhe1YPU8bQRAdo/wKUHCDU6DUGBn5B4Q0WMIUbtLhzrYAdynT2UI+d9DRuDARThPzA5AjTI1SYBog5mdweXOz67tb7mJzhwVBftLh26/ZuTdvZ3dJ2ADNMDXMvbQDbx0zgqeM109wZ42oefrSXkRGInIOvigS1fB7fIA/ICC/HtJxW/VhXBPtYVD9IKRvENj2D48Nsw3zVvEJKyg2EYzNHtG89u8w2GS2i35XRP3PRLklCWLrV7gL2n4U2HEwbNj25ra/ro+y1Q0ZMLDtXaO/Y4P8Tx/1J5nH9TwX2/eWR+g+9mUcLDWX15dQ36MhuoLD0EwQrQZEPEglWkn7eK+X3X4LUOGKoXaupyO0oe58g6j0yW/LVGwBtntQ943poLGimj/hA17LleDviaNeipODmcjOtfueV88ZyjVPOV+UPjmQdoyPdj4QTluNMRNg6e4sg2SL6B7P3VdZzoGAH22QWx0QJZX9XMqda/RwuzFHCYGdL0t7NgO/PP0Lmcj0aLyLPLJkK5IH8l4iKb8fhKtsYrB6U676lLid4GVB2tm6vGskEay6LePaT7RfgL/0xV1dZwmjb0LZL1MURCeYUdLZRW027KyjMizBIZb03lW4Y39+IxjYZOgqoHFJEaZse+1wKqCuBG+0qTFhCTcgeag5yyvkUN592HbtO2mHZHXlohAwHvEIdhSLD2m1ZWnx7q1zKDudtiRN6Dx2D6KSy5PZNnN2nnMkyKkGddYBMU8cT1Bd2EkihnoZMc7BUM0tclSa8xfI7K+5OXloSe78XvFvEqzaxQ+TmU9vkeTQruTVpNqchpcIaip4DAeQVctzMzoenxis/n+dqau2P2eP3SfGIwbBnLu2RLWsnNZHdxNa4KUPVa/CwVrRHXKOj1+dJC+DlH1eFVqJUH19Q4i7QzEdstn125KmFhHYC5RzOHX0aqrxVM7tQftCs/i47pkQPUWwWrQaO9/wYUeeRhDA6W0IogttURFvfLcN2QwZrESNm4pKAQpVXvI9Y0IQs8NHOh1U0x9LgnzM5HclGCtlRwOiYvhYNW0CrZS70dXMDY4kRcRB5BM0XwROBm55dAFA/dDszBcMVW/248P9bsNvt6/HqAuFPvybFwPLM5fZFnhRUY+ezztmNK8Hpm8R8PwXjRl8eP3/7PnPMSN4ypgRPGXMCJ4y5ujh4aV9eLsAt38Bs9SbKFf9BIoAAAAASUVORK5CYII="

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-6.bb6d65a.png";

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAAVCAYAAAAzWHILAAADkUlEQVRYhe1YTUtbQRS9lv6C7EJwESoI3QWt+AMKhSiIBNxmEUKyyMZFN8GFC3HjIiBZREIWboUQBBsQ/AHiB+6EgsWFBLsK9Ae09tw3M515k3lpMjFoyzvwfF/z7tx77pl7J848/eg/UYyp4M1LO/A/IyZ3injd5HY/ETXPXtoLb8x41dybTaI6zq0a/iD4wkbEwLwcw7gn2t7HUYsY6wLb/mLYsN9h3kqfKIPbJhKxekqUVP4duk0uH2HcHcZgfDYtEti+jHZB2feAH7mMxwbR1tdw4BzU1QpR8aPjAwe5gY1qeBgH8+gKGImqkEGambhhSYhAM0G0aBDHvpzMRfjuB39yXbAdVnCpQynoANfbZT0uCfVlrETwc0LwyX138myl5mD7Aqp+sB20VlITc63SYIIVJlAt463XV0xi6losK74+N96dJ4wbGUwWQWQNdQUqGTYB7JbmQS7GlXDb+wxC8ezGNRYkHYPYCvw5VgnBs4u8pWSZMHOOokxqqxwuK4wgoZPBj9xiX5DavRbXRdKER6lrZDAJC1p1W/LMCVwGYecb4WTO7mJ8X3x3PKb9HPylsl5VIWEwEtJ+2SsSP3IZTGoA2VhyUslUEzVz+y7aqe+o1SlWxp3jZVqSJW2bdnj505FI3B+lMVkJnYwCVLwMQuhQXIeQ1/aVMoNV5UPA3+FPbqBUBNHuEO30xXJSNZMdzmBJFxK6bj2CpNn50WzbNbrANVE2tAGoZNhNbQy1Re0YJlAtw3OfC7X0PoA0TNw6Fdua7r14xfWUa+VJNdwQArXOjWY+s06iXkOls3lxBLX6Fjbeub/h5LFaeW5G1/CJwaoftmdmX1vGsbM7mq9D4EnuNxzrsvjD4fZ7WRKAJC83qHkRztU39SdXCHxxlDoMQg54NSgFcmNbEaT1cJtJuz+76YjSlKqKxpfF+AvVwM7EvtzVB5qbg8+eCX5lgVWiVNjdQ1AN4yWCXyJRd3MdoR5ucr1d0fiC72/18IeqXPYSFV7mp9aEIKXE27Z13c1D/jREgltM/JFIBK+qNZLqhY8V2ybQXtBNrW43MxJlYQL4kcsqSUlCub7ykguaB0rFDk4ZFQifueGAzFLN2I/yuLQOwNznBjA6Ou+HGVxm1lSjs6BKUAAkYmnPSJhqaonwfL1LXba6NLin5YQdjM1MCM/7IyJGCK/7Hzf/OGJyp4iY3CkiJneKiMmdFn79pN9rQ19akx9lBQAAAABJRU5ErkJggg=="

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-7.e91e893.png";

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAAZCAYAAAAVDoETAAAFFklEQVRoge1ZsarqTBD+7uV/EFFOo3mIcEC4hZBKH0CwESsLC63TnMJKbEQfwE6wEAT1IYLNQc2b5M7sZpNN3KgRDz//bz7wEJKd2dmdmW929vwKCCjwv8bvf9uAAj+PwslvgMLJb4DCyW+AwslvgJc5+TCyYI0OOSR8LFotLPxHx1pomQYfRrBaC1x/uSGj5Iz2PjPXASNrhIM+zrKyfykd/qKVbecrEOTAZd4MarVa4jfcm9/XasNg/5C+++MU9kPS25wHl/hFtvxlHjS1sSw73O+DoRrPstL4oKnrSMmZ15Za4+US7MW4ZjCPjNP03Vkjz9G8EnwdfvGfvIHBkTfAF5btknhunLrwXDv8ylE9RWW9BH3W3vWwengGBxPPhc0Z0XtcCqiiL+blbBwAX0t87qR9E/SwrXvonEPbyzNY2zrWlWm0FpnFUq7t09zTCtbLNuJlGN6l9iW5F8m9yoJ5jGnP1PpybAnhCSfzRsxQXj7mBGfiwbXZ4C3q7Li7+jPG+gu0Gid0E+81p5R0FSO0zh3aND8KuPLMEk6ObJkAvS3ZR+ZHc0VyIL0NnLo86E5wOpNkoAg7xzje3hURxCUOirFhJOmkz6l9yFjrI8id+4J+dLpiClQ0pT8rinwN5Zhp7xLMm9cUKWg9tFHR4JUtiq4z5OJvPEfNQKfyvWB8sm2YkNH0iXdamTCAxyn9ojwYZcxrfQT/5AsJiqYBRakWaRJHjBsWxmqY9uzUQxozRewNVPvrmxR3C7brkX2Usa0zOrqObZp5VrBW2ny6XES5JbSXHsojPoyt0T01Qtof0Br7WNtiBFyvDOJyLDo2ZEK30Ftxxko97mQrDlxZVJ9Ye4VH+E+t3YR8Tj7MsKG6cA1VK5L1mE/cHAal9hJe26TvVo2Tp9x0bPQsA3nqAVbtC33+iOwgakvorbvkRBdRvRPBaqdMSsrxGqYVGQC2NFngek02OdqOZKSDJSVbok67WNN5oGGd5HnDsB0/hRwtFG36FOh2P56fjeuVsQUxQWaQ54W/dR9VdqCnvfPW6Fc5wLR3sqDSJkt24ZYl3Z4IR/YdSuQefY/bON8gx6zA2SvbLR/n7ypEomWsbcEOpmOel3DkloKqhd0nBca6ginpjrs31gl8lE1KX4Mcmcyb7sahrOCf8U10vbpB19HQ3QbHj24yu45jGj5GAoYMM8pmWWpgDmU2O3JakafrcVR2yNHMPldynPGN8ODVi6g9wRyhrco+zvg2Ygb4EoPqqNMJbzobYUM6up4XB4C/w+booJtc7kuRsyaHWKkFO6j7JxxDiizBTNcSB8yYe6tnil07dlYkewssC8pY+ylzI5wXGJzYEWycehnTrIQvTtaiTLADySGusoIdR5l8xJ+UzT52myMc5SmKKEnXNGIRzlJ30KPSNOlv0NNqswgOp/uj9P3cjVe4eM/r4Dxdofrn846TeONkDZx8cOY+etPFkPXzu/+Vs3WQNV3cMCluLLfJwbZ8tt1rtuD6aXGbElK/+h7eYPGBa7mkbKf0HOhlQGSjonGylw53ziRVd+06nOMG588vOq6NMWBZovgBB28nHumfjhp1r+gMom7KGlfnk4eR/0CeOPsnb6BUCzUfhq2IPPLHrYTqBvQ2LOMXtRG32jBzW3Ex3D4l2qPM+Qzry/oWxOsS8yX2IXlTZhaPWzC1zuRN4etaqKduvAr8t1D8F+oNUDj5DVA4+Q1QOPkNUDj5DVA4+Q3wF3Z8FfLKDTLrAAAAAElFTkSuQmCC"

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-9.879152d.png";

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAAAZCAYAAABNcRIKAAAD5klEQVRogdVZW0sVURT+5nB+Q1Adw/oLBmpeiAKpl+xipYVgSBmaVnaji2aiUakVBkX1IBmpD1lpEJZQENFFyR6CCCKKPErab+ic1nhmmsvZM7P3nj2CC8ZZs2edtff+Zn1rrRm1dH5DGlGIRm5j6cx5QYdNTwfosHRfW9Y8Af7s4yK2HPuJRwJk0GK4gZUASxZYnocf4E8tmEKLFQBLNqp5wFLmTyWYomCpSAG+vtWDFWSrBsxAivGCxQu+YrBUpIDQNA8L1hIqLjzgx0IBGTMdp+icsq49j5TtSDt9nBqgo8g2bthpXr5ygY6bQI7H3BpLTxlrZdgw1+lx3+1Pv16ARLQ1MiNGJrL2XQIqljv99e4hQLqBbStcE00A1Zf9/W2/BWxKAvXt7MhSnS9Z0emILxEwpfIbA/zqLjr3AgM/gb09QGIY6Hlj2BQDD3YAZ5uApOmnFOg7KvDE3wLHWsVpLZoCXMKfM5UVlxygYAY4TECWNhsR2QgMNTrn6xzOnO+UAx90hf4c6OCIrI3A1RLXg5UEy8tGY0MUHJmytPayXbMb6C43nE8CVe+AwQrgDEXiNIFwn/TWQ6STbdMT4KMOpl/kKwYrKAX4iH9kuhcsm1/+66uAZgJn8gbRmq6HCjObA0XnxYfWvO2PLX0qlcmNmxO+S82SV/uB8W8+a+Xdjw2HAPEGU0Xb4o6CEsqFmLXuwRgH0b6FaJ7Uc+NOoK2ehmi8YTRjO1oHPHX51H+X1waU/QK67qoByyvyOSW7NXK/5zJbCM5WyN4y6VFJDMajGefMZv7R/loLd2zC5i9RA5yrgaNl0rzW6mqDPI9U9n7s/gTEGZmhiwsrOs2xH8DxK0DxCeuB6UDl6vRdSdQesdZxftTSP9n85K0D5gac0beskiKz0rmrL52UQsbC70dQLDBVFBfeSphHxaZfn5QqdILA/E2Vu+Ue3VtP1XsXNeNE61myrXtmi6ANRGnqBOZynf7mB4Frt/nm500BkhLLprAfFRg0cOg2ynj51cenrlMDvxWoJSC25NP1ayet7PqCz9XA6ZPAZ2ri/+jdQB8Fs/mQ4b1O1tysFCBJa7fE5WggQRlz/D29BU0Y14VVdJOq+Mh3AxRjVWup4S4rIGUaeEF2tVTN5+l3/eNk95yKP1XqIy8NY3oF7azK3tnXC8DwWHBxsTMmpGjpooNp9kSSYIUGn4OG7jWK2CqktVvijlCXLi4RgCXyoMJ8k1Qo8SxgwhSXoM3JRnUU3yQV0JoBplksJMFSkQIW+5tkRBJnb4IXWAmwVOdLUfAjFDaYomAthX94RUDrbDADc1AEYC1WcTH1RZJ/WbamSKAoW8kAAAAASUVORK5CYII="

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy1-11.703b2b2.png";

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy2-1.889ea10.png";

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy2-2.43f6495.png";

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy2-3.2107def.png";

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy2-4.f70d8e7.png";

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAAAYCAYAAABk8drWAAADT0lEQVRYhe2YXUgUURiGX8sy7CYvoiBKDTMvKmwrKELrJrqJoros+jGl6CK3iyAQyqC6NoIotB+hkKB/IogoSgmDwv4MxCQLCwwpKbKgH23evj5mdnd29sywQ+TuA8POnHPm25n3vN93zm7OjNqREWRJG2P+9QOMNrKCppmsoGkm4wSdNSXc+Bkn6ITx4cb3JWhTtRxkayVwt07OD6wHnhyKHcs27SeLZsZek8tRGTea8CVoiZUuJ+7IedFkoOe9nO+/CNScBN40iHDaxn6KRh6+Au512df8/PBFxjnhhKnwjMWYeqj4nLygE5GXG+w+U3wJOilfhCHTCoB3g3Yf2wujdj+pbgIKJoqbKciWCiBSJOf8XDEnVigKuLAYWP7X7Rd2AfWXJC6PedOlvbxOYgVh3Nhg95mSY7qxpyj168yC9g7YorhBh5XXJbbTtc/6xLX8vtqV7uOIlh5Omh+WlADtPe59uZa9fg4nvzdV/58xpg9yulUOhWnpJRr7i62ycKvT/KU5/vA1Oe98K+6me+PLArnfDWwO6NJktO0Ddp8FHrgIvqAIOF5lTUi9t6jGDnXCl0yWcmfabAE4jqWBML2T0fFahGzcFutIZ1YURhPvY7lwa/fCy6GLrb6jm4CqRuB5n90+1yo1zduBqCV2a5d3/EAlek1EnMcFylkz+YLXHyeOj3coU/7IzVjH62LmRLOC6c3YFH5tQ5AnNoPO3HseOFUDbDgGdPcDpVPlek9LajGJ730oX+5Rr4hERylMcYrsFDgeXbVZY5muPKcLU8HvohO5kJmM9+LHL+/+2y+Ag1csR+4AKsuAczsl49hugi+HUhCmrqaZbpUI3ZOsVmqJGBxKTFG6dXXEdh6/g5NC4eLbCWsrYT8nxi/DBgXuageQnwc0bLSe3dpl3HhqHt+XoLqNcV4rdI+KoWid1a2PG86aSYFWzZcYTPWlpfaEaRyNzz7dB/shlUOVlnY5/GK8KDGluTFfViarMXFzG1dmdU5zmzjKKbwbus3ihMQvTMkIsiAR/pZ/GWAiTAm0yocJazR/kfV/cu8f+AxUzJa0dNtOpSJsQUP+IeYfvxt1v3z9Hm78jPu36VtW0P+LjBP041C48TNO0LDJCppmfgNKMShZQf9AgwAAAABJRU5ErkJggg=="

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dy2-5.61b75d9.png";

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //第1步
      isShowQnIcon: true,
      //是否显示千牛图标
      isShowQnIcon2: false,
      //显示点击千牛图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false,
      //显示接待中心

      //第1步
      isShowqh1_1: true,
      //显示切换输入法页面
      isShowqh1_2: false,
      //鼠标移入切换输入法
      isShowqh1_3: false,
      //鼠标点击切换输入法
      isShowqh1_4: false,
      //鼠标移入搜狗输入法
      isShowqh1_5: false,
      //鼠标点击搜狗输入法
      // 设置截屏
      isShowjp1_1: false,
      //延时两秒设置截屏页面显示
      isShowjp1_2: false,
      //鼠标移入输入法设置
      isShowjp1_3: false,
      //鼠标点击输入法设置
      isShowjp1_4: false,
      //鼠标移入截屏设置
      isShowjp1_5: false,
      //点击鼠标右键
      isShowjp1_6: false,
      //鼠标点击发送到桌面
      //设置截屏快捷键
      isShowkj1_1: false,
      //延时两秒显示设置截屏快捷键页面
      isShowkj1_2: false,
      //鼠标移入输入法图标
      isShowkj1_3: false,
      //鼠标点击输入法（菜单）图标
      isShowkj1_4: false,
      //鼠标点击更多设置
      isShowkj1_5: false,
      //鼠标移入按钮
      isShowkj1_6: false,
      //鼠标点击按钮,鼠标滚轮滑动
      // isShowkj1_7:false,//监听滚轮滚动
      isShowkj1_8: false,
      //鼠标移入系统功能快捷键设置
      isShowkj1_9: false,
      //鼠标点击系统功能快捷键设置
      isShowkj1_10: false,
      //监听滚轮滚动
      isShowkj1_11: false,
      //鼠标移入截屏
      isShowkj1_12: false,
      //鼠标点击截屏

      //第2步
      // 搜狗输入法的快捷短语
      isShowdy1_1: true,
      //显示快捷短语的第一张图片
      isShowdy1_2: false,
      //鼠标移入高级
      isShowdy1_3: false,
      //鼠标点击高级
      isShowdy1_4: false,
      //鼠标移入自定义短语
      isShowdy1_5: false,
      //鼠标点击自定义短语
      isShowdy1_6: false,
      //鼠标移入添加新短语
      isShowdy1_7: false,
      //鼠标点击添加新短语
      isShowdy1_7_input: '',
      //缩写输入框
      isShowdy1_7_textarea: '',
      //内容输入框
      isShowdy1_7_select: 1,
      //候选位置值
      isShowdy1_7_selectopint: [{
        value: 1,
        label: 1
      }, {
        value: 2,
        label: 2
      }, {
        value: 3,
        label: 3
      }, {
        value: 4,
        label: 4
      }, {
        value: 5,
        label: 5
      }, {
        value: 6,
        label: 6
      }, {
        value: 7,
        label: 7
      }, {
        value: 8,
        label: 8
      }, {
        value: 9,
        label: 9
      }],
      //候选位置下拉框值
      isShowdy1_8: false,
      //鼠标点击确定并添加
      isShowdy1_9: false,
      //鼠标点确定

      // 显示调用界面
      isShowdy1_10: false,
      //鼠标点击高级
      isb: 0,
      //记录b按下次数
      isShowdy1_11: false,
      //键盘连续输入bb
      isShowdy1_12: false,
      //键盘移入2
      isShowdy1_13: false,
      //键盘点击2
      isShowdy1_14: false //鼠标点击发送
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    var step = this.$route.query.step;
    if (step == 12) {
      this.studyNext('#tab-twelve', step, 'twelve');
    }
    var _this = this;
    document.onkeydown = function (event) {
      var key = window.event.keyCode;
      console.log(key, 88877);
      if (key === 83 && event.ctrlKey) {
        event.returnValue = false; // 阻止直接保存网页
        if (_this.isShowbc1_1 == true) {
          _this.showLoginbc1_1();
        }

        // 监听ctrl+S组合键      
      }
      if (key === 67 && event.ctrlKey) {
        if (_this.isShowfs1_4 == true) {
          _this.Loginfs1_4();
        }
        if (_this.isShownr1_7 == true) {
          _this.showLoginnr1_7();
        }

        // 监听ctrl+C组合键      
      }
      if (key === 86 && event.ctrlKey) {
        if (_this.isShowfs1_5 == true) {
          _this.Loginfs1_5();
        }
        if (_this.isShownr1_9 == true) {
          _this.listenTwo_3();
        }

        // 监听ctrl+V组合键      
      }
      if (key === 13) {
        if (_this.isShowqh1_4 == true) {
          _this.showLoginqh1_4();
        }
        if (_this.isShowpj1_3 == true) {
          _this.showLoginpj1_1();
        }
        if (_this.isShowzf1_4 == true) {
          _this.showLoginzf1_1();
        }
        if (_this.isShowzb1_4 == true) {
          _this.showLoginzb1_1();
        }
        if (_this.isShowfs1_6 == true) {
          _this.Loginfs1_6();
        }
        if (_this.isShowdy1_13 == true) {
          _this.showLogindy1_12_1();
        }

        // 监听回车     
      }
      if (key === 65 && event.ctrlKey) {
        if (_this.isShowwdzt1_1 == true) {
          event.returnValue = false; // 阻止
          _this.Loginwdzt1_1();
        }

        // 监听ctrl+A     
      }
      if (key === 66) {
        _this.isb++;
        console.log(_this.isb, 888);
        if (_this.isShowdy1_10 == true) {
          if (_this.isb == 2) {
            _this.showLogindy1_9();
          }
        } else {
          _this.isb = 0;
        }
        // 监听连续按下两次b    
      } else {
        _this.isb = 0;
      }
      if (key === 50 || key === 98) {
        if (_this.isShowdy1_11 == true) {
          _this.showLogindy1_10_1();
        }
      }
    };
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.isShowqh1_1 = true,
      //显示切换输入法页面
      this.isShowqh1_2 = false,
      //鼠标移入切换输入法
      this.isShowqh1_3 = false,
      //鼠标点击切换输入法
      this.isShowqh1_4 = false,
      //鼠标移入搜狗输入法
      this.isShowqh1_5 = false,
      //鼠标点击搜狗输入法
      // 设置截屏
      this.isShowjp1_1 = false,
      //延时两秒设置截屏页面显示
      this.isShowjp1_2 = false,
      //鼠标移入输入法设置
      this.isShowjp1_3 = false,
      //鼠标点击输入法设置
      this.isShowjp1_4 = false,
      //鼠标移入截屏设置
      this.isShowjp1_5 = false,
      //点击鼠标右键
      this.isShowjp1_6 = false,
      //鼠标点击发送到桌面
      //设置截屏快捷键
      this.isShowkj1_1 = false,
      //延时两秒显示设置截屏快捷键页面
      this.isShowkj1_2 = false,
      //鼠标移入输入法图标
      this.isShowkj1_3 = false,
      //鼠标点击输入法（菜单）图标
      this.isShowkj1_4 = false,
      //鼠标点击更多设置
      this.isShowkj1_5 = false,
      //鼠标移入按钮
      this.isShowkj1_6 = false,
      //鼠标点击按钮,鼠标滚轮滑动
      // isShowkj1_7:false,//监听滚轮滚动
      this.isShowkj1_8 = false,
      //鼠标移入系统功能快捷键设置
      this.isShowkj1_9 = false,
      //鼠标点击系统功能快捷键设置
      this.isShowkj1_10 = false,
      //监听滚轮滚动
      this.isShowkj1_11 = false,
      //鼠标移入截屏
      this.isShowkj1_12 = false; //鼠标点击截屏
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      // 搜狗输入法的快捷短语
      this.isShowdy1_1 = true,
      //显示快捷短语的第一张图片
      this.isShowdy1_2 = false,
      //鼠标移入高级
      this.isShowdy1_3 = false,
      //鼠标点击高级
      this.isShowdy1_4 = false,
      //鼠标移入自定义短语
      this.isShowdy1_5 = false,
      //鼠标点击自定义短语
      this.isShowdy1_6 = false,
      //鼠标移入添加新短语
      this.isShowdy1_7 = false,
      //鼠标点击添加新短语
      this.isShowdy1_7_input = '',
      //缩写输入框
      this.isShowdy1_7_textarea = '',
      //内容输入框
      this.isShowdy1_7_select = 1,
      //候选位置值
      this.isShowdy1_7_selectopint = [{
        value: 1,
        label: 1
      }, {
        value: 2,
        label: 2
      }, {
        value: 3,
        label: 3
      }, {
        value: 4,
        label: 4
      }, {
        value: 5,
        label: 5
      }, {
        value: 6,
        label: 6
      }, {
        value: 7,
        label: 7
      }, {
        value: 8,
        label: 8
      }, {
        value: 9,
        label: 9
      }],
      //候选位置下拉框值
      this.isShowdy1_8 = false,
      //鼠标点击确定并添加
      this.isShowdy1_9 = false,
      //鼠标点确定

      // 显示调用界面
      this.isShowdy1_10 = false,
      //鼠标点击高级
      this.isb = 0,
      //记录b按下次数
      this.isShowdy1_11 = false,
      //键盘连续输入bb
      this.isShowdy1_12 = false,
      //键盘移入2
      this.isShowdy1_13 = false,
      //键盘点击2
      this.isShowdy1_14 = false; //鼠标点击发送
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      //  	this.initThird()
      //  	//第4步
      //  	this.initFour()
      //  	//第5步
      //  	this.initFive()
      //  	//第6步
      //   this.initSix()
      //   //第7步
      //   this.initSeven()
      //   //第8步
      //   this.initEight()
      //   //第9步
      //   this.initNine()
      //   //第10步
      //   this.initTen()
      //   //第11步
      //   this.initEleven()
      //   //第12步
      //   this.initTwelve()
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    //第1步-单击千牛图标
    // showLoginImg() {
    // 	this.isShowQnIcon = false
    // 	this.isShowQnIcon2 = true
    // },
    // //双击千牛图标
    // showLoginImg2() {
    // 	this.isShowQnIcon2 = false
    // 	this.isShowLoginImg = true
    // },
    // //登录
    // loginIn() {
    //   if(this.name == '') {
    //     this.notify('<p>请输入账号</p>')
    //     return
    //   }else if(this.name != '淘金客服:001') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   if(this.password == '') {
    //     this.notify('<p>请输入密码</p>')
    //     return
    //   }else if(this.password != 'TJ2019') {
    //     this.notify('<p>用户名或密码错误</p>'+'<p>请注意大小写或特殊符号</p>')
    //     return
    //   }
    //   this.isShowLoginImg = false
    //   this.isShowRnd = true
    // },
    // //验证码登录
    // loginInRnd() {
    // 	if(this.rnd == '') {
    //     this.notify('<p>请输入短信验证码</p>')
    //     return
    //   }else if(this.rnd != '660220') {
    //     this.notify('<p>短信验证码错误</p>')
    //     return
    //   }
    //   this.isShowRnd = false
    //   this.isShowLoginIndex = true
    // },
    //第1步-鼠标移入输入法
    showLoginqh1_1: function showLoginqh1_1() {
      this.isShowqh1_1 = false;
      this.isShowqh1_2 = true;
    },
    //鼠标点击输入法
    showLoginqh1_2: function showLoginqh1_2() {
      this.isShowqh1_2 = false;
      this.isShowqh1_3 = true;
    },
    //鼠标移入搜狗输入法
    showLoginqh1_3: function showLoginqh1_3() {
      this.isShowqh1_3 = false;
      this.isShowqh1_4 = true;
    },
    //鼠标点击搜狗输入法
    showLoginqh1_4: function showLoginqh1_4() {
      var _this2 = this;
      this.isShowqh1_4 = false;
      this.isShowqh1_5 = true;
      // 设置截屏页面显示
      setTimeout(function () {
        _this2.isShowqh1_5 = false;
        _this2.isShowjp1_1 = true;
      }, 2000);
    },
    //鼠标移入输入法设置
    showLoginjp1_1: function showLoginjp1_1() {
      this.isShowjp1_1 = false;
      this.isShowjp1_2 = true;
    },
    //鼠标点击输入法设置
    showLoginjp1_2: function showLoginjp1_2() {
      this.isShowjp1_2 = false;
      this.isShowjp1_3 = true;
    },
    //鼠标移入截屏设置
    showLoginjp1_3: function showLoginjp1_3() {
      this.isShowjp1_3 = false;
      this.isShowjp1_4 = true;
    },
    //点击鼠标右键
    showLoginjp1_4: function showLoginjp1_4() {
      this.isShowjp1_4 = false;
      this.isShowjp1_5 = true;
    },
    //鼠标点击发送到桌面
    showLoginjp1_5: function showLoginjp1_5() {
      var _this3 = this;
      this.isShowjp1_5 = false;
      this.isShowjp1_6 = true;
      // 设置截屏快捷键页面显示
      setTimeout(function () {
        _this3.isShowjp1_6 = false;
        _this3.isShowkj1_1 = true;
      }, 2000);
    },
    //鼠标移入输入法
    showLoginkj1_1: function showLoginkj1_1() {
      this.isShowkj1_1 = false;
      this.isShowkj1_2 = true;
    },
    //鼠标点击输入法菜单
    showLoginkj1_2: function showLoginkj1_2() {
      this.isShowkj1_2 = false;
      this.isShowkj1_3 = true;
    },
    //鼠标点击更多设置
    showLoginkj1_3: function showLoginkj1_3() {
      this.isShowkj1_3 = false;
      this.isShowkj1_4 = true;
    },
    //鼠标移入按键
    showLoginkj1_4: function showLoginkj1_4() {
      this.isShowkj1_4 = false;
      this.isShowkj1_5 = true;
    },
    //鼠标点击按键
    showLoginkj1_5: function showLoginkj1_5() {
      this.isShowkj1_5 = false;
      this.isShowkj1_6 = true;
    },
    // //滚轮滑动
    // gunlun(e){
    // 	console.log(e)
    // 	if(e.deltaY>0){
    // 		this.isShowkj1_6=false
    // 		this.isShowkj1_7=true
    // 	}
    // },
    //鼠标移入系统功能快捷键设置
    showLoginkj1_6: function showLoginkj1_6() {
      this.isShowkj1_6 = false;
      this.isShowkj1_8 = true;
    },
    //鼠标点击系统功能快捷键设置
    showLoginkj1_7: function showLoginkj1_7() {
      this.isShowkj1_8 = false;
      this.isShowkj1_9 = true;
    },
    // //滚轮滑动
    // showLoginkj1_8(e){
    // 	if(e.deltaY>0){
    // 		this.isShowkj1_9=false
    // 		this.isShowkj1_10=true
    // 	}
    // },
    //鼠标移入截屏
    showLoginkj1_9: function showLoginkj1_9() {
      this.isShowkj1_9 = false;
      this.isShowkj1_11 = true;
    },
    //鼠标点击截屏单选框
    showLoginkj1_10: function showLoginkj1_10() {
      this.isShowkj1_11 = false;
      this.isShowkj1_12 = true;
      var self = this;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 搜狗输入法的快捷短语
    // 搜狗输入法的快捷短语的第一张图显示// 鼠标移入高级
    showLogindy1_1: function showLogindy1_1() {
      this.isShowdy1_1 = false;
      this.isShowdy1_2 = true;
    },
    // 鼠标点击高级
    showLogindy1_2: function showLogindy1_2() {
      this.isShowdy1_2 = false;
      this.isShowdy1_3 = true;
    },
    //鼠标移入自定义短语设置
    showLogindy1_3: function showLogindy1_3() {
      this.isShowdy1_3 = false;
      this.isShowdy1_4 = true;
    },
    //鼠标点击自定义短语设置
    showLogindy1_4: function showLogindy1_4() {
      this.isShowdy1_4 = false;
      this.isShowdy1_5 = true;
    },
    //鼠标移入添加新短语
    showLogindy1_5: function showLogindy1_5() {
      this.isShowdy1_5 = false;
      this.isShowdy1_6 = true;
    },
    //鼠标点击添加新短语
    showLogindy1_6: function showLogindy1_6() {
      this.isShowdy1_6 = false;
      this.isShowdy1_7 = true;
    },
    //鼠标点击确定并继续添加
    showLogindy1_7: function showLogindy1_7() {
      if (this.isShowdy1_7_input != 'bb') {
        this.notify('<p>请将“缩写”按照要求编辑</p>');
      } else {
        if (this.isShowdy1_7_textarea != '报备：去上厕所，离开3分钟') {
          this.notify('<p>请将“内容”按照要求编辑</p>');
        } else {
          this.isShowdy1_7 = false;
          this.isShowdy1_7_input = '';
          this.isShowdy1_7_textarea = '';
          this.isShowdy1_8 = true;
        }
      }
    },
    //鼠标点击确定
    showLogindy1_8: function showLogindy1_8() {
      var _this4 = this;
      if (this.isShowdy1_7_input != 'bb') {
        this.notify('<p>请将“缩写”按照要求编辑</p>');
      } else {
        if (this.isShowdy1_7_textarea != '报备：去上厕所，离开5分钟') {
          this.notify('<p>请将“内容”按照要求编辑</p>');
        } else {
          if (this.isShowdy1_7_select != 2) {
            this.notify('<p>请将“候选位置”按照要求编辑</p>');
          } else {
            this.isShowdy1_8 = false;
            this.isShowdy1_9 = true;
            //   延时两秒显示调用页面
            setTimeout(function () {
              _this4.isShowdy1_9 = false;
              _this4.isShowdy1_10 = true;
            }, 2000);
          }
        }
      }
    },
    //连续点击两次b
    showLogindy1_9: function showLogindy1_9() {
      this.isShowdy1_10 = false;
      this.isShowdy1_11 = true;
    },
    //鼠标移到2
    showLogindy1_10: function showLogindy1_10() {
      this.isShowdy1_11 = false;
      this.isShowdy1_12 = true;
    },
    //键盘按下2
    showLogindy1_10_1: function showLogindy1_10_1() {
      this.isShowdy1_11 = false;
      this.isShowdy1_13 = true;
    },
    //鼠标点击2
    showLogindy1_11: function showLogindy1_11() {
      this.isShowdy1_12 = false;
      this.isShowdy1_13 = true;
    },
    //鼠标点击发送
    showLogindy1_12: function showLogindy1_12() {
      this.isShowdy1_13 = false;
      this.isShowdy1_14 = true;
      var self = this;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //按下键盘enter
    showLogindy1_12_1: function showLogindy1_12_1() {
      this.isShowdy1_13 = false;
      this.isShowdy1_14 = true;
      var self = this;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // //进入接待中心
    // enterJd() {
    // 	var self = this
    // 	this.isShowLoginIndex = false
    // 	this.isShowLoginIndexTwo = true
    // 	this.addRecord('END', 1)
    // 	setTimeout(function() {
    //     $('#studytip-'+self.tabCurrent).show();
    //   }, 2000);
    // },
    //第2步-切换状态-显示未挂起图片
    //第2步-
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this5 = this;
      var data = {
        exerciseType: 'SOUGOU_INPUT_EXAM',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 2 && type == 'END') {
            window.parent['goBack']();
          }
        } else {
          _this5.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this5.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //当前标签页
      tabIndex: 1,
      //序号
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt1: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示飞鸽图标
      isShowQnIcon2: false,
      //显示点击飞鸽图标后图片
      isShowIcon3: false,
      //显示选择商家图片
      isShowIcon4: false,
      //显示切换手机号登录页面
      isShowIcon5: false,
      isShowIcon6: false,
      isShowIcon7: false,
      isShowIcon8: false,
      isShowLogin1: false,
      isShowLogin2: false,
      isShowLogin3: false,
      isShowLogin4: false,
      isShowLogin5: false,
      isShowLogin6: false,
      name: '',
      //登录账号
      password: '',
      //密码

      // 第二部
      isShowSetUp: true,
      isShowSetUp1: false,
      isShowSetUp2: false,
      isShowSetUp3: false,
      isShowSetUp4: false,
      isShowSetUp5: false,
      isShowSetUp6: false,
      isShowSetUp7: false,
      isShowSetUp8: false,
      isShowSetUp9: false,
      isShowSetUp10: false,
      // 第三步
      duanyuInputVal: '',
      duanyuInputVal1: '',
      downCount: 0,
      dyInput: '',
      //快捷短语输入
      dynr: '',
      //短语内容
      bmdy: '',
      //编码短语
      isShowSetDown: true,
      isShowSetDown1: false,
      isShowSetDown2: false,
      isShowSetDown3: false,
      isShowSetDown4: false,
      isShowSetDown5: false,
      isShowSetDown6: false,
      isShowSetDown7: false,
      isShowSetDown8: false,
      isShowSetDown9: false,
      isShowSetDown10: false,
      isShowSetDown11: false,
      isShowSetDown12: false,
      isShowSetDown13: false,
      isShowSetDown14: false,
      isShowSetDown15: false,
      isShowSetDown16: false,
      isShowSetDown17: false,
      isShowSetDown18: false,
      isShowSetDown19: false,
      isShowSetDown20: false,
      isShowSetDown21: false,
      isShowSetDown22: false,
      isShowSetDown23: false,
      isShowSetDown24: false,
      isShowSetDown25: false,
      isShowSetDown26: false,
      isShowSetDown27: false,
      isShowSetDown28: false,
      isShowSetDown29: false,
      isShowSetDown30: false,
      isShowSetDown31: false,
      isShowSetDown32: false,
      isShowSetDown33: false,
      isShowSetDown34: false,
      isShowSetDown35: false,
      isShowSetDown36: false,
      isShowSetDown37: false,
      isShowSetDown38: false,
      isShowSetDown39: false,
      isShowSetDown40: false,
      isShowSetDown41: false,
      isShowSetDown42: false,
      isShowSetDown43: false,
      isShowSetDown44: false,
      isShowSetDown45: false,
      isShowSetDown431: false,
      isShowSetDown432: false,
      isShowSetDown433: false,
      isShowSetDown434: false,
      isShowSetDown451: false,
      isShowSetDown452: false,
      // 第四步
      isShowSession: true,
      isShowSession1: false,
      isShowSession2: false,
      isShowSession3: false,
      isShowSession4: false,
      // 第五步
      isShowFive: true,
      isShowFive1: false,
      isShowFive2: false,
      isShowFive3: false,
      isShowFive4: false,
      isShowFive5: false,
      isShowFive6: false,
      isShowFive7: false,
      isShowFive8: false,
      isShowFive9: false,
      // 第六步
      isShowSix: true,
      beizhu: '',
      yjgj: '',
      yfInput: '',
      sjhm: '',
      isShowSix1: false,
      isShowSix2: false,
      isShowSix3: false,
      isShowSix4: false,
      isShowSix5: false,
      isShowSix6: false,
      isShowSix7: false,
      isShowSix8: false,
      isShowSix9: false,
      isShowSix10: false,
      isShowSix11: false,
      isShowSix12: false,
      isShowSix13: false,
      isShowSix14: false,
      isShowSix15: false,
      isShowSix16: false,
      isShowSix17: false,
      isShowSix18: false,
      isShowSix19: false,
      isShowSix20: false,
      isShowSix21: false,
      isShowSix22: false,
      isShowSix23: false,
      isShowSix24: false,
      // 第七步
      isShowSeven: true,
      isShowSeven1: false,
      isShowSeven2: false,
      isShowSeven3: false,
      isShowSeven4: false,
      isShowSeven5: false,
      isShowSeven6: false,
      isShowSeven7: false,
      isShowSeven8: false,
      isShowSeven9: false,
      isShowSeven10: false,
      isShowSeven11: false,
      isShowSmallPic: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this.tabCurrent).show();
      _this.$set(_this.isShowBtn, _this.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
    // 去掉双击事件默认选中
    var select = document.getElementById('select');
    select.onmousedown = function () {
      return false;
    };
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('first').play();
      $('#startvideo').hide();
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.isShowBtn[this.tabCurrent] = false;
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START');
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initFirst();
      this.initSecond();
      this.initThird();
      this.initFour();
      this.initFive();
      this.initSix();
      this.initSeven();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    // 重练1
    restartStudyFirst: function restartStudyFirst() {
      this.initFirst();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //重练2
    restartStudySecond: function restartStudySecond() {
      this.initSecond();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //重练第三步
    restartStudyThird: function restartStudyThird() {
      this.initThird();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyFour: function restartStudyFour() {
      this.initFour();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyFive: function restartStudyFive() {
      this.initFive();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudySix: function restartStudySix() {
      this.initSix();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudySeven: function restartStudySeven() {
      this.initSeven();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = false;
      this.isShowIcon4 = false;
      this.isShowIcon5 = false;
      this.isShowIcon6 = false;
      this.isShowIcon7 = false;
      this.isShowIcon8 = false;
      this.isShowLogin1 = false;
      this.isShowLogin2 = false;
      this.isShowLogin3 = false;
      this.isShowLogin4 = false;
      this.isShowLogin5 = false;
      this.isShowLogin6 = false;
    },
    initSecond: function initSecond() {
      this.isShowSetUp = true;
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = false;
    },
    initThird: function initThird() {
      this.downCount = 0;
      this.duanyuInputVal = '';
      this.duanyuInputVal1 = '';
      this.dyInput = '',
      //快捷短语输入
      this.dynr = '',
      //短语内容
      this.bmdy = '',
      //编码短语
      this.isShowSetDown = true;
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = false;
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = false;
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = false;
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = false;
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = false;
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = false;
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = false;
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = false;
      this.isShowSetDown431 = false;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = false;
      this.isShowSetDown434 = false;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = false;
    },
    initFour: function initFour() {
      this.isShowSession = true;
      this.isShowSession1 = false;
      this.isShowSession2 = false;
      this.isShowSession3 = false;
      this.isShowSession4 = false;
    },
    initFive: function initFive() {
      this.isShowFive = true;
      this.isShowFive1 = false;
      this.isShowFive2 = false;
      this.isShowFive3 = false;
      this.isShowFive4 = false;
      this.isShowFive5 = false;
      this.isShowFive6 = false;
      this.isShowFive7 = false;
      this.isShowFive8 = false;
      this.isShowFive9 = false;
    },
    initSix: function initSix() {
      this.beizhu = '';
      this.yjgj = '';
      this.yfInput = '';
      this.sjhm = '';
      this.isShowSix = true;
      this.isShowSix1 = false;
      this.isShowSix2 = false;
      this.isShowSix3 = false;
      this.isShowSix4 = false;
      this.isShowSix5 = false;
      this.isShowSix6 = false;
      this.isShowSix7 = false;
      this.isShowSix8 = false;
      this.isShowSix9 = false;
      this.isShowSix10 = false;
      this.isShowSix11 = false;
      this.isShowSix12 = false;
      this.isShowSix13 = false;
      this.isShowSix14 = false;
      this.isShowSix15 = false;
      this.isShowSix16 = false;
      this.isShowSix17 = false;
      this.isShowSix18 = false;
      this.isShowSix19 = false;
      this.isShowSix20 = false;
      this.isShowSix21 = false;
      this.isShowSix22 = false;
      this.isShowSix23 = false;
      this.isShowSix24 = false;
    },
    initSeven: function initSeven() {
      this.isShowSeven = true;
      this.isShowSeven1 = false;
      this.isShowSeven2 = false;
      this.isShowSeven3 = false;
      this.isShowSeven4 = false;
      this.isShowSeven5 = false;
      this.isShowSeven6 = false;
      this.isShowSeven7 = false;
      this.isShowSeven8 = false;
      this.isShowSeven9 = false;
      this.isShowSeven10 = false;
      this.isShowSeven11 = false;
      this.isShowSmallPic = false;
    },
    handleClick: function handleClick(tab, event) {
      var _this2 = this;
      this.tabIndex = parseInt(tab.index) + 1;
      //内容初始化
      this.initAll();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this2.tabCurrent).show();
        _this2.$set(_this2.isShowBtn, _this2.tabCurrent, true);
      }, false);
    },
    initAll: function initAll() {
      $('#startvideo').hide();
      this.isShowBtn = [];
      this.isOpenPpt = false;
      this.isOpenPpt1 = false;
      this.isOpenPpt2 = false;
      this.isOpenPpt3 = false;
      this.isOpenPpt4 = false;
      this.isOpenPpt5 = false;
      this.isOpenPpt6 = false;
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
      $('.content').each(function (i) {
        $(this).hide();
      });
      $('.stoptip').each(function (i) {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function (i) {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show();
    },
    viewPpt: function viewPpt(bol) {
      if (this.isOpenPpt == true || !bol) {
        this.isOpenPpt = false;
        $('#pdf_viewer').height('0');
      } else {
        this.isOpenPpt = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/c6255fbab2284e7cbbfc4a2d2405efcc.pdf', "#pdf_viewer", options);
        }
      }
    },
    viewPpt1: function viewPpt1(bol) {
      if (this.isOpenPpt1 == true || !bol) {
        this.isOpenPpt1 = false;
        $('#pdf_viewer1').height('0');
      } else {
        this.isOpenPpt1 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer1').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/ae85ff093cdd420db17db8951f1db636.pdf', "#pdf_viewer1", options);
        }
      }
    },
    viewPpt2: function viewPpt2(bol) {
      if (this.isOpenPpt2 == true || !bol) {
        this.isOpenPpt2 = false;
        $('#pdf_viewer2').height('0');
      } else {
        this.isOpenPpt2 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer2').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/60c2e539816d44cc9f96c2382b697acf.pdf', "#pdf_viewer2", options);
        }
      }
    },
    viewPpt3: function viewPpt3(bol) {
      if (this.isOpenPpt3 == true || !bol) {
        this.isOpenPpt3 = false;
        $('#pdf_viewer3').height('0');
      } else {
        this.isOpenPpt3 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer3').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/2dc362b569934aeb8e2fe1cbdba6de10.pdf', "#pdf_viewer3", options);
        }
      }
    },
    viewPpt4: function viewPpt4(bol) {
      if (this.isOpenPpt4 == true || !bol) {
        this.isOpenPpt4 = false;
        $('#pdf_viewer4').height('0');
      } else {
        this.isOpenPpt4 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer4').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/a3c76b39ef424f87880a86920d8e40e4.pdf', "#pdf_viewer4", options);
        }
      }
    },
    viewPpt5: function viewPpt5(bol) {
      if (this.isOpenPpt5 == true || !bol) {
        this.isOpenPpt5 = false;
        $('#pdf_viewer5').height('0');
      } else {
        this.isOpenPpt5 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer5').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/a672de44ceb541aa8703e38b14e87b4b.pdf', "#pdf_viewer5", options);
        }
      }
    },
    viewPpt6: function viewPpt6(bol) {
      if (this.isOpenPpt6 == true || !bol) {
        this.isOpenPpt6 = false;
        $('#pdf_viewer6').height('0');
      } else {
        this.isOpenPpt6 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer6').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/95475ae5557840489964ac00ad6e4650.pdf', "#pdf_viewer6", options);
        }
      }
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = true;
    },
    showLoginImg3: function showLoginImg3() {
      this.isShowIcon3 = false;
      this.isShowIcon4 = true;
    },
    showLoginImg4: function showLoginImg4() {
      this.isShowIcon4 = false;
      this.isShowIcon5 = true;
    },
    showLoginImg5: function showLoginImg5() {
      this.isShowIcon5 = false;
      this.isShowIcon6 = true;
    },
    showLoginImg6: function showLoginImg6() {
      this.isShowIcon6 = false;
      this.isShowIcon7 = true;
    },
    showLoginImg7: function showLoginImg7() {
      this.isShowIcon7 = false;
      this.isShowIcon8 = true;
    },
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '13853678478') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != '3346') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowIcon8 = false;
      this.isShowLogin1 = true;
    },
    loginIn1: function loginIn1() {
      this.isShowLogin1 = false;
      this.isShowLogin2 = true;
    },
    loginIn2: function loginIn2() {
      this.isShowLogin2 = false;
      this.isShowLogin3 = true;
    },
    loginIn3: function loginIn3() {
      this.isShowLogin3 = false;
      this.isShowLogin4 = true;
    },
    loginIn4: function loginIn4() {
      var self = this;
      this.isShowLogin4 = false;
      this.isShowLogin5 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第二布  设置上事件
    setUp: function setUp() {
      this.isShowSetUp = false;
      this.isShowSetUp1 = true;
    },
    setUp1: function setUp1() {
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = true;
    },
    setUp2: function setUp2() {
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = true;
    },
    setUp3: function setUp3() {
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = true;
    },
    setUp4: function setUp4() {
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = true;
    },
    setUp5: function setUp5() {
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = true;
    },
    setUp6: function setUp6() {
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = true;
    },
    setUp7: function setUp7() {
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = true;
    },
    setUp8: function setUp8() {
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = true;
    },
    setUp9: function setUp9() {
      var self = this;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第三步
    setDown: function setDown() {
      this.isShowSetDown = false;
      this.isShowSetDown1 = true;
    },
    setDown1: function setDown1() {
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = true;
    },
    setDown2: function setDown2() {
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = true;
    },
    setDown3: function setDown3() {
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = true;
    },
    setDown4: function setDown4() {
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = true;
    },
    setDown5: function setDown5() {
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = true;
    },
    setDown6: function setDown6() {
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = true;
    },
    setDown7: function setDown7() {
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = true;
    },
    setDown8: function setDown8() {
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = true;
    },
    setDown9: function setDown9() {
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = true;
    },
    setDown10: function setDown10() {
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = true;
    },
    setDown11: function setDown11() {
      if (this.dyInput == '催单') {
        this.isShowSetDown11 = false;
        this.isShowSetDown12 = true;
      } else {
        this.notify('<p>请按照右边提示输入催单</p>');
      }
    },
    setDown12: function setDown12() {
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = true;
    },
    setDown13: function setDown13() {
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = true;
    },
    // 填写编码配置部分前后
    setDown14: function setDown14() {
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = true;
    },
    setDown16: function setDown16() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = true;
    },
    setDown17: function setDown17() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown16 = false;
      this.isShowSetDown19 = true;
    },
    setDown15: function setDown15() {
      this.isShowSetDown14 = false;
      this.isShowSetDown17 = true;
    },
    setDown18: function setDown18() {
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = true;
    },
    setDown19: function setDown19() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = true;
    },
    setDown20: function setDown20() {
      var _this3 = this;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = true;
      setTimeout(function () {
        _this3.isShowSetDown20 = false;
        _this3.isShowSetDown21 = true;
      }, 2000);
    },
    setDown22: function setDown22() {
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = true;
    },
    setDown23: function setDown23() {
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = true;
    },
    setDown24: function setDown24() {
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = true;
    },
    setDown25: function setDown25() {
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = true;
    },
    // 先勾选
    // setDown241() {
    //     this.isShowSetDown24 = false
    //     this.isShowSetDown271 = true
    // },
    // setDown281() {
    //     this.isShowSetDown271 = false
    //     this.isShowSetDown281 = true
    // },
    setDown26: function setDown26() {
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = true;
    },
    setDown27: function setDown27() {
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = true;
    },
    setDown28: function setDown28() {
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = true;
    },
    setDown29: function setDown29() {
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = true;
    },
    setDown30: function setDown30() {
      var _this4 = this;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = true;
      setTimeout(function () {
        _this4.isShowSetDown30 = false;
        _this4.isShowSetDown31 = true;
      }, 2000);
    },
    setDown32: function setDown32() {
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = true;
    },
    setDown33: function setDown33() {
      if (this.downCount == 0) {
        this.$alert('请先下载飞鸽快捷短语模板');
        return false;
      }
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = true;
    },
    setDown34: function setDown34() {
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = true;
    },
    setDown36: function setDown36() {
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = true;
    },
    setDown37: function setDown37() {
      var _this5 = this;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = true;
      setTimeout(function () {
        _this5.isShowSetDown37 = false;
        _this5.isShowSetDown38 = true;
      }, 2000);
    },
    setDown39: function setDown39() {
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = true;
    },
    setDown40: function setDown40() {
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = true;
    },
    setDown41: function setDown41() {
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = true;
    },
    setDown42: function setDown42() {
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = true;
    },
    setDown43: function setDown43() {
      var _this6 = this;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = true;
      setTimeout(function () {
        _this6.isShowSetDown43 = false;
        _this6.isShowSetDown431 = true;
      }, 1500);
    },
    duanyuInput: function duanyuInput(e) {
      if (e.target.value == '/您好') {
        this.isShowSetDown431 = false;
        this.isShowSetDown432 = true;
        // this.isShowSetDown44 = true
      }
    },
    setDown432: function setDown432() {
      var _this7 = this;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = true;
      setTimeout(function () {
        _this7.isShowSetDown433 = false;
        _this7.isShowSetDown434 = true;
      }, 2000);
    },
    duanyuInput1: function duanyuInput1(e) {
      if (e.target.value == '您好') {
        this.isShowSetDown434 = false;
        this.isShowSetDown44 = true;
      }
    },
    setDown45: function setDown45() {
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = true;
    },
    setDown46: function setDown46() {
      this.isShowSetDown45 = false;
      this.isShowSetDown451 = true;
    },
    setDown461: function setDown461() {
      var self = this;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 下载快捷短语
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '飞鸽快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = true;
    },
    // 第四步  操作
    four: function four() {
      this.isShowSession = false;
      this.isShowSession1 = true;
    },
    four1: function four1() {
      this.isShowSession1 = false;
      this.isShowSession2 = true;
    },
    four2: function four2() {
      this.isShowSession2 = false;
      this.isShowSession3 = true;
    },
    four3: function four3() {
      var self = this;
      this.isShowSession3 = false;
      this.isShowSession4 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第五步
    five: function five() {
      this.isShowFive = false;
      this.isShowFive1 = true;
    },
    five1: function five1() {
      this.isShowFive1 = false;
      this.isShowFive2 = true;
    },
    five2: function five2() {
      this.isShowFive2 = false;
      this.isShowFive3 = true;
    },
    five3: function five3() {
      var _this8 = this;
      this.isShowFive3 = false;
      this.isShowFive4 = true;
      setTimeout(function () {
        _this8.isShowFive4 = false;
        _this8.isShowFive5 = true;
      }, 2000);
    },
    five5: function five5() {
      this.isShowFive5 = false;
      this.isShowFive6 = true;
    },
    five6: function five6() {
      this.isShowFive6 = false;
      this.isShowFive7 = true;
    },
    five7: function five7() {
      this.isShowFive7 = false;
      this.isShowFive8 = true;
    },
    five8: function five8() {
      var self = this;
      this.isShowFive8 = false;
      this.isShowFive9 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第六步
    six: function six() {
      this.isShowSix = false;
      this.isShowSix1 = true;
    },
    six1: function six1() {
      this.isShowSix1 = false;
      this.isShowSix2 = true;
    },
    beiZhuInput: function beiZhuInput(e) {
      if (e.target.value == '用户要求发顺丰') {
        this.isShowSix2 = false;
        this.isShowSix3 = true;
      }
    },
    six121: function six121() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      } else {
        this.notify('<p>请按照右边提示选择对应的彩旗</p>');
      }
    },
    six122: function six122() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      }
    },
    six3: function six3() {
      this.isShowSix3 = false;
      this.isShowSix4 = true;
    },
    six4: function six4() {
      this.isShowSix4 = false;
      this.isShowSix5 = true;
    },
    six5: function six5() {
      var _this9 = this;
      this.isShowSix5 = false;
      this.isShowSix6 = true;
      setTimeout(function () {
        _this9.isShowSix6 = false;
        _this9.isShowSix7 = true;
      }, 2000);
    },
    six6: function six6() {
      this.isShowSix7 = false;
      this.isShowSix8 = true;
    },
    six7: function six7() {
      var _this0 = this;
      this.isShowSix8 = false;
      this.isShowSix9 = true;
      setTimeout(function () {
        _this0.isShowSix9 = false;
        _this0.isShowSix10 = true;
      }, 2000);
    },
    six8: function six8() {
      this.isShowSix10 = false;
      this.isShowSix11 = true;
    },
    six9: function six9() {
      var _this1 = this;
      this.isShowSix11 = false;
      this.isShowSix12 = true;
      setTimeout(function () {
        _this1.isShowSix12 = false;
        _this1.isShowSix13 = true;
      }, 2000);
    },
    six10: function six10() {
      this.isShowSix13 = false;
      this.isShowSix14 = true;
    },
    six11: function six11() {
      this.isShowSix14 = false;
      this.isShowSix15 = true;
    },
    six12: function six12() {
      if (this.yjgj != '48') {
        this.notify('<p>请按照右边提示输入正确的一键改价价格</p>');
        return;
      }
      if (this.yfInput != '10') {
        this.notify('<p>请按照右边提示输入正确的运费价格</p>');
        return;
      }
      this.isShowSix15 = false;
      this.isShowSix16 = true;
    },
    six13: function six13() {
      var _this10 = this;
      this.isShowSix16 = false;
      this.isShowSix17 = true;
      setTimeout(function () {
        _this10.isShowSix17 = false;
        _this10.isShowSix18 = true;
      }, 2000);
    },
    six14: function six14() {
      this.isShowSix18 = false;
      this.isShowSix19 = true;
    },
    six15: function six15() {
      this.isShowSix19 = false;
      this.isShowSix20 = true;
    },
    six16: function six16() {
      this.isShowSix20 = false;
      this.isShowSix21 = true;
    },
    six17: function six17() {
      if (this.sjhm != '13512345678') {
        this.notify('<p>请按照右边提示输入正确的手机号码</p>');
        return;
      }
      this.isShowSix21 = false;
      this.isShowSix22 = true;
    },
    six18: function six18() {
      var self = this;
      this.isShowSix22 = false;
      this.isShowSix23 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第七步
    seven: function seven() {
      this.isShowSeven = false;
      this.isShowSeven1 = true;
    },
    seven1: function seven1() {
      this.isShowSeven1 = false;
      this.isShowSeven2 = true;
    },
    seven2: function seven2() {
      this.isShowSeven2 = false;
      this.isShowSeven3 = true;
    },
    seven3: function seven3() {
      this.isShowSeven3 = false;
      this.isShowSeven4 = true;
    },
    seven4: function seven4() {
      this.isShowSeven4 = false;
      this.isShowSeven5 = true;
    },
    seven5: function seven5() {
      this.isShowSeven5 = false;
      this.isShowSeven6 = true;
    },
    seven6: function seven6() {
      this.isShowSeven6 = false;
      this.isShowSeven7 = true;
    },
    seven7: function seven7() {
      this.isShowSeven7 = false;
      this.isShowSeven8 = true;
    },
    seven8: function seven8() {
      this.isShowSeven8 = false;
      this.isShowSeven9 = true;
    },
    seven9: function seven9() {
      this.isShowSeven9 = false;
      this.isShowSeven10 = true;
    },
    seven10: function seven10() {
      this.isShowSmallPic = true;
    },
    seven11: function seven11() {
      var self = this;
      this.isShowSeven10 = false;
      this.isShowSmallPic = false;
      this.isShowSeven11 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('飞鸽快捷短语') < 0) {
        this.$alert('请选择你下载的“飞鸽快捷短语.csv”模板文件');
        return false;
      }
      setTimeout(function () {
        self.isShowSetDown34 = false;
        self.isShowSetDown35 = true;
      }, 500);
    },
    // 记录接口
    addRecord: function addRecord(type) {
      var _this11 = this;
      var data = {
        exerciseType: 'FEIGE',
        stepSeq: this.tabIndex,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this11.tabIndex == 7 && type == 'END') {
            window.parent['goBack']();
          }
        } else {
          _this11.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this11.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //当前标签页
      tabIndex: 1,
      //序号
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt1: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示飞鸽图标
      isShowQnIcon2: false,
      //显示点击飞鸽图标后图片
      isShowIcon3: false,
      //显示选择商家图片
      isShowIcon4: false,
      //显示切换手机号登录页面
      isShowIcon5: false,
      isShowIcon6: false,
      isShowIcon7: false,
      isShowIcon8: false,
      isShowLogin1: false,
      isShowLogin2: false,
      isShowLogin3: false,
      isShowLogin4: false,
      isShowLogin5: false,
      isShowLogin6: false,
      name: '',
      //登录账号
      password: '',
      //密码

      // 第二部
      isShowSetUp: true,
      isShowSetUp1: false,
      isShowSetUp2: false,
      isShowSetUp3: false,
      isShowSetUp4: false,
      isShowSetUp5: false,
      isShowSetUp6: false,
      isShowSetUp7: false,
      isShowSetUp8: false,
      isShowSetUp9: false,
      isShowSetUp10: false,
      // 第三步
      duanyuInputVal: '',
      duanyuInputVal1: '',
      downCount: 0,
      dyInput: '',
      //快捷短语输入
      dynr: '',
      //短语内容
      bmdy: '',
      //编码短语
      isShowSetDown: true,
      isShowSetDown1: false,
      isShowSetDown2: false,
      isShowSetDown3: false,
      isShowSetDown4: false,
      isShowSetDown5: false,
      isShowSetDown6: false,
      isShowSetDown7: false,
      isShowSetDown8: false,
      isShowSetDown9: false,
      isShowSetDown10: false,
      isShowSetDown11: false,
      isShowSetDown12: false,
      isShowSetDown13: false,
      isShowSetDown14: false,
      isShowSetDown15: false,
      isShowSetDown16: false,
      isShowSetDown17: false,
      isShowSetDown18: false,
      isShowSetDown19: false,
      isShowSetDown20: false,
      isShowSetDown21: false,
      isShowSetDown22: false,
      isShowSetDown23: false,
      isShowSetDown24: false,
      isShowSetDown25: false,
      isShowSetDown26: false,
      isShowSetDown27: false,
      isShowSetDown28: false,
      isShowSetDown29: false,
      isShowSetDown30: false,
      isShowSetDown31: false,
      isShowSetDown32: false,
      isShowSetDown33: false,
      isShowSetDown34: false,
      isShowSetDown35: false,
      isShowSetDown36: false,
      isShowSetDown37: false,
      isShowSetDown38: false,
      isShowSetDown39: false,
      isShowSetDown40: false,
      isShowSetDown41: false,
      isShowSetDown42: false,
      isShowSetDown43: false,
      isShowSetDown44: false,
      isShowSetDown45: false,
      isShowSetDown431: false,
      isShowSetDown432: false,
      isShowSetDown433: false,
      isShowSetDown434: false,
      isShowSetDown451: false,
      isShowSetDown452: false,
      // 第四步
      isShowSession: true,
      isShowSession1: false,
      isShowSession2: false,
      isShowSession3: false,
      isShowSession4: false,
      // 第五步
      isShowFive: true,
      isShowFive1: false,
      isShowFive2: false,
      isShowFive3: false,
      isShowFive4: false,
      isShowFive5: false,
      isShowFive6: false,
      isShowFive7: false,
      isShowFive8: false,
      isShowFive9: false,
      // 第六步
      isShowSix: true,
      beizhu: '',
      yjgj: '',
      yfInput: '',
      sjhm: '',
      isShowSix1: false,
      isShowSix2: false,
      isShowSix3: false,
      isShowSix4: false,
      isShowSix5: false,
      isShowSix6: false,
      isShowSix7: false,
      isShowSix8: false,
      isShowSix9: false,
      isShowSix10: false,
      isShowSix11: false,
      isShowSix12: false,
      isShowSix13: false,
      isShowSix14: false,
      isShowSix15: false,
      isShowSix16: false,
      isShowSix17: false,
      isShowSix18: false,
      isShowSix19: false,
      isShowSix20: false,
      isShowSix21: false,
      isShowSix22: false,
      isShowSix23: false,
      isShowSix24: false,
      // 第七步
      isShowSeven: true,
      isShowSeven1: false,
      isShowSeven2: false,
      isShowSeven3: false,
      isShowSeven4: false,
      isShowSeven5: false,
      isShowSeven6: false,
      isShowSeven7: false,
      isShowSeven8: false,
      isShowSeven9: false,
      isShowSeven10: false,
      isShowSeven11: false,
      isShowSmallPic: false
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    var step = this.$route.query.step;
    if (step == 7) {
      this.studyNext('#tab-seven', step, 'seven');
    }
    // 去掉双击事件默认选中
    var select = document.getElementById('select');
    select.onmousedown = function () {
      return false;
    };
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = false;
      this.isShowIcon4 = false;
      this.isShowIcon5 = false;
      this.isShowIcon6 = false;
      this.isShowIcon7 = false;
      this.isShowIcon8 = false;
      this.isShowLogin1 = false;
      this.isShowLogin2 = false;
      this.isShowLogin3 = false;
      this.isShowLogin4 = false;
      this.isShowLogin5 = false;
      this.isShowLogin6 = false;
    },
    initSecond: function initSecond() {
      this.isShowSetUp = true;
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = false;
    },
    initThird: function initThird() {
      this.downCount = 0;
      this.duanyuInputVal = '';
      this.duanyuInputVal1 = '';
      this.dyInput = '',
      //快捷短语输入
      this.dynr = '',
      //短语内容
      this.bmdy = '',
      //编码短语
      this.isShowSetDown = true;
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = false;
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = false;
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = false;
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = false;
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = false;
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = false;
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = false;
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = false;
      this.isShowSetDown431 = false;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = false;
      this.isShowSetDown434 = false;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = false;
    },
    initFour: function initFour() {
      this.isShowSession = true;
      this.isShowSession1 = false;
      this.isShowSession2 = false;
      this.isShowSession3 = false;
      this.isShowSession4 = false;
    },
    initFive: function initFive() {
      this.isShowFive = true;
      this.isShowFive1 = false;
      this.isShowFive2 = false;
      this.isShowFive3 = false;
      this.isShowFive4 = false;
      this.isShowFive5 = false;
      this.isShowFive6 = false;
      this.isShowFive7 = false;
      this.isShowFive8 = false;
      this.isShowFive9 = false;
    },
    initSix: function initSix() {
      this.beizhu = '';
      this.yjgj = '';
      this.yfInput = '';
      this.sjhm = '';
      this.isShowSix = true;
      this.isShowSix1 = false;
      this.isShowSix2 = false;
      this.isShowSix3 = false;
      this.isShowSix4 = false;
      this.isShowSix5 = false;
      this.isShowSix6 = false;
      this.isShowSix7 = false;
      this.isShowSix8 = false;
      this.isShowSix9 = false;
      this.isShowSix10 = false;
      this.isShowSix11 = false;
      this.isShowSix12 = false;
      this.isShowSix13 = false;
      this.isShowSix14 = false;
      this.isShowSix15 = false;
      this.isShowSix16 = false;
      this.isShowSix17 = false;
      this.isShowSix18 = false;
      this.isShowSix19 = false;
      this.isShowSix20 = false;
      this.isShowSix21 = false;
      this.isShowSix22 = false;
      this.isShowSix23 = false;
      this.isShowSix24 = false;
    },
    initSeven: function initSeven() {
      this.isShowSeven = true;
      this.isShowSeven1 = false;
      this.isShowSeven2 = false;
      this.isShowSeven3 = false;
      this.isShowSeven4 = false;
      this.isShowSeven5 = false;
      this.isShowSeven6 = false;
      this.isShowSeven7 = false;
      this.isShowSeven8 = false;
      this.isShowSeven9 = false;
      this.isShowSeven10 = false;
      this.isShowSeven11 = false;
      this.isShowSmallPic = false;
    },
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = true;
    },
    showLoginImg3: function showLoginImg3() {
      this.isShowIcon3 = false;
      this.isShowIcon4 = true;
    },
    showLoginImg4: function showLoginImg4() {
      this.isShowIcon4 = false;
      this.isShowIcon5 = true;
    },
    showLoginImg5: function showLoginImg5() {
      this.isShowIcon5 = false;
      this.isShowIcon6 = true;
    },
    showLoginImg6: function showLoginImg6() {
      this.isShowIcon6 = false;
      this.isShowIcon7 = true;
    },
    showLoginImg7: function showLoginImg7() {
      this.isShowIcon7 = false;
      this.isShowIcon8 = true;
    },
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '13853678478') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != '3346') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowIcon8 = false;
      this.isShowLogin1 = true;
    },
    loginIn1: function loginIn1() {
      this.isShowLogin1 = false;
      this.isShowLogin2 = true;
    },
    loginIn2: function loginIn2() {
      this.isShowLogin2 = false;
      this.isShowLogin3 = true;
    },
    loginIn3: function loginIn3() {
      this.isShowLogin3 = false;
      this.isShowLogin4 = true;
    },
    loginIn4: function loginIn4() {
      var self = this;
      this.isShowLogin4 = false;
      this.isShowLogin5 = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第二布  设置上事件
    setUp: function setUp() {
      this.isShowSetUp = false;
      this.isShowSetUp1 = true;
    },
    setUp1: function setUp1() {
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = true;
    },
    setUp2: function setUp2() {
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = true;
    },
    setUp3: function setUp3() {
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = true;
    },
    setUp4: function setUp4() {
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = true;
    },
    setUp5: function setUp5() {
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = true;
    },
    setUp6: function setUp6() {
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = true;
    },
    setUp7: function setUp7() {
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = true;
    },
    setUp8: function setUp8() {
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = true;
    },
    setUp9: function setUp9() {
      var self = this;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = true;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第三步
    setDown: function setDown() {
      this.isShowSetDown = false;
      this.isShowSetDown1 = true;
    },
    setDown1: function setDown1() {
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = true;
    },
    setDown2: function setDown2() {
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = true;
    },
    setDown3: function setDown3() {
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = true;
    },
    setDown4: function setDown4() {
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = true;
    },
    setDown5: function setDown5() {
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = true;
    },
    setDown6: function setDown6() {
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = true;
    },
    setDown7: function setDown7() {
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = true;
    },
    setDown8: function setDown8() {
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = true;
    },
    setDown9: function setDown9() {
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = true;
    },
    setDown10: function setDown10() {
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = true;
    },
    setDown11: function setDown11() {
      if (this.dyInput == '催单') {
        this.isShowSetDown11 = false;
        this.isShowSetDown12 = true;
      } else {
        this.notify('<p>请按照右边提示输入催单</p>');
      }
    },
    setDown12: function setDown12() {
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = true;
    },
    setDown13: function setDown13() {
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = true;
    },
    // 填写编码配置部分前后
    setDown14: function setDown14() {
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = true;
    },
    setDown16: function setDown16() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = true;
    },
    setDown17: function setDown17() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown16 = false;
      this.isShowSetDown19 = true;
    },
    setDown15: function setDown15() {
      this.isShowSetDown14 = false;
      this.isShowSetDown17 = true;
    },
    setDown18: function setDown18() {
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = true;
    },
    setDown19: function setDown19() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = true;
    },
    setDown20: function setDown20() {
      var _this = this;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = true;
      setTimeout(function () {
        _this.isShowSetDown20 = false;
        _this.isShowSetDown21 = true;
      }, 2000);
    },
    setDown22: function setDown22() {
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = true;
    },
    setDown23: function setDown23() {
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = true;
    },
    setDown24: function setDown24() {
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = true;
    },
    setDown25: function setDown25() {
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = true;
    },
    // 先勾选
    // setDown241() {
    //     this.isShowSetDown24 = false
    //     this.isShowSetDown271 = true
    // },
    // setDown281() {
    //     this.isShowSetDown271 = false
    //     this.isShowSetDown281 = true
    // },
    setDown26: function setDown26() {
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = true;
    },
    setDown27: function setDown27() {
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = true;
    },
    setDown28: function setDown28() {
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = true;
    },
    setDown29: function setDown29() {
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = true;
    },
    setDown30: function setDown30() {
      var _this2 = this;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = true;
      setTimeout(function () {
        _this2.isShowSetDown30 = false;
        _this2.isShowSetDown31 = true;
      }, 2000);
    },
    setDown32: function setDown32() {
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = true;
    },
    setDown33: function setDown33() {
      if (this.downCount == 0) {
        this.$alert('请先下载飞鸽快捷短语模板');
        return false;
      }
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = true;
    },
    setDown34: function setDown34() {
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = true;
    },
    setDown36: function setDown36() {
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = true;
    },
    setDown37: function setDown37() {
      var _this3 = this;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = true;
      setTimeout(function () {
        _this3.isShowSetDown37 = false;
        _this3.isShowSetDown38 = true;
      }, 2000);
    },
    setDown39: function setDown39() {
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = true;
    },
    setDown40: function setDown40() {
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = true;
    },
    setDown41: function setDown41() {
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = true;
    },
    setDown42: function setDown42() {
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = true;
    },
    setDown43: function setDown43() {
      var _this4 = this;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = true;
      setTimeout(function () {
        _this4.isShowSetDown43 = false;
        _this4.isShowSetDown431 = true;
      }, 1500);
    },
    duanyuInput: function duanyuInput(e) {
      if (e.target.value == '/您好') {
        this.isShowSetDown431 = false;
        this.isShowSetDown432 = true;
        // this.isShowSetDown44 = true
      }
    },
    setDown432: function setDown432() {
      var _this5 = this;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = true;
      setTimeout(function () {
        _this5.isShowSetDown433 = false;
        _this5.isShowSetDown434 = true;
      }, 2000);
    },
    duanyuInput1: function duanyuInput1(e) {
      if (e.target.value == '您好') {
        this.isShowSetDown434 = false;
        this.isShowSetDown44 = true;
      }
    },
    setDown45: function setDown45() {
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = true;
    },
    setDown46: function setDown46() {
      this.isShowSetDown45 = false;
      this.isShowSetDown451 = true;
    },
    setDown461: function setDown461() {
      var self = this;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = true;
      this.addRecord('END', 3);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 下载快捷短语
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '飞鸽快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = true;
    },
    // 第四步  操作
    four: function four() {
      this.isShowSession = false;
      this.isShowSession1 = true;
    },
    four1: function four1() {
      this.isShowSession1 = false;
      this.isShowSession2 = true;
    },
    four2: function four2() {
      this.isShowSession2 = false;
      this.isShowSession3 = true;
    },
    four3: function four3() {
      var self = this;
      this.isShowSession3 = false;
      this.isShowSession4 = true;
      this.addRecord('END', 4);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第五步
    five: function five() {
      this.isShowFive = false;
      this.isShowFive1 = true;
    },
    five1: function five1() {
      this.isShowFive1 = false;
      this.isShowFive2 = true;
    },
    five2: function five2() {
      this.isShowFive2 = false;
      this.isShowFive3 = true;
    },
    five3: function five3() {
      var _this6 = this;
      this.isShowFive3 = false;
      this.isShowFive4 = true;
      setTimeout(function () {
        _this6.isShowFive4 = false;
        _this6.isShowFive5 = true;
      }, 2000);
    },
    five5: function five5() {
      this.isShowFive5 = false;
      this.isShowFive6 = true;
    },
    five6: function five6() {
      this.isShowFive6 = false;
      this.isShowFive7 = true;
    },
    five7: function five7() {
      this.isShowFive7 = false;
      this.isShowFive8 = true;
    },
    five8: function five8() {
      var self = this;
      this.isShowFive8 = false;
      this.isShowFive9 = true;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第六步
    six: function six() {
      this.isShowSix = false;
      this.isShowSix1 = true;
    },
    six1: function six1() {
      this.isShowSix1 = false;
      this.isShowSix2 = true;
    },
    beiZhuInput: function beiZhuInput(e) {
      if (e.target.value == '用户要求发顺丰') {
        this.isShowSix2 = false;
        this.isShowSix3 = true;
      }
    },
    six121: function six121() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      } else {
        this.notify('<p>请按照右边提示选择对应的彩旗</p>');
      }
    },
    six122: function six122() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      }
    },
    six3: function six3() {
      this.isShowSix3 = false;
      this.isShowSix4 = true;
    },
    six4: function six4() {
      this.isShowSix4 = false;
      this.isShowSix5 = true;
    },
    six5: function six5() {
      var _this7 = this;
      this.isShowSix5 = false;
      this.isShowSix6 = true;
      setTimeout(function () {
        _this7.isShowSix6 = false;
        _this7.isShowSix7 = true;
      }, 2000);
    },
    six6: function six6() {
      this.isShowSix7 = false;
      this.isShowSix8 = true;
    },
    six7: function six7() {
      var _this8 = this;
      this.isShowSix8 = false;
      this.isShowSix9 = true;
      setTimeout(function () {
        _this8.isShowSix9 = false;
        _this8.isShowSix10 = true;
      }, 2000);
    },
    six8: function six8() {
      this.isShowSix10 = false;
      this.isShowSix11 = true;
    },
    six9: function six9() {
      var _this9 = this;
      this.isShowSix11 = false;
      this.isShowSix12 = true;
      setTimeout(function () {
        _this9.isShowSix12 = false;
        _this9.isShowSix13 = true;
      }, 2000);
    },
    six10: function six10() {
      this.isShowSix13 = false;
      this.isShowSix14 = true;
    },
    six11: function six11() {
      this.isShowSix14 = false;
      this.isShowSix15 = true;
    },
    six12: function six12() {
      if (this.yjgj != '48') {
        this.notify('<p>请按照右边提示输入正确的一键改价价格</p>');
        return;
      }
      if (this.yfInput != '10') {
        this.notify('<p>请按照右边提示输入正确的运费价格</p>');
        return;
      }
      this.isShowSix15 = false;
      this.isShowSix16 = true;
    },
    six13: function six13() {
      var _this0 = this;
      this.isShowSix16 = false;
      this.isShowSix17 = true;
      setTimeout(function () {
        _this0.isShowSix17 = false;
        _this0.isShowSix18 = true;
      }, 2000);
    },
    six14: function six14() {
      this.isShowSix18 = false;
      this.isShowSix19 = true;
    },
    six15: function six15() {
      this.isShowSix19 = false;
      this.isShowSix20 = true;
    },
    six16: function six16() {
      this.isShowSix20 = false;
      this.isShowSix21 = true;
    },
    six17: function six17() {
      if (this.sjhm != '13512345678') {
        this.notify('<p>请按照右边提示输入正确的手机号码</p>');
        return;
      }
      this.isShowSix21 = false;
      this.isShowSix22 = true;
    },
    six18: function six18() {
      var self = this;
      this.isShowSix22 = false;
      this.isShowSix23 = true;
      this.addRecord('END', 6);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第七步
    seven: function seven() {
      this.isShowSeven = false;
      this.isShowSeven1 = true;
    },
    seven1: function seven1() {
      this.isShowSeven1 = false;
      this.isShowSeven2 = true;
    },
    seven2: function seven2() {
      this.isShowSeven2 = false;
      this.isShowSeven3 = true;
    },
    seven3: function seven3() {
      this.isShowSeven3 = false;
      this.isShowSeven4 = true;
    },
    seven4: function seven4() {
      this.isShowSeven4 = false;
      this.isShowSeven5 = true;
    },
    seven5: function seven5() {
      this.isShowSeven5 = false;
      this.isShowSeven6 = true;
    },
    seven6: function seven6() {
      this.isShowSeven6 = false;
      this.isShowSeven7 = true;
    },
    seven7: function seven7() {
      this.isShowSeven7 = false;
      this.isShowSeven8 = true;
    },
    seven8: function seven8() {
      this.isShowSeven8 = false;
      this.isShowSeven9 = true;
    },
    seven9: function seven9() {
      this.isShowSeven9 = false;
      this.isShowSeven10 = true;
    },
    seven10: function seven10() {
      this.isShowSmallPic = true;
    },
    seven11: function seven11() {
      var self = this;
      this.isShowSeven10 = false;
      this.isShowSmallPic = false;
      this.isShowSeven11 = true;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('飞鸽快捷短语') < 0) {
        this.$alert('请选择你下载的“飞鸽快捷短语.csv”模板文件');
        return false;
      }
      setTimeout(function () {
        self.isShowSetDown34 = false;
        self.isShowSetDown35 = true;
      }, 500);
    },
    // 记录接口
    addRecord: function addRecord(type, index) {
      var _this1 = this;
      var data = {
        exerciseType: 'FEIGE_EXAM',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 7 && type == 'END') {
            window.parent['goBack']();
            try {
              _this1.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/courseRecord/tool/addCourseRecord?courseId=10468', null).then(function (response) {});
            } catch (e) {}
          }
        } else {
          _this1.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this1.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //当前标签页
      tabIndex: 1,
      //序号
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt1: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示飞鸽图标
      isShowQnIcon2: false,
      //显示点击飞鸽图标后图片
      isShowIcon3: false,
      //显示选择商家图片
      isShowIcon4: false,
      //显示切换手机号登录页面
      isShowIcon5: false,
      isShowIcon6: false,
      isShowIcon7: false,
      isShowIcon8: false,
      isShowLogin1: false,
      isShowLogin2: false,
      isShowLogin3: false,
      isShowLogin4: false,
      isShowLogin5: false,
      isShowLogin6: false,
      name: '',
      //登录账号
      password: '',
      //密码

      // 第二部
      isShowSetUp: true,
      isShowSetUp1: false,
      isShowSetUp2: false,
      isShowSetUp3: false,
      isShowSetUp4: false,
      isShowSetUp5: false,
      isShowSetUp6: false,
      isShowSetUp7: false,
      isShowSetUp8: false,
      isShowSetUp9: false,
      isShowSetUp10: false,
      // 第三步
      duanyuInputVal: '',
      duanyuInputVal1: '',
      downCount: 0,
      dyInput: '',
      //快捷短语输入
      dynr: '',
      //短语内容
      bmdy: '',
      //编码短语
      isShowSetDown: true,
      isShowSetDown1: false,
      isShowSetDown2: false,
      isShowSetDown3: false,
      isShowSetDown4: false,
      isShowSetDown5: false,
      isShowSetDown6: false,
      isShowSetDown7: false,
      isShowSetDown8: false,
      isShowSetDown9: false,
      isShowSetDown10: false,
      isShowSetDown11: false,
      isShowSetDown12: false,
      isShowSetDown13: false,
      isShowSetDown14: false,
      isShowSetDown15: false,
      isShowSetDown16: false,
      isShowSetDown17: false,
      isShowSetDown18: false,
      isShowSetDown19: false,
      isShowSetDown20: false,
      isShowSetDown21: false,
      isShowSetDown22: false,
      isShowSetDown23: false,
      isShowSetDown24: false,
      isShowSetDown25: false,
      isShowSetDown26: false,
      isShowSetDown27: false,
      isShowSetDown28: false,
      isShowSetDown29: false,
      isShowSetDown30: false,
      isShowSetDown31: false,
      isShowSetDown32: false,
      isShowSetDown33: false,
      isShowSetDown34: false,
      isShowSetDown35: false,
      isShowSetDown36: false,
      isShowSetDown37: false,
      isShowSetDown38: false,
      isShowSetDown39: false,
      isShowSetDown40: false,
      isShowSetDown41: false,
      isShowSetDown42: false,
      isShowSetDown43: false,
      isShowSetDown44: false,
      isShowSetDown45: false,
      isShowSetDown431: false,
      isShowSetDown432: false,
      isShowSetDown433: false,
      isShowSetDown434: false,
      isShowSetDown451: false,
      isShowSetDown452: false,
      // 第四步
      isShowSession: true,
      isShowSession1: false,
      isShowSession2: false,
      isShowSession3: false,
      isShowSession4: false,
      // 第五步
      isShowFive: true,
      isShowFive1: false,
      isShowFive2: false,
      isShowFive3: false,
      isShowFive4: false,
      isShowFive5: false,
      isShowFive6: false,
      isShowFive7: false,
      isShowFive8: false,
      isShowFive9: false,
      // 第六步
      isShowSix: true,
      beizhu: '',
      yjgj: '',
      yfInput: '',
      sjhm: '',
      isShowSix1: false,
      isShowSix2: false,
      isShowSix3: false,
      isShowSix4: false,
      isShowSix5: false,
      isShowSix6: false,
      isShowSix7: false,
      isShowSix8: false,
      isShowSix9: false,
      isShowSix10: false,
      isShowSix11: false,
      isShowSix12: false,
      isShowSix13: false,
      isShowSix14: false,
      isShowSix15: false,
      isShowSix16: false,
      isShowSix17: false,
      isShowSix18: false,
      isShowSix19: false,
      isShowSix20: false,
      isShowSix21: false,
      isShowSix22: false,
      isShowSix23: false,
      isShowSix24: false,
      // 第七步
      isShowSeven: true,
      isShowSeven1: false,
      isShowSeven2: false,
      isShowSeven3: false,
      isShowSeven4: false,
      isShowSeven5: false,
      isShowSeven6: false,
      isShowSeven7: false,
      isShowSeven8: false,
      isShowSeven9: false,
      isShowSeven10: false,
      isShowSeven11: false,
      isShowSmallPic: false
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    var step = this.$route.query.step;
    if (step == 7) {
      this.studyNext('#tab-seven', step, 'seven');
    }
    // 去掉双击事件默认选中
    var select = document.getElementById('select');
    select.onmousedown = function () {
      return false;
    };
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = false;
      this.isShowIcon4 = false;
      this.isShowIcon5 = false;
      this.isShowIcon6 = false;
      this.isShowIcon7 = false;
      this.isShowIcon8 = false;
      this.isShowLogin1 = false;
      this.isShowLogin2 = false;
      this.isShowLogin3 = false;
      this.isShowLogin4 = false;
      this.isShowLogin5 = false;
      this.isShowLogin6 = false;
    },
    initSecond: function initSecond() {
      this.isShowSetUp = true;
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = false;
    },
    initThird: function initThird() {
      this.downCount = 0;
      this.duanyuInputVal = '';
      this.duanyuInputVal1 = '';
      this.dyInput = '',
      //快捷短语输入
      this.dynr = '',
      //短语内容
      this.bmdy = '',
      //编码短语
      this.isShowSetDown = true;
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = false;
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = false;
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = false;
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = false;
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = false;
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = false;
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = false;
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = false;
      this.isShowSetDown431 = false;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = false;
      this.isShowSetDown434 = false;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = false;
    },
    initFour: function initFour() {
      this.isShowSession = true;
      this.isShowSession1 = false;
      this.isShowSession2 = false;
      this.isShowSession3 = false;
      this.isShowSession4 = false;
    },
    initFive: function initFive() {
      this.isShowFive = true;
      this.isShowFive1 = false;
      this.isShowFive2 = false;
      this.isShowFive3 = false;
      this.isShowFive4 = false;
      this.isShowFive5 = false;
      this.isShowFive6 = false;
      this.isShowFive7 = false;
      this.isShowFive8 = false;
      this.isShowFive9 = false;
    },
    initSix: function initSix() {
      this.beizhu = '';
      this.yjgj = '';
      this.yfInput = '';
      this.sjhm = '';
      this.isShowSix = true;
      this.isShowSix1 = false;
      this.isShowSix2 = false;
      this.isShowSix3 = false;
      this.isShowSix4 = false;
      this.isShowSix5 = false;
      this.isShowSix6 = false;
      this.isShowSix7 = false;
      this.isShowSix8 = false;
      this.isShowSix9 = false;
      this.isShowSix10 = false;
      this.isShowSix11 = false;
      this.isShowSix12 = false;
      this.isShowSix13 = false;
      this.isShowSix14 = false;
      this.isShowSix15 = false;
      this.isShowSix16 = false;
      this.isShowSix17 = false;
      this.isShowSix18 = false;
      this.isShowSix19 = false;
      this.isShowSix20 = false;
      this.isShowSix21 = false;
      this.isShowSix22 = false;
      this.isShowSix23 = false;
      this.isShowSix24 = false;
    },
    initSeven: function initSeven() {
      this.isShowSeven = true;
      this.isShowSeven1 = false;
      this.isShowSeven2 = false;
      this.isShowSeven3 = false;
      this.isShowSeven4 = false;
      this.isShowSeven5 = false;
      this.isShowSeven6 = false;
      this.isShowSeven7 = false;
      this.isShowSeven8 = false;
      this.isShowSeven9 = false;
      this.isShowSeven10 = false;
      this.isShowSeven11 = false;
      this.isShowSmallPic = false;
    },
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = true;
    },
    showLoginImg3: function showLoginImg3() {
      this.isShowIcon3 = false;
      this.isShowIcon4 = true;
    },
    showLoginImg4: function showLoginImg4() {
      this.isShowIcon4 = false;
      this.isShowIcon5 = true;
    },
    showLoginImg5: function showLoginImg5() {
      this.isShowIcon5 = false;
      this.isShowIcon6 = true;
    },
    showLoginImg6: function showLoginImg6() {
      this.isShowIcon6 = false;
      this.isShowIcon7 = true;
    },
    showLoginImg7: function showLoginImg7() {
      this.isShowIcon7 = false;
      this.isShowIcon8 = true;
    },
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '13853678478') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != '3346') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowIcon8 = false;
      this.isShowLogin1 = true;
    },
    loginIn1: function loginIn1() {
      this.isShowLogin1 = false;
      this.isShowLogin2 = true;
    },
    loginIn2: function loginIn2() {
      this.isShowLogin2 = false;
      this.isShowLogin3 = true;
    },
    loginIn3: function loginIn3() {
      this.isShowLogin3 = false;
      this.isShowLogin4 = true;
    },
    loginIn4: function loginIn4() {
      var self = this;
      this.isShowLogin4 = false;
      this.isShowLogin5 = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第二布  设置上事件
    setUp: function setUp() {
      this.isShowSetUp = false;
      this.isShowSetUp1 = true;
    },
    setUp1: function setUp1() {
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = true;
    },
    setUp2: function setUp2() {
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = true;
    },
    setUp3: function setUp3() {
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = true;
    },
    setUp4: function setUp4() {
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = true;
    },
    setUp5: function setUp5() {
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = true;
    },
    setUp6: function setUp6() {
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = true;
    },
    setUp7: function setUp7() {
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = true;
    },
    setUp8: function setUp8() {
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = true;
    },
    setUp9: function setUp9() {
      var self = this;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = true;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第三步
    setDown: function setDown() {
      this.isShowSetDown = false;
      this.isShowSetDown1 = true;
    },
    setDown1: function setDown1() {
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = true;
    },
    setDown2: function setDown2() {
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = true;
    },
    setDown3: function setDown3() {
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = true;
    },
    setDown4: function setDown4() {
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = true;
    },
    setDown5: function setDown5() {
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = true;
    },
    setDown6: function setDown6() {
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = true;
    },
    setDown7: function setDown7() {
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = true;
    },
    setDown8: function setDown8() {
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = true;
    },
    setDown9: function setDown9() {
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = true;
    },
    setDown10: function setDown10() {
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = true;
    },
    setDown11: function setDown11() {
      if (this.dyInput == '催单') {
        this.isShowSetDown11 = false;
        this.isShowSetDown12 = true;
      } else {
        this.notify('<p>请按照右边提示输入催单</p>');
      }
    },
    setDown12: function setDown12() {
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = true;
    },
    setDown13: function setDown13() {
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = true;
    },
    // 填写编码配置部分前后
    setDown14: function setDown14() {
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = true;
    },
    setDown16: function setDown16() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = true;
    },
    setDown17: function setDown17() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown16 = false;
      this.isShowSetDown19 = true;
    },
    setDown15: function setDown15() {
      this.isShowSetDown14 = false;
      this.isShowSetDown17 = true;
    },
    setDown18: function setDown18() {
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = true;
    },
    setDown19: function setDown19() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = true;
    },
    setDown20: function setDown20() {
      var _this = this;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = true;
      setTimeout(function () {
        _this.isShowSetDown20 = false;
        _this.isShowSetDown21 = true;
      }, 2000);
    },
    setDown22: function setDown22() {
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = true;
    },
    setDown23: function setDown23() {
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = true;
    },
    setDown24: function setDown24() {
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = true;
    },
    setDown25: function setDown25() {
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = true;
    },
    // 先勾选
    // setDown241() {
    //     this.isShowSetDown24 = false
    //     this.isShowSetDown271 = true
    // },
    // setDown281() {
    //     this.isShowSetDown271 = false
    //     this.isShowSetDown281 = true
    // },
    setDown26: function setDown26() {
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = true;
    },
    setDown27: function setDown27() {
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = true;
    },
    setDown28: function setDown28() {
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = true;
    },
    setDown29: function setDown29() {
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = true;
    },
    setDown30: function setDown30() {
      var _this2 = this;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = true;
      setTimeout(function () {
        _this2.isShowSetDown30 = false;
        _this2.isShowSetDown31 = true;
      }, 2000);
    },
    setDown32: function setDown32() {
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = true;
    },
    setDown33: function setDown33() {
      if (this.downCount == 0) {
        this.$alert('请先下载飞鸽快捷短语模板');
        return false;
      }
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = true;
    },
    setDown34: function setDown34() {
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = true;
    },
    setDown36: function setDown36() {
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = true;
    },
    setDown37: function setDown37() {
      var _this3 = this;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = true;
      setTimeout(function () {
        _this3.isShowSetDown37 = false;
        _this3.isShowSetDown38 = true;
      }, 2000);
    },
    setDown39: function setDown39() {
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = true;
    },
    setDown40: function setDown40() {
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = true;
    },
    setDown41: function setDown41() {
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = true;
    },
    setDown42: function setDown42() {
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = true;
    },
    setDown43: function setDown43() {
      var _this4 = this;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = true;
      setTimeout(function () {
        _this4.isShowSetDown43 = false;
        _this4.isShowSetDown431 = true;
      }, 1500);
    },
    duanyuInput: function duanyuInput(e) {
      if (e.target.value == '/您好') {
        this.isShowSetDown431 = false;
        this.isShowSetDown432 = true;
        // this.isShowSetDown44 = true
      }
    },
    setDown432: function setDown432() {
      var _this5 = this;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = true;
      setTimeout(function () {
        _this5.isShowSetDown433 = false;
        _this5.isShowSetDown434 = true;
      }, 2000);
    },
    duanyuInput1: function duanyuInput1(e) {
      if (e.target.value == '您好') {
        this.isShowSetDown434 = false;
        this.isShowSetDown44 = true;
      }
    },
    setDown45: function setDown45() {
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = true;
    },
    setDown46: function setDown46() {
      this.isShowSetDown45 = false;
      this.isShowSetDown451 = true;
    },
    setDown461: function setDown461() {
      var self = this;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = true;
      this.addRecord('END', 3);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 下载快捷短语
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '飞鸽快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = true;
    },
    // 第四步  操作
    four: function four() {
      this.isShowSession = false;
      this.isShowSession1 = true;
    },
    four1: function four1() {
      this.isShowSession1 = false;
      this.isShowSession2 = true;
    },
    four2: function four2() {
      this.isShowSession2 = false;
      this.isShowSession3 = true;
    },
    four3: function four3() {
      var self = this;
      this.isShowSession3 = false;
      this.isShowSession4 = true;
      this.addRecord('END', 4);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第五步
    five: function five() {
      this.isShowFive = false;
      this.isShowFive1 = true;
    },
    five1: function five1() {
      this.isShowFive1 = false;
      this.isShowFive2 = true;
    },
    five2: function five2() {
      this.isShowFive2 = false;
      this.isShowFive3 = true;
    },
    five3: function five3() {
      var _this6 = this;
      this.isShowFive3 = false;
      this.isShowFive4 = true;
      setTimeout(function () {
        _this6.isShowFive4 = false;
        _this6.isShowFive5 = true;
      }, 2000);
    },
    five5: function five5() {
      this.isShowFive5 = false;
      this.isShowFive6 = true;
    },
    five6: function five6() {
      this.isShowFive6 = false;
      this.isShowFive7 = true;
    },
    five7: function five7() {
      this.isShowFive7 = false;
      this.isShowFive8 = true;
    },
    five8: function five8() {
      var self = this;
      this.isShowFive8 = false;
      this.isShowFive9 = true;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第六步
    six: function six() {
      this.isShowSix = false;
      this.isShowSix1 = true;
    },
    six1: function six1() {
      this.isShowSix1 = false;
      this.isShowSix2 = true;
    },
    beiZhuInput: function beiZhuInput(e) {
      if (e.target.value == '用户要求发顺丰') {
        this.isShowSix2 = false;
        this.isShowSix3 = true;
      }
    },
    six121: function six121() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      } else {
        this.notify('<p>请按照右边提示选择对应的彩旗</p>');
      }
    },
    six122: function six122() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      }
    },
    six3: function six3() {
      this.isShowSix3 = false;
      this.isShowSix4 = true;
    },
    six4: function six4() {
      this.isShowSix4 = false;
      this.isShowSix5 = true;
    },
    six5: function six5() {
      var _this7 = this;
      this.isShowSix5 = false;
      this.isShowSix6 = true;
      setTimeout(function () {
        _this7.isShowSix6 = false;
        _this7.isShowSix7 = true;
      }, 2000);
    },
    six6: function six6() {
      this.isShowSix7 = false;
      this.isShowSix8 = true;
    },
    six7: function six7() {
      var _this8 = this;
      this.isShowSix8 = false;
      this.isShowSix9 = true;
      setTimeout(function () {
        _this8.isShowSix9 = false;
        _this8.isShowSix10 = true;
      }, 2000);
    },
    six8: function six8() {
      this.isShowSix10 = false;
      this.isShowSix11 = true;
    },
    six9: function six9() {
      var _this9 = this;
      this.isShowSix11 = false;
      this.isShowSix12 = true;
      setTimeout(function () {
        _this9.isShowSix12 = false;
        _this9.isShowSix13 = true;
      }, 2000);
    },
    six10: function six10() {
      this.isShowSix13 = false;
      this.isShowSix14 = true;
    },
    six11: function six11() {
      this.isShowSix14 = false;
      this.isShowSix15 = true;
    },
    six12: function six12() {
      if (this.yjgj != '48') {
        this.notify('<p>请按照右边提示输入正确的一键改价价格</p>');
        return;
      }
      if (this.yfInput != '10') {
        this.notify('<p>请按照右边提示输入正确的运费价格</p>');
        return;
      }
      this.isShowSix15 = false;
      this.isShowSix16 = true;
    },
    six13: function six13() {
      var _this0 = this;
      this.isShowSix16 = false;
      this.isShowSix17 = true;
      setTimeout(function () {
        _this0.isShowSix17 = false;
        _this0.isShowSix18 = true;
      }, 2000);
    },
    six14: function six14() {
      this.isShowSix18 = false;
      this.isShowSix19 = true;
    },
    six15: function six15() {
      this.isShowSix19 = false;
      this.isShowSix20 = true;
    },
    six16: function six16() {
      this.isShowSix20 = false;
      this.isShowSix21 = true;
    },
    six17: function six17() {
      if (this.sjhm != '13512345678') {
        this.notify('<p>请按照右边提示输入正确的手机号码</p>');
        return;
      }
      this.isShowSix21 = false;
      this.isShowSix22 = true;
    },
    six18: function six18() {
      var self = this;
      this.isShowSix22 = false;
      this.isShowSix23 = true;
      this.addRecord('END', 6);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第七步
    seven: function seven() {
      this.isShowSeven = false;
      this.isShowSeven1 = true;
    },
    seven1: function seven1() {
      this.isShowSeven1 = false;
      this.isShowSeven2 = true;
    },
    seven2: function seven2() {
      this.isShowSeven2 = false;
      this.isShowSeven3 = true;
    },
    seven3: function seven3() {
      this.isShowSeven3 = false;
      this.isShowSeven4 = true;
    },
    seven4: function seven4() {
      this.isShowSeven4 = false;
      this.isShowSeven5 = true;
    },
    seven5: function seven5() {
      this.isShowSeven5 = false;
      this.isShowSeven6 = true;
    },
    seven6: function seven6() {
      this.isShowSeven6 = false;
      this.isShowSeven7 = true;
    },
    seven7: function seven7() {
      this.isShowSeven7 = false;
      this.isShowSeven8 = true;
    },
    seven8: function seven8() {
      this.isShowSeven8 = false;
      this.isShowSeven9 = true;
    },
    seven9: function seven9() {
      this.isShowSeven9 = false;
      this.isShowSeven10 = true;
    },
    seven10: function seven10() {
      this.isShowSmallPic = true;
    },
    seven11: function seven11() {
      var self = this;
      this.isShowSeven10 = false;
      this.isShowSmallPic = false;
      this.isShowSeven11 = true;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('飞鸽快捷短语') < 0) {
        this.$alert('请选择你下载的“飞鸽快捷短语.csv”模板文件');
        return false;
      }
      setTimeout(function () {
        self.isShowSetDown34 = false;
        self.isShowSetDown35 = true;
      }, 500);
    },
    // 记录接口
    addRecord: function addRecord(type, index) {
      var _this1 = this;
      var data = {
        exerciseType: 'FEIGE_EXAM_11618',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 7 && type == 'END') {
            window.parent['goBack']();
          }
        } else {
          _this1.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this1.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "courseList",
  data: function data() {
    return {
      categoryId: this.$route.query.categoryId,
      courseList: [],
      //四级列表
      tjkId: this.$route.query.tjkId || 12345678,
      //淘金客id
      tabIndex: null //二级tab的index
    };
  },
  // ... 其他代码
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // 每次进入页面时都刷新数据
      vm.Lv3Courses();
    });
  },
  methods: {
    // 返回按钮
    isreturn: function isreturn() {
      localStorage.setItem('needSetDefaultTab2', 'false');
      this.tabIndex = localStorage.getItem('tabIndex');
      this.$router.push({
        path: '/train/index',
        query: {
          tabIndex: this.tabIndex,
          condition: false
        }
      });
    },
    // 获取三级课程列表
    Lv3Courses: function Lv3Courses() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/majors/queryCourseViewNewXlkCategoryId", {
        categoryId: this.categoryId
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this.courseList = result.data.courseViewList;
        } else {
          _this.$alert(result.msg);
        }
      }, function (res) {
        _this.$alert("AJAX请求接口异常！");
      });
    },
    // 点击学习
    goStudy: function goStudy(c) {
      var _this2 = this;
      var assitantType = c.assitantType;
      if (assitantType === "qianniuplugin") {
        this.$router.push({
          name: 'fbtQianniu',
          query: {
            courseId: c.courseId
          }
        });
        return;
      } else if (assitantType === "qianniupluginexam") {
        this.$router.push({
          name: 'fbtQianniuExam',
          query: {
            courseId: c.courseId
          }
        });
        return;
      } else if (assitantType === "jingmaiplugin") {
        this.$router.push({
          name: 'fbtJingmai',
          query: {
            courseId: c.courseId
          }
        });
        return;
      } else if (assitantType === "jingmaipluginexam") {
        this.$router.push({
          name: 'fbtJingmaiExam',
          query: {
            courseId: c.courseId
          }
        });
        return;
      } else if (assitantType === "feigeplugin") {
        this.$router.push({
          name: 'fbtDoudian',
          query: {
            courseId: c.courseId
          }
        });
        return;
      } else if (assitantType === "feigepluginexam") {
        this.$router.push({
          name: 'fbtDoudianExam',
          query: {
            courseId: c.courseId
          }
        });
        return;
      } else {
        var courseId = c.courseId;
        if (c.courseType == "Exam") {
          var trainFlag = null;
          if (c.assitantType == 'fbtExamCourse') {
            trainFlag = 'fbtTrain';
          }
          window.location.href = '/tjkStudy/train/examDetail?courseId=' + c.courseId + '&trainFlag=' + trainFlag + '&assitantType=' + c.assitantType + '&tjkId=' + this.tjkId;
        } else {
          this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + "/course/getKnowledgeListXlk", {
            courseId: courseId
          }).then(function (res) {
            var result = res.data;
            if (result.success) {
              if (result.data.knowledgeRecordFullList.length >= 1) {
                _this2.$router.push({
                  path: '/train/Secondarylist',
                  query: {
                    courseId: courseId,
                    Level: 4,
                    tjkId: _this2.tjkId
                  }
                });
              }
            } else {
              _this2.$alert(result.msg);
            }
          }, function (res) {
            _this2.$alert("AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！");
          });
        }
      }
    }
  }
};

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      myExamNum: null,
      //我的完成次数
      nextCourseId: null,
      //下个课程，一般用于 功能学习的，下个课程
      examNum: null,
      tabIndex: 0,
      //序号
      tabCurrent: 'zero',
      //当前标签页
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      isOpenPpt61: false,
      //是否展开ppt
      isOpenPpt7: false,
      //是否展开ppt
      isOpenPpt8: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示千牛图标
      isShowQnIcon2: false,
      //显示点击千牛图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      mouseFocusSaveAP: false,
      //鼠标焦点
      isSaveAP: false,
      //是否保存账号密码
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      mouseFocusRnd: false,
      //鼠标焦点
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      mouseFocusJD: false,
      //鼠标焦点
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      gqstep: 1,
      //挂起步骤
      wgqstep: 1,
      mouseFocusZX: false,
      //鼠标焦点
      mouseFocusGQ: false,
      mouseFocusDdsc: false,
      mouseFocusSet: false,
      mouseFocusSetInfo: false,
      mouseFocusSetInfoDetail: false,
      secondStep: 1,
      secondStepStep: 1,
      //第3步---------
      kjdyStep: 1,
      kjdySearch: '',
      mouseFocusKJDY: false,
      mouseFocusFZ: false,
      mouseFocusFZI: false,
      kjdybm: '',
      kjdynr: '',
      kjdyfz: '',
      kjdyfs: '',
      //第4步---------
      cygnStep: 1,
      mouseFocus: false,
      zjyy: '',
      //第5步---------
      zncjsstep: 1,
      //第6步---------
      zncjxstep: 1,
      showYfstep: false,
      yfamount: '0',
      bznr: '',
      phone: '18418966473-4839',
      //第7（6-1）步---------
      qtcjStep: 1,
      gfkf: '',
      //第8步---------
      shcygnStep: 1,
      //第9步---------
      tcqnStep: 1
    };
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this.tabCurrent).show();
      _this.$set(_this.isShowBtn, _this.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    goExam: function goExam() {
      if (this.examNum && this.myExamNum >= this.examNum) {
        if (this.nextCourseId) {
          this.$router.replace({
            name: 'fbtQianniuExam',
            query: {
              courseId: this.nextCourseId
            }
          });
        } else {
          this.$router.back();
        }
      } else {
        location.reload();
      }
    },
    resetFocus: function resetFocus() {
      this.mouseFocus = false;
      this.mouseFocusZX = false;
      this.mouseFocusGQ = false;
      this.mouseFocusDdsc = false;
      this.mouseFocusSet = false;
      this.mouseFocusSetInfo = false;
      this.mouseFocusSetInfoDetail = false;
      this.mouseFocusKJDY = false;
      this.mouseFocusFZ = false;
      this.mouseFocusFZI = false;
      this.mouseFocusSaveAP = false;
      this.mouseFocusRnd = false;
      this.mouseFocusJD = false;
    },
    //&&*************第三步的内容*****/
    kjdyfsChange: function kjdyfsChange(e) {
      if (e == '/欢迎') {
        this.kjdyStep = 15;
      }
    },
    enterSelect: function enterSelect() {
      var _this2 = this;
      this.kjdyStep = 16;
      var self = this;
      this.$nextTick(function () {
        _this2.$refs.sixInput.focus();
      });
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$alert('请选择你下载的"快捷短语.csv"模板文件');
        return false;
      }
      var fileInput = this.$refs.fileInput;
      setTimeout(function () {
        fileInput.value = "";
        self.kjdyStep = 11;
      }, 500);
    },
    kjdyConfirm: function kjdyConfirm() {
      if (this.kjdynr != '亲，欢迎光临，请问有什么可以帮您的？') {
        this.$alert('请输入正确的快捷短语内容！');
        return;
      }
      if (this.kjdybm != '欢迎') {
        this.$alert('请输入正确的编码');
        return;
      }
      this.kjdyStep = 9;
    },
    kjdySearchChange: function kjdySearchChange() {
      if (this.kjdySearch == '淘金云客服:小淘') {
        var self = this;
        setTimeout(function () {
          self.kjdyStep = 2;
        }, 500);
      }
    },
    kjdyfzConfirm: function kjdyfzConfirm() {
      if (this.kjdyfz == '开头语') {
        this.kjdyStep = 8;
        return;
      }
      this.$alert('分组名称应为: 开头语');
    },
    //********第四步的内容**********/
    fourStepBystep: function fourStepBystep() {
      this.cygnStep = 3;
      var self = this;
      setTimeout(function () {
        self.cygnStep = 4;
      }, 2500);
    },
    sendZfyy: function sendZfyy() {
      if (this.zjyy == '少件') {
        this.cygnStep = 7;
        var self = this;
        this.addRecord('END');
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
        return;
      }
      this.$alert('请输入正确的转交原因');
    },
    //********第5步的内容**********/
    tjspEnd: function tjspEnd() {
      this.zncjsstep = 3;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /********第6步的内*********/sixStepByStep: function sixStepByStep() {
      this.zncjxstep = 4;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 5;
      }, 2500);
    },
    sixStepByStep2: function sixStepByStep2() {
      this.zncjxstep = 6;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 7;
      }, 2500);
    },
    sixStepByStep3: function sixStepByStep3() {
      if (this.yfamount == 8) {
        this.showYfstep = false;
        this.yfamount = '';
        this.zncjxstep = 8;
        return;
      }
      this.$alert('请输入正确的邮费');
    },
    sixStepByStep4: function sixStepByStep4() {
      if (this.bznr == '发顺丰') {
        this.bznr = '';
        this.zncjxstep = 11;
        var self = this;
        setTimeout(function () {
          self.zncjxstep = 12;
        }, 2500);
        return;
      }
      this.$alert('请输入正确的备注');
    },
    sixStepByStep5: function sixStepByStep5() {
      this.zncjxstep = 13;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 14;
      }, 2500);
    },
    sixStepByStep6: function sixStepByStep6() {
      if (this.phone == '13656565656') {
        this.zncjxstep = 16;
        var self = this;
        this.addRecord('END');
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
        return;
      }
      this.$alert('请输入正确的电话号码！');
    },
    six1StepEnd: function six1StepEnd() {
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /********第7 8步的内*********/sevenStepEnd: function sevenStepEnd() {
      this.shcygnStep = 6;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    eightStepEnd: function eightStepEnd() {
      this.tcqnStep = 7;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /******************/
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('zero').play();
      $('#startvideo').hide();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.isSaveAP = false; //是否保存账号密码
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.gqstep = 1; //挂起步骤
      this.wgqstep = 1; //未挂起步骤
      this.secondStep = 1;
      this.secondStepStep = 1;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.kjdyStep = 1;
      this.kjdySearch = '';
      this.mouseFocusKJDY = false;
      this.mouseFocusFZ = false;
      this.mouseFocusFZI = false;
      this.kjdybm = '';
      this.kjdynr = '';
      this.kjdyfz = '';
      this.kjdyfs = '';
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.cygnStep = 1;
      this.zjyy = '';
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.zncjsstep = 1;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.zncjxstep = 1;
      this.showYfstep = false;
      this.yfamount = '0';
      this.bznr = '';
      this.phone = '18418966473-4839';
    },
    //初始化第6-1步状态值
    initSix1: function initSix1() {
      this.qtcjStep = 1;
      this.gfkf = null;
    },
    //初始化第7步状态值
    initSeven: function initSeven() {
      this.shcygnStep = 1;
    },
    //初始化第8步状态值
    initEight: function initEight() {
      this.tcqnStep = 1;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      $('#startvideo').hide();
      this.isShowBtn = [];
      this.isOpenPpt = false;
      this.isOpenPpt2 = false;
      this.isOpenPpt3 = false;
      this.isOpenPpt4 = false;
      this.isOpenPpt5 = false;
      this.isOpenPpt6 = false;
      this.isOpenPpt61 = false;
      this.isOpenPpt7 = false;
      this.isOpenPpt8 = false;
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      $('#pdf_viewer61').height('0');
      $('#pdf_viewer7').height('0');
      $('#pdf_viewer8').height('0');
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第6-1步
      this.initSix1();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
      $('.content').each(function (i) {
        $(this).hide();
      });
      $('.stoptip').each(function (i) {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function (i) {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show();
    },
    //tab切换
    handleClick: function handleClick(tab, event) {
      var _this3 = this;
      this.tabIndex = parseInt(tab.index);
      //内容初始化
      this.initAll();
      this.resetFocus();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this3.tabCurrent).show();
        _this3.$set(_this3.isShowBtn, _this3.tabCurrent, true);
      }, false);
    },
    //展开/收起ppt
    viewPpt: function viewPpt(bol) {
      if (this.isOpenPpt == true || !bol) {
        this.isOpenPpt = false;
        $('#pdf_viewer').height('0');
      } else {
        this.isOpenPpt = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/661361ebec2f434fb859625f84480ea0.pdf', "#pdf_viewer", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt2: function viewPpt2(bol) {
      if (this.isOpenPpt2 == true || !bol) {
        this.isOpenPpt2 = false;
        $('#pdf_viewer2').height('0');
      } else {
        this.isOpenPpt2 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer2').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/e203c6b30e9049818094cee869c17026.pdf', "#pdf_viewer2", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt3: function viewPpt3(bol) {
      if (this.isOpenPpt3 == true || !bol) {
        this.isOpenPpt3 = false;
        $('#pdf_viewer3').height('0');
      } else {
        this.isOpenPpt3 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer3').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/6fa4070d7418446690ce19576261afe5.pdf ', "#pdf_viewer3", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt4: function viewPpt4(bol) {
      if (this.isOpenPpt4 == true || !bol) {
        this.isOpenPpt4 = false;
        $('#pdf_viewer4').height('0');
      } else {
        this.isOpenPpt4 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer4').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/8a2815e9246840c2be40e87ac705da18.pdf', "#pdf_viewer4", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt5: function viewPpt5(bol) {
      if (this.isOpenPpt5 == true || !bol) {
        this.isOpenPpt5 = false;
        $('#pdf_viewer5').height('0');
      } else {
        this.isOpenPpt5 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer5').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/52d4b0fc262c4b058ddee379d625552f.pdf', "#pdf_viewer5", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt6: function viewPpt6(bol) {
      if (this.isOpenPpt6 == true || !bol) {
        this.isOpenPpt6 = false;
        $('#pdf_viewer6').height('0');
      } else {
        this.isOpenPpt6 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer6').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/5490dc4ddc6c4e73897aaa3332e5a3d1.pdf', "#pdf_viewer6", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt61: function viewPpt61(bol) {
      if (this.isOpenPpt61 == true || !bol) {
        this.isOpenPpt61 = false;
        $('#pdf_viewer61').height('0');
      } else {
        this.isOpenPpt61 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer61').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/%E6%B7%BB%E5%8A%A0%E5%85%B6%E4%BB%96%E6%8F%92%E4%BB%B6-%E5%B0%8F%E5%8A%A9%E6%89%8B%E4%B8%8A%E8%AF%BE%E4%BB%B6.pdf', "#pdf_viewer61", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt7: function viewPpt7(bol) {
      if (this.isOpenPpt7 == true || !bol) {
        this.isOpenPpt7 = false;
        $('#pdf_viewer7').height('0');
      } else {
        this.isOpenPpt7 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer7').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/4183c223f03d4892a6768486996d5455.pdf', "#pdf_viewer7", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt8: function viewPpt8(bol) {
      if (this.isOpenPpt8 == true || !bol) {
        this.isOpenPpt8 = false;
        $('#pdf_viewer8').height('0');
      } else {
        this.isOpenPpt8 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer8').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2024-12/d138c13a5f304a0198294afb2495384b.pdf', "#pdf_viewer8", options);
        }
      }
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //开始实操练习
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.isShowBtn[this.tabCurrent] = false;
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START');
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initFirst();
      this.initSecond();
      this.initThird();
      this.initFour();
      this.initFive();
      this.initSix();
      this.initSix1();
      this.initSeven();
      this.initEight();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    //第1步-单击千牛图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击千牛图标
    showLoginImg2: function showLoginImg2(event) {
      event.preventDefault();
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '淘金云客服:小淘') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != 'Tj1234') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowLoginImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.notify('<p>请输入短信验证码</p>');
        return;
      } else if (this.rnd != '660220') {
        this.notify('<p>短信验证码错误</p>');
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showGqImgClick: function showGqImgClick() {
      this.secondStepStep = 5;
      this.addRecord('END');
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    finishThird: function finishThird() {
      this.kjdyStep = 17;
      this.addRecord('END');
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
    },
    restartStudyFirst: function restartStudyFirst() {
      this.initFirst();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudySecond: function restartStudySecond() {
      this.initSecond();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyThird: function restartStudyThird() {
      this.initThird();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyFour: function restartStudyFour() {
      this.initFour();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyFive: function restartStudyFive() {
      this.initFive();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudySix: function restartStudySix() {
      this.initSix();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudySix1: function restartStudySix1() {
      this.initSix1();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudySeven: function restartStudySeven() {
      this.initSeven();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyEight: function restartStudyEight() {
      this.initEight();
      this.resetFocus();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type) {
      var _this4 = this;
      var data = {
        exerciseType: "QIANNIU_PLUGIN",
        stepSeq: this.tabIndex,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this4.tabIndex == 9 && type == 'END') {
            _this4.queryFinishInfo();
          }
        } else {
          _this4.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (res) {
        _this4.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1500
        });
      });
    },
    //查，完成了几次
    queryFinishInfo: function queryFinishInfo() {
      var _this5 = this;
      var query = {
        assitantType: "qianniuplugin",
        courseId: this.$route.query.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryFinishInfo', query).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this5.myExamNum = result.data.examNum;
          _this5.examNum = result.data.targetPassCnt;
          _this5.nextCourseId = result.data.nextCourseId;
        } else {
          _this5.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (res) {
        _this5.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1500
        });
      });
    },
    onGfkfInput: function onGfkfInput() {
      if (this.gfkf && this.gfkf.trim() === '天猫官方客服') {
        this.qtcjStep = 2;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      myExamNum: null,
      //我的完成次数
      nextCourseId: null,
      //下个课程，一般用于 功能学习的，下个课程
      examNum: null,
      categoryId: this.$route.query.categoryId,
      tjkId: this.$route.query.tjkId,
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //第1步
      isShowQnIcon: true,
      //是否显示千牛图标
      isShowQnIcon2: false,
      //显示点击千牛图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      mouseFocusSaveAP: false,
      //鼠标焦点
      isSaveAP: false,
      //是否保存账号密码
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      mouseFocusRnd: false,
      //鼠标焦点
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      mouseFocusJD: false,
      //鼠标焦点
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      gqstep: 1,
      //挂起步骤
      wgqstep: 1,
      mouseFocusZX: false,
      //鼠标焦点
      mouseFocusGQ: false,
      mouseFocusDdsc: false,
      mouseFocusSet: false,
      mouseFocusSetInfo: false,
      mouseFocusSetInfoDetail: false,
      secondStep: 1,
      secondStepStep: 1,
      //第3步---------
      kjdyStep: 1,
      kjdySearch: '',
      mouseFocusKJDY: false,
      mouseFocusFZ: false,
      mouseFocusFZI: false,
      kjdybm: '',
      kjdynr: '',
      kjdyfz: '',
      kjdyfs: '',
      //第4步---------
      cygnStep: 1,
      mouseFocus: false,
      zjyy: '',
      //第5步---------
      zncjsstep: 1,
      //第6步---------
      zncjxstep: 15,
      showYfstep: false,
      yfamount: '0',
      bznr: '',
      phone: '18418966473-4839',
      //第7（6-1）步---------
      qtcjStep: 1,
      gfkf: '',
      //第8步---------
      shcygnStep: 1,
      //第9步---------
      tcqnStep: 1
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    var step = this.$route.query.step;
    if (step == 8) {
      this.studyNext('#tab-eight', step, 'eight');
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
    //跳到末尾步骤
    if (this.$route.query.end) {
      this.tabCurrent = 'eight';
      this.eightStepEnd();
    }
  },
  methods: {
    goExam: function goExam() {
      if (this.examNum && this.myExamNum >= this.examNum) {
        this.$router.back();
      } else {
        location.reload();
      }
    },
    goBack: function goBack() {
      this.$router.back();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.isSaveAP = false; //是否保存账号密码
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.gqstep = 1; //挂起步骤
      this.wgqstep = 1; //未挂起步骤
      this.secondStep = 1;
      this.secondStepStep = 1;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.kjdyStep = 1;
      this.kjdySearch = '';
      this.mouseFocusKJDY = false;
      this.mouseFocusFZ = false;
      this.mouseFocusFZI = false;
      this.kjdybm = '';
      this.kjdynr = '';
      this.kjdyfz = '';
      this.kjdyfs = '';
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.cygnStep = 1;
      this.zjyy = '';
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.zncjsstep = 1;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.zncjxstep = 1;
      this.showYfstep = false;
      this.yfamount = '0';
      this.bznr = '';
      this.phone = '18418966473-4839';
    },
    initSix1: function initSix1() {
      this.qtcjStep = 1;
      this.gfkf = '';
    },
    //初始化第7步状态值
    initSeven: function initSeven() {
      this.shcygnStep = 1;
    },
    //初始化第8步状态值
    initEight: function initEight() {
      this.tcqnStep = 1;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      this.initSix1();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
      this.resetFocus();
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    resetFocus: function resetFocus() {
      this.mouseFocus = false;
      this.mouseFocusZX = false;
      this.mouseFocusGQ = false;
      this.mouseFocusDdsc = false;
      this.mouseFocusSet = false;
      this.mouseFocusSetInfo = false;
      this.mouseFocusSetInfoDetail = false;
      this.mouseFocusKJDY = false;
      this.mouseFocusFZ = false;
      this.mouseFocusFZI = false;
      this.mouseFocusSaveAP = false;
      this.mouseFocusRnd = false;
      this.mouseFocusJD = false;
    },
    //第1步-单击千牛图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击千牛图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '淘金云客服:小淘') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != 'Tj1234') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowLoginImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.notify('<p>请输入短信验证码</p>');
        return;
      } else if (this.rnd != '660220') {
        this.notify('<p>短信验证码错误</p>');
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showGqImgClick: function showGqImgClick() {
      this.secondStepStep = 5;
      this.addRecord('END', 2);
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    finishThird: function finishThird() {
      this.kjdyStep = 17;
      this.addRecord('END', 3);
      var self = this;
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
    },
    kjdyfsChange: function kjdyfsChange(e) {
      if (e == '/欢迎') {
        this.kjdyStep = 15;
      }
    },
    enterSelect: function enterSelect() {
      var _this = this;
      this.kjdyStep = 16;
      var self = this;
      this.$nextTick(function () {
        _this.$refs.sixInput.focus();
      });
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$alert('请选择你下载的“快捷短语.csv”模板文件');
        return false;
      }
      var fileInput = this.$refs.fileInput;
      setTimeout(function () {
        fileInput.value = "";
        self.kjdyStep = 11;
      }, 500);
    },
    kjdyConfirm: function kjdyConfirm() {
      if (this.kjdynr != '亲，欢迎光临，请问有什么可以帮您的？') {
        this.$alert('请输入正确的快捷短语内容！');
        return;
      }
      if (this.kjdybm != '欢迎') {
        this.$alert('请输入正确的编码');
        return;
      }
      this.kjdyStep = 9;
    },
    kjdySearchChange: function kjdySearchChange() {
      if (this.kjdySearch == '淘金云客服:小淘') {
        var self = this;
        setTimeout(function () {
          self.kjdyStep = 2;
        }, 500);
      }
    },
    kjdyfzConfirm: function kjdyfzConfirm() {
      if (this.kjdyfz == '开头语') {
        this.kjdyStep = 8;
        return;
      }
      this.$alert('分组名称应为: 开头语');
    },
    //********第四步的内容**********/
    fourStepBystep: function fourStepBystep() {
      this.cygnStep = 3;
      var self = this;
      setTimeout(function () {
        self.cygnStep = 4;
      }, 2500);
    },
    sendZfyy: function sendZfyy() {
      if (this.zjyy == '少件') {
        this.cygnStep = 7;
        var self = this;
        this.addRecord('END', 4);
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
        return;
      }
      this.$alert('请输入正确的转交原因');
    },
    //********第5步的内容**********/
    tjspEnd: function tjspEnd() {
      this.zncjsstep = 3;
      var self = this;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /********第6步的内*********/sixStepByStep: function sixStepByStep() {
      this.zncjxstep = 4;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 5;
      }, 2500);
    },
    sixStepByStep2: function sixStepByStep2() {
      this.zncjxstep = 6;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 7;
      }, 2500);
    },
    sixStepByStep3: function sixStepByStep3() {
      if (this.yfamount == 8) {
        this.showYfstep = false;
        this.yfamount = '';
        this.zncjxstep = 8;
        return;
      }
      this.$alert('请输入正确的邮费');
    },
    sixStepByStep4: function sixStepByStep4() {
      if (this.bznr == '发顺丰') {
        this.bznr = '';
        this.zncjxstep = 11;
        var self = this;
        setTimeout(function () {
          self.zncjxstep = 12;
        }, 2500);
        return;
      }
      this.$alert('请输入正确的备注');
    },
    sixStepByStep5: function sixStepByStep5() {
      this.zncjxstep = 13;
      var self = this;
      setTimeout(function () {
        self.zncjxstep = 14;
      }, 2500);
    },
    sixStepByStep6: function sixStepByStep6() {
      if (this.phone == '13656565656') {
        this.zncjxstep = 16;
        var self = this;
        this.addRecord('END', 6);
        setTimeout(function () {
          $('#studytip-' + self.tabCurrent).show();
        }, 2000);
        return;
      }
      this.$alert('请输入正确的电话号码！');
    },
    onGfkfInput: function onGfkfInput() {
      if (this.gfkf && this.gfkf.trim() === '天猫官方客服') {
        this.qtcjStep = 2;
      }
    },
    six1StepEnd: function six1StepEnd() {
      var self = this;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /********第7 8步的内*********/sevenStepEnd: function sevenStepEnd() {
      this.shcygnStep = 6;
      var self = this;
      this.addRecord('END', 8);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    eightStepEnd: function eightStepEnd() {
      debugger;
      this.tcqnStep = 7;
      var self = this;
      this.addRecord('END', 9);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this2 = this;
      var data = {
        exerciseType: 'QIANNIU_PLUGIN_EXAM',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 9 && type == 'END') {
            _this2.queryFinishInfo();
          }
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this2.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    //查，完成了几次
    queryFinishInfo: function queryFinishInfo() {
      var _this3 = this;
      var query = {
        assitantType: "qianniupluginexam",
        courseId: this.$route.query.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryFinishInfo', query).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this3.myExamNum = result.data.examNum;
          _this3.examNum = result.data.targetPassCnt;
          _this3.nextCourseId = result.data.nextCourseId;
        } else {
          _this3.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (res) {
        _this3.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1500
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _FastReplyImportDialog = _interopRequireDefault(__webpack_require__(1705));
var _FastReplyEditorDialog = _interopRequireDefault(__webpack_require__(968));
var _TrainScoreDialog = _interopRequireDefault(__webpack_require__(970));
var _order = _interopRequireDefault(__webpack_require__(972));
var _OrderMsgCard = _interopRequireDefault(__webpack_require__(973));
var _CourseProductModal = _interopRequireDefault(__webpack_require__(975));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'jingmaiChat',
  data: function data() {
    return {
      sceneId: this.$route.query.sceneId,
      hasProducts: false,
      settings: {
        isStart: false,
        onlineStatus: '1',
        isRecommendReply: false,
        time: 0,
        collapsedGroups: {},
        groups: [],
        defaultGroupId: null,
        trainId: null,
        trainSession: [],
        isMaxSession: false
      },
      timer: null,
      taskATimer: null,
      taskBTimer: null,
      taskCTimer: null,
      keyword: '',
      showImport: false,
      showEditor: false,
      showScore: false,
      trainResult: null,
      editorValue: null,
      // 外部订单数据：jingmai
      ordersJingmai: _order.default.jingmai,
      menu: {
        visible: false,
        x: 0,
        y: 0,
        group: null,
        reply: null,
        type: 'group'
      },
      fastReplyList: [],
      replyText: '',
      fullLoading: null,
      showQuickReplySuggestions: false,
      quickReplySuggestions: [],
      selectedSuggestionIndex: 0,
      // 打字速度（实用口径 + 粘贴修正）
      typingStartMs: null,
      typingAccumMs: 0,
      typedCharsTotal: 0,
      pastedCharsCurrent: 0,
      // 订单头部展示信息
      orderHeader: {
        orderNo: '',
        orderTime: '',
        orderPayTime: ''
      }
    };
  },
  components: {
    FastReplyImportDialog: _FastReplyImportDialog.default,
    FastReplyEditorDialog: _FastReplyEditorDialog.default,
    TrainScoreDialog: _TrainScoreDialog.default,
    OrderMsgCard: _OrderMsgCard.default,
    CourseProductModal: _CourseProductModal.default
  },
  mounted: function mounted() {
    this.refreshFastReply();
    // 生成随机订单号和下单时间（早于昨天）
    this.generateOrderHeader();
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁前清理所有定时器，防止内存泄漏
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.taskATimer) {
      clearInterval(this.taskATimer);
      this.taskATimer = null;
    }
    if (this.taskBTimer) {
      clearInterval(this.taskBTimer);
      this.taskBTimer = null;
    }
    if (this.taskCTimer) {
      clearInterval(this.taskCTimer);
      this.taskCTimer = null;
    }
    if (this.fullLoading) {
      this.fullLoading.close();
      this.fullLoading = null;
    }
  },
  watch: {
    matchedOrder: {
      handler: function handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          this.generateOrderHeader();
        }
      }
    }
  },
  computed: {
    matchedOrder: function matchedOrder() {
      var session = this.currentSession;
      if (!session || !Array.isArray(session.quesList) || !session.quesList.length) return null;
      // 取当前对方发出的最后一个问题（已送达：sendTime 存在）的 questionOrderId
      var lastDelivered = null;
      for (var i = session.quesList.length - 1; i >= 0; i--) {
        var q = session.quesList[i];
        if (q && q.sendTime && q.questionOrderId) {
          lastDelivered = q;
          break;
        }
      }
      if (!lastDelivered) return null;
      var list = this.ordersJingmai || [];
      return list.find(function (o) {
        return String(o.id) === String(lastDelivered.questionOrderId);
      }) || null;
    },
    formattedTime: function formattedTime() {
      var t = Math.max(0, this.settings.time | 0);
      var m = String(Math.floor(t / 60)).padStart(2, '0');
      var s = String(t % 60).padStart(2, '0');
      return "00:".concat(m, ":").concat(s);
    },
    currentSession: function currentSession() {
      return (this.settings.trainSession || []).find(function (s) {
        return s.isCurrent;
      }) || null;
    },
    currentMessages: function currentMessages() {
      var _this = this;
      if (!this.currentSession) return [];
      var messages = [];
      this.currentSession.quesList.forEach(function (q) {
        if (q.sendTime) {
          console.log('[order-card]', {
            questionType: q.questionType,
            questionOrderId: q.questionOrderId,
            matched: !!_this.findOrderById(q.questionOrderId),
            q: q
          });
          messages.push(q);
        }
      });
      return messages;
    },
    totalReplyCount: function totalReplyCount() {
      var count = 0;
      (this.settings.trainSession || []).forEach(function (s) {
        (s.quesList || []).forEach(function (q) {
          if (Array.isArray(q.replyList)) {
            count += q.replyList.length;
          }
        });
      });
      return count;
    },
    firstResponseAvgSec: function firstResponseAvgSec() {
      var sessions = this.settings.trainSession || [];
      var deltas = [];
      sessions.forEach(function (s) {
        var firstQ = (s.quesList || [])[0];
        if (!firstQ || !firstQ.sendTime) return;
        var firstReply = (firstQ.replyList || []).find(function (r) {
          return r && r.sendTime;
        });
        if (!firstReply) return;
        var deltaMs = Number(firstReply.sendTime) - Number(firstQ.sendTime);
        if (isFinite(deltaMs) && deltaMs >= 0) {
          deltas.push(deltaMs);
        }
      });
      if (!deltas.length) return 0;
      var avgMs = deltas.reduce(function (a, b) {
        return a + b;
      }, 0) / deltas.length;
      return Math.round(avgMs / 1000);
    },
    avgResponseSec: function avgResponseSec() {
      var sessions = this.settings.trainSession || [];
      var deltas = [];
      sessions.forEach(function (s) {
        (s.quesList || []).forEach(function (q) {
          if (!q || !q.sendTime) return;
          var firstReply = (q.replyList || []).find(function (r) {
            return r && r.sendTime;
          });
          if (!firstReply) return;
          var deltaMs = Number(firstReply.sendTime) - Number(q.sendTime);
          if (isFinite(deltaMs) && deltaMs >= 0) {
            deltas.push(deltaMs);
          }
        });
      });
      if (!deltas.length) return 0;
      var avgMs = deltas.reduce(function (a, b) {
        return a + b;
      }, 0) / deltas.length;
      return Math.round(avgMs / 1000);
    },
    typingSpeedWPM: function typingSpeedWPM() {
      var ms = Number(this.typingAccumMs) || 0;
      var chars = Number(this.typedCharsTotal) || 0;
      if (ms <= 0 || chars <= 0) return 0;
      var minutes = ms / 60000;
      if (minutes <= 0) return 0;
      return Math.round(chars / minutes);
    },
    filteredFastReplyList: function filteredFastReplyList() {
      if (!this.keyword || !this.keyword.trim()) {
        // 无关键词时返回原始数据，展开所有分组
        return (this.fastReplyList || []).map(function (g) {
          return _objectSpread(_objectSpread({}, g), {}, {
            filteredReplyList: g.replyList || []
          });
        });
      }
      var keyword = this.keyword.trim().toLowerCase();
      return (this.fastReplyList || []).map(function (g) {
        var filtered = (g.replyList || []).filter(function (r) {
          var quicktext = (r.quicktext || '').toLowerCase();
          var replytext = (r.replytext || '').toLowerCase();
          return quicktext.includes(keyword) || replytext.includes(keyword);
        });
        return _objectSpread(_objectSpread({}, g), {}, {
          filteredReplyList: filtered
        });
      }).filter(function (g) {
        return g.filteredReplyList.length > 0;
      }); // 只显示有匹配项的分组
    }
  },
  methods: (0, _defineProperty2.default)({
    // 根据 questionOrderId 匹配本地订单数据，用于聊天流订单卡片
    findOrderById: function findOrderById(orderId) {
      var list = this.ordersJingmai || [];
      var order = orderId != null && orderId !== '' ? list.find(function (o) {
        return String(o.id) === String(orderId);
      }) : null;
      // 匹配不到用 1101 兜底
      return order || list.find(function (o) {
        return String(o.id) === '1101';
      }) || null;
    },
    sendReply: function sendReply() {
      var _this2 = this;
      var text = (this.replyText || '').trim();
      if (!text || !this.currentSession) {
        this.$message({
          type: 'error',
          message: '请先选择一个会话'
        });
        return;
      }
      if (text.length > 2000) {
        this.$message({
          type: 'warning',
          message: '消息内容过长，请控制在2000字符以内'
        });
        return;
      }
      var target = null;
      var list = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
      for (var i = list.length - 1; i >= 0; i--) {
        var q = list[i];
        if (q && q.sendTime) {
          target = q;
          break;
        }
      }
      if (!target) {
        this.$message({
          type: 'warning',
          message: '暂无可回复的问题'
        });
        return;
      }
      if (!Array.isArray(target.replyList)) {
        this.$set(target, 'replyList', []);
      }
      var now = Date.now();
      if (this.typingStartMs) {
        this.typingAccumMs += Math.max(0, now - this.typingStartMs);
      }
      var effectiveChars = Math.max(0, text.length - (this.pastedCharsCurrent || 0));
      this.typedCharsTotal += effectiveChars;
      var localMinutes = ((this.typingStartMs ? now - this.typingStartMs : 0) || 0) / 60000;
      var localSpeed = localMinutes > 0 ? Math.round(effectiveChars / localMinutes) : 0;
      this.typingStartMs = null;
      this.pastedCharsCurrent = 0;
      target.replyList.push({
        id: 'local-' + Date.now(),
        from: 'self',
        fromName: '',
        sendTime: now,
        content: text
      });
      this.sendMsg(0, text, localSpeed, '', '', target.id, this.currentSession && this.currentSession.id);
      this.replyText = '';
      this.$nextTick(function () {
        _this2.scrollChatToBottom();
      });
    },
    generateOrderHeader: function generateOrderHeader() {
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      // 订单号：年月日时分秒 + 随机4位
      var now = new Date();
      var no = "".concat(now.getFullYear()).concat(pad(now.getMonth() + 1)).concat(pad(now.getDate())).concat(pad(now.getHours())).concat(pad(now.getMinutes())).concat(pad(now.getSeconds())).concat(Math.floor(1000 + Math.random() * 9000));
      // 时间：在昨天之前的随机时间
      var todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      var yesterdayStart = new Date(todayStart.getTime() - 24 * 60 * 60 * 1000);
      var threeDaysAgo = new Date(yesterdayStart.getTime() - 3 * 24 * 60 * 60 * 1000);
      var ts = threeDaysAgo.getTime() + Math.random() * (yesterdayStart.getTime() - threeDaysAgo.getTime() - 1);
      var dt = new Date(ts);
      var timeStr = "".concat(dt.getFullYear(), "-").concat(pad(dt.getMonth() + 1), "-").concat(pad(dt.getDate()), " ").concat(pad(dt.getHours()), ":").concat(pad(dt.getMinutes()), ":").concat(pad(dt.getSeconds()));
      // 付款时间：下单后 1-15 分钟内
      var payDeltaMin = 1 + Math.floor(Math.random() * 15);
      var payDt = new Date(dt.getTime() + payDeltaMin * 60 * 1000);
      var payStr = "".concat(payDt.getFullYear(), "-").concat(pad(payDt.getMonth() + 1), "-").concat(pad(payDt.getDate()), " ").concat(pad(payDt.getHours()), ":").concat(pad(payDt.getMinutes()), ":").concat(pad(payDt.getSeconds()));
      this.orderHeader.orderNo = no;
      this.orderHeader.orderTime = timeStr;
      this.orderHeader.orderPayTime = payStr;
    },
    watchMatchedOrder: function watchMatchedOrder(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.generateOrderHeader();
      }
    },
    onReplyKeydown: function onReplyKeydown(e) {
      console.log('onReplyKeydown called:', e.key, e.shiftKey, this.replyText);

      // 处理快捷短语选择；如果是回车且有建议，优先选择建议；否则继续走发送
      if (this.showQuickReplySuggestions) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.selectedSuggestionIndex = Math.min(this.selectedSuggestionIndex + 1, this.quickReplySuggestions.length - 1);
          return;
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.selectedSuggestionIndex = Math.max(this.selectedSuggestionIndex - 1, 0);
          return;
        }
        if (e.key === 'Enter' && this.quickReplySuggestions.length > 0) {
          e.preventDefault();
          if (this.quickReplySuggestions[this.selectedSuggestionIndex]) {
            this.selectSuggestion(this.quickReplySuggestions[this.selectedSuggestionIndex]);
          }
          return;
        }
        if (e.key === 'Escape') {
          e.preventDefault();
          this.hideSuggestions();
          return;
        }
      }
      if (e.key === 'Enter' && !e.shiftKey) {
        console.log('Enter key detected, processing send...');
        e.preventDefault();
        this.sendReply();
      }
    },
    onClickReply: function onClickReply(item) {
      var _this3 = this;
      if (!item) return;
      var text = (item.replytext || '').trim();
      if (!text) return;
      // 将快捷短语填充到输入框，若已有内容则在末尾追加换行
      if (this.replyText) {
        this.replyText = this.replyText.replace(/\s*$/, '') + '\n' + text;
      } else {
        this.replyText = text;
      }
      this.$nextTick(function () {
        var ta = _this3.$el.querySelector('.reply-textarea textarea');
        if (ta) {
          ta.focus();
          ta.selectionStart = ta.selectionEnd = _this3.replyText.length;
        }
      });
    },
    back: function back() {
      this.$router.back();
    },
    changeRecommendReply: function changeRecommendReply() {
      var _this4 = this;
      this.settings.trainSession.forEach(function (s) {
        s.quesList.forEach(function (q) {
          q.fold = !_this4.settings.isRecommendReply;
        });
      });
    },
    startTrain: function startTrain() {
      var _this5 = this;
      this.settings.isStart = true;
      this.settings.time = 60 * 10; // 10分钟
      if (this.timer) clearInterval(this.timer);
      if (this.taskATimer) clearInterval(this.taskATimer);
      if (this.taskBTimer) clearInterval(this.taskBTimer);
      if (this.taskCTimer) clearInterval(this.taskCTimer);
      this.timer = setInterval(function () {
        if (_this5.settings.time > 0) {
          _this5.settings.time -= 1;
          if (_this5.settings.time == 60 * 7) {
            _this5.newSession();
            _this5.startTaskB();
          }
          if (_this5.settings.time == 60 * 4) {
            _this5.newSession();
            _this5.startTaskC();
            _this5.settings.isMaxSession = true;
          }
        } else {
          clearInterval(_this5.timer);
          _this5.timer = null;
          if (_this5.settings.trainSession.length == 0) {
            _this5.submitTrain();
          } else {
            _this5.$alert('已经不会有客户进线了，接待完客户依次关闭对话即可评分', '训练结束', {
              confirmButtonText: '确定',
              type: 'info'
            });
          }
        }
      }, 1000);
      // 初始化与任务定时器
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/initTrain?exam=0&sessionnum=3&dependid=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this5.settings.trainId = result.data.trainId;
          _this5.newSession();
          _this5.startTaskA();
        } else {
          _this5.$message({
            type: 'error',
            message: result.msg || '开始训练失败'
          });
        }
      });
    },
    startTaskA: function startTaskA() {
      var _this6 = this;
      // 独立的任务定时器：不随倒计时结束而停止
      if (this.taskATimer) {
        clearInterval(this.taskATimer);
        this.taskATimer = null;
      }
      this.taskATimer = setInterval(function () {
        console.log('taskATimer');
        // 从 trainSession 找第一个元素
        var sessions = _this6.settings.trainSession || [];
        if (!sessions.length) return;
        var firstSession = sessions[0];
        var quesList = Array.isArray(firstSession.quesList) ? firstSession.quesList : [];
        if (!quesList.length) return;
        // 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
        var idx = -1;
        for (var i = quesList.length - 1; i >= 0; i--) {
          var q = quesList[i];
          if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) {
            idx = i;
            break;
          }
        }
        if (idx === -1) return;
        console.log('idx', idx);
        var nextIdx = idx + 1;
        if (nextIdx >= quesList.length) return;
        var nextQ = quesList[nextIdx];
        console.log('nextQ', nextQ.answer);
        if (!nextQ) return;
        // 若下一题尚未"送达"，则激活它
        if (!nextQ.sendTime) {
          nextQ.sendTime = Date.now();
          // 触发一条“对方”消息，用于保持与新会话一致的行为
          _this6.sendMsg(1, '', 0, nextQ.answer, firstSession.veruser, nextQ.id, firstSession.id);
          if (!firstSession.isCurrent) {
            firstSession.didReply = false;
          }
        }
      }, 15000);
    },
    startTaskB: function startTaskB() {
      var _this7 = this;
      if (this.taskBTimer) {
        clearInterval(this.taskBTimer);
        this.taskBTimer = null;
      }
      this.taskBTimer = setInterval(function () {
        console.log('taskBTimer');
        // 从 trainSession 找第一个元素
        var sessions = _this7.settings.trainSession || [];
        if (!sessions.length || sessions.length <= 1) return;
        var secondSession = sessions[1];
        var quesList = Array.isArray(secondSession.quesList) ? secondSession.quesList : [];
        if (!quesList.length) return;
        // 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
        var idx = -1;
        for (var i = quesList.length - 1; i >= 0; i--) {
          var q = quesList[i];
          if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) {
            idx = i;
            break;
          }
        }
        if (idx === -1) return;
        var nextIdx = idx + 1;
        if (nextIdx >= quesList.length) return;
        var nextQ = quesList[nextIdx];
        if (!nextQ) return;
        // 若下一题尚未"送达"，则激活它
        if (!nextQ.sendTime) {
          nextQ.sendTime = Date.now();
          // 触发一条“对方”消息，用于保持与新会话一致的行为
          _this7.sendMsg(1, '', 0, nextQ.answer, secondSession.veruser, nextQ.id, secondSession.id);
          if (!secondSession.isCurrent) {
            secondSession.didReply = false;
          }
        }
      }, 15000);
    },
    startTaskC: function startTaskC() {
      var _this8 = this;
      if (this.taskCTimer) {
        clearInterval(this.taskCTimer);
        this.taskCTimer = null;
      }
      this.taskCTimer = setInterval(function () {
        console.log('taskCTimer');
        // 从 trainSession 找第一个元素
        var sessions = _this8.settings.trainSession || [];
        if (!sessions.length || sessions.length <= 2) return;
        var thirdSession = sessions[2];
        var quesList = Array.isArray(thirdSession.quesList) ? thirdSession.quesList : [];
        if (!quesList.length) return;
        // 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
        var idx = -1;
        for (var i = quesList.length - 1; i >= 0; i--) {
          var q = quesList[i];
          if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) {
            idx = i;
            break;
          }
        }
        if (idx === -1) return;
        var nextIdx = idx + 1;
        if (nextIdx >= quesList.length) return;
        var nextQ = quesList[nextIdx];
        if (!nextQ) return;
        // 若下一题尚未"送达"，则激活它
        if (!nextQ.sendTime) {
          nextQ.sendTime = Date.now();
          // 触发一条“对方”消息，用于保持与新会话一致的行为
          _this8.sendMsg(1, '', 0, nextQ.answer, thirdSession.veruser, nextQ.id, thirdSession.id);
          if (!thirdSession.isCurrent) {
            thirdSession.didReply = false;
          }
        }
      }, 15000);
    },
    closeSession: function closeSession() {
      var _this9 = this;
      if (!this.currentSession) return;
      var currentIndex = this.settings.trainSession.findIndex(function (s) {
        return s.id === _this9.currentSession.id;
      });
      if (currentIndex === -1) return;

      // 检查是否存在未下发或未回复的问题
      var quesList = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
      var hasPending = quesList.some(function (q) {
        return !q || !q.sendTime || q.sendTime && (!Array.isArray(q.replyList) || q.replyList.length === 0);
      });
      var doRemove = function doRemove() {
        // 移除当前会话
        _this9.settings.trainSession.splice(currentIndex, 1);
        // 如果数组中还有会话，选择下一个（或前一个）
        if (_this9.settings.trainSession.length > 0) {
          var nextIndex = currentIndex < _this9.settings.trainSession.length ? currentIndex : currentIndex - 1;
          _this9.selectSession(_this9.settings.trainSession[nextIndex]);
        } else {
          // 如果没有会话了，清空当前会话
          _this9.settings.trainSession = [];
          if (_this9.settings.isMaxSession) {
            // 如果已经达到最大会话数，则停止训练
            if (_this9.settings.time <= 0) {
              _this9.submitTrain();
            }
          }
        }
      };
      if (hasPending) {
        this.$confirm('当前会话您还有未回复的问题，确定关闭会话？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          doRemove();
        }).catch(function () {});
      } else {
        doRemove();
      }
    },
    submitTrain: function submitTrain() {
      var _this0 = this;
      this.openFullLoading('提交中...');
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/submitTrain', {
        id: this.settings.trainId
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this0.getScorById();
        } else {
          _this0.$message({
            type: 'error',
            message: result.msg || '提交失败'
          });
          _this0.closeFullLoading();
        }
      }, function () {
        _this0.$message({
          type: 'error',
          message: '提交失败'
        });
        _this0.closeFullLoading();
      });
    },
    getScorById: function getScorById() {
      var _this1 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/getById', {
        id: this.settings.trainId
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          self.closeFullLoading();
          self.trainResult = result.data;
          self.showScore = true;
        } else {
          _this1.$message({
            type: 'error',
            message: result.msg || '提交失败'
          });
          self.closeFullLoading();
        }
      }, function () {
        _this1.$message({
          type: 'error',
          message: '提交失败'
        });
        _this1.closeFullLoading();
      });
    },
    openFullLoading: function openFullLoading(text) {
      if (this.fullLoading) {
        this.fullLoading.close();
        this.fullLoading = null;
      }
      this.fullLoading = this.$loading({
        lock: true,
        text: text || '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)'
      });
    },
    closeFullLoading: function closeFullLoading() {
      if (this.fullLoading) {
        this.fullLoading.close();
        this.fullLoading = null;
      }
    },
    newSession: function newSession() {
      var _this10 = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/newSession', {
        id: this.settings.trainId,
        batchId: this.$route.query.batchId
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          var item = result.data.trainSession[0];
          if (_this10.settings.trainSession.length == 0) {
            item.isCurrent = true;
            item.didReply = true;
          } else {
            item.isCurrent = false;
            item.didReply = false;
          }
          item.quesList.forEach(function (q) {
            q.fromName = item.veruser;
            q.sendTime = null;
            q.fold = true;
            q.replyList = [];
          });
          item.quesList[0].sendTime = Date.now();
          _this10.settings.trainSession.push(item);
          _this10.sendMsg(1, '', 0, item.quesList[0].answer, item.veruser, item.quesList[0].id, item.id);
          _this10.$nextTick(function () {
            _this10.scrollChatToBottom();
          });
        } else {
          _this10.$message({
            type: 'error',
            message: result.msg || '开始训练失败'
          });
        }
      });
    },
    sendMsg: function sendMsg(role, content, typingspeed, sysanswer, username, questionId, sessionId) {
      var _this11 = this;
      console.log('sendMsg called with:', {
        role: role,
        content: content,
        typingspeed: typingspeed,
        sysanswer: sysanswer,
        username: username,
        questionId: questionId,
        sessionId: sessionId
      });
      var data;
      if (role === 1) {
        data = {
          role: 1,
          content: '',
          typingspeed: 0,
          sysanswer: sysanswer,
          username: username,
          questionId: questionId,
          sessionid: sessionId || this.currentSession && this.currentSession.id
        };
      } else {
        data = {
          role: 0,
          content: content,
          typingspeed: typingspeed,
          questionId: questionId,
          sessionid: sessionId || this.currentSession && this.currentSession.id
        };
      }
      console.log('Sending data to API:', data);
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/sendMsg', data).then(function (res) {
        var result = res.data;
        if (result && result.success) {} else {
          _this11.$message({
            type: 'error',
            message: result.msg || '发送失败'
          });
        }
      }).catch(function (err) {
        console.error('发送消息失败:', err);
        _this11.$message({
          type: 'error',
          message: '网络错误，发送失败。请检查网络连接或稍后重试。'
        });
      });
      this.$nextTick(function () {
        _this11.scrollChatToBottom();
      });
    },
    selectSession: function selectSession(target) {
      var _this12 = this;
      (this.settings.trainSession || []).forEach(function (s) {
        s.isCurrent = false;
      });
      target.isCurrent = true;
      target.didReply = true;
      this.$nextTick(function () {
        _this12.scrollChatToBottom();
      });
    },
    stopTrain: function stopTrain() {
      this.settings = {
        isStart: false,
        onlineStatus: '1',
        isRecommendReply: false,
        time: 0,
        collapsedGroups: {},
        groups: [],
        defaultGroupId: null,
        trainId: null,
        trainSession: [],
        isMaxSession: false
      },
      // 重置打字统计
      this.typingStartMs = null;
      this.typingAccumMs = 0;
      this.typedCharsTotal = 0;
      this.pastedCharsCurrent = 0;
      clearInterval(this.timer);
      this.timer = null;
      if (this.taskATimer) {
        clearInterval(this.taskATimer);
        this.taskATimer = null;
      }
      if (this.taskBTimer) {
        clearInterval(this.taskBTimer);
        this.taskBTimer = null;
      }
      if (this.taskCTimer) {
        clearInterval(this.taskCTimer);
        this.taskCTimer = null;
      }
    },
    restartTrain: function restartTrain() {
      this.showScore = false;
      this.stopTrain();
      this.$refs.productModal.handleStart();
    },
    viewResult: function viewResult() {
      this.$router.push({
        name: 'fbtTrainResult',
        query: {
          trainId: this.settings.trainId
        }
      });
      this.showScore = false;
      this.stopTrain();
    },
    onKeywordInput: function onKeywordInput() {
      // 实时筛选逻辑在 computed 中处理
    },
    onReplyInput: function onReplyInput() {
      // 进入输入状态的起点：从空到非空
      var textNow = this.replyText || '';
      if (!this.typingStartMs && textNow.trim().length > 0) {
        this.typingStartMs = Date.now();
      }
      // 检测是否输入了 / 符号
      var text = this.replyText || '';
      var lastSlashIndex = text.lastIndexOf('/');
      if (lastSlashIndex !== -1) {
        // 获取 / 后面的内容作为搜索关键词
        var searchKeyword = text.substring(lastSlashIndex + 1).toLowerCase();
        if (searchKeyword.length === 0) {
          // 如果只输入了 /，显示所有快捷短语
          this.showAllQuickReplies();
        } else {
          // 根据关键词筛选快捷短语
          this.filterQuickReplies(searchKeyword);
        }
      } else {
        // 没有 / 符号，隐藏提示框
        this.hideSuggestions();
      }
      // 若清空输入，则结束当前输入段并清零本段粘贴统计
      if (textNow.trim().length === 0) {
        if (this.typingStartMs) {
          // 不累计时间（只有发送时累计），仅重置起点
          this.typingStartMs = null;
        }
        this.pastedCharsCurrent = 0;
      }
    },
    onReplyPaste: function onReplyPaste(e) {
      try {
        var text = e.clipboardData && e.clipboardData.getData('text') || '';
        this.pastedCharsCurrent += (text || '').length;
      } catch (err) {/* ignore */}
    },
    showAllQuickReplies: function showAllQuickReplies() {
      var allReplies = [];
      (this.fastReplyList || []).forEach(function (group) {
        (group.replyList || []).forEach(function (reply) {
          allReplies.push(reply);
        });
      });
      this.quickReplySuggestions = allReplies.slice(0, 6); // 最多显示6个
      this.selectedSuggestionIndex = 0;
      this.showQuickReplySuggestions = true;
    },
    filterQuickReplies: function filterQuickReplies(keyword) {
      var filteredReplies = [];
      (this.fastReplyList || []).forEach(function (group) {
        (group.replyList || []).forEach(function (reply) {
          var quicktext = (reply.quicktext || '').toLowerCase();
          var replytext = (reply.replytext || '').toLowerCase();
          if (quicktext.includes(keyword) || replytext.includes(keyword)) {
            filteredReplies.push(reply);
          }
        });
      });
      this.quickReplySuggestions = filteredReplies.slice(0, 6); // 最多显示6个
      this.selectedSuggestionIndex = 0;
      this.showQuickReplySuggestions = true;
    },
    selectSuggestion: function selectSuggestion(item) {
      var _this13 = this;
      if (!item) return;
      var text = this.replyText || '';
      var lastSlashIndex = text.lastIndexOf('/');
      if (lastSlashIndex !== -1) {
        // 替换 / 及其后面的内容为选中的快捷短语
        var beforeSlash = text.substring(0, lastSlashIndex);
        this.replyText = beforeSlash + item.replytext;
      } else {
        // 如果没有 / 符号，直接添加
        this.replyText = text + item.replytext;
      }
      this.hideSuggestions();

      // 聚焦到输入框
      this.$nextTick(function () {
        var textarea = _this13.$el.querySelector('.reply-textarea textarea');
        if (textarea) {
          textarea.focus();
          textarea.setSelectionRange(_this13.replyText.length, _this13.replyText.length);
        }
      });
    },
    hideSuggestions: function hideSuggestions() {
      this.showQuickReplySuggestions = false;
      this.quickReplySuggestions = [];
      this.selectedSuggestionIndex = 0;
    },
    refreshFastReply: function refreshFastReply() {
      var _this14 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/searchType?id=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this14.settings.groups = Array.isArray(result.data.personalType) ? result.data.personalType : [];
        }
      });
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/search?type=1&sceneId=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this14.fastReplyList = result.data.typeList;
        } else {
          _this14.$message({
            message: result.msg,
            type: 'error'
          });
        }
      }, function (err) {
        _this14.$message({
          message: '保存失败',
          type: 'error'
        });
      });
    },
    newFastReply: function newFastReply() {
      this.showEditor = true;
    },
    toggleGroup: function toggleGroup(id) {
      if (!this.settings.collapsedGroups) this.$set(this.settings, 'collapsedGroups', {});
      this.$set(this.settings.collapsedGroups, id, !this.settings.collapsedGroups[id]);
    },
    onGroupContext: function onGroupContext(e, group) {
      this.menu.visible = true;
      var rect = this.$el.getBoundingClientRect();
      this.menu.x = e.clientX - rect.left;
      this.menu.y = e.clientY - rect.top - 110;
      this.menu.group = group;
      this.menu.type = 'group';
      document.addEventListener('click', this.hideMenuOnce, {
        once: true
      });
    },
    onReplyContext: function onReplyContext(e, reply, group) {
      this.menu.visible = true;
      var rect = this.$el.getBoundingClientRect();
      this.menu.x = e.clientX - rect.left;
      this.menu.y = e.clientY - rect.top - 110;
      this.menu.reply = reply;
      this.menu.group = group;
      this.menu.type = 'reply';
      document.addEventListener('click', this.hideMenuOnce, {
        once: true
      });
    },
    hideMenuOnce: function hideMenuOnce() {
      this.menu.visible = false;
      this.menu.group = null;
      this.menu.reply = null;
      this.menu.type = 'group';
    },
    menuAddGroup: function menuAddGroup() {
      var _this15 = this;
      this.menu.visible = false;
      var self = this;
      this.$prompt('请输入分组名', '新增分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        // 非空
        inputErrorMessage: '分组名不能为空'
      }).then(function (_ref) {
        var value = _ref.value;
        var name = value && value.trim();
        if (!name) return;
        _this15.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/saveReplyType?sceneId=' + self.sceneId, {
          name: name
        }).then(function (res) {
          var result = res.data;
          if (result && result.success) {
            _this15.$message({
              type: 'success',
              message: '保存分组成功'
            });
            self.refreshFastReply();
          } else {
            _this15.$message({
              type: 'error',
              message: result.msg || '保存失败'
            });
          }
        }, function () {
          _this15.$message({
            type: 'error',
            message: '保存失败'
          });
        });
      });
    },
    menuEditGroup: function menuEditGroup() {
      var _this16 = this;
      var group = this.menu.group;
      this.menu.visible = false;
      var self = this;
      this.$prompt('请输入分组名', '编辑分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        // 非空
        inputErrorMessage: '分组名不能为空',
        inputValue: group && group.name ? group.name : ''
      }).then(function (_ref2) {
        var value = _ref2.value;
        var name = value && value.trim();
        if (!name) return;
        _this16.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/saveReplyType?sceneId=' + self.sceneId, {
          name: name,
          id: group.id
        }).then(function (res) {
          var result = res.data;
          if (result && result.success) {
            _this16.$message({
              type: 'success',
              message: '保存分组成功'
            });
            self.refreshFastReply();
          } else {
            _this16.$message({
              type: 'error',
              message: result.msg || '保存失败'
            });
          }
        }, function () {
          _this16.$message({
            type: 'error',
            message: '保存失败'
          });
        });
      });
    },
    /**
     * 修改短语分组
     */
    menuEditReplyGroup: function menuEditReplyGroup() {
      var _this17 = this;
      var reply = this.menu.reply;
      var currentGroup = this.menu.group;
      this.menu.visible = false;
      var self = this;

      // 创建分组选择弹窗
      var h = this.$createElement;
      var selectVNode = h('el-select', {
        props: {
          value: currentGroup ? currentGroup.id : '',
          placeholder: '请选择分组'
        },
        on: {
          input: function input(value) {
            selectVNode.componentInstance.value = value;
          }
        }
      }, this.settings.groups.map(function (group) {
        return h('el-option', {
          props: {
            key: group.id,
            label: group.name,
            value: group.id
          }
        });
      }));
      this.$msgbox({
        title: '修改分组',
        message: h('div', [h('p', {
          style: 'margin-bottom: 10px;'
        }, '请选择新的分组：'), selectVNode]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            var selectedGroupId = selectVNode.componentInstance.value;
            if (!selectedGroupId) {
              _this17.$message({
                type: 'warning',
                message: '请选择分组'
              });
              return;
            }
            var group = self.settings.groups.find(function (g) {
              return g.id === selectedGroupId;
            });
            // 调用修改分组接口
            _this17.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/saveReply', {
              type: group.type,
              typeid: selectedGroupId,
              quicktext: reply.quicktext,
              replytext: reply.replytext,
              id: reply.id
            }).then(function (res) {
              var result = res.data;
              if (result && result.success) {
                _this17.$message({
                  type: 'success',
                  message: '修改分组成功'
                });
                self.refreshFastReply();
                done();
              } else {
                _this17.$message({
                  type: 'error',
                  message: result.msg || '修改失败'
                });
              }
            }, function () {
              _this17.$message({
                type: 'error',
                message: '修改失败'
              });
            });
          } else {
            done();
          }
        }
      });
    },
    /**
     * 删除分组
     */
    menuDeleteGroup: function menuDeleteGroup() {
      var _this18 = this;
      var group = this.menu.group;
      this.menu.visible = false;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/deleteReplyType?id=' + group.id).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this18.$message({
            type: 'success',
            message: '删除成功'
          });
          self.refreshFastReply();
        } else {
          _this18.$message({
            type: 'error',
            message: result.msg || '删除失败'
          });
        }
      }, function () {
        _this18.$message({
          type: 'error',
          message: '删除失败'
        });
      });
    },
    /**
     * 添加短语
     */
    menuAddReply: function menuAddReply() {
      this.settings.defaultGroupId = this.menu.group ? this.menu.group.id : null;
      this.menu.visible = false;
      this.showEditor = true;
    },
    menuCollapseAll: function menuCollapseAll() {
      this.menu.visible = false;
      var map = {};
      (this.fastReplyList || []).forEach(function (g) {
        map[g.id] = true;
      });
      this.$set(this.settings, 'collapsedGroups', map);
    },
    menuEditReply: function menuEditReply() {
      this.menu.visible = false;
      var reply = this.menu.reply || {};
      // 将当前短语的数据映射到编辑弹窗所需字段
      var groupId = this.menu.group && this.menu.group.id ? this.menu.group.id : '';
      this.settings.defaultGroupId = groupId;
      this.editorValue = {
        id: reply.id || '',
        content: reply.replytext || '',
        group: groupId,
        code: reply.quicktext || ''
      };
      this.showEditor = true;
    },
    menuDeleteReply: function menuDeleteReply() {
      var _this19 = this;
      this.menu.visible = false;
      var reply = this.menu.reply;
      var self = this;
      this.$confirm('确定要删除这条快捷短语吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this19.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/deleteReply', {
          id: reply.id
        }).then(function (res) {
          var result = res.data;
          if (result && result.success) {
            _this19.$message({
              type: 'success',
              message: '删除成功'
            });
            self.refreshFastReply();
          } else {
            _this19.$message({
              type: 'error',
              message: result.msg || '删除失败'
            });
          }
        }, function () {
          _this19.$message({
            type: 'error',
            message: '删除失败'
          });
        });
      }).catch(function () {
        _this19.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    formatMsgTime: function formatMsgTime(t) {
      if (!t) return '';
      var date = typeof t === 'number' ? new Date(t) : new Date(String(t));
      var y = date.getFullYear();
      var M = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      var h = String(date.getHours()).padStart(2, '0');
      var m = String(date.getMinutes()).padStart(2, '0');
      var s = String(date.getSeconds()).padStart(2, '0');
      return "".concat(y, "-").concat(M, "-").concat(d, " ").concat(h, ":").concat(m, ":").concat(s);
    },
    scrollChatToBottom: function scrollChatToBottom() {
      var el = this.$refs && this.$refs.chatContent;
      if (!el) return;
      try {
        el.scrollTop = el.scrollHeight;
      } catch (e) {/* ignore */}
    },
    parseContent: function parseContent(content) {
      // 识别普通图片链接（含查询参数），并进行图文混排
      // 匹配形如 http(s)://.../xxx.(png|jpg|jpeg|gif|webp|bmp)[?...] 的链接
      var urlRegex = /(https?:\/\/[^\s]+?\.(?:png|jpe?g|gif|webp|bmp)(?:\?[^\s]*)?)/ig;
      var nodes = [];
      var str = String(content || '');
      var lastIndex = 0;
      var match;
      while ((match = urlRegex.exec(str)) !== null) {
        var start = match.index;
        if (start > lastIndex) {
          nodes.push({
            type: 'text',
            text: str.slice(lastIndex, start)
          });
        }
        nodes.push({
          type: 'img',
          src: match[1]
        });
        lastIndex = urlRegex.lastIndex;
      }
      if (lastIndex < str.length) {
        nodes.push({
          type: 'text',
          text: str.slice(lastIndex)
        });
      }
      return nodes.length ? nodes : [{
        type: 'text',
        text: str
      }];
    }
  }, "onClickReply", function onClickReply(reply) {
    this.replyText = reply.replytext;
  })
};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FastReplyImportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sceneId: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    return {
      filePath: '',
      fileBlob: null,
      tableData: []
    };
  },
  computed: {
    visibleProxy: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    }
  },
  methods: {
    chooseFile: function chooseFile() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    loadReplyList: function loadReplyList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/search?type=1&sceneId=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          var typeList = Array.isArray(result.data && result.data.typeList) ? result.data.typeList : [];
          // 构建父级名称索引
          var idToItem = {};
          typeList.forEach(function (t) {
            idToItem[t.id] = t;
          });
          var index = 1;
          var rows = [];
          typeList.forEach(function (t) {
            var parentName = t.name;
            var replies = Array.isArray(t.replyList) ? t.replyList : [];
            replies.forEach(function (r) {
              rows.push({
                index: index++,
                code: r.quicktext || '',
                content: r.replytext || '',
                group: parentName,
                image: '',
                status: '完成'
              });
            });
          });
          _this.tableData = rows;
        } else {
          _this.$message({
            message: result.msg,
            type: 'error'
          });
        }
      }, function (err) {
        _this.$message({
          message: '保存失败',
          type: 'error'
        });
      });
    },
    onFileChange: function onFileChange(e) {
      var _this2 = this;
      var file = e && e.target && e.target.files ? e.target.files[0] : null;
      if (!file) return;
      this.fileBlob = file;
      this.filePath = file.name;
      var formdata = new FormData();
      // 文件
      formdata.append('file', file);
      // 附带元字段，形成多 part 提交
      formdata.append('id', 'WU_FILE_0');
      formdata.append('name', file.name || '');
      formdata.append('type', file.type || '');
      formdata.append('lastModifiedDate', (file.lastModified ? new Date(file.lastModified) : new Date()).toLocaleString());
      formdata.append('size', file.size != null ? String(file.size) : '');
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/reply/importReply?importType=override&sceneId=' + this.sceneId, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this2.$emit('refresh');
          _this2.loadReplyList();
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error'
          });
        }
      }, function (res) {
        _this2.$message({
          message: '导入失败',
          type: 'error'
        });
      });
    }
  }
};

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyEditorDialog_vue__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyEditorDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyEditorDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyEditorDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyEditorDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c92a3f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastReplyEditorDialog_vue__ = __webpack_require__(1711);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1709)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70c92a3f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyEditorDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c92a3f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastReplyEditorDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/components/FastReplyEditorDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70c92a3f", Component.options)
  } else {
    hotAPI.reload("data-v-70c92a3f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FastReplyEditorDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sceneId: {
      type: String,
      default: 0
    },
    defaultGroupId: {
      type: Number,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    showAddGroup: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      form: {
        content: '',
        group: '',
        code: '',
        id: ''
      },
      newGroup: '',
      groups: [],
      saving: false
    };
  },
  computed: {
    visibleProxy: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function handler(v) {
        if (!v) return;
        this.form = {
          content: v.content || '',
          group: v.group || '',
          code: v.code || '',
          id: v.id || ''
        };
      }
    }
  },
  methods: {
    onConfirm: function onConfirm() {
      var _this = this;
      if (this.saving) return;
      var content = (this.form.content || '').trim();
      var code = (this.form.code || '').trim();
      var groupId = this.form.group;
      if (!content) {
        this.$message({
          message: '请输入快捷短语',
          type: 'warning'
        });
        return;
      }
      if (!groupId) {
        this.$message({
          message: '请选择分组',
          type: 'warning'
        });
        return;
      }
      if (!code) {
        this.$message({
          message: '请输入快捷编码',
          type: 'warning'
        });
        return;
      }
      var groupObj = this.groups.find(function (g) {
        return g.id === groupId;
      });
      if (!groupObj) {
        this.$message({
          message: '分组无效，请重新选择',
          type: 'warning'
        });
        return;
      }
      this.saving = true;
      var data = {
        type: groupObj.type,
        typeid: groupId,
        quicktext: code,
        replytext: content
      };
      if (this.form.id) data.id = this.form.id;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/saveReply', data).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this.$message({
            message: '保存成功',
            type: 'success'
          });
          _this.visibleProxy = false;
          _this.$emit('refresh');
        } else {
          _this.$message({
            message: result.msg,
            type: 'error'
          });
        }
      }, function (err) {
        _this.$message({
          message: '保存失败',
          type: 'error'
        });
      }).finally(function () {
        _this.saving = false;
      });
    },
    addGroup: function addGroup() {
      var _this2 = this;
      if (!this.newGroup) return;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/saveReplyType?sceneId=' + this.sceneId, {
        name: this.newGroup
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this2.$message({
            message: '保存分组成功',
            type: 'success'
          });
          self.onOpen();
          self.newGroup = '';
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error'
          });
        }
      }, function (err) {
        _this2.$message({
          message: '保存分组失败',
          type: 'error'
        });
      });
    },
    onOpen: function onOpen() {
      var _this3 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/searchType?id=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this3.groups = Array.isArray(result.data.personalType) ? result.data.personalType : [];
          // 如果有默认分组ID，设置为选中状态
          if (_this3.defaultGroupId && _this3.groups.some(function (g) {
            return g.id === _this3.defaultGroupId;
          })) {
            _this3.form.group = _this3.defaultGroupId;
          }
        }
      }, function (err) {
        // 忽略错误，保持现有分组
      });
    },
    onClosed: function onClosed() {
      // 关闭时重置表单内容
      this.form = {
        content: '',
        group: '',
        code: ''
      };
      this.newGroup = '';
    }
  }
};

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainScoreDialog_vue__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainScoreDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainScoreDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainScoreDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainScoreDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dddafd34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainScoreDialog_vue__ = __webpack_require__(1714);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1712)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dddafd34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainScoreDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dddafd34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainScoreDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/components/TrainScoreDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dddafd34", Component.options)
  } else {
    hotAPI.reload("data-v-dddafd34", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'TrainScoreDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 后端返回的完整结果对象
    result: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    visibleProxy: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    },
    actionTypeMap: function actionTypeMap() {
      var actionTypeMap = this.result && this.result.actionTypeMap || null;
      return actionTypeMap;
    },
    computedItems: function computedItems() {
      var t = this.result && this.result.train || {};
      var s = this.result && this.result.score || {};
      return [{
        label: '平均首次响应时间',
        value: (t.restime != null ? t.restime : 0) + '秒',
        score: s.firstResponseAvgScore || 0
      }, {
        label: '平均响应时间',
        value: (t.avgrestime != null ? t.avgrestime : 0) + '秒',
        score: s.responseAvgScore || 0
      }, {
        label: '回复率',
        value: (t.responseRate != null ? t.responseRate : 0) + '%',
        score: s.responseRateScore || 0
      }, {
        label: '回复正确率',
        value: (t.responseRightRate != null ? t.responseRightRate : 0) + '%',
        score: s.responseRightScore || 0
      }];
    },
    computedScore: function computedScore() {
      return this.result && this.result.train && (this.result.train.sysScore || 0) || 0;
    },
    computedPassed: function computedPassed() {
      return !!(this.result && this.result.train && Number(this.result.train.pass) === 1);
    }
  },
  methods: {
    formatScore: function formatScore(score) {
      return Number(score) || 0;
    },
    onRestart: function onRestart() {
      this.$emit('onRestart');
    },
    onViewResult: function onViewResult() {
      this.$emit('onViewResult');
    }
  }
};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// 外部可读取的订单元数据
// 使用方式：import orders from '@/page/train/FBT/data/order';

var orders = {
  "douyin": [{
    'id': 1001,
    'productName': '【22包】帮宝适黑金帮尿不湿夏季透气亲肤纸尿裤拉拉裤ZC [快照]',
    'address': '吉林省长春市宽城区兰家镇**********',
    'phone': '1*********',
    'name': '李*',
    'size': '摇摇车(莫奈绿-A1 旗舰款)/黑金帮纸尿裤L32片*4包+赠黑金帮安睡拉拉裤甄选装L19片*1包(推荐18-28斤)/18包',
    'num': '1',
    'price': 2618,
    'lastprice': 2603,
    'youfei': '',
    'status': '待发货',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/bbs1.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1002,
    'productName': '【护臀级】帮宝适一级帮纸尿裤超薄透气NB-M尿不湿添加类胎脂清爽 [快照]',
    'address': '安徽省宣城市宣州区金坝街道*********',
    'phone': '1*********',
    'name': '小*',
    'size': '【 新人尝鲜】纸尿裤NB29片/包（5kg以下）',
    'num': '1',
    'price': 29.9,
    'lastprice': 29.9,
    'youfei': '',
    'status': '已退款',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/bbs2.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1003,
    'productName': '【暖暖专属】帮宝适清新帮夏日透气干爽纸尿裤拉拉裤尿不湿NB-3XL [快照]',
    'address': '辽宁省沈阳市铁西区沈阳市经济技术开发区*********',
    'phone': '1*********',
    'name': '刘*',
    'size': '拉拉裤XXL28片*3包【推荐30斤以上】',
    'num': '1',
    'price': 174,
    'lastprice': 174,
    'youfei': '',
    'status': '已退款',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/bbs3.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1004,
    'productName': '【超品狂欢立即付定金】帮宝适黑金帮纸尿裤拉拉裤添加真蚕丝尿不湿 [快照]',
    'address': '四川省绵阳市游仙区小枧镇***************',
    'phone': '1*********',
    'name': '晨*',
    'size': '手拍鼓手摇铃礼盒六件套/新升级！【纸尿裤】M34片*6包（6-11kg，共204片）',
    'num': '1',
    'price': 627,
    'lastprice': 627,
    'youfei': '',
    'status': '待发货',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/bbs4.png',
    'actionType': '',
    'remark': ''
  },
  //====================抖音美的售前售后实操案例==================
  {
    'id': 1011,
    'productName': '【国补20%】华凌空调1.5匹超省电Pro变频一级WiFi智能',
    'address': '山东省济南市槐荫区腊山街道东湖小区',
    'phone': '13345454545',
    'name': '小王',
    'size': '大1.5匹：KFR-35GW/N8HA1Ⅲ-P',
    'num': 1,
    'price': 1649,
    'lastprice': 1319.2,
    'youfei': 0.8,
    'status': '未付款',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd1.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1012,
    'productName': '【国补20%】神机二代华凌空调1.5匹35HE1Ⅱ Pro一级变频WiFi智能',
    'address': '河北省保定市定州市南城区街道135号',
    'phone': '13588888888',
    'name': '小涛',
    'size': '大1.5匹：KFR-35GW/N8HE1Ⅱ',
    'num': 1,
    'price': 2299,
    'lastprice': 1839.2,
    'youfei': 0.8,
    'status': '未付款',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd2.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1013,
    'productName': '【国补20%】神机二代华凌空调1.5匹挂机35HE1Ⅱ超一级变频智能 [快照]',
    'address': '广东省佛山市顺德区伦教街道幸福小区',
    'phone': '15625252525',
    'name': '王雪',
    'size': '大1.5匹：KFR-35GW/N8HE1Ⅱ',
    'num': 1,
    'price': 2299,
    'lastprice': 2155,
    'youfei': '平台优惠',
    'status': '未发货',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd3.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1014,
    'productName': '【国补】美的WAHIN冰箱589大容量精细分储一级风冷无霜变频轻音',
    'address': '山东省济宁市任城区丰泰园北区19号',
    'phone': '15255555555',
    'name': '邵晓',
    'size': '默认',
    'num': 1,
    'price': 1999,
    'lastprice': 1599.2,
    'youfei': 400,
    'status': '未发货',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd4.png',
    'actionType': ''
  }, {
    'id': 1015,
    'productName': '【国补20%】华凌空调1.5匹超省电Pro变频一级WiFi智能 [快照]',
    'address': '湖南省永州市江华瑶族自治县白芒营镇3号',
    'phone': '198****0567',
    'name': '安琪拉',
    'size': '一级能耗挂机',
    'num': 1,
    'price': 1699,
    'lastprice': 1659,
    'youfei': 40,
    'status': '已发货',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd5.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1016,
    'productName': '【国补20%】神机二代华凌空调1.5匹35HE1Ⅱ Pro一级变频WiFi智能',
    'address': '湖南省长沙市天门区魔仙堡街',
    'phone': '198****0567',
    'name': '安琪拉',
    'size': '大1.5匹：KFR-35GWN8HL1Pro',
    'num': 1,
    'price': 2799,
    'lastprice': 2239,
    'youfei': '8折',
    'status': '已关闭',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd6.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1017,
    'productName': '【国补8折】神机二代华凌空调1.5匹挂机35HE1Ⅱ超一级变频智能',
    'address': '湖南省长沙市天门区魔仙堡街',
    'phone': '198****0567',
    'name': '安琪拉',
    'size': '大1.5匹：KFR-35GW/N8HE1Ⅱ',
    'num': 1,
    'price': 2499,
    'lastprice': 1519.2,
    'youfei': 979.8,
    'status': '已签收',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd7.png',
    'actionType': '',
    'remark': ''
  }],
  "jingmai": [
  //====================京东华凌售后实操案例==================
  {
    id: 1101,
    productName: '华凌空调 新一级能效 变频冷暖 超大风口 1.5匹 客厅卧室空调挂机 升级电量查询 KFR-35GW/N8HE1Pro',
    address: '广东湛江市赤坎区南桥街道',
    phone: '18666746871',
    name: '周弘',
    size: '(无)',
    num: 1,
    price: 2299,
    lastprice: 1874,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm1.png',
    actionType: '',
    remark: ''
  }, {
    id: 1102,
    productName: '华凌空调 新一级能效 变频冷暖 超大风口 1.5匹 客厅卧室空调挂机 升级电量查询 KFR-35GW/N8HE1Pro',
    address: '四川眉山市',
    phone: '18328118480',
    name: '琦',
    size: '(无)',
    num: 1,
    price: 2099,
    lastprice: 2093,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm2.png',
    actionType: '',
    remark: ''
  }, {
    id: 1103,
    productName: '华凌空调 大1.5匹 【大风口】双排神机二代变频冷暖挂机 超一级能效 KFR-35GW/N8HE1Ⅱ 家电国家补贴',
    address: '广东茂名市高州市',
    phone: '13790916882',
    name: '甘',
    size: '(无)',
    num: 1,
    price: 1899,
    lastprice: 1740,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm3.png',
    actionType: '',
    remark: ''
  }, {
    id: 1104,
    productName: '华凌空调 大1.5匹 【大风口】双排神机二代变频冷暖挂机 超一级能效 KFR-35GW/N8HE1Ⅱ 家电国家补贴',
    address: '广东惠州市',
    phone: '13790916882',
    name: '韦*',
    size: '(无)',
    num: 1,
    price: 2899,
    lastprice: 2319,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm4.png',
    actionType: '',
    remark: ''
  }, {
    id: 1105,
    productName: '华凌空调 新一级变频冷暖 大风口 1.5匹 客厅卧室挂式空调挂机 智能 升级电量查询 KFR-35GW/N8HL1Pro 以旧换新',
    address: '广东湛江市',
    phone: '13790916882',
    name: '黄*',
    size: '(无)',
    num: 1,
    price: 2029,
    lastprice: 1979,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm5.png',
    actionType: '',
    remark: ''
  }, {
    id: 1106,
    productName: '华凌空调 2匹 超省电 新一级 大风量 智能互联 卧室客厅空调挂机 以旧换新 KFR-50GW/N8HL1 家电国家补贴',
    address: '河南安阳市',
    phone: '18530622583',
    name: '王**',
    size: '(无)',
    num: 1,
    price: 2599,
    lastprice: 2070,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm6.png',
    actionType: '',
    remark: ''
  }, {
    id: 1107,
    productName: '华凌空调 2匹 超省电 新一级 大风量 智能互联 卧室客厅空调挂机 以旧换新 KFR-50GW/N8HL1 家电国家补贴',
    address: '河北石家庄',
    phone: '18530622583',
    name: '刘*',
    size: '(无)',
    num: 1,
    price: 5199,
    lastprice: 5199,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm7.png',
    actionType: '',
    remark: ''
  }, {
    id: 1108,
    productName: '华凌空调 神机二代 3匹 超一级能效 变频冷暖 客厅圆柱立式柜机 KFR-72LW/N8HE1Ⅱ 家电国家补贴 以旧换新',
    address: '江苏南通市',
    phone: '18530622583',
    name: '雯*',
    size: '(无)',
    num: 1,
    price: 5199,
    lastprice: 5199,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm8.png',
    actionType: '',
    remark: ''
  }, {
    id: 1109,
    productName: '华凌空调 新一级能效 变频冷暖 超大风口 1.5匹 客厅卧室空调挂机 升级电量查询 KFR-35GW/N8HE1Pro',
    address: '江西赣州市',
    phone: '18530622583',
    name: '华*',
    size: '(无)',
    num: 1,
    price: 2199,
    lastprice: 2199,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm9.png',
    actionType: '',
    remark: ''
  }, {
    id: 1110,
    productName: '华凌空调 大1.5匹 新一级能效 超省电Pro 巨省电 变频冷暖空调挂机 KFR-35GW/N8HA1Ⅲ-P 家电国家补贴',
    address: '湖南岳阳市',
    phone: '18530622583',
    name: '魏*',
    size: '(无)',
    num: 1,
    price: 1599,
    lastprice: 1599,
    youfei: '',
    status: '已签收',
    imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm9.png',
    actionType: '',
    remark: ''
  },
  //====================京东美的售后实操案例==================
  {
    'id': 1121,
    'productName': '美的空调 大1.5匹 酷省电pro 新一级能效 变频冷暖 家电国家补贴 节能壁挂式挂机 KFR-35GW/N8KS1-1P',
    'address': '福建福州市仓山区建新镇福湾新城春风苑*区-14号楼**1',
    'phone': '1******3271',
    'name': '张栋义',
    'size': '大1.5匹 一级能效 酷省电pro',
    'num': 1,
    'price': 2799,
    'lastprice': 2369,
    'youfei': 8,
    'status': '待收货',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou1.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1122,
    'productName': '美的空调 大1.5匹 全面风PRO 风尊二代 家电国家补贴20%空调挂机 超一级能效 KFR-35GW/N8MXC1ⅡPro',
    'address': '江苏苏州市吴江区江陵街道江陵东路599号璀璨**花园2栋一单元6*1',
    'phone': '17851741124-2415',
    'name': '杨女士',
    'size': '大1.5匹 一级能效 风尊二代PRO',
    'num': 1,
    'price': 3699,
    'lastprice': 3584.2,
    'youfei': 8,
    'status': '已完成',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou2.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1123,
    'productName': '美的空调挂机大1.5匹 酷省电Ultra新一级能效变频冷暖以旧换新国家补贴【25年新品】KFR-35GW/N8KS1-1U',
    'address': '湖北武汉市蔡甸区**街道秦*路60号',
    'phone': '17834774515-2631',
    'name': '周峰',
    'size': '大1.5匹 一级能效 酷省电ultra',
    'num': 1,
    'price': 2769,
    'lastprice': 2620.55,
    'youfei': null,
    'status': '已完成',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou3.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1124,
    'productName': '美的大1.5匹 风尊二代PRO 2024新款 超一级能效空调挂机 安睡 家电政府补贴 KFR-35GW/N8MXC1ⅡPro',
    'address': '广东惠州市惠*区江北街道金**1栋2603室',
    'phone': '17834774515-2631',
    'name': '明镜',
    'size': '大1.5匹 一级能效 全新风尊二代PRO',
    'num': 1,
    'price': 3900,
    'lastprice': 2499.36,
    'youfei': 8,
    'status': '已完成',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou4.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1125,
    'productName': '美的空调 大1匹 酷省电 新一级能效 变频冷暖 壁挂式小空调挂机节能 家电国家补贴 KFR-26GW/N8KS1-1',
    'address': '湖南长沙市岳麓区**洲街道湖南大学阜**小区',
    'phone': '18472749095-6063 ',
    'name': '西西',
    'size': '大1匹 一级能效 酷省电',
    'num': 1,
    'price': 2099,
    'lastprice': 1749,
    'youfei': null,
    'status': '已完成',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou5.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1126,
    'productName': '美的空调 大1.5匹 酷省电 新一级能效 变频冷暖 省电壁挂式卧室挂机 国家补贴 KFR-35GW/N8KS1-1 ',
    'address': ' 广东清远市清城区洲*街道***家11栋11栋6A',
    'phone': '17820056315-1257 ',
    'name': '朱先去',
    'size': '大1.5匹 一级能效 酷省电',
    'num': 1,
    'price': 2099,
    'lastprice': 1778.92,
    'youfei': null,
    'status': '已完成',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou6.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1127,
    'productName': '美的（Midea）大1匹 变频 智弧 冷暖 智能壁挂式空调 KFR-26GW/WDAA3@',
    'address': '山东聊城市临清市城区车营城***(温泉路北100米)车***花园10号楼3单元802',
    'phone': '18472749095-6063 ',
    'name': '王立民',
    'size': '大1匹',
    'num': 1,
    'price': 2399,
    'lastprice': 2399,
    'youfei': 0,
    'status': '已完成',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou7.png',
    'actionType': '',
    'remark': ''
  }, {
    'id': 1128,
    'productName': '美的空调 大1.5匹 酷省电pro 新一级能效 变频冷暖 家电国家补贴 节能壁挂式挂机 KFR-35GW/N8KS1-1P',
    'address': '四川眉山市彭山区锦江镇莲花村恒大金碧***栋1503房',
    'phone': '17834774634-6323 ',
    'name': '杨小虎',
    'size': '大1.5匹 一级能效 酷省电pro',
    'num': 1,
    'price': 2679,
    'lastprice': 2668.2,
    'youfei': null,
    'status': '已完成',
    'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou8.png',
    'actionType': '',
    'remark': ''
  }]
};
var _default = exports.default = orders;

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderMsgCard_vue__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderMsgCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderMsgCard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderMsgCard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderMsgCard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da29697_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderMsgCard_vue__ = __webpack_require__(1717);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1715)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2da29697"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderMsgCard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da29697_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderMsgCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/components/OrderMsgCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2da29697", Component.options)
  } else {
    hotAPI.reload("data-v-2da29697", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 聊天流中的订单卡片消息（抖店/京麦统一外观，无操作按钮）
// platform 预留区分平台，目前两端外观一致
var _default = exports.default = {
  name: 'OrderMsgCard',
  props: {
    order: {
      type: Object,
      required: true
    },
    platform: {
      type: String,
      default: ''
    }
  },
  computed: {
    priceText: function priceText() {
      var p = Number(this.order && this.order.price);
      return isFinite(p) ? p.toFixed(2) : this.order && this.order.price || '';
    }
  }
};

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseProductModal_vue__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseProductModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseProductModal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseProductModal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseProductModal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175ddb66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseProductModal_vue__ = __webpack_require__(1720);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1718)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-175ddb66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseProductModal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175ddb66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseProductModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/components/CourseProductModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-175ddb66", Component.options)
  } else {
    hotAPI.reload("data-v-175ddb66", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CourseProductModal',
  props: {
    courseId: {
      type: [String, Number],
      default: null
    }
  },
  data: function data() {
    return {
      products: [],
      beginVisible: false,
      orderVisible: false,
      beginActiveIndex: 0,
      orderActiveIndex: 0
    };
  },
  mounted: function mounted() {
    this.fetchProducts();
  },
  watch: {
    courseId: function courseId() {
      this.fetchProducts();
    }
  },
  methods: {
    fetchProducts: function fetchProducts() {
      var _this = this;
      if (!this.courseId) {
        this.$emit('products-fetched', false);
        return;
      }
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/courseProduct?courseId=' + this.courseId).then(function (res) {
        var result = res.data;
        _this.products = result && result.success && result.data ? result.data : [];
        _this.$emit('products-fetched', _this.products.length > 0);
      }).catch(function () {
        _this.products = [];
        _this.$emit('products-fetched', false);
      });
    },
    handleStart: function handleStart() {
      if (this.products.length > 0) {
        this.beginActiveIndex = 0;
        this.beginVisible = true;
      } else {
        this.$emit('confirm');
      }
    },
    showProducts: function showProducts() {
      this.orderActiveIndex = 0;
      this.orderVisible = true;
    },
    onBeginConfirm: function onBeginConfirm() {
      this.beginVisible = false;
      this.$emit('confirm');
    }
  }
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      myExamNum: null,
      //我的完成次数
      nextCourseId: null,
      //下个课程，一般用于 功能学习的，下个课程
      examNum: null,
      OnInline: 'false',
      //小助手跳转
      tabIndex: 0,
      //序号
      tabCurrent: 'zero',
      //当前标签页
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      isOpenPpt7: false,
      //是否展开ppt
      isOpenPpt8: false,
      //是否展开ppt
      isOpenPpt9: false,
      //是否展开ppt
      isOpenPpt10: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示图标
      isShowQnIcon2: false,
      //显示点击图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowMimaImg: false,
      //显示记住密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      showGqImg: false,
      //显示切换挂起图片
      isShowWgq: false,
      //显示未挂起图片
      //第3步
      isShowOne: true,
      //显示排序1
      isShowTwo: false,
      //显示排序2
      isShowThree: false,
      //显示排序3
      isShowFour: false,
      //显示排序4
      isShowFive: false,
      //显示排序5
      isShowSix: false,
      //显示数据
      //第4步
      zdhf: '',
      //自动回复输入框
      isShowZdhficon: true,
      isShowZdhf01: false,
      isShowZdhf02: false,
      isShowZdhf03: false,
      isShowZdhf04: false,
      isShowZdhf05: false,
      isShowZdhf06: false,
      isShowZdhf07: false,
      isShowZdhf08: false,
      //第5步
      kjdy: '',
      //快捷编码输入框-16
      kjdytwo: '',
      //快捷编码输入框-发货
      xjkjdy: '',
      //新建快捷短语
      fenzu: '',
      //分组名称
      kjbm: '',
      //快捷编码
      downCount: 0,
      //是否点击下载csv
      isShowKjdy01: true,
      isShowKjdy02: false,
      isShowKjdy03: false,
      isShowKjdy04: false,
      isShowKjdy05: false,
      isShowKjdy06: false,
      isShowKjdy07: false,
      isShowKjdy08: false,
      isShowKjdy09: false,
      isShowKjdy10: false,
      isShowKjdy11: false,
      isShowKjdy12: false,
      isShowKjdy13: false,
      isShowKjdy14: false,
      isShowKjdy15: false,
      isShowKjdy16: false,
      isShowKjdy17: false,
      isShowKjdy18: false,
      isShowKjdy19: false,
      isShowKjdy20: false,
      isShowKjdy21: false,
      isShowKjdy22: false,
      isShowKjdy23: false,
      isShowKjdyTip01: true,
      isShowKjdyTip02: false,
      isShowKjdyTip03: false,
      isShowKjdyTip04: false,
      isShowKjdyTip05: false,
      isShowKjdyTip06: false,
      //第6步
      isShowZjgn01: true,
      isShowZjgn02: false,
      isShowZjgn03: false,
      isShowZjgn04: false,
      isShowZjgn05: false,
      isShowZjgn06: false,
      isShowZjgn07: false,
      //第7步上
      isShowCjgn01: true,
      isShowCjgn02: false,
      isShowCjgn03: false,
      isShowCjgn04: false,
      isShowCjgn05: false,
      isShowCjgn06: false,
      isShowCjgn07: false,
      isShowCjgn08: false,
      isShowCjgn09: false,
      isShowCjgn10: false,
      isShowCjgn11: false,
      isShowCjgn12: false,
      isShowCjgn13: false,
      isShowCjgn14: false,
      isShowCjgn15: false,
      isShowCjgn16: false,
      isShowCjgn17: false,
      isShowCjgn18: false,
      isShowCjgn19: false,
      isShowCjgn20: false,
      isShowCjgnTip01: true,
      isShowCjgnTip02: false,
      isShowCjgnTip03: false,
      isShowCjgnTip04: false,
      isShowCjgnTip05: false,
      isShowCjgnTip06: false,
      isShowCjgnTip07: false,
      //第7步下
      yunfei: '',
      dizhi: '',
      beizhu: '',
      isShowCjgnx01: true,
      isShowCjgnx02: false,
      isShowCjgnx03: false,
      isShowCjgnx04: false,
      isShowCjgnx05: false,
      isShowCjgnx06: false,
      isShowCjgnx07: false,
      isShowCjgnx08: false,
      isShowCjgnx09: false,
      isShowCjgnx10: false,
      isShowCjgnx11: false,
      isShowCjgnx12: false,
      isShowCjgnx13: false,
      isShowCjgnxTip01: true,
      isShowCjgnxTip02: false,
      isShowCjgnxTip03: false,
      isShowCjgnxTip04: false,
      isShowCjgnxTip05: false,
      isShowCjgnxTip06: false,
      //第8步
      isShowTcjm01: true,
      isShowTcjm02: false,
      isShowTcjm03: false,
      isShowTcjm04: false,
      isShowTcjm05: false,
      isShowTcjm06: false,
      isShowTcjm07: false,
      isShowTcjm08: false,
      isShowTcjm09: false,
      isShowTcjm10: false,
      isShowTcjmTip01: true,
      isShowTcjmTip02: false,
      isShowTcjmTip03: false,
      //第9步
      duomaiStep: 1,
      mouseFocusDM: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this.tabCurrent).show();
      _this.$set(_this.isShowBtn, _this.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/16') {
        this.isShowKjdy08 = false;
        this.isShowKjdy09 = true;
      }
    },
    kjdytwo: function kjdytwo() {
      if (this.kjdytwo == '/发货') {
        this.isShowKjdy12 = false;
        this.isShowKjdy13 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.back();
    },
    goExam: function goExam() {
      if (this.examNum && this.myExamNum >= this.examNum) {
        if (this.nextCourseId) {
          this.$router.replace({
            name: 'fbtJingmaiExam',
            query: {
              courseId: this.nextCourseId
            }
          });
        } else {
          this.$router.back();
        }
      } else {
        location.reload();
      }
    },
    lastStep: function lastStep() {
      this.duomaiStep = 5;
      this.mouseFocusDM = false;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('zero').play();
      $('#startvideo').hide();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowMimaImg = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.showGqImg = false;
      this.isShowWgq = false;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowOne = true;
      this.isShowTwo = false;
      this.isShowThree = false;
      this.isShowFour = false;
      this.isShowFive = false;
      this.isShowSix = false;
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.zdhf = '';
      this.isShowZdhficon = true;
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = false;
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.kjdy = '';
      this.kjdytwo = '';
      this.xjkjdy = '';
      this.fenzu = '';
      this.downCount = 0;
      this.isShowKjdy01 = true;
      this.isShowKjdy02 = false;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = false;
      this.isShowKjdy08 = false;
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = false;
      this.isShowKjdy12 = false;
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = false;
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = false;
      this.isShowKjdyTip01 = true;
      this.isShowKjdyTip02 = false;
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = false;
      this.isShowKjdyTip05 = false;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.isShowZjgn01 = true;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = false;
    },
    //初始化第7步上状态值
    initSeven: function initSeven() {
      this.isShowCjgn01 = true;
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = false;
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = false;
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = false;
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = false;
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = false;
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = false;
      this.isShowCjgnTip01 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = false;
      this.isShowCjgnTip04 = false;
      this.isShowCjgnTip05 = false;
      this.isShowCjgnTip06 = false;
      this.isShowCjgnTip07 = false;
    },
    //初始化第7步下状态值
    initEight: function initEight() {
      this.yunfei = '';
      this.dizhi = '';
      this.beizhu = '';
      this.isShowCjgnx01 = true;
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = false;
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = false;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = false;
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = false;
      this.isShowCjgnxTip01 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = false;
      this.isShowCjgnxTip04 = false;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = false;
    },
    //初始化第8步状态值
    initNine: function initNine() {
      this.isShowTcjm01 = true;
      this.isShowTcjm02 = false;
      this.isShowTcjm03 = false;
      this.isShowTcjm04 = false;
      this.isShowTcjm05 = false;
      this.isShowTcjm06 = false;
      this.isShowTcjm07 = false;
      this.isShowTcjm08 = false;
      this.isShowTcjm09 = false;
      this.isShowTcjm10 = false;
      this.isShowTcjmTip01 = true;
      this.isShowTcjmTip02 = false;
      this.isShowTcjmTip03 = false;
    },
    //初始化第9步状态值
    initTen: function initTen() {
      this.duomaiStep = 1;
      this.mouseFocusDM = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      $('#startvideo').hide();
      this.isShowBtn = [];
      this.isOpenPpt = false;
      this.isOpenPpt2 = false;
      this.isOpenPpt3 = false;
      this.isOpenPpt4 = false;
      this.isOpenPpt5 = false;
      this.isOpenPpt6 = false;
      this.isOpenPpt7 = false;
      this.isOpenPpt8 = false;
      this.isOpenPpt9 = false;
      this.isOpenPpt10 = false;
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      $('#pdf_viewer7').height('0');
      $('#pdf_viewer8').height('0');
      $('#pdf_viewer9').height('0');
      $('#pdf_viewer10').height('0');
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步上
      this.initSeven();
      //第7步下
      this.initEight();
      //第9步
      this.initNine();
      //第9步
      this.initTen();
      $('.content').each(function (i) {
        $(this).hide();
      });
      $('.stoptip').each(function (i) {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function (i) {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show();
    },
    //tab切换
    handleClick: function handleClick(tab, event) {
      var _this2 = this;
      this.tabIndex = parseInt(tab.index) + 1;
      //内容初始化
      this.initAll();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this2.tabCurrent).show();
        _this2.$set(_this2.isShowBtn, _this2.tabCurrent, true);
      }, false);
    },
    //展开/收起ppt
    viewPpt: function viewPpt(bol) {
      if (this.isOpenPpt == true || !bol) {
        this.isOpenPpt = false;
        $('#pdf_viewer').height('0');
      } else {
        this.isOpenPpt = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/2022-11/47a9abea7f634f6ea4687fc57e21fd9b.pdf?version=0512', "#pdf_viewer", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt2: function viewPpt2(bol) {
      if (this.isOpenPpt2 == true || !bol) {
        this.isOpenPpt2 = false;
        $('#pdf_viewer2').height('0');
      } else {
        this.isOpenPpt2 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer2').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-002.pdf?version=0512', "#pdf_viewer2", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt3: function viewPpt3(bol) {
      if (this.isOpenPpt3 == true || !bol) {
        this.isOpenPpt3 = false;
        $('#pdf_viewer3').height('0');
      } else {
        this.isOpenPpt3 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer3').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-003.pdf?version=0512', "#pdf_viewer3", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt4: function viewPpt4(bol) {
      if (this.isOpenPpt4 == true || !bol) {
        this.isOpenPpt4 = false;
        $('#pdf_viewer4').height('0');
      } else {
        this.isOpenPpt4 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer4').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-004.pdf?version=0512', "#pdf_viewer4", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt5: function viewPpt5(bol) {
      if (this.isOpenPpt5 == true || !bol) {
        this.isOpenPpt5 = false;
        $('#pdf_viewer5').height('0');
      } else {
        this.isOpenPpt5 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer5').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-005.pdf?version=0512', "#pdf_viewer5", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt6: function viewPpt6(bol) {
      if (this.isOpenPpt6 == true || !bol) {
        this.isOpenPpt6 = false;
        $('#pdf_viewer6').height('0');
      } else {
        this.isOpenPpt6 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer6').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-006.pdf?version=0512', "#pdf_viewer6", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt7: function viewPpt7(bol) {
      if (this.isOpenPpt7 == true || !bol) {
        this.isOpenPpt7 = false;
        $('#pdf_viewer7').height('0');
      } else {
        this.isOpenPpt7 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer7').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-007-01.pdf?version=0512', "#pdf_viewer7", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt8: function viewPpt8(bol) {
      if (this.isOpenPpt8 == true || !bol) {
        this.isOpenPpt8 = false;
        $('#pdf_viewer8').height('0');
      } else {
        this.isOpenPpt8 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer8').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-007-02.pdf?version=0512', "#pdf_viewer8", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt9: function viewPpt9(bol) {
      if (this.isOpenPpt9 == true || !bol) {
        this.isOpenPpt9 = false;
        $('#pdf_viewer9').height('0');
      } else {
        this.isOpenPpt9 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer9').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/jingmai/jingmai-008.pdf?version=0512', "#pdf_viewer9", options);
        }
      }
    },
    //展开/收起ppt
    viewPpt10: function viewPpt10(bol) {
      if (this.isOpenPpt10 == true || !bol) {
        this.isOpenPpt10 = false;
        $('#pdf_viewer10').height('0');
      } else {
        this.isOpenPpt10 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer10').height('700px');
          _pdfobject.default.embed('//res.study.itaojin.cn/training-resource/2025-09/%E4%BB%8E%E5%A4%9A%E8%84%89%E5%90%AF%E5%8A%A8%E4%BA%AC%E9%BA%A6-%E5%B0%8F%E5%8A%A9%E6%89%8B%E8%AF%BE%E4%BB%B6.pdf', "#pdf_viewer10", options);
        }
      }
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $('#stoptip-' + this.tabCurrent).hide();
    },
    //第9节-重看视频
    restartVideoNine: function restartVideoNine() {
      this.initNine();
      $('#studytip-' + this.tabCurrent).hide();
      document.getElementById(this.tabCurrent).currentTime = 0;
      this.addRecord('START');
    },
    //第910节-重看视频
    restartVideoTen: function restartVideoTen() {
      this.initTen();
      $('#studytip-' + this.tabCurrent).hide();
      document.getElementById(this.tabCurrent).currentTime = 0;
      this.addRecord('START');
    },
    //开始实操练习
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.isShowBtn[this.tabCurrent] = false;
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START');
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initFirst();
      this.initSecond();
      this.initThird();
      this.initFour();
      this.initFive();
      this.initSix();
      this.initSeven();
      this.initEight();
      this.initNine();
      this.initTen();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.$notify({
          message: '请输入账号',
          duration: 2000
        });
        return;
      } else if (this.name != '淘金客服:002') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (this.password == '') {
        this.$notify({
          message: '请输入密码',
          duration: 2000
        });
        return;
      } else if (this.password != 'TJ2022') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (!this.isShowMimaImg) {
        this.$notify({
          message: '请勾选记住密码',
          duration: 2000
        });
        return;
      }
      this.isShowLoginImg = false;
      this.isShowMimaImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.$notify({
          message: '请输入短信验证码',
          duration: 2000
        });
        return;
      } else if (this.rnd != '6022') {
        this.$notify({
          message: '短信验证码错误',
          duration: 2000
        });
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练-登录
    restartStudyFirst: function restartStudyFirst() {
      this.initFirst();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg: function showWgqImg() {
      var self = this;
      this.showGqImg = false;
      this.isShowWgq = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练-切换状态
    restartStudySecond: function restartStudySecond() {
      this.initSecond();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第3步-排序
    showPaixuImgOne: function showPaixuImgOne() {
      this.isShowOne = false;
      this.isShowTwo = true;
    },
    showPaixuImgTwo: function showPaixuImgTwo() {
      this.isShowTwo = false;
      this.isShowThree = true;
    },
    showPaixuImgThree: function showPaixuImgThree() {
      this.isShowThree = false;
      this.isShowFour = true;
    },
    showPaixuImgFour: function showPaixuImgFour() {
      this.isShowFour = false;
      this.isShowFive = true;
    },
    showPaixuImgFive: function showPaixuImgFive() {
      var self = this;
      this.isShowFive = false;
      this.isShowSix = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第三步
    restartStudyThird: function restartStudyThird() {
      this.initThird();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第4步-自动回复
    showZdhf01: function showZdhf01() {
      this.isShowZdhficon = false;
      this.isShowZdhf01 = true;
    },
    showZdhf02: function showZdhf02() {
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = true;
    },
    showZdhf03: function showZdhf03() {
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = true;
    },
    showZdhf04: function showZdhf04() {
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = true;
    },
    showZdhf05: function showZdhf05() {
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = true;
    },
    showZdhf06: function showZdhf06() {
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = true;
    },
    showZdhf07: function showZdhf07() {
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = true;
    },
    showZdhf08: function showZdhf08() {
      var self = this;
      if (this.zdhf != '您好！欢迎光临，请问有什么可以帮到您？') {
        this.$notify({
          message: '请输入正确的回复内容',
          duration: 2000
        });
        return;
      }
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第4步-自动回复
    restartStudyFour: function restartStudyFour() {
      this.initFour();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第5步-快捷短语
    showKjdy01: function showKjdy01() {
      if (this.downCount == 0) {
        this.$notify({
          message: '请先下载快捷短语模板',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy01 = false;
      this.isShowKjdy02 = true;
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // window.open('//res.study.itaojin.cn/jingmai/快捷短语.csv');
      var path = '//res.study.itaojin.cn/jingmai/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$notify({
          message: '请选择你下载的“快捷短语.csv”模板文件',
          duration: 2000
        });
        return false;
      }
      self.isShowKjdy02 = false;
      self.isShowKjdy03 = true;
      self.$notify({
        message: '快捷短语导入练习完成，下一步快捷短语调出练习',
        duration: 2000
      });
      setTimeout(function () {
        self.isShowKjdy03 = false;
        self.isShowKjdy04 = true;
        self.isShowKjdyTip02 = false;
        self.isShowKjdyTip03 = true;
      }, 2000);
    },
    showKjdy02: function showKjdy02() {
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = true;
    },
    showKjdy03: function showKjdy03() {
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = true;
    },
    showKjdy04: function showKjdy04() {
      var self = this;
      self.isShowKjdy06 = false;
      self.isShowKjdy07 = true;
      setTimeout(function () {
        self.isShowKjdy07 = false;
        self.isShowKjdy08 = true;
        self.isShowKjdyTip03 = false;
        self.isShowKjdyTip04 = true;
      }, 2000);
    },
    showKjdy05: function showKjdy05() {
      this.kjdy = '';
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = true;
    },
    showKjdy06: function showKjdy06() {
      var self = this;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = true;
      setTimeout(function () {
        self.isShowKjdy11 = false;
        self.isShowKjdy12 = true;
        self.isShowKjdyTip04 = false;
        self.isShowKjdyTip05 = true;
      }, 2000);
    },
    showKjdy07: function showKjdy07() {
      this.kjdytwo = '';
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = true;
    },
    showKjdy08: function showKjdy08() {
      var self = this;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = true;
      setTimeout(function () {
        self.isShowKjdy15 = false;
        self.isShowKjdy16 = true;
        self.isShowKjdyTip05 = false;
        self.isShowKjdyTip06 = true;
      }, 2000);
    },
    showKjdy09: function showKjdy09() {
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = true;
    },
    showKjdy10: function showKjdy10() {
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = true;
    },
    showKjdy11: function showKjdy11() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = true;
    },
    showKjdy12: function showKjdy12() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.fenzu != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语分组名称',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = true;
    },
    showKjdy13: function showKjdy13() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = true;
    },
    showKjdy14: function showKjdy14() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = true;
    },
    showKjdy15: function showKjdy15() {
      var self = this;
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.kjbm != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语编码',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第5步-快捷短语
    restartStudyFive: function restartStudyFive() {
      this.initFive();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第6步-转接
    showZjgn01: function showZjgn01() {
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = true;
    },
    showZjgn02: function showZjgn02() {
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = true;
    },
    showZjgn03: function showZjgn03() {
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = true;
    },
    showZjgn04: function showZjgn04() {
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = true;
    },
    showZjgn05: function showZjgn05() {
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = true;
    },
    showZjgn06: function showZjgn06() {
      var self = this;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第6步-转接
    restartStudySix: function restartStudySix() {
      this.initSix();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第7步-插件功能上
    showCjgn01: function showCjgn01() {
      this.isShowCjgn01 = false;
      this.isShowCjgn02 = true;
    },
    showCjgn02: function showCjgn02() {
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = true;
    },
    showCjgn03: function showCjgn03() {
      var self = this;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = true;
      setTimeout(function () {
        self.isShowCjgn04 = false;
        self.isShowCjgn05 = true;
        self.isShowCjgnTip01 = false;
        self.isShowCjgnTip02 = true;
      }, 2000);
    },
    showCjgn04: function showCjgn04() {
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = true;
    },
    showCjgn05: function showCjgn05() {
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = true;
    },
    showCjgn06: function showCjgn06() {
      var self = this;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = true;
      setTimeout(function () {
        self.isShowCjgn08 = false;
        self.isShowCjgn09 = true;
        self.isShowCjgnTip03 = false;
        self.isShowCjgnTip04 = true;
      }, 2000);
    },
    showCjgn07: function showCjgn07() {
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = true;
    },
    showCjgn08: function showCjgn08() {
      var self = this;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = true;
      setTimeout(function () {
        self.isShowCjgn11 = false;
        self.isShowCjgn12 = true;
        self.isShowCjgnTip04 = false;
        self.isShowCjgnTip05 = true;
      }, 2000);
    },
    showCjgn09: function showCjgn09() {
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = true;
    },
    showCjgn10: function showCjgn10() {
      var self = this;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = true;
      setTimeout(function () {
        self.isShowCjgn14 = false;
        self.isShowCjgn15 = true;
        self.isShowCjgnTip05 = false;
        self.isShowCjgnTip06 = true;
      }, 2000);
    },
    showCjgn11: function showCjgn11() {
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = true;
    },
    showCjgn12: function showCjgn12() {
      var self = this;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = true;
      setTimeout(function () {
        self.isShowCjgn17 = false;
        self.isShowCjgn18 = true;
        self.isShowCjgnTip06 = false;
        self.isShowCjgnTip07 = true;
      }, 2000);
    },
    showCjgn13: function showCjgn13() {
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = true;
    },
    showCjgn14: function showCjgn14() {
      var self = this;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第7步-插件功能上
    restartStudySeven: function restartStudySeven() {
      this.initSeven();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第7步-插件功能（下）
    showCjgnx01: function showCjgnx01() {
      this.isShowCjgnx01 = false;
      this.isShowCjgnx02 = true;
    },
    showCjgnx02: function showCjgnx02() {
      var self = this;
      if (this.yunfei != 15) {
        this.$notify({
          message: '请输入正确的运费',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = true;
      setTimeout(function () {
        self.isShowCjgnx03 = false;
        self.isShowCjgnx04 = true;
        self.isShowCjgnxTip01 = false;
        self.isShowCjgnxTip02 = true;
      }, 2000);
    },
    showCjgnx03: function showCjgnx03() {
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = true;
    },
    showCjgnx04: function showCjgnx04() {
      if (this.dizhi != '淘金云客服') {
        this.$notify({
          message: '请输入正确的详细地址',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = true;
    },
    showCjgnx05: function showCjgnx05() {
      var self = this;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = true;
      setTimeout(function () {
        self.isShowCjgnx07 = false;
        self.isShowCjgnx08 = true;
        self.isShowCjgnxTip03 = false;
        self.isShowCjgnxTip04 = true;
      }, 2000);
    },
    showCjgnx06: function showCjgnx06() {
      var self = this;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = true;
      setTimeout(function () {
        self.isShowCjgnx09 = false;
        self.isShowCjgnx10 = true;
        self.isShowCjgnxTip04 = false;
        self.isShowCjgnxTip05 = true;
      }, 2000);
    },
    showCjgnx07: function showCjgnx07() {
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = true;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = true;
    },
    showCjgnx08: function showCjgnx08() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = true;
    },
    showCjgnx09: function showCjgnx09() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = true;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //重练第7步-插件功能下
    restartStudyEight: function restartStudyEight() {
      this.initEight();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //第8步-退出京麦
    showTcjm01: function showTcjm01() {
      this.isShowTcjm01 = false;
      this.isShowTcjm02 = true;
    },
    showTcjm02: function showTcjm02() {
      this.isShowTcjm02 = false;
      this.isShowTcjm03 = true;
      this.isShowTcjmTip01 = false;
      this.isShowTcjmTip02 = true;
    },
    showTcjm03: function showTcjm03() {
      this.isShowTcjm03 = false;
      this.isShowTcjm04 = true;
      this.isShowTcjmTip02 = false;
      this.isShowTcjmTip03 = true;
      setTimeout(function () {
        var $left = $('.tcjm04icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight);
      }, 100);
    },
    showTcjm04: function showTcjm04() {
      this.isShowTcjm04 = false;
      this.isShowTcjm05 = true;
    },
    showTcjm05: function showTcjm05() {
      this.isShowTcjm06 = true;
    },
    showTcjm06: function showTcjm06() {
      this.isShowTcjm05 = false;
      this.isShowTcjm06 = false;
      this.isShowTcjm07 = true;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type) {
      var _this3 = this;
      var data = {
        exerciseType: 'JING_MAI_PLUGIN',
        stepSeq: this.tabIndex,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this3.tabIndex == 11 && type == 'END') {
            _this3.queryFinishInfo();
          }
        } else {
          _this3.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (res) {});
    },
    //查，完成了几次
    queryFinishInfo: function queryFinishInfo() {
      var _this4 = this;
      var query = {
        assitantType: "jingmaiplugin",
        courseId: this.$route.query.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryFinishInfo', query).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this4.myExamNum = result.data.examNum;
          _this4.examNum = result.data.targetPassCnt;
          _this4.nextCourseId = result.data.nextCourseId;
        } else {
          _this4.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (res) {
        _this4.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1500
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom02.e788316.png";

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom03.2d45f54.png";

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom04.1847c04.png";

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom05.b0bad8b.png";

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom06.cac994c.png";

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom07.f911208.png";

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom08.b88fe50.png";

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom09.1650e06.png";

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      myExamNum: null,
      //我的完成次数
      nextCourseId: null,
      //下个课程，一般用于 功能学习的，下个课程
      examNum: null,
      tabCurrent: 'first',
      OnInline: 'false',
      //小助手跳转
      //第1步
      isShowQnIcon: true,
      //是否显示图标
      isShowQnIcon2: false,
      //显示点击图标后图片
      isShowLoginImg: false,
      //是否显示登录图片
      name: '',
      //登录账号
      password: '',
      //密码
      showPassword: false,
      //显示账号密码
      isShowMimaImg: false,
      //显示记住密码
      isShowRnd: false,
      //显示获取随机码
      rnd: '',
      //随机密码
      showRnd: false,
      //显示随机码
      isShowLoginIndex: false,
      //显示登录后图片
      isShowLoginIndexTwo: false,
      //显示接待中心
      //第2步
      showGqImg: false,
      //显示切换挂起图片
      isShowWgq: false,
      //显示未挂起图片
      //第3步
      isShowOne: true,
      //显示排序1
      isShowTwo: false,
      //显示排序2
      isShowThree: false,
      //显示排序3
      isShowFour: false,
      //显示排序4
      isShowFive: false,
      //显示排序5
      isShowSix: false,
      //显示数据
      //第4步
      zdhf: '',
      //自动回复输入框
      isShowZdhficon: true,
      isShowZdhf01: false,
      isShowZdhf02: false,
      isShowZdhf03: false,
      isShowZdhf04: false,
      isShowZdhf05: false,
      isShowZdhf06: false,
      isShowZdhf07: false,
      isShowZdhf08: false,
      //第5步
      kjdy: '',
      //快捷编码输入框-16
      kjdytwo: '',
      //快捷编码输入框-发货
      xjkjdy: '',
      //新建快捷短语
      fenzu: '',
      //分组名称
      kjbm: '',
      //快捷编码
      downCount: 0,
      //是否点击下载csv
      isShowKjdy01: true,
      isShowKjdy02: false,
      isShowKjdy03: false,
      isShowKjdy04: false,
      isShowKjdy05: false,
      isShowKjdy06: false,
      isShowKjdy07: false,
      isShowKjdy08: false,
      isShowKjdy09: false,
      isShowKjdy10: false,
      isShowKjdy11: false,
      isShowKjdy12: false,
      isShowKjdy13: false,
      isShowKjdy14: false,
      isShowKjdy15: false,
      isShowKjdy16: false,
      isShowKjdy17: false,
      isShowKjdy18: false,
      isShowKjdy19: false,
      isShowKjdy20: false,
      isShowKjdy21: false,
      isShowKjdy22: false,
      isShowKjdy23: false,
      isShowKjdyTip01: true,
      isShowKjdyTip02: false,
      isShowKjdyTip03: false,
      isShowKjdyTip04: false,
      isShowKjdyTip05: false,
      isShowKjdyTip06: false,
      //第6步
      isShowZjgn01: true,
      isShowZjgn02: false,
      isShowZjgn03: false,
      isShowZjgn04: false,
      isShowZjgn05: false,
      isShowZjgn06: false,
      isShowZjgn07: false,
      //第7步上
      isShowCjgn01: true,
      isShowCjgn02: false,
      isShowCjgn03: false,
      isShowCjgn04: false,
      isShowCjgn05: false,
      isShowCjgn06: false,
      isShowCjgn07: false,
      isShowCjgn08: false,
      isShowCjgn09: false,
      isShowCjgn10: false,
      isShowCjgn11: false,
      isShowCjgn12: false,
      isShowCjgn13: false,
      isShowCjgn14: false,
      isShowCjgn15: false,
      isShowCjgn16: false,
      isShowCjgn17: false,
      isShowCjgn18: false,
      isShowCjgn19: false,
      isShowCjgn20: false,
      isShowCjgnTip01: true,
      isShowCjgnTip02: false,
      isShowCjgnTip03: false,
      isShowCjgnTip04: false,
      isShowCjgnTip05: false,
      isShowCjgnTip06: false,
      isShowCjgnTip07: false,
      //第7步下
      yunfei: '',
      dizhi: '',
      beizhu: '',
      isShowCjgnx01: true,
      isShowCjgnx02: false,
      isShowCjgnx03: false,
      isShowCjgnx04: false,
      isShowCjgnx05: false,
      isShowCjgnx06: false,
      isShowCjgnx07: false,
      isShowCjgnx08: false,
      isShowCjgnx09: false,
      isShowCjgnx10: false,
      isShowCjgnx11: false,
      isShowCjgnx12: false,
      isShowCjgnx13: false,
      isShowCjgnxTip01: true,
      isShowCjgnxTip02: false,
      isShowCjgnxTip03: false,
      isShowCjgnxTip04: false,
      isShowCjgnxTip05: false,
      isShowCjgnxTip06: false,
      //第8步
      isShowTcjm01: true,
      isShowTcjm02: false,
      isShowTcjm03: false,
      isShowTcjm04: false,
      isShowTcjm05: false,
      isShowTcjm06: false,
      isShowTcjm07: false,
      isShowTcjm08: false,
      isShowTcjm09: false,
      isShowTcjm10: false,
      isShowTcjmTip01: true,
      isShowTcjmTip02: false,
      isShowTcjmTip03: false,
      //第9步
      duomaiStep: 1,
      mouseFocusDM: false
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/16') {
        this.isShowKjdy08 = false;
        this.isShowKjdy09 = true;
      }
    },
    kjdytwo: function kjdytwo() {
      if (this.kjdytwo == '/发货') {
        this.isShowKjdy12 = false;
        this.isShowKjdy13 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }

    //跳到末尾步骤
    if (this.$route.query.end) {
      this.tabCurrent = 'ten';
      this.showTcjm06();
    }
  },
  methods: {
    goExam: function goExam() {
      if (this.examNum && this.myExamNum >= this.examNum) {
        this.$router.back();
      } else {
        location.reload();
      }
    },
    goBack: function goBack() {
      this.$router.back();
    },
    lastStep: function lastStep() {
      this.duomaiStep = 5;
      this.mouseFocusDM = false;
      var self = this;
      this.addRecord('END', 10);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('first').play();
      $('#startvideo').hide();
    },
    //初始化第1步状态值
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.rnd = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = false;
      this.showPassword = false;
      this.isShowMimaImg = false;
      this.isShowRnd = false;
      this.showRnd = false;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = false;
    },
    //初始化第2步状态值
    initSecond: function initSecond() {
      this.showGqImg = false;
      this.isShowWgq = false;
    },
    //初始化第3步状态值
    initThird: function initThird() {
      this.isShowOne = true;
      this.isShowTwo = false;
      this.isShowThree = false;
      this.isShowFour = false;
      this.isShowFive = false;
      this.isShowSix = false;
    },
    //初始化第4步状态值
    initFour: function initFour() {
      this.zdhf = '';
      this.isShowZdhficon = true;
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = false;
    },
    //初始化第5步状态值
    initFive: function initFive() {
      this.kjdy = '';
      this.kjdytwo = '';
      this.xjkjdy = '';
      this.fenzu = '';
      this.downCount = 0;
      this.isShowKjdy01 = true;
      this.isShowKjdy02 = false;
      this.isShowKjdy03 = false;
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = false;
      this.isShowKjdy07 = false;
      this.isShowKjdy08 = false;
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = false;
      this.isShowKjdy12 = false;
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = false;
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = false;
      this.isShowKjdyTip01 = true;
      this.isShowKjdyTip02 = false;
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = false;
      this.isShowKjdyTip05 = false;
    },
    //初始化第6步状态值
    initSix: function initSix() {
      this.isShowZjgn01 = true;
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = false;
    },
    //初始化第7步上状态值
    initSeven: function initSeven() {
      this.isShowCjgn01 = true;
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = false;
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = false;
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = false;
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = false;
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = false;
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = false;
      this.isShowCjgnTip01 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = false;
      this.isShowCjgnTip04 = false;
      this.isShowCjgnTip05 = false;
      this.isShowCjgnTip06 = false;
      this.isShowCjgnTip07 = false;
    },
    //初始化第7步下状态值
    initEight: function initEight() {
      this.yunfei = '';
      this.dizhi = '';
      this.beizhu = '';
      this.isShowCjgnx01 = true;
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = false;
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = false;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = false;
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = false;
      this.isShowCjgnxTip01 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = false;
      this.isShowCjgnxTip04 = false;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = false;
    },
    //初始化第8步状态值
    initNine: function initNine() {
      this.isShowTcjm01 = true;
      this.isShowTcjm02 = false;
      this.isShowTcjm03 = false;
      this.isShowTcjm04 = false;
      this.isShowTcjm05 = false;
      this.isShowTcjm06 = false;
      this.isShowTcjm07 = false;
      this.isShowTcjm08 = false;
      this.isShowTcjm09 = false;
      this.isShowTcjm10 = false;
      this.isShowTcjmTip01 = true;
      this.isShowTcjmTip02 = false;
      this.isShowTcjmTip03 = false;
    },
    //初始化第9步状态值
    initTen: function initTen() {
      this.duomaiStep = 1;
      this.mouseFocusDM = false;
    },
    //初始化所有tab内容
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步上
      this.initSeven();
      //第7步下
      this.initEight();
      //第9步
      this.initNine();
      //第10步
      this.initTen();
    },
    //开始实操练习
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowLoginImg = true;
    },
    //登录
    loginIn: function loginIn() {
      if (this.name == '') {
        this.$notify({
          message: '请输入账号',
          duration: 2000
        });
        return;
      } else if (this.name != '淘金客服:002') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (this.password == '') {
        this.$notify({
          message: '请输入密码',
          duration: 2000
        });
        return;
      } else if (this.password != 'TJ2022') {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>',
          duration: 2000
        });
        return;
      }
      if (!this.isShowMimaImg) {
        this.$notify({
          message: '请勾选记住密码',
          duration: 2000
        });
        return;
      }
      this.isShowLoginImg = false;
      this.isShowMimaImg = false;
      this.isShowRnd = true;
    },
    //验证码登录
    loginInRnd: function loginInRnd() {
      if (this.rnd == '') {
        this.$notify({
          message: '请输入短信验证码',
          duration: 2000
        });
        return;
      } else if (this.rnd != '6022') {
        this.$notify({
          message: '短信验证码错误',
          duration: 2000
        });
        return;
      }
      this.isShowRnd = false;
      this.isShowLoginIndex = true;
    },
    //进入接待中心
    enterJd: function enterJd() {
      var self = this;
      this.isShowLoginIndex = false;
      this.isShowLoginIndexTwo = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第2步-切换状态-显示未挂起图片
    showWgqImg: function showWgqImg() {
      var self = this;
      this.showGqImg = false;
      this.isShowWgq = true;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第3步-排序
    showPaixuImgOne: function showPaixuImgOne() {
      this.isShowOne = false;
      this.isShowTwo = true;
    },
    showPaixuImgTwo: function showPaixuImgTwo() {
      this.isShowTwo = false;
      this.isShowThree = true;
    },
    showPaixuImgThree: function showPaixuImgThree() {
      this.isShowThree = false;
      this.isShowFour = true;
    },
    showPaixuImgFour: function showPaixuImgFour() {
      this.isShowFour = false;
      this.isShowFive = true;
    },
    showPaixuImgFive: function showPaixuImgFive() {
      var self = this;
      this.isShowFive = false;
      this.isShowSix = true;
      this.addRecord('END', 3);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第4步-自动回复
    showZdhf01: function showZdhf01() {
      this.isShowZdhficon = false;
      this.isShowZdhf01 = true;
    },
    showZdhf02: function showZdhf02() {
      this.isShowZdhf01 = false;
      this.isShowZdhf02 = true;
    },
    showZdhf03: function showZdhf03() {
      this.isShowZdhf02 = false;
      this.isShowZdhf03 = true;
    },
    showZdhf04: function showZdhf04() {
      this.isShowZdhf03 = false;
      this.isShowZdhf04 = true;
    },
    showZdhf05: function showZdhf05() {
      this.isShowZdhf04 = false;
      this.isShowZdhf05 = true;
    },
    showZdhf06: function showZdhf06() {
      this.isShowZdhf05 = false;
      this.isShowZdhf06 = true;
    },
    showZdhf07: function showZdhf07() {
      this.isShowZdhf06 = false;
      this.isShowZdhf07 = true;
    },
    showZdhf08: function showZdhf08() {
      var self = this;
      if (this.zdhf != '您好！欢迎光临，请问有什么可以帮到您？') {
        this.$notify({
          message: '请输入正确的回复内容',
          duration: 2000
        });
        return;
      }
      this.isShowZdhf07 = false;
      this.isShowZdhf08 = true;
      this.addRecord('END', 4);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第5步-快捷短语
    showKjdy01: function showKjdy01() {
      if (this.downCount == 0) {
        this.$notify({
          message: '请先下载快捷短语模板',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy01 = false;
      this.isShowKjdy02 = true;
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // window.open('//res.study.itaojin.cn/jingmai/快捷短语.csv');
      var path = '//res.study.itaojin.cn/jingmai/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip01 = false;
      this.isShowKjdyTip02 = true;
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
        this.$notify({
          message: '请选择你下载的“快捷短语.csv”模板文件',
          duration: 2000
        });
        return false;
      }
      self.isShowKjdy02 = false;
      self.isShowKjdy03 = true;
      self.$notify({
        message: '快捷短语导入练习完成，下一步快捷短语调出练习',
        duration: 2000
      });
      setTimeout(function () {
        self.isShowKjdy03 = false;
        self.isShowKjdy04 = true;
        self.isShowKjdyTip02 = false;
        self.isShowKjdyTip03 = true;
      }, 2000);
    },
    showKjdy02: function showKjdy02() {
      this.isShowKjdy04 = false;
      this.isShowKjdy05 = true;
    },
    showKjdy03: function showKjdy03() {
      this.isShowKjdy05 = false;
      this.isShowKjdy06 = true;
    },
    showKjdy04: function showKjdy04() {
      var self = this;
      self.isShowKjdy06 = false;
      self.isShowKjdy07 = true;
      setTimeout(function () {
        self.isShowKjdy07 = false;
        self.isShowKjdy08 = true;
        self.isShowKjdyTip03 = false;
        self.isShowKjdyTip04 = true;
      }, 2000);
    },
    showKjdy05: function showKjdy05() {
      this.kjdy = '';
      this.isShowKjdy09 = false;
      this.isShowKjdy10 = true;
    },
    showKjdy06: function showKjdy06() {
      var self = this;
      this.isShowKjdy10 = false;
      this.isShowKjdy11 = true;
      setTimeout(function () {
        self.isShowKjdy11 = false;
        self.isShowKjdy12 = true;
        self.isShowKjdyTip04 = false;
        self.isShowKjdyTip05 = true;
      }, 2000);
    },
    showKjdy07: function showKjdy07() {
      this.kjdytwo = '';
      this.isShowKjdy13 = false;
      this.isShowKjdy14 = true;
    },
    showKjdy08: function showKjdy08() {
      var self = this;
      this.isShowKjdy14 = false;
      this.isShowKjdy15 = true;
      setTimeout(function () {
        self.isShowKjdy15 = false;
        self.isShowKjdy16 = true;
        self.isShowKjdyTip05 = false;
        self.isShowKjdyTip06 = true;
      }, 2000);
    },
    showKjdy09: function showKjdy09() {
      this.isShowKjdy16 = false;
      this.isShowKjdy17 = true;
    },
    showKjdy10: function showKjdy10() {
      this.isShowKjdy17 = false;
      this.isShowKjdy18 = true;
    },
    showKjdy11: function showKjdy11() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy18 = false;
      this.isShowKjdy19 = true;
    },
    showKjdy12: function showKjdy12() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.fenzu != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语分组名称',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy19 = false;
      this.isShowKjdy20 = true;
    },
    showKjdy13: function showKjdy13() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy20 = false;
      this.isShowKjdy21 = true;
    },
    showKjdy14: function showKjdy14() {
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy21 = false;
      this.isShowKjdy22 = true;
    },
    showKjdy15: function showKjdy15() {
      var self = this;
      if (this.xjkjdy != '您好！您拍下的商品还未付款，请问您是有什么顾虑吗？') {
        this.$notify({
          message: '请输入正确的快捷短语内容',
          duration: 2000
        });
        return false;
      }
      if (this.kjbm != '催付') {
        this.$notify({
          message: '请输入正确的快捷短语编码',
          duration: 2000
        });
        return false;
      }
      this.isShowKjdy22 = false;
      this.isShowKjdy23 = true;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第6步-转接
    showZjgn01: function showZjgn01() {
      this.isShowZjgn01 = false;
      this.isShowZjgn02 = true;
    },
    showZjgn02: function showZjgn02() {
      this.isShowZjgn02 = false;
      this.isShowZjgn03 = true;
    },
    showZjgn03: function showZjgn03() {
      this.isShowZjgn03 = false;
      this.isShowZjgn04 = true;
    },
    showZjgn04: function showZjgn04() {
      this.isShowZjgn04 = false;
      this.isShowZjgn05 = true;
    },
    showZjgn05: function showZjgn05() {
      this.isShowZjgn05 = false;
      this.isShowZjgn06 = true;
    },
    showZjgn06: function showZjgn06() {
      var self = this;
      this.isShowZjgn06 = false;
      this.isShowZjgn07 = true;
      this.addRecord('END', 6);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第7步-插件功能上
    showCjgn01: function showCjgn01() {
      this.isShowCjgn01 = false;
      this.isShowCjgn02 = true;
    },
    showCjgn02: function showCjgn02() {
      this.isShowCjgn02 = false;
      this.isShowCjgn03 = true;
    },
    showCjgn03: function showCjgn03() {
      var self = this;
      this.isShowCjgn03 = false;
      this.isShowCjgn04 = true;
      setTimeout(function () {
        self.isShowCjgn04 = false;
        self.isShowCjgn05 = true;
        self.isShowCjgnTip01 = false;
        self.isShowCjgnTip02 = true;
      }, 2000);
    },
    showCjgn04: function showCjgn04() {
      this.isShowCjgn05 = false;
      this.isShowCjgn06 = true;
      this.isShowCjgnTip02 = false;
      this.isShowCjgnTip03 = true;
    },
    showCjgn05: function showCjgn05() {
      this.isShowCjgn06 = false;
      this.isShowCjgn07 = true;
    },
    showCjgn06: function showCjgn06() {
      var self = this;
      this.isShowCjgn07 = false;
      this.isShowCjgn08 = true;
      setTimeout(function () {
        self.isShowCjgn08 = false;
        self.isShowCjgn09 = true;
        self.isShowCjgnTip03 = false;
        self.isShowCjgnTip04 = true;
      }, 2000);
    },
    showCjgn07: function showCjgn07() {
      this.isShowCjgn09 = false;
      this.isShowCjgn10 = true;
    },
    showCjgn08: function showCjgn08() {
      var self = this;
      this.isShowCjgn10 = false;
      this.isShowCjgn11 = true;
      setTimeout(function () {
        self.isShowCjgn11 = false;
        self.isShowCjgn12 = true;
        self.isShowCjgnTip04 = false;
        self.isShowCjgnTip05 = true;
      }, 2000);
    },
    showCjgn09: function showCjgn09() {
      this.isShowCjgn12 = false;
      this.isShowCjgn13 = true;
    },
    showCjgn10: function showCjgn10() {
      var self = this;
      this.isShowCjgn13 = false;
      this.isShowCjgn14 = true;
      setTimeout(function () {
        self.isShowCjgn14 = false;
        self.isShowCjgn15 = true;
        self.isShowCjgnTip05 = false;
        self.isShowCjgnTip06 = true;
      }, 2000);
    },
    showCjgn11: function showCjgn11() {
      this.isShowCjgn15 = false;
      this.isShowCjgn16 = true;
    },
    showCjgn12: function showCjgn12() {
      var self = this;
      this.isShowCjgn16 = false;
      this.isShowCjgn17 = true;
      setTimeout(function () {
        self.isShowCjgn17 = false;
        self.isShowCjgn18 = true;
        self.isShowCjgnTip06 = false;
        self.isShowCjgnTip07 = true;
      }, 2000);
    },
    showCjgn13: function showCjgn13() {
      this.isShowCjgn18 = false;
      this.isShowCjgn19 = true;
    },
    showCjgn14: function showCjgn14() {
      var self = this;
      this.isShowCjgn19 = false;
      this.isShowCjgn20 = true;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第7步-插件功能（下）
    showCjgnx01: function showCjgnx01() {
      this.isShowCjgnx01 = false;
      this.isShowCjgnx02 = true;
    },
    showCjgnx02: function showCjgnx02() {
      var self = this;
      if (this.yunfei != 15) {
        this.$notify({
          message: '请输入正确的运费',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx02 = false;
      this.isShowCjgnx03 = true;
      setTimeout(function () {
        self.isShowCjgnx03 = false;
        self.isShowCjgnx04 = true;
        self.isShowCjgnxTip01 = false;
        self.isShowCjgnxTip02 = true;
      }, 2000);
    },
    showCjgnx03: function showCjgnx03() {
      this.isShowCjgnx04 = false;
      this.isShowCjgnx05 = true;
    },
    showCjgnx04: function showCjgnx04() {
      if (this.dizhi != '淘金云客服') {
        this.$notify({
          message: '请输入正确的详细地址',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx05 = false;
      this.isShowCjgnx06 = true;
      this.isShowCjgnxTip02 = false;
      this.isShowCjgnxTip03 = true;
    },
    showCjgnx05: function showCjgnx05() {
      var self = this;
      this.isShowCjgnx06 = false;
      this.isShowCjgnx07 = true;
      setTimeout(function () {
        self.isShowCjgnx07 = false;
        self.isShowCjgnx08 = true;
        self.isShowCjgnxTip03 = false;
        self.isShowCjgnxTip04 = true;
      }, 2000);
    },
    showCjgnx06: function showCjgnx06() {
      var self = this;
      this.isShowCjgnx08 = false;
      this.isShowCjgnx09 = true;
      setTimeout(function () {
        self.isShowCjgnx09 = false;
        self.isShowCjgnx10 = true;
        self.isShowCjgnxTip04 = false;
        self.isShowCjgnxTip05 = true;
      }, 2000);
    },
    showCjgnx07: function showCjgnx07() {
      this.isShowCjgnx10 = false;
      this.isShowCjgnx11 = true;
      this.isShowCjgnxTip05 = false;
      this.isShowCjgnxTip06 = true;
    },
    showCjgnx08: function showCjgnx08() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx11 = false;
      this.isShowCjgnx12 = true;
    },
    showCjgnx09: function showCjgnx09() {
      if (this.beizhu != '要纸质发票') {
        this.$notify({
          message: '请输入正确的备注',
          duration: 2000
        });
        return false;
      }
      this.isShowCjgnx12 = false;
      this.isShowCjgnx13 = true;
      var self = this;
      this.addRecord('END', 8);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    //第8步-退出京麦
    showTcjm01: function showTcjm01() {
      this.isShowTcjm01 = false;
      this.isShowTcjm02 = true;
    },
    showTcjm02: function showTcjm02() {
      this.isShowTcjm02 = false;
      this.isShowTcjm03 = true;
      this.isShowTcjmTip01 = false;
      this.isShowTcjmTip02 = true;
    },
    showTcjm03: function showTcjm03() {
      this.isShowTcjm03 = false;
      this.isShowTcjm04 = true;
      this.isShowTcjmTip02 = false;
      this.isShowTcjmTip03 = true;
      setTimeout(function () {
        var $left = $('.tcjm04icon').closest('.con-left');
        $left.scrollTop($left[0].scrollHeight);
      }, 100);
    },
    showTcjm04: function showTcjm04() {
      this.isShowTcjm04 = false;
      this.isShowTcjm05 = true;
    },
    showTcjm05: function showTcjm05() {
      this.isShowTcjm06 = true;
    },
    showTcjm06: function showTcjm06() {
      this.isShowTcjm05 = false;
      this.isShowTcjm06 = false;
      this.isShowTcjm07 = true;
      var self = this;
      this.addRecord('END', 9);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    //记录接口
    addRecord: function addRecord(type, index) {
      var _this = this;
      var self = this;
      var data = {
        exerciseType: 'JING_MAI_PLUGIN_EXAM',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 10 && type == 'END') {
            _this.queryFinishInfo();
          }
        } else {
          _this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    //查，完成了几次
    queryFinishInfo: function queryFinishInfo() {
      var _this2 = this;
      var query = {
        assitantType: "jingmaipluginexam",
        courseId: this.$route.query.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryFinishInfo', query).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this2.myExamNum = result.data.examNum;
          _this2.examNum = result.data.targetPassCnt;
          _this2.nextCourseId = result.data.nextCourseId;
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (res) {
        _this2.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1500
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
var _pdfobject = _interopRequireDefault(__webpack_require__(23));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      myExamNum: null,
      //我的完成次数
      nextCourseId: null,
      //下个课程，一般用于 功能学习的，下个课程
      examNum: null,
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'zero',
      //当前标签页
      tabIndex: 0,
      //序号
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt1: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      isOpenPpt7: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示飞鸽图标
      isShowQnIcon2: false,
      //显示点击飞鸽图标后图片
      isShowIcon3: false,
      //显示选择商家图片
      isShowIcon4: false,
      //显示切换手机号登录页面
      isShowIcon5: false,
      isShowIcon6: false,
      isShowIcon7: false,
      isShowIcon8: false,
      isShowLogin1: false,
      isShowLogin2: false,
      isShowLogin3: false,
      isShowLogin4: false,
      isShowLogin5: false,
      isShowLogin6: false,
      name: '',
      //登录账号
      password: '',
      //密码

      // 第二部
      isShowSetUp: true,
      isShowSetUp1: false,
      isShowSetUp2: false,
      isShowSetUp3: false,
      isShowSetUp4: false,
      isShowSetUp5: false,
      isShowSetUp6: false,
      isShowSetUp7: false,
      isShowSetUp8: false,
      isShowSetUp9: false,
      isShowSetUp10: false,
      // 第三步
      duanyuInputVal: '',
      duanyuInputVal1: '',
      downCount: 0,
      dyInput: '',
      //快捷短语输入
      dynr: '',
      //短语内容
      bmdy: '',
      //编码短语
      isShowSetDown: true,
      isShowSetDown1: false,
      isShowSetDown2: false,
      isShowSetDown3: false,
      isShowSetDown4: false,
      isShowSetDown5: false,
      isShowSetDown6: false,
      isShowSetDown7: false,
      isShowSetDown8: false,
      isShowSetDown9: false,
      isShowSetDown10: false,
      isShowSetDown11: false,
      isShowSetDown12: false,
      isShowSetDown13: false,
      isShowSetDown14: false,
      isShowSetDown15: false,
      isShowSetDown16: false,
      isShowSetDown17: false,
      isShowSetDown18: false,
      isShowSetDown19: false,
      isShowSetDown20: false,
      isShowSetDown21: false,
      isShowSetDown22: false,
      isShowSetDown23: false,
      isShowSetDown24: false,
      isShowSetDown25: false,
      isShowSetDown26: false,
      isShowSetDown27: false,
      isShowSetDown28: false,
      isShowSetDown29: false,
      isShowSetDown30: false,
      isShowSetDown31: false,
      isShowSetDown32: false,
      isShowSetDown33: false,
      isShowSetDown34: false,
      isShowSetDown35: false,
      isShowSetDown36: false,
      isShowSetDown37: false,
      isShowSetDown38: false,
      isShowSetDown39: false,
      isShowSetDown40: false,
      isShowSetDown41: false,
      isShowSetDown42: false,
      isShowSetDown43: false,
      isShowSetDown44: false,
      isShowSetDown45: false,
      isShowSetDown431: false,
      isShowSetDown432: false,
      isShowSetDown433: false,
      isShowSetDown434: false,
      isShowSetDown451: false,
      isShowSetDown452: false,
      // 第四步
      isShowSession: true,
      isShowSession1: false,
      isShowSession2: false,
      isShowSession3: false,
      isShowSession4: false,
      // 第五步
      isShowFive: true,
      isShowFive1: false,
      isShowFive2: false,
      isShowFive3: false,
      isShowFive4: false,
      isShowFive5: false,
      isShowFive6: false,
      isShowFive7: false,
      isShowFive8: false,
      isShowFive9: false,
      // 第六步
      isShowSix: true,
      beizhu: '',
      yjgj: '',
      yfInput: '',
      sjhm: '',
      isShowSix1: false,
      isShowSix2: false,
      isShowSix3: false,
      isShowSix4: false,
      isShowSix5: false,
      isShowSix6: false,
      isShowSix7: false,
      isShowSix8: false,
      isShowSix9: false,
      isShowSix10: false,
      isShowSix11: false,
      isShowSix12: false,
      isShowSix13: false,
      isShowSix14: false,
      isShowSix15: false,
      isShowSix16: false,
      isShowSix17: false,
      isShowSix18: false,
      isShowSix19: false,
      isShowSix20: false,
      isShowSix21: false,
      isShowSix22: false,
      isShowSix23: false,
      isShowSix24: false,
      // 第七步
      isShowSeven: true,
      isShowSeven1: false,
      isShowSeven2: false,
      isShowSeven3: false,
      isShowSeven4: false,
      isShowSeven5: false,
      isShowSeven6: false,
      isShowSeven7: false,
      isShowSeven8: false,
      isShowSeven9: false,
      isShowSeven10: false,
      isShowSeven11: false,
      isShowSmallPic: false,
      //第八步
      duomaiStep: 1,
      mouseFocusDM: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    document.getElementById(this.tabCurrent).addEventListener('ended', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
      $('#stoptip-' + _this.tabCurrent).show();
      _this.$set(_this.isShowBtn, _this.tabCurrent, true);
    }, false);
    document.getElementById(this.tabCurrent).addEventListener('play', function () {
      //该视频播放是否已结束
      $('#startvideo').hide();
    }, false);
    // 去掉双击事件默认选中
    var select = document.getElementById('select');
    select.onmousedown = function () {
      return false;
    };
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }
  },
  methods: {
    lastStep: function lastStep() {
      this.duomaiStep = 4;
      this.mouseFocusDM = false;
      var self = this;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    goBack: function goBack() {
      this.$router.back();
    },
    goExam: function goExam() {
      if (this.examNum && this.myExamNum >= this.examNum) {
        if (this.nextCourseId) {
          this.$router.replace({
            name: 'fbtDoudianExam',
            query: {
              courseId: this.nextCourseId
            }
          });
        } else {
          this.$router.back();
        }
      } else {
        location.reload();
      }
    },
    //第1步-开始播放视频
    startVideo: function startVideo() {
      document.getElementById('zero').play();
      $('#startvideo').hide();
    },
    //重播
    restartVideo: function restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-' + this.tabCurrent).hide();
    },
    startStudy: function startStudy() {
      document.getElementById(this.tabCurrent).pause();
      $('#stoptip-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).hide();
      this.isShowBtn[this.tabCurrent] = false;
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START');
    },
    //下一关
    studyNext: function studyNext(next) {
      this.initFirst();
      this.initSecond();
      this.initThird();
      this.initFour();
      this.initFive();
      this.initSix();
      this.initSeven();
      this.initEight();
      $('#studytip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).hide();
      $('#video-' + this.tabCurrent).show();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    // 重练1
    restartStudyFirst: function restartStudyFirst() {
      this.initFirst();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //重练2
    restartStudySecond: function restartStudySecond() {
      this.initSecond();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    //重练第三步
    restartStudyThird: function restartStudyThird() {
      this.initThird();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyFour: function restartStudyFour() {
      this.initFour();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyFive: function restartStudyFive() {
      this.initFive();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudySix: function restartStudySix() {
      this.initSix();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudySeven: function restartStudySeven() {
      this.initSeven();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    restartStudyEight: function restartStudyEight() {
      this.initEight();
      $('#studytip-' + this.tabCurrent).hide();
      this.addRecord('START');
    },
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = false;
      this.isShowIcon4 = false;
      this.isShowIcon5 = false;
      this.isShowIcon6 = false;
      this.isShowIcon7 = false;
      this.isShowIcon8 = false;
      this.isShowLogin1 = false;
      this.isShowLogin2 = false;
      this.isShowLogin3 = false;
      this.isShowLogin4 = false;
      this.isShowLogin5 = false;
      this.isShowLogin6 = false;
    },
    initSecond: function initSecond() {
      this.isShowSetUp = true;
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = false;
    },
    initThird: function initThird() {
      this.downCount = 0;
      this.duanyuInputVal = '';
      this.duanyuInputVal1 = '';
      this.dyInput = '',
      //快捷短语输入
      this.dynr = '',
      //短语内容
      this.bmdy = '',
      //编码短语
      this.isShowSetDown = true;
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = false;
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = false;
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = false;
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = false;
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = false;
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = false;
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = false;
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = false;
      this.isShowSetDown431 = false;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = false;
      this.isShowSetDown434 = false;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = false;
    },
    initFour: function initFour() {
      this.isShowSession = true;
      this.isShowSession1 = false;
      this.isShowSession2 = false;
      this.isShowSession3 = false;
      this.isShowSession4 = false;
    },
    initFive: function initFive() {
      this.isShowFive = true;
      this.isShowFive1 = false;
      this.isShowFive2 = false;
      this.isShowFive3 = false;
      this.isShowFive4 = false;
      this.isShowFive5 = false;
      this.isShowFive6 = false;
      this.isShowFive7 = false;
      this.isShowFive8 = false;
      this.isShowFive9 = false;
    },
    initSix: function initSix() {
      this.beizhu = '';
      this.yjgj = '';
      this.yfInput = '';
      this.sjhm = '';
      this.isShowSix = true;
      this.isShowSix1 = false;
      this.isShowSix2 = false;
      this.isShowSix3 = false;
      this.isShowSix4 = false;
      this.isShowSix5 = false;
      this.isShowSix6 = false;
      this.isShowSix7 = false;
      this.isShowSix8 = false;
      this.isShowSix9 = false;
      this.isShowSix10 = false;
      this.isShowSix11 = false;
      this.isShowSix12 = false;
      this.isShowSix13 = false;
      this.isShowSix14 = false;
      this.isShowSix15 = false;
      this.isShowSix16 = false;
      this.isShowSix17 = false;
      this.isShowSix18 = false;
      this.isShowSix19 = false;
      this.isShowSix20 = false;
      this.isShowSix21 = false;
      this.isShowSix22 = false;
      this.isShowSix23 = false;
      this.isShowSix24 = false;
    },
    initSeven: function initSeven() {
      this.isShowSeven = true;
      this.isShowSeven1 = false;
      this.isShowSeven2 = false;
      this.isShowSeven3 = false;
      this.isShowSeven4 = false;
      this.isShowSeven5 = false;
      this.isShowSeven6 = false;
      this.isShowSeven7 = false;
      this.isShowSeven8 = false;
      this.isShowSeven9 = false;
      this.isShowSeven10 = false;
      this.isShowSeven11 = false;
      this.isShowSmallPic = false;
    },
    initEight: function initEight() {
      this.duomaiStep = 1;
      this.mouseFocusDM = false;
    },
    handleClick: function handleClick(tab, event) {
      var _this2 = this;
      this.tabIndex = parseInt(tab.index);
      //内容初始化
      this.initAll();
      document.getElementById(this.tabCurrent).play();
      $('video').not('#' + this.tabCurrent).each(function (i) {
        var tabId = $(this).attr('id');
        document.getElementById(tabId).pause();
        document.getElementById(tabId).currentTime = 0;
      });
      document.getElementById(this.tabCurrent).addEventListener('ended', function () {
        //该视频播放是否已结束
        $('#stoptip-' + _this2.tabCurrent).show();
        _this2.$set(_this2.isShowBtn, _this2.tabCurrent, true);
      }, false);
    },
    initAll: function initAll() {
      $('#startvideo').hide();
      this.isShowBtn = [];
      this.isOpenPpt = false;
      this.isOpenPpt1 = false;
      this.isOpenPpt2 = false;
      this.isOpenPpt3 = false;
      this.isOpenPpt4 = false;
      this.isOpenPpt5 = false;
      this.isOpenPpt6 = false;
      this.isOpenPpt7 = false;
      $('#pdf_viewer').height('0');
      $('#pdf_viewer1').height('0');
      $('#pdf_viewer2').height('0');
      $('#pdf_viewer3').height('0');
      $('#pdf_viewer4').height('0');
      $('#pdf_viewer5').height('0');
      $('#pdf_viewer6').height('0');
      $('#pdf_viewer7').height('0');
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
      $('.content').each(function (i) {
        $(this).hide();
      });
      $('.stoptip').each(function (i) {
        $(this).hide();
      });
      $('.video-box').not('#video-' + this.tabCurrent).each(function (i) {
        $(this).hide();
      });
      $('#video-' + this.tabCurrent).show();
    },
    viewPpt: function viewPpt(bol) {
      if (this.isOpenPpt == true || !bol) {
        this.isOpenPpt = false;
        $('#pdf_viewer').height('0');
      } else {
        this.isOpenPpt = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/c6255fbab2284e7cbbfc4a2d2405efcc.pdf', "#pdf_viewer", options);
        }
      }
    },
    viewPpt1: function viewPpt1(bol) {
      if (this.isOpenPpt1 == true || !bol) {
        this.isOpenPpt1 = false;
        $('#pdf_viewer1').height('0');
      } else {
        this.isOpenPpt1 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer1').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/ae85ff093cdd420db17db8951f1db636.pdf', "#pdf_viewer1", options);
        }
      }
    },
    viewPpt2: function viewPpt2(bol) {
      if (this.isOpenPpt2 == true || !bol) {
        this.isOpenPpt2 = false;
        $('#pdf_viewer2').height('0');
      } else {
        this.isOpenPpt2 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer2').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/60c2e539816d44cc9f96c2382b697acf.pdf', "#pdf_viewer2", options);
        }
      }
    },
    viewPpt3: function viewPpt3(bol) {
      if (this.isOpenPpt3 == true || !bol) {
        this.isOpenPpt3 = false;
        $('#pdf_viewer3').height('0');
      } else {
        this.isOpenPpt3 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer3').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/2dc362b569934aeb8e2fe1cbdba6de10.pdf', "#pdf_viewer3", options);
        }
      }
    },
    viewPpt4: function viewPpt4(bol) {
      if (this.isOpenPpt4 == true || !bol) {
        this.isOpenPpt4 = false;
        $('#pdf_viewer4').height('0');
      } else {
        this.isOpenPpt4 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer4').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/a3c76b39ef424f87880a86920d8e40e4.pdf', "#pdf_viewer4", options);
        }
      }
    },
    viewPpt5: function viewPpt5(bol) {
      if (this.isOpenPpt5 == true || !bol) {
        this.isOpenPpt5 = false;
        $('#pdf_viewer5').height('0');
      } else {
        this.isOpenPpt5 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer5').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/a672de44ceb541aa8703e38b14e87b4b.pdf', "#pdf_viewer5", options);
        }
      }
    },
    viewPpt6: function viewPpt6(bol) {
      if (this.isOpenPpt6 == true || !bol) {
        this.isOpenPpt6 = false;
        $('#pdf_viewer6').height('0');
      } else {
        this.isOpenPpt6 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer6').height('700px');
          _pdfobject.default.embed('http://res.study.itaojin.cn/2023-02/95475ae5557840489964ac00ad6e4650.pdf', "#pdf_viewer6", options);
        }
      }
    },
    viewPpt7: function viewPpt7(bol) {
      if (this.isOpenPpt7 == true || !bol) {
        this.isOpenPpt7 = false;
        $('#pdf_viewer7').height('0');
      } else {
        this.isOpenPpt7 = true;
        var options = {
          pdfOpenParams: {
            navpanes: 0,
            toolbar: 0,
            statusbar: 0,
            view: "FitV",
            pagemode: "thumbs",
            page: 1
          },
          forcePDFJS: true,
          PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
        };
        if (_pdfobject.default.supportsPDFs) {
          $('#pdf_viewer7').height('700px');
          _pdfobject.default.embed('https://res.study.itaojin.cn/training-resource/2025-09/%E4%BB%8E%E5%A4%9A%E8%84%89%E5%90%AF%E5%8A%A8%E6%8A%96%E5%BA%97-%E5%B0%8F%E5%8A%A9%E6%89%8B%E8%AF%BE%E7%A8%8B.pdf', "#pdf_viewer7", options);
        }
      }
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = true;
    },
    showLoginImg3: function showLoginImg3() {
      this.isShowIcon3 = false;
      this.isShowIcon4 = true;
    },
    showLoginImg4: function showLoginImg4() {
      this.isShowIcon4 = false;
      this.isShowIcon5 = true;
    },
    showLoginImg5: function showLoginImg5() {
      this.isShowIcon5 = false;
      this.isShowIcon6 = true;
    },
    showLoginImg6: function showLoginImg6() {
      this.isShowIcon6 = false;
      this.isShowIcon7 = true;
    },
    showLoginImg7: function showLoginImg7() {
      this.isShowIcon7 = false;
      this.isShowIcon8 = true;
    },
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '13853678478') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != '3346') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowIcon8 = false;
      this.isShowLogin1 = true;
    },
    loginIn1: function loginIn1() {
      this.isShowLogin1 = false;
      this.isShowLogin2 = true;
    },
    loginIn2: function loginIn2() {
      this.isShowLogin2 = false;
      this.isShowLogin3 = true;
    },
    loginIn3: function loginIn3() {
      this.isShowLogin3 = false;
      this.isShowLogin4 = true;
    },
    loginIn4: function loginIn4() {
      var self = this;
      this.isShowLogin4 = false;
      this.isShowLogin5 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第二布  设置上事件
    setUp: function setUp() {
      this.isShowSetUp = false;
      this.isShowSetUp1 = true;
    },
    setUp1: function setUp1() {
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = true;
    },
    setUp2: function setUp2() {
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = true;
    },
    setUp3: function setUp3() {
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = true;
    },
    setUp4: function setUp4() {
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = true;
    },
    setUp5: function setUp5() {
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = true;
    },
    setUp6: function setUp6() {
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = true;
    },
    setUp7: function setUp7() {
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = true;
    },
    setUp8: function setUp8() {
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = true;
    },
    setUp9: function setUp9() {
      var self = this;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第三步
    setDown: function setDown() {
      this.isShowSetDown = false;
      this.isShowSetDown1 = true;
    },
    setDown1: function setDown1() {
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = true;
    },
    setDown2: function setDown2() {
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = true;
    },
    setDown3: function setDown3() {
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = true;
    },
    setDown4: function setDown4() {
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = true;
    },
    setDown5: function setDown5() {
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = true;
    },
    setDown6: function setDown6() {
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = true;
    },
    setDown7: function setDown7() {
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = true;
    },
    setDown8: function setDown8() {
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = true;
    },
    setDown9: function setDown9() {
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = true;
    },
    setDown10: function setDown10() {
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = true;
    },
    setDown11: function setDown11() {
      if (this.dyInput == '催单') {
        this.isShowSetDown11 = false;
        this.isShowSetDown12 = true;
      } else {
        this.notify('<p>请按照右边提示输入催单</p>');
      }
    },
    setDown12: function setDown12() {
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = true;
    },
    setDown13: function setDown13() {
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = true;
    },
    // 填写编码配置部分前后
    setDown14: function setDown14() {
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = true;
    },
    setDown16: function setDown16() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = true;
    },
    setDown17: function setDown17() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown16 = false;
      this.isShowSetDown19 = true;
    },
    setDown15: function setDown15() {
      this.isShowSetDown14 = false;
      this.isShowSetDown17 = true;
    },
    setDown18: function setDown18() {
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = true;
    },
    setDown19: function setDown19() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = true;
    },
    setDown20: function setDown20() {
      var _this3 = this;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = true;
      setTimeout(function () {
        _this3.isShowSetDown20 = false;
        _this3.isShowSetDown21 = true;
      }, 2000);
    },
    setDown22: function setDown22() {
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = true;
    },
    setDown23: function setDown23() {
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = true;
    },
    setDown24: function setDown24() {
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = true;
    },
    setDown25: function setDown25() {
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = true;
    },
    // 先勾选
    // setDown241() {
    //     this.isShowSetDown24 = false
    //     this.isShowSetDown271 = true
    // },
    // setDown281() {
    //     this.isShowSetDown271 = false
    //     this.isShowSetDown281 = true
    // },
    setDown26: function setDown26() {
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = true;
    },
    setDown27: function setDown27() {
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = true;
    },
    setDown28: function setDown28() {
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = true;
    },
    setDown29: function setDown29() {
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = true;
    },
    setDown30: function setDown30() {
      var _this4 = this;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = true;
      setTimeout(function () {
        _this4.isShowSetDown30 = false;
        _this4.isShowSetDown31 = true;
      }, 2000);
    },
    setDown32: function setDown32() {
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = true;
    },
    setDown33: function setDown33() {
      if (this.downCount == 0) {
        this.$alert('请先下载飞鸽快捷短语模板');
        return false;
      }
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = true;
    },
    setDown34: function setDown34() {
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = true;
    },
    setDown36: function setDown36() {
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = true;
    },
    setDown37: function setDown37() {
      var _this5 = this;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = true;
      setTimeout(function () {
        _this5.isShowSetDown37 = false;
        _this5.isShowSetDown38 = true;
      }, 2000);
    },
    setDown39: function setDown39() {
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = true;
    },
    setDown40: function setDown40() {
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = true;
    },
    setDown41: function setDown41() {
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = true;
    },
    setDown42: function setDown42() {
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = true;
    },
    setDown43: function setDown43() {
      var _this6 = this;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = true;
      setTimeout(function () {
        _this6.isShowSetDown43 = false;
        _this6.isShowSetDown431 = true;
      }, 1500);
    },
    duanyuInput: function duanyuInput(e) {
      if (e.target.value == '/您好') {
        this.isShowSetDown431 = false;
        this.isShowSetDown432 = true;
        // this.isShowSetDown44 = true
      }
    },
    setDown432: function setDown432() {
      var _this7 = this;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = true;
      setTimeout(function () {
        _this7.isShowSetDown433 = false;
        _this7.isShowSetDown434 = true;
      }, 2000);
    },
    duanyuInput1: function duanyuInput1(e) {
      if (e.target.value == '您好') {
        this.isShowSetDown434 = false;
        this.isShowSetDown44 = true;
      }
    },
    setDown45: function setDown45() {
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = true;
    },
    setDown46: function setDown46() {
      this.isShowSetDown45 = false;
      this.isShowSetDown451 = true;
    },
    setDown461: function setDown461() {
      var self = this;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 下载快捷短语
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '飞鸽快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = true;
    },
    // 第四步  操作
    four: function four() {
      this.isShowSession = false;
      this.isShowSession1 = true;
    },
    four1: function four1() {
      this.isShowSession1 = false;
      this.isShowSession2 = true;
    },
    four2: function four2() {
      this.isShowSession2 = false;
      this.isShowSession3 = true;
    },
    four3: function four3() {
      var self = this;
      this.isShowSession3 = false;
      this.isShowSession4 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第五步
    five: function five() {
      this.isShowFive = false;
      this.isShowFive1 = true;
    },
    five1: function five1() {
      this.isShowFive1 = false;
      this.isShowFive2 = true;
    },
    five2: function five2() {
      this.isShowFive2 = false;
      this.isShowFive3 = true;
    },
    five3: function five3() {
      var _this8 = this;
      this.isShowFive3 = false;
      this.isShowFive4 = true;
      setTimeout(function () {
        _this8.isShowFive4 = false;
        _this8.isShowFive5 = true;
      }, 2000);
    },
    five5: function five5() {
      this.isShowFive5 = false;
      this.isShowFive6 = true;
    },
    five6: function five6() {
      this.isShowFive6 = false;
      this.isShowFive7 = true;
    },
    five7: function five7() {
      this.isShowFive7 = false;
      this.isShowFive8 = true;
    },
    five8: function five8() {
      var self = this;
      this.isShowFive8 = false;
      this.isShowFive9 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第六步
    six: function six() {
      this.isShowSix = false;
      this.isShowSix1 = true;
    },
    six1: function six1() {
      this.isShowSix1 = false;
      this.isShowSix2 = true;
    },
    beiZhuInput: function beiZhuInput(e) {
      if (e.target.value == '用户要求发顺丰') {
        this.isShowSix2 = false;
        this.isShowSix3 = true;
      }
    },
    six121: function six121() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      } else {
        this.notify('<p>请按照右边提示选择对应的彩旗</p>');
      }
    },
    six122: function six122() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      }
    },
    six3: function six3() {
      this.isShowSix3 = false;
      this.isShowSix4 = true;
    },
    six4: function six4() {
      this.isShowSix4 = false;
      this.isShowSix5 = true;
    },
    six5: function six5() {
      var _this9 = this;
      this.isShowSix5 = false;
      this.isShowSix6 = true;
      setTimeout(function () {
        _this9.isShowSix6 = false;
        _this9.isShowSix7 = true;
      }, 2000);
    },
    six6: function six6() {
      this.isShowSix7 = false;
      this.isShowSix8 = true;
    },
    six7: function six7() {
      var _this0 = this;
      this.isShowSix8 = false;
      this.isShowSix9 = true;
      setTimeout(function () {
        _this0.isShowSix9 = false;
        _this0.isShowSix10 = true;
      }, 2000);
    },
    six8: function six8() {
      this.isShowSix10 = false;
      this.isShowSix11 = true;
    },
    six9: function six9() {
      var _this1 = this;
      this.isShowSix11 = false;
      this.isShowSix12 = true;
      setTimeout(function () {
        _this1.isShowSix12 = false;
        _this1.isShowSix13 = true;
      }, 2000);
    },
    six10: function six10() {
      this.isShowSix13 = false;
      this.isShowSix14 = true;
    },
    six11: function six11() {
      this.isShowSix14 = false;
      this.isShowSix15 = true;
    },
    six12: function six12() {
      if (this.yjgj != '48') {
        this.notify('<p>请按照右边提示输入正确的一键改价价格</p>');
        return;
      }
      if (this.yfInput != '10') {
        this.notify('<p>请按照右边提示输入正确的运费价格</p>');
        return;
      }
      this.isShowSix15 = false;
      this.isShowSix16 = true;
    },
    six13: function six13() {
      var _this10 = this;
      this.isShowSix16 = false;
      this.isShowSix17 = true;
      setTimeout(function () {
        _this10.isShowSix17 = false;
        _this10.isShowSix18 = true;
      }, 2000);
    },
    six14: function six14() {
      this.isShowSix18 = false;
      this.isShowSix19 = true;
    },
    six15: function six15() {
      this.isShowSix19 = false;
      this.isShowSix20 = true;
    },
    six16: function six16() {
      this.isShowSix20 = false;
      this.isShowSix21 = true;
    },
    six17: function six17() {
      if (this.sjhm != '13512345678') {
        this.notify('<p>请按照右边提示输入正确的手机号码</p>');
        return;
      }
      this.isShowSix21 = false;
      this.isShowSix22 = true;
    },
    six18: function six18() {
      var self = this;
      this.isShowSix22 = false;
      this.isShowSix23 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第七步
    seven: function seven() {
      this.isShowSeven = false;
      this.isShowSeven1 = true;
    },
    seven1: function seven1() {
      this.isShowSeven1 = false;
      this.isShowSeven2 = true;
    },
    seven2: function seven2() {
      this.isShowSeven2 = false;
      this.isShowSeven3 = true;
    },
    seven3: function seven3() {
      this.isShowSeven3 = false;
      this.isShowSeven4 = true;
    },
    seven4: function seven4() {
      this.isShowSeven4 = false;
      this.isShowSeven5 = true;
    },
    seven5: function seven5() {
      this.isShowSeven5 = false;
      this.isShowSeven6 = true;
    },
    seven6: function seven6() {
      this.isShowSeven6 = false;
      this.isShowSeven7 = true;
    },
    seven7: function seven7() {
      this.isShowSeven7 = false;
      this.isShowSeven8 = true;
    },
    seven8: function seven8() {
      this.isShowSeven8 = false;
      this.isShowSeven9 = true;
    },
    seven9: function seven9() {
      this.isShowSeven9 = false;
      this.isShowSeven10 = true;
    },
    seven10: function seven10() {
      this.isShowSmallPic = true;
    },
    seven11: function seven11() {
      var self = this;
      this.isShowSeven10 = false;
      this.isShowSmallPic = false;
      this.isShowSeven11 = true;
      this.addRecord('END');
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('飞鸽快捷短语') < 0) {
        this.$alert('请选择你下载的“飞鸽快捷短语.csv”模板文件');
        return false;
      }
      setTimeout(function () {
        self.isShowSetDown34 = false;
        self.isShowSetDown35 = true;
      }, 500);
    },
    // 记录接口
    addRecord: function addRecord(type) {
      var _this11 = this;
      var data = {
        exerciseType: 'FEIGE_PLUGIN',
        stepSeq: this.tabIndex,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (_this11.tabIndex == 8 && type == 'END') {
            _this11.queryFinishInfo();
          }
        } else {
          _this11.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this11.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    //查，完成了几次
    queryFinishInfo: function queryFinishInfo() {
      var _this12 = this;
      var query = {
        assitantType: "feigeplugin",
        courseId: this.$route.query.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryFinishInfo', query).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this12.myExamNum = result.data.examNum;
          _this12.examNum = result.data.targetPassCnt;
          _this12.nextCourseId = result.data.nextCourseId;
        } else {
          _this12.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (res) {
        _this12.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1500
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom011.251a008.png";

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom022.ae03087.png";

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom033.1495f07.png";

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom044.123ec86.png";

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom055.ec495ac.png";

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/duom066.d423179.png";

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(17));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(18));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      myExamNum: null,
      //我的完成次数
      nextCourseId: null,
      //下个课程，一般用于 功能学习的，下个课程
      examNum: null,
      OnInline: 'false',
      //小助手跳转
      tabCurrent: 'first',
      //当前标签页
      tabIndex: 1,
      //序号
      isShowBtn: [],
      //是否显示开始练习按钮
      isOpenPpt: false,
      //是否展开ppt
      isOpenPpt1: false,
      //是否展开ppt
      isOpenPpt2: false,
      //是否展开ppt
      isOpenPpt3: false,
      //是否展开ppt
      isOpenPpt4: false,
      //是否展开ppt
      isOpenPpt5: false,
      //是否展开ppt
      isOpenPpt6: false,
      //是否展开ppt
      //第1步
      isShowQnIcon: true,
      //是否显示飞鸽图标
      isShowQnIcon2: false,
      //显示点击飞鸽图标后图片
      isShowIcon3: false,
      //显示选择商家图片
      isShowIcon4: false,
      //显示切换手机号登录页面
      isShowIcon5: false,
      isShowIcon6: false,
      isShowIcon7: false,
      isShowIcon8: false,
      isShowLogin1: false,
      isShowLogin2: false,
      isShowLogin3: false,
      isShowLogin4: false,
      isShowLogin5: false,
      isShowLogin6: false,
      name: '',
      //登录账号
      password: '',
      //密码

      // 第二部
      isShowSetUp: true,
      isShowSetUp1: false,
      isShowSetUp2: false,
      isShowSetUp3: false,
      isShowSetUp4: false,
      isShowSetUp5: false,
      isShowSetUp6: false,
      isShowSetUp7: false,
      isShowSetUp8: false,
      isShowSetUp9: false,
      isShowSetUp10: false,
      // 第三步
      duanyuInputVal: '',
      duanyuInputVal1: '',
      downCount: 0,
      dyInput: '',
      //快捷短语输入
      dynr: '',
      //短语内容
      bmdy: '',
      //编码短语
      isShowSetDown: true,
      isShowSetDown1: false,
      isShowSetDown2: false,
      isShowSetDown3: false,
      isShowSetDown4: false,
      isShowSetDown5: false,
      isShowSetDown6: false,
      isShowSetDown7: false,
      isShowSetDown8: false,
      isShowSetDown9: false,
      isShowSetDown10: false,
      isShowSetDown11: false,
      isShowSetDown12: false,
      isShowSetDown13: false,
      isShowSetDown14: false,
      isShowSetDown15: false,
      isShowSetDown16: false,
      isShowSetDown17: false,
      isShowSetDown18: false,
      isShowSetDown19: false,
      isShowSetDown20: false,
      isShowSetDown21: false,
      isShowSetDown22: false,
      isShowSetDown23: false,
      isShowSetDown24: false,
      isShowSetDown25: false,
      isShowSetDown26: false,
      isShowSetDown27: false,
      isShowSetDown28: false,
      isShowSetDown29: false,
      isShowSetDown30: false,
      isShowSetDown31: false,
      isShowSetDown32: false,
      isShowSetDown33: false,
      isShowSetDown34: false,
      isShowSetDown35: false,
      isShowSetDown36: false,
      isShowSetDown37: false,
      isShowSetDown38: false,
      isShowSetDown39: false,
      isShowSetDown40: false,
      isShowSetDown41: false,
      isShowSetDown42: false,
      isShowSetDown43: false,
      isShowSetDown44: false,
      isShowSetDown45: false,
      isShowSetDown431: false,
      isShowSetDown432: false,
      isShowSetDown433: false,
      isShowSetDown434: false,
      isShowSetDown451: false,
      isShowSetDown452: false,
      // 第四步
      isShowSession: true,
      isShowSession1: false,
      isShowSession2: false,
      isShowSession3: false,
      isShowSession4: false,
      // 第五步
      isShowFive: true,
      isShowFive1: false,
      isShowFive2: false,
      isShowFive3: false,
      isShowFive4: false,
      isShowFive5: false,
      isShowFive6: false,
      isShowFive7: false,
      isShowFive8: false,
      isShowFive9: false,
      // 第六步
      isShowSix: true,
      beizhu: '',
      yjgj: '',
      yfInput: '',
      sjhm: '',
      isShowSix1: false,
      isShowSix2: false,
      isShowSix3: false,
      isShowSix4: false,
      isShowSix5: false,
      isShowSix6: false,
      isShowSix7: false,
      isShowSix8: false,
      isShowSix9: false,
      isShowSix10: false,
      isShowSix11: false,
      isShowSix12: false,
      isShowSix13: false,
      isShowSix14: false,
      isShowSix15: false,
      isShowSix16: false,
      isShowSix17: false,
      isShowSix18: false,
      isShowSix19: false,
      isShowSix20: false,
      isShowSix21: false,
      isShowSix22: false,
      isShowSix23: false,
      isShowSix24: false,
      // 第七步
      isShowSeven: true,
      isShowSeven1: false,
      isShowSeven2: false,
      isShowSeven3: false,
      isShowSeven4: false,
      isShowSeven5: false,
      isShowSeven6: false,
      isShowSeven7: false,
      isShowSeven8: false,
      isShowSeven9: false,
      isShowSeven10: false,
      isShowSeven11: false,
      isShowSmallPic: false,
      // 第八步
      duomaiStep: 1,
      mouseFocusDM: false
    };
  },
  mounted: function mounted() {
    $('#stoptip-' + this.tabCurrent).show();
    this.initAll();
    var step = this.$route.query.step;
    if (step == 8) {
      this.studyNext('#tab-eight', step, 'eight');
    }
    // 去掉双击事件默认选中
    var select = document.getElementById('select');
    select.onmousedown = function () {
      return false;
    };
  },
  watch: {
    kjdy: function kjdy() {
      if (this.kjdy == '/结束') {
        this.isShowKjdy06 = true;
      }
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el, _ref) {
        var value = _ref.value;
        if (value) {
          el.focus();
        }
      }
    }
  },
  created: function created() {
    if (this.$route.query.OnInline) {
      this.OnInline = this.$route.query.OnInline;
    }

    //跳到末尾步骤
    if (this.$route.query.end) {
      this.tabCurrent = 'eight';
      this.seven11();
    }
  },
  methods: {
    goExam: function goExam() {
      if (this.examNum && this.myExamNum >= this.examNum) {
        this.$router.back();
      } else {
        location.reload();
      }
    },
    goBack: function goBack() {
      this.$router.back();
    },
    startStudy: function startStudy() {
      $('#stoptip-' + this.tabCurrent).hide();
      $('#content-' + this.tabCurrent).show();
      this.addRecord('START', 1);
    },
    //下一关
    studyNext: function studyNext(next, index, tabCurrent) {
      $('.el-tabs__header').find('.js-tab').each(function () {
        $(this).removeClass('is-active');
      });
      $(next).addClass('is-active');
      $('.el-tabs__content').find('.el-tab-pane').each(function () {
        $(this).hide();
      });
      $(next + '-content').show();
      this.tabCurrent = tabCurrent;
      this.addRecord('START', index);
    },
    initFirst: function initFirst() {
      this.name = '';
      this.password = '';
      this.isShowQnIcon = true;
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = false;
      this.isShowIcon4 = false;
      this.isShowIcon5 = false;
      this.isShowIcon6 = false;
      this.isShowIcon7 = false;
      this.isShowIcon8 = false;
      this.isShowLogin1 = false;
      this.isShowLogin2 = false;
      this.isShowLogin3 = false;
      this.isShowLogin4 = false;
      this.isShowLogin5 = false;
      this.isShowLogin6 = false;
    },
    initSecond: function initSecond() {
      this.isShowSetUp = true;
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = false;
    },
    initThird: function initThird() {
      this.downCount = 0;
      this.duanyuInputVal = '';
      this.duanyuInputVal1 = '';
      this.dyInput = '',
      //快捷短语输入
      this.dynr = '',
      //短语内容
      this.bmdy = '',
      //编码短语
      this.isShowSetDown = true;
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = false;
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = false;
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = false;
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = false;
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = false;
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = false;
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = false;
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = false;
      this.isShowSetDown431 = false;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = false;
      this.isShowSetDown434 = false;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = false;
    },
    initFour: function initFour() {
      this.isShowSession = true;
      this.isShowSession1 = false;
      this.isShowSession2 = false;
      this.isShowSession3 = false;
      this.isShowSession4 = false;
    },
    initFive: function initFive() {
      this.isShowFive = true;
      this.isShowFive1 = false;
      this.isShowFive2 = false;
      this.isShowFive3 = false;
      this.isShowFive4 = false;
      this.isShowFive5 = false;
      this.isShowFive6 = false;
      this.isShowFive7 = false;
      this.isShowFive8 = false;
      this.isShowFive9 = false;
    },
    initSix: function initSix() {
      this.beizhu = '';
      this.yjgj = '';
      this.yfInput = '';
      this.sjhm = '';
      this.isShowSix = true;
      this.isShowSix1 = false;
      this.isShowSix2 = false;
      this.isShowSix3 = false;
      this.isShowSix4 = false;
      this.isShowSix5 = false;
      this.isShowSix6 = false;
      this.isShowSix7 = false;
      this.isShowSix8 = false;
      this.isShowSix9 = false;
      this.isShowSix10 = false;
      this.isShowSix11 = false;
      this.isShowSix12 = false;
      this.isShowSix13 = false;
      this.isShowSix14 = false;
      this.isShowSix15 = false;
      this.isShowSix16 = false;
      this.isShowSix17 = false;
      this.isShowSix18 = false;
      this.isShowSix19 = false;
      this.isShowSix20 = false;
      this.isShowSix21 = false;
      this.isShowSix22 = false;
      this.isShowSix23 = false;
      this.isShowSix24 = false;
    },
    initSeven: function initSeven() {
      this.isShowSeven = true;
      this.isShowSeven1 = false;
      this.isShowSeven2 = false;
      this.isShowSeven3 = false;
      this.isShowSeven4 = false;
      this.isShowSeven5 = false;
      this.isShowSeven6 = false;
      this.isShowSeven7 = false;
      this.isShowSeven8 = false;
      this.isShowSeven9 = false;
      this.isShowSeven10 = false;
      this.isShowSeven11 = false;
      this.isShowSmallPic = false;
    },
    initEight: function initEight() {
      this.duomaiStep = 1;
      this.mouseFocusDM = false;
    },
    initAll: function initAll() {
      //第1步
      this.initFirst();
      //第2步
      this.initSecond();
      //第3步
      this.initThird();
      //第4步
      this.initFour();
      //第5步
      this.initFive();
      //第6步
      this.initSix();
      //第7步
      this.initSeven();
      //第8步
      this.initEight();
    },
    //第1步-单击图标
    showLoginImg: function showLoginImg() {
      this.isShowQnIcon = false;
      this.isShowQnIcon2 = true;
    },
    //双击图标
    showLoginImg2: function showLoginImg2() {
      this.isShowQnIcon2 = false;
      this.isShowIcon3 = true;
    },
    showLoginImg3: function showLoginImg3() {
      this.isShowIcon3 = false;
      this.isShowIcon4 = true;
    },
    showLoginImg4: function showLoginImg4() {
      this.isShowIcon4 = false;
      this.isShowIcon5 = true;
    },
    showLoginImg5: function showLoginImg5() {
      this.isShowIcon5 = false;
      this.isShowIcon6 = true;
    },
    showLoginImg6: function showLoginImg6() {
      this.isShowIcon6 = false;
      this.isShowIcon7 = true;
    },
    showLoginImg7: function showLoginImg7() {
      this.isShowIcon7 = false;
      this.isShowIcon8 = true;
    },
    loginIn: function loginIn() {
      if (this.name == '') {
        this.notify('<p>请输入账号</p>');
        return;
      } else if (this.name != '13853678478') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      if (this.password == '') {
        this.notify('<p>请输入密码</p>');
        return;
      } else if (this.password != '3346') {
        this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>');
        return;
      }
      this.isShowIcon8 = false;
      this.isShowLogin1 = true;
    },
    loginIn1: function loginIn1() {
      this.isShowLogin1 = false;
      this.isShowLogin2 = true;
    },
    loginIn2: function loginIn2() {
      this.isShowLogin2 = false;
      this.isShowLogin3 = true;
    },
    loginIn3: function loginIn3() {
      this.isShowLogin3 = false;
      this.isShowLogin4 = true;
    },
    loginIn4: function loginIn4() {
      var self = this;
      this.isShowLogin4 = false;
      this.isShowLogin5 = true;
      this.addRecord('END', 1);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第二布  设置上事件
    setUp: function setUp() {
      this.isShowSetUp = false;
      this.isShowSetUp1 = true;
    },
    setUp1: function setUp1() {
      this.isShowSetUp1 = false;
      this.isShowSetUp2 = true;
    },
    setUp2: function setUp2() {
      this.isShowSetUp2 = false;
      this.isShowSetUp3 = true;
    },
    setUp3: function setUp3() {
      this.isShowSetUp3 = false;
      this.isShowSetUp4 = true;
    },
    setUp4: function setUp4() {
      this.isShowSetUp4 = false;
      this.isShowSetUp5 = true;
    },
    setUp5: function setUp5() {
      this.isShowSetUp5 = false;
      this.isShowSetUp6 = true;
    },
    setUp6: function setUp6() {
      this.isShowSetUp6 = false;
      this.isShowSetUp7 = true;
    },
    setUp7: function setUp7() {
      this.isShowSetUp7 = false;
      this.isShowSetUp8 = true;
    },
    setUp8: function setUp8() {
      this.isShowSetUp8 = false;
      this.isShowSetUp9 = true;
    },
    setUp9: function setUp9() {
      var self = this;
      this.isShowSetUp9 = false;
      this.isShowSetUp10 = true;
      this.addRecord('END', 2);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第三步
    setDown: function setDown() {
      this.isShowSetDown = false;
      this.isShowSetDown1 = true;
    },
    setDown1: function setDown1() {
      this.isShowSetDown1 = false;
      this.isShowSetDown2 = true;
    },
    setDown2: function setDown2() {
      this.isShowSetDown2 = false;
      this.isShowSetDown3 = true;
    },
    setDown3: function setDown3() {
      this.isShowSetDown3 = false;
      this.isShowSetDown4 = true;
    },
    setDown4: function setDown4() {
      this.isShowSetDown4 = false;
      this.isShowSetDown5 = true;
    },
    setDown5: function setDown5() {
      this.isShowSetDown5 = false;
      this.isShowSetDown6 = true;
    },
    setDown6: function setDown6() {
      this.isShowSetDown6 = false;
      this.isShowSetDown7 = true;
    },
    setDown7: function setDown7() {
      this.isShowSetDown7 = false;
      this.isShowSetDown8 = true;
    },
    setDown8: function setDown8() {
      this.isShowSetDown8 = false;
      this.isShowSetDown9 = true;
    },
    setDown9: function setDown9() {
      this.isShowSetDown9 = false;
      this.isShowSetDown10 = true;
    },
    setDown10: function setDown10() {
      this.isShowSetDown10 = false;
      this.isShowSetDown11 = true;
    },
    setDown11: function setDown11() {
      if (this.dyInput == '催单') {
        this.isShowSetDown11 = false;
        this.isShowSetDown12 = true;
      } else {
        this.notify('<p>请按照右边提示输入催单</p>');
      }
    },
    setDown12: function setDown12() {
      this.isShowSetDown12 = false;
      this.isShowSetDown13 = true;
    },
    setDown13: function setDown13() {
      this.isShowSetDown13 = false;
      this.isShowSetDown14 = true;
    },
    // 填写编码配置部分前后
    setDown14: function setDown14() {
      this.isShowSetDown14 = false;
      this.isShowSetDown15 = true;
    },
    setDown16: function setDown16() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      this.isShowSetDown15 = false;
      this.isShowSetDown16 = true;
    },
    setDown17: function setDown17() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown16 = false;
      this.isShowSetDown19 = true;
    },
    setDown15: function setDown15() {
      this.isShowSetDown14 = false;
      this.isShowSetDown17 = true;
    },
    setDown18: function setDown18() {
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown17 = false;
      this.isShowSetDown18 = true;
    },
    setDown19: function setDown19() {
      if (this.dynr != '亲亲，喜欢的话就下单吧，早拍早发货哦！') {
        this.notify('<p>请按照右边提示输入正确的短语内容</p>');
        return;
      }
      if (this.bmdy != '催单') {
        this.notify('<p>请按照右边提示输入正确的编码短语</p>');
        return;
      }
      this.isShowSetDown18 = false;
      this.isShowSetDown19 = true;
    },
    setDown20: function setDown20() {
      var _this = this;
      this.isShowSetDown19 = false;
      this.isShowSetDown20 = true;
      setTimeout(function () {
        _this.isShowSetDown20 = false;
        _this.isShowSetDown21 = true;
      }, 2000);
    },
    setDown22: function setDown22() {
      this.isShowSetDown21 = false;
      this.isShowSetDown22 = true;
    },
    setDown23: function setDown23() {
      this.isShowSetDown22 = false;
      this.isShowSetDown23 = true;
    },
    setDown24: function setDown24() {
      this.isShowSetDown23 = false;
      this.isShowSetDown24 = true;
    },
    setDown25: function setDown25() {
      this.isShowSetDown24 = false;
      this.isShowSetDown25 = true;
    },
    // 先勾选
    // setDown241() {
    //     this.isShowSetDown24 = false
    //     this.isShowSetDown271 = true
    // },
    // setDown281() {
    //     this.isShowSetDown271 = false
    //     this.isShowSetDown281 = true
    // },
    setDown26: function setDown26() {
      this.isShowSetDown25 = false;
      this.isShowSetDown26 = true;
    },
    setDown27: function setDown27() {
      this.isShowSetDown26 = false;
      this.isShowSetDown27 = true;
    },
    setDown28: function setDown28() {
      this.isShowSetDown27 = false;
      this.isShowSetDown28 = true;
    },
    setDown29: function setDown29() {
      this.isShowSetDown28 = false;
      this.isShowSetDown29 = true;
    },
    setDown30: function setDown30() {
      var _this2 = this;
      this.isShowSetDown29 = false;
      this.isShowSetDown30 = true;
      setTimeout(function () {
        _this2.isShowSetDown30 = false;
        _this2.isShowSetDown31 = true;
      }, 2000);
    },
    setDown32: function setDown32() {
      this.isShowSetDown31 = false;
      this.isShowSetDown32 = true;
    },
    setDown33: function setDown33() {
      if (this.downCount == 0) {
        this.$alert('请先下载飞鸽快捷短语模板');
        return false;
      }
      this.isShowSetDown32 = false;
      this.isShowSetDown33 = true;
    },
    setDown34: function setDown34() {
      this.isShowSetDown33 = false;
      this.isShowSetDown34 = true;
    },
    setDown36: function setDown36() {
      this.isShowSetDown35 = false;
      this.isShowSetDown36 = true;
    },
    setDown37: function setDown37() {
      var _this3 = this;
      this.isShowSetDown36 = false;
      this.isShowSetDown37 = true;
      setTimeout(function () {
        _this3.isShowSetDown37 = false;
        _this3.isShowSetDown38 = true;
      }, 2000);
    },
    setDown39: function setDown39() {
      this.isShowSetDown38 = false;
      this.isShowSetDown39 = true;
    },
    setDown40: function setDown40() {
      this.isShowSetDown39 = false;
      this.isShowSetDown40 = true;
    },
    setDown41: function setDown41() {
      this.isShowSetDown40 = false;
      this.isShowSetDown41 = true;
    },
    setDown42: function setDown42() {
      this.isShowSetDown41 = false;
      this.isShowSetDown42 = true;
    },
    setDown43: function setDown43() {
      var _this4 = this;
      this.isShowSetDown42 = false;
      this.isShowSetDown43 = true;
      setTimeout(function () {
        _this4.isShowSetDown43 = false;
        _this4.isShowSetDown431 = true;
      }, 1500);
    },
    duanyuInput: function duanyuInput(e) {
      if (e.target.value == '/您好') {
        this.isShowSetDown431 = false;
        this.isShowSetDown432 = true;
        // this.isShowSetDown44 = true
      }
    },
    setDown432: function setDown432() {
      var _this5 = this;
      this.isShowSetDown432 = false;
      this.isShowSetDown433 = true;
      setTimeout(function () {
        _this5.isShowSetDown433 = false;
        _this5.isShowSetDown434 = true;
      }, 2000);
    },
    duanyuInput1: function duanyuInput1(e) {
      if (e.target.value == '您好') {
        this.isShowSetDown434 = false;
        this.isShowSetDown44 = true;
      }
    },
    setDown45: function setDown45() {
      this.isShowSetDown44 = false;
      this.isShowSetDown45 = true;
    },
    setDown46: function setDown46() {
      this.isShowSetDown45 = false;
      this.isShowSetDown451 = true;
    },
    setDown461: function setDown461() {
      var self = this;
      this.isShowSetDown451 = false;
      this.isShowSetDown452 = true;
      this.addRecord('END', 3);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    lastStep: function lastStep() {
      this.duomaiStep = 4;
      this.mouseFocusDM = false;
      var self = this;
      this.addRecord('END', 8);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 下载快捷短语
    downloadKjdyFile: function downloadKjdyFile() {
      this.downCount = 1;
      // indow.open(('//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'),"_blank")
      var path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv';
      var downloadRes = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, blob, objectUrl, a;
          return _regenerator.default.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return fetch(path);
              case 1:
                response = _context.sent;
                _context.next = 2;
                return response.blob();
              case 2:
                blob = _context.sent;
                objectUrl = window.URL.createObjectURL(blob);
                a = document.createElement('a');
                a.href = objectUrl;
                a.download = '飞鸽快捷短语.csv';
                a.click();
                a.remove();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function downloadRes() {
          return _ref2.apply(this, arguments);
        };
      }();
      downloadRes();
      this.isShowKjdyTip03 = false;
      this.isShowKjdyTip04 = true;
    },
    // 第四步  操作
    four: function four() {
      this.isShowSession = false;
      this.isShowSession1 = true;
    },
    four1: function four1() {
      this.isShowSession1 = false;
      this.isShowSession2 = true;
    },
    four2: function four2() {
      this.isShowSession2 = false;
      this.isShowSession3 = true;
    },
    four3: function four3() {
      var self = this;
      this.isShowSession3 = false;
      this.isShowSession4 = true;
      this.addRecord('END', 4);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第五步
    five: function five() {
      this.isShowFive = false;
      this.isShowFive1 = true;
    },
    five1: function five1() {
      this.isShowFive1 = false;
      this.isShowFive2 = true;
    },
    five2: function five2() {
      this.isShowFive2 = false;
      this.isShowFive3 = true;
    },
    five3: function five3() {
      var _this6 = this;
      this.isShowFive3 = false;
      this.isShowFive4 = true;
      setTimeout(function () {
        _this6.isShowFive4 = false;
        _this6.isShowFive5 = true;
      }, 2000);
    },
    five5: function five5() {
      this.isShowFive5 = false;
      this.isShowFive6 = true;
    },
    five6: function five6() {
      this.isShowFive6 = false;
      this.isShowFive7 = true;
    },
    five7: function five7() {
      this.isShowFive7 = false;
      this.isShowFive8 = true;
    },
    five8: function five8() {
      var self = this;
      this.isShowFive8 = false;
      this.isShowFive9 = true;
      this.addRecord('END', 5);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第六步
    six: function six() {
      this.isShowSix = false;
      this.isShowSix1 = true;
    },
    six1: function six1() {
      this.isShowSix1 = false;
      this.isShowSix2 = true;
    },
    beiZhuInput: function beiZhuInput(e) {
      if (e.target.value == '用户要求发顺丰') {
        this.isShowSix2 = false;
        this.isShowSix3 = true;
      }
    },
    six121: function six121() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      } else {
        this.notify('<p>请按照右边提示选择对应的彩旗</p>');
      }
    },
    six122: function six122() {
      if (this.beizhu != '用户要求发顺丰') {
        this.notify('<p>请按照右边提示输入正确的备注内容</p>');
      }
    },
    six3: function six3() {
      this.isShowSix3 = false;
      this.isShowSix4 = true;
    },
    six4: function six4() {
      this.isShowSix4 = false;
      this.isShowSix5 = true;
    },
    six5: function six5() {
      var _this7 = this;
      this.isShowSix5 = false;
      this.isShowSix6 = true;
      setTimeout(function () {
        _this7.isShowSix6 = false;
        _this7.isShowSix7 = true;
      }, 2000);
    },
    six6: function six6() {
      this.isShowSix7 = false;
      this.isShowSix8 = true;
    },
    six7: function six7() {
      var _this8 = this;
      this.isShowSix8 = false;
      this.isShowSix9 = true;
      setTimeout(function () {
        _this8.isShowSix9 = false;
        _this8.isShowSix10 = true;
      }, 2000);
    },
    six8: function six8() {
      this.isShowSix10 = false;
      this.isShowSix11 = true;
    },
    six9: function six9() {
      var _this9 = this;
      this.isShowSix11 = false;
      this.isShowSix12 = true;
      setTimeout(function () {
        _this9.isShowSix12 = false;
        _this9.isShowSix13 = true;
      }, 2000);
    },
    six10: function six10() {
      this.isShowSix13 = false;
      this.isShowSix14 = true;
    },
    six11: function six11() {
      this.isShowSix14 = false;
      this.isShowSix15 = true;
    },
    six12: function six12() {
      if (this.yjgj != '48') {
        this.notify('<p>请按照右边提示输入正确的一键改价价格</p>');
        return;
      }
      if (this.yfInput != '10') {
        this.notify('<p>请按照右边提示输入正确的运费价格</p>');
        return;
      }
      this.isShowSix15 = false;
      this.isShowSix16 = true;
    },
    six13: function six13() {
      var _this0 = this;
      this.isShowSix16 = false;
      this.isShowSix17 = true;
      setTimeout(function () {
        _this0.isShowSix17 = false;
        _this0.isShowSix18 = true;
      }, 2000);
    },
    six14: function six14() {
      this.isShowSix18 = false;
      this.isShowSix19 = true;
    },
    six15: function six15() {
      this.isShowSix19 = false;
      this.isShowSix20 = true;
    },
    six16: function six16() {
      this.isShowSix20 = false;
      this.isShowSix21 = true;
    },
    six17: function six17() {
      if (this.sjhm != '13512345678') {
        this.notify('<p>请按照右边提示输入正确的手机号码</p>');
        return;
      }
      this.isShowSix21 = false;
      this.isShowSix22 = true;
    },
    six18: function six18() {
      var self = this;
      this.isShowSix22 = false;
      this.isShowSix23 = true;
      this.addRecord('END', 6);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    // 第七步
    seven: function seven() {
      this.isShowSeven = false;
      this.isShowSeven1 = true;
    },
    seven1: function seven1() {
      this.isShowSeven1 = false;
      this.isShowSeven2 = true;
    },
    seven2: function seven2() {
      this.isShowSeven2 = false;
      this.isShowSeven3 = true;
    },
    seven3: function seven3() {
      this.isShowSeven3 = false;
      this.isShowSeven4 = true;
    },
    seven4: function seven4() {
      this.isShowSeven4 = false;
      this.isShowSeven5 = true;
    },
    seven5: function seven5() {
      this.isShowSeven5 = false;
      this.isShowSeven6 = true;
    },
    seven6: function seven6() {
      this.isShowSeven6 = false;
      this.isShowSeven7 = true;
    },
    seven7: function seven7() {
      this.isShowSeven7 = false;
      this.isShowSeven8 = true;
    },
    seven8: function seven8() {
      this.isShowSeven8 = false;
      this.isShowSeven9 = true;
    },
    seven9: function seven9() {
      this.isShowSeven9 = false;
      this.isShowSeven10 = true;
    },
    seven10: function seven10() {
      this.isShowSmallPic = true;
    },
    seven11: function seven11() {
      var self = this;
      this.isShowSeven10 = false;
      this.isShowSmallPic = false;
      this.isShowSeven11 = true;
      this.addRecord('END', 7);
      setTimeout(function () {
        $('#studytip-' + self.tabCurrent).show();
      }, 2000);
    },
    tirggerFile: function tirggerFile($event) {
      var self = this;
      var file = $event.target.files;
      if (!file[0] || file[0] && file[0].name.indexOf('飞鸽快捷短语') < 0) {
        this.$alert('请选择你下载的“飞鸽快捷短语.csv”模板文件');
        return false;
      }
      setTimeout(function () {
        self.isShowSetDown34 = false;
        self.isShowSetDown35 = true;
      }, 500);
    },
    // 记录接口
    addRecord: function addRecord(type, index) {
      var _this1 = this;
      var data = {
        exerciseType: 'FEIGE_PLUGIN_EXAM',
        stepSeq: index,
        exerciseAction: type
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/addRecord', data).then(function (res) {
        var result = res.data;
        if (result.success) {
          if (index == 8 && type == 'END') {
            _this1.queryFinishInfo();
          }
        } else {
          _this1.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }, function (res) {
        _this1.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    //查，完成了几次
    queryFinishInfo: function queryFinishInfo() {
      var _this10 = this;
      var query = {
        assitantType: "feigepluginexam",
        courseId: this.$route.query.courseId
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.college + '/majors/queryFinishInfo', query).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this10.myExamNum = result.data.examNum;
          _this10.examNum = result.data.targetPassCnt;
          _this10.nextCourseId = result.data.nextCourseId;
        } else {
          _this10.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (res) {
        _this10.$message({
          message: "网络繁忙，请稍后重试！",
          type: 'error',
          center: true,
          duration: 1500
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _FastReplyImportDDDialog = _interopRequireDefault(__webpack_require__(1744));
var _FastReplyEditorDialog = _interopRequireDefault(__webpack_require__(968));
var _TrainScoreDialog = _interopRequireDefault(__webpack_require__(970));
var _GroupManageDialog = _interopRequireDefault(__webpack_require__(1748));
var _order = _interopRequireDefault(__webpack_require__(972));
var _OrderMsgCard = _interopRequireDefault(__webpack_require__(973));
var _CourseProductModal = _interopRequireDefault(__webpack_require__(975));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'doudianChat',
  data: function data() {
    return {
      transferPopoverVisible: false,
      notePopoverVisible: false,
      noteFlagColors: ['#a0a0a0', '#a0a0a0', '#a0a0a0', '#a0a0a0'],
      noteFlagIndex: 0,
      noteText: '',
      sceneId: this.$route.query.sceneId,
      hasProducts: false,
      settings: {
        isStart: false,
        onlineStatus: '1',
        isRecommendReply: false,
        time: 0,
        collapsedGroups: {},
        groups: [],
        defaultGroupId: null,
        trainId: null,
        trainSession: [],
        isMaxSession: false,
        pageType: 1,
        //1快捷短语 2订单 3导入
        selectedFrgId: 'all',
        showGroupManage: false
      },
      timer: null,
      taskATimer: null,
      taskBTimer: null,
      taskCTimer: null,
      keyword: '',
      showImport: false,
      showEditor: false,
      showScore: false,
      trainResult: null,
      editorValue: null,
      // 外部订单数据：jingmai
      ordersJingmai: _order.default.douyin,
      menu: {
        visible: false,
        x: 0,
        y: 0,
        group: null,
        reply: null,
        type: 'group'
      },
      fastReplyList: [],
      replyText: '',
      fullLoading: null,
      showQuickReplySuggestions: false,
      quickReplySuggestions: [],
      selectedSuggestionIndex: 0,
      // 打字速度（实用口径 + 粘贴修正）
      typingStartMs: null,
      typingAccumMs: 0,
      typedCharsTotal: 0,
      pastedCharsCurrent: 0,
      // 订单头部展示信息
      orderHeader: {
        orderNo: '',
        orderTime: '',
        orderPayTime: ''
      }
    };
  },
  components: {
    FastReplyImportDDDialog: _FastReplyImportDDDialog.default,
    FastReplyEditorDialog: _FastReplyEditorDialog.default,
    TrainScoreDialog: _TrainScoreDialog.default,
    GroupManageDialog: _GroupManageDialog.default,
    OrderMsgCard: _OrderMsgCard.default,
    CourseProductModal: _CourseProductModal.default
  },
  mounted: function mounted() {
    this.refreshFastReply();
    // 生成随机订单号和下单时间（早于昨天）
    this.generateOrderHeader();
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁前清理所有定时器，防止内存泄漏
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.taskATimer) {
      clearInterval(this.taskATimer);
      this.taskATimer = null;
    }
    if (this.taskBTimer) {
      clearInterval(this.taskBTimer);
      this.taskBTimer = null;
    }
    if (this.taskCTimer) {
      clearInterval(this.taskCTimer);
      this.taskCTimer = null;
    }
    if (this.fullLoading) {
      this.fullLoading.close();
      this.fullLoading = null;
    }
  },
  watch: {
    matchedOrder: {
      handler: function handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          this.generateOrderHeader();
        }
      }
    }
  },
  computed: {
    matchedOrder: function matchedOrder() {
      var session = this.currentSession;
      if (!session || !Array.isArray(session.quesList) || !session.quesList.length) return null;
      // 取当前对方发出的最后一个问题（已送达：sendTime 存在）的 questionOrderId
      var lastDelivered = null;
      for (var i = session.quesList.length - 1; i >= 0; i--) {
        var q = session.quesList[i];
        if (q && q.sendTime && q.questionOrderId) {
          lastDelivered = q;
          break;
        }
      }
      if (!lastDelivered) return null;
      var list = this.ordersJingmai || [];
      return list.find(function (o) {
        return String(o.id) === String(lastDelivered.questionOrderId);
      }) || null;
    },
    formattedTime: function formattedTime() {
      var t = Math.max(0, this.settings.time | 0);
      var m = String(Math.floor(t / 60)).padStart(2, '0');
      var s = String(t % 60).padStart(2, '0');
      return "00:".concat(m, ":").concat(s);
    },
    currentSession: function currentSession() {
      return (this.settings.trainSession || []).find(function (s) {
        return s.isCurrent;
      }) || null;
    },
    currentMessages: function currentMessages() {
      var _this = this;
      if (!this.currentSession) return [];
      var messages = [];
      this.currentSession.quesList.forEach(function (q) {
        if (q.sendTime) {
          console.log('[order-card]', {
            questionType: q.questionType,
            questionOrderId: q.questionOrderId,
            matched: !!_this.findOrderById(q.questionOrderId),
            q: q
          });
          messages.push(q);
        }
      });
      return messages;
    },
    totalReplyCount: function totalReplyCount() {
      var count = 0;
      (this.settings.trainSession || []).forEach(function (s) {
        (s.quesList || []).forEach(function (q) {
          if (Array.isArray(q.replyList)) {
            count += q.replyList.length;
          }
        });
      });
      return count;
    },
    firstResponseAvgSec: function firstResponseAvgSec() {
      var sessions = this.settings.trainSession || [];
      var deltas = [];
      sessions.forEach(function (s) {
        var firstQ = (s.quesList || [])[0];
        if (!firstQ || !firstQ.sendTime) return;
        var firstReply = (firstQ.replyList || []).find(function (r) {
          return r && r.sendTime;
        });
        if (!firstReply) return;
        var deltaMs = Number(firstReply.sendTime) - Number(firstQ.sendTime);
        if (isFinite(deltaMs) && deltaMs >= 0) {
          deltas.push(deltaMs);
        }
      });
      if (!deltas.length) return 0;
      var avgMs = deltas.reduce(function (a, b) {
        return a + b;
      }, 0) / deltas.length;
      return Math.round(avgMs / 1000);
    },
    avgResponseSec: function avgResponseSec() {
      var sessions = this.settings.trainSession || [];
      var deltas = [];
      sessions.forEach(function (s) {
        (s.quesList || []).forEach(function (q) {
          if (!q || !q.sendTime) return;
          var firstReply = (q.replyList || []).find(function (r) {
            return r && r.sendTime;
          });
          if (!firstReply) return;
          var deltaMs = Number(firstReply.sendTime) - Number(q.sendTime);
          if (isFinite(deltaMs) && deltaMs >= 0) {
            deltas.push(deltaMs);
          }
        });
      });
      if (!deltas.length) return 0;
      var avgMs = deltas.reduce(function (a, b) {
        return a + b;
      }, 0) / deltas.length;
      return Math.round(avgMs / 1000);
    },
    typingSpeedWPM: function typingSpeedWPM() {
      var ms = Number(this.typingAccumMs) || 0;
      var chars = Number(this.typedCharsTotal) || 0;
      if (ms <= 0 || chars <= 0) return 0;
      var minutes = ms / 60000;
      if (minutes <= 0) return 0;
      return Math.round(chars / minutes);
    },
    filteredFastReplyList: function filteredFastReplyList() {
      if (!this.keyword || !this.keyword.trim()) {
        // 无关键词时返回原始数据，展开所有分组
        return (this.fastReplyList || []).map(function (g) {
          return _objectSpread(_objectSpread({}, g), {}, {
            filteredReplyList: g.replyList || []
          });
        });
      }
      var keyword = this.keyword.trim().toLowerCase();
      return (this.fastReplyList || []).map(function (g) {
        var filtered = (g.replyList || []).filter(function (r) {
          var quicktext = (r.quicktext || '').toLowerCase();
          var replytext = (r.replytext || '').toLowerCase();
          return quicktext.includes(keyword) || replytext.includes(keyword);
        });
        return _objectSpread(_objectSpread({}, g), {}, {
          filteredReplyList: filtered
        });
      }).filter(function (g) {
        return g.filteredReplyList.length > 0;
      }); // 只显示有匹配项的分组
    },
    selectedGroupReplyCount: function selectedGroupReplyCount() {
      var _this2 = this;
      // 计算当前选中分组下的快捷回复条数；all 统计全部
      var source = !this.keyword || !this.keyword.trim() ? (this.fastReplyList || []).map(function (g) {
        return _objectSpread(_objectSpread({}, g), {}, {
          filteredReplyList: g.replyList || []
        });
      }) : this.filteredFastReplyList;
      if (this.settings.selectedFrgId === 'all') {
        return source.reduce(function (sum, g) {
          return sum + (g.filteredReplyList ? g.filteredReplyList.length : 0);
        }, 0);
      }
      var g = source.find(function (x) {
        return x.id === _this2.settings.selectedFrgId;
      });
      return g ? g.filteredReplyList ? g.filteredReplyList.length : 0 : 0;
    },
    displayedReplies: function displayedReplies() {
      var _this3 = this;
      // 根据选中分组和关键词，得到要在表格里展示的快捷短语列表
      var groups = !this.keyword || !this.keyword.trim() ? (this.fastReplyList || []).map(function (g) {
        return _objectSpread(_objectSpread({}, g), {}, {
          filteredReplyList: g.replyList || []
        });
      }) : this.filteredFastReplyList;
      if (this.settings.selectedFrgId === 'all') {
        return groups.flatMap(function (g) {
          return g.filteredReplyList || [];
        });
      }
      var g = groups.find(function (x) {
        return x.id === _this3.settings.selectedFrgId;
      });
      return g ? g.filteredReplyList || [] : [];
    }
  },
  methods: (0, _defineProperty2.default)({
    // 根据 questionOrderId 匹配本地订单数据，用于聊天流订单卡片
    findOrderById: function findOrderById(orderId) {
      var list = this.ordersJingmai || [];
      var order = orderId != null && orderId !== '' ? list.find(function (o) {
        return String(o.id) === String(orderId);
      }) : null;
      // 匹配不到用 1001 兜底
      return order || list.find(function (o) {
        return String(o.id) === '1001';
      }) || null;
    },
    onNoteConfirm: function onNoteConfirm() {
      var text = (this.noteText || '').trim();
      if (!text) {
        this.$message.warning('请输入备注内容');
        return;
      }
      this.notePopoverVisible = false;
      this.saveActionRecord('REMARK_MODIFY', text);
    },
    saveActionRecord: function saveActionRecord(actionType, text) {
      var _this4 = this;
      this.transferPopoverVisible = false;
      var target = null;
      var list = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
      for (var i = list.length - 1; i >= 0; i--) {
        var q = list[i];
        if (q && q.sendTime) {
          target = q;
          break;
        }
      }
      if (!target) {
        this.$message({
          type: 'warning',
          message: '暂无可回复的问题'
        });
        return;
      }
      var data = {
        trainRecordId: this.settings.trainId,
        sessionId: this.currentSession.id,
        questionId: target.id,
        questionOrderId: target.questionOrderId,
        actionType: actionType
      };
      if (actionType == 'REMARK_MODIFY') {
        data.opeRemark = '备注：' + text;
      }
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/saveActionRecord', data).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this4.$message({
            type: 'success',
            message: '操作成功'
          });
        }
      });
      if (actionType == 'REMARK_MODIFY') {
        return;
      }
      if (!Array.isArray(target.replyList)) {
        this.$set(target, 'replyList', []);
      }
      var now = Date.now();
      target.replyList.push({
        id: 'local-' + Date.now(),
        from: 'self',
        fromName: '',
        sendTime: now,
        content: text
      });
      this.sendMsg(0, text, 0, '', '', target.id, this.currentSession && this.currentSession.id);
    },
    sendReply: function sendReply() {
      var _this5 = this;
      var text = (this.replyText || '').trim();
      if (!text || !this.currentSession) {
        this.$message({
          type: 'error',
          message: '请先选择一个会话'
        });
        return;
      }
      if (text.length > 2000) {
        this.$message({
          type: 'warning',
          message: '消息内容过长，请控制在2000字符以内'
        });
        return;
      }
      var target = null;
      var list = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
      for (var i = list.length - 1; i >= 0; i--) {
        var q = list[i];
        if (q && q.sendTime) {
          target = q;
          break;
        }
      }
      if (!target) {
        this.$message({
          type: 'warning',
          message: '暂无可回复的问题'
        });
        return;
      }
      if (!Array.isArray(target.replyList)) {
        this.$set(target, 'replyList', []);
      }
      var now = Date.now();
      if (this.typingStartMs) {
        this.typingAccumMs += Math.max(0, now - this.typingStartMs);
      }
      var effectiveChars = Math.max(0, text.length - (this.pastedCharsCurrent || 0));
      this.typedCharsTotal += effectiveChars;
      var localMinutes = ((this.typingStartMs ? now - this.typingStartMs : 0) || 0) / 60000;
      var localSpeed = localMinutes > 0 ? Math.round(effectiveChars / localMinutes) : 0;
      this.typingStartMs = null;
      this.pastedCharsCurrent = 0;
      target.replyList.push({
        id: 'local-' + Date.now(),
        from: 'self',
        fromName: '',
        sendTime: now,
        content: text
      });
      this.sendMsg(0, text, localSpeed, '', '', target.id, this.currentSession && this.currentSession.id);
      this.replyText = '';
      this.$nextTick(function () {
        _this5.scrollChatToBottom();
      });
    },
    onSelectFrgAll: function onSelectFrgAll() {
      this.settings.selectedFrgId = 'all';
    },
    onSelectFrg: function onSelectFrg(group) {
      this.settings.selectedFrgId = group && group.id;
    },
    getStatusClass: function getStatusClass(status) {
      switch (status) {
        case '1':
          return 'status-online';
        case '2':
          return 'status-offline';
        case '3':
          return 'status-pending';
        default:
          return '';
      }
    },
    generateOrderHeader: function generateOrderHeader() {
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      // 订单号：年月日时分秒 + 随机4位
      var now = new Date();
      var no = "".concat(now.getFullYear()).concat(pad(now.getMonth() + 1)).concat(pad(now.getDate())).concat(pad(now.getHours())).concat(pad(now.getMinutes())).concat(pad(now.getSeconds())).concat(Math.floor(1000 + Math.random() * 9000));
      // 时间：在昨天之前的随机时间
      var todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      var yesterdayStart = new Date(todayStart.getTime() - 24 * 60 * 60 * 1000);
      var threeDaysAgo = new Date(yesterdayStart.getTime() - 3 * 24 * 60 * 60 * 1000);
      var ts = threeDaysAgo.getTime() + Math.random() * (yesterdayStart.getTime() - threeDaysAgo.getTime() - 1);
      var dt = new Date(ts);
      var timeStr = "".concat(dt.getFullYear(), "-").concat(pad(dt.getMonth() + 1), "-").concat(pad(dt.getDate()), " ").concat(pad(dt.getHours()), ":").concat(pad(dt.getMinutes()), ":").concat(pad(dt.getSeconds()));
      // 付款时间：下单后 1-15 分钟内
      var payDeltaMin = 1 + Math.floor(Math.random() * 15);
      var payDt = new Date(dt.getTime() + payDeltaMin * 60 * 1000);
      var payStr = "".concat(payDt.getFullYear(), "-").concat(pad(payDt.getMonth() + 1), "-").concat(pad(payDt.getDate()), " ").concat(pad(payDt.getHours()), ":").concat(pad(payDt.getMinutes()), ":").concat(pad(payDt.getSeconds()));
      this.orderHeader.orderNo = no;
      this.orderHeader.orderTime = timeStr;
      this.orderHeader.orderPayTime = payStr;
    },
    watchMatchedOrder: function watchMatchedOrder(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.generateOrderHeader();
      }
    },
    onReplyKeydown: function onReplyKeydown(e) {
      // 处理快捷短语选择；如果是回车且有建议，优先选择建议；否则继续走发送
      if (this.showQuickReplySuggestions) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.selectedSuggestionIndex = Math.min(this.selectedSuggestionIndex + 1, this.quickReplySuggestions.length - 1);
          return;
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.selectedSuggestionIndex = Math.max(this.selectedSuggestionIndex - 1, 0);
          return;
        }
        if (e.key === 'Enter' && this.quickReplySuggestions.length > 0) {
          e.preventDefault();
          if (this.quickReplySuggestions[this.selectedSuggestionIndex]) {
            this.selectSuggestion(this.quickReplySuggestions[this.selectedSuggestionIndex]);
          }
          return;
        }
        if (e.key === 'Escape') {
          e.preventDefault();
          this.hideSuggestions();
          return;
        }
      }
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.sendReply();
      }
    },
    onClickReply: function onClickReply(item) {
      var _this6 = this;
      if (!item) return;
      var text = (item.replytext || '').trim();
      if (!text) return;
      // 将快捷短语填充到输入框，若已有内容则在末尾追加换行
      if (this.replyText) {
        this.replyText = this.replyText.replace(/\s*$/, '') + '\n' + text;
      } else {
        this.replyText = text;
      }
      this.$nextTick(function () {
        var ta = _this6.$el.querySelector('.reply-textarea textarea');
        if (ta) {
          ta.focus();
          ta.selectionStart = ta.selectionEnd = _this6.replyText.length;
        }
      });
    },
    back: function back() {
      this.$router.back();
    },
    changeRecommendReply: function changeRecommendReply() {
      var _this7 = this;
      this.settings.trainSession.forEach(function (s) {
        s.quesList.forEach(function (q) {
          q.fold = !_this7.settings.isRecommendReply;
        });
      });
    },
    startTrain: function startTrain() {
      var _this8 = this;
      this.settings.isStart = true;
      this.settings.time = 60 * 10; // 10分钟
      if (this.timer) clearInterval(this.timer);
      if (this.taskATimer) clearInterval(this.taskATimer);
      if (this.taskBTimer) clearInterval(this.taskBTimer);
      if (this.taskCTimer) clearInterval(this.taskCTimer);
      this.timer = setInterval(function () {
        if (_this8.settings.time > 0) {
          _this8.settings.time -= 1;
          if (_this8.settings.time == 60 * 7) {
            _this8.newSession();
            _this8.startTaskB();
          }
          if (_this8.settings.time == 60 * 4) {
            _this8.newSession();
            _this8.startTaskC();
            _this8.settings.isMaxSession = true;
          }
        } else {
          clearInterval(_this8.timer);
          _this8.timer = null;
          if (_this8.settings.trainSession.length == 0) {
            _this8.submitTrain();
          } else {
            _this8.$alert('已经不会有客户进线了，接待完客户依次关闭对话即可评分', '训练结束', {
              confirmButtonText: '确定',
              type: 'info'
            });
          }
        }
      }, 1000);
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/initTrain?exam=0&sessionnum=3&dependid=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this8.settings.trainId = result.data.trainId;
          _this8.newSession();
          _this8.startTaskA();
        } else {
          _this8.$message({
            type: 'error',
            message: result.msg || '开始训练失败'
          });
        }
      });
    },
    startTaskA: function startTaskA() {
      var _this9 = this;
      // 独立的任务定时器：不随倒计时结束而停止
      this.taskATimer = setInterval(function () {
        console.log('taskATimer');
        // 从 trainSession 找第一个元素
        var sessions = _this9.settings.trainSession || [];
        if (!sessions.length) return;
        var firstSession = sessions[0];
        var quesList = Array.isArray(firstSession.quesList) ? firstSession.quesList : [];
        if (!quesList.length) return;
        // 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
        var idx = -1;
        for (var i = quesList.length - 1; i >= 0; i--) {
          var q = quesList[i];
          if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) {
            idx = i;
            break;
          }
        }
        if (idx === -1) return;
        console.log('idx', idx);
        var nextIdx = idx + 1;
        if (nextIdx >= quesList.length) return;
        var nextQ = quesList[nextIdx];
        console.log('nextQ', nextQ.answer);
        if (!nextQ) return;
        // 若下一题尚未"送达"，则激活它
        if (!nextQ.sendTime) {
          nextQ.sendTime = Date.now();
          // 触发一条“对方”消息，用于保持与新会话一致的行为
          _this9.sendMsg(1, '', 0, nextQ.answer, firstSession.veruser, nextQ.id, firstSession.id);
          if (!firstSession.isCurrent) {
            firstSession.didReply = false;
          }
        }
      }, 15000);
    },
    startTaskB: function startTaskB() {
      var _this0 = this;
      this.taskBTimer = setInterval(function () {
        console.log('taskBTimer');
        // 从 trainSession 找第一个元素
        var sessions = _this0.settings.trainSession || [];
        if (!sessions.length || sessions.length <= 1) return;
        var secondSession = sessions[1];
        var quesList = Array.isArray(secondSession.quesList) ? secondSession.quesList : [];
        if (!quesList.length) return;
        // 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
        var idx = -1;
        for (var i = quesList.length - 1; i >= 0; i--) {
          var q = quesList[i];
          if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) {
            idx = i;
            break;
          }
        }
        if (idx === -1) return;
        var nextIdx = idx + 1;
        if (nextIdx >= quesList.length) return;
        var nextQ = quesList[nextIdx];
        if (!nextQ) return;
        // 若下一题尚未"送达"，则激活它
        if (!nextQ.sendTime) {
          nextQ.sendTime = Date.now();
          // 触发一条“对方”消息，用于保持与新会话一致的行为
          _this0.sendMsg(1, '', 0, nextQ.answer, secondSession.veruser, nextQ.id, secondSession.id);
          if (!secondSession.isCurrent) {
            secondSession.didReply = false;
          }
        }
      }, 15000);
    },
    startTaskC: function startTaskC() {
      var _this1 = this;
      this.taskCTimer = setInterval(function () {
        console.log('taskCTimer');
        // 从 trainSession 找第一个元素
        var sessions = _this1.settings.trainSession || [];
        if (!sessions.length || sessions.length <= 2) return;
        var thirdSession = sessions[2];
        var quesList = Array.isArray(thirdSession.quesList) ? thirdSession.quesList : [];
        if (!quesList.length) return;
        // 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
        var idx = -1;
        for (var i = quesList.length - 1; i >= 0; i--) {
          var q = quesList[i];
          if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) {
            idx = i;
            break;
          }
        }
        if (idx === -1) return;
        var nextIdx = idx + 1;
        if (nextIdx >= quesList.length) return;
        var nextQ = quesList[nextIdx];
        if (!nextQ) return;
        // 若下一题尚未"送达"，则激活它
        if (!nextQ.sendTime) {
          nextQ.sendTime = Date.now();
          // 触发一条“对方”消息，用于保持与新会话一致的行为
          _this1.sendMsg(1, '', 0, nextQ.answer, thirdSession.veruser, nextQ.id, thirdSession.id);
          if (!thirdSession.isCurrent) {
            thirdSession.didReply = false;
          }
        }
      }, 15000);
    },
    closeSession: function closeSession() {
      var _this10 = this;
      if (!this.currentSession) return;
      var currentIndex = this.settings.trainSession.findIndex(function (s) {
        return s.id === _this10.currentSession.id;
      });
      if (currentIndex === -1) return;

      // 检查是否存在未下发或未回复的问题
      var quesList = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
      var hasPending = quesList.some(function (q) {
        return !q || !q.sendTime || q.sendTime && (!Array.isArray(q.replyList) || q.replyList.length === 0);
      });
      var doRemove = function doRemove() {
        // 移除当前会话
        _this10.settings.trainSession.splice(currentIndex, 1);
        // 如果数组中还有会话，选择下一个（或前一个）
        if (_this10.settings.trainSession.length > 0) {
          var nextIndex = currentIndex < _this10.settings.trainSession.length ? currentIndex : currentIndex - 1;
          _this10.selectSession(_this10.settings.trainSession[nextIndex]);
        } else {
          // 如果没有会话了，清空当前会话
          _this10.settings.trainSession = [];
          if (_this10.settings.isMaxSession) {
            // 如果已经达到最大会话数，则停止训练
            if (_this10.settings.time <= 0) {
              _this10.submitTrain();
            }
          }
        }
      };
      if (hasPending) {
        this.$confirm('当前会话您还有未回复的问题，确定关闭会话？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          doRemove();
        }).catch(function () {});
      } else {
        doRemove();
      }
    },
    submitTrain: function submitTrain() {
      var _this11 = this;
      this.openFullLoading('提交中...');
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/submitTrain', {
        id: this.settings.trainId
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this11.getScorById();
        } else {
          _this11.$message({
            type: 'error',
            message: result.msg || '提交失败'
          });
          _this11.closeFullLoading();
        }
      }, function () {
        _this11.$message({
          type: 'error',
          message: '提交失败'
        });
        _this11.closeFullLoading();
      });
    },
    getScorById: function getScorById() {
      var _this12 = this;
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/getById', {
        id: this.settings.trainId
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          self.closeFullLoading();
          self.trainResult = result.data;
          self.showScore = true;
        } else {
          _this12.$message({
            type: 'error',
            message: result.msg || '提交失败'
          });
          self.closeFullLoading();
        }
      }, function () {
        _this12.$message({
          type: 'error',
          message: '提交失败'
        });
        _this12.closeFullLoading();
      });
    },
    openFullLoading: function openFullLoading(text) {
      if (this.fullLoading) {
        this.fullLoading.close();
        this.fullLoading = null;
      }
      this.fullLoading = this.$loading({
        lock: true,
        text: text || '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)'
      });
    },
    closeFullLoading: function closeFullLoading() {
      if (this.fullLoading) {
        this.fullLoading.close();
        this.fullLoading = null;
      }
    },
    newSession: function newSession() {
      var _this13 = this;
      // ,batchId: 'dd0e3a32a49a49b59e3f134ea2f21fbe'
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/newSession', {
        id: this.settings.trainId,
        batchId: this.$route.query.batchId
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          var item = result.data.trainSession[0];
          if (_this13.settings.trainSession.length == 0) {
            item.isCurrent = true;
            item.didReply = true;
          } else {
            item.isCurrent = false;
            item.didReply = false;
          }
          item.quesList.forEach(function (q) {
            q.fromName = item.veruser;
            q.sendTime = null;
            q.fold = true;
            q.replyList = [];
          });
          item.quesList[0].sendTime = Date.now();
          _this13.settings.trainSession.push(item);
          _this13.sendMsg(1, '', 0, item.quesList[0].answer, item.veruser, item.quesList[0].id, item.id);
          _this13.$nextTick(function () {
            _this13.scrollChatToBottom();
          });
        } else {
          _this13.$message({
            type: 'error',
            message: result.msg || '开始训练失败'
          });
        }
      });
    },
    sendMsg: function sendMsg(role, content, typingspeed, sysanswer, username, questionId, sessionId) {
      var _this14 = this;
      var data;
      if (role === 1) {
        data = {
          role: 1,
          content: '',
          typingspeed: 0,
          sysanswer: sysanswer,
          username: username,
          questionId: questionId,
          sessionid: sessionId || this.currentSession && this.currentSession.id
        };
      } else {
        data = {
          role: 0,
          content: content,
          typingspeed: typingspeed,
          questionId: questionId,
          sessionid: sessionId || this.currentSession && this.currentSession.id
        };
      }
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/sendMsg', data).then(function (res) {
        var result = res.data;
        if (result && result.success) {} else {
          _this14.$message({
            type: 'error',
            message: result.msg || '发送失败'
          });
        }
      }).catch(function (err) {
        console.error('发送消息失败:', err);
        _this14.$message({
          type: 'error',
          message: '网络错误，发送失败。请检查网络连接或稍后重试。'
        });
      });
      this.$nextTick(function () {
        _this14.scrollChatToBottom();
      });
    },
    selectSession: function selectSession(target) {
      var _this15 = this;
      (this.settings.trainSession || []).forEach(function (s) {
        s.isCurrent = false;
      });
      target.isCurrent = true;
      target.didReply = true;
      this.$nextTick(function () {
        _this15.scrollChatToBottom();
      });
    },
    stopTrain: function stopTrain() {
      this.settings = {
        isStart: false,
        onlineStatus: '1',
        isRecommendReply: false,
        time: 0,
        collapsedGroups: {},
        groups: [],
        defaultGroupId: null,
        trainId: null,
        trainSession: [],
        isMaxSession: false,
        pageType: 2,
        //1快捷短语 2订单 3导入
        selectedFrgId: 'all',
        showGroupManage: false
      },
      // 重置打字统计
      this.typingStartMs = null;
      this.typingAccumMs = 0;
      this.typedCharsTotal = 0;
      this.pastedCharsCurrent = 0;
      clearInterval(this.timer);
      this.timer = null;
      if (this.taskATimer) {
        clearInterval(this.taskATimer);
        this.taskATimer = null;
      }
      if (this.taskBTimer) {
        clearInterval(this.taskBTimer);
        this.taskBTimer = null;
      }
      if (this.taskCTimer) {
        clearInterval(this.taskCTimer);
        this.taskCTimer = null;
      }
    },
    restartTrain: function restartTrain() {
      this.showScore = false;
      this.stopTrain();
      this.$refs.productModal.handleStart();
    },
    viewResult: function viewResult() {
      this.$router.push({
        name: 'fbtTrainResult',
        query: {
          trainId: this.settings.trainId
        }
      });
      this.showScore = false;
      this.stopTrain();
    },
    onKeywordInput: function onKeywordInput() {
      // 实时筛选逻辑在 computed 中处理
    },
    onReplyInput: function onReplyInput() {
      // 进入输入状态的起点：从空到非空
      var textNow = this.replyText || '';
      if (!this.typingStartMs && textNow.trim().length > 0) {
        this.typingStartMs = Date.now();
      }
      // 检测是否输入了 / 符号
      var text = this.replyText || '';
      var lastSlashIndex = text.lastIndexOf('/');
      if (lastSlashIndex !== -1) {
        // 获取 / 后面的内容作为搜索关键词
        var searchKeyword = text.substring(lastSlashIndex + 1).toLowerCase();
        if (searchKeyword.length === 0) {
          // 如果只输入了 /，显示所有快捷短语
          this.showAllQuickReplies();
        } else {
          // 根据关键词筛选快捷短语
          this.filterQuickReplies(searchKeyword);
        }
      } else {
        // 没有 / 符号，隐藏提示框
        this.hideSuggestions();
      }
      // 若清空输入，则结束当前输入段并清零本段粘贴统计
      if (textNow.trim().length === 0) {
        if (this.typingStartMs) {
          // 不累计时间（只有发送时累计），仅重置起点
          this.typingStartMs = null;
        }
        this.pastedCharsCurrent = 0;
      }
    },
    onReplyPaste: function onReplyPaste(e) {
      try {
        var text = e.clipboardData && e.clipboardData.getData('text') || '';
        this.pastedCharsCurrent += (text || '').length;
      } catch (err) {/* ignore */}
    },
    showAllQuickReplies: function showAllQuickReplies() {
      var allReplies = [];
      (this.fastReplyList || []).forEach(function (group) {
        (group.replyList || []).forEach(function (reply) {
          allReplies.push(reply);
        });
      });
      this.quickReplySuggestions = allReplies.slice(0, 6); // 最多显示6个
      this.selectedSuggestionIndex = 0;
      this.showQuickReplySuggestions = true;
    },
    filterQuickReplies: function filterQuickReplies(keyword) {
      var filteredReplies = [];
      (this.fastReplyList || []).forEach(function (group) {
        (group.replyList || []).forEach(function (reply) {
          var quicktext = (reply.quicktext || '').toLowerCase();
          var replytext = (reply.replytext || '').toLowerCase();
          if (quicktext.includes(keyword) || replytext.includes(keyword)) {
            filteredReplies.push(reply);
          }
        });
      });
      this.quickReplySuggestions = filteredReplies.slice(0, 6); // 最多显示6个
      this.selectedSuggestionIndex = 0;
      this.showQuickReplySuggestions = true;
    },
    selectSuggestion: function selectSuggestion(item) {
      var _this16 = this;
      if (!item) return;
      var text = this.replyText || '';
      var lastSlashIndex = text.lastIndexOf('/');
      if (lastSlashIndex !== -1) {
        // 替换 / 及其后面的内容为选中的快捷短语
        var beforeSlash = text.substring(0, lastSlashIndex);
        this.replyText = beforeSlash + item.replytext;
      } else {
        // 如果没有 / 符号，直接添加
        this.replyText = text + item.replytext;
      }
      this.hideSuggestions();

      // 聚焦到输入框
      this.$nextTick(function () {
        var textarea = _this16.$el.querySelector('.reply-textarea textarea');
        if (textarea) {
          textarea.focus();
          textarea.setSelectionRange(_this16.replyText.length, _this16.replyText.length);
        }
      });
    },
    hideSuggestions: function hideSuggestions() {
      this.showQuickReplySuggestions = false;
      this.quickReplySuggestions = [];
      this.selectedSuggestionIndex = 0;
    },
    refreshFastReply: function refreshFastReply() {
      var _this17 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/searchType?id=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this17.settings.groups = Array.isArray(result.data.personalType) ? result.data.personalType : [];
        }
      });
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/search?type=1&sceneId=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this17.fastReplyList = result.data.typeList;
        } else {
          _this17.$message({
            message: result.msg,
            type: 'error'
          });
        }
      }, function (err) {
        _this17.$message({
          message: '保存失败',
          type: 'error'
        });
      });
    },
    newFastReply: function newFastReply() {
      this.showEditor = true;
    },
    toggleGroup: function toggleGroup(id) {
      if (!this.settings.collapsedGroups) this.$set(this.settings, 'collapsedGroups', {});
      this.$set(this.settings.collapsedGroups, id, !this.settings.collapsedGroups[id]);
    },
    menuAddGroup: function menuAddGroup() {
      var _this18 = this;
      var self = this;
      this.$prompt('请输入分组名', '新增分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        // 非空
        inputErrorMessage: '分组名不能为空'
      }).then(function (_ref) {
        var value = _ref.value;
        var name = value && value.trim();
        if (!name) return;
        _this18.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/saveReplyType?sceneId=' + self.sceneId, {
          name: name
        }).then(function (res) {
          var result = res.data;
          if (result && result.success) {
            _this18.$message({
              type: 'success',
              message: '保存分组成功'
            });
            self.refreshFastReply();
          } else {
            _this18.$message({
              type: 'error',
              message: result.msg || '保存失败'
            });
          }
        }, function () {
          _this18.$message({
            type: 'error',
            message: '保存失败'
          });
        });
      });
    },
    menuEditReply: function menuEditReply(reply, group) {
      // 将当前短语的数据映射到编辑弹窗所需字段
      var groupId = group && group.id ? group.id : '';
      this.settings.defaultGroupId = groupId;
      this.editorValue = {
        id: reply.id || '',
        content: reply.replytext || '',
        group: groupId,
        code: reply.quicktext || ''
      };
      this.showEditor = true;
    },
    /**
     * 添加短语
     */
    menuAddReply: function menuAddReply() {
      this.settings.defaultGroupId = this.settings.selectedFrgId == 'all' ? null : this.settings.selectedFrgId;
      this.showEditor = true;
    },
    menuDeleteReply: function menuDeleteReply(reply) {
      var _this19 = this;
      var self = this;
      this.$confirm('确定要删除这条快捷短语吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this19.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/deleteReply', {
          id: reply.id
        }).then(function (res) {
          var result = res.data;
          if (result && result.success) {
            _this19.$message({
              type: 'success',
              message: '删除成功'
            });
            self.refreshFastReply();
          } else {
            _this19.$message({
              type: 'error',
              message: result.msg || '删除失败'
            });
          }
        }, function () {
          _this19.$message({
            type: 'error',
            message: '删除失败'
          });
        });
      }).catch(function () {
        _this19.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    formatMsgTime: function formatMsgTime(t) {
      if (!t) return '';
      var date = typeof t === 'number' ? new Date(t) : new Date(String(t));
      var y = date.getFullYear();
      var M = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      var h = String(date.getHours()).padStart(2, '0');
      var m = String(date.getMinutes()).padStart(2, '0');
      var s = String(date.getSeconds()).padStart(2, '0');
      return "".concat(y, "-").concat(M, "-").concat(d, " ").concat(h, ":").concat(m, ":").concat(s);
    },
    scrollChatToBottom: function scrollChatToBottom() {
      var el = this.$refs && this.$refs.chatContent;
      if (!el) return;
      try {
        el.scrollTop = el.scrollHeight;
      } catch (e) {/* ignore */}
    },
    parseContent: function parseContent(content) {
      // 识别普通图片链接（含查询参数），并进行图文混排
      // 匹配形如 http(s)://.../xxx.(png|jpg|jpeg|gif|webp|bmp)[?...] 的链接
      var urlRegex = /(https?:\/\/[^\s]+?\.(?:png|jpe?g|gif|webp|bmp)(?:\?[^\s]*)?)/ig;
      var nodes = [];
      var str = String(content || '');
      var lastIndex = 0;
      var match;
      while ((match = urlRegex.exec(str)) !== null) {
        var start = match.index;
        if (start > lastIndex) {
          nodes.push({
            type: 'text',
            text: str.slice(lastIndex, start)
          });
        }
        nodes.push({
          type: 'img',
          src: match[1]
        });
        lastIndex = urlRegex.lastIndex;
      }
      if (lastIndex < str.length) {
        nodes.push({
          type: 'text',
          text: str.slice(lastIndex)
        });
      }
      return nodes.length ? nodes : [{
        type: 'text',
        text: str
      }];
    }
  }, "onClickReply", function onClickReply(reply) {
    this.replyText = reply.replytext;
  })
};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FastReplyImportDDDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sceneId: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    return {
      filePath: '',
      fileBlob: null,
      tableData: [],
      importType: 'override',
      // 新增：导入类型
      fileName: '',
      // 新增：文件名
      importLoading: false // 新增：导入中状态
    };
  },
  computed: {
    visibleProxy: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    }
  },
  methods: {
    chooseFile: function chooseFile() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    loadReplyList: function loadReplyList() {
      var _this = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/search?type=1&sceneId=' + this.sceneId).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          var typeList = Array.isArray(result.data && result.data.typeList) ? result.data.typeList : [];
          // 构建父级名称索引
          var idToItem = {};
          typeList.forEach(function (t) {
            idToItem[t.id] = t;
          });
          var index = 1;
          var rows = [];
          typeList.forEach(function (t) {
            var parentName = t.name;
            var replies = Array.isArray(t.replyList) ? t.replyList : [];
            replies.forEach(function (r) {
              rows.push({
                index: index++,
                code: r.quicktext || '',
                content: r.replytext || '',
                group: parentName,
                image: '',
                status: '完成'
              });
            });
          });
          _this.tableData = rows;
        } else {
          _this.$message({
            message: result.msg,
            type: 'error'
          });
        }
      }, function (err) {
        _this.$message({
          message: '保存失败',
          type: 'error'
        });
      });
    },
    onFileChange: function onFileChange(e) {
      var file = e && e.target && e.target.files ? e.target.files[0] : null;
      if (!file) return;
      this.fileBlob = file;
      this.fileName = file.name; // 仅记录文件，真正导入在“导入”按钮触发
    },
    onImportClick: function onImportClick() {
      var _this2 = this;
      if (!this.fileBlob) {
        this.$message({
          message: '请选择要导入的文件',
          type: 'warning'
        });
        return;
      }
      this.importLoading = true;
      var formdata = new FormData();
      formdata.append('file', this.fileBlob);
      formdata.append('id', 'WU_FILE_0');
      formdata.append('name', this.fileBlob.name || '');
      formdata.append('type', this.fileBlob.type || '');
      formdata.append('lastModifiedDate', (this.fileBlob.lastModified ? new Date(this.fileBlob.lastModified) : new Date()).toLocaleString());
      formdata.append('size', this.fileBlob.size != null ? String(this.fileBlob.size) : '');
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/reply/importReply?importType=' + this.importType + '&sceneId=' + this.sceneId, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this2.$emit('refresh');
          _this2.loadReplyList();
          _this2.visibleProxy = false;
          _this2.$message({
            message: '导入成功',
            type: 'success'
          });
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error'
          });
        }
      }, function (res) {
        _this2.$message({
          message: '导入失败',
          type: 'error'
        });
      }).finally(function () {
        _this2.importLoading = false;
      });
    },
    onDownloadTemplate: function onDownloadTemplate() {
      var _this3 = this;
      this.$http.get({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/simulationExercise/reply/downloadTemplate?sceneId=' + this.sceneId).then(function (res) {
        var blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '快捷短语模板.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch(function (err) {
        _this3.$message({
          message: '下载模板失败',
          type: 'error'
        });
      });
    },
    onClosed: function onClosed() {
      this.fileBlob = null;
      this.fileName = '';
      this.importType = 'override';
      this.importLoading = false;
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    }
  }
};

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'GroupManageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sceneId: {
      type: String,
      default: ''
    },
    groups: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      customGroups: [],
      newGroupName: '',
      showAddInput: false,
      editingGroupId: null,
      editingGroupName: '',
      hoveredGroupId: null,
      isAddingNew: false
    };
  },
  computed: {
    visibleProxy: {
      get: function get() {
        return this.visible;
      },
      set: function set(v) {
        this.$emit('update:visible', v);
      }
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.updateCustomGroups();
      }
    },
    groups: {
      handler: function handler() {
        this.updateCustomGroups();
      },
      immediate: true
    }
  },
  methods: {
    updateCustomGroups: function updateCustomGroups() {
      // 从props.groups中筛选自定义分组（非系统默认分组）
      this.customGroups = (this.groups || []).filter(function (g) {
        return g && g.isCustom !== false;
      }).map(function (g) {
        return _objectSpread(_objectSpread({}, g), {}, {
          replyCount: Array.isArray(g.replyList) ? g.replyList.length : 0
        });
      });
    },
    onDeleteGroup: function onDeleteGroup(group) {
      var _this = this;
      var self = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u5206\u7EC4\"".concat(group.name, "\"\u5417\uFF1F\u5220\u9664\u540E\u8BE5\u5206\u7EC4\u4E0B\u7684\u5FEB\u6377\u77ED\u8BED\u4E5F\u5C06\u88AB\u5220\u9664\u3002"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/deleteReplyType?id=' + group.id).then(function (res) {
          var result = res.data;
          if (result && result.success) {
            _this.$message({
              type: 'success',
              message: '删除成功'
            });
            _this.$emit('refresh');
          } else {
            _this.$message({
              type: 'error',
              message: result.msg || '删除失败'
            });
          }
        }, function () {
          _this.$message({
            type: 'error',
            message: '删除失败'
          });
        });
      }).catch(function () {});
    },
    onStartAddGroup: function onStartAddGroup() {
      var _this2 = this;
      this.isAddingNew = true;
      this.newGroupName = '';
      this.$nextTick(function () {
        // 聚焦到输入框
        var inputs = _this2.$refs.newGroupInput;
        if (inputs && inputs.length > 0) {
          inputs[0].focus();
        }
      });
    },
    onSaveNewGroup: function onSaveNewGroup() {
      var _this3 = this;
      if (!this.newGroupName || !this.newGroupName.trim()) {
        this.$message.warning('分组名称不能为空');
        return;
      }
      var self = this;
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/saveReplyType?sceneId=' + self.sceneId, {
        name: this.newGroupName.trim()
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this3.$message.success('新建成功');
          _this3.onCancelAdd();
          _this3.$emit('refresh');
        } else {
          _this3.$message.error(result.msg || '新建失败');
        }
      }).catch(function (err) {
        _this3.$message.error('新建失败');
      });
    },
    onCancelAdd: function onCancelAdd() {
      this.isAddingNew = false;
      this.newGroupName = '';
    },
    onEditGroup: function onEditGroup(group) {
      var _this4 = this;
      // 确保只能有一个编辑状态
      this.editingGroupId = group.id;
      this.editingGroupName = group.name;
      this.$nextTick(function () {
        // 聚焦到输入框
        var inputs = _this4.$refs.editInput;
        if (inputs && inputs.length > 0) {
          inputs[0].focus();
        }
      });
    },
    onSaveGroup: function onSaveGroup(group) {
      var _this5 = this;
      if (!this.editingGroupName || !this.editingGroupName.trim()) {
        this.$message.warning('分组名称不能为空');
        return;
      }
      if (this.editingGroupName.trim() === group.name) {
        // 名称未变化，直接取消编辑
        this.onCancelEdit();
        return;
      }
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.newcustomer + '/train/reply/saveReplyType?sceneId=' + self.sceneId, {
        id: group.id,
        name: this.editingGroupName.trim()
      }).then(function (res) {
        var result = res.data;
        if (result && result.success) {
          _this5.$message.success('保存成功');
          _this5.onCancelEdit();
          _this5.$emit('refresh');
        } else {
          _this5.$message.error(result.msg || '保存失败');
        }
      }).catch(function (err) {
        _this5.$message.error('保存失败');
      });
    },
    onCancelEdit: function onCancelEdit() {
      this.editingGroupId = null;
      this.editingGroupName = '';
    },
    onConfirm: function onConfirm() {
      this.visibleProxy = false;
    },
    onClosed: function onClosed() {
      this.customGroups = [];
      this.newGroupName = '';
      this.showAddInput = false;
      this.editingGroupId = null;
      this.editingGroupName = '';
      this.hoveredGroupId = null;
      this.isAddingNew = false;
    }
  }
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'trainResult',
  data: function data() {
    return {
      trainId: this.$route.query.trainId
    };
  },
  computed: {
    iframeSrc: function iframeSrc() {
      return "/cloudtraining/customer/trainrecord/trainDeatil?id=" + this.$route.query.trainId;
    }
  },
  methods: {
    onIframeLoad: function onIframeLoad() {
      console.log('iframe loaded');
      this.$emit('iframe-loaded');
    },
    isreturn: function isreturn() {
      this.$router.back();
    }
  }
};

/***/ }),
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ModalBg = _interopRequireDefault(__webpack_require__(1997));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'Modal',
  data: function data() {
    return {
      comps: []
    };
  },
  props: {
    'btns': {
      type: Array,
      default: function _default() {
        return [{
          text: '确定',
          value: 'ok'
        }, {
          text: '取消',
          value: 'cancel'
        }];
      }
    },
    'mIndex': {
      type: Number,
      default: 2000
    },
    'showBtn': {
      type: Boolean,
      default: true
    }
  },
  computed: {
    realIndex: function realIndex() {
      return this.mIndex;
    }
  },
  components: {
    hDialogBack: _ModalBg.default
  },
  methods: {
    open: function open(comp) {
      comp.width = comp.width || 780;
      comp.title = comp.title || '信息提示';
      comp.pending = false;
      this.comps.push(comp);
      if (!this.$refs.back.show) {
        this.$refs.back.open();
      }
    },
    close: function close(index, comp) {
      this.comps.splice(index, 1);
      if (this.comps.length === 0 && this.$refs.back.show) {
        this.$refs.back.close();
      }
      if (typeof comp.callBack == 'function') {
        comp.callBack();
      }
    },
    clickHandler: function clickHandler(type, comp, index) {
      var self = this;
      var close = function close() {
        self.comps.splice(index, 1);
        if (self.comps.length === 0 && self.$refs.back.show) {
          self.$refs.back.close();
        }
      };
      var pending = function pending(sign) {
        if (sign === undefined) return self.comps[index].pending;
        self.comps[index].pending = !!sign;
      };
      if (typeof comp.callBack == 'function') {
        comp.callBack({
          'type': type,
          'close': close,
          'pending': pending
        });
      }
    },
    style: function style(index, comp) {
      return {
        zIndex: this.realIndex + index,
        width: comp.width + 'px'
      };
    },
    heightStyle: function heightStyle(index, comp) {
      var maxHeight = document.documentElement.clientHeight % 2 ? document.documentElement.clientHeight - 129 : document.documentElement.clientHeight - 130;
      if (!comp.height) {
        return {
          maxHeight: maxHeight + 'px'
        };
      } else {
        return {
          maxHeight: maxHeight + 'px',
          height: comp.height - 130 + 'px'
        };
      }
    }
  }
};

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
var _default = exports.default = {
  name: 'HDialog-background',
  data: function data() {
    return {
      show: false
    };
  },
  props: {
    'zIndex': {
      type: Number,
      default: 19861015
    }
  },
  methods: {
    open: function open() {
      this.show = true;
    },
    close: function close() {
      this.show = false;
    }
  }
};

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
var _default = exports.default = {
  name: 'tjkautocomplete',
  data: function data() {
    return {
      tjkName: ''
    };
  },
  watch: {
    tjkName: function tjkName() {
      if (this.tjkName == '') {
        this.$emit('callBack', '');
      }
    }
  },
  methods: {
    //根据姓名或登录账户查询淘金客信息
    querySearchAsync: function querySearchAsync(queryString, callback) {
      var _this = this;
      if (queryString !== '' && queryString.length >= 2) {
        var list = [];
        var data = {
          'tjkParam': queryString
        };
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/tjk/query', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            _this.success = result.success;
            _this.message = result.msg;
            //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
            var _iterator = _createForOfIteratorHelper(response.data.data),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var i = _step.value;
                i.value = i.realName + '（' + i.tjkNumber + '）';
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            list = result.data;
            callback(list);
          } else {
            alert(result.msg);
          }
        }, function (response) {
          alert('网络繁忙，请稍后重试！');
        });
      }
    },
    handleSelect: function handleSelect(item) {
      this.$emit('callBack', item.id);
    }
  }
};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'tjkautocompleteall',
  data: function data() {
    return {
      userList: [],
      tjkName: this.$route.query.tjkName ? this.$route.query.tjkName + '(' + this.$route.query.tjkNumber + ')' : ''
    };
  },
  props: ['tjkId'],
  watch: {
    tjkName: function tjkName() {
      if (this.tjkName == '') {
        this.$emit('change', '');
      }
    },
    tjkId: function tjkId() {
      if (this.tjkId == '') {
        this.tjkName = '';
      }
    }
  },
  methods: {
    querySearch: function querySearch(queryString) {
      var _this = this;
      var data = {
        'tjkParam': queryString
      };
      this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.tjkuser + '/tjk/queryForAllType', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.userList = result.data.map(_this.userWithLabel);
        } else {
          _this.$alert(result.msg);
        }
      }, function (response) {
        _this.$alert('网络繁忙，请稍后重试！');
      });
    },
    // 选中
    onChange: function onChange(item) {
      this.$emit("change", item);
    },
    onClear: function onClear() {
      this.$emit("change", '');
    },
    //淘金客姓名或登录账号模糊搜索
    tjkSearch: function tjkSearch(queryString, callback) {
      if (queryString !== '' && queryString.length >= 2) {
        var tjkList = [];
        var data = {
          'tjkParam': queryString
        };
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.system + '/tjk/queryForAllType', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
            var _iterator = _createForOfIteratorHelper(response.data.data),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var i = _step.value;
                i.value = (i.realName ? i.realName : "空") + '(' + i.tjkNumber + ')';
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            tjkList = result.data;
            if (result.data.length > 0) {
              callback(tjkList);
            } else {
              callback([{
                'value': '无数据'
              }]);
            }
          } else {
            alert(result.msg);
          }
        }, function (response) {
          alert('网络繁忙，请稍后重试！');
        });
      }
    },
    tjkHandleSelect: function tjkHandleSelect(item) {
      this.$emit('callBack', item);
    },
    userWithLabel: function userWithLabel(user) {
      if (!user) {
        return user;
      }
      user.label = (user.realName ? user.realName : "空") + '(' + user.tjkNumber + ')';
      return user;
    }
  }
};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
var _default = exports.default = {
  name: 'providerautocomplete',
  data: function data() {
    return {
      providerName: ''
    };
  },
  watch: {
    providerName: function providerName() {
      if (this.providerName == '') {
        this.$emit('callBack', '');
      }
    }
  },
  methods: {
    //根据姓名或登录账户查询淘金客信息
    querySearchAsync: function querySearchAsync(queryString, callback) {
      var _this = this;
      if (queryString !== '' && queryString.length >= 2) {
        var list = [];
        var data = {
          'providerName': queryString
        };
        this.$http.post({"system":"//t.itaojin.cn/studyExam","tjkuser":"//t.itaojin.cn/tjuser","tjkInfo":"//t.itaojin.cn/tjkInfo","college":"//t.itaojin.cn/college","achievement":"//s.itaojin.cn/achievement","teamTalk":"//t.itaojin.cn/teamTalk/action","teamTalkManage":"//t.itaojin.cn/teamTalk/manage","systemHeader":"//t.itaojin.cn","hawkeyeUrlWeixin":"ws://127.0.0.1:18891","hawkeyeUrl":"ws://127.0.0.1:8891","wsUrl":"ws://www.itaojin.cn:8083/tj-call-connector-web/websocket","tjk":"//t.itaojin.cn/tjkOperation","customer":"//t.itaojin.cn/cloudtraining/customer","newcustomer":"//t.itaojin.cn/cloudtraining/customer","method":"//t.itaojin.cn/tjkjobtaskApi","provider":"//t.itaojin.cn/provider","staticCDN":"//t-cdn.itaojin.cn","imUrl":"//www.itaojin.cn","imToken":"bb235147b451447c90cc965b49402bc1"}.provider + '/providerInfo/queryList', data).then(function (response) {
          var result = response.data;
          if (result.success) {
            _this.success = result.success;
            _this.message = result.msg;
            //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
            var _iterator = _createForOfIteratorHelper(response.data.data),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var i = _step.value;
                i.value = i.providerName;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            list = result.data;
            callback(list);
          } else {
            alert(result.msg);
          }
        }, function (response) {
          alert('网络繁忙，请稍后重试！');
        });
      }
    },
    handleSelect: function handleSelect(item) {
      this.$emit('callBack', item.providerId);
    }
  }
};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'children',
  data: function data() {
    return {};
  },
  props: ['dataArr', 'dataObj'],
  methods: {
    objToStr: function objToStr(obj) {
      /*
      if(!obj.dynamicForm) {
        if(obj.type == 'TEXT' && this.isHasFormFieldValue(obj.field)) {
          obj.defaultValue = this.getFormFieldValue(obj.field)
        }
        if(obj.type == 'TEXT' && !this.isHasFormFieldValue(obj.field)) {
          obj.defaultValue = ''
        }
        if(obj.type == 'SELECT') {
          obj.fieldOptions = this.getFormFieldValue(obj.fieldName)
        }
       }
      return obj.children && obj.children.length ? '' : JSON.stringify(obj);
      */
    },
    //判断是否有值
    isHasFormFieldValue: function isHasFormFieldValue(name) {
      /* if(this.dataObj.hasOwnProperty(name)) {
         return true
       }else {
         return false
       }*/
    },
    //获取非动态字段默认值/下拉列表
    getFormFieldValue: function getFormFieldValue(name) {
      /*if(this.dataObj.fieldOptions(name)) {
        return this.dataObj[name]
      }*/
    }
  }
};

/***/ }),
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _vue = _interopRequireDefault(__webpack_require__(22));
var _App = _interopRequireDefault(__webpack_require__(1077));
var _router = _interopRequireDefault(__webpack_require__(1082));
__webpack_require__(1761);
var _axios = _interopRequireDefault(__webpack_require__(469));
var _qs = _interopRequireDefault(__webpack_require__(1963));
__webpack_require__(1993);
__webpack_require__(23);
var _pagination = _interopRequireDefault(__webpack_require__(104));
var _Modal = _interopRequireDefault(__webpack_require__(1994));
var _tjkAutoComplete = _interopRequireDefault(__webpack_require__(2002));
var _tjkAutoCompleteAll = _interopRequireDefault(__webpack_require__(2004));
var _providerAutoComplete = _interopRequireDefault(__webpack_require__(2008));
var _children = _interopRequireDefault(__webpack_require__(2010));
var _jquery = _interopRequireDefault(__webpack_require__(7));
var _common = _interopRequireDefault(__webpack_require__(2014));
var _elementUi = _interopRequireDefault(__webpack_require__(2015));
__webpack_require__(2098);
var _animate = _interopRequireDefault(__webpack_require__(2099));
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import VueLazyload from 'vue-lazyload'

/******** 发送请求前配置请求及参数 ********/
_axios.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
_axios.default.interceptors.request.use(function (config) {
  if (config.url.match(new RegExp('^.*/json/.*$'))) {
    _axios.default.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
  } else {
    _axios.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  }
  if (config.method === 'post') {
    var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)')),
      arrValue = arr != null ? unescape(arr[2]) : null;
    if (arr) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      //小助手接口不添加tjk-login-token
      if (!config.url.match(new RegExp('^.*/hawkeye/action/.*$'))) {
        config.headers.common['tjk-login-token'] = "".concat(arrValue);
        config.headers.common['tjk_login_token'] = "".concat(arrValue);
      }
      config.headers.common['login_token'] = "".concat(arrValue);
    }
    // 上传到七牛时如果在参数中添加login_token会报错
    if (config.url == 'http://upload.qiniu.com' || config.url == '//upload-z0.qiniup.com') return config;
    if (config.url.match(new RegExp('^.*/simulationExercise/reply/importReply.*$'))) return config;
    if (config.url.match(new RegExp('^.*/json/.*$')) || config.url.match(new RegExp('^.*/hawkeye/action/.*$'))) return config;
    if (!config.data) config.data = {};
    config.data.tjk_login_token = arr != null ? unescape(arr[2]) : null;
    config.data = _qs.default.stringify(config.data, {
      allowDots: true
    });
  }
  if (config.method === 'get') {
    var arr = document.cookie.match(new RegExp('(^| )login_token=([^;]*)(;|$)')),
      arrValue = arr != null ? unescape(arr[2]) : null;
    if (arr) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.common['tjk-login-token'] = "".concat(arrValue);
      config.headers.common['tjk_login_token'] = "".concat(arrValue);
      config.headers.common['login_token'] = "".concat(arrValue);
    }
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
_axios.default.interceptors.response.use(function (res) {
  if (!res.data.success && res.data.data == 201) {
    if (confirm('跳转到登陆?')) {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger' && ua.match(/wxwork/i) == 'wxwork') {
        window.location.href = '/college/sso/authorize';
        return;
      } else {
        window.location.href = '/customer/sso/authorize?25';
        return;
      }
    }
  }
  return res;
}, function (error) {
  _.toast("网络异常", 'fail');
  return Promise.reject(error);
});
_vue.default.prototype.$http = _axios.default;
/******** 发送请求前配置请求及参数 END ********/
// 提示语公用方法
_vue.default.prototype.notify = function (msg) {
  this.$notify((0, _defineProperty2.default)({
    title: '',
    dangerouslyUseHTMLString: true,
    message: msg,
    showClose: false,
    offset: 100
  }, "showClose", true));
};
_vue.default.config.productionTip = false;

// 注册弹窗组件c
_vue.default.component(_Modal.default.name, _Modal.default);

// 注册分页组件
_vue.default.component(_pagination.default.name, _pagination.default);
// 注册自动搜索组件
_vue.default.component(_tjkAutoComplete.default.name, _tjkAutoComplete.default);
_vue.default.component(_tjkAutoCompleteAll.default.name, _tjkAutoCompleteAll.default);
_vue.default.component(_providerAutoComplete.default.name, _providerAutoComplete.default);
_vue.default.component(_children.default.name, _children.default);

// 注册ElementUI
_vue.default.use(_elementUi.default);
_vue.default.mixin(_common.default);

// Vue.use(VueLazyload)

_router.default.beforeEach(function (to, from, next) {
  if (from && from.path) {
    sessionStorage.setItem('prevRoutePath', from.path);
  } else {
    sessionStorage.removeItem('prevRoutePath');
  }
  next();
});
_router.default.onError(function (error) {
  var pattern = /Loading chunk (\d)+ failed/g;
  var isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    var targetPath = _router.default.history.pending.fullPath;
    if (_router.default.__chunkRetryCount && _router.default.__chunkRetryCount >= 1) {
      if (confirm('页面资源已更新，请刷新页面以获取最新版本？')) {
        window.location.reload();
      }
    } else {
      _router.default.__chunkRetryCount = (_router.default.__chunkRetryCount || 0) + 1;
      setTimeout(function () {
        _router.default.replace(targetPath);
      }, 500);
    }
  }
});
_vue.default.config.errorHandler = function (err, vm, info) {
  console.error('Vue Error:', err, info);
};
window.onerror = function (message, source, lineno, colno, error) {
  if (message.indexOf('Unexpected token') !== -1 || message.indexOf('Loading chunk') !== -1) {
    if (confirm('页面资源已更新，请刷新页面以获取最新版本？')) {
      window.location.reload();
    }
  }
  return true;
};

/* eslint-disable no-new */
new _vue.default({
  el: '#app',
  router: _router.default,
  template: '<App/>',
  components: {
    App: _App.default
  }
});

/***/ }),
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1081);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1078)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ba5bd90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1079);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4851e060", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#app[data-v-7ba5bd90] {\n  height: 100%;\n  width: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 1080 */,
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view", {
        directives: [
          {
            name: "wechat-title",
            rawName: "v-wechat-title",
            value: _vm.$route.meta.title,
            expression: "$route.meta.title"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(__webpack_require__(73));
var _vue = _interopRequireDefault(__webpack_require__(22));
var _vueRouter = _interopRequireDefault(__webpack_require__(1083));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
_vue.default.use(_vueRouter.default);
_vue.default.use(__webpack_require__(1084));
var _default = exports.default = new _vueRouter.default({
  mode: 'history',
  base: '/tjkStudy',
  routes: [{
    path: '/',
    redirect: '/train/index'
  }, {
    path: '/courselist',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1085));
      });
    },
    name: 'courseList',
    meta: {
      title: '培训中心'
    }
  }, {
    path: '/video',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(530));
      });
    },
    name: 'video',
    meta: {
      title: '视频'
    }
  }, {
    path: '/signContract',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1090));
      });
    },
    name: 'signContract',
    meta: {
      title: '签约'
    }
  }, {
    path: '/courseDetail/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1104));
      });
    },
    name: 'courseDetail',
    meta: {
      title: '课程详情'
    }
  }, {
    path: '/course',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1109));
      });
    },
    name: 'course',
    meta: {
      title: '课程目录'
    }
  }, {
    path: '/examlist',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1111));
      });
    },
    name: 'examList',
    meta: {
      title: '考试中心'
    }
  }, {
    path: '/exam/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1113));
      });
    },
    name: 'exam',
    meta: {
      title: '考试答题'
    }
  }, {
    path: '/examTemp/:id/:trainId',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1118));
      });
    },
    name: 'examTemp',
    meta: {
      title: '考试答题2'
    }
  }, {
    path: '/examTyping/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1124));
      });
    },
    name: 'examTyping',
    meta: {
      title: '打字测试'
    }
  }, {
    path: '/examDetail/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1126));
      });
    },
    name: 'examDetail',
    meta: {
      title: '考试详情'
    }
  }, {
    path: '/examDetailTemp/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1128));
      });
    },
    name: 'examDetailTemp',
    meta: {
      title: '考试详情(暂命名)'
    }
  }, {
    path: '/train/fbtExperienceChoose',
    name: 'fbtExperienceChoose',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1130));
      });
    },
    meta: {
      title: '淘系认证经验选择'
    }
  }, {
    path: '/examResult/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1134));
      });
    },
    name: 'examResult',
    meta: {
      title: '考试结果'
    }
  }, {
    path: '/typingResult/:id',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1136));
      });
    },
    name: 'typingResult',
    meta: {
      title: '考试结果'
    }
  }, {
    path: '/liveCourse',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1138));
      });
    },
    name: 'liveCourse',
    meta: {
      title: '直播'
    }
  }, {
    path: '/trainRecords',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1140));
      });
    },
    name: 'trainRecords',
    meta: {
      title: 'APP-我的培训记录'
    }
  }, {
    path: '/taojinMethod',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1147));
      });
    },
    name: 'taojinMethod',
    meta: {
      title: '淘金攻略'
    }
  }, {
    path: '/blacklist',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1152));
      });
    },
    name: 'blacklist',
    meta: {
      title: '违规记录'
    }
  }, {
    path: '/intentRegister',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1156));
      });
    },
    name: 'intentRegister',
    meta: {
      title: '意向登记'
    }
  }, {
    path: '/groupTrain',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1159));
      });
    },
    name: 'groupTrain',
    meta: {
      title: '群培训管理'
    }
  }, {
    path: '/waitWork',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1163));
      });
    },
    name: 'waitWork',
    meta: {
      title: '群待岗学员'
    }
  }, {
    path: '/voiceExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1167));
      });
    },
    name: 'voiceExam',
    meta: {
      title: '语音考核'
    }
  }, {
    path: '/tjkExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1171));
      });
    },
    name: 'tjkExam',
    meta: {
      title: '学员考核'
    }
  }, {
    path: '/waitWorkExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1175));
      });
    },
    name: 'waitWorkExam',
    meta: {
      title: '群待岗学员群考核'
    }
  }, {
    path: '/retrialExamine',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1179));
      });
    },
    name: 'retrialExamine',
    meta: {
      title: '建议复训考核'
    }
  }, {
    path: '/linkage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1183));
      });
    },
    name: 'linkage',
    meta: {
      title: '联动课程'
    }
  }, {
    path: '/interview',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1185));
      });
    },
    name: 'interview',
    meta: {
      title: '基础面试'
    }
  }, {
    path: '/interviewTjk/:id/:groupName/:groupId',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1189));
      });
    },
    name: 'interviewTjk',
    meta: {
      title: '申请人详情'
    }
  }, {
    path: '/groupCheckIn',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1193));
      });
    },
    name: 'groupCheckIn',
    meta: {
      title: 'teamTalk签到'
    }
  }, {
    path: '/operatorExamine',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1195));
      });
    },
    name: 'operatorExamine',
    meta: {
      title: '合伙人运营商考核'
    }
  }, {
    path: '/enterExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1199));
      });
    },
    name: 'enterExam',
    meta: {
      title: '语音考核'
    }
  }, {
    path: '/tjkExamOperator',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1203));
      });
    },
    name: 'tjkExamOperator',
    meta: {
      title: '学员考核'
    }
  },
  // pdd模拟-新版
  {
    path: '/simulate/pddStudy',
    name: 'pddStudy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1207));
      });
    },
    meta: {
      title: '拼多多功能学习',
      type: 'pddStudy'
    }
  },
  // pdd模拟-新版
  {
    path: '/simulate/pddExam',
    name: 'pddExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1293));
      });
    },
    meta: {
      title: '拼多多模拟实操',
      type: 'pddExam'
    }
  },
  // 聚水潭ERP模拟
  {
    path: '/simulate/jushuitanerpStudy',
    name: 'juShuiTanErpStudy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1297));
      });
    },
    meta: {
      title: '聚水潭ERP功能学习',
      type: 'workorderjushuitan'
    }
  }, {
    path: '/simulate/jushuitanerpexam',
    name: 'juShuiTanErpExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1383));
      });
    },
    meta: {
      title: '聚水潭ERP模拟实操',
      type: 'workorderjushuitanexam'
    }
  },
  // 千牛模拟-新版
  {
    path: '/simulate/newqianniu',
    name: 'newQianNiu',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1387));
      });
    },
    meta: {
      title: '千牛功能学习',
      type: 'qianniu'
    }
  }, {
    path: '/simulate/newqianniuexam',
    name: 'newQianNiuExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1394));
      });
    },
    meta: {
      title: '千牛模拟实操',
      type: 'qianniu'
    }
  }, {
    path: '/simulate/newQianNiuExam_11618',
    name: 'newQianNiuExam_11618',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1398));
      });
    },
    meta: {
      title: '千牛模拟实操11618',
      type: 'qianniu'
    }
  }, {
    path: '/simulate/doubleQianNiuExam',
    name: 'doubleQianNiuExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1402));
      });
    },
    meta: {
      title: '618双11徽章附加千牛操作',
      type: 'qianniu'
    }
  }, {
    path: '/simulate/jmStudy',
    name: 'jingMaiStudy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1436));
      });
    },
    meta: {
      title: '京麦功能学习',
      type: 'qianniu'
    }
  }, {
    path: '/simulate/jmExam',
    name: 'jingMaiExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1440));
      });
    },
    meta: {
      title: '京麦模拟实操',
      type: 'qianniu'
    }
  }, {
    path: '/simulate/jmExam_11618',
    name: 'jingMaiExam_11618',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1444));
      });
    },
    meta: {
      title: '京麦模拟实操,双11 618',
      type: 'qianniu'
    }
  },
  //任务培训-签到评价
  {
    path: '/traincheck/index',
    name: 'index',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1448));
      });
    },
    meta: {
      title: '签到评价'
    }
  }, {
    path: '/traincheck/list',
    name: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1452));
      });
    },
    meta: {
      title: '培训助手'
    }
  }, {
    path: '/traincheck/namelist',
    name: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1456));
      });
    },
    meta: {
      title: '培训名单'
    }
  },
  // 小助手成员管理
  {
    path: '/hawkeye/memberManage',
    name: 'memberManage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1478));
      });
    },
    meta: {
      title: '成员管理'
    }
  },
  // 小助手语音培训考核
  {
    path: '/hawkeye/voiceExam',
    name: 'voiceExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1482));
      });
    },
    meta: {
      title: '小助手功能学习'
    }
  }, {
    path: '/hawkeye/blankLogin',
    name: 'blankLogin',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1486));
      });
    },
    meta: {
      title: '小助手功能学习'
    }
  }, {
    path: '/hawkeye/voiceTrain',
    name: 'voiceTrain',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1488));
      });
    },
    meta: {
      title: '岗前培训'
    }
  }, {
    path: '/wallet',
    name: 'wallet',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1493));
      });
    },
    meta: {
      title: '我的钱包'
    }
  }, {
    path: '/voiceExercise',
    name: 'voiceExercise',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1497));
      });
    },
    meta: {
      title: '语音对练场'
    }
  }, {
    path: '/voiceSceneIndex',
    name: 'voiceScene',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1501));
      });
    },
    meta: {
      title: '语音陪练'
    }
  }, {
    path: '/teacherDetail',
    name: 'teacherDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1505));
      });
    },
    meta: {
      title: '语音陪练'
    }
  }, {
    path: '/voiceScene/blankLogin',
    name: 'voiceSceneBlankLogin',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1507));
      });
    },
    meta: {
      title: '语音陪练'
    }
  }, {
    path: '/partner',
    name: 'partner',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1509));
      });
    },
    meta: {
      title: '语音对练'
    }
  }, {
    path: '/kaoheDetail',
    name: 'kaoheDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1513));
      });
    },
    meta: {
      title: '语音考核'
    }
  }, {
    path: '/kaoheTeacher',
    name: 'kaoheTeacher',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1515));
      });
    },
    meta: {
      title: '语音考核'
    }
  }, {
    path: '/kaoheTeacherDetail',
    name: 'kaoheTeacherDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1517));
      });
    },
    meta: {
      title: '语音考核'
    }
  },
  //新版小助手嵌套陪练&考核页面
  {
    path: '/newVoiceSceneIndex',
    name: 'newVoiceSceneIndex',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1519));
      });
    },
    meta: {
      title: '语音陪练'
    }
  }, {
    path: '/newTeacherDetail',
    name: 'newTeacherDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1523));
      });
    },
    meta: {
      title: '语音陪练'
    }
  }, {
    path: '/newVoiceScene/blankLogin',
    name: 'newVoiceSceneBlankLogin',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1525));
      });
    },
    meta: {
      title: '语音陪练'
    }
  }, {
    path: '/newPartner',
    name: 'newPartner',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1527));
      });
    },
    meta: {
      title: '语音对练'
    }
  }, {
    path: '/newKaoheDetail',
    name: 'newKaoheDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1531));
      });
    },
    meta: {
      title: '语音考核'
    }
  }, {
    path: '/newKaoheTeacher',
    name: 'newKaoheTeacher',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1533));
      });
    },
    meta: {
      title: '语音考核'
    }
  }, {
    path: '/newKaoheTeacherDetail',
    name: 'newKaoheTeacherDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1535));
      });
    },
    meta: {
      title: '语音考核'
    }
  }, {
    path: '/train/blankLogin',
    name: 'trainBlankLogin',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1537));
      });
    },
    meta: {
      title: '语音陪练'
    }
  }, {
    path: '/train/index',
    name: 'trainIndex',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1539));
      });
    },
    meta: {
      title: '语音/在线客服培训'
    }
  }, {
    path: '/vedioDetail',
    name: 'vedioDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1553));
      });
    },
    meta: {
      title: '学习课程'
    }
  }, {
    path: '/webPageLink',
    name: 'webPageLink',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1580));
      });
    },
    meta: {
      title: '子页面'
    }
  }, {
    path: '/train/examDetail',
    name: 'trainExamDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1584));
      });
    },
    meta: {
      title: '测试课程'
    }
  }, {
    path: '/train/examResult',
    name: 'trainExamResult',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1589));
      });
    },
    meta: {
      title: '测试课程结果页'
    }
  }, {
    path: '/train/basicExamDetail/:id',
    name: 'basicExamDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1593));
      });
    },
    meta: {
      title: '试卷答题详情',
      parentname: '测试课程'
    }
  }, {
    path: '/train/courseList',
    name: 'trainCourseList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1597));
      });
    },
    meta: {
      title: '技能提升课程页'
    }
  }, {
    path: '/train/childCourseList',
    name: 'trainChildCourseList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1603));
      });
    },
    meta: {
      title: '技能提升二级课程页'
    }
  }, {
    path: '/train/partnerIndex',
    name: 'trainPartnerIndex',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1607));
      });
    },
    meta: {
      title: '技能提升-对练首页'
    }
  }, {
    path: '/train/recordDetail',
    name: 'recordDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1611));
      });
    },
    meta: {
      title: '录音课程'
    }
  }, {
    path: '/train/eachExerciseRecord',
    name: 'eachExerciseRecord',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1615));
      });
    },
    meta: {
      title: '对练记录'
    }
  }, {
    path: '/train/eachExerciseRecordAll',
    name: 'eachExerciseRecordAll',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1617));
      });
    },
    meta: {
      title: '对练&扮演客服记录'
    }
  }, {
    path: '/train/eachRecordDetail',
    name: 'eachRecordDetail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1621));
      });
    },
    meta: {
      title: '对练详情'
    }
  }, {
    path: '/train/examRecordList',
    name: 'examRecordList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1625));
      });
    },
    meta: {
      title: '考核记录'
    }
  }, {
    path: '/train/Secondarylist',
    name: 'Secondarylist',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1627));
      });
    },
    meta: {
      title: '课程学习'
    }
  }, {
    path: '/train/Knowledge',
    name: 'Knowledge',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1631));
      });
    },
    meta: {
      title: '新知识点'
    }
  }, {
    path: '/train/Scene',
    name: 'Scene',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1635));
      });
    },
    meta: {
      title: '新二级场景'
    }
  }, {
    path: '/train/SpecialCourses',
    name: 'SpecialCourses',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1639));
      });
    },
    meta: {
      title: '新特殊课程'
    }
  }, {
    path: '/train/CallOutRandomScript',
    name: 'CallOutRandomScript',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1645));
      });
    },
    meta: {
      title: '随机话术'
    }
  }, {
    path: '/train/Sessions',
    name: 'Sessions',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1649));
      });
    },
    meta: {
      title: '新场景（分上下场）'
    }
  }, {
    path: '/train/OnInline',
    name: 'OnInline',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1653));
      });
    },
    meta: {
      title: '在线，（内嵌iframe:打字测试、千牛实操等）'
    }
  }, {
    path: '/train/OperationRecord',
    name: 'OperationRecord',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1657));
      });
    },
    meta: {
      title: '在线查看实操记录'
    }
  },
  // excel办公软件学习
  {
    path: '/newexcel',
    name: 'newexcel',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1661));
      });
    },
    meta: {
      title: 'excel与word学习'
    }
  },
  // excel办公软件考试
  {
    path: '/excelstudy',
    name: 'excelstudy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1666));
      });
    },
    meta: {
      title: 'excel与word考试'
    }
  },
  // 搜狗输入法的学习
  {
    path: '/typewriting',
    name: 'typewriting',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1670));
      });
    },
    meta: {
      title: '搜狗输入法的学习'
    }
  },
  // 搜狗输入法的考试
  {
    path: '/typewritingstudy',
    name: 'typewritingstudy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1674));
      });
    },
    meta: {
      title: '搜狗输入法的学习'
    }
  }, {
    path: '/feiGeTrain',
    name: 'feiGeTrain',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1678));
      });
    },
    meta: {
      title: '飞鸽练习场',
      type: 'feige'
    }
  }, {
    path: '/feiGeTrainexam',
    name: 'feiGeTrainExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1682));
      });
    },
    meta: {
      title: '飞鸽模拟实操',
      type: 'feige'
    }
  }, {
    path: '/feiGeTrainexam_11618',
    name: 'feiGeTrainExam_11618',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1686));
      });
    },
    meta: {
      title: '飞鸽模拟实操双11618',
      type: 'feige'
    }
  }, {
    path: '/train/FBT/courseList',
    name: 'fbtCourseList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1690));
      });
    },
    meta: {
      title: '淘系认证课程列表'
    }
  }, {
    path: '/train/FBT/qianniu',
    name: 'fbtQianniu',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1694));
      });
    },
    meta: {
      title: '千牛'
    }
  }, {
    path: '/train/FBT/qianniuExam',
    name: 'fbtQianniuExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1698));
      });
    },
    meta: {
      title: '千牛'
    }
  }, {
    path: '/train/FBT/jingmaiChat',
    name: 'fbtJingmaiChat',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1702));
      });
    },
    meta: {
      title: '京麦'
    }
  }, {
    path: '/train/FBT/jingmai',
    name: 'fbtJingmai',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1723));
      });
    },
    meta: {
      title: '京麦'
    }
  }, {
    path: '/train/FBT/jingmaiExam',
    name: 'fbtJingmaiExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1727));
      });
    },
    meta: {
      title: '京麦'
    }
  }, {
    path: '/train/FBT/doudian',
    name: 'fbtDoudian',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1731));
      });
    },
    meta: {
      title: '抖店'
    }
  }, {
    path: '/train/FBT/doudianExam',
    name: 'fbtDoudianExam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1735));
      });
    },
    meta: {
      title: '抖店'
    }
  }, {
    path: '/train/FBT/doudianChat',
    name: 'fbtDoudianChat',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1739));
      });
    },
    meta: {
      title: '抖店'
    }
  }, {
    path: '/train/FBT/trainResult',
    name: 'fbtTrainResult',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(__webpack_require__(1757));
      });
    },
    meta: {
      title: '实操结果'
    }
  }]
});
var originalPush = _vueRouter.default.prototype.push;
_vueRouter.default.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

/***/ }),
/* 1083 */,
/* 1084 */,
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a1368e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courseList_vue__ = __webpack_require__(1086);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a1368e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courseList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/courseList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8a1368e0", Component.options)
  } else {
    hotAPI.reload("data-v-8a1368e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "classRoom" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "classify", attrs: { id: "type" } }, [
          _c("p", [_vm._v("分类：")]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _c(
                "li",
                {
                  staticClass: "buxian active",
                  on: {
                    click: function($event) {
                      return _vm.queryListByType("", 0)
                    }
                  }
                },
                [_vm._v("不限")]
              ),
              _vm._v(" "),
              _vm._l(_vm.list, function(lists, key) {
                return _c(
                  "li",
                  {
                    attrs: { title: lists.categoryName },
                    on: {
                      click: function($event) {
                        return _vm.queryListByType(lists.categoryId, key + 1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(lists.categoryName))]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "classify", attrs: { id: "genre" } }, [
          _c("p", [_vm._v("类别：")]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _c(
                "li",
                {
                  staticClass: "buxian active",
                  on: {
                    click: function($event) {
                      return _vm.queryListByCategory("", 0)
                    }
                  }
                },
                [_vm._v("不限")]
              ),
              _vm._v(" "),
              _vm._l(_vm.children, function(childrens, key) {
                return _c(
                  "li",
                  {
                    attrs: { title: childrens.categoryName },
                    on: {
                      click: function($event) {
                        return _vm.queryListByCategory(
                          childrens.categoryId,
                          key + 1
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(childrens.categoryName))]
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "room-text" },
        [
          !_vm.success
            ? _c("p", { staticClass: "tj-shift-notice" }, [
                _vm._v(_vm._s(_vm.message))
              ])
            : !_vm.categoryList.length
            ? [
                _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录")
                ])
              ]
            : [
                _c(
                  "ul",
                  { staticClass: "clear" },
                  _vm._l(_vm.categoryList, function(list) {
                    return _c("li", [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "tj-link-blue tj-inblock",
                              attrs: {
                                to: {
                                  name: "courseDetail",
                                  params: { id: list.courseId }
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "zoomImage",
                                style: _vm.style(list.iconUrl)
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "text" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "title",
                                    attrs: { title: list.courseName }
                                  },
                                  [_vm._v(_vm._s(list.courseName))]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _c(
                                    "span",
                                    { staticClass: "iconfont icon-yuyue1" },
                                    [
                                      _c("i", [
                                        _vm._v(_vm._s(list.lessonPeriod))
                                      ]),
                                      _vm._v("学时")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "iconfont icon-people",
                                      attrs: {
                                        title:
                                          "已有" + list.totalUserNum + "人学习"
                                      }
                                    },
                                    [
                                      _vm._v("已有"),
                                      _c("i", [
                                        _vm._v(_vm._s(list.totalUserNum))
                                      ]),
                                      _vm._v("人学习")
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("pagination", {
                  attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
                  on: { getData: _vm.courselist }
                })
              ]
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "study" }, [
        _c("h2", [_vm._v("学习排行榜")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.info, function(infos, key) {
            return _c("li", [
              _c(
                "div",
                {
                  staticClass: "num",
                  class: {
                    one: infos.rank === 1,
                    two: infos.rank === 2,
                    three: infos.rank === 3
                  }
                },
                [_vm._v(_vm._s(infos.rank))]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(infos.loginName))]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(infos.totalStudyTime) + "学时")])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a1368e0", esExports)
  }
}

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1088);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("158465fb", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b1dbe7d8\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./video.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b1dbe7d8\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./video.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.container{\n    width: 100%;\n    padding: 0;\n}\n.__cov-video-container {\n    position: relative;\n    width: 100%;\n    background-color: #000;\n}\n.__cov-video {\n    width: 100%;\n    height: 100%;\n    vertical-align: bottom;\n}\n.__cov-contrl-content {\n    position: absolute;\n    display: flex;\n    left: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.41);\n    height: 2rem;\n    width: 100%;\n    z-index: 2147483647;\n}\n.__cov-contrl-play-btn {\n    position: relative;\n    height: 100%;\n    background: none;\n    border: none;\n    height: 2rem;\n    width: 4rem;\n    outline: none;\n    vertical-align: top;\n}\n.__cov-contrl-play-btn:hover {\n    background-color: rgba(255, 255, 255, 0.27);\n}\n.__cov-contrl-play-btn-icon {\n    position: absolute;\n    height: 1rem;\n    width: 1rem;\n    top: 50%;\n    left: 50%;\n    margin-top: -.5rem;\n    margin-left: -.5rem;\n}\n.__cov-contrl-vol-btn-icon {\n    position: absolute;\n    height: 1.1rem;\n    width: 1.1rem;\n    top: 50%;\n    left: 50%;\n    margin-top: -.55rem;\n    margin-left: -.55rem;\n}\n.__cov-contrl-vol-slider {\n    position: relative;\n    display: inline-block;\n    height: 100%;\n    width: 6rem;\n    height: 2rem;\n    overflow: hidden;\n    transition: all .2s ease-in;\n}\n.__cov-contrl-vol-rail {\n    position: absolute;\n    top: 50%;\n    width: 6rem;\n    height: .1rem;\n    margin-top: -.05rem;\n    background: #fff;\n}\n.__cov-contrl-vol-inner {\n    position: absolute;\n    display: inline-block;\n    left: 0;\n    top: 50%;\n    background: #fff;\n    width: .5rem;\n    height: .5rem;\n    border-radius: 50%;\n    margin-top: -.25rem;\n    z-index: 2;\n    cursor: pointer;\n}\n.__cov-contrl-vol-box {\n    display: flex;\n}\n.__cov-contrl-video-slider {\n    position: relative;\n    display: inline-block;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    margin: 0 .5rem;\n    transition: all .2s ease-in;\n}\n.__cov-contrl-video-rail {\n    position: absolute;\n    top: 50%;\n    width: 100%;\n    height: .1rem;\n    margin-top: -.05rem;\n    background: rgba(255, 255, 255, 0.5);\n    overflow: hidden;\n}\n.__cov-contrl-video-rail-inner {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: .1rem;\n    background: rgb(255, 255, 255);\n    transition: transform .2s;\n}\n.__cov-contrl-video-inner {\n    position: absolute;\n    display: inline-block;\n    left: 0;\n    top: 50%;\n    background: #fff;\n    width: .5rem;\n    height: .5rem;\n    border-radius: 50%;\n    margin-top: -.25rem;\n    z-index: 2;\n    cursor: pointer;\n    transition: all 16ms;\n}\n.__cov-contrl-video-time {\n    padding: 0 1rem;\n}\n.__cov-contrl-video-time-text {\n    color: #fff;\n    line-height: 2rem;\n    font-size: .8rem;\n}\n::-webkit-media-controls {\n  display:none !important;\n}\nvideo::-webkit-media-controls {\n  display:none !important;\n}\nvideo::-webkit-media-controls-enclosure {\n  display:none !important;\n}\n.fade-transition {\n    transition: opacity .3s ease;\n}\n.fade-enter{\n    opacity: 1;\n}\n.fade-leave {\n    opacity: 0;\n}\n.hide-cursor {\n    cursor: none;\n}\n@media all and (max-width: 768px) {\n.__cov-contrl-vol-slider {\n        width: 3rem;\n}\n.__cov-contrl-video-time {\n        padding: 0 .2rem;\n}\n.__cov-contrl-vol-box .__cov-contrl-play-btn {\n        width: 2rem;\n}\n}\n", ""]);

// exports


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass: "__cov-video-container",
          on: {
            mouseenter: _vm.mouseEnterVideo,
            mouseleave: _vm.mouseLeaveVideo
          }
        },
        [
          _c(
            "video",
            {
              staticClass: "__cov-video",
              class: { "hide-cursor": !_vm.state.contrlShow },
              attrs: { poster: _vm.options.poster, src: _vm.poster }
            },
            _vm._l(_vm.sources, function(source) {
              return _c("source", {
                attrs: { src: source.src, type: source.type }
              })
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state.contrlShow,
                  expression: "state.contrlShow"
                }
              ],
              staticClass: "__cov-contrl-content",
              attrs: { transition: "fade" }
            },
            [
              _c(
                "button",
                {
                  staticClass: "__cov-contrl-play-btn",
                  on: { click: _vm.play }
                },
                [
                  _c(
                    "svg",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.state.playing,
                          expression: "!state.playing"
                        }
                      ],
                      staticClass: "__cov-contrl-play-btn-icon",
                      attrs: {
                        viewBox: "0 0 47 57",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("title", [_vm._v("Triangle 1")]),
                      _vm._v(" "),
                      _c("desc", [_vm._v("Created with Sketch.")]),
                      _vm._v(" "),
                      _c("defs"),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Page-1",
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd"
                          }
                        },
                        [
                          _c("polygon", {
                            attrs: {
                              id: "Triangle-1",
                              stroke: "#FFFFFF",
                              fill: "#FFFFFF",
                              points: "1 56 1 1 47 28.5"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.state.playing,
                          expression: "state.playing"
                        }
                      ],
                      staticClass: "__cov-contrl-play-btn-icon",
                      attrs: {
                        viewBox: "0 0 15 22",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("title", [_vm._v("Combined Shape")]),
                      _vm._v(" "),
                      _c("desc", [_vm._v("Created with Sketch.")]),
                      _vm._v(" "),
                      _c("defs", [
                        _c("path", {
                          attrs: {
                            d:
                              "M0,0.979149244 L5,0.979149244 L5,22 L0,22 L0,0.979149244 Z M10,0.979149244 L15,0.979149244 L15,22 L10,22 L10,0.979149244 Z",
                            id: "path-1"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "mask",
                          {
                            attrs: {
                              id: "mask-2",
                              maskContentUnits: "userSpaceOnUse",
                              maskUnits: "objectBoundingBox",
                              x: "0",
                              y: "0",
                              width: "15",
                              height: "21.0208508",
                              fill: "white"
                            }
                          },
                          [_c("use", { attrs: { "xlink:href": "#path-1" } })]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Page-1",
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd"
                          }
                        },
                        [
                          _c("use", {
                            attrs: {
                              id: "Combined-Shape",
                              stroke: "#FFFFFF",
                              mask: "url(#mask-2)",
                              "stroke-width": "2",
                              fill: "#FFFFFF",
                              "xlink:href": "#path-1"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "__cov-contrl-video-slider",
                  on: { click: _vm.slideClick, mousedown: _vm.videoMove }
                },
                [
                  _c("div", {
                    staticClass: "__cov-contrl-video-inner",
                    style: {
                      transform:
                        "translate3d(" + _vm.video.pos.current + "px, 0, 0)"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "__cov-contrl-video-rail" }, [
                    _c("div", {
                      staticClass: "__cov-contrl-video-rail-inner",
                      style: {
                        transform:
                          "translate3d(" + _vm.video.loaded + "%, 0, 0)"
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "__cov-contrl-video-time" }, [
                _c("span", { staticClass: "__cov-contrl-video-time-text" }, [
                  _vm._v(_vm._s(_vm.video.displayTime))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "__cov-contrl-vol-box" }, [
                _c(
                  "button",
                  {
                    staticClass: "__cov-contrl-play-btn",
                    on: { click: _vm.volMuted }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "__cov-contrl-vol-btn-icon",
                        attrs: {
                          viewBox: "0 0 41 44",
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink"
                        }
                      },
                      [
                        _c("title", [_vm._v("vol")]),
                        _vm._v(" "),
                        _c("desc", [_vm._v("Created with Sketch.")]),
                        _vm._v(" "),
                        _c("defs", [
                          _c("path", {
                            attrs: {
                              d:
                                "M8.61522369,12 L20,0.615223689 L20,37.3847763 L8.61522369,26 L1.99201702,26 C0.891856397,26 0,25.1029399 0,23.9941413 L0,14.0058587 C0,12.8980535 0.900176167,12 1.99201702,12 L8.61522369,12 L8.61522369,12 Z",
                              id: "cov-vol"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "Page-1",
                              stroke: "none",
                              "stroke-width": "2",
                              fill: "none",
                              "fill-rule": "evenodd"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "vol",
                                  transform: "translate(2.000000, 3.000000)"
                                }
                              },
                              [
                                _c("g", { attrs: { id: "cov-vol-icon" } }, [
                                  _c(
                                    "g",
                                    { attrs: { id: "Combined-Shape-Clipped" } },
                                    [
                                      _c("path", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.volume.percent > 1 &&
                                              !_vm.volume.muted,
                                            expression:
                                              "volume.percent > 1 && !volume.muted"
                                          }
                                        ],
                                        attrs: {
                                          d:
                                            "M25,29.5538997 C28.4589093,27.6757536 31.2629093,23.2984641 31.2629093,19.7769499 C31.2629093,16.2554357 28.4589093,11.8781461 25,10",
                                          id: "vol-range-2",
                                          stroke: "#FFFFFF"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.volume.percent > 70 &&
                                              !_vm.volume.muted,
                                            expression:
                                              "volume.percent > 70 && !volume.muted"
                                          }
                                        ],
                                        attrs: {
                                          d:
                                            "M28,35.5538997 C33.5816016,32.5231573 38.1063837,25.4595762 38.1063837,19.7769499 C38.1063837,14.0943235 33.5816016,7.03074247 28,4",
                                          id: "vol-range-2",
                                          stroke: "#FFFFFF"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "mask",
                                        {
                                          attrs: { id: "mask-2", fill: "white" }
                                        },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#cov-vol" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("use", {
                                        attrs: {
                                          id: "vol-path",
                                          stroke: "#FFFFFF",
                                          "stroke-width": "3",
                                          "xlink:href": "#cov-vol"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Combined-Shape",
                                            mask: "url(#mask-2)",
                                            stroke: "#FFFFFF",
                                            "stroke-width": "2",
                                            fill: "#FFFFFF"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M8.61522369,12 L20,0.615223689 L20,37.3847763 L8.61522369,26 L1.99201702,26 C0.891856397,26 0,25.1029399 0,23.9941413 L0,14.0058587 C0,12.8980535 0.900176167,12 1.99201702,12 L8.61522369,12 L8.61522369,12 Z",
                                              id: "cov-vol"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "__cov-contrl-vol-slider",
                    on: { click: _vm.volSlideClick, mousedown: _vm.volMove }
                  },
                  [
                    _c("div", {
                      staticClass: "__cov-contrl-vol-inner",
                      style: {
                        transform:
                          "translate3d(" + _vm.volume.pos.current + "px, 0, 0)"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "__cov-contrl-vol-rail" })
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "__cov-contrl-play-btn",
                  on: { click: _vm.fullScreen }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "__cov-contrl-vol-btn-icon",
                      attrs: {
                        viewBox: "0 0 33 33",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink"
                      }
                    },
                    [
                      _c("defs"),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Page-1",
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M31.1682064,22 L31.1682064,31.0073537 L22,31.0073537 M22,1 L31.0073537,1 L31.0073537,10.1682064 M1,10.0073537 L1,1 L10.1682064,1 M10.0073537,31.1682064 L1,31.1682064 L1,22",
                              id: "Combined-Shape",
                              stroke: "#FFFFFF",
                              "stroke-width": "2"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1dbe7d8", esExports)
  }
}

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signContract_vue__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signContract_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signContract_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signContract_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signContract_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14266934_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signContract_vue__ = __webpack_require__(1103);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1091)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signContract_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14266934_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signContract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/signContract.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14266934", Component.options)
  } else {
    hotAPI.reload("data-v-14266934", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1092);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ef03d212", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14266934\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./signContract.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14266934\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./signContract.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.container{\n    width: min(100%, 800px);\n    margin: auto;\n    padding: 1px;\n}\n.form-box {\n    width: 500px;\n    margin: 50px auto;\n}\n.protocol-box {\nimg {\n        display: block;\n        max-width: 100%;\n        margin: auto;\n}\n.btns {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 50px;\n}\n}\n.box {\n    margin-top: -20px;\n    border: 1px solid #ccc;\n}\n", ""]);

// exports


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vueEsign_vue__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vueEsign_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vueEsign_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vueEsign_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vueEsign_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2066fbcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vueEsign_vue__ = __webpack_require__(1099);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1094)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2066fbcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vueEsign_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2066fbcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vueEsign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/vueEsign.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2066fbcc", Component.options)
  } else {
    hotAPI.reload("data-v-2066fbcc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1095);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5f20d430", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2066fbcc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./vueEsign.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2066fbcc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./vueEsign.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\ncanvas[data-v-2066fbcc] {\n  max-width: 100%;\n  display: block;\n}\n", ""]);

// exports


/***/ }),
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("canvas", {
    ref: "canvas",
    on: {
      mousedown: _vm.mouseDown,
      mousemove: _vm.mouseMove,
      mouseup: _vm.mouseUp,
      touchstart: _vm.touchStart,
      touchmove: _vm.touchMove,
      touchend: _vm.touchEnd
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2066fbcc", esExports)
  }
}

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iTaojinAppUtil = void 0;
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1101));
var _createClass2 = _interopRequireDefault(__webpack_require__(1102));
var iTaojinAppUtil = exports.iTaojinAppUtil = /*#__PURE__*/function () {
  function iTaojinAppUtil() {
    (0, _classCallCheck2.default)(this, iTaojinAppUtil);
  }
  return (0, _createClass2.default)(iTaojinAppUtil, null, [{
    key: "getPhoneOS",
    value: function getPhoneOS() {
      var u = navigator.userAgent,
        isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
        isHarmonyOS = u.indexOf('ArkWeb') > -1 || u.indexOf('HarmonyOS') > -1;
      if (isAndroid) {
        return 'android';
      }
      if (isHarmonyOS) {
        return 'harmonyos';
      }
      if (/(iPhone|iPad|iPod|iOS)/i.test(u)) {
        return 'ios';
      }
    }
  }, {
    key: "getAppInterface",
    value: function getAppInterface() {
      var phoneOS = this.getPhoneOS();
      var key = this.keys[phoneOS];
      if (phoneOS == 'android') {
        return window[key];
      }
      if (phoneOS == 'harmonyos') {
        return window[key];
      }
      if (phoneOS == 'ios') {
        return window["webkit"].messageHandlers[key];
      }
    }
    /**
    * @param funName 需要调用的原生方法名称
    * @param funParams 需传递的参数
    */
  }, {
    key: "callNativeFun",
    value: function callNativeFun(funName, funParams) {
      try {
        var native = this.getAppInterface();
        var phoneOS = this.getPhoneOS();
        if (!native || !phoneOS) return {
          result: false,
          data: null
        };
        var data = null;
        if (phoneOS == 'android') {
          if (funParams) {
            data = native[funName](JSON.stringify(funParams));
          } else {
            data = native[funName]();
          }
        }
        if (phoneOS == 'harmonyos') {
          if (funParams) {
            data = native[funName](JSON.stringify(funParams));
          } else {
            data = native[funName]();
          }
        }
        if (phoneOS == 'ios') {
          if (funParams) {
            native.postMessage({
              methods: funName,
              params: funParams
            });
          } else {
            native.postMessage({
              methods: funName
            });
          }
        }
        return {
          result: true,
          data: data
        };
      } catch (e) {
        return {
          result: false,
          data: null
        };
      }
    }
  }]);
}();
iTaojinAppUtil.keys = {
  "android": 'iTaojinAndroidInterface',
  "ios": 'iTaojinIosInterface',
  "harmonyos": 'iTaojinHarmonyInterface'
};

/***/ }),
/* 1101 */,
/* 1102 */,
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.step === 0
        ? _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "form-box",
              attrs: { model: _vm.form, "label-width": "150px" }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "个人姓名：",
                    prop: "realName",
                    rules: [
                      {
                        required: true,
                        message: "请输入个人姓名",
                        trigger: "blur"
                      }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.realName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "realName", $$v)
                      },
                      expression: "form.realName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "身份证号码：",
                    prop: "idcardNo",
                    rules: [
                      {
                        required: true,
                        message: "请输入身份证号码",
                        trigger: "blur"
                      }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.idcardNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "idcardNo", $$v)
                      },
                      expression: "form.idcardNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "联系电话：",
                    prop: "phone",
                    rules: [
                      {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur"
                      }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "联系地址：",
                    prop: "address",
                    rules: [
                      {
                        required: true,
                        message: "请输入联系地址",
                        trigger: "blur"
                      }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.address,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.type === "food"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "智恒小程序用户ID：",
                        prop: "address",
                        rules: [
                          {
                            required: true,
                            message: "请输入智恒小程序用户ID",
                            trigger: "blur"
                          }
                        ]
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.appletUserId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "appletUserId", $$v)
                          },
                          expression: "form.appletUserId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.nextStep } },
                    [_vm._v("下一步")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.step === 1
        ? _c("div", { staticClass: "protocol-box" }, [
            _vm.type === "food"
              ? _c("img", {
                  attrs: {
                    src:
                      "https://res.study.itaojin.cn/2024-12/a2db0178b91242aa95dccc40e7bea392.png",
                    alt: ""
                  }
                })
              : _c("img", {
                  attrs: {
                    src:
                      "https://res.study.itaojin.cn/2024-12/43abc179e17f495fbc5470878567ac8d.png",
                    alt: ""
                  }
                }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btns" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.step = _vm.step - 1
                      }
                    }
                  },
                  [_vm._v("上一步")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: !!_vm.countdown },
                    on: { click: _vm.signContract }
                  },
                  [
                    _c("span", [_vm._v("去签名")]),
                    _vm._v(" "),
                    _vm.countdown
                      ? _c("span", [_vm._v("(" + _vm._s(_vm.countdown) + "s)")])
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        : _vm.step === 2
        ? _c("div", { staticClass: "protocol-box" }, [
            _c("img", { attrs: { src: _vm.dealUrl, alt: "" } }),
            _vm._v(" "),
            _vm.$route.query.admin
              ? _c(
                  "div",
                  { staticClass: "btns" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.step = 0
                          }
                        }
                      },
                      [_vm._v("修 改")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请签名",
            visible: _vm.dialogObj.visible,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialogObj, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "box" },
            [
              _c("vue-esign", {
                ref: "esign",
                attrs: {
                  width: 458,
                  height: 260,
                  isCrop: false,
                  lineWidth: 3,
                  lineColor: "#000"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重 写")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.submitFun }
                },
                [_vm._v("提交签名")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14266934", esExports)
  }
}

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseDetail_vue__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bff997a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courseDetail_vue__ = __webpack_require__(1108);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bff997a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courseDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/courseDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7bff997a", Component.options)
  } else {
    hotAPI.reload("data-v-7bff997a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABMklEQVQ4je2UTytFQRjGf4ezlYU/WSgslLrx3oXYmI24CB/AyheYT2I9G2VtayWlGzKysJu7kKIQS6S7drG4r4yce51yNspT0zPzNPNr5m16E+PCIJBSkFLgBBgqCthRFOgf+EV3QADqUfYI3AIvUXau+34EbnsrZWAzyla9lWFgV9d1YAJYzwNcUD9WfwLOdH6kfuitNIDlPMCycaGf5v98A/a9lYZxoSsCVtVX8gAB5r2VZ6AG7BkXeoE1XT8AVc2m8wLjZx8Ai8Cst/IK7HgrF8BS1vmWNzQuJMCWt3L/AdRsQ/d8q1874AAw7q3UjAudCuwDSt7KlXEh1Sw3EKCiPgX06HxOfQbozjqUGBduyO421zRrOMZn8S+BU6AETGYB2/XBER2xRnW01N9sDr/SO9rLTRzpG0fcAAAAAElFTkSuQmCC"

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAAyElEQVQ4jdXTsUoDQRDG8Z9ykOawSSMI4QxY2icgBKvkAex9gbyDrQ9hoUWsUwbS5CmutjaVYCFCiIWLKGHvuGMD8YOBWWbmz+zM7tF2aoCJNPrIMMBdIuDbcSLQjw4fmFXElnj+dc7RxRjDWFFVhyUWKIKd4AXXeGrTIZzafQF93OO2aYcxXWAdCzYFvuMRV7GEuiuXOA/+J15xiXlbYA8Pwe/4nmlRVVAHzDGqyfmj//1TblRssw3wLFgjHf4M97KUGVaJeJsvkBIXCXyc1y4AAAAASUVORK5CYII="

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pages
    ? _c(
        "div",
        { staticClass: "C_pagination js-pager" },
        [
          !_vm.prePage
            ? [
                _c(
                  "a",
                  {
                    staticClass: "start disabled",
                    attrs: { href: "javascript:;" }
                  },
                  [_vm._v("首页")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "prev disabled",
                    attrs: { href: "javascript:;" }
                  },
                  [_vm._v("上一页")]
                )
              ]
            : [
                _c(
                  "a",
                  {
                    staticClass: "start",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        return _vm.pageOffset(1)
                      }
                    }
                  },
                  [_vm._v("首页")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "prev",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm.goPrePage }
                  },
                  [_vm._v("上一页")]
                )
              ],
          _vm._v(" "),
          _vm._l(_vm.showPageBtn, function(i) {
            return [
              i
                ? _c(
                    "a",
                    {
                      class: i === _vm.pageNum ? "disabled current" : "",
                      on: {
                        click: function($event) {
                          return _vm.pageOffset(i)
                        }
                      }
                    },
                    [_vm._v(_vm._s(i))]
                  )
                : _c("span", [_vm._v("···")])
            ]
          }),
          _vm._v(" "),
          !_vm.nextPage
            ? [
                _c(
                  "a",
                  {
                    staticClass: "next disabled",
                    attrs: { href: "javascript:;" }
                  },
                  [_vm._v("下一页")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "end disabled",
                    attrs: { href: "javascript:;" }
                  },
                  [_vm._v("尾页")]
                )
              ]
            : [
                _c(
                  "a",
                  {
                    staticClass: "next",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm.goNextPage }
                  },
                  [_vm._v("下一页")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "end",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        return _vm.pageOffset(_vm.pages)
                      }
                    }
                  },
                  [_vm._v("尾页")]
                )
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d27aeac", esExports)
  }
}

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/courseList" } },
        [_vm._v("培训课程")]
      ),
      _vm._v(">"),
      _c("span", [_vm._v(_vm._s(_vm.courseDetail.courseName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "left leftcour" }, [
        _c("div", { staticClass: "details-box clear" }, [
          _c("div", {
            staticClass: "zoomImage",
            style: _vm.style(_vm.courseDetail.iconUrl)
          }),
          _vm._v(" "),
          _c("div", { staticClass: "txt txt-over course-txt" }, [
            _c("h2", [_vm._v(_vm._s(_vm.courseDetail.courseName))]),
            _vm._v(" "),
            _c("div", { staticClass: "iconfont icon-yuyue1 text-float" }, [
              _c("span", [
                _c("i", [_vm._v(_vm._s(_vm.courseDetail.lessonPeriod))]),
                _vm._v("学时")
              ]),
              _c("span", [_vm._v("|")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "iconfont icon-people text-float" }, [
              _c("span", [
                _vm._v("已有"),
                _c("i", [_vm._v(_vm._s(_vm.courseDetail.totalUserNum))]),
                _vm._v("人学习")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "join",
                on: {
                  click: function($event) {
                    return _vm.startStudyCourse()
                  }
                }
              },
              [
                _vm._v("立即学习"),
                _vm.courseDetail.isDone == "yes" ? [_vm._v("(已学)")] : _vm._e()
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "present", attrs: { id: "present" } }, [
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.courseDetail.description) }
            })
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "top-head", attrs: { href: "javascript:;" } },
            [_vm._v("课程目录")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "catalog", attrs: { id: "catalog" } }, [
            _c(
              "ul",
              _vm._l(_vm.materialList, function(m, key) {
                return _c(
                  "li",
                  {
                    class: { active: (key + 1) % 2 },
                    on: {
                      click: function($event) {
                        return _vm.studyCourse(
                          m.materialId,
                          m.courseId,
                          _vm.courseDetail.courseName
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "order" }, [
                      _vm._v(_vm._s(key + 1) + "、")
                    ]),
                    _c("img", {
                      staticClass: "resType",
                      attrs: { src: m.resTypeUrl }
                    }),
                    _c("span", [_vm._v(_vm._s(m.catalogName))]),
                    m.duration != null
                      ? _c("time", [
                          _vm._v(
                            "(" + _vm._s(_vm.formatSeconds(m.duration)) + ")"
                          )
                        ])
                      : _vm._e(),
                    m.isDone == "yes"
                      ? _c("div", { staticClass: "complete" }, [
                          _vm._v("已完成")
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("h4", { attrs: { title: "学习该课程的学员" + _vm.keys } }, [
          _vm._v("学习该课程的学员（" + _vm._s(_vm.keys) + "）")
        ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.info, function(infos) {
            return _c("li", [
              _c("img", {
                staticClass: "head",
                attrs: { src: infos.userIcon }
              }),
              _vm._v(" "),
              _c("p", { attrs: { title: infos.loginName } }, [
                _vm._v(_vm._s(infos.loginName))
              ])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cat-head" }, [
      _c("a", { staticClass: "active", attrs: { href: "#present" } }, [
        _vm._v("课程介绍")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "#catalog" } }, [_vm._v("课程目录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bff997a", esExports)
  }
}

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b562d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_vue__ = __webpack_require__(1110);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_course_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b562d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_course_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/course.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32b562d2", Component.options)
  } else {
    hotAPI.reload("data-v-32b562d2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "course" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/courseList" } },
        [_vm._v("培训课程")]
      ),
      _vm._v(">\n    "),
      _c(
        "a",
        {
          staticClass: "active",
          attrs: { href: "/tjkStudy/courseDetail/" + _vm.test.courseId }
        },
        [_vm._v(_vm._s(_vm.courseName))]
      ),
      _vm._v(">\n    "),
      _c("span", [_vm._v(_vm._s(_vm.test.catalogName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "video" }, [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.test.catalogName))]),
          _vm._v(" "),
          _c("component1", { attrs: { poster: _vm.poster, id: "component" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "pdf_viewer" } })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "catalog" }, [_vm._v("课程目录")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.List, function(lists, key) {
            return _c(
              "li",
              {
                class: { bg: (key + 1) % 2 },
                on: {
                  click: function($event) {
                    return _vm.MaterialDetail(lists.materialId)
                  }
                }
              },
              [
                _c("p", [
                  _vm._v(_vm._s(key + 1) + "、" + _vm._s(lists.catalogName))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  [
                    lists.duration != null
                      ? [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.formatSeconds(lists.duration)) +
                              ")"
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "resType",
                      attrs: { src: _vm.img[0].src }
                    })
                  ],
                  2
                )
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32b562d2", esExports)
  }
}

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examList_vue__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_210fdb54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examList_vue__ = __webpack_require__(1112);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_210fdb54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/examList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-210fdb54", Component.options)
  } else {
    hotAPI.reload("data-v-210fdb54", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "examRoom" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "classify", attrs: { id: "type" } }, [
          _c("p", [_vm._v("分类：")]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _c(
                "li",
                {
                  staticClass: "active",
                  on: {
                    click: function($event) {
                      return _vm.queryListByType("", 0)
                    }
                  }
                },
                [_vm._v("不限")]
              ),
              _vm._v(" "),
              _vm._l(_vm.examTypeList, function(t, key) {
                return _c(
                  "li",
                  {
                    attrs: { title: t.label },
                    on: {
                      click: function($event) {
                        return _vm.queryListByType(t.value, key + 1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(t.label))]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "classify", attrs: { id: "category" } }, [
          _c("p", [_vm._v("类别：")]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _c(
                "li",
                {
                  staticClass: "active",
                  on: {
                    click: function($event) {
                      return _vm.queryListByCategory("", 0)
                    }
                  }
                },
                [_vm._v("不限")]
              ),
              _vm._v(" "),
              _vm._l(_vm.categorylist, function(l, key) {
                return _c(
                  "li",
                  {
                    attrs: { title: l.name },
                    on: {
                      click: function($event) {
                        return _vm.queryListByCategory(l.id, key + 1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(l.name))]
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "room-text" },
        [
          !_vm.success
            ? _c("p", { staticClass: "tj-shift-notice" }, [
                _vm._v(_vm._s(_vm.message))
              ])
            : !_vm.examlist.length
            ? [
                _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录")
                ])
              ]
            : [
                _c(
                  "ul",
                  { staticClass: "clear" },
                  _vm._l(_vm.examlist, function(e) {
                    return _c("li", [
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "tj-link-blue tj-inblock",
                              attrs: {
                                to: {
                                  name: "examDetail",
                                  params: { id: e.examConfigId }
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "zoomImage",
                                style: _vm.style(e.examConfig.iconUrl)
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "text" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "title",
                                    attrs: { title: e.examConfig.name }
                                  },
                                  [_vm._v(_vm._s(e.examConfig.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    e.examConfig.examType == "Formal"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "formal",
                                              attrs: { title: "正式考试" }
                                            },
                                            [_vm._v("正")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "iconfont icon-people"
                                            },
                                            [
                                              e.examConfig.registerNum != null
                                                ? [
                                                    _vm._v("已有"),
                                                    _c("i", [
                                                      _vm._v(
                                                        _vm._s(
                                                          e.examConfig
                                                            .registerNum
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v("人报名")
                                                  ]
                                                : [
                                                    _vm._v("已有"),
                                                    _c("i", [_vm._v("0")]),
                                                    _vm._v("人报名")
                                                  ]
                                            ],
                                            2
                                          )
                                        ]
                                      : e.examConfig.examType == "Practice"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "practice",
                                              attrs: {
                                                title: "模拟练习，可多次练习"
                                              }
                                            },
                                            [_vm._v("练")]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("pagination", {
                  attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
                  on: { getData: _vm.getList }
                })
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-210fdb54", esExports)
  }
}

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exam_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e757496_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exam_vue__ = __webpack_require__(1117);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e757496_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/exam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e757496", Component.options)
  } else {
    hotAPI.reload("data-v-7e757496", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4e400b6d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d4f9910\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./zoomImg.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d4f9910\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./zoomImg.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*动画*/\n.fade-enter-active[data-v-6d4f9910],\n.fade-leave-active[data-v-6d4f9910] {\n    transition: all .2s linear;\n    transform: translate3D(0, 0, 0);\n}\n.fade-enter[data-v-6d4f9910],\n.fade-leave-active[data-v-6d4f9910] {\n    transform: translate3D(100%, 0, 0);\n}\n\n\n/* bigimg */\n.img-view[data-v-6d4f9910] {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    z-index: 99;\n}\n\n/*遮罩层样式*/\n.img-view .img-layer[data-v-6d4f9910] {\n    position: fixed;\n    z-index: 999;\n    top: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.7);\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n/*不限制图片大小，实现居中*/\n.img-view .img img[data-v-6d4f9910] {\n    max-width: 50vh;\n    /* 原参数为100% */\n    display: block;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    z-index: 1000;\n}\n", ""]);

// exports


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "img-view", on: { click: _vm.bigImg } }, [
      _c("div", { staticClass: "img-layer" }),
      _vm._v(" "),
      _c("div", { staticClass: "img" }, [
        _c("img", { attrs: { src: _vm.imgSrc } })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d4f9910", esExports)
  }
}

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c(
          "a",
          { staticClass: "active", attrs: { href: "/tjkStudy/examlist" } },
          [_vm._v("考试中心")]
        ),
        _vm._v(">"),
        _c("span", [_vm._v(_vm._s(_vm.data.examName))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "exam-con" }, [
          _c("h2", [_vm._v(_vm._s(_vm.data.examName))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.paperQuestion, function(l, key) {
                return [
                  _c(
                    "div",
                    { staticClass: "type" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.getNum(key)) +
                              "、" +
                              _vm._s(l.questionGroupTittle) +
                              "（共" +
                              _vm._s(l.questionDetailList.length) +
                              "题）共" +
                              _vm._s(l.totalScore) +
                              "分"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(l.questionDetailList, function(q, index) {
                        return _c(
                          "div",
                          { staticClass: "list" },
                          [
                            q.question
                              ? [
                                  q.questionType == "BlankFilling"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.question.questionContent
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.question
                                                            .questionContent
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.question.questionContent.questionStem.length - 1"
                                                      }
                                                    ],
                                                    attrs: {
                                                      placeholder: "请输入答案"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "savelist[key][index].tjkAnswerString[k]"
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : q.questionType == "BlankChoice"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.question.questionContent
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.question
                                                            .questionContent
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.question.questionContent.questionStem.length - 1"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString[k],
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString[k]"
                                                      }
                                                    ],
                                                    staticClass: "answer-input",
                                                    attrs: {
                                                      type: "text",
                                                      size: "1",
                                                      maxlength: "1",
                                                      placeholder: "请输入答案"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k]
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、"
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.replaceNToBr(
                                                    q.question.questionContent
                                                      .questionStemString
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                  _vm._v(" "),
                                  q.question.questionContent.imageUrlList
                                    ? _c(
                                        "p",
                                        [
                                          _vm._l(
                                            q.question.questionContent
                                              .imageUrlList,
                                            function(i) {
                                              return [
                                                i != ""
                                                  ? _c("img", {
                                                      staticClass: "s-img",
                                                      attrs: { src: i },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.clickImg(
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  q.questionType == "SingleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.question.questionContent.choices,
                                            function(value, k) {
                                              return _c(
                                                "p",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: { label: k },
                                                      model: {
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.savelist[key][
                                                              index
                                                            ],
                                                            "tjkAnswerString",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(k) +
                                                          "、" +
                                                          _vm._s(value)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.questionType == "MultipleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              _vm._l(
                                                q.question.questionContent
                                                  .choices,
                                                function(value, k) {
                                                  return _c(
                                                    "p",
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        { attrs: { label: k } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(k) +
                                                              "、" +
                                                              _vm._s(value)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.questionType == "TrueOrFalse"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: true }
                                                      },
                                                      [_vm._v("正确")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: false }
                                                      },
                                                      [_vm._v("错误")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.questionType == "BlankChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.question.questionContent.choices,
                                            function(value, k) {
                                              return _c("p", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(k) +
                                                      "、" +
                                                      _vm._s(value)
                                                  )
                                                ])
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.questionType == "ShortAnswer"
                                    ? [
                                        _c("div", { staticClass: "answer" }, [
                                          _c("p", [
                                            _vm._v("答案："),
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              ],
                                              staticClass:
                                                "answer-input shortanswer",
                                              domProps: {
                                                value:
                                                  _vm.savelist[key][index]
                                                    .tjkAnswerString
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.savelist[key][index],
                                                    "tjkAnswerString",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ])
                                        ])
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "count" }, [
          _c("h2", [_vm._v("统计")]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", [_vm._v("距自动交卷时间")]),
            _vm._v(" "),
            _c("span", { staticClass: "blue" }, [_vm._v(_vm._s(_vm.time))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v(
                "满分" +
                  _vm._s(_vm.data.totalScore) +
                  "分，" +
                  _vm._s(_vm.data.passScore) +
                  "分及格"
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.list, function(s) {
              return _c(
                "li",
                { class: { active3: _vm.getClass(s.tjkAnswerString) } },
                [
                  _c("a", { attrs: { href: "#" + s.num } }, [
                    _vm._v(_vm._s(s.num))
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn" }, [
            _c("div", { staticClass: "hold", on: { click: _vm.saveExam } }, [
              _vm._v("保存")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submit", on: { click: _vm.submitExam } },
              [_vm._v("提交试卷")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showImg
        ? _c("zoom-img", {
            attrs: { imgSrc: _vm.imgSrc },
            on: { clickit: _vm.viewImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e757496", esExports)
  }
}

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTemp_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTemp_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTemp_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTemp_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbea38ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examTemp_vue__ = __webpack_require__(1123);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTemp_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbea38ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examTemp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/examTemp.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fbea38ec", Component.options)
  } else {
    hotAPI.reload("data-v-fbea38ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v(_vm._s(_vm.data.examName))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "exam-con" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.paperQuestion, function(l, key) {
                return [
                  _c(
                    "div",
                    { staticClass: "type" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.getNum(key)) +
                              "、" +
                              _vm._s(l.questionGroupTittle) +
                              "（共" +
                              _vm._s(l.questionDetailList.length) +
                              "题）共" +
                              _vm._s(l.totalScore) +
                              "分"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(l.questionDetailList, function(q, index) {
                        return _c(
                          "div",
                          { staticClass: "list" },
                          [
                            q.question
                              ? [
                                  q.questionType == "BlankFilling"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.question.questionContent
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.question
                                                            .questionContent
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.question.questionContent.questionStem.length - 1"
                                                      }
                                                    ],
                                                    attrs: {
                                                      placeholder: "请输入答案"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "savelist[key][index].tjkAnswerString[k]"
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : q.questionType == "BlankChoice"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.question.questionContent
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.question
                                                            .questionContent
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.question.questionContent.questionStem.length - 1"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString[k],
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString[k]"
                                                      }
                                                    ],
                                                    staticClass: "answer-input",
                                                    attrs: {
                                                      type: "text",
                                                      size: "1",
                                                      maxlength: "1",
                                                      placeholder: "请输入答案"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k]
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、"
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.replaceNToBr(
                                                    q.question.questionContent
                                                      .questionStemString
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                  _vm._v(" "),
                                  q.question.questionContent.imageUrlList
                                    ? _c(
                                        "p",
                                        [
                                          _vm._l(
                                            q.question.questionContent
                                              .imageUrlList,
                                            function(i) {
                                              return [
                                                i != ""
                                                  ? _c("img", {
                                                      staticClass: "s-img",
                                                      attrs: { src: i },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.clickImg(
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  q.questionType == "SingleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.question.questionContent.choices,
                                            function(value, k) {
                                              return _c(
                                                "p",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: { label: k },
                                                      model: {
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.savelist[key][
                                                              index
                                                            ],
                                                            "tjkAnswerString",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(k) +
                                                          "、" +
                                                          _vm._s(value)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.questionType == "MultipleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              _vm._l(
                                                q.question.questionContent
                                                  .choices,
                                                function(value, k) {
                                                  return _c(
                                                    "p",
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        { attrs: { label: k } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(k) +
                                                              "、" +
                                                              _vm._s(value)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.questionType == "TrueOrFalse"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: true }
                                                      },
                                                      [_vm._v("正确")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: false }
                                                      },
                                                      [_vm._v("错误")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.questionType == "BlankChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.question.questionContent.choices,
                                            function(value, k) {
                                              return _c("p", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(k) +
                                                      "、" +
                                                      _vm._s(value)
                                                  )
                                                ])
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.questionType == "ShortAnswer"
                                    ? [
                                        _c("div", { staticClass: "answer" }, [
                                          _c("p", [
                                            _vm._v("答案："),
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              ],
                                              staticClass:
                                                "answer-input shortanswer",
                                              domProps: {
                                                value:
                                                  _vm.savelist[key][index]
                                                    .tjkAnswerString
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.savelist[key][index],
                                                    "tjkAnswerString",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ])
                                        ])
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "count" }, [
          _c("h2", [_vm._v("统计")]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", [_vm._v("距自动交卷时间")]),
            _vm._v(" "),
            _c("span", { staticClass: "blue" }, [_vm._v(_vm._s(_vm.time))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v(
                "满分" +
                  _vm._s(_vm.data.totalScore) +
                  "分，" +
                  _vm._s(_vm.data.passScore) +
                  "分及格"
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.list, function(s) {
              return _c(
                "li",
                { class: { active3: _vm.getClass(s.tjkAnswerString) } },
                [
                  _c("a", { attrs: { href: "#" + s.num } }, [
                    _vm._v(_vm._s(s.num))
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn" }, [
            _c("div", { staticClass: "hold", on: { click: _vm.saveExam } }, [
              _vm._v("保存")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submit", on: { click: _vm.submitExam } },
              [_vm._v("提交试卷")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showImg
        ? _c("zoom-img", {
            attrs: { imgSrc: _vm.imgSrc },
            on: { clickit: _vm.viewImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbea38ec", esExports)
  }
}

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTyping_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTyping_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTyping_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTyping_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTyping_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c58e7a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examTyping_vue__ = __webpack_require__(1125);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examTyping_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c58e7a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examTyping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/examTyping.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c58e7a6", Component.options)
  } else {
    hotAPI.reload("data-v-1c58e7a6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam typeing" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/examlist" } },
        [_vm._v("考试中心")]
      ),
      _vm._v(">"),
      _c("span", [_vm._v(_vm._s(_vm.data.examName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "exam-con" }, [
        _c("h2", [_vm._v(_vm._s(_vm.data.examName))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content typing-con" },
          [
            _vm._l(_vm.paperlist, function(l, key) {
              return [
                _c("p", {
                  staticClass: "row-con",
                  domProps: { innerHTML: _vm._s(l.lastcontent) }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: l.input,
                      expression: "l.input"
                    }
                  ],
                  staticClass: "typing-input",
                  attrs: { maxlength: l.maxlength, onpaste: "return false" },
                  domProps: { value: l.input },
                  on: {
                    keyup: function($event) {
                      return _vm.computeFun(key, $event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(l, "input", $event.target.value)
                    }
                  }
                })
              ]
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "count" }, [
        _c("h2", [_vm._v("统计")]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", [_vm._v("距自动交卷时间")]),
          _vm._v("jingmai\n        "),
          _c("span", { staticClass: "blue" }, [_vm._v(_vm._s(_vm.time))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", { staticClass: "txt" }, [
            _vm._v("速度：" + _vm._s(_vm.lastspeed) + "字/分")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", { staticClass: "txt" }, [
            _vm._v("正确率：" + _vm._s(_vm.ratio) + "%")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", { staticClass: "txt" }, [
            _vm._v("总字数：" + _vm._s(_vm.totalNum) + "字")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", { staticClass: "txt" }, [
            _vm._v("错误：" + _vm._s(_vm.errorNum) + "字")
          ])
        ]),
        _vm._v(" "),
        _vm.isShowBtn == true
          ? _c("div", { staticClass: "btn" }, [
              _c(
                "div",
                { staticClass: "submit typing", on: { click: _vm.submitExam } },
                [_vm._v("提交试卷")]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c58e7a6", esExports)
  }
}

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f4e207_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examDetail_vue__ = __webpack_require__(1127);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f4e207_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/examDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07f4e207", Component.options)
  } else {
    hotAPI.reload("data-v-07f4e207", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/examlist" } },
        [_vm._v("考试中心")]
      ),
      _vm._v(">"),
      _c("span", [_vm._v(_vm._s(_vm.data.examConfig.name))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "details-box clear" }, [
          _c("div", {
            staticClass: "zoomImage",
            style: _vm.style(_vm.data.examConfig.iconUrl)
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "txt" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.data.examConfig.name))]),
              _vm._v(" "),
              _vm.data.examConfig.examType == "Formal"
                ? [
                    _c("div", { staticClass: "iconfont icon-people" }, [
                      _vm.data.examStastics != null
                        ? _c("span", [
                            _vm._v("已有"),
                            _c("i", [
                              _vm._v(_vm._s(_vm.data.examStastics.registerNum))
                            ]),
                            _vm._v("人报名")
                          ])
                        : _c("span", [
                            _vm._v("已有"),
                            _c("i", [_vm._v("0")]),
                            _vm._v("人报名")
                          ])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "报名时间：" +
                          _vm._s(_vm.data.examConfig.regStartTime) +
                          " ~ " +
                          _vm._s(_vm.data.examConfig.regEndTime)
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "考试时间：" +
                    _vm._s(_vm.data.examConfig.startTime) +
                    " ~ " +
                    _vm._s(_vm.data.examConfig.endTime)
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm.data.examPaper.paperType == "Normal"
                    ? [
                        _c("span", { staticClass: "pr" }, [
                          _vm._v(
                            "总分：" +
                              _vm._s(_vm.data.examPaper.totalScore) +
                              "分"
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _vm._v("及格：" + _vm._s(_vm.data.examConfig.passScore)),
                      _vm.data.examPaper.paperType == "Normal"
                        ? [_vm._v("分")]
                        : [_vm._v("字/分")]
                    ],
                    2
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm.data.highestScoreRecord != null
                ? _c(
                    "p",
                    [
                      _vm._v(
                        "\n              我的最高纪录：" +
                          _vm._s(_vm.data.highestScoreRecord.score)
                      ),
                      _vm.data.examPaper.paperType == "Normal"
                        ? [_vm._v("分")]
                        : [_vm._v("字/分")],
                      _vm._v("("),
                      _vm.data.highestScoreRecord.isPassed == "passed"
                        ? [_vm._v("通过")]
                        : [_vm._v("未通过")],
                      _vm._v(")\n            ")
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.data.examState == "WaitingRegister"
                ? _c("div", { staticClass: "join" }, [_vm._v("报名未开始")])
                : _vm.data.examState == "WaitingCheckState"
                ? _c("div", { staticClass: "join" }, [
                    _vm._v("已报名，等待审核")
                  ])
                : _vm.data.examState == "GoRegister"
                ? _c(
                    "div",
                    {
                      staticClass: "join",
                      on: {
                        click: function($event) {
                          return _vm.toRegister(_vm.data.examConfigId)
                        }
                      }
                    },
                    [_vm._v("立即报名")]
                  )
                : _vm.data.examState == "UnRegister"
                ? _c("div", { staticClass: "join" }, [_vm._v("报名已结束")])
                : _vm.data.examState == "WaitingExam"
                ? _c("div", { staticClass: "join" }, [
                    _vm._v(_vm._s(_vm.data.examTypeName) + "未开始")
                  ])
                : _vm.data.examState == "GoExam"
                ? _c(
                    "div",
                    { staticClass: "join" },
                    [
                      _vm.data.examPaper.paperType == "Normal"
                        ? [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "exam",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("开始" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                        : [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "examTyping",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("开始" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                    ],
                    2
                  )
                : _vm.data.examState == "KeppingExam"
                ? _c(
                    "div",
                    { staticClass: "join" },
                    [
                      _vm.data.examPaper.paperType == "Normal"
                        ? [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "exam",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("继续" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                        : [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "examTyping",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("继续" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                    ],
                    2
                  )
                : _vm.data.examState == "WaitingReExam"
                ? _c("div", { staticClass: "join refuse" }, [
                    _vm._v(_vm._s(_vm.data.hint))
                  ])
                : _vm.data.examState == "GoReExam"
                ? _c(
                    "div",
                    { staticClass: "join" },
                    [
                      _vm.data.examPaper.paperType == "Normal"
                        ? [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "exam",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("重新" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                        : [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "examTyping",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("重新" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                    ],
                    2
                  )
                : _vm.data.examState == "Examed"
                ? _c("div", { staticClass: "join" }, [
                    _vm._v(_vm._s(_vm.data.examTypeName) + "完毕")
                  ])
                : _vm.data.examState == "OutDateExam"
                ? _c("div", { staticClass: "join" }, [
                    _vm._v(_vm._s(_vm.data.examTypeName) + "已结束")
                  ])
                : _vm.data.examState == "CheckStateUnPassed"
                ? _c("div", { staticClass: "join refuse" }, [
                    _c("p", [
                      _vm._v("审核申请被拒绝，" + _vm._s(_vm.data.hint))
                    ])
                  ])
                : _vm.data.examState == "UnableRegister"
                ? _c(
                    "div",
                    { staticClass: "join refuse" },
                    [
                      !!_vm.data.prerequisiteTodo
                        ? [
                            _vm.data.prerequisiteTodo.todoTypeName == "Course"
                              ? _c("p", [
                                  _vm._v("\n                  先去参加"),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getCourseUrl(
                                          _vm.data.prerequisiteTodo.todoId
                                        ),
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.data.prerequisiteTodo.todoName
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v("课程再来报名吧\n                ")
                                ])
                              : _vm.data.prerequisiteTodo.todoTypeName ==
                                "ExamConfig"
                              ? _c("p", [
                                  _vm._v("\n                  先去参加"),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getExamUrl(
                                          _vm.data.prerequisiteTodo.todoId
                                        ),
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.data.prerequisiteTodo.todoName
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v("考试再来报名吧\n                ")
                                ])
                              : _vm._e()
                          ]
                        : [
                            _c("p", [
                              _vm._v(
                                "暂时不能报名该场考试，由于需要先参加的考试或课程正在上架中，请耐心等待或联系培训老师"
                              )
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "present", attrs: { id: "present" } }, [
            _c(
              "ul",
              [
                _vm.data.examPaper.paperType == "Normal"
                  ? [
                      _c("li", [
                        _vm._v(
                          "考试总分：" +
                            _vm._s(_vm.data.examPaper.totalScore) +
                            "分"
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _vm._v(
                      "及格分数：" + _vm._s(_vm.data.examConfig.passScore)
                    ),
                    _vm.data.examPaper.paperType == "Normal"
                      ? [_vm._v("分")]
                      : [_vm._v("字/分")]
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.data.examConfig.maxExamTimes > 1
                  ? [
                      _c("li", [
                        _vm._v(
                          "最高可考次数：" +
                            _vm._s(_vm.data.examConfig.maxExamTimes) +
                            "次"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "考试间隔：" +
                            _vm._s(_vm.data.examConfig.eachExamIntervalHours) +
                            "小时"
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "考试时长：" + _vm._s(_vm.data.examConfig.duration) + "分钟"
                  )
                ]),
                _vm._v(" "),
                _vm.data.examConfig.examType == "Formal"
                  ? _c("li", [_vm._v("考试类型：正式考试")])
                  : _c("li", [_vm._v("考试类型：模拟练习")])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "top-head", attrs: { href: "javascript:;" } },
            [_vm._v("考试须知")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "catalog", attrs: { id: "catalog" } }, [
            _vm.data.examConfig.description != ""
              ? _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.data.examConfig.description)
                  }
                })
              : _c("p", [_vm._v("暂无信息")])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cat-head" }, [
      _c("a", { staticClass: "active", attrs: { href: "#present" } }, [
        _vm._v("考试详情")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "#catalog" } }, [_vm._v("考试须知")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07f4e207", esExports)
  }
}

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetailTemp_vue__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetailTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetailTemp_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetailTemp_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetailTemp_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a44307b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examDetailTemp_vue__ = __webpack_require__(1129);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetailTemp_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a44307b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examDetailTemp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/examDetailTemp.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a44307b", Component.options)
  } else {
    hotAPI.reload("data-v-3a44307b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details" }, [
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "details-box clear" }, [
          _c("div", {
            staticClass: "zoomImage",
            style: _vm.style(_vm.data.examConfig.iconUrl)
          }),
          _vm._v(" "),
          _c("div", { staticClass: "txt" }, [
            _c("h2", [_vm._v(_vm._s(_vm.data.examConfig.name))]),
            _vm._v(" "),
            _c("p", [_vm._v("您已通过考核，请联系老师了解接下来的安排")]),
            _vm._v(" "),
            _vm.data.examState == "WaitingRegister"
              ? _c("div", { staticClass: "join" }, [_vm._v("报名未开始")])
              : _vm.data.examState == "WaitingCheckState"
              ? _c("div", { staticClass: "join" }, [_vm._v("已报名，等待审核")])
              : _vm.data.examState == "GoRegister"
              ? _c(
                  "div",
                  {
                    staticClass: "join",
                    on: {
                      click: function($event) {
                        return _vm.toRegister(_vm.data.examConfigId)
                      }
                    }
                  },
                  [_vm._v("立即报名")]
                )
              : _vm.data.examState == "UnRegister"
              ? _c("div", { staticClass: "join" }, [_vm._v("报名已结束")])
              : _vm.data.examState == "WaitingExam"
              ? _c("div", { staticClass: "join" }, [
                  _vm._v(_vm._s(_vm.data.examTypeName) + "未开始")
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "top-head", attrs: { href: "javascript:;" } },
            [_vm._v("考试须知")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "catalog", attrs: { id: "catalog" } }, [
            _vm.data.examConfig.description != ""
              ? _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.data.examConfig.description)
                  }
                })
              : _c("p", [_vm._v("自定义")])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cat-head" }, [
      _c("a", { staticClass: "active", attrs: { href: "#present" } }, [
        _vm._v("考试详情")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "present", attrs: { id: "present" } }, [
      _c("ul", [
        _c("li", [_vm._v("考试类型：淘金大学（语音）本科考核")]),
        _vm._v(" "),
        _c("li", [_vm._v("考试总分：100分")]),
        _vm._v(" "),
        _c("li", [_vm._v("笔试占比：35%")]),
        _vm._v(" "),
        _c("li", [_vm._v("考试时长：560分钟")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a44307b", esExports)
  }
}

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fbtExperienceChoose_vue__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fbtExperienceChoose_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fbtExperienceChoose_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fbtExperienceChoose_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fbtExperienceChoose_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425512ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fbtExperienceChoose_vue__ = __webpack_require__(1133);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1131)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-425512ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fbtExperienceChoose_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425512ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fbtExperienceChoose_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/fbtExperienceChoose.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-425512ea", Component.options)
  } else {
    hotAPI.reload("data-v-425512ea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1132);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("cebfc778", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-425512ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./fbtExperienceChoose.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-425512ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./fbtExperienceChoose.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.isreturn[data-v-425512ea]{color:#000;cursor: pointer;\n}\n[data-v-425512ea].el-icon-arrow-left{color: #000;\n}\n#Return_Bar[data-v-425512ea] {\n    padding-left: 21px;\n    display: flex;\n    padding-top: 10px;\n    padding-bottom: 15px;\n    width: 100%;\n}\n[data-v-425512ea].el-icon-arrow-left {\n    margin-top: 5px;\n}\n.radioOrCheckedBox[data-v-425512ea]{\n  height:30px;border:1px solid #ddd;width:455px;padding-left:15px;\n}\n", ""]);

// exports


/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "train" } }, [
    _vm.$route.query.tabIndex
      ? _c("div", { attrs: { id: "Return_Bar" } }, [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
            _vm._v("返回")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "video-box", staticStyle: { "padding-left": "20px" } },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              height: "42px",
              "background-color": "#DDDDDD",
              "line-height": "36px",
              "font-size": "16px",
              "padding-left": "10px"
            }
          },
          [
            _vm._v(
              "\n      请认真选择，系统会根据你选择的结果来匹配，准确率越高任务录取率越高，如存在弄虚作假的情况，平台将做永久封禁处理。\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-form",
          { attrs: { inline: true } },
          [
            _c(
              "el-form-item",
              { staticStyle: { width: "700px" } },
              [
                _c("el-link", { attrs: { type: "info", underline: false } }, [
                  _vm._v("1、选择自己的在线经验【多选】")
                ]),
                _vm._v(" "),
                _c("el-tree", {
                  ref: "tree",
                  staticStyle: { width: "500px" },
                  attrs: {
                    data: _vm.experience.list,
                    props: _vm.props,
                    "default-checked-keys": _vm.experience.defaultCheckedArr,
                    "node-key": "operationTagId",
                    "show-checkbox": "",
                    "check-strictly": true,
                    "default-expand-all": false
                  },
                  on: { check: _vm.checkChildrenChecked },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var node = ref.node
                        var data = ref.data
                        return _c(
                          "span",
                          {
                            staticClass: "aaa",
                            staticStyle: {
                              height: "27px",
                              "line-height": "26px",
                              width: "100%",
                              border: "1px solid #D3D6DB"
                            }
                          },
                          [
                            _c("span", { staticStyle: { width: "100%" } }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-left": "10px"
                                  }
                                },
                                [_vm._v(_vm._s(node.label.operationTagName))]
                              )
                            ])
                          ]
                        )
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { type: "info", underline: false }
                  },
                  [_vm._v("2、选择自己的意向班次【多选】")]
                ),
                _vm._v(" "),
                _c(
                  "el-checkbox-group",
                  {
                    staticStyle: { width: "500px", "margin-left": "44px" },
                    model: {
                      value: _vm.intent_schedule_hour.defaultCheckedArr,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.intent_schedule_hour,
                          "defaultCheckedArr",
                          $$v
                        )
                      },
                      expression: "intent_schedule_hour.defaultCheckedArr"
                    }
                  },
                  _vm._l(_vm.intent_schedule_hour.list, function(m) {
                    return _c(
                      "el-checkbox",
                      {
                        key: m.operationTagId,
                        staticClass: "radioOrCheckedBox",
                        attrs: { label: m.operationTagId }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { margin: "5px 0px 0px 10px" } },
                          [_vm._v(_vm._s(m.operationTagName))]
                        )
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: { type: "info", underline: false }
                  },
                  [_vm._v("3、选择自己期望每天服务的时长【单选】")]
                ),
                _vm._v(" "),
                _c(
                  "el-radio-group",
                  {
                    staticStyle: { width: "500px", "margin-left": "44px" },
                    model: {
                      value: _vm.intent_serve_hour.value,
                      callback: function($$v) {
                        _vm.$set(_vm.intent_serve_hour, "value", $$v)
                      },
                      expression: "intent_serve_hour.value"
                    }
                  },
                  _vm._l(_vm.intent_serve_hour.list, function(m) {
                    return _c(
                      "el-radio",
                      {
                        key: m.operationTagId,
                        staticClass: "radioOrCheckedBox",
                        staticStyle: { "line-height": "26px" },
                        attrs: { label: m.operationTagId }
                      },
                      [_vm._v(_vm._s(m.operationTagName))]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-top": "20px" } },
                  [
                    _vm.$route.query.tabIndex
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "26px" },
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.isreturn }
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.saveLabel }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br")
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-425512ea", esExports)
  }
}

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a3cbd3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examResult_vue__ = __webpack_require__(1135);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a3cbd3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/examResult.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23a3cbd3", Component.options)
  } else {
    hotAPI.reload("data-v-23a3cbd3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam" }, [
    _c("div", { staticClass: "nuv" }),
    _vm._v(" "),
    _c("div", { staticClass: "result-con" }, [
      _c("div", { staticClass: "count" }, [
        _c("h2", [_vm._v("考试结果")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "useTime" },
          [
            _vm.data.isCorrect == "no"
              ? [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("用时："),
                    _c("span", { staticClass: "blue" }, [
                      _vm._v(_vm._s(_vm.getTime(_vm.data.examTimeSpent)))
                    ])
                  ])
                ]
              : [
                  _c("p", [
                    _vm.data.isPassed == "passed"
                      ? _c("span", { staticClass: "result-txt" }, [
                          _vm._v("恭喜您已通过考试")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.data.isPassed == "failed"
                      ? _c("span", { staticClass: "result-txt" }, [
                          _vm._v("很遗憾您未通过考试")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("用时："),
                    _c("span", { staticClass: "blue" }, [
                      _vm._v(_vm._s(_vm.getTime(_vm.data.examTimeSpent)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("得分："),
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.data.tjkScore) + "分")
                    ])
                  ])
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.list, function(s) {
            return _c(
              "li",
              {
                class: {
                  active2: s.answerState == "right",
                  active4: s.answerState == "wrong",
                  active1: s.answerState == "halfRight"
                }
              },
              [_vm._v(_vm._s(s.num))]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm._m(1)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "result-txt" }, [
        _vm._v("请耐心等待批阅，考试结果会在消息中心公布")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "color-txt" }, [
      _c("span", { staticClass: "right" }, [_vm._v("正确")]),
      _c("span", { staticClass: "wrong" }, [_vm._v("错误")]),
      _c("span", { staticClass: "halfright" }, [_vm._v("部分正确")]),
      _c("span", { staticClass: "waitGrade" }, [_vm._v("待批阅")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23a3cbd3", esExports)
  }
}

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typingResult_vue__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typingResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typingResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typingResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typingResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db5c012a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typingResult_vue__ = __webpack_require__(1137);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typingResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db5c012a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typingResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/typingResult.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db5c012a", Component.options)
  } else {
    hotAPI.reload("data-v-db5c012a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/examlist" } },
        [_vm._v("考试中心")]
      ),
      _vm._v(">"),
      _c("span", [_vm._v(_vm._s(_vm.data.examName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "result-con" }, [
      _c("div", { staticClass: "count" }, [
        _c("h2", [_vm._v("考试结果")]),
        _vm._v(" "),
        _c("div", { staticClass: "useTime" }, [
          _c("p", [
            _vm.data.isPassed == "passed"
              ? _c("span", { staticClass: "result-txt" }, [
                  _vm._v("恭喜您已通过考试")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.isPassed == "failed"
              ? _c("span", { staticClass: "result-txt" }, [
                  _vm._v("很遗憾您未通过考试")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("用时："),
            _c("span", { staticClass: "blue" }, [
              _vm._v(_vm._s(_vm.getTime(_vm.data.examTimeSpent)))
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("label", [_vm._v("打字速度：")]),
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.tjkAnswer.speed) + "字/分")
            ]),
            _vm._v(" "),
            _c("label", [_vm._v("正确率：")]),
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.tjkAnswer.accuracy) + "%")
            ]),
            _vm._v(" "),
            _c("label", [_vm._v("总字数：")]),
            _c("span", { staticClass: "num" }, [
              _vm._v(_vm._s(_vm.tjkAnswer.tjkWordNumber) + "字")
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "txt" }, [
            _vm._v("及格分数：" + _vm._s(_vm.data.examPassScore) + "字/分")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db5c012a", esExports)
  }
}

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liveCourse_vue__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liveCourse_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liveCourse_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liveCourse_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liveCourse_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0800d15e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liveCourse_vue__ = __webpack_require__(1139);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liveCourse_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0800d15e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liveCourse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/liveCourse.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0800d15e", Component.options)
  } else {
    hotAPI.reload("data-v-0800d15e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "live-course", staticStyle: { height: "100%" } },
    [
      _c("iframe", {
        staticStyle: { border: "none" },
        attrs: { src: _vm.url, width: "100%", height: "100%" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0800d15e", esExports)
  }
}

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainRecords_vue__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainRecords_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainRecords_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainRecords_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainRecords_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578ee311_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainRecords_vue__ = __webpack_require__(1146);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1141)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-578ee311"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainRecords_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578ee311_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainRecords_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/trainRecords.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-578ee311", Component.options)
  } else {
    hotAPI.reload("data-v-578ee311", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1142);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ebfde7e4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-578ee311\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainRecords.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-578ee311\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainRecords.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.highcharts-legend-box[data-v-578ee311] {\n  display: none !important;\n}\n.highcharts-credits[data-v-578ee311] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

/*
 Highcharts JS v6.1.1 (2018-06-27)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(T,K){"object"===typeof module&&module.exports?module.exports=T.document?K(T):K:T.Highcharts=K(T)})("undefined"!==typeof window?window:this,function(T){var K=function(){var a="undefined"===typeof T?window:T,C=a.document,E=a.navigator&&a.navigator.userAgent||"",F=C&&C.createElementNS&&!!C.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,n=/(edge|msie|trident)/i.test(E)&&!a.opera,h=-1!==E.indexOf("Firefox"),e=-1!==E.indexOf("Chrome"),u=h&&4>parseInt(E.split("Firefox/")[1],
10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",version:"6.1.1",deg2rad:2*Math.PI/360,doc:C,hasBidiBug:u,hasTouch:C&&void 0!==C.documentElement.ontouchstart,isMS:n,isWebKit:-1!==E.indexOf("AppleWebKit"),isFirefox:h,isChrome:e,isSafari:!e&&-1!==E.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(E),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:F,win:a,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},
charts:[]}}();(function(a){a.timers=[];var C=a.charts,E=a.doc,F=a.win;a.error=function(n,h){n=a.isNumber(n)?"Highcharts error #"+n+": www.highcharts.com/errors/"+n:n;if(h)throw Error(n);F.console&&console.log(n)};a.Fx=function(a,h,e){this.options=h;this.elem=a;this.prop=e};a.Fx.prototype={dSetter:function(){var a=this.paths[0],h=this.paths[1],e=[],u=this.now,y=a.length,q;if(1===u)e=this.toD;else if(y===h.length&&1>u)for(;y--;)q=parseFloat(a[y]),e[y]=isNaN(q)?h[y]:u*parseFloat(h[y]-q)+q;else e=h;this.elem.attr("d",
e,null,!0)},update:function(){var a=this.elem,h=this.prop,e=this.now,u=this.options.step;if(this[h+"Setter"])this[h+"Setter"]();else a.attr?a.element&&a.attr(h,e,null,!0):a.style[h]=e+this.unit;u&&u.call(a,e,this)},run:function(n,h,e){var u=this,y=u.options,q=function(a){return q.stopped?!1:u.step(a)},x=F.requestAnimationFrame||function(a){setTimeout(a,13)},f=function(){for(var c=0;c<a.timers.length;c++)a.timers[c]()||a.timers.splice(c--,1);a.timers.length&&x(f)};n!==h||this.elem["forceAnimate:"+
this.prop]?(this.startTime=+new Date,this.start=n,this.end=h,this.unit=e,this.now=this.start,this.pos=0,q.elem=this.elem,q.prop=this.prop,q()&&1===a.timers.push(q)&&x(f)):(delete y.curAnim[this.prop],y.complete&&0===a.keys(y.curAnim).length&&y.complete.call(this.elem))},step:function(n){var h=+new Date,e,u=this.options,y=this.elem,q=u.complete,x=u.duration,f=u.curAnim;y.attr&&!y.element?n=!1:n||h>=x+this.startTime?(this.now=this.end,this.pos=1,this.update(),e=f[this.prop]=!0,a.objectEach(f,function(a){!0!==
a&&(e=!1)}),e&&q&&q.call(y),n=!1):(this.pos=u.easing((h-this.startTime)/x),this.now=this.start+(this.end-this.start)*this.pos,this.update(),n=!0);return n},initPath:function(n,h,e){function u(a){var d,l;for(b=a.length;b--;)d="M"===a[b]||"L"===a[b],l=/[a-zA-Z]/.test(a[b+3]),d&&l&&a.splice(b+1,0,a[b+1],a[b+2],a[b+1],a[b+2])}function y(a,d){for(;a.length<l;){a[0]=d[l-a.length];var c=a.slice(0,r);[].splice.apply(a,[0,0].concat(c));v&&(c=a.slice(a.length-r),[].splice.apply(a,[a.length,0].concat(c)),b--)}a[0]=
"M"}function q(a,b){for(var c=(l-a.length)/r;0<c&&c--;)d=a.slice().splice(a.length/p-r,r*p),d[0]=b[l-r-c*r],k&&(d[r-6]=d[r-2],d[r-5]=d[r-1]),[].splice.apply(a,[a.length/p,0].concat(d)),v&&c--}h=h||"";var x,f=n.startX,c=n.endX,k=-1<h.indexOf("C"),r=k?7:3,l,d,b;h=h.split(" ");e=e.slice();var v=n.isArea,p=v?2:1,I;k&&(u(h),u(e));if(f&&c){for(b=0;b<f.length;b++)if(f[b]===c[0]){x=b;break}else if(f[0]===c[c.length-f.length+b]){x=b;I=!0;break}void 0===x&&(h=[])}h.length&&a.isNumber(x)&&(l=e.length+x*p*r,
I?(y(h,e),q(e,h)):(y(e,h),q(h,e)));return[h,e]}};a.Fx.prototype.fillSetter=a.Fx.prototype.strokeSetter=function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)};a.merge=function(){var n,h=arguments,e,u={},y=function(e,n){"object"!==typeof e&&(e={});a.objectEach(n,function(f,c){!a.isObject(f,!0)||a.isClass(f)||a.isDOMElement(f)?e[c]=n[c]:e[c]=y(e[c]||{},f)});return e};!0===h[0]&&(u=h[1],h=Array.prototype.slice.call(h,2));e=h.length;for(n=0;n<e;n++)u=y(u,
h[n]);return u};a.pInt=function(a,h){return parseInt(a,h||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(n,h){return!!n&&"object"===typeof n&&(!h||!a.isArray(n))};a.isDOMElement=function(n){return a.isObject(n)&&"number"===typeof n.nodeType};a.isClass=function(n){var h=n&&n.constructor;return!(!a.isObject(n,!0)||a.isDOMElement(n)||!h||!h.name||"Object"===
h.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a};a.erase=function(a,h){for(var e=a.length;e--;)if(a[e]===h){a.splice(e,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(n,h,e){var u;a.isString(h)?a.defined(e)?n.setAttribute(h,e):n&&n.getAttribute&&((u=n.getAttribute(h))||"class"!==h||(u=n.getAttribute(h+"Name"))):a.defined(h)&&a.isObject(h)&&a.objectEach(h,function(a,e){n.setAttribute(e,a)});return u};a.splat=function(n){return a.isArray(n)?
n:[n]};a.syncTimeout=function(a,h,e){if(h)return setTimeout(a,h,e);a.call(0,e)};a.clearTimeout=function(n){a.defined(n)&&clearTimeout(n)};a.extend=function(a,h){var e;a||(a={});for(e in h)a[e]=h[e];return a};a.pick=function(){var a=arguments,h,e,u=a.length;for(h=0;h<u;h++)if(e=a[h],void 0!==e&&null!==e)return e};a.css=function(n,h){a.isMS&&!a.svg&&h&&void 0!==h.opacity&&(h.filter="alpha(opacity\x3d"+100*h.opacity+")");a.extend(n.style,h)};a.createElement=function(n,h,e,u,y){n=E.createElement(n);var q=
a.css;h&&a.extend(n,h);y&&q(n,{padding:0,border:"none",margin:0});e&&q(n,e);u&&u.appendChild(n);return n};a.extendClass=function(n,h){var e=function(){};e.prototype=new n;a.extend(e.prototype,h);return e};a.pad=function(a,h,e){return Array((h||2)+1-String(a).replace("-","").length).join(e||0)+a};a.relativeLength=function(a,h,e){return/%$/.test(a)?h*parseFloat(a)/100+(e||0):parseFloat(a)};a.wrap=function(a,h,e){var n=a[h];a[h]=function(){var a=Array.prototype.slice.call(arguments),q=arguments,x=this;
x.proceed=function(){n.apply(x,arguments.length?arguments:q)};a.unshift(n);a=e.apply(this,a);x.proceed=null;return a}};a.formatSingle=function(n,h,e){var u=/\.([0-9])/,y=a.defaultOptions.lang;/f$/.test(n)?(e=(e=n.match(u))?e[1]:-1,null!==h&&(h=a.numberFormat(h,e,y.decimalPoint,-1<n.indexOf(",")?y.thousandsSep:""))):h=(e||a.time).dateFormat(n,h);return h};a.format=function(n,h,e){for(var u="{",y=!1,q,x,f,c,k=[],r;n;){u=n.indexOf(u);if(-1===u)break;q=n.slice(0,u);if(y){q=q.split(":");x=q.shift().split(".");
c=x.length;r=h;for(f=0;f<c;f++)r&&(r=r[x[f]]);q.length&&(r=a.formatSingle(q.join(":"),r,e));k.push(r)}else k.push(q);n=n.slice(u+1);u=(y=!y)?"}":"{"}k.push(n);return k.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(n,h,e,u,y){var q,x=n;e=a.pick(e,1);q=n/e;h||(h=y?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===u&&(1===e?h=a.grep(h,function(a){return 0===a%1}):.1>=e&&(h=[1/e])));for(u=0;u<h.length&&!(x=h[u],y&&x*e>=n||
!y&&q<=(h[u]+(h[u+1]||h[u]))/2);u++);return x=a.correctFloat(x*e,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,h){var e=a.length,n,y;for(y=0;y<e;y++)a[y].safeI=y;a.sort(function(a,e){n=h(a,e);return 0===n?a.safeI-e.safeI:n});for(y=0;y<e;y++)delete a[y].safeI};a.arrayMin=function(a){for(var h=a.length,e=a[0];h--;)a[h]<e&&(e=a[h]);return e};a.arrayMax=function(a){for(var h=a.length,e=a[0];h--;)a[h]>e&&(e=a[h]);return e};a.destroyObjectProperties=function(n,h){a.objectEach(n,function(a,
u){a&&a!==h&&a.destroy&&a.destroy();delete n[u]})};a.discardElement=function(n){var h=a.garbageBin;h||(h=a.createElement("div"));n&&h.appendChild(n);h.innerHTML=""};a.correctFloat=function(a,h){return parseFloat(a.toPrecision(h||14))};a.setAnimation=function(n,h){h.renderer.globalAnimation=a.pick(n,h.options.chart.animation,!0)};a.animObject=function(n){return a.isObject(n)?a.merge(n):{duration:n?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,
year:314496E5};a.numberFormat=function(n,h,e,u){n=+n||0;h=+h;var y=a.defaultOptions.lang,q=(n.toString().split(".")[1]||"").split("e")[0].length,x,f,c=n.toString().split("e");-1===h?h=Math.min(q,20):a.isNumber(h)?h&&c[1]&&0>c[1]&&(x=h+ +c[1],0<=x?(c[0]=(+c[0]).toExponential(x).split("e")[0],h=x):(c[0]=c[0].split(".")[0]||0,n=20>h?(c[0]*Math.pow(10,c[1])).toFixed(h):0,c[1]=0)):h=2;f=(Math.abs(c[1]?c[0]:n)+Math.pow(10,-Math.max(h,q)-1)).toFixed(h);q=String(a.pInt(f));x=3<q.length?q.length%3:0;e=a.pick(e,
y.decimalPoint);u=a.pick(u,y.thousandsSep);n=(0>n?"-":"")+(x?q.substr(0,x)+u:"");n+=q.substr(x).replace(/(\d{3})(?=\d)/g,"$1"+u);h&&(n+=e+f.slice(-h));c[1]&&0!==+n&&(n+="e"+c[1]);return n};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(n,h,e){if("width"===h)return Math.max(0,Math.min(n.offsetWidth,n.scrollWidth)-a.getStyle(n,"padding-left")-a.getStyle(n,"padding-right"));if("height"===h)return Math.max(0,Math.min(n.offsetHeight,n.scrollHeight)-a.getStyle(n,"padding-top")-
a.getStyle(n,"padding-bottom"));F.getComputedStyle||a.error(27,!0);if(n=F.getComputedStyle(n,void 0))n=n.getPropertyValue(h),a.pick(e,"opacity"!==h)&&(n=a.pInt(n));return n};a.inArray=function(n,h,e){return(a.indexOfPolyfill||Array.prototype.indexOf).call(h,n,e)};a.grep=function(n,h){return(a.filterPolyfill||Array.prototype.filter).call(n,h)};a.find=Array.prototype.find?function(a,h){return a.find(h)}:function(a,h){var e,u=a.length;for(e=0;e<u;e++)if(h(a[e],e))return a[e]};a.some=function(n,h,e){return(a.somePolyfill||
Array.prototype.some).call(n,h,e)};a.map=function(a,h){for(var e=[],u=0,y=a.length;u<y;u++)e[u]=h.call(a[u],a[u],u,a);return e};a.keys=function(n){return(a.keysPolyfill||Object.keys).call(void 0,n)};a.reduce=function(n,h,e){return(a.reducePolyfill||Array.prototype.reduce).apply(n,2<arguments.length?[h,e]:[h])};a.offset=function(a){var h=E.documentElement;a=a.parentElement||a.parentNode?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(F.pageYOffset||h.scrollTop)-(h.clientTop||0),left:a.left+
(F.pageXOffset||h.scrollLeft)-(h.clientLeft||0)}};a.stop=function(n,h){for(var e=a.timers.length;e--;)a.timers[e].elem!==n||h&&h!==a.timers[e].prop||(a.timers[e].stopped=!0)};a.each=function(n,h,e){return(a.forEachPolyfill||Array.prototype.forEach).call(n,h,e)};a.objectEach=function(a,h,e){for(var u in a)a.hasOwnProperty(u)&&h.call(e||a[u],a[u],u,a)};a.addEvent=function(n,h,e,u){var y,q=n.addEventListener||a.addEventListenerPolyfill;y="function"===typeof n&&n.prototype?n.prototype.protoEvents=n.prototype.protoEvents||
{}:n.hcEvents=n.hcEvents||{};a.Point&&n instanceof a.Point&&n.series&&n.series.chart&&(n.series.chart.runTrackerClick=!0);q&&q.call(n,h,e,!1);y[h]||(y[h]=[]);y[h].push(e);u&&a.isNumber(u.order)&&(e.order=u.order,y[h].sort(function(a,f){return a.order-f.order}));return function(){a.removeEvent(n,h,e)}};a.removeEvent=function(n,h,e){function u(f,c){var k=n.removeEventListener||a.removeEventListenerPolyfill;k&&k.call(n,f,c,!1)}function y(f){var c,k;n.nodeName&&(h?(c={},c[h]=!0):c=f,a.objectEach(c,function(a,
c){if(f[c])for(k=f[c].length;k--;)u(c,f[c][k])}))}var q,x;a.each(["protoEvents","hcEvents"],function(f){var c=n[f];c&&(h?(q=c[h]||[],e?(x=a.inArray(e,q),-1<x&&(q.splice(x,1),c[h]=q),u(h,e)):(y(c),c[h]=[])):(y(c),n[f]={}))})};a.fireEvent=function(n,h,e,u){var y,q,x,f,c;e=e||{};E.createEvent&&(n.dispatchEvent||n.fireEvent)?(y=E.createEvent("Events"),y.initEvent(h,!0,!0),a.extend(y,e),n.dispatchEvent?n.dispatchEvent(y):n.fireEvent(h,y)):a.each(["protoEvents","hcEvents"],function(k){if(n[k])for(q=n[k][h]||
[],x=q.length,e.target||a.extend(e,{preventDefault:function(){e.defaultPrevented=!0},target:n,type:h}),f=0;f<x;f++)(c=q[f])&&!1===c.call(n,e)&&e.preventDefault()});u&&!e.defaultPrevented&&u.call(n,e)};a.animate=function(n,h,e){var u,y="",q,x,f;a.isObject(e)||(f=arguments,e={duration:f[2],easing:f[3],complete:f[4]});a.isNumber(e.duration)||(e.duration=400);e.easing="function"===typeof e.easing?e.easing:Math[e.easing]||Math.easeInOutSine;e.curAnim=a.merge(h);a.objectEach(h,function(c,f){a.stop(n,f);
x=new a.Fx(n,e,f);q=null;"d"===f?(x.paths=x.initPath(n,n.d,h.d),x.toD=h.d,u=0,q=1):n.attr?u=n.attr(f):(u=parseFloat(a.getStyle(n,f))||0,"opacity"!==f&&(y="px"));q||(q=c);q&&q.match&&q.match("px")&&(q=q.replace(/px/g,""));x.run(u,q,y)})};a.seriesType=function(n,h,e,u,y){var q=a.getOptions(),x=a.seriesTypes;q.plotOptions[n]=a.merge(q.plotOptions[h],e);x[n]=a.extendClass(x[h]||function(){},u);x[n].prototype.type=n;y&&(x[n].prototype.pointClass=a.extendClass(a.Point,y));return x[n]};a.uniqueKey=function(){var a=
Math.random().toString(36).substring(2,9),h=0;return function(){return"highcharts-"+a+"-"+h++}}();F.jQuery&&(F.jQuery.fn.highcharts=function(){var n=[].slice.call(arguments);if(this[0])return n[0]?(new (a[a.isString(n[0])?n.shift():"Chart"])(this[0],n[0],n[1]),this):C[a.attr(this[0],"data-highcharts-chart")]})})(K);(function(a){var C=a.each,E=a.isNumber,F=a.map,n=a.merge,h=a.pInt;a.Color=function(e){if(!(this instanceof a.Color))return new a.Color(e);this.init(e)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
parse:function(a){return[h(a[1]),h(a[2]),h(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[h(a[1]),h(a[2]),h(a[3]),1]}}],names:{none:"rgba(255,255,255,0)",white:"#ffffff",black:"#000000"},init:function(e){var h,y,q,x;if((this.input=e=this.names[e&&e.toLowerCase?e.toLowerCase():""]||e)&&e.stops)this.stops=F(e.stops,function(f){return new a.Color(f[1])});else if(e&&e.charAt&&"#"===e.charAt()&&(h=e.length,e=parseInt(e.substr(1),
16),7===h?y=[(e&16711680)>>16,(e&65280)>>8,e&255,1]:4===h&&(y=[(e&3840)>>4|(e&3840)>>8,(e&240)>>4|e&240,(e&15)<<4|e&15,1])),!y)for(q=this.parsers.length;q--&&!y;)x=this.parsers[q],(h=x.regex.exec(e))&&(y=x.parse(h));this.rgba=y||[]},get:function(a){var e=this.input,h=this.rgba,q;this.stops?(q=n(e),q.stops=[].concat(q.stops),C(this.stops,function(e,f){q.stops[f]=[q.stops[f][0],e.get(a)]})):q=h&&E(h[0])?"rgb"===a||!a&&1===h[3]?"rgb("+h[0]+","+h[1]+","+h[2]+")":"a"===a?h[3]:"rgba("+h.join(",")+")":e;
return q},brighten:function(a){var e,y=this.rgba;if(this.stops)C(this.stops,function(e){e.brighten(a)});else if(E(a)&&0!==a)for(e=0;3>e;e++)y[e]+=h(255*a),0>y[e]&&(y[e]=0),255<y[e]&&(y[e]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,h){var e=this.rgba,q=a.rgba;q.length&&e&&e.length?(a=1!==q[3]||1!==e[3],h=(a?"rgba(":"rgb(")+Math.round(q[0]+(e[0]-q[0])*(1-h))+","+Math.round(q[1]+(e[1]-q[1])*(1-h))+","+Math.round(q[2]+(e[2]-q[2])*(1-h))+(a?","+(q[3]+(e[3]-
q[3])*(1-h)):"")+")"):h=a.input||"none";return h}};a.color=function(e){return new a.Color(e)}})(K);(function(a){var C,E,F=a.addEvent,n=a.animate,h=a.attr,e=a.charts,u=a.color,y=a.css,q=a.createElement,x=a.defined,f=a.deg2rad,c=a.destroyObjectProperties,k=a.doc,r=a.each,l=a.extend,d=a.erase,b=a.grep,v=a.hasTouch,p=a.inArray,I=a.isArray,t=a.isFirefox,L=a.isMS,A=a.isObject,H=a.isString,m=a.isWebKit,D=a.merge,B=a.noop,M=a.objectEach,G=a.pick,g=a.pInt,w=a.removeEvent,P=a.stop,Q=a.svg,J=a.SVG_NS,O=a.symbolSizes,
N=a.win;C=a.SVGElement=function(){return this};l(C.prototype,{opacity:1,SVG_NS:J,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "),init:function(a,g){this.element="span"===g?q(g):k.createElementNS(this.SVG_NS,g);this.renderer=a},animate:function(z,g,b){g=a.animObject(G(g,this.renderer.globalAnimation,!0));0!==g.duration?(b&&(g.complete=b),n(this,z,g)):(this.attr(z,null,b),g.step&&g.step.call(this));return this},
complexColor:function(z,g,b){var d=this.renderer,w,c,l,J,f,m,B,k,R,v,p,t=[],A;a.fireEvent(this.renderer,"complexColor",{args:arguments},function(){z.radialGradient?c="radialGradient":z.linearGradient&&(c="linearGradient");c&&(l=z[c],f=d.gradients,B=z.stops,v=b.radialReference,I(l)&&(z[c]=l={x1:l[0],y1:l[1],x2:l[2],y2:l[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===c&&v&&!x(l.gradientUnits)&&(J=l,l=D(l,d.getRadialAttr(v,J),{gradientUnits:"userSpaceOnUse"})),M(l,function(a,z){"id"!==z&&t.push(z,
a)}),M(B,function(a){t.push(a)}),t=t.join(","),f[t]?p=f[t].attr("id"):(l.id=p=a.uniqueKey(),f[t]=m=d.createElement(c).attr(l).add(d.defs),m.radAttr=J,m.stops=[],r(B,function(z){0===z[1].indexOf("rgba")?(w=a.color(z[1]),k=w.get("rgb"),R=w.get("a")):(k=z[1],R=1);z=d.createElement("stop").attr({offset:z[0],"stop-color":k,"stop-opacity":R}).add(m);m.stops.push(z)})),A="url("+d.url+"#"+p+")",b.setAttribute(g,A),b.gradient=t,z.toString=function(){return A})})},applyTextOutline:function(z){var g=this.element,
b,w,c,l,m;-1!==z.indexOf("contrast")&&(z=z.replace(/contrast/g,this.renderer.getContrast(g.style.fill)));z=z.split(" ");w=z[z.length-1];if((c=z[0])&&"none"!==c&&a.svg){this.fakeTS=!0;z=[].slice.call(g.getElementsByTagName("tspan"));this.ySetter=this.xSetter;c=c.replace(/(^[\d\.]+)(.*?)$/g,function(a,z,g){return 2*z+g});for(m=z.length;m--;)b=z[m],"highcharts-text-outline"===b.getAttribute("class")&&d(z,g.removeChild(b));l=g.firstChild;r(z,function(a,z){0===z&&(a.setAttribute("x",g.getAttribute("x")),
z=g.getAttribute("y"),a.setAttribute("y",z||0),null===z&&g.setAttribute("y",0));a=a.cloneNode(1);h(a,{"class":"highcharts-text-outline",fill:w,stroke:w,"stroke-width":c,"stroke-linejoin":"round"});g.insertBefore(a,l)})}},attr:function(a,g,b,d){var z,w=this.element,c,l=this,m,f;"string"===typeof a&&void 0!==g&&(z=a,a={},a[z]=g);"string"===typeof a?l=(this[a+"Getter"]||this._defaultGetter).call(this,a,w):(M(a,function(z,g){m=!1;d||P(this,g);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(g)&&
(c||(this.symbolAttr(a),c=!0),m=!0);!this.rotation||"x"!==g&&"y"!==g||(this.doTransform=!0);m||(f=this[g+"Setter"]||this._defaultSetter,f.call(this,z,g,w),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(g)&&this.updateShadows(g,z,f))},this),this.afterSetters());b&&b.call(this);return l},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,g,b){for(var z=this.shadows,d=z.length;d--;)b.call(z[d],"height"===a?Math.max(g-
(z[d].cutHeight||0),0):"d"===a?this.d:g,a,z[d])},addClass:function(a,g){var z=this.attr("class")||"";-1===z.indexOf(a)&&(g||(a=(z+(z?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==p(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var z=this;r("x y r start end width height innerR anchorX anchorY".split(" "),function(g){z[g]=G(a[g],z[g])});z.attr({d:z.renderer.symbols[z.symbolName](z.x,
z.y,z.width,z.height,z)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,g){var z;g=g||a.strokeWidth||0;z=Math.round(g)%2/2;a.x=Math.floor(a.x||this.x||0)+z;a.y=Math.floor(a.y||this.y||0)+z;a.width=Math.floor((a.width||this.width||0)-2*z);a.height=Math.floor((a.height||this.height||0)-2*z);x(a.strokeWidth)&&(a.strokeWidth=g);return a},css:function(a){var z=this.styles,b={},d=this.element,w,c="",m,f=!z,J=["textOutline","textOverflow",
"width"];a&&a.color&&(a.fill=a.color);z&&M(a,function(a,g){a!==z[g]&&(b[g]=a,f=!0)});f&&(z&&(a=l(z,b)),a&&(null===a.width||"auto"===a.width?delete this.textWidth:"text"===d.nodeName.toLowerCase()&&a.width&&(w=this.textWidth=g(a.width))),this.styles=a,w&&!Q&&this.renderer.forExport&&delete a.width,d.namespaceURI===this.SVG_NS?(m=function(a,z){return"-"+z.toLowerCase()},M(a,function(a,z){-1===p(z,J)&&(c+=z.replace(/([A-Z])/g,m)+":"+a+";")}),c&&h(d,"style",c)):y(d,a),this.added&&("text"===this.element.nodeName&&
this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,g){var z=this,b=z.element;v&&"click"===a?(b.ontouchstart=function(a){z.touchEventFired=Date.now();a.preventDefault();g.call(b,a)},b.onclick=function(a){(-1===N.navigator.userAgent.indexOf("Android")||1100<Date.now()-(z.touchEventFired||0))&&g.call(b,a)}):b["on"+a]=g;return this},setRadialReference:function(a){var z=this.renderer.gradients[this.element.gradient];
this.element.radialReference=a;z&&z.radAttr&&z.animate(this.renderer.getRadialAttr(a,z.radAttr));return this},translate:function(a,g){return this.attr({translateX:a,translateY:g})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,g=this.translateY||0,b=this.scaleX,d=this.scaleY,w=this.inverted,c=this.rotation,l=this.matrix,m=this.element;w&&(a+=this.width,g+=this.height);a=["translate("+a+","+g+")"];x(l)&&a.push("matrix("+l.join(",")+
")");w?a.push("rotate(90) scale(-1,1)"):c&&a.push("rotate("+c+" "+G(this.rotationOriginX,m.getAttribute("x"),0)+" "+G(this.rotationOriginY,m.getAttribute("y")||0)+")");(x(b)||x(d))&&a.push("scale("+G(b,1)+" "+G(d,1)+")");a.length&&m.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,g,b){var z,w,c,l,m={};w=this.renderer;c=w.alignedObjects;var f,J;if(a){if(this.alignOptions=a,this.alignByTranslate=g,!b||H(b))this.alignTo=
z=b||"renderer",d(c,this),c.push(this),b=null}else a=this.alignOptions,g=this.alignByTranslate,z=this.alignTo;b=G(b,w[z],w);z=a.align;w=a.verticalAlign;c=(b.x||0)+(a.x||0);l=(b.y||0)+(a.y||0);"right"===z?f=1:"center"===z&&(f=2);f&&(c+=(b.width-(a.width||0))/f);m[g?"translateX":"x"]=Math.round(c);"bottom"===w?J=1:"middle"===w&&(J=2);J&&(l+=(b.height-(a.height||0))/J);m[g?"translateY":"y"]=Math.round(l);this[this.placed?"animate":"attr"](m);this.placed=!0;this.alignAttr=m;return this},getBBox:function(a,
g){var z,b=this.renderer,d,w=this.element,c=this.styles,m,J=this.textStr,B,k=b.cache,v=b.cacheKeys,p;g=G(g,this.rotation);d=g*f;m=c&&c.fontSize;x(J)&&(p=J.toString(),-1===p.indexOf("\x3c")&&(p=p.replace(/[0-9]/g,"0")),p+=["",g||0,m,this.textWidth,c&&c.textOverflow].join());p&&!a&&(z=k[p]);if(!z){if(w.namespaceURI===this.SVG_NS||b.forExport){try{(B=this.fakeTS&&function(a){r(w.querySelectorAll(".highcharts-text-outline"),function(z){z.style.display=a})})&&B("none"),z=w.getBBox?l({},w.getBBox()):{width:w.offsetWidth,
height:w.offsetHeight},B&&B("")}catch(W){}if(!z||0>z.width)z={width:0,height:0}}else z=this.htmlGetBBox();b.isSVG&&(a=z.width,b=z.height,c&&"11px"===c.fontSize&&17===Math.round(b)&&(z.height=b=14),g&&(z.width=Math.abs(b*Math.sin(d))+Math.abs(a*Math.cos(d)),z.height=Math.abs(b*Math.cos(d))+Math.abs(a*Math.sin(d))));if(p&&0<z.height){for(;250<v.length;)delete k[v.shift()];k[p]||v.push(p);k[p]=z}}return z},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},
fadeOut:function(a){var z=this;z.animate({opacity:0},{duration:a||150,complete:function(){z.attr({y:-9999})}})},add:function(a){var z=this.renderer,g=this.element,b;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&z.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)b=this.zIndexSetter();b||(a?a.element:z.box).appendChild(g);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var z=a.parentNode;z&&z.removeChild(a)},destroy:function(){var a=
this,g=a.element||{},b=a.renderer.isSVG&&"SPAN"===g.nodeName&&a.parentGroup,w=g.ownerSVGElement,c=a.clipPath;g.onclick=g.onmouseout=g.onmouseover=g.onmousemove=g.point=null;P(a);c&&w&&(r(w.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){var g=a.getAttribute("clip-path"),z=c.element.id;(-1<g.indexOf("(#"+z+")")||-1<g.indexOf('("#'+z+'")'))&&a.removeAttribute("clip-path")}),a.clipPath=c.destroy());if(a.stops){for(w=0;w<a.stops.length;w++)a.stops[w]=a.stops[w].destroy();a.stops=null}a.safeRemoveChild(g);
for(a.destroyShadows();b&&b.div&&0===b.div.childNodes.length;)g=b.parentGroup,a.safeRemoveChild(b.div),delete b.div,b=g;a.alignTo&&d(a.renderer.alignedObjects,a);M(a,function(g,z){delete a[z]});return null},shadow:function(a,g,b){var z=[],d,w,c=this.element,l,m,f,J;if(!a)this.destroyShadows();else if(!this.shadows){m=G(a.width,3);f=(a.opacity||.15)/m;J=this.parentInverted?"(-1,-1)":"("+G(a.offsetX,1)+", "+G(a.offsetY,1)+")";for(d=1;d<=m;d++)w=c.cloneNode(0),l=2*m+1-2*d,h(w,{isShadow:"true",stroke:a.color||
"#000000","stroke-opacity":f*d,"stroke-width":l,transform:"translate"+J,fill:"none"}),b&&(h(w,"height",Math.max(h(w,"height")-l,0)),w.cutHeight=l),g?g.element.appendChild(w):c.parentNode&&c.parentNode.insertBefore(w,c),z.push(w);this.shadows=z}return this},destroyShadows:function(){r(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=
G(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,g,b){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[g]!==a&&(b.setAttribute(g,a),this[g]=a)},dashstyleSetter:function(a){var b,z=this["stroke-width"];"inherit"===z&&(z=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash",
"8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=g(a[b])*z;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.alignValue=a;this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,g,b){this[g]=a;b.setAttribute(g,a)},titleSetter:function(a){var g=this.element.getElementsByTagName("title")[0];g||(g=k.createElementNS(this.SVG_NS,
"title"),this.element.appendChild(g));g.firstChild&&g.removeChild(g.firstChild);g.appendChild(k.createTextNode(String(G(a),"").replace(/<[^>]*>/g,"").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,g,b){"string"===typeof a?b.setAttribute(g,a):a&&this.complexColor(a,g,b)},visibilitySetter:function(a,g,b){"inherit"===a?b.removeAttribute(g):this[g]!==a&&b.setAttribute(g,
a);this[g]=a},zIndexSetter:function(a,b){var d=this.renderer,w=this.parentGroup,z=(w||d).element||d.box,c,l=this.element,m,f,d=z===d.box;c=this.added;var J;x(a)?(l.setAttribute("data-z-index",a),a=+a,this[b]===a&&(c=!1)):x(this[b])&&l.removeAttribute("data-z-index");this[b]=a;if(c){(a=this.zIndex)&&w&&(w.handleZ=!0);b=z.childNodes;for(J=b.length-1;0<=J&&!m;J--)if(w=b[J],c=w.getAttribute("data-z-index"),f=!x(c),w!==l)if(0>a&&f&&!d&&!J)z.insertBefore(l,b[J]),m=!0;else if(g(c)<=a||f&&(!x(a)||0<=a))z.insertBefore(l,
b[J+1]||null),m=!0;m||(z.insertBefore(l,b[d?3:0]||null),m=!0)}return m},_defaultSetter:function(a,g,b){b.setAttribute(g,a)}});C.prototype.yGetter=C.prototype.xGetter;C.prototype.translateXSetter=C.prototype.translateYSetter=C.prototype.rotationSetter=C.prototype.verticalAlignSetter=C.prototype.rotationOriginXSetter=C.prototype.rotationOriginYSetter=C.prototype.scaleXSetter=C.prototype.scaleYSetter=C.prototype.matrixSetter=function(a,g){this[g]=a;this.doTransform=!0};C.prototype["stroke-widthSetter"]=
C.prototype.strokeSetter=function(a,g,b){this[g]=a;this.stroke&&this["stroke-width"]?(C.prototype.fillSetter.call(this,this.stroke,"stroke",b),b.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===g&&0===a&&this.hasStroke&&(b.removeAttribute("stroke"),this.hasStroke=!1)};E=a.SVGRenderer=function(){this.init.apply(this,arguments)};l(E.prototype,{Element:C,SVG_NS:J,init:function(a,g,b,d,w,c){var z;d=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(d));
z=d.element;a.appendChild(z);h(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&h(z,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=z;this.boxWrapper=d;this.alignedObjects=[];this.url=(t||m)&&k.getElementsByTagName("base").length?N.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(k.createTextNode("Created with Highcharts 6.1.1"));this.defs=this.createElement("defs").add();this.allowHTML=c;
this.forExport=w;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(g,b,!1);var l;t&&a.getBoundingClientRect&&(g=function(){y(a,{left:0,top:0});l=a.getBoundingClientRect();y(a,{left:Math.ceil(l.left)-l.left+"px",top:Math.ceil(l.top)-l.top+"px"})},g(),this.unSubPixelFix=F(N,"resize",g))},getStyle:function(a){return this.style=l({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},
isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();c(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var g=new this.Element;g.init(this,a);return g},draw:B,getRadialAttr:function(a,g){return{cx:a[0]-a[2]/2+g.cx*a[2],cy:a[1]-a[2]/2+g.cy*a[2],r:g.r*a[2]}},getSpanWidth:function(a){return a.getBBox(!0).width},
applyEllipsis:function(a,g,b,d){var w=a.rotation,c=b,z,l=0,m=b.length,J=function(a){g.removeChild(g.firstChild);a&&g.appendChild(k.createTextNode(a))},f;a.rotation=0;c=this.getSpanWidth(a,g);if(f=c>d){for(;l<=m;)z=Math.ceil((l+m)/2),c=b.substring(0,z)+"\u2026",J(c),c=this.getSpanWidth(a,g),l===m?l=m+1:c>d?m=z-1:l=z;0===m&&J("")}a.rotation=w;return f},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot;"},buildText:function(a){var d=a.element,w=this,c=w.forExport,
l=G(a.textStr,"").toString(),z=-1!==l.indexOf("\x3c"),m=d.childNodes,f,B=h(d,"x"),v=a.styles,D=a.textWidth,t=v&&v.lineHeight,A=v&&v.textOutline,e=v&&"ellipsis"===v.textOverflow,P=v&&"nowrap"===v.whiteSpace,O=v&&v.fontSize,q,x,I=m.length,v=D&&!a.added&&this.box,H=function(a){var b;b=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:O||w.style.fontSize||12;return t?g(t):w.fontMetrics(b,a.getAttribute("style")?a:d).h},N=function(a,g){M(w.escapes,function(b,d){g&&-1!==p(b,g)||(a=a.toString().replace(new RegExp(b,
"g"),d))});return a},u=function(a,g){var b;b=a.indexOf("\x3c");a=a.substring(b,a.indexOf("\x3e")-b);b=a.indexOf(g+"\x3d");if(-1!==b&&(b=b+g.length+1,g=a.charAt(b),'"'===g||"'"===g))return a=a.substring(b+1),a.substring(0,a.indexOf(g))};q=[l,e,P,t,A,O,D].join();if(q!==a.textCache){for(a.textCache=q;I--;)d.removeChild(m[I]);z||A||e||D||-1!==l.indexOf(" ")?(v&&v.appendChild(d),l=z?l.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,
"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[l],l=b(l,function(a){return""!==a}),r(l,function(g,b){var l,z=0;g=g.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");l=g.split("|||");r(l,function(g){if(""!==g||1===l.length){var m={},v=k.createElementNS(w.SVG_NS,"tspan"),p,r;(p=u(g,"class"))&&h(v,"class",p);if(p=u(g,"style"))p=p.replace(/(;| |^)color([ :])/,"$1fill$2"),h(v,"style",p);(r=u(g,"href"))&&!c&&(h(v,"onclick",
'location.href\x3d"'+r+'"'),h(v,"class","highcharts-anchor"),y(v,{cursor:"pointer"}));g=N(g.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==g){v.appendChild(k.createTextNode(g));z?m.dx=0:b&&null!==B&&(m.x=B);h(v,m);d.appendChild(v);!z&&x&&(!Q&&c&&y(v,{display:"block"}),h(v,"dy",H(v)));if(D){m=g.replace(/([^\^])-/g,"$1- ").split(" ");r=1<l.length||b||1<m.length&&!P;var t=[],A,O=H(v),q=a.rotation;for(e&&(f=w.applyEllipsis(a,v,g,D));!e&&r&&(m.length||t.length);)a.rotation=0,A=w.getSpanWidth(a,v),
g=A>D,void 0===f&&(f=g),g&&1!==m.length?(v.removeChild(v.firstChild),t.unshift(m.pop())):(m=t,t=[],m.length&&!P&&(v=k.createElementNS(J,"tspan"),h(v,{dy:O,x:B}),p&&h(v,"style",p),d.appendChild(v)),A>D&&(D=A+1)),m.length&&v.appendChild(k.createTextNode(m.join(" ").replace(/- /g,"-")));a.rotation=q}z++}}});x=x||d.childNodes.length}),e&&f&&a.attr("title",N(a.textStr,["\x26lt;","\x26gt;"])),v&&v.removeChild(d),A&&a.applyTextOutline&&a.applyTextOutline(A)):d.appendChild(k.createTextNode(N(l)))}},getContrast:function(a){a=
u(a).rgba;return 510<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,g,b,d,w,c,m,f,J){var z=this.label(a,g,b,J,null,null,null,null,"button"),v=0;z.attr(D({padding:8,r:2},w));var B,k,p,r;w=D({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},w);B=w.style;delete w.style;c=D(w,{fill:"#e6e6e6"},c);k=c.style;delete c.style;m=D(w,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},m);p=m.style;delete m.style;f=D(w,{style:{color:"#cccccc"}},
f);r=f.style;delete f.style;F(z.element,L?"mouseover":"mouseenter",function(){3!==v&&z.setState(1)});F(z.element,L?"mouseout":"mouseleave",function(){3!==v&&z.setState(v)});z.setState=function(a){1!==a&&(z.state=v=a);z.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);z.attr([w,c,m,f][a||0]).css([B,k,p,r][a||0])};z.attr(w).css(l({cursor:"default"},B));return z.on("click",function(a){3!==v&&d.call(z,a)})},crispLine:function(a,
g){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-g%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+g%2/2);return a},path:function(a){var g={fill:"none"};I(a)?g.d=a:A(a)&&l(g,a);return this.createElement("path").attr(g)},circle:function(a,g,b){a=A(a)?a:{x:a,y:g,r:b};g=this.createElement("circle");g.xSetter=g.ySetter=function(a,g,b){b.setAttribute("c"+g,a)};return g.attr(a)},arc:function(a,g,b,d,w,c){A(a)?(d=a,g=d.y,b=d.r,a=d.x):d={innerR:d,start:w,end:c};a=this.symbol("arc",a,g,b,b,d);a.r=b;return a},rect:function(a,
g,b,d,w,c){w=A(a)?a.r:w;var l=this.createElement("rect");a=A(a)?a:void 0===a?{}:{x:a,y:g,width:Math.max(b,0),height:Math.max(d,0)};void 0!==c&&(a.strokeWidth=c,a=l.crisp(a));a.fill="none";w&&(a.r=w);l.rSetter=function(a,g,b){h(b,{rx:a,ry:a})};return l.attr(a)},setSize:function(a,g,b){var d=this.alignedObjects,w=d.length;this.width=a;this.height=g;for(this.boxWrapper.animate({width:a,height:g},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:G(b,!0)?
void 0:0});w--;)d[w].align()},g:function(a){var g=this.createElement("g");return a?g.attr({"class":"highcharts-"+a}):g},image:function(a,g,b,d,w,c){var m={preserveAspectRatio:"none"},f,J=function(a,g){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",g):a.setAttribute("hc-svg-href",g)},z=function(g){J(f.element,a);c.call(f,g)};1<arguments.length&&l(m,{x:g,y:b,width:d,height:w});f=this.createElement("image").attr(m);c?(J(f.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"),
m=new N.Image,F(m,"load",z),m.src=a,m.complete&&z({})):J(f.element,a);return f},symbol:function(a,g,b,d,w,c){var m=this,f,J=/^url\((.*?)\)$/,z=J.test(a),v=!z&&(this.symbols[a]?a:"circle"),B=v&&this.symbols[v],p=x(g)&&B&&B.call(this.symbols,Math.round(g),Math.round(b),d,w,c),D,t;B?(f=this.path(p),f.attr("fill","none"),l(f,{symbolName:v,x:g,y:b,width:d,height:w}),c&&l(f,c)):z&&(D=a.match(J)[1],f=this.image(D),f.imgwidth=G(O[D]&&O[D].width,c&&c.width),f.imgheight=G(O[D]&&O[D].height,c&&c.height),t=function(){f.attr({width:f.width,
height:f.height})},r(["width","height"],function(a){f[a+"Setter"]=function(a,g){var b={},d=this["img"+g],w="width"===g?"translateX":"translateY";this[g]=a;x(d)&&(this.element&&this.element.setAttribute(g,d),this.alignByTranslate||(b[w]=((this[g]||0)-d)/2,this.attr(b)))}}),x(g)&&f.attr({x:g,y:b}),f.isImg=!0,x(f.imgwidth)&&x(f.imgheight)?t():(f.attr({width:0,height:0}),q("img",{onload:function(){var a=e[m.chartIndex];0===this.width&&(y(this,{position:"absolute",top:"-999em"}),k.body.appendChild(this));
O[D]={width:this.width,height:this.height};f.imgwidth=this.width;f.imgheight=this.height;f.element&&t();this.parentNode&&this.parentNode.removeChild(this);m.imgCount--;if(!m.imgCount&&a&&a.onload)a.onload()},src:D}),this.imgCount++));return f},symbols:{circle:function(a,g,b,d){return this.arc(a+b/2,g+d/2,b/2,d/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,g,b,d){return["M",a,g,"L",a+b,g,a+b,g+d,a,g+d,"Z"]},triangle:function(a,g,b,d){return["M",a+b/2,g,"L",a+b,g+d,a,g+d,"Z"]},"triangle-down":function(a,
g,b,d){return["M",a,g,"L",a+b,g,a+b/2,g+d,"Z"]},diamond:function(a,g,b,d){return["M",a+b/2,g,"L",a+b,g+d/2,a+b/2,g+d,a,g+d/2,"Z"]},arc:function(a,g,b,d,w){var c=w.start,l=w.r||b,m=w.r||d||b,f=w.end-.001;b=w.innerR;d=G(w.open,.001>Math.abs(w.end-w.start-2*Math.PI));var J=Math.cos(c),v=Math.sin(c),z=Math.cos(f),f=Math.sin(f);w=.001>w.end-c-Math.PI?0:1;l=["M",a+l*J,g+m*v,"A",l,m,0,w,1,a+l*z,g+m*f];x(b)&&l.push(d?"M":"L",a+b*z,g+b*f,"A",b,b,0,w,0,a+b*J,g+b*v);l.push(d?"":"Z");return l},callout:function(a,
g,b,d,w){var c=Math.min(w&&w.r||0,b,d),l=c+6,m=w&&w.anchorX;w=w&&w.anchorY;var f;f=["M",a+c,g,"L",a+b-c,g,"C",a+b,g,a+b,g,a+b,g+c,"L",a+b,g+d-c,"C",a+b,g+d,a+b,g+d,a+b-c,g+d,"L",a+c,g+d,"C",a,g+d,a,g+d,a,g+d-c,"L",a,g+c,"C",a,g,a,g,a+c,g];m&&m>b?w>g+l&&w<g+d-l?f.splice(13,3,"L",a+b,w-6,a+b+6,w,a+b,w+6,a+b,g+d-c):f.splice(13,3,"L",a+b,d/2,m,w,a+b,d/2,a+b,g+d-c):m&&0>m?w>g+l&&w<g+d-l?f.splice(33,3,"L",a,w+6,a-6,w,a,w-6,a,g+c):f.splice(33,3,"L",a,d/2,m,w,a,d/2,a,g+c):w&&w>d&&m>a+l&&m<a+b-l?f.splice(23,
3,"L",m+6,g+d,m,g+d+6,m-6,g+d,a+c,g+d):w&&0>w&&m>a+l&&m<a+b-l&&f.splice(3,3,"L",m-6,g,m,g-6,m+6,g,b-c,g);return f}},clipRect:function(g,b,d,w){var c=a.uniqueKey(),l=this.createElement("clipPath").attr({id:c}).add(this.defs);g=this.rect(g,b,d,w,0).add(l);g.id=c;g.clipPath=l;g.count=0;return g},text:function(a,g,b,d){var w={};if(d&&(this.allowHTML||!this.forExport))return this.html(a,g,b);w.x=Math.round(g||0);b&&(w.y=Math.round(b));if(a||0===a)w.text=a;a=this.createElement("text").attr(w);d||(a.xSetter=
function(a,g,b){var d=b.getElementsByTagName("tspan"),w,c=b.getAttribute(g),l;for(l=0;l<d.length;l++)w=d[l],w.getAttribute(g)===c&&w.setAttribute(g,a);b.setAttribute(g,a)});return a},fontMetrics:function(a,b){a=a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?g(a):/em/.test(a)?parseFloat(a)*(b?this.fontMetrics(null,b.parentNode).f:16):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,g,b){var d=a;g&&b&&(d=Math.max(d*Math.cos(g*f),
4));return{x:-a/3*Math.sin(g*f),y:d}},label:function(g,b,d,c,m,f,J,v,B){var k=this,p=k.g("button"!==B&&"label"),t=p.text=k.text("",0,0,J).attr({zIndex:1}),z,A,Q=0,e=3,P=0,h,O,q,G,I,H={},N,y,M=/^url\((.*?)\)$/.test(c),u=M,n,L,R,U;B&&p.addClass("highcharts-"+B);u=M;n=function(){return(N||0)%2/2};L=function(){var a=t.element.style,g={};A=(void 0===h||void 0===O||I)&&x(t.textStr)&&t.getBBox();p.width=(h||A.width||0)+2*e+P;p.height=(O||A.height||0)+2*e;y=e+k.fontMetrics(a&&a.fontSize,t).b;u&&(z||(p.box=
z=k.symbols[c]||M?k.symbol(c):k.rect(),z.addClass(("button"===B?"":"highcharts-label-box")+(B?" highcharts-"+B+"-box":"")),z.add(p),a=n(),g.x=a,g.y=(v?-y:0)+a),g.width=Math.round(p.width),g.height=Math.round(p.height),z.attr(l(g,H)),H={})};R=function(){var a=P+e,g;g=v?0:y;x(h)&&A&&("center"===I||"right"===I)&&(a+={center:.5,right:1}[I]*(h-A.width));if(a!==t.x||g!==t.y)t.attr("x",a),t.hasBoxWidthChanged&&(A=t.getBBox(!0),L()),void 0!==g&&t.attr("y",g);t.x=a;t.y=g};U=function(a,g){z?z.attr(a,g):H[a]=
g};p.onAdd=function(){t.add(p);p.attr({text:g||0===g?g:"",x:b,y:d});z&&x(m)&&p.attr({anchorX:m,anchorY:f})};p.widthSetter=function(g){h=a.isNumber(g)?g:null};p.heightSetter=function(a){O=a};p["text-alignSetter"]=function(a){I=a};p.paddingSetter=function(a){x(a)&&a!==e&&(e=p.padding=a,R())};p.paddingLeftSetter=function(a){x(a)&&a!==P&&(P=a,R())};p.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==Q&&(Q=a,A&&p.attr({x:q}))};p.textSetter=function(a){void 0!==a&&t.textSetter(a);L();R()};p["stroke-widthSetter"]=
function(a,g){a&&(u=!0);N=this["stroke-width"]=a;U(g,a)};p.strokeSetter=p.fillSetter=p.rSetter=function(a,g){"r"!==g&&("fill"===g&&a&&(u=!0),p[g]=a);U(g,a)};p.anchorXSetter=function(a,g){m=p.anchorX=a;U(g,Math.round(a)-n()-q)};p.anchorYSetter=function(a,g){f=p.anchorY=a;U(g,a-G)};p.xSetter=function(a){p.x=a;Q&&(a-=Q*((h||A.width)+2*e),p["forceAnimate:x"]=!0);q=Math.round(a);p.attr("translateX",q)};p.ySetter=function(a){G=p.y=Math.round(a);p.attr("translateY",G)};var S=p.css;return l(p,{css:function(a){if(a){var g=
{};a=D(a);r(p.textProps,function(b){void 0!==a[b]&&(g[b]=a[b],delete a[b])});t.css(g);"width"in g&&L()}return S.call(p,a)},getBBox:function(){return{width:A.width+2*e,height:A.height+2*e,x:A.x-e,y:A.y-e}},shadow:function(a){a&&(L(),z&&z.shadow(a));return p},destroy:function(){w(p.element,"mouseenter");w(p.element,"mouseleave");t&&(t=t.destroy());z&&(z=z.destroy());C.prototype.destroy.call(p);p=k=L=R=U=null}})}});a.Renderer=E})(K);(function(a){var C=a.attr,E=a.createElement,F=a.css,n=a.defined,h=a.each,
e=a.extend,u=a.isFirefox,y=a.isMS,q=a.isWebKit,x=a.pick,f=a.pInt,c=a.SVGRenderer,k=a.win,r=a.wrap;e(a.SVGElement.prototype,{htmlCss:function(a){var d=this.element;if(d=a&&"SPAN"===d.tagName&&a.width)delete a.width,this.textWidth=d,this.htmlUpdateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=e(this.styles,a);F(this.element,a);return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},
htmlUpdateTransform:function(){if(this.added){var a=this.renderer,d=this.element,b=this.translateX||0,c=this.translateY||0,p=this.x||0,k=this.y||0,t=this.textAlign||"left",r={left:0,center:.5,right:1}[t],A=this.styles,e=A&&A.whiteSpace;F(d,{marginLeft:b,marginTop:c});this.shadows&&h(this.shadows,function(a){F(a,{marginLeft:b+1,marginTop:c+1})});this.inverted&&h(d.childNodes,function(b){a.invertChild(b,d)});if("SPAN"===d.tagName){var A=this.rotation,m=this.textWidth&&f(this.textWidth),D=[A,t,d.innerHTML,
this.textWidth,this.textAlign].join(),B;(B=m!==this.oldTextWidth)&&!(B=m>this.oldTextWidth)&&((B=this.textPxLength)||(F(d,{width:"",whiteSpace:e||"nowrap"}),B=d.offsetWidth),B=B>m);B&&/[ \-]/.test(d.textContent||d.innerText)?(F(d,{width:m+"px",display:"block",whiteSpace:e||"normal"}),this.oldTextWidth=m,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;D!==this.cTT&&(e=a.fontMetrics(d.style.fontSize).b,n(A)&&A!==(this.oldRotation||0)&&this.setSpanRotation(A,r,e),this.getSpanCorrection(!n(A)&&
this.textPxLength||d.offsetWidth,e,r,A,t));F(d,{left:p+(this.xCorr||0)+"px",top:k+(this.yCorr||0)+"px"});this.cTT=D;this.oldRotation=A}}else this.alignOnAdd=!0},setSpanRotation:function(a,d,b){var c={},l=this.renderer.getTransformKey();c[l]=c.transform="rotate("+a+"deg)";c[l+(u?"Origin":"-origin")]=c.transformOrigin=100*d+"% "+b+"px";F(this.element,c)},getSpanCorrection:function(a,d,b){this.xCorr=-a*b;this.yCorr=-d}});e(c.prototype,{getTransformKey:function(){return y&&!/Edge/.test(k.navigator.userAgent)?
"-ms-transform":q?"-webkit-transform":u?"MozTransform":k.opera?"-o-transform":""},html:function(a,d,b){var c=this.createElement("span"),l=c.element,f=c.renderer,k=f.isSVG,q=function(a,b){h(["opacity","visibility"],function(d){r(a,d+"Setter",function(a,d,c,m){a.call(this,d,c,m);b[c]=d})});a.addedSetters=!0};c.textSetter=function(a){a!==l.innerHTML&&delete this.bBox;this.textStr=a;l.innerHTML=x(a,"");c.doTransform=!0};k&&q(c,c.element.style);c.xSetter=c.ySetter=c.alignSetter=c.rotationSetter=function(a,
b){"align"===b&&(b="textAlign");c[b]=a;c.doTransform=!0};c.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};c.attr({text:a,x:Math.round(d),y:Math.round(b)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});l.style.whiteSpace="nowrap";c.css=c.htmlCss;k&&(c.add=function(a){var b,d=f.box.parentNode,p=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)p.push(a),a=a.parentGroup;h(p.reverse(),function(a){function m(g,b){a[b]=
g;"translateX"===b?l.left=g+"px":l.top=g+"px";a.doTransform=!0}var l,g=C(a.element,"class");g&&(g={className:g});b=a.div=a.div||E("div",g,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||d);l=b.style;e(a,{classSetter:function(a){return function(g){this.element.setAttribute("class",g);a.className=g}}(b),on:function(){p[0].div&&c.on.apply({element:p[0].div},arguments);return a},translateXSetter:m,
translateYSetter:m});a.addedSetters||q(a,l)})}}else b=d;b.appendChild(l);c.added=!0;c.alignOnAdd&&c.htmlUpdateTransform();return c});return c}})})(K);(function(a){var C=a.defined,E=a.each,F=a.extend,n=a.merge,h=a.pick,e=a.timeUnits,u=a.win;a.Time=function(a){this.update(a,!1)};a.Time.prototype={defaultOptions:{},update:function(e){var q=h(e&&e.useUTC,!0),x=this;this.options=e=n(!0,this.options||{},e);this.Date=e.Date||u.Date;this.timezoneOffset=(this.useUTC=q)&&e.timezoneOffset;this.getTimezoneOffset=
this.timezoneOffsetFunction();(this.variableTimezone=!(q&&!e.getTimezoneOffset&&!e.timezone))||this.timezoneOffset?(this.get=function(a,c){var f=c.getTime(),r=f-x.getTimezoneOffset(c);c.setTime(r);a=c["getUTC"+a]();c.setTime(f);return a},this.set=function(f,c,k){var r;if(-1!==a.inArray(f,["Milliseconds","Seconds","Minutes"]))c["set"+f](k);else r=x.getTimezoneOffset(c),r=c.getTime()-r,c.setTime(r),c["setUTC"+f](k),f=x.getTimezoneOffset(c),r=c.getTime()+f,c.setTime(r)}):q?(this.get=function(a,c){return c["getUTC"+
a]()},this.set=function(a,c,k){return c["setUTC"+a](k)}):(this.get=function(a,c){return c["get"+a]()},this.set=function(a,c,k){return c["set"+a](k)})},makeTime:function(e,q,x,f,c,k){var r,l,d;this.useUTC?(r=this.Date.UTC.apply(0,arguments),l=this.getTimezoneOffset(r),r+=l,d=this.getTimezoneOffset(r),l!==d?r+=d-l:l-36E5!==this.getTimezoneOffset(r-36E5)||a.isSafari||(r-=36E5)):r=(new this.Date(e,q,h(x,1),h(f,0),h(c,0),h(k,0))).getTime();return r},timezoneOffsetFunction:function(){var e=this,h=this.options,
x=u.moment;if(!this.useUTC)return function(a){return 6E4*(new Date(a)).getTimezoneOffset()};if(h.timezone){if(x)return function(a){return 6E4*-x.tz(a,h.timezone).utcOffset()};a.error(25)}return this.useUTC&&h.getTimezoneOffset?function(a){return 6E4*h.getTimezoneOffset(a)}:function(){return 6E4*(e.timezoneOffset||0)}},dateFormat:function(e,h,x){if(!a.defined(h)||isNaN(h))return a.defaultOptions.lang.invalidDate||"";e=a.pick(e,"%Y-%m-%d %H:%M:%S");var f=this,c=new this.Date(h),k=this.get("Hours",c),
r=this.get("Day",c),l=this.get("Date",c),d=this.get("Month",c),b=this.get("FullYear",c),v=a.defaultOptions.lang,p=v.weekdays,q=v.shortWeekdays,t=a.pad,c=a.extend({a:q?q[r]:p[r].substr(0,3),A:p[r],d:t(l),e:t(l,2," "),w:r,b:v.shortMonths[d],B:v.months[d],m:t(d+1),o:d+1,y:b.toString().substr(2,2),Y:b,H:t(k),k:k,I:t(k%12||12),l:k%12||12,M:t(f.get("Minutes",c)),p:12>k?"AM":"PM",P:12>k?"am":"pm",S:t(c.getSeconds()),L:t(Math.round(h%1E3),3)},a.dateFormats);a.objectEach(c,function(a,b){for(;-1!==e.indexOf("%"+
b);)e=e.replace("%"+b,"function"===typeof a?a.call(f,h):a)});return x?e.substr(0,1).toUpperCase()+e.substr(1):e},getTimeTicks:function(a,q,x,f){var c=this,k=[],r={},l,d=new c.Date(q),b=a.unitRange,v=a.count||1,p;if(C(q)){c.set("Milliseconds",d,b>=e.second?0:v*Math.floor(c.get("Milliseconds",d)/v));b>=e.second&&c.set("Seconds",d,b>=e.minute?0:v*Math.floor(c.get("Seconds",d)/v));b>=e.minute&&c.set("Minutes",d,b>=e.hour?0:v*Math.floor(c.get("Minutes",d)/v));b>=e.hour&&c.set("Hours",d,b>=e.day?0:v*Math.floor(c.get("Hours",
d)/v));b>=e.day&&c.set("Date",d,b>=e.month?1:v*Math.floor(c.get("Date",d)/v));b>=e.month&&(c.set("Month",d,b>=e.year?0:v*Math.floor(c.get("Month",d)/v)),l=c.get("FullYear",d));b>=e.year&&c.set("FullYear",d,l-l%v);b===e.week&&c.set("Date",d,c.get("Date",d)-c.get("Day",d)+h(f,1));l=c.get("FullYear",d);f=c.get("Month",d);var I=c.get("Date",d),t=c.get("Hours",d);q=d.getTime();c.variableTimezone&&(p=x-q>4*e.month||c.getTimezoneOffset(q)!==c.getTimezoneOffset(x));d=d.getTime();for(q=1;d<x;)k.push(d),d=
b===e.year?c.makeTime(l+q*v,0):b===e.month?c.makeTime(l,f+q*v):!p||b!==e.day&&b!==e.week?p&&b===e.hour&&1<v?c.makeTime(l,f,I,t+q*v):d+b*v:c.makeTime(l,f,I+q*v*(b===e.day?1:7)),q++;k.push(d);b<=e.hour&&1E4>k.length&&E(k,function(a){0===a%18E5&&"000000000"===c.dateFormat("%H%M%S%L",a)&&(r[a]="day")})}k.info=F(a,{higherRanks:r,totalRange:b*v});return k}}})(K);(function(a){var C=a.color,E=a.merge;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),
symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:a.Time.prototype.defaultOptions,
chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",
labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",
position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:C("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(C){a.defaultOptions=E(!0,a.defaultOptions,C);a.time.update(E(a.defaultOptions.global,
a.defaultOptions.time),!1);return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;a.time=new a.Time(E(a.defaultOptions.global,a.defaultOptions.time));a.dateFormat=function(C,n,h){return a.time.dateFormat(C,n,h)}})(K);(function(a){var C=a.correctFloat,E=a.defined,F=a.destroyObjectProperties,n=a.fireEvent,h=a.isNumber,e=a.merge,u=a.pick,y=a.deg2rad;a.Tick=function(a,e,f,c){this.axis=a;this.pos=e;this.type=f||"";this.isNewLabel=this.isNew=
!0;f||c||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,h=a.options,f=a.chart,c=a.categories,k=a.names,r=this.pos,l=h.labels,d=a.tickPositions,b=r===d[0],v=r===d[d.length-1],k=c?u(c[r],k[r],r):r,c=this.label,d=d.info,p;a.isDatetimeAxis&&d&&(p=h.dateTimeLabelFormats[d.higherRanks[r]||d.unitName]);this.isFirst=b;this.isLast=v;h=a.labelFormatter.call({axis:a,chart:f,isFirst:b,isLast:v,dateTimeLabelFormat:p,value:a.isLog?C(a.lin2log(k)):k,pos:r});if(E(c))c&&c.attr({text:h});else{if(this.label=
c=E(h)&&l.enabled?f.renderer.text(h,0,0,l.useHTML).css(e(l.style)).add(a.labelGroup):null)c.textPxLength=c.getBBox().width;this.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var e=this.axis,f=e.options.labels,c=a.x,k=e.chart.chartWidth,r=e.chart.spacing,l=u(e.labelLeft,Math.min(e.pos,r[3])),r=u(e.labelRight,Math.max(e.isRadial?0:e.pos+e.len,k-r[1])),d=this.label,b=this.rotation,v={left:0,center:.5,right:1}[e.labelAlign||
d.attr("align")],p=d.getBBox().width,h=e.getSlotWidth(this),t=h,q=1,A,H={};if(b||!1===f.overflow)0>b&&c-v*p<l?A=Math.round(c/Math.cos(b*y)-l):0<b&&c+v*p>r&&(A=Math.round((k-c)/Math.cos(b*y)));else if(k=c+(1-v)*p,c-v*p<l?t=a.x+t*(1-v)-l:k>r&&(t=r-a.x+t*v,q=-1),t=Math.min(h,t),t<h&&"center"===e.labelAlign&&(a.x+=q*(h-t-v*(h-Math.min(p,t)))),p>t||e.autoRotation&&(d.styles||{}).width)A=t;A&&(H.width=A,(f.style||{}).textOverflow||(H.textOverflow="ellipsis"),d.css(H))},getPosition:function(e,h,f,c){var k=
this.axis,r=k.chart,l=c&&r.oldChartHeight||r.chartHeight;e={x:e?a.correctFloat(k.translate(h+f,null,null,c)+k.transB):k.left+k.offset+(k.opposite?(c&&r.oldChartWidth||r.chartWidth)-k.right-k.left:0),y:e?l-k.bottom+k.offset-(k.opposite?k.height:0):a.correctFloat(l-k.translate(h+f,null,null,c)-k.transB)};n(this,"afterGetPosition",{pos:e});return e},getLabelPosition:function(a,e,f,c,k,r,l,d){var b=this.axis,v=b.transA,p=b.reversed,h=b.staggerLines,t=b.tickRotCorr||{x:0,y:0},q=k.y,A=c||b.reserveSpaceDefault?
0:-b.labelOffset*("center"===b.labelAlign?.5:1),x={};E(q)||(q=0===b.side?f.rotation?-8:-f.getBBox().height:2===b.side?t.y+8:Math.cos(f.rotation*y)*(t.y-f.getBBox(!1,0).height/2));a=a+k.x+A+t.x-(r&&c?r*v*(p?-1:1):0);e=e+q-(r&&!c?r*v*(p?1:-1):0);h&&(f=l/(d||1)%h,b.opposite&&(f=h-f-1),e+=b.labelOffset/h*f);x.x=a;x.y=Math.round(e);n(this,"afterGetLabelPosition",{pos:x});return x},getMarkPath:function(a,e,f,c,k,r){return r.crispLine(["M",a,e,"L",a+(k?0:-f),e+(k?f:0)],c)},renderGridLine:function(a,e,f){var c=
this.axis,k=c.options,r=this.gridLine,l={},d=this.pos,b=this.type,v=c.tickmarkOffset,p=c.chart.renderer,h=b?b+"Grid":"grid",t=k[h+"LineWidth"],q=k[h+"LineColor"],k=k[h+"LineDashStyle"];r||(l.stroke=q,l["stroke-width"]=t,k&&(l.dashstyle=k),b||(l.zIndex=1),a&&(l.opacity=0),this.gridLine=r=p.path().attr(l).addClass("highcharts-"+(b?b+"-":"")+"grid-line").add(c.gridGroup));if(!a&&r&&(a=c.getPlotLinePath(d+v,r.strokeWidth()*f,a,!0)))r[this.isNew?"attr":"animate"]({d:a,opacity:e})},renderMark:function(a,
e,f){var c=this.axis,k=c.options,r=c.chart.renderer,l=this.type,d=l?l+"Tick":"tick",b=c.tickSize(d),v=this.mark,p=!v,h=a.x;a=a.y;var t=u(k[d+"Width"],!l&&c.isXAxis?1:0),k=k[d+"Color"];b&&(c.opposite&&(b[0]=-b[0]),p&&(this.mark=v=r.path().addClass("highcharts-"+(l?l+"-":"")+"tick").add(c.axisGroup),v.attr({stroke:k,"stroke-width":t})),v[p?"attr":"animate"]({d:this.getMarkPath(h,a,b[0],v.strokeWidth()*f,c.horiz,r),opacity:e}))},renderLabel:function(a,e,f,c){var k=this.axis,r=k.horiz,l=k.options,d=this.label,
b=l.labels,v=b.step,k=k.tickmarkOffset,p=!0,I=a.x;a=a.y;d&&h(I)&&(d.xy=a=this.getLabelPosition(I,a,d,r,b,k,c,v),this.isFirst&&!this.isLast&&!u(l.showFirstLabel,1)||this.isLast&&!this.isFirst&&!u(l.showLastLabel,1)?p=!1:!r||b.step||b.rotation||e||0===f||this.handleOverflow(a),v&&c%v&&(p=!1),p&&h(a.y)?(a.opacity=f,d[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(d.attr("y",-9999),this.isNewLabel=!0))},render:function(e,h,f){var c=this.axis,k=c.horiz,r=this.getPosition(k,this.pos,c.tickmarkOffset,
h),l=r.x,d=r.y,c=k&&l===c.pos+c.len||!k&&d===c.pos?-1:1;f=u(f,1);this.isActive=!0;this.renderGridLine(h,f,c);this.renderMark(r,f,c);this.renderLabel(r,h,f,e);this.isNew=!1;a.fireEvent(this,"afterRender")},destroy:function(){F(this,this.axis)}}})(K);var V=function(a){var C=a.addEvent,E=a.animObject,F=a.arrayMax,n=a.arrayMin,h=a.color,e=a.correctFloat,u=a.defaultOptions,y=a.defined,q=a.deg2rad,x=a.destroyObjectProperties,f=a.each,c=a.extend,k=a.fireEvent,r=a.format,l=a.getMagnitude,d=a.grep,b=a.inArray,
v=a.isArray,p=a.isNumber,I=a.isString,t=a.merge,L=a.normalizeTickInterval,A=a.objectEach,H=a.pick,m=a.removeEvent,D=a.splat,B=a.syncTimeout,M=a.Tick,G=function(){this.init.apply(this,arguments)};a.extend(G.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},x:0},maxPadding:.01,minorTickLength:2,
minorTickPosition:"outside",minPadding:.01,startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,minPadding:.05,startOnTick:!0,
title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},
title:{rotation:0}},init:function(a,d){var g=d.isX,w=this;w.chart=a;w.horiz=a.inverted&&!w.isZAxis?!g:g;w.isXAxis=g;w.coll=w.coll||(g?"xAxis":"yAxis");k(this,"init",{userOptions:d});w.opposite=d.opposite;w.side=d.side||(w.horiz?w.opposite?0:2:w.opposite?1:3);w.setOptions(d);var c=this.options,m=c.type;w.labelFormatter=c.labels.formatter||w.defaultLabelFormatter;w.userOptions=d;w.minPixelPadding=0;w.reversed=c.reversed;w.visible=!1!==c.visible;w.zoomEnabled=!1!==c.zoomEnabled;w.hasNames="category"===
m||!0===c.categories;w.categories=c.categories||w.hasNames;w.names||(w.names=[],w.names.keys={});w.plotLinesAndBandsGroups={};w.isLog="logarithmic"===m;w.isDatetimeAxis="datetime"===m;w.positiveValuesOnly=w.isLog&&!w.allowNegativeLog;w.isLinked=y(c.linkedTo);w.ticks={};w.labelEdge=[];w.minorTicks={};w.plotLinesAndBands=[];w.alternateBands={};w.len=0;w.minRange=w.userMinRange=c.minRange||c.maxZoom;w.range=c.range;w.offset=c.offset||0;w.stacks={};w.oldStacks={};w.stacksTouched=0;w.max=null;w.min=null;
w.crosshair=H(c.crosshair,D(a.options.tooltip.crosshairs)[g?0:1],!1);d=w.options.events;-1===b(w,a.axes)&&(g?a.axes.splice(a.xAxis.length,0,w):a.axes.push(w),a[w.coll].push(w));w.series=w.series||[];a.inverted&&!w.isZAxis&&g&&void 0===w.reversed&&(w.reversed=!0);A(d,function(a,g){C(w,g,a)});w.lin2log=c.linearToLogConverter||w.lin2log;w.isLog&&(w.val2lin=w.log2lin,w.lin2val=w.lin2log);k(this,"afterInit")},setOptions:function(a){this.options=t(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,
[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],t(u[this.coll],a));k(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var g=this.axis,b=this.value,d=g.chart.time,c=g.categories,m=this.dateTimeLabelFormat,l=u.lang,f=l.numericSymbols,l=l.numericSymbolMagnitude||1E3,p=f&&f.length,k,v=g.options.labels.format,g=g.isLog?Math.abs(b):g.tickInterval;if(v)k=r(v,this,d);else if(c)k=b;else if(m)k=d.dateFormat(m,
b);else if(p&&1E3<=g)for(;p--&&void 0===k;)d=Math.pow(l,p+1),g>=d&&0===10*b%d&&null!==f[p]&&0!==b&&(k=a.numberFormat(b/d,-1)+f[p]);void 0===k&&(k=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,-1,void 0,""));return k},getSeriesExtremes:function(){var a=this,b=a.chart;k(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();f(a.series,function(g){if(g.visible||!b.options.chart.ignoreHiddenSeries){var w=
g.options,c=w.threshold,m;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=c&&(c=null);if(a.isXAxis)w=g.xData,w.length&&(g=n(w),m=F(w),p(g)||g instanceof Date||(w=d(w,p),g=n(w),m=F(w)),w.length&&(a.dataMin=Math.min(H(a.dataMin,w[0],g),g),a.dataMax=Math.max(H(a.dataMax,w[0],m),m)));else if(g.getExtremes(),m=g.dataMax,g=g.dataMin,y(g)&&y(m)&&(a.dataMin=Math.min(H(a.dataMin,g),g),a.dataMax=Math.max(H(a.dataMax,m),m)),y(c)&&(a.threshold=c),!w.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});
k(this,"afterGetSeriesExtremes")},translate:function(a,b,d,c,m,l){var g=this.linkedParent||this,w=1,f=0,J=c?g.oldTransA:g.transA;c=c?g.oldMin:g.min;var k=g.minPixelPadding;m=(g.isOrdinal||g.isBroken||g.isLog&&m)&&g.lin2val;J||(J=g.transA);d&&(w*=-1,f=g.len);g.reversed&&(w*=-1,f-=w*(g.sector||g.len));b?(a=(a*w+f-k)/J+c,m&&(a=g.lin2val(a))):(m&&(a=g.val2lin(a)),a=p(c)?w*(a-c)*J+f+w*k+(p(l)?J*l:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},
toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,d,c,m){var g=this.chart,w=this.left,l=this.top,f,J,k=d&&g.oldChartHeight||g.chartHeight,v=d&&g.oldChartWidth||g.chartWidth,e;f=this.transB;var B=function(a,g,b){if(a<g||a>b)c?a=Math.min(Math.max(g,a),b):e=!0;return a};m=H(m,this.translate(a,null,null,d));m=Math.min(Math.max(-1E5,m),1E5);a=d=Math.round(m+f);f=J=Math.round(k-m-f);p(m)?this.horiz?(f=l,J=k-this.bottom,a=d=B(a,w,w+this.width)):
(a=w,d=v-this.right,f=J=B(f,l,l+this.height)):(e=!0,c=!1);return e&&!c?null:g.renderer.crispLine(["M",a,f,"L",d,J],b||1)},getLinearTickPositions:function(a,b,d){var g,w=e(Math.floor(b/a)*a);d=e(Math.ceil(d/a)*a);var c=[],m;e(w+a)===w&&(m=20);if(this.single)return[b];for(b=w;b<=d;){c.push(b);b=e(b+a,m);if(b===g)break;g=b}return c},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?H(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=
this,b=a.options,d=a.tickPositions,c=a.minorTickInterval,m=[],l=a.pointRangePadding||0,p=a.min-l,l=a.max+l,k=l-p;if(k&&k/c<a.len/3)if(a.isLog)f(this.paddedTicks,function(g,b,d){b&&m.push.apply(m,a.getLogTickPositions(c,d[b-1],d[b],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())m=m.concat(a.getTimeTicks(a.normalizeTimeTickInterval(c),p,l,b.startOfWeek));else for(b=p+(d[0]-p)%c;b<=l&&b!==m[0];b+=c)m.push(b);0!==m.length&&a.trimTicks(m);return m},adjustForMinRange:function(){var a=
this.options,b=this.min,d=this.max,c,m,l,p,k,v,e,B;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(y(a.min)||y(a.max)?this.minRange=null:(f(this.series,function(a){v=a.xData;for(p=e=a.xIncrement?1:v.length-1;0<p;p--)if(k=v[p]-v[p-1],void 0===l||k<l)l=k}),this.minRange=Math.min(5*l,this.dataMax-this.dataMin)));d-b<this.minRange&&(m=this.dataMax-this.dataMin>=this.minRange,B=this.minRange,c=(B-d+b)/2,c=[b-c,H(a.min,b-c)],m&&(c[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=F(c),d=[b+B,
H(a.max,b+B)],m&&(d[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),d=n(d),d-b<B&&(c[0]=d-B,c[1]=H(a.min,d-B),b=F(c)));this.min=b;this.max=d},getClosest:function(){var a;this.categories?a=1:f(this.series,function(g){var b=g.closestPointRange,d=g.visible||!g.chart.options.chart.ignoreHiddenSeries;!g.noSharedTooltip&&y(b)&&d&&(a=y(a)?Math.min(a,b):b)});return a},nameToX:function(a){var g=v(this.categories),d=g?this.categories:this.names,c=a.options.x,m;a.series.requireSorting=!1;y(c)||(c=!1===
this.options.uniqueNames?a.series.autoIncrement():g?b(a.name,d):H(d.keys[a.name],-1));-1===c?g||(m=d.length):m=c;void 0!==m&&(this.names[m]=a.name,this.names.keys[a.name]=m);return m},updateNames:function(){var g=this,b=this.names;0<b.length&&(f(a.keys(b.keys),function(a){delete b.keys[a]}),b.length=0,this.minRange=this.userMinRange,f(this.series||[],function(a){a.xIncrement=null;if(!a.points||a.isDirtyData)a.processData(),a.generatePoints();f(a.points,function(b,d){var c;b.options&&(c=g.nameToX(b),
void 0!==c&&c!==b.x&&(b.x=c,a.xData[d]=c))})}))},setAxisTranslation:function(a){var b=this,g=b.max-b.min,d=b.axisPointRange||0,c,m=0,l=0,p=b.linkedParent,v=!!b.categories,B=b.transA,e=b.isXAxis;if(e||v||d)c=b.getClosest(),p?(m=p.minPointOffset,l=p.pointRangePadding):f(b.series,function(a){var g=v?1:e?H(a.options.pointRange,c,0):b.axisPointRange||0;a=a.options.pointPlacement;d=Math.max(d,g);b.single||(m=Math.max(m,I(a)?0:g/2),l=Math.max(l,"on"===a?0:g))}),p=b.ordinalSlope&&c?b.ordinalSlope/c:1,b.minPointOffset=
m*=p,b.pointRangePadding=l*=p,b.pointRange=Math.min(d,g),e&&(b.closestPointRange=c);a&&(b.oldTransA=B);b.translationSlope=b.transA=B=b.options.staticScale||b.len/(g+l||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=B*m;k(this,"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(b){var g=this,d=g.chart,c=g.options,m=g.isLog,v=g.isDatetimeAxis,B=g.isXAxis,t=g.isLinked,r=c.maxPadding,D=c.minPadding,h=c.tickInterval,A=c.tickPixelInterval,G=g.categories,
I=p(g.threshold)?g.threshold:null,x=g.softThreshold,q,u,M,n;v||G||t||this.getTickAmount();M=H(g.userMin,c.min);n=H(g.userMax,c.max);t?(g.linkedParent=d[g.coll][c.linkedTo],d=g.linkedParent.getExtremes(),g.min=H(d.min,d.dataMin),g.max=H(d.max,d.dataMax),c.type!==g.linkedParent.options.type&&a.error(11,1)):(!x&&y(I)&&(g.dataMin>=I?(q=I,D=0):g.dataMax<=I&&(u=I,r=0)),g.min=H(M,q,g.dataMin),g.max=H(n,u,g.dataMax));m&&(g.positiveValuesOnly&&!b&&0>=Math.min(g.min,H(g.dataMin,g.min))&&a.error(10,1),g.min=
e(g.log2lin(g.min),15),g.max=e(g.log2lin(g.max),15));g.range&&y(g.max)&&(g.userMin=g.min=M=Math.max(g.dataMin,g.minFromRange()),g.userMax=n=g.max,g.range=null);k(g,"foundExtremes");g.beforePadding&&g.beforePadding();g.adjustForMinRange();!(G||g.axisPointRange||g.usePercentage||t)&&y(g.min)&&y(g.max)&&(d=g.max-g.min)&&(!y(M)&&D&&(g.min-=d*D),!y(n)&&r&&(g.max+=d*r));p(c.softMin)&&!p(g.userMin)&&(g.min=Math.min(g.min,c.softMin));p(c.softMax)&&!p(g.userMax)&&(g.max=Math.max(g.max,c.softMax));p(c.floor)&&
(g.min=Math.max(g.min,c.floor));p(c.ceiling)&&(g.max=Math.min(g.max,c.ceiling));x&&y(g.dataMin)&&(I=I||0,!y(M)&&g.min<I&&g.dataMin>=I?g.min=I:!y(n)&&g.max>I&&g.dataMax<=I&&(g.max=I));g.tickInterval=g.min===g.max||void 0===g.min||void 0===g.max?1:t&&!h&&A===g.linkedParent.options.tickPixelInterval?h=g.linkedParent.tickInterval:H(h,this.tickAmount?(g.max-g.min)/Math.max(this.tickAmount-1,1):void 0,G?1:(g.max-g.min)*A/Math.max(g.len,A));B&&!b&&f(g.series,function(a){a.processData(g.min!==g.oldMin||g.max!==
g.oldMax)});g.setAxisTranslation(!0);g.beforeSetTickPositions&&g.beforeSetTickPositions();g.postProcessTickInterval&&(g.tickInterval=g.postProcessTickInterval(g.tickInterval));g.pointRange&&!h&&(g.tickInterval=Math.max(g.pointRange,g.tickInterval));b=H(c.minTickInterval,g.isDatetimeAxis&&g.closestPointRange);!h&&g.tickInterval<b&&(g.tickInterval=b);v||m||h||(g.tickInterval=L(g.tickInterval,null,l(g.tickInterval),H(c.allowDecimals,!(.5<g.tickInterval&&5>g.tickInterval&&1E3<g.max&&9999>g.max)),!!this.tickAmount));
this.tickAmount||(g.tickInterval=g.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,d=a.tickPositions;b=this.getMinorTickInterval();var c=a.tickPositioner,m=a.startOnTick,l=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===b&&this.tickInterval?this.tickInterval/5:b;this.single=this.min===this.max&&y(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);
this.tickPositions=b=d&&d.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()],b[0]===b[1]&&(b.length=1)),this.tickPositions=b,c&&(c=c.apply(this,[this.min,this.max])))&&(this.tickPositions=
b=c);this.paddedTicks=b.slice(0);this.trimTicks(b,m,l);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),d||c||this.adjustTickAmount());k(this,"afterSetTickPositions")},trimTicks:function(a,b,d){var g=a[0],c=a[a.length-1],m=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==g)this.min=g;else for(;this.min-m>a[0];)a.shift();if(d)this.max=c;else for(;this.max+m<a[a.length-1];)a.pop();0===a.length&&y(g)&&!this.options.tickPositions&&a.push((c+g)/2)}},alignToOthers:function(){var a=
{},b,d=this.options;!1===this.chart.options.chart.alignTicks||!1===d.alignTicks||!1===d.startOnTick||!1===d.endOnTick||this.isLog||f(this.chart[this.coll],function(g){var d=g.options,d=[g.horiz?d.left:d.top,d.width,d.height,d.pane].join();g.series.length&&(a[d]?b=!0:a[d]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,d=a.tickPixelInterval;!y(a.tickInterval)&&this.len<d&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/
d)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,d=this.tickAmount,c=this.finalTickAmt,m=b&&b.length,l=H(this.threshold,this.softThreshold?0:null);if(this.hasData()){if(m<d){for(;b.length<d;)b.length%2||this.min===l?b.push(e(b[b.length-1]+a)):b.unshift(e(b[0]-a));this.transA*=(m-1)/(d-1);this.min=b[0];this.max=b[b.length-1]}else m>d&&(this.tickInterval*=2,this.setTickPositions());if(y(c)){for(a=d=b.length;a--;)(3===c&&
1===a%2||2>=c&&0<a&&a<d-1)&&b.splice(a,1);this.finalTickAmt=void 0}}},setScale:function(){var a,b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;f(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),
this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();k(this,"afterSetScale")},setExtremes:function(a,b,d,m,l){var g=this,p=g.chart;d=H(d,!0);f(g.series,function(a){delete a.kdTree});l=c(l,{min:a,max:b});k(g,"setExtremes",l,function(){g.userMin=a;g.userMax=b;g.eventArgs=l;d&&p.redraw(m)})},zoom:function(a,b){var g=this.dataMin,d=this.dataMax,c=this.options,
m=Math.min(g,H(c.min,g)),c=Math.max(d,H(c.max,d));if(a!==this.min||b!==this.max)this.allowZoomOutside||(y(g)&&(a<m&&(a=m),a>c&&(a=c)),y(d)&&(b<m&&(b=m),b>c&&(b=c))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,d=this.options,c=d.offsets||[0,0,0,0],m=this.horiz,l=this.width=Math.round(a.relativeLength(H(d.width,b.plotWidth-c[3]+c[1]),b.plotWidth)),f=this.height=Math.round(a.relativeLength(H(d.height,b.plotHeight-
c[0]+c[2]),b.plotHeight)),p=this.top=Math.round(a.relativeLength(H(d.top,b.plotTop+c[0]),b.plotHeight,b.plotTop)),d=this.left=Math.round(a.relativeLength(H(d.left,b.plotLeft+c[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-f-p;this.right=b.chartWidth-l-d;this.len=Math.max(m?l:f,0);this.pos=m?d:p},getExtremes:function(){var a=this.isLog;return{min:a?e(this.lin2log(this.min)):this.min,max:a?e(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},
getThreshold:function(a){var b=this.isLog,g=b?this.lin2log(this.min):this.min,b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=g:Infinity===a?a=b:g>a?a=g:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(H(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,g=b[a+"Length"],d=H(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(d&&g)return"inside"===b[a+"Position"]&&(g=-g),[g,d]},labelMetrics:function(){var a=
this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,d=this.tickInterval,c=d,m=this.len/(((this.categories?1:0)+this.max-this.min)/d),l,p=a.rotation,k=this.labelMetrics(),v,B=Number.MAX_VALUE,t,r=function(a){a/=m||1;a=1<a?Math.ceil(a):1;return e(a*d)};b?(t=!a.staggerLines&&!a.step&&(y(p)?[p]:m<H(a.autoRotationLimit,
80)&&a.autoRotation))&&f(t,function(a){var b;if(a===p||a&&-90<=a&&90>=a)v=r(Math.abs(k.h/Math.sin(q*a))),b=v+Math.abs(a/360),b<B&&(B=b,l=a,c=v)}):a.step||(c=r(k.h));this.autoRotation=t;this.labelRotation=H(l,p);return c},getSlotWidth:function(){var a=this.chart,b=this.horiz,d=this.options.labels,c=Math.max(this.tickPositions.length-(this.categories?0:1),1),m=a.margin[3];return b&&2>(d.step||0)&&!d.rotation&&(this.staggerLines||1)*this.len/c||!b&&(d.style&&parseInt(d.style.width,10)||m&&m-a.spacing[3]||
.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,d=this.tickPositions,c=this.ticks,m=this.options.labels,l=m&&m.style||{},p=this.horiz,k=this.getSlotWidth(),v=Math.max(1,Math.round(k-2*(m.padding||5))),B={},e=this.labelMetrics(),t=m.style&&m.style.textOverflow,r,D,h=0,A;I(m.rotation)||(B.rotation=m.rotation||0);f(d,function(a){(a=c[a])&&a.label&&a.label.textPxLength>h&&(h=a.label.textPxLength)});this.maxLabelLength=h;if(this.autoRotation)h>v&&h>e.h?B.rotation=this.labelRotation:
this.labelRotation=0;else if(k&&(r=v,!t))for(D="clip",v=d.length;!p&&v--;)if(A=d[v],A=c[A].label)A.styles&&"ellipsis"===A.styles.textOverflow?A.css({textOverflow:"clip"}):A.textPxLength>k&&A.css({width:k+"px"}),A.getBBox().height>this.len/d.length-(e.h-e.f)&&(A.specificTextOverflow="ellipsis");B.rotation&&(r=h>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight,t||(D="ellipsis"));if(this.labelAlign=m.align||this.autoLabelAlign(this.labelRotation))B.align=this.labelAlign;f(d,function(a){var b=(a=c[a])&&
a.label,g=l.width,d={};b&&(b.attr(B),r&&!g&&"nowrap"!==l.whiteSpace&&(r<b.textPxLength||"SPAN"===b.element.tagName)?(d.width=r,t||(d.textOverflow=b.specificTextOverflow||D),b.css(d)):b.styles&&b.styles.width&&!d.width&&!g&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=B.rotation)});this.tickRotCorr=b.rotCorr(e.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||y(this.min)&&y(this.max)&&this.tickPositions&&0<this.tickPositions.length},addTitle:function(a){var b=
this.chart.renderer,g=this.horiz,d=this.opposite,c=this.options.title,m;this.axisTitle||((m=c.textAlign)||(m=(g?{low:"left",middle:"center",high:"right"}:{low:d?"right":"left",middle:"center",high:d?"left":"right"})[c.align]),this.axisTitle=b.text(c.text,0,0,c.useHTML).attr({zIndex:7,rotation:c.rotation||0,align:m}).addClass("highcharts-axis-title").css(t(c.style)).add(this.axisGroup),this.axisTitle.isNew=!0);c.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":
"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new M(this,a)},getOffset:function(){var a=this,b=a.chart,d=b.renderer,c=a.options,m=a.tickPositions,l=a.ticks,p=a.horiz,k=a.side,v=b.inverted&&!a.isZAxis?[1,0,3,2][k]:k,B,e,t=0,r,D=0,h=c.title,G=c.labels,I=0,x=b.axisOffset,b=b.clipOffset,q=[-1,1,1,-1][k],M=c.className,u=a.axisParent,n=this.tickSize("tick");B=a.hasData();a.showAxis=e=B||H(c.showEmpty,!0);a.staggerLines=a.horiz&&G.staggerLines;a.axisGroup||(a.gridGroup=
d.g("grid").attr({zIndex:c.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(M||"")).add(u),a.axisGroup=d.g("axis").attr({zIndex:c.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(M||"")).add(u),a.labelGroup=d.g("axis-labels").attr({zIndex:G.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(M||"")).add(u));B||a.isLinked?(f(m,function(b,g){a.generateTick(b,g)}),a.renderUnsquish(),a.reserveSpaceDefault=0===k||2===k||{1:"left",3:"right"}[k]===a.labelAlign,
H(G.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&f(m,function(a){I=Math.max(l[a].getLabelSize(),I)}),a.staggerLines&&(I*=a.staggerLines),a.labelOffset=I*(a.opposite?-1:1)):A(l,function(a,b){a.destroy();delete l[b]});h&&h.text&&!1!==h.enabled&&(a.addTitle(e),e&&!1!==h.reserveSpace&&(a.titleOffset=t=a.axisTitle.getBBox()[p?"height":"width"],r=h.offset,D=y(r)?0:H(h.margin,p?5:10)));a.renderLine();a.offset=q*H(c.offset,x[k]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};d=0===k?-a.labelMetrics().h:
2===k?a.tickRotCorr.y:0;D=Math.abs(I)+D;I&&(D=D-d+q*(p?H(G.y,a.tickRotCorr.y+8*q):G.x));a.axisTitleMargin=H(r,D);x[k]=Math.max(x[k],a.axisTitleMargin+t+q*a.offset,D,B&&m.length&&n?n[0]+q*a.offset:0);c=c.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[v]=Math.max(b[v],c)},getLinePath:function(a){var b=this.chart,g=this.opposite,d=this.offset,c=this.horiz,m=this.left+(g?this.width:0)+d,d=b.chartHeight-this.bottom-(g?this.height:0)+d;g&&(a*=-1);return b.renderer.crispLine(["M",c?this.left:m,c?d:
this.top,"L",c?b.chartWidth-this.right:m,c?d:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,d=this.top,c=this.len,m=this.options.title,l=a?b:d,f=this.opposite,p=this.offset,k=m.x||0,v=m.y||0,B=this.axisTitle,e=this.chart.renderer.fontMetrics(m.style&&
m.style.fontSize,B),B=Math.max(B.getBBox(null,0).height-e.h-1,0),c={low:l+(a?0:c),middle:l+c/2,high:l+(a?c:0)}[m.align],b=(a?d+this.height:b)+(a?1:-1)*(f?-1:1)*this.axisTitleMargin+[-B,B,e.f,-B][this.side];return{x:a?c+k:b+(f?this.width:0)+p+k,y:a?b+v-(f?this.height:0)+p:c+v}},renderMinorTick:function(a){var b=this.chart.hasRendered&&p(this.oldMin),d=this.minorTicks;d[a]||(d[a]=new M(this,a,"minor"));b&&d[a].isNew&&d[a].render(null,!0);d[a].render(null,!1,1)},renderTick:function(a,b){var d=this.isLinked,
g=this.ticks,c=this.chart.hasRendered&&p(this.oldMin);if(!d||a>=this.min&&a<=this.max)g[a]||(g[a]=new M(this,a)),c&&g[a].isNew&&g[a].render(b,!0,.1),g[a].render(b)},render:function(){var b=this,d=b.chart,c=b.options,m=b.isLog,l=b.isLinked,v=b.tickPositions,e=b.axisTitle,t=b.ticks,r=b.minorTicks,D=b.alternateBands,h=c.stackLabels,G=c.alternateGridColor,I=b.tickmarkOffset,x=b.axisLine,q=b.showAxis,H=E(d.renderer.globalAnimation),u,n;b.labelEdge.length=0;b.overlap=!1;f([t,r,D],function(a){A(a,function(a){a.isActive=
!1})});if(b.hasData()||l)b.minorTickInterval&&!b.categories&&f(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),v.length&&(f(v,function(a,d){b.renderTick(a,d)}),I&&(0===b.min||b.single)&&(t[-1]||(t[-1]=new M(b,-1,null,!0)),t[-1].render(-1))),G&&f(v,function(c,g){n=void 0!==v[g+1]?v[g+1]+I:b.max-I;0===g%2&&c<b.max&&n<=b.max+(d.polar?-I:I)&&(D[c]||(D[c]=new a.PlotLineOrBand(b)),u=c+I,D[c].options={from:m?b.lin2log(u):u,to:m?b.lin2log(n):n,color:G},D[c].render(),D[c].isActive=!0)}),b._addedPlotLB||
(f((c.plotLines||[]).concat(c.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);f([t,r,D],function(a){var b,c=[],g=H.duration;A(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,c.push(b))});B(function(){for(b=c.length;b--;)a[c[b]]&&!a[c[b]].isActive&&(a[c[b]].destroy(),delete a[c[b]])},a!==D&&d.hasRendered&&g?g:0)});x&&(x[x.isPlaced?"animate":"attr"]({d:this.getLinePath(x.strokeWidth())}),x.isPlaced=!0,x[q?"show":"hide"](!0));e&&q&&(c=b.getTitlePosition(),p(c.y)?(e[e.isNew?
"attr":"animate"](c),e.isNew=!1):(e.attr("y",-9999),e.isNew=!0));h&&h.enabled&&b.renderStackTotals();b.isDirty=!1;k(this,"afterRender")},redraw:function(){this.visible&&(this.render(),f(this.plotLinesAndBands,function(a){a.render()}));f(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var d=this,c=d.stacks,g=d.plotLinesAndBands,l;k(this,"destroy",{keepEvents:a});a||m(d);A(c,function(a,b){x(a);c[b]=null});f([d.ticks,d.minorTicks,
d.alternateBands],function(a){x(a)});if(g)for(a=g.length;a--;)g[a].destroy();f("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){d[a]&&(d[a]=d[a].destroy())});for(l in d.plotLinesAndBandsGroups)d.plotLinesAndBandsGroups[l]=d.plotLinesAndBandsGroups[l].destroy();A(d,function(a,c){-1===b(c,d.keepProps)&&delete d[c]})},drawCrosshair:function(a,b){var d,c=this.crosshair,g=H(c.snap,!0),m,l=this.cross;k(this,"drawCrosshair",{e:a,point:b});a||(a=this.cross&&
this.cross.e);if(this.crosshair&&!1!==(y(b)||!g)){g?y(b)&&(m=H(b.crosshairPos,this.isXAxis?b.plotX:this.len-b.plotY)):m=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);y(m)&&(d=this.getPlotLinePath(b&&(this.isXAxis?b.x:H(b.stackY,b.y)),null,null,null,m)||null);if(!y(d)){this.hideCrosshair();return}g=this.categories&&!this.isRadial;l||(this.cross=l=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(g?"category ":"thin ")+c.className).attr({zIndex:H(c.zIndex,
2)}).add(),l.attr({stroke:c.color||(g?h("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":H(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&l.attr({dashstyle:c.dashStyle}));l.show().attr({d:d});g&&!c.width&&l.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();k(this,"afterDrawCrosshair",{e:a,point:b})},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=G}(K);(function(a){var C=a.Axis,E=a.getMagnitude,F=a.normalizeTickInterval,n=a.timeUnits;
C.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};C.prototype.normalizeTimeTickInterval=function(a,e){var h=e||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];e=h[h.length-1];var y=n[e[0]],q=e[1],x;for(x=0;x<h.length&&!(e=h[x],y=n[e[0]],q=e[1],h[x+1]&&a<=(y*q[q.length-1]+n[h[x+1][0]])/2);x++);y===
n.year&&a<5*y&&(q=[1,2,5]);a=F(a/y,q,"year"===e[0]?Math.max(E(a/y),1):1);return{unitRange:y,count:a,unitName:e[0]}}})(K);(function(a){var C=a.Axis,E=a.getMagnitude,F=a.map,n=a.normalizeTickInterval,h=a.pick;C.prototype.getLogTickPositions=function(a,u,y,q){var e=this.options,f=this.len,c=[];q||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),c=this.getLinearTickPositions(a,u,y);else if(.08<=a)for(var f=Math.floor(u),k,r,l,d,b,e=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];f<y+1&&!b;f++)for(r=
e.length,k=0;k<r&&!b;k++)l=this.log2lin(this.lin2log(f)*e[k]),l>u&&(!q||d<=y)&&void 0!==d&&c.push(d),d>y&&(b=!0),d=l;else u=this.lin2log(u),y=this.lin2log(y),a=q?this.getMinorTickInterval():e.tickInterval,a=h("auto"===a?null:a,this._minorAutoInterval,e.tickPixelInterval/(q?5:1)*(y-u)/((q?f/this.tickPositions.length:f)||1)),a=n(a,null,E(a)),c=F(this.getLinearTickPositions(a,u,y),this.log2lin),q||(this._minorAutoInterval=a/5);q||(this.tickInterval=a);return c};C.prototype.log2lin=function(a){return Math.log(a)/
Math.LN10};C.prototype.lin2log=function(a){return Math.pow(10,a)}})(K);(function(a,C){var E=a.arrayMax,F=a.arrayMin,n=a.defined,h=a.destroyObjectProperties,e=a.each,u=a.erase,y=a.merge,q=a.pick;a.PlotLineOrBand=function(a,f){this.axis=a;f&&(this.options=f,this.id=f.id)};a.PlotLineOrBand.prototype={render:function(){var e=this,f=e.axis,c=f.horiz,k=e.options,r=k.label,l=e.label,d=k.to,b=k.from,v=k.value,p=n(b)&&n(d),h=n(v),t=e.svgElem,u=!t,A=[],H=k.color,m=q(k.zIndex,0),D=k.events,A={"class":"highcharts-plot-"+
(p?"band ":"line ")+(k.className||"")},B={},M=f.chart.renderer,G=p?"bands":"lines";f.isLog&&(b=f.log2lin(b),d=f.log2lin(d),v=f.log2lin(v));h?(A.stroke=H,A["stroke-width"]=k.width,k.dashStyle&&(A.dashstyle=k.dashStyle)):p&&(H&&(A.fill=H),k.borderWidth&&(A.stroke=k.borderColor,A["stroke-width"]=k.borderWidth));B.zIndex=m;G+="-"+m;(H=f.plotLinesAndBandsGroups[G])||(f.plotLinesAndBandsGroups[G]=H=M.g("plot-"+G).attr(B).add());u&&(e.svgElem=t=M.path().attr(A).add(H));if(h)A=f.getPlotLinePath(v,t.strokeWidth());
else if(p)A=f.getPlotBandPath(b,d,k);else return;u&&A&&A.length?(t.attr({d:A}),D&&a.objectEach(D,function(a,b){t.on(b,function(a){D[b].apply(e,[a])})})):t&&(A?(t.show(),t.animate({d:A})):(t.hide(),l&&(e.label=l=l.destroy())));r&&n(r.text)&&A&&A.length&&0<f.width&&0<f.height&&!A.isFlat?(r=y({align:c&&p&&"center",x:c?!p&&4:10,verticalAlign:!c&&p&&"middle",y:c?p?16:10:p?6:-4,rotation:c&&!p&&90},r),this.renderLabel(r,A,p,m)):l&&l.hide();return e},renderLabel:function(a,f,c,k){var e=this.label,l=this.axis.chart.renderer;
e||(e={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(c?"band":"line")+"-label "+(a.className||"")},e.zIndex=k,this.label=e=l.text(a.text,0,0,a.useHTML).attr(e).add(),e.css(a.style));k=f.xBounds||[f[1],f[4],c?f[6]:f[1]];f=f.yBounds||[f[2],f[5],c?f[7]:f[2]];c=F(k);l=F(f);e.align(a,!1,{x:c,y:l,width:E(k)-c,height:E(f)-l});e.show()},destroy:function(){u(this.axis.plotLinesAndBands,this);delete this.axis;h(this)}};a.extend(C.prototype,{getPlotBandPath:function(a,f){var c=this.getPlotLinePath(f,
null,null,!0),k=this.getPlotLinePath(a,null,null,!0),e=[],l=this.horiz,d=1,b;a=a<this.min&&f<this.min||a>this.max&&f>this.max;if(k&&c)for(a&&(b=k.toString()===c.toString(),d=0),a=0;a<k.length;a+=6)l&&c[a+1]===k[a+1]?(c[a+1]+=d,c[a+4]+=d):l||c[a+2]!==k[a+2]||(c[a+2]+=d,c[a+5]+=d),e.push("M",k[a+1],k[a+2],"L",k[a+4],k[a+5],c[a+4],c[a+5],c[a+1],c[a+2],"z"),e.isFlat=b;return e},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,
"plotLines")},addPlotBandOrLine:function(e,f){var c=(new a.PlotLineOrBand(this,e)).render(),k=this.userOptions;c&&(f&&(k[f]=k[f]||[],k[f].push(e)),this.plotLinesAndBands.push(c));return c},removePlotBandOrLine:function(a){for(var f=this.plotLinesAndBands,c=this.options,k=this.userOptions,r=f.length;r--;)f[r].id===a&&f[r].destroy();e([c.plotLines||[],k.plotLines||[],c.plotBands||[],k.plotBands||[]],function(c){for(r=c.length;r--;)c[r].id===a&&u(c,c[r])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},
removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(K,V);(function(a){var C=a.doc,E=a.each,F=a.extend,n=a.format,h=a.isNumber,e=a.map,u=a.merge,y=a.pick,q=a.splat,x=a.syncTimeout,f=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,f){this.chart=a;this.options=f;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=f.split&&!a.inverted;this.shared=f.shared||this.split;this.outside=f.outside&&!this.split},cleanSplit:function(a){E(this.chart.series,
function(c){var f=c&&c.tt;f&&(!f.isActive||a?c.tt=f.destroy():f.isActive=!1)})},getLabel:function(){var c=this.chart.renderer,f=this.options,e;this.label||(this.outside&&(this.container=e=a.doc.createElement("div"),e.className="highcharts-tooltip-container",a.css(e,{position:"absolute",top:"1px",pointerEvents:"none"}),a.doc.body.appendChild(e),this.renderer=c=new a.Renderer(e,0,0)),this.split?this.label=c.g("tooltip"):(this.label=c.label("",0,0,f.shape||"callout",null,null,f.useHTML,null,"tooltip").attr({padding:f.padding,
r:f.borderRadius}),this.label.attr({fill:f.backgroundColor,"stroke-width":f.borderWidth}).css(f.style).shadow(f.shadow)),this.outside&&(this.label.attr({x:this.distance,y:this.distance}),this.label.xSetter=function(a){e.style.left=a+"px"},this.label.ySetter=function(a){e.style.top=a+"px"}),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();u(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,u(!0,this.options,a))},destroy:function(){this.label&&
(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),a.discardElement(this.container));a.clearTimeout(this.hideTimer);a.clearTimeout(this.tooltipTimeout)},move:function(c,f,e,l){var d=this,b=d.now,v=!1!==d.options.animation&&!d.isHidden&&(1<Math.abs(c-b.x)||1<Math.abs(f-b.y)),p=d.followPointer||1<d.len;F(b,{x:v?(2*b.x+c)/3:c,y:v?(b.y+f)/2:f,anchorX:p?void 0:v?(2*b.anchorX+e)/3:e,anchorY:p?
void 0:v?(b.anchorY+l)/2:l});d.getLabel().attr(b);v&&(a.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){d&&d.move(c,f,e,l)},32))},hide:function(c){var f=this;a.clearTimeout(this.hideTimer);c=y(c,this.options.hideDelay,500);this.isHidden||(this.hideTimer=x(function(){f.getLabel()[c?"fadeOut":"hide"]();f.isHidden=!0},c))},getAnchor:function(a,f){var c,l=this.chart,d=l.inverted,b=l.plotTop,v=l.plotLeft,p=0,k=0,t,h;a=q(a);c=a[0].tooltipPos;this.followPointer&&f&&(void 0===
f.chartX&&(f=l.pointer.normalize(f)),c=[f.chartX-l.plotLeft,f.chartY-b]);c||(E(a,function(a){t=a.series.yAxis;h=a.series.xAxis;p+=a.plotX+(!d&&h?h.left-v:0);k+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!d&&t?t.top-b:0)}),p/=a.length,k/=a.length,c=[d?l.plotWidth-k:p,this.shared&&!d&&1<a.length&&f?f.chartY-b:d?l.plotHeight-p:k]);return e(c,Math.round)},getPosition:function(a,f,e){var c=this.chart,d=this.distance,b={},v=c.inverted&&e.h||0,p,k=this.outside,t=k?C.documentElement.clientWidth-2*d:c.chartWidth,
h=k?Math.max(C.body.scrollHeight,C.documentElement.scrollHeight,C.body.offsetHeight,C.documentElement.offsetHeight,C.documentElement.clientHeight):c.chartHeight,A=c.pointer.chartPosition,r=["y",h,f,(k?A.top-d:0)+e.plotY+c.plotTop,k?0:c.plotTop,k?h:c.plotTop+c.plotHeight],m=["x",t,a,(k?A.left-d:0)+e.plotX+c.plotLeft,k?0:c.plotLeft,k?t:c.plotLeft+c.plotWidth],D=!this.followPointer&&y(e.ttBelow,!c.inverted===!!e.negative),B=function(a,c,g,m,l,f){var p=g<m-d,e=m+d+g<c,B=m-d-g;m+=d;if(D&&e)b[a]=m;else if(!D&&
p)b[a]=B;else if(p)b[a]=Math.min(f-g,0>B-v?B:B-v);else if(e)b[a]=Math.max(l,m+v+g>c?m:m+v);else return!1},q=function(a,c,g,m){var l;m<d||m>c-d?l=!1:b[a]=m<g/2?1:m>c-g/2?c-g-2:m-g/2;return l},G=function(a){var b=r;r=m;m=b;p=a},g=function(){!1!==B.apply(0,r)?!1!==q.apply(0,m)||p||(G(!0),g()):p?b.x=b.y=0:(G(!0),g())};(c.inverted||1<this.len)&&G();g();return b},defaultFormatter:function(a){var c=this.points||q(this),f;f=[a.tooltipFooterHeaderFormatter(c[0])];f=f.concat(a.bodyFormatter(c));f.push(a.tooltipFooterHeaderFormatter(c[0],
!0));return f},refresh:function(c,f){var e,l=this.options,d,b=c,v,p={},k=[];e=l.formatter||this.defaultFormatter;var p=this.shared,t;l.enabled&&(a.clearTimeout(this.hideTimer),this.followPointer=q(b)[0].series.tooltipOptions.followPointer,v=this.getAnchor(b,f),f=v[0],d=v[1],!p||b.series&&b.series.noSharedTooltip?p=b.getLabelConfig():(E(b,function(a){a.setState("hover");k.push(a.getLabelConfig())}),p={x:b[0].category,y:b[0].y},p.points=k,b=b[0]),this.len=k.length,p=e.call(p,this),t=b.series,this.distance=
y(t.tooltipOptions.distance,16),!1===p?this.hide():(e=this.getLabel(),this.isHidden&&e.attr({opacity:1}).show(),this.split?this.renderSplit(p,q(c)):(l.style.width||e.css({width:this.chart.spacingBox.width}),e.attr({text:p&&p.join?p.join(""):p}),e.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+y(b.colorIndex,t.colorIndex)),e.attr({stroke:l.borderColor||b.color||t.color||"#666666"}),this.updatePosition({plotX:f,plotY:d,negative:b.negative,ttBelow:b.ttBelow,h:v[2]||0})),this.isHidden=
!1))},renderSplit:function(c,f){var e=this,l=[],d=this.chart,b=d.renderer,v=!0,p=this.options,k=0,t=this.getLabel();a.isString(c)&&(c=[!1,c]);E(c.slice(0,f.length+1),function(a,c){if(!1!==a){c=f[c-1]||{isHeader:!0,plotX:f[0].plotX};var h=c.series||e,m=h.tt,D=c.series||{},B="highcharts-color-"+y(c.colorIndex,D.colorIndex,"none");m||(h.tt=m=b.label(null,null,null,"callout",null,null,p.useHTML).addClass("highcharts-tooltip-box "+B).attr({padding:p.padding,r:p.borderRadius,fill:p.backgroundColor,stroke:p.borderColor||
c.color||D.color||"#333333","stroke-width":p.borderWidth}).add(t));m.isActive=!0;m.attr({text:a});m.css(p.style).shadow(p.shadow);a=m.getBBox();D=a.width+m.strokeWidth();c.isHeader?(k=a.height,D=Math.max(0,Math.min(c.plotX+d.plotLeft-D/2,d.chartWidth-D))):D=c.plotX+d.plotLeft-y(p.distance,16)-D;0>D&&(v=!1);a=(c.series&&c.series.yAxis&&c.series.yAxis.pos)+(c.plotY||0);a-=d.plotTop;l.push({target:c.isHeader?d.plotHeight+k:a,rank:c.isHeader?1:0,size:h.tt.getBBox().height+1,point:c,x:D,tt:m})}});this.cleanSplit();
a.distribute(l,d.plotHeight+k);E(l,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:v||b.isHeader?a.x:b.plotX+d.plotLeft+y(p.distance,16),y:a.pos+d.plotTop,anchorX:b.isHeader?b.plotX+d.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+d.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var c=this.chart,f=this.getLabel(),l=(this.options.positioner||this.getPosition).call(this,f.width,f.height,a),d=a.plotX+c.plotLeft;a=a.plotY+c.plotTop;
var b;this.outside&&(b=(this.options.borderWidth||0)+2*this.distance,this.renderer.setSize(f.width+b,f.height+b,!1),d+=c.pointer.chartPosition.left-l.x,a+=c.pointer.chartPosition.top-l.y);this.move(Math.round(l.x),Math.round(l.y||0),d,a)},getDateFormat:function(a,e,h,l){var d=this.chart.time,b=d.dateFormat("%m-%d %H:%M:%S.%L",e),c,p,k={millisecond:15,second:12,minute:9,hour:6,day:3},t="millisecond";for(p in f){if(a===f.week&&+d.dateFormat("%w",e)===h&&"00:00:00.000"===b.substr(6)){p="week";break}if(f[p]>
a){p=t;break}if(k[p]&&b.substr(k[p])!=="01-01 00:00:00.000".substr(k[p]))break;"week"!==p&&(t=p)}p&&(c=l[p]);return c},getXDateFormat:function(a,f,e){f=f.dateTimeLabelFormats;var c=e&&e.closestPointRange;return(c?this.getDateFormat(c,a.x,e.options.startOfWeek,f):f.day)||f.year},tooltipFooterHeaderFormatter:function(a,f){f=f?"footer":"header";var c=a.series,l=c.tooltipOptions,d=l.xDateFormat,b=c.xAxis,e=b&&"datetime"===b.options.type&&h(a.key),p=l[f+"Format"];e&&!d&&(d=this.getXDateFormat(a,l,b));
e&&d&&E(a.point&&a.point.tooltipDateKeys||["key"],function(a){p=p.replace("{point."+a+"}","{point."+a+":"+d+"}")});return n(p,{point:a,series:c},this.chart.time)},bodyFormatter:function(a){return e(a,function(a){var c=a.series.tooltipOptions;return(c[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,c[(a.point.formatPrefix||"point")+"Format"])})}}})(K);(function(a){var C=a.addEvent,E=a.attr,F=a.charts,n=a.color,h=a.css,e=a.defined,u=a.each,y=a.extend,q=a.find,x=
a.fireEvent,f=a.isNumber,c=a.isObject,k=a.offset,r=a.pick,l=a.splat,d=a.Tooltip;a.Pointer=function(a,d){this.init(a,d)};a.Pointer.prototype={init:function(a,c){this.options=c;this.chart=a;this.runChartClick=c.chart.events&&!!c.chart.events.click;this.pinchDown=[];this.lastValidTouch={};d&&(a.tooltip=new d(a,c.tooltip),this.followTouchMove=r(c.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,d=b.options.chart,c=d.zoomType||"",b=b.inverted;/touch/.test(a.type)&&
(c=r(d.pinchType,c));this.zoomX=a=/x/.test(c);this.zoomY=c=/y/.test(c);this.zoomHor=a&&!b||c&&b;this.zoomVert=c&&!b||a&&b;this.hasZoom=a||c},normalize:function(a,c){var b;b=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;c||(this.chartPosition=c=k(this.chart.container));return y(a,{chartX:Math.round(b.pageX-c.left),chartY:Math.round(b.pageY-c.top)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};u(this.chart.axes,function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?
"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,d,f){var b;u(a,function(a){var l=!(a.noSharedTooltip&&d)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(f,l);if((l=c(a,!0))&&!(l=!c(b,!0)))var l=b.distX-a.distX,e=b.dist-a.dist,p=(a.series.group&&a.series.group.zIndex)-(b.series.group&&b.series.group.zIndex),l=0<(0!==l&&d?l:0!==e?e:0!==p?p:b.series.index>a.series.index?-1:1);l&&(b=a)});return b},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;
return b},getChartCoordinatesFromPoint:function(a,c){var b=a.series,d=b.xAxis,b=b.yAxis,f=r(a.clientX,a.plotX),l=a.shapeArgs;if(d&&b)return c?{chartX:d.len+d.pos-f,chartY:b.len+b.pos-a.plotY}:{chartX:f+d.pos,chartY:a.plotY+b.pos};if(l&&l.x&&l.y)return{chartX:l.x,chartY:l.y}},getHoverData:function(b,d,f,l,e,k,h){var p,m=[],v=h&&h.isBoosting;l=!(!l||!b);h=d&&!d.stickyTracking?[d]:a.grep(f,function(a){return a.visible&&!(!e&&a.directTouch)&&r(a.options.enableMouseTracking,!0)&&a.stickyTracking});d=(p=
l?b:this.findNearestKDPoint(h,e,k))&&p.series;p&&(e&&!d.noSharedTooltip?(h=a.grep(f,function(a){return a.visible&&!(!e&&a.directTouch)&&r(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),u(h,function(a){var b=q(a.points,function(a){return a.x===p.x&&!a.isNull});c(b)&&(v&&(b=a.getPoint(b)),m.push(b))})):m.push(p));return{hoverPoint:p,hoverSeries:d,hoverPoints:m}},runPointActions:function(b,d){var c=this.chart,f=c.tooltip&&c.tooltip.options.enabled?c.tooltip:void 0,l=f?f.shared:!1,e=d||c.hoverPoint,
k=e&&e.series||c.hoverSeries,k=this.getHoverData(e,k,c.series,!!d||k&&k.directTouch&&this.isDirectTouch,l,b,{isBoosting:c.isBoosting}),h,e=k.hoverPoint;h=k.hoverPoints;d=(k=k.hoverSeries)&&k.tooltipOptions.followPointer;l=l&&k&&!k.noSharedTooltip;if(e&&(e!==c.hoverPoint||f&&f.isHidden)){u(c.hoverPoints||[],function(b){-1===a.inArray(b,h)&&b.setState()});u(h||[],function(a){a.setState("hover")});if(c.hoverSeries!==k)k.onMouseOver();c.hoverPoint&&c.hoverPoint.firePointEvent("mouseOut");if(!e.series)return;
e.firePointEvent("mouseOver");c.hoverPoints=h;c.hoverPoint=e;f&&f.refresh(l?h:e,b)}else d&&f&&!f.isHidden&&(e=f.getAnchor([{}],b),f.updatePosition({plotX:e[0],plotY:e[1]}));this.unDocMouseMove||(this.unDocMouseMove=C(c.container.ownerDocument,"mousemove",function(b){var c=F[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));u(c.axes,function(c){var d=r(c.crosshair.snap,!0),m=d?a.find(h,function(a){return a.series[c.coll]===c}):void 0;m||!d?c.drawCrosshair(b,m):c.hideCrosshair()})},reset:function(a,
c){var b=this.chart,d=b.hoverSeries,f=b.hoverPoint,e=b.hoverPoints,k=b.tooltip,h=k&&k.shared?e:f;a&&h&&u(l(h),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)k&&h&&(k.refresh(h),f&&(f.setState(f.state,!0),u(b.axes,function(a){a.crosshair&&a.drawCrosshair(null,f)})));else{if(f)f.onMouseOut();e&&u(e,function(a){a.setState()});if(d)d.onMouseOut();k&&k.hide(c);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());u(b.axes,function(a){a.hideCrosshair()});this.hoverX=b.hoverPoints=
b.hoverPoint=null}},scaleGroups:function(a,c){var b=this.chart,d;u(b.series,function(f){d=a||f.getPlotBox();f.xAxis&&f.xAxis.zoomEnabled&&f.group&&(f.group.attr(d),f.markerGroup&&(f.markerGroup.attr(d),f.markerGroup.clip(c?b.clipRect:null)),f.dataLabelsGroup&&f.dataLabelsGroup.attr(d))});b.clipRect.attr(c||b.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,
c=b.options.chart,d=a.chartX,f=a.chartY,l=this.zoomHor,e=this.zoomVert,k=b.plotLeft,m=b.plotTop,h=b.plotWidth,B=b.plotHeight,r,G=this.selectionMarker,g=this.mouseDownX,w=this.mouseDownY,q=c.panKey&&a[c.panKey+"Key"];G&&G.touch||(d<k?d=k:d>k+h&&(d=k+h),f<m?f=m:f>m+B&&(f=m+B),this.hasDragged=Math.sqrt(Math.pow(g-d,2)+Math.pow(w-f,2)),10<this.hasDragged&&(r=b.isInsidePlot(g-k,w-m),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&r&&!q&&!G&&(this.selectionMarker=G=b.renderer.rect(k,m,l?1:h,e?1:B,0).attr({fill:c.selectionMarkerFill||
n("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),G&&l&&(d-=g,G.attr({width:Math.abs(d),x:(0<d?0:d)+g})),G&&e&&(d=f-w,G.attr({height:Math.abs(d),y:(0<d?0:d)+w})),r&&!G&&c.panning&&b.pan(a,c.panning)))},drop:function(a){var b=this,c=this.chart,d=this.hasPinched;if(this.selectionMarker){var l={originalEvent:a,xAxis:[],yAxis:[]},k=this.selectionMarker,r=k.attr?k.attr("x"):k.x,q=k.attr?k.attr("y"):k.y,m=k.attr?k.attr("width"):k.width,D=k.attr?k.attr("height"):
k.height,B;if(this.hasDragged||d)u(c.axes,function(c){if(c.zoomEnabled&&e(c.min)&&(d||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var f=c.horiz,g="touchend"===a.type?c.minPixelPadding:0,k=c.toValue((f?r:q)+g),f=c.toValue((f?r+m:q+D)-g);l[c.coll].push({axis:c,min:Math.min(k,f),max:Math.max(k,f)});B=!0}}),B&&x(c,"selection",l,function(a){c.zoom(y(a,d?{animation:!1}:null))});f(c.index)&&(this.selectionMarker=this.selectionMarker.destroy());d&&this.scaleGroups()}c&&f(c.index)&&(h(c.container,{cursor:c._cursor}),
c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(b){F[a.hoverChartIndex]&&F[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-
b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=F[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;e(a.hoverChartIndex)&&F[a.hoverChartIndex]&&F[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=c.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===c.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-c.plotLeft,
b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,c){for(var b;a;){if(b=E(a,"class")){if(-1!==b.indexOf(c))return!0;if(-1!==b.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=
this.chart,c=b.hoverPoint,d=b.plotLeft,f=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(x(c.series,"click",y(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(y(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-f)&&x(b,"click",a)))},setDOMEvents:function(){var b=this,c=b.chart.container,d=c.ownerDocument;c.onmousedown=function(a){b.onContainerMouseDown(a)};c.onmousemove=function(a){b.onContainerMouseMove(a)};c.onclick=function(a){b.onContainerClick(a)};
this.unbindContainerMouseLeave=C(c,"mouseleave",b.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=C(d,"mouseup",b.onDocumentMouseUp));a.hasTouch&&(c.ontouchstart=function(a){b.onContainerTouchStart(a)},c.ontouchmove=function(a){b.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=C(d,"touchend",b.onDocumentTouchEnd)))},destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();this.unbindContainerMouseLeave();a.chartCount||(a.unbindDocumentMouseUp&&
(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,c){b[c]=null})}}})(K);(function(a){var C=a.charts,E=a.each,F=a.extend,n=a.map,h=a.noop,e=a.pick;F(a.Pointer.prototype,{pinchTranslate:function(a,e,h,n,f,c){this.zoomHor&&this.pinchTranslateDirection(!0,a,e,h,n,f,c);this.zoomVert&&this.pinchTranslateDirection(!1,a,e,h,n,f,c)},pinchTranslateDirection:function(a,
e,h,n,f,c,k,r){var l=this.chart,d=a?"x":"y",b=a?"X":"Y",v="chart"+b,p=a?"width":"height",q=l["plot"+(a?"Left":"Top")],t,u,A=r||1,y=l.inverted,m=l.bounds[a?"h":"v"],D=1===e.length,B=e[0][v],M=h[0][v],G=!D&&e[1][v],g=!D&&h[1][v],w;h=function(){!D&&20<Math.abs(B-G)&&(A=r||Math.abs(M-g)/Math.abs(B-G));u=(q-M)/A+B;t=l["plot"+(a?"Width":"Height")]/A};h();e=u;e<m.min?(e=m.min,w=!0):e+t>m.max&&(e=m.max-t,w=!0);w?(M-=.8*(M-k[d][0]),D||(g-=.8*(g-k[d][1])),h()):k[d]=[M,g];y||(c[d]=u-q,c[p]=t);c=y?1/A:A;f[p]=
t;f[d]=e;n[y?a?"scaleY":"scaleX":"scale"+b]=A;n["translate"+b]=c*q+(M-c*B)},pinch:function(a){var u=this,q=u.chart,x=u.pinchDown,f=a.touches,c=f.length,k=u.lastValidTouch,r=u.hasZoom,l=u.selectionMarker,d={},b=1===c&&(u.inClass(a.target,"highcharts-tracker")&&q.runTrackerClick||u.runChartClick),v={};1<c&&(u.initiated=!0);r&&u.initiated&&!b&&a.preventDefault();n(f,function(a){return u.normalize(a)});"touchstart"===a.type?(E(f,function(a,b){x[b]={chartX:a.chartX,chartY:a.chartY}}),k.x=[x[0].chartX,
x[1]&&x[1].chartX],k.y=[x[0].chartY,x[1]&&x[1].chartY],E(q.axes,function(a){if(a.zoomEnabled){var b=q.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,d=a.toPixels(e(a.options.min,a.dataMin)),f=a.toPixels(e(a.options.max,a.dataMax)),l=Math.max(d,f);b.min=Math.min(a.pos,Math.min(d,f)-c);b.max=Math.max(a.pos+a.len,l+c)}}),u.res=!0):u.followTouchMove&&1===c?this.runPointActions(u.normalize(a)):x.length&&(l||(u.selectionMarker=l=F({destroy:h,touch:!0},q.plotBox)),u.pinchTranslate(x,f,d,l,v,k),u.hasPinched=
r,u.scaleGroups(d,v),u.res&&(u.res=!1,this.reset(!1,0)))},touch:function(h,n){var q=this.chart,u,f;if(q.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=q.index;1===h.touches.length?(h=this.normalize(h),(f=q.isInsidePlot(h.chartX-q.plotLeft,h.chartY-q.plotTop))&&!q.openMenu?(n&&this.runPointActions(h),"touchmove"===h.type&&(n=this.pinchDown,u=n[0]?4<=Math.sqrt(Math.pow(n[0].chartX-h.chartX,2)+Math.pow(n[0].chartY-h.chartY,2)):!1),e(u,!0)&&this.pinch(h)):n&&
this.reset()):2===h.touches.length&&this.pinch(h)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(e){C[a.hoverChartIndex]&&C[a.hoverChartIndex].pointer.drop(e)}})})(K);(function(a){var C=a.addEvent,E=a.charts,F=a.css,n=a.doc,h=a.extend,e=a.noop,u=a.Pointer,y=a.removeEvent,q=a.win,x=a.wrap;if(!a.hasTouch&&(q.PointerEvent||q.MSPointerEvent)){var f={},c=!!q.PointerEvent,k=function(){var c=[];c.item=function(a){return this[a]};
a.objectEach(f,function(a){c.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return c},r=function(c,d,b,f){"touch"!==c.pointerType&&c.pointerType!==c.MSPOINTER_TYPE_TOUCH||!E[a.hoverChartIndex]||(f(c),f=E[a.hoverChartIndex].pointer,f[d]({type:b,target:c.currentTarget,preventDefault:e,touches:k()}))};h(u.prototype,{onContainerPointerDown:function(a){r(a,"onContainerTouchStart","touchstart",function(a){f[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){r(a,
"onContainerTouchMove","touchmove",function(a){f[a.pointerId]={pageX:a.pageX,pageY:a.pageY};f[a.pointerId].target||(f[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){r(a,"onDocumentTouchEnd","touchend",function(a){delete f[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,c?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,c?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(n,c?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});
x(u.prototype,"init",function(a,c,b){a.call(this,c,b);this.hasZoom&&F(c.container,{"-ms-touch-action":"none","touch-action":"none"})});x(u.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(C)});x(u.prototype,"destroy",function(a){this.batchMSEvents(y);a.call(this)})}})(K);(function(a){var C=a.addEvent,E=a.css,F=a.discardElement,n=a.defined,h=a.each,e=a.fireEvent,u=a.isFirefox,y=a.marginNames,q=a.merge,x=a.pick,f=a.setAnimation,c=a.stableSort,
k=a.win,r=a.wrap;a.Legend=function(a,c){this.init(a,c)};a.Legend.prototype={init:function(a,c){this.chart=a;this.setOptions(c);c.enabled&&(this.render(),C(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=C(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(a){var c=x(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=
q(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=c;this.initialItemY=c-5;this.symbolWidth=x(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted},update:function(a,c){var b=this.chart;this.setOptions(q(!0,this.options,a));this.destroy();b.isDirtyLegend=b.isDirtyBox=!0;x(c,!0)&&b.redraw();e(this,"afterUpdate")},colorizeItem:function(a,c){a.legendGroup[c?"removeClass":"addClass"]("highcharts-legend-item-hidden");var b=this.options,
d=a.legendItem,f=a.legendLine,l=a.legendSymbol,k=this.itemHiddenStyle.color,b=c?b.itemStyle.color:k,h=c?a.color||k:k,r=a.options&&a.options.marker,q={fill:h};d&&d.css({fill:b,color:b});f&&f.attr({stroke:h});l&&(r&&l.isMarker&&(q=a.pointAttribs(),c||(q.stroke=q.fill=k)),l.attr(q));e(this,"afterColorizeItem",{item:a,visible:c})},positionItems:function(){h(this.allItems,this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var c=this.options,b=c.symbolPadding,
c=!c.rtl,f=a._legendItemPos,l=f[0],f=f[1],e=a.checkbox;if((a=a.legendGroup)&&a.element)a[n(a.translateY)?"animate":"attr"]({translateX:c?l:this.legendWidth-l-2*b-4,translateY:f});e&&(e.x=l,e.y=f)},destroyItem:function(a){var c=a.checkbox;h(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});c&&F(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}h(this.getAllItems(),function(c){h(["legendItem","legendGroup"],a,c)});h("clipRect up down pager nav box title group".split(" "),
a,this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,c,b=this.clipHeight||this.legendHeight,f=this.titleHeight;a&&(c=a.translateY,h(this.allItems,function(d){var l=d.checkbox,e;l&&(e=c+f+l.y+(this.scrollOffset||0)+3,E(l,{left:a.translateX+d.checkboxOffset+l.x-20+"px",top:e+"px",display:e>c-6&&e<c+b-6?"":"none"}))},this))},renderTitle:function(){var a=this.options,c=this.padding,b=a.title,f=0;b.text&&(this.title||(this.title=this.chart.renderer.label(b.text,
c-3,c-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group)),a=this.title.getBBox(),f=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:f}));this.titleHeight=f},setText:function(c){var d=this.options;c.legendItem.attr({text:d.labelFormat?a.format(d.labelFormat,c,this.chart.time):d.labelFormatter.call(c)})},renderItem:function(a){var c=this.chart,b=c.renderer,f=this.options,e=this.symbolWidth,l=f.symbolPadding,k=this.itemStyle,h=this.itemHiddenStyle,
r="horizontal"===f.layout?x(f.itemDistance,20):0,n=!f.rtl,m=a.legendItem,D=!a.series,B=!D&&a.series.drawLegendSymbol?a.series:a,u=B.options,u=this.createCheckboxForItem&&u&&u.showCheckbox,r=e+l+r+(u?20:0),G=f.useHTML,g=a.options.className;m||(a.legendGroup=b.g("legend-item").addClass("highcharts-"+B.type+"-series highcharts-color-"+a.colorIndex+(g?" "+g:"")+(D?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=m=b.text("",n?e+l:-l,this.baseline||0,G).css(q(a.visible?
k:h)).attr({align:n?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(e=k.fontSize,this.fontMetrics=b.fontMetrics(e,m),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,m.attr("y",this.baseline)),this.symbolHeight=f.symbolHeight||this.fontMetrics.f,B.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,m,G),u&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);k.width||m.css({width:(f.itemWidth||f.width||c.spacingBox.width)-r});this.setText(a);c=m.getBBox();
a.itemWidth=a.checkboxOffset=f.itemWidth||a.legendItemWidth||c.width+r;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||c.height||this.symbolHeight)},layoutItem:function(a){var c=this.options,b=this.padding,f="horizontal"===c.layout,e=a.itemHeight,l=c.itemMarginBottom||0,k=this.itemMarginTop,h=f?x(c.itemDistance,20):0,r=c.width,q=r||this.chart.spacingBox.width-2*b-c.x,c=c.alignColumns&&this.totalItemWidth>
q?this.maxItemWidth:a.itemWidth;f&&this.itemX-b+c>q&&(this.itemX=b,this.itemY+=k+this.lastLineHeight+l,this.lastLineHeight=0);this.lastItemY=k+this.itemY+l;this.lastLineHeight=Math.max(e,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];f?this.itemX+=c:(this.itemY+=k+e+l,this.lastLineHeight=e);this.offsetWidth=r||Math.max((f?this.itemX-b-(a.checkbox?0:h):c)+b,this.offsetWidth)},getAllItems:function(){var a=[];h(this.chart.series,function(c){var b=c&&c.options;c&&x(b.showInLegend,n(b.linkedTo)?
!1:void 0,!0)&&(a=a.concat(c.legendItems||("point"===b.legendType?c.data:c)))});e(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,c){var b=this.chart,d=this.options,f=this.getAlignment();f&&h([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(e,l){e.test(f)&&!n(a[l])&&(b[y[l]]=Math.max(b[y[l]],
b.legend[(l+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][l]*d[l%2?"x":"y"]+x(d.margin,12)+c[l]+(0===l&&void 0!==b.options.title.margin?b.titleOffset+b.options.title.margin:0)))})},proximatePositions:function(){var c=this.chart,d=[],b="left"===this.options.align;h(this.allItems,function(f){var e,l;e=b;f.xAxis&&f.points&&(f.xAxis.options.reversed&&(e=!e),e=a.find(e?f.points:f.points.slice(0).reverse(),function(b){return a.isNumber(b.plotY)}),l=f.legendGroup.getBBox().height,d.push({target:f.visible?
e.plotY-.3*l:c.plotHeight,size:l,item:f}))},this);a.distribute(d,c.plotHeight);h(d,function(a){a.item._legendItemPos[1]=c.plotTop-c.spacing[0]+a.pos})},render:function(){var a=this.chart,d=a.renderer,b=this.group,f,e,k,r=this.box,n=this.options,A=this.padding;this.itemX=A;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=0;b||(this.group=b=d.g("legend").attr({zIndex:7}).add(),this.contentGroup=d.g().attr({zIndex:1}).add(b),this.scrollGroup=d.g().add(this.contentGroup));this.renderTitle();
f=this.getAllItems();c(f,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});n.reversed&&f.reverse();this.allItems=f;this.display=e=!!f.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;h(f,this.renderItem,this);h(f,this.layoutItem,this);f=(n.width||this.offsetWidth)+A;k=this.lastItemY+this.lastLineHeight+this.titleHeight;k=this.handleOverflow(k);k+=A;r||(this.box=r=d.rect().addClass("highcharts-legend-box").attr({r:n.borderRadius}).add(b),
r.isNew=!0);r.attr({stroke:n.borderColor,"stroke-width":n.borderWidth||0,fill:n.backgroundColor||"none"}).shadow(n.shadow);0<f&&0<k&&(r[r.isNew?"attr":"animate"](r.crisp.call({},{x:0,y:0,width:f,height:k},r.strokeWidth())),r.isNew=!1);r[e?"show":"hide"]();this.legendWidth=f;this.legendHeight=k;e&&(d=a.spacingBox,/(lth|ct|rth)/.test(this.getAlignment())&&(d=q(d,{y:d.y+a.titleOffset+a.options.title.margin})),b.align(q(n,{width:f,height:k,verticalAlign:this.proximate?"top":n.verticalAlign}),!0,d));this.proximate||
this.positionItems()},handleOverflow:function(a){var c=this,b=this.chart,f=b.renderer,e=this.options,l=e.y,k=this.padding,b=b.spacingBox.height+("top"===e.verticalAlign?-l:l)-k,l=e.maxHeight,r,A=this.clipRect,q=e.navigation,m=x(q.animation,!0),D=q.arrowSize||12,B=this.nav,n=this.pages,G,g=this.allItems,w=function(a){"number"===typeof a?A.attr({height:a}):A&&(c.clipRect=A.destroy(),c.contentGroup.clip());c.contentGroup.div&&(c.contentGroup.div.style.clip=a?"rect("+k+"px,9999px,"+(k+a)+"px,0)":"auto")};
"horizontal"!==e.layout||"middle"===e.verticalAlign||e.floating||(b/=2);l&&(b=Math.min(b,l));n.length=0;a>b&&!1!==q.enabled?(this.clipHeight=r=Math.max(b-20-this.titleHeight-k,0),this.currentPage=x(this.currentPage,1),this.fullHeight=a,h(g,function(a,b){var c=a._legendItemPos[1],d=Math.round(a.legendItem.getBBox().height),f=n.length;if(!f||c-n[f-1]>r&&(G||c)!==n[f-1])n.push(G||c),f++;a.pageIx=f-1;G&&(g[b-1].pageIx=f-1);b===g.length-1&&c+d-n[f-1]>r&&(n.push(c),a.pageIx=f);c!==G&&(G=c)}),A||(A=c.clipRect=
f.clipRect(0,k,9999,0),c.contentGroup.clip(A)),w(r),B||(this.nav=B=f.g().attr({zIndex:1}).add(this.group),this.up=f.symbol("triangle",0,0,D,D).on("click",function(){c.scroll(-1,m)}).add(B),this.pager=f.text("",15,10).addClass("highcharts-legend-navigation").css(q.style).add(B),this.down=f.symbol("triangle-down",0,0,D,D).on("click",function(){c.scroll(1,m)}).add(B)),c.scroll(0),a=b):B&&(w(),this.nav=B.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,c){var b=
this.pages,d=b.length;a=this.currentPage+a;var e=this.clipHeight,l=this.options.navigation,k=this.pager,h=this.padding;a>d&&(a=d);0<a&&(void 0!==c&&f(c,this.chart),this.nav.attr({translateX:h,translateY:e+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),k.attr({text:a+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===d?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),
this.up.attr({fill:1===a?l.inactiveColor:l.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===d?l.inactiveColor:l.activeColor}).css({cursor:a===d?"default":"pointer"}),this.scrollOffset=-b[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=a,this.positionCheckboxes())}};a.LegendSymbolMixin={drawRectangle:function(a,c){var b=a.symbolHeight,d=a.options.squareSymbol;c.legendSymbol=this.chart.renderer.rect(d?(a.symbolWidth-b)/2:
0,a.baseline-b+1,d?b:a.symbolWidth,b,x(a.options.symbolRadius,b/2)).addClass("highcharts-point").attr({zIndex:3}).add(c.legendGroup)},drawLineMarker:function(a){var c=this.options,b=c.marker,f=a.symbolWidth,e=a.symbolHeight,k=e/2,l=this.chart.renderer,h=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var r;r={"stroke-width":c.lineWidth||0};c.dashStyle&&(r.dashstyle=c.dashStyle);this.legendLine=l.path(["M",0,a,"L",f,a]).addClass("highcharts-graph").attr(r).add(h);b&&!1!==b.enabled&&f&&
(c=Math.min(x(b.radius,k),k),0===this.symbol.indexOf("url")&&(b=q(b,{width:e,height:e}),c=0),this.legendSymbol=b=l.symbol(this.symbol,f/2-c,a-c,2*c,2*c,b).addClass("highcharts-point").add(h),b.isMarker=!0)}};(/Trident\/7\.0/.test(k.navigator.userAgent)||u)&&r(a.Legend.prototype,"positionItem",function(a,c){var b=this,d=function(){c._legendItemPos&&a.call(b,c)};d();setTimeout(d)})})(K);(function(a){var C=a.addEvent,E=a.animate,F=a.animObject,n=a.attr,h=a.doc,e=a.Axis,u=a.createElement,y=a.defaultOptions,
q=a.discardElement,x=a.charts,f=a.css,c=a.defined,k=a.each,r=a.extend,l=a.find,d=a.fireEvent,b=a.grep,v=a.isNumber,p=a.isObject,I=a.isString,t=a.Legend,L=a.marginNames,A=a.merge,H=a.objectEach,m=a.Pointer,D=a.pick,B=a.pInt,M=a.removeEvent,G=a.seriesTypes,g=a.splat,w=a.syncTimeout,P=a.win,Q=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new Q(a,b,c)};r(Q.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(I(a[0])||a[0].nodeName)this.renderTo=
a.shift();this.init(a[0],a[1])},init:function(b,c){var g,f,m=b.series,e=b.plotOptions||{};d(this,"init",{args:arguments},function(){b.series=null;g=A(y,b);for(f in g.plotOptions)g.plotOptions[f].tooltip=e[f]&&A(e[f].tooltip)||void 0;g.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;g.series=b.series=m;this.userOptions=b;var k=g.chart,l=k.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=
g;this.axes=[];this.series=[];this.time=b.time&&a.keys(b.time).length?new a.Time(b.time):a.time;this.hasCartesianSeries=k.showAxes;var h=this;h.index=x.length;x.push(h);a.chartCount++;l&&H(l,function(a,b){C(h,b,a)});h.xAxis=[];h.yAxis=[];h.pointCount=h.colorCounter=h.symbolCounter=0;d(h,"afterInit");h.firstRender()})},initSeries:function(b){var c=this.options.chart;(c=G[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;
for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,c){var d=c?b:a;a=c?a:b;return 0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){d(this,"beforeRedraw");var c=this.axes,g=this.series,f=this.pointer,m=this.legend,e=this.isDirtyLegend,l,h,B=this.hasCartesianSeries,D=this.isDirtyBox,w,p=this.renderer,t=p.isHidden(),G=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);t&&this.temporaryDisplay();this.layOutTitles();
for(b=g.length;b--;)if(w=g[b],w.options.stacking&&(l=!0,w.isDirty)){h=!0;break}if(h)for(b=g.length;b--;)w=g[b],w.options.stacking&&(w.isDirty=!0);k(g,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),e=!0);a.isDirtyData&&d(a,"updatedData")});e&&m.options.enabled&&(m.render(),this.isDirtyLegend=!1);l&&this.getStacks();B&&k(c,function(a){a.updateNames();a.setScale()});this.getMargins();B&&(k(c,function(a){a.isDirty&&(D=!0)}),k(c,function(a){var b=a.min+","+a.max;
a.extKey!==b&&(a.extKey=b,G.push(function(){d(a,"afterSetExtremes",r(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(D||l)&&a.redraw()}));D&&this.drawChartBox();d(this,"predraw");k(g,function(a){(D||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});f&&f.reset(!0);p.draw();d(this,"redraw");d(this,"render");t&&this.temporaryDisplay(!0);k(G,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,d=this.series,g;c=l(this.axes,b)||l(this.series,
b);for(g=0;!c&&g<d.length;g++)c=l(d[g].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=g(b.xAxis||{}),b=b.yAxis=g(b.yAxis||{});d(this,"getAxes");k(c,function(a,b){a.index=b;a.isX=!0});k(b,function(a,b){a.index=b});c=c.concat(b);k(c,function(b){new e(a,b)});d(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];k(this.series,function(c){a=a.concat(b(c.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return b(this.series,function(a){return a.selected})},
setTitle:function(a,b,c){var d=this,g=d.options,f;f=g.title=A({style:{color:"#333333",fontSize:g.isStock?"16px":"18px"}},g.title,a);g=g.subtitle=A({style:{color:"#666666"}},g.subtitle,b);k([["title",a,f],["subtitle",b,g]],function(a,b){var c=a[0],g=d[c],f=a[1];a=a[2];g&&f&&(d[c]=g=g.destroy());a&&!g&&(d[c]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),d[c].update=function(a){d.setTitle(!b&&a,b&&a)},d[c].css(a.style))});d.layOutTitles(c)},
layOutTitles:function(a){var b=0,c,d=this.renderer,g=this.spacingBox;k(["title","subtitle"],function(a){var c=this[a],f=this.options[a];a="title"===a?-3:f.verticalAlign?0:b+2;var m;c&&(m=f.style.fontSize,m=d.fontMetrics(m,c).b,c.css({width:(f.width||g.width+f.widthAdjust)+"px"}).align(r({y:a+m},f),!1,"spacingBox"),f.floating||f.verticalAlign||(b=Math.ceil(b+c.getBBox(f.useHTML).height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=this.isDirtyLegend=c,this.hasRendered&&
D(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,d=b.width,b=b.height,g=this.renderTo;c(d)||(this.containerWidth=a.getStyle(g,"width"));c(b)||(this.containerHeight=a.getStyle(g,"height"));this.chartWidth=Math.max(0,d||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),
delete c.hcOrigStyle),c.hcOrigDetached&&(h.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){h.body.contains(c)||c.parentNode||(c.hcOrigDetached=!0,h.body.appendChild(c));if("none"===a.getStyle(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;
if(c===h.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,g=c.chart,f,m;b=this.renderTo;var e=a.uniqueKey(),k;b||(this.renderTo=b=g.renderTo);I(b)&&(this.renderTo=b=h.getElementById(b));b||a.error(13,!0);f=B(n(b,"data-highcharts-chart"));v(f)&&x[f]&&x[f].hasRendered&&x[f].destroy();n(b,"data-highcharts-chart",this.index);b.innerHTML="";g.skipClone||b.offsetWidth||this.temporaryDisplay();this.getChartSize();
f=this.chartWidth;m=this.chartHeight;k=r({position:"relative",overflow:"hidden",width:f+"px",height:m+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},g.style);this.container=b=u("div",{id:e},k,b);this._cursor=b.style.cursor;this.renderer=new (a[g.renderer]||a.Renderer)(b,f,m,null,g.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(g.className);this.renderer.setStyle(g.style);this.renderer.chartIndex=this.index;d(this,"afterGetContainer")},
getMargins:function(a){var b=this.spacing,g=this.margin,f=this.titleOffset;this.resetMargins();f&&!c(g[0])&&(this.plotTop=Math.max(this.plotTop,f+this.options.title.margin+b[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(g,b);d(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],d=a.margin;a.hasCartesianSeries&&k(a.axes,function(a){a.visible&&a.getOffset()});k(L,function(g,f){c(d[f])||(a[g]+=b[f])});a.setChartSize()},reflow:function(b){var d=
this,g=d.options.chart,f=d.renderTo,m=c(g.width)&&c(g.height),e=g.width||a.getStyle(f,"width"),g=g.height||a.getStyle(f,"height"),f=b?b.target:P;if(!m&&!d.isPrinting&&e&&g&&(f===P||f===h)){if(e!==d.containerWidth||g!==d.containerHeight)a.clearTimeout(d.reflowTimeout),d.reflowTimeout=w(function(){d.container&&d.setSize(void 0,void 0,!1)},b?100:0);d.containerWidth=e;d.containerHeight=g}},setReflow:function(a){var b=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):
(this.unbindReflow=C(P,"resize",function(a){b.reflow(a)}),C(this,"destroy",this.unbindReflow))},setSize:function(b,c,g){var m=this,e=m.renderer;m.isResizing+=1;a.setAnimation(g,m);m.oldChartHeight=m.chartHeight;m.oldChartWidth=m.chartWidth;void 0!==b&&(m.options.chart.width=b);void 0!==c&&(m.options.chart.height=c);m.getChartSize();b=e.globalAnimation;(b?E:f)(m.container,{width:m.chartWidth+"px",height:m.chartHeight+"px"},b);m.setChartSize(!0);e.setSize(m.chartWidth,m.chartHeight,g);k(m.axes,function(a){a.isDirty=
!0;a.setScale()});m.isDirtyLegend=!0;m.isDirtyBox=!0;m.layOutTitles();m.getMargins();m.redraw(g);m.oldChartHeight=null;d(m,"resize");w(function(){m&&d(m,"endResize",null,function(){--m.isResizing})},F(b).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,g=this.chartWidth,f=this.chartHeight,m=this.options.chart,e=this.spacing,l=this.clipOffset,h,B,D,r;this.plotLeft=h=Math.round(this.plotLeft);this.plotTop=B=Math.round(this.plotTop);this.plotWidth=D=Math.max(0,Math.round(g-h-this.marginRight));
this.plotHeight=r=Math.max(0,Math.round(f-B-this.marginBottom));this.plotSizeX=b?r:D;this.plotSizeY=b?D:r;this.plotBorderWidth=m.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:e[3],y:e[0],width:g-e[3]-e[1],height:f-e[0]-e[2]};this.plotBox=c.plotBox={x:h,y:B,width:D,height:r};g=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(g,l[3])/2);c=Math.ceil(Math.max(g,l[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(g,l[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-
Math.max(g,l[2])/2-c))};a||k(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()});d(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){var a=this,b=a.options.chart;k(["margin","spacing"],function(c){var d=b[c],g=p(d)?d:[d,d,d,d];k(["Top","Right","Bottom","Left"],function(d,f){a[c][f]=D(b[c+d],g[f])})});k(L,function(b,c){a[b]=D(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,
g=this.chartHeight,f=this.chartBackground,m=this.plotBackground,e=this.plotBorder,k,l=this.plotBGImage,h=a.backgroundColor,B=a.plotBackgroundColor,D=a.plotBackgroundImage,r,w=this.plotLeft,p=this.plotTop,t=this.plotWidth,G=this.plotHeight,A=this.plotBox,n=this.clipRect,q=this.clipBox,v="animate";f||(this.chartBackground=f=b.rect().addClass("highcharts-background").add(),v="attr");k=a.borderWidth||0;r=k+(a.shadow?8:0);h={fill:h||"none"};if(k||f["stroke-width"])h.stroke=a.borderColor,h["stroke-width"]=
k;f.attr(h).shadow(a.shadow);f[v]({x:r/2,y:r/2,width:c-r-k%2,height:g-r-k%2,r:a.borderRadius});v="animate";m||(v="attr",this.plotBackground=m=b.rect().addClass("highcharts-plot-background").add());m[v](A);m.attr({fill:B||"none"}).shadow(a.plotShadow);D&&(l?l.animate(A):this.plotBGImage=b.image(D,w,p,t,G).add());n?n.animate({width:q.width,height:q.height}):this.clipRect=b.clipRect(q);v="animate";e||(v="attr",this.plotBorder=e=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());e.attr({stroke:a.plotBorderColor,
"stroke-width":a.plotBorderWidth||0,fill:"none"});e[v](e.crisp({x:w,y:p,width:t,height:G},-e.strokeWidth()));this.isDirtyBox=!1;d(this,"afterDrawChartBox")},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,g,f;k(["inverted","angular","polar"],function(m){c=G[b.type||b.defaultSeriesType];f=b[m]||c&&c.prototype[m];for(g=d&&d.length;!f&&g--;)(c=G[d[g].type])&&c.prototype[m]&&(f=!0);a[m]=f})},linkSeries:function(){var a=this,b=a.series;k(b,function(a){a.linkedSeries.length=
0});k(b,function(b){var c=b.options.linkedTo;I(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=D(b.options.visible,c.options.visible,b.visible))});d(this,"afterLinkSeries")},renderSeries:function(){k(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&k(b.items,function(c){var d=r(b.style,c.style),g=B(d.left)+a.plotLeft,f=B(d.top)+a.plotTop+12;delete d.left;delete d.top;
a.renderer.text(c.html,g,f).attr({zIndex:2}).css(d).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,d,g,f;this.setTitle();this.legend=new t(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;d=this.plotHeight=Math.max(this.plotHeight-21,0);k(a,function(a){a.setScale()});this.getAxisMargins();g=1.1<c/this.plotWidth;f=1.05<d/this.plotHeight;if(g||f)k(a,function(a){(a.horiz&&g||!a.horiz&&f)&&a.setTickInterval(!0)}),this.getMargins();
this.drawChartBox();this.hasCartesianSeries&&k(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=A(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&
(P.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,g=b.series,f=b.container,m,e=f&&f.parentNode;d(b,"destroy");b.renderer.forExport?a.erase(x,b):x[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");M(b);for(m=c.length;m--;)c[m]=c[m].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();
for(m=g.length;m--;)g[m]=g[m].destroy();k("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});f&&(f.innerHTML="",M(f),e&&q(f));H(b,function(a,c){delete b[c]})},firstRender:function(){var a=this,b=a.options;if(!a.isReadyToRender||a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();
k(b.series||[],function(b){a.initSeries(b)});a.linkSeries();d(a,"beforeRender");m&&(a.pointer=new m(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){k([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);d(this,"load");d(this,"render");c(this.index)&&this.setReflow(this.options.chart.reflow);this.onload=null}})})(K);(function(a){var C=a.addEvent,E=a.Chart,F=a.each;C(E,"afterSetChartSize",function(n){var h=
this.options.chart.scrollablePlotArea;(h=h&&h.minWidth)&&!this.renderer.forExport&&(this.scrollablePixels=h=Math.max(0,h-this.chartWidth))&&(this.plotWidth+=h,this.clipBox.width+=h,n.skipAxes||F(this.axes,function(e){1===e.side?e.getPlotLinePath=function(){var h=this.right,n;this.right=h-e.chart.scrollablePixels;n=a.Axis.prototype.getPlotLinePath.apply(this,arguments);this.right=h;return n}:(e.setAxisSize(),e.setAxisTranslation())}))});C(E,"render",function(){this.scrollablePixels?(this.setUpScrolling&&
this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});E.prototype.setUpScrolling=function(){this.scrollingContainer=a.createElement("div",{className:"highcharts-scrolling"},{overflowX:"auto",WebkitOverflowScrolling:"touch"},this.renderTo);this.innerContainer=a.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=null};E.prototype.applyFixed=function(){var n=this.container,
h,e,u=!this.fixedDiv;u&&(this.fixedDiv=a.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.fixedRenderer=h=new a.Renderer(this.fixedDiv,0,0),this.scrollableMask=h.path().attr({fill:a.color(this.options.chart.backgroundColor||"#fff").setOpacity(.85).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),a.each([this.inverted?".highcharts-xaxis":
".highcharts-yaxis",this.inverted?".highcharts-xaxis-labels":".highcharts-yaxis-labels",".highcharts-contextbutton",".highcharts-credits",".highcharts-legend",".highcharts-subtitle",".highcharts-title"],function(e){a.each(n.querySelectorAll(e),function(a){h.box.appendChild(a);a.style.pointerEvents="auto"})}));this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);e=this.chartWidth+this.scrollablePixels;this.container.style.width=e+"px";this.renderer.boxWrapper.attr({width:e,height:this.chartHeight,
viewBox:[0,0,e,this.chartHeight].join(" ")});u&&(e=this.options.chart.scrollablePlotArea,e.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixels*e.scrollPositionX));u=this.axisOffset;e=this.plotTop-u[0]-1;var u=this.plotTop+this.plotHeight+u[2],y=this.plotLeft+this.plotWidth-this.scrollablePixels;this.scrollableMask.attr({d:this.scrollablePixels?["M",0,e,"L",this.plotLeft-1,e,"L",this.plotLeft-1,u,"L",0,u,"Z","M",y,e,"L",this.chartWidth,e,"L",this.chartWidth,u,"L",y,u,"Z"]:["M",
0,0]})}})(K);(function(a){var C,E=a.each,F=a.extend,n=a.erase,h=a.fireEvent,e=a.format,u=a.isArray,y=a.isNumber,q=a.pick,x=a.removeEvent;a.Point=C=function(){};a.Point.prototype={init:function(a,c,e){this.series=a;this.color=a.color;this.applyOptions(c,e);a.options.colorByPoint?(c=a.options.colors||a.chart.options.colors,this.color=this.color||c[a.colorCounter],c=c.length,e=a.colorCounter,a.colorCounter++,a.colorCounter===c&&(a.colorCounter=0)):e=a.colorIndex;this.colorIndex=q(this.colorIndex,e);
a.chart.pointCount++;h(this,"afterInit");return this},applyOptions:function(a,c){var f=this.series,e=f.options.pointValKey||f.pointValKey;a=C.prototype.optionsToObject.call(this,a);F(this,a);this.options=this.options?F(this.options,a):a;a.group&&delete this.group;e&&(this.y=this[e]);this.isNull=q(this.isValid&&!this.isValid(),null===this.x||!y(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===c&&f.xAxis&&f.xAxis.hasNames&&(this.x=f.xAxis.nameToX(this));void 0===this.x&&f&&(this.x=
void 0===c?f.autoIncrement(this):c);return this},setNestedProperty:function(f,c,e){e=e.split(".");a.reduce(e,function(f,e,d,b){f[e]=b.length-1===d?c:a.isObject(f[e],!0)?f[e]:{};return f[e]},f);return f},optionsToObject:function(f){var c={},e=this.series,h=e.options.keys,l=h||e.pointArrayMap||["y"],d=l.length,b=0,n=0;if(y(f)||null===f)c[l[0]]=f;else if(u(f))for(!h&&f.length>d&&(e=typeof f[0],"string"===e?c.name=f[0]:"number"===e&&(c.x=f[0]),b++);n<d;)h&&void 0===f[b]||(0<l[n].indexOf(".")?a.Point.prototype.setNestedProperty(c,
f[b],l[n]):c[l[n]]=f[b]),b++,n++;else"object"===typeof f&&(c=f,f.dataLabels&&(e._hasPointLabels=!0),f.marker&&(e._hasPointMarkers=!0));return c},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",
""):"")},getZone:function(){var a=this.series,c=a.zones,a=a.zoneAxis||"y",e=0,h;for(h=c[e];this[a]>=h.value;)h=c[++e];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=h&&h.color&&!this.options.color?h.color:this.nonZonedColor;return h},destroy:function(){var a=this.series.chart,c=a.hoverPoints,e;a.pointCount--;c&&(this.setState(),n(c,this),c.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)x(this),this.destroyElements();this.legendItem&&
a.legend.destroyItem(this);for(e in this)this[e]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],c,e=6;e--;)c=a[e],this[c]&&(this[c]=this[c].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var c=this.series,f=c.tooltipOptions,
h=q(f.valueDecimals,""),l=f.valuePrefix||"",d=f.valueSuffix||"";E(c.pointArrayMap||["y"],function(b){b="{point."+b;if(l||d)a=a.replace(RegExp(b+"}","g"),l+b+"}"+d);a=a.replace(RegExp(b+"}","g"),b+":,."+h+"f}")});return e(a,{point:this,series:this.series},c.chart.time)},firePointEvent:function(a,c,e){var f=this,l=this.series.options;(l.point.events[a]||f.options&&f.options.events&&f.options.events[a])&&this.importEvents();"click"===a&&l.allowPointSelect&&(e=function(a){f.select&&f.select(null,a.ctrlKey||
a.metaKey||a.shiftKey)});h(this,a,c,e)},visible:!0}})(K);(function(a){var C=a.addEvent,E=a.animObject,F=a.arrayMax,n=a.arrayMin,h=a.correctFloat,e=a.defaultOptions,u=a.defaultPlotOptions,y=a.defined,q=a.each,x=a.erase,f=a.extend,c=a.fireEvent,k=a.grep,r=a.isArray,l=a.isNumber,d=a.isString,b=a.merge,v=a.objectEach,p=a.pick,I=a.removeEvent,t=a.splat,L=a.SVGElement,A=a.syncTimeout,H=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},
marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,
softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var d=this,m,e=a.series,g;d.chart=a;d.options=b=d.setOptions(b);d.linkedSeries=[];d.bindAxes();f(d,{name:b.name,
state:"",visible:!1!==b.visible,selected:!0===b.selected});m=b.events;v(m,function(a,b){C(d,b,a)});if(m&&m.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();q(d.parallelArrays,function(a){d[a+"Data"]=[]});d.setData(b.data,!1);d.isCartesian&&(a.hasCartesianSeries=!0);e.length&&(g=e[e.length-1]);d._i=p(g&&g._i,-1)+1;a.orderSeries(this.insert(e));c(this,"afterInit")},insert:function(a){var b=this.options.index,c;if(l(b)){for(c=a.length;c--;)if(b>=
p(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return p(c,a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,f;q(b.axisTypes||[],function(m){q(d[m],function(a){f=a.options;if(c[m]===f.index||void 0!==c[m]&&c[m]===f.id||void 0===c[m]&&0===f.index)b.insert(a.series),b[m]=a,a.isDirty=!0});b[m]||b.optionalAxis===m||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,f=l(b)?function(d){var g="y"===d&&c.toYData?
c.toYData(a):a[d];c[d+"Data"][b]=g}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))};q(c.parallelArrays,f)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,f=this.chart.time,b=p(b,a.pointStart,0);this.pointInterval=c=p(this.pointInterval,a.pointInterval,1);d&&(a=new f.Date(b),"day"===d?f.set("Date",a,f.get("Date",a)+c):"month"===d?f.set("Month",a,f.get("Month",a)+c):"year"===d&&f.set("FullYear",a,f.get("FullYear",a)+c),c=a.getTime()-
b);this.xIncrement=b+c;return b},setOptions:function(a){var d=this.chart,f=d.options,m=f.plotOptions,h=(d.userOptions||{}).plotOptions||{},g=m[this.type];this.userOptions=a;d=b(g,m.series,a);this.tooltipOptions=b(e.tooltip,e.plotOptions.series&&e.plotOptions.series.tooltip,e.plotOptions[this.type].tooltip,f.tooltip.userOptions,m.series&&m.series.tooltip,m[this.type].tooltip,a.tooltip);this.stickyTracking=p(a.stickyTracking,h[this.type]&&h[this.type].stickyTracking,h.series&&h.series.stickyTracking,
this.tooltipOptions.shared&&!this.noSharedTooltip?!0:d.stickyTracking);null===g.marker&&delete d.marker;this.zoneAxis=d.zoneAxis;a=this.zones=(d.zones||[]).slice();!d.negativeColor&&!d.negativeFillColor||d.zones||a.push({value:d[this.zoneAxis+"Threshold"]||d.threshold||0,className:"highcharts-negative",color:d.negativeColor,fillColor:d.negativeFillColor});a.length&&y(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});c(this,"afterSetOptions",{options:d});return d},getName:function(){return this.name||
"Series "+(this.index+1)},getCyclic:function(a,b,c){var d,f=this.chart,g=this.userOptions,m=a+"Index",e=a+"Counter",h=c?c.length:p(f.options.chart[a+"Count"],f[a+"Count"]);b||(d=p(g[m],g["_"+m]),y(d)||(f.series.length||(f[e]=0),g["_"+m]=d=f[e]%h,f[e]+=1),c&&(b=c[d]));void 0!==d&&(this[m]=d);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||u[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",
this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,updateData:function(b){var c=this.options,d=this.points,f=[],m,g,e,h=this.requireSorting;q(b,function(b){var g;g=a.defined(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b).x;l(g)&&(g=a.inArray(g,this.xData,e),-1===g?f.push(b):b!==c.data[g]?(d[g].update(b,!1,null,!1),d[g].touched=!0,h&&(e=g)):d[g]&&(d[g].touched=!0),m=!0)},this);if(m)for(b=d.length;b--;)g=d[b],g.touched||g.remove(!1),
g.touched=!1;else if(b.length===d.length)q(b,function(a,b){d[b].update&&a!==c.data[b]&&d[b].update(a,!1,null,!1)});else return!1;q(f,function(a){this.addPoint(a,!1)},this);return!0},setData:function(b,c,f,e){var m=this,g=m.points,h=g&&g.length||0,k,B=m.options,D=m.chart,t=null,A=m.xAxis,n=B.turboThreshold,v=this.xData,u=this.yData,y=(k=m.pointArrayMap)&&k.length,H;b=b||[];k=b.length;c=p(c,!0);!1!==e&&k&&h&&!m.cropped&&!m.hasGroupedData&&m.visible&&(H=this.updateData(b));if(!H){m.xIncrement=null;m.colorCounter=
0;q(this.parallelArrays,function(a){m[a+"Data"].length=0});if(n&&k>n){for(f=0;null===t&&f<k;)t=b[f],f++;if(l(t))for(f=0;f<k;f++)v[f]=this.autoIncrement(),u[f]=b[f];else if(r(t))if(y)for(f=0;f<k;f++)t=b[f],v[f]=t[0],u[f]=t.slice(1,y+1);else for(f=0;f<k;f++)t=b[f],v[f]=t[0],u[f]=t[1];else a.error(12)}else for(f=0;f<k;f++)void 0!==b[f]&&(t={series:m},m.pointClass.prototype.applyOptions.apply(t,[b[f]]),m.updateParallelArrays(t,f));u&&d(u[0])&&a.error(14,!0);m.data=[];m.options.data=m.userOptions.data=
b;for(f=h;f--;)g[f]&&g[f].destroy&&g[f].destroy();A&&(A.minRange=A.userMinRange);m.isDirty=D.isDirtyBox=!0;m.isDirtyData=!!g;f=!1}"point"===B.legendType&&(this.processData(),this.generatePoints());c&&D.redraw(f)},processData:function(b){var c=this.xData,d=this.yData,f=c.length,m;m=0;var g,e,h=this.xAxis,l,k=this.options;l=k.cropThreshold;var p=this.getExtremesFromAll||k.getExtremesFromAll,r=this.isCartesian,k=h&&h.val2lin,t=h&&h.isLog,A=this.requireSorting,n,q;if(r&&!this.isDirty&&!h.isDirty&&!this.yAxis.isDirty&&
!b)return!1;h&&(b=h.getExtremes(),n=b.min,q=b.max);if(r&&this.sorted&&!p&&(!l||f>l||this.forceCrop))if(c[f-1]<n||c[0]>q)c=[],d=[];else if(c[0]<n||c[f-1]>q)m=this.cropData(this.xData,this.yData,n,q),c=m.xData,d=m.yData,m=m.start,g=!0;for(l=c.length||1;--l;)f=t?k(c[l])-k(c[l-1]):c[l]-c[l-1],0<f&&(void 0===e||f<e)?e=f:0>f&&A&&(a.error(15),A=!1);this.cropped=g;this.cropStart=m;this.processedXData=c;this.processedYData=d;this.closestPointRange=e},cropData:function(a,b,c,d,f){var g=a.length,m=0,e=g,h;f=
p(f,this.cropShoulder,1);for(h=0;h<g;h++)if(a[h]>=c){m=Math.max(0,h-f);break}for(c=h;c<g;c++)if(a[c]>d){e=c+f;break}return{xData:a.slice(m,e),yData:b.slice(m,e),start:m,end:e}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,d,f=this.processedXData,g=this.processedYData,e=this.pointClass,h=f.length,l=this.cropStart||0,k,p=this.hasGroupedData,a=a.keys,r,n=[],A;c||p||(c=[],c.length=b.length,c=this.data=c);a&&p&&(this.options.keys=!1);for(A=0;A<h;A++)k=l+A,p?(r=(new e).init(this,[f[A]].concat(t(g[A]))),
r.dataGroup=this.groupMap[A]):(r=c[k])||void 0===b[k]||(c[k]=r=(new e).init(this,b[k],f[A])),r&&(r.index=k,n[A]=r);this.options.keys=a;if(c&&(h!==(d=c.length)||p))for(A=0;A<d;A++)A!==l||p||(A+=h),c[A]&&(c[A].destroyElements(),c[A].plotX=void 0);this.data=c;this.points=n},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,d,f=[],g=0;d=this.xAxis.getExtremes();var m=d.min,e=d.max,h,k,p=this.requireSorting?1:0,t,A;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(A=0;A<d;A++)if(k=
c[A],t=a[A],h=(l(t,!0)||r(t))&&(!b.positiveValuesOnly||t.length||0<t),k=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[A+p]||k)>=m&&(c[A-p]||k)<=e,h&&k)if(h=t.length)for(;h--;)"number"===typeof t[h]&&(f[g++]=t[h]);else f[g++]=t;this.dataMin=n(f);this.dataMax=F(f)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,d=this.xAxis,f=d.categories,e=this.yAxis,g=this.points,k=g.length,r=!!this.modifyValue,t=a.pointPlacement,
A="between"===t||l(t),n=a.threshold,q=a.startFromThreshold?n:0,v,u,H,x,I=Number.MAX_VALUE;"between"===t&&(t=.5);l(t)&&(t*=p(a.pointRange||d.pointRange));for(a=0;a<k;a++){var L=g[a],C=L.x,E=L.y;u=L.low;var F=b&&e.stacks[(this.negStacks&&E<(q?0:n)?"-":"")+this.stackKey],K;e.positiveValuesOnly&&null!==E&&0>=E&&(L.isNull=!0);L.plotX=v=h(Math.min(Math.max(-1E5,d.translate(C,0,0,0,1,t,"flags"===this.type)),1E5));b&&this.visible&&!L.isNull&&F&&F[C]&&(x=this.getStackIndicator(x,C,this.index),K=F[C],E=K.points[x.key],
u=E[0],E=E[1],u===q&&x.key===F[C].base&&(u=p(l(n)&&n,e.min)),e.positiveValuesOnly&&0>=u&&(u=null),L.total=L.stackTotal=K.total,L.percentage=K.total&&L.y/K.total*100,L.stackY=E,K.setOffset(this.pointXOffset||0,this.barW||0));L.yBottom=y(u)?Math.min(Math.max(-1E5,e.translate(u,0,1,0,1)),1E5):null;r&&(E=this.modifyValue(E,L));L.plotY=u="number"===typeof E&&Infinity!==E?Math.min(Math.max(-1E5,e.translate(E,0,1,0,1)),1E5):void 0;L.isInside=void 0!==u&&0<=u&&u<=e.len&&0<=v&&v<=d.len;L.clientX=A?h(d.translate(C,
0,0,0,1,t)):v;L.negative=L.y<(n||0);L.category=f&&void 0!==f[L.x]?f[L.x]:L.x;L.isNull||(void 0!==H&&(I=Math.min(I,Math.abs(v-H))),H=v);L.zone=this.zones.length&&L.getZone()}this.closestPointRangePx=I;c(this,"afterTranslate")},getValidPoints:function(a,b){var c=this.chart;return k(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,f=b.inverted,g=this.clipBox,e=g||b.clipBox,m=this.sharedClipKey||
["_sharedClip",a&&a.duration,a&&a.easing,e.height,c.xAxis,c.yAxis].join(),h=b[m],l=b[m+"m"];h||(a&&(e.width=0,f&&(e.x=b.plotSizeX),b[m+"m"]=l=d.clipRect(f?b.plotSizeX+99:-99,f?-b.plotLeft:-b.plotTop,99,f?b.chartWidth:b.chartHeight)),b[m]=h=d.clipRect(e),h.count={length:0});a&&!h.count[this.index]&&(h.count[this.index]=!0,h.count.length+=1);!1!==c.clip&&(this.group.clip(a||g?h:b.clipRect),this.markerGroup.clip(l),this.sharedClipKey=m);a||(h.count[this.index]&&(delete h.count[this.index],--h.count.length),
0===h.count.length&&m&&b[m]&&(g||(b[m]=b[m].destroy()),b[m+"m"]&&(b[m+"m"]=b[m+"m"].destroy())))},animate:function(a){var b=this.chart,c=E(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX,x:0},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99,x:0},c),this.animate=null)},afterAnimate:function(){this.setClip();c(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,d,f,g,e=this.options.marker,
h,l,k,r=this[this.specialGroup]||this.markerGroup,t,A=p(e.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=e.enabledThreshold*e.radius);if(!1!==e.enabled||this._hasPointMarkers)for(c=0;c<a.length;c++)d=a[c],g=d.graphic,h=d.marker||{},l=!!d.marker,f=A&&void 0===h.enabled||h.enabled,k=d.isInside,f&&!d.isNull?(f=p(h.symbol,this.symbol),t=this.markerAttribs(d,d.selected&&"select"),g?g[k?"show":"hide"](!0).animate(t):k&&(0<t.width||d.hasImage)&&(d.graphic=g=b.renderer.symbol(f,t.x,t.y,t.width,
t.height,l?h:e).add(r)),g&&g.attr(this.pointAttribs(d,d.selected&&"select")),g&&g.addClass(d.getClassName(),!0)):g&&(d.graphic=g.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},f=d.symbol||c.symbol,g=p(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],g=p(b&&b.radius,c&&c.radius,g+(c&&c.radiusPlus||0)));a.hasImage=f&&0===f.indexOf("url");a.hasImage&&(g=0);a={x:Math.floor(a.plotX)-g,y:a.plotY-g};g&&(a.width=a.height=2*g);return a},pointAttribs:function(a,
b){var c=this.options.marker,d=a&&a.options,f=d&&d.marker||{},g=this.color,e=d&&d.color,m=a&&a.color,d=p(f.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;g=e||a||m||g;a=f.fillColor||c.fillColor||g;g=f.lineColor||c.lineColor||g;b&&(c=c.states[b],b=f.states&&f.states[b]||{},d=p(b.lineWidth,c.lineWidth,d+p(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,g=b.lineColor||c.lineColor||g);return{stroke:g,"stroke-width":d,fill:a}},destroy:function(){var b=this,d=b.chart,f=/AppleWebKit\/533/.test(H.navigator.userAgent),
e,h,g=b.data||[],l,k;c(b,"destroy");I(b);q(b.axisTypes||[],function(a){(k=b[a])&&k.series&&(x(k.series,b),k.isDirty=k.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(h=g.length;h--;)(l=g[h])&&l.destroy&&l.destroy();b.points=null;a.clearTimeout(b.animationTimeout);v(b,function(a,b){a instanceof L&&!a.survive&&(e=f&&"group"===b?"hide":"destroy",a[e]())});d.hoverSeries===b&&(d.hoverSeries=null);x(d.series,b);d.orderSeries();v(b,function(a,c){delete b[c]})},getGraphPath:function(a,b,
c){var d=this,f=d.options,g=f.step,e,m=[],h=[],l;a=a||d.points;(e=a.reversed)&&a.reverse();(g={right:1,center:2}[g]||g&&3)&&e&&(g=4-g);!f.connectNulls||b||c||(a=this.getValidPoints(a));q(a,function(e,k){var p=e.plotX,r=e.plotY,t=a[k-1];(e.leftCliff||t&&t.rightCliff)&&!c&&(l=!0);e.isNull&&!y(b)&&0<k?l=!f.connectNulls:e.isNull&&!b?l=!0:(0===k||l?k=["M",e.plotX,e.plotY]:d.getPointSpline?k=d.getPointSpline(a,e,k):g?(k=1===g?["L",t.plotX,r]:2===g?["L",(t.plotX+p)/2,t.plotY,"L",(t.plotX+p)/2,r]:["L",p,
t.plotY],k.push("L",p,r)):k=["L",p,r],h.push(e.x),g&&(h.push(e.x),2===g&&h.push(e.x)),m.push.apply(m,k),l=!1)});m.xMap=h;return d.graphPath=m},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),d=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]],d=a.getZonesGraphs(d);q(d,function(d,f){var g=d[0],e=a[g];e?(e.endX=a.preventGraphAnimation?null:c.xMap,e.animate({d:c})):c.length&&(a[g]=a.chart.renderer.path(c).addClass(d[1]).attr({zIndex:1}).add(a.group),
e={stroke:d[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},d[3]?e.dashstyle=d[3]:"square"!==b.linecap&&(e["stroke-linecap"]=e["stroke-linejoin"]="round"),e=a[g].attr(e).shadow(2>f&&b.shadow));e&&(e.startX=c.xMap,e.isArea=c.isArea)})},getZonesGraphs:function(a){q(this.zones,function(b,c){a.push(["zone-graph-"+c,"highcharts-graph highcharts-zone-graph-"+c+" "+(b.className||""),b.color||this.color,b.dashStyle||this.options.dashStyle])},this);return a},applyZones:function(){var a=this,
b=this.chart,c=b.renderer,d=this.zones,f,g,e=this.clips||[],h,l=this.graph,k=this.area,r=Math.max(b.chartWidth,b.chartHeight),t=this[(this.zoneAxis||"y")+"Axis"],A,n,v=b.inverted,u,H,y,x,I=!1;d.length&&(l||k)&&t&&void 0!==t.min&&(n=t.reversed,u=t.horiz,l&&!this.showLine&&l.hide(),k&&k.hide(),A=t.getExtremes(),q(d,function(d,m){f=n?u?b.plotWidth:0:u?0:t.toPixels(A.min);f=Math.min(Math.max(p(g,f),0),r);g=Math.min(Math.max(Math.round(t.toPixels(p(d.value,A.max),!0)),0),r);I&&(f=g=t.toPixels(A.max));
H=Math.abs(f-g);y=Math.min(f,g);x=Math.max(f,g);t.isXAxis?(h={x:v?x:y,y:0,width:H,height:r},u||(h.x=b.plotHeight-h.x)):(h={x:0,y:v?x:y,width:r,height:H},u&&(h.y=b.plotWidth-h.y));v&&c.isVML&&(h=t.isXAxis?{x:0,y:n?y:x,height:h.width,width:b.chartWidth}:{x:h.y-b.plotLeft-b.spacingBox.x,y:0,width:h.height,height:b.chartHeight});e[m]?e[m].animate(h):(e[m]=c.clipRect(h),l&&a["zone-graph-"+m].clip(e[m]),k&&a["zone-area-"+m].clip(e[m]));I=d.value>A.max;a.resetZones&&0===g&&(g=void 0)}),this.clips=e)},invertGroups:function(a){function b(){q(["group",
"markerGroup"],function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,f;c.xAxis&&(f=C(d,"resize",b),C(c,"destroy",f),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,d,f){var g=this[a],e=!g;e&&(this[a]=g=this.chart.renderer.g().attr({zIndex:d||.1}).add(f));g.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(y(this.colorIndex)?"highcharts-color-"+
this.colorIndex+" ":"")+(this.options.className||"")+(g.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);g.attr({visibility:c})[e?"attr":"animate"](this.getPlotBox());return g},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,d,f=a.options,e=!!a.animate&&b.renderer.isSVG&&E(f.animation).duration,g=a.visible?"inherit":
"hidden",h=f.zIndex,l=a.hasRendered,k=b.seriesGroup,r=b.inverted;d=a.plotGroup("group","series",g,h,k);a.markerGroup=a.plotGroup("markerGroup","markers",g,h,k);e&&a.animate(!0);d.inverted=a.isCartesian?r:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(r);!1===f.clip||a.sharedClipKey||l||d.clip(b.clipRect);e&&a.animate();l||(a.animationTimeout=A(function(){a.afterAnimate()},
e));a.isDirty=!1;a.hasRendered=!0;c(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,f=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:p(d&&d.left,a.plotLeft),translateY:p(f&&f.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,f=this.chart.inverted;return this.searchKDTree({clientX:f?
c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:f?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,d,f){var g,e;if(e=c&&c.length)return g=b.kdAxisArray[d%f],c.sort(function(a,b){return a[g]-b[g]}),e=Math.floor(e/2),{point:c[e],left:a(c.slice(0,e),d+1,f),right:a(c.slice(e+1),d+1,f)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;A(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?
0:1)},searchKDTree:function(a,b){function c(a,b,h,m){var l=b.point,k=d.kdAxisArray[h%m],r,p,t=l;p=y(a[f])&&y(l[f])?Math.pow(a[f]-l[f],2):null;r=y(a[g])&&y(l[g])?Math.pow(a[g]-l[g],2):null;r=(p||0)+(r||0);l.dist=y(r)?Math.sqrt(r):Number.MAX_VALUE;l.distX=y(p)?Math.sqrt(p):Number.MAX_VALUE;k=a[k]-l[k];r=0>k?"left":"right";p=0>k?"right":"left";b[r]&&(r=c(a,b[r],h+1,m),t=r[e]<t[e]?r:l);b[p]&&Math.sqrt(k*k)<t[e]&&(a=c(a,b[p],h+1,m),t=a[e]<t[e]?a:t);return t}var d=this,f=this.kdAxisArray[0],g=this.kdAxisArray[1],
e=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(K);(function(a){var C=a.Axis,E=a.Chart,F=a.correctFloat,n=a.defined,h=a.destroyObjectProperties,e=a.each,u=a.format,y=a.objectEach,q=a.pick,x=a.Series;a.StackItem=function(a,c,e,h,l){var d=a.chart.inverted;this.axis=a;this.isNegative=e;this.options=c;this.x=h;this.total=null;this.points={};this.stack=l;this.rightCliff=this.leftCliff=
0;this.alignOptions={align:c.align||(d?e?"left":"right":"center"),verticalAlign:c.verticalAlign||(d?"middle":e?"bottom":"top"),y:q(c.y,d?4:e?14:-6),x:q(c.x,d?e?-6:6:0)};this.textAlign=c.textAlign||(d?e?"right":"left":"center")};a.StackItem.prototype={destroy:function(){h(this,this.axis)},render:function(a){var c=this.axis.chart,f=this.options,e=f.format,e=e?u(e,this,c.time):f.formatter.call(this);this.label?this.label.attr({text:e,visibility:"hidden"}):this.label=c.renderer.text(e,null,null,f.useHTML).css(f.style).attr({align:this.textAlign,
rotation:f.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,c){var f=this.axis,e=f.chart,h=f.translate(f.usePercentage?100:this.total,0,0,0,1),d=f.translate(0),d=Math.abs(h-d);a=e.xAxis[0].translate(this.x)+a;f=this.getStackBox(e,this,a,h,c,d,f);if(c=this.label)c.align(this.alignOptions,null,f),f=c.alignAttr,c[!1===this.options.crop||e.isInsidePlot(f.x,f.y)?"show":"hide"](!0)},getStackBox:function(a,c,e,h,l,d,b){var f=c.axis.reversed,k=a.inverted;a=b.height+b.pos-(k?a.plotLeft:a.plotTop);
c=c.isNegative&&!f||!c.isNegative&&f;return{x:k?c?h:h-d:e,y:k?a-e-l:c?a-h-d:a-h,width:k?d:l,height:k?l:d}}};E.prototype.getStacks=function(){var a=this;e(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});e(a.series,function(c){!c.options.stacking||!0!==c.visible&&!1!==a.options.chart.ignoreHiddenSeries||(c.stackKey=c.type+q(c.options.stack,""))})};C.prototype.buildStacks=function(){var a=this.series,c=q(this.options.reversedStacks,!0),e=a.length,h;if(!this.isXAxis){this.usePercentage=
!1;for(h=e;h--;)a[c?h:e-h-1].setStackedPoints();for(h=0;h<e;h++)a[h].modifyStacks()}};C.prototype.renderStackTotals=function(){var a=this.chart,c=a.renderer,e=this.stacks,h=this.stackTotalGroup;h||(this.stackTotalGroup=h=c.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());h.translate(a.plotLeft,a.plotTop);y(e,function(a){y(a,function(a){a.render(h)})})};C.prototype.resetStacks=function(){var a=this,c=a.stacks;a.isXAxis||y(c,function(c){y(c,function(f,e){f.touched<a.stacksTouched?(f.destroy(),
delete c[e]):(f.total=null,f.cumulative=null)})})};C.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&(a=this.stacks=this.oldStacks),y(a,function(a){y(a,function(a){a.cumulative=a.total})}))};x.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var f=this.processedXData,c=this.processedYData,e=[],h=c.length,l=this.options,d=l.threshold,b=q(l.startFromThreshold&&d,0),v=l.stack,l=l.stacking,p=this.stackKey,
u="-"+p,t=this.negStacks,y=this.yAxis,A=y.stacks,H=y.oldStacks,m,D,B,x,G,g,w;y.stacksTouched+=1;for(G=0;G<h;G++)g=f[G],w=c[G],m=this.getStackIndicator(m,g,this.index),x=m.key,B=(D=t&&w<(b?0:d))?u:p,A[B]||(A[B]={}),A[B][g]||(H[B]&&H[B][g]?(A[B][g]=H[B][g],A[B][g].total=null):A[B][g]=new a.StackItem(y,y.options.stackLabels,D,g,v)),B=A[B][g],null!==w?(B.points[x]=B.points[this.index]=[q(B.cumulative,b)],n(B.cumulative)||(B.base=x),B.touched=y.stacksTouched,0<m.index&&!1===this.singleStacks&&(B.points[x][0]=
B.points[this.index+","+g+",0"][0])):B.points[x]=B.points[this.index]=null,"percent"===l?(D=D?p:u,t&&A[D]&&A[D][g]?(D=A[D][g],B.total=D.total=Math.max(D.total,B.total)+Math.abs(w)||0):B.total=F(B.total+(Math.abs(w)||0))):B.total=F(B.total+(w||0)),B.cumulative=q(B.cumulative,b)+(w||0),null!==w&&(B.points[x].push(B.cumulative),e[G]=B.cumulative);"percent"===l&&(y.usePercentage=!0);this.stackedYData=e;y.oldStacks={}}};x.prototype.modifyStacks=function(){var a=this,c=a.stackKey,h=a.yAxis.stacks,r=a.processedXData,
l,d=a.options.stacking;a[d+"Stacker"]&&e([c,"-"+c],function(b){for(var c=r.length,f,e;c--;)if(f=r[c],l=a.getStackIndicator(l,f,a.index,b),e=(f=h[b]&&h[b][f])&&f.points[l.key])a[d+"Stacker"](e,f,c)})};x.prototype.percentStacker=function(a,c,e){c=c.total?100/c.total:0;a[0]=F(a[0]*c);a[1]=F(a[1]*c);this.stackedYData[e]=a[1]};x.prototype.getStackIndicator=function(a,c,e,h){!n(a)||a.x!==c||h&&a.key!==h?a={x:c,index:0,key:h}:a.index++;a.key=[e,c,a.index].join();return a}})(K);(function(a){var C=a.addEvent,
E=a.animate,F=a.Axis,n=a.createElement,h=a.css,e=a.defined,u=a.each,y=a.erase,q=a.extend,x=a.fireEvent,f=a.inArray,c=a.isNumber,k=a.isObject,r=a.isArray,l=a.merge,d=a.objectEach,b=a.pick,v=a.Point,p=a.Series,I=a.seriesTypes,t=a.setAnimation,L=a.splat;q(a.Chart.prototype,{addSeries:function(a,c,d){var f,e=this;a&&(c=b(c,!0),x(e,"addSeries",{options:a},function(){f=e.initSeries(a);e.isDirtyLegend=!0;e.linkSeries();x(e,"afterAddSeries");c&&e.redraw(d)}));return f},addAxis:function(a,c,d,f){var e=c?"xAxis":
"yAxis",h=this.options;a=l(a,{index:this[e].length,isX:c});c=new F(this,a);h[e]=L(h[e]||{});h[e].push(a);b(d,!0)&&this.redraw(f);return c},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,f=c.loading,e=function(){d&&h(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=n("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=n("span",{className:"highcharts-loading-inner"},null,d),C(b,
"redraw",e));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;h(d,q(f.style,{zIndex:10}));h(b.loadingSpan,f.labelStyle);b.loadingShown||(h(d,{opacity:0,display:""}),E(d,{opacity:f.style.opacity||.5},{duration:f.showDuration||0}));b.loadingShown=!0;e()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",E(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){h(b,{display:"none"})}}));
this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),update:function(a,h,m,k){var t=this,p={credits:"addCredits",
title:"setTitle",subtitle:"setSubtitle"},r=a.chart,g,n,A=[];x(t,"update",{options:a});if(r){l(!0,t.options.chart,r);"className"in r&&t.setClassName(r.className);"reflow"in r&&t.setReflow(r.reflow);if("inverted"in r||"polar"in r||"type"in r)t.propFromSeries(),g=!0;"alignTicks"in r&&(g=!0);d(r,function(a,b){-1!==f("chart."+b,t.propsRequireUpdateSeries)&&(n=!0);-1!==f(b,t.propsRequireDirtyBox)&&(t.isDirtyBox=!0)});"style"in r&&t.renderer.setStyle(r.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&
l(!0,this.options.plotOptions,a.plotOptions);d(a,function(a,b){if(t[b]&&"function"===typeof t[b].update)t[b].update(a,!1);else if("function"===typeof t[p[b]])t[p[b]](a);"chart"!==b&&-1!==f(b,t.propsRequireUpdateSeries)&&(n=!0)});u("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){var c;a[b]&&("series"===b&&(c=[],u(t[b],function(a,b){a.options.isInternal||c.push(b)})),u(L(a[b]),function(a,d){(d=e(a.id)&&t.get(a.id)||t[b][c?c[d]:d])&&d.coll===b&&(d.update(a,!1),m&&(d.touched=!0));if(!d&&
m)if("series"===b)t.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)t.addAxis(a,"xAxis"===b,!1).touched=!0}),m&&u(t[b],function(a){a.touched||a.options.isInternal?delete a.touched:A.push(a)}))});u(A,function(a){a.remove(!1)});g&&u(t.axes,function(a){a.update({},!1)});n&&u(t.series,function(a){a.update({},!1)});a.loading&&l(!0,t.options.loading,a.loading);g=r&&r.width;r=r&&r.height;c(g)&&g!==t.chartWidth||c(r)&&r!==t.chartHeight?t.setSize(g,r,k):b(h,!0)&&t.redraw(k);x(t,"afterUpdate",{options:a})},
setSubtitle:function(a){this.setTitle(void 0,a)}});q(v.prototype,{update:function(a,c,d,f){function e(){h.applyOptions(a);null===h.y&&g&&(h.graphic=g.destroy());k(a,!0)&&(g&&g.element&&a&&a.marker&&void 0!==a.marker.symbol&&(h.graphic=g.destroy()),a&&a.dataLabels&&h.dataLabel&&(h.dataLabel=h.dataLabel.destroy()),h.connector&&(h.connector=h.connector.destroy()));l=h.index;m.updateParallelArrays(h,l);p.data[l]=k(p.data[l],!0)||k(a,!0)?h.options:b(a,p.data[l]);m.isDirty=m.isDirtyData=!0;!m.fixedBox&&
m.hasCartesianSeries&&(t.isDirtyBox=!0);"point"===p.legendType&&(t.isDirtyLegend=!0);c&&t.redraw(d)}var h=this,m=h.series,g=h.graphic,l,t=m.chart,p=m.options;c=b(c,!0);!1===f?e():h.firePointEvent("update",{options:a},e)},remove:function(a,b){this.series.removePoint(f(this,this.series.data),a,b)}});q(p.prototype,{addPoint:function(a,c,d,f){var e=this.options,h=this.data,m=this.chart,g=this.xAxis,g=g&&g.hasNames&&g.names,l=e.data,k,t,p=this.xData,r,n;c=b(c,!0);k={series:this};this.pointClass.prototype.applyOptions.apply(k,
[a]);n=k.x;r=p.length;if(this.requireSorting&&n<p[r-1])for(t=!0;r&&p[r-1]>n;)r--;this.updateParallelArrays(k,"splice",r,0,0);this.updateParallelArrays(k,r);g&&k.name&&(g[n]=k.name);l.splice(r,0,a);t&&(this.data.splice(r,0,null),this.processData());"point"===e.legendType&&this.generatePoints();d&&(h[0]&&h[0].remove?h[0].remove(!1):(h.shift(),this.updateParallelArrays(k,"shift"),l.shift()));this.isDirtyData=this.isDirty=!0;c&&m.redraw(f)},removePoint:function(a,c,d){var f=this,e=f.data,h=e[a],m=f.points,
g=f.chart,l=function(){m&&m.length===e.length&&m.splice(a,1);e.splice(a,1);f.options.data.splice(a,1);f.updateParallelArrays(h||{series:f},"splice",a,1);h&&h.destroy();f.isDirty=!0;f.isDirtyData=!0;c&&g.redraw()};t(d,g);c=b(c,!0);h?h.firePointEvent("remove",null,l):l()},remove:function(a,c,d){function f(){e.destroy();h.isDirtyLegend=h.isDirtyBox=!0;h.linkSeries();b(a,!0)&&h.redraw(c)}var e=this,h=e.chart;!1!==d?x(e,"remove",null,f):f()},update:function(c,d){var e=this,h=e.chart,k=e.userOptions,t=
e.oldType||e.type,p=c.type||k.type||h.options.chart.type,g=I[t].prototype,r,n=["group","markerGroup","dataLabelsGroup"],v=["navigatorSeries","baseSeries"],A=e.finishedAnimating&&{animation:!1},y=["data","name","turboThreshold"],H=a.keys(c),z=0<H.length;u(H,function(a){-1===f(a,y)&&(z=!1)});if(z)c.data&&this.setData(c.data,!1),c.name&&this.setName(c.name,!1);else{v=n.concat(v);u(v,function(a){v[a]=e[a];delete e[a]});c=l(k,A,{index:e.index,pointStart:b(k.pointStart,e.xData[0])},{data:e.options.data},
c);e.remove(!1,null,!1);for(r in g)e[r]=void 0;I[p||t]?q(e,I[p||t].prototype):a.error(17,!0);u(v,function(a){e[a]=v[a]});e.init(h,c);c.zIndex!==k.zIndex&&u(n,function(a){e[a]&&e[a].attr({zIndex:c.zIndex})});e.oldType=t;h.linkSeries()}x(this,"afterUpdate");b(d,!0)&&h.redraw(!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});q(F.prototype,{update:function(a,c){var f=this.chart,e=a&&a.events||{};a=l(this.userOptions,a);f.options[this.coll].indexOf&&
(f.options[this.coll][f.options[this.coll].indexOf(this.userOptions)]=a);d(f.options[this.coll].events,function(a,b){"undefined"===typeof e[b]&&(e[b]=void 0)});this.destroy(!0);this.init(f,q(a,{events:e}));f.isDirtyBox=!0;b(c,!0)&&f.redraw()},remove:function(a){for(var c=this.chart,d=this.coll,f=this.series,e=f.length;e--;)f[e]&&f[e].remove(!1);y(c.axes,this);y(c[d],this);r(c.options[d])?c.options[d].splice(this.options.index,1):delete c.options[d];u(c[d],function(a,b){a.options.index=a.userOptions.index=
b});this.destroy();c.isDirtyBox=!0;b(a,!0)&&c.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(K);(function(a){var C=a.color,E=a.each,F=a.map,n=a.pick,h=a.Series,e=a.seriesType;e("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(e){var h=[],q=[],u=this.xAxis,f=this.yAxis,c=f.stacks[this.stackKey],k={},r=this.index,l=f.series,d=l.length,b,v=n(f.options.reversedStacks,!0)?1:-1,p;e=e||this.points;
if(this.options.stacking){for(p=0;p<e.length;p++)e[p].leftNull=e[p].rightNull=null,k[e[p].x]=e[p];a.objectEach(c,function(a,b){null!==a.total&&q.push(b)});q.sort(function(a,b){return a-b});b=F(l,function(){return this.visible});E(q,function(a,e){var l=0,t,n;if(k[a]&&!k[a].isNull)h.push(k[a]),E([-1,1],function(f){var h=1===f?"rightNull":"leftNull",l=0,m=c[q[e+f]];if(m)for(p=r;0<=p&&p<d;)t=m.points[p],t||(p===r?k[a][h]=!0:b[p]&&(n=c[a].points[p])&&(l-=n[1]-n[0])),p+=v;k[a][1===f?"rightCliff":"leftCliff"]=
l});else{for(p=r;0<=p&&p<d;){if(t=c[a].points[p]){l=t[1];break}p+=v}l=f.translate(l,0,1,0,1);h.push({isNull:!0,plotX:u.translate(a,0,0,0,1),x:a,plotY:l,yBottom:l})}})}return h},getGraphPath:function(a){var e=h.prototype.getGraphPath,q=this.options,u=q.stacking,f=this.yAxis,c,k,r=[],l=[],d=this.index,b,v=f.stacks[this.stackKey],p=q.threshold,I=f.getThreshold(q.threshold),t,q=q.connectNulls||"percent"===u,L=function(c,e,h){var m=a[c];c=u&&v[m.x].points[d];var k=m[h+"Null"]||0;h=m[h+"Cliff"]||0;var t,
n,m=!0;h||k?(t=(k?c[0]:c[1])+h,n=c[0]+h,m=!!k):!u&&a[e]&&a[e].isNull&&(t=n=p);void 0!==t&&(l.push({plotX:b,plotY:null===t?I:f.getThreshold(t),isNull:m,isCliff:!0}),r.push({plotX:b,plotY:null===n?I:f.getThreshold(n),doCurve:!1}))};a=a||this.points;u&&(a=this.getStackPoints(a));for(c=0;c<a.length;c++)if(k=a[c].isNull,b=n(a[c].rectPlotX,a[c].plotX),t=n(a[c].yBottom,I),!k||q)q||L(c,c-1,"left"),k&&!u&&q||(l.push(a[c]),r.push({x:c,plotX:b,plotY:t})),q||L(c,c+1,"right");c=e.call(this,l,!0,!0);r.reversed=
!0;k=e.call(this,r,!0,!0);k.length&&(k[0]="L");k=c.concat(k);e=e.call(this,l,!1,q);k.xMap=c.xMap;this.areaPath=k;return e},drawGraph:function(){this.areaPath=[];h.prototype.drawGraph.apply(this);var a=this,e=this.areaPath,q=this.options,x=[["area","highcharts-area",this.color,q.fillColor]];E(this.zones,function(f,c){x.push(["zone-area-"+c,"highcharts-area highcharts-zone-area-"+c+" "+f.className,f.color||a.color,f.fillColor||q.fillColor])});E(x,function(f){var c=f[0],h=a[c];h?(h.endX=a.preventGraphAnimation?
null:e.xMap,h.animate({d:e})):(h=a[c]=a.chart.renderer.path(e).addClass(f[1]).attr({fill:n(f[3],C(f[2]).setOpacity(n(q.fillOpacity,.75)).get()),zIndex:0}).add(a.group),h.isArea=!0);h.startX=e.xMap;h.shiftUnit=q.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,F,n){var h=F.plotX,e=F.plotY,u=a[n-1];n=a[n+1];var y,q,x,f;if(u&&!u.isNull&&!1!==u.doCurve&&!F.isCliff&&n&&!n.isNull&&!1!==n.doCurve&&
!F.isCliff){a=u.plotY;x=n.plotX;n=n.plotY;var c=0;y=(1.5*h+u.plotX)/2.5;q=(1.5*e+a)/2.5;x=(1.5*h+x)/2.5;f=(1.5*e+n)/2.5;x!==y&&(c=(f-q)*(x-h)/(x-y)+e-f);q+=c;f+=c;q>a&&q>e?(q=Math.max(a,e),f=2*e-q):q<a&&q<e&&(q=Math.min(a,e),f=2*e-q);f>n&&f>e?(f=Math.max(n,e),q=2*e-f):f<n&&f<e&&(f=Math.min(n,e),q=2*e-f);F.rightContX=x;F.rightContY=f}F=["C",C(u.rightContX,u.plotX),C(u.rightContY,u.plotY),C(y,h),C(q,e),h,e];u.rightContX=u.rightContY=null;return F}})})(K);(function(a){var C=a.seriesTypes.area.prototype,
E=a.seriesType;E("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:C.getStackPoints,getGraphPath:C.getGraphPath,drawGraph:C.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.animObject,E=a.color,F=a.each,n=a.extend,h=a.isNumber,e=a.merge,u=a.pick,y=a.Series,q=a.seriesType,x=a.svg;q("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},
select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){y.prototype.init.apply(this,arguments);var a=this,c=a.chart;c.hasRendered&&F(c.series,function(c){c.type===a.type&&(c.isDirty=!0)})},getColumnMetrics:function(){var a=this,c=a.options,e=a.xAxis,
h=a.yAxis,l=e.options.reversedStacks,l=e.reversed&&!l||!e.reversed&&l,d,b={},n=0;!1===c.grouping?n=1:F(a.chart.series,function(c){var f=c.options,e=c.yAxis,l;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||h.len!==e.len||h.pos!==e.pos||(f.stacking?(d=c.stackKey,void 0===b[d]&&(b[d]=n++),l=b[d]):!1!==f.grouping&&(l=n++),c.columnIndex=l)});var p=Math.min(Math.abs(e.transA)*(e.ordinalSlope||c.pointRange||e.closestPointRange||e.tickInterval||1),e.len),q=p*c.groupPadding,t=(p-2*
q)/(n||1),c=Math.min(c.maxPointWidth||e.len,u(c.pointWidth,t*(1-2*c.pointPadding)));a.columnMetrics={width:c,offset:(t-c)/2+(q+((a.columnIndex||0)+(l?1:0))*t-p/2)*(l?-1:1)};return a.columnMetrics},crispCol:function(a,c,e,h){var f=this.chart,d=this.borderWidth,b=-(d%2?.5:0),d=d%2?.5:1;f.inverted&&f.renderer.isVML&&(d+=1);this.options.crisp&&(e=Math.round(a+e)+b,a=Math.round(a)+b,e-=a);h=Math.round(c+h)+d;b=.5>=Math.abs(c)&&.5<h;c=Math.round(c)+d;h-=c;b&&h&&(--c,h+=1);return{x:a,y:c,width:e,height:h}},
translate:function(){var a=this,c=a.chart,e=a.options,h=a.dense=2>a.closestPointRange*a.xAxis.transA,h=a.borderWidth=u(e.borderWidth,h?0:1),l=a.yAxis,d=e.threshold,b=a.translatedThreshold=l.getThreshold(d),n=u(e.minPointLength,5),p=a.getColumnMetrics(),q=p.width,t=a.barW=Math.max(q,1+2*h),x=a.pointXOffset=p.offset;c.inverted&&(b-=.5);e.pointPadding&&(t=Math.ceil(t));y.prototype.translate.apply(a);F(a.points,function(f){var e=u(f.yBottom,b),h=999+Math.abs(e),h=Math.min(Math.max(-h,f.plotY),l.len+h),
k=f.plotX+x,p=t,r=Math.min(h,e),v,g=Math.max(h,e)-r;n&&Math.abs(g)<n&&(g=n,v=!l.reversed&&!f.negative||l.reversed&&f.negative,f.y===d&&a.dataMax<=d&&l.min<d&&(v=!v),r=Math.abs(r-b)>n?e-n:b-(v?n:0));f.barX=k;f.pointWidth=q;f.tooltipPos=c.inverted?[l.len+l.pos-c.plotLeft-h,a.xAxis.len-k-p/2,g]:[k+p/2,h+l.pos-c.plotTop,g];f.shapeType="rect";f.shapeArgs=a.crispCol.apply(a,f.isNull?[k,b,p,0]:[k,r,p,g])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?
"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,c){var f=this.options,h,l=this.pointAttrToOptions||{};h=l.stroke||"borderColor";var d=l["stroke-width"]||"borderWidth",b=a&&a.color||this.color,n=a&&a[h]||f[h]||this.color||b,p=a&&a[d]||f[d]||this[d]||0,l=f.dashStyle;a&&this.zones.length&&(b=a.getZone(),b=a.options.color||b&&b.color||this.color);c&&(a=e(f.states[c],a.options.states&&a.options.states[c]||{}),c=a.brightness,b=a.color||void 0!==c&&E(b).brighten(a.brightness).get()||
b,n=a[h]||n,p=a[d]||p,l=a.dashStyle||l);h={fill:b,stroke:n,"stroke-width":p};l&&(h.dashstyle=l);return h},drawPoints:function(){var a=this,c=this.chart,k=a.options,r=c.renderer,l=k.animationLimit||250,d;F(a.points,function(b){var f=b.graphic,p=f&&c.pointCount<l?"animate":"attr";if(h(b.plotY)&&null!==b.y){d=b.shapeArgs;if(f)f[p](e(d));else b.graphic=f=r[b.shapeType](d).add(b.group||a.group);k.borderRadius&&f.attr({r:k.borderRadius});f[p](a.pointAttribs(b,b.selected&&"select")).shadow(k.shadow,null,
k.stacking&&!k.borderRadius);f.addClass(b.getClassName(),!0)}else f&&(b.graphic=f.destroy())})},animate:function(a){var c=this,f=this.yAxis,e=c.options,h=this.chart.inverted,d={},b=h?"translateX":"translateY",q;x&&(a?(d.scaleY=.001,a=Math.min(f.pos+f.len,Math.max(f.pos,f.toPixels(e.threshold))),h?d.translateX=a-f.len:d.translateY=a,c.group.attr(d)):(q=c.group.attr(b),c.group.animate({scaleY:1},n(C(c.options.animation),{step:function(a,e){d[b]=q+e.pos*(f.pos-q);c.group.attr(d)}})),c.animate=null))},
remove:function(){var a=this,c=a.chart;c.hasRendered&&F(c.series,function(c){c.type===a.type&&(c.isDirty=!0)});y.prototype.remove.apply(a,arguments)}})})(K);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(K);(function(a){var C=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&C.prototype.drawGraph.call(this)}})})(K);(function(a){var C=a.deg2rad,E=a.isNumber,F=a.pick,n=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,e=this.chart,u=2*(a.slicedOffset||0),y=e.plotWidth-2*u,
e=e.plotHeight-2*u,q=a.center,q=[F(q[0],"50%"),F(q[1],"50%"),a.size||"100%",a.innerSize||0],x=Math.min(y,e),f,c;for(f=0;4>f;++f)c=q[f],a=2>f||2===f&&/%$/.test(c),q[f]=n(c,[y,e,x,q[2]][f])+(a?u:0);q[3]>q[2]&&(q[3]=q[2]);return q},getStartAndEndRadians:function(a,e){a=E(a)?a:0;e=E(e)&&e>a&&360>e-a?e:a+360;return{start:C*(a+-90),end:C*(e+-90)}}}})(K);(function(a){var C=a.addEvent,E=a.CenteredSeriesMixin,F=a.defined,n=a.each,h=a.extend,e=E.getStartAndEndRadians,u=a.inArray,y=a.noop,q=a.pick,x=a.Point,
f=a.Series,c=a.seriesType,k=a.setAnimation;c("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,
trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var c=this,d=c.points,b=c.startAngleRad;a||(n(d,function(a){var d=a.graphic,f=a.shapeArgs;d&&(d.attr({r:a.startR||c.center[3]/2,start:b,end:b}),d.animate({r:f.r,start:f.start,end:f.end},c.options.animation))}),c.animate=null)},updateTotals:function(){var a,c=0,d=this.points,b=d.length,f,e=this.options.ignoreHiddenPoint;for(a=0;a<b;a++)f=d[a],c+=e&&!f.visible?0:f.isNull?
0:f.y;this.total=c;for(a=0;a<b;a++)f=d[a],f.percentage=0<c&&(f.visible||!e)?f.y/c*100:0,f.total=c},generatePoints:function(){f.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();var c=0,d=this.options,b=d.slicedOffset,f=b+(d.borderWidth||0),h,k,t,n=e(d.startAngle,d.endAngle),r=this.startAngleRad=n.start,n=(this.endAngleRad=n.end)-r,u=this.points,m,x=d.dataLabels.distance,d=d.ignoreHiddenPoint,y,C=u.length,G;a||(this.center=a=this.getCenter());this.getX=
function(b,c,d){t=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(t)*(a[2]/2+d.labelDistance)};for(y=0;y<C;y++){G=u[y];G.labelDistance=q(G.options.dataLabels&&G.options.dataLabels.distance,x);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,G.labelDistance);h=r+c*n;if(!d||G.visible)c+=G.percentage/100;k=r+c*n;G.shapeType="arc";G.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*h)/1E3,end:Math.round(1E3*k)/1E3};t=(k+h)/2;t>1.5*Math.PI?
t-=2*Math.PI:t<-Math.PI/2&&(t+=2*Math.PI);G.slicedTranslation={translateX:Math.round(Math.cos(t)*b),translateY:Math.round(Math.sin(t)*b)};k=Math.cos(t)*a[2]/2;m=Math.sin(t)*a[2]/2;G.tooltipPos=[a[0]+.7*k,a[1]+.7*m];G.half=t<-Math.PI/2||t>Math.PI/2?1:0;G.angle=t;h=Math.min(f,G.labelDistance/5);G.labelPos=[a[0]+k+Math.cos(t)*G.labelDistance,a[1]+m+Math.sin(t)*G.labelDistance,a[0]+k+Math.cos(t)*h,a[1]+m+Math.sin(t)*h,a[0]+k,a[1]+m,0>G.labelDistance?"center":G.half?"right":"left",t]}},drawGraph:null,
drawPoints:function(){var a=this,c=a.chart.renderer,d,b,f,e,k=a.options.shadow;k&&!a.shadowGroup&&(a.shadowGroup=c.g("shadow").add(a.group));n(a.points,function(l){b=l.graphic;if(l.isNull)b&&(l.graphic=b.destroy());else{e=l.shapeArgs;d=l.getTranslate();var t=l.shadowGroup;k&&!t&&(t=l.shadowGroup=c.g("shadow").add(a.shadowGroup));t&&t.attr(d);f=a.pointAttribs(l,l.selected&&"select");b?b.setRadialReference(a.center).attr(f).animate(h(e,d)):(l.graphic=b=c[l.shapeType](e).setRadialReference(a.center).attr(d).add(a.group),
b.attr(f).attr({"stroke-linejoin":"round"}).shadow(k,t));b.attr({visibility:l.visible?"inherit":"hidden"});b.addClass(l.getClassName())}})},searchPoint:y,sortByAngle:function(a,c){a.sort(function(a,b){return void 0!==a.angle&&(b.angle-a.angle)*c})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:E.getCenter,getSymbol:y},{init:function(){x.prototype.init.apply(this,arguments);var a=this,c;a.name=q(a.name,"Slice");c=function(c){a.slice("select"===c.type)};C(a,"select",c);C(a,"unselect",
c);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,c){var d=this,b=d.series,f=b.chart,e=b.options.ignoreHiddenPoint;c=q(c,e);a!==d.visible&&(d.visible=d.options.visible=a=void 0===a?!d.visible:a,b.options.data[u(d,b.data)]=d.options,n(["graphic","dataLabel","connector","shadowGroup"],function(b){if(d[b])d[b][a?"show":"hide"](!0)}),d.legendItem&&f.legend.colorizeItem(d,a),a||"hover"!==d.state||d.setState(""),e&&(b.isDirty=!0),c&&f.redraw())},slice:function(a,
c,d){var b=this.series;k(d,b.chart);q(c,!0);this.sliced=this.options.sliced=F(a)?a:!this.sliced;b.options.data[u(this,b.data)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var c=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.x,c.y,c.r+a,c.r+a,{innerR:this.shapeArgs.r-
1,start:c.start,end:c.end})}})})(K);(function(a){var C=a.addEvent,E=a.arrayMax,F=a.defined,n=a.each,h=a.extend,e=a.format,u=a.map,y=a.merge,q=a.noop,x=a.pick,f=a.relativeLength,c=a.Series,k=a.seriesTypes,r=a.some,l=a.stableSort;a.distribute=function(c,b,f){function d(a,b){return a.target-b.target}var e,h=!0,k=c,q=[],v;v=0;var m=k.reducedLen||b;for(e=c.length;e--;)v+=c[e].size;if(v>m){l(c,function(a,b){return(b.rank||0)-(a.rank||0)});for(v=e=0;v<=m;)v+=c[e].size,e++;q=c.splice(e-1,c.length)}l(c,d);
for(c=u(c,function(a){return{size:a.size,targets:[a.target],align:x(a.align,.5)}});h;){for(e=c.length;e--;)h=c[e],v=(Math.min.apply(0,h.targets)+Math.max.apply(0,h.targets))/2,h.pos=Math.min(Math.max(0,v-h.size*h.align),b-h.size);e=c.length;for(h=!1;e--;)0<e&&c[e-1].pos+c[e-1].size>c[e].pos&&(c[e-1].size+=c[e].size,c[e-1].targets=c[e-1].targets.concat(c[e].targets),c[e-1].align=.5,c[e-1].pos+c[e-1].size>b&&(c[e-1].pos=b-c[e-1].size),c.splice(e,1),h=!0)}k.push.apply(k,q);e=0;r(c,function(c){var d=
0;if(r(c.targets,function(){k[e].pos=c.pos+d;if(Math.abs(k[e].pos-k[e].target)>f)return n(k.slice(0,e+1),function(a){delete a.pos}),k.reducedLen=(k.reducedLen||b)-.1*b,k.reducedLen>.1*b&&a.distribute(k,b,f),!0;d+=k[e].size;e++}))return!0});l(k,d)};c.prototype.drawDataLabels=function(){function c(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}
var b=this,f=b.chart,h=b.options,l=h.dataLabels,k=b.points,r,q,u=b.hasRendered||0,m,D,B=x(l.defer,!!h.animation),E=f.renderer;if(l.enabled||b._hasPointLabels)b.dlProcessOptions&&b.dlProcessOptions(l),D=b.plotGroup("dataLabelsGroup","data-labels",B&&!u?"hidden":"visible",l.zIndex||6),B&&(D.attr({opacity:+u}),u||C(b,"afterAnimate",function(){b.visible&&D.show(!0);D[h.animation?"animate":"attr"]({opacity:1},{duration:200})})),q=l,n(k,function(d){var g,k=d.dataLabel,t,p,n=d.connector,u=!k,v;r=d.dlOptions||
d.options&&d.options.dataLabels;(g=x(r&&r.enabled,q.enabled)&&!d.isNull)&&(g=!0===c(d,r||l));g&&(l=y(q,r),t=d.getLabelConfig(),v=l[d.formatPrefix+"Format"]||l.format,m=F(v)?e(v,t,f.time):(l[d.formatPrefix+"Formatter"]||l.formatter).call(t,l),v=l.style,t=l.rotation,v.color=x(l.color,v.color,b.color,"#000000"),"contrast"===v.color&&(d.contrastColor=E.getContrast(d.color||b.color),v.color=l.inside||0>x(d.labelDistance,l.distance)||h.stacking?d.contrastColor:"#000000"),h.cursor&&(v.cursor=h.cursor),p=
{fill:l.backgroundColor,stroke:l.borderColor,"stroke-width":l.borderWidth,r:l.borderRadius||0,rotation:t,padding:l.padding,zIndex:1},a.objectEach(p,function(a,b){void 0===a&&delete p[b]}));!k||g&&F(m)?g&&F(m)&&(k?p.text=m:(k=d.dataLabel=t?E.text(m,0,-9999).addClass("highcharts-data-label"):E.label(m,0,-9999,l.shape,null,null,l.useHTML,null,"data-label"),k.addClass(" highcharts-data-label-color-"+d.colorIndex+" "+(l.className||"")+(l.useHTML?" highcharts-tracker":""))),k.attr(p),k.css(v).shadow(l.shadow),
k.added||k.add(D),b.alignDataLabel(d,k,l,null,u)):(d.dataLabel=k=k.destroy(),n&&(d.connector=n.destroy()))});a.fireEvent(this,"afterDrawDataLabels")};c.prototype.alignDataLabel=function(a,b,c,e,f){var d=this.chart,l=d.inverted,k=x(a.dlBox&&a.dlBox.centerX,a.plotX,-9999),n=x(a.plotY,-9999),m=b.getBBox(),p,r=c.rotation,q=c.align,u=this.visible&&(a.series.forceDL||d.isInsidePlot(k,Math.round(n),l)||e&&d.isInsidePlot(k,l?e.x+1:e.y+e.height-1,l)),g="justify"===x(c.overflow,"justify");if(u&&(p=c.style.fontSize,
p=d.renderer.fontMetrics(p,b).b,e=h({x:l?this.yAxis.len-n:k,y:Math.round(l?this.xAxis.len-k:n),width:0,height:0},e),h(c,{width:m.width,height:m.height}),r?(g=!1,k=d.renderer.rotCorr(p,r),k={x:e.x+c.x+e.width/2+k.x,y:e.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*e.height},b[f?"attr":"animate"](k).attr({align:q}),n=(r+720)%360,n=180<n&&360>n,"left"===q?k.y-=n?m.height:0:"center"===q?(k.x-=m.width/2,k.y-=m.height/2):"right"===q&&(k.x-=m.width,k.y-=n?0:m.height),b.placed=!0,b.alignAttr=k):(b.align(c,
null,e),k=b.alignAttr),g?a.isLabelJustified=this.justifyDataLabel(b,c,k,m,e,f):x(c.crop,!0)&&(u=d.isInsidePlot(k.x,k.y)&&d.isInsidePlot(k.x+m.width,k.y+m.height)),c.shape&&!r))b[f?"attr":"animate"]({anchorX:l?d.plotWidth-a.plotY:a.plotX,anchorY:l?d.plotHeight-a.plotX:a.plotY});u||(b.attr({y:-9999}),b.placed=!1)};c.prototype.justifyDataLabel=function(a,b,c,e,f,h){var d=this.chart,l=b.align,k=b.verticalAlign,m,t,n=a.box?0:a.padding||0;m=c.x+n;0>m&&("right"===l?b.align="left":b.x=-m,t=!0);m=c.x+e.width-
n;m>d.plotWidth&&("left"===l?b.align="right":b.x=d.plotWidth-m,t=!0);m=c.y+n;0>m&&("bottom"===k?b.verticalAlign="top":b.y=-m,t=!0);m=c.y+e.height-n;m>d.plotHeight&&("top"===k?b.verticalAlign="bottom":b.y=d.plotHeight-m,t=!0);t&&(a.placed=!h,a.align(b,null,f));return t};k.pie&&(k.pie.prototype.drawDataLabels=function(){var d=this,b=d.data,e,f=d.chart,h=d.options.dataLabels,l=x(h.connectorPadding,10),k=x(h.connectorWidth,1),r=f.plotWidth,q=f.plotHeight,m=Math.round(f.chartWidth/3),u,y=d.center,C=y[2]/
2,G=y[1],g,w,K,Q,J=[[],[]],O,N,z,R,S=[0,0,0,0];d.visible&&(h.enabled||d._hasPointLabels)&&(n(b,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),c.prototype.drawDataLabels.apply(d),n(b,function(a){a.dataLabel&&(a.visible?(J[a.half].push(a),a.dataLabel._pos=null,!F(h.style.width)&&!F(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>
m&&(a.dataLabel.css({width:.7*m}),a.dataLabel.shortened=!0)):a.dataLabel=a.dataLabel.destroy())}),n(J,function(b,c){var k,m,t=b.length,p=[],u;if(t)for(d.sortByAngle(b,c-.5),0<d.maxLabelDistance&&(k=Math.max(0,G-C-d.maxLabelDistance),m=Math.min(G+C+d.maxLabelDistance,f.plotHeight),n(b,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,G-C-a.labelDistance),a.bottom=Math.min(G+C+a.labelDistance,f.plotHeight),u=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPos[1]-a.top+u/
2,size:u,rank:a.y},p.push(a.distributeBox))}),k=m+u-k,a.distribute(p,k,k/5)),R=0;R<t;R++)e=b[R],K=e.labelPos,g=e.dataLabel,z=!1===e.visible?"hidden":"inherit",N=k=K[1],p&&F(e.distributeBox)&&(void 0===e.distributeBox.pos?z="hidden":(Q=e.distributeBox.size,N=e.top+e.distributeBox.pos)),delete e.positionIndex,O=h.justify?y[0]+(c?-1:1)*(C+e.labelDistance):d.getX(N<e.top+2||N>e.bottom-2?k:N,c,e),g._attr={visibility:z,align:K[6]},g._pos={x:O+h.x+({left:l,right:-l}[K[6]]||0),y:N+h.y-10},K.x=O,K.y=N,x(h.crop,
!0)&&(w=g.getBBox().width,k=null,O-w<l&&1===c?(k=Math.round(w-O+l),S[3]=Math.max(k,S[3])):O+w>r-l&&0===c&&(k=Math.round(O+w-r+l),S[1]=Math.max(k,S[1])),0>N-Q/2?S[0]=Math.max(Math.round(-N+Q/2),S[0]):N+Q/2>q&&(S[2]=Math.max(Math.round(N+Q/2-q),S[2])),g.sideOverflow=k)}),0===E(S)||this.verifyDataLabelOverflow(S))&&(this.placeDataLabels(),k&&n(this.points,function(a){var b;u=a.connector;if((g=a.dataLabel)&&g._pos&&a.visible&&0<a.labelDistance){z=g._attr.visibility;if(b=!u)a.connector=u=f.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+
a.colorIndex+(a.className?" "+a.className:"")).add(d.dataLabelsGroup),u.attr({"stroke-width":k,stroke:h.connectorColor||a.color||"#666666"});u[b?"attr":"animate"]({d:d.connectorPath(a.labelPos)});u.attr("visibility",z)}else u&&(a.connector=u.destroy())}))},k.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return x(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",
a[4],a[5]]},k.pie.prototype.placeDataLabels=function(){n(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:this.options.dataLabels.style.textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))},this)},k.pie.prototype.alignDataLabel=q,k.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=
this.options,d=c.center,e=c.minSize||80,h,l=null!==c.size;l||(null!==d[0]?h=Math.max(b[2]-Math.max(a[1],a[3]),e):(h=Math.max(b[2]-a[1]-a[3],e),b[0]+=(a[3]-a[1])/2),null!==d[1]?h=Math.max(Math.min(h,b[2]-Math.max(a[0],a[2])),e):(h=Math.max(Math.min(h,b[2]-a[0]-a[2]),e),b[1]+=(a[0]-a[2])/2),h<b[2]?(b[2]=h,b[3]=Math.min(f(c.innerSize||0,h),h),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):l=!0);return l});k.column&&(k.column.prototype.alignDataLabel=function(a,b,e,f,h){var d=this.chart.inverted,
l=a.series,k=a.dlBox||a.shapeArgs,n=x(a.below,a.plotY>x(this.translatedThreshold,l.yAxis.len)),m=x(e.inside,!!this.options.stacking);k&&(f=y(k),0>f.y&&(f.height+=f.y,f.y=0),k=f.y+f.height-l.yAxis.len,0<k&&(f.height-=k),d&&(f={x:l.yAxis.len-f.y-f.height,y:l.xAxis.len-f.x-f.width,width:f.height,height:f.width}),m||(d?(f.x+=n?0:f.width,f.width=0):(f.y+=n?f.height:0,f.height=0)));e.align=x(e.align,!d||m?"center":n?"right":"left");e.verticalAlign=x(e.verticalAlign,d||m?"middle":n?"top":"bottom");c.prototype.alignDataLabel.call(this,
a,b,e,f,h);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(K);(function(a){var C=a.Chart,E=a.each,F=a.objectEach,n=a.pick;a=a.addEvent;a(C,"render",function(){var a=[];E(this.labelCollectors||[],function(e){a=a.concat(e())});E(this.yAxis||[],function(e){e.options.stackLabels&&!e.options.stackLabels.allowOverlap&&F(e.stacks,function(e){F(e,function(e){a.push(e.label)})})});E(this.series||[],function(e){var h=e.options.dataLabels,y=e.dataLabelCollections||["dataLabel"];
(h.enabled||e._hasPointLabels)&&!h.allowOverlap&&e.visible&&E(y,function(h){E(e.points,function(e){e[h]&&(e[h].labelrank=n(e.labelrank,e.shapeArgs&&e.shapeArgs.height),a.push(e[h]))})})});this.hideOverlappingLabels(a)});C.prototype.hideOverlappingLabels=function(a){var e=a.length,h,n,q,x,f,c,k=function(a,c,d,b,e,f,h,k){return!(e>a+d||e+h<a||f>c+b||f+k<c)};q=function(a){var c,d,b,e=2*(a.box?0:a.padding||0);if(a&&(!a.alignAttr||a.placed))return c=a.alignAttr||{x:a.attr("x"),y:a.attr("y")},d=a.parentGroup,
a.width||(b=a.getBBox(),a.width=b.width,a.height=b.height),{x:c.x+(d.translateX||0),y:c.y+(d.translateY||0),width:a.width-e,height:a.height-e}};for(n=0;n<e;n++)if(h=a[n])h.oldOpacity=h.opacity,h.newOpacity=1,h.absoluteBox=q(h);a.sort(function(a,c){return(c.labelrank||0)-(a.labelrank||0)});for(n=0;n<e;n++)for(c=(q=a[n])&&q.absoluteBox,h=n+1;h<e;++h)if(f=(x=a[h])&&x.absoluteBox,c&&f&&q!==x&&0!==q.newOpacity&&0!==x.newOpacity&&(f=k(c.x,c.y,c.width,c.height,f.x,f.y,f.width,f.height)))(q.labelrank<x.labelrank?
q:x).newOpacity=0;E(a,function(a){var c,d;a&&(d=a.newOpacity,a.oldOpacity!==d&&(a.alignAttr&&a.placed?(d?a.show(!0):c=function(){a.hide()},a.alignAttr.opacity=d,a[a.isOld?"animate":"attr"](a.alignAttr,null,c)):a.attr({opacity:d})),a.isOld=!0)})}})(K);(function(a){var C=a.addEvent,E=a.Chart,F=a.createElement,n=a.css,h=a.defaultOptions,e=a.defaultPlotOptions,u=a.each,y=a.extend,q=a.fireEvent,x=a.hasTouch,f=a.inArray,c=a.isObject,k=a.Legend,r=a.merge,l=a.pick,d=a.Point,b=a.Series,v=a.seriesTypes,p=a.svg,
I;I=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};u(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(u(a.trackerGroups,function(d){if(a[d]){a[d].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(x)a[d].on("touchstart",
c);a.options.cursor&&a[d].css(n).css({cursor:a.options.cursor})}}),a._hasTracking=!0);q(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),e=d.length,f=a.chart,h=f.pointer,l=f.renderer,k=f.options.tooltip.snap,g=a.tracker,n,r=function(){if(f.hoverSeries!==a)a.onMouseOver()},v="rgba(192,192,192,"+(p?.0001:.002)+")";if(e&&!c)for(n=e+1;n--;)"M"===d[n]&&d.splice(n+1,0,d[n+1]-k,d[n+2],"L"),(n&&"M"===d[n]||n===e)&&d.splice(n,
0,"L",d[n-2]+k,d[n-1]);g?g.attr({d:d}):a.graph&&(a.tracker=l.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:v,fill:c?v:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*k),zIndex:2}).add(a.group),u([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",r).on("mouseout",function(a){h.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(x)a.on("touchstart",r)}));q(this,"afterDrawTracker")}};v.column&&(v.column.prototype.drawTracker=
I.drawTrackerPoint);v.pie&&(v.pie.prototype.drawTracker=I.drawTrackerPoint);v.scatter&&(v.scatter.prototype.drawTracker=I.drawTrackerPoint);y(k.prototype,{setItemEvents:function(a,b,c){var e=this,f=e.chart.renderer.boxWrapper,h="highcharts-legend-"+(a instanceof d?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");f.addClass(h);b.css(e.options.itemHoverStyle)}).on("mouseout",function(){b.css(r(a.visible?e.itemStyle:e.itemHiddenStyle));f.removeClass(h);a.setState()}).on("click",
function(b){var c=function(){a.setVisible&&a.setVisible()};f.removeClass(h);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):q(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=F("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){q(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});h.legend.itemStyle.cursor=
"pointer";y(E.prototype,{showResetZoom:function(){function a(){b.zoomOut()}var b=this,c=h.lang,d=b.options.chart.resetZoomButton,e=d.theme,f=e.states,k="chart"===d.relativeTo?null:"plotBox";q(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,e,f&&f.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,k)})},zoomOut:function(){q(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b,
d=this.pointer,e=!1,f;!a||a.resetSelection?(u(this.axes,function(a){b=a.zoom()}),d.initiated=!1):u(a.xAxis.concat(a.yAxis),function(a){var c=a.axis;d[c.isXAxis?"zoomX":"zoomY"]&&(b=c.zoom(a.min,a.max),c.displayBtn&&(e=!0))});f=this.resetZoomButton;e&&!f?this.showResetZoom():!e&&c(f)&&(this.resetZoomButton=f.destroy());b&&this.redraw(l(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&u(d,function(a){a.setState()});u("xy"===b?[1,0]:
[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",h=c[d],g=(b.pointRange||0)/2,k=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,l=b.getExtremes(),m=b.toValue(h-f,!0)+g*k,k=b.toValue(h+b.len-f,!0)-g*k,n=k<m,h=n?k:m,m=n?m:k,k=Math.min(l.dataMin,g?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding)),g=Math.max(l.dataMax,g?l.max:b.toValue(b.toPixels(l.max)+b.minPixelPadding)),n=k-h;0<n&&(m+=n,h=k);n=m-g;0<n&&(m=g,h-=n);b.series.length&&
h!==l.min&&m!==l.max&&(b.setExtremes(h,m,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);n(c.container,{cursor:"move"})}});y(d.prototype,{select:function(a,b){var c=this,d=c.series,e=d.chart;a=l(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[f(c,d.data)]=c.options;c.setState(a&&"select");b||u(e.getSelectedPoints(),function(a){a.selected&&a!==c&&(a.selected=a.options.selected=!1,d.options.data[f(a,d.data)]=a.options,
a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");u(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,c=r(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,
c){C(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,f=this.series,h=f.options.states[a||"normal"]||{},k=e[f.type].marker&&f.options.marker,n=k&&!1===k.enabled,p=k&&k.states&&k.states[a||"normal"]||{},g=!1===p.enabled,t=f.stateMarkerGraphic,r=this.marker||{},u=f.chart,v=f.halo,x,C=k&&f.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===h.enabled||a&&(g||n&&!1===p.enabled)||a&&r.states&&r.states[a]&&!1===r.states[a].enabled)){C&&
(x=f.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.animate(f.pointAttribs(this,a),l(u.options.chart.animation,h.animation)),x&&this.graphic.animate(x,l(u.options.chart.animation,p.animation,k.animation)),t&&t.hide();else{if(a&&p){k=r.symbol||f.symbol;t&&t.currentSymbol!==k&&(t=t.destroy());if(t)t[b?"animate":"attr"]({x:x.x,y:x.y});else k&&(f.stateMarkerGraphic=t=u.renderer.symbol(k,
x.x,x.y,x.width,x.height).add(f.markerGroup),t.currentSymbol=k);t&&t.attr(f.pointAttribs(this,a))}t&&(t[a&&u.isInsidePlot(c,d,u.inverted)?"show":"hide"](),t.element.point=this)}(c=h.halo)&&c.size?(v||(f.halo=v=u.renderer.path().add((this.graphic||t).parentGroup)),v.show()[b?"animate":"attr"]({d:this.haloPath(c.size)}),v.attr({"class":"highcharts-halo highcharts-color-"+l(this.colorIndex,f.colorIndex)+(this.className?" "+this.className:""),zIndex:-1}),v.point=this,v.attr(y({fill:this.color||f.color,
"fill-opacity":c.opacity},c.attributes))):v&&v.point&&v.point.haloPath&&v.animate({d:v.point.haloPath(0)},null,v.hide);this.state=a;q(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});y(b.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&q(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=
this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&q(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,e=c.states,f=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(u([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!e[a]||!1!==
e[a].enabled)&&(a&&(f=e[a].lineWidth||f+(e[a].lineWidthPlus||0)),d&&!d.dashstyle))for(f={"stroke-width":f},d.animate(f,l(e[a||"normal"]&&e[a||"normal"].animation,b.chart.options.chart.animation));b["zone-graph-"+c];)b["zone-graph-"+c].attr(f),c+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,h=d.options.chart.ignoreHiddenSeries,k=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!k:a)?"show":"hide";u(["group","dataLabelsGroup","markerGroup","tracker","tt"],
function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&u(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});u(c.linkedSeries,function(b){b.setVisible(a,!1)});h&&(d.isDirtyBox=!0);q(c,f);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=
a);q(this,a?"select":"unselect")},drawTracker:I.drawTrackerGraph})})(K);(function(a){var C=a.Chart,E=a.each,F=a.inArray,n=a.isArray,h=a.isObject,e=a.pick,u=a.splat;C.prototype.setResponsive=function(e){var h=this.options.responsive,n=[],f=this.currentResponsive;h&&h.rules&&E(h.rules,function(c){void 0===c._id&&(c._id=a.uniqueKey());this.matchResponsiveRule(c,n,e)},this);var c=a.merge.apply(0,a.map(n,function(c){return a.find(h.rules,function(a){return a._id===c}).chartOptions})),n=n.toString()||void 0;
n!==(f&&f.ruleIds)&&(f&&this.update(f.undoOptions,e),n?(this.currentResponsive={ruleIds:n,mergedOptions:c,undoOptions:this.currentOptions(c)},this.update(c,e)):this.currentResponsive=void 0)};C.prototype.matchResponsiveRule=function(a,h){var n=a.condition;(n.callback||function(){return this.chartWidth<=e(n.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=e(n.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=e(n.minWidth,0)&&this.chartHeight>=e(n.minHeight,0)}).call(this)&&h.push(a._id)};C.prototype.currentOptions=
function(e){function q(e,c,k,r){var f;a.objectEach(e,function(a,b){if(!r&&-1<F(b,["series","xAxis","yAxis"]))for(a=u(a),k[b]=[],f=0;f<a.length;f++)c[b][f]&&(k[b][f]={},q(a[f],c[b][f],k[b][f],r+1));else h(a)?(k[b]=n(a)?[]:{},q(a,c[b]||{},k[b],r+1)):k[b]=c[b]||null})}var x={};q(e,this.options,x,0);return x}})(K);return K});


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

/*
 Highcharts JS v6.1.1 (2018-06-27)
 Exporting module

 (c) 2010-2017 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(h){"object"===typeof module&&module.exports?module.exports=h:h(Highcharts)})(function(h){(function(f){var h=f.defaultOptions,z=f.doc,A=f.Chart,q=f.addEvent,I=f.removeEvent,C=f.fireEvent,r=f.createElement,D=f.discardElement,u=f.css,p=f.merge,B=f.pick,k=f.each,F=f.objectEach,t=f.extend,J=f.isTouchDevice,E=f.win,G=E.navigator.userAgent,K=f.Renderer.prototype.symbols;/Edge\/|Trident\/|MSIE /.test(G);/firefox/i.test(G);t(h.lang,{printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",
downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});h.navigation={buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}};p(!0,h.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",background:"none",color:"#333333",fontSize:J?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",
color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{fill:"#ffffff",stroke:"none",padding:5}}});h.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",_titleKey:"contextButtonTitle",menuItems:"printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},menuItemDefinitions:{printChart:{textKey:"printChart",
onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};f.post=function(a,b,e){var c=r("form",p({method:"post",action:a,enctype:"multipart/form-data"},
e),{display:"none"},z.body);F(b,function(a,b){r("input",{type:"hidden",name:b,value:a},null,c)});c.submit();D(c)};t(A.prototype,{sanitizeSVG:function(a,b){if(b&&b.exporting&&b.exporting.allowHTML){var e=a.match(/<\/svg>(.*?$)/);e&&e[1]&&(e='\x3cforeignObject x\x3d"0" y\x3d"0" width\x3d"'+b.chart.width+'" height\x3d"'+b.chart.height+'"\x3e\x3cbody xmlns\x3d"http://www.w3.org/1999/xhtml"\x3e'+e[1]+"\x3c/body\x3e\x3c/foreignObject\x3e",a=a.replace("\x3c/svg\x3e",e+"\x3c/svg\x3e"))}a=a.replace(/zIndex="[^"]+"/g,
"").replace(/isShadow="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(\S+)("|&quot;)\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'\x3csvg xmlns:xlink\x3d"http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+\:)href=/g," xlink:href\x3d").replace(/\n/," ").replace(/<\/svg>.*?$/,"\x3c/svg\x3e").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1\x3d"rgb($2)" $1-opacity\x3d"$3"').replace(/&nbsp;/g,
"\u00a0").replace(/&shy;/g,"\u00ad");this.ieSanitizeSVG&&(a=this.ieSanitizeSVG(a));return a},getChartHTML:function(){return this.container.innerHTML},getSVG:function(a){var b,e,c,v,m,g=p(this.options,a);e=r("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},z.body);c=this.renderTo.style.width;m=this.renderTo.style.height;c=g.exporting.sourceWidth||g.chart.width||/px$/.test(c)&&parseInt(c,10)||600;m=g.exporting.sourceHeight||g.chart.height||/px$/.test(m)&&
parseInt(m,10)||400;t(g.chart,{animation:!1,renderTo:e,forExport:!0,renderer:"SVGRenderer",width:c,height:m});g.exporting.enabled=!1;delete g.data;g.series=[];k(this.series,function(a){v=p(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});v.isInternal||g.series.push(v)});k(this.axes,function(a){a.userOptions.internalKey||(a.userOptions.internalKey=f.uniqueKey())});b=new f.Chart(g,this.callback);a&&k(["xAxis","yAxis","series"],function(c){var d={};a[c]&&(d[c]=a[c],
b.update(d))});k(this.axes,function(a){var c=f.find(b.axes,function(b){return b.options.internalKey===a.userOptions.internalKey}),d=a.getExtremes(),e=d.userMin,d=d.userMax;c&&(void 0!==e&&e!==c.min||void 0!==d&&d!==c.max)&&c.setExtremes(e,d,!0,!1)});c=b.getChartHTML();C(this,"getSVG",{chartCopy:b});c=this.sanitizeSVG(c,g);g=null;b.destroy();D(e);return c},getSVGForExport:function(a,b){var e=this.options.exporting;return this.getSVG(p({chart:{borderRadius:0}},e.chartOptions,b,{exporting:{sourceWidth:a&&
a.sourceWidth||e.sourceWidth,sourceHeight:a&&a.sourceHeight||e.sourceHeight}}))},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=p(this.options.exporting,a);f.post(a.url,{filename:a.filename||"chart",type:a.type,width:a.width||0,scale:a.scale,svg:b},a.formAttributes)},print:function(){var a=this,b=a.container,e=[],c=b.parentNode,f=z.body,m=f.childNodes,g=a.options.exporting.printMaxWidth,d,n;if(!a.isPrinting){a.isPrinting=!0;a.pointer.reset(null,0);C(a,"beforePrint");if(n=g&&a.chartWidth>
g)d=[a.options.chart.width,void 0,!1],a.setSize(g,void 0,!1);k(m,function(a,b){1===a.nodeType&&(e[b]=a.style.display,a.style.display="none")});f.appendChild(b);E.focus();E.print();setTimeout(function(){c.appendChild(b);k(m,function(a,b){1===a.nodeType&&(a.style.display=e[b])});a.isPrinting=!1;n&&a.setSize.apply(a,d);C(a,"afterPrint")},1E3)}},contextMenu:function(a,b,e,c,v,m,g){var d=this,n=d.options.navigation,h=d.chartWidth,H=d.chartHeight,p="cache-"+a,l=d[p],w=Math.max(v,m),x,y;l||(d[p]=l=r("div",
{className:a},{position:"absolute",zIndex:1E3,padding:w+"px",pointerEvents:"auto"},d.fixedDiv||d.container),x=r("div",{className:"highcharts-menu"},null,l),u(x,t({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},n.menuStyle)),y=function(){u(l,{display:"none"});g&&g.setState(0);d.openMenu=!1},d.exportEvents.push(q(l,"mouseleave",function(){l.hideTimer=setTimeout(y,500)}),q(l,"mouseenter",function(){f.clearTimeout(l.hideTimer)}),q(z,"mouseup",function(b){d.pointer.inClass(b.target,
a)||y()}),q(l,"click",function(){d.openMenu&&y()})),k(b,function(a){"string"===typeof a&&(a=d.options.exporting.menuItemDefinitions[a]);if(f.isObject(a,!0)){var b;a.separator?b=r("hr",null,null,x):(b=r("div",{className:"highcharts-menu-item",onclick:function(b){b&&b.stopPropagation();y();a.onclick&&a.onclick.apply(d,arguments)},innerHTML:a.text||d.options.lang[a.textKey]},null,x),b.onmouseover=function(){u(this,n.menuItemHoverStyle)},b.onmouseout=function(){u(this,n.menuItemStyle)},u(b,t({cursor:"pointer"},
n.menuItemStyle)));d.exportDivElements.push(b)}}),d.exportDivElements.push(x,l),d.exportMenuWidth=l.offsetWidth,d.exportMenuHeight=l.offsetHeight);b={display:"block"};e+d.exportMenuWidth>h?b.right=h-e-v-w+"px":b.left=e-w+"px";c+m+d.exportMenuHeight>H&&"top"!==g.alignOptions.verticalAlign?b.bottom=H-c-w+"px":b.top=c+m-w+"px";u(l,b);d.openMenu=!0},addButton:function(a){var b=this,e=b.renderer,c=p(b.options.navigation.buttonOptions,a),f=c.onclick,m=c.menuItems,g,d,n=c.symbolSize||12;b.btnCount||(b.btnCount=
0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==c.enabled){var h=c.theme,k=h.states,q=k&&k.hover,k=k&&k.select,l;delete h.states;f?l=function(a){a.stopPropagation();f.call(b,a)}:m&&(l=function(){b.contextMenu(d.menuClassName,m,d.translateX,d.translateY,d.width,d.height,d);d.setState(2)});c.text&&c.symbol?h.paddingLeft=B(h.paddingLeft,25):c.text||t(h,{width:c.width,height:c.height,padding:0});d=e.button(c.text,0,0,l,h,q,k).addClass(a.className).attr({"stroke-linecap":"round",
title:B(b.options.lang[c._titleKey],"")});d.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;c.symbol&&(g=e.symbol(c.symbol,c.symbolX-n/2,c.symbolY-n/2,n,n,{width:n,height:n}).addClass("highcharts-button-symbol").attr({zIndex:1}).add(d),g.attr({stroke:c.symbolStroke,fill:c.symbolFill,"stroke-width":c.symbolStrokeWidth||1}));d.add(b.exportingGroup).align(t(c,{width:d.width,x:B(c.x,b.buttonOffset)}),!0,"spacingBox");b.buttonOffset+=(d.width+c.buttonSpacing)*("right"===c.align?-1:1);b.exportSVGElements.push(d,
g)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var e=b.exportDivElements,c=b.exportEvents,h;a&&(k(a,function(a,c){a&&(a.onclick=a.ontouchstart=null,h="cache-"+a.menuClassName,b[h]&&delete b[h],b.exportSVGElements[c]=a.destroy())}),a.length=0);b.exportingGroup&&(b.exportingGroup.destroy(),delete b.exportingGroup);e&&(k(e,function(a,c){f.clearTimeout(a.hideTimer);I(a,"mouseleave");b.exportDivElements[c]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;D(a)}),e.length=
0);c&&(k(c,function(a){a()}),c.length=0)}});K.menu=function(a,b,e,c){return["M",a,b+2.5,"L",a+e,b+2.5,"M",a,b+c/2+.5,"L",a+e,b+c/2+.5,"M",a,b+c-1.5,"L",a+e,b+c-1.5]};A.prototype.renderExporting=function(){var a=this,b=a.options.exporting,e=b.buttons,c=a.isDirtyExporting||!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();c&&!1!==b.enabled&&(a.exportEvents=[],a.exportingGroup=a.exportingGroup||a.renderer.g("exporting-group").attr({zIndex:3}).add(),F(e,function(b){a.addButton(b)}),
a.isDirtyExporting=!1);q(a,"destroy",a.destroyExport)};q(A,"init",function(){var a=this;k(["exporting","navigation"],function(b){a[b]={update:function(e,c){a.isDirtyExporting=!0;p(!0,a.options[b],e);B(c,!0)&&a.redraw()}}})});A.prototype.callbacks.push(function(a){a.renderExporting();q(a,"redraw",a.renderExporting)})})(h)});


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "trainRecords" } }, [
    _c("div", { attrs: { id: "container" } }),
    _vm._v(" "),
    _c("ul", { staticClass: "records first" }, [
      _c("li", [
        _c("div", { staticClass: "content" }, [
          _c("p", [
            !!_vm.cardStatistics.totalVideoLearnDuration &&
            _vm.cardStatistics.totalVideoLearnDuration / 60 < 1
              ? _c("span", [_vm._v("1")])
              : _c("span", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        !!_vm.cardStatistics.totalVideoLearnDuration
                          ? (
                              _vm.cardStatistics.totalVideoLearnDuration / 60
                            ).toFixed(0)
                          : 0
                      ) +
                      "\n              "
                  )
                ]),
            _vm._v("\n              分钟\n            ")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("课程听取")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "content" }, [
          _c("p", [
            _c("span", [
              _vm._v(
                _vm._s(
                  !!_vm.cardStatistics.totalPracticeCount
                    ? _vm.cardStatistics.totalPracticeCount
                    : 0
                )
              )
            ]),
            _vm._v("次")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("练习次数")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "records" }, [
      _c("li", [
        _c("div", { staticClass: "content" }, [
          _c("p", [
            _c("span", [
              _vm._v(
                _vm._s(
                  !!_vm.cardStatistics.totalExamCount
                    ? _vm.cardStatistics.totalExamCount
                    : 0
                )
              )
            ]),
            _vm._v("次")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("考试次数")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "content" }, [
          _c("p", [
            _c("span", [
              _vm._v(
                _vm._s(
                  !!_vm.cardStatistics.accumulativeLearnDays
                    ? _vm.cardStatistics.accumulativeLearnDays
                    : 0
                )
              )
            ]),
            _vm._v("天")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("学习天数")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-578ee311", esExports)
  }
}

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taojinMethod_vue__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taojinMethod_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taojinMethod_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taojinMethod_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taojinMethod_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_152bf565_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taojinMethod_vue__ = __webpack_require__(1151);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1148)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taojinMethod_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_152bf565_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taojinMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/taojinMethod.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-152bf565", Component.options)
  } else {
    hotAPI.reload("data-v-152bf565", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("aa4b166e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-152bf565\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./taojinMethod.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-152bf565\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./taojinMethod.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.method-container {\n  background: #e7f0f6;\n  padding: 20px;\n  height: 100%;\n  overflow-y: scroll;\n}\n.method-container .left-box {\n  background: #fff;\n  padding: 20px;\n}\n.method-container .left-box li {\n  margin-top: 20px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n}\n.method-container .left-box li.active {\n  color: #4297ff;\n}\n.method-container .left-box .img-box {\n  width: 15.2%;\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n}\n.method-container .left-box .img-box img {\n  max-width: 100%;\n}\n.method-container .right-box {\n  background: #fff;\n  padding: 20px;\n}\n.method-container .title {\n  padding-left: 8px;\n  font-size: 18px;\n  font-weight: bold;\n  border-left: 3px solid #333;\n  color: #333;\n}\n.method-container .el-table td div {\n  white-space: pre-wrap;\n}\n.method-container .el-table .cell img {\n  max-height: 80px !important;\n  width: auto !important;\n  max-width: 95% !important;\n}\n", ""]);

// exports


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_index_remind.9332cb2.png";

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "method-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 4 } }, [
            _c("div", { staticClass: "left-box" }, [
              _c("p", { staticClass: "title" }, [_vm._v("目录")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.menuList, function(item) {
                  return _c(
                    "li",
                    {
                      key: item.manualCategoryId,
                      class: { active: item.checked },
                      on: {
                        click: function($event) {
                          return _vm.getMethodDataByCategory(item)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.manualCategoryName))]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "img-box" }, [
                _c("img", { attrs: { src: _vm.img, alt: "" } })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 20 } }, [
            _c(
              "div",
              { staticClass: "right-box" },
              [
                _c(
                  "el-table",
                  { attrs: { data: _vm.methodData, border: true } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "序号",
                        type: "index",
                        align: "center",
                        width: "100px"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "分类",
                        prop: "rulePunishType",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.rulePunishType == "Warning"
                                ? _c("span", [_vm._v("警告")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.rulePunishType == "ViolationPenalty"
                                ? _c("span", [_vm._v("薪资奖惩")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.rulePunishType == "StopApplication"
                                ? _c("span", [_vm._v("限制领取任务")])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "规则说明",
                        prop: "ruleDescription",
                        align: "left",
                        width: "500"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(scope.row.ruleDescription)
                                }
                              })
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "处理力度",
                        prop: "rulePunishValue",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.rulePunishType == "StopApplication" &&
                              scope.row.rulePunishValue
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row.rulePunishValue) + "天"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.rulePunishType == "ViolationPenalty" &&
                              scope.row.rulePunishValue
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row.rulePunishValue) + "元"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.rulePunishType == "Warning"
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.ruleNoticeMessage))
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "行为处理", prop: "ruleHandle" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-152bf565", esExports)
  }
}

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blacklist_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blacklist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blacklist_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blacklist_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blacklist_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b23d736_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blacklist_vue__ = __webpack_require__(1155);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1153)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b23d736"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blacklist_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b23d736_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blacklist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/blacklist.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b23d736", Component.options)
  } else {
    hotAPI.reload("data-v-6b23d736", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1154);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4cea4859", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6b23d736\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./blacklist.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6b23d736\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./blacklist.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.content-wrap[data-v-6b23d736] {\n  padding: 20px;\n}\n.link-text[data-v-6b23d736] {\n  display: inline-block;\n  margin: 5px;\n  cursor: pointer;\n  color: #4297ff;\n}\n.form-img[data-v-6b23d736] {\n  width: 180px;\n  float: left;\n  margin-right: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap" },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "违规记录ID号" } },
            [
              _c("el-input", {
                attrs: { placeholder: "违规记录ID号", clearable: "" },
                model: {
                  value: _vm.blacklistId,
                  callback: function($$v) {
                    _vm.blacklistId = _vm._n($$v)
                  },
                  expression: "blacklistId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "类型" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.platform,
                    callback: function($$v) {
                      _vm.platform = $$v
                    },
                    expression: "platform"
                  }
                },
                [
                  _c("el-option", {
                    key: "QualityControl",
                    attrs: { label: "质检平台", value: "QualityControl" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Forewarning",
                    attrs: { label: "预警平台", value: "Forewarning" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "CommonRule",
                    attrs: { label: "通用规则", value: "CommonRule" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.compositeState,
                    callback: function($$v) {
                      _vm.compositeState = $$v
                    },
                    expression: "compositeState"
                  }
                },
                [
                  _c("el-option", {
                    key: "Punished",
                    attrs: { label: "已扣罚", value: "Punished" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Appealable",
                    attrs: { label: "有疑议可申诉", value: "Appealable" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Appealing",
                    attrs: { label: "申诉中", value: "Appealing" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "AppealSuccess",
                    attrs: { label: "申诉成功", value: "AppealSuccess" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "AppealFail",
                    attrs: { label: "申诉失败", value: "AppealFail" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("查询")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "blacklistId", label: "违规记录ID", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "compositeStateValue",
              label: "状态",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "日期", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "platformName", label: "类型", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "shopName", label: "关联店铺", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "platformRuleContent",
              label: "违反规章",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "punishContent", label: "处罚内容", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "具体原因", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.platform == "QualityControl" &&
                    scope.row.thirdPlatformId.indexOf("offline_") < 0
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "link-text",
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function($event) {
                                  return _vm.jumpToInfo(scope.row)
                                }
                              }
                            },
                            [_vm._v("查看详情")]
                          )
                        ]
                      : [
                          scope.row.compositeState == "Appealing" ||
                          scope.row.compositeState == "AppealSuccess" ||
                          scope.row.compositeState == "AppealFail"
                            ? _c(
                                "span",
                                {
                                  staticClass: "link-text",
                                  on: {
                                    click: function($event) {
                                      return _vm.showResultModal(
                                        scope.row.blacklistId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("查看详情")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.compositeState == "Appealable" &&
                          "QualityControl" !== scope.row.platform
                            ? _c(
                                "span",
                                {
                                  staticClass: "link-text",
                                  on: {
                                    click: function($event) {
                                      return _vm.showModal(
                                        scope.row.blacklistId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("申诉")]
                              )
                            : _vm._e()
                        ]
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
        on: { getData: _vm.getList }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申诉原因",
            visible: _vm.dialogVisible,
            width: "50%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modal",
              attrs: {
                model: _vm.modal,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "is-required", attrs: { label: "上传图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: "//upload-z0.qiniup.com",
                        "list-type": "picture-card",
                        "on-remove": _vm.handleRemove,
                        data: _vm.token,
                        "before-upload": _vm.getToken,
                        "on-success": _vm.uploadSuccess,
                        "file-list": _vm.fileList
                      }
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "原因", prop: "appealExplain" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      placeholder: "请控制在500个字内",
                      clearable: ""
                    },
                    model: {
                      value: _vm.modal.appealExplain,
                      callback: function($$v) {
                        _vm.$set(_vm.modal, "appealExplain", $$v)
                      },
                      expression: "modal.appealExplain"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addModalFun } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申诉原因",
            visible: _vm.dialogVisibleResult,
            width: "50%",
            "before-close": _vm.handleCloseResult
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleResult = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "图片：" } },
                [
                  _vm._l(_vm.result.appealExtend, function(item, key) {
                    return [
                      _c("img", {
                        staticClass: "form-img",
                        attrs: { src: item }
                      })
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "原因：" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.result.appealExplain) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "结果：" } },
                [
                  _vm.result.handleState == "Appealing"
                    ? [_vm._v("申诉中")]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.handleState == "AppealSuccess"
                    ? [_vm._v("申诉成功")]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.handleState == "AppealUnSuccess"
                    ? [_vm._v("申诉失败")]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.result.handleExplain) +
                    "\n        "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseResult } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b23d736", esExports)
  }
}

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intentRegister_vue__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intentRegister_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intentRegister_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intentRegister_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intentRegister_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65c39f16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intentRegister_vue__ = __webpack_require__(1158);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intentRegister_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65c39f16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intentRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/intentRegister.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65c39f16", Component.options)
  } else {
    hotAPI.reload("data-v-65c39f16", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports = {"provinces":[{"citys":[{"citysName":"东城区"},{"citysName":"西城区"},{"citysName":"崇文区"},{"citysName":"宣武区"},{"citysName":"朝阳区"},{"citysName":"丰台区"},{"citysName":"石景山区"},{"citysName":"海淀区"},{"citysName":"门头沟区"},{"citysName":"房山区"},{"citysName":"通州区"},{"citysName":"顺义区"},{"citysName":"昌平区"},{"citysName":"大兴区"},{"citysName":"怀柔区"},{"citysName":"平谷区"},{"citysName":"密云县"},{"citysName":"延庆县"}],"provinceName":"北京市"},{"citys":[{"citysName":"黄浦区"},{"citysName":"卢湾区"},{"citysName":"徐汇区"},{"citysName":"长宁区"},{"citysName":"静安区"},{"citysName":"普陀区"},{"citysName":"闸北区"},{"citysName":"虹口区"},{"citysName":"杨浦区"},{"citysName":"闵行区"},{"citysName":"宝山区"},{"citysName":"嘉定区"},{"citysName":"浦东新区"},{"citysName":"金山区"},{"citysName":"松江区"},{"citysName":"青浦区"},{"citysName":"南汇区"},{"citysName":"奉贤区"},{"citysName":"崇明县"}],"provinceName":"上海市"},{"citys":[{"citysName":"和平区"},{"citysName":"河东区"},{"citysName":"河西区"},{"citysName":"南开区"},{"citysName":"河北区"},{"citysName":"红桥区"},{"citysName":"塘沽区"},{"citysName":"汉沽区"},{"citysName":"大港区"},{"citysName":"东丽区"},{"citysName":"西青区"},{"citysName":"津南区"},{"citysName":"北辰区"},{"citysName":"武清区"},{"citysName":"宝坻区"},{"citysName":"宁河县"},{"citysName":"静海县"},{"citysName":"蓟　县"}],"provinceName":"天津市"},{"citys":[{"citysName":"万州区"},{"citysName":"涪陵区"},{"citysName":"渝中区"},{"citysName":"大渡口区"},{"citysName":"江北区"},{"citysName":"沙坪坝区"},{"citysName":"九龙坡区"},{"citysName":"南岸区"},{"citysName":"北碚区"},{"citysName":"万盛区"},{"citysName":"双桥区"},{"citysName":"渝北区"},{"citysName":"巴南区"},{"citysName":"黔江区"},{"citysName":"长寿区"}],"provinceName":"重庆市"},{"citys":[{"citysName":"石家庄市"},{"citysName":"邯郸市"},{"citysName":"唐山市"},{"citysName":"保定市"},{"citysName":"秦皇岛市"},{"citysName":"邢台市"},{"citysName":"张家口市"},{"citysName":"承德市"},{"citysName":"沧州市"},{"citysName":"廊坊市"},{"citysName":"衡水市"}],"provinceName":"河北省"},{"citys":[{"citysName":"太原市"},{"citysName":"大同市"},{"citysName":"朔州市"},{"citysName":"阳泉市"},{"citysName":"长治市"},{"citysName":"晋城市"},{"citysName":"忻州市"},{"citysName":"吕梁市"},{"citysName":"晋中市"},{"citysName":"临汾市"},{"citysName":"运城市"}],"provinceName":"山西省"},{"citys":[{"citysName":"呼和浩特市"},{"citysName":"包头市"},{"citysName":"乌海市"},{"citysName":"赤峰市"},{"citysName":"呼伦贝尔市"},{"citysName":"通辽市"},{"citysName":"乌兰察布市"},{"citysName":"鄂尔多斯市"},{"citysName":"巴彦淖尔市"},{"citysName":"兴安盟"},{"citysName":"锡林郭勒盟"},{"citysName":"阿拉善盟"}],"provinceName":"内蒙古自治区"},{"citys":[{"citysName":"沈阳市"},{"citysName":"大连市"},{"citysName":"朝阳市"},{"citysName":"阜新市"},{"citysName":"铁岭市"},{"citysName":"抚顺市"},{"citysName":"本溪市"},{"citysName":"辽阳市"},{"citysName":"鞍山市"},{"citysName":"丹东市"},{"citysName":"营口市"},{"citysName":"盘锦市"},{"citysName":"锦州市"},{"citysName":"葫芦岛市"}],"provinceName":"辽宁省"},{"citys":[{"citysName":"长春市"},{"citysName":"吉林市"},{"citysName":"白城市"},{"citysName":"松原市"},{"citysName":"四平市"},{"citysName":"辽源市"},{"citysName":"通化市"},{"citysName":"白山市"},{"citysName":"延边朝鲜族自治州"}],"provinceName":"吉林省"},{"citys":[{"citysName":"哈尔滨市"},{"citysName":"齐齐哈尔市"},{"citysName":"黑河市"},{"citysName":"大庆市"},{"citysName":"伊春市"},{"citysName":"鹤岗市"},{"citysName":"佳木斯市"},{"citysName":"双鸭山市"},{"citysName":"七台河市"},{"citysName":"鸡西市"},{"citysName":"牡丹江市"},{"citysName":"绥化市"},{"citysName":"大兴安岭地区"}],"provinceName":"黑龙江省"},{"citys":[{"citysName":"南京市"},{"citysName":"徐州市"},{"citysName":"连云港市"},{"citysName":"宿迁市"},{"citysName":"淮安市"},{"citysName":"盐城市"},{"citysName":"扬州市"},{"citysName":"泰州市"},{"citysName":"南通市"},{"citysName":"镇江市"},{"citysName":"常州市"},{"citysName":"无锡市"},{"citysName":"苏州市"}],"provinceName":"江苏省"},{"citys":[{"citysName":"杭州市"},{"citysName":"宁波市"},{"citysName":"湖州市"},{"citysName":"嘉兴市"},{"citysName":"舟山市"},{"citysName":"绍兴市"},{"citysName":"衢州市"},{"citysName":"金华市"},{"citysName":"台州市"},{"citysName":"温州市"},{"citysName":"丽水市"}],"provinceName":"浙江省"},{"citys":[{"citysName":"合肥市"},{"citysName":"芜湖市"},{"citysName":"蚌埠市"},{"citysName":"淮南市"},{"citysName":"马鞍山市"},{"citysName":"淮北市"},{"citysName":"铜陵市"},{"citysName":"安庆市"},{"citysName":"黄山市"},{"citysName":"滁州市"},{"citysName":"阜阳市"},{"citysName":"宿州市"},{"citysName":"六安市"},{"citysName":"亳州市"},{"citysName":"池州市"},{"citysName":"宣城市"},{"citysName":"巢湖市"}],"provinceName":"安徽省"},{"citys":[{"citysName":"厦门市"},{"citysName":"福州市"},{"citysName":"南平市"},{"citysName":"三明市"},{"citysName":"莆田市"},{"citysName":"泉州市"},{"citysName":"漳州市"},{"citysName":"龙岩市"},{"citysName":"宁德市"}],"provinceName":"福建省"},{"citys":[{"citysName":"南昌市"},{"citysName":"九江市"},{"citysName":"景德镇市"},{"citysName":"鹰潭市"},{"citysName":"新余市"},{"citysName":"萍乡市"},{"citysName":"赣州市"},{"citysName":"上饶市"},{"citysName":"抚州市"},{"citysName":"宜春市"},{"citysName":"吉安市"}],"provinceName":"江西省"},{"citys":[{"citysName":"济南市"},{"citysName":"青岛市"},{"citysName":"聊城市"},{"citysName":"德州市"},{"citysName":"东营市"},{"citysName":"淄博市"},{"citysName":"潍坊市"},{"citysName":"烟台市"},{"citysName":"威海市"},{"citysName":"日照市"},{"citysName":"临沂市"},{"citysName":"枣庄市"},{"citysName":"济宁市"},{"citysName":"泰安市"},{"citysName":"莱芜市"},{"citysName":"滨州市"},{"citysName":"菏泽市"}],"provinceName":"山东省"},{"citys":[{"citysName":"郑州市"},{"citysName":"开封市"},{"citysName":"洛阳市"},{"citysName":"平顶山市"},{"citysName":"安阳市"},{"citysName":"鹤壁市"},{"citysName":"新乡市"},{"citysName":"焦作市"},{"citysName":"濮阳市"},{"citysName":"许昌市"},{"citysName":"漯河市"},{"citysName":"三门峡市"},{"citysName":"南阳市"},{"citysName":"商丘市"},{"citysName":"周口市"},{"citysName":"驻马店市"},{"citysName":"信阳市"}],"provinceName":"河南省"},{"citys":[{"citysName":"武汉市"},{"citysName":"十堰市"},{"citysName":"襄阳市"},{"citysName":"荆门市"},{"citysName":"孝感市"},{"citysName":"黄冈市"},{"citysName":"鄂州市"},{"citysName":"黄石市"},{"citysName":"咸宁市"},{"citysName":"荆州市"},{"citysName":"宜昌市"},{"citysName":"随州市"},{"citysName":"恩施土家族苗族自治州"}],"provinceName":"湖北省"},{"citys":[{"citysName":"长沙市"},{"citysName":"衡阳市"},{"citysName":"张家界市"},{"citysName":"常德市"},{"citysName":"益阳市"},{"citysName":"岳阳市"},{"citysName":"株洲市"},{"citysName":"湘潭市"},{"citysName":"郴州市"},{"citysName":"永州市"},{"citysName":"邵阳市"},{"citysName":"怀化市"},{"citysName":"娄底市"},{"citysName":"湘西土家族苗族自治州"}],"provinceName":"湖南省"},{"citys":[{"citysName":"广州市"},{"citysName":"深圳市"},{"citysName":"清远市"},{"citysName":"韶关市"},{"citysName":"河源市"},{"citysName":"梅州市"},{"citysName":"潮州市"},{"citysName":"汕头市"},{"citysName":"揭阳市"},{"citysName":"汕尾市"},{"citysName":"惠州市"},{"citysName":"东莞市"},{"citysName":"珠海市"},{"citysName":"中山市"},{"citysName":"江门市"},{"citysName":"佛山市"},{"citysName":"肇庆市"},{"citysName":"云浮市"},{"citysName":"阳江市"},{"citysName":"茂名市"},{"citysName":"湛江市"}],"provinceName":"广东省"},{"citys":[{"citysName":"南宁市"},{"citysName":"桂林市"},{"citysName":"柳州市"},{"citysName":"梧州市"},{"citysName":"贵港市"},{"citysName":"玉林市"},{"citysName":"钦州市"},{"citysName":"北海市"},{"citysName":"防城港市"},{"citysName":"崇左市"},{"citysName":"百色市"},{"citysName":"河池市"},{"citysName":"来宾市"},{"citysName":"贺州市"}],"provinceName":"广西壮族自治区"},{"citys":[{"citysName":"海口市"},{"citysName":"三亚市"}],"provinceName":"海南省"},{"citys":[{"citysName":"成都市"},{"citysName":"广元市"},{"citysName":"绵阳市"},{"citysName":"德阳市"},{"citysName":"南充市"},{"citysName":"广安市"},{"citysName":"遂宁市"},{"citysName":"内江市"},{"citysName":"乐山市"},{"citysName":"自贡市"},{"citysName":"泸州市"},{"citysName":"宜宾市"},{"citysName":"攀枝花市"},{"citysName":"巴中市"},{"citysName":"达州市"},{"citysName":"资阳市"},{"citysName":"眉山市"},{"citysName":"雅安市"},{"citysName":"凉山彝族自治州"},{"citysName":"阿坝藏族羌族自治州"},{"citysName":"凉山彝族自治州"}],"provinceName":"四川省"},{"citys":[{"citysName":"贵阳市"},{"citysName":"六盘水市"},{"citysName":"遵义市"},{"citysName":"安顺市"},{"citysName":"毕节市"},{"citysName":"铜仁市"},{"citysName":"黔西南布依族苗族自治州"},{"citysName":"黔东南苗族侗族自治州"},{"citysName":"黔南布依族苗族自治州"}],"provinceName":"贵州省"},{"citys":[{"citysName":"昆明市"},{"citysName":"曲靖市"},{"citysName":"玉溪市"},{"citysName":"丽江市"},{"citysName":"昭通市"},{"citysName":"思茅市"},{"citysName":"临沧市"},{"citysName":"保山市"},{"citysName":"楚雄彝族自治州"},{"citysName":"红河哈尼族彝族自治州"},{"citysName":"文山壮族苗族自治州"},{"citysName":"西双版纳傣族自治州"},{"citysName":"大理白族自治州"},{"citysName":"德宏傣族景颇族自治州"},{"citysName":"怒江傈僳族自治州"},{"citysName":"迪庆藏族自治州"}],"provinceName":"云南省"},{"citys":[{"citysName":"西安市"},{"citysName":"延安市"},{"citysName":"铜川市"},{"citysName":"渭南市"},{"citysName":"咸阳市"},{"citysName":"宝鸡市"},{"citysName":"汉中市"},{"citysName":"榆林市"},{"citysName":"商洛市"},{"citysName":"安康市"}],"provinceName":"陕西省"},{"citys":[{"citysName":"兰州市"},{"citysName":"嘉峪关市"},{"citysName":"金昌市"},{"citysName":"白银市"},{"citysName":"天水市"},{"citysName":"酒泉市"},{"citysName":"张掖市"},{"citysName":"武威市"},{"citysName":"庆阳市"},{"citysName":"平凉市"},{"citysName":"定西市"},{"citysName":"陇南市"},{"citysName":"临夏回族自治州"},{"citysName":"甘南藏族自治州"}],"provinceName":"甘肃省"},{"citys":[{"citysName":"西宁市"},{"citysName":"海东地区"},{"citysName":"海北藏族自治州"},{"citysName":"黄南藏族自治州"},{"citysName":"海南藏族自治州"},{"citysName":"果洛藏族自治州"},{"citysName":"玉树藏族自治州"},{"citysName":"海西蒙古族藏族自治州"}],"provinceName":"青海省"},{"citys":[{"citysName":"拉萨市"},{"citysName":"日喀则地区"},{"citysName":"昌都地区"},{"citysName":"那曲地区"},{"citysName":"山南地区"},{"citysName":"阿里地区"},{"citysName":"林芝地区"}],"provinceName":"西藏自治区"},{"citys":[{"citysName":"银川市"},{"citysName":"石嘴山市"},{"citysName":"吴忠市"},{"citysName":"中卫市"},{"citysName":"固原市"}],"provinceName":"宁夏回族自治区"},{"citys":[{"citysName":"乌鲁木齐市"},{"citysName":"克拉玛依市"},{"citysName":"吐鲁番市"},{"citysName":"哈密市"},{"citysName":"昌吉回族自治州"},{"citysName":"博尔塔拉蒙古自治州"},{"citysName":"巴音郭楞蒙古自治州"},{"citysName":"阿克苏地区"},{"citysName":"克孜勒苏柯尔克孜自治州"},{"citysName":"喀什地区"},{"citysName":"和田地区"},{"citysName":"伊犁哈萨克自治州"},{"citysName":"塔城地区"},{"citysName":"阿勒泰地区"}],"provinceName":"新疆维吾尔自治区"},{"citys":[{"citysName":"台北市"},{"citysName":"新北市"},{"citysName":"桃园市"},{"citysName":"台中市"},{"citysName":"台南市"},{"citysName":"高雄市"},{"citysName":"基隆市"},{"citysName":"新竹市"},{"citysName":"嘉义市"}],"provinceName":"台湾"},{"citys":[{"citysName":"香港特别行政区"}],"provinceName":"香港"},{"citys":[{"citysName":"澳门特别行政区"}],"provinceName":"澳门"}]}

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intentRegister" },
    [
      _c("img", {
        staticClass: "banner",
        attrs: { src: "/tjkStudy/static/yxdj.png" }
      }),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "intent-content",
          attrs: { model: _vm.form }
        },
        [
          _vm._l(_vm.voList, function(item, key) {
            return [
              _vm.voList.length > 0
                ? _c(
                    "el-form-item",
                    {
                      class: { "is-required": item.requiredStatus == "YES" },
                      attrs: { label: key + 1 + "、" + item.question }
                    },
                    [
                      item.questionType == "TEXT"
                        ? [
                            _c("el-input", {
                              model: {
                                value: _vm.form.answerList[item.questionId],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.answerList,
                                    item.questionId,
                                    $$v
                                  )
                                },
                                expression: "form.answerList[item.questionId]"
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "MULTIPLE_TEXT"
                        ? [
                            _c("el-input", {
                              attrs: { type: "textarea", autosize: "" },
                              model: {
                                value: _vm.form.answerList[item.questionId],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.answerList,
                                    item.questionId,
                                    $$v
                                  )
                                },
                                expression: "form.answerList[item.questionId]"
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "SINGLE_CHOICE"
                        ? [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.answerList[item.questionId],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.answerList,
                                      item.questionId,
                                      $$v
                                    )
                                  },
                                  expression: "form.answerList[item.questionId]"
                                }
                              },
                              [
                                _vm._l(item.choiceList, function(s) {
                                  return [
                                    _c("el-radio", {
                                      attrs: { label: s.choiceContent }
                                    })
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "MULTIPLE_CHOICE"
                        ? [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.form.answerList[item.questionId],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.answerList,
                                      item.questionId,
                                      $$v
                                    )
                                  },
                                  expression: "form.answerList[item.questionId]"
                                }
                              },
                              [
                                _vm._l(item.choiceList, function(m) {
                                  return [
                                    _c("el-checkbox", {
                                      attrs: { label: m.choiceContent }
                                    })
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "BLANK_CHOICE"
                        ? [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "170px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择省份"
                                },
                                on: { change: _vm.queryCitysFun },
                                model: {
                                  value: _vm.province,
                                  callback: function($$v) {
                                    _vm.province = $$v
                                  },
                                  expression: "province"
                                }
                              },
                              _vm._l(_vm.provinceList, function(item, key) {
                                return _c("el-option", {
                                  key: key,
                                  attrs: {
                                    label: item.provinceName,
                                    value: item.provinceName
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "170px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择地市"
                                },
                                model: {
                                  value: _vm.city,
                                  callback: function($$v) {
                                    _vm.city = $$v
                                  },
                                  expression: "city"
                                }
                              },
                              _vm._l(_vm.citysList, function(item, key) {
                                return _c("el-option", {
                                  key: key,
                                  attrs: {
                                    label: item.citysName,
                                    value: item.citysName
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "IMAGE"
                        ? [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "//upload-z0.qiniup.com",
                                  "list-type": "picture-card",
                                  "on-preview": _vm.handlePictureCardPreview,
                                  "on-remove": _vm.handleRemove,
                                  data: _vm.token,
                                  "before-upload": _vm.getToken,
                                  "on-success": _vm.uploadSuccess,
                                  "file-list": _vm.fileList,
                                  limit: item.wordLimit
                                }
                              },
                              [_c("i", { staticClass: "el-icon-plus" })]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "btn" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitInfo } },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [_c("img", { attrs: { width: "100%", src: _vm.dialogImageUrl } })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c39f16", esExports)
  }
}

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupTrain_vue__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupTrain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupTrain_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupTrain_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupTrain_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5db110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_groupTrain_vue__ = __webpack_require__(1162);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1160)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a5db110"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupTrain_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5db110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_groupTrain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/groupTrain.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a5db110", Component.options)
  } else {
    hotAPI.reload("data-v-7a5db110", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1161);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("789f7102", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7a5db110\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./groupTrain.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7a5db110\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./groupTrain.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.nuv[data-v-7a5db110] {\n  font-size: 16px;\n}\n.top-button[data-v-7a5db110] {\n  margin: 10px 15px 20px 0;\n  display: inline-block;\n}\n.tab > li[data-v-7a5db110] {\n  float: left;\n  padding: 10px;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  border: 1px solid #dfdfdf;\n  margin-right: 10px;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n}\n.tab > li.active[data-v-7a5db110] {\n  background-color: #ecf5ff;\n  border: 1px solid #b3d8ff;\n  color: #ffffff;\n  cursor: pointer;\n}\n.tab > li.active[data-v-7a5db110]:hover {\n  background-color: #409EFF;\n}\n.tab > li.active:hover > a[data-v-7a5db110] {\n  color: #ffffff;\n}\n.tip-box[data-v-7a5db110] {\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #80a9f5;\n  text-align: center;\n  margin-right: 20px;\n}\n.tip-con[data-v-7a5db110] {\n  font-size: 14px;\n  line-height: 24px;\n}\n[data-v-7a5db110] .el-table .el-table__cell {\n    padding: 2px;\n    font-size:12px;\n}\n[data-v-7a5db110] .el-table .el-table__cell input {\n    height: 30px;\n}\n.el-button[data-v-7a5db110]{\n    padding: 10px 20px;\n    font-size:12px;\n}\n", ""]);

// exports


/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("群培训管理 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "top-button", attrs: { href: "javascript:;" } },
        [
          _c("el-button", { attrs: { type: "primary" } }, [
            _vm._v("群考核名单")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("el-tooltip", { attrs: { placement: "right", effect: "light" } }, [
        _c(
          "div",
          {
            staticClass: "tip-con",
            attrs: { slot: "content" },
            slot: "content"
          },
          [_c("p", [_vm._v("1、群考核名单是指没有通过岗前培训的名单")])]
        ),
        _vm._v(" "),
        _c("a", { staticClass: "tip-box" }, [_vm._v("？")])
      ]),
      _vm._v(" "),
      _c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { "margin-left": "10px" },
          attrs: { type: "danger" },
          on: {
            click: function($event) {
              return _vm.getList("tjk")
            }
          }
        },
        [_vm._v("查询淘金客")]
      ),
      _vm._v(" "),
      _c("el-input", {
        staticStyle: {
          width: "400px",
          "margin-left": "10px",
          "margin-bottom": "5px"
        },
        attrs: {
          type: "textarea",
          placeholder: "输入淘金号，用英文逗号隔开，例如940732001,949329488",
          autosize: { minRows: 2, maxRows: 3 }
        },
        model: {
          value: _vm.tjkNumbers,
          callback: function($$v) {
            _vm.tjkNumbers = $$v
          },
          expression: "tjkNumbers"
        }
      }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { "margin-left": "10px" },
          attrs: { type: "danger" },
          on: {
            click: function($event) {
              return _vm.getList("tjkNumbers")
            }
          }
        },
        [_vm._v("批量查询")]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "tab" },
        _vm._l(_vm.examiningList, function(t, key) {
          return _c(
            "li",
            { class: { active: t.isCurrent } },
            [
              t.isCurrent
                ? [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/tjkStudy/voiceExam?id=" +
                            t.examineRecordId +
                            "&groupId=" +
                            _vm.groupId +
                            "&groupName=" +
                            _vm.groupName,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(t.codeName) +
                            "  剩余考核人：" +
                            _vm._s(t.waitNum)
                        )
                      ]
                    )
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(t.codeName) +
                        "  剩余考核人：" +
                        _vm._s(t.waitNum) +
                        "\n      "
                    )
                  ]
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c(
                  "p",
                  {
                    staticClass: "tj-shift-notice",
                    staticStyle: { "padding-top": "45px" }
                  },
                  [_vm._v("暂无记录！")]
                )
              : [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        data: _vm.list,
                        height:
                          _vm.type == "Voice"
                            ? _vm.tableHeight
                            : _vm.onlineTableHeight,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", align: "center" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: scope.row.passState,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "passState", $$v)
                                      },
                                      expression: "scope.row.passState"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      key: "Passed",
                                      attrs: { label: "通过", value: "Passed" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Failed",
                                      attrs: {
                                        label: "未通过",
                                        value: "Failed"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Abandoned",
                                      attrs: {
                                        label: "标记不参培",
                                        value: "Abandoned"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Retrial",
                                      attrs: {
                                        label: "建议复训",
                                        value: "Retrial"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "AbandonInTrain",
                                      attrs: {
                                        label: "培训老师同意放弃",
                                        value: "AbandonInTrain"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "score",
                          label: "综合得分",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "只能填写数字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.score,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "score", $$v)
                                    },
                                    expression: "scope.row.score"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "remark",
                          label: "备注",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: "",
                                    placeholder: "不能超过200字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.remark,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "remark", $$v)
                                    },
                                    expression: "scope.row.remark"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tj-margin-top-xl" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: {
                            click: function($event) {
                              return _vm.toggleSelection("Passed")
                            }
                          }
                        },
                        [_vm._v("标记通过")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "info" },
                          on: {
                            click: function($event) {
                              return _vm.toggleSelection("Failed")
                            }
                          }
                        },
                        [_vm._v("标记不通过")]
                      ),
                      _vm._v(" "),
                      _vm.type == "Voice"
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "warning" },
                                on: { click: _vm.checkGroup }
                              },
                              [_vm._v("群考核")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == "Online"
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.saveOnline }
                              },
                              [_vm._v("保存打分")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == "Voice"
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.saveVoice }
                              },
                              [_vm._v("保存打分")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.releaseGroup }
                        },
                        [_vm._v("发布成绩")]
                      )
                    ],
                    2
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "check" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.callOutPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "callOutPhone", $$v)
                    },
                    expression: "check.callOutPhone"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 平均外呼时长（分钟）：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.avgDuration,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "avgDuration", $$v)
                    },
                    expression: "check.avgDuration"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 考核代号：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.codeName,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "codeName", $$v)
                    },
                    expression: "check.codeName"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "release" }, [
        _c(
          "div",
          {
            staticClass: "tj-table tj-fill tj-padding-right-xl",
            staticStyle: { "border-bottom": "1px solid #f2f2f2" }
          },
          [
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 考核通过流转群：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.release.shopGroupId,
                        callback: function($$v) {
                          _vm.$set(_vm.release, "shopGroupId", $$v)
                        },
                        expression: "release.shopGroupId"
                      }
                    },
                    _vm._l(_vm.shopGroupList, function(g, key) {
                      return _c("el-option", {
                        key: g.groupId,
                        attrs: { label: g.name, value: g.groupId }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 考核未通过学员：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.release.failedState,
                        callback: function($$v) {
                          _vm.$set(_vm.release, "failedState", $$v)
                        },
                        expression: "release.failedState"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "Kicked",
                        attrs: { label: "踢出本群", value: "Kicked" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 放弃和培训中放弃的学员：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.release.abandonState,
                        callback: function($$v) {
                          _vm.$set(_vm.release, "abandonState", $$v)
                        },
                        expression: "release.abandonState"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "Kicked",
                        attrs: { label: "踢出本群", value: "Kicked" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 通过发送的消息：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "恭喜你通过了本次考核。"
                    },
                    model: {
                      value: _vm.release.passedMsg,
                      callback: function($$v) {
                        _vm.$set(_vm.release, "passedMsg", $$v)
                      },
                      expression: "release.passedMsg"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 留在本群发送的消息：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "考核成绩已发布。"
                    },
                    model: {
                      value: _vm.release.stayMsg,
                      callback: function($$v) {
                        _vm.$set(_vm.release, "stayMsg", $$v)
                      },
                      expression: "release.stayMsg"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("dl", [
              _c(
                "dt",
                {
                  staticClass: "tj-text-right",
                  staticStyle: { width: "200px" }
                },
                [
                  _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(" 踢出本群发送的消息：")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "dd",
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "考核成绩已发布，很遗憾你没有通过本次考核。"
                    },
                    model: {
                      value: _vm.release.kickMsg,
                      callback: function($$v) {
                        _vm.$set(_vm.release, "kickMsg", $$v)
                      },
                      expression: "release.kickMsg"
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a5db110", esExports)
  }
}

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWork_vue__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWork_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWork_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWork_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWork_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f869bd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_waitWork_vue__ = __webpack_require__(1166);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1164)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f869bd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWork_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f869bd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_waitWork_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/waitWork.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f869bd6", Component.options)
  } else {
    hotAPI.reload("data-v-4f869bd6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1165);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1f434016", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f869bd6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./waitWork.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f869bd6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./waitWork.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.nuv[data-v-4f869bd6] {\n  font-size: 16px;\n}\n.top-button[data-v-4f869bd6] {\n  margin: 10px 15px 20px 0;\n  display: inline-block;\n}\n.tip-box[data-v-4f869bd6] {\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #80a9f5;\n  text-align: center;\n  margin-right: 20px;\n}\n.tip-con[data-v-4f869bd6] {\n  font-size: 14px;\n  line-height: 24px;\n}\n.tab > li[data-v-4f869bd6] {\n  float: left;\n  padding: 10px;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  border: 1px solid #dfdfdf;\n  margin-right: 10px;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n}\n.tab > li.active[data-v-4f869bd6] {\n  background-color: #ecf5ff;\n  border: 1px solid #b3d8ff;\n  color: #ffffff;\n  cursor: pointer;\n}\n.tab > li.active[data-v-4f869bd6]:hover {\n  background-color: #409EFF;\n}\n.tab > li.active:hover > a[data-v-4f869bd6] {\n  color: #ffffff;\n}\n", ""]);

// exports


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("群培训管理 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "a",
            {
              staticClass: "top-button",
              attrs: {
                href:
                  "/tjkStudy/groupTrain?groupId=" +
                  _vm.groupId +
                  "&groupName=" +
                  _vm.groupName
              }
            },
            [
              _c("el-button", { attrs: { type: "primary", plain: "" } }, [
                _vm._v("群考核名单")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "top-button", attrs: { href: "javascript:;" } },
            [
              _c("el-button", { attrs: { type: "primary" } }, [
                _vm._v("群待岗学员")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "right", effect: "light" } }, [
            _c(
              "div",
              {
                staticClass: "tip-con",
                attrs: { slot: "content" },
                slot: "content"
              },
              [
                _c("p", [
                  _vm._v("群待岗学员发起群考核时，默认全部学员发起考核")
                ])
              ]
            ),
            _vm._v(" "),
            _c("a", { staticClass: "tip-box" }, [_vm._v("？")])
          ])
        ],
        1
      ),
      _vm._v(" "),
      !!_vm.examiningList
        ? _c(
            "ul",
            { staticClass: "tab" },
            _vm._l(_vm.examiningList, function(t, key) {
              return _c("li", { staticClass: "active" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "/tjkStudy/waitWorkExam?id=" +
                        t.examineRecordId +
                        "&groupId=" +
                        _vm.groupId +
                        "&groupName=" +
                        _vm.groupName,
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(t.codeName))]
                )
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        data: _vm.list,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", { attrs: { type: "selection" } }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "realName", label: "考核人员" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "tjkNumber", label: "淘金号" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.passState == "Passed"
                                  ? [_vm._v("通过")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Failed"
                                  ? [_vm._v("未通过")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Abandoned"
                                  ? [_vm._v("标记不参培")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Retrial"
                                  ? [_vm._v("建议复训")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "AbandonInTrain"
                                  ? [_vm._v("培训老师同意放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "score", label: "综合得分" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "remark", label: "备注" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tj-margin-top-xl tj-margin-bottom-xl" },
                    [
                      _c("el-button", { on: { click: _vm.toggleSelection } }, [
                        _vm._v("移除待岗学员名单")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.checkGroup }
                        },
                        [_vm._v("群考核")]
                      )
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "check" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.callOutPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "callOutPhone", $$v)
                    },
                    expression: "check.callOutPhone"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 平均外呼时长（分钟）：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.avgDuration,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "avgDuration", $$v)
                    },
                    expression: "check.avgDuration"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 考核代号：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.codeName,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "codeName", $$v)
                    },
                    expression: "check.codeName"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f869bd6", esExports)
  }
}

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97b46ddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voiceExam_vue__ = __webpack_require__(1170);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1168)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97b46ddc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97b46ddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voiceExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/voiceExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-97b46ddc", Component.options)
  } else {
    hotAPI.reload("data-v-97b46ddc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1169);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1892d691", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-97b46ddc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voiceExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-97b46ddc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voiceExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.nuv[data-v-97b46ddc] {\n  font-size: 16px;\n}\n.current[data-v-97b46ddc], .next[data-v-97b46ddc] {\n  border: 1px solid #dfdfdf;\n  background-color: #ffffff;\n}\n.current .tab[data-v-97b46ddc], .next .tab[data-v-97b46ddc] {\n  border-bottom: 1px solid #dfdfdf;\n  padding: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.next .tab[data-v-97b46ddc] {\n  border-bottom: none;\n}\n.current .content[data-v-97b46ddc] {\n  padding: 10px;\n}\ntable > tr > th[data-v-97b46ddc], table > tr > td[data-v-97b46ddc] {\n  padding: 5px;\n}\n.content .button[data-v-97b46ddc] {\n  margin: 0px 5px 10px 5px;\n}\n.next[data-v-97b46ddc] {\n  margin: 20px 0;\n}\n.end[data-v-97b46ddc] {\n  margin-bottom: 20px;\n  margin-top: 10px;\n}\n.end > span[data-v-97b46ddc] {\n  padding: 0 20px;\n  font-size: 18px;\n}\n.gotoindex[data-v-97b46ddc] {\n  margin: 20px 0;\n}\n.nopeople[data-v-97b46ddc] {\n  padding: 10px 0 20px;\n}\n", ""]);

// exports


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c(
          "a",
          {
            staticClass: "active",
            attrs: {
              href:
                "/tjkStudy/groupTrain?groupId=" +
                _vm.groupId +
                "&groupName=" +
                _vm.groupName,
              target: "_blank"
            }
          },
          [_vm._v("群培训管理")]
        ),
        _vm._v(">\n    "),
        _c("span", [_vm._v("语音考核")]),
        _vm._v(">\n    "),
        _c("span", [_vm._v(_vm._s(_vm.codeName))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "end" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.endExam()
                }
              }
            },
            [_vm._v("结束考核")]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("剩余" + _vm._s(_vm.waitNum) + "人待考核")]),
          _vm._v(" "),
          _c("span", [_vm._v("当前拨打电话：" + _vm._s(_vm.callOutPhone))]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.changePhone } },
            [_vm._v("修改电话号码")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.status
        ? [
            _c("p", { staticClass: "nopeople" }, [
              _vm._v("名单中全部人员考核结束")
            ])
          ]
        : [
            _c("div", { staticClass: "current" }, [
              _c(
                "div",
                { staticClass: "tab" },
                [
                  _c("span", [_vm._v("当前考核人员：")]),
                  _vm._v(" "),
                  !!_vm.userList.current
                    ? [
                        _c("span", [
                          _vm._v(
                            "【" + _vm._s(_vm.userList.current.realName) + "】"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm.userList.current.userState == "Calling"
                              ? [_vm._v("正在外呼")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Confirmed"
                              ? [_vm._v("已确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Unconfirmed"
                              ? [_vm._v("未确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Call"
                              ? [_vm._v("通话中")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Callend"
                              ? [_vm._v("通话结束")]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("table", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: { placeholder: "只能填写数字", clearable: "" },
                          model: {
                            value: _vm.score,
                            callback: function($$v) {
                              _vm.score = _vm._n($$v)
                            },
                            expression: "score"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: "",
                            placeholder: "不能超过200字",
                            clearable: ""
                          },
                          model: {
                            value: _vm.remark,
                            callback: function($$v) {
                              _vm.remark = $$v
                            },
                            expression: "remark"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "button" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Passed")
                          }
                        }
                      },
                      [_vm._v("通过考核并下一位")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "info" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Failed")
                          }
                        }
                      },
                      [_vm._v("不通过考核并下一位")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Retrial")
                          }
                        }
                      },
                      [_vm._v("建议复训并下一位")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Abandoned")
                          }
                        }
                      },
                      [_vm._v("学员放弃")]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "next" }, [
              _c(
                "div",
                { staticClass: "tab" },
                [
                  _c("span", [_vm._v("接下来考核人员：")]),
                  _vm._v(" "),
                  !!_vm.userList.next
                    ? [
                        _c("span", [
                          _vm._v(
                            "【" + _vm._s(_vm.userList.next.realName) + "】"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm.userList.next.userState == "Calling"
                              ? [_vm._v("正在外呼")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Confirmed"
                              ? [_vm._v("已确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Unconfirmed"
                              ? [_vm._v("未确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Call"
                              ? [_vm._v("通话中")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Callend"
                              ? [_vm._v("通话结束")]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    : [_vm._v("暂无")]
                ],
                2
              )
            ])
          ],
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c("h3", [_vm._v("考核名单")]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.list, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "examineSeq",
                          label: "顺序",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.examineState == "Examining"
                                  ? [_vm._v("正在考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Examined"
                                  ? [_vm._v("已考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Wait"
                                  ? [_vm._v("待考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Abandon"
                                  ? [_vm._v("学员放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "startTime", label: "考核开始时间" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "duration", label: "考核时长" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.formatTime(scope.row.duration)) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.passState == "Passed"
                                  ? [_vm._v("是")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Failed"
                                  ? [_vm._v("否")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Abandoned"
                                  ? [_vm._v("学员放弃")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Retrial"
                                  ? [_vm._v("建议复训")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "AbandonInTrain"
                                  ? [_vm._v("培训老师同意放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "change" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.change.callOutPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.change, "callOutPhone", $$v)
                    },
                    expression: "change.callOutPhone"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("综合得分")]),
      _vm._v(" "),
      _c("th", [_vm._v("备注")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97b46ddc", esExports)
  }
}

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExam_vue__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010f83d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tjkExam_vue__ = __webpack_require__(1174);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1172)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-010f83d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_010f83d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tjkExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/tjkExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-010f83d5", Component.options)
  } else {
    hotAPI.reload("data-v-010f83d5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4825c4ea", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-010f83d5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tjkExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-010f83d5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tjkExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.tips[data-v-010f83d5] {\n  background-color: #3b3b62;\n  text-align: center;\n  font-size: 18px;\n  color: #ffffff;\n  margin-bottom: 20px;\n}\n.tips p[data-v-010f83d5] {\n  padding: 5px 0;\n}\n", ""]);

// exports


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.eventName == null
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [_vm._v("目前考核不存在或考核已经结束。")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "Wait"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [
              _vm._v("考核前请确认耳机耳麦都准备好，小助手已调试正确。")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "待你考核前方还有" +
                  _vm._s(_vm.people) +
                  "位小伙伴，预计" +
                  _vm._s(_vm.time) +
                  "分钟。"
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "Confirm"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [
              _vm._v("考核前请确认耳机耳麦都准备好，小助手已调试正确。")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("下一位就是你考核，是否确认？")]),
            _vm._v(" "),
            _c(
              "p",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function($event) {
                        return _vm.confirmExam()
                      }
                    }
                  },
                  [_vm._v("确认考核")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [_vm._v("如果不及时确认考核，将视为你放弃本次机会")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "WaitCall"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [
              _vm._v("考核前请确认耳机耳麦都准备好，小助手已调试正确。")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("已确认考核，请等待屏幕出现外呼按钮时，进行外呼")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "StartCall"
        ? _c(
            "div",
            { staticClass: "tips" },
            [
              _vm.isWait
                ? [
                    _c("p", [
                      _vm._v("不要紧张，记得你平时所学习和保持和练习的一样。")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "正在等待接通：" +
                          _vm._s(_vm.currCallTimeForSecond) +
                          "秒"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.endCall()
                              }
                            }
                          },
                          [_vm._v("挂断")]
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _c("p", [
                      _vm._v("考核前请确认耳机耳麦都准备好，小助手已调试正确。")
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核中，请外呼电话")]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.callClick()
                              }
                            }
                          },
                          [_vm._v("外呼")]
                        )
                      ],
                      1
                    )
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "Call"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [_vm._v("不要紧张，记得你平时所学习和保持和练习的一样。")]),
            _vm._v(" "),
            _c("p", [_vm._v("电话已接通，请不要刷新和关闭当前考核页面！")]),
            _vm._v(" "),
            _c("p", [_vm._v("通话时长：" + _vm._s(_vm.currCallingTimeForStr))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "CallEnd"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [
              _vm._v(
                "考核完毕，请等待老师发布成绩，成绩将已通知的形式发送到你的APP！"
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.eventName == "Abandon"
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [_vm._v("非常遗憾，你被视为放弃考核，请下次认真对待。")])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            _c("h3", [_vm._v("考核名单")]),
            _vm._v(" "),
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.list,
                        border: "",
                        "row-class-name": _vm.tableRowClassName
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "examineSeq",
                          label: "顺序",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.examineState == "Examining"
                                  ? [_vm._v("正在考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Examined"
                                  ? [_vm._v("已考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Wait"
                                  ? [_vm._v("待考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Abandon"
                                  ? [_vm._v("学员放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "startTime", label: "考核开始时间" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "duration", label: "考核时长" }
                      })
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nuv" }, [
      _c("a", { staticClass: "active", attrs: { href: "#" } }, [
        _vm._v("语音考核")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-010f83d5", esExports)
  }
}

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWorkExam_vue__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWorkExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWorkExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWorkExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWorkExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75acbf58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_waitWorkExam_vue__ = __webpack_require__(1178);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1176)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75acbf58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_waitWorkExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75acbf58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_waitWorkExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/waitWorkExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75acbf58", Component.options)
  } else {
    hotAPI.reload("data-v-75acbf58", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1177);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6c0476d2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-75acbf58\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./waitWorkExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-75acbf58\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./waitWorkExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.nuv[data-v-75acbf58] {\n  font-size: 16px;\n}\n.current[data-v-75acbf58], .next[data-v-75acbf58] {\n  border: 1px solid #dfdfdf;\n  background-color: #ffffff;\n}\n.current .tab[data-v-75acbf58], .next .tab[data-v-75acbf58] {\n  border-bottom: 1px solid #dfdfdf;\n  padding: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.next .tab[data-v-75acbf58] {\n  border-bottom: none;\n}\n.current .content[data-v-75acbf58] {\n  padding: 10px;\n}\ntable > tr > th[data-v-75acbf58], table > tr > td[data-v-75acbf58] {\n  padding: 5px;\n}\n.content .button[data-v-75acbf58] {\n  margin: 0px 5px 10px 5px;\n}\n.next[data-v-75acbf58] {\n  margin: 20px 0;\n}\n.end[data-v-75acbf58] {\n  margin-bottom: 20px;\n  margin-top: 10px;\n}\n.end > span[data-v-75acbf58] {\n  padding: 0 20px;\n  font-size: 18px;\n}\n.gotoindex[data-v-75acbf58] {\n  margin: 20px 0;\n}\n.nopeople[data-v-75acbf58] {\n  padding: 10px 0 20px;\n}\n", ""]);

// exports


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c(
          "a",
          {
            staticClass: "active",
            attrs: {
              href:
                "/tjkStudy/waitWork?groupId=" +
                _vm.groupId +
                "&groupName=" +
                _vm.groupName,
              target: "_blank"
            }
          },
          [_vm._v("群待岗学员")]
        ),
        _vm._v(">\n    "),
        _c("span", [_vm._v("群待岗学员群考核")]),
        _vm._v(">\n    "),
        _c("span", [_vm._v(_vm._s(_vm.codeName))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "end" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.endExam()
                }
              }
            },
            [_vm._v("结束考核")]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("剩余" + _vm._s(_vm.waitNum) + "人待考核")]),
          _vm._v(" "),
          _c("span", [_vm._v("当前拨打电话：" + _vm._s(_vm.callOutPhone))]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.changePhone } },
            [_vm._v("修改电话号码")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.status
        ? [
            _c("p", { staticClass: "nopeople" }, [
              _vm._v("名单中全部人员考核结束")
            ])
          ]
        : [
            _c("div", { staticClass: "current" }, [
              _c(
                "div",
                { staticClass: "tab" },
                [
                  _c("span", [_vm._v("当前考核人员：")]),
                  _vm._v(" "),
                  !!_vm.userList.current
                    ? [
                        _c("span", [
                          _vm._v(
                            "【" + _vm._s(_vm.userList.current.realName) + "】"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm.userList.current.userState == "Calling"
                              ? [_vm._v("正在外呼")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Confirmed"
                              ? [_vm._v("已确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Unconfirmed"
                              ? [_vm._v("未确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Call"
                              ? [_vm._v("通话中")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Callend"
                              ? [_vm._v("通话结束")]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "p",
                  { staticClass: "button" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Passed")
                          }
                        }
                      },
                      [_vm._v("录取")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "info" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Failed")
                          }
                        }
                      },
                      [_vm._v("不录取")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Pending")
                          }
                        }
                      },
                      [_vm._v("待定")]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "next" }, [
              _c(
                "div",
                { staticClass: "tab" },
                [
                  _c("span", [_vm._v("接下来考核人员：")]),
                  _vm._v(" "),
                  !!_vm.userList.next
                    ? [
                        _c("span", [
                          _vm._v(
                            "【" + _vm._s(_vm.userList.next.realName) + "】"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm.userList.next.userState == "Calling"
                              ? [_vm._v("正在外呼")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Confirmed"
                              ? [_vm._v("已确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Unconfirmed"
                              ? [_vm._v("未确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Call"
                              ? [_vm._v("通话中")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Callend"
                              ? [_vm._v("通话结束")]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    : [_vm._v("暂无")]
                ],
                2
              )
            ])
          ],
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c("h3", [_vm._v("考核名单")]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.list, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "examineSeq",
                          label: "顺序",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.examineState == "Examining"
                                  ? [_vm._v("正在考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Examined"
                                  ? [_vm._v("已考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Wait"
                                  ? [_vm._v("待考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Abandon"
                                  ? [_vm._v("学员放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "startTime", label: "考核开始时间" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "duration", label: "考核时长" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.formatTime(scope.row.duration)) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否录取" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.passState == "Passed"
                                  ? [_vm._v("是")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Failed"
                                  ? [_vm._v("否")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Pending"
                                  ? [_vm._v("待定")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "change" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.change.callOutPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.change, "callOutPhone", $$v)
                    },
                    expression: "change.callOutPhone"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75acbf58", esExports)
  }
}

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_retrialExamine_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_retrialExamine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_retrialExamine_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_retrialExamine_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_retrialExamine_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef13866_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_retrialExamine_vue__ = __webpack_require__(1182);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1180)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ef13866"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_retrialExamine_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef13866_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_retrialExamine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/retrialExamine.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ef13866", Component.options)
  } else {
    hotAPI.reload("data-v-2ef13866", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1181);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c8d552e6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2ef13866\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./retrialExamine.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2ef13866\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./retrialExamine.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.nuv[data-v-2ef13866] {\n  font-size: 16px;\n}\n.top-button[data-v-2ef13866] {\n  margin: 10px 15px 20px 0;\n  display: inline-block;\n}\n.tab > li[data-v-2ef13866] {\n  float: left;\n  padding: 10px;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  border: 1px solid #dfdfdf;\n  margin-right: 10px;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n}\n.tab > li.active[data-v-2ef13866] {\n  background-color: #ecf5ff;\n  border: 1px solid #b3d8ff;\n  color: #ffffff;\n  cursor: pointer;\n}\n.tab > li.active[data-v-2ef13866]:hover {\n  background-color: #409EFF;\n}\n.tab > li.active:hover > a[data-v-2ef13866] {\n  color: #ffffff;\n}\n.tip-box[data-v-2ef13866] {\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #80a9f5;\n  text-align: center;\n  margin-right: 20px;\n}\n.tip-con[data-v-2ef13866] {\n  font-size: 14px;\n  line-height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("群培训管理 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "top-button", attrs: { href: "javascript:;" } },
        [
          _c("el-button", { attrs: { type: "primary" } }, [
            _vm._v("群考核名单")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } }),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { "margin-left": "10px" },
          attrs: { type: "danger" },
          on: { click: _vm.getList }
        },
        [_vm._v("查询淘金客")]
      ),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c(
                  "p",
                  {
                    staticClass: "tj-shift-notice",
                    staticStyle: { "padding-top": "45px" }
                  },
                  [_vm._v("暂无记录！")]
                )
              : [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        data: _vm.list,
                        height: _vm.onlineTableHeight,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", align: "center" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: scope.row.retrialState,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "retrialState", $$v)
                                      },
                                      expression: "scope.row.retrialState"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      key: "Passed",
                                      attrs: { label: "通过", value: "Passed" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "InRetrial",
                                      attrs: {
                                        label: "复训中",
                                        value: "InRetrial"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "passRemark",
                          label: "备注",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: "",
                                    placeholder: "不能超过200字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.passRemark,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "passRemark", $$v)
                                    },
                                    expression: "scope.row.passRemark"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tj-margin-top-xl" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveScore }
                        },
                        [_vm._v("保存打分")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.releaseGroup }
                        },
                        [_vm._v("发布成绩")]
                      )
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "release" }, [
        _c(
          "h3",
          { staticStyle: { "text-align": "center", "margin-bottom": "10px" } },
          [_vm._v("所有通过学员将被T出本群，且建议复训通过。")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 发送消息：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 3,
                    placeholder: "恭喜你通过基础复训，赶快去领取任务吧。"
                  },
                  model: {
                    value: _vm.release.publishMsg,
                    callback: function($$v) {
                      _vm.$set(_vm.release, "publishMsg", $$v)
                    },
                    expression: "release.publishMsg"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ef13866", esExports)
  }
}

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkage_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_521110b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkage_vue__ = __webpack_require__(1184);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_521110b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/linkage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-521110b4", Component.options)
  } else {
    hotAPI.reload("data-v-521110b4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("学员明细情况 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "总学习学员名单", name: "first" } },
            [
              _c("label", [_vm._v("淘金客：")]),
              _vm._v(" "),
              _c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } }),
              _vm._v(" "),
              _c("label", [_vm._v("基础培训老师：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.teacherId,
                    callback: function($$v) {
                      _vm.teacherId = $$v
                    },
                    expression: "teacherId"
                  }
                },
                _vm._l(_vm.teacherList, function(ll, key) {
                  return _c("el-option", {
                    key: ll.roleId,
                    attrs: { label: ll.tjkName, value: ll.roleId }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("label", [_vm._v("所属群：")]),
              _vm._v(" "),
              _c("el-input", {
                staticStyle: { width: "150px" },
                attrs: { placeholder: "请输入群ID" },
                model: {
                  value: _vm.queryGroupId,
                  callback: function($$v) {
                    _vm.queryGroupId = $$v
                  },
                  expression: "queryGroupId"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-top": "20px" },
                  attrs: { data: _vm.totalList, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "tjkName",
                      label: "姓名",
                      width: "180",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tjkNumber",
                      label: "淘金号",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "groupName",
                      label: "所属群",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "teacherName",
                      label: "培训老师",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "学习进度", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [_vm._v(_vm._s(scope.row.progress) + "%")]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "lastStudyTime",
                      label: "最近学习时间",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "loseState",
                      label: "学员状态",
                      align: "center"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
                on: { getData: _vm.getList }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.tabList, function(item, index) {
            return _c(
              "el-tab-pane",
              {
                key: item.courseId,
                attrs: {
                  label: item.courseName,
                  name: _vm.getString(item.courseId)
                }
              },
              [
                _c("label", [_vm._v("淘金客：")]),
                _vm._v(" "),
                _c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "danger" },
                    on: {
                      click: function($event) {
                        return _vm.getLinkageList(1)
                      }
                    }
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                !_vm.success
                  ? _c("p", { staticClass: "tj-shift-notice" }, [
                      _vm._v(_vm._s(_vm.message))
                    ])
                  : [
                      !_vm.linkageList.length
                        ? _c(
                            "p",
                            {
                              staticClass: "tj-shift-notice",
                              staticStyle: { "padding-top": "45px" }
                            },
                            [_vm._v("暂无记录！")]
                          )
                        : [
                            _c(
                              "el-table",
                              {
                                ref: "multipleTable",
                                refInFor: true,
                                staticStyle: {
                                  width: "100%",
                                  "margin-top": "20px"
                                },
                                attrs: {
                                  border: "",
                                  data: _vm.linkageList,
                                  "tooltip-effect": "dark"
                                },
                                on: {
                                  "selection-change": _vm.handleSelectionChange
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "selection", align: "center" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "realName",
                                    label: "姓名",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "tjkNumber",
                                    label: "淘金号",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { label: "学习进度", align: "center" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(scope.row.progress) + "%"
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "lastStudyTime",
                                    label: "最近学习时间",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "isPassed",
                                    label: "操作",
                                    align: "center"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row.isPassed == "No"
                                              ? [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.passSingle(
                                                            scope.row
                                                              .evaluationId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("通过")]
                                                  )
                                                ]
                                              : scope.row.isPassed == "Yes"
                                              ? [_vm._v("已通过")]
                                              : void 0
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "tj-margin-top-xl" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.passEvaluations }
                                  },
                                  [_vm._v("学员通过课程")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("pagination", {
                              attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
                              on: { getData: _vm.getLinkageList }
                            })
                          ]
                    ]
              ],
              2
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-521110b4", esExports)
  }
}

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interview_vue__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interview_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interview_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interview_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a96e22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_interview_vue__ = __webpack_require__(1188);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1186)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35a96e22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interview_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a96e22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_interview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/interview.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35a96e22", Component.options)
  } else {
    hotAPI.reload("data-v-35a96e22", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1187);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2c8ec529", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35a96e22\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./interview.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35a96e22\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./interview.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.el-row[data-v-35a96e22] {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n.el-row .el-col[data-v-35a96e22] {\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-bottom: 20px;\n}\n.el-row .el-col .el-card[data-v-35a96e22] {\n  cursor: pointer;\n}\n.button[data-v-35a96e22] {\n  margin: 20px 0;\n}\n.tab-box[data-v-35a96e22] {\n  line-height: 30px;\n  position: relative;\n  margin: -10px -10px 10px -10px;\n}\n.tab-box .badge[data-v-35a96e22] {\n  position: absolute;\n  background-color: #999999;\n  display: inline-block;\n  height: 24px;\n  padding: 1px 8px;\n  border-radius: 12px;\n  color: #ffffff;\n  top: 0;\n  right: 0;\n  line-height: 24px;\n}\n.tab-box .badge.active[data-v-35a96e22] {\n  background-color: #f56c6c;\n}\n.tab-box .title[data-v-35a96e22] {\n  font-size: 16px;\n  font-weight: 600;\n}\n.tab-box .padding-r-sm[data-v-35a96e22] {\n  padding-right: 20px;\n}\n.tab-box .detail[data-v-35a96e22] {\n  position: absolute;\n  bottom: -25px;\n  right: 0;\n  color: #409EFF;\n}\n", ""]);

// exports


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", [
            _vm._v(_vm._s(_vm.groupName) + "的面试邀请")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "button",
          attrs: { type: "primary" },
          on: {
            click: function($event) {
              _vm.dialogVisible = true
            }
          }
        },
        [_vm._v("新增面试邀请")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "el-row" },
        _vm._l(_vm.list, function(item, key) {
          return _c(
            "div",
            { staticClass: "el-col el-col-4" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "interviewTjk",
                      params: {
                        id: item.interviewInviteId,
                        groupName: _vm.groupName,
                        groupId: _vm.groupId
                      }
                    }
                  }
                },
                [
                  _c("div", { staticClass: "el-card is-always-shadow" }, [
                    _c("div", { staticClass: "el-card__body" }, [
                      _c(
                        "div",
                        { staticClass: "tab-box" },
                        [
                          item.endStatus == "Ongoing"
                            ? [
                                _c("span", { staticClass: "badge active" }, [
                                  _vm._v("进行中")
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          item.endStatus == "End"
                            ? [
                                _c("span", { staticClass: "badge" }, [
                                  _vm._v("已结束")
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.title))
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", { staticClass: "padding-r-sm" }, [
                              _vm._v("申请人数：" + _vm._s(item.applyNum))
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("通过人数：" + _vm._s(item.passedNum))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("截止日期：" + _vm._s(item.expireTime))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "detail" }, [
                            _vm._v("查看详情")
                          ])
                        ],
                        2
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.list.length > _vm.pageSize
        ? _c("pagination", {
            attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
            on: { getData: _vm.getList }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增面试邀请",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "add",
              attrs: {
                model: _vm.add,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "面试主题", prop: "title" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请控制在10个字内", clearable: "" },
                    model: {
                      value: _vm.add.title,
                      callback: function($$v) {
                        _vm.$set(_vm.add, "title", $$v)
                      },
                      expression: "add.title"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "面试邀请简述", prop: "description" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      placeholder: "请控制在200个字内",
                      clearable: ""
                    },
                    model: {
                      value: _vm.add.description,
                      callback: function($$v) {
                        _vm.$set(_vm.add, "description", $$v)
                      },
                      expression: "add.description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "截止日期", prop: "expireTime" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      placeholder: "选择日期时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss"
                    },
                    on: { change: _vm.changeHandlerStart },
                    model: {
                      value: _vm.add.expireTime,
                      callback: function($$v) {
                        _vm.$set(_vm.add, "expireTime", $$v)
                      },
                      expression: "add.expireTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNew } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a96e22", esExports)
  }
}

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interviewTjk_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interviewTjk_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interviewTjk_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interviewTjk_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interviewTjk_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d5c8e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_interviewTjk_vue__ = __webpack_require__(1192);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1190)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74d5c8e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_interviewTjk_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d5c8e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_interviewTjk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/interviewTjk.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74d5c8e3", Component.options)
  } else {
    hotAPI.reload("data-v-74d5c8e3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1191);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f53d9c62", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74d5c8e3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./interviewTjk.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74d5c8e3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./interviewTjk.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.link-text[data-v-74d5c8e3] {\n  display: inline-block;\n  margin: 5px;\n  cursor: pointer;\n  color: #409eff;\n}\nh3[data-v-74d5c8e3] {\n  padding-top: 20px;\n  padding-bottom: 10px;\n}\n.el-row[data-v-74d5c8e3] {\n  line-height: 36px;\n}\n", ""]);

// exports


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "/tjkStudy/interview?groupId=" +
                    _vm.groupId +
                    "&groupName=" +
                    _vm.groupName
                }
              },
              [_vm._v(_vm._s(_vm.groupName) + "的面试邀请")]
            )
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v("申请人详情")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: { data: _vm.tjkList, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "tjkName",
              label: "淘金客",
              width: "180",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "applyTime", label: "申请日期", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "mobilePhone", label: "电话号码", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "wechatNumber", label: "微信号", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "备注", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "通过状态", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.passState == "Passed"
                      ? _c("span", [_vm._v("已通过")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "Failed"
                      ? _c("span", [_vm._v("未通过")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.passState == "Passed"
                      ? _c(
                          "span",
                          {
                            staticClass: "link-text",
                            on: {
                              click: function($event) {
                                return _vm.updateState(
                                  scope.row.applyId,
                                  "Failed"
                                )
                              }
                            }
                          },
                          [_vm._v("不通过")]
                        )
                      : scope.row.passState == "Failed"
                      ? _c(
                          "span",
                          {
                            staticClass: "link-text",
                            on: {
                              click: function($event) {
                                return _vm.updateState(
                                  scope.row.applyId,
                                  "Passed"
                                )
                              }
                            }
                          },
                          [_vm._v("通过")]
                        )
                      : [
                          _c(
                            "span",
                            {
                              staticClass: "link-text",
                              on: {
                                click: function($event) {
                                  return _vm.updateState(
                                    scope.row.applyId,
                                    "Failed"
                                  )
                                }
                              }
                            },
                            [_vm._v("不通过")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "link-text",
                              on: {
                                click: function($event) {
                                  return _vm.updateState(
                                    scope.row.applyId,
                                    "Passed"
                                  )
                                }
                              }
                            },
                            [_vm._v("通过")]
                          )
                        ],
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "link-text",
                        on: {
                          click: function($event) {
                            return _vm.addRemark(
                              scope.row.applyId,
                              scope.row.remark
                            )
                          }
                        }
                      },
                      [_vm._v("备注")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "link-text",
                        on: {
                          click: function($event) {
                            return _vm.queryTjkFun(scope.row.tjkId)
                          }
                        }
                      },
                      [_vm._v("个人信息")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.tjkList.length > _vm.pageSize
        ? _c("pagination", {
            attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
            on: { getData: _vm.getTjkList }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogVisibleTjk
        ? [
            _c("h3", [_vm._v("淘金客个人信息")]),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("平台昵称：" + _vm._s(_vm.nick))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("我的优势：" + _vm._s(_vm.advantage))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("平台外客服经验：" + _vm._s(_vm.experience))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("是否有小孩：" + _vm._s(_vm.haveChildren))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("年龄：" + _vm._s(_vm.age))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("最低接受薪酬：" + _vm._s(_vm.lowestSalary))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("绑定微信：" + _vm._s(_vm.wechatId))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("每天可工作时长：" + _vm._s(_vm.workHours))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [_vm._v("推荐人：无")]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("注册来源：" + _vm._s(_vm.channel))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("擅长语种：")]),
                      _vm._v(" "),
                      _vm._l(_vm.language, function(item, index) {
                        return _c("span", [
                          _vm._v("\n              " + _vm._s(item)),
                          index < _vm.language.length - 1
                            ? _c("span", [_vm._v(" 、")])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("平台外经验工作类型：")]),
                      _vm._v(" "),
                      _vm._l(_vm.experienceWork, function(item, index) {
                        return _c("span", [
                          _vm._v("\n              " + _vm._s(item)),
                          index < _vm.experienceWork.length - 1
                            ? _c("span", [_vm._v(" 、")])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("注册日期：" + _vm._s(_vm.registerTime))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("\n          客服标签：\n          "),
                  _vm.providerTag == "HH"
                    ? _c("span", [_vm._v("合伙人")])
                    : _vm.providerTag == "ZJ"
                    ? _c("span", [_vm._v("自建职场")])
                    : _vm.providerTag == "LY"
                    ? _c("span", [_vm._v("联营")])
                    : _c("span", [_vm._v("平台客服")])
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("期望工作类型：")]),
                      _vm._v(" "),
                      _vm._l(_vm.expectedWork, function(item, index) {
                        return _c("span", [
                          _vm._v("\n              " + _vm._s(item)),
                          index < _vm.expectedWork.length - 1
                            ? _c("span", [_vm._v(" 、")])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("所属团队：" + _vm._s(_vm.providerName))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("最高学历：" + _vm._s(_vm.education))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("擅长行业：")]),
                      _vm._v(" "),
                      _vm._l(_vm.industryed, function(item, index) {
                        return _c("span", [
                          _vm._v("\n              " + _vm._s(item)),
                          index < _vm.industryed.length - 1
                            ? _c("span", [_vm._v(" 、")])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("特殊任务要求：" + _vm._s(_vm.acceptShortProject))
                ])
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "备注",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modal",
              attrs: {
                model: _vm.modal,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "description" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      placeholder: "请控制在100个字内",
                      clearable: ""
                    },
                    model: {
                      value: _vm.modal.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.modal, "remark", $$v)
                      },
                      expression: "modal.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addRemarkFun } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74d5c8e3", esExports)
  }
}

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupCheckIn_vue__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupCheckIn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupCheckIn_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupCheckIn_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupCheckIn_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55b1013d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_groupCheckIn_vue__ = __webpack_require__(1194);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_groupCheckIn_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55b1013d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_groupCheckIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/college/groupCheckIn.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-55b1013d", Component.options)
  } else {
    hotAPI.reload("data-v-55b1013d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("签到 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "p",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.dialogVisible = true
                }
              }
            },
            [_vm._v("发起签到")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", { staticStyle: { margin: "20px 0" } }, [_vm._v("签到记录")]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "签到人" } },
            [_c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "发起签到时间" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "选择开始日期"
                },
                on: { change: _vm.changeHandlerStart },
                model: {
                  value: _vm.queryStartTime,
                  callback: function($$v) {
                    _vm.queryStartTime = $$v
                  },
                  expression: "queryStartTime"
                }
              }),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "选择结束日期"
                },
                on: { change: _vm.changeHandlerEnd },
                model: {
                  value: _vm.queryEndTime,
                  callback: function($$v) {
                    _vm.queryEndTime = $$v
                  },
                  expression: "queryEndTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "签到主题" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { clearable: "" },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getExcel } },
                [_vm._v("导出")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "startTime", label: "发起签到时间", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "timeRule", label: "签到规则", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "签到主题", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "tjkNumber", label: "淘金号", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "tjkName", label: "签到人", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-popover",
                      { attrs: { trigger: "hover", placement: "right-start" } },
                      [
                        _c("p", [
                          _vm._v("真实姓名：" + _vm._s(scope.row.realName))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("淘金号：" + _vm._s(scope.row.tjkNumber))
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "客服标签：" + _vm._s(scope.row.tjkTypeTagName)
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("所属团队：" + _vm._s(scope.row.providerName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _c("span", [_vm._v(_vm._s(scope.row.tjkName))]),
                            _vm._v(" "),
                            scope.row.tjkTypeTag === "ProviderService"
                              ? _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconTuan.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                              : scope.row.tjkTypeTag === "SaleService"
                              ? _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconXiao.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                              : scope.row.tjkTypeTag === "FreeService"
                              ? _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconZi.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                              : scope.row.tjkTypeTag === "MerchantService"
                              ? _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconShang.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                              : _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "http://taojinyun.file.itaojin.cn/tjkTypeIconYun.png",
                                      width: "20px"
                                    }
                                  })
                                ])
                          ]
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "checkInTime", label: "签到时间", align: "center" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
        on: { getData: _vm.getList }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发起签到",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modal",
              attrs: {
                model: _vm.modal,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "签到主题", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请控制在5个字内", clearable: "" },
                    model: {
                      value: _vm.modal.name,
                      callback: function($$v) {
                        _vm.$set(_vm.modal, "name", $$v)
                      },
                      expression: "modal.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "时间", prop: "time" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.modal.time,
                        callback: function($$v) {
                          _vm.$set(_vm.modal, "time", $$v)
                        },
                        expression: "modal.time"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "1",
                        attrs: { label: "1分钟内", value: "1" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: "3",
                        attrs: { label: "3分钟内", value: "3" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: "5",
                        attrs: { label: "5分钟内", value: "5" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: "60",
                        attrs: { label: "1小时内", value: "60" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addCheckIn } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55b1013d", esExports)
  }
}

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_operatorExamine_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_operatorExamine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_operatorExamine_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_operatorExamine_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_operatorExamine_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b416614_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_operatorExamine_vue__ = __webpack_require__(1198);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1196)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b416614"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_operatorExamine_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b416614_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_operatorExamine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/provider/operatorExamine.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1b416614", Component.options)
  } else {
    hotAPI.reload("data-v-1b416614", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1197);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("59ddb3d2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1b416614\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./operatorExamine.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1b416614\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./operatorExamine.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.nuv[data-v-1b416614] {\n  font-size: 16px;\n}\n.top-button[data-v-1b416614] {\n  margin: 10px 15px 20px 0;\n  display: inline-block;\n}\n.tab > li[data-v-1b416614] {\n  float: left;\n  padding: 10px;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  border: 1px solid #dfdfdf;\n  margin-right: 10px;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n}\n.tab > li.active[data-v-1b416614] {\n  background-color: #ecf5ff;\n  border: 1px solid #b3d8ff;\n  color: #ffffff;\n  cursor: pointer;\n}\n.tab > li.active[data-v-1b416614]:hover {\n  background-color: #409EFF;\n}\n.tab > li.active:hover > a[data-v-1b416614] {\n  color: #ffffff;\n}\n.tip-box[data-v-1b416614] {\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #80a9f5;\n  text-align: center;\n  margin-right: 20px;\n}\n.tip-con[data-v-1b416614] {\n  font-size: 14px;\n  line-height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("群培训管理 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "top-button", attrs: { href: "javascript:;" } },
        [
          _c("el-button", { attrs: { type: "primary" } }, [
            _vm._v("群考核名单")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "淘金客" } },
            [_c("tjkautocomplete", { on: { callBack: _vm.updateTjkId } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "合作公司" } },
            [
              _c("providerautocomplete", {
                on: { callBack: _vm.updateProviderId }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否通过" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.passState,
                    callback: function($$v) {
                      _vm.passState = $$v
                    },
                    expression: "passState"
                  }
                },
                [
                  _c("el-option", {
                    key: "Passed",
                    attrs: { label: "通过", value: "Passed" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Failed",
                    attrs: { label: "未通过", value: "Failed" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "NotExamine",
                    attrs: { label: "未考", value: "NotExamine" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Loss",
                    attrs: { label: "流失", value: "Loss" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "Cancel",
                    attrs: { label: "取消资格", value: "Cancel" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "签到次数" } },
            [
              _c("el-input", {
                attrs: { clearable: "" },
                model: {
                  value: _vm.checkInTimes,
                  callback: function($$v) {
                    _vm.checkInTimes = $$v
                  },
                  expression: "checkInTimes"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "签到时间" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "选择开始日期"
                },
                on: { change: _vm.changeHandlerStart },
                model: {
                  value: _vm.checkInStartTime,
                  callback: function($$v) {
                    _vm.checkInStartTime = $$v
                  },
                  expression: "checkInStartTime"
                }
              }),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "选择结束日期"
                },
                on: { change: _vm.changeHandlerEnd },
                model: {
                  value: _vm.checkInEndTime,
                  callback: function($$v) {
                    _vm.checkInEndTime = $$v
                  },
                  expression: "checkInEndTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _vm.list.length > 0
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getExcel } },
                    [_vm._v("导出")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.endOperatorExam }
                },
                [_vm._v("结束培训")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "tab" },
        _vm._l(_vm.examiningList, function(t, key) {
          return _c(
            "li",
            { class: { active: t.isCurrent } },
            [
              t.isCurrent
                ? [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/tjkStudy/enterExam?id=" +
                            t.operatorExamId +
                            "&groupId=" +
                            _vm.groupId +
                            "&groupName=" +
                            _vm.groupName,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(t.operatorName) +
                            "  考核人数：" +
                            _vm._s(t.examNum)
                        )
                      ]
                    )
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(t.operatorName) +
                        "  考核人数：" +
                        _vm._s(t.examNum) +
                        "\n      "
                    )
                  ]
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c(
                  "p",
                  {
                    staticClass: "tj-shift-notice",
                    staticStyle: { "padding-top": "45px" }
                  },
                  [_vm._v("暂无记录！")]
                )
              : [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        data: _vm.list,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", align: "center" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "loginName",
                          label: "电话",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "companyName",
                          label: "公司简称",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "checkInTimes",
                          label: "签到次数",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: scope.row.passState,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "passState", $$v)
                                      },
                                      expression: "scope.row.passState"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      key: "Passed",
                                      attrs: { label: "通过", value: "Passed" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Failed",
                                      attrs: {
                                        label: "未通过",
                                        value: "Failed"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "NotExamine",
                                      attrs: {
                                        label: "未考",
                                        value: "NotExamine"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Loss",
                                      attrs: { label: "流失", value: "Loss" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      key: "Cancel",
                                      attrs: {
                                        label: "取消资格",
                                        value: "Cancel"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "综合得分", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "只能填写数字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.score,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "score", _vm._n($$v))
                                    },
                                    expression: "scope.row.score"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "备注", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    autosize: "",
                                    placeholder: "不能超过200字",
                                    clearable: ""
                                  },
                                  model: {
                                    value: scope.row.remark,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "remark", $$v)
                                    },
                                    expression: "scope.row.remark"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tj-margin-top-xl" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.checkGroup }
                        },
                        [_vm._v("群考核")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveScore }
                        },
                        [_vm._v("保存打分")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.releaseGroup }
                        },
                        [_vm._v("发布成绩")]
                      )
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "check" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.callPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "callPhone", _vm._n($$v))
                    },
                    expression: "check.callPhone"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 平均外呼时长（分钟）：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.averageDuration,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "averageDuration", _vm._n($$v))
                    },
                    expression: "check.averageDuration"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b416614", esExports)
  }
}

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enterExam_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enterExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enterExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enterExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enterExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_512b85b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_enterExam_vue__ = __webpack_require__(1202);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1200)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-512b85b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_enterExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_512b85b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_enterExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/provider/enterExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-512b85b0", Component.options)
  } else {
    hotAPI.reload("data-v-512b85b0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1201);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("df3b951e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-512b85b0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./enterExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-512b85b0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./enterExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\nh3[data-v-512b85b0] {\n  margin-top: 20px;\n}\n.nuv[data-v-512b85b0] {\n  font-size: 16px;\n}\n.current[data-v-512b85b0] {\n  border: 1px solid #dfdfdf;\n  background-color: #ffffff;\n}\n.current .tab[data-v-512b85b0] {\n  border-bottom: 1px solid #dfdfdf;\n  padding: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n.current .content[data-v-512b85b0] {\n  padding: 10px;\n}\ntable > tr > th[data-v-512b85b0], table > tr > td[data-v-512b85b0] {\n  padding: 5px;\n}\n.content .button[data-v-512b85b0] {\n  margin: 0px 5px 10px 5px;\n}\n.end[data-v-512b85b0] {\n  margin-bottom: 20px;\n  margin-top: 10px;\n}\n.end > span[data-v-512b85b0] {\n  padding: 0 20px;\n  font-size: 18px;\n}\n.nopeople[data-v-512b85b0] {\n  padding: 10px 0 20px;\n}\n", ""]);

// exports


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c(
          "a",
          {
            staticClass: "active",
            attrs: {
              href:
                "/tjkStudy/operatorExamine?groupId=" +
                _vm.groupId +
                "&groupName=" +
                _vm.groupName,
              target: "_blank"
            }
          },
          [_vm._v("群培训管理")]
        ),
        _vm._v(">\n    "),
        _c("span", [_vm._v("语音考核")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "end" },
        [
          _c("span", [_vm._v("当前拨打电话：" + _vm._s(_vm.callPhone))]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "danger" },
              on: {
                click: function($event) {
                  return _vm.endExam()
                }
              }
            },
            [_vm._v("结束考核")]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.currentExamRecord
        ? [
            _c("p", { staticClass: "nopeople" }, [
              _vm._v("名单中全部人员考核结束")
            ])
          ]
        : [
            _c("div", { staticClass: "current" }, [
              _c("div", { staticClass: "content" }, [
                _c("table", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v(_vm._s(_vm.realName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.loginName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.tjkNumber))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.passState,
                              callback: function($$v) {
                                _vm.passState = $$v
                              },
                              expression: "passState"
                            }
                          },
                          [
                            _c("el-option", {
                              key: "Passed",
                              attrs: { label: "通过", value: "Passed" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              key: "Failed",
                              attrs: { label: "未通过", value: "Failed" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              key: "NotExamine",
                              attrs: { label: "未考", value: "NotExamine" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              key: "Loss",
                              attrs: { label: "流失", value: "Loss" }
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              key: "Cancel",
                              attrs: { label: "取消资格", value: "Cancel" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: { placeholder: "只能填写数字", clearable: "" },
                          model: {
                            value: _vm.score,
                            callback: function($$v) {
                              _vm.score = _vm._n($$v)
                            },
                            expression: "score"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: "",
                            placeholder: "不能超过200字",
                            clearable: ""
                          },
                          model: {
                            value: _vm.remark,
                            callback: function($$v) {
                              _vm.remark = $$v
                            },
                            expression: "remark"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.saveScore }
                          },
                          [_vm._v("保存打分")]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ],
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c("h3", [_vm._v("考核名单")]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.list, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "sequence",
                          label: "顺序",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "loginName",
                          label: "电话",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.passState == "Passed"
                                  ? _c("span", [_vm._v("通过")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Failed"
                                  ? _c("span", [_vm._v("未通过")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "NotExamine"
                                  ? _c("span", [_vm._v("未考")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Loss"
                                  ? _c("span", [_vm._v("流失")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Cancel"
                                  ? _c("span", [_vm._v("取消资格")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "score",
                          label: "综合得分",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "remark",
                          label: "备注",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "isFinish",
                          label: "是否完成考核",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.isFinish == "No"
                                  ? _c("span", [_vm._v("否")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.isFinish == "Yes"
                                  ? _c("span", [_vm._v("是")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("考核人员")]),
      _vm._v(" "),
      _c("th", [_vm._v("电话")]),
      _vm._v(" "),
      _c("th", [_vm._v("淘金号")]),
      _vm._v(" "),
      _c("th", [_vm._v("是否通过")]),
      _vm._v(" "),
      _c("th", [_vm._v("综合得分")]),
      _vm._v(" "),
      _c("th", [_vm._v("备注")]),
      _vm._v(" "),
      _c("th")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-512b85b0", esExports)
  }
}

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExamOperator_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExamOperator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExamOperator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExamOperator_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExamOperator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d48491_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tjkExamOperator_vue__ = __webpack_require__(1206);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1204)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20d48491"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkExamOperator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d48491_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tjkExamOperator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/provider/tjkExamOperator.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20d48491", Component.options)
  } else {
    hotAPI.reload("data-v-20d48491", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1205);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("dbae3a04", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-20d48491\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tjkExamOperator.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-20d48491\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tjkExamOperator.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.tips[data-v-20d48491] {\n  background-color: #3b3b62;\n  text-align: center;\n  font-size: 18px;\n  color: #ffffff;\n  margin-bottom: 20px;\n}\n.tips p[data-v-20d48491] {\n  padding: 5px 0;\n}\nh3[data-v-20d48491] {\n  margin-top: 20px;\n}\n", ""]);

// exports


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.tjkExamRecord == null
        ? _c("div", { staticClass: "tips" }, [
            _c("p", [_vm._v("目前考核不存在或考核已经结束。")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isCurrent == "Yes"
        ? _c(
            "div",
            { staticClass: "tips" },
            [
              _vm._v("\n    开始考核，请拨打电话（"),
              _c("font", { attrs: { color: "red" } }, [
                _vm._v(_vm._s(_vm.callPhone))
              ]),
              _vm._v("）完成考核。\n  ")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCurrent == "No"
        ? _c(
            "div",
            { staticClass: "tips" },
            [
              _vm._v(
                "\n    请耐心等待考核，预估考核时间：" +
                  _vm._s(_vm.expectExamineTime) +
                  "，考核电话："
              ),
              _c("font", { attrs: { color: "red" } }, [
                _vm._v(_vm._s(_vm.callPhone))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isFinish == "Yes"
        ? _c("div", { staticClass: "tips" }, [
            _vm._v("\n    考核完成，考核结果："),
            _vm.passState == "Passed" ? _c("span", [_vm._v("通过")]) : _vm._e(),
            _vm.passState == "Failed"
              ? _c("span", [_vm._v("未通过")])
              : _vm._e(),
            _vm.passState == "NotExamine"
              ? _c("span", [_vm._v("未考")])
              : _vm._e(),
            _vm.passState == "Loss" ? _c("span", [_vm._v("流失")]) : _vm._e(),
            _vm.passState == "Cancel"
              ? _c("span", [_vm._v("取消资格")])
              : _vm._e(),
            _vm._v("，得分：" + _vm._s(_vm.score) + "分\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("当前考核人员")]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.currentlist, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "realName",
              label: "考核人员",
              width: "180",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "tjkNumber",
              label: "淘金号",
              width: "180",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否通过", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.passState == "Passed"
                      ? _c("span", [_vm._v("通过")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "Failed"
                      ? _c("span", [_vm._v("未通过")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "NotExamine"
                      ? _c("span", [_vm._v("未考")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "Loss"
                      ? _c("span", [_vm._v("流失")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "Cancel"
                      ? _c("span", [_vm._v("取消资格")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "expectExamineTime",
              label: "预估考核时间",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "score", label: "综合得分", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "备注", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否完成考核", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.isFinish == "Yes" ? [_vm._v("是")] : _vm._e(),
                    _vm._v(" "),
                    scope.row.isFinish == "No" ? [_vm._v("否")] : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            _c("h3", [_vm._v("考核名单")]),
            _vm._v(" "),
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.list,
                        border: "",
                        "row-class-name": _vm.tableRowClassName
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "sequence",
                          label: "顺序",
                          width: "60",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          width: "180",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          width: "180",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "expectExamineTime",
                          label: "预估考核时间",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否完成考核", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.isFinish == "Yes"
                                  ? [_vm._v("是")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.isFinish == "No"
                                  ? [_vm._v("否")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nuv" }, [
      _c("a", { staticClass: "active", attrs: { href: "#" } }, [
        _vm._v("语音考核")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20d48491", esExports)
  }
}

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddStudy_vue__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddStudy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddStudy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddStudy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddStudy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7478846_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pddStudy_vue__ = __webpack_require__(1292);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1208)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7478846"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddStudy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7478846_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pddStudy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/pddStudy.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d7478846", Component.options)
  } else {
    hotAPI.reload("data-v-d7478846", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1209);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1afab253", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d7478846\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pddStudy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d7478846\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pddStudy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-d7478846] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-d7478846] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n[data-v-d7478846] .el-tabs__content {\n  height: 100% !important;\n}\n.con-left[data-v-d7478846] {\n  background: none !important;\n  flex: 1 1 auto;\n  min-width: 1;\n}\n.con-right[data-v-d7478846] {\n  width: 170px;\n  flex: 0 0 170px;\n}\n.stoptip[data-v-d7478846] {\n  width: 100% !important;\n  height: 100% !important;\n}\n.video-box[data-v-d7478846] {\n  width: 100% !important;\n  overflow: hidden;\n  line-height: 0;\n  transition: none !important;\n}\n.video[data-v-d7478846] {\n  display: block;\n  width: 100% !important;\n  height: auto !important;\n  transform: none !important;\n  transform-origin: center center;\n  transition: none !important;\n}\n#newQianniuex[data-v-d7478846] {\n  box-sizing: border-box;\n  height: 100vh;\n  overflow-y: scroll;\n}\n", ""]);

// exports


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./add_kjdy_success.png": 1211,
	"./allchat.png": 1212,
	"./caitaxihuan.png": 1213,
	"./coupon.png": 1214,
	"./coupon_hover.png": 1215,
	"./dealuser.png": 1216,
	"./dkhsqsh.png": 1217,
	"./dkhsqsh_hover.png": 1218,
	"./dr_alert1.png": 1219,
	"./dr_alert1a.png": 1220,
	"./dr_alert2.png": 1221,
	"./emoj.png": 1222,
	"./goodmsg.png": 1223,
	"./jbalert.png": 1224,
	"./jbeykh.png": 1225,
	"./jbeysh.png": 1226,
	"./kjdy_alert.png": 1227,
	"./kjdy_alert_hover.png": 1228,
	"./kjdy_dr_done.jpeg": 1229,
	"./kjdy_drdc.jpeg": 1230,
	"./kjdy_raw.png": 1231,
	"./kjhf1.jpeg": 1232,
	"./kjhf_add.jpeg": 1233,
	"./kjhf_add_group.jpeg": 1234,
	"./kjhf_add_group_success.jpeg": 1235,
	"./kjhf_add_new.jpeg": 1236,
	"./kjhf_add_select_group.jpeg": 1237,
	"./link.png": 1238,
	"./link_hover.png": 1239,
	"./llzj.png": 1240,
	"./login1.png": 1241,
	"./login2.png": 1242,
	"./login3.png": 1243,
	"./loginindex.png": 1244,
	"./ltjl.png": 1245,
	"./markend.png": 1246,
	"./more_feature.png": 1247,
	"./order1.png": 1248,
	"./order2.png": 1249,
	"./order3.png": 1250,
	"./order_hover.png": 1251,
	"./orderremark1.png": 1252,
	"./orderremark2.png": 1253,
	"./other.png": 1254,
	"./pddbg1.png": 1255,
	"./pddbg2.png": 1256,
	"./qtalert.png": 1257,
	"./quitpdd.png": 1258,
	"./rexiao.png": 1259,
	"./rnd1.png": 1260,
	"./rnd2.png": 1261,
	"./send_kjdy.png": 1262,
	"./sjmb.png": 1263,
	"./status_bar_left.png": 1264,
	"./status_bar_right.png": 1265,
	"./status_menu1.png": 1266,
	"./status_menu2.png": 1267,
	"./statusonline.png": 1268,
	"./statusonline1.png": 1269,
	"./staus.png": 1270,
	"./sucaiku.png": 1271,
	"./sucaikubtn.png": 1272,
	"./tag.png": 1273,
	"./tagsuccess.png": 1274,
	"./tjsp.png": 1275,
	"./tjsp2.png": 1276,
	"./undealuser.png": 1277,
	"./untagsuccess.png": 1278,
	"./untagsuccessbg.png": 1279,
	"./video.png": 1280,
	"./xedk.png": 1281,
	"./xesk.png": 1282,
	"./zyhh1.png": 1283,
	"./zyhh2.png": 1284
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1210;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/add_kjdy_success.22c23d8.png";

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/allchat.358928c.png";

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/caitaxihuan.baafba8.png";

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAAAWCAYAAACMq7H+AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAImSURBVFhH7ZbbscMgDERvly7EM26DQiiEQlwIVxLICEk88s/OMHHCazlakvw9z5NPmzeCdDTWgbShA2lDB9KGlpDeeOc7vvwm3yGV5xTydYVc3xXhZ9yPwvF3zHU2KYUryyGkblzKgdZ9c7yvtvdIsOd8DKwnPHTnUX0jLSGlcOe2pjaEBxL9IDTRgRLgeoNNxriAj1C5j9a+rr3GHt43v+iBYCB49lu9J/x0rgUkWwWTAiMwEmAOGvPM19bWQeMykfPqGg9e4Xg+JtTZ27a+0FpzSNubQJvGVoMQqklbpeSnNLleZIp+0yJJUvMKFxPFpL1SI0h1Th8N2icNUvtLkvCqGoCj5m1WtQ1pVkHP9LLiMOkbIxeoPw4GRtVyXWyqmARLF5huyV6yNiGVJMQIrVsUqqY3MpVF+VFPAdJVrxsLITBkD5JRt59OO6fbv+pukRxtQWLj2oT85fmkIfH3GnyZF8MWajPZYHaQRLpMarwmrxs8x8m1C5H9jUGtIdEhRSX40NAMIBRDwsPjOB3zWt1vroBEEMSzhtSECUZPfkLteFBXjKLu781EC0j6OuF7BATJ8lLx9Tt/GEdi86oYHSQGT+vjGH5FIajyTIeGrwSTCiqY9trmrTSFhHEN8GeLf7Xs3RZ9YOyrjEjbsPFBCBJeRXUIOhiPL33FD3eLtbhxanEuPrOPD5o8i/x8rkWSjlAH0oYOpA0dSBs6kDb0QTpt1p78Dxer1FaylYphAAAAAElFTkSuQmCC"

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dealuser.39dc74d.png";

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dkhsqsh.48396d3.png";

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAAAWCAYAAADKHRJUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAKRSURBVGhD7VaJjcQgDLwuU0ikbYNCUkgKSSEcNhAGg4F97k7oGMm72QB+Zmy0X4/Hwy6by1i0hXmwRJsQS7QJsUSbEIOindZsxn12cBq7xX3ueT8ufm3tZY89nb+O3ZrCGe3ZrT+S71dxHXbfD7d7HBQ75SXh6iwTc2jXTz63eO6FnAjsY9u8dc63RWMRgiMwc1IR8C4LQmue/CQOiIBFKf4LA/9ZccJIDF5vFE3rumhpvRWH7PZB9YR6I05DHIUfAqpf7UAFL05a+t0mIYolv2vANXx2sTQRsAGYPCCTQX4qBEnL/LszRsaT9UfQ+4q/iqVBrN0yz6EjWi0pSj4UIbqMOqwuoCbWc6T2uj8zPkP+8ykomgyFR4QmqPp2RsRTvfQsaz5NHhMxXEND2cFJk6Rj53nisZM44EDR7OcmDGPIeBp8U7UnfVQ0XwflVvrDegWGrvh0luI39BhCUzStK/bj4CJM6DSyIhGtgx1S4p509K0Z+tfy8obkJiGahnnyH6izfy6eyf5wefQm7UdF8yBiIQlO0otWi01JcRFDk5ZwGkl22Z33deSmpz5dckKfmbQAEKFOPt4ODkOTlqY31kLftX1sHVXbonWIj4Yx7n9OQ5NGGJk2QV6TqE+KVvPvTKlrBLERijwiqLa3RGOI+xyKItwiMWBvd9Li1eWSF1OV/IuujhA5JNQmrYxdmCraZyYtqyfw8yeipS6EwrBrhyctEV361EVDUnKTor0yae76d++OkUkLfKiAdYodBeHnmm+y90UTaCSJSRVkZJMXiMzekUXC5YSgEA5qDnLSShSiCXgyYxN9ctLy3NQ8yN/HRftHyEQDcVqi/waWaBNiiTYhlmgTYok2IW7Rls1kD/sNl41ZMyUqdzgAAAAASUVORK5CYII="

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dr_alert1.0e3ac1f.png";

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dr_alert1a.1a6961b.png";

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/emoj.74b71e9.png";

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/goodmsg.9c13db0.png";

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jbalert.d08da8e.png";

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jbeykh.c7e590a.png";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jbeysh.61958f4.png";

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy_dr_done.a279dfe.jpeg";

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy_drdc.c2870f0.jpeg";

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy_raw.bedbb04.png";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjhf1.3d60a95.jpeg";

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjhf_add.6d3c0da.jpeg";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjhf_add_group.110b862.jpeg";

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjhf_add_group_success.76e4a49.jpeg";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjhf_add_new.3d1aedb.jpeg";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjhf_add_select_group.bdf2045.jpeg";

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHJSURBVFhH7ZXhsYQgDISvSwthxjYohEIsxEJ4WQSyQUDf/TzdmdwpkpgvyXGfdV3j0yxBP0kv9FP0Qo+1Rb94+bzSHoNb4rKo+ey0eRfDflyz9uCiyw/4Gur67CG6EpS0+cX4zjSH3rwBUBAUgdZcEFwI0FocQFxBm3UADWJVETRAOS+2WQG+7LTe2+70oJsCJSug/Axrh38QP7tfTEAt5BGDCwu109LTBXQvYUBlaFS9AkCj8ca67ivdnSXYwlSdxpsKjcnsOlnd7LTtIHf6eMZwuk8T53VcH9CAd6VIsubSN8Zb4ptvUoFOBdfinkz8RppCI+leQBdCgvY0bgpn9/ahqYCmOxmyc5bUiSiw1SfnSfdXutFpdJVGWBIq0OfXWCDtNHes7GkLhLW2s61f3ougg0O22qQIc+irEcqm8QfQ5ndo9/Q6HXqncoE/xeIzBeHsfU83O22T5MMHJ2oLbU9fAZdE2j0cD9C7TM+801kMveP58R7kdPe/+mto/fvQypY1fnH6vc1AypgKSM//JNPprBIjGeU60A3oRk2n56KuUmKnogACz3MxtKBkTVGSHz1ToUnzwv0f+gf0Qj9FL/RTVKGfZWv8A8yTK2HjZyboAAAAAElFTkSuQmCC"

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/llzj.018b99d.png";

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login1.3a17098.png";

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login2.5390a4c.png";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login3.30159a5.png";

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginindex.f0515f3.png";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ltjl.1cbae6c.png";

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/markend.a2e624c.png";

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAWCAYAAABzCZQcAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVFhH7ZSJjcQgDEW3yykEKW1QCIWkkBTC+oLYTjhmNSutlnzJGoXD8Pw9fG3bllcLgl5JD/Qq+pvQe8whHfLxefWh4fDX6zUVcZc9WkfKoTUH2qPPEzMthXNbeyBpTsHlxHPKwOBM1PtOT7pwpOCAVNgbA4TAFnWg9xgyH7/nWIokoJQ7JMjY1xC6e3kJWwS8jB8TUec4QA3d7CwGvXYGBFZHO43y305T0AbAOW3mqeLihFnHLWkdLro6bc/E+eLujbArkoN0d/T6BadPnXs7l25AnwwKWrdxCVrI3aXHO0a/7/Tom1QvxzAM3wK/QmMbN6H1fxb/Dj26hj7qdF1bLnbnjISF0tAKkjThtIaXNa3uQw2hKaGqLoLp4t46Xdvt6i49RsYdhCoQAO/O43kpSstp/C1FMHvvNYZGUVIA2LGKthW9+IVVlxTw8vJq3voa10EugKkJFVDnkz0lCrTehOtsEqM5aJBp805CI3XJ8RYGvu+aCaf1AfD94/auTkCYJOT8OUeBh3onJlqN5YHta1zHK/Q5z3N2PUavyNNO/yc90KvogV5FFXqt2PI3Y5dD4YwmYEsAAAAASUVORK5CYII="

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order1.2f2c705.png";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order2.50e5639.png";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order3.e179a0b.png";

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAWCAYAAABHcFUAAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADWSURBVEhL7ZTBDcMgDEW7JYNYYg0GYRAGYRAXozSltimOqhQOPMkHJ5F5fCIe3ntcrarUSmwpK/dIpYAupKN5k4JD5bFgIJUwQMR8dFcggVaMeoi2SeOkaNdVLGOEspDr1CGfI+jv2xrENZYq0EJyDkkC8s3zb6n/SKhztC0mKZ2+lJpOW79Incel/lczk8oR4aKUSIbXDKm/JpVCKJfEC12KI6QMmKUiu3ekFPXsmL5VmdnDJlWGyN3OTKr8A+3QelM3ux0td4/UBLaUlS1l5ZRaqzw+AflnRzillYgBAAAAAElFTkSuQmCC"

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/orderremark1.5c84db9.png";

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/orderremark2.085b83d.png";

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pddbg1.9c142e1.png";

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pddbg2.b049d08.png";

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAB/CAIAAACSZCBmAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAFp0lEQVR4nO2csXKrOBSG/7tzC9MtJeouM2koo9fAj3HRYxBV+wyQl9gZeIyopbBnSGVRqoTOWwCOjXHiYzs38ez5KmMkGT4fHcmTQ35st9v1eg3mPP7R//5YrVYPDw9ffSV3w3q9/uurr+H+YGVkWBkZVkaGlZFhZWRYGRlWRoaVkWFlZFgZGVZGhpWRYWVkWBkZVkbmSmWuNrU7o5ExY7u2qc7o8p35eVXvtus8b3HqZFNVtgXgiUiGHgDA1ZVtgdqYsZUnoijwrrqKPwxd2VFgVcbONPNEFEUyQNtUr3s9OxHJ0VDbVJXz/74rX7hEmR9KObx0tXG+DP2z+rm67kT0C6/GtJ7vw7nWD2V0XufvxDUT0znnecHp02/hWBmL3k/rFh7a1iGU8v5sAbhKmXPO899JQ34o5TD5oijwXG1MDXhC+K6Ff6e+cIWytmkcWnc6kQUeANfYFmgr40QUSYk+9nCwAPjhuXP7e3CpMtdYvGXytqmqNji687ZpOt/3Ou9XtGhM7WSI+mgBaO8t4C7bl7VN4/zgg71B27zaxdjID2WI2tQIo31fdhHeVYQBl0VZ27xaiA/Xuq5dhKGPphk6VY0XyaCrjRkWBW8v3u4IurJB2Mf36ochgHY48oIoAoBuPHlfCWwPsjLX2EUog6421eRnz15Gx/Guftxy+KGU4WXX+k3gMhYaXMZyCayMDCsjw8rIsDIyrIwMKyPDysiwMjKsjAwrI8PKyLAyMqyMDCsjw8rIsDIyrIwMKyPDysiwMjLXK3O1+aAskasYD2ibxnnzfznnKsaBnYj992bqf/xQhlzFCADwgkiOZXgnCn7m4SpGwNWV86PT98xVjBNcXTtgviSvz09cxbjPEECz5TuuNs3bAVcxArssHrbT0p8juIoRwJjFz9kXcBXjgB+em7a5inEGd1iFt8PzAK5inOXj9H/wNlcx/i/hKsZLYGVkWBkZVkaGlZFhZWRYGRlWRoaVkWFlZFgZGVZGhpWRYWVkfgLouu6rL+Oe+AlgsTj1n46YGXhikmFlZFgZGVZGhpWRYWVkWBkZVkaGlZFhZWRYGRlWRoaVkWFlZFgZGVZG5oIqRltqbWSaxqJ/XUwr/8WyP3mEyVUpZs+ZXOX7NaQySUWpbZwl8rjbtPEBMskSeerkbVitVlsym+IpeSo2/YvsZXLqqdiMRy9ZcvLouO/YqH/7JUt6norNZrM5ajjDSzY34i1ZrVaX1cqKOM1iALAATK7U4dkldTxbal0ESZYgV7mRSSYByCSRY3jZUisdDAE0G9oj8pND7PqHCzGdCrbUz+QhRJxmj6VWykJKefAdGK2K/kMyudc6nh3H5OrkjL0ZZGVjIjk7Z9iiv+mx/8HRbgST68LOjmlLrQuI4O3gVIANIyn1Tjq9AWRlMsmyw2/zvYkpkyzDfsu9PG5Lre34wsg0Fc96MtJuRGmflbJimabTALOlHpeJP8RtJmbc6Gf8Hl2YXOkyTWMBkysjT92OeJSiMAZS9hPNlvPBYUv9jDhNkuH4eN01xow5zJb7V/Ip3GZfJuI0tlrlxuRKqVKkvx9vMu4sMkml0UqXbxPUlOWwEGkj40/8bOAmUQYAMMbIJDF5flUWmeS9HZM1eFgtyhKNsQEgl7JPkTLJ0u+5Ytpm/5EbkysFsUxTKZClpdbKXKRNxGkWTGbyyUxlysIaBEkWN9rYIE4Tq/I/sMPAJcrGJTPXZZo+YrJ2DgHwXD4O0qaLw+GKick9yiQxSunluBnTRZBkh236zxfLNEsEAFuOPbO01Erln779Jz/DtMvo7/5sOWsTsguhD4baIZbLoDBD6n/rdPBR/Tbk0zYZ6/WaH/uiwY99XQIrI8PKyLAyMqyMDCsjw8rIsDIyrIwMKyPDysiwMjKsjAwrI8PKyLAyMj+22+16vf7qy7gbHh4e/gOUuyqZ0aCz8AAAAABJRU5ErkJggg=="

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rexiao.eaea7f8.png";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rnd1.b86b8e1.png";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rnd2.ea1cc70.png";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/send_kjdy.29c3fde.png";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sjmb.260f9b8.png";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/status_bar_left.0d70064.png";

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/statusonline.d3815e1.png";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/statusonline1.79d399d.png";

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sucaiku.915d49f.png";

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIYAAAAiCAYAAACa9KFpAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAOySURBVHhe7ZxLbhRLEEVrOSA2g57EXpAYsBUGjN5KmDBjZBuMDTY8gWXUbRoZCxJOS1e6BJFV7X40vwqkQ1VGRkbG53Z7ZA/t67+rq6t2evqqPTs8bHt7e8UMYfYnJ6ft8vISSbQBUWB8/XbRzhYf27tVK2YIs//vbNkOnx+txTHwTYEoMudifrx596EdHR234eDgoJ2//5Q6FfOEHy0D/2WbxXwpYRQpJYwipYRRpJQwipQSRpFSwihSthLGo8dP2u1/7nxju3HzVnvw8N/1+zAMax/fF9jx5R1/fHvcvXf/u/MOOUz5wJQfe5vGUY0ZU/VEYg97eWKLvrtm628ML4JhU6j2eN9EGNAr2mMo/qZ4fOg1XLA3ti+UR682hOG1SCju43ux7l6evR7tkq2FASqaxDWUDBXVs/P0wtnbZFCcGfNDIPHOqVwVLzs7BoOOw878gDv+amEIivVPUVw72OMnGihcjaNpcR+b9qeIZ7FlDRfZPjl6Hvq2cJ+ID5vz4H1QDdFXeA+m8Nx2wVbCUHI9FbN3HWF4PL33zjv4jw0cNAzFj/vYsjgShs6OobgaNmhwioMNX9Ulm+4D1lP1/Cy2/sZQYRQSG5WhRtGY3p5DQ7Wnpl4HxeQsschTT93hNcSBaKDyY+37GYrnNtUBLvbMV7m47Vfxv4XhNor39/ipV4N6TSaehtGDs/FezhA3NpX78fWG624JlPcpYXgtPHv5qyeq088B52TnvlhHPBvxWLvmhwnDGw1eiDfZG6szPXwAY77kEfMBznMOuw9esXiy7gmDfeLG+yK6N+bgZ2XzvZgva+xuE8on29sFP0QYarQ3l7UK8XeePnBnrDGCsx4PuBebkF358VRuGlY8H4URfcRY/tmwgTPE83OZ79jwx/Z2wdbCoChQo+NA2cMeG+KN5SmfHhpYHL7DXcQih6zhrDmvAcUGR2EoR9W2CfFurw27YouYJ2v1JYO9314YFORkPj1cGBFiZU0ECcPvi83VILQW+PjgI1EYY/5j+cd8hItEZ7Pce7XDHyEMb4wGNgVFq0FZ8wB71hzu8DvxU9w4QNYxPuvoxz2KAWo6T9bu60wJw2NOoTyznCN/hDCKHIQxNWBxHd9fQQmjSClhFCkljCKlhFGklDCKlBJGkbIWxv7+fjt//zl1KObJWhgvXr5sb85XqUMxP/itd/76wbBardrzo+N2trxKHYv5wC+3H784acvlsq3/cMrFxUV7+vTZ+iukmC/85YPFYvFVEa19AbbJzs2ita7sAAAAAElFTkSuQmCC"

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKwAAAA4CAIAAADvpITaAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAFTUlEQVR4nO2cP2gbZxiHf99noXMkS4OQI18lx5ggQghChhRKE5JChAxNx0ydqsFLWrykW5bSJWO2ksWDoHPWFCKUoYF0CliIEGI3CNcXXZQ75EYnOdaf03UQmMSSzid9d00c3me0f37fT9yD77t778S63S6Ik4NhGLquA5ifn5+bmxMvWKlUfOJViP+NVqul6/rg2GuaxhgLBoOCNS3LIglODAcHB5qmBYNBWZYBVKtVTdNmZmZmZ2dFyjLGuEsrJLyl2+2qqipJ0sAAALIsS5KkqqrgCd2yLJLgBGCapqqqfr8/Ho8zxgY/ZIzF43G/36+qqmmaIvVJgk8dy7IURRkccs4/OF6c84EWiqJYljVdfTodnAAODfD5RmzgfD7foQdTtyAJPmmq1appmrIs+/3+cRm/3y/Lsmma1Wp1ui7s7du3tVpt2kUS3sIYW1hYcHI/oNlsvn79eoqTAuecbW1tBQKBUCg01SIJb5EkSZIkh+F2u91utyeqbxhGq9XyAQiFQuFweOIFEp8YExlzyP7+Pu0JCNoYEiQBAZKAAElAgCQgQBIQIAkIkAQESAICJAEBkoAASUAAcOlpY0VBsYhSCboOANEo0mlkMkgk3Kk/EuMZdjbw5iH2/wGAwBmcXsXSGkIXvOupNDrFl41S7Z2+3wMQDfjSsVOZs+FEeOxDH+LstNTCqydP68/1dh1AVIpcjJzPxi8tBWVX6rOtra1YLDb9KLnXQz6PQgH9/tFfcY5sFrkcRj0XJYTVQfkWKveAoabgWL6J1F0wl49Kr4/8pl7YNvo4+uAGB8smQ7mVqM/tf6w9y9zYvv9g93F/6JNy8OuLV9aSN3xsZur6jUajVquJSdDr4c4dlMt2mVQKt2+76YHVwV/fQntkl5m/hq//cNGDXh93/qyWawc2mVRs9vbVL1z0oGeZv2z+Vqq/sMmkI+d+Xflpag8GEogtOZ8/xgAA5TLyeaEuRwveOsYAANojlG+52DO/qdsbAKBcO8hv6i423di+b28AgFL9xcb2fcFGAhIoCgoFR8lCAQLPwn6A8QyVe46SlXswnrnSU2l0CtuGk2Rh21AaHVea7rTUB7uPnSQf7D7eaakivQQkKBZH7ANG0u+jWJy+0fvsbIzaB4zuip0NV3oWXzaG9wFjWlrFlw1XmhZePRneB4xp2i+8eiLSS0CCUsmrsA1vHnoVHk+p9s6jsA1P6889Cg8jIIE+yflvorANg6tBL8LjGVwNehG2q9OuexQehm4WESISRKNehW0InPEqPJ5oYILr24nCdnWkiEfhYQQkSKe9CttwetWr8HjSsVMehW24GDnvUXgYAQkyGXBnf845MpnpG73P0prjNXMsrbnSM3M2zMGctWSZs+68xpONX+LOPikHz8YvifQSkCCRQDbrKJnNujZECF3A8k1HyeWbbg0REmF/NunoNb1sMuTWEGEpKF9fvOIkeX3xiuAQQWxjmMshlTomk0ohlxPqcrTgXcxfOyYzfw2puy72zK1EU7FjvhUmFZvNrbi09QEArCVvpCPn7DPpyLm15A3BRjPr6+tzc3NTvMMGAJzj8mU0m6hUMPw+LOdYXcX6ussDJDaDxPfo7OHfpxhxD4dj+Udc/N3dARJnuHwm1OyalXpnVEu2mgyvfxVzd4DEGf9m4ctmb//vxq41YmrFv1u8+vOFH0QGSO12u9VqCU8RB9Ao+WSOkt2YIhInHDemiMRnAUlAkAQESUCAJCBAEhAgCQiQBARIAgIkAQGSgABJQIAkIDB4K9kwHL1eQ3x+GIZhWRbTNG1vb+9jL4b4aHDO/wOxcQBU2Jg1NwAAAABJRU5ErkJggg=="

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tjsp.ed90655.png";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tjsp2.566a10b.png";

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/undealuser.4b66595.png";

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAAkCAIAAABQa6LEAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAIVUlEQVR4nO1aT4jc1hn/dtR1l8XeMSyGrolZJLUhmJSStTq5OeCRcL3sxYfx9OZDkaaH9BKoNeNAMS2NZhzooT5phro3L/Lck4OktphCYSscSNOsk0ZP3amLE9ZLvWvierxZJ4cv+/yif6Px2Eyn6HdYJM2np+/p/d7v+6Od2t7eBoD19fWrV6/6vn/v3j3IkSMZhw8fFkXx3LlzpVIJAKa2t7evX79+7dq1nZ2dcfuWY2JQLBZLpdLFixe55eXlK1eu5OzJMRT6/f7W1laxWOQAoNfrjdufHJOHfr8fBAE3Ozu7t7c3bmdyTCTu379f6Pf743YjxwSjMG4Hckw2cgLlGAk5gXKMhJxAOUbC0AQSlxbOvPnya635V956/Mpbj19rzZ9582VxaeF5OPfU4Hne8zye5/HU87xyuZzllujxQFiWlWTM87xlWUk3qqrq7UNV1ZRHqKqK4xiGkW5J7Q3DGGj2TPCt7KbTM5xy4aWN6bUefAKPvr54d68HM72Zs7C8UrIv39p9mNYRsCxLFMUsz7Jtu9Fo8Dzf7XYlSQIAnuc1TWs0GnSodrvtui4A4DvtdDqxQyF10DKE6MKzV0K/mqYZfQSuk23bhmFQ31gQQjzPkyQJ5xKaI05tIAgheNBut5vNpizL1Wo1y42xQE90XY99J8MiK4GmZ7hTl17Y2F1LMtiYXjt16fgfLt1O4VC1WjUMgxCCK6GqqiAIjUaDZQMAoA0e27bteV6lUgEAQRBUVQ2toqqqtVrNNE0AKJfLrVYrtCqyLNu2HesPaxkiKz0GAMuyYhfMMAxFUdDM8zw6L4ogCJBV6Db7OMuy6ByzIwiCarVK1TS6IZEWgiAMO/JTIyuBlAsvpbAHcXv3Q+VC6Z1f/n1YJwghgiBQAgmC4DgO7C8AIaTZbFar1Xq93u12CSHUkuf5Wq2Wso95nlcUBQDwL4tKpSIIgizLuMZBENBx6DGKR7vdjgoMxhR6iyRJnufhfgg9KFaZkoD7IfankCLquo60pvswJHLslFHRs7uRHZkIJC4tbEwPYA9iY3pNXPquf/NOik2tVqPvCLUBCfTkcaLI7s5Op4M7OwgC0zRlWaYEYlc9FpqmwTeVhlU7fGg0uLCgy+Y4Dn2u53nRJZEkybKsJLmKhktRFFmu0JgSHblcLmuaNjBs0beBgZUOEsqHgiBIH2coZCLQi2fme/BJ0q+FKe7s915/f/PGP/7zHhqnE4gmE7h1AIAQIssy/loul33fx0lG1ykp0YmFIAi4C3mep28txE6KWCJG2YAKkZRAVKtVTI1N03Qch/JSkqTQ+JZlOY6TcTqEkIy5I3tLyukzRCYCPZi7Q7PmEApT3E9/cPnVhWWy/f4T4yHhum6r1cJllmUZ4xcASJJULpc9z9N1nRAS0olWq0WPYyValmXTNDFO4VJhXRa7BaM6hHkV3oIx1DAMQRCoV7FzMU0TpUiW5djceSAURWGjD86dNcAXkpICC4Lw/BgTQiYC7ext0uPj86+S7Q8efvE5MOz5/Qe/eO+zPzLGad2BaAjDA1xmRVEwZUa4rksTW0jQiaSStd1uB0GgqiolkCzLvu+zNuxq+b5frVbZcg91UZZlXA/KUepVEkapktjNgLk5Mh43mGEYvu+nF1CiKLbbbXr6XPk0RBkPAIWpws+Wrnz6+T/f/utPHn7xgLLnT/8aYpNFQxgAOI6DikLjFyJUWCXt+6Q6CwA6nU6tVovKG+zzIEUk8L3Lssyux1MD50JP2RxoYD3v+74gCBiU2Q0WBe60Z1KiZ0EmAs1xR+7u9QDg8ZePf3vz9Tck8+c//N3d//679J0fRdkzxx0B2BrWD9d1bdvG9IK9LggCqxlZFCg2GDWbTcdxRFGk2hA1E0WREpSuE4oQrsdQ8SgpyoSmEBqTVQvaCAUAQoimaaIomqaZEoJ1XU9pWyT5MAoyEWh2ZwFmvv6ns/Wttd94tTckUyh+P1Z7ZncWBhKI3YuKoqAmYSgJiW1IM7IoULfbrVQq7Kp0Oh1ZlkPsDIKgUqk0m816vd5sNmE/hOGvWKUTQti7QkVfbNtpRNAWBuwXiUgXVGjbtlG8aZ1VLpdRxjA5w7ZFVKLGHMI+fndr5uyT0/WttV/95cfFbx/52+afY42TxqHLj01YtoGBBRdWLpVKhUZ9URTr9TodIV2BcPPhgCEDrGI0TUvRdlaBEIQQ27Zd141tdrPsyVhppwPn67ou7RBiIg/7/QjKA+SZ53m+77PvpNvtRiUqVMGhVsU21p8CmQjk37yzvFJiW0G9nY8APopaLu6W3rmZ2EiMXX7aSsb56LpOG+3sFsyCaCFGAwQ+GmtsmqWGsstQEs3zfKvVwgDKCgPCsiy2bY0XsfEY6xvW9un+a5qGUsoSEcf3fV/X9VarhX1U3FcsA9CMShR7HcauQABgX7516tLx27sfpti8MH3c/vWtoR6PYYtNF1zXxQA0MJyzahHKnBCapqGeUwpiT9IwDKyEsbwKRUn2doxx0Q+xKGmsA2yazz6RXqQepnympR9GKDBK0vdDQ3Oo1Ih+3mKfYts2azyw+zoUpk6cOJHRlH5Mjf11cXfwx9T/NWCfMOVjJ/t9gL50wzDYrnQIPM9j0whPsYmAp7E5U+i728RhCAIhxKWFF8/MP5i7g82hOe7I7M7Cx+9upXefc/y/YmgC5cjBIv+PxBwjISdQjpGQEyjHSMgJlGMkFDiOG7cPOSYYhWPHjo3bhxyTimKxWFhZWTl06NC4PckxeeA47uTJk4WVlZXFxcWDBw+O258ckwSO444ePapp2tTm5iYArK6urq6uPnqU8I+rOXIwOHDgwOnTp8+fP3/jxo2vAP1GExMqZ5hJAAAAAElFTkSuQmCC"

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/untagsuccessbg.8935649.png";

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xedk.4d67b6c.png";

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zyhh1.87d1767.png";

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zyhh2.82c9f3e.png";

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1286);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("482bf394", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7e465850\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StepPlayer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7e465850\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StepPlayer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.step-player[data-v-7e465850] {\n  display: flex;\n  gap: 16px;\n}\n.stage[data-v-7e465850] {\n  position: relative;\n  width: 100%;\n  aspect-ratio: var(--stage-ratio, 1.766);\n  height: auto;\n  user-select: none;\n}\n/* 旧浏览器兜底 */\n.stage[data-v-7e465850]::before {\n  content: '';\n  float: left;\n  padding-top: calc(100% / var(--stage-ratio, 1.766));\n}\n.stage[data-v-7e465850]::after {\n  content: '';\n  display: block;\n  clear: both;\n}\n.canvas[data-v-7e465850] {\n  position: absolute;\n  inset: 0;\n}\n.base-image[data-v-7e465850] {\n  width: 100% !important;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n.overlay-image[data-v-7e465850] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100% !important;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n  pointer-events: none;\n}\n.label[data-v-7e465850] {\n  position: absolute;\n  white-space: nowrap;\n}\n.extra-image[data-v-7e465850] {\n  position: absolute;\n  display: block;\n  object-fit: contain;\n  pointer-events: none;\n  box-shadow: 0 0px 16px rgba(0, 0, 0, 0.2);\n}\n.hotspot[data-v-7e465850] {\n  position: absolute;\n  box-sizing: border-box;\n  transition: background .18s ease, border-color .18s ease, box-shadow .18s ease, opacity .18s ease;\n}\n.field[data-v-7e465850] {\n  position: absolute;\n  display: flex;\n  align-items: center;\n}\n.field-input[data-v-7e465850] {\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  background: transparent;\n  padding: 0 6px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n.field-textarea[data-v-7e465850] {\n  resize: none;\n  padding-top: 6px;\n}\n.tip[data-v-7e465850] {\n  width: 260px;\n}\n.tip-title[data-v-7e465850] {\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n", ""]);

// exports


/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SceneTable_vue__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SceneTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SceneTable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SceneTable_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SceneTable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e87472d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SceneTable_vue__ = __webpack_require__(1290);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1288)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e87472d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SceneTable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e87472d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SceneTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/simulate/SceneTable.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2e87472d", Component.options)
  } else {
    hotAPI.reload("data-v-2e87472d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1289);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5699f50d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2e87472d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SceneTable.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2e87472d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SceneTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.scene-table[data-v-2e87472d] {\n  position: absolute;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n.scene-table-inner[data-v-2e87472d] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  border: 1px solid #ebeef5;\n}\n.scene-table-scroll[data-v-2e87472d] {\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.scene-table-main[data-v-2e87472d] {\n  min-width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 12px;\n  color: #303133;\n}\n.scene-table-main th[data-v-2e87472d],\n.scene-table-main td[data-v-2e87472d] {\n  box-sizing: border-box;\n  padding: 8px 10px;\n  border: 1px solid #ebeef5;\n  vertical-align: middle;\n  background: #fff;\n}\n.scene-table-main th[data-v-2e87472d] {\n  font-weight: 600;\n  text-align: left;\n  white-space: nowrap;\n  background: #f8fafc;\n}\n.col-select[data-v-2e87472d] {\n  width: 40px;\n  text-align: center !important;\n}\n.col-select.radio-select input[type=\"radio\"][data-v-2e87472d] {\n  appearance: radio;\n  -webkit-appearance: radio;\n  width: auto;\n  height: auto;\n  cursor: pointer;\n}\n.col-select input[type=\"checkbox\"][data-v-2e87472d] {\n  cursor: pointer;\n}\n.table-image-placeholder[data-v-2e87472d] {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  background: #f1f3f6;\n  border: 1px solid #dcdfe6;\n  border-radius: 2px;\n}\n.table-image[data-v-2e87472d] {\n  display: block;\n  width: 48px;\n  height: 48px;\n  margin: 0 auto;\n  object-fit: contain;\n  background: #fff;\n}\n.table-type-badge[data-v-2e87472d] {\n  display: inline-block;\n  min-width: 18px;\n  font-weight: 700;\n  text-align: center;\n}\n.badge-exchange[data-v-2e87472d] { color: #159de0;\n}\n.badge-return[data-v-2e87472d] { color: #f04444;\n}\n.badge-resend[data-v-2e87472d] { color: #d6ae00;\n}\n.table-cell-input[data-v-2e87472d] {\n  width: 100%;\n  height: 28px;\n  box-sizing: border-box;\n  padding: 0 8px;\n  border: 1px solid #dcdfe6;\n  border-radius: 2px;\n  outline: none;\n  font-size: 12px;\n}\n.scene-table-pagination[data-v-2e87472d] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 8px 10px;\n  border-top: 1px solid #ebeef5;\n  background: #fff;\n  font-size: 12px;\n  color: #606266;\n}\n.page-btn[data-v-2e87472d] {\n  min-width: 24px;\n  height: 24px;\n  padding: 0 6px;\n  color: #409eff;\n  background: #fff;\n  border: 1px solid #dcdfe6;\n  border-radius: 2px;\n  cursor: pointer;\n}\n.page-btn[disabled][data-v-2e87472d] {\n  color: #c0c4cc;\n  cursor: not-allowed;\n}\n.page-info[data-v-2e87472d] {\n  min-width: 20px;\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scene-table" }, [
    _c("div", { staticClass: "scene-table-inner" }, [
      _c("div", { staticClass: "scene-table-scroll" }, [
        _c(
          "table",
          { staticClass: "scene-table-main", style: _vm.tableStyle },
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm.selectable
                    ? _c("th", {
                        staticClass: "col-select",
                        class: { "radio-select": _vm.selectionType === "radio" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "th",
                      { key: column.key, style: _vm.columnStyle(column) },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(column.title) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.pagedRows, function(row) {
                return _c(
                  "tr",
                  { key: row[_vm.rowKey] || row.id },
                  [
                    _vm.selectable
                      ? _c(
                          "td",
                          {
                            staticClass: "col-select",
                            class: {
                              "radio-select": _vm.selectionType === "radio"
                            }
                          },
                          [
                            _c("input", {
                              attrs: {
                                type: _vm.selectionInputType,
                                name:
                                  _vm.selectionType === "radio"
                                    ? _vm.tableName
                                    : undefined,
                                disabled: _vm.selectionDisabled
                              },
                              domProps: { checked: _vm.isSelected(row) },
                              on: {
                                change: function($event) {
                                  return _vm.toggleRow(row, $event)
                                }
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.columns, function(column) {
                      return _c(
                        "td",
                        {
                          key: column.key,
                          style: [
                            _vm.columnStyle(column),
                            _vm.cellStyle(row, column)
                          ]
                        },
                        [
                          column.type === "image"
                            ? [
                                row[column.key]
                                  ? _c("img", {
                                      staticClass: "table-image",
                                      attrs: {
                                        src: row[column.key],
                                        draggable: "false"
                                      }
                                    })
                                  : _c("span", {
                                      staticClass: "table-image-placeholder"
                                    })
                              ]
                            : column.type === "badge"
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass: "table-type-badge",
                                    class: _vm.badgeClass(row, column)
                                  },
                                  [_vm._v(_vm._s(_vm.formatCell(row, column)))]
                                )
                              ]
                            : column.type === "input"
                            ? [
                                _c("input", {
                                  staticClass: "table-cell-input",
                                  attrs: {
                                    disabled: _vm.isCellInputDisabled(
                                      row,
                                      column
                                    )
                                  },
                                  domProps: { value: row[column.key] },
                                  on: {
                                    input: function($event) {
                                      return _vm.changeCell(row, column, $event)
                                    }
                                  }
                                })
                              ]
                            : column.type === "select"
                            ? [
                                _c(
                                  "select",
                                  {
                                    staticClass: "table-cell-input",
                                    attrs: {
                                      disabled: _vm.isCellInputDisabled(
                                        row,
                                        column
                                      )
                                    },
                                    domProps: { value: row[column.key] },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeCell(
                                          row,
                                          column,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("请选择")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(column.options || [], function(
                                      option
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: option.value || option,
                                          domProps: {
                                            value: option.value || option
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(option.label || option) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.formatCell(row, column)) +
                                    "\n              "
                                )
                              ]
                        ],
                        2
                      )
                    })
                  ],
                  2
                )
              }),
              0
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPagination
        ? _c("div", { staticClass: "scene-table-pagination" }, [
            _c(
              "button",
              {
                staticClass: "page-btn",
                attrs: { disabled: _vm.page <= 1 },
                on: {
                  click: function($event) {
                    return _vm.changePage(_vm.page - 1)
                  }
                }
              },
              [_vm._v("‹")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "page-info" }, [
              _vm._v(_vm._s(_vm.page))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "page-btn",
                attrs: { disabled: _vm.page >= _vm.totalPages },
                on: {
                  click: function($event) {
                    return _vm.changePage(_vm.page + 1)
                  }
                }
              },
              [_vm._v("›")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "page-total" }, [
              _vm._v("共 " + _vm._s(_vm.total) + " 条")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e87472d", esExports)
  }
}

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-player" }, [
    _c("div", { ref: "stage", staticClass: "stage", style: _vm.stageStyle }, [
      _c(
        "div",
        { staticClass: "canvas", style: _vm.canvasStyle },
        [
          _vm.resolvedImage
            ? _c("img", {
                staticClass: "base-image",
                attrs: { src: _vm.resolvedImage, draggable: "false" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.resolvedOverlayImage
            ? _c("img", {
                staticClass: "overlay-image",
                style: _vm.overlayStyle,
                attrs: { src: _vm.resolvedOverlayImage, draggable: "false" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.resolvedLabels, function(label) {
            return [
              _c(
                "div",
                {
                  key: label.id,
                  staticClass: "label",
                  style: [_vm.rectStyle(label), _vm.labelStyle(label)]
                },
                [_vm._v("\n          " + _vm._s(label.text) + "\n        ")]
              )
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.resolvedExtraImages, function(img) {
            return [
              _c("img", {
                key: img.id,
                staticClass: "extra-image",
                style: [_vm.rectStyle(img), _vm.extraImageStyle(img)],
                attrs: { src: img.src, draggable: "false" }
              })
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.resolvedHotspots, function(hotspot) {
            return [
              _c("div", {
                key: hotspot.id,
                staticClass: "hotspot",
                style: [_vm.rectStyle(hotspot), _vm.hotspotStyle(hotspot)],
                on: {
                  mouseenter: function($event) {
                    return _vm.onEnter(hotspot)
                  },
                  mouseleave: function($event) {
                    return _vm.onLeave(hotspot)
                  },
                  click: function($event) {
                    return _vm.onClick(hotspot)
                  },
                  contextmenu: function($event) {
                    $event.preventDefault()
                    return _vm.onContextMenu(hotspot)
                  },
                  dblclick: function($event) {
                    $event.preventDefault()
                    return _vm.onDblClick(hotspot)
                  }
                }
              })
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.resolvedFields, function(field) {
            return [
              _c(
                "div",
                {
                  key: field.id,
                  staticClass: "field",
                  style: [_vm.rectStyle(field), _vm.fieldStyle(field)],
                  attrs: { "data-field-id": field.id }
                },
                [
                  field.type === "label"
                    ? _c(
                        "div",
                        {
                          staticClass: "field-label",
                          style: _vm.fieldLabelStyle(field)
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.form[field.model]) +
                              "\n          "
                          )
                        ]
                      )
                    : field.type !== "textarea" && field.type !== "select"
                    ? _c("input", {
                        staticClass: "field-input",
                        style: _vm.fieldInputStyle(field),
                        attrs: {
                          type: field.type || "text",
                          placeholder: field.placeholder,
                          autocomplete: field.autocomplete || "off",
                          "data-field-id": field.id
                        },
                        domProps: { value: _vm.form[field.model] },
                        on: {
                          input: function($event) {
                            return _vm.onFieldInput(field, $event)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.onEnterSubmit(field)
                          }
                        }
                      })
                    : field.type === "select"
                    ? _c(
                        "select",
                        {
                          staticClass: "field-input field-select",
                          style: _vm.fieldInputStyle(field),
                          attrs: { "data-field-id": field.id },
                          domProps: { value: _vm.form[field.model] },
                          on: {
                            change: function($event) {
                              return _vm.onFieldInput(field, $event)
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(field.placeholder || "请选择"))
                          ]),
                          _vm._v(" "),
                          _vm._l(field.options || [], function(option) {
                            return _c(
                              "option",
                              {
                                key: option.value || option,
                                domProps: { value: option.value || option }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.label || option) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _c("textarea", {
                        staticClass: "field-input field-textarea",
                        style: _vm.fieldInputStyle(field),
                        attrs: {
                          placeholder: field.placeholder,
                          "data-field-id": field.id
                        },
                        domProps: { value: _vm.form[field.model] },
                        on: {
                          input: function($event) {
                            return _vm.onFieldInput(field, $event)
                          }
                        }
                      })
                ]
              )
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.resolvedTables, function(table) {
            return [
              _c("SceneTable", {
                key: table.id,
                style: _vm.rectStyle(table),
                attrs: { config: table },
                on: {
                  "selection-change": function($event) {
                    return _vm.onTableSelectionChange(table, $event)
                  },
                  "cell-change": function($event) {
                    return _vm.onTableCellChange(table, $event)
                  },
                  "page-change": function($event) {
                    return _vm.onTablePageChange(table, $event)
                  }
                }
              })
            ]
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm.showTip
      ? _c(
          "div",
          { staticClass: "tip" },
          [
            _vm._t("tip", function() {
              return [
                _c("div", { staticClass: "tip-title" }, [_vm._v("提示")]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "tip-body",
                  domProps: { innerHTML: _vm._s(_vm.resolvedTip) }
                })
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e465850", esExports)
  }
}

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "max-width": "100%" }, attrs: { id: "newQianniuex" } },
    [
      _c("input", {
        ref: "fileInputSix",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".csv" },
        on: { change: _vm.onSixFileChange }
      }),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("1、登录拼多多商家版")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src: "http://res.study.itaojin.cn/pdd1.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFirst",
                      attrs: {
                        steps: _vm.scenarioConfig.first.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.first.initialStepId,
                        "initial-form": _vm.scenarioConfig.first.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("first")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("first", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "first",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tip-body" },
                    [
                      _vm.tabCurrent === "first" &&
                      _vm.currentStepId.first === "login2"
                        ? [
                            _c("p", [_vm._v("1.复制粘贴账号和密码")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("2.自动登录不要勾选")]),
                            _vm._v(" "),
                            !_vm.showLoginPassword
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        _vm.showLoginPassword = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t获取账号密码\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showLoginPassword
                              ? [
                                  _c("p", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-weight": "normal"
                                        }
                                      },
                                      [_vm._v("账号：淘金云客服:小淘")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-weight": "normal"
                                        }
                                      },
                                      [_vm._v("密码：Tj1234")]
                                    )
                                  ])
                                ]
                              : _vm._e()
                          ]
                        : [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.rightTip.first)
                              }
                            })
                          ]
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "stoptip",
                staticStyle: { height: "696px" },
                attrs: { id: "studytip-first" }
              },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-登录拼多多商家版.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.first
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("first", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("first")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("2、基础设置")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src: "http://res.study.itaojin.cn/pdd2.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSecond",
                      attrs: {
                        steps: _vm.scenarioConfig.second.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.second.initialStepId,
                        "initial-form": _vm.scenarioConfig.second.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("second")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("second", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "second",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.second) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-基础设置.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.second
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("second", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("second")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("3、订单管理")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src: "http://res.study.itaojin.cn/pdd3.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerThird",
                      attrs: {
                        steps: _vm.scenarioConfig.third.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.third.initialStepId,
                        "initial-form": _vm.scenarioConfig.third.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("third")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("third", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "third",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.third) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-订单管理常用功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.third
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("third", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("third")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("4、会话窗口常用功能")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src: "http://res.study.itaojin.cn/pdd4.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFour",
                      attrs: {
                        steps: _vm.scenarioConfig.four.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.four.initialStepId,
                        "initial-form": _vm.scenarioConfig.four.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("four")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("four", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "four",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.four) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-会话窗口常用功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.four
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("four", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("four")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("5、插件常用功能")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src: "http://res.study.itaojin.cn/pdd5.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFive",
                      attrs: {
                        steps: _vm.scenarioConfig.five.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.five.initialStepId,
                        "initial-form": _vm.scenarioConfig.five.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("five")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("five", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "five",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.five) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-插件常用功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.five
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("five", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("five")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、添加快捷回复")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src: "http://res.study.itaojin.cn/pdd6.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSix",
                      attrs: {
                        steps: _vm.scenarioConfig.six.steps,
                        "initial-step-id": _vm.scenarioConfig.six.initialStepId,
                        "initial-form": _vm.scenarioConfig.six.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("six")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("six", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "six",
                            stepId,
                            step,
                            resolvedTip
                          )
                        },
                        "request-file": _vm.onRequestFile,
                        "download-file": _vm.downloadKjdyFile
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.six) }
                  }),
                  _vm._v(" "),
                  _vm.rightTip.third && _vm.rightTip.six.indexOf("下载") !== -1
                    ? _c("p", [
                        _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                          _vm._v("点击下载“快捷短语.csv”")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-添加快捷回复.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.six
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("six", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("six")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("7、退出账号")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src: "http://res.study.itaojin.cn/pdd7.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSeven",
                      attrs: {
                        steps: _vm.scenarioConfig.seven.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.seven.initialStepId,
                        "initial-form": _vm.scenarioConfig.seven.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("seven")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("seven", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "seven",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.seven) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成拼多多的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《拼多多模拟实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px" },
                          attrs: { href: "/tjkStudy/simulate/pddExam" }
                        },
                        [_vm._v("去完成拼多多模拟实操")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-退出账号.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.seven
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("seven", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("seven")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer7" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7478846", esExports)
  }
}

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddExam_vue__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a510688a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pddExam_vue__ = __webpack_require__(1296);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1294)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a510688a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pddExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a510688a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pddExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/pddExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a510688a", Component.options)
  } else {
    hotAPI.reload("data-v-a510688a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1295);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("03ad2e37", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a510688a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pddExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a510688a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pddExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n[data-v-a510688a] .el-tabs__content {\n  height: 100% !important;\n}\n.con-left[data-v-a510688a] {\n  background: none !important;\n  flex: 1 1 auto;\n  min-width: 1;\n}\n.con-right[data-v-a510688a] {\n  width: 170px;\n  flex: 0 0 170px;\n}\n.stoptip[data-v-a510688a] {\n  width: 100% !important;\n  height: 100% !important;\n}\n", ""]);

// exports


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "max-width": "100%" }, attrs: { id: "newQianniuExamex" } },
    [
      _c("input", {
        ref: "fileInputSix",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".csv" },
        on: { change: _vm.onSixFileChange }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs el-tabs--left" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "el-tabs__content" }, [
          _c(
            "div",
            { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
            [
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始实操练习")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-first" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerFirst",
                        attrs: {
                          steps: _vm.scenarioConfig.first.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.first.initialStepId,
                          "initial-form": _vm.scenarioConfig.first.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("first")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("first", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "first",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tip-body" },
                      [
                        _vm.tabCurrent === "first" &&
                        _vm.currentStepId.first === "login2"
                          ? [
                              _c("p", [_vm._v("1.复制粘贴账号和密码")]),
                              _vm._v(" "),
                              _c("p", [_vm._v("2.自动登录不要勾选")]),
                              _vm._v(" "),
                              !_vm.showLoginPassword
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          _vm.showLoginPassword = true
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t获取账号密码\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showLoginPassword
                                ? [_vm._m(2), _vm._v(" "), _vm._m(3)]
                                : _vm._e()
                            ]
                          : [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.rightTip.first)
                                }
                              })
                            ]
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "stoptip",
                  staticStyle: { height: "696px" },
                  attrs: { id: "studytip-first" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-second", 2, "second")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "second" },
              attrs: { id: "tab-second-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-second" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-second" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerSecond",
                        attrs: {
                          steps: _vm.scenarioConfig.second.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.second.initialStepId,
                          "initial-form": _vm.scenarioConfig.second.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("second")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("second", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "second",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.second) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-second" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-third", 3, "third")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "third" },
              attrs: { id: "tab-third-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-third" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-third" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerThird",
                        attrs: {
                          steps: _vm.scenarioConfig.third.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.third.initialStepId,
                          "initial-form": _vm.scenarioConfig.third.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("third")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("third", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "third",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.third) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-third" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-four", 4, "four")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "four" },
              attrs: { id: "tab-four-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-four" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-four" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerFour",
                        attrs: {
                          steps: _vm.scenarioConfig.four.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.four.initialStepId,
                          "initial-form": _vm.scenarioConfig.four.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("four")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("four", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "four",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.four) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-four" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-five", 5, "five")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "five" },
              attrs: { id: "tab-five-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-five" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-five" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerFive",
                        attrs: {
                          steps: _vm.scenarioConfig.five.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.five.initialStepId,
                          "initial-form": _vm.scenarioConfig.five.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("five")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("five", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "five",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.five) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-five" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-six", 6, "six")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "six" },
              attrs: { id: "tab-six-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-six" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-six" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerSix",
                        attrs: {
                          steps: _vm.scenarioConfig.six.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.six.initialStepId,
                          "initial-form": _vm.scenarioConfig.six.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("six")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("six", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "six",
                              stepId,
                              step,
                              resolvedTip
                            )
                          },
                          "request-file": _vm.onRequestFile,
                          "download-file": _vm.downloadKjdyFile
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.six) }
                    }),
                    _vm._v(" "),
                    _vm.rightTip.six && _vm.rightTip.six.indexOf("下载") !== -1
                      ? _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-six" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-seven", 7, "seven")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "seven" },
              attrs: { id: "tab-seven-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-seven" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-seven" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerSeven",
                        attrs: {
                          steps: _vm.scenarioConfig.seven.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.seven.initialStepId,
                          "initial-form": _vm.scenarioConfig.seven.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("seven")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("seven", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "seven",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.seven) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.goBack }
                        },
                        [_vm._v("返回")]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录拼多多商家版")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、基础设置")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("3、订单管理")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("4、会话窗口常用功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、插件常用功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、添加快捷回复")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("7、退出账号")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("账号：淘金云客服:小淘")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("密码：Tj1234")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a510688a", esExports)
  }
}

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpStudy_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpStudy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpStudy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpStudy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpStudy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60605782_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_juShuiTanErpStudy_vue__ = __webpack_require__(1382);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1298)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60605782"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpStudy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60605782_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_juShuiTanErpStudy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/juShuiTanErpStudy.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60605782", Component.options)
  } else {
    hotAPI.reload("data-v-60605782", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1299);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b90d49de", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60605782\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./juShuiTanErpStudy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60605782\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./juShuiTanErpStudy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#jushuitanStudy[data-v-60605782] {\n  position: relative;\n  box-sizing: border-box;\n  min-height: 100vh;\n  padding: 10px;\n  color: #454545;\n  background: #f1f5f8;\n}\n[data-v-60605782] .el-tabs__content {\n  min-height: calc(80vh);\n  overflow: visible;\n}\n[data-v-60605782] .el-tabs__header.is-left {\n  min-height: calc(80vh);\n  margin-right: 10px;\n}\n[data-v-60605782] .el-tabs__item {\n  box-sizing: border-box;\n  width: 180px;\n  height: auto;\n  padding: 10px;\n  color: #454545;\n  text-align: center;\n}\n[data-v-60605782] .el-tabs__item.is-active {\n  color: #fff;\n  background: #4c75f1;\n}\n[data-v-60605782] .el-tabs__item.is-active .hover-con {\n  display: block;\n}\n[data-v-60605782] .el-tabs__active-bar {\n  background: #4c75f1;\n}\n.tab-slot p[data-v-60605782] {\n  margin: 0;\n  line-height: 30px;\n}\n.tab-slot .title[data-v-60605782] {\n  text-align: left;\n}\n.hover-con[data-v-60605782] {\n  display: none;\n}\n[data-v-60605782] .el-tabs__item.is-active .hover-con {\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.hover-con p[data-v-60605782] {\n  width: 100%;\n  margin: 0;\n  text-align: center;\n}\n.hover-con .el-icon-video-play[data-v-60605782] {\n  display: block;\n  font-size: 36px;\n  line-height: 42px;\n}\n.video-box[data-v-60605782] {\n  position: relative;\n  width: 100%;\n  line-height: 0;\n  background: #000;\n}\n.video[data-v-60605782] {\n  display: block;\n  width: 100%;\n  max-height: calc(80vh);\n}\n.startvideo[data-v-60605782],\n.stoptip[data-v-60605782] {\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 598px;\n  height: calc(80vh);\n  color: #2b2b2b;\n  text-align: center;\n  background: rgba(127, 127, 127, 0.5);\n}\n.startvideo .tip[data-v-60605782],\n.stoptip .tip[data-v-60605782] {\n  box-sizing: border-box;\n  width: 360px;\n  min-height: 240px;\n  padding: 45px 26px;\n  font-size: 16px;\n  font-weight: bold;\n  background: #fff;\n  border-radius: 5px;\n}\n.startvideo .tip > p[data-v-60605782],\n.stoptip .tip > p[data-v-60605782] {\n  margin: 15px 0;\n}\n.startvideo .el-icon-video-play[data-v-60605782] {\n  color: #4c75f1;\n  font-size: 36px;\n}\n.stoptip > .tip > span[data-v-60605782] {\n  color: #3fde3f;\n  font-size: 40px;\n}\n.startstudy[data-v-60605782],\n.restart[data-v-60605782] {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 130px;\n  height: 38px;\n  color: #fff;\n  line-height: 36px;\n  background: #4c75f1;\n  border: 1px solid #4c75f1;\n  cursor: pointer;\n}\n.restart[data-v-60605782] {\n  margin-right: 5px;\n  color: #4c75f1;\n  background: #fff;\n}\n.restart .el-icon-refresh-left[data-v-60605782] {\n  padding-right: 5px;\n  font-size: 20px;\n  vertical-align: -2px;\n}\n.content[data-v-60605782] {\n  display: flex;\n  min-height: calc(-42vh);\n  color: #2b2b2b;\n  background: #f1f5f8;\n}\n.con-left[data-v-60605782] {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: auto;\n  background: #fff;\n}\n.con-right[data-v-60605782] {\n  flex: 0 0 170px;\n  box-sizing: border-box;\n  min-width: 0;\n  min-height: calc(-42vh);\n  padding: 10px;\n  margin-left: 10px;\n  overflow: auto;\n  font-size: 14px;\n  line-height: 26px;\n  overflow-wrap: anywhere;\n  word-break: break-all;\n  background: #fff;\n}\n.con-right .compact-tip[data-v-60605782] {\n  font-size: 12px;\n  line-height: 20px;\n}\n.con-right h3[data-v-60605782] {\n  margin: 0 0 12px;\n  font-size: 16px;\n}\n.con-right p[data-v-60605782] {\n  margin: 0 0 8px;\n}\n.con-right[data-v-60605782] * {\n  box-sizing: border-box;\n  max-width: 100%;\n}\n.con-right .el-button--primary[data-v-60605782] {\n  background: #4c75f1;\n  border-color: #4c75f1;\n}\n.credential[data-v-60605782] {\n  color: red;\n  font-weight: normal;\n}\n.line[data-v-60605782] {\n  display: inline-block;\n  width: 4px;\n  height: 20px;\n  margin-right: 2px;\n  vertical-align: text-bottom;\n  background: #4c75f1;\n}\n.practice-finish[data-v-60605782] {\n  z-index: 20;\n}\n.study-box[data-v-60605782] {\n  float: left;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 10px;\n  margin-top: 10px;\n  background: #fff;\n}\n.study-box h3[data-v-60605782] {\n  margin: 0 0 4px;\n  font-size: 16px;\n}\n.img-box[data-v-60605782] {\n  display: block;\n  float: left;\n  width: 40px;\n  padding-top: 15px;\n  margin-bottom: 10px;\n}\n.con-box[data-v-60605782] {\n  padding-top: 10px;\n  padding-left: 50px;\n  margin-bottom: 10px;\n}\n.con-box p[data-v-60605782] {\n  margin: 0;\n  line-height: 24px;\n}\n.btn-open[data-v-60605782] {\n  display: inline-block;\n  padding: 2px 15px;\n  margin-top: 5px;\n  color: #fff;\n  background: #4c75f1;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.startbtn[data-v-60605782] {\n  margin-top: 22px;\n  margin-right: 10px;\n  background: #4c75f1;\n  border-color: #4c75f1;\n}\n@media (max-width: 860px) {\n#jushuitanStudy[data-v-60605782] {\n    min-width: 760px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1301);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d4e83378", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31178041\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpLoginScene.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31178041\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpLoginScene.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.jst-erp-scene[data-v-31178041] {\n  width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  color: #303133;\n  text-align: left;\n  background: #fff;\n}\n[data-v-31178041] .step-player {\n  display: block;\n  width: 100%;\n}\n[data-v-31178041] .step-player .stage {\n  width: 100%;\n  min-height: 420px;\n  overflow: hidden;\n  background-color: #eef2f7;\n}\n[data-v-31178041] .step-player .hotspot {\n  z-index: 3;\n}\n[data-v-31178041] .step-player .field {\n  z-index: 4;\n  border-radius: 2px;\n}\n[data-v-31178041] .step-player .field-input {\n  color: #303133;\n  background: rgba(255, 255, 255, 0.01);\n}\n", ""]);

// exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJstErpScenario = getJstErpScenario;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _jstErpGoodsData = __webpack_require__(1303);
var _jstTip = __webpack_require__(302);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * 聚水潭 ERP 第一章截图场景。
 *
 * 图片、步骤提示、热区和表单校验统一在这里维护；页面组件只负责挂载 StepPlayer。
 * 将截图放入 `src/assets/images/jushuitan/scenes/` 后，仅替换下面
 * SCENE_IMAGES 中的三个路径即可，不需要改动热区流程代码。
 *
 * 推荐图片：
 * - login：完整登录页截图
 * - home：登录成功后首页截图
 * - done：点击“订单”后的成功页面截图（首版也可与 home 相同）
 */
function r(path) {
  return __webpack_require__(303)("./" + path);
}
var ALL_GOODS = (0, _jstErpGoodsData.getGoodsList)();
var TARGET_GOODS = ALL_GOODS[0];
var TARGET_GOODS_CODE = TARGET_GOODS.goodsCode;
var AFTERSALE_ISSUE_TYPES = ['尺码拍错/不喜欢/效果差', '商品质量问题', '重复购买', '大小尺寸与商品描述不符', '不想买了', '买错了', '其他', '服务承诺或态度'];
var SCENE_IMAGES = {
  login: r('jst_login.png'),
  home: r('1-0.png'),
  home_click: r('1-1.png'),
  fast: r('1-2.png'),
  noinfo: r('1-3.png'),
  noinfo_goods: r('1-4.png'),
  noinfo_done: r('1-5.png')
};
function getJstErpScenario() {
  return {
    initialStepId: 'login',
    initialForm: {
      loginAccount: '',
      loginPassword: '',
      loginAgreement: false,
      goodsCode: '',
      goodsNum: 0,
      goodsCodes: '',
      returnExpress: '',
      returnWaybill: '',
      returnWarehouse: '',
      aftersaleIssueType: ''
    },
    steps: [{
      id: 'login',
      image: SCENE_IMAGES.login,
      aspectRatio: 2,
      tip: '登录聚水潭' + (0, _jstTip.br)() + '账号：' + (0, _jstTip.red)('taojinyun-jst') + (0, _jstTip.br)() + '密码：' + (0, _jstTip.red)('Tj123456'),
      fields: [{
        id: 'login-account',
        model: 'loginAccount',
        type: 'text',
        placeholder: '邮箱地址/手机号',
        bgColor: '#fff',
        fontSize: 12,
        x: 0.614,
        y: 0.369,
        w: 0.179,
        h: 0.034,
        autoFocus: true,
        hideCaret: false
      }, {
        id: 'login-password',
        model: 'loginPassword',
        type: 'password',
        placeholder: '请输入密码',
        bgColor: '#fff',
        fontSize: 12,
        x: 0.614,
        y: 0.462,
        w: 0.179,
        h: 0.034
      }],
      labels: function labels(_ref) {
        var form = _ref.form;
        return form.loginAgreement ? [{
          id: 'login-agreement-check',
          text: '✓',
          color: '#1677ff',
          fontSize: 15,
          fontWeight: 'bold',
          x: 0.61,
          y: 0.531,
          w: 0.01,
          h: 0.022
        }] : [];
      },
      hotspots: [{
        id: 'login-agreement',
        x: 0.608,
        y: 0.53,
        w: 0.018,
        h: 0.024,
        highlight: 'primary',
        action: function action(_ref2) {
          var form = _ref2.form;
          return {
            setForm: {
              loginAgreement: !form.loginAgreement
            }
          };
        }
      }, {
        id: 'login-button',
        x: 0.61,
        y: 0.567,
        w: 0.193,
        h: 0.04,
        highlight: 'primary',
        guard: function guard(_ref3) {
          var form = _ref3.form;
          if (form.loginAccount !== 'taojinyun-jst') return {
            ok: false,
            msg: '请输入正确的登录账号'
          };
          if (form.loginPassword !== 'Tj123456') return {
            ok: false,
            msg: '请输入正确的登录密码'
          };
          if (!form.loginAgreement) return {
            ok: false,
            msg: '请先勾选阅读并同意协议'
          };
          return {
            ok: true
          };
        },
        next: 'home'
      }]
    }, {
      id: 'home',
      image: SCENE_IMAGES.home,
      aspectRatio: 2,
      tip: '进入' + (0, _jstTip.red)('售后极速版'),
      hotspots: [{
        id: 'home-menu',
        x: 0,
        y: 0.06,
        w: 0.03,
        h: 0.06,
        highlight: 'primary',
        next: 'home_click'
      }]
    }, {
      id: 'home_click',
      image: SCENE_IMAGES.home_click,
      aspectRatio: 2,
      tip: '进入' + (0, _jstTip.red)('售后极速版'),
      hotspots: [{
        id: 'topOrder',
        x: 0.294,
        y: 0.122,
        w: 0.084,
        h: 0.03,
        highlight: 'primary',
        next: 'fast'
      }, {
        id: 'common-fast-aftersale',
        x: 0.04,
        y: 0.524,
        w: 0.1,
        h: 0.032,
        highlight: 'primary',
        next: 'fast'
      }]
    }, {
      id: 'fast',
      image: SCENE_IMAGES.fast,
      aspectRatio: 2,
      tip: '登记无信息件' + (0, _jstTip.br)() + '商品' + (0, _jstTip.red)('TEST-GD-0001退回') + (0, _jstTip.br)() + '买家退回快递公司：' + (0, _jstTip.red)('圆通') + (0, _jstTip.br)() + '买家退回快递单号：' + (0, _jstTip.red)('YT8888888888') + (0, _jstTip.br)() + '退回仓库：' + (0, _jstTip.red)('淘金仓库') + (0, _jstTip.br)() + '售后问题类型：' + (0, _jstTip.red)('尺码拍错/不喜欢/效果差'),
      hotspots: [{
        id: 'noinfo-btn',
        x: 0.89,
        y: 0.52,
        w: 0.084,
        h: 0.03,
        highlight: 'primary',
        next: 'noinfo-goods-add'
      }]
    }, {
      id: 'noinfo-goods-add',
      image: SCENE_IMAGES.noinfo,
      aspectRatio: 2,
      tip: '登记无信息件' + (0, _jstTip.br)() + '商品' + (0, _jstTip.red)('TEST-GD-0001退回') + (0, _jstTip.br)() + '买家退回快递公司：' + (0, _jstTip.red)('圆通') + (0, _jstTip.br)() + '买家退回快递单号：' + (0, _jstTip.red)('YT8888888888') + (0, _jstTip.br)() + '退回仓库：' + (0, _jstTip.red)('淘金仓库') + (0, _jstTip.br)() + '售后问题类型：' + (0, _jstTip.red)('尺码拍错/不喜欢/效果差'),
      hotspots: [{
        id: 'noinfo',
        x: 0.14,
        y: 0.162,
        w: 0.084,
        h: 0.03,
        highlight: 'primary',
        next: 'noinfo-goods'
      }]
    }, {
      id: 'noinfo-goods',
      image: SCENE_IMAGES.noinfo_goods,
      aspectRatio: 2,
      tip: '登记无信息件' + (0, _jstTip.br)() + '商品' + (0, _jstTip.red)('TEST-GD-0001退回') + (0, _jstTip.br)() + '买家退回快递公司：' + (0, _jstTip.red)('圆通') + (0, _jstTip.br)() + '买家退回快递单号：' + (0, _jstTip.red)('YT8888888888') + (0, _jstTip.br)() + '退回仓库：' + (0, _jstTip.red)('淘金仓库') + (0, _jstTip.br)() + '售后问题类型：' + (0, _jstTip.red)('尺码拍错/不喜欢/效果差'),
      fields: [{
        id: 'goods-code',
        model: 'goodsCode',
        type: 'text',
        bgColor: '#FFFFFF',
        fontSize: 10,
        placeholder: '商品编码',
        x: 0.275,
        y: 0.22,
        w: 0.08,
        h: 0.02
      }, {
        id: 'goods-num',
        model: 'goodsNum',
        type: 'label',
        fontSize: 12,
        color: '#5045a8',
        x: 0.265,
        y: 0.305,
        h: 0.02
      }, {
        id: 'goods-codes',
        model: 'goodsCodes',
        type: 'label',
        fontSize: 12,
        color: '#5045a8',
        x: 0.285,
        y: 0.305,
        w: 0.53,
        h: 0.02
      }],
      tables: function tables(_ref4) {
        var ui = _ref4.ui,
          form = _ref4.form;
        var keyword = (form.goodsCode || '').trim().toUpperCase();
        var filtered = ui.goodsSearched && keyword ? ALL_GOODS.filter(function (g) {
          return g.goodsCode.toUpperCase().indexOf(keyword) !== -1 || g.goodsName.toUpperCase().indexOf(keyword) !== -1;
        }) : ALL_GOODS;
        var selectedRows = Array.isArray(ui['goods-tableSelectedRows']) ? ui['goods-tableSelectedRows'] : [];
        var selectedKeys = Array.isArray(ui['goods-tableSelectedKeys']) ? ui['goods-tableSelectedKeys'] : [];
        var selectedRowMap = selectedRows.reduce(function (map, row) {
          map[row.id] = row;
          return map;
        }, {});
        return [{
          id: 'goods-table',
          x: 0.215,
          y: 0.34,
          w: 0.605,
          h: 0.36,
          rows: filtered.map(function (row) {
            return selectedRowMap[row.id] ? _objectSpread(_objectSpread({}, row), {}, {
              quantity: selectedRowMap[row.id].quantity
            }) : row;
          }),
          selectedKeys: selectedKeys,
          columns: [{
            key: 'image',
            type: 'image',
            title: '图片',
            width: 60
          }, {
            key: 'goodsName',
            title: '商品名称',
            width: 180
          }, {
            key: 'goodsShortName',
            title: '商品简称',
            width: 140
          }, {
            key: 'quantity',
            type: 'input',
            title: '数量',
            width: 70,
            align: 'right'
          }, {
            key: 'price',
            title: '单价',
            width: 70,
            align: 'right'
          }, {
            key: 'goodsCode',
            title: '商品编码',
            width: 170
          }, {
            key: 'styleCode',
            title: '款式编码',
            width: 130
          }, {
            key: 'spec',
            title: '颜色及规格',
            width: 160
          }],
          selectable: true,
          rowKey: 'id',
          pageSize: 10,
          onSelectionChange: function onSelectionChange(_ref5) {
            var selectedKeys = _ref5.selectedKeys,
              selectedRows = _ref5.selectedRows,
              setForm = _ref5.setForm;
            setForm({
              goodsNum: selectedKeys.length,
              goodsCodes: selectedRows.map(function (r) {
                return r.goodsCode;
              }).join(',')
            });
          }
        }];
      },
      hotspots: [{
        id: 'goods-search',
        x: 0.744,
        y: 0.252,
        w: 0.032,
        h: 0.03,
        highlight: 'primary',
        guard: function guard(_ref6) {
          var form = _ref6.form;
          return String(form.goodsCode || '').trim().toUpperCase() === TARGET_GOODS_CODE.toUpperCase() ? {
            ok: true
          } : {
            ok: false,
            msg: '请输入正确的商品编码 ' + TARGET_GOODS_CODE
          };
        },
        set: {
          goodsSearched: true
        }
      }, {
        id: 'goods-confirm',
        x: 0.788,
        y: 0.722,
        w: 0.033,
        h: 0.03,
        highlight: 'primary',
        guard: function guard(_ref7) {
          var ui = _ref7.ui;
          return (ui['goods-tableSelectedKeys'] || []).includes(TARGET_GOODS.id) && ui.goodsSearched ? {
            ok: true
          } : {
            ok: false,
            msg: '请搜索并选中商品 ' + TARGET_GOODS_CODE
          };
        },
        next: 'done'
      }]
    }, {
      id: 'done',
      image: SCENE_IMAGES.noinfo_done,
      aspectRatio: 2,
      tip: '登记无信息件' + (0, _jstTip.br)() + '商品' + (0, _jstTip.red)('TEST-GD-0001退回') + (0, _jstTip.br)() + '买家退回快递公司：' + (0, _jstTip.red)('圆通') + (0, _jstTip.br)() + '买家退回快递单号：' + (0, _jstTip.red)('YT8888888888') + (0, _jstTip.br)() + '退回仓库：' + (0, _jstTip.red)('淘金仓库') + (0, _jstTip.br)() + '售后问题类型：' + (0, _jstTip.red)('尺码拍错/不喜欢/效果差'),
      fields: [{
        id: 'return-express',
        model: 'returnExpress',
        type: 'text',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '请输入',
        x: 0.207,
        y: 0.549,
        w: 0.21,
        h: 0.028
      }, {
        id: 'return-waybill',
        model: 'returnWaybill',
        type: 'text',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '请输入',
        x: 0.488,
        y: 0.549,
        w: 0.21,
        h: 0.028
      }, {
        id: 'return-warehouse',
        model: 'returnWarehouse',
        type: 'select',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '请选择',
        options: ['淘金仓库'],
        x: 0.739,
        y: 0.549,
        w: 0.24,
        h: 0.028
      }, {
        id: 'aftersale-issue-type',
        model: 'aftersaleIssueType',
        type: 'select',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '请选择',
        options: AFTERSALE_ISSUE_TYPES,
        x: 0.207,
        y: 0.587,
        w: 0.21,
        h: 0.028
      }],
      tables: function tables(_ref8) {
        var ui = _ref8.ui;
        var selectedRows = Array.isArray(ui['goods-tableSelectedRows']) ? ui['goods-tableSelectedRows'] : [];
        var selectedKeys = selectedRows.map(function (r) {
          return r.id;
        });
        return [{
          id: 'done-goods-table',
          x: 0.14,
          y: 0.2,
          w: 0.845,
          h: 0.32,
          rows: selectedRows,
          selectedKeys: selectedKeys,
          columns: [{
            key: 'image',
            type: 'image',
            title: '图片',
            width: 60
          }, {
            key: 'goodsName',
            title: '商品名称',
            width: 180
          }, {
            key: 'goodsShortName',
            title: '商品简称',
            width: 140
          }, {
            key: 'quantity',
            title: '数量',
            width: 70,
            align: 'right'
          }, {
            key: 'price',
            title: '单价',
            width: 70,
            align: 'right'
          }, {
            key: 'goodsCode',
            title: '商品编码',
            width: 170
          }, {
            key: 'styleCode',
            title: '款式编码',
            width: 130
          }, {
            key: 'spec',
            title: '颜色及规格',
            width: 160
          }],
          selectable: true,
          rowKey: 'id'
        }];
      },
      hotspots: [{
        id: 'save-aftersale',
        x: 0.958,
        y: 0.959,
        w: 0.033,
        h: 0.03,
        highlight: 'primary',
        guard: function guard(_ref9) {
          var form = _ref9.form;
          if (!String(form.returnExpress || '').trim()) return {
            ok: false,
            msg: '请填写买家退回快递公司'
          };
          if (!String(form.returnWaybill || '').trim()) return {
            ok: false,
            msg: '请填写买家退回快递单号'
          };
          if (!String(form.returnWarehouse || '').trim()) return {
            ok: false,
            msg: '请选择退货仓库'
          };
          if (!String(form.aftersaleIssueType || '').trim()) return {
            ok: false,
            msg: '请选择售后问题类型'
          };
          return {
            ok: true
          };
        },
        action: function action(_ref0) {
          var ui = _ref0.ui,
            form = _ref0.form;
          var selectedRows = Array.isArray(ui['goods-tableSelectedRows']) ? ui['goods-tableSelectedRows'] : [];
          var selectedGoods = selectedRows[0] || TARGET_GOODS;
          return {
            set: {
              createdAftersale: {
                aftersaleNo: 'SH202608070001',
                goodsName: selectedGoods.goodsName,
                goodsCode: selectedGoods.goodsCode,
                returnExpress: form.returnExpress,
                returnWaybill: form.returnWaybill,
                returnWarehouse: form.returnWarehouse,
                issueType: form.aftersaleIssueType,
                status: '待确认'
              }
            },
            next: 'fast-created'
          };
        }
      }]
    }, {
      id: 'fast-created',
      image: SCENE_IMAGES.fast,
      aspectRatio: 2,
      tip: '登记无信息件' + (0, _jstTip.br)() + '商品' + (0, _jstTip.red)('TEST-GD-0001退回') + (0, _jstTip.br)() + '买家退回快递公司：' + (0, _jstTip.red)('圆通') + (0, _jstTip.br)() + '买家退回快递单号：' + (0, _jstTip.red)('YT8888888888') + (0, _jstTip.br)() + '退回仓库：' + (0, _jstTip.red)('淘金仓库') + (0, _jstTip.br)() + '售后问题类型：' + (0, _jstTip.red)('尺码拍错/不喜欢/效果差'),
      tables: function tables(_ref1) {
        var ui = _ref1.ui;
        return ui.createdAftersale ? [{
          id: 'created-aftersale-table',
          x: 0.04,
          y: 0.62,
          w: 0.94,
          h: 0.25,
          rows: [ui.createdAftersale],
          columns: [{
            key: 'aftersaleNo',
            title: '售后单号',
            width: 150
          }, {
            key: 'status',
            title: '售后单状态',
            width: 110
          }, {
            key: 'goodsCode',
            title: '商品编码',
            width: 150
          }, {
            key: 'goodsName',
            title: '商品名称',
            width: 220
          }, {
            key: 'returnExpress',
            title: '退回快递公司',
            width: 130
          }, {
            key: 'returnWaybill',
            title: '退回快递单号',
            width: 170
          }, {
            key: 'returnWarehouse',
            title: '退货仓库',
            width: 130
          }, {
            key: 'issueType',
            title: '售后问题类型',
            width: 180
          }],
          rowKey: 'aftersaleNo',
          selectable: false
        }] : [];
      },
      afterEnter: {
        delay: 2000,
        finish: true
      }
    }]
  };
}

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGoodsList = getGoodsList;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _jstErpFixtureData = __webpack_require__(301);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** 聚水潭 ERP 第一章商品列表，统一复用练习数据源。 */
function getGoodsList() {
  return _jstErpFixtureData.JST_PRODUCT_LIST.map(function (item) {
    return _objectSpread({}, item);
  });
}

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

module.exports = {"version":1,"targets":{"serviceOrder":"5124299977002014714","createAftersaleOrder":"3312733548438011187","orderQuery":"3311622986439033564","aftersaleQuery":"51221269825210"},"products":[{"id":"product-ksb020","goodsCode":"TEST-GD-0001","styleCode":"STY-CUP-001","goodsName":"晨雾陶瓷马克杯","goodsShortName":"晨雾陶瓷马克杯","spec":"雾灰/350ml","price":18.5,"stock":120},{"id":"product-cpt078","goodsCode":"TEST-GD-0002","styleCode":"STY-CUP-002","goodsName":"云杉双层随行杯","goodsShortName":"云杉双层随行杯","spec":"松绿/500ml","price":29.9,"stock":85},{"id":"product-umn005","goodsCode":"TEST-GD-0003","styleCode":"STY-BOT-001","goodsName":"极光保温水壶","goodsShortName":"极光保温水壶","spec":"冰蓝/750ml","price":56,"stock":60},{"id":"product-umn006","goodsCode":"TEST-GD-0004","styleCode":"STY-JUG-001","goodsName":"方格玻璃冷水壶","goodsShortName":"方格玻璃冷水壶","spec":"透明/1.5L","price":38.8,"stock":42},{"id":"product-acb001","goodsCode":"TEST-GD-0005","styleCode":"STY-PLT-001","goodsName":"砂岩餐盘四件套","goodsShortName":"砂岩餐盘四件套","spec":"米白/8英寸/4件","price":79,"stock":35},{"id":"product-acb002","goodsCode":"TEST-GD-0006","styleCode":"STY-PAN-001","goodsName":"轻羽不粘煎锅","goodsShortName":"轻羽不粘煎锅","spec":"石墨灰/24cm","price":96,"stock":50},{"id":"product-acb003","goodsCode":"TEST-GD-0007","styleCode":"STY-BRD-001","goodsName":"谷仓竹制砧板","goodsShortName":"谷仓竹制砧板","spec":"原竹色/30x20cm","price":32.5,"stock":73},{"id":"product-acb004","goodsCode":"TEST-GD-0008","styleCode":"STY-SPC-001","goodsName":"橄榄木调味罐三件套","goodsShortName":"橄榄木调味罐三件套","spec":"木色/250ml/3件","price":44.9,"stock":40},{"id":"product-acb005","goodsCode":"TEST-GD-0009","styleCode":"STY-CLT-001","goodsName":"棉絮厨房擦拭巾","goodsShortName":"棉絮厨房擦拭巾","spec":"暖白/30x30cm/5条","price":12,"stock":200},{"id":"product-acb006","goodsCode":"TEST-GD-0010","styleCode":"STY-UTL-001","goodsName":"环岛硅胶锅铲","goodsShortName":"环岛硅胶锅铲","spec":"珊瑚橙/33cm","price":15.8,"stock":98},{"id":"product-sml001","goodsCode":"TEST-HM-0011","styleCode":"STY-CSN-001","goodsName":"北窗亚麻靠垫套","goodsShortName":"北窗亚麻靠垫套","spec":"烟蓝/45x45cm","price":22,"stock":110},{"id":"product-sml014","goodsCode":"TEST-HM-0012","styleCode":"STY-BLN-001","goodsName":"柔光针织盖毯","goodsShortName":"柔光针织盖毯","spec":"燕麦色/130x170cm","price":68,"stock":55},{"id":"product-snn001","goodsCode":"TEST-HM-0013","styleCode":"STY-CND-001","goodsName":"苔原香薰蜡烛","goodsShortName":"苔原香薰蜡烛","spec":"雪松香/200g","price":39.9,"stock":90},{"id":"product-ksn054","goodsCode":"TEST-HM-0014","styleCode":"STY-BSK-001","goodsName":"月湾藤编收纳篮","goodsShortName":"月湾藤编收纳篮","spec":"自然棕/直径32cm","price":45,"stock":48},{"id":"product-ucp001","goodsCode":"TEST-HM-0015","styleCode":"STY-CRN-001","goodsName":"静帆遮光窗帘","goodsShortName":"静帆遮光窗帘","spec":"深海蓝/140x250cm","price":128,"stock":30},{"id":"product-ksj0417","goodsCode":"TEST-HM-0016","styleCode":"STY-FRM-001","goodsName":"雾面相框摆台","goodsShortName":"雾面相框摆台","spec":"象牙白/6英寸","price":26.9,"stock":76},{"id":"product-ksj0450","goodsCode":"TEST-HM-0017","styleCode":"STY-VAS-001","goodsName":"浅丘桌面花瓶","goodsShortName":"浅丘桌面花瓶","spec":"沙岩色/18cm","price":34.5,"stock":64}],"orders":[{"id":"order-service","role":"service","internalOrderNo":"381499","onlineOrderNo":"5124299977002014714","externalOrderNo":"357441026810924511","orderTime":"2026-07-14 17:45:19","paymentTime":"2026-07-14 17:45:31","auditTime":"2026-07-14 18:06:12","buyerAccount":"掌**","receiver":"朱**","phone":"138****0000","address":"陕西省西安市雁塔区丈八街道丹轩梓园3号楼","store":"淘金云官方旗舰店","status":"已发货","amount":48.4,"freight":0,"orderType":"普通订单","expressCompany":"京东快递","expressNo":"JDAP20513539914","tags":"发货后售后","buyerMessage":"请注意包装","sellerRemark":""},{"id":"order-create","role":"create","internalOrderNo":"381421","onlineOrderNo":"3312733548438011187","externalOrderNo":"357320896478225104","orderTime":"2026-07-21 10:00:00","paymentTime":"2026-07-21 10:00:16","auditTime":"2026-07-21 10:18:42","buyerAccount":"安**","receiver":"朱**","phone":"138****0000","address":"陕西省西安市雁塔区丈八街道丹轩梓园3号楼","store":"淘金云官方旗舰店","status":"已发货","amount":94.8,"freight":0,"orderType":"普通订单","expressCompany":"京东快递","expressNo":"JDAP2051745816","tags":"云仓发货","buyerMessage":"礼盒包装","sellerRemark":"重点客户"},{"id":"order-query-1","role":"query-list","internalOrderNo":"382982","onlineOrderNo":"5125218444030265606","externalOrderNo":"357511864402851026","orderTime":"2026-07-20 16:19:18","paymentTime":"2026-07-20 16:19:26","auditTime":"","buyerAccount":"林**","receiver":"林**","phone":"137****5208","address":"浙江省杭州市余杭区五常街道文一西路","store":"淘金云官方旗舰店","status":"已付款待审核","amount":79,"freight":0,"orderType":"普通订单","expressCompany":"","expressNo":"","tags":"店铺新客","buyerMessage":"","sellerRemark":""},{"id":"order-query-2","role":"query-list","internalOrderNo":"382981","onlineOrderNo":"5125279645269000522","externalOrderNo":"357511864402851031","orderTime":"2026-07-20 16:18:42","paymentTime":"2026-07-20 16:18:55","auditTime":"","buyerAccount":"周**","receiver":"周**","phone":"136****1182","address":"江苏省南京市建邺区江东中路","store":"淘金云官方旗舰店","status":"已付款待审核","amount":96,"freight":0,"orderType":"普通订单","expressCompany":"","expressNo":"","tags":"会员订单","buyerMessage":"周末送达","sellerRemark":""},{"id":"order-query-3","role":"query-list","internalOrderNo":"382980","onlineOrderNo":"5124982106525003612","externalOrderNo":"357511864402851044","orderTime":"2026-07-20 16:16:58","paymentTime":"2026-07-20 16:17:25","auditTime":"2026-07-20 16:19:46","buyerAccount":"陈**","receiver":"陈**","phone":"135****6421","address":"广东省广州市天河区珠江新城","store":"淘金云官方旗舰店","status":"发货中","amount":32.5,"freight":0,"orderType":"普通订单","expressCompany":"顺丰速运","expressNo":"SF5115053064251","tags":"当日发货","buyerMessage":"","sellerRemark":""},{"id":"order-query-4","role":"query-list","internalOrderNo":"382979","onlineOrderNo":"5125278817886003841","externalOrderNo":"357511864402851059","orderTime":"2026-07-20 16:11:34","paymentTime":"2026-07-20 16:11:59","auditTime":"","buyerAccount":"宋**","receiver":"宋**","phone":"139****2056","address":"四川省成都市武侯区天府三街","store":"淘金云官方旗舰店","status":"异常\n缺货\n提交仓库判断","amount":68,"freight":0,"orderType":"普通订单","expressCompany":"","expressNo":"","tags":"库存预警","buyerMessage":"","sellerRemark":"等待调仓"},{"id":"order-query-target","role":"query-list","internalOrderNo":"380927","onlineOrderNo":"3311622986439033564","externalOrderNo":"357320785611460927","orderTime":"2026-07-10 09:09:54","paymentTime":"2026-07-10 09:10:03","auditTime":"2026-07-10 09:58:13","buyerAccount":"马**","receiver":"马**","phone":"138****6632","address":"广东省深圳市南山区粤海街道科苑路","store":"淘金云官方旗舰店","status":"已发货","amount":22,"freight":0,"orderType":"预售订单","expressCompany":"京东快递","expressNo":"JDAP2051745807","tags":"线上预售","buyerMessage":"请放丰巢","sellerRemark":""},{"id":"order-query-6","role":"query-list","internalOrderNo":"380926","onlineOrderNo":"5125218444030265607","externalOrderNo":"357320785611460936","orderTime":"2026-07-10 09:08:54","paymentTime":"2026-07-10 09:09:03","auditTime":"","buyerAccount":"叶**","receiver":"叶**","phone":"137****0926","address":"福建省厦门市思明区环岛东路","store":"淘金云官方旗舰店","status":"异常\n待下单","amount":45,"freight":0,"orderType":"预售订单","expressCompany":"","expressNo":"","tags":"线上预售","buyerMessage":"","sellerRemark":"等待平台确认"},{"id":"order-query-7","role":"query-list","internalOrderNo":"380922","onlineOrderNo":"5125218444030265608","externalOrderNo":"357320785611460945","orderTime":"2026-07-10 09:07:54","paymentTime":"2026-07-10 09:08:03","auditTime":"","buyerAccount":"许**","receiver":"许**","phone":"136****3428","address":"湖北省武汉市江汉区建设大道","store":"淘金云官方旗舰店","status":"被拆分","amount":256,"freight":0,"orderType":"普通订单","expressCompany":"","expressNo":"","tags":"组合订单","buyerMessage":"分开发货","sellerRemark":"已拆两单"},{"id":"order-query-8","role":"query-list","internalOrderNo":"380918","onlineOrderNo":"5125218444030265609","externalOrderNo":"357320785611460953","orderTime":"2026-07-10 09:06:48","paymentTime":"2026-07-10 09:06:57","auditTime":"2026-07-10 09:10:22","buyerAccount":"沈**","receiver":"沈**","phone":"135****7831","address":"上海市浦东新区张江路","store":"淘金云官方旗舰店","status":"已发货","amount":38.8,"freight":0,"orderType":"普通订单","expressCompany":"顺丰速运","expressNo":"SF5115053064268","tags":"云仓发货","buyerMessage":"","sellerRemark":""},{"id":"order-query-9","role":"query-list","internalOrderNo":"380916","onlineOrderNo":"5125218444030265610","externalOrderNo":"357320785611460968","orderTime":"2026-07-10 09:05:36","paymentTime":"2026-07-10 09:05:49","auditTime":"","buyerAccount":"顾**","receiver":"顾**","phone":"139****1176","address":"北京市朝阳区望京东路","store":"淘金云官方旗舰店","status":"待审核","amount":56,"freight":0,"orderType":"普通订单","expressCompany":"","expressNo":"","tags":"店铺会员","buyerMessage":"","sellerRemark":""},{"id":"order-aftersale-target","role":"aftersale","internalOrderNo":"382498","onlineOrderNo":"51221269825210","externalOrderNo":"357511864402852210","orderTime":"2026-07-18 14:26:18","paymentTime":"2026-07-18 14:26:31","auditTime":"2026-07-18 14:45:08","buyerAccount":"梁**","receiver":"李**","phone":"138****8888","address":"广东省深圳市龙岗区坂田街道","store":"淘金云官方旗舰店","status":"已发货","amount":22,"freight":0,"orderType":"普通订单","expressCompany":"京东快递","expressNo":"JDAP2051745801","tags":"发货后售后／云仓发货","buyerMessage":"","sellerRemark":""}],"orderItems":[{"id":"item-service-1","orderId":"order-service","productId":"product-ksb020","quantity":1,"unitPrice":18.5,"amount":18.5,"appliedReturnQty":0,"actualReturnQty":0},{"id":"item-service-2","orderId":"order-service","productId":"product-cpt078","quantity":1,"unitPrice":29.9,"amount":29.9,"appliedReturnQty":0,"actualReturnQty":0},{"id":"item-create-1","orderId":"order-create","productId":"product-umn005","quantity":1,"unitPrice":56,"amount":56,"appliedReturnQty":1,"actualReturnQty":0},{"id":"item-create-2","orderId":"order-create","productId":"product-umn006","quantity":1,"unitPrice":38.8,"amount":38.8,"appliedReturnQty":0,"actualReturnQty":0},{"id":"item-query-1","orderId":"order-query-1","productId":"product-acb001","quantity":1,"unitPrice":79,"amount":79,"appliedReturnQty":1,"actualReturnQty":0},{"id":"item-query-2","orderId":"order-query-2","productId":"product-acb002","quantity":1,"unitPrice":96,"amount":96,"appliedReturnQty":1,"actualReturnQty":0},{"id":"item-query-3","orderId":"order-query-3","productId":"product-acb003","quantity":1,"unitPrice":32.5,"amount":32.5,"appliedReturnQty":1,"actualReturnQty":0},{"id":"item-query-4","orderId":"order-query-4","productId":"product-sml014","quantity":1,"unitPrice":68,"amount":68,"appliedReturnQty":1,"actualReturnQty":0},{"id":"item-query-target","orderId":"order-query-target","productId":"product-sml001","quantity":1,"unitPrice":22,"amount":22,"appliedReturnQty":0,"actualReturnQty":0},{"id":"item-query-6","orderId":"order-query-6","productId":"product-ksn054","quantity":1,"unitPrice":45,"amount":45,"appliedReturnQty":0,"actualReturnQty":0},{"id":"item-query-7","orderId":"order-query-7","productId":"product-ucp001","quantity":2,"unitPrice":128,"amount":256,"appliedReturnQty":0,"actualReturnQty":0},{"id":"item-query-8","orderId":"order-query-8","productId":"product-umn006","quantity":1,"unitPrice":38.8,"amount":38.8,"appliedReturnQty":1,"actualReturnQty":0},{"id":"item-query-9","orderId":"order-query-9","productId":"product-umn005","quantity":1,"unitPrice":56,"amount":56,"appliedReturnQty":0,"actualReturnQty":0},{"id":"item-aftersale-target","orderId":"order-aftersale-target","productId":"product-sml001","quantity":1,"unitPrice":22,"amount":22,"appliedReturnQty":1,"actualReturnQty":0}],"aftersales":[{"id":"aftersale-1","aftersaleNo":"1090155418","orderId":"order-query-1","onlineAftersaleNo":"277293399976081","businessType":"普通售后","aftersaleStatus":"待确认","solution":"退货退款","onlineStatus":"等待买家退货","onlineType":"普通退货","aftersaleCategory":"退货退款","cargoStatus":"买家已收到货","issueType":"不想要了","tags":"线上下载","issueRecord":"买家已上传商品照片","applyTime":"2026-07-22 17:50:32","confirmTime":"","warehouse":"淘金云仓库","returnExpressNo":"","returnInternationalNo":"","supplierRefundStatus":"退款处理中","applyQty":1,"actualReturnQty":0,"applyAmount":79,"refundedAmount":0},{"id":"aftersale-2","aftersaleNo":"1090155417","orderId":"order-query-2","onlineAftersaleNo":"400083841285692","businessType":"普通售后","aftersaleStatus":"待确认","solution":"退货退款","onlineStatus":"等待买家退货","onlineType":"普通退货","aftersaleCategory":"退货退款","cargoStatus":"买家已收到货","issueType":"尺寸不合适","tags":"线上下载","issueRecord":"等待买家寄回商品","applyTime":"2026-07-22 17:35:43","confirmTime":"","warehouse":"淘金云仓库","returnExpressNo":"","returnInternationalNo":"","supplierRefundStatus":"退款处理中","applyQty":1,"actualReturnQty":0,"applyAmount":96,"refundedAmount":0},{"id":"aftersale-target","aftersaleNo":"1090155416","orderId":"order-aftersale-target","onlineAftersaleNo":"400083841285703","businessType":"普通售后","aftersaleStatus":"待确认","solution":"退货退款","onlineStatus":"等待买家退货","onlineType":"普通退货","aftersaleCategory":"退货退款","cargoStatus":"买家已收到货","issueType":"不喜欢款式","tags":"线上下载","issueRecord":"买家申请退货退款","applyTime":"2026-07-22 17:22:16","confirmTime":"","warehouse":"淘金云仓库","returnExpressNo":"","returnInternationalNo":"","supplierRefundStatus":"退款处理中","applyQty":1,"actualReturnQty":0,"applyAmount":22,"refundedAmount":0},{"id":"aftersale-4","aftersaleNo":"1090155415","orderId":"order-query-4","onlineAftersaleNo":"400083841285714","businessType":"普通售后","aftersaleStatus":"已确认","solution":"仅退款","onlineStatus":"退款处理中","onlineType":"普通退款","aftersaleCategory":"退款","cargoStatus":"未发货","issueType":"协商退款","tags":"线上下载","issueRecord":"仓库缺货，已与买家协商","applyTime":"2026-07-22 17:08:31","confirmTime":"2026-07-22 17:10:12","warehouse":"淘金云仓库","returnExpressNo":"","returnInternationalNo":"","supplierRefundStatus":"已退款","applyQty":1,"actualReturnQty":0,"applyAmount":68,"refundedAmount":68},{"id":"aftersale-5","aftersaleNo":"1090155414","orderId":"order-query-8","onlineAftersaleNo":"400083841285725","businessType":"普通售后","aftersaleStatus":"处理中","solution":"换货","onlineStatus":"等待仓库收货","onlineType":"普通退货","aftersaleCategory":"换货","cargoStatus":"运输中","issueType":"商品有轻微划痕","tags":"发货后售后","issueRecord":"已上传开箱照片","applyTime":"2026-07-22 16:54:20","confirmTime":"2026-07-22 16:58:42","warehouse":"淘金云仓库","returnExpressNo":"YT3000851742631","returnInternationalNo":"","supplierRefundStatus":"无需退款","applyQty":1,"actualReturnQty":0,"applyAmount":38.8,"refundedAmount":0}],"aftersaleItems":[{"id":"aftersale-item-1","aftersaleId":"aftersale-1","productId":"product-acb001","applyQty":1,"actualReturnQty":0,"unitPrice":79,"amount":79},{"id":"aftersale-item-2","aftersaleId":"aftersale-2","productId":"product-acb002","applyQty":1,"actualReturnQty":0,"unitPrice":96,"amount":96},{"id":"aftersale-item-target","aftersaleId":"aftersale-target","productId":"product-sml001","applyQty":1,"actualReturnQty":0,"unitPrice":22,"amount":22},{"id":"aftersale-item-4","aftersaleId":"aftersale-4","productId":"product-sml014","applyQty":1,"actualReturnQty":0,"unitPrice":68,"amount":68},{"id":"aftersale-item-5","aftersaleId":"aftersale-5","productId":"product-umn006","applyQty":1,"actualReturnQty":0,"unitPrice":38.8,"amount":38.8}]}

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-0.4a7fd2b.png";

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-1.dedf392.png";

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-2.7940590.png";

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-3.587e54a.png";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-4.a209c61.png";

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-5.49b274c.png";

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-0-aftersale-fast.dc0b9d4.png";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-0-order.185ef3e.png";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-1-search.8f5cbc0.png";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-2-普通仅退款.3b682ae.png";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-3-普通换货.b71ee0f.png";

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-4-普通补发.1b3d3ce.png";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-5-普通维修.71ca2bc.png";

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-6-普通拒收退货.5a2dd0d.png";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-7-错发退货退款.1c42d7d.png";

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-8-错发仅退款.1177405.png";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-9-错发换货.95ad519.png";

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-1-create-aftersale-empty.d8c1ad8.png";

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-2-create-aftersale-return.17b92b1.png";

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-3-create-aftersale-refund.baadd31.png";

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-4-create-aftersale-resend.1aa0554.png";

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-5-aftersale-detail.d188327.png";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-6-create-noinfo-aftersale.43b6251.png";

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-7-select-noinfo-goods.8921c7d.png";

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-aftersale-issue-registration.d84f1fc.png";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-leak-resend-selected.c19b8af.png";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-leak-resend.d573cf3.png";

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-noinfo-aftersale.43b6251.png";

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-noinfo-product-library.8921c7d.png";

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-normal-return.212e35d.png";

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-product-library-search-result.8a87dd6.png";

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-product-library.a782834.png";

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-select-exchange-order-goods.3388749.png";

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-select-return-order-goods.90b3a7c.png";

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-wrong-exchange.c83cb32.png";

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-1-order-query-result.a8f2a73.png";

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-2-aftersale-query.d910f8f.png";

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-3-aftersale-query-result.5bbbca3.png";

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jst_login.51a159d.png";

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order-default-necklace.2a8f5cb.png";

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-10-普通退货退款建单.e67f907.png";

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-11-普通补发建单.4551076.png";

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-12-普通补发填写.00b303f.png";

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-13-普通维修建单.b0312cc.png";

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-14-错发退货退款建单.de5793e.png";

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-15-错发退货退款问题类型.2d7d2ca.png";

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-16-错发退货退款问题选择.12db708.png";

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-17-错发退货退款商品库.c84eb16.png";

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-18-漏发补发问题类型.8feda28.png";

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-18-错发退货退款添加商品.96fffa9.png";

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-19-错发退货退款完成.872a9c9.png";

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-20-错发换货建单.ae5cc00.png";

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-21-漏发补发建单.cd6f171.png";

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-22-已创建手工售后单.6ed8122.png";

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-22-漏发仅退款建单.1631239.png";

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-34-错发换货选择订单商品.4215bf4.png";

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jst-erp-scene" },
    [
      _c("StepPlayer", {
        ref: "player",
        attrs: {
          steps: _vm.scenario.steps,
          "initial-step-id": _vm.scenario.initialStepId,
          "initial-form": _vm.scenario.initialForm,
          "show-tip": false
        },
        on: {
          "step-change": _vm.onStepChange,
          "guard-failed": _vm.onGuardFailed,
          finish: _vm.onFinish
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31178041", esExports)
  }
}

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1363);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("abcf9f9e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-634d6f4a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpSecondScene.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-634d6f4a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpSecondScene.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.jst-erp-scene[data-v-634d6f4a] {\n  width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  color: #303133;\n  text-align: left;\n  background: #fff;\n}\n[data-v-634d6f4a] .step-player {\n  display: block;\n  width: 100%;\n}\n[data-v-634d6f4a] .step-player .stage {\n  width: 100%;\n  min-height: 420px;\n  overflow: hidden;\n  background-color: #eef2f7;\n}\n[data-v-634d6f4a] .step-player .hotspot {\n  z-index: 3;\n}\n[data-v-634d6f4a] .step-player .field {\n  z-index: 4;\n  border-radius: 2px;\n}\n[data-v-634d6f4a] .step-player .field-input {\n  color: #303133;\n  background: rgba(255, 255, 255, 0.01);\n}\n", ""]);

// exports


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJstErpSecondScenario = getJstErpSecondScenario;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(460));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _jstProvinces = _interopRequireDefault(__webpack_require__(584));
var _jstCities = _interopRequireDefault(__webpack_require__(585));
var _jstDistricts = _interopRequireDefault(__webpack_require__(586));
var _jstErpFixtureData = __webpack_require__(301);
var _jstTip = __webpack_require__(302);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * 聚水潭 ERP 第二章截图场景。
 *
 * 当前仅完成图片接入与步骤骨架，具体交互流程后续补充。
 */
function r(path) {
  return __webpack_require__(303)("./" + path);
}
var TARGET_ORDER_CODE = _jstErpFixtureData.JST_TARGETS.serviceOrder;
var TARGET_ORDER_NO = _jstErpFixtureData.JST_SECOND_ORDER_ROW.orderNo;
var ERROR_PRODUCT_STYLE_CODE = _jstErpFixtureData.JST_ERROR_PRODUCT.styleCode;
var EXCHANGE_RECEIVER_TEXT = '朱小明 13800138000 陕西省西安市雁塔区丈八街道丹轩梓园3号楼';
var DOMESTIC_EXPRESS_COMPANIES = ['EMS', '邮政快递包裹', '顺丰速运', '顺丰同城', '京东快递', '中通快递', '圆通速递', '申通快递', '韵达快递', '极兔速递', '德邦快递', '菜鸟速递', '百世快递'];
var DIRECT_CONTROLLED_MUNICIPALITIES = ['北京市', '天津市', '上海市', '重庆市'];
function findResendProvince(provinceName) {
  return _jstProvinces.default.find(function (item) {
    return item.name === provinceName;
  });
}
function getResendCities(provinceName) {
  var province = findResendProvince(provinceName);
  if (!province) return [];
  if (DIRECT_CONTROLLED_MUNICIPALITIES.indexOf(provinceName) > -1) return [provinceName];
  return _jstCities.default.filter(function (item) {
    return item.province === province.province;
  }).map(function (item) {
    return item.name;
  });
}
function getResendDistricts(provinceName, cityName) {
  var province = findResendProvince(provinceName);
  if (!province || !cityName) return [];
  if (DIRECT_CONTROLLED_MUNICIPALITIES.indexOf(provinceName) > -1) {
    return _jstDistricts.default.filter(function (item) {
      return item.province === province.province;
    }).map(function (item) {
      return item.name;
    });
  }
  var city = _jstCities.default.find(function (item) {
    return item.province === province.province && item.name === cityName;
  });
  return city ? _jstDistricts.default.filter(function (item) {
    return item.province === province.province && item.city === city.city;
  }).map(function (item) {
    return item.name;
  }) : [];
}
var ERROR_PRODUCT = _jstErpFixtureData.JST_ERROR_PRODUCT;
var ERROR_PRODUCT_LIBRARY = _jstErpFixtureData.JST_ERROR_PRODUCT_LIBRARY;
var MOCK_ORDER_ROWS = [_jstErpFixtureData.JST_SECOND_ORDER_ROW];
var MOCK_GOODS_ROWS = _jstErpFixtureData.JST_SECOND_GOODS_ROWS;
var EXCHANGE_PRODUCT = _objectSpread(_objectSpread({}, MOCK_GOODS_ROWS[0]), {}, {
  id: 'exchange-product-goods-1',
  type: '换',
  typeColor: '#409eff',
  issueType: '无',
  issueTypeLocked: true
});
var DEFAULT_ORDER_TABLE_POSITION = {
  x: 0.14,
  y: 0.21,
  w: 0.848,
  h: 0.15
};
var DEFAULT_GOODS_TABLE_POSITION = {
  x: 0.14,
  y: 0.51,
  w: 0.848,
  h: 0.17
};
var _54_GOODS_TABLE_POSITION = {
  x: 0.14,
  y: 0.54,
  w: 0.848,
  h: 0.17
};
function buildTables(_ref) {
  var ui = _ref.ui;
  var goodsTablePosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_GOODS_TABLE_POSITION;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // const searched = ui.searchSearched
  // const orderCode = (form.orderCode || '').trim()

  // 未查询或订单号不匹配，不展示表格
  // if (!searched || orderCode !== TARGET_ORDER_CODE) return []

  // 合并商品草稿：用户编辑的单价、数量、金额
  var draft = ui.goodsTableDraft || {};
  var sourceRows = MOCK_GOODS_ROWS.concat(options.additionalGoods || []);
  var orderSelected = (ui['order-tableSelectedKeys'] || []).includes(MOCK_ORDER_ROWS[0].id);
  var goodsRows = sourceRows.map(function (row) {
    var cellDraft = draft[row.id];
    var rowDefaults = typeof options.rowDefaults === 'function' ? options.rowDefaults(row) : options.rowDefaults || {};
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, row), {}, {
      type: options.goodsType || row.type,
      typeColor: options.goodsTypeColor || row.typeColor
    }, options.defaultQty !== undefined ? {
      qty: options.defaultQty
    } : {}), options.defaultAmount !== undefined ? {
      amount: options.defaultAmount
    } : {}), rowDefaults), cellDraft || {});
  });
  return [// ── 上表：订单搜索结果 ──
  _objectSpread(_objectSpread({
    id: 'order-table'
  }, DEFAULT_ORDER_TABLE_POSITION), {}, {
    rows: MOCK_ORDER_ROWS,
    columns: [{
      key: 'orderNo',
      title: '订单号',
      width: 100
    }, {
      key: 'orderTime',
      title: '下单时间',
      width: 126
    }, {
      key: 'buyerNickname',
      title: '买家昵称',
      width: 92
    }, {
      key: 'receiver',
      title: '收货人',
      width: 260
    }, {
      key: 'shop',
      title: '店铺',
      width: 140
    }, {
      key: 'status',
      title: '状态',
      width: 92
    }, {
      key: 'orderCode',
      title: '线上订单号',
      width: 168
    }, {
      key: 'payAmount',
      title: '买家下单金额',
      width: 120,
      align: 'right'
    }, {
      key: 'orderType',
      title: '订单类型',
      width: 100
    }, {
      key: 'expressInfo',
      title: '快递信息',
      width: 140
    }, {
      key: 'buyerMessage',
      title: '买家留言',
      width: 100
    }, {
      key: 'buyerRemark',
      title: '卖家备注',
      width: 100
    }],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: []
  }), // ── 下表：商品售后明细 ──
  _objectSpread(_objectSpread({
    id: 'goods-table'
  }, goodsTablePosition), {}, {
    rows: orderSelected ? goodsRows : [],
    columns: [{
      key: 'image',
      type: 'image',
      title: '商品图片',
      width: 74
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: options.wideDetailColumns ? 236 : 118
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 100
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: options.wideDetailColumns ? 300 : 150
    }, {
      key: 'goodsShortName',
      title: '商品简称',
      width: options.wideDetailColumns ? 290 : 145
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: options.wideDetailColumns ? 260 : 130
    }, {
      key: 'type',
      title: '类型',
      width: 58,
      cellStyle: function cellStyle(row) {
        return row.typeColor ? {
          color: row.typeColor,
          fontWeight: '600'
        } : {};
      }
    }].concat((0, _toConsumableArray2.default)(options.issueTypeColumn ? [{
      key: 'issueType',
      type: 'select',
      title: '明细问题类型',
      width: options.wideDetailColumns ? 240 : 120,
      options: ['应发未发', '无', '错发已发'],
      inputDisabled: function inputDisabled(row) {
        return row.issueTypeLocked === true;
      }
    }] : []), [{
      key: 'price',
      type: 'input',
      title: options.priceTitle || '单价',
      width: options.wideDetailColumns ? 176 : 88,
      align: 'right'
    }, {
      key: 'qty',
      type: 'input',
      title: options.qtyTitle || '退货数量',
      width: 96,
      align: 'right'
    }, {
      key: 'amount',
      type: 'input',
      title: options.amountTitle || '退货金额',
      width: 100,
      align: 'right',
      inputDisabled: options.amountInputDisabled === true
    }, {
      key: 'appliedReturnQty',
      title: '已申请退货',
      width: 100,
      align: 'right'
    }, {
      key: 'actualReturnQty',
      title: '实际退货',
      width: 90,
      align: 'right'
    }, {
      key: 'goodsAmount',
      title: '商品金额',
      width: 90,
      align: 'right'
    }, {
      key: 'orderQty',
      title: '订单数',
      width: 72,
      align: 'right'
    }]),
    rowKey: 'id',
    selectable: true,
    selectedKeys: [],
    selectionDisabled: options.goodsSelectionDisabled === true,
    onCellChange: function onCellChange(_ref2) {
      var row = _ref2.row,
        key = _ref2.key,
        value = _ref2.value,
        ui = _ref2.ui,
        setUi = _ref2.setUi;
      var draft = _objectSpread({}, ui.goodsTableDraft || {});
      var rowId = row.id;
      draft[rowId] = _objectSpread(_objectSpread({}, draft[rowId] || {}), {}, (0, _defineProperty2.default)({}, key, value));
      setUi({
        goodsTableDraft: draft
      });
    }
  })];
}
function requireOrderSelection(_ref3) {
  var ui = _ref3.ui;
  return (ui['order-tableSelectedKeys'] || []).includes(MOCK_ORDER_ROWS[0].id) ? {
    ok: true
  } : {
    ok: false,
    msg: '请先选中搜索出的订单'
  };
}
function buildCreatedTables(_ref4) {
  var ui = _ref4.ui;
  var rows = ui.createdOrders || [];
  if (!rows.length) return [];
  return [{
    id: 'created-aftersale-table',
    x: 0.04,
    y: 0.63,
    w: 0.948,
    h: 0.33,
    rows: rows,
    columns: [{
      key: 'serialNo',
      title: '序号',
      width: 56,
      align: 'center'
    }, {
      key: 'aftersaleNo',
      title: '售后单号',
      width: 160
    }, {
      key: 'internalOrderNo',
      title: '内部订单号',
      width: 130
    }, {
      key: 'aftersaleStatus',
      title: '售后单状态',
      width: 110
    }, {
      key: 'solution',
      title: '解决方案',
      width: 120
    }, {
      key: 'onlineStatus',
      title: '线上状态',
      width: 130
    }, {
      key: 'onlineType',
      title: '线上类型',
      width: 100
    }, {
      key: 'aftersaleCategory',
      title: '售后分类',
      width: 110
    }, {
      key: 'goodsInfo',
      title: '商品信息',
      width: 200,
      whiteSpace: 'pre-line'
    }, {
      key: 'returnWaybill',
      title: '退货快递单号',
      width: 150
    }, {
      key: 'returnInternationalWaybill',
      title: '退货国际单号',
      width: 150
    }, {
      key: 'cargoStatus',
      title: '货物状态',
      width: 130
    }, {
      key: 'expressInterceptStatus',
      title: '快递拦截状态',
      width: 140
    }, {
      key: 'operation',
      title: '操作',
      width: 100,
      whiteSpace: 'pre-line'
    }],
    rowKey: 'aftersaleNo',
    selectable: true,
    selectedKeys: []
  }];
}
function buildReturnFields() {
  return [{
    id: 'return-express',
    model: 'returnExpress',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.21,
    y: 0.695,
    w: 0.14,
    h: 0.026
  }, {
    id: 'return-waybill',
    model: 'returnWaybill',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.42,
    y: 0.695,
    w: 0.14,
    h: 0.026
  }, {
    id: 'return-warehouse',
    model: 'returnWarehouse',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请选择',
    options: ['淘金仓库'],
    x: 0.60,
    y: 0.695,
    w: 0.17,
    h: 0.026
  }, {
    id: 'remark',
    model: 'remark',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入备注',
    x: 0.16,
    y: 0.735,
    w: 0.19,
    h: 0.026
  }, {
    id: 'buyer-subsidy',
    model: 'buyerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.405,
    y: 0.735,
    w: 0.15,
    h: 0.026
  }];
}
function buildErrorReturnTables(context) {
  var addedGoods = context.ui.errorAddedGoods || [];
  return buildTables(context, DEFAULT_GOODS_TABLE_POSITION, {
    issueTypeColumn: true,
    additionalGoods: addedGoods
  });
}
function buildErrorExchangeTables(context) {
  return buildTables(context, DEFAULT_GOODS_TABLE_POSITION, {
    issueTypeColumn: true,
    additionalGoods: (context.ui.errorAddedGoods || []).concat(context.ui.exchangeAddedGoods || []),
    qtyTitle: '本次退换数量',
    amountTitle: '退换金额'
  });
}
function fillBuyerAddress(value, setForm, nextTick, prefix, phoneModel) {
  var normalizedValue = String(value || '').replace(/\s+/g, '');
  var normalizedReceiver = EXCHANGE_RECEIVER_TEXT.replace(/\s+/g, '');
  if (normalizedValue !== normalizedReceiver) return;
  var province = prefix + 'Province';
  var city = prefix + 'City';
  var district = prefix + 'District';
  var detail = prefix + 'Detail';
  var receiver = prefix + 'Receiver';
  var phone = phoneModel || prefix + 'Phone';
  setForm((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, province, '陕西省'), city, ''), district, ''), detail, '丈八街道丹轩梓园3号楼'), receiver, '朱小明'), phone, '13800138000'));
  nextTick(function () {
    setForm((0, _defineProperty2.default)((0, _defineProperty2.default)({}, city, '西安市'), district, ''));
    nextTick(function () {
      return setForm((0, _defineProperty2.default)({}, district, '雁塔区'));
    });
  });
}
function buildErrorExchangeFields() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var provinceOptions = _jstProvinces.default.map(function (item) {
    return item.name;
  });
  var cityOptions = getResendCities(form.buyerProvince);
  var districtOptions = getResendDistricts(form.buyerProvince, form.buyerCity);
  return [].concat((0, _toConsumableArray2.default)(buildReturnFields()), [{
    id: 'out-express',
    model: 'outExpress',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请选择',
    options: DOMESTIC_EXPRESS_COMPANIES,
    x: 0.812,
    y: 0.7333,
    w: 0.169,
    h: 0.025
  }, {
    id: 'buyer-province',
    model: 'buyerProvince',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '省份',
    options: provinceOptions,
    x: 0.21,
    y: 0.771,
    w: 0.044,
    h: 0.028,
    onInput: function onInput(_ref5) {
      var setForm = _ref5.setForm;
      return setForm({
        buyerCity: '',
        buyerDistrict: ''
      });
    }
  }, {
    id: 'buyer-city',
    model: 'buyerCity',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '城市',
    options: cityOptions,
    x: 0.258,
    y: 0.771,
    w: 0.044,
    h: 0.028,
    onInput: function onInput(_ref6) {
      var setForm = _ref6.setForm;
      return setForm({
        buyerDistrict: ''
      });
    }
  }, {
    id: 'buyer-district',
    model: 'buyerDistrict',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '区县',
    options: districtOptions,
    x: 0.306,
    y: 0.771,
    w: 0.044,
    h: 0.028
  }, {
    id: 'buyer-detail',
    model: 'buyerDetail',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '详细地址',
    x: 0.356,
    y: 0.771,
    w: 0.207,
    h: 0.028
  }, {
    id: 'buyer-receiver',
    model: 'buyerReceiver',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '收货人',
    x: 0.567,
    y: 0.771,
    w: 0.10,
    h: 0.028
  }, {
    id: 'buyer-phone',
    model: 'buyerReceiverPhone',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '联系电话',
    x: 0.671,
    y: 0.771,
    w: 0.101,
    h: 0.028
  }, {
    id: 'receiver-smart-input',
    model: 'receiverSmartInput',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '粘贴或输入收件人信息回车后系统自动识别',
    x: 0.8164,
    y: 0.771,
    w: 0.1563,
    h: 0.027,
    onInput: function onInput(_ref7) {
      var value = _ref7.value,
        setForm = _ref7.setForm,
        nextTick = _ref7.nextTick;
      return fillBuyerAddress(value, setForm, nextTick, 'buyer', 'buyerReceiverPhone');
    }
  }]);
}
function buildRepairFields() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildErrorExchangeFields(form).filter(function (field) {
    return field.id !== 'out-express';
  });
}
function buildResendFields() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var provinceOptions = _jstProvinces.default.map(function (item) {
    return item.name;
  });
  var cityOptions = getResendCities(form.resendBuyerProvince);
  var districtOptions = getResendDistricts(form.resendBuyerProvince, form.resendBuyerCity);
  return [{
    id: 'resend-remark',
    model: 'resendRemark',
    type: 'text',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '请输入',
    x: 0.165,
    y: 0.736,
    w: 0.182,
    h: 0.022
  }, {
    id: 'resend-buyer-subsidy',
    model: 'resendBuyerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '请输入',
    x: 0.405,
    y: 0.736,
    w: 0.157,
    h: 0.022
  }, {
    id: 'resend-out-express',
    model: 'resendOutExpress',
    type: 'select',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '请选择',
    options: DOMESTIC_EXPRESS_COMPANIES,
    x: 0.602,
    y: 0.736,
    w: 0.168,
    h: 0.022
  }, {
    id: 'resend-buyer-province',
    model: 'resendBuyerProvince',
    type: 'select',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '省份',
    options: provinceOptions,
    x: 0.839,
    y: 0.736,
    w: 0.046,
    h: 0.022,
    onInput: function onInput(_ref8) {
      var setForm = _ref8.setForm;
      return setForm({
        resendBuyerCity: '',
        resendBuyerDistrict: ''
      });
    }
  }, {
    id: 'resend-buyer-city',
    model: 'resendBuyerCity',
    type: 'select',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '城市',
    options: cityOptions,
    x: 0.887,
    y: 0.736,
    w: 0.046,
    h: 0.022,
    onInput: function onInput(_ref9) {
      var setForm = _ref9.setForm;
      return setForm({
        resendBuyerDistrict: ''
      });
    }
  }, {
    id: 'resend-buyer-district',
    model: 'resendBuyerDistrict',
    type: 'select',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '区县',
    options: districtOptions,
    x: 0.935,
    y: 0.736,
    w: 0.048,
    h: 0.022
  }, {
    id: 'resend-buyer-detail',
    model: 'resendBuyerDetail',
    type: 'text',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '详细地址',
    x: 0.146,
    y: 0.775,
    w: 0.205,
    h: 0.022
  }, {
    id: 'resend-buyer-receiver',
    model: 'resendBuyerReceiver',
    type: 'text',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '收货人',
    x: 0.357,
    y: 0.775,
    w: 0.101,
    h: 0.022
  }, {
    id: 'resend-buyer-phone',
    model: 'resendBuyerPhone',
    type: 'text',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '联系电话',
    x: 0.462,
    y: 0.775,
    w: 0.10,
    h: 0.022
  }, {
    id: 'resend-smart-input',
    model: 'resendSmartInput',
    type: 'text',
    bgColor: '#fff',
    fontSize: 9,
    placeholder: '粘贴或输入收件人信息回车后系统自动识别',
    x: 0.602,
    y: 0.775,
    w: 0.171,
    h: 0.022,
    onInput: function onInput(_ref0) {
      var value = _ref0.value,
        setForm = _ref0.setForm,
        nextTick = _ref0.nextTick;
      var normalizedValue = String(value || '').replace(/\s+/g, '');
      var normalizedReceiver = EXCHANGE_RECEIVER_TEXT.replace(/\s+/g, '');
      if (normalizedValue !== normalizedReceiver) return;
      setForm({
        resendBuyerProvince: '陕西省',
        resendBuyerCity: '',
        resendBuyerDistrict: '',
        resendBuyerDetail: '丈八街道丹轩梓园3号楼',
        resendBuyerReceiver: '朱小明',
        resendBuyerPhone: '13800138000'
      });
      nextTick(function () {
        setForm({
          resendBuyerCity: '西安市',
          resendBuyerDistrict: ''
        });
        nextTick(function () {
          return setForm({
            resendBuyerDistrict: '雁塔区'
          });
        });
      });
    }
  }];
}
function buildLeakResendTables(context) {
  var beforeIssueSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return buildTables(context, _54_GOODS_TABLE_POSITION, {
    goodsType: '补',
    goodsTypeColor: '#e6a23c',
    issueTypeColumn: true,
    qtyTitle: '本次补发数量',
    amountTitle: '补发金额',
    defaultAmount: 0,
    amountInputDisabled: true,
    rowDefaults: function rowDefaults(row) {
      return beforeIssueSelection ? {
        qty: 1,
        issueType: ''
      } : row.id === 'goods-1' ? {
        qty: 1,
        issueType: ''
      } : {
        qty: 0,
        issueType: ''
      };
    }
  });
}
function buildLeakResendFields() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var provinceOptions = _jstProvinces.default.map(function (item) {
    return item.name;
  });
  var cityOptions = getResendCities(form.leakBuyerProvince);
  var districtOptions = getResendDistricts(form.leakBuyerProvince, form.leakBuyerCity);
  return [{
    id: 'leak-remark',
    model: 'leakRemark',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.165,
    y: 0.732,
    w: 0.187,
    h: 0.028
  }, {
    id: 'leak-buyer-subsidy',
    model: 'leakBuyerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.405,
    y: 0.732,
    w: 0.157,
    h: 0.028
  }, {
    id: 'leak-out-express',
    model: 'leakOutExpress',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请选择',
    options: DOMESTIC_EXPRESS_COMPANIES,
    x: 0.601,
    y: 0.732,
    w: 0.171,
    h: 0.028
  }, {
    id: 'leak-buyer-province',
    model: 'leakBuyerProvince',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '省份',
    options: provinceOptions,
    x: 0.839,
    y: 0.732,
    w: 0.045,
    h: 0.028,
    onInput: function onInput(_ref1) {
      var setForm = _ref1.setForm;
      return setForm({
        leakBuyerCity: '',
        leakBuyerDistrict: ''
      });
    }
  }, {
    id: 'leak-buyer-city',
    model: 'leakBuyerCity',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '城市',
    options: cityOptions,
    x: 0.888,
    y: 0.732,
    w: 0.045,
    h: 0.028,
    onInput: function onInput(_ref10) {
      var setForm = _ref10.setForm;
      return setForm({
        leakBuyerDistrict: ''
      });
    }
  }, {
    id: 'leak-buyer-district',
    model: 'leakBuyerDistrict',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '区县',
    options: districtOptions,
    x: 0.937,
    y: 0.732,
    w: 0.046,
    h: 0.028
  }, {
    id: 'leak-buyer-detail',
    model: 'leakBuyerDetail',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '详细地址',
    x: 0.145,
    y: 0.771,
    w: 0.207,
    h: 0.028
  }, {
    id: 'leak-buyer-receiver',
    model: 'leakBuyerReceiver',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '收货人',
    x: 0.356,
    y: 0.771,
    w: 0.101,
    h: 0.028
  }, {
    id: 'leak-buyer-phone',
    model: 'leakBuyerPhone',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '联系电话',
    x: 0.461,
    y: 0.771,
    w: 0.10,
    h: 0.028
  }, {
    id: 'leak-smart-input',
    model: 'leakSmartInput',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '粘贴或输入收件人信息回车后系统自动识别',
    x: 0.601,
    y: 0.771,
    w: 0.171,
    h: 0.028,
    onInput: function onInput(_ref11) {
      var value = _ref11.value,
        setForm = _ref11.setForm,
        nextTick = _ref11.nextTick;
      return fillBuyerAddress(value, setForm, nextTick, 'leakBuyer');
    }
  }];
}
function buildProductSearchTable(searched) {
  return [{
    id: 'error-product-search-table',
    x: 0.214,
    y: 0.376,
    w: 0.60,
    h: searched ? 0.20 : 0.34,
    rows: searched ? [ERROR_PRODUCT] : ERROR_PRODUCT_LIBRARY,
    rowKey: 'id',
    selectable: true,
    selectedKeys: [],
    columns: [{
      key: 'goodsName',
      title: '商品名称',
      width: 210
    }, {
      key: 'goodsShortName',
      title: '商品简称',
      width: 160
    }, {
      key: 'qty',
      type: 'input',
      title: '数量',
      width: 100
    }, {
      key: 'price',
      title: '单价',
      width: 90
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 160
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 110
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 120
    }]
  }];
}
function buildExchangeProductSelectTable() {
  return [{
    id: 'exchange-product-select-table',
    x: 0.214,
    y: 0.25,
    w: 0.60,
    h: 0.17,
    rows: MOCK_GOODS_ROWS,
    rowKey: 'id',
    selectable: true,
    selectedKeys: [],
    columns: [{
      key: 'image',
      type: 'image',
      title: '图片',
      width: 70
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 260
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 150
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 120
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 150
    }, {
      key: 'qty',
      title: '数量',
      width: 80
    }, {
      key: 'price',
      title: '单价',
      width: 80
    }]
  }];
}
function productSearchLabels(_ref12) {
  var ui = _ref12.ui;
  var selected = ui['error-product-search-tableSelectedKeys'] || [];
  var codes = ERROR_PRODUCT_LIBRARY.filter(function (row) {
    return selected.includes(row.id);
  }).map(function (row) {
    return row.goodsCode;
  });
  return [{
    id: 'error-product-count',
    text: String(selected.length),
    color: '#5045a8',
    fontSize: 12,
    bgColor: '#fff',
    x: 0.256,
    y: 0.344,
    w: 0.02,
    h: 0.02
  }, {
    id: 'error-product-codes',
    text: codes.join('，'),
    color: '#5045a8',
    fontSize: 12,
    bgColor: '#fff',
    justifyContent: 'flex-start',
    x: 0.28,
    y: 0.344,
    w: 0.52,
    h: 0.02
  }];
}
var SCENE_IMAGES = {
  fastEmpty: r('1-2.png'),
  fast: r('2-0-aftersale-fast.png'),
  order: r('2-0-order.png'),
  search: r('2-1-search.png'),
  resend: r('2-4-普通补发.png'),
  repair: r('2-5-普通维修.png'),
  errorReturnRefund: r('2-7-错发退货退款.png'),
  errorExchange: r('2-9-错发换货.png'),
  leakBusiness: r('ppt/2-18-漏发补发问题类型.png'),
  leakResend: r('ppt/2-21-漏发补发建单.png'),
  errorProductSearch: r('ppt/2-16-错发退货退款问题选择.png'),
  errorProductSearchResult: r('ppt/2-17-错发退货退款商品库.png'),
  exchangeProductSelect: r('ppt/2-34-错发换货选择订单商品.png')
};
var EMPTY_RETURN_FORM = {
  returnExpress: '',
  returnWaybill: '',
  returnWarehouse: '',
  remark: '',
  buyerSubsidy: ''
};
var EMPTY_RECEIVER_FORM = {
  buyerProvince: '',
  buyerCity: '',
  buyerDistrict: '',
  buyerDetail: '',
  buyerReceiver: '',
  buyerReceiverPhone: '',
  receiverSmartInput: ''
};
var EMPTY_RESEND_FORM = {
  resendRemark: '',
  resendBuyerSubsidy: '',
  resendOutExpress: '',
  resendBuyerProvince: '',
  resendBuyerCity: '',
  resendBuyerDistrict: '',
  resendBuyerDetail: '',
  resendBuyerReceiver: '',
  resendBuyerPhone: '',
  resendSmartInput: ''
};
var EMPTY_ERROR_EXCHANGE_FORM = _objectSpread(_objectSpread(_objectSpread({}, EMPTY_RETURN_FORM), EMPTY_RECEIVER_FORM), {}, {
  outExpress: ''
});
var EMPTY_LEAK_RESEND_FORM = {
  leakRemark: '',
  leakBuyerSubsidy: '',
  leakOutExpress: '',
  leakBuyerProvince: '',
  leakBuyerCity: '',
  leakBuyerDistrict: '',
  leakBuyerDetail: '',
  leakBuyerReceiver: '',
  leakBuyerPhone: '',
  leakSmartInput: ''
};
var SECOND_CHAPTER_TIPS = ['线上订单号为' + (0, _jstTip.red)('5124299977002014714') + '的订单中商品编码为' + (0, _jstTip.red)('TEST-GD-0001') + '的商品，买家需要退回，原因是' + (0, _jstTip.red)('买错了') + '，符合' + (0, _jstTip.red)('7天无理由退回') + '场景，现已寄回商品，邮费由' + (0, _jstTip.red)('买家承担') + '，需创建新的售后单。' + (0, _jstTip.br)() + '快递信息：' + (0, _jstTip.red)('申通快递') + '，单号' + (0, _jstTip.red)('st12654458855') + '。', '手机号' + (0, _jstTip.red)('115680518989') + '关联的订单商品' + (0, _jstTip.red)('TEST-GD-0001') + '破损需要补发' + (0, _jstTip.red)('1件') + '。' + (0, _jstTip.br)() + '卖家将使用' + (0, _jstTip.red)('京东快递') + '寄出，买家收货信息“' + (0, _jstTip.red)(EXCHANGE_RECEIVER_TEXT) + '”。', '订单号' + (0, _jstTip.red)('381499') + '关联的商品维修' + (0, _jstTip.red)('TEST-GD-0001') + '，需要寄回维修，维修金额' + (0, _jstTip.red)('99元') + '。' + (0, _jstTip.br)() + '买家现已使用' + (0, _jstTip.red)('申通快递') + '寄回商品，单号为' + (0, _jstTip.red)('st12654458855') + '，寄回仓库为' + (0, _jstTip.red)('淘金仓库') + '，维修好后再寄给买家，需买家承担邮费' + (0, _jstTip.red)('8元') + '。' + (0, _jstTip.br)() + '买家收货地址：' + (0, _jstTip.red)(EXCHANGE_RECEIVER_TEXT), '线上订单号 ' + (0, _jstTip.red)('5124299977002014714') + '关联的商品' + (0, _jstTip.red)('TEST-GD-0001') + (0, _jstTip.red)('未发') + '，错发了商品' + (0, _jstTip.red)('STY-BSK-001') + '。' + (0, _jstTip.br)() + '买家已使用' + (0, _jstTip.red)('申通快递') + '退回错发商品，' + (0, _jstTip.red)('st12654458855') + '，退回' + (0, _jstTip.red)('淘金仓库') + '。', '线上订单号' + (0, _jstTip.red)('5124299977002014714') + '关联的商品' + (0, _jstTip.red)('TEST-GD-0001') + '的商品' + (0, _jstTip.red)('应发未发') + '，错发了商品' + (0, _jstTip.red)('STY-BSK-001') + '。买家已使用' + (0, _jstTip.red)('申通快递') + '退回错发商品，' + (0, _jstTip.red)('st12654458855') + '，退回' + (0, _jstTip.red)('淘金仓库') + '，同时需使用' + (0, _jstTip.red)('京东快递') + '寄出未发商品，买家收件地址为：' + (0, _jstTip.red)(EXCHANGE_RECEIVER_TEXT), '线上订单号' + (0, _jstTip.red)('5124299977002014714') + '关联商品' + (0, _jstTip.red)('漏发') + '，需要' + (0, _jstTip.red)('补发') + '。' + (0, _jstTip.br)() + '卖家将使用' + (0, _jstTip.red)('京东快递') + '寄出，买家收货地址为：' + (0, _jstTip.red)(EXCHANGE_RECEIVER_TEXT)];
function getSecondChapterTip(_ref13) {
  var ui = _ref13.ui;
  var createdCount = (ui.createdOrders || []).length;
  return SECOND_CHAPTER_TIPS[Math.min(createdCount, SECOND_CHAPTER_TIPS.length - 1)];
}
var SECOND_CHAPTER_STEPS = [{
  id: 'fasts',
  image: function image(_ref14) {
    var ui = _ref14.ui;
    return (ui.createdOrders || []).length ? SCENE_IMAGES.fast : SCENE_IMAGES.fastEmpty;
  },
  tip: function tip(_ref15) {
    var ui = _ref15.ui;
    return ui.leakFlowCompleted ? '<span style="color:red;font-weight:bold;">漏发补发售后单已创建，本流程已完成。</span>' : '<span style="color:red;font-weight:bold;">手工创建售后单</span>';
  },
  tables: buildCreatedTables,
  hotspots: function hotspots(_ref16) {
    var ui = _ref16.ui;
    return ui.leakFlowCompleted ? [] : [{
      id: 'addOrderButton',
      x: 0.8055,
      y: 0.52,
      w: 0.08,
      h: 0.03,
      highlight: 'primary',
      set: {
        'order-tableSelectedKeys': [],
        'order-tableSelectedRows': [],
        'goods-tableSelectedKeys': [],
        'goods-tableSelectedRows': [],
        goodsTableDraft: {}
      },
      setForm: {
        orderCode: '',
        orderNo: '',
        buyerPhone: ''
      },
      next: 'order'
    }];
  }
}, {
  id: 'fasts-complete',
  image: SCENE_IMAGES.fast,
  tip: '<span style="color:red;font-weight:bold;">漏发补发售后单已创建，本流程已完成。</span>',
  tables: buildCreatedTables,
  hotspots: [],
  isEnd: true
}, {
  id: 'order',
  image: SCENE_IMAGES.order,
  tip: function tip(_ref17) {
    var ui = _ref17.ui;
    var count = (ui.createdOrders || []).length;
    if (count === 1) return '查询手机号为<span style="color:red;font-weight:bold;">115680518989</span>的订单，并创建<span style="color:red;font-weight:bold;">普通业务类型-仅退款</span>售后单';
    if (count === 2) return '搜索<span style="color:red;font-weight:bold;">订单号为' + TARGET_ORDER_NO + '</span>的订单。';
    return '搜索<span style="color:red;font-weight:bold;">线上订单号为' + TARGET_ORDER_CODE + '</span>的订单，并创建<span style="color:red;font-weight:bold;">普通业务类型-退货退款</span>售后单';
  },
  fields: function fields(_ref18) {
    var ui = _ref18.ui;
    var count = (ui.createdOrders || []).length;
    if (count === 1) return [{
      id: 'buyer-phone',
      model: 'buyerPhone',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 10,
      placeholder: '多个手机号，以逗号分隔',
      x: 0.25,
      y: 0.122,
      w: 0.085,
      h: 0.02
    }];
    if (count === 2) return [{
      id: 'order-no',
      model: 'orderNo',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 10,
      placeholder: '多个订单号，以逗...',
      x: 0.355,
      y: 0.122,
      w: 0.085,
      h: 0.02
    }];
    return [{
      id: 'order-code',
      model: 'orderCode',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 10,
      placeholder: '多个线上订单号，...',
      x: 0.465,
      y: 0.122,
      w: 0.08,
      h: 0.02
    }];
  },
  hotspots: [{
    id: 'search-btn-order',
    x: 0.915,
    y: 0.154,
    w: 0.03,
    h: 0.03,
    highlight: 'primary',
    guard: function guard(_ref19) {
      var ui = _ref19.ui,
        form = _ref19.form;
      return (ui.createdOrders || []).length === 1 ? form.buyerPhone === '115680518989' ? {
        ok: true
      } : {
        ok: false,
        msg: '请输入手机号 115680518989'
      } : (ui.createdOrders || []).length === 2 ? (form.orderNo || '').trim() === TARGET_ORDER_NO ? {
        ok: true
      } : {
        ok: false,
        msg: '请输入正确的订单号 ' + TARGET_ORDER_NO
      } : (form.orderCode || '').trim() === TARGET_ORDER_CODE ? {
        ok: true
      } : {
        ok: false,
        msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE
      };
    },
    set: {
      'order-tableSelectedKeys': [],
      'order-tableSelectedRows': [],
      'goods-tableSelectedKeys': [],
      'goods-tableSelectedRows': [],
      goodsTableDraft: {}
    },
    setForm: EMPTY_RETURN_FORM,
    next: 'search'
  }]
}, {
  id: 'search',
  image: SCENE_IMAGES.search,
  tip: function tip(_ref20) {
    var ui = _ref20.ui;
    var count = (ui.createdOrders || []).length;
    if (count === 0) return '退货场景：买家要求<span style="color:red;font-weight:bold;">无理由退货</span>，选中要退货的商品（商品编码：<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>），填入买家退回快递信息：<span style="color:red;font-weight:bold;">申通快递</span>，单号<span style="color:red;font-weight:bold;">st12654458855</span>。备注：<span style="color:red;font-weight:bold;">7天无理由</span>，买家应补运费<span style="color:red;font-weight:bold;">8元</span>。';
    if (count === 1) return '查看<span style="color:red;font-weight:bold;">普通业务类型-仅退款</span>的售后分类。';
    if (count === 3) return '查看<span style="color:red;font-weight:bold;">错发业务类型-退货退款</span>的售后分类。';
    return '查看<span style="color:red;font-weight:bold;">普通业务类型-拒收退货</span>的售后分类。';
  },
  fields: function fields(_ref21) {
    var ui = _ref21.ui;
    return (ui.createdOrders || []).length === 1 ? [{
      id: 'search-phone',
      model: 'buyerPhone',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 10,
      placeholder: '多个手机号，以逗号分隔',
      x: 0.25,
      y: 0.122,
      w: 0.085,
      h: 0.02
    }] : [].concat((0, _toConsumableArray2.default)((ui.createdOrders || []).length === 2 ? [{
      id: 'search-order-no',
      model: 'orderNo',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 11,
      placeholder: '多个订单号，以逗...',
      x: 0.355,
      y: 0.122,
      w: 0.085,
      h: 0.02
    }] : [{
      id: 'search-code',
      model: 'orderCode',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 11,
      placeholder: '多个线上订单号，...',
      x: 0.465,
      y: 0.122,
      w: 0.08,
      h: 0.02
    }]), (0, _toConsumableArray2.default)((ui.createdOrders || []).length === 0 ? buildReturnFields() : []));
  },
  tables: function tables(context) {
    return buildTables(context, DEFAULT_GOODS_TABLE_POSITION, {
      goodsSelectionDisabled: (context.ui.createdOrders || []).length === 1
    });
  },
  hotspots: function hotspots(_ref22) {
    var ui = _ref22.ui;
    return [].concat((0, _toConsumableArray2.default)((ui.createdOrders || []).length === 0 ? [{
      id: 'search-btn-search',
      x: 0.915,
      y: 0.154,
      w: 0.03,
      h: 0.03,
      highlight: 'primary',
      guard: function guard(_ref23) {
        var form = _ref23.form;
        var code = (form.orderCode || '').trim();
        if (!code) return {
          ok: false,
          msg: '请输入线上订单号'
        };
        if (code !== TARGET_ORDER_CODE) return {
          ok: false,
          msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE
        };
        return {
          ok: true
        };
      },
      set: {
        searchSearched: true
      }
    }] : []), (0, _toConsumableArray2.default)((ui.createdOrders || []).length === 1 ? [{
      id: 'select-ordinary-resend',
      x: 0.335,
      y: 0.42,
      w: 0.04,
      h: 0.03,
      highlight: 'primary',
      guard: requireOrderSelection,
      setForm: EMPTY_RESEND_FORM,
      next: 'resend'
    }] : []), (0, _toConsumableArray2.default)((ui.createdOrders || []).length === 2 ? [{
      id: 'select-ordinary-repair',
      x: 0.38,
      y: 0.42,
      w: 0.04,
      h: 0.03,
      highlight: 'primary',
      guard: requireOrderSelection,
      set: {
        'goods-tableSelectedKeys': [],
        goodsTableDraft: {}
      },
      setForm: _objectSpread(_objectSpread({}, EMPTY_RETURN_FORM), EMPTY_RECEIVER_FORM),
      next: 'repair'
    }] : []), (0, _toConsumableArray2.default)((ui.createdOrders || []).length === 3 ? [{
      id: 'select-error-business',
      x: 0.205,
      y: 0.36,
      w: 0.075,
      h: 0.04,
      highlight: 'primary',
      guard: requireOrderSelection,
      setForm: EMPTY_RETURN_FORM,
      next: 'error-return-refund'
    }] : []), (0, _toConsumableArray2.default)((ui.createdOrders || []).length === 4 ? [{
      id: 'select-error-business-refund',
      x: 0.205,
      y: 0.36,
      w: 0.075,
      h: 0.04,
      highlight: 'primary',
      guard: requireOrderSelection,
      next: 'error-business-refund'
    }] : []), (0, _toConsumableArray2.default)((ui.createdOrders || []).length === 5 ? [{
      id: 'select-leak-business',
      x: 0.281,
      y: 0.36,
      w: 0.078,
      h: 0.04,
      highlight: 'primary',
      guard: requireOrderSelection,
      next: 'leak-business'
    }] : []), (0, _toConsumableArray2.default)((ui.createdOrders || []).length === 0 ? [{
      id: 'create-ordinary-return',
      x: 0.956,
      y: 0.962,
      w: 0.036,
      h: 0.032,
      highlight: 'primary',
      guard: function guard(_ref24) {
        var ui = _ref24.ui,
          form = _ref24.form;
        if (!(ui['goods-tableSelectedKeys'] || []).includes('goods-1')) return {
          ok: false,
          msg: '请选中要退货的商品'
        };
        var required = ['returnExpress', 'returnWaybill', 'returnWarehouse'];
        if (required.some(function (key) {
          return !String(form[key] || '').trim();
        })) return {
          ok: false,
          msg: '请完成退货快递和仓库信息'
        };
        var buyerSubsidy = String(form.buyerSubsidy || '').trim();
        if (buyerSubsidy && buyerSubsidy !== '0') return {
          ok: false,
          msg: '邮费由买家承担，请填写0'
        };
        return {
          ok: true
        };
      },
      action: function action(_ref25) {
        var ui = _ref25.ui,
          form = _ref25.form;
        var drafts = ui.goodsTableDraft || {};
        var firstGoods = _objectSpread(_objectSpread({}, MOCK_GOODS_ROWS[0]), drafts['goods-1'] || {});
        return {
          set: {
            createdOrders: (ui.createdOrders || []).concat({
              serialNo: (ui.createdOrders || []).length + 1,
              aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
              internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
              aftersaleStatus: '待确认',
              solution: '',
              onlineStatus: '等待买家退货',
              onlineType: '普通退货',
              aftersaleCategory: '退货退款',
              goodsInfo: firstGoods.goodsName + '\n商品明细  合计：1',
              returnWaybill: form.returnWaybill,
              returnInternationalWaybill: '',
              cargoStatus: '买家已收到货',
              expressInterceptStatus: '',
              operation: '编辑\n查看日志'
            }),
            goodsTableDraft: {},
            'goods-tableSelectedKeys': []
          },
          setForm: {
            orderCode: '',
            returnExpress: '',
            returnWaybill: '',
            returnWarehouse: '',
            remark: '',
            buyerSubsidy: ''
          },
          next: 'fasts'
        };
      }
    }] : []));
  }
}, {
  id: 'leak-business',
  image: SCENE_IMAGES.leakBusiness,
  tip: '创建<span style="color:red;font-weight:bold;">漏发业务类型-补发</span>的售后单，售后问题类型选择<span style="color:red;font-weight:bold;">商品少件或破损</span>。',
  fields: function fields(_ref26) {
    var form = _ref26.form;
    return [{
      id: 'leak-business-search-code',
      model: 'orderCode',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 11,
      placeholder: '多个线上订单号，...',
      x: 0.465,
      y: 0.122,
      w: 0.08,
      h: 0.02
    }].concat((0, _toConsumableArray2.default)(buildLeakResendFields(form)));
  },
  tables: function tables(context) {
    return buildLeakResendTables(context, true);
  },
  hotspots: [{
    id: 'select-leak-after-sale-issue',
    x: 0.196,
    y: 0.464,
    w: 0.074,
    h: 0.026,
    highlight: 'primary',
    set: {
      leakIssueSelected: true
    },
    next: 'leak-resend'
  }, {
    id: 'create-leak-resend-before-issue',
    x: 0.956,
    y: 0.962,
    w: 0.036,
    h: 0.032,
    highlight: 'primary',
    guard: function guard() {
      return {
        ok: false,
        msg: '请选择售后问题类型：商品少件或破损'
      };
    }
  }]
}, {
  id: 'leak-resend',
  image: SCENE_IMAGES.leakResend,
  tip: '<p style="margin:0 0 8px;">售后问题类型选择<span style="color:red;font-weight:bold;">商品少发或破损</span>。选中商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品，本次补发数量填写<span style="color:red;font-weight:bold;">1</span>，明细问题类型选择<span style="color:red;font-weight:bold;">应发未发</span>；</p><p style="margin:0 0 8px;">填写备注<span style="color:red;font-weight:bold;">漏发补发</span>，买家应补运费填写<span style="color:red;font-weight:bold;">0</span>，寄出快递选择<span style="color:red;font-weight:bold;">京东快递</span>。</p><p style="margin:0;">买家收货信息：“<span style="color:red;font-weight:bold;">' + EXCHANGE_RECEIVER_TEXT + '</span>”，确认地址、详细地址、联系人和联系电话后点击创建。</p>',
  tables: buildLeakResendTables,
  fields: function fields(_ref27) {
    var form = _ref27.form;
    return [{
      id: 'leak-resend-search-code',
      model: 'orderCode',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 11,
      placeholder: '多个线上订单号，...',
      x: 0.465,
      y: 0.122,
      w: 0.08,
      h: 0.02
    }].concat((0, _toConsumableArray2.default)(buildLeakResendFields(form)));
  },
  hotspots: [{
    id: 'create-leak-resend',
    x: 0.956,
    y: 0.962,
    w: 0.036,
    h: 0.032,
    highlight: 'primary',
    guard: function guard(_ref28) {
      var _first$qty;
      var ui = _ref28.ui,
        form = _ref28.form;
      if (!ui.leakIssueSelected) return {
        ok: false,
        msg: '请选择售后问题类型：商品少件或破损'
      };
      var draft = ui.goodsTableDraft || {};
      var first = draft['goods-1'] || {};
      if (String((_first$qty = first.qty) !== null && _first$qty !== void 0 ? _first$qty : 1) !== '1') return {
        ok: false,
        msg: '请填写商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 的补发数量 1'
      };
      if (first.issueType !== '应发未发') return {
        ok: false,
        msg: '请选择商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 的明细问题类型：应发未发'
      };
      if (!(ui['goods-tableSelectedKeys'] || []).includes('goods-1')) return {
        ok: false,
        msg: '请选中应发未发商品 ' + MOCK_GOODS_ROWS[0].goodsCode
      };
      var buyerSubsidy = String(form.leakBuyerSubsidy || '').trim();
      if (buyerSubsidy && buyerSubsidy !== '0') return {
        ok: false,
        msg: '无需买家承担运费'
      };
      if (form.leakOutExpress !== '京东快递') return {
        ok: false,
        msg: '寄出快递请选择京东快递'
      };
      if (!form.leakBuyerProvince || !form.leakBuyerCity || !form.leakBuyerDistrict || !form.leakBuyerDetail || !form.leakBuyerReceiver || !form.leakBuyerPhone) return {
        ok: false,
        msg: '请完成买家收货地址和收件人信息'
      };
      return {
        ok: true
      };
    },
    action: function action(_ref29) {
      var ui = _ref29.ui;
      return {
        set: {
          createdOrders: (ui.createdOrders || []).concat({
            serialNo: (ui.createdOrders || []).length + 1,
            aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
            internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
            aftersaleStatus: '待确认',
            solution: '',
            onlineStatus: '等待补发',
            onlineType: '漏发补发',
            aftersaleCategory: '补发',
            goodsInfo: MOCK_GOODS_ROWS[0].goodsName + '\n商品明细  合计：1',
            returnWaybill: '',
            returnInternationalWaybill: '',
            cargoStatus: '买家未收到货',
            expressInterceptStatus: '',
            operation: '编辑\n查看日志'
          }),
          goodsTableDraft: {},
          'goods-tableSelectedKeys': [],
          leakIssueSelected: false,
          leakFlowCompleted: true
        },
        setForm: _objectSpread({
          orderCode: ''
        }, EMPTY_LEAK_RESEND_FORM),
        next: 'fasts-complete'
      };
    }
  }]
}, {
  id: 'error-business-refund',
  image: SCENE_IMAGES.errorReturnRefund,
  tip: '',
  fields: [{
    id: 'error-business-search-code',
    model: 'orderCode',
    type: 'text',
    bgColor: '#FFFFFF',
    fontSize: 11,
    placeholder: '多个线上订单号，...',
    x: 0.465,
    y: 0.122,
    w: 0.08,
    h: 0.02
  }],
  tables: function tables(context) {
    return buildTables(context, DEFAULT_GOODS_TABLE_POSITION);
  },
  hotspots: [{
    id: 'select-error-exchange',
    x: 0.295,
    y: 0.42,
    w: 0.04,
    h: 0.03,
    highlight: 'primary',
    setForm: EMPTY_ERROR_EXCHANGE_FORM,
    next: 'error-exchange'
  }]
}, {
  id: 'resend',
  image: SCENE_IMAGES.resend,
  tip: '<p style="margin:0 0 8px;">补发商品编号为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品，填写补发数量为<span style="color:red;font-weight:bold;">1</span>。</p><p style="margin:0 0 8px;">在商品列表下方填写备注<span style="color:red;font-weight:bold;">破损补发</span>、买家应补运费<span style="color:red;font-weight:bold;">0</span>，寄出快递选择<span style="color:red;font-weight:bold;">京东快递</span>。</p><p style="margin:0;">买家收货信息“<span style="color:red;font-weight:bold;">' + EXCHANGE_RECEIVER_TEXT + '</span>”，确认买家收货地址、详细地址、联系人和联系电话后点击创建。</p>',
  tables: function tables(context) {
    return buildTables(context, _54_GOODS_TABLE_POSITION, {
      goodsType: '补',
      goodsTypeColor: '#e6a23c',
      qtyTitle: '补发数量',
      amountTitle: '补发金额',
      defaultQty: 0,
      defaultAmount: 0,
      amountInputDisabled: true
    });
  },
  fields: function fields(_ref30) {
    var form = _ref30.form;
    return [{
      id: 'search-code',
      model: 'orderCode',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 11,
      placeholder: '多个线上订单号，...',
      x: 0.465,
      y: 0.122,
      w: 0.08,
      h: 0.02
    }].concat((0, _toConsumableArray2.default)(buildResendFields(form)));
  },
  hotspots: [{
    id: 'create-ordinary-resend',
    x: 0.956,
    y: 0.962,
    w: 0.036,
    h: 0.032,
    highlight: 'primary',
    guard: function guard(_ref31) {
      var ui = _ref31.ui,
        form = _ref31.form;
      if (!(ui['goods-tableSelectedKeys'] || []).includes('goods-1')) return {
        ok: false,
        msg: '请选中要补发的商品'
      };
      var draft = (ui.goodsTableDraft || {})['goods-1'] || {};
      if (String(draft.qty || '') !== '1') return {
        ok: false,
        msg: '请填写补发数量 1'
      };
      if (form.resendOutExpress !== '京东快递') return {
        ok: false,
        msg: '寄出快递请选择京东快递'
      };
      if (!form.resendBuyerProvince || !form.resendBuyerCity || !form.resendBuyerDistrict || !form.resendBuyerDetail || !form.resendBuyerReceiver || !form.resendBuyerPhone) {
        return {
          ok: false,
          msg: '请完成买家收货地址和收件人信息'
        };
      }
      return {
        ok: true
      };
    },
    action: function action(_ref32) {
      var ui = _ref32.ui;
      var createdOrders = (ui.createdOrders || []).concat({
        serialNo: (ui.createdOrders || []).length + 1,
        aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
        internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
        aftersaleStatus: '待确认',
        solution: '',
        onlineStatus: '等待补发',
        onlineType: '普通补发',
        aftersaleCategory: '补发',
        goodsInfo: MOCK_GOODS_ROWS[0].goodsName + '\n商品明细  合计：1',
        returnWaybill: '',
        returnInternationalWaybill: '',
        cargoStatus: '买家未收到货',
        expressInterceptStatus: '',
        operation: '编辑\n查看日志'
      });
      return {
        set: {
          createdOrders: createdOrders,
          goodsTableDraft: {},
          'goods-tableSelectedKeys': []
        },
        setForm: {
          orderCode: '',
          orderNo: '',
          buyerPhone: ''
        },
        next: 'fasts'
      };
    }
  }]
}, {
  id: 'repair',
  image: SCENE_IMAGES.repair,
  tip: '<p style="margin:0 0 8px;"><span style="color:red;font-weight:bold;">维修业务场景：</span>针对退回商品进行货品维修处理；确认维修售后单后创建维修发货单，并在维修单据界面将维修完成的商品发给买家。售后收货和维修发货过程中<span style="color:red;font-weight:bold;">库存不变</span>。</p><p style="margin:0 0 8px;">商品处理：选中商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品，维修数量填写<span style="color:red;font-weight:bold;">1</span>，维修金额填写<span style="color:red;font-weight:bold;">99</span>元。</p><p style="margin:0 0 8px;">买家寄件：退回快递公司填写<span style="color:red;font-weight:bold;">申通快递</span>，单号填写<span style="color:red;font-weight:bold;">st12654458855</span>；退货仓库选择<span style="color:red;font-weight:bold;">淘金仓库</span>，备注填写<span style="color:red;font-weight:bold;">维修返件</span>。买家应补运费<span style="color:red;font-weight:bold;">8元</span>。</p><p style="margin:0;">买家收货地址：“<span style="color:red;font-weight:bold;">' + EXCHANGE_RECEIVER_TEXT + '</span>”，确认后点击创建。</p>',
  tables: function tables(context) {
    return buildTables(context, DEFAULT_GOODS_TABLE_POSITION, {
      goodsType: '修',
      goodsTypeColor: '#e6a23c',
      qtyTitle: '维修数量',
      amountTitle: '维修金额',
      defaultQty: 0
    });
  },
  fields: function fields(_ref33) {
    var form = _ref33.form;
    return [{
      id: 'search-order-no',
      model: 'orderNo',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 11,
      placeholder: '多个订单号，以逗...',
      x: 0.355,
      y: 0.122,
      w: 0.085,
      h: 0.02
    }].concat((0, _toConsumableArray2.default)(buildRepairFields(form)));
  },
  hotspots: [{
    id: 'create-ordinary-repair',
    x: 0.956,
    y: 0.962,
    w: 0.036,
    h: 0.032,
    highlight: 'primary',
    guard: function guard(_ref34) {
      var ui = _ref34.ui,
        form = _ref34.form;
      if (!(ui['goods-tableSelectedKeys'] || []).includes('goods-1')) return {
        ok: false,
        msg: '请选中要维修的商品'
      };
      var draft = (ui.goodsTableDraft || {})['goods-1'] || {};
      if (String(draft.qty || '') !== '1' || String(draft.amount || '') !== '99') {
        return {
          ok: false,
          msg: '请填写维修数量 1 和维修金额 99'
        };
      }
      if (['returnExpress', 'returnWaybill', 'returnWarehouse'].some(function (key) {
        return !String(form[key] || '').trim();
      })) return {
        ok: false,
        msg: '请完成买家寄件信息'
      };
      if (String(form.buyerSubsidy || '').trim() !== '8') return {
        ok: false,
        msg: '买家应补运费请填写8'
      };
      if (!form.buyerProvince || !form.buyerCity || !form.buyerDistrict || !form.buyerDetail || !form.buyerReceiver || !form.buyerReceiverPhone) return {
        ok: false,
        msg: '请完成买家收货地址和收件人信息'
      };
      return {
        ok: true
      };
    },
    action: function action(_ref35) {
      var ui = _ref35.ui;
      var firstGoods = _objectSpread(_objectSpread({}, MOCK_GOODS_ROWS[0]), (ui.goodsTableDraft || {})['goods-1'] || {});
      var createdOrders = (ui.createdOrders || []).concat({
        serialNo: (ui.createdOrders || []).length + 1,
        aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
        internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
        aftersaleStatus: '待确认',
        solution: '',
        onlineStatus: '等待买家寄回',
        onlineType: '普通维修',
        aftersaleCategory: '维修',
        goodsInfo: firstGoods.goodsName + '\n商品明细  合计：1',
        returnWaybill: '',
        returnInternationalWaybill: '',
        cargoStatus: '买家已收到货',
        expressInterceptStatus: '',
        operation: '编辑\n查看日志'
      });
      return {
        set: {
          createdOrders: createdOrders,
          goodsTableDraft: {},
          'goods-tableSelectedKeys': []
        },
        setForm: {
          orderNo: ''
        },
        next: 'fasts'
      };
    }
  }]
}, {
  id: 'error-return-refund',
  image: SCENE_IMAGES.errorReturnRefund,
  tip: '<span style="color:red;font-weight:bold;">选中</span>商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品且标记为<span style="color:red;font-weight:bold;">应发未发</span>，然后添加错发已发商品（款式编码：<span style="color:red;font-weight:bold;">' + ERROR_PRODUCT_STYLE_CODE + '</span>）。再填入买家退回快递信息：<span style="color:red;font-weight:bold;">申通快递，单号 st12654458855</span>；退回仓库选择<span style="color:red;font-weight:bold;">淘金仓库</span>；备注填写<span style="color:red;font-weight:bold;">错发退货</span>；买家应补运费填写<span style="color:red;font-weight:bold;">0</span>。',
  tables: buildErrorReturnTables,
  fields: [{
    id: 'search-code',
    model: 'orderCode',
    type: 'text',
    bgColor: '#FFFFFF',
    fontSize: 11,
    placeholder: '多个线上订单号，...',
    x: 0.465,
    y: 0.122,
    w: 0.08,
    h: 0.02
  }].concat((0, _toConsumableArray2.default)(buildReturnFields())),
  hotspots: [{
    id: 'add-error-issued-goods',
    x: 0.14,
    y: 0.46,
    w: 0.09,
    h: 0.03,
    highlight: 'primary',
    guard: function guard(_ref36) {
      var ui = _ref36.ui;
      return ((ui.goodsTableDraft || {})['goods-1'] || {}).issueType === '应发未发' ? {
        ok: true
      } : {
        ok: false,
        msg: '请先将商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 标记为应发未发'
      };
    },
    set: {
      errorProductReturnStep: 'error-return-refund'
    },
    setForm: {
      errorProductStyleCode: ''
    },
    next: 'error-product-search'
  }, {
    id: 'create-error-return-refund',
    x: 0.956,
    y: 0.962,
    w: 0.036,
    h: 0.032,
    highlight: 'primary',
    guard: function guard(_ref37) {
      var ui = _ref37.ui,
        form = _ref37.form;
      var drafts = ui.goodsTableDraft || {};
      var addedGoods = ui.errorAddedGoods || [];
      if ((drafts['goods-1'] || {}).issueType !== '应发未发') return {
        ok: false,
        msg: '请将商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 标记为应发未发'
      };
      if (!addedGoods.some(function (row) {
        return row.goodsCode === ERROR_PRODUCT.goodsCode && row.issueType === '错发已发';
      })) {
        return {
          ok: false,
          msg: '请添加并标记错发已发商品 ' + ERROR_PRODUCT.goodsCode
        };
      }
      var required = ['returnExpress', 'returnWaybill', 'returnWarehouse'];
      if (required.some(function (key) {
        return !String(form[key] || '').trim();
      })) return {
        ok: false,
        msg: '请完成退回快递和仓库信息'
      };
      var buyerSubsidy = String(form.buyerSubsidy || '').trim();
      if (buyerSubsidy && buyerSubsidy !== '0') return {
        ok: false,
        msg: '错发无需买家承担运费'
      };
      var selectedKeys = ui['goods-tableSelectedKeys'] || [];
      if (!selectedKeys.includes('goods-1')) return {
        ok: false,
        msg: '请选中原订单商品 ' + MOCK_GOODS_ROWS[0].goodsCode
      };
      return selectedKeys.includes(ERROR_PRODUCT.id) ? {
        ok: true
      } : {
        ok: false,
        msg: '请选中错发已发商品 ' + ERROR_PRODUCT.goodsCode
      };
    },
    action: function action(_ref38) {
      var ui = _ref38.ui,
        form = _ref38.form;
      var firstGoods = _objectSpread(_objectSpread({}, MOCK_GOODS_ROWS[0]), (ui.goodsTableDraft || {})['goods-1'] || {});
      var createdOrders = (ui.createdOrders || []).concat({
        serialNo: (ui.createdOrders || []).length + 1,
        aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
        internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
        aftersaleStatus: '待确认',
        solution: '',
        onlineStatus: '等待买家退货',
        onlineType: '错发退货',
        aftersaleCategory: '退货退款',
        goodsInfo: firstGoods.goodsName + '\n商品明细  合计：1',
        returnWaybill: form.returnWaybill,
        returnInternationalWaybill: '',
        cargoStatus: '买家已收到货',
        expressInterceptStatus: '',
        operation: '编辑\n查看日志'
      });
      return {
        set: {
          createdOrders: createdOrders,
          goodsTableDraft: {},
          'goods-tableSelectedKeys': [],
          errorAddedGoods: [],
          errorProductReturnStep: '',
          errorFlow: 'refund'
        },
        setForm: {
          returnExpress: '',
          returnWaybill: '',
          returnWarehouse: '',
          remark: '',
          buyerSubsidy: ''
        },
        next: 'fasts'
      };
    }
  }]
}, {
  id: 'error-product-search',
  image: SCENE_IMAGES.errorProductSearch,
  tip: '在本地商品库中搜索款式编码为<span style="color:red;font-weight:bold;">' + ERROR_PRODUCT_STYLE_CODE + '</span>的错发已发商品。',
  labels: productSearchLabels,
  tables: function tables() {
    return buildProductSearchTable(false);
  },
  fields: [{
    id: 'error-product-style-code',
    model: 'errorProductStyleCode',
    type: 'text',
    bgColor: '#FFFFFF',
    fontSize: 10,
    placeholder: '款式编码',
    x: 0.42,
    y: 0.257,
    w: 0.09,
    h: 0.026
  }],
  hotspots: [{
    id: 'search-error-product',
    x: 0.743,
    y: 0.292,
    w: 0.033,
    h: 0.03,
    highlight: 'primary',
    guard: function guard(_ref39) {
      var form = _ref39.form;
      return (form.errorProductStyleCode || '').trim().toUpperCase() === ERROR_PRODUCT_STYLE_CODE.toUpperCase() ? {
        ok: true
      } : {
        ok: false,
        msg: '请输入正确的款式编码 ' + ERROR_PRODUCT_STYLE_CODE
      };
    },
    set: {
      'error-product-search-tableSelectedKeys': []
    },
    next: 'error-product-search-result'
  }]
}, {
  id: 'error-product-search-result',
  image: SCENE_IMAGES.errorProductSearchResult,
  tip: '选中商品编码为<span style="color:red;font-weight:bold;">' + ERROR_PRODUCT.goodsCode + '</span>的商品并确认添加。',
  labels: productSearchLabels,
  tables: function tables() {
    return buildProductSearchTable(true);
  },
  fields: [{
    id: 'error-product-style-code-result',
    model: 'errorProductStyleCode',
    type: 'text',
    bgColor: '#FFFFFF',
    fontSize: 11,
    placeholder: '款式编码',
    x: 0.42,
    y: 0.255,
    w: 0.09,
    h: 0.026
  }],
  hotspots: [{
    id: 'confirm-error-product',
    x: 0.786,
    y: 0.622,
    w: 0.035,
    h: 0.032,
    highlight: 'primary',
    guard: function guard(_ref40) {
      var ui = _ref40.ui;
      if (!(ui['error-product-search-tableSelectedKeys'] || []).includes(ERROR_PRODUCT.id)) return {
        ok: false,
        msg: '请选择要添加的商品'
      };
      if (MOCK_GOODS_ROWS.concat(ui.errorAddedGoods || []).some(function (row) {
        return row.goodsCode === ERROR_PRODUCT.goodsCode;
      })) {
        return {
          ok: false,
          msg: '该商品已在商品库中，不能重复添加'
        };
      }
      return {
        ok: true
      };
    },
    action: function action(_ref41) {
      var ui = _ref41.ui;
      return {
        set: {
          errorAddedGoods: (ui.errorAddedGoods || []).concat(ERROR_PRODUCT),
          'error-product-search-tableSelectedKeys': []
        },
        next: ui.errorProductReturnStep || 'error-return-refund'
      };
    }
  }]
}, {
  id: 'error-exchange',
  image: SCENE_IMAGES.errorExchange,
  tip: '<p style="margin:0 0 8px;">商品处理：将商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品标记为<span style="color:red;font-weight:bold;">应发未发</span>，并添加款式编码为<span style="color:red;font-weight:bold;">' + ERROR_PRODUCT_STYLE_CODE + '</span>的错发已发商品；再添加要换商品，必须选择商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品。</p><p style="margin:0 0 8px;">退回信息：快递公司填写<span style="color:red;font-weight:bold;">申通快递</span>，单号填写<span style="color:red;font-weight:bold;">st12654458855</span>；退回仓库选择<span style="color:red;font-weight:bold;">淘金仓库</span>，备注填写<span style="color:red;font-weight:bold;">错发换货</span>。</p><p style="margin:0 0 8px;">寄出信息：买家应补运费填写<span style="color:red;font-weight:bold;">0</span>，寄出快递选择<span style="color:red;font-weight:bold;">京东快递</span>。</p><p style="margin:0 0 8px;">收件人信息：“<span style="color:red;font-weight:bold;">' + EXCHANGE_RECEIVER_TEXT + '</span>”。</p><p style="margin:0;">完成后点击<span style="color:red;font-weight:bold;">创建</span>。</p>',
  tables: buildErrorExchangeTables,
  fields: function fields(_ref42) {
    var form = _ref42.form;
    return [{
      id: 'search-code',
      model: 'orderCode',
      type: 'text',
      bgColor: '#FFFFFF',
      fontSize: 11,
      placeholder: '多个线上订单号，...',
      x: 0.465,
      y: 0.122,
      w: 0.08,
      h: 0.02
    }].concat((0, _toConsumableArray2.default)(buildErrorExchangeFields(form)));
  },
  hotspots: [{
    id: 'add-error-issued-goods-exchange',
    x: 0.14,
    y: 0.46,
    w: 0.09,
    h: 0.03,
    highlight: 'primary',
    guard: function guard(_ref43) {
      var ui = _ref43.ui;
      return ((ui.goodsTableDraft || {})['goods-1'] || {}).issueType === '应发未发' ? {
        ok: true
      } : {
        ok: false,
        msg: '请先将商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 标记为应发未发'
      };
    },
    set: {
      errorProductReturnStep: 'error-exchange'
    },
    setForm: {
      errorProductStyleCode: ''
    },
    next: 'error-product-search'
  }, {
    id: 'add-exchange-goods',
    x: 0.335,
    y: 0.46,
    w: 0.09,
    h: 0.03,
    highlight: 'primary',
    next: 'exchange-product-select'
  }, {
    id: 'create-error-exchange',
    x: 0.956,
    y: 0.962,
    w: 0.036,
    h: 0.032,
    highlight: 'primary',
    guard: function guard(_ref44) {
      var ui = _ref44.ui,
        form = _ref44.form;
      var drafts = ui.goodsTableDraft || {};
      if ((drafts['goods-1'] || {}).issueType !== '应发未发') return {
        ok: false,
        msg: '请将原商品标记为应发未发'
      };
      if (!(ui.errorAddedGoods || []).some(function (row) {
        return row.goodsCode === ERROR_PRODUCT.goodsCode;
      })) return {
        ok: false,
        msg: '请添加错发已发商品'
      };
      if (!(ui.exchangeAddedGoods || []).some(function (row) {
        return row.goodsCode === MOCK_GOODS_ROWS[0].goodsCode && row.issueType === '无';
      })) return {
        ok: false,
        msg: '请添加要换商品'
      };
      var selectedKeys = ui['goods-tableSelectedKeys'] || [];
      if (!selectedKeys.includes('goods-1')) return {
        ok: false,
        msg: '请选中应发未发商品 ' + MOCK_GOODS_ROWS[0].goodsCode
      };
      if (!selectedKeys.includes(ERROR_PRODUCT.id)) return {
        ok: false,
        msg: '请选中错发已发商品 ' + ERROR_PRODUCT.goodsCode
      };
      if (!selectedKeys.includes(EXCHANGE_PRODUCT.id)) return {
        ok: false,
        msg: '请选中要换商品 ' + EXCHANGE_PRODUCT.goodsCode
      };
      if (['returnExpress', 'returnWaybill', 'returnWarehouse'].some(function (key) {
        return !String(form[key] || '').trim();
      })) return {
        ok: false,
        msg: '请完成买家退回信息'
      };
      var buyerSubsidy = String(form.buyerSubsidy || '').trim();
      if (buyerSubsidy && buyerSubsidy !== '0') return {
        ok: false,
        msg: '无需买家承担运费'
      };
      if (form.outExpress !== '京东快递') return {
        ok: false,
        msg: '寄出快递请选择京东快递'
      };
      if (!form.buyerProvince || !form.buyerCity || !form.buyerDistrict || !form.buyerDetail || !form.buyerReceiver || !form.buyerReceiverPhone) return {
        ok: false,
        msg: '请完成买家收货地址和收件人信息'
      };
      return {
        ok: true
      };
    },
    action: function action(_ref45) {
      var ui = _ref45.ui,
        form = _ref45.form;
      return {
        set: {
          createdOrders: (ui.createdOrders || []).concat({
            serialNo: (ui.createdOrders || []).length + 1,
            aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
            internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
            aftersaleStatus: '待确认',
            solution: '',
            onlineStatus: '等待买家退货',
            onlineType: '错发换货',
            aftersaleCategory: '换货',
            goodsInfo: MOCK_GOODS_ROWS[0].goodsName + '\n商品明细  合计：3',
            returnWaybill: form.returnWaybill,
            returnInternationalWaybill: '',
            cargoStatus: '买家已收到货',
            expressInterceptStatus: '',
            operation: '编辑\n查看日志'
          }),
          goodsTableDraft: {},
          'goods-tableSelectedKeys': [],
          errorAddedGoods: [],
          exchangeAddedGoods: [],
          errorProductReturnStep: '',
          errorFlow: ''
        },
        next: 'fasts'
      };
    }
  }]
}, {
  id: 'exchange-product-select',
  image: SCENE_IMAGES.exchangeProductSelect,
  tip: '选择商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的要换商品并确认添加。',
  tables: buildExchangeProductSelectTable,
  hotspots: [{
    id: 'confirm-exchange-product',
    x: 0.786,
    y: 0.436,
    w: 0.035,
    h: 0.032,
    highlight: 'primary',
    guard: function guard(_ref46) {
      var ui = _ref46.ui;
      return (ui['exchange-product-select-tableSelectedKeys'] || []).includes('goods-1') ? {
        ok: true
      } : {
        ok: false,
        msg: '请选择商品编码 ' + MOCK_GOODS_ROWS[0].goodsCode
      };
    },
    action: function action() {
      return {
        set: {
          exchangeAddedGoods: [EXCHANGE_PRODUCT],
          'exchange-product-select-tableSelectedKeys': []
        },
        next: 'error-exchange'
      };
    }
  }]
}];
function getJstErpSecondScenario() {
  return {
    initialStepId: 'fasts',
    initialForm: {
      orderCode: ''
    },
    steps: SECOND_CHAPTER_STEPS.map(function (step) {
      return _objectSpread(_objectSpread({}, step), {}, {
        tip: getSecondChapterTip,
        aspectRatio: 1912 / 956
      });
    })
  };
}

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jst-erp-scene" },
    [
      _c("StepPlayer", {
        ref: "player",
        attrs: {
          steps: _vm.scenario.steps,
          "initial-step-id": _vm.scenario.initialStepId,
          "initial-form": _vm.scenario.initialForm,
          "show-tip": false
        },
        on: {
          "step-change": _vm.onStepChange,
          "guard-failed": _vm.onGuardFailed,
          finish: _vm.onFinish
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-634d6f4a", esExports)
  }
}

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1367);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("52713df8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-06264f63\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpCreateAftersaleScene.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-06264f63\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpCreateAftersaleScene.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.jst-erp-scene[data-v-06264f63] {\n  width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  color: #303133;\n  text-align: left;\n  background: #fff;\n}\n[data-v-06264f63] .step-player {\n  display: block;\n  width: 100%;\n}\n[data-v-06264f63] .step-player .stage {\n  width: 100%;\n  min-height: 420px;\n  overflow: hidden;\n  background-color: #eef2f7;\n}\n[data-v-06264f63] .step-player .hotspot {\n  z-index: 3;\n}\n[data-v-06264f63] .step-player .field {\n  z-index: 4;\n  border-radius: 2px;\n}\n[data-v-06264f63] .step-player .field-input {\n  color: #303133;\n  background: rgba(255, 255, 255, 0.01);\n}\n", ""]);

// exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJstErpCreateAftersaleScenario = getJstErpCreateAftersaleScenario;
var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(460));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1369));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _jstProvinces = _interopRequireDefault(__webpack_require__(584));
var _jstCities = _interopRequireDefault(__webpack_require__(585));
var _jstDistricts = _interopRequireDefault(__webpack_require__(586));
var _jstErpFixtureData = __webpack_require__(301);
var _jstTip = __webpack_require__(302);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * 聚水潭 ERP 第三章「创建售后」场景，素材对应《聚水潭功能学习》PPT 第 38-45 页。
 */
function r(path) {
  return __webpack_require__(303)("./" + path);
}
var TARGET_ORDER_CODE = _jstErpFixtureData.JST_TARGETS.createAftersaleOrder;
var DETAIL_ORDER_CODE = '331273354843811187';
var TARGET_PRACTICE_GOODS_CODE = _jstErpFixtureData.JST_CREATE_GOODS[0].goodsCode;
var TARGET_PRACTICE_STYLE_CODE = _jstErpFixtureData.JST_CREATE_GOODS[0].styleCode;
var DOMESTIC_EXPRESS_COMPANIES = ['EMS', '邮政快递包裹', '顺丰速运', '顺丰同城', '京东快递', '中通快递', '圆通速递', '申通快递', '韵达快递', '极兔速递', '德邦快递', '菜鸟速递', '百世快递'];
var DIRECT_CONTROLLED_MUNICIPALITIES = ['北京市', '天津市', '上海市', '重庆市'];
function findReceiverProvince(provinceName) {
  return _jstProvinces.default.find(function (item) {
    return item.name === provinceName;
  });
}
function getReceiverCities(provinceName) {
  var province = findReceiverProvince(provinceName);
  if (!province) return [];
  if (DIRECT_CONTROLLED_MUNICIPALITIES.indexOf(provinceName) > -1) return [provinceName];
  return _jstCities.default.filter(function (item) {
    return item.province === province.province;
  }).map(function (item) {
    return item.name;
  });
}
function getReceiverDistricts(provinceName, cityName) {
  var province = findReceiverProvince(provinceName);
  if (!province || !cityName) return [];
  if (DIRECT_CONTROLLED_MUNICIPALITIES.indexOf(provinceName) > -1) {
    return _jstDistricts.default.filter(function (item) {
      return item.province === province.province;
    }).map(function (item) {
      return item.name;
    });
  }
  var city = _jstCities.default.find(function (item) {
    return item.province === province.province && item.name === cityName;
  });
  return city ? _jstDistricts.default.filter(function (item) {
    return item.province === province.province && item.city === city.city;
  }).map(function (item) {
    return item.name;
  }) : [];
}
var SCENE_IMAGES = {
  aftersaleList: r('ppt/2-22-已创建手工售后单.png'),
  empty: r('3-1-create-aftersale-empty.png'),
  return: r('3-2-create-aftersale-return.png'),
  refund: r('3-3-create-aftersale-refund.png'),
  resend: r('3-leak-resend-selected.png'),
  detail: r('3-5-aftersale-detail.png'),
  noInfo: r('3-noinfo-aftersale.png'),
  goods: r('3-noinfo-product-library.png')
};
var ORDER_FIELD = {
  id: 'order-code',
  model: 'orderCode',
  type: 'text',
  bgColor: '#fff',
  fontSize: 11,
  placeholder: '线上订单号',
  x: 0.132,
  y: 0.093,
  w: 0.077,
  h: 0.021
};
var PRACTICE_ORDER = _jstErpFixtureData.JST_CREATE_ORDER;
var DETAIL_PRACTICE_ORDER = _objectSpread(_objectSpread({}, PRACTICE_ORDER), {}, {
  onlineOrderNo: DETAIL_ORDER_CODE
});
var PRACTICE_GOODS = _jstErpFixtureData.JST_CREATE_GOODS;
var THIRD_CHAPTER_TIPS = ['线上订单号' + (0, _jstTip.red)('3312733548438011187') + '关联的商品' + (0, _jstTip.red)('TEST-GD-0003') + '破损，卖家需补发。买家已经使用' + (0, _jstTip.red)('申通快递') + '退回' + (0, _jstTip.red)('淘金仓库') + '，单号' + (0, _jstTip.red)('st12654458855') + '，花费' + (0, _jstTip.red)('8元') + '。' + (0, _jstTip.br)() + '补发商品卖家将使用' + (0, _jstTip.red)('京东快递') + '由' + (0, _jstTip.red)('淘金仓库') + '寄出，买家手机地址为：' + (0, _jstTip.red)('陕西省西安市雁塔区丈八街道丹轩梓园3号楼，收货人朱小明、13800138000'), '线上订单号 ' + (0, _jstTip.red)('3312733548438011187') + '关联的商品' + (0, _jstTip.red)('TEST-GD-0001') + '未发，错发了商品' + (0, _jstTip.red)('STY-BSK-001') + '。' + (0, _jstTip.br)() + '买家已使用' + (0, _jstTip.red)('申通快递') + '，自担' + (0, _jstTip.red)('8元') + '运费退回错发商品，' + (0, _jstTip.red)('st12654458855') + '，退回' + (0, _jstTip.red)('淘金仓库') + '。买家退款账号为 ' + (0, _jstTip.red)('13800138000') + '，卖家退款账号为' + (0, _jstTip.red)('淘金账户') + '。', '线上订单号' + (0, _jstTip.red)('3312733548438011187') + '关联商品 ' + (0, _jstTip.red)('TEST-GD-0003') + ' 涉及' + (0, _jstTip.red)('错发退换货') + '。买家已使用' + (0, _jstTip.red)('申通快递') + '退回' + (0, _jstTip.red)('淘金仓库') + '，退回单号 ' + (0, _jstTip.red)('st12654458855') + '，退货运费 ' + (0, _jstTip.red)('8元') + '，买家退款账号为 ' + (0, _jstTip.red)('13800138000') + '，卖家退款账号为' + (0, _jstTip.red)('淘金账户') + '。' + (0, _jstTip.br)() + '卖家需补发订单原商品 ' + (0, _jstTip.red)('TEST-GD-0003') + '，错发已发商品为 ' + (0, _jstTip.red)('STY-PLT-001') + '。买家收货地址为：' + (0, _jstTip.red)('陕西省西安市雁塔区丈八街道丹轩梓园3号楼') + '，收货人' + (0, _jstTip.red)('朱小明') + '，联系手机 ' + (0, _jstTip.red)('13800138000') + '。补发商品卖家将使用' + (0, _jstTip.red)('京东快递') + '寄出，备注为“' + (0, _jstTip.red)('错发退换货') + '”。', '线上订单号 ' + (0, _jstTip.red)('3312733548438011187') + '关联商品 ' + (0, _jstTip.red)('TEST-GD-0003') + ' 漏发，卖家需补发 ' + (0, _jstTip.red)('1件') + '。' + (0, _jstTip.br)() + '补发商品由卖家使用' + (0, _jstTip.red)('京东快递') + '从' + (0, _jstTip.red)('淘金仓库') + '寄出。买家收货地址为：' + (0, _jstTip.red)('陕西省西安市雁塔区丈八街道丹轩梓园3号楼') + '；收货人：' + (0, _jstTip.red)('朱小明') + '；联系电话：' + (0, _jstTip.red)('13800138000') + '。', '登记无信息件商品' + (0, _jstTip.red)('STY-PLT-001') + '退回' + (0, _jstTip.br)() + '买家退回快递公司：' + (0, _jstTip.red)('申通快递') + (0, _jstTip.br)() + '买家退回快递单号：' + (0, _jstTip.red)('st12654458855') + (0, _jstTip.br)() + '退回仓库：' + (0, _jstTip.red)('淘金仓库') + (0, _jstTip.br)() + '售后店铺：' + (0, _jstTip.red)('淘金云官方旗舰店')];
var THIRD_CHAPTER_DETAIL_TIP = '查询线上订单' + (0, _jstTip.red)(DETAIL_ORDER_CODE) + '的售后明细';
function getThirdChapterTip(_ref) {
  var ui = _ref.ui;
  var createdCount = (ui.createdThirdAftersales || []).length;
  return createdCount >= THIRD_CHAPTER_TIPS.length ? THIRD_CHAPTER_DETAIL_TIP : THIRD_CHAPTER_TIPS[createdCount];
}
function requirePracticeOrderSelection(_ref2) {
  var ui = _ref2.ui;
  return (ui['third-practice-order-tableSelectedKeys'] || []).includes(PRACTICE_ORDER.id) ? {
    ok: true
  } : {
    ok: false,
    msg: '请先选中搜索出的订单'
  };
}
var CLEAR_PRACTICE_ORDER_SELECTION = {
  'third-practice-order-tableSelectedKeys': [],
  'third-practice-order-tableSelectedRows': [],
  'third-practice-goods-tableSelectedKeys': [],
  'third-practice-goods-tableSelectedRows': [],
  'third-practice-goods-tableRowDrafts': {}
};
function buildPracticeOrderTables(goodsType) {
  var ui = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var practiceOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PRACTICE_ORDER;
  var orderSelected = (ui['third-practice-order-tableSelectedKeys'] || []).includes(PRACTICE_ORDER.id);
  var selectedKeys = ui['third-practice-goods-tableSelectedKeys'] || [];
  var selectedRows = ui['third-practice-goods-tableSelectedRows'] || [];
  var rowDrafts = ui['third-practice-goods-tableRowDrafts'] || {};
  var rows = PRACTICE_GOODS.map(function (row) {
    var changed = selectedRows.find(function (item) {
      return item.id === row.id;
    });
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, row), changed), rowDrafts[row.id] || {}), {}, {
      type: goodsType
    });
  });
  return [{
    id: 'third-practice-order-table',
    x: 0.045,
    y: 0.12,
    w: 0.94,
    h: 0.365,
    fontSize: 10,
    rows: [practiceOrder],
    columns: [{
      key: 'internalOrderNo',
      title: '内部订单号',
      width: 126
    }, {
      key: 'orderDate',
      title: '订单日期',
      width: 150
    }, {
      key: 'buyerAccount',
      title: '买家账号',
      width: 100
    }, {
      key: 'shop',
      title: '店铺',
      width: 125
    }, {
      key: 'status',
      title: '状态',
      width: 90
    }, {
      key: 'onlineOrderNo',
      title: '线上订单号',
      width: 180
    }, {
      key: 'receivableAmount',
      title: '应付金额',
      width: 90,
      align: 'right'
    }, {
      key: 'paidAmount',
      title: '已付金额',
      width: 90,
      align: 'right'
    }, {
      key: 'freight',
      title: '运费',
      width: 70,
      align: 'right'
    }, {
      key: 'orderType',
      title: '订单类型',
      width: 100
    }, {
      key: 'receiver',
      title: '收货人',
      width: 100
    }, {
      key: 'buyerMessage',
      title: '买家留言',
      width: 110
    }, {
      key: 'phone',
      title: '手机',
      width: 120
    }, {
      key: 'address',
      title: '收货地址',
      width: 210
    }, {
      key: 'expressCompany',
      title: '快递公司',
      width: 100
    }, {
      key: 'expressNo',
      title: '快递单号',
      width: 150
    }, {
      key: 'orderRemark',
      title: '订单备注',
      width: 110
    }],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: []
  }, {
    id: 'third-practice-goods-table',
    x: 0.045,
    y: 0.715,
    w: 0.94,
    h: 0.23,
    fontSize: 10,
    rows: orderSelected ? rows : [],
    columns: [{
      key: 'thumbnail',
      type: 'image',
      title: '缩略图',
      width: 68
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 140
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 110
    }, {
      key: 'type',
      title: '类型',
      width: 58
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 210
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 160
    }, {
      key: 'orderGoodsStatus',
      title: '订单商品状态',
      width: 120
    }, {
      key: 'goodsTag',
      title: '商品标签',
      width: 100
    }, {
      key: 'unitPrice',
      type: 'input',
      title: '单价',
      width: 88,
      align: 'right'
    }, {
      key: 'goodsAmount',
      title: '商品金额',
      width: 100,
      align: 'right'
    }, {
      key: 'orderQty',
      title: '订单数量',
      width: 88,
      align: 'right'
    }, {
      key: 'currentQty',
      type: 'input',
      title: '本次数量',
      width: 88,
      align: 'right'
    }, {
      key: 'defectiveQty',
      title: '次品数量',
      width: 88,
      align: 'right'
    }, {
      key: 'currentAmount',
      type: 'input',
      title: '本次金额',
      width: 100,
      align: 'right'
    }, {
      key: 'appliedReturnQty',
      title: '已申请退货',
      width: 100,
      align: 'right'
    }, {
      key: 'actualReturnQty',
      title: '实退退货',
      width: 100,
      align: 'right'
    }, {
      key: 'remark',
      type: 'input',
      title: '备注',
      width: 160
    }, {
      key: 'availableStock',
      title: '可用库存',
      width: 88,
      align: 'right'
    }],
    rowKey: 'id',
    selectable: true,
    selectedKeys: selectedKeys,
    onCellChange: function onCellChange(_ref3) {
      var row = _ref3.row,
        key = _ref3.key,
        value = _ref3.value,
        ui = _ref3.ui,
        setUi = _ref3.setUi;
      var drafts = _objectSpread({}, ui['third-practice-goods-tableRowDrafts'] || {});
      drafts[row.id] = _objectSpread(_objectSpread({}, drafts[row.id] || {}), {}, (0, _defineProperty2.default)({}, key, value));
      setUi({
        'third-practice-goods-tableRowDrafts': drafts
      });
    }
  }];
}
function buildLeakResendOrderTables() {
  var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _buildPracticeOrderTa = buildPracticeOrderTables('补', ui),
    _buildPracticeOrderTa2 = (0, _slicedToArray2.default)(_buildPracticeOrderTa, 2),
    orderTable = _buildPracticeOrderTa2[0],
    baseGoodsTable = _buildPracticeOrderTa2[1];
  var selectedKeys = ui['third-leak-resend-goods-tableSelectedKeys'] || [];
  var selectedRows = ui['third-leak-resend-goods-tableSelectedRows'] || [];
  var rowDrafts = ui['third-leak-resend-goods-tableRowDrafts'] || {};
  var rows = PRACTICE_GOODS.map(function (row) {
    var changed = selectedRows.find(function (item) {
      return item.id === row.id;
    });
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, row), changed), rowDrafts[row.id] || {}), {}, {
      type: '补'
    });
  });
  var isSelected = function isSelected(row) {
    return selectedKeys.indexOf(row.id) > -1;
  };
  var columns = baseGoodsTable.columns.map(function (column) {
    if (column.key === 'type') return _objectSpread(_objectSpread({}, column), {}, {
      type: 'badge',
      width: 58
    });
    if (column.key === 'currentQty') return _objectSpread(_objectSpread({}, column), {}, {
      inputDisabled: function inputDisabled(row) {
        return !isSelected(row);
      }
    });
    return column;
  });
  columns.splice(4, 0, {
    key: 'issueType',
    type: 'select',
    title: '明细问题类型',
    width: 130,
    options: ['应发未发'],
    inputDisabled: function inputDisabled(row) {
      return !isSelected(row);
    }
  });
  return [orderTable, _objectSpread(_objectSpread({}, baseGoodsTable), {}, {
    id: 'third-leak-resend-goods-table',
    rows: rows,
    columns: columns,
    selectedKeys: selectedKeys,
    onCellChange: function onCellChange(_ref4) {
      var row = _ref4.row,
        key = _ref4.key,
        value = _ref4.value,
        ui = _ref4.ui,
        setUi = _ref4.setUi;
      var drafts = _objectSpread({}, ui['third-leak-resend-goods-tableRowDrafts'] || {});
      drafts[row.id] = _objectSpread(_objectSpread({}, drafts[row.id] || {}), {}, (0, _defineProperty2.default)({}, key, value));
      setUi({
        'third-leak-resend-goods-tableRowDrafts': drafts
      });
    }
  })];
}
function buildWrongReturnOrderTables() {
  var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _buildPracticeOrderTa3 = buildPracticeOrderTables('退', ui),
    _buildPracticeOrderTa4 = (0, _slicedToArray2.default)(_buildPracticeOrderTa3, 1),
    orderTable = _buildPracticeOrderTa4[0];
  var orderSelected = (ui['third-practice-order-tableSelectedKeys'] || []).includes(PRACTICE_ORDER.id);
  var rows = [_objectSpread(_objectSpread({}, PRACTICE_GOODS[0]), {}, {
    id: 'wrong-return-goods-1',
    type: '退',
    issueType: '',
    currentQty: 0,
    currentAmount: 0
  })].concat(ui.wrongReturnAddedGoods || []);
  return [orderTable].concat((0, _toConsumableArray2.default)(orderSelected ? [{
    id: 'third-wrong-return-goods-table',
    x: 0.045,
    y: 0.715,
    w: 0.94,
    h: 0.23,
    fontSize: 10,
    rows: rows,
    columns: [{
      key: 'thumbnail',
      type: 'image',
      title: '缩略图',
      width: 68
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 140
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 110
    }, {
      key: 'type',
      title: '类型',
      width: 58
    }, {
      key: 'issueType',
      title: '明细问题类型',
      width: 130
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 210
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 160
    }, {
      key: 'orderGoodsStatus',
      title: '订单商品状态',
      width: 120
    }, {
      key: 'goodsTag',
      title: '商品标签',
      width: 100
    }, {
      key: 'unitPrice',
      title: '单价',
      width: 88,
      align: 'right'
    }, {
      key: 'goodsAmount',
      title: '商品金额',
      width: 100,
      align: 'right'
    }, {
      key: 'orderQty',
      title: '订单数量',
      width: 88,
      align: 'right'
    }, {
      key: 'currentQty',
      title: '本次数量',
      width: 88,
      align: 'right'
    }, {
      key: 'defectiveQty',
      title: '次品数量',
      width: 88,
      align: 'right'
    }, {
      key: 'currentAmount',
      title: '本次金额',
      width: 100,
      align: 'right'
    }, {
      key: 'appliedReturnQty',
      title: '已申请退货',
      width: 100,
      align: 'right'
    }, {
      key: 'actualReturnQty',
      title: '实退退货',
      width: 100,
      align: 'right'
    }, {
      key: 'remark',
      title: '备注',
      width: 160
    }, {
      key: 'availableStock',
      title: '可用库存',
      width: 88,
      align: 'right'
    }],
    rowKey: 'id',
    selectable: true
  }] : []));
}
var WRONG_EXCHANGE_GOODS = [_objectSpread(_objectSpread({}, PRACTICE_GOODS[0]), {}, {
  id: 'wrong-exchange-goods-1',
  type: '退',
  issueType: ''
}), _objectSpread(_objectSpread({}, PRACTICE_GOODS[1]), {}, {
  id: 'wrong-exchange-goods-2',
  type: '退',
  issueType: ''
})];
var PRODUCT_LIBRARY_GOODS = _jstErpFixtureData.JST_PRODUCT_LIBRARY_GOODS;
var TARGET_LIBRARY_GOODS = PRODUCT_LIBRARY_GOODS[0];
var TARGET_LIBRARY_STYLE_CODE = TARGET_LIBRARY_GOODS.styleCode;
var TARGET_LIBRARY_GOODS_CODE = TARGET_LIBRARY_GOODS.goodsCode;
var WRONG_RETURN_LIBRARY_PRODUCT = {
  id: 'wrong-return-library-sty-bsk-001',
  styleCode: _jstErpFixtureData.JST_ERROR_PRODUCT.styleCode,
  goodsCode: _jstErpFixtureData.JST_ERROR_PRODUCT.goodsCode,
  goodsName: _jstErpFixtureData.JST_ERROR_PRODUCT.goodsName,
  spec: _jstErpFixtureData.JST_ERROR_PRODUCT.spec,
  unitPrice: _jstErpFixtureData.JST_ERROR_PRODUCT.price,
  stock: 48
};
var WRONG_RETURN_ADDED_GOOD = {
  id: 'wrong-return-added-wrong-goods-1',
  thumbnail: '',
  goodsCode: WRONG_RETURN_LIBRARY_PRODUCT.goodsCode,
  styleCode: WRONG_RETURN_LIBRARY_PRODUCT.styleCode,
  type: '退',
  issueType: '错发已发',
  goodsName: WRONG_RETURN_LIBRARY_PRODUCT.goodsName,
  spec: WRONG_RETURN_LIBRARY_PRODUCT.spec,
  orderGoodsStatus: '',
  goodsTag: '',
  unitPrice: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  goodsAmount: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  orderQty: 1,
  currentQty: '1',
  defectiveQty: '',
  currentAmount: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  appliedReturnQty: 0,
  actualReturnQty: 0,
  remark: '',
  availableStock: WRONG_RETURN_LIBRARY_PRODUCT.stock
};
function pickerColumns() {
  return [{
    key: 'goodsCode',
    title: '商品编码',
    width: 160
  }, {
    key: 'styleCode',
    title: '款式编码',
    width: 120
  }, {
    key: 'goodsName',
    title: '商品名称',
    width: 220
  }, {
    key: 'spec',
    title: '颜色及规格',
    width: 160
  }, {
    key: 'orderQty',
    title: '数量',
    width: 70,
    align: 'right'
  }, {
    key: 'unitPrice',
    title: '单价',
    width: 80,
    align: 'right'
  }, {
    key: 'goodsAmount',
    title: '金额',
    width: 80,
    align: 'right'
  }];
}
function buildOrderGoodsPicker(id, selectedKeys) {
  var layout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return [{
    id: id,
    x: layout.x === undefined ? 0.3 : layout.x,
    y: layout.y === undefined ? 0.31 : layout.y,
    w: layout.w === undefined ? 0.43 : layout.w,
    h: layout.h === undefined ? 0.12 : layout.h,
    fontSize: 10,
    rows: WRONG_EXCHANGE_GOODS,
    columns: pickerColumns(),
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: selectedKeys
  }];
}
function buildProductLibraryTables(_ref5) {
  var form = _ref5.form,
    ui = _ref5.ui;
  var styleCode = String(form.libraryStyleCode || '').trim().toUpperCase();
  var rows = styleCode ? PRODUCT_LIBRARY_GOODS.filter(function (item) {
    return item.styleCode === styleCode;
  }) : PRODUCT_LIBRARY_GOODS;
  return [{
    id: 'wrong-exchange-library-table',
    x: 0.19,
    y: 0.235,
    w: 0.62,
    h: 0.39,
    fontSize: 10,
    rows: rows,
    columns: [{
      key: 'styleCode',
      title: '款式编码',
      width: 130
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 180
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 220
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 140
    }, {
      key: 'unitPrice',
      title: '单价',
      width: 90,
      align: 'right'
    }, {
      key: 'stock',
      title: '可用库存',
      width: 90,
      align: 'right'
    }],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: ui['wrong-exchange-library-tableSelectedKeys'] || []
  }];
}
function buildWrongReturnProductLibraryTables(_ref6) {
  var form = _ref6.form,
    ui = _ref6.ui;
  var styleCode = String(form.wrongReturnLibraryStyleCode || '').trim().toUpperCase();
  var sourceRows = PRODUCT_LIBRARY_GOODS.concat(WRONG_RETURN_LIBRARY_PRODUCT);
  var rows = ui.wrongReturnLibrarySearched && styleCode ? sourceRows.filter(function (item) {
    return item.styleCode.toUpperCase() === styleCode;
  }) : sourceRows;
  return [{
    id: 'wrong-return-library-table',
    x: 0.19,
    y: 0.235,
    w: 0.62,
    h: 0.39,
    fontSize: 10,
    rows: rows,
    columns: [{
      key: 'styleCode',
      title: '款式编码',
      width: 130
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 180
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 220
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 140
    }, {
      key: 'unitPrice',
      title: '单价',
      width: 90,
      align: 'right'
    }, {
      key: 'stock',
      title: '可用库存',
      width: 90,
      align: 'right'
    }],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: ui['wrong-return-library-tableSelectedKeys'] || []
  }];
}
function buildNoInfoProductLibraryTables(_ref7) {
  var ui = _ref7.ui;
  var keyword = String(ui.noinfoSearchedGoodsCode || '').trim().toUpperCase();
  var rows = keyword ? PRODUCT_LIBRARY_GOODS.filter(function (item) {
    return item.styleCode === keyword || item.goodsCode === keyword;
  }) : PRODUCT_LIBRARY_GOODS;
  return [{
    id: 'noinfo-product-library-table',
    x: 0.187,
    y: 0.235,
    w: 0.626,
    h: 0.555,
    fontSize: 10,
    rows: rows,
    columns: [{
      key: 'styleCode',
      title: '款式编码',
      width: 130
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 180
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 220
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 140
    }, {
      key: 'unitPrice',
      title: '单价',
      width: 90,
      align: 'right'
    }, {
      key: 'stock',
      title: '可用库存',
      width: 90,
      align: 'right'
    }],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: ui['noinfo-product-library-tableSelectedKeys'] || []
  }];
}
function buildNoInfoCreateGoodsTables() {
  var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rows = ui.noinfoAddedGoods || [];
  if (!rows.length) return [];
  return [{
    id: 'noinfo-added-goods-table',
    x: 0.229,
    y: 0.446,
    w: 0.574,
    h: 0.25,
    fontSize: 10,
    rows: rows,
    columns: [{
      key: 'goodsCode',
      title: '商品编码',
      width: 150
    }, {
      key: 'comboGoodsCode',
      title: '组合商品编码',
      width: 150
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 120
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 200
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 140
    }, {
      key: 'applyQty',
      title: '申请数量',
      width: 90,
      align: 'right'
    }, {
      key: 'defectiveQty',
      title: '次品数量',
      width: 90,
      align: 'right'
    }, {
      key: 'applyAmount',
      title: '申请金额',
      width: 90,
      align: 'right'
    }],
    rowKey: 'id'
  }];
}
function selectWrongExchangeGood(ui, good) {
  var selectedKeys = (ui['third-wrong-exchange-goods-tableSelectedKeys'] || []).slice();
  var selectedRows = (ui['third-wrong-exchange-goods-tableSelectedRows'] || []).slice();
  if (selectedKeys.indexOf(good.id) < 0) selectedKeys.push(good.id);
  var rowIndex = selectedRows.findIndex(function (row) {
    return row.id === good.id;
  });
  if (rowIndex < 0) selectedRows.push(good);else selectedRows.splice(rowIndex, 1, _objectSpread(_objectSpread({}, selectedRows[rowIndex]), good));
  return {
    'third-wrong-exchange-goods-tableSelectedKeys': selectedKeys,
    'third-wrong-exchange-goods-tableSelectedRows': selectedRows
  };
}
function appendWrongExchangeGood(ui, good) {
  var rows = ui.wrongExchangeExtraRows || [];
  return _objectSpread({
    wrongExchangeExtraRows: rows.some(function (row) {
      return row.id === good.id;
    }) ? rows : rows.concat(good)
  }, selectWrongExchangeGood(ui, good));
}
function buildWrongExchangeOrderTables() {
  var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _buildPracticeOrderTa5 = buildPracticeOrderTables('换', ui),
    _buildPracticeOrderTa6 = (0, _slicedToArray2.default)(_buildPracticeOrderTa5, 1),
    orderTable = _buildPracticeOrderTa6[0];
  var orderSelected = (ui['third-practice-order-tableSelectedKeys'] || []).includes(PRACTICE_ORDER.id);
  var selectedKeys = ui['third-wrong-exchange-goods-tableSelectedKeys'] || [];
  var selectedRows = ui['third-wrong-exchange-goods-tableSelectedRows'] || [];
  var issueTypeOverrides = ui.wrongExchangeOrderIssueTypes || {};
  var rows = WRONG_EXCHANGE_GOODS.map(function (goods) {
    var changed = selectedRows.find(function (row) {
      return row.id === goods.id;
    });
    return _objectSpread(_objectSpread(_objectSpread({}, goods), changed), {}, {
      issueType: issueTypeOverrides[goods.id] || changed && changed.issueType || goods.issueType
    });
  }).concat(ui.wrongExchangeExtraRows || []);
  var isSelected = function isSelected(row) {
    return selectedKeys.indexOf(row.id) > -1;
  };
  return [orderTable].concat((0, _toConsumableArray2.default)(orderSelected ? [{
    id: 'third-wrong-exchange-goods-table',
    x: 0.045,
    y: 0.715,
    w: 0.94,
    h: 0.23,
    fontSize: 10,
    rows: rows,
    columns: [{
      key: 'thumbnail',
      type: 'image',
      title: '缩略图',
      width: 68
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 140
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 110
    }, {
      key: 'type',
      type: 'badge',
      title: '类型',
      width: 72
    }, {
      key: 'issueType',
      type: 'select',
      title: '明细问题类型',
      width: 150,
      options: ['应发未发', '错发已发'],
      inputDisabled: function inputDisabled(row) {
        return !isSelected(row);
      }
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 180
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 150
    }, {
      key: 'orderGoodsStatus',
      title: '订单商品状态',
      width: 120
    }, {
      key: 'goodsTag',
      title: '商品标签',
      width: 100
    }, {
      key: 'unitPrice',
      type: 'input',
      title: '单价',
      width: 88,
      align: 'right',
      inputDisabled: function inputDisabled(row) {
        return !isSelected(row);
      }
    }, {
      key: 'goodsAmount',
      title: '商品金额',
      width: 100,
      align: 'right'
    }, {
      key: 'orderQty',
      title: '订单数量',
      width: 88,
      align: 'right'
    }, {
      key: 'currentQty',
      type: 'input',
      title: '本次数量',
      width: 88,
      align: 'right',
      inputDisabled: function inputDisabled(row) {
        return !isSelected(row);
      }
    }, {
      key: 'defectiveQty',
      type: 'input',
      title: '次品数量',
      width: 88,
      align: 'right',
      inputDisabled: function inputDisabled(row) {
        return !isSelected(row);
      }
    }, {
      key: 'currentAmount',
      type: 'input',
      title: '本次金额',
      width: 100,
      align: 'right',
      inputDisabled: function inputDisabled(row) {
        return !isSelected(row);
      }
    }, {
      key: 'appliedReturnQty',
      title: '已申请退货',
      width: 100,
      align: 'right'
    }, {
      key: 'actualReturnQty',
      title: '实退退货',
      width: 100,
      align: 'right'
    }, {
      key: 'remark',
      type: 'input',
      title: '备注',
      width: 160,
      inputDisabled: function inputDisabled(row) {
        return !isSelected(row);
      }
    }, {
      key: 'availableStock',
      title: '可用库存',
      width: 88,
      align: 'right'
    }],
    rowKey: 'id',
    selectable: true,
    selectedKeys: selectedKeys
  }] : []));
}
function buildWrongReturnFields() {
  return [{
    id: 'wrong-return-express',
    model: 'wrongReturnExpress',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.112,
    y: 0.552,
    w: 0.05,
    h: 0.023
  }, {
    id: 'wrong-return-waybill',
    model: 'wrongReturnWaybill',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.231,
    y: 0.552,
    w: 0.057,
    h: 0.023
  }, {
    id: 'wrong-return-seller-subsidy',
    model: 'wrongReturnSellerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.602,
    y: 0.552,
    w: 0.06,
    h: 0.023
  }, {
    id: 'wrong-return-buyer-subsidy',
    model: 'wrongReturnBuyerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.725,
    y: 0.552,
    w: 0.057,
    h: 0.023
  }, {
    id: 'wrong-return-refund-freight',
    model: 'wrongReturnRefundFreight',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.848,
    y: 0.552,
    w: 0.06,
    h: 0.023
  }, {
    id: 'wrong-return-warehouse',
    model: 'wrongReturnWarehouse',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择退货仓',
    options: ['淘金仓库'],
    x: 0.23,
    y: 0.584,
    w: 0.065,
    h: 0.023
  }, {
    id: 'wrong-return-buyer-account',
    model: 'wrongReturnBuyerAccount',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入买家退款账号',
    x: 0.352,
    y: 0.584,
    w: 0.06,
    h: 0.023
  }, {
    id: 'wrong-return-seller-account',
    model: 'wrongReturnSellerAccount',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择卖家退款账号',
    options: ['淘金账户'],
    x: 0.477,
    y: 0.584,
    w: 0.06,
    h: 0.023
  }, {
    id: 'wrong-return-remark',
    model: 'wrongReturnRemark',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入备注',
    x: 0.602,
    y: 0.584,
    w: 0.18,
    h: 0.023
  }, {
    id: 'wrong-return-receiving-warehouse',
    model: 'wrongReturnReceivingWarehouse',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择收货仓',
    options: ['淘金仓库'],
    x: 0.848,
    y: 0.584,
    w: 0.06,
    h: 0.023
  }];
}
function buildNoInfoFields() {
  return [{
    id: 'noinfo-return-express',
    model: 'noinfoReturnExpress',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '买家退回快递',
    x: 0.3,
    y: 0.287,
    w: 0.08,
    h: 0.022
  }, {
    id: 'noinfo-return-waybill',
    model: 'noinfoReturnWaybill',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '退回快递单号',
    x: 0.45,
    y: 0.287,
    w: 0.09,
    h: 0.022
  }, {
    id: 'noinfo-remark',
    model: 'noinfoRemark',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '备注',
    x: 0.451,
    y: 0.352,
    w: 0.33,
    h: 0.022
  }, {
    id: 'noinfo-warehouse',
    model: 'noinfoWarehouse',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择退货仓',
    options: ['淘金仓库'],
    x: 0.3,
    y: 0.385,
    w: 0.082,
    h: 0.022
  }, {
    id: 'noinfo-shop',
    model: 'noinfoShop',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择店铺',
    options: ['淘金云官方旗舰店'],
    x: 0.45,
    y: 0.385,
    w: 0.094,
    h: 0.022
  }];
}
function buildWrongExchangeFields() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var provinceOptions = _jstProvinces.default.map(function (item) {
    return item.name;
  });
  var cityOptions = getReceiverCities(form.exchangeReceiverProvince);
  var districtOptions = getReceiverDistricts(form.exchangeReceiverProvince, form.exchangeReceiverCity);
  return [{
    id: 'exchange-return-express',
    model: 'exchangeReturnExpress',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.112,
    y: 0.552,
    w: 0.05,
    h: 0.023
  }, {
    id: 'exchange-return-waybill',
    model: 'exchangeReturnWaybill',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.231,
    y: 0.552,
    w: 0.057,
    h: 0.023
  }, {
    id: 'exchange-seller-subsidy',
    model: 'exchangeSellerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.602,
    y: 0.552,
    w: 0.06,
    h: 0.023
  }, {
    id: 'exchange-buyer-subsidy',
    model: 'exchangeBuyerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.725,
    y: 0.552,
    w: 0.057,
    h: 0.023
  }, {
    id: 'exchange-refund-freight',
    model: 'exchangeRefundFreight',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.848,
    y: 0.552,
    w: 0.06,
    h: 0.023
  }, {
    id: 'exchange-return-warehouse',
    model: 'exchangeReturnWarehouse',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择退货仓',
    options: ['淘金仓库'],
    x: 0.23,
    y: 0.584,
    w: 0.065,
    h: 0.023
  }, {
    id: 'exchange-buyer-account',
    model: 'exchangeBuyerAccount',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入买家退款账号',
    x: 0.352,
    y: 0.584,
    w: 0.06,
    h: 0.023
  }, {
    id: 'exchange-seller-account',
    model: 'exchangeSellerAccount',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择卖家退款账号',
    options: ['淘金账户'],
    x: 0.477,
    y: 0.584,
    w: 0.06,
    h: 0.023
  }, {
    id: 'exchange-remark',
    model: 'exchangeRemark',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入备注',
    x: 0.602,
    y: 0.584,
    w: 0.18,
    h: 0.023
  }, {
    id: 'exchange-receiving-warehouse',
    model: 'exchangeReceivingWarehouse',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择收货仓',
    options: ['淘金仓库'],
    x: 0.848,
    y: 0.584,
    w: 0.06,
    h: 0.023
  }, {
    id: 'exchange-shipping-warehouse',
    model: 'exchangeShippingWarehouse',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择发货仓',
    options: ['淘金仓库'],
    x: 0.478,
    y: 0.615,
    w: 0.058,
    h: 0.023
  }, {
    id: 'exchange-receiver-province',
    model: 'exchangeReceiverProvince',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '省份',
    options: provinceOptions,
    x: 0.107,
    y: 0.65,
    w: 0.037,
    h: 0.023,
    onInput: function onInput(_ref8) {
      var setForm = _ref8.setForm;
      return setForm({
        exchangeReceiverCity: '',
        exchangeReceiverDistrict: ''
      });
    }
  }, {
    id: 'exchange-receiver-city',
    model: 'exchangeReceiverCity',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '城市',
    options: cityOptions,
    x: 0.16,
    y: 0.65,
    w: 0.047,
    h: 0.023,
    onInput: function onInput(_ref9) {
      var setForm = _ref9.setForm;
      return setForm({
        exchangeReceiverDistrict: ''
      });
    }
  }, {
    id: 'exchange-receiver-district',
    model: 'exchangeReceiverDistrict',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '县市',
    options: districtOptions,
    x: 0.213,
    y: 0.65,
    w: 0.047,
    h: 0.023
  }, {
    id: 'exchange-receiver-address',
    model: 'exchangeReceiverAddress',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '详细地址',
    x: 0.267,
    y: 0.65,
    w: 0.142,
    h: 0.023
  }, {
    id: 'exchange-receiver-name',
    model: 'exchangeReceiverName',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '收货人',
    x: 0.477,
    y: 0.65,
    w: 0.06,
    h: 0.023
  }, {
    id: 'exchange-receiver-phone',
    model: 'exchangeReceiverPhone',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '联系手机',
    x: 0.602,
    y: 0.65,
    w: 0.06,
    h: 0.023
  }, {
    id: 'exchange-out-express',
    model: 'exchangeOutExpress',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择寄出快递',
    options: DOMESTIC_EXPRESS_COMPANIES,
    x: 0.848,
    y: 0.65,
    w: 0.06,
    h: 0.023
  }];
}
function buildResendOrderFields() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var provinceOptions = _jstProvinces.default.map(function (item) {
    return item.name;
  });
  var cityOptions = getReceiverCities(form.receiverProvince);
  var districtOptions = getReceiverDistricts(form.receiverProvince, form.receiverCity);
  var zeroPlaceholder = options.showZeroPlaceholder === true ? '0' : '请输入';
  return [{
    id: 'return-express',
    model: 'returnExpress',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.112,
    y: 0.552,
    w: 0.05,
    h: 0.023
  }, {
    id: 'return-waybill',
    model: 'returnWaybill',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.231,
    y: 0.552,
    w: 0.057,
    h: 0.023
  }, {
    id: 'seller-subsidy',
    model: 'sellerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: zeroPlaceholder,
    x: 0.602,
    y: 0.552,
    w: 0.06,
    h: 0.023
  }, {
    id: 'buyer-subsidy',
    model: 'buyerSubsidy',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入',
    x: 0.725,
    y: 0.552,
    w: 0.057,
    h: 0.023
  }, {
    id: 'refund-freight',
    model: 'refundFreight',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: zeroPlaceholder,
    x: 0.848,
    y: 0.552,
    w: 0.06,
    h: 0.023
  }, {
    id: 'remark',
    model: 'remark',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '请输入备注',
    x: 0.478,
    y: 0.584,
    w: 0.18,
    h: 0.022
  }, {
    id: 'shipping-warehouse',
    model: 'shippingWarehouse',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择发货仓',
    options: ['淘金仓库'],
    x: 0.23,
    y: 0.615,
    w: 0.058,
    h: 0.023
  }, {
    id: 'receiver-province',
    model: 'receiverProvince',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '省份',
    options: provinceOptions,
    x: 0.107,
    y: 0.65,
    w: 0.037,
    h: 0.023,
    onInput: function onInput(_ref0) {
      var setForm = _ref0.setForm;
      return setForm({
        receiverCity: '',
        receiverDistrict: ''
      });
    }
  }, {
    id: 'receiver-city',
    model: 'receiverCity',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '城市',
    options: cityOptions,
    x: 0.16,
    y: 0.65,
    w: 0.047,
    h: 0.023,
    onInput: function onInput(_ref1) {
      var setForm = _ref1.setForm;
      return setForm({
        receiverDistrict: ''
      });
    }
  }, {
    id: 'receiver-district',
    model: 'receiverDistrict',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '县市',
    options: districtOptions,
    x: 0.213,
    y: 0.65,
    w: 0.047,
    h: 0.023
  }, {
    id: 'receiver-address',
    model: 'receiverAddress',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '详细地址',
    x: 0.267,
    y: 0.65,
    w: 0.142,
    h: 0.023
  }, {
    id: 'receiver-name',
    model: 'receiverName',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '收货人',
    x: 0.477,
    y: 0.65,
    w: 0.06,
    h: 0.023
  }, {
    id: 'receiver-phone',
    model: 'receiverPhone',
    type: 'text',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '联系手机',
    x: 0.602,
    y: 0.65,
    w: 0.06,
    h: 0.023
  }, {
    id: 'out-express',
    model: 'outExpress',
    type: 'select',
    bgColor: '#fff',
    fontSize: 10,
    placeholder: '选择寄出快递',
    options: DOMESTIC_EXPRESS_COMPANIES,
    x: 0.848,
    y: 0.65,
    w: 0.06,
    h: 0.023
  }];
}
function validateResendOrderForm(form) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var expected = {
    returnExpress: '申通快递',
    returnWaybill: 'st12654458855',
    sellerSubsidy: '0',
    buyerSubsidy: '0',
    refundFreight: '8',
    shippingWarehouse: '淘金仓库',
    receiverProvince: '陕西省',
    receiverCity: '西安市',
    receiverDistrict: '雁塔区',
    receiverAddress: '丈八街道丹轩梓园3号楼',
    receiverName: '朱小明',
    receiverPhone: '13800138000',
    outExpress: '京东快递'
  };
  if (options.refundFreight !== undefined) expected.refundFreight = options.refundFreight;
  if (options.skipReturnInfo === true) {
    delete expected.returnExpress;
    delete expected.returnWaybill;
  }
  var missing = Object.keys(expected).find(function (key) {
    return String(form[key] || '').trim() !== expected[key];
  });
  if (!missing) return {
    ok: true
  };
  var messages = {
    returnExpress: '请填写买家退回快递：申通快递',
    returnWaybill: '请填写买家退回快递单号：st12654458855',
    sellerSubsidy: '请填写卖家应补：0',
    buyerSubsidy: '请填写买家应补：0',
    refundFreight: '请填写应退运费：' + expected.refundFreight,
    shippingWarehouse: '请选择发货仓：淘金仓库',
    receiverProvince: '请选择收货省份：陕西省',
    receiverCity: '请选择收货城市：西安市',
    receiverDistrict: '请选择收货县市：雁塔区',
    receiverAddress: '请填写详细地址：丈八街道丹轩梓园3号楼',
    receiverName: '请填写收货人：朱小明',
    receiverPhone: '请填写联系手机：13800138000',
    outExpress: '请选择寄出快递：京东快递'
  };
  return {
    ok: false,
    msg: messages[missing]
  };
}
function validateResendOrder(_ref10) {
  var form = _ref10.form,
    ui = _ref10.ui;
  var formResult = validateResendOrderForm(form);
  if (!formResult.ok) return formResult;
  var selectedKeys = ui['third-practice-goods-tableSelectedKeys'] || [];
  return selectedKeys.indexOf('practice-goods-1') > -1 ? {
    ok: true
  } : {
    ok: false,
    msg: '请勾选商品编码为 ' + TARGET_PRACTICE_GOODS_CODE + ' 的商品。'
  };
}
function validateLeakResendOrder(_ref11) {
  var form = _ref11.form,
    ui = _ref11.ui;
  var formResult = validateResendOrderForm(form, {
    skipReturnInfo: true,
    refundFreight: '0'
  });
  if (!formResult.ok) return formResult;
  var selectedKeys = ui['third-leak-resend-goods-tableSelectedKeys'] || [];
  if (selectedKeys.indexOf('practice-goods-1') < 0) return {
    ok: false,
    msg: '请勾选商品编码为 ' + TARGET_PRACTICE_GOODS_CODE + ' 的第一个商品。'
  };
  var selected = _objectSpread(_objectSpread({}, (ui['third-leak-resend-goods-tableSelectedRows'] || []).find(function (row) {
    return row.id === 'practice-goods-1';
  }) || {}), (ui['third-leak-resend-goods-tableRowDrafts'] || {})['practice-goods-1'] || {});
  if (selected.issueType !== '应发未发') return {
    ok: false,
    msg: '请选择明细问题类型：应发未发。'
  };
  return String(selected.currentQty || '').trim() === '1' ? {
    ok: true
  } : {
    ok: false,
    msg: '请将第一个商品的本次数量填写为 1。'
  };
}
function validateWrongReturnCreation(_ref12) {
  var form = _ref12.form,
    ui = _ref12.ui;
  var addedGoods = ui.wrongReturnAddedGoods || [];
  if (!addedGoods.some(function (row) {
    return row.styleCode === WRONG_RETURN_LIBRARY_PRODUCT.styleCode;
  })) {
    return {
      ok: false,
      msg: '请先添加错发已发商品 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + '。'
    };
  }
  var selectedKeys = ui['third-wrong-return-goods-tableSelectedKeys'] || [];
  if (!selectedKeys.includes(WRONG_RETURN_ADDED_GOOD.id)) return {
    ok: false,
    msg: '请勾选错发已发商品 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + '。'
  };
  var expected = {
    wrongReturnExpress: '申通快递',
    wrongReturnWaybill: 'st12654458855',
    wrongReturnSellerSubsidy: '0',
    wrongReturnBuyerSubsidy: '0',
    wrongReturnRefundFreight: '8',
    wrongReturnWarehouse: '淘金仓库',
    wrongReturnBuyerAccount: '13800138000',
    wrongReturnSellerAccount: '淘金账户',
    wrongReturnRemark: '错发退货退款'
  };
  var invalidKey = Object.keys(expected).find(function (key) {
    return String(form[key] || '').trim() !== expected[key];
  });
  var messages = {
    wrongReturnExpress: '请填写买家退回快递：申通快递',
    wrongReturnWaybill: '请填写买家退回快递单号：st12654458855',
    wrongReturnSellerSubsidy: '请填写卖家应补：0',
    wrongReturnBuyerSubsidy: '请填写买家应补：0',
    wrongReturnRefundFreight: '请填写应退运费：8',
    wrongReturnWarehouse: '请选择退货仓：淘金仓库',
    wrongReturnBuyerAccount: '请填写买家退款账号：13800138000',
    wrongReturnSellerAccount: '请选择卖家退款账号：淘金账户',
    wrongReturnRemark: '请填写备注：错发退货退款'
  };
  if (invalidKey) return {
    ok: false,
    msg: messages[invalidKey]
  };
  return {
    ok: true
  };
}
function validateNoInfoCreation(_ref13) {
  var form = _ref13.form,
    ui = _ref13.ui;
  if (!(ui.noinfoAddedGoods || []).length) return {
    ok: false,
    msg: '请先添加退回来的商品。'
  };
  var expected = {
    noinfoReturnExpress: '申通快递',
    noinfoReturnWaybill: 'st12654458855',
    noinfoRemark: '无信息件退货',
    noinfoWarehouse: '淘金仓库',
    noinfoShop: '淘金云官方旗舰店'
  };
  var invalidKey = Object.keys(expected).find(function (key) {
    return String(form[key] || '').trim() !== expected[key];
  });
  if (!invalidKey) return {
    ok: true
  };
  var messages = {
    noinfoReturnExpress: '请填写买家退回快递：申通快递',
    noinfoReturnWaybill: '请填写买家退回快递单号：st12654458855',
    noinfoRemark: '请填写备注：无信息件退货',
    noinfoWarehouse: '请选择退货仓：淘金仓库',
    noinfoShop: '请选择店铺：淘金云官方旗舰店'
  };
  return {
    ok: false,
    msg: messages[invalidKey]
  };
}
function validateWrongExchangeCreation(_ref14) {
  var form = _ref14.form,
    ui = _ref14.ui;
  var incompleteActions = [];
  if (!ui.wrongExchangeAddedMissing) incompleteActions.push('添加应发未发商品');
  if (!ui.wrongExchangeAddedWrong) incompleteActions.push('添加错发已发商品');
  if (!ui.wrongExchangeAddedExchange) incompleteActions.push('添加换货商品（订单）');
  if (!ui.wrongExchangeIssueRegistrationCompleted) incompleteActions.push('售后问题登记');
  if (incompleteActions.length) return {
    ok: false,
    msg: '请先完成：' + incompleteActions.join('、') + '。'
  };
  var expected = {
    exchangeReturnExpress: '申通快递',
    exchangeReturnWaybill: 'st12654458855',
    exchangeSellerSubsidy: '0',
    exchangeBuyerSubsidy: '0',
    exchangeRefundFreight: '8',
    exchangeReturnWarehouse: '淘金仓库',
    exchangeBuyerAccount: '13800138000',
    exchangeSellerAccount: '淘金账户',
    exchangeReceivingWarehouse: '淘金仓库',
    exchangeShippingWarehouse: '淘金仓库',
    exchangeReceiverProvince: '陕西省',
    exchangeReceiverCity: '西安市',
    exchangeReceiverDistrict: '雁塔区',
    exchangeReceiverAddress: '丈八街道丹轩梓园3号楼',
    exchangeReceiverName: '朱小明',
    exchangeReceiverPhone: '13800138000',
    exchangeOutExpress: '京东快递'
  };
  var invalidKey = Object.keys(expected).find(function (key) {
    return String(form[key] || '').trim() !== expected[key];
  });
  var messages = {
    exchangeReturnExpress: '请填写买家退回快递：申通快递',
    exchangeReturnWaybill: '请填写买家退回快递单号：st12654458855',
    exchangeSellerSubsidy: '请填写卖家应补：0',
    exchangeBuyerSubsidy: '请填写买家应补：0',
    exchangeRefundFreight: '请填写应退运费：8',
    exchangeReturnWarehouse: '请选择退货仓：淘金仓库',
    exchangeBuyerAccount: '请填写买家退款账号：13800138000',
    exchangeSellerAccount: '请选择卖家退款账号：淘金账户',
    exchangeReceivingWarehouse: '请选择收货仓：淘金仓库',
    exchangeShippingWarehouse: '请选择发货仓：淘金仓库',
    exchangeReceiverProvince: '请选择收货省份：陕西省',
    exchangeReceiverCity: '请选择收货城市：西安市',
    exchangeReceiverDistrict: '请选择收货县市：雁塔区',
    exchangeReceiverAddress: '请填写详细地址：丈八街道丹轩梓园3号楼',
    exchangeReceiverName: '请填写收货人：朱小明',
    exchangeReceiverPhone: '请填写联系手机：13800138000',
    exchangeOutExpress: '请选择寄出快递：京东快递'
  };
  if (invalidKey) return {
    ok: false,
    msg: messages[invalidKey]
  };
  var selectedKeys = ui['third-wrong-exchange-goods-tableSelectedKeys'] || [];
  if (!selectedKeys.includes('wrong-exchange-goods-1')) return {
    ok: false,
    msg: '请选中应发未发商品 ' + TARGET_PRACTICE_GOODS_CODE
  };
  if (!selectedKeys.includes('added-wrong-sent-goods-1')) return {
    ok: false,
    msg: '请选中错发已发商品 ' + TARGET_LIBRARY_GOODS_CODE
  };
  return selectedKeys.includes('added-exchange-goods-1') ? {
    ok: true
  } : {
    ok: false,
    msg: '请选中要换商品 ' + TARGET_PRACTICE_GOODS_CODE
  };
}
var SIMULATED_AFTERSALE = {
  id: 'simulated-aftersale-1',
  aftersaleNo: '1090155421',
  businessType: '普通',
  internalOrderNo: '381421',
  applyTime: '2026-07-13 23:00:00',
  onlineType: '普通补发',
  aftersaleCategory: '补发',
  status: '待确认',
  onlineStatus: '等待补发',
  cargoStatus: '买家未收到货',
  buyerAccount: '顾**',
  externalTradeNo: '',
  receivingWarehouse: '',
  warehouse: '淘金云仓库',
  returnLogistics: '',
  returnInternationalNo: ''
};
var SIMULATED_WRONG_RETURN_AFTERSALE = {
  id: 'simulated-aftersale-2',
  aftersaleNo: '1090155422',
  businessType: '错发',
  internalOrderNo: '381421',
  applyTime: '2026-07-21 15:30:00',
  onlineType: '错发退货',
  aftersaleCategory: '普通退货',
  status: '待确认',
  onlineStatus: '等待退货',
  cargoStatus: '买家已寄回',
  buyerAccount: PRACTICE_ORDER.buyerAccount,
  externalTradeNo: '',
  receivingWarehouse: '',
  warehouse: '淘金仓库',
  returnLogistics: '申通快递',
  returnInternationalNo: 'st12654458855'
};
var SIMULATED_WRONG_EXCHANGE_AFTERSALE = {
  id: 'simulated-aftersale-3',
  aftersaleNo: '1090155423',
  businessType: '错发',
  internalOrderNo: '381421',
  applyTime: '2026-07-21 16:00:00',
  onlineType: '错发换货',
  aftersaleCategory: '换货',
  status: '待确认',
  onlineStatus: '等待换货',
  cargoStatus: '买家已寄回',
  buyerAccount: PRACTICE_ORDER.buyerAccount,
  externalTradeNo: '',
  receivingWarehouse: '',
  warehouse: '淘金仓库',
  returnLogistics: '申通快递',
  returnInternationalNo: 'st12654458855'
};
var SIMULATED_LEAK_RESEND_AFTERSALE = {
  id: 'simulated-aftersale-4',
  aftersaleNo: '1090155424',
  businessType: '漏发',
  internalOrderNo: '381421',
  applyTime: '2026-07-22 10:30:00',
  onlineType: '漏发补发',
  aftersaleCategory: '补发',
  status: '待确认',
  onlineStatus: '等待补发',
  cargoStatus: '买家未收到货',
  buyerAccount: PRACTICE_ORDER.buyerAccount,
  externalTradeNo: '',
  receivingWarehouse: '',
  warehouse: '淘金仓库',
  returnLogistics: '申通快递',
  returnInternationalNo: 'st12654458855'
};
var SIMULATED_NOINFO_AFTERSALE = {
  id: 'simulated-aftersale-5',
  aftersaleNo: '1090155425',
  businessType: '无信息件',
  internalOrderNo: '',
  applyTime: '2026-07-22 14:00:00',
  onlineType: '无信息件',
  aftersaleCategory: '普通退货',
  status: '待确认',
  onlineStatus: '待处理',
  cargoStatus: '买家已寄回',
  buyerAccount: '',
  externalTradeNo: '',
  receivingWarehouse: '淘金仓库',
  warehouse: '淘金仓库',
  returnLogistics: '',
  returnInternationalNo: ''
};
var SIMULATED_AFTERSALE_GOODS = [{
  id: 'simulated-aftersale-goods-1',
  thumbnail: '',
  goodsCode: PRACTICE_GOODS[0].goodsCode,
  comboGoodsCode: '',
  styleCode: PRACTICE_GOODS[0].styleCode,
  goodsName: PRACTICE_GOODS[0].goodsName,
  spec: PRACTICE_GOODS[0].spec,
  goodsTag: '每日加权',
  onlineDetailAmount: PRACTICE_GOODS[0].goodsAmount,
  unitPrice: PRACTICE_GOODS[0].unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}];
var SIMULATED_WRONG_RETURN_AFTERSALE_GOODS = [{
  id: 'simulated-wrong-return-goods-1',
  thumbnail: '',
  goodsCode: TARGET_PRACTICE_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_PRACTICE_STYLE_CODE,
  goodsName: PRACTICE_GOODS[0].goodsName,
  spec: PRACTICE_GOODS[0].spec,
  goodsTag: '每日加权',
  onlineDetailAmount: PRACTICE_GOODS[0].goodsAmount,
  unitPrice: PRACTICE_GOODS[0].unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}, {
  id: 'simulated-wrong-return-goods-2',
  thumbnail: '',
  goodsCode: WRONG_RETURN_LIBRARY_PRODUCT.goodsCode,
  comboGoodsCode: '',
  styleCode: WRONG_RETURN_LIBRARY_PRODUCT.styleCode,
  goodsName: WRONG_RETURN_LIBRARY_PRODUCT.goodsName,
  spec: WRONG_RETURN_LIBRARY_PRODUCT.spec,
  goodsTag: '',
  onlineDetailAmount: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  unitPrice: WRONG_RETURN_LIBRARY_PRODUCT.unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}];
var SIMULATED_WRONG_EXCHANGE_AFTERSALE_GOODS = [{
  id: 'simulated-wrong-exchange-goods-1',
  thumbnail: '',
  goodsCode: TARGET_PRACTICE_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_PRACTICE_STYLE_CODE,
  goodsName: PRACTICE_GOODS[0].goodsName,
  spec: PRACTICE_GOODS[0].spec,
  goodsTag: '每日加权',
  onlineDetailAmount: PRACTICE_GOODS[0].goodsAmount,
  unitPrice: PRACTICE_GOODS[0].unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}, {
  id: 'simulated-wrong-exchange-goods-2',
  thumbnail: '',
  goodsCode: TARGET_LIBRARY_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_LIBRARY_STYLE_CODE,
  goodsName: TARGET_LIBRARY_GOODS.goodsName,
  spec: TARGET_LIBRARY_GOODS.spec,
  goodsTag: '',
  onlineDetailAmount: TARGET_LIBRARY_GOODS.unitPrice,
  unitPrice: TARGET_LIBRARY_GOODS.unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}];
var SIMULATED_LEAK_RESEND_AFTERSALE_GOODS = [{
  id: 'simulated-leak-resend-goods-1',
  thumbnail: '',
  goodsCode: TARGET_PRACTICE_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_PRACTICE_STYLE_CODE,
  goodsName: PRACTICE_GOODS[0].goodsName,
  spec: PRACTICE_GOODS[0].spec,
  goodsTag: '每日加权',
  onlineDetailAmount: PRACTICE_GOODS[0].goodsAmount,
  unitPrice: PRACTICE_GOODS[0].unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}];
var SIMULATED_NOINFO_AFTERSALE_GOODS = [{
  id: 'simulated-noinfo-goods-1',
  thumbnail: '',
  goodsCode: TARGET_LIBRARY_GOODS_CODE,
  comboGoodsCode: '',
  styleCode: TARGET_LIBRARY_STYLE_CODE,
  goodsName: TARGET_LIBRARY_GOODS.goodsName,
  spec: TARGET_LIBRARY_GOODS.spec,
  goodsTag: '',
  onlineDetailAmount: TARGET_LIBRARY_GOODS.unitPrice,
  unitPrice: TARGET_LIBRARY_GOODS.unitPrice,
  applyAmount: TARGET_LIBRARY_GOODS.unitPrice,
  applyQty: 1,
  actualReturnQty: 0
}];
var AFTERSALE_GOODS_BY_ID = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, SIMULATED_AFTERSALE.id, SIMULATED_AFTERSALE_GOODS), SIMULATED_WRONG_RETURN_AFTERSALE.id, SIMULATED_WRONG_RETURN_AFTERSALE_GOODS), SIMULATED_WRONG_EXCHANGE_AFTERSALE.id, SIMULATED_WRONG_EXCHANGE_AFTERSALE_GOODS), SIMULATED_LEAK_RESEND_AFTERSALE.id, SIMULATED_LEAK_RESEND_AFTERSALE_GOODS), SIMULATED_NOINFO_AFTERSALE.id, SIMULATED_NOINFO_AFTERSALE_GOODS);
function buildAftersaleListTables(_ref15, onSelect) {
  var ui = _ref15.ui;
  var rows = ui.createdThirdAftersales || [];
  var selectedKeys = ui['third-aftersale-tableSelectedKeys'] || [];
  var selectedId = selectedKeys[0];
  var goodsRows = AFTERSALE_GOODS_BY_ID[selectedId] || [];
  return [{
    id: 'third-aftersale-table',
    x: 0.165,
    y: 0.21,
    w: 0.84,
    h: 0.51,
    rows: rows,
    columns: [{
      key: 'aftersaleNo',
      title: '售后单号',
      width: 126
    }, {
      key: 'businessType',
      title: '业务类型',
      width: 92
    }, {
      key: 'internalOrderNo',
      title: '内部订单号',
      width: 120
    }, {
      key: 'applyTime',
      title: '申请日期',
      width: 160
    }, {
      key: 'onlineType',
      title: '线上类型',
      width: 92
    }, {
      key: 'aftersaleCategory',
      title: '售后分类',
      width: 92
    }, {
      key: 'status',
      title: '状态',
      width: 78
    }, {
      key: 'onlineStatus',
      title: '线上状态',
      width: 100
    }, {
      key: 'cargoStatus',
      title: '货物状态',
      width: 120
    }, {
      key: 'buyerAccount',
      title: '买家账号',
      width: 96
    }, {
      key: 'externalTradeNo',
      title: '外部交易单号',
      width: 130
    }, {
      key: 'receivingWarehouse',
      title: '收货仓',
      width: 96
    }, {
      key: 'warehouse',
      title: '仓库',
      width: 110
    }, {
      key: 'returnLogistics',
      title: '退回物流商渠道',
      width: 130
    }, {
      key: 'returnInternationalNo',
      title: '退回国际单号',
      width: 130
    }],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: selectedKeys,
    onSelectionChange: onSelect
  }, {
    id: 'third-aftersale-goods-table',
    x: 0.165,
    y: 0.76,
    w: 0.84,
    h: 0.21,
    rows: goodsRows,
    columns: [{
      key: 'thumbnail',
      type: 'image',
      title: '缩略图',
      width: 68
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 150
    }, {
      key: 'comboGoodsCode',
      title: '组合商品编码',
      width: 150
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 118
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 270
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 220
    }, {
      key: 'goodsTag',
      title: '商品标签',
      width: 110
    }, {
      key: 'onlineDetailAmount',
      title: '线上明细金额',
      width: 120,
      align: 'right'
    }, {
      key: 'unitPrice',
      title: '单价',
      width: 88,
      align: 'right'
    }, {
      key: 'applyQty',
      title: '申请数量',
      width: 88,
      align: 'right'
    }, {
      key: 'actualReturnQty',
      title: '实退数量',
      width: 88,
      align: 'right'
    }],
    rowKey: 'id'
  }];
}
function buildOrderAftersaleDetailTables() {
  return [{
    id: 'third-order-aftersale-detail-table',
    x: 0.045,
    y: 0.518,
    w: 0.94,
    h: 0.40,
    fontSize: 10,
    rows: [{
      id: 'order-aftersale-detail-1',
      aftersaleNo: '1090154418',
      aftersaleCategory: '仅退款',
      status: '已确认',
      goodsName: PRACTICE_GOODS[0].goodsName,
      goodsCode: TARGET_PRACTICE_GOODS_CODE,
      styleCode: TARGET_PRACTICE_STYLE_CODE,
      spec: PRACTICE_GOODS[0].spec,
      applyQty: 1,
      actualReturnQty: 0,
      refundAmount: PRACTICE_GOODS[0].unitPrice,
      detailCategory: '退款',
      creator: '客服-小淘'
    }],
    columns: [{
      key: 'aftersaleNo',
      title: '售后单号',
      width: 130
    }, {
      key: 'aftersaleCategory',
      title: '售后分类',
      width: 100
    }, {
      key: 'status',
      title: '状态',
      width: 90
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 220
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 150
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 130
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 190
    }, {
      key: 'applyQty',
      title: '申请数量',
      width: 88,
      align: 'right'
    }, {
      key: 'actualReturnQty',
      title: '实收数量',
      width: 88,
      align: 'right'
    }, {
      key: 'refundAmount',
      title: '实退实收金额',
      width: 120,
      align: 'right'
    }, {
      key: 'detailCategory',
      title: '明细类别',
      width: 100
    }, {
      key: 'creator',
      title: '创建人',
      width: 130
    }],
    rowKey: 'id'
  }];
}
function getJstErpCreateAftersaleScenario() {
  var scenario = {
    initialStepId: 'aftersale-list',
    initialUi: {},
    initialForm: {
      orderCode: '',
      goodsCode: '',
      returnExpress: '',
      returnWaybill: '',
      sellerSubsidy: '',
      buyerSubsidy: '',
      refundFreight: '',
      remark: '',
      shippingWarehouse: '',
      receiverProvince: '',
      receiverCity: '',
      receiverDistrict: '',
      receiverAddress: '',
      receiverName: '',
      receiverPhone: '',
      outExpress: '',
      wrongReturnExpress: '',
      wrongReturnWaybill: '',
      wrongReturnSellerSubsidy: '',
      wrongReturnBuyerSubsidy: '',
      wrongReturnRefundFreight: '',
      wrongReturnWarehouse: '',
      wrongReturnSellerAccount: '',
      wrongReturnBuyerAccount: '',
      wrongReturnRemark: '',
      wrongReturnReceivingWarehouse: '',
      wrongReturnLibraryStyleCode: '',
      exchangeReturnExpress: '',
      exchangeReturnWaybill: '',
      exchangeSellerSubsidy: '',
      exchangeBuyerSubsidy: '',
      exchangeRefundFreight: '',
      exchangeReturnWarehouse: '',
      exchangeSellerAccount: '',
      exchangeBuyerAccount: '',
      exchangeRemark: '',
      exchangeReceivingWarehouse: '',
      exchangeShippingWarehouse: '',
      exchangeReceiverProvince: '',
      exchangeReceiverCity: '',
      exchangeReceiverDistrict: '',
      exchangeReceiverAddress: '',
      exchangeReceiverName: '',
      exchangeReceiverPhone: '',
      exchangeOutExpress: '',
      libraryStyleCode: '',
      noinfoReturnExpress: '',
      noinfoReturnWaybill: '',
      noinfoRemark: '',
      noinfoWarehouse: '',
      noinfoShop: ''
    },
    steps: [{
      id: 'aftersale-list',
      image: SCENE_IMAGES.aftersaleList,
      aspectRatio: 2,
      tip: function tip(_ref16) {
        var ui = _ref16.ui;
        return (ui.createdThirdAftersales || []).length ? '售后单已创建，请选中售后单查看下方的商品明细。' : '当前没有售后单，售后单列表及商品明细均为空。点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>开始练习。';
      },
      tables: function tables(context) {
        return buildAftersaleListTables(context, function (_ref17) {
          var checked = _ref17.checked,
            go = _ref17.go;
          if (checked) go('done');
        });
      },
      hotspots: function hotspots(_ref18) {
        var ui = _ref18.ui;
        return (ui.createdThirdAftersales || []).length ? [] : [{
          id: 'create-aftersale',
          x: 0.17,
          y: 0.145,
          w: 0.10,
          h: 0.035,
          highlight: 'primary',
          next: 'order-search'
        }];
      }
    }, {
      id: 'noinfo-order-result',
      image: SCENE_IMAGES.empty,
      aspectRatio: 2,
      tip: '无需搜索订单，请直接点击页面中的红色按钮<span style="color:red;font-weight:bold;">创建无信息件售后单</span>。',
      hotspots: [{
        id: 'create-noinfo-aftersale',
        x: 0.707,
        y: 0.091,
        w: 0.07,
        h: 0.03,
        highlight: 'primary',
        next: 'create-noinfo'
      }]
    }, {
      id: 'leak-order-search',
      image: SCENE_IMAGES.empty,
      aspectRatio: 2,
      tip: '输入线上订单号 <span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span> 并点击搜索，创建<span style="color:red;font-weight:bold;">漏发售后业务－补发</span>。',
      fields: [ORDER_FIELD],
      hotspots: [{
        id: 'search-leak-order',
        x: 0.657,
        y: 0.091,
        w: 0.03,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref19) {
          var form = _ref19.form;
          return String(form.orderCode || '').trim() === TARGET_ORDER_CODE ? {
            ok: true
          } : {
            ok: false,
            msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE
          };
        },
        set: CLEAR_PRACTICE_ORDER_SELECTION,
        next: 'select-leak-business'
      }]
    }, {
      id: 'select-leak-business',
      image: SCENE_IMAGES.return,
      aspectRatio: 2,
      tip: '订单搜索完成，当前处于<span style="color:red;font-weight:bold;">普通售后业务</span>。请点击<span style="color:red;font-weight:bold;">漏发售后业务</span>。',
      fields: [ORDER_FIELD],
      tables: function tables(_ref20) {
        var ui = _ref20.ui;
        return buildPracticeOrderTables('退', ui);
      },
      hotspots: [{
        id: 'enter-leak-business',
        x: 0.15,
        y: 0.492,
        w: 0.053,
        h: 0.027,
        highlight: 'primary',
        guard: requirePracticeOrderSelection,
        next: 'create-leak-resend'
      }]
    }, {
      id: 'create-leak-resend',
      image: r('3-leak-resend.png'),
      aspectRatio: 2,
      tip: '已选择<span style="color:red;font-weight:bold;">漏发售后业务－补发</span>。请勾选第一个商品编码为<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>的商品，选择明细问题类型<span style="color:red;font-weight:bold;">应发未发</span>，并将本次数量填写为<span style="color:red;font-weight:bold;">1</span>。卖家应补<span style="color:red;font-weight:bold;">0</span>、买家应补<span style="color:red;font-weight:bold;">0</span>、应退运费<span style="color:red;font-weight:bold;">0</span>元；发货仓选择<span style="color:red;font-weight:bold;">淘金仓库</span>；备注<span style="color:red;font-weight:bold;">漏发补发</span>；收货地址为陕西省西安市雁塔区丈八街道丹轩梓园3号楼，收货人朱小明、13800138000，寄出快递选择京东快递，再点击<span style="color:red;font-weight:bold;">确定创建新售后单</span>。',
      fields: function fields(_ref21) {
        var form = _ref21.form;
        return [ORDER_FIELD].concat((0, _toConsumableArray2.default)(buildResendOrderFields(form)));
      },
      tables: function tables(_ref22) {
        var ui = _ref22.ui;
        return buildLeakResendOrderTables(ui);
      },
      hotspots: [{
        id: 'create-leak-resend-aftersale',
        x: 0.91,
        y: 0.945,
        w: 0.065,
        h: 0.025,
        highlight: 'primary',
        guard: validateLeakResendOrder,
        action: function action(_ref23) {
          var ui = _ref23.ui;
          return {
            set: {
              createdThirdAftersales: [].concat((0, _toConsumableArray2.default)(ui.createdThirdAftersales || []), [SIMULATED_LEAK_RESEND_AFTERSALE])
            },
            next: 'after-leak-resend-list'
          };
        }
      }]
    }, {
      id: 'after-leak-resend-list',
      image: SCENE_IMAGES.aftersaleList,
      aspectRatio: 2,
      tip: '漏发售后业务－补发已创建。请继续创建<span style="color:red;font-weight:bold;">无信息件售后单</span>。',
      tables: function tables(context) {
        return buildAftersaleListTables(context);
      },
      hotspots: [{
        id: 'create-noinfo-aftersale-from-list',
        x: 0.17,
        y: 0.145,
        w: 0.10,
        h: 0.035,
        highlight: 'primary',
        next: 'noinfo-order-result'
      }]
    }, {
      id: 'order-search',
      image: SCENE_IMAGES.empty,
      aspectRatio: 2,
      tip: '输入线上订单号 <span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span> 并点击搜索。',
      fields: [ORDER_FIELD],
      hotspots: [{
        id: 'search-order',
        x: 0.657,
        y: 0.091,
        w: 0.03,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref24) {
          var form = _ref24.form;
          return String(form.orderCode || '').trim() === TARGET_ORDER_CODE ? {
            ok: true
          } : {
            ok: false,
            msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE
          };
        },
        set: CLEAR_PRACTICE_ORDER_SELECTION,
        next: 'select-resend'
      }]
    }, {
      id: 'select-resend',
      image: SCENE_IMAGES.return,
      aspectRatio: 2,
      tip: '订单查询成功，当前为<span style="color:red;font-weight:bold;">普通售后业务</span>，请点击售后分类中的<span style="color:red;font-weight:bold;">补发</span>。',
      fields: [ORDER_FIELD],
      tables: function tables(_ref25) {
        var ui = _ref25.ui;
        return buildPracticeOrderTables('退', ui);
      },
      hotspots: [{
        id: 'resend-type',
        x: 0.233,
        y: 0.526,
        w: 0.04,
        h: 0.027,
        highlight: 'primary',
        guard: requirePracticeOrderSelection,
        next: 'create-resend'
      }]
    }, {
      id: 'create-resend',
      image: SCENE_IMAGES.resend,
      aspectRatio: 2,
      tip: '已选择<span style="color:red;font-weight:bold;">普通售后业务-补发</span>。<br>请勾选商品编码为<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>的商品；本次数量填写<span style="color:red;font-weight:bold;">1</span>。买家退回快递<span style="color:red;font-weight:bold;">申通快递</span>、单号<span style="color:red;font-weight:bold;">st12654458855</span>；卖家应补<span style="color:red;font-weight:bold;">0</span>、买家应补<span style="color:red;font-weight:bold;">0</span>、应退运费<span style="color:red;font-weight:bold;">8</span>元；发货仓选择<span style="color:red;font-weight:bold;">淘金仓库</span>；备注：<span style="color:red;font-weight:bold;">破损补发</span>；<br>收件人信息：<span style="color:red;font-weight:bold;">陕西省西安市雁塔区丈八街道丹轩梓园3号楼，收货人朱小明、13800138000</span>，寄出快递选择京东快递，再点击<span style="color:red;font-weight:bold;">确定创建新售后单</span>。',
      fields: function fields(_ref26) {
        var form = _ref26.form;
        return [ORDER_FIELD].concat((0, _toConsumableArray2.default)(buildResendOrderFields(form)));
      },
      tables: function tables(_ref27) {
        var ui = _ref27.ui;
        return buildPracticeOrderTables('补', ui);
      },
      hotspots: [{
        id: 'create-resend-aftersale',
        x: 0.91,
        y: 0.95,
        w: 0.07,
        h: 0.028,
        highlight: 'primary',
        guard: validateResendOrder,
        action: function action() {
          return {
            set: {
              createdThirdAftersales: [SIMULATED_AFTERSALE]
            },
            next: 'after-resend-list'
          };
        }
      }]
    }, {
      id: 'after-resend-list',
      image: SCENE_IMAGES.aftersaleList,
      aspectRatio: 2,
      tip: '普通售后业务－补发已创建。请继续点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>，创建<span style="color:red;font-weight:bold;">错发售后业务－普通退货</span>。',
      tables: function tables(context) {
        return buildAftersaleListTables(context);
      },
      hotspots: [{
        id: 'create-wrong-return-aftersale',
        x: 0.17,
        y: 0.145,
        w: 0.10,
        h: 0.035,
        highlight: 'primary',
        setForm: {
          orderCode: ''
        },
        next: 'wrong-order-search'
      }]
    }, {
      id: 'wrong-order-search',
      image: SCENE_IMAGES.empty,
      aspectRatio: 2,
      tip: '输入线上订单号 <span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span> 并点击搜索，进入错发售后建单。',
      fields: [ORDER_FIELD],
      hotspots: [{
        id: 'search-wrong-order',
        x: 0.657,
        y: 0.091,
        w: 0.03,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref28) {
          var form = _ref28.form;
          return String(form.orderCode || '').trim() === TARGET_ORDER_CODE ? {
            ok: true
          } : {
            ok: false,
            msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE
          };
        },
        set: CLEAR_PRACTICE_ORDER_SELECTION,
        next: 'wrong-normal-business'
      }]
    }, {
      id: 'wrong-normal-business',
      image: SCENE_IMAGES.return,
      aspectRatio: 2,
      tip: '订单搜索完成，当前处于<span style="color:red;font-weight:bold;">普通售后业务</span>。请点击<span style="color:red;font-weight:bold;">错发售后业务</span>。',
      fields: [ORDER_FIELD],
      tables: function tables(_ref29) {
        var ui = _ref29.ui;
        return buildPracticeOrderTables('退', ui);
      },
      hotspots: [{
        id: 'enter-wrong-business',
        x: 0.095,
        y: 0.492,
        w: 0.053,
        h: 0.027,
        highlight: 'primary',
        guard: requirePracticeOrderSelection,
        next: 'create-wrong-return'
      }]
    }, {
      id: 'create-wrong-return',
      image: SCENE_IMAGES.refund,
      aspectRatio: 2,
      tip: '已选择<span style="color:red;font-weight:bold;">错发售后业务－普通退货</span>。请勾选商品编码为<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>的商品；填写买家退回快递<span style="color:red;font-weight:bold;">申通快递</span>、单号<span style="color:red;font-weight:bold;">st12654458855</span>，卖家应补<span style="color:red;font-weight:bold;">0</span>、买家应补<span style="color:red;font-weight:bold;">0</span>、应退运费<span style="color:red;font-weight:bold;">8</span>；退货仓选择<span style="color:red;font-weight:bold;">淘金仓库</span>，买家退款账号填写<span style="color:red;font-weight:bold;">13800138000</span>，卖家退款账号选择<span style="color:red;font-weight:bold;">淘金账户</span>，备注填写<span style="color:red;font-weight:bold;">错发退货退款</span>，再点击<span style="color:red;font-weight:bold;">确定创建新售后单</span>。',
      fields: [ORDER_FIELD].concat((0, _toConsumableArray2.default)(buildWrongReturnFields())),
      tables: function tables(_ref30) {
        var ui = _ref30.ui;
        return buildWrongReturnOrderTables(ui);
      },
      hotspots: [{
        id: 'add-wrong-return-sent-goods',
        x: 0.138,
        y: 0.685,
        w: 0.075,
        h: 0.026,
        highlight: 'primary',
        action: function action() {
          return {
            set: {
              wrongReturnLibrarySearched: false,
              'wrong-return-library-tableSelectedKeys': [],
              'wrong-return-library-tableSelectedRows': []
            },
            setForm: {
              wrongReturnLibraryStyleCode: ''
            },
            next: 'select-wrong-return-sent-library-goods'
          };
        }
      }, {
        id: 'confirm-create-wrong-return',
        x: 0.912,
        y: 0.945,
        w: 0.065,
        h: 0.03,
        highlight: 'primary',
        guard: validateWrongReturnCreation,
        action: function action(_ref31) {
          var ui = _ref31.ui;
          return {
            set: {
              createdThirdAftersales: [].concat((0, _toConsumableArray2.default)(ui.createdThirdAftersales || []), [SIMULATED_WRONG_RETURN_AFTERSALE]),
              wrongReturnAddedGoods: [],
              wrongReturnLibrarySearched: false,
              'wrong-return-library-tableSelectedKeys': [],
              'wrong-return-library-tableSelectedRows': [],
              'third-wrong-return-goods-tableSelectedKeys': [],
              'third-wrong-return-goods-tableSelectedRows': []
            },
            next: 'after-wrong-return-list'
          };
        }
      }]
    }, {
      id: 'after-wrong-return-list',
      image: SCENE_IMAGES.aftersaleList,
      aspectRatio: 2,
      tip: '错发售后业务－普通退货已创建。请继续点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>，开始创建<span style="color:red;font-weight:bold;">错发售后业务－换货</span>。',
      tables: function tables(context) {
        return buildAftersaleListTables(context);
      },
      hotspots: [{
        id: 'create-wrong-exchange-aftersale',
        x: 0.17,
        y: 0.145,
        w: 0.10,
        h: 0.035,
        highlight: 'primary',
        setForm: {
          orderCode: ''
        },
        next: 'wrong-exchange-order-search'
      }]
    }, {
      id: 'wrong-exchange-order-search',
      image: SCENE_IMAGES.empty,
      aspectRatio: 2,
      tip: '输入线上订单号 <span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span> 并点击搜索，创建错发售后业务－换货。',
      fields: [ORDER_FIELD],
      hotspots: [{
        id: 'search-wrong-exchange-order',
        x: 0.657,
        y: 0.091,
        w: 0.03,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref32) {
          var form = _ref32.form;
          return String(form.orderCode || '').trim() === TARGET_ORDER_CODE ? {
            ok: true
          } : {
            ok: false,
            msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE
          };
        },
        set: CLEAR_PRACTICE_ORDER_SELECTION,
        next: 'wrong-exchange-normal-business'
      }]
    }, {
      id: 'wrong-exchange-normal-business',
      image: SCENE_IMAGES.return,
      aspectRatio: 2,
      tip: '订单搜索完成，当前处于<span style="color:red;font-weight:bold;">普通售后业务</span>。请点击<span style="color:red;font-weight:bold;">错发售后业务</span>。',
      fields: [ORDER_FIELD],
      tables: function tables(_ref33) {
        var ui = _ref33.ui;
        return buildPracticeOrderTables('退', ui);
      },
      hotspots: [{
        id: 'enter-wrong-exchange-business',
        x: 0.095,
        y: 0.492,
        w: 0.053,
        h: 0.027,
        highlight: 'primary',
        guard: requirePracticeOrderSelection,
        next: 'wrong-exchange-default-return'
      }]
    }, {
      id: 'wrong-exchange-default-return',
      image: SCENE_IMAGES.refund,
      aspectRatio: 2,
      tip: '已进入<span style="color:red;font-weight:bold;">错发售后业务</span>，系统默认选中<span style="color:red;font-weight:bold;">普通退货</span>。请点击售后分类中的<span style="color:red;font-weight:bold;">换货</span>。',
      fields: [ORDER_FIELD],
      tables: function tables(_ref34) {
        var ui = _ref34.ui;
        return buildWrongReturnOrderTables(ui);
      },
      hotspots: [{
        id: 'wrong-exchange-type',
        x: 0.155,
        y: 0.526,
        w: 0.045,
        h: 0.027,
        highlight: 'primary',
        next: 'create-wrong-exchange'
      }]
    }, {
      id: 'create-wrong-exchange',
      image: r('3-wrong-exchange.png'),
      aspectRatio: 2,
      tip: '<p><strong>订单信息</strong><br>退回快递：<span style="color:red;font-weight:bold;">申通快递</span>；单号：<span style="color:red;font-weight:bold;">st12654458855</span>；卖家应补：<span style="color:red;font-weight:bold;">0</span>；买家应补：<span style="color:red;font-weight:bold;">0</span>；应退运费：<span style="color:red;font-weight:bold;">8</span>。退货仓、收货仓、发货仓均选择<span style="color:red;font-weight:bold;">淘金仓库</span>；买家退款账号<span style="color:red;font-weight:bold;">13800138000</span>；卖家退款账号<span style="color:red;font-weight:bold;">淘金账户</span>。买家地址：<span style="color:red;font-weight:bold;">陕西省西安市雁塔区丈八街道丹轩梓园3号楼</span>，收货人<span style="color:red;font-weight:bold;">朱小明</span>，联系手机<span style="color:red;font-weight:bold;">13800138000</span>，寄出快递选择<span style="color:red;font-weight:bold;">京东快递</span>，备注<span style="color:red;font-weight:bold;">错发退换货</span>。</p><p><strong>操作一：标记应发未发商品</strong><br>点击<span style="color:red;font-weight:bold;">添加应发未发商品</span>，在弹窗中选中订单原商品 <span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>。</p><p><strong>操作二：添加错发已发商品</strong><br>在商品库中按款式编码搜索或直接选择 <span style="color:red;font-weight:bold;">' + TARGET_LIBRARY_STYLE_CODE + '</span>。</p><p><strong>操作三：点击添加换货的商品(订单)</strong><br>选择订单原商品 <span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>，确认后添加为换货商品。</p><p><strong>操作四：售后问题登记（图片／线下备注）</strong><br>选择<span style="color:red;font-weight:bold;">待客服处理</span>，点击<span style="color:red;font-weight:bold;">确定</span>保存并返回建单页。</p>',
      fields: function fields(_ref35) {
        var form = _ref35.form;
        return [ORDER_FIELD].concat((0, _toConsumableArray2.default)(buildWrongExchangeFields(form)));
      },
      tables: function tables(_ref36) {
        var ui = _ref36.ui;
        return buildWrongExchangeOrderTables(ui);
      },
      hotspots: [{
        id: 'add-missing-order-goods',
        x: 0.052,
        y: 0.685,
        w: 0.075,
        h: 0.026,
        highlight: 'primary',
        next: 'select-missing-order-goods'
      }, {
        id: 'add-wrong-sent-goods',
        x: 0.138,
        y: 0.685,
        w: 0.075,
        h: 0.026,
        highlight: 'primary',
        next: 'select-wrong-sent-library-goods'
      }, {
        id: 'add-exchange-order-goods',
        x: 0.222,
        y: 0.685,
        w: 0.08,
        h: 0.026,
        highlight: 'primary',
        next: 'select-exchange-order-goods'
      }, {
        id: 'open-aftersale-issue-registration',
        x: 0.411,
        y: 0.685,
        w: 0.10,
        h: 0.026,
        highlight: 'primary',
        next: 'aftersale-issue-registration'
      }, {
        id: 'confirm-create-wrong-exchange',
        x: 0.91,
        y: 0.945,
        w: 0.065,
        h: 0.025,
        highlight: 'primary',
        guard: validateWrongExchangeCreation,
        action: function action(_ref37) {
          var ui = _ref37.ui;
          return {
            set: {
              createdThirdAftersales: [].concat((0, _toConsumableArray2.default)(ui.createdThirdAftersales || []), [SIMULATED_WRONG_EXCHANGE_AFTERSALE])
            },
            next: 'after-wrong-exchange-list'
          };
        }
      }]
    }, {
      id: 'after-wrong-exchange-list',
      image: SCENE_IMAGES.aftersaleList,
      aspectRatio: 2,
      tip: '错发售后业务－换货已创建。请继续点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>，创建<span style="color:red;font-weight:bold;">漏发售后业务－补发</span>。',
      tables: function tables(context) {
        return buildAftersaleListTables(context);
      },
      hotspots: [{
        id: 'create-leak-resend-aftersale',
        x: 0.17,
        y: 0.145,
        w: 0.10,
        h: 0.035,
        highlight: 'primary',
        setForm: {
          orderCode: '',
          returnExpress: '',
          returnWaybill: '',
          sellerSubsidy: '',
          buyerSubsidy: '',
          refundFreight: '',
          remark: '',
          shippingWarehouse: '',
          receiverProvince: '',
          receiverCity: '',
          receiverDistrict: '',
          receiverAddress: '',
          receiverName: '',
          receiverPhone: '',
          outExpress: ''
        },
        next: 'leak-order-search'
      }]
    }, {
      id: 'aftersale-issue-registration',
      image: r('3-aftersale-issue-registration.png'),
      aspectRatio: 2,
      tip: '请选择<span style="color:red;font-weight:bold;">待客服处理</span>，点击<span style="color:red;font-weight:bold;">确定</span>保存并返回建单页。',
      labels: function labels(_ref38) {
        var ui = _ref38.ui;
        return ui.wrongExchangeIssueRegistrationPending ? [{
          id: 'issue-registration-pending-check',
          text: '✓',
          color: '#1687ff',
          fontWeight: 'bold',
          fontSize: 15,
          x: 0.494,
          y: 0.338,
          w: 0.012,
          h: 0.022
        }] : [];
      },
      hotspots: [{
        id: 'select-issue-registration-pending',
        x: 0.49,
        y: 0.337,
        w: 0.09,
        h: 0.03,
        highlight: 'primary',
        action: function action() {
          return {
            set: {
              wrongExchangeIssueRegistrationPending: true
            }
          };
        }
      }, {
        id: 'save-aftersale-issue-registration',
        x: 0.602,
        y: 0.823,
        w: 0.035,
        h: 0.032,
        highlight: 'primary',
        guard: function guard(_ref39) {
          var ui = _ref39.ui;
          return ui.wrongExchangeIssueRegistrationPending ? {
            ok: true
          } : {
            ok: false,
            msg: '请先选择待客服处理。'
          };
        },
        action: function action() {
          return {
            set: {
              wrongExchangeIssueRegistrationCompleted: true
            },
            next: 'create-wrong-exchange'
          };
        }
      }, {
        id: 'close-aftersale-issue-registration',
        x: 0.625,
        y: 0.142,
        w: 0.012,
        h: 0.022,
        next: 'create-wrong-exchange'
      }]
    }, {
      id: 'select-missing-order-goods',
      image: r('3-select-return-order-goods.png'),
      aspectRatio: 2,
      tip: '请选择<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>。选择后会将该订单商品的明细问题类型改为<span style="color:red;font-weight:bold;">应发未发</span>。',
      tables: function tables(_ref40) {
        var ui = _ref40.ui;
        return buildOrderGoodsPicker('wrong-exchange-missing-picker-table', ui['wrong-exchange-missing-picker-tableSelectedKeys'] || [], {
          x: 0.297,
          y: 0.3,
          w: 0.438,
          h: 0.4
        });
      },
      hotspots: [{
        id: 'close-missing-order-goods-modal',
        x: 0.716,
        y: 0.267,
        w: 0.016,
        h: 0.025,
        next: 'create-wrong-exchange'
      }, {
        id: 'confirm-missing-order-goods',
        x: 0.628,
        y: 0.74,
        w: 0.1,
        h: 0.032,
        highlight: 'primary',
        guard: function guard(_ref41) {
          var ui = _ref41.ui;
          var existingType = (ui.wrongExchangeOrderIssueTypes || {})['wrong-exchange-goods-1'];
          var selectedMainRow = (ui['third-wrong-exchange-goods-tableSelectedRows'] || []).find(function (row) {
            return row.id === 'wrong-exchange-goods-1';
          });
          var currentType = existingType || selectedMainRow && selectedMainRow.issueType;
          if (currentType && currentType !== '应发未发') return {
            ok: false,
            msg: '该订单商品已经是其他明细问题类型，不能改为应发未发。'
          };
          if (ui.wrongExchangeAddedMissing) return {
            ok: false,
            msg: '该订单商品已设置为应发未发。'
          };
          var selected = (ui['wrong-exchange-missing-picker-tableSelectedRows'] || [])[0];
          return selected && selected.id === 'wrong-exchange-goods-1' ? {
            ok: true
          } : {
            ok: false,
            msg: '请选择商品编码 ' + TARGET_PRACTICE_GOODS_CODE + '。'
          };
        },
        action: function action(_ref42) {
          var ui = _ref42.ui;
          return {
            set: _objectSpread({
              wrongExchangeAddedMissing: true,
              wrongExchangeOrderIssueTypes: _objectSpread(_objectSpread({}, ui.wrongExchangeOrderIssueTypes || {}), {}, {
                'wrong-exchange-goods-1': '应发未发'
              })
            }, selectWrongExchangeGood(ui, _objectSpread(_objectSpread({}, WRONG_EXCHANGE_GOODS[0]), {}, {
              issueType: '应发未发'
            }))),
            next: 'create-wrong-exchange'
          };
        }
      }]
    }, {
      id: 'select-wrong-return-sent-library-goods',
      image: r('3-product-library.png'),
      aspectRatio: 2,
      fields: [{
        id: 'wrong-return-library-style-code',
        model: 'wrongReturnLibraryStyleCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '款式编码',
        x: 0.19,
        y: 0.1702,
        w: 0.04,
        h: 0.023
      }],
      tables: function tables(context) {
        return buildWrongReturnProductLibraryTables(context);
      },
      hotspots: [{
        id: 'close-wrong-return-library-modal',
        x: 0.795,
        y: 0.135,
        w: 0.016,
        h: 0.025,
        next: 'create-wrong-return'
      }, {
        id: 'search-wrong-return-library-style-code',
        x: 0.665,
        y: 0.202,
        w: 0.035,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref43) {
          var form = _ref43.form;
          return String(form.wrongReturnLibraryStyleCode || '').trim().toUpperCase() === WRONG_RETURN_LIBRARY_PRODUCT.styleCode ? {
            ok: true
          } : {
            ok: false,
            msg: '请使用款式编码 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + ' 搜索商品。'
          };
        },
        set: {
          wrongReturnLibrarySearched: true,
          'wrong-return-library-tableSelectedKeys': [],
          'wrong-return-library-tableSelectedRows': []
        }
      }, {
        id: 'confirm-wrong-return-library-goods',
        x: 0.761,
        y: 0.833,
        w: 0.045,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref44) {
          var ui = _ref44.ui;
          if (!ui.wrongReturnLibrarySearched) return {
            ok: false,
            msg: '请先搜索款式编码 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + '。'
          };
          var selected = (ui['wrong-return-library-tableSelectedRows'] || [])[0];
          return selected && selected.id === WRONG_RETURN_LIBRARY_PRODUCT.id ? {
            ok: true
          } : {
            ok: false,
            msg: '请搜索并选中款式编码 ' + WRONG_RETURN_LIBRARY_PRODUCT.styleCode + ' 的商品。'
          };
        },
        action: function action() {
          return {
            set: {
              wrongReturnAddedGoods: [WRONG_RETURN_ADDED_GOOD],
              'wrong-return-library-tableSelectedKeys': [],
              'wrong-return-library-tableSelectedRows': []
            },
            next: 'create-wrong-return'
          };
        }
      }]
    }, {
      id: 'select-wrong-sent-library-goods',
      image: r('3-product-library.png'),
      aspectRatio: 2,
      tip: '商品库默认展示全部商品。请用款式编码搜索<span style="color:red;font-weight:bold;">' + TARGET_LIBRARY_STYLE_CODE + '</span>，选中不在订单中的商品后确认返回。',
      fields: [{
        id: 'library-style-code',
        model: 'libraryStyleCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '款式编码',
        x: 0.19,
        y: 0.1702,
        w: 0.04,
        h: 0.023
      }],
      tables: function tables(context) {
        return buildProductLibraryTables(context);
      },
      hotspots: [{
        id: 'close-wrong-sent-library-modal',
        x: 0.795,
        y: 0.135,
        w: 0.016,
        h: 0.025,
        next: 'create-wrong-exchange'
      }, {
        id: 'search-library-style-code',
        x: 0.665,
        y: 0.202,
        w: 0.035,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref45) {
          var form = _ref45.form;
          return String(form.libraryStyleCode || '').trim().toUpperCase() === TARGET_LIBRARY_STYLE_CODE.toUpperCase() ? {
            ok: true
          } : {
            ok: false,
            msg: '请使用款式编码 ' + TARGET_LIBRARY_STYLE_CODE + ' 搜索商品。'
          };
        }
      }, {
        id: 'confirm-wrong-sent-library-goods',
        x: 0.761,
        y: 0.833,
        w: 0.045,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref46) {
          var ui = _ref46.ui;
          var selected = (ui['wrong-exchange-library-tableSelectedRows'] || [])[0];
          return selected && selected.id === TARGET_LIBRARY_GOODS.id ? {
            ok: true
          } : {
            ok: false,
            msg: '请搜索并选中款式编码 ' + TARGET_LIBRARY_STYLE_CODE + ' 的商品。'
          };
        },
        action: function action(_ref47) {
          var ui = _ref47.ui;
          return {
            set: _objectSpread({
              wrongExchangeAddedWrong: true
            }, appendWrongExchangeGood(ui, {
              id: 'added-wrong-sent-goods-1',
              thumbnail: '',
              goodsCode: TARGET_LIBRARY_GOODS_CODE,
              styleCode: TARGET_LIBRARY_STYLE_CODE,
              type: '退',
              issueType: '错发已发',
              goodsName: TARGET_LIBRARY_GOODS.goodsName,
              spec: TARGET_LIBRARY_GOODS.spec,
              orderGoodsStatus: '',
              goodsTag: '',
              unitPrice: TARGET_LIBRARY_GOODS.unitPrice,
              goodsAmount: TARGET_LIBRARY_GOODS.unitPrice,
              orderQty: 1,
              currentQty: '1',
              defectiveQty: '',
              currentAmount: TARGET_LIBRARY_GOODS.unitPrice,
              appliedReturnQty: 0,
              actualReturnQty: 0,
              remark: '',
              availableStock: TARGET_LIBRARY_GOODS.stock
            })),
            next: 'create-wrong-exchange'
          };
        }
      }]
    }, {
      id: 'select-exchange-order-goods',
      image: r('3-select-exchange-order-goods.png'),
      aspectRatio: 2,
      tip: '请选择订单原商品中的<span style="color:red;font-weight:bold;">' + TARGET_PRACTICE_GOODS_CODE + '</span>，确认后将其添加为<span style="color:red;font-weight:bold;">换货</span>商品。',
      tables: function tables(_ref48) {
        var ui = _ref48.ui;
        return buildOrderGoodsPicker('wrong-exchange-order-picker-table', ui['wrong-exchange-order-picker-tableSelectedKeys'] || [], {
          x: 0.296,
          y: 0.3,
          w: 0.44,
          h: 0.4
        });
      },
      hotspots: [{
        id: 'close-exchange-order-goods-modal',
        x: 0.716,
        y: 0.267,
        w: 0.016,
        h: 0.025,
        next: 'create-wrong-exchange'
      }, {
        id: 'confirm-exchange-order-goods',
        x: 0.628,
        y: 0.738,
        w: 0.105,
        h: 0.032,
        highlight: 'primary',
        guard: function guard(_ref49) {
          var ui = _ref49.ui;
          var selected = (ui['wrong-exchange-order-picker-tableSelectedRows'] || [])[0];
          return selected && selected.id === 'wrong-exchange-goods-1' ? {
            ok: true
          } : {
            ok: false,
            msg: '请选择商品编码 ' + TARGET_PRACTICE_GOODS_CODE + '。'
          };
        },
        action: function action(_ref50) {
          var ui = _ref50.ui;
          return {
            set: _objectSpread({
              wrongExchangeAddedExchange: true
            }, appendWrongExchangeGood(ui, _objectSpread(_objectSpread({}, WRONG_EXCHANGE_GOODS[0]), {}, {
              id: 'added-exchange-goods-1',
              type: '换',
              issueType: '',
              currentQty: '0'
            }))),
            next: 'create-wrong-exchange'
          };
        }
      }]
    }, {
      id: 'aftersale-detail',
      image: SCENE_IMAGES.detail,
      aspectRatio: 2,
      tip: '已进入<span style="color:red;font-weight:bold;">订单售后明细</span>。查看线上订单号<span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span>的售后单号、商品、申请数量和退款金额。',
      fields: [ORDER_FIELD],
      tables: function tables(_ref51) {
        var ui = _ref51.ui;
        return [buildPracticeOrderTables('退', ui, DETAIL_PRACTICE_ORDER)[0]].concat((0, _toConsumableArray2.default)(buildOrderAftersaleDetailTables()));
      },
      isEnd: true
    }, {
      id: 'create-noinfo',
      image: SCENE_IMAGES.noInfo,
      aspectRatio: 2,
      tip: '<p><strong>快递信息</strong><br>买家退回快递填写<span style="color:red;font-weight:bold;">申通快递</span>；买家退回快递单号填写<span style="color:red;font-weight:bold;">st12654458855</span>。</p><p><strong>基础信息</strong><br>备注填写<span style="color:red;font-weight:bold;">无信息件退货</span>；退货仓选择<span style="color:red;font-weight:bold;">淘金仓库</span>；店铺选择<span style="color:red;font-weight:bold;">淘金云官方旗舰店</span>。</p><p><strong>下一步</strong><br>完成上述信息后，点击<span style="color:red;font-weight:bold;">添加退回来的商品（商品库）</span>。</p>',
      fields: buildNoInfoFields(),
      tables: function tables(_ref52) {
        var ui = _ref52.ui;
        return buildNoInfoCreateGoodsTables(ui);
      },
      hotspots: function hotspots(_ref53) {
        var ui = _ref53.ui;
        return [{
          id: 'add-return-goods',
          x: 0.235,
          y: 0.418,
          w: 0.105,
          h: 0.024,
          highlight: 'primary',
          next: 'select-noinfo-goods'
        }].concat((0, _toConsumableArray2.default)((ui.noinfoAddedGoods || []).length ? [{
          id: 'confirm-create-noinfo-aftersale',
          x: 0.731,
          y: 0.742,
          w: 0.06,
          h: 0.028,
          highlight: 'primary',
          guard: validateNoInfoCreation,
          action: function action(_ref54) {
            var ui = _ref54.ui;
            return {
              set: {
                createdThirdAftersales: [].concat((0, _toConsumableArray2.default)(ui.createdThirdAftersales || []), [SIMULATED_NOINFO_AFTERSALE])
              },
              next: 'after-noinfo-list'
            };
          }
        }] : []));
      }
    }, {
      id: 'after-noinfo-list',
      image: SCENE_IMAGES.aftersaleList,
      aspectRatio: 2,
      tip: '无信息件售后单已创建。继续点击<span style="color:red;font-weight:bold;">创建退货补发换货售后单</span>，查看订单售后明细。',
      tables: function tables(context) {
        return buildAftersaleListTables(context);
      },
      hotspots: [{
        id: 'create-aftersale-detail',
        x: 0.17,
        y: 0.145,
        w: 0.10,
        h: 0.035,
        highlight: 'primary',
        setForm: {
          orderCode: ''
        },
        next: 'detail-order-search'
      }]
    }, {
      id: 'detail-order-search',
      image: SCENE_IMAGES.empty,
      aspectRatio: 2,
      tip: '输入线上订单号<span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span>并点击搜索，查看该订单的售后明细。',
      fields: [ORDER_FIELD],
      hotspots: [{
        id: 'search-detail-order',
        x: 0.657,
        y: 0.091,
        w: 0.03,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref55) {
          var form = _ref55.form;
          return String(form.orderCode || '').trim() === DETAIL_ORDER_CODE ? {
            ok: true
          } : {
            ok: false,
            msg: '请输入正确的线上订单号 ' + DETAIL_ORDER_CODE
          };
        },
        set: CLEAR_PRACTICE_ORDER_SELECTION,
        next: 'detail-order-result'
      }]
    }, {
      id: 'detail-order-result',
      image: SCENE_IMAGES.return,
      aspectRatio: 2,
      tip: '订单查询成功。点击<span style="color:red;font-weight:bold;">订单售后明细</span>查看线上订单号<span style="color:red;font-weight:bold;">' + TARGET_ORDER_CODE + '</span>的售后明细。',
      fields: [ORDER_FIELD],
      tables: function tables(_ref56) {
        var ui = _ref56.ui;
        return buildPracticeOrderTables('退', ui, DETAIL_PRACTICE_ORDER);
      },
      hotspots: [{
        id: 'view-order-aftersale-detail',
        x: 0.20,
        y: 0.485,
        w: 0.05,
        h: 0.03,
        highlight: 'primary',
        guard: requirePracticeOrderSelection,
        next: 'aftersale-detail'
      }]
    }, {
      id: 'select-noinfo-goods',
      image: SCENE_IMAGES.goods,
      aspectRatio: 2,
      tip: '请在商品编码中搜索<span style="color:red;font-weight:bold;">' + TARGET_LIBRARY_STYLE_CODE + '</span>，选中搜索结果后点击<span style="color:red;font-weight:bold;">确定返回</span>。',
      fields: [{
        id: 'goods-code',
        model: 'goodsCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 11,
        placeholder: '商品编码',
        x: 0.23,
        y: 0.171,
        w: 0.04,
        h: 0.022
      }],
      tables: function tables(context) {
        return buildNoInfoProductLibraryTables(context);
      },
      hotspots: [{
        id: 'search-noinfo-goods',
        x: 0.665,
        y: 0.202,
        w: 0.035,
        h: 0.028,
        highlight: 'primary',
        guard: function guard(_ref57) {
          var form = _ref57.form;
          return String(form.goodsCode || '').trim().toUpperCase() === TARGET_LIBRARY_STYLE_CODE.toUpperCase() ? {
            ok: true
          } : {
            ok: false,
            msg: '请在商品编码中输入 ' + TARGET_LIBRARY_STYLE_CODE + ' 后搜索。'
          };
        },
        action: function action(_ref58) {
          var form = _ref58.form;
          return {
            set: {
              noinfoSearchedGoodsCode: String(form.goodsCode || '').trim()
            }
          };
        }
      }, {
        id: 'confirm-goods',
        x: 0.761,
        y: 0.838,
        w: 0.05,
        h: 0.03,
        highlight: 'primary',
        guard: function guard(_ref59) {
          var ui = _ref59.ui;
          var selected = (ui['noinfo-product-library-tableSelectedRows'] || [])[0];
          return selected && selected.id === TARGET_LIBRARY_GOODS.id ? {
            ok: true
          } : {
            ok: false,
            msg: '请选择款式编码为 ' + TARGET_LIBRARY_STYLE_CODE + ' 的商品。'
          };
        },
        action: function action() {
          return {
            set: {
              noinfoAddedGoods: SIMULATED_NOINFO_AFTERSALE_GOODS
            },
            next: 'create-noinfo'
          };
        }
      }]
    }, {
      id: 'done',
      image: SCENE_IMAGES.aftersaleList,
      aspectRatio: 2,
      tables: function tables(context) {
        return buildAftersaleListTables(context);
      },
      tip: '<span style="color:red;font-weight:bold;">第三章创建售后练习完成。</span>',
      isEnd: true
    }]
  };
  return _objectSpread(_objectSpread({}, scenario), {}, {
    steps: scenario.steps.map(function (step) {
      return _objectSpread(_objectSpread({}, step), {}, {
        tip: getThirdChapterTip
      });
    })
  });
}

/***/ }),
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jst-erp-scene" },
    [
      _c("StepPlayer", {
        ref: "player",
        attrs: {
          steps: _vm.scenario.steps,
          "initial-step-id": _vm.scenario.initialStepId,
          "initial-form": _vm.scenario.initialForm,
          "initial-ui": _vm.scenario.initialUi,
          "show-tip": false
        },
        on: {
          "step-change": _vm.onStepChange,
          "guard-failed": _vm.onGuardFailed,
          finish: _vm.onFinish
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06264f63", esExports)
  }
}

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c85e8b4a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ff6ff64\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpOrderQueryScene.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ff6ff64\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpOrderQueryScene.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.jst-erp-scene[data-v-4ff6ff64] {\n  width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  color: #303133;\n  text-align: left;\n  background: #fff;\n}\n[data-v-4ff6ff64] .step-player {\n  display: block;\n  width: 100%;\n}\n[data-v-4ff6ff64] .step-player .stage {\n  width: 100%;\n  min-height: 420px;\n  overflow: hidden;\n  background-color: #eef2f7;\n}\n[data-v-4ff6ff64] .step-player .hotspot {\n  z-index: 3;\n}\n[data-v-4ff6ff64] .step-player .field {\n  z-index: 4;\n  border-radius: 2px;\n}\n[data-v-4ff6ff64] .step-player .field-input {\n  color: #303133;\n  background: rgba(255, 255, 255, 0.01);\n}\n", ""]);

// exports


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJstErpOrderQueryScenario = getJstErpOrderQueryScenario;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(16));
var _jstErpFixtureData = __webpack_require__(301);
var _jstTip = __webpack_require__(302);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * 聚水潭 ERP 第四章「订单查询」场景，素材对应《聚水潭功能学习》PPT 第 46-48 页。
 */
function r(path) {
  return __webpack_require__(303)("./" + path);
}
var TARGET_ORDER_CODE = _jstErpFixtureData.JST_TARGETS.orderQuery;
var TARGET_AFTERSALE_ORDER_CODE = _jstErpFixtureData.JST_TARGETS.aftersaleQuery;
var ORDER_QUERY_TIP = '在' + (0, _jstTip.red)('订单页面') + '查询线上订单号' + (0, _jstTip.red)(TARGET_ORDER_CODE) + '的售后';
var AFTERSALE_RETURN_QUERY_TIP = '在' + (0, _jstTip.red)('售后（退货退款）') + '查询线上订单号' + (0, _jstTip.red)(TARGET_AFTERSALE_ORDER_CODE) + '的售后';
var AFTERSALE_FAST_QUERY_TIP = '在' + (0, _jstTip.red)('售后极速版') + '查询线上订单号' + (0, _jstTip.red)(TARGET_AFTERSALE_ORDER_CODE) + '的售后';
var LOGOUT_TIP = '退出聚水潭';
var SCENE_IMAGES = {
  login: r('jst_login.png'),
  home: r('1-0.png'),
  homeMenu: r('1-1.png'),
  orderResult: r('4-1-order-query-result.png'),
  aftersaleQuery: r('4-2-aftersale-query.png'),
  aftersaleResult: r('4-3-aftersale-query-result.png')
};
var DEFAULT_GOODS_THUMBNAIL = r('order-default-necklace.png');
var ORDER_QUERY_ROWS = _jstErpFixtureData.JST_ORDER_QUERY_ROWS.map(function (row) {
  return _objectSpread(_objectSpread({}, row), {}, {
    goods: DEFAULT_GOODS_THUMBNAIL
  });
});
var ORDER_QUERY_COLUMNS = [{
  key: 'internalOrderNo',
  title: '内部订单号',
  width: 96
}, {
  key: 'tags',
  title: '标记及多标签',
  width: 94,
  align: 'center'
}, {
  key: 'goods',
  type: 'image',
  title: '商品',
  width: 92,
  align: 'center'
}, {
  key: 'onlineOrderNo',
  title: '线上订单号',
  width: 142,
  whiteSpace: 'pre-line'
}, {
  key: 'externalOrderNo',
  title: '外部交易',
  width: 64
}, {
  key: 'orderTime',
  title: '下单时间',
  width: 126,
  whiteSpace: 'pre-line'
}, {
  key: 'paymentTime',
  title: '付款时间',
  width: 126,
  whiteSpace: 'pre-line'
}, {
  key: 'auditTime',
  title: '审核时间',
  width: 118,
  whiteSpace: 'pre-line'
}, {
  key: 'buyer',
  title: '买家账号及店铺',
  width: 144,
  whiteSpace: 'pre-line'
}, {
  key: 'payable',
  title: '应付金额及运费',
  width: 78,
  align: 'right',
  whiteSpace: 'pre-line'
}, {
  key: 'profit',
  title: '利润',
  width: 50,
  align: 'right'
}, {
  key: 'paidAmount',
  title: '已付金额',
  width: 78,
  align: 'right'
}, {
  key: 'additional',
  title: '附加信息',
  width: 90,
  align: 'right',
  whiteSpace: 'pre-line'
}, {
  key: 'status',
  title: '状态',
  width: 92,
  align: 'center',
  whiteSpace: 'pre-line'
}, {
  key: 'suggestion',
  title: '处理建议',
  width: 192,
  whiteSpace: 'pre-line'
}];
function buildOrderQueryTables() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ORDER_QUERY_ROWS;
  return [{
    id: 'fourth-order-query-table',
    x: 0.146,
    y: 0.17,
    w: 0.858,
    h: 0.804,
    fontSize: 9,
    rowHeight: 66,
    rows: rows,
    columns: ORDER_QUERY_COLUMNS.map(function (column) {
      return _objectSpread(_objectSpread({}, column), {}, {
        cellStyle: function cellStyle(row) {
          var style = {
            color: '#454545',
            verticalAlign: 'middle'
          };
          if (row.selected) style.background = '#dcecff';
          if (column.key === 'status') {
            if (row.status === '发货中') Object.assign(style, {
              color: '#1689c9',
              background: '#d9f1fd',
              fontWeight: '700'
            });
            if (row.status.indexOf('已付款待审核') > -1) Object.assign(style, {
              background: '#ffe7a3'
            });
            if (row.status.indexOf('异常') > -1) Object.assign(style, {
              color: '#fff',
              background: '#b38d4f',
              fontWeight: '700'
            });
          }
          if (column.key === 'suggestion') style.fontSize = '9px';
          return style;
        }
      });
    }),
    rowKey: 'id',
    selectable: true
  }];
}
var AFTERSALE_FAST_ROWS = _jstErpFixtureData.JST_AFTERSALE_FAST_ROWS;
var AFTERSALE_FAST_COLUMNS = [{
  key: 'aftersaleNo',
  title: '售后单号',
  width: 126
}, {
  key: 'internalOrderNo',
  title: '内部订单号',
  width: 116
}, {
  key: 'aftersaleStatus',
  title: '售后单状态',
  width: 92,
  align: 'center'
}, {
  key: 'solution',
  title: '解决方案',
  width: 82
}, {
  key: 'onlineStatus',
  title: '线上状态',
  width: 120
}, {
  key: 'onlineType',
  title: '线上类型',
  width: 92
}, {
  key: 'aftersaleCategory',
  title: '售后分类',
  width: 92
}, {
  key: 'goodsInfo',
  title: '商品信息',
  width: 220,
  whiteSpace: 'pre-line'
}, {
  key: 'returnExpressNo',
  title: '退货快递单号',
  width: 138
}, {
  key: 'returnInternationalNo',
  title: '退货国际单号',
  width: 138
}, {
  key: 'cargoStatus',
  title: '货物状态',
  width: 100
}, {
  key: 'interceptStatus',
  title: '快递拦截状态',
  width: 120
}, {
  key: 'interceptReason',
  title: '拦截失败原因',
  width: 128
}, {
  key: 'interceptTime',
  title: '快递拦截时间',
  width: 124
}, {
  key: 'receivingWarehouse',
  title: '收货仓',
  width: 90
}, {
  key: 'warehouse',
  title: '仓库',
  width: 148,
  whiteSpace: 'pre-line'
}, {
  key: 'onlineOrderNo',
  title: '线上订单号',
  width: 154,
  whiteSpace: 'pre-line'
}, {
  key: 'onlineAftersaleNo',
  title: '线上售后单号',
  width: 154
}, {
  key: 'issueType',
  title: '售后问题类型',
  width: 128
}, {
  key: 'tags',
  title: '售后标签',
  width: 96
}, {
  key: 'issueRecord',
  title: '售后问题登记',
  width: 160
}, {
  key: 'supplierMemo',
  title: '供分销备注',
  width: 156
}, {
  key: 'supplierAftersaleStatus',
  title: '供应商售后单状态',
  width: 128
}, {
  key: 'workOrder',
  title: '聚工单',
  width: 88
}, {
  key: 'buyer',
  title: '买家账号',
  width: 90
}, {
  key: 'receiver',
  title: '收货信息',
  width: 160,
  whiteSpace: 'pre-line'
}, {
  key: 'store',
  title: '店铺',
  width: 114,
  whiteSpace: 'pre-line'
}, {
  key: 'exceptionStatus',
  title: '异常状态',
  width: 96
}, {
  key: 'supplierRefundStatus',
  title: '供应商退款状态',
  width: 128
}, {
  key: 'applyTime',
  title: '申请时间',
  width: 118,
  whiteSpace: 'pre-line'
}, {
  key: 'confirmTime',
  title: '确认时间',
  width: 118,
  whiteSpace: 'pre-line'
}, {
  key: 'originalOrderStatus',
  title: '原订单状态',
  width: 100
}, {
  key: 'orderStatusSnapshot',
  title: '订单状态快照',
  width: 122
}, {
  key: 'deliveryExpressNo',
  title: '发货快递单号',
  width: 148,
  whiteSpace: 'pre-line'
}, {
  key: 'deliveryInternationalNo',
  title: '发货国际单号',
  width: 138
}, {
  key: 'originalTags',
  title: '原订单标签',
  width: 178,
  whiteSpace: 'pre-line'
}, {
  key: 'originalWarehouse',
  title: '原订单发货仓',
  width: 132,
  whiteSpace: 'pre-line'
}, {
  key: 'originalRemark',
  title: '原订单备注/旗帜',
  width: 126
}, {
  key: 'originalOfflineRemark',
  title: '原订单线下备注',
  width: 126
}, {
  key: 'originalSalesman',
  title: '原订单业务员',
  width: 118
}, {
  key: 'originalPurchaseAmount',
  title: '原订单采购金额',
  width: 128,
  align: 'right'
}, {
  key: 'originalOrderAmount',
  title: '原订单下单金额',
  width: 136,
  align: 'right',
  whiteSpace: 'pre-line'
}, {
  key: 'onlineApplyAmount',
  title: '线上申请金额',
  width: 126,
  align: 'right'
}, {
  key: 'refundedAmount',
  title: '实退金额',
  width: 126,
  align: 'right',
  whiteSpace: 'pre-line'
}, {
  key: 'actualReceivedAmount',
  title: '实际收货金额',
  width: 126,
  align: 'right'
}, {
  key: 'applyReturnQty',
  title: '申请退货数量',
  width: 100,
  align: 'right'
}, {
  key: 'actualReturnQty',
  title: '实退数量',
  width: 90,
  align: 'right'
}, {
  key: 'creator',
  title: '创建人',
  width: 90
}, {
  key: 'modifier',
  title: '修改人',
  width: 90
}, {
  key: 'platformDetail',
  title: '平台售后详情',
  width: 160
}, {
  key: 'arbitrationStatus',
  title: '仲裁状态',
  width: 110
}, {
  key: 'actions',
  title: '操作',
  width: 94,
  align: 'center',
  whiteSpace: 'pre-line'
}];
function buildAftersaleFastTables() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AFTERSALE_FAST_ROWS;
  return [{
    id: 'fourth-aftersale-fast-table',
    x: 0.04,
    y: 0.63,
    w: 0.95,
    h: 0.34,
    fontSize: 9,
    rowHeight: 70,
    rows: rows,
    columns: AFTERSALE_FAST_COLUMNS.map(function (column) {
      return _objectSpread(_objectSpread({}, column), {}, {
        cellStyle: function cellStyle(row) {
          var style = {
            color: '#454545',
            verticalAlign: 'middle'
          };
          if (column.key === 'aftersaleStatus' && row.aftersaleStatus === '待确认') Object.assign(style, {
            color: '#ff8a21',
            fontWeight: '700'
          });
          if (['aftersaleNo', 'internalOrderNo', 'onlineOrderNo', 'buyer', 'deliveryExpressNo', 'platformDetail', 'actions'].indexOf(column.key) > -1) style.color = '#1697ec';
          if (column.key === 'tags') Object.assign(style, {
            color: '#52769d',
            background: '#dfe8f5'
          });
          return style;
        }
      });
    }),
    rowKey: 'id',
    selectable: true
  }];
}
var AFTERSALE_RETURN_ROWS = _jstErpFixtureData.JST_AFTERSALE_RETURN_ROWS;
var AFTERSALE_RETURN_GOODS_BY_ID = Object.keys(_jstErpFixtureData.JST_AFTERSALE_RETURN_GOODS_BY_ID).reduce(function (result, key) {
  result[key] = _jstErpFixtureData.JST_AFTERSALE_RETURN_GOODS_BY_ID[key].map(function (row) {
    return _objectSpread(_objectSpread({}, row), {}, {
      thumbnail: DEFAULT_GOODS_THUMBNAIL
    });
  });
  return result;
}, {});
function buildAftersaleReturnTables(_ref) {
  var ui = _ref.ui;
  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AFTERSALE_RETURN_ROWS;
  var selectedKeys = ui['fourth-aftersale-return-tableSelectedKeys'] || [];
  var goodsRows = AFTERSALE_RETURN_GOODS_BY_ID[selectedKeys[0]] || [];
  return [{
    id: 'fourth-aftersale-return-table',
    x: 0.165,
    y: 0.18,
    w: 0.84,
    h: 0.54,
    cursor: 'pointer',
    rows: rows,
    columns: [{
      key: 'aftersaleNo',
      title: '售后单号',
      width: 126
    }, {
      key: 'businessType',
      title: '业务类型',
      width: 92
    }, {
      key: 'internalOrderNo',
      title: '内部订单号',
      width: 120
    }, {
      key: 'applyTime',
      title: '申请日期',
      width: 160
    }, {
      key: 'onlineType',
      title: '线上类型',
      width: 92
    }, {
      key: 'aftersaleCategory',
      title: '售后分类',
      width: 92
    }, {
      key: 'status',
      title: '状态',
      width: 78
    }, {
      key: 'onlineStatus',
      title: '线上状态',
      width: 100
    }, {
      key: 'cargoStatus',
      title: '货物状态',
      width: 120
    }, {
      key: 'buyerAccount',
      title: '买家账号',
      width: 96
    }, {
      key: 'externalTradeNo',
      title: '外部交易单号',
      width: 130
    }, {
      key: 'receivingWarehouse',
      title: '收货仓',
      width: 96
    }, {
      key: 'warehouse',
      title: '仓库',
      width: 110
    }, {
      key: 'returnLogistics',
      title: '退回物流商渠道',
      width: 130
    }, {
      key: 'returnInternationalNo',
      title: '退回国际单号',
      width: 130
    }],
    rowKey: 'id',
    selectable: true,
    selectionType: 'radio',
    selectedKeys: selectedKeys
  }, {
    id: 'fourth-aftersale-return-goods-table',
    x: 0.165,
    y: 0.76,
    w: 0.84,
    h: 0.21,
    rows: goodsRows,
    columns: [{
      key: 'thumbnail',
      type: 'image',
      title: '缩略图',
      width: 68
    }, {
      key: 'goodsCode',
      title: '商品编码',
      width: 150
    }, {
      key: 'comboGoodsCode',
      title: '组合商品编码',
      width: 150
    }, {
      key: 'styleCode',
      title: '款式编码',
      width: 118
    }, {
      key: 'goodsName',
      title: '商品名称',
      width: 270
    }, {
      key: 'spec',
      title: '颜色及规格',
      width: 220
    }, {
      key: 'goodsTag',
      title: '商品标签',
      width: 110
    }, {
      key: 'onlineDetailAmount',
      title: '线上明细金额',
      width: 120,
      align: 'right'
    }, {
      key: 'unitPrice',
      title: '单价',
      width: 88,
      align: 'right'
    }, {
      key: 'applyQty',
      title: '申请数量',
      width: 88,
      align: 'right'
    }, {
      key: 'actualReturnQty',
      title: '实退数量',
      width: 88,
      align: 'right'
    }],
    rowKey: 'id'
  }];
}
function getJstErpOrderQueryScenario() {
  return {
    initialStepId: 'home',
    initialForm: {
      orderCode: '',
      aftersaleOrderCode: ''
    },
    steps: [{
      id: 'home',
      image: SCENE_IMAGES.home,
      aspectRatio: 2,
      tip: ORDER_QUERY_TIP,
      hotspots: [{
        id: 'open-order-menu',
        x: 0,
        y: 0.06,
        w: 0.03,
        h: 0.06,
        highlight: 'primary',
        next: 'home-menu-order'
      }]
    }, {
      id: 'home-menu-order',
      image: SCENE_IMAGES.homeMenu,
      aspectRatio: 2,
      tip: ORDER_QUERY_TIP,
      hotspots: [{
        id: 'enter-order',
        x: 0.175,
        y: 0.155,
        w: 0.075,
        h: 0.035,
        highlight: 'primary',
        next: 'order-query'
      }, {
        id: 'common-order',
        x: 0.04,
        y: 0.055,
        w: 0.10,
        h: 0.032,
        highlight: 'primary',
        next: 'order-query'
      }]
    }, {
      id: 'order-query',
      image: SCENE_IMAGES.orderResult,
      aspectRatio: 2,
      tip: ORDER_QUERY_TIP,
      fields: [{
        id: 'order-code',
        model: 'orderCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '线上订单号',
        x: 0.034,
        y: 0.107,
        w: 0.06,
        h: 0.022,
        onEnter: function onEnter(_ref2) {
          var form = _ref2.form,
            go = _ref2.go;
          if (String(form.orderCode || '').trim() === TARGET_ORDER_CODE) {
            go('order-done');
            return;
          }
          return {
            ok: false,
            msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE
          };
        }
      }],
      tables: function tables() {
        return buildOrderQueryTables();
      }
    }, {
      id: 'order-done',
      image: SCENE_IMAGES.orderResult,
      aspectRatio: 2,
      fields: [{
        id: 'order-code-result',
        model: 'orderCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '线上订单号',
        x: 0.034,
        y: 0.107,
        w: 0.06,
        h: 0.022
      }],
      tables: function tables() {
        return buildOrderQueryTables(ORDER_QUERY_ROWS.filter(function (row) {
          return row.onlineOrderNo === TARGET_ORDER_CODE;
        }));
      },
      tip: ORDER_QUERY_TIP,
      afterEnter: {
        delay: 2000,
        go: 'home-after-order'
      }
    }, {
      id: 'home-after-order',
      image: SCENE_IMAGES.home,
      aspectRatio: 2,
      tip: AFTERSALE_RETURN_QUERY_TIP,
      hotspots: [{
        id: 'open-menu-after-order',
        x: 0,
        y: 0.06,
        w: 0.03,
        h: 0.06,
        highlight: 'primary',
        next: 'home-menu-aftersale-return'
      }]
    }, {
      id: 'home-menu-aftersale-fast',
      image: SCENE_IMAGES.homeMenu,
      aspectRatio: 2,
      tip: AFTERSALE_FAST_QUERY_TIP,
      hotspots: [{
        id: 'enter-aftersale-fast',
        x: 0.294,
        y: 0.122,
        w: 0.084,
        h: 0.03,
        highlight: 'primary',
        next: 'aftersale-fast'
      }, {
        id: 'common-aftersale-fast',
        x: 0.04,
        y: 0.524,
        w: 0.10,
        h: 0.032,
        highlight: 'primary',
        next: 'aftersale-fast'
      }]
    }, {
      id: 'aftersale-fast',
      image: SCENE_IMAGES.aftersaleQuery,
      aspectRatio: 2,
      tip: AFTERSALE_FAST_QUERY_TIP,
      fields: [{
        id: 'aftersale-order-code',
        model: 'aftersaleOrderCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 11,
        placeholder: '线上订单号',
        x: 0.425,
        y: 0.384,
        w: 0.07,
        h: 0.022
      }],
      tables: function tables() {
        return buildAftersaleFastTables();
      },
      hotspots: [{
        id: 'search-aftersale',
        x: 0.915,
        y: 0.467,
        w: 0.045,
        h: 0.03,
        highlight: 'primary',
        guard: function guard(_ref3) {
          var form = _ref3.form;
          return String(form.aftersaleOrderCode || '').trim() === TARGET_AFTERSALE_ORDER_CODE ? {
            ok: true
          } : {
            ok: false,
            msg: '请输入正确的订单号 ' + TARGET_AFTERSALE_ORDER_CODE
          };
        },
        next: 'aftersale-fast-done'
      }]
    }, {
      id: 'aftersale-fast-done',
      image: SCENE_IMAGES.aftersaleQuery,
      aspectRatio: 2,
      fields: [{
        id: 'aftersale-order-code-result',
        model: 'aftersaleOrderCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 11,
        placeholder: '线上订单号',
        x: 0.425,
        y: 0.384,
        w: 0.07,
        h: 0.022
      }],
      tables: function tables() {
        return buildAftersaleFastTables(AFTERSALE_FAST_ROWS.filter(function (row) {
          return row.onlineOrderNo === TARGET_AFTERSALE_ORDER_CODE;
        }));
      },
      tip: AFTERSALE_FAST_QUERY_TIP,
      afterEnter: {
        delay: 2000,
        go: 'home-exit'
      }
    }, {
      id: 'home-exit',
      image: SCENE_IMAGES.home,
      aspectRatio: 2,
      tip: LOGOUT_TIP,
      hotspots: [{
        id: 'open-merchant-menu',
        x: 0.875,
        y: 0.006,
        w: 0.12,
        h: 0.04,
        highlight: 'primary',
        next: 'merchant-menu'
      }]
    }, {
      id: 'merchant-menu',
      image: SCENE_IMAGES.home,
      aspectRatio: 2,
      tip: LOGOUT_TIP,
      labels: [{
        id: 'merchant-menu-panel',
        text: '',
        x: 0.883,
        y: 0.04,
        w: 0.105,
        h: 0.385,
        bgColor: '#fff'
      }, {
        id: 'merchant-menu-logout',
        text: '退出',
        x: 0.891,
        y: 0.052,
        w: 0.085,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }, {
        id: 'merchant-menu-switch',
        text: '切换分仓　›',
        x: 0.891,
        y: 0.094,
        w: 0.085,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }, {
        id: 'merchant-menu-account',
        text: '账号密码管理　›',
        x: 0.891,
        y: 0.136,
        w: 0.09,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }, {
        id: 'merchant-menu-print-download',
        text: '打印控件下载',
        x: 0.891,
        y: 0.178,
        w: 0.085,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }, {
        id: 'merchant-menu-print-test',
        text: '打印测试工具',
        x: 0.891,
        y: 0.22,
        w: 0.085,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }, {
        id: 'merchant-menu-cloud',
        text: '下载聚水云',
        x: 0.891,
        y: 0.262,
        w: 0.085,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }, {
        id: 'merchant-menu-feedback',
        text: '建议反馈',
        x: 0.891,
        y: 0.304,
        w: 0.085,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }, {
        id: 'merchant-menu-service',
        text: '商家服务账单',
        x: 0.891,
        y: 0.346,
        w: 0.085,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }, {
        id: 'merchant-menu-support',
        text: '联系售后',
        x: 0.891,
        y: 0.388,
        w: 0.085,
        h: 0.026,
        fontSize: 13,
        justifyContent: 'flex-start'
      }],
      hotspots: [{
        id: 'logout',
        x: 0.883,
        y: 0.046,
        w: 0.105,
        h: 0.04,
        highlight: 'primary',
        next: 'logout-login'
      }]
    }, {
      id: 'logout-login',
      image: SCENE_IMAGES.login,
      aspectRatio: 2,
      tip: LOGOUT_TIP,
      afterEnter: {
        delay: 2000,
        finish: true
      }
    }, {
      id: 'home-after-aftersale-return',
      image: SCENE_IMAGES.home,
      aspectRatio: 2,
      afterEnter: {
        setForm: {
          aftersaleOrderCode: ''
        }
      },
      tip: AFTERSALE_FAST_QUERY_TIP,
      hotspots: [{
        id: 'open-menu-after-aftersale-return',
        x: 0,
        y: 0.06,
        w: 0.03,
        h: 0.06,
        highlight: 'primary',
        next: 'home-menu-aftersale-fast'
      }]
    }, {
      id: 'home-menu-aftersale-return',
      image: SCENE_IMAGES.homeMenu,
      aspectRatio: 2,
      tip: AFTERSALE_RETURN_QUERY_TIP,
      hotspots: [{
        id: 'enter-aftersale-return',
        x: 0.294,
        y: 0.059,
        w: 0.11,
        h: 0.028,
        highlight: 'primary',
        next: 'aftersale-return'
      }, {
        id: 'common-aftersale-return',
        x: 0.04,
        y: 0.094,
        w: 0.10,
        h: 0.03,
        highlight: 'primary',
        next: 'aftersale-return'
      }]
    }, {
      id: 'aftersale-return',
      image: SCENE_IMAGES.aftersaleResult,
      aspectRatio: 2,
      tip: AFTERSALE_RETURN_QUERY_TIP,
      fields: [{
        id: 'aftersale-return-order-code',
        model: 'aftersaleOrderCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '线上订单号',
        x: 0.055,
        y: 0.165,
        w: 0.06,
        h: 0.02,
        onEnter: function onEnter(_ref4) {
          var form = _ref4.form,
            go = _ref4.go,
            setUi = _ref4.setUi;
          if (String(form.aftersaleOrderCode || '').trim() === TARGET_AFTERSALE_ORDER_CODE) {
            setUi({
              'fourth-aftersale-return-tableSelectedKeys': [],
              'fourth-aftersale-return-tableSelectedRows': []
            });
            go('aftersale-return-done');
            return;
          }
          return {
            ok: false,
            msg: '请输入正确的订单号 ' + TARGET_AFTERSALE_ORDER_CODE
          };
        }
      }],
      tables: function tables(context) {
        return buildAftersaleReturnTables(context);
      }
    }, {
      id: 'aftersale-return-done',
      image: SCENE_IMAGES.aftersaleResult,
      aspectRatio: 2,
      fields: [{
        id: 'aftersale-return-order-code-result',
        model: 'aftersaleOrderCode',
        type: 'text',
        bgColor: '#fff',
        fontSize: 10,
        placeholder: '线上订单号',
        x: 0.055,
        y: 0.165,
        w: 0.06,
        h: 0.02
      }],
      tables: function tables(context) {
        return buildAftersaleReturnTables(context, AFTERSALE_RETURN_ROWS.filter(function (row) {
          return row.onlineOrderNo === TARGET_AFTERSALE_ORDER_CODE;
        }));
      },
      tip: AFTERSALE_RETURN_QUERY_TIP,
      afterEnter: {
        delay: 2000,
        go: 'home-after-aftersale-return'
      }
    }]
  };
}

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jst-erp-scene" },
    [
      _c("StepPlayer", {
        ref: "player",
        attrs: {
          steps: _vm.scenario.steps,
          "initial-step-id": _vm.scenario.initialStepId,
          "initial-form": _vm.scenario.initialForm,
          "show-tip": false
        },
        on: {
          "step-change": _vm.onStepChange,
          "guard-failed": _vm.onGuardFailed,
          finish: _vm.onFinish
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ff6ff64", esExports)
  }
}

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpPlaceholderScene_vue__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpPlaceholderScene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpPlaceholderScene_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpPlaceholderScene_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpPlaceholderScene_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a418f7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpPlaceholderScene_vue__ = __webpack_require__(1381);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1379)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57a418f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JstErpPlaceholderScene_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a418f7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JstErpPlaceholderScene_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/jushuitan/JstErpPlaceholderScene.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-57a418f7", Component.options)
  } else {
    hotAPI.reload("data-v-57a418f7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1380);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1bde9353", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-57a418f7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpPlaceholderScene.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-57a418f7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JstErpPlaceholderScene.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.placeholder-scene[data-v-57a418f7] { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 520px; color: #a0a8b8; background: #fff;\n}\n.placeholder-scene i[data-v-57a418f7] { margin-bottom: 14px; font-size: 42px; color: #bfd0ed;\n}\n.placeholder-scene p[data-v-57a418f7] { margin: 0; font-size: 15px;\n}\n", ""]);

// exports


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "placeholder-scene" }, [
      _c("i", { staticClass: "el-icon-document" }),
      _vm._v(" "),
      _c("p", [_vm._v("该章节内容待配置")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57a418f7", esExports)
  }
}

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "jushuitanStudy" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        _vm._l(_vm.chapters, function(chapter) {
          return _c(
            "el-tab-pane",
            { key: chapter.key, attrs: { name: chapter.key } },
            [
              _c(
                "div",
                {
                  staticClass: "tab-slot",
                  attrs: { slot: "label" },
                  slot: "label"
                },
                [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(chapter.title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hover-con" }, [
                    _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                    _vm._v(" "),
                    _c("p", [_vm._v("点击学习")])
                  ])
                ]
              ),
              _vm._v(" "),
              chapter.key === "first" && _vm.state.videoGateVisible
                ? _c("div", { staticClass: "startvideo" }, [
                    _c("div", { staticClass: "tip" }, [
                      _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "startstudy",
                            on: { click: _vm.startVideo }
                          },
                          [_vm._v("开始学习")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.state.practiceVisible,
                      expression: "!state.practiceVisible"
                    }
                  ],
                  staticClass: "video-box"
                },
                [
                  _c(
                    "video",
                    {
                      ref: "video-" + chapter.key,
                      refInFor: true,
                      staticClass: "video",
                      attrs: { src: chapter.videoUrl, controls: "controls" },
                      on: {
                        play: _vm.onVideoPlay,
                        ended: function($event) {
                          return _vm.onVideoEnded(chapter.key)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          您的浏览器不支持 video 标签。\n        "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.state.videoCompleted && !_vm.state.practiceVisible
                ? _c("div", { staticClass: "stoptip" }, [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "restart",
                            on: { click: _vm.restartVideo }
                          },
                          [
                            _c("i", { staticClass: "el-icon-refresh-left" }),
                            _vm._v("重播")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "startstudy",
                            on: { click: _vm.startStudy }
                          },
                          [_vm._v("开始实操练习")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.state.practiceVisible,
                      expression: "state.practiceVisible"
                    }
                  ],
                  staticClass: "content"
                },
                [
                  _c(
                    "div",
                    { staticClass: "con-left" },
                    [
                      chapter.key === "first"
                        ? _c("JstErpLoginScene", {
                            ref: "scene-" + chapter.key,
                            refInFor: true,
                            on: {
                              "step-change": _vm.onStepChange,
                              "guard-failed": _vm.onGuardFailed,
                              finish: _vm.onFinish
                            }
                          })
                        : chapter.key === "second"
                        ? _c("JstErpSecondScene", {
                            ref: "scene-" + chapter.key,
                            refInFor: true,
                            on: {
                              "step-change": _vm.onStepChange,
                              "guard-failed": _vm.onGuardFailed,
                              finish: _vm.onFinish
                            }
                          })
                        : chapter.key === "third"
                        ? _c("JstErpCreateAftersaleScene", {
                            ref: "scene-" + chapter.key,
                            refInFor: true,
                            on: {
                              "step-change": _vm.onStepChange,
                              "guard-failed": _vm.onGuardFailed,
                              finish: _vm.onFinish
                            }
                          })
                        : chapter.key === "four"
                        ? _c("JstErpOrderQueryScene", {
                            ref: "scene-" + chapter.key,
                            refInFor: true,
                            on: {
                              "step-change": _vm.onStepChange,
                              "guard-failed": _vm.onGuardFailed,
                              finish: _vm.onFinish
                            }
                          })
                        : _c("JstErpPlaceholderScene")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("aside", { staticClass: "con-right" }, [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v("提示")
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      class: {
                        "compact-tip":
                          _vm.tabCurrent === "third" &&
                          _vm.rightTipStep === "create-wrong-exchange"
                      },
                      domProps: { innerHTML: _vm._s(_vm.rightTip) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.state.practiceCompleted
                ? _c("div", { staticClass: "stoptip practice-finish" }, [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.isLastChapter
                              ? "聚水潭实操完成"
                              : "实操通关，进入下一关吧"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "restart",
                            on: { click: _vm.restartStudy }
                          },
                          [
                            _c("i", { staticClass: "el-icon-refresh-left" }),
                            _vm._v("重练")
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isLastChapter
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.studyNext }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "study-box" },
                [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("查看学习资料")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 20 } }, [
                        _c("img", {
                          staticClass: "img-box",
                          attrs: {
                            src: __webpack_require__(10)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-box" }, [
                          _c("p", [_vm._v(_vm._s(chapter.pptTitle))]),
                          _vm._v(" "),
                          _c("p", [
                            _vm.isOpenPpt[chapter.key]
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn-open",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewPpt(chapter.key, false)
                                      }
                                    }
                                  },
                                  [_vm._v("点击收起")]
                                )
                              : _c(
                                  "a",
                                  {
                                    staticClass: "btn-open",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewPpt(chapter.key)
                                      }
                                    }
                                  },
                                  [_vm._v("点击展开")]
                                )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _vm.state.videoCompleted && !_vm.state.practiceVisible
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "pull-right startbtn",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.startStudy }
                                },
                                [_vm._v("开始练习")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { id: chapter.pdfViewerId } })
                ],
                1
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60605782", esExports)
  }
}

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpExam_vue__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c242c1ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_juShuiTanErpExam_vue__ = __webpack_require__(1386);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1384)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c242c1ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_juShuiTanErpExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c242c1ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_juShuiTanErpExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/juShuiTanErpExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c242c1ce", Component.options)
  } else {
    hotAPI.reload("data-v-c242c1ce", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1385);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0357f378", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c242c1ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./juShuiTanErpExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c242c1ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./juShuiTanErpExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#jushuitanExam[data-v-c242c1ce] {\n  box-sizing: border-box;\n  min-height: 100vh;\n  padding: 10px;\n  color: #454545;\n  background: #f1f5f8;\n}\n.exam-layout[data-v-c242c1ce] {\n  display: flex;\n  min-height: calc(80vh);\n}\n.chapter-nav[data-v-c242c1ce] {\n  flex: 0 0 180px;\n  margin-right: 10px;\n  background: #fff;\n}\n.chapter-item[data-v-c242c1ce] {\n  box-sizing: border-box;\n  min-height: 54px;\n  padding: 10px;\n  color: #454545;\n  cursor: default;\n}\n.chapter-item p[data-v-c242c1ce] {\n  margin: 0;\n  line-height: 34px;\n  text-align: left;\n}\n.chapter-item.active[data-v-c242c1ce] {\n  color: #fff;\n  background: #4c75f1;\n}\n.exam-main[data-v-c242c1ce] {\n  position: relative;\n  flex: 1 1 auto;\n  min-width: 0;\n  background: #fff;\n}\n.content[data-v-c242c1ce] {\n  display: flex;\n  min-height: calc(80vh);\n  color: #2b2b2b;\n  background: #f1f5f8;\n}\n.con-left[data-v-c242c1ce] {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: auto;\n  background: #fff;\n}\n.con-right[data-v-c242c1ce] {\n  flex: 0 0 170px;\n  box-sizing: border-box;\n  min-width: 0;\n  min-height: calc(80vh);\n  padding: 10px;\n  margin-left: 10px;\n  overflow: auto;\n  font-size: 14px;\n  line-height: 26px;\n  overflow-wrap: anywhere;\n  word-break: break-all;\n  background: #fff;\n}\n.con-right .compact-tip[data-v-c242c1ce] {\n  font-size: 12px;\n  line-height: 20px;\n}\n.con-right h3[data-v-c242c1ce] {\n  margin: 0 0 12px;\n  font-size: 16px;\n}\n.con-right p[data-v-c242c1ce] {\n  margin: 0 0 8px;\n}\n.con-right[data-v-c242c1ce] * {\n  box-sizing: border-box;\n  max-width: 100%;\n}\n.line[data-v-c242c1ce] {\n  display: inline-block;\n  width: 4px;\n  height: 20px;\n  margin-right: 2px;\n  vertical-align: text-bottom;\n  background: #4c75f1;\n}\n.stoptip[data-v-c242c1ce] {\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #2b2b2b;\n  text-align: center;\n  background: rgba(127, 127, 127, 0.5);\n}\n.tip[data-v-c242c1ce] {\n  box-sizing: border-box;\n  width: 360px;\n  min-height: 220px;\n  padding: 48px 26px;\n  font-size: 16px;\n  font-weight: bold;\n  background: #fff;\n  border-radius: 5px;\n}\n.tip > p[data-v-c242c1ce] {\n  margin: 15px 0;\n}\n.tip > .el-icon-success[data-v-c242c1ce] {\n  color: #3fde3f;\n  font-size: 40px;\n}\n.startstudy[data-v-c242c1ce],\n.restart[data-v-c242c1ce] {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 130px;\n  height: 38px;\n  color: #fff;\n  line-height: 36px;\n  background: #4c75f1;\n  border: 1px solid #4c75f1;\n  cursor: pointer;\n}\n.restart[data-v-c242c1ce] {\n  margin-right: 5px;\n  color: #4c75f1;\n  background: #fff;\n}\n.restart .el-icon-refresh-left[data-v-c242c1ce] {\n  padding-right: 5px;\n  font-size: 20px;\n  vertical-align: -2px;\n}\n@media (max-width: 860px) {\n#jushuitanExam[data-v-c242c1ce] {\n    min-width: 760px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "jushuitanExam" } }, [
    _c("div", { staticClass: "exam-layout" }, [
      _c(
        "aside",
        { staticClass: "chapter-nav" },
        _vm._l(_vm.chapters, function(chapter) {
          return _c(
            "div",
            {
              key: chapter.key,
              class: [
                "chapter-item",
                { active: _vm.tabCurrent === chapter.key }
              ]
            },
            [_c("p", [_vm._v(_vm._s(chapter.title))])]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("main", { staticClass: "exam-main" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.state.practiceVisible,
                expression: "state.practiceVisible"
              }
            ],
            staticClass: "content"
          },
          [
            _c(
              "div",
              { staticClass: "con-left" },
              [
                _vm.tabCurrent === "first"
                  ? _c("JstErpLoginScene", {
                      ref: "scene-first",
                      on: {
                        "step-change": _vm.onStepChange,
                        "guard-failed": _vm.onGuardFailed,
                        finish: _vm.onFinish
                      }
                    })
                  : _vm.tabCurrent === "second"
                  ? _c("JstErpSecondScene", {
                      ref: "scene-second",
                      on: {
                        "step-change": _vm.onStepChange,
                        "guard-failed": _vm.onGuardFailed,
                        finish: _vm.onFinish
                      }
                    })
                  : _vm.tabCurrent === "third"
                  ? _c("JstErpCreateAftersaleScene", {
                      ref: "scene-third",
                      on: {
                        "step-change": _vm.onStepChange,
                        "guard-failed": _vm.onGuardFailed,
                        finish: _vm.onFinish
                      }
                    })
                  : _c("JstErpOrderQueryScene", {
                      ref: "scene-four",
                      on: {
                        "step-change": _vm.onStepChange,
                        "guard-failed": _vm.onGuardFailed,
                        finish: _vm.onFinish
                      }
                    })
              ],
              1
            ),
            _vm._v(" "),
            _c("aside", { staticClass: "con-right" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", {
                class: {
                  "compact-tip":
                    _vm.tabCurrent === "third" &&
                    _vm.rightTipStep === "create-wrong-exchange"
                },
                domProps: { innerHTML: _vm._s(_vm.rightTip) }
              })
            ])
          ]
        ),
        _vm._v(" "),
        !_vm.state.practiceVisible || _vm.state.practiceCompleted
          ? _c("div", { staticClass: "stoptip" }, [
              _c("div", { staticClass: "tip" }, [
                _vm.state.practiceCompleted
                  ? _c("span", { staticClass: "el-icon-success" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.state.practiceCompleted
                  ? _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.isLastChapter
                            ? "聚水潭实操完成"
                            : "实操通关，进入下一关吧"
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.state.practiceVisible
                  ? _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始实操练习")]
                      )
                    ])
                  : _vm.isLastChapter
                  ? _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重练")
                        ]
                      )
                    ])
                  : _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重练")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.studyNext }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c242c1ce", esExports)
  }
}

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiu_vue__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04eda40e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newQianNiu_vue__ = __webpack_require__(1393);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1388)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04eda40e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04eda40e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newQianNiu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/newQianNiu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-04eda40e", Component.options)
  } else {
    hotAPI.reload("data-v-04eda40e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1389);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5d033b46", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04eda40e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./newQianNiu.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04eda40e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./newQianNiu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-04eda40e] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-04eda40e] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n[data-v-04eda40e] .el-tabs__content {\n  height: 100% !important;\n}\n.con-left[data-v-04eda40e] {\n  background: none !important;\n  flex: 1 1 auto;\n  min-width: 1;\n}\n.con-right[data-v-04eda40e] {\n  width: 170px;\n  flex: 0 0 170px;\n}\n.stoptip[data-v-04eda40e] {\n  width: 100% !important;\n  height: 100% !important;\n}\n.video-box[data-v-04eda40e] {\n  width: 100% !important;\n}\n", ""]);

// exports


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScenarioConfig = getScenarioConfig;
/**
 * 千牛 8 关配置驱动场景
 * 每关: { steps, initialStepId, initialForm }
 * 步骤: id, image, tip, hotspots[], fields[], isEnd, afterEnter?: { delay, go }, onEnter?
 */
function r(path) {
  return __webpack_require__(1391)("./" + path);
}
function getScenarioConfig() {
  return {
    first: {
      initialStepId: 'desktop',
      initialForm: {
        name: '',
        password: '',
        rnd: ''
      },
      steps: [{
        id: 'desktop',
        image: function image(_ref) {
          var ui = _ref.ui;
          return ui.qnHover ? r('qnbg2.png') : r('qnbg1.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">左侧练习场</span>中的千牛图标进行登录',
        hotspots: [{
          id: 'qnIcon',
          x: 0.20,
          y: 0.24,
          w: 0.04,
          h: 0.08,
          hoverSet: {
            qnHover: true
          },
          hoverUnset: {
            qnHover: false
          },
          next: 'desktop2'
        }]
      }, {
        id: 'desktop2',
        image: function image() {
          return r('qnbg2.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">左侧练习场</span>中的千牛图标进行登录',
        hotspots: [{
          id: 'qnDbl',
          on: 'dblclick',
          x: 0.20,
          y: 0.24,
          w: 0.04,
          h: 0.08,
          next: 'login'
        }]
      }, {
        id: 'login',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.78,
        image: function image(_ref2) {
          var ui = _ref2.ui;
          if (ui.saveChecked) return r('login3.png');
          if (ui.saveHover) return r('login2.png');
          return r('login1.png');
        },
        tip: '1.复制粘贴账号和密码<br>2.勾选记住密码',
        fields: [{
          id: 'name',
          model: 'name',
          type: 'text',
          bgColor: '#F6F7F9',
          placeholder: '请输入账号',
          x: 0.54,
          y: 0.44,
          w: 0.23,
          h: 0.05
        }, {
          id: 'pwd',
          model: 'password',
          type: 'password',
          bgColor: '#F6F7F9',
          placeholder: '请输入密码',
          autocomplete: 'new-password',
          x: 0.54,
          y: 0.54,
          w: 0.23,
          h: 0.05
        }],
        hotspots: [{
          id: 'save',
          x: 0.51,
          y: 0.80,
          w: 0.09,
          h: 0.03,
          hoverSet: {
            saveHover: true
          },
          hoverUnset: {
            saveHover: false
          },
          set: {
            saveChecked: true
          }
        }, {
          id: 'loginBtn',
          x: 0.51,
          y: 0.71,
          w: 0.30,
          h: 0.08,
          guard: function guard(_ref3) {
            var form = _ref3.form;
            if (!form.name) return {
              ok: false,
              msg: '请输入账号'
            };
            if (form.name !== '淘金云客服:小淘') return {
              ok: false,
              msg: '用户名或密码错误，请注意大小写或特殊符号'
            };
            if (!form.password) return {
              ok: false,
              msg: '请输入密码'
            };
            if (form.password !== 'Tj1234') return {
              ok: false,
              msg: '用户名或密码错误，请注意大小写或特殊符号'
            };
            return {
              ok: true
            };
          },
          next: 'rnd'
        }]
      }, {
        id: 'rnd',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.78,
        image: function image(_ref4) {
          var ui = _ref4.ui;
          if (ui.rndShown) return r('loginrnd3.png');
          if (ui.rndHover) return r('loginrnd2.png');
          return r('loginrnd1.png');
        },
        tip: function tip(_ref5) {
          var ui = _ref5.ui;
          return ui.rndShown ? '短信校验码：<br><span style="color: red;font-weight:bold;">660220</span>' : '<span style="color: red;font-weight:bold;">获取短信校验码</span>';
        },
        fields: [{
          id: 'rnd',
          model: 'rnd',
          type: 'text',
          bgColor: '#FFFFFF',
          placeholder: '短信校验码',
          x: 0.595,
          y: 0.35,
          w: 0.09,
          h: 0.05
        }],
        hotspots: [{
          id: 'sendRnd',
          x: 0.68,
          y: 0.355,
          w: 0.10,
          h: 0.05,
          hoverSet: {
            rndHover: true
          },
          hoverUnset: {
            rndHover: false
          },
          set: {
            rndShown: true
          }
        }, {
          id: 'loginRndBtn',
          x: 0.53,
          y: 0.86,
          w: 0.25,
          h: 0.07,
          guard: function guard(_ref6) {
            var form = _ref6.form;
            if (!form.rnd) return {
              ok: false,
              msg: '请输入短信校验'
            };
            if (form.rnd !== '660220') return {
              ok: false,
              msg: '短信校验错误'
            };
            return {
              ok: true
            };
          },
          next: 'loginIndex'
        }]
      }, {
        id: 'loginIndex',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref7) {
          var ui = _ref7.ui;
          return ui.jdHover ? r('loginindex1.png') : r('loginindex2.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">接待中心</span>',
        hotspots: [{
          id: 'enterJd',
          x: 0.94,
          y: 0.07,
          w: 0.02,
          h: 0.04,
          hoverSet: {
            jdHover: true
          },
          hoverUnset: {
            jdHover: false
          },
          next: 'done'
        }]
      }, {
        id: 'done',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('loginindex3.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">接待中心</span>',
        isEnd: true
      }]
    },
    second: {
      initialStepId: 's2_1',
      initialForm: {},
      steps: [{
        id: 's2_1',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('qnstatus1.png');
        },
        tip: '请将状态切换为“<span style="color: red;font-weight:bold;">在线</span>”状态',
        hotspots: [{
          id: 'a',
          x: 0.09,
          y: 0.08,
          w: 0.05,
          h: 0.04,
          next: 's2_2'
        }]
      }, {
        id: 's2_2',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref8) {
          var ui = _ref8.ui;
          return ui.hover ? r('qnstatus3.png') : r('qnstatus2.png');
        },
        tip: '请将状态切换为“<span style="color: red;font-weight:bold;">在线</span>”状态',
        hotspots: [{
          id: 'b',
          x: 0.09,
          y: 0.12,
          w: 0.21,
          h: 0.05,
          hoverSet: {
            hover: true
          },
          hoverUnset: {
            hover: false
          },
          next: 's2_3'
        }]
      }, {
        id: 's2_3',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('qnstatus4.png');
        },
        tip: '请将状态切换为“<span style="color: red;font-weight:bold;">挂起</span>”状态',
        hotspots: [{
          id: 'c1',
          x: 0.09,
          y: 0.08,
          w: 0.05,
          h: 0.04,
          next: 's2_3b'
        }]
      }, {
        id: 's2_3b',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref9) {
          var ui = _ref9.ui;
          return ui.s2_3bhover ? r('qnstatus6.png') : r('qnstatus5.png');
        },
        tip: '请将状态切换为“<span style="color: red;font-weight:bold;">挂起</span>”状态',
        hotspots: [{
          id: 'c2',
          x: 0.09,
          y: 0.17,
          w: 0.21,
          h: 0.05,
          hoverSet: {
            s2_3bhover: true
          },
          hoverUnset: {
            s2_3bhover: false
          },
          next: 's2_3c'
        }]
      }, {
        id: 's2_3c',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('qnstatus7.png');
        },
        tip: '请将状态切换为“<span style="color: red;font-weight:bold;">挂起</span>”状态',
        hotspots: [{
          id: 'c3',
          x: 0.54,
          y: 0.54,
          w: 0.05,
          h: 0.05,
          next: 's2_4'
        }]
      }, {
        id: 's2_4',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('qnstatus1.png');
        },
        tip: '请将接待排序设置为：<span style="color: red;font-weight:bold;">按客户等待时长排序</span>',
        hotspots: [{
          id: 'd',
          x: 0.17,
          y: 0.30,
          w: 0.07,
          h: 0.02,
          next: 's2_4b'
        }]
      }, {
        id: 's2_4b',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref0) {
          var ui = _ref0.ui;
          return ui.s2_4bhover ? r('qnsort2.png') : r('qnsort1.png');
        },
        tip: '请将接待排序设置为：<span style="color: red;font-weight:bold;">按客户等待时长排序</span>',
        hotspots: [{
          id: 'e',
          x: 0.18,
          y: 0.385,
          w: 0.12,
          h: 0.04,
          hoverSet: {
            s2_4bhover: true
          },
          hoverUnset: {
            s2_4bhover: false
          },
          next: 's2_4c'
        }]
      }, {
        id: 's2_4c',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref1) {
          var ui = _ref1.ui;
          return ui.s2_4cHover ? r('qnset1.png') : r('qnsort3.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">系统设置</span>中的<span style="color: red;font-weight:bold;">消息接收与提醒</span>，核对<span style="color: red;font-weight:bold;">店铺分流</span>和<span style="color: red;font-weight:bold;">账号分流</span>是否开启',
        hotspots: [{
          id: 'f',
          x: 0.84,
          y: 0.01,
          w: 0.03,
          h: 0.03,
          hoverSet: {
            s2_4cHover: true
          },
          hoverUnset: {
            s2_4cHover: false
          },
          next: 's2_4d'
        }]
      }, {
        id: 's2_4d',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref10) {
          var ui = _ref10.ui;
          return ui.s2_4dHover ? r('qnset3.png') : r('qnset2.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">系统设置</span>中的<span style="color: red;font-weight:bold;">消息接收与提醒</span>，核对<span style="color: red;font-weight:bold;">店铺分流</span>和<span style="color: red;font-weight:bold;">账号分流</span>是否开启',
        hotspots: [{
          id: 'g',
          x: 0.85,
          y: 0.10,
          w: 0.08,
          h: 0.03,
          hoverSet: {
            s2_4dHover: true
          },
          hoverUnset: {
            s2_4dHover: false
          },
          next: 's2_4e'
        }]
      }, {
        id: 's2_4e',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref11) {
          var ui = _ref11.ui;
          return ui.s2_4eHover ? r('qnset5.png') : r('qnset4.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">系统设置</span>中的<span style="color: red;font-weight:bold;">消息接收与提醒</span>，核对<span style="color: red;font-weight:bold;">店铺分流</span>和<span style="color: red;font-weight:bold;">账号分流</span>是否开启',
        hotspots: [{
          id: 'h',
          x: 0.09,
          y: 0.54,
          w: 0.07,
          h: 0.03,
          hoverSet: {
            s2_4eHover: true
          },
          hoverUnset: {
            s2_4eHover: false
          },
          next: 's2_done'
        }]
      }, {
        id: 's2_done',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('qnset6.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">系统设置</span>中的<span style="color: red;font-weight:bold;">消息接收与提醒</span>，核对<span style="color: red;font-weight:bold;">店铺分流</span>和<span style="color: red;font-weight:bold;">账号分流</span>是否开启',
        isEnd: true
      }]
    },
    third: {
      initialStepId: 's3_1',
      initialForm: {
        search: '',
        kjdybm: '',
        kjdynr: '',
        kjdyfz: '',
        kjdyfs: ''
      },
      steps: [{
        id: 's3_1',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy1.png');
        },
        tip: '请搜索登录账号<br><span style="color: red;font-weight:bold;">淘金云客服:小淘</span>',
        fields: [{
          id: 'search',
          model: 'search',
          bgColor: '#FFFFFF',
          fontSize: 12,
          type: 'text',
          placeholder: '联系人,订单号，聊天记录',
          x: 0.11,
          y: 0.135,
          w: 0.12,
          h: 0.04,
          onInput: function onInput(_ref12) {
            var value = _ref12.value,
              go = _ref12.go;
            if (value === '淘金云客服:小淘') setTimeout(function () {
              return go('s3_2');
            }, 500);
          }
        }],
        hotspots: []
      }, {
        id: 's3_2',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy2.png');
        },
        tip: '请搜索登录账号<br><span style="color: red;font-weight:bold;">淘金云客服:小淘</span>',
        hotspots: [{
          id: 'a',
          x: 0.1,
          y: 0.22,
          w: 0.2,
          h: 0.06,
          next: 's3_3'
        }]
      }, {
        id: 's3_3',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref13) {
          var ui = _ref13.ui;
          return ui.s3_3hover ? r('kjdy4.png') : r('kjdy3.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">打开快捷短语</span>',
        hotspots: [{
          id: 'b',
          x: 0.58,
          y: 0.67,
          w: 0.03,
          h: 0.03,
          hoverSet: {
            s3_3hover: true
          },
          hoverUnset: {
            s3_3hover: false
          },
          next: 's3_4'
        }]
      }, {
        id: 's3_4',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy5.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
        hotspots: [{
          id: 'c',
          x: 0.83,
          y: 0.28,
          w: 0.03,
          h: 0.03,
          next: 's3_5'
        }]
      }, {
        id: 's3_5',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy6.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
        fields: [{
          id: 'bm',
          model: 'kjdybm',
          bgColor: '#F6F8FA',
          fontSize: 12,
          type: 'text',
          placeholder: '快捷编码',
          x: 0.38,
          y: 0.535,
          w: 0.25,
          h: 0.035
        }, {
          id: 'nr',
          model: 'kjdynr',
          bgColor: '#F6F8FA',
          fontSize: 12,
          type: 'textarea',
          placeholder: '请输入快捷短语',
          x: 0.34,
          y: 0.35,
          w: 0.22,
          h: 0.12
        }],
        hotspots: [{
          id: 'd',
          x: 0.38,
          y: 0.59,
          w: 0.27,
          h: 0.035,
          next: 's3_6'
        }]
      }, {
        id: 's3_6',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref14) {
          var ui = _ref14.ui;
          return ui.s3_6hover ? r('kjdy8.png') : r('kjdy7.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
        fields: [
        // 展示上一屏已输入的快捷编码与短语（可继续编辑）
        {
          id: 'bm_preview',
          model: 'kjdybm',
          bgColor: '#F6F8FA',
          fontSize: 12,
          type: 'text',
          placeholder: '快捷编码',
          x: 0.38,
          y: 0.535,
          w: 0.25,
          h: 0.035
        }, {
          id: 'nr_preview',
          model: 'kjdynr',
          bgColor: '#F6F8FA',
          fontSize: 12,
          type: 'textarea',
          placeholder: '请输入快捷短语',
          x: 0.34,
          y: 0.35,
          w: 0.22,
          h: 0.12
        }],
        hotspots: [{
          id: 'e',
          x: 0.39,
          y: 0.63,
          w: 0.26,
          h: 0.05,
          hoverSet: {
            s3_6hover: true
          },
          hoverUnset: {
            s3_6hover: false
          },
          next: 's3_7'
        }]
      }, {
        id: 's3_7',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref15) {
          var ui = _ref15.ui;
          return ui.hover ? r('kjdy10.png') : r('kjdy9.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
        fields: [{
          id: 'fz2',
          model: 'kjdyfz',
          type: 'text',
          fontSize: 12,
          placeholder: '请输入分组',
          x: 0.41,
          y: 0.48,
          w: 0.22,
          h: 0.025
        }],
        hotspots: [{
          id: 'f',
          x: 0.54,
          y: 0.54,
          w: 0.05,
          h: 0.05,
          guard: function guard(_ref16) {
            var form = _ref16.form;
            return form.kjdyfz === '开头语' ? {
              ok: true
            } : {
              ok: false,
              msg: '分组名称应为: 开头语'
            };
          },
          next: 's3_8'
        }]
      }, {
        id: 's3_8',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy11.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。<br>短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span><br> 编码：<span style="color: red;font-weight:bold;">欢迎</span><br>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）',
        fields: [
        // 展示上一屏已输入的快捷编码与短语（可继续编辑）
        {
          id: 'bm_preview2',
          model: 'kjdybm',
          bgColor: '#F6F8FA',
          fontSize: 12,
          type: 'text',
          placeholder: '快捷编码',
          x: 0.38,
          y: 0.535,
          w: 0.25,
          h: 0.035
        }, {
          id: 'nr_preview2',
          model: 'kjdynr',
          bgColor: '#F6F8FA',
          fontSize: 12,
          type: 'textarea',
          placeholder: '请输入快捷短语',
          x: 0.34,
          y: 0.35,
          w: 0.22,
          h: 0.12
        }],
        hotspots: [{
          id: 'g',
          x: 0.56,
          y: 0.64,
          w: 0.05,
          h: 0.05,
          guard: function guard(_ref17) {
            var form = _ref17.form;
            if (form.kjdynr !== '亲，欢迎光临，请问有什么可以帮您的？') return {
              ok: false,
              msg: '请输入正确的快捷短语内容！'
            };
            if (form.kjdybm !== '欢迎') return {
              ok: false,
              msg: '请输入正确的编码'
            };
            return {
              ok: true
            };
          },
          next: 's3_9'
        }]
      }, {
        id: 's3_9',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy12.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
        hotspots: [{
          id: 'h',
          x: 0.86,
          y: 0.28,
          w: 0.03,
          h: 0.03,
          next: 's3_10'
        }]
      }, {
        id: 's3_10',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy13.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
        hotspots: [{
          id: 'file',
          x: 0.50,
          y: 0.56,
          w: 0.03,
          h: 0.04,
          emit: 'request-file'
        }]
      }, {
        id: 's3_11',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy14.png');
        },
        tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
        hotspots: [{
          id: 'i',
          x: 0.63,
          y: 0.55,
          w: 0.04,
          h: 0.04,
          next: 's3_12'
        }]
      }, {
        id: 's3_12',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref18) {
          var ui = _ref18.ui;
          return ui.s3_12hover ? r('kjdy16.png') : r('kjdy15.png');
        },
        tip: '请采用<span style="color: red;font-weight:bold;">鼠标左键</span>点击快捷短语的方式，选择并<span style="color: red;font-weight:bold;">发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
        hotspots: [{
          id: 'j',
          x: 0.70,
          y: 0.39,
          w: 0.24,
          h: 0.03,
          hoverSet: {
            s3_12hover: true
          },
          hoverUnset: {
            s3_12hover: false
          },
          next: 's3_13'
        }]
      }, {
        id: 's3_13',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy17.png');
        },
        tip: '请采用<span style="color: red;font-weight:bold;">鼠标左键</span>点击快捷短语的方式，选择并<span style="color: red;font-weight:bold;">发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
        fields: [{
          id: 'enter',
          model: 's3_13_enter',
          type: 'text',
          placeholder: '',
          autoFocus: true,
          x: 0,
          y: 0,
          w: 1,
          h: 0.94,
          onEnter: function onEnter(_ref19) {
            var go = _ref19.go;
            go('s3_14');
          }
        }],
        // 输入框本身覆盖了热点区域，保留 hotspot 作为兼容点击
        hotspots: [{
          id: 'k',
          x: 0.56,
          y: 0.95,
          w: 0.05,
          h: 0.04,
          next: 's3_14'
        }]
      }, {
        id: 's3_14',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy18.png');
        },
        tip: '请采用 <span style="color: red;font-weight:bold;">/+快捷编码</span>点击快捷短语的方式，选择<span style="color: red;font-weight:bold;">并发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
        fields: [{
          id: 'fs',
          model: 'kjdyfs',
          type: 'textarea',
          placeholder: '',
          x: 0.26,
          y: 0.71,
          w: 0.35,
          h: 0.1,
          onInput: function onInput(_ref20) {
            var value = _ref20.value,
              go = _ref20.go;
            if (value === '/欢迎') go('s3_15');
          }
        }],
        hotspots: []
      }, {
        id: 's3_15',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy19.png');
        },
        tip: '请采用 <span style="color: red;font-weight:bold;">/+快捷编码</span>点击快捷短语的方式，选择<span style="color: red;font-weight:bold;">并发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
        fields: [{
          id: 'enter',
          model: 's3_15_enter',
          type: 'text',
          placeholder: '',
          autoFocus: true,
          x: 0,
          y: 0.38,
          w: 1,
          h: 0.56,
          onEnter: function onEnter(_ref21) {
            var go = _ref21.go;
            go('s3_16');
          }
        }],
        hotspots: [{
          id: 'm',
          x: 0.29,
          y: 0.33,
          w: 0.43,
          h: 0.04,
          next: 's3_16'
        }]
      }, {
        id: 's3_16',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy20.png');
        },
        tip: '请采用 <span style="color: red;font-weight:bold;">/+快捷编码</span>点击快捷短语的方式，选择<span style="color: red;font-weight:bold;">并发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
        fields: [{
          id: 'enter',
          model: 's3_16_enter',
          type: 'text',
          placeholder: '',
          autoFocus: true,
          x: 0,
          y: 0,
          w: 1,
          h: 0.94,
          onEnter: function onEnter(_ref22) {
            var go = _ref22.go;
            go('s3_done');
          }
        }],
        // 输入框本身覆盖了热点区域，保留 hotspot 作为兼容点击
        hotspots: [{
          id: 'n',
          x: 0.56,
          y: 0.95,
          w: 0.05,
          h: 0.04,
          next: 's3_done'
        }]
      }, {
        id: 's3_done',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('kjdy21.png');
        },
        tip: '请采用 <span style="color: red;font-weight:bold;">/+快捷编码</span>点击快捷短语的方式，选择<span style="color: red;font-weight:bold;">并发送</span>快捷短语：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span>',
        isEnd: true
      }]
    },
    four: {
      initialStepId: 's4_1',
      initialForm: {
        zjyy: ''
      },
      steps: [{
        id: 's4_1',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('cygn1.png');
        },
        tip: '请给当前用户标记<span style="color: red;font-weight:bold;">黄色星星</span>',
        hotspots: [{
          id: 'a',
          on: 'mouseenter',
          x: 0.23,
          y: 0.36,
          w: 0.02,
          h: 0.03,
          next: 's4_2'
        }]
      }, {
        id: 's4_2',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref23) {
          var ui = _ref23.ui;
          return ui.s4_2hover ? r('cygn3.png') : r('cygn2.png');
        },
        tip: '请给当前用户标记<span style="color: red;font-weight:bold;">黄色星星</span>',
        hotspots: [{
          id: 'b',
          x: 0.2,
          y: 0.2,
          w: 0.3,
          h: 0.15,
          hoverSet: {
            s4_2hover: true
          },
          hoverUnset: {
            s4_2hover: false
          },
          next: 's4_3'
        }]
      }, {
        id: 's4_3',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('cygn4.png');
        },
        tip: '请给当前用户标记<span style="color: red;font-weight:bold;">黄色星星</span>',
        afterEnter: {
          delay: 2500,
          go: 's4_4'
        }
      }, {
        id: 's4_4',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref24) {
          var ui = _ref24.ui;
          return ui.s4_4hover ? r('cygn6.png') : r('cygn5.png');
        },
        tip: '请将当前用户<span style="color: red;font-weight:bold;">转发</span>给<span style="color: red;font-weight:bold;">小金</span>，转交原因填写<span style="color: red;font-weight:bold;">少件</span>',
        hotspots: [{
          id: 'c',
          x: 0.54,
          y: 0.14,
          w: 0.02,
          h: 0.03,
          hoverSet: {
            s4_4hover: true
          },
          hoverUnset: {
            s4_4hover: false
          },
          next: 's4_5'
        }]
      }, {
        id: 's4_5',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('cygn7.png');
        },
        tip: '请将当前用户<span style="color: red;font-weight:bold;">转发</span>给<span style="color: red;font-weight:bold;">小金</span>，转交原因填写<span style="color: red;font-weight:bold;">少件</span>',
        hotspots: [{
          id: 'd',
          x: 0.56,
          y: 0.34,
          w: 0.21,
          h: 0.04,
          next: 's4_6'
        }]
      }, {
        id: 's4_6',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('cygn8.png');
        },
        tip: '请将当前用户<span style="color: red;font-weight:bold;">转发</span>给<span style="color: red;font-weight:bold;">小金</span>，转交原因填写<span style="color: red;font-weight:bold;">少件</span>',
        fields: [{
          id: 'zjyy',
          model: 'zjyy',
          type: 'text',
          bgColor: '#F7F8FA',
          fontSize: 12,
          placeholder: '请输入转交原因',
          x: 0.80,
          y: 0.58,
          w: 0.09,
          h: 0.04
        }],
        hotspots: [{
          id: 'e',
          x: 0.89,
          y: 0.58,
          w: 0.03,
          h: 0.04,
          guard: function guard(_ref25) {
            var form = _ref25.form;
            return form.zjyy === '少件' ? {
              ok: true
            } : {
              ok: false,
              msg: '请输入正确的转交原因'
            };
          },
          next: 's4_done'
        }]
      }, {
        id: 's4_done',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('cygn10.png');
        },
        tip: '请将当前用户<span style="color: red;font-weight:bold;">转发</span>给<span style="color: red;font-weight:bold;">小金</span>，转交原因填写<span style="color: red;font-weight:bold;">少件</span>',
        isEnd: true
      }]
    },
    five: {
      initialStepId: 's5_1',
      initialForm: {},
      steps: [{
        id: 's5_1',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref26) {
          var ui = _ref26.ui;
          return ui.s5_1hover ? r('tjsp2.png') : r('tjsp1.png');
        },
        tip: '请将<span style="color: red;font-weight:bold;">商品导购区</span>客户<span style="color: red;font-weight:bold;">足迹</span>中<span style="color: red;font-weight:bold;">符合客户需求</span>的商品发送给客户',
        hotspots: [{
          id: 'a',
          x: 0.70,
          y: 0.56,
          w: 0.05,
          h: 0.08,
          hoverSet: {
            s5_1hover: true
          },
          hoverUnset: {
            s5_1hover: false
          },
          next: 's5_2'
        }]
      }, {
        id: 's5_2',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref27) {
          var ui = _ref27.ui;
          return ui.s5_2hover ? r('tjsp4.png') : r('tjsp3.png');
        },
        tip: '请将<span style="color: red;font-weight:bold;">商品导购区</span>客户<span style="color: red;font-weight:bold;">足迹</span>中<span style="color: red;font-weight:bold;">符合客户需求</span>的商品发送给客户',
        hotspots: [{
          id: 'b',
          x: 0.64,
          y: 0.94,
          w: 0.06,
          h: 0.04,
          hoverSet: {
            s5_2hover: true
          },
          hoverUnset: {
            s5_2hover: false
          },
          next: 's5_done'
        }]
      }, {
        id: 's5_done',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('tjsp5.png');
        },
        tip: '请将<span style="color: red;font-weight:bold;">商品导购区</span>客户<span style="color: red;font-weight:bold;">足迹</span>中<span style="color: red;font-weight:bold;">符合客户需求</span>的商品发送给客户',
        isEnd: true
      }]
    },
    six: {
      initialStepId: 's6_1',
      initialForm: {
        yfamount: '0',
        bznr: '',
        phone: '18418966473-4839'
      },
      steps: [{
        id: 's6_1',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('fkzt1.png');
        },
        tip: '请将会话切换到<span style="color: red;font-weight:bold;">未付款客户</span>',
        hotspots: [{
          id: 'a',
          x: 0.09,
          y: 0.41,
          w: 0.15,
          h: 0.06,
          next: 's6_2'
        }]
      }, {
        id: 's6_2',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('fkzt2.png');
        },
        tip: '请将会话切换到<span style="color: red;font-weight:bold;">已付款</span>客户',
        hotspots: [{
          id: 'b',
          x: 0.09,
          y: 0.48,
          w: 0.15,
          h: 0.06,
          next: 's6_3'
        }]
      }, {
        id: 's6_3',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('fkzt3.png');
        },
        tip: '请将会话切换到<span style="color: red;font-weight:bold;">已发货</span>待收货<span style="color: red;font-weight:bold;">客户</span>',
        hotspots: [{
          id: 'b',
          x: 0.09,
          y: 0.54,
          w: 0.15,
          h: 0.06,
          next: 's6_4'
        }]
      }, {
        id: 's6_4',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('fkzt4.png');
        },
        tip: '请将会话切换到<span style="color: red;font-weight:bold;">已发货</span>待收货<span style="color: red;font-weight:bold;">客户</span>',
        hotspots: [],
        afterEnter: {
          delay: 2500,
          go: 's6_5'
        }
      }, {
        id: 's6_5',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('ck1.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">催付</span>按钮，给客户发送催付卡片',
        hotspots: [{
          id: 'b',
          x: 0.70,
          y: 0.88,
          w: 0.05,
          h: 0.04,
          next: 's6_6'
        }]
      }, {
        id: 's6_6',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('ck2.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">催付</span>按钮，给客户发送催付卡片',
        afterEnter: {
          delay: 2500,
          go: 's6_7'
        }
      }, {
        id: 's6_7',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('xgyf1.png');
        },
        overlayImage: function overlayImage(_ref28) {
          var ui = _ref28.ui;
          return ui.showYf ? r('yfalert1.png') : null;
        },
        overlayScale: 0.7,
        tip: '请<span style="color: red;font-weight:bold;">根据聊天内容</span>在<span style="color: red;font-weight:bold;">订单操作区</span>的<span style="color: red;font-weight:bold;">改价</span>中<span style="color: red;font-weight:bold;">修改邮费</span>',
        fields: function fields(_ref29) {
          var ui = _ref29.ui;
          return ui.showYf ? [{
            id: 'yf',
            model: 'yfamount',
            type: 'text',
            bgColor: '#F2F4F7',
            fontSize: '12',
            placeholder: '请输入邮费',
            x: 0.24,
            y: 0.63,
            w: 0.07,
            h: 0.04
          }] : [];
        },
        hotspots: function hotspots(_ref30) {
          var ui = _ref30.ui;
          var list = [{
            id: 'showYf',
            x: 0.75,
            y: 0.88,
            w: 0.06,
            h: 0.04,
            set: {
              showYf: true
            }
          }];
          if (ui.showYf) {
            list.push({
              id: 'yfBtn',
              x: 0.75,
              y: 0.78,
              w: 0.05,
              h: 0.05,
              guard: function guard(_ref31) {
                var form = _ref31.form;
                return String(form.yfamount) === '8' ? {
                  ok: true
                } : {
                  ok: false,
                  msg: '请输入正确的邮费'
                };
              },
              next: 's6_8'
            });
          }
          return list;
        }
      }, {
        id: 's6_8',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('xgyf2.png');
        },
        tip: '【假设商家要求<span style="color: red;font-weight:bold;">发顺丰</span>的客户插<span style="color: red;font-weight:bold;">红色</span>旗子】<span style="color: red;font-weight:bold;">请添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰',
        hotspots: [{
          id: 'd',
          x: 0.85,
          y: 0.82,
          w: 0.03,
          h: 0.03,
          next: 's6_9'
        }]
      }, {
        id: 's6_9',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('bz1.png');
        },
        tip: '【假设商家要求<span style="color: red;font-weight:bold;">发顺丰</span>的客户插<span style="color: red;font-weight:bold;">红色</span>旗子】<span style="color: red;font-weight:bold;">请添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰',
        fields: [{
          id: 'bz',
          model: 'bznr',
          type: 'textarea',
          bgColor: '#FFFFFF',
          fontSize: 12,
          placeholder: '请输入备注内容',
          x: 0.64,
          y: 0.70,
          w: 0.30,
          h: 0.06
        }],
        hotspots: [{
          id: 'e',
          x: 0.71,
          y: 0.54,
          w: 0.07,
          h: 0.03,
          next: 's6_10'
        }]
      }, {
        id: 's6_10',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('bz2.png');
        },
        tip: '【假设商家要求<span style="color: red;font-weight:bold;">发顺丰</span>的客户插<span style="color: red;font-weight:bold;">红色</span>旗子】<span style="color: red;font-weight:bold;">请添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰',
        fields: [{
          id: 'bz',
          model: 'bznr',
          type: 'textarea',
          bgColor: '#FFFFFF',
          fontSize: 12,
          placeholder: '请输入备注内容',
          x: 0.64,
          y: 0.70,
          w: 0.30,
          h: 0.06
        }],
        hotspots: [{
          id: 'f',
          x: 0.84,
          y: 0.95,
          w: 0.05,
          h: 0.04,
          guard: function guard(_ref32) {
            var form = _ref32.form;
            return form.bznr === '发顺丰' ? {
              ok: true
            } : {
              ok: false,
              msg: '请输入正确的备注'
            };
          },
          next: 's6_11'
        }]
      }, {
        id: 's6_11',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('bz3.png');
        },
        tip: '【假设商家要求<span style="color: red;font-weight:bold;">发顺丰</span>的客户插<span style="color: red;font-weight:bold;">红色</span>旗子】<span style="color: red;font-weight:bold;">请添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰',
        afterEnter: {
          delay: 2500,
          go: 's6_12'
        }
      }, {
        id: 's6_12',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('hddd1.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">核对订单</span>按钮，给客户发送订单卡片',
        hotspots: [{
          id: 'g',
          x: 0.64,
          y: 0.88,
          w: 0.06,
          h: 0.04,
          next: 's6_13'
        }]
      }, {
        id: 's6_13',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('hddd2.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">核对订单</span>按钮，给客户发送订单卡片',
        afterEnter: {
          delay: 2500,
          go: 's6_14'
        }
      }, {
        id: 's6_14',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('xgdh1.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">改址</span>按钮，修改客户电话',
        hotspots: [{
          id: 'h',
          x: 0.70,
          y: 0.52,
          w: 0.05,
          h: 0.03,
          next: 's6_15'
        }]
      }, {
        id: 's6_15',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('xgdh2.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">改址</span>按钮，修改客户电话',
        labels: [{
          id: 'phoneLabel',
          text: '13656565656',
          x: 0.30,
          y: 0.42,
          w: 0.07,
          h: 0.04,
          color: '#000',
          fontWeight: 'normal',
          fontSize: 13,
          bgColor: '#FFFFFF',
          selectable: true
        }],
        fields: [{
          id: 'phone',
          model: 'phone',
          bgColor: '#F7F8FA',
          type: 'text',
          placeholder: '请输入',
          x: 0.75,
          y: 0.78,
          w: 0.15,
          h: 0.05
        }],
        hotspots: [{
          id: 'i',
          x: 0.84,
          y: 0.94,
          w: 0.08,
          h: 0.05,
          guard: function guard(_ref33) {
            var form = _ref33.form;
            return form.phone === '13656565656' ? {
              ok: true
            } : {
              ok: false,
              msg: '请输入正确的电话号码！'
            };
          },
          next: 's6_done'
        }]
      }, {
        id: 's6_done',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('xgdh1.png');
        },
        tip: '请点击<span style="color: red;font-weight:bold;">订单操作区</span>中的<span style="color: red;font-weight:bold;">改址</span>按钮，修改客户电话',
        isEnd: true
      }]
    },
    seven: {
      initialStepId: 's7_1',
      initialForm: {},
      steps: [{
        id: 's7_1',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref34) {
          var ui = _ref34.ui;
          return ui.s7_1hover ? r('shcygn2.png') : r('shcygn1.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">工作台</span></span>',
        hotspots: [{
          id: 'a',
          x: 0.04,
          y: 0.16,
          w: 0.04,
          h: 0.06,
          hoverSet: {
            s7_1hover: true
          },
          hoverUnset: {
            s7_1hover: false
          },
          next: 's7_2'
        }]
      }, {
        id: 's7_2',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('shcygn3.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">交易→已卖出宝贝</span></span>',
        hotspots: [{
          id: 'b',
          x: 0.01,
          y: 0.18,
          w: 0.05,
          h: 0.04,
          next: 's7_3'
        }]
      }, {
        id: 's7_3',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref35) {
          var ui = _ref35.ui;
          return ui.s7_3hover ? r('shcygn5.png') : r('shcygn4.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">交易→已卖出宝贝</span></span>',
        hotspots: [{
          id: 'c',
          x: 0.08,
          y: 0.24,
          w: 0.07,
          h: 0.04,
          hoverSet: {
            s7_3hover: true
          },
          hoverUnset: {
            s7_3hover: false
          },
          next: 's7_4'
        }]
      }, {
        id: 's7_4',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref36) {
          var ui = _ref36.ui;
          return ui.s7_4hover ? r('shcygn7.png') : r('shcygn6.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">评价管理</span></span>',
        hotspots: [{
          id: 'd',
          x: 0.08,
          y: 0.31,
          w: 0.07,
          h: 0.04,
          hoverSet: {
            s7_4hover: true
          },
          hoverUnset: {
            s7_4hover: false
          },
          next: 's7_5'
        }]
      }, {
        id: 's7_5',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref37) {
          var ui = _ref37.ui;
          return ui.s7_5hover ? r('shcygn9.png') : r('shcygn8.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">退款管理</span></span>',
        hotspots: [{
          id: 'e',
          x: 0.08,
          y: 0.38,
          w: 0.07,
          h: 0.04,
          hoverSet: {
            s7_5hover: true
          },
          hoverUnset: {
            s7_5hover: false
          },
          next: 's7_done'
        }]
      }, {
        id: 's7_done',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('shcygn10.png');
        },
        tip: '请进入<span style="color: red;font-weight:bold;">退款管理</span></span>',
        isEnd: true
      }]
    },
    eight: {
      initialStepId: 's8_1',
      initialForm: {},
      steps: [{
        id: 's8_1',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('tcqn1.png');
        },
        tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>',
        hotspots: [{
          id: 'a',
          x: 0.09,
          y: 0.08,
          w: 0.05,
          h: 0.03,
          next: 's8_2'
        }]
      }, {
        id: 's8_2',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref38) {
          var ui = _ref38.ui;
          return ui.s8_2hover ? r('tcqn3.png') : r('tcqn2.png');
        },
        tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>',
        hotspots: [{
          id: 'b',
          x: 0.10,
          y: 0.17,
          w: 0.20,
          h: 0.05,
          hoverSet: {
            s8_2hover: true
          },
          hoverUnset: {
            s8_2hover: false
          },
          next: 's8_3'
        }]
      }, {
        id: 's8_3',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('tcqn4.png');
        },
        tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>',
        hotspots: [{
          id: 'c',
          x: 0.54,
          y: 0.54,
          w: 0.25,
          h: 0.05,
          next: 's8_4'
        }]
      }, {
        id: 's8_4',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('tcqn5.png');
        },
        tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>',
        hotspots: [{
          id: 'd',
          x: 0.09,
          y: 0.08,
          w: 0.05,
          h: 0.03,
          next: 's8_5'
        }]
      }, {
        id: 's8_5',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image(_ref39) {
          var ui = _ref39.ui;
          return ui.s8_5hover ? r('tcqn7.png') : r('tcqn6.png');
        },
        tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>',
        hotspots: [{
          id: 'e',
          x: 0.10,
          y: 0.28,
          w: 0.20,
          h: 0.04,
          hoverSet: {
            s8_5hover: true
          },
          hoverUnset: {
            s8_5hover: false
          },
          next: 's8_6'
        }]
      }, {
        id: 's8_6',
        stageBg: function stageBg() {
          return r('qnbg1.png');
        },
        canvasScale: 0.95,
        image: function image() {
          return r('tcqn8.png');
        },
        tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>',
        hotspots: [{
          id: 'e',
          x: 0.56,
          y: 0.57,
          w: 0.05,
          h: 0.06,
          next: 's8_done'
        }]
      }, {
        id: 's8_done',
        image: function image() {
          return r('qnbg1.png');
        },
        tip: '请将状态切换为<span style="color: red;font-weight:bold;">挂起，再退出千牛</span></span>',
        isEnd: true
      }]
    }
  };
}

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bz1.png": 304,
	"./bz2.png": 305,
	"./bz3.png": 306,
	"./ck1.png": 307,
	"./ck2.png": 308,
	"./cygn1.png": 309,
	"./cygn10.png": 310,
	"./cygn2.png": 311,
	"./cygn3.png": 312,
	"./cygn4.png": 313,
	"./cygn5.png": 314,
	"./cygn6.png": 315,
	"./cygn7.png": 316,
	"./cygn8.png": 317,
	"./fkzt1.png": 318,
	"./fkzt2.png": 319,
	"./fkzt3.png": 320,
	"./fkzt4.png": 321,
	"./hddd1.png": 322,
	"./hddd2.png": 323,
	"./kjdy1.png": 324,
	"./kjdy10.png": 325,
	"./kjdy11.png": 326,
	"./kjdy12.png": 327,
	"./kjdy13.png": 328,
	"./kjdy14.png": 329,
	"./kjdy15.png": 330,
	"./kjdy16.png": 331,
	"./kjdy17.png": 332,
	"./kjdy18.png": 333,
	"./kjdy19.png": 334,
	"./kjdy2.png": 335,
	"./kjdy20.png": 336,
	"./kjdy21.png": 337,
	"./kjdy3.png": 338,
	"./kjdy4.png": 339,
	"./kjdy5.png": 340,
	"./kjdy6.png": 341,
	"./kjdy7.png": 342,
	"./kjdy8.png": 343,
	"./kjdy9.png": 344,
	"./login1.png": 345,
	"./login2.png": 346,
	"./login3.png": 347,
	"./loginindex1.png": 348,
	"./loginindex2.png": 349,
	"./loginindex3.png": 350,
	"./loginrnd1.png": 351,
	"./loginrnd2.png": 352,
	"./loginrnd3.png": 353,
	"./qnbg1.png": 354,
	"./qnbg2.png": 75,
	"./qnset1.png": 355,
	"./qnset2.png": 356,
	"./qnset3.png": 357,
	"./qnset4.png": 358,
	"./qnset5.png": 359,
	"./qnset6.png": 360,
	"./qnsort1.png": 361,
	"./qnsort2.png": 362,
	"./qnsort3.png": 363,
	"./qnstatus1.png": 76,
	"./qnstatus2.png": 364,
	"./qnstatus3.png": 365,
	"./qnstatus4.png": 366,
	"./qnstatus5.png": 367,
	"./qnstatus6.png": 368,
	"./qnstatus7.png": 369,
	"./qtcj01.png": 461,
	"./qtcj02.png": 462,
	"./qtcj03.png": 463,
	"./qtcj04.png": 464,
	"./qtcj05.png": 465,
	"./qtcj06.png": 466,
	"./qtcj07.png": 467,
	"./qtcj08.png": 468,
	"./shcygn1.png": 370,
	"./shcygn10.png": 371,
	"./shcygn2.png": 372,
	"./shcygn3.png": 373,
	"./shcygn4.png": 374,
	"./shcygn5.png": 375,
	"./shcygn6.png": 376,
	"./shcygn7.png": 377,
	"./shcygn8.png": 378,
	"./shcygn9.png": 379,
	"./tcqn1.png": 380,
	"./tcqn2.png": 381,
	"./tcqn3.png": 382,
	"./tcqn4.png": 383,
	"./tcqn5.png": 384,
	"./tcqn6.png": 385,
	"./tcqn7.png": 386,
	"./tcqn8.png": 387,
	"./tcqn9.png": 1392,
	"./tjsp1.png": 388,
	"./tjsp2.png": 389,
	"./tjsp3.png": 390,
	"./tjsp4.png": 391,
	"./tjsp5.png": 392,
	"./xgdh1.png": 77,
	"./xgdh2.png": 393,
	"./xgyf1.png": 394,
	"./xgyf2.png": 395,
	"./yfalert1.png": 396,
	"./yfalert2.png": 397
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1391;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tcqn9.8f90d91.png";

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "max-width": "100%" }, attrs: { id: "newQianniuex" } },
    [
      _c("input", {
        ref: "fileInputThird",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".csv" },
        on: { change: _vm.onThirdFileChange }
      }),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("1、登录千牛")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step1.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFirst",
                      attrs: {
                        steps: _vm.scenarioConfig.first.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.first.initialStepId,
                        "initial-form": _vm.scenarioConfig.first.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("first")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("first", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "first",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tip-body" },
                    [
                      _vm.tabCurrent === "first" &&
                      _vm.currentStepId.first === "login"
                        ? [
                            _c("p", [_vm._v("1.复制粘贴账号和密码")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("2.勾选记住密码")]),
                            _vm._v(" "),
                            !_vm.showLoginPassword
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        _vm.showLoginPassword = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t获取账号密码\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showLoginPassword
                              ? [
                                  _c("p", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-weight": "normal"
                                        }
                                      },
                                      [_vm._v("账号：淘金云客服:小淘")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-weight": "normal"
                                        }
                                      },
                                      [_vm._v("密码：Tj1234")]
                                    )
                                  ])
                                ]
                              : _vm._e()
                          ]
                        : [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.rightTip.first)
                              }
                            })
                          ]
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "stoptip",
                staticStyle: { height: "696px" },
                attrs: { id: "studytip-first" }
              },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-登录千牛.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.first
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("first", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("first")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、基础设置（上）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step2.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSecond",
                      attrs: {
                        steps: _vm.scenarioConfig.second.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.second.initialStepId,
                        "initial-form": _vm.scenarioConfig.second.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("second")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("second", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "second",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.second) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-基础设置（上）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.second
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("second", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("second")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("3、基础设置（下）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step3.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerThird",
                      attrs: {
                        steps: _vm.scenarioConfig.third.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.third.initialStepId,
                        "initial-form": _vm.scenarioConfig.third.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("third")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("third", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "third",
                            stepId,
                            step,
                            resolvedTip
                          )
                        },
                        "request-file": _vm.onRequestFile
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.third) }
                  }),
                  _vm._v(" "),
                  _vm.rightTip.third &&
                  _vm.rightTip.third.indexOf("下载") !== -1
                    ? _c("p", [
                        _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                          _vm._v("点击下载“快捷短语.csv”")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-设置快捷短语.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.third
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("third", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("third")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("4、会话窗口常用功能")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step4.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFour",
                      attrs: {
                        steps: _vm.scenarioConfig.four.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.four.initialStepId,
                        "initial-form": _vm.scenarioConfig.four.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("four")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("four", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "four",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.four) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-会话窗口常用功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.four
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("four", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("four")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("5、智能客服插件(上)")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step5.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFive",
                      attrs: {
                        steps: _vm.scenarioConfig.five.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.five.initialStepId,
                        "initial-form": _vm.scenarioConfig.five.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("five")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("five", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "five",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.five) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-智能客服插件(上).ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.five
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("five", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("five")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("6、智能客服插件(下)")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step6.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSix",
                      attrs: {
                        steps: _vm.scenarioConfig.six.steps,
                        "initial-step-id": _vm.scenarioConfig.six.initialStepId,
                        "initial-form": _vm.scenarioConfig.six.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("six")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("six", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "six",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.six) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-智能客服插件(下).ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.six
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("six", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("six")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("7、售后客服常用功能")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step7.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSeven",
                      attrs: {
                        steps: _vm.scenarioConfig.seven.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.seven.initialStepId,
                        "initial-form": _vm.scenarioConfig.seven.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("seven")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("seven", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "seven",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.seven) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-售后客服常用功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.seven
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("seven", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("seven")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer7" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "eight" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("8、退出千牛")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-eight" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "eight",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step8.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerEight",
                      attrs: {
                        steps: _vm.scenarioConfig.eight.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.eight.initialStepId,
                        "initial-form": _vm.scenarioConfig.eight.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("eight")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("eight", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "eight",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.eight) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成千牛的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《千牛模拟实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px" },
                          attrs: { href: "/tjkStudy/simulate/newqianniuexam" }
                        },
                        [_vm._v("去完成千牛模拟实操")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-退出千牛.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.eight
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("eight", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("eight")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer8" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04eda40e", esExports)
  }
}

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364d8a38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newQianNiuExam_vue__ = __webpack_require__(1397);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1395)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-364d8a38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364d8a38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newQianNiuExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/newQianNiuExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-364d8a38", Component.options)
  } else {
    hotAPI.reload("data-v-364d8a38", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1396);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c2b5e308", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-364d8a38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./newQianNiuExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-364d8a38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./newQianNiuExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-364d8a38] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-364d8a38] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.mynone[data-v-364d8a38] {\n  display: none !important;\n}\n.red-span[data-v-364d8a38] {\n  color: red;\n  font-weight: bold;\n}\n", ""]);

// exports


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newQianniuExamex" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isShowQnIcon ||
                              _vm.isShowLoginImg ||
                              _vm.isShowRnd,
                            expression:
                              "isShowQnIcon || isShowLoginImg || isShowRnd"
                          }
                        ],
                        staticClass: "qnbox",
                        staticStyle: { "user-select": "none" }
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.mouseFocus,
                              expression: "!mouseFocus"
                            }
                          ],
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(354)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mouseFocus,
                              expression: "mouseFocus"
                            }
                          ],
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(75)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "qnicon01",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocus = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocus = false
                            },
                            click: _vm.showLoginImg
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowLoginImg,
                                expression: "isShowLoginImg"
                              }
                            ],
                            staticClass: "login",
                            staticStyle: { "user-select": "none" }
                          },
                          [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isSaveAP,
                                  expression: "isSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(347)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSaveAP && _vm.mouseFocusSaveAP,
                                  expression: "!isSaveAP && mouseFocusSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(346)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSaveAP && !_vm.mouseFocusSaveAP,
                                  expression: "!isSaveAP && !mouseFocusSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(345)
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.name,
                                  expression: "name",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "name",
                              attrs: {
                                type: "text",
                                placeholder: "请输入账号"
                              },
                              domProps: { value: _vm.name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.name = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.password,
                                  expression: "password",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "password",
                              attrs: {
                                type: "password",
                                autocomplete: "new-password",
                                placeholder: "请输入密码"
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "hovertag",
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusSaveAP = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusSaveAP = false
                                },
                                click: function($event) {
                                  _vm.isSaveAP = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "logIn",
                              on: { click: _vm.loginIn }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowRnd,
                                expression: "isShowRnd"
                              }
                            ],
                            staticClass: "loginrnd"
                          },
                          [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showRnd,
                                  expression: "showRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(353)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showRnd && _vm.mouseFocusRnd,
                                  expression: "!showRnd && mouseFocusRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(352)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showRnd && !_vm.mouseFocusRnd,
                                  expression: "!showRnd && !mouseFocusRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(351)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sendRnd",
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusRnd = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusRnd = false
                                },
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.rnd,
                                  expression: "rnd",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "rnd",
                              attrs: {
                                type: "text",
                                placeholder: "短信验证码"
                              },
                              domProps: { value: _vm.rnd },
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusRnd = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusRnd = false
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.rnd = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "logInRnd",
                              on: { click: _vm.loginInRnd }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowQnIcon2,
                            expression: "isShowQnIcon2"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(75)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "qnicon02",
                          on: { dblclick: _vm.showLoginImg2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowLoginIndex,
                            expression: "isShowLoginIndex"
                          }
                        ],
                        staticClass: "jdbox"
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mouseFocusJD,
                              expression: "mouseFocusJD"
                            }
                          ],
                          staticClass: "jdimg",
                          attrs: {
                            src: __webpack_require__(348)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.mouseFocusJD,
                              expression: "!mouseFocusJD"
                            }
                          ],
                          staticClass: "jdimg",
                          attrs: {
                            src: __webpack_require__(349)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "jdicon",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusJD = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusJD = false
                            },
                            click: _vm.enterJd
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowLoginIndexTwo,
                            expression: "isShowLoginIndexTwo"
                          }
                        ],
                        staticClass: "indexbox"
                      },
                      [
                        _c("img", {
                          staticClass: "indeximg",
                          attrs: {
                            src: __webpack_require__(350)
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "red-span" }, [
                            _vm._v("登录")
                          ]),
                          _vm._v("千牛工作台，并进入"),
                          _c("span", { staticClass: "red-span" }, [
                            _vm._v("接待中心")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [_vm._m(2), _vm._v(" "), _vm._m(3)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [_vm.showRnd ? [_vm._m(4)] : [_vm._m(5)]]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex ? [_vm._m(6)] : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 1,
                          expression: "secondStep == 1"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 1,
                            expression: "gqstep == 1"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(76)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.gqstep == 1,
                              expression: "gqstep == 1"
                            }
                          ],
                          staticClass: "gqbtn",
                          on: {
                            click: function($event) {
                              _vm.gqstep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 2 && _vm.mouseFocusZX,
                            expression: "gqstep == 2 && mouseFocusZX"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(365)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 2 && !_vm.mouseFocusZX,
                            expression: "gqstep == 2 && !mouseFocusZX"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(364)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.gqstep == 2,
                              expression: "gqstep == 2"
                            }
                          ],
                          staticClass: "gqclick",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusZX = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusZX = false
                            },
                            click: function($event) {
                              _vm.secondStep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 2,
                          expression: "secondStep == 2"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 1,
                            expression: "wgqstep == 1"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(366)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 1,
                              expression: "wgqstep == 1"
                            }
                          ],
                          staticClass: "gqbtn",
                          on: {
                            click: function($event) {
                              _vm.wgqstep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 2 && _vm.mouseFocusGQ,
                            expression: "wgqstep == 2 && mouseFocusGQ"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(368)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 2 && !_vm.mouseFocusGQ,
                            expression: "wgqstep == 2 && !mouseFocusGQ"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(367)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 2,
                              expression: "wgqstep == 2"
                            }
                          ],
                          staticClass: "gqclick",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusGQ = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusGQ = false
                            },
                            click: function($event) {
                              _vm.wgqstep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 3,
                            expression: "wgqstep == 3"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(369)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 3,
                              expression: "wgqstep == 3"
                            }
                          ],
                          staticClass: "cgqbtn",
                          on: {
                            click: function($event) {
                              _vm.secondStep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 3,
                          expression: "secondStep == 3"
                        }
                      ],
                      staticClass: "second-step3"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 1,
                            expression: "secondStepStep == 1"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(76)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 1,
                            expression: "secondStepStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.secondStepStep = 2
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && !_vm.mouseFocusDdsc,
                            expression: "secondStepStep == 2 && !mouseFocusDdsc"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(361)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && _vm.mouseFocusDdsc,
                            expression: "secondStepStep == 2 && mouseFocusDdsc"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(362)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 2,
                              expression: "secondStepStep == 2"
                            }
                          ],
                          staticClass: "btn2",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusDdsc = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusDdsc = false
                            },
                            click: function($event) {
                              _vm.secondStep = 4
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 4,
                          expression: "secondStep == 4"
                        }
                      ],
                      staticClass: "second-step3"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && !_vm.mouseFocusSet,
                            expression: "secondStepStep == 2 && !mouseFocusSet"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(363)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 2 && _vm.mouseFocusSet,
                            expression: "secondStepStep == 2 && mouseFocusSet"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(355)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 2,
                              expression: "secondStepStep == 2"
                            }
                          ],
                          staticClass: "btn3",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSet = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSet = false
                            },
                            click: function($event) {
                              _vm.secondStepStep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 3 && !_vm.mouseFocusSetInfo,
                            expression:
                              "secondStepStep == 3 && !mouseFocusSetInfo"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(356)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 3 && _vm.mouseFocusSetInfo,
                            expression:
                              "secondStepStep == 3 && mouseFocusSetInfo"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(357)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 3,
                              expression: "secondStepStep == 3"
                            }
                          ],
                          staticClass: "btn4",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSetInfo = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSetInfo = false
                            },
                            click: function($event) {
                              _vm.secondStepStep = 4
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 4 &&
                              !_vm.mouseFocusSetInfoDetail,
                            expression:
                              "secondStepStep == 4 && !mouseFocusSetInfoDetail"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(358)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 4 &&
                              _vm.mouseFocusSetInfoDetail,
                            expression:
                              "secondStepStep == 4 && mouseFocusSetInfoDetail"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(359)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 4,
                              expression: "secondStepStep == 4"
                            }
                          ],
                          staticClass: "btn5",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSetInfoDetail = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSetInfoDetail = false
                            },
                            click: _vm.showGqImgClick
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 5,
                            expression: "secondStepStep == 5"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(360)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _vm.secondStep == 1
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("在线")]
                        )
                      ])
                    : _vm.secondStep == 2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("挂起")]
                        )
                      ])
                    : _vm.secondStep == 3
                    ? _c("p", [
                        _vm._v("请将接待排序设置为："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("按客户等待时长排序")]
                        )
                      ])
                    : _vm.secondStep == 4
                    ? _c("p", [
                        _vm._v("请确认"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("店铺分流")
                        ]),
                        _vm._v("和"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("账号分流")
                        ]),
                        _vm._v("是否开启")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "jdgkbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 1,
                          expression: "kjdyStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(324)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 1,
                            expression: "kjdyStep == 1"
                          }
                        ],
                        staticClass: "search-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "search",
                          attrs: { placeholder: "联系人,订单号，聊天记录" },
                          on: { input: _vm.kjdySearchChange },
                          model: {
                            value: _vm.kjdySearch,
                            callback: function($$v) {
                              _vm.kjdySearch = $$v
                            },
                            expression: "kjdySearch"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 2,
                          expression: "kjdyStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(335)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 2,
                            expression: "kjdyStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 3 && !_vm.mouseFocusKJDY,
                          expression: "kjdyStep == 3 && !mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(338)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 3 && _vm.mouseFocusKJDY,
                          expression: "kjdyStep == 3 && mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(339)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 3,
                            expression: "kjdyStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusKJDY = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusKJDY = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 4,
                          expression: "kjdyStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(340)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 4,
                            expression: "kjdyStep == 4"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _vm.kjdyStep == 5
                      ? _c("img", {
                          staticClass: "img-base",
                          attrs: {
                            src: __webpack_require__(341)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 5,
                            expression: "kjdyStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 6 && !_vm.mouseFocusFZ,
                          expression: "kjdyStep == 6 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(342)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 6 && _vm.mouseFocusFZ,
                          expression: "kjdyStep == 6 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(343)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 6,
                            expression: "kjdyStep == 6"
                          }
                        ],
                        staticClass: "btn6",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 7
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7 && !_vm.mouseFocusFZI,
                          expression: "kjdyStep == 7 && !mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(344)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7 && _vm.mouseFocusFZI,
                          expression: "kjdyStep == 7 && mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(325)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 7,
                            expression: "kjdyStep == 7"
                          }
                        ],
                        staticClass: "kjdyfz-c",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZI = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZI = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjfz-input",
                          attrs: { placeholder: "请输入分组" },
                          model: {
                            value: _vm.kjdyfz,
                            callback: function($$v) {
                              _vm.kjdyfz = $$v
                            },
                            expression: "kjdyfz"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7,
                          expression: "kjdyStep == 7"
                        }
                      ],
                      staticClass: "btn7",
                      on: { click: _vm.kjdyfzConfirm }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 8,
                          expression: "kjdyStep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(326)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.kjdyStep == 5 ||
                              _vm.kjdyStep == 6 ||
                              _vm.kjdyStep == 8,
                            expression:
                              "kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8"
                          }
                        ],
                        staticClass: "kjbm-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjbm-input",
                          model: {
                            value: _vm.kjdybm,
                            callback: function($$v) {
                              _vm.kjdybm = $$v
                            },
                            expression: "kjdybm"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.kjdyStep == 5 ||
                              _vm.kjdyStep == 6 ||
                              _vm.kjdyStep == 8,
                            expression:
                              "kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8"
                          }
                        ],
                        staticClass: "kjdy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdy-input",
                          attrs: {
                            placeholder: "请输入快捷短语",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.kjdynr,
                            callback: function($$v) {
                              _vm.kjdynr = $$v
                            },
                            expression: "kjdynr"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 8,
                            expression: "kjdyStep == 8"
                          }
                        ],
                        staticClass: "btn8",
                        on: { click: _vm.kjdyConfirm }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 9,
                          expression: "kjdyStep == 9"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(327)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 9,
                            expression: "kjdyStep == 9"
                          }
                        ],
                        staticClass: "btn9",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 10
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 10,
                          expression: "kjdyStep == 10"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(328)
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput",
                      staticClass: "btn-file",
                      attrs: { type: "file" },
                      on: {
                        change: function($event) {
                          return _vm.tirggerFile($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 11,
                          expression: "kjdyStep == 11"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(329)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 11,
                            expression: "kjdyStep == 11"
                          }
                        ],
                        staticClass: "btn11",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 12
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 12 && !_vm.mouseFocusKJDY,
                          expression: "kjdyStep == 12 && !mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(330)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 12 && _vm.mouseFocusKJDY,
                          expression: "kjdyStep == 12 && mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(331)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 12,
                            expression: "kjdyStep == 12"
                          }
                        ],
                        staticClass: "btn12",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusKJDY = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusKJDY = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 13
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 13,
                          expression: "kjdyStep == 13"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(332)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 13
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "btn133",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              _vm.kjdyStep = 14
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 13,
                            expression: "kjdyStep == 13"
                          }
                        ],
                        staticClass: "btn13",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 14
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 14,
                          expression: "kjdyStep == 14"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(333)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 14,
                            expression: "kjdyStep == 14"
                          }
                        ],
                        staticClass: "kjdyfs-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdyfs-input",
                          attrs: { type: "textarea" },
                          on: { input: _vm.kjdyfsChange },
                          model: {
                            value: _vm.kjdyfs,
                            callback: function($$v) {
                              _vm.kjdyfs = $$v
                            },
                            expression: "kjdyfs"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 15,
                          expression: "kjdyStep == 15"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(334)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 15
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "btn155",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.enterSelect.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 15,
                            expression: "kjdyStep == 15"
                          }
                        ],
                        staticClass: "btn15",
                        on: { click: _vm.enterSelect }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 16,
                          expression: "kjdyStep == 16"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(336)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 16
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          ref: "sixInput",
                          staticClass: "btn16",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.finishThird.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 16,
                            expression: "kjdyStep == 16"
                          }
                        ],
                        staticClass: "btn13",
                        on: { click: _vm.finishThird }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 17,
                          expression: "kjdyStep == 17"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(337)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(8),
                    _vm._v(" "),
                    _vm.kjdyStep == 1 || _vm.kjdyStep == 2
                      ? _c("p", [
                          _vm._v("请搜索登录账号"),
                          _c("br"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("淘金云客服:小淘")]
                          ),
                          _vm._v("打开会话窗口")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 3
                      ? _c("p", [
                          _vm._v("请"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("打开快捷短语")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 4 ||
                    _vm.kjdyStep == 5 ||
                    _vm.kjdyStep == 6 ||
                    _vm.kjdyStep == 7 ||
                    _vm.kjdyStep == 8
                      ? [
                          _vm._m(9),
                          _vm._v(" "),
                          _vm._m(10),
                          _vm._v(" "),
                          _vm._m(11)
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 9 ||
                    _vm.kjdyStep == 10 ||
                    _vm.kjdyStep == 11
                      ? [
                          _vm._m(12),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 12 || _vm.kjdyStep == 13
                      ? [_vm._m(13)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 14 ||
                    _vm.kjdyStep == 15 ||
                    _vm.kjdyStep == 16 ||
                    _vm.kjdyStep == 17
                      ? [_vm._m(14)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cygnbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 1,
                          expression: "cygnStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(309)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 1,
                            expression: "cygnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.cygnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 2 && !_vm.mouseFocusDdsc,
                          expression: "cygnStep == 2 && !mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(311)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 2 && _vm.mouseFocusDdsc,
                          expression: "cygnStep == 2 && mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(312)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 2,
                            expression: "cygnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusDdsc = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDdsc = false
                          },
                          click: _vm.fourStepBystep
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 3,
                          expression: "cygnStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(313)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 4 && !_vm.mouseFocus,
                          expression: "cygnStep == 4 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(314)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 4 && _vm.mouseFocus,
                          expression: "cygnStep == 4 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(315)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 4,
                            expression: "cygnStep == 4"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.cygnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 5,
                          expression: "cygnStep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(316)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 5,
                            expression: "cygnStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          click: function($event) {
                            _vm.cygnStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 6,
                          expression: "cygnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(317)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 6,
                            expression: "cygnStep == 6"
                          }
                        ],
                        staticClass: "zfyy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "zjyy-input",
                          attrs: { placeholder: "请输入转交原因" },
                          model: {
                            value: _vm.zjyy,
                            callback: function($$v) {
                              _vm.zjyy = $$v
                            },
                            expression: "zjyy"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 6,
                            expression: "cygnStep == 6"
                          }
                        ],
                        staticClass: "btn6",
                        on: { click: _vm.sendZfyy }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 7,
                          expression: "cygnStep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(310)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(15),
                  _vm._v(" "),
                  _vm.cygnStep == 1 || _vm.cygnStep == 2 || _vm.cygnStep == 3
                    ? _c("p", [
                        _vm._v("请给当前用户标记"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("黄色星星")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cygnStep == 4 ||
                  _vm.cygnStep == 5 ||
                  _vm.cygnStep == 6 ||
                  _vm.cygnStep == 7
                    ? _c("p", [
                        _vm._v("请将当前用户"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("转发")
                        ]),
                        _vm._v("给"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("小金")
                        ]),
                        _vm._v("，转交原因填写"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("少件")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zncj-top-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 1 && !_vm.mouseFocus,
                          expression: "zncjsstep == 1 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(388)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 1 && _vm.mouseFocus,
                          expression: "zncjsstep == 1 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(389)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjsstep == 1,
                            expression: "zncjsstep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.zncjsstep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 2 && !_vm.mouseFocus,
                          expression: "zncjsstep == 2 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(390)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 2 && _vm.mouseFocus,
                          expression: "zncjsstep == 2 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(391)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjsstep == 2,
                            expression: "zncjsstep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: _vm.tjspEnd
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 3,
                          expression: "zncjsstep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(392)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(16),
                  _vm._v(" "),
                  _vm.zncjsstep == 1 || _vm.zncjsstep == 2 || _vm.zncjsstep == 3
                    ? _c("p", [
                        _vm._v("请将"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("足迹")
                        ]),
                        _vm._v("中"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("符合客户需求")
                        ]),
                        _vm._v("的商品发送给客户")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zncj-bottom-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 1,
                          expression: "zncjxstep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(318)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 1,
                            expression: "zncjxstep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 2,
                          expression: "zncjxstep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(319)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 2,
                            expression: "zncjxstep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 3,
                          expression: "zncjxstep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(320)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 3,
                            expression: "zncjxstep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: { click: _vm.sixStepByStep }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 4,
                          expression: "zncjxstep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(321)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 5,
                          expression: "zncjxstep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(307)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 5,
                            expression: "zncjxstep == 5"
                          }
                        ],
                        staticClass: "btn6",
                        on: { click: _vm.sixStepByStep2 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 6,
                          expression: "zncjxstep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(308)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 7,
                          expression: "zncjxstep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(394)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7,
                            expression: "zncjxstep == 7"
                          }
                        ],
                        staticClass: "btn7",
                        on: {
                          click: function($event) {
                            _vm.showYfstep = true
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.zncjxstep == 7 &&
                            _vm.showYfstep &&
                            !_vm.mouseFocus,
                          expression:
                            "zncjxstep == 7 && showYfstep && !mouseFocus"
                        }
                      ],
                      staticClass: "img-yf",
                      attrs: {
                        src: __webpack_require__(396)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.zncjxstep == 7 &&
                            _vm.showYfstep &&
                            _vm.mouseFocus,
                          expression:
                            "zncjxstep == 7 && showYfstep && mouseFocus"
                        }
                      ],
                      staticClass: "img-yf",
                      attrs: {
                        src: __webpack_require__(397)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7 && _vm.showYfstep,
                            expression: "zncjxstep == 7 && showYfstep"
                          }
                        ],
                        class: {
                          "yf-c": !_vm.mouseFocus,
                          "yf-c1": _vm.mouseFocus
                        },
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "yf-input",
                          attrs: { placeholder: "请输入邮费" },
                          model: {
                            value: _vm.yfamount,
                            callback: function($$v) {
                              _vm.yfamount = $$v
                            },
                            expression: "yfamount"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7 && _vm.showYfstep,
                            expression: "zncjxstep == 7 && showYfstep"
                          }
                        ],
                        staticClass: "btn77",
                        on: { click: _vm.sixStepByStep3 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 8,
                          expression: "zncjxstep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(395)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 8,
                            expression: "zncjxstep == 8"
                          }
                        ],
                        staticClass: "btn8",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 9
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 9,
                          expression: "zncjxstep == 9"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(304)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 9,
                            expression: "zncjxstep == 9"
                          }
                        ],
                        staticClass: "btn9",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 10
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 10,
                          expression: "zncjxstep == 10"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(305)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 10 || _vm.zncjxstep == 9,
                            expression: "zncjxstep == 10 || zncjxstep == 9"
                          }
                        ],
                        staticClass: "kjdy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdy-input",
                          attrs: {
                            placeholder: "请输入备注内容",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.bznr,
                            callback: function($$v) {
                              _vm.bznr = $$v
                            },
                            expression: "bznr"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 10,
                            expression: "zncjxstep == 10"
                          }
                        ],
                        staticClass: "btn10",
                        on: { click: _vm.sixStepByStep4 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 11,
                          expression: "zncjxstep == 11"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(306)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 12,
                          expression: "zncjxstep == 12"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(322)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 12,
                            expression: "zncjxstep == 12"
                          }
                        ],
                        staticClass: "btn12",
                        on: { click: _vm.sixStepByStep5 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 13,
                          expression: "zncjxstep == 13"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(323)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 14,
                          expression: "zncjxstep == 14"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(77)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 14,
                            expression: "zncjxstep == 14"
                          }
                        ],
                        staticClass: "btn14",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 15
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 15,
                          expression: "zncjxstep == 15"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(393)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "phone"
                      },
                      [_vm._v("13656565656")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "phone-c",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "phone-input",
                          attrs: { placeholder: "请输入" },
                          model: {
                            value: _vm.phone,
                            callback: function($$v) {
                              _vm.phone = $$v
                            },
                            expression: "phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "btn15",
                        on: { click: _vm.sixStepByStep6 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 16,
                          expression: "zncjxstep == 16"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(77)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(17),
                  _vm._v(" "),
                  _vm.zncjxstep == 1
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("未付款客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 2
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已付款")
                        ]),
                        _vm._v("待发货"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 3 || _vm.zncjxstep == 4
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已发货")
                        ]),
                        _vm._v("待收货"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 5 || _vm.zncjxstep == 6
                    ? _c("p", [
                        _vm._v("请给客户发送"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("催付")
                        ]),
                        _vm._v("卡片")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 7
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("根据聊天内容，修改邮费")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 8 ||
                  _vm.zncjxstep == 9 ||
                  _vm.zncjxstep == 10 ||
                  _vm.zncjxstep == 11
                    ? _c("p", [
                        _vm._v("【假设商家要求"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("发顺丰")
                        ]),
                        _vm._v("的客户插"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("红色")
                        ]),
                        _vm._v("旗子】请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("添加订单备注，并勾选对应的彩旗。")
                        ]),
                        _c("br"),
                        _vm._v("备注内容为：发顺丰")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 12 || _vm.zncjxstep == 13
                    ? _c("p", [
                        _vm._v("请给客户发送"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("核对订单")
                        ]),
                        _vm._v("卡片")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 14 ||
                  _vm.zncjxstep == 15 ||
                  _vm.zncjxstep == 16
                    ? _c("p", [_vm._v("请修改客户电话")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "sh-cygn" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 1 && !_vm.mouseFocusDdsc,
                          expression: "shcygnStep == 1 && !mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(370)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 1 && _vm.mouseFocusDdsc,
                          expression: "shcygnStep == 1 && mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(372)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 1,
                            expression: "shcygnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusDdsc = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDdsc = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 2,
                          expression: "shcygnStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(373)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 2,
                            expression: "shcygnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.shcygnStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 3 && !_vm.mouseFocus,
                          expression: "shcygnStep == 3 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(374)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 3 && _vm.mouseFocus,
                          expression: "shcygnStep == 3 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(375)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 3,
                            expression: "shcygnStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 4 && !_vm.mouseFocusFZ,
                          expression: "shcygnStep == 4 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(376)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 4 && _vm.mouseFocusFZ,
                          expression: "shcygnStep == 4 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(377)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 4,
                            expression: "shcygnStep == 4"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 5 && !_vm.mouseFocusFZI,
                          expression: "shcygnStep == 5 && !mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(378)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 5 && _vm.mouseFocusFZI,
                          expression: "shcygnStep == 5 && mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(379)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 5,
                            expression: "shcygnStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZI = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZI = false
                          },
                          click: _vm.sevenStepEnd
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 6,
                          expression: "shcygnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(371)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(18),
                  _vm._v(" "),
                  _vm.shcygnStep == 1
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("工作台")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 2 || _vm.shcygnStep == 3
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已卖出宝贝")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 4
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("评价管理")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 5 || _vm.shcygnStep == 6
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("退款管理")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 8, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcqn" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 1,
                          expression: "tcqnStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(380)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 1,
                            expression: "tcqnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 2 && !_vm.mouseFocus,
                          expression: "tcqnStep == 2 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(381)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 2 && _vm.mouseFocus,
                          expression: "tcqnStep == 2 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(382)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 2,
                            expression: "tcqnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.tcqnStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 3,
                          expression: "tcqnStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(383)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 3,
                            expression: "tcqnStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 4,
                          expression: "tcqnStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(384)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 4,
                            expression: "tcqnStep == 4"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 5 && !_vm.mouseFocusFZ,
                          expression: "tcqnStep == 5 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(385)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 5 && _vm.mouseFocusFZ,
                          expression: "tcqnStep == 5 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(386)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 5,
                            expression: "tcqnStep == 5"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.tcqnStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 6,
                          expression: "tcqnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(387)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 6,
                            expression: "tcqnStep == 6"
                          }
                        ],
                        staticClass: "btn5",
                        on: { click: _vm.eightStepEnd }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(19)
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
                  [_vm._m(20)]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("1、登录千牛")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、基础设置（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("4、会话窗口常用功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("5、智能客服插件（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("6、智能客服插件（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、售后客服常用功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("8、退出千牛")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("账号：淘金云客服:小淘")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("密码：Tj1234")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("验证码为：660220")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("获取短信校验码")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("进入接待中心")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("新增一条")
      ]),
      _vm._v("快捷短语。短语内容："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("快捷编码："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("欢迎")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("分组："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("开头语")
      ]),
      _vm._v("（需要自己新增分组）")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请"),
      _c("span", { staticClass: "red-span" }, [_vm._v("先下载")]),
      _vm._v("快捷短语表格"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并保存到桌面上")]),
      _vm._v("，再"),
      _c("span", { staticClass: "red-span" }, [_vm._v("导入")]),
      _vm._v("快捷短语。")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "red-span" }, [_vm._v("鼠标左键")]),
      _vm._v("点击快捷短语的方式，选择"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并发送")]),
      _vm._v("快捷短语："),
      _c("span", { staticClass: "red-span" }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "red-span" }, [_vm._v("/+快捷编码")]),
      _vm._v("点击快捷短语的方式，选择"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并发送")]),
      _vm._v("快捷短语："),
      _c("span", { staticClass: "red-span" }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("请将状态切换为"),
        _c("span", { staticClass: "red-span" }, [_vm._v("挂起，再退出千牛")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip" }, [
      _c("span", { staticClass: "el-icon-success" }),
      _vm._v(" "),
      _c("p", [
        _vm._v("你已完成千牛模拟实操，"),
        _c("br"),
        _vm._v("接下来请完成《京麦功能学习》。")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "startstudy",
          staticStyle: { width: "160px" },
          attrs: { href: "/tjkStudy/simulate/jmStudy" }
        },
        [_vm._v("去完成京麦功能学习")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-364d8a38", esExports)
  }
}

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_11618_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_11618_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_11618_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_11618_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_11618_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2c3cf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newQianNiuExam_11618_vue__ = __webpack_require__(1401);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1399)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b2c3cf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newQianNiuExam_11618_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2c3cf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newQianNiuExam_11618_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/newQianNiuExam_11618.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b2c3cf6", Component.options)
  } else {
    hotAPI.reload("data-v-0b2c3cf6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1400);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("54ad3a5e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0b2c3cf6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./newQianNiuExam_11618.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0b2c3cf6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./newQianNiuExam_11618.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-0b2c3cf6] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-0b2c3cf6] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.mynone[data-v-0b2c3cf6] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newQianniuExam" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: { src: "/tjkStudy/static/newqianniu/qnbg.jpg" }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: "/tjkStudy/static/newqianniu/qnicon01.png"
                        },
                        on: { click: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: { src: "/tjkStudy/static/newqianniu/qnbg.jpg" }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02",
                        attrs: {
                          src: "/tjkStudy/static/newqianniu/qnicon02.png"
                        },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginImg,
                          expression: "isShowLoginImg"
                        }
                      ],
                      staticClass: "login"
                    },
                    [
                      _c("img", {
                        staticClass: "homeImg",
                        attrs: { src: "/tjkStudy/static/newqianniu/login.jpg" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text", placeholder: "请输入账号" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.password,
                            expression: "password",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                          placeholder: "请输入密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logIn",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowRnd,
                          expression: "isShowRnd"
                        }
                      ],
                      staticClass: "loginrnd"
                    },
                    [
                      _c("img", {
                        staticClass: "rndImg",
                        attrs: {
                          src: "/tjkStudy/static/newqianniu/loginrnd.jpg"
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.rnd,
                            expression: "rnd",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "rnd",
                        attrs: {
                          type: "text",
                          placeholder: "请输入短信验证码"
                        },
                        domProps: { value: _vm.rnd },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rnd = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logInRnd",
                        on: { click: _vm.loginInRnd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndex,
                          expression: "isShowLoginIndex"
                        }
                      ],
                      staticClass: "jdbox"
                    },
                    [
                      _c("img", {
                        staticClass: "jdimg",
                        attrs: { src: "/tjkStudy/static/newqianniu/jdicon.jpg" }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "jdicon",
                        on: { click: _vm.enterJd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndexTwo,
                          expression: "isShowLoginIndexTwo"
                        }
                      ],
                      staticClass: "indexbox"
                    },
                    [
                      _c("img", {
                        staticClass: "indeximg",
                        attrs: { src: "/tjkStudy/static/newqianniu/gq.jpg" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的千牛图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _vm._m(2),
                                _vm._v(" "),
                                _vm._m(3),
                                _vm._v(" "),
                                _c("p", [_vm._v("密码：")]),
                                _vm._v(" "),
                                _vm._m(4)
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            },
                            [_vm._v("获取短信验证码")]
                          ),
                          _vm._v(" "),
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _vm._m(5)
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [_vm._v("请进入千牛接待中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowWgq,
                          expression: "!isShowWgq"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "gqimg",
                        attrs: { src: "/tjkStudy/static/newqianniu/gq.jpg" }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "gqbtn",
                        on: {
                          click: function($event) {
                            _vm.showGqImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "qhimg",
                        attrs: { src: "/tjkStudy/static/newqianniu/qh.png" }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqclick",
                        on: { click: _vm.showWgqImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "wgqbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowWgq,
                          expression: "isShowWgq"
                        }
                      ],
                      staticClass: "wgqimg",
                      attrs: { src: "/tjkStudy/static/newqianniu/wgq.jpg" }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm._m(6)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    { staticClass: "jdgkbox" },
                    [
                      _c("img", {
                        staticClass: "jiedaiimg",
                        attrs: { src: "/tjkStudy/static/newqianniu/jiedai.jpg" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "replyone" }, [
                        _c("p", { staticClass: "session" }, [
                          _c("span", { staticClass: "user" }, [
                            _vm._v("fanchaocdmc")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "time" }, [
                            _vm._v(_vm._s(_vm.time))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(7)
                      ]),
                      _vm._v(" "),
                      _vm.isShowOne
                        ? [
                            _c("el-input", {
                              staticClass: "jiedaitextarea",
                              attrs: { type: "textarea" },
                              nativeOn: {
                                keydown: function($event) {
                                  return _vm.listenOne($event)
                                }
                              },
                              model: {
                                value: _vm.jdnr,
                                callback: function($$v) {
                                  _vm.jdnr =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "jdnr"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "jdbtn",
                              on: { click: _vm.showJieDaiImgOne }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowTwo
                        ? [
                            _c("el-input", {
                              staticClass: "jiedaitextarea",
                              attrs: { type: "textarea" },
                              nativeOn: {
                                keydown: function($event) {
                                  return _vm.listenTwo($event)
                                }
                              },
                              model: {
                                value: _vm.jdnr,
                                callback: function($$v) {
                                  _vm.jdnr =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "jdnr"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "jdbtn",
                              on: { click: _vm.showJieDaiImgTwo }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowThree
                        ? [
                            _c("el-input", {
                              staticClass: "jiedaitextarea",
                              attrs: { type: "textarea" },
                              nativeOn: {
                                keydown: function($event) {
                                  return _vm.listenThree($event)
                                }
                              },
                              model: {
                                value: _vm.jdnr,
                                callback: function($$v) {
                                  _vm.jdnr =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "jdnr"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "jdbtn",
                              on: { click: _vm.showJieDaiImgThree }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowFour
                        ? [
                            _c("el-input", {
                              staticClass: "jiedaitextarea",
                              attrs: { type: "textarea" },
                              nativeOn: {
                                keydown: function($event) {
                                  return _vm.listenFour($event)
                                }
                              },
                              model: {
                                value: _vm.jdnr,
                                callback: function($$v) {
                                  _vm.jdnr =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "jdnr"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "jdbtn",
                              on: { click: _vm.showJieDaiImgFour }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _vm.isShowOne
                    ? _c("p", [
                        _vm._v("请接待顾客，回复内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("您好！欢迎光临，请问有什么可以帮到您？")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTwo
                    ? _c("p", [
                        _vm._v("请接待顾客，回复内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("亲亲，正常情况下大概3天左右能到哦！")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowThree
                    ? _c("p", [
                        _vm._v("请接待顾客，回复内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("请问还有什么可以帮到您？")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowFour
                    ? _c("p", [
                        _vm._v("请接待顾客，回复内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("好的，感谢亲亲的支持，祝您生活愉快")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zdhfbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon || _vm.isShowZdhf01,
                          expression: "isShowZdhficon || isShowZdhf01"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: { src: "/tjkStudy/static/newqianniu/gq.jpg" }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { click: _vm.showZdhf01 }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf01,
                            expression: "isShowZdhf01"
                          }
                        ],
                        staticClass: "zdhf01"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf01.png"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf01icon",
                          on: { click: _vm.showZdhf02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf02,
                            expression: "isShowZdhf02"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf02icon",
                          on: { click: _vm.showZdhf03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf03,
                            expression: "isShowZdhf03"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf03icon",
                          on: { click: _vm.showZdhf04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf04,
                            expression: "isShowZdhf04"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf04icon",
                          on: { click: _vm.showZdhf05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf05,
                            expression: "isShowZdhf05"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "zdhf05icon",
                          attrs: { type: "textarea", rows: 10 },
                          model: {
                            value: _vm.zdhf,
                            callback: function($$v) {
                              _vm.zdhf =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "zdhf"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf05btn",
                          on: { click: _vm.showZdhf06 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf06,
                            expression: "isShowZdhf06"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf06.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf06icon",
                          on: { click: _vm.showZdhf07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf07,
                            expression: "isShowZdhf07"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf07.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf07icon",
                          on: { click: _vm.showZdhf08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf08,
                            expression: "isShowZdhf08"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf08.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf08icon",
                          on: { click: _vm.showZdhf09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf09,
                            expression: "isShowZdhf09"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf09.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf09icon",
                          on: { click: _vm.showZdhf10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf10,
                            expression: "isShowZdhf10"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf10.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(9)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjxxbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxxicon,
                            expression: "isShowCjxxicon"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          staticClass: "gqimg",
                          attrs: { src: "/tjkStudy/static/newqianniu/gq.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxxicon",
                          on: { click: _vm.showCjxx01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx01,
                            expression: "isShowCjxx01"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx01icon",
                          on: { click: _vm.showCjxx02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx02,
                            expression: "isShowCjxx02"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx02icon",
                          on: { click: _vm.showCjxx03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx03,
                            expression: "isShowCjxx03"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx03icon",
                          on: { click: _vm.showCjxx04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx04,
                            expression: "isShowCjxx04"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx04icon",
                          on: { mouseover: _vm.showCjxx05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx05,
                            expression: "isShowCjxx05"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx05icon",
                          on: { click: _vm.showCjxx06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx06,
                            expression: "isShowCjxx06"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx06.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx06icon",
                          on: { mouseover: _vm.showCjxx07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx07,
                            expression: "isShowCjxx07"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx07.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx07icon",
                          on: { click: _vm.showCjxx08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx08,
                            expression: "isShowCjxx08"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx08.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx08icon",
                          on: { mouseover: _vm.showCjxx09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx09,
                            expression: "isShowCjxx09"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx09.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx09icon",
                          on: { click: _vm.showCjxx10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx10,
                            expression: "isShowCjxx10"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx10.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx10icon",
                          on: { mouseover: _vm.showCjxx11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx11,
                            expression: "isShowCjxx11"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx11.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx11icon",
                          on: { click: _vm.showCjxx12 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx12,
                            expression: "isShowCjxx12"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx12.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx12icon",
                          on: { mouseover: _vm.showCjxx13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx13,
                            expression: "isShowCjxx13"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx13.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx13icon",
                          on: { click: _vm.showCjxx14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx14,
                            expression: "isShowCjxx14"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx14.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx14icon",
                          on: { mouseover: _vm.showCjxx15 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx15,
                            expression: "isShowCjxx15"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx15.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx15icon",
                          on: { click: _vm.showCjxx16 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx16,
                            expression: "isShowCjxx16"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx16.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx16icon",
                          on: { mouseover: _vm.showCjxx17 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx17,
                            expression: "isShowCjxx17"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx17.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx17icon",
                          on: { click: _vm.showCjxx18 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx18,
                            expression: "isShowCjxx18"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx18.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx18icon",
                          on: { mouseover: _vm.showCjxx19 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx19,
                            expression: "isShowCjxx19"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx19.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx19icon",
                          on: { click: _vm.showCjxx20 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx20,
                            expression: "isShowCjxx20"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx20.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(10),
                    _vm._v(" "),
                    _vm.isShowCjxxTip
                      ? _c("p", [_vm._v("请调出一位最近联系人的对话")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowCjxxTip01 ||
                    _vm.isShowCjxxTip02 ||
                    _vm.isShowCjxxTip03 ||
                    _vm.isShowCjxxTip04
                      ? [
                          _c("p", [_vm._v("请依次完成以下操作：")]),
                          _vm._v(" "),
                          _vm._m(11),
                          _vm._v(" "),
                          _vm._m(12),
                          _vm._v(" "),
                          _vm._m(13),
                          _vm._v(" "),
                          _vm._m(14)
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowCjxxTip05
                      ? _c("p", [_vm._v("请关闭旺旺插件中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "kjdybox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdyicon,
                            expression: "isShowKjdyicon"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/kjdy.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdyicon",
                          on: { click: _vm.showKjdy01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy01,
                            expression: "isShowKjdy01"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/kjdy01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy01icon",
                          on: { mouseover: _vm.showKjdy02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy02,
                            expression: "isShowKjdy02"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/kjdy02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy02icon",
                          on: { click: _vm.showKjdy03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy03,
                            expression: "isShowKjdy03"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/kjdy03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdy03input",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy04.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy03icon",
                          on: { click: _vm.showKjdy04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy04,
                            expression: "isShowKjdy04"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/kjdy04.jpg"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isShowKjdy05
                      ? _c(
                          "div",
                          { staticClass: "kjdy" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/kjdy01.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "kjdytextarea",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdy,
                                callback: function($$v) {
                                  _vm.kjdy =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "kjdy"
                              }
                            }),
                            _vm._v(" "),
                            _vm.isShowKjdy06
                              ? _c("img", {
                                  staticClass: "kjdy05icon",
                                  attrs: {
                                    src:
                                      "/tjkStudy/static/newqianniu/kjdy08.png"
                                  },
                                  on: { click: _vm.showKjdy05 }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy07
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy03.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "focus",
                                rawName: "v-focus",
                                value: true,
                                expression: "true"
                              }
                            ],
                            staticClass: "kjdy03input",
                            attrs: { type: "text" },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.showKjdy06.apply(null, arguments)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "kjdy03icon",
                            on: { click: _vm.showKjdy06 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy08
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy04.jpg"
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy09
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy04.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "kjdy04icon",
                            on: { click: _vm.showKjdy07 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy10
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy05.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "kjdy06icon" }, [
                            _c("input", {
                              staticClass: "btn-file",
                              attrs: { type: "file" },
                              on: {
                                change: function($event) {
                                  return _vm.tirggerFile($event)
                                }
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy11
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy06.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "kjdy07icon",
                            on: { click: _vm.showKjdy08 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy12
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy07.jpg"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(15),
                  _vm._v(" "),
                  _vm.isShowKjdyTip01
                    ? _c("p", [
                        _vm._v(
                          "使用快捷短语操作练习：请采用鼠标左键点击快捷键的方式，给当前顾客发送一条结束语的快捷短语"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip02
                    ? _c("div", [
                        _c("p", [_vm._v("使用快捷短语操作练习：")]),
                        _vm._v(" "),
                        _vm._m(16)
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip03
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请先下载下方的快捷短语表格，并保存在桌面上")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip04
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请将下载好的快捷短语表格导入到千牛上")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "ztsbbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsbicon,
                            expression: "isShowZtsbicon"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/ztsb.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsbicon",
                          on: { mouseover: _vm.showZtsb01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb01,
                            expression: "isShowZtsb01"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb01icon",
                          on: { click: _vm.showZtsb02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb02,
                            expression: "isShowZtsb02"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb02icon",
                          on: { mouseover: _vm.showZtsb03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb03,
                            expression: "isShowZtsb03"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb03icon",
                          on: { click: _vm.showZtsb04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb04,
                            expression: "isShowZtsb04"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb04icon",
                          on: { mouseover: _vm.showZtsb05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb05,
                            expression: "isShowZtsb05"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb05icon",
                          on: { click: _vm.showZtsb06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb06,
                            expression: "isShowZtsb06"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb06.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(17),
                  _vm._v(" "),
                  _vm.isShowZtsbTip01
                    ? _c("p", [
                        _vm._v("状态识别：请将对话切换为“"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("已下单，未付款")]
                        ),
                        _vm._v("”的顾客")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowZtsbTip02
                    ? _c("p", [
                        _vm._v("状态识别：请将对话切换为“"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("已付款，未发货")]
                        ),
                        _vm._v("”的顾客")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowZtsbTip03
                    ? _c("p", [
                        _vm._v("状态识别：请将对话切换为“"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("已发货，未收货")]
                        ),
                        _vm._v("”的顾客")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 8, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgnicon,
                            expression: "isShowZjgnicon"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/zjgn.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgnicon",
                          on: { click: _vm.showZjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn01,
                            expression: "isShowZjgn01"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zjgn01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { mouseover: _vm.showZjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn03,
                            expression: "isShowZjgn03"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zjgn03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn03icon",
                          on: { mouseover: _vm.showZjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn04,
                            expression: "isShowZjgn04"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zjgn04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn04icon",
                          on: { click: _vm.showZjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn05,
                            expression: "isShowZjgn05"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zjgn05.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(18)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-nine", 9, "nine")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "nine" },
            attrs: { id: "tab-nine-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-nine" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgnicon,
                            expression: "isShowTjgnicon"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/tjgn.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgnicon",
                          on: { mouseover: _vm.showTjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn01,
                            expression: "isShowTjgn01"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn01icon",
                          on: { click: _vm.showTjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn02,
                            expression: "isShowTjgn02"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn02icon",
                          on: { click: _vm.showTjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn03,
                            expression: "isShowTjgn03"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn03icon",
                          on: { mouseover: _vm.showTjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn04,
                            expression: "isShowTjgn04"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn04icon",
                          on: { click: _vm.showTjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn05,
                            expression: "isShowTjgn05"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "tjgn05input",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showTjgn06.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn05icon",
                          on: { click: _vm.showTjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn06,
                            expression: "isShowTjgn06"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn06.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(19)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-ten", 10, "ten")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "ten" },
            attrs: { id: "tab-ten-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-ten" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-ten" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "ddcjbox" }, [
                    _vm.isShowDdcj07
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj07.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj07icon",
                            on: { mouseover: _vm.showDdcj08 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj08
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj08.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj08icon",
                            on: { click: _vm.showDdcj09 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj09
                      ? _c(
                          "div",
                          { staticClass: "ddcj" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/ddcj09.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "ddcj09input",
                              attrs: { placeholder: "" },
                              model: {
                                value: _vm.ddcjyf,
                                callback: function($$v) {
                                  _vm.ddcjyf =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "ddcjyf"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "ddcj09icon",
                              on: { click: _vm.showDdcj10 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcjicon
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcjicon",
                            on: { click: _vm.showDdcj01 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj01
                      ? _c(
                          "div",
                          { staticClass: "ddcj" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/ddcj01.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "ddcj01input",
                              attrs: {
                                type: "textarea",
                                placeholder: "请填写备注"
                              },
                              model: {
                                value: _vm.ddcjbz,
                                callback: function($$v) {
                                  _vm.ddcjbz =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "ddcjbz"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "ddcj01icon",
                              on: { click: _vm.showDdcj02 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj02
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj02.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj02icon",
                            on: { click: _vm.showDdcj03 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj03
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj03.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj03icon",
                            on: { click: _vm.showDdcj04 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj04
                      ? _c(
                          "div",
                          { staticClass: "ddcj" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/ddcj04.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "ddcj04input",
                              attrs: { placeholder: "请输入地址" },
                              model: {
                                value: _vm.ddcjdz,
                                callback: function($$v) {
                                  _vm.ddcjdz =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "ddcjdz"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "ddcj04icon",
                              on: { click: _vm.showDdcj05 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj05
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj05.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj05icon",
                            on: { click: _vm.showDdcj06 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj06
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj06.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "focus",
                                rawName: "v-focus",
                                value: true,
                                expression: "true"
                              }
                            ],
                            staticClass: "ddcj06input",
                            attrs: { type: "text" },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.showDdcj07.apply(null, arguments)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj06icon",
                            on: { click: _vm.showDdcj07 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj10
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj10.jpg"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(20),
                  _vm._v(" "),
                  _vm.isShowDdcjTip01
                    ? _c("p", [
                        _vm._v("订单插件操作练习：1.请将商品邮费改成"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("10")]
                        ),
                        _vm._v("元")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowDdcjTip02
                    ? _c("p", [
                        _vm._v(
                          "订单插件操作练习：2.请点击备注按钮，给此客户添加备注内容“"
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("顾客要求发顺丰")]
                        ),
                        _vm._v("”")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowDdcjTip03
                    ? _c("p", [
                        _vm._v("订单插件操作练习：3.请将街道地址修改为“"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("双流区大林镇")]
                        ),
                        _vm._v("”并核对地址")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-ten" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eleven", 11, "eleven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eleven" },
            attrs: { id: "tab-eleven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eleven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eleven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "xjrwbox" }, [
                    _vm.isShowXjrwicon
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "xjrwicon",
                            on: { click: _vm.showXjrw01 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw01
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw01.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "xjrw01icon",
                            on: { click: _vm.showXjrw02 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw02
                      ? _c(
                          "div",
                          { staticClass: "xjrw" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/xjrw02.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "xjrw02input",
                              attrs: {
                                type: "textarea",
                                placeholder:
                                  "请输入任务内容，按Ctrl+回车键，创建任务"
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (!$event.ctrlKey) {
                                    return null
                                  }
                                  return _vm.showXjrw06.apply(null, arguments)
                                }
                              },
                              model: {
                                value: _vm.xjrwtxt,
                                callback: function($$v) {
                                  _vm.xjrwtxt =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "xjrwtxt"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "xjrw02icon",
                              on: { click: _vm.showXjrw03 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw03
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw03.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "xjrw03icon",
                            on: { click: _vm.showXjrw04 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw04
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw04.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "xjrw04icon",
                            on: { click: _vm.showXjrw05 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw05
                      ? _c(
                          "div",
                          { staticClass: "xjrw" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/xjrw05.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticClass: "xjrw05input",
                              attrs: {
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm",
                                format: "yyyy-MM-dd HH:mm",
                                placeholder: "选择日期时间"
                              },
                              model: {
                                value: _vm.xjrwsj,
                                callback: function($$v) {
                                  _vm.xjrwsj = $$v
                                },
                                expression: "xjrwsj"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "xjrw05icon",
                              on: { click: _vm.showXjrw06 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw06
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw06.jpg"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(21),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "新建任务操作练习：请给同事“乐乐”新建一个跟进此顾客的任务提醒，任务内容编辑为“"
                    ),
                    _c(
                      "span",
                      { staticStyle: { color: "red", "font-weight": "bold" } },
                      [_vm._v("此顾客有购买意向，请继续跟进")]
                    ),
                    _vm._v("”，提醒时间设置为"),
                    _c(
                      "span",
                      { staticStyle: { color: "red", "font-weight": "bold" } },
                      [_vm._v(_vm._s(_vm.xjrwmt))]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eleven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-twelve", 12, "twelve")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "twelve" },
            attrs: { id: "tab-twelve-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-twelve" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-twelve" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcqnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqnicon,
                            expression: "isShowTcqnicon"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/tcqn.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqnicon",
                          on: { click: _vm.showTcqn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn01,
                            expression: "isShowTcqn01"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn01icon",
                          on: { click: _vm.showTcqn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn02,
                            expression: "isShowTcqn02"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn02icon",
                          on: { click: _vm.showTcqn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn03,
                            expression: "isShowTcqn03"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn03icon",
                          on: { mouseover: _vm.showTcqn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn04,
                            expression: "isShowTcqn04"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn04icon",
                          on: { click: _vm.showTcqn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn05,
                            expression: "isShowTcqn05"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn05icon",
                          on: { mouseover: _vm.showTcqn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn06,
                            expression: "isShowTcqn06"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn06.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn06icon",
                          on: { click: _vm.showTcqn07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn07,
                            expression: "isShowTcqn07"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn07.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn07icon",
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.showTcqn08.apply(null, arguments)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn08,
                            expression: "isShowTcqn08"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn08.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn08icon",
                          on: { click: _vm.showTcqn09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn09,
                            expression: "isShowTcqn09"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn09.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn09icon",
                          on: { click: _vm.showTcqn10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn10,
                            expression: "isShowTcqn10"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn10.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(22),
                  _vm._v(" "),
                  _vm.isShowTcqnTip01
                    ? _c("p", [_vm._v("请先将状态切换为“挂起”")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcqnTip02
                    ? _c("p", [
                        _vm._v("退出千牛练习：请退出"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("左侧练习场")]
                        ),
                        _vm._v("中的千牛工作台")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-twelve" } },
                  [_vm._m(23)]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录千牛工作台")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、切换状态")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("3、接待顾客")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、设置自动回复")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、添加插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("6、快捷短语的使用和导入")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("7、状态识别")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("8、转接功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-nine" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("9、商品插件学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-ten" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("10、订单插件学习")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eleven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("11、新建任务")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-twelve" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("12、退出千牛")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("账号（"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("账号中间的冒号是英文冒号")
      ]),
      _vm._v("）：")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("淘金客服:001")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("TJ2019")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("660220")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("请将状态切换为“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("未挂起")
        ]),
        _vm._v("”状态")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", [_vm._v("在吗？")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("请新增一条内容为“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("您好！欢迎光临，请问有什么可以帮到您？")
        ]),
        _vm._v("”的自动回复，并设置成“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("当天第一次收到买家消息时自动回复")
        ]),
        _vm._v("”")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("1、添加"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("“淘宝商品管理”")
      ]),
      _vm._v("插件")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("2、添加"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("“淘宝交易管理”")
      ]),
      _vm._v("插件")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("3、添加"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("“智能客服”")
      ]),
      _vm._v("插件")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("4、添加"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("“物流”")
      ]),
      _vm._v("插件")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用/+快捷编码的方式（例如："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("/结束")
      ]),
      _vm._v("），给当前顾客发送一条结束语的快捷短语")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n              提示\n            ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("转接功能操作练习：请将“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("客户001")
        ]),
        _vm._v("”转接给“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("小红（贝拉）")
        ]),
        _vm._v("”")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n              提示\n            ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("商品插件操作练习：请将"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("团队推荐")
        ]),
        _vm._v("里，"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("销量最高的蓝牙耳机")
        ]),
        _vm._v("链接发送给顾客")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip" }, [
      _c("span", { staticClass: "el-icon-success" }),
      _vm._v(" "),
      _c("p", [
        _vm._v("你已完成千牛模拟实操，"),
        _c("br"),
        _vm._v("接下来请完成《京麦功能学习》。")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "startstudy",
          staticStyle: { width: "160px" },
          attrs: { href: "/tjkStudy/simulate/jmStudy" }
        },
        [_vm._v("去完成京麦功能学习")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b2c3cf6", esExports)
  }
}

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doubleQianNiuExam_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doubleQianNiuExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doubleQianNiuExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doubleQianNiuExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doubleQianNiuExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290c004f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doubleQianNiuExam_vue__ = __webpack_require__(1405);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1403)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-290c004f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doubleQianNiuExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290c004f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doubleQianNiuExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/doubleQianNiuExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-290c004f", Component.options)
  } else {
    hotAPI.reload("data-v-290c004f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1404);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6a4a7ce6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-290c004f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./doubleQianNiuExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-290c004f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./doubleQianNiuExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-290c004f] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-290c004f] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.mynone[data-v-290c004f] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newQianniuExam" } },
    [
      !_vm.isHaveBadge
        ? [
            _c("p", { attrs: { align: "center" } }, [
              _vm._v("您还没有获得在线上岗徽章！")
            ])
          ]
        : [
            _c("div", { staticClass: "el-tabs el-tabs--left" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "el-tabs__content" }, [
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    attrs: { id: "tab-first-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-first" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        attrs: { id: "content-first" }
                      },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowQnIcon,
                                  expression: "isShowQnIcon"
                                }
                              ],
                              staticClass: "qnbox"
                            },
                            [
                              _c("img", {
                                staticClass: "qnbg",
                                attrs: {
                                  src: __webpack_require__(597)
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "qnicon01",
                                attrs: {
                                  src: __webpack_require__(1406)
                                },
                                on: { click: _vm.showLoginImg }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowQnIcon2,
                                  expression: "isShowQnIcon2"
                                }
                              ],
                              staticClass: "qnbox"
                            },
                            [
                              _c("img", {
                                staticClass: "qnbg",
                                attrs: {
                                  src: __webpack_require__(597)
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "qnicon02",
                                attrs: {
                                  src: __webpack_require__(1407)
                                },
                                on: { dblclick: _vm.showLoginImg2 }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowLoginImg,
                                  expression: "isShowLoginImg"
                                }
                              ],
                              staticClass: "login"
                            },
                            [
                              _c("img", {
                                staticClass: "homeImg",
                                attrs: {
                                  src: __webpack_require__(1408)
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.name,
                                    expression: "name"
                                  }
                                ],
                                staticClass: "name",
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入账号"
                                },
                                domProps: { value: _vm.name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.name = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password"
                                  }
                                ],
                                staticClass: "password",
                                attrs: {
                                  type: "password",
                                  autocomplete: "new-password",
                                  placeholder: "请输入密码"
                                },
                                domProps: { value: _vm.password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "logIn",
                                on: { click: _vm.loginIn }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowRnd,
                                  expression: "isShowRnd"
                                }
                              ],
                              staticClass: "loginrnd"
                            },
                            [
                              _c("img", {
                                staticClass: "rndImg",
                                attrs: {
                                  src: __webpack_require__(1409)
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.rnd,
                                    expression: "rnd"
                                  }
                                ],
                                staticClass: "rnd",
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入短信验证码"
                                },
                                domProps: { value: _vm.rnd },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.rnd = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "logInRnd",
                                on: { click: _vm.loginInRnd }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowLoginIndex,
                                  expression: "isShowLoginIndex"
                                }
                              ],
                              staticClass: "jdbox"
                            },
                            [
                              _c("img", {
                                staticClass: "jdimg",
                                attrs: {
                                  src: __webpack_require__(1410)
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "con-right" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _vm.isShowQnIcon || _vm.isShowQnIcon2
                              ? _c("p", [
                                  _vm._v("请点击"),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "font-weight": "bold"
                                      }
                                    },
                                    [_vm._v("左侧练习场")]
                                  ),
                                  _vm._v("中的千牛图标进行登录")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowLoginImg ||
                            _vm.isShowRnd ||
                            _vm.isShowLoginIndex
                              ? [
                                  _c("p", [_vm._v("① 账号密码由项目主管提供")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("② 验证码15分钟内有效")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v("③ 如果是新账号，需要绑定自己的信息")
                                  ])
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-first" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext(
                                      "#tab-second",
                                      2,
                                      "second"
                                    )
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "second" },
                    attrs: { id: "tab-second-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-second" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        attrs: { id: "content-second" }
                      },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowWgq,
                                  expression: "!isShowWgq"
                                }
                              ],
                              staticClass: "gqbox"
                            },
                            [
                              _c("img", {
                                staticClass: "gqimg",
                                attrs: {
                                  src: __webpack_require__(1411)
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "gqbtn",
                                on: {
                                  click: function($event) {
                                    _vm.showGqImg = true
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showGqImg,
                                    expression: "showGqImg"
                                  }
                                ],
                                staticClass: "qhimg",
                                attrs: {
                                  src: __webpack_require__(1412)
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showGqImg,
                                    expression: "showGqImg"
                                  }
                                ],
                                staticClass: "gqclick",
                                on: { click: _vm.showWgqImg }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "wgqbox" }, [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShowWgq,
                                  expression: "isShowWgq"
                                }
                              ],
                              staticClass: "wgqimg",
                              attrs: {
                                src: __webpack_require__(1413)
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(2)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-second" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext(
                                      "#tab-third",
                                      3,
                                      "third"
                                    )
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "third" },
                    attrs: { id: "tab-third-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-third" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        attrs: { id: "content-third" }
                      },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "kjdybox" }, [
                            _vm.isShowKjdy01
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1414)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy04icon",
                                    on: { click: _vm.showKjdy01 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy02
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1415)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "kjdy06icon" }, [
                                    _c("input", {
                                      staticClass: "btn-file",
                                      attrs: { type: "file" },
                                      on: {
                                        change: function($event) {
                                          return _vm.tirggerFile($event)
                                        }
                                      }
                                    })
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy03
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1416)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy07icon",
                                    on: { click: _vm.showKjdy02 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy04
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1417)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy08icon",
                                    on: { click: _vm.showKjdy03 }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-right" }, [
                          _vm._m(3),
                          _vm._v(" "),
                          _vm.isShowKjdyTip01
                            ? _c("div", [
                                _c("p", [_vm._v("请将快捷短语导入。")])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShowKjdyTip02
                            ? _c("div", [
                                _c("p", [_vm._v("请将快捷短语导出。")])
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-third" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-four", 4, "four")
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "four" },
                    attrs: { id: "tab-four-content" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content", attrs: { id: "content-four" } },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "kjdybox" }, [
                            _vm.isShowKjdy05
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1418)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy09icon",
                                    on: { click: _vm.showKjdy04 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy06
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1419)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "focus",
                                        rawName: "v-focus",
                                        value: true,
                                        expression: "true"
                                      }
                                    ],
                                    staticClass: "kjdy09input",
                                    attrs: { type: "text" },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.showKjdy05.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy03icon",
                                    on: { click: _vm.showKjdy05 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy07
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1420)
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy08
                              ? _c(
                                  "div",
                                  { staticClass: "kjdy" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: __webpack_require__(1421)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "kjdytextarea",
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: _vm.kjdy,
                                        callback: function($$v) {
                                          _vm.kjdy = $$v
                                        },
                                        expression: "kjdy"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "kjdy03icon",
                                      on: { click: _vm.showKjdy06 }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowKjdy09
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1422)
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-right" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _vm.isShowKjdyTip03
                            ? _c("div", [
                                _c("p", [_vm._v("使用快捷短语回复")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "每个店铺对于响应时间的要求不同，首响一般是15秒，平响30秒，越短越好哦"
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShowKjdyTip04
                            ? _c("div", [
                                _c("p", [
                                  _vm._v(
                                    "请手动回复“您好，请问您的收货地址是哪里？”"
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-four" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-five", 5, "five")
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "five" },
                    attrs: { id: "tab-five-content" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content", attrs: { id: "content-five" } },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "zjgnbox" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgnicon,
                                    expression: "isShowZjgnicon"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: __webpack_require__(1423)
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "zjgntextarea",
                                  attrs: { type: "textarea" },
                                  model: {
                                    value: _vm.zjcz,
                                    callback: function($$v) {
                                      _vm.zjcz = $$v
                                    },
                                    expression: "zjcz"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgnsend",
                                  on: { click: _vm.showZjgn01 }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn01,
                                    expression: "isShowZjgn01"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: __webpack_require__(1424)
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgnicon",
                                  on: { click: _vm.showZjgn02 }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn02,
                                    expression: "isShowZjgn02"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: __webpack_require__(1425)
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgn01icon",
                                  on: { mouseover: _vm.showZjgn03 }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn03,
                                    expression: "isShowZjgn03"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: __webpack_require__(1426)
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgn03icon",
                                  on: { mouseover: _vm.showZjgn04 }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn04,
                                    expression: "isShowZjgn04"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: __webpack_require__(1427)
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "zjgn04icon",
                                  on: { click: _vm.showZjgn05 }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isShowZjgn05,
                                    expression: "isShowZjgn05"
                                  }
                                ],
                                staticClass: "zjgn"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: __webpack_require__(1428)
                                  }
                                })
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-right" }, [
                          _vm._m(5),
                          _vm._v(" "),
                          _vm.isShowZjgnTip01
                            ? _c("p", [
                                _vm._v(
                                  "手动回复“抱歉给您带来了不好的体验，这边给您转接售后客服”"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isShowZjgnTip02
                            ? _c("p", [
                                _vm._v(
                                  "转接功能操作练习：请将“客户002”转接给“小红（贝拉）”"
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-five" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-six", 6, "six")
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "six" },
                    attrs: { id: "tab-six-content" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content", attrs: { id: "content-six" } },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "ddcjbox" }, [
                            _vm.isShowDdcjicon
                              ? _c("div", { staticClass: "ddcj" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1429)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "ddcjicon",
                                    on: { click: _vm.showDdcj01 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowDdcj01
                              ? _c(
                                  "div",
                                  { staticClass: "ddcj" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: __webpack_require__(1430)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "ddcj01input",
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "请填写备注"
                                      },
                                      model: {
                                        value: _vm.ddcjbz,
                                        callback: function($$v) {
                                          _vm.ddcjbz = $$v
                                        },
                                        expression: "ddcjbz"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "ddcj01icon",
                                      on: { click: _vm.showDdcj02 }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowDdcj02
                              ? _c("div", { staticClass: "ddcj" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1431)
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(6)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "studytip-six" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("实操通关，进入下一关吧")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext(
                                      "#tab-seven",
                                      7,
                                      "seven"
                                    )
                                  }
                                }
                              },
                              [_vm._v("GO，下一关")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-tab-pane",
                    class: { mynone: _vm.tabCurrent !== "seven" },
                    attrs: { id: "tab-seven-content" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-seven" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始实操练习")]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        attrs: { id: "content-seven" }
                      },
                      [
                        _c("div", { staticClass: "con-left" }, [
                          _c("div", { staticClass: "kjdybox" }, [
                            _vm.isShowEnd01
                              ? _c(
                                  "div",
                                  { staticClass: "kjdy" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: __webpack_require__(1432)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "kjdytextarea",
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: _vm.end,
                                        callback: function($$v) {
                                          _vm.end = $$v
                                        },
                                        expression: "end"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "kjdy03icon",
                                      on: { click: _vm.showEnd01 }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowEnd02
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1433)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy10icon",
                                    on: { click: _vm.showEnd02 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowEnd03
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1434)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "focus",
                                        rawName: "v-focus",
                                        value: true,
                                        expression: "true"
                                      }
                                    ],
                                    staticClass: "kjdy09input",
                                    attrs: { type: "text" },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.showEnd03.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "kjdy03icon",
                                    on: { click: _vm.showEnd03 }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowEnd04
                              ? _c("div", { staticClass: "kjdy" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(1435)
                                    }
                                  })
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(7)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "studytip-seven" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tip",
                            staticStyle: { width: "400px", height: "310px" }
                          },
                          [
                            _c("span", { staticClass: "el-icon-success" }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "padding-bottom": "5px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.tjkName) +
                                    "（" +
                                    _vm._s(_vm.tjkNumber) +
                                    "），恭喜您！"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticStyle: { padding: "5px 0" } }, [
                              _vm._v("通过【双11&618徽章】培训-实操演练！")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticStyle: { padding: "5px 0" } }, [
                              _vm._v("快快截图此页面去提交作业吧！")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticStyle: { padding: "5px 0" } }, [
                              _vm._v("如果想再次练习可以点击再来一遍！")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "padding-top": "5px" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.again }
                                  },
                                  [_vm._v("再来一遍")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录千牛工作台")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、切换状态")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、快捷短语导入导出")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("4、快捷短语+开头语")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、转接功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、备注")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、结束语+快捷短语")
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("① 挂起=不接待客户，不能随意挂起！！！")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("② 下班时间到点后，才能挂起，挂起之后需接待完手上的客户")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t              提示\n\t            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t              提示\n\t            ")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("添加备注")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t              提示\n\t            ")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("① 结束语是必须要有的哦！")]),
      _vm._v(" "),
      _c("p", [_vm._v("② 聊天记录的最后一句一定是要客服回复的！")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("③ 另外还要关注问答比，问答比是客户跟客服的对话各占的比率！")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("如果话术过长，可以适当拆分进行发送")]),
      _vm._v(" "),
      _c("p", [_vm._v("不能为了问答比拆封一整句话，形成一句不完整的话")]),
      _vm._v(" "),
      _c("p", [_vm._v("只要是能够逻辑清晰，正常表达的，就可以适当的拆分")]),
      _vm._v(" "),
      _c("p", [_vm._v("stepA、提示：手动回复“还有其他的可以帮您吗？”")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "stepB、提示：发送快捷短语。好的亲，祝您购物愉快，有其他问题可以咨询我哦~小金随时为您服务！"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-290c004f", esExports)
  }
}

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login.1554e15.jpg";

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginrnd.db8c7c0.jpg";

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jdicon.8e1b487.jpg";

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gq.beee151.jpg";

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wgq.4bf17d2.jpg";

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy01.770b6b1.jpg";

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy02.7b73dde.jpg";

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy03.88b2ac1.jpg";

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy04.d41743e.jpg";

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy05.983a7f9.jpg";

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy06.33c0ddc.jpg";

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy07.5422772.jpg";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy08.a7f7982.jpg";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kjdy09.cc6f6de.jpg";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zjgn.8f59c4d.jpg";

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zjgn01.8249e23.jpg";

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zjgn02.07d7197.jpg";

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zjgn03.7f25dd6.jpg";

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zjgn04.787583e.jpg";

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zjgn05.7df7b66.jpg";

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ddcj.bfdb515.jpg";

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ddcj01.620d676.jpg";

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ddcj02.8d99258.jpg";

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/end01.28098bb.jpg";

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/end02.379d8f2.jpg";

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/end03.2dcbfb2.jpg";

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/end04.caa7225.jpg";

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiStudy_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiStudy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiStudy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiStudy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiStudy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae80a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingMaiStudy_vue__ = __webpack_require__(1439);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1437)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ae80a70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiStudy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae80a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingMaiStudy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/jingMaiStudy.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ae80a70", Component.options)
  } else {
    hotAPI.reload("data-v-4ae80a70", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1438);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6a34f8c5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ae80a70\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingMaiStudy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4ae80a70\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingMaiStudy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-4ae80a70] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-4ae80a70] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "jingmai" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "zero" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("通关必看")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-zero" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "zero",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/%E9%80%9A%E5%85%B3%E5%BF%85%E7%9C%8B.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-zero" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-first")
                          }
                        }
                      },
                      [_vm._v("继续下一步学习")]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("1、登录京麦")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2022-11/096bd7c00d2a450b9a3ae1916fe2f6a5.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: __webpack_require__(105)
                        },
                        on: { click: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02",
                        attrs: {
                          src: __webpack_require__(106)
                        },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginImg,
                          expression: "isShowLoginImg"
                        }
                      ],
                      staticClass: "login"
                    },
                    [
                      _c("img", {
                        staticClass: "homeImg",
                        attrs: {
                          src: __webpack_require__(107)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text", placeholder: "请输入账号" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                          placeholder: "请输入密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "mima",
                        on: {
                          click: function($event) {
                            _vm.isShowMimaImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowMimaImg,
                            expression: "isShowMimaImg"
                          }
                        ],
                        staticClass: "mima",
                        attrs: {
                          src: __webpack_require__(108)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logIn",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowRnd,
                          expression: "isShowRnd"
                        }
                      ],
                      staticClass: "loginrnd"
                    },
                    [
                      _c("img", {
                        staticClass: "rndImg",
                        attrs: {
                          src: __webpack_require__(109)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rnd,
                            expression: "rnd"
                          }
                        ],
                        staticClass: "rnd",
                        attrs: {
                          type: "text",
                          placeholder: "请输入短信验证码"
                        },
                        domProps: { value: _vm.rnd },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rnd = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logInRnd",
                        on: { click: _vm.loginInRnd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndex,
                          expression: "isShowLoginIndex"
                        }
                      ],
                      staticClass: "jdbox"
                    },
                    [
                      _c("img", {
                        staticClass: "jdimg",
                        attrs: {
                          src: __webpack_require__(110)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "jdicon",
                        on: { click: _vm.enterJd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndexTwo,
                          expression: "isShowLoginIndexTwo"
                        }
                      ],
                      staticClass: "indexbox"
                    },
                    [
                      _c("img", {
                        staticClass: "indeximg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的京麦图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _c(
                                  "p",
                                  [
                                    _vm._v("账号（"),
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("账号中间的冒号是英文冒号")
                                    ]),
                                    _vm._v("）：")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("淘金客服:002")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("密码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("TJ2022")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("勾选“记住密码”")])
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            },
                            [_vm._v("获取短信验证码")]
                          ),
                          _vm._v(" "),
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("6022")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [_vm._v("请进入京麦接待中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-登录京麦.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("2、状态切换")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2022-11/bf768f11e5d5476e94c8dd88db73f697.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowWgq,
                          expression: "!isShowWgq"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "gqbtn",
                        on: {
                          click: function($event) {
                            _vm.showGqImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(111)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqclick",
                        on: { click: _vm.showWgqImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowWgq,
                          expression: "isShowWgq"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(112)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("请将状态切换为“在线”")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySecond }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-状态切换.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("3、客户列表+数据统计")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://res.study.itaojin.cn/2022-11/94504bfa2973434d8de12c4d62ca81a3.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "paixubox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne || _vm.isShowFive,
                          expression: "isShowOne || isShowFive"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(113)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne,
                          expression: "isShowOne"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { mouseover: _vm.showPaixuImgOne }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(114)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { click: _vm.showPaixuImgTwo }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(115)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { mouseover: _vm.showPaixuImgThree }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(116)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { click: _vm.showPaixuImgFour }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "sjclick",
                      on: { click: _vm.showPaixuImgFive }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(117)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowOne ||
                  _vm.isShowTwo ||
                  _vm.isShowThree ||
                  _vm.isShowFour
                    ? _c(
                        "p",
                        [
                          _vm._v("请将客户咨询排序设置为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("按等待时间降序")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowFive
                    ? _c(
                        "p",
                        [
                          _vm._v("请切换到"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("数据")
                          ]),
                          _vm._v("功能，查看数据")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyThird }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-客户列表+数据统计.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt3
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt3(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt3 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("4、自动回复设置")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://res.study.itaojin.cn/2022-11/413b658d30854eb0bccc77fb88e9da12.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zdhfbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(118)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { mouseover: _vm.showZdhf01 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(119)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { click: _vm.showZdhf02 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(120)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "zdhf01icon",
                      on: { click: _vm.showZdhf03 }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf03,
                            expression: "isShowZdhf03"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(121)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf02icon",
                          on: { click: _vm.showZdhf04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf04,
                            expression: "isShowZdhf04"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(122)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf03icon",
                          on: { click: _vm.showZdhf05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf05,
                            expression: "isShowZdhf05"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(123)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf04icon",
                          on: { click: _vm.showZdhf06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf06,
                            expression: "isShowZdhf06"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(124)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf05icon",
                          on: { click: _vm.showZdhf07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf07,
                            expression: "isShowZdhf07"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(125)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "scrollImg",
                          attrs: {
                            src: __webpack_require__(126)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "zdhf06input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.zdhf,
                            callback: function($$v) {
                              _vm.zdhf = $$v
                            },
                            expression: "zdhf"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf06icon",
                          on: { click: _vm.showZdhf08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf08,
                            expression: "isShowZdhf08"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(127)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "请设置“您好！欢迎光临，请问有什么可以帮到您？”的自动回复"
                      ),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("个人版欢迎语")
                      ]),
                      _vm._v("，并勾选“"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("第一次收到顾客消息的回复语")
                      ]),
                      _vm._v("”（记得保存）")
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFour }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-自动回复设置.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt4
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt4(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt4 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("5、快捷短语导入和使用")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://res.study.itaojin.cn/2022-11/d019c786030c48aabb89a67a1a8ff003.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "kjdybox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy01,
                            expression: "isShowKjdy01"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy01icon",
                          on: { mouseover: _vm.showKjdy01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy02,
                            expression: "isShowKjdy02"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(128)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "kjdy01icon" }, [
                          _c("input", {
                            staticClass: "btn-file",
                            attrs: { type: "file", accept: ".csv" },
                            on: {
                              change: function($event) {
                                return _vm.tirggerFile($event)
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy03,
                            expression: "isShowKjdy03"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(129)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy04,
                            expression: "isShowKjdy04"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy02icon",
                          on: { mouseover: _vm.showKjdy02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy05,
                            expression: "isShowKjdy05"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(130)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy03icon",
                          on: { click: _vm.showKjdy03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy06,
                            expression: "isShowKjdy06"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy04.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy07,
                            expression: "isShowKjdy07"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy08,
                            expression: "isShowKjdy08"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdy,
                                callback: function($$v) {
                                  _vm.kjdy = $$v
                                },
                                expression: "kjdy"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy09,
                            expression: "isShowKjdy09"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(131)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy10,
                            expression: "isShowKjdy10"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy06.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy11,
                            expression: "isShowKjdy11"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy12,
                            expression: "isShowKjdy12"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdytwo,
                                callback: function($$v) {
                                  _vm.kjdytwo = $$v
                                },
                                expression: "kjdytwo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy13,
                            expression: "isShowKjdy13"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(132)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy14,
                            expression: "isShowKjdy14"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy08.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy15,
                            expression: "isShowKjdy15"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy16,
                            expression: "isShowKjdy16"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { mouseover: _vm.showKjdy09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy17,
                            expression: "isShowKjdy17"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(133)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { click: _vm.showKjdy10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy18,
                            expression: "isShowKjdy18"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy08icon",
                          on: { click: _vm.showKjdy11 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy19,
                            expression: "isShowKjdy19"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(134)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.fenzu,
                            callback: function($$v) {
                              _vm.fenzu = $$v
                            },
                            expression: "fenzu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy09icon",
                          on: { click: _vm.showKjdy12 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy20,
                            expression: "isShowKjdy20"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy10icon",
                          on: { click: _vm.showKjdy13 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy21,
                            expression: "isShowKjdy21"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(135)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy11icon",
                          on: { click: _vm.showKjdy14 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy22,
                            expression: "isShowKjdy22"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(136)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy04input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.kjbm,
                            callback: function($$v) {
                              _vm.kjbm = $$v
                            },
                            expression: "kjbm"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy12icon",
                          on: { click: _vm.showKjdy15 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy23,
                            expression: "isShowKjdy23"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(137)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowKjdyTip01
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请先下载下方的快捷短语表格，并保存在桌面上")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip02
                    ? _c("p", [_vm._v("请将下载好的快捷短语表格导入到京麦上")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip03
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("鼠标左键")
                          ]),
                          _vm._v("调出"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("发货")
                          ]),
                          _vm._v("的快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/16")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/发货")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip06
                    ? _c("div", [
                        _c("p", [_vm._v("新建一条催付的快捷短语：")]),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语内容："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(
                                "您好！您拍下的商品还未付款，请问您是有什么顾虑吗？"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("新建快捷短语分组："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语编码："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFive }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-快捷短语导入和使用.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt5
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt5(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt5 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、转接功能")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://res.study.itaojin.cn/2022-11/2c7b60063f4e48b99953e5c13c35918b.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n            您的浏览器不支持 video 标签。\n          "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn01,
                            expression: "isShowZjgn01"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(138)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { mouseover: _vm.showZjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn02,
                            expression: "isShowZjgn02"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(139)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { click: _vm.showZjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn03,
                            expression: "isShowZjgn03"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(140)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn02icon",
                          on: { click: _vm.showZjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn04,
                            expression: "isShowZjgn04"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(141)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn03icon",
                          on: { dblclick: _vm.showZjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn05,
                            expression: "isShowZjgn05"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(142)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn04icon",
                          on: { click: _vm.showZjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn06,
                            expression: "isShowZjgn06"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(143)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn05icon",
                          on: { click: _vm.showZjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn07,
                            expression: "isShowZjgn07"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(144)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n              提示\n            ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v("请根据聊天内容，将此顾客转接给状态为“"),
                      _c("font", { attrs: { color: "red" } }, [_vm._v("在线")]),
                      _vm._v("”的售后客服，并选择对应的"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("转接原因")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySix }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n            查看学习资料\n          ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-转接功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt6(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt6 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("7、插件功能（上）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src:
                        "http://res.study.itaojin.cn/2022-11/9ffffdca284f418dadbf961f2d6b4e82.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n            您的浏览器不支持 video 标签。\n\t        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn01,
                            expression: "isShowCjgn01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(145)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { mouseover: _vm.showCjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn02,
                            expression: "isShowCjgn02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(146)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { click: _vm.showCjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn03,
                            expression: "isShowCjgn03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(147)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn02icon",
                          on: { click: _vm.showCjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn04,
                            expression: "isShowCjgn04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(148)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn05,
                            expression: "isShowCjgn05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(149)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn03icon",
                          on: { click: _vm.showCjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn06,
                            expression: "isShowCjgn06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn04icon",
                          on: { click: _vm.showCjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn07,
                            expression: "isShowCjgn07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(150)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn05icon",
                          on: { click: _vm.showCjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn08,
                            expression: "isShowCjgn08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(151)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn09,
                            expression: "isShowCjgn09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn06icon",
                          on: { click: _vm.showCjgn07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn10,
                            expression: "isShowCjgn10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(152)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn07icon",
                          on: { click: _vm.showCjgn08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn11,
                            expression: "isShowCjgn11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(153)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn12,
                            expression: "isShowCjgn12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn08icon",
                          on: { click: _vm.showCjgn09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn13,
                            expression: "isShowCjgn13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(154)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn09icon",
                          on: { click: _vm.showCjgn10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn14,
                            expression: "isShowCjgn14"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(155)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn15,
                            expression: "isShowCjgn15"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn10icon",
                          on: { click: _vm.showCjgn11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn16,
                            expression: "isShowCjgn16"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn11icon",
                          on: { click: _vm.showCjgn12 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn17,
                            expression: "isShowCjgn17"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(156)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn18,
                            expression: "isShowCjgn18"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn12icon",
                          on: { click: _vm.showCjgn13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn19,
                            expression: "isShowCjgn19"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(157)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn13icon",
                          on: { click: _vm.showCjgn14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn20,
                            expression: "isShowCjgn20"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(158)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n              提示\n            ")
                  ]),
                  _vm._v(" "),
                  _vm.isShowCjgnTip01
                    ? _c("p", [_vm._v("请添加客服助手插件")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip02
                    ? _c("p", [
                        _vm._v("请查看客户的商品浏览足迹，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请发送符合客户需求的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("金")
                          ]),
                          _vm._v("和"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("银")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip04
                    ? _c("p", [_vm._v("请查看客户的购物车，并推荐合适的商品")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip05
                    ? _c("p", [
                        _vm._v("请查看客户收藏关注的商品，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip06
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺销量最高，且符合客户需求的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip07
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺评价最高，且符合客户需求的商品")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySeven }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n            查看学习资料\n          ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-插件功能（上）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt7
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt7(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt7 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer7" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "eight" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("7、插件功能（下）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-eight" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "eight",
                      src:
                        "http://res.study.itaojin.cn/2022-11/e10f85a5021046eabc0783481fb6bab1.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n            您的浏览器不支持 video 标签。\n          "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx01,
                            expression: "isShowCjgnx01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(159)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx01icon",
                          on: { click: _vm.showCjgnx01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx02,
                            expression: "isShowCjgnx02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(160)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx01input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.yunfei,
                            callback: function($$v) {
                              _vm.yunfei = $$v
                            },
                            expression: "yunfei"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx02icon",
                          on: { click: _vm.showCjgnx02 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx03,
                            expression: "isShowCjgnx03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(161)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx04,
                            expression: "isShowCjgnx04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(162)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx03icon",
                          on: { click: _vm.showCjgnx03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx05,
                            expression: "isShowCjgnx05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(163)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.dizhi,
                            callback: function($$v) {
                              _vm.dizhi = $$v
                            },
                            expression: "dizhi"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx04icon",
                          on: { click: _vm.showCjgnx04 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx06,
                            expression: "isShowCjgnx06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx05icon",
                          on: { click: _vm.showCjgnx05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx07,
                            expression: "isShowCjgnx07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(164)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx08,
                            expression: "isShowCjgnx08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx06icon",
                          on: { click: _vm.showCjgnx06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx09,
                            expression: "isShowCjgnx09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(165)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx10,
                            expression: "isShowCjgnx10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(166)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx07icon",
                          on: { click: _vm.showCjgnx07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx11,
                            expression: "isShowCjgnx11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(167)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx08icon",
                          on: { click: _vm.showCjgnx08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx12,
                            expression: "isShowCjgnx12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(168)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx09icon",
                          on: { click: _vm.showCjgnx09 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx13,
                            expression: "isShowCjgnx13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(169)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n              提示\n            ")
                  ]),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip01
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待付款")
                          ]),
                          _vm._v(
                            "的订单可以修改运费。请阅读聊天内容，修改运费金额"
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip02
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待出库")
                          ]),
                          _vm._v(
                            "的订单，可以修改客户收货信息。请根据聊天内容，修改客户收货信息"
                          ),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v(
                              "（注意：如果提示输入的内容不正确，那就是地址的省、市、区、街道重复了）"
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("收货信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("假设店铺规定有关发票的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("1级")
                          ]),
                          _vm._v("；有关顺丰快递的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("2级")
                          ]),
                          _vm._v("。请根据聊天内容，给此客户添加对应的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单备注")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip06
                    ? _c(
                        "p",
                        [
                          _vm._v("请编辑备注内容为："),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("要纸质发票")
                          ]),
                          _vm._v("，并选择对应的等级")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyEight }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-nine")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n            查看学习资料\n          ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-插件功能（下）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt8
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt8(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt8 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer8" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "nine" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("8、退出京麦")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-nine" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "nine",
                      src:
                        "http://res.study.itaojin.cn/2022-11/405a93afb6cf40a7b66fdf7b3dc676bc.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n            您的浏览器不支持 video 标签。\n          "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-nine" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcjmbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm01,
                            expression: "isShowTcjm01"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(170)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm01icon",
                          on: { click: _vm.showTcjm01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm02,
                            expression: "isShowTcjm02"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(171)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm02icon",
                          on: { click: _vm.showTcjm02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm03,
                            expression: "isShowTcjm03"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(172)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm03icon",
                          on: { click: _vm.showTcjm03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm04,
                            expression: "isShowTcjm04"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(173)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm04icon",
                          on: { click: _vm.showTcjm04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm05,
                            expression: "isShowTcjm05"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(174)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm05icon",
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.showTcjm05.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjmImg",
                          attrs: {
                            src: __webpack_require__(175)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjm06icon",
                          on: { click: _vm.showTcjm06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm07,
                            expression: "isShowTcjm07"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(176)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n              提示\n            ")
                  ]),
                  _vm._v(" "),
                  _vm.isShowTcjmTip01
                    ? _c(
                        "p",
                        [
                          _vm._v("请将状态切换为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("离线")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip02
                    ? _c("p", [_vm._v("请关闭接待中心")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip03
                    ? _c("p", [_vm._v("请在右下角找到京麦的图标，并退出京麦")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-nine" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成京麦的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《京麦模拟实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartVideoLast }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重看视频")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px" },
                          attrs: { href: "/tjkStudy/simulate/jmExam" }
                        },
                        [_vm._v("去完成京麦模拟实操")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n            查看学习资料\n          ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-退出京麦.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt9
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt9(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt9 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer9" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ae80a70", esExports)
  }
}

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fbe5ec8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingMaiExam_vue__ = __webpack_require__(1443);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1441)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fbe5ec8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fbe5ec8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingMaiExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/jingMaiExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3fbe5ec8", Component.options)
  } else {
    hotAPI.reload("data-v-3fbe5ec8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1442);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6209e5ee", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3fbe5ec8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingMaiExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3fbe5ec8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingMaiExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-3fbe5ec8] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-3fbe5ec8] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.mynone[data-v-3fbe5ec8] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "jingmaiExam" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: __webpack_require__(105)
                        },
                        on: { click: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02",
                        attrs: {
                          src: __webpack_require__(106)
                        },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginImg,
                          expression: "isShowLoginImg"
                        }
                      ],
                      staticClass: "login"
                    },
                    [
                      _c("img", {
                        staticClass: "homeImg",
                        attrs: {
                          src: __webpack_require__(107)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text", placeholder: "请输入账号" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                          placeholder: "请输入密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "mima",
                        on: {
                          click: function($event) {
                            _vm.isShowMimaImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowMimaImg,
                            expression: "isShowMimaImg"
                          }
                        ],
                        staticClass: "mima",
                        attrs: {
                          src: __webpack_require__(108)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logIn",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowRnd,
                          expression: "isShowRnd"
                        }
                      ],
                      staticClass: "loginrnd"
                    },
                    [
                      _c("img", {
                        staticClass: "rndImg",
                        attrs: {
                          src: __webpack_require__(109)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rnd,
                            expression: "rnd"
                          }
                        ],
                        staticClass: "rnd",
                        attrs: {
                          type: "text",
                          placeholder: "请输入短信验证码"
                        },
                        domProps: { value: _vm.rnd },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rnd = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logInRnd",
                        on: { click: _vm.loginInRnd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndex,
                          expression: "isShowLoginIndex"
                        }
                      ],
                      staticClass: "jdbox"
                    },
                    [
                      _c("img", {
                        staticClass: "jdimg",
                        attrs: {
                          src: __webpack_require__(110)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "jdicon",
                        on: { click: _vm.enterJd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndexTwo,
                          expression: "isShowLoginIndexTwo"
                        }
                      ],
                      staticClass: "indexbox"
                    },
                    [
                      _c("img", {
                        staticClass: "indeximg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的京麦图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _c(
                                  "p",
                                  [
                                    _vm._v("账号（"),
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("账号中间的冒号是英文冒号")
                                    ]),
                                    _vm._v("）：")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("淘金客服:002")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("密码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("TJ2022")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("勾选“记住密码”")])
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            },
                            [_vm._v("获取短信验证码")]
                          ),
                          _vm._v(" "),
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("6022")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [_vm._v("请进入京麦接待中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowWgq,
                          expression: "!isShowWgq"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "gqbtn",
                        on: {
                          click: function($event) {
                            _vm.showGqImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(111)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqclick",
                        on: { click: _vm.showWgqImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowWgq,
                          expression: "isShowWgq"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(112)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(2)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "paixubox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne || _vm.isShowFive,
                          expression: "isShowOne || isShowFive"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(113)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne,
                          expression: "isShowOne"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { mouseover: _vm.showPaixuImgOne }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(114)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { click: _vm.showPaixuImgTwo }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(115)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { mouseover: _vm.showPaixuImgThree }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(116)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { click: _vm.showPaixuImgFour }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "sjclick",
                      on: { click: _vm.showPaixuImgFive }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(117)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _vm.isShowOne ||
                  _vm.isShowTwo ||
                  _vm.isShowThree ||
                  _vm.isShowFour
                    ? _c(
                        "p",
                        [
                          _vm._v("请将客户咨询排序设置为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("按等待时间降序")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowFive
                    ? _c(
                        "p",
                        [
                          _vm._v("请切换到"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("数据")
                          ]),
                          _vm._v("功能，查看数据")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zdhfbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(118)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { mouseover: _vm.showZdhf01 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(119)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { click: _vm.showZdhf02 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(120)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "zdhf01icon",
                      on: { click: _vm.showZdhf03 }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf03,
                            expression: "isShowZdhf03"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(121)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf02icon",
                          on: { click: _vm.showZdhf04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf04,
                            expression: "isShowZdhf04"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(122)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf03icon",
                          on: { click: _vm.showZdhf05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf05,
                            expression: "isShowZdhf05"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(123)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf04icon",
                          on: { click: _vm.showZdhf06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf06,
                            expression: "isShowZdhf06"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(124)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf05icon",
                          on: { click: _vm.showZdhf07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf07,
                            expression: "isShowZdhf07"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(125)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "scrollImg",
                          attrs: {
                            src: __webpack_require__(126)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "zdhf06input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.zdhf,
                            callback: function($$v) {
                              _vm.zdhf = $$v
                            },
                            expression: "zdhf"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf06icon",
                          on: { click: _vm.showZdhf08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf08,
                            expression: "isShowZdhf08"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(127)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "请设置“您好！欢迎光临，请问有什么可以帮到您？”的自动回复"
                      ),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("个人版欢迎语")
                      ]),
                      _vm._v("，并勾选“"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("第一次收到顾客消息的回复语")
                      ]),
                      _vm._v("”（记得保存）")
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "kjdybox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy01,
                            expression: "isShowKjdy01"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy01icon",
                          on: { mouseover: _vm.showKjdy01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy02,
                            expression: "isShowKjdy02"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(128)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "kjdy01icon" }, [
                          _c("input", {
                            staticClass: "btn-file",
                            attrs: { type: "file", accept: ".csv" },
                            on: {
                              change: function($event) {
                                return _vm.tirggerFile($event)
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy03,
                            expression: "isShowKjdy03"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(129)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy04,
                            expression: "isShowKjdy04"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy02icon",
                          on: { mouseover: _vm.showKjdy02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy05,
                            expression: "isShowKjdy05"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(130)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy03icon",
                          on: { click: _vm.showKjdy03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy06,
                            expression: "isShowKjdy06"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy04.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy07,
                            expression: "isShowKjdy07"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy08,
                            expression: "isShowKjdy08"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdy,
                                callback: function($$v) {
                                  _vm.kjdy = $$v
                                },
                                expression: "kjdy"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy09,
                            expression: "isShowKjdy09"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(131)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy10,
                            expression: "isShowKjdy10"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy06.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy11,
                            expression: "isShowKjdy11"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy12,
                            expression: "isShowKjdy12"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdytwo,
                                callback: function($$v) {
                                  _vm.kjdytwo = $$v
                                },
                                expression: "kjdytwo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy13,
                            expression: "isShowKjdy13"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(132)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy14,
                            expression: "isShowKjdy14"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy08.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy15,
                            expression: "isShowKjdy15"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy16,
                            expression: "isShowKjdy16"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { mouseover: _vm.showKjdy09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy17,
                            expression: "isShowKjdy17"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(133)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { click: _vm.showKjdy10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy18,
                            expression: "isShowKjdy18"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy08icon",
                          on: { click: _vm.showKjdy11 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy19,
                            expression: "isShowKjdy19"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(134)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.fenzu,
                            callback: function($$v) {
                              _vm.fenzu = $$v
                            },
                            expression: "fenzu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy09icon",
                          on: { click: _vm.showKjdy12 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy20,
                            expression: "isShowKjdy20"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy10icon",
                          on: { click: _vm.showKjdy13 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy21,
                            expression: "isShowKjdy21"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(135)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy11icon",
                          on: { click: _vm.showKjdy14 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy22,
                            expression: "isShowKjdy22"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(136)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy04input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.kjbm,
                            callback: function($$v) {
                              _vm.kjbm = $$v
                            },
                            expression: "kjbm"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy12icon",
                          on: { click: _vm.showKjdy15 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy23,
                            expression: "isShowKjdy23"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(137)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _vm.isShowKjdyTip01
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请先下载下方的快捷短语表格，并保存在桌面上")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip02
                    ? _c("p", [_vm._v("请将下载好的快捷短语表格导入到京麦上")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip03
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("鼠标左键")
                          ]),
                          _vm._v("调出"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("发货")
                          ]),
                          _vm._v("的快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/16")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/发货")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip06
                    ? _c("div", [
                        _c("p", [_vm._v("新建一条催付的快捷短语：")]),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语内容："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(
                                "您好！您拍下的商品还未付款，请问您是有什么顾虑吗？"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("新建快捷短语分组："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语编码："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn01,
                            expression: "isShowZjgn01"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(138)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { mouseover: _vm.showZjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn02,
                            expression: "isShowZjgn02"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(139)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { click: _vm.showZjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn03,
                            expression: "isShowZjgn03"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(140)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn02icon",
                          on: { click: _vm.showZjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn04,
                            expression: "isShowZjgn04"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(141)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn03icon",
                          on: { dblclick: _vm.showZjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn05,
                            expression: "isShowZjgn05"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(142)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn04icon",
                          on: { click: _vm.showZjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn06,
                            expression: "isShowZjgn06"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(143)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn05icon",
                          on: { click: _vm.showZjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn07,
                            expression: "isShowZjgn07"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(144)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v("请根据聊天内容，将此顾客转接给状态为“"),
                      _c("font", { attrs: { color: "red" } }, [_vm._v("在线")]),
                      _vm._v("”的售后客服，并选择对应的"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("转接原因")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn01,
                            expression: "isShowCjgn01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(145)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { mouseover: _vm.showCjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn02,
                            expression: "isShowCjgn02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(146)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { click: _vm.showCjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn03,
                            expression: "isShowCjgn03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(147)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn02icon",
                          on: { click: _vm.showCjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn04,
                            expression: "isShowCjgn04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(148)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn05,
                            expression: "isShowCjgn05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(149)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn03icon",
                          on: { click: _vm.showCjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn06,
                            expression: "isShowCjgn06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn04icon",
                          on: { click: _vm.showCjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn07,
                            expression: "isShowCjgn07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(150)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn05icon",
                          on: { click: _vm.showCjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn08,
                            expression: "isShowCjgn08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(151)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn09,
                            expression: "isShowCjgn09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn06icon",
                          on: { click: _vm.showCjgn07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn10,
                            expression: "isShowCjgn10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(152)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn07icon",
                          on: { click: _vm.showCjgn08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn11,
                            expression: "isShowCjgn11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(153)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn12,
                            expression: "isShowCjgn12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn08icon",
                          on: { click: _vm.showCjgn09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn13,
                            expression: "isShowCjgn13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(154)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn09icon",
                          on: { click: _vm.showCjgn10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn14,
                            expression: "isShowCjgn14"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(155)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn15,
                            expression: "isShowCjgn15"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn10icon",
                          on: { click: _vm.showCjgn11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn16,
                            expression: "isShowCjgn16"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn11icon",
                          on: { click: _vm.showCjgn12 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn17,
                            expression: "isShowCjgn17"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(156)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn18,
                            expression: "isShowCjgn18"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn12icon",
                          on: { click: _vm.showCjgn13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn19,
                            expression: "isShowCjgn19"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(157)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn13icon",
                          on: { click: _vm.showCjgn14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn20,
                            expression: "isShowCjgn20"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(158)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _vm.isShowCjgnTip01
                    ? _c("p", [_vm._v("请添加客服助手插件")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip02
                    ? _c("p", [
                        _vm._v("请查看客户的商品浏览足迹，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请发送符合客户需求的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("金")
                          ]),
                          _vm._v("和"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("银")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip04
                    ? _c("p", [_vm._v("请查看客户的购物车，并推荐合适的商品")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip05
                    ? _c("p", [
                        _vm._v("请查看客户收藏关注的商品，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip06
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺销量最高，且符合客户需求的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip07
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺评价最高，且符合客户需求的商品")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 8, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx01,
                            expression: "isShowCjgnx01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(159)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx01icon",
                          on: { click: _vm.showCjgnx01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx02,
                            expression: "isShowCjgnx02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(160)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx01input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.yunfei,
                            callback: function($$v) {
                              _vm.yunfei = $$v
                            },
                            expression: "yunfei"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx02icon",
                          on: { click: _vm.showCjgnx02 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx03,
                            expression: "isShowCjgnx03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(161)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx04,
                            expression: "isShowCjgnx04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(162)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx03icon",
                          on: { click: _vm.showCjgnx03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx05,
                            expression: "isShowCjgnx05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(163)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.dizhi,
                            callback: function($$v) {
                              _vm.dizhi = $$v
                            },
                            expression: "dizhi"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx04icon",
                          on: { click: _vm.showCjgnx04 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx06,
                            expression: "isShowCjgnx06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx05icon",
                          on: { click: _vm.showCjgnx05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx07,
                            expression: "isShowCjgnx07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(164)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx08,
                            expression: "isShowCjgnx08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx06icon",
                          on: { click: _vm.showCjgnx06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx09,
                            expression: "isShowCjgnx09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(165)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx10,
                            expression: "isShowCjgnx10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(166)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx07icon",
                          on: { click: _vm.showCjgnx07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx11,
                            expression: "isShowCjgnx11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(167)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx08icon",
                          on: { click: _vm.showCjgnx08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx12,
                            expression: "isShowCjgnx12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(168)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx09icon",
                          on: { click: _vm.showCjgnx09 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx13,
                            expression: "isShowCjgnx13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(169)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip01
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待付款")
                          ]),
                          _vm._v(
                            "的订单可以修改运费。请阅读聊天内容，修改运费金额"
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip02
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待出库")
                          ]),
                          _vm._v(
                            "的订单，可以修改客户收货信息。请根据聊天内容，修改客户收货信息"
                          ),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v(
                              "（注意：如果提示输入的内容不正确，那就是地址的省、市、区、街道重复了）"
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("收货信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("假设店铺规定有关发票的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("1级")
                          ]),
                          _vm._v("；有关顺丰快递的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("2级")
                          ]),
                          _vm._v("。请根据聊天内容，给此客户添加对应的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单备注")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip06
                    ? _c(
                        "p",
                        [
                          _vm._v("请编辑备注内容为："),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("要纸质发票")
                          ]),
                          _vm._v("，并选择对应的等级")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-nine", 9, "nine")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "nine" },
            attrs: { id: "tab-nine-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-nine" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcjmbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm01,
                            expression: "isShowTcjm01"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(170)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm01icon",
                          on: { click: _vm.showTcjm01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm02,
                            expression: "isShowTcjm02"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(171)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm02icon",
                          on: { click: _vm.showTcjm02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm03,
                            expression: "isShowTcjm03"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(172)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm03icon",
                          on: { click: _vm.showTcjm03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm04,
                            expression: "isShowTcjm04"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(173)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm04icon",
                          on: { click: _vm.showTcjm04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm05,
                            expression: "isShowTcjm05"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(174)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm05icon",
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.showTcjm05.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjmImg",
                          attrs: {
                            src: __webpack_require__(175)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjm06icon",
                          on: { click: _vm.showTcjm06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm07,
                            expression: "isShowTcjm07"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(176)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _vm.isShowTcjmTip01
                    ? _c(
                        "p",
                        [
                          _vm._v("请将状态切换为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("离线")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip02
                    ? _c("p", [_vm._v("请关闭接待中心")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip03
                    ? _c("p", [_vm._v("请在右下角找到京麦的图标，并退出京麦")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-nine" } },
                  [_vm._m(10)]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("1、登录京麦")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、状态切换")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、客户列表+数据统计")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、自动回复设置")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("5、快捷短语导入和使用")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、转接功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、插件功能（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、插件功能（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-nine" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("8、退出京麦")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("请将状态切换为“在线”")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "tip", staticStyle: { width: "400px", height: "270px" } },
      [
        _c("span", { staticClass: "el-icon-success" }),
        _vm._v(" "),
        _c("p", { staticStyle: { "padding-bottom": "5px" } }, [
          _vm._v("恭喜您完成所有训练，获得系统实操徽章。")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { padding: "5px 0" } }, [
          _vm._v("接下来请继续完成，")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { padding: "5px 0" } }, [
          _vm._v("淘金云客服app上的其他课程。")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fbe5ec8", esExports)
  }
}

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_11618_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_11618_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_11618_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_11618_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_11618_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9a134f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingMaiExam_11618_vue__ = __webpack_require__(1447);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1445)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a9a134f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingMaiExam_11618_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9a134f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingMaiExam_11618_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/simulate/jingMaiExam_11618.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a9a134f4", Component.options)
  } else {
    hotAPI.reload("data-v-a9a134f4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ca460134", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a9a134f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingMaiExam_11618.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a9a134f4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingMaiExam_11618.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-a9a134f4] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-a9a134f4] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.mynone[data-v-a9a134f4] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "jingmaiExam" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: __webpack_require__(105)
                        },
                        on: { click: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02",
                        attrs: {
                          src: __webpack_require__(106)
                        },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginImg,
                          expression: "isShowLoginImg"
                        }
                      ],
                      staticClass: "login"
                    },
                    [
                      _c("img", {
                        staticClass: "homeImg",
                        attrs: {
                          src: __webpack_require__(107)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text", placeholder: "请输入账号" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                          placeholder: "请输入密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "mima",
                        on: {
                          click: function($event) {
                            _vm.isShowMimaImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowMimaImg,
                            expression: "isShowMimaImg"
                          }
                        ],
                        staticClass: "mima",
                        attrs: {
                          src: __webpack_require__(108)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logIn",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowRnd,
                          expression: "isShowRnd"
                        }
                      ],
                      staticClass: "loginrnd"
                    },
                    [
                      _c("img", {
                        staticClass: "rndImg",
                        attrs: {
                          src: __webpack_require__(109)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rnd,
                            expression: "rnd"
                          }
                        ],
                        staticClass: "rnd",
                        attrs: {
                          type: "text",
                          placeholder: "请输入短信验证码"
                        },
                        domProps: { value: _vm.rnd },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rnd = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logInRnd",
                        on: { click: _vm.loginInRnd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndex,
                          expression: "isShowLoginIndex"
                        }
                      ],
                      staticClass: "jdbox"
                    },
                    [
                      _c("img", {
                        staticClass: "jdimg",
                        attrs: {
                          src: __webpack_require__(110)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "jdicon",
                        on: { click: _vm.enterJd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndexTwo,
                          expression: "isShowLoginIndexTwo"
                        }
                      ],
                      staticClass: "indexbox"
                    },
                    [
                      _c("img", {
                        staticClass: "indeximg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的京麦图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _c(
                                  "p",
                                  [
                                    _vm._v("账号（"),
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("账号中间的冒号是英文冒号")
                                    ]),
                                    _vm._v("）：")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("淘金客服:002")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("密码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("TJ2022")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("勾选“记住密码”")])
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            },
                            [_vm._v("获取短信验证码")]
                          ),
                          _vm._v(" "),
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("6022")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [_vm._v("请进入京麦接待中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowWgq,
                          expression: "!isShowWgq"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "gqbtn",
                        on: {
                          click: function($event) {
                            _vm.showGqImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(111)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqclick",
                        on: { click: _vm.showWgqImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowWgq,
                          expression: "isShowWgq"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(112)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(2)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "paixubox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne || _vm.isShowFive,
                          expression: "isShowOne || isShowFive"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(113)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne,
                          expression: "isShowOne"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { mouseover: _vm.showPaixuImgOne }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(114)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { click: _vm.showPaixuImgTwo }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(115)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { mouseover: _vm.showPaixuImgThree }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(116)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { click: _vm.showPaixuImgFour }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "sjclick",
                      on: { click: _vm.showPaixuImgFive }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(117)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _vm.isShowOne ||
                  _vm.isShowTwo ||
                  _vm.isShowThree ||
                  _vm.isShowFour
                    ? _c(
                        "p",
                        [
                          _vm._v("请将客户咨询排序设置为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("按等待时间降序")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowFive
                    ? _c(
                        "p",
                        [
                          _vm._v("请切换到"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("数据")
                          ]),
                          _vm._v("功能，查看数据")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zdhfbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(118)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { mouseover: _vm.showZdhf01 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(119)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { click: _vm.showZdhf02 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(120)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "zdhf01icon",
                      on: { click: _vm.showZdhf03 }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf03,
                            expression: "isShowZdhf03"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(121)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf02icon",
                          on: { click: _vm.showZdhf04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf04,
                            expression: "isShowZdhf04"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(122)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf03icon",
                          on: { click: _vm.showZdhf05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf05,
                            expression: "isShowZdhf05"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(123)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf04icon",
                          on: { click: _vm.showZdhf06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf06,
                            expression: "isShowZdhf06"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(124)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf05icon",
                          on: { click: _vm.showZdhf07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf07,
                            expression: "isShowZdhf07"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(125)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "scrollImg",
                          attrs: {
                            src: __webpack_require__(126)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "zdhf06input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.zdhf,
                            callback: function($$v) {
                              _vm.zdhf = $$v
                            },
                            expression: "zdhf"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf06icon",
                          on: { click: _vm.showZdhf08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf08,
                            expression: "isShowZdhf08"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(127)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "请设置“您好！欢迎光临，请问有什么可以帮到您？”的自动回复"
                      ),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("个人版欢迎语")
                      ]),
                      _vm._v("，并勾选“"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("第一次收到顾客消息的回复语")
                      ]),
                      _vm._v("”（记得保存）")
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "kjdybox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy01,
                            expression: "isShowKjdy01"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy01icon",
                          on: { mouseover: _vm.showKjdy01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy02,
                            expression: "isShowKjdy02"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(128)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "kjdy01icon" }, [
                          _c("input", {
                            staticClass: "btn-file",
                            attrs: { type: "file", accept: ".csv" },
                            on: {
                              change: function($event) {
                                return _vm.tirggerFile($event)
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy03,
                            expression: "isShowKjdy03"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(129)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy04,
                            expression: "isShowKjdy04"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy02icon",
                          on: { mouseover: _vm.showKjdy02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy05,
                            expression: "isShowKjdy05"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(130)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy03icon",
                          on: { click: _vm.showKjdy03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy06,
                            expression: "isShowKjdy06"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy04.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy07,
                            expression: "isShowKjdy07"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy08,
                            expression: "isShowKjdy08"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdy,
                                callback: function($$v) {
                                  _vm.kjdy = $$v
                                },
                                expression: "kjdy"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy09,
                            expression: "isShowKjdy09"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(131)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy10,
                            expression: "isShowKjdy10"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy06.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy11,
                            expression: "isShowKjdy11"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy12,
                            expression: "isShowKjdy12"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdytwo,
                                callback: function($$v) {
                                  _vm.kjdytwo = $$v
                                },
                                expression: "kjdytwo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy13,
                            expression: "isShowKjdy13"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(132)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy14,
                            expression: "isShowKjdy14"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy08.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy15,
                            expression: "isShowKjdy15"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy16,
                            expression: "isShowKjdy16"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { mouseover: _vm.showKjdy09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy17,
                            expression: "isShowKjdy17"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(133)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { click: _vm.showKjdy10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy18,
                            expression: "isShowKjdy18"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy08icon",
                          on: { click: _vm.showKjdy11 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy19,
                            expression: "isShowKjdy19"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(134)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.fenzu,
                            callback: function($$v) {
                              _vm.fenzu = $$v
                            },
                            expression: "fenzu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy09icon",
                          on: { click: _vm.showKjdy12 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy20,
                            expression: "isShowKjdy20"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy10icon",
                          on: { click: _vm.showKjdy13 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy21,
                            expression: "isShowKjdy21"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(135)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy11icon",
                          on: { click: _vm.showKjdy14 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy22,
                            expression: "isShowKjdy22"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(136)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy04input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.kjbm,
                            callback: function($$v) {
                              _vm.kjbm = $$v
                            },
                            expression: "kjbm"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy12icon",
                          on: { click: _vm.showKjdy15 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy23,
                            expression: "isShowKjdy23"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(137)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _vm.isShowKjdyTip01
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请先下载下方的快捷短语表格，并保存在桌面上")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip02
                    ? _c("p", [_vm._v("请将下载好的快捷短语表格导入到京麦上")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip03
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("鼠标左键")
                          ]),
                          _vm._v("调出"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("发货")
                          ]),
                          _vm._v("的快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/16")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/发货")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip06
                    ? _c("div", [
                        _c("p", [_vm._v("新建一条催付的快捷短语：")]),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语内容："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(
                                "您好！您拍下的商品还未付款，请问您是有什么顾虑吗？"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("新建快捷短语分组："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语编码："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn01,
                            expression: "isShowZjgn01"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(138)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { mouseover: _vm.showZjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn02,
                            expression: "isShowZjgn02"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(139)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { click: _vm.showZjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn03,
                            expression: "isShowZjgn03"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(140)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn02icon",
                          on: { click: _vm.showZjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn04,
                            expression: "isShowZjgn04"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(141)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn03icon",
                          on: { dblclick: _vm.showZjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn05,
                            expression: "isShowZjgn05"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(142)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn04icon",
                          on: { click: _vm.showZjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn06,
                            expression: "isShowZjgn06"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(143)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn05icon",
                          on: { click: _vm.showZjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn07,
                            expression: "isShowZjgn07"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(144)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v("请根据聊天内容，将此顾客转接给状态为“"),
                      _c("font", { attrs: { color: "red" } }, [_vm._v("在线")]),
                      _vm._v("”的售后客服，并选择对应的"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("转接原因")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn01,
                            expression: "isShowCjgn01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(145)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { mouseover: _vm.showCjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn02,
                            expression: "isShowCjgn02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(146)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { click: _vm.showCjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn03,
                            expression: "isShowCjgn03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(147)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn02icon",
                          on: { click: _vm.showCjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn04,
                            expression: "isShowCjgn04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(148)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn05,
                            expression: "isShowCjgn05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(149)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn03icon",
                          on: { click: _vm.showCjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn06,
                            expression: "isShowCjgn06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn04icon",
                          on: { click: _vm.showCjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn07,
                            expression: "isShowCjgn07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(150)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn05icon",
                          on: { click: _vm.showCjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn08,
                            expression: "isShowCjgn08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(151)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn09,
                            expression: "isShowCjgn09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn06icon",
                          on: { click: _vm.showCjgn07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn10,
                            expression: "isShowCjgn10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(152)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn07icon",
                          on: { click: _vm.showCjgn08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn11,
                            expression: "isShowCjgn11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(153)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn12,
                            expression: "isShowCjgn12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn08icon",
                          on: { click: _vm.showCjgn09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn13,
                            expression: "isShowCjgn13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(154)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn09icon",
                          on: { click: _vm.showCjgn10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn14,
                            expression: "isShowCjgn14"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(155)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn15,
                            expression: "isShowCjgn15"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn10icon",
                          on: { click: _vm.showCjgn11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn16,
                            expression: "isShowCjgn16"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn11icon",
                          on: { click: _vm.showCjgn12 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn17,
                            expression: "isShowCjgn17"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(156)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn18,
                            expression: "isShowCjgn18"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn12icon",
                          on: { click: _vm.showCjgn13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn19,
                            expression: "isShowCjgn19"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(157)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn13icon",
                          on: { click: _vm.showCjgn14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn20,
                            expression: "isShowCjgn20"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(158)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _vm.isShowCjgnTip01
                    ? _c("p", [_vm._v("请添加客服助手插件")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip02
                    ? _c("p", [
                        _vm._v("请查看客户的商品浏览足迹，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请发送符合客户需求的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("金")
                          ]),
                          _vm._v("和"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("银")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip04
                    ? _c("p", [_vm._v("请查看客户的购物车，并推荐合适的商品")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip05
                    ? _c("p", [
                        _vm._v("请查看客户收藏关注的商品，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip06
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺销量最高，且符合客户需求的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip07
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺评价最高，且符合客户需求的商品")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 8, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx01,
                            expression: "isShowCjgnx01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(159)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx01icon",
                          on: { click: _vm.showCjgnx01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx02,
                            expression: "isShowCjgnx02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(160)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx01input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.yunfei,
                            callback: function($$v) {
                              _vm.yunfei = $$v
                            },
                            expression: "yunfei"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx02icon",
                          on: { click: _vm.showCjgnx02 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx03,
                            expression: "isShowCjgnx03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(161)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx04,
                            expression: "isShowCjgnx04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(162)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx03icon",
                          on: { click: _vm.showCjgnx03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx05,
                            expression: "isShowCjgnx05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(163)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.dizhi,
                            callback: function($$v) {
                              _vm.dizhi = $$v
                            },
                            expression: "dizhi"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx04icon",
                          on: { click: _vm.showCjgnx04 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx06,
                            expression: "isShowCjgnx06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx05icon",
                          on: { click: _vm.showCjgnx05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx07,
                            expression: "isShowCjgnx07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(164)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx08,
                            expression: "isShowCjgnx08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx06icon",
                          on: { click: _vm.showCjgnx06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx09,
                            expression: "isShowCjgnx09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(165)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx10,
                            expression: "isShowCjgnx10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(166)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx07icon",
                          on: { click: _vm.showCjgnx07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx11,
                            expression: "isShowCjgnx11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(167)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx08icon",
                          on: { click: _vm.showCjgnx08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx12,
                            expression: "isShowCjgnx12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(168)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx09icon",
                          on: { click: _vm.showCjgnx09 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx13,
                            expression: "isShowCjgnx13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(169)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip01
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待付款")
                          ]),
                          _vm._v(
                            "的订单可以修改运费。请阅读聊天内容，修改运费金额"
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip02
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待出库")
                          ]),
                          _vm._v(
                            "的订单，可以修改客户收货信息。请根据聊天内容，修改客户收货信息"
                          ),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v(
                              "（注意：如果提示输入的内容不正确，那就是地址的省、市、区、街道重复了）"
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("收货信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("假设店铺规定有关发票的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("1级")
                          ]),
                          _vm._v("；有关顺丰快递的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("2级")
                          ]),
                          _vm._v("。请根据聊天内容，给此客户添加对应的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单备注")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip06
                    ? _c(
                        "p",
                        [
                          _vm._v("请编辑备注内容为："),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("要纸质发票")
                          ]),
                          _vm._v("，并选择对应的等级")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-nine", 9, "nine")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "nine" },
            attrs: { id: "tab-nine-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-nine" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcjmbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm01,
                            expression: "isShowTcjm01"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(170)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm01icon",
                          on: { click: _vm.showTcjm01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm02,
                            expression: "isShowTcjm02"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(171)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm02icon",
                          on: { click: _vm.showTcjm02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm03,
                            expression: "isShowTcjm03"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(172)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm03icon",
                          on: { click: _vm.showTcjm03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm04,
                            expression: "isShowTcjm04"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(173)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm04icon",
                          on: { click: _vm.showTcjm04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm05,
                            expression: "isShowTcjm05"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(174)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm05icon",
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.showTcjm05.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjmImg",
                          attrs: {
                            src: __webpack_require__(175)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjm06icon",
                          on: { click: _vm.showTcjm06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm07,
                            expression: "isShowTcjm07"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(176)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _vm.isShowTcjmTip01
                    ? _c(
                        "p",
                        [
                          _vm._v("请将状态切换为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("离线")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip02
                    ? _c("p", [_vm._v("请关闭接待中心")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip03
                    ? _c("p", [_vm._v("请在右下角找到京麦的图标，并退出京麦")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-nine" } },
                  [_vm._m(10)]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("1、登录京麦")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、状态切换")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、客户列表+数据统计")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、自动回复设置")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("5、快捷短语导入和使用")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、转接功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、插件功能（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、插件功能（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-nine" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("8、退出京麦")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("请将状态切换为“在线”")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "tip", staticStyle: { width: "400px", height: "270px" } },
      [
        _c("span", { staticClass: "el-icon-success" }),
        _vm._v(" "),
        _c("p", { staticStyle: { "padding-bottom": "5px" } }, [
          _vm._v("恭喜您完成所有训练，获得系统实操徽章。")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { padding: "5px 0" } }, [
          _vm._v("接下来请继续完成，")
        ]),
        _vm._v(" "),
        _c("p", { staticStyle: { padding: "5px 0" } }, [
          _vm._v("淘金云客服app上的其他课程。")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9a134f4", esExports)
  }
}

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed89c4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1449);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed89c4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/trainCheck/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0ed89c4c", Component.options)
  } else {
    hotAPI.reload("data-v-0ed89c4c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "traincheck" }, [
    _vm.isShowList
      ? _c("div", { staticClass: "content" }, [
          _c("h3", [_vm._v(_vm._s(_vm.description))]),
          _vm._v(" "),
          _c("p", [_vm._v("下面是本次培训的安排：")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "list-box" },
            [
              _vm._l(_vm.list, function(item, key) {
                return [
                  _c(
                    "div",
                    {
                      class: {
                        list: true,
                        first: item.isExpireFirst && item.isExpireFirst == "Yes"
                      }
                    },
                    [
                      _c("div", { staticClass: "top" }, [
                        _c("div", { staticClass: "xuhao" }, [
                          _c("span", [_vm._v(_vm._s(key + 1))])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text" }, [
                          _c("p", { staticClass: "name" }, [
                            _vm._v("【培训讲师】：" + _vm._s(item.teacherName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "gary",
                              attrs: { title: item.content }
                            },
                            [_vm._v("【培训内容】：" + _vm._s(item.content))]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "gary" }, [
                            _vm._v(
                              "【培训日期】：" +
                                _vm._s(item.startTime.substring(0, 10)) +
                                "（" +
                                _vm._s(item.startTime.substring(11, 16)) +
                                "-" +
                                _vm._s(item.endTime.substring(11, 16)) +
                                "）"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "button" }, [
                          _c(
                            "a",
                            {
                              staticClass: "pjia",
                              on: {
                                click: function($event) {
                                  return _vm.showPjia(item.courseId)
                                }
                              }
                            },
                            [_vm._v("匿名评价")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bottom" }, [
                        _c(
                          "div",
                          { staticClass: "c-list" },
                          [
                            item.signTimes != null
                              ? _vm._l(item.signTimes, function(c, index) {
                                  return _c("span", [
                                    _vm._v(
                                      _vm._s(c.substring(11, 19)) + "（已签到）"
                                    )
                                  ])
                                })
                              : [_c("p", [_vm._v("您还没有签到")])]
                          ],
                          2
                        )
                      ])
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowPjia
      ? _c("div", { staticClass: "pjia-box" }, [
          _c("h3", [_vm._v("参与评价")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "感谢您的评价，以帮助我们改进培训质量，请放心参与评价，我们将不会记录任何您的个人信息"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c(
              "div",
              { staticClass: "rate-box-first" },
              [
                _c("span", { staticClass: "first" }, [_vm._v("课程评价")]),
                _vm._v(" "),
                _c("el-rate", {
                  attrs: { "allow-half": true },
                  model: {
                    value: _vm.courseScore,
                    callback: function($$v) {
                      _vm.courseScore = $$v
                    },
                    expression: "courseScore"
                  }
                }),
                _vm._v(" "),
                !_vm.isShowMore
                  ? _c(
                      "span",
                      { staticClass: "close", on: { click: _vm.showMore } },
                      [_vm._v("点击展开")]
                    )
                  : _c(
                      "span",
                      { staticClass: "close", on: { click: _vm.closeMore } },
                      [_vm._v("点击收起")]
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowMore,
                    expression: "isShowMore"
                  }
                ],
                staticClass: "rate-box"
              },
              [
                _c("span", { staticClass: "first" }, [_vm._v("实用性")]),
                _vm._v(" "),
                _c("el-rate", {
                  attrs: { "allow-half": true },
                  model: {
                    value: _vm.utility,
                    callback: function($$v) {
                      _vm.utility = $$v
                    },
                    expression: "utility"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "close" })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowMore,
                    expression: "isShowMore"
                  }
                ],
                staticClass: "rate-box"
              },
              [
                _c("span", { staticClass: "first" }, [_vm._v("条理性")]),
                _vm._v(" "),
                _c("el-rate", {
                  attrs: { "allow-half": true },
                  model: {
                    value: _vm.reasonability,
                    callback: function($$v) {
                      _vm.reasonability = $$v
                    },
                    expression: "reasonability"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "close" })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowMore,
                    expression: "isShowMore"
                  }
                ],
                staticClass: "rate-box"
              },
              [
                _c("span", { staticClass: "first" }, [_vm._v("通用性")]),
                _vm._v(" "),
                _c("el-rate", {
                  attrs: { "allow-half": true },
                  model: {
                    value: _vm.popularity,
                    callback: function($$v) {
                      _vm.popularity = $$v
                    },
                    expression: "popularity"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "close" })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rate-box-first" },
              [
                _c("span", { staticClass: "first" }, [_vm._v("讲师评价")]),
                _vm._v(" "),
                _c("el-rate", {
                  attrs: { "allow-half": true },
                  model: {
                    value: _vm.teacherScore,
                    callback: function($$v) {
                      _vm.teacherScore = $$v
                    },
                    expression: "teacherScore"
                  }
                }),
                _vm._v(" "),
                !_vm.isShowMoreTwo
                  ? _c(
                      "span",
                      { staticClass: "close", on: { click: _vm.showMoreTwo } },
                      [_vm._v("点击展开")]
                    )
                  : _c(
                      "span",
                      { staticClass: "close", on: { click: _vm.closeMoreTwo } },
                      [_vm._v("点击收起")]
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowMoreTwo,
                    expression: "isShowMoreTwo"
                  }
                ],
                staticClass: "rate-box"
              },
              [
                _c("span", { staticClass: "first" }, [_vm._v("互动性")]),
                _vm._v(" "),
                _c("el-rate", {
                  attrs: { "allow-half": true },
                  model: {
                    value: _vm.interaction,
                    callback: function($$v) {
                      _vm.interaction = $$v
                    },
                    expression: "interaction"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "close" })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowMoreTwo,
                    expression: "isShowMoreTwo"
                  }
                ],
                staticClass: "rate-box"
              },
              [
                _c("span", { staticClass: "first" }, [_vm._v("纪律性")]),
                _vm._v(" "),
                _c("el-rate", {
                  attrs: { "allow-half": true },
                  model: {
                    value: _vm.discipline,
                    callback: function($$v) {
                      _vm.discipline = $$v
                    },
                    expression: "discipline"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "close" })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowMoreTwo,
                    expression: "isShowMoreTwo"
                  }
                ],
                staticClass: "rate-box"
              },
              [
                _c("span", { staticClass: "first" }, [_vm._v("亲和力")]),
                _vm._v(" "),
                _c("el-rate", {
                  attrs: { "allow-half": true },
                  model: {
                    value: _vm.affinity,
                    callback: function($$v) {
                      _vm.affinity = $$v
                    },
                    expression: "affinity"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "close" })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rate-box-first" },
              [
                _c("span", { staticClass: "first" }, [_vm._v("其他建议")]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: { type: "textarea", autosize: "" },
                  model: {
                    value: _vm.advice,
                    callback: function($$v) {
                      _vm.advice = $$v
                    },
                    expression: "advice"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "btn-box" }, [
              _c(
                "p",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "margin-r",
                      attrs: { plain: "" },
                      on: { click: _vm.gotoList }
                    },
                    [_vm._v("返回")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    { staticClass: "btn", on: { click: _vm.submitPjia } },
                    [_vm._v("匿名评价")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("p", [_vm._v("请放心评价，我们将不会记录您的个人信息。")])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowPjiaSucc
      ? _c("div", { staticClass: "succ-box" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("p", [
            _c("a", { staticClass: "btn", on: { click: _vm.closePjiaSucc } }, [
              _vm._v("返回")
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowCheck ? _c("div", { staticClass: "check-box-bg" }) : _vm._e(),
    _vm._v(" "),
    _vm.isShowCheck
      ? _c(
          "div",
          {
            staticClass: "check-box",
            on: {
              click: function($event) {
                return _vm.checkIn()
              }
            }
          },
          [
            _c("p", [_vm._v("立即签到")]),
            _vm._v(" "),
            _c("p", [_c("span", { domProps: { innerHTML: _vm._s(_vm.djs) } })])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowCheckSucc
      ? _c("div", {
          staticClass: "check-succ-box-bg",
          on: {
            click: function($event) {
              _vm.isShowCheckSucc = false
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowCheckSucc
      ? _c("div", { staticClass: "check-succ-box" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("p", [
            _c(
              "a",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    _vm.isShowCheckSucc = false
                  }
                }
              },
              [_vm._v("确定")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowLogin
      ? _c(
          "div",
          { staticClass: "login-box" },
          [
            _c(
              "el-form",
              { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "账号", prop: "loginName" } },
                  [
                    _c("el-input", {
                      attrs: { type: "text", autocomplete: "off" },
                      model: {
                        value: _vm.form.loginName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "loginName", $$v)
                        },
                        expression: "form.loginName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "密码", prop: "loginPwd" } },
                  [
                    _c("el-input", {
                      attrs: { type: "password", autocomplete: "off" },
                      model: {
                        value: _vm.form.loginPwd,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "loginPwd", $$v)
                        },
                        expression: "form.loginPwd"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", [
                  _c("a", { staticClass: "btn", on: { click: _vm.login } }, [
                    _vm._v("登录")
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowTemplate
      ? _c(
          "div",
          { staticClass: "template-box" },
          [
            _c("h3", [_vm._v("填写问卷")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "本人郑重承诺以下填写的信息属实，如因信息不属实产生的后果由自己承担。每个问题都需要填写！"
              )
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "wjform",
                staticClass: "intent-content",
                attrs: { model: _vm.wjform }
              },
              [
                _vm._l(_vm.questionList, function(item, key) {
                  return [
                    _vm.questionList.length > 0
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "is-required",
                            attrs: { label: key + 1 + "、" + item.paramName }
                          },
                          [
                            item.paramType == "TEXT"
                              ? [
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.wjform.answerList[item.paramId],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.wjform.answerList,
                                          item.paramId,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "wjform.answerList[item.paramId]"
                                    }
                                  })
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            item.paramType == "RADIO"
                              ? [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value:
                                          _vm.wjform.answerList[item.paramId],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.wjform.answerList,
                                            item.paramId,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "wjform.answerList[item.paramId]"
                                      }
                                    },
                                    [
                                      _vm._l(item.optionList, function(s) {
                                        return [
                                          _c("el-radio", {
                                            attrs: { label: s }
                                          })
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                }),
                _vm._v(" "),
                _c("p", [
                  _c(
                    "a",
                    { staticClass: "btn", on: { click: _vm.submitInfo } },
                    [_vm._v("提交")]
                  )
                ])
              ],
              2
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowRecruit
      ? _c("div", { staticClass: "recruit-box" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("p", { staticClass: "text" }, [_vm._v(_vm._s(_vm.description))]),
          _vm._v(" "),
          _c("p", [
            _c("a", { staticClass: "btn", on: { click: _vm.recruitFun } }, [
              _vm._v("我要报名")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", { staticClass: "el-icon-success" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("b", [_vm._v("提交成功！感谢您的评价！")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", { attrs: { src: __webpack_require__(1450) } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("b", [_vm._v("签到成功！")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", { attrs: { src: __webpack_require__(1451) } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ed89c4c", esExports)
  }
}

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b909ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainList_vue__ = __webpack_require__(1455);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1453)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61b909ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b909ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/trainCheck/trainList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-61b909ce", Component.options)
  } else {
    hotAPI.reload("data-v-61b909ce", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1454);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9b79c5c0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-61b909ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-61b909ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.content-wrap[data-v-61b909ce] {\n  padding: 20px;\n}\n.el-pagination[data-v-61b909ce] {\n  text-align: center;\n  margin-top: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap" },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "培训日期" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  placeholder: "选择开始日期",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm:ss"
                },
                on: { change: _vm.getStartTime },
                model: {
                  value: _vm.courseStartTime,
                  callback: function($$v) {
                    _vm.courseStartTime = $$v
                  },
                  expression: "courseStartTime"
                }
              }),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  placeholder: "选择结束日期",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm:ss"
                },
                on: { change: _vm.getEndTime },
                model: {
                  value: _vm.courseEndTime,
                  callback: function($$v) {
                    _vm.courseEndTime = $$v
                  },
                  expression: "courseEndTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查询")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "培训日期", width: "340", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.courses, function(l, key) {
                    return _c("p", [
                      _vm._v(_vm._s(l.startTime) + "--" + _vm._s(l.endTime))
                    ])
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "merchantName",
              label: "商家（项目）",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "培训老师", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.courses, function(l, key) {
                    return _c("p", [_vm._v(_vm._s(l.teacherName))])
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "description",
              label: "说明",
              width: "400",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "应到人数", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.participateTjkList != null
                      ? _c("span", [
                          _vm._v(_vm._s(scope.row.participateTjkList.length))
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "signNum",
              label: "签到人数",
              width: "100",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "courseScore",
              label: "课程评分",
              width: "100",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "teacherScore",
              label: "讲师评分",
              width: "100",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "350" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.showSign(scope.row)
                          }
                        }
                      },
                      [_vm._v("发起签到")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.editRow(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑课程")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.showCheckList(scope.row)
                          }
                        }
                      },
                      [_vm._v("签到明细")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.gotoNameList(scope.row)
                          }
                        }
                      },
                      [_vm._v("培训名单")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0"
          }
        ],
        attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
        on: { getData: _vm.getList }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "培训课程",
            visible: _vm.dialogVisible,
            width: "50%",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { ref: "add", attrs: { model: _vm.add, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { staticClass: "is-required", attrs: { label: "课程" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addCourse }
                    },
                    [_vm._v("新增课程")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.add.courses,
                        border: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "培训时间",
                          align: "center",
                          width: "260"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.startTime.substring(0, 10)
                                    ) +
                                    "（" +
                                    _vm._s(
                                      scope.row.startTime.substring(11, 16)
                                    ) +
                                    "-" +
                                    _vm._s(
                                      scope.row.endTime.substring(11, 16)
                                    ) +
                                    "）\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "content",
                          label: "课程内容",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", align: "center", width: "60" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link-text",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteCourse(scope.rowindex)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.editSubmitCourse }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增课程",
            visible: _vm.dialogVisibleCourse,
            width: "40%",
            "before-close": _vm.handleCloseCourse,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleCourse = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addcourse",
              attrs: { model: _vm.addcourse, "label-width": "120px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "培训日期", prop: "date" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "选择开始日期",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd"
                    },
                    on: { change: _vm.getDateTime },
                    model: {
                      value: _vm.date,
                      callback: function($$v) {
                        _vm.date = $$v
                      },
                      expression: "date"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "时间" } },
                [
                  _c("el-time-select", {
                    attrs: {
                      placeholder: "起始时间",
                      "picker-options": {
                        start: "00:00",
                        step: "00:30",
                        end: "23:00"
                      }
                    },
                    model: {
                      value: _vm.addcourse.startTime,
                      callback: function($$v) {
                        _vm.$set(_vm.addcourse, "startTime", $$v)
                      },
                      expression: "addcourse.startTime"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-time-select", {
                    attrs: {
                      placeholder: "结束时间",
                      "picker-options": {
                        start: "00:00",
                        step: "00:30",
                        end: "23:00"
                      }
                    },
                    model: {
                      value: _vm.addcourse.endTime,
                      callback: function($$v) {
                        _vm.$set(_vm.addcourse, "endTime", $$v)
                      },
                      expression: "addcourse.endTime"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "培训内容", prop: "content" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请填写培训内容",
                      autosize: ""
                    },
                    model: {
                      value: _vm.addcourse.content,
                      callback: function($$v) {
                        _vm.$set(_vm.addcourse, "content", $$v)
                      },
                      expression: "addcourse.content"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseCourse } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addCourseFun } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "签到明细",
            visible: _vm.dialogVisibleCheck,
            width: "50%",
            "before-close": _vm.handleCloseCheck,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleCheck = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { ref: "check", attrs: { model: _vm.check } },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "课程", prop: "courseId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.check.courseId,
                            callback: function($$v) {
                              _vm.$set(_vm.check, "courseId", $$v)
                            },
                            expression: "check.courseId"
                          }
                        },
                        _vm._l(_vm.checkCourseList, function(t, index) {
                          return _c("el-option", {
                            key: t.courseId,
                            attrs: { label: t.content, value: t.courseId }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否签到", prop: "isNotSign" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.check.isNotSign,
                            callback: function($$v) {
                              _vm.$set(_vm.check, "isNotSign", $$v)
                            },
                            expression: "check.isNotSign"
                          }
                        },
                        [
                          _c("el-option", {
                            key: true,
                            attrs: { label: "未签到", value: true }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            key: false,
                            attrs: { label: "已签到", value: false }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.getCheckList }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.checkList,
                    border: "",
                    "highlight-current-row": ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "realName",
                      label: "姓名",
                      width: "180",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "content",
                      label: "课程内容",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "签到时间", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return _vm._l(scope.row.signTimes, function(s, key) {
                            return _c("p", [_vm._v(_vm._s(s))])
                          })
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.check.pageNum,
                  "page-size": _vm.check.pageSize,
                  layout: "prev, pager, next, jumper",
                  total: _vm.check.total
                },
                on: {
                  "current-change": _vm.getCheckList,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.check, "pageNum", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.check, "pageNum", $event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发起签到",
            visible: _vm.dialogVisibleSign,
            width: "40%",
            "before-close": _vm.handleCloseSign,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleSign = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "sign",
              attrs: {
                model: _vm.sign,
                rules: _vm.signRules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "过期时间", prop: "expireMinute" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.sign.expireMinute,
                      callback: function($$v) {
                        _vm.$set(_vm.sign, "expireMinute", _vm._n($$v))
                      },
                      expression: "sign.expireMinute"
                    }
                  }),
                  _vm._v("分钟\n      ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisibleSign = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.signFun } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61b909ce", esExports)
  }
}

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainNameList_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainNameList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainNameList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainNameList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainNameList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcebd0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainNameList_vue__ = __webpack_require__(1477);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1457)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcebd0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainNameList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcebd0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainNameList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/trainCheck/trainNameList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3fcebd0e", Component.options)
  } else {
    hotAPI.reload("data-v-3fcebd0e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1458);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3bf6c7b6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3fcebd0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainNameList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3fcebd0e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainNameList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.table[data-v-3fcebd0e] {\n  border-left: 1px solid #EBEEF5;\n  border-top: 1px solid #EBEEF5;\n  width: 100%;\n  text-align: center;\n}\n.table thead[data-v-3fcebd0e] {\n  color: #909399;\n  font-weight: 500;\n}\n.table thead th[data-v-3fcebd0e] {\n  background: #e2e2e2 !important;\n  color: #333333 !important;\n  border-bottom: 1px solid #EBEEF5;\n  border-right: 1px solid #EBEEF5;\n  text-align: center;\n  width: 100px;\n}\n.table tr[data-v-3fcebd0e] {\n  background-color: #ffffff;\n}\n.table tr td[data-v-3fcebd0e] {\n  border-right: 1px solid #EBEEF5;\n  border-bottom: 1px solid #EBEEF5;\n}\n.el-dropdown[data-v-3fcebd0e] {\n  margin: 0 10px;\n}\n.upload-btn[data-v-3fcebd0e] {\n  position: relative;\n  margin: 0;\n  cursor: pointer;\n}\n.upload-btn.pic-upload-btn[data-v-3fcebd0e] {\n  display: inline-block;\n  text-align: center;\n  font-size: 14px;\n  color: #ffffff;\n  background-color: #2197ff !important;\n  border: 1px solid #2197ff;\n  border-radius: 2px !important;\n  padding: 0px 14px !important;\n  height: 36px !important;\n  line-height: 34px !important;\n  margin-right: 10px;\n}\n.upload-btn input[data-v-3fcebd0e] {\n  display: none;\n}\n.upload-btn .filename[data-v-3fcebd0e] {\n  word-break: break-all;\n}\n.link-text[data-v-3fcebd0e] {\n  display: inline-block;\n  margin: 3px;\n  cursor: pointer;\n  color: #409eff;\n}\n", ""]);

// exports


/***/ }),
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap" },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "客服" } },
            [_c("tjkautocompleteall", { on: { change: _vm.updateTjkId } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "参培情况" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.searchData.tjkJoin,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "tjkJoin", $$v)
                    },
                    expression: "searchData.tjkJoin"
                  }
                },
                [
                  _c("el-option", {
                    key: "noJoin",
                    attrs: { label: "未参培", value: "noJoin" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "abandonNoSay",
                    attrs: {
                      label: "中途退出（无报备）",
                      value: "abandonNoSay"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "abandonAndSay",
                    attrs: {
                      label: "中途退出（有报备）",
                      value: "abandonAndSay"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "joinComplete",
                    attrs: { label: "完整参培", value: "joinComplete" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "平台考核" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchData.platformAppraise,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "platformAppraise", $$v)
                    },
                    expression: "searchData.platformAppraise"
                  }
                },
                [
                  _c("el-option", {
                    key: "pass",
                    attrs: { label: "通过", value: "pass" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "nopass",
                    attrs: { label: "未通过", value: "nopass" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "reject",
                    attrs: { label: "拒考", value: "reject" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商家考核" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchData.merchantAppraise,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "merchantAppraise", $$v)
                    },
                    expression: "searchData.merchantAppraise"
                  }
                },
                [
                  _c("el-option", {
                    key: "pass",
                    attrs: { label: "通过", value: "pass" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "nopass",
                    attrs: { label: "未通过", value: "nopass" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "录取状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchData.enrollState,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "enrollState", $$v)
                    },
                    expression: "searchData.enrollState"
                  }
                },
                [
                  _c("el-option", {
                    key: "Yes",
                    attrs: { label: "录取", value: "Yes" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "No",
                    attrs: { label: "释放", value: "No" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    key: "None",
                    attrs: { label: "暂未处理", value: "None" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getExcel } },
                [_vm._v("下载查询结果")]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                { on: { click: _vm.doDownload, command: _vm.doDownload } },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("\n          下载"),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "51" } }, [
                        _vm._v("下载平台考核")
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "52" } }, [
                        _vm._v("下载商家考核")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("label", { staticClass: "upload-btn pic-upload-btn" }, [
                _c("span", [_vm._v("导入平台考核")]),
                _vm._v(" "),
                _c("input", {
                  ref: "referenceUpload",
                  staticClass: "file tj-btn tj-btn-blue",
                  attrs: { name: "file", type: "file", accept: ".xls,.xlsx" },
                  on: {
                    change: function($event) {
                      return _vm.importExcel($event)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "upload-btn pic-upload-btn" }, [
                _c("span", [_vm._v("导入商家考核")]),
                _vm._v(" "),
                _c("input", {
                  ref: "referenceUploadMerchant",
                  staticClass: "file tj-btn tj-btn-blue",
                  attrs: { name: "file", type: "file", accept: ".xls,.xlsx" },
                  on: {
                    change: function($event) {
                      return _vm.importMerchantExcel($event)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.enroll("Yes")
                    }
                  }
                },
                [_vm._v("录取")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.enroll("No")
                    }
                  }
                },
                [_vm._v("释放")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getTjkJoin } },
                [_vm._v("参培生成")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.tableData.length > 0
        ? _c(
            "div",
            { staticClass: "search-box" },
            [
              _c(
                "el-scrollbar",
                {
                  staticClass: "scroll-bar-x",
                  attrs: {
                    viewStyle: "display: inline-block; min-width: 100%;"
                  }
                },
                [
                  _c(
                    "children",
                    { attrs: { dataArr: _vm.headList } },
                    _vm._l(_vm.finalTableData, function(trlist, trIndex) {
                      return _c(
                        "tr",
                        { staticClass: "formcontent" },
                        [
                          _vm._l(trlist, function(item, index) {
                            return _c(
                              "td",
                              [
                                item.type == "TEXT"
                                  ? [
                                      index == 0 || index == 4
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.finalTableData[trIndex][
                                                  index
                                                ].value
                                              )
                                            )
                                          ])
                                        : [
                                            _vm.finalTableData[trIndex][index]
                                              .value != "" &&
                                            _vm.finalTableData[trIndex][index]
                                              .value != null
                                              ? [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "dark",
                                                        content:
                                                          _vm.finalTableData[
                                                            trIndex
                                                          ][index].value,
                                                        placement: "top"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "85%",
                                                          height: "40px"
                                                        },
                                                        attrs: {
                                                          editable: "false"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.finalTableData[
                                                              trIndex
                                                            ][index].value,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .finalTableData[
                                                                trIndex
                                                              ][index],
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "finalTableData[trIndex][index].value"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              : [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "85%",
                                                      height: "40px"
                                                    },
                                                    attrs: {
                                                      editable: "false"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.finalTableData[
                                                          trIndex
                                                        ][index].value,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.finalTableData[
                                                            trIndex
                                                          ][index],
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "finalTableData[trIndex][index].value"
                                                    }
                                                  })
                                                ]
                                          ]
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                item.type == "SELECT"
                                  ? [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: { filterable: "" },
                                          model: {
                                            value:
                                              _vm.finalTableData[trIndex][index]
                                                .value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.finalTableData[trIndex][
                                                  index
                                                ],
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "finalTableData[trIndex][index].value"
                                          }
                                        },
                                        _vm._l(item.fieldOptions, function(
                                          m,
                                          key
                                        ) {
                                          return _c("el-option", {
                                            key: m.value,
                                            attrs: {
                                              label: m.describe,
                                              value: m.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              trlist.length > 0
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "link-text",
                                        staticStyle: {
                                          color: "cornflowerblue",
                                          margin: "3px 3px",
                                          float: "left"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.saveTjkJoin(
                                              _vm.tableData[trIndex],
                                              _vm.finalTableData[trIndex]
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("保存")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "link-text",
                                        staticStyle: {
                                          color: "cornflowerblue",
                                          margin: "3px 3px",
                                          float: "left"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.delTjk(
                                              _vm.tableData[trIndex]
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        2
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.searchData.enroll == "Yes" ? "录取" : "释放",
            visible: _vm.dialogEnrollVisible,
            center: "",
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogEnrollVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "通知消息", "label-width": "120px" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "350px" },
                    attrs: { type: "textarea", autocomplete: "off", rows: 6 },
                    model: {
                      value: _vm.searchData.msg,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "msg", $$v)
                      },
                      expression: "searchData.msg"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              this.searchData.enroll == "Yes" && this.way == "Excel"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "录取到店铺", "label-width": "120px" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            remote: "",
                            placeholder: "请设置目标店铺",
                            "remote-method": _vm.queryShopIdByName
                          },
                          model: {
                            value: _vm.searchData.shopId,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "shopId", $$v)
                            },
                            expression: "searchData.shopId"
                          }
                        },
                        _vm._l(_vm.shopOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.shopName, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogEnrollVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.doEnroll } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fcebd0e", esExports)
  }
}

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_memberManage_vue__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_memberManage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_memberManage_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_memberManage_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_memberManage_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae05041_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_memberManage_vue__ = __webpack_require__(1481);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1479)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_memberManage_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae05041_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_memberManage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/hawkeye/memberManage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ae05041", Component.options)
  } else {
    hotAPI.reload("data-v-2ae05041", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5e9cc908", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2ae05041\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./memberManage.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2ae05041\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./memberManage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.member-container {\n  padding: 20px;\n}\n.member-container h4 {\n  margin-bottom: 10px;\n  color: #333;\n}\n", ""]);

// exports


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { staticClass: "content-container", attrs: { span: 8 } },
            [
              _c("h4", [_vm._v("手动添加")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "addForm",
                  attrs: {
                    model: _vm.addForm,
                    rules: _vm.rules,
                    "label-width": "110px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "小组名称", prop: "groupId" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.addForm.groupId,
                            callback: function($$v) {
                              _vm.$set(_vm.addForm, "groupId", $$v)
                            },
                            expression: "addForm.groupId"
                          }
                        },
                        _vm._l(_vm.groupList, function(g, idx) {
                          return _c("el-option", {
                            key: idx,
                            attrs: { label: g.name, value: g.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服", prop: "tjkId" } },
                    [
                      _c("tjkautocompleteall", {
                        on: { change: _vm.updateAddTjkId }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addMember }
                        },
                        [_vm._v("添加")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "content-container", attrs: { span: 16 } },
            [
              _c("h4", [_vm._v("成员列表")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: { model: _vm.searchForm, inline: true }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客服" } },
                    [
                      _c("tjkautocompleteall", {
                        on: { change: _vm.updateTjkId }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "小组名称" } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.searchForm.groupId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "groupId", $$v)
                                },
                                expression: "searchForm.groupId"
                              }
                            },
                            _vm._l(_vm.groupList, function(g, idx) {
                              return _c("el-option", {
                                key: idx,
                                attrs: { label: g.name, value: g.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.getList(1)
                            }
                          }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.list,
                    border: "",
                    "highlight-current-row": ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "客服", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(scope.row.tjkName) +
                                    "(" +
                                    _vm._s(scope.row.tjkNumber) +
                                    ")\n                        "
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.memberTagName,
                                      placement: "top"
                                    }
                                  },
                                  [
                                    scope.row.tjkTypeTag
                                      ? _c("img", {
                                          attrs: {
                                            src: _vm._f("tagFilter")(
                                              scope.row.tjkTypeTag
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "添加时间", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(scope.row.createTime) +
                                "\n                    "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteRow(scope.row)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                attrs: { pages: _vm.pages, pageNum: _vm.searchForm.pageNum },
                on: { getData: _vm.getList }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ae05041", esExports)
  }
}

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364ac63f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voiceExam_vue__ = __webpack_require__(1485);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1483)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364ac63f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voiceExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/hawkeye/voiceExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-364ac63f", Component.options)
  } else {
    hotAPI.reload("data-v-364ac63f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1484);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("67a5959e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-364ac63f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voiceExam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-364ac63f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voiceExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "voiceExam" } },
    [
      _c(
        "el-tabs",
        {
          staticClass: "toptab",
          model: {
            value: _vm.toptab,
            callback: function($$v) {
              _vm.toptab = $$v
            },
            expression: "toptab"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "语音客服", name: "voice" } },
            [
              _c(
                "el-steps",
                {
                  staticStyle: { margin: "20px 0" },
                  attrs: {
                    active: _vm.stepactive,
                    "finish-status": "success",
                    simple: ""
                  }
                },
                [
                  _c("el-step", {
                    attrs: { title: "功能学习" },
                    nativeOn: {
                      click: function($event) {
                        _vm.stepactive >= 2 && _vm.showStep(1)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("el-step", {
                    attrs: { title: "测试须知" },
                    nativeOn: {
                      click: function($event) {
                        _vm.stepactive >= 2 && _vm.showStep(2)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("el-step", {
                    attrs: { title: "开始测试" },
                    nativeOn: {
                      click: function($event) {
                        _vm.stepactive >= 3 && _vm.showStep(3)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("el-step", {
                    attrs: { title: "获得徽章" },
                    nativeOn: {
                      click: function($event) {
                        _vm.stepactive >= 4 && _vm.showStep(4)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.clickFlag == 1
                ? _c(
                    "div",
                    { staticClass: "js-video" },
                    [
                      _c("p", { staticClass: "red" }, [
                        _vm._v(
                          "温馨提示：语音客服必须掌握小助手的功能，请认真观看视频，学完所有功能，不要快进，否则不能正常进入下一步。"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-tabs",
                        {
                          attrs: { "tab-position": "left" },
                          on: { "tab-click": _vm.handleClick },
                          model: {
                            value: _vm.tabCurrent,
                            callback: function($$v) {
                              _vm.tabCurrent = $$v
                            },
                            expression: "tabCurrent"
                          }
                        },
                        [
                          _c("el-tab-pane", { attrs: { name: "first" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tab-slot",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v("打卡")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "video-box",
                                attrs: { id: "video-first" }
                              },
                              [
                                _c(
                                  "video",
                                  {
                                    staticClass: "video",
                                    attrs: {
                                      id: "first",
                                      src:
                                        "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/1.%E6%89%93%E5%8D%A1.mp4",
                                      controls: "controls"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  您的浏览器不支持 video 标签。\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "stoptip",
                                attrs: { id: "stoptip-first" }
                              },
                              [
                                _c("div", { staticClass: "tip" }, [
                                  _c("span", {
                                    staticClass: "el-icon-success"
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("视频学习完毕")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "restart",
                                        on: { click: _vm.restartVideo }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-refresh-left"
                                        }),
                                        _vm._v("重播")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "startstudy",
                                        on: {
                                          click: function($event) {
                                            return _vm.studyNext("#tab-second")
                                          }
                                        }
                                      },
                                      [_vm._v("继续下一步学习")]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-tab-pane", { attrs: { name: "second" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tab-slot",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v("领数据外呼111")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "video-box",
                                attrs: { id: "video-second" }
                              },
                              [
                                _c(
                                  "video",
                                  {
                                    staticClass: "video",
                                    attrs: {
                                      id: "second",
                                      src:
                                        "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/2.%E9%A2%86%E6%95%B0%E6%8D%AE%E5%A4%96%E5%91%BC.mp4",
                                      controls: "controls"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  您的浏览器不支持 video 标签。\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "stoptip",
                                attrs: { id: "stoptip-second" }
                              },
                              [
                                _c("div", { staticClass: "tip" }, [
                                  _c("span", {
                                    staticClass: "el-icon-success"
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("视频学习完毕")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "restart",
                                        on: { click: _vm.restartVideo }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-refresh-left"
                                        }),
                                        _vm._v("重播")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "startstudy",
                                        on: {
                                          click: function($event) {
                                            return _vm.studyNext("#tab-third")
                                          }
                                        }
                                      },
                                      [_vm._v("继续下一步学习")]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-tab-pane", { attrs: { name: "third" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tab-slot",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v("修改客户资料")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "video-box",
                                attrs: { id: "video-third" }
                              },
                              [
                                _c(
                                  "video",
                                  {
                                    staticClass: "video",
                                    attrs: {
                                      id: "third",
                                      src:
                                        "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/3.%E4%BF%AE%E6%94%B9%E5%AE%A2%E6%88%B7%E8%B5%84%E6%96%99.mp4",
                                      controls: "controls"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  您的浏览器不支持 video 标签。\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "stoptip",
                                attrs: { id: "stoptip-third" }
                              },
                              [
                                _c("div", { staticClass: "tip" }, [
                                  _c("span", {
                                    staticClass: "el-icon-success"
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("视频学习完毕")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "restart",
                                        on: { click: _vm.restartVideo }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-refresh-left"
                                        }),
                                        _vm._v("重播")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "startstudy",
                                        on: {
                                          click: function($event) {
                                            return _vm.studyNext("#tab-four")
                                          }
                                        }
                                      },
                                      [_vm._v("继续下一步学习")]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-tab-pane", { attrs: { name: "four" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tab-slot",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v("下载录音")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "video-box",
                                attrs: { id: "video-four" }
                              },
                              [
                                _c(
                                  "video",
                                  {
                                    staticClass: "video",
                                    attrs: {
                                      id: "four",
                                      src:
                                        "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/4.%E4%B8%8B%E8%BD%BD%E5%BD%95%E9%9F%B3.mp4",
                                      controls: "controls"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  您的浏览器不支持 video 标签。\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "stoptip",
                                attrs: { id: "stoptip-four" }
                              },
                              [
                                _c("div", { staticClass: "tip" }, [
                                  _c("span", {
                                    staticClass: "el-icon-success"
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("视频学习完毕")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "restart",
                                        on: { click: _vm.restartVideo }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-refresh-left"
                                        }),
                                        _vm._v("重播")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "startstudy",
                                        on: {
                                          click: function($event) {
                                            return _vm.studyNext("#tab-five")
                                          }
                                        }
                                      },
                                      [_vm._v("继续下一步学习")]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-tab-pane", { attrs: { name: "five" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tab-slot",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v("呼入操作")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "video-box",
                                attrs: { id: "video-five" }
                              },
                              [
                                _c(
                                  "video",
                                  {
                                    staticClass: "video",
                                    attrs: {
                                      id: "five",
                                      src:
                                        "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/5.%E5%91%BC%E5%85%A5%E6%93%8D%E4%BD%9C.mp4",
                                      controls: "controls"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  您的浏览器不支持 video 标签。\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "stoptip",
                                attrs: { id: "stoptip-five" }
                              },
                              [
                                _c("div", { staticClass: "tip" }, [
                                  _c("span", {
                                    staticClass: "el-icon-success"
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("视频学习完毕")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "restart",
                                        on: { click: _vm.restartVideo }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-refresh-left"
                                        }),
                                        _vm._v("重播")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "startstudy",
                                        on: { click: _vm.studyNextLast }
                                      },
                                      [_vm._v("进入测试须知")]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.clickFlag == 2
                ? _c(
                    "div",
                    { staticClass: "warp" },
                    [
                      _c("div", { staticClass: "box" }, [
                        _c("div", { staticClass: "title" }, [
                          _c("span", { staticClass: "dot" }),
                          _c("span", { staticClass: "dot big" }),
                          _c("span", { staticClass: "dot bigger" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("测试目的")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "dot bigger" }),
                          _c("span", { staticClass: "dot big" }),
                          _c("span", { staticClass: "dot" })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "whitebg" }, [
                          _c("p", [
                            _c("span", { staticClass: "dot big" }),
                            _vm._v("检测您是否掌握了小助手的使用方法")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", { staticClass: "dot big" }),
                            _vm._v("检测您是否符合语音客服的条件")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "whitebg flex" }, [
                          _c("div", { staticClass: "left" }, [
                            _c("p", [
                              _c("span", { staticClass: "type" }, [
                                _vm._v("设备要求")
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("必须要有耳麦")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt" }, [
                              _c("span", { staticClass: "type" }, [
                                _vm._v("测试时间")
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("9:00-17:30")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt" }, [
                              _c("span", { staticClass: "type" }, [
                                _vm._v("测试机会")
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("每人每天有一次测试机会")])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt" }, [
                              _c("span", { staticClass: "type" }, [
                                _vm._v("测试结果")
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("当天18点前会出测试结果")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _c("p", [
                              _c("span", { staticClass: "type" }, [
                                _vm._v("合格标准")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v("1、完成当天的测试外呼量（10通电话）")
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v("2、普通话良好")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("3、耳麦没有回音、杂音")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("4、话术流畅、灵活性强")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _c("span", { staticClass: "dot" }),
                          _c("span", { staticClass: "dot big" }),
                          _c("span", { staticClass: "dot bigger" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("操作说明")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "dot bigger" }),
                          _c("span", { staticClass: "dot big" }),
                          _c("span", { staticClass: "dot" })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "whitebg" }, [
                          _c("p", { staticClass: "red" }, [
                            _vm._v(
                              "温馨提示：请认真观看视频，不然你不知道接下来应该怎么做！"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "video",
                            {
                              staticClass: "video",
                              attrs: {
                                src:
                                  "http://res.study.itaojin.cn/2020-11/test-guide-1124.mp4",
                                controls: "controls"
                              }
                            },
                            [
                              _vm._v(
                                "\n                您的浏览器不支持 video 标签。\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _c("span", { staticClass: "dot" }),
                          _c("span", { staticClass: "dot big" }),
                          _c("span", { staticClass: "dot bigger" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("温馨提示")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "dot bigger" }),
                          _c("span", { staticClass: "dot big" }),
                          _c("span", { staticClass: "dot" })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "whitebg" }, [
                          _c("p", [_vm._v("系统测试时，请保持您的电话畅通；")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "如果您的耳麦有问题，我们平台的工作人员会电话联系您（为了您能顺利通过测试，请不要拒接，谢谢）；"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "电话联系不上您时，我们会在APP上的消息中私信您，或者发送系统消息通知您，请注意查看信息。"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "blue" }, [
                            _vm._v(
                              "*ps：外呼过程中，有任何的问题，可以点击小助手上的“在线沟通”，在“今日系统测试咨询群”反馈。"
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.miaoone !== 0 && _vm.stepactive == 2
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btn hui",
                              attrs: { type: "primary" }
                            },
                            [_vm._v("我已知晓(" + _vm._s(_vm.miaoone) + "s)")]
                          )
                        : _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.goNext }
                            },
                            [_vm._v("我已知晓")]
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.isShowStepOne ||
                _vm.isShowStepTwo ||
                _vm.isShowStepThird ||
                _vm.isShowStepFour) &&
              _vm.clickFlag === 3 &&
              _vm.stepactive === 3
                ? _c("div", { staticClass: "opertionbg" })
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowStepOne && _vm.clickFlag === 3 && _vm.stepactive === 3
                ? _c("div", { staticClass: "opertiontip-box" }, [
                    _c("div", { staticClass: "opertiontip" }, [
                      _c("div", { staticClass: "step-tip" }, [
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "*注意：外呼测试的时候，接听对象是机器人，必须要用这个话术，才能和机器人进行对话，否则测试不合格！（右侧有录音参考）"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tip-quan" }, [
                      _c("img", {
                        attrs: {
                          src: __webpack_require__(398)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tip-text" },
                      [
                        _c("p", [_vm._v("请认真阅读注意事项！")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.showStepTwo }
                          },
                          [_vm._v("下一步")]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowStepTwo && _vm.clickFlag === 3 && _vm.stepactive === 3
                ? _c("div", { staticClass: "opertiontip-box tip-two" }, [
                    _c("div", { staticClass: "opertiontip" }, [
                      _c("div", { staticClass: "step-tip" }, [
                        _c("audio", {
                          attrs: {
                            src:
                              "http://res.study.itaojin.cn/2020-09/luyinanli.mp3?version=0821",
                            controls: "controls"
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tip-quan" }, [
                      _c("img", {
                        attrs: {
                          src: __webpack_require__(398)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tip-text" },
                      [
                        _c("p", [_vm._v("这是一段优秀录音，请认真学习！")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.showStepThird }
                          },
                          [_vm._v("下一步")]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowStepThird && _vm.clickFlag === 3 && _vm.stepactive === 3
                ? _c("div", { staticClass: "opertiontip-box tip-third" }, [
                    _c(
                      "div",
                      { staticClass: "tip-text" },
                      [
                        _c("p", [
                          _vm._v("以下是参考话术，测试时需要使用此话术")
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.showStepFour }
                          },
                          [_vm._v("下一步")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tip-quan" }, [
                      _c("img", {
                        attrs: {
                          src: __webpack_require__(399)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "opertiontip" }, [
                      _c("div", { staticClass: "step-tip" }, [
                        _c("table", { staticClass: "huashu" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { attrs: { width: "120" } }),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "200" } }, [
                                _vm._v("步骤")
                              ]),
                              _vm._v(" "),
                              _c("th", [_vm._v("客服参考话术")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", { staticClass: "blue" }, [
                                _vm._v("开场白")
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("核对尾号，确认机主")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "您好！我是淘金平台的工作人员，请问您是手机尾号****的机主吗？"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "blue" }, [
                                _vm._v("探寻需求")
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("询问任务意向")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "今天给您致电是想做一个简单的回访，我们平台有语音客服任务、在线客服任务、标注客服任务，请问您是想做哪种类型的任务呢？"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "blue",
                                  attrs: { rowspan: "2" }
                                },
                                [_vm._v("推荐产品")]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("普通话好引导做语音")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "我听您普通话不错的，您可以考虑下做语音的任务，语音任务时薪报酬要比在线多几倍呢。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("获得徽章就可领任务")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "好的，您可以在手机APP上完成语音基础培训，获得语音上岗徽章就可以申请语音的任务。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "blue",
                                  attrs: { rowspan: "2" }
                                },
                                [_vm._v("异议处理")]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("对方想做语音")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "好的，请问您之前是有做过语音客服相关的工作吗？您可以在手机APP上完成语音基础培训，获得语音徽章就可以申请语音的任务。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("对方不想做语音")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "好的，是您那边环境不适合做语音吗？那您可以在APP上完成在线基础培训，获得相关的在线徽章就可以申请在线的任务。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "blue" }, [
                                _vm._v("结束语")
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "请尽快去APP上学习，我就不打扰您了，感谢您的接听，祝您生活愉快，再见！"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "blue",
                                  attrs: { rowspan: "11" }
                                },
                                [
                                  _vm._v("其"),
                                  _c("br"),
                                  _vm._v("他"),
                                  _c("br"),
                                  _vm._v("常"),
                                  _c("br"),
                                  _vm._v("见"),
                                  _c("br"),
                                  _vm._v("问"),
                                  _c("br"),
                                  _vm._v("题")
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("有工作，没时间")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v("好的，您以后有需要了欢迎您随时回来。")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("有工作但晚上有时间")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "您这种情况呢，我这边是建议您可以尝试做在线客服，在线任务的时间安排相对来说更自由一些。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("询问工资怎么计算")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "报酬是根据任务而定的，不同的任务，报酬也不同；常见的形式是时薪。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("培训收费吗")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "您放心，我们平台承诺大家在整个过程中都是完全免费的，不收取任何一分钱的费用。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("什么是在线客服？")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "在线客服主要是通过文字和顾客交流，跟淘宝上的客服一样的。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("什么是语音客服？")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "语音客服主要是通过电话和顾客交流，就是电话销售。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("学习课程中有问题")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "这个情况的话，您可以在APP上反馈给班主任，班主任那边可以帮您解决。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("已经上岗")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "好的，如果您执行任务中有任务问题，都可以直接反馈给主管，那我就不打扰您了，祝您生活愉快，再见！"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("是我家人注册的")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "那您知道您家人是想在我们平台做语音客服还是在线客服吗？目前是否已经上岗了呢？"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("做不好会有扣罚吗")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "这个也是视任务而定的，等申请任务之后，任务老师也会给您们提前说明扣罚的。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("我随便下载的，我不清楚你们是做什么的")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "我简单的给您介绍下我们平台，我们淘金是2015年成立，是客服外包平台，客服是在家执行任务，获得报酬，而且我们的任务大多是长期的，在家就可以在平台上获得稳定的收入，我们执行任务的时间也比较灵活，您可以用您平时的空闲时间来平台做任务。"
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowStepFour && _vm.clickFlag === 3 && _vm.stepactive === 3
                ? _c("div", { staticClass: "opertiontip-box tip-four" }, [
                    _c(
                      "div",
                      { staticClass: "tip-text" },
                      [
                        _c("p", [_vm._v("学习时间180秒后可以开始测试")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.closeStep }
                          },
                          [_vm._v("确定")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tip-quan" }, [
                      _c("img", {
                        attrs: {
                          src: __webpack_require__(399)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "opertiontip" }, [
                      _c("div", { staticClass: "step-tip" }, [
                        _vm.status == "AlreadyTheoryBadge" ||
                        _vm.status == "NoTheoryBadge"
                          ? _c("div", { staticClass: "result" }, [
                              _c(
                                "p",
                                { staticClass: "tip" },
                                [
                                  _vm._v("温馨提示："),
                                  _c("font", { attrs: { color: "red" } }, [
                                    _c("b", [
                                      _vm._v(
                                        "每天只能进行一次测试，外呼时请参考话术内容。"
                                      )
                                    ])
                                  ]),
                                  _vm._v("准备好即可开始测试，请珍惜测试机会。")
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.status == "Failed"
                          ? _c("div", { staticClass: "result" }, [
                              _c("p", { staticClass: "failtext" }, [
                                _vm._v("很遗憾，测试未通过！")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "reason" },
                                [
                                  _vm._v("未通过原因："),
                                  _c("span", {
                                    domProps: { innerHTML: _vm._s(_vm.result) }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn",
                                      staticStyle: { width: "150px" },
                                      attrs: { type: "primary" },
                                      on: { click: _vm.closeStep }
                                    },
                                    [_vm._v("确定")]
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.clickFlag == 3
                ? _c("div", { staticClass: "opertion warp" }, [
                    _c("div", { staticClass: "box" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("span", { staticClass: "dot" }),
                        _c("span", { staticClass: "dot big" }),
                        _c("span", { staticClass: "dot bigger" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("话术参考")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "dot bigger" }),
                        _c("span", { staticClass: "dot big" }),
                        _c("span", { staticClass: "dot" })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "whitebg" }, [
                        _c("div", { staticClass: "audio-box" }, [
                          _c("div", [
                            _c("span", { staticClass: "red" }, [
                              _vm._v(
                                "*注意：外呼测试的时候，接听对象是机器人，必须要用这个话术，才能和机器人进行对话，否则测试不合格！（右侧有录音参考）"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("audio", {
                            attrs: {
                              src:
                                "http://res.study.itaojin.cn/2020-09/luyinanli.mp3?version=0821",
                              controls: "controls"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "huashu" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { attrs: { width: "120" } }),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "200" } }, [
                                _vm._v("步骤")
                              ]),
                              _vm._v(" "),
                              _c("th", [_vm._v("客服参考话术")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", { staticClass: "blue" }, [
                                _vm._v("开场白")
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("核对尾号，确认机主")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "您好！我是淘金平台的工作人员，请问您是手机尾号****的机主吗？"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "blue" }, [
                                _vm._v("探寻需求")
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("询问任务意向")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "今天给您致电是想做一个简单的回访，我们平台有语音客服任务、在线客服任务、标注客服任务，请问您是想做哪种类型的任务呢？"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "blue",
                                  attrs: { rowspan: "2" }
                                },
                                [_vm._v("推荐产品")]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("普通话好引导做语音")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "我听您普通话不错的，您可以考虑下做语音的任务，语音任务时薪报酬要比在线多几倍呢。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("获得徽章就可领任务")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "好的，您可以在手机APP上完成语音基础培训，获得语音上岗徽章就可以申请语音的任务。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "blue",
                                  attrs: { rowspan: "2" }
                                },
                                [_vm._v("异议处理")]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("对方想做语音")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "好的，请问您之前是有做过语音客服相关的工作吗？您可以在手机APP上完成语音基础培训，获得语音徽章就可以申请语音的任务。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("对方不想做语音")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "好的，是您那边环境不适合做语音吗？那您可以在APP上完成在线基础培训，获得相关的在线徽章就可以申请在线的任务。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "blue" }, [
                                _vm._v("结束语")
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "请尽快去APP上学习，我就不打扰您了，感谢您的接听，祝您生活愉快，再见！"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "blue",
                                  attrs: { rowspan: "11" }
                                },
                                [
                                  _vm._v("其"),
                                  _c("br"),
                                  _vm._v("他"),
                                  _c("br"),
                                  _vm._v("常"),
                                  _c("br"),
                                  _vm._v("见"),
                                  _c("br"),
                                  _vm._v("问"),
                                  _c("br"),
                                  _vm._v("题")
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "black" }, [
                                _vm._v("有工作，没时间")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v("好的，您以后有需要了欢迎您随时回来。")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("有工作但晚上有时间")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "您这种情况呢，我这边是建议您可以尝试做在线客服，在线任务的时间安排相对来说更自由一些。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("询问工资怎么计算")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "报酬是根据任务而定的，不同的任务，报酬也不同；常见的形式是时薪。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("培训收费吗")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "您放心，我们平台承诺大家在整个过程中都是完全免费的，不收取任何一分钱的费用。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("什么是在线客服？")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "在线客服主要是通过文字和顾客交流，跟淘宝上的客服一样的。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("什么是语音客服？")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "语音客服主要是通过电话和顾客交流，就是电话销售。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("学习课程中有问题")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "这个情况的话，您可以在APP上反馈给班主任，班主任那边可以帮您解决。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("已经上岗")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "好的，如果您执行任务中有任务问题，都可以直接反馈给主管，那我就不打扰您了，祝您生活愉快，再见！"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("是我家人注册的")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "那您知道您家人是想在我们平台做语音客服还是在线客服吗？目前是否已经上岗了呢？"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("做不好会有扣罚吗")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "这个也是视任务而定的，等申请任务之后，任务老师也会给您们提前说明扣罚的。"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { staticClass: "black" }, [
                                _vm._v("我随便下载的，我不清楚你们是做什么的")
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "我简单的给您介绍下我们平台，我们淘金是2015年成立，是客服外包平台，客服是在家执行任务，获得报酬，而且我们的任务大多是长期的，在家就可以在平台上获得稳定的收入，我们执行任务的时间也比较灵活，您可以用您平时的空闲时间来平台做任务。"
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.status == "AlreadyTheoryBadge" ||
                    _vm.status == "NoTheoryBadge"
                      ? _c(
                          "div",
                          { staticClass: "result" },
                          [
                            _c(
                              "p",
                              { staticClass: "tip" },
                              [
                                _vm._v("温馨提示："),
                                _c("font", { attrs: { color: "red" } }, [
                                  _c("b", [
                                    _vm._v(
                                      "每天只能进行一次测试，外呼时请参考话术内容。"
                                    )
                                  ])
                                ]),
                                _vm._v("准备好即可开始测试，请珍惜测试机会。")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.miaotwo !== 0 && _vm.stepactive === 3
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "btn hui",
                                    attrs: { type: "primary" }
                                  },
                                  [
                                    _vm._v(
                                      "开始测试(" + _vm._s(_vm.miaotwo) + "s)"
                                    )
                                  ]
                                )
                              : _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: {
                                      type: "primary",
                                      disabled: _vm.isDisable
                                    },
                                    on: { click: _vm.startExam }
                                  },
                                  [_vm._v("开始测试")]
                                )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.status == "Failed"
                      ? _c("div", { staticClass: "result" }, [
                          _c("p", { staticClass: "failtext" }, [
                            _vm._v("很遗憾，测试未通过！")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "reason" }, [
                            _vm._v("未通过原因："),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.result) }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.retry == "true"
                            ? _c(
                                "p",
                                [
                                  _vm.miaotwo !== 0 && _vm.stepactive === 3
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "btn hui",
                                          attrs: { type: "primary" }
                                        },
                                        [
                                          _vm._v(
                                            "重新测试(" +
                                              _vm._s(_vm.miaotwo) +
                                              "s)"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          staticClass: "btn",
                                          attrs: {
                                            type: "primary",
                                            disabled: _vm.isDisable
                                          },
                                          on: { click: _vm.replyBegin }
                                        },
                                        [_vm._v("重新测试")]
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.retry == "false"
                            ? _c("p", [_vm._v("请按照上面提示进行操作！")])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.status == "Ongoing"
                      ? _c("div", [
                          _c("div", { staticClass: "on" }, [
                            _c(
                              "p",
                              {
                                staticClass: "red",
                                staticStyle: { color: "#333" }
                              },
                              [
                                _vm._v(
                                  "接下来请你打开“淘金小助手”，按照以下步骤操作："
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "red" }, [
                              _vm._v(
                                " 第一步：刷新小助手（刷新之后才会显示打卡）"
                              )
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src:
                                  "http://taojinyun.file.itaojin.cn/2021-01/f87463e52eac479d8aea0fc5d33ed085.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "red" }, [
                              _vm._v(
                                " 第二步：完成打卡（不知道如何打卡，请回顾前面的打卡视频）"
                              )
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src:
                                  "http://taojinyun.file.itaojin.cn/2021-01/8979fba4bab54e5981491ac24071a8f4"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "red" }, [
                              _vm._v(" 第三步：签入sip话机")
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src:
                                  "http://taojinyun.file.itaojin.cn/2021-01/d9e056cc1ae34590b1ccdee489056a74.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "red" }, [
                              _vm._v(" 第四步：领取数据、外呼")
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src:
                                  "http://taojinyun.file.itaojin.cn/2021-01/d4dbf3bbc0e54727b6c8c801db701e1b.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "red" }, [
                              _vm._v(
                                " 第五步：如果你耳麦有问题，系统审核员会发起远程，帮你调试耳麦，请点击确认"
                              )
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src:
                                  "http://taojinyun.file.itaojin.cn/2021-01/4c732d78177f4694a73d0e745cafd5c5.png"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "red",
                                staticStyle: { color: "#333" }
                              },
                              [_vm._v(" 外呼完成后，请等待审核结果。")]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { on: { click: _vm.getCurrentStep } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-refresh"
                                  }
                                },
                                [_vm._v("点击刷新审核结果")]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.clickFlag >= 4
                ? _c("div", { staticClass: "opertion" }, [
                    _vm.status == "Passed"
                      ? _c("div", { staticClass: "pass" }, [
                          _c("p", [_vm._v("恭喜你！")]),
                          _vm._v(" "),
                          _c("p", [_vm._v("你的测试合格了，已获得以下徽章。")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "接下来，请打开淘金云客服APP，点击培训完成语音技能提升。"
                            )
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: { src: "/tjkStudy/static/yyxr.jpg" }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              staticClass: "video-box",
              attrs: { label: "在线客服", name: "web" }
            },
            [
              _c(
                "video",
                {
                  staticClass: "video",
                  attrs: {
                    id: "web",
                    src:
                      "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D%E6%89%93%E5%8D%A1.mp4",
                    controls: "controls"
                  }
                },
                [_vm._v("\n          您的浏览器不支持 video 标签。\n        ")]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-364ac63f", esExports)
  }
}

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c80cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blankLogin_vue__ = __webpack_require__(1487);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c80cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blankLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/hawkeye/blankLogin.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b5c80cd2", Component.options)
  } else {
    hotAPI.reload("data-v-b5c80cd2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5c80cd2", esExports)
  }
}

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceTrain_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceTrain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceTrain_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceTrain_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceTrain_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4982d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voiceTrain_vue__ = __webpack_require__(1491);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1489)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f4982d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceTrain_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f4982d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voiceTrain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/hawkeye/voiceTrain.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f4982d0", Component.options)
  } else {
    hotAPI.reload("data-v-5f4982d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1490);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("46ef524a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f4982d0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voiceTrain.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f4982d0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voiceTrain.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.content-wrap[data-v-5f4982d0] {\n  padding: 20px;\n}\n.link-text[data-v-5f4982d0] {\n  display: inline-block;\n  margin: 5px;\n  cursor: pointer;\n  color: #4297ff;\n}\n", ""]);

// exports


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap" },
    [
      _vm.trainState == "Passed"
        ? _c("div", [
            _c("img", {
              staticStyle: { width: "100%" },
              attrs: { src: __webpack_require__(1492) }
            })
          ])
        : _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.list, border: "", "highlight-current-row": "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "trainTitle", label: "标题", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "trainDate", label: "培训日期", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "trainSeqName", label: "场次", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerNum",
                  label: "报名人数",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "applyState", label: "状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.applyState ? "已报名" : "未报名")
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "link-text",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                return _vm.showDetail(scope.row.trainId)
                              }
                            }
                          },
                          [_vm._v("我要报名")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "我要报名",
            visible: _vm.dialogVisible,
            width: "40%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modal",
              attrs: { model: _vm.modal, "label-width": "120px" }
            },
            [
              _c("el-form-item", { attrs: { label: "标题：" } }, [
                _vm._v(_vm._s(_vm.modal.trainTitle))
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "讲师：" } }, [
                _vm._v(_vm._s(_vm.modal.teacherName))
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "培训内容：" } }, [
                _vm._v(_vm._s(_vm.modal.trainContent))
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "引导内容：" } }, [
                _vm._v(_vm._s(_vm.modal.guideContent))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              staticStyle: { "text-align": "center", display: "block" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.modal.applyState
                ? _c("el-button", { attrs: { type: "info" } }, [
                    _vm._v("已报名")
                  ])
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.applyTrain }
                    },
                    [_vm._v("我要报名")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f4982d0", esExports)
  }
}

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/voicetrain.e5d1af1.jpg";

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wallet_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wallet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wallet_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wallet_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wallet_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1c1ac2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wallet_vue__ = __webpack_require__(1496);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1494)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a1c1ac2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wallet_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1c1ac2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/customerIframe/wallet.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a1c1ac2", Component.options)
  } else {
    hotAPI.reload("data-v-1a1c1ac2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1495);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6fd7a79e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a1c1ac2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./wallet.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a1c1ac2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./wallet.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wallet" } },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "服务月份" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "month",
                  placeholder: "选择月",
                  "value-format": "yyyy-MM-dd HH:mm:ss"
                },
                model: {
                  value: _vm.month,
                  callback: function($$v) {
                    _vm.month = $$v
                  },
                  expression: "month"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getSearch } },
                [_vm._v("查询")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabs" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 14 } }, [
                _c("div", { staticClass: "panel" }, [
                  _c("div", { staticClass: "panel-head" }, [
                    _c("h4", [_vm._v("预估报酬")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "left-con" }, [
                    _c("div", [
                      _c("p", { staticClass: "big" }, [
                        _vm._v(
                          "￥" + _vm._s(_vm.totalAmount ? _vm.totalAmount : 0)
                        )
                      ]),
                      _c("p", [_vm._v("报酬总额")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fuhao" }, [
                      _c("p", [_vm._v("=")]),
                      _c("p")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "big" }, [
                        _vm._v(
                          "￥" +
                            _vm._s(
                              _vm.basicSalaryAmount ? _vm.basicSalaryAmount : 0
                            )
                        )
                      ]),
                      _c("p", [_vm._v("任务报酬")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fuhao" }, [
                      _c("p", [_vm._v("+")]),
                      _c("p")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "big" }, [
                        _vm._v(
                          "￥" +
                            _vm._s(
                              _vm.serviceAwardAmount
                                ? _vm.serviceAwardAmount
                                : 0
                            )
                        )
                      ]),
                      _c("p", [_vm._v("奖励")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fuhao" }, [
                      _c("p", [_vm._v("-")]),
                      _c("p")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "big" }, [
                        _vm._v(
                          "￥" +
                            _vm._s(
                              _vm.servicePunishAmount
                                ? _vm.servicePunishAmount
                                : 0
                            )
                        )
                      ]),
                      _c("p", [_vm._v("扣罚")])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 10 } }, [
                _c("div", { staticClass: "panel" }, [
                  _c("div", { staticClass: "panel-head" }, [
                    _c("h4", [_vm._v("实际发放")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "right-con" }, [
                    _c("div", [
                      _c("p", { staticClass: "big" }, [
                        _vm._v(
                          "￥" +
                            _vm._s(
                              _vm.paySuccessAmount ? _vm.paySuccessAmount : 0
                            )
                        )
                      ]),
                      _c("p", [_vm._v("实发")])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", { staticClass: "big" }, [
                        _vm._v("￥" + _vm._s(_vm.tax ? _vm.tax : 0))
                      ]),
                      _c("p", [_vm._v("扣税")])
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.salaryList,
                border: "",
                "highlight-current-row": ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "serviceDate", label: "日期", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "serviceShop",
                  label: "服务店铺",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "amount", label: "金额", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n            ￥" +
                            _vm._s(scope.row.amount) +
                            "\n          "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "amountExpression",
                  label: "说明",
                  align: "center"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a1c1ac2", esExports)
  }
}

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExercise_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExercise_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExercise_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExercise_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExercise_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4224f418_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voiceExercise_vue__ = __webpack_require__(1500);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1498)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4224f418"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_voiceExercise_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4224f418_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_voiceExercise_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/mobile/voiceExercise.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4224f418", Component.options)
  } else {
    hotAPI.reload("data-v-4224f418", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1499);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("fd01ce3c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4224f418\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voiceExercise.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4224f418\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voiceExercise.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.tj-header[data-v-4224f418] {\n  display: none;\n}\n[data-v-4224f418]::-webkit-scrollbar {\n  display: none;\n}\n.wrapper[data-v-4224f418] {\n  width: 100%;\n  color: #000000;\n  display: -webkit-flex;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  background-color: #ffffff;\n  align-items: center;\n}\n.wrapper .btn[data-v-4224f418] {\n  color: #ffffff;\n  height: 36px;\n  background: linear-gradient(250deg, #3EABF9, #0A89F1);\n  border-radius: 2px;\n  font-size: 14px;\n  text-align: center;\n  line-height: 26px;\n  padding: 5px 20px;\n  font-weight: bold;\n  cursor: pointer;\n  display: inline-block;\n}\n.wrapper .box[data-v-4224f418] {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  height: auto;\n  padding: 60px 10px 10px;\n  text-align: center;\n}\n.wrapper .box .text-box[data-v-4224f418] {\n  text-align: left;\n  width: 480px;\n  margin: 10px auto 0;\n  line-height: 28px;\n}\n.wrapper .box > h3[data-v-4224f418] {\n  padding: 20px 0;\n}\n.wrapper .box .btn-box[data-v-4224f418] {\n  margin-top: 20px;\n}\n.wrapper .box .person[data-v-4224f418] {\n  background-color: #F7F7F7;\n  padding: 20px;\n}\n.wrapper .box .person > p[data-v-4224f418] {\n  text-align: left;\n  font-size: 16px;\n  padding-bottom: 10px;\n}\n.wrapper .box .person .icon[data-v-4224f418] {\n  display: flex;\n  align-items: center;\n}\n.wrapper .box .person .icon > span[data-v-4224f418] {\n  color: #000000;\n  font-weight: bold;\n  padding-left: 10px;\n}\n.wrapper .box .text[data-v-4224f418] {\n  margin: 40px 0 20px 0;\n}\n.wrapper .box .call-box[data-v-4224f418] {\n  background-color: #F7F7F7;\n  padding: 20px;\n  margin-top: 20px;\n  font-size: 16px;\n}\n.wrapper .box .call-box .time[data-v-4224f418] {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("img", {
          attrs: { src: __webpack_require__(400) }
        }),
        _vm._v(" "),
        _vm.isShowFirst
          ? [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("p", { staticClass: "btn-box" }, [
                _c("a", { staticClass: "btn", on: { click: _vm.callClick } }, [
                  _vm._v("我已知晓")
                ])
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowSecond
          ? [
              _c(
                "div",
                { staticClass: "text-box" },
                [
                  _c("h3", [_vm._v("请输入对练搭档的9位数淘金号:")]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "add",
                      staticStyle: { "margin-top": "10px" },
                      attrs: { inline: true, model: _vm.add, rules: _vm.rules }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "tjkId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "320px" },
                              attrs: {
                                filterable: "",
                                remote: "",
                                clearable: "",
                                "remote-method": _vm.querySearch,
                                placeholder: "输入对练搭档的淘金号"
                              },
                              on: { clear: _vm.onClear, change: _vm.onChange },
                              model: {
                                value: _vm.tjkName,
                                callback: function($$v) {
                                  _vm.tjkName = $$v
                                },
                                expression: "tjkName"
                              }
                            },
                            _vm._l(_vm.userList, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", [
                        !_vm.isPending
                          ? _c(
                              "a",
                              {
                                staticClass: "btn",
                                on: { click: _vm.gotoReady }
                              },
                              [_vm._v("确认")]
                            )
                          : _c("a", { staticClass: "btn" }, [_vm._v("加载中")])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowThird ? [_vm._m(2)] : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("h3", [_vm._v("对练目的：")]),
      _vm._v(" "),
      _c("p", [_vm._v("1、熟悉小助手外呼操作步骤；")]),
      _vm._v(" "),
      _c("p", [_vm._v("2、与搭档进行话术对练；")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("h3", [_vm._v("必备条件：")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "1、有对练搭档（一般老师会分组，若未分组，请自行在群内找搭档）；"
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("2、你的对练搭档也进入了语音对练；")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("h3", [_vm._v("接下来，请按照以下步骤操作：")]),
      _vm._v(" "),
      _c("p", [_vm._v("1、点击“待办任务”，并刷新小助手；")]),
      _vm._v(" "),
      _c("p", [_vm._v("2、完成打卡；")]),
      _vm._v(" "),
      _c("p", [_vm._v("3、签入SIP话机；")]),
      _vm._v(" "),
      _c("p", [_vm._v("4、领取数据；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "5、进行外呼练习，并填写客户资料（对练话术用培训考试给到的话术）；"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4224f418", esExports)
  }
}

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_861a3018_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1504);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1502)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-861a3018"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_861a3018_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/voiceScene/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-861a3018", Component.options)
  } else {
    hotAPI.reload("data-v-861a3018", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1503);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("536fdb67", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-861a3018\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-861a3018\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.priContent[data-v-861a3018] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.priContent .prictice .imgBox[data-v-861a3018] {\n  display: flex;\n  justify-content: center;\n}\n.priContent .prictice .title[data-v-861a3018] {\n  font-weight: 700;\n  font-size: 16px;\n  margin-top: 10px;\n}\n.priContent .prictice .value[data-v-861a3018] {\n  margin-top: 10px;\n  color: #80858B;\n}\n.priContent .prictice .in-block[data-v-861a3018] {\n  display: inline-block;\n  margin-right: 10px;\n}\n.priContent .prictice .konwBox[data-v-861a3018] {\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n}\n.priContent .prictice .knowBtn[data-v-861a3018] {\n  width: 150px;\n  cursor: pointer;\n  height: 40px;\n  line-height: 40px;\n  background-color: #118EF2;\n  color: #fff;\n  border-radius: 15px;\n  text-align: center;\n}\n.priContent .prictice .pricComfir[data-v-861a3018] {\n  width: 100%;\n  margin-top: 20px;\n}\n.priContent .prictice .comTitle[data-v-861a3018] {\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n.priContent .prictice .content[data-v-861a3018] {\n  display: flex;\n}\n.priContent .prictice .input .el-input__inner[data-v-861a3018] {\n  border-radius: 10px;\n  width: 320px;\n}\n.priContent .prictice .comfirmBtn[data-v-861a3018] {\n  margin-left: 15px;\n  width: 170px;\n  line-height: 40px;\n  background-color: #D3D3D3;\n  text-align: center;\n  color: #fff;\n  border-radius: 15px;\n}\n.priContent .prictice .ActiveComBtn[data-v-861a3018] {\n  background-color: #118EF2;\n  cursor: pointer;\n}\n.priContent .prictice .stOrNew[data-v-861a3018] {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.priContent .prictice .defaultBtn[data-v-861a3018] {\n  width: 120px;\n  color: #fff;\n  border-radius: 20px;\n  text-align: center;\n  line-height: 35px;\n  height: 35px;\n  cursor: pointer;\n}\n.priContent .prictice .newPrict[data-v-861a3018] {\n  background-color: #008000;\n  margin-left: 20px;\n}\n.priContent .prictice .stopPrict[data-v-861a3018] {\n  background-color: #FF0000;\n}\n.priContent .prictice .handBox[data-v-861a3018] {\n  margin-top: 50px;\n}\n", ""]);

// exports


/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "voiceScene" } },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "语音对练", name: "first" } }, [
            _c("div", { staticClass: "priContent" }, [
              _c("div", { staticClass: "prictice" }, [
                _c("div", { staticClass: "imgBox" }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(400),
                      alt: ""
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.step == "first"
                  ? _c(
                      "div",
                      [
                        _vm._l(_vm.priList, function(item, i) {
                          return _c(
                            "div",
                            { key: i },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(_vm._s(item.title) + "：")
                              ]),
                              _vm._v(" "),
                              _vm._l(item.tips, function(priItem, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class:
                                      item.title == "操作手册"
                                        ? "value in-block"
                                        : "value"
                                  },
                                  [_vm._v(_vm._s(priItem.value))]
                                )
                              }),
                              _vm._v(" "),
                              item.title == "操作手册"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "goToNewAdd",
                                      staticStyle: { color: "red" },
                                      attrs: {
                                        href:
                                          "https://tjhawkeye.oss-cn-beijing.aliyuncs.com/ts/%E5%AF%B9%E7%BB%83%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf",
                                        target: "_blank"
                                      }
                                    },
                                    [_vm._v("点击查看操作手册")]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "konwBox" }, [
                          _c(
                            "div",
                            {
                              staticClass: "knowBtn",
                              on: { click: _vm.showKnow }
                            },
                            [_vm._v("我已知晓")]
                          )
                        ])
                      ],
                      2
                    )
                  : _vm.step == "second"
                  ? _c("div", { staticClass: "pricComfir" }, [
                      _c("div", { staticClass: "comTitle" }, [
                        _vm._v(" 请输入对练搭档的9位数淘金号：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("el-input", {
                            staticClass: "input",
                            attrs: { placeholder: "请输入对练搭档的淘金号" },
                            model: {
                              value: _vm.input,
                              callback: function($$v) {
                                _vm.input = $$v
                              },
                              expression: "input"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: _vm.input
                                ? "comfirmBtn ActiveComBtn"
                                : "comfirmBtn",
                              on: { click: _vm.goToPrict }
                            },
                            [_vm._v("确定")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm.step == "handing"
                  ? _c("div", { staticClass: "handBox" }, [
                      _c("div", { staticClass: "stOrNew" }, [
                        _c(
                          "div",
                          {
                            staticClass: "stopPrict defaultBtn",
                            on: { click: _vm.stopPrict }
                          },
                          [_vm._v("停止对练")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "newPrict defaultBtn",
                            on: { click: _vm.newPrict }
                          },
                          [_vm._v("继续对练")]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "场景考核", name: "third" } },
            [
              !_vm.kaoheList.length
                ? [
                    _c("p", { staticClass: "tj-shift-notice" }, [
                      _vm._v("暂无记录")
                    ])
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "scene-box" },
                      _vm._l(_vm.kaoheList, function(l, key) {
                        return _c("div", { staticClass: "scene" }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toKaoheDetail(l.id)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "zoomImage",
                                style: _vm.style(l.imageUrl)
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass: "title",
                                    attrs: { title: l.name }
                                  },
                                  [_vm._v(_vm._s(l.name))]
                                ),
                                _vm._v(" "),
                                l.exerciseStatus == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "btn",
                                        staticStyle: {
                                          "background-color": "#FF0000"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.stopKaohePrict.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("结束考核")]
                                    )
                                  : _c("div", { staticClass: "btn" }, [
                                      _vm._v("点击进入")
                                    ])
                              ])
                            ]
                          )
                        ])
                      }),
                      0
                    )
                  ]
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("span", [
            _vm._v(
              "是否确定与" +
                _vm._s(_vm.partner.realName) +
                "(" +
                _vm._s(_vm.partner.tjkNumber) +
                ")进行语音对练?"
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.clearSchedule }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-861a3018", esExports)
  }
}

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f2e916_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teacherDetail_vue__ = __webpack_require__(1506);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f2e916_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teacherDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/voiceScene/teacherDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17f2e916", Component.options)
  } else {
    hotAPI.reload("data-v-17f2e916", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneTeacherDetail" } }, [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "btn-box" }, [
        _c("div", [
          _vm.preId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.preId)
                    }
                  }
                },
                [_vm._v("上一通练习")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.nextId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.nextId)
                    }
                  }
                },
                [_vm._v("下一通练习")]
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "header" }, [_vm._v("练习得分与建议")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content wx" },
        [
          _c("div", { staticClass: "video" }, [
            _c("span", [_vm._v("练习录音")]),
            _vm._v(" "),
            _c("audio", { attrs: { src: _vm.videoUrl, controls: "controls" } })
          ]),
          _vm._v(" "),
          _vm.effectStatus == 0
            ? [
                _c("div", { staticClass: "text-box" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", [_vm._v("练习无效")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "wuxiao" }, [
                    _vm._v(_vm._s(_vm.effectReason))
                  ])
                ])
              ]
            : _vm.effectStatus == 1
            ? [
                _c(
                  "div",
                  { staticClass: "score" },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("span", [_vm._v("练习得分")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "blue" }, [
                        _vm._v(_vm._s(_vm.gradeScore) + "分")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.gradeList, function(f, index) {
                      return _c(
                        "div",
                        { staticClass: "grade" },
                        [
                          _c("div", { staticClass: "first" }, [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(f.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "blue gradescore" }, [
                              _vm._v(_vm._s(f.gradeScore) + "分")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(f.childList, function(s, key) {
                            return _c(
                              "div",
                              { staticClass: "second" },
                              [
                                _c("div", { staticClass: "parent" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(s.name))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "red gradescore" },
                                    [_vm._v(_vm._s(s.gradeScore) + "分")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    key: key + _vm.keyData,
                                    class: {
                                      "el-icon-arrow-right": !s.isClickSecond,
                                      "el-icon-arrow-down": s.isClickSecond
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickSecond(index, key)
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _vm._l(s.childList, function(t, key) {
                                  return _c(
                                    "div",
                                    {
                                      key: key + _vm.keyData,
                                      class: {
                                        third: true,
                                        none: !s.isClickSecond
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(t.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "red gradescore" },
                                        [_vm._v(_vm._s(t.gradeScore) + "分")]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "evaluate" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.evaluateList, function(e, key) {
                      return _c("p", [
                        _c("span", { staticClass: "dot" }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(key + 1) +
                            "、" +
                            _vm._s(e) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    })
                  ],
                  2
                )
              ]
            : [_vm._m(2)]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(92) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("练习建议")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(93) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("待评分")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17f2e916", esExports)
  }
}

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82f4997a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blankLogin_vue__ = __webpack_require__(1508);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82f4997a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blankLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/voiceScene/blankLogin.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-82f4997a", Component.options)
  } else {
    hotAPI.reload("data-v-82f4997a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82f4997a", esExports)
  }
}

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d2766a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partner_vue__ = __webpack_require__(1512);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1510)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74d2766a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d2766a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/voiceScene/partner.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74d2766a", Component.options)
  } else {
    hotAPI.reload("data-v-74d2766a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1511);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4bff943a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74d2766a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partner.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74d2766a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partner.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.ivideo[data-v-74d2766a]{    background-color: #252733;\n    border-radius: 10px;\n    padding: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n.ivideo>span[data-v-74d2766a]{color: #fff;\n    width: 80px;\n}\n.topicformat[data-v-74d2766a]{display:flex;justify-content: left;\n\tborder-bottom: 10px solid #fff;padding: 10px 0;\n}\n.SpecialSymbol[data-v-74d2766a]{width: 23%;display: inline-block;\n}\n.SpecialSymboltext[data-v-74d2766a]{width: 70%;\n}\n.SpecialSymbol>span[data-v-74d2766a]{color: red;\n}\n.otherbox[data-v-74d2766a]{padding: 10px 0 !important\n}\n.text-style[data-v-74d2766a]{text-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n", ""]);

// exports


/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "partner" } }, [
    _c("div", { staticClass: "top" }, [
      _c("div", [
        _vm._v("已练习："),
        _c("span", { staticClass: "red" }, [_vm._v(_vm._s(_vm.count))]),
        _vm._v("次")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "btn-end", on: { click: _vm.endScene } }, [
        _vm._v("结束练习")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hawkeye" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.selfassessment == false
        ? _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "header" }, [_vm._v("练习得分")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("div", { staticClass: "video" }, [
                  _c("span", [_vm._v("练习录音")]),
                  _vm._v(" "),
                  _c("audio", {
                    attrs: { src: _vm.videoUrl, controls: "controls" }
                  })
                ]),
                _vm._v(" "),
                _vm.gradeState == 1
                  ? [
                      _c("p", [_vm._v("点评自己的练习")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "box otherbox" },
                        [
                          _vm._l(_vm.gradeList, function(f, index) {
                            return [
                              _vm._l(f.childList, function(s, key) {
                                return [
                                  _c("div", { staticClass: "topicformat" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "second name SpecialSymbol"
                                      },
                                      [
                                        _c("span", [_vm._v("*")]),
                                        _vm._v(_vm._s(s.name))
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "SpecialSymboltext" },
                                      _vm._l(s.childList, function(t, tkey) {
                                        return _c(
                                          "p",
                                          { staticClass: "second" },
                                          [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: t.id },
                                                model: {
                                                  value: s.checked,
                                                  callback: function($$v) {
                                                    _vm.$set(s, "checked", $$v)
                                                  },
                                                  expression: "s.checked"
                                                }
                                              },
                                              [_vm._v(_vm._s(t.name))]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                ]
                              })
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "save" }, [
                        _c("a", { on: { click: _vm.saveScore } }, [
                          _vm._v("确认自评")
                        ])
                      ])
                    ]
                  : _vm.gradeState == 2
                  ? void 0
                  : [_vm._m(1)]
              ],
              2
            )
          ])
        : _c("div", [
            _vm.complete == "yes"
              ? _c("div", [
                  _c("div", { staticClass: "bottom" }, [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.existAdvise ? "练习得分与建议" : "练习得分"
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "video ivideo" }, [
                          _c("span", [_vm._v("练习录音")]),
                          _vm._v(" "),
                          _c("audio", {
                            attrs: { src: _vm.videoUrl, controls: "controls" }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.gradeList2,
                              "span-method": _vm.objectSpanMethod,
                              "header-cell-style": _vm.rowClass,
                              border: ""
                            }
                          },
                          [
                            _c(
                              "el-table-column",
                              { attrs: { label: "练习内容", align: "center" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "parentname",
                                    width: "110",
                                    align: "center"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "name",
                                    width: "150",
                                    align: "center"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "gradeScore",
                                label: "总分",
                                width: "80",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-table-column",
                              { attrs: { label: "自评分", align: "center" } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    label: "扣分",
                                    align: "center",
                                    width: "auto"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-tooltip",
                                              { attrs: { placement: "top" } },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "text-style" },
                                                  [
                                                    scope.row.gradeScore -
                                                      scope.row.score !=
                                                    0
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "DeductPoints"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-" +
                                                                _vm._s(
                                                                  scope.row
                                                                    .gradeScore -
                                                                    scope.row
                                                                      .score
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "DeductionDetails"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              scope.row
                                                                .checkedName
                                                            ) +
                                                            ")"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: { slot: "content" },
                                                    slot: "content"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.checkedName
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1575302639
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "score",
                                    label: "得分",
                                    width: "80",
                                    align: "center"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.existAdvise
                              ? _c("el-table-column", {
                                  attrs: { label: "练习建议", align: "center" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "isred" },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.description)
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1785883823
                                  )
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
    ]),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox-bg" })
      : _vm._e(),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "iframe-box" }, [
        _c("iframe", {
          attrs: {
            src: "/customer/action/workbench/index",
            width: "100%",
            height: "100%",
            frameborder: "0"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "init" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(401) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("完成本次练习后")]),
      _vm._v(" "),
      _c("p", [_vm._v("才能给自己打分哦")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span", { staticClass: "tip" }, [_vm._v("提示")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(36) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("请先完成自评~")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74d2766a", esExports)
  }
}

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130a61a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheDetail_vue__ = __webpack_require__(1514);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130a61a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/voiceScene/kaoheDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-130a61a9", Component.options)
  } else {
    hotAPI.reload("data-v-130a61a9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneDetail" } }, [
    _c("div", { staticClass: "top" }, [
      _c("a", { staticClass: "btn-end", on: { click: _vm.endScene } }, [
        _vm._v("结束考核")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hawkeye" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "header" }, [_vm._v("考核得分与建议")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _vm.isHasData
              ? [
                  _vm.gradeState == 1
                    ? [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("p", [_vm._v("讲师正在对你的考核打分")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("预计需要3分钟，请稍等…")])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gradeState == 2
                    ? [
                        _vm.effectStatus == 0
                          ? [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("p", [_vm._v("本次考核无效")]),
                              _vm._v(" "),
                              _vm.isCurrent
                                ? _c("p", [_vm._v("你还有1次考核机会")])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", { staticClass: "wuxiao" }, [
                                _vm._v(_vm._s(_vm.effectReason))
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.effectStatus == 1
                          ? [
                              _c("div", { staticClass: "video" }, [
                                _c("span", [_vm._v("考核录音")]),
                                _vm._v(" "),
                                _c("audio", {
                                  attrs: {
                                    src: _vm.videoUrl,
                                    controls: "controls"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "score" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "title",
                                      staticStyle: {
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _c("span", [_vm._v("考核结果")]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              blue: _vm.passedStatus,
                                              red: !_vm.passedStatus
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.gradeScore) + "分"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.passedStatus
                                        ? _c(
                                            "span",
                                            {
                                              class: {
                                                blue: _vm.passedStatus,
                                                red: !_vm.passedStatus
                                              }
                                            },
                                            [_vm._v("已通过，请尽快完成结业课")]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              class: {
                                                blue: _vm.passedStatus,
                                                red: !_vm.passedStatus
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "没有通过考核，需要继续加油哦"
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.gradeList, function(f, index) {
                                    return _c(
                                      "div",
                                      { staticClass: "grade" },
                                      [
                                        _c("div", { staticClass: "first" }, [
                                          _c("span", { staticClass: "name" }, [
                                            _vm._v(_vm._s(f.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "blue gradescore" },
                                            [
                                              _vm._v(
                                                _vm._s(f.gradeScore) + "分"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(f.childList, function(s, key) {
                                          return _c(
                                            "div",
                                            { staticClass: "second" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "parent" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "name" },
                                                    [_vm._v(_vm._s(s.name))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "red gradescore"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          s.gradeScore < 0
                                                            ? s.gradeScore
                                                            : "-" +
                                                                (s.score -
                                                                  s.gradeScore)
                                                        ) + "分"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    key: key + _vm.keyData,
                                                    class: {
                                                      "el-icon-arrow-right": !s.isClickSecond,
                                                      "el-icon-arrow-down":
                                                        s.isClickSecond
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.clickSecond(
                                                          index,
                                                          key
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(s.childList, function(
                                                t,
                                                key
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: key + _vm.keyData,
                                                    class: {
                                                      third: true,
                                                      none: !s.isClickSecond
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "name" },
                                                      [_vm._v(_vm._s(t.name))]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red gradescore"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(t.gradeScore) +
                                                            "分"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "evaluate" },
                                [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _vm._l(_vm.evaluateList, function(e, key) {
                                    return _c("p", [
                                      _c("span", { staticClass: "dot" }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(key + 1) +
                                          "、" +
                                          _vm._s(e) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ]
                    : _vm._e()
                ]
              : [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("p", [_vm._v("完成本次考核后")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("讲师将为你本次的考核打分")])
                ]
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox-bg" })
      : _vm._e(),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox" }, [
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "iframe-box" }, [
        _c("iframe", {
          attrs: {
            src: "/customer/action/workbench/index",
            width: "100%",
            height: "100%",
            frameborder: "0"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(93) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(92) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("讲师建议")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(401) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span", { staticClass: "tip" }, [_vm._v("提示")]),
      _vm._v(" "),
      _c("span", { staticClass: "el-icon-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(36) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("讲师正在对你的考核打分，请耐心等待~")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-130a61a9", esExports)
  }
}

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e007e3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheTeacher_vue__ = __webpack_require__(1516);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e007e3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheTeacher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/voiceScene/kaoheTeacher.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2e007e3a", Component.options)
  } else {
    hotAPI.reload("data-v-2e007e3a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneTeacher" } }, [
    _c("div", { staticClass: "left" }, [
      _c(
        "div",
        { staticClass: "header kaohe" },
        [
          _c("span", [
            _vm._v("考核点评（"),
            _c("span", [_vm._v(_vm._s(_vm.name))]),
            _vm._v("）")
          ]),
          _vm._v(" "),
          _vm.passedStatus != null
            ? [
                _vm.passedStatus
                  ? _c("div", { staticClass: "pass" }, [
                      _c("span", [_vm._v("考核通过")])
                    ])
                  : _c(
                      "div",
                      { staticClass: "nopass" },
                      [
                        _c("span", [_vm._v("考核不通过")]),
                        _vm._v(" "),
                        _vm.showBtn
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.updateExamStatus(1)
                                    }
                                  }
                                },
                                [_vm._v("继续考核")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn red",
                                  on: {
                                    click: function($event) {
                                      return _vm.updateExamStatus(0)
                                    }
                                  }
                                },
                                [_vm._v("结束考核")]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", [_vm._v("考核状态")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c(
              "p",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 1 },
                    model: {
                      value: _vm.effectStatus,
                      callback: function($$v) {
                        _vm.effectStatus = $$v
                      },
                      expression: "effectStatus"
                    }
                  },
                  [_vm._v("有效")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 0 },
                    model: {
                      value: _vm.effectStatus,
                      callback: function($$v) {
                        _vm.effectStatus = $$v
                      },
                      expression: "effectStatus"
                    }
                  },
                  [_vm._v("无效")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.effectStatus == 0
              ? [
                  _c(
                    "p",
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "输入无效原因，显示在考核得分",
                          clearable: ""
                        },
                        model: {
                          value: _vm.effectReason,
                          callback: function($$v) {
                            _vm.effectReason = $$v
                          },
                          expression: "effectReason"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [_vm._v("例如：通话中挂断，本次考核无评分与建议")])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c("p", { staticClass: "totalScore" }, [
              _c("span", [_vm._v("考核点评")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c(
              "div",
              { staticClass: "box" },
              [
                _vm._l(_vm.gradeList, function(f, index) {
                  return [
                    _c("p", { staticClass: "name" }, [_vm._v(_vm._s(f.name))]),
                    _vm._v(" "),
                    _vm._l(f.childList, function(s, key) {
                      return [
                        _c("p", { staticClass: "second name" }, [
                          _c("span", [_vm._v("*")]),
                          _vm._v(_vm._s(s.name))
                        ]),
                        _vm._v(" "),
                        _vm._l(s.childList, function(t, tkey) {
                          return _c(
                            "p",
                            { staticClass: "second" },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: t.id },
                                  on: { change: _vm.computeTotalScore },
                                  model: {
                                    value: s.checked,
                                    callback: function($$v) {
                                      _vm.$set(s, "checked", $$v)
                                    },
                                    expression: "s.checked"
                                  }
                                },
                                [_vm._v(_vm._s(t.name))]
                              )
                            ],
                            1
                          )
                        })
                      ]
                    })
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c("p", { staticClass: "advice" }, [
              _c("span", [_vm._v("考核建议")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "btn-advice", on: { click: _vm.addEvaluate } },
                [_vm._v("添加建议")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c(
              "div",
              { staticClass: "box" },
              _vm._l(_vm.evaluateList, function(e, key) {
                return _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "输入建议", clearable: "" },
                      model: {
                        value: e.evaluate,
                        callback: function($$v) {
                          _vm.$set(e, "evaluate", $$v)
                        },
                        expression: "e.evaluate"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.delEvaluate(key)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "save" }, [
        _c("span", { staticClass: "score" }, [
          _vm._v(
            "总分：" +
              _vm._s(_vm.gradeScore ? _vm.gradeScore : _vm.totalScore) +
              "分"
          )
        ]),
        _vm._v(" "),
        _c("a", { on: { click: _vm.saveScore } }, [_vm._v("保存")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "header" }, [_vm._v("客服考核记录")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.list.length == 0
            ? _c("div", { staticClass: "kong" }, [
                _c("img", {
                  attrs: {
                    src: __webpack_require__(621)
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("该客服没有考核记录")])
              ])
            : [
                _vm._l(_vm.list, function(l, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "infinite-scroll",
                          rawName: "v-infinite-scroll",
                          value: _vm.load,
                          expression: "load"
                        }
                      ],
                      staticClass: "list",
                      attrs: { "infinite-scroll-disabled": "disabled" }
                    },
                    [
                      _c(
                        "div",
                        {
                          class: { top: true, hasborder: l.effectStatus == 1 }
                        },
                        [
                          l.recordType == "Each"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("对练")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          l.recordType == "Teacher"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("陪练")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          l.recordType == "Exam"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("考核")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "time" }, [
                            _vm._v(_vm._s(l.beginTime))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              class: {
                                score: true,
                                wuxiao: l.effectStatus == 0
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    l.effectStatus == 0
                                      ? "无效"
                                      : l.effectStatus == 1
                                      ? l.gradeScore
                                      : "待评分"
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: "/tjkStudy/kaoheTeacherDetail?id=" + l.id
                              }
                            },
                            [_c("span", { staticClass: "el-icon-arrow-right" })]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      l.effectStatus == 1
                        ? _c(
                            "ul",
                            { staticClass: "clear" },
                            _vm._l(l.gradeList, function(g, key) {
                              return _c("li", [
                                _vm._v(
                                  _vm._s(g.name) + "：" + _vm._s(g.gradeScore)
                                )
                              ])
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.loading
                  ? _c("p", { staticClass: "nomore" }, [_vm._v("加载中...")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.noMore
                  ? _c("p", { staticClass: "nomore" }, [_vm._v("没有更多了")])
                  : _vm._e()
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e007e3a", esExports)
  }
}

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c259beaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheTeacherDetail_vue__ = __webpack_require__(1518);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c259beaa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheTeacherDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/voiceScene/kaoheTeacherDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c259beaa", Component.options)
  } else {
    hotAPI.reload("data-v-c259beaa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneTeacherDetail" } }, [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "btn-box" }, [
        _c("div", [
          _vm.preId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.preId)
                    }
                  }
                },
                [_vm._v("上一通考核")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.nextId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.nextId)
                    }
                  }
                },
                [_vm._v("下一通考核")]
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "header" }, [_vm._v("考核得分与建议")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content wx" },
        [
          _c("div", { staticClass: "video" }, [
            _c("span", [_vm._v("考核录音")]),
            _vm._v(" "),
            _c("audio", { attrs: { src: _vm.videoUrl, controls: "controls" } })
          ]),
          _vm._v(" "),
          _vm.effectStatus == 0
            ? [
                _c("div", { staticClass: "text-box" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", [_vm._v("考核无效")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "wuxiao" }, [
                    _vm._v(_vm._s(_vm.effectReason))
                  ])
                ])
              ]
            : _vm.effectStatus == 1
            ? [
                _c(
                  "div",
                  { staticClass: "score" },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("span", [_vm._v("考核结果")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "blue" }, [
                        _vm._v(_vm._s(_vm.gradeScore) + "分")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.gradeList, function(f, index) {
                      return _c(
                        "div",
                        { staticClass: "grade" },
                        [
                          _c("div", { staticClass: "first" }, [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(f.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "blue gradescore" }, [
                              _vm._v(_vm._s(f.gradeScore) + "分")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(f.childList, function(s, key) {
                            return _c(
                              "div",
                              { staticClass: "second" },
                              [
                                _c("div", { staticClass: "parent" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(s.name))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "red gradescore" },
                                    [_vm._v(_vm._s(s.gradeScore) + "分")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    key: key + _vm.keyData,
                                    class: {
                                      "el-icon-arrow-right": !s.isClickSecond,
                                      "el-icon-arrow-down": s.isClickSecond
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickSecond(index, key)
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _vm._l(s.childList, function(t, key) {
                                  return _c(
                                    "div",
                                    {
                                      key: key + _vm.keyData,
                                      class: {
                                        third: true,
                                        none: !s.isClickSecond
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(t.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "red gradescore" },
                                        [_vm._v(_vm._s(t.gradeScore) + "分")]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "evaluate" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.evaluateList, function(e, key) {
                      return _c("p", [
                        _c("span", { staticClass: "dot" }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(key + 1) +
                            "、" +
                            _vm._s(e) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    })
                  ],
                  2
                )
              ]
            : [_vm._m(2)]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(92) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("考核建议")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(93) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("待评分")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c259beaa", esExports)
  }
}

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2db39f96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1522);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1520)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2db39f96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2db39f96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/newVoiceScene/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2db39f96", Component.options)
  } else {
    hotAPI.reload("data-v-2db39f96", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1521);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("32d14a08", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2db39f96\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2db39f96\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.iframe-box[data-v-2db39f96] {\n  width: 100%;\n  height: 100%;\n}\n.priContent[data-v-2db39f96] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.priContent .prictice .imgBox[data-v-2db39f96] {\n  display: flex;\n  justify-content: center;\n}\n.priContent .prictice .title[data-v-2db39f96] {\n  font-weight: 700;\n  font-size: 16px;\n  margin-top: 10px;\n}\n.priContent .prictice .value[data-v-2db39f96] {\n  margin-top: 10px;\n  color: #80858B;\n}\n.priContent .prictice .in-block[data-v-2db39f96] {\n  display: inline-block;\n  margin-right: 10px;\n}\n.priContent .prictice .konwBox[data-v-2db39f96] {\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n}\n.priContent .prictice .knowBtn[data-v-2db39f96] {\n  width: 150px;\n  cursor: pointer;\n  height: 40px;\n  line-height: 40px;\n  background-color: #118EF2;\n  color: #fff;\n  border-radius: 15px;\n  text-align: center;\n}\n.priContent .prictice .pricComfir[data-v-2db39f96] {\n  width: 100%;\n  margin-top: 20px;\n}\n.priContent .prictice .comTitle[data-v-2db39f96] {\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n.priContent .prictice .content[data-v-2db39f96] {\n  display: flex;\n}\n.priContent .prictice .input .el-input__inner[data-v-2db39f96] {\n  border-radius: 10px;\n  width: 320px;\n}\n.priContent .prictice .comfirmBtn[data-v-2db39f96] {\n  margin-left: 15px;\n  width: 170px;\n  line-height: 40px;\n  background-color: #D3D3D3;\n  text-align: center;\n  color: #fff;\n  border-radius: 15px;\n}\n.priContent .prictice .ActiveComBtn[data-v-2db39f96] {\n  background-color: #118EF2;\n  cursor: pointer;\n}\n.priContent .prictice .stOrNew[data-v-2db39f96] {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.priContent .prictice .defaultBtn[data-v-2db39f96] {\n  width: 120px;\n  color: #fff;\n  border-radius: 20px;\n  text-align: center;\n  line-height: 35px;\n  height: 35px;\n  cursor: pointer;\n}\n.priContent .prictice .newPrict[data-v-2db39f96] {\n  background-color: #008000;\n  margin-left: 20px;\n}\n.priContent .prictice .stopPrict[data-v-2db39f96] {\n  background-color: #FF0000;\n}\n.priContent .prictice .handBox[data-v-2db39f96] {\n  margin-top: 50px;\n}\n", ""]);

// exports


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "voiceScene" } },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "功能学习", name: "zero" } }, [
            _c("div", { staticClass: "iframe-box" }, [
              _c("iframe", {
                attrs: {
                  src: "/tjkStudy/hawkeye/voiceExam",
                  frameborder: "0",
                  width: "100%",
                  height: "100%"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "语音对练", name: "first" } }, [
            _c("div", { staticClass: "priContent" }, [
              _c("div", { staticClass: "prictice" }, [
                _c("div", { staticClass: "imgBox" }, [
                  _c("img", {
                    attrs: {
                      src: __webpack_require__(400),
                      alt: ""
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.step == "first"
                  ? _c(
                      "div",
                      [
                        _vm._l(_vm.priList, function(item, i) {
                          return _c(
                            "div",
                            { key: i },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(_vm._s(item.title) + "：")
                              ]),
                              _vm._v(" "),
                              _vm._l(item.tips, function(priItem, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class:
                                      item.title == "操作手册"
                                        ? "value in-block"
                                        : "value"
                                  },
                                  [_vm._v(_vm._s(priItem.value))]
                                )
                              }),
                              _vm._v(" "),
                              item.title == "操作手册"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "goToNewAdd",
                                      staticStyle: { color: "red" },
                                      attrs: {
                                        href:
                                          "https://tjhawkeye.oss-cn-beijing.aliyuncs.com/ts/%E5%AF%B9%E7%BB%83%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf",
                                        target: "_blank"
                                      }
                                    },
                                    [_vm._v("点击查看操作手册")]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "konwBox" }, [
                          _c(
                            "div",
                            {
                              staticClass: "knowBtn",
                              on: { click: _vm.showKnow }
                            },
                            [_vm._v("我已知晓")]
                          )
                        ])
                      ],
                      2
                    )
                  : _vm.step == "second"
                  ? _c("div", { staticClass: "pricComfir" }, [
                      _c("div", { staticClass: "comTitle" }, [
                        _vm._v(" 请输入对练搭档的9位数淘金号： ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("el-input", {
                            staticClass: "input",
                            attrs: { placeholder: "请输入对练搭档的淘金号" },
                            model: {
                              value: _vm.input,
                              callback: function($$v) {
                                _vm.input = $$v
                              },
                              expression: "input"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: _vm.input
                                ? "comfirmBtn ActiveComBtn"
                                : "comfirmBtn",
                              on: { click: _vm.goToPrict }
                            },
                            [_vm._v("确定")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm.step == "handing"
                  ? _c("div", { staticClass: "handBox" }, [
                      _c("div", { staticClass: "stOrNew" }, [
                        _c(
                          "div",
                          {
                            staticClass: "stopPrict defaultBtn",
                            on: { click: _vm.stopPrict }
                          },
                          [_vm._v("停止对练")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "newPrict defaultBtn",
                            on: { click: _vm.newPrict }
                          },
                          [_vm._v("继续对练")]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "场景考核", name: "third" } },
            [
              !_vm.kaoheList.length
                ? [
                    _c("p", { staticClass: "tj-shift-notice" }, [
                      _vm._v("暂无记录")
                    ])
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "scene-box" },
                      _vm._l(_vm.kaoheList, function(l, key) {
                        return _c("div", { staticClass: "scene" }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toKaoheDetail(l.id)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "zoomImage",
                                style: _vm.style(l.imageUrl)
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass: "title",
                                    attrs: { title: l.name }
                                  },
                                  [_vm._v(_vm._s(l.name))]
                                ),
                                _vm._v(" "),
                                l.exerciseStatus == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "btn",
                                        staticStyle: {
                                          "background-color": "#FF0000"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.stopKaohePrict.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("结束考核")]
                                    )
                                  : _c("div", { staticClass: "btn" }, [
                                      _vm._v("点击进入")
                                    ])
                              ])
                            ]
                          )
                        ])
                      }),
                      0
                    )
                  ]
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("span", [
            _vm._v(
              "是否确定与" +
                _vm._s(_vm.partner.realName) +
                "(" +
                _vm._s(_vm.partner.tjkNumber) +
                ")进行语音对练?"
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.clearSchedule }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2db39f96", esExports)
  }
}

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636e8117_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teacherDetail_vue__ = __webpack_require__(1524);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teacherDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_636e8117_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teacherDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/newVoiceScene/teacherDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-636e8117", Component.options)
  } else {
    hotAPI.reload("data-v-636e8117", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneTeacherDetail" } }, [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "btn-box" }, [
        _c("div", [
          _vm.preId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.preId)
                    }
                  }
                },
                [_vm._v("上一通练习")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.nextId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.nextId)
                    }
                  }
                },
                [_vm._v("下一通练习")]
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "header" }, [_vm._v("练习得分与建议")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content wx" },
        [
          _c("div", { staticClass: "video" }, [
            _c("span", [_vm._v("练习录音")]),
            _vm._v(" "),
            _c("audio", { attrs: { src: _vm.videoUrl, controls: "controls" } })
          ]),
          _vm._v(" "),
          _vm.effectStatus == 0
            ? [
                _c("div", { staticClass: "text-box" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", [_vm._v("练习无效")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "wuxiao" }, [
                    _vm._v(_vm._s(_vm.effectReason))
                  ])
                ])
              ]
            : _vm.effectStatus == 1
            ? [
                _c(
                  "div",
                  { staticClass: "score" },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("span", [_vm._v("练习得分")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "blue" }, [
                        _vm._v(_vm._s(_vm.gradeScore) + "分")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.gradeList, function(f, index) {
                      return _c(
                        "div",
                        { staticClass: "grade" },
                        [
                          _c("div", { staticClass: "first" }, [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(f.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "blue gradescore" }, [
                              _vm._v(_vm._s(f.gradeScore) + "分")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(f.childList, function(s, key) {
                            return _c(
                              "div",
                              { staticClass: "second" },
                              [
                                _c("div", { staticClass: "parent" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(s.name))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "red gradescore" },
                                    [_vm._v(_vm._s(s.gradeScore) + "分")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    key: key + _vm.keyData,
                                    class: {
                                      "el-icon-arrow-right": !s.isClickSecond,
                                      "el-icon-arrow-down": s.isClickSecond
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickSecond(index, key)
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _vm._l(s.childList, function(t, key) {
                                  return _c(
                                    "div",
                                    {
                                      key: key + _vm.keyData,
                                      class: {
                                        third: true,
                                        none: !s.isClickSecond
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(t.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "red gradescore" },
                                        [_vm._v(_vm._s(t.gradeScore) + "分")]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "evaluate" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.evaluateList, function(e, key) {
                      return _c("p", [
                        _c("span", { staticClass: "dot" }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(key + 1) +
                            "、" +
                            _vm._s(e) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    })
                  ],
                  2
                )
              ]
            : [_vm._m(2)]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(92) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("练习建议")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(93) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("待评分")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-636e8117", esExports)
  }
}

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211070e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blankLogin_vue__ = __webpack_require__(1526);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211070e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blankLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/newVoiceScene/blankLogin.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-211070e1", Component.options)
  } else {
    hotAPI.reload("data-v-211070e1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-211070e1", esExports)
  }
}

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f7864e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partner_vue__ = __webpack_require__(1530);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1528)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f7864e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partner_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f7864e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/newVoiceScene/partner.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8f7864e8", Component.options)
  } else {
    hotAPI.reload("data-v-8f7864e8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1529);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("68f85b15", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8f7864e8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partner.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8f7864e8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partner.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.record p[data-v-8f7864e8] {\n  line-height: 25px;\n}\n.record .save[data-v-8f7864e8] {\n  display: inline-block;\n  background-color: #497AF2;\n  color: #fff;\n  border-radius: 6px;\n  width: 80px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n  margin-right: 15px;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n.ivideo[data-v-8f7864e8] {\n  background-color: #252733;\n  border-radius: 10px;\n  padding: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n.ivideo > span[data-v-8f7864e8] {\n  color: #fff;\n  width: 80px;\n}\n.topicformat[data-v-8f7864e8] {\n  display: flex;\n  justify-content: left;\n  border-bottom: 10px solid #fff;\n  padding: 10px 0;\n}\n.SpecialSymbol[data-v-8f7864e8] {\n  width: 23%;\n  display: inline-block;\n}\n.SpecialSymboltext[data-v-8f7864e8] {\n  width: 70%;\n}\n.SpecialSymbol > span[data-v-8f7864e8] {\n  color: red;\n}\n.otherbox[data-v-8f7864e8] {\n  padding: 10px 0 !important;\n}\n.text-style[data-v-8f7864e8] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.DeductPoints[data-v-8f7864e8] {\n  color: red;\n  font-weight: 600;\n  width: auto;\n}\n.isblue[data-v-8f7864e8] {\n  color: #6982D6 ;\n  font-weight: 600;\n  width: auto;\n}\n.isred[data-v-8f7864e8] {\n  color: red;\n}\n.DeductionDetails[data-v-8f7864e8] {\n  color: #d3d3d3;\n}\n.addBorderStyle_4[data-v-8f7864e8] {\n  border-right: solid 2px #acb9e0 !important;\n}\n.text-style[data-v-8f7864e8] {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "partner" } }, [
    _c("div", { staticClass: "top" }, [
      _c("div", [
        _vm._v("已练习："),
        _c("span", { staticClass: "red" }, [_vm._v(_vm._s(_vm.count))]),
        _vm._v("次")
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "btn-end", on: { click: _vm.stopPrict } }, [
        _vm._v("结束练习")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hawkeye" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "header" }, [_vm._v("练习得分")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("div", { staticClass: "video" }, [
              _c("span", [_vm._v("练习录音")]),
              _vm._v(" "),
              _c("audio", {
                attrs: { src: _vm.videoUrl, controls: "controls" }
              })
            ]),
            _vm._v(" "),
            _vm.gradeState == 1
              ? [
                  _c("p", [_vm._v("点评自己的练习")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "box otherbox" },
                    [
                      _vm._l(_vm.gradeList, function(f, index) {
                        return [
                          _vm._l(f.childList, function(s, key) {
                            return [
                              _c("div", { staticClass: "topicformat" }, [
                                _c(
                                  "div",
                                  { staticClass: "second name SpecialSymbol" },
                                  [
                                    _c("span", [_vm._v("*")]),
                                    _vm._v(_vm._s(s.name))
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "SpecialSymboltext" },
                                  _vm._l(s.childList, function(t, tkey) {
                                    return _c(
                                      "p",
                                      { staticClass: "second" },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: { label: t.id },
                                            model: {
                                              value: s.checked,
                                              callback: function($$v) {
                                                _vm.$set(s, "checked", $$v)
                                              },
                                              expression: "s.checked"
                                            }
                                          },
                                          [_vm._v(_vm._s(t.name))]
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ])
                            ]
                          })
                        ]
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "save" }, [
                    _c("a", { on: { click: _vm.saveScore } }, [
                      _vm._v("确认自评")
                    ])
                  ])
                ]
              : _vm.gradeState == 2
              ? [
                  _c("div", { staticClass: "table" }, [
                    _vm.complete == "no" && _vm.Clickrecord
                      ? _c("div", [
                          _c("div", { staticClass: "bottom" }, [
                            _vm.Clickrecord
                              ? _c(
                                  "div",
                                  { staticClass: "content" },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          data: _vm.afterArry,
                                          "span-method": _vm.objectSpanMethod,
                                          "header-cell-style": _vm.rowsClass,
                                          "cell-class-name": _vm.addsClass,
                                          border: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "el-table-column",
                                          {
                                            attrs: {
                                              label: "练习内容",
                                              align: "center"
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "parentname",
                                                width: "50px",
                                                align: "center"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "name",
                                                width: "50px",
                                                align: "center"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "gradeScore",
                                            label: "总分",
                                            width: "50px",
                                            align: "center"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { staticClass: "isblue" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.gradeScore
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            514991758
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "el-table-column",
                                          {
                                            attrs: {
                                              label: "自评分",
                                              align: "center"
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "扣分",
                                                align: "center",
                                                width: "60px"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              placement: "top"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-style"
                                                              },
                                                              [
                                                                scope.row
                                                                  .gradeScore -
                                                                  scope.row
                                                                    .score !=
                                                                0
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "DeductPoints"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              scope
                                                                                .row
                                                                                .gradeScore -
                                                                                scope
                                                                                  .row
                                                                                  .score
                                                                            ) +
                                                                            "分"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "DeductionDetails"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(" +
                                                                        _vm._s(
                                                                          scope
                                                                            .row
                                                                            .selfDp
                                                                        ) +
                                                                        ")"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "content"
                                                                },
                                                                slot: "content"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .selfDp
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                3883518978
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "score",
                                                label: "得分",
                                                width: "60px",
                                                align: "center"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "isblue"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.score
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                1626580731
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "练习建议",
                                            align: "center",
                                            width: "150px"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          placement: "top"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-style"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "isred"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .description
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "content"
                                                            },
                                                            slot: "content"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .description
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            475786103
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.complete == "yes"
                      ? _c("div", [
                          _c("div", { staticClass: "bottom" }, [
                            _vm.Clickrecord == false
                              ? _c(
                                  "div",
                                  { staticClass: "content" },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          data: _vm.gradeList2,
                                          "span-method": _vm.objectSpanMethod,
                                          "header-cell-style": _vm.rowsClass,
                                          "cell-class-name": _vm.addsClass,
                                          border: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "el-table-column",
                                          {
                                            attrs: {
                                              label: "练习内容",
                                              align: "center"
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "parentname",
                                                width: "60px",
                                                align: "center"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "name",
                                                width: "60px",
                                                align: "center"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "gradeScore",
                                            label: "总分",
                                            width: "50px",
                                            align: "center"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { staticClass: "isblue" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.gradeScore
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            514991758
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "el-table-column",
                                          {
                                            attrs: {
                                              label: "自评分",
                                              align: "center"
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "扣分",
                                                align: "center",
                                                width: "60px"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              placement: "top"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-style"
                                                              },
                                                              [
                                                                scope.row
                                                                  .gradeScore -
                                                                  scope.row
                                                                    .score !=
                                                                0
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "DeductPoints"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              scope
                                                                                .row
                                                                                .gradeScore -
                                                                                scope
                                                                                  .row
                                                                                  .score
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "DeductionDetails"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(" +
                                                                        _vm._s(
                                                                          scope
                                                                            .row
                                                                            .checkedName
                                                                        ) +
                                                                        ")"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "content"
                                                                },
                                                                slot: "content"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .checkedName
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                1575302639
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "score",
                                                label: "得分",
                                                width: "80px",
                                                align: "center"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "isblue"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.score
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                1626580731
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "练习建议",
                                            align: "center",
                                            width: "150px"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          placement: "top"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-style"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "isred"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .description
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "content"
                                                            },
                                                            slot: "content"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .description
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            475786103
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Clickrecord
                              ? _c(
                                  "div",
                                  { staticClass: "content" },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          data: _vm.afterArry,
                                          "span-method": _vm.objectSpanMethod,
                                          "header-cell-style": _vm.rowsClass,
                                          "cell-class-name": _vm.addsClass,
                                          border: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "el-table-column",
                                          {
                                            attrs: {
                                              label: "练习内容",
                                              align: "center"
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "parentname",
                                                width: "50px",
                                                align: "center"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "name",
                                                width: "50px",
                                                align: "center"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "gradeScore",
                                            label: "总分",
                                            width: "50px",
                                            align: "center"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { staticClass: "isblue" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.gradeScore
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            514991758
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "el-table-column",
                                          {
                                            attrs: {
                                              label: "自评分",
                                              align: "center"
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "扣分",
                                                align: "center",
                                                width: "60px"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              placement: "top"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-style"
                                                              },
                                                              [
                                                                scope.row
                                                                  .gradeScore -
                                                                  scope.row
                                                                    .score !=
                                                                0
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "DeductPoints"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "-" +
                                                                            _vm._s(
                                                                              scope
                                                                                .row
                                                                                .gradeScore -
                                                                                scope
                                                                                  .row
                                                                                  .score
                                                                            ) +
                                                                            "分"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "DeductionDetails"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(" +
                                                                        _vm._s(
                                                                          scope
                                                                            .row
                                                                            .selfDp
                                                                        ) +
                                                                        ")"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  slot:
                                                                    "content"
                                                                },
                                                                slot: "content"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .selfDp
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                3883518978
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "score",
                                                label: "得分",
                                                width: "60px",
                                                align: "center"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "isblue"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row.score
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                1626580731
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "练习建议",
                                            align: "center",
                                            width: "150px"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          placement: "top"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-style"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "isred"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .description
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "content"
                                                            },
                                                            slot: "content"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .description
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            475786103
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e()
                  ])
                ]
              : [_vm._m(1)],
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "",
                  visible: _vm.centerDialogVisible,
                  width: "30%",
                  center: ""
                },
                on: {
                  "update:visible": function($event) {
                    _vm.centerDialogVisible = $event
                  }
                }
              },
              [
                _c("span", [_vm._v("你还有未点评的内容，还不能确认自评哦～")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.centerDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox-bg" })
      : _vm._e(),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3)
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowRecord ? _c("div", { staticClass: "confirmbox-bg" }) : _vm._e(),
    _vm._v(" "),
    _vm.isShowRecord
      ? _c("div", { staticClass: "confirmbox record" }, [
          _c("div", { staticClass: "head" }, [
            _c("span", { staticClass: "tip" }, [_vm._v("提示")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { "font-weight": "bold" },
                on: {
                  click: function($event) {
                    _vm.isShowRecord = false
                  }
                }
              },
              [_vm._v("x")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("p", [_vm._v("辛苦了，练了这么久！")]),
            _vm._v(" "),
            _c("p", [_vm._v("休息一下听听别人的录音吧，")]),
            _vm._v(" "),
            _c("p", [_vm._v("多学习才能让自己更上一层楼！")]),
            _vm._v(" "),
            _c("div", { staticClass: "save", on: { click: _vm.goRecord } }, [
              _vm._v("去听录音")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "iframe-box" }, [
        _c("iframe", {
          attrs: {
            src: "/hawkeyeVue/#/service/index",
            width: "100%",
            height: "100%",
            frameborder: "0"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "init" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(401) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("完成本次练习后")]),
      _vm._v(" "),
      _c("p", [_vm._v("才能给自己打分哦")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span", { staticClass: "tip" }, [_vm._v("提示")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(36) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("请先完成自评~")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(36) }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f7864e8", esExports)
  }
}

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d757cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheDetail_vue__ = __webpack_require__(1532);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d757cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/newVoiceScene/kaoheDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01d757cb", Component.options)
  } else {
    hotAPI.reload("data-v-01d757cb", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneDetail" } }, [
    _c("div", { staticClass: "top" }, [
      _c("a", { staticClass: "btn-end", on: { click: _vm.endScene } }, [
        _vm._v("结束考核")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hawkeye" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "header" }, [_vm._v("考核得分与建议")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _vm.isHasData
              ? [
                  _vm.gradeState == 1
                    ? [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("p", [_vm._v("讲师正在对你的考核打分")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("预计需要3分钟，请稍等…")])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.gradeState == 2
                    ? [
                        _vm.effectStatus == 0
                          ? [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("p", [_vm._v("本次考核无效")]),
                              _vm._v(" "),
                              _vm.isCurrent
                                ? _c("p", [_vm._v("你还有1次考核机会")])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("p", { staticClass: "wuxiao" }, [
                                _vm._v(_vm._s(_vm.effectReason))
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.effectStatus == 1
                          ? [
                              _c("div", { staticClass: "video" }, [
                                _c("span", [_vm._v("考核录音")]),
                                _vm._v(" "),
                                _c("audio", {
                                  attrs: {
                                    src: _vm.videoUrl,
                                    controls: "controls"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "score" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "title",
                                      staticStyle: {
                                        "justify-content": "space-between"
                                      }
                                    },
                                    [
                                      _c("div", [
                                        _c("span", [_vm._v("考核结果")]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              blue: _vm.passedStatus,
                                              red: !_vm.passedStatus
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.gradeScore) + "分"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.passedStatus
                                        ? _c(
                                            "div",
                                            {
                                              class: {
                                                blue: _vm.passedStatus,
                                                red: !_vm.passedStatus
                                              }
                                            },
                                            [_vm._v("已通过，请尽快完成结业课")]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              class: {
                                                blue: _vm.passedStatus,
                                                red: !_vm.passedStatus
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "没有通过考核，需要继续加油哦"
                                              )
                                            ]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.gradeList, function(f, index) {
                                    return _c(
                                      "div",
                                      { staticClass: "grade" },
                                      [
                                        _c("div", { staticClass: "first" }, [
                                          _c("span", { staticClass: "name" }, [
                                            _vm._v(_vm._s(f.name))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "blue gradescore" },
                                            [
                                              _vm._v(
                                                _vm._s(f.gradeScore) + "分"
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(f.childList, function(s, key) {
                                          return _c(
                                            "div",
                                            { staticClass: "second" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "parent" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "name" },
                                                    [_vm._v(_vm._s(s.name))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "red gradescore"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          s.gradeScore < 0
                                                            ? s.gradeScore
                                                            : "-" +
                                                                (s.score -
                                                                  s.gradeScore)
                                                        ) + "分"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    key: key + _vm.keyData,
                                                    class: {
                                                      "el-icon-arrow-right": !s.isClickSecond,
                                                      "el-icon-arrow-down":
                                                        s.isClickSecond
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.clickSecond(
                                                          index,
                                                          key
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(s.childList, function(
                                                t,
                                                key
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: key + _vm.keyData,
                                                    class: {
                                                      third: true,
                                                      none: !s.isClickSecond
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "name" },
                                                      [_vm._v(_vm._s(t.name))]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "red gradescore"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(t.gradeScore) +
                                                            "分"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "evaluate" },
                                [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _vm._l(_vm.evaluateList, function(e, key) {
                                    return _c("p", [
                                      _c("span", { staticClass: "dot" }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(key + 1) +
                                          "、" +
                                          _vm._s(e) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  })
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ]
                    : _vm._e()
                ]
              : [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("p", [_vm._v("完成本次考核后")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("讲师将为你本次的考核打分")])
                ]
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox-bg" })
      : _vm._e(),
    _vm._v(" "),
    _vm.gradeState == 1
      ? _c("div", { staticClass: "confirmbox" }, [
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "iframe-box" }, [
        _c("iframe", {
          attrs: {
            src: "/hawkeyeVue/#/service/index",
            width: "100%",
            height: "100%",
            frameborder: "0"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(93) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(92) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("讲师建议")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(401) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span", { staticClass: "tip" }, [_vm._v("提示")]),
      _vm._v(" "),
      _c("span", { staticClass: "el-icon-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(36) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("讲师正在对你的考核打分，请耐心等待~")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01d757cb", esExports)
  }
}

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18d24c58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheTeacher_vue__ = __webpack_require__(1534);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacher_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18d24c58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheTeacher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/newVoiceScene/kaoheTeacher.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-18d24c58", Component.options)
  } else {
    hotAPI.reload("data-v-18d24c58", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneTeacher" } }, [
    _vm.scriptTitle
      ? _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "header" }, [
            _vm._v("营销场景:" + _vm._s(_vm.scriptTitle))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "kong" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "16px",
                    margin: "20px 0px 0px 10px",
                    "background-color": "#F2F2F2",
                    "min-height": "170px",
                    padding: "10px 20px 10px 20px"
                  }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.scriptObj.intro))])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "16px",
                    margin: "10px 0px 0px 10px",
                    "background-color": "#F2F2F2",
                    "min-height": "170px",
                    padding: "10px 20px 10px 20px"
                  }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { "font-size": "14px" },
                    domProps: { innerHTML: _vm._s(_vm.scriptObj.script) }
                  })
                ]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "left" }, [
      _c(
        "div",
        { staticClass: "header kaohe" },
        [
          _c("span", [
            _vm._v(
              "考核点评" +
                _vm._s(
                  _vm.scriptTitle
                    ? "（" + _vm.scriptTitle + "）"
                    : "（" + _vm.name + "）"
                )
            )
          ]),
          _vm._v(" "),
          _vm.passedStatus != null
            ? [
                _vm.passedStatus
                  ? _c("div", { staticClass: "pass" }, [
                      _c("span", [_vm._v("考核通过")])
                    ])
                  : _c(
                      "div",
                      { staticClass: "nopass" },
                      [
                        _c("span", [_vm._v("考核不通过")]),
                        _vm._v(" "),
                        _vm.showBtn
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.updateExamStatus(1)
                                    }
                                  }
                                },
                                [_vm._v("继续考核")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn red",
                                  on: {
                                    click: function($event) {
                                      return _vm.updateExamStatus(0)
                                    }
                                  }
                                },
                                [_vm._v("结束考核")]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", [_vm._v("考核状态")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c(
              "p",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 1 },
                    model: {
                      value: _vm.effectStatus,
                      callback: function($$v) {
                        _vm.effectStatus = $$v
                      },
                      expression: "effectStatus"
                    }
                  },
                  [_vm._v("有效")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 0 },
                    model: {
                      value: _vm.effectStatus,
                      callback: function($$v) {
                        _vm.effectStatus = $$v
                      },
                      expression: "effectStatus"
                    }
                  },
                  [_vm._v("无效")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.effectStatus == 0
              ? [
                  _c(
                    "p",
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "输入无效原因，显示在考核得分",
                          clearable: ""
                        },
                        model: {
                          value: _vm.effectReason,
                          callback: function($$v) {
                            _vm.effectReason = $$v
                          },
                          expression: "effectReason"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [_vm._v("例如：通话中挂断，本次考核无评分与建议")])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c("p", { staticClass: "totalScore" }, [
              _c("span", [_vm._v("考核点评")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c(
              "div",
              { staticClass: "box" },
              [
                _vm._l(_vm.gradeList, function(f, index) {
                  return [
                    _c("p", { staticClass: "name" }, [_vm._v(_vm._s(f.name))]),
                    _vm._v(" "),
                    _vm._l(f.childList, function(s, key) {
                      return [
                        _c("p", { staticClass: "second name" }, [
                          _c("span", [_vm._v("*")]),
                          _vm._v(_vm._s(s.name))
                        ]),
                        _vm._v(" "),
                        _vm._l(s.childList, function(t, tkey) {
                          return _c(
                            "p",
                            { staticClass: "second" },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: t.id },
                                  on: { change: _vm.computeTotalScore },
                                  model: {
                                    value: s.checked,
                                    callback: function($$v) {
                                      _vm.$set(s, "checked", $$v)
                                    },
                                    expression: "s.checked"
                                  }
                                },
                                [_vm._v(_vm._s(t.name))]
                              )
                            ],
                            1
                          )
                        })
                      ]
                    })
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c("p", { staticClass: "advice" }, [
              _c("span", [_vm._v("考核建议")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "btn-advice", on: { click: _vm.addEvaluate } },
                [_vm._v("添加建议")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c(
              "div",
              { staticClass: "box" },
              _vm._l(_vm.evaluateList, function(e, key) {
                return _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "输入建议", clearable: "" },
                      model: {
                        value: e.evaluate,
                        callback: function($$v) {
                          _vm.$set(e, "evaluate", $$v)
                        },
                        expression: "e.evaluate"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.delEvaluate(key)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "save" }, [
        _c("span", { staticClass: "score" }, [
          _vm._v(
            "总分：" +
              _vm._s(_vm.gradeScore ? _vm.gradeScore : _vm.totalScore) +
              "分"
          )
        ]),
        _vm._v(" "),
        _c("a", { on: { click: _vm.saveScore } }, [_vm._v("保存")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "header" }, [_vm._v("客服考核记录")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.list.length == 0
            ? _c("div", { staticClass: "kong" }, [
                _c("img", {
                  attrs: {
                    src: __webpack_require__(621)
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("该客服没有考核记录")])
              ])
            : [
                _vm._l(_vm.list, function(l, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "infinite-scroll",
                          rawName: "v-infinite-scroll",
                          value: _vm.load,
                          expression: "load"
                        }
                      ],
                      staticClass: "list",
                      attrs: { "infinite-scroll-disabled": "disabled" }
                    },
                    [
                      _c(
                        "div",
                        {
                          class: { top: true, hasborder: l.effectStatus == 1 }
                        },
                        [
                          l.recordType == "Each"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("对练")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          l.recordType == "Teacher"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("陪练")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          l.recordType == "Exam"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("考核")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "time" }, [
                            _vm._v(_vm._s(l.beginTime))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              class: {
                                score: true,
                                wuxiao: l.effectStatus == 0
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    l.effectStatus == 0
                                      ? "无效"
                                      : l.effectStatus == 1
                                      ? l.gradeScore
                                      : "待评分"
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href:
                                  "/tjkStudy/newKaoheTeacherDetail?id=" + l.id
                              }
                            },
                            [_c("span", { staticClass: "el-icon-arrow-right" })]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      l.effectStatus == 1
                        ? _c(
                            "ul",
                            { staticClass: "clear" },
                            _vm._l(l.gradeList, function(g, key) {
                              return _c("li", [
                                _vm._v(
                                  _vm._s(g.name) + "：" + _vm._s(g.gradeScore)
                                )
                              ])
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.loading
                  ? _c("p", { staticClass: "nomore" }, [_vm._v("加载中...")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.noMore
                  ? _c("p", { staticClass: "nomore" }, [_vm._v("没有更多了")])
                  : _vm._e()
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("项目介绍")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("参考话术")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18d24c58", esExports)
  }
}

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e53f6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheTeacherDetail_vue__ = __webpack_require__(1536);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kaoheTeacherDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e53f6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kaoheTeacherDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/newVoiceScene/kaoheTeacherDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40e53f6e", Component.options)
  } else {
    hotAPI.reload("data-v-40e53f6e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneTeacherDetail" } }, [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "btn-box" }, [
        _c("div", [
          _vm.preId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.preId)
                    }
                  }
                },
                [_vm._v("考核")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.nextId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.nextId)
                    }
                  }
                },
                [_vm._v("下一通考核")]
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "header" }, [_vm._v("考核得分与建议")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content wx" },
        [
          _c("div", { staticClass: "video" }, [
            _c("span", [_vm._v("考核录音")]),
            _vm._v(" "),
            _c("audio", { attrs: { src: _vm.videoUrl, controls: "controls" } })
          ]),
          _vm._v(" "),
          _vm.effectStatus == 0
            ? [
                _c("div", { staticClass: "text-box" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", [_vm._v("考核无效")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "wuxiao" }, [
                    _vm._v(_vm._s(_vm.effectReason))
                  ])
                ])
              ]
            : _vm.effectStatus == 1
            ? [
                _c(
                  "div",
                  { staticClass: "score" },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("span", [_vm._v("考核结果")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "blue" }, [
                        _vm._v(_vm._s(_vm.gradeScore) + "分")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.gradeList, function(f, index) {
                      return _c(
                        "div",
                        { staticClass: "grade" },
                        [
                          _c("div", { staticClass: "first" }, [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(f.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "blue gradescore" }, [
                              _vm._v(_vm._s(f.gradeScore) + "分")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(f.childList, function(s, key) {
                            return _c(
                              "div",
                              { staticClass: "second" },
                              [
                                _c("div", { staticClass: "parent" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(s.name))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "red gradescore" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          s.gradeScore < 0
                                            ? s.gradeScore
                                            : "-" + (s.score - s.gradeScore)
                                        ) + "分"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    key: key + _vm.keyData,
                                    class: {
                                      "el-icon-arrow-right": !s.isClickSecond,
                                      "el-icon-arrow-down": s.isClickSecond
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickSecond(index, key)
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _vm._l(s.childList, function(t, key) {
                                  return _c(
                                    "div",
                                    {
                                      key: key + _vm.keyData,
                                      class: {
                                        third: true,
                                        none: !s.isClickSecond
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(t.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "red gradescore" },
                                        [_vm._v(_vm._s(t.gradeScore) + "分")]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "evaluate" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.evaluateList, function(e, key) {
                      return _c("p", [
                        _c("span", { staticClass: "dot" }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(key + 1) +
                            "、" +
                            _vm._s(e) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    })
                  ],
                  2
                )
              ]
            : [_vm._m(2)]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: __webpack_require__(92) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("考核建议")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("p", [
        _c("img", {
          attrs: { src: __webpack_require__(93) }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("待评分")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40e53f6e", esExports)
  }
}

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f6cec53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blankLogin_vue__ = __webpack_require__(1538);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blankLogin_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f6cec53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blankLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/blankLogin.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f6cec53", Component.options)
  } else {
    hotAPI.reload("data-v-5f6cec53", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f6cec53", esExports)
  }
}

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4df7638_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1552);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1540)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4df7638"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4df7638_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e4df7638", Component.options)
  } else {
    hotAPI.reload("data-v-e4df7638", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7bc49bce", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e4df7638\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e4df7638\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(177);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.description[data-v-e4df7638] {\n  padding-bottom: 10px;\n}\n.scene .box[data-v-e4df7638] {\n  position: relative;\n}\n.box .text[data-v-e4df7638] {\n  width: 100%;\n}\n.test-button[data-v-e4df7638] {\n  position: absolute;\n  margin-top: 10px;\n  z-index: 999;\n  bottom: 20px;\n}\n.isred[data-v-e4df7638] {\n  color: #E53434;\n  margin-right: 10px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #E53434;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #FBE5E5;\n  line-height: 16px;\n  height: 18px;\n}\n.isgreen[data-v-e4df7638] {\n  color: #14C034;\n  margin-right: 10px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #39CA54;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #D9F4DE;\n  line-height: 16px;\n  height: 18px;\n}\n.isposition[data-v-e4df7638] {\n  position: absolute;\n  right: 20px;\n  top: 5px;\n}\n.istext[data-v-e4df7638] {\n  width: 90%;\n}\n.Signinstyle[data-v-e4df7638] {\n  align-self: flex-end;\n  display: inline-block;\n  font-size: 16px;\n  margin-left: 20px;\n}\n.Signinblue[data-v-e4df7638] {\n  color: #4a7bea;\n  font-weight: 600;\n}\n.Signingreen[data-v-e4df7638] {\n  color: #5dc998;\n  font-weight: 600;\n}\n.train-list[data-v-e4df7638] {\n  position: relative;\n}\n.buttonst[data-v-e4df7638] {\n  background: #5dc998 !important;\n}\n.buttonsb[data-v-e4df7638] {\n  background: #4a7bea !important;\n}\n.Sign_in[data-v-e4df7638] {\n  color: #4978fb;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.noSign_in[data-v-e4df7638] {\n  color: #53cb95;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.isnoSign_in[data-v-e4df7638] {\n  color: #53cb95;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.Training_failed[data-v-e4df7638] {\n  color: red;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.Invalid[data-v-e4df7638] {\n  color: red;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.train-list_position[data-v-e4df7638] {\n  position: relative;\n}\n.train-list_position .title[data-v-e4df7638] {\n  font-size: 18px !important;\n}\n.Entry_training[data-v-e4df7638] {\n  background: #5dc998 !important;\n}\n.button_box[data-v-e4df7638] {\n  margin-top: 30px !important;\n}\n.button_box > span[data-v-e4df7638] {\n  font-size: 16px;\n  line-height: 35px !important;\n  height: 37px !important;\n}\n.title_style[data-v-e4df7638] {\n  font-size: 16px;\n  font-weight: 600;\n}\n.Badge_result_page[data-v-e4df7638] {\n  text-align: center;\n}\n.img_style[data-v-e4df7638] {\n  width: 50%;\n}\n.result-txt[data-v-e4df7638] {\n  font-size: 18px;\n  color: #000;\n  text-align: center;\n}\n.content_style[data-v-e4df7638] {\n  color: #000;\n  font-size: 18px;\n  text-align: center;\n}\n.button_primary[data-v-e4df7638] {\n  text-align: center;\n  margin-top: 50px;\n}\n.button_again[data-v-e4df7638] {\n  background-color: #d3d5d7 !important;\n  color: #898a8c !important;\n}\n.colorstylr[data-v-e4df7638] {\n  margin-right: 10px;\n}\n.button_box_true > span[data-v-e4df7638] {\n  margin-left: 50%;\n  transform: translateX(-50%);\n}\n[data-v-e4df7638] .el-dialog__footer {\n  padding: 10px 20px 10px 20px;\n}\n[data-v-e4df7638] .el-dialog {\n  border-radius: 10px;\n}\n.systemPopup[data-v-e4df7638] .el-dialog {\n  width: 21% !important;\n}\n.systemPopup[data-v-e4df7638] .el-dialog__header {\n  padding: 5px 20px 5px 10px;\n}\n.dimensionalimg_text[data-v-e4df7638] {\n  text-align: center;\n  font-weight: 600px;\n  margin-top: 10px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n}\n.dimensionalimg_Line[data-v-e4df7638] {\n  width: 100%;\n  background: #F4F4F5;\n  height: 2px;\n}\n.dimensionalimg_box[data-v-e4df7638] .el-dialog--center .el-dialog__body {\n  padding: 25px 0px 30px;\n}\n.dimensionalimg_box[data-v-e4df7638] .el-dialog__footer {\n  padding: 10px 20px 23px 20px;\n}\n[data-v-e4df7638] .el-tabs__nav-wrap::after {\n  background: #fff;\n}\n[data-v-e4df7638] .el-icon-house {\n  margin-right: 6px;\n}\n[data-v-e4df7638] .el-icon-message {\n  margin-right: 6px;\n}\n.el-tabs__active-bar[data-v-e4df7638] {\n  width: 124px;\n}\n.tabBox[data-v-e4df7638] {\n  margin-top: 14px;\n  margin-left: 20px;\n  margin-right: 20px;\n  padding-bottom: 14px;\n  display: flex;\n  background: #F5F6F7;\n}\n.index_tabBox[data-v-e4df7638] {\n  color: #497AF2;\n  font-weight: 550;\n  border: 1px solid #1684FC;\n  border-right: 0px;\n  text-align: center;\n  padding: 3px 21px;\n  background: #fff;\n  font-size: 14px;\n  cursor: pointer;\n}\n.index_tabBox_left[data-v-e4df7638] {\n  color: #497AF2;\n  font-weight: 550;\n  border: 1px solid #1684FC;\n  text-align: center;\n  padding: 3px 21px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.index_tabBox_after[data-v-e4df7638] {\n  color: #fff !important;\n  background: #497AF2;\n}\n.right_listleft[data-v-e4df7638] {\n  font-size: 17px;\n  color: #000;\n  font-weight: 600;\n}\n.right_listleft > .pass[data-v-e4df7638] {\n  margin-left: 10px;\n  color: #6cc080;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #6cc080;\n  border-radius: 5px;\n  background: #d3f6d3;\n}\n.right_listleft > .failed[data-v-e4df7638] {\n  margin-left: 10px;\n  color: #e15062;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #e15062;\n  border-radius: 5px;\n  background: #ffe3e2;\n}\n.right_listright[data-v-e4df7638] {\n  background: #1684fc;\n  color: #fff;\n  padding: 5px 20px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n.right_under[data-v-e4df7638] {\n  background: #f6f5f8;\n  padding: 10px 20px;\n  margin-top: 10px;\n  border-radius: 5px;\n  font-size: 13px;\n}\n.right_under > div[data-v-e4df7638] {\n  overflow: hidden;\n  height: 60px;\n}\n.content[data-v-e4df7638] {\n  display: block !important;\n}\n.right-top[data-v-e4df7638] {\n  display: flex;\n  justify-content: space-between;\n}\n.circle[data-v-e4df7638] {\n  width: 20px;\n  height: 20px;\n  background: #497AF2;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  top: 65px;\n  left: 10px;\n  color: #fff;\n  line-height: 20px;\n}\n.boxstyle[data-v-e4df7638] {\n  width: 100% !important;\n}\n.boxstyle > .title[data-v-e4df7638] {\n  justify-content: left !important;\n}\n.isposition[data-v-e4df7638] .el-button--small {\n  border-radius: 6px;\n  height: 31px;\n  line-height: 10px;\n  letter-spacing: 1px;\n  width: 101px;\n  text-align: center;\n  padding: 5px 20px;\n  font-size: 14px;\n}\n.isposition[data-v-e4df7638] .el-button--small > span {\n  letter-spacing: 1px;\n}\n.textstyle[data-v-e4df7638] {\n  margin-top: 10px;\n  background: #f5f6f7;\n  border-radius: 5px;\n  padding: 20px;\n  font-size: 13px;\n  overflow: hidden;\n  height: auto !important;\n}\n.lock[data-v-e4df7638] {\n  background: url(" + escape(__webpack_require__(178)) + ") no-repeat center;\n  background-size: cover;\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  right: 20px;\n}\n.otherline[data-v-e4df7638] {\n  width: 2px;\n  top: 85px;\n  bottom: -20px;\n  left: 29px;\n  position: absolute;\n  border-color: inherit;\n  background-color: #BBBBBB;\n  z-index: 99;\n}\n.othercircle[data-v-e4df7638] {\n  width: 20px;\n  height: 20px;\n  background: #BBBBBB;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  top: 65px;\n  line-height: 20px;\n  color: #fff;\n}\n.RegistrationSessions[data-v-e4df7638] {\n  background: #fff;\n  border-radius: 10px;\n  width: 100%;\n  margin-bottom: 20px;\n  padding: 0px 0 20px 0;\n  position: relative;\n  overflow: hidden;\n}\n.RegistrationSessions .label[data-v-e4df7638] {\n  background: #497AF2;\n  display: inline-block;\n  color: #fff;\n  border-radius: 10px 0px 10px 0px;\n  width: 100px;\n  height: 34px;\n  font-size: 16px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  line-height: 35px;\n  text-align: center;\n}\n.text_box[data-v-e4df7638] {\n  padding: 0 20px;\n}\n.title_state_button[data-v-e4df7638] {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n.title_state[data-v-e4df7638] {\n  font-size: 20px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n  display: flex;\n}\n.Reg_button[data-v-e4df7638] {\n  background: #497AF2;\n  color: #fff;\n  padding: 5px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  letter-spacing: 1px;\n}\n.special_button[data-v-e4df7638] {\n  background: #14C034;\n}\n/*直播模式：已签到文案（卡片右上角）*/\n.live_signed_badge[data-v-e4df7638] {\n  position: absolute;\n  top: 16px;\n  right: 20px;\n  color: #14C034;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  line-height: 20px;\n}\n/*直播模式：操作按钮行（卡片右下角）*/\n.live_btns[data-v-e4df7638] {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n.Reg_isred[data-v-e4df7638] {\n  color: #E53434;\n  margin-right: 9px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  margin-left: 9px;\n  margin-top: 6px;\n  height: 23px;\n  background: #FBE5E5;\n  border: 1px solid #E53434;\n  border-radius: 4px;\n  height: 18px;\n  line-height: 15px;\n}\n.Reg_isgreen[data-v-e4df7638] {\n  color: #14C034;\n  margin-right: 9px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #39CA54;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 6px;\n  background: #D9F4DE;\n  height: 18px;\n  line-height: 15px;\n}\n.Reg_date[data-v-e4df7638],\n.Reg_time[data-v-e4df7638],\n.Reg_lecturer[data-v-e4df7638] {\n  color: #262626;\n  font-size: 14px;\n  margin-bottom: 5px;\n}\n.Reg_time[data-v-e4df7638] {\n  width: 500px;\n}\n.Reg_qq[data-v-e4df7638] {\n  color: #262626;\n  font-size: 14px;\n}\n.Reg_content[data-v-e4df7638] {\n  margin-top: 12px;\n  background: #f5f6f7;\n  padding: 20px;\n}\n.index_tabbox_0[data-v-e4df7638] {\n  border-radius: 4px 0px 0px 4px;\n}\n.index_tabbox_last[data-v-e4df7638] {\n  border-radius: 0px 4px 4px 0px;\n  color: #497AF2;\n  font-weight: 550;\n  border: 1px solid #1684FC;\n  border-left: 0;\n  text-align: center;\n  padding: 3px 21px;\n  font-size: 14px;\n  cursor: pointer;\n}\n[data-v-e4df7638] .el-tabs__header {\n  margin: 0px !important;\n  padding-left: 20px !important;\n}\n.dialog_img[data-v-e4df7638] {\n  width: 85px;\n  height: 64px;\n  margin: 0 auto;\n}\n.dialog_img > img[data-v-e4df7638] {\n  width: 360px;\n  height: 100%;\n}\n.qq_text[data-v-e4df7638] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n  text-align: center;\n  margin-top: 14px;\n}\n.currency_button[data-v-e4df7638] {\n  display: flex;\n  justify-content: center;\n}\n.determine[data-v-e4df7638] {\n  width: 80px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.cancel[data-v-e4df7638] {\n  width: 80px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #717171;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n[data-v-e4df7638] .el-dialog--center .el-dialog__body {\n  padding: 18px 0 0 0;\n}\n.cel-button[data-v-e4df7638] {\n  margin: 0 auto;\n  width: 100px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  margin-top: 30px;\n  margin-bottom: 20px;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.fail_img[data-v-e4df7638] {\n  font-size: 14px;\n  color: #EE3F3F;\n  font-weight: 500;\n  display: flex;\n  position: absolute;\n  right: 20px;\n  top: 80px;\n}\n.fail_img > img[data-v-e4df7638] {\n  margin-right: 6px;\n}\n.Reg_button_isqian[data-v-e4df7638] {\n  width: 100px;\n  height: 28px;\n  background: #DBE5FF;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: bold;\n  color: #497AF2;\n  text-align: center;\n  line-height: 28px;\n}\n.Reg_button_noqian[data-v-e4df7638] {\n  width: 100px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #ABABAB;\n  text-align: center;\n  line-height: 28px;\n}\n.thespan[data-v-e4df7638] {\n  color: #E53434;\n}\n.typingCertification[data-v-e4df7638] {\n  background: #FFFFFF;\n  border-radius: 10px;\n  padding: 19px 20px 21px 0;\n}\n.typing_top[data-v-e4df7638] {\n  display: flex;\n}\n.typing_title[data-v-e4df7638] {\n  font-size: 16px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n  line-height: 24px;\n  margin-left: 19px;\n  margin-bottom: 19px;\n}\n.typing_state[data-v-e4df7638] {\n  color: #E53434;\n  margin-right: 10px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #E53434;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #FBE5E5;\n  line-height: 16px;\n  height: 18px;\n}\n.typing_bottom[data-v-e4df7638] {\n  background: #F5F6F7;\n  padding: 20px 110px 20px 20px;\n  margin-left: 20px;\n}\n.top_line[data-v-e4df7638] {\n  position: absolute;\n  top: 0;\n  left: 29px;\n  width: 2px;\n  height: 65px;\n}\n.top_isCheck[data-v-e4df7638] {\n  background: #1684fc;\n}\n.top_noCheck[data-v-e4df7638] {\n  background: #BBBBBB;\n}\n.other-list[data-v-e4df7638] {\n  height: auto !important;\n}\n.Lvone_tab[data-v-e4df7638] {\n  margin: 13px 19px 0 19px;\n  display: flex;\n}\n.Onetabtext[data-v-e4df7638] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  margin-right: 39px;\n  padding-bottom: 13px;\n  cursor: pointer;\n}\n.Onetabtext_1[data-v-e4df7638] {\n  color: #497AF2;\n  border-bottom: 2px solid #497AF2;\n}\n.index_tabbox_fristss[data-v-e4df7638] {\n  border: 1px solid #497AF2;\n  border-radius: 4px;\n}\n", ""]);

// exports


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2750299b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fe166578\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voice.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fe166578\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./voice.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.positionimgbox[data-v-fe166578]{text-align: left !important;\n}\n.tip-quan_positionimg[data-v-fe166578]{margin-left: 250px;\n}\n.password>p[data-v-fe166578]{font-size: 20px !important; color:red; font-weight:normal !important;\n    padding-bottom: 0px !important;\n}\n.otheropertion[data-v-fe166578]{padding-top: 139px !important;\n}\n.button_box[data-v-fe166578]{margin-top: 50px;display: flex;justify-content:center;\n}\n.button_box1[data-v-fe166578]{padding-right: 5%;\n}\n.button_box2[data-v-fe166578]{padding-left: 5%;\n}\n.other_button_box1[data-v-fe166578]{padding-right:0\n}\n[data-v-fe166578] .el-button--primary {font-size: 16px !important;\n}\n[data-v-fe166578] .el-button {border-radius: 20px;\n}\n.to_finish[data-v-fe166578]{display: inline-block;\n  font-size: 16px;\n    \n    background-color:#d3d5d7;\n    width: 127px;\n    height: 42px;\n    height: 36px;\n    border-radius: 18px;\n    color: #898a8c;\n    text-align: center;\n    line-height: 36px;\n    cursor: pointer;\n}\n.relearn_button[data-v-fe166578]{display: inline-block;\n  font-size: 16px;\n   background-color: #497AF2;\n    width: 127px;\n    height: 42px;\n    height: 36px;\n    border-radius: 18px;\n    color: #fff;\n    text-align: center;\n    line-height: 36px;\n    cursor: pointer;\n}\n.button_box[data-v-fe166578] {margin-top: 30px !important;\n}\n.button_box > span[data-v-fe166578] {font-size: 16px;\n    line-height: 35px !important;height: 37px !important;\n}\n.otheropertion .btn-box[data-v-fe166578]{width: 30%;\n}\n", ""]);

// exports


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "voiceExam" } },
    [
      _c(
        "el-steps",
        {
          staticStyle: { margin: "20px 0" },
          attrs: {
            active: _vm.stepactive,
            "finish-status": "success",
            simple: ""
          }
        },
        [
          _c("el-step", {
            attrs: { title: "功能学习" },
            nativeOn: {
              click: function($event) {
                _vm.stepactive >= 2 && _vm.showStep(1)
              }
            }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: "测试须知" },
            nativeOn: {
              click: function($event) {
                _vm.stepactive >= 2 && _vm.showStep(2)
              }
            }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: "开始测试" },
            nativeOn: {
              click: function($event) {
                _vm.stepactive >= 3 && _vm.showStep(3)
              }
            }
          }),
          _vm._v(" "),
          _c("el-step", {
            attrs: { title: "测试合格" },
            nativeOn: {
              click: function($event) {
                _vm.stepactive >= 4 && _vm.showStep(4)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.clickFlag == 1
        ? _c(
            "div",
            { staticClass: "js-video" },
            [
              _c("p", { staticClass: "red" }, [
                _vm._v(
                  "温馨提示：语音客服必须掌握小助手的功能，请认真观看视频，学完所有功能，不要快进，否则不能正常进入下一步。"
                )
              ]),
              _vm._v(" "),
              _c(
                "el-tabs",
                {
                  attrs: { "tab-position": "left" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.tabCurrent,
                    callback: function($$v) {
                      _vm.tabCurrent = $$v
                    },
                    expression: "tabCurrent"
                  }
                },
                [
                  _c("el-tab-pane", { attrs: { name: "first" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_c("p", { staticClass: "title" }, [_vm._v("打卡")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "video-box",
                        attrs: { id: "video-first" }
                      },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "first",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/1.%E6%89%93%E5%8D%A1.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-first" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-second")
                                  }
                                }
                              },
                              [_vm._v("继续下一步学习")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "second" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("领数据外呼")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "video-box",
                        attrs: { id: "video-second" }
                      },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "second",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/2.%E9%A2%86%E6%95%B0%E6%8D%AE%E5%A4%96%E5%91%BC.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-second" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-third")
                                  }
                                }
                              },
                              [_vm._v("继续下一步学习")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "third" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm._v("修改客户资料")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "video-box",
                        attrs: { id: "video-third" }
                      },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "third",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/3.%E4%BF%AE%E6%94%B9%E5%AE%A2%E6%88%B7%E8%B5%84%E6%96%99.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "stoptip",
                        attrs: { id: "stoptip-third" }
                      },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-four")
                                  }
                                }
                              },
                              [_vm._v("继续下一步学习")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "four" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_c("p", { staticClass: "title" }, [_vm._v("下载录音")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "video-box", attrs: { id: "video-four" } },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "four",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/4.%E4%B8%8B%E8%BD%BD%E5%BD%95%E9%9F%B3.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: {
                                  click: function($event) {
                                    return _vm.studyNext("#tab-five")
                                  }
                                }
                              },
                              [_vm._v("继续下一步学习")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { name: "five" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "tab-slot",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_c("p", { staticClass: "title" }, [_vm._v("呼入操作")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "video-box", attrs: { id: "video-five" } },
                      [
                        _c(
                          "video",
                          {
                            staticClass: "video",
                            attrs: {
                              id: "five",
                              src:
                                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/5.%E5%91%BC%E5%85%A5%E6%93%8D%E4%BD%9C.mp4",
                              controls: "controls"
                            }
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持 video 标签。\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
                      [
                        _c("div", { staticClass: "tip" }, [
                          _c("span", { staticClass: "el-icon-success" }),
                          _vm._v(" "),
                          _c("p", [_vm._v("视频学习完毕")]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "restart",
                                on: { click: _vm.restartVideo }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-refresh-left"
                                }),
                                _vm._v("重播")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                on: { click: _vm.studyNextLast }
                              },
                              [_vm._v("进入测试须知")]
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clickFlag == 2
        ? _c(
            "div",
            { staticClass: "warp" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm.miaoone !== 0 && _vm.stepactive == 2
                ? _c(
                    "el-button",
                    { staticClass: "btn hui", attrs: { type: "primary" } },
                    [_vm._v("我已知晓(" + _vm._s(_vm.miaoone) + "s)")]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.goNext }
                    },
                    [_vm._v("我已知晓")]
                  )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.isShowStepOne ||
        _vm.isShowStepTwo ||
        _vm.isShowStepThird ||
        _vm.isShowStepFour) &&
      _vm.clickFlag === 3 &&
      _vm.stepactive === 3
        ? _c("div", { staticClass: "opertionbg" })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowStepOne && _vm.clickFlag === 3 && _vm.stepactive === 3
        ? _c("div", { staticClass: "opertiontip-box" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tip-text" },
              [
                _c("p", [_vm._v("请认真阅读注意事项！")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showStepTwo }
                  },
                  [_vm._v("下一步")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowStepTwo && _vm.clickFlag === 3 && _vm.stepactive === 3
        ? _c("div", { staticClass: "opertiontip-box tip-two" }, [
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tip-text" },
              [
                _c("p", [_vm._v("这是一段优秀录音，请认真学习！")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showStepThird }
                  },
                  [_vm._v("下一步")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowStepThird && _vm.clickFlag === 3 && _vm.stepactive === 3
        ? _c("div", { staticClass: "opertiontip-box tip-third" }, [
            _c(
              "div",
              { staticClass: "tip-text" },
              [
                _c("p", [_vm._v("以下是参考话术，测试时需要使用此话术")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.showStepFour }
                  },
                  [_vm._v("下一步")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clickFlag == 3
        ? _c("div", { staticClass: "opertion warp" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "test-outer-container" }, [
              _vm.isShowStepFour && _vm.clickFlag === 3 && _vm.stepactive === 3
                ? _c("div", { staticClass: "opertiontip-box tip-four" }, [
                    _c(
                      "div",
                      { staticClass: "tip-text" },
                      [
                        _c("p", [_vm._v("学习时间180秒后可以开始测试")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.closeStep }
                          },
                          [_vm._v("确定")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "opertiontip" }, [
                      _c("div", { staticClass: "step-tip" }, [
                        _vm.status == "AlreadyTheoryBadge" ||
                        _vm.status == "NoTheoryBadge"
                          ? _c("div", { staticClass: "result" }, [
                              _c(
                                "p",
                                { staticClass: "tip" },
                                [
                                  _vm._v("温馨提示："),
                                  _c("font", { attrs: { color: "red" } }, [
                                    _c("b", [
                                      _vm._v(
                                        "每天只能进行一次测试，外呼时请参考话术内容。"
                                      )
                                    ])
                                  ]),
                                  _vm._v("准备好即可开始测试，请珍惜测试机会。")
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.status == "Failed"
                          ? _c("div", { staticClass: "result" }, [
                              _c("p", { staticClass: "failtext" }, [
                                _vm._v("很遗憾，测试未通过！")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "reason" }, [
                                _vm._v("未通过原因："),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(_vm.result) }
                                })
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.status == "AlreadyTheoryBadge" ||
              _vm.status == "NoTheoryBadge"
                ? _c(
                    "div",
                    { staticClass: "result" },
                    [
                      _c(
                        "p",
                        { staticClass: "tip" },
                        [
                          _vm._v("温馨提示："),
                          _c("font", { attrs: { color: "red" } }, [
                            _c("b", [
                              _vm._v(
                                "每天只能进行一次测试，外呼时请参考话术内容。"
                              )
                            ])
                          ]),
                          _vm._v("准备好即可开始测试，请珍惜测试机会。")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.miaotwo !== 0 && _vm.stepactive === 3
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btn hui",
                              attrs: { type: "primary" }
                            },
                            [_vm._v("开始测试(" + _vm._s(_vm.miaotwo) + "s)")]
                          )
                        : _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: {
                                type: "primary",
                                disabled: _vm.isDisable
                              },
                              on: { click: _vm.startExam }
                            },
                            [_vm._v("开始测试")]
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status == "Failed"
                ? _c("div", { staticClass: "result" }, [
                    _c("p", { staticClass: "failtext" }, [
                      _vm._v("很遗憾，测试未通过！")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "reason" }, [
                      _vm._v("未通过原因："),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.result) }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.retry == "true"
                      ? _c(
                          "p",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.isDisable
                                },
                                on: { click: _vm.replyBegin }
                              },
                              [_vm._v("重新测试")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.retry == "false"
                      ? _c("p", [_vm._v("请按照上面提示进行操作！")])
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.status == "Ongoing"
              ? _c("div", [
                  _vm._m(9),
                  _vm._v(" "),
                  _c(
                    "p",
                    { on: { click: _vm.getCurrentStep } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { type: "primary", icon: "el-icon-refresh" }
                        },
                        [_vm._v("点击刷新审核结果")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clickFlag >= 4
        ? _c("div", { staticClass: "opertion otheropertion" }, [
            _vm.status == "Passed"
              ? _c("div", { staticClass: "pass password" }, [
                  _c("p", [_vm._v("恭喜你！")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("你已经通过系统测试")]),
                  _vm._v(" "),
                  _vm.Finished !== "yes"
                    ? _c("p", [_vm._v("快去完成“技能提升”的学习与测试吧！")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "button_box" }, [
                    _vm.registration == 1
                      ? _c("div", { staticClass: "btn-box button_box" }, [
                          _c(
                            "span",
                            {
                              staticClass: "button_again",
                              on: { click: _vm.relearn }
                            },
                            [_vm._v("点击重新学习")]
                          ),
                          _vm._v(" "),
                          _c("span", { on: { click: _vm.sign_up } }, [
                            _vm._v("去查看报名场次")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.registration == 0
                      ? _c("div", { staticClass: "btn-box button_box" }, [
                          _c(
                            "span",
                            {
                              staticClass: "button_again",
                              on: { click: _vm.relearn }
                            },
                            [_vm._v("点击重新学习")]
                          ),
                          _vm._v(" "),
                          _c("span", { on: { click: _vm.sign_up } }, [
                            _vm._v("去报名")
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot bigger" }),
        _vm._v(" "),
        _c("span", [_vm._v("测试目的")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot bigger" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "whitebg" }, [
        _c("p", [
          _c("span", { staticClass: "dot big" }),
          _vm._v("检测您是否掌握了小助手的使用方法")
        ]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "dot big" }),
          _vm._v("检测您是否符合语音客服的条件")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "whitebg flex" }, [
        _c("div", { staticClass: "left" }, [
          _c("p", [
            _c("span", { staticClass: "type" }, [_vm._v("设备要求")]),
            _vm._v(" "),
            _c("span", [_vm._v("必须要有耳麦")])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt" }, [
            _c("span", { staticClass: "type" }, [_vm._v("测试时间")]),
            _vm._v(" "),
            _c("span", [_vm._v("9:00-17:30")])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt" }, [
            _c("span", { staticClass: "type" }, [_vm._v("测试机会")]),
            _vm._v(" "),
            _c("span", [_vm._v("每人每天有一次测试机会")])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mt" }, [
            _c("span", { staticClass: "type" }, [_vm._v("测试结果")]),
            _vm._v(" "),
            _c("span", [_vm._v("当天18点前会出测试结果")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("p", [_c("span", { staticClass: "type" }, [_vm._v("合格标准")])]),
          _vm._v(" "),
          _c("p", [_vm._v("1、完成当天的测试外呼量（10通电话）")]),
          _vm._v(" "),
          _c("p", [_vm._v("2、普通话良好")]),
          _vm._v(" "),
          _c("p", [_vm._v("3、耳麦没有回音、杂音")]),
          _vm._v(" "),
          _c("p", [_vm._v("4、话术流畅、灵活性强")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot bigger" }),
        _vm._v(" "),
        _c("span", [_vm._v("操作说明")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot bigger" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "whitebg" }, [
        _c("p", { staticClass: "red" }, [
          _vm._v("温馨提示：请认真观看视频，不然你不知道接下来应该怎么做！")
        ]),
        _vm._v(" "),
        _c(
          "video",
          {
            staticClass: "video",
            attrs: {
              src:
                "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/6.%E7%B3%BB%E7%BB%9F%E6%B5%8B%E8%AF%95.mp4",
              controls: "controls"
            }
          },
          [_vm._v("\n            您的浏览器不支持 video 标签。\n          ")]
        )
      ]),
      _vm._v("test-guide\n        "),
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot bigger" }),
        _vm._v(" "),
        _c("span", [_vm._v("温馨提示")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot bigger" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "whitebg" }, [
        _c("p", [_vm._v("系统测试时，请保持您的电话畅通；")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "如果您的耳麦有问题，我们平台的工作人员会电话联系您（为了您能顺利通过测试，请不要拒接，谢谢）；"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "电话联系不上您时，我们会在APP上的消息中私信您，或者发送系统消息通知您，请注意查看信息。"
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "blue" }, [
          _vm._v(
            "*ps：外呼过程中，有任何的问题，可以点击小助手上的“在线沟通”，在“今日系统测试咨询群”反馈。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "opertiontip" }, [
      _c("div", { staticClass: "step-tip" }, [
        _c("span", { staticClass: "red" }, [
          _vm._v(
            "*注意：外呼测试的时候，接听对象是机器人，必须要用这个话术，才能和机器人进行对话，否则测试不合格！（右侧有录音参考）"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-quan" }, [
      _c("img", { attrs: { src: __webpack_require__(398) } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "opertiontip" }, [
      _c("div", { staticClass: "step-tip" }, [
        _c("audio", {
          attrs: {
            src:
              "http://res.study.itaojin.cn/2020-09/luyinanli.mp3?version=0821",
            controls: "controls"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-quan" }, [
      _c("img", { attrs: { src: __webpack_require__(398) } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-quan" }, [
      _c("img", {
        attrs: { src: __webpack_require__(399) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "opertiontip" }, [
      _c("div", { staticClass: "step-tip" }, [
        _c("table", { staticClass: "huashu" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { width: "120" } }),
              _vm._v(" "),
              _c("th", { attrs: { width: "200" } }, [_vm._v("步骤")]),
              _vm._v(" "),
              _c("th", [_vm._v("客服参考话术")])
            ])
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("开场白")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [
                _vm._v("核对尾号，确认机主")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您好！我是淘金平台的工作人员，请问您是手机尾号****的机主吗？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("探寻需求")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("询问任务意向")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "今天给您致电是想做一个简单的回访，我们平台有语音客服任务、在线客服任务、标注客服任务，请问您是想做哪种类型的任务呢？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "2" } }, [
                _vm._v("推荐产品")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [
                _vm._v("普通话好引导做语音")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "我听您普通话不错的，您可以考虑下做语音的任务，语音任务时薪报酬要比在线多几倍呢。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("获得徽章就可领任务")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，您可以在手机APP上完成语音基础培训，获得语音上岗徽章就可以申请语音的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "2" } }, [
                _vm._v("异议处理")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("对方想做语音")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，请问您之前是有做过语音客服相关的工作吗？您可以在手机APP上完成语音基础培训，获得语音徽章就可以申请语音的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("对方不想做语音")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，是您那边环境不适合做语音吗？那您可以在APP上完成在线基础培训，获得相关的在线徽章就可以申请在线的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("结束语")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "请尽快去APP上学习，我就不打扰您了，感谢您的接听，祝您生活愉快，再见！"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "11" } }, [
                _vm._v("其"),
                _c("br"),
                _vm._v("他"),
                _c("br"),
                _vm._v("常"),
                _c("br"),
                _vm._v("见"),
                _c("br"),
                _vm._v("问"),
                _c("br"),
                _vm._v("题")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("有工作，没时间")]),
              _vm._v(" "),
              _c("td", [_vm._v("好的，您以后有需要了欢迎您随时回来。")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("有工作但晚上有时间")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您这种情况呢，我这边是建议您可以尝试做在线客服，在线任务的时间安排相对来说更自由一些。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("询问工资怎么计算")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "报酬是根据任务而定的，不同的任务，报酬也不同；常见的形式是时薪。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("培训收费吗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您放心，我们平台承诺大家在整个过程中都是完全免费的，不收取任何一分钱的费用。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("什么是在线客服？")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "在线客服主要是通过文字和顾客交流，跟淘宝上的客服一样的。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("什么是语音客服？")]),
              _vm._v(" "),
              _c("td", [
                _vm._v("语音客服主要是通过电话和顾客交流，就是电话销售。")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("学习课程中有问题")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "这个情况的话，您可以在APP上反馈给班主任，班主任那边可以帮您解决。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("已经上岗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，如果您执行任务中有任务问题，都可以直接反馈给主管，那我就不打扰您了，祝您生活愉快，再见！"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("是我家人注册的")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "那您知道您家人是想在我们平台做语音客服还是在线客服吗？目前是否已经上岗了呢？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("做不好会有扣罚吗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "这个也是视任务而定的，等申请任务之后，任务老师也会给您们提前说明扣罚的。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("我随便下载的，我不清楚你们是做什么的")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "我简单的给您介绍下我们平台，我们淘金是2015年成立，是客服外包平台，客服是在家执行任务，获得报酬，而且我们的任务大多是长期的，在家就可以在平台上获得稳定的收入，我们执行任务的时间也比较灵活，您可以用您平时的空闲时间来平台做任务。"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "title" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot bigger" }),
        _vm._v(" "),
        _c("span", [_vm._v("话术参考")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot bigger" }),
        _c("span", { staticClass: "dot big" }),
        _c("span", { staticClass: "dot" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "Addmodifications" }, [
        _c("div", { staticClass: "audio-box" }, [
          _c("div", [
            _c("div", { staticClass: "red text-font" }, [
              _vm._v(
                "*注意：外呼测试的时候，接听对象是机器人，必须要用这个话术，才能和机器人进行对话，否则测试不合格！（右侧有录音参考）"
              )
            ])
          ]),
          _vm._v(" "),
          _c("audio", {
            attrs: {
              src:
                "http://res.study.itaojin.cn/2020-09/luyinanli.mp3?version=0821",
              controls: "controls"
            }
          })
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "huashu" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { width: "120" } }),
              _vm._v(" "),
              _c("th", { attrs: { width: "200" } }, [_vm._v("步骤")]),
              _vm._v(" "),
              _c("th", [_vm._v("客服参考话术")])
            ])
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("开场白")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [
                _vm._v("核对尾号，确认机主")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您好！我是淘金平台的工作人员，请问您是手机尾号****的机主吗？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("探寻需求")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("询问任务意向")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "今天给您致电是想做一个简单的回访，我们平台有语音客服任务、在线客服任务、标注客服任务，请问您是想做哪种类型的任务呢？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "2" } }, [
                _vm._v("推荐产品")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [
                _vm._v("普通话好引导做语音")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "我听您普通话不错的，您可以考虑下做语音的任务，语音任务时薪报酬要比在线多几倍呢。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("获得徽章就可领任务")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，您可以在手机APP上完成语音基础培训，获得语音上岗徽章就可以申请语音的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "2" } }, [
                _vm._v("异议处理")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("对方想做语音")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，请问您之前是有做过语音客服相关的工作吗？您可以在手机APP上完成语音基础培训，获得语音徽章就可以申请语音的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("对方不想做语音")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，是您那边环境不适合做语音吗？那您可以在APP上完成在线基础培训，获得相关的在线徽章就可以申请在线的任务。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue" }, [_vm._v("结束语")]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "请尽快去APP上学习，我就不打扰您了，感谢您的接听，祝您生活愉快，再见！"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "blue", attrs: { rowspan: "11" } }, [
                _vm._v("其"),
                _c("br"),
                _vm._v("他"),
                _c("br"),
                _vm._v("常"),
                _c("br"),
                _vm._v("见"),
                _c("br"),
                _vm._v("问"),
                _c("br"),
                _vm._v("题")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "black" }, [_vm._v("有工作，没时间")]),
              _vm._v(" "),
              _c("td", [_vm._v("好的，您以后有需要了欢迎您随时回来。")])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("有工作但晚上有时间")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您这种情况呢，我这边是建议您可以尝试做在线客服，在线任务的时间安排相对来说更自由一些。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("询问工资怎么计算")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "报酬是根据任务而定的，不同的任务，报酬也不同；常见的形式是时薪。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("培训收费吗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "您放心，我们平台承诺大家在整个过程中都是完全免费的，不收取任何一分钱的费用。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("什么是在线客服？")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "在线客服主要是通过文字和顾客交流，跟淘宝上的客服一样的。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("什么是语音客服？")]),
              _vm._v(" "),
              _c("td", [
                _vm._v("语音客服主要是通过电话和顾客交流，就是电话销售。")
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("学习课程中有问题")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "这个情况的话，您可以在APP上反馈给班主任，班主任那边可以帮您解决。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("已经上岗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "好的，如果您执行任务中有任务问题，都可以直接反馈给主管，那我就不打扰您了，祝您生活愉快，再见！"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("是我家人注册的")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "那您知道您家人是想在我们平台做语音客服还是在线客服吗？目前是否已经上岗了呢？"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [_vm._v("做不好会有扣罚吗")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "这个也是视任务而定的，等申请任务之后，任务老师也会给您们提前说明扣罚的。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "black" }, [
                _vm._v("我随便下载的，我不清楚你们是做什么的")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "我简单的给您介绍下我们平台，我们淘金是2015年成立，是客服外包平台，客服是在家执行任务，获得报酬，而且我们的任务大多是长期的，在家就可以在平台上获得稳定的收入，我们执行任务的时间也比较灵活，您可以用您平时的空闲时间来平台做任务。"
                )
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip-quan positionimgbox" }, [
      _c("img", {
        staticClass: "tip-quan_positionimg",
        attrs: { src: __webpack_require__(399) }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "on" }, [
      _c("img", {
        attrs: {
          src:
            "https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWeb/web/%E4%BB%BB%E5%8A%A1%E6%89%93%E5%8D%A12.png",
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe166578", esExports)
  }
}

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1546);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("02ce7b39", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d24141b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./examDialog.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d24141b6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./examDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.content[data-v-d24141b6] {\n  padding-top: 10px;\n}\n.content > span[data-v-d24141b6] {\n  padding-right: 20px;\n}\n", ""]);

// exports


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "",
        visible: _vm.examVisible,
        width: "30%",
        center: "",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.examVisible = $event
        }
      }
    },
    [
      _c("span", [_vm._v("测试须知：" + _vm._s(_vm.exam.examDescription))]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [
          _vm._v("测试机会：" + _vm._s(_vm.exam.remainingExamTimes) + "次")
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("时间：" + _vm._s(_vm.exam.examDuration) + "分钟")]),
        _vm._v(" "),
        _c("span", [_vm._v("题目：" + _vm._s(_vm.exam.questionNum) + "题")])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.returnCourseList } }, [
            _vm._v("重新学习")
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.beginExam } },
            [_vm._v("开始测试")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d24141b6", esExports)
  }
}

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8a8421_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainList_vue__ = __webpack_require__(1551);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1549)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a8a8421"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8a8421_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/trainList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a8a8421", Component.options)
  } else {
    hotAPI.reload("data-v-5a8a8421", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ec53b84e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5a8a8421\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainList.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5a8a8421\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.train-list-container[data-v-5a8a8421] {\n  padding: 20px;\n  background-color: #f5f5f5;\n  min-height: 100vh;\n}\n.cards-grid[data-v-5a8a8421] {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 340px);\n  gap: 20px;\n  justify-content: start;\n}\n.card-item[data-v-5a8a8421] {\n  width: 340px;\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n}\n.card-item[data-v-5a8a8421]:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n.card-image[data-v-5a8a8421] {\n  width: 340px;\n  height: 220px;\n  background-color: #a8c8ec;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n.card-image img[data-v-5a8a8421] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.card-content[data-v-5a8a8421] {\n  padding: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  flex: 0 0 auto;\n  height: 106px;\n}\n.card-title[data-v-5a8a8421] {\n  flex: 1;\n  font-size: 16px;\n  color: #333;\n  line-height: 1.4;\n  margin-right: 15px;\n}\n.card-button[data-v-5a8a8421] {\n  background-color: #1890ff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5em 1em;\n  font-size: 0.875em;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  white-space: nowrap;\n  min-width: 0;\n  flex-shrink: 0;\n}\n.card-button[data-v-5a8a8421]:hover {\n  background-color: #40a9ff;\n}\n\n/* 响应式设计：自动换行，不限制每行数量 */\n@media (max-width: 768px) {\n.cards-grid[data-v-5a8a8421] {\n    gap: 15px;\n}\n.card-title[data-v-5a8a8421] {\n    margin-right: 0;\n}\n}\n", ""]);

// exports


/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "train-list-container" }, [
    _c(
      "div",
      { staticClass: "cards-grid" },
      _vm._l(_vm.cardList, function(item, index) {
        return _c("div", { key: index, staticClass: "card-item" }, [
          _c("div", { staticClass: "card-image" }, [
            _c("img", { attrs: { src: item.majorImg, alt: item.title } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" }, [
            _c("div", { staticClass: "card-title" }, [
              _vm._v(_vm._s(item.majorTitle))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "card-button",
                on: {
                  click: function($event) {
                    return _vm.handleCardClick(item)
                  }
                }
              },
              [_vm._v("点击进入")]
            )
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a8a8421", esExports)
  }
}

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c(
        "div",
        { staticClass: "Lvone_tab" },
        _vm._l(_vm.tabOneList, function(item, index) {
          return _c("div", { key: index }, [
            _c(
              "div",
              {
                staticClass: "Onetabtext",
                class: { Onetabtext_1: index == _vm.Onetabtindex },
                on: {
                  click: function($event) {
                    return _vm.oneClick(index, item.id, item.type)
                  }
                }
              },
              [_vm._v(_vm._s(item.name))]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "voice", staticStyle: { position: "relative" } },
        [
          _c(
            "div",
            { staticClass: "tabBox" },
            [
              _vm._l(_vm.tabTwoList, function(t, key) {
                return _c(
                  "div",
                  {
                    key: key,
                    staticClass: "index_tabBox",
                    class: {
                      index_tabBox_after: key == _vm.tabIndex,
                      index_tabBox_left:
                        key != 0 && key != _vm.tabTwoList.length - 1,
                      index_tabbox_0: key == 0,
                      index_tabbox_last: key == _vm.tabTwoList.length - 1,
                      index_tabbox_fristss:
                        key == 0 && _vm.tabTwoList.length - 1 == 0
                    },
                    on: {
                      click: function($event) {
                        return _vm.changeSecondaryTab(key, t.categoryId, t)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(t.categoryName) + "\n      ")]
                )
              }),
              _vm._v(" "),
              _vm.showAskingDoor
                ? _c(
                    "a",
                    {
                      staticStyle: {
                        position: "absolute",
                        top: "14px",
                        right: "20px",
                        "z-index": "9"
                      },
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.imUrl +
                          "/TJ_TJK_IMAction.html?token=" +
                          _vm.imToken +
                          "&tjkId=" +
                          _vm.tjkInfo.id +
                          "&userName=" +
                          _vm.tjkInfo.realName +
                          "&tjkNumber=" +
                          _vm.tjkInfo.tjkNum +
                          "&platform=assitant"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { height: "30px" },
                        attrs: {
                          src: __webpack_require__(471),
                          alt: ""
                        }
                      })
                    ]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _vm.newPeopleBadgeId == false
                ? _c(
                    "div",
                    [
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            title: "注意",
                            visible: _vm.dialogVisible,
                            width: "30%",
                            "show-close": false,
                            "close-on-click-modal": false
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.dialogVisible = $event
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "完成前面的《系统测试》，才能报名技能提升培训"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "dialog-footer",
                              attrs: { slot: "footer" },
                              slot: "footer"
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.dialogVisible = false
                                    }
                                  }
                                },
                                [_vm._v("确 定")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType != "VoiceUpgradeSkill" &&
              _vm.assitantType != "OnlineUpgradeSkill" &&
              _vm.assitantType != "TjCollegeYingxiao" &&
              _vm.assitantType != "FbtOperate"
                ? _vm._l(_vm.courseList, function(c, key) {
                    return _c(
                      "div",
                      { key: key, staticClass: "step-list other-list" },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              step: true,
                              active: c.passState == "Passed",
                              progress:
                                c.passState == "Ongoing" || c.passState == null
                            }
                          },
                          [
                            _vm.courseList.length != 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "circle",
                                    class: {
                                      circle: c.passState == "Passed",
                                      othercircle:
                                        c.passState == "Ongoing" ||
                                        c.passState == null
                                    }
                                  },
                                  [
                                    _vm.courseList.length != 1
                                      ? _c("div", [_vm._v(_vm._s(key + 1))])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            key != 0
                              ? _c("div", {
                                  staticClass: "top_line",
                                  class: {
                                    top_isCheck:
                                      c.passState == "Passed" ||
                                      c.passState == "Ongoing",
                                    top_noCheck: c.passState == null
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.courseList.length > 1 &&
                            key != _vm.courseList.length - 1
                              ? _c("div", {
                                  class: {
                                    line: c.passState == "Passed",
                                    otherline:
                                      c.passState == "Ongoing" ||
                                      c.passState == null
                                  }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _c("div", { staticClass: "box boxstyle" }, [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _c("div", [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(c.courseName))
                                  ])
                                ]),
                                _vm._v(" "),
                                c.unlock
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          class:
                                            c.passState == "Passed"
                                              ? "isgreen"
                                              : "isred"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              c.passState == "Passed"
                                                ? "已完成"
                                                : "未完成"
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "test-button isposition"
                                        },
                                        [
                                          (c.assitantType == null ||
                                            c.assitantType == "" ||
                                            c.assitantType == "allSaleExam" ||
                                            c.assitantType == "fbt") &&
                                          c.courseType == "Integrate" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (c.assitantType == null ||
                                            c.assitantType == "" ||
                                            c.assitantType == "allSaleExam" ||
                                            c.assitantType == "fbt") &&
                                          c.courseType == "Integrate" &&
                                          c.passState == "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.courseType == "Exam" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("开始测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.courseType == "Exam" &&
                                          c.passState == "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.courseType != "Exam" &&
                                          c.assitantType == "fbtExamCourse"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goCompleteExperience(
                                                        c
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        c.gainBadge == true
                                                          ? "修改经验"
                                                          : "去完善"
                                                      )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType == "urlLink" &&
                                          c.unlock == true
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击跳转")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType ==
                                            "AssitantSpecialRobotExam" &&
                                          c.retry == "false" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("开始测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType ==
                                            "AssitantSpecialRobotExam" &&
                                          c.retry == "true" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("开始测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType == "WordInputExam" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType == "WordInputExam" &&
                                          c.passState == "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (c.assitantType == null ||
                                            c.assitantType == "") &&
                                          c.courseType == "Linkage" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (c.assitantType == null ||
                                            c.assitantType == "") &&
                                          c.courseType == "Linkage" &&
                                          c.passState == "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.passState == "Ongoing" &&
                                          (c.assitantType == "beforeSaleExam" ||
                                            c.assitantType ==
                                              "afterSaleExam") &&
                                          c.unlock == true
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.passState == "Passed" &&
                                          (c.assitantType == "beforeSaleExam" ||
                                            c.assitantType ==
                                              "afterSaleExam") &&
                                          c.unlock == true
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新学习")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  : [_c("div", { staticClass: "lock" })]
                              ],
                              2
                            ),
                            _vm._v(" "),
                            c.courseType == "Integrate" ||
                            c.courseType == "Linkage"
                              ? _c("div", { staticClass: "text textstyle" }, [
                                  _vm._v(
                                    "\n                课程说明：\n                "
                                  ),
                                  c.result
                                    ? _c(
                                        "div",
                                        { staticStyle: { width: "70%" } },
                                        [
                                          _vm._v(_vm._s(c.description)),
                                          c.result
                                            ? _c(
                                                "span",
                                                { staticClass: "thespan" },
                                                [
                                                  _vm._v(
                                                    "(" + _vm._s(c.result) + ")"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _c("div", {
                                        staticStyle: { width: "70%" },
                                        domProps: {
                                          innerHTML: _vm._s(c.description)
                                        }
                                      })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            c.courseType == "Exam"
                              ? _c("div", {
                                  staticClass: "text textstyle",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      "完成要求：" + c.description
                                    )
                                  }
                                })
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType == "OnlineUpgradeSkill"
                ? [
                    _vm._l(_vm.Onlinelist, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "RegistrationSessions" },
                        [
                          item.trainFlag == "theory"
                            ? _c("div", { staticClass: "label" }, [
                                _vm._v("理论培训")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.trainFlag == "exercise"
                            ? _c("div", { staticClass: "label" }, [
                                _vm._v("实操培训")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "text_box" }, [
                            _c("div", { staticClass: "title_state_button" }, [
                              _c("div", { staticClass: "title_state" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.trainTitle) +
                                    "\n                "
                                ),
                                item.passState != "signTimeOut"
                                  ? _c(
                                      "div",
                                      {
                                        class: {
                                          Reg_isred:
                                            item.passState != "passed" &&
                                            item.passState != "signTimeOut",
                                          Reg_isgreen:
                                            item.passState == "passed"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.passState != "passed" &&
                                                item.passState != "signTimeOut"
                                                ? "未完成"
                                                : "已完成"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              item.passState == "noJoin"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.togoscene(item)
                                        }
                                      }
                                    },
                                    [_vm._v("点击报名")]
                                  )
                                : item.passState == "alreadyApply"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button_noqian",
                                      on: {
                                        click: function($event) {
                                          return _vm.alertTrainNoStartOnline(
                                            item.startTime
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("等待培训")]
                                  )
                                : item.passState != "signTimeOut"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button special_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.gotest(item)
                                        }
                                      }
                                    },
                                    [_vm._v("点击学习")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            item.trainFlag == "exercise" ||
                            item.trainFlag == "theory"
                              ? _c("div", { staticClass: "Reg_date" }, [
                                  _vm._v(
                                    "\n              培训时间：" +
                                      _vm._s(item.startTime) +
                                      "-" +
                                      _vm._s(item.endTime) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.trainFlag == "exercise" ||
                            item.trainFlag == "theory"
                              ? _c("div", { staticClass: "Reg_lecturer" }, [
                                  _vm._v(
                                    "\n              培训模式：在线自学讲师帮扶\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState != "passed" &&
                            item.passState != "signTimeOut" &&
                            item.passState != "noJoin"
                              ? _c("div", { staticClass: "Reg_qq" }, [
                                  _vm._v(
                                    "\n              问题咨询： " +
                                      _vm._s(item.qqNumber) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_content" }, [
                              _vm._v("培训内容：" + _vm._s(item.trainContent))
                            ]),
                            _vm._v(" "),
                            item.passState == "signTimeOut"
                              ? _c("div", { staticClass: "fail_img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(403),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fail_text" }, [
                                    _vm._v("已失效")
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.addGroupDialog.show,
                          width: "360px",
                          "show-close": false,
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(_vm.addGroupDialog, "show", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dialog_img" }, [
                          _c("img", {
                            attrs: {
                              src: __webpack_require__(36),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "qq_text" }, [
                          _vm._v("确认参加培训并加入培训群")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "currency_button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "cancel",
                                  on: {
                                    click: function($event) {
                                      _vm.addGroupDialog.show = false
                                    }
                                  }
                                },
                                [_vm._v("取消")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "determine",
                                  on: { click: _vm.isenlist }
                                },
                                [_vm._v("确定")]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.dimensional,
                          width: "360px",
                          "close-on-click-modal": false,
                          center: ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dimensional = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dimensionalimg_Line" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dialog_img",
                            staticStyle: { "margin-top": "50px" }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: __webpack_require__(36),
                                alt: ""
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "dimensionalimg_text" }, [
                              _vm._v("你已成功报名")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cel-button",
                                on: { click: _vm.qqsceneId }
                              },
                              [_vm._v("进入培训群")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType == "VoiceUpgradeSkill"
                ? [
                    _vm._l(_vm.cseList, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "RegistrationSessions" },
                        [
                          item.mode == "live" &&
                          item.sign == "Yes" &&
                          item.passState != "signTimeOut"
                            ? _c("div", { staticClass: "live_signed_badge" }, [
                                _vm._v("已签到")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "text_box" }, [
                            _c("div", { staticClass: "title_state_button" }, [
                              _c("div", { staticClass: "title_state" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.trainTitle) +
                                    "\n                "
                                ),
                                item.passState != "signTimeOut" &&
                                item.passState != "noJoin"
                                  ? _c(
                                      "div",
                                      {
                                        class: {
                                          Reg_isred:
                                            item.passState != "passed" &&
                                            item.passState != "signTimeOut",
                                          Reg_isgreen:
                                            item.passState == "passed"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.passState != "passed" &&
                                                item.passState != "signTimeOut"
                                                ? "未完成"
                                                : "已完成"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              item.mode == "self"
                                ? _c("div", [
                                    item.passState == "noJoin"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "Reg_button",
                                            on: {
                                              click: function($event) {
                                                return _vm.goscene(item)
                                              }
                                            }
                                          },
                                          [_vm._v("点击报名")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.passState != "noJoin" &&
                                    item.passState != "passed" &&
                                    item.passState != "signTimeOut"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "Reg_button special_button",
                                            on: {
                                              click: function($event) {
                                                return _vm.regoscene(
                                                  item.sceneId,
                                                  item.trainId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  点击学习"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.passState == "passed"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "Reg_button",
                                            on: {
                                              click: function($event) {
                                                return _vm.regoscene(
                                                  item.sceneId,
                                                  item.trainId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  重新学习"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_date" }, [
                              _vm._v(
                                "\n              培训日期：" +
                                  _vm._s(item.startTime) +
                                  "-" +
                                  _vm._s(item.endTime) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "Reg_time" },
                              [
                                _vm._v("\n              培训时间："),
                                _vm._l(item.trainTime, function(m, key) {
                                  return _c("span", { key: key }, [
                                    _vm._v(_vm._s(m)),
                                    key < item.trainTime.length - 1
                                      ? _c("span", [_vm._v("，")])
                                      : _vm._e()
                                  ])
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_content" }, [
                              _vm._v("培训内容：" + _vm._s(item.trainContent))
                            ]),
                            _vm._v(" "),
                            item.mode == "live"
                              ? _c("div", { staticClass: "live_btns" }, [
                                  item.passState == "noJoin"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "Reg_button",
                                          on: {
                                            click: function($event) {
                                              return _vm.goscene(item)
                                            }
                                          }
                                        },
                                        [_vm._v("点击报名")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.passState != "noJoin" &&
                                  item.passState != "signTimeOut" &&
                                  item.sign != "Yes"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "Reg_button",
                                          on: {
                                            click: function($event) {
                                              return _vm.liveSignIn(item)
                                            }
                                          }
                                        },
                                        [_vm._v("点击签到")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.passState != "noJoin" &&
                                  item.passState != "signTimeOut" &&
                                  item.sign == "Yes"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Reg_button special_button",
                                          on: {
                                            click: function($event) {
                                              return _vm.regoscene(
                                                item.sceneId,
                                                item.trainId
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("进入培训")]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState == "signTimeOut"
                              ? _c("div", { staticClass: "fail_img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(403),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fail_text" }, [
                                    _vm._v("已失效")
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.addGroupDialog.show,
                          width: "360px",
                          "show-close": false,
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(_vm.addGroupDialog, "show", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dialog_img" }, [
                          _c("img", {
                            attrs: {
                              src: __webpack_require__(36),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "qq_text" }, [
                          _vm._v("确认参加培训并加入培训群")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "currency_button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "cancel",
                                  on: {
                                    click: function($event) {
                                      _vm.addGroupDialog.show = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                取消\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "determine",
                                  on: { click: _vm.isenlist }
                                },
                                [
                                  _vm._v(
                                    "\n                确定\n              "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.dimensional,
                          width: "360px",
                          "close-on-click-modal": false,
                          center: ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dimensional = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dimensionalimg_Line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "dimensionalimg" }, [
                          _c("img", {
                            attrs: { src: _vm.dimensionalimg, alt: "" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dimensionalimg_text" }, [
                          _vm._v("请使用手机QQ扫一扫加入培训群")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cel-button",
                                on: { click: _vm.qqsceneId }
                              },
                              [_vm._v("已扫码加入")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType == "TjCollegeYingxiao"
                ? [
                    _vm._l(_vm.cseList, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "RegistrationSessions" },
                        [
                          _c("div", { staticClass: "text_box" }, [
                            _c("div", { staticClass: "title_state_button" }, [
                              _c("div", { staticClass: "title_state" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.trainTitle) +
                                    "\n                "
                                ),
                                item.passState != "signTimeOut" &&
                                item.passState != "noJoin"
                                  ? _c(
                                      "div",
                                      {
                                        class: {
                                          Reg_isred:
                                            item.passState != "passed" &&
                                            item.passState != "signTimeOut",
                                          Reg_isgreen:
                                            item.passState == "passed"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.passState != "passed" &&
                                                item.passState != "signTimeOut"
                                                ? "未完成"
                                                : "已完成"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              item.passState == "noJoin"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.goscene(item)
                                        }
                                      }
                                    },
                                    [_vm._v("点击报名")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.passState != "noJoin" &&
                              item.passState != "passed" &&
                              item.passState != "noSignAlreadyOpen" &&
                              item.passState != "noSignedNoOpen" &&
                              item.passState != "signTimeOut"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button special_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.regoscene(
                                            item.sceneId,
                                            item.trainId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("\n                点击学习")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.passState == "passed"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.regoscene(
                                            item.sceneId,
                                            item.trainId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("\n                重新学习")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.passState == "noSignAlreadyOpen"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.signIn(
                                            item.sceneId,
                                            item.trainId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("点击签到")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.passState == "noSignedNoOpen"
                                ? _c(
                                    "div",
                                    { staticClass: "Reg_button_noqian" },
                                    [_vm._v("点击签到")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_date" }, [
                              _vm._v(
                                "\n              培训日期：" +
                                  _vm._s(item.trainDate) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "Reg_time" },
                              [
                                _vm._v("\n              培训时间："),
                                _vm._l(item.trainTime, function(m, key) {
                                  return _c("span", { key: key }, [
                                    _vm._v(_vm._s(m)),
                                    key < item.trainTime.length - 1
                                      ? _c("span", [_vm._v("，")])
                                      : _vm._e()
                                  ])
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_lecturer" }, [
                              _vm._v(
                                "\n              培训讲师：" +
                                  _vm._s(item.teacherName) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_qq" }, [
                              _vm._v(
                                "\n              企业微信群：" +
                                  _vm._s(item.groupName) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_content" }, [
                              _vm._v("培训内容：" + _vm._s(item.trainContent))
                            ]),
                            _vm._v(" "),
                            item.passState == "signTimeOut"
                              ? _c("div", { staticClass: "fail_img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: __webpack_require__(403),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fail_text" }, [
                                    _vm._v("已失效")
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.addGroupDialog.show,
                          width: "360px",
                          "show-close": false,
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(_vm.addGroupDialog, "show", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dialog_img" }, [
                          _c("img", {
                            attrs: {
                              src: __webpack_require__(36),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "qq_text" }, [
                          _vm._v(_vm._s(_vm.addGroupDialog.tip))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "currency_button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "cancel",
                                  on: {
                                    click: function($event) {
                                      _vm.addGroupDialog.show = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                取消\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "determine",
                                  on: { click: _vm.isenlist }
                                },
                                [
                                  _vm._v(
                                    "\n                确定\n              "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.dimensional,
                          width: "360px",
                          "close-on-click-modal": false,
                          center: ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dimensional = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dimensionalimg_Line" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dialog_img",
                            staticStyle: { "margin-top": "50px" }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: __webpack_require__(36),
                                alt: ""
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "dimensionalimg_text" }, [
                              _vm._v("你已成功报名")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cel-button",
                                on: { click: _vm.qqsceneId }
                              },
                              [_vm._v("进入培训群")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType == "FbtOperate"
                ? [_c("trainList", { attrs: { categoryId: _vm.categoryId } })]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "考核次数",
            visible: _vm.theoryRemainDialog.show,
            width: "360px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.theoryRemainDialog, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "总考核次数", "label-width": "150px" } },
                [
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary", underline: false },
                      on: {
                        click: function($event) {
                          return _vm.editRow(_vm.scope.row)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.theoryRemainDialog.total))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "剩余考核数", "label-width": "150px" } },
                [
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary", underline: false },
                      on: {
                        click: function($event) {
                          return _vm.editRow(_vm.scope.row)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.theoryRemainDialog.remain))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "currency_button" }, [
                _c(
                  "div",
                  {
                    staticClass: "cancel",
                    on: {
                      click: function($event) {
                        _vm.theoryRemainDialog.show = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "determine",
                    on: { click: _vm.goThoryExamPage }
                  },
                  [_vm._v("确定")]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4df7638", esExports)
  }
}

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vedioDetail_vue__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vedioDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vedioDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vedioDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vedioDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8234984_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vedioDetail_vue__ = __webpack_require__(1579);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1554)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8234984"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vedioDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8234984_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vedioDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/vedioDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e8234984", Component.options)
  } else {
    hotAPI.reload("data-v-e8234984", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1555);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("942865e4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e8234984\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./vedioDetail.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e8234984\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./vedioDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.video-player-box[data-v-e8234984] {\n  max-height: 900px !important;\n}\n.video-player[data-v-e8234984] {\n  display: flex;\n  justify-content: center;\n}\n.video-player[data-v-e8234984] .vjs-progress-control {\n  pointer-events: none;\n}\n.video-player[data-v-e8234984] .vjs-fullscreen-control {\n  visibility: hidden !important;\n}\n.video-player[data-v-e8234984] .video-js {\n  max-height: 900px !important;\n  background-color: transparent !important;\n}\n.video-player[data-v-e8234984] .vjs-big-play-button {\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%);\n}\n#train[data-v-e8234984] {\n  padding: 0;\n}\n#Return_Bar[data-v-e8234984] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n[data-v-e8234984] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-e8234984] {\n  background: #f6f5f8;\n  width: 100%;\n  padding: 20px 20px;\n}\n.study-countdown[data-v-e8234984] {\n  display: inline-block;\n  margin: 5px 0;\n  padding: 6px 12px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 14px;\n  border-radius: 4px;\n}\n.isreturn[data-v-e8234984] {\n  color: #000;\n  cursor: pointer;\n}\n.boxstyle[data-v-e8234984] {\n  display: flex;\n  justify-content: space-between;\n  margin: 10px 0;\n}\n.timestyle[data-v-e8234984] {\n  margin: 0 20px;\n  height: 28px;\n  line-height: 28px;\n}\n[data-v-e8234984] .el-dialog {\n  border-radius: 10px;\n}\n[data-v-e8234984] .el-dialog__header {\n  border-bottom: 1px solid #E9E9E9;\n}\n[data-v-e8234984] .el-dialog__title {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n}\n.currency_img[data-v-e8234984] {\n  width: 85px;\n  height: 64px;\n  margin: 0 auto;\n  margin-bottom: 12px;\n}\n.currency_img > img[data-v-e8234984] {\n  width: 100%;\n  height: 100%;\n}\n.currency_text[data-v-e8234984] {\n  text-align: center;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 20px;\n}\n.currency_text > span[data-v-e8234984] {\n  color: #497AF2;\n}\n.cancel[data-v-e8234984] {\n  width: 80px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #717171;\n  text-align: center;\n  line-height: 28px;\n  margin-right: 10px;\n}\n.determine[data-v-e8234984] {\n  width: 80px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.currency_button[data-v-e8234984] {\n  display: flex;\n  justify-content: center;\n}\n.left_span[data-v-e8234984] {\n  color: #497AF2;\n}\n.otherdetermine[data-v-e8234984] {\n  padding: 0px 15px 0px 15px;\n  height: 33px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 33px;\n  cursor: pointer;\n}\n.img-fix-bg[data-v-e8234984] {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 99999;\n  background: rgba(0, 0, 0, 0.6);\n}\n.img-fix-bg .larger-box[data-v-e8234984] {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  position: relative;\n}\n.img-fix-bg .larger-box img[data-v-e8234984] {\n  max-width: 100%;\n  max-height: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.img-fix-bg .close[data-v-e8234984] {\n  position: absolute;\n  right: 30px;\n  top: 30px;\n  color: #fff;\n  font-size: 30px;\n  cursor: pointer;\n}\n.offline-footer[data-v-e8234984] {\n  width: 100%;\n  height: 60px;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  background: #fff;\n  border-top: 1px solid #dadbe3;\n  padding: 12px 30px;\n  z-index: 10;\n}\n.offline-footer[data-v-e8234984] .el-form .el-button {\n  padding: 10px 35px;\n}\n.offline-footer[data-v-e8234984] .el-form .el-form-item {\n  margin-right: 30px;\n}\n.offline-footer[data-v-e8234984] .el-form .remark {\n  width: 250px;\n  height: 36px;\n  position: relative;\n}\n.offline-footer[data-v-e8234984] .el-form .remark .el-textarea:before {\n  position: absolute;\n  left: 0;\n  top: 0;\n  line-height: 36px;\n  padding-left: 15px;\n}\n", ""]);

// exports


/***/ }),
/* 1556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_knowledgeDialog_vue__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_knowledgeDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_knowledgeDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_knowledgeDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_knowledgeDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f56d7d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_knowledgeDialog_vue__ = __webpack_require__(1574);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1572)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f56d7d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_knowledgeDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f56d7d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_knowledgeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/videoDetail/knowledgeDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0f56d7d6", Component.options)
  } else {
    hotAPI.reload("data-v-0f56d7d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2af6a696", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0f56d7d6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./knowledgeDialog.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0f56d7d6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./knowledgeDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.dialog_title[data-v-0f56d7d6] {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.dialog_title .title[data-v-0f56d7d6] {\n  font-size: 15px;\n  font-weight: 500;\n  color: black;\n}\n.dialog_title .timers[data-v-0f56d7d6] {\n  font-size: 15px;\n}\n.choicess[data-v-0f56d7d6] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  margin-top: 20px;\n}\n.choicess .item[data-v-0f56d7d6] {\n  width: 90%;\n  padding: 8px 15px;\n  text-align: left;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  margin-top: 15px;\n  color: darkgray;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.choicess .item.active[data-v-0f56d7d6] {\n  border: 1px solid #497AF2;\n}\n.submit-btn[data-v-0f56d7d6] {\n  width: 140px;\n  height: 40px;\n  margin-left: 110px;\n  margin-top: 30px;\n  border-radius: 20px;\n}\n.submit-btn.active[data-v-0f56d7d6] {\n  background-color: lightgray !important;\n  border: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "400px",
        "close-on-click-modal": false,
        "show-close": false,
        "destroy-on-close": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("div", { staticClass: "dialog_title" }, [
                _c("div", { staticClass: "title" }, [_vm._v("知识点小测验")]),
                _vm._v(" "),
                _c("div", { staticClass: "timers" }, [
                  _vm._v("剩余答题时间："),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.remainingTime) + "s")
                  ])
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm.question && _vm.question.questionContent
        ? _c("div", { staticStyle: { "font-size": "15px" } }, [
            _vm._v(
              _vm._s(_vm.type() + _vm.question.questionContent.questionStem)
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.question &&
      _vm.question.questionContent &&
      _vm.question.questionContent.imageUrlList
        ? _c(
            "div",
            { staticStyle: { "margin-top": "5px" } },
            _vm._l(_vm.question.questionContent.imageUrlList, function(
              imgUrl,
              index
            ) {
              return _c("el-image", {
                key: index,
                staticStyle: { width: "100px", height: "100px" },
                attrs: { src: imgUrl, fit: "cover" },
                on: {
                  click: function($event) {
                    return _vm.picturePreview(imgUrl)
                  }
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "choicess" },
        _vm._l(_vm.choices, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              class: { item: true, active: item.checked },
              on: {
                click: function($event) {
                  return _vm.updateChecked(index)
                }
              }
            },
            [
              _c("span", [_vm._v(_vm._s(item.content))]),
              _vm._v(" "),
              item.checked
                ? _c("img", {
                    staticStyle: { width: "18px", height: "18px" },
                    attrs: {
                      src: __webpack_require__(638),
                      alt: ""
                    }
                  })
                : _c("div", {
                    staticStyle: { "min-width": "18px", "min-height": "18px" }
                  })
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          class: { "submit-btn": true, active: _vm.btnDisabled },
          attrs: { type: "primary" },
          on: { click: _vm.submit }
        },
        [_vm._v("提交")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f56d7d6", esExports)
  }
}

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_answerResultDialog_vue__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_answerResultDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_answerResultDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_answerResultDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_answerResultDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_575d7978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_answerResultDialog_vue__ = __webpack_require__(1578);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1576)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-575d7978"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_answerResultDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_575d7978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_answerResultDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/videoDetail/answerResultDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-575d7978", Component.options)
  } else {
    hotAPI.reload("data-v-575d7978", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1577);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d2400d24", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-575d7978\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./answerResultDialog.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-575d7978\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./answerResultDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n[data-v-575d7978] .el-dialog__header {\n  text-align: center;\n}\n.submit-btn[data-v-575d7978] {\n  width: 140px;\n  height: 40px;\n  margin-left: 55px;\n  margin-top: 30px;\n  border-radius: 20px;\n}\n", ""]);

// exports


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "300px",
        title: "提示",
        "close-on-click-modal": false,
        "show-close": false,
        "destroy-on-close": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { "text-align": "center" } }, [
        _vm._v(
          _vm._s(
            _vm.isRight ? "恭喜你，答对了！" : "很遗憾，答错了！请重新学习。"
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "submit-btn",
          attrs: { type: "primary" },
          on: { click: _vm.submit }
        },
        [_vm._v(_vm._s(_vm.isRight ? "继续学习" : "重新学习"))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-575d7978", esExports)
  }
}

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c("div", { attrs: { id: "Return_Bar" } }, [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
          _vm._v("返回")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "text" } },
        [
          _c("div", { staticClass: "boxstyle" }),
          _vm._v(" "),
          _vm.knowledge.knowledgeType == "Pdf" && _vm.timerTimeValue
            ? _c("div", { staticClass: "study-countdown" }, [
                _vm._v(_vm._s(_vm.timerTimeValue))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.knowledge.knowledgeType == "Video"
            ? _c(
                "div",
                { staticClass: "video-player-box" },
                [
                  _c("videoPlayer", {
                    ref: "videoPlayer",
                    staticClass: "video-player",
                    attrs: { options: _vm.playerOptions },
                    on: {
                      play: _vm.onPlayerPlay,
                      pause: _vm.onPause,
                      ended: _vm.onPlayerEnded
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.knowledge.knowledgeType == "Pdf"
            ? [_c("div", { attrs: { id: "pdf_viewer" } })]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.currency, width: "360px" },
              on: {
                "update:visible": function($event) {
                  _vm.currency = $event
                }
              }
            },
            [
              _c("div", { staticClass: "currency_img" }, [
                _c("img", {
                  attrs: {
                    src: __webpack_require__(640),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "currency_text" }, [
                _vm.knowledgestate == 1
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.knowledgename))
                      ]),
                      _vm._v("”的学习"),
                      _c("br"),
                      _vm._v("接下来，请进行“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.nextknowledgename))
                      ]),
                      _vm._v("”的学习")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 &&
                _vm.Coursestate == "Exam" &&
                _vm.tabstate == null
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.knowledgename))
                      ]),
                      _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                      _c("br"),
                      _vm._v("接下来，请进行一个测试")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 &&
                _vm.Coursestate == "Practice" &&
                _vm.tabstate == null
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.knowledgename))
                      ]),
                      _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                      _c("br"),
                      _vm._v("接下来，请进行下一个练习")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 &&
                _vm.Coursestate == "Study" &&
                _vm.tabstate == null
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.knowledgename))
                      ]),
                      _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                      _c("br"),
                      _vm._v("接下来，请进行下一个课程的学习")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.tabstate == 2
                  ? _c("div", [
                      _vm._v("你已完成“"),
                      _c("span", { staticClass: "left_span" }, [
                        _vm._v(_vm._s(_vm.categoryName))
                      ]),
                      _vm._v("”的学习"),
                      _c("br"),
                      _vm._v("接下来，请进行下一个阶段的学习")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.tabstate == 1
                  ? _c("div", [
                      _vm._v("你已完成" + _vm._s(_vm.categoryName) + "的学习")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("div", { staticClass: "currency_button" }, [
                    _vm.knowledgestate == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.determine }
                          },
                          [_vm._v("去学习")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 && _vm.Coursestate == "Exam"
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.determine }
                          },
                          [_vm._v("去测试")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 && _vm.Coursestate == "Study"
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.determine }
                          },
                          [_vm._v("继续学习")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 && _vm.Coursestate == "Practice"
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.determine }
                          },
                          [_vm._v("去练习")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 &&
                    _vm.tabstate == 2 &&
                    _vm.dazhiJump == false
                      ? _c(
                          "div",
                          {
                            staticClass: "otherdetermine",
                            on: { click: _vm.goindex }
                          },
                          [
                            _vm._v(
                              "\n            去报名并参加" +
                                _vm._s(_vm.nextcategoryName)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 &&
                    _vm.tabstate == 2 &&
                    _vm.dazhiJump
                      ? _c(
                          "div",
                          {
                            staticClass: "otherdetermine",
                            on: { click: _vm.goindex }
                          },
                          [_vm._v("去学习\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.knowledgestate == 2 && _vm.tabstate == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "determine",
                            on: { click: _vm.goindex }
                          },
                          [_vm._v("我知道了")]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.nextExamCourse
            ? _c("exam-dialog", {
                attrs: {
                  id: _vm.id,
                  visible: _vm.examVisible,
                  courseId: _vm.nextCourseId,
                  tabMajorId: _vm.tabMajorId,
                  majorId: _vm.majorId,
                  type: _vm.type,
                  isListPage: false,
                  parent: _vm.parent
                },
                on: { callback: _vm.closeDialog }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("knowledge-dialog", {
        attrs: {
          show: _vm.knowledgeDialogObj.visible,
          courseId: _vm.knowledgeDialogObj.courseId,
          knowledgeId: _vm.knowledgeDialogObj.knowledgeId,
          playSecondsAt: _vm.knowledgeDialogObj.playSecondsAt
        },
        on: {
          handleChildEvent: _vm.handleChildEventMethod,
          result: _vm.knowledgeResult
        }
      }),
      _vm._v(" "),
      _c("answer-result-dialog", {
        attrs: {
          isRight: _vm.answerResultDialogObj.isRight,
          show: _vm.answerResultDialogObj.visible
        },
        on: { goonOrNot: _vm.goonOrNot }
      }),
      _vm._v(" "),
      _vm.largerVisible
        ? _c("div", { staticClass: "img-fix-bg" }, [
            _c("div", { staticClass: "larger-box" }, [
              _c("img", { attrs: { src: _vm.largerUrl } })
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-close close",
              on: {
                click: function($event) {
                  _vm.largerVisible = false
                }
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8234984", esExports)
  }
}

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webPageLink_vue__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webPageLink_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webPageLink_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webPageLink_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webPageLink_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031f84a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_webPageLink_vue__ = __webpack_require__(1583);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1581)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-031f84a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webPageLink_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031f84a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_webPageLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/webPageLink.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-031f84a2", Component.options)
  } else {
    hotAPI.reload("data-v-031f84a2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("44712a5e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-031f84a2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./webPageLink.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-031f84a2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./webPageLink.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#train[data-v-031f84a2] {\n  padding: 0;\n}\n#Return_Bar[data-v-031f84a2] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n[data-v-031f84a2] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-031f84a2] {\n  background: #f6f5f8;\n  width: 100%;\n  padding: 20px 20px;\n}\n.isreturn[data-v-031f84a2] {\n  color: #000;\n  cursor: pointer;\n}\n.boxstyle[data-v-031f84a2] {\n  display: flex;\n  justify-content: space-between;\n  margin: 10px 0;\n}\n.timestyle[data-v-031f84a2] {\n  margin: 0 20px;\n  height: 28px;\n  line-height: 28px;\n}\n[data-v-031f84a2] .el-dialog {\n  border-radius: 10px;\n}\n[data-v-031f84a2] .el-dialog__header {\n  border-bottom: 1px solid #E9E9E9;\n}\n[data-v-031f84a2] .el-dialog__title {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n}\n.currency_img[data-v-031f84a2] {\n  width: 85px;\n  height: 64px;\n  margin: 0 auto;\n  margin-bottom: 12px;\n}\n.currency_img > img[data-v-031f84a2] {\n  width: 100%;\n  height: 100%;\n}\n.currency_text[data-v-031f84a2] {\n  text-align: center;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 20px;\n}\n.currency_text > span[data-v-031f84a2] {\n  color: #497AF2;\n}\n.cancel[data-v-031f84a2] {\n  width: 80px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #717171;\n  text-align: center;\n  line-height: 28px;\n  margin-right: 10px;\n}\n.determine[data-v-031f84a2] {\n  width: 80px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.currency_button[data-v-031f84a2] {\n  display: flex;\n  justify-content: center;\n}\n.left_span[data-v-031f84a2] {\n  color: #497AF2;\n}\n.otherdetermine[data-v-031f84a2] {\n  padding: 0px 15px 0px 15px;\n  height: 33px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 33px;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "train" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "text" } }, [
      _c("div", { staticClass: "boxstyle" }),
      _vm._v(" "),
      _c("iframe", {
        staticClass: "frame",
        attrs: { src: _vm.urlLink, scrolling: "auto", frameborder: "0" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-031f84a2", esExports)
  }
}

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8ae64a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examDetail_vue__ = __webpack_require__(1587);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1585)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8ae64a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8ae64a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/examDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a8ae64a4", Component.options)
  } else {
    hotAPI.reload("data-v-a8ae64a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1586);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("68a3e6db", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a8ae64a4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./examDetail.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a8ae64a4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./examDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#train[data-v-a8ae64a4] {\n  padding: 0 0 0 20px !important;\n}\n.correct_img[data-v-a8ae64a4] {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto;\n  margin-bottom: 10px;\n}\n.score[data-v-a8ae64a4] {\n  font-size: 36px;\n  font-family: Source Han Sans CN;\n  font-weight: bold;\n  color: #497AF2;\n  line-height: 18px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n.state_text1[data-v-a8ae64a4] {\n  font-size: 18px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n  line-height: 18px;\n  text-align: center;\n  margin-left: 15px;\n  margin-bottom: 11px;\n}\n.state_text2[data-v-a8ae64a4] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n  text-align: center;\n  margin-left: 15px;\n}\n.state_text2 > .spanclass[data-v-a8ae64a4] {\n  color: #497AF2;\n}\n[data-v-a8ae64a4] .el-dialog--center {\n  border-radius: 10px;\n}\n.state_text1_1[data-v-a8ae64a4] {\n  background: #FFFFFF;\n  border-radius: 10px;\n  margin-bottom: 11px;\n  color: #262626;\n  text-align: center;\n  font-size: 14px;\n}\n.failed[data-v-a8ae64a4] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n  margin-left: 15px;\n  margin-top: 20px;\n  text-align: center;\n  margin-bottom: 59px;\n}\n.failed > span[data-v-a8ae64a4] {\n  color: #497AF2;\n}\n.state_text1_2[data-v-a8ae64a4] {\n  margin-top: 78px;\n}\n.badge_box[data-v-a8ae64a4] {\n  text-align: center;\n}\n.badge[data-v-a8ae64a4] {\n  margin-top: 31px;\n  margin-bottom: 40px;\n  width: 209px;\n  display: inline-block;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n}\n[data-v-a8ae64a4] .el-dialog--center .el-dialog__body {\n  padding: 25px 25px 0px 30px;\n}\n[data-v-a8ae64a4] .el-dialog__footer {\n  padding: 0px 20px 20px 20px;\n}\n.button_box[data-v-a8ae64a4] {\n  display: flex;\n  justify-content: center;\n}\n.button_box1[data-v-a8ae64a4] {\n  text-align: center;\n}\n.out_button_1[data-v-a8ae64a4] {\n  width: 100px;\n  height: 28px;\n  background: #DBE5FF;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #497AF2;\n  line-height: 28px;\n  margin-right: 10px;\n  cursor: pointer;\n}\n.out_button_2[data-v-a8ae64a4] {\n  width: 100px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  line-height: 28px;\n  cursor: pointer;\n}\n.out_button_3[data-v-a8ae64a4] {\n  width: 100px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  line-height: 28px;\n  cursor: pointer;\n  margin: 0 auto;\n}\n.newtext[data-v-a8ae64a4] {\n  margin-bottom: 40px;\n  margin-left: 0px !important;\n}\n.dialog-footer[data-v-a8ae64a4] .el-button {\n  background: #497AF2;\n  color: #fff;\n}\n", ""]);

// exports


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam", attrs: { id: "train" } },
    [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "exam-con" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.paperQuestion, function(l, key) {
                return [
                  _c(
                    "div",
                    { staticClass: "type" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.getNum(key)) +
                              "、" +
                              _vm._s(l.title) +
                              "（共" +
                              _vm._s(l.questionRecordFullList.length) +
                              "题，每题" +
                              _vm._s(l.eachScore) +
                              "分）"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(l.questionRecordFullList, function(q, index) {
                        return _c(
                          "div",
                          { staticClass: "list" },
                          [
                            q.answerRecord
                              ? [
                                  q.answerRecord.questionType == "BlankFilling"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.answerRecord.question
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.answerRecord
                                                            .question
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.answerRecord.question.questionStem.length - 1"
                                                      }
                                                    ],
                                                    attrs: {
                                                      placeholder: "请输入答案"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "savelist[key][index].tjkAnswerString[k]"
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "BlankChoice"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、\n                    "
                                            ),
                                            _vm._l(
                                              q.answerRecord.question
                                                .questionStem,
                                              function(s, k) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.replaceNToBr(s)
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          k !=
                                                          q.answerRecord
                                                            .question
                                                            .questionStem
                                                            .length -
                                                            1,
                                                        expression:
                                                          "k != q.answerRecord.question.questionStem.length - 1"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString[k],
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString[k]"
                                                      }
                                                    ],
                                                    staticClass: "answer-input",
                                                    attrs: {
                                                      type: "text",
                                                      size: "1",
                                                      maxlength: "1",
                                                      placeholder: "请输入答案"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.savelist[key][index]
                                                          .tjkAnswerString[k]
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                          k,
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ]
                                    : [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              id: _vm.savelist[key][index].num
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.savelist[key][index].num
                                              ) + "、"
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.replaceNToBr(
                                                    q.answerRecord.question
                                                      .questionStemString
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                  _vm._v(" "),
                                  q.answerRecord.question.imageUrlList
                                    ? _c(
                                        "p",
                                        [
                                          _vm._l(
                                            q.answerRecord.question
                                              .imageUrlList,
                                            function(i) {
                                              return [
                                                i != ""
                                                  ? _c("img", {
                                                      staticClass: "s-img",
                                                      attrs: { src: i },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.clickImg(
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  q.answerRecord.questionType == "SingleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.answerRecord.question.choices,
                                            function(value, k) {
                                              return _c(
                                                "p",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: { label: k },
                                                      model: {
                                                        value:
                                                          _vm.savelist[key][
                                                            index
                                                          ].tjkAnswerString,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.savelist[key][
                                                              index
                                                            ],
                                                            "tjkAnswerString",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "savelist[key][index].tjkAnswerString"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(k) +
                                                          "、" +
                                                          _vm._s(value)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "MultipleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              _vm._l(
                                                q.answerRecord.question.choices,
                                                function(value, k) {
                                                  return _c(
                                                    "p",
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        { attrs: { label: k } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(k) +
                                                              "、" +
                                                              _vm._s(value)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "TrueOrFalse"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.savelist[key][index],
                                                      "tjkAnswerString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: true }
                                                      },
                                                      [_vm._v("正确")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: false }
                                                      },
                                                      [_vm._v("错误")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "BlankChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.answerRecord.question.choices,
                                            function(value, k) {
                                              return _c("p", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(k) +
                                                      "、" +
                                                      _vm._s(value)
                                                  )
                                                ])
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "ShortAnswer"
                                    ? [
                                        _c("div", { staticClass: "answer" }, [
                                          _c("p", [
                                            _vm._v("答案："),
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.savelist[key][index]
                                                      .tjkAnswerString,
                                                  expression:
                                                    "savelist[key][index].tjkAnswerString"
                                                }
                                              ],
                                              staticClass:
                                                "answer-input shortanswer",
                                              domProps: {
                                                value:
                                                  _vm.savelist[key][index]
                                                    .tjkAnswerString
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.savelist[key][index],
                                                    "tjkAnswerString",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ])
                                        ])
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "count" }, [
          _c("h2", [_vm._v("统计")]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", [_vm._v("距自动交卷时间")]),
            _vm._v(" "),
            _c("span", { staticClass: "blue" }, [_vm._v(_vm._s(_vm.time))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v("满分100分，" + _vm._s(_vm.passScore) + "分及格")
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.list, function(s) {
              return _c(
                "li",
                { class: { active3: _vm.getClass(s.tjkAnswerString) } },
                [
                  _c("a", { attrs: { href: "#" + s.num } }, [
                    _vm._v(_vm._s(s.num))
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn" }, [
            _c("div", { staticClass: "hold", on: { click: _vm.exitExam } }, [
              _vm._v("返回学习")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "submit", on: { click: _vm.saveExam } }, [
              _vm._v("提交试卷")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.completeDialogVisible,
            width: "360px",
            "close-on-click-modal": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.completeDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state == "passed",
                  expression: "state == 'passed'"
                }
              ],
              staticClass: "correct_img"
            },
            [
              _c("img", {
                attrs: {
                  src: __webpack_require__(638),
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state == "failed",
                  expression: "state == 'failed'"
                }
              ],
              staticClass: "correct_img"
            },
            [
              _c("img", {
                attrs: {
                  src: __webpack_require__(1588),
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state == "passed",
                  expression: "state == 'passed'"
                }
              ],
              staticClass: "score"
            },
            [_vm._v(_vm._s(_vm.score) + "分")]
          ),
          _vm._v(" "),
          _vm.state == "passed"
            ? _c("div", { staticClass: "state_text1" }, [_vm._v("恭喜你！")])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "failed"
            ? _c("div", { staticClass: "state_text1" }, [_vm._v("很遗憾！")])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "failed"
            ? _c("div", { staticClass: "state_text1_1" }, [
                _vm._v("你未通过测试检验")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToCourse" &&
          (_vm.Graduation == "false" || _vm.Graduation == "") &&
          _vm.tabstate == null
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("你已通过“\n      "),
                _c("span", { staticClass: "spanclass" }, [
                  _vm._v(_vm._s(_vm.knowledgename))
                ]),
                _vm._v("\n      ”"),
                _c("br"),
                _vm._v("接下来，请进行下一个课程的"),
                _vm.Coursestate == "Study"
                  ? _c("span", [_vm._v("学习")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.Coursestate == "Practice"
                  ? _c("span", [_vm._v("练习")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.Coursestate == "Exam"
                  ? _c("span", [_vm._v("测试")])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.tabstate == "noNextTab" &&
          _vm.trainFlag == "theory"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("你已通过“"),
                _c("span", { staticClass: "spanclass" }, [_vm._v("理论考试")]),
                _vm._v("”")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.tabstate == "noNextTab" &&
          _vm.trainFlag != "theory"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("你已通过“"),
                _c("span", { staticClass: "spanclass" }, [
                  _vm._v(_vm._s(_vm.categoryName))
                ]),
                _vm._v("”")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToKnowledge" &&
          _vm.Graduation == "true"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("\n      你已通过“"),
                _c("span", [_vm._v(_vm._s(_vm.Coursename))]),
                _vm._v("”")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" && _vm.tabstate == 0 && _vm.Graduation == "true"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v(
                  "\n      你已通过语音" +
                    _vm._s(_vm.categoryName) +
                    "全部课程的学习"
                ),
                _c("br"),
                _vm._v("并获得“" + _vm._s(_vm.huizhang) + "”徽章"),
                _c("br"),
                _vm._v("现在可以领取语音任务了")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.tabstate == "noNextTab" &&
          _vm.Graduation == "true"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v(
                  "\n      你已通过语音" +
                    _vm._s(_vm.categoryName) +
                    "全部课程的学习"
                ),
                _c("br"),
                _vm._v("并获得“" + _vm._s(_vm.huizhang) + "”徽章"),
                _c("br"),
                _vm._v("现在可以领取语音任务了")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToCourse" &&
          _vm.tabstate == "noNextTab" &&
          (_vm.Graduation == "false" || _vm.Graduation == "") &&
          _vm.trainFlag == "theory"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("\n      接下来请进行下一个课程的学习")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToCourse" &&
          _vm.tabstate == "noNextTab" &&
          (_vm.Graduation == "false" || _vm.Graduation == "") &&
          _vm.trainFlag != "theory"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("\n      你已通过全部课程的学习"),
                _c("br"),
                _vm._v("现在可以领取任务了")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.state == "passed" &&
          _vm.knowledgestate == "jumpToCourse" &&
          _vm.tabstate == "hasNextTab"
            ? _c("div", { staticClass: "state_text2 newtext" }, [
                _vm._v("你已通过“\n      "),
                _c("span", { staticClass: "spanclass" }, [
                  _vm._v(_vm._s(_vm.categoryName))
                ]),
                _vm._v("\n      ” "),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$route.query.trainFlag == "fbtTrain"
                        ? "接下来，请完善你的在线经验和意向班次"
                        : "接下来，请进行下一阶段的学习"
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _vm.state == "failed"
            ? _c("div", { staticClass: "failed" }, [
                _vm._v("测试分数："),
                _c("span", [_vm._v(_vm._s(_vm.score))]),
                _vm._v("分；剩余测试次数："),
                _c("span", [_vm._v(_vm._s(_vm.times))]),
                _vm._v("次")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "button_box1" }, [
                _vm.state == "passed" &&
                _vm.tabstate == "noNextTab" &&
                _vm.trainFlag != "theory"
                  ? _c(
                      "div",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.isreturn }
                      },
                      [_vm._v("我知道了")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.tabstate == "noNextTab" &&
                _vm.trainFlag == "theory"
                  ? _c(
                      "div",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.goindex }
                      },
                      [_vm._v("去报名并参加实操培训\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.tabstate == null &&
                _vm.Coursestate != "Study"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.determine }
                      },
                      [
                        _vm._v("去"),
                        _vm.Coursestate == "Practice"
                          ? _c("span", [_vm._v("练习")])
                          : _vm._e(),
                        _vm.Coursestate == "Exam"
                          ? _c("span", [_vm._v("测试")])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.tabstate == null &&
                _vm.Coursestate == "Study"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.determine }
                      },
                      [_vm._v("继续学习")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.tabstate == "hasNextTab" &&
                _vm.trainFlag == "theory"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.goindex }
                      },
                      [_vm._v("去报名并参加" + _vm._s(_vm.nextcategoryName))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.trainFlag != "theory" &&
                _vm.trainFlag == "fbtTrain"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.goUpdateExp }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.fbtBadge || _vm.state == "passed"
                              ? "修改经验"
                              : "去完善"
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state == "passed" &&
                _vm.knowledgestate == "jumpToCourse" &&
                _vm.tabstate == "hasNextTab" &&
                _vm.trainFlag != "theory" &&
                _vm.trainFlag != "fbtTrain"
                  ? _c(
                      "div",
                      {
                        staticClass: "out_button_3",
                        attrs: { type: "primary" },
                        on: { click: _vm.goindex }
                      },
                      [_vm._v("我知道了")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.state == "failed"
                ? _c("div", { staticClass: "button_box" }, [
                    _c(
                      "div",
                      { staticClass: "out_button_1", on: { click: _vm.again } },
                      [_vm._v("继续测试")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "out_button_2",
                        on: { click: _vm.relearn }
                      },
                      [_vm._v("重新学习")]
                    ),
                    _vm._v(" "),
                    _vm.showExamError
                      ? _c(
                          "div",
                          {
                            staticClass: "out_button_2",
                            staticStyle: { "margin-left": "10px" },
                            on: { click: _vm.goCuotiji }
                          },
                          [_vm._v("错题集")]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.showImg
        ? _c("zoom-img", {
            attrs: { imgSrc: _vm.imgSrc },
            on: { clickit: _vm.viewImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8ae64a4", esExports)
  }
}

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7150910c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examResult_vue__ = __webpack_require__(1592);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1590)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7150910c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7150910c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/examResult.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7150910c", Component.options)
  } else {
    hotAPI.reload("data-v-7150910c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1591);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("102a243f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7150910c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./examResult.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7150910c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./examResult.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.count[data-v-7150910c] {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  flex-direction: column;\n}\n.count > p[data-v-7150910c] {\n  font-size: 30px;\n  padding: 20px 0;\n}\n.score-box[data-v-7150910c] {\n  margin: 10px 0;\n}\n.score-box span[data-v-7150910c] {\n  color: #666666;\n  font-size: 16px;\n  line-height: 30px;\n  margin-right: 20px;\n}\n.score-box span.num[data-v-7150910c] {\n  font-weight: bold;\n}\n.score-box span[data-v-7150910c]:last-child {\n  margin-right: 0;\n}\n.btn-box[data-v-7150910c] {\n  margin-top: 30px;\n}\n.btn-box > span[data-v-7150910c] {\n  background: #497AF2;\n  border-radius: 6px;\n  color: #fff;\n  width: 152px;\n  text-align: center;\n  cursor: pointer;\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 16px;\n  line-height: 20px;\n  margin-right: 20px;\n}\n.btn-box > span[data-v-7150910c]:last-child {\n  margin-right: 0;\n}\n.textimg[data-v-7150910c] {\n  width: 20vw;\n}\n.result-text[data-v-7150910c] {\n  color: #000;\n  font-weight: 500;\n  font-size: 18px;\n}\n.btn-box > span[data-v-7150910c] {\n  border-radius: 20px !important;\n}\n.relearn_button[data-v-7150910c] {\n  background-color: #d3d5d7 !important;\n  color: #898a8c !important;\n}\n", ""]);

// exports


/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam" }, [
    _c("div", { staticClass: "count" }, [
      _vm.examPassState == "passed" && _vm.parent == "jineng" && _vm.voiceBadge
        ? _c("div", [
            _c("img", {
              staticClass: "textimg",
              attrs: {
                src:
                  "http://res.study.itaojin.cn/2020-11/7d643a6946e548d3b20c87b45516875b.png",
                alt: ""
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p"),
      _vm.examPassState == "passed" &&
      _vm.parent != "jineng" &&
      _vm.newPeopleBadge
        ? _c("div", { staticClass: "result-txt result-text" }, [
            _vm._v("你已通过该课程的学习与考试!")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "passed" && _vm.parent == "jineng" && _vm.voiceBadge
        ? _c("div", { staticClass: "result-txt result-text" }, [
            _vm._v("你已通过技能提升，现在可以去领任务了")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "passed" && _vm.isexamination == false
        ? _c("div", { staticClass: "result-txt result-text" }, [
            _vm._v("你已通过该课程！")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "failed"
        ? _c("span", { staticClass: "result-txt" }, [
            _vm._v("很遗憾您未通过考试")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _vm.examPassState == "failed"
        ? _c("div", { staticClass: "score-box" }, [
            _c("span", [
              _vm._v("测试分数："),
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.score) + "分")
              ])
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("剩余测试机会："),
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(_vm.remainingExamTimes) + "次")
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "failed" || _vm.isexamination == false
        ? _c("div", { staticClass: "btn-box" }, [
            _c(
              "span",
              {
                staticClass: "relearn_button",
                on: { click: _vm.returnCourseList }
              },
              [_vm._v("点击重新学习")]
            ),
            _vm._v(" "),
            _c("span", { on: { click: _vm.beginExam } }, [_vm._v("再测一次")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.examPassState == "passed" && _vm.parent == "jineng" && _vm.voiceBadge
        ? _c("div", { staticClass: "btn-box" }, [
            _c("span", { on: { click: _vm.returnscene } }, [
              _vm._v("返回到场景")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7150910c", esExports)
  }
}

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basicExamDetail_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basicExamDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basicExamDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basicExamDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basicExamDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dce04a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basicExamDetail_vue__ = __webpack_require__(1596);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1594)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dce04a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basicExamDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dce04a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basicExamDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/basicExamDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2dce04a0", Component.options)
  } else {
    hotAPI.reload("data-v-2dce04a0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1595);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("366ec67c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2dce04a0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./basicExamDetail.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2dce04a0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./basicExamDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.my-disabled[data-v-2dce04a0] {\n  pointer-events: none;\n}\n#train[data-v-2dce04a0] {\n  padding: 0 0 0 20px !important;\n}\n.correct_img[data-v-2dce04a0] {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto;\n  margin-bottom: 10px;\n}\n.score[data-v-2dce04a0] {\n  font-size: 36px;\n  font-family: Source Han Sans CN;\n  font-weight: bold;\n  color: #497AF2;\n  line-height: 18px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n.state_text1[data-v-2dce04a0] {\n  font-size: 18px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n  line-height: 18px;\n  text-align: center;\n  margin-left: 15px;\n  margin-bottom: 11px;\n}\n.state_text2[data-v-2dce04a0] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n  text-align: center;\n  margin-left: 15px;\n}\n.state_text2 > .spanclass[data-v-2dce04a0] {\n  color: #497AF2;\n}\n[data-v-2dce04a0] .el-dialog--center {\n  border-radius: 10px;\n}\n.state_text1_1[data-v-2dce04a0] {\n  background: #FFFFFF;\n  border-radius: 10px;\n  margin-bottom: 11px;\n  color: #262626;\n  text-align: center;\n  font-size: 14px;\n}\n.failed[data-v-2dce04a0] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n  margin-left: 15px;\n  margin-top: 20px;\n  text-align: center;\n  margin-bottom: 59px;\n}\n.failed > span[data-v-2dce04a0] {\n  color: #497AF2;\n}\n.state_text1_2[data-v-2dce04a0] {\n  margin-top: 78px;\n}\n.badge_box[data-v-2dce04a0] {\n  text-align: center;\n}\n.badge[data-v-2dce04a0] {\n  margin-top: 31px ;\n  margin-bottom: 40px;\n  width: 209px;\n  display: inline-block;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n}\n[data-v-2dce04a0] .el-dialog--center .el-dialog__body {\n  padding: 25px 25px 0px 30px;\n}\n[data-v-2dce04a0] .el-dialog__footer {\n  padding: 0px 20px 20px 20px;\n}\n.button_box[data-v-2dce04a0] {\n  display: flex;\n  justify-content: center;\n}\n.button_box1[data-v-2dce04a0] {\n  text-align: center;\n}\n.out_button_1[data-v-2dce04a0] {\n  width: 100px;\n  height: 28px;\n  background: #DBE5FF;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #497AF2;\n  line-height: 28px;\n  margin-right: 10px;\n  cursor: pointer;\n}\n.out_button_2[data-v-2dce04a0] {\n  width: 100px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  line-height: 28px;\n  cursor: pointer;\n}\n.out_button_3[data-v-2dce04a0] {\n  width: 100px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  line-height: 28px;\n  cursor: pointer;\n  margin: 0 auto;\n}\n.newtext[data-v-2dce04a0] {\n  margin-bottom: 40px;\n  margin-left: 0px !important;\n}\n.dialog-footer[data-v-2dce04a0] .el-button {\n  background: #497AF2;\n  color: #fff;\n}\n.right[data-v-2dce04a0] {\n  color: #09ae14;\n}\n.wrong[data-v-2dce04a0] {\n  color: #f8370e;\n}\n", ""]);

// exports


/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam", attrs: { id: "train" } },
    [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "exam-con" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.groupRecordList, function(l, QIndex) {
                return [
                  _c(
                    "div",
                    { staticClass: "type" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.getNum(QIndex)) +
                              "、" +
                              _vm._s(l.title) +
                              "（共" +
                              _vm._s(l.questionRecordFullList.length) +
                              "题，每题" +
                              _vm._s(l.eachScore) +
                              "分）"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(l.questionRecordFullList, function(q, index) {
                        return _c("div", { staticClass: "list" }, [
                          q.answerRecord
                            ? _c(
                                "div",
                                { attrs: { title: q.num } },
                                [
                                  _c("p", [
                                    q.answerRecord.answerState == "Right"
                                      ? _c("span", { staticClass: "right" }, [
                                          _vm._v("【正确】")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    q.answerRecord.answerState == "Wrong"
                                      ? _c("span", { staticClass: "wrong" }, [
                                          _vm._v("【错误】")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    q.answerRecord.answerState == "HalfRight"
                                      ? _c("span", { staticClass: "right" }, [
                                          _vm._v("【部分正确】")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    q.answerRecord.answerState == "Blank"
                                      ? _c("span", { staticClass: "wrong" }, [
                                          _vm._v("【未作答】")
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(q.num) +
                                        "、"
                                    ),
                                    _c("span", {
                                      attrs: { id: q.num },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.replaceNToBr(
                                            q.answerRecord.question
                                              .questionStemString
                                          )
                                        )
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  q.answerRecord.question.imageUrlList &&
                                  q.answerRecord.question.imageUrlList.length >
                                    0
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          q.answerRecord.question.imageUrlList,
                                          function(i) {
                                            return _c("img", {
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px"
                                              },
                                              attrs: { src: i },
                                              on: {
                                                click: function($event) {
                                                  return _vm.clickImg($event)
                                                }
                                              }
                                            })
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  q.answerRecord.questionType == "SingleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.answerRecord.question.choices,
                                            function(value, k) {
                                              return _c(
                                                "p",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      staticClass:
                                                        "my-disabled",
                                                      attrs: { label: k },
                                                      model: {
                                                        value:
                                                          q.answerRecord
                                                            .tjkAnswer,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            q.answerRecord,
                                                            "tjkAnswer",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "q.answerRecord.tjkAnswer"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(k) +
                                                          "、" +
                                                          _vm._s(value)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "MultipleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                staticClass: "my-disabled",
                                                model: {
                                                  value:
                                                    q.answerRecord.tjkAnswer,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      q.answerRecord,
                                                      "tjkAnswer",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "q.answerRecord.tjkAnswer"
                                                }
                                              },
                                              _vm._l(
                                                q.answerRecord.question.choices,
                                                function(value, k) {
                                                  return _c(
                                                    "p",
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        { attrs: { label: k } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(k) +
                                                              "、" +
                                                              _vm._s(value)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "TrueOrFalse"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                staticClass: "my-disabled",
                                                model: {
                                                  value:
                                                    q.answerRecord.tjkAnswer,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      q.answerRecord,
                                                      "tjkAnswer",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "q.answerRecord.tjkAnswer"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: true }
                                                      },
                                                      [_vm._v("正确")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: false }
                                                      },
                                                      [_vm._v("错误")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "count" }, [
          _c("h2", [_vm._v("统计")]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("span", { staticClass: "blue" }, [
              _vm._v(
                _vm._s(
                  _vm.examRecord.score >= _vm.exam.passScore ? "通过" : "未通过"
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v("得分：" + _vm._s(_vm.examRecord.score))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v("通过分数：" + _vm._s(_vm.exam.passScore))
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _vm._l(_vm.groupRecordList, function(l, QIndex) {
                return [
                  _vm._l(l.questionRecordFullList, function(q, qIndex) {
                    return [
                      _c(
                        "li",
                        {
                          class: {
                            active2: q.answerRecord.answerState == "Right",
                            active4: q.answerRecord.answerState != "Right"
                          }
                        },
                        [
                          _c("a", { attrs: { href: "#" + q.num } }, [
                            _vm._v(_vm._s(q.num))
                          ])
                        ]
                      )
                    ]
                  })
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn" }, [
            _c("div", { staticClass: "hold", on: { click: _vm.exitExam } }, [
              _vm._v("继续测试")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hold", on: { click: _vm.relearn } }, [
              _vm._v("重新学习")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showImg
        ? _c("zoom-img", {
            attrs: { imgSrc: _vm.imgSrc },
            on: { clickit: _vm.viewImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dce04a0", esExports)
  }
}

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eaa3737_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courseList_vue__ = __webpack_require__(1602);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1598)
  __webpack_require__(1600)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5eaa3737"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eaa3737_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courseList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/courseList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5eaa3737", Component.options)
  } else {
    hotAPI.reload("data-v-5eaa3737", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1599);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7a459741", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5eaa3737\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./courseList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5eaa3737\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./courseList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#train[data-v-5eaa3737] {\n  background: #f5f6f7;\n  height: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1601);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d73dd440", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5eaa3737\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./courseList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5eaa3737\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./courseList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.priContent[data-v-5eaa3737] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.priContent .prictice .pricComfir[data-v-5eaa3737] {\n  width: 100%;\n  margin-top: 20px;\n  padding-bottom: 50px;\n}\n.priContent .prictice .comTitle[data-v-5eaa3737] {\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n.priContent .prictice .content[data-v-5eaa3737] {\n  display: flex;\n}\n.priContent .prictice .input .el-input__inner[data-v-5eaa3737] {\n  border-radius: 10px;\n  width: 320px;\n}\n.priContent .prictice .comfirmBtn[data-v-5eaa3737] {\n  margin-left: 15px;\n  width: 170px;\n  line-height: 40px;\n  background-color: #D3D3D3;\n  text-align: center;\n  color: #fff;\n  border-radius: 15px;\n}\n.priContent .prictice .ActiveComBtn[data-v-5eaa3737] {\n  background-color: #118EF2;\n  cursor: pointer;\n}\n.priContent .prictice .stOrNew[data-v-5eaa3737] {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.priContent .prictice .defaultBtn[data-v-5eaa3737] {\n  width: 120px;\n  color: #fff;\n  border-radius: 20px;\n  text-align: center;\n  line-height: 35px;\n  height: 35px;\n  cursor: pointer;\n}\n.priContent .prictice .newPrict[data-v-5eaa3737] {\n  background-color: #008000;\n  margin-left: 20px;\n}\n.priContent .prictice .stopPrict[data-v-5eaa3737] {\n  background-color: #FF0000;\n}\n.priContent .prictice .handBox[data-v-5eaa3737] {\n  margin-top: 50px;\n}\n.titleposition[data-v-5eaa3737] {\n  display: flex;\n  justify-content: left;\n}\n.textposition[data-v-5eaa3737] {\n  margin-left: 10px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.isgreen[data-v-5eaa3737] {\n  color: #39CA54;\n}\n.isred[data-v-5eaa3737] {\n  color: #FF0000;\n}\n.status_style[data-v-5eaa3737] {\n  background: #FF0000 !important;\n}\n[data-v-5eaa3737] .el-dialog {\n  border-radius: 11px;\n}\n.isbox[data-v-5eaa3737] {\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "train" } }, [
    _c("div", { staticClass: "course-list" }, [
      _c("p", { staticClass: "nav", on: { click: _vm.toSceneList } }, [
        _c("span", { staticClass: "el-icon-arrow-left" }),
        _c("span", [_vm._v("返回")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5eaa3737", esExports)
  }
}

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_childCourseList_vue__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_childCourseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_childCourseList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_childCourseList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_childCourseList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc9f60b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_childCourseList_vue__ = __webpack_require__(1606);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1604)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc9f60b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_childCourseList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc9f60b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_childCourseList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/childCourseList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bc9f60b2", Component.options)
  } else {
    hotAPI.reload("data-v-bc9f60b2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1605);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2d3c49ab", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bc9f60b2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./childCourseList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bc9f60b2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./childCourseList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#train[data-v-bc9f60b2] {\n  background: #f5f6f7;\n  height: 100%;\n}\n.green[data-v-bc9f60b2] {\n  color: green !important;\n}\n.red[data-v-bc9f60b2] {\n  color: red !important;\n}\n.cancel_botton[data-v-bc9f60b2] {\n  background: #fff !important;\n  font-weight: 600 !important;\n  font-size: 16px;\n}\n.start_botton[data-v-bc9f60b2] {\n  background: #497AF2;\n  width: 80px;\n  height: 28px;\n  border-radius: 6px;\n  color: #fff;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  position: absolute;\n  right: 1%;\n  bottom: 20px;\n  font-weight: 300 !important;\n}\n.content_box[data-v-bc9f60b2] {\n  position: relative;\n}\n.status_botton[data-v-bc9f60b2] {\n  background: #497AF2;\n  width: 80px;\n  height: 28px;\n  border-radius: 6px;\n  color: #fff;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  position: absolute;\n  right: 1%;\n  bottom: 20px;\n  font-weight: 300 !important;\n  font-size: 15px !important;\n}\n.state_posi[data-v-bc9f60b2] {\n  margin-right: 15px ;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n}\n", ""]);

// exports


/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c(
        "div",
        { staticClass: "course-list child" },
        [
          _c("p", { staticClass: "nav", on: { click: _vm.toCourseList } }, [
            _c("span", { staticClass: "el-icon-arrow-left" }),
            _c("span", [_vm._v("返回")])
          ]),
          _vm._v(" "),
          _vm._l(_vm.courseList, function(c, key) {
            return _c("div", { staticClass: "step-list" }, [
              _c(
                "div",
                {
                  class: {
                    step: true,
                    active: c.passState == "Passed",
                    progress: c.passState == "Ongoing"
                  }
                },
                [
                  _c("div", {
                    class: {
                      icon: true,
                      "el-icon-success": c.passState == "Passed"
                    },
                    staticStyle: { top: "75px !important" }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "line",
                    staticStyle: { top: "92px !important" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content content_box" }, [
                _c("img", { attrs: { src: c.imageUrl } }),
                _vm._v(" "),
                _c("div", { staticClass: "box" }, [
                  _c(
                    "div",
                    { staticClass: "title" },
                    [
                      _c("div", [
                        _c("span", { staticClass: "type" }, [
                          _vm._v(_vm._s(c.categoryName))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(c.courseName))
                        ])
                      ]),
                      _vm._v(" "),
                      c.unlock
                        ? [
                            _c(
                              "div",
                              {
                                class: { cancel_botton: c.courseType != "Exam" }
                              },
                              [
                                c.courseType == "Exam" &&
                                c.passState != "Passed"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "status_botton",
                                        on: {
                                          click: function($event) {
                                            return _vm.toStudy(
                                              c.courseId,
                                              c.unlock,
                                              c.courseType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("开始测试")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                c.courseType == "Exam" &&
                                c.passState == "Passed"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "status_botton",
                                        on: {
                                          click: function($event) {
                                            return _vm.toStudy(
                                              c.courseId,
                                              c.unlock,
                                              c.courseType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("重新测试")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "state_posi",
                                    class:
                                      c.passState == "Passed" ? "green" : "red"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        c.passState == "Passed"
                                          ? "已完成"
                                          : "未完成"
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                c.passState == "Passed" &&
                                c.courseType != "Exam" &&
                                c.passState != "Study"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "start_botton",
                                        on: {
                                          click: function($event) {
                                            return _vm.toStudy(
                                              c.courseId,
                                              c.unlock,
                                              c.courseType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("继续学习")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                c.passState != "Passed" &&
                                c.courseType != "Exam" &&
                                c.passState != "Study"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "start_botton",
                                        on: {
                                          click: function($event) {
                                            return _vm.toStudy(
                                              c.courseId,
                                              c.unlock,
                                              c.courseType
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("开始学习")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        : [_c("div", { staticClass: "el-icon-lock" })]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text",
                      staticStyle: { height: "90px !important" }
                    },
                    [
                      _vm._v(
                        "\n            课程说明：" +
                          _vm._s(c.description) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("exam-dialog", {
        attrs: {
          visible: _vm.examVisible,
          id: _vm.id,
          courseId: _vm.examCourseId,
          tabMajorId: _vm.tabMajorId,
          majorId: _vm.majorId,
          type: _vm.type,
          isListPage: true,
          parent: "jineng"
        },
        on: { callback: _vm.closeDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc9f60b2", esExports)
  }
}

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partnerIndex_vue__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partnerIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partnerIndex_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partnerIndex_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partnerIndex_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a877270_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partnerIndex_vue__ = __webpack_require__(1610);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1608)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a877270"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partnerIndex_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a877270_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partnerIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/partnerIndex.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8a877270", Component.options)
  } else {
    hotAPI.reload("data-v-8a877270", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1609);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("48fca2bf", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8a877270\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partnerIndex.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8a877270\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partnerIndex.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.iframe-box[data-v-8a877270] {\n  width: 100%;\n  height: 100%;\n}\n.priContent[data-v-8a877270] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.priContent .prictice .imgBox[data-v-8a877270] {\n  display: flex;\n  justify-content: center;\n}\n.priContent .prictice .title[data-v-8a877270] {\n  font-weight: 700;\n  font-size: 16px;\n  margin-top: 10px;\n}\n.priContent .prictice .value[data-v-8a877270] {\n  margin-top: 10px;\n  color: #80858B;\n}\n.priContent .prictice .in-block[data-v-8a877270] {\n  display: inline-block;\n  margin-right: 10px;\n}\n.priContent .prictice .konwBox[data-v-8a877270] {\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n}\n.priContent .prictice .knowBtn[data-v-8a877270] {\n  width: 150px;\n  cursor: pointer;\n  height: 40px;\n  line-height: 40px;\n  background-color: #118EF2;\n  color: #fff;\n  border-radius: 15px;\n  text-align: center;\n}\n.priContent .prictice .pricComfir[data-v-8a877270] {\n  width: 100%;\n  margin-top: 20px;\n}\n.priContent .prictice .comTitle[data-v-8a877270] {\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n.priContent .prictice .content[data-v-8a877270] {\n  display: flex;\n}\n.priContent .prictice .input .el-input__inner[data-v-8a877270] {\n  border-radius: 10px;\n  width: 320px;\n}\n.priContent .prictice .comfirmBtn[data-v-8a877270] {\n  margin-left: 15px;\n  width: 170px;\n  line-height: 40px;\n  background-color: #D3D3D3;\n  text-align: center;\n  color: #fff;\n  border-radius: 15px;\n}\n.priContent .prictice .ActiveComBtn[data-v-8a877270] {\n  background-color: #118EF2;\n  cursor: pointer;\n}\n.priContent .prictice .stOrNew[data-v-8a877270] {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.priContent .prictice .defaultBtn[data-v-8a877270] {\n  width: 120px;\n  color: #fff;\n  border-radius: 20px;\n  text-align: center;\n  line-height: 35px;\n  height: 35px;\n  cursor: pointer;\n}\n.priContent .prictice .newPrict[data-v-8a877270] {\n  background-color: #008000;\n  margin-left: 20px;\n}\n.priContent .prictice .stopPrict[data-v-8a877270] {\n  background-color: #FF0000;\n}\n.priContent .prictice .handBox[data-v-8a877270] {\n  margin-top: 50px;\n}\n", ""]);

// exports


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c("div", { staticClass: "priContent" }, [
        _c("div", { staticClass: "prictice" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.step == "first"
            ? _c(
                "div",
                [
                  _vm._l(_vm.priList, function(item, i) {
                    return _c(
                      "div",
                      { key: i },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(_vm._s(item.title) + "：")
                        ]),
                        _vm._v(" "),
                        _vm._l(item.tips, function(priItem, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class:
                                item.title == "操作手册"
                                  ? "value in-block"
                                  : "value"
                            },
                            [_vm._v(_vm._s(priItem.value))]
                          )
                        }),
                        _vm._v(" "),
                        item.title == "操作手册"
                          ? _c(
                              "a",
                              {
                                staticClass: "goToNewAdd",
                                staticStyle: { color: "red" },
                                attrs: {
                                  href:
                                    "https://tjhawkeye.oss-cn-beijing.aliyuncs.com/hawkeye_v6/Files/%E5%AF%B9%E7%BB%83%E5%9C%BA%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%28PDF%29.pdf",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("点击查看操作手册")]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "konwBox" }, [
                    _c(
                      "div",
                      { staticClass: "knowBtn", on: { click: _vm.showKnow } },
                      [_vm._v("我已知晓")]
                    )
                  ])
                ],
                2
              )
            : _vm.step == "second"
            ? _c("div", { staticClass: "pricComfir" }, [
                _c("div", { staticClass: "comTitle" }, [
                  _vm._v(" 请输入对练搭档的9位数淘金号： ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c("el-input", {
                      staticClass: "input",
                      attrs: { placeholder: "请输入对练搭档的淘金号" },
                      model: {
                        value: _vm.input,
                        callback: function($$v) {
                          _vm.input = $$v
                        },
                        expression: "input"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: _vm.input
                          ? "comfirmBtn ActiveComBtn"
                          : "comfirmBtn",
                        on: { click: _vm.goToPrict }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ])
            : _vm.step == "handing"
            ? _c("div", { staticClass: "handBox" }, [
                _c("div", { staticClass: "stOrNew" }, [
                  _c(
                    "div",
                    {
                      staticClass: "stopPrict defaultBtn",
                      on: { click: _vm.stopPrict }
                    },
                    [_vm._v("结束对练")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "newPrict defaultBtn",
                      on: { click: _vm.newPrict }
                    },
                    [_vm._v("继续对练")]
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("span", [
            _vm._v(
              "是否确定与" +
                _vm._s(_vm.partner.realName) +
                "(" +
                _vm._s(_vm.partner.tjkNumber) +
                ")进行语音对练?"
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.clearSchedule }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imgBox" }, [
      _c("img", {
        attrs: { src: __webpack_require__(400), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a877270", esExports)
  }
}

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordDetail_vue__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98abdc40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordDetail_vue__ = __webpack_require__(1614);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1612)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98abdc40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98abdc40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/recordDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-98abdc40", Component.options)
  } else {
    hotAPI.reload("data-v-98abdc40", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1613);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("73ad3130", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-98abdc40\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./recordDetail.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-98abdc40\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./recordDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "train" } }, [
    _c("p", { staticClass: "nav", on: { click: _vm.toCourseList } }, [
      _c("span", { staticClass: "el-icon-arrow-left" }),
      _c("span", [_vm._v("返回")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-box" }, [
      _vm.lastRecordId
        ? _c("span", { on: { click: _vm.lastStudy } }, [_vm._v("上一课录音")])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "video-box" }, [
      _c(
        "video",
        {
          ref: "video",
          staticClass: "video",
          attrs: { src: _vm.record.url, controls: "controls" }
        },
        [_vm._v("\n        您的浏览器不支持 video 标签。\n      ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98abdc40", esExports)
  }
}

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecord_vue__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecord_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecord_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecord_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecord_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b522e98c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eachExerciseRecord_vue__ = __webpack_require__(1616);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecord_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b522e98c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eachExerciseRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/record/eachExerciseRecord.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b522e98c", Component.options)
  } else {
    hotAPI.reload("data-v-b522e98c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap" },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "练习时间" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "260px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "~",
                  "value-format": "yyyy-MM-dd",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期"
                },
                model: {
                  value: _vm.queryDate,
                  callback: function($$v) {
                    _vm.queryDate = $$v
                  },
                  expression: "queryDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "淘金客" } },
            [
              _c("tjkautocompleteall", {
                attrs: { tjkId: _vm.searchData.tjkId },
                on: { callBack: _vm.updateTjkId }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "扮演客户" } },
            [
              _c("tjkautocompleteall", {
                attrs: { teacherTjkId: _vm.searchData.toTjkId },
                on: { callBack: _vm.updateToTjkId }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "最低分数",
                prop: "minScore",
                rules: [{ type: "number", message: "必须为数字值" }]
              }
            },
            [
              _c("el-input", {
                attrs: { type: "minScore", autocomplete: "off" },
                model: {
                  value: _vm.searchData.minScore,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "minScore", _vm._n($$v))
                  },
                  expression: "searchData.minScore"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "最高分数",
                prop: "maxScore",
                rules: [{ type: "number", message: "必须为数字值" }]
              }
            },
            [
              _c("el-input", {
                attrs: { type: "maxScore", autocomplete: "off" },
                model: {
                  value: _vm.searchData.maxScore,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "maxScore", _vm._n($$v))
                  },
                  expression: "searchData.maxScore"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.exportList } },
                [_vm._v("导出")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "beginTime",
              label: "练习时间",
              align: "center",
              width: "150"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "realName",
              label: "客服",
              align: "center",
              width: "162"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n            " +
                        _vm._s(scope.row.realName) +
                        "（" +
                        _vm._s(scope.row.tjkNumber) +
                        "）\n         "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "teacherName",
              label: "扮演客户",
              align: "center",
              width: "162"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(scope.row.teacherName) +
                        "（" +
                        _vm._s(scope.row.teacherTjkNumber) +
                        "）\n        "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "练习结果", align: "center" } },
            [
              _c("el-table-column", {
                attrs: { prop: "baseScore", label: "基本条件", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skillScore",
                  label: "服务技巧",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "riteScore", label: "服务礼仪", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "flowScore", label: "服务流程", align: "center" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "gradeScore", label: "分数", align: "center" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: { pages: _vm.searchData.pages, pageNum: _vm.searchData.pageNum },
        on: { getData: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b522e98c", esExports)
  }
}

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecordAll_vue__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecordAll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecordAll_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecordAll_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecordAll_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568bd7b7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eachExerciseRecordAll_vue__ = __webpack_require__(1620);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1618)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-568bd7b7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachExerciseRecordAll_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568bd7b7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eachExerciseRecordAll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/record/eachExerciseRecordAll.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-568bd7b7", Component.options)
  } else {
    hotAPI.reload("data-v-568bd7b7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1619);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("36cad82d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-568bd7b7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./eachExerciseRecordAll.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-568bd7b7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./eachExerciseRecordAll.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n[data-v-568bd7b7].el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{color: #fff;border-radius: 20px 20px 0 0;margin-top: 10px;margin-left: 10px;\n    background-color: #497af2;\n}\n.isreturn[data-v-568bd7b7]{padding-left: 10px !important;cursor: pointer;background:#f5f6f7;\n}\n", ""]);

// exports


/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "nav isreturn", on: { click: _vm.toSceneList } }, [
        _c("span", { staticClass: "el-icon-arrow-left" }),
        _c("span", [_vm._v("返回")])
      ]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "扮演客服记录", name: "actAsKf" } },
            [
              _c(
                "div",
                { staticClass: "content-wrap" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.list,
                        border: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "beginTime",
                          label: "练习时间",
                          align: "center",
                          width: "150"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "courseName",
                          label: "课程名称",
                          align: "center",
                          "show-overflow-tooltip": "",
                          width: "280"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "callType",
                          label: "呼叫类型",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.callType == "inbund"
                                  ? _c("span", [_vm._v("内呼")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.callType == "outbund"
                                  ? _c("span", [_vm._v("外呼")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        { attrs: { label: "练习结果", align: "center" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "baseScore",
                              label: "基本条件",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skillScore",
                              label: "服务技巧",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "riteScore",
                              label: "服务礼仪",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "flowScore",
                              label: "服务流程",
                              align: "center"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "callInterval",
                          label: "时长(秒)",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "gradeScore",
                          label: "分数",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link-text",
                                    attrs: {
                                      href:
                                        "/tjkStudy/train/eachRecordDetail?id=" +
                                        scope.row.id +
                                        "&kf=" +
                                        _vm.tjkId,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "查看详情" + _vm._s(_vm.searchData.total)
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    attrs: {
                      pages: _vm.searchData.pages,
                      pageNum: _vm.searchData.pageNum
                    },
                    on: { getData: _vm.getList }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "扮演客户记录", name: "actAsKh" } },
            [
              _c(
                "div",
                { staticClass: "content-wrap" },
                [
                  _c("el-form", { attrs: { inline: true } }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.listActKh,
                        border: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "beginTime",
                          label: "扮演时间",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "courseName",
                          label: "课程名称",
                          align: "center",
                          "show-overflow-tooltip": "",
                          width: "280"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "callType",
                          label: "呼叫类型",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.callType == "inbund"
                                  ? _c("span", [_vm._v("内呼")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.callType == "outbund"
                                  ? _c("span", [_vm._v("外呼")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "teacherName",
                          label: "练习对象",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.teacherName) +
                                    "（" +
                                    _vm._s(scope.row.teacherTjkNumber) +
                                    "）\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "videoUrl",
                          label: "练习录音",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("audio", {
                                  attrs: {
                                    src: scope.row.videoUrl,
                                    controls: "controls"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    attrs: {
                      pages: _vm.searchData.pages,
                      pageNum: _vm.searchData.pageNum
                    },
                    on: { getData: _vm.getList }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-568bd7b7", esExports)
  }
}

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachRecordDetail_vue__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachRecordDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachRecordDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachRecordDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachRecordDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa25fe9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eachRecordDetail_vue__ = __webpack_require__(1624);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1622)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eachRecordDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa25fe9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eachRecordDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/record/eachRecordDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fa25fe9a", Component.options)
  } else {
    hotAPI.reload("data-v-fa25fe9a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a18de912", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fa25fe9a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./eachRecordDetail.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fa25fe9a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./eachRecordDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#voiceSceneTeacherDetail {\n  width: 100%;\n  color: #262626;\n  height: auto;\n  padding-bottom: 100px;\n}\n#voiceSceneTeacherDetail .top {\n  background-color: #D5D5D5;\n  height: 104px;\n}\n#voiceSceneTeacherDetail .top .btn-box {\n  width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n#voiceSceneTeacherDetail .top .btn-box > div {\n  width: 50%;\n  text-align: left;\n}\n#voiceSceneTeacherDetail .top .btn-box > div:last-child {\n  text-align: right;\n}\n#voiceSceneTeacherDetail .top .btn-box > div > a {\n  display: inline-block;\n  background-color: #497AF2;\n  color: #fff;\n  border-radius: 6px;\n  width: 100px;\n  height: 28px;\n  line-height: 28px;\n  text-align: center;\n}\n#voiceSceneTeacherDetail .bottom {\n  width: 1000px;\n  height: auto;\n  margin: 20px auto;\n  background: #fff;\n  box-shadow: 2px -2px 14px #999999;\n}\n#voiceSceneTeacherDetail .bottom .content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  height: auto;\n  padding: 10px;\n  font-size: 14px;\n}\n#voiceSceneTeacherDetail .bottom .content .box {\n  text-align: left;\n  width: 100%;\n}\n#voiceSceneTeacherDetail .bottom .content .text-box {\n  text-align: center;\n}\n#voiceSceneTeacherDetail .bottom .content > p {\n  margin-bottom: 5px;\n}\n#voiceSceneTeacherDetail .bottom .content .wuxiao {\n  color: #F23B3F;\n  width: 300px;\n  text-align: center;\n}\n#voiceSceneTeacherDetail .bottom .content > h3 {\n  text-align: left;\n  font-size: 16px;\n  width: 100%;\n}\n#voiceSceneTeacherDetail .bottom .content .row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n}\n#voiceSceneTeacherDetail .bottom .content .row .el-input__inner {\n  height: 36px;\n}\n#voiceSceneTeacherDetail .bottom .content .row > span {\n  width: 60px;\n  height: 32px;\n  display: inline-block;\n  color: #fff;\n  text-align: center;\n  line-height: 32px;\n  background: #F57174;\n  margin: 0 10px;\n  border-radius: 6px;\n  padding: 0 10px;\n  cursor: pointer;\n}\n#voiceSceneTeacherDetail .bottom .content .btn-save {\n  width: 100%;\n  text-align: center;\n  margin: 10px 0;\n}\n#voiceSceneTeacherDetail .bottom .content audio {\n  height: 36px;\n  width: 100%;\n}\n.DeductPoints {\n  color: red;\n  font-weight: 600;\n  width: auto;\n}\n.isred {\n  color: red;\n}\n.DeductionDetails {\n  color: #d3d3d3;\n}\n.textstyle {\n  text-align: left;\n}\n.text-style {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.addBorderStyle_3 {\n  border-left: solid 2px #acb9e0 !important;\n}\n.addBorderStyle_4 {\n  border-right: solid 2px #acb9e0 !important;\n}\n.text-style {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.isgrey {\n  background: #8d9199 !important;\n}\n", ""]);

// exports


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap", attrs: { id: "voiceSceneTeacherDetail" } },
    [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "btn-box" }, [
          _vm.preId != null
            ? _c("div", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.toPre(_vm.preId)
                      }
                    }
                  },
                  [_vm._v("上一通练习")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.preId == null
            ? _c("div", [
                _c("a", { staticClass: "isgrey" }, [_vm._v("上一通练习")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.nextId != null
            ? _c("div", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.toNext(_vm.nextId)
                      }
                    }
                  },
                  [_vm._v("下一通练习")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.nextId == null
            ? _c("div", [
                _c("a", { staticClass: "isgrey" }, [_vm._v("下一通练习")])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("h3", [
              _vm._v(_vm._s(_vm.existAdvise ? "练习得分与建议" : "练习得分"))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "video ivideo" }, [
              _c("span", [_vm._v("练习录音")]),
              _vm._v(" "),
              _c("audio", {
                attrs: { src: _vm.videoUrl, controls: "controls" }
              })
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "practice" }, [
              _vm._v(
                "\n\t\t\t\t\t\t\t练习评分(" +
                  _vm._s(_vm.gradeScore) +
                  ")\n\t\t\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.gradeList,
                  "span-method": _vm.objectSpanMethod,
                  "header-cell-style": _vm.rowClass,
                  "cell-class-name": _vm.addClass,
                  border: ""
                }
              },
              [
                _c(
                  "el-table-column",
                  { attrs: { label: "练习内容", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "parentname",
                        width: "110",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "name", width: "150", align: "center" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "gradeScore",
                    label: "总分",
                    width: "80",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { label: "自评分", align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: { label: "扣分", align: "center", width: "auto" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "textstyle text-style" },
                                    [
                                      scope.row.gradeScore - scope.row.score !=
                                      0
                                        ? _c(
                                            "span",
                                            { staticClass: "DeductPoints" },
                                            [
                                              _vm._v(
                                                "-" +
                                                  _vm._s(
                                                    scope.row.gradeScore -
                                                      scope.row.score
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "DeductionDetails" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(scope.row.checkedName) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [_vm._v(_vm._s(scope.row.checkedName))]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "score",
                        label: "得分",
                        width: "80",
                        align: "center"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.existAdvise
                  ? _c("el-table-column", {
                      attrs: { label: "练习建议", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c("div", { staticClass: "text-style" }, [
                                      _c("span", { staticClass: "isred" }, [
                                        _vm._v(_vm._s(scope.row.description))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content"
                                      },
                                      [_vm._v(_vm._s(scope.row.description))]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        475786103
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa25fe9a", esExports)
  }
}

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examRecordList_vue__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examRecordList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examRecordList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examRecordList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examRecordList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bfffe9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examRecordList_vue__ = __webpack_require__(1626);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_examRecordList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bfffe9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_examRecordList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/record/examRecordList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1bfffe9e", Component.options)
  } else {
    hotAPI.reload("data-v-1bfffe9e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrap" },
    [
      _c(
        "el-form",
        { attrs: { inline: true } },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.gobackScene } },
                [_vm._v("返回")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "beginTime",
              label: "考核时间",
              align: "center",
              width: "180"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "courseName", label: "课程名称", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "realName",
              label: "客服",
              align: "center",
              width: "162"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.realName) +
                        "（" +
                        _vm._s(scope.row.tjkNumber) +
                        "）\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "teacherName",
              label: "讲师",
              align: "center",
              width: "162"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.teacherName) +
                        "（" +
                        _vm._s(scope.row.teacherTjkNumber) +
                        "）\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "考核结果", align: "center" } },
            [
              _c("el-table-column", {
                attrs: { prop: "baseScore", label: "基本条件", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skillScore",
                  label: "服务技巧",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "riteScore", label: "服务礼仪", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "flowScore", label: "服务流程", align: "center" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "gradeScore", label: "分数", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否合格", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.sceneExamPass == "Yes"
                      ? _c("span", [_vm._v("是")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.sceneExamPass == "No"
                      ? _c("span", [_vm._v("否")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.sceneExamPass == "Empty" ? _c("span") : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: { pages: _vm.searchData.pages, pageNum: _vm.searchData.pageNum },
        on: { getData: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bfffe9e", esExports)
  }
}

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Secondarylist_vue__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Secondarylist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Secondarylist_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Secondarylist_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Secondarylist_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01580b54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Secondarylist_vue__ = __webpack_require__(1630);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1628)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01580b54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Secondarylist_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01580b54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Secondarylist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/newservice/Secondarylist.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01580b54", Component.options)
  } else {
    hotAPI.reload("data-v-01580b54", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1629);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("19783cb6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-01580b54\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Secondarylist.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-01580b54\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Secondarylist.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(177);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.isreturn[data-v-01580b54]{color:#000;cursor: pointer;\n}\n[data-v-01580b54].el-icon-arrow-left{color: #000;\n}\n.step-list[data-v-01580b54]{margin-bottom: 20px;background:#fff;border-radius:5px ;padding: 19px 20px 20px 60px;position: relative;\n}\n.step-list_top[data-v-01580b54]{display: flex;justify-content: space-between;\n}\n.list_top_left[data-v-01580b54]{display: flex;\n}\n.list_top_left[data-v-01580b54]{font-size: 16px;color: #262626;font-weight: bold;position: relative;left: -20px;\n}\n.isred[data-v-01580b54]{color: #E53434; margin-right: 10px;font-weight: 500;font-size: 12px;padding: 0px 3px;border: 1px solid #E53434;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #FBE5E5;height: 18px;line-height: 16px;\n}\n.isgreen[data-v-01580b54]{color: #14C034; margin-right: 10px;font-weight: 500;font-size: 12px;padding: 0px 3px;border: 1px solid #39CA54;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #D9F4DE;height: 18px;line-height: 16px;\n}\n[data-v-01580b54].el-button--small{padding: 9px 24px !important;border-radius:6px;\n}\n[data-v-01580b54].el-button--primary{background-color: #497af2;\n}\n[data-v-01580b54].el-button--primary>span{letter-spacing: 1px;\n}\n.step-list_under2[data-v-01580b54]{margin-top:3px;font-size: 13px;overflow: hidden;color: #000;\n}\n.circle[data-v-01580b54]{width: 20px;height: 20px;background:#1684fc;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:2px;color: #fff;font-weight: normal;line-height: 20px;\n}\n.othercircle[data-v-01580b54]{width: 20px;height: 20px;background:#BBBBBB;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:2px;color: #fff;font-weight: normal;line-height: 20px;\n}\n.line[data-v-01580b54]{\n    width: 2px;\n\n    top:41px;\n    bottom: -20px;\n    left: 29px;\n    position: absolute;\n    border-color: inherit;\n    background-color: #1684fc;\n    z-index: 99;\n}\n.otherline[data-v-01580b54]{\n    width: 2px;\n\n    top:41px;\n    bottom: -20px;\n    left: 29px;\n    position: absolute;\n    border-color: inherit;\n    background-color: #BBBBBB;\n    z-index: 99;\n}\n#app[data-v-01580b54] {\n  height: 100%;\n  box-sizing: border-box;\n}\n#Return_Bar[data-v-01580b54] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n[data-v-01580b54].el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-01580b54] {\n  background: #f6f5f8;\n  width: 100%;\n  padding: 20px 20px;\n  height: 100%;\n}\n#text .right[data-v-01580b54] {\n  width: 100%;\n  margin-left: 10px;\n}\n.right-top[data-v-01580b54] {\n  display: flex;\n  justify-content: space-between;\n}\n.twolevel_list[data-v-01580b54] {\n  padding: 10px 20px;\n  background: #fff;\n  width: 100%;\n  border-radius: 5px;\n  display: flex;\n  margin-bottom: 20px;\n}\n.twolevel_list .left[data-v-01580b54] {\n  width: 40px;\n}\n.twolevel_list .left .circle_state[data-v-01580b54] {\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  margin-top: 3px;\n  margin-left: 10px;\n  background: #d5d7d8;\n  color: #fff;\n  text-align: center;\n}\n.right_listleft[data-v-01580b54] {\n  font-size: 17px;\n  color: #000;\n  font-weight: 600;\n}\n.right_listleft > .pass[data-v-01580b54] {\n  margin-left: 10px;\n  color: #6cc080;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #6cc080;\n  border-radius: 5px;\n  background: #d3f6d3;\n}\n.right_listleft > .failed[data-v-01580b54] {\n  margin-left: 10px;\n  color: #e15062;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #e15062;\n  border-radius: 5px;\n  background: #ffe3e2;\n}\n.right_listright[data-v-01580b54] {\n  background: #1684fc;\n  color: #fff;\n  padding: 5px 20px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n.right_under[data-v-01580b54] {\n  background: #f6f5f8;\n  padding: 20px;\n  margin-top: 10px;\n  border-radius: 5px;\n  font-size: 13px;\n}\n.right_under>div[data-v-01580b54]{overflow: hidden;white-space: nowrap; text-overflow: ellipsis; overflow: hidden;\n}\n.circle_state_pass[data-v-01580b54] {\n  background: #1684fc !important;\n}\n.sp_button[data-v-01580b54]{float:left;width: 95px;height: 28px;background: #BFD0FB;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #497AF2;text-align: center;line-height: 28px;cursor: pointer;letter-spacing: 1px;\n}\n.spb_button[data-v-01580b54]{float:right;width: 95px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;text-align: center;line-height: 28px;cursor: pointer;margin-left: 10px;letter-spacing: 1px;\n}\n.lock[data-v-01580b54]{background: url(" + escape(__webpack_require__(178)) + ") no-repeat center;background-size: cover;width: 22px;height: 22px;position:absolute;right: 20px;\n}\n.step-list_under[data-v-01580b54]{margin-top: 15px;background: #f5f6f7;padding: 19px 20px 20px 19px;font-size: 13px;overflow: hidden;color:#262626;\n}\n.description[data-v-01580b54]{width:80%;\n}\n.top_line[data-v-01580b54]{position:absolute;top:0;left: 29px;width:2px;height:21px;\n}\n.top_isCheck[data-v-01580b54]{background:#1684fc;\n}\n.top_noCheck[data-v-01580b54]{background:#BBBBBB;\n}\n.iframe-container[data-v-01580b54] {\n    position: absolute;\n    top: 50px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    width: 100%;\n    height: 100%;\n}\n\n", ""]);

// exports


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ]),
      _vm._v(" "),
      !_vm.urlLink
        ? _c(
            "a",
            {
              staticStyle: {
                position: "absolute",
                top: "9px",
                right: "20px",
                "z-index": "9"
              },
              attrs: {
                target: "_blank",
                href:
                  _vm.imUrl +
                  "/TJ_TJK_IMAction.html?token=" +
                  _vm.imToken +
                  "&tjkId=" +
                  _vm.tjkInfo.id +
                  "&userName=" +
                  _vm.tjkInfo.realName +
                  "&tjkNumber=" +
                  _vm.tjkInfo.tjkNum +
                  "&platform=assitant"
              }
            },
            [
              _c("img", {
                staticStyle: { height: "30px" },
                attrs: { src: __webpack_require__(471), alt: "" }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "text" } },
      [
        _vm._l(_vm.courseList, function(c, key) {
          return !_vm.urlLink
            ? _c("div", { key: key, staticClass: "step-list" }, [
                _c("div", { staticClass: "step-list_top" }, [
                  _c("div", { staticClass: "list_top_left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "circle",
                        class: {
                          circle: c.passState == "Passed",
                          othercircle:
                            c.passState == "Ongoing" || c.passState == null
                        }
                      },
                      [
                        _vm.courseList.length != 1
                          ? _c("div", [_vm._v(_vm._s(key + 1))])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(
                      "\n            " +
                        _vm._s(c.knowledge.title) +
                        "\n            "
                    ),
                    _c(
                      "div",
                      { class: c.passState == "Passed" ? "isgreen" : "isred" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              c.passState == "Passed" && c.passState != null
                                ? "已完成"
                                : "未完成"
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "step-list_under2",
                      domProps: { innerHTML: _vm._s(c.knowledge.description) }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "list_top_right",
                      staticStyle: { width: "200px" }
                    },
                    [
                      c.passState == null
                        ? _c("div", { staticClass: "lock" })
                        : _c(
                            "div",
                            [
                              c.knowledgeType != "Special"
                                ? _c("div", [
                                    c.passState == "Ongoing"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "spb_button",
                                            attrs: {
                                              type: "primary",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.goKnowledge(c, key)
                                              }
                                            }
                                          },
                                          [_vm._v("点击学习")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    c.passState == "Passed"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "spb_button",
                                            attrs: {
                                              type: "primary",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.goKnowledge(c, key)
                                              }
                                            }
                                          },
                                          [_vm._v("重新学习")]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              c.knowledgeType == "Special"
                                ? [
                                    c.knowledge.assitantType == "downLink"
                                      ? [
                                          c.passState != "Passed" &&
                                          c.knowledge.assitantType ==
                                            "downLink" &&
                                          c.knowledge.downLink
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "spb_button",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goDownLoadLink(
                                                        c.knowledge
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击下载")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.passState == "Passed" &&
                                          c.knowledge.assitantType ==
                                            "downLink" &&
                                          c.knowledge.downLink
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "spb_button",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goDownLoadLink(
                                                        c.knowledge
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新下载")]
                                              )
                                            : _vm._e()
                                        ]
                                      : [
                                          [
                                            "fbt",
                                            "fbtoperate",
                                            "primary",
                                            "middle",
                                            "high",
                                            "aftersaleprimary",
                                            "aftersalemiddle",
                                            "aftersalehigh"
                                          ].includes(c.knowledge.assitantType)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "sp_button",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.Gorecord(
                                                        c.knowledge
                                                          .assitantType,
                                                        c.knowledge
                                                          .businessMajorId
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("练习记录")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.knowledge.assitantType.endsWith(
                                            "exam"
                                          ) ||
                                          c.knowledge.assitantType.endsWith(
                                            "primary"
                                          ) ||
                                          c.knowledge.assitantType.endsWith(
                                            "middle"
                                          ) ||
                                          c.knowledge.assitantType.endsWith(
                                            "high"
                                          )
                                            ? [
                                                c.passState == "Ongoing"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spb_button",
                                                        attrs: {
                                                          type: "primary",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.GoPracticalOperation(
                                                              c.knowledge,
                                                              c.knowledge
                                                                .businessMajorId,
                                                              _vm.courseId,
                                                              key,
                                                              c.knowledge.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("点击练习")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                c.passState == "Passed"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spb_button",
                                                        attrs: {
                                                          type: "primary",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.GoPracticalOperation(
                                                              c.knowledge,
                                                              c.knowledge
                                                                .businessMajorId,
                                                              _vm.courseId,
                                                              key,
                                                              c.knowledge.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("重新练习")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : [
                                                c.passState == "Ongoing"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spb_button",
                                                        attrs: {
                                                          type: "primary",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.GoPracticalOperation(
                                                              c.knowledge,
                                                              c.knowledge
                                                                .businessMajorId,
                                                              _vm.courseId,
                                                              key,
                                                              c.knowledge.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("点击学习")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                c.passState == "Passed"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spb_button",
                                                        attrs: {
                                                          type: "primary",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.GoPracticalOperation(
                                                              c.knowledge,
                                                              c.knowledge
                                                                .businessMajorId,
                                                              _vm.courseId,
                                                              key,
                                                              c.knowledge.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("重新学习")]
                                                    )
                                                  : _vm._e()
                                              ]
                                        ]
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                    ]
                  )
                ]),
                _vm._v(" "),
                key != 0
                  ? _c("div", {
                      staticClass: "top_line",
                      class: {
                        top_isCheck:
                          c.passState == "Passed" || c.passState == "Ongoing",
                        top_noCheck: c.passState == null
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.courseList.length > 1 && key != _vm.courseList.length - 1
                  ? _c("div", {
                      class: {
                        line: c.passState == "Passed",
                        otherline:
                          c.passState == "Ongoing" || c.passState == null
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm.urlLink
          ? _c("div", [
              _c("iframe", {
                staticClass: "iframe-container",
                attrs: { src: _vm.urlLink, scrolling: "auto", frameborder: "0" }
              })
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01580b54", esExports)
  }
}

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Knowledge_vue__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Knowledge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Knowledge_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Knowledge_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Knowledge_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_465d3ac2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Knowledge_vue__ = __webpack_require__(1634);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1632)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-465d3ac2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Knowledge_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_465d3ac2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Knowledge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/newservice/Knowledge.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-465d3ac2", Component.options)
  } else {
    hotAPI.reload("data-v-465d3ac2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1633);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("675bc96b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-465d3ac2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Knowledge.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-465d3ac2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Knowledge.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.description[data-v-465d3ac2] {\n  padding-bottom: 10px;\n}\n.scene .box[data-v-465d3ac2] {\n  position: relative;\n}\n.box .text[data-v-465d3ac2] {\n  width: 100%;\n}\n.test-button[data-v-465d3ac2] {\n  position: absolute;\n  margin-top: 10px;\n  z-index: 999;\n  bottom: 20px;\n}\n.isred[data-v-465d3ac2] {\n  color: #E53434;\n  margin-right: 10px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #E53434;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #FBE5E5;\n  line-height: 16px;\n  height: 18px;\n}\n.isgreen[data-v-465d3ac2] {\n  color: #14C034;\n  margin-right: 10px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #39CA54;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #D9F4DE;\n  line-height: 16px;\n  height: 18px;\n}\n.isposition[data-v-465d3ac2] {\n  position: absolute;\n  right: 20px;\n  top: 5px;\n}\n.istext[data-v-465d3ac2] {\n  width: 90%;\n}\n.Signinstyle[data-v-465d3ac2] {\n  align-self: flex-end;\n  display: inline-block;\n  font-size: 16px;\n  margin-left: 20px;\n}\n.Signinblue[data-v-465d3ac2] {\n  color: #4a7bea;\n  font-weight: 600;\n}\n.Signingreen[data-v-465d3ac2] {\n  color: #5dc998;\n  font-weight: 600;\n}\n.train-list[data-v-465d3ac2] {\n  position: relative;\n}\n.buttonst[data-v-465d3ac2] {\n  background: #5dc998 !important;\n}\n.buttonsb[data-v-465d3ac2] {\n  background: #4a7bea !important;\n}\n.Sign_in[data-v-465d3ac2] {\n  color: #4978fb;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.noSign_in[data-v-465d3ac2] {\n  color: #53cb95;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.isnoSign_in[data-v-465d3ac2] {\n  color: #53cb95;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.Training_failed[data-v-465d3ac2] {\n  color: red;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.Invalid[data-v-465d3ac2] {\n  color: red;\n  position: absolute;\n  right: 30px;\n  font-weight: 600;\n  font-size: 16px;\n}\n.train-list_position[data-v-465d3ac2] {\n  position: relative;\n}\n.train-list_position .title[data-v-465d3ac2] {\n  font-size: 18px !important;\n}\n.Entry_training[data-v-465d3ac2] {\n  background: #5dc998 !important;\n}\n.button_box[data-v-465d3ac2] {\n  margin-top: 30px !important;\n}\n.button_box > span[data-v-465d3ac2] {\n  font-size: 16px;\n  line-height: 35px !important;\n  height: 37px !important;\n}\n.title_style[data-v-465d3ac2] {\n  font-size: 16px;\n  font-weight: 600;\n}\n.Badge_result_page[data-v-465d3ac2] {\n  text-align: center;\n}\n.img_style[data-v-465d3ac2] {\n  width: 50%;\n}\n.result-txt[data-v-465d3ac2] {\n  font-size: 18px;\n  color: #000;\n  text-align: center;\n}\n.content_style[data-v-465d3ac2] {\n  color: #000;\n  font-size: 18px;\n  text-align: center;\n}\n.button_primary[data-v-465d3ac2] {\n  text-align: center;\n  margin-top: 50px;\n}\n.button_again[data-v-465d3ac2] {\n  background-color: #d3d5d7 !important;\n  color: #898a8c !important;\n}\n.colorstylr[data-v-465d3ac2] {\n  margin-right: 10px;\n}\n.button_box_true > span[data-v-465d3ac2] {\n  margin-left: 50%;\n  transform: translateX(-50%);\n}\n[data-v-465d3ac2] .el-dialog__footer {\n  padding: 10px 20px 10px 20px;\n}\n[data-v-465d3ac2] .el-dialog {\n  border-radius: 10px;\n}\n.systemPopup[data-v-465d3ac2] .el-dialog {\n  width: 21% !important;\n}\n.systemPopup[data-v-465d3ac2] .el-dialog__header {\n  padding: 5px 20px 5px 10px;\n}\n.dimensionalimg[data-v-465d3ac2] {\n  width: 190px;\n  height: 190px;\n  margin: 0 auto;\n  margin-top: 30px;\n  text-align: center;\n  margin-bottom: 13px;\n}\n.dimensionalimg img[data-v-465d3ac2] {\n  width: 100%;\n  height: 100%;\n}\n.dimensionalimg_text[data-v-465d3ac2] {\n  text-align: center;\n  font-weight: 600px;\n  margin-top: 10px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n}\n.dimensionalimg_Line[data-v-465d3ac2] {\n  width: 100%;\n  background: #F4F4F5;\n  height: 2px;\n}\n.dimensionalimg_box[data-v-465d3ac2] .el-dialog--center .el-dialog__body {\n  padding: 25px 0px 30px;\n}\n.dimensionalimg_box[data-v-465d3ac2] .el-dialog__footer {\n  padding: 10px 20px 23px 20px;\n}\n[data-v-465d3ac2] .el-tabs__nav-wrap::after {\n  background: #fff;\n}\n[data-v-465d3ac2] .el-icon-house {\n  margin-right: 6px;\n}\n[data-v-465d3ac2] .el-icon-message {\n  margin-right: 6px;\n}\n.el-tabs__active-bar[data-v-465d3ac2] {\n  width: 124px;\n}\n.tabBox[data-v-465d3ac2] {\n  margin-top: 14px;\n  margin-left: 20px;\n  margin-right: 20px;\n  padding-bottom: 14px;\n  display: flex;\n  background: #F5F6F7;\n}\n.index_tabBox[data-v-465d3ac2] {\n  color: #497AF2 ;\n  font-weight: 550;\n  border: 1px solid #1684FC;\n  width: 100px;\n  text-align: center;\n  padding: 3px 0;\n  background: #fff;\n  font-size: 14px;\n  cursor: pointer;\n}\n.index_tabBox_left[data-v-465d3ac2] {\n  color: #497AF2 ;\n  font-weight: 550;\n  border: 1px solid #1684FC;\n  border-left: 0px ;\n  width: 100px;\n  text-align: center;\n  padding: 3px 0;\n  background: #fff;\n  font-size: 14px;\n  cursor: pointer;\n}\n.index_tabBox_after[data-v-465d3ac2] {\n  color: #fff;\n  font-weight: 550;\n  border: 1px solid #1684FC;\n  border-left: 0px ;\n  width: 100px;\n  text-align: center;\n  padding: 3px 0;\n  background: #497AF2;\n  font-size: 14px;\n  cursor: pointer;\n}\n.right_listleft[data-v-465d3ac2] {\n  font-size: 17px;\n  color: #000;\n  font-weight: 600;\n}\n.right_listleft > .pass[data-v-465d3ac2] {\n  margin-left: 10px;\n  color: #6cc080;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #6cc080;\n  border-radius: 5px;\n  background: #d3f6d3;\n}\n.right_listleft > .failed[data-v-465d3ac2] {\n  margin-left: 10px;\n  color: #e15062;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #e15062;\n  border-radius: 5px;\n  background: #ffe3e2;\n}\n.right_listright[data-v-465d3ac2] {\n  background: #1684fc;\n  color: #fff;\n  padding: 5px 20px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n.right_under[data-v-465d3ac2] {\n  background: #f6f5f8;\n  padding: 10px 20px;\n  margin-top: 10px;\n  border-radius: 5px;\n  font-size: 13px;\n}\n.right_under > div[data-v-465d3ac2] {\n  overflow: hidden;\n  height: 60px ;\n}\n.content[data-v-465d3ac2] {\n  display: block !important;\n}\n.right-top[data-v-465d3ac2] {\n  display: flex;\n  justify-content: space-between;\n}\n.circle[data-v-465d3ac2] {\n  width: 20px;\n  height: 20px;\n  background: #497AF2;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  top: 65px;\n  left: 10px;\n  color: #fff;\n  line-height: 20px;\n}\n.boxstyle[data-v-465d3ac2] {\n  width: 100% !important;\n}\n.boxstyle > .title[data-v-465d3ac2] {\n  justify-content: left !important;\n}\n.isposition[data-v-465d3ac2] .el-button--small {\n  padding: 8px 23px 6px 24px!important;\n  border-radius: 6px ;\n  height: 28px;\n  line-height: 9px;\n  letter-spacing: 1px ;\n  width: 100px;\n}\n.textstyle[data-v-465d3ac2] {\n  margin-top: 10px;\n  background: #f5f6f7;\n  border-radius: 5px;\n  padding: 20px;\n  font-size: 13px;\n  overflow: hidden;\n  height: auto !important;\n}\n.otherline[data-v-465d3ac2] {\n  width: 2px;\n  height: 161px;\n  top: 85px;\n  bottom: 0;\n  left: 29px;\n  position: absolute;\n  border-color: inherit;\n  background-color: #BBBBBB;\n  z-index: 99;\n}\n.othercircle[data-v-465d3ac2] {\n  width: 20px;\n  height: 20px;\n  background: #BBBBBB;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  top: 65px;\n  line-height: 20px;\n  color: #fff;\n}\n.RegistrationSessions[data-v-465d3ac2] {\n  background: #fff;\n  border-radius: 10px;\n  width: 100%;\n  margin-bottom: 20px;\n  padding: 21px 0 20px 0;\n  position: relative;\n}\n.RegistrationSessions .label[data-v-465d3ac2] {\n  padding: 5px 20px;\n  background: #4B79F1;\n  display: inline-block;\n  color: #fff;\n  border-radius: 10px 0 10px 0 ;\n  margin-bottom: 10px;\n  font-size: 17px;\n}\n.text_box[data-v-465d3ac2] {\n  padding: 0  20px;\n}\n.title_state_button[data-v-465d3ac2] {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.title_state[data-v-465d3ac2] {\n  font-size: 20px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n  display: flex;\n}\n.Reg_button[data-v-465d3ac2] {\n  background: #497AF2;\n  color: #fff;\n  padding: 5px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.Reg_isred[data-v-465d3ac2] {\n  color: #E53434;\n  margin-right: 9px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  margin-left: 9px;\n  margin-top: 6px;\n  height: 23px;\n  background: #FBE5E5;\n  border: 1px solid #E53434;\n  border-radius: 4px;\n  height: 18px;\n  line-height: 15px;\n}\n.Reg_isgreen[data-v-465d3ac2] {\n  color: #14C034;\n  margin-right: 9px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #39CA54;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 6px;\n  background: #D9F4DE;\n  height: 18px;\n  line-height: 15px;\n}\n.Reg_date[data-v-465d3ac2],\n.Reg_time[data-v-465d3ac2],\n.Reg_lecturer[data-v-465d3ac2] {\n  color: #262626;\n  font-size: 14px;\n  margin-bottom: 5px;\n}\n.Reg_qq[data-v-465d3ac2] {\n  color: #262626;\n  font-size: 14px;\n}\n.Reg_content[data-v-465d3ac2] {\n  margin-top: 12px;\n  background: #f5f6f7;\n  padding: 20px;\n}\n.index_tabbox_0[data-v-465d3ac2] {\n  border-radius: 4px 0px 0px 4px;\n}\n.index_tabbox_last[data-v-465d3ac2] {\n  border-radius: 0px 4px 4px 0px;\n}\n[data-v-465d3ac2] .el-tabs__header {\n  margin: 0px !important;\n  padding-left: 20px !important;\n}\n.dialog_img[data-v-465d3ac2] {\n  width: 85px;\n  height: 64px;\n  margin: 0 auto;\n}\n.dialog_img > img[data-v-465d3ac2] {\n  width: 100%;\n  height: 100%;\n}\n.qq_text[data-v-465d3ac2] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n  text-align: center;\n  margin-top: 14px;\n}\n.currency_button[data-v-465d3ac2] {\n  display: flex;\n  justify-content: center;\n}\n.determine[data-v-465d3ac2] {\n  width: 80px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.cancel[data-v-465d3ac2] {\n  width: 80px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #717171;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n[data-v-465d3ac2] .el-dialog--center .el-dialog__body {\n  padding: 18px 0 0 0;\n}\n.cel-button[data-v-465d3ac2] {\n  margin: 0 auto;\n  width: 100px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  margin-top: 30px;\n  margin-bottom: 20px;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.fail_img[data-v-465d3ac2] {\n  font-size: 14px;\n  color: #EE3F3F;\n  font-weight: 500;\n  display: flex;\n  position: absolute;\n  right: 20px;\n  top: 80px;\n}\n.fail_img > img[data-v-465d3ac2] {\n  margin-right: 6px;\n}\n.Reg_button_isqian[data-v-465d3ac2] {\n  width: 100px;\n  height: 28px;\n  background: #DBE5FF;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: bold;\n  color: #497AF2;\n  text-align: center;\n  line-height: 28px ;\n}\n.Reg_button_noqian[data-v-465d3ac2] {\n  width: 100px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #ABABAB;\n  text-align: center;\n  line-height: 28px ;\n}\n.thespan[data-v-465d3ac2] {\n  color: #E53434;\n}\n.typingCertification[data-v-465d3ac2] {\n  background: #FFFFFF;\n  border-radius: 10px;\n  padding: 19px 20px 21px 0;\n}\n.typing_top[data-v-465d3ac2] {\n  display: flex;\n}\n.typing_title[data-v-465d3ac2] {\n  font-size: 16px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n  line-height: 24px;\n  margin-left: 19px;\n  margin-bottom: 19px;\n}\n.typing_state[data-v-465d3ac2] {\n  color: #E53434;\n  margin-right: 10px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #E53434;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #FBE5E5;\n  line-height: 16px;\n  height: 18px;\n}\n.typing_bottom[data-v-465d3ac2] {\n  background: #F5F6F7;\n  padding: 20px 110px 20px 20px;\n  margin-left: 20px;\n}\n.train[data-v-465d3ac2] {\n  height: auto !important;\n}\n.top_line[data-v-465d3ac2] {\n  position: absolute;\n  top: 0;\n  left: 29px;\n  width: 2px;\n  bottom: 55px;\n}\n.top_isCheck[data-v-465d3ac2] {\n  background: #1684fc;\n}\n.top_noCheck[data-v-465d3ac2] {\n  background: #BBBBBB;\n}\n", ""]);

// exports


/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.toptab,
            callback: function($$v) {
              _vm.toptab = $$v
            },
            expression: "toptab"
          }
        },
        _vm._l(_vm.loneTab, function(item, index) {
          return _c("el-tab-pane", { key: index, attrs: { name: item.name } }, [
            _c("span", { attrs: { slot: "label" }, slot: "label" }, [
              _vm._v(_vm._s(item.name))
            ])
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "voice" }, [
        _c(
          "div",
          { staticClass: "tabBox" },
          _vm._l(_vm.tabList, function(t, key) {
            return _c(
              "div",
              {
                key: key,
                staticClass: "index_tabBox",
                class: {
                  index_tabBox_after: key == _vm.tabIndex,
                  index_tabBox_left: key != 0,
                  index_tabbox_0: key == 0,
                  index_tabbox_last: key == _vm.loneTab.length - 1
                },
                on: {
                  click: function($event) {
                    return _vm.changeSecondaryTab(key, t.categoryId, t)
                  }
                }
              },
              [_vm._v("\n         " + _vm._s(t.categoryName) + "\n       ")]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _vm.newPeopleBadgeId == false
              ? _c(
                  "div",
                  [
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "注意",
                          visible: _vm.dialogVisible,
                          width: "30%",
                          "show-close": false,
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dialogVisible = $event
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v("完成前面的《系统测试》，才能报名技能提升培训")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.dialogVisible = false
                                  }
                                }
                              },
                              [_vm._v("确 定")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.assitantType != "VoiceUpgradeSkill"
              ? _vm._l(_vm.courseList, function(c, key) {
                  return _c("div", { key: key, staticClass: "step-list" }, [
                    _c(
                      "div",
                      {
                        class: {
                          step: true,
                          active: c.passState == "Passed",
                          progress:
                            c.passState == "Ongoing" || c.passState == null
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "circle",
                            class: {
                              circle: c.passState == "Passed",
                              othercircle:
                                c.passState == "Ongoing" || c.passState == null
                            }
                          },
                          [
                            _vm.courseList.length != 1
                              ? _c("div", [_vm._v(_vm._s(key + 1))])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        key != 0
                          ? _c("div", {
                              staticClass: "top_line",
                              class: {
                                top_isCheck:
                                  c.passState == "Passed" ||
                                  c.passState == "Ongoing"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        key != _vm.courseList.length - 1
                          ? _c("div", {
                              class: {
                                line: c.passState == "Passed",
                                otherline:
                                  c.passState == "Ongoing" ||
                                  c.passState == null
                              }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "box boxstyle" }, [
                        _c(
                          "div",
                          { staticClass: "title" },
                          [
                            _c("div", [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(c.courseName))
                              ])
                            ]),
                            _vm._v(" "),
                            c.unlock
                              ? [
                                  _c(
                                    "div",
                                    {
                                      class:
                                        c.passState == "Passed"
                                          ? "isgreen"
                                          : "isred"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          c.passState == "Passed"
                                            ? "已完成"
                                            : "未完成"
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "test-button isposition",
                                      on: {
                                        click: function($event) {
                                          return _vm.toStudy(
                                            c.courseId,
                                            c.unlock,
                                            c.courseType,
                                            c,
                                            c.status
                                          )
                                        }
                                      }
                                    },
                                    [
                                      (c.assitantType == null ||
                                        c.assitantType == "") &&
                                      c.courseType == "Integrate" &&
                                      c.passState != "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("点击学习")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (c.assitantType == null ||
                                        c.assitantType == "") &&
                                      c.courseType == "Integrate" &&
                                      c.passState == "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("重新学习")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (c.assitantType == null ||
                                        c.assitantType == "") &&
                                      c.courseType == "Exam" &&
                                      c.passState != "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("开始测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (c.assitantType == null ||
                                        c.assitantType == "") &&
                                      c.courseType == "Exam" &&
                                      c.passState == "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("重新测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      c.assitantType ==
                                        "AssitantSpecialRobotExam" &&
                                      c.retry == "false" &&
                                      c.passState != "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "primary"
                                              }
                                            },
                                            [_vm._v("开始测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      c.assitantType ==
                                        "AssitantSpecialRobotExam" &&
                                      c.retry == "true" &&
                                      c.passState != "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "primary"
                                              }
                                            },
                                            [_vm._v("开始测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      c.assitantType ==
                                        "AssitantSpecialRobotExam" &&
                                      c.retry == "true" &&
                                      c.passState == "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("重新测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      c.assitantType ==
                                        "AssitantSpecialRobotExam" &&
                                      c.retry == "false" &&
                                      c.passState == "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("重新测试")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              : [_c("div", { staticClass: "lock" })]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        c.courseType == "Integrate"
                          ? _c("div", { staticClass: "text textstyle" }, [
                              _vm._v(
                                "\n                 课程说明：\n                 "
                              ),
                              _c("div", { staticStyle: { width: "70%" } }, [
                                _vm._v(_vm._s(c.description)),
                                c.result != null
                                  ? _c("span", { staticClass: "thespan" }, [
                                      _vm._v("(" + _vm._s(c.result) + ")")
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        c.courseType == "Exam"
                          ? _c("div", { staticClass: "text textstyle" }, [
                              _vm._v(
                                "完成要求：" +
                                  _vm._s(c.description) +
                                  "\n               "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                })
              : [
                  _vm._l(_vm.cseList, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "RegistrationSessions" },
                      [
                        _c("div", { staticClass: "text_box" }, [
                          _c("div", { staticClass: "title_state_button" }, [
                            _c("div", { staticClass: "title_state" }, [
                              _vm._v(
                                "\n       " +
                                  _vm._s(item.trainTitle) +
                                  "\n       "
                              ),
                              _vm._v(" "),
                              item.passState != "signTimeOut"
                                ? _c(
                                    "div",
                                    {
                                      class: {
                                        Reg_isred:
                                          item.passState != "passed" &&
                                          item.passState != "signTimeOut",
                                        Reg_isgreen: item.passState == "passed"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n        " +
                                          _vm._s(
                                            item.passState != "passed" &&
                                              item.passState != "signTimeOut"
                                              ? "未完成"
                                              : "已完成"
                                          ) +
                                          "\n       "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            item.passState == "noJoin"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Reg_button",
                                    on: {
                                      click: function($event) {
                                        return _vm.goscene(
                                          item.sceneId,
                                          item.trainId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("点击报名")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState != "noJoin" &&
                            item.passState != "passed" &&
                            item.passState != "noSignAlreadyOpen" &&
                            item.passState != "noSignedNoOpen" &&
                            item.passState != "signTimeOut"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Reg_button",
                                    on: {
                                      click: function($event) {
                                        return _vm.regoscene(
                                          item.sceneId,
                                          item.trainId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("点击学习")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState == "passed"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Reg_button",
                                    on: {
                                      click: function($event) {
                                        return _vm.regoscene(
                                          item.sceneId,
                                          item.trainId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("重新学习")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState == "noSignAlreadyOpen"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Reg_button",
                                    on: {
                                      click: function($event) {
                                        return _vm.signIn(item.trainId)
                                      }
                                    }
                                  },
                                  [_vm._v("点击签到")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState == "noSignedNoOpen"
                              ? _c(
                                  "div",
                                  { staticClass: "Reg_button_noqian" },
                                  [_vm._v("点击签到")]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "Reg_date" }, [
                            _vm._v(
                              "\n      " + _vm._s(item.trainDate) + "\n    "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "Reg_time" },
                            _vm._l(item.trainTime, function(m, key) {
                              return _c("span", { key: key }, [
                                _vm._v(_vm._s(m)),
                                key < item.trainTime.length - 1
                                  ? _c("span", [_vm._v("，")])
                                  : _vm._e()
                              ])
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "Reg_lecturer" }, [
                            _vm._v(
                              "\n      培训讲师：" +
                                _vm._s(item.teacherName) +
                                "\n    "
                            )
                          ]),
                          _vm._v(" "),
                          item.passState != "passed" &&
                          item.passState != "signTimeOut" &&
                          item.passState1 != "noJoin"
                            ? _c("div", { staticClass: "Reg_qq" }, [
                                _vm._v("\n      培训QQ群： 793655472\n    ")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "Reg_content" }, [
                            _vm._v("培训内容：" + _vm._s(item.trainContent))
                          ]),
                          _vm._v(" "),
                          item.passState == "signTimeOut"
                            ? _c("div", { staticClass: "fail_img" }, [
                                _c("img", {
                                  attrs: {
                                    src: __webpack_require__(403),
                                    alt: ""
                                  }
                                }),
                                _c("div", { staticClass: "fail_text" }, [
                                  _vm._v("已失效")
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "",
                        visible: _vm.enlist,
                        width: "360px",
                        "show-close": false,
                        "close-on-click-modal": false
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.enlist = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "dialog_img" }, [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(36),
                            alt: ""
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "qq_text" }, [
                        _vm._v("确认参加培训并加入培训群")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c("div", { staticClass: "currency_button" }, [
                            _c(
                              "div",
                              {
                                staticClass: "cancel",
                                on: {
                                  click: function($event) {
                                    _vm.enlist = false
                                  }
                                }
                              },
                              [_vm._v("\n            取消\n          ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "determine",
                                on: { click: _vm.isenlist }
                              },
                              [_vm._v("\n            确定\n          ")]
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "",
                        visible: _vm.dimensional,
                        width: "360px",
                        "close-on-click-modal": false,
                        center: ""
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dimensional = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "dimensionalimg_Line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "dimensionalimg" }, [
                        _c("img", {
                          attrs: { src: _vm.dimensionalimg, alt: "" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dimensionalimg_text" }, [
                        _vm._v("请使用手机QQ扫一扫加入培训群")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cel-button",
                              on: { click: _vm.qqsceneId }
                            },
                            [_vm._v("已扫码加入")]
                          )
                        ]
                      )
                    ]
                  )
                ],
            _vm._v(" "),
            [
              [
                [
                  _c("p", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.description))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.sceneList, function(s, key) {
                    return _c("div", { staticClass: "scene" }, [
                      _c("img", { attrs: { src: s.imageUrl } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "box" }, [
                        _c("div", { staticClass: "title title_style" }, [
                          _c("div", [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(s.name))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                blue: true,
                                green: s.status == "Finish",
                                colorstylr: true
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    s.status == "Finish" ? "已完成" : "未完成"
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text" }, [
                          _c("div", { staticStyle: { width: "70%" } }, [
                            _vm._v(
                              "课程说明：\n                     " +
                                _vm._s(s.description)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "status",
                            on: {
                              click: function($event) {
                                return _vm.toCourseList(s.id)
                              }
                            }
                          },
                          [_vm._v("点击进入")]
                        )
                      ])
                    ])
                  })
                ]
              ]
            ]
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-465d3ac2", esExports)
  }
}

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scene_vue__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scene_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scene_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scene_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scene_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f669d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scene_vue__ = __webpack_require__(1638);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1636)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06f669d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scene_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f669d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scene_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/newservice/Scene.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06f669d0", Component.options)
  } else {
    hotAPI.reload("data-v-06f669d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1637);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2cdf4f2e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-06f669d0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Scene.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-06f669d0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Scene.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(177);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.isreturn[data-v-06f669d0]{color:#000;cursor: pointer;\n}\n[data-v-06f669d0].el-icon-arrow-left{color: #000;\n}\n.step-list[data-v-06f669d0]{margin-bottom: 20px;background:#fff;border-radius:5px ;padding: 19px 20px 20px 60px;position: relative;\n}\n.step-list_top[data-v-06f669d0]{display: flex;justify-content: space-between;\n}\n.list_top_left[data-v-06f669d0]{display: flex;\n}\n.list_top_left[data-v-06f669d0]{font-size: 16px;color: #262626;font-weight: 500;position: relative;left: -20px;font-size: 18px;font-family: Source Han Sans CN;color: #262626;line-height: 24px;\n}\n.isred[data-v-06f669d0]{color: #E53434; margin-right: 10px;font-weight: 600;font-size: 12px;padding: 0px 3px;border: 1px solid #E53434;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #FBE5E5;height: 18px;line-height: 18px;\n}\n.isgreen[data-v-06f669d0]{color: #14C034; margin-right: 10px;font-weight: 600;font-size: 12px;padding: 0px 3px;border: 1px solid #39CA54;border-radius: 4px;margin-left: 9px;margin-top: 4px;background: #D9F4DE;height: 18px;line-height: 18px;\n}\n.step-list_under[data-v-06f669d0]{margin-top: 15px;background: #f5f6f7;padding: 19px 360px 20px 19px;font-size: 13px;overflow: hidden;color: #000;\n}\n.circle[data-v-06f669d0]{width: 20px;height: 20px;background:#497AF2;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:4px;color: #fff;font-weight: normal;line-height: 20px;\n}\n.othercircle[data-v-06f669d0]{width: 20px;height: 20px;background:#D6D6D6;border-radius: 20px;position: relative;z-index: 1;display: inline-flex;justify-content: center;align-items: center;transition: 0.15s ease-out;left: -20px;top:4px;color: #fff;font-weight: normal;line-height: 20px;\n}\n.line[data-v-06f669d0]{    \n    width: 2px;\n    height: 256px;\n    top:24px;\n    bottom: 0;\n    left: -11px;\n    position: absolute;\n    border-color: inherit;\n    background-color: #1684fc;\n    z-index: 99;\n}\n.otherline[data-v-06f669d0]{    \n    width: 2px;\n    height: 156px;\n    top:24px;\n    bottom: 0;\n    left: -11px;\n    position: absolute;\n    border-color: inherit;\n    background-color: #BBBBBB;\n    z-index: 99;\n}\n#app[data-v-06f669d0] {\n  height: 100%;\n  box-sizing: border-box;\n   background: #f6f5f8;\n}\n#Return_Bar[data-v-06f669d0] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n  background: #fff;\n}\n[data-v-06f669d0].el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-06f669d0] {\n  background: #f6f5f8;\n  width: 100%;\n  padding: 20px 20px;\n}\n#text .right[data-v-06f669d0] {\n  width: 100%;\n  margin-left: 10px;\n}\n.right-top[data-v-06f669d0] {\n  display: flex;\n  justify-content: space-between;\n}\n.twolevel_list[data-v-06f669d0] {\n  padding: 10px 20px;\n  background: #fff;\n  width: 100%;\n  border-radius: 5px;\n  display: flex;\n  margin-bottom: 20px;\n}\n.twolevel_list .left[data-v-06f669d0] {\n  width: 40px;\n}\n.twolevel_list .left .circle_state[data-v-06f669d0] {\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  margin-top: 3px;\n  margin-left: 10px;\n  background: #d5d7d8;\n  color: #fff;\n  text-align: center;\n}\n.right_listleft[data-v-06f669d0] {\n  font-size: 17px;\n  color: #000;\n  font-weight: 600;\n}\n.right_listleft > .pass[data-v-06f669d0] {\n  margin-left: 10px;\n  color: #6cc080;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #6cc080;\n  border-radius: 5px;\n  background: #d3f6d3;\n}\n.right_listleft > .failed[data-v-06f669d0] {\n  margin-left: 10px;\n  color: #e15062;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #e15062;\n  border-radius: 5px;\n  background: #ffe3e2;\n}\n.right_listright[data-v-06f669d0] {\n  background: #1684fc;\n  color: #fff;\n  padding: 5px 20px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n.right_under[data-v-06f669d0] {\n  background: #f6f5f8;\n  padding: 20px;\n  margin-top: 10px;\n  border-radius: 5px;\n  font-size: 13px;\n}\n.right_under>div[data-v-06f669d0]{overflow: hidden;white-space: nowrap; text-overflow: ellipsis; overflow: hidden;\n}\n.circle_state_pass[data-v-06f669d0] {\n  background: #497AF2  !important;\n}\n.lock[data-v-06f669d0]{background: url(" + escape(__webpack_require__(178)) + ") no-repeat center;background-size: cover;width: 22px;height: 22px;position:absolute;right: 20px;\n}\n.description[data-v-06f669d0]{white-space:nowrap; overflow:hidden; text-overflow:ellipsis\n}\n.buttonx[data-v-06f669d0]{width: 100px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;line-height: 28px;text-align: center;cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "text" } },
      [
        _vm._l(_vm.sceneList, function(c, key) {
          return _c("div", { key: key, staticClass: "step-list" }, [
            _c("div", { staticClass: "step-list_top" }, [
              _c("div", { staticClass: "list_top_left" }, [
                _c("div", {
                  staticClass: "circle",
                  class: c.status == "Finish" ? "circle" : "othercircle"
                }),
                _vm._v(
                  "\n                " + _vm._s(c.name) + "\n                "
                ),
                _c(
                  "div",
                  { class: c.status == "Finish" ? "isgreen" : "isred" },
                  [
                    _vm._v(
                      "\n                  " +
                        _vm._s(c.status == "Finish" ? "已完成" : "未完成") +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "list_top_right" }, [
                _c(
                  "div",
                  { staticClass: "buttonx", on: { click: _vm.gocurriculum } },
                  [_vm._v("点击学习")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "step-list_under" }, [
              _vm._v(
                "\n              场景介绍：" +
                  _vm._s(c.description) +
                  "\n            "
              )
            ])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06f669d0", esExports)
  }
}

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialCourses_vue__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialCourses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialCourses_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialCourses_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialCourses_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14be3eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialCourses_vue__ = __webpack_require__(1644);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1640)
  __webpack_require__(1642)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14be3eaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialCourses_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14be3eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialCourses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/newservice/SpecialCourses.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14be3eaa", Component.options)
  } else {
    hotAPI.reload("data-v-14be3eaa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f8f033ae", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14be3eaa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SpecialCourses.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14be3eaa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SpecialCourses.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(177);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.isreturn[data-v-14be3eaa] {\n  color: #000;\n  cursor: pointer;\n}\n[data-v-14be3eaa] .el-icon-arrow-left {\n  color: #000;\n}\n.step-list[data-v-14be3eaa] {\n  margin-bottom: 20px;\n  background: #fff;\n  border-radius: 5px;\n  padding: 19px 20px 20px 60px;\n  position: relative;\n}\n.step-list_top[data-v-14be3eaa] {\n  display: flex;\n  justify-content: space-between;\n}\n.list_top_left[data-v-14be3eaa] {\n  display: flex;\n}\n.list_top_left[data-v-14be3eaa] {\n  font-size: 16px;\n  color: #262626;\n  font-weight: bold;\n  position: relative;\n  left: -20px;\n}\n.isred[data-v-14be3eaa] {\n  color: #E53434;\n  margin-right: 10px;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #E53434;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #FBE5E5;\n  height: 18px;\n  line-height: 15px;\n}\n.isgreen[data-v-14be3eaa] {\n  color: #14C034;\n  margin-right: 10px;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #39CA54;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #D9F4DE;\n  height: 18px;\n  line-height: 15px;\n}\n[data-v-14be3eaa] .el-button--small {\n  padding: 9px 24px !important;\n  border-radius: 6px;\n}\n[data-v-14be3eaa] .el-button--primary {\n  background-color: #497af2;\n}\n.step-list_under[data-v-14be3eaa] {\n  margin-top: 15px;\n  background: #f5f6f7;\n  padding: 19px 20px 20px 19px;\n  font-size: 13px;\n  overflow: hidden;\n  color: #262626;\n}\n.circle[data-v-14be3eaa] {\n  width: 20px;\n  height: 20px;\n  background: #497AF2;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  left: -20px;\n  top: 2px;\n  color: #fff;\n  font-weight: normal;\n  line-height: 20px;\n}\n.othercircle[data-v-14be3eaa] {\n  width: 20px;\n  height: 20px;\n  background: #BBBBBB;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  left: -20px;\n  top: 2px;\n  color: #fff;\n  font-weight: normal;\n  line-height: 20px;\n}\n.line[data-v-14be3eaa] {\n  width: 2px;\n  top: 41px;\n  bottom: -20px;\n  left: 29px;\n  position: absolute;\n  border-color: inherit;\n  background-color: #1684fc;\n  z-index: 99;\n}\n.otherline[data-v-14be3eaa] {\n  width: 2px;\n  top: 41px;\n  bottom: -20px;\n  left: 29px;\n  position: absolute;\n  border-color: inherit;\n  background-color: #BBBBBB;\n  z-index: 99;\n}\n#app[data-v-14be3eaa] {\n  height: 100%;\n  box-sizing: border-box;\n}\n#Return_Bar[data-v-14be3eaa] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n[data-v-14be3eaa] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-14be3eaa] {\n  background: #f6f5f8;\n  width: 100%;\n  height: 100%;\n  padding: 20px 20px;\n}\n#text .right[data-v-14be3eaa] {\n  width: 100%;\n  margin-left: 10px;\n}\n.right-top[data-v-14be3eaa] {\n  display: flex;\n  justify-content: space-between;\n}\n.twolevel_list[data-v-14be3eaa] {\n  padding: 10px 20px;\n  background: #fff;\n  width: 100%;\n  border-radius: 5px;\n  display: flex;\n  margin-bottom: 20px;\n}\n.twolevel_list .left[data-v-14be3eaa] {\n  width: 40px;\n}\n.twolevel_list .left .circle_state[data-v-14be3eaa] {\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  margin-top: 3px;\n  margin-left: 10px;\n  background: #d5d7d8;\n  color: #fff;\n  text-align: center;\n}\n.right_listleft[data-v-14be3eaa] {\n  font-size: 17px;\n  color: #000;\n  font-weight: 600;\n}\n.right_listleft > .pass[data-v-14be3eaa] {\n  margin-left: 10px;\n  color: #6cc080;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #6cc080;\n  border-radius: 5px;\n  background: #d3f6d3;\n}\n.right_listleft > .failed[data-v-14be3eaa] {\n  margin-left: 10px;\n  color: #e15062;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 5px;\n  border: 1px solid #e15062;\n  border-radius: 5px;\n  background: #ffe3e2;\n}\n.right_listright[data-v-14be3eaa] {\n  background: #1684fc;\n  color: #fff;\n  padding: 5px 20px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n.right_under[data-v-14be3eaa] {\n  background: #f6f5f8;\n  padding: 20px;\n  margin-top: 10px;\n  border-radius: 5px;\n  font-size: 13px;\n}\n.right_under > div[data-v-14be3eaa] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.circle_state_pass[data-v-14be3eaa] {\n  background: #1684fc !important;\n}\n.lock[data-v-14be3eaa] {\n  background: url(" + escape(__webpack_require__(178)) + ") no-repeat center;\n  background-size: cover;\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  right: 20px;\n}\n.description[data-v-14be3eaa] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.sp_button[data-v-14be3eaa] {\n  width: 95px;\n  height: 28px;\n  background: #BFD0FB;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #497AF2;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  letter-spacing: 1px;\n}\n.spb_button[data-v-14be3eaa] {\n  width: 95px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  margin-left: 10px;\n  letter-spacing: 1px;\n}\n.sph_button[data-v-14be3eaa] {\n  width: 95px;\n  height: 28px;\n  background: #ff2323;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  margin-left: 10px;\n  letter-spacing: 1px;\n}\n.list_top_right[data-v-14be3eaa] {\n  display: flex;\n}\n.priContent[data-v-14be3eaa] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.priContent .prictice .pricComfir[data-v-14be3eaa] {\n  width: 100%;\n  margin-top: 20px;\n  padding-bottom: 50px;\n}\n.priContent .prictice .comTitle[data-v-14be3eaa] {\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n.priContent .prictice .content[data-v-14be3eaa] {\n  display: flex;\n}\n.priContent .prictice .input .el-input__inner[data-v-14be3eaa] {\n  border-radius: 10px;\n  width: 320px;\n}\n.priContent .prictice .comfirmBtn[data-v-14be3eaa] {\n  margin-left: 15px;\n  width: 170px;\n  line-height: 40px;\n  background-color: #D3D3D3;\n  text-align: center;\n  color: #fff;\n  border-radius: 15px;\n}\n.priContent .prictice .ActiveComBtn[data-v-14be3eaa] {\n  background-color: #118EF2;\n  cursor: pointer;\n}\n.priContent .prictice .stOrNew[data-v-14be3eaa] {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.priContent .prictice .defaultBtn[data-v-14be3eaa] {\n  width: 120px;\n  color: #fff;\n  border-radius: 20px;\n  text-align: center;\n  line-height: 35px;\n  height: 35px;\n  cursor: pointer;\n}\n.priContent .prictice .newPrict[data-v-14be3eaa] {\n  background-color: #008000;\n  margin-left: 20px;\n}\n.priContent .prictice .stopPrict[data-v-14be3eaa] {\n  background-color: #FF0000;\n}\n.priContent .prictice .handBox[data-v-14be3eaa] {\n  margin-top: 50px;\n}\n.top_line[data-v-14be3eaa] {\n  position: absolute;\n  top: 0;\n  left: 29px;\n  width: 2px;\n  height: 21px;\n}\n.top_isCheck[data-v-14be3eaa] {\n  background: #1684fc;\n}\n.top_noCheck[data-v-14be3eaa] {\n  background: #BBBBBB;\n}\n[data-v-14be3eaa] .el-dialog--center .el-dialog__body {\n  text-align: center;\n}\n.dialog_img[data-v-14be3eaa] {\n  width: 85px;\n  height: 64px;\n  margin: 0 auto;\n}\n[data-v-14be3eaa] .el-dialog {\n  border-radius: 10px;\n}\n.qq_text[data-v-14be3eaa] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 18px;\n  text-align: center;\n  margin-top: 14px;\n}\n", ""]);

// exports


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1643);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c0cb7990", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14be3eaa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./SpecialCourses.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14be3eaa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./SpecialCourses.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.currency_button {\n  display: flex;\n  justify-content: center;\n}\n.determine {\n  width: 80px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.cancel {\n  width: 80px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #717171;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("div", { attrs: { id: "Return_Bar" } }, [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
          _vm._v("返回")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "text" } },
        [
          [
            _vm._l(_vm.courseList, function(c, key) {
              return _c(
                "div",
                {
                  key: key,
                  ref: "asx",
                  refInFor: true,
                  staticClass: "step-list"
                },
                [
                  _c("div", { staticClass: "step-list_top" }, [
                    _c("div", { staticClass: "list_top_left" }, [
                      _c(
                        "div",
                        {
                          staticClass: "circle",
                          class: {
                            circle: c.passState == "Passed",
                            othercircle:
                              c.passState == "Ongoing" || c.passState == null
                          }
                        },
                        [
                          _vm.courseList.length != 1
                            ? _c("div", [_vm._v(_vm._s(key + 1))])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(
                        "\n            " +
                          _vm._s(c.courseName) +
                          "\n            "
                      ),
                      _c(
                        "div",
                        {
                          class: c.passState == "Passed" ? "isgreen" : "isred"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                c.passState == "Passed" && c.passState != "null"
                                  ? "已完成"
                                  : "未完成"
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "list_top_right" }, [
                      c.assitantType == "PartnerCallOutExercise" &&
                      c.unlock == true
                        ? _c(
                            "div",
                            {
                              staticClass: "sp_button",
                              on: {
                                click: function($event) {
                                  return _vm.practise(c.courseId)
                                }
                              }
                            },
                            [_vm._v("练习记录")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "PartnerCallOutExercise" &&
                      _vm.step != "handing" &&
                      c.unlock == true
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goDuilian(
                                    c.assitantType,
                                    c.courseId
                                  )
                                }
                              }
                            },
                            [_vm._v("点击练习")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "PartnerCallOutExercise" &&
                      _vm.step == "handing" &&
                      c.unlock == true &&
                      (_vm.curLinkCourseId == "null" ||
                        _vm.curLinkCourseId == c.courseId)
                        ? _c(
                            "div",
                            {
                              staticClass: "sph_button",
                              on: { click: _vm.stopPrict }
                            },
                            [_vm._v("结束练习")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "CallOutAbilityCheck" &&
                      c.unlock == true
                        ? _c(
                            "div",
                            {
                              staticClass: "sp_button",
                              on: {
                                click: function($event) {
                                  return _vm.testRecord(c.courseId)
                                }
                              }
                            },
                            [_vm._v("测试记录")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "CallOutAbilityCheck" &&
                      c.passState == "Ongoing" &&
                      c.exerciseStatus == null &&
                      !_vm.examCheckBtnTip &&
                      !_vm.hasExerciseStatus
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.toChildCourse(
                                    c.courseId,
                                    c.assitantType,
                                    c.businessMajorId
                                  )
                                }
                              }
                            },
                            [_vm._v("点击测试")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "CallOutAbilityCheck" &&
                      c.passState == "Ongoing" &&
                      c.exerciseStatus == null &&
                      _vm.examCheckBtnTip &&
                      !_vm.hasExerciseStatus
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              staticStyle: {
                                "background-color": "#E1E1E1",
                                color: "#ABABAB"
                              },
                              on: { click: _vm.alertTrainNoStart }
                            },
                            [_vm._v("\n              点击测试\n            ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "CallOutAbilityCheck" &&
                      c.passState == "Ongoing" &&
                      c.exerciseStatus == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "sph_button",
                              on: { click: _vm.stopKaohePrict }
                            },
                            [_vm._v("结束测试")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "CallOutAbilityCheckRandom" &&
                      c.passState == "Ongoing" &&
                      c.exerciseStatus == null &&
                      !_vm.hasExerciseStatus
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.showRandomScript(c)
                                }
                              }
                            },
                            [_vm._v("点击测试")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "CallOutAbilityCheckRandom" &&
                      c.passState == "Ongoing" &&
                      c.exerciseStatus == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "sph_button",
                              on: { click: _vm.stopKaohePrict }
                            },
                            [_vm._v("结束测试")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.assitantType == "urlLink" && c.unlock == true
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goStudy(c)
                                }
                              }
                            },
                            [_vm._v("点击上传")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.passState == "Ongoing" &&
                      (c.assitantType == "" || c.assitantType == null) &&
                      c.courseType != "Exam"
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goStudy(c)
                                }
                              }
                            },
                            [_vm._v("点击学习")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.passState == "Passed" &&
                      (c.assitantType == "" || c.assitantType == null) &&
                      c.courseType != "Exam"
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goStudy(c)
                                }
                              }
                            },
                            [_vm._v("重新学习")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.passState == "Ongoing" && c.courseType == "Exam"
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goStudy(c)
                                }
                              }
                            },
                            [_vm._v("点击测试\n            ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.passState == "Passed" && c.courseType == "Exam"
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goStudy(c)
                                }
                              }
                            },
                            [_vm._v("重新测试\n            ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.passState == null &&
                      (c.assitantType == "" || c.assitantType == null) &&
                      c.unlock == true
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goStudy(c)
                                }
                              }
                            },
                            [_vm._v("点击学习")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.passState == "Ongoing" &&
                      (c.assitantType == "beforeSaleExam" ||
                        c.assitantType == "afterSaleExam") &&
                      c.unlock == true
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goStudy(c)
                                }
                              }
                            },
                            [_vm._v("点击学习")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.passState == "Passed" &&
                      (c.assitantType == "beforeSaleExam" ||
                        c.assitantType == "afterSaleExam") &&
                      c.unlock == true
                        ? _c(
                            "div",
                            {
                              staticClass: "spb_button",
                              on: {
                                click: function($event) {
                                  return _vm.goStudy(c)
                                }
                              }
                            },
                            [_vm._v("重新学习")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      c.unlock == false
                        ? _c("div", { staticClass: "lock" })
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    c.description != ""
                      ? _c("div", { staticClass: "step-list_under" }, [
                          _c("div", {
                            staticStyle: { width: "80%" },
                            domProps: { innerHTML: _vm._s(c.description) }
                          })
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  key != 0
                    ? _c("div", {
                        staticClass: "top_line",
                        class: {
                          top_isCheck:
                            c.passState == "Passed" || c.passState == "Ongoing",
                          top_noCheck: c.passState == null
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.courseList.length > 1 && key != _vm.courseList.length - 1
                    ? _c("div", {
                        class: {
                          line: c.passState == "Passed",
                          otherline:
                            c.passState == "Ongoing" || c.passState == null
                        }
                      })
                    : _vm._e()
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "",
                  visible: _vm.notification,
                  width: "27%",
                  center: ""
                },
                on: {
                  "update:visible": function($event) {
                    _vm.notification = $event
                  }
                }
              },
              [
                _c("div", { staticClass: "isbox" }, [_vm._v("需要先结束考核")]),
                _vm._v(" "),
                _c("div", { staticClass: "isbox" }, [
                  _vm._v("是否确定结束考核")
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.notification = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.Clickconfirm }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: { visible: _vm.showEachDialog, width: "500px" },
                on: {
                  "update:visible": function($event) {
                    _vm.showEachDialog = $event
                  }
                }
              },
              [
                _c("div", { staticClass: "priContent" }, [
                  _c("div", { staticClass: "prictice" }, [
                    _vm.step == "second"
                      ? _c("div", { staticClass: "pricComfir" }, [
                          _c("div", { staticClass: "comTitle" }, [
                            _vm._v(" 请输入对练搭档的9位数淘金号：")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _c("el-input", {
                                staticClass: "input",
                                attrs: {
                                  placeholder: "请输入对练搭档的淘金号"
                                },
                                model: {
                                  value: _vm.input,
                                  callback: function($$v) {
                                    _vm.input = $$v
                                  },
                                  expression: "input"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class: _vm.input
                                    ? "comfirmBtn ActiveComBtn"
                                    : "comfirmBtn",
                                  on: { click: _vm.goToPrict }
                                },
                                [_vm._v("确定")]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "提示",
                  visible: _vm.dialogVisible,
                  width: "30%",
                  "before-close": _vm.handleClose
                },
                on: {
                  "update:visible": function($event) {
                    _vm.dialogVisible = $event
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(
                    "是否确定与" +
                      _vm._s(_vm.partner.realName) +
                      "(" +
                      _vm._s(_vm.partner.tjkNumber) +
                      ")进行语音对练?"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.dialogVisible = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.clearSchedule }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "",
                  visible: _vm.exercisePopup,
                  width: "27%",
                  center: ""
                },
                on: {
                  "update:visible": function($event) {
                    _vm.exercisePopup = $event
                  }
                }
              },
              [
                _c("div", { staticClass: "isbox" }, [_vm._v("需要先结束对练")]),
                _vm._v(" "),
                _c("div", { staticClass: "isbox" }, [
                  _vm._v("是否确定结束对练")
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.exercisePopup = false
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.exerciseClickconfirm }
                      },
                      [_vm._v("确 定")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "考核次数",
            visible: _vm.theoryRemainDialog.show,
            width: "360px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.theoryRemainDialog, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "总考核次数", "label-width": "150px" } },
                [
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary", underline: false },
                      on: {
                        click: function($event) {
                          return _vm.editRow(_vm.scope.row)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.theoryRemainDialog.total))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "剩余考核数", "label-width": "150px" } },
                [
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary", underline: false },
                      on: {
                        click: function($event) {
                          return _vm.editRow(_vm.scope.row)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.theoryRemainDialog.remain))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "currency_button" }, [
                _c(
                  "div",
                  {
                    staticClass: "cancel",
                    on: {
                      click: function($event) {
                        _vm.theoryRemainDialog.show = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "determine",
                    on: { click: _vm.goThoryExamPage }
                  },
                  [_vm._v("确定")]
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: !!_vm.enterGroup.popwin,
            width: "360px",
            "show-close": false,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(!!_vm.enterGroup, "popwin", $event)
            }
          }
        },
        [
          _c("div", { staticClass: "dialog_img" }, [
            _c("img", {
              attrs: {
                src: __webpack_require__(36),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qq_text" }, [
            _vm._v(_vm._s(_vm.enterGroup.popTips))
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "currency_button" }, [
                _c(
                  "div",
                  {
                    staticClass: "determine",
                    on: { click: _vm.enterGroupAct }
                  },
                  [_vm._v("确定")]
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14be3eaa", esExports)
  }
}

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CallOutRandomScript_vue__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CallOutRandomScript_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CallOutRandomScript_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CallOutRandomScript_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CallOutRandomScript_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaaada3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CallOutRandomScript_vue__ = __webpack_require__(1648);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1646)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aaaada3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CallOutRandomScript_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaaada3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CallOutRandomScript_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/newservice/CallOutRandomScript.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aaaada3c", Component.options)
  } else {
    hotAPI.reload("data-v-aaaada3c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1647);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("506bee2c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-aaaada3c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CallOutRandomScript.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-aaaada3c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CallOutRandomScript.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.isreturn[data-v-aaaada3c] {\n  color: #000;\n  cursor: pointer;\n}\n[data-v-aaaada3c] .el-icon-arrow-left {\n  color: #000;\n}\n.step-list[data-v-aaaada3c] {\n  margin-bottom: 20px;\n  background: #fff;\n  border-radius: 5px ;\n  padding: 19px 20px 20px 60px;\n  position: relative;\n}\n.step-list_top[data-v-aaaada3c] {\n  display: flex;\n  justify-content: space-between;\n}\n.list_top_left[data-v-aaaada3c] {\n  display: flex;\n}\n.list_top_left[data-v-aaaada3c] {\n  font-size: 16px;\n  color: #262626;\n  font-weight: bold;\n  position: relative;\n  left: -20px;\n}\n[data-v-aaaada3c] .el-button--small {\n  padding: 9px 24px !important;\n  border-radius: 6px;\n}\n[data-v-aaaada3c] .el-button--primary {\n  background-color: #497af2;\n}\n.step-list_under[data-v-aaaada3c] {\n  margin-top: 15px;\n  background: #f5f6f7;\n  padding: 19px 20px 20px 19px;\n  font-size: 13px;\n  overflow: hidden;\n  color: #262626;\n}\n.circle[data-v-aaaada3c] {\n  width: 20px;\n  height: 20px;\n  background: #497AF2;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  left: -20px;\n  top: 2px;\n  color: #fff;\n  font-weight: normal;\n  line-height: 20px;\n}\n.othercircle[data-v-aaaada3c] {\n  width: 20px;\n  height: 20px;\n  background: #BBBBBB;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  left: -20px;\n  top: 2px;\n  color: #fff;\n  font-weight: normal;\n  line-height: 20px;\n}\n.line[data-v-aaaada3c] {\n  width: 2px;\n  top: 41px;\n  bottom: -20px;\n  left: 29px;\n  position: absolute;\n  border-color: inherit;\n  background-color: #1684fc;\n  z-index: 99;\n}\n.otherline[data-v-aaaada3c] {\n  width: 2px;\n  top: 41px;\n  bottom: -20px;\n  left: 29px;\n  position: absolute;\n  border-color: inherit;\n  background-color: #BBBBBB;\n  z-index: 99;\n}\n#app[data-v-aaaada3c] {\n  height: 100%;\n  box-sizing: border-box;\n}\n#Return_Bar[data-v-aaaada3c] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n[data-v-aaaada3c] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-aaaada3c] {\n  background: #f6f5f8;\n  width: 100%;\n  height: 100%;\n  padding: 20px 20px;\n}\n#text .right[data-v-aaaada3c] {\n  width: 100%;\n  margin-left: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: { "text-align": "center", width: "100%" },
        attrs: { id: "text" }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              "margin-left": "10%",
              "min-height": "800px",
              "padding-bottom": "30px",
              "background-color": "#fff"
            }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "left",
                  width: "80%",
                  "margin-left": "10%"
                }
              },
              [
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      margin: "30px 0px 0px 20px"
                    }
                  },
                  [
                    _c("b", [
                      _vm._v("本次测试的项目场景为“"),
                      _c("span", { staticStyle: { color: "#4978F2" } }, [
                        _vm._v(_vm._s(_vm.randomScript.title))
                      ]),
                      _vm._v("”，请尽快熟悉以下资料并了解测试要求：")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      margin: "20px 0px 0px 20px",
                      "background-color": "#F2F2F2",
                      "min-height": "170px",
                      padding: "10px 20px 10px 20px"
                    }
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.randomScript.intro))])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      margin: "20px 0px 0px 20px",
                      "background-color": "#F2F2F2",
                      "min-height": "170px",
                      padding: "10px 20px 10px 20px"
                    }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { "font-size": "14px" },
                      domProps: { innerHTML: _vm._s(_vm.randomScript.script) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      margin: "20px 0px 0px 20px",
                      "background-color": "#F2F2F2",
                      "min-height": "170px",
                      padding: "10px 20px 10px 20px"
                    }
                  },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: { "font-size": "14px" },
                      domProps: { innerHTML: _vm._s(_vm.randomScript.asking) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "18px",
                      margin: "20px 0px 0px 20px",
                      padding: "10px 20px 10px 20px",
                      "text-align": "center"
                    }
                  },
                  [
                    _vm.seconds > 0
                      ? _c("div", { staticStyle: { "font-weight": "bold" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "38%",
                                width: "80px"
                              }
                            },
                            [_vm._v("测试将在")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                width: "100px",
                                height: "30px",
                                "border-radius": "6px",
                                "background-color": "#AAA",
                                "padding-top": "2px",
                                margin: "0px 5px 0px 5px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.time))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticStyle: { float: "left" } }, [
                            _vm._v("后开始")
                          ])
                        ])
                      : _c("div", { staticStyle: { "font-weight": "bold" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "38%",
                                width: "80px"
                              }
                            },
                            [_vm._v(" ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                "font-size": "15px",
                                width: "100px",
                                height: "30px",
                                "border-radius": "6px",
                                "background-color": "#69f",
                                color: "#f7f7f7",
                                "padding-top": "2px",
                                margin: "0px 5px 0px 5px"
                              },
                              on: { click: _vm.goKaohe }
                            },
                            [_vm._v("开始测试")]
                          )
                        ])
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("项目介绍")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("参考话术")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("测试要求")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aaaada3c", esExports)
  }
}

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessions_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessions_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessions_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessions_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeb24eee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sessions_vue__ = __webpack_require__(1652);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1650)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aeb24eee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sessions_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeb24eee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sessions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/newservice/Sessions.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aeb24eee", Component.options)
  } else {
    hotAPI.reload("data-v-aeb24eee", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1651);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ee33da3e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-aeb24eee\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sessions.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-aeb24eee\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sessions.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#app[data-v-aeb24eee] {\n  height: 100%;\n  box-sizing: border-box;\n  background: #f6f5f8;\n}\n#Return_Bar[data-v-aeb24eee] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n  background: #fff;\n}\n[data-v-aeb24eee].el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-aeb24eee] {\n  background: #f6f5f8;\n  width: 100%;\n\n  padding: 20px 20px;\n}\n.isreturn[data-v-aeb24eee] {\n  color: #262626;\n  cursor: pointer;\n  margin-top: 2px;\n}\n.title[data-v-aeb24eee] {\n  margin-top: 21px;\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n  line-height: 24px;\n}\n.list[data-v-aeb24eee] {\n  background: #ffffff;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  position: relative;\n}\n.list_title[data-v-aeb24eee] {\n  width: 100px;\n  height: 34px;\n  background: #497af2;\n  border-radius: 10px 0px 10px 0px;\n  font-size: 16px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #ffffff;\n  text-align: center;\n  line-height: 34px;\n}\n.list_attribute[data-v-aeb24eee] {\n  margin-left: 20px;\n  margin-top: 20px;\n}\n.Training_date[data-v-aeb24eee],\n.Training_time[data-v-aeb24eee],\n.Trainer[data-v-aeb24eee] {\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n}\n.title_content[data-v-aeb24eee] {\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-top: 4px;\n  background: #f5f6f7;\n  padding: 20px;\n}\n.title_content_text[data-v-aeb24eee] {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n}\n.list_button_stuta[data-v-aeb24eee]{\n  position: absolute;\n  top: 46px;\n  right: 20px;\n  width: 100px;\n  height: 28px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: bold;\n  letter-spacing: 1px;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.list_button_stuta1[data-v-aeb24eee] {\n  background: #dbe5ff;\n  color: #497af2;\n}\n.list_button_stuta2[data-v-aeb24eee]{\nbackground: #497AF2;\ncolor: #FFFFFF;\n}\n.list_button_stuta3[data-v-aeb24eee]{\ntop: 85px;\nbackground: #E1E1E1;\ncolor: #ABABAB;\n}\n.list_button_stuta4[data-v-aeb24eee]{\nbackground: #E1E1E1;\ncolor: #ABABAB;\n}\n", ""]);

// exports


/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "text" } },
      [
        _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.trainTitle))]),
        _vm._v(" "),
        _vm._l(_vm.SessionsList, function(item, index) {
          return _c("div", { key: index, staticClass: "list" }, [
            _c("div", { staticClass: "list_title" }, [
              _vm._v(_vm._s(item.trainIndexDesc))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "list_attribute" }, [
              _c("div", { staticClass: "Training_date" }, [
                _vm._v("培训日期：" + _vm._s(item.trainDate))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "Training_time" },
                [
                  _vm._v("\n          培训时间："),
                  _vm._l(item.trainTimeList, function(i, s) {
                    return _c("span", { key: s }, [
                      _vm._v(_vm._s(i)),
                      s < item.trainTime.length - 1
                        ? _c("span", [_vm._v("，")])
                        : _vm._e()
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "Trainer" }, [
                _vm._v("培训讲师：" + _vm._s(item.teacherName))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "title_content" }, [
              _c("div", { staticClass: "title_content_text" }, [
                _vm._v(
                  "\n          培训内容：" +
                    _vm._s(_vm.trainContent) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            item.signStatus == "Yes"
              ? _c(
                  "div",
                  { staticClass: "list_button_stuta list_button_stuta1" },
                  [_vm._v("已签到")]
                )
              : _vm._e(),
            _vm._v(" "),
            item.signStatus == "noSignAlreadyOpen"
              ? _c(
                  "div",
                  {
                    staticClass: "list_button_stuta list_button_stuta2",
                    on: {
                      click: function($event) {
                        return _vm.GoSignin(item.seqId)
                      }
                    }
                  },
                  [_vm._v("点击签到")]
                )
              : _vm._e(),
            _vm._v(" "),
            item.signStatus == "noSignedNoOpen"
              ? _c(
                  "div",
                  {
                    staticClass: "list_button_stuta",
                    class:
                      item.signStatus == "noSignedNoOpen" &&
                      item.signStatus != "Yes"
                        ? "list_button_stuta4"
                        : "list_button_stuta3"
                  },
                  [_vm._v("点击签到")]
                )
              : _vm._e()
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aeb24eee", esExports)
  }
}

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnInline_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnInline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnInline_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnInline_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnInline_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73fea878_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnInline_vue__ = __webpack_require__(1656);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1654)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73fea878"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnInline_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73fea878_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnInline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/newservice/OnInline.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-73fea878", Component.options)
  } else {
    hotAPI.reload("data-v-73fea878", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1655);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("254d6538", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73fea878\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OnInline.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-73fea878\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OnInline.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#app[data-v-73fea878] {\n  height: 100%;\n  box-sizing: border-box;\n  background: #f6f5f8;\n}\n#Return_Bar[data-v-73fea878] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n  background: #fff;\n}\n[data-v-73fea878] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-73fea878] {\n  background: #f6f5f8;\n  width: 100%;\n  height: 100%;\n  padding: 20px 20px;\n}\n.isreturn[data-v-73fea878] {\n  color: #262626;\n  cursor: pointer;\n  margin-top: 2px;\n}\n.timestyle[data-v-73fea878] {\n  margin: 0 20px;\n  height: 28px;\n  line-height: 28px;\n}\n[data-v-73fea878] .el-dialog {\n  border-radius: 10px;\n}\n[data-v-73fea878] .el-dialog__header {\n  border-bottom: 1px solid #E9E9E9;\n}\n[data-v-73fea878] .el-dialog__title {\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n}\n.currency_img[data-v-73fea878] {\n  width: 85px;\n  height: 64px;\n  margin: 0 auto;\n  margin-bottom: 12px;\n}\n.currency_img > img[data-v-73fea878] {\n  width: 100%;\n  height: 100%;\n}\n.currency_text[data-v-73fea878] {\n  text-align: center;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 400;\n  color: #262626;\n  line-height: 20px;\n}\n.currency_text > span[data-v-73fea878] {\n  color: #497AF2;\n}\n.cancel[data-v-73fea878] {\n  width: 80px;\n  height: 28px;\n  background: #E1E1E1;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #717171;\n  text-align: center;\n  line-height: 28px;\n  margin-right: 10px;\n}\n.determine[data-v-73fea878] {\n  width: 80px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n}\n.currency_button[data-v-73fea878] {\n  display: flex;\n  justify-content: center;\n}\n.left_span[data-v-73fea878] {\n  color: #497AF2;\n}\n.otherdetermine[data-v-73fea878] {\n  padding: 0px 15px 0px 15px;\n  height: 33px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 33px;\n  cursor: pointer;\n}\n.specialfont[data-v-73fea878] {\n  font-size: 18px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #262626;\n  line-height: 18px;\n  margin-bottom: 11px;\n  margin-top: 12px;\n}\n.specialfont-small[data-v-73fea878] {\n  margin-top: 3px;\n  margin-bottom: 12px;\n  font-size: 11px;\n}\n.pecialfont-text[data-v-73fea878] {\n  font-size: 14px;\n}\n", ""]);

// exports


/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        { staticStyle: { position: "relative" }, attrs: { id: "Return_Bar" } },
        [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
            _vm._v("返回")
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: {
                position: "absolute",
                top: "9px",
                right: "20px",
                "z-index": "9"
              },
              attrs: {
                target: "_blank",
                href:
                  _vm.imUrl +
                  "/TJ_TJK_IMAction.html?token=" +
                  _vm.imToken +
                  "&tjkId=" +
                  _vm.tjkInfo.id +
                  "&userName=" +
                  _vm.tjkInfo.realName +
                  "&tjkNumber=" +
                  _vm.tjkInfo.tjkNum +
                  "&platform=assitant"
              }
            },
            [
              _c("img", {
                staticStyle: { height: "30px" },
                attrs: { src: __webpack_require__(471), alt: "" }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "text" } }, [
        _c(
          "iframe",
          {
            ref: "iframeQiannui",
            attrs: {
              id: "iframeQiannui",
              frameborder: "no",
              scrolling: "yes",
              allowfullscreen: "true",
              width: "100%",
              height: "100%",
              src: _vm.QiannuiiframeURL
            }
          },
          [
            _vm._v(
              "\n                您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面\n            "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "提示", visible: _vm.currency, width: "360px" },
          on: {
            "update:visible": function($event) {
              _vm.currency = $event
            }
          }
        },
        [
          _c("div", { staticClass: "currency_img" }, [
            _c("img", {
              attrs: {
                src: __webpack_require__(640),
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "currency_text" }, [
            _vm.tjkAnswer
              ? _c("div", { staticClass: "specialfont" }, [_vm._v("恭喜你!")])
              : _vm._e(),
            _vm._v(" "),
            _vm.tjkAnswer
              ? _c("div", { staticClass: "pecialfont-text" }, [
                  _vm._v("你已通过“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v("打字测试")
                  ]),
                  _vm._v("”")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tjkAnswer
              ? _c("div", { staticClass: "specialfont-small" }, [
                  _vm._v("测试结果："),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.speedfraction) + "字/分钟")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 1
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.knowledgename))
                  ]),
                  _vm._v("”的学习"),
                  _c("br"),
                  _vm._v("接下来，请进行“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.nextknowledgename))
                  ]),
                  _vm._v("”的学习")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 &&
            _vm.Coursestate == "Exam" &&
            _vm.tabstate == null
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.knowledgename))
                  ]),
                  _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                  _c("br"),
                  _vm._v("接下来，请进行一个测试")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 &&
            _vm.Coursestate == "Practice" &&
            _vm.tabstate == null
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.knowledgename))
                  ]),
                  _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                  _c("br"),
                  _vm._v("接下来，请进行下一个练习")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 &&
            _vm.Coursestate == "Study" &&
            _vm.tabstate == null
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.knowledgename))
                  ]),
                  _vm._v("”的" + _vm._s(_vm.nowCoursestatetext)),
                  _c("br"),
                  _vm._v("接下来，请进行下一个课程的学习")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 && _vm.tabstate == 2
              ? _c("div", [
                  _vm._v("你已完成“"),
                  _c("span", { staticClass: "left_span" }, [
                    _vm._v(_vm._s(_vm.categoryName))
                  ]),
                  _vm._v("”的学习"),
                  _c("br"),
                  _vm._v("接下来，请进行下一个阶段的学习")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.knowledgestate == 2 && _vm.tabstate == 1
              ? _c("div", [
                  _vm._v(
                    "你已完成" + _vm._s(_vm.categoryName) + "全部课程的学习"
                  ),
                  _c("br"),
                  _vm._v("现在可以去APP领取任务了")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "currency_button" }, [
                _vm.knowledgestate == 1 && _vm.Operation == false
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去学习\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 1 && _vm.Operation
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去练习\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.Coursestate == "Exam"
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去测试\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.Coursestate == "Study"
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [
                        _vm._v(
                          "\n                    继续学习\n                "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.Coursestate == "Practice"
                  ? _c(
                      "div",
                      {
                        staticClass: "determine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去练习\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 &&
                _vm.tabstate == 2 &&
                _vm.dazhiJump == false
                  ? _c(
                      "div",
                      {
                        staticClass: "otherdetermine",
                        on: { click: _vm.determine }
                      },
                      [
                        _vm._v(
                          "\n                    去报名并参加" +
                            _vm._s(_vm.nextcategoryName) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.tabstate == 2 && _vm.dazhiJump
                  ? _c(
                      "div",
                      {
                        staticClass: "otherdetermine",
                        on: { click: _vm.determine }
                      },
                      [_vm._v("\n                    去学习\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.knowledgestate == 2 && _vm.tabstate == 1
                  ? _c(
                      "div",
                      { staticClass: "determine", on: { click: _vm.goindex } },
                      [
                        _vm._v(
                          "\n                    我知道了\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73fea878", esExports)
  }
}

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationRecord_vue__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationRecord_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationRecord_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationRecord_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationRecord_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9dc8dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationRecord_vue__ = __webpack_require__(1660);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1658)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c9dc8dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationRecord_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9dc8dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationRecord_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/newservice/OperationRecord.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c9dc8dc", Component.options)
  } else {
    hotAPI.reload("data-v-4c9dc8dc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ed7c1682", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c9dc8dc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OperationRecord.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c9dc8dc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OperationRecord.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n#app[data-v-4c9dc8dc] {\n  height: 100%;\n  box-sizing: border-box;\n  background: #f6f5f8;\n}\n#Return_Bar[data-v-4c9dc8dc] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n  background: #fff;\n}\n[data-v-4c9dc8dc] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-4c9dc8dc] {\n  background: #f6f5f8;\n  width: 100%;\n  height: 100%;\n  padding: 20px 20px;\n}\n.isreturn[data-v-4c9dc8dc] {\n  color: #262626;\n  cursor: pointer;\n  margin-top: 2px;\n}\n.timestyle[data-v-4c9dc8dc] {\n  margin: 0 20px;\n  height: 28px;\n  line-height: 28px;\n}\n", ""]);

// exports


/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "text" } }, [
      _c(
        "iframe",
        {
          ref: "iframeOperationRecordi",
          attrs: {
            id: "iframeOperationRecord",
            frameborder: "no",
            scrolling: "yes",
            allowfullscreen: "true",
            width: "100%",
            height: "100%",
            src: _vm.QiannuiiframeURL
          }
        },
        [
          _vm._v(
            "\n                 您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面\n             "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c9dc8dc", esExports)
  }
}

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newexcel_vue__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newexcel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newexcel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newexcel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newexcel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dc4f9b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newexcel_vue__ = __webpack_require__(1664);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1662)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7dc4f9b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newexcel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dc4f9b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newexcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/excel/newexcel.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7dc4f9b4", Component.options)
  } else {
    hotAPI.reload("data-v-7dc4f9b4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1663);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("123db4ba", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7dc4f9b4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./newexcel.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7dc4f9b4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./newexcel.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-7dc4f9b4] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-7dc4f9b4] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n#newQianniu .content .qnbox .qnicon01[data-v-7dc4f9b4] {\n  position: absolute;\n  margin-top: -218px;\n  margin-left: -285px;\n  width: 98px;\n  height: 98px;\n}\n#newQianniu .content .qnbox .qnicon02-1[data-v-7dc4f9b4] {\n  width: 67px !important;\n  height: 21px !important;\n  top: 216px;\n  left: 473px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon04-1[data-v-7dc4f9b4] {\n  width: 176px !important;\n  height: 43px !important;\n  top: 486px;\n  left: 272px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon05-1[data-v-7dc4f9b4] {\n  width: 123px !important;\n  height: 32px !important;\n  top: 491px;\n  left: 286px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon06-1[data-v-7dc4f9b4] {\n  width: 120px !important;\n  height: 92px !important;\n  top: 389px;\n  left: 533px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon09-1[data-v-7dc4f9b4] {\n  width: 59px !important;\n  height: 20px !important;\n  top: 399px;\n  left: 372px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon11-1[data-v-7dc4f9b4] {\n  width: 23px !important;\n  height: 12px !important;\n  top: 519px;\n  left: 260px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon13-1[data-v-7dc4f9b4] {\n  width: 69px !important;\n  height: 15px !important;\n  top: 461px;\n  left: 367px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-1tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 352px;\n  left: 752px;\n  cursor: pointer;\n}\n#content-second .nr1_2input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 352px;\n  left: 752px;\n  cursor: pointer;\n}\n#content-second .exclenrbox[data-v-7dc4f9b4] {\n  width: 1060px;\n  height: 650px;\n  position: relative;\n}\n#content-second .qnbox .nr1-3tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 38px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1_4input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 370px;\n  left: 36px;\n  cursor: pointer;\n}\n.nr1_4[data-v-7dc4f9b4] .el-input__inner {\n  width: 77px !important;\n  height: 16px !important;\n}\n#content-second .qnbox .nr1_7input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 76px !important;\n  height: 16px !important;\n  top: 370px;\n  left: 35px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-6tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 81px !important;\n  height: 16px !important;\n  top: 329px;\n  left: 38px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-8tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 76px !important;\n  height: 16px !important;\n  top: 370px;\n  left: 35px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-11tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 67px !important;\n  height: 19px !important;\n  top: 309px;\n  left: 199px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-12tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 76px !important;\n  height: 371px !important;\n  top: 310px;\n  left: 194px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-13tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 262px !important;\n  height: 29px !important;\n  top: 472px;\n  left: 232px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-14tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 265px !important;\n  height: 26px !important;\n  top: 479px;\n  left: 260px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-15tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 29px !important;\n  height: 15px !important;\n  top: 386px;\n  left: 3px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-16tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 257px !important;\n  height: 530px !important;\n  top: 179px;\n  left: 203px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-17tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 250px !important;\n  height: 30px !important;\n  top: 335px;\n  left: 207px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-19tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 74px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 671px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1-1tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 74px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 433px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1-2tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 515px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1-3tb[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 593px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1_4input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 593px;\n  cursor: pointer;\n  text-align: right;\n  background: #CEDBC6;\n}\n#content-second .qnbox .pjtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 74px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 749px;\n  cursor: pointer;\n}\n#content-second .qnbox .pjtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 671px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1_1input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 328px;\n  left: 669px;\n  cursor: pointer;\n  text-align: left;\n}\n#content-second .qnbox .pj1_1input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 328px;\n  left: 747px;\n  cursor: pointer;\n  text-align: left;\n}\n#content-second .qnbox .zftb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 828px;\n  cursor: pointer;\n}\n#content-second .qnbox .zftb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 356px;\n  cursor: pointer;\n}\n#content-second .qnbox .zf1_1input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 328px;\n  left: 827px;\n  cursor: pointer;\n  text-align: left;\n}\n#content-second .qnbox .xgtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 70px !important;\n  height: 18px !important;\n  top: 707px;\n  left: 129px;\n  cursor: pointer;\n}\n#content-second .qnbox .xg1_1input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 70px !important;\n  height: 20px !important;\n  top: 704px;\n  left: 129px;\n  cursor: pointer;\n  text-align: center;\n}\n#content-second .qnbox .xjtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 28px !important;\n  height: 18px !important;\n  top: 706px;\n  left: 214px;\n  cursor: pointer;\n  text-align: center;\n}\n#content-second .qnbox .xjtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 20px !important;\n  height: 22px !important;\n  top: 705px;\n  left: 210px;\n  cursor: pointer;\n  text-align: center;\n}\n#content-second .qnbox .zbtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 460px;\n  left: 444px;\n  cursor: pointer;\n}\n#content-second .qnbox .zbtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 112px;\n  cursor: pointer;\n}\n#content-second .qnbox .zbtb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 328px;\n  left: 37px;\n  cursor: pointer;\n}\n#content-second .qnbox .zb1_1input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 69px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 188px;\n  cursor: pointer;\n  text-align: left;\n}\n#content-second .qnbox .xgtb2-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 69px !important;\n  height: 22px !important;\n  top: 703px;\n  left: 214px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-second .qnbox .xg2_1input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 69px !important;\n  height: 22px !important;\n  top: 704px;\n  left: 214px;\n  cursor: pointer;\n  text-align: center;\n}\n#content-third .qnbox .zttb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 11px !important;\n  height: 24px !important;\n  top: 154px;\n  left: 296px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-third .qnbox .zttb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 278px !important;\n  height: 27px !important;\n  top: 259px;\n  left: 187px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-third .qnbox .zttb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 266px !important;\n  height: 20px !important;\n  top: 264px;\n  left: 187px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-third .qnbox .jztb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 22px !important;\n  height: 20px !important;\n  top: 186px;\n  left: 478px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-third .qnbox .jztb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 22px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 477px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .kxtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 30px !important;\n  height: 21px !important;\n  top: 184px;\n  left: 262px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .kxtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 31px !important;\n  height: 22px !important;\n  top: 181px;\n  left: 260px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .kxtb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 188px !important;\n  height: 24px !important;\n  top: 242px;\n  left: 261px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .kxtb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 188px !important;\n  height: 26px !important;\n  top: 240px;\n  left: 262px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .tatb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 72px !important;\n  height: 18px !important;\n  top: 269px;\n  left: 38px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .tatb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 2px !important;\n  height: 389px !important;\n  top: 263px;\n  left: 113px;\n  cursor: move;\n  text-align: right;\n  z-index: 9;\n}\n#content-third .qnbox .dbclick[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 60px !important;\n  height: 40px !important;\n  top: 255px;\n  left: 85px;\n  cursor: move;\n  text-align: center;\n}\n#content-third .qnbox .jchbtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 24px !important;\n  height: 21px !important;\n  top: 156px;\n  left: 389px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 23px !important;\n  height: 23px !important;\n  top: 155px;\n  left: 387px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 20px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 185px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-5[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 20px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 184px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-6[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 64px !important;\n  height: 47px !important;\n  top: 159px;\n  left: 592px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-7[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 70px !important;\n  height: 47px !important;\n  top: 158px;\n  left: 588px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-8[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 30px !important;\n  height: 28px !important;\n  top: 183px;\n  left: 333px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-9[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 36px !important;\n  height: 24px !important;\n  top: 183px;\n  left: 330px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-10[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 14px !important;\n  height: 15px !important;\n  top: 287px;\n  left: 489px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-11[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 12px !important;\n  height: 9px !important;\n  top: 292px;\n  left: 490px;\n  cursor: pointer;\n}\n#content-third .qnbox .yshhtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 20px !important;\n  height: 23px !important;\n  top: 184px;\n  left: 369px;\n  cursor: pointer;\n}\n#content-third .qnbox .yshhtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 20px !important;\n  height: 23px !important;\n  top: 184px;\n  left: 369px;\n  cursor: pointer;\n}\n#content-third .qnbox .yshhtb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 56px !important;\n  height: 50px !important;\n  top: 155px;\n  left: 662px;\n  cursor: pointer;\n}\n#content-third .qnbox .yshhtb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 56px !important;\n  height: 50px !important;\n  top: 156px;\n  left: 661px;\n  cursor: pointer;\n}\n#content-third .qnbox .djtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 63px !important;\n  height: 49px !important;\n  top: 156px;\n  left: 839px;\n  cursor: pointer;\n}\n#content-third .qnbox .djtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 63px !important;\n  height: 49px !important;\n  top: 156px;\n  left: 839px;\n  cursor: pointer;\n}\n#content-third .qnbox .djtb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 146px !important;\n  height: 24px !important;\n  top: 216px;\n  left: 839px;\n  cursor: pointer;\n}\n#content-third .qnbox .djtb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 146px !important;\n  height: 24px !important;\n  top: 216px;\n  left: 839px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 12px !important;\n  height: 19px !important;\n  top: 158px;\n  left: 863px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 12px !important;\n  height: 19px !important;\n  top: 158px;\n  left: 863px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 210px !important;\n  height: 25px !important;\n  top: 730px;\n  left: 738px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 202px !important;\n  height: 19px !important;\n  top: 727px;\n  left: 738px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-5[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 40px !important;\n  height: 29px !important;\n  top: 246px;\n  left: 323px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-6[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 67px !important;\n  height: 32pxpx !important;\n  top: 277px;\n  left: 522px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-7[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 12px !important;\n  height: 7px !important;\n  top: 293px;\n  left: 570px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-8[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 27px !important;\n  top: 644px;\n  left: 605px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-9[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 71px !important;\n  height: 28px !important;\n  top: 645px;\n  left: 605px;\n  cursor: pointer;\n}\n#content-third .qnbox .zbbltb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 12px !important;\n  height: 19px !important;\n  top: 158px;\n  left: 863px;\n  cursor: pointer;\n}\n#content-third .qnbox .zbbltb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 12px !important;\n  height: 19px !important;\n  top: 158px;\n  left: 863px;\n  cursor: pointer;\n}\n#content-third .qnbox .zbbltb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 210px !important;\n  height: 51px !important;\n  top: 537px;\n  left: 735px;\n  cursor: pointer;\n}\n#content-third .qnbox .zbbltb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 203px !important;\n  height: 42px !important;\n  top: 537px;\n  left: 735px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 133px !important;\n  height: 30px !important;\n  top: 302px;\n  left: 108px;\n  cursor: pointer;\n}\n#content-four .qnbox .bc1_1input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 67px !important;\n  height: 35px !important;\n  top: 382px;\n  left: 869px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 137px !important;\n  height: 33px !important;\n  top: 302px;\n  left: 111px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 157px !important;\n  height: 45px !important;\n  top: 297px;\n  left: 790px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 247px !important;\n  height: 57px !important;\n  top: 291px;\n  left: 786px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-5[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 93px !important;\n  height: 22px !important;\n  top: 627px;\n  left: 377px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-6[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 97px !important;\n  height: 24px !important;\n  top: 627px;\n  left: 376px;\n  cursor: pointer;\n}\n#content-four .qnbox .bc_2input[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 550px !important;\n  height: 22px !important;\n  top: 627px;\n  left: 376px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-7[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 88px !important;\n  height: 28px !important;\n  top: 691px;\n  left: 850px;\n  cursor: pointer;\n}\n#content-four .qnbox .lc1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 245px !important;\n  height: 339px !important;\n  top: 97px;\n  left: 394px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 235px !important;\n  height: 30px !important;\n  top: 126px;\n  left: 397px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 235px !important;\n  height: 24px !important;\n  top: 126px;\n  left: 397px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 113px !important;\n  height: 33px !important;\n  top: 228px;\n  left: 116px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 113px !important;\n  height: 33px !important;\n  top: 228px;\n  left: 116px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-5[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 86px !important;\n  height: 25px !important;\n  top: 623px;\n  left: 852px;\n  cursor: pointer;\n}\n#content-five .qnbox .fstb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 21px !important;\n  height: 20px !important;\n  top: 86px;\n  left: 450px;\n  cursor: pointer;\n}\n#content-five .qnbox .fstb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 69px !important;\n  height: 90px !important;\n  top: 266px;\n  left: 63px;\n  cursor: pointer;\n}\n#content-five .qnbox .fstb1-0[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 15px !important;\n  height: 14px !important;\n  top: 91px;\n  left: 452px;\n  cursor: pointer;\n}\n#content-five .qnbox .fstb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 70px !important;\n  height: 26px !important;\n  top: 668px;\n  left: 796px;\n  cursor: pointer;\n}\n#content-six .qnbox .zttb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 11px !important;\n  height: 24px !important;\n  top: 154px;\n  left: 278px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 12px !important;\n  height: 21px !important;\n  top: 156px;\n  left: 280px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 276px !important;\n  height: 28px !important;\n  top: 262px;\n  left: 175px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 262px !important;\n  height: 20px !important;\n  top: 263px;\n  left: 179px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-5[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 11px !important;\n  height: 24px !important;\n  top: 154px;\n  left: 362px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdzttb1-6[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 12px !important;\n  height: 22px !important;\n  top: 156px;\n  left: 363px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-7[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 47px !important;\n  height: 23px !important;\n  top: 414px;\n  left: 295px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdzttb1-8[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 63px !important;\n  height: 22px !important;\n  top: 419px;\n  left: 297px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 37px !important;\n  height: 20px !important;\n  top: 186px;\n  left: 642px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 33px !important;\n  height: 19px !important;\n  top: 185px;\n  left: 648px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 156px !important;\n  height: 30px !important;\n  top: 235px;\n  left: 649px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 156px !important;\n  height: 30px !important;\n  top: 235px;\n  left: 649px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 152px !important;\n  height: 24px !important;\n  top: 240px;\n  left: 652px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 217.7px !important;\n  height: 457.1px !important;\n  top: 240px;\n  left: 652px;\n}\n#content-six .qnbox .wdsjtb1-1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 213.7px !important;\n  height: 25px !important;\n  top: 524px;\n  left: 652px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 327.6px !important;\n  height: 417.2px !important;\n  top: 309px;\n  left: 394px;\n}\n#content-six .qnbox .wdsjtb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 65px !important;\n  height: 17px !important;\n  top: 466px;\n  left: 561px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 59px !important;\n  height: 17px !important;\n  top: 502px;\n  left: 560px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-5[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 59px !important;\n  height: 15px !important;\n  top: 502px;\n  left: 560px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-6[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 63.6px !important;\n  height: 21px !important;\n  top: 696px;\n  left: 576px;\n  cursor: pointer;\n}\n#content-six .qnbox .jchbtb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 20px !important;\n  height: 22px !important;\n  top: 185px;\n  left: 174px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .jchbtb1-5[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 21px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 174px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .jztb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 22px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 532px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-six .qnbox .jztb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 23px !important;\n  height: 25px !important;\n  top: 182px;\n  left: 532px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdystb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 30px !important;\n  height: 21px !important;\n  top: 184px;\n  left: 423px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdystb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 38px !important;\n  height: 29px !important;\n  top: 181px;\n  left: 418px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdystb1-3[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 17px !important;\n  height: 16px !important;\n  top: 397px;\n  left: 443px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdystb1-4[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 11px !important;\n  height: 9px !important;\n  top: 402px;\n  left: 447px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdtxtb1-1[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 29px !important;\n  height: 21px !important;\n  top: 184px;\n  left: 387px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdtxtb1-2[data-v-7dc4f9b4] {\n  position: absolute;\n  width: 29px !important;\n  height: 20px !important;\n  top: 184px;\n  left: 387px;\n  cursor: pointer;\n  text-align: right;\n}\n", ""]);

// exports


/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newQianniu" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "zero" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("通关必看")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-zero" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "zero",
                      src:
                        "http://res.study.itaojin.cn/2023-02/2589f33edc9a487fb974cd4968040bb8.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-zero" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-first")
                          }
                        }
                      },
                      [_vm._v("继续下一步学习")]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("1、Excel界面介绍")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2023-02/5f691afc34024d2da811ff4f6c245131.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(662)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: __webpack_require__(663)
                        },
                        on: { dblclick: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(664)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon02-1",
                        attrs: {
                          src: __webpack_require__(404)
                        },
                        on: { mousemove: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon3,
                          expression: "isShowQnIcon3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(665)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon02-1",
                        attrs: {
                          src: __webpack_require__(404)
                        },
                        on: { click: _vm.showLoginImg3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon4,
                          expression: "isShowQnIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(666)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon04-1",
                        attrs: {
                          src: __webpack_require__(667)
                        },
                        on: { mousemove: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon5,
                          expression: "isShowQnIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(668)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon05-1",
                        attrs: {
                          src: __webpack_require__(669)
                        },
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon6,
                          expression: "isShowQnIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(670)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon06-1",
                        attrs: {
                          src: __webpack_require__(405)
                        },
                        on: { mousemove: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon7,
                          expression: "isShowQnIcon7"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(671)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon06-1",
                        attrs: {
                          src: __webpack_require__(405)
                        },
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon8,
                          expression: "isShowQnIcon8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(406)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon9,
                          expression: "isShowQnIcon9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(406)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon09-1",
                        attrs: {
                          src: __webpack_require__(672)
                        },
                        on: { click: _vm.showLoginImg8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon10,
                          expression: "isShowQnIcon10"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(407)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon11,
                          expression: "isShowQnIcon11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(407)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon11-1",
                        attrs: {
                          src: __webpack_require__(673)
                        },
                        on: { click: _vm.showLoginImg9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon12,
                          expression: "isShowQnIcon12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(408)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon13,
                          expression: "isShowQnIcon13"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(408)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon13-1",
                        attrs: {
                          src: __webpack_require__(94)
                        },
                        on: { click: _vm.showLoginImg10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon14,
                          expression: "isShowQnIcon14"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(674)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowQnIcon ? _c("p", [_vm._v("请打开WPS")]) : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon2 ||
                  _vm.isShowQnIcon3 ||
                  _vm.isShowQnIcon4 ||
                  _vm.isShowQnIcon5 ||
                  _vm.isShowQnIcon6 ||
                  _vm.isShowQnIcon7 ||
                  _vm.isShowQnIcon8
                    ? _c("p", [_vm._v("新建一个表格")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon9 || _vm.isShowQnIcon10
                    ? _c("p", [
                        _vm._v("选中"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("B列")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon11 || _vm.isShowQnIcon12
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第6行")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon13 || _vm.isShowQnIcon14
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("B3单元格")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowLoginIndex
                    ? _c("p", [_vm._v("请进入千牛接待中心")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("2、Excel内容编辑")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2023-02/bd934f84a7f94ff08ccb293a3bd739c7.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_1,
                            expression: "isShownr1_1"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(675)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-1tb",
                          attrs: {
                            src: __webpack_require__(66)
                          },
                          on: { click: _vm.showLoginnr1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_2,
                            expression: "isShownr1_2"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(676)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nr_input,
                              expression: "nr_input"
                            }
                          ],
                          ref: "strname",
                          staticClass: "nr1_2input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.nr_input },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.listenOne.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nr_input = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_3,
                            expression: "isShownr1_3"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(677)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-3tb",
                          attrs: {
                            src: __webpack_require__(66)
                          },
                          on: { click: _vm.showLoginnr1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_4,
                            expression: "isShownr1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(409)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nr_input2,
                              expression: "nr_input2"
                            }
                          ],
                          ref: "strname2",
                          staticClass: "nr1_4input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.nr_input2 },
                          on: {
                            keyup: function($event) {
                              if (!$event.ctrlKey) {
                                return null
                              }
                              return _vm.listenTwo.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nr_input2 = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_5,
                            expression: "isShownr1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(409)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nr_input2,
                              expression: "nr_input2"
                            }
                          ],
                          staticClass: "nr1_4input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.nr_input2 },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.listenTwo_1.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nr_input2 = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_6,
                            expression: "isShownr1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(678)
                          }
                        }),
                        _vm._v(" "),
                        _vm.isShownr1_6_1
                          ? _c("img", {
                              staticClass: "nr1-6tb",
                              attrs: {
                                src: __webpack_require__(679)
                              },
                              on: { click: _vm.showLoginnr1_6 }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_7,
                            expression: "isShownr1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(680)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_8,
                            expression: "isShownr1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(681)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_9,
                            expression: "isShownr1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(682)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_10,
                            expression: "isShownr1_10"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(683)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_11,
                            expression: "isShownr1_11"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(684)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-11tb",
                          attrs: {
                            src: __webpack_require__(685)
                          },
                          on: { click: _vm.showLoginnr1_11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_12,
                            expression: "isShownr1_12"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(686)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-12tb",
                          attrs: {
                            src: __webpack_require__(687)
                          },
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.rightClick($event)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_13,
                            expression: "isShownr1_13"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(688)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-13tb",
                          attrs: {
                            src: __webpack_require__(689)
                          },
                          on: { mousemove: _vm.showLoginnr1_13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_14,
                            expression: "isShownr1_14"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(690)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-14tb",
                          attrs: {
                            src: __webpack_require__(691)
                          },
                          on: { click: _vm.showLoginnr1_14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_15,
                            expression: "isShownr1_15"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(692)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_16,
                            expression: "isShownr1_16"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(693)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-15tb",
                          attrs: {
                            src: __webpack_require__(694)
                          },
                          on: { click: _vm.showLoginnr1_15 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_17,
                            expression: "isShownr1_17"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(695)
                          },
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.showLoginnr1_16($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.isShownr1_17_1
                          ? _c("img", {
                              staticClass: "nr1-16tb",
                              attrs: {
                                src: __webpack_require__(696)
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShownr1_17_1
                          ? _c("img", {
                              staticClass: "nr1-17tb",
                              attrs: {
                                src: __webpack_require__(697)
                              },
                              on: { mousemove: _vm.showLoginnr1_17 }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShownr1_17_2
                          ? _c("img", {
                              staticClass: "nr1-16tb",
                              attrs: {
                                src: __webpack_require__(698)
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShownr1_17_2
                          ? _c("img", {
                              staticClass: "nr1-17tb",
                              attrs: {
                                src: __webpack_require__(699)
                              },
                              on: { click: _vm.showLoginnr1_17_1 }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_18,
                            expression: "isShownr1_18"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(700)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_19,
                            expression: "isShownr1_19"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(701)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-19tb",
                          attrs: {
                            src: __webpack_require__(66)
                          },
                          on: { click: _vm.showLoginnr1_19 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_1,
                            expression: "isShowqh1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(702)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.qh1_input,
                              expression: "qh1_input"
                            }
                          ],
                          ref: "strname_1qh",
                          staticClass: "qh1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.qh1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.qh1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "qh1-1tb",
                          attrs: {
                            src: __webpack_require__(703)
                          },
                          on: { click: _vm.showLoginnr1_20 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_2,
                            expression: "isShowqh1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(704)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.qh1_input1,
                              expression: "qh1_input1"
                            }
                          ],
                          ref: "strname_2qh",
                          staticClass: "qh1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.qh1_input1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.qh1_input1 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "qh1-2tb",
                          attrs: {
                            src: __webpack_require__(705)
                          },
                          on: { click: _vm.showLoginqh1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_3,
                            expression: "isShowqh1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(706)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.qh1_input,
                              expression: "qh1_input"
                            }
                          ],
                          ref: "strname_1qh",
                          staticClass: "qh1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.qh1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.qh1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "qh1-3tb",
                          attrs: {
                            src: __webpack_require__(707)
                          },
                          on: { click: _vm.showLoginqh1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_4,
                            expression: "isShowqh1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(708)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_5,
                            expression: "isShowqh1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(709)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowpj1_1,
                            expression: "isShowpj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(710)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "pjtb1-1",
                          attrs: {
                            src: __webpack_require__(66)
                          },
                          on: { click: _vm.Loginpj1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowpj1_2,
                            expression: "isShowpj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(711)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pj1_input,
                              expression: "pj1_input"
                            }
                          ],
                          ref: "strname_pj1",
                          staticClass: "pj1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.pj1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pj1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "pjtb1-2",
                          attrs: {
                            src: __webpack_require__(410)
                          },
                          on: { click: _vm.Loginpj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowpj1_3,
                            expression: "isShowpj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(712)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pj1_input,
                              expression: "pj1_input"
                            }
                          ],
                          ref: "strname_pj1",
                          staticClass: "pj1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.pj1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pj1_input = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowpj1_4,
                            expression: "isShowpj1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(713)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_1,
                            expression: "isShowzf1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(714)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zftb1-1",
                          attrs: {
                            src: __webpack_require__(94)
                          },
                          on: { click: _vm.Loginzf1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_2,
                            expression: "isShowzf1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(715)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zf1_input,
                              expression: "zf1_input"
                            }
                          ],
                          ref: "strname_zf1",
                          staticClass: "zf1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.zf1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zf1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "pjtb1-2",
                          attrs: {
                            src: __webpack_require__(410)
                          },
                          on: { click: _vm.Loginzf1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_3,
                            expression: "isShowzf1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(716)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zf1_input,
                              expression: "zf1_input"
                            }
                          ],
                          ref: "strname_zf1",
                          staticClass: "zf1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.zf1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zf1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zftb1-2",
                          attrs: {
                            src: __webpack_require__(717)
                          },
                          on: { click: _vm.Loginzf1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_4,
                            expression: "isShowzf1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(718)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_5,
                            expression: "isShowzf1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(719)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg1_1,
                            expression: "isShowxg1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(720)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xgtb1-1",
                          attrs: {
                            src: __webpack_require__(721)
                          },
                          on: { click: _vm.Loginxg1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg1_2,
                            expression: "isShowxg1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(722)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.xg_input1,
                              expression: "xg_input1"
                            }
                          ],
                          ref: "strname_xg1",
                          staticClass: "xg1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.xg_input1 },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showLoginxg1_1.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.xg_input1 = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg1_3,
                            expression: "isShowxg1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(723)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxj1_1,
                            expression: "isShowxj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(724)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xjtb1-1",
                          attrs: {
                            src: __webpack_require__(725)
                          },
                          on: { mousemove: _vm.Loginxj1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxj1_2,
                            expression: "isShowxj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(726)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xjtb1-2",
                          attrs: {
                            src: __webpack_require__(727)
                          },
                          on: { click: _vm.Loginxj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxj1_3,
                            expression: "isShowxj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(728)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_1,
                            expression: "isShowzb1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(729)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "qnicon02 zbtb1-1",
                          attrs: {
                            src: __webpack_require__(94)
                          },
                          on: { click: _vm.Loginzb1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_2,
                            expression: "isShowzb1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(730)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zb_input1,
                              expression: "zb_input1"
                            }
                          ],
                          ref: "strname_zb1",
                          staticClass: "zb1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.zb_input1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zb_input1 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbtb1-2",
                          attrs: {
                            src: __webpack_require__(731)
                          },
                          on: { click: _vm.Loginzb1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_3,
                            expression: "isShowzb1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(732)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zb_input1,
                              expression: "zb_input1"
                            }
                          ],
                          ref: "strname_zb1",
                          staticClass: "zb1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.zb_input1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zb_input1 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbtb1-3",
                          attrs: {
                            src: __webpack_require__(733)
                          },
                          on: { click: _vm.Loginzb1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_4,
                            expression: "isShowzb1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(734)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_5,
                            expression: "isShowzb1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(735)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg2_1,
                            expression: "isShowxg2_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(736)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xgtb2-1",
                          attrs: {
                            src: __webpack_require__(737)
                          },
                          on: { click: _vm.Loginxg2_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg2_2,
                            expression: "isShowxg2_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(738)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.xg_input2,
                              expression: "xg_input2"
                            }
                          ],
                          ref: "strname_xg2",
                          staticClass: "xg2_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.xg_input2 },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showLoginxg2_1.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.xg_input2 = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg2_3,
                            expression: "isShowxg2_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(739)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  (_vm.isShownr1_1 && _vm.isShownr1_3_1 == false) ||
                  (_vm.isShownr1_2 && _vm.isShownr1_3_1 == false) ||
                  (_vm.isShownr1_3 && _vm.isShownr1_3_1 == false)
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("J2")]
                        ),
                        _vm._v("单元格输入"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("总分较8月上升（下降）")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定\n\t\t\t\t\t\t")
                      ])
                    : _vm._e(),
                  (_vm.isShownr1_3 && _vm.isShownr1_3_1) ||
                  _vm.isShownr1_4 ||
                  _vm.isShownr1_5 ||
                  (_vm.isShownr1_6 && _vm.isShownr1_6_1 == false)
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A3")]
                        ),
                        _vm._v("单元格先使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("的方式录入当前日期，再将日期修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2022/9/29")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.isShownr1_6 && _vm.isShownr1_6_1) ||
                  _vm.isShownr1_7 ||
                  _vm.isShownr1_8 ||
                  _vm.isShownr1_9 ||
                  _vm.isShownr1_9
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("使用复制快捷键")]
                        ),
                        _vm._v("复制"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A3")]
                        ),
                        _vm._v("单元格日期，"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("使用粘贴快捷键")]
                        ),
                        _vm._v("粘贴日期")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_11 ||
                  _vm.isShownr1_12 ||
                  _vm.isShownr1_13 ||
                  _vm.isShownr1_14 ||
                  _vm.isShownr1_15
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("姓名列右侧")]
                        ),
                        _vm._v("插入一列")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_16 || _vm.isShownr1_17 || _vm.isShownr1_18
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第6行上方")]
                        ),
                        _vm._v("插入一行")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_19 ||
                  _vm.isShowqh1_1 ||
                  _vm.isShowqh1_2 ||
                  _vm.isShowqh1_3 ||
                  _vm.isShowqh1_4 ||
                  _vm.isShowqh1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("I3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相加")]
                        ),
                        _vm._v("的方式计算9月总分")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowpj1_1 ||
                  _vm.isShowpj1_2 ||
                  _vm.isShowpj1_3 ||
                  _vm.isShowpj1_4
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("J3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相除")]
                        ),
                        _vm._v("的方式计算平均分")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzf1_1 ||
                  _vm.isShowzf1_2 ||
                  _vm.isShowzf1_3 ||
                  _vm.isShowzf1_4 ||
                  _vm.isShowzf1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("K3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相减")]
                        ),
                        _vm._v("的方式计算总分较8月上升（下降）")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxg1_1 || _vm.isShowxg1_2 || _vm.isShowxg1_3
                    ? _c("p", [
                        _vm._v("将工作表"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Sheet1")]
                        ),
                        _vm._v("名称修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("成绩汇总")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxj1_1 || _vm.isShowxj1_2 || _vm.isShowxj1_3
                    ? _c("p", [
                        _vm._v("新建一个"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("工作表")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzb1_1 ||
                  _vm.isShowzb1_2 ||
                  _vm.isShowzb1_3 ||
                  _vm.isShowzb1_4 ||
                  _vm.isShowzb1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("C3")]
                        ),
                        _vm._v("单元格中计算290分及以上的人数"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("在总人数中的占比")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxg2_1 || _vm.isShowxg2_2 || _vm.isShowxg2_3
                    ? _c("p", [
                        _vm._v("将工作表"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Sheet2")]
                        ),
                        _vm._v("名称修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("数据统计")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySecond }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("3、Excel内容布局")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://res.study.itaojin.cn/2023-02/3f087b31498b48479e7249cfa12ef8dd.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_1,
                            expression: "isShowzt1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(740)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-1",
                          attrs: {
                            src: __webpack_require__(67)
                          },
                          on: { mousemove: _vm.Loginzt1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_2,
                            expression: "isShowzt1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(741)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-1",
                          attrs: {
                            src: __webpack_require__(67)
                          },
                          on: { click: _vm.Loginzt1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_3,
                            expression: "isShowzt1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(742)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-2",
                          attrs: {
                            src: __webpack_require__(743)
                          },
                          on: { mousemove: _vm.Loginzt1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_4,
                            expression: "isShowzt1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(744)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-3",
                          attrs: {
                            src: __webpack_require__(745)
                          },
                          on: { click: _vm.Loginzt1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_5,
                            expression: "isShowzt1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(411)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjz1_1,
                            expression: "isShowjz1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(411)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jztb1-1",
                          attrs: {
                            src: __webpack_require__(412)
                          },
                          on: { mousemove: _vm.Loginjz1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjz1_2,
                            expression: "isShowjz1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(746)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jztb1-2",
                          attrs: {
                            src: __webpack_require__(413)
                          },
                          on: { click: _vm.Loginjz1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjz1_3,
                            expression: "isShowjz1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(414)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_1,
                            expression: "isShowkx1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(414)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kxtb1-1",
                          attrs: {
                            src: __webpack_require__(747)
                          },
                          on: { mousemove: _vm.Loginkx1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_2,
                            expression: "isShowkx1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(748)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kxtb1-2",
                          attrs: {
                            src: __webpack_require__(749)
                          },
                          on: { click: _vm.Loginkx1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_3,
                            expression: "isShowkx1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(750)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kxtb1-3",
                          attrs: {
                            src: __webpack_require__(751)
                          },
                          on: { mousemove: _vm.Loginkx1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_4,
                            expression: "isShowkx1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(752)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kxtb1-4",
                          attrs: {
                            src: __webpack_require__(753)
                          },
                          on: { click: _vm.Loginkx1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_5,
                            expression: "isShowkx1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(754)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowta1_2,
                            expression: "isShowta1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(755)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "tatb1-2",
                          attrs: {
                            src: __webpack_require__(756)
                          },
                          on: { dblclick: _vm.Loginta1_2 }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "dbclick",
                          attrs: {
                            src: __webpack_require__(1665),
                            alt: "",
                            srcset: ""
                          },
                          on: { dblclick: _vm.Loginta1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowta1_3,
                            expression: "isShowta1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(757)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_1,
                            expression: "isShowjchb1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(758)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-1",
                          attrs: {
                            src: __webpack_require__(759)
                          },
                          on: { mousemove: _vm.Loginjchb1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_2,
                            expression: "isShowjchb1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(760)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-2",
                          attrs: {
                            src: __webpack_require__(415)
                          },
                          on: { click: _vm.Loginjchb1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_3,
                            expression: "isShowjchb1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(761)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-2",
                          attrs: {
                            src: __webpack_require__(415)
                          },
                          on: { click: _vm.Loginjchb1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_4,
                            expression: "isShowjchb1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(762)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-4",
                          attrs: {
                            src: __webpack_require__(416)
                          },
                          on: { mousemove: _vm.Loginjchb1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_5,
                            expression: "isShowjchb1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(763)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-5",
                          attrs: {
                            src: __webpack_require__(417)
                          },
                          on: { click: _vm.Loginjchb1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_6,
                            expression: "isShowjchb1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(764)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-6",
                          attrs: {
                            src: __webpack_require__(765)
                          },
                          on: { mousemove: _vm.Loginjchb1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_7,
                            expression: "isShowjchb1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(766)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-7",
                          attrs: {
                            src: __webpack_require__(767)
                          },
                          on: { click: _vm.Loginjchb1_7 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_8,
                            expression: "isShowjchb1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(768)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-8",
                          attrs: {
                            src: __webpack_require__(769)
                          },
                          on: { mousemove: _vm.Loginjchb1_8 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_9,
                            expression: "isShowjchb1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(770)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-9",
                          attrs: {
                            src: __webpack_require__(771)
                          },
                          on: { click: _vm.Loginjchb1_9 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_10,
                            expression: "isShowjchb1_10"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(772)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-10",
                          attrs: {
                            src: __webpack_require__(418)
                          },
                          on: { mousemove: _vm.Loginjchb1_10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_11,
                            expression: "isShowjchb1_11"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(773)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-11",
                          attrs: {
                            src: __webpack_require__(418)
                          },
                          on: { click: _vm.Loginjchb1_11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_12,
                            expression: "isShowjchb1_12"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(774)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_1,
                            expression: "isShowyshh1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(775)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "yshhtb1-1",
                          attrs: {
                            src: __webpack_require__(776)
                          },
                          on: { mousemove: _vm.Loginyshh1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_2,
                            expression: "isShowyshh1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(777)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "yshhtb1-2",
                          attrs: {
                            src: __webpack_require__(778)
                          },
                          on: { click: _vm.Loginyshh1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_3,
                            expression: "isShowyshh1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(779)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "yshhtb1-3",
                          attrs: {
                            src: __webpack_require__(780)
                          },
                          on: { mousemove: _vm.Loginyshh1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_4,
                            expression: "isShowyshh1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(781)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "yshhtb1-4",
                          attrs: {
                            src: __webpack_require__(782)
                          },
                          on: { click: _vm.Loginyshh1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_5,
                            expression: "isShowyshh1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(783)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_1,
                            expression: "isShowdj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(784)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "djtb1-1",
                          attrs: {
                            src: __webpack_require__(785)
                          },
                          on: { mousemove: _vm.Logindj1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_2,
                            expression: "isShowdj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(786)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "djtb1-2",
                          attrs: {
                            src: __webpack_require__(787)
                          },
                          on: { click: _vm.Logindj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_3,
                            expression: "isShowdj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(788)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "djtb1-3",
                          attrs: {
                            src: __webpack_require__(789)
                          },
                          on: { mousemove: _vm.Logindj1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_4,
                            expression: "isShowdj1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(790)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "djtb1-4",
                          attrs: {
                            src: __webpack_require__(791)
                          },
                          on: { click: _vm.Logindj1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_5,
                            expression: "isShowdj1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(792)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_1,
                            expression: "isShowxs1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(793)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-1",
                          attrs: {
                            src: __webpack_require__(419)
                          },
                          on: { mousemove: _vm.Loginxs1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_2,
                            expression: "isShowxs1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(794)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-2",
                          attrs: {
                            src: __webpack_require__(420)
                          },
                          on: { click: _vm.Loginxs1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_3,
                            expression: "isShowxs1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(795)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-3",
                          attrs: {
                            src: __webpack_require__(796)
                          },
                          on: { mousemove: _vm.Loginxs1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_4,
                            expression: "isShowxs1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(797)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-4",
                          attrs: {
                            src: __webpack_require__(798)
                          },
                          on: { click: _vm.Loginxs1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_5,
                            expression: "isShowxs1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(799)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-5",
                          attrs: {
                            src: __webpack_require__(800)
                          },
                          on: { click: _vm.Loginxs1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_6,
                            expression: "isShowxs1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(801)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-6",
                          attrs: {
                            src: __webpack_require__(802)
                          },
                          on: { mousemove: _vm.Loginxs1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_7,
                            expression: "isShowxs1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(803)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-7",
                          attrs: {
                            src: __webpack_require__(804)
                          },
                          on: { click: _vm.Loginxs1_7 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_8,
                            expression: "isShowxs1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(805)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-8",
                          attrs: {
                            src: __webpack_require__(806)
                          },
                          on: { mousemove: _vm.Loginxs1_8 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_9,
                            expression: "isShowxs1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(807)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-9",
                          attrs: {
                            src: __webpack_require__(808)
                          },
                          on: { click: _vm.Loginxs1_9 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_10,
                            expression: "isShowxs1_10"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(809)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_1,
                            expression: "isShowzbbl1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(810)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbbltb1-1",
                          attrs: {
                            src: __webpack_require__(419)
                          },
                          on: { mousemove: _vm.Loginzbbl1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_2,
                            expression: "isShowzbbl1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(811)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbbltb1-2",
                          attrs: {
                            src: __webpack_require__(420)
                          },
                          on: { click: _vm.Loginzbbl1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_3,
                            expression: "isShowzbbl1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(812)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbbltb1-3",
                          attrs: {
                            src: __webpack_require__(813)
                          },
                          on: { mousemove: _vm.Loginzbbl1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_4,
                            expression: "isShowzbbl1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(814)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbbltb1-4",
                          attrs: {
                            src: __webpack_require__(815)
                          },
                          on: { click: _vm.Loginzbbl1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_5,
                            expression: "isShowzbbl1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(816)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowzt1_1 ||
                  _vm.isShowzt1_2 ||
                  _vm.isShowzt1_3 ||
                  _vm.isShowzt1_4 ||
                  _vm.isShowzt1_5
                    ? _c("p", [
                        _vm._v("请将字体设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("微软雅黑")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjz1_1 || _vm.isShowjz1_2 || _vm.isShowjz1_3
                    ? _c("p", [
                        _vm._v("将内容"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("水平居中")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowkx1_1 ||
                  _vm.isShowkx1_2 ||
                  _vm.isShowkx1_3 ||
                  _vm.isShowkx1_4 ||
                  _vm.isShowkx1_5
                    ? _c("p", [
                        _vm._v("将框线设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("所有框线")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowta1_2 || _vm.isShowta1_3
                    ? _c("p", [
                        _vm._v("补充知识:"),
                        _c("br"),
                        _vm._v("请采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("双击鼠标")]
                        ),
                        _vm._v("的方式调整"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A列")]
                        ),
                        _vm._v("宽度")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjchb1_1 ||
                  _vm.isShowjchb1_2 ||
                  _vm.isShowjchb1_3 ||
                  _vm.isShowjchb1_4 ||
                  _vm.isShowjchb1_5 ||
                  _vm.isShowjchb1_6 ||
                  _vm.isShowjchb1_7 ||
                  _vm.isShowjchb1_8 ||
                  _vm.isShowjchb1_9 ||
                  _vm.isShowjchb1_10 ||
                  _vm.isShowjchb1_11 ||
                  _vm.isShowjchb1_12
                    ? _c("p", [
                        _vm._v("1、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第1行")]
                        ),
                        _vm._v("字号大小"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("逐步加大到14号")]
                        ),
                        _c("br"),
                        _vm._v("2、"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("字体加粗")]
                        ),
                        _vm._v("；"),
                        _c("br"),
                        _vm._v("3、合并"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A1-K1")]
                        ),
                        _vm._v("单元格；"),
                        _c("br"),
                        _vm._v("4、将背景填充为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("浅蓝色")]
                        ),
                        _vm._v("（第二行倒数第二个颜色）")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowyshh1_1 || _vm.isShowyshh1_2
                    ? _c("p", [
                        _vm._v("1、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("I2-K2")]
                        ),
                        _vm._v("字体设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("红色")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowyshh1_3 || _vm.isShowyshh1_4 || _vm.isShowyshh1_5
                    ? _c("p", [
                        _vm._v("2、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("K2")]
                        ),
                        _vm._v("单元格内的内容"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("自动换行")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdj1_1 ||
                  _vm.isShowdj1_2 ||
                  _vm.isShowdj1_3 ||
                  _vm.isShowdj1_4 ||
                  _vm.isShowdj1_5
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("冻结")]
                        ),
                        _vm._v("第"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1")]
                        ),
                        _vm._v("行和第"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2")]
                        ),
                        _vm._v("行")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxs1_1 ||
                  _vm.isShowxs1_2 ||
                  _vm.isShowxs1_3 ||
                  _vm.isShowxs1_4 ||
                  _vm.isShowxs1_5 ||
                  _vm.isShowxs1_6 ||
                  _vm.isShowxs1_7 ||
                  _vm.isShowxs1_8 ||
                  _vm.isShowxs1_9 ||
                  _vm.isShowxs1_10
                    ? _c("p", [
                        _vm._v("将平均分设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1位小数")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzbbl1_1 ||
                  _vm.isShowzbbl1_2 ||
                  _vm.isShowzbbl1_3 ||
                  _vm.isShowzbbl1_4 ||
                  _vm.isShowzbbl1_5
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("占比")]
                        ),
                        _vm._v("用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("百分比")]
                        ),
                        _vm._v("表示，保留2位小数")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyThird }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt3
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt3(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt3 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("4、保存文件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://res.study.itaojin.cn/2023-02/1811f87020ab466db890f5b601f915be.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_1,
                            expression: "isShowbc1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(817)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_2,
                            expression: "isShowbc1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(818)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-1",
                          attrs: {
                            src: __webpack_require__(819)
                          },
                          on: { mousemove: _vm.Loginbc1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_3,
                            expression: "isShowbc1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(820)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-2",
                          attrs: {
                            src: __webpack_require__(421)
                          },
                          on: { click: _vm.Loginbc1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_4,
                            expression: "isShowbc1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(821)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-3",
                          attrs: {
                            src: __webpack_require__(822)
                          },
                          on: { mousemove: _vm.Loginbc1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_5,
                            expression: "isShowbc1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(823)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-4",
                          attrs: {
                            src: __webpack_require__(824)
                          },
                          on: { dblclick: _vm.Loginbc1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_6,
                            expression: "isShowbc1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(825)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-5",
                          attrs: {
                            src: __webpack_require__(826)
                          },
                          on: { click: _vm.Loginbc1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_7,
                            expression: "isShowbc1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(827)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-6",
                          attrs: {
                            src: __webpack_require__(828)
                          },
                          on: { click: _vm.Loginbc1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_8,
                            expression: "isShowbc1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4 inputlength"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(829)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.bc_input2,
                              expression: "bc_input2"
                            }
                          ],
                          ref: "strname_bc2",
                          staticClass: "bc_2input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.bc_input2 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.bc_input2 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-7",
                          attrs: {
                            src: __webpack_require__(422)
                          },
                          on: { click: _vm.Loginbc1_7 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_9,
                            expression: "isShowbc1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(37)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_1,
                            expression: "isShowlc1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(37)
                          },
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.Loginlc1_1($event)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_2,
                            expression: "isShowlc1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(37)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lc1-1",
                          attrs: {
                            src: __webpack_require__(830)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-1",
                          attrs: {
                            src: __webpack_require__(831)
                          },
                          on: { mousemove: _vm.Loginlc1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_3,
                            expression: "isShowlc1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(37)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lc1-1",
                          attrs: {
                            src: __webpack_require__(832)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-2",
                          attrs: {
                            src: __webpack_require__(833)
                          },
                          on: { click: _vm.Loginlc1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_4,
                            expression: "isShowlc1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "lc1-2",
                          attrs: {
                            src: __webpack_require__(834)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-3",
                          attrs: {
                            src: __webpack_require__(835)
                          },
                          on: { mousemove: _vm.Loginlc1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_5,
                            expression: "isShowlc1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "lc1-2",
                          attrs: {
                            src: __webpack_require__(836)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-4",
                          attrs: {
                            src: __webpack_require__(421)
                          },
                          on: { click: _vm.Loginlc1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_6,
                            expression: "isShowlc1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "lc1-2",
                          attrs: {
                            src: __webpack_require__(837)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-5",
                          attrs: {
                            src: __webpack_require__(422)
                          },
                          on: { click: _vm.Loginlc1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_7,
                            expression: "isShowlc1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "lc1-2",
                          attrs: {
                            src: __webpack_require__(37)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowbc1_1
                    ? _c("p", [
                        _vm._v("使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("打开文件保存路径，将表格保存到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        ),
                        _vm._v("的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("办公软件培训")]
                        ),
                        _vm._v("文件夹中，并将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("文件名称")]
                        ),
                        _vm._v("修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("月考成绩统计")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_2 || _vm.isShowbc1_3
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("我的桌面")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_4 || _vm.isShowbc1_5
                    ? _c("p", [
                        _vm._v("鼠标左键"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("双击办公软件培训")]
                        ),
                        _vm._v("，打开文件夹")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_6 ||
                  _vm.isShowbc1_7 ||
                  _vm.isShowbc1_8 ||
                  _vm.isShowbc1_9
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("文件名")]
                        ),
                        _vm._v("修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("月考成绩统计，并点击保存")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowlc1_1 ||
                  _vm.isShowlc1_2 ||
                  _vm.isShowlc1_3 ||
                  _vm.isShowlc1_4 ||
                  _vm.isShowlc1_5 ||
                  _vm.isShowlc1_6 ||
                  _vm.isShowlc1_7
                    ? _c("p", [
                        _vm._v("将文件另存到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFour }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt4
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt4(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt4 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("5、发送文件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://res.study.itaojin.cn/2023-02/78ceee7e08034c37a419140a8a5298a0.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_1,
                            expression: "isShowfs1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(37)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fstb1-0",
                          attrs: {
                            src: __webpack_require__(838)
                          },
                          on: { mousemove: _vm.Loginfs1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_2,
                            expression: "isShowfs1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(839)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fstb1-1",
                          attrs: {
                            src: __webpack_require__(840)
                          },
                          on: { click: _vm.Loginfs1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_3,
                            expression: "isShowfs1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(841)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fstb1-2",
                          attrs: {
                            src: __webpack_require__(842)
                          },
                          on: { click: _vm.Loginfs1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_4,
                            expression: "isShowfs1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(843)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_5,
                            expression: "isShowfs1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(844)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_6,
                            expression: "isShowfs1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(845)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fstb1-3",
                          attrs: {
                            src: __webpack_require__(846)
                          },
                          on: { click: _vm.Loginfs1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_7,
                            expression: "isShowfs1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(847)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowfs1_1 ||
                  _vm.isShowfs1_2 ||
                  _vm.isShowfs1_3 ||
                  _vm.isShowfs1_4 ||
                  _vm.isShowfs1_5 ||
                  _vm.isShowfs1_6 ||
                  _vm.isShowfs1_7
                    ? _c("p", [
                        _vm._v("1、关闭表格;"),
                        _c("br"),
                        _vm._v("2、使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("复制快捷键")]
                        ),
                        _vm._v("复制表格;"),
                        _c("br"),
                        _vm._v("3、使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("粘贴快捷键")]
                        ),
                        _vm._v("粘贴表格到QQ群，并发送")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFive }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt5
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt5(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt5 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、Word基础功能")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://res.study.itaojin.cn/2023-02/0671010263394b0993b576b5ff316603.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_1,
                            expression: "isShowwdzt1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(848)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_2,
                            expression: "isShowwdzt1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(849)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-1",
                          attrs: {
                            src: __webpack_require__(67)
                          },
                          on: { mousemove: _vm.Loginwdzt1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_3,
                            expression: "isShowwdzt1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(850)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-2",
                          attrs: {
                            src: __webpack_require__(423)
                          },
                          on: { click: _vm.Loginwdzt1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_4,
                            expression: "isShowwdzt1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(851)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-3",
                          attrs: {
                            src: __webpack_require__(852)
                          },
                          on: { mousemove: _vm.Loginwdzt1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_5,
                            expression: "isShowwdzt1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(853)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-4",
                          attrs: {
                            src: __webpack_require__(854)
                          },
                          on: { click: _vm.Loginwdzt1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_6,
                            expression: "isShowwdzt1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(855)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-5",
                          attrs: {
                            src: __webpack_require__(67)
                          },
                          on: { mousemove: _vm.Loginwdzt1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_7,
                            expression: "isShowwdzt1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(856)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-6",
                          attrs: {
                            src: __webpack_require__(423)
                          },
                          on: { click: _vm.Loginwdzt1_7 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_8,
                            expression: "isShowwdzt1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(857)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-7",
                          attrs: {
                            src: __webpack_require__(858)
                          },
                          on: { mousemove: _vm.Loginwdzt1_8 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_9,
                            expression: "isShowwdzt1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(859)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-8",
                          attrs: {
                            src: __webpack_require__(860)
                          },
                          on: { click: _vm.Loginwdzt1_9 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_10,
                            expression: "isShowwdzt1_10"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(424)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_1,
                            expression: "isShowwdhj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(424)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdhjtb1-1",
                          attrs: {
                            src: __webpack_require__(861)
                          },
                          on: { mousemove: _vm.Loginwdhj1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_2,
                            expression: "isShowwdhj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(862)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdhjtb1-2",
                          attrs: {
                            src: __webpack_require__(863)
                          },
                          on: { click: _vm.Loginwdhj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_3,
                            expression: "isShowwdhj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(864)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdhjtb1-3",
                          attrs: {
                            src: __webpack_require__(865)
                          },
                          on: { mousemove: _vm.Loginwdhj1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_4,
                            expression: "isShowwdhj1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(866)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdhjtb1-4",
                          attrs: {
                            src: __webpack_require__(867)
                          },
                          on: { click: _vm.Loginwdhj1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_5,
                            expression: "isShowwdhj1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(868)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_1,
                            expression: "isShowwdsj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(38)
                          },
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.rightClick_sj($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.isShowwdsj1_1_1
                          ? _c("img", {
                              staticClass: "wdsjtb1-1",
                              attrs: {
                                src: __webpack_require__(425)
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShowwdsj1_1_1
                          ? _c("img", {
                              staticClass: "wdsjtb1-1-1",
                              attrs: {
                                src: __webpack_require__(869)
                              },
                              on: { mousemove: _vm.Loginwdsj1_1 }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_2,
                            expression: "isShowwdsj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(38)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-1",
                          attrs: {
                            src: __webpack_require__(425)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-1-1",
                          attrs: {
                            src: __webpack_require__(870)
                          },
                          on: { click: _vm.Loginwdsj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_3,
                            expression: "isShowwdsj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(38)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-2",
                          attrs: {
                            src: __webpack_require__(871)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-3",
                          attrs: {
                            src: __webpack_require__(872)
                          },
                          on: { click: _vm.Loginwdsj1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_4,
                            expression: "isShowwdsj1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(38)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-2",
                          attrs: {
                            src: __webpack_require__(873)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-4",
                          attrs: {
                            src: __webpack_require__(874)
                          },
                          on: { mousemove: _vm.Loginwdsj1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_5,
                            expression: "isShowwdsj1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(38)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-2",
                          attrs: {
                            src: __webpack_require__(875)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-5",
                          attrs: {
                            src: __webpack_require__(876)
                          },
                          on: { click: _vm.Loginwdsj1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_6,
                            expression: "isShowwdsj1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(38)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-2",
                          attrs: {
                            src: __webpack_require__(877)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-6",
                          attrs: {
                            src: __webpack_require__(878)
                          },
                          on: { click: _vm.Loginwdsj1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_7,
                            expression: "isShowwdsj1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(879)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_1,
                            expression: "isShowwdjc1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(880)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-4",
                          attrs: {
                            src: __webpack_require__(416)
                          },
                          on: { mousemove: _vm.Loginwdjc1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_2,
                            expression: "isShowwdjc1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(881)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-5",
                          attrs: {
                            src: __webpack_require__(417)
                          },
                          on: { click: _vm.Loginwdjc1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_3,
                            expression: "isShowwdjc1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(882)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jztb1-1",
                          attrs: {
                            src: __webpack_require__(412)
                          },
                          on: { mousemove: _vm.Loginwdjc1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_4,
                            expression: "isShowwdjc1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(883)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jztb1-2",
                          attrs: {
                            src: __webpack_require__(413)
                          },
                          on: { click: _vm.Loginwdjc1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_5,
                            expression: "isShowwdjc1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(884)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_1,
                            expression: "isShowwdys1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(885)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdystb1-1",
                          attrs: {
                            src: __webpack_require__(886)
                          },
                          on: { mousemove: _vm.Loginwdys1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_2,
                            expression: "isShowwdys1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(887)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdystb1-2",
                          attrs: {
                            src: __webpack_require__(888)
                          },
                          on: { click: _vm.Loginwdys1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_3,
                            expression: "isShowwdys1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(889)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdystb1-3",
                          attrs: {
                            src: __webpack_require__(890)
                          },
                          on: { mousemove: _vm.Loginwdys1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_4,
                            expression: "isShowwdys1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(891)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdystb1-4",
                          attrs: {
                            src: __webpack_require__(892)
                          },
                          on: { click: _vm.Loginwdys1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_5,
                            expression: "isShowwdys1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(893)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdtx1_1,
                            expression: "isShowwdtx1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(894)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdtxtb1-1",
                          attrs: {
                            src: __webpack_require__(895)
                          },
                          on: { mousemove: _vm.Loginwdtx1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdtx1_2,
                            expression: "isShowwdtx1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(896)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdtxtb1-2",
                          attrs: {
                            src: __webpack_require__(897)
                          },
                          on: { click: _vm.Loginwdtx1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdtx1_3,
                            expression: "isShowwdtx1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(898)
                          },
                          on: { click: _vm.Loginwdtx1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdtx1_4,
                            expression: "isShowwdtx1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(899)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowwdzt1_1 ||
                  _vm.isShowwdzt1_2 ||
                  _vm.isShowwdzt1_3 ||
                  _vm.isShowwdzt1_4 ||
                  _vm.isShowwdzt1_5 ||
                  _vm.isShowwdzt1_6 ||
                  _vm.isShowwdzt1_7 ||
                  _vm.isShowwdzt1_8 ||
                  _vm.isShowwdzt1_9 ||
                  _vm.isShowwdzt1_10
                    ? _c("p", [
                        _vm._v("先采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("全选内容，再将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("字体")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("楷体，字号")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("小四")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdhj1_1 ||
                  _vm.isShowwdhj1_2 ||
                  _vm.isShowwdhj1_3 ||
                  _vm.isShowwdhj1_4 ||
                  _vm.isShowwdhj1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("行距")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1.5")]
                        ),
                        _vm._v("倍")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdsj1_1 ||
                  _vm.isShowwdsj1_2 ||
                  _vm.isShowwdsj1_3 ||
                  _vm.isShowwdsj1_4 ||
                  _vm.isShowwdsj1_5 ||
                  _vm.isShowwdsj1_6 ||
                  _vm.isShowwdsj1_7
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("首行缩进2字符")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdjc1_1 ||
                  _vm.isShowwdjc1_2 ||
                  _vm.isShowwdjc1_3 ||
                  _vm.isShowwdjc1_4 ||
                  _vm.isShowwdjc1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("标题加粗，并居中")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdys1_1 ||
                  _vm.isShowwdys1_2 ||
                  _vm.isShowwdys1_3 ||
                  _vm.isShowwdys1_4 ||
                  _vm.isShowwdys1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2015")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("红色")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdtx1_1 ||
                  _vm.isShowwdtx1_2 ||
                  _vm.isShowwdtx1_3 ||
                  _vm.isShowwdtx1_4
                    ? _c("p", [
                        _vm._v("用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("黄色突出显示")]
                        ),
                        _vm._v("最后自然段")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-six" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成办公软件的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《办公软件模拟实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: {
                            width: "230px",
                            "border-radius": "5px"
                          },
                          attrs: { href: "/excelstudy" }
                        },
                        [_vm._v("去完成《办公软件模拟实操》")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt6(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt6 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dc4f9b4", esExports)
  }
}

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkYwNEUwNENDN0NBOTExRUZBRTkyOUM1QTJFRjkxRUFDIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkYwNEUwNENEN0NBOTExRUZBRTkyOUM1QTJFRjkxRUFDIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjA0RTA0Q0E3Q0E5MTFFRkFFOTI5QzVBMkVGOTFFQUMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjA0RTA0Q0I3Q0E5MTFFRkFFOTI5QzVBMkVGOTFFQUMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6ggSPLAAAAEElEQVR42mL6//8/A0CAAQAJBgMA+A+HZAAAAABJRU5ErkJggg=="

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_excelstudy_vue__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_excelstudy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_excelstudy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_excelstudy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_excelstudy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38252441_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_excelstudy_vue__ = __webpack_require__(1669);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1667)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38252441"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_excelstudy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38252441_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_excelstudy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/excel/excelstudy.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38252441", Component.options)
  } else {
    hotAPI.reload("data-v-38252441", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("77f62dd6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38252441\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./excelstudy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38252441\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./excelstudy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-38252441] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-38252441] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n#newQianniuExam .content .qnbox .qnicon01[data-v-38252441] {\n  position: absolute;\n  margin-top: -218px;\n  margin-left: -285px;\n  width: 98px;\n  height: 98px;\n}\n#newQianniuExam .content .qnbox .qnicon02-1[data-v-38252441] {\n  width: 67px !important;\n  height: 21px !important;\n  top: 216px;\n  left: 473px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon04-1[data-v-38252441] {\n  width: 176px !important;\n  height: 43px !important;\n  top: 486px;\n  left: 272px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon05-1[data-v-38252441] {\n  width: 123px !important;\n  height: 32px !important;\n  top: 491px;\n  left: 286px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon06-1[data-v-38252441] {\n  width: 120px !important;\n  height: 92px !important;\n  top: 389px;\n  left: 533px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon09-1[data-v-38252441] {\n  width: 59px !important;\n  height: 20px !important;\n  top: 399px;\n  left: 372px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon11-1[data-v-38252441] {\n  width: 23px !important;\n  height: 12px !important;\n  top: 519px;\n  left: 260px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon13-1[data-v-38252441] {\n  width: 69px !important;\n  height: 15px !important;\n  top: 461px;\n  left: 367px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-1tb[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 352px;\n  left: 752px;\n  cursor: pointer;\n}\n#content-second .nr1_2input[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 352px;\n  left: 752px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-3tb[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 38px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1_4input[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 370px;\n  left: 36px;\n  cursor: pointer;\n}\n.nr1_4[data-v-38252441] .el-input__inner {\n  width: 77px !important;\n  height: 16px !important;\n}\n#content-second .qnbox .nr1_7input[data-v-38252441] {\n  position: absolute;\n  width: 76px !important;\n  height: 16px !important;\n  top: 370px;\n  left: 35px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-6tb[data-v-38252441] {\n  position: absolute;\n  width: 81px !important;\n  height: 16px !important;\n  top: 329px;\n  left: 38px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-8tb[data-v-38252441] {\n  position: absolute;\n  width: 76px !important;\n  height: 16px !important;\n  top: 370px;\n  left: 35px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-11tb[data-v-38252441] {\n  position: absolute;\n  width: 67px !important;\n  height: 19px !important;\n  top: 309px;\n  left: 199px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-12tb[data-v-38252441] {\n  position: absolute;\n  width: 76px !important;\n  height: 371px !important;\n  top: 310px;\n  left: 194px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-13tb[data-v-38252441] {\n  position: absolute;\n  width: 262px !important;\n  height: 29px !important;\n  top: 472px;\n  left: 232px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-14tb[data-v-38252441] {\n  position: absolute;\n  width: 265px !important;\n  height: 26px !important;\n  top: 479px;\n  left: 260px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-15tb[data-v-38252441] {\n  position: absolute;\n  width: 29px !important;\n  height: 15px !important;\n  top: 386px;\n  left: 3px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-16tb[data-v-38252441] {\n  position: absolute;\n  width: 257px !important;\n  height: 530px !important;\n  top: 179px;\n  left: 203px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-17tb[data-v-38252441] {\n  position: absolute;\n  width: 250px !important;\n  height: 30px !important;\n  top: 335px;\n  left: 207px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1-19tb[data-v-38252441] {\n  position: absolute;\n  width: 74px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 671px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1-1tb[data-v-38252441] {\n  position: absolute;\n  width: 74px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 433px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1-2tb[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 515px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1-3tb[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 593px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1_4input[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 593px;\n  cursor: pointer;\n  text-align: right;\n  background: #CEDBC6;\n}\n#content-second .qnbox .pjtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 74px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 749px;\n  cursor: pointer;\n}\n#content-second .qnbox .pjtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 671px;\n  cursor: pointer;\n}\n#content-second .qnbox .qh1_1input[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 328px;\n  left: 669px;\n  cursor: pointer;\n  text-align: left;\n}\n#content-second .qnbox .pj1_1input[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 328px;\n  left: 747px;\n  cursor: pointer;\n  text-align: left;\n}\n#content-second .qnbox .zftb1-1[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 828px;\n  cursor: pointer;\n}\n#content-second .qnbox .zftb1-2[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 356px;\n  cursor: pointer;\n}\n#content-second .qnbox .zf1_1input[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 328px;\n  left: 827px;\n  cursor: pointer;\n  text-align: left;\n}\n#content-second .qnbox .xgtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 70px !important;\n  height: 18px !important;\n  top: 707px;\n  left: 129px;\n  cursor: pointer;\n}\n#content-second .qnbox .xg1_1input[data-v-38252441] {\n  position: absolute;\n  width: 70px !important;\n  height: 20px !important;\n  top: 704px;\n  left: 129px;\n  cursor: pointer;\n  text-align: center;\n}\n#content-second .qnbox .xjtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 28px !important;\n  height: 18px !important;\n  top: 706px;\n  left: 214px;\n  cursor: pointer;\n  text-align: center;\n}\n#content-second .qnbox .xjtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 20px !important;\n  height: 22px !important;\n  top: 705px;\n  left: 210px;\n  cursor: pointer;\n  text-align: center;\n}\n#content-second .qnbox .zbtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 460px;\n  left: 444px;\n  cursor: pointer;\n}\n#content-second .qnbox .zbtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 327px;\n  left: 112px;\n  cursor: pointer;\n}\n#content-second .qnbox .zbtb1-3[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 17px !important;\n  top: 328px;\n  left: 37px;\n  cursor: pointer;\n}\n#content-second .qnbox .zb1_1input[data-v-38252441] {\n  position: absolute;\n  width: 69px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 188px;\n  cursor: pointer;\n  text-align: left;\n}\n#content-second .qnbox .xgtb2-1[data-v-38252441] {\n  position: absolute;\n  width: 69px !important;\n  height: 22px !important;\n  top: 703px;\n  left: 214px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-second .qnbox .xg2_1input[data-v-38252441] {\n  position: absolute;\n  width: 69px !important;\n  height: 22px !important;\n  top: 704px;\n  left: 214px;\n  cursor: pointer;\n  text-align: center;\n}\n#content-third .qnbox .zttb1-1[data-v-38252441] {\n  position: absolute;\n  width: 11px !important;\n  height: 24px !important;\n  top: 154px;\n  left: 296px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-third .qnbox .zttb1-2[data-v-38252441] {\n  position: absolute;\n  width: 278px !important;\n  height: 27px !important;\n  top: 259px;\n  left: 187px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-third .qnbox .zttb1-3[data-v-38252441] {\n  position: absolute;\n  width: 266px !important;\n  height: 20px !important;\n  top: 264px;\n  left: 187px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-third .qnbox .jztb1-1[data-v-38252441] {\n  position: absolute;\n  width: 22px !important;\n  height: 20px !important;\n  top: 186px;\n  left: 478px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-third .qnbox .jztb1-2[data-v-38252441] {\n  position: absolute;\n  width: 22px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 477px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .kxtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 30px !important;\n  height: 21px !important;\n  top: 184px;\n  left: 262px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .kxtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 31px !important;\n  height: 22px !important;\n  top: 181px;\n  left: 260px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .kxtb1-3[data-v-38252441] {\n  position: absolute;\n  width: 188px !important;\n  height: 24px !important;\n  top: 242px;\n  left: 261px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .kxtb1-4[data-v-38252441] {\n  position: absolute;\n  width: 188px !important;\n  height: 26px !important;\n  top: 240px;\n  left: 262px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .tatb1-1[data-v-38252441] {\n  position: absolute;\n  width: 72px !important;\n  height: 18px !important;\n  top: 269px;\n  left: 38px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .tatb1-2[data-v-38252441] {\n  position: absolute;\n  width: 2px !important;\n  height: 389px !important;\n  top: 263px;\n  left: 113px;\n  cursor: move;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 24px !important;\n  height: 21px !important;\n  top: 156px;\n  left: 389px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 23px !important;\n  height: 23px !important;\n  top: 155px;\n  left: 387px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-4[data-v-38252441] {\n  position: absolute;\n  width: 20px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 185px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-5[data-v-38252441] {\n  position: absolute;\n  width: 20px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 184px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-6[data-v-38252441] {\n  position: absolute;\n  width: 64px !important;\n  height: 47px !important;\n  top: 159px;\n  left: 592px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-7[data-v-38252441] {\n  position: absolute;\n  width: 70px !important;\n  height: 47px !important;\n  top: 158px;\n  left: 588px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-8[data-v-38252441] {\n  position: absolute;\n  width: 30px !important;\n  height: 28px !important;\n  top: 183px;\n  left: 333px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-9[data-v-38252441] {\n  position: absolute;\n  width: 36px !important;\n  height: 24px !important;\n  top: 183px;\n  left: 330px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-10[data-v-38252441] {\n  position: absolute;\n  width: 14px !important;\n  height: 15px !important;\n  top: 287px;\n  left: 489px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-third .qnbox .jchbtb1-11[data-v-38252441] {\n  position: absolute;\n  width: 12px !important;\n  height: 9px !important;\n  top: 292px;\n  left: 490px;\n  cursor: pointer;\n}\n#content-third .qnbox .yshhtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 20px !important;\n  height: 23px !important;\n  top: 184px;\n  left: 369px;\n  cursor: pointer;\n}\n#content-third .qnbox .yshhtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 20px !important;\n  height: 23px !important;\n  top: 184px;\n  left: 369px;\n  cursor: pointer;\n}\n#content-third .qnbox .yshhtb1-3[data-v-38252441] {\n  position: absolute;\n  width: 56px !important;\n  height: 50px !important;\n  top: 155px;\n  left: 662px;\n  cursor: pointer;\n}\n#content-third .qnbox .yshhtb1-4[data-v-38252441] {\n  position: absolute;\n  width: 56px !important;\n  height: 50px !important;\n  top: 156px;\n  left: 661px;\n  cursor: pointer;\n}\n#content-third .qnbox .djtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 63px !important;\n  height: 49px !important;\n  top: 156px;\n  left: 839px;\n  cursor: pointer;\n}\n#content-third .qnbox .djtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 63px !important;\n  height: 49px !important;\n  top: 156px;\n  left: 839px;\n  cursor: pointer;\n}\n#content-third .qnbox .djtb1-3[data-v-38252441] {\n  position: absolute;\n  width: 146px !important;\n  height: 24px !important;\n  top: 216px;\n  left: 839px;\n  cursor: pointer;\n}\n#content-third .qnbox .djtb1-4[data-v-38252441] {\n  position: absolute;\n  width: 146px !important;\n  height: 24px !important;\n  top: 216px;\n  left: 839px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-1[data-v-38252441] {\n  position: absolute;\n  width: 12px !important;\n  height: 19px !important;\n  top: 158px;\n  left: 863px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-2[data-v-38252441] {\n  position: absolute;\n  width: 12px !important;\n  height: 19px !important;\n  top: 158px;\n  left: 863px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-3[data-v-38252441] {\n  position: absolute;\n  width: 210px !important;\n  height: 25px !important;\n  top: 730px;\n  left: 738px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-4[data-v-38252441] {\n  position: absolute;\n  width: 202px !important;\n  height: 19px !important;\n  top: 727px;\n  left: 738px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-5[data-v-38252441] {\n  position: absolute;\n  width: 40px !important;\n  height: 29px !important;\n  top: 246px;\n  left: 323px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-6[data-v-38252441] {\n  position: absolute;\n  width: 67px !important;\n  height: 32pxpx !important;\n  top: 277px;\n  left: 522px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-7[data-v-38252441] {\n  position: absolute;\n  width: 12px !important;\n  height: 7px !important;\n  top: 293px;\n  left: 570px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-8[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 27px !important;\n  top: 644px;\n  left: 605px;\n  cursor: pointer;\n}\n#content-third .qnbox .xstb1-9[data-v-38252441] {\n  position: absolute;\n  width: 71px !important;\n  height: 28px !important;\n  top: 645px;\n  left: 605px;\n  cursor: pointer;\n}\n#content-third .qnbox .zbbltb1-1[data-v-38252441] {\n  position: absolute;\n  width: 12px !important;\n  height: 19px !important;\n  top: 158px;\n  left: 863px;\n  cursor: pointer;\n}\n#content-third .qnbox .zbbltb1-2[data-v-38252441] {\n  position: absolute;\n  width: 12px !important;\n  height: 19px !important;\n  top: 158px;\n  left: 863px;\n  cursor: pointer;\n}\n#content-third .qnbox .zbbltb1-3[data-v-38252441] {\n  position: absolute;\n  width: 210px !important;\n  height: 51px !important;\n  top: 537px;\n  left: 735px;\n  cursor: pointer;\n}\n#content-third .qnbox .zbbltb1-4[data-v-38252441] {\n  position: absolute;\n  width: 203px !important;\n  height: 42px !important;\n  top: 537px;\n  left: 735px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-1[data-v-38252441] {\n  position: absolute;\n  width: 133px !important;\n  height: 30px !important;\n  top: 302px;\n  left: 108px;\n  cursor: pointer;\n}\n#content-four .qnbox .bc1_1input[data-v-38252441] {\n  position: absolute;\n  width: 67px !important;\n  height: 35px !important;\n  top: 382px;\n  left: 869px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-2[data-v-38252441] {\n  position: absolute;\n  width: 137px !important;\n  height: 33px !important;\n  top: 302px;\n  left: 111px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-3[data-v-38252441] {\n  position: absolute;\n  width: 157px !important;\n  height: 45px !important;\n  top: 297px;\n  left: 790px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-4[data-v-38252441] {\n  position: absolute;\n  width: 247px !important;\n  height: 57px !important;\n  top: 291px;\n  left: 786px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-5[data-v-38252441] {\n  position: absolute;\n  width: 93px !important;\n  height: 22px !important;\n  top: 627px;\n  left: 377px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-6[data-v-38252441] {\n  position: absolute;\n  width: 97px !important;\n  height: 24px !important;\n  top: 627px;\n  left: 376px;\n  cursor: pointer;\n}\n#content-four .qnbox .bc_2input[data-v-38252441] {\n  position: absolute;\n  width: 550px !important;\n  height: 22px !important;\n  top: 627px;\n  left: 376px;\n  cursor: pointer;\n}\n#content-four .qnbox .bctb1-7[data-v-38252441] {\n  position: absolute;\n  width: 88px !important;\n  height: 28px !important;\n  top: 691px;\n  left: 850px;\n  cursor: pointer;\n}\n#content-four .qnbox .lc1-1[data-v-38252441] {\n  position: absolute;\n  width: 245px !important;\n  height: 339px !important;\n  top: 97px;\n  left: 394px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-1[data-v-38252441] {\n  position: absolute;\n  width: 235px !important;\n  height: 30px !important;\n  top: 126px;\n  left: 397px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-2[data-v-38252441] {\n  position: absolute;\n  width: 235px !important;\n  height: 24px !important;\n  top: 126px;\n  left: 397px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-3[data-v-38252441] {\n  position: absolute;\n  width: 113px !important;\n  height: 33px !important;\n  top: 228px;\n  left: 116px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-4[data-v-38252441] {\n  position: absolute;\n  width: 113px !important;\n  height: 33px !important;\n  top: 228px;\n  left: 116px;\n  cursor: pointer;\n}\n#content-four .qnbox .lctb1-5[data-v-38252441] {\n  position: absolute;\n  width: 86px !important;\n  height: 25px !important;\n  top: 623px;\n  left: 852px;\n  cursor: pointer;\n}\n#content-five .qnbox .fstb1-1[data-v-38252441] {\n  position: absolute;\n  width: 21px !important;\n  height: 20px !important;\n  top: 86px;\n  left: 450px;\n  cursor: pointer;\n}\n#content-five .qnbox .fstb1-2[data-v-38252441] {\n  position: absolute;\n  width: 69px !important;\n  height: 90px !important;\n  top: 266px;\n  left: 63px;\n  cursor: pointer;\n}\n#content-five .qnbox .fstb1-0[data-v-38252441] {\n  position: absolute;\n  width: 15px !important;\n  height: 14px !important;\n  top: 91px;\n  left: 452px;\n  cursor: pointer;\n}\n#content-five .qnbox .fstb1-3[data-v-38252441] {\n  position: absolute;\n  width: 70px !important;\n  height: 26px !important;\n  top: 668px;\n  left: 796px;\n  cursor: pointer;\n}\n#content-six .qnbox .zttb1-1[data-v-38252441] {\n  position: absolute;\n  width: 11px !important;\n  height: 24px !important;\n  top: 154px;\n  left: 278px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-2[data-v-38252441] {\n  position: absolute;\n  width: 12px !important;\n  height: 21px !important;\n  top: 156px;\n  left: 280px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-3[data-v-38252441] {\n  position: absolute;\n  width: 276px !important;\n  height: 28px !important;\n  top: 262px;\n  left: 175px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-4[data-v-38252441] {\n  position: absolute;\n  width: 262px !important;\n  height: 20px !important;\n  top: 263px;\n  left: 179px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-5[data-v-38252441] {\n  position: absolute;\n  width: 11px !important;\n  height: 24px !important;\n  top: 154px;\n  left: 362px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdzttb1-6[data-v-38252441] {\n  position: absolute;\n  width: 12px !important;\n  height: 22px !important;\n  top: 156px;\n  left: 363px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdzttb1-7[data-v-38252441] {\n  position: absolute;\n  width: 47px !important;\n  height: 23px !important;\n  top: 414px;\n  left: 295px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdzttb1-8[data-v-38252441] {\n  position: absolute;\n  width: 63px !important;\n  height: 22px !important;\n  top: 419px;\n  left: 297px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 37px !important;\n  height: 20px !important;\n  top: 186px;\n  left: 642px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 33px !important;\n  height: 19px !important;\n  top: 185px;\n  left: 648px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-3[data-v-38252441] {\n  position: absolute;\n  width: 156px !important;\n  height: 30px !important;\n  top: 235px;\n  left: 649px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-3[data-v-38252441] {\n  position: absolute;\n  width: 156px !important;\n  height: 30px !important;\n  top: 235px;\n  left: 649px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdhjtb1-4[data-v-38252441] {\n  position: absolute;\n  width: 152px !important;\n  height: 24px !important;\n  top: 240px;\n  left: 652px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 217.7px !important;\n  height: 457.1px !important;\n  top: 240px;\n  left: 652px;\n}\n#content-six .qnbox .wdsjtb1-1-1[data-v-38252441] {\n  position: absolute;\n  width: 213.7px !important;\n  height: 25px !important;\n  top: 524px;\n  left: 652px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 327.6px !important;\n  height: 417.2px !important;\n  top: 309px;\n  left: 394px;\n}\n#content-six .qnbox .wdsjtb1-3[data-v-38252441] {\n  position: absolute;\n  width: 65px !important;\n  height: 17px !important;\n  top: 466px;\n  left: 561px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-4[data-v-38252441] {\n  position: absolute;\n  width: 59px !important;\n  height: 17px !important;\n  top: 502px;\n  left: 560px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-5[data-v-38252441] {\n  position: absolute;\n  width: 59px !important;\n  height: 15px !important;\n  top: 502px;\n  left: 560px;\n  cursor: pointer;\n}\n#content-six .qnbox .wdsjtb1-6[data-v-38252441] {\n  position: absolute;\n  width: 63.6px !important;\n  height: 21px !important;\n  top: 696px;\n  left: 576px;\n  cursor: pointer;\n}\n#content-six .qnbox .jchbtb1-4[data-v-38252441] {\n  position: absolute;\n  width: 20px !important;\n  height: 22px !important;\n  top: 185px;\n  left: 174px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .jchbtb1-5[data-v-38252441] {\n  position: absolute;\n  width: 21px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 174px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .jztb1-1[data-v-38252441] {\n  position: absolute;\n  width: 22px !important;\n  height: 22px !important;\n  top: 184px;\n  left: 532px;\n  cursor: pointer;\n  text-align: right;\n  background: #EDC8C8;\n}\n#content-six .qnbox .jztb1-2[data-v-38252441] {\n  position: absolute;\n  width: 23px !important;\n  height: 25px !important;\n  top: 182px;\n  left: 532px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdystb1-1[data-v-38252441] {\n  position: absolute;\n  width: 30px !important;\n  height: 21px !important;\n  top: 184px;\n  left: 423px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdystb1-2[data-v-38252441] {\n  position: absolute;\n  width: 38px !important;\n  height: 29px !important;\n  top: 181px;\n  left: 418px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdystb1-3[data-v-38252441] {\n  position: absolute;\n  width: 17px !important;\n  height: 16px !important;\n  top: 397px;\n  left: 443px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdystb1-4[data-v-38252441] {\n  position: absolute;\n  width: 11px !important;\n  height: 9px !important;\n  top: 402px;\n  left: 447px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdtxtb1-1[data-v-38252441] {\n  position: absolute;\n  width: 29px !important;\n  height: 21px !important;\n  top: 184px;\n  left: 387px;\n  cursor: pointer;\n  text-align: right;\n}\n#content-six .qnbox .wdtxtb1-2[data-v-38252441] {\n  position: absolute;\n  width: 29px !important;\n  height: 20px !important;\n  top: 184px;\n  left: 387px;\n  cursor: pointer;\n  text-align: right;\n}\n.mynone[data-v-38252441] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newQianniuExam" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(662)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: __webpack_require__(663)
                        },
                        on: { dblclick: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(664)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon02-1",
                        attrs: {
                          src: __webpack_require__(404)
                        },
                        on: { mousemove: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon3,
                          expression: "isShowQnIcon3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(665)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon02-1",
                        attrs: {
                          src: __webpack_require__(404)
                        },
                        on: { click: _vm.showLoginImg3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon4,
                          expression: "isShowQnIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(666)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon04-1",
                        attrs: {
                          src: __webpack_require__(667)
                        },
                        on: { mousemove: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon5,
                          expression: "isShowQnIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(668)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon05-1",
                        attrs: {
                          src: __webpack_require__(669)
                        },
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon6,
                          expression: "isShowQnIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(670)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon06-1",
                        attrs: {
                          src: __webpack_require__(405)
                        },
                        on: { mousemove: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon7,
                          expression: "isShowQnIcon7"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(671)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon06-1",
                        attrs: {
                          src: __webpack_require__(405)
                        },
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon8,
                          expression: "isShowQnIcon8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(406)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon9,
                          expression: "isShowQnIcon9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(406)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon09-1",
                        attrs: {
                          src: __webpack_require__(672)
                        },
                        on: { click: _vm.showLoginImg8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon10,
                          expression: "isShowQnIcon10"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(407)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon11,
                          expression: "isShowQnIcon11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(407)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon11-1",
                        attrs: {
                          src: __webpack_require__(673)
                        },
                        on: { click: _vm.showLoginImg9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon12,
                          expression: "isShowQnIcon12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(408)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon13,
                          expression: "isShowQnIcon13"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(408)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon13-1",
                        attrs: {
                          src: __webpack_require__(94)
                        },
                        on: { click: _vm.showLoginImg10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon14,
                          expression: "isShowQnIcon14"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(674)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm.isShowQnIcon ? _c("p", [_vm._v("请打开WPS")]) : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon2 ||
                  _vm.isShowQnIcon3 ||
                  _vm.isShowQnIcon4 ||
                  _vm.isShowQnIcon5 ||
                  _vm.isShowQnIcon6 ||
                  _vm.isShowQnIcon7 ||
                  _vm.isShowQnIcon8
                    ? _c("p", [_vm._v("新建一个表格")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon9 || _vm.isShowQnIcon10
                    ? _c("p", [
                        _vm._v("选中"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("B列")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon11 || _vm.isShowQnIcon12
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第6行")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon13 || _vm.isShowQnIcon14
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("B3单元格")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_1,
                          expression: "isShownr1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(675)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "nr1-1tb",
                        attrs: {
                          src: __webpack_require__(66)
                        },
                        on: { click: _vm.showLoginnr1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_2,
                          expression: "isShownr1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(676)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.nr_input,
                            expression: "nr_input"
                          }
                        ],
                        ref: "strname",
                        staticClass: "nr1_2input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.nr_input },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.listenOne.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.nr_input = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_3,
                          expression: "isShownr1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(677)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "nr1-3tb",
                        attrs: {
                          src: __webpack_require__(66)
                        },
                        on: { click: _vm.showLoginnr1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_4,
                          expression: "isShownr1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(409)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.nr_input2,
                            expression: "nr_input2"
                          }
                        ],
                        ref: "strname2",
                        staticClass: "nr1_4input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.nr_input2 },
                        on: {
                          keyup: function($event) {
                            if (!$event.ctrlKey) {
                              return null
                            }
                            return _vm.listenTwo.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.nr_input2 = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_5,
                          expression: "isShownr1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(409)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.nr_input2,
                            expression: "nr_input2"
                          }
                        ],
                        staticClass: "nr1_4input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.nr_input2 },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.listenTwo_1.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.nr_input2 = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_6,
                          expression: "isShownr1_6"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(678)
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShownr1_6_1
                        ? _c("img", {
                            staticClass: "nr1-6tb",
                            attrs: {
                              src: __webpack_require__(679)
                            },
                            on: { click: _vm.showLoginnr1_6 }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_7,
                          expression: "isShownr1_7"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(680)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_8,
                          expression: "isShownr1_8"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(681)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_9,
                          expression: "isShownr1_9"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(682)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_10,
                          expression: "isShownr1_10"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(683)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_11,
                          expression: "isShownr1_11"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(684)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "nr1-11tb",
                        attrs: {
                          src: __webpack_require__(685)
                        },
                        on: { click: _vm.showLoginnr1_11 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_12,
                          expression: "isShownr1_12"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(686)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "nr1-12tb",
                        attrs: {
                          src: __webpack_require__(687)
                        },
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.rightClick($event)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_13,
                          expression: "isShownr1_13"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(688)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "nr1-13tb",
                        attrs: {
                          src: __webpack_require__(689)
                        },
                        on: { mousemove: _vm.showLoginnr1_13 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_14,
                          expression: "isShownr1_14"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(690)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "nr1-14tb",
                        attrs: {
                          src: __webpack_require__(691)
                        },
                        on: { click: _vm.showLoginnr1_14 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_15,
                          expression: "isShownr1_15"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(692)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_16,
                          expression: "isShownr1_16"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(693)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "nr1-15tb",
                        attrs: {
                          src: __webpack_require__(694)
                        },
                        on: { click: _vm.showLoginnr1_15 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_17,
                          expression: "isShownr1_17"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(695)
                        },
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.showLoginnr1_16($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShownr1_17_1
                        ? _c("img", {
                            staticClass: "nr1-16tb",
                            attrs: {
                              src: __webpack_require__(696)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShownr1_17_1
                        ? _c("img", {
                            staticClass: "nr1-17tb",
                            attrs: {
                              src: __webpack_require__(697)
                            },
                            on: { mousemove: _vm.showLoginnr1_17 }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShownr1_17_2
                        ? _c("img", {
                            staticClass: "nr1-16tb",
                            attrs: {
                              src: __webpack_require__(698)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShownr1_17_2
                        ? _c("img", {
                            staticClass: "nr1-17tb",
                            attrs: {
                              src: __webpack_require__(699)
                            },
                            on: { click: _vm.showLoginnr1_17_1 }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_18,
                          expression: "isShownr1_18"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(700)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShownr1_19,
                          expression: "isShownr1_19"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(701)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "nr1-19tb",
                        attrs: {
                          src: __webpack_require__(66)
                        },
                        on: { click: _vm.showLoginnr1_19 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_1,
                          expression: "isShowqh1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(702)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.qh1_input,
                            expression: "qh1_input"
                          }
                        ],
                        ref: "strname_1qh",
                        staticClass: "qh1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.qh1_input },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.qh1_input = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qh1-1tb",
                        attrs: {
                          src: __webpack_require__(703)
                        },
                        on: { click: _vm.showLoginnr1_20 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_2,
                          expression: "isShowqh1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(704)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.qh1_input1,
                            expression: "qh1_input1"
                          }
                        ],
                        ref: "strname_2qh",
                        staticClass: "qh1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.qh1_input1 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.qh1_input1 = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qh1-2tb",
                        attrs: {
                          src: __webpack_require__(705)
                        },
                        on: { click: _vm.showLoginqh1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_3,
                          expression: "isShowqh1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(706)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.qh1_input,
                            expression: "qh1_input"
                          }
                        ],
                        ref: "strname_1qh",
                        staticClass: "qh1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.qh1_input },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.qh1_input = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qh1-3tb",
                        attrs: {
                          src: __webpack_require__(707)
                        },
                        on: { click: _vm.showLoginqh1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_4,
                          expression: "isShowqh1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(708)
                        },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.showLoginqh1_4.apply(null, arguments)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_5,
                          expression: "isShowqh1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(709)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowpj1_1,
                          expression: "isShowpj1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(710)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "pjtb1-1",
                        attrs: {
                          src: __webpack_require__(66)
                        },
                        on: { click: _vm.Loginpj1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowpj1_2,
                          expression: "isShowpj1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(711)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pj1_input,
                            expression: "pj1_input"
                          }
                        ],
                        ref: "strname_pj1",
                        staticClass: "pj1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.pj1_input },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.pj1_input = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "pjtb1-2",
                        attrs: {
                          src: __webpack_require__(410)
                        },
                        on: { click: _vm.Loginpj1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowpj1_3,
                          expression: "isShowpj1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(712)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pj1_input,
                            expression: "pj1_input"
                          }
                        ],
                        ref: "strname_pj1",
                        staticClass: "pj1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.pj1_input },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.pj1_input = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowpj1_4,
                          expression: "isShowpj1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(713)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzf1_1,
                          expression: "isShowzf1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(714)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zftb1-1",
                        attrs: {
                          src: __webpack_require__(94)
                        },
                        on: { click: _vm.Loginzf1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzf1_2,
                          expression: "isShowzf1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(715)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.zf1_input,
                            expression: "zf1_input"
                          }
                        ],
                        ref: "strname_zf1",
                        staticClass: "zf1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.zf1_input },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.zf1_input = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "pjtb1-2",
                        attrs: {
                          src: __webpack_require__(410)
                        },
                        on: { click: _vm.Loginzf1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzf1_3,
                          expression: "isShowzf1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(716)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.zf1_input,
                            expression: "zf1_input"
                          }
                        ],
                        ref: "strname_zf1",
                        staticClass: "zf1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.zf1_input },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.zf1_input = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zftb1-2",
                        attrs: {
                          src: __webpack_require__(717)
                        },
                        on: { click: _vm.Loginzf1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzf1_4,
                          expression: "isShowzf1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(718)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzf1_5,
                          expression: "isShowzf1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(719)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxg1_1,
                          expression: "isShowxg1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(720)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xgtb1-1",
                        attrs: {
                          src: __webpack_require__(721)
                        },
                        on: { click: _vm.Loginxg1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxg1_2,
                          expression: "isShowxg1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(722)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.xg_input1,
                            expression: "xg_input1"
                          }
                        ],
                        ref: "strname_xg1",
                        staticClass: "xg1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.xg_input1 },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.showLoginxg1_1.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.xg_input1 = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxg1_3,
                          expression: "isShowxg1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(723)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxj1_1,
                          expression: "isShowxj1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(724)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xjtb1-1",
                        attrs: {
                          src: __webpack_require__(725)
                        },
                        on: { mousemove: _vm.Loginxj1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxj1_2,
                          expression: "isShowxj1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(726)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xjtb1-2",
                        attrs: {
                          src: __webpack_require__(727)
                        },
                        on: { click: _vm.Loginxj1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxj1_3,
                          expression: "isShowxj1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(728)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzb1_1,
                          expression: "isShowzb1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(729)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 zbtb1-1",
                        attrs: {
                          src: __webpack_require__(94)
                        },
                        on: { click: _vm.Loginzb1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzb1_2,
                          expression: "isShowzb1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(730)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.zb_input1,
                            expression: "zb_input1"
                          }
                        ],
                        ref: "strname_zb1",
                        staticClass: "zb1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.zb_input1 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.zb_input1 = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zbtb1-2",
                        attrs: {
                          src: __webpack_require__(731)
                        },
                        on: { click: _vm.Loginzb1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzb1_3,
                          expression: "isShowzb1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(732)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.zb_input1,
                            expression: "zb_input1"
                          }
                        ],
                        ref: "strname_zb1",
                        staticClass: "zb1_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.zb_input1 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.zb_input1 = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zbtb1-3",
                        attrs: {
                          src: __webpack_require__(733)
                        },
                        on: { click: _vm.Loginzb1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzb1_4,
                          expression: "isShowzb1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(734)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzb1_5,
                          expression: "isShowzb1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(735)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxg2_1,
                          expression: "isShowxg2_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(736)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xgtb2-1",
                        attrs: {
                          src: __webpack_require__(737)
                        },
                        on: { click: _vm.Loginxg2_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxg2_2,
                          expression: "isShowxg2_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(738)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.xg_input2,
                            expression: "xg_input2"
                          }
                        ],
                        ref: "strname_xg2",
                        staticClass: "xg2_1input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.xg_input2 },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.showLoginxg2_1.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.xg_input2 = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxg2_3,
                          expression: "isShowxg2_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(739)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  (_vm.isShownr1_1 && _vm.isShownr1_3_1 == false) ||
                  (_vm.isShownr1_2 && _vm.isShownr1_3_1 == false) ||
                  (_vm.isShownr1_3 && _vm.isShownr1_3_1 == false)
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("J2")]
                        ),
                        _vm._v("单元格输入"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("总分较8月上升（下降）")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定\n\t\t\t\t\t")
                      ])
                    : _vm._e(),
                  (_vm.isShownr1_3 && _vm.isShownr1_3_1) ||
                  _vm.isShownr1_4 ||
                  _vm.isShownr1_5 ||
                  (_vm.isShownr1_6 && _vm.isShownr1_6_1 == false)
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A3")]
                        ),
                        _vm._v("单元格先使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("的方式录入当前日期，再将日期修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2022/9/29")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.isShownr1_6 && _vm.isShownr1_6_1) ||
                  _vm.isShownr1_7 ||
                  _vm.isShownr1_8 ||
                  _vm.isShownr1_9 ||
                  _vm.isShownr1_9
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("使用复制快捷键")]
                        ),
                        _vm._v("复制"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A3")]
                        ),
                        _vm._v("单元格日期，"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("使用粘贴快捷键")]
                        ),
                        _vm._v("粘贴日期")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_11 ||
                  _vm.isShownr1_12 ||
                  _vm.isShownr1_13 ||
                  _vm.isShownr1_14 ||
                  _vm.isShownr1_15
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("姓名列右侧")]
                        ),
                        _vm._v("插入一列")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_16 || _vm.isShownr1_17 || _vm.isShownr1_18
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第6行上方")]
                        ),
                        _vm._v("插入一行")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_19 ||
                  _vm.isShowqh1_1 ||
                  _vm.isShowqh1_2 ||
                  _vm.isShowqh1_3 ||
                  _vm.isShowqh1_4 ||
                  _vm.isShowqh1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("I3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相加")]
                        ),
                        _vm._v("的方式计算9月总分")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowpj1_1 ||
                  _vm.isShowpj1_2 ||
                  _vm.isShowpj1_3 ||
                  _vm.isShowpj1_4
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("J3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相除")]
                        ),
                        _vm._v("的方式计算平均分")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzf1_1 ||
                  _vm.isShowzf1_2 ||
                  _vm.isShowzf1_3 ||
                  _vm.isShowzf1_4 ||
                  _vm.isShowzf1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("K3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相减")]
                        ),
                        _vm._v("的方式计算总分较8月上升（下降）")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxg1_1 || _vm.isShowxg1_2 || _vm.isShowxg1_3
                    ? _c("p", [
                        _vm._v("将工作表"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Sheet1")]
                        ),
                        _vm._v("名称修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("成绩汇总")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxj1_1 || _vm.isShowxj1_2 || _vm.isShowxj1_3
                    ? _c("p", [
                        _vm._v("新建一个"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("工作表")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzb1_1 ||
                  _vm.isShowzb1_2 ||
                  _vm.isShowzb1_3 ||
                  _vm.isShowzb1_4 ||
                  _vm.isShowzb1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("C3")]
                        ),
                        _vm._v("单元格中计算290分及以上的人数"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("在总人数中的占比")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxg2_1 || _vm.isShowxg2_2 || _vm.isShowxg2_3
                    ? _c("p", [
                        _vm._v("将工作表"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Sheet2")]
                        ),
                        _vm._v("名称修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("数据统计")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzt1_1,
                          expression: "isShowzt1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(740)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zttb1-1",
                        attrs: {
                          src: __webpack_require__(67)
                        },
                        on: { mousemove: _vm.Loginzt1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzt1_2,
                          expression: "isShowzt1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(741)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zttb1-1",
                        attrs: {
                          src: __webpack_require__(67)
                        },
                        on: { click: _vm.Loginzt1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzt1_3,
                          expression: "isShowzt1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(742)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zttb1-2",
                        attrs: {
                          src: __webpack_require__(743)
                        },
                        on: { mousemove: _vm.Loginzt1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzt1_4,
                          expression: "isShowzt1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(744)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zttb1-3",
                        attrs: {
                          src: __webpack_require__(745)
                        },
                        on: { click: _vm.Loginzt1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzt1_5,
                          expression: "isShowzt1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(411)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjz1_1,
                          expression: "isShowjz1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(411)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jztb1-1",
                        attrs: {
                          src: __webpack_require__(412)
                        },
                        on: { mousemove: _vm.Loginjz1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjz1_2,
                          expression: "isShowjz1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(746)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jztb1-2",
                        attrs: {
                          src: __webpack_require__(413)
                        },
                        on: { click: _vm.Loginjz1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjz1_3,
                          expression: "isShowjz1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(414)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkx1_1,
                          expression: "isShowkx1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(414)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kxtb1-1",
                        attrs: {
                          src: __webpack_require__(747)
                        },
                        on: { mousemove: _vm.Loginkx1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkx1_2,
                          expression: "isShowkx1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(748)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kxtb1-2",
                        attrs: {
                          src: __webpack_require__(749)
                        },
                        on: { click: _vm.Loginkx1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkx1_3,
                          expression: "isShowkx1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(750)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kxtb1-3",
                        attrs: {
                          src: __webpack_require__(751)
                        },
                        on: { mousemove: _vm.Loginkx1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkx1_4,
                          expression: "isShowkx1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(752)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kxtb1-4",
                        attrs: {
                          src: __webpack_require__(753)
                        },
                        on: { click: _vm.Loginkx1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkx1_5,
                          expression: "isShowkx1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(754)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowta1_2,
                          expression: "isShowta1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(755)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "tatb1-2",
                        attrs: {
                          src: __webpack_require__(756)
                        },
                        on: { dblclick: _vm.Loginta1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowta1_3,
                          expression: "isShowta1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(757)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_1,
                          expression: "isShowjchb1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(758)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-1",
                        attrs: {
                          src: __webpack_require__(759)
                        },
                        on: { mousemove: _vm.Loginjchb1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_2,
                          expression: "isShowjchb1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(760)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-2",
                        attrs: {
                          src: __webpack_require__(415)
                        },
                        on: { click: _vm.Loginjchb1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_3,
                          expression: "isShowjchb1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(761)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-2",
                        attrs: {
                          src: __webpack_require__(415)
                        },
                        on: { click: _vm.Loginjchb1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_4,
                          expression: "isShowjchb1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(762)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-4",
                        attrs: {
                          src: __webpack_require__(416)
                        },
                        on: { mousemove: _vm.Loginjchb1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_5,
                          expression: "isShowjchb1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(763)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-5",
                        attrs: {
                          src: __webpack_require__(417)
                        },
                        on: { click: _vm.Loginjchb1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_6,
                          expression: "isShowjchb1_6"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(764)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-6",
                        attrs: {
                          src: __webpack_require__(765)
                        },
                        on: { mousemove: _vm.Loginjchb1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_7,
                          expression: "isShowjchb1_7"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(766)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-7",
                        attrs: {
                          src: __webpack_require__(767)
                        },
                        on: { click: _vm.Loginjchb1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_8,
                          expression: "isShowjchb1_8"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(768)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-8",
                        attrs: {
                          src: __webpack_require__(769)
                        },
                        on: { mousemove: _vm.Loginjchb1_8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_9,
                          expression: "isShowjchb1_9"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(770)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-9",
                        attrs: {
                          src: __webpack_require__(771)
                        },
                        on: { click: _vm.Loginjchb1_9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_10,
                          expression: "isShowjchb1_10"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(772)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-10",
                        attrs: {
                          src: __webpack_require__(418)
                        },
                        on: { mousemove: _vm.Loginjchb1_10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_11,
                          expression: "isShowjchb1_11"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(773)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-11",
                        attrs: {
                          src: __webpack_require__(418)
                        },
                        on: { click: _vm.Loginjchb1_11 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjchb1_12,
                          expression: "isShowjchb1_12"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(774)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowyshh1_1,
                          expression: "isShowyshh1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(775)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "yshhtb1-1",
                        attrs: {
                          src: __webpack_require__(776)
                        },
                        on: { mousemove: _vm.Loginyshh1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowyshh1_2,
                          expression: "isShowyshh1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(777)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "yshhtb1-2",
                        attrs: {
                          src: __webpack_require__(778)
                        },
                        on: { click: _vm.Loginyshh1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowyshh1_3,
                          expression: "isShowyshh1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(779)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "yshhtb1-3",
                        attrs: {
                          src: __webpack_require__(780)
                        },
                        on: { mousemove: _vm.Loginyshh1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowyshh1_4,
                          expression: "isShowyshh1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(781)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "yshhtb1-4",
                        attrs: {
                          src: __webpack_require__(782)
                        },
                        on: { click: _vm.Loginyshh1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowyshh1_5,
                          expression: "isShowyshh1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(783)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdj1_1,
                          expression: "isShowdj1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(784)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "djtb1-1",
                        attrs: {
                          src: __webpack_require__(785)
                        },
                        on: { mousemove: _vm.Logindj1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdj1_2,
                          expression: "isShowdj1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(786)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "djtb1-2",
                        attrs: {
                          src: __webpack_require__(787)
                        },
                        on: { click: _vm.Logindj1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdj1_3,
                          expression: "isShowdj1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(788)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "djtb1-3",
                        attrs: {
                          src: __webpack_require__(789)
                        },
                        on: { mousemove: _vm.Logindj1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdj1_4,
                          expression: "isShowdj1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(790)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "djtb1-4",
                        attrs: {
                          src: __webpack_require__(791)
                        },
                        on: { click: _vm.Logindj1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdj1_5,
                          expression: "isShowdj1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(792)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_1,
                          expression: "isShowxs1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(793)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-1",
                        attrs: {
                          src: __webpack_require__(419)
                        },
                        on: { mousemove: _vm.Loginxs1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_2,
                          expression: "isShowxs1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(794)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-2",
                        attrs: {
                          src: __webpack_require__(420)
                        },
                        on: { click: _vm.Loginxs1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_3,
                          expression: "isShowxs1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(795)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-3",
                        attrs: {
                          src: __webpack_require__(796)
                        },
                        on: { mousemove: _vm.Loginxs1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_4,
                          expression: "isShowxs1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(797)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-4",
                        attrs: {
                          src: __webpack_require__(798)
                        },
                        on: { click: _vm.Loginxs1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_5,
                          expression: "isShowxs1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(799)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-5",
                        attrs: {
                          src: __webpack_require__(800)
                        },
                        on: { click: _vm.Loginxs1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_6,
                          expression: "isShowxs1_6"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(801)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-6",
                        attrs: {
                          src: __webpack_require__(802)
                        },
                        on: { mousemove: _vm.Loginxs1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_7,
                          expression: "isShowxs1_7"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(803)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-7",
                        attrs: {
                          src: __webpack_require__(804)
                        },
                        on: { click: _vm.Loginxs1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_8,
                          expression: "isShowxs1_8"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(805)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-8",
                        attrs: {
                          src: __webpack_require__(806)
                        },
                        on: { mousemove: _vm.Loginxs1_8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_9,
                          expression: "isShowxs1_9"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(807)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "xstb1-9",
                        attrs: {
                          src: __webpack_require__(808)
                        },
                        on: { click: _vm.Loginxs1_9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowxs1_10,
                          expression: "isShowxs1_10"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(809)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzbbl1_1,
                          expression: "isShowzbbl1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(810)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zbbltb1-1",
                        attrs: {
                          src: __webpack_require__(419)
                        },
                        on: { mousemove: _vm.Loginzbbl1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzbbl1_2,
                          expression: "isShowzbbl1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(811)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zbbltb1-2",
                        attrs: {
                          src: __webpack_require__(420)
                        },
                        on: { click: _vm.Loginzbbl1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzbbl1_3,
                          expression: "isShowzbbl1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(812)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zbbltb1-3",
                        attrs: {
                          src: __webpack_require__(813)
                        },
                        on: { mousemove: _vm.Loginzbbl1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzbbl1_4,
                          expression: "isShowzbbl1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(814)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zbbltb1-4",
                        attrs: {
                          src: __webpack_require__(815)
                        },
                        on: { click: _vm.Loginzbbl1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowzbbl1_5,
                          expression: "isShowzbbl1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(816)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _vm.isShowzt1_1 ||
                  _vm.isShowzt1_2 ||
                  _vm.isShowzt1_3 ||
                  _vm.isShowzt1_4 ||
                  _vm.isShowzt1_5
                    ? _c("p", [
                        _vm._v("请将字体设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("微软雅黑")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjz1_1 || _vm.isShowjz1_2 || _vm.isShowjz1_3
                    ? _c("p", [
                        _vm._v("将内容"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("水平居中")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowkx1_1 ||
                  _vm.isShowkx1_2 ||
                  _vm.isShowkx1_3 ||
                  _vm.isShowkx1_4 ||
                  _vm.isShowkx1_5
                    ? _c("p", [
                        _vm._v("将框线设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("所有框线")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowta1_2 || _vm.isShowta1_3
                    ? _c("p", [
                        _vm._v("补充知识:"),
                        _c("br"),
                        _vm._v("请采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("双击鼠标")]
                        ),
                        _vm._v("的方式调整"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A列")]
                        ),
                        _vm._v("宽度")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjchb1_1 ||
                  _vm.isShowjchb1_2 ||
                  _vm.isShowjchb1_3 ||
                  _vm.isShowjchb1_4 ||
                  _vm.isShowjchb1_5 ||
                  _vm.isShowjchb1_6 ||
                  _vm.isShowjchb1_7 ||
                  _vm.isShowjchb1_8 ||
                  _vm.isShowjchb1_9 ||
                  _vm.isShowjchb1_10 ||
                  _vm.isShowjchb1_11 ||
                  _vm.isShowjchb1_12
                    ? _c("p", [
                        _vm._v("1、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第1行")]
                        ),
                        _vm._v("字号大小"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("逐步加大到14号")]
                        ),
                        _c("br"),
                        _vm._v("2、"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("字体加粗")]
                        ),
                        _vm._v("；"),
                        _c("br"),
                        _vm._v("3、合并"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A1-K1")]
                        ),
                        _vm._v("单元格；"),
                        _c("br"),
                        _vm._v("4、将背景填充为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("浅蓝色")]
                        ),
                        _vm._v("（第二行倒数第二个颜色）")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowyshh1_1 || _vm.isShowyshh1_2
                    ? _c("p", [
                        _vm._v("1、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("I2-K2")]
                        ),
                        _vm._v("字体设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("红色")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowyshh1_3 || _vm.isShowyshh1_4 || _vm.isShowyshh1_5
                    ? _c("p", [
                        _vm._v("2、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("K2")]
                        ),
                        _vm._v("单元格内的内容"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("自动换行")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdj1_1 ||
                  _vm.isShowdj1_2 ||
                  _vm.isShowdj1_3 ||
                  _vm.isShowdj1_4 ||
                  _vm.isShowdj1_5
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("冻结")]
                        ),
                        _vm._v("第"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1")]
                        ),
                        _vm._v("行和第"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2")]
                        ),
                        _vm._v("行")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxs1_1 ||
                  _vm.isShowxs1_2 ||
                  _vm.isShowxs1_3 ||
                  _vm.isShowxs1_4 ||
                  _vm.isShowxs1_5 ||
                  _vm.isShowxs1_6 ||
                  _vm.isShowxs1_7 ||
                  _vm.isShowxs1_8 ||
                  _vm.isShowxs1_9 ||
                  _vm.isShowxs1_10
                    ? _c("p", [
                        _vm._v("将平均分设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1位小数")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzbbl1_1 ||
                  _vm.isShowzbbl1_2 ||
                  _vm.isShowzbbl1_3 ||
                  _vm.isShowzbbl1_4 ||
                  _vm.isShowzbbl1_5
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("占比")]
                        ),
                        _vm._v("用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("百分比")]
                        ),
                        _vm._v("表示，保留2位小数")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_1,
                          expression: "isShowbc1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(817)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_2,
                          expression: "isShowbc1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(818)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "bctb1-1",
                        attrs: {
                          src: __webpack_require__(819)
                        },
                        on: { mousemove: _vm.Loginbc1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_3,
                          expression: "isShowbc1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(820)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "bctb1-2",
                        attrs: {
                          src: __webpack_require__(421)
                        },
                        on: { click: _vm.Loginbc1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_4,
                          expression: "isShowbc1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(821)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "bctb1-3",
                        attrs: {
                          src: __webpack_require__(822)
                        },
                        on: { mousemove: _vm.Loginbc1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_5,
                          expression: "isShowbc1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(823)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "bctb1-4",
                        attrs: {
                          src: __webpack_require__(824)
                        },
                        on: { dblclick: _vm.Loginbc1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_6,
                          expression: "isShowbc1_6"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(825)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "bctb1-5",
                        attrs: {
                          src: __webpack_require__(826)
                        },
                        on: { click: _vm.Loginbc1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_7,
                          expression: "isShowbc1_7"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(827)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "bctb1-6",
                        attrs: {
                          src: __webpack_require__(828)
                        },
                        on: { click: _vm.Loginbc1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_8,
                          expression: "isShowbc1_8"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(829)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.bc_input2,
                            expression: "bc_input2"
                          }
                        ],
                        ref: "strname_bc2",
                        staticClass: "bc_2input",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bc_input2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bc_input2 = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "bctb1-7",
                        attrs: {
                          src: __webpack_require__(422)
                        },
                        on: { click: _vm.Loginbc1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowbc1_9,
                          expression: "isShowbc1_9"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(37)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowlc1_1,
                          expression: "isShowlc1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(37)
                        },
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.Loginlc1_1($event)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowlc1_2,
                          expression: "isShowlc1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(37)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "lc1-1",
                        attrs: {
                          src: __webpack_require__(830)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "lctb1-1",
                        attrs: {
                          src: __webpack_require__(831)
                        },
                        on: { mousemove: _vm.Loginlc1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowlc1_3,
                          expression: "isShowlc1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(37)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "lc1-1",
                        attrs: {
                          src: __webpack_require__(832)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "lctb1-2",
                        attrs: {
                          src: __webpack_require__(833)
                        },
                        on: { click: _vm.Loginlc1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowlc1_4,
                          expression: "isShowlc1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "lc1-2",
                        attrs: {
                          src: __webpack_require__(834)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "lctb1-3",
                        attrs: {
                          src: __webpack_require__(835)
                        },
                        on: { mousemove: _vm.Loginlc1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowlc1_5,
                          expression: "isShowlc1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "lc1-2",
                        attrs: {
                          src: __webpack_require__(836)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "lctb1-4",
                        attrs: {
                          src: __webpack_require__(421)
                        },
                        on: { click: _vm.Loginlc1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowlc1_6,
                          expression: "isShowlc1_6"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "lc1-2",
                        attrs: {
                          src: __webpack_require__(837)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "lctb1-5",
                        attrs: {
                          src: __webpack_require__(422)
                        },
                        on: { click: _vm.Loginlc1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowlc1_7,
                          expression: "isShowlc1_7"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "lc1-2",
                        attrs: {
                          src: __webpack_require__(37)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _vm.isShowbc1_1
                    ? _c("p", [
                        _vm._v("使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("打开文件保存路径，将表格保存到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        ),
                        _vm._v("的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("办公软件培训")]
                        ),
                        _vm._v("文件夹中，并将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("文件名称")]
                        ),
                        _vm._v("修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("月考成绩统计")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_2 || _vm.isShowbc1_3
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("我的桌面")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_4 || _vm.isShowbc1_5
                    ? _c("p", [
                        _vm._v("鼠标左键"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("双击办公软件培训")]
                        ),
                        _vm._v("，打开文件夹")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_6 ||
                  _vm.isShowbc1_7 ||
                  _vm.isShowbc1_8 ||
                  _vm.isShowbc1_9
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("文件名")]
                        ),
                        _vm._v("修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("月考成绩统计，并点击保存")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowlc1_1 ||
                  _vm.isShowlc1_2 ||
                  _vm.isShowlc1_3 ||
                  _vm.isShowlc1_4 ||
                  _vm.isShowlc1_5 ||
                  _vm.isShowlc1_6 ||
                  _vm.isShowlc1_7
                    ? _c("p", [
                        _vm._v("将文件另存到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowfs1_1,
                          expression: "isShowfs1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(37)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "fstb1-0",
                        attrs: {
                          src: __webpack_require__(838)
                        },
                        on: { mousemove: _vm.Loginfs1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowfs1_2,
                          expression: "isShowfs1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(839)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "fstb1-1",
                        attrs: {
                          src: __webpack_require__(840)
                        },
                        on: { click: _vm.Loginfs1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowfs1_3,
                          expression: "isShowfs1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(841)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "fstb1-2",
                        attrs: {
                          src: __webpack_require__(842)
                        },
                        on: { click: _vm.Loginfs1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowfs1_4,
                          expression: "isShowfs1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(843)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowfs1_5,
                          expression: "isShowfs1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(844)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowfs1_6,
                          expression: "isShowfs1_6"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(845)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "fstb1-3",
                        attrs: {
                          src: __webpack_require__(846)
                        },
                        on: { click: _vm.Loginfs1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowfs1_7,
                          expression: "isShowfs1_7"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(847)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _vm.isShowfs1_1 ||
                  _vm.isShowfs1_2 ||
                  _vm.isShowfs1_3 ||
                  _vm.isShowfs1_4 ||
                  _vm.isShowfs1_5 ||
                  _vm.isShowfs1_6 ||
                  _vm.isShowfs1_7
                    ? _c("p", [
                        _vm._v("1、关闭表格;"),
                        _c("br"),
                        _vm._v("2、使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("复制快捷键")]
                        ),
                        _vm._v("复制表格;"),
                        _c("br"),
                        _vm._v("3、使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("粘贴快捷键")]
                        ),
                        _vm._v("粘贴表格到QQ群，并发送")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_1,
                          expression: "isShowwdzt1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(848)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_2,
                          expression: "isShowwdzt1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(849)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "zttb1-1",
                        attrs: {
                          src: __webpack_require__(67)
                        },
                        on: { mousemove: _vm.Loginwdzt1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_3,
                          expression: "isShowwdzt1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(850)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdzttb1-2",
                        attrs: {
                          src: __webpack_require__(423)
                        },
                        on: { click: _vm.Loginwdzt1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_4,
                          expression: "isShowwdzt1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(851)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdzttb1-3",
                        attrs: {
                          src: __webpack_require__(852)
                        },
                        on: { mousemove: _vm.Loginwdzt1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_5,
                          expression: "isShowwdzt1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(853)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdzttb1-4",
                        attrs: {
                          src: __webpack_require__(854)
                        },
                        on: { click: _vm.Loginwdzt1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_6,
                          expression: "isShowwdzt1_6"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(855)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdzttb1-5",
                        attrs: {
                          src: __webpack_require__(67)
                        },
                        on: { mousemove: _vm.Loginwdzt1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_7,
                          expression: "isShowwdzt1_7"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(856)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdzttb1-6",
                        attrs: {
                          src: __webpack_require__(423)
                        },
                        on: { click: _vm.Loginwdzt1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_8,
                          expression: "isShowwdzt1_8"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(857)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdzttb1-7",
                        attrs: {
                          src: __webpack_require__(858)
                        },
                        on: { mousemove: _vm.Loginwdzt1_8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_9,
                          expression: "isShowwdzt1_9"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(859)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdzttb1-8",
                        attrs: {
                          src: __webpack_require__(860)
                        },
                        on: { click: _vm.Loginwdzt1_9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdzt1_10,
                          expression: "isShowwdzt1_10"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(424)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdhj1_1,
                          expression: "isShowwdhj1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(424)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdhjtb1-1",
                        attrs: {
                          src: __webpack_require__(861)
                        },
                        on: { mousemove: _vm.Loginwdhj1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdhj1_2,
                          expression: "isShowwdhj1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(862)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdhjtb1-2",
                        attrs: {
                          src: __webpack_require__(863)
                        },
                        on: { click: _vm.Loginwdhj1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdhj1_3,
                          expression: "isShowwdhj1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(864)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdhjtb1-3",
                        attrs: {
                          src: __webpack_require__(865)
                        },
                        on: { mousemove: _vm.Loginwdhj1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdhj1_4,
                          expression: "isShowwdhj1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(866)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdhjtb1-4",
                        attrs: {
                          src: __webpack_require__(867)
                        },
                        on: { click: _vm.Loginwdhj1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdhj1_5,
                          expression: "isShowwdhj1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(868)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdsj1_1,
                          expression: "isShowwdsj1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(38)
                        },
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.rightClick_sj($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShowwdsj1_1_1
                        ? _c("img", {
                            staticClass: "wdsjtb1-1",
                            attrs: {
                              src: __webpack_require__(425)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowwdsj1_1_1
                        ? _c("img", {
                            staticClass: "wdsjtb1-1-1",
                            attrs: {
                              src: __webpack_require__(869)
                            },
                            on: { mousemove: _vm.Loginwdsj1_1 }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdsj1_2,
                          expression: "isShowwdsj1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(38)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-1",
                        attrs: {
                          src: __webpack_require__(425)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-1-1",
                        attrs: {
                          src: __webpack_require__(870)
                        },
                        on: { click: _vm.Loginwdsj1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdsj1_3,
                          expression: "isShowwdsj1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(38)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-2",
                        attrs: {
                          src: __webpack_require__(871)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-3",
                        attrs: {
                          src: __webpack_require__(872)
                        },
                        on: { click: _vm.Loginwdsj1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdsj1_4,
                          expression: "isShowwdsj1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(38)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-2",
                        attrs: {
                          src: __webpack_require__(873)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-4",
                        attrs: {
                          src: __webpack_require__(874)
                        },
                        on: { mousemove: _vm.Loginwdsj1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdsj1_5,
                          expression: "isShowwdsj1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(38)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-2",
                        attrs: {
                          src: __webpack_require__(875)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-5",
                        attrs: {
                          src: __webpack_require__(876)
                        },
                        on: { click: _vm.Loginwdsj1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdsj1_6,
                          expression: "isShowwdsj1_6"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(38)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-2",
                        attrs: {
                          src: __webpack_require__(877)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdsjtb1-6",
                        attrs: {
                          src: __webpack_require__(878)
                        },
                        on: { click: _vm.Loginwdsj1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdsj1_7,
                          expression: "isShowwdsj1_7"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(879)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdjc1_1,
                          expression: "isShowwdjc1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(880)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-4",
                        attrs: {
                          src: __webpack_require__(416)
                        },
                        on: { mousemove: _vm.Loginwdjc1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdjc1_2,
                          expression: "isShowwdjc1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(881)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jchbtb1-5",
                        attrs: {
                          src: __webpack_require__(417)
                        },
                        on: { click: _vm.Loginwdjc1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdjc1_3,
                          expression: "isShowwdjc1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(882)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jztb1-1",
                        attrs: {
                          src: __webpack_require__(412)
                        },
                        on: { mousemove: _vm.Loginwdjc1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdjc1_4,
                          expression: "isShowwdjc1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(883)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jztb1-2",
                        attrs: {
                          src: __webpack_require__(413)
                        },
                        on: { click: _vm.Loginwdjc1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdjc1_5,
                          expression: "isShowwdjc1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(884)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdys1_1,
                          expression: "isShowwdys1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(885)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdystb1-1",
                        attrs: {
                          src: __webpack_require__(886)
                        },
                        on: { mousemove: _vm.Loginwdys1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdys1_2,
                          expression: "isShowwdys1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(887)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdystb1-2",
                        attrs: {
                          src: __webpack_require__(888)
                        },
                        on: { click: _vm.Loginwdys1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdys1_3,
                          expression: "isShowwdys1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(889)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdystb1-3",
                        attrs: {
                          src: __webpack_require__(890)
                        },
                        on: { mousemove: _vm.Loginwdys1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdys1_4,
                          expression: "isShowwdys1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(891)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdystb1-4",
                        attrs: {
                          src: __webpack_require__(892)
                        },
                        on: { click: _vm.Loginwdys1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdys1_5,
                          expression: "isShowwdys1_5"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(893)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdtx1_1,
                          expression: "isShowwdtx1_1"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(894)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdtxtb1-1",
                        attrs: {
                          src: __webpack_require__(895)
                        },
                        on: { mousemove: _vm.Loginwdtx1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdtx1_2,
                          expression: "isShowwdtx1_2"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(896)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "wdtxtb1-2",
                        attrs: {
                          src: __webpack_require__(897)
                        },
                        on: { click: _vm.Loginwdtx1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdtx1_3,
                          expression: "isShowwdtx1_3"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(898)
                        },
                        on: { click: function($event) {} }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowwdtx1_4,
                          expression: "isShowwdtx1_4"
                        }
                      ],
                      staticClass: "qnbox nr1_4"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(899)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _vm.isShowwdzt1_1 ||
                  _vm.isShowwdzt1_2 ||
                  _vm.isShowwdzt1_3 ||
                  _vm.isShowwdzt1_4 ||
                  _vm.isShowwdzt1_5 ||
                  _vm.isShowwdzt1_6 ||
                  _vm.isShowwdzt1_7 ||
                  _vm.isShowwdzt1_8 ||
                  _vm.isShowwdzt1_9 ||
                  _vm.isShowwdzt1_10
                    ? _c("p", [
                        _vm._v("先采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("全选内容，再将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("字体")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("楷体，字号")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("小四")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdhj1_1 ||
                  _vm.isShowwdhj1_2 ||
                  _vm.isShowwdhj1_3 ||
                  _vm.isShowwdhj1_4 ||
                  _vm.isShowwdhj1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("行距")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1.5")]
                        ),
                        _vm._v("倍")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdsj1_1 ||
                  _vm.isShowwdsj1_2 ||
                  _vm.isShowwdsj1_3 ||
                  _vm.isShowwdsj1_4 ||
                  _vm.isShowwdsj1_5 ||
                  _vm.isShowwdsj1_6 ||
                  _vm.isShowwdsj1_7
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("首行缩进2字符")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdjc1_1 ||
                  _vm.isShowwdjc1_2 ||
                  _vm.isShowwdjc1_3 ||
                  _vm.isShowwdjc1_4 ||
                  _vm.isShowwdjc1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("标题加粗，并居中")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdys1_1 ||
                  _vm.isShowwdys1_2 ||
                  _vm.isShowwdys1_3 ||
                  _vm.isShowwdys1_4 ||
                  _vm.isShowwdys1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2015")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("红色")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdtx1_1 ||
                  _vm.isShowwdtx1_2 ||
                  _vm.isShowwdtx1_3 ||
                  _vm.isShowwdtx1_4
                    ? _c("p", [
                        _vm._v("用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("黄色突出显示")]
                        ),
                        _vm._v("最后自然段")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-six" } },
                  [_vm._m(7)]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            staticStyle: { display: "none" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、Excel界面介绍")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、Excel内容编辑")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、Excel内容布局")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、保存文件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、发送文件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、Word基础功能")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip" }, [
      _c("span", { staticClass: "el-icon-success" }),
      _vm._v(" "),
      _c("p", [
        _vm._v("你已完成办公软件模拟实操，"),
        _c("br"),
        _vm._v("接下来请完成《搜狗输入法》。")
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            staticClass: "startstudy",
            staticStyle: { width: "160px" },
            attrs: { href: "/tjkStudy/simulate/jmStudy" }
          },
          [_vm._v("去完成~~学习")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38252441", esExports)
  }
}

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewriting_vue__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewriting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewriting_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewriting_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewriting_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2102e2e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typewriting_vue__ = __webpack_require__(1673);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1671)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2102e2e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewriting_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2102e2e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typewriting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/typewriting/typewriting.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2102e2e4", Component.options)
  } else {
    hotAPI.reload("data-v-2102e2e4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1672);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b5a07b00", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2102e2e4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./typewriting.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2102e2e4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./typewriting.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-2102e2e4] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-2102e2e4] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n#newQianniu .content .qnbox[data-v-2102e2e4] {\n  width: 1060px;\n  height: 650px;\n  position: relative;\n}\n#newQianniu .content .qnbox .qnicon01[data-v-2102e2e4] {\n  position: absolute;\n  margin-top: -218px;\n  margin-left: -285px;\n  width: 98px;\n  height: 98px;\n}\n#newQianniu .content .qnbox .qnicon02-1[data-v-2102e2e4] {\n  width: 67px !important;\n  height: 21px !important;\n  top: 216px;\n  left: 473px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon04-1[data-v-2102e2e4] {\n  width: 176px !important;\n  height: 43px !important;\n  top: 486px;\n  left: 272px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon05-1[data-v-2102e2e4] {\n  width: 123px !important;\n  height: 32px !important;\n  top: 491px;\n  left: 286px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon06-1[data-v-2102e2e4] {\n  width: 120px !important;\n  height: 92px !important;\n  top: 389px;\n  left: 533px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon09-1[data-v-2102e2e4] {\n  width: 59px !important;\n  height: 20px !important;\n  top: 399px;\n  left: 372px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon11-1[data-v-2102e2e4] {\n  width: 23px !important;\n  height: 12px !important;\n  top: 519px;\n  left: 260px;\n  cursor: pointer;\n}\n#newQianniu .content .qnbox .qnicon13-1[data-v-2102e2e4] {\n  width: 69px !important;\n  height: 15px !important;\n  top: 461px;\n  left: 367px;\n  cursor: pointer;\n}\n#newQianniu .content .con-left[data-v-2102e2e4] {\n  height: calc(100vh - 217px) !important;\n  width: calc(100% - 210px) !important;\n}\n#newQianniu .content .con-right[data-v-2102e2e4] {\n  height: calc(100vh - 214px);\n  width: 200px;\n}\n#content-second .qnbox .nr1-1tb[data-v-2102e2e4] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 352px;\n  left: 752px;\n  cursor: pointer;\n}\n#content-second .nr1_2input[data-v-2102e2e4] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 352px;\n  left: 752px;\n  cursor: pointer;\n}\n#content-second .exclenrbox[data-v-2102e2e4] {\n  width: 1060px;\n  height: 650px;\n  position: relative;\n}\n#content-second .qnbox .nr1-3tb[data-v-2102e2e4] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 38px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1_4input[data-v-2102e2e4] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 370px;\n  left: 36px;\n  cursor: pointer;\n}\n#content-first .qnbox .qhtb1-1[data-v-2102e2e4] {\n  position: absolute;\n  width: 18px !important;\n  height: 20px !important;\n  top: 620px;\n  left: 906px;\n  cursor: pointer;\n}\n#content-first .qnbox .qhtb1-2[data-v-2102e2e4] {\n  position: absolute;\n  width: 15px !important;\n  height: 16px !important;\n  top: 622px;\n  left: 908px;\n  cursor: pointer;\n}\n#content-first .qnbox .qhtb1-3[data-v-2102e2e4] {\n  position: absolute;\n  width: 298px !important;\n  height: 62px !important;\n  top: 424px;\n  left: 756px;\n  cursor: pointer;\n}\n#content-first .qnbox .qhtb1-4[data-v-2102e2e4] {\n  position: absolute;\n  width: 296px !important;\n  height: 57px !important;\n  top: 428px;\n  left: 756px;\n  cursor: pointer;\n}\n#content-first .qnbox .jptb1-1[data-v-2102e2e4] {\n  position: absolute;\n  width: 14px !important;\n  height: 16px !important;\n  top: 71px;\n  left: 496px;\n  cursor: pointer;\n}\n#content-first .qnbox .jptb1-2[data-v-2102e2e4] {\n  position: absolute;\n  width: 19px !important;\n  height: 18px !important;\n  top: 70px;\n  left: 493px;\n  cursor: pointer;\n}\n#content-first .qnbox .jptb1-3[data-v-2102e2e4] {\n  position: absolute;\n  width: 249px !important;\n  height: 71px !important;\n  top: 502px;\n  left: 453px;\n  cursor: pointer;\n}\n#content-first .qnbox .jptb1-4[data-v-2102e2e4] {\n  position: absolute;\n  width: 84px !important;\n  height: 34px !important;\n  top: 539px;\n  left: 605px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-1[data-v-2102e2e4] {\n  position: absolute;\n  width: 34px !important;\n  height: 31px !important;\n  top: 60px;\n  left: 337px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-2[data-v-2102e2e4] {\n  position: absolute;\n  width: 34px !important;\n  height: 31px !important;\n  top: 59px;\n  left: 337px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-3[data-v-2102e2e4] {\n  position: absolute;\n  width: 249px !important;\n  height: 516px !important;\n  top: 20px;\n  left: 112px;\n}\n#content-first .qnbox .kjtb1-4[data-v-2102e2e4] {\n  position: absolute;\n  width: 63px !important;\n  height: 48px !important;\n  top: 438px;\n  left: 284px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-5[data-v-2102e2e4] {\n  position: absolute;\n  width: 34px !important;\n  height: 16px !important;\n  top: 411px;\n  left: 143px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-6[data-v-2102e2e4] {\n  position: absolute;\n  width: 31px !important;\n  height: 16px !important;\n  top: 411px;\n  left: 143px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-6-1_box[data-v-2102e2e4] {\n  position: absolute;\n  width: 674px !important;\n  height: 456px !important;\n  top: 142px;\n  left: 298px;\n  overflow: auto;\n}\n#content-first .qnbox .kjtb1-6-1_box[data-v-2102e2e4]::-webkit-scrollbar {\n  display: none !important;\n}\n#content-first .qnbox .kjtb1-6-1[data-v-2102e2e4] {\n  width: 100% !important;\n  height: 746px !important;\n}\n#content-first .qnbox .kjtb1-7[data-v-2102e2e4] {\n  position: absolute;\n  width: 617px !important;\n  height: 466px !important;\n  top: 133px;\n  left: 302px;\n}\n#content-first .qnbox .kjtb1-8[data-v-2102e2e4] {\n  position: absolute;\n  width: 562px !important;\n  height: 37px !important;\n  top: 452px;\n  left: 47px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-9[data-v-2102e2e4] {\n  position: absolute;\n  width: 613px !important;\n  height: 38px !important;\n  top: 297px;\n  left: 305px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-9-1[data-v-2102e2e4] {\n  position: absolute;\n  width: 674px !important;\n  height: 472px !important;\n  top: 127px;\n  left: 298px;\n  overflow: auto;\n}\n#content-first .qnbox .kjtb1-9-1[data-v-2102e2e4]::-webkit-scrollbar {\n  display: none;\n}\n#content-first .qnbox .kjtb1-10[data-v-2102e2e4] {\n  width: 100% !important;\n  height: 682px !important;\n}\n#content-first .qnbox .kjtb1-11[data-v-2102e2e4] {\n  position: absolute;\n  width: 606px !important;\n  height: 39px !important;\n  top: 466px;\n  left: 13px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-12[data-v-2102e2e4] {\n  position: absolute;\n  width: 17px !important;\n  height: 17px !important;\n  top: 389px;\n  left: 324px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-1[data-v-2102e2e4] {\n  position: absolute;\n  width: 32px !important;\n  height: 15px !important;\n  top: 457px;\n  left: 157px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-2[data-v-2102e2e4] {\n  position: absolute;\n  width: 31px !important;\n  height: 18px !important;\n  top: 457px;\n  left: 157px;\n  cursor: pointer;\n}\n#content-second .qnbox .qnbg1-3-1box[data-v-2102e2e4] {\n  position: absolute;\n  width: 677px !important;\n  height: 472px !important;\n  top: 129px;\n  left: 308px;\n  overflow: auto;\n}\n#content-second .qnbox .qnbg1-3-1box[data-v-2102e2e4]::-webkit-scrollbar {\n  display: none;\n}\n#content-second .qnbox .dytb1-3[data-v-2102e2e4] {\n  width: 100% !important;\n  height: 700px !important;\n}\n#content-second .qnbox .dytb1-4[data-v-2102e2e4] {\n  position: absolute;\n  width: 588px !important;\n  height: 39px !important;\n  top: 575px;\n  left: 31px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-5[data-v-2102e2e4] {\n  position: absolute;\n  width: 614px !important;\n  height: 37px !important;\n  top: 477px;\n  left: 316px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-6[data-v-2102e2e4] {\n  position: absolute;\n  width: 88px !important;\n  height: 21px !important;\n  top: 81px;\n  left: 843px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-7[data-v-2102e2e4] {\n  position: absolute;\n  width: 87px !important;\n  height: 21px !important;\n  top: 81px;\n  left: 843px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_input[data-v-2102e2e4] {\n  position: absolute;\n  width: 236px !important;\n  top: 218px;\n  left: 313px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_input[data-v-2102e2e4] .el-input__inner {\n  height: 32px;\n}\n#content-second .qnbox .isShowdy1_7_textarea[data-v-2102e2e4] {\n  position: absolute;\n  width: 450px !important;\n  top: 303px;\n  left: 313px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_textarea[data-v-2102e2e4] .el-textarea__inner {\n  height: 114px !important;\n}\n#content-second .qnbox .dytb1-8[data-v-2102e2e4] {\n  position: absolute;\n  width: 121px !important;\n  height: 25px !important;\n  top: 430px;\n  left: 317px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_select[data-v-2102e2e4] {\n  position: absolute;\n  width: 111px !important;\n  height: 25px !important;\n  top: 220px;\n  left: 589px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_select[data-v-2102e2e4] .el-input__inner {\n  background: #F5F7FC;\n  height: 28px;\n  border-color: #F5F7FC;\n}\n#content-second .qnbox .isShowdy1_7_select[data-v-2102e2e4] .el-select .el-input .el-select__caret {\n  color: #000;\n  font-size: 13px;\n  font-weight: 500;\n}\n#content-second .qnbox .isShowdy1_7_select[data-v-2102e2e4] .el-input__icon {\n  line-height: 38px;\n}\n#content-second .qnbox .dytb1-9[data-v-2102e2e4] {\n  position: absolute;\n  width: 84px !important;\n  height: 26px !important;\n  top: 430px;\n  left: 582px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb2-1[data-v-2102e2e4] {\n  position: absolute;\n  width: 237px !important;\n  height: 44px !important;\n  top: 457px;\n  left: 525px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb2-2[data-v-2102e2e4] {\n  position: absolute;\n  width: 84px !important;\n  height: 24px !important;\n  top: 528px;\n  left: 568px;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newQianniu" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("1、搜狗输入法的截屏功能")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2023-02/62fe7f6473a2439eb02b097878cc8ca0.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_1,
                          expression: "isShowqh1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(902)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-1",
                        attrs: {
                          src: __webpack_require__(903)
                        },
                        on: { mousemove: _vm.showLoginqh1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_2,
                          expression: "isShowqh1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(904)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-2",
                        attrs: {
                          src: __webpack_require__(905)
                        },
                        on: { click: _vm.showLoginqh1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_3,
                          expression: "isShowqh1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(906)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-3",
                        attrs: {
                          src: __webpack_require__(907)
                        },
                        on: { mousemove: _vm.showLoginqh1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_4,
                          expression: "isShowqh1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(908)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-4",
                        attrs: {
                          src: __webpack_require__(909)
                        },
                        on: { click: _vm.showLoginqh1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_5,
                          expression: "isShowqh1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(426)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_1,
                          expression: "isShowjp1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(426)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-1",
                        attrs: {
                          src: __webpack_require__(910)
                        },
                        on: { mousemove: _vm.showLoginjp1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_2,
                          expression: "isShowjp1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(911)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-2",
                        attrs: {
                          src: __webpack_require__(912)
                        },
                        on: { click: _vm.showLoginjp1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_3,
                          expression: "isShowjp1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(913)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-3",
                        attrs: {
                          src: __webpack_require__(427)
                        },
                        on: { mousemove: _vm.showLoginjp1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_4,
                          expression: "isShowjp1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(914)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-3",
                        attrs: {
                          src: __webpack_require__(427)
                        },
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.showLoginjp1_4($event)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_5,
                          expression: "isShowjp1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(915)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-4",
                        attrs: {
                          src: __webpack_require__(916)
                        },
                        on: { click: _vm.showLoginjp1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_6,
                          expression: "isShowjp1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(917)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_1,
                          expression: "isShowkj1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(428)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-1",
                        attrs: {
                          src: __webpack_require__(429)
                        },
                        on: { mousemove: _vm.showLoginkj1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_2,
                          expression: "isShowkj1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(918)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-2",
                        attrs: {
                          src: __webpack_require__(429)
                        },
                        on: { click: _vm.showLoginkj1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_3,
                          expression: "isShowkj1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(428)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-3",
                        attrs: {
                          src: __webpack_require__(919)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-4",
                        attrs: {
                          src: __webpack_require__(920)
                        },
                        on: { click: _vm.showLoginkj1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_4,
                          expression: "isShowkj1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(921)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-5",
                        attrs: {
                          src: __webpack_require__(922)
                        },
                        on: { mousemove: _vm.showLoginkj1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_5,
                          expression: "isShowkj1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(923)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-6",
                        attrs: {
                          src: __webpack_require__(430)
                        },
                        on: { click: _vm.showLoginkj1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_6,
                          expression: "isShowkj1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(924)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-6",
                        attrs: {
                          src: __webpack_require__(430)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "kjtb1-6-1_box" }, [
                        _c("img", {
                          staticClass: "kjtb1-6-1",
                          attrs: {
                            src: __webpack_require__(925)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kjtb1-8",
                          attrs: {
                            src: __webpack_require__(926)
                          },
                          on: { mousemove: _vm.showLoginkj1_6 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_8,
                          expression: "isShowkj1_8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(927)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-9",
                        attrs: {
                          src: __webpack_require__(928)
                        },
                        on: { click: _vm.showLoginkj1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_9,
                          expression: "isShowkj1_9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(929)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "kjtb1-9-1" }, [
                        _c("img", {
                          staticClass: "kjtb1-10",
                          attrs: {
                            src: __webpack_require__(930)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kjtb1-11",
                          attrs: {
                            src: __webpack_require__(931)
                          },
                          on: { mousemove: _vm.showLoginkj1_9 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_11,
                          expression: "isShowkj1_11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(932)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-12",
                        attrs: {
                          src: __webpack_require__(933)
                        },
                        on: { click: _vm.showLoginkj1_10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_12,
                          expression: "isShowkj1_12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(934)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowqh1_1 ||
                  _vm.isShowqh1_2 ||
                  _vm.isShowqh1_3 ||
                  _vm.isShowqh1_4 ||
                  _vm.isShowqh1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("左侧练习场")]
                        ),
                        _vm._v("中，"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("右下角")]
                        ),
                        _vm._v("的输入法"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("切换")]
                        ),
                        _vm._v("为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("搜狗输入法")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjp1_1 ||
                  _vm.isShowjp1_2 ||
                  _vm.isShowjp1_3 ||
                  _vm.isShowjp1_4 ||
                  _vm.isShowjp1_5 ||
                  _vm.isShowjp1_6
                    ? _c("p", [
                        _vm._v("打开搜狗输入法的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("智能输入助手,")]
                        ),
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("截屏")]
                        ),
                        _vm._v("功能快捷方式设置到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        ),
                        _vm._v("上")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowkj1_1 ||
                  _vm.isShowkj1_2 ||
                  _vm.isShowkj1_3 ||
                  _vm.isShowkj1_4 ||
                  _vm.isShowkj1_5 ||
                  _vm.isShowkj1_6 ||
                  _vm.isShowkj1_8 ||
                  _vm.isShowkj1_9 ||
                  _vm.isShowkj1_10 ||
                  _vm.isShowkj1_11 ||
                  _vm.isShowkj1_12
                    ? _c("p", [
                        _vm._v("在搜狗输入法的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("菜单")]
                        ),
                        _vm._v("中，将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("截屏")]
                        ),
                        _vm._v("的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("设置为Ctrl+Alt+Q")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("搜狗输入法练习-截屏功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、搜狗输入法的快捷短语")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2023-02/82f510f141db4151a86594302eac1b11.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_1,
                          expression: "isShowdy1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(935)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-1",
                        attrs: {
                          src: __webpack_require__(936)
                        },
                        on: { mousemove: _vm.showLogindy1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_2,
                          expression: "isShowdy1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(937)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-2",
                        attrs: {
                          src: __webpack_require__(938)
                        },
                        on: { click: _vm.showLogindy1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_3,
                          expression: "isShowdy1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(939)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "qnbg1-3-1box" }, [
                        _c("img", {
                          staticClass: "dytb1-3",
                          attrs: {
                            src: __webpack_require__(940)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "dytb1-4",
                          attrs: {
                            src: __webpack_require__(941)
                          },
                          on: { mousemove: _vm.showLogindy1_3 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_4,
                          expression: "isShowdy1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(942)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-5",
                        attrs: {
                          src: __webpack_require__(943)
                        },
                        on: { click: _vm.showLogindy1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_5,
                          expression: "isShowdy1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(944)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-6",
                        attrs: {
                          src: __webpack_require__(945)
                        },
                        on: { mousemove: _vm.showLogindy1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_6,
                          expression: "isShowdy1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(946)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-7",
                        attrs: {
                          src: __webpack_require__(947)
                        },
                        on: { click: _vm.showLogindy1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_7,
                          expression: "isShowdy1_7"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(948)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_input" },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.isShowdy1_7_input,
                              callback: function($$v) {
                                _vm.isShowdy1_7_input = $$v
                              },
                              expression: "isShowdy1_7_input"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_textarea" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              resize: "none"
                            },
                            model: {
                              value: _vm.isShowdy1_7_textarea,
                              callback: function($$v) {
                                _vm.isShowdy1_7_textarea = $$v
                              },
                              expression: "isShowdy1_7_textarea"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-8",
                        attrs: {
                          src: __webpack_require__(949)
                        },
                        on: { click: _vm.showLogindy1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_8,
                          expression: "isShowdy1_8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(950)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_input" },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.isShowdy1_7_input,
                              callback: function($$v) {
                                _vm.isShowdy1_7_input = $$v
                              },
                              expression: "isShowdy1_7_input"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_textarea" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              resize: "none"
                            },
                            model: {
                              value: _vm.isShowdy1_7_textarea,
                              callback: function($$v) {
                                _vm.isShowdy1_7_textarea = $$v
                              },
                              expression: "isShowdy1_7_textarea"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_select" },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.isShowdy1_7_select,
                                callback: function($$v) {
                                  _vm.isShowdy1_7_select = $$v
                                },
                                expression: "isShowdy1_7_select"
                              }
                            },
                            _vm._l(_vm.isShowdy1_7_selectopint, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-9",
                        attrs: {
                          src: __webpack_require__(951)
                        },
                        on: { click: _vm.showLogindy1_8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_9,
                          expression: "isShowdy1_9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(952)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_10,
                          expression: "isShowdy1_10"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(953)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_11,
                          expression: "isShowdy1_11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(954)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-1",
                        attrs: {
                          src: __webpack_require__(431)
                        },
                        on: { mousemove: _vm.showLogindy1_10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_12,
                          expression: "isShowdy1_12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(955)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-1",
                        attrs: {
                          src: __webpack_require__(431)
                        },
                        on: { click: _vm.showLogindy1_11 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_13,
                          expression: "isShowdy1_13"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(956)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-2",
                        attrs: {
                          src: __webpack_require__(957)
                        },
                        on: { click: _vm.showLogindy1_12 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_14,
                          expression: "isShowdy1_14"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(958)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowdy1_1 ||
                  _vm.isShowdy1_2 ||
                  _vm.isShowdy1_3 ||
                  _vm.isShowdy1_4 ||
                  _vm.isShowdy1_5 ||
                  _vm.isShowdy1_6
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语:"),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开3分钟")]
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定并继续添加")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_7
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语："),
                        _c("br"),
                        _vm._v("缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开3分钟")]
                        ),
                        _c("br"),
                        _vm._v("点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定并继续添加")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_8 || _vm.isShowdy1_9
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语："),
                        _c("br"),
                        _vm._v("缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("候选位置："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2")]
                        ),
                        _c("br"),
                        _vm._v("内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开5分钟")]
                        ),
                        _c("br"),
                        _vm._v("点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_10 ||
                  _vm.isShowdy1_11 ||
                  _vm.isShowdy1_12 ||
                  _vm.isShowdy1_13 ||
                  _vm.isShowdy1_14
                    ? _c("p", [
                        _vm._v("在聊天输入框中输入"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _vm._v("，调出快捷短语，选择离开"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("5分钟")]
                        ),
                        _vm._v("的短语，并"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("发送")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-second" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成搜狗输入法的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《搜狗输入法实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px" },
                          attrs: { href: "/excelstudy" }
                        },
                        [_vm._v("去完成搜狗输入法实操")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("搜狗输入法练习-快捷短语.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2102e2e4", esExports)
  }
}

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewritingstudy_vue__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewritingstudy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewritingstudy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewritingstudy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewritingstudy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d74e1ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typewritingstudy_vue__ = __webpack_require__(1677);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1675)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d74e1ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_typewritingstudy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d74e1ab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_typewritingstudy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/typewriting/typewritingstudy.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d74e1ab", Component.options)
  } else {
    hotAPI.reload("data-v-7d74e1ab", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1676);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d67a29b8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d74e1ab\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./typewritingstudy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d74e1ab\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./typewritingstudy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-7d74e1ab] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-7d74e1ab] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n#newQianniuExam .content .qnbox[data-v-7d74e1ab] {\n  width: 1060px;\n  height: 650px;\n  position: relative;\n}\n#newQianniuExam .content .qnbox .qnicon01[data-v-7d74e1ab] {\n  position: absolute;\n  margin-top: -218px;\n  margin-left: -285px;\n  width: 98px;\n  height: 98px;\n}\n#newQianniuExam .content .qnbox .qnicon02-1[data-v-7d74e1ab] {\n  width: 67px !important;\n  height: 21px !important;\n  top: 216px;\n  left: 473px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon04-1[data-v-7d74e1ab] {\n  width: 176px !important;\n  height: 43px !important;\n  top: 486px;\n  left: 272px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon05-1[data-v-7d74e1ab] {\n  width: 123px !important;\n  height: 32px !important;\n  top: 491px;\n  left: 286px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon06-1[data-v-7d74e1ab] {\n  width: 120px !important;\n  height: 92px !important;\n  top: 389px;\n  left: 533px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon09-1[data-v-7d74e1ab] {\n  width: 59px !important;\n  height: 20px !important;\n  top: 399px;\n  left: 372px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon11-1[data-v-7d74e1ab] {\n  width: 23px !important;\n  height: 12px !important;\n  top: 519px;\n  left: 260px;\n  cursor: pointer;\n}\n#newQianniuExam .content .qnbox .qnicon13-1[data-v-7d74e1ab] {\n  width: 69px !important;\n  height: 15px !important;\n  top: 461px;\n  left: 367px;\n  cursor: pointer;\n}\n#newQianniuExam .content .con-left[data-v-7d74e1ab] {\n  height: calc(100vh - 217px) !important;\n  width: calc(100% - 210px) !important;\n}\n#newQianniuExam .content .con-right[data-v-7d74e1ab] {\n  height: calc(100vh - 214px);\n  width: 200px;\n}\n#content-second .qnbox .nr1-1tb[data-v-7d74e1ab] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 352px;\n  left: 752px;\n  cursor: pointer;\n}\n#content-second .nr1_2input[data-v-7d74e1ab] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 352px;\n  left: 752px;\n  cursor: pointer;\n}\n#content-second .exclenrbox[data-v-7d74e1ab] {\n  width: 1060px;\n  height: 650px;\n  position: relative;\n}\n#content-second .qnbox .nr1-3tb[data-v-7d74e1ab] {\n  position: absolute;\n  width: 71px !important;\n  height: 15px !important;\n  top: 329px;\n  left: 38px;\n  cursor: pointer;\n}\n#content-second .qnbox .nr1_4input[data-v-7d74e1ab] {\n  position: absolute;\n  width: 71px !important;\n  height: 16px !important;\n  top: 370px;\n  left: 36px;\n  cursor: pointer;\n}\n#content-first .qnbox .qhtb1-1[data-v-7d74e1ab] {\n  position: absolute;\n  width: 18px !important;\n  height: 20px !important;\n  top: 620px;\n  left: 906px;\n  cursor: pointer;\n}\n#content-first .qnbox .qhtb1-2[data-v-7d74e1ab] {\n  position: absolute;\n  width: 15px !important;\n  height: 16px !important;\n  top: 622px;\n  left: 908px;\n  cursor: pointer;\n}\n#content-first .qnbox .qhtb1-3[data-v-7d74e1ab] {\n  position: absolute;\n  width: 298px !important;\n  height: 62px !important;\n  top: 424px;\n  left: 756px;\n  cursor: pointer;\n}\n#content-first .qnbox .qhtb1-4[data-v-7d74e1ab] {\n  position: absolute;\n  width: 296px !important;\n  height: 57px !important;\n  top: 428px;\n  left: 756px;\n  cursor: pointer;\n}\n#content-first .qnbox .jptb1-1[data-v-7d74e1ab] {\n  position: absolute;\n  width: 14px !important;\n  height: 16px !important;\n  top: 71px;\n  left: 496px;\n  cursor: pointer;\n}\n#content-first .qnbox .jptb1-2[data-v-7d74e1ab] {\n  position: absolute;\n  width: 19px !important;\n  height: 18px !important;\n  top: 70px;\n  left: 493px;\n  cursor: pointer;\n}\n#content-first .qnbox .jptb1-3[data-v-7d74e1ab] {\n  position: absolute;\n  width: 249px !important;\n  height: 71px !important;\n  top: 502px;\n  left: 453px;\n  cursor: pointer;\n}\n#content-first .qnbox .jptb1-4[data-v-7d74e1ab] {\n  position: absolute;\n  width: 84px !important;\n  height: 34px !important;\n  top: 539px;\n  left: 605px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-1[data-v-7d74e1ab] {\n  position: absolute;\n  width: 34px !important;\n  height: 31px !important;\n  top: 60px;\n  left: 337px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-2[data-v-7d74e1ab] {\n  position: absolute;\n  width: 34px !important;\n  height: 31px !important;\n  top: 59px;\n  left: 337px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-3[data-v-7d74e1ab] {\n  position: absolute;\n  width: 249px !important;\n  height: 516px !important;\n  top: 20px;\n  left: 112px;\n}\n#content-first .qnbox .kjtb1-4[data-v-7d74e1ab] {\n  position: absolute;\n  width: 63px !important;\n  height: 48px !important;\n  top: 438px;\n  left: 284px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-5[data-v-7d74e1ab] {\n  position: absolute;\n  width: 34px !important;\n  height: 16px !important;\n  top: 411px;\n  left: 143px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-6[data-v-7d74e1ab] {\n  position: absolute;\n  width: 31px !important;\n  height: 16px !important;\n  top: 411px;\n  left: 143px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-6-1_box[data-v-7d74e1ab] {\n  position: absolute;\n  width: 674px !important;\n  height: 456px !important;\n  top: 142px;\n  left: 298px;\n  overflow: auto;\n}\n#content-first .qnbox .kjtb1-6-1_box[data-v-7d74e1ab]::-webkit-scrollbar {\n  display: none !important;\n}\n#content-first .qnbox .kjtb1-6-1[data-v-7d74e1ab] {\n  width: 100% !important;\n  height: 746px !important;\n}\n#content-first .qnbox .kjtb1-7[data-v-7d74e1ab] {\n  position: absolute;\n  width: 617px !important;\n  height: 466px !important;\n  top: 133px;\n  left: 302px;\n}\n#content-first .qnbox .kjtb1-8[data-v-7d74e1ab] {\n  position: absolute;\n  width: 562px !important;\n  height: 37px !important;\n  top: 452px;\n  left: 47px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-9[data-v-7d74e1ab] {\n  position: absolute;\n  width: 613px !important;\n  height: 38px !important;\n  top: 297px;\n  left: 305px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-9-1[data-v-7d74e1ab] {\n  position: absolute;\n  width: 674px !important;\n  height: 472px !important;\n  top: 127px;\n  left: 298px;\n  overflow: auto;\n}\n#content-first .qnbox .kjtb1-9-1[data-v-7d74e1ab]::-webkit-scrollbar {\n  display: none;\n}\n#content-first .qnbox .kjtb1-10[data-v-7d74e1ab] {\n  width: 100% !important;\n  height: 682px !important;\n}\n#content-first .qnbox .kjtb1-11[data-v-7d74e1ab] {\n  position: absolute;\n  width: 606px !important;\n  height: 39px !important;\n  top: 466px;\n  left: 13px;\n  cursor: pointer;\n}\n#content-first .qnbox .kjtb1-12[data-v-7d74e1ab] {\n  position: absolute;\n  width: 17px !important;\n  height: 17px !important;\n  top: 389px;\n  left: 324px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-1[data-v-7d74e1ab] {\n  position: absolute;\n  width: 32px !important;\n  height: 15px !important;\n  top: 457px;\n  left: 157px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-2[data-v-7d74e1ab] {\n  position: absolute;\n  width: 31px !important;\n  height: 18px !important;\n  top: 457px;\n  left: 157px;\n  cursor: pointer;\n}\n#content-second .qnbox .qnbg1-3-1box[data-v-7d74e1ab] {\n  position: absolute;\n  width: 677px !important;\n  height: 472px !important;\n  top: 129px;\n  left: 308px;\n  overflow: auto;\n}\n#content-second .qnbox .qnbg1-3-1box[data-v-7d74e1ab]::-webkit-scrollbar {\n  display: none;\n}\n#content-second .qnbox .dytb1-3[data-v-7d74e1ab] {\n  width: 100% !important;\n  height: 700px !important;\n}\n#content-second .qnbox .dytb1-4[data-v-7d74e1ab] {\n  position: absolute;\n  width: 588px !important;\n  height: 39px !important;\n  top: 575px;\n  left: 31px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-5[data-v-7d74e1ab] {\n  position: absolute;\n  width: 614px !important;\n  height: 37px !important;\n  top: 477px;\n  left: 316px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-6[data-v-7d74e1ab] {\n  position: absolute;\n  width: 88px !important;\n  height: 21px !important;\n  top: 81px;\n  left: 843px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb1-7[data-v-7d74e1ab] {\n  position: absolute;\n  width: 87px !important;\n  height: 21px !important;\n  top: 81px;\n  left: 843px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_input[data-v-7d74e1ab] {\n  position: absolute;\n  width: 236px !important;\n  top: 218px;\n  left: 313px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_input[data-v-7d74e1ab] .el-input__inner {\n  height: 32px;\n}\n#content-second .qnbox .isShowdy1_7_textarea[data-v-7d74e1ab] {\n  position: absolute;\n  width: 450px !important;\n  top: 303px;\n  left: 313px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_textarea[data-v-7d74e1ab] .el-textarea__inner {\n  height: 114px !important;\n}\n#content-second .qnbox .dytb1-8[data-v-7d74e1ab] {\n  position: absolute;\n  width: 121px !important;\n  height: 25px !important;\n  top: 430px;\n  left: 317px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_select[data-v-7d74e1ab] {\n  position: absolute;\n  width: 111px !important;\n  height: 25px !important;\n  top: 220px;\n  left: 589px;\n  cursor: pointer;\n}\n#content-second .qnbox .isShowdy1_7_select[data-v-7d74e1ab] .el-input__inner {\n  background: #F5F7FC;\n  height: 28px;\n  border-color: #F5F7FC;\n}\n#content-second .qnbox .isShowdy1_7_select[data-v-7d74e1ab] .el-select .el-input .el-select__caret {\n  color: #000;\n  font-size: 13px;\n  font-weight: 500;\n}\n#content-second .qnbox .isShowdy1_7_select[data-v-7d74e1ab] .el-input__icon {\n  line-height: 38px;\n}\n#content-second .qnbox .dytb1-9[data-v-7d74e1ab] {\n  position: absolute;\n  width: 84px !important;\n  height: 26px !important;\n  top: 430px;\n  left: 582px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb2-1[data-v-7d74e1ab] {\n  position: absolute;\n  width: 237px !important;\n  height: 44px !important;\n  top: 457px;\n  left: 525px;\n  cursor: pointer;\n}\n#content-second .qnbox .dytb2-2[data-v-7d74e1ab] {\n  position: absolute;\n  width: 84px !important;\n  height: 24px !important;\n  top: 528px;\n  left: 568px;\n  cursor: pointer;\n}\n.mynone[data-v-7d74e1ab] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newQianniuExam" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_1,
                          expression: "isShowqh1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(902)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-1",
                        attrs: {
                          src: __webpack_require__(903)
                        },
                        on: { mousemove: _vm.showLoginqh1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_2,
                          expression: "isShowqh1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(904)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-2",
                        attrs: {
                          src: __webpack_require__(905)
                        },
                        on: { click: _vm.showLoginqh1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_3,
                          expression: "isShowqh1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(906)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-3",
                        attrs: {
                          src: __webpack_require__(907)
                        },
                        on: { mousemove: _vm.showLoginqh1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_4,
                          expression: "isShowqh1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(908)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qhtb1-4",
                        attrs: {
                          src: __webpack_require__(909)
                        },
                        on: { click: _vm.showLoginqh1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowqh1_5,
                          expression: "isShowqh1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(426)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_1,
                          expression: "isShowjp1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(426)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-1",
                        attrs: {
                          src: __webpack_require__(910)
                        },
                        on: { mousemove: _vm.showLoginjp1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_2,
                          expression: "isShowjp1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(911)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-2",
                        attrs: {
                          src: __webpack_require__(912)
                        },
                        on: { click: _vm.showLoginjp1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_3,
                          expression: "isShowjp1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(913)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-3",
                        attrs: {
                          src: __webpack_require__(427)
                        },
                        on: { mousemove: _vm.showLoginjp1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_4,
                          expression: "isShowjp1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(914)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-3",
                        attrs: {
                          src: __webpack_require__(427)
                        },
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.showLoginjp1_4($event)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_5,
                          expression: "isShowjp1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(915)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "jptb1-4",
                        attrs: {
                          src: __webpack_require__(916)
                        },
                        on: { click: _vm.showLoginjp1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowjp1_6,
                          expression: "isShowjp1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(917)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_1,
                          expression: "isShowkj1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(428)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-1",
                        attrs: {
                          src: __webpack_require__(429)
                        },
                        on: { mousemove: _vm.showLoginkj1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_2,
                          expression: "isShowkj1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(918)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-2",
                        attrs: {
                          src: __webpack_require__(429)
                        },
                        on: { click: _vm.showLoginkj1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_3,
                          expression: "isShowkj1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(428)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-3",
                        attrs: {
                          src: __webpack_require__(919)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-4",
                        attrs: {
                          src: __webpack_require__(920)
                        },
                        on: { click: _vm.showLoginkj1_3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_4,
                          expression: "isShowkj1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(921)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-5",
                        attrs: {
                          src: __webpack_require__(922)
                        },
                        on: { mousemove: _vm.showLoginkj1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_5,
                          expression: "isShowkj1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(923)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-6",
                        attrs: {
                          src: __webpack_require__(430)
                        },
                        on: { click: _vm.showLoginkj1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_6,
                          expression: "isShowkj1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(924)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-6",
                        attrs: {
                          src: __webpack_require__(430)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "kjtb1-6-1_box" }, [
                        _c("img", {
                          staticClass: "kjtb1-6-1",
                          attrs: {
                            src: __webpack_require__(925)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kjtb1-8",
                          attrs: {
                            src: __webpack_require__(926)
                          },
                          on: { mousemove: _vm.showLoginkj1_6 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_8,
                          expression: "isShowkj1_8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(927)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-9",
                        attrs: {
                          src: __webpack_require__(928)
                        },
                        on: { click: _vm.showLoginkj1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_9,
                          expression: "isShowkj1_9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(929)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "kjtb1-9-1" }, [
                        _c("img", {
                          staticClass: "kjtb1-10",
                          attrs: {
                            src: __webpack_require__(930)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kjtb1-11",
                          attrs: {
                            src: __webpack_require__(931)
                          },
                          on: { mousemove: _vm.showLoginkj1_9 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_11,
                          expression: "isShowkj1_11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(932)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "kjtb1-12",
                        attrs: {
                          src: __webpack_require__(933)
                        },
                        on: { click: _vm.showLoginkj1_10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowkj1_12,
                          expression: "isShowkj1_12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(934)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm.isShowqh1_1 ||
                  _vm.isShowqh1_2 ||
                  _vm.isShowqh1_3 ||
                  _vm.isShowqh1_4 ||
                  _vm.isShowqh1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("左侧练习场")]
                        ),
                        _vm._v("中，"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("右下角")]
                        ),
                        _vm._v("的输入法"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("切换")]
                        ),
                        _vm._v("为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("搜狗输入法")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjp1_1 ||
                  _vm.isShowjp1_2 ||
                  _vm.isShowjp1_3 ||
                  _vm.isShowjp1_4 ||
                  _vm.isShowjp1_5 ||
                  _vm.isShowjp1_6
                    ? _c("p", [
                        _vm._v("打开搜狗输入法的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("智能输入助手,")]
                        ),
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("截屏")]
                        ),
                        _vm._v("功能快捷方式设置到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        ),
                        _vm._v("上")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowkj1_1 ||
                  _vm.isShowkj1_2 ||
                  _vm.isShowkj1_3 ||
                  _vm.isShowkj1_4 ||
                  _vm.isShowkj1_5 ||
                  _vm.isShowkj1_6 ||
                  _vm.isShowkj1_8 ||
                  _vm.isShowkj1_9 ||
                  _vm.isShowkj1_10 ||
                  _vm.isShowkj1_11 ||
                  _vm.isShowkj1_12
                    ? _c("p", [
                        _vm._v("在搜狗输入法的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("菜单")]
                        ),
                        _vm._v("中，将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("截屏")]
                        ),
                        _vm._v("的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("设置为Ctrl+Alt+Q")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_1,
                          expression: "isShowdy1_1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(935)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-1",
                        attrs: {
                          src: __webpack_require__(936)
                        },
                        on: { mousemove: _vm.showLogindy1_1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_2,
                          expression: "isShowdy1_2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(937)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-2",
                        attrs: {
                          src: __webpack_require__(938)
                        },
                        on: { click: _vm.showLogindy1_2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_3,
                          expression: "isShowdy1_3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(939)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "qnbg1-3-1box" }, [
                        _c("img", {
                          staticClass: "dytb1-3",
                          attrs: {
                            src: __webpack_require__(940)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "dytb1-4",
                          attrs: {
                            src: __webpack_require__(941)
                          },
                          on: { mousemove: _vm.showLogindy1_3 }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_4,
                          expression: "isShowdy1_4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(942)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-5",
                        attrs: {
                          src: __webpack_require__(943)
                        },
                        on: { click: _vm.showLogindy1_4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_5,
                          expression: "isShowdy1_5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(944)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-6",
                        attrs: {
                          src: __webpack_require__(945)
                        },
                        on: { mousemove: _vm.showLogindy1_5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_6,
                          expression: "isShowdy1_6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(946)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-7",
                        attrs: {
                          src: __webpack_require__(947)
                        },
                        on: { click: _vm.showLogindy1_6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_7,
                          expression: "isShowdy1_7"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(948)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_input" },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.isShowdy1_7_input,
                              callback: function($$v) {
                                _vm.isShowdy1_7_input = $$v
                              },
                              expression: "isShowdy1_7_input"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_textarea" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              resize: "none"
                            },
                            model: {
                              value: _vm.isShowdy1_7_textarea,
                              callback: function($$v) {
                                _vm.isShowdy1_7_textarea = $$v
                              },
                              expression: "isShowdy1_7_textarea"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-8",
                        attrs: {
                          src: __webpack_require__(949)
                        },
                        on: { click: _vm.showLogindy1_7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_8,
                          expression: "isShowdy1_8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(950)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_input" },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.isShowdy1_7_input,
                              callback: function($$v) {
                                _vm.isShowdy1_7_input = $$v
                              },
                              expression: "isShowdy1_7_input"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_textarea" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              resize: "none"
                            },
                            model: {
                              value: _vm.isShowdy1_7_textarea,
                              callback: function($$v) {
                                _vm.isShowdy1_7_textarea = $$v
                              },
                              expression: "isShowdy1_7_textarea"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "isShowdy1_7_select" },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.isShowdy1_7_select,
                                callback: function($$v) {
                                  _vm.isShowdy1_7_select = $$v
                                },
                                expression: "isShowdy1_7_select"
                              }
                            },
                            _vm._l(_vm.isShowdy1_7_selectopint, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb1-9",
                        attrs: {
                          src: __webpack_require__(951)
                        },
                        on: { click: _vm.showLogindy1_8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_9,
                          expression: "isShowdy1_9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(952)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_10,
                          expression: "isShowdy1_10"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(953)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_11,
                          expression: "isShowdy1_11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(954)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-1",
                        attrs: {
                          src: __webpack_require__(431)
                        },
                        on: { mousemove: _vm.showLogindy1_10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_12,
                          expression: "isShowdy1_12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(955)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-1",
                        attrs: {
                          src: __webpack_require__(431)
                        },
                        on: { click: _vm.showLogindy1_11 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_13,
                          expression: "isShowdy1_13"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(956)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "dytb2-2",
                        attrs: {
                          src: __webpack_require__(957)
                        },
                        on: { click: _vm.showLogindy1_12 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowdy1_14,
                          expression: "isShowdy1_14"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(958)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm.isShowdy1_1 ||
                  _vm.isShowdy1_2 ||
                  _vm.isShowdy1_3 ||
                  _vm.isShowdy1_4 ||
                  _vm.isShowdy1_5 ||
                  _vm.isShowdy1_6
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语:"),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t\t缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t\t内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开3分钟")]
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t\t\t点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定并继续添加")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_7
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语："),
                        _c("br"),
                        _vm._v("缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开3分钟")]
                        ),
                        _c("br"),
                        _vm._v("点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定并继续添加")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_8 || _vm.isShowdy1_9
                    ? _c("p", [
                        _vm._v("按照以下要求添加短语："),
                        _c("br"),
                        _vm._v("缩写："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _c("br"),
                        _vm._v("候选位置："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2")]
                        ),
                        _c("br"),
                        _vm._v("内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("报备：去上厕所，离开5分钟")]
                        ),
                        _c("br"),
                        _vm._v("点击"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("确定")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdy1_10 ||
                  _vm.isShowdy1_11 ||
                  _vm.isShowdy1_12 ||
                  _vm.isShowdy1_13 ||
                  _vm.isShowdy1_14
                    ? _c("p", [
                        _vm._v("在聊天输入框中输入"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("bb")]
                        ),
                        _vm._v("，调出快捷短语，选择离开"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("5分钟")]
                        ),
                        _vm._v("的短语，并"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("发送")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-second" } },
                  [_vm._m(3)]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、搜狗输入法的截屏功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、搜狗输入法的快捷短语")
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip" }, [
      _c("span", { staticClass: "el-icon-success" }),
      _vm._v(" "),
      _c("p", [_vm._v("你已完成搜狗输入法的功能学习")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "startstudy",
          staticStyle: { width: "160px" },
          attrs: { href: "/tjkStudy/simulate/newqianniuexam" }
        },
        [_vm._v("去观看下载视频")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d74e1ab", esExports)
  }
}

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_training_vue__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_training_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_training_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_training_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_training_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32be8b33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_training_vue__ = __webpack_require__(1681);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1679)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32be8b33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_training_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32be8b33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_training_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/flying/training.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32be8b33", Component.options)
  } else {
    hotAPI.reload("data-v-32be8b33", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1680);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("26382e3c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32be8b33\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./training.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32be8b33\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./training.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-32be8b33] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-32be8b33] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.blod-span[data-v-32be8b33] {\n  color: red;\n  font-weight: bold;\n}\n", ""]);

// exports


/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "feiGe" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("1、登录飞鸽工作台")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2023-02/385cc51762b74eb985d3ab9b39f0925a.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(179)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        on: { mouseenter: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(180)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        attrs: { id: "select" },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowIcon3
                    ? _c("div", { staticClass: "qnbox" }, [
                        _c("img", {
                          staticClass: "qnbg left-img",
                          attrs: {
                            src: __webpack_require__(181)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "fgicon03",
                          on: { click: _vm.showLoginImg3 }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon4,
                          expression: "isShowIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(182)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon04",
                        on: { mouseenter: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon5,
                          expression: "isShowIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(183)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon05",
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon6,
                          expression: "isShowIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(184)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon06",
                        on: { click: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon7,
                          expression: "isShowIcon7"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(185)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon07",
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon8,
                          expression: "isShowIcon8"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(186)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.password,
                            expression: "password",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon08",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin1,
                          expression: "isShowLogin1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(187)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { mouseenter: _vm.loginIn1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin2,
                          expression: "isShowLogin2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(188)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { click: _vm.loginIn2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin3,
                          expression: "isShowLogin3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(189)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            return _vm.loginIn3.apply(null, arguments)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin4,
                          expression: "isShowLogin4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(190)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon10",
                        on: { click: _vm.loginIn4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin5,
                          expression: "isShowLogin5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(191)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请打开"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("左侧练习场")
                          ]),
                          _vm._v("中的飞鸽客服工作台")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon3
                      ? [
                          _c("p", [
                            _vm._v("选择"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("我是商家")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon4 || _vm.isShowIcon5
                      ? [
                          _c("p", [
                            _vm._v("点击右上角的电脑图标，切换为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("手机号登录")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon6 || _vm.isShowIcon7 || _vm.isShowIcon8
                      ? [
                          _c("p", [
                            _vm._v("注意："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("正式任务")
                            ]),
                            _vm._v("需提前将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("自己的手机号")
                            ]),
                            _vm._v("反馈给主管开通账号！")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("假设练习场"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("账号为：13853678478")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("验证码为：3346")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin1 || _vm.isShowLogin2
                      ? [
                          _c("p", [
                            _vm._v("鼠标"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("左键")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("第2个")
                            ]),
                            _vm._v("店铺，切换到第2个店铺")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin3 || _vm.isShowLogin4
                      ? [
                          _c("p", [
                            _vm._v("鼠标"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("右键")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("第2个")
                            ]),
                            _vm._v("店铺，"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("退出店铺")
                            ]),
                            _vm._v("铺")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("登录飞鸽.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、基础设置（上）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2023-02/ffe43489dcdf458cb1df730725770806.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp,
                          expression: "isShowSetUp"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(192)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon01",
                        on: { click: _vm.setUp }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp1,
                          expression: "isShowSetUp1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(193)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { mouseenter: _vm.setUp1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp2,
                          expression: "isShowSetUp2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(194)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { click: _vm.setUp2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp3,
                          expression: "isShowSetUp3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(195)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon03",
                        on: { click: _vm.setUp3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp4,
                          expression: "isShowSetUp4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(196)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { mouseenter: _vm.setUp4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp5,
                          expression: "isShowSetUp5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(197)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { click: _vm.setUp5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp6,
                          expression: "isShowSetUp6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(198)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { mouseenter: _vm.setUp6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp7,
                          expression: "isShowSetUp7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(199)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { click: _vm.setUp7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp8,
                          expression: "isShowSetUp8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(200)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { mouseenter: _vm.setUp8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp9,
                          expression: "isShowSetUp9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(201)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { click: _vm.setUp9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp10,
                          expression: "isShowSetUp10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                            提示\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isShowSetUp || _vm.isShowSetUp1 || _vm.isShowSetUp2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("在线")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp3 || _vm.isShowSetUp4 || _vm.isShowSetUp5
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("小休")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp6 ||
                  _vm.isShowSetUp7 ||
                  _vm.isShowSetUp8 ||
                  _vm.isShowSetUp9
                    ? _c("p", [
                        _vm._v("请将当前会话的接待排序设置为：按"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("等待时长")
                        ]),
                        _vm._v("由长到短排序")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySecond }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("基础设置（上）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt1
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt1(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt1 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer1" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、基础设置（下）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://res.study.itaojin.cn/2023-02/9154da85cd3b4f718d49e1502dd0d96e.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown,
                          expression: "isShowSetDown"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown1,
                          expression: "isShowSetDown1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(202)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          click: function($event) {
                            return _vm.setDown1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown2,
                          expression: "isShowSetDown2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(203)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown3,
                          expression: "isShowSetDown3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(204)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          click: function($event) {
                            return _vm.setDown3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown4,
                          expression: "isShowSetDown4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(205)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown5,
                          expression: "isShowSetDown5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(206)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          click: function($event) {
                            return _vm.setDown5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown6,
                          expression: "isShowSetDown6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(207)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown7,
                          expression: "isShowSetDown7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(208)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown033",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown8,
                          expression: "isShowSetDown8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(209)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown9,
                          expression: "isShowSetDown9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(210)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          click: function($event) {
                            return _vm.setDown9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown10,
                          expression: "isShowSetDown10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(211)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown05",
                        on: {
                          click: function($event) {
                            return _vm.setDown10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown11,
                          expression: "isShowSetDown11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(212)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dyInput,
                            expression: "dyInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dyInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.dyInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dyInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown06",
                        on: {
                          click: function($event) {
                            return _vm.setDown11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown12,
                          expression: "isShowSetDown12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(213)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown13,
                          expression: "isShowSetDown13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(214)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          click: function($event) {
                            return _vm.setDown13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown14,
                          expression: "isShowSetDown14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(215)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown14()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown15,
                          expression: "isShowSetDown15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown16,
                          expression: "isShowSetDown16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown17,
                          expression: "isShowSetDown17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown18,
                          expression: "isShowSetDown18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown19()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown19,
                          expression: "isShowSetDown19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(216)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          click: function($event) {
                            return _vm.setDown20()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown20,
                          expression: "isShowSetDown20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(217)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown21,
                          expression: "isShowSetDown21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(218)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown22()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown22,
                          expression: "isShowSetDown22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(219)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          click: function($event) {
                            return _vm.setDown23()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown23,
                          expression: "isShowSetDown23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(220)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown24()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown24,
                          expression: "isShowSetDown24"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(221)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          click: function($event) {
                            return _vm.setDown25()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown25,
                          expression: "isShowSetDown25"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(222)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown12",
                        on: {
                          click: function($event) {
                            return _vm.setDown26()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown26,
                          expression: "isShowSetDown26"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(223)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown13",
                        on: {
                          click: function($event) {
                            return _vm.setDown27()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown27,
                          expression: "isShowSetDown27"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(224)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown14",
                        on: {
                          click: function($event) {
                            return _vm.setDown28()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown28,
                          expression: "isShowSetDown28"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(225)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown29()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown29,
                          expression: "isShowSetDown29"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(226)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          click: function($event) {
                            return _vm.setDown30()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown30,
                          expression: "isShowSetDown30"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(227)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown31,
                          expression: "isShowSetDown31"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(228)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown32()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown32,
                          expression: "isShowSetDown32"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(229)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          click: function($event) {
                            return _vm.setDown33()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown33,
                          expression: "isShowSetDown33"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(230)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown17",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown34()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowSetDown34
                    ? _c("div", { staticClass: "szbox" }, [
                        _c("img", {
                          staticClass: "szbg",
                          attrs: {
                            src: __webpack_require__(231)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "btn-file",
                          attrs: { type: "file" },
                          on: {
                            change: function($event) {
                              return _vm.tirggerFile($event)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown35,
                          expression: "isShowSetDown35"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(232)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown36()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown36,
                          expression: "isShowSetDown36"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(233)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          click: function($event) {
                            return _vm.setDown37()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown37,
                          expression: "isShowSetDown37"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(234)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown38,
                          expression: "isShowSetDown38"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(235)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown39()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown39,
                          expression: "isShowSetDown39"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(236)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          click: function($event) {
                            return _vm.setDown40()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown40,
                          expression: "isShowSetDown40"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown41()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown41,
                          expression: "isShowSetDown41"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(237)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          click: function($event) {
                            return _vm.setDown42()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown42,
                          expression: "isShowSetDown42"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown43()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown43()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown43,
                          expression: "isShowSetDown43"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown431,
                          expression: "isShowSetDown431"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal,
                            expression: "duanyuInputVal",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal = $event.target.value.trim()
                            },
                            _vm.duanyuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown432,
                          expression: "isShowSetDown432"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown432()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown432()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown433,
                          expression: "isShowSetDown433"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown434,
                          expression: "isShowSetDown434"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal1,
                            expression: "duanyuInputVal1",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal1 },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal1 = $event.target.value.trim()
                            },
                            _vm.duanyuInput1
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown44,
                          expression: "isShowSetDown44"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(238)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown45()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown45,
                          expression: "isShowSetDown45"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(239)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          click: function($event) {
                            return _vm.setDown46()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown451,
                          expression: "isShowSetDown451"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown461()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown461()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown452,
                          expression: "isShowSetDown452"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSetDown ||
                    _vm.isShowSetDown1 ||
                    _vm.isShowSetDown2 ||
                    _vm.isShowSetDown3
                      ? _c("p", [
                          _vm._v("请从"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服管理")
                          ]),
                          _vm._v("进入"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服工具")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown4 || _vm.isShowSetDown5
                      ? _c("p", [
                          _vm._v("选择客服工具中的"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("快捷短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown6 || _vm.isShowSetDown7
                      ? _c("p", [
                          _vm._v("点击"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新建短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown8 ||
                    _vm.isShowSetDown9 ||
                    _vm.isShowSetDown10 ||
                    _vm.isShowSetDown11
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新增")
                          ]),
                          _vm._v("一个"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown12 || _vm.isShowSetDown13
                      ? _c("p", [
                          _vm._v("选择"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown14 ||
                    _vm.isShowSetDown15 ||
                    _vm.isShowSetDown16 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown18 ||
                    _vm.isShowSetDown19
                      ? [
                          _c("p", [
                            _vm._v("添加催单短语内容："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("亲亲，喜欢的话就下单吧，早拍早发货哦！")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("编码短语设置为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("催单")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("确定")
                            ]),
                            _vm._v("按钮进行保存")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown20 ||
                    _vm.isShowSetDown21 ||
                    _vm.isShowSetDown22
                      ? [
                          _c("p", [
                            _vm._v("请点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("模板库导入")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown23 ||
                    _vm.isShowSetDown24 ||
                    _vm.isShowSetDown25 ||
                    _vm.isShowSetDown26 ||
                    _vm.isShowSetDown27 ||
                    _vm.isShowSetDown28 ||
                    _vm.isShowSetDown29
                      ? [
                          _c("p", [
                            _vm._v("请将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("分组")
                            ]),
                            _vm._v("设置为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("问候语")
                            ]),
                            _vm._v("，并选择"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("前面2条")
                            ]),
                            _vm._v("快捷问候语；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("确定导入")
                            ]),
                            _vm._v("按钮")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown30 ||
                    _vm.isShowSetDown31 ||
                    _vm.isShowSetDown32 ||
                    _vm.isShowSetDown33 ||
                    _vm.isShowSetDown34 ||
                    _vm.isShowSetDown35 ||
                    _vm.isShowSetDown36
                      ? [
                          _c("p", [
                            _vm._v("1.先"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("下载下方的飞鸽快捷短语")
                            ]),
                            _vm._v("表格；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("2.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("批量导入")
                            ]),
                            _vm._v("按钮；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("3.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("添加文件")
                            ]),
                            _vm._v(
                              "，选择下载的飞鸽快捷短语表格（可以先将下载的表格另存到桌面上，方便导入时快速找到表格）；"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("4.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("导入")
                            ]),
                            _vm._v("按钮；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“飞鸽快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown37 ||
                    _vm.isShowSetDown38 ||
                    _vm.isShowSetDown39
                      ? [
                          _c("p", [
                            _vm._v("点击右侧的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("快捷短语；")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown40 ||
                    _vm.isShowSetDown41 ||
                    _vm.isShowSetDown42
                      ? [
                          _c("p", [
                            _vm._v("请采用"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("鼠标左键")
                            ]),
                            _vm._v(
                              "点击快捷短语的方式，给当前用户发送欢迎语："
                            ),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown43 ||
                    _vm.isShowSetDown431 ||
                    _vm.isShowSetDown432 ||
                    _vm.isShowSetDown433
                      ? [
                          _c("p", [
                            _vm._v("请采用输入"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("/您好")
                            ]),
                            _vm._v("的方式，给当前用户发送欢迎语："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown434 ||
                    _vm.isShowSetDown44 ||
                    _vm.isShowSetDown45 ||
                    _vm.isShowSetDown451 ||
                    _vm.isShowSetDown452
                      ? [
                          _c("p", [
                            _vm._v("请采用输入文本"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("您好")
                            ]),
                            _vm._v("的方式，给当前用户发送欢迎语："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyThird }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("基础设置（下）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("3、会话窗口")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://res.study.itaojin.cn/2023-02/b1da8c11184d4b1da68389bc7e89f0f8.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession,
                          expression: "isShowSession"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(240) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession1,
                          expression: "isShowSession1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(241) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          click: function($event) {
                            return _vm.four1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession2,
                          expression: "isShowSession2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(242) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession3,
                          expression: "isShowSession3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(243) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          click: function($event) {
                            return _vm.four3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession4,
                          expression: "isShowSession4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(244) }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSession ||
                    _vm.isShowSession1 ||
                    _vm.isShowSession2 ||
                    _vm.isShowSession3 ||
                    _vm.isShowSession4
                      ? [
                          _c("p", [
                            _vm._v("请将当前用户"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("转接")
                            ]),
                            _vm._v("给"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("军瑞")
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFour }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("会话窗口.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt3
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt3(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt3 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("4、商品插件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://res.study.itaojin.cn/2023-02/09572dc3445b4b06871354236e70b454.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(245) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive1,
                          expression: "isShowFive1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(246) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          click: function($event) {
                            return _vm.five1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive2,
                          expression: "isShowFive2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(247) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive3,
                          expression: "isShowFive3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(248) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          click: function($event) {
                            return _vm.five3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive4,
                          expression: "isShowFive4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(249) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive5,
                          expression: "isShowFive5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(250)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive6,
                          expression: "isShowFive6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(251)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          click: function($event) {
                            return _vm.five6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive7,
                          expression: "isShowFive7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(252) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive8,
                          expression: "isShowFive8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(253) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          click: function($event) {
                            return _vm.five8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive9,
                          expression: "isShowFive9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(254) }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowFive ||
                    _vm.isShowFive1 ||
                    _vm.isShowFive2 ||
                    _vm.isShowFive3 ||
                    _vm.isShowFive4
                      ? [
                          _c("p", [
                            _vm._v("请点击商品插件，将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("全部商品")
                            ]),
                            _vm._v("中"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("销量最高")
                            ]),
                            _vm._v("的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("腰带")
                            ]),
                            _vm._v("链接发送给用户")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowFive5 ||
                    _vm.isShowFive6 ||
                    _vm.isShowFive7 ||
                    _vm.isShowFive8 ||
                    _vm.isShowFive9
                      ? [
                          _c("p", [
                            _vm._v("请将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("浏览足迹")
                            ]),
                            _vm._v("中"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("销量最高")
                            ]),
                            _vm._v("的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("腰带")
                            ]),
                            _vm._v("链接发送给用户")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFive }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("商品插件.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt4
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt4(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt4 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("5、订单插件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://res.study.itaojin.cn/2023-02/b2b06910e7194460875ed8c6ed04e312.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(255)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix1,
                          expression: "isShowSix1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(256)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          click: function($event) {
                            return _vm.six1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix2,
                          expression: "isShowSix2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(257)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.beizhu,
                            expression: "beizhu",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "beizhu",
                        domProps: { value: _vm.beizhu },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.beizhu = $event.target.value.trim()
                            },
                            _vm.beiZhuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six033",
                        on: {
                          click: function($event) {
                            return _vm.six122()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix3,
                          expression: "isShowSix3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(258)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six02",
                        on: {
                          click: function($event) {
                            return _vm.six3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix4,
                          expression: "isShowSix4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(259)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix5,
                          expression: "isShowSix5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(260)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix6,
                          expression: "isShowSix6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(261)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix7,
                          expression: "isShowSix7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(262)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix8,
                          expression: "isShowSix8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(263)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          click: function($event) {
                            return _vm.six7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix9,
                          expression: "isShowSix9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(264)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix10,
                          expression: "isShowSix10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(265)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix11,
                          expression: "isShowSix11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(266)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          click: function($event) {
                            return _vm.six9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix12,
                          expression: "isShowSix12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(267)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix13,
                          expression: "isShowSix13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(268)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix14,
                          expression: "isShowSix14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(269)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          click: function($event) {
                            return _vm.six11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix15,
                          expression: "isShowSix15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(270)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yjgj,
                            expression: "yjgj",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yjgj",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yjgj },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yjgj = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yfInput,
                            expression: "yfInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yfInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yfInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yfInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix16,
                          expression: "isShowSix16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(271)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          click: function($event) {
                            return _vm.six13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix17,
                          expression: "isShowSix17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(272)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix18,
                          expression: "isShowSix18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(273)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six14()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix19,
                          expression: "isShowSix19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(274)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          click: function($event) {
                            return _vm.six15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix20,
                          expression: "isShowSix20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(275)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six081",
                        on: {
                          click: function($event) {
                            return _vm.six16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix21,
                          expression: "isShowSix21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(276)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.sjhm,
                            expression: "sjhm",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "sjhm",
                        attrs: { type: "text" },
                        domProps: { value: _vm.sjhm },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.sjhm = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix22,
                          expression: "isShowSix22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(277)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          click: function($event) {
                            return _vm.six18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix23,
                          expression: "isShowSix23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(278)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSix ||
                    _vm.isShowSix1 ||
                    _vm.isShowSix2 ||
                    _vm.isShowSix3 ||
                    _vm.isShowSix4 ||
                    _vm.isShowSix5 ||
                    _vm.isShowSix6
                      ? [
                          _c("p", [
                            _vm._v("假设此商家规定"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("红色彩旗跟发货相关")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("请给该用户添加"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("备注")
                            ]),
                            _vm._v("内容："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("用户要求发顺丰")
                            ]),
                            _vm._v("并"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("选择对应的彩旗")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix7 || _vm.isShowSix8 || _vm.isShowSix9
                      ? [
                          _c("p", [
                            _vm._v("请给用户发送"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("核对地址")
                            ]),
                            _vm._v("卡片")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix10 || _vm.isShowSix11 || _vm.isShowSix12
                      ? [
                          _c("p", [
                            _vm._v("请给用户发送订单"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("催付")
                            ]),
                            _vm._v("卡片")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix13 ||
                    _vm.isShowSix14 ||
                    _vm.isShowSix15 ||
                    _vm.isShowSix16 ||
                    _vm.isShowSix17
                      ? [
                          _c("p", [
                            _vm._v("请采用"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("一键改价")
                            ]),
                            _vm._v("方式，将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("最终实付价")
                            ]),
                            _vm._v("改为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("48")
                            ]),
                            _vm._v("元，"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("运费")
                            ]),
                            _vm._v("改为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("10")
                            ]),
                            _vm._v("元")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix18 ||
                    _vm.isShowSix19 ||
                    _vm.isShowSix20 ||
                    _vm.isShowSix21 ||
                    _vm.isShowSix22 ||
                    _vm.isShowSix23
                      ? [
                          _c("p", [
                            _vm._v("请在"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("改地址")
                            ]),
                            _vm._v("中，将用户的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("手机号码")
                            ]),
                            _vm._v("改成"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("13512345678")
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySix }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("订单插件.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt5
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt5(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt5 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、退出飞鸽")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src:
                        "http://res.study.itaojin.cn/2023-02/bb58cf754fc24605ac2e993b864565ce.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven,
                          expression: "isShowSeven"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(279) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven1,
                          expression: "isShowSeven1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(280) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven2,
                          expression: "isShowSeven2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(281) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          click: function($event) {
                            return _vm.seven2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven3,
                          expression: "isShowSeven3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(282) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven4,
                          expression: "isShowSeven4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(283) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven03",
                        on: {
                          click: function($event) {
                            return _vm.seven4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven5,
                          expression: "isShowSeven5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(284) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven6,
                          expression: "isShowSeven6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(285) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          click: function($event) {
                            return _vm.seven6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven7,
                          expression: "isShowSeven7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(286) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven8,
                          expression: "isShowSeven8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(287) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          click: function($event) {
                            return _vm.seven8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven9,
                          expression: "isShowSeven9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(288)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven10,
                          expression: "isShowSeven10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(289)
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("img", {
                            staticClass: "small-img",
                            attrs: {
                              src: __webpack_require__(290)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven06",
                            on: {
                              contextmenu: function($event) {
                                $event.preventDefault()
                                return _vm.seven10()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven07",
                            on: {
                              click: function($event) {
                                return _vm.seven11()
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven11,
                          expression: "isShowSeven11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(291)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSeven || _vm.isShowSeven1 || _vm.isShowSeven2
                      ? [
                          _c("p", [
                            _vm._v("请将状态切换为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("小休")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven3 || _vm.isShowSeven4
                      ? [
                          _c("p", [
                            _vm._v("请将状态切换为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("离线")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven5 || _vm.isShowSeven6
                      ? [
                          _c("p", [
                            _vm._v("请关闭"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("接待页面")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven7 || _vm.isShowSeven8
                      ? [_c("p", [_vm._v("请点击右下方显示隐藏的图标")])]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven9 || _vm.isShowSeven10 || _vm.isShowSeven11
                      ? [_c("p", [_vm._v("右键点击飞鸽小图标")])]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成飞鸽的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《飞鸽模拟实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px" },
                          attrs: { href: "/tjkStudy/feiGeTrainexam" }
                        },
                        [_vm._v("去完成飞鸽模拟实操")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("退出飞鸽.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt6(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt6 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32be8b33", esExports)
  }
}

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_vue__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62610818_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feiGeTrainexam_vue__ = __webpack_require__(1685);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1683)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62610818"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62610818_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feiGeTrainexam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/flying/feiGeTrainexam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62610818", Component.options)
  } else {
    hotAPI.reload("data-v-62610818", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1684);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8c718f54", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62610818\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./feiGeTrainexam.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62610818\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./feiGeTrainexam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-62610818] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-62610818] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.blod-span[data-v-62610818] {\n  color: red;\n  font-weight: bold;\n}\n.mynone[data-v-62610818] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "feiGeExam" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(179)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        on: { mouseenter: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(180)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        attrs: { id: "select" },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon3,
                          expression: "isShowIcon3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(181)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon03",
                        on: { click: _vm.showLoginImg3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon4,
                          expression: "isShowIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(182)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon04",
                        on: { mouseenter: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon5,
                          expression: "isShowIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(183)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon05",
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon6,
                          expression: "isShowIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(184)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon06",
                        on: { click: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon7,
                          expression: "isShowIcon7"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(185)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon07",
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon8,
                          expression: "isShowIcon8"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(186)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.password,
                            expression: "password",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon08",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin1,
                          expression: "isShowLogin1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(187)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { mouseenter: _vm.loginIn1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin2,
                          expression: "isShowLogin2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(188)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { click: _vm.loginIn2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin3,
                          expression: "isShowLogin3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(189)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            return _vm.loginIn3.apply(null, arguments)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin4,
                          expression: "isShowLogin4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(190)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon10",
                        on: { click: _vm.loginIn4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin5,
                          expression: "isShowLogin5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(191)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请打开"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("左侧练习场")
                          ]),
                          _vm._v("中的飞鸽客服工作台")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon3 ? [_vm._m(2)] : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon4 || _vm.isShowIcon5 ? [_vm._m(3)] : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon6 || _vm.isShowIcon7 || _vm.isShowIcon8
                      ? [
                          _vm._m(4),
                          _vm._v(" "),
                          _vm._m(5),
                          _vm._v(" "),
                          _vm._m(6)
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin1 || _vm.isShowLogin2
                      ? [_vm._m(7)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin3 || _vm.isShowLogin4
                      ? [_vm._m(8)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp,
                          expression: "isShowSetUp"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(192)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon01",
                        on: { click: _vm.setUp }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp1,
                          expression: "isShowSetUp1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(193)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { mouseenter: _vm.setUp1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp2,
                          expression: "isShowSetUp2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(194)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { click: _vm.setUp2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp3,
                          expression: "isShowSetUp3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(195)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon03",
                        on: { click: _vm.setUp3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp4,
                          expression: "isShowSetUp4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(196)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { mouseenter: _vm.setUp4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp5,
                          expression: "isShowSetUp5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(197)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { click: _vm.setUp5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp6,
                          expression: "isShowSetUp6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(198)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { mouseenter: _vm.setUp6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp7,
                          expression: "isShowSetUp7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(199)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { click: _vm.setUp7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp8,
                          expression: "isShowSetUp8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(200)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { mouseenter: _vm.setUp8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp9,
                          expression: "isShowSetUp9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(201)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { click: _vm.setUp9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp10,
                          expression: "isShowSetUp10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _vm.isShowSetUp || _vm.isShowSetUp1 || _vm.isShowSetUp2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("在线")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp3 || _vm.isShowSetUp4 || _vm.isShowSetUp5
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("小休")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp6 ||
                  _vm.isShowSetUp7 ||
                  _vm.isShowSetUp8 ||
                  _vm.isShowSetUp9
                    ? _c("p", [
                        _vm._v("请将当前会话的接待排序设置为：按"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("等待时长")
                        ]),
                        _vm._v("由长到短排序")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown,
                          expression: "isShowSetDown"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown1,
                          expression: "isShowSetDown1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(202)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          click: function($event) {
                            return _vm.setDown1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown2,
                          expression: "isShowSetDown2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(203)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown3,
                          expression: "isShowSetDown3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(204)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          click: function($event) {
                            return _vm.setDown3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown4,
                          expression: "isShowSetDown4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(205)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown5,
                          expression: "isShowSetDown5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(206)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          click: function($event) {
                            return _vm.setDown5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown6,
                          expression: "isShowSetDown6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(207)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown7,
                          expression: "isShowSetDown7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(208)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown033",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown8,
                          expression: "isShowSetDown8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(209)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown9,
                          expression: "isShowSetDown9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(210)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          click: function($event) {
                            return _vm.setDown9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown10,
                          expression: "isShowSetDown10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(211)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown05",
                        on: {
                          click: function($event) {
                            return _vm.setDown10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown11,
                          expression: "isShowSetDown11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(212)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dyInput,
                            expression: "dyInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dyInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.dyInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dyInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown06",
                        on: {
                          click: function($event) {
                            return _vm.setDown11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown12,
                          expression: "isShowSetDown12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(213)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown13,
                          expression: "isShowSetDown13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(214)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          click: function($event) {
                            return _vm.setDown13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown14,
                          expression: "isShowSetDown14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(215)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown14()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown15,
                          expression: "isShowSetDown15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown16,
                          expression: "isShowSetDown16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown17,
                          expression: "isShowSetDown17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown18,
                          expression: "isShowSetDown18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown19()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown19,
                          expression: "isShowSetDown19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(216)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          click: function($event) {
                            return _vm.setDown20()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown20,
                          expression: "isShowSetDown20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(217)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown21,
                          expression: "isShowSetDown21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(218)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown22()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown22,
                          expression: "isShowSetDown22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(219)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          click: function($event) {
                            return _vm.setDown23()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown23,
                          expression: "isShowSetDown23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(220)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown24()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown24,
                          expression: "isShowSetDown24"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(221)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          click: function($event) {
                            return _vm.setDown25()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown25,
                          expression: "isShowSetDown25"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(222)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown12",
                        on: {
                          click: function($event) {
                            return _vm.setDown26()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown26,
                          expression: "isShowSetDown26"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(223)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown13",
                        on: {
                          click: function($event) {
                            return _vm.setDown27()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown27,
                          expression: "isShowSetDown27"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(224)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown14",
                        on: {
                          click: function($event) {
                            return _vm.setDown28()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown28,
                          expression: "isShowSetDown28"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(225)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown29()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown29,
                          expression: "isShowSetDown29"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(226)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          click: function($event) {
                            return _vm.setDown30()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown30,
                          expression: "isShowSetDown30"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(227)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown31,
                          expression: "isShowSetDown31"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(228)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown32()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown32,
                          expression: "isShowSetDown32"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(229)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          click: function($event) {
                            return _vm.setDown33()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown33,
                          expression: "isShowSetDown33"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(230)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown17",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown34()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowSetDown34
                    ? _c("div", { staticClass: "szbox" }, [
                        _c("img", {
                          staticClass: "szbg",
                          attrs: {
                            src: __webpack_require__(231)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "btn-file",
                          attrs: { type: "file" },
                          on: {
                            change: function($event) {
                              return _vm.tirggerFile($event)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown35,
                          expression: "isShowSetDown35"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(232)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown36()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown36,
                          expression: "isShowSetDown36"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(233)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          click: function($event) {
                            return _vm.setDown37()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown37,
                          expression: "isShowSetDown37"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(234)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown38,
                          expression: "isShowSetDown38"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(235)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown39()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown39,
                          expression: "isShowSetDown39"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(236)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          click: function($event) {
                            return _vm.setDown40()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown40,
                          expression: "isShowSetDown40"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown41()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown41,
                          expression: "isShowSetDown41"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(237)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          click: function($event) {
                            return _vm.setDown42()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown42,
                          expression: "isShowSetDown42"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown43()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown43()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown43,
                          expression: "isShowSetDown43"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown431,
                          expression: "isShowSetDown431"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal,
                            expression: "duanyuInputVal",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal = $event.target.value.trim()
                            },
                            _vm.duanyuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown432,
                          expression: "isShowSetDown432"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown432()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown432()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown433,
                          expression: "isShowSetDown433"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown434,
                          expression: "isShowSetDown434"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal1,
                            expression: "duanyuInputVal1",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal1 },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal1 = $event.target.value.trim()
                            },
                            _vm.duanyuInput1
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown44,
                          expression: "isShowSetDown44"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(238)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown45()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown45,
                          expression: "isShowSetDown45"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(239)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          click: function($event) {
                            return _vm.setDown46()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown451,
                          expression: "isShowSetDown451"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown461()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown461()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown452,
                          expression: "isShowSetDown452"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(10),
                    _vm._v(" "),
                    _vm.isShowSetDown ||
                    _vm.isShowSetDown1 ||
                    _vm.isShowSetDown2 ||
                    _vm.isShowSetDown3
                      ? _c("p", [
                          _vm._v("请从"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服管理")
                          ]),
                          _vm._v("进入"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服工具")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown4 || _vm.isShowSetDown5
                      ? _c("p", [
                          _vm._v("选择客服工具中的"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("快捷短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown6 || _vm.isShowSetDown7
                      ? _c("p", [
                          _vm._v("点击"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新建短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown8 ||
                    _vm.isShowSetDown9 ||
                    _vm.isShowSetDown10 ||
                    _vm.isShowSetDown11
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新增")
                          ]),
                          _vm._v("一个"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown12 || _vm.isShowSetDown13
                      ? _c("p", [
                          _vm._v("选择"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown14 ||
                    _vm.isShowSetDown15 ||
                    _vm.isShowSetDown16 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown18 ||
                    _vm.isShowSetDown19
                      ? [_vm._m(11), _vm._v(" "), _vm._m(12)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown20 ||
                    _vm.isShowSetDown21 ||
                    _vm.isShowSetDown22
                      ? [_vm._m(13)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown23 ||
                    _vm.isShowSetDown24 ||
                    _vm.isShowSetDown25 ||
                    _vm.isShowSetDown26 ||
                    _vm.isShowSetDown27 ||
                    _vm.isShowSetDown28 ||
                    _vm.isShowSetDown29
                      ? [_vm._m(14), _vm._v(" "), _vm._m(15)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown30 ||
                    _vm.isShowSetDown31 ||
                    _vm.isShowSetDown32 ||
                    _vm.isShowSetDown33 ||
                    _vm.isShowSetDown34 ||
                    _vm.isShowSetDown35 ||
                    _vm.isShowSetDown36
                      ? [
                          _vm._m(16),
                          _vm._v(" "),
                          _vm._m(17),
                          _vm._v(" "),
                          _vm._m(18),
                          _vm._v(" "),
                          _vm._m(19),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“飞鸽快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown37 ||
                    _vm.isShowSetDown38 ||
                    _vm.isShowSetDown39
                      ? [_vm._m(20)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown40 ||
                    _vm.isShowSetDown41 ||
                    _vm.isShowSetDown42
                      ? [_vm._m(21)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown43 ||
                    _vm.isShowSetDown431 ||
                    _vm.isShowSetDown432 ||
                    _vm.isShowSetDown433
                      ? [_vm._m(22)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown434 ||
                    _vm.isShowSetDown44 ||
                    _vm.isShowSetDown45 ||
                    _vm.isShowSetDown451 ||
                    _vm.isShowSetDown452
                      ? [_vm._m(23)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession,
                          expression: "isShowSession"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(240) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession1,
                          expression: "isShowSession1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(241) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          click: function($event) {
                            return _vm.four1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession2,
                          expression: "isShowSession2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(242) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession3,
                          expression: "isShowSession3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(243) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          click: function($event) {
                            return _vm.four3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession4,
                          expression: "isShowSession4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(244) }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(24),
                    _vm._v(" "),
                    _vm.isShowSession ||
                    _vm.isShowSession1 ||
                    _vm.isShowSession2 ||
                    _vm.isShowSession3 ||
                    _vm.isShowSession4
                      ? [_vm._m(25)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(245) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive1,
                          expression: "isShowFive1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(246) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          click: function($event) {
                            return _vm.five1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive2,
                          expression: "isShowFive2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(247) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive3,
                          expression: "isShowFive3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(248) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          click: function($event) {
                            return _vm.five3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive4,
                          expression: "isShowFive4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(249) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive5,
                          expression: "isShowFive5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(250)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive6,
                          expression: "isShowFive6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(251)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          click: function($event) {
                            return _vm.five6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive7,
                          expression: "isShowFive7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(252) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive8,
                          expression: "isShowFive8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(253) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          click: function($event) {
                            return _vm.five8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive9,
                          expression: "isShowFive9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(254) }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(26),
                    _vm._v(" "),
                    _vm.isShowFive ||
                    _vm.isShowFive1 ||
                    _vm.isShowFive2 ||
                    _vm.isShowFive3 ||
                    _vm.isShowFive4
                      ? [_vm._m(27)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowFive5 ||
                    _vm.isShowFive6 ||
                    _vm.isShowFive7 ||
                    _vm.isShowFive8 ||
                    _vm.isShowFive9
                      ? [_vm._m(28)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(255)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix1,
                          expression: "isShowSix1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(256)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          click: function($event) {
                            return _vm.six1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix2,
                          expression: "isShowSix2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(257)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.beizhu,
                            expression: "beizhu",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "beizhu",
                        domProps: { value: _vm.beizhu },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.beizhu = $event.target.value.trim()
                            },
                            _vm.beiZhuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six033",
                        on: {
                          click: function($event) {
                            return _vm.six122()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix3,
                          expression: "isShowSix3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(258)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six02",
                        on: {
                          click: function($event) {
                            return _vm.six3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix4,
                          expression: "isShowSix4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(259)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix5,
                          expression: "isShowSix5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(260)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix6,
                          expression: "isShowSix6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(261)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix7,
                          expression: "isShowSix7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(262)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix8,
                          expression: "isShowSix8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(263)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          click: function($event) {
                            return _vm.six7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix9,
                          expression: "isShowSix9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(264)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix10,
                          expression: "isShowSix10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(265)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix11,
                          expression: "isShowSix11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(266)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          click: function($event) {
                            return _vm.six9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix12,
                          expression: "isShowSix12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(267)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix13,
                          expression: "isShowSix13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(268)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix14,
                          expression: "isShowSix14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(269)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          click: function($event) {
                            return _vm.six11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix15,
                          expression: "isShowSix15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(270)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yjgj,
                            expression: "yjgj",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yjgj",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yjgj },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yjgj = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yfInput,
                            expression: "yfInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yfInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yfInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yfInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix16,
                          expression: "isShowSix16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(271)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          click: function($event) {
                            return _vm.six13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix17,
                          expression: "isShowSix17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(272)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix18,
                          expression: "isShowSix18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(273)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six14()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix19,
                          expression: "isShowSix19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(274)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          click: function($event) {
                            return _vm.six15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix20,
                          expression: "isShowSix20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(275)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six081",
                        on: {
                          click: function($event) {
                            return _vm.six16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix21,
                          expression: "isShowSix21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(276)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.sjhm,
                            expression: "sjhm",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "sjhm",
                        attrs: { type: "text" },
                        domProps: { value: _vm.sjhm },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.sjhm = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix22,
                          expression: "isShowSix22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(277)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          click: function($event) {
                            return _vm.six18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix23,
                          expression: "isShowSix23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(278)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(29),
                    _vm._v(" "),
                    _vm.isShowSix ||
                    _vm.isShowSix1 ||
                    _vm.isShowSix2 ||
                    _vm.isShowSix3 ||
                    _vm.isShowSix4 ||
                    _vm.isShowSix5 ||
                    _vm.isShowSix6
                      ? [_vm._m(30), _vm._v(" "), _vm._m(31)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix7 || _vm.isShowSix8 || _vm.isShowSix9
                      ? [_vm._m(32)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix10 || _vm.isShowSix11 || _vm.isShowSix12
                      ? [_vm._m(33)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix13 ||
                    _vm.isShowSix14 ||
                    _vm.isShowSix15 ||
                    _vm.isShowSix16 ||
                    _vm.isShowSix17
                      ? [_vm._m(34)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix18 ||
                    _vm.isShowSix19 ||
                    _vm.isShowSix20 ||
                    _vm.isShowSix21 ||
                    _vm.isShowSix22 ||
                    _vm.isShowSix23
                      ? [_vm._m(35)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven,
                          expression: "isShowSeven"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(279) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven1,
                          expression: "isShowSeven1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(280) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven2,
                          expression: "isShowSeven2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(281) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          click: function($event) {
                            return _vm.seven2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven3,
                          expression: "isShowSeven3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(282) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven4,
                          expression: "isShowSeven4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(283) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven03",
                        on: {
                          click: function($event) {
                            return _vm.seven4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven5,
                          expression: "isShowSeven5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(284) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven6,
                          expression: "isShowSeven6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(285) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          click: function($event) {
                            return _vm.seven6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven7,
                          expression: "isShowSeven7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(286) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven8,
                          expression: "isShowSeven8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(287) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          click: function($event) {
                            return _vm.seven8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven9,
                          expression: "isShowSeven9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(288)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven10,
                          expression: "isShowSeven10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(289)
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("img", {
                            staticClass: "small-img",
                            attrs: {
                              src: __webpack_require__(290)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven06",
                            on: {
                              contextmenu: function($event) {
                                $event.preventDefault()
                                return _vm.seven10()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven07",
                            on: {
                              click: function($event) {
                                return _vm.seven11()
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven11,
                          expression: "isShowSeven11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(291)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(36),
                    _vm._v(" "),
                    _vm.isShowSeven || _vm.isShowSeven1 || _vm.isShowSeven2
                      ? [_vm._m(37)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven3 || _vm.isShowSeven4
                      ? [_vm._m(38)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven5 || _vm.isShowSeven6
                      ? [_vm._m(39)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven7 || _vm.isShowSeven8
                      ? [_c("p", [_vm._v("请点击右下方显示隐藏的图标")])]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven9 || _vm.isShowSeven10 || _vm.isShowSeven11
                      ? [_c("p", [_vm._v("右键点击飞鸽小图标")])]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                  [_vm._m(40)]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录飞鸽工作台")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("3、会话窗口")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、商品插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、订单插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、退出飞鸽")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("选择"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("我是商家")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击右上角的电脑图标，切换为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("手机号登录")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("注意："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("正式任务")]),
      _vm._v("需提前将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("自己的手机号")]),
      _vm._v("反馈给主管开通账号！")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("假设练习场"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("账号为：13853678478")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "blod-span" }, [_vm._v("验证码为：3346")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("鼠标"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("左键")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("第2个")]),
      _vm._v("店铺，切换到第2个店铺")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("鼠标"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("右键")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("第2个")]),
      _vm._v("店铺，"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("退出店铺")]),
      _vm._v("铺")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("添加催单短语内容："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("亲亲，喜欢的话就下单吧，早拍早发货哦！")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("编码短语设置为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("催单")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("确定")]),
      _vm._v("按钮进行保存")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("模板库导入")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("分组")]),
      _vm._v("设置为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("问候语")]),
      _vm._v("，并选择"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("前面2条")]),
      _vm._v("快捷问候语；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("确定导入")]),
      _vm._v("按钮")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("1.先"),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("下载下方的飞鸽快捷短语")
      ]),
      _vm._v("表格；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("2.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("批量导入")]),
      _vm._v("按钮；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("3.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("添加文件")]),
      _vm._v(
        "，选择下载的飞鸽快捷短语表格（可以先将下载的表格另存到桌面上，方便导入时快速找到表格）；"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("4.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("导入")]),
      _vm._v("按钮；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击右侧的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("快捷短语；")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("鼠标左键")]),
      _vm._v("点击快捷短语的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用输入"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("/您好")]),
      _vm._v("的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用输入文本"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("您好")]),
      _vm._v("的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将当前用户"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("转接")]),
      _vm._v("给"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("军瑞")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请点击商品插件，将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("全部商品")]),
      _vm._v("中"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("销量最高")]),
      _vm._v("的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("腰带")]),
      _vm._v("链接发送给用户")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("浏览足迹")]),
      _vm._v("中"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("销量最高")]),
      _vm._v("的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("腰带")]),
      _vm._v("链接发送给用户")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("假设此商家规定"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("红色彩旗跟发货相关")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给该用户添加"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("备注")]),
      _vm._v("内容："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("用户要求发顺丰")]),
      _vm._v("并"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("选择对应的彩旗")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给用户发送"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("核对地址")]),
      _vm._v("卡片")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给用户发送订单"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("催付")]),
      _vm._v("卡片")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("一键改价")]),
      _vm._v("方式，将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("最终实付价")]),
      _vm._v("改为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("48")]),
      _vm._v("元，"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("运费")]),
      _vm._v("改为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("10")]),
      _vm._v("元")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请在"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("改地址")]),
      _vm._v("中，将用户的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("手机号码")]),
      _vm._v("改成"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("13512345678")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将状态切换为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("小休")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将状态切换为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("离线")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请关闭"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("接待页面")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "tip", staticStyle: { width: "400px", height: "270px" } },
      [_c("span", { staticClass: "el-icon-success" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62610818", esExports)
  }
}

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_11618_vue__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_11618_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_11618_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_11618_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_11618_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5161d2d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feiGeTrainexam_11618_vue__ = __webpack_require__(1689);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1687)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5161d2d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feiGeTrainexam_11618_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5161d2d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feiGeTrainexam_11618_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/flying/feiGeTrainexam_11618.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5161d2d6", Component.options)
  } else {
    hotAPI.reload("data-v-5161d2d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("74c27167", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5161d2d6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./feiGeTrainexam_11618.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5161d2d6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./feiGeTrainexam_11618.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-5161d2d6] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-5161d2d6] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.blod-span[data-v-5161d2d6] {\n  color: red;\n  font-weight: bold;\n}\n.mynone[data-v-5161d2d6] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "feiGeExam" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(179)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        on: { mouseenter: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(180)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        attrs: { id: "select" },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon3,
                          expression: "isShowIcon3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(181)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon03",
                        on: { click: _vm.showLoginImg3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon4,
                          expression: "isShowIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(182)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon04",
                        on: { mouseenter: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon5,
                          expression: "isShowIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(183)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon05",
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon6,
                          expression: "isShowIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(184)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon06",
                        on: { click: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon7,
                          expression: "isShowIcon7"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(185)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon07",
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon8,
                          expression: "isShowIcon8"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(186)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.password,
                            expression: "password",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon08",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin1,
                          expression: "isShowLogin1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(187)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { mouseenter: _vm.loginIn1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin2,
                          expression: "isShowLogin2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(188)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { click: _vm.loginIn2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin3,
                          expression: "isShowLogin3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(189)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            return _vm.loginIn3.apply(null, arguments)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin4,
                          expression: "isShowLogin4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(190)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon10",
                        on: { click: _vm.loginIn4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin5,
                          expression: "isShowLogin5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(191)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请打开"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("左侧练习场")
                          ]),
                          _vm._v("中的飞鸽客服工作台")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon3 ? [_vm._m(2)] : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon4 || _vm.isShowIcon5 ? [_vm._m(3)] : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon6 || _vm.isShowIcon7 || _vm.isShowIcon8
                      ? [
                          _vm._m(4),
                          _vm._v(" "),
                          _vm._m(5),
                          _vm._v(" "),
                          _vm._m(6)
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin1 || _vm.isShowLogin2
                      ? [_vm._m(7)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin3 || _vm.isShowLogin4
                      ? [_vm._m(8)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp,
                          expression: "isShowSetUp"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(192)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon01",
                        on: { click: _vm.setUp }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp1,
                          expression: "isShowSetUp1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(193)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { mouseenter: _vm.setUp1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp2,
                          expression: "isShowSetUp2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(194)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { click: _vm.setUp2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp3,
                          expression: "isShowSetUp3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(195)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon03",
                        on: { click: _vm.setUp3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp4,
                          expression: "isShowSetUp4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(196)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { mouseenter: _vm.setUp4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp5,
                          expression: "isShowSetUp5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(197)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { click: _vm.setUp5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp6,
                          expression: "isShowSetUp6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(198)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { mouseenter: _vm.setUp6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp7,
                          expression: "isShowSetUp7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(199)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { click: _vm.setUp7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp8,
                          expression: "isShowSetUp8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(200)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { mouseenter: _vm.setUp8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp9,
                          expression: "isShowSetUp9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(201)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { click: _vm.setUp9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp10,
                          expression: "isShowSetUp10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _vm.isShowSetUp || _vm.isShowSetUp1 || _vm.isShowSetUp2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("在线")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp3 || _vm.isShowSetUp4 || _vm.isShowSetUp5
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("小休")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp6 ||
                  _vm.isShowSetUp7 ||
                  _vm.isShowSetUp8 ||
                  _vm.isShowSetUp9
                    ? _c("p", [
                        _vm._v("请将当前会话的接待排序设置为：按"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("等待时长")
                        ]),
                        _vm._v("由长到短排序")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown,
                          expression: "isShowSetDown"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown1,
                          expression: "isShowSetDown1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(202)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          click: function($event) {
                            return _vm.setDown1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown2,
                          expression: "isShowSetDown2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(203)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown3,
                          expression: "isShowSetDown3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(204)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          click: function($event) {
                            return _vm.setDown3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown4,
                          expression: "isShowSetDown4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(205)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown5,
                          expression: "isShowSetDown5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(206)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          click: function($event) {
                            return _vm.setDown5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown6,
                          expression: "isShowSetDown6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(207)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown7,
                          expression: "isShowSetDown7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(208)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown8,
                          expression: "isShowSetDown8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(209)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown9,
                          expression: "isShowSetDown9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(210)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          click: function($event) {
                            return _vm.setDown9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown10,
                          expression: "isShowSetDown10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(211)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown05",
                        on: {
                          click: function($event) {
                            return _vm.setDown10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown11,
                          expression: "isShowSetDown11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(212)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dyInput,
                            expression: "dyInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dyInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.dyInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dyInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown06",
                        on: {
                          click: function($event) {
                            return _vm.setDown11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown12,
                          expression: "isShowSetDown12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(213)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown13,
                          expression: "isShowSetDown13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(214)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          click: function($event) {
                            return _vm.setDown13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown14,
                          expression: "isShowSetDown14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(215)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown14()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown15,
                          expression: "isShowSetDown15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown16,
                          expression: "isShowSetDown16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown17,
                          expression: "isShowSetDown17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown18,
                          expression: "isShowSetDown18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown19()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown19,
                          expression: "isShowSetDown19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(216)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          click: function($event) {
                            return _vm.setDown20()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown20,
                          expression: "isShowSetDown20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(217)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown21,
                          expression: "isShowSetDown21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(218)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown22()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown22,
                          expression: "isShowSetDown22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(219)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          click: function($event) {
                            return _vm.setDown23()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown23,
                          expression: "isShowSetDown23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(220)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown24()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown24,
                          expression: "isShowSetDown24"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(221)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          click: function($event) {
                            return _vm.setDown25()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown25,
                          expression: "isShowSetDown25"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(222)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown12",
                        on: {
                          click: function($event) {
                            return _vm.setDown26()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown26,
                          expression: "isShowSetDown26"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(223)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown13",
                        on: {
                          click: function($event) {
                            return _vm.setDown27()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown27,
                          expression: "isShowSetDown27"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(224)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown14",
                        on: {
                          click: function($event) {
                            return _vm.setDown28()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown28,
                          expression: "isShowSetDown28"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(225)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown29()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown29,
                          expression: "isShowSetDown29"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(226)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          click: function($event) {
                            return _vm.setDown30()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown30,
                          expression: "isShowSetDown30"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(227)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown31,
                          expression: "isShowSetDown31"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(228)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown32()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown32,
                          expression: "isShowSetDown32"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(229)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          click: function($event) {
                            return _vm.setDown33()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown33,
                          expression: "isShowSetDown33"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(230)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown17",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown34()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowSetDown34
                    ? _c("div", { staticClass: "szbox" }, [
                        _c("img", {
                          staticClass: "szbg",
                          attrs: {
                            src: __webpack_require__(231)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "btn-file",
                          attrs: { type: "file" },
                          on: {
                            change: function($event) {
                              return _vm.tirggerFile($event)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown35,
                          expression: "isShowSetDown35"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(232)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown36()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown36,
                          expression: "isShowSetDown36"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(233)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          click: function($event) {
                            return _vm.setDown37()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown37,
                          expression: "isShowSetDown37"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(234)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown38,
                          expression: "isShowSetDown38"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(235)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown39()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown39,
                          expression: "isShowSetDown39"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(236)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          click: function($event) {
                            return _vm.setDown40()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown40,
                          expression: "isShowSetDown40"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown41()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown41,
                          expression: "isShowSetDown41"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(237)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          click: function($event) {
                            return _vm.setDown42()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown42,
                          expression: "isShowSetDown42"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown43()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown43()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown43,
                          expression: "isShowSetDown43"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown431,
                          expression: "isShowSetDown431"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal,
                            expression: "duanyuInputVal",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal = $event.target.value.trim()
                            },
                            _vm.duanyuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown432,
                          expression: "isShowSetDown432"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown432()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown432()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown433,
                          expression: "isShowSetDown433"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown434,
                          expression: "isShowSetDown434"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal1,
                            expression: "duanyuInputVal1",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal1 },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal1 = $event.target.value.trim()
                            },
                            _vm.duanyuInput1
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown44,
                          expression: "isShowSetDown44"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(238)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown45()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown45,
                          expression: "isShowSetDown45"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(239)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          click: function($event) {
                            return _vm.setDown46()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown451,
                          expression: "isShowSetDown451"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown461()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown461()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown452,
                          expression: "isShowSetDown452"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(10),
                    _vm._v(" "),
                    _vm.isShowSetDown ||
                    _vm.isShowSetDown1 ||
                    _vm.isShowSetDown2 ||
                    _vm.isShowSetDown3
                      ? _c("p", [
                          _vm._v("请从"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服管理")
                          ]),
                          _vm._v("进入"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服工具")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown4 || _vm.isShowSetDown5
                      ? _c("p", [
                          _vm._v("选择客服工具中的"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("快捷短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown6 || _vm.isShowSetDown7
                      ? _c("p", [
                          _vm._v("点击"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新建短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown8 ||
                    _vm.isShowSetDown9 ||
                    _vm.isShowSetDown10 ||
                    _vm.isShowSetDown11
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新增")
                          ]),
                          _vm._v("一个"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown12 || _vm.isShowSetDown13
                      ? _c("p", [
                          _vm._v("选择"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown14 ||
                    _vm.isShowSetDown15 ||
                    _vm.isShowSetDown16 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown18 ||
                    _vm.isShowSetDown19
                      ? [_vm._m(11), _vm._v(" "), _vm._m(12)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown20 ||
                    _vm.isShowSetDown21 ||
                    _vm.isShowSetDown22
                      ? [_vm._m(13)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown23 ||
                    _vm.isShowSetDown24 ||
                    _vm.isShowSetDown25 ||
                    _vm.isShowSetDown26 ||
                    _vm.isShowSetDown27 ||
                    _vm.isShowSetDown28 ||
                    _vm.isShowSetDown29
                      ? [_vm._m(14), _vm._v(" "), _vm._m(15)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown30 ||
                    _vm.isShowSetDown31 ||
                    _vm.isShowSetDown32 ||
                    _vm.isShowSetDown33 ||
                    _vm.isShowSetDown34 ||
                    _vm.isShowSetDown35 ||
                    _vm.isShowSetDown36
                      ? [
                          _vm._m(16),
                          _vm._v(" "),
                          _vm._m(17),
                          _vm._v(" "),
                          _vm._m(18),
                          _vm._v(" "),
                          _vm._m(19),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“飞鸽快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown37 ||
                    _vm.isShowSetDown38 ||
                    _vm.isShowSetDown39
                      ? [_vm._m(20)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown40 ||
                    _vm.isShowSetDown41 ||
                    _vm.isShowSetDown42
                      ? [_vm._m(21)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown43 ||
                    _vm.isShowSetDown431 ||
                    _vm.isShowSetDown432 ||
                    _vm.isShowSetDown433
                      ? [_vm._m(22)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown434 ||
                    _vm.isShowSetDown44 ||
                    _vm.isShowSetDown45 ||
                    _vm.isShowSetDown451 ||
                    _vm.isShowSetDown452
                      ? [_vm._m(23)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession,
                          expression: "isShowSession"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(240) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession1,
                          expression: "isShowSession1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(241) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          click: function($event) {
                            return _vm.four1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession2,
                          expression: "isShowSession2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(242) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession3,
                          expression: "isShowSession3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(243) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          click: function($event) {
                            return _vm.four3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession4,
                          expression: "isShowSession4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(244) }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(24),
                    _vm._v(" "),
                    _vm.isShowSession ||
                    _vm.isShowSession1 ||
                    _vm.isShowSession2 ||
                    _vm.isShowSession3 ||
                    _vm.isShowSession4
                      ? [_vm._m(25)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(245) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive1,
                          expression: "isShowFive1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(246) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          click: function($event) {
                            return _vm.five1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive2,
                          expression: "isShowFive2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(247) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive3,
                          expression: "isShowFive3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(248) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          click: function($event) {
                            return _vm.five3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive4,
                          expression: "isShowFive4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(249) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive5,
                          expression: "isShowFive5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(250)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive6,
                          expression: "isShowFive6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(251)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          click: function($event) {
                            return _vm.five6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive7,
                          expression: "isShowFive7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(252) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive8,
                          expression: "isShowFive8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(253) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          click: function($event) {
                            return _vm.five8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive9,
                          expression: "isShowFive9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(254) }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(26),
                    _vm._v(" "),
                    _vm.isShowFive ||
                    _vm.isShowFive1 ||
                    _vm.isShowFive2 ||
                    _vm.isShowFive3 ||
                    _vm.isShowFive4
                      ? [_vm._m(27)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowFive5 ||
                    _vm.isShowFive6 ||
                    _vm.isShowFive7 ||
                    _vm.isShowFive8 ||
                    _vm.isShowFive9
                      ? [_vm._m(28)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(255)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix1,
                          expression: "isShowSix1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(256)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          click: function($event) {
                            return _vm.six1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix2,
                          expression: "isShowSix2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(257)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.beizhu,
                            expression: "beizhu",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "beizhu",
                        domProps: { value: _vm.beizhu },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.beizhu = $event.target.value.trim()
                            },
                            _vm.beiZhuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six033",
                        on: {
                          click: function($event) {
                            return _vm.six122()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix3,
                          expression: "isShowSix3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(258)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six02",
                        on: {
                          click: function($event) {
                            return _vm.six3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix4,
                          expression: "isShowSix4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(259)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix5,
                          expression: "isShowSix5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(260)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix6,
                          expression: "isShowSix6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(261)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix7,
                          expression: "isShowSix7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(262)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix8,
                          expression: "isShowSix8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(263)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          click: function($event) {
                            return _vm.six7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix9,
                          expression: "isShowSix9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(264)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix10,
                          expression: "isShowSix10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(265)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix11,
                          expression: "isShowSix11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(266)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          click: function($event) {
                            return _vm.six9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix12,
                          expression: "isShowSix12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(267)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix13,
                          expression: "isShowSix13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(268)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix14,
                          expression: "isShowSix14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(269)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          click: function($event) {
                            return _vm.six11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix15,
                          expression: "isShowSix15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(270)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yjgj,
                            expression: "yjgj",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yjgj",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yjgj },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yjgj = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yfInput,
                            expression: "yfInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yfInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yfInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yfInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix16,
                          expression: "isShowSix16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(271)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          click: function($event) {
                            return _vm.six13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix17,
                          expression: "isShowSix17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(272)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix18,
                          expression: "isShowSix18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(273)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six14()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix19,
                          expression: "isShowSix19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(274)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          click: function($event) {
                            return _vm.six15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix20,
                          expression: "isShowSix20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(275)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six081",
                        on: {
                          click: function($event) {
                            return _vm.six16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix21,
                          expression: "isShowSix21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(276)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.sjhm,
                            expression: "sjhm",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "sjhm",
                        attrs: { type: "text" },
                        domProps: { value: _vm.sjhm },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.sjhm = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix22,
                          expression: "isShowSix22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(277)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          click: function($event) {
                            return _vm.six18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix23,
                          expression: "isShowSix23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(278)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(29),
                    _vm._v(" "),
                    _vm.isShowSix ||
                    _vm.isShowSix1 ||
                    _vm.isShowSix2 ||
                    _vm.isShowSix3 ||
                    _vm.isShowSix4 ||
                    _vm.isShowSix5 ||
                    _vm.isShowSix6
                      ? [_vm._m(30), _vm._v(" "), _vm._m(31)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix7 || _vm.isShowSix8 || _vm.isShowSix9
                      ? [_vm._m(32)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix10 || _vm.isShowSix11 || _vm.isShowSix12
                      ? [_vm._m(33)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix13 ||
                    _vm.isShowSix14 ||
                    _vm.isShowSix15 ||
                    _vm.isShowSix16 ||
                    _vm.isShowSix17
                      ? [_vm._m(34)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix18 ||
                    _vm.isShowSix19 ||
                    _vm.isShowSix20 ||
                    _vm.isShowSix21 ||
                    _vm.isShowSix22 ||
                    _vm.isShowSix23
                      ? [_vm._m(35)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven,
                          expression: "isShowSeven"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(279) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven1,
                          expression: "isShowSeven1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(280) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven2,
                          expression: "isShowSeven2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(281) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          click: function($event) {
                            return _vm.seven2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven3,
                          expression: "isShowSeven3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(282) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven4,
                          expression: "isShowSeven4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(283) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven03",
                        on: {
                          click: function($event) {
                            return _vm.seven4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven5,
                          expression: "isShowSeven5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(284) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven6,
                          expression: "isShowSeven6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(285) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          click: function($event) {
                            return _vm.seven6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven7,
                          expression: "isShowSeven7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(286) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven8,
                          expression: "isShowSeven8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: { src: __webpack_require__(287) }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          click: function($event) {
                            return _vm.seven8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven9,
                          expression: "isShowSeven9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(288)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven10,
                          expression: "isShowSeven10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(289)
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("img", {
                            staticClass: "small-img",
                            attrs: {
                              src: __webpack_require__(290)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven06",
                            on: {
                              contextmenu: function($event) {
                                $event.preventDefault()
                                return _vm.seven10()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven07",
                            on: {
                              click: function($event) {
                                return _vm.seven11()
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven11,
                          expression: "isShowSeven11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(291)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(36),
                    _vm._v(" "),
                    _vm.isShowSeven || _vm.isShowSeven1 || _vm.isShowSeven2
                      ? [_vm._m(37)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven3 || _vm.isShowSeven4
                      ? [_vm._m(38)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven5 || _vm.isShowSeven6
                      ? [_vm._m(39)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven7 || _vm.isShowSeven8
                      ? [_c("p", [_vm._v("请点击右下方显示隐藏的图标")])]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven9 || _vm.isShowSeven10 || _vm.isShowSeven11
                      ? [_c("p", [_vm._v("右键点击飞鸽小图标")])]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                  [_vm._m(40)]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录飞鸽工作台")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("3、会话窗口")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、商品插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、订单插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、退出飞鸽")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("选择"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("我是商家")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击右上角的电脑图标，切换为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("手机号登录")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("注意："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("正式任务")]),
      _vm._v("需提前将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("自己的手机号")]),
      _vm._v("反馈给主管开通账号！")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("假设练习场"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("账号为：13853678478")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "blod-span" }, [_vm._v("验证码为：3346")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("鼠标"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("左键")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("第2个")]),
      _vm._v("店铺，切换到第2个店铺")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("鼠标"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("右键")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("第2个")]),
      _vm._v("店铺，"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("退出店铺")]),
      _vm._v("铺")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("添加催单短语内容："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("亲亲，喜欢的话就下单吧，早拍早发货哦！")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("编码短语设置为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("催单")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("确定")]),
      _vm._v("按钮进行保存")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("模板库导入")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("分组")]),
      _vm._v("设置为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("问候语")]),
      _vm._v("，并选择"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("前面2条")]),
      _vm._v("快捷问候语；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("确定导入")]),
      _vm._v("按钮")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("1.先"),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("下载下方的飞鸽快捷短语")
      ]),
      _vm._v("表格；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("2.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("批量导入")]),
      _vm._v("按钮；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("3.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("添加文件")]),
      _vm._v(
        "，选择下载的飞鸽快捷短语表格（可以先将下载的表格另存到桌面上，方便导入时快速找到表格）；"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("4.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("导入")]),
      _vm._v("按钮；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击右侧的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("快捷短语；")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("鼠标左键")]),
      _vm._v("点击快捷短语的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用输入"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("/您好")]),
      _vm._v("的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用输入文本"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("您好")]),
      _vm._v("的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将当前用户"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("转接")]),
      _vm._v("给"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("军瑞")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请点击商品插件，将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("全部商品")]),
      _vm._v("中"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("销量最高")]),
      _vm._v("的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("腰带")]),
      _vm._v("链接发送给用户")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("浏览足迹")]),
      _vm._v("中"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("销量最高")]),
      _vm._v("的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("腰带")]),
      _vm._v("链接发送给用户")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("假设此商家规定"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("红色彩旗跟发货相关")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给该用户添加"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("备注")]),
      _vm._v("内容："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("用户要求发顺丰")]),
      _vm._v("并"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("选择对应的彩旗")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给用户发送"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("核对地址")]),
      _vm._v("卡片")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给用户发送订单"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("催付")]),
      _vm._v("卡片")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("一键改价")]),
      _vm._v("方式，将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("最终实付价")]),
      _vm._v("改为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("48")]),
      _vm._v("元，"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("运费")]),
      _vm._v("改为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("10")]),
      _vm._v("元")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请在"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("改地址")]),
      _vm._v("中，将用户的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("手机号码")]),
      _vm._v("改成"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("13512345678")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将状态切换为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("小休")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将状态切换为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("离线")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请关闭"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("接待页面")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "tip", staticStyle: { width: "400px", height: "270px" } },
      [_c("span", { staticClass: "el-icon-success" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5161d2d6", esExports)
  }
}

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e10440e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courseList_vue__ = __webpack_require__(1693);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1691)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e10440e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_courseList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e10440e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_courseList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/courseList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e10440e", Component.options)
  } else {
    hotAPI.reload("data-v-6e10440e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1692);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3152d2ff", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6e10440e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./courseList.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6e10440e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./courseList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(177);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.isreturn[data-v-6e10440e] {\n  color: #000;\n  cursor: pointer;\n}\n[data-v-6e10440e] .el-icon-arrow-left {\n  color: #000;\n}\n.step-list[data-v-6e10440e] {\n  margin-bottom: 20px;\n  background: #fff;\n  border-radius: 5px;\n  padding: 19px 20px 20px 60px;\n  position: relative;\n}\n.step-list_top[data-v-6e10440e] {\n  display: flex;\n  justify-content: space-between;\n}\n.list_top_left[data-v-6e10440e] {\n  display: flex;\n  font-size: 16px;\n  color: #262626;\n  font-weight: bold;\n  position: relative;\n  left: -20px;\n}\n.isred[data-v-6e10440e] {\n  color: #E53434;\n  margin-right: 10px;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #E53434;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #FBE5E5;\n  height: 18px;\n  line-height: 15px;\n}\n.isgreen[data-v-6e10440e] {\n  color: #14C034;\n  margin-right: 10px;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 0px 3px;\n  border: 1px solid #39CA54;\n  border-radius: 4px;\n  margin-left: 9px;\n  margin-top: 4px;\n  background: #D9F4DE;\n  height: 18px;\n  line-height: 15px;\n}\n[data-v-6e10440e] .el-button--small {\n  padding: 9px 24px !important;\n  border-radius: 6px;\n}\n[data-v-6e10440e] .el-button--primary {\n  background-color: #497af2;\n}\n.step-list_under[data-v-6e10440e] {\n  margin-top: 15px;\n  background: #f5f6f7;\n  padding: 19px 20px 20px 19px;\n  font-size: 13px;\n  overflow: hidden;\n  color: #262626;\n}\n.circle[data-v-6e10440e] {\n  width: 20px;\n  height: 20px;\n  background: #497AF2;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  left: -20px;\n  top: 2px;\n  color: #fff;\n  font-weight: normal;\n  line-height: 20px;\n}\n.othercircle[data-v-6e10440e] {\n  width: 20px;\n  height: 20px;\n  background: #BBBBBB;\n  border-radius: 20px;\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.15s ease-out;\n  left: -20px;\n  top: 2px;\n  color: #fff;\n  font-weight: normal;\n  line-height: 20px;\n}\n.line[data-v-6e10440e] {\n  width: 2px;\n  top: 41px;\n  bottom: -20px;\n  left: 29px;\n  position: absolute;\n  border-color: inherit;\n  background-color: #1684fc;\n  z-index: 99;\n}\n.otherline[data-v-6e10440e] {\n  width: 2px;\n  top: 41px;\n  bottom: -20px;\n  left: 29px;\n  position: absolute;\n  border-color: inherit;\n  background-color: #BBBBBB;\n  z-index: 99;\n}\n#app[data-v-6e10440e] {\n  height: 100%;\n  box-sizing: border-box;\n}\n#Return_Bar[data-v-6e10440e] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n[data-v-6e10440e] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n#text[data-v-6e10440e] {\n  background: #f6f5f8;\n  width: 100%;\n  height: 100%;\n  padding: 20px 20px;\n}\n.lock[data-v-6e10440e] {\n  background: url(" + escape(__webpack_require__(178)) + ") no-repeat center;\n  background-size: cover;\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  right: 20px;\n}\n.description[data-v-6e10440e] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.sp_button[data-v-6e10440e] {\n  width: 95px;\n  height: 28px;\n  background: #BFD0FB;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #497AF2;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  letter-spacing: 1px;\n}\n.spb_button[data-v-6e10440e] {\n  width: 95px;\n  height: 28px;\n  background: #497AF2;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  margin-left: 10px;\n  letter-spacing: 1px;\n}\n.sph_button[data-v-6e10440e] {\n  width: 95px;\n  height: 28px;\n  background: #ff2323;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: Source Han Sans CN;\n  font-weight: 500;\n  color: #FFFFFF;\n  text-align: center;\n  line-height: 28px;\n  cursor: pointer;\n  margin-left: 10px;\n  letter-spacing: 1px;\n}\n.list_top_right[data-v-6e10440e] {\n  display: flex;\n}\n.top_line[data-v-6e10440e] {\n  position: absolute;\n  top: 0;\n  left: 29px;\n  width: 2px;\n  height: 21px;\n}\n.top_isCheck[data-v-6e10440e] {\n  background: #1684fc;\n}\n.top_noCheck[data-v-6e10440e] {\n  background: #BBBBBB;\n}\n[data-v-6e10440e] .el-dialog--center .el-dialog__body {\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "text" } },
      _vm._l(_vm.courseList, function(c, key) {
        return _c(
          "div",
          { key: key, ref: "asx", refInFor: true, staticClass: "step-list" },
          [
            _c("div", { staticClass: "step-list_top" }, [
              _c("div", { staticClass: "list_top_left" }, [
                _c(
                  "div",
                  {
                    staticClass: "circle",
                    class: {
                      circle: c.passState == "Passed",
                      othercircle:
                        c.passState == "Ongoing" || c.passState == null
                    }
                  },
                  [
                    _vm.courseList.length != 1
                      ? _c("div", [_vm._v(_vm._s(key + 1))])
                      : _vm._e()
                  ]
                ),
                _vm._v(
                  "\n                    " +
                    _vm._s(c.courseName) +
                    "\n                    "
                ),
                _c(
                  "div",
                  { class: c.passState == "Passed" ? "isgreen" : "isred" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          c.passState == "Passed" && c.passState != "null"
                            ? "已完成"
                            : "未完成"
                        ) +
                        "\n                    "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list_top_right" },
                [
                  c.unlock == true
                    ? [
                        c.passState == "Ongoing" && c.courseType != "Exam"
                          ? _c(
                              "div",
                              {
                                staticClass: "spb_button",
                                on: {
                                  click: function($event) {
                                    return _vm.goStudy(c)
                                  }
                                }
                              },
                              [_vm._v("点击学习")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        c.passState == "Passed" && c.courseType != "Exam"
                          ? _c(
                              "div",
                              {
                                staticClass: "spb_button",
                                on: {
                                  click: function($event) {
                                    return _vm.goStudy(c)
                                  }
                                }
                              },
                              [_vm._v("重新学习")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        c.passState == null &&
                        c.unlock == true &&
                        c.courseType != "Exam"
                          ? _c(
                              "div",
                              {
                                staticClass: "spb_button",
                                on: {
                                  click: function($event) {
                                    return _vm.goStudy(c)
                                  }
                                }
                              },
                              [_vm._v("点击学习")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        c.courseType == "Exam" && c.passState != "Passed"
                          ? _c(
                              "div",
                              {
                                staticClass: "spb_button",
                                on: {
                                  click: function($event) {
                                    return _vm.goStudy(c)
                                  }
                                }
                              },
                              [_vm._v("开始考试")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        c.courseType == "Exam" && c.passState == "Passed"
                          ? _c(
                              "div",
                              {
                                staticClass: "spb_button",
                                on: {
                                  click: function($event) {
                                    return _vm.goStudy(c)
                                  }
                                }
                              },
                              [_vm._v("重新考试")]
                            )
                          : _vm._e()
                      ]
                    : _c("div", { staticClass: "lock" })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", [
              c.description != ""
                ? _c("div", { staticClass: "step-list_under" }, [
                    _c("div", {
                      staticStyle: { width: "80%" },
                      domProps: { innerHTML: _vm._s(c.description) }
                    })
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            key != 0
              ? _c("div", {
                  staticClass: "top_line",
                  class: {
                    top_isCheck:
                      c.passState == "Passed" || c.passState == "Ongoing",
                    top_noCheck: c.passState == null
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.courseList.length > 1 && key != _vm.courseList.length - 1
              ? _c("div", {
                  class: {
                    line: c.passState == "Passed",
                    otherline: c.passState == "Ongoing" || c.passState == null
                  }
                })
              : _vm._e()
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e10440e", esExports)
  }
}

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniu_vue__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9746b60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qianniu_vue__ = __webpack_require__(1697);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1695)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d9746b60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9746b60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qianniu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/qianniu.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d9746b60", Component.options)
  } else {
    hotAPI.reload("data-v-d9746b60", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1696);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("03cc6306", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d9746b60\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./qianniu.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d9746b60\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./qianniu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-d9746b60] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-d9746b60] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.red-span[data-v-d9746b60] {\n  color: red;\n  font-weight: bold;\n}\n.video-mask[data-v-d9746b60] {\n  position: absolute;\n  bottom: 0;\n  left: 0px;\n  width: 1350px;\n  height: 25px;\n}\n", ""]);

// exports


/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newQianniuex" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "align-items": "center",
            "margin-bottom": "10px",
            cursor: "pointer",
            width: "100px"
          },
          on: { click: _vm.back }
        },
        [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("返回")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "zero" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("通关必看")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c(
                  "div",
                  { staticClass: "tip", staticStyle: { width: "290px" } },
                  [
                    _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startVideo }
                        },
                        [_vm._v("开始学习")]
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-zero" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "zero",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/%E9%80%9A%E5%85%B3%E5%BF%85%E7%9C%8B.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-zero" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-first")
                          }
                        }
                      },
                      [_vm._v("继续下一步学习")]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("1、登录千牛")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step1.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isShowQnIcon ||
                              _vm.isShowLoginImg ||
                              _vm.isShowRnd,
                            expression:
                              "isShowQnIcon || isShowLoginImg || isShowRnd"
                          }
                        ],
                        staticClass: "qnbox",
                        staticStyle: { "user-select": "none" }
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.mouseFocus,
                              expression: "!mouseFocus"
                            }
                          ],
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(354)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mouseFocus,
                              expression: "mouseFocus"
                            }
                          ],
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(75)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "qnicon01",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocus = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocus = false
                            },
                            click: _vm.showLoginImg
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowLoginImg,
                                expression: "isShowLoginImg"
                              }
                            ],
                            staticClass: "login",
                            staticStyle: { "user-select": "none" }
                          },
                          [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isSaveAP,
                                  expression: "isSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(347)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSaveAP && _vm.mouseFocusSaveAP,
                                  expression: "!isSaveAP && mouseFocusSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(346)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSaveAP && !_vm.mouseFocusSaveAP,
                                  expression: "!isSaveAP && !mouseFocusSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(345)
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.name,
                                  expression: "name",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "name",
                              attrs: {
                                type: "text",
                                placeholder: "请输入账号"
                              },
                              domProps: { value: _vm.name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.name = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.password,
                                  expression: "password",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "password",
                              attrs: {
                                type: "password",
                                autocomplete: "new-password",
                                placeholder: "请输入密码"
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "hovertag",
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusSaveAP = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusSaveAP = false
                                },
                                click: function($event) {
                                  _vm.isSaveAP = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "logIn",
                              on: { click: _vm.loginIn }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowRnd,
                                expression: "isShowRnd"
                              }
                            ],
                            staticClass: "loginrnd"
                          },
                          [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showRnd,
                                  expression: "showRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(353)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showRnd && _vm.mouseFocusRnd,
                                  expression: "!showRnd && mouseFocusRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(352)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showRnd && !_vm.mouseFocusRnd,
                                  expression: "!showRnd && !mouseFocusRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(351)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sendRnd",
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusRnd = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusRnd = false
                                },
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.rnd,
                                  expression: "rnd",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "rnd",
                              attrs: {
                                type: "text",
                                placeholder: "短信验证码"
                              },
                              domProps: { value: _vm.rnd },
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusRnd = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusRnd = false
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.rnd = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "logInRnd",
                              on: { click: _vm.loginInRnd }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowQnIcon2,
                            expression: "isShowQnIcon2"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(75)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "qnicon02",
                          on: { dblclick: _vm.showLoginImg2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowLoginIndex,
                            expression: "isShowLoginIndex"
                          }
                        ],
                        staticClass: "jdbox"
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mouseFocusJD,
                              expression: "mouseFocusJD"
                            }
                          ],
                          staticClass: "jdimg",
                          attrs: {
                            src: __webpack_require__(348)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.mouseFocusJD,
                              expression: "!mouseFocusJD"
                            }
                          ],
                          staticClass: "jdimg",
                          attrs: {
                            src: __webpack_require__(349)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "jdicon",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusJD = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusJD = false
                            },
                            click: _vm.enterJd
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowLoginIndexTwo,
                            expression: "isShowLoginIndexTwo"
                          }
                        ],
                        staticClass: "indexbox"
                      },
                      [
                        _c("img", {
                          staticClass: "indeximg",
                          attrs: {
                            src: __webpack_require__(350)
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的千牛图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [_vm._v("1.复制粘贴账号和密码")]),
                          _vm._v(" "),
                          _c("p", [_vm._v("2.勾选记住密码")]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "font-weight": "normal"
                                      }
                                    },
                                    [_vm._v("账号：淘金云客服:小淘")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "font-weight": "normal"
                                      }
                                    },
                                    [_vm._v("密码：Tj1234")]
                                  )
                                ])
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "font-weight": "bold"
                                      }
                                    },
                                    [_vm._v("660220")]
                                  )
                                ])
                              ]
                            : [
                                _c("p", [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "font-weight": "bold"
                                      }
                                    },
                                    [_vm._v("获取短信校验码")]
                                  )
                                ])
                              ]
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [
                          _vm._v("请进入"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("接待中心")]
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "stoptip",
                staticStyle: { height: "696px" },
                attrs: { id: "studytip-first" }
              },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-登录千牛.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、基础设置（上）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step2.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 1,
                          expression: "secondStep == 1"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 1,
                            expression: "gqstep == 1"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(76)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.gqstep == 1,
                              expression: "gqstep == 1"
                            }
                          ],
                          staticClass: "gqbtn",
                          on: {
                            click: function($event) {
                              _vm.gqstep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 2 && _vm.mouseFocusZX,
                            expression: "gqstep == 2 && mouseFocusZX"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(365)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 2 && !_vm.mouseFocusZX,
                            expression: "gqstep == 2 && !mouseFocusZX"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(364)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.gqstep == 2,
                              expression: "gqstep == 2"
                            }
                          ],
                          staticClass: "gqclick",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusZX = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusZX = false
                            },
                            click: function($event) {
                              _vm.secondStep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 2,
                          expression: "secondStep == 2"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 1,
                            expression: "wgqstep == 1"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(366)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 1,
                              expression: "wgqstep == 1"
                            }
                          ],
                          staticClass: "gqbtn",
                          on: {
                            click: function($event) {
                              _vm.wgqstep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 2 && _vm.mouseFocusGQ,
                            expression: "wgqstep == 2 && mouseFocusGQ"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(368)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 2 && !_vm.mouseFocusGQ,
                            expression: "wgqstep == 2 && !mouseFocusGQ"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(367)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 2,
                              expression: "wgqstep == 2"
                            }
                          ],
                          staticClass: "gqclick",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusGQ = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusGQ = false
                            },
                            click: function($event) {
                              _vm.wgqstep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 3,
                            expression: "wgqstep == 3"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(369)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 3,
                              expression: "wgqstep == 3"
                            }
                          ],
                          staticClass: "cgqbtn",
                          on: {
                            click: function($event) {
                              _vm.secondStep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 3,
                          expression: "secondStep == 3"
                        }
                      ],
                      staticClass: "second-step3"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 1,
                            expression: "secondStepStep == 1"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(76)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 1,
                            expression: "secondStepStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.secondStepStep = 2
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && !_vm.mouseFocusDdsc,
                            expression: "secondStepStep == 2 && !mouseFocusDdsc"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(361)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && _vm.mouseFocusDdsc,
                            expression: "secondStepStep == 2 && mouseFocusDdsc"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(362)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 2,
                              expression: "secondStepStep == 2"
                            }
                          ],
                          staticClass: "btn2",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusDdsc = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusDdsc = false
                            },
                            click: function($event) {
                              _vm.secondStep = 4
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 4,
                          expression: "secondStep == 4"
                        }
                      ],
                      staticClass: "second-step3"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && !_vm.mouseFocusSet,
                            expression: "secondStepStep == 2 && !mouseFocusSet"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(363)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 2 && _vm.mouseFocusSet,
                            expression: "secondStepStep == 2 && mouseFocusSet"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(355)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 2,
                              expression: "secondStepStep == 2"
                            }
                          ],
                          staticClass: "btn3",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSet = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSet = false
                            },
                            click: function($event) {
                              _vm.secondStepStep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 3 && !_vm.mouseFocusSetInfo,
                            expression:
                              "secondStepStep == 3 && !mouseFocusSetInfo"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(356)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 3 && _vm.mouseFocusSetInfo,
                            expression:
                              "secondStepStep == 3 && mouseFocusSetInfo"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(357)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 3,
                              expression: "secondStepStep == 3"
                            }
                          ],
                          staticClass: "btn4",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSetInfo = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSetInfo = false
                            },
                            click: function($event) {
                              _vm.secondStepStep = 4
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 4 &&
                              !_vm.mouseFocusSetInfoDetail,
                            expression:
                              "secondStepStep == 4 && !mouseFocusSetInfoDetail"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(358)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 4 &&
                              _vm.mouseFocusSetInfoDetail,
                            expression:
                              "secondStepStep == 4 && mouseFocusSetInfoDetail"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(359)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 4,
                              expression: "secondStepStep == 4"
                            }
                          ],
                          staticClass: "btn5",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSetInfoDetail = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSetInfoDetail = false
                            },
                            click: _vm.showGqImgClick
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 5,
                            expression: "secondStepStep == 5"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(360)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.secondStep == 1
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("在线")
                        ]),
                        _vm._v("状态")
                      ])
                    : _vm.secondStep == 2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("挂起")
                        ]),
                        _vm._v("状态")
                      ])
                    : _vm.secondStep == 3
                    ? _c("p", [
                        _vm._v("请将接待排序设置为："),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("按客户等待时长排序")
                        ])
                      ])
                    : _vm.secondStep == 4
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("系统设置")
                        ]),
                        _vm._v("中的"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("消息接收与提醒，")
                        ]),
                        _vm._v("核对"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("店铺分流")
                        ]),
                        _vm._v("和"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("账号分流")
                        ]),
                        _vm._v("是否开启")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySecond }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-基础设置（上）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("3、基础设置（下）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step3.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "jdgkbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 1,
                          expression: "kjdyStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(324)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 1,
                            expression: "kjdyStep == 1"
                          }
                        ],
                        staticClass: "search-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "search",
                          attrs: { placeholder: "联系人,订单号，聊天记录" },
                          on: { input: _vm.kjdySearchChange },
                          model: {
                            value: _vm.kjdySearch,
                            callback: function($$v) {
                              _vm.kjdySearch = $$v
                            },
                            expression: "kjdySearch"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 2,
                          expression: "kjdyStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(335)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 2,
                            expression: "kjdyStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 3 && !_vm.mouseFocusKJDY,
                          expression: "kjdyStep == 3 && !mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(338)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 3 && _vm.mouseFocusKJDY,
                          expression: "kjdyStep == 3 && mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(339)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 3,
                            expression: "kjdyStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusKJDY = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusKJDY = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 4,
                          expression: "kjdyStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(340)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 4,
                            expression: "kjdyStep == 4"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _vm.kjdyStep == 5
                      ? _c("img", {
                          staticClass: "img-base",
                          attrs: {
                            src: __webpack_require__(341)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 5,
                            expression: "kjdyStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 6 && !_vm.mouseFocusFZ,
                          expression: "kjdyStep == 6 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(342)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 6 && _vm.mouseFocusFZ,
                          expression: "kjdyStep == 6 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(343)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 6,
                            expression: "kjdyStep == 6"
                          }
                        ],
                        staticClass: "btn6",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 7
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7 && !_vm.mouseFocusFZI,
                          expression: "kjdyStep == 7 && !mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(344)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7 && _vm.mouseFocusFZI,
                          expression: "kjdyStep == 7 && mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(325)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 7,
                            expression: "kjdyStep == 7"
                          }
                        ],
                        staticClass: "kjdyfz-c",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZI = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZI = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjfz-input",
                          attrs: { placeholder: "请输入分组" },
                          model: {
                            value: _vm.kjdyfz,
                            callback: function($$v) {
                              _vm.kjdyfz = $$v
                            },
                            expression: "kjdyfz"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7,
                          expression: "kjdyStep == 7"
                        }
                      ],
                      staticClass: "btn7",
                      on: { click: _vm.kjdyfzConfirm }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 8,
                          expression: "kjdyStep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(326)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.kjdyStep == 5 ||
                              _vm.kjdyStep == 6 ||
                              _vm.kjdyStep == 8,
                            expression:
                              "kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8"
                          }
                        ],
                        staticClass: "kjbm-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjbm-input",
                          model: {
                            value: _vm.kjdybm,
                            callback: function($$v) {
                              _vm.kjdybm = $$v
                            },
                            expression: "kjdybm"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.kjdyStep == 5 ||
                              _vm.kjdyStep == 6 ||
                              _vm.kjdyStep == 8,
                            expression:
                              "kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8"
                          }
                        ],
                        staticClass: "kjdy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdy-input",
                          attrs: {
                            placeholder: "请输入快捷短语",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.kjdynr,
                            callback: function($$v) {
                              _vm.kjdynr = $$v
                            },
                            expression: "kjdynr"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 8,
                            expression: "kjdyStep == 8"
                          }
                        ],
                        staticClass: "btn8",
                        on: { click: _vm.kjdyConfirm }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 9,
                          expression: "kjdyStep == 9"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(327)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 9,
                            expression: "kjdyStep == 9"
                          }
                        ],
                        staticClass: "btn9",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 10
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 10,
                          expression: "kjdyStep == 10"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(328)
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput",
                      staticClass: "btn-file",
                      attrs: { type: "file" },
                      on: {
                        change: function($event) {
                          return _vm.tirggerFile($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 11,
                          expression: "kjdyStep == 11"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(329)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 11,
                            expression: "kjdyStep == 11"
                          }
                        ],
                        staticClass: "btn11",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 12
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 12 && !_vm.mouseFocusKJDY,
                          expression: "kjdyStep == 12 && !mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(330)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 12 && _vm.mouseFocusKJDY,
                          expression: "kjdyStep == 12 && mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(331)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 12,
                            expression: "kjdyStep == 12"
                          }
                        ],
                        staticClass: "btn12",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusKJDY = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusKJDY = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 13
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 13,
                          expression: "kjdyStep == 13"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(332)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 13
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "btn133",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              _vm.kjdyStep = 14
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 13,
                            expression: "kjdyStep == 13"
                          }
                        ],
                        staticClass: "btn13",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 14
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 14,
                          expression: "kjdyStep == 14"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(333)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 14,
                            expression: "kjdyStep == 14"
                          }
                        ],
                        staticClass: "kjdyfs-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdyfs-input",
                          attrs: { type: "textarea" },
                          on: { input: _vm.kjdyfsChange },
                          model: {
                            value: _vm.kjdyfs,
                            callback: function($$v) {
                              _vm.kjdyfs = $$v
                            },
                            expression: "kjdyfs"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 15,
                          expression: "kjdyStep == 15"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(334)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 15
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "btn155",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.enterSelect.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 15,
                            expression: "kjdyStep == 15"
                          }
                        ],
                        staticClass: "btn15",
                        on: { click: _vm.enterSelect }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 16,
                          expression: "kjdyStep == 16"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(336)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 16
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          ref: "sixInput",
                          staticClass: "btn16",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.finishThird.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 16,
                            expression: "kjdyStep == 16"
                          }
                        ],
                        staticClass: "btn13",
                        on: { click: _vm.finishThird }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 17,
                          expression: "kjdyStep == 17"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(337)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _vm.kjdyStep == 1 || _vm.kjdyStep == 2
                      ? _c("p", [
                          _vm._v("请搜索登录账号"),
                          _c("br"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("淘金云客服:小淘")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 3
                      ? _c("p", [
                          _vm._v("请"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("打开快捷短语")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 4 ||
                    _vm.kjdyStep == 5 ||
                    _vm.kjdyStep == 6 ||
                    _vm.kjdyStep == 7 ||
                    _vm.kjdyStep == 8
                      ? [
                          _c("p", [
                            _vm._v("请"),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  "font-weight": "bold"
                                }
                              },
                              [_vm._v("新增一条")]
                            ),
                            _vm._v("快捷短语。短语内容："),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  "font-weight": "bold"
                                }
                              },
                              [_vm._v("亲，欢迎光临，请问有什么可以帮您的？")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("快捷编码："),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  "font-weight": "bold"
                                }
                              },
                              [_vm._v("欢迎")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("分组："),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "red",
                                  "font-weight": "bold"
                                }
                              },
                              [_vm._v("开头语")]
                            ),
                            _vm._v("（需要自己新增分组）")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 9 ||
                    _vm.kjdyStep == 10 ||
                    _vm.kjdyStep == 11
                      ? [
                          _c("p", [
                            _vm._v("请"),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("先下载")
                            ]),
                            _vm._v("快捷短语表格"),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("并保存到桌面上")
                            ]),
                            _vm._v("，再"),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("导入")
                            ]),
                            _vm._v("快捷短语。")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v('点击下载"快捷短语.csv"')
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 12 || _vm.kjdyStep == 13
                      ? [
                          _c("p", [
                            _vm._v("请采用"),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("鼠标左键")
                            ]),
                            _vm._v("点击快捷短语的方式，选择"),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("并发送")
                            ]),
                            _vm._v("快捷短语："),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 14 ||
                    _vm.kjdyStep == 15 ||
                    _vm.kjdyStep == 16 ||
                    _vm.kjdyStep == 17
                      ? [
                          _c("p", [
                            _vm._v("请采用"),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("/+快捷编码")
                            ]),
                            _vm._v("点击快捷短语的方式，选择"),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("并发送")
                            ]),
                            _vm._v("快捷短语："),
                            _c("span", { staticClass: "red-span" }, [
                              _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyThird }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-设置快捷短语.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt3
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt3(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt3 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("4、会话窗口常用功能")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step4.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cygnbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 1,
                          expression: "cygnStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(309)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 1,
                            expression: "cygnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.cygnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 2 && !_vm.mouseFocusDdsc,
                          expression: "cygnStep == 2 && !mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(311)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 2 && _vm.mouseFocusDdsc,
                          expression: "cygnStep == 2 && mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(312)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 2,
                            expression: "cygnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusDdsc = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDdsc = false
                          },
                          click: _vm.fourStepBystep
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 3,
                          expression: "cygnStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(313)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 4 && !_vm.mouseFocus,
                          expression: "cygnStep == 4 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(314)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 4 && _vm.mouseFocus,
                          expression: "cygnStep == 4 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(315)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 4,
                            expression: "cygnStep == 4"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.cygnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 5,
                          expression: "cygnStep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(316)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 5,
                            expression: "cygnStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          click: function($event) {
                            _vm.cygnStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 6,
                          expression: "cygnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(317)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 6,
                            expression: "cygnStep == 6"
                          }
                        ],
                        staticClass: "zfyy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "zjyy-input",
                          attrs: { placeholder: "请输入转交原因" },
                          model: {
                            value: _vm.zjyy,
                            callback: function($$v) {
                              _vm.zjyy = $$v
                            },
                            expression: "zjyy"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 6,
                            expression: "cygnStep == 6"
                          }
                        ],
                        staticClass: "btn6",
                        on: { click: _vm.sendZfyy }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 7,
                          expression: "cygnStep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(310)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.cygnStep == 1 || _vm.cygnStep == 2 || _vm.cygnStep == 3
                    ? _c("p", [
                        _vm._v("请给当前用户标记"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("黄色星星")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cygnStep == 4 ||
                  _vm.cygnStep == 5 ||
                  _vm.cygnStep == 6 ||
                  _vm.cygnStep == 7
                    ? _c("p", [
                        _vm._v("请将当前用户"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("转发")
                        ]),
                        _vm._v("给"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("小金")
                        ]),
                        _vm._v("，转交原因填写"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("少件")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFour }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-会话窗口常用功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt4
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt4(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt4 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("5、智能客服插件(上)")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step5.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zncj-top-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 1 && !_vm.mouseFocus,
                          expression: "zncjsstep == 1 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(388)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 1 && _vm.mouseFocus,
                          expression: "zncjsstep == 1 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(389)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjsstep == 1,
                            expression: "zncjsstep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.zncjsstep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 2 && !_vm.mouseFocus,
                          expression: "zncjsstep == 2 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(390)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 2 && _vm.mouseFocus,
                          expression: "zncjsstep == 2 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(391)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjsstep == 2,
                            expression: "zncjsstep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: _vm.tjspEnd
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 3,
                          expression: "zncjsstep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(392)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.zncjsstep == 1 || _vm.zncjsstep == 2 || _vm.zncjsstep == 3
                    ? _c("p", [
                        _vm._v("请将"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("商品导购区")
                        ]),
                        _vm._v("客户"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("足迹")
                        ]),
                        _vm._v("中"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("符合客户需求")
                        ]),
                        _vm._v("的商品发送给客户")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFive }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-智能客服插件(上).ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt5
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt5(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt5 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("6、智能客服插件(下)")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step6.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zncj-bottom-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 1,
                          expression: "zncjxstep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(318)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 1,
                            expression: "zncjxstep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 2,
                          expression: "zncjxstep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(319)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 2,
                            expression: "zncjxstep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 3,
                          expression: "zncjxstep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(320)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 3,
                            expression: "zncjxstep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: { click: _vm.sixStepByStep }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 4,
                          expression: "zncjxstep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(321)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 5,
                          expression: "zncjxstep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(307)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 5,
                            expression: "zncjxstep == 5"
                          }
                        ],
                        staticClass: "btn6",
                        on: { click: _vm.sixStepByStep2 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 6,
                          expression: "zncjxstep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(308)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 7,
                          expression: "zncjxstep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(394)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7,
                            expression: "zncjxstep == 7"
                          }
                        ],
                        staticClass: "btn7",
                        on: {
                          click: function($event) {
                            _vm.showYfstep = true
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.zncjxstep == 7 &&
                            _vm.showYfstep &&
                            !_vm.mouseFocus,
                          expression:
                            "zncjxstep == 7 && showYfstep && !mouseFocus"
                        }
                      ],
                      staticClass: "img-yf",
                      attrs: {
                        src: __webpack_require__(396)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.zncjxstep == 7 &&
                            _vm.showYfstep &&
                            _vm.mouseFocus,
                          expression:
                            "zncjxstep == 7 && showYfstep && mouseFocus"
                        }
                      ],
                      staticClass: "img-yf",
                      attrs: {
                        src: __webpack_require__(397)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7 && _vm.showYfstep,
                            expression: "zncjxstep == 7 && showYfstep"
                          }
                        ],
                        class: {
                          "yf-c": !_vm.mouseFocus,
                          "yf-c1": _vm.mouseFocus
                        },
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "yf-input",
                          attrs: { placeholder: "请输入邮费" },
                          model: {
                            value: _vm.yfamount,
                            callback: function($$v) {
                              _vm.yfamount = $$v
                            },
                            expression: "yfamount"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7 && _vm.showYfstep,
                            expression: "zncjxstep == 7 && showYfstep"
                          }
                        ],
                        staticClass: "btn77",
                        on: { click: _vm.sixStepByStep3 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 8,
                          expression: "zncjxstep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(395)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 8,
                            expression: "zncjxstep == 8"
                          }
                        ],
                        staticClass: "btn8",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 9
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 9,
                          expression: "zncjxstep == 9"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(304)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 9,
                            expression: "zncjxstep == 9"
                          }
                        ],
                        staticClass: "btn9",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 10
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 10,
                          expression: "zncjxstep == 10"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(305)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 10 || _vm.zncjxstep == 9,
                            expression: "zncjxstep == 10 || zncjxstep == 9"
                          }
                        ],
                        staticClass: "kjdy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdy-input",
                          attrs: {
                            placeholder: "请输入备注内容",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.bznr,
                            callback: function($$v) {
                              _vm.bznr = $$v
                            },
                            expression: "bznr"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 10,
                            expression: "zncjxstep == 10"
                          }
                        ],
                        staticClass: "btn10",
                        on: { click: _vm.sixStepByStep4 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 11,
                          expression: "zncjxstep == 11"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(306)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 12,
                          expression: "zncjxstep == 12"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(322)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 12,
                            expression: "zncjxstep == 12"
                          }
                        ],
                        staticClass: "btn12",
                        on: { click: _vm.sixStepByStep5 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 13,
                          expression: "zncjxstep == 13"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(323)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 14,
                          expression: "zncjxstep == 14"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(77)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 14,
                            expression: "zncjxstep == 14"
                          }
                        ],
                        staticClass: "btn14",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 15
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 15,
                          expression: "zncjxstep == 15"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(393)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "phone"
                      },
                      [_vm._v("13656565656")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "phone-c",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "phone-input",
                          attrs: { placeholder: "请输入" },
                          model: {
                            value: _vm.phone,
                            callback: function($$v) {
                              _vm.phone = $$v
                            },
                            expression: "phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "btn15",
                        on: { click: _vm.sixStepByStep6 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 16,
                          expression: "zncjxstep == 16"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(77)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.zncjxstep == 1
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("未付款客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 2
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已付款")
                        ]),
                        _vm._v("待发货"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 3 || _vm.zncjxstep == 4
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已发货")
                        ]),
                        _vm._v("待收货"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 5 || _vm.zncjxstep == 6
                    ? _c("p", [
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("订单操作区")
                        ]),
                        _vm._v("中的"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("催付")
                        ]),
                        _vm._v("按钮，给客户发送催付卡片")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 7
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("根据聊天内容")
                        ]),
                        _vm._v("在"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("订单操作区")
                        ]),
                        _vm._v("的"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("改价")
                        ]),
                        _vm._v("中"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("修改邮费")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 8 ||
                  _vm.zncjxstep == 9 ||
                  _vm.zncjxstep == 10 ||
                  _vm.zncjxstep == 11
                    ? _c("p", [
                        _vm._v("【假设商家要求"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("发顺丰")
                        ]),
                        _vm._v("的客户插"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("红色")
                        ]),
                        _vm._v("旗子】请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("添加订单备注，并勾选对应的彩旗。")
                        ]),
                        _c("br"),
                        _vm._v("备注内容为：发顺丰")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 12 || _vm.zncjxstep == 13
                    ? _c("p", [
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("订单操作区")
                        ]),
                        _vm._v("中的"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("核对订单")
                        ]),
                        _vm._v("按钮，给客户发送订单卡片")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 14 ||
                  _vm.zncjxstep == 15 ||
                  _vm.zncjxstep == 16
                    ? _c("p", [
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("订单操作区")
                        ]),
                        _vm._v("中的"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("改址")
                        ]),
                        _vm._v("按钮，修改客户电话")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySix }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six1")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-智能客服插件(下).ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt6(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt6 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six1" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("7、添加其他插件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six1" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six1",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step61.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six1" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six1" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "qtcj-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 1,
                          expression: "qtcjStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(461)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 2,
                          expression: "qtcjStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(462)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 1 || _vm.qtcjStep == 2,
                            expression: "qtcjStep == 1 || qtcjStep == 2"
                          }
                        ],
                        staticClass: "gfkf-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "gfkf-input",
                          attrs: { placeholder: "联系人、订单号、聊天记录" },
                          on: { input: _vm.onGfkfInput },
                          model: {
                            value: _vm.gfkf,
                            callback: function($$v) {
                              _vm.gfkf = $$v
                            },
                            expression: "gfkf"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 2,
                            expression: "qtcjStep == 2"
                          }
                        ],
                        staticClass: "gfkf-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 3,
                          expression: "qtcjStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(463)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 3,
                            expression: "qtcjStep == 3"
                          }
                        ],
                        staticClass: "cjzx-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 4,
                          expression: "qtcjStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(464)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 4,
                            expression: "qtcjStep == 4"
                          }
                        ],
                        staticClass: "fbtzj-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 5,
                          expression: "qtcjStep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(465)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 5,
                            expression: "qtcjStep == 5"
                          }
                        ],
                        staticClass: "lzykf-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 6,
                          expression: "qtcjStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(466)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 6,
                            expression: "qtcjStep == 6"
                          }
                        ],
                        staticClass: "closecjzx-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 7
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 7,
                          expression: "qtcjStep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(467)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 7,
                            expression: "qtcjStep == 7"
                          }
                        ],
                        staticClass: "fbt-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 8
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 8,
                          expression: "qtcjStep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(468)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 8,
                            expression: "qtcjStep == 8"
                          }
                        ],
                        staticClass: "ly-btn",
                        on: { click: _vm.six1StepEnd }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.qtcjStep == 1 || _vm.qtcjStep == 2
                    ? _c("p", [
                        _vm._v("请搜索"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("天猫官方客服")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 3
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("打开插件中心")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 4
                    ? _c("p", [
                        _vm._v("请添加"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("FBT咨询")
                        ]),
                        _vm._v("插件")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 5
                    ? _c("p", [
                        _vm._v("请添加"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("瓴羊客服")
                        ]),
                        _vm._v("插件")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 6
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("关闭插件中心")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 7
                    ? _c("p", [
                        _vm._v("此页面右侧是"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("FBT插件")
                        ]),
                        _vm._v("功能区。"),
                        _c("br"),
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("订单备注")
                        ]),
                        _vm._v("按钮")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 8
                    ? _c("p", [
                        _vm._v("此页面右侧是"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("瓴羊插件")
                        ]),
                        _vm._v("功能区。"),
                        _c("br"),
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("物流详情")
                        ]),
                        _vm._v("按钮")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six1" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySix1 }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-其他插件.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt61(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt61 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer61" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("8、售后客服常用功能")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step7.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "sh-cygn" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 1 && !_vm.mouseFocusDdsc,
                          expression: "shcygnStep == 1 && !mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(370)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 1 && _vm.mouseFocusDdsc,
                          expression: "shcygnStep == 1 && mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(372)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 1,
                            expression: "shcygnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusDdsc = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDdsc = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 2,
                          expression: "shcygnStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(373)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 2,
                            expression: "shcygnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.shcygnStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 3 && !_vm.mouseFocus,
                          expression: "shcygnStep == 3 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(374)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 3 && _vm.mouseFocus,
                          expression: "shcygnStep == 3 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(375)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 3,
                            expression: "shcygnStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 4 && !_vm.mouseFocusFZ,
                          expression: "shcygnStep == 4 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(376)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 4 && _vm.mouseFocusFZ,
                          expression: "shcygnStep == 4 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(377)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 4,
                            expression: "shcygnStep == 4"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 5 && !_vm.mouseFocusFZI,
                          expression: "shcygnStep == 5 && !mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(378)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 5 && _vm.mouseFocusFZI,
                          expression: "shcygnStep == 5 && mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(379)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 5,
                            expression: "shcygnStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZI = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZI = false
                          },
                          click: _vm.sevenStepEnd
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 6,
                          expression: "shcygnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(371)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.shcygnStep == 1
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("工作台")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 2 || _vm.shcygnStep == 3
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("交易→已卖出宝贝")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 4
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("评价管理")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 5 || _vm.shcygnStep == 6
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("退款管理")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySeven }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-售后客服常用功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt7
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt7(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt7 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer7" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "eight" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("9、退出千牛")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-eight" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "eight",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/step8.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcqn" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 1,
                          expression: "tcqnStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(380)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 1,
                            expression: "tcqnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 2 && !_vm.mouseFocus,
                          expression: "tcqnStep == 2 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(381)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 2 && _vm.mouseFocus,
                          expression: "tcqnStep == 2 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(382)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 2,
                            expression: "tcqnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.tcqnStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 3,
                          expression: "tcqnStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(383)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 3,
                            expression: "tcqnStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 4,
                          expression: "tcqnStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(384)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 4,
                            expression: "tcqnStep == 4"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 5 && !_vm.mouseFocusFZ,
                          expression: "tcqnStep == 5 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(385)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 5 && _vm.mouseFocusFZ,
                          expression: "tcqnStep == 5 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(386)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 5,
                            expression: "tcqnStep == 5"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.tcqnStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 6,
                          expression: "tcqnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(387)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 6,
                            expression: "tcqnStep == 6"
                          }
                        ],
                        staticClass: "btn5",
                        on: { click: _vm.eightStepEnd }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("请将状态切换为"),
                    _c("span", { staticClass: "red-span" }, [
                      _vm._v("挂起，再退出千牛")
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _vm.examNum
                    ? _c("div", { staticStyle: { "margin-top": "5px" } }, [
                        _vm._v(
                          "\n                            你已完成\n                            "
                        ),
                        _c("b", { staticStyle: { color: "#66B1FF" } }, [
                          _vm._v(_vm._s(_vm.myExamNum))
                        ]),
                        _vm._v(
                          "\n                            次，需完成\n                            "
                        ),
                        _c("b", { staticStyle: { color: "#66B1FF" } }, [
                          _vm._v(_vm._s(_vm.examNum))
                        ]),
                        _vm._v("\n                            次\n\t\t\t\t\t\t")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-top": "5px" } }, [
                    _vm._v("你已完成千牛的功能学习，")
                  ]),
                  _vm._v(" "),
                  !_vm.examNum || _vm.myExamNum >= _vm.examNum
                    ? _c("div", { staticStyle: { "margin-top": "5px" } }, [
                        _vm._v("接下来请完成《千牛模拟实操》。")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.examNum || _vm.myExamNum >= _vm.examNum
                    ? _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px", "margin-top": "5px" },
                          on: { click: _vm.goExam }
                        },
                        [_vm._v("去完成千牛模拟实操")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px" },
                          on: { click: _vm.goExam }
                        },
                        [_vm._v("继续学习")]
                      )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(10)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("千牛练习-退出千牛.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt8
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt8(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt8 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer8" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9746b60", esExports)
  }
}

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniuExam_vue__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniuExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniuExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniuExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniuExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2926230f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qianniuExam_vue__ = __webpack_require__(1701);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1699)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2926230f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qianniuExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2926230f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qianniuExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/qianniuExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2926230f", Component.options)
  } else {
    hotAPI.reload("data-v-2926230f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1700);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("44f130bc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2926230f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./qianniuExam.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2926230f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./qianniuExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-2926230f] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-2926230f] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.mynone[data-v-2926230f] {\n  display: none !important;\n}\n.red-span[data-v-2926230f] {\n  color: red;\n  font-weight: bold;\n}\n", ""]);

// exports


/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newQianniuExamex" } }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          "align-items": "center",
          "margin-bottom": "10px",
          cursor: "pointer",
          width: "100px"
        },
        on: { click: _vm.goBack }
      },
      [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-left": "10px" } }, [_vm._v("返回")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isShowQnIcon ||
                              _vm.isShowLoginImg ||
                              _vm.isShowRnd,
                            expression:
                              "isShowQnIcon || isShowLoginImg || isShowRnd"
                          }
                        ],
                        staticClass: "qnbox",
                        staticStyle: { "user-select": "none" }
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.mouseFocus,
                              expression: "!mouseFocus"
                            }
                          ],
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(354)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mouseFocus,
                              expression: "mouseFocus"
                            }
                          ],
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(75)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "qnicon01",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocus = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocus = false
                            },
                            click: _vm.showLoginImg
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowLoginImg,
                                expression: "isShowLoginImg"
                              }
                            ],
                            staticClass: "login",
                            staticStyle: { "user-select": "none" }
                          },
                          [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isSaveAP,
                                  expression: "isSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(347)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSaveAP && _vm.mouseFocusSaveAP,
                                  expression: "!isSaveAP && mouseFocusSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(346)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSaveAP && !_vm.mouseFocusSaveAP,
                                  expression: "!isSaveAP && !mouseFocusSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: __webpack_require__(345)
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.name,
                                  expression: "name",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "name",
                              attrs: {
                                type: "text",
                                placeholder: "请输入账号"
                              },
                              domProps: { value: _vm.name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.name = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.password,
                                  expression: "password",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "password",
                              attrs: {
                                type: "password",
                                autocomplete: "new-password",
                                placeholder: "请输入密码"
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "hovertag",
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusSaveAP = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusSaveAP = false
                                },
                                click: function($event) {
                                  _vm.isSaveAP = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "logIn",
                              on: { click: _vm.loginIn }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowRnd,
                                expression: "isShowRnd"
                              }
                            ],
                            staticClass: "loginrnd"
                          },
                          [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showRnd,
                                  expression: "showRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(353)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showRnd && _vm.mouseFocusRnd,
                                  expression: "!showRnd && mouseFocusRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(352)
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showRnd && !_vm.mouseFocusRnd,
                                  expression: "!showRnd && !mouseFocusRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: __webpack_require__(351)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sendRnd",
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusRnd = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusRnd = false
                                },
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.rnd,
                                  expression: "rnd",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "rnd",
                              attrs: {
                                type: "text",
                                placeholder: "短信验证码"
                              },
                              domProps: { value: _vm.rnd },
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusRnd = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusRnd = false
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.rnd = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "logInRnd",
                              on: { click: _vm.loginInRnd }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowQnIcon2,
                            expression: "isShowQnIcon2"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: __webpack_require__(75)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "qnicon02",
                          on: { dblclick: _vm.showLoginImg2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowLoginIndex,
                            expression: "isShowLoginIndex"
                          }
                        ],
                        staticClass: "jdbox"
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mouseFocusJD,
                              expression: "mouseFocusJD"
                            }
                          ],
                          staticClass: "jdimg",
                          attrs: {
                            src: __webpack_require__(348)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.mouseFocusJD,
                              expression: "!mouseFocusJD"
                            }
                          ],
                          staticClass: "jdimg",
                          attrs: {
                            src: __webpack_require__(349)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "jdicon",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusJD = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusJD = false
                            },
                            click: _vm.enterJd
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowLoginIndexTwo,
                            expression: "isShowLoginIndexTwo"
                          }
                        ],
                        staticClass: "indexbox"
                      },
                      [
                        _c("img", {
                          staticClass: "indeximg",
                          attrs: {
                            src: __webpack_require__(350)
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "red-span" }, [
                            _vm._v("登录")
                          ]),
                          _vm._v("千牛工作台，并进入"),
                          _c("span", { staticClass: "red-span" }, [
                            _vm._v("接待中心")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [_vm._m(2), _vm._v(" "), _vm._m(3)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [_vm.showRnd ? [_vm._m(4)] : [_vm._m(5)]]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex ? [_vm._m(6)] : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 1,
                          expression: "secondStep == 1"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 1,
                            expression: "gqstep == 1"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(76)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.gqstep == 1,
                              expression: "gqstep == 1"
                            }
                          ],
                          staticClass: "gqbtn",
                          on: {
                            click: function($event) {
                              _vm.gqstep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 2 && _vm.mouseFocusZX,
                            expression: "gqstep == 2 && mouseFocusZX"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(365)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 2 && !_vm.mouseFocusZX,
                            expression: "gqstep == 2 && !mouseFocusZX"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(364)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.gqstep == 2,
                              expression: "gqstep == 2"
                            }
                          ],
                          staticClass: "gqclick",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusZX = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusZX = false
                            },
                            click: function($event) {
                              _vm.secondStep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 2,
                          expression: "secondStep == 2"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 1,
                            expression: "wgqstep == 1"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(366)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 1,
                              expression: "wgqstep == 1"
                            }
                          ],
                          staticClass: "gqbtn",
                          on: {
                            click: function($event) {
                              _vm.wgqstep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 2 && _vm.mouseFocusGQ,
                            expression: "wgqstep == 2 && mouseFocusGQ"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(368)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 2 && !_vm.mouseFocusGQ,
                            expression: "wgqstep == 2 && !mouseFocusGQ"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(367)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 2,
                              expression: "wgqstep == 2"
                            }
                          ],
                          staticClass: "gqclick",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusGQ = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusGQ = false
                            },
                            click: function($event) {
                              _vm.wgqstep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 3,
                            expression: "wgqstep == 3"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(369)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 3,
                              expression: "wgqstep == 3"
                            }
                          ],
                          staticClass: "cgqbtn",
                          on: {
                            click: function($event) {
                              _vm.secondStep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 3,
                          expression: "secondStep == 3"
                        }
                      ],
                      staticClass: "second-step3"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 1,
                            expression: "secondStepStep == 1"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(76)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 1,
                            expression: "secondStepStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.secondStepStep = 2
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && !_vm.mouseFocusDdsc,
                            expression: "secondStepStep == 2 && !mouseFocusDdsc"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(361)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && _vm.mouseFocusDdsc,
                            expression: "secondStepStep == 2 && mouseFocusDdsc"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(362)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 2,
                              expression: "secondStepStep == 2"
                            }
                          ],
                          staticClass: "btn2",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusDdsc = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusDdsc = false
                            },
                            click: function($event) {
                              _vm.secondStep = 4
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 4,
                          expression: "secondStep == 4"
                        }
                      ],
                      staticClass: "second-step3"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && !_vm.mouseFocusSet,
                            expression: "secondStepStep == 2 && !mouseFocusSet"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(363)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 2 && _vm.mouseFocusSet,
                            expression: "secondStepStep == 2 && mouseFocusSet"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(355)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 2,
                              expression: "secondStepStep == 2"
                            }
                          ],
                          staticClass: "btn3",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSet = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSet = false
                            },
                            click: function($event) {
                              _vm.secondStepStep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 3 && !_vm.mouseFocusSetInfo,
                            expression:
                              "secondStepStep == 3 && !mouseFocusSetInfo"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(356)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 3 && _vm.mouseFocusSetInfo,
                            expression:
                              "secondStepStep == 3 && mouseFocusSetInfo"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: __webpack_require__(357)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 3,
                              expression: "secondStepStep == 3"
                            }
                          ],
                          staticClass: "btn4",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSetInfo = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSetInfo = false
                            },
                            click: function($event) {
                              _vm.secondStepStep = 4
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 4 &&
                              !_vm.mouseFocusSetInfoDetail,
                            expression:
                              "secondStepStep == 4 && !mouseFocusSetInfoDetail"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(358)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 4 &&
                              _vm.mouseFocusSetInfoDetail,
                            expression:
                              "secondStepStep == 4 && mouseFocusSetInfoDetail"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(359)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 4,
                              expression: "secondStepStep == 4"
                            }
                          ],
                          staticClass: "btn5",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSetInfoDetail = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSetInfoDetail = false
                            },
                            click: _vm.showGqImgClick
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 5,
                            expression: "secondStepStep == 5"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: __webpack_require__(360)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _vm.secondStep == 1
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("在线")]
                        )
                      ])
                    : _vm.secondStep == 2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("挂起")]
                        )
                      ])
                    : _vm.secondStep == 3
                    ? _c("p", [
                        _vm._v("请将接待排序设置为："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("按客户等待时长排序")]
                        )
                      ])
                    : _vm.secondStep == 4
                    ? _c("p", [
                        _vm._v("请确认"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("店铺分流")
                        ]),
                        _vm._v("和"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("账号分流")
                        ]),
                        _vm._v("是否开启")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "jdgkbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 1,
                          expression: "kjdyStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(324)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 1,
                            expression: "kjdyStep == 1"
                          }
                        ],
                        staticClass: "search-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "search",
                          attrs: { placeholder: "联系人,订单号，聊天记录" },
                          on: { input: _vm.kjdySearchChange },
                          model: {
                            value: _vm.kjdySearch,
                            callback: function($$v) {
                              _vm.kjdySearch = $$v
                            },
                            expression: "kjdySearch"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 2,
                          expression: "kjdyStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(335)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 2,
                            expression: "kjdyStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 3 && !_vm.mouseFocusKJDY,
                          expression: "kjdyStep == 3 && !mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(338)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 3 && _vm.mouseFocusKJDY,
                          expression: "kjdyStep == 3 && mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(339)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 3,
                            expression: "kjdyStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusKJDY = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusKJDY = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 4,
                          expression: "kjdyStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(340)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 4,
                            expression: "kjdyStep == 4"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _vm.kjdyStep == 5
                      ? _c("img", {
                          staticClass: "img-base",
                          attrs: {
                            src: __webpack_require__(341)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 5,
                            expression: "kjdyStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 6 && !_vm.mouseFocusFZ,
                          expression: "kjdyStep == 6 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(342)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 6 && _vm.mouseFocusFZ,
                          expression: "kjdyStep == 6 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(343)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 6,
                            expression: "kjdyStep == 6"
                          }
                        ],
                        staticClass: "btn6",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 7
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7 && !_vm.mouseFocusFZI,
                          expression: "kjdyStep == 7 && !mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(344)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7 && _vm.mouseFocusFZI,
                          expression: "kjdyStep == 7 && mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(325)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 7,
                            expression: "kjdyStep == 7"
                          }
                        ],
                        staticClass: "kjdyfz-c",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZI = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZI = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjfz-input",
                          attrs: { placeholder: "请输入分组" },
                          model: {
                            value: _vm.kjdyfz,
                            callback: function($$v) {
                              _vm.kjdyfz = $$v
                            },
                            expression: "kjdyfz"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7,
                          expression: "kjdyStep == 7"
                        }
                      ],
                      staticClass: "btn7",
                      on: { click: _vm.kjdyfzConfirm }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 8,
                          expression: "kjdyStep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(326)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.kjdyStep == 5 ||
                              _vm.kjdyStep == 6 ||
                              _vm.kjdyStep == 8,
                            expression:
                              "kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8"
                          }
                        ],
                        staticClass: "kjbm-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjbm-input",
                          model: {
                            value: _vm.kjdybm,
                            callback: function($$v) {
                              _vm.kjdybm = $$v
                            },
                            expression: "kjdybm"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.kjdyStep == 5 ||
                              _vm.kjdyStep == 6 ||
                              _vm.kjdyStep == 8,
                            expression:
                              "kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8"
                          }
                        ],
                        staticClass: "kjdy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdy-input",
                          attrs: {
                            placeholder: "请输入快捷短语",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.kjdynr,
                            callback: function($$v) {
                              _vm.kjdynr = $$v
                            },
                            expression: "kjdynr"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 8,
                            expression: "kjdyStep == 8"
                          }
                        ],
                        staticClass: "btn8",
                        on: { click: _vm.kjdyConfirm }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 9,
                          expression: "kjdyStep == 9"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(327)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 9,
                            expression: "kjdyStep == 9"
                          }
                        ],
                        staticClass: "btn9",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 10
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 10,
                          expression: "kjdyStep == 10"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(328)
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput",
                      staticClass: "btn-file",
                      attrs: { type: "file" },
                      on: {
                        change: function($event) {
                          return _vm.tirggerFile($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 11,
                          expression: "kjdyStep == 11"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(329)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 11,
                            expression: "kjdyStep == 11"
                          }
                        ],
                        staticClass: "btn11",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 12
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 12 && !_vm.mouseFocusKJDY,
                          expression: "kjdyStep == 12 && !mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(330)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 12 && _vm.mouseFocusKJDY,
                          expression: "kjdyStep == 12 && mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(331)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 12,
                            expression: "kjdyStep == 12"
                          }
                        ],
                        staticClass: "btn12",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusKJDY = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusKJDY = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 13
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 13,
                          expression: "kjdyStep == 13"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(332)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 13
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "btn133",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              _vm.kjdyStep = 14
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 13,
                            expression: "kjdyStep == 13"
                          }
                        ],
                        staticClass: "btn13",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 14
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 14,
                          expression: "kjdyStep == 14"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(333)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 14,
                            expression: "kjdyStep == 14"
                          }
                        ],
                        staticClass: "kjdyfs-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdyfs-input",
                          attrs: { type: "textarea" },
                          on: { input: _vm.kjdyfsChange },
                          model: {
                            value: _vm.kjdyfs,
                            callback: function($$v) {
                              _vm.kjdyfs = $$v
                            },
                            expression: "kjdyfs"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 15,
                          expression: "kjdyStep == 15"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(334)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 15
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "btn155",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.enterSelect.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 15,
                            expression: "kjdyStep == 15"
                          }
                        ],
                        staticClass: "btn15",
                        on: { click: _vm.enterSelect }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 16,
                          expression: "kjdyStep == 16"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(336)
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 16
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          ref: "sixInput",
                          staticClass: "btn16",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.finishThird.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 16,
                            expression: "kjdyStep == 16"
                          }
                        ],
                        staticClass: "btn13",
                        on: { click: _vm.finishThird }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 17,
                          expression: "kjdyStep == 17"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(337)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(8),
                    _vm._v(" "),
                    _vm.kjdyStep == 1 || _vm.kjdyStep == 2
                      ? _c("p", [
                          _vm._v("请搜索登录账号"),
                          _c("br"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("淘金云客服:小淘")]
                          ),
                          _vm._v("打开会话窗口")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 3
                      ? _c("p", [
                          _vm._v("请"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("打开快捷短语")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 4 ||
                    _vm.kjdyStep == 5 ||
                    _vm.kjdyStep == 6 ||
                    _vm.kjdyStep == 7 ||
                    _vm.kjdyStep == 8
                      ? [
                          _vm._m(9),
                          _vm._v(" "),
                          _vm._m(10),
                          _vm._v(" "),
                          _vm._m(11)
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 9 ||
                    _vm.kjdyStep == 10 ||
                    _vm.kjdyStep == 11
                      ? [
                          _vm._m(12),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 12 || _vm.kjdyStep == 13
                      ? [_vm._m(13)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 14 ||
                    _vm.kjdyStep == 15 ||
                    _vm.kjdyStep == 16 ||
                    _vm.kjdyStep == 17
                      ? [_vm._m(14)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cygnbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 1,
                          expression: "cygnStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(309)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 1,
                            expression: "cygnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.cygnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 2 && !_vm.mouseFocusDdsc,
                          expression: "cygnStep == 2 && !mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(311)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 2 && _vm.mouseFocusDdsc,
                          expression: "cygnStep == 2 && mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(312)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 2,
                            expression: "cygnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusDdsc = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDdsc = false
                          },
                          click: _vm.fourStepBystep
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 3,
                          expression: "cygnStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(313)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 4 && !_vm.mouseFocus,
                          expression: "cygnStep == 4 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(314)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 4 && _vm.mouseFocus,
                          expression: "cygnStep == 4 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(315)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 4,
                            expression: "cygnStep == 4"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.cygnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 5,
                          expression: "cygnStep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(316)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 5,
                            expression: "cygnStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          click: function($event) {
                            _vm.cygnStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 6,
                          expression: "cygnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(317)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 6,
                            expression: "cygnStep == 6"
                          }
                        ],
                        staticClass: "zfyy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "zjyy-input",
                          attrs: { placeholder: "请输入转交原因" },
                          model: {
                            value: _vm.zjyy,
                            callback: function($$v) {
                              _vm.zjyy = $$v
                            },
                            expression: "zjyy"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 6,
                            expression: "cygnStep == 6"
                          }
                        ],
                        staticClass: "btn6",
                        on: { click: _vm.sendZfyy }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 7,
                          expression: "cygnStep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(310)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(15),
                  _vm._v(" "),
                  _vm.cygnStep == 1 || _vm.cygnStep == 2 || _vm.cygnStep == 3
                    ? _c("p", [
                        _vm._v("请给当前用户标记"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("黄色星星")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cygnStep == 4 ||
                  _vm.cygnStep == 5 ||
                  _vm.cygnStep == 6 ||
                  _vm.cygnStep == 7
                    ? _c("p", [
                        _vm._v("请将当前用户"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("转发")
                        ]),
                        _vm._v("给"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("小金")
                        ]),
                        _vm._v("，转交原因填写"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("少件")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zncj-top-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 1 && !_vm.mouseFocus,
                          expression: "zncjsstep == 1 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(388)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 1 && _vm.mouseFocus,
                          expression: "zncjsstep == 1 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(389)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjsstep == 1,
                            expression: "zncjsstep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.zncjsstep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 2 && !_vm.mouseFocus,
                          expression: "zncjsstep == 2 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(390)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 2 && _vm.mouseFocus,
                          expression: "zncjsstep == 2 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(391)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjsstep == 2,
                            expression: "zncjsstep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: _vm.tjspEnd
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 3,
                          expression: "zncjsstep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(392)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(16),
                  _vm._v(" "),
                  _vm.zncjsstep == 1 || _vm.zncjsstep == 2 || _vm.zncjsstep == 3
                    ? _c("p", [
                        _vm._v("请将"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("足迹")
                        ]),
                        _vm._v("中"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("符合客户需求")
                        ]),
                        _vm._v("的商品发送给客户")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zncj-bottom-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 1,
                          expression: "zncjxstep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(318)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 1,
                            expression: "zncjxstep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 2,
                          expression: "zncjxstep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(319)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 2,
                            expression: "zncjxstep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 3,
                          expression: "zncjxstep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(320)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 3,
                            expression: "zncjxstep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: { click: _vm.sixStepByStep }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 4,
                          expression: "zncjxstep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(321)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 5,
                          expression: "zncjxstep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(307)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 5,
                            expression: "zncjxstep == 5"
                          }
                        ],
                        staticClass: "btn6",
                        on: { click: _vm.sixStepByStep2 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 6,
                          expression: "zncjxstep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(308)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 7,
                          expression: "zncjxstep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(394)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7,
                            expression: "zncjxstep == 7"
                          }
                        ],
                        staticClass: "btn7",
                        on: {
                          click: function($event) {
                            _vm.showYfstep = true
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.zncjxstep == 7 &&
                            _vm.showYfstep &&
                            !_vm.mouseFocus,
                          expression:
                            "zncjxstep == 7 && showYfstep && !mouseFocus"
                        }
                      ],
                      staticClass: "img-yf",
                      attrs: {
                        src: __webpack_require__(396)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.zncjxstep == 7 &&
                            _vm.showYfstep &&
                            _vm.mouseFocus,
                          expression:
                            "zncjxstep == 7 && showYfstep && mouseFocus"
                        }
                      ],
                      staticClass: "img-yf",
                      attrs: {
                        src: __webpack_require__(397)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7 && _vm.showYfstep,
                            expression: "zncjxstep == 7 && showYfstep"
                          }
                        ],
                        class: {
                          "yf-c": !_vm.mouseFocus,
                          "yf-c1": _vm.mouseFocus
                        },
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "yf-input",
                          attrs: { placeholder: "请输入邮费" },
                          model: {
                            value: _vm.yfamount,
                            callback: function($$v) {
                              _vm.yfamount = $$v
                            },
                            expression: "yfamount"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7 && _vm.showYfstep,
                            expression: "zncjxstep == 7 && showYfstep"
                          }
                        ],
                        staticClass: "btn77",
                        on: { click: _vm.sixStepByStep3 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 8,
                          expression: "zncjxstep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(395)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 8,
                            expression: "zncjxstep == 8"
                          }
                        ],
                        staticClass: "btn8",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 9
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 9,
                          expression: "zncjxstep == 9"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(304)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 9,
                            expression: "zncjxstep == 9"
                          }
                        ],
                        staticClass: "btn9",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 10
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 10,
                          expression: "zncjxstep == 10"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(305)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 10 || _vm.zncjxstep == 9,
                            expression: "zncjxstep == 10 || zncjxstep == 9"
                          }
                        ],
                        staticClass: "kjdy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdy-input",
                          attrs: {
                            placeholder: "请输入备注内容",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.bznr,
                            callback: function($$v) {
                              _vm.bznr = $$v
                            },
                            expression: "bznr"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 10,
                            expression: "zncjxstep == 10"
                          }
                        ],
                        staticClass: "btn10",
                        on: { click: _vm.sixStepByStep4 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 11,
                          expression: "zncjxstep == 11"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(306)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 12,
                          expression: "zncjxstep == 12"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(322)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 12,
                            expression: "zncjxstep == 12"
                          }
                        ],
                        staticClass: "btn12",
                        on: { click: _vm.sixStepByStep5 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 13,
                          expression: "zncjxstep == 13"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(323)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 14,
                          expression: "zncjxstep == 14"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(77)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 14,
                            expression: "zncjxstep == 14"
                          }
                        ],
                        staticClass: "btn14",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 15
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 15,
                          expression: "zncjxstep == 15"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(393)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "phone"
                      },
                      [_vm._v("13656565656")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "phone-c",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "phone-input",
                          attrs: { placeholder: "请输入" },
                          model: {
                            value: _vm.phone,
                            callback: function($$v) {
                              _vm.phone = $$v
                            },
                            expression: "phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "btn15",
                        on: { click: _vm.sixStepByStep6 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 16,
                          expression: "zncjxstep == 16"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(77)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(17),
                  _vm._v(" "),
                  _vm.zncjxstep == 1
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("未付款客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 2
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已付款")
                        ]),
                        _vm._v("待发货"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 3 || _vm.zncjxstep == 4
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已发货")
                        ]),
                        _vm._v("待收货"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 5 || _vm.zncjxstep == 6
                    ? _c("p", [
                        _vm._v("请给客户发送"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("催付")
                        ]),
                        _vm._v("卡片")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 7
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("根据聊天内容，修改邮费")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 8 ||
                  _vm.zncjxstep == 9 ||
                  _vm.zncjxstep == 10 ||
                  _vm.zncjxstep == 11
                    ? _c("p", [
                        _vm._v("【假设商家要求"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("发顺丰")
                        ]),
                        _vm._v("的客户插"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("红色")
                        ]),
                        _vm._v("旗子】请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("添加订单备注，并勾选对应的彩旗。")
                        ]),
                        _c("br"),
                        _vm._v("备注内容为：发顺丰")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 12 || _vm.zncjxstep == 13
                    ? _c("p", [
                        _vm._v("请给客户发送"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("核对订单")
                        ]),
                        _vm._v("卡片")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 14 ||
                  _vm.zncjxstep == 15 ||
                  _vm.zncjxstep == 16
                    ? _c("p", [_vm._v("请修改客户电话")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six1", 7, "six1")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six1" },
            attrs: { id: "tab-six1-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six1" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six1" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "qtcj-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 1,
                          expression: "qtcjStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(461)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 2,
                          expression: "qtcjStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(462)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 1 || _vm.qtcjStep == 2,
                            expression: "qtcjStep == 1 || qtcjStep == 2"
                          }
                        ],
                        staticClass: "gfkf-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "gfkf-input",
                          attrs: { placeholder: "联系人、订单号、聊天记录" },
                          on: { input: _vm.onGfkfInput },
                          model: {
                            value: _vm.gfkf,
                            callback: function($$v) {
                              _vm.gfkf = $$v
                            },
                            expression: "gfkf"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 2,
                            expression: "qtcjStep == 2"
                          }
                        ],
                        staticClass: "gfkf-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 3,
                          expression: "qtcjStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(463)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 3,
                            expression: "qtcjStep == 3"
                          }
                        ],
                        staticClass: "cjzx-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 4,
                          expression: "qtcjStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(464)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 4,
                            expression: "qtcjStep == 4"
                          }
                        ],
                        staticClass: "fbtzj-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 5,
                          expression: "qtcjStep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(465)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 5,
                            expression: "qtcjStep == 5"
                          }
                        ],
                        staticClass: "lzykf-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 6,
                          expression: "qtcjStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(466)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 6,
                            expression: "qtcjStep == 6"
                          }
                        ],
                        staticClass: "closecjzx-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 7
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 7,
                          expression: "qtcjStep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(467)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 7,
                            expression: "qtcjStep == 7"
                          }
                        ],
                        staticClass: "fbt-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 8
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 8,
                          expression: "qtcjStep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(468)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 8,
                            expression: "qtcjStep == 8"
                          }
                        ],
                        staticClass: "ly-btn",
                        on: { click: _vm.six1StepEnd }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(18),
                  _vm._v(" "),
                  _vm.qtcjStep == 1 || _vm.qtcjStep == 2
                    ? _c("p", [
                        _vm._v("请搜索"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("天猫官方客服")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 3
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("打开插件中心")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 4
                    ? _c("p", [
                        _vm._v("请添加"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("FBT咨询")
                        ]),
                        _vm._v("插件")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 5
                    ? _c("p", [
                        _vm._v("请添加"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("瓴羊客服")
                        ]),
                        _vm._v("插件")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 6
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("关闭插件中心")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 7
                    ? _c("p", [
                        _vm._v("此页面右侧是"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("FBT插件")
                        ]),
                        _vm._v("功能区。"),
                        _c("br"),
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("订单备注")
                        ]),
                        _vm._v("按钮")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 8
                    ? _c("p", [
                        _vm._v("此页面右侧是"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("瓴羊插件")
                        ]),
                        _vm._v("功能区。"),
                        _c("br"),
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("物流详情")
                        ]),
                        _vm._v("按钮")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six1" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 8, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "sh-cygn" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 1 && !_vm.mouseFocusDdsc,
                          expression: "shcygnStep == 1 && !mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(370)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 1 && _vm.mouseFocusDdsc,
                          expression: "shcygnStep == 1 && mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(372)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 1,
                            expression: "shcygnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusDdsc = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDdsc = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 2,
                          expression: "shcygnStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(373)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 2,
                            expression: "shcygnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.shcygnStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 3 && !_vm.mouseFocus,
                          expression: "shcygnStep == 3 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(374)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 3 && _vm.mouseFocus,
                          expression: "shcygnStep == 3 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(375)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 3,
                            expression: "shcygnStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 4 && !_vm.mouseFocusFZ,
                          expression: "shcygnStep == 4 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(376)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 4 && _vm.mouseFocusFZ,
                          expression: "shcygnStep == 4 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(377)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 4,
                            expression: "shcygnStep == 4"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 5 && !_vm.mouseFocusFZI,
                          expression: "shcygnStep == 5 && !mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(378)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 5 && _vm.mouseFocusFZI,
                          expression: "shcygnStep == 5 && mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(379)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 5,
                            expression: "shcygnStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZI = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZI = false
                          },
                          click: _vm.sevenStepEnd
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 6,
                          expression: "shcygnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: __webpack_require__(371)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(19),
                  _vm._v(" "),
                  _vm.shcygnStep == 1
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("工作台")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 2 || _vm.shcygnStep == 3
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已卖出宝贝")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 4
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("评价管理")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 5 || _vm.shcygnStep == 6
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("退款管理")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 9, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcqn" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 1,
                          expression: "tcqnStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(380)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 1,
                            expression: "tcqnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 2 && !_vm.mouseFocus,
                          expression: "tcqnStep == 2 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(381)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 2 && _vm.mouseFocus,
                          expression: "tcqnStep == 2 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(382)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 2,
                            expression: "tcqnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.tcqnStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 3,
                          expression: "tcqnStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(383)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 3,
                            expression: "tcqnStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 4,
                          expression: "tcqnStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(384)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 4,
                            expression: "tcqnStep == 4"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 5 && !_vm.mouseFocusFZ,
                          expression: "tcqnStep == 5 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(385)
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 5 && _vm.mouseFocusFZ,
                          expression: "tcqnStep == 5 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(386)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 5,
                            expression: "tcqnStep == 5"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.tcqnStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 6,
                          expression: "tcqnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: __webpack_require__(387)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 6,
                            expression: "tcqnStep == 6"
                          }
                        ],
                        staticClass: "btn5",
                        on: { click: _vm.eightStepEnd }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(20)
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
                  [
                    _c(
                      "div",
                      { staticClass: "tip", staticStyle: { width: "290px" } },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _vm._v(
                                  "\n                                你已完成\n                                "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.myExamNum))
                                ]),
                                _vm._v(
                                  "\n                                次，需完成\n                                "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.examNum))
                                ]),
                                _vm._v(
                                  "\n                                次\n                            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("你已完成千牛模拟实操")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "5px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("返回")]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: { width: "160px" },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("继续学习")]
                            )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("1、登录千牛")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、基础设置（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("4、会话窗口常用功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("5、智能客服插件（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("6、智能客服插件（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six1" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("7、添加其他插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("8、售后客服常用功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("9、退出千牛")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("账号：淘金云客服:小淘")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("密码：Tj1234")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("验证码为：660220")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("获取短信校验码")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("进入接待中心")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("新增一条")
      ]),
      _vm._v("快捷短语。短语内容："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("快捷编码："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("欢迎")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("分组："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("开头语")
      ]),
      _vm._v("（需要自己新增分组）")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请"),
      _c("span", { staticClass: "red-span" }, [_vm._v("先下载")]),
      _vm._v("快捷短语表格"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并保存到桌面上")]),
      _vm._v("，再"),
      _c("span", { staticClass: "red-span" }, [_vm._v("导入")]),
      _vm._v("快捷短语。")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "red-span" }, [_vm._v("鼠标左键")]),
      _vm._v("点击快捷短语的方式，选择"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并发送")]),
      _vm._v("快捷短语："),
      _c("span", { staticClass: "red-span" }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "red-span" }, [_vm._v("/+快捷编码")]),
      _vm._v("点击快捷短语的方式，选择"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并发送")]),
      _vm._v("快捷短语："),
      _c("span", { staticClass: "red-span" }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n                            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("请将状态切换为"),
        _c("span", { staticClass: "red-span" }, [_vm._v("挂起，再退出千牛")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2926230f", esExports)
  }
}

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiChat_vue__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiChat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiChat_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiChat_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiChat_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c93130_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingmaiChat_vue__ = __webpack_require__(1721);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1703)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52c93130"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiChat_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c93130_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingmaiChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/jingmaiChat.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52c93130", Component.options)
  } else {
    hotAPI.reload("data-v-52c93130", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ecde7ae0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-52c93130\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingmaiChat.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-52c93130\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingmaiChat.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* 页面根容器，居中显示 1311px 布局 */\n.jm-page[data-v-52c93130] {\n  width: 1448px;\n  margin: 0 auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n  background: #fff;\n  border-radius: 8px;\n  padding-top: 15px;\n}\n.jm-back[data-v-52c93130] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  width: 100px;\n  margin-left: 8px;\n  margin-bottom: 10px;\n}\n.jm-back .el-icon-arrow-left[data-v-52c93130] {\n  margin-right: 10px;\n}\n.jm-back-text[data-v-52c93130] {\n  margin-left: 0;\n}\n/* 上方空白占位，可根据需要调整高度 */\n.jm-spacer[data-v-52c93130] {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  background-color: #f6f6f6;\n}\n/* 相对定位的容器，固定 1311 x 751 */\n.jm-container[data-v-52c93130] {\n  position: relative;\n  width: 1448px;\n  height: 917px;\n  overflow: hidden;\n}\n/* 等宽高图片，用作“背景”，不直接写到容器样式上 */\n.jm-bg[data-v-52c93130] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 817px;\n  object-fit: cover;\n  pointer-events: none;\n}\n/* 业务内容容器，覆盖在背景图上层 */\n.jm-content[data-v-52c93130] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* 快捷短语分组与子项样式 */\n}\n.jm-content .status-select[data-v-52c93130] {\n  position: absolute;\n  width: 65px;\n  left: 130px;\n  top: 62px;\n  height: 25px;\n}\n.jm-content .status-select[data-v-52c93130] .el-input__inner {\n  height: 25px;\n  line-height: 25px;\n  padding: 0 24px 0 8px;\n  font-size: 13px;\n  border: none;\n  box-shadow: none;\n  border-color: transparent;\n}\n.jm-content .status-select[data-v-52c93130] .el-input.is-focus .el-input__inner,\n.jm-content .status-select[data-v-52c93130] .el-input__inner:focus,\n.jm-content .status-select[data-v-52c93130] .el-input__inner:hover {\n  border: none !important;\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n.jm-content .status-select[data-v-52c93130] .el-input__icon {\n  line-height: 25px;\n}\n.jm-content .keyword-input[data-v-52c93130] {\n  position: absolute;\n  width: 200px;\n  left: 830px;\n  top: 103px;\n  height: 25px;\n  /* 调整清空按钮位置与垂直居中 */\n}\n.jm-content .keyword-input[data-v-52c93130] .el-input__inner {\n  height: 25px;\n  line-height: 25px;\n  padding: 0 22px 0 8px;\n  /* 预留右侧空白给清空按钮 */\n  font-size: 13px;\n  background-color: #F7F7F7;\n  border: none;\n  box-shadow: none;\n  border-color: transparent;\n}\n.jm-content .keyword-input[data-v-52c93130] .el-input__suffix {\n  right: 4px;\n  height: 25px;\n  display: flex;\n  align-items: center;\n}\n.jm-content .keyword-input[data-v-52c93130] .el-input__clear {\n  line-height: 25px;\n  height: 25px;\n}\n.jm-content .keyword-input[data-v-52c93130] .el-input.is-focus .el-input__inner,\n.jm-content .keyword-input[data-v-52c93130] .el-input__inner:focus,\n.jm-content .keyword-input[data-v-52c93130] .el-input__inner:hover {\n  border: none !important;\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n.jm-content .chat-msg-input[data-v-52c93130] {\n  position: absolute;\n  width: 460px;\n  height: 152px;\n  left: 343px;\n  top: 622px;\n  background: #F7F7F7;\n}\n.jm-content .reply-textarea[data-v-52c93130] .el-textarea__inner {\n  height: 100% !important;\n  min-height: 100% !important;\n  max-height: 100% !important;\n  background: #F7F7F7;\n  border: none;\n  box-shadow: none;\n  font-size: 14px;\n  line-height: 22px;\n}\n.jm-content .chat-msg-toolbar[data-v-52c93130] {\n  position: absolute;\n  left: 652px;\n  top: 777px;\n  display: flex;\n  background: #F7F7F7;\n}\n.jm-content .orders-list[data-v-52c93130] {\n  position: absolute;\n  width: 360px;\n  height: 433px;\n  right: 5px;\n  top: 178px;\n  background: #F0F0F0;\n  padding: 10px;\n  box-sizing: border-box;\n}\n.jm-content .order-card[data-v-52c93130] {\n  background: #fff;\n  border-radius: 6px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n}\n.jm-content .order-top[data-v-52c93130] {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 6px;\n  background: #f7f8fa;\n  border-radius: 4px;\n  padding: 6px 8px;\n}\n.jm-content .copy-icon[data-v-52c93130] {\n  color: #999;\n  font-size: 12px;\n  margin-left: 6px;\n}\n.jm-content .order-time[data-v-52c93130] {\n  font-size: 12px;\n}\n.jm-content .order-time .pay-time[data-v-52c93130] {\n  color: #666;\n}\n.jm-content .order-header[data-v-52c93130] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.jm-content .order-price[data-v-52c93130] {\n  color: #e1251b;\n  font-size: 18px;\n  font-weight: 700;\n}\n.jm-content .order-meta[data-v-52c93130] {\n  color: #666;\n  font-size: 12px;\n}\n.jm-content .order-status[data-v-52c93130] {\n  margin-left: auto;\n  color: #52c41a;\n  font-size: 12px;\n}\n.jm-content .order-body[data-v-52c93130] {\n  display: flex;\n  gap: 10px;\n}\n.jm-content .order-img[data-v-52c93130] {\n  width: 86px;\n  height: 86px;\n  object-fit: cover;\n  border-radius: 4px;\n  background: #f5f5f5;\n}\n.jm-content .order-info[data-v-52c93130] {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.jm-content .order-title[data-v-52c93130] {\n  font-size: 13px;\n  color: #333;\n  line-height: 18px;\n  height: 36px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.jm-content .order-sku[data-v-52c93130] {\n  color: #888;\n  font-size: 12px;\n}\n.jm-content .order-pay .price[data-v-52c93130] {\n  color: #e1251b;\n  font-weight: 600;\n}\n.jm-content .order-footer[data-v-52c93130] {\n  margin-top: auto;\n  padding-top: 10px;\n  font-size: 12px;\n  color: #666;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.jm-content .chat-msg-content[data-v-52c93130] {\n  position: absolute;\n  width: 460px;\n  height: 433px;\n  left: 342px;\n  top: 147px;\n  background: #F7F7F7;\n  overflow: auto;\n}\n.jm-content .chat-msg-list[data-v-52c93130] {\n  padding: 12px;\n}\n.jm-content .msg-item[data-v-52c93130] {\n  display: flex;\n  margin-bottom: 14px;\n  justify-content: flex-start;\n  width: 100%;\n}\n.jm-content .msg-avatar[data-v-52c93130] {\n  width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  border-radius: 50%;\n}\n.jm-content .msg-main[data-v-52c93130] {\n  width: 100%;\n}\n.jm-content .msg-header[data-v-52c93130] {\n  color: #999;\n  font-size: 12px;\n  margin-bottom: 6px;\n}\n.jm-content .msg-name[data-v-52c93130] {\n  margin-right: 8px;\n  color: #666;\n}\n.jm-content .msg-text[data-v-52c93130] {\n  color: #333;\n  font-size: 14px;\n  line-height: 22px;\n}\n.jm-content .msg-image[data-v-52c93130] {\n  max-width: 300px;\n  margin-top: 10px;\n  border-radius: 4px;\n  object-fit: cover;\n}\n.jm-content .ref-title[data-v-52c93130] {\n  color: red;\n  margin-bottom: 6px;\n  margin-top: 20px;\n  cursor: pointer;\n}\n.jm-content .msg-reference[data-v-52c93130] {\n  background: #E9F4FF;\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n.jm-content .msg-reference .ref-label[data-v-52c93130] {\n  color: #F56C6C;\n  margin-bottom: 4px;\n}\n.jm-content .msg-reference .ref-body[data-v-52c93130] {\n  background: #fff;\n  border-radius: 4px;\n  padding: 10px 12px;\n  color: #E84C3D;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.jm-content .reply-list[data-v-52c93130] {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.jm-content .reply-item[data-v-52c93130] {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n.jm-content .reply-item .msg-text[data-v-52c93130] {\n  color: #333;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: start;\n  margin-right: 42px;\n  max-width: 300px;\n}\n.jm-content .msg-header.right[data-v-52c93130] {\n  text-align: right;\n  margin-bottom: 4px;\n}\n.jm-content .fast-reply-content[data-v-52c93130] {\n  position: absolute;\n  width: 275px;\n  height: 600px;\n  left: 805px;\n  top: 176px;\n  overflow: auto;\n}\n.jm-content .train-session-list[data-v-52c93130] {\n  position: absolute;\n  width: 275px;\n  height: 600px;\n  left: 65px;\n  top: 163px;\n  overflow: auto;\n  background-color: #FDFDFD;\n  border-radius: 8px;\n  padding: 8px;\n}\n.jm-content .current-user[data-v-52c93130] {\n  position: absolute;\n  width: 275px;\n  left: 346px;\n  top: 98px;\n  overflow: auto;\n}\n.jm-content .ts-item[data-v-52c93130] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  background: #fff;\n  cursor: pointer;\n}\n.jm-content .ts-item.replied[data-v-52c93130] {\n  background: #FFF5CC;\n}\n.jm-content .ts-item.current[data-v-52c93130] {\n  background: #E6F0FF;\n}\n.jm-content .ts-item.normal[data-v-52c93130] {\n  background: transparent;\n}\n.jm-content .ts-avatar[data-v-52c93130] {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #e5e6eb;\n  flex: none;\n}\n.jm-content .ts-name[data-v-52c93130] {\n  font-size: 13px;\n  color: #333;\n}\n.jm-content .fr-group[data-v-52c93130] {\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  background: #fff;\n}\n.jm-content .fr-group-header[data-v-52c93130] {\n  padding: 4px 10px;\n  cursor: pointer;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #f7f8fa;\n  border-bottom: 1px solid #eee;\n}\n.jm-content .fr-group-title[data-v-52c93130] {\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n}\n.jm-content .fr-group-body[data-v-52c93130] {\n  padding: 6px 8px;\n}\n.jm-content .fr-item[data-v-52c93130] {\n  display: flex;\n  gap: 6px;\n  font-size: 12px;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 6px 4px;\n  border-radius: 4px;\n}\n.jm-content .fr-item[data-v-52c93130]:hover {\n  background: #f5f7fa;\n}\n.jm-content .fr-quick[data-v-52c93130] {\n  color: #2d6cf6;\n  flex: none;\n}\n.jm-content .fr-text[data-v-52c93130] {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.jm-content .fast-reply-actionbars[data-v-52c93130] {\n  position: absolute;\n  width: 175px;\n  height: 25px;\n  left: 805px;\n  bottom: 110px;\n  display: flex;\n}\n.jm-content .action-item[data-v-52c93130] {\n  flex: 1 1 20%;\n  height: 100%;\n  cursor: pointer;\n}\n/* 右键菜单样式 */\n.fr-menu[data-v-52c93130] {\n  position: absolute;\n  z-index: 9999;\n  min-width: 140px;\n  background: #fff;\n  border: 1px solid #eaeaea;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n  border-radius: 6px;\n  padding: 6px 0;\n}\n.fr-menu-item[data-v-52c93130] {\n  padding: 6px 12px;\n  font-size: 13px;\n  color: #333;\n  cursor: pointer;\n}\n.fr-menu-item[data-v-52c93130]:hover {\n  background: #f5f7fa;\n}\n.fr-menu-item.danger[data-v-52c93130] {\n  color: #e34d59;\n}\n.fr-menu-item.danger[data-v-52c93130]:hover {\n  background: #fff2f2;\n}\n/* 快捷短语提示框样式 */\n.quick-reply-suggestions[data-v-52c93130] {\n  position: absolute;\n  width: 400px;\n  top: 550px;\n  left: 454px;\n  background: #fff;\n  border: 1px solid #e4e7ed;\n  border-radius: 4px;\n  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n  overflow-y: auto;\n  z-index: 1000;\n}\n.suggestion-item[data-v-52c93130] {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid #f5f7fa;\n}\n.suggestion-item[data-v-52c93130]:last-child {\n  border-bottom: none;\n}\n.suggestion-item[data-v-52c93130]:hover,\n.suggestion-item.active[data-v-52c93130] {\n  background-color: #f5f7fa;\n}\n.suggestion-text[data-v-52c93130] {\n  color: #909399;\n  font-size: 12px;\n  margin-right: 8px;\n  min-width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f5f7fa;\n  border: 1px solid #e4e7ed;\n  border-radius: 3px;\n  font-weight: 500;\n}\n.suggestion-code[data-v-52c93130] {\n  color: #409eff;\n  font-size: 12px;\n  margin-right: 8px;\n  min-width: 60px;\n}\n.suggestion-content[data-v-52c93130] {\n  color: #333;\n  font-size: 12px;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports


/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDialog_vue__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b1d312_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastReplyImportDialog_vue__ = __webpack_require__(1708);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1706)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35b1d312"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b1d312_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastReplyImportDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/components/FastReplyImportDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35b1d312", Component.options)
  } else {
    hotAPI.reload("data-v-35b1d312", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1707);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("53428a22", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35b1d312\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FastReplyImportDialog.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35b1d312\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FastReplyImportDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.fri-dialog[data-v-35b1d312] .el-dialog__header {\n  background-color: #2d6cf6;\n  color: #fff;\n  padding: 12px 20px;\n}\n.fri-dialog[data-v-35b1d312] .el-dialog__title {\n  color: #fff;\n  font-weight: 600;\n}\n.fri-dialog[data-v-35b1d312] .el-dialog__headerbtn .el-dialog__close {\n  color: #fff;\n}\n.fri-dialog[data-v-35b1d312] .el-dialog__body {\n  padding: 10px 20px;\n}\n.fri-desc[data-v-35b1d312] {\n  margin: 8px 0 12px 0;\n  color: #666;\n  font-size: 13px;\n}\n.fri-file-row[data-v-35b1d312] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.fri-label[data-v-35b1d312] {\n  width: 70px;\n  color: #333;\n  font-size: 13px;\n}\n.fri-input[data-v-35b1d312] {\n  flex: 1;\n  margin-right: 8px;\n}\n.fri-file[data-v-35b1d312] {\n  display: none;\n}\n.fri-choose[data-v-35b1d312] {\n  width: 80px;\n  padding: 10px 10px;\n}\n.fri-table[data-v-35b1d312] .el-table__header th {\n  background: #f7f8fa;\n  color: #333;\n}\n", ""]);

// exports


/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "导入快捷短语(个人)",
        visible: _vm.visibleProxy,
        width: "960px",
        "append-to-body": "",
        "custom-class": "fri-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        }
      }
    },
    [
      _c("div", { staticClass: "fri-desc" }, [
        _vm._v("添加导入：在现有快捷短语后方增加新导入的短语")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fri-file-row" },
        [
          _c("div", { staticClass: "fri-label" }, [_vm._v("文件路径：")]),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "fri-input",
            attrs: {
              placeholder: "/Users/xxx/Downloads/快捷短语.csv",
              size: "small"
            },
            model: {
              value: _vm.filePath,
              callback: function($$v) {
                _vm.filePath = $$v
              },
              expression: "filePath"
            }
          }),
          _vm._v(" "),
          _c("input", {
            ref: "fileInput",
            staticClass: "fri-file",
            attrs: { type: "file", accept: ".csv,.txt,.xls,.xlsx" },
            on: { change: _vm.onFileChange }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "fri-choose",
              attrs: { size: "small" },
              on: { click: _vm.chooseFile }
            },
            [_vm._v("选择文件")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "fri-table",
          attrs: { data: _vm.tableData, border: "", height: "380" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "index",
              label: "编号",
              width: "70",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "code", label: "短语编码", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "content",
              label: "短语内容",
              "min-width": "260",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "group", label: "分组名", width: "120" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "image",
              label: "图片(仅支持链接)",
              "min-width": "180",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              width: "100",
              align: "center"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35b1d312", esExports)
  }
}

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1710);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("973a63bc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-70c92a3f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FastReplyEditorDialog.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-70c92a3f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FastReplyEditorDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.fre-dialog[data-v-70c92a3f] .el-dialog__header {\n  background-color: #2d6cf6;\n  color: #fff;\n  padding: 12px 20px;\n}\n.fre-dialog[data-v-70c92a3f] .el-dialog__title {\n  color: #fff;\n  font-weight: 600;\n}\n.fre-dialog[data-v-70c92a3f] .el-dialog__headerbtn .el-dialog__close {\n  color: #fff;\n}\n.fre-dialog[data-v-70c92a3f] .el-dialog__body {\n  padding: 14px 20px;\n}\n.fre-row[data-v-70c92a3f] {\n  margin-bottom: 14px;\n}\n.fre-label[data-v-70c92a3f] {\n  color: #666;\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n.fre-uploader[data-v-70c92a3f] {\n  width: 100px;\n  height: 100px;\n  border: 1px dashed #c0c4cc;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: #909399;\n  margin-top: 6px;\n  position: relative;\n}\n.fre-uploader .el-icon-plus[data-v-70c92a3f] {\n  font-size: 24px;\n}\n.fre-upload-text[data-v-70c92a3f] {\n  margin-top: 6px;\n  font-size: 12px;\n}\n.fre-file[data-v-70c92a3f] {\n  display: none;\n}\n.fre-thumb[data-v-70c92a3f] {\n  width: 100px;\n  height: 100px;\n  background-size: cover;\n  background-position: center;\n  border-radius: 4px;\n  margin-left: 12px;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n}\n.fre-thumb-actions[data-v-70c92a3f] {\n  position: absolute;\n  right: 6px;\n  top: 6px;\n  background: rgba(0, 0, 0, 0.45);\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  cursor: pointer;\n}\n.fre-flex[data-v-70c92a3f] {\n  display: flex;\n  align-items: center;\n}\n.fre-group-select[data-v-70c92a3f] {\n  width: 180px;\n  margin-left: 10px;\n}\n.fre-group-input[data-v-70c92a3f] {\n  width: 180px;\n  margin: 0 10px;\n}\n.fre-code-input[data-v-70c92a3f] {\n  width: 260px;\n}\n.fre-tips[data-v-70c92a3f] {\n  color: #909399;\n  font-size: 12px;\n}\n", ""]);

// exports


/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "快捷短语设置",
        visible: _vm.visibleProxy,
        width: "640px",
        "append-to-body": "",
        "custom-class": "fre-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        },
        open: _vm.onOpen,
        closed: _vm.onClosed
      }
    },
    [
      _c(
        "div",
        { staticClass: "fre-row" },
        [
          _c("div", { staticClass: "fre-label" }, [
            _vm._v("请输入快捷短语（700字以内）")
          ]),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 6,
              maxlength: "700",
              "show-word-limit": "",
              placeholder: ""
            },
            model: {
              value: _vm.form.content,
              callback: function($$v) {
                _vm.$set(_vm.form, "content", $$v)
              },
              expression: "form.content"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fre-row fre-flex" },
        [
          _c("div", { staticClass: "fre-label" }, [_vm._v("选择分组")]),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "fre-group-select",
              attrs: { placeholder: "请选择" },
              model: {
                value: _vm.form.group,
                callback: function($$v) {
                  _vm.$set(_vm.form, "group", $$v)
                },
                expression: "form.group"
              }
            },
            _vm._l(_vm.groups, function(g) {
              return _c("el-option", {
                key: g.id,
                attrs: { label: g.name, value: g.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.showAddGroup
            ? _c("el-input", {
                staticClass: "fre-group-input",
                attrs: { placeholder: "请输入分组名" },
                model: {
                  value: _vm.newGroup,
                  callback: function($$v) {
                    _vm.newGroup = $$v
                  },
                  expression: "newGroup"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showAddGroup
            ? _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.addGroup }
                },
                [_vm._v("添加")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fre-row" },
        [
          _c("div", { staticClass: "fre-label" }, [_vm._v("快捷编码")]),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "fre-code-input",
            attrs: { placeholder: "字母、数字、中文" },
            model: {
              value: _vm.form.code,
              callback: function($$v) {
                _vm.$set(_vm.form, "code", $$v)
              },
              expression: "form.code"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fre-tips" }, [
        _vm._v(
          "\n\t\t输入框输入“/”+“快捷编码”或关键字,可以进行搜索。输入数字、↑、↓ 键进行选择，回车键进行确认。\n\t"
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.saving },
              on: {
                click: function($event) {
                  _vm.visibleProxy = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.saving,
                disabled: _vm.saving
              },
              on: { click: _vm.onConfirm }
            },
            [_vm._v("确认")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70c92a3f", esExports)
  }
}

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1713);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3653fe87", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-dddafd34\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TrainScoreDialog.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-dddafd34\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TrainScoreDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.tsd-header[data-v-dddafd34] {\n  text-align: center;\n}\n.tsd-header .tsd-level[data-v-dddafd34] {\n  font-size: 25px;\n  margin: 0 0 6px 0;\n}\n.tsd-header .tsd-level .tsd-score[data-v-dddafd34] {\n  color: #f56c6c;\n  font-weight: 600;\n}\n.tsd-header .tsd-pass[data-v-dddafd34] {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 20px;\n}\n.tsd-header .tsd-pass.is-pass[data-v-dddafd34] {\n  color: #67C23A;\n}\n.tsd-table[data-v-dddafd34] {\n  background: #fff;\n  border: 1px solid #dfe6ec;\n  border-radius: 2px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n.tsd-table table[data-v-dddafd34] {\n  width: 100%;\n  border-collapse: collapse;\n}\n.tsd-table table th[data-v-dddafd34],\n.tsd-table table td[data-v-dddafd34] {\n  border: 1px solid #dfe6ec;\n  padding: 8px 10px;\n  font-size: 12px;\n}\n.tsd-table table thead th[data-v-dddafd34] {\n  background: #2F78FF;\n  color: #fff;\n  font-weight: 600;\n}\n.tsd-table table .col-score[data-v-dddafd34] {\n  width: 80px;\n  text-align: center;\n}\n.tsd-table table .is-advance[data-v-dddafd34] {\n  color: #f56c6c;\n}\n.tsd-table table .is-negative[data-v-dddafd34] {\n  color: #f56c6c;\n}\n.tsd-table table .total[data-v-dddafd34] {\n  text-align: center;\n  font-weight: 600;\n  color: #f56c6c;\n}\n.dialog-footer[data-v-dddafd34] {\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "练习完成",
        visible: _vm.visibleProxy,
        width: "460px",
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        }
      }
    },
    [
      _c("div", { staticClass: "tsd-header" }, [
        _c("p", { staticClass: "tsd-level" }, [
          _vm._v("得分："),
          _c("span", { staticClass: "tsd-score" }, [
            _vm._v(_vm._s(_vm.computedScore))
          ]),
          _vm._v(" 分")
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "tsd-pass", class: { "is-pass": _vm.computedPassed } },
          [
            _vm._v(
              _vm._s(
                _vm.computedPassed ? "通过，干得漂亮！" : "未通过，继续加油哦！"
              )
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tsd-table" }, [
        _c("table", { attrs: { cellspacing: "0", cellpadding: "0" } }, [
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { colspan: "2" } }, [_vm._v("操作项目")]),
              _vm._v(" "),
              _c("th", { staticClass: "col-score" }, [_vm._v("得分")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.computedItems, function(row, idx) {
                return _c(
                  "tr",
                  { key: idx },
                  [
                    row.isSection
                      ? [
                          _c(
                            "td",
                            {
                              staticClass: "is-advance",
                              attrs: { colspan: "2" }
                            },
                            [_vm._v(_vm._s(row.label))]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-score" })
                        ]
                      : [
                          _c("td", [_vm._v(_vm._s(row.label))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-value" }, [
                            _vm._v(_vm._s(row.value))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "col-score" }, [
                            _vm._v(_vm._s(_vm.formatScore(row.score)))
                          ])
                        ]
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.actionTypeMap && _vm.actionTypeMap.length > 0
                ? _vm._l(_vm.actionTypeMap, function(actionType, index) {
                    return _c("tr", { key: actionType.actionType }, [
                      index === 0
                        ? _c(
                            "td",
                            {
                              staticStyle: { color: "red" },
                              attrs: { rowspan: _vm.actionTypeMap.length }
                            },
                            [_vm._v("高级操作")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", { staticClass: "col-value" }, [
                        _vm._v(
                          "漏掉" +
                            _vm._s(
                              actionType.actionType == "TRANSFER_AFTER_SALE"
                                ? "转接售后"
                                : actionType.actionType == "REMARK_MODIFY"
                                ? "添加备注"
                                : ""
                            ) +
                            _vm._s(actionType.times) +
                            "次"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "col-score" }, [
                        _vm._v("-" + _vm._s(actionType.points))
                      ])
                    ])
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("tfoot", [
            _c("tr", [
              _c("td", { staticClass: "total", attrs: { colspan: "2" } }, [
                _vm._v("总分")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "col-score" }, [
                _vm._v(_vm._s(_vm.computedScore))
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { plain: "" }, on: { click: _vm.onRestart } },
            [_vm._v("再练一次")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onViewResult } },
            [_vm._v("查看结果")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dddafd34", esExports)
  }
}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1716);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0bd68f4d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2da29697\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderMsgCard.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2da29697\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderMsgCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.order-msg-card[data-v-2da29697] {\n\twidth: 360px;\n\tbackground: #fff;\n\tborder: 1px solid #e6e6e6;\n\tborder-radius: 8px;\n\toverflow: hidden;\n\tfont-size: 13px;\n\tcolor: #333;\n}\n.omc-head[data-v-2da29697] {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 8px 10px;\n\tbackground: #f7f8fa;\n\tborder-bottom: 1px solid #eee;\n}\n.omc-status[data-v-2da29697] { color: #fa5151; font-weight: 600;\n}\n.omc-code[data-v-2da29697] { color: #999; font-size: 12px;\n}\n.omc-body[data-v-2da29697] { display: flex; padding: 10px;\n}\n.omc-img[data-v-2da29697] {\n\twidth: 60px;\n\theight: 60px;\n\tborder-radius: 4px;\n\tobject-fit: cover;\n\tflex: 0 0 60px;\n}\n.omc-info[data-v-2da29697] { margin-left: 10px; min-width: 0; flex: 1;\n}\n.omc-title[data-v-2da29697] {\n\tline-height: 18px;\n\tmax-height: 36px;\n\toverflow: hidden;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 2;\n\t-webkit-box-orient: vertical;\n}\n.omc-price[data-v-2da29697] { margin-top: 6px; color: #fa5151; font-weight: 700;\n}\n.omc-spec[data-v-2da29697] { color: #999; font-weight: 400; font-size: 12px; margin-left: 8px;\n}\n.omc-recv[data-v-2da29697] { padding: 8px 10px; border-top: 1px solid #f0f0f0; line-height: 20px;\n}\n.omc-row[data-v-2da29697] { color: #666; word-break: break-all;\n}\n", ""]);

// exports


/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-msg-card" }, [
    _c("div", { staticClass: "omc-head" }, [
      _c("span", { staticClass: "omc-status" }, [
        _vm._v(_vm._s(_vm.order.status))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "omc-code" }, [
        _vm._v("编码：" + _vm._s(_vm.order.id))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "omc-body" }, [
      _c("img", {
        staticClass: "omc-img",
        attrs: { src: _vm.order.imgurl, alt: "商品图" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "omc-info" }, [
        _c(
          "div",
          { staticClass: "omc-title", attrs: { title: _vm.order.productName } },
          [_vm._v(_vm._s(_vm.order.productName))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "omc-price" }, [
          _vm._v("\n\t\t\t\t¥ " + _vm._s(_vm.priceText) + "\n\t\t\t\t"),
          _vm.order.size
            ? _c("span", { staticClass: "omc-spec" }, [
                _vm._v("规格：" + _vm._s(_vm.order.size))
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "omc-recv" }, [
      _c("div", { staticClass: "omc-row" }, [
        _vm._v(
          "收件人：" + _vm._s(_vm.order.name) + "　" + _vm._s(_vm.order.phone)
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "omc-row" }, [
        _vm._v("地址：" + _vm._s(_vm.order.address))
      ]),
      _vm._v(" "),
      _vm.order.remark
        ? _c("div", { staticClass: "omc-row" }, [
            _vm._v("备注：" + _vm._s(_vm.order.remark))
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2da29697", esExports)
  }
}

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1719);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("95c7c3bc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-175ddb66\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CourseProductModal.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-175ddb66\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CourseProductModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.cp-tabs[data-v-175ddb66] {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 6px 0 10px;\n}\n.cp-tab[data-v-175ddb66] {\n  background: #ffb452;\n  color: #fff;\n  padding: 0 12px;\n  height: 36px;\n  line-height: 36px;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 5px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.cp-tab.active[data-v-175ddb66] {\n  background: #d4820f;\n}\n.cp-img[data-v-175ddb66] {\n  display: block;\n  width: 736px;\n  height: auto;\n  margin-bottom: 8px;\n}\n", ""]);

// exports


/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.beginVisible,
            width: "840px",
            "show-close": false,
            "close-on-click-modal": false,
            title: " "
          },
          on: {
            "update:visible": function($event) {
              _vm.beginVisible = $event
            }
          }
        },
        [
          _vm.products.length > 0
            ? _c(
                "div",
                { staticClass: "cp-tabs" },
                _vm._l(_vm.products, function(p, i) {
                  return _c(
                    "span",
                    {
                      key: p.productId,
                      class: ["cp-tab", { active: _vm.beginActiveIndex === i }],
                      on: {
                        click: function($event) {
                          _vm.beginActiveIndex = i
                        }
                      }
                    },
                    [_vm._v(_vm._s(p.productName))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.products, function(p, i) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.beginActiveIndex === i,
                    expression: "beginActiveIndex === i"
                  }
                ],
                key: "b-" + p.productId
              },
              [
                _c("h3", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("开始对练前，请了解店铺产品")
                ]),
                _vm._v(" "),
                _vm._l(p.imageUrls, function(url) {
                  return _c("img", {
                    key: url,
                    staticClass: "cp-img",
                    attrs: { src: url }
                  })
                })
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.onBeginConfirm }
                },
                [_vm._v("我已知晓，确认后进入对练")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.orderVisible,
            width: "840px",
            title: "产品须知"
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        },
        [
          _vm.products.length > 0
            ? _c(
                "div",
                { staticClass: "cp-tabs" },
                _vm._l(_vm.products, function(p, i) {
                  return _c(
                    "span",
                    {
                      key: p.productId,
                      class: ["cp-tab", { active: _vm.orderActiveIndex === i }],
                      on: {
                        click: function($event) {
                          _vm.orderActiveIndex = i
                        }
                      }
                    },
                    [_vm._v(_vm._s(p.productName))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.products, function(p, i) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.orderActiveIndex === i,
                    expression: "orderActiveIndex === i"
                  }
                ],
                key: "o-" + p.productId
              },
              _vm._l(p.imageUrls, function(url) {
                return _c("img", {
                  key: url,
                  staticClass: "cp-img",
                  attrs: { src: url }
                })
              }),
              0
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-175ddb66", esExports)
  }
}

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jm-page" },
    [
      _c("div", { staticClass: "jm-back", on: { click: _vm.back } }, [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticClass: "jm-back-text" }, [_vm._v("返回")])
      ]),
      _vm._v(" "),
      !_vm.settings.isStart
        ? _c(
            "div",
            { staticClass: "jm-spacer" },
            [
              _c("span", [_vm._v("每10分钟进线 3 名客户")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.productModal.handleStart()
                    }
                  }
                },
                [_vm._v("开始")]
              ),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "jm-spacer" },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm.hasProducts
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.productModal.showProducts()
                        }
                      }
                    },
                    [_vm._v("产品须知")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "10px"
                  }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-weight": "bold", color: "black" } },
                    [_vm._v("推荐回复")]
                  ),
                  _vm._v(" "),
                  _c("el-switch", {
                    on: { change: _vm.changeRecommendReply },
                    model: {
                      value: _vm.settings.isRecommendReply,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "isRecommendReply", $$v)
                      },
                      expression: "settings.isRecommendReply"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "20px",
                    "font-weight": "bold",
                    color: "black"
                  }
                },
                [_vm._v(_vm._s(_vm.formattedTime))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.stopTrain } },
                [_vm._v("退出")]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "回复数：" +
                    _vm._s(_vm.totalReplyCount) +
                    " 打字速度：" +
                    _vm._s(_vm.typingSpeedWPM) +
                    "字/分钟 "
                ),
                _c("br"),
                _vm._v(
                  "首次响应时间：" +
                    _vm._s(_vm.firstResponseAvgSec) +
                    "秒 平均响应时间：" +
                    _vm._s(_vm.avgResponseSec) +
                    "秒"
                )
              ])
            ],
            1
          ),
      _vm._v(" "),
      _c("div", { staticClass: "jm-container" }, [
        _c("img", {
          staticClass: "jm-bg",
          attrs: {
            src: __webpack_require__(1722),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "jm-content" },
          [
            _c(
              "el-select",
              {
                staticClass: "status-select",
                attrs: { placeholder: "请选择" },
                model: {
                  value: _vm.settings.onlineStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.settings, "onlineStatus", $$v)
                  },
                  expression: "settings.onlineStatus"
                }
              },
              [
                _c("el-option", { attrs: { label: "接待", value: "1" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "离线", value: "2" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "挂起", value: "3" } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "train-session-list" },
              _vm._l(_vm.settings.trainSession || [], function(s) {
                return _c(
                  "div",
                  {
                    key: s.id || s.veruser,
                    staticClass: "ts-item",
                    class: {
                      current: s.isCurrent,
                      replied: !s.isCurrent && !s.didReply
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectSession(s)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "ts-avatar",
                      attrs: {
                        src: __webpack_require__(68)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ts-name" }, [
                      _vm._v(_vm._s(s.veruser))
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.currentSession
              ? _c("div", { staticClass: "current-user" }, [
                  _c("div", { staticClass: "ts-item normal" }, [
                    _c("img", {
                      staticClass: "ts-avatar",
                      attrs: {
                        src: __webpack_require__(68)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ts-name" }, [
                      _vm._v(_vm._s(_vm.currentSession.veruser))
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentSession
              ? _c(
                  "div",
                  { ref: "chatContent", staticClass: "chat-msg-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "chat-msg-list" },
                      _vm._l(_vm.currentMessages, function(msg, idx) {
                        return _c(
                          "div",
                          { key: msg.id || idx, staticClass: "msg-item" },
                          [
                            _c("img", {
                              staticClass: "msg-avatar",
                              attrs: {
                                src: __webpack_require__(68)
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "msg-main" },
                              [
                                _c("div", { staticClass: "msg-header" }, [
                                  _c("span", { staticClass: "msg-name" }, [
                                    _vm._v(_vm._s(msg.fromName || "对方"))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "msg-time" }, [
                                    _vm._v(
                                      _vm._s(_vm.formatMsgTime(msg.sendTime))
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                msg.questionType === "卡片" &&
                                _vm.findOrderById(msg.questionOrderId)
                                  ? _c("order-msg-card", {
                                      attrs: {
                                        order: _vm.findOrderById(
                                          msg.questionOrderId
                                        ),
                                        platform: "jingmai"
                                      }
                                    })
                                  : [
                                      _c("div", {
                                        staticClass: "msg-text",
                                        domProps: {
                                          innerHTML: _vm._s(msg.question)
                                        }
                                      }),
                                      _vm._v(" "),
                                      msg.questionImg
                                        ? _c("img", {
                                            staticClass: "msg-image",
                                            attrs: { src: msg.questionImg }
                                          })
                                        : _vm._e()
                                    ],
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ref-title",
                                    on: {
                                      click: function($event) {
                                        msg.fold = !msg.fold
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        msg.fold
                                          ? "查看参考答案"
                                          : "收起参考答案"
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                !msg.fold
                                  ? _c(
                                      "div",
                                      { staticClass: "msg-reference" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "ref-label" },
                                          [_vm._v("参考回复：")]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "ref-body",
                                          domProps: {
                                            innerHTML: _vm._s(msg.answer)
                                          },
                                          on: {
                                            copy: function($event) {
                                              $event.preventDefault()
                                            },
                                            cut: function($event) {
                                              $event.preventDefault()
                                            },
                                            contextmenu: function($event) {
                                              $event.preventDefault()
                                            },
                                            selectstart: function($event) {
                                              $event.preventDefault()
                                            },
                                            dragstart: function($event) {
                                              $event.preventDefault()
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (msg.replyList || []).length
                                  ? _c(
                                      "div",
                                      { staticClass: "reply-list" },
                                      _vm._l(msg.replyList, function(
                                        rep,
                                        rIdx
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: rep.id || rIdx,
                                            staticClass: "reply-item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "msg-header right"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "msg-time" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMsgTime(
                                                          rep.sendTime
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("img", {
                                                  staticClass: "msg-avatar",
                                                  attrs: {
                                                    src: __webpack_require__(68)
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "msg-text msg-rich"
                                              },
                                              [
                                                _vm._l(
                                                  _vm.parseContent(rep.content),
                                                  function(node, nIdx) {
                                                    return [
                                                      node.type === "img"
                                                        ? _c("img", {
                                                            key: "img-" + nIdx,
                                                            staticClass:
                                                              "msg-image",
                                                            attrs: {
                                                              src: node.src
                                                            }
                                                          })
                                                        : _c(
                                                            "span",
                                                            {
                                                              key:
                                                                "txt-" + nIdx,
                                                              staticStyle: {
                                                                display: "block"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  node.text
                                                                )
                                                              )
                                                            ]
                                                          )
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat-msg-toolbar" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.closeSession }
                  },
                  [_vm._v("关闭会话")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.sendReply }
                  },
                  [_vm._v("发送")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat-msg-input" },
              [
                _c("el-input", {
                  staticClass: "reply-textarea",
                  attrs: {
                    type: "textarea",
                    rows: 6,
                    placeholder: "请输入回复内容...",
                    resize: "none"
                  },
                  on: { input: _vm.onReplyInput },
                  nativeOn: {
                    keydown: function($event) {
                      return _vm.onReplyKeydown.apply(null, arguments)
                    },
                    paste: function($event) {
                      return _vm.onReplyPaste.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.replyText,
                    callback: function($$v) {
                      _vm.replyText = $$v
                    },
                    expression: "replyText"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.showQuickReplySuggestions
              ? _c(
                  "div",
                  { staticClass: "quick-reply-suggestions" },
                  _vm._l(_vm.quickReplySuggestions, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "suggestion-item",
                        class: {
                          active: index === _vm.selectedSuggestionIndex
                        },
                        on: {
                          click: function($event) {
                            return _vm.selectSuggestion(item)
                          },
                          mouseenter: function($event) {
                            _vm.selectedSuggestionIndex = index
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "suggestion-text" }, [
                          _vm._v("个")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "suggestion-code" }, [
                          _vm._v(_vm._s(item.quicktext))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "suggestion-content" }, [
                          _vm._v(_vm._s(item.replytext))
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "keyword-input",
              attrs: { placeholder: "搜索短语", clearable: "" },
              on: { input: _vm.onKeywordInput },
              model: {
                value: _vm.keyword,
                callback: function($$v) {
                  _vm.keyword = $$v
                },
                expression: "keyword"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fast-reply-content" },
              _vm._l(_vm.filteredFastReplyList, function(g) {
                return _c("div", { key: g.id, staticClass: "fr-group" }, [
                  _c(
                    "div",
                    {
                      staticClass: "fr-group-header",
                      on: {
                        click: function($event) {
                          return _vm.toggleGroup(g.id)
                        },
                        contextmenu: function($event) {
                          $event.preventDefault()
                          return _vm.onGroupContext($event, g)
                        }
                      }
                    },
                    [
                      _c("i", {
                        class: _vm.settings.collapsedGroups[g.id]
                          ? "el-icon-caret-right"
                          : "el-icon-caret-bottom"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "fr-group-title" }, [
                        _vm._v(
                          _vm._s(g.name) +
                            " (" +
                            _vm._s((g.filteredReplyList || []).length) +
                            "/100)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.settings.collapsedGroups[g.id],
                          expression: "!settings.collapsedGroups[g.id]"
                        }
                      ],
                      staticClass: "fr-group-body"
                    },
                    _vm._l(g.filteredReplyList || [], function(r) {
                      return _c(
                        "div",
                        {
                          key: r.id,
                          staticClass: "fr-item",
                          on: {
                            click: function($event) {
                              return _vm.onClickReply(r)
                            },
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.onReplyContext($event, r, g)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "fr-quick" }, [
                            _vm._v(_vm._s(r.quicktext))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "fr-text" }, [
                            _vm._v(_vm._s(r.replytext))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm.menu.visible
              ? _c(
                  "div",
                  {
                    staticClass: "fr-menu",
                    style: { left: _vm.menu.x + "px", top: _vm.menu.y + "px" }
                  },
                  [
                    _vm.menu.type === "group"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuAddGroup }
                            },
                            [_vm._v("添加分组")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuEditGroup }
                            },
                            [_vm._v("修改")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item danger",
                              on: { click: _vm.menuDeleteGroup }
                            },
                            [_vm._v("删除")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuAddReply }
                            },
                            [_vm._v("添加短语")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuCollapseAll }
                            },
                            [_vm._v("收起所有")]
                          )
                        ]
                      : _vm.menu.type === "reply"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuEditReplyGroup }
                            },
                            [_vm._v("修改分组")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuAddReply }
                            },
                            [_vm._v("添加短语")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item",
                              on: { click: _vm.menuEditReply }
                            },
                            [_vm._v("修改")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-menu-item danger",
                              on: { click: _vm.menuDeleteReply }
                            },
                            [_vm._v("删除")]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fast-reply-actionbars" },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: "刷新", placement: "bottom" } },
                  [
                    _c("div", {
                      staticClass: "action-item",
                      on: { click: _vm.refreshFastReply }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "新建", placement: "bottom" } },
                  [
                    _c("div", {
                      staticClass: "action-item",
                      on: { click: _vm.newFastReply }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "导入", placement: "bottom" } },
                  [
                    _c("div", {
                      staticClass: "action-item",
                      on: {
                        click: function($event) {
                          _vm.showImport = true
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "导出", placement: "bottom" } },
                  [_c("div", { staticClass: "action-item" })]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "下载", placement: "bottom" } },
                  [_c("div", { staticClass: "action-item" })]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.matchedOrder
              ? _c("div", { staticClass: "orders-list" }, [
                  _c("div", { staticClass: "order-card" }, [
                    _c("div", { staticClass: "order-top" }, [
                      _c("div", { staticClass: "order-no" }, [
                        _vm._v(
                          "订单编号：" + _vm._s(_vm.orderHeader.orderNo) + " "
                        ),
                        _c("i", {
                          staticClass: "el-icon-document-copy copy-icon"
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-time" }, [
                        _vm._v(
                          "下单时间：" + _vm._s(_vm.orderHeader.orderTime) + " "
                        ),
                        _c("br"),
                        _c("span", { staticClass: "pay-time" }, [
                          _vm._v(
                            "付款时间：" + _vm._s(_vm.orderHeader.orderPayTime)
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-header" }, [
                      _c("div", { staticClass: "order-price" }, [
                        _vm._v("¥ " + _vm._s(_vm.matchedOrder.price.toFixed(2)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-meta" }, [
                        _vm._v("数量：" + _vm._s(_vm.matchedOrder.num))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-status" }, [
                        _vm._v(_vm._s(_vm.matchedOrder.status))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-body" }, [
                      _c("img", {
                        staticClass: "order-img",
                        attrs: { src: _vm.matchedOrder.imgurl, alt: "商品图" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-info" }, [
                        _c(
                          "div",
                          {
                            staticClass: "order-title",
                            attrs: { title: _vm.matchedOrder.productName }
                          },
                          [_vm._v(_vm._s(_vm.matchedOrder.productName))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "order-sku" }, [
                          _vm._v(
                            "SKU：" + _vm._s(_vm.matchedOrder.size || "(无)")
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "order-pay" }, [
                          _vm._v("支付："),
                          _c("span", { staticClass: "price" }, [
                            _vm._v(
                              "¥ " +
                                _vm._s(
                                  (
                                    _vm.matchedOrder.price *
                                    _vm.matchedOrder.num
                                  ).toFixed(2)
                                )
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-footer" }, [
                      _c("div", { staticClass: "order-row" }, [
                        _vm._v("收件人：" + _vm._s(_vm.matchedOrder.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-row" }, [
                        _vm._v("电话：" + _vm._s(_vm.matchedOrder.phone))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-row" }, [
                        _vm._v("地址：" + _vm._s(_vm.matchedOrder.address))
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("FastReplyImportDialog", {
              attrs: { sceneId: _vm.sceneId, visible: _vm.showImport },
              on: {
                "update:visible": function($event) {
                  _vm.showImport = $event
                },
                refresh: _vm.refreshFastReply
              }
            }),
            _vm._v(" "),
            _c("FastReplyEditorDialog", {
              attrs: {
                sceneId: _vm.sceneId,
                visible: _vm.showEditor,
                defaultGroupId: _vm.settings.defaultGroupId,
                value: _vm.editorValue
              },
              on: {
                "update:visible": function($event) {
                  _vm.showEditor = $event
                },
                refresh: _vm.refreshFastReply
              }
            }),
            _vm._v(" "),
            _c("TrainScoreDialog", {
              attrs: { result: _vm.trainResult, visible: _vm.showScore },
              on: {
                "update:visible": function($event) {
                  _vm.showScore = $event
                },
                onRestart: _vm.restartTrain,
                onViewResult: _vm.viewResult
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("CourseProductModal", {
        ref: "productModal",
        attrs: { "course-id": _vm.sceneId },
        on: {
          confirm: _vm.startTrain,
          "products-fetched": function($event) {
            _vm.hasProducts = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("实操练习疑问，或者问题反馈的途径："),
      _c("br"),
      _vm._v(" 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("实操练习疑问，或者问题反馈的途径："),
      _c("br"),
      _vm._v(" 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52c93130", esExports)
  }
}

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jingmai_chat.ef752a1.png";

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmai_vue__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmai_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmai_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmai_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmai_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23bf9490_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingmai_vue__ = __webpack_require__(1726);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1724)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23bf9490"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmai_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23bf9490_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingmai_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/jingmai.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23bf9490", Component.options)
  } else {
    hotAPI.reload("data-v-23bf9490", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1725);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7883f287", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-23bf9490\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingmai.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-23bf9490\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingmai.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-23bf9490] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-23bf9490] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.video-mask[data-v-23bf9490] {\n  position: absolute;\n  bottom: 0;\n  left: 0px;\n  width: 100%;\n  height: 25px;\n}\n", ""]);

// exports


/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "jingmai" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "align-items": "center",
            "margin-bottom": "10px",
            cursor: "pointer",
            width: "100px"
          },
          on: { click: _vm.goBack }
        },
        [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("返回")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "zero" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("通关必看")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-zero" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "zero",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/%E9%80%9A%E5%85%B3%E5%BF%85%E7%9C%8B.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-zero" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-first")
                          }
                        }
                      },
                      [_vm._v("继续下一步学习")]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("1、登录京麦")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2022-11/096bd7c00d2a450b9a3ae1916fe2f6a5.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: __webpack_require__(105)
                        },
                        on: { click: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02",
                        attrs: {
                          src: __webpack_require__(106)
                        },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginImg,
                          expression: "isShowLoginImg"
                        }
                      ],
                      staticClass: "login"
                    },
                    [
                      _c("img", {
                        staticClass: "homeImg",
                        attrs: {
                          src: __webpack_require__(107)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text", placeholder: "请输入账号" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                          placeholder: "请输入密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "mima",
                        on: {
                          click: function($event) {
                            _vm.isShowMimaImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowMimaImg,
                            expression: "isShowMimaImg"
                          }
                        ],
                        staticClass: "mima",
                        attrs: {
                          src: __webpack_require__(108)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logIn",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowRnd,
                          expression: "isShowRnd"
                        }
                      ],
                      staticClass: "loginrnd"
                    },
                    [
                      _c("img", {
                        staticClass: "rndImg",
                        attrs: {
                          src: __webpack_require__(109)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rnd,
                            expression: "rnd"
                          }
                        ],
                        staticClass: "rnd",
                        attrs: {
                          type: "text",
                          placeholder: "请输入短信验证码"
                        },
                        domProps: { value: _vm.rnd },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rnd = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logInRnd",
                        on: { click: _vm.loginInRnd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndex,
                          expression: "isShowLoginIndex"
                        }
                      ],
                      staticClass: "jdbox"
                    },
                    [
                      _c("img", {
                        staticClass: "jdimg",
                        attrs: {
                          src: __webpack_require__(110)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "jdicon",
                        on: { click: _vm.enterJd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndexTwo,
                          expression: "isShowLoginIndexTwo"
                        }
                      ],
                      staticClass: "indexbox"
                    },
                    [
                      _c("img", {
                        staticClass: "indeximg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                        提示\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的京麦图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _c(
                                  "p",
                                  [
                                    _vm._v("账号（"),
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("账号中间的冒号是英文冒号")
                                    ]),
                                    _vm._v("）：")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("淘金客服:002")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("密码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("TJ2022")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("勾选“记住密码”")])
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            },
                            [_vm._v("获取短信验证码")]
                          ),
                          _vm._v(" "),
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("6022")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [_vm._v("请进入京麦接待中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-登录京麦.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("2、状态切换")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2022-11/bf768f11e5d5476e94c8dd88db73f697.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowWgq,
                          expression: "!isShowWgq"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "gqbtn",
                        on: {
                          click: function($event) {
                            _vm.showGqImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(111)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqclick",
                        on: { click: _vm.showWgqImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowWgq,
                          expression: "isShowWgq"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(112)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("请将状态切换为“在线”")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySecond }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-状态切换.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("3、客户列表+数据统计")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://res.study.itaojin.cn/2022-11/94504bfa2973434d8de12c4d62ca81a3.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "paixubox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne || _vm.isShowFive,
                          expression: "isShowOne || isShowFive"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(113)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne,
                          expression: "isShowOne"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { mouseover: _vm.showPaixuImgOne }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(114)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { click: _vm.showPaixuImgTwo }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(115)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { mouseover: _vm.showPaixuImgThree }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(116)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { click: _vm.showPaixuImgFour }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "sjclick",
                      on: { click: _vm.showPaixuImgFive }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(117)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isShowOne ||
                  _vm.isShowTwo ||
                  _vm.isShowThree ||
                  _vm.isShowFour
                    ? _c(
                        "p",
                        [
                          _vm._v("请将客户咨询排序设置为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v(
                              "\n                            按等待时间降序"
                            )
                          ]),
                          _vm._v("”\n                    ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowFive
                    ? _c(
                        "p",
                        [
                          _vm._v("请切换到"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("数据")
                          ]),
                          _vm._v("功能，查看数据")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyThird }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-客户列表+数据统计.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt3
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt3(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt3 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("4、自动回复设置")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://res.study.itaojin.cn/2022-11/413b658d30854eb0bccc77fb88e9da12.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zdhfbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(118)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { mouseover: _vm.showZdhf01 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(119)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { click: _vm.showZdhf02 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(120)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "zdhf01icon",
                      on: { click: _vm.showZdhf03 }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf03,
                            expression: "isShowZdhf03"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(121)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf02icon",
                          on: { click: _vm.showZdhf04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf04,
                            expression: "isShowZdhf04"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(122)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf03icon",
                          on: { click: _vm.showZdhf05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf05,
                            expression: "isShowZdhf05"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(123)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf04icon",
                          on: { click: _vm.showZdhf06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf06,
                            expression: "isShowZdhf06"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(124)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf05icon",
                          on: { click: _vm.showZdhf07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf07,
                            expression: "isShowZdhf07"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(125)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "scrollImg",
                          attrs: {
                            src: __webpack_require__(126)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "zdhf06input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.zdhf,
                            callback: function($$v) {
                              _vm.zdhf = $$v
                            },
                            expression: "zdhf"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf06icon",
                          on: { click: _vm.showZdhf08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf08,
                            expression: "isShowZdhf08"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(127)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "请设置“您好！欢迎光临，请问有什么可以帮到您？”的自动回复"
                      ),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("个人版欢迎语")
                      ]),
                      _vm._v("，并勾选“"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v(
                          "\n                            第一次收到顾客消息的回复语"
                        )
                      ]),
                      _vm._v("\n                        ”（记得保存）")
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFour }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-自动回复设置.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt4
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt4(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt4 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("5、快捷短语导入和使用")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://res.study.itaojin.cn/2022-11/d019c786030c48aabb89a67a1a8ff003.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "kjdybox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy01,
                            expression: "isShowKjdy01"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy01icon",
                          on: { mouseover: _vm.showKjdy01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy02,
                            expression: "isShowKjdy02"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(128)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "kjdy01icon" }, [
                          _c("input", {
                            staticClass: "btn-file",
                            attrs: { type: "file", accept: ".csv" },
                            on: {
                              change: function($event) {
                                return _vm.tirggerFile($event)
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy03,
                            expression: "isShowKjdy03"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(129)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy04,
                            expression: "isShowKjdy04"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy02icon",
                          on: { mouseover: _vm.showKjdy02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy05,
                            expression: "isShowKjdy05"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(130)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy03icon",
                          on: { click: _vm.showKjdy03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy06,
                            expression: "isShowKjdy06"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy04.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy07,
                            expression: "isShowKjdy07"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy08,
                            expression: "isShowKjdy08"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdy,
                                callback: function($$v) {
                                  _vm.kjdy = $$v
                                },
                                expression: "kjdy"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy09,
                            expression: "isShowKjdy09"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(131)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy10,
                            expression: "isShowKjdy10"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy06.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy11,
                            expression: "isShowKjdy11"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy12,
                            expression: "isShowKjdy12"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdytwo,
                                callback: function($$v) {
                                  _vm.kjdytwo = $$v
                                },
                                expression: "kjdytwo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy13,
                            expression: "isShowKjdy13"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(132)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy14,
                            expression: "isShowKjdy14"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy08.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy15,
                            expression: "isShowKjdy15"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy16,
                            expression: "isShowKjdy16"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { mouseover: _vm.showKjdy09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy17,
                            expression: "isShowKjdy17"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(133)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { click: _vm.showKjdy10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy18,
                            expression: "isShowKjdy18"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy08icon",
                          on: { click: _vm.showKjdy11 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy19,
                            expression: "isShowKjdy19"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(134)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.fenzu,
                            callback: function($$v) {
                              _vm.fenzu = $$v
                            },
                            expression: "fenzu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy09icon",
                          on: { click: _vm.showKjdy12 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy20,
                            expression: "isShowKjdy20"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy10icon",
                          on: { click: _vm.showKjdy13 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy21,
                            expression: "isShowKjdy21"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(135)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy11icon",
                          on: { click: _vm.showKjdy14 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy22,
                            expression: "isShowKjdy22"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(136)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy04input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.kjbm,
                            callback: function($$v) {
                              _vm.kjbm = $$v
                            },
                            expression: "kjbm"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy12icon",
                          on: { click: _vm.showKjdy15 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy23,
                            expression: "isShowKjdy23"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(137)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isShowKjdyTip01
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请先下载下方的快捷短语表格，并保存在桌面上")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip02
                    ? _c("p", [_vm._v("请将下载好的快捷短语表格导入到京麦上")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip03
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("鼠标左键")
                          ]),
                          _vm._v("调出"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("发货")
                          ]),
                          _vm._v("的快捷短语，并发送\n                    ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/16")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/发货")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip06
                    ? _c("div", [
                        _c("p", [_vm._v("新建一条催付的快捷短语：")]),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语内容："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(
                                "您好！您拍下的商品还未付款，请问您是有什么顾虑吗？"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("新建快捷短语分组："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语编码："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFive }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-快捷短语导入和使用.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt5
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt5(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt5 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、转接功能")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://res.study.itaojin.cn/2022-11/2c7b60063f4e48b99953e5c13c35918b.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn01,
                            expression: "isShowZjgn01"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(138)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { mouseover: _vm.showZjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn02,
                            expression: "isShowZjgn02"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(139)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { click: _vm.showZjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn03,
                            expression: "isShowZjgn03"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(140)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn02icon",
                          on: { click: _vm.showZjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn04,
                            expression: "isShowZjgn04"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(141)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn03icon",
                          on: { dblclick: _vm.showZjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn05,
                            expression: "isShowZjgn05"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(142)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn04icon",
                          on: { click: _vm.showZjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn06,
                            expression: "isShowZjgn06"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(143)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn05icon",
                          on: { click: _vm.showZjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn07,
                            expression: "isShowZjgn07"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(144)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v("请根据聊天内容，将此顾客转接给状态为“"),
                      _c("font", { attrs: { color: "red" } }, [_vm._v("在线")]),
                      _vm._v("”的售后客服，并选择对应的"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("转接原因")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySix }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-转接功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt6(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt6 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("7、插件功能（上）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src:
                        "http://res.study.itaojin.cn/2022-11/9ffffdca284f418dadbf961f2d6b4e82.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn01,
                            expression: "isShowCjgn01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(145)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { mouseover: _vm.showCjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn02,
                            expression: "isShowCjgn02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(146)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { click: _vm.showCjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn03,
                            expression: "isShowCjgn03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(147)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn02icon",
                          on: { click: _vm.showCjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn04,
                            expression: "isShowCjgn04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(148)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn05,
                            expression: "isShowCjgn05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(149)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn03icon",
                          on: { click: _vm.showCjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn06,
                            expression: "isShowCjgn06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn04icon",
                          on: { click: _vm.showCjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn07,
                            expression: "isShowCjgn07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(150)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn05icon",
                          on: { click: _vm.showCjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn08,
                            expression: "isShowCjgn08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(151)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn09,
                            expression: "isShowCjgn09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn06icon",
                          on: { click: _vm.showCjgn07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn10,
                            expression: "isShowCjgn10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(152)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn07icon",
                          on: { click: _vm.showCjgn08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn11,
                            expression: "isShowCjgn11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(153)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn12,
                            expression: "isShowCjgn12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn08icon",
                          on: { click: _vm.showCjgn09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn13,
                            expression: "isShowCjgn13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(154)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn09icon",
                          on: { click: _vm.showCjgn10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn14,
                            expression: "isShowCjgn14"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(155)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn15,
                            expression: "isShowCjgn15"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn10icon",
                          on: { click: _vm.showCjgn11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn16,
                            expression: "isShowCjgn16"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn11icon",
                          on: { click: _vm.showCjgn12 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn17,
                            expression: "isShowCjgn17"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(156)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn18,
                            expression: "isShowCjgn18"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn12icon",
                          on: { click: _vm.showCjgn13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn19,
                            expression: "isShowCjgn19"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(157)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn13icon",
                          on: { click: _vm.showCjgn14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn20,
                            expression: "isShowCjgn20"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(158)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isShowCjgnTip01
                    ? _c("p", [_vm._v("请添加客服助手插件")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip02
                    ? _c("p", [
                        _vm._v("请查看客户的商品浏览足迹，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请发送符合客户需求的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("金")
                          ]),
                          _vm._v("和"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("银")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip04
                    ? _c("p", [_vm._v("请查看客户的购物车，并推荐合适的商品")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip05
                    ? _c("p", [
                        _vm._v("请查看客户收藏关注的商品，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip06
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺销量最高，且符合客户需求的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip07
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺评价最高，且符合客户需求的商品")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySeven }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-插件功能（上）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt7
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt7(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt7 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer7" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "eight" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("7、插件功能（下）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-eight" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "eight",
                      src:
                        "http://res.study.itaojin.cn/2022-11/e10f85a5021046eabc0783481fb6bab1.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx01,
                            expression: "isShowCjgnx01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(159)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx01icon",
                          on: { click: _vm.showCjgnx01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx02,
                            expression: "isShowCjgnx02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(160)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx01input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.yunfei,
                            callback: function($$v) {
                              _vm.yunfei = $$v
                            },
                            expression: "yunfei"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx02icon",
                          on: { click: _vm.showCjgnx02 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx03,
                            expression: "isShowCjgnx03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(161)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx04,
                            expression: "isShowCjgnx04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(162)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx03icon",
                          on: { click: _vm.showCjgnx03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx05,
                            expression: "isShowCjgnx05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(163)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.dizhi,
                            callback: function($$v) {
                              _vm.dizhi = $$v
                            },
                            expression: "dizhi"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx04icon",
                          on: { click: _vm.showCjgnx04 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx06,
                            expression: "isShowCjgnx06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx05icon",
                          on: { click: _vm.showCjgnx05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx07,
                            expression: "isShowCjgnx07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(164)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx08,
                            expression: "isShowCjgnx08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx06icon",
                          on: { click: _vm.showCjgnx06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx09,
                            expression: "isShowCjgnx09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(165)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx10,
                            expression: "isShowCjgnx10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(166)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx07icon",
                          on: { click: _vm.showCjgnx07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx11,
                            expression: "isShowCjgnx11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(167)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx08icon",
                          on: { click: _vm.showCjgnx08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx12,
                            expression: "isShowCjgnx12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(168)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx09icon",
                          on: { click: _vm.showCjgnx09 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx13,
                            expression: "isShowCjgnx13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(169)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip01
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待付款")
                          ]),
                          _vm._v(
                            "的订单可以修改运费。请阅读聊天内容，修改运费金额\n                    "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip02
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待出库")
                          ]),
                          _vm._v(
                            "的订单，可以修改客户收货信息。请根据聊天内容，修改客户收货信息"
                          ),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v(
                              "\n                            （注意：如果提示输入的内容不正确，那就是地址的省、市、区、街道重复了）"
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("收货信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("假设店铺规定有关发票的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("1级")
                          ]),
                          _vm._v("；有关顺丰快递的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("2级\n                        ")
                          ]),
                          _vm._v("。请根据聊天内容，给此客户添加对应的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单备注")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip06
                    ? _c(
                        "p",
                        [
                          _vm._v("请编辑备注内容为："),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("要纸质发票")
                          ]),
                          _vm._v("，并选择对应的等级")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyEight }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-nine")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-插件功能（下）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt8
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt8(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt8 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer8" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "nine" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("8、退出京麦")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-nine" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "nine",
                      src:
                        "http://res.study.itaojin.cn/2022-11/405a93afb6cf40a7b66fdf7b3dc676bc.mp4?version=0512",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-nine" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcjmbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm01,
                            expression: "isShowTcjm01"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(170)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm01icon",
                          on: { click: _vm.showTcjm01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm02,
                            expression: "isShowTcjm02"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(171)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm02icon",
                          on: { click: _vm.showTcjm02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm03,
                            expression: "isShowTcjm03"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(172)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm03icon",
                          on: { click: _vm.showTcjm03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm04,
                            expression: "isShowTcjm04"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(173)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm04icon",
                          on: { click: _vm.showTcjm04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm05,
                            expression: "isShowTcjm05"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(174)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm05icon",
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.showTcjm05.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjmImg",
                          attrs: {
                            src: __webpack_require__(175)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjm06icon",
                          on: { click: _vm.showTcjm06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm07,
                            expression: "isShowTcjm07"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(176)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isShowTcjmTip01
                    ? _c(
                        "p",
                        [
                          _vm._v("请将状态切换为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("离线")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip02
                    ? _c("p", [_vm._v("请关闭接待中心")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip03
                    ? _c("p", [_vm._v("请在右下角找到京麦的图标，并退出京麦")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-nine" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [_vm._v("实操通关，进入下一关吧")]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartVideoNine }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重练")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-ten")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-退出京麦.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt9
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt9(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt9 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer9" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "ten" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("9、从多脉启动京麦")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-ten" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "ten",
                      src:
                        "https://res.study.itaojin.cn/training-resource/2025-09/20250908.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    您的浏览器不支持 video 标签。\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-ten" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-ten" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "dmqdbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 1 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(432),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 1 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(978),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1,
                          expression: "duomaiStep == 1"
                        }
                      ],
                      staticClass: "desktop-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 2
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 2 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(979),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 2 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(980),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2,
                          expression: "duomaiStep == 2"
                        }
                      ],
                      staticClass: "jingmai-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 3
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 3 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(981),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 3 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(982),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3,
                          expression: "duomaiStep == 3"
                        }
                      ],
                      staticClass: "login-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 4
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 4 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(983),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 4 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(984),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4,
                          expression: "duomaiStep == 4"
                        }
                      ],
                      staticClass: "dd-hover",
                      on: {
                        click: _vm.lastStep,
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 5,
                          expression: "duomaiStep == 5"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(432),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 5,
                          expression: "duomaiStep == 5"
                        }
                      ],
                      staticClass: "dmjm-img",
                      attrs: {
                        src: __webpack_require__(985),
                        alt: ""
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                        提示\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.duomaiStep == 1
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("打开左侧")
                          ]),
                          _vm._v("练习场中的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("多脉客服助手")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 2
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("启动京麦")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 3
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("点击登录")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 4
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("点击右上角的咚咚图标，进入接待中心")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-ten" } },
                  [
                    _c(
                      "div",
                      { staticClass: "tip", staticStyle: { width: "290px" } },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _vm._v(
                                  "\n                        你已完成\n                        "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.myExamNum))
                                ]),
                                _vm._v(
                                  "\n                        次，需完成\n                        "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.examNum))
                                ]),
                                _vm._v(
                                  "\n                        次\n                    "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "margin-top": "5px" } }, [
                          _vm._v("你已完成京麦的功能学习,")
                        ]),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("接下来请完成《京麦模拟实操》。")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "5px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("去完成京麦模拟实操")]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: { width: "160px" },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("继续学习")]
                            )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n                    查看学习资料\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: { src: "/tjkStudy/static/newqianniu/ppt.png" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("京麦练习-从多脉启动京麦.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt10
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt10(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt10 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer10" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23bf9490", esExports)
  }
}

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiExam_vue__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_708c9a77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingmaiExam_vue__ = __webpack_require__(1730);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1728)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-708c9a77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jingmaiExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_708c9a77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_jingmaiExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/jingmaiExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-708c9a77", Component.options)
  } else {
    hotAPI.reload("data-v-708c9a77", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1729);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4c74ebdc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-708c9a77\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingmaiExam.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-708c9a77\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./jingmaiExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-708c9a77] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-708c9a77] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.mynone[data-v-708c9a77] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "jingmaiExam" } }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          "align-items": "center",
          "margin-bottom": "10px",
          cursor: "pointer",
          width: "100px"
        },
        on: { click: _vm.goBack }
      },
      [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-left": "10px" } }, [_vm._v("返回")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: __webpack_require__(105)
                        },
                        on: { click: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(50)
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02",
                        attrs: {
                          src: __webpack_require__(106)
                        },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginImg,
                          expression: "isShowLoginImg"
                        }
                      ],
                      staticClass: "login"
                    },
                    [
                      _c("img", {
                        staticClass: "homeImg",
                        attrs: {
                          src: __webpack_require__(107)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text", placeholder: "请输入账号" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                          placeholder: "请输入密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "mima",
                        on: {
                          click: function($event) {
                            _vm.isShowMimaImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowMimaImg,
                            expression: "isShowMimaImg"
                          }
                        ],
                        staticClass: "mima",
                        attrs: {
                          src: __webpack_require__(108)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logIn",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowRnd,
                          expression: "isShowRnd"
                        }
                      ],
                      staticClass: "loginrnd"
                    },
                    [
                      _c("img", {
                        staticClass: "rndImg",
                        attrs: {
                          src: __webpack_require__(109)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rnd,
                            expression: "rnd"
                          }
                        ],
                        staticClass: "rnd",
                        attrs: {
                          type: "text",
                          placeholder: "请输入短信验证码"
                        },
                        domProps: { value: _vm.rnd },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rnd = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logInRnd",
                        on: { click: _vm.loginInRnd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndex,
                          expression: "isShowLoginIndex"
                        }
                      ],
                      staticClass: "jdbox"
                    },
                    [
                      _c("img", {
                        staticClass: "jdimg",
                        attrs: {
                          src: __webpack_require__(110)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "jdicon",
                        on: { click: _vm.enterJd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndexTwo,
                          expression: "isShowLoginIndexTwo"
                        }
                      ],
                      staticClass: "indexbox"
                    },
                    [
                      _c("img", {
                        staticClass: "indeximg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的京麦图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _c(
                                  "p",
                                  [
                                    _vm._v("账号（"),
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("账号中间的冒号是英文冒号")
                                    ]),
                                    _vm._v("）：")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("淘金客服:002")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("密码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("TJ2022")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("勾选“记住密码”")])
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            },
                            [_vm._v("获取短信验证码")]
                          ),
                          _vm._v(" "),
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("6022")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [_vm._v("请进入京麦接待中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowWgq,
                          expression: "!isShowWgq"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(51)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "gqbtn",
                        on: {
                          click: function($event) {
                            _vm.showGqImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: __webpack_require__(111)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqclick",
                        on: { click: _vm.showWgqImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowWgq,
                          expression: "isShowWgq"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "wgqimg",
                        attrs: {
                          src: __webpack_require__(112)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(2)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "paixubox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne || _vm.isShowFive,
                          expression: "isShowOne || isShowFive"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(113)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne,
                          expression: "isShowOne"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { mouseover: _vm.showPaixuImgOne }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(114)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { click: _vm.showPaixuImgTwo }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(115)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { mouseover: _vm.showPaixuImgThree }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(116)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { click: _vm.showPaixuImgFour }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "sjclick",
                      on: { click: _vm.showPaixuImgFive }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: __webpack_require__(117)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _vm.isShowOne ||
                  _vm.isShowTwo ||
                  _vm.isShowThree ||
                  _vm.isShowFour
                    ? _c(
                        "p",
                        [
                          _vm._v("请将客户咨询排序设置为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("\n\t\t\t\t\t\t\t\t\t按等待时间降序")
                          ]),
                          _vm._v("”\n\t\t\t\t\t\t\t")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowFive
                    ? _c(
                        "p",
                        [
                          _vm._v("请切换到"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("数据")
                          ]),
                          _vm._v("功能，查看数据")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zdhfbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(118)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { mouseover: _vm.showZdhf01 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(119)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { click: _vm.showZdhf02 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: __webpack_require__(120)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "zdhf01icon",
                      on: { click: _vm.showZdhf03 }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf03,
                            expression: "isShowZdhf03"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(121)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf02icon",
                          on: { click: _vm.showZdhf04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf04,
                            expression: "isShowZdhf04"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(122)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf03icon",
                          on: { click: _vm.showZdhf05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf05,
                            expression: "isShowZdhf05"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(123)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf04icon",
                          on: { click: _vm.showZdhf06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf06,
                            expression: "isShowZdhf06"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(124)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf05icon",
                          on: { click: _vm.showZdhf07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf07,
                            expression: "isShowZdhf07"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(125)
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "scrollImg",
                          attrs: {
                            src: __webpack_require__(126)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "zdhf06input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.zdhf,
                            callback: function($$v) {
                              _vm.zdhf = $$v
                            },
                            expression: "zdhf"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf06icon",
                          on: { click: _vm.showZdhf08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf08,
                            expression: "isShowZdhf08"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(127)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "请设置“您好！欢迎光临，请问有什么可以帮到您？”的自动回复"
                      ),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("个人版欢迎语")
                      ]),
                      _vm._v("，并勾选“"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t第一次收到顾客消息的回复语")
                      ]),
                      _vm._v("\n\t\t\t\t\t\t\t\t”（记得保存）")
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "kjdybox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy01,
                            expression: "isShowKjdy01"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy01icon",
                          on: { mouseover: _vm.showKjdy01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy02,
                            expression: "isShowKjdy02"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(128)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "kjdy01icon" }, [
                          _c("input", {
                            staticClass: "btn-file",
                            attrs: { type: "file", accept: ".csv" },
                            on: {
                              change: function($event) {
                                return _vm.tirggerFile($event)
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy03,
                            expression: "isShowKjdy03"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(129)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy04,
                            expression: "isShowKjdy04"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy02icon",
                          on: { mouseover: _vm.showKjdy02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy05,
                            expression: "isShowKjdy05"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(130)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy03icon",
                          on: { click: _vm.showKjdy03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy06,
                            expression: "isShowKjdy06"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy04.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy07,
                            expression: "isShowKjdy07"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy08,
                            expression: "isShowKjdy08"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdy,
                                callback: function($$v) {
                                  _vm.kjdy = $$v
                                },
                                expression: "kjdy"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy09,
                            expression: "isShowKjdy09"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(131)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy10,
                            expression: "isShowKjdy10"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy06.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy11,
                            expression: "isShowKjdy11"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy12,
                            expression: "isShowKjdy12"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(24)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdytwo,
                                callback: function($$v) {
                                  _vm.kjdytwo = $$v
                                },
                                expression: "kjdytwo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy13,
                            expression: "isShowKjdy13"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(132)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy14,
                            expression: "isShowKjdy14"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(25)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy08.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy15,
                            expression: "isShowKjdy15"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(26)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy16,
                            expression: "isShowKjdy16"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(52)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { mouseover: _vm.showKjdy09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy17,
                            expression: "isShowKjdy17"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(133)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { click: _vm.showKjdy10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy18,
                            expression: "isShowKjdy18"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy08icon",
                          on: { click: _vm.showKjdy11 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy19,
                            expression: "isShowKjdy19"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(134)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.fenzu,
                            callback: function($$v) {
                              _vm.fenzu = $$v
                            },
                            expression: "fenzu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy09icon",
                          on: { click: _vm.showKjdy12 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy20,
                            expression: "isShowKjdy20"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(53)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy10icon",
                          on: { click: _vm.showKjdy13 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy21,
                            expression: "isShowKjdy21"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(135)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy11icon",
                          on: { click: _vm.showKjdy14 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy22,
                            expression: "isShowKjdy22"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(136)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy04input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.kjbm,
                            callback: function($$v) {
                              _vm.kjbm = $$v
                            },
                            expression: "kjbm"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy12icon",
                          on: { click: _vm.showKjdy15 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy23,
                            expression: "isShowKjdy23"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(137)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _vm.isShowKjdyTip01
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请先下载下方的快捷短语表格，并保存在桌面上")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip02
                    ? _c("p", [_vm._v("请将下载好的快捷短语表格导入到京麦上")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip03
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("鼠标左键")
                          ]),
                          _vm._v("调出"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("发货")
                          ]),
                          _vm._v("的快捷短语，并发送\n\t\t\t\t\t\t\t")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/16")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/发货")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip06
                    ? _c("div", [
                        _c("p", [_vm._v("新建一条催付的快捷短语：")]),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语内容："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(
                                "您好！您拍下的商品还未付款，请问您是有什么顾虑吗？"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("新建快捷短语分组："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语编码："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn01,
                            expression: "isShowZjgn01"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(138)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { mouseover: _vm.showZjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn02,
                            expression: "isShowZjgn02"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(139)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { click: _vm.showZjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn03,
                            expression: "isShowZjgn03"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(140)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn02icon",
                          on: { click: _vm.showZjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn04,
                            expression: "isShowZjgn04"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(141)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn03icon",
                          on: { dblclick: _vm.showZjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn05,
                            expression: "isShowZjgn05"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(142)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn04icon",
                          on: { click: _vm.showZjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn06,
                            expression: "isShowZjgn06"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(143)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn05icon",
                          on: { click: _vm.showZjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn07,
                            expression: "isShowZjgn07"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(144)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v("请根据聊天内容，将此顾客转接给状态为“"),
                      _c("font", { attrs: { color: "red" } }, [_vm._v("在线")]),
                      _vm._v("”的售后客服，并选择对应的"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("转接原因")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn01,
                            expression: "isShowCjgn01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(145)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { mouseover: _vm.showCjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn02,
                            expression: "isShowCjgn02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(146)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { click: _vm.showCjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn03,
                            expression: "isShowCjgn03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(147)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn02icon",
                          on: { click: _vm.showCjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn04,
                            expression: "isShowCjgn04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(148)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn05,
                            expression: "isShowCjgn05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(149)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn03icon",
                          on: { click: _vm.showCjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn06,
                            expression: "isShowCjgn06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn04icon",
                          on: { click: _vm.showCjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn07,
                            expression: "isShowCjgn07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(150)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn05icon",
                          on: { click: _vm.showCjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn08,
                            expression: "isShowCjgn08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(151)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn09,
                            expression: "isShowCjgn09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn06icon",
                          on: { click: _vm.showCjgn07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn10,
                            expression: "isShowCjgn10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(152)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn07icon",
                          on: { click: _vm.showCjgn08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn11,
                            expression: "isShowCjgn11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(153)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn12,
                            expression: "isShowCjgn12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn08icon",
                          on: { click: _vm.showCjgn09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn13,
                            expression: "isShowCjgn13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(154)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn09icon",
                          on: { click: _vm.showCjgn10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn14,
                            expression: "isShowCjgn14"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(155)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn15,
                            expression: "isShowCjgn15"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(19)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn10icon",
                          on: { click: _vm.showCjgn11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn16,
                            expression: "isShowCjgn16"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn11icon",
                          on: { click: _vm.showCjgn12 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn17,
                            expression: "isShowCjgn17"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(156)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn18,
                            expression: "isShowCjgn18"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(54)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn12icon",
                          on: { click: _vm.showCjgn13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn19,
                            expression: "isShowCjgn19"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(157)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn13icon",
                          on: { click: _vm.showCjgn14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn20,
                            expression: "isShowCjgn20"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(158)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _vm.isShowCjgnTip01
                    ? _c("p", [_vm._v("请添加客服助手插件")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip02
                    ? _c("p", [
                        _vm._v("请查看客户的商品浏览足迹，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请发送符合客户需求的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("金")
                          ]),
                          _vm._v("和"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("银")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip04
                    ? _c("p", [_vm._v("请查看客户的购物车，并推荐合适的商品")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip05
                    ? _c("p", [
                        _vm._v("请查看客户收藏关注的商品，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip06
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺销量最高，且符合客户需求的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip07
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺评价最高，且符合客户需求的商品")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 8, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx01,
                            expression: "isShowCjgnx01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(159)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx01icon",
                          on: { click: _vm.showCjgnx01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx02,
                            expression: "isShowCjgnx02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(160)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx01input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.yunfei,
                            callback: function($$v) {
                              _vm.yunfei = $$v
                            },
                            expression: "yunfei"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx02icon",
                          on: { click: _vm.showCjgnx02 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx03,
                            expression: "isShowCjgnx03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(161)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx04,
                            expression: "isShowCjgnx04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(162)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx03icon",
                          on: { click: _vm.showCjgnx03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx05,
                            expression: "isShowCjgnx05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(163)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.dizhi,
                            callback: function($$v) {
                              _vm.dizhi = $$v
                            },
                            expression: "dizhi"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx04icon",
                          on: { click: _vm.showCjgnx04 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx06,
                            expression: "isShowCjgnx06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx05icon",
                          on: { click: _vm.showCjgnx05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx07,
                            expression: "isShowCjgnx07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(164)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx08,
                            expression: "isShowCjgnx08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(55)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx06icon",
                          on: { click: _vm.showCjgnx06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx09,
                            expression: "isShowCjgnx09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(165)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx10,
                            expression: "isShowCjgnx10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(166)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx07icon",
                          on: { click: _vm.showCjgnx07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx11,
                            expression: "isShowCjgnx11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(167)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx08icon",
                          on: { click: _vm.showCjgnx08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx12,
                            expression: "isShowCjgnx12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(168)
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx09icon",
                          on: { click: _vm.showCjgnx09 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx13,
                            expression: "isShowCjgnx13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(169)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip01
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待付款")
                          ]),
                          _vm._v(
                            "的订单可以修改运费。请阅读聊天内容，修改运费金额\n\t\t\t\t\t\t\t"
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip02
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待出库")
                          ]),
                          _vm._v(
                            "的订单，可以修改客户收货信息。请根据聊天内容，修改客户收货信息"
                          ),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t（注意：如果提示输入的内容不正确，那就是地址的省、市、区、街道重复了）"
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("收货信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("假设店铺规定有关发票的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("1级")
                          ]),
                          _vm._v("；有关顺丰快递的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("2级\n\t\t\t\t\t\t\t\t")
                          ]),
                          _vm._v("。请根据聊天内容，给此客户添加对应的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单备注")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip06
                    ? _c(
                        "p",
                        [
                          _vm._v("请编辑备注内容为："),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("要纸质发票")
                          ]),
                          _vm._v("，并选择对应的等级")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-nine", 9, "nine")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "nine" },
            attrs: { id: "tab-nine-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-nine" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcjmbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm01,
                            expression: "isShowTcjm01"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(170)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm01icon",
                          on: { click: _vm.showTcjm01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm02,
                            expression: "isShowTcjm02"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(171)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm02icon",
                          on: { click: _vm.showTcjm02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm03,
                            expression: "isShowTcjm03"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(172)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm03icon",
                          on: { click: _vm.showTcjm03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm04,
                            expression: "isShowTcjm04"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(173)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm04icon",
                          on: { click: _vm.showTcjm04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm05,
                            expression: "isShowTcjm05"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(174)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm05icon",
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.showTcjm05.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjmImg",
                          attrs: {
                            src: __webpack_require__(175)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjm06icon",
                          on: { click: _vm.showTcjm06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm07,
                            expression: "isShowTcjm07"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: __webpack_require__(176)
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _vm.isShowTcjmTip01
                    ? _c(
                        "p",
                        [
                          _vm._v("请将状态切换为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("离线")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip02
                    ? _c("p", [_vm._v("请关闭接待中心")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip03
                    ? _c("p", [_vm._v("请在右下角找到京麦的图标，并退出京麦")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-nine" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tip",
                        staticStyle: { width: "400px", height: "270px" }
                      },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("实操通关，进入下一关吧")]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "a",
                            {
                              staticClass: "startstudy",
                              on: {
                                click: function($event) {
                                  return _vm.studyNext("#tab-ten", 10, "ten")
                                }
                              }
                            },
                            [_vm._v("GO，下一关")]
                          )
                        ])
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "ten" },
            attrs: { id: "tab-ten-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-ten" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "dmqdbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 1 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(432),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 1 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(978),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1,
                          expression: "duomaiStep == 1"
                        }
                      ],
                      staticClass: "desktop-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 2
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 2 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(979),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 2 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(980),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2,
                          expression: "duomaiStep == 2"
                        }
                      ],
                      staticClass: "jingmai-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 3
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 3 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(981),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 3 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(982),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3,
                          expression: "duomaiStep == 3"
                        }
                      ],
                      staticClass: "login-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 4
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 4 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(983),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 4 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(984),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4,
                          expression: "duomaiStep == 4"
                        }
                      ],
                      staticClass: "dd-hover",
                      on: {
                        click: _vm.lastStep,
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 5,
                          expression: "duomaiStep == 5"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: __webpack_require__(432),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 5,
                          expression: "duomaiStep == 5"
                        }
                      ],
                      staticClass: "dmjm-img",
                      attrs: {
                        src: __webpack_require__(985),
                        alt: ""
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(10),
                  _vm._v(" "),
                  _vm.duomaiStep == 1
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("打开左侧")
                          ]),
                          _vm._v("练习场中的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("多脉客服助手")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 2
                    ? _c("p", [_vm._v("启动京麦")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 3
                    ? _c("p", [_vm._v("点击登录")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 4
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("点击右上角的咚咚图标，进入接待中心")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-ten" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tip",
                        staticStyle: { width: "400px", height: "270px" }
                      },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t你已完成\n\t\t\t\t\t\t\t\t"
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.myExamNum))
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t次，需完成\n\t\t\t\t\t\t\t\t"
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.examNum))
                                ]),
                                _vm._v("\n\t\t\t\t\t\t\t\t次\n\t\t\t\t\t\t\t")
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("恭喜您完成所有训练")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "5px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("返回")]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "10px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("继续学习")]
                            )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("1、登录京麦")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、状态切换")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、客户列表+数据统计")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、自动回复设置")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("5、快捷短语导入和使用")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、转接功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、插件功能（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、插件功能（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-nine" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("8、退出京麦")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-ten" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("9、从多脉打开京麦")
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("请将状态切换为“在线”")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-708c9a77", esExports)
  }
}

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudian_vue__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudian_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudian_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudian_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudian_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d65b6d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doudian_vue__ = __webpack_require__(1734);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1732)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d65b6d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudian_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d65b6d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doudian_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/doudian.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d65b6d7", Component.options)
  } else {
    hotAPI.reload("data-v-2d65b6d7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1733);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2c68ab66", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d65b6d7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./doudian.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d65b6d7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./doudian.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-2d65b6d7] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-2d65b6d7] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.blod-span[data-v-2d65b6d7] {\n  color: red;\n  font-weight: bold;\n}\n.video-mask[data-v-2d65b6d7] {\n  position: absolute;\n  bottom: 0;\n  left: 0px;\n  width: 1291px;\n  height: 25px;\n}\n", ""]);

// exports


/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "feiGe" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "align-items": "center",
            "margin-bottom": "10px",
            cursor: "pointer",
            width: "100px"
          },
          on: { click: _vm.goBack }
        },
        [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("返回")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "zero" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("通关必看")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-zero" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "zero",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/%E9%80%9A%E5%85%B3%E5%BF%85%E7%9C%8B.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-zero" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-first")
                          }
                        }
                      },
                      [_vm._v("继续下一步学习")]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("1、登录飞鸽工作台")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2023-02/385cc51762b74eb985d3ab9b39f0925a.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(179)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        on: { mouseenter: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(180)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        attrs: { id: "select" },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowIcon3
                    ? _c("div", { staticClass: "qnbox" }, [
                        _c("img", {
                          staticClass: "qnbg left-img",
                          attrs: {
                            src: __webpack_require__(181)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "fgicon03",
                          on: { click: _vm.showLoginImg3 }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon4,
                          expression: "isShowIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(182)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon04",
                        on: { mouseenter: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon5,
                          expression: "isShowIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(183)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon05",
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon6,
                          expression: "isShowIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(184)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon06",
                        on: { click: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon7,
                          expression: "isShowIcon7"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(185)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon07",
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon8,
                          expression: "isShowIcon8"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(186)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.password,
                            expression: "password",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon08",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin1,
                          expression: "isShowLogin1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(187)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { mouseenter: _vm.loginIn1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin2,
                          expression: "isShowLogin2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(188)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { click: _vm.loginIn2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin3,
                          expression: "isShowLogin3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(189)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            return _vm.loginIn3.apply(null, arguments)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin4,
                          expression: "isShowLogin4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(190)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon10",
                        on: { click: _vm.loginIn4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin5,
                          expression: "isShowLogin5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(191)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请打开"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("左侧练习场")
                          ]),
                          _vm._v("中的飞鸽客服工作台")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon3
                      ? [
                          _c("p", [
                            _vm._v("选择"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("我是商家")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon4 || _vm.isShowIcon5
                      ? [
                          _c("p", [
                            _vm._v("点击右上角的电脑图标，切换为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("手机号登录")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon6 || _vm.isShowIcon7 || _vm.isShowIcon8
                      ? [
                          _c("p", [
                            _vm._v("注意："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("正式任务")
                            ]),
                            _vm._v("需提前将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("自己的手机号")
                            ]),
                            _vm._v("反馈给主管开通账号！")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("假设练习场"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("账号为：13853678478")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("验证码为：3346")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin1 || _vm.isShowLogin2
                      ? [
                          _c("p", [
                            _vm._v("鼠标"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("左键")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("第2个")
                            ]),
                            _vm._v("店铺，切换到第2个店铺")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin3 || _vm.isShowLogin4
                      ? [
                          _c("p", [
                            _vm._v("鼠标"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("右键")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("第2个")
                            ]),
                            _vm._v("店铺，"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("退出店铺")
                            ]),
                            _vm._v("铺")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("登录飞鸽.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、基础设置（上）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2023-02/ffe43489dcdf458cb1df730725770806.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp,
                          expression: "isShowSetUp"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(192)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon01",
                        on: { click: _vm.setUp }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp1,
                          expression: "isShowSetUp1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(193)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { mouseenter: _vm.setUp1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp2,
                          expression: "isShowSetUp2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(194)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { click: _vm.setUp2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp3,
                          expression: "isShowSetUp3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(195)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon03",
                        on: { click: _vm.setUp3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp4,
                          expression: "isShowSetUp4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(196)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { mouseenter: _vm.setUp4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp5,
                          expression: "isShowSetUp5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(197)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { click: _vm.setUp5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp6,
                          expression: "isShowSetUp6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(198)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { mouseenter: _vm.setUp6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp7,
                          expression: "isShowSetUp7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(199)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { click: _vm.setUp7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp8,
                          expression: "isShowSetUp8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(200)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { mouseenter: _vm.setUp8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp9,
                          expression: "isShowSetUp9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(201)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { click: _vm.setUp9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp10,
                          expression: "isShowSetUp10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                            提示\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isShowSetUp || _vm.isShowSetUp1 || _vm.isShowSetUp2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("在线")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp3 || _vm.isShowSetUp4 || _vm.isShowSetUp5
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("小休")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp6 ||
                  _vm.isShowSetUp7 ||
                  _vm.isShowSetUp8 ||
                  _vm.isShowSetUp9
                    ? _c("p", [
                        _vm._v("请将当前会话的接待排序设置为：按"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("等待时长")
                        ]),
                        _vm._v("由长到短排序")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySecond }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("基础设置（上）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt1
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt1(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt1 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer1" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、基础设置（下）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://res.study.itaojin.cn/2023-02/9154da85cd3b4f718d49e1502dd0d96e.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown,
                          expression: "isShowSetDown"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown1,
                          expression: "isShowSetDown1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(202)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          click: function($event) {
                            return _vm.setDown1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown2,
                          expression: "isShowSetDown2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(203)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown3,
                          expression: "isShowSetDown3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(204)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          click: function($event) {
                            return _vm.setDown3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown4,
                          expression: "isShowSetDown4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(205)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown5,
                          expression: "isShowSetDown5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(206)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          click: function($event) {
                            return _vm.setDown5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown6,
                          expression: "isShowSetDown6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(207)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown7,
                          expression: "isShowSetDown7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(208)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown033",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown8,
                          expression: "isShowSetDown8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(209)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown9,
                          expression: "isShowSetDown9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(210)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          click: function($event) {
                            return _vm.setDown9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown10,
                          expression: "isShowSetDown10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(211)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown05",
                        on: {
                          click: function($event) {
                            return _vm.setDown10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown11,
                          expression: "isShowSetDown11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(212)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dyInput,
                            expression: "dyInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dyInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.dyInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dyInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown06",
                        on: {
                          click: function($event) {
                            return _vm.setDown11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown12,
                          expression: "isShowSetDown12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(213)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown13,
                          expression: "isShowSetDown13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(214)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          click: function($event) {
                            return _vm.setDown13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown14,
                          expression: "isShowSetDown14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(215)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown14()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown15,
                          expression: "isShowSetDown15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown16,
                          expression: "isShowSetDown16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown17,
                          expression: "isShowSetDown17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown18,
                          expression: "isShowSetDown18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown19()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown19,
                          expression: "isShowSetDown19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(216)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          click: function($event) {
                            return _vm.setDown20()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown20,
                          expression: "isShowSetDown20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(217)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown21,
                          expression: "isShowSetDown21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(218)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown22()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown22,
                          expression: "isShowSetDown22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(219)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          click: function($event) {
                            return _vm.setDown23()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown23,
                          expression: "isShowSetDown23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(220)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown24()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown24,
                          expression: "isShowSetDown24"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(221)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          click: function($event) {
                            return _vm.setDown25()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown25,
                          expression: "isShowSetDown25"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(222)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown12",
                        on: {
                          click: function($event) {
                            return _vm.setDown26()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown26,
                          expression: "isShowSetDown26"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(223)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown13",
                        on: {
                          click: function($event) {
                            return _vm.setDown27()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown27,
                          expression: "isShowSetDown27"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(224)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown14",
                        on: {
                          click: function($event) {
                            return _vm.setDown28()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown28,
                          expression: "isShowSetDown28"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(225)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown29()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown29,
                          expression: "isShowSetDown29"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(226)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          click: function($event) {
                            return _vm.setDown30()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown30,
                          expression: "isShowSetDown30"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(227)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown31,
                          expression: "isShowSetDown31"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(228)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown32()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown32,
                          expression: "isShowSetDown32"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(229)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          click: function($event) {
                            return _vm.setDown33()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown33,
                          expression: "isShowSetDown33"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(230)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown17",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown34()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowSetDown34
                    ? _c("div", { staticClass: "szbox" }, [
                        _c("img", {
                          staticClass: "szbg",
                          attrs: {
                            src: __webpack_require__(231)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "btn-file",
                          attrs: { type: "file" },
                          on: {
                            change: function($event) {
                              return _vm.tirggerFile($event)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown35,
                          expression: "isShowSetDown35"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(232)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown36()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown36,
                          expression: "isShowSetDown36"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(233)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          click: function($event) {
                            return _vm.setDown37()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown37,
                          expression: "isShowSetDown37"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(234)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown38,
                          expression: "isShowSetDown38"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(235)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown39()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown39,
                          expression: "isShowSetDown39"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(236)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          click: function($event) {
                            return _vm.setDown40()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown40,
                          expression: "isShowSetDown40"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown41()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown41,
                          expression: "isShowSetDown41"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(237)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          click: function($event) {
                            return _vm.setDown42()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown42,
                          expression: "isShowSetDown42"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown43()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown43()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown43,
                          expression: "isShowSetDown43"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown431,
                          expression: "isShowSetDown431"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal,
                            expression: "duanyuInputVal",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal = $event.target.value.trim()
                            },
                            _vm.duanyuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown432,
                          expression: "isShowSetDown432"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown432()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown432()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown433,
                          expression: "isShowSetDown433"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown434,
                          expression: "isShowSetDown434"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal1,
                            expression: "duanyuInputVal1",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal1 },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal1 = $event.target.value.trim()
                            },
                            _vm.duanyuInput1
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown44,
                          expression: "isShowSetDown44"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(238)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown45()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown45,
                          expression: "isShowSetDown45"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(239)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          click: function($event) {
                            return _vm.setDown46()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown451,
                          expression: "isShowSetDown451"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown461()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown461()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown452,
                          expression: "isShowSetDown452"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSetDown ||
                    _vm.isShowSetDown1 ||
                    _vm.isShowSetDown2 ||
                    _vm.isShowSetDown3
                      ? _c("p", [
                          _vm._v("请从"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服管理")
                          ]),
                          _vm._v("进入"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服工具")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown4 || _vm.isShowSetDown5
                      ? _c("p", [
                          _vm._v("选择客服工具中的"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("快捷短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown6 || _vm.isShowSetDown7
                      ? _c("p", [
                          _vm._v("点击"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新建短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown8 ||
                    _vm.isShowSetDown9 ||
                    _vm.isShowSetDown10 ||
                    _vm.isShowSetDown11
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新增")
                          ]),
                          _vm._v("一个"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown12 || _vm.isShowSetDown13
                      ? _c("p", [
                          _vm._v("选择"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown14 ||
                    _vm.isShowSetDown15 ||
                    _vm.isShowSetDown16 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown18 ||
                    _vm.isShowSetDown19
                      ? [
                          _c("p", [
                            _vm._v("添加催单短语内容："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("亲亲，喜欢的话就下单吧，早拍早发货哦！")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("编码短语设置为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("催单")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("确定")
                            ]),
                            _vm._v("按钮进行保存")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown20 ||
                    _vm.isShowSetDown21 ||
                    _vm.isShowSetDown22
                      ? [
                          _c("p", [
                            _vm._v("请点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("模板库导入")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown23 ||
                    _vm.isShowSetDown24 ||
                    _vm.isShowSetDown25 ||
                    _vm.isShowSetDown26 ||
                    _vm.isShowSetDown27 ||
                    _vm.isShowSetDown28 ||
                    _vm.isShowSetDown29
                      ? [
                          _c("p", [
                            _vm._v("请将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("分组")
                            ]),
                            _vm._v("设置为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("问候语")
                            ]),
                            _vm._v("，并选择"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("前面2条")
                            ]),
                            _vm._v("快捷问候语；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("确定导入")
                            ]),
                            _vm._v("按钮")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown30 ||
                    _vm.isShowSetDown31 ||
                    _vm.isShowSetDown32 ||
                    _vm.isShowSetDown33 ||
                    _vm.isShowSetDown34 ||
                    _vm.isShowSetDown35 ||
                    _vm.isShowSetDown36
                      ? [
                          _c("p", [
                            _vm._v("1.先"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("下载下方的飞鸽快捷短语")
                            ]),
                            _vm._v("表格；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("2.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("批量导入")
                            ]),
                            _vm._v("按钮；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("3.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("添加文件")
                            ]),
                            _vm._v(
                              "，选择下载的飞鸽快捷短语表格（可以先将下载的表格另存到桌面上，方便导入时快速找到表格）；"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("4.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("导入")
                            ]),
                            _vm._v("按钮；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“飞鸽快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown37 ||
                    _vm.isShowSetDown38 ||
                    _vm.isShowSetDown39
                      ? [
                          _c("p", [
                            _vm._v("点击右侧的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("快捷短语；")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown40 ||
                    _vm.isShowSetDown41 ||
                    _vm.isShowSetDown42
                      ? [
                          _c("p", [
                            _vm._v("请采用"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("鼠标左键")
                            ]),
                            _vm._v(
                              "点击快捷短语的方式，给当前用户发送欢迎语："
                            ),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown43 ||
                    _vm.isShowSetDown431 ||
                    _vm.isShowSetDown432 ||
                    _vm.isShowSetDown433
                      ? [
                          _c("p", [
                            _vm._v("请采用输入"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("/您好")
                            ]),
                            _vm._v("的方式，给当前用户发送欢迎语："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown434 ||
                    _vm.isShowSetDown44 ||
                    _vm.isShowSetDown45 ||
                    _vm.isShowSetDown451 ||
                    _vm.isShowSetDown452
                      ? [
                          _c("p", [
                            _vm._v("请采用输入文本"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("您好")
                            ]),
                            _vm._v("的方式，给当前用户发送欢迎语："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyThird }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("基础设置（下）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("3、会话窗口")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://res.study.itaojin.cn/2023-02/b1da8c11184d4b1da68389bc7e89f0f8.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession,
                          expression: "isShowSession"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(240)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession1,
                          expression: "isShowSession1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(241)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          click: function($event) {
                            return _vm.four1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession2,
                          expression: "isShowSession2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(242)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession3,
                          expression: "isShowSession3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(243)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          click: function($event) {
                            return _vm.four3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession4,
                          expression: "isShowSession4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(244)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSession ||
                    _vm.isShowSession1 ||
                    _vm.isShowSession2 ||
                    _vm.isShowSession3 ||
                    _vm.isShowSession4
                      ? [
                          _c("p", [
                            _vm._v("请将当前用户"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("转接")
                            ]),
                            _vm._v("给"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("军瑞")
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFour }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("会话窗口.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt3
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt3(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt3 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("4、商品插件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://res.study.itaojin.cn/2023-02/09572dc3445b4b06871354236e70b454.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(245)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive1,
                          expression: "isShowFive1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(246)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          click: function($event) {
                            return _vm.five1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive2,
                          expression: "isShowFive2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(247)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive3,
                          expression: "isShowFive3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(248)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          click: function($event) {
                            return _vm.five3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive4,
                          expression: "isShowFive4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(249)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive5,
                          expression: "isShowFive5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(250)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive6,
                          expression: "isShowFive6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(251)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          click: function($event) {
                            return _vm.five6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive7,
                          expression: "isShowFive7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(252)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive8,
                          expression: "isShowFive8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(253)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          click: function($event) {
                            return _vm.five8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive9,
                          expression: "isShowFive9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(254)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowFive ||
                    _vm.isShowFive1 ||
                    _vm.isShowFive2 ||
                    _vm.isShowFive3 ||
                    _vm.isShowFive4
                      ? [
                          _c("p", [
                            _vm._v("请点击商品插件，将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("全部商品")
                            ]),
                            _vm._v("中"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("销量最高")
                            ]),
                            _vm._v("的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("腰带")
                            ]),
                            _vm._v("链接发送给用户")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowFive5 ||
                    _vm.isShowFive6 ||
                    _vm.isShowFive7 ||
                    _vm.isShowFive8 ||
                    _vm.isShowFive9
                      ? [
                          _c("p", [
                            _vm._v("请将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("浏览足迹")
                            ]),
                            _vm._v("中"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("销量最高")
                            ]),
                            _vm._v("的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("腰带")
                            ]),
                            _vm._v("链接发送给用户")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFive }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("商品插件.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt4
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt4(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt4 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("5、订单插件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://res.study.itaojin.cn/2023-02/b2b06910e7194460875ed8c6ed04e312.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(255)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix1,
                          expression: "isShowSix1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(256)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          click: function($event) {
                            return _vm.six1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix2,
                          expression: "isShowSix2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(257)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.beizhu,
                            expression: "beizhu",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "beizhu",
                        domProps: { value: _vm.beizhu },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.beizhu = $event.target.value.trim()
                            },
                            _vm.beiZhuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six033",
                        on: {
                          click: function($event) {
                            return _vm.six122()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix3,
                          expression: "isShowSix3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(258)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six02",
                        on: {
                          click: function($event) {
                            return _vm.six3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix4,
                          expression: "isShowSix4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(259)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix5,
                          expression: "isShowSix5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(260)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix6,
                          expression: "isShowSix6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(261)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix7,
                          expression: "isShowSix7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(262)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix8,
                          expression: "isShowSix8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(263)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          click: function($event) {
                            return _vm.six7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix9,
                          expression: "isShowSix9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(264)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix10,
                          expression: "isShowSix10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(265)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix11,
                          expression: "isShowSix11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(266)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          click: function($event) {
                            return _vm.six9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix12,
                          expression: "isShowSix12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(267)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix13,
                          expression: "isShowSix13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(268)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix14,
                          expression: "isShowSix14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(269)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          click: function($event) {
                            return _vm.six11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix15,
                          expression: "isShowSix15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(270)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yjgj,
                            expression: "yjgj",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yjgj",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yjgj },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yjgj = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yfInput,
                            expression: "yfInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yfInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yfInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yfInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix16,
                          expression: "isShowSix16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(271)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          click: function($event) {
                            return _vm.six13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix17,
                          expression: "isShowSix17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(272)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix18,
                          expression: "isShowSix18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(273)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six14()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix19,
                          expression: "isShowSix19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(274)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          click: function($event) {
                            return _vm.six15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix20,
                          expression: "isShowSix20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(275)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six081",
                        on: {
                          click: function($event) {
                            return _vm.six16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix21,
                          expression: "isShowSix21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(276)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.sjhm,
                            expression: "sjhm",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "sjhm",
                        attrs: { type: "text" },
                        domProps: { value: _vm.sjhm },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.sjhm = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix22,
                          expression: "isShowSix22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(277)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          click: function($event) {
                            return _vm.six18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix23,
                          expression: "isShowSix23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(278)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSix ||
                    _vm.isShowSix1 ||
                    _vm.isShowSix2 ||
                    _vm.isShowSix3 ||
                    _vm.isShowSix4 ||
                    _vm.isShowSix5 ||
                    _vm.isShowSix6
                      ? [
                          _c("p", [
                            _vm._v("假设此商家规定"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("红色彩旗跟发货相关")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("请给该用户添加"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("备注")
                            ]),
                            _vm._v("内容："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("用户要求发顺丰")
                            ]),
                            _vm._v("并"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("选择对应的彩旗")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix7 || _vm.isShowSix8 || _vm.isShowSix9
                      ? [
                          _c("p", [
                            _vm._v("请给用户发送"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("核对地址")
                            ]),
                            _vm._v("卡片")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix10 || _vm.isShowSix11 || _vm.isShowSix12
                      ? [
                          _c("p", [
                            _vm._v("请给用户发送订单"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("催付")
                            ]),
                            _vm._v("卡片")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix13 ||
                    _vm.isShowSix14 ||
                    _vm.isShowSix15 ||
                    _vm.isShowSix16 ||
                    _vm.isShowSix17
                      ? [
                          _c("p", [
                            _vm._v("请采用"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("一键改价")
                            ]),
                            _vm._v("方式，将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("最终实付价")
                            ]),
                            _vm._v("改为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("48")
                            ]),
                            _vm._v("元，"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("运费")
                            ]),
                            _vm._v("改为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("10")
                            ]),
                            _vm._v("元")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix18 ||
                    _vm.isShowSix19 ||
                    _vm.isShowSix20 ||
                    _vm.isShowSix21 ||
                    _vm.isShowSix22 ||
                    _vm.isShowSix23
                      ? [
                          _c("p", [
                            _vm._v("请在"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("改地址")
                            ]),
                            _vm._v("中，将用户的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("手机号码")
                            ]),
                            _vm._v("改成"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("13512345678")
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySix }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("订单插件.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt5
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt5(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt5 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、退出飞鸽")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src:
                        "http://res.study.itaojin.cn/2023-02/bb58cf754fc24605ac2e993b864565ce.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven,
                          expression: "isShowSeven"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(279)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven1,
                          expression: "isShowSeven1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(280)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven2,
                          expression: "isShowSeven2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(281)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          click: function($event) {
                            return _vm.seven2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven3,
                          expression: "isShowSeven3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(282)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven4,
                          expression: "isShowSeven4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(283)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven03",
                        on: {
                          click: function($event) {
                            return _vm.seven4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven5,
                          expression: "isShowSeven5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(284)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven6,
                          expression: "isShowSeven6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(285)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          click: function($event) {
                            return _vm.seven6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven7,
                          expression: "isShowSeven7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(286)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven8,
                          expression: "isShowSeven8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(287)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          click: function($event) {
                            return _vm.seven8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven9,
                          expression: "isShowSeven9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(288)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven10,
                          expression: "isShowSeven10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(289)
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("img", {
                            staticClass: "small-img",
                            attrs: {
                              src: __webpack_require__(290)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven06",
                            on: {
                              contextmenu: function($event) {
                                $event.preventDefault()
                                return _vm.seven10()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven07",
                            on: {
                              click: function($event) {
                                return _vm.seven11()
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven11,
                          expression: "isShowSeven11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(291)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSeven || _vm.isShowSeven1 || _vm.isShowSeven2
                      ? [
                          _c("p", [
                            _vm._v("请将状态切换为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("小休")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven3 || _vm.isShowSeven4
                      ? [
                          _c("p", [
                            _vm._v("请将状态切换为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("离线")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven5 || _vm.isShowSeven6
                      ? [
                          _c("p", [
                            _vm._v("请关闭"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("接待页面")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven7 || _vm.isShowSeven8
                      ? [_c("p", [_vm._v("请点击右下方显示隐藏的图标")])]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven9 || _vm.isShowSeven10 || _vm.isShowSeven11
                      ? [_c("p", [_vm._v("右键点击飞鸽小图标")])]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [_vm._v("实操通关，进入下一关吧")]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "restart",
                            on: { click: _vm.restartStudySeven }
                          },
                          [
                            _c("i", { staticClass: "el-icon-refresh-left" }),
                            _vm._v("重练")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "startstudy",
                            on: {
                              click: function($event) {
                                return _vm.studyNext("#tab-eight")
                              }
                            }
                          },
                          [_vm._v("GO，下一关")]
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("退出飞鸽.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt6(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt6 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "eight" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("7、从多脉启动抖店")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-eight" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "eight",
                      src:
                        "https://res.study.itaojin.cn/training-resource/2025-09/20250908.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "szbox" }, [
                    _c("div", { staticClass: "duomai-box" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 1 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(988),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1 && _vm.mouseFocusDM,
                            expression: "duomaiStep == 1 && mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(989),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1,
                            expression: "duomaiStep == 1"
                          }
                        ],
                        staticClass: "desktop-hover",
                        on: {
                          click: function() {
                            _vm.duomaiStep = 2
                            _vm.mouseFocusDM = false
                          },
                          mouseenter: function($event) {
                            _vm.mouseFocusDM = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDM = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 2 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(990),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2 && _vm.mouseFocusDM,
                            expression: "duomaiStep == 2 && mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(991),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2,
                            expression: "duomaiStep == 2"
                          }
                        ],
                        staticClass: "doudian-hover",
                        on: {
                          click: function() {
                            _vm.duomaiStep = 3
                            _vm.mouseFocusDM = false
                          },
                          mouseenter: function($event) {
                            _vm.mouseFocusDM = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDM = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 3 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 3 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(992),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 3,
                            expression: "duomaiStep == 3"
                          }
                        ],
                        staticClass: "msg-hover",
                        on: { click: _vm.lastStep }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 4,
                            expression: "duomaiStep == 4"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(993),
                          alt: ""
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                            提示\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.duomaiStep == 1
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("打开左侧")
                          ]),
                          _vm._v("练习场中的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("多脉客服助手")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 2
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("启动抖店")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 3
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("点击右上角的前往飞鸽IM图标，进入接待中心")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
                  [
                    _c(
                      "div",
                      { staticClass: "tip", staticStyle: { width: "290px" } },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _vm._v(
                                  "\n                            你已完成\n                            "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.myExamNum))
                                ]),
                                _vm._v(
                                  "\n                            次，需完成\n                            "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.examNum))
                                ]),
                                _vm._v(
                                  "\n                            次\n                        "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("接下来请完成《抖店模拟实操》。")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "5px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("去完成抖店模拟实操")]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: { width: "160px" },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("继续学习")]
                            )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: __webpack_require__(13)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("抖店练习-从多脉启动抖店.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt7
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt7(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt7 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer7" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d65b6d7", esExports)
  }
}

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianExam_vue__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianExam_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianExam_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianExam_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianExam_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be4317d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doudianExam_vue__ = __webpack_require__(1738);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1736)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be4317d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianExam_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be4317d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doudianExam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/doudianExam.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-be4317d4", Component.options)
  } else {
    hotAPI.reload("data-v-be4317d4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1737);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5aeae366", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-be4317d4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./doudianExam.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-be4317d4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./doudianExam.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.account-table[data-v-be4317d4] {\n  border-top: 1px solid #000000;\n  border-left: 1px solid #000000;\n  margin: 10px;\n  border-spacing: inherit;\n}\n.account-table > tr > td[data-v-be4317d4] {\n  border-right: 1px solid #000000;\n  border-bottom: 1px solid #000000;\n  padding: 5px;\n}\n.blod-span[data-v-be4317d4] {\n  color: red;\n  font-weight: bold;\n}\n.mynone[data-v-be4317d4] {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "feiGeExam" } }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          "align-items": "center",
          "margin-bottom": "10px",
          cursor: "pointer",
          width: "100px"
        },
        on: { click: _vm.goBack }
      },
      [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-left": "10px" } }, [_vm._v("返回")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(179)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        on: { mouseenter: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(180)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        attrs: { id: "select" },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon3,
                          expression: "isShowIcon3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(181)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon03",
                        on: { click: _vm.showLoginImg3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon4,
                          expression: "isShowIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(182)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon04",
                        on: { mouseenter: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon5,
                          expression: "isShowIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(183)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon05",
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon6,
                          expression: "isShowIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(184)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon06",
                        on: { click: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon7,
                          expression: "isShowIcon7"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(185)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon07",
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon8,
                          expression: "isShowIcon8"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: __webpack_require__(186)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.password,
                            expression: "password",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon08",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin1,
                          expression: "isShowLogin1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(187)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { mouseenter: _vm.loginIn1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin2,
                          expression: "isShowLogin2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(188)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { click: _vm.loginIn2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin3,
                          expression: "isShowLogin3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(189)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            return _vm.loginIn3.apply(null, arguments)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin4,
                          expression: "isShowLogin4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(190)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon10",
                        on: { click: _vm.loginIn4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin5,
                          expression: "isShowLogin5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: __webpack_require__(191)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请打开"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("左侧练习场")
                          ]),
                          _vm._v("中的飞鸽客服工作台")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon3 ? [_vm._m(2)] : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon4 || _vm.isShowIcon5 ? [_vm._m(3)] : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon6 || _vm.isShowIcon7 || _vm.isShowIcon8
                      ? [
                          _vm._m(4),
                          _vm._v(" "),
                          _vm._m(5),
                          _vm._v(" "),
                          _vm._m(6)
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin1 || _vm.isShowLogin2
                      ? [_vm._m(7)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin3 || _vm.isShowLogin4
                      ? [_vm._m(8)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp,
                          expression: "isShowSetUp"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(192)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon01",
                        on: { click: _vm.setUp }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp1,
                          expression: "isShowSetUp1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(193)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { mouseenter: _vm.setUp1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp2,
                          expression: "isShowSetUp2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(194)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { click: _vm.setUp2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp3,
                          expression: "isShowSetUp3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(195)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon03",
                        on: { click: _vm.setUp3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp4,
                          expression: "isShowSetUp4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(196)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { mouseenter: _vm.setUp4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp5,
                          expression: "isShowSetUp5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(197)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { click: _vm.setUp5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp6,
                          expression: "isShowSetUp6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(198)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { mouseenter: _vm.setUp6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp7,
                          expression: "isShowSetUp7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(199)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { click: _vm.setUp7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp8,
                          expression: "isShowSetUp8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(200)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { mouseenter: _vm.setUp8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp9,
                          expression: "isShowSetUp9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(201)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { click: _vm.setUp9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp10,
                          expression: "isShowSetUp10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _vm.isShowSetUp || _vm.isShowSetUp1 || _vm.isShowSetUp2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("在线")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp3 || _vm.isShowSetUp4 || _vm.isShowSetUp5
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("小休")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp6 ||
                  _vm.isShowSetUp7 ||
                  _vm.isShowSetUp8 ||
                  _vm.isShowSetUp9
                    ? _c("p", [
                        _vm._v("请将当前会话的接待排序设置为：按"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("等待时长")
                        ]),
                        _vm._v("由长到短排序")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown,
                          expression: "isShowSetDown"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(56)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown1,
                          expression: "isShowSetDown1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(202)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          click: function($event) {
                            return _vm.setDown1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown2,
                          expression: "isShowSetDown2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(203)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown3,
                          expression: "isShowSetDown3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(204)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          click: function($event) {
                            return _vm.setDown3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown4,
                          expression: "isShowSetDown4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(205)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown5,
                          expression: "isShowSetDown5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(206)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          click: function($event) {
                            return _vm.setDown5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown6,
                          expression: "isShowSetDown6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(207)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown7,
                          expression: "isShowSetDown7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(208)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown033",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown8,
                          expression: "isShowSetDown8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(209)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown9,
                          expression: "isShowSetDown9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(210)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          click: function($event) {
                            return _vm.setDown9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown10,
                          expression: "isShowSetDown10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(211)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown05",
                        on: {
                          click: function($event) {
                            return _vm.setDown10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown11,
                          expression: "isShowSetDown11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(212)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dyInput,
                            expression: "dyInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dyInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.dyInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dyInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown06",
                        on: {
                          click: function($event) {
                            return _vm.setDown11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown12,
                          expression: "isShowSetDown12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(213)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown13,
                          expression: "isShowSetDown13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(214)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          click: function($event) {
                            return _vm.setDown13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown14,
                          expression: "isShowSetDown14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(215)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown14()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown15,
                          expression: "isShowSetDown15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown16,
                          expression: "isShowSetDown16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown17,
                          expression: "isShowSetDown17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(58)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown18,
                          expression: "isShowSetDown18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(57)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown19()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown19,
                          expression: "isShowSetDown19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(216)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          click: function($event) {
                            return _vm.setDown20()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown20,
                          expression: "isShowSetDown20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(217)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown21,
                          expression: "isShowSetDown21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(218)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown22()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown22,
                          expression: "isShowSetDown22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(219)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          click: function($event) {
                            return _vm.setDown23()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown23,
                          expression: "isShowSetDown23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(220)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown24()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown24,
                          expression: "isShowSetDown24"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(221)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          click: function($event) {
                            return _vm.setDown25()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown25,
                          expression: "isShowSetDown25"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(222)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown12",
                        on: {
                          click: function($event) {
                            return _vm.setDown26()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown26,
                          expression: "isShowSetDown26"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(223)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown13",
                        on: {
                          click: function($event) {
                            return _vm.setDown27()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown27,
                          expression: "isShowSetDown27"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(224)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown14",
                        on: {
                          click: function($event) {
                            return _vm.setDown28()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown28,
                          expression: "isShowSetDown28"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(225)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown29()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown29,
                          expression: "isShowSetDown29"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(226)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          click: function($event) {
                            return _vm.setDown30()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown30,
                          expression: "isShowSetDown30"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(227)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown31,
                          expression: "isShowSetDown31"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(228)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown32()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown32,
                          expression: "isShowSetDown32"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(229)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          click: function($event) {
                            return _vm.setDown33()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown33,
                          expression: "isShowSetDown33"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(230)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown17",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown34()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowSetDown34
                    ? _c("div", { staticClass: "szbox" }, [
                        _c("img", {
                          staticClass: "szbg",
                          attrs: {
                            src: __webpack_require__(231)
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "btn-file",
                          attrs: { type: "file" },
                          on: {
                            change: function($event) {
                              return _vm.tirggerFile($event)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown35,
                          expression: "isShowSetDown35"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(232)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown36()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown36,
                          expression: "isShowSetDown36"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(233)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          click: function($event) {
                            return _vm.setDown37()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown37,
                          expression: "isShowSetDown37"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(234)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown38,
                          expression: "isShowSetDown38"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(235)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown39()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown39,
                          expression: "isShowSetDown39"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(236)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          click: function($event) {
                            return _vm.setDown40()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown40,
                          expression: "isShowSetDown40"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown41()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown41,
                          expression: "isShowSetDown41"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(237)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          click: function($event) {
                            return _vm.setDown42()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown42,
                          expression: "isShowSetDown42"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown43()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown43()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown43,
                          expression: "isShowSetDown43"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown431,
                          expression: "isShowSetDown431"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal,
                            expression: "duanyuInputVal",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal = $event.target.value.trim()
                            },
                            _vm.duanyuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown432,
                          expression: "isShowSetDown432"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown432()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown432()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown433,
                          expression: "isShowSetDown433"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown434,
                          expression: "isShowSetDown434"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(27)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal1,
                            expression: "duanyuInputVal1",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal1 },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal1 = $event.target.value.trim()
                            },
                            _vm.duanyuInput1
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown44,
                          expression: "isShowSetDown44"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(238)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown45()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown45,
                          expression: "isShowSetDown45"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(239)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          click: function($event) {
                            return _vm.setDown46()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown451,
                          expression: "isShowSetDown451"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(28)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown461()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown461()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown452,
                          expression: "isShowSetDown452"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(29)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(10),
                    _vm._v(" "),
                    _vm.isShowSetDown ||
                    _vm.isShowSetDown1 ||
                    _vm.isShowSetDown2 ||
                    _vm.isShowSetDown3
                      ? _c("p", [
                          _vm._v("请从"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服管理")
                          ]),
                          _vm._v("进入"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服工具")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown4 || _vm.isShowSetDown5
                      ? _c("p", [
                          _vm._v("选择客服工具中的"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("快捷短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown6 || _vm.isShowSetDown7
                      ? _c("p", [
                          _vm._v("点击"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新建短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown8 ||
                    _vm.isShowSetDown9 ||
                    _vm.isShowSetDown10 ||
                    _vm.isShowSetDown11
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新增")
                          ]),
                          _vm._v("一个"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown12 || _vm.isShowSetDown13
                      ? _c("p", [
                          _vm._v("选择"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown14 ||
                    _vm.isShowSetDown15 ||
                    _vm.isShowSetDown16 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown18 ||
                    _vm.isShowSetDown19
                      ? [_vm._m(11), _vm._v(" "), _vm._m(12)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown20 ||
                    _vm.isShowSetDown21 ||
                    _vm.isShowSetDown22
                      ? [_vm._m(13)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown23 ||
                    _vm.isShowSetDown24 ||
                    _vm.isShowSetDown25 ||
                    _vm.isShowSetDown26 ||
                    _vm.isShowSetDown27 ||
                    _vm.isShowSetDown28 ||
                    _vm.isShowSetDown29
                      ? [_vm._m(14), _vm._v(" "), _vm._m(15)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown30 ||
                    _vm.isShowSetDown31 ||
                    _vm.isShowSetDown32 ||
                    _vm.isShowSetDown33 ||
                    _vm.isShowSetDown34 ||
                    _vm.isShowSetDown35 ||
                    _vm.isShowSetDown36
                      ? [
                          _vm._m(16),
                          _vm._v(" "),
                          _vm._m(17),
                          _vm._v(" "),
                          _vm._m(18),
                          _vm._v(" "),
                          _vm._m(19),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“飞鸽快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown37 ||
                    _vm.isShowSetDown38 ||
                    _vm.isShowSetDown39
                      ? [_vm._m(20)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown40 ||
                    _vm.isShowSetDown41 ||
                    _vm.isShowSetDown42
                      ? [_vm._m(21)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown43 ||
                    _vm.isShowSetDown431 ||
                    _vm.isShowSetDown432 ||
                    _vm.isShowSetDown433
                      ? [_vm._m(22)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown434 ||
                    _vm.isShowSetDown44 ||
                    _vm.isShowSetDown45 ||
                    _vm.isShowSetDown451 ||
                    _vm.isShowSetDown452
                      ? [_vm._m(23)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession,
                          expression: "isShowSession"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(240)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession1,
                          expression: "isShowSession1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(241)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          click: function($event) {
                            return _vm.four1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession2,
                          expression: "isShowSession2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(242)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession3,
                          expression: "isShowSession3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(243)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          click: function($event) {
                            return _vm.four3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession4,
                          expression: "isShowSession4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(244)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(24),
                    _vm._v(" "),
                    _vm.isShowSession ||
                    _vm.isShowSession1 ||
                    _vm.isShowSession2 ||
                    _vm.isShowSession3 ||
                    _vm.isShowSession4
                      ? [_vm._m(25)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(245)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive1,
                          expression: "isShowFive1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(246)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          click: function($event) {
                            return _vm.five1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive2,
                          expression: "isShowFive2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(247)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive3,
                          expression: "isShowFive3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(248)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          click: function($event) {
                            return _vm.five3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive4,
                          expression: "isShowFive4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(249)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive5,
                          expression: "isShowFive5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(250)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive6,
                          expression: "isShowFive6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(251)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          click: function($event) {
                            return _vm.five6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive7,
                          expression: "isShowFive7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(252)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive8,
                          expression: "isShowFive8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(253)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          click: function($event) {
                            return _vm.five8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive9,
                          expression: "isShowFive9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(254)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(26),
                    _vm._v(" "),
                    _vm.isShowFive ||
                    _vm.isShowFive1 ||
                    _vm.isShowFive2 ||
                    _vm.isShowFive3 ||
                    _vm.isShowFive4
                      ? [_vm._m(27)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowFive5 ||
                    _vm.isShowFive6 ||
                    _vm.isShowFive7 ||
                    _vm.isShowFive8 ||
                    _vm.isShowFive9
                      ? [_vm._m(28)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(255)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix1,
                          expression: "isShowSix1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(256)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          click: function($event) {
                            return _vm.six1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix2,
                          expression: "isShowSix2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(257)
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.beizhu,
                            expression: "beizhu",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "beizhu",
                        domProps: { value: _vm.beizhu },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.beizhu = $event.target.value.trim()
                            },
                            _vm.beiZhuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six033",
                        on: {
                          click: function($event) {
                            return _vm.six122()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix3,
                          expression: "isShowSix3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(258)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six02",
                        on: {
                          click: function($event) {
                            return _vm.six3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix4,
                          expression: "isShowSix4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(259)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix5,
                          expression: "isShowSix5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(260)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix6,
                          expression: "isShowSix6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(261)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix7,
                          expression: "isShowSix7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(262)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix8,
                          expression: "isShowSix8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(263)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          click: function($event) {
                            return _vm.six7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix9,
                          expression: "isShowSix9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(264)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix10,
                          expression: "isShowSix10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(265)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix11,
                          expression: "isShowSix11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(266)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          click: function($event) {
                            return _vm.six9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix12,
                          expression: "isShowSix12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(267)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix13,
                          expression: "isShowSix13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(268)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix14,
                          expression: "isShowSix14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(269)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          click: function($event) {
                            return _vm.six11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix15,
                          expression: "isShowSix15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(270)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yjgj,
                            expression: "yjgj",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yjgj",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yjgj },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yjgj = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yfInput,
                            expression: "yfInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yfInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yfInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yfInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix16,
                          expression: "isShowSix16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(271)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          click: function($event) {
                            return _vm.six13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix17,
                          expression: "isShowSix17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(272)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix18,
                          expression: "isShowSix18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(273)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six14()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix19,
                          expression: "isShowSix19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(274)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          click: function($event) {
                            return _vm.six15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix20,
                          expression: "isShowSix20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(275)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six081",
                        on: {
                          click: function($event) {
                            return _vm.six16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix21,
                          expression: "isShowSix21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(276)
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.sjhm,
                            expression: "sjhm",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "sjhm",
                        attrs: { type: "text" },
                        domProps: { value: _vm.sjhm },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.sjhm = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix22,
                          expression: "isShowSix22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(277)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          click: function($event) {
                            return _vm.six18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix23,
                          expression: "isShowSix23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(278)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(29),
                    _vm._v(" "),
                    _vm.isShowSix ||
                    _vm.isShowSix1 ||
                    _vm.isShowSix2 ||
                    _vm.isShowSix3 ||
                    _vm.isShowSix4 ||
                    _vm.isShowSix5 ||
                    _vm.isShowSix6
                      ? [_vm._m(30), _vm._v(" "), _vm._m(31)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix7 || _vm.isShowSix8 || _vm.isShowSix9
                      ? [_vm._m(32)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix10 || _vm.isShowSix11 || _vm.isShowSix12
                      ? [_vm._m(33)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix13 ||
                    _vm.isShowSix14 ||
                    _vm.isShowSix15 ||
                    _vm.isShowSix16 ||
                    _vm.isShowSix17
                      ? [_vm._m(34)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix18 ||
                    _vm.isShowSix19 ||
                    _vm.isShowSix20 ||
                    _vm.isShowSix21 ||
                    _vm.isShowSix22 ||
                    _vm.isShowSix23
                      ? [_vm._m(35)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven,
                          expression: "isShowSeven"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(279)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven1,
                          expression: "isShowSeven1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(280)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven2,
                          expression: "isShowSeven2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(281)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          click: function($event) {
                            return _vm.seven2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven3,
                          expression: "isShowSeven3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(282)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven4,
                          expression: "isShowSeven4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(283)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven03",
                        on: {
                          click: function($event) {
                            return _vm.seven4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven5,
                          expression: "isShowSeven5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(284)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven6,
                          expression: "isShowSeven6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(285)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          click: function($event) {
                            return _vm.seven6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven7,
                          expression: "isShowSeven7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(286)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven8,
                          expression: "isShowSeven8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(287)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          click: function($event) {
                            return _vm.seven8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven9,
                          expression: "isShowSeven9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(288)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven10,
                          expression: "isShowSeven10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(289)
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("img", {
                            staticClass: "small-img",
                            attrs: {
                              src: __webpack_require__(290)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven06",
                            on: {
                              contextmenu: function($event) {
                                $event.preventDefault()
                                return _vm.seven10()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven07",
                            on: {
                              click: function($event) {
                                return _vm.seven11()
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven11,
                          expression: "isShowSeven11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(291)
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(36),
                    _vm._v(" "),
                    _vm.isShowSeven || _vm.isShowSeven1 || _vm.isShowSeven2
                      ? [_vm._m(37)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven3 || _vm.isShowSeven4
                      ? [_vm._m(38)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven5 || _vm.isShowSeven6
                      ? [_vm._m(39)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven7 || _vm.isShowSeven8
                      ? [_c("p", [_vm._v("请点击右下方显示隐藏的图标")])]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven9 || _vm.isShowSeven10 || _vm.isShowSeven11
                      ? [_c("p", [_vm._v("右键点击飞鸽小图标")])]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tip",
                        staticStyle: { width: "400px", height: "290px" }
                      },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("实操通关，进入下一关吧")]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "a",
                            {
                              staticClass: "startstudy",
                              on: {
                                click: function($event) {
                                  return _vm.studyNext("#tab-eight", 8, "eight")
                                }
                              }
                            },
                            [_vm._v("GO，下一关")]
                          )
                        ])
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "szbox" }, [
                    _c("div", { staticClass: "duomai-box" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 1 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(988),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1 && _vm.mouseFocusDM,
                            expression: "duomaiStep == 1 && mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(989),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1,
                            expression: "duomaiStep == 1"
                          }
                        ],
                        staticClass: "desktop-hover",
                        on: {
                          click: function() {
                            _vm.duomaiStep = 2
                            _vm.mouseFocusDM = false
                          },
                          mouseenter: function($event) {
                            _vm.mouseFocusDM = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDM = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 2 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(990),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2 && _vm.mouseFocusDM,
                            expression: "duomaiStep == 2 && mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(991),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2,
                            expression: "duomaiStep == 2"
                          }
                        ],
                        staticClass: "doudian-hover",
                        on: {
                          click: function() {
                            _vm.duomaiStep = 3
                            _vm.mouseFocusDM = false
                          },
                          mouseenter: function($event) {
                            _vm.mouseFocusDM = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDM = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 3 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 3 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(992),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 3,
                            expression: "duomaiStep == 3"
                          }
                        ],
                        staticClass: "msg-hover",
                        on: { click: _vm.lastStep }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 4,
                            expression: "duomaiStep == 4"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: __webpack_require__(993),
                          alt: ""
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(40),
                  _vm._v(" "),
                  _vm.duomaiStep == 1
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("打开左侧")
                          ]),
                          _vm._v("练习场中的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("多脉客服助手")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 2
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("启动抖店")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 3
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("点击右上角的前往飞鸽IM图标，进入接待中心")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tip",
                        staticStyle: { width: "400px", height: "270px" }
                      },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _vm._v(
                                  "\n                                你已完成\n                                "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.myExamNum))
                                ]),
                                _vm._v(
                                  "\n                                次，需完成\n                                "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.examNum))
                                ]),
                                _vm._v(
                                  "\n                                次\n                            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("实操通关")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "5px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("返回")]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: { width: "160px" },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("继续学习")]
                            )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录飞鸽工作台")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("3、会话窗口")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、商品插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、订单插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、退出飞鸽")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、从多脉打开抖店")
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("选择"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("我是商家")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击右上角的电脑图标，切换为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("手机号登录")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("注意："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("正式任务")]),
      _vm._v("需提前将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("自己的手机号")]),
      _vm._v("反馈给主管开通账号！")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("假设练习场"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("账号为：13853678478")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "blod-span" }, [_vm._v("验证码为：3346")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("鼠标"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("左键")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("第2个")]),
      _vm._v("店铺，切换到第2个店铺")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("鼠标"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("右键")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("第2个")]),
      _vm._v("店铺，"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("退出店铺")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("添加催单短语内容："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("亲亲，喜欢的话就下单吧，早拍早发货哦！")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("编码短语设置为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("催单")]),
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("确定")]),
      _vm._v("按钮进行保存")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("模板库导入")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("分组")]),
      _vm._v("设置为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("问候语")]),
      _vm._v("，并选择"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("前面2条")]),
      _vm._v("快捷问候语；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("确定导入")]),
      _vm._v("按钮")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("1.先"),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("下载下方的飞鸽快捷短语")
      ]),
      _vm._v("表格；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("2.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("批量导入")]),
      _vm._v("按钮；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("3.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("添加文件")]),
      _vm._v(
        "，选择下载的飞鸽快捷短语表格（可以先将下载的表格另存到桌面上，方便导入时快速找到表格）；"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("4.点击"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("导入")]),
      _vm._v("按钮；")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击右侧的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("快捷短语；")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("鼠标左键")]),
      _vm._v("点击快捷短语的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用输入"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("/您好")]),
      _vm._v("的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用输入文本"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("您好")]),
      _vm._v("的方式，给当前用户发送欢迎语："),
      _c("span", { staticClass: "blod-span" }, [
        _vm._v("您好，欢迎光临本店，请问有什么可以帮到您？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将当前用户"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("转接")]),
      _vm._v("给"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("军瑞")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请点击商品插件，将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("全部商品")]),
      _vm._v("中"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("销量最高")]),
      _vm._v("的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("腰带")]),
      _vm._v("链接发送给用户")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("浏览足迹")]),
      _vm._v("中"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("销量最高")]),
      _vm._v("的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("腰带")]),
      _vm._v("链接发送给用户")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("假设此商家规定"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("红色彩旗跟发货相关")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给该用户添加"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("备注")]),
      _vm._v("内容："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("用户要求发顺丰")]),
      _vm._v("并"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("选择对应的彩旗")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给用户发送"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("核对地址")]),
      _vm._v("卡片")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请给用户发送订单"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("催付")]),
      _vm._v("卡片")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("一键改价")]),
      _vm._v("方式，将"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("最终实付价")]),
      _vm._v("改为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("48")]),
      _vm._v("元，"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("运费")]),
      _vm._v("改为"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("10")]),
      _vm._v("元")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请在"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("改地址")]),
      _vm._v("中，将用户的"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("手机号码")]),
      _vm._v("改成"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("13512345678")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将状态切换为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("小休")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请将状态切换为："),
      _c("span", { staticClass: "blod-span" }, [_vm._v("离线")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请关闭"),
      _c("span", { staticClass: "blod-span" }, [_vm._v("接待页面")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v(
        "\n                                提示\n                            "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be4317d4", esExports)
  }
}

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianChat_vue__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianChat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianChat_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianChat_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianChat_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c9ea62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doudianChat_vue__ = __webpack_require__(1752);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1740)
  __webpack_require__(1742)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9c9ea62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doudianChat_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c9ea62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doudianChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/doudianChat.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f9c9ea62", Component.options)
  } else {
    hotAPI.reload("data-v-f9c9ea62", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1741);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e3c6c906", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f9c9ea62\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./doudianChat.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f9c9ea62\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./doudianChat.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* 页面根容器，居中显示 1311px 布局 */\n.jm-page[data-v-f9c9ea62] {\n  width: 1448px;\n  margin: 0 auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n  background: #fff;\n  border-radius: 8px;\n  padding-top: 15px;\n  /* 上方空白占位，可根据需要调整高度 */\n  /* 相对定位的容器，固定 1311 x 751 */\n}\n.jm-page .jm-back[data-v-f9c9ea62] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  width: 100px;\n  margin-left: 8px;\n  margin-bottom: 10px;\n}\n.jm-page .jm-back .el-icon-arrow-left[data-v-f9c9ea62] {\n  margin-right: 10px;\n}\n.jm-page .jm-back .jm-back-text[data-v-f9c9ea62] {\n  margin-left: 0;\n}\n.jm-page .jm-spacer[data-v-f9c9ea62] {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  background-color: #f6f6f6;\n}\n.jm-page .jm-container[data-v-f9c9ea62] {\n  position: relative;\n  width: 1448px;\n  height: 917px;\n  overflow: hidden;\n  /* 等宽高图片，用作“背景”，不直接写到容器样式上 */\n}\n.jm-page .jm-container .jm-bg[data-v-f9c9ea62] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 817px;\n  object-fit: cover;\n  pointer-events: none;\n  border-radius: 10px;\n}\n/* 业务内容容器，覆盖在背景图上层 */\n.jm-content[data-v-f9c9ea62] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.jm-content .shop-name[data-v-f9c9ea62] {\n  position: absolute;\n  top: 10px;\n  left: 109px;\n  font-size: 14px;\n  color: #333;\n  background: white;\n}\n.jm-content .xiaoer-name[data-v-f9c9ea62] {\n  position: absolute;\n  top: 54px;\n  left: 132px;\n  font-size: 14px;\n  color: #333;\n  background: white;\n}\n.jm-content .fast-reply-group[data-v-f9c9ea62] {\n  position: absolute;\n  top: 215px;\n  left: 272px;\n  width: 1100px;\n  height: 45px;\n  background: white;\n  border-radius: 8px;\n  padding: 6px 8px;\n  box-sizing: border-box;\n}\n.jm-content .fast-reply-group .frg-scroll[data-v-f9c9ea62] {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  height: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.jm-content .fast-reply-group .frg-item[data-v-f9c9ea62] {\n  cursor: pointer;\n  flex: none;\n  padding: 6px 14px;\n  background: #f5f7fa;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #606266;\n  white-space: nowrap;\n}\n.jm-content .fast-reply-group .frg-item.active[data-v-f9c9ea62] {\n  color: #2d6cf6;\n}\n.jm-content .fast-reply-group .frg-item.frg-add[data-v-f9c9ea62] {\n  color: #2d6cf6;\n}\n.jm-content .fast-reply-toolbar[data-v-f9c9ea62] {\n  position: absolute;\n  width: 1155px;\n  height: 42px;\n  left: 271px;\n  top: 281px;\n  display: flex;\n  background-color: white;\n  align-items: center;\n  padding: 0 10px;\n  box-sizing: border-box;\n  border-radius: 8px;\n}\n.jm-content .fast-reply-toolbar .frt-left[data-v-f9c9ea62] {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.jm-content .fast-reply-toolbar .frt-right[data-v-f9c9ea62] {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.jm-content .fast-reply-toolbar .frt-count[data-v-f9c9ea62] {\n  color: #333;\n  font-size: 14px;\n  margin-right: 8px;\n}\n.jm-content .fast-reply-toolbar .frt-btn[data-v-f9c9ea62] {\n  padding: 6px 14px;\n  border: 1px solid #2d6cf6;\n  color: #2d6cf6;\n  border-radius: 10px;\n  cursor: pointer;\n  background: #fff;\n}\n.jm-content .fast-reply-toolbar .frt-btn-primary[data-v-f9c9ea62] {\n  background: #2d6cf6;\n  color: #fff;\n  border-color: #2d6cf6;\n}\n.jm-content .fast-reply-list[data-v-f9c9ea62] {\n  position: absolute;\n  width: 1164px;\n  height: 478px;\n  left: 272px;\n  top: 331px;\n  padding-right: 30px;\n  background-color: white;\n  box-sizing: border-box;\n}\n.jm-content .fast-reply-list .fr-table[data-v-f9c9ea62] {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.jm-content .fast-reply-list .fr-tr[data-v-f9c9ea62] {\n  display: grid;\n  grid-template-columns: 80px 220px 1fr 180px;\n  align-items: center;\n}\n.jm-content .fast-reply-list .fr-thead[data-v-f9c9ea62] {\n  background: #f7f8fa;\n  border-bottom: 1px solid #ebeef5;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.jm-content .fast-reply-list .fr-th[data-v-f9c9ea62] {\n  padding: 10px 14px;\n  color: #606266;\n  font-size: 14px;\n}\n.jm-content .fast-reply-list .fr-tbody[data-v-f9c9ea62] {\n  overflow: auto;\n  flex: 1;\n}\n.jm-content .fast-reply-list .fr-td[data-v-f9c9ea62] {\n  padding: 10px 14px;\n  color: #303133;\n  font-size: 14px;\n  border-bottom: 1px solid #f2f3f5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.jm-content .fast-reply-list .fr-tr:hover .fr-td[data-v-f9c9ea62] {\n  background: #f7faff;\n}\n.jm-content .fast-reply-list .col-actions[data-v-f9c9ea62] {\n  text-align: center;\n}\n.jm-content .fast-reply-list .fr-op-btn[data-v-f9c9ea62] {\n  display: inline-block;\n  color: #2d6cf6;\n  cursor: pointer;\n  background: #fff;\n  margin-left: 8px;\n}\n.jm-content .fast-reply-list .fr-op-btn.danger[data-v-f9c9ea62] {\n  border-color: #f56c6c;\n  color: #f56c6c;\n}\n.jm-content .fast-reply-list .fr-empty[data-v-f9c9ea62] {\n  text-align: center;\n  color: #909399;\n  padding: 30px 0;\n}\n.jm-content .status-select[data-v-f9c9ea62] {\n  position: absolute;\n  width: 50px;\n  left: 86px;\n  top: 86px;\n  height: 20px;\n}\n.jm-content .status-select[data-v-f9c9ea62] .el-input__inner {\n  height: 20px;\n  line-height: 20px;\n  padding: 0 0px 0 5px;\n  font-size: 13px;\n  border: none;\n  box-shadow: none;\n  border-color: transparent;\n  background-color: #f5f5f5;\n}\n.jm-content .status-select[data-v-f9c9ea62] .el-input.is-focus .el-input__inner,\n.jm-content .status-select[data-v-f9c9ea62] .el-input__inner:focus,\n.jm-content .status-select[data-v-f9c9ea62] .el-input__inner:hover {\n  border: none !important;\n  box-shadow: none !important;\n  border-color: transparent !important;\n}\n.jm-content .status-select[data-v-f9c9ea62] .el-input__icon {\n  line-height: 20px;\n  width: auto;\n}\n.jm-content .status-select.status-online[data-v-f9c9ea62] .el-input__inner {\n  background-color: #00b578;\n  color: #fff;\n}\n.jm-content .status-select.status-online[data-v-f9c9ea62] .el-select__caret,\n.jm-content .status-select.status-online[data-v-f9c9ea62] .el-input__icon {\n  color: #fff;\n}\n.jm-content .status-select.status-offline[data-v-f9c9ea62] .el-input__inner {\n  background-color: #9e9e9e;\n  color: #fff;\n}\n.jm-content .status-select.status-offline[data-v-f9c9ea62] .el-select__caret,\n.jm-content .status-select.status-offline[data-v-f9c9ea62] .el-input__icon {\n  color: #fff;\n}\n.jm-content .status-select.status-pause[data-v-f9c9ea62] .el-input__inner {\n  background-color: #ff4d4f;\n  color: #fff;\n}\n.jm-content .status-select.status-pause[data-v-f9c9ea62] .el-select__caret,\n.jm-content .status-select.status-pause[data-v-f9c9ea62] .el-input__icon {\n  color: #fff;\n}\n.jm-content .keyword-input[data-v-f9c9ea62] {\n  position: absolute;\n  width: 370px;\n  left: 986px;\n  top: 60px;\n  height: 25px;\n}\n.jm-content .keyword-input[data-v-f9c9ea62] .el-input__inner {\n  height: 25px;\n  line-height: 25px;\n  padding: 0 26px 0 8px;\n  /* 预留右侧空白给清空按钮 */\n  font-size: 13px;\n  border: none;\n  box-shadow: none;\n}\n.jm-content .keyword-input[data-v-f9c9ea62] .el-input__inner:focus,\n.jm-content .keyword-input[data-v-f9c9ea62] .el-input__inner:hover {\n  border: none !important;\n  box-shadow: none !important;\n}\n.jm-content .keyword-input[data-v-f9c9ea62] .el-input__suffix {\n  right: 8px;\n  top: -8px;\n  line-height: 25px;\n}\n.jm-content .chat-msg-input[data-v-f9c9ea62] {\n  position: absolute;\n  width: 621px;\n  height: 146px;\n  left: 343px;\n  top: 622px;\n  background: #F7F7F7;\n}\n.jm-content .reply-textarea[data-v-f9c9ea62] {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 621px;\n  height: 125px;\n  border: none;\n  border-radius: 4px 4px 0 0;\n  padding: 12px 12px 24px;\n  box-sizing: border-box;\n  background: transparent;\n  font-size: 13px;\n  resize: none;\n}\n.jm-content .chat-msg-toolbar[data-v-f9c9ea62] {\n  position: absolute;\n  left: 804px;\n  top: 771px;\n  display: flex;\n}\n.jm-content .add-reply-btn[data-v-f9c9ea62] {\n  position: absolute;\n  width: 356px;\n  height: 30px;\n  right: 100px;\n  bottom: 120px;\n  cursor: pointer;\n}\n.jm-content .orders-list[data-v-f9c9ea62] {\n  position: absolute;\n  width: 409px;\n  height: 633px;\n  right: 70px;\n  top: 40px;\n  background: #F5F6FA;\n  padding: 10px;\n  box-sizing: border-box;\n}\n.jm-content .orders-list .order-card[data-v-f9c9ea62] {\n  background: #fff;\n  border-radius: 6px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n.jm-content .orders-list .oc-head[data-v-f9c9ea62] {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.jm-content .orders-list .oc-line1[data-v-f9c9ea62] {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 10px;\n}\n.jm-content .orders-list .oc-status[data-v-f9c9ea62] {\n  background: #ff7f50;\n  color: #fff;\n  border-radius: 3px;\n  padding: 2px 6px;\n  font-size: 12px;\n}\n.jm-content .orders-list .oc-no[data-v-f9c9ea62] {\n  color: #333;\n  font-weight: 600;\n}\n.jm-content .orders-list .oc-icons[data-v-f9c9ea62] {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.jm-content .orders-list .oc-icons i[data-v-f9c9ea62] {\n  color: #9aa0a6;\n}\n.jm-content .orders-list .oc-badge[data-v-f9c9ea62] {\n  color: #2d6cf6;\n  border: 1px solid #2d6cf6;\n  border-radius: 3px;\n  padding: 0 4px;\n  line-height: 16px;\n  height: 16px;\n  font-size: 12px;\n}\n.jm-content .orders-list .oc-time[data-v-f9c9ea62] {\n  color: #999;\n  font-size: 12px;\n}\n.jm-content .orders-list .oc-body[data-v-f9c9ea62] {\n  display: flex;\n  gap: 12px;\n  padding: 12px;\n}\n.jm-content .orders-list .oc-img[data-v-f9c9ea62] {\n  width: 60px;\n  height: 60;\n  border-radius: 4px;\n  object-fit: cover;\n  background: #f5f5f5;\n}\n.jm-content .orders-list .oc-info[data-v-f9c9ea62] {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 224px;\n}\n.jm-content .orders-list .oc-title[data-v-f9c9ea62] {\n  font-size: 13px;\n  color: #333;\n  line-height: 18px;\n  max-height: 36px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.jm-content .orders-list .oc-tags[data-v-f9c9ea62] {\n  display: flex;\n  gap: 8px;\n}\n.jm-content .orders-list .oc-tags span[data-v-f9c9ea62] {\n  background: #eef5ff;\n  color: #2d6cf6;\n  border-radius: 3px;\n  padding: 0 6px;\n  height: 20px;\n  line-height: 20px;\n  font-size: 12px;\n}\n.jm-content .orders-list .oc-spec[data-v-f9c9ea62] {\n  color: #888;\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.jm-content .orders-list .oc-code[data-v-f9c9ea62] {\n  color: #888;\n  font-size: 12px;\n}\n.jm-content .orders-list .oc-side[data-v-f9c9ea62] {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n.jm-content .orders-list .oc-price[data-v-f9c9ea62] {\n  font-size: 13px;\n  font-weight: 400;\n}\n.jm-content .orders-list .oc-btns[data-v-f9c9ea62] {\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  width: 65px;\n}\n.jm-content .orders-list .oc-btns .btn[data-v-f9c9ea62] {\n  background: #f4f6f8;\n  border-radius: 4px;\n  padding: 6px 8px;\n  font-size: 12px;\n  color: #2d6cf6;\n  text-align: center;\n  cursor: default;\n}\n.jm-content .orders-list .oc-recv[data-v-f9c9ea62] {\n  padding: 12px;\n  border-top: 1px solid #f5f5f5;\n}\n.jm-content .orders-list .oc-recv .row[data-v-f9c9ea62] {\n  color: #666;\n  font-size: 12px;\n  line-height: 20px;\n}\n.jm-content .orders-list .oc-recv .title[data-v-f9c9ea62] {\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n.jm-content .orders-list .oc-ship[data-v-f9c9ea62] {\n  padding: 10px 12px;\n  color: #666;\n  font-size: 12px;\n  border-top: 1px dashed #eee;\n}\n.jm-content .orders-list .oc-foot[data-v-f9c9ea62] {\n  padding: 10px 12px;\n  border-top: 1px solid #f0f0f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.jm-content .orders-list .oc-foot .label[data-v-f9c9ea62] {\n  color: #666;\n}\n.jm-content .orders-list .oc-foot .value[data-v-f9c9ea62] {\n  color: #e1251b;\n  font-weight: 700;\n}\n.jm-content .orders-list .oc-foot .ship[data-v-f9c9ea62] {\n  color: #999;\n  font-style: normal;\n  font-weight: 400;\n  margin-left: 4px;\n}\n.jm-content .chat-msg-header[data-v-f9c9ea62] {\n  position: absolute;\n  width: 625px;\n  height: 40px;\n  left: 342px;\n  top: 114px;\n  background: white;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  justify-content: start;\n}\n.jm-content .chat-msg-header .cmh-avatar[data-v-f9c9ea62] {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n.jm-content .chat-msg-header .cmh-name[data-v-f9c9ea62] {\n  font-size: 13px;\n  color: #333;\n  max-width: 520px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.jm-content .chat-msg-header .cmh-actions[data-v-f9c9ea62] {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.jm-content .chat-msg-header .cmh-action[data-v-f9c9ea62] {\n  color: #9e9e9e;\n  font-size: 18px;\n  cursor: pointer;\n}\n.jm-content .chat-msg-header .cmh-action[data-v-f9c9ea62]:hover {\n  color: #666;\n}\n.jm-content .chat-msg-header .cmh-icon-wrap[data-v-f9c9ea62] {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.jm-content .chat-msg-header .cmh-icon-wrap .cmh-action[data-v-f9c9ea62] {\n  font-size: 18px;\n}\n.jm-content .chat-msg-header .cmh-badge[data-v-f9c9ea62] {\n  position: absolute;\n  right: 2px;\n  bottom: -2px;\n  width: 10px;\n  height: 10px;\n  pointer-events: none;\n  background-color: white;\n}\n.jm-content .chat-msg-content[data-v-f9c9ea62] {\n  position: absolute;\n  width: 621px;\n  height: 450px;\n  left: 342px;\n  top: 161px;\n  background: #F5F6FA;\n  overflow: auto;\n}\n.jm-content .chat-msg-content .chat-msg-list[data-v-f9c9ea62] {\n  padding: 12px;\n}\n.jm-content .chat-msg-content .msg-item[data-v-f9c9ea62] {\n  display: flex;\n  margin-bottom: 14px;\n  justify-content: flex-start;\n  width: 100%;\n}\n.jm-content .chat-msg-content .msg-avatar[data-v-f9c9ea62] {\n  width: 32px;\n  height: 32px;\n  margin-right: 8px;\n  border-radius: 50%;\n}\n.jm-content .chat-msg-content .msg-main[data-v-f9c9ea62] {\n  width: 100%;\n}\n.jm-content .chat-msg-content .msg-header[data-v-f9c9ea62] {\n  color: #999;\n  font-size: 12px;\n  margin-bottom: 6px;\n}\n.jm-content .chat-msg-content .msg-name[data-v-f9c9ea62] {\n  margin-right: 8px;\n  color: #666;\n}\n.jm-content .chat-msg-content .msg-text[data-v-f9c9ea62] {\n  color: #333;\n  font-size: 14px;\n  line-height: 22px;\n}\n.jm-content .chat-msg-content .msg-image[data-v-f9c9ea62] {\n  max-width: 300px;\n  margin-top: 10px;\n  border-radius: 4px;\n  object-fit: cover;\n}\n.jm-content .chat-msg-content .ref-title[data-v-f9c9ea62] {\n  color: red;\n  margin-bottom: 6px;\n  margin-top: 20px;\n  cursor: pointer;\n}\n.jm-content .chat-msg-content .msg-reference[data-v-f9c9ea62] {\n  background: #E9F4FF;\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n.jm-content .chat-msg-content .msg-reference .ref-label[data-v-f9c9ea62] {\n  color: #F56C6C;\n  margin-bottom: 4px;\n}\n.jm-content .chat-msg-content .msg-reference .ref-body[data-v-f9c9ea62] {\n  background: #fff;\n  border-radius: 4px;\n  padding: 10px 12px;\n  color: #E84C3D;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.jm-content .chat-msg-content .reply-list[data-v-f9c9ea62] {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.jm-content .chat-msg-content .reply-item[data-v-f9c9ea62] {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n.jm-content .chat-msg-content .reply-item .msg-text[data-v-f9c9ea62] {\n  color: #333;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: start;\n  margin-right: 42px;\n  max-width: 300px;\n}\n.jm-content .chat-msg-content .msg-header.right[data-v-f9c9ea62] {\n  text-align: right;\n  margin-bottom: 4px;\n}\n.jm-content .fast-reply-content[data-v-f9c9ea62] {\n  position: absolute;\n  width: 409px;\n  height: 600px;\n  left: 968px;\n  top: 149px;\n  background: white;\n  overflow: auto;\n  /* 快捷短语分组与子项样式 */\n}\n.jm-content .fast-reply-content .fr-group[data-v-f9c9ea62] {\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  background: #fff;\n}\n.jm-content .fast-reply-content .fr-group-header[data-v-f9c9ea62] {\n  padding: 4px 10px;\n  cursor: pointer;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #f7f8fa;\n  border-bottom: 1px solid #eee;\n}\n.jm-content .fast-reply-content .fr-group-title[data-v-f9c9ea62] {\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n}\n.jm-content .fast-reply-content .fr-group-body[data-v-f9c9ea62] {\n  padding: 6px 8px;\n}\n.jm-content .fast-reply-content .fr-item[data-v-f9c9ea62] {\n  display: flex;\n  gap: 6px;\n  font-size: 12px;\n  color: #666;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 6px 4px;\n  border-radius: 4px;\n  align-items: center;\n}\n.jm-content .fast-reply-content .fr-item[data-v-f9c9ea62]:hover {\n  background: #f5f7fa;\n}\n.jm-content .fast-reply-content .fr-actions[data-v-f9c9ea62] {\n  display: none;\n  gap: 10px;\n  flex: none;\n  margin-left: 8px;\n}\n.jm-content .fast-reply-content .fr-actions span[data-v-f9c9ea62] {\n  color: #2d6cf6;\n  cursor: pointer;\n}\n.jm-content .fast-reply-content .fr-item:hover .fr-actions[data-v-f9c9ea62] {\n  display: inline-flex;\n}\n.jm-content .fast-reply-content .fr-text[data-v-f9c9ea62] {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.jm-content .train-session-list[data-v-f9c9ea62] {\n  position: absolute;\n  width: 249px;\n  height: 600px;\n  left: 79px;\n  top: 174px;\n  overflow: auto;\n  background-color: #FDFDFD;\n}\n.jm-content .train-session-list .ts-item[data-v-f9c9ea62] {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  transition: background 0.2s ease;\n  margin-bottom: 10px;\n  background: #fff;\n  cursor: pointer;\n}\n.jm-content .train-session-list .ts-item.replied[data-v-f9c9ea62] {\n  background: #FFF5CC;\n}\n.jm-content .train-session-list .ts-item.current[data-v-f9c9ea62] {\n  background: #E6F0FF;\n}\n.jm-content .train-session-list .ts-item .ts-avatar[data-v-f9c9ea62] {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #e5e6eb;\n  flex: none;\n}\n.jm-content .train-session-list .ts-item .ts-name[data-v-f9c9ea62] {\n  font-size: 13px;\n  color: #333;\n}\n.jm-content .action-order-btn[data-v-f9c9ea62] {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  right: 10px;\n  bottom: 800px;\n  cursor: pointer;\n}\n.jm-content .action-reply-btn[data-v-f9c9ea62] {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  right: 10px;\n  bottom: 578px;\n  cursor: pointer;\n}\n.jm-content .action-import-btn[data-v-f9c9ea62] {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  left: 12px;\n  bottom: 510px;\n  cursor: pointer;\n}\n.jm-content .action-chat-btn[data-v-f9c9ea62] {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  left: 12px;\n  top: 110px;\n  cursor: pointer;\n}\n/* 快捷短语提示框样式 */\n.quick-reply-suggestions[data-v-f9c9ea62] {\n  position: absolute;\n  left: 486px;\n  top: 585px;\n  width: 473px;\n  max-height: 210px;\n  background: #fff;\n  border: 1px solid #e4e7ed;\n  border-radius: 4px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\n  padding: 4px 0;\n  overflow-y: auto;\n  z-index: 1000;\n}\n.quick-reply-suggestions .suggestion-item[data-v-f9c9ea62] {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid #f5f7fa;\n}\n.quick-reply-suggestions .suggestion-item[data-v-f9c9ea62]:last-child {\n  border-bottom: none;\n}\n.quick-reply-suggestions .suggestion-item[data-v-f9c9ea62]:hover,\n.quick-reply-suggestions .suggestion-item.active[data-v-f9c9ea62] {\n  background-color: #f5f7fa;\n}\n.quick-reply-suggestions .suggestion-text[data-v-f9c9ea62] {\n  color: #909399;\n  font-size: 12px;\n  margin-right: 8px;\n  min-width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f5f7fa;\n  border: 1px solid #e4e7ed;\n  border-radius: 3px;\n  font-weight: 500;\n}\n.quick-reply-suggestions .suggestion-code[data-v-f9c9ea62] {\n  color: #409eff;\n  font-size: 12px;\n  margin-right: 8px;\n  min-width: 60px;\n}\n.quick-reply-suggestions .suggestion-content[data-v-f9c9ea62] {\n  color: #333;\n  font-size: 12px;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1743);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9a63d652", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f9c9ea62\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./doudianChat.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f9c9ea62\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./doudianChat.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.transfer-pop {\n  padding: 8px;\n}\n.transfer-pop .tp-tabs {\n  display: flex;\n  gap: 24px;\n  font-size: 14px;\n  color: #666;\n}\n.transfer-pop .tp-tab {\n  cursor: pointer;\n  padding-bottom: 6px;\n}\n.transfer-pop .tp-tab.active {\n  color: #2d6cf6;\n  border-bottom: 3px solid #2d6cf6;\n}\n.transfer-pop .tp-search {\n  margin: 10px 0 8px;\n}\n.transfer-pop .tp-list {\n  max-height: 260px;\n  overflow: auto;\n  background: #fff;\n  border-radius: 4px;\n}\n.transfer-pop .tp-item {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #f0f0f0;\n  background-color: rgba(232, 229, 229, 0.3);\n  cursor: pointer;\n}\n.transfer-pop .tp-item:last-child {\n  border-bottom: none;\n}\n.transfer-pop .tp-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n.transfer-pop .tp-dot.online {\n  background: #31c24b;\n}\n.transfer-pop .tp-name {\n  flex: 1;\n  color: #333;\n}\n.order-note-pop {\n  padding: 10px 12px;\n}\n.order-note-pop .onp-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.order-note-pop .onp-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  color: #333;\n}\n.order-note-pop .onp-history {\n  color: #2d6cf6;\n  font-size: 12px;\n}\n.order-note-pop .onp-flags {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.order-note-pop .onp-flag {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.order-note-pop .onp-flag .dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n}\n.order-note-pop .onp-text textarea {\n  resize: vertical;\n}\n.order-note-pop .onp-check {\n  color: #999;\n  font-size: 12px;\n}\n.order-note-pop .onp-foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n", ""]);

// exports


/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDDDialog_vue__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDDDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDDDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDDDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDDDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b4bd37_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastReplyImportDDDialog_vue__ = __webpack_require__(1747);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1745)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11b4bd37"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastReplyImportDDDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b4bd37_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastReplyImportDDDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/components/FastReplyImportDDDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-11b4bd37", Component.options)
  } else {
    hotAPI.reload("data-v-11b4bd37", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1746);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2b959c19", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-11b4bd37\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FastReplyImportDDDialog.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-11b4bd37\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FastReplyImportDDDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.fri-dialog[data-v-11b4bd37] .el-dialog__header {\n  background-color: #2d6cf6;\n  color: #fff;\n  padding: 12px 20px;\n}\n.fri-dialog[data-v-11b4bd37] .el-dialog__title {\n  color: #fff;\n  font-weight: 600;\n}\n.fri-dialog[data-v-11b4bd37] .el-dialog__headerbtn .el-dialog__close {\n  color: #fff;\n}\n.fri-dialog[data-v-11b4bd37] .el-dialog__body {\n  padding: 18px 24px;\n}\n.fri-row[data-v-11b4bd37] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 18px;\n}\n.fri-row-label[data-v-11b4bd37] {\n  width: 110px;\n  color: #303133;\n  font-size: 14px;\n}\n.fri-radio[data-v-11b4bd37] .el-radio {\n  margin-right: 24px;\n}\n.fri-file[data-v-11b4bd37] {\n  display: none;\n}\n.fri-upload-btn[data-v-11b4bd37] {\n  padding: 8px 14px;\n}\n.fri-file-name[data-v-11b4bd37] {\n  margin-left: 12px;\n  color: #606266;\n  font-size: 13px;\n}\n.fri-tips[data-v-11b4bd37] {\n  color: #909399;\n  font-size: 13px;\n  line-height: 22px;\n  margin-top: 12px;\n}\n.fri-tips a[data-v-11b4bd37] {\n  color: #2d6cf6;\n}\n", ""]);

// exports


/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量导入快捷短语",
        visible: _vm.visibleProxy,
        width: "680px",
        "append-to-body": "",
        "custom-class": "fri-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        },
        closed: _vm.onClosed
      }
    },
    [
      _c(
        "div",
        { staticClass: "fri-row" },
        [
          _c("div", { staticClass: "fri-row-label" }, [
            _vm._v("选择覆盖方式：")
          ]),
          _vm._v(" "),
          _c(
            "el-radio-group",
            {
              staticClass: "fri-radio",
              model: {
                value: _vm.importType,
                callback: function($$v) {
                  _vm.importType = $$v
                },
                expression: "importType"
              }
            },
            [
              _c("el-radio", { attrs: { label: "increase" } }, [
                _vm._v("增量覆盖")
              ]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "override" } }, [
                _vm._v("全量覆盖")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fri-row" },
        [
          _c("div", { staticClass: "fri-row-label" }, [
            _vm._v("选择上传文件：")
          ]),
          _vm._v(" "),
          _c("input", {
            ref: "fileInput",
            staticClass: "fri-file",
            attrs: { type: "file", accept: ".csv,.txt,.xls,.xlsx" },
            on: { change: _vm.onFileChange }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "fri-upload-btn",
              attrs: { size: "small" },
              on: { click: _vm.chooseFile }
            },
            [_c("i", { staticClass: "el-icon-upload2" }), _vm._v(" 添加文件")]
          ),
          _vm._v(" "),
          _vm.fileName
            ? _c("div", { staticClass: "fri-file-name" }, [
                _vm._v(_vm._s(_vm.fileName))
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fri-tips" }, [
        _c("div", [
          _vm._v(
            "1、导入成功后会覆盖已添加内容，请谨慎操作（可先将现有内容导出）；"
          )
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("2、不同分组有不同的模板，需分别导入。")])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.visibleProxy = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.importLoading },
              on: { click: _vm.onImportClick }
            },
            [_vm._v("导入")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11b4bd37", esExports)
  }
}

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupManageDialog_vue__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupManageDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupManageDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupManageDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupManageDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42207a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupManageDialog_vue__ = __webpack_require__(1751);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1749)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42207a70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupManageDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42207a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupManageDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/components/GroupManageDialog.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42207a70", Component.options)
  } else {
    hotAPI.reload("data-v-42207a70", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e09426fc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-42207a70\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GroupManageDialog.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-42207a70\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GroupManageDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.gm-dialog[data-v-42207a70] .el-dialog__header {\n  background-color: #2d6cf6;\n  color: #fff;\n  padding: 12px 20px;\n}\n.gm-dialog[data-v-42207a70] .el-dialog__title {\n  color: #fff;\n  font-weight: 600;\n}\n.gm-dialog[data-v-42207a70] .el-dialog__headerbtn .el-dialog__close {\n  color: #fff;\n}\n.gm-dialog[data-v-42207a70] .el-dialog__body {\n  padding: 18px 24px;\n}\n.gm-subtitle[data-v-42207a70] {\n  color: #909399;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n.gm-table[data-v-42207a70] {\n  border: 1px solid #ebeef5;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n.gm-thead[data-v-42207a70] {\n  display: grid;\n  grid-template-columns: 1fr 120px 120px;\n  background: #f5f7fa;\n  border-bottom: 1px solid #ebeef5;\n}\n.gm-tr[data-v-42207a70] {\n  display: grid;\n  grid-template-columns: 1fr 120px 120px;\n  border-bottom: 1px solid #f2f3f5;\n}\n.gm-tr[data-v-42207a70]:last-child {\n  border-bottom: none;\n}\n.gm-tr[data-v-42207a70]:hover {\n  background: #f7faff;\n}\n.gm-th[data-v-42207a70],\n.gm-td[data-v-42207a70] {\n  padding: 12px 16px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n}\n.gm-th[data-v-42207a70] {\n  color: #606266;\n  font-weight: 600;\n  background: #f5f7fa;\n}\n.gm-td[data-v-42207a70] {\n  color: #303133;\n}\n.gm-name[data-v-42207a70] {\n  justify-content: flex-start;\n}\n.gm-count[data-v-42207a70] {\n  justify-content: center;\n}\n.gm-actions[data-v-42207a70] {\n  justify-content: center;\n}\n.gm-name-text[data-v-42207a70] {\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n.gm-name-text[data-v-42207a70]:hover {\n  background: #f0f9ff;\n}\n.gm-name-hover[data-v-42207a70] {\n  border: 1px solid #2d6cf6;\n  background: #f0f9ff;\n}\n.gm-delete-btn[data-v-42207a70] {\n  color: #f56c6c;\n  padding: 0;\n}\n.gm-delete-btn[data-v-42207a70]:hover {\n  color: #f78989;\n}\n.gm-cancel-btn[data-v-42207a70] {\n  color: #909399;\n  padding: 0;\n}\n.gm-cancel-btn[data-v-42207a70]:hover {\n  color: #b1b3b8;\n}\n.gm-add-row[data-v-42207a70] {\n  background: #f8f9fa;\n  border: 1px dashed #d9d9d9;\n}\n.gm-empty[data-v-42207a70] {\n  text-align: center;\n  color: #909399;\n  padding: 40px 0;\n  font-size: 14px;\n}\n.gm-add-group[data-v-42207a70] {\n  text-align: center;\n  margin-bottom: 16px;\n}\n.gm-add-btn[data-v-42207a70] {\n  border: 1px solid #dcdfe6;\n  color: #606266;\n  background: #fff;\n  padding: 8px 20px;\n}\n.gm-add-btn[data-v-42207a70]:hover {\n  border-color: #2d6cf6;\n  color: #2d6cf6;\n}\n", ""]);

// exports


/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "管理分组",
        visible: _vm.visibleProxy,
        width: "600px",
        "append-to-body": "",
        "custom-class": "gm-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.visibleProxy = $event
        },
        closed: _vm.onClosed
      }
    },
    [
      _c("div", { staticClass: "gm-subtitle" }, [_vm._v("仅展示自定义的分组")]),
      _vm._v(" "),
      _c("div", { staticClass: "gm-table" }, [
        _c("div", { staticClass: "gm-thead" }, [
          _c("div", { staticClass: "gm-th" }, [_vm._v("自定义组名")]),
          _vm._v(" "),
          _c("div", { staticClass: "gm-th" }, [_vm._v("快捷短语数量")]),
          _vm._v(" "),
          _c("div", { staticClass: "gm-th" }, [_vm._v("操作")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gm-tbody" },
          [
            _vm._l(_vm.customGroups, function(group) {
              return _c("div", { key: group.id, staticClass: "gm-tr" }, [
                _c(
                  "div",
                  { staticClass: "gm-td gm-name" },
                  [
                    _vm.editingGroupId === group.id
                      ? _c("el-input", {
                          ref: "editInput",
                          refInFor: true,
                          attrs: { size: "small" },
                          on: {
                            blur: function($event) {
                              return _vm.onSaveGroup(group)
                            }
                          },
                          nativeOn: {
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onSaveGroup(group)
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onCancelEdit.apply(null, arguments)
                              }
                            ]
                          },
                          model: {
                            value: _vm.editingGroupName,
                            callback: function($$v) {
                              _vm.editingGroupName = $$v
                            },
                            expression: "editingGroupName"
                          }
                        })
                      : _c(
                          "span",
                          {
                            staticClass: "gm-name-text",
                            class: {
                              "gm-name-hover": _vm.hoveredGroupId === group.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.onEditGroup(group)
                              },
                              mouseenter: function($event) {
                                _vm.hoveredGroupId = group.id
                              },
                              mouseleave: function($event) {
                                _vm.hoveredGroupId = null
                              }
                            }
                          },
                          [_vm._v(_vm._s(group.name))]
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "gm-td gm-count" }, [
                  _vm._v(_vm._s(group.replyList.length || 0))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gm-td gm-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "gm-delete-btn",
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.onDeleteGroup(group)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              ])
            }),
            _vm._v(" "),
            !_vm.customGroups || _vm.customGroups.length === 0
              ? _c("div", { staticClass: "gm-empty" }, [
                  _vm._v("暂无自定义分组")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isAddingNew
              ? _c("div", { staticClass: "gm-tr gm-add-row" }, [
                  _c(
                    "div",
                    { staticClass: "gm-td gm-name" },
                    [
                      _c("el-input", {
                        ref: "newGroupInput",
                        attrs: { size: "small", placeholder: "请输入分组名称" },
                        on: { blur: _vm.onSaveNewGroup },
                        nativeOn: {
                          keydown: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onSaveNewGroup.apply(null, arguments)
                            },
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape"
                                ])
                              ) {
                                return null
                              }
                              return _vm.onCancelAdd.apply(null, arguments)
                            }
                          ]
                        },
                        model: {
                          value: _vm.newGroupName,
                          callback: function($$v) {
                            _vm.newGroupName = $$v
                          },
                          expression: "newGroupName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "gm-td gm-count" }, [_vm._v("0")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "gm-td gm-actions" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "gm-cancel-btn",
                          attrs: { type: "text" },
                          on: { click: _vm.onCancelAdd }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gm-add-group" },
        [
          _c(
            "el-button",
            { staticClass: "gm-add-btn", on: { click: _vm.onStartAddGroup } },
            [_vm._v("+ 新建分组")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.visibleProxy = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42207a70", esExports)
  }
}

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jm-page" },
    [
      _c("div", { staticClass: "jm-back", on: { click: _vm.back } }, [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticClass: "jm-back-text" }, [_vm._v("返回")])
      ]),
      _vm._v(" "),
      !_vm.settings.isStart
        ? _c(
            "div",
            { staticClass: "jm-spacer" },
            [
              _c("span", [_vm._v("每10分钟进线 3 名客户")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.productModal.handleStart()
                    }
                  }
                },
                [_vm._v("开始")]
              ),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "jm-spacer" },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm.hasProducts
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.productModal.showProducts()
                        }
                      }
                    },
                    [_vm._v("产品须知")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "10px"
                  }
                },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-weight": "bold", color: "black" } },
                    [_vm._v("推荐回复")]
                  ),
                  _vm._v(" "),
                  _c("el-switch", {
                    on: { change: _vm.changeRecommendReply },
                    model: {
                      value: _vm.settings.isRecommendReply,
                      callback: function($$v) {
                        _vm.$set(_vm.settings, "isRecommendReply", $$v)
                      },
                      expression: "settings.isRecommendReply"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "20px",
                    "font-weight": "bold",
                    color: "black"
                  }
                },
                [_vm._v(_vm._s(_vm.formattedTime))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.stopTrain } },
                [_vm._v("退出")]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "回复数：" +
                    _vm._s(_vm.totalReplyCount) +
                    " 打字速度：" +
                    _vm._s(_vm.typingSpeedWPM) +
                    "字/分钟 "
                ),
                _c("br"),
                _vm._v(
                  "首次响应时间：" +
                    _vm._s(_vm.firstResponseAvgSec) +
                    "秒 平均响应时间：" +
                    _vm._s(_vm.avgResponseSec) +
                    "秒"
                )
              ])
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.settings.pageType == 1 || _vm.settings.pageType == 2,
              expression: "settings.pageType == 1 || settings.pageType == 2"
            }
          ],
          staticClass: "jm-container"
        },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.settings.pageType == 1,
                expression: "settings.pageType == 1"
              }
            ],
            staticClass: "jm-bg",
            attrs: {
              src: __webpack_require__(1753),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.settings.pageType == 2,
                expression: "settings.pageType == 2"
              }
            ],
            staticClass: "jm-bg",
            attrs: {
              src: __webpack_require__(1754),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "jm-content" },
            [
              _c("div", { staticClass: "shop-name" }, [
                _vm._v("飞鸽对练实操店铺")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "xiaoer-name" }, [_vm._v("练习账号")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "status-select",
                  class: _vm.getStatusClass(_vm.settings.onlineStatus),
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.settings.onlineStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "onlineStatus", $$v)
                    },
                    expression: "settings.onlineStatus"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "接待", value: "1" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "小休", value: "2" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "挂起", value: "3" } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "train-session-list" },
                _vm._l(_vm.settings.trainSession || [], function(s) {
                  return _c(
                    "div",
                    {
                      key: s.id || s.veruser,
                      staticClass: "ts-item",
                      class: {
                        current: s.isCurrent,
                        replied: !s.isCurrent && !s.didReply
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectSession(s)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "ts-avatar",
                        attrs: {
                          src: __webpack_require__(68)
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "ts-name" }, [
                        _vm._v(_vm._s(s.veruser))
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.currentSession
                ? _c("div", { staticClass: "chat-msg-header" }, [
                    _c("img", {
                      staticClass: "cmh-avatar",
                      attrs: {
                        src: __webpack_require__(68)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "cmh-name",
                        attrs: { title: _vm.currentSession.veruser }
                      },
                      [_vm._v(_vm._s(_vm.currentSession.veruser))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { flex: "1" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cmh-actions" },
                      [
                        _c("i", { staticClass: "el-icon-star-off cmh-action" }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-warning-outline cmh-action"
                        }),
                        _vm._v(" "),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-start",
                              width: "300",
                              trigger: "click",
                              "popper-class": "transfer-pop"
                            },
                            model: {
                              value: _vm.transferPopoverVisible,
                              callback: function($$v) {
                                _vm.transferPopoverVisible = $$v
                              },
                              expression: "transferPopoverVisible"
                            }
                          },
                          [
                            _c("div", { staticClass: "transfer-pop" }, [
                              _c("div", { staticClass: "tp-tabs" }, [
                                _c("div", { staticClass: "tp-tab active" }, [
                                  _vm._v("转接到客服")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "tp-tab" }, [
                                  _vm._v("转接到组")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "tp-search" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      size: "small",
                                      placeholder: "请输入在线客服昵称",
                                      "suffix-icon": "el-icon-search"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "tp-list" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "tp-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.saveActionRecord(
                                          "TRANSFER_AFTER_SALE",
                                          "已转接给售后客服:001"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "tp-dot online"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "tp-name" }, [
                                      _vm._v("售后客服001")
                                    ])
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "cmh-icon-wrap",
                                attrs: { slot: "reference" },
                                slot: "reference"
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-user cmh-action"
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "cmh-badge",
                                  attrs: {
                                    src: __webpack_require__(1755)
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "关闭会话",
                              placement: "top",
                              effect: "dark"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-switch-button cmh-action",
                              on: { click: _vm.closeSession }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentSession
                ? _c(
                    "div",
                    { ref: "chatContent", staticClass: "chat-msg-content" },
                    [
                      _c(
                        "div",
                        { staticClass: "chat-msg-list" },
                        _vm._l(_vm.currentMessages, function(msg, idx) {
                          return _c(
                            "div",
                            { key: msg.id || idx, staticClass: "msg-item" },
                            [
                              _c("img", {
                                staticClass: "msg-avatar",
                                attrs: {
                                  src: __webpack_require__(68)
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "msg-main" },
                                [
                                  _c("div", { staticClass: "msg-header" }, [
                                    _c("span", { staticClass: "msg-name" }, [
                                      _vm._v(_vm._s(msg.fromName || "对方"))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "msg-time" }, [
                                      _vm._v(
                                        _vm._s(_vm.formatMsgTime(msg.sendTime))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  msg.questionType === "卡片" &&
                                  _vm.findOrderById(msg.questionOrderId)
                                    ? _c("order-msg-card", {
                                        attrs: {
                                          order: _vm.findOrderById(
                                            msg.questionOrderId
                                          ),
                                          platform: "douyin"
                                        }
                                      })
                                    : [
                                        _c("div", {
                                          staticClass: "msg-text",
                                          domProps: {
                                            innerHTML: _vm._s(msg.question)
                                          }
                                        }),
                                        _vm._v(" "),
                                        msg.questionImg
                                          ? _c("img", {
                                              staticClass: "msg-image",
                                              attrs: { src: msg.questionImg }
                                            })
                                          : _vm._e()
                                      ],
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ref-title",
                                      on: {
                                        click: function($event) {
                                          msg.fold = !msg.fold
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          msg.fold
                                            ? "查看参考答案"
                                            : "收起参考答案"
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !msg.fold
                                    ? _c(
                                        "div",
                                        { staticClass: "msg-reference" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ref-label" },
                                            [_vm._v("参考回复：")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "ref-body",
                                            domProps: {
                                              innerHTML: _vm._s(msg.answer)
                                            },
                                            on: {
                                              copy: function($event) {
                                                $event.preventDefault()
                                              },
                                              cut: function($event) {
                                                $event.preventDefault()
                                              },
                                              contextmenu: function($event) {
                                                $event.preventDefault()
                                              },
                                              selectstart: function($event) {
                                                $event.preventDefault()
                                              },
                                              dragstart: function($event) {
                                                $event.preventDefault()
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (msg.replyList || []).length
                                    ? _c(
                                        "div",
                                        { staticClass: "reply-list" },
                                        _vm._l(msg.replyList, function(
                                          rep,
                                          rIdx
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: rep.id || rIdx,
                                              staticClass: "reply-item"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "msg-header right"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "msg-time" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatMsgTime(
                                                            rep.sendTime
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("img", {
                                                    staticClass: "msg-avatar",
                                                    attrs: {
                                                      src: __webpack_require__(68)
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "msg-text msg-rich"
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.parseContent(
                                                      rep.content
                                                    ),
                                                    function(node, nIdx) {
                                                      return [
                                                        node.type === "img"
                                                          ? _c("img", {
                                                              key:
                                                                "img-" + nIdx,
                                                              staticClass:
                                                                "msg-image",
                                                              attrs: {
                                                                src: node.src
                                                              }
                                                            })
                                                          : _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "txt-" + nIdx,
                                                                staticStyle: {
                                                                  display:
                                                                    "block"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    node.text
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chat-msg-toolbar" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.closeSession }
                    },
                    [_vm._v("关闭会话")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.sendReply }
                    },
                    [_vm._v("发送")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chat-msg-input" },
                [
                  _c("el-input", {
                    staticClass: "reply-textarea",
                    attrs: {
                      type: "textarea",
                      rows: 6,
                      placeholder: "请输入回复内容...",
                      resize: "none"
                    },
                    on: { input: _vm.onReplyInput },
                    nativeOn: {
                      keydown: function($event) {
                        return _vm.onReplyKeydown.apply(null, arguments)
                      },
                      paste: function($event) {
                        return _vm.onReplyPaste.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.replyText,
                      callback: function($$v) {
                        _vm.replyText = $$v
                      },
                      expression: "replyText"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showQuickReplySuggestions
                ? _c(
                    "div",
                    { staticClass: "quick-reply-suggestions" },
                    _vm._l(_vm.quickReplySuggestions, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "suggestion-item",
                          class: {
                            active: index === _vm.selectedSuggestionIndex
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectSuggestion(item)
                            },
                            mouseenter: function($event) {
                              _vm.selectedSuggestionIndex = index
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "suggestion-text" }, [
                            _vm._v("个")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "suggestion-code" }, [
                            _vm._v(_vm._s(item.quicktext))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "suggestion-content" }, [
                            _vm._v(_vm._s(item.replytext))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.pageType == 1
                ? _c("el-input", {
                    staticClass: "keyword-input",
                    attrs: {
                      placeholder: "输入关键词搜索短语或编码",
                      clearable: ""
                    },
                    on: { input: _vm.onKeywordInput },
                    model: {
                      value: _vm.keyword,
                      callback: function($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.pageType == 1
                ? _c(
                    "div",
                    { staticClass: "fast-reply-content" },
                    _vm._l(_vm.filteredFastReplyList, function(g) {
                      return _c("div", { key: g.id, staticClass: "fr-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "fr-group-header",
                            on: {
                              click: function($event) {
                                return _vm.toggleGroup(g.id)
                              }
                            }
                          },
                          [
                            _c("i", {
                              class: _vm.settings.collapsedGroups[g.id]
                                ? "el-icon-caret-right"
                                : "el-icon-caret-bottom"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fr-group-title" }, [
                              _vm._v(
                                _vm._s(g.name) +
                                  " (" +
                                  _vm._s((g.filteredReplyList || []).length) +
                                  ")"
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.settings.collapsedGroups[g.id],
                                expression: "!settings.collapsedGroups[g.id]"
                              }
                            ],
                            staticClass: "fr-group-body"
                          },
                          _vm._l(g.filteredReplyList || [], function(r) {
                            return _c(
                              "div",
                              { key: r.id, staticClass: "fr-item" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "fr-quick",
                                    staticStyle: { "font-weight": "800" }
                                  },
                                  [_vm._v("/" + _vm._s(r.quicktext) + " |")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "fr-text",
                                    on: {
                                      click: function($event) {
                                        return _vm.onClickReply(r)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(r.replytext))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "fr-actions" }, [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.menuDeleteReply(r)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.menuEditReply(r, g)
                                        }
                                      }
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.onClickReply(r)
                                        }
                                      }
                                    },
                                    [_vm._v("发送")]
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.pageType == 1
                ? _c("div", {
                    staticClass: "add-reply-btn",
                    on: { click: _vm.newFastReply }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.pageType == 2 && _vm.matchedOrder
                ? _c("div", { staticClass: "orders-list" }, [
                    _c("div", { staticClass: "order-card" }, [
                      _c("div", { staticClass: "oc-head" }, [
                        _c("div", { staticClass: "oc-line1" }, [
                          _c("span", { staticClass: "oc-status" }, [
                            _vm._v(_vm._s(_vm.matchedOrder.status))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "oc-no" }, [
                            _vm._v(_vm._s(_vm.orderHeader.orderNo))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "oc-icons" },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom-start",
                                    trigger: "click",
                                    width: "320",
                                    "popper-class": "order-note-pop"
                                  },
                                  model: {
                                    value: _vm.notePopoverVisible,
                                    callback: function($$v) {
                                      _vm.notePopoverVisible = $$v
                                    },
                                    expression: "notePopoverVisible"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "onp-wrap" }, [
                                    _c("div", { staticClass: "onp-head" }, [
                                      _c("span", [_vm._v("订单备注")])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "onp-flags" },
                                      [
                                        _vm._l(_vm.noteFlagColors, function(
                                          c,
                                          i
                                        ) {
                                          return _c(
                                            "label",
                                            {
                                              key: "f_" + i,
                                              staticClass: "onp-flag"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.noteFlagIndex,
                                                    expression: "noteFlagIndex"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  name: "noteFlag"
                                                },
                                                domProps: {
                                                  value: i,
                                                  checked: _vm._q(
                                                    _vm.noteFlagIndex,
                                                    i
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    _vm.noteFlagIndex = i
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "dot",
                                                style: { background: c }
                                              })
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "onp-flag" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.noteFlagIndex,
                                                  expression: "noteFlagIndex"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "noteFlag"
                                              },
                                              domProps: {
                                                value: 4,
                                                checked: _vm._q(
                                                  _vm.noteFlagIndex,
                                                  4
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.noteFlagIndex = 4
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "dot",
                                                staticStyle: {
                                                  "margin-top": "-12px"
                                                }
                                              },
                                              [_vm._v("🚩")]
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "onp-text" },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 5,
                                            placeholder: "请输入备注内容"
                                          },
                                          model: {
                                            value: _vm.noteText,
                                            callback: function($$v) {
                                              _vm.noteText = $$v
                                            },
                                            expression: "noteText"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "onp-check" },
                                      [
                                        _c(
                                          "el-checkbox",
                                          { attrs: { disabled: "" } },
                                          [_vm._v("自动添加暗注人和时间到末尾")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "onp-foot" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini"
                                            },
                                            on: { click: _vm.onNoteConfirm }
                                          },
                                          [_vm._v("确定")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function($event) {
                                                _vm.notePopoverVisible = false
                                              }
                                            }
                                          },
                                          [_vm._v("取消")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "oc-badge",
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v("备")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "oc-badge" }, [
                                _vm._v("详")
                              ])
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "oc-time" }, [
                          _vm._v("下单：" + _vm._s(_vm.orderHeader.orderTime))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "oc-body" }, [
                        _c("img", {
                          staticClass: "oc-img",
                          attrs: { src: _vm.matchedOrder.imgurl }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "oc-info" }, [
                          _c(
                            "div",
                            {
                              staticClass: "oc-title",
                              attrs: { title: _vm.matchedOrder.productName }
                            },
                            [_vm._v(_vm._s(_vm.matchedOrder.productName))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "oc-price" }, [
                            _vm._v("实付: "),
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "700" } },
                              [
                                _vm._v(
                                  "¥ " +
                                    _vm._s(_vm.matchedOrder.price.toFixed(2))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c("div", { staticClass: "oc-spec" }, [
                            _vm._v(
                              "规格：" + _vm._s(_vm.matchedOrder.size || "默认")
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "oc-code" }, [
                            _vm._v("编码：" + _vm._s(_vm.matchedOrder.id))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(3)
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "oc-recv" }, [
                        _c("div", { staticClass: "row title" }, [
                          _vm._v("收货信息")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _vm._v(
                            _vm._s(_vm.matchedOrder.name) +
                              "  " +
                              _vm._s(_vm.matchedOrder.phone)
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _vm._v(_vm._s(_vm.matchedOrder.address))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.matchedOrder.status == "待发货"
                        ? _c("div", { staticClass: "oc-ship" }, [
                            _vm._v("承诺发货：1天8小时48分钟54秒内发货")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "oc-foot" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单金额")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            "¥ " + _vm._s(_vm.matchedOrder.price.toFixed(2))
                          ),
                          _c("em", { staticClass: "ship" }, [
                            _vm._v("（含运费 ¥0.00）")
                          ])
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "action-order-btn",
                on: {
                  click: function($event) {
                    _vm.settings.pageType = 2
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "action-reply-btn",
                on: {
                  click: function($event) {
                    _vm.settings.pageType = 1
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "action-import-btn",
                on: {
                  click: function($event) {
                    _vm.settings.pageType = 3
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.settings.pageType == 3,
              expression: "settings.pageType == 3"
            }
          ],
          staticClass: "jm-container"
        },
        [
          _c("img", {
            staticClass: "jm-bg",
            attrs: {
              src: __webpack_require__(1756),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "jm-content" }, [
            _c("div", {
              staticClass: "action-chat-btn",
              on: {
                click: function($event) {
                  _vm.settings.pageType = 1
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "fast-reply-group" }, [
              _c(
                "div",
                { staticClass: "frg-scroll" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "frg-item",
                      class: { active: _vm.settings.selectedFrgId === "all" },
                      on: { click: _vm.onSelectFrgAll }
                    },
                    [_vm._v("全部")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "frg-item frg-add",
                      on: {
                        click: function($event) {
                          _vm.settings.showGroupManage = true
                        }
                      }
                    },
                    [_vm._v("+ 新增分组")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.settings.groups, function(g) {
                    return _c(
                      "div",
                      {
                        key: g.id,
                        staticClass: "frg-item",
                        class: { active: _vm.settings.selectedFrgId === g.id },
                        on: {
                          click: function($event) {
                            return _vm.onSelectFrg(g)
                          }
                        }
                      },
                      [_vm._v(_vm._s(g.name))]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fast-reply-toolbar" }, [
              _c("div", { staticClass: "frt-left" }, [
                _c("div", { staticClass: "frt-count" }, [
                  _vm._v("共" + _vm._s(_vm.selectedGroupReplyCount) + "条")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frt-btn",
                    on: {
                      click: function($event) {
                        _vm.showImport = true
                      }
                    }
                  },
                  [_vm._v("批量导入")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "frt-right" }, [
                _c(
                  "div",
                  {
                    staticClass: "frt-btn",
                    on: {
                      click: function($event) {
                        _vm.settings.showGroupManage = true
                      }
                    }
                  },
                  [_vm._v("管理分组")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "frt-btn frt-btn-primary",
                    on: { click: _vm.menuAddReply }
                  },
                  [_vm._v("新建短语")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fast-reply-list" }, [
              _c("div", { staticClass: "fr-table" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "fr-tbody" },
                  [
                    _vm._l(_vm.displayedReplies, function(r, i) {
                      return _c(
                        "div",
                        { key: (r.id || i) + "_row", staticClass: "fr-tr" },
                        [
                          _c("div", { staticClass: "fr-td col-index" }, [
                            _vm._v(_vm._s(i + 1))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "fr-td col-quick" }, [
                            _vm._v("/" + _vm._s(r.quicktext))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fr-td col-text",
                              attrs: { title: r.replytext }
                            },
                            [_vm._v(_vm._s(r.replytext))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "fr-td col-actions" }, [
                            _c(
                              "div",
                              {
                                staticClass: "fr-op-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.menuEditReply(r, {
                                      id: _vm.settings.selectedFrgId
                                    })
                                  }
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fr-op-btn danger",
                                on: {
                                  click: function($event) {
                                    return _vm.menuDeleteReply(r)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !_vm.displayedReplies || _vm.displayedReplies.length === 0
                      ? _c("div", { staticClass: "fr-empty" }, [
                          _vm._v("暂无数据")
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("FastReplyImportDDDialog", {
        attrs: { sceneId: _vm.sceneId, visible: _vm.showImport },
        on: {
          "update:visible": function($event) {
            _vm.showImport = $event
          },
          refresh: _vm.refreshFastReply
        }
      }),
      _vm._v(" "),
      _c("FastReplyEditorDialog", {
        attrs: {
          showAddGroup: false,
          sceneId: _vm.sceneId,
          visible: _vm.showEditor,
          defaultGroupId: _vm.settings.defaultGroupId,
          value: _vm.editorValue
        },
        on: {
          "update:visible": function($event) {
            _vm.showEditor = $event
          },
          refresh: _vm.refreshFastReply
        }
      }),
      _vm._v(" "),
      _c("TrainScoreDialog", {
        attrs: { result: _vm.trainResult, visible: _vm.showScore },
        on: {
          "update:visible": function($event) {
            _vm.showScore = $event
          },
          onRestart: _vm.restartTrain,
          onViewResult: _vm.viewResult
        }
      }),
      _vm._v(" "),
      _c("GroupManageDialog", {
        attrs: {
          sceneId: _vm.sceneId,
          visible: _vm.settings.showGroupManage,
          groups: _vm.fastReplyList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.settings, "showGroupManage", $event)
          },
          refresh: _vm.refreshFastReply
        }
      }),
      _vm._v(" "),
      _c("CourseProductModal", {
        ref: "productModal",
        attrs: { "course-id": _vm.sceneId },
        on: {
          confirm: _vm.startTrain,
          "products-fetched": function($event) {
            _vm.hasProducts = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("实操练习疑问，或者问题反馈的途径："),
      _c("br"),
      _vm._v(" 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("实操练习疑问，或者问题反馈的途径："),
      _c("br"),
      _vm._v(" 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "oc-tags" }, [
      _c("span", [_vm._v("安心购")]),
      _c("span", [_vm._v("环保包装")]),
      _c("span", [_vm._v("运费险")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "oc-side" }, [
      _c("div", { staticClass: "oc-btns" }, [
        _c("div", { staticClass: "btn" }, [_vm._v("核对地址")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn" }, [_vm._v("催付")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn" }, [_vm._v("改价")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn" }, [_vm._v("改地址")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fr-thead fr-tr" }, [
      _c("div", { staticClass: "fr-th col-index" }, [_vm._v("序号")]),
      _vm._v(" "),
      _c("div", { staticClass: "fr-th col-quick" }, [_vm._v("快捷短语编码")]),
      _vm._v(" "),
      _c("div", { staticClass: "fr-th col-text" }, [_vm._v("快捷短语")]),
      _vm._v(" "),
      _c("div", { staticClass: "fr-th col-actions" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9c9ea62", esExports)
  }
}

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dd_reply.fe62e52.png";

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dd_order.5a7f9f7.png";

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dd_fast-import.3478001.png";

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainResult_vue__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainResult_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainResult_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainResult_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd11540_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainResult_vue__ = __webpack_require__(1760);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1758)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dd11540"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_trainResult_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd11540_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_trainResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/page/train/FBT/trainResult.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2dd11540", Component.options)
  } else {
    hotAPI.reload("data-v-2dd11540", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1759);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4dbca25f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2dd11540\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainResult.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2dd11540\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./trainResult.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.iframe-container[data-v-2dd11540] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.iframe-content[data-v-2dd11540] {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n}\n#Return_Bar[data-v-2dd11540] {\n  padding-left: 21px;\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  width: 100%;\n}\n[data-v-2dd11540] .el-icon-arrow-left {\n  margin-top: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "iframe-container" }, [
    _c("div", { attrs: { id: "Return_Bar" } }, [
      _c("i", { staticClass: "el-icon-arrow-left" }),
      _vm._v(" "),
      _c("div", { staticClass: "isreturn", on: { click: _vm.isreturn } }, [
        _vm._v("返回")
      ])
    ]),
    _vm._v(" "),
    _c("iframe", {
      staticClass: "iframe-content",
      attrs: { src: _vm.iframeSrc, frameborder: "0", scrolling: "auto" },
      on: { load: _vm.onIframeLoad }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dd11540", esExports)
  }
}

/***/ }),
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_701ac82d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(2001);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1995)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-701ac82d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_701ac82d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Modal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-701ac82d", Component.options)
  } else {
    hotAPI.reload("data-v-701ac82d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1996);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9d8a965a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-701ac82d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Modal.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-701ac82d\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Modal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.modal-dialog[data-v-701ac82d] {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  margin: 0;\n  transform: translate(-50%, -50%) !important;\n}\n.modal-body .modal-form[data-v-701ac82d] {\n  min-height: 0;\n  padding-bottom: 0;\n  overflow-y: auto;\n}\n.modal-body .btn-box[data-v-701ac82d] {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n}\n.modal-body.show-btn[data-v-701ac82d] {\n  padding-bottom: 65px;\n}\n.el-message-box__close[data-v-701ac82d] {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  padding: 0;\n  border: none;\n  outline: 0;\n  background: 0 0;\n  font-size: 16px;\n  cursor: pointer;\n  color: #909399;\n}\n", ""]);

// exports


/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBg_vue__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBg_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBg_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBg_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBg_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1491f65c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBg_vue__ = __webpack_require__(2000);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1998)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1491f65c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBg_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1491f65c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/ModalBg.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1491f65c", Component.options)
  } else {
    hotAPI.reload("data-v-1491f65c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1999);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("69cb7aec", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1491f65c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ModalBg.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1491f65c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ModalBg.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.modal-backdrop[data-v-1491f65c] {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n", ""]);

// exports


/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
    ],
    staticClass: "modal-backdrop fade in",
    style: { zIndex: _vm.zIndex }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1491f65c", esExports)
  }
}

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.comps, function(comp, index) {
        return _c(
          "div",
          { staticClass: "modal-dialog", style: _vm.style(index, comp) },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h4", [_vm._v(_vm._s(_vm.comps[index].title))]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "el-message-box__close el-icon-close",
                  on: {
                    click: function($event) {
                      return _vm.close(index, comp)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { class: { "modal-body": true, "show-btn": _vm.showBtn } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-form",
                      style: _vm.heightStyle(index, comp)
                    },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _vm.showBtn
                    ? _c(
                        "div",
                        { staticClass: "btn-box" },
                        _vm._l(_vm.btns, function(btn) {
                          return _c(
                            "button",
                            {
                              staticClass:
                                "tj-btn tj-btn-big tj-btn-blue tj-margin-left-xs",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.clickHandler(
                                    btn.value,
                                    comp,
                                    index
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(btn.text))]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            ])
          ]
        )
      }),
      _vm._v(" "),
      _c("hDialogBack", {
        ref: "back",
        attrs: { "z-index": _vm.realIndex - 1 }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-701ac82d", esExports)
  }
}

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoComplete_vue__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoComplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoComplete_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoComplete_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoComplete_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_049e8cfd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tjkAutoComplete_vue__ = __webpack_require__(2003);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoComplete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_049e8cfd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tjkAutoComplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/tjkAutoComplete.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-049e8cfd", Component.options)
  } else {
    hotAPI.reload("data-v-049e8cfd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-autocomplete", {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      placeholder: "请输入姓名或淘金号",
      "trigger-on-focus": false,
      debounce: 500
    },
    on: { select: _vm.handleSelect },
    model: {
      value: _vm.tjkName,
      callback: function($$v) {
        _vm.tjkName = $$v
      },
      expression: "tjkName"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-049e8cfd", esExports)
  }
}

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoCompleteAll_vue__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoCompleteAll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoCompleteAll_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoCompleteAll_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoCompleteAll_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a28db14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tjkAutoCompleteAll_vue__ = __webpack_require__(2007);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2005)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a28db14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tjkAutoCompleteAll_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a28db14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tjkAutoCompleteAll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/tjkAutoCompleteAll.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a28db14", Component.options)
  } else {
    hotAPI.reload("data-v-6a28db14", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2006);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3796b27e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a28db14\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tjkAutoCompleteAll.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a28db14\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./tjkAutoCompleteAll.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.el-scrollbar li[data-v-6a28db14] {\n  font-size: 14px !important;\n}\n", ""]);

// exports


/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        filterable: "",
        remote: "",
        clearable: "",
        "remote-method": _vm.querySearch,
        placeholder: "姓名或淘金号或登录账号"
      },
      on: { clear: _vm.onClear, change: _vm.onChange },
      model: {
        value: _vm.tjkName,
        callback: function($$v) {
          _vm.tjkName = $$v
        },
        expression: "tjkName"
      }
    },
    _vm._l(_vm.userList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.label, value: item.id }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a28db14", esExports)
  }
}

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_providerAutoComplete_vue__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_providerAutoComplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_providerAutoComplete_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_providerAutoComplete_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_providerAutoComplete_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df1c9fae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_providerAutoComplete_vue__ = __webpack_require__(2009);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_providerAutoComplete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df1c9fae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_providerAutoComplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/providerAutoComplete.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-df1c9fae", Component.options)
  } else {
    hotAPI.reload("data-v-df1c9fae", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-autocomplete", {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      placeholder: "请输入合作公司名称",
      "trigger-on-focus": false,
      debounce: 500
    },
    on: { select: _vm.handleSelect },
    model: {
      value: _vm.providerName,
      callback: function($$v) {
        _vm.providerName = $$v
      },
      expression: "providerName"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df1c9fae", esExports)
  }
}

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_children_vue__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_children_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_children_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_children_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_children_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28aa128f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_children_vue__ = __webpack_require__(2013);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2011)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28aa128f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_children_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28aa128f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_children_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/children.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28aa128f", Component.options)
  } else {
    hotAPI.reload("data-v-28aa128f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2012);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0afd6ff4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-28aa128f\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./children.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-28aa128f\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./children.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "\n.table[data-v-28aa128f] {\n  border-collapse: collapse;\n  width: 100%;\n  text-align: center;\n  margin-top: 10px;\n}\n.table td[data-v-28aa128f] {\n  border: 1px solid #e5e5e5;\n  background-color: #ffffff;\n  padding-top: 10px;\n}\n.table .ultimate[data-v-28aa128f] {\n  border-top: 1px solid #e5e5e5;\n  background-color: #ffffff;\n  padding: 5px;\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n}\n.table .single[data-v-28aa128f] {\n  border-left: 1px solid #e5e5e5;\n  width: 100px;\n}\n", ""]);

// exports


/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataArr && _vm.dataArr.length
    ? _c(
        "table",
        { staticClass: "table" },
        [
          _c(
            "tr",
            _vm._l(_vm.dataArr, function(item) {
              return _c(
                "td",
                {
                  class: {
                    ultimate: !(item.children && item.children.length),
                    single: item.children.length == 0
                  },
                  attrs: {
                    colspan: item.children.length,
                    "data-obj": _vm.objToStr(item)
                  }
                },
                [
                  _vm._v("\n      " + _vm._s(item.name) + "\n      "),
                  _c("children", { attrs: { dataArr: item.children } })
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28aa128f", esExports)
  }
}

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(__webpack_require__(73));
var _default = exports.default = {
  methods: {
    /*
     * @description 时间格式化
     * @param { date } date 时间或时间戳
     * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    dateFormatString: function dateFormatString(date, format) {
      // 时间格式化
      var date = new Date(date),
        o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
        };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    /*
     * @description 获取文件后缀名
     * @param { string } file 文件url地址
     *
     * @return { string } 文件后缀名
    */
    getSuffix: function getSuffix(file) {
      // 获取文件后缀名
      var lastPlace = file.lastIndexOf("."),
        fileLength = file.length;
      return file.substring(lastPlace + 1, fileLength);
    },
    /*
     * @description 将秒格式化
     * @param { number } seconds 秒数
     * @param { string } format 格式化的字符串 eg: 'hh:mm:ss'
     *
     * @return { string } 格式化后的字符串
    */
    formatSeconds: function formatSeconds(seconds, format) {
      // 将秒格式化
      var o;
      if (format.indexOf('h') != -1) {
        o = {
          'h+': Math.floor(seconds / 3600),
          'm+': Math.floor(seconds / 60) % 60,
          's+': Math.floor(seconds) % 60
        };
      } else {
        o = {
          'm+': Math.floor(seconds / 60),
          's+': Math.floor(seconds) % 60
        };
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length > 1 ? 2 : 1));
        }
      }
      return format;
    },
    /*
     * @description 数组深拷贝
     * @param { array } 需要拷贝的数组
     *
     * @return { array } 拷贝后的数组
    */
    coppyArray: function coppyArray(arr) {
      return arr.map(function (e) {
        if ((0, _typeof2.default)(e) === 'object') {
          return Object.assign({}, e);
        } else {
          return e;
        }
      });
    },
    /* 
     * @description 将json格式的对象拼接成复杂的url参数
     * @param { object } param  将要转为URL参数字符串的对象 
     * @param { string } key URL参数字符串的前缀 
     * @param { boolean } encode 是否进行URL编码,默认为true 
     *  
     * @return { string } URL参数字符串 
    */
    urlEncode: function urlEncode(param, key, encode) {
      if (param == null) return '';
      var paramStr = '';
      var t = (0, _typeof2.default)(param);
      if (t == 'string' || t == 'number' || t == 'boolean') {
        paramStr += '&' + key + '=' + (encode == null || encode ? encodeURIComponent(param) : param);
      } else {
        for (var i in param) {
          var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
          paramStr += this.urlEncode(param[i], k, encode);
        }
      }
      return paramStr;
    },
    /*
     * @desciprtion  删除url地址参数
     * @param { string } url url地址
     * @param { string } name 需要删除的参数
     *
     * @return  { string } 删除参数后的url地址
    */
    delUrlParam: function delUrlParam(url, name) {
      var str = "";
      var arr = "";
      var returnurl = "";
      var setparam = "";
      if (url.indexOf('?') != -1) {
        str = url.substr(url.indexOf('?') + 1);
      } else {
        return url;
      }
      if (str.indexOf('&') != -1) {
        arr = str.split('&');
        for (var i in arr) {
          if (arr[i].split('=')[0] != name) {
            returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&";
          }
        }
        return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1);
      } else {
        arr = str.split('=');
        if (arr[0] == name) {
          return url.substr(0, url.indexOf('?'));
        } else {
          return url;
        }
      }
    },
    /** 
     * @description 过滤数组中的空值
     * @param { array } arr 需要过滤的数组 
     * @return { array } [] 
     */
    clearArrTrim: function clearArrTrim(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (typeof arr[i] == 'undefined' || arr[i] == '') {
          arr.splice(i, 1);
          i = i - 1;
        }
      }
      return arr;
    },
    /** 
     * @description 判断数组是否有重复元素
     * @param { array } arr 需要判断的数组 
     * @return { boolean } 
     */
    arrayIsRepeat: function arrayIsRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return arr[i];
        }
        hash[arr[i]] = true;
      }
      return false;
    },
    /** 
     * @description 保留两位小数(少于两位不会补0)
     * @param { number } num 需要转换的数字
     * @return { number }  
     */
    toDecimal2NoZero: function toDecimal2NoZero(num) {
      return Number((Math.round(num * 100) / 100).toString());
    },
    /*
     * @description 获取cookie
     * @param { string } cname 需要获取的cookie
     * @return { string }
    */
    getCookie: function getCookie(cname) {
      var name = cname + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
      }
      return '';
    },
    /**
     * 获取本周、本季度、本月、上月的开端日期、停止日期
     */
    getCurrentDate: function getCurrentDate() {
      var now = new Date(); //当前日期
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      var nowDay = now.getDate(); //当前日
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年
      nowYear += nowYear < 2000 ? 1900 : 0;
      var lastMonthDate = new Date(); //上月日期 
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastYear = lastMonthDate.getYear();
      var lastMonth = lastMonthDate.getMonth();
      return {
        weekStartDate: this.getWeekStartDate(nowYear, nowMonth, nowDay, nowDayOfWeek),
        weekEndDate: this.getWeekEndDate(nowYear, nowMonth, nowDay, nowDayOfWeek),
        monthStartDate: this.getMonthStartDate(nowYear, nowMonth),
        monthEndDate: this.getMonthEndDate(nowYear, nowMonth),
        lastMonthStartDate: this.getLastMonthStartDate(nowYear, lastMonth),
        lastMonthEndDate: this.getLastMonthEndDate(nowYear, lastMonth)
      };
    },
    //获得本季度的开端月份 
    getQuarterStartMonth: function getQuarterStartMonth(nowMonth) {
      var quarterStartMonth = 0;
      if (nowMonth < 3) {
        quarterStartMonth = 0;
      }
      if (2 < nowMonth && nowMonth < 6) {
        quarterStartMonth = 3;
      }
      if (5 < nowMonth && nowMonth < 9) {
        quarterStartMonth = 6;
      }
      if (nowMonth > 8) {
        quarterStartMonth = 9;
      }
      return quarterStartMonth;
    },
    //获得某月的天数
    getMonthDays: function getMonthDays(nowYear, myMonth) {
      var monthStartDate = new Date(nowYear, myMonth, 1);
      var monthEndDate = new Date(nowYear, myMonth + 1, 1);
      var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
    },
    //获得本周的开端日期
    getWeekStartDate: function getWeekStartDate(nowYear, nowMonth, nowDay, nowDayOfWeek) {
      var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
      return this.dateFormatString(weekStartDate, 'yyyy-MM-dd');
    },
    //获得本周的停止日期
    getWeekEndDate: function getWeekEndDate(nowYear, nowMonth, nowDay, nowDayOfWeek) {
      var weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
      return this.dateFormatString(weekEndDate, 'yyyy-MM-dd');
    },
    //获得本月的开端日期
    getMonthStartDate: function getMonthStartDate(nowYear, nowMonth) {
      var monthStartDate = new Date(nowYear, nowMonth, 1);
      return this.dateFormatString(monthStartDate, 'yyyy-MM-dd');
    },
    //获得本月的停止日期
    getMonthEndDate: function getMonthEndDate(nowYear, nowMonth) {
      var monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowYear, nowMonth));
      return this.dateFormatString(monthEndDate, 'yyyy-MM-dd');
    },
    // 获得上月开端时候 
    getLastMonthStartDate: function getLastMonthStartDate(nowYear, lastMonth) {
      var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
      return this.dateFormatString(lastMonthStartDate, 'yyyy-MM-dd');
    },
    // 获得上月停止时候 
    getLastMonthEndDate: function getLastMonthEndDate(nowYear, lastMonth) {
      var lastMonthEndDate = new Date(nowYear, lastMonth, this.getMonthDays(nowYear, lastMonth));
      return this.dateFormatString(lastMonthEndDate, 'yyyy-MM-dd');
    },
    // 获得本季度的开端日期 
    getQuarterStartDate: function getQuarterStartDate(nowYear, nowMonth) {
      var quarterStartDate = new Date(nowYear, this.getQuarterStartMonth(nowMonth), 1);
      return this.dateFormatString(quarterStartDate, 'yyyy-MM-dd');
    },
    // 获得本季度的停止日期 
    getQuarterEndDate: function getQuarterEndDate(nowYear, nowMonth) {
      var quarterEndMonth = this.getQuarterStartMonth(nowMonth) + 2;
      var quarterStartDate = new Date(nowYear, quarterEndMonth, this.getMonthDays(nowYear, quarterEndMonth));
      return this.dateFormatString(quarterStartDate, 'yyyy-MM-dd');
    },
    /**
     * 获取从今日开始的前 n 天的日期
     */
    getLastDaysFromToday: function getLastDaysFromToday(n) {
      var lastDays = new Date().setDate(new Date().getDate() - n);
      var lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
      return lastDaysStr;
    },
    setSessionStorage: function setSessionStorage() {
      // 存储startTime，endTime用于页面传递
      var obj = {
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime
      };
      sessionStorage.setItem('params', JSON.stringify(obj));
    },
    /**金额进行千分位格式化 并保留两位小数 20000 => 20,000.00 */
    salaryThousandFormat: function salaryThousandFormat(num) {
      if (num == 0 || num == 'undefined' || !num || num == '') {
        return num;
      }
      if (typeof num !== 'number') {
        num = Number(num);
      }
      var newNum = num.toFixed(2).toString().split('.');
      newNum[0] = newNum[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
      return newNum.join('.');
    },
    /** 
    * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。 
    * 
    * @param num1被乘数 | num2乘数 
    */
    numMulti: function numMulti(num1, num2) {
      var baseNum = 0;
      try {
        baseNum += num1.toString().split(".")[1].length;
      } catch (e) {}
      try {
        baseNum += num2.toString().split(".")[1].length;
      } catch (e) {}
      return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
    },
    /** 
    * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。 
    * 
    * @param num1被除数 | num2除数 
    */
    numDiv: function numDiv(num1, num2) {
      var baseNum1 = 0,
        baseNum2 = 0;
      var baseNum3, baseNum4;
      try {
        baseNum1 = num1.toString().split(".")[1].length;
      } catch (e) {
        baseNum1 = 0;
      }
      try {
        baseNum2 = num2.toString().split(".")[1].length;
      } catch (e) {
        baseNum2 = 0;
      }
      baseNum3 = Number(num1.toString().replace(".", ""));
      baseNum4 = Number(num2.toString().replace(".", ""));
      return baseNum3 / baseNum4 * Math.pow(10, baseNum2 - baseNum1);
    },
    // des加密请求
    $m_desRequest: function $m_desRequest(url, data) {
      var _this = this;
      var params = new URLSearchParams();
      params.append('desc', 'cbc');
      params.append('param', this.getDES(data));
      return new Promise(function (resolve, reject) {
        _this.$http({
          url: url,
          method: 'post',
          data: params,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (res) {
          if (res.data.code == 200) {
            resolve(res);
          } else {
            if (!~url.indexOf('hideErr')) {
              _this.$message.error(res.data.msg);
            }
            reject();
          }
        }, function (err) {
          reject();
        });
      });
    },
    // 获取加密后的数据
    getDES: function getDES(obj) {
      var str = obj;
      if ((0, _typeof2.default)(obj) == 'object') {
        str = JSON.stringify(obj);
      } else if (typeof obj == 'number') {
        str = obj.toString();
      }
      var key = 'tjhawkeye';
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      var ivHex = CryptoJS.enc.Utf8.parse(key);
      var option = {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      };
      var encrypted = CryptoJS.DES.encrypt(str, keyHex, option);
      return encrypted.ciphertext.toString();
    }
  }
};

/***/ }),
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[1073]);


// WEBPACK FOOTER //
// static/js/app.35e688c1eafedcf6fc09.js